var _regeneratorRuntime = require("/home/ubuntu/frontend/development/fleetmaintenancehubca/fleetmd/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

module.exports = function (c) {
  var e = {};

  function a(n) {
    if (e[n]) return e[n].exports;
    var t = e[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return c[n].call(t.exports, t, t.exports, a), t.l = !0, t.exports;
  }

  return a.m = c, a.c = e, a.d = function (c, e, n) {
    a.o(c, e) || Object.defineProperty(c, e, {
      enumerable: !0,
      get: n
    });
  }, a.r = function (c) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(c, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(c, "__esModule", {
      value: !0
    });
  }, a.t = function (c, e) {
    if (1 & e && (c = a(c)), 8 & e) return c;
    if (4 & e && "object" == typeof c && c && c.__esModule) return c;
    var n = Object.create(null);
    if (a.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: c
    }), 2 & e && "string" != typeof c) for (var t in c) {
      a.d(n, t, function (e) {
        return c[e];
      }.bind(null, t));
    }
    return n;
  }, a.n = function (c) {
    var e = c && c.__esModule ? function () {
      return c.default;
    } : function () {
      return c;
    };
    return a.d(e, "a", e), e;
  }, a.o = function (c, e) {
    return Object.prototype.hasOwnProperty.call(c, e);
  }, a.p = "", a(a.s = 100);
}([function (c, e, a) {
  "use strict";

  c.exports = a(107);
}, function (c, e, a) {
  "use strict";

  function n() {
    return (n = Object.assign ? Object.assign.bind() : function (c) {
      for (var e = 1; e < arguments.length; e++) {
        var a = arguments[e];

        for (var n in a) {
          Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
        }
      }

      return c;
    }).apply(this, arguments);
  }

  a.d(e, "a", function () {
    return n;
  });
}, function (c, e, a) {
  c.exports = a(108)();
}, function (c, e, a) {
  "use strict";

  function n(c, e) {
    return (n = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (c, e) {
      return c.__proto__ = e, c;
    })(c, e);
  }

  function t(c, e) {
    c.prototype = Object.create(e.prototype), c.prototype.constructor = c, n(c, e);
  }

  a.d(e, "a", function () {
    return t;
  });
}, function (c, e, a) {
  "use strict";

  for (var n = function n(c) {
    return null !== c && !Array.isArray(c) && "object" == typeof c;
  }, t = {
    3: "Cancel",
    6: "Help",
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    28: "Convert",
    29: "NonConvert",
    30: "Accept",
    31: "ModeChange",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    41: "Select",
    42: "Print",
    43: "Execute",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    48: ["0", ")"],
    49: ["1", "!"],
    50: ["2", "@"],
    51: ["3", "#"],
    52: ["4", "$"],
    53: ["5", "%"],
    54: ["6", "^"],
    55: ["7", "&"],
    56: ["8", "*"],
    57: ["9", "("],
    91: "OS",
    93: "ContextMenu",
    144: "NumLock",
    145: "ScrollLock",
    181: "VolumeMute",
    182: "VolumeDown",
    183: "VolumeUp",
    186: [";", ":"],
    187: ["=", "+"],
    188: [",", "<"],
    189: ["-", "_"],
    190: [".", ">"],
    191: ["/", "?"],
    192: ["`", "~"],
    219: ["[", "{"],
    220: ["\\", "|"],
    221: ["]", "}"],
    222: ["'", '"'],
    224: "Meta",
    225: "AltGraph",
    246: "Attn",
    247: "CrSel",
    248: "ExSel",
    249: "EraseEof",
    250: "Play",
    251: "ZoomOut"
  }, r = 0; r < 24; r += 1) {
    t[112 + r] = "F" + (r + 1);
  }

  for (var i = 0; i < 26; i += 1) {
    var o = i + 65;
    t[o] = [String.fromCharCode(o + 32), String.fromCharCode(o)];
  }

  var l = {
    codes: t,
    getCode: function getCode(c) {
      return n(c) ? c.keyCode || c.which || this[c.key] : this[c];
    },
    getKey: function getKey(c) {
      var e = n(c);
      if (e && c.key) return c.key;
      var a = t[e ? c.keyCode || c.which : c];
      return Array.isArray(a) && (a = e ? a[c.shiftKey ? 1 : 0] : a[0]), a;
    },
    Cancel: 3,
    Help: 6,
    Backspace: 8,
    Tab: 9,
    Clear: 12,
    Enter: 13,
    Shift: 16,
    Control: 17,
    Alt: 18,
    Pause: 19,
    CapsLock: 20,
    Escape: 27,
    Convert: 28,
    NonConvert: 29,
    Accept: 30,
    ModeChange: 31,
    " ": 32,
    PageUp: 33,
    PageDown: 34,
    End: 35,
    Home: 36,
    ArrowLeft: 37,
    ArrowUp: 38,
    ArrowRight: 39,
    ArrowDown: 40,
    Select: 41,
    Print: 42,
    Execute: 43,
    PrintScreen: 44,
    Insert: 45,
    Delete: 46,
    0: 48,
    ")": 48,
    1: 49,
    "!": 49,
    2: 50,
    "@": 50,
    3: 51,
    "#": 51,
    4: 52,
    $: 52,
    5: 53,
    "%": 53,
    6: 54,
    "^": 54,
    7: 55,
    "&": 55,
    8: 56,
    "*": 56,
    9: 57,
    "(": 57,
    a: 65,
    A: 65,
    b: 66,
    B: 66,
    c: 67,
    C: 67,
    d: 68,
    D: 68,
    e: 69,
    E: 69,
    f: 70,
    F: 70,
    g: 71,
    G: 71,
    h: 72,
    H: 72,
    i: 73,
    I: 73,
    j: 74,
    J: 74,
    k: 75,
    K: 75,
    l: 76,
    L: 76,
    m: 77,
    M: 77,
    n: 78,
    N: 78,
    o: 79,
    O: 79,
    p: 80,
    P: 80,
    q: 81,
    Q: 81,
    r: 82,
    R: 82,
    s: 83,
    S: 83,
    t: 84,
    T: 84,
    u: 85,
    U: 85,
    v: 86,
    V: 86,
    w: 87,
    W: 87,
    x: 88,
    X: 88,
    y: 89,
    Y: 89,
    z: 90,
    Z: 90,
    OS: 91,
    ContextMenu: 93,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    F13: 124,
    F14: 125,
    F15: 126,
    F16: 127,
    F17: 128,
    F18: 129,
    F19: 130,
    F20: 131,
    F21: 132,
    F22: 133,
    F23: 134,
    F24: 135,
    NumLock: 144,
    ScrollLock: 145,
    VolumeMute: 181,
    VolumeDown: 182,
    VolumeUp: 183,
    ";": 186,
    ":": 186,
    "=": 187,
    "+": 187,
    ",": 188,
    "<": 188,
    "-": 189,
    _: 189,
    ".": 190,
    ">": 190,
    "/": 191,
    "?": 191,
    "`": 192,
    "~": 192,
    "[": 219,
    "{": 219,
    "\\": 220,
    "|": 220,
    "]": 221,
    "}": 221,
    "'": 222,
    '"': 222,
    Meta: 224,
    AltGraph: 225,
    Attn: 246,
    CrSel: 247,
    ExSel: 248,
    EraseEof: 249,
    Play: 250,
    ZoomOut: 251
  };
  l.Spacebar = l[" "], l.Digit0 = l[0], l.Digit1 = l[1], l.Digit2 = l[2], l.Digit3 = l[3], l.Digit4 = l[4], l.Digit5 = l[5], l.Digit6 = l[6], l.Digit7 = l[7], l.Digit8 = l[8], l.Digit9 = l[9], l.Tilde = l["~"], l.GraveAccent = l["`"], l.ExclamationPoint = l["!"], l.AtSign = l["@"], l.PoundSign = l["#"], l.PercentSign = l["%"], l.Caret = l["^"], l.Ampersand = l["&"], l.PlusSign = l["+"], l.MinusSign = l["-"], l.EqualsSign = l["="], l.DivisionSign = l["/"], l.MultiplicationSign = l["*"], l.Comma = l[","], l.Decimal = l["."], l.Colon = l[":"], l.Semicolon = l[";"], l.Pipe = l["|"], l.BackSlash = l["\\"], l.QuestionMark = l["?"], l.SingleQuote = l["'"], l.DoubleQuote = l['"'], l.LeftCurlyBrace = l["{"], l.RightCurlyBrace = l["}"], l.LeftParenthesis = l["("], l.RightParenthesis = l[")"], l.LeftAngleBracket = l["<"], l.RightAngleBracket = l[">"], l.LeftSquareBracket = l["["], l.RightSquareBracket = l["]"], c.exports = l;
}, function (c, e, a) {
  "use strict";

  var n = a(40),
      t = "object" == typeof self && self && self.Object === Object && self,
      r = n.a || t || Function("return this")();
  e.a = r;
}, function (c, e, a) {
  "use strict";

  var n = function n() {};

  c.exports = n;
}, function (c, e, a) {
  "use strict";

  c.exports = function (c, e, a, n, t, r, i, o) {
    if (!c) {
      var l;
      if (void 0 === e) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
        var f = [a, n, t, r, i, o],
            s = 0;
        (l = new Error(e.replace(/%s/g, function () {
          return f[s++];
        }))).name = "Invariant Violation";
      }
      throw l.framesToPop = 1, l;
    }
  };
}, function (c, e, a) {
  "use strict";

  function n(c, e) {
    if (null == c) return {};
    var a,
        n,
        t = {},
        r = Object.keys(c);

    for (n = 0; n < r.length; n++) {
      a = r[n], e.indexOf(a) >= 0 || (t[a] = c[a]);
    }

    return t;
  }

  a.d(e, "a", function () {
    return n;
  });
}, function (c, e, a) {
  "use strict";

  var n;
  n = a(224), c.exports = n.default, c.exports.instance = n.instance;
}, function (c, e) {
  c.exports = function (c, e, a, n) {
    var t = a ? a.call(n, c, e) : void 0;
    if (void 0 !== t) return !!t;
    if (c === e) return !0;
    if ("object" != typeof c || !c || "object" != typeof e || !e) return !1;
    var r = Object.keys(c),
        i = Object.keys(e);
    if (r.length !== i.length) return !1;

    for (var o = Object.prototype.hasOwnProperty.bind(e), l = 0; l < r.length; l++) {
      var f = r[l];
      if (!o(f)) return !1;
      var s = c[f],
          u = e[f];
      if (!1 === (t = a ? a.call(n, s, u, f) : void 0) || void 0 === t && s !== u) return !1;
    }

    return !0;
  };
}, function (c, e) {
  var a = Array.isArray;
  c.exports = a;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = e.STATUS = {
    active: 0,
    completed: 1,
    canceled: 2,
    paid: 3,
    paid_at_shop: 4,
    initiated_by_user: 5,
    awaiting_approval: 6,
    approval: 7,
    in_manual_review: 8,
    walk_in: 9,
    seeking_quote: 10,
    price_review: 11
  };
  e.INITIATED_BY_USER = "initiated_by_user", e.ACTIVE = "active", e.CANCELLED = "canceled", e.COMPLETED = "completed", e.PAID = "paid", e.PAID_AT_SHOP = "paid_at_shop", e.IN_MANUAL_REVIEW = "in_manual_review", e.APPROVAL = "approval", e.AWAITING_APPROVAL = "awaiting_approval", e.WALK_IN = "walk_in", e.SEEKING_QUOTE = "seeking_quote", e.PRICE_REVIEW = "price_review", e.PAID_STATUSES = [n.paid, n.paid_at_shop, n.in_manual_review], e.INACTIVE_STATUSES = [n.canceled, n.paid, n.paid_at_shop, n.in_manual_review], e.ACTIVE_STATUSES = [n.initiated_by_user, n.active, n.awaiting_approval, n.approval, n.completed, n.walk_in, n.seeking_quote, n.price_review], e.CHECKED_IN_STATUSES = [n.active, n.awaiting_approval, n.price_review];
}, function (c, e, a) {
  var n = a(61),
      t = "object" == typeof self && self && self.Object === Object && self,
      r = n || t || Function("return this")();
  c.exports = r;
}, function (c, e, a) {
  "use strict";

  a.r(e), a.d(e, "FontAwesomeIcon", function () {
    return A;
  });
  var n = a(29),
      t = a(2),
      r = a.n(t),
      i = a(0),
      o = a.n(i);

  function l(c, e) {
    var a = Object.keys(c);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(c);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(c, e).enumerable;
      })), a.push.apply(a, n);
    }

    return a;
  }

  function f(c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = null != arguments[e] ? arguments[e] : {};
      e % 2 ? l(Object(a), !0).forEach(function (e) {
        u(c, e, a[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(a)) : l(Object(a)).forEach(function (e) {
        Object.defineProperty(c, e, Object.getOwnPropertyDescriptor(a, e));
      });
    }

    return c;
  }

  function s(c) {
    return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (c) {
      return typeof c;
    } : function (c) {
      return c && "function" == typeof Symbol && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
    })(c);
  }

  function u(c, e, a) {
    return e in c ? Object.defineProperty(c, e, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[e] = a, c;
  }

  function h(c, e) {
    if (null == c) return {};

    var a,
        n,
        t = function (c, e) {
      if (null == c) return {};
      var a,
          n,
          t = {},
          r = Object.keys(c);

      for (n = 0; n < r.length; n++) {
        a = r[n], e.indexOf(a) >= 0 || (t[a] = c[a]);
      }

      return t;
    }(c, e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(c);

      for (n = 0; n < r.length; n++) {
        a = r[n], e.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(c, a) && (t[a] = c[a]);
      }
    }

    return t;
  }

  function m(c) {
    return function (c) {
      if (Array.isArray(c)) return v(c);
    }(c) || function (c) {
      if ("undefined" != typeof Symbol && null != c[Symbol.iterator] || null != c["@@iterator"]) return Array.from(c);
    }(c) || function (c, e) {
      if (!c) return;
      if ("string" == typeof c) return v(c, e);
      var a = Object.prototype.toString.call(c).slice(8, -1);
      "Object" === a && c.constructor && (a = c.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(c);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return v(c, e);
    }(c) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function v(c, e) {
    (null == e || e > c.length) && (e = c.length);

    for (var a = 0, n = new Array(e); a < e; a++) {
      n[a] = c[a];
    }

    return n;
  }

  function d(c) {
    return e = c, (e -= 0) == e ? c : (c = c.replace(/[\-_\s]+(.)?/g, function (c, e) {
      return e ? e.toUpperCase() : "";
    })).substr(0, 1).toLowerCase() + c.substr(1);
    var e;
  }

  var M = ["style"];
  var p = !1;

  try {
    p = !0;
  } catch (c) {}

  function z(c) {
    return c && "object" === s(c) && c.prefix && c.iconName && c.icon ? c : n.b.icon ? n.b.icon(c) : null === c ? null : c && "object" === s(c) && c.prefix && c.iconName ? c : Array.isArray(c) && 2 === c.length ? {
      prefix: c[0],
      iconName: c[1]
    } : "string" == typeof c ? {
      prefix: "fas",
      iconName: c
    } : void 0;
  }

  function C(c, e) {
    return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? u({}, c, e) : {};
  }

  var L = ["forwardedRef"];

  function A(c) {
    var e = c.forwardedRef,
        a = h(c, L),
        t = a.icon,
        r = a.mask,
        i = a.symbol,
        o = a.className,
        l = a.title,
        s = a.titleId,
        v = a.maskId,
        d = z(t),
        M = C("classes", [].concat(m(function (c) {
      var e,
          a = c.beat,
          n = c.fade,
          t = c.beatFade,
          r = c.bounce,
          i = c.shake,
          o = c.flash,
          l = c.spin,
          f = c.spinPulse,
          s = c.spinReverse,
          h = c.pulse,
          m = c.fixedWidth,
          v = c.inverse,
          d = c.border,
          M = c.listItem,
          p = c.flip,
          z = c.size,
          C = c.rotation,
          L = c.pull,
          A = (u(e = {
        "fa-beat": a,
        "fa-fade": n,
        "fa-beat-fade": t,
        "fa-bounce": r,
        "fa-shake": i,
        "fa-flash": o,
        "fa-spin": l,
        "fa-spin-reverse": s,
        "fa-spin-pulse": f,
        "fa-pulse": h,
        "fa-fw": m,
        "fa-inverse": v,
        "fa-border": d,
        "fa-li": M,
        "fa-flip": !0 === p,
        "fa-flip-horizontal": "horizontal" === p || "both" === p,
        "fa-flip-vertical": "vertical" === p || "both" === p
      }, "fa-".concat(z), null != z), u(e, "fa-rotate-".concat(C), null != C && 0 !== C), u(e, "fa-pull-".concat(L), null != L), u(e, "fa-swap-opacity", c.swapOpacity), e);
      return Object.keys(A).map(function (c) {
        return A[c] ? c : null;
      }).filter(function (c) {
        return c;
      });
    }(a)), m(o.split(" ")))),
        g = C("transform", "string" == typeof a.transform ? n.b.transform(a.transform) : a.transform),
        H = C("mask", z(r)),
        V = Object(n.a)(d, f(f(f(f({}, M), g), H), {}, {
      symbol: i,
      title: l,
      titleId: s,
      maskId: v
    }));
    if (!V) return function () {
      var c;
      !p && console && "function" == typeof console.error && (c = console).error.apply(c, arguments);
    }("Could not find icon", d), null;
    var x = V.abstract,
        w = {
      ref: e
    };
    return Object.keys(a).forEach(function (c) {
      A.defaultProps.hasOwnProperty(c) || (w[c] = a[c]);
    }), N(x[0], w);
  }

  A.displayName = "FontAwesomeIcon", A.propTypes = {
    beat: r.a.bool,
    border: r.a.bool,
    beatFade: r.a.bool,
    bounce: r.a.bool,
    className: r.a.string,
    fade: r.a.bool,
    flash: r.a.bool,
    mask: r.a.oneOfType([r.a.object, r.a.array, r.a.string]),
    maskId: r.a.string,
    fixedWidth: r.a.bool,
    inverse: r.a.bool,
    flip: r.a.oneOf([!0, !1, "horizontal", "vertical", "both"]),
    icon: r.a.oneOfType([r.a.object, r.a.array, r.a.string]),
    listItem: r.a.bool,
    pull: r.a.oneOf(["right", "left"]),
    pulse: r.a.bool,
    rotation: r.a.oneOf([0, 90, 180, 270]),
    shake: r.a.bool,
    size: r.a.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
    spin: r.a.bool,
    spinPulse: r.a.bool,
    spinReverse: r.a.bool,
    symbol: r.a.oneOfType([r.a.bool, r.a.string]),
    title: r.a.string,
    titleId: r.a.string,
    transform: r.a.oneOfType([r.a.string, r.a.object]),
    swapOpacity: r.a.bool
  }, A.defaultProps = {
    border: !1,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: !1,
    inverse: !1,
    flip: !1,
    icon: null,
    listItem: !1,
    pull: null,
    pulse: !1,
    rotation: null,
    size: null,
    spin: !1,
    spinPulse: !1,
    spinReverse: !1,
    beat: !1,
    fade: !1,
    beatFade: !1,
    bounce: !1,
    shake: !1,
    symbol: !1,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: !1
  };

  var N = function c(e, a) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    if ("string" == typeof a) return a;
    var t = (a.children || []).map(function (a) {
      return c(e, a);
    }),
        r = Object.keys(a.attributes || {}).reduce(function (c, e) {
      var n = a.attributes[e];

      switch (e) {
        case "class":
          c.attrs.className = n, delete a.attributes.class;
          break;

        case "style":
          c.attrs.style = n.split(";").map(function (c) {
            return c.trim();
          }).filter(function (c) {
            return c;
          }).reduce(function (c, e) {
            var a,
                n = e.indexOf(":"),
                t = d(e.slice(0, n)),
                r = e.slice(n + 1).trim();
            return t.startsWith("webkit") ? c[(a = t, a.charAt(0).toUpperCase() + a.slice(1))] = r : c[t] = r, c;
          }, {});
          break;

        default:
          0 === e.indexOf("aria-") || 0 === e.indexOf("data-") ? c.attrs[e.toLowerCase()] = n : c.attrs[d(e)] = n;
      }

      return c;
    }, {
      attrs: {}
    }),
        i = n.style,
        o = void 0 === i ? {} : i,
        l = h(n, M);
    return r.attrs.style = f(f({}, r.attrs.style), o), e.apply(void 0, [a.tag, f(f({}, r.attrs), l)].concat(m(t)));
  }.bind(null, o.a.createElement);
}, function (c, e, a) {
  "use strict";

  !function c() {
    if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(c);
    } catch (c) {
      console.error(c);
    }
  }(), c.exports = a(202);
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = l;
  var n = o(a(0)),
      t = a(302),
      r = a(14),
      i = o(a(2));

  function o(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  function l(c) {
    var e = c.tel,
        a = c.trackingClassName,
        i = c.text,
        o = c.iconLeft,
        l = c.iconRight,
        f = c.colorStyle,
        s = c.onClick,
        u = c.width,
        h = c.fontSize,
        m = c.borderRadius,
        v = (c.children, c.linkTo),
        d = c.style,
        M = c.styleText,
        p = c.disabled,
        z = s ? function (c) {
      v || c.preventDefault(), p || s(c);
    } : function (c) {
      p && c.preventDefault();
    },
        C = n.default.createElement("span", {
      className: f + "-button-text-color"
    }, o && n.default.createElement(r.FontAwesomeIcon, {
      icon: o,
      className: "left-button-icons"
    }), n.default.createElement("span", {
      className: "button-text",
      style: M
    }, i), l && n.default.createElement(r.FontAwesomeIcon, {
      icon: l,
      className: "right-button-icons"
    }));
    return d = d ? Object.assign({}, d) : {}, u && (d.width = u), h && (d.fontSize = h), m && (d.borderRadius = m), p && (d.opacity = .7, d.cursor = "default"), s || p || e ? n.default.createElement("a", {
      onClick: z,
      className: a + " classic-ca-button " + f + "-button",
      style: d,
      href: "" + (e || "#" + v)
    }, C) : n.default.createElement(t.Link, {
      to: v,
      className: a + " classic-ca-button " + f + "-button",
      style: d
    }, C);
  }

  l.propTypes = {
    colorStyle: i.default.oneOf(["orange", "grey", "white"]),
    iconRight: i.default.object,
    iconLeft: i.default.object,
    text: i.default.string,
    onClick: i.default.func,
    linkTo: i.default.oneOfType([i.default.string, i.default.object]),
    width: i.default.number,
    fontSize: i.default.number,
    borderRadius: i.default.number,
    trackingClassName: i.default.string,
    style: i.default.object,
    styleText: i.default.object,
    disabled: i.default.bool
  }, l.defaultProps = {
    colorStyle: "grey",
    trackingClassName: "",
    style: {},
    styleText: {},
    disabled: !1
  };
}, function (c, e, a) {
  "use strict";

  (function (c) {
    var n = a(5),
        t = a(95),
        r = "object" == typeof exports && exports && !exports.nodeType && exports,
        i = r && "object" == typeof c && c && !c.nodeType && c,
        o = i && i.exports === r ? n.a.Buffer : void 0,
        l = (o ? o.isBuffer : void 0) || t.a;
    e.a = l;
  }).call(this, a(86)(c));
}, function (c, e) {
  var a;

  a = function () {
    return this;
  }();

  try {
    a = a || new Function("return this")();
  } catch (c) {
    "object" == typeof window && (a = window);
  }

  c.exports = a;
}, function (c, e, a) {
  var n = a(130),
      t = a(133);

  c.exports = function (c, e) {
    var a = t(c, e);
    return n(a) ? a : void 0;
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = e.statuses = {
    initiated: 0,
    initiatedByUser: 1,
    approved: 2,
    saved: 3,
    deleted: 4,
    completed: 5
  };
  e.SAVED_OR_DELETED_STATUSES = [n.saved, n.deleted], e.WAITING_FOR_APPROVAL_STATUSES = [n.initiated, n.initiatedByUser];
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  },
      t = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      r = s(a(0)),
      i = s(a(52)),
      o = s(a(16)),
      l = s(a(54)),
      f = a(14);

  function s(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  function u(c) {
    return function () {
      var e = c.apply(this, arguments);
      return new Promise(function (c, a) {
        return function n(t, r) {
          try {
            var i = e[t](r),
                o = i.value;
          } catch (c) {
            return void a(c);
          }

          if (!i.done) return Promise.resolve(o).then(function (c) {
            n("next", c);
          }, function (c) {
            n("throw", c);
          });
          c(o);
        }("next");
      });
    };
  }

  i.default.setAppElement(document.getElementById("root"));

  var h = function (c) {
    function e(c) {
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var a = function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, c));

      return a.closeModal = function () {
        a.setState({
          modalIsOpen: !1
        });
        var c = a.props.afterCloseModal;
        c && c();
      }, a.state = {
        modalIsOpen: !1
      }, a.openModal = a.openModal.bind(a), a.afterOpenModal = a.afterOpenModal.bind(a), a.closeModal = a.closeModal.bind(a), a;
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, r.default.Component), t(e, [{
      key: "openModal",
      value: function value() {
        this.setState({
          modalIsOpen: !0
        });
      }
    }, {
      key: "afterOpenModal",
      value: function value() {
        this.props.afterOpenModal && this.props.afterOpenModal();
      }
    }, {
      key: "render",
      value: function value() {
        var c = this,
            e = arguments,
            a = 0,
            t = (this.props.buttons || []).map(function (t) {
          var i,
              l,
              f = void 0,
              s = "modal-dialog-buttons-" + a++,
              h = (t.onClick, t.validate),
              m = function (c, e) {
            var a = {};

            for (var n in c) {
              e.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(c, n) && (a[n] = c[n]);
            }

            return a;
          }(t, ["onClick", "validate"]);

          if (t.appendClose) {
            var v = c;
            l = u(_regeneratorRuntime.mark(function a(n) {
              var r;
              return _regeneratorRuntime.wrap(function (a) {
                for (;;) {
                  switch (a.prev = a.next) {
                    case 0:
                      if (t.warning || n.preventDefault(), r = t.onClick, a.t0 = h, !a.t0) {
                        a.next = 7;
                        break;
                      }

                      return a.next = 6, h.apply(c, e);

                    case 6:
                      a.t0 = !a.sent;

                    case 7:
                      if (!a.t0) {
                        a.next = 9;
                        break;
                      }

                      return a.abrupt("return");

                    case 9:
                      if (v.closeModal(), !r) {
                        a.next = 13;
                        break;
                      }

                      return a.next = 13, r.apply(c, e);

                    case 13:
                    case "end":
                      return a.stop();
                  }
                }
              }, a, c);
            })), f = function f(c) {
              return l.apply(this, arguments);
            };
          } else i = u(_regeneratorRuntime.mark(function a(n) {
            var r;
            return _regeneratorRuntime.wrap(function (a) {
              for (;;) {
                switch (a.prev = a.next) {
                  case 0:
                    if (n.preventDefault(), r = t.onClick, a.t0 = h, !a.t0) {
                      a.next = 7;
                      break;
                    }

                    return a.next = 6, h.apply(c, e);

                  case 6:
                    a.t0 = !a.sent;

                  case 7:
                    if (!a.t0) {
                      a.next = 9;
                      break;
                    }

                    return a.abrupt("return");

                  case 9:
                    if (!r) {
                      a.next = 12;
                      break;
                    }

                    return a.next = 12, r.apply(c, e);

                  case 12:
                  case "end":
                    return a.stop();
                }
              }
            }, a, c);
          })), f = function f(c) {
            return i.apply(this, arguments);
          };

          return r.default.createElement(o.default, n({
            key: s,
            onClick: f
          }, m));
        }),
            s = this.props.style || {},
            h = this.props,
            m = h.chromeless,
            v = h.headerTitle,
            d = r.default.createElement("span", null, this.props.linkText && r.default.createElement("p", null, r.default.createElement("a", {
          className: this.props.className,
          onClick: this.openModal,
          style: n({}, s, {
            cursor: "pointer"
          })
        }, this.props.linkText)), this.props.buttonText && r.default.createElement(o.default, {
          onClick: function onClick(e) {
            e.preventDefault(), c.openModal();
          },
          text: this.props.buttonText,
          colorStyle: this.props.colorStyle,
          linkTo: this.props.linkTo
        }), this.props.icon && r.default.createElement("span", {
          className: this.props.className,
          onClick: this.openModal,
          style: n({}, s, {
            cursor: "pointer"
          })
        }, r.default.createElement(f.FontAwesomeIcon, {
          icon: this.props.icon
        })), this.props.customElement && r.default.createElement("div", {
          className: this.props.className,
          onClick: this.openModal,
          style: n({}, s, {
            cursor: "pointer"
          })
        }, this.props.customElement), r.default.createElement(i.default, {
          isOpen: this.state.modalIsOpen,
          onAfterOpen: this.afterOpenModal,
          onRequestClose: this.closeModal,
          contentLabel: this.props.contentLabel,
          className: "modal-dialog",
          style: this.props.modalStyleOverrides
        }, r.default.createElement(l.default, {
          onClose: this.closeModal
        }), v && r.default.createElement("div", {
          style: m ? {
            backgroundColor: "unset"
          } : {}
        }, r.default.createElement("div", {
          className: "modal-title"
        }, v)), this.props.warningClassName ? r.default.createElement("div", {
          className: "" + (this.props.warningClassName ? this.props.warningClassName : "")
        }, this.props.children) : r.default.createElement("div", {
          className: "modal-dialog-content " + (this.props.contentClassName ? this.props.contentClassName : ""),
          style: v ? {} : {
            marginTop: 0
          }
        }, this.props.children), r.default.createElement("div", {
          className: "modal-dialog-buttons",
          style: this.props.centerButtons ? {
            justifyContent: "center"
          } : {}
        }, t)));
        return this.props.icon ? d : r.default.createElement("div", null, d);
      }
    }]), e;
  }();

  e.default = h;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  };

  e.calculateTax = function (c, e) {
    if (0 == c.tax_amount && 0 == c.estimated_total_pre_tax) return 0;
    var a = void 0;
    c.tax_amount && (a = c.tax_amount / c.estimated_total_pre_tax);
    return e * a;
  }, e.formatForApprovalsForm = function (c) {
    return c && c.map(function (c) {
      var e = void 0;
      return e = c.status === o.statuses.approved ? o.statuses.approved : c.user_originated ? o.statuses.approved : o.statuses.saved, n({}, c, {
        status_new: e,
        status_original: c.status,
        rejection_reason_id: c.rejection_reason && c.rejection_reason.id
      });
    });
  }, e.formatForApprovalsFormSubmission = function (c) {
    return c && c.map(function (c) {
      var e = n({}, c, {
        status: c.status_new,
        rejection_reason_id: c.rejection_reason && c.rejection_reason.id
      });
      return delete e.status_new, delete e.status_original, e;
    });
  }, e.formattedName = function (c) {
    var e = (0, i.default)(c.order_service_options || [], function (c) {
      return c.order_service_option_items || [];
    }).find(function (c) {
      return c.quantity;
    }),
        a = "Inspections" === c.name ? c.groupedServices.length : null;
    return e && a ? a + " " + c.name + " (Qty. " + e.quantity + ")" : a ? a + " " + c.name : c.name;
  }, e.priceForRetail = function (c) {
    var e = (c.price_estimate || {}).retail_price_estimate || l(c);
    return Number(e || 0);
  }, e.priceForShop = l, e.splitByCategory = function (c) {
    var e = {
      previously_approved: [],
      shop_suggested: [],
      user_requested: [],
      auto_approved: []
    };
    return c && c.forEach(function (c) {
      c.approval_policy_id && c.status === o.statuses.approved ? e.auto_approved.push(c) : c.status === o.statuses.approved ? e.previously_approved.push(c) : c.user_originated ? e.user_requested.push(c) : e.shop_suggested.push(c);
    }), e;
  }, e.savedOrDeletedStatus = function (c) {
    return null != c && o.SAVED_OR_DELETED_STATUSES.includes(Number(c.status));
  };
  var t,
      r = a(110),
      i = (t = r) && t.__esModule ? t : {
    default: t
  },
      o = a(20);

  function l(c) {
    if (void 0 !== c.override_total_with_promotional_discount && null !== c.override_total_with_promotional_discount) return Number(c.override_total_with_promotional_discount);
    var e = c.price_estimate || {};
    return Number(e.shop_price_estimate || 0);
  }
}, function (c, e, a) {
  var n = a(13).Symbol;
  c.exports = n;
}, function (c, e, a) {
  var n = a(23),
      t = a(114),
      r = a(115),
      i = "[object Null]",
      o = "[object Undefined]",
      l = n ? n.toStringTag : void 0;

  c.exports = function (c) {
    return null == c ? void 0 === c ? o : i : l && l in Object(c) ? t(c) : r(c);
  };
}, function (c, e) {
  c.exports = function (c) {
    return null != c && "object" == typeof c;
  };
}, function (c, e, a) {
  "use strict";

  a.r(e), a.d(e, "fas", function () {
    return Op;
  }), a.d(e, "prefix", function () {
    return n;
  }), a.d(e, "faAd", function () {
    return t;
  }), a.d(e, "faAddressBook", function () {
    return r;
  }), a.d(e, "faAddressCard", function () {
    return i;
  }), a.d(e, "faAdjust", function () {
    return o;
  }), a.d(e, "faAirFreshener", function () {
    return l;
  }), a.d(e, "faAlignCenter", function () {
    return f;
  }), a.d(e, "faAlignJustify", function () {
    return s;
  }), a.d(e, "faAlignLeft", function () {
    return u;
  }), a.d(e, "faAlignRight", function () {
    return h;
  }), a.d(e, "faAllergies", function () {
    return m;
  }), a.d(e, "faAmbulance", function () {
    return v;
  }), a.d(e, "faAmericanSignLanguageInterpreting", function () {
    return d;
  }), a.d(e, "faAnchor", function () {
    return M;
  }), a.d(e, "faAngleDoubleDown", function () {
    return p;
  }), a.d(e, "faAngleDoubleLeft", function () {
    return z;
  }), a.d(e, "faAngleDoubleRight", function () {
    return C;
  }), a.d(e, "faAngleDoubleUp", function () {
    return L;
  }), a.d(e, "faAngleDown", function () {
    return A;
  }), a.d(e, "faAngleLeft", function () {
    return N;
  }), a.d(e, "faAngleRight", function () {
    return g;
  }), a.d(e, "faAngleUp", function () {
    return H;
  }), a.d(e, "faAngry", function () {
    return V;
  }), a.d(e, "faAnkh", function () {
    return x;
  }), a.d(e, "faAppleAlt", function () {
    return w;
  }), a.d(e, "faArchive", function () {
    return y;
  }), a.d(e, "faArchway", function () {
    return b;
  }), a.d(e, "faArrowAltCircleDown", function () {
    return S;
  }), a.d(e, "faArrowAltCircleLeft", function () {
    return T;
  }), a.d(e, "faArrowAltCircleRight", function () {
    return D;
  }), a.d(e, "faArrowAltCircleUp", function () {
    return j;
  }), a.d(e, "faArrowCircleDown", function () {
    return E;
  }), a.d(e, "faArrowCircleLeft", function () {
    return k;
  }), a.d(e, "faArrowCircleRight", function () {
    return I;
  }), a.d(e, "faArrowCircleUp", function () {
    return O;
  }), a.d(e, "faArrowDown", function () {
    return Q;
  }), a.d(e, "faArrowLeft", function () {
    return Z;
  }), a.d(e, "faArrowRight", function () {
    return U;
  }), a.d(e, "faArrowUp", function () {
    return B;
  }), a.d(e, "faArrowsAlt", function () {
    return R;
  }), a.d(e, "faArrowsAltH", function () {
    return Y;
  }), a.d(e, "faArrowsAltV", function () {
    return P;
  }), a.d(e, "faAssistiveListeningSystems", function () {
    return F;
  }), a.d(e, "faAsterisk", function () {
    return W;
  }), a.d(e, "faAt", function () {
    return G;
  }), a.d(e, "faAtlas", function () {
    return q;
  }), a.d(e, "faAtom", function () {
    return J;
  }), a.d(e, "faAudioDescription", function () {
    return K;
  }), a.d(e, "faAward", function () {
    return X;
  }), a.d(e, "faBaby", function () {
    return _;
  }), a.d(e, "faBabyCarriage", function () {
    return $;
  }), a.d(e, "faBackspace", function () {
    return cc;
  }), a.d(e, "faBackward", function () {
    return ec;
  }), a.d(e, "faBacon", function () {
    return ac;
  }), a.d(e, "faBacteria", function () {
    return nc;
  }), a.d(e, "faBacterium", function () {
    return tc;
  }), a.d(e, "faBahai", function () {
    return rc;
  }), a.d(e, "faBalanceScale", function () {
    return ic;
  }), a.d(e, "faBalanceScaleLeft", function () {
    return oc;
  }), a.d(e, "faBalanceScaleRight", function () {
    return lc;
  }), a.d(e, "faBan", function () {
    return fc;
  }), a.d(e, "faBandAid", function () {
    return sc;
  }), a.d(e, "faBarcode", function () {
    return uc;
  }), a.d(e, "faBars", function () {
    return hc;
  }), a.d(e, "faBaseballBall", function () {
    return mc;
  }), a.d(e, "faBasketballBall", function () {
    return vc;
  }), a.d(e, "faBath", function () {
    return dc;
  }), a.d(e, "faBatteryEmpty", function () {
    return Mc;
  }), a.d(e, "faBatteryFull", function () {
    return pc;
  }), a.d(e, "faBatteryHalf", function () {
    return zc;
  }), a.d(e, "faBatteryQuarter", function () {
    return Cc;
  }), a.d(e, "faBatteryThreeQuarters", function () {
    return Lc;
  }), a.d(e, "faBed", function () {
    return Ac;
  }), a.d(e, "faBeer", function () {
    return Nc;
  }), a.d(e, "faBell", function () {
    return gc;
  }), a.d(e, "faBellSlash", function () {
    return Hc;
  }), a.d(e, "faBezierCurve", function () {
    return Vc;
  }), a.d(e, "faBible", function () {
    return xc;
  }), a.d(e, "faBicycle", function () {
    return wc;
  }), a.d(e, "faBiking", function () {
    return yc;
  }), a.d(e, "faBinoculars", function () {
    return bc;
  }), a.d(e, "faBiohazard", function () {
    return Sc;
  }), a.d(e, "faBirthdayCake", function () {
    return Tc;
  }), a.d(e, "faBlender", function () {
    return Dc;
  }), a.d(e, "faBlenderPhone", function () {
    return jc;
  }), a.d(e, "faBlind", function () {
    return Ec;
  }), a.d(e, "faBlog", function () {
    return kc;
  }), a.d(e, "faBold", function () {
    return Ic;
  }), a.d(e, "faBolt", function () {
    return Oc;
  }), a.d(e, "faBomb", function () {
    return Qc;
  }), a.d(e, "faBone", function () {
    return Zc;
  }), a.d(e, "faBong", function () {
    return Uc;
  }), a.d(e, "faBook", function () {
    return Bc;
  }), a.d(e, "faBookDead", function () {
    return Rc;
  }), a.d(e, "faBookMedical", function () {
    return Yc;
  }), a.d(e, "faBookOpen", function () {
    return Pc;
  }), a.d(e, "faBookReader", function () {
    return Fc;
  }), a.d(e, "faBookmark", function () {
    return Wc;
  }), a.d(e, "faBorderAll", function () {
    return Gc;
  }), a.d(e, "faBorderNone", function () {
    return qc;
  }), a.d(e, "faBorderStyle", function () {
    return Jc;
  }), a.d(e, "faBowlingBall", function () {
    return Kc;
  }), a.d(e, "faBox", function () {
    return Xc;
  }), a.d(e, "faBoxOpen", function () {
    return _c;
  }), a.d(e, "faBoxTissue", function () {
    return $c;
  }), a.d(e, "faBoxes", function () {
    return ce;
  }), a.d(e, "faBraille", function () {
    return ee;
  }), a.d(e, "faBrain", function () {
    return ae;
  }), a.d(e, "faBreadSlice", function () {
    return ne;
  }), a.d(e, "faBriefcase", function () {
    return te;
  }), a.d(e, "faBriefcaseMedical", function () {
    return re;
  }), a.d(e, "faBroadcastTower", function () {
    return ie;
  }), a.d(e, "faBroom", function () {
    return oe;
  }), a.d(e, "faBrush", function () {
    return le;
  }), a.d(e, "faBug", function () {
    return fe;
  }), a.d(e, "faBuilding", function () {
    return se;
  }), a.d(e, "faBullhorn", function () {
    return ue;
  }), a.d(e, "faBullseye", function () {
    return he;
  }), a.d(e, "faBurn", function () {
    return me;
  }), a.d(e, "faBus", function () {
    return ve;
  }), a.d(e, "faBusAlt", function () {
    return de;
  }), a.d(e, "faBusinessTime", function () {
    return Me;
  }), a.d(e, "faCalculator", function () {
    return pe;
  }), a.d(e, "faCalendar", function () {
    return ze;
  }), a.d(e, "faCalendarAlt", function () {
    return Ce;
  }), a.d(e, "faCalendarCheck", function () {
    return Le;
  }), a.d(e, "faCalendarDay", function () {
    return Ae;
  }), a.d(e, "faCalendarMinus", function () {
    return Ne;
  }), a.d(e, "faCalendarPlus", function () {
    return ge;
  }), a.d(e, "faCalendarTimes", function () {
    return He;
  }), a.d(e, "faCalendarWeek", function () {
    return Ve;
  }), a.d(e, "faCamera", function () {
    return xe;
  }), a.d(e, "faCameraRetro", function () {
    return we;
  }), a.d(e, "faCampground", function () {
    return ye;
  }), a.d(e, "faCandyCane", function () {
    return be;
  }), a.d(e, "faCannabis", function () {
    return Se;
  }), a.d(e, "faCapsules", function () {
    return Te;
  }), a.d(e, "faCar", function () {
    return De;
  }), a.d(e, "faCarAlt", function () {
    return je;
  }), a.d(e, "faCarBattery", function () {
    return Ee;
  }), a.d(e, "faCarCrash", function () {
    return ke;
  }), a.d(e, "faCarSide", function () {
    return Ie;
  }), a.d(e, "faCaravan", function () {
    return Oe;
  }), a.d(e, "faCaretDown", function () {
    return Qe;
  }), a.d(e, "faCaretLeft", function () {
    return Ze;
  }), a.d(e, "faCaretRight", function () {
    return Ue;
  }), a.d(e, "faCaretSquareDown", function () {
    return Be;
  }), a.d(e, "faCaretSquareLeft", function () {
    return Re;
  }), a.d(e, "faCaretSquareRight", function () {
    return Ye;
  }), a.d(e, "faCaretSquareUp", function () {
    return Pe;
  }), a.d(e, "faCaretUp", function () {
    return Fe;
  }), a.d(e, "faCarrot", function () {
    return We;
  }), a.d(e, "faCartArrowDown", function () {
    return Ge;
  }), a.d(e, "faCartPlus", function () {
    return qe;
  }), a.d(e, "faCashRegister", function () {
    return Je;
  }), a.d(e, "faCat", function () {
    return Ke;
  }), a.d(e, "faCertificate", function () {
    return Xe;
  }), a.d(e, "faChair", function () {
    return _e;
  }), a.d(e, "faChalkboard", function () {
    return $e;
  }), a.d(e, "faChalkboardTeacher", function () {
    return ca;
  }), a.d(e, "faChargingStation", function () {
    return ea;
  }), a.d(e, "faChartArea", function () {
    return aa;
  }), a.d(e, "faChartBar", function () {
    return na;
  }), a.d(e, "faChartLine", function () {
    return ta;
  }), a.d(e, "faChartPie", function () {
    return ra;
  }), a.d(e, "faCheck", function () {
    return ia;
  }), a.d(e, "faCheckCircle", function () {
    return oa;
  }), a.d(e, "faCheckDouble", function () {
    return la;
  }), a.d(e, "faCheckSquare", function () {
    return fa;
  }), a.d(e, "faCheese", function () {
    return sa;
  }), a.d(e, "faChess", function () {
    return ua;
  }), a.d(e, "faChessBishop", function () {
    return ha;
  }), a.d(e, "faChessBoard", function () {
    return ma;
  }), a.d(e, "faChessKing", function () {
    return va;
  }), a.d(e, "faChessKnight", function () {
    return da;
  }), a.d(e, "faChessPawn", function () {
    return Ma;
  }), a.d(e, "faChessQueen", function () {
    return pa;
  }), a.d(e, "faChessRook", function () {
    return za;
  }), a.d(e, "faChevronCircleDown", function () {
    return Ca;
  }), a.d(e, "faChevronCircleLeft", function () {
    return La;
  }), a.d(e, "faChevronCircleRight", function () {
    return Aa;
  }), a.d(e, "faChevronCircleUp", function () {
    return Na;
  }), a.d(e, "faChevronDown", function () {
    return ga;
  }), a.d(e, "faChevronLeft", function () {
    return Ha;
  }), a.d(e, "faChevronRight", function () {
    return Va;
  }), a.d(e, "faChevronUp", function () {
    return xa;
  }), a.d(e, "faChild", function () {
    return wa;
  }), a.d(e, "faChurch", function () {
    return ya;
  }), a.d(e, "faCircle", function () {
    return ba;
  }), a.d(e, "faCircleNotch", function () {
    return Sa;
  }), a.d(e, "faCity", function () {
    return Ta;
  }), a.d(e, "faClinicMedical", function () {
    return Da;
  }), a.d(e, "faClipboard", function () {
    return ja;
  }), a.d(e, "faClipboardCheck", function () {
    return Ea;
  }), a.d(e, "faClipboardList", function () {
    return ka;
  }), a.d(e, "faClock", function () {
    return Ia;
  }), a.d(e, "faClone", function () {
    return Oa;
  }), a.d(e, "faClosedCaptioning", function () {
    return Qa;
  }), a.d(e, "faCloud", function () {
    return Za;
  }), a.d(e, "faCloudDownloadAlt", function () {
    return Ua;
  }), a.d(e, "faCloudMeatball", function () {
    return Ba;
  }), a.d(e, "faCloudMoon", function () {
    return Ra;
  }), a.d(e, "faCloudMoonRain", function () {
    return Ya;
  }), a.d(e, "faCloudRain", function () {
    return Pa;
  }), a.d(e, "faCloudShowersHeavy", function () {
    return Fa;
  }), a.d(e, "faCloudSun", function () {
    return Wa;
  }), a.d(e, "faCloudSunRain", function () {
    return Ga;
  }), a.d(e, "faCloudUploadAlt", function () {
    return qa;
  }), a.d(e, "faCocktail", function () {
    return Ja;
  }), a.d(e, "faCode", function () {
    return Ka;
  }), a.d(e, "faCodeBranch", function () {
    return Xa;
  }), a.d(e, "faCoffee", function () {
    return _a;
  }), a.d(e, "faCog", function () {
    return $a;
  }), a.d(e, "faCogs", function () {
    return cn;
  }), a.d(e, "faCoins", function () {
    return en;
  }), a.d(e, "faColumns", function () {
    return an;
  }), a.d(e, "faComment", function () {
    return nn;
  }), a.d(e, "faCommentAlt", function () {
    return tn;
  }), a.d(e, "faCommentDollar", function () {
    return rn;
  }), a.d(e, "faCommentDots", function () {
    return on;
  }), a.d(e, "faCommentMedical", function () {
    return ln;
  }), a.d(e, "faCommentSlash", function () {
    return fn;
  }), a.d(e, "faComments", function () {
    return sn;
  }), a.d(e, "faCommentsDollar", function () {
    return un;
  }), a.d(e, "faCompactDisc", function () {
    return hn;
  }), a.d(e, "faCompass", function () {
    return mn;
  }), a.d(e, "faCompress", function () {
    return vn;
  }), a.d(e, "faCompressAlt", function () {
    return dn;
  }), a.d(e, "faCompressArrowsAlt", function () {
    return Mn;
  }), a.d(e, "faConciergeBell", function () {
    return pn;
  }), a.d(e, "faCookie", function () {
    return zn;
  }), a.d(e, "faCookieBite", function () {
    return Cn;
  }), a.d(e, "faCopy", function () {
    return Ln;
  }), a.d(e, "faCopyright", function () {
    return An;
  }), a.d(e, "faCouch", function () {
    return Nn;
  }), a.d(e, "faCreditCard", function () {
    return gn;
  }), a.d(e, "faCrop", function () {
    return Hn;
  }), a.d(e, "faCropAlt", function () {
    return Vn;
  }), a.d(e, "faCross", function () {
    return xn;
  }), a.d(e, "faCrosshairs", function () {
    return wn;
  }), a.d(e, "faCrow", function () {
    return yn;
  }), a.d(e, "faCrown", function () {
    return bn;
  }), a.d(e, "faCrutch", function () {
    return Sn;
  }), a.d(e, "faCube", function () {
    return Tn;
  }), a.d(e, "faCubes", function () {
    return Dn;
  }), a.d(e, "faCut", function () {
    return jn;
  }), a.d(e, "faDatabase", function () {
    return En;
  }), a.d(e, "faDeaf", function () {
    return kn;
  }), a.d(e, "faDemocrat", function () {
    return In;
  }), a.d(e, "faDesktop", function () {
    return On;
  }), a.d(e, "faDharmachakra", function () {
    return Qn;
  }), a.d(e, "faDiagnoses", function () {
    return Zn;
  }), a.d(e, "faDice", function () {
    return Un;
  }), a.d(e, "faDiceD20", function () {
    return Bn;
  }), a.d(e, "faDiceD6", function () {
    return Rn;
  }), a.d(e, "faDiceFive", function () {
    return Yn;
  }), a.d(e, "faDiceFour", function () {
    return Pn;
  }), a.d(e, "faDiceOne", function () {
    return Fn;
  }), a.d(e, "faDiceSix", function () {
    return Wn;
  }), a.d(e, "faDiceThree", function () {
    return Gn;
  }), a.d(e, "faDiceTwo", function () {
    return qn;
  }), a.d(e, "faDigitalTachograph", function () {
    return Jn;
  }), a.d(e, "faDirections", function () {
    return Kn;
  }), a.d(e, "faDisease", function () {
    return Xn;
  }), a.d(e, "faDivide", function () {
    return _n;
  }), a.d(e, "faDizzy", function () {
    return $n;
  }), a.d(e, "faDna", function () {
    return ct;
  }), a.d(e, "faDog", function () {
    return et;
  }), a.d(e, "faDollarSign", function () {
    return at;
  }), a.d(e, "faDolly", function () {
    return nt;
  }), a.d(e, "faDollyFlatbed", function () {
    return tt;
  }), a.d(e, "faDonate", function () {
    return rt;
  }), a.d(e, "faDoorClosed", function () {
    return it;
  }), a.d(e, "faDoorOpen", function () {
    return ot;
  }), a.d(e, "faDotCircle", function () {
    return lt;
  }), a.d(e, "faDove", function () {
    return ft;
  }), a.d(e, "faDownload", function () {
    return st;
  }), a.d(e, "faDraftingCompass", function () {
    return ut;
  }), a.d(e, "faDragon", function () {
    return ht;
  }), a.d(e, "faDrawPolygon", function () {
    return mt;
  }), a.d(e, "faDrum", function () {
    return vt;
  }), a.d(e, "faDrumSteelpan", function () {
    return dt;
  }), a.d(e, "faDrumstickBite", function () {
    return Mt;
  }), a.d(e, "faDumbbell", function () {
    return pt;
  }), a.d(e, "faDumpster", function () {
    return zt;
  }), a.d(e, "faDumpsterFire", function () {
    return Ct;
  }), a.d(e, "faDungeon", function () {
    return Lt;
  }), a.d(e, "faEdit", function () {
    return At;
  }), a.d(e, "faEgg", function () {
    return Nt;
  }), a.d(e, "faEject", function () {
    return gt;
  }), a.d(e, "faEllipsisH", function () {
    return Ht;
  }), a.d(e, "faEllipsisV", function () {
    return Vt;
  }), a.d(e, "faEnvelope", function () {
    return xt;
  }), a.d(e, "faEnvelopeOpen", function () {
    return wt;
  }), a.d(e, "faEnvelopeOpenText", function () {
    return yt;
  }), a.d(e, "faEnvelopeSquare", function () {
    return bt;
  }), a.d(e, "faEquals", function () {
    return St;
  }), a.d(e, "faEraser", function () {
    return Tt;
  }), a.d(e, "faEthernet", function () {
    return Dt;
  }), a.d(e, "faEuroSign", function () {
    return jt;
  }), a.d(e, "faExchangeAlt", function () {
    return Et;
  }), a.d(e, "faExclamation", function () {
    return kt;
  }), a.d(e, "faExclamationCircle", function () {
    return It;
  }), a.d(e, "faExclamationTriangle", function () {
    return Ot;
  }), a.d(e, "faExpand", function () {
    return Qt;
  }), a.d(e, "faExpandAlt", function () {
    return Zt;
  }), a.d(e, "faExpandArrowsAlt", function () {
    return Ut;
  }), a.d(e, "faExternalLinkAlt", function () {
    return Bt;
  }), a.d(e, "faExternalLinkSquareAlt", function () {
    return Rt;
  }), a.d(e, "faEye", function () {
    return Yt;
  }), a.d(e, "faEyeDropper", function () {
    return Pt;
  }), a.d(e, "faEyeSlash", function () {
    return Ft;
  }), a.d(e, "faFan", function () {
    return Wt;
  }), a.d(e, "faFastBackward", function () {
    return Gt;
  }), a.d(e, "faFastForward", function () {
    return qt;
  }), a.d(e, "faFaucet", function () {
    return Jt;
  }), a.d(e, "faFax", function () {
    return Kt;
  }), a.d(e, "faFeather", function () {
    return Xt;
  }), a.d(e, "faFeatherAlt", function () {
    return _t;
  }), a.d(e, "faFemale", function () {
    return $t;
  }), a.d(e, "faFighterJet", function () {
    return cr;
  }), a.d(e, "faFile", function () {
    return er;
  }), a.d(e, "faFileAlt", function () {
    return ar;
  }), a.d(e, "faFileArchive", function () {
    return nr;
  }), a.d(e, "faFileAudio", function () {
    return tr;
  }), a.d(e, "faFileCode", function () {
    return rr;
  }), a.d(e, "faFileContract", function () {
    return ir;
  }), a.d(e, "faFileCsv", function () {
    return or;
  }), a.d(e, "faFileDownload", function () {
    return lr;
  }), a.d(e, "faFileExcel", function () {
    return fr;
  }), a.d(e, "faFileExport", function () {
    return sr;
  }), a.d(e, "faFileImage", function () {
    return ur;
  }), a.d(e, "faFileImport", function () {
    return hr;
  }), a.d(e, "faFileInvoice", function () {
    return mr;
  }), a.d(e, "faFileInvoiceDollar", function () {
    return vr;
  }), a.d(e, "faFileMedical", function () {
    return dr;
  }), a.d(e, "faFileMedicalAlt", function () {
    return Mr;
  }), a.d(e, "faFilePdf", function () {
    return pr;
  }), a.d(e, "faFilePowerpoint", function () {
    return zr;
  }), a.d(e, "faFilePrescription", function () {
    return Cr;
  }), a.d(e, "faFileSignature", function () {
    return Lr;
  }), a.d(e, "faFileUpload", function () {
    return Ar;
  }), a.d(e, "faFileVideo", function () {
    return Nr;
  }), a.d(e, "faFileWord", function () {
    return gr;
  }), a.d(e, "faFill", function () {
    return Hr;
  }), a.d(e, "faFillDrip", function () {
    return Vr;
  }), a.d(e, "faFilm", function () {
    return xr;
  }), a.d(e, "faFilter", function () {
    return wr;
  }), a.d(e, "faFingerprint", function () {
    return yr;
  }), a.d(e, "faFire", function () {
    return br;
  }), a.d(e, "faFireAlt", function () {
    return Sr;
  }), a.d(e, "faFireExtinguisher", function () {
    return Tr;
  }), a.d(e, "faFirstAid", function () {
    return Dr;
  }), a.d(e, "faFish", function () {
    return jr;
  }), a.d(e, "faFistRaised", function () {
    return Er;
  }), a.d(e, "faFlag", function () {
    return kr;
  }), a.d(e, "faFlagCheckered", function () {
    return Ir;
  }), a.d(e, "faFlagUsa", function () {
    return Or;
  }), a.d(e, "faFlask", function () {
    return Qr;
  }), a.d(e, "faFlushed", function () {
    return Zr;
  }), a.d(e, "faFolder", function () {
    return Ur;
  }), a.d(e, "faFolderMinus", function () {
    return Br;
  }), a.d(e, "faFolderOpen", function () {
    return Rr;
  }), a.d(e, "faFolderPlus", function () {
    return Yr;
  }), a.d(e, "faFont", function () {
    return Pr;
  }), a.d(e, "faFontAwesomeLogoFull", function () {
    return Fr;
  }), a.d(e, "faFootballBall", function () {
    return Wr;
  }), a.d(e, "faForward", function () {
    return Gr;
  }), a.d(e, "faFrog", function () {
    return qr;
  }), a.d(e, "faFrown", function () {
    return Jr;
  }), a.d(e, "faFrownOpen", function () {
    return Kr;
  }), a.d(e, "faFunnelDollar", function () {
    return Xr;
  }), a.d(e, "faFutbol", function () {
    return _r;
  }), a.d(e, "faGamepad", function () {
    return $r;
  }), a.d(e, "faGasPump", function () {
    return ci;
  }), a.d(e, "faGavel", function () {
    return ei;
  }), a.d(e, "faGem", function () {
    return ai;
  }), a.d(e, "faGenderless", function () {
    return ni;
  }), a.d(e, "faGhost", function () {
    return ti;
  }), a.d(e, "faGift", function () {
    return ri;
  }), a.d(e, "faGifts", function () {
    return ii;
  }), a.d(e, "faGlassCheers", function () {
    return oi;
  }), a.d(e, "faGlassMartini", function () {
    return li;
  }), a.d(e, "faGlassMartiniAlt", function () {
    return fi;
  }), a.d(e, "faGlassWhiskey", function () {
    return si;
  }), a.d(e, "faGlasses", function () {
    return ui;
  }), a.d(e, "faGlobe", function () {
    return hi;
  }), a.d(e, "faGlobeAfrica", function () {
    return mi;
  }), a.d(e, "faGlobeAmericas", function () {
    return vi;
  }), a.d(e, "faGlobeAsia", function () {
    return di;
  }), a.d(e, "faGlobeEurope", function () {
    return Mi;
  }), a.d(e, "faGolfBall", function () {
    return pi;
  }), a.d(e, "faGopuram", function () {
    return zi;
  }), a.d(e, "faGraduationCap", function () {
    return Ci;
  }), a.d(e, "faGreaterThan", function () {
    return Li;
  }), a.d(e, "faGreaterThanEqual", function () {
    return Ai;
  }), a.d(e, "faGrimace", function () {
    return Ni;
  }), a.d(e, "faGrin", function () {
    return gi;
  }), a.d(e, "faGrinAlt", function () {
    return Hi;
  }), a.d(e, "faGrinBeam", function () {
    return Vi;
  }), a.d(e, "faGrinBeamSweat", function () {
    return xi;
  }), a.d(e, "faGrinHearts", function () {
    return wi;
  }), a.d(e, "faGrinSquint", function () {
    return yi;
  }), a.d(e, "faGrinSquintTears", function () {
    return bi;
  }), a.d(e, "faGrinStars", function () {
    return Si;
  }), a.d(e, "faGrinTears", function () {
    return Ti;
  }), a.d(e, "faGrinTongue", function () {
    return Di;
  }), a.d(e, "faGrinTongueSquint", function () {
    return ji;
  }), a.d(e, "faGrinTongueWink", function () {
    return Ei;
  }), a.d(e, "faGrinWink", function () {
    return ki;
  }), a.d(e, "faGripHorizontal", function () {
    return Ii;
  }), a.d(e, "faGripLines", function () {
    return Oi;
  }), a.d(e, "faGripLinesVertical", function () {
    return Qi;
  }), a.d(e, "faGripVertical", function () {
    return Zi;
  }), a.d(e, "faGuitar", function () {
    return Ui;
  }), a.d(e, "faHSquare", function () {
    return Bi;
  }), a.d(e, "faHamburger", function () {
    return Ri;
  }), a.d(e, "faHammer", function () {
    return Yi;
  }), a.d(e, "faHamsa", function () {
    return Pi;
  }), a.d(e, "faHandHolding", function () {
    return Fi;
  }), a.d(e, "faHandHoldingHeart", function () {
    return Wi;
  }), a.d(e, "faHandHoldingMedical", function () {
    return Gi;
  }), a.d(e, "faHandHoldingUsd", function () {
    return qi;
  }), a.d(e, "faHandHoldingWater", function () {
    return Ji;
  }), a.d(e, "faHandLizard", function () {
    return Ki;
  }), a.d(e, "faHandMiddleFinger", function () {
    return Xi;
  }), a.d(e, "faHandPaper", function () {
    return _i;
  }), a.d(e, "faHandPeace", function () {
    return $i;
  }), a.d(e, "faHandPointDown", function () {
    return co;
  }), a.d(e, "faHandPointLeft", function () {
    return eo;
  }), a.d(e, "faHandPointRight", function () {
    return ao;
  }), a.d(e, "faHandPointUp", function () {
    return no;
  }), a.d(e, "faHandPointer", function () {
    return to;
  }), a.d(e, "faHandRock", function () {
    return ro;
  }), a.d(e, "faHandScissors", function () {
    return io;
  }), a.d(e, "faHandSparkles", function () {
    return oo;
  }), a.d(e, "faHandSpock", function () {
    return lo;
  }), a.d(e, "faHands", function () {
    return fo;
  }), a.d(e, "faHandsHelping", function () {
    return so;
  }), a.d(e, "faHandsWash", function () {
    return uo;
  }), a.d(e, "faHandshake", function () {
    return ho;
  }), a.d(e, "faHandshakeAltSlash", function () {
    return mo;
  }), a.d(e, "faHandshakeSlash", function () {
    return vo;
  }), a.d(e, "faHanukiah", function () {
    return Mo;
  }), a.d(e, "faHardHat", function () {
    return po;
  }), a.d(e, "faHashtag", function () {
    return zo;
  }), a.d(e, "faHatCowboy", function () {
    return Co;
  }), a.d(e, "faHatCowboySide", function () {
    return Lo;
  }), a.d(e, "faHatWizard", function () {
    return Ao;
  }), a.d(e, "faHdd", function () {
    return No;
  }), a.d(e, "faHeadSideCough", function () {
    return go;
  }), a.d(e, "faHeadSideCoughSlash", function () {
    return Ho;
  }), a.d(e, "faHeadSideMask", function () {
    return Vo;
  }), a.d(e, "faHeadSideVirus", function () {
    return xo;
  }), a.d(e, "faHeading", function () {
    return wo;
  }), a.d(e, "faHeadphones", function () {
    return yo;
  }), a.d(e, "faHeadphonesAlt", function () {
    return bo;
  }), a.d(e, "faHeadset", function () {
    return So;
  }), a.d(e, "faHeart", function () {
    return To;
  }), a.d(e, "faHeartBroken", function () {
    return Do;
  }), a.d(e, "faHeartbeat", function () {
    return jo;
  }), a.d(e, "faHelicopter", function () {
    return Eo;
  }), a.d(e, "faHighlighter", function () {
    return ko;
  }), a.d(e, "faHiking", function () {
    return Io;
  }), a.d(e, "faHippo", function () {
    return Oo;
  }), a.d(e, "faHistory", function () {
    return Qo;
  }), a.d(e, "faHockeyPuck", function () {
    return Zo;
  }), a.d(e, "faHollyBerry", function () {
    return Uo;
  }), a.d(e, "faHome", function () {
    return Bo;
  }), a.d(e, "faHorse", function () {
    return Ro;
  }), a.d(e, "faHorseHead", function () {
    return Yo;
  }), a.d(e, "faHospital", function () {
    return Po;
  }), a.d(e, "faHospitalAlt", function () {
    return Fo;
  }), a.d(e, "faHospitalSymbol", function () {
    return Wo;
  }), a.d(e, "faHospitalUser", function () {
    return Go;
  }), a.d(e, "faHotTub", function () {
    return qo;
  }), a.d(e, "faHotdog", function () {
    return Jo;
  }), a.d(e, "faHotel", function () {
    return Ko;
  }), a.d(e, "faHourglass", function () {
    return Xo;
  }), a.d(e, "faHourglassEnd", function () {
    return _o;
  }), a.d(e, "faHourglassHalf", function () {
    return $o;
  }), a.d(e, "faHourglassStart", function () {
    return cl;
  }), a.d(e, "faHouseDamage", function () {
    return el;
  }), a.d(e, "faHouseUser", function () {
    return al;
  }), a.d(e, "faHryvnia", function () {
    return nl;
  }), a.d(e, "faICursor", function () {
    return tl;
  }), a.d(e, "faIceCream", function () {
    return rl;
  }), a.d(e, "faIcicles", function () {
    return il;
  }), a.d(e, "faIcons", function () {
    return ol;
  }), a.d(e, "faIdBadge", function () {
    return ll;
  }), a.d(e, "faIdCard", function () {
    return fl;
  }), a.d(e, "faIdCardAlt", function () {
    return sl;
  }), a.d(e, "faIgloo", function () {
    return ul;
  }), a.d(e, "faImage", function () {
    return hl;
  }), a.d(e, "faImages", function () {
    return ml;
  }), a.d(e, "faInbox", function () {
    return vl;
  }), a.d(e, "faIndent", function () {
    return dl;
  }), a.d(e, "faIndustry", function () {
    return Ml;
  }), a.d(e, "faInfinity", function () {
    return pl;
  }), a.d(e, "faInfo", function () {
    return zl;
  }), a.d(e, "faInfoCircle", function () {
    return Cl;
  }), a.d(e, "faItalic", function () {
    return Ll;
  }), a.d(e, "faJedi", function () {
    return Al;
  }), a.d(e, "faJoint", function () {
    return Nl;
  }), a.d(e, "faJournalWhills", function () {
    return gl;
  }), a.d(e, "faKaaba", function () {
    return Hl;
  }), a.d(e, "faKey", function () {
    return Vl;
  }), a.d(e, "faKeyboard", function () {
    return xl;
  }), a.d(e, "faKhanda", function () {
    return wl;
  }), a.d(e, "faKiss", function () {
    return yl;
  }), a.d(e, "faKissBeam", function () {
    return bl;
  }), a.d(e, "faKissWinkHeart", function () {
    return Sl;
  }), a.d(e, "faKiwiBird", function () {
    return Tl;
  }), a.d(e, "faLandmark", function () {
    return Dl;
  }), a.d(e, "faLanguage", function () {
    return jl;
  }), a.d(e, "faLaptop", function () {
    return El;
  }), a.d(e, "faLaptopCode", function () {
    return kl;
  }), a.d(e, "faLaptopHouse", function () {
    return Il;
  }), a.d(e, "faLaptopMedical", function () {
    return Ol;
  }), a.d(e, "faLaugh", function () {
    return Ql;
  }), a.d(e, "faLaughBeam", function () {
    return Zl;
  }), a.d(e, "faLaughSquint", function () {
    return Ul;
  }), a.d(e, "faLaughWink", function () {
    return Bl;
  }), a.d(e, "faLayerGroup", function () {
    return Rl;
  }), a.d(e, "faLeaf", function () {
    return Yl;
  }), a.d(e, "faLemon", function () {
    return Pl;
  }), a.d(e, "faLessThan", function () {
    return Fl;
  }), a.d(e, "faLessThanEqual", function () {
    return Wl;
  }), a.d(e, "faLevelDownAlt", function () {
    return Gl;
  }), a.d(e, "faLevelUpAlt", function () {
    return ql;
  }), a.d(e, "faLifeRing", function () {
    return Jl;
  }), a.d(e, "faLightbulb", function () {
    return Kl;
  }), a.d(e, "faLink", function () {
    return Xl;
  }), a.d(e, "faLiraSign", function () {
    return _l;
  }), a.d(e, "faList", function () {
    return $l;
  }), a.d(e, "faListAlt", function () {
    return cf;
  }), a.d(e, "faListOl", function () {
    return ef;
  }), a.d(e, "faListUl", function () {
    return af;
  }), a.d(e, "faLocationArrow", function () {
    return nf;
  }), a.d(e, "faLock", function () {
    return tf;
  }), a.d(e, "faLockOpen", function () {
    return rf;
  }), a.d(e, "faLongArrowAltDown", function () {
    return of;
  }), a.d(e, "faLongArrowAltLeft", function () {
    return lf;
  }), a.d(e, "faLongArrowAltRight", function () {
    return ff;
  }), a.d(e, "faLongArrowAltUp", function () {
    return sf;
  }), a.d(e, "faLowVision", function () {
    return uf;
  }), a.d(e, "faLuggageCart", function () {
    return hf;
  }), a.d(e, "faLungs", function () {
    return mf;
  }), a.d(e, "faLungsVirus", function () {
    return vf;
  }), a.d(e, "faMagic", function () {
    return df;
  }), a.d(e, "faMagnet", function () {
    return Mf;
  }), a.d(e, "faMailBulk", function () {
    return pf;
  }), a.d(e, "faMale", function () {
    return zf;
  }), a.d(e, "faMap", function () {
    return Cf;
  }), a.d(e, "faMapMarked", function () {
    return Lf;
  }), a.d(e, "faMapMarkedAlt", function () {
    return Af;
  }), a.d(e, "faMapMarker", function () {
    return Nf;
  }), a.d(e, "faMapMarkerAlt", function () {
    return gf;
  }), a.d(e, "faMapPin", function () {
    return Hf;
  }), a.d(e, "faMapSigns", function () {
    return Vf;
  }), a.d(e, "faMarker", function () {
    return xf;
  }), a.d(e, "faMars", function () {
    return wf;
  }), a.d(e, "faMarsDouble", function () {
    return yf;
  }), a.d(e, "faMarsStroke", function () {
    return bf;
  }), a.d(e, "faMarsStrokeH", function () {
    return Sf;
  }), a.d(e, "faMarsStrokeV", function () {
    return Tf;
  }), a.d(e, "faMask", function () {
    return Df;
  }), a.d(e, "faMedal", function () {
    return jf;
  }), a.d(e, "faMedkit", function () {
    return Ef;
  }), a.d(e, "faMeh", function () {
    return kf;
  }), a.d(e, "faMehBlank", function () {
    return If;
  }), a.d(e, "faMehRollingEyes", function () {
    return Of;
  }), a.d(e, "faMemory", function () {
    return Qf;
  }), a.d(e, "faMenorah", function () {
    return Zf;
  }), a.d(e, "faMercury", function () {
    return Uf;
  }), a.d(e, "faMeteor", function () {
    return Bf;
  }), a.d(e, "faMicrochip", function () {
    return Rf;
  }), a.d(e, "faMicrophone", function () {
    return Yf;
  }), a.d(e, "faMicrophoneAlt", function () {
    return Pf;
  }), a.d(e, "faMicrophoneAltSlash", function () {
    return Ff;
  }), a.d(e, "faMicrophoneSlash", function () {
    return Wf;
  }), a.d(e, "faMicroscope", function () {
    return Gf;
  }), a.d(e, "faMinus", function () {
    return qf;
  }), a.d(e, "faMinusCircle", function () {
    return Jf;
  }), a.d(e, "faMinusSquare", function () {
    return Kf;
  }), a.d(e, "faMitten", function () {
    return Xf;
  }), a.d(e, "faMobile", function () {
    return _f;
  }), a.d(e, "faMobileAlt", function () {
    return $f;
  }), a.d(e, "faMoneyBill", function () {
    return cs;
  }), a.d(e, "faMoneyBillAlt", function () {
    return es;
  }), a.d(e, "faMoneyBillWave", function () {
    return as;
  }), a.d(e, "faMoneyBillWaveAlt", function () {
    return ns;
  }), a.d(e, "faMoneyCheck", function () {
    return ts;
  }), a.d(e, "faMoneyCheckAlt", function () {
    return rs;
  }), a.d(e, "faMonument", function () {
    return is;
  }), a.d(e, "faMoon", function () {
    return os;
  }), a.d(e, "faMortarPestle", function () {
    return ls;
  }), a.d(e, "faMosque", function () {
    return fs;
  }), a.d(e, "faMotorcycle", function () {
    return ss;
  }), a.d(e, "faMountain", function () {
    return us;
  }), a.d(e, "faMouse", function () {
    return hs;
  }), a.d(e, "faMousePointer", function () {
    return ms;
  }), a.d(e, "faMugHot", function () {
    return vs;
  }), a.d(e, "faMusic", function () {
    return ds;
  }), a.d(e, "faNetworkWired", function () {
    return Ms;
  }), a.d(e, "faNeuter", function () {
    return ps;
  }), a.d(e, "faNewspaper", function () {
    return zs;
  }), a.d(e, "faNotEqual", function () {
    return Cs;
  }), a.d(e, "faNotesMedical", function () {
    return Ls;
  }), a.d(e, "faObjectGroup", function () {
    return As;
  }), a.d(e, "faObjectUngroup", function () {
    return Ns;
  }), a.d(e, "faOilCan", function () {
    return gs;
  }), a.d(e, "faOm", function () {
    return Hs;
  }), a.d(e, "faOtter", function () {
    return Vs;
  }), a.d(e, "faOutdent", function () {
    return xs;
  }), a.d(e, "faPager", function () {
    return ws;
  }), a.d(e, "faPaintBrush", function () {
    return ys;
  }), a.d(e, "faPaintRoller", function () {
    return bs;
  }), a.d(e, "faPalette", function () {
    return Ss;
  }), a.d(e, "faPallet", function () {
    return Ts;
  }), a.d(e, "faPaperPlane", function () {
    return Ds;
  }), a.d(e, "faPaperclip", function () {
    return js;
  }), a.d(e, "faParachuteBox", function () {
    return Es;
  }), a.d(e, "faParagraph", function () {
    return ks;
  }), a.d(e, "faParking", function () {
    return Is;
  }), a.d(e, "faPassport", function () {
    return Os;
  }), a.d(e, "faPastafarianism", function () {
    return Qs;
  }), a.d(e, "faPaste", function () {
    return Zs;
  }), a.d(e, "faPause", function () {
    return Us;
  }), a.d(e, "faPauseCircle", function () {
    return Bs;
  }), a.d(e, "faPaw", function () {
    return Rs;
  }), a.d(e, "faPeace", function () {
    return Ys;
  }), a.d(e, "faPen", function () {
    return Ps;
  }), a.d(e, "faPenAlt", function () {
    return Fs;
  }), a.d(e, "faPenFancy", function () {
    return Ws;
  }), a.d(e, "faPenNib", function () {
    return Gs;
  }), a.d(e, "faPenSquare", function () {
    return qs;
  }), a.d(e, "faPencilAlt", function () {
    return Js;
  }), a.d(e, "faPencilRuler", function () {
    return Ks;
  }), a.d(e, "faPeopleArrows", function () {
    return Xs;
  }), a.d(e, "faPeopleCarry", function () {
    return _s;
  }), a.d(e, "faPepperHot", function () {
    return $s;
  }), a.d(e, "faPercent", function () {
    return cu;
  }), a.d(e, "faPercentage", function () {
    return eu;
  }), a.d(e, "faPersonBooth", function () {
    return au;
  }), a.d(e, "faPhone", function () {
    return nu;
  }), a.d(e, "faPhoneAlt", function () {
    return tu;
  }), a.d(e, "faPhoneSlash", function () {
    return ru;
  }), a.d(e, "faPhoneSquare", function () {
    return iu;
  }), a.d(e, "faPhoneSquareAlt", function () {
    return ou;
  }), a.d(e, "faPhoneVolume", function () {
    return lu;
  }), a.d(e, "faPhotoVideo", function () {
    return fu;
  }), a.d(e, "faPiggyBank", function () {
    return su;
  }), a.d(e, "faPills", function () {
    return uu;
  }), a.d(e, "faPizzaSlice", function () {
    return hu;
  }), a.d(e, "faPlaceOfWorship", function () {
    return mu;
  }), a.d(e, "faPlane", function () {
    return vu;
  }), a.d(e, "faPlaneArrival", function () {
    return du;
  }), a.d(e, "faPlaneDeparture", function () {
    return Mu;
  }), a.d(e, "faPlaneSlash", function () {
    return pu;
  }), a.d(e, "faPlay", function () {
    return zu;
  }), a.d(e, "faPlayCircle", function () {
    return Cu;
  }), a.d(e, "faPlug", function () {
    return Lu;
  }), a.d(e, "faPlus", function () {
    return Au;
  }), a.d(e, "faPlusCircle", function () {
    return Nu;
  }), a.d(e, "faPlusSquare", function () {
    return gu;
  }), a.d(e, "faPodcast", function () {
    return Hu;
  }), a.d(e, "faPoll", function () {
    return Vu;
  }), a.d(e, "faPollH", function () {
    return xu;
  }), a.d(e, "faPoo", function () {
    return wu;
  }), a.d(e, "faPooStorm", function () {
    return yu;
  }), a.d(e, "faPoop", function () {
    return bu;
  }), a.d(e, "faPortrait", function () {
    return Su;
  }), a.d(e, "faPoundSign", function () {
    return Tu;
  }), a.d(e, "faPowerOff", function () {
    return Du;
  }), a.d(e, "faPray", function () {
    return ju;
  }), a.d(e, "faPrayingHands", function () {
    return Eu;
  }), a.d(e, "faPrescription", function () {
    return ku;
  }), a.d(e, "faPrescriptionBottle", function () {
    return Iu;
  }), a.d(e, "faPrescriptionBottleAlt", function () {
    return Ou;
  }), a.d(e, "faPrint", function () {
    return Qu;
  }), a.d(e, "faProcedures", function () {
    return Zu;
  }), a.d(e, "faProjectDiagram", function () {
    return Uu;
  }), a.d(e, "faPumpMedical", function () {
    return Bu;
  }), a.d(e, "faPumpSoap", function () {
    return Ru;
  }), a.d(e, "faPuzzlePiece", function () {
    return Yu;
  }), a.d(e, "faQrcode", function () {
    return Pu;
  }), a.d(e, "faQuestion", function () {
    return Fu;
  }), a.d(e, "faQuestionCircle", function () {
    return Wu;
  }), a.d(e, "faQuidditch", function () {
    return Gu;
  }), a.d(e, "faQuoteLeft", function () {
    return qu;
  }), a.d(e, "faQuoteRight", function () {
    return Ju;
  }), a.d(e, "faQuran", function () {
    return Ku;
  }), a.d(e, "faRadiation", function () {
    return Xu;
  }), a.d(e, "faRadiationAlt", function () {
    return _u;
  }), a.d(e, "faRainbow", function () {
    return $u;
  }), a.d(e, "faRandom", function () {
    return ch;
  }), a.d(e, "faReceipt", function () {
    return eh;
  }), a.d(e, "faRecordVinyl", function () {
    return ah;
  }), a.d(e, "faRecycle", function () {
    return nh;
  }), a.d(e, "faRedo", function () {
    return th;
  }), a.d(e, "faRedoAlt", function () {
    return rh;
  }), a.d(e, "faRegistered", function () {
    return ih;
  }), a.d(e, "faRemoveFormat", function () {
    return oh;
  }), a.d(e, "faReply", function () {
    return lh;
  }), a.d(e, "faReplyAll", function () {
    return fh;
  }), a.d(e, "faRepublican", function () {
    return sh;
  }), a.d(e, "faRestroom", function () {
    return uh;
  }), a.d(e, "faRetweet", function () {
    return hh;
  }), a.d(e, "faRibbon", function () {
    return mh;
  }), a.d(e, "faRing", function () {
    return vh;
  }), a.d(e, "faRoad", function () {
    return dh;
  }), a.d(e, "faRobot", function () {
    return Mh;
  }), a.d(e, "faRocket", function () {
    return ph;
  }), a.d(e, "faRoute", function () {
    return zh;
  }), a.d(e, "faRss", function () {
    return Ch;
  }), a.d(e, "faRssSquare", function () {
    return Lh;
  }), a.d(e, "faRubleSign", function () {
    return Ah;
  }), a.d(e, "faRuler", function () {
    return Nh;
  }), a.d(e, "faRulerCombined", function () {
    return gh;
  }), a.d(e, "faRulerHorizontal", function () {
    return Hh;
  }), a.d(e, "faRulerVertical", function () {
    return Vh;
  }), a.d(e, "faRunning", function () {
    return xh;
  }), a.d(e, "faRupeeSign", function () {
    return wh;
  }), a.d(e, "faSadCry", function () {
    return yh;
  }), a.d(e, "faSadTear", function () {
    return bh;
  }), a.d(e, "faSatellite", function () {
    return Sh;
  }), a.d(e, "faSatelliteDish", function () {
    return Th;
  }), a.d(e, "faSave", function () {
    return Dh;
  }), a.d(e, "faSchool", function () {
    return jh;
  }), a.d(e, "faScrewdriver", function () {
    return Eh;
  }), a.d(e, "faScroll", function () {
    return kh;
  }), a.d(e, "faSdCard", function () {
    return Ih;
  }), a.d(e, "faSearch", function () {
    return Oh;
  }), a.d(e, "faSearchDollar", function () {
    return Qh;
  }), a.d(e, "faSearchLocation", function () {
    return Zh;
  }), a.d(e, "faSearchMinus", function () {
    return Uh;
  }), a.d(e, "faSearchPlus", function () {
    return Bh;
  }), a.d(e, "faSeedling", function () {
    return Rh;
  }), a.d(e, "faServer", function () {
    return Yh;
  }), a.d(e, "faShapes", function () {
    return Ph;
  }), a.d(e, "faShare", function () {
    return Fh;
  }), a.d(e, "faShareAlt", function () {
    return Wh;
  }), a.d(e, "faShareAltSquare", function () {
    return Gh;
  }), a.d(e, "faShareSquare", function () {
    return qh;
  }), a.d(e, "faShekelSign", function () {
    return Jh;
  }), a.d(e, "faShieldAlt", function () {
    return Kh;
  }), a.d(e, "faShieldVirus", function () {
    return Xh;
  }), a.d(e, "faShip", function () {
    return _h;
  }), a.d(e, "faShippingFast", function () {
    return $h;
  }), a.d(e, "faShoePrints", function () {
    return cm;
  }), a.d(e, "faShoppingBag", function () {
    return em;
  }), a.d(e, "faShoppingBasket", function () {
    return am;
  }), a.d(e, "faShoppingCart", function () {
    return nm;
  }), a.d(e, "faShower", function () {
    return tm;
  }), a.d(e, "faShuttleVan", function () {
    return rm;
  }), a.d(e, "faSign", function () {
    return im;
  }), a.d(e, "faSignInAlt", function () {
    return om;
  }), a.d(e, "faSignLanguage", function () {
    return lm;
  }), a.d(e, "faSignOutAlt", function () {
    return fm;
  }), a.d(e, "faSignal", function () {
    return sm;
  }), a.d(e, "faSignature", function () {
    return um;
  }), a.d(e, "faSimCard", function () {
    return hm;
  }), a.d(e, "faSink", function () {
    return mm;
  }), a.d(e, "faSitemap", function () {
    return vm;
  }), a.d(e, "faSkating", function () {
    return dm;
  }), a.d(e, "faSkiing", function () {
    return Mm;
  }), a.d(e, "faSkiingNordic", function () {
    return pm;
  }), a.d(e, "faSkull", function () {
    return zm;
  }), a.d(e, "faSkullCrossbones", function () {
    return Cm;
  }), a.d(e, "faSlash", function () {
    return Lm;
  }), a.d(e, "faSleigh", function () {
    return Am;
  }), a.d(e, "faSlidersH", function () {
    return Nm;
  }), a.d(e, "faSmile", function () {
    return gm;
  }), a.d(e, "faSmileBeam", function () {
    return Hm;
  }), a.d(e, "faSmileWink", function () {
    return Vm;
  }), a.d(e, "faSmog", function () {
    return xm;
  }), a.d(e, "faSmoking", function () {
    return wm;
  }), a.d(e, "faSmokingBan", function () {
    return ym;
  }), a.d(e, "faSms", function () {
    return bm;
  }), a.d(e, "faSnowboarding", function () {
    return Sm;
  }), a.d(e, "faSnowflake", function () {
    return Tm;
  }), a.d(e, "faSnowman", function () {
    return Dm;
  }), a.d(e, "faSnowplow", function () {
    return jm;
  }), a.d(e, "faSoap", function () {
    return Em;
  }), a.d(e, "faSocks", function () {
    return km;
  }), a.d(e, "faSolarPanel", function () {
    return Im;
  }), a.d(e, "faSort", function () {
    return Om;
  }), a.d(e, "faSortAlphaDown", function () {
    return Qm;
  }), a.d(e, "faSortAlphaDownAlt", function () {
    return Zm;
  }), a.d(e, "faSortAlphaUp", function () {
    return Um;
  }), a.d(e, "faSortAlphaUpAlt", function () {
    return Bm;
  }), a.d(e, "faSortAmountDown", function () {
    return Rm;
  }), a.d(e, "faSortAmountDownAlt", function () {
    return Ym;
  }), a.d(e, "faSortAmountUp", function () {
    return Pm;
  }), a.d(e, "faSortAmountUpAlt", function () {
    return Fm;
  }), a.d(e, "faSortDown", function () {
    return Wm;
  }), a.d(e, "faSortNumericDown", function () {
    return Gm;
  });
  a.d(e, "faSortNumericDownAlt", function () {
    return qm;
  }), a.d(e, "faSortNumericUp", function () {
    return Jm;
  }), a.d(e, "faSortNumericUpAlt", function () {
    return Km;
  }), a.d(e, "faSortUp", function () {
    return Xm;
  }), a.d(e, "faSpa", function () {
    return _m;
  }), a.d(e, "faSpaceShuttle", function () {
    return $m;
  }), a.d(e, "faSpellCheck", function () {
    return cv;
  }), a.d(e, "faSpider", function () {
    return ev;
  }), a.d(e, "faSpinner", function () {
    return av;
  }), a.d(e, "faSplotch", function () {
    return nv;
  }), a.d(e, "faSprayCan", function () {
    return tv;
  }), a.d(e, "faSquare", function () {
    return rv;
  }), a.d(e, "faSquareFull", function () {
    return iv;
  }), a.d(e, "faSquareRootAlt", function () {
    return ov;
  }), a.d(e, "faStamp", function () {
    return lv;
  }), a.d(e, "faStar", function () {
    return fv;
  }), a.d(e, "faStarAndCrescent", function () {
    return sv;
  }), a.d(e, "faStarHalf", function () {
    return uv;
  }), a.d(e, "faStarHalfAlt", function () {
    return hv;
  }), a.d(e, "faStarOfDavid", function () {
    return mv;
  }), a.d(e, "faStarOfLife", function () {
    return vv;
  }), a.d(e, "faStepBackward", function () {
    return dv;
  }), a.d(e, "faStepForward", function () {
    return Mv;
  }), a.d(e, "faStethoscope", function () {
    return pv;
  }), a.d(e, "faStickyNote", function () {
    return zv;
  }), a.d(e, "faStop", function () {
    return Cv;
  }), a.d(e, "faStopCircle", function () {
    return Lv;
  }), a.d(e, "faStopwatch", function () {
    return Av;
  }), a.d(e, "faStopwatch20", function () {
    return Nv;
  }), a.d(e, "faStore", function () {
    return gv;
  }), a.d(e, "faStoreAlt", function () {
    return Hv;
  }), a.d(e, "faStoreAltSlash", function () {
    return Vv;
  }), a.d(e, "faStoreSlash", function () {
    return xv;
  }), a.d(e, "faStream", function () {
    return wv;
  }), a.d(e, "faStreetView", function () {
    return yv;
  }), a.d(e, "faStrikethrough", function () {
    return bv;
  }), a.d(e, "faStroopwafel", function () {
    return Sv;
  }), a.d(e, "faSubscript", function () {
    return Tv;
  }), a.d(e, "faSubway", function () {
    return Dv;
  }), a.d(e, "faSuitcase", function () {
    return jv;
  }), a.d(e, "faSuitcaseRolling", function () {
    return Ev;
  }), a.d(e, "faSun", function () {
    return kv;
  }), a.d(e, "faSuperscript", function () {
    return Iv;
  }), a.d(e, "faSurprise", function () {
    return Ov;
  }), a.d(e, "faSwatchbook", function () {
    return Qv;
  }), a.d(e, "faSwimmer", function () {
    return Zv;
  }), a.d(e, "faSwimmingPool", function () {
    return Uv;
  }), a.d(e, "faSynagogue", function () {
    return Bv;
  }), a.d(e, "faSync", function () {
    return Rv;
  }), a.d(e, "faSyncAlt", function () {
    return Yv;
  }), a.d(e, "faSyringe", function () {
    return Pv;
  }), a.d(e, "faTable", function () {
    return Fv;
  }), a.d(e, "faTableTennis", function () {
    return Wv;
  }), a.d(e, "faTablet", function () {
    return Gv;
  }), a.d(e, "faTabletAlt", function () {
    return qv;
  }), a.d(e, "faTablets", function () {
    return Jv;
  }), a.d(e, "faTachometerAlt", function () {
    return Kv;
  }), a.d(e, "faTag", function () {
    return Xv;
  }), a.d(e, "faTags", function () {
    return _v;
  }), a.d(e, "faTape", function () {
    return $v;
  }), a.d(e, "faTasks", function () {
    return cd;
  }), a.d(e, "faTaxi", function () {
    return ed;
  }), a.d(e, "faTeeth", function () {
    return ad;
  }), a.d(e, "faTeethOpen", function () {
    return nd;
  }), a.d(e, "faTemperatureHigh", function () {
    return td;
  }), a.d(e, "faTemperatureLow", function () {
    return rd;
  }), a.d(e, "faTenge", function () {
    return id;
  }), a.d(e, "faTerminal", function () {
    return od;
  }), a.d(e, "faTextHeight", function () {
    return ld;
  }), a.d(e, "faTextWidth", function () {
    return fd;
  }), a.d(e, "faTh", function () {
    return sd;
  }), a.d(e, "faThLarge", function () {
    return ud;
  }), a.d(e, "faThList", function () {
    return hd;
  }), a.d(e, "faTheaterMasks", function () {
    return md;
  }), a.d(e, "faThermometer", function () {
    return vd;
  }), a.d(e, "faThermometerEmpty", function () {
    return dd;
  }), a.d(e, "faThermometerFull", function () {
    return Md;
  }), a.d(e, "faThermometerHalf", function () {
    return pd;
  }), a.d(e, "faThermometerQuarter", function () {
    return zd;
  }), a.d(e, "faThermometerThreeQuarters", function () {
    return Cd;
  }), a.d(e, "faThumbsDown", function () {
    return Ld;
  }), a.d(e, "faThumbsUp", function () {
    return Ad;
  }), a.d(e, "faThumbtack", function () {
    return Nd;
  }), a.d(e, "faTicketAlt", function () {
    return gd;
  }), a.d(e, "faTimes", function () {
    return Hd;
  }), a.d(e, "faTimesCircle", function () {
    return Vd;
  }), a.d(e, "faTint", function () {
    return xd;
  }), a.d(e, "faTintSlash", function () {
    return wd;
  }), a.d(e, "faTired", function () {
    return yd;
  }), a.d(e, "faToggleOff", function () {
    return bd;
  }), a.d(e, "faToggleOn", function () {
    return Sd;
  }), a.d(e, "faToilet", function () {
    return Td;
  }), a.d(e, "faToiletPaper", function () {
    return Dd;
  }), a.d(e, "faToiletPaperSlash", function () {
    return jd;
  }), a.d(e, "faToolbox", function () {
    return Ed;
  }), a.d(e, "faTools", function () {
    return kd;
  }), a.d(e, "faTooth", function () {
    return Id;
  }), a.d(e, "faTorah", function () {
    return Od;
  }), a.d(e, "faToriiGate", function () {
    return Qd;
  }), a.d(e, "faTractor", function () {
    return Zd;
  }), a.d(e, "faTrademark", function () {
    return Ud;
  }), a.d(e, "faTrafficLight", function () {
    return Bd;
  }), a.d(e, "faTrailer", function () {
    return Rd;
  }), a.d(e, "faTrain", function () {
    return Yd;
  }), a.d(e, "faTram", function () {
    return Pd;
  }), a.d(e, "faTransgender", function () {
    return Fd;
  }), a.d(e, "faTransgenderAlt", function () {
    return Wd;
  }), a.d(e, "faTrash", function () {
    return Gd;
  }), a.d(e, "faTrashAlt", function () {
    return qd;
  }), a.d(e, "faTrashRestore", function () {
    return Jd;
  }), a.d(e, "faTrashRestoreAlt", function () {
    return Kd;
  }), a.d(e, "faTree", function () {
    return Xd;
  }), a.d(e, "faTrophy", function () {
    return _d;
  }), a.d(e, "faTruck", function () {
    return $d;
  }), a.d(e, "faTruckLoading", function () {
    return cM;
  }), a.d(e, "faTruckMonster", function () {
    return eM;
  }), a.d(e, "faTruckMoving", function () {
    return aM;
  }), a.d(e, "faTruckPickup", function () {
    return nM;
  }), a.d(e, "faTshirt", function () {
    return tM;
  }), a.d(e, "faTty", function () {
    return rM;
  }), a.d(e, "faTv", function () {
    return iM;
  }), a.d(e, "faUmbrella", function () {
    return oM;
  }), a.d(e, "faUmbrellaBeach", function () {
    return lM;
  }), a.d(e, "faUnderline", function () {
    return fM;
  }), a.d(e, "faUndo", function () {
    return sM;
  }), a.d(e, "faUndoAlt", function () {
    return uM;
  }), a.d(e, "faUniversalAccess", function () {
    return hM;
  }), a.d(e, "faUniversity", function () {
    return mM;
  }), a.d(e, "faUnlink", function () {
    return vM;
  }), a.d(e, "faUnlock", function () {
    return dM;
  }), a.d(e, "faUnlockAlt", function () {
    return MM;
  }), a.d(e, "faUpload", function () {
    return pM;
  }), a.d(e, "faUser", function () {
    return zM;
  }), a.d(e, "faUserAlt", function () {
    return CM;
  }), a.d(e, "faUserAltSlash", function () {
    return LM;
  }), a.d(e, "faUserAstronaut", function () {
    return AM;
  }), a.d(e, "faUserCheck", function () {
    return NM;
  }), a.d(e, "faUserCircle", function () {
    return gM;
  }), a.d(e, "faUserClock", function () {
    return HM;
  }), a.d(e, "faUserCog", function () {
    return VM;
  }), a.d(e, "faUserEdit", function () {
    return xM;
  }), a.d(e, "faUserFriends", function () {
    return wM;
  }), a.d(e, "faUserGraduate", function () {
    return yM;
  }), a.d(e, "faUserInjured", function () {
    return bM;
  }), a.d(e, "faUserLock", function () {
    return SM;
  }), a.d(e, "faUserMd", function () {
    return TM;
  }), a.d(e, "faUserMinus", function () {
    return DM;
  }), a.d(e, "faUserNinja", function () {
    return jM;
  }), a.d(e, "faUserNurse", function () {
    return EM;
  }), a.d(e, "faUserPlus", function () {
    return kM;
  }), a.d(e, "faUserSecret", function () {
    return IM;
  }), a.d(e, "faUserShield", function () {
    return OM;
  }), a.d(e, "faUserSlash", function () {
    return QM;
  }), a.d(e, "faUserTag", function () {
    return ZM;
  }), a.d(e, "faUserTie", function () {
    return UM;
  }), a.d(e, "faUserTimes", function () {
    return BM;
  }), a.d(e, "faUsers", function () {
    return RM;
  }), a.d(e, "faUsersCog", function () {
    return YM;
  }), a.d(e, "faUsersSlash", function () {
    return PM;
  }), a.d(e, "faUtensilSpoon", function () {
    return FM;
  }), a.d(e, "faUtensils", function () {
    return WM;
  }), a.d(e, "faVectorSquare", function () {
    return GM;
  }), a.d(e, "faVenus", function () {
    return qM;
  }), a.d(e, "faVenusDouble", function () {
    return JM;
  }), a.d(e, "faVenusMars", function () {
    return KM;
  }), a.d(e, "faVest", function () {
    return XM;
  }), a.d(e, "faVestPatches", function () {
    return _M;
  }), a.d(e, "faVial", function () {
    return $M;
  }), a.d(e, "faVials", function () {
    return cp;
  }), a.d(e, "faVideo", function () {
    return ep;
  }), a.d(e, "faVideoSlash", function () {
    return ap;
  }), a.d(e, "faVihara", function () {
    return np;
  }), a.d(e, "faVirus", function () {
    return tp;
  }), a.d(e, "faVirusSlash", function () {
    return rp;
  }), a.d(e, "faViruses", function () {
    return ip;
  }), a.d(e, "faVoicemail", function () {
    return op;
  }), a.d(e, "faVolleyballBall", function () {
    return lp;
  }), a.d(e, "faVolumeDown", function () {
    return fp;
  }), a.d(e, "faVolumeMute", function () {
    return sp;
  }), a.d(e, "faVolumeOff", function () {
    return up;
  }), a.d(e, "faVolumeUp", function () {
    return hp;
  }), a.d(e, "faVoteYea", function () {
    return mp;
  }), a.d(e, "faVrCardboard", function () {
    return vp;
  }), a.d(e, "faWalking", function () {
    return dp;
  }), a.d(e, "faWallet", function () {
    return Mp;
  }), a.d(e, "faWarehouse", function () {
    return pp;
  }), a.d(e, "faWater", function () {
    return zp;
  }), a.d(e, "faWaveSquare", function () {
    return Cp;
  }), a.d(e, "faWeight", function () {
    return Lp;
  }), a.d(e, "faWeightHanging", function () {
    return Ap;
  }), a.d(e, "faWheelchair", function () {
    return Np;
  }), a.d(e, "faWifi", function () {
    return gp;
  }), a.d(e, "faWind", function () {
    return Hp;
  }), a.d(e, "faWindowClose", function () {
    return Vp;
  }), a.d(e, "faWindowMaximize", function () {
    return xp;
  }), a.d(e, "faWindowMinimize", function () {
    return wp;
  }), a.d(e, "faWindowRestore", function () {
    return yp;
  }), a.d(e, "faWineBottle", function () {
    return bp;
  }), a.d(e, "faWineGlass", function () {
    return Sp;
  }), a.d(e, "faWineGlassAlt", function () {
    return Tp;
  }), a.d(e, "faWonSign", function () {
    return Dp;
  }), a.d(e, "faWrench", function () {
    return jp;
  }), a.d(e, "faXRay", function () {
    return Ep;
  }), a.d(e, "faYenSign", function () {
    return kp;
  }), a.d(e, "faYinYang", function () {
    return Ip;
  });
  /*!
   * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
   * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
   */

  var n = "fas",
      t = {
    prefix: "fas",
    iconName: "ad",
    icon: [512, 512, [], "f641", "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"]
  },
      r = {
    prefix: "fas",
    iconName: "address-book",
    icon: [448, 512, [], "f2b9", "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"]
  },
      i = {
    prefix: "fas",
    iconName: "address-card",
    icon: [576, 512, [], "f2bb", "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"]
  },
      o = {
    prefix: "fas",
    iconName: "adjust",
    icon: [512, 512, [], "f042", "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"]
  },
      l = {
    prefix: "fas",
    iconName: "air-freshener",
    icon: [512, 512, [], "f5d0", "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"]
  },
      f = {
    prefix: "fas",
    iconName: "align-center",
    icon: [448, 512, [], "f037", "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"]
  },
      s = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      u = {
    prefix: "fas",
    iconName: "align-left",
    icon: [448, 512, [], "f036", "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      h = {
    prefix: "fas",
    iconName: "align-right",
    icon: [448, 512, [], "f038", "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"]
  },
      m = {
    prefix: "fas",
    iconName: "allergies",
    icon: [448, 512, [], "f461", "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      v = {
    prefix: "fas",
    iconName: "ambulance",
    icon: [640, 512, [], "f0f9", "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"]
  },
      d = {
    prefix: "fas",
    iconName: "american-sign-language-interpreting",
    icon: [640, 512, [], "f2a3", "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"]
  },
      M = {
    prefix: "fas",
    iconName: "anchor",
    icon: [576, 512, [], "f13d", "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"]
  },
      p = {
    prefix: "fas",
    iconName: "angle-double-down",
    icon: [320, 512, [], "f103", "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"]
  },
      z = {
    prefix: "fas",
    iconName: "angle-double-left",
    icon: [448, 512, [], "f100", "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"]
  },
      C = {
    prefix: "fas",
    iconName: "angle-double-right",
    icon: [448, 512, [], "f101", "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"]
  },
      L = {
    prefix: "fas",
    iconName: "angle-double-up",
    icon: [320, 512, [], "f102", "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"]
  },
      A = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [320, 512, [], "f107", "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"]
  },
      N = {
    prefix: "fas",
    iconName: "angle-left",
    icon: [256, 512, [], "f104", "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"]
  },
      g = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [256, 512, [], "f105", "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"]
  },
      H = {
    prefix: "fas",
    iconName: "angle-up",
    icon: [320, 512, [], "f106", "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"]
  },
      V = {
    prefix: "fas",
    iconName: "angry",
    icon: [496, 512, [], "f556", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"]
  },
      x = {
    prefix: "fas",
    iconName: "ankh",
    icon: [320, 512, [], "f644", "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"]
  },
      w = {
    prefix: "fas",
    iconName: "apple-alt",
    icon: [448, 512, [], "f5d1", "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"]
  },
      y = {
    prefix: "fas",
    iconName: "archive",
    icon: [512, 512, [], "f187", "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"]
  },
      b = {
    prefix: "fas",
    iconName: "archway",
    icon: [576, 512, [], "f557", "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"]
  },
      S = {
    prefix: "fas",
    iconName: "arrow-alt-circle-down",
    icon: [512, 512, [], "f358", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"]
  },
      T = {
    prefix: "fas",
    iconName: "arrow-alt-circle-left",
    icon: [512, 512, [], "f359", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"]
  },
      D = {
    prefix: "fas",
    iconName: "arrow-alt-circle-right",
    icon: [512, 512, [], "f35a", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"]
  },
      j = {
    prefix: "fas",
    iconName: "arrow-alt-circle-up",
    icon: [512, 512, [], "f35b", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"]
  },
      E = {
    prefix: "fas",
    iconName: "arrow-circle-down",
    icon: [512, 512, [], "f0ab", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"]
  },
      k = {
    prefix: "fas",
    iconName: "arrow-circle-left",
    icon: [512, 512, [], "f0a8", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"]
  },
      I = {
    prefix: "fas",
    iconName: "arrow-circle-right",
    icon: [512, 512, [], "f0a9", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"]
  },
      O = {
    prefix: "fas",
    iconName: "arrow-circle-up",
    icon: [512, 512, [], "f0aa", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"]
  },
      Q = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [448, 512, [], "f063", "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"]
  },
      Z = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [448, 512, [], "f060", "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"]
  },
      U = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [448, 512, [], "f061", "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"]
  },
      B = {
    prefix: "fas",
    iconName: "arrow-up",
    icon: [448, 512, [], "f062", "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"]
  },
      R = {
    prefix: "fas",
    iconName: "arrows-alt",
    icon: [512, 512, [], "f0b2", "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"]
  },
      Y = {
    prefix: "fas",
    iconName: "arrows-alt-h",
    icon: [512, 512, [], "f337", "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"]
  },
      P = {
    prefix: "fas",
    iconName: "arrows-alt-v",
    icon: [256, 512, [], "f338", "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"]
  },
      F = {
    prefix: "fas",
    iconName: "assistive-listening-systems",
    icon: [512, 512, [], "f2a2", "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"]
  },
      W = {
    prefix: "fas",
    iconName: "asterisk",
    icon: [512, 512, [], "f069", "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"]
  },
      G = {
    prefix: "fas",
    iconName: "at",
    icon: [512, 512, [], "f1fa", "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"]
  },
      q = {
    prefix: "fas",
    iconName: "atlas",
    icon: [448, 512, [], "f558", "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"]
  },
      J = {
    prefix: "fas",
    iconName: "atom",
    icon: [448, 512, [], "f5d2", "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"]
  },
      K = {
    prefix: "fas",
    iconName: "audio-description",
    icon: [512, 512, [], "f29e", "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"]
  },
      X = {
    prefix: "fas",
    iconName: "award",
    icon: [384, 512, [], "f559", "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"]
  },
      _ = {
    prefix: "fas",
    iconName: "baby",
    icon: [384, 512, [], "f77c", "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"]
  },
      $ = {
    prefix: "fas",
    iconName: "baby-carriage",
    icon: [512, 512, [], "f77d", "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"]
  },
      cc = {
    prefix: "fas",
    iconName: "backspace",
    icon: [640, 512, [], "f55a", "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"]
  },
      ec = {
    prefix: "fas",
    iconName: "backward",
    icon: [512, 512, [], "f04a", "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"]
  },
      ac = {
    prefix: "fas",
    iconName: "bacon",
    icon: [576, 512, [], "f7e5", "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"]
  },
      nc = {
    prefix: "fas",
    iconName: "bacteria",
    icon: [640, 512, [], "e059", "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"]
  },
      tc = {
    prefix: "fas",
    iconName: "bacterium",
    icon: [512, 512, [], "e05a", "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"]
  },
      rc = {
    prefix: "fas",
    iconName: "bahai",
    icon: [512, 512, [], "f666", "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"]
  },
      ic = {
    prefix: "fas",
    iconName: "balance-scale",
    icon: [640, 512, [], "f24e", "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      oc = {
    prefix: "fas",
    iconName: "balance-scale-left",
    icon: [640, 512, [], "f515", "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"]
  },
      lc = {
    prefix: "fas",
    iconName: "balance-scale-right",
    icon: [640, 512, [], "f516", "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"]
  },
      fc = {
    prefix: "fas",
    iconName: "ban",
    icon: [512, 512, [], "f05e", "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"]
  },
      sc = {
    prefix: "fas",
    iconName: "band-aid",
    icon: [640, 512, [], "f462", "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"]
  },
      uc = {
    prefix: "fas",
    iconName: "barcode",
    icon: [512, 512, [], "f02a", "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"]
  },
      hc = {
    prefix: "fas",
    iconName: "bars",
    icon: [448, 512, [], "f0c9", "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"]
  },
      mc = {
    prefix: "fas",
    iconName: "baseball-ball",
    icon: [496, 512, [], "f433", "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"]
  },
      vc = {
    prefix: "fas",
    iconName: "basketball-ball",
    icon: [496, 512, [], "f434", "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"]
  },
      dc = {
    prefix: "fas",
    iconName: "bath",
    icon: [512, 512, [], "f2cd", "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"]
  },
      Mc = {
    prefix: "fas",
    iconName: "battery-empty",
    icon: [640, 512, [], "f244", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"]
  },
      pc = {
    prefix: "fas",
    iconName: "battery-full",
    icon: [640, 512, [], "f240", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"]
  },
      zc = {
    prefix: "fas",
    iconName: "battery-half",
    icon: [640, 512, [], "f242", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"]
  },
      Cc = {
    prefix: "fas",
    iconName: "battery-quarter",
    icon: [640, 512, [], "f243", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"]
  },
      Lc = {
    prefix: "fas",
    iconName: "battery-three-quarters",
    icon: [640, 512, [], "f241", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"]
  },
      Ac = {
    prefix: "fas",
    iconName: "bed",
    icon: [640, 512, [], "f236", "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"]
  },
      Nc = {
    prefix: "fas",
    iconName: "beer",
    icon: [448, 512, [], "f0fc", "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"]
  },
      gc = {
    prefix: "fas",
    iconName: "bell",
    icon: [448, 512, [], "f0f3", "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"]
  },
      Hc = {
    prefix: "fas",
    iconName: "bell-slash",
    icon: [640, 512, [], "f1f6", "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"]
  },
      Vc = {
    prefix: "fas",
    iconName: "bezier-curve",
    icon: [640, 512, [], "f55b", "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"]
  },
      xc = {
    prefix: "fas",
    iconName: "bible",
    icon: [448, 512, [], "f647", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"]
  },
      wc = {
    prefix: "fas",
    iconName: "bicycle",
    icon: [640, 512, [], "f206", "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"]
  },
      yc = {
    prefix: "fas",
    iconName: "biking",
    icon: [640, 512, [], "f84a", "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"]
  },
      bc = {
    prefix: "fas",
    iconName: "binoculars",
    icon: [512, 512, [], "f1e5", "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"]
  },
      Sc = {
    prefix: "fas",
    iconName: "biohazard",
    icon: [576, 512, [], "f780", "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      Tc = {
    prefix: "fas",
    iconName: "birthday-cake",
    icon: [448, 512, [], "f1fd", "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"]
  },
      Dc = {
    prefix: "fas",
    iconName: "blender",
    icon: [512, 512, [], "f517", "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"]
  },
      jc = {
    prefix: "fas",
    iconName: "blender-phone",
    icon: [576, 512, [], "f6b6", "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Ec = {
    prefix: "fas",
    iconName: "blind",
    icon: [384, 512, [], "f29d", "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"]
  },
      kc = {
    prefix: "fas",
    iconName: "blog",
    icon: [512, 512, [], "f781", "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"]
  },
      Ic = {
    prefix: "fas",
    iconName: "bold",
    icon: [384, 512, [], "f032", "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"]
  },
      Oc = {
    prefix: "fas",
    iconName: "bolt",
    icon: [320, 512, [], "f0e7", "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"]
  },
      Qc = {
    prefix: "fas",
    iconName: "bomb",
    icon: [512, 512, [], "f1e2", "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"]
  },
      Zc = {
    prefix: "fas",
    iconName: "bone",
    icon: [640, 512, [], "f5d7", "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"]
  },
      Uc = {
    prefix: "fas",
    iconName: "bong",
    icon: [448, 512, [], "f55c", "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"]
  },
      Bc = {
    prefix: "fas",
    iconName: "book",
    icon: [448, 512, [], "f02d", "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"]
  },
      Rc = {
    prefix: "fas",
    iconName: "book-dead",
    icon: [448, 512, [], "f6b7", "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"]
  },
      Yc = {
    prefix: "fas",
    iconName: "book-medical",
    icon: [448, 512, [], "f7e6", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"]
  },
      Pc = {
    prefix: "fas",
    iconName: "book-open",
    icon: [576, 512, [], "f518", "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"]
  },
      Fc = {
    prefix: "fas",
    iconName: "book-reader",
    icon: [512, 512, [], "f5da", "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"]
  },
      Wc = {
    prefix: "fas",
    iconName: "bookmark",
    icon: [384, 512, [], "f02e", "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"]
  },
      Gc = {
    prefix: "fas",
    iconName: "border-all",
    icon: [448, 512, [], "f84c", "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"]
  },
      qc = {
    prefix: "fas",
    iconName: "border-none",
    icon: [448, 512, [], "f850", "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Jc = {
    prefix: "fas",
    iconName: "border-style",
    icon: [448, 512, [], "f853", "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Kc = {
    prefix: "fas",
    iconName: "bowling-ball",
    icon: [496, 512, [], "f436", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Xc = {
    prefix: "fas",
    iconName: "box",
    icon: [512, 512, [], "f466", "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"]
  },
      _c = {
    prefix: "fas",
    iconName: "box-open",
    icon: [640, 512, [], "f49e", "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"]
  },
      $c = {
    prefix: "fas",
    iconName: "box-tissue",
    icon: [512, 512, [], "e05b", "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"]
  },
      ce = {
    prefix: "fas",
    iconName: "boxes",
    icon: [576, 512, [], "f468", "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
  },
      ee = {
    prefix: "fas",
    iconName: "braille",
    icon: [640, 512, [], "f2a1", "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"]
  },
      ae = {
    prefix: "fas",
    iconName: "brain",
    icon: [576, 512, [], "f5dc", "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"]
  },
      ne = {
    prefix: "fas",
    iconName: "bread-slice",
    icon: [576, 512, [], "f7ec", "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"]
  },
      te = {
    prefix: "fas",
    iconName: "briefcase",
    icon: [512, 512, [], "f0b1", "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"]
  },
      re = {
    prefix: "fas",
    iconName: "briefcase-medical",
    icon: [512, 512, [], "f469", "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"]
  },
      ie = {
    prefix: "fas",
    iconName: "broadcast-tower",
    icon: [640, 512, [], "f519", "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"]
  },
      oe = {
    prefix: "fas",
    iconName: "broom",
    icon: [640, 512, [], "f51a", "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"]
  },
      le = {
    prefix: "fas",
    iconName: "brush",
    icon: [384, 512, [], "f55d", "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"]
  },
      fe = {
    prefix: "fas",
    iconName: "bug",
    icon: [512, 512, [], "f188", "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"]
  },
      se = {
    prefix: "fas",
    iconName: "building",
    icon: [448, 512, [], "f1ad", "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"]
  },
      ue = {
    prefix: "fas",
    iconName: "bullhorn",
    icon: [576, 512, [], "f0a1", "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"]
  },
      he = {
    prefix: "fas",
    iconName: "bullseye",
    icon: [496, 512, [], "f140", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"]
  },
      me = {
    prefix: "fas",
    iconName: "burn",
    icon: [384, 512, [], "f46a", "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"]
  },
      ve = {
    prefix: "fas",
    iconName: "bus",
    icon: [512, 512, [], "f207", "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      de = {
    prefix: "fas",
    iconName: "bus-alt",
    icon: [512, 512, [], "f55e", "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Me = {
    prefix: "fas",
    iconName: "business-time",
    icon: [640, 512, [], "f64a", "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"]
  },
      pe = {
    prefix: "fas",
    iconName: "calculator",
    icon: [448, 512, [], "f1ec", "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"]
  },
      ze = {
    prefix: "fas",
    iconName: "calendar",
    icon: [448, 512, [], "f133", "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"]
  },
      Ce = {
    prefix: "fas",
    iconName: "calendar-alt",
    icon: [448, 512, [], "f073", "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"]
  },
      Le = {
    prefix: "fas",
    iconName: "calendar-check",
    icon: [448, 512, [], "f274", "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"]
  },
      Ae = {
    prefix: "fas",
    iconName: "calendar-day",
    icon: [448, 512, [], "f783", "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"]
  },
      Ne = {
    prefix: "fas",
    iconName: "calendar-minus",
    icon: [448, 512, [], "f272", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"]
  },
      ge = {
    prefix: "fas",
    iconName: "calendar-plus",
    icon: [448, 512, [], "f271", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"]
  },
      He = {
    prefix: "fas",
    iconName: "calendar-times",
    icon: [448, 512, [], "f273", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"]
  },
      Ve = {
    prefix: "fas",
    iconName: "calendar-week",
    icon: [448, 512, [], "f784", "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"]
  },
      xe = {
    prefix: "fas",
    iconName: "camera",
    icon: [512, 512, [], "f030", "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"]
  },
      we = {
    prefix: "fas",
    iconName: "camera-retro",
    icon: [512, 512, [], "f083", "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"]
  },
      ye = {
    prefix: "fas",
    iconName: "campground",
    icon: [640, 512, [], "f6bb", "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"]
  },
      be = {
    prefix: "fas",
    iconName: "candy-cane",
    icon: [512, 512, [], "f786", "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"]
  },
      Se = {
    prefix: "fas",
    iconName: "cannabis",
    icon: [512, 512, [], "f55f", "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"]
  },
      Te = {
    prefix: "fas",
    iconName: "capsules",
    icon: [576, 512, [], "f46b", "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"]
  },
      De = {
    prefix: "fas",
    iconName: "car",
    icon: [512, 512, [], "f1b9", "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"]
  },
      je = {
    prefix: "fas",
    iconName: "car-alt",
    icon: [480, 512, [], "f5de", "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"]
  },
      Ee = {
    prefix: "fas",
    iconName: "car-battery",
    icon: [512, 512, [], "f5df", "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"]
  },
      ke = {
    prefix: "fas",
    iconName: "car-crash",
    icon: [640, 512, [], "f5e1", "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"]
  },
      Ie = {
    prefix: "fas",
    iconName: "car-side",
    icon: [640, 512, [], "f5e4", "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"]
  },
      Oe = {
    prefix: "fas",
    iconName: "caravan",
    icon: [640, 512, [], "f8ff", "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"]
  },
      Qe = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [320, 512, [], "f0d7", "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"]
  },
      Ze = {
    prefix: "fas",
    iconName: "caret-left",
    icon: [192, 512, [], "f0d9", "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"]
  },
      Ue = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [192, 512, [], "f0da", "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"]
  },
      Be = {
    prefix: "fas",
    iconName: "caret-square-down",
    icon: [448, 512, [], "f150", "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"]
  },
      Re = {
    prefix: "fas",
    iconName: "caret-square-left",
    icon: [448, 512, [], "f191", "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"]
  },
      Ye = {
    prefix: "fas",
    iconName: "caret-square-right",
    icon: [448, 512, [], "f152", "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"]
  },
      Pe = {
    prefix: "fas",
    iconName: "caret-square-up",
    icon: [448, 512, [], "f151", "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"]
  },
      Fe = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [320, 512, [], "f0d8", "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"]
  },
      We = {
    prefix: "fas",
    iconName: "carrot",
    icon: [512, 512, [], "f787", "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"]
  },
      Ge = {
    prefix: "fas",
    iconName: "cart-arrow-down",
    icon: [576, 512, [], "f218", "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"]
  },
      qe = {
    prefix: "fas",
    iconName: "cart-plus",
    icon: [576, 512, [], "f217", "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"]
  },
      Je = {
    prefix: "fas",
    iconName: "cash-register",
    icon: [512, 512, [], "f788", "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"]
  },
      Ke = {
    prefix: "fas",
    iconName: "cat",
    icon: [512, 512, [], "f6be", "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      Xe = {
    prefix: "fas",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"]
  },
      _e = {
    prefix: "fas",
    iconName: "chair",
    icon: [448, 512, [], "f6c0", "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"]
  },
      $e = {
    prefix: "fas",
    iconName: "chalkboard",
    icon: [640, 512, [], "f51b", "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      ca = {
    prefix: "fas",
    iconName: "chalkboard-teacher",
    icon: [640, 512, [], "f51c", "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"]
  },
      ea = {
    prefix: "fas",
    iconName: "charging-station",
    icon: [576, 512, [], "f5e7", "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"]
  },
      aa = {
    prefix: "fas",
    iconName: "chart-area",
    icon: [512, 512, [], "f1fe", "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"]
  },
      na = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [512, 512, [], "f080", "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      ta = {
    prefix: "fas",
    iconName: "chart-line",
    icon: [512, 512, [], "f201", "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"]
  },
      ra = {
    prefix: "fas",
    iconName: "chart-pie",
    icon: [544, 512, [], "f200", "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"]
  },
      ia = {
    prefix: "fas",
    iconName: "check",
    icon: [512, 512, [], "f00c", "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"]
  },
      oa = {
    prefix: "fas",
    iconName: "check-circle",
    icon: [512, 512, [], "f058", "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"]
  },
      la = {
    prefix: "fas",
    iconName: "check-double",
    icon: [512, 512, [], "f560", "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"]
  },
      fa = {
    prefix: "fas",
    iconName: "check-square",
    icon: [448, 512, [], "f14a", "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"]
  },
      sa = {
    prefix: "fas",
    iconName: "cheese",
    icon: [512, 512, [], "f7ef", "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"]
  },
      ua = {
    prefix: "fas",
    iconName: "chess",
    icon: [512, 512, [], "f439", "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"]
  },
      ha = {
    prefix: "fas",
    iconName: "chess-bishop",
    icon: [320, 512, [], "f43a", "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      ma = {
    prefix: "fas",
    iconName: "chess-board",
    icon: [512, 512, [], "f43c", "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"]
  },
      va = {
    prefix: "fas",
    iconName: "chess-king",
    icon: [448, 512, [], "f43f", "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"]
  },
      da = {
    prefix: "fas",
    iconName: "chess-knight",
    icon: [384, 512, [], "f441", "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      Ma = {
    prefix: "fas",
    iconName: "chess-pawn",
    icon: [320, 512, [], "f443", "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      pa = {
    prefix: "fas",
    iconName: "chess-queen",
    icon: [512, 512, [], "f445", "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"]
  },
      za = {
    prefix: "fas",
    iconName: "chess-rook",
    icon: [384, 512, [], "f447", "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      Ca = {
    prefix: "fas",
    iconName: "chevron-circle-down",
    icon: [512, 512, [], "f13a", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"]
  },
      La = {
    prefix: "fas",
    iconName: "chevron-circle-left",
    icon: [512, 512, [], "f137", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"]
  },
      Aa = {
    prefix: "fas",
    iconName: "chevron-circle-right",
    icon: [512, 512, [], "f138", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"]
  },
      Na = {
    prefix: "fas",
    iconName: "chevron-circle-up",
    icon: [512, 512, [], "f139", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"]
  },
      ga = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [448, 512, [], "f078", "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"]
  },
      Ha = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [320, 512, [], "f053", "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"]
  },
      Va = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [320, 512, [], "f054", "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"]
  },
      xa = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [448, 512, [], "f077", "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"]
  },
      wa = {
    prefix: "fas",
    iconName: "child",
    icon: [384, 512, [], "f1ae", "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"]
  },
      ya = {
    prefix: "fas",
    iconName: "church",
    icon: [640, 512, [], "f51d", "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"]
  },
      ba = {
    prefix: "fas",
    iconName: "circle",
    icon: [512, 512, [], "f111", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"]
  },
      Sa = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [512, 512, [], "f1ce", "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"]
  },
      Ta = {
    prefix: "fas",
    iconName: "city",
    icon: [640, 512, [], "f64f", "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"]
  },
      Da = {
    prefix: "fas",
    iconName: "clinic-medical",
    icon: [576, 512, [], "f7f2", "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"]
  },
      ja = {
    prefix: "fas",
    iconName: "clipboard",
    icon: [384, 512, [], "f328", "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"]
  },
      Ea = {
    prefix: "fas",
    iconName: "clipboard-check",
    icon: [384, 512, [], "f46c", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"]
  },
      ka = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"]
  },
      Ia = {
    prefix: "fas",
    iconName: "clock",
    icon: [512, 512, [], "f017", "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"]
  },
      Oa = {
    prefix: "fas",
    iconName: "clone",
    icon: [512, 512, [], "f24d", "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"]
  },
      Qa = {
    prefix: "fas",
    iconName: "closed-captioning",
    icon: [512, 512, [], "f20a", "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"]
  },
      Za = {
    prefix: "fas",
    iconName: "cloud",
    icon: [640, 512, [], "f0c2", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"]
  },
      Ua = {
    prefix: "fas",
    iconName: "cloud-download-alt",
    icon: [640, 512, [], "f381", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"]
  },
      Ba = {
    prefix: "fas",
    iconName: "cloud-meatball",
    icon: [512, 512, [], "f73b", "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"]
  },
      Ra = {
    prefix: "fas",
    iconName: "cloud-moon",
    icon: [576, 512, [], "f6c3", "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"]
  },
      Ya = {
    prefix: "fas",
    iconName: "cloud-moon-rain",
    icon: [576, 512, [], "f73c", "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"]
  },
      Pa = {
    prefix: "fas",
    iconName: "cloud-rain",
    icon: [512, 512, [], "f73d", "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"]
  },
      Fa = {
    prefix: "fas",
    iconName: "cloud-showers-heavy",
    icon: [512, 512, [], "f740", "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"]
  },
      Wa = {
    prefix: "fas",
    iconName: "cloud-sun",
    icon: [640, 512, [], "f6c4", "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"]
  },
      Ga = {
    prefix: "fas",
    iconName: "cloud-sun-rain",
    icon: [576, 512, [], "f743", "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"]
  },
      qa = {
    prefix: "fas",
    iconName: "cloud-upload-alt",
    icon: [640, 512, [], "f382", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"]
  },
      Ja = {
    prefix: "fas",
    iconName: "cocktail",
    icon: [576, 512, [], "f561", "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"]
  },
      Ka = {
    prefix: "fas",
    iconName: "code",
    icon: [640, 512, [], "f121", "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"]
  },
      Xa = {
    prefix: "fas",
    iconName: "code-branch",
    icon: [384, 512, [], "f126", "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"]
  },
      _a = {
    prefix: "fas",
    iconName: "coffee",
    icon: [640, 512, [], "f0f4", "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"]
  },
      $a = {
    prefix: "fas",
    iconName: "cog",
    icon: [512, 512, [], "f013", "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      cn = {
    prefix: "fas",
    iconName: "cogs",
    icon: [640, 512, [], "f085", "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"]
  },
      en = {
    prefix: "fas",
    iconName: "coins",
    icon: [512, 512, [], "f51e", "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"]
  },
      an = {
    prefix: "fas",
    iconName: "columns",
    icon: [512, 512, [], "f0db", "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"]
  },
      nn = {
    prefix: "fas",
    iconName: "comment",
    icon: [512, 512, [], "f075", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"]
  },
      tn = {
    prefix: "fas",
    iconName: "comment-alt",
    icon: [512, 512, [], "f27a", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"]
  },
      rn = {
    prefix: "fas",
    iconName: "comment-dollar",
    icon: [512, 512, [], "f651", "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"]
  },
      on = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [512, 512, [], "f4ad", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      ln = {
    prefix: "fas",
    iconName: "comment-medical",
    icon: [512, 512, [], "f7f5", "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"]
  },
      fn = {
    prefix: "fas",
    iconName: "comment-slash",
    icon: [640, 512, [], "f4b3", "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"]
  },
      sn = {
    prefix: "fas",
    iconName: "comments",
    icon: [576, 512, [], "f086", "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"]
  },
      un = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [576, 512, [], "f653", "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"]
  },
      hn = {
    prefix: "fas",
    iconName: "compact-disc",
    icon: [496, 512, [], "f51f", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      mn = {
    prefix: "fas",
    iconName: "compass",
    icon: [496, 512, [], "f14e", "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"]
  },
      vn = {
    prefix: "fas",
    iconName: "compress",
    icon: [448, 512, [], "f066", "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"]
  },
      dn = {
    prefix: "fas",
    iconName: "compress-alt",
    icon: [448, 512, [], "f422", "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"]
  },
      Mn = {
    prefix: "fas",
    iconName: "compress-arrows-alt",
    icon: [512, 512, [], "f78c", "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"]
  },
      pn = {
    prefix: "fas",
    iconName: "concierge-bell",
    icon: [512, 512, [], "f562", "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      zn = {
    prefix: "fas",
    iconName: "cookie",
    icon: [512, 512, [], "f563", "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Cn = {
    prefix: "fas",
    iconName: "cookie-bite",
    icon: [512, 512, [], "f564", "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Ln = {
    prefix: "fas",
    iconName: "copy",
    icon: [448, 512, [], "f0c5", "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"]
  },
      An = {
    prefix: "fas",
    iconName: "copyright",
    icon: [512, 512, [], "f1f9", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"]
  },
      Nn = {
    prefix: "fas",
    iconName: "couch",
    icon: [640, 512, [], "f4b8", "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"]
  },
      gn = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [576, 512, [], "f09d", "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"]
  },
      Hn = {
    prefix: "fas",
    iconName: "crop",
    icon: [512, 512, [], "f125", "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"]
  },
      Vn = {
    prefix: "fas",
    iconName: "crop-alt",
    icon: [512, 512, [], "f565", "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"]
  },
      xn = {
    prefix: "fas",
    iconName: "cross",
    icon: [384, 512, [], "f654", "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
  },
      wn = {
    prefix: "fas",
    iconName: "crosshairs",
    icon: [512, 512, [], "f05b", "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"]
  },
      yn = {
    prefix: "fas",
    iconName: "crow",
    icon: [640, 512, [], "f520", "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
  },
      bn = {
    prefix: "fas",
    iconName: "crown",
    icon: [640, 512, [], "f521", "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"]
  },
      Sn = {
    prefix: "fas",
    iconName: "crutch",
    icon: [512, 512, [], "f7f7", "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"]
  },
      Tn = {
    prefix: "fas",
    iconName: "cube",
    icon: [512, 512, [], "f1b2", "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"]
  },
      Dn = {
    prefix: "fas",
    iconName: "cubes",
    icon: [512, 512, [], "f1b3", "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"]
  },
      jn = {
    prefix: "fas",
    iconName: "cut",
    icon: [448, 512, [], "f0c4", "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"]
  },
      En = {
    prefix: "fas",
    iconName: "database",
    icon: [448, 512, [], "f1c0", "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"]
  },
      kn = {
    prefix: "fas",
    iconName: "deaf",
    icon: [512, 512, [], "f2a4", "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"]
  },
      In = {
    prefix: "fas",
    iconName: "democrat",
    icon: [640, 512, [], "f747", "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"]
  },
      On = {
    prefix: "fas",
    iconName: "desktop",
    icon: [576, 512, [], "f108", "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"]
  },
      Qn = {
    prefix: "fas",
    iconName: "dharmachakra",
    icon: [512, 512, [], "f655", "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"]
  },
      Zn = {
    prefix: "fas",
    iconName: "diagnoses",
    icon: [640, 512, [], "f470", "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
  },
      Un = {
    prefix: "fas",
    iconName: "dice",
    icon: [640, 512, [], "f522", "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
  },
      Bn = {
    prefix: "fas",
    iconName: "dice-d20",
    icon: [480, 512, [], "f6cf", "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"]
  },
      Rn = {
    prefix: "fas",
    iconName: "dice-d6",
    icon: [448, 512, [], "f6d1", "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"]
  },
      Yn = {
    prefix: "fas",
    iconName: "dice-five",
    icon: [448, 512, [], "f523", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Pn = {
    prefix: "fas",
    iconName: "dice-four",
    icon: [448, 512, [], "f524", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Fn = {
    prefix: "fas",
    iconName: "dice-one",
    icon: [448, 512, [], "f525", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Wn = {
    prefix: "fas",
    iconName: "dice-six",
    icon: [448, 512, [], "f526", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Gn = {
    prefix: "fas",
    iconName: "dice-three",
    icon: [448, 512, [], "f527", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      qn = {
    prefix: "fas",
    iconName: "dice-two",
    icon: [448, 512, [], "f528", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Jn = {
    prefix: "fas",
    iconName: "digital-tachograph",
    icon: [640, 512, [], "f566", "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"]
  },
      Kn = {
    prefix: "fas",
    iconName: "directions",
    icon: [512, 512, [], "f5eb", "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"]
  },
      Xn = {
    prefix: "fas",
    iconName: "disease",
    icon: [512, 512, [], "f7fa", "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"]
  },
      _n = {
    prefix: "fas",
    iconName: "divide",
    icon: [448, 512, [], "f529", "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
  },
      $n = {
    prefix: "fas",
    iconName: "dizzy",
    icon: [496, 512, [], "f567", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"]
  },
      ct = {
    prefix: "fas",
    iconName: "dna",
    icon: [448, 512, [], "f471", "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"]
  },
      et = {
    prefix: "fas",
    iconName: "dog",
    icon: [576, 512, [], "f6d3", "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"]
  },
      at = {
    prefix: "fas",
    iconName: "dollar-sign",
    icon: [288, 512, [], "f155", "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"]
  },
      nt = {
    prefix: "fas",
    iconName: "dolly",
    icon: [576, 512, [], "f472", "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      tt = {
    prefix: "fas",
    iconName: "dolly-flatbed",
    icon: [640, 512, [], "f474", "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
  },
      rt = {
    prefix: "fas",
    iconName: "donate",
    icon: [512, 512, [], "f4b9", "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"]
  },
      it = {
    prefix: "fas",
    iconName: "door-closed",
    icon: [640, 512, [], "f52a", "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"]
  },
      ot = {
    prefix: "fas",
    iconName: "door-open",
    icon: [640, 512, [], "f52b", "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"]
  },
      lt = {
    prefix: "fas",
    iconName: "dot-circle",
    icon: [512, 512, [], "f192", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"]
  },
      ft = {
    prefix: "fas",
    iconName: "dove",
    icon: [512, 512, [], "f4ba", "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      st = {
    prefix: "fas",
    iconName: "download",
    icon: [512, 512, [], "f019", "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"]
  },
      ut = {
    prefix: "fas",
    iconName: "drafting-compass",
    icon: [512, 512, [], "f568", "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"]
  },
      ht = {
    prefix: "fas",
    iconName: "dragon",
    icon: [640, 512, [], "f6d5", "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"]
  },
      mt = {
    prefix: "fas",
    iconName: "draw-polygon",
    icon: [448, 512, [], "f5ee", "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"]
  },
      vt = {
    prefix: "fas",
    iconName: "drum",
    icon: [512, 512, [], "f569", "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"]
  },
      dt = {
    prefix: "fas",
    iconName: "drum-steelpan",
    icon: [576, 512, [], "f56a", "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"]
  },
      Mt = {
    prefix: "fas",
    iconName: "drumstick-bite",
    icon: [512, 512, [], "f6d7", "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"]
  },
      pt = {
    prefix: "fas",
    iconName: "dumbbell",
    icon: [640, 512, [], "f44b", "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"]
  },
      zt = {
    prefix: "fas",
    iconName: "dumpster",
    icon: [576, 512, [], "f793", "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
  },
      Ct = {
    prefix: "fas",
    iconName: "dumpster-fire",
    icon: [640, 512, [], "f794", "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"]
  },
      Lt = {
    prefix: "fas",
    iconName: "dungeon",
    icon: [512, 512, [], "f6d9", "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"]
  },
      At = {
    prefix: "fas",
    iconName: "edit",
    icon: [576, 512, [], "f044", "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"]
  },
      Nt = {
    prefix: "fas",
    iconName: "egg",
    icon: [384, 512, [], "f7fb", "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"]
  },
      gt = {
    prefix: "fas",
    iconName: "eject",
    icon: [448, 512, [], "f052", "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"]
  },
      Ht = {
    prefix: "fas",
    iconName: "ellipsis-h",
    icon: [512, 512, [], "f141", "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"]
  },
      Vt = {
    prefix: "fas",
    iconName: "ellipsis-v",
    icon: [192, 512, [], "f142", "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"]
  },
      xt = {
    prefix: "fas",
    iconName: "envelope",
    icon: [512, 512, [], "f0e0", "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"]
  },
      wt = {
    prefix: "fas",
    iconName: "envelope-open",
    icon: [512, 512, [], "f2b6", "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"]
  },
      yt = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"]
  },
      bt = {
    prefix: "fas",
    iconName: "envelope-square",
    icon: [448, 512, [], "f199", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"]
  },
      St = {
    prefix: "fas",
    iconName: "equals",
    icon: [448, 512, [], "f52c", "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
  },
      Tt = {
    prefix: "fas",
    iconName: "eraser",
    icon: [512, 512, [], "f12d", "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"]
  },
      Dt = {
    prefix: "fas",
    iconName: "ethernet",
    icon: [512, 512, [], "f796", "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"]
  },
      jt = {
    prefix: "fas",
    iconName: "euro-sign",
    icon: [320, 512, [], "f153", "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"]
  },
      Et = {
    prefix: "fas",
    iconName: "exchange-alt",
    icon: [512, 512, [], "f362", "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"]
  },
      kt = {
    prefix: "fas",
    iconName: "exclamation",
    icon: [192, 512, [], "f12a", "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"]
  },
      It = {
    prefix: "fas",
    iconName: "exclamation-circle",
    icon: [512, 512, [], "f06a", "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"]
  },
      Ot = {
    prefix: "fas",
    iconName: "exclamation-triangle",
    icon: [576, 512, [], "f071", "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"]
  },
      Qt = {
    prefix: "fas",
    iconName: "expand",
    icon: [448, 512, [], "f065", "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"]
  },
      Zt = {
    prefix: "fas",
    iconName: "expand-alt",
    icon: [448, 512, [], "f424", "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"]
  },
      Ut = {
    prefix: "fas",
    iconName: "expand-arrows-alt",
    icon: [448, 512, [], "f31e", "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"]
  },
      Bt = {
    prefix: "fas",
    iconName: "external-link-alt",
    icon: [512, 512, [], "f35d", "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"]
  },
      Rt = {
    prefix: "fas",
    iconName: "external-link-square-alt",
    icon: [448, 512, [], "f360", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"]
  },
      Yt = {
    prefix: "fas",
    iconName: "eye",
    icon: [576, 512, [], "f06e", "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"]
  },
      Pt = {
    prefix: "fas",
    iconName: "eye-dropper",
    icon: [512, 512, [], "f1fb", "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"]
  },
      Ft = {
    prefix: "fas",
    iconName: "eye-slash",
    icon: [640, 512, [], "f070", "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"]
  },
      Wt = {
    prefix: "fas",
    iconName: "fan",
    icon: [512, 512, [], "f863", "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"]
  },
      Gt = {
    prefix: "fas",
    iconName: "fast-backward",
    icon: [512, 512, [], "f049", "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"]
  },
      qt = {
    prefix: "fas",
    iconName: "fast-forward",
    icon: [512, 512, [], "f050", "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"]
  },
      Jt = {
    prefix: "fas",
    iconName: "faucet",
    icon: [512, 512, [], "e005", "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"]
  },
      Kt = {
    prefix: "fas",
    iconName: "fax",
    icon: [512, 512, [], "f1ac", "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"]
  },
      Xt = {
    prefix: "fas",
    iconName: "feather",
    icon: [512, 512, [], "f52d", "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"]
  },
      _t = {
    prefix: "fas",
    iconName: "feather-alt",
    icon: [512, 512, [], "f56b", "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"]
  },
      $t = {
    prefix: "fas",
    iconName: "female",
    icon: [256, 512, [], "f182", "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"]
  },
      cr = {
    prefix: "fas",
    iconName: "fighter-jet",
    icon: [640, 512, [], "f0fb", "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"]
  },
      er = {
    prefix: "fas",
    iconName: "file",
    icon: [384, 512, [], "f15b", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
  },
      ar = {
    prefix: "fas",
    iconName: "file-alt",
    icon: [384, 512, [], "f15c", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
  },
      nr = {
    prefix: "fas",
    iconName: "file-archive",
    icon: [384, 512, [], "f1c6", "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"]
  },
      tr = {
    prefix: "fas",
    iconName: "file-audio",
    icon: [384, 512, [], "f1c7", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
  },
      rr = {
    prefix: "fas",
    iconName: "file-code",
    icon: [384, 512, [], "f1c9", "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"]
  },
      ir = {
    prefix: "fas",
    iconName: "file-contract",
    icon: [384, 512, [], "f56c", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
  },
      or = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [384, 512, [], "f6dd", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
  },
      lr = {
    prefix: "fas",
    iconName: "file-download",
    icon: [384, 512, [], "f56d", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
  },
      fr = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
  },
      sr = {
    prefix: "fas",
    iconName: "file-export",
    icon: [576, 512, [], "f56e", "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"]
  },
      ur = {
    prefix: "fas",
    iconName: "file-image",
    icon: [384, 512, [], "f1c5", "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"]
  },
      hr = {
    prefix: "fas",
    iconName: "file-import",
    icon: [512, 512, [], "f56f", "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"]
  },
      mr = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"]
  },
      vr = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"]
  },
      dr = {
    prefix: "fas",
    iconName: "file-medical",
    icon: [384, 512, [], "f477", "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"]
  },
      Mr = {
    prefix: "fas",
    iconName: "file-medical-alt",
    icon: [448, 512, [], "f478", "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
  },
      pr = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [384, 512, [], "f1c1", "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"]
  },
      zr = {
    prefix: "fas",
    iconName: "file-powerpoint",
    icon: [384, 512, [], "f1c4", "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"]
  },
      Cr = {
    prefix: "fas",
    iconName: "file-prescription",
    icon: [384, 512, [], "f572", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
  },
      Lr = {
    prefix: "fas",
    iconName: "file-signature",
    icon: [576, 512, [], "f573", "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"]
  },
      Ar = {
    prefix: "fas",
    iconName: "file-upload",
    icon: [384, 512, [], "f574", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
  },
      Nr = {
    prefix: "fas",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"]
  },
      gr = {
    prefix: "fas",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
  },
      Hr = {
    prefix: "fas",
    iconName: "fill",
    icon: [512, 512, [], "f575", "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"]
  },
      Vr = {
    prefix: "fas",
    iconName: "fill-drip",
    icon: [576, 512, [], "f576", "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"]
  },
      xr = {
    prefix: "fas",
    iconName: "film",
    icon: [512, 512, [], "f008", "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"]
  },
      wr = {
    prefix: "fas",
    iconName: "filter",
    icon: [512, 512, [], "f0b0", "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"]
  },
      yr = {
    prefix: "fas",
    iconName: "fingerprint",
    icon: [512, 512, [], "f577", "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"]
  },
      br = {
    prefix: "fas",
    iconName: "fire",
    icon: [384, 512, [], "f06d", "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"]
  },
      Sr = {
    prefix: "fas",
    iconName: "fire-alt",
    icon: [448, 512, [], "f7e4", "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"]
  },
      Tr = {
    prefix: "fas",
    iconName: "fire-extinguisher",
    icon: [448, 512, [], "f134", "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"]
  },
      Dr = {
    prefix: "fas",
    iconName: "first-aid",
    icon: [576, 512, [], "f479", "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"]
  },
      jr = {
    prefix: "fas",
    iconName: "fish",
    icon: [576, 512, [], "f578", "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"]
  },
      Er = {
    prefix: "fas",
    iconName: "fist-raised",
    icon: [384, 512, [], "f6de", "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"]
  },
      kr = {
    prefix: "fas",
    iconName: "flag",
    icon: [512, 512, [], "f024", "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"]
  },
      Ir = {
    prefix: "fas",
    iconName: "flag-checkered",
    icon: [512, 512, [], "f11e", "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"]
  },
      Or = {
    prefix: "fas",
    iconName: "flag-usa",
    icon: [512, 512, [], "f74d", "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"]
  },
      Qr = {
    prefix: "fas",
    iconName: "flask",
    icon: [448, 512, [], "f0c3", "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"]
  },
      Zr = {
    prefix: "fas",
    iconName: "flushed",
    icon: [496, 512, [], "f579", "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"]
  },
      Ur = {
    prefix: "fas",
    iconName: "folder",
    icon: [512, 512, [], "f07b", "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"]
  },
      Br = {
    prefix: "fas",
    iconName: "folder-minus",
    icon: [512, 512, [], "f65d", "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"]
  },
      Rr = {
    prefix: "fas",
    iconName: "folder-open",
    icon: [576, 512, [], "f07c", "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"]
  },
      Yr = {
    prefix: "fas",
    iconName: "folder-plus",
    icon: [512, 512, [], "f65e", "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"]
  },
      Pr = {
    prefix: "fas",
    iconName: "font",
    icon: [448, 512, [], "f031", "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"]
  },
      Fr = {
    prefix: "fas",
    iconName: "font-awesome-logo-full",
    icon: [3992, 512, ["Font Awesome"], "f4e6", "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"]
  },
      Wr = {
    prefix: "fas",
    iconName: "football-ball",
    icon: [496, 512, [], "f44e", "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"]
  },
      Gr = {
    prefix: "fas",
    iconName: "forward",
    icon: [512, 512, [], "f04e", "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"]
  },
      qr = {
    prefix: "fas",
    iconName: "frog",
    icon: [576, 512, [], "f52e", "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"]
  },
      Jr = {
    prefix: "fas",
    iconName: "frown",
    icon: [496, 512, [], "f119", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"]
  },
      Kr = {
    prefix: "fas",
    iconName: "frown-open",
    icon: [496, 512, [], "f57a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Xr = {
    prefix: "fas",
    iconName: "funnel-dollar",
    icon: [640, 512, [], "f662", "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"]
  },
      _r = {
    prefix: "fas",
    iconName: "futbol",
    icon: [512, 512, [], "f1e3", "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"]
  },
      $r = {
    prefix: "fas",
    iconName: "gamepad",
    icon: [640, 512, [], "f11b", "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"]
  },
      ci = {
    prefix: "fas",
    iconName: "gas-pump",
    icon: [512, 512, [], "f52f", "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"]
  },
      ei = {
    prefix: "fas",
    iconName: "gavel",
    icon: [512, 512, [], "f0e3", "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"]
  },
      ai = {
    prefix: "fas",
    iconName: "gem",
    icon: [576, 512, [], "f3a5", "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"]
  },
      ni = {
    prefix: "fas",
    iconName: "genderless",
    icon: [288, 512, [], "f22d", "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"]
  },
      ti = {
    prefix: "fas",
    iconName: "ghost",
    icon: [384, 512, [], "f6e2", "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      ri = {
    prefix: "fas",
    iconName: "gift",
    icon: [512, 512, [], "f06b", "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"]
  },
      ii = {
    prefix: "fas",
    iconName: "gifts",
    icon: [640, 512, [], "f79c", "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"]
  },
      oi = {
    prefix: "fas",
    iconName: "glass-cheers",
    icon: [640, 512, [], "f79f", "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"]
  },
      li = {
    prefix: "fas",
    iconName: "glass-martini",
    icon: [512, 512, [], "f000", "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"]
  },
      fi = {
    prefix: "fas",
    iconName: "glass-martini-alt",
    icon: [512, 512, [], "f57b", "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"]
  },
      si = {
    prefix: "fas",
    iconName: "glass-whiskey",
    icon: [512, 512, [], "f7a0", "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"]
  },
      ui = {
    prefix: "fas",
    iconName: "glasses",
    icon: [576, 512, [], "f530", "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"]
  },
      hi = {
    prefix: "fas",
    iconName: "globe",
    icon: [496, 512, [], "f0ac", "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"]
  },
      mi = {
    prefix: "fas",
    iconName: "globe-africa",
    icon: [496, 512, [], "f57c", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"]
  },
      vi = {
    prefix: "fas",
    iconName: "globe-americas",
    icon: [496, 512, [], "f57d", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"]
  },
      di = {
    prefix: "fas",
    iconName: "globe-asia",
    icon: [496, 512, [], "f57e", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"]
  },
      Mi = {
    prefix: "fas",
    iconName: "globe-europe",
    icon: [496, 512, [], "f7a2", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"]
  },
      pi = {
    prefix: "fas",
    iconName: "golf-ball",
    icon: [416, 512, [], "f450", "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"]
  },
      zi = {
    prefix: "fas",
    iconName: "gopuram",
    icon: [512, 512, [], "f664", "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"]
  },
      Ci = {
    prefix: "fas",
    iconName: "graduation-cap",
    icon: [640, 512, [], "f19d", "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"]
  },
      Li = {
    prefix: "fas",
    iconName: "greater-than",
    icon: [384, 512, [], "f531", "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"]
  },
      Ai = {
    prefix: "fas",
    iconName: "greater-than-equal",
    icon: [448, 512, [], "f532", "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"]
  },
      Ni = {
    prefix: "fas",
    iconName: "grimace",
    icon: [496, 512, [], "f57f", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"]
  },
      gi = {
    prefix: "fas",
    iconName: "grin",
    icon: [496, 512, [], "f580", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
  },
      Hi = {
    prefix: "fas",
    iconName: "grin-alt",
    icon: [496, 512, [], "f581", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
  },
      Vi = {
    prefix: "fas",
    iconName: "grin-beam",
    icon: [496, 512, [], "f582", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
  },
      xi = {
    prefix: "fas",
    iconName: "grin-beam-sweat",
    icon: [504, 512, [], "f583", "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
  },
      wi = {
    prefix: "fas",
    iconName: "grin-hearts",
    icon: [496, 512, [], "f584", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"]
  },
      yi = {
    prefix: "fas",
    iconName: "grin-squint",
    icon: [496, 512, [], "f585", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
  },
      bi = {
    prefix: "fas",
    iconName: "grin-squint-tears",
    icon: [512, 512, [], "f586", "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"]
  },
      Si = {
    prefix: "fas",
    iconName: "grin-stars",
    icon: [496, 512, [], "f587", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"]
  },
      Ti = {
    prefix: "fas",
    iconName: "grin-tears",
    icon: [640, 512, [], "f588", "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
  },
      Di = {
    prefix: "fas",
    iconName: "grin-tongue",
    icon: [496, 512, [], "f589", "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"]
  },
      ji = {
    prefix: "fas",
    iconName: "grin-tongue-squint",
    icon: [496, 512, [], "f58a", "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"]
  },
      Ei = {
    prefix: "fas",
    iconName: "grin-tongue-wink",
    icon: [496, 512, [], "f58b", "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"]
  },
      ki = {
    prefix: "fas",
    iconName: "grin-wink",
    icon: [496, 512, [], "f58c", "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"]
  },
      Ii = {
    prefix: "fas",
    iconName: "grip-horizontal",
    icon: [448, 512, [], "f58d", "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
  },
      Oi = {
    prefix: "fas",
    iconName: "grip-lines",
    icon: [512, 512, [], "f7a4", "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
  },
      Qi = {
    prefix: "fas",
    iconName: "grip-lines-vertical",
    icon: [256, 512, [], "f7a5", "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"]
  },
      Zi = {
    prefix: "fas",
    iconName: "grip-vertical",
    icon: [320, 512, [], "f58e", "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
  },
      Ui = {
    prefix: "fas",
    iconName: "guitar",
    icon: [512, 512, [], "f7a6", "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"]
  },
      Bi = {
    prefix: "fas",
    iconName: "h-square",
    icon: [448, 512, [], "f0fd", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"]
  },
      Ri = {
    prefix: "fas",
    iconName: "hamburger",
    icon: [512, 512, [], "f805", "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"]
  },
      Yi = {
    prefix: "fas",
    iconName: "hammer",
    icon: [576, 512, [], "f6e3", "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"]
  },
      Pi = {
    prefix: "fas",
    iconName: "hamsa",
    icon: [512, 512, [], "f665", "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
  },
      Fi = {
    prefix: "fas",
    iconName: "hand-holding",
    icon: [576, 512, [], "f4bd", "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"]
  },
      Wi = {
    prefix: "fas",
    iconName: "hand-holding-heart",
    icon: [576, 512, [], "f4be", "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"]
  },
      Gi = {
    prefix: "fas",
    iconName: "hand-holding-medical",
    icon: [576, 512, [], "e05c", "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"]
  },
      qi = {
    prefix: "fas",
    iconName: "hand-holding-usd",
    icon: [576, 512, [], "f4c0", "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"]
  },
      Ji = {
    prefix: "fas",
    iconName: "hand-holding-water",
    icon: [576, 512, [], "f4c1", "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"]
  },
      Ki = {
    prefix: "fas",
    iconName: "hand-lizard",
    icon: [576, 512, [], "f258", "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"]
  },
      Xi = {
    prefix: "fas",
    iconName: "hand-middle-finger",
    icon: [512, 512, [], "f806", "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"]
  },
      _i = {
    prefix: "fas",
    iconName: "hand-paper",
    icon: [448, 512, [], "f256", "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"]
  },
      $i = {
    prefix: "fas",
    iconName: "hand-peace",
    icon: [448, 512, [], "f25b", "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"]
  },
      co = {
    prefix: "fas",
    iconName: "hand-point-down",
    icon: [384, 512, [], "f0a7", "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"]
  },
      eo = {
    prefix: "fas",
    iconName: "hand-point-left",
    icon: [512, 512, [], "f0a5", "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"]
  },
      ao = {
    prefix: "fas",
    iconName: "hand-point-right",
    icon: [512, 512, [], "f0a4", "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"]
  },
      no = {
    prefix: "fas",
    iconName: "hand-point-up",
    icon: [384, 512, [], "f0a6", "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"]
  },
      to = {
    prefix: "fas",
    iconName: "hand-pointer",
    icon: [448, 512, [], "f25a", "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"]
  },
      ro = {
    prefix: "fas",
    iconName: "hand-rock",
    icon: [512, 512, [], "f255", "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"]
  },
      io = {
    prefix: "fas",
    iconName: "hand-scissors",
    icon: [512, 512, [], "f257", "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"]
  },
      oo = {
    prefix: "fas",
    iconName: "hand-sparkles",
    icon: [640, 512, [], "e05d", "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"]
  },
      lo = {
    prefix: "fas",
    iconName: "hand-spock",
    icon: [512, 512, [], "f259", "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"]
  },
      fo = {
    prefix: "fas",
    iconName: "hands",
    icon: [640, 512, [], "f4c2", "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"]
  },
      so = {
    prefix: "fas",
    iconName: "hands-helping",
    icon: [640, 512, [], "f4c4", "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"]
  },
      uo = {
    prefix: "fas",
    iconName: "hands-wash",
    icon: [576, 512, [], "e05e", "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"]
  },
      ho = {
    prefix: "fas",
    iconName: "handshake",
    icon: [640, 512, [], "f2b5", "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"]
  },
      mo = {
    prefix: "fas",
    iconName: "handshake-alt-slash",
    icon: [640, 512, [], "e05f", "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"]
  },
      vo = {
    prefix: "fas",
    iconName: "handshake-slash",
    icon: [640, 512, [], "e060", "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"]
  },
      Mo = {
    prefix: "fas",
    iconName: "hanukiah",
    icon: [640, 512, [], "f6e6", "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"]
  },
      po = {
    prefix: "fas",
    iconName: "hard-hat",
    icon: [512, 512, [], "f807", "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      zo = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [448, 512, [], "f292", "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"]
  },
      Co = {
    prefix: "fas",
    iconName: "hat-cowboy",
    icon: [640, 512, [], "f8c0", "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"]
  },
      Lo = {
    prefix: "fas",
    iconName: "hat-cowboy-side",
    icon: [640, 512, [], "f8c1", "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"]
  },
      Ao = {
    prefix: "fas",
    iconName: "hat-wizard",
    icon: [512, 512, [], "f6e8", "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"]
  },
      No = {
    prefix: "fas",
    iconName: "hdd",
    icon: [576, 512, [], "f0a0", "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"]
  },
      go = {
    prefix: "fas",
    iconName: "head-side-cough",
    icon: [640, 512, [], "e061", "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"]
  },
      Ho = {
    prefix: "fas",
    iconName: "head-side-cough-slash",
    icon: [640, 512, [], "e062", "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"]
  },
      Vo = {
    prefix: "fas",
    iconName: "head-side-mask",
    icon: [512, 512, [], "e063", "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"]
  },
      xo = {
    prefix: "fas",
    iconName: "head-side-virus",
    icon: [512, 512, [], "e064", "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"]
  },
      wo = {
    prefix: "fas",
    iconName: "heading",
    icon: [512, 512, [], "f1dc", "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"]
  },
      yo = {
    prefix: "fas",
    iconName: "headphones",
    icon: [512, 512, [], "f025", "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"]
  },
      bo = {
    prefix: "fas",
    iconName: "headphones-alt",
    icon: [512, 512, [], "f58f", "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"]
  },
      So = {
    prefix: "fas",
    iconName: "headset",
    icon: [512, 512, [], "f590", "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"]
  },
      To = {
    prefix: "fas",
    iconName: "heart",
    icon: [512, 512, [], "f004", "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"]
  },
      Do = {
    prefix: "fas",
    iconName: "heart-broken",
    icon: [512, 512, [], "f7a9", "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"]
  },
      jo = {
    prefix: "fas",
    iconName: "heartbeat",
    icon: [512, 512, [], "f21e", "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"]
  },
      Eo = {
    prefix: "fas",
    iconName: "helicopter",
    icon: [640, 512, [], "f533", "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"]
  },
      ko = {
    prefix: "fas",
    iconName: "highlighter",
    icon: [544, 512, [], "f591", "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"]
  },
      Io = {
    prefix: "fas",
    iconName: "hiking",
    icon: [384, 512, [], "f6ec", "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"]
  },
      Oo = {
    prefix: "fas",
    iconName: "hippo",
    icon: [640, 512, [], "f6ed", "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      Qo = {
    prefix: "fas",
    iconName: "history",
    icon: [512, 512, [], "f1da", "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"]
  },
      Zo = {
    prefix: "fas",
    iconName: "hockey-puck",
    icon: [512, 512, [], "f453", "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"]
  },
      Uo = {
    prefix: "fas",
    iconName: "holly-berry",
    icon: [448, 512, [], "f7aa", "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"]
  },
      Bo = {
    prefix: "fas",
    iconName: "home",
    icon: [576, 512, [], "f015", "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"]
  },
      Ro = {
    prefix: "fas",
    iconName: "horse",
    icon: [576, 512, [], "f6f0", "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      Yo = {
    prefix: "fas",
    iconName: "horse-head",
    icon: [512, 512, [], "f7ab", "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"]
  },
      Po = {
    prefix: "fas",
    iconName: "hospital",
    icon: [448, 512, [], "f0f8", "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"]
  },
      Fo = {
    prefix: "fas",
    iconName: "hospital-alt",
    icon: [576, 512, [], "f47d", "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"]
  },
      Wo = {
    prefix: "fas",
    iconName: "hospital-symbol",
    icon: [512, 512, [], "f47e", "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"]
  },
      Go = {
    prefix: "fas",
    iconName: "hospital-user",
    icon: [640, 512, [], "f80d", "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"]
  },
      qo = {
    prefix: "fas",
    iconName: "hot-tub",
    icon: [512, 512, [], "f593", "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"]
  },
      Jo = {
    prefix: "fas",
    iconName: "hotdog",
    icon: [512, 512, [], "f80f", "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"]
  },
      Ko = {
    prefix: "fas",
    iconName: "hotel",
    icon: [576, 512, [], "f594", "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"]
  },
      Xo = {
    prefix: "fas",
    iconName: "hourglass",
    icon: [384, 512, [], "f254", "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"]
  },
      _o = {
    prefix: "fas",
    iconName: "hourglass-end",
    icon: [384, 512, [], "f253", "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"]
  },
      $o = {
    prefix: "fas",
    iconName: "hourglass-half",
    icon: [384, 512, [], "f252", "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"]
  },
      cl = {
    prefix: "fas",
    iconName: "hourglass-start",
    icon: [384, 512, [], "f251", "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"]
  },
      el = {
    prefix: "fas",
    iconName: "house-damage",
    icon: [576, 512, [], "f6f1", "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"]
  },
      al = {
    prefix: "fas",
    iconName: "house-user",
    icon: [576, 512, [], "e065", "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"]
  },
      nl = {
    prefix: "fas",
    iconName: "hryvnia",
    icon: [384, 512, [], "f6f2", "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"]
  },
      tl = {
    prefix: "fas",
    iconName: "i-cursor",
    icon: [256, 512, [], "f246", "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"]
  },
      rl = {
    prefix: "fas",
    iconName: "ice-cream",
    icon: [448, 512, [], "f810", "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"]
  },
      il = {
    prefix: "fas",
    iconName: "icicles",
    icon: [512, 512, [], "f7ad", "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"]
  },
      ol = {
    prefix: "fas",
    iconName: "icons",
    icon: [512, 512, [], "f86d", "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"]
  },
      ll = {
    prefix: "fas",
    iconName: "id-badge",
    icon: [384, 512, [], "f2c1", "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"]
  },
      fl = {
    prefix: "fas",
    iconName: "id-card",
    icon: [576, 512, [], "f2c2", "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"]
  },
      sl = {
    prefix: "fas",
    iconName: "id-card-alt",
    icon: [576, 512, [], "f47f", "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"]
  },
      ul = {
    prefix: "fas",
    iconName: "igloo",
    icon: [576, 512, [], "f7ae", "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"]
  },
      hl = {
    prefix: "fas",
    iconName: "image",
    icon: [512, 512, [], "f03e", "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"]
  },
      ml = {
    prefix: "fas",
    iconName: "images",
    icon: [576, 512, [], "f302", "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"]
  },
      vl = {
    prefix: "fas",
    iconName: "inbox",
    icon: [576, 512, [], "f01c", "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"]
  },
      dl = {
    prefix: "fas",
    iconName: "indent",
    icon: [448, 512, [], "f03c", "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Ml = {
    prefix: "fas",
    iconName: "industry",
    icon: [512, 512, [], "f275", "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"]
  },
      pl = {
    prefix: "fas",
    iconName: "infinity",
    icon: [640, 512, [], "f534", "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"]
  },
      zl = {
    prefix: "fas",
    iconName: "info",
    icon: [192, 512, [], "f129", "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"]
  },
      Cl = {
    prefix: "fas",
    iconName: "info-circle",
    icon: [512, 512, [], "f05a", "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"]
  },
      Ll = {
    prefix: "fas",
    iconName: "italic",
    icon: [320, 512, [], "f033", "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"]
  },
      Al = {
    prefix: "fas",
    iconName: "jedi",
    icon: [576, 512, [], "f669", "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"]
  },
      Nl = {
    prefix: "fas",
    iconName: "joint",
    icon: [640, 512, [], "f595", "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"]
  },
      gl = {
    prefix: "fas",
    iconName: "journal-whills",
    icon: [448, 512, [], "f66a", "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"]
  },
      Hl = {
    prefix: "fas",
    iconName: "kaaba",
    icon: [576, 512, [], "f66b", "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"]
  },
      Vl = {
    prefix: "fas",
    iconName: "key",
    icon: [512, 512, [], "f084", "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"]
  },
      xl = {
    prefix: "fas",
    iconName: "keyboard",
    icon: [576, 512, [], "f11c", "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"]
  },
      wl = {
    prefix: "fas",
    iconName: "khanda",
    icon: [512, 512, [], "f66d", "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"]
  },
      yl = {
    prefix: "fas",
    iconName: "kiss",
    icon: [496, 512, [], "f596", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      bl = {
    prefix: "fas",
    iconName: "kiss-beam",
    icon: [496, 512, [], "f597", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"]
  },
      Sl = {
    prefix: "fas",
    iconName: "kiss-wink-heart",
    icon: [504, 512, [], "f598", "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"]
  },
      Tl = {
    prefix: "fas",
    iconName: "kiwi-bird",
    icon: [576, 512, [], "f535", "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"]
  },
      Dl = {
    prefix: "fas",
    iconName: "landmark",
    icon: [512, 512, [], "f66f", "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      jl = {
    prefix: "fas",
    iconName: "language",
    icon: [640, 512, [], "f1ab", "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"]
  },
      El = {
    prefix: "fas",
    iconName: "laptop",
    icon: [640, 512, [], "f109", "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"]
  },
      kl = {
    prefix: "fas",
    iconName: "laptop-code",
    icon: [640, 512, [], "f5fc", "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"]
  },
      Il = {
    prefix: "fas",
    iconName: "laptop-house",
    icon: [640, 512, [], "e066", "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"]
  },
      Ol = {
    prefix: "fas",
    iconName: "laptop-medical",
    icon: [640, 512, [], "f812", "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"]
  },
      Ql = {
    prefix: "fas",
    iconName: "laugh",
    icon: [496, 512, [], "f599", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"]
  },
      Zl = {
    prefix: "fas",
    iconName: "laugh-beam",
    icon: [496, 512, [], "f59a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"]
  },
      Ul = {
    prefix: "fas",
    iconName: "laugh-squint",
    icon: [496, 512, [], "f59b", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"]
  },
      Bl = {
    prefix: "fas",
    iconName: "laugh-wink",
    icon: [496, 512, [], "f59c", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"]
  },
      Rl = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [512, 512, [], "f5fd", "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"]
  },
      Yl = {
    prefix: "fas",
    iconName: "leaf",
    icon: [576, 512, [], "f06c", "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"]
  },
      Pl = {
    prefix: "fas",
    iconName: "lemon",
    icon: [512, 512, [], "f094", "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"]
  },
      Fl = {
    prefix: "fas",
    iconName: "less-than",
    icon: [384, 512, [], "f536", "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"]
  },
      Wl = {
    prefix: "fas",
    iconName: "less-than-equal",
    icon: [448, 512, [], "f537", "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"]
  },
      Gl = {
    prefix: "fas",
    iconName: "level-down-alt",
    icon: [320, 512, [], "f3be", "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"]
  },
      ql = {
    prefix: "fas",
    iconName: "level-up-alt",
    icon: [320, 512, [], "f3bf", "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"]
  },
      Jl = {
    prefix: "fas",
    iconName: "life-ring",
    icon: [512, 512, [], "f1cd", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"]
  },
      Kl = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [352, 512, [], "f0eb", "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"]
  },
      Xl = {
    prefix: "fas",
    iconName: "link",
    icon: [512, 512, [], "f0c1", "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"]
  },
      _l = {
    prefix: "fas",
    iconName: "lira-sign",
    icon: [384, 512, [], "f195", "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"]
  },
      $l = {
    prefix: "fas",
    iconName: "list",
    icon: [512, 512, [], "f03a", "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      cf = {
    prefix: "fas",
    iconName: "list-alt",
    icon: [512, 512, [], "f022", "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"]
  },
      ef = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [512, 512, [], "f0cb", "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"]
  },
      af = {
    prefix: "fas",
    iconName: "list-ul",
    icon: [512, 512, [], "f0ca", "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      nf = {
    prefix: "fas",
    iconName: "location-arrow",
    icon: [512, 512, [], "f124", "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"]
  },
      tf = {
    prefix: "fas",
    iconName: "lock",
    icon: [448, 512, [], "f023", "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"]
  },
      rf = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [576, 512, [], "f3c1", "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"]
  },
      of = {
    prefix: "fas",
    iconName: "long-arrow-alt-down",
    icon: [256, 512, [], "f309", "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"]
  },
      lf = {
    prefix: "fas",
    iconName: "long-arrow-alt-left",
    icon: [448, 512, [], "f30a", "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"]
  },
      ff = {
    prefix: "fas",
    iconName: "long-arrow-alt-right",
    icon: [448, 512, [], "f30b", "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"]
  },
      sf = {
    prefix: "fas",
    iconName: "long-arrow-alt-up",
    icon: [256, 512, [], "f30c", "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"]
  },
      uf = {
    prefix: "fas",
    iconName: "low-vision",
    icon: [576, 512, [], "f2a8", "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"]
  },
      hf = {
    prefix: "fas",
    iconName: "luggage-cart",
    icon: [640, 512, [], "f59d", "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"]
  },
      mf = {
    prefix: "fas",
    iconName: "lungs",
    icon: [640, 512, [], "f604", "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"]
  },
      vf = {
    prefix: "fas",
    iconName: "lungs-virus",
    icon: [640, 512, [], "e067", "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"]
  },
      df = {
    prefix: "fas",
    iconName: "magic",
    icon: [512, 512, [], "f0d0", "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"]
  },
      Mf = {
    prefix: "fas",
    iconName: "magnet",
    icon: [512, 512, [], "f076", "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"]
  },
      pf = {
    prefix: "fas",
    iconName: "mail-bulk",
    icon: [576, 512, [], "f674", "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"]
  },
      zf = {
    prefix: "fas",
    iconName: "male",
    icon: [192, 512, [], "f183", "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"]
  },
      Cf = {
    prefix: "fas",
    iconName: "map",
    icon: [576, 512, [], "f279", "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"]
  },
      Lf = {
    prefix: "fas",
    iconName: "map-marked",
    icon: [576, 512, [], "f59f", "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"]
  },
      Af = {
    prefix: "fas",
    iconName: "map-marked-alt",
    icon: [576, 512, [], "f5a0", "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"]
  },
      Nf = {
    prefix: "fas",
    iconName: "map-marker",
    icon: [384, 512, [], "f041", "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"]
  },
      gf = {
    prefix: "fas",
    iconName: "map-marker-alt",
    icon: [384, 512, [], "f3c5", "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"]
  },
      Hf = {
    prefix: "fas",
    iconName: "map-pin",
    icon: [288, 512, [], "f276", "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"]
  },
      Vf = {
    prefix: "fas",
    iconName: "map-signs",
    icon: [512, 512, [], "f277", "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"]
  },
      xf = {
    prefix: "fas",
    iconName: "marker",
    icon: [512, 512, [], "f5a1", "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"]
  },
      wf = {
    prefix: "fas",
    iconName: "mars",
    icon: [384, 512, [], "f222", "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      yf = {
    prefix: "fas",
    iconName: "mars-double",
    icon: [512, 512, [], "f227", "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"]
  },
      bf = {
    prefix: "fas",
    iconName: "mars-stroke",
    icon: [384, 512, [], "f229", "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      Sf = {
    prefix: "fas",
    iconName: "mars-stroke-h",
    icon: [480, 512, [], "f22b", "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"]
  },
      Tf = {
    prefix: "fas",
    iconName: "mars-stroke-v",
    icon: [288, 512, [], "f22a", "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"]
  },
      Df = {
    prefix: "fas",
    iconName: "mask",
    icon: [640, 512, [], "f6fa", "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"]
  },
      jf = {
    prefix: "fas",
    iconName: "medal",
    icon: [512, 512, [], "f5a2", "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"]
  },
      Ef = {
    prefix: "fas",
    iconName: "medkit",
    icon: [512, 512, [], "f0fa", "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"]
  },
      kf = {
    prefix: "fas",
    iconName: "meh",
    icon: [496, 512, [], "f11a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      If = {
    prefix: "fas",
    iconName: "meh-blank",
    icon: [496, 512, [], "f5a4", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Of = {
    prefix: "fas",
    iconName: "meh-rolling-eyes",
    icon: [496, 512, [], "f5a5", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"]
  },
      Qf = {
    prefix: "fas",
    iconName: "memory",
    icon: [640, 512, [], "f538", "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"]
  },
      Zf = {
    prefix: "fas",
    iconName: "menorah",
    icon: [640, 512, [], "f676", "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"]
  },
      Uf = {
    prefix: "fas",
    iconName: "mercury",
    icon: [288, 512, [], "f223", "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"]
  },
      Bf = {
    prefix: "fas",
    iconName: "meteor",
    icon: [512, 512, [], "f753", "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"]
  },
      Rf = {
    prefix: "fas",
    iconName: "microchip",
    icon: [512, 512, [], "f2db", "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"]
  },
      Yf = {
    prefix: "fas",
    iconName: "microphone",
    icon: [352, 512, [], "f130", "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"]
  },
      Pf = {
    prefix: "fas",
    iconName: "microphone-alt",
    icon: [352, 512, [], "f3c9", "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"]
  },
      Ff = {
    prefix: "fas",
    iconName: "microphone-alt-slash",
    icon: [640, 512, [], "f539", "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"]
  },
      Wf = {
    prefix: "fas",
    iconName: "microphone-slash",
    icon: [640, 512, [], "f131", "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"]
  },
      Gf = {
    prefix: "fas",
    iconName: "microscope",
    icon: [512, 512, [], "f610", "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"]
  },
      qf = {
    prefix: "fas",
    iconName: "minus",
    icon: [448, 512, [], "f068", "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
  },
      Jf = {
    prefix: "fas",
    iconName: "minus-circle",
    icon: [512, 512, [], "f056", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"]
  },
      Kf = {
    prefix: "fas",
    iconName: "minus-square",
    icon: [448, 512, [], "f146", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"]
  },
      Xf = {
    prefix: "fas",
    iconName: "mitten",
    icon: [448, 512, [], "f7b5", "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"]
  },
      _f = {
    prefix: "fas",
    iconName: "mobile",
    icon: [320, 512, [], "f10b", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      $f = {
    prefix: "fas",
    iconName: "mobile-alt",
    icon: [320, 512, [], "f3cd", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"]
  },
      cs = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [640, 512, [], "f0d6", "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"]
  },
      es = {
    prefix: "fas",
    iconName: "money-bill-alt",
    icon: [640, 512, [], "f3d1", "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"]
  },
      as = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [640, 512, [], "f53a", "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"]
  },
      ns = {
    prefix: "fas",
    iconName: "money-bill-wave-alt",
    icon: [640, 512, [], "f53b", "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"]
  },
      ts = {
    prefix: "fas",
    iconName: "money-check",
    icon: [640, 512, [], "f53c", "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"]
  },
      rs = {
    prefix: "fas",
    iconName: "money-check-alt",
    icon: [640, 512, [], "f53d", "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"]
  },
      is = {
    prefix: "fas",
    iconName: "monument",
    icon: [384, 512, [], "f5a6", "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"]
  },
      os = {
    prefix: "fas",
    iconName: "moon",
    icon: [512, 512, [], "f186", "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"]
  },
      ls = {
    prefix: "fas",
    iconName: "mortar-pestle",
    icon: [512, 512, [], "f5a7", "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      fs = {
    prefix: "fas",
    iconName: "mosque",
    icon: [640, 512, [], "f678", "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"]
  },
      ss = {
    prefix: "fas",
    iconName: "motorcycle",
    icon: [640, 512, [], "f21c", "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"]
  },
      us = {
    prefix: "fas",
    iconName: "mountain",
    icon: [640, 512, [], "f6fc", "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"]
  },
      hs = {
    prefix: "fas",
    iconName: "mouse",
    icon: [384, 512, [], "f8cc", "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"]
  },
      ms = {
    prefix: "fas",
    iconName: "mouse-pointer",
    icon: [320, 512, [], "f245", "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"]
  },
      vs = {
    prefix: "fas",
    iconName: "mug-hot",
    icon: [512, 512, [], "f7b6", "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
  },
      ds = {
    prefix: "fas",
    iconName: "music",
    icon: [512, 512, [], "f001", "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"]
  },
      Ms = {
    prefix: "fas",
    iconName: "network-wired",
    icon: [640, 512, [], "f6ff", "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"]
  },
      ps = {
    prefix: "fas",
    iconName: "neuter",
    icon: [288, 512, [], "f22c", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      zs = {
    prefix: "fas",
    iconName: "newspaper",
    icon: [576, 512, [], "f1ea", "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"]
  },
      Cs = {
    prefix: "fas",
    iconName: "not-equal",
    icon: [448, 512, [], "f53e", "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"]
  },
      Ls = {
    prefix: "fas",
    iconName: "notes-medical",
    icon: [384, 512, [], "f481", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"]
  },
      As = {
    prefix: "fas",
    iconName: "object-group",
    icon: [512, 512, [], "f247", "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"]
  },
      Ns = {
    prefix: "fas",
    iconName: "object-ungroup",
    icon: [576, 512, [], "f248", "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"]
  },
      gs = {
    prefix: "fas",
    iconName: "oil-can",
    icon: [640, 512, [], "f613", "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"]
  },
      Hs = {
    prefix: "fas",
    iconName: "om",
    icon: [512, 512, [], "f679", "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"]
  },
      Vs = {
    prefix: "fas",
    iconName: "otter",
    icon: [640, 512, [], "f700", "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"]
  },
      xs = {
    prefix: "fas",
    iconName: "outdent",
    icon: [448, 512, [], "f03b", "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      ws = {
    prefix: "fas",
    iconName: "pager",
    icon: [512, 512, [], "f815", "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"]
  },
      ys = {
    prefix: "fas",
    iconName: "paint-brush",
    icon: [512, 512, [], "f1fc", "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"]
  },
      bs = {
    prefix: "fas",
    iconName: "paint-roller",
    icon: [512, 512, [], "f5aa", "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"]
  },
      Ss = {
    prefix: "fas",
    iconName: "palette",
    icon: [512, 512, [], "f53f", "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Ts = {
    prefix: "fas",
    iconName: "pallet",
    icon: [640, 512, [], "f482", "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"]
  },
      Ds = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [512, 512, [], "f1d8", "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"]
  },
      js = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [448, 512, [], "f0c6", "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"]
  },
      Es = {
    prefix: "fas",
    iconName: "parachute-box",
    icon: [512, 512, [], "f4cd", "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"]
  },
      ks = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [448, 512, [], "f1dd", "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"]
  },
      Is = {
    prefix: "fas",
    iconName: "parking",
    icon: [448, 512, [], "f540", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"]
  },
      Os = {
    prefix: "fas",
    iconName: "passport",
    icon: [448, 512, [], "f5ab", "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"]
  },
      Qs = {
    prefix: "fas",
    iconName: "pastafarianism",
    icon: [640, 512, [], "f67b", "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"]
  },
      Zs = {
    prefix: "fas",
    iconName: "paste",
    icon: [448, 512, [], "f0ea", "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"]
  },
      Us = {
    prefix: "fas",
    iconName: "pause",
    icon: [448, 512, [], "f04c", "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"]
  },
      Bs = {
    prefix: "fas",
    iconName: "pause-circle",
    icon: [512, 512, [], "f28b", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"]
  },
      Rs = {
    prefix: "fas",
    iconName: "paw",
    icon: [512, 512, [], "f1b0", "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"]
  },
      Ys = {
    prefix: "fas",
    iconName: "peace",
    icon: [496, 512, [], "f67c", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"]
  },
      Ps = {
    prefix: "fas",
    iconName: "pen",
    icon: [512, 512, [], "f304", "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"]
  },
      Fs = {
    prefix: "fas",
    iconName: "pen-alt",
    icon: [512, 512, [], "f305", "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"]
  },
      Ws = {
    prefix: "fas",
    iconName: "pen-fancy",
    icon: [512, 512, [], "f5ac", "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"]
  },
      Gs = {
    prefix: "fas",
    iconName: "pen-nib",
    icon: [512, 512, [], "f5ad", "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"]
  },
      qs = {
    prefix: "fas",
    iconName: "pen-square",
    icon: [448, 512, [], "f14b", "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"]
  },
      Js = {
    prefix: "fas",
    iconName: "pencil-alt",
    icon: [512, 512, [], "f303", "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"]
  },
      Ks = {
    prefix: "fas",
    iconName: "pencil-ruler",
    icon: [512, 512, [], "f5ae", "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"]
  },
      Xs = {
    prefix: "fas",
    iconName: "people-arrows",
    icon: [576, 512, [], "e068", "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"]
  },
      _s = {
    prefix: "fas",
    iconName: "people-carry",
    icon: [640, 512, [], "f4ce", "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"]
  },
      $s = {
    prefix: "fas",
    iconName: "pepper-hot",
    icon: [512, 512, [], "f816", "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"]
  },
      cu = {
    prefix: "fas",
    iconName: "percent",
    icon: [448, 512, [], "f295", "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"]
  },
      eu = {
    prefix: "fas",
    iconName: "percentage",
    icon: [384, 512, [], "f541", "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"]
  },
      au = {
    prefix: "fas",
    iconName: "person-booth",
    icon: [576, 512, [], "f756", "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"]
  },
      nu = {
    prefix: "fas",
    iconName: "phone",
    icon: [512, 512, [], "f095", "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"]
  },
      tu = {
    prefix: "fas",
    iconName: "phone-alt",
    icon: [512, 512, [], "f879", "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"]
  },
      ru = {
    prefix: "fas",
    iconName: "phone-slash",
    icon: [640, 512, [], "f3dd", "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"]
  },
      iu = {
    prefix: "fas",
    iconName: "phone-square",
    icon: [448, 512, [], "f098", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"]
  },
      ou = {
    prefix: "fas",
    iconName: "phone-square-alt",
    icon: [448, 512, [], "f87b", "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"]
  },
      lu = {
    prefix: "fas",
    iconName: "phone-volume",
    icon: [384, 512, [], "f2a0", "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"]
  },
      fu = {
    prefix: "fas",
    iconName: "photo-video",
    icon: [640, 512, [], "f87c", "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"]
  },
      su = {
    prefix: "fas",
    iconName: "piggy-bank",
    icon: [576, 512, [], "f4d3", "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"]
  },
      uu = {
    prefix: "fas",
    iconName: "pills",
    icon: [576, 512, [], "f484", "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"]
  },
      hu = {
    prefix: "fas",
    iconName: "pizza-slice",
    icon: [512, 512, [], "f818", "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"]
  },
      mu = {
    prefix: "fas",
    iconName: "place-of-worship",
    icon: [640, 512, [], "f67f", "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"]
  },
      vu = {
    prefix: "fas",
    iconName: "plane",
    icon: [576, 512, [], "f072", "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"]
  },
      du = {
    prefix: "fas",
    iconName: "plane-arrival",
    icon: [640, 512, [], "f5af", "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"]
  },
      Mu = {
    prefix: "fas",
    iconName: "plane-departure",
    icon: [640, 512, [], "f5b0", "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"]
  },
      pu = {
    prefix: "fas",
    iconName: "plane-slash",
    icon: [640, 512, [], "e069", "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"]
  },
      zu = {
    prefix: "fas",
    iconName: "play",
    icon: [448, 512, [], "f04b", "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"]
  },
      Cu = {
    prefix: "fas",
    iconName: "play-circle",
    icon: [512, 512, [], "f144", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"]
  },
      Lu = {
    prefix: "fas",
    iconName: "plug",
    icon: [384, 512, [], "f1e6", "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"]
  },
      Au = {
    prefix: "fas",
    iconName: "plus",
    icon: [448, 512, [], "f067", "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
  },
      Nu = {
    prefix: "fas",
    iconName: "plus-circle",
    icon: [512, 512, [], "f055", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"]
  },
      gu = {
    prefix: "fas",
    iconName: "plus-square",
    icon: [448, 512, [], "f0fe", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"]
  },
      Hu = {
    prefix: "fas",
    iconName: "podcast",
    icon: [448, 512, [], "f2ce", "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"]
  },
      Vu = {
    prefix: "fas",
    iconName: "poll",
    icon: [448, 512, [], "f681", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"]
  },
      xu = {
    prefix: "fas",
    iconName: "poll-h",
    icon: [448, 512, [], "f682", "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"]
  },
      wu = {
    prefix: "fas",
    iconName: "poo",
    icon: [512, 512, [], "f2fe", "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      yu = {
    prefix: "fas",
    iconName: "poo-storm",
    icon: [448, 512, [], "f75a", "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"]
  },
      bu = {
    prefix: "fas",
    iconName: "poop",
    icon: [512, 512, [], "f619", "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"]
  },
      Su = {
    prefix: "fas",
    iconName: "portrait",
    icon: [384, 512, [], "f3e0", "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"]
  },
      Tu = {
    prefix: "fas",
    iconName: "pound-sign",
    icon: [320, 512, [], "f154", "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"]
  },
      Du = {
    prefix: "fas",
    iconName: "power-off",
    icon: [512, 512, [], "f011", "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"]
  },
      ju = {
    prefix: "fas",
    iconName: "pray",
    icon: [384, 512, [], "f683", "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"]
  },
      Eu = {
    prefix: "fas",
    iconName: "praying-hands",
    icon: [640, 512, [], "f684", "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"]
  },
      ku = {
    prefix: "fas",
    iconName: "prescription",
    icon: [384, 512, [], "f5b1", "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"]
  },
      Iu = {
    prefix: "fas",
    iconName: "prescription-bottle",
    icon: [384, 512, [], "f485", "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"]
  },
      Ou = {
    prefix: "fas",
    iconName: "prescription-bottle-alt",
    icon: [384, 512, [], "f486", "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"]
  },
      Qu = {
    prefix: "fas",
    iconName: "print",
    icon: [512, 512, [], "f02f", "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
  },
      Zu = {
    prefix: "fas",
    iconName: "procedures",
    icon: [640, 512, [], "f487", "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"]
  },
      Uu = {
    prefix: "fas",
    iconName: "project-diagram",
    icon: [640, 512, [], "f542", "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"]
  },
      Bu = {
    prefix: "fas",
    iconName: "pump-medical",
    icon: [384, 512, [], "e06a", "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"]
  },
      Ru = {
    prefix: "fas",
    iconName: "pump-soap",
    icon: [384, 512, [], "e06b", "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"]
  },
      Yu = {
    prefix: "fas",
    iconName: "puzzle-piece",
    icon: [576, 512, [], "f12e", "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"]
  },
      Pu = {
    prefix: "fas",
    iconName: "qrcode",
    icon: [448, 512, [], "f029", "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"]
  },
      Fu = {
    prefix: "fas",
    iconName: "question",
    icon: [384, 512, [], "f128", "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"]
  },
      Wu = {
    prefix: "fas",
    iconName: "question-circle",
    icon: [512, 512, [], "f059", "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"]
  },
      Gu = {
    prefix: "fas",
    iconName: "quidditch",
    icon: [640, 512, [], "f458", "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"]
  },
      qu = {
    prefix: "fas",
    iconName: "quote-left",
    icon: [512, 512, [], "f10d", "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"]
  },
      Ju = {
    prefix: "fas",
    iconName: "quote-right",
    icon: [512, 512, [], "f10e", "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"]
  },
      Ku = {
    prefix: "fas",
    iconName: "quran",
    icon: [448, 512, [], "f687", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"]
  },
      Xu = {
    prefix: "fas",
    iconName: "radiation",
    icon: [496, 512, [], "f7b9", "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"]
  },
      _u = {
    prefix: "fas",
    iconName: "radiation-alt",
    icon: [496, 512, [], "f7ba", "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"]
  },
      $u = {
    prefix: "fas",
    iconName: "rainbow",
    icon: [576, 512, [], "f75b", "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"]
  },
      ch = {
    prefix: "fas",
    iconName: "random",
    icon: [512, 512, [], "f074", "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"]
  },
      eh = {
    prefix: "fas",
    iconName: "receipt",
    icon: [384, 512, [], "f543", "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"]
  },
      ah = {
    prefix: "fas",
    iconName: "record-vinyl",
    icon: [512, 512, [], "f8d9", "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"]
  },
      nh = {
    prefix: "fas",
    iconName: "recycle",
    icon: [512, 512, [], "f1b8", "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"]
  },
      th = {
    prefix: "fas",
    iconName: "redo",
    icon: [512, 512, [], "f01e", "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"]
  },
      rh = {
    prefix: "fas",
    iconName: "redo-alt",
    icon: [512, 512, [], "f2f9", "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"]
  },
      ih = {
    prefix: "fas",
    iconName: "registered",
    icon: [512, 512, [], "f25d", "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"]
  },
      oh = {
    prefix: "fas",
    iconName: "remove-format",
    icon: [640, 512, [], "f87d", "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"]
  },
      lh = {
    prefix: "fas",
    iconName: "reply",
    icon: [512, 512, [], "f3e5", "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"]
  },
      fh = {
    prefix: "fas",
    iconName: "reply-all",
    icon: [576, 512, [], "f122", "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"]
  },
      sh = {
    prefix: "fas",
    iconName: "republican",
    icon: [640, 512, [], "f75e", "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"]
  },
      uh = {
    prefix: "fas",
    iconName: "restroom",
    icon: [640, 512, [], "f7bd", "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"]
  },
      hh = {
    prefix: "fas",
    iconName: "retweet",
    icon: [640, 512, [], "f079", "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"]
  },
      mh = {
    prefix: "fas",
    iconName: "ribbon",
    icon: [448, 512, [], "f4d6", "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"]
  },
      vh = {
    prefix: "fas",
    iconName: "ring",
    icon: [512, 512, [], "f70b", "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"]
  },
      dh = {
    prefix: "fas",
    iconName: "road",
    icon: [576, 512, [], "f018", "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"]
  },
      Mh = {
    prefix: "fas",
    iconName: "robot",
    icon: [640, 512, [], "f544", "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"]
  },
      ph = {
    prefix: "fas",
    iconName: "rocket",
    icon: [512, 512, [], "f135", "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"]
  },
      zh = {
    prefix: "fas",
    iconName: "route",
    icon: [512, 512, [], "f4d7", "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Ch = {
    prefix: "fas",
    iconName: "rss",
    icon: [448, 512, [], "f09e", "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"]
  },
      Lh = {
    prefix: "fas",
    iconName: "rss-square",
    icon: [448, 512, [], "f143", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"]
  },
      Ah = {
    prefix: "fas",
    iconName: "ruble-sign",
    icon: [384, 512, [], "f158", "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"]
  },
      Nh = {
    prefix: "fas",
    iconName: "ruler",
    icon: [640, 512, [], "f545", "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"]
  },
      gh = {
    prefix: "fas",
    iconName: "ruler-combined",
    icon: [512, 512, [], "f546", "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"]
  },
      Hh = {
    prefix: "fas",
    iconName: "ruler-horizontal",
    icon: [576, 512, [], "f547", "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"]
  },
      Vh = {
    prefix: "fas",
    iconName: "ruler-vertical",
    icon: [256, 512, [], "f548", "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"]
  },
      xh = {
    prefix: "fas",
    iconName: "running",
    icon: [416, 512, [], "f70c", "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"]
  },
      wh = {
    prefix: "fas",
    iconName: "rupee-sign",
    icon: [320, 512, [], "f156", "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"]
  },
      yh = {
    prefix: "fas",
    iconName: "sad-cry",
    icon: [496, 512, [], "f5b3", "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"]
  },
      bh = {
    prefix: "fas",
    iconName: "sad-tear",
    icon: [496, 512, [], "f5b4", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"]
  },
      Sh = {
    prefix: "fas",
    iconName: "satellite",
    icon: [512, 512, [], "f7bf", "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"]
  },
      Th = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [512, 512, [], "f7c0", "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"]
  },
      Dh = {
    prefix: "fas",
    iconName: "save",
    icon: [448, 512, [], "f0c7", "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"]
  },
      jh = {
    prefix: "fas",
    iconName: "school",
    icon: [640, 512, [], "f549", "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"]
  },
      Eh = {
    prefix: "fas",
    iconName: "screwdriver",
    icon: [512, 512, [], "f54a", "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"]
  },
      kh = {
    prefix: "fas",
    iconName: "scroll",
    icon: [640, 512, [], "f70e", "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"]
  },
      Ih = {
    prefix: "fas",
    iconName: "sd-card",
    icon: [384, 512, [], "f7c2", "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"]
  },
      Oh = {
    prefix: "fas",
    iconName: "search",
    icon: [512, 512, [], "f002", "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"]
  },
      Qh = {
    prefix: "fas",
    iconName: "search-dollar",
    icon: [512, 512, [], "f688", "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"]
  },
      Zh = {
    prefix: "fas",
    iconName: "search-location",
    icon: [512, 512, [], "f689", "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
  },
      Uh = {
    prefix: "fas",
    iconName: "search-minus",
    icon: [512, 512, [], "f010", "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"]
  },
      Bh = {
    prefix: "fas",
    iconName: "search-plus",
    icon: [512, 512, [], "f00e", "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"]
  },
      Rh = {
    prefix: "fas",
    iconName: "seedling",
    icon: [512, 512, [], "f4d8", "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"]
  },
      Yh = {
    prefix: "fas",
    iconName: "server",
    icon: [512, 512, [], "f233", "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"]
  },
      Ph = {
    prefix: "fas",
    iconName: "shapes",
    icon: [512, 512, [], "f61f", "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"]
  },
      Fh = {
    prefix: "fas",
    iconName: "share",
    icon: [512, 512, [], "f064", "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"]
  },
      Wh = {
    prefix: "fas",
    iconName: "share-alt",
    icon: [448, 512, [], "f1e0", "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"]
  },
      Gh = {
    prefix: "fas",
    iconName: "share-alt-square",
    icon: [448, 512, [], "f1e1", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"]
  },
      qh = {
    prefix: "fas",
    iconName: "share-square",
    icon: [576, 512, [], "f14d", "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"]
  },
      Jh = {
    prefix: "fas",
    iconName: "shekel-sign",
    icon: [448, 512, [], "f20b", "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"]
  },
      Kh = {
    prefix: "fas",
    iconName: "shield-alt",
    icon: [512, 512, [], "f3ed", "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"]
  },
      Xh = {
    prefix: "fas",
    iconName: "shield-virus",
    icon: [512, 512, [], "e06c", "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"]
  },
      _h = {
    prefix: "fas",
    iconName: "ship",
    icon: [640, 512, [], "f21a", "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"]
  },
      $h = {
    prefix: "fas",
    iconName: "shipping-fast",
    icon: [640, 512, [], "f48b", "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"]
  },
      cm = {
    prefix: "fas",
    iconName: "shoe-prints",
    icon: [640, 512, [], "f54b", "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"]
  },
      em = {
    prefix: "fas",
    iconName: "shopping-bag",
    icon: [448, 512, [], "f290", "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"]
  },
      am = {
    prefix: "fas",
    iconName: "shopping-basket",
    icon: [576, 512, [], "f291", "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"]
  },
      nm = {
    prefix: "fas",
    iconName: "shopping-cart",
    icon: [576, 512, [], "f07a", "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"]
  },
      tm = {
    prefix: "fas",
    iconName: "shower",
    icon: [512, 512, [], "f2cc", "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"]
  },
      rm = {
    prefix: "fas",
    iconName: "shuttle-van",
    icon: [640, 512, [], "f5b6", "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"]
  },
      im = {
    prefix: "fas",
    iconName: "sign",
    icon: [512, 512, [], "f4d9", "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"]
  },
      om = {
    prefix: "fas",
    iconName: "sign-in-alt",
    icon: [512, 512, [], "f2f6", "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"]
  },
      lm = {
    prefix: "fas",
    iconName: "sign-language",
    icon: [448, 512, [], "f2a7", "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"]
  },
      fm = {
    prefix: "fas",
    iconName: "sign-out-alt",
    icon: [512, 512, [], "f2f5", "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"]
  },
      sm = {
    prefix: "fas",
    iconName: "signal",
    icon: [640, 512, [], "f012", "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"]
  },
      um = {
    prefix: "fas",
    iconName: "signature",
    icon: [640, 512, [], "f5b7", "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"]
  },
      hm = {
    prefix: "fas",
    iconName: "sim-card",
    icon: [384, 512, [], "f7c4", "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"]
  },
      mm = {
    prefix: "fas",
    iconName: "sink",
    icon: [512, 512, [], "e06d", "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"]
  },
      vm = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [640, 512, [], "f0e8", "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"]
  },
      dm = {
    prefix: "fas",
    iconName: "skating",
    icon: [448, 512, [], "f7c5", "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"]
  },
      Mm = {
    prefix: "fas",
    iconName: "skiing",
    icon: [512, 512, [], "f7c9", "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"]
  },
      pm = {
    prefix: "fas",
    iconName: "skiing-nordic",
    icon: [576, 512, [], "f7ca", "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"]
  },
      zm = {
    prefix: "fas",
    iconName: "skull",
    icon: [512, 512, [], "f54c", "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"]
  },
      Cm = {
    prefix: "fas",
    iconName: "skull-crossbones",
    icon: [448, 512, [], "f714", "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"]
  },
      Lm = {
    prefix: "fas",
    iconName: "slash",
    icon: [640, 512, [], "f715", "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"]
  },
      Am = {
    prefix: "fas",
    iconName: "sleigh",
    icon: [640, 512, [], "f7cc", "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"]
  },
      Nm = {
    prefix: "fas",
    iconName: "sliders-h",
    icon: [512, 512, [], "f1de", "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"]
  },
      gm = {
    prefix: "fas",
    iconName: "smile",
    icon: [496, 512, [], "f118", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"]
  },
      Hm = {
    prefix: "fas",
    iconName: "smile-beam",
    icon: [496, 512, [], "f5b8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"]
  },
      Vm = {
    prefix: "fas",
    iconName: "smile-wink",
    icon: [496, 512, [], "f4da", "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"]
  },
      xm = {
    prefix: "fas",
    iconName: "smog",
    icon: [640, 512, [], "f75f", "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"]
  },
      wm = {
    prefix: "fas",
    iconName: "smoking",
    icon: [640, 512, [], "f48d", "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"]
  },
      ym = {
    prefix: "fas",
    iconName: "smoking-ban",
    icon: [512, 512, [], "f54d", "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"]
  },
      bm = {
    prefix: "fas",
    iconName: "sms",
    icon: [512, 512, [], "f7cd", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"]
  },
      Sm = {
    prefix: "fas",
    iconName: "snowboarding",
    icon: [512, 512, [], "f7ce", "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"]
  },
      Tm = {
    prefix: "fas",
    iconName: "snowflake",
    icon: [448, 512, [], "f2dc", "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"]
  },
      Dm = {
    prefix: "fas",
    iconName: "snowman",
    icon: [512, 512, [], "f7d0", "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      jm = {
    prefix: "fas",
    iconName: "snowplow",
    icon: [640, 512, [], "f7d2", "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
  },
      Em = {
    prefix: "fas",
    iconName: "soap",
    icon: [512, 512, [], "e06e", "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"]
  },
      km = {
    prefix: "fas",
    iconName: "socks",
    icon: [512, 512, [], "f696", "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"]
  },
      Im = {
    prefix: "fas",
    iconName: "solar-panel",
    icon: [640, 512, [], "f5ba", "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"]
  },
      Om = {
    prefix: "fas",
    iconName: "sort",
    icon: [320, 512, [], "f0dc", "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"]
  },
      Qm = {
    prefix: "fas",
    iconName: "sort-alpha-down",
    icon: [448, 512, [], "f15d", "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"]
  },
      Zm = {
    prefix: "fas",
    iconName: "sort-alpha-down-alt",
    icon: [448, 512, [], "f881", "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"]
  },
      Um = {
    prefix: "fas",
    iconName: "sort-alpha-up",
    icon: [448, 512, [], "f15e", "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"]
  },
      Bm = {
    prefix: "fas",
    iconName: "sort-alpha-up-alt",
    icon: [448, 512, [], "f882", "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"]
  },
      Rm = {
    prefix: "fas",
    iconName: "sort-amount-down",
    icon: [512, 512, [], "f160", "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Ym = {
    prefix: "fas",
    iconName: "sort-amount-down-alt",
    icon: [512, 512, [], "f884", "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"]
  },
      Pm = {
    prefix: "fas",
    iconName: "sort-amount-up",
    icon: [512, 512, [], "f161", "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Fm = {
    prefix: "fas",
    iconName: "sort-amount-up-alt",
    icon: [512, 512, [], "f885", "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"]
  },
      Wm = {
    prefix: "fas",
    iconName: "sort-down",
    icon: [320, 512, [], "f0dd", "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"]
  },
      Gm = {
    prefix: "fas",
    iconName: "sort-numeric-down",
    icon: [448, 512, [], "f162", "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"]
  },
      qm = {
    prefix: "fas",
    iconName: "sort-numeric-down-alt",
    icon: [448, 512, [], "f886", "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"]
  },
      Jm = {
    prefix: "fas",
    iconName: "sort-numeric-up",
    icon: [448, 512, [], "f163", "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"]
  },
      Km = {
    prefix: "fas",
    iconName: "sort-numeric-up-alt",
    icon: [448, 512, [], "f887", "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"]
  },
      Xm = {
    prefix: "fas",
    iconName: "sort-up",
    icon: [320, 512, [], "f0de", "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"]
  },
      _m = {
    prefix: "fas",
    iconName: "spa",
    icon: [576, 512, [], "f5bb", "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"]
  },
      $m = {
    prefix: "fas",
    iconName: "space-shuttle",
    icon: [640, 512, [], "f197", "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"]
  },
      cv = {
    prefix: "fas",
    iconName: "spell-check",
    icon: [576, 512, [], "f891", "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"]
  },
      ev = {
    prefix: "fas",
    iconName: "spider",
    icon: [576, 512, [], "f717", "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"]
  },
      av = {
    prefix: "fas",
    iconName: "spinner",
    icon: [512, 512, [], "f110", "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"]
  },
      nv = {
    prefix: "fas",
    iconName: "splotch",
    icon: [512, 512, [], "f5bc", "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"]
  },
      tv = {
    prefix: "fas",
    iconName: "spray-can",
    icon: [512, 512, [], "f5bd", "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
  },
      rv = {
    prefix: "fas",
    iconName: "square",
    icon: [448, 512, [], "f0c8", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"]
  },
      iv = {
    prefix: "fas",
    iconName: "square-full",
    icon: [512, 512, [], "f45c", "M512 512H0V0h512v512z"]
  },
      ov = {
    prefix: "fas",
    iconName: "square-root-alt",
    icon: [576, 512, [], "f698", "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"]
  },
      lv = {
    prefix: "fas",
    iconName: "stamp",
    icon: [512, 512, [], "f5bf", "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"]
  },
      fv = {
    prefix: "fas",
    iconName: "star",
    icon: [576, 512, [], "f005", "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"]
  },
      sv = {
    prefix: "fas",
    iconName: "star-and-crescent",
    icon: [512, 512, [], "f699", "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"]
  },
      uv = {
    prefix: "fas",
    iconName: "star-half",
    icon: [576, 512, [], "f089", "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"]
  },
      hv = {
    prefix: "fas",
    iconName: "star-half-alt",
    icon: [536, 512, [], "f5c0", "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"]
  },
      mv = {
    prefix: "fas",
    iconName: "star-of-david",
    icon: [464, 512, [], "f69a", "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"]
  },
      vv = {
    prefix: "fas",
    iconName: "star-of-life",
    icon: [480, 512, [], "f621", "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"]
  },
      dv = {
    prefix: "fas",
    iconName: "step-backward",
    icon: [448, 512, [], "f048", "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"]
  },
      Mv = {
    prefix: "fas",
    iconName: "step-forward",
    icon: [448, 512, [], "f051", "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"]
  },
      pv = {
    prefix: "fas",
    iconName: "stethoscope",
    icon: [512, 512, [], "f0f1", "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      zv = {
    prefix: "fas",
    iconName: "sticky-note",
    icon: [448, 512, [], "f249", "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"]
  },
      Cv = {
    prefix: "fas",
    iconName: "stop",
    icon: [448, 512, [], "f04d", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"]
  },
      Lv = {
    prefix: "fas",
    iconName: "stop-circle",
    icon: [512, 512, [], "f28d", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"]
  },
      Av = {
    prefix: "fas",
    iconName: "stopwatch",
    icon: [448, 512, [], "f2f2", "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"]
  },
      Nv = {
    prefix: "fas",
    iconName: "stopwatch-20",
    icon: [448, 512, [], "e06f", "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"]
  },
      gv = {
    prefix: "fas",
    iconName: "store",
    icon: [616, 512, [], "f54e", "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"]
  },
      Hv = {
    prefix: "fas",
    iconName: "store-alt",
    icon: [640, 512, [], "f54f", "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"]
  },
      Vv = {
    prefix: "fas",
    iconName: "store-alt-slash",
    icon: [640, 512, [], "e070", "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"]
  },
      xv = {
    prefix: "fas",
    iconName: "store-slash",
    icon: [640, 512, [], "e071", "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"]
  },
      wv = {
    prefix: "fas",
    iconName: "stream",
    icon: [512, 512, [], "f550", "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"]
  },
      yv = {
    prefix: "fas",
    iconName: "street-view",
    icon: [512, 512, [], "f21d", "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"]
  },
      bv = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"]
  },
      Sv = {
    prefix: "fas",
    iconName: "stroopwafel",
    icon: [512, 512, [], "f551", "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"]
  },
      Tv = {
    prefix: "fas",
    iconName: "subscript",
    icon: [512, 512, [], "f12c", "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"]
  },
      Dv = {
    prefix: "fas",
    iconName: "subway",
    icon: [448, 512, [], "f239", "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"]
  },
      jv = {
    prefix: "fas",
    iconName: "suitcase",
    icon: [512, 512, [], "f0f2", "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"]
  },
      Ev = {
    prefix: "fas",
    iconName: "suitcase-rolling",
    icon: [384, 512, [], "f5c1", "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"]
  },
      kv = {
    prefix: "fas",
    iconName: "sun",
    icon: [512, 512, [], "f185", "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"]
  },
      Iv = {
    prefix: "fas",
    iconName: "superscript",
    icon: [512, 512, [], "f12b", "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"]
  },
      Ov = {
    prefix: "fas",
    iconName: "surprise",
    icon: [496, 512, [], "f5c2", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Qv = {
    prefix: "fas",
    iconName: "swatchbook",
    icon: [512, 512, [], "f5c3", "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"]
  },
      Zv = {
    prefix: "fas",
    iconName: "swimmer",
    icon: [640, 512, [], "f5c4", "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"]
  },
      Uv = {
    prefix: "fas",
    iconName: "swimming-pool",
    icon: [640, 512, [], "f5c5", "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"]
  },
      Bv = {
    prefix: "fas",
    iconName: "synagogue",
    icon: [640, 512, [], "f69b", "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"]
  },
      Rv = {
    prefix: "fas",
    iconName: "sync",
    icon: [512, 512, [], "f021", "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"]
  },
      Yv = {
    prefix: "fas",
    iconName: "sync-alt",
    icon: [512, 512, [], "f2f1", "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"]
  },
      Pv = {
    prefix: "fas",
    iconName: "syringe",
    icon: [512, 512, [], "f48e", "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"]
  },
      Fv = {
    prefix: "fas",
    iconName: "table",
    icon: [512, 512, [], "f0ce", "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"]
  },
      Wv = {
    prefix: "fas",
    iconName: "table-tennis",
    icon: [512, 512, [], "f45d", "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"]
  },
      Gv = {
    prefix: "fas",
    iconName: "tablet",
    icon: [448, 512, [], "f10a", "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      qv = {
    prefix: "fas",
    iconName: "tablet-alt",
    icon: [448, 512, [], "f3fa", "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"]
  },
      Jv = {
    prefix: "fas",
    iconName: "tablets",
    icon: [640, 512, [], "f490", "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"]
  },
      Kv = {
    prefix: "fas",
    iconName: "tachometer-alt",
    icon: [576, 512, [], "f3fd", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Xv = {
    prefix: "fas",
    iconName: "tag",
    icon: [512, 512, [], "f02b", "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"]
  },
      _v = {
    prefix: "fas",
    iconName: "tags",
    icon: [640, 512, [], "f02c", "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"]
  },
      $v = {
    prefix: "fas",
    iconName: "tape",
    icon: [640, 512, [], "f4db", "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"]
  },
      cd = {
    prefix: "fas",
    iconName: "tasks",
    icon: [512, 512, [], "f0ae", "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      ed = {
    prefix: "fas",
    iconName: "taxi",
    icon: [512, 512, [], "f1ba", "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      ad = {
    prefix: "fas",
    iconName: "teeth",
    icon: [640, 512, [], "f62e", "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"]
  },
      nd = {
    prefix: "fas",
    iconName: "teeth-open",
    icon: [640, 512, [], "f62f", "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"]
  },
      td = {
    prefix: "fas",
    iconName: "temperature-high",
    icon: [512, 512, [], "f769", "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"]
  },
      rd = {
    prefix: "fas",
    iconName: "temperature-low",
    icon: [512, 512, [], "f76b", "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"]
  },
      id = {
    prefix: "fas",
    iconName: "tenge",
    icon: [384, 512, [], "f7d7", "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"]
  },
      od = {
    prefix: "fas",
    iconName: "terminal",
    icon: [640, 512, [], "f120", "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"]
  },
      ld = {
    prefix: "fas",
    iconName: "text-height",
    icon: [576, 512, [], "f034", "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"]
  },
      fd = {
    prefix: "fas",
    iconName: "text-width",
    icon: [448, 512, [], "f035", "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"]
  },
      sd = {
    prefix: "fas",
    iconName: "th",
    icon: [512, 512, [], "f00a", "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"]
  },
      ud = {
    prefix: "fas",
    iconName: "th-large",
    icon: [512, 512, [], "f009", "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"]
  },
      hd = {
    prefix: "fas",
    iconName: "th-list",
    icon: [512, 512, [], "f00b", "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"]
  },
      md = {
    prefix: "fas",
    iconName: "theater-masks",
    icon: [640, 512, [], "f630", "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"]
  },
      vd = {
    prefix: "fas",
    iconName: "thermometer",
    icon: [512, 512, [], "f491", "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"]
  },
      dd = {
    prefix: "fas",
    iconName: "thermometer-empty",
    icon: [256, 512, [], "f2cb", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]
  },
      Md = {
    prefix: "fas",
    iconName: "thermometer-full",
    icon: [256, 512, [], "f2c7", "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"]
  },
      pd = {
    prefix: "fas",
    iconName: "thermometer-half",
    icon: [256, 512, [], "f2c9", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]
  },
      zd = {
    prefix: "fas",
    iconName: "thermometer-quarter",
    icon: [256, 512, [], "f2ca", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]
  },
      Cd = {
    prefix: "fas",
    iconName: "thermometer-three-quarters",
    icon: [256, 512, [], "f2c8", "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]
  },
      Ld = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [512, 512, [], "f165", "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"]
  },
      Ad = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [512, 512, [], "f164", "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"]
  },
      Nd = {
    prefix: "fas",
    iconName: "thumbtack",
    icon: [384, 512, [], "f08d", "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"]
  },
      gd = {
    prefix: "fas",
    iconName: "ticket-alt",
    icon: [576, 512, [], "f3ff", "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"]
  },
      Hd = {
    prefix: "fas",
    iconName: "times",
    icon: [352, 512, [], "f00d", "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"]
  },
      Vd = {
    prefix: "fas",
    iconName: "times-circle",
    icon: [512, 512, [], "f057", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"]
  },
      xd = {
    prefix: "fas",
    iconName: "tint",
    icon: [352, 512, [], "f043", "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"]
  },
      wd = {
    prefix: "fas",
    iconName: "tint-slash",
    icon: [640, 512, [], "f5c7", "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"]
  },
      yd = {
    prefix: "fas",
    iconName: "tired",
    icon: [496, 512, [], "f5c8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"]
  },
      bd = {
    prefix: "fas",
    iconName: "toggle-off",
    icon: [576, 512, [], "f204", "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"]
  },
      Sd = {
    prefix: "fas",
    iconName: "toggle-on",
    icon: [576, 512, [], "f205", "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"]
  },
      Td = {
    prefix: "fas",
    iconName: "toilet",
    icon: [384, 512, [], "f7d8", "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"]
  },
      Dd = {
    prefix: "fas",
    iconName: "toilet-paper",
    icon: [576, 512, [], "f71e", "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"]
  },
      jd = {
    prefix: "fas",
    iconName: "toilet-paper-slash",
    icon: [640, 512, [], "e072", "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"]
  },
      Ed = {
    prefix: "fas",
    iconName: "toolbox",
    icon: [512, 512, [], "f552", "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"]
  },
      kd = {
    prefix: "fas",
    iconName: "tools",
    icon: [512, 512, [], "f7d9", "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"]
  },
      Id = {
    prefix: "fas",
    iconName: "tooth",
    icon: [448, 512, [], "f5c9", "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"]
  },
      Od = {
    prefix: "fas",
    iconName: "torah",
    icon: [640, 512, [], "f6a0", "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"]
  },
      Qd = {
    prefix: "fas",
    iconName: "torii-gate",
    icon: [512, 512, [], "f6a1", "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"]
  },
      Zd = {
    prefix: "fas",
    iconName: "tractor",
    icon: [640, 512, [], "f722", "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"]
  },
      Ud = {
    prefix: "fas",
    iconName: "trademark",
    icon: [640, 512, [], "f25c", "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"]
  },
      Bd = {
    prefix: "fas",
    iconName: "traffic-light",
    icon: [384, 512, [], "f637", "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"]
  },
      Rd = {
    prefix: "fas",
    iconName: "trailer",
    icon: [640, 512, [], "e041", "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"]
  },
      Yd = {
    prefix: "fas",
    iconName: "train",
    icon: [448, 512, [], "f238", "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"]
  },
      Pd = {
    prefix: "fas",
    iconName: "tram",
    icon: [512, 512, [], "f7da", "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"]
  },
      Fd = {
    prefix: "fas",
    iconName: "transgender",
    icon: [384, 512, [], "f224", "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      Wd = {
    prefix: "fas",
    iconName: "transgender-alt",
    icon: [480, 512, [], "f225", "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      Gd = {
    prefix: "fas",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"]
  },
      qd = {
    prefix: "fas",
    iconName: "trash-alt",
    icon: [448, 512, [], "f2ed", "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Jd = {
    prefix: "fas",
    iconName: "trash-restore",
    icon: [448, 512, [], "f829", "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Kd = {
    prefix: "fas",
    iconName: "trash-restore-alt",
    icon: [448, 512, [], "f82a", "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Xd = {
    prefix: "fas",
    iconName: "tree",
    icon: [384, 512, [], "f1bb", "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"]
  },
      _d = {
    prefix: "fas",
    iconName: "trophy",
    icon: [576, 512, [], "f091", "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"]
  },
      $d = {
    prefix: "fas",
    iconName: "truck",
    icon: [640, 512, [], "f0d1", "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"]
  },
      cM = {
    prefix: "fas",
    iconName: "truck-loading",
    icon: [640, 512, [], "f4de", "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      eM = {
    prefix: "fas",
    iconName: "truck-monster",
    icon: [640, 512, [], "f63b", "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"]
  },
      aM = {
    prefix: "fas",
    iconName: "truck-moving",
    icon: [640, 512, [], "f4df", "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"]
  },
      nM = {
    prefix: "fas",
    iconName: "truck-pickup",
    icon: [640, 512, [], "f63c", "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"]
  },
      tM = {
    prefix: "fas",
    iconName: "tshirt",
    icon: [640, 512, [], "f553", "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"]
  },
      rM = {
    prefix: "fas",
    iconName: "tty",
    icon: [512, 512, [], "f1e4", "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"]
  },
      iM = {
    prefix: "fas",
    iconName: "tv",
    icon: [640, 512, [], "f26c", "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"]
  },
      oM = {
    prefix: "fas",
    iconName: "umbrella",
    icon: [576, 512, [], "f0e9", "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"]
  },
      lM = {
    prefix: "fas",
    iconName: "umbrella-beach",
    icon: [640, 512, [], "f5ca", "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"]
  },
      fM = {
    prefix: "fas",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      sM = {
    prefix: "fas",
    iconName: "undo",
    icon: [512, 512, [], "f0e2", "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"]
  },
      uM = {
    prefix: "fas",
    iconName: "undo-alt",
    icon: [512, 512, [], "f2ea", "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"]
  },
      hM = {
    prefix: "fas",
    iconName: "universal-access",
    icon: [512, 512, [], "f29a", "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"]
  },
      mM = {
    prefix: "fas",
    iconName: "university",
    icon: [512, 512, [], "f19c", "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"]
  },
      vM = {
    prefix: "fas",
    iconName: "unlink",
    icon: [512, 512, [], "f127", "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"]
  },
      dM = {
    prefix: "fas",
    iconName: "unlock",
    icon: [448, 512, [], "f09c", "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"]
  },
      MM = {
    prefix: "fas",
    iconName: "unlock-alt",
    icon: [448, 512, [], "f13e", "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"]
  },
      pM = {
    prefix: "fas",
    iconName: "upload",
    icon: [512, 512, [], "f093", "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"]
  },
      zM = {
    prefix: "fas",
    iconName: "user",
    icon: [448, 512, [], "f007", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"]
  },
      CM = {
    prefix: "fas",
    iconName: "user-alt",
    icon: [512, 512, [], "f406", "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"]
  },
      LM = {
    prefix: "fas",
    iconName: "user-alt-slash",
    icon: [640, 512, [], "f4fa", "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"]
  },
      AM = {
    prefix: "fas",
    iconName: "user-astronaut",
    icon: [448, 512, [], "f4fb", "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"]
  },
      NM = {
    prefix: "fas",
    iconName: "user-check",
    icon: [640, 512, [], "f4fc", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"]
  },
      gM = {
    prefix: "fas",
    iconName: "user-circle",
    icon: [496, 512, [], "f2bd", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"]
  },
      HM = {
    prefix: "fas",
    iconName: "user-clock",
    icon: [640, 512, [], "f4fd", "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"]
  },
      VM = {
    prefix: "fas",
    iconName: "user-cog",
    icon: [640, 512, [], "f4fe", "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"]
  },
      xM = {
    prefix: "fas",
    iconName: "user-edit",
    icon: [640, 512, [], "f4ff", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"]
  },
      wM = {
    prefix: "fas",
    iconName: "user-friends",
    icon: [640, 512, [], "f500", "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"]
  },
      yM = {
    prefix: "fas",
    iconName: "user-graduate",
    icon: [448, 512, [], "f501", "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"]
  },
      bM = {
    prefix: "fas",
    iconName: "user-injured",
    icon: [448, 512, [], "f728", "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"]
  },
      SM = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [640, 512, [], "f502", "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"]
  },
      TM = {
    prefix: "fas",
    iconName: "user-md",
    icon: [448, 512, [], "f0f0", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"]
  },
      DM = {
    prefix: "fas",
    iconName: "user-minus",
    icon: [640, 512, [], "f503", "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"]
  },
      jM = {
    prefix: "fas",
    iconName: "user-ninja",
    icon: [448, 512, [], "f504", "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"]
  },
      EM = {
    prefix: "fas",
    iconName: "user-nurse",
    icon: [448, 512, [], "f82f", "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"]
  },
      kM = {
    prefix: "fas",
    iconName: "user-plus",
    icon: [640, 512, [], "f234", "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"]
  },
      IM = {
    prefix: "fas",
    iconName: "user-secret",
    icon: [448, 512, [], "f21b", "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"]
  },
      OM = {
    prefix: "fas",
    iconName: "user-shield",
    icon: [640, 512, [], "f505", "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"]
  },
      QM = {
    prefix: "fas",
    iconName: "user-slash",
    icon: [640, 512, [], "f506", "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"]
  },
      ZM = {
    prefix: "fas",
    iconName: "user-tag",
    icon: [640, 512, [], "f507", "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"]
  },
      UM = {
    prefix: "fas",
    iconName: "user-tie",
    icon: [448, 512, [], "f508", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"]
  },
      BM = {
    prefix: "fas",
    iconName: "user-times",
    icon: [640, 512, [], "f235", "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"]
  },
      RM = {
    prefix: "fas",
    iconName: "users",
    icon: [640, 512, [], "f0c0", "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"]
  },
      YM = {
    prefix: "fas",
    iconName: "users-cog",
    icon: [640, 512, [], "f509", "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"]
  },
      PM = {
    prefix: "fas",
    iconName: "users-slash",
    icon: [640, 512, [], "e073", "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"]
  },
      FM = {
    prefix: "fas",
    iconName: "utensil-spoon",
    icon: [512, 512, [], "f2e5", "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"]
  },
      WM = {
    prefix: "fas",
    iconName: "utensils",
    icon: [416, 512, [], "f2e7", "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"]
  },
      GM = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [512, 512, [], "f5cb", "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"]
  },
      qM = {
    prefix: "fas",
    iconName: "venus",
    icon: [288, 512, [], "f221", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"]
  },
      JM = {
    prefix: "fas",
    iconName: "venus-double",
    icon: [512, 512, [], "f226", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"]
  },
      KM = {
    prefix: "fas",
    iconName: "venus-mars",
    icon: [576, 512, [], "f228", "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      XM = {
    prefix: "fas",
    iconName: "vest",
    icon: [448, 512, [], "e085", "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"]
  },
      _M = {
    prefix: "fas",
    iconName: "vest-patches",
    icon: [448, 512, [], "e086", "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"]
  },
      $M = {
    prefix: "fas",
    iconName: "vial",
    icon: [480, 512, [], "f492", "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"]
  },
      cp = {
    prefix: "fas",
    iconName: "vials",
    icon: [640, 512, [], "f493", "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"]
  },
      ep = {
    prefix: "fas",
    iconName: "video",
    icon: [576, 512, [], "f03d", "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"]
  },
      ap = {
    prefix: "fas",
    iconName: "video-slash",
    icon: [640, 512, [], "f4e2", "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"]
  },
      np = {
    prefix: "fas",
    iconName: "vihara",
    icon: [640, 512, [], "f6a7", "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"]
  },
      tp = {
    prefix: "fas",
    iconName: "virus",
    icon: [512, 512, [], "e074", "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"]
  },
      rp = {
    prefix: "fas",
    iconName: "virus-slash",
    icon: [640, 512, [], "e075", "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"]
  },
      ip = {
    prefix: "fas",
    iconName: "viruses",
    icon: [640, 512, [], "e076", "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"]
  },
      op = {
    prefix: "fas",
    iconName: "voicemail",
    icon: [640, 512, [], "f897", "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"]
  },
      lp = {
    prefix: "fas",
    iconName: "volleyball-ball",
    icon: [512, 512, [], "f45f", "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"]
  },
      fp = {
    prefix: "fas",
    iconName: "volume-down",
    icon: [384, 512, [], "f027", "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"]
  },
      sp = {
    prefix: "fas",
    iconName: "volume-mute",
    icon: [512, 512, [], "f6a9", "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"]
  },
      up = {
    prefix: "fas",
    iconName: "volume-off",
    icon: [256, 512, [], "f026", "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"]
  },
      hp = {
    prefix: "fas",
    iconName: "volume-up",
    icon: [576, 512, [], "f028", "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"]
  },
      mp = {
    prefix: "fas",
    iconName: "vote-yea",
    icon: [640, 512, [], "f772", "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"]
  },
      vp = {
    prefix: "fas",
    iconName: "vr-cardboard",
    icon: [640, 512, [], "f729", "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"]
  },
      dp = {
    prefix: "fas",
    iconName: "walking",
    icon: [320, 512, [], "f554", "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"]
  },
      Mp = {
    prefix: "fas",
    iconName: "wallet",
    icon: [512, 512, [], "f555", "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      pp = {
    prefix: "fas",
    iconName: "warehouse",
    icon: [640, 512, [], "f494", "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"]
  },
      zp = {
    prefix: "fas",
    iconName: "water",
    icon: [576, 512, [], "f773", "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"]
  },
      Cp = {
    prefix: "fas",
    iconName: "wave-square",
    icon: [640, 512, [], "f83e", "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"]
  },
      Lp = {
    prefix: "fas",
    iconName: "weight",
    icon: [512, 512, [], "f496", "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"]
  },
      Ap = {
    prefix: "fas",
    iconName: "weight-hanging",
    icon: [512, 512, [], "f5cd", "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"]
  },
      Np = {
    prefix: "fas",
    iconName: "wheelchair",
    icon: [512, 512, [], "f193", "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"]
  },
      gp = {
    prefix: "fas",
    iconName: "wifi",
    icon: [640, 512, [], "f1eb", "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"]
  },
      Hp = {
    prefix: "fas",
    iconName: "wind",
    icon: [512, 512, [], "f72e", "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"]
  },
      Vp = {
    prefix: "fas",
    iconName: "window-close",
    icon: [512, 512, [], "f410", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"]
  },
      xp = {
    prefix: "fas",
    iconName: "window-maximize",
    icon: [512, 512, [], "f2d0", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"]
  },
      wp = {
    prefix: "fas",
    iconName: "window-minimize",
    icon: [512, 512, [], "f2d1", "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"]
  },
      yp = {
    prefix: "fas",
    iconName: "window-restore",
    icon: [512, 512, [], "f2d2", "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"]
  },
      bp = {
    prefix: "fas",
    iconName: "wine-bottle",
    icon: [512, 512, [], "f72f", "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"]
  },
      Sp = {
    prefix: "fas",
    iconName: "wine-glass",
    icon: [288, 512, [], "f4e3", "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"]
  },
      Tp = {
    prefix: "fas",
    iconName: "wine-glass-alt",
    icon: [288, 512, [], "f5ce", "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"]
  },
      Dp = {
    prefix: "fas",
    iconName: "won-sign",
    icon: [576, 512, [], "f159", "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"]
  },
      jp = {
    prefix: "fas",
    iconName: "wrench",
    icon: [512, 512, [], "f0ad", "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
  },
      Ep = {
    prefix: "fas",
    iconName: "x-ray",
    icon: [640, 512, [], "f497", "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"]
  },
      kp = {
    prefix: "fas",
    iconName: "yen-sign",
    icon: [384, 512, [], "f157", "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"]
  },
      Ip = {
    prefix: "fas",
    iconName: "yin-yang",
    icon: [496, 512, [], "f6ad", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
  },
      Op = {
    faAd: t,
    faAddressBook: r,
    faAddressCard: i,
    faAdjust: o,
    faAirFreshener: l,
    faAlignCenter: f,
    faAlignJustify: s,
    faAlignLeft: u,
    faAlignRight: h,
    faAllergies: m,
    faAmbulance: v,
    faAmericanSignLanguageInterpreting: d,
    faAnchor: M,
    faAngleDoubleDown: p,
    faAngleDoubleLeft: z,
    faAngleDoubleRight: C,
    faAngleDoubleUp: L,
    faAngleDown: A,
    faAngleLeft: N,
    faAngleRight: g,
    faAngleUp: H,
    faAngry: V,
    faAnkh: x,
    faAppleAlt: w,
    faArchive: y,
    faArchway: b,
    faArrowAltCircleDown: S,
    faArrowAltCircleLeft: T,
    faArrowAltCircleRight: D,
    faArrowAltCircleUp: j,
    faArrowCircleDown: E,
    faArrowCircleLeft: k,
    faArrowCircleRight: I,
    faArrowCircleUp: O,
    faArrowDown: Q,
    faArrowLeft: Z,
    faArrowRight: U,
    faArrowUp: B,
    faArrowsAlt: R,
    faArrowsAltH: Y,
    faArrowsAltV: P,
    faAssistiveListeningSystems: F,
    faAsterisk: W,
    faAt: G,
    faAtlas: q,
    faAtom: J,
    faAudioDescription: K,
    faAward: X,
    faBaby: _,
    faBabyCarriage: $,
    faBackspace: cc,
    faBackward: ec,
    faBacon: ac,
    faBacteria: nc,
    faBacterium: tc,
    faBahai: rc,
    faBalanceScale: ic,
    faBalanceScaleLeft: oc,
    faBalanceScaleRight: lc,
    faBan: fc,
    faBandAid: sc,
    faBarcode: uc,
    faBars: hc,
    faBaseballBall: mc,
    faBasketballBall: vc,
    faBath: dc,
    faBatteryEmpty: Mc,
    faBatteryFull: pc,
    faBatteryHalf: zc,
    faBatteryQuarter: Cc,
    faBatteryThreeQuarters: Lc,
    faBed: Ac,
    faBeer: Nc,
    faBell: gc,
    faBellSlash: Hc,
    faBezierCurve: Vc,
    faBible: xc,
    faBicycle: wc,
    faBiking: yc,
    faBinoculars: bc,
    faBiohazard: Sc,
    faBirthdayCake: Tc,
    faBlender: Dc,
    faBlenderPhone: jc,
    faBlind: Ec,
    faBlog: kc,
    faBold: Ic,
    faBolt: Oc,
    faBomb: Qc,
    faBone: Zc,
    faBong: Uc,
    faBook: Bc,
    faBookDead: Rc,
    faBookMedical: Yc,
    faBookOpen: Pc,
    faBookReader: Fc,
    faBookmark: Wc,
    faBorderAll: Gc,
    faBorderNone: qc,
    faBorderStyle: Jc,
    faBowlingBall: Kc,
    faBox: Xc,
    faBoxOpen: _c,
    faBoxTissue: $c,
    faBoxes: ce,
    faBraille: ee,
    faBrain: ae,
    faBreadSlice: ne,
    faBriefcase: te,
    faBriefcaseMedical: re,
    faBroadcastTower: ie,
    faBroom: oe,
    faBrush: le,
    faBug: fe,
    faBuilding: se,
    faBullhorn: ue,
    faBullseye: he,
    faBurn: me,
    faBus: ve,
    faBusAlt: de,
    faBusinessTime: Me,
    faCalculator: pe,
    faCalendar: ze,
    faCalendarAlt: Ce,
    faCalendarCheck: Le,
    faCalendarDay: Ae,
    faCalendarMinus: Ne,
    faCalendarPlus: ge,
    faCalendarTimes: He,
    faCalendarWeek: Ve,
    faCamera: xe,
    faCameraRetro: we,
    faCampground: ye,
    faCandyCane: be,
    faCannabis: Se,
    faCapsules: Te,
    faCar: De,
    faCarAlt: je,
    faCarBattery: Ee,
    faCarCrash: ke,
    faCarSide: Ie,
    faCaravan: Oe,
    faCaretDown: Qe,
    faCaretLeft: Ze,
    faCaretRight: Ue,
    faCaretSquareDown: Be,
    faCaretSquareLeft: Re,
    faCaretSquareRight: Ye,
    faCaretSquareUp: Pe,
    faCaretUp: Fe,
    faCarrot: We,
    faCartArrowDown: Ge,
    faCartPlus: qe,
    faCashRegister: Je,
    faCat: Ke,
    faCertificate: Xe,
    faChair: _e,
    faChalkboard: $e,
    faChalkboardTeacher: ca,
    faChargingStation: ea,
    faChartArea: aa,
    faChartBar: na,
    faChartLine: ta,
    faChartPie: ra,
    faCheck: ia,
    faCheckCircle: oa,
    faCheckDouble: la,
    faCheckSquare: fa,
    faCheese: sa,
    faChess: ua,
    faChessBishop: ha,
    faChessBoard: ma,
    faChessKing: va,
    faChessKnight: da,
    faChessPawn: Ma,
    faChessQueen: pa,
    faChessRook: za,
    faChevronCircleDown: Ca,
    faChevronCircleLeft: La,
    faChevronCircleRight: Aa,
    faChevronCircleUp: Na,
    faChevronDown: ga,
    faChevronLeft: Ha,
    faChevronRight: Va,
    faChevronUp: xa,
    faChild: wa,
    faChurch: ya,
    faCircle: ba,
    faCircleNotch: Sa,
    faCity: Ta,
    faClinicMedical: Da,
    faClipboard: ja,
    faClipboardCheck: Ea,
    faClipboardList: ka,
    faClock: Ia,
    faClone: Oa,
    faClosedCaptioning: Qa,
    faCloud: Za,
    faCloudDownloadAlt: Ua,
    faCloudMeatball: Ba,
    faCloudMoon: Ra,
    faCloudMoonRain: Ya,
    faCloudRain: Pa,
    faCloudShowersHeavy: Fa,
    faCloudSun: Wa,
    faCloudSunRain: Ga,
    faCloudUploadAlt: qa,
    faCocktail: Ja,
    faCode: Ka,
    faCodeBranch: Xa,
    faCoffee: _a,
    faCog: $a,
    faCogs: cn,
    faCoins: en,
    faColumns: an,
    faComment: nn,
    faCommentAlt: tn,
    faCommentDollar: rn,
    faCommentDots: on,
    faCommentMedical: ln,
    faCommentSlash: fn,
    faComments: sn,
    faCommentsDollar: un,
    faCompactDisc: hn,
    faCompass: mn,
    faCompress: vn,
    faCompressAlt: dn,
    faCompressArrowsAlt: Mn,
    faConciergeBell: pn,
    faCookie: zn,
    faCookieBite: Cn,
    faCopy: Ln,
    faCopyright: An,
    faCouch: Nn,
    faCreditCard: gn,
    faCrop: Hn,
    faCropAlt: Vn,
    faCross: xn,
    faCrosshairs: wn,
    faCrow: yn,
    faCrown: bn,
    faCrutch: Sn,
    faCube: Tn,
    faCubes: Dn,
    faCut: jn,
    faDatabase: En,
    faDeaf: kn,
    faDemocrat: In,
    faDesktop: On,
    faDharmachakra: Qn,
    faDiagnoses: Zn,
    faDice: Un,
    faDiceD20: Bn,
    faDiceD6: Rn,
    faDiceFive: Yn,
    faDiceFour: Pn,
    faDiceOne: Fn,
    faDiceSix: Wn,
    faDiceThree: Gn,
    faDiceTwo: qn,
    faDigitalTachograph: Jn,
    faDirections: Kn,
    faDisease: Xn,
    faDivide: _n,
    faDizzy: $n,
    faDna: ct,
    faDog: et,
    faDollarSign: at,
    faDolly: nt,
    faDollyFlatbed: tt,
    faDonate: rt,
    faDoorClosed: it,
    faDoorOpen: ot,
    faDotCircle: lt,
    faDove: ft,
    faDownload: st,
    faDraftingCompass: ut,
    faDragon: ht,
    faDrawPolygon: mt,
    faDrum: vt,
    faDrumSteelpan: dt,
    faDrumstickBite: Mt,
    faDumbbell: pt,
    faDumpster: zt,
    faDumpsterFire: Ct,
    faDungeon: Lt,
    faEdit: At,
    faEgg: Nt,
    faEject: gt,
    faEllipsisH: Ht,
    faEllipsisV: Vt,
    faEnvelope: xt,
    faEnvelopeOpen: wt,
    faEnvelopeOpenText: yt,
    faEnvelopeSquare: bt,
    faEquals: St,
    faEraser: Tt,
    faEthernet: Dt,
    faEuroSign: jt,
    faExchangeAlt: Et,
    faExclamation: kt,
    faExclamationCircle: It,
    faExclamationTriangle: Ot,
    faExpand: Qt,
    faExpandAlt: Zt,
    faExpandArrowsAlt: Ut,
    faExternalLinkAlt: Bt,
    faExternalLinkSquareAlt: Rt,
    faEye: Yt,
    faEyeDropper: Pt,
    faEyeSlash: Ft,
    faFan: Wt,
    faFastBackward: Gt,
    faFastForward: qt,
    faFaucet: Jt,
    faFax: Kt,
    faFeather: Xt,
    faFeatherAlt: _t,
    faFemale: $t,
    faFighterJet: cr,
    faFile: er,
    faFileAlt: ar,
    faFileArchive: nr,
    faFileAudio: tr,
    faFileCode: rr,
    faFileContract: ir,
    faFileCsv: or,
    faFileDownload: lr,
    faFileExcel: fr,
    faFileExport: sr,
    faFileImage: ur,
    faFileImport: hr,
    faFileInvoice: mr,
    faFileInvoiceDollar: vr,
    faFileMedical: dr,
    faFileMedicalAlt: Mr,
    faFilePdf: pr,
    faFilePowerpoint: zr,
    faFilePrescription: Cr,
    faFileSignature: Lr,
    faFileUpload: Ar,
    faFileVideo: Nr,
    faFileWord: gr,
    faFill: Hr,
    faFillDrip: Vr,
    faFilm: xr,
    faFilter: wr,
    faFingerprint: yr,
    faFire: br,
    faFireAlt: Sr,
    faFireExtinguisher: Tr,
    faFirstAid: Dr,
    faFish: jr,
    faFistRaised: Er,
    faFlag: kr,
    faFlagCheckered: Ir,
    faFlagUsa: Or,
    faFlask: Qr,
    faFlushed: Zr,
    faFolder: Ur,
    faFolderMinus: Br,
    faFolderOpen: Rr,
    faFolderPlus: Yr,
    faFont: Pr,
    faFontAwesomeLogoFull: Fr,
    faFootballBall: Wr,
    faForward: Gr,
    faFrog: qr,
    faFrown: Jr,
    faFrownOpen: Kr,
    faFunnelDollar: Xr,
    faFutbol: _r,
    faGamepad: $r,
    faGasPump: ci,
    faGavel: ei,
    faGem: ai,
    faGenderless: ni,
    faGhost: ti,
    faGift: ri,
    faGifts: ii,
    faGlassCheers: oi,
    faGlassMartini: li,
    faGlassMartiniAlt: fi,
    faGlassWhiskey: si,
    faGlasses: ui,
    faGlobe: hi,
    faGlobeAfrica: mi,
    faGlobeAmericas: vi,
    faGlobeAsia: di,
    faGlobeEurope: Mi,
    faGolfBall: pi,
    faGopuram: zi,
    faGraduationCap: Ci,
    faGreaterThan: Li,
    faGreaterThanEqual: Ai,
    faGrimace: Ni,
    faGrin: gi,
    faGrinAlt: Hi,
    faGrinBeam: Vi,
    faGrinBeamSweat: xi,
    faGrinHearts: wi,
    faGrinSquint: yi,
    faGrinSquintTears: bi,
    faGrinStars: Si,
    faGrinTears: Ti,
    faGrinTongue: Di,
    faGrinTongueSquint: ji,
    faGrinTongueWink: Ei,
    faGrinWink: ki,
    faGripHorizontal: Ii,
    faGripLines: Oi,
    faGripLinesVertical: Qi,
    faGripVertical: Zi,
    faGuitar: Ui,
    faHSquare: Bi,
    faHamburger: Ri,
    faHammer: Yi,
    faHamsa: Pi,
    faHandHolding: Fi,
    faHandHoldingHeart: Wi,
    faHandHoldingMedical: Gi,
    faHandHoldingUsd: qi,
    faHandHoldingWater: Ji,
    faHandLizard: Ki,
    faHandMiddleFinger: Xi,
    faHandPaper: _i,
    faHandPeace: $i,
    faHandPointDown: co,
    faHandPointLeft: eo,
    faHandPointRight: ao,
    faHandPointUp: no,
    faHandPointer: to,
    faHandRock: ro,
    faHandScissors: io,
    faHandSparkles: oo,
    faHandSpock: lo,
    faHands: fo,
    faHandsHelping: so,
    faHandsWash: uo,
    faHandshake: ho,
    faHandshakeAltSlash: mo,
    faHandshakeSlash: vo,
    faHanukiah: Mo,
    faHardHat: po,
    faHashtag: zo,
    faHatCowboy: Co,
    faHatCowboySide: Lo,
    faHatWizard: Ao,
    faHdd: No,
    faHeadSideCough: go,
    faHeadSideCoughSlash: Ho,
    faHeadSideMask: Vo,
    faHeadSideVirus: xo,
    faHeading: wo,
    faHeadphones: yo,
    faHeadphonesAlt: bo,
    faHeadset: So,
    faHeart: To,
    faHeartBroken: Do,
    faHeartbeat: jo,
    faHelicopter: Eo,
    faHighlighter: ko,
    faHiking: Io,
    faHippo: Oo,
    faHistory: Qo,
    faHockeyPuck: Zo,
    faHollyBerry: Uo,
    faHome: Bo,
    faHorse: Ro,
    faHorseHead: Yo,
    faHospital: Po,
    faHospitalAlt: Fo,
    faHospitalSymbol: Wo,
    faHospitalUser: Go,
    faHotTub: qo,
    faHotdog: Jo,
    faHotel: Ko,
    faHourglass: Xo,
    faHourglassEnd: _o,
    faHourglassHalf: $o,
    faHourglassStart: cl,
    faHouseDamage: el,
    faHouseUser: al,
    faHryvnia: nl,
    faICursor: tl,
    faIceCream: rl,
    faIcicles: il,
    faIcons: ol,
    faIdBadge: ll,
    faIdCard: fl,
    faIdCardAlt: sl,
    faIgloo: ul,
    faImage: hl,
    faImages: ml,
    faInbox: vl,
    faIndent: dl,
    faIndustry: Ml,
    faInfinity: pl,
    faInfo: zl,
    faInfoCircle: Cl,
    faItalic: Ll,
    faJedi: Al,
    faJoint: Nl,
    faJournalWhills: gl,
    faKaaba: Hl,
    faKey: Vl,
    faKeyboard: xl,
    faKhanda: wl,
    faKiss: yl,
    faKissBeam: bl,
    faKissWinkHeart: Sl,
    faKiwiBird: Tl,
    faLandmark: Dl,
    faLanguage: jl,
    faLaptop: El,
    faLaptopCode: kl,
    faLaptopHouse: Il,
    faLaptopMedical: Ol,
    faLaugh: Ql,
    faLaughBeam: Zl,
    faLaughSquint: Ul,
    faLaughWink: Bl,
    faLayerGroup: Rl,
    faLeaf: Yl,
    faLemon: Pl,
    faLessThan: Fl,
    faLessThanEqual: Wl,
    faLevelDownAlt: Gl,
    faLevelUpAlt: ql,
    faLifeRing: Jl,
    faLightbulb: Kl,
    faLink: Xl,
    faLiraSign: _l,
    faList: $l,
    faListAlt: cf,
    faListOl: ef,
    faListUl: af,
    faLocationArrow: nf,
    faLock: tf,
    faLockOpen: rf,
    faLongArrowAltDown: of,
    faLongArrowAltLeft: lf,
    faLongArrowAltRight: ff,
    faLongArrowAltUp: sf,
    faLowVision: uf,
    faLuggageCart: hf,
    faLungs: mf,
    faLungsVirus: vf,
    faMagic: df,
    faMagnet: Mf,
    faMailBulk: pf,
    faMale: zf,
    faMap: Cf,
    faMapMarked: Lf,
    faMapMarkedAlt: Af,
    faMapMarker: Nf,
    faMapMarkerAlt: gf,
    faMapPin: Hf,
    faMapSigns: Vf,
    faMarker: xf,
    faMars: wf,
    faMarsDouble: yf,
    faMarsStroke: bf,
    faMarsStrokeH: Sf,
    faMarsStrokeV: Tf,
    faMask: Df,
    faMedal: jf,
    faMedkit: Ef,
    faMeh: kf,
    faMehBlank: If,
    faMehRollingEyes: Of,
    faMemory: Qf,
    faMenorah: Zf,
    faMercury: Uf,
    faMeteor: Bf,
    faMicrochip: Rf,
    faMicrophone: Yf,
    faMicrophoneAlt: Pf,
    faMicrophoneAltSlash: Ff,
    faMicrophoneSlash: Wf,
    faMicroscope: Gf,
    faMinus: qf,
    faMinusCircle: Jf,
    faMinusSquare: Kf,
    faMitten: Xf,
    faMobile: _f,
    faMobileAlt: $f,
    faMoneyBill: cs,
    faMoneyBillAlt: es,
    faMoneyBillWave: as,
    faMoneyBillWaveAlt: ns,
    faMoneyCheck: ts,
    faMoneyCheckAlt: rs,
    faMonument: is,
    faMoon: os,
    faMortarPestle: ls,
    faMosque: fs,
    faMotorcycle: ss,
    faMountain: us,
    faMouse: hs,
    faMousePointer: ms,
    faMugHot: vs,
    faMusic: ds,
    faNetworkWired: Ms,
    faNeuter: ps,
    faNewspaper: zs,
    faNotEqual: Cs,
    faNotesMedical: Ls,
    faObjectGroup: As,
    faObjectUngroup: Ns,
    faOilCan: gs,
    faOm: Hs,
    faOtter: Vs,
    faOutdent: xs,
    faPager: ws,
    faPaintBrush: ys,
    faPaintRoller: bs,
    faPalette: Ss,
    faPallet: Ts,
    faPaperPlane: Ds,
    faPaperclip: js,
    faParachuteBox: Es,
    faParagraph: ks,
    faParking: Is,
    faPassport: Os,
    faPastafarianism: Qs,
    faPaste: Zs,
    faPause: Us,
    faPauseCircle: Bs,
    faPaw: Rs,
    faPeace: Ys,
    faPen: Ps,
    faPenAlt: Fs,
    faPenFancy: Ws,
    faPenNib: Gs,
    faPenSquare: qs,
    faPencilAlt: Js,
    faPencilRuler: Ks,
    faPeopleArrows: Xs,
    faPeopleCarry: _s,
    faPepperHot: $s,
    faPercent: cu,
    faPercentage: eu,
    faPersonBooth: au,
    faPhone: nu,
    faPhoneAlt: tu,
    faPhoneSlash: ru,
    faPhoneSquare: iu,
    faPhoneSquareAlt: ou,
    faPhoneVolume: lu,
    faPhotoVideo: fu,
    faPiggyBank: su,
    faPills: uu,
    faPizzaSlice: hu,
    faPlaceOfWorship: mu,
    faPlane: vu,
    faPlaneArrival: du,
    faPlaneDeparture: Mu,
    faPlaneSlash: pu,
    faPlay: zu,
    faPlayCircle: Cu,
    faPlug: Lu,
    faPlus: Au,
    faPlusCircle: Nu,
    faPlusSquare: gu,
    faPodcast: Hu,
    faPoll: Vu,
    faPollH: xu,
    faPoo: wu,
    faPooStorm: yu,
    faPoop: bu,
    faPortrait: Su,
    faPoundSign: Tu,
    faPowerOff: Du,
    faPray: ju,
    faPrayingHands: Eu,
    faPrescription: ku,
    faPrescriptionBottle: Iu,
    faPrescriptionBottleAlt: Ou,
    faPrint: Qu,
    faProcedures: Zu,
    faProjectDiagram: Uu,
    faPumpMedical: Bu,
    faPumpSoap: Ru,
    faPuzzlePiece: Yu,
    faQrcode: Pu,
    faQuestion: Fu,
    faQuestionCircle: Wu,
    faQuidditch: Gu,
    faQuoteLeft: qu,
    faQuoteRight: Ju,
    faQuran: Ku,
    faRadiation: Xu,
    faRadiationAlt: _u,
    faRainbow: $u,
    faRandom: ch,
    faReceipt: eh,
    faRecordVinyl: ah,
    faRecycle: nh,
    faRedo: th,
    faRedoAlt: rh,
    faRegistered: ih,
    faRemoveFormat: oh,
    faReply: lh,
    faReplyAll: fh,
    faRepublican: sh,
    faRestroom: uh,
    faRetweet: hh,
    faRibbon: mh,
    faRing: vh,
    faRoad: dh,
    faRobot: Mh,
    faRocket: ph,
    faRoute: zh,
    faRss: Ch,
    faRssSquare: Lh,
    faRubleSign: Ah,
    faRuler: Nh,
    faRulerCombined: gh,
    faRulerHorizontal: Hh,
    faRulerVertical: Vh,
    faRunning: xh,
    faRupeeSign: wh,
    faSadCry: yh,
    faSadTear: bh,
    faSatellite: Sh,
    faSatelliteDish: Th,
    faSave: Dh,
    faSchool: jh,
    faScrewdriver: Eh,
    faScroll: kh,
    faSdCard: Ih,
    faSearch: Oh,
    faSearchDollar: Qh,
    faSearchLocation: Zh,
    faSearchMinus: Uh,
    faSearchPlus: Bh,
    faSeedling: Rh,
    faServer: Yh,
    faShapes: Ph,
    faShare: Fh,
    faShareAlt: Wh,
    faShareAltSquare: Gh,
    faShareSquare: qh,
    faShekelSign: Jh,
    faShieldAlt: Kh,
    faShieldVirus: Xh,
    faShip: _h,
    faShippingFast: $h,
    faShoePrints: cm,
    faShoppingBag: em,
    faShoppingBasket: am,
    faShoppingCart: nm,
    faShower: tm,
    faShuttleVan: rm,
    faSign: im,
    faSignInAlt: om,
    faSignLanguage: lm,
    faSignOutAlt: fm,
    faSignal: sm,
    faSignature: um,
    faSimCard: hm,
    faSink: mm,
    faSitemap: vm,
    faSkating: dm,
    faSkiing: Mm,
    faSkiingNordic: pm,
    faSkull: zm,
    faSkullCrossbones: Cm,
    faSlash: Lm,
    faSleigh: Am,
    faSlidersH: Nm,
    faSmile: gm,
    faSmileBeam: Hm,
    faSmileWink: Vm,
    faSmog: xm,
    faSmoking: wm,
    faSmokingBan: ym,
    faSms: bm,
    faSnowboarding: Sm,
    faSnowflake: Tm,
    faSnowman: Dm,
    faSnowplow: jm,
    faSoap: Em,
    faSocks: km,
    faSolarPanel: Im,
    faSort: Om,
    faSortAlphaDown: Qm,
    faSortAlphaDownAlt: Zm,
    faSortAlphaUp: Um,
    faSortAlphaUpAlt: Bm,
    faSortAmountDown: Rm,
    faSortAmountDownAlt: Ym,
    faSortAmountUp: Pm,
    faSortAmountUpAlt: Fm,
    faSortDown: Wm,
    faSortNumericDown: Gm,
    faSortNumericDownAlt: qm,
    faSortNumericUp: Jm,
    faSortNumericUpAlt: Km,
    faSortUp: Xm,
    faSpa: _m,
    faSpaceShuttle: $m,
    faSpellCheck: cv,
    faSpider: ev,
    faSpinner: av,
    faSplotch: nv,
    faSprayCan: tv,
    faSquare: rv,
    faSquareFull: iv,
    faSquareRootAlt: ov,
    faStamp: lv,
    faStar: fv,
    faStarAndCrescent: sv,
    faStarHalf: uv,
    faStarHalfAlt: hv,
    faStarOfDavid: mv,
    faStarOfLife: vv,
    faStepBackward: dv,
    faStepForward: Mv,
    faStethoscope: pv,
    faStickyNote: zv,
    faStop: Cv,
    faStopCircle: Lv,
    faStopwatch: Av,
    faStopwatch20: Nv,
    faStore: gv,
    faStoreAlt: Hv,
    faStoreAltSlash: Vv,
    faStoreSlash: xv,
    faStream: wv,
    faStreetView: yv,
    faStrikethrough: bv,
    faStroopwafel: Sv,
    faSubscript: Tv,
    faSubway: Dv,
    faSuitcase: jv,
    faSuitcaseRolling: Ev,
    faSun: kv,
    faSuperscript: Iv,
    faSurprise: Ov,
    faSwatchbook: Qv,
    faSwimmer: Zv,
    faSwimmingPool: Uv,
    faSynagogue: Bv,
    faSync: Rv,
    faSyncAlt: Yv,
    faSyringe: Pv,
    faTable: Fv,
    faTableTennis: Wv,
    faTablet: Gv,
    faTabletAlt: qv,
    faTablets: Jv,
    faTachometerAlt: Kv,
    faTag: Xv,
    faTags: _v,
    faTape: $v,
    faTasks: cd,
    faTaxi: ed,
    faTeeth: ad,
    faTeethOpen: nd,
    faTemperatureHigh: td,
    faTemperatureLow: rd,
    faTenge: id,
    faTerminal: od,
    faTextHeight: ld,
    faTextWidth: fd,
    faTh: sd,
    faThLarge: ud,
    faThList: hd,
    faTheaterMasks: md,
    faThermometer: vd,
    faThermometerEmpty: dd,
    faThermometerFull: Md,
    faThermometerHalf: pd,
    faThermometerQuarter: zd,
    faThermometerThreeQuarters: Cd,
    faThumbsDown: Ld,
    faThumbsUp: Ad,
    faThumbtack: Nd,
    faTicketAlt: gd,
    faTimes: Hd,
    faTimesCircle: Vd,
    faTint: xd,
    faTintSlash: wd,
    faTired: yd,
    faToggleOff: bd,
    faToggleOn: Sd,
    faToilet: Td,
    faToiletPaper: Dd,
    faToiletPaperSlash: jd,
    faToolbox: Ed,
    faTools: kd,
    faTooth: Id,
    faTorah: Od,
    faToriiGate: Qd,
    faTractor: Zd,
    faTrademark: Ud,
    faTrafficLight: Bd,
    faTrailer: Rd,
    faTrain: Yd,
    faTram: Pd,
    faTransgender: Fd,
    faTransgenderAlt: Wd,
    faTrash: Gd,
    faTrashAlt: qd,
    faTrashRestore: Jd,
    faTrashRestoreAlt: Kd,
    faTree: Xd,
    faTrophy: _d,
    faTruck: $d,
    faTruckLoading: cM,
    faTruckMonster: eM,
    faTruckMoving: aM,
    faTruckPickup: nM,
    faTshirt: tM,
    faTty: rM,
    faTv: iM,
    faUmbrella: oM,
    faUmbrellaBeach: lM,
    faUnderline: fM,
    faUndo: sM,
    faUndoAlt: uM,
    faUniversalAccess: hM,
    faUniversity: mM,
    faUnlink: vM,
    faUnlock: dM,
    faUnlockAlt: MM,
    faUpload: pM,
    faUser: zM,
    faUserAlt: CM,
    faUserAltSlash: LM,
    faUserAstronaut: AM,
    faUserCheck: NM,
    faUserCircle: gM,
    faUserClock: HM,
    faUserCog: VM,
    faUserEdit: xM,
    faUserFriends: wM,
    faUserGraduate: yM,
    faUserInjured: bM,
    faUserLock: SM,
    faUserMd: TM,
    faUserMinus: DM,
    faUserNinja: jM,
    faUserNurse: EM,
    faUserPlus: kM,
    faUserSecret: IM,
    faUserShield: OM,
    faUserSlash: QM,
    faUserTag: ZM,
    faUserTie: UM,
    faUserTimes: BM,
    faUsers: RM,
    faUsersCog: YM,
    faUsersSlash: PM,
    faUtensilSpoon: FM,
    faUtensils: WM,
    faVectorSquare: GM,
    faVenus: qM,
    faVenusDouble: JM,
    faVenusMars: KM,
    faVest: XM,
    faVestPatches: _M,
    faVial: $M,
    faVials: cp,
    faVideo: ep,
    faVideoSlash: ap,
    faVihara: np,
    faVirus: tp,
    faVirusSlash: rp,
    faViruses: ip,
    faVoicemail: op,
    faVolleyballBall: lp,
    faVolumeDown: fp,
    faVolumeMute: sp,
    faVolumeOff: up,
    faVolumeUp: hp,
    faVoteYea: mp,
    faVrCardboard: vp,
    faWalking: dp,
    faWallet: Mp,
    faWarehouse: pp,
    faWater: zp,
    faWaveSquare: Cp,
    faWeight: Lp,
    faWeightHanging: Ap,
    faWheelchair: Np,
    faWifi: gp,
    faWind: Hp,
    faWindowClose: Vp,
    faWindowMaximize: xp,
    faWindowMinimize: wp,
    faWindowRestore: yp,
    faWineBottle: bp,
    faWineGlass: Sp,
    faWineGlassAlt: Tp,
    faWonSign: Dp,
    faWrench: jp,
    faXRay: Ep,
    faYenSign: kp,
    faYinYang: Ip
  };
}, function (c, e, a) {
  "use strict";

  c.exports = a(218);
}, function (c, e, a) {
  "use strict";

  function n(c) {
    if (void 0 === c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return c;
  }

  a.d(e, "a", function () {
    return n;
  });
}, function (c, e, a) {
  "use strict";

  (function (c, n) {
    /*!
     * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
     * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
     */
    function t(c) {
      return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (c) {
        return typeof c;
      } : function (c) {
        return c && "function" == typeof Symbol && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
      })(c);
    }

    function r(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    function i(c, e, a) {
      return e in c ? Object.defineProperty(c, e, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : c[e] = a, c;
    }

    function o(c) {
      for (var e = 1; e < arguments.length; e++) {
        var a = null != arguments[e] ? arguments[e] : {},
            n = Object.keys(a);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(a).filter(function (c) {
          return Object.getOwnPropertyDescriptor(a, c).enumerable;
        }))), n.forEach(function (e) {
          i(c, e, a[e]);
        });
      }

      return c;
    }

    function l(c, e) {
      return function (c) {
        if (Array.isArray(c)) return c;
      }(c) || function (c, e) {
        var a = [],
            n = !0,
            t = !1,
            r = void 0;

        try {
          for (var i, o = c[Symbol.iterator](); !(n = (i = o.next()).done) && (a.push(i.value), !e || a.length !== e); n = !0) {
            ;
          }
        } catch (c) {
          t = !0, r = c;
        } finally {
          try {
            n || null == o.return || o.return();
          } finally {
            if (t) throw r;
          }
        }

        return a;
      }(c, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    a.d(e, "a", function () {
      return Dc;
    }), a.d(e, "b", function () {
      return Tc;
    });

    var f = function f() {},
        s = {},
        u = {},
        h = {
      mark: f,
      measure: f
    };

    try {
      "undefined" != typeof window && (s = window), "undefined" != typeof document && (u = document), "undefined" != typeof MutationObserver && MutationObserver, "undefined" != typeof performance && (h = performance);
    } catch (c) {}

    var m = (s.navigator || {}).userAgent,
        v = void 0 === m ? "" : m,
        d = s,
        M = u,
        p = h,
        z = (d.document, !!M.documentElement && !!M.head && "function" == typeof M.addEventListener && "function" == typeof M.createElement),
        C = (~v.indexOf("MSIE") || v.indexOf("Trident/"), "fa"),
        L = "svg-inline--fa",
        A = "data-fa-i2svg",
        N = (function () {
      try {} catch (c) {
        return !1;
      }
    }(), [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
        g = N.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
        H = {
      GROUP: "group",
      SWAP_OPACITY: "swap-opacity",
      PRIMARY: "primary",
      SECONDARY: "secondary"
    },
        V = (["xs", "sm", "lg", "fw", "ul", "li", "border", "pull-left", "pull-right", "spin", "pulse", "rotate-90", "rotate-180", "rotate-270", "flip-horizontal", "flip-vertical", "flip-both", "stack", "stack-1x", "stack-2x", "inverse", "layers", "layers-text", "layers-counter", H.GROUP, H.SWAP_OPACITY, H.PRIMARY, H.SECONDARY].concat(N.map(function (c) {
      return "".concat(c, "x");
    })).concat(g.map(function (c) {
      return "w-".concat(c);
    })), d.FontAwesomeConfig || {});

    if (M && "function" == typeof M.querySelector) {
      [["data-family-prefix", "familyPrefix"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach(function (c) {
        var e = l(c, 2),
            a = e[0],
            n = e[1],
            t = function (c) {
          return "" === c || "false" !== c && ("true" === c || c);
        }(function (c) {
          var e = M.querySelector("script[" + c + "]");
          if (e) return e.getAttribute(c);
        }(a));

        null != t && (V[n] = t);
      });
    }

    var x = o({}, {
      familyPrefix: C,
      replacementClass: L,
      autoReplaceSvg: !0,
      autoAddCss: !0,
      autoA11y: !0,
      searchPseudoElements: !1,
      observeMutations: !0,
      mutateApproach: "async",
      keepOriginalSource: !0,
      measurePerformance: !1,
      showMissingIcons: !0
    }, V);
    x.autoReplaceSvg || (x.observeMutations = !1);
    var w = o({}, x);
    d.FontAwesomeConfig = w;
    var y = d || {};
    y.___FONT_AWESOME___ || (y.___FONT_AWESOME___ = {}), y.___FONT_AWESOME___.styles || (y.___FONT_AWESOME___.styles = {}), y.___FONT_AWESOME___.hooks || (y.___FONT_AWESOME___.hooks = {}), y.___FONT_AWESOME___.shims || (y.___FONT_AWESOME___.shims = []);
    var b = y.___FONT_AWESOME___,
        S = [];
    z && ((M.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(M.readyState) || M.addEventListener("DOMContentLoaded", function c() {
      M.removeEventListener("DOMContentLoaded", c), 1, S.map(function (c) {
        return c();
      });
    }));

    var T,
        D = "pending",
        j = "settled",
        E = "fulfilled",
        k = "rejected",
        I = function I() {},
        O = void 0 !== c && void 0 !== c.process && "function" == typeof c.process.emit,
        Q = void 0 === n ? setTimeout : n,
        Z = [];

    function U() {
      for (var c = 0; c < Z.length; c++) {
        Z[c][0](Z[c][1]);
      }

      Z = [], T = !1;
    }

    function B(c, e) {
      Z.push([c, e]), T || (T = !0, Q(U, 0));
    }

    function R(c) {
      var e = c.owner,
          a = e._state,
          n = e._data,
          t = c[a],
          r = c.then;

      if ("function" == typeof t) {
        a = E;

        try {
          n = t(n);
        } catch (c) {
          W(r, c);
        }
      }

      Y(r, n) || (a === E && P(r, n), a === k && W(r, n));
    }

    function Y(c, e) {
      var a;

      try {
        if (c === e) throw new TypeError("A promises callback cannot return that same promise.");

        if (e && ("function" == typeof e || "object" === t(e))) {
          var n = e.then;
          if ("function" == typeof n) return n.call(e, function (n) {
            a || (a = !0, e === n ? F(c, n) : P(c, n));
          }, function (e) {
            a || (a = !0, W(c, e));
          }), !0;
        }
      } catch (e) {
        return a || W(c, e), !0;
      }

      return !1;
    }

    function P(c, e) {
      c !== e && Y(c, e) || F(c, e);
    }

    function F(c, e) {
      c._state === D && (c._state = j, c._data = e, B(q, c));
    }

    function W(c, e) {
      c._state === D && (c._state = j, c._data = e, B(J, c));
    }

    function G(c) {
      c._then = c._then.forEach(R);
    }

    function q(c) {
      c._state = E, G(c);
    }

    function J(e) {
      e._state = k, G(e), !e._handled && O && c.process.emit("unhandledRejection", e._data, e);
    }

    function K(e) {
      c.process.emit("rejectionHandled", e);
    }

    function X(c) {
      if ("function" != typeof c) throw new TypeError("Promise resolver " + c + " is not a function");
      if (this instanceof X == !1) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
      this._then = [], function (c, e) {
        function a(c) {
          W(e, c);
        }

        try {
          c(function (c) {
            P(e, c);
          }, a);
        } catch (c) {
          a(c);
        }
      }(c, this);
    }

    X.prototype = {
      constructor: X,
      _state: D,
      _then: null,
      _data: void 0,
      _handled: !1,
      then: function then(c, e) {
        var a = {
          owner: this,
          then: new this.constructor(I),
          fulfilled: c,
          rejected: e
        };
        return !e && !c || this._handled || (this._handled = !0, this._state === k && O && B(K, this)), this._state === E || this._state === k ? B(R, a) : this._then.push(a), a.then;
      },
      catch: function _catch(c) {
        return this.then(null, c);
      }
    }, X.all = function (c) {
      if (!Array.isArray(c)) throw new TypeError("You must pass an array to Promise.all().");
      return new X(function (e, a) {
        var n = [],
            t = 0;

        function r(c) {
          return t++, function (a) {
            n[c] = a, --t || e(n);
          };
        }

        for (var i, o = 0; o < c.length; o++) {
          (i = c[o]) && "function" == typeof i.then ? i.then(r(o), a) : n[o] = i;
        }

        t || e(n);
      });
    }, X.race = function (c) {
      if (!Array.isArray(c)) throw new TypeError("You must pass an array to Promise.race().");
      return new X(function (e, a) {
        for (var n, t = 0; t < c.length; t++) {
          (n = c[t]) && "function" == typeof n.then ? n.then(e, a) : e(n);
        }
      });
    }, X.resolve = function (c) {
      return c && "object" === t(c) && c.constructor === X ? c : new X(function (e) {
        e(c);
      });
    }, X.reject = function (c) {
      return new X(function (e, a) {
        a(c);
      });
    };
    "function" == typeof Promise && Promise;
    var _ = {
      size: 16,
      x: 0,
      y: 0,
      rotate: 0,
      flipX: !1,
      flipY: !1
    };

    function $(c) {
      if (c && z) {
        var e = M.createElement("style");
        e.setAttribute("type", "text/css"), e.innerHTML = c;

        for (var a = M.head.childNodes, n = null, t = a.length - 1; t > -1; t--) {
          var r = a[t],
              i = (r.tagName || "").toUpperCase();
          ["STYLE", "LINK"].indexOf(i) > -1 && (n = r);
        }

        return M.head.insertBefore(e, n), c;
      }
    }

    var cc = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

    function ec() {
      for (var c = 12, e = ""; c-- > 0;) {
        e += cc[62 * Math.random() | 0];
      }

      return e;
    }

    function ac(c) {
      return "".concat(c).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    function nc(c) {
      return Object.keys(c || {}).reduce(function (e, a) {
        return e + "".concat(a, ": ").concat(c[a], ";");
      }, "");
    }

    function tc(c) {
      return c.size !== _.size || c.x !== _.x || c.y !== _.y || c.rotate !== _.rotate || c.flipX || c.flipY;
    }

    function rc(c) {
      var e = c.transform,
          a = c.containerWidth,
          n = c.iconWidth,
          t = {
        transform: "translate(".concat(a / 2, " 256)")
      },
          r = "translate(".concat(32 * e.x, ", ").concat(32 * e.y, ") "),
          i = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "),
          o = "rotate(".concat(e.rotate, " 0 0)");
      return {
        outer: t,
        inner: {
          transform: "".concat(r, " ").concat(i, " ").concat(o)
        },
        path: {
          transform: "translate(".concat(n / 2 * -1, " -256)")
        }
      };
    }

    var ic = {
      x: 0,
      y: 0,
      width: "100%",
      height: "100%"
    };

    function oc(c) {
      var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
      return c.attributes && (c.attributes.fill || e) && (c.attributes.fill = "black"), c;
    }

    function lc(c) {
      var e = c.icons,
          a = e.main,
          n = e.mask,
          t = c.prefix,
          r = c.iconName,
          i = c.transform,
          l = c.symbol,
          f = c.title,
          s = c.maskId,
          u = c.titleId,
          h = c.extra,
          m = c.watchable,
          v = void 0 !== m && m,
          d = n.found ? n : a,
          M = d.width,
          p = d.height,
          z = "fak" === t,
          C = z ? "" : "fa-w-".concat(Math.ceil(M / p * 16)),
          L = [w.replacementClass, r ? "".concat(w.familyPrefix, "-").concat(r) : "", C].filter(function (c) {
        return -1 === h.classes.indexOf(c);
      }).filter(function (c) {
        return "" !== c || !!c;
      }).concat(h.classes).join(" "),
          N = {
        children: [],
        attributes: o({}, h.attributes, {
          "data-prefix": t,
          "data-icon": r,
          class: L,
          role: h.attributes.role || "img",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 ".concat(M, " ").concat(p)
        })
      },
          g = z && !~h.classes.indexOf("fa-fw") ? {
        width: "".concat(M / p * 16 * .0625, "em")
      } : {};
      v && (N.attributes[A] = ""), f && N.children.push({
        tag: "title",
        attributes: {
          id: N.attributes["aria-labelledby"] || "title-".concat(u || ec())
        },
        children: [f]
      });
      var H = o({}, N, {
        prefix: t,
        iconName: r,
        main: a,
        mask: n,
        maskId: s,
        transform: i,
        symbol: l,
        styles: o({}, g, h.styles)
      }),
          V = n.found && a.found ? function (c) {
        var e,
            a = c.children,
            n = c.attributes,
            t = c.main,
            r = c.mask,
            i = c.maskId,
            l = c.transform,
            f = t.width,
            s = t.icon,
            u = r.width,
            h = r.icon,
            m = rc({
          transform: l,
          containerWidth: u,
          iconWidth: f
        }),
            v = {
          tag: "rect",
          attributes: o({}, ic, {
            fill: "white"
          })
        },
            d = s.children ? {
          children: s.children.map(oc)
        } : {},
            M = {
          tag: "g",
          attributes: o({}, m.inner),
          children: [oc(o({
            tag: s.tag,
            attributes: o({}, s.attributes, m.path)
          }, d))]
        },
            p = {
          tag: "g",
          attributes: o({}, m.outer),
          children: [M]
        },
            z = "mask-".concat(i || ec()),
            C = "clip-".concat(i || ec()),
            L = {
          tag: "mask",
          attributes: o({}, ic, {
            id: z,
            maskUnits: "userSpaceOnUse",
            maskContentUnits: "userSpaceOnUse"
          }),
          children: [v, p]
        },
            A = {
          tag: "defs",
          children: [{
            tag: "clipPath",
            attributes: {
              id: C
            },
            children: (e = h, "g" === e.tag ? e.children : [e])
          }, L]
        };
        return a.push(A, {
          tag: "rect",
          attributes: o({
            fill: "currentColor",
            "clip-path": "url(#".concat(C, ")"),
            mask: "url(#".concat(z, ")")
          }, ic)
        }), {
          children: a,
          attributes: n
        };
      }(H) : function (c) {
        var e = c.children,
            a = c.attributes,
            n = c.main,
            t = c.transform,
            r = nc(c.styles);

        if (r.length > 0 && (a.style = r), tc(t)) {
          var i = rc({
            transform: t,
            containerWidth: n.width,
            iconWidth: n.width
          });
          e.push({
            tag: "g",
            attributes: o({}, i.outer),
            children: [{
              tag: "g",
              attributes: o({}, i.inner),
              children: [{
                tag: n.icon.tag,
                children: n.icon.children,
                attributes: o({}, n.icon.attributes, i.path)
              }]
            }]
          });
        } else e.push(n.icon);

        return {
          children: e,
          attributes: a
        };
      }(H),
          x = V.children,
          y = V.attributes;
      return H.children = x, H.attributes = y, l ? function (c) {
        var e = c.prefix,
            a = c.iconName,
            n = c.children,
            t = c.attributes,
            r = c.symbol;
        return [{
          tag: "svg",
          attributes: {
            style: "display: none;"
          },
          children: [{
            tag: "symbol",
            attributes: o({}, t, {
              id: !0 === r ? "".concat(e, "-").concat(w.familyPrefix, "-").concat(a) : r
            }),
            children: n
          }]
        }];
      }(H) : function (c) {
        var e = c.children,
            a = c.main,
            n = c.mask,
            t = c.attributes,
            r = c.styles,
            i = c.transform;

        if (tc(i) && a.found && !n.found) {
          var l = {
            x: a.width / a.height / 2,
            y: .5
          };
          t.style = nc(o({}, r, {
            "transform-origin": "".concat(l.x + i.x / 16, "em ").concat(l.y + i.y / 16, "em")
          }));
        }

        return [{
          tag: "svg",
          attributes: t,
          children: e
        }];
      }(H);
    }

    var fc = function fc() {},
        sc = (w.measurePerformance && p && p.mark && p.measure, function (c, e, a, n) {
      var t,
          r,
          i,
          o = Object.keys(c),
          l = o.length,
          f = void 0 !== n ? function (c, e) {
        return function (a, n, t, r) {
          return c.call(e, a, n, t, r);
        };
      }(e, n) : e;

      for (void 0 === a ? (t = 1, i = c[o[0]]) : (t = 0, i = a); t < l; t++) {
        i = f(i, c[r = o[t]], r, c);
      }

      return i;
    });

    var uc = b.styles,
        hc = b.shims,
        mc = function mc() {
      var c = function c(_c2) {
        return sc(uc, function (e, a, n) {
          return e[n] = sc(a, _c2, {}), e;
        }, {});
      };

      c(function (c, e, a) {
        return e[3] && (c[e[3]] = a), c;
      }), c(function (c, e, a) {
        var n = e[2];
        return c[a] = a, n.forEach(function (e) {
          c[e] = a;
        }), c;
      });
      var e = "far" in uc;
      sc(hc, function (c, a) {
        var n = a[0],
            t = a[1],
            r = a[2];
        return "far" !== t || e || (t = "fas"), c[n] = {
          prefix: t,
          iconName: r
        }, c;
      }, {});
    };

    mc();
    b.styles;

    function vc(c, e, a) {
      if (c && c[e] && c[e][a]) return {
        prefix: e,
        iconName: a,
        icon: c[e][a]
      };
    }

    function dc(c) {
      var e = c.tag,
          a = c.attributes,
          n = void 0 === a ? {} : a,
          t = c.children,
          r = void 0 === t ? [] : t;
      return "string" == typeof c ? ac(c) : "<".concat(e, " ").concat(function (c) {
        return Object.keys(c || {}).reduce(function (e, a) {
          return e + "".concat(a, '="').concat(ac(c[a]), '" ');
        }, "").trim();
      }(n), ">").concat(r.map(dc).join(""), "</").concat(e, ">");
    }

    var Mc = function Mc(c) {
      var e = {
        size: 16,
        x: 0,
        y: 0,
        flipX: !1,
        flipY: !1,
        rotate: 0
      };
      return c ? c.toLowerCase().split(" ").reduce(function (c, e) {
        var a = e.toLowerCase().split("-"),
            n = a[0],
            t = a.slice(1).join("-");
        if (n && "h" === t) return c.flipX = !0, c;
        if (n && "v" === t) return c.flipY = !0, c;
        if (t = parseFloat(t), isNaN(t)) return c;

        switch (n) {
          case "grow":
            c.size = c.size + t;
            break;

          case "shrink":
            c.size = c.size - t;
            break;

          case "left":
            c.x = c.x - t;
            break;

          case "right":
            c.x = c.x + t;
            break;

          case "up":
            c.y = c.y - t;
            break;

          case "down":
            c.y = c.y + t;
            break;

          case "rotate":
            c.rotate = c.rotate + t;
        }

        return c;
      }, e) : e;
    };

    function pc(c) {
      this.name = "MissingIcon", this.message = c || "Icon unavailable", this.stack = new Error().stack;
    }

    pc.prototype = Object.create(Error.prototype), pc.prototype.constructor = pc;
    var zc = {
      fill: "currentColor"
    },
        Cc = {
      attributeType: "XML",
      repeatCount: "indefinite",
      dur: "2s"
    },
        Lc = {
      tag: "path",
      attributes: o({}, zc, {
        d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
      })
    },
        Ac = o({}, Cc, {
      attributeName: "opacity"
    });
    o({}, zc, {
      cx: "256",
      cy: "364",
      r: "28"
    }), o({}, Cc, {
      attributeName: "r",
      values: "28;14;28;28;14;28;"
    }), o({}, Ac, {
      values: "1;0;1;1;0;1;"
    }), o({}, zc, {
      opacity: "1",
      d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
    }), o({}, Ac, {
      values: "1;0;0;0;0;1;"
    }), o({}, zc, {
      opacity: "0",
      d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
    }), o({}, Ac, {
      values: "0;0;1;1;0;0;"
    }), b.styles;

    function Nc(c) {
      var e = c[0],
          a = c[1],
          n = l(c.slice(4), 1)[0];
      return {
        found: !0,
        width: e,
        height: a,
        icon: Array.isArray(n) ? {
          tag: "g",
          attributes: {
            class: "".concat(w.familyPrefix, "-").concat(H.GROUP)
          },
          children: [{
            tag: "path",
            attributes: {
              class: "".concat(w.familyPrefix, "-").concat(H.SECONDARY),
              fill: "currentColor",
              d: n[0]
            }
          }, {
            tag: "path",
            attributes: {
              class: "".concat(w.familyPrefix, "-").concat(H.PRIMARY),
              fill: "currentColor",
              d: n[1]
            }
          }]
        } : {
          tag: "path",
          attributes: {
            fill: "currentColor",
            d: n
          }
        }
      };
    }

    b.styles;
    var gc = 'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';

    function Hc() {
      var c = C,
          e = L,
          a = w.familyPrefix,
          n = w.replacementClass,
          t = gc;

      if (a !== c || n !== e) {
        var r = new RegExp("\\.".concat(c, "\\-"), "g"),
            i = new RegExp("\\--".concat(c, "\\-"), "g"),
            o = new RegExp("\\.".concat(e), "g");
        t = t.replace(r, ".".concat(a, "-")).replace(i, "--".concat(a, "-")).replace(o, ".".concat(n));
      }

      return t;
    }

    function Vc() {
      w.autoAddCss && !Sc && ($(Hc()), Sc = !0);
    }

    function xc(c, e) {
      return Object.defineProperty(c, "abstract", {
        get: e
      }), Object.defineProperty(c, "html", {
        get: function get() {
          return c.abstract.map(function (c) {
            return dc(c);
          });
        }
      }), Object.defineProperty(c, "node", {
        get: function get() {
          if (z) {
            var e = M.createElement("div");
            return e.innerHTML = c.html, e.children;
          }
        }
      }), c;
    }

    function wc(c) {
      var e = c.prefix,
          a = void 0 === e ? "fa" : e,
          n = c.iconName;
      if (n) return vc(bc.definitions, a, n) || vc(b.styles, a, n);
    }

    var yc,
        bc = new (function () {
      function c() {
        !function (c, e) {
          if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, c), this.definitions = {};
      }

      var e, a, n;
      return e = c, (a = [{
        key: "add",
        value: function value() {
          for (var c = this, e = arguments.length, a = new Array(e), n = 0; n < e; n++) {
            a[n] = arguments[n];
          }

          var t = a.reduce(this._pullDefinitions, {});
          Object.keys(t).forEach(function (e) {
            c.definitions[e] = o({}, c.definitions[e] || {}, t[e]), function c(e, a) {
              var n = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).skipHooks,
                  t = void 0 !== n && n,
                  r = Object.keys(a).reduce(function (c, e) {
                var n = a[e];
                return n.icon ? c[n.iconName] = n.icon : c[e] = n, c;
              }, {});
              "function" != typeof b.hooks.addPack || t ? b.styles[e] = o({}, b.styles[e] || {}, r) : b.hooks.addPack(e, r), "fas" === e && c("fa", a);
            }(e, t[e]), mc();
          });
        }
      }, {
        key: "reset",
        value: function value() {
          this.definitions = {};
        }
      }, {
        key: "_pullDefinitions",
        value: function value(c, e) {
          var a = e.prefix && e.iconName && e.icon ? {
            0: e
          } : e;
          return Object.keys(a).map(function (e) {
            var n = a[e],
                t = n.prefix,
                r = n.iconName,
                i = n.icon;
            c[t] || (c[t] = {}), c[t][r] = i;
          }), c;
        }
      }]) && r(e.prototype, a), n && r(e, n), c;
    }())(),
        Sc = !1,
        Tc = {
      transform: function transform(c) {
        return Mc(c);
      }
    },
        Dc = (yc = function yc(c) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          a = e.transform,
          n = void 0 === a ? _ : a,
          t = e.symbol,
          r = void 0 !== t && t,
          i = e.mask,
          l = void 0 === i ? null : i,
          f = e.maskId,
          s = void 0 === f ? null : f,
          u = e.title,
          h = void 0 === u ? null : u,
          m = e.titleId,
          v = void 0 === m ? null : m,
          d = e.classes,
          M = void 0 === d ? [] : d,
          p = e.attributes,
          z = void 0 === p ? {} : p,
          C = e.styles,
          L = void 0 === C ? {} : C;

      if (c) {
        var A = c.prefix,
            N = c.iconName,
            g = c.icon;
        return xc(o({
          type: "icon"
        }, c), function () {
          return Vc(), w.autoA11y && (h ? z["aria-labelledby"] = "".concat(w.replacementClass, "-title-").concat(v || ec()) : (z["aria-hidden"] = "true", z.focusable = "false")), lc({
            icons: {
              main: Nc(g),
              mask: l ? Nc(l.icon) : {
                found: !1,
                width: null,
                height: null,
                icon: {}
              }
            },
            prefix: A,
            iconName: N,
            transform: o({}, _, n),
            symbol: r,
            title: h,
            maskId: s,
            titleId: v,
            extra: {
              attributes: z,
              styles: L,
              classes: M
            }
          });
        });
      }
    }, function (c) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          a = (c || {}).icon ? c : wc(c || {}),
          n = e.mask;
      return n && (n = (n || {}).icon ? n : wc(n || {})), yc(a, o({}, e, {
        mask: n
      }));
    });
  }).call(this, a(18), a(212).setImmediate);
}, function (c, e, a) {
  var n = a(120),
      t = a(121),
      r = a(122),
      i = a(123),
      o = a(124);

  function l(c) {
    var e = -1,
        a = null == c ? 0 : c.length;

    for (this.clear(); ++e < a;) {
      var n = c[e];
      this.set(n[0], n[1]);
    }
  }

  l.prototype.clear = n, l.prototype.delete = t, l.prototype.get = r, l.prototype.has = i, l.prototype.set = o, c.exports = l;
}, function (c, e, a) {
  var n = a(64);

  c.exports = function (c, e) {
    for (var a = c.length; a--;) {
      if (n(c[a][0], e)) return a;
    }

    return -1;
  };
}, function (c, e, a) {
  var n = a(19)(Object, "create");
  c.exports = n;
}, function (c, e, a) {
  var n = a(142);

  c.exports = function (c, e) {
    var a = c.__data__;
    return n(e) ? a["string" == typeof e ? "string" : "hash"] : a.map;
  };
}, function (c, e, a) {
  var n = a(51),
      t = 1 / 0;

  c.exports = function (c) {
    if ("string" == typeof c || n(c)) return c;
    var e = c + "";
    return "0" == e && 1 / c == -t ? "-0" : e;
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Image = void 0;

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = o(t),
      i = o(a(2));

  function o(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var l = e.Image = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.alt,
            a = c.className,
            n = c.src;
        return r.default.createElement("img", {
          alt: e,
          className: a,
          src: n
        });
      }
    }]), e;
  }();

  l.propTypes = {
    src: i.default.string.isRequired,
    alt: i.default.string,
    className: i.default.string
  }, l.defaultProps = {
    alt: "",
    className: ""
  }, e.default = l;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.numberFormatToCurrency = void 0, e.toCurrencyString = function (c) {
    if (null == c || "" === c) return "";
    var e = "number" == typeof c ? c : Number(c);
    return "$" + e.toFixed(2);
  };
  var n = a(37);

  e.numberFormatToCurrency = function (c, e) {
    return null == c ? "" : (0, n.getSubdomain)() == n.FLEET_MAINTENANCE_HUB_CANADA ? "$" + parseFloat(c).toFixed(2) + " CAD" : new Intl.NumberFormat(function (c) {
      switch (c && c.toLowerCase()) {
        case "en":
        case "en-ca":
          return "en";

        case "fr-ca":
          return "fr-CA";
      }
    }(e.language), {
      style: "currency",
      currency: t(e.language)
    }).format(c);
  };

  function t(c) {
    switch (c && c.toLowerCase()) {
      case "en":
        return "USD";

      case "en-ca":
      case "fr-ca":
        return "CAD";
    }
  }
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.getSubdomain = l, e.isFleetMaintenanceHub = function () {
    return l() === t;
  }, e.isFleetMaintenanceHubCanada = function () {
    return l() === n;
  }, e.isFleetcor = function () {
    return l() === r;
  }, e.isInstacartCanada = function () {
    return l() === i;
  };
  var n = e.FLEET_MAINTENANCE_HUB_CANADA = "shellcanada",
      t = e.FLEET_MAINTENANCE_HUB = "shell",
      r = e.FLEETCOR = "fleetcor",
      i = e.INSTA_CA = "instacart-ca",
      o = (e.FUELMAN = "fuelman", e.NTWTBC = "ntw");

  function l(c) {
    c || (c = window.location.hostname);
    var e = void 0;
    if (c.match(/fleetmaintenancehubca/)) e = n;else if (c.match(/fleetmaintenancehub/)) e = t;else if (c.match(/fuelmanmaintenance/)) e = r;else if (c.match(/instacart-ca/)) e = i;else if (c.match(/ntw/)) e = o;else {
      var a = c.indexOf(".");
      "www" !== (e = -1 !== a ? c.substring(0, a).toLowerCase() : c) && "localhost" !== e && "app" !== e || (e = "fleetadvise");
    }
    return e;
  }
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  e.BRAINTREE = "braintree", e.WEX = "wex", e.FLEETCOR = "fleetcor", e.AFFIRM = "affirm";
}, function (c, e, a) {
  var n = a(211);
  c.exports = m, c.exports.parse = r, c.exports.compile = function (c, e) {
    return o(r(c, e), e);
  }, c.exports.tokensToFunction = o, c.exports.tokensToRegExp = h;
  var t = new RegExp(["(\\\\.)", "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"].join("|"), "g");

  function r(c, e) {
    for (var a, n = [], r = 0, i = 0, o = "", s = e && e.delimiter || "/"; null != (a = t.exec(c));) {
      var u = a[0],
          h = a[1],
          m = a.index;
      if (o += c.slice(i, m), i = m + u.length, h) o += h[1];else {
        var v = c[i],
            d = a[2],
            M = a[3],
            p = a[4],
            z = a[5],
            C = a[6],
            L = a[7];
        o && (n.push(o), o = "");
        var A = null != d && null != v && v !== d,
            N = "+" === C || "*" === C,
            g = "?" === C || "*" === C,
            H = a[2] || s,
            V = p || z;
        n.push({
          name: M || r++,
          prefix: d || "",
          delimiter: H,
          optional: g,
          repeat: N,
          partial: A,
          asterisk: !!L,
          pattern: V ? f(V) : L ? ".*" : "[^" + l(H) + "]+?"
        });
      }
    }

    return i < c.length && (o += c.substr(i)), o && n.push(o), n;
  }

  function i(c) {
    return encodeURI(c).replace(/[\/?#]/g, function (c) {
      return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
  }

  function o(c, e) {
    for (var a = new Array(c.length), t = 0; t < c.length; t++) {
      "object" == typeof c[t] && (a[t] = new RegExp("^(?:" + c[t].pattern + ")$", u(e)));
    }

    return function (e, t) {
      for (var r = "", o = e || {}, l = (t || {}).pretty ? i : encodeURIComponent, f = 0; f < c.length; f++) {
        var s = c[f];

        if ("string" != typeof s) {
          var u,
              h = o[s.name];

          if (null == h) {
            if (s.optional) {
              s.partial && (r += s.prefix);
              continue;
            }

            throw new TypeError('Expected "' + s.name + '" to be defined');
          }

          if (n(h)) {
            if (!s.repeat) throw new TypeError('Expected "' + s.name + '" to not repeat, but received `' + JSON.stringify(h) + "`");

            if (0 === h.length) {
              if (s.optional) continue;
              throw new TypeError('Expected "' + s.name + '" to not be empty');
            }

            for (var m = 0; m < h.length; m++) {
              if (u = l(h[m]), !a[f].test(u)) throw new TypeError('Expected all "' + s.name + '" to match "' + s.pattern + '", but received `' + JSON.stringify(u) + "`");
              r += (0 === m ? s.prefix : s.delimiter) + u;
            }
          } else {
            if (u = s.asterisk ? encodeURI(h).replace(/[?#]/g, function (c) {
              return "%" + c.charCodeAt(0).toString(16).toUpperCase();
            }) : l(h), !a[f].test(u)) throw new TypeError('Expected "' + s.name + '" to match "' + s.pattern + '", but received "' + u + '"');
            r += s.prefix + u;
          }
        } else r += s;
      }

      return r;
    };
  }

  function l(c) {
    return c.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
  }

  function f(c) {
    return c.replace(/([=!:$\/()])/g, "\\$1");
  }

  function s(c, e) {
    return c.keys = e, c;
  }

  function u(c) {
    return c && c.sensitive ? "" : "i";
  }

  function h(c, e, a) {
    n(e) || (a = e || a, e = []);

    for (var t = (a = a || {}).strict, r = !1 !== a.end, i = "", o = 0; o < c.length; o++) {
      var f = c[o];
      if ("string" == typeof f) i += l(f);else {
        var h = l(f.prefix),
            m = "(?:" + f.pattern + ")";
        e.push(f), f.repeat && (m += "(?:" + h + m + ")*"), i += m = f.optional ? f.partial ? h + "(" + m + ")?" : "(?:" + h + "(" + m + "))?" : h + "(" + m + ")";
      }
    }

    var v = l(a.delimiter || "/"),
        d = i.slice(-v.length) === v;
    return t || (i = (d ? i.slice(0, -v.length) : i) + "(?:" + v + "(?=$))?"), i += r ? "$" : t && d ? "" : "(?=" + v + "|$)", s(new RegExp("^" + i, u(a)), e);
  }

  function m(c, e, a) {
    return n(e) || (a = e || a, e = []), a = a || {}, c instanceof RegExp ? function (c, e) {
      var a = c.source.match(/\((?!\?)/g);
      if (a) for (var n = 0; n < a.length; n++) {
        e.push({
          name: n,
          prefix: null,
          delimiter: null,
          optional: !1,
          repeat: !1,
          partial: !1,
          asterisk: !1,
          pattern: null
        });
      }
      return s(c, e);
    }(c, e) : n(c) ? function (c, e, a) {
      for (var n = [], t = 0; t < c.length; t++) {
        n.push(m(c[t], e, a).source);
      }

      return s(new RegExp("(?:" + n.join("|") + ")", u(a)), e);
    }(c, e, a) : function (c, e, a) {
      return h(r(c, a), e, a);
    }(c, e, a);
  }
}, function (c, e, a) {
  "use strict";

  (function (c) {
    var a = "object" == typeof c && c && c.Object === Object && c;
    e.a = a;
  }).call(this, a(18));
}, function (c, e, a) {
  "use strict";

  function n(c) {
    return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (c) {
      return typeof c;
    } : function (c) {
      return c && "function" == typeof Symbol && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
    })(c);
  }

  function t(c) {
    var e = function (c, e) {
      if ("object" !== n(c) || null === c) return c;
      var a = c[Symbol.toPrimitive];

      if (void 0 !== a) {
        var t = a.call(c, e || "default");
        if ("object" !== n(t)) return t;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }

      return ("string" === e ? String : Number)(c);
    }(c, "string");

    return "symbol" === n(e) ? e : String(e);
  }

  a.d(e, "a", function () {
    return t;
  });
},, function (c, e, a) {
  var n = a(113),
      t = a(25),
      r = Object.prototype,
      i = r.hasOwnProperty,
      o = r.propertyIsEnumerable,
      l = n(function () {
    return arguments;
  }()) ? n : function (c) {
    return t(c) && i.call(c, "callee") && !o.call(c, "callee");
  };
  c.exports = l;
}, function (c, e, a) {
  var n = a(19)(a(13), "Map");
  c.exports = n;
}, function (c, e) {
  c.exports = function (c) {
    var e = typeof c;
    return null != c && ("object" == e || "function" == e);
  };
}, function (c, e, a) {
  var n = a(134),
      t = a(141),
      r = a(143),
      i = a(144),
      o = a(145);

  function l(c) {
    var e = -1,
        a = null == c ? 0 : c.length;

    for (this.clear(); ++e < a;) {
      var n = c[e];
      this.set(n[0], n[1]);
    }
  }

  l.prototype.clear = n, l.prototype.delete = t, l.prototype.get = r, l.prototype.has = i, l.prototype.set = o, c.exports = l;
}, function (c, e, a) {
  var n = a(162),
      t = a(168),
      r = a(49);

  c.exports = function (c) {
    return r(c) ? n(c) : t(c);
  };
}, function (c, e) {
  var a = 9007199254740991;

  c.exports = function (c) {
    return "number" == typeof c && c > -1 && c % 1 == 0 && c <= a;
  };
}, function (c, e, a) {
  var n = a(65),
      t = a(48);

  c.exports = function (c) {
    return null != c && t(c.length) && !n(c);
  };
}, function (c, e, a) {
  var n = a(11),
      t = a(51),
      r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      i = /^\w*$/;

  c.exports = function (c, e) {
    if (n(c)) return !1;
    var a = typeof c;
    return !("number" != a && "symbol" != a && "boolean" != a && null != c && !t(c)) || i.test(c) || !r.test(c) || null != e && c in Object(e);
  };
}, function (c, e, a) {
  var n = a(24),
      t = a(25),
      r = "[object Symbol]";

  c.exports = function (c) {
    return "symbol" == typeof c || t(c) && n(c) == r;
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n,
      t = a(201),
      r = (n = t) && n.__esModule ? n : {
    default: n
  };
  e.default = r.default, c.exports = e.default;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.canUseDOM = e.SafeNodeList = e.SafeHTMLCollection = void 0;
  var n,
      t = a(80);
  var r = ((n = t) && n.__esModule ? n : {
    default: n
  }).default,
      i = r.canUseDOM ? window.HTMLElement : {};
  e.SafeHTMLCollection = r.canUseDOM ? window.HTMLCollection : {}, e.SafeNodeList = r.canUseDOM ? window.NodeList : {}, e.canUseDOM = r.canUseDOM;
  e.default = i;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n,
      t = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      r = a(0),
      i = (n = r) && n.__esModule ? n : {
    default: n
  },
      o = a(14),
      l = a(215);

  var f = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, i.default.Component), t(e, [{
      key: "render",
      value: function value() {
        var c = this.props.onClose;
        return i.default.createElement("div", {
          className: "modal-header-close"
        }, i.default.createElement("a", {
          className: "modal-header-close-button",
          onClick: c
        }, i.default.createElement(o.FontAwesomeIcon, {
          className: "ca-gray",
          icon: l.faTimes,
          size: "2x"
        })));
      }
    }]), e;
  }();

  e.default = f;
}, function (c, e, a) {
  var n;
  n = function n(c) {
    return function (c) {
      var e = {};

      function a(n) {
        if (e[n]) return e[n].exports;
        var t = e[n] = {
          exports: {},
          id: n,
          loaded: !1
        };
        return c[n].call(t.exports, t, t.exports, a), t.loaded = !0, t.exports;
      }

      return a.m = c, a.c = e, a.p = "", a(0);
    }([function (c, e, a) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var n = Object.assign || function (c) {
        for (var e = 1; e < arguments.length; e++) {
          var a = arguments[e];

          for (var n in a) {
            Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
          }
        }

        return c;
      },
          t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (c) {
        return typeof c;
      } : function (c) {
        return c && "function" == typeof Symbol && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
      },
          r = function () {
        function c(c, e) {
          for (var a = 0; a < e.length; a++) {
            var n = e[a];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
          }
        }

        return function (e, a, n) {
          return a && c(e.prototype, a), n && c(e, n), e;
        };
      }(),
          i = a(2),
          o = f(i),
          l = f(a(1));

      function f(c) {
        return c && c.__esModule ? c : {
          default: c
        };
      }

      var s = !1,
          u = function (c) {
        function e(c) {
          !function (c, e) {
            if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, e);

          var a = function (c, e) {
            if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !e || "object" != typeof e && "function" != typeof e ? c : e;
          }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, c));

          return a.getStyleString = function () {
            if (a.props.children instanceof Array) {
              var c = a.props.children.filter(function (c) {
                return !(0, i.isValidElement)(c) && "string" == typeof c;
              });
              if (c.length > 1) throw new Error("Multiple style objects as direct descedents of a Style component are not supported (" + c.length + " style objects detected): \n\n" + c[0]);
              return c[0];
            }

            return "string" != typeof a.props.children || (0, i.isValidElement)(a.props.children) ? null : a.props.children;
          }, a.getRootElement = function () {
            if (a.props.children instanceof Array) {
              var c = a.props.children.filter(function (c) {
                return (0, i.isValidElement)(c);
              });

              if (s) {
                if (c.length > 1) throw console.log(c), new Error("Adjacent JSX elements must be wrapped in an enclosing tag (" + c.length + " root elements detected).");
                if (void 0 !== c[0] && a.isVoidElement(c[0].type)) throw new Error("Self-closing void elements like " + c.type + " must be wrapped in an enclosing tag. Reactive Style must be able to nest a style element inside of the root element and void element content models never allowit to have contents under any circumstances.");
              }

              return c[0];
            }

            return (0, i.isValidElement)(a.props.children) ? a.props.children : null;
          }, a.getRootSelectors = function (c) {
            var e = [];
            return c.props.id && e.push("#" + c.props.id), c.props.className && c.props.className.trim().split(/\s+/g).forEach(function (c) {
              return e.push(c);
            }), e.length || "function" == typeof c.type || e.push(c.type), e;
          }, a.processCSSText = function (c, e, n) {
            return c.replace(/\s*\/\/(?![^(]*\)).*|\s*\/\*.*\*\//g, "").replace(/\s\s+/g, " ").split("}").map(function (c) {
              var t = /.*:.*;/g,
                  r = /.*:.*(;|$|\s+)/g,
                  i = /\s*@/g,
                  o = /\s*(([0-9][0-9]?|100)\s*%)|\s*(to|from)\s*$/g;
              return c.split("{").map(function (c, l, f) {
                if (!c.trim().length) return "";
                var s = f.length - 1 === l && c.match(r);
                if (c.match(t) || s) return a.escapeTextContentForBrowser(c);
                var u = c;
                return e && !/:target/gi.test(u) ? u.match(i) || u.match(o) ? u : a.scopeSelector(e, u, n) : u;
              }).join("{\n");
            }).join("}\n");
          }, a.escaper = function (c) {
            return {
              ">": "&gt;",
              "<": "&lt;"
            }[c];
          }, a.escapeTextContentForBrowser = function (c) {
            return ("" + c).replace(/[><]/g, a.escaper);
          }, a.scopeSelector = function (c, e, a) {
            for (var n = [], t = e.split(/,(?![^(|[]*\)|\])/g), r = 0; r < t.length; r++) {
              var i = void 0,
                  o = void 0;

              if (a.length && a.some(function (c) {
                return e.match(c);
              })) {
                o = t[r];
                var l = a.map(function (c) {
                  return c.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
                });
                o = o.replace(new RegExp("(" + l.join("|") + ")"), "$1" + c), i = c + " " + t[r], n.push(o, i);
              } else i = c + " " + t[r], n.push(i);
            }

            return n.join(", ");
          }, a.getScopeClassName = function (c, e) {
            var n = c;
            return e && (a.pepper = "", a.traverseObjectToGeneratePepper(e), n += a.pepper), (s ? "scope-" : "s") + (0, l.default)(n);
          }, a.traverseObjectToGeneratePepper = function (c) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            if (!(e > 32 || a.pepper.length > 1e4)) for (var n in c) {
              var r = /^[_$]|type|ref|^value$/.test(n);
              c[n] && "object" === t(c[n]) && !r ? a.traverseObjectToGeneratePepper(c[n], e + 1) : c[n] && !r && "function" != typeof c[n] && (a.pepper += c[n]);
            }
          }, a.isVoidElement = function (c) {
            return ["area", "base", "br", "col", "command", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"].some(function (e) {
              return c === e;
            });
          }, a.addCSSTextToHead = function (c) {
            if (c.length) {
              var e = (0, l.default)(c);
              window._reactiveStyle.cssTextHashesAddedToHead.some(function (c) {
                return c === e;
              }) || (window._reactiveStyle.el.innerHTML += c, window._reactiveStyle.cssTextHashesAddedToHead.push(e));
            }
          }, a.createStyleElement = function (c, e) {
            return o.default.createElement("style", {
              type: "text/css",
              key: e,
              ref: function ref(c) {
                return a._style = c;
              },
              dangerouslySetInnerHTML: {
                __html: c || ""
              }
            });
          }, a.getNewChildrenForCloneElement = function (c, e, n) {
            return [a.createStyleElement(c, n)].concat(e.props.children);
          }, a.scopeClassNameCache = {}, a.scopedCSSTextCache = {}, a;
        }

        return function (c, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
          c.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: c,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
        }(e, i.Component), r(e, [{
          key: "render",
          value: function value() {
            if (!this.props.children) return this.createStyleElement();
            var c = this.getStyleString(),
                e = this.getRootElement();
            if (!c && e) return e.props.children;
            if (c && !e) return this.createStyleElement(this.processCSSText(c), this.getScopeClassName(c, e));
            var a = e.props.className ? e.props.className + " " : "",
                t = void 0,
                r = void 0,
                o = a + (e.props.id ? e.props.id : "") + c;
            return this.scopeClassNameCache[o] ? (t = this.scopeClassNameCache[o], r = this.scopedCSSTextCache[t]) : (t = this.getScopeClassName(c, e), r = this.processCSSText(c, "." + t, this.getRootSelectors(e)), this.scopeClassNameCache[o] = t, this.scopedCSSTextCache[t] = r), (0, i.cloneElement)(e, n({}, e.props, {
              className: "" + a + t
            }), this.getNewChildrenForCloneElement(r, e, t));
          }
        }]), e;
      }();

      u.it = function (c, e) {
        return o.default.createElement(u, null, c, e);
      }, e.default = u;
    }, function (c, e) {
      "use strict";

      var a = 65521;

      c.exports = function (c) {
        for (var e = 1, n = 0, t = 0, r = c.length, i = -4 & r; t < i;) {
          for (var o = Math.min(t + 4096, i); t < o; t += 4) {
            n += (e += c.charCodeAt(t)) + (e += c.charCodeAt(t + 1)) + (e += c.charCodeAt(t + 2)) + (e += c.charCodeAt(t + 3));
          }

          e %= a, n %= a;
        }

        for (; t < r; t++) {
          n += e += c.charCodeAt(t);
        }

        return (e %= a) | (n %= a) << 16;
      };
    }, function (e, a) {
      e.exports = c;
    }]);
  }, c.exports = n(a(0));
}, function (c, e, a) {
  "use strict";

  a.r(e);
  var n = {};
  a.r(n), a.d(n, "someByType", function () {
    return at;
  }), a.d(n, "findByType", function () {
    return nt;
  }), a.d(n, "isNil", function () {
    return tt;
  });
  var t = {};
  a.r(t), a.d(t, "COLORS", function () {
    return Ct;
  }), a.d(t, "FLOATS", function () {
    return Lt;
  }), a.d(t, "SIZES", function () {
    return At;
  }), a.d(t, "TEXT_ALIGNMENTS", function () {
    return Nt;
  }), a.d(t, "VERTICAL_ALIGNMENTS", function () {
    return gt;
  }), a.d(t, "VISIBILITY", function () {
    return Ht;
  }), a.d(t, "WIDTHS", function () {
    return Vt;
  }), a.d(t, "DIRECTIONAL_TRANSITIONS", function () {
    return xt;
  }), a.d(t, "STATIC_TRANSITIONS", function () {
    return wt;
  }), a.d(t, "TRANSITIONS", function () {
    return yt;
  }), a.d(t, "ACCESSIBILITY", function () {
    return bt;
  }), a.d(t, "ARROWS", function () {
    return St;
  }), a.d(t, "AUDIO_VIDEO", function () {
    return Tt;
  }), a.d(t, "BUSINESS", function () {
    return Dt;
  }), a.d(t, "CHESS", function () {
    return jt;
  }), a.d(t, "CODE", function () {
    return Et;
  }), a.d(t, "COMMUNICATION", function () {
    return kt;
  }), a.d(t, "COMPUTERS", function () {
    return It;
  }), a.d(t, "CURRENCY", function () {
    return Ot;
  }), a.d(t, "DATE_TIME", function () {
    return Qt;
  }), a.d(t, "DESIGN", function () {
    return Zt;
  }), a.d(t, "EDITORS", function () {
    return Ut;
  }), a.d(t, "FILES", function () {
    return Bt;
  }), a.d(t, "GENDERS", function () {
    return Rt;
  }), a.d(t, "HANDS_GESTURES", function () {
    return Yt;
  }), a.d(t, "HEALTH", function () {
    return Pt;
  }), a.d(t, "IMAGES", function () {
    return Ft;
  }), a.d(t, "INTERFACES", function () {
    return Wt;
  }), a.d(t, "LOGISTICS", function () {
    return Gt;
  }), a.d(t, "MAPS", function () {
    return qt;
  }), a.d(t, "MEDICAL", function () {
    return Jt;
  }), a.d(t, "OBJECTS", function () {
    return Kt;
  }), a.d(t, "PAYMENTS_SHOPPING", function () {
    return Xt;
  }), a.d(t, "SHAPES", function () {
    return _t;
  }), a.d(t, "SPINNERS", function () {
    return $t;
  }), a.d(t, "SPORTS", function () {
    return cr;
  }), a.d(t, "STATUS", function () {
    return er;
  }), a.d(t, "USERS_PEOPLE", function () {
    return ar;
  }), a.d(t, "VEHICLES", function () {
    return nr;
  }), a.d(t, "WRITING", function () {
    return tr;
  }), a.d(t, "BRANDS", function () {
    return rr;
  }), a.d(t, "ICONS", function () {
    return ir;
  }), a.d(t, "ICON_ALIASES", function () {
    return or;
  }), a.d(t, "ICONS_AND_ALIASES", function () {
    return lr;
  }), a.d(t, "COMPONENT_CONTEXT_SPECIFIC_ICONS", function () {
    return fr;
  }), a.d(t, "ALL_ICONS_IN_ALL_CONTEXTS", function () {
    return sr;
  });

  var r = a(8),
      i = a(0),
      o = a.n(i),
      l = a(27),
      f = a(3),
      s = a(15),
      u = function u(c, e) {
    "function" != typeof c ? null !== c && "object" == typeof c && (c.current = e) : c(e);
  },
      h = function h(c) {
    return null !== c && "object" == typeof c && c.hasOwnProperty("current");
  };

  var m = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).prevNode = void 0, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.componentDidMount = function () {
      var c = s.findDOMNode(this);
      this.prevNode = c, u(this.props.innerRef, c);
    }, a.componentDidUpdate = function (c) {
      var e = s.findDOMNode(this);
      this.prevNode !== e && (this.prevNode = e, u(this.props.innerRef, e)), c.innerRef !== this.props.innerRef && u(this.props.innerRef, e);
    }, a.componentWillUnmount = function () {
      u(this.props.innerRef, null), delete this.prevNode;
    }, a.render = function () {
      return this.props.children;
    }, e;
  }(i.Component),
      v = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).currentNode = void 0, e.handleRefOverride = function (c) {
        var a = e.props,
            n = a.children,
            t = a.innerRef;
        u(n.ref, c), u(t, c), e.currentNode = c;
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.componentDidUpdate = function (c) {
      c.innerRef !== this.props.innerRef && u(this.props.innerRef, this.currentNode);
    }, a.componentWillUnmount = function () {
      delete this.currentNode;
    }, a.render = function () {
      var c = this.props.children;
      return i.cloneElement(c, {
        ref: this.handleRefOverride
      });
    }, e;
  }(i.Component),
      d = ["children", "innerRef"],
      M = function M(c) {
    var e = c.children,
        a = c.innerRef,
        n = Object(r.a)(c, d),
        t = i.Children.only(e),
        o = l.isForwardRef(t) ? v : m,
        f = t && n && Object.keys(n).length > 0 ? i.cloneElement(t, n) : t;
    return i.createElement(o, {
      innerRef: a
    }, f);
  },
      p = a(1),
      z = Object.prototype.hasOwnProperty;

  var C = function C(c, e) {
    return null != c && z.call(c, e);
  },
      L = Array.isArray,
      A = a(5),
      N = A.a.Symbol,
      g = Object.prototype,
      H = g.hasOwnProperty,
      V = g.toString,
      x = N ? N.toStringTag : void 0;

  var w = function w(c) {
    var e = H.call(c, x),
        a = c[x];

    try {
      c[x] = void 0;
      var n = !0;
    } catch (c) {}

    var t = V.call(c);
    return n && (e ? c[x] = a : delete c[x]), t;
  },
      y = Object.prototype.toString;

  var b = function b(c) {
    return y.call(c);
  },
      S = "[object Null]",
      T = "[object Undefined]",
      D = N ? N.toStringTag : void 0;

  var j = function j(c) {
    return null == c ? void 0 === c ? T : S : D && D in Object(c) ? w(c) : b(c);
  };

  var E = function E(c) {
    return null != c && "object" == typeof c;
  },
      k = "[object Symbol]";

  var I = function I(c) {
    return "symbol" == typeof c || E(c) && j(c) == k;
  },
      O = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      Q = /^\w*$/;

  var Z = function Z(c, e) {
    if (L(c)) return !1;
    var a = typeof c;
    return !("number" != a && "symbol" != a && "boolean" != a && null != c && !I(c)) || Q.test(c) || !O.test(c) || null != e && c in Object(e);
  };

  var U = function U(c) {
    var e = typeof c;
    return null != c && ("object" == e || "function" == e);
  },
      B = "[object AsyncFunction]",
      R = "[object Function]",
      Y = "[object GeneratorFunction]",
      P = "[object Proxy]";

  var F,
      W = function W(c) {
    if (!U(c)) return !1;
    var e = j(c);
    return e == R || e == Y || e == B || e == P;
  },
      G = A.a["__core-js_shared__"],
      q = (F = /[^.]+$/.exec(G && G.keys && G.keys.IE_PROTO || "")) ? "Symbol(src)_1." + F : "";

  var J = function J(c) {
    return !!q && q in c;
  },
      K = Function.prototype.toString;

  var X = function X(c) {
    if (null != c) {
      try {
        return K.call(c);
      } catch (c) {}

      try {
        return c + "";
      } catch (c) {}
    }

    return "";
  },
      _ = /^\[object .+?Constructor\]$/,
      $ = Function.prototype,
      cc = Object.prototype,
      ec = $.toString,
      ac = cc.hasOwnProperty,
      nc = RegExp("^" + ec.call(ac).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

  var tc = function tc(c) {
    return !(!U(c) || J(c)) && (W(c) ? nc : _).test(X(c));
  };

  var rc = function rc(c, e) {
    return null == c ? void 0 : c[e];
  };

  var ic = function ic(c, e) {
    var a = rc(c, e);
    return tc(a) ? a : void 0;
  },
      oc = ic(Object, "create");

  var lc = function lc() {
    this.__data__ = oc ? oc(null) : {}, this.size = 0;
  };

  var fc = function fc(c) {
    var e = this.has(c) && delete this.__data__[c];
    return this.size -= e ? 1 : 0, e;
  },
      sc = "__lodash_hash_undefined__",
      uc = Object.prototype.hasOwnProperty;

  var hc = function hc(c) {
    var e = this.__data__;

    if (oc) {
      var a = e[c];
      return a === sc ? void 0 : a;
    }

    return uc.call(e, c) ? e[c] : void 0;
  },
      mc = Object.prototype.hasOwnProperty;

  var vc = function vc(c) {
    var e = this.__data__;
    return oc ? void 0 !== e[c] : mc.call(e, c);
  },
      dc = "__lodash_hash_undefined__";

  var Mc = function Mc(c, e) {
    var a = this.__data__;
    return this.size += this.has(c) ? 0 : 1, a[c] = oc && void 0 === e ? dc : e, this;
  };

  function pc(c) {
    var e = -1,
        a = null == c ? 0 : c.length;

    for (this.clear(); ++e < a;) {
      var n = c[e];
      this.set(n[0], n[1]);
    }
  }

  pc.prototype.clear = lc, pc.prototype.delete = fc, pc.prototype.get = hc, pc.prototype.has = vc, pc.prototype.set = Mc;
  var zc = pc;

  var Cc = function Cc() {
    this.__data__ = [], this.size = 0;
  };

  var Lc = function Lc(c, e) {
    return c === e || c != c && e != e;
  };

  var Ac = function Ac(c, e) {
    for (var a = c.length; a--;) {
      if (Lc(c[a][0], e)) return a;
    }

    return -1;
  },
      Nc = Array.prototype.splice;

  var gc = function gc(c) {
    var e = this.__data__,
        a = Ac(e, c);
    return !(a < 0 || (a == e.length - 1 ? e.pop() : Nc.call(e, a, 1), --this.size, 0));
  };

  var Hc = function Hc(c) {
    var e = this.__data__,
        a = Ac(e, c);
    return a < 0 ? void 0 : e[a][1];
  };

  var Vc = function Vc(c) {
    return Ac(this.__data__, c) > -1;
  };

  var xc = function xc(c, e) {
    var a = this.__data__,
        n = Ac(a, c);
    return n < 0 ? (++this.size, a.push([c, e])) : a[n][1] = e, this;
  };

  function wc(c) {
    var e = -1,
        a = null == c ? 0 : c.length;

    for (this.clear(); ++e < a;) {
      var n = c[e];
      this.set(n[0], n[1]);
    }
  }

  wc.prototype.clear = Cc, wc.prototype.delete = gc, wc.prototype.get = Hc, wc.prototype.has = Vc, wc.prototype.set = xc;
  var yc = wc,
      bc = ic(A.a, "Map");

  var Sc = function Sc() {
    this.size = 0, this.__data__ = {
      hash: new zc(),
      map: new (bc || yc)(),
      string: new zc()
    };
  };

  var Tc = function Tc(c) {
    var e = typeof c;
    return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== c : null === c;
  };

  var Dc = function Dc(c, e) {
    var a = c.__data__;
    return Tc(e) ? a["string" == typeof e ? "string" : "hash"] : a.map;
  };

  var jc = function jc(c) {
    var e = Dc(this, c).delete(c);
    return this.size -= e ? 1 : 0, e;
  };

  var Ec = function Ec(c) {
    return Dc(this, c).get(c);
  };

  var kc = function kc(c) {
    return Dc(this, c).has(c);
  };

  var Ic = function Ic(c, e) {
    var a = Dc(this, c),
        n = a.size;
    return a.set(c, e), this.size += a.size == n ? 0 : 1, this;
  };

  function Oc(c) {
    var e = -1,
        a = null == c ? 0 : c.length;

    for (this.clear(); ++e < a;) {
      var n = c[e];
      this.set(n[0], n[1]);
    }
  }

  Oc.prototype.clear = Sc, Oc.prototype.delete = jc, Oc.prototype.get = Ec, Oc.prototype.has = kc, Oc.prototype.set = Ic;
  var Qc = Oc,
      Zc = "Expected a function";

  function Uc(c, e) {
    if ("function" != typeof c || null != e && "function" != typeof e) throw new TypeError(Zc);

    var a = function a() {
      var n = arguments,
          t = e ? e.apply(this, n) : n[0],
          r = a.cache;
      if (r.has(t)) return r.get(t);
      var i = c.apply(this, n);
      return a.cache = r.set(t, i) || r, i;
    };

    return a.cache = new (Uc.Cache || Qc)(), a;
  }

  Uc.Cache = Qc;
  var Bc = Uc,
      Rc = 500;

  var Yc = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      Pc = /\\(\\)?/g,
      Fc = function (c) {
    var e = Bc(c, function (c) {
      return a.size === Rc && a.clear(), c;
    }),
        a = e.cache;
    return e;
  }(function (c) {
    var e = [];
    return 46 === c.charCodeAt(0) && e.push(""), c.replace(Yc, function (c, a, n, t) {
      e.push(n ? t.replace(Pc, "$1") : a || c);
    }), e;
  });

  var Wc = function Wc(c, e) {
    for (var a = -1, n = null == c ? 0 : c.length, t = Array(n); ++a < n;) {
      t[a] = e(c[a], a, c);
    }

    return t;
  },
      Gc = 1 / 0,
      qc = N ? N.prototype : void 0,
      Jc = qc ? qc.toString : void 0;

  var Kc = function c(e) {
    if ("string" == typeof e) return e;
    if (L(e)) return Wc(e, c) + "";
    if (I(e)) return Jc ? Jc.call(e) : "";
    var a = e + "";
    return "0" == a && 1 / e == -Gc ? "-0" : a;
  };

  var Xc = function Xc(c) {
    return null == c ? "" : Kc(c);
  };

  var _c = function _c(c, e) {
    return L(c) ? c : Z(c, e) ? [c] : Fc(Xc(c));
  },
      $c = "[object Arguments]";

  var ce = function ce(c) {
    return E(c) && j(c) == $c;
  },
      ee = Object.prototype,
      ae = ee.hasOwnProperty,
      ne = ee.propertyIsEnumerable,
      te = ce(function () {
    return arguments;
  }()) ? ce : function (c) {
    return E(c) && ae.call(c, "callee") && !ne.call(c, "callee");
  },
      re = 9007199254740991,
      ie = /^(?:0|[1-9]\d*)$/;

  var oe = function oe(c, e) {
    var a = typeof c;
    return !!(e = null == e ? re : e) && ("number" == a || "symbol" != a && ie.test(c)) && c > -1 && c % 1 == 0 && c < e;
  },
      le = 9007199254740991;

  var fe = function fe(c) {
    return "number" == typeof c && c > -1 && c % 1 == 0 && c <= le;
  },
      se = 1 / 0;

  var ue = function ue(c) {
    if ("string" == typeof c || I(c)) return c;
    var e = c + "";
    return "0" == e && 1 / c == -se ? "-0" : e;
  };

  var he = function he(c, e, a) {
    for (var n = -1, t = (e = _c(e, c)).length, r = !1; ++n < t;) {
      var i = ue(e[n]);
      if (!(r = null != c && a(c, i))) break;
      c = c[i];
    }

    return r || ++n != t ? r : !!(t = null == c ? 0 : c.length) && fe(t) && oe(i, t) && (L(c) || te(c));
  };

  var me = function me(c, e) {
    return null != c && he(c, e, C);
  };

  var ve = function ve(c, e, a) {
    switch (a.length) {
      case 0:
        return c.call(e);

      case 1:
        return c.call(e, a[0]);

      case 2:
        return c.call(e, a[0], a[1]);

      case 3:
        return c.call(e, a[0], a[1], a[2]);
    }

    return c.apply(e, a);
  };

  var de = function de(c) {
    var e = null == c ? 0 : c.length;
    return e ? c[e - 1] : void 0;
  };

  var Me = function Me(c, e) {
    for (var a = 0, n = (e = _c(e, c)).length; null != c && a < n;) {
      c = c[ue(e[a++])];
    }

    return a && a == n ? c : void 0;
  };

  var pe = function pe(c, e, a) {
    var n = -1,
        t = c.length;
    e < 0 && (e = -e > t ? 0 : t + e), (a = a > t ? t : a) < 0 && (a += t), t = e > a ? 0 : a - e >>> 0, e >>>= 0;

    for (var r = Array(t); ++n < t;) {
      r[n] = c[n + e];
    }

    return r;
  };

  var ze = function ze(c, e) {
    return e.length < 2 ? c : Me(c, pe(e, 0, -1));
  };

  var Ce = function Ce(c, e, a) {
    e = _c(e, c);
    var n = null == (c = ze(c, e)) ? c : c[ue(de(e))];
    return null == n ? void 0 : ve(n, c, a);
  };

  var Le = function Le(c) {
    return c;
  },
      Ae = Math.max;

  var Ne = function Ne(c, e, a) {
    return e = Ae(void 0 === e ? c.length - 1 : e, 0), function () {
      for (var n = arguments, t = -1, r = Ae(n.length - e, 0), i = Array(r); ++t < r;) {
        i[t] = n[e + t];
      }

      t = -1;

      for (var o = Array(e + 1); ++t < e;) {
        o[t] = n[t];
      }

      return o[e] = a(i), ve(c, this, o);
    };
  };

  var ge = function ge(c) {
    return function () {
      return c;
    };
  },
      He = function () {
    try {
      var c = ic(Object, "defineProperty");
      return c({}, "", {}), c;
    } catch (c) {}
  }(),
      Ve = He ? function (c, e) {
    return He(c, "toString", {
      configurable: !0,
      enumerable: !1,
      value: ge(e),
      writable: !0
    });
  } : Le,
      xe = 800,
      we = 16,
      ye = Date.now;

  var be = function be(c) {
    var e = 0,
        a = 0;
    return function () {
      var n = ye(),
          t = we - (n - a);

      if (a = n, t > 0) {
        if (++e >= xe) return arguments[0];
      } else e = 0;

      return c.apply(void 0, arguments);
    };
  },
      Se = be(Ve);

  var Te = function Te(c, e) {
    return Se(Ne(c, e, Le), c + "");
  },
      De = Te(Ce),
      je = function je(c, e) {
    var a = c.handledProps,
        n = void 0 === a ? [] : a;
    return Object.keys(e).reduce(function (c, a) {
      return "childKey" === a ? c : (-1 === n.indexOf(a) && (c[a] = e[a]), c);
    }, {});
  };

  var Ee = function Ee(c) {
    return null == c;
  };

  function ke(c) {
    var e,
        a,
        n = "";
    if ("string" == typeof c || "number" == typeof c) n += c;else if ("object" == typeof c) if (Array.isArray(c)) for (e = 0; e < c.length; e++) {
      c[e] && (a = ke(c[e])) && (n && (n += " "), n += a);
    } else for (e in c) {
      c[e] && (n && (n += " "), n += e);
    }
    return n;
  }

  var Ie = function Ie() {
    for (var c, e, a = 0, n = ""; a < arguments.length;) {
      (c = arguments[a++]) && (e = ke(c)) && (n && (n += " "), n += e);
    }

    return n;
  };

  var Oe = function Oe() {
    this.__data__ = new yc(), this.size = 0;
  };

  var Qe = function Qe(c) {
    var e = this.__data__,
        a = e.delete(c);
    return this.size = e.size, a;
  };

  var Ze = function Ze(c) {
    return this.__data__.get(c);
  };

  var Ue = function Ue(c) {
    return this.__data__.has(c);
  },
      Be = 200;

  var Re = function Re(c, e) {
    var a = this.__data__;

    if (a instanceof yc) {
      var n = a.__data__;
      if (!bc || n.length < Be - 1) return n.push([c, e]), this.size = ++a.size, this;
      a = this.__data__ = new Qc(n);
    }

    return a.set(c, e), this.size = a.size, this;
  };

  function Ye(c) {
    var e = this.__data__ = new yc(c);
    this.size = e.size;
  }

  Ye.prototype.clear = Oe, Ye.prototype.delete = Qe, Ye.prototype.get = Ze, Ye.prototype.has = Ue, Ye.prototype.set = Re;
  var Pe = Ye,
      Fe = "__lodash_hash_undefined__";

  var We = function We(c) {
    return this.__data__.set(c, Fe), this;
  };

  var Ge = function Ge(c) {
    return this.__data__.has(c);
  };

  function qe(c) {
    var e = -1,
        a = null == c ? 0 : c.length;

    for (this.__data__ = new Qc(); ++e < a;) {
      this.add(c[e]);
    }
  }

  qe.prototype.add = qe.prototype.push = We, qe.prototype.has = Ge;
  var Je = qe;

  var Ke = function Ke(c, e) {
    for (var a = -1, n = null == c ? 0 : c.length; ++a < n;) {
      if (e(c[a], a, c)) return !0;
    }

    return !1;
  };

  var Xe = function Xe(c, e) {
    return c.has(e);
  },
      _e = 1,
      $e = 2;

  var ca = function ca(c, e, a, n, t, r) {
    var i = a & _e,
        o = c.length,
        l = e.length;
    if (o != l && !(i && l > o)) return !1;
    var f = r.get(c),
        s = r.get(e);
    if (f && s) return f == e && s == c;
    var u = -1,
        h = !0,
        m = a & $e ? new Je() : void 0;

    for (r.set(c, e), r.set(e, c); ++u < o;) {
      var v = c[u],
          d = e[u];
      if (n) var M = i ? n(d, v, u, e, c, r) : n(v, d, u, c, e, r);

      if (void 0 !== M) {
        if (M) continue;
        h = !1;
        break;
      }

      if (m) {
        if (!Ke(e, function (c, e) {
          if (!Xe(m, e) && (v === c || t(v, c, a, n, r))) return m.push(e);
        })) {
          h = !1;
          break;
        }
      } else if (v !== d && !t(v, d, a, n, r)) {
        h = !1;
        break;
      }
    }

    return r.delete(c), r.delete(e), h;
  },
      ea = A.a.Uint8Array;

  var aa = function aa(c) {
    var e = -1,
        a = Array(c.size);
    return c.forEach(function (c, n) {
      a[++e] = [n, c];
    }), a;
  };

  var na = function na(c) {
    var e = -1,
        a = Array(c.size);
    return c.forEach(function (c) {
      a[++e] = c;
    }), a;
  },
      ta = 1,
      ra = 2,
      ia = "[object Boolean]",
      oa = "[object Date]",
      la = "[object Error]",
      fa = "[object Map]",
      sa = "[object Number]",
      ua = "[object RegExp]",
      ha = "[object Set]",
      ma = "[object String]",
      va = "[object Symbol]",
      da = "[object ArrayBuffer]",
      Ma = "[object DataView]",
      pa = N ? N.prototype : void 0,
      za = pa ? pa.valueOf : void 0;

  var Ca = function Ca(c, e, a, n, t, r, i) {
    switch (a) {
      case Ma:
        if (c.byteLength != e.byteLength || c.byteOffset != e.byteOffset) return !1;
        c = c.buffer, e = e.buffer;

      case da:
        return !(c.byteLength != e.byteLength || !r(new ea(c), new ea(e)));

      case ia:
      case oa:
      case sa:
        return Lc(+c, +e);

      case la:
        return c.name == e.name && c.message == e.message;

      case ua:
      case ma:
        return c == e + "";

      case fa:
        var o = aa;

      case ha:
        var l = n & ta;
        if (o || (o = na), c.size != e.size && !l) return !1;
        var f = i.get(c);
        if (f) return f == e;
        n |= ra, i.set(c, e);
        var s = ca(o(c), o(e), n, t, r, i);
        return i.delete(c), s;

      case va:
        if (za) return za.call(c) == za.call(e);
    }

    return !1;
  };

  var La = function La(c, e) {
    for (var a = -1, n = e.length, t = c.length; ++a < n;) {
      c[t + a] = e[a];
    }

    return c;
  };

  var Aa = function Aa(c, e, a) {
    var n = e(c);
    return L(c) ? n : La(n, a(c));
  };

  var Na = function Na(c, e) {
    for (var a = -1, n = null == c ? 0 : c.length, t = 0, r = []; ++a < n;) {
      var i = c[a];
      e(i, a, c) && (r[t++] = i);
    }

    return r;
  };

  var ga = function ga() {
    return [];
  },
      Ha = Object.prototype.propertyIsEnumerable,
      Va = Object.getOwnPropertySymbols,
      xa = Va ? function (c) {
    return null == c ? [] : (c = Object(c), Na(Va(c), function (e) {
      return Ha.call(c, e);
    }));
  } : ga;

  var wa = function wa(c, e) {
    for (var a = -1, n = Array(c); ++a < c;) {
      n[a] = e(a);
    }

    return n;
  },
      ya = a(17),
      ba = {};

  ba["[object Float32Array]"] = ba["[object Float64Array]"] = ba["[object Int8Array]"] = ba["[object Int16Array]"] = ba["[object Int32Array]"] = ba["[object Uint8Array]"] = ba["[object Uint8ClampedArray]"] = ba["[object Uint16Array]"] = ba["[object Uint32Array]"] = !0, ba["[object Arguments]"] = ba["[object Array]"] = ba["[object ArrayBuffer]"] = ba["[object Boolean]"] = ba["[object DataView]"] = ba["[object Date]"] = ba["[object Error]"] = ba["[object Function]"] = ba["[object Map]"] = ba["[object Number]"] = ba["[object Object]"] = ba["[object RegExp]"] = ba["[object Set]"] = ba["[object String]"] = ba["[object WeakMap]"] = !1;

  var Sa = function Sa(c) {
    return E(c) && fe(c.length) && !!ba[j(c)];
  };

  var Ta = function Ta(c) {
    return function (e) {
      return c(e);
    };
  },
      Da = a(57),
      ja = Da.a && Da.a.isTypedArray,
      Ea = ja ? Ta(ja) : Sa,
      ka = Object.prototype.hasOwnProperty;

  var Ia = function Ia(c, e) {
    var a = L(c),
        n = !a && te(c),
        t = !a && !n && Object(ya.a)(c),
        r = !a && !n && !t && Ea(c),
        i = a || n || t || r,
        o = i ? wa(c.length, String) : [],
        l = o.length;

    for (var f in c) {
      !e && !ka.call(c, f) || i && ("length" == f || t && ("offset" == f || "parent" == f) || r && ("buffer" == f || "byteLength" == f || "byteOffset" == f) || oe(f, l)) || o.push(f);
    }

    return o;
  },
      Oa = Object.prototype;

  var Qa = function Qa(c) {
    var e = c && c.constructor;
    return c === ("function" == typeof e && e.prototype || Oa);
  };

  var Za = function Za(c, e) {
    return function (a) {
      return c(e(a));
    };
  },
      Ua = Za(Object.keys, Object),
      Ba = Object.prototype.hasOwnProperty;

  var Ra = function Ra(c) {
    if (!Qa(c)) return Ua(c);
    var e = [];

    for (var a in Object(c)) {
      Ba.call(c, a) && "constructor" != a && e.push(a);
    }

    return e;
  };

  var Ya = function Ya(c) {
    return null != c && fe(c.length) && !W(c);
  };

  var Pa = function Pa(c) {
    return Ya(c) ? Ia(c) : Ra(c);
  };

  var Fa = function Fa(c) {
    return Aa(c, Pa, xa);
  },
      Wa = 1,
      Ga = Object.prototype.hasOwnProperty;

  var qa = function qa(c, e, a, n, t, r) {
    var i = a & Wa,
        o = Fa(c),
        l = o.length;
    if (l != Fa(e).length && !i) return !1;

    for (var f = l; f--;) {
      var s = o[f];
      if (!(i ? s in e : Ga.call(e, s))) return !1;
    }

    var u = r.get(c),
        h = r.get(e);
    if (u && h) return u == e && h == c;
    var m = !0;
    r.set(c, e), r.set(e, c);

    for (var v = i; ++f < l;) {
      var d = c[s = o[f]],
          M = e[s];
      if (n) var p = i ? n(M, d, s, e, c, r) : n(d, M, s, c, e, r);

      if (!(void 0 === p ? d === M || t(d, M, a, n, r) : p)) {
        m = !1;
        break;
      }

      v || (v = "constructor" == s);
    }

    if (m && !v) {
      var z = c.constructor,
          C = e.constructor;
      z != C && "constructor" in c && "constructor" in e && !("function" == typeof z && z instanceof z && "function" == typeof C && C instanceof C) && (m = !1);
    }

    return r.delete(c), r.delete(e), m;
  },
      Ja = ic(A.a, "DataView"),
      Ka = ic(A.a, "Promise"),
      Xa = ic(A.a, "Set"),
      _a = ic(A.a, "WeakMap"),
      $a = X(Ja),
      cn = X(bc),
      en = X(Ka),
      an = X(Xa),
      nn = X(_a),
      tn = j;

  (Ja && "[object DataView]" != tn(new Ja(new ArrayBuffer(1))) || bc && "[object Map]" != tn(new bc()) || Ka && "[object Promise]" != tn(Ka.resolve()) || Xa && "[object Set]" != tn(new Xa()) || _a && "[object WeakMap]" != tn(new _a())) && (tn = function tn(c) {
    var e = j(c),
        a = "[object Object]" == e ? c.constructor : void 0,
        n = a ? X(a) : "";
    if (n) switch (n) {
      case $a:
        return "[object DataView]";

      case cn:
        return "[object Map]";

      case en:
        return "[object Promise]";

      case an:
        return "[object Set]";

      case nn:
        return "[object WeakMap]";
    }
    return e;
  });
  var rn = tn,
      on = 1,
      ln = "[object Arguments]",
      fn = "[object Array]",
      sn = "[object Object]",
      un = Object.prototype.hasOwnProperty;

  var hn = function hn(c, e, a, n, t, r) {
    var i = L(c),
        o = L(e),
        l = i ? fn : rn(c),
        f = o ? fn : rn(e),
        s = (l = l == ln ? sn : l) == sn,
        u = (f = f == ln ? sn : f) == sn,
        h = l == f;

    if (h && Object(ya.a)(c)) {
      if (!Object(ya.a)(e)) return !1;
      i = !0, s = !1;
    }

    if (h && !s) return r || (r = new Pe()), i || Ea(c) ? ca(c, e, a, n, t, r) : Ca(c, e, l, a, n, t, r);

    if (!(a & on)) {
      var m = s && un.call(c, "__wrapped__"),
          v = u && un.call(e, "__wrapped__");

      if (m || v) {
        var d = m ? c.value() : c,
            M = v ? e.value() : e;
        return r || (r = new Pe()), t(d, M, a, n, r);
      }
    }

    return !!h && (r || (r = new Pe()), qa(c, e, a, n, t, r));
  };

  var mn = function c(e, a, n, t, r) {
    return e === a || (null == e || null == a || !E(e) && !E(a) ? e != e && a != a : hn(e, a, n, t, c, r));
  },
      vn = 1,
      dn = 2;

  var Mn = function Mn(c, e, a, n) {
    var t = a.length,
        r = t,
        i = !n;
    if (null == c) return !r;

    for (c = Object(c); t--;) {
      var o = a[t];
      if (i && o[2] ? o[1] !== c[o[0]] : !(o[0] in c)) return !1;
    }

    for (; ++t < r;) {
      var l = (o = a[t])[0],
          f = c[l],
          s = o[1];

      if (i && o[2]) {
        if (void 0 === f && !(l in c)) return !1;
      } else {
        var u = new Pe();
        if (n) var h = n(f, s, l, c, e, u);
        if (!(void 0 === h ? mn(s, f, vn | dn, n, u) : h)) return !1;
      }
    }

    return !0;
  };

  var pn = function pn(c) {
    return c == c && !U(c);
  };

  var zn = function zn(c) {
    for (var e = Pa(c), a = e.length; a--;) {
      var n = e[a],
          t = c[n];
      e[a] = [n, t, pn(t)];
    }

    return e;
  };

  var Cn = function Cn(c, e) {
    return function (a) {
      return null != a && a[c] === e && (void 0 !== e || c in Object(a));
    };
  };

  var Ln = function Ln(c) {
    var e = zn(c);
    return 1 == e.length && e[0][2] ? Cn(e[0][0], e[0][1]) : function (a) {
      return a === c || Mn(a, c, e);
    };
  };

  var An = function An(c, e, a) {
    var n = null == c ? void 0 : Me(c, e);
    return void 0 === n ? a : n;
  };

  var Nn = function Nn(c, e) {
    return null != c && e in Object(c);
  };

  var gn = function gn(c, e) {
    return null != c && he(c, e, Nn);
  },
      Hn = 1,
      Vn = 2;

  var xn = function xn(c, e) {
    return Z(c) && pn(e) ? Cn(ue(c), e) : function (a) {
      var n = An(a, c);
      return void 0 === n && n === e ? gn(a, c) : mn(e, n, Hn | Vn);
    };
  };

  var wn = function wn(c) {
    return function (e) {
      return null == e ? void 0 : e[c];
    };
  };

  var yn = function yn(c) {
    return function (e) {
      return Me(e, c);
    };
  };

  var bn = function bn(c) {
    return Z(c) ? wn(ue(c)) : yn(c);
  };

  var Sn = function Sn(c) {
    return "function" == typeof c ? c : null == c ? Le : "object" == typeof c ? L(c) ? xn(c[0], c[1]) : Ln(c) : bn(c);
  };

  var Tn = function Tn(c) {
    return function (e, a, n) {
      var t = Object(e);

      if (!Ya(e)) {
        var r = Sn(a, 3);
        e = Pa(e), a = function a(c) {
          return r(t[c], c, t);
        };
      }

      var i = c(e, a, n);
      return i > -1 ? t[r ? e[i] : i] : void 0;
    };
  };

  var Dn = function Dn(c, e, a, n) {
    for (var t = c.length, r = a + (n ? 1 : -1); n ? r-- : ++r < t;) {
      if (e(c[r], r, c)) return r;
    }

    return -1;
  },
      jn = /\s/;

  var En = function En(c) {
    for (var e = c.length; e-- && jn.test(c.charAt(e));) {
      ;
    }

    return e;
  },
      kn = /^\s+/;

  var In = function In(c) {
    return c ? c.slice(0, En(c) + 1).replace(kn, "") : c;
  },
      On = NaN,
      Qn = /^[-+]0x[0-9a-f]+$/i,
      Zn = /^0b[01]+$/i,
      Un = /^0o[0-7]+$/i,
      Bn = parseInt;

  var Rn = function Rn(c) {
    if ("number" == typeof c) return c;
    if (I(c)) return On;

    if (U(c)) {
      var e = "function" == typeof c.valueOf ? c.valueOf() : c;
      c = U(e) ? e + "" : e;
    }

    if ("string" != typeof c) return 0 === c ? c : +c;
    c = In(c);
    var a = Zn.test(c);
    return a || Un.test(c) ? Bn(c.slice(2), a ? 2 : 8) : Qn.test(c) ? On : +c;
  },
      Yn = 1 / 0,
      Pn = 1.7976931348623157e308;

  var Fn = function Fn(c) {
    return c ? (c = Rn(c)) === Yn || c === -Yn ? (c < 0 ? -1 : 1) * Pn : c == c ? c : 0 : 0 === c ? c : 0;
  };

  var Wn = function Wn(c) {
    var e = Fn(c),
        a = e % 1;
    return e == e ? a ? e - a : e : 0;
  },
      Gn = Math.max;

  var qn = function qn(c, e, a) {
    var n = null == c ? 0 : c.length;
    if (!n) return -1;
    var t = null == a ? 0 : Wn(a);
    return t < 0 && (t = Gn(n + t, 0)), Dn(c, Sn(e, 3), t);
  },
      Jn = Tn(qn);

  var Kn = function (c) {
    return function (e, a, n) {
      for (var t = -1, r = Object(e), i = n(e), o = i.length; o--;) {
        var l = i[c ? o : ++t];
        if (!1 === a(r[l], l, r)) break;
      }

      return e;
    };
  }();

  var Xn = function Xn(c, e) {
    return c && Kn(c, e, Pa);
  };

  var _n = function (c, e) {
    return function (a, n) {
      if (null == a) return a;
      if (!Ya(a)) return c(a, n);

      for (var t = a.length, r = e ? t : -1, i = Object(a); (e ? r-- : ++r < t) && !1 !== n(i[r], r, i);) {
        ;
      }

      return a;
    };
  }(Xn);

  var $n = function $n(c, e) {
    var a;
    return _n(c, function (c, n, t) {
      return !(a = e(c, n, t));
    }), !!a;
  };

  var ct = function ct(c, e, a) {
    if (!U(a)) return !1;
    var n = typeof e;
    return !!("number" == n ? Ya(a) && oe(e, a.length) : "string" == n && e in a) && Lc(a[e], c);
  };

  var et = function et(c, e, a) {
    var n = L(c) ? Ke : $n;
    return a && ct(c, e, a) && (e = void 0), n(c, Sn(e, 3));
  },
      at = function at(c, e) {
    return et(i.Children.toArray(c), {
      type: e
    });
  },
      nt = function nt(c, e) {
    return Jn(i.Children.toArray(c), {
      type: e
    });
  },
      tt = function tt(c) {
    return null == c || Array.isArray(c) && 0 === c.length;
  };

  var rt = function rt(c) {
    return c != c;
  };

  var it = function it(c, e, a) {
    for (var n = a - 1, t = c.length; ++n < t;) {
      if (c[n] === e) return n;
    }

    return -1;
  };

  var ot = function ot(c, e, a) {
    return e == e ? it(c, e, a) : Dn(c, rt, a);
  };

  var lt = function lt(c, e) {
    return !(null == c || !c.length) && ot(c, e, 0) > -1;
  };

  var ft = function ft(c, e, a) {
    for (var n = -1, t = null == c ? 0 : c.length; ++n < t;) {
      if (a(e, c[n])) return !0;
    }

    return !1;
  };

  var st = function st() {},
      ut = Xa && 1 / na(new Xa([, -0]))[1] == 1 / 0 ? function (c) {
    return new Xa(c);
  } : st,
      ht = 200;

  var mt = function mt(c, e, a) {
    var n = -1,
        t = lt,
        r = c.length,
        i = !0,
        o = [],
        l = o;
    if (a) i = !1, t = ft;else if (r >= ht) {
      var f = e ? null : ut(c);
      if (f) return na(f);
      i = !1, t = Xe, l = new Je();
    } else l = e ? [] : o;

    c: for (; ++n < r;) {
      var s = c[n],
          u = e ? e(s) : s;

      if (s = a || 0 !== s ? s : 0, i && u == u) {
        for (var h = l.length; h--;) {
          if (l[h] === u) continue c;
        }

        e && l.push(u), o.push(s);
      } else t(l, u, a) || (l !== o && l.push(u), o.push(s));
    }

    return o;
  };

  var vt = function vt(c) {
    return c && c.length ? mt(c) : [];
  };

  var dt = function dt(c, e) {
    return Wc(e, function (e) {
      return c[e];
    });
  };

  var Mt = function Mt(c) {
    return null == c ? [] : dt(c, Pa(c));
  },
      pt = {
    1: "one",
    2: "two",
    3: "three",
    4: "four",
    5: "five",
    6: "six",
    7: "seven",
    8: "eight",
    9: "nine",
    10: "ten",
    11: "eleven",
    12: "twelve",
    13: "thirteen",
    14: "fourteen",
    15: "fifteen",
    16: "sixteen"
  };

  function zt(c) {
    var e = typeof c;
    return "string" === e || "number" === e ? pt[c] || c : "";
  }

  var Ct = ["red", "orange", "yellow", "olive", "green", "teal", "blue", "violet", "purple", "pink", "brown", "grey", "black"],
      Lt = ["left", "right"],
      At = ["mini", "tiny", "small", "medium", "large", "big", "huge", "massive"],
      Nt = ["left", "center", "right", "justified"],
      gt = ["bottom", "middle", "top"],
      Ht = ["mobile", "tablet", "computer", "large screen", "widescreen"],
      Vt = [].concat(Pa(pt), Pa(pt).map(Number), Mt(pt)),
      xt = ["browse", "browse right", "drop", "fade", "fade up", "fade down", "fade left", "fade right", "fly up", "fly down", "fly left", "fly right", "horizontal flip", "vertical flip", "scale", "slide up", "slide down", "slide left", "slide right", "swing up", "swing down", "swing left", "swing right", "zoom"],
      wt = ["jiggle", "flash", "shake", "pulse", "tada", "bounce", "glow"],
      yt = [].concat(xt, wt),
      bt = ["american sign language interpreting", "assistive listening systems", "audio description", "blind", "braille", "closed captioning", "closed captioning outline", "deaf", "low vision", "phone volume", "question circle", "question circle outline", "sign language", "tty", "universal access", "wheelchair"],
      St = ["angle double down", "angle double left", "angle double right", "angle double up", "angle down", "angle left", "angle right", "angle up", "arrow alternate circle down", "arrow alternate circle down outline", "arrow alternate circle left", "arrow alternate circle left outline", "arrow alternate circle right", "arrow alternate circle right outline", "arrow alternate circle up", "arrow alternate circle up outline", "arrow circle down", "arrow circle left", "arrow circle right", "arrow circle up", "arrow down", "arrow left", "arrow right", "arrow up", "arrows alternate", "arrows alternate horizontal", "arrows alternate vertical", "caret down", "caret left", "caret right", "caret square down", "caret square down outline", "caret square left", "caret square left outline", "caret square right", "caret square right outline", "caret square up", "caret square up outline", "caret up", "cart arrow down", "chart line", "chevron circle down", "chevron circle left", "chevron circle right", "chevron circle up", "chevron down", "chevron left", "chevron right", "chevron up", "cloud download", "cloud upload", "download", "exchange", "expand arrows alternate", "external alternate", "external square alternate", "hand point down", "hand point down outline", "hand point left", "hand point left outline", "hand point right", "hand point right outline", "hand point up", "hand point up outline", "hand pointer", "hand pointer outline", "history", "level down alternate", "level up alternate", "location arrow", "long arrow alternate down", "long arrow alternate left", "long arrow alternate right", "long arrow alternate up", "mouse pointer", "play", "random", "recycle", "redo", "redo alternate", "reply", "reply all", "retweet", "share", "share square", "share square outline", "sign-in", "sign-out", "sign-in alternate", "sign-out alternate", "sort", "sort alphabet down", "sort alphabet up", "sort amount down", "sort amount up", "sort down", "sort numeric down", "sort numeric up", "sort up", "sync", "sync alternate", "text height", "text width", "undo", "undo alternate", "upload", "zoom-in", "zoom-out"],
      Tt = ["audio description", "backward", "circle", "circle outline", "closed captioning", "closed captioning outline", "compress", "eject", "expand", "expand arrows alternate", "fast backward", "fast forward", "file audio", "file audio outline", "file video", "file video outline", "film", "forward", "headphones", "microphone", "microphone slash", "music", "pause", "pause circle", "pause circle outline", "phone volume", "play", "play circle", "play circle outline", "podcast", "random", "redo", "redo alternate", "rss", "rss square", "step backward", "step forward", "stop", "stop circle", "stop circle outline", "sync", "sync alternate", "undo", "undo alternate", "video", "volume down", "volume off", "volume up"],
      Dt = ["address book", "address book outline", "address card", "address card outline", "archive", "balance scale", "birthday cake", "book", "briefcase", "building", "building outline", "bullhorn", "bullseye", "calculator", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "certificate", "chart area", "chart bar", "chart bar outline", "chart line", "chart pie", "clipboard", "clipboard outline", "coffee", "columns", "compass", "compass outline", "copy", "copy outline", "copyright", "copyright outline", "cut", "edit", "edit outline", "envelope", "envelope outline", "envelope open", "envelope open outline", "envelope square", "eraser", "fax", "file", "file outline", "file alternate", "file alternate outline", "folder", "folder outline", "folder open", "folder open outline", "globe", "industry", "paperclip", "paste", "pen square", "pencil alternate", "percent", "phone", "phone square", "phone volume", "registered", "registered outline", "save", "save outline", "sitemap", "sticky note", "sticky note outline", "suitcase", "table", "tag", "tags", "tasks", "thumbtack", "trademark"],
      jt = ["chess", "chess bishop", "chess board", "chess king", "chess knight", "chess pawn", "chess queen", "chess rook", "square full"],
      Et = ["archive", "barcode", "bath", "bug", "code", "code branch", "coffee", "file", "file outline", "file alternate", "file alternate outline", "file code", "file code outline", "filter", "fire extinguisher", "folder", "folder outline", "folder open", "folder open outline", "keyboard", "keyboard outline", "microchip", "qrcode", "shield alternate", "sitemap", "terminal", "user secret", "window close", "window close outline", "window maximize", "window maximize outline", "window minimize", "window minimize outline", "window restore", "window restore outline"],
      kt = ["address book", "address book outline", "address card", "address card outline", "american sign language interpreting", "assistive listening systems", "at", "bell", "bell outline", "bell slash", "bell slash outline", "bullhorn", "comment", "comment outline", "comment alternate", "comment alternate outline", "comments", "comments outline", "envelope", "envelope outline", "envelope open", "envelope open outline", "envelope square", "fax", "inbox", "language", "microphone", "microphone slash", "mobile", "mobile alternate", "paper plane", "paper plane outline", "phone", "phone square", "phone volume", "rss", "rss square", "tty", "wifi"],
      It = ["desktop", "download", "hdd", "hdd outline", "headphones", "keyboard", "keyboard outline", "laptop", "microchip", "mobile", "mobile alternate", "plug", "power off", "print", "save", "save outline", "server", "tablet", "tablet alternate", "tv", "upload"],
      Ot = ["dollar sign", "euro sign", "lira sign", "money bill alternate", "money bill alternate outline", "pound sign", "ruble sign", "rupee sign", "shekel sign", "won sign", "yen sign"],
      Qt = ["bell", "bell outline", "bell slash", "bell slash outline", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "calendar check", "calendar check outline", "calendar minus", "calendar minus outline", "calendar plus", "calendar plus outline", "calendar times", "calendar times outline", "clock", "clock outline", "hourglass", "hourglass outline", "hourglass end", "hourglass half", "hourglass start", "stopwatch"],
      Zt = ["adjust", "clone", "clone outline", "copy", "copy outline", "crop", "crosshairs", "cut", "edit", "edit outline", "eraser", "eye", "eye dropper", "eye slash", "eye slash outline", "object group", "object group outline", "object ungroup", "object ungroup outline", "paint brush", "paste", "pencil alternate", "save", "save outline", "tint"],
      Ut = ["align center", "align justify", "align left", "align right", "bold", "clipboard", "clipboard outline", "clone", "clone outline", "columns", "copy", "copy outline", "cut", "edit", "edit outline", "eraser", "file", "file outline", "file alternate", "file alternate outline", "font", "heading", "i cursor", "indent", "italic", "linkify", "list", "list alternate", "list alternate outline", "list ol", "list ul", "outdent", "paper plane", "paper plane outline", "paperclip", "paragraph", "paste", "pencil alternate", "print", "quote left", "quote right", "redo", "redo alternate", "reply", "reply all", "share", "strikethrough", "subscript", "superscript", "sync", "sync alternate", "table", "tasks", "text height", "text width", "th", "th large", "th list", "trash", "trash alternate", "trash alternate outline", "underline", "undo", "undo alternate", "unlink"],
      Bt = ["archive", "clone", "clone outline", "copy", "copy outline", "cut", "file", "file outline", "file alternate", "file alternate outline", "file archive", "file archive outline", "file audio", "file audio outline", "file code", "file code outline", "file excel", "file excel outline", "file image", "file image outline", "file pdf", "file pdf outline", "file powerpoint", "file powerpoint outline", "file video", "file video outline", "file word", "file word outline", "folder", "folder outline", "folder open", "folder open outline", "paste", "save", "save outline", "sticky note", "sticky note outline"],
      Rt = ["genderless", "mars", "mars double", "mars stroke", "mars stroke horizontal", "mars stroke vertical", "mercury", "neuter", "transgender", "transgender alternate", "venus", "venus double", "venus mars"],
      Yt = ["hand lizard", "hand lizard outline", "hand paper", "hand paper outline", "hand peace", "hand peace outline", "hand point down", "hand point down outline", "hand point left", "hand point left outline", "hand point right", "hand point right outline", "hand point up", "hand point up outline", "hand pointer", "hand pointer outline", "hand rock", "hand rock outline", "hand scissors", "hand scissors outline", "hand spock", "hand spock outline", "handshake", "handshake outline", "thumbs down", "thumbs down outline", "thumbs up", "thumbs up outline"],
      Pt = ["ambulance", "h square", "heart", "heart outline", "heartbeat", "hospital", "hospital outline", "medkit", "plus square", "plus square outline", "stethoscope", "user md", "wheelchair"],
      Ft = ["adjust", "bolt", "camera", "camera retro", "clone", "clone outline", "compress", "expand", "eye", "eye dropper", "eye slash", "eye slash outline", "file image", "file image outline", "film", "id badge", "id badge outline", "id card", "id card outline", "image", "image outline", "images", "images outline", "sliders horizontal", "tint"],
      Wt = ["ban", "barcode", "bars", "beer", "bell", "bell outline", "bell slash", "bell slash outline", "bug", "bullhorn", "bullseye", "calculator", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "calendar check", "calendar check outline", "calendar minus", "calendar minus outline", "calendar plus", "calendar plus outline", "calendar times", "calendar times outline", "certificate", "check", "check circle", "check circle outline", "check square", "check square outline", "circle", "circle outline", "clipboard", "clipboard outline", "clone", "clone outline", "cloud", "cloud download", "cloud upload", "coffee", "cog", "cogs", "copy", "copy outline", "cut", "database", "dot circle", "dot circle outline", "download", "edit", "edit outline", "ellipsis horizontal", "ellipsis vertical", "envelope", "envelope outline", "envelope open", "envelope open outline", "eraser", "exclamation", "exclamation circle", "exclamation triangle", "external alternate", "external square alternate", "eye", "eye slash", "eye slash outline", "file", "file outline", "file alternate", "file alternate outline", "filter", "flag", "flag outline", "flag checkered", "folder", "folder outline", "folder open", "folder open outline", "frown", "frown outline", "hashtag", "heart", "heart outline", "history", "home", "i cursor", "info", "info circle", "language", "magic", "meh", "meh outline", "microphone", "microphone slash", "minus", "minus circle", "minus square", "minus square outline", "paste", "pencil alternate", "plus", "plus circle", "plus square", "plus square outline", "qrcode", "question", "question circle", "question circle outline", "quote left", "quote right", "redo", "redo alternate", "reply", "reply all", "rss", "rss square", "save", "save outline", "search", "search minus", "search plus", "share", "share alternate", "share alternate square", "share square", "share square outline", "shield alternate", "sign-in", "sign-out", "signal", "sitemap", "sliders horizontal", "smile", "smile outline", "sort", "sort alphabet down", "sort alphabet up", "sort amount down", "sort amount up", "sort down", "sort numeric down", "sort numeric up", "sort up", "star", "star outline", "star half", "star half outline", "sync", "sync alternate", "thumbs down", "thumbs down outline", "thumbs up", "thumbs up outline", "times", "times circle", "times circle outline", "toggle off", "toggle on", "trash", "trash alternate", "trash alternate outline", "trophy", "undo", "undo alternate", "upload", "user", "user outline", "user circle", "user circle outline", "wifi"],
      Gt = ["box", "boxes", "clipboard check", "clipboard list", "dolly", "dolly flatbed", "pallet", "shipping fast", "truck", "warehouse"],
      qt = ["ambulance", "anchor", "balance scale", "bath", "bed", "beer", "bell", "bell outline", "bell slash", "bell slash outline", "bicycle", "binoculars", "birthday cake", "blind", "bomb", "book", "bookmark", "bookmark outline", "briefcase", "building", "building outline", "car", "coffee", "crosshairs", "dollar sign", "eye", "eye slash", "eye slash outline", "fighter jet", "fire", "fire extinguisher", "flag", "flag outline", "flag checkered", "flask", "gamepad", "gavel", "gift", "glass martini", "globe", "graduation cap", "h square", "heart", "heart outline", "heartbeat", "home", "hospital", "hospital outline", "image", "image outline", "images", "images outline", "industry", "info", "info circle", "key", "leaf", "lemon", "lemon outline", "life ring", "life ring outline", "lightbulb", "lightbulb outline", "location arrow", "low vision", "magnet", "male", "map", "map outline", "map marker", "map marker alternate", "map pin", "map signs", "medkit", "money bill alternate", "money bill alternate outline", "motorcycle", "music", "newspaper", "newspaper outline", "paw", "phone", "phone square", "phone volume", "plane", "plug", "plus", "plus square", "plus square outline", "print", "recycle", "road", "rocket", "search", "search minus", "search plus", "ship", "shopping bag", "shopping basket", "shopping cart", "shower", "street view", "subway", "suitcase", "tag", "tags", "taxi", "thumbtack", "ticket alternate", "tint", "train", "tree", "trophy", "truck", "tty", "umbrella", "university", "utensil spoon", "utensils", "wheelchair", "wifi", "wrench"],
      Jt = ["ambulance", "band aid", "dna", "first aid", "heart", "heart outline", "heartbeat", "hospital", "hospital outline", "hospital symbol", "pills", "plus", "stethoscope", "syringe", "thermometer", "user md", "weight"],
      Kt = ["ambulance", "anchor", "archive", "balance scale", "bath", "bed", "beer", "bell", "bell outline", "bicycle", "binoculars", "birthday cake", "bomb", "book", "bookmark", "bookmark outline", "briefcase", "bug", "building", "building outline", "bullhorn", "bullseye", "bus", "calculator", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "camera", "camera retro", "car", "clipboard", "clipboard outline", "cloud", "coffee", "cog", "cogs", "compass", "compass outline", "copy", "copy outline", "cube", "cubes", "cut", "envelope", "envelope outline", "envelope open", "envelope open outline", "eraser", "eye", "eye dropper", "fax", "fighter jet", "file", "file outline", "file alternate", "file alternate outline", "film", "fire", "fire extinguisher", "flag", "flag outline", "flag checkered", "flask", "futbol", "futbol outline", "gamepad", "gavel", "gem", "gem outline", "gift", "glass martini", "globe", "graduation cap", "hdd", "hdd outline", "headphones", "heart", "heart outline", "home", "hospital", "hospital outline", "hourglass", "hourglass outline", "image", "image outline", "images", "images outline", "industry", "key", "keyboard", "keyboard outline", "laptop", "leaf", "lemon", "lemon outline", "life ring", "life ring outline", "lightbulb", "lightbulb outline", "lock", "lock open", "magic", "magnet", "map", "map outline", "map marker", "map marker alternate", "map pin", "map signs", "medkit", "microchip", "microphone", "mobile", "mobile alternate", "money bill alternate", "money bill alternate outline", "moon", "moon outline", "motorcycle", "newspaper", "newspaper outline", "paint brush", "paper plane", "paper plane outline", "paperclip", "paste", "paw", "pencil alternate", "phone", "plane", "plug", "print", "puzzle piece", "road", "rocket", "save", "save outline", "search", "shield alternate", "shopping bag", "shopping basket", "shopping cart", "shower", "snowflake", "snowflake outline", "space shuttle", "star", "star outline", "sticky note", "sticky note outline", "stopwatch", "subway", "suitcase", "sun", "sun outline", "tablet", "tablet alternate", "tachometer alternate", "tag", "tags", "taxi", "thumbtack", "ticket alternate", "train", "trash", "trash alternate", "trash alternate outline", "tree", "trophy", "truck", "tv", "umbrella", "university", "unlock", "unlock alternate", "utensil spoon", "utensils", "wheelchair", "wrench"],
      Xt = ["bell", "bell outline", "bookmark", "bookmark outline", "bullhorn", "camera", "camera retro", "cart arrow down", "cart plus", "certificate", "credit card", "credit card outline", "gem", "gem outline", "gift", "handshake", "handshake outline", "heart", "heart outline", "key", "shopping bag", "shopping basket", "shopping cart", "star", "star outline", "tag", "tags", "thumbs down", "thumbs down outline", "thumbs up", "thumbs up outline", "trophy"],
      _t = ["bookmark", "bookmark outline", "calendar", "calendar outline", "certificate", "circle", "circle outline", "cloud", "comment", "comment outline", "file", "file outline", "folder", "folder outline", "heart", "heart outline", "map marker", "play", "square", "square outline", "star", "star outline"],
      $t = ["asterisk", "certificate", "circle notch", "cog", "compass", "compass outline", "crosshairs", "life ring", "life ring outline", "snowflake", "snowflake outline", "spinner", "sun", "sun outline", "sync"],
      cr = ["baseball ball", "basketball ball", "bowling ball", "football ball", "futbol", "futbol outline", "golf ball", "hockey puck", "quidditch", "table tennis", "volleyball ball"],
      er = ["ban", "battery empty", "battery full", "battery half", "battery quarter", "battery three quarters", "bell", "bell outline", "bell slash", "bell slash outline", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "calendar check", "calendar check outline", "calendar minus", "calendar minus outline", "calendar plus", "calendar plus outline", "calendar times", "calendar times outline", "cart arrow down", "cart plus", "exclamation", "exclamation circle", "exclamation triangle", "eye", "eye slash", "eye slash outline", "file", "file outline", "file alternate", "file alternate outline", "folder", "folder outline", "folder open", "folder open outline", "info", "info circle", "lock", "lock open", "minus", "minus circle", "minus square", "minus square outline", "plus", "plus circle", "plus square", "plus square outline", "question", "question circle", "question circle outline", "shield alternate", "shopping cart", "sign in alternate", "sign out alternate", "thermometer empty", "thermometer full", "thermometer half", "thermometer quarter", "thermometer three quarters", "thumbs down", "thumbs down outline", "thumbs up", "thumbs up outline", "toggle off", "toggle on", "unlock", "unlock alternate"],
      ar = ["address book", "address book outline", "address card", "address card outline", "bed", "blind", "child", "female", "frown", "frown outline", "id badge", "id badge outline", "id card", "id card outline", "male", "meh", "meh outline", "power off", "smile", "smile outline", "street view", "user", "user outline", "user circle", "user circle outline", "user md", "user plus", "user secret", "user times", "users", "wheelchair"],
      nr = ["ambulance", "bicycle", "bus", "car", "fighter jet", "motorcycle", "paper plane", "paper plane outline", "plane", "rocket", "ship", "shopping cart", "space shuttle", "subway", "taxi", "train", "truck", "wheelchair"],
      tr = ["archive", "book", "bookmark", "bookmark outline", "edit", "edit outline", "envelope", "envelope outline", "envelope open", "envelope open outline", "eraser", "file", "file outline", "file alternate", "file alternate outline", "folder", "folder outline", "folder open", "folder open outline", "keyboard", "keyboard outline", "newspaper", "newspaper outline", "paper plane", "paper plane outline", "paperclip", "paragraph", "pen square", "pencil alternate", "quote left", "quote right", "sticky note", "sticky note outline", "thumbtack"],
      rr = ["500px", "accessible", "accusoft", "adn", "adversal", "affiliatetheme", "algolia", "amazon", "amazon pay", "amilia", "android", "angellist", "angrycreative", "angular", "app store", "app store ios", "apper", "apple", "apple pay", "asymmetrik", "audible", "autoprefixer", "avianex", "aviato", "aws", "bandcamp", "behance", "behance square", "bimobject", "bitbucket", "bitcoin", "bity", "black tie", "blackberry", "blogger", "blogger b", "bluetooth", "bluetooth b", "btc", "buromobelexperte", "buysellads", "cc amazon pay", "cc amex", "cc apple pay", "cc diners club", "cc discover", "cc jcb", "cc mastercard", "cc paypal", "cc stripe", "cc visa", "centercode", "chrome", "cloudscale", "cloudsmith", "cloudversify", "codepen", "codiepie", "connectdevelop", "contao", "cpanel", "creative commons", "css3", "css3 alternate", "cuttlefish", "d and d", "dashcube", "delicious", "deploydog", "deskpro", "deviantart", "digg", "digital ocean", "discord", "discourse", "dochub", "docker", "draft2digital", "dribbble", "dribbble square", "dropbox", "drupal", "dyalog", "earlybirds", "edge", "elementor", "ember", "empire", "envira", "erlang", "ethereum", "etsy", "expeditedssl", "facebook", "facebook f", "facebook messenger", "facebook square", "firefox", "first order", "firstdraft", "flickr", "flipboard", "fly", "font awesome", "font awesome alternate", "font awesome flag", "fonticons", "fonticons fi", "fort awesome", "fort awesome alternate", "forumbee", "foursquare", "free code camp", "freebsd", "get pocket", "gg", "gg circle", "git", "git square", "github", "github alternate", "github square", "gitkraken", "gitlab", "gitter", "glide", "glide g", "gofore", "goodreads", "goodreads g", "google", "google drive", "google play", "google plus", "google plus g", "google plus square", "google wallet", "gratipay", "grav", "gripfire", "grunt", "gulp", "hacker news", "hacker news square", "hips", "hire a helper", "hooli", "hotjar", "houzz", "html5", "hubspot", "imdb", "instagram", "internet explorer", "ioxhost", "itunes", "itunes note", "jenkins", "joget", "joomla", "js", "js square", "jsfiddle", "keycdn", "kickstarter", "kickstarter k", "korvue", "laravel", "lastfm", "lastfm square", "leanpub", "less", "linechat", "linkedin", "linkedin alternate", "linode", "linux", "lyft", "magento", "maxcdn", "medapps", "medium", "medium m", "medrt", "meetup", "microsoft", "mix", "mixcloud", "mizuni", "modx", "monero", "napster", "nintendo switch", "node", "node js", "npm", "ns8", "nutritionix", "odnoklassniki", "odnoklassniki square", "opencart", "openid", "opera", "optin monster", "osi", "page4", "pagelines", "palfed", "patreon", "paypal", "periscope", "phabricator", "phoenix framework", "php", "pied piper", "pied piper alternate", "pied piper pp", "pinterest", "pinterest p", "pinterest square", "playstation", "product hunt", "pushed", "python", "qq", "quinscape", "quora", "ravelry", "react", "rebel", "redriver", "reddit", "reddit alien", "reddit square", "rendact", "renren", "replyd", "resolving", "rocketchat", "rockrms", "safari", "sass", "schlix", "scribd", "searchengin", "sellcast", "sellsy", "servicestack", "shirtsinbulk", "simplybuilt", "sistrix", "skyatlas", "skype", "slack", "slack hash", "slideshare", "snapchat", "snapchat ghost", "snapchat square", "soundcloud", "speakap", "spotify", "stack exchange", "stack overflow", "staylinked", "steam", "steam square", "steam symbol", "sticker mule", "strava", "stripe", "stripe s", "studiovinari", "stumbleupon", "stumbleupon circle", "superpowers", "supple", "telegram", "telegram plane", "tencent weibo", "themeisle", "trello", "tripadvisor", "tumblr", "tumblr square", "twitch", "twitter", "twitter square", "typo3", "uber", "uikit", "uniregistry", "untappd", "usb", "ussunnah", "vaadin", "viacoin", "viadeo", "viadeo square", "viber", "vimeo", "vimeo square", "vimeo v", "vine", "vk", "vnv", "vuejs", "wechat", "weibo", "weixin", "whatsapp", "whatsapp square", "whmcs", "wikipedia w", "windows", "wordpress", "wordpress simple", "wpbeginner", "wpexplorer", "wpforms", "xbox", "xing", "xing square", "y combinator", "yahoo", "yandex", "yandex international", "yelp", "yoast", "youtube", "youtube square"],
      ir = vt([].concat(bt, St, Tt, Dt, jt, Et, kt, It, Ot, Qt, Zt, Ut, Bt, Rt, Yt, Pt, Ft, Wt, Gt, qt, Jt, Kt, Xt, _t, $t, cr, er, ar, nr, tr, rr)),
      or = ["chess rock", "ordered list", "unordered list", "user doctor", "shield", "puzzle", "add circle", "add square", "add to calendar", "add to cart", "add user", "add", "alarm mute", "alarm", "ald", "als", "announcement", "area chart", "area graph", "arrow down cart", "asexual", "asl interpreting", "asl", "assistive listening devices", "attach", "attention", "balance", "bar", "bathtub", "battery four", "battery high", "battery low", "battery one", "battery three", "battery two", "battery zero", "birthday", "block layout", "bluetooth alternative", "broken chain", "browser", "call square", "call", "cancel", "cart", "cc", "chain", "chat", "checked calendar", "checkmark", "circle notched", "close", "cny", "cocktail", "commenting", "computer", "configure", "content", "deafness", "delete calendar", "delete", "detective", "discussions", "doctor", "dollar", "dont", "drivers license", "dropdown", "emergency", "envira gallery", "erase", "eur", "euro", "eyedropper", "factory", "favorite", "feed", "female homosexual", "file text", "file text outline", "find", "first aid", "fork", "game", "gay", "gbp", "google plus circle", "google plus official", "grab", "graduation", "grid layout", "group", "h", "hand victory", "handicap", "hard of hearing", "header", "help circle", "help", "heterosexual", "hide", "hotel", "hourglass four", "hourglass full", "hourglass one", "hourglass three", "hourglass two", "idea", "ils", "in cart", "inr", "intergender", "intersex", "jpy", "krw", "lab", "law", "legal", "lesbian", "lightning", "like", "line graph", "linkedin square", "linkify", "lira", "list layout", "magnify", "mail forward", "mail outline", "mail square", "mail", "male homosexual", "man", "marker", "mars alternate", "mars horizontal", "mars vertical", "microsoft edge", "military", "ms edge", "mute", "new pied piper", "non binary transgender", "numbered list", "options", "other gender horizontal", "other gender vertical", "other gender", "payment", "paypal card", "pencil square", "photo", "picture", "pie chart", "pie graph", "pied piper hat", "pin", "plus cart", "point", "pointing down", "pointing left", "pointing right", "pointing up", "pound", "power cord", "power", "privacy", "r circle", "rain", "record", "refresh", "remove circle", "remove from calendar", "remove user", "remove", "repeat", "rmb", "rouble", "rub", "ruble", "rupee", "s15", "selected radio", "send", "setting", "settings", "shekel", "sheqel", "shipping", "shop", "shuffle", "shutdown", "sidebar", "signing", "signup", "sliders", "soccer", "sort alphabet ascending", "sort alphabet descending", "sort ascending", "sort content ascending", "sort content descending", "sort descending", "sort numeric ascending", "sort numeric descending", "sound", "spy", "stripe card", "student", "talk", "target", "teletype", "television", "text cursor", "text telephone", "theme", "thermometer", "thumb tack", "time", "tm", "toggle down", "toggle left", "toggle right", "toggle up", "translate", "travel", "treatment", "triangle down", "triangle left", "triangle right", "triangle up", "try", "unhide", "unlinkify", "unmute", "usd", "user cancel", "user close", "user delete", "user x", "vcard", "video camera", "video play", "volume control phone", "wait", "warning circle", "warning sign", "warning", "wi-fi", "winner", "wizard", "woman", "won", "wordpress beginner", "wordpress forms", "world", "write square", "x", "yen", "zip", "zoom in", "zoom out", "zoom", "bitbucket square", "checkmark box", "circle thin", "cloud download", "cloud upload", "compose", "conversation", "credit card alternative", "currency", "dashboard", "diamond", "disk", "exchange", "external share", "external square", "external", "facebook official", "food", "hourglass zero", "level down", "level up", "log out", "meanpath", "money", "move", "pencil", "protect", "radio", "remove bookmark", "resize horizontal", "resize vertical", "sign in", "sign out", "spoon", "star half empty", "star half full", "ticket", "times rectangle", "write", "youtube play"],
      lr = vt([].concat(ir, or)),
      fr = ["left dropdown"],
      sr = vt([].concat(lr, fr)),
      ur = function ur(c, e) {
    return c && e;
  },
      hr = function hr(c, e) {
    return c && !0 !== c && c + " " + e;
  },
      mr = function mr(c, e) {
    return c && (!0 === c ? e : c + " " + e);
  },
      vr = function vr(c, e) {
    return c && !0 !== c ? c.replace("large screen", "large-screen").replace(/ vertically/g, "-vertically").split(" ").map(function (c) {
      return c.replace("-", " ") + " " + e;
    }).join(" ") : null;
  },
      dr = function dr(c) {
    return "justified" === c ? "justified" : hr(c, "aligned");
  },
      Mr = function Mr(c) {
    return hr(c, "aligned");
  },
      pr = function pr(c, e, a) {
    if (void 0 === e && (e = ""), void 0 === a && (a = !1), a && "equal" === c) return "equal width";
    var n = typeof c;
    return "string" !== n && "number" !== n || !e ? zt(c) : zt(c) + " " + e;
  };

  var zr = function zr(c, e, a) {
    var n = c.defaultProps,
        t = void 0 === n ? {} : n;
    if (e.as && e.as !== t.as) return e.as;

    if (a) {
      var r = a();
      if (r) return r;
    }

    return e.href ? "a" : t.as || "div";
  },
      Cr = Za(Object.getPrototypeOf, Object),
      Lr = "[object Object]",
      Ar = Function.prototype,
      Nr = Object.prototype,
      gr = Ar.toString,
      Hr = Nr.hasOwnProperty,
      Vr = gr.call(Object);

  var xr = function xr(c) {
    if (!E(c) || j(c) != Lr) return !1;
    var e = Cr(c);
    if (null === e) return !0;
    var a = Hr.call(e, "constructor") && e.constructor;
    return "function" == typeof a && a instanceof a && gr.call(a) == Vr;
  },
      wr = "[object Number]";

  var yr = function yr(c) {
    return "number" == typeof c || E(c) && j(c) == wr;
  },
      br = "[object String]";

  var Sr = function Sr(c) {
    return "string" == typeof c || !L(c) && E(c) && j(c) == br;
  },
      Tr = "[object Boolean]";

  var Dr = function Dr(c) {
    return !0 === c || !1 === c || E(c) && j(c) == Tr;
  };

  function jr(c, e, a, n) {
    if (void 0 === n && (n = {}), "function" != typeof c && "string" != typeof c) throw new Error("createShorthand() Component must be a string or function.");
    if (Ee(a) || Dr(a)) return null;
    var t = Sr(a),
        r = yr(a),
        o = W(a),
        l = i.isValidElement(a),
        f = xr(a),
        s = t || r || L(a);
    if (!(o || l || f || s)) return null;
    var u = n.defaultProps,
        h = void 0 === u ? {} : u,
        m = l && a.props || f && a || s && e(a),
        v = n.overrideProps,
        d = void 0 === v ? {} : v;
    d = W(d) ? d(Object(p.a)({}, h, m)) : d;
    var M = Object(p.a)({}, h, m, d);

    if (h.className || d.className || m.className) {
      var z = Ie(h.className, d.className, m.className);
      M.className = vt(z.split(" ")).join(" ");
    }

    if ((h.style || d.style || m.style) && (M.style = Object(p.a)({}, h.style, m.style, d.style)), Ee(M.key)) {
      var C = M.childKey,
          A = n.autoGenerateKey,
          N = void 0 === A || A;
      Ee(C) ? N && (t || r) && (M.key = a) : (M.key = "function" == typeof C ? C(M) : C, delete M.childKey);
    }

    return l ? i.cloneElement(a, M) : "function" == typeof M.children ? M.children(c, Object(p.a)({}, M, {
      children: void 0
    })) : s || f ? i.createElement(c, M) : o ? a(c, M, M.children) : void 0;
  }

  function Er(c, e) {
    if ("function" != typeof c && "string" != typeof c) throw new Error("createShorthandFactory() Component must be a string or function.");
    return function (a, n) {
      return jr(c, e, a, n);
    };
  }

  var kr = Er("div", function (c) {
    return {
      children: c
    };
  }),
      Ir = Er("iframe", function (c) {
    return {
      src: c
    };
  }),
      Or = Er("img", function (c) {
    return {
      src: c
    };
  }),
      Qr = Er("input", function (c) {
    return {
      type: c
    };
  }),
      Zr = Er("label", function (c) {
    return {
      children: c
    };
  }),
      Ur = Er("p", function (c) {
    return {
      children: c
    };
  });

  function Br(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.size,
        i = Ie(r, "icons", a),
        l = je(Br, c),
        f = zr(Br, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(e) ? t : e);
  }

  Br.handledProps = ["as", "children", "className", "content", "size"], Br.propTypes = {}, Br.defaultProps = {
    as: "i"
  };

  var Rr = Br,
      Yr = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleClick = function (c) {
        e.props.disabled ? c.preventDefault() : De(e.props, "onClick", c, e.props);
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.getIconAriaOptions = function () {
      var c = {},
          e = this.props,
          a = e["aria-label"],
          n = e["aria-hidden"];
      return Ee(a) ? c["aria-hidden"] = "true" : c["aria-label"] = a, Ee(n) || (c["aria-hidden"] = n), c;
    }, a.render = function () {
      var c = this.props,
          a = c.bordered,
          n = c.circular,
          t = c.className,
          r = c.color,
          i = c.corner,
          l = c.disabled,
          f = c.fitted,
          s = c.flipped,
          u = c.inverted,
          h = c.link,
          m = c.loading,
          v = c.name,
          d = c.rotated,
          M = c.size,
          z = Ie(r, v, M, ur(a, "bordered"), ur(n, "circular"), ur(l, "disabled"), ur(f, "fitted"), ur(u, "inverted"), ur(h, "link"), ur(m, "loading"), mr(i, "corner"), hr(s, "flipped"), hr(d, "rotated"), "icon", t),
          C = je(e, this.props),
          L = zr(e, this.props),
          A = this.getIconAriaOptions();
      return o.a.createElement(L, Object(p.a)({}, C, A, {
        className: z,
        onClick: this.handleClick
      }));
    }, e;
  }(i.PureComponent);

  Yr.handledProps = ["aria-hidden", "aria-label", "as", "bordered", "circular", "className", "color", "corner", "disabled", "fitted", "flipped", "inverted", "link", "loading", "name", "rotated", "size"], Yr.propTypes = {}, Yr.defaultProps = {
    as: "i"
  }, Yr.Group = Rr, Yr.create = Er(Yr, function (c) {
    return {
      name: c
    };
  });
  var Pr = Yr;

  var Fr = function Fr(c) {
    return void 0 === c;
  },
      Wr = Math.max;

  var Gr = function Gr(c, e, a, n) {
    c = Ya(c) ? c : Mt(c), a = a && !n ? Wn(a) : 0;
    var t = c.length;
    return a < 0 && (a = Wr(t + a, 0)), Sr(c) ? a <= t && c.indexOf(e, a) > -1 : !!t && ot(c, e, a) > -1;
  };

  var qr = function qr(c, e) {
    for (var a = -1, n = null == c ? 0 : c.length; ++a < n && !1 !== e(c[a], a, c);) {
      ;
    }

    return c;
  };

  var Jr = function Jr(c) {
    return "function" == typeof c ? c : Le;
  };

  var Kr = function Kr(c, e) {
    return (L(c) ? qr : _n)(c, Jr(e));
  },
      Xr = ["selected", "defaultValue", "defaultChecked", "accept", "autoCapitalize", "autoComplete", "autoCorrect", "autoFocus", "checked", "disabled", "enterKeyHint", "form", "id", "inputMode", "lang", "list", "max", "maxLength", "min", "minLength", "multiple", "name", "pattern", "placeholder", "readOnly", "required", "step", "title", "type", "value"],
      _r = [].concat(Xr, ["onKeyDown", "onKeyPress", "onKeyUp", "onFocus", "onBlur", "onChange", "onInput", "onClick", "onContextMenu", "onDrag", "onDragEnd", "onDragEnter", "onDragExit", "onDragLeave", "onDragOver", "onDragStart", "onDrop", "onMouseDown", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseOut", "onMouseOver", "onMouseUp", "onSelect", "onTouchCancel", "onTouchEnd", "onTouchMove", "onTouchStart"]),
      $r = ["alt", "height", "src", "srcSet", "width", "loading"],
      ci = function ci(c, e) {
    void 0 === e && (e = {});
    var a = e,
        n = a.htmlProps,
        t = void 0 === n ? _r : n,
        r = a.includeAria,
        i = void 0 === r || r,
        o = {},
        l = {};
    return Kr(c, function (c, e) {
      var a = i && (/^aria-.*$/.test(e) || "role" === e);
      (Gr(t, e) || a ? o : l)[e] = c;
    }), [o, l];
  },
      ei = "object" == typeof document && null !== document,
      ai = "object" == typeof window && null !== window && window.self === window,
      ni = function c() {
    return Ee(c.override) ? ei && ai : c.override;
  },
      ti = a(9),
      ri = a.n(ti),
      ii = a(4),
      oi = a.n(ii),
      li = Math.max,
      fi = Math.min;

  var si = function si(c, e, a) {
    return c >= fi(e, a) && c < li(e, a);
  };

  var ui = function ui(c, e, a) {
    return e = Fn(e), void 0 === a ? (a = e, e = 0) : a = Fn(a), c = Rn(c), si(c, e, a);
  };

  var hi = function hi(c) {
    return c && c.length ? c[0] : void 0;
  },
      mi = function mi(c, e) {
    if (et([e, c], Ee)) return !1;
    if (e.target && (De(e.target, "setAttribute", "data-suir-click-target", !0), document.querySelector("[data-suir-click-target=true]"))) return De(e.target, "removeAttribute", "data-suir-click-target"), c.contains(e.target);
    var a = e.clientX,
        n = e.clientY;
    if (et([a, n], Ee)) return !1;
    var t = c.getClientRects();
    if (!(c.offsetWidth && c.offsetHeight && t && t.length)) return !1;
    var r = hi(t),
        i = r.top,
        o = r.bottom,
        l = r.left,
        f = r.right;
    return !et([i, o, l, f], Ee) && ui(n, i, o + .001) && ui(a, l, f + .001);
  },
      vi = a(28),
      di = function di(c, e, a, n) {
    void 0 === n && (n = !1);
    var t,
        r = e[c];
    if (void 0 !== r) return r;

    if (n) {
      var i = e[(t = c, "default" + (t[0].toUpperCase() + t.slice(1)))];
      if (void 0 !== i) return i;

      if (a) {
        var o = a[c];
        if (void 0 !== o) return o;
      }
    }

    return "checked" !== c && ("value" === c ? e.multiple ? [] : "" : void 0);
  },
      Mi = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      var r = (e = c.call.apply(c, [this].concat(n)) || this).constructor,
          i = r.autoControlledProps,
          o = r.getAutoControlledStateFromProps,
          l = De(Object(vi.a)(e), "getInitialAutoControlledState", e.props) || {},
          f = i.reduce(function (c, a) {
        return c[a] = di(a, e.props, l, !0), c;
      }, {});
      return e.state = Object(p.a)({}, l, f, {
        autoControlledProps: i,
        getAutoControlledStateFromProps: o
      }), e;
    }

    return Object(f.a)(e, c), e.getDerivedStateFromProps = function (c, e) {
      var a = e.autoControlledProps,
          n = e.getAutoControlledStateFromProps,
          t = a.reduce(function (e, a) {
        return !Fr(c[a]) && (e[a] = c[a]), e;
      }, {});

      if (n) {
        var r = n(c, Object(p.a)({}, e, t), e);
        return Object(p.a)({}, t, r);
      }

      return t;
    }, e.getAutoControlledStateFromProps = function () {
      return null;
    }, e;
  }(o.a.Component),
      pi = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleRef = function (c) {
        u(e.props.innerRef, c);
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.componentDidMount = function () {
      De(this.props, "onMount", null, this.props);
    }, a.componentWillUnmount = function () {
      De(this.props, "onUnmount", null, this.props);
    }, a.render = function () {
      if (!ni()) return null;
      var c = this.props,
          e = c.children,
          a = c.mountNode,
          n = void 0 === a ? document.body : a;
      return Object(s.createPortal)(o.a.createElement(M, {
        innerRef: this.handleRef
      }, e), n);
    }, e;
  }(i.Component);

  pi.handledProps = ["children", "innerRef", "mountNode", "onMount", "onUnmount"], pi.propTypes = {};

  var zi = pi,
      Ci = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).contentRef = o.a.createRef(), e.triggerRef = o.a.createRef(), e.latestDocumentMouseDownEvent = null, e.handleDocumentMouseDown = function (c) {
        e.latestDocumentMouseDownEvent = c;
      }, e.handleDocumentClick = function (c) {
        var a = e.props.closeOnDocumentClick,
            n = e.latestDocumentMouseDownEvent;
        e.latestDocumentMouseDownEvent = null, !e.contentRef.current || mi(e.triggerRef.current, c) || n && mi(e.contentRef.current, n) || mi(e.contentRef.current, c) || a && e.close(c);
      }, e.handleEscape = function (c) {
        e.props.closeOnEscape && oi.a.getCode(c) === oi.a.Escape && e.close(c);
      }, e.handlePortalMouseLeave = function (c) {
        var a = e.props,
            n = a.closeOnPortalMouseLeave,
            t = a.mouseLeaveDelay;
        n && c.target === e.contentRef.current && (e.mouseLeaveTimer = e.closeWithTimeout(c, t));
      }, e.handlePortalMouseEnter = function () {
        e.props.closeOnPortalMouseLeave && clearTimeout(e.mouseLeaveTimer);
      }, e.handleTriggerBlur = function (c) {
        for (var a = e.props, n = a.trigger, t = a.closeOnTriggerBlur, r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
          i[o - 1] = arguments[o];
        }

        De.apply(void 0, [n, "props.onBlur", c].concat(i));
        var l = c.relatedTarget || document.activeElement,
            f = De(e.contentRef.current, "contains", l);
        t && !f && e.close(c);
      }, e.handleTriggerClick = function (c) {
        for (var a = e.props, n = a.trigger, t = a.closeOnTriggerClick, r = a.openOnTriggerClick, i = e.state.open, o = arguments.length, l = new Array(o > 1 ? o - 1 : 0), f = 1; f < o; f++) {
          l[f - 1] = arguments[f];
        }

        De.apply(void 0, [n, "props.onClick", c].concat(l)), i && t ? e.close(c) : !i && r && e.open(c);
      }, e.handleTriggerFocus = function (c) {
        for (var a = e.props, n = a.trigger, t = a.openOnTriggerFocus, r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
          i[o - 1] = arguments[o];
        }

        De.apply(void 0, [n, "props.onFocus", c].concat(i)), t && e.open(c);
      }, e.handleTriggerMouseLeave = function (c) {
        clearTimeout(e.mouseEnterTimer);

        for (var a = e.props, n = a.trigger, t = a.closeOnTriggerMouseLeave, r = a.mouseLeaveDelay, i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), l = 1; l < i; l++) {
          o[l - 1] = arguments[l];
        }

        De.apply(void 0, [n, "props.onMouseLeave", c].concat(o)), t && (e.mouseLeaveTimer = e.closeWithTimeout(c, r));
      }, e.handleTriggerMouseEnter = function (c) {
        clearTimeout(e.mouseLeaveTimer);

        for (var a = e.props, n = a.trigger, t = a.mouseEnterDelay, r = a.openOnTriggerMouseEnter, i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), l = 1; l < i; l++) {
          o[l - 1] = arguments[l];
        }

        De.apply(void 0, [n, "props.onMouseEnter", c].concat(o)), r && (e.mouseEnterTimer = e.openWithTimeout(c, t));
      }, e.open = function (c) {
        De(e.props, "onOpen", c, Object(p.a)({}, e.props, {
          open: !0
        })), e.setState({
          open: !0
        });
      }, e.openWithTimeout = function (c, a) {
        var n = Object(p.a)({}, c);
        return setTimeout(function () {
          return e.open(n);
        }, a || 0);
      }, e.close = function (c) {
        e.setState({
          open: !1
        }), De(e.props, "onClose", c, Object(p.a)({}, e.props, {
          open: !1
        }));
      }, e.closeWithTimeout = function (c, a) {
        var n = Object(p.a)({}, c);
        return setTimeout(function () {
          return e.close(n);
        }, a || 0);
      }, e.handleMount = function () {
        De(e.props, "onMount", null, e.props);
      }, e.handleUnmount = function () {
        De(e.props, "onUnmount", null, e.props);
      }, e.handleTriggerRef = function (c) {
        e.triggerRef.current = c, u(e.props.triggerRef, c);
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.componentWillUnmount = function () {
      clearTimeout(this.mouseEnterTimer), clearTimeout(this.mouseLeaveTimer);
    }, a.render = function () {
      var c = this.props,
          e = c.children,
          a = c.eventPool,
          n = c.mountNode,
          t = c.trigger,
          r = this.state.open;
      return o.a.createElement(o.a.Fragment, null, r && o.a.createElement(o.a.Fragment, null, o.a.createElement(zi, {
        innerRef: this.contentRef,
        mountNode: n,
        onMount: this.handleMount,
        onUnmount: this.handleUnmount
      }, e), o.a.createElement(ri.a, {
        name: "mouseleave",
        on: this.handlePortalMouseLeave,
        pool: a,
        target: this.contentRef
      }), o.a.createElement(ri.a, {
        name: "mouseenter",
        on: this.handlePortalMouseEnter,
        pool: a,
        target: this.contentRef
      }), o.a.createElement(ri.a, {
        name: "mousedown",
        on: this.handleDocumentMouseDown,
        pool: a
      }), o.a.createElement(ri.a, {
        name: "click",
        on: this.handleDocumentClick,
        pool: a
      }), o.a.createElement(ri.a, {
        name: "keydown",
        on: this.handleEscape,
        pool: a
      })), t && o.a.createElement(M, {
        innerRef: this.handleTriggerRef
      }, o.a.cloneElement(t, {
        onBlur: this.handleTriggerBlur,
        onClick: this.handleTriggerClick,
        onFocus: this.handleTriggerFocus,
        onMouseLeave: this.handleTriggerMouseLeave,
        onMouseEnter: this.handleTriggerMouseEnter
      })));
    }, e;
  }(Mi);

  Ci.handledProps = ["children", "closeOnDocumentClick", "closeOnEscape", "closeOnPortalMouseLeave", "closeOnTriggerBlur", "closeOnTriggerClick", "closeOnTriggerMouseLeave", "defaultOpen", "eventPool", "mountNode", "mouseEnterDelay", "mouseLeaveDelay", "onClose", "onMount", "onOpen", "onUnmount", "open", "openOnTriggerClick", "openOnTriggerFocus", "openOnTriggerMouseEnter", "trigger", "triggerRef"], Ci.propTypes = {}, Ci.defaultProps = {
    closeOnDocumentClick: !0,
    closeOnEscape: !0,
    eventPool: "default",
    openOnTriggerClick: !0
  }, Ci.autoControlledProps = ["open"], Ci.Inner = zi;
  var Li = Ci;

  function Ai(c) {
    var e = c.blurring,
        a = c.className,
        t = c.children,
        r = c.content,
        i = c.dimmed,
        l = Ie(ur(e, "blurring"), ur(i, "dimmed"), "dimmable", a),
        f = je(Ai, c),
        s = zr(Ai, c);
    return o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), n.isNil(t) ? r : t);
  }

  Ai.handledProps = ["as", "blurring", "children", "className", "content", "dimmed"], Ai.propTypes = {};

  var Ni = Ai,
      gi = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).containerRef = Object(i.createRef)(), e.contentRef = Object(i.createRef)(), e.handleClick = function (c) {
        var a = e.contentRef.current;
        De(e.props, "onClick", c, e.props), a && a !== c.target && mi(a, c) || De(e.props, "onClickOutside", c, e.props);
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.componentDidMount = function () {
      var c = this.props.active;
      this.toggleStyles(c);
    }, a.componentDidUpdate = function (c) {
      var e = this.props.active;
      c.active !== e && this.toggleStyles(e);
    }, a.toggleStyles = function (c) {
      var e = this.containerRef.current;
      e && e.style && (c ? e.style.setProperty("display", "flex", "important") : e.style.removeProperty("display"));
    }, a.render = function () {
      var c = this.props,
          a = c.active,
          t = c.children,
          r = c.className,
          i = c.content,
          l = c.disabled,
          f = c.inverted,
          s = c.page,
          u = c.simple,
          h = c.verticalAlign,
          m = Ie("ui", ur(a, "active transition visible"), ur(l, "disabled"), ur(f, "inverted"), ur(s, "page"), ur(u, "simple"), Mr(h), "dimmer", r),
          v = je(e, this.props),
          d = zr(e, this.props),
          z = n.isNil(t) ? i : t;
      return o.a.createElement(M, {
        innerRef: this.containerRef
      }, o.a.createElement(d, Object(p.a)({}, v, {
        className: m,
        onClick: this.handleClick
      }), z && o.a.createElement("div", {
        className: "content",
        ref: this.contentRef
      }, z)));
    }, e;
  }(i.Component);

  gi.handledProps = ["active", "as", "children", "className", "content", "disabled", "inverted", "onClick", "onClickOutside", "page", "simple", "verticalAlign"], gi.propTypes = {};

  var Hi = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handlePortalMount = function () {
        ni() && (document.body.classList.add("dimmed"), document.body.classList.add("dimmable"));
      }, e.handlePortalUnmount = function () {
        ni() && (document.body.classList.remove("dimmed"), document.body.classList.remove("dimmable"));
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.active,
          n = c.page,
          t = je(e, this.props);
      return n ? o.a.createElement(Li, {
        closeOnEscape: !1,
        closeOnDocumentClick: !1,
        onMount: this.handlePortalMount,
        onUnmount: this.handlePortalUnmount,
        open: a,
        openOnTriggerClick: !1
      }, o.a.createElement(gi, Object(p.a)({}, t, {
        active: a,
        page: n
      }))) : o.a.createElement(gi, Object(p.a)({}, t, {
        active: a,
        page: n
      }));
    }, e;
  }(i.Component);

  function Vi(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.size,
        i = Ie("ui", r, a, "images"),
        l = je(Vi, c),
        f = zr(Vi, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(e) ? t : e);
  }

  Hi.handledProps = ["active", "page"], Hi.propTypes = {}, Hi.Dimmable = Ni, Hi.Inner = gi, Hi.create = Er(Hi, function (c) {
    return {
      content: c
    };
  }), Vi.handledProps = ["as", "children", "className", "content", "size"], Vi.propTypes = {};
  var xi = Vi;

  function wi(c) {
    var e = c.avatar,
        a = c.bordered,
        t = c.centered,
        r = c.children,
        i = c.circular,
        l = c.className,
        f = c.content,
        s = c.dimmer,
        u = c.disabled,
        h = c.floated,
        m = c.fluid,
        v = c.hidden,
        d = c.href,
        M = c.inline,
        z = c.label,
        C = c.rounded,
        L = c.size,
        A = c.spaced,
        N = c.verticalAlign,
        g = c.wrapped,
        H = c.ui,
        V = Ie(ur(H, "ui"), L, ur(e, "avatar"), ur(a, "bordered"), ur(i, "circular"), ur(t, "centered"), ur(u, "disabled"), ur(m, "fluid"), ur(v, "hidden"), ur(M, "inline"), ur(C, "rounded"), mr(A, "spaced"), hr(h, "floated"), Mr(N, "aligned"), "image", l),
        x = je(wi, c),
        w = ci(x, {
      htmlProps: $r
    }),
        y = w[0],
        b = w[1],
        S = zr(wi, c, function () {
      if (!(Ee(s) && Ee(z) && Ee(g) && n.isNil(r))) return "div";
    });
    return n.isNil(r) ? n.isNil(f) ? "img" === S ? o.a.createElement(S, Object(p.a)({}, b, y, {
      className: V
    })) : o.a.createElement(S, Object(p.a)({}, b, {
      className: V,
      href: d
    }), Hi.create(s, {
      autoGenerateKey: !1
    }), ji.create(z, {
      autoGenerateKey: !1
    }), o.a.createElement("img", y)) : o.a.createElement(S, Object(p.a)({}, x, {
      className: V
    }), f) : o.a.createElement(S, Object(p.a)({}, x, {
      className: V
    }), r);
  }

  wi.handledProps = ["as", "avatar", "bordered", "centered", "children", "circular", "className", "content", "dimmer", "disabled", "floated", "fluid", "hidden", "href", "inline", "label", "rounded", "size", "spaced", "ui", "verticalAlign", "wrapped"], wi.Group = xi, wi.propTypes = {}, wi.defaultProps = {
    as: "img",
    ui: !0
  }, wi.create = Er(wi, function (c) {
    return {
      src: c
    };
  });
  var yi = wi;

  function bi(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("detail", a),
        i = je(bi, c),
        l = zr(bi, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  bi.handledProps = ["as", "children", "className", "content"], bi.propTypes = {}, bi.create = Er(bi, function (c) {
    return {
      content: c
    };
  });
  var Si = bi;

  function Ti(c) {
    var e = c.children,
        a = c.circular,
        t = c.className,
        r = c.color,
        i = c.content,
        l = c.size,
        f = c.tag,
        s = Ie("ui", r, l, ur(a, "circular"), ur(f, "tag"), "labels", t),
        u = je(Ti, c),
        h = zr(Ti, c);
    return o.a.createElement(h, Object(p.a)({}, u, {
      className: s
    }), n.isNil(e) ? i : e);
  }

  Ti.handledProps = ["as", "children", "circular", "className", "color", "content", "size", "tag"], Ti.propTypes = {};

  var Di = Ti,
      ji = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleClick = function (c) {
        var a = e.props.onClick;
        a && a(c, e.props);
      }, e.handleIconOverrides = function (c) {
        return {
          onClick: function onClick(a) {
            De(c, "onClick", a), De(e.props, "onRemove", a, e.props);
          }
        };
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.active,
          t = c.attached,
          r = c.basic,
          i = c.children,
          l = c.circular,
          f = c.className,
          s = c.color,
          u = c.content,
          h = c.corner,
          m = c.detail,
          v = c.empty,
          d = c.floating,
          M = c.horizontal,
          z = c.icon,
          C = c.image,
          L = c.onRemove,
          A = c.pointing,
          N = c.prompt,
          g = c.removeIcon,
          H = c.ribbon,
          V = c.size,
          x = c.tag,
          w = Ie("ui", s, (!0 === A ? "pointing" : ("left" === A || "right" === A) && A + " pointing") || ("above" === A || "below" === A) && "pointing " + A, V, ur(a, "active"), ur(r, "basic"), ur(l, "circular"), ur(v, "empty"), ur(d, "floating"), ur(M, "horizontal"), ur(!0 === C, "image"), ur(N, "prompt"), ur(x, "tag"), mr(h, "corner"), mr(H, "ribbon"), hr(t, "attached"), "label", f),
          y = je(e, this.props),
          b = zr(e, this.props);
      if (!n.isNil(i)) return o.a.createElement(b, Object(p.a)({}, y, {
        className: w,
        onClick: this.handleClick
      }), i);
      var S = Fr(g) ? "delete" : g;
      return o.a.createElement(b, Object(p.a)({
        className: w,
        onClick: this.handleClick
      }, y), Pr.create(z, {
        autoGenerateKey: !1
      }), "boolean" != typeof C && yi.create(C, {
        autoGenerateKey: !1
      }), u, Si.create(m, {
        autoGenerateKey: !1
      }), L && Pr.create(S, {
        autoGenerateKey: !1,
        overrideProps: this.handleIconOverrides
      }));
    }, e;
  }(i.Component);

  function Ei(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.hidden,
        i = c.visible,
        l = Ie(ur(i, "visible"), ur(r, "hidden"), "content", a),
        f = je(Ei, c),
        s = zr(Ei, c);
    return o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), n.isNil(e) ? t : e);
  }

  ji.handledProps = ["active", "as", "attached", "basic", "children", "circular", "className", "color", "content", "corner", "detail", "empty", "floating", "horizontal", "icon", "image", "onClick", "onRemove", "pointing", "prompt", "removeIcon", "ribbon", "size", "tag"], ji.propTypes = {}, ji.Detail = Si, ji.Group = Di, ji.create = Er(ji, function (c) {
    return {
      content: c
    };
  }), Ei.handledProps = ["as", "children", "className", "content", "hidden", "visible"], Ei.propTypes = {};
  var ki = Ei;

  var Ii = function Ii(c, e) {
    var a = -1,
        n = Ya(c) ? Array(c.length) : [];
    return _n(c, function (c, t, r) {
      n[++a] = e(c, t, r);
    }), n;
  };

  var Oi = function Oi(c, e) {
    return (L(c) ? Wc : Ii)(c, Sn(e, 3));
  };

  function Qi(c) {
    var e = c.attached,
        a = c.basic,
        t = c.buttons,
        r = c.children,
        i = c.className,
        l = c.color,
        f = c.compact,
        s = c.content,
        u = c.floated,
        h = c.fluid,
        m = c.icon,
        v = c.inverted,
        d = c.labeled,
        M = c.negative,
        z = c.positive,
        C = c.primary,
        L = c.secondary,
        A = c.size,
        N = c.toggle,
        g = c.vertical,
        H = c.widths,
        V = Ie("ui", l, A, ur(a, "basic"), ur(f, "compact"), ur(h, "fluid"), ur(m, "icon"), ur(v, "inverted"), ur(d, "labeled"), ur(M, "negative"), ur(z, "positive"), ur(C, "primary"), ur(L, "secondary"), ur(N, "toggle"), ur(g, "vertical"), mr(e, "attached"), hr(u, "floated"), pr(H), "buttons", i),
        x = je(Qi, c),
        w = zr(Qi, c);
    return Ee(t) ? o.a.createElement(w, Object(p.a)({}, x, {
      className: V
    }), n.isNil(r) ? s : r) : o.a.createElement(w, Object(p.a)({}, x, {
      className: V
    }), Oi(t, function (c) {
      return Yi.create(c);
    }));
  }

  Qi.handledProps = ["as", "attached", "basic", "buttons", "children", "className", "color", "compact", "content", "floated", "fluid", "icon", "inverted", "labeled", "negative", "positive", "primary", "secondary", "size", "toggle", "vertical", "widths"], Qi.propTypes = {};
  var Zi = Qi;

  function Ui(c) {
    var e = c.className,
        a = c.text,
        n = Ie("or", e),
        t = je(Ui, c),
        r = zr(Ui, c);
    return o.a.createElement(r, Object(p.a)({}, t, {
      className: n,
      "data-text": a
    }));
  }

  Ui.handledProps = ["as", "className", "text"], Ui.propTypes = {};

  var Bi = Ui,
      Ri = function (c) {
    function e() {
      for (var e, a = arguments.length, t = new Array(a), r = 0; r < a; r++) {
        t[r] = arguments[r];
      }

      return (e = c.call.apply(c, [this].concat(t)) || this).ref = Object(i.createRef)(), e.computeElementType = function () {
        var c = e.props,
            a = c.attached,
            n = c.label;
        if (!Ee(a) || !Ee(n)) return "div";
      }, e.computeTabIndex = function (c) {
        var a = e.props,
            n = a.disabled,
            t = a.tabIndex;
        return Ee(t) ? n ? -1 : "div" === c ? 0 : void 0 : t;
      }, e.focus = function (c) {
        return De(e.ref.current, "focus", c);
      }, e.handleClick = function (c) {
        e.props.disabled ? c.preventDefault() : De(e.props, "onClick", c, e.props);
      }, e.hasIconClass = function () {
        var c = e.props,
            a = c.labelPosition,
            t = c.children,
            r = c.content,
            i = c.icon;
        return !0 === i || i && (a || n.isNil(t) && Ee(r));
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.computeButtonAriaRole = function (c) {
      var e = this.props.role;
      return Ee(e) ? "button" !== c ? "button" : void 0 : e;
    }, a.render = function () {
      var c = this.props,
          a = c.active,
          t = c.animated,
          r = c.attached,
          i = c.basic,
          l = c.children,
          f = c.circular,
          s = c.className,
          u = c.color,
          h = c.compact,
          m = c.content,
          v = c.disabled,
          d = c.floated,
          z = c.fluid,
          C = c.icon,
          L = c.inverted,
          A = c.label,
          N = c.labelPosition,
          g = c.loading,
          H = c.negative,
          V = c.positive,
          x = c.primary,
          w = c.secondary,
          y = c.size,
          b = c.toggle,
          S = c.type,
          T = Ie(u, y, ur(a, "active"), ur(i, "basic"), ur(f, "circular"), ur(h, "compact"), ur(z, "fluid"), ur(this.hasIconClass(), "icon"), ur(L, "inverted"), ur(g, "loading"), ur(H, "negative"), ur(V, "positive"), ur(x, "primary"), ur(w, "secondary"), ur(b, "toggle"), mr(t, "animated"), mr(r, "attached")),
          D = Ie(mr(N || !!A, "labeled")),
          j = Ie(ur(v, "disabled"), hr(d, "floated")),
          E = je(e, this.props),
          k = zr(e, this.props, this.computeElementType),
          I = this.computeTabIndex(k);

      if (!Ee(A)) {
        var O = Ie("ui", T, "button", s),
            Q = Ie("ui", D, "button", s, j),
            Z = ji.create(A, {
          defaultProps: {
            basic: !0,
            pointing: "left" === N ? "right" : "left"
          },
          autoGenerateKey: !1
        });
        return o.a.createElement(k, Object(p.a)({}, E, {
          className: Q,
          onClick: this.handleClick
        }), "left" === N && Z, o.a.createElement(M, {
          innerRef: this.ref
        }, o.a.createElement("button", {
          className: O,
          "aria-pressed": b ? !!a : void 0,
          disabled: v,
          type: S,
          tabIndex: I
        }, Pr.create(C, {
          autoGenerateKey: !1
        }), " ", m)), ("right" === N || !N) && Z);
      }

      var U = Ie("ui", T, j, D, "button", s),
          B = !n.isNil(l),
          R = this.computeButtonAriaRole(k);
      return o.a.createElement(M, {
        innerRef: this.ref
      }, o.a.createElement(k, Object(p.a)({}, E, {
        className: U,
        "aria-pressed": b ? !!a : void 0,
        disabled: v && "button" === k || void 0,
        onClick: this.handleClick,
        role: R,
        type: S,
        tabIndex: I
      }), B && l, !B && Pr.create(C, {
        autoGenerateKey: !1
      }), !B && m));
    }, e;
  }(i.Component);

  Ri.handledProps = ["active", "animated", "as", "attached", "basic", "children", "circular", "className", "color", "compact", "content", "disabled", "floated", "fluid", "icon", "inverted", "label", "labelPosition", "loading", "negative", "onClick", "positive", "primary", "role", "secondary", "size", "tabIndex", "toggle", "type"], Ri.propTypes = {}, Ri.defaultProps = {
    as: "button"
  }, Ri.Content = ki, Ri.Group = Zi, Ri.Or = Bi, Ri.create = Er(Ri, function (c) {
    return {
      content: c
    };
  });
  var Yi = Ri;

  var Pi = function Pi(c, e, a) {
    "__proto__" == e && He ? He(c, e, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : c[e] = a;
  },
      Fi = Object.prototype.hasOwnProperty;

  var Wi = function Wi(c, e, a) {
    var n = c[e];
    Fi.call(c, e) && Lc(n, a) && (void 0 !== a || e in c) || Pi(c, e, a);
  };

  var Gi = function Gi(c, e, a, n) {
    if (!U(c)) return c;

    for (var t = -1, r = (e = _c(e, c)).length, i = r - 1, o = c; null != o && ++t < r;) {
      var l = ue(e[t]),
          f = a;
      if ("__proto__" === l || "constructor" === l || "prototype" === l) return c;

      if (t != i) {
        var s = o[l];
        void 0 === (f = n ? n(s, l, o) : void 0) && (f = U(s) ? s : oe(e[t + 1]) ? [] : {});
      }

      Wi(o, l, f), o = o[l];
    }

    return c;
  };

  var qi = function qi(c, e, a) {
    for (var n = -1, t = e.length, r = {}; ++n < t;) {
      var i = e[n],
          o = Me(c, i);
      a(o, i) && Gi(r, _c(i, c), o);
    }

    return r;
  };

  var Ji = function Ji(c, e) {
    return qi(c, e, function (e, a) {
      return gn(c, a);
    });
  },
      Ki = N ? N.isConcatSpreadable : void 0;

  var Xi = function Xi(c) {
    return L(c) || te(c) || !!(Ki && c && c[Ki]);
  };

  var _i = function c(e, a, n, t, r) {
    var i = -1,
        o = e.length;

    for (n || (n = Xi), r || (r = []); ++i < o;) {
      var l = e[i];
      a > 0 && n(l) ? a > 1 ? c(l, a - 1, n, t, r) : La(r, l) : t || (r[r.length] = l);
    }

    return r;
  };

  var $i = function $i(c) {
    return null != c && c.length ? _i(c, 1) : [];
  };

  var co = function (c) {
    return Se(Ne(c, void 0, $i), c + "");
  }(function (c, e) {
    return null == c ? {} : Ji(c, e);
  });

  var eo = function eo(c, e, a, n) {
    var t = -1,
        r = null == c ? 0 : c.length;

    for (n && r && (a = c[++t]); ++t < r;) {
      a = e(a, c[t], t, c);
    }

    return a;
  };

  var ao = function ao(c, e, a, n, t) {
    return t(c, function (c, t, r) {
      a = n ? (n = !1, c) : e(a, c, t, r);
    }), a;
  };

  var no = function no(c, e, a) {
    var n = L(c) ? eo : ao,
        t = arguments.length < 3;
    return n(c, Sn(e, 4), a, t, _n);
  },
      to = "[object Map]",
      ro = "[object Set]",
      io = Object.prototype.hasOwnProperty;

  var oo = function oo(c) {
    if (null == c) return !0;
    if (Ya(c) && (L(c) || "string" == typeof c || "function" == typeof c.splice || Object(ya.a)(c) || Ea(c) || te(c))) return !c.length;
    var e = rn(c);
    if (e == to || e == ro) return !c.size;
    if (Qa(c)) return !Ra(c).length;

    for (var a in c) {
      if (io.call(c, a)) return !1;
    }

    return !0;
  },
      lo = a(10),
      fo = a.n(lo),
      so = ti.instance,
      uo = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleButtonOverrides = function (c) {
        return {
          onClick: function onClick(a, n) {
            De(c, "onClick", a, n), De(e.props, "onActionClick", a, n);
          }
        };
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this,
          a = this.props,
          t = a.actions,
          r = a.children,
          i = a.className,
          l = a.content,
          f = Ie("actions", i),
          s = je(e, this.props),
          u = zr(e, this.props);
      return n.isNil(r) ? n.isNil(l) ? o.a.createElement(u, Object(p.a)({}, s, {
        className: f
      }), Oi(t, function (e) {
        return Yi.create(e, {
          overrideProps: c.handleButtonOverrides
        });
      })) : o.a.createElement(u, Object(p.a)({}, s, {
        className: f
      }), l) : o.a.createElement(u, Object(p.a)({}, s, {
        className: f
      }), r);
    }, e;
  }(i.Component);

  function ho(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.image,
        i = c.scrolling,
        l = Ie(a, ur(r, "image"), ur(i, "scrolling"), "content"),
        f = je(ho, c),
        s = zr(ho, c);
    return o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), n.isNil(e) ? t : e);
  }

  uo.handledProps = ["actions", "as", "children", "className", "content", "onActionClick"], uo.propTypes = {}, uo.create = Er(uo, function (c) {
    return {
      actions: c
    };
  }), ho.handledProps = ["as", "children", "className", "content", "image", "scrolling"], ho.propTypes = {}, ho.create = Er(ho, function (c) {
    return {
      content: c
    };
  });
  var mo = ho;

  function vo(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("description", a),
        i = je(vo, c),
        l = zr(vo, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  vo.handledProps = ["as", "children", "className", "content"], vo.propTypes = {};
  var Mo = vo,
      po = ni() ? o.a.useLayoutEffect : o.a.useEffect,
      zo = /\s+/;

  var Co = new Map(),
      Lo = function Lo(c, e) {
    var a = function (c) {
      var e = [];
      return c ? (c.forEach(function (c) {
        "string" == typeof c.current && c.current.split(zo).forEach(function (c) {
          e.push(c);
        });
      }), e.filter(function (c, e, a) {
        return c.length > 0 && a.indexOf(c) === e;
      })) : [];
    }(e),
        n = function (c, e) {
      return [e.filter(function (e) {
        return -1 === c.indexOf(e);
      }), c.filter(function (c) {
        return -1 === e.indexOf(c);
      })];
    }(Co.get(c) || [], a),
        t = n[0],
        r = n[1];

    c && (t.forEach(function (e) {
      return c.classList.add(e);
    }), r.forEach(function (e) {
      return c.classList.remove(e);
    })), Co.set(c, a);
  },
      Ao = new function () {
    var c = this;
    this.add = function (e, a) {
      if (c.nodes.has(e)) c.nodes.get(e).add(a);else {
        var n = new Set();
        n.add(a), c.nodes.set(e, n);
      }
    }, this.del = function (e, a) {
      if (c.nodes.has(e)) {
        var n = c.nodes.get(e);
        1 !== n.size ? n.delete(a) : c.nodes.delete(e);
      }
    }, this.emit = function (e, a) {
      a(e, c.nodes.get(e));
    }, this.nodes = new Map();
  }();

  function No(c) {
    var e = c.blurring,
        a = c.children,
        t = c.className,
        r = c.centered,
        i = c.content,
        l = c.inverted,
        f = c.mountNode,
        s = c.scrolling,
        u = o.a.useRef(),
        m = Ie("ui", ur(l, "inverted"), ur(!r, "top aligned"), "page modals dimmer transition visible active", t),
        v = Ie("dimmable dimmed", ur(e, "blurring"), ur(s, "scrolling")),
        d = je(No, c),
        z = zr(No, c);
    return function (c, e) {
      var a = o.a.useRef(),
          n = o.a.useRef(!1);
      po(function () {
        if (a.current = e, n.current) {
          var t = h(c) ? c.current : c;
          Ao.emit(t, Lo);
        }

        n.current = !0;
      }, [e]), po(function () {
        var e = h(c) ? c.current : c;
        return Ao.add(e, a), Ao.emit(e, Lo), function () {
          Ao.del(e, a), Ao.emit(e, Lo);
        };
      }, [c]);
    }(f, v), o.a.useEffect(function () {
      u.current && u.current.style && u.current.style.setProperty("display", "flex", "important");
    }, []), o.a.createElement(M, {
      innerRef: u
    }, o.a.createElement(z, Object(p.a)({}, d, {
      className: m
    }), n.isNil(a) ? i : a));
  }

  No.handledProps = ["as", "blurring", "centered", "children", "className", "content", "inverted", "mountNode", "scrolling"], No.propTypes = {}, No.create = Er(No, function (c) {
    return {
      content: c
    };
  });
  var go = No;

  function Ho(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("header", a),
        i = je(Ho, c),
        l = zr(Ho, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  Ho.handledProps = ["as", "children", "className", "content"], Ho.propTypes = {}, Ho.create = Er(Ho, function (c) {
    return {
      content: c
    };
  });

  var Vo = Ho,
      xo = function xo(c) {
    var e = c.height + 0,
        a = c.height + 0,
        n = window.innerHeight;
    return n / 2 + -a / 2 + e + 50 < n;
  },
      wo = function wo(c, e, a) {
    var n = e && c ? -a.height / 2 : 0;
    return {
      marginLeft: -a.width / 2,
      marginTop: n
    };
  },
      yo = function yo() {
    return !window.ActiveXObject && "ActiveXObject" in window;
  },
      bo = function (c) {
    function e() {
      for (var a, t = arguments.length, r = new Array(t), l = 0; l < t; l++) {
        r[l] = arguments[l];
      }

      return (a = c.call.apply(c, [this].concat(r)) || this).legacy = ni() && yo(), a.ref = Object(i.createRef)(), a.dimmerRef = Object(i.createRef)(), a.latestDocumentMouseDownEvent = null, a.getMountNode = function () {
        return ni() ? a.props.mountNode || document.body : null;
      }, a.handleActionsOverrides = function (c) {
        return {
          onActionClick: function onActionClick(e, n) {
            De(c, "onActionClick", e, n), De(a.props, "onActionClick", e, a.props), a.handleClose(e);
          }
        };
      }, a.handleClose = function (c) {
        a.setState({
          open: !1
        }), De(a.props, "onClose", c, Object(p.a)({}, a.props, {
          open: !1
        }));
      }, a.handleDocumentMouseDown = function (c) {
        a.latestDocumentMouseDownEvent = c;
      }, a.handleDocumentClick = function (c) {
        var e = a.props.closeOnDimmerClick,
            n = a.latestDocumentMouseDownEvent;
        a.latestDocumentMouseDownEvent = null, !e || mi(a.ref.current, n) || mi(a.ref.current, c) || (a.setState({
          open: !1
        }), De(a.props, "onClose", c, Object(p.a)({}, a.props, {
          open: !1
        })));
      }, a.handleIconOverrides = function (c) {
        return {
          onClick: function onClick(e) {
            De(c, "onClick", e), a.handleClose(e);
          }
        };
      }, a.handleOpen = function (c) {
        De(a.props, "onOpen", c, Object(p.a)({}, a.props, {
          open: !0
        })), a.setState({
          open: !0
        });
      }, a.handlePortalMount = function (c) {
        var e = a.props.eventPool;
        a.setState({
          scrolling: !1
        }), a.setPositionAndClassNames(), so.sub("mousedown", a.handleDocumentMouseDown, {
          pool: e,
          target: a.dimmerRef.current
        }), so.sub("click", a.handleDocumentClick, {
          pool: e,
          target: a.dimmerRef.current
        }), De(a.props, "onMount", c, a.props);
      }, a.handlePortalUnmount = function (c) {
        var e = a.props.eventPool;
        cancelAnimationFrame(a.animationRequestId), so.unsub("mousedown", a.handleDocumentMouseDown, {
          pool: e,
          target: a.dimmerRef.current
        }), so.unsub("click", a.handleDocumentClick, {
          pool: e,
          target: a.dimmerRef.current
        }), De(a.props, "onUnmount", c, a.props);
      }, a.setPositionAndClassNames = function () {
        var c,
            e = a.props.centered,
            n = {};

        if (a.ref.current) {
          var t = a.ref.current.getBoundingClientRect(),
              r = xo(t);
          c = !r;
          var i = a.legacy ? wo(r, e, t) : {};
          fo()(a.state.legacyStyles, i) || (n.legacyStyles = i), a.state.scrolling !== c && (n.scrolling = c);
        }

        oo(n) || a.setState(n), a.animationRequestId = requestAnimationFrame(a.setPositionAndClassNames);
      }, a.renderContent = function (c) {
        var t = a.props,
            r = t.actions,
            i = t.basic,
            l = t.children,
            f = t.className,
            s = t.closeIcon,
            u = t.content,
            h = t.header,
            m = t.size,
            v = t.style,
            d = a.state,
            z = d.legacyStyles,
            C = d.scrolling,
            L = Ie("ui", m, ur(i, "basic"), ur(a.legacy, "legacy"), ur(C, "scrolling"), "modal transition visible active", f),
            A = zr(e, a.props),
            N = !0 === s ? "close" : s,
            g = Pr.create(N, {
          overrideProps: a.handleIconOverrides
        });
        return o.a.createElement(M, {
          innerRef: a.ref
        }, o.a.createElement(A, Object(p.a)({}, c, {
          className: L,
          style: Object(p.a)({}, z, v)
        }), g, n.isNil(l) ? o.a.createElement(o.a.Fragment, null, Vo.create(h, {
          autoGenerateKey: !1
        }), mo.create(u, {
          autoGenerateKey: !1
        }), uo.create(r, {
          overrideProps: a.handleActionsOverrides
        })) : l));
      }, a;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.componentWillUnmount = function () {
      this.handlePortalUnmount();
    }, a.render = function () {
      var c = this.props,
          a = c.centered,
          n = c.closeOnDocumentClick,
          t = c.dimmer,
          r = c.eventPool,
          l = c.trigger,
          f = this.state,
          s = f.open,
          u = f.scrolling,
          h = this.getMountNode();
      if (!ni()) return Object(i.isValidElement)(l) ? l : null;
      var m = je(e, this.props),
          v = Li.handledProps,
          d = no(m, function (c, e, a) {
        return Gr(v, a) || (c[a] = e), c;
      }, {}),
          z = co(m, v);
      return o.a.createElement(Li, Object(p.a)({
        closeOnDocumentClick: n
      }, z, {
        trigger: l,
        eventPool: r,
        mountNode: h,
        open: s,
        onClose: this.handleClose,
        onMount: this.handlePortalMount,
        onOpen: this.handleOpen,
        onUnmount: this.handlePortalUnmount
      }), o.a.createElement(M, {
        innerRef: this.dimmerRef
      }, go.create(xr(t) ? t : {}, {
        autoGenerateKey: !1,
        defaultProps: {
          blurring: "blurring" === t,
          inverted: "inverted" === t
        },
        overrideProps: {
          children: this.renderContent(d),
          centered: a,
          mountNode: h,
          scrolling: u
        }
      })));
    }, e;
  }(Mi);

  bo.handledProps = ["actions", "as", "basic", "centered", "children", "className", "closeIcon", "closeOnDimmerClick", "closeOnDocumentClick", "content", "defaultOpen", "dimmer", "eventPool", "header", "mountNode", "onActionClick", "onClose", "onMount", "onOpen", "onUnmount", "open", "size", "style", "trigger"], bo.propTypes = {}, bo.defaultProps = {
    centered: !0,
    dimmer: !0,
    closeOnDimmerClick: !0,
    closeOnDocumentClick: !1,
    eventPool: "Modal"
  }, bo.autoControlledProps = ["open"], bo.Actions = uo, bo.Content = mo, bo.Description = Mo, bo.Dimmer = go, bo.Header = Vo;

  var So = bo,
      To = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleCancel = function (c) {
        De(e.props, "onCancel", c, e.props);
      }, e.handleCancelOverrides = function (c) {
        return {
          onClick: function onClick(a, n) {
            De(c, "onClick", a, n), e.handleCancel(a);
          }
        };
      }, e.handleConfirmOverrides = function (c) {
        return {
          onClick: function onClick(a, n) {
            De(c, "onClick", a, n), De(e.props, "onConfirm", a, e.props);
          }
        };
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.cancelButton,
          n = c.confirmButton,
          t = c.content,
          r = c.header,
          i = c.open,
          l = c.size,
          f = je(e, this.props),
          s = {};
      return me(this.props, "open") && (s.open = i), o.a.createElement(So, Object(p.a)({}, f, s, {
        size: l,
        onClose: this.handleCancel
      }), So.Header.create(r, {
        autoGenerateKey: !1
      }), So.Content.create(t, {
        autoGenerateKey: !1
      }), o.a.createElement(So.Actions, null, Yi.create(a, {
        autoGenerateKey: !1,
        overrideProps: this.handleCancelOverrides
      }), Yi.create(n, {
        autoGenerateKey: !1,
        defaultProps: {
          primary: !0
        },
        overrideProps: this.handleConfirmOverrides
      })));
    }, e;
  }(i.Component);

  To.handledProps = ["cancelButton", "confirmButton", "content", "header", "onCancel", "onConfirm", "open", "size"], To.propTypes = {}, To.defaultProps = {
    cancelButton: "Cancel",
    confirmButton: "OK",
    content: "Are you sure?",
    size: "small"
  };

  var Do = To,
      jo = function jo(c) {
    return {
      active: !1,
      type: "ellipsisItem",
      value: c
    };
  },
      Eo = function Eo(c) {
    return {
      active: !1,
      type: "prevItem",
      value: Math.max(1, c - 1)
    };
  },
      ko = function ko(c, e) {
    return {
      active: !1,
      type: "nextItem",
      value: Math.min(c + 1, e)
    };
  },
      Io = function Io(c) {
    return {
      active: !1,
      type: "lastItem",
      value: c
    };
  },
      Oo = Math.ceil,
      Qo = Math.max;

  var Zo = function Zo(c, e, a, n) {
    for (var t = -1, r = Qo(Oo((e - c) / (a || 1)), 0), i = Array(r); r--;) {
      i[n ? r : ++t] = c, c += a;
    }

    return i;
  };

  var Uo = function (c) {
    return function (e, a, n) {
      return n && "number" != typeof n && ct(e, a, n) && (a = n = void 0), e = Fn(e), void 0 === a ? (a = e, e = 0) : a = Fn(a), n = void 0 === n ? e < a ? 1 : -1 : Fn(n), Zo(e, a, n, c);
    };
  }(),
      Bo = function Bo(c, e, a) {
    var n = e - 1;
    return (n !== c + 1 ? jo : a)(n);
  },
      Ro = function Ro(c, e, a) {
    var n = c + 1;
    return (n !== e - 1 ? jo : a)(n);
  },
      Yo = function Yo(c, e, a) {
    return Oi(Uo(c, e + 1), a);
  },
      Po = function Po(c) {
    var e,
        a,
        n,
        t = {
      activePage: +(e = c).activePage,
      boundaryRange: +e.boundaryRange,
      hideEllipsis: !!e.hideEllipsis,
      siblingRange: +e.siblingRange,
      totalPages: +e.totalPages
    },
        r = t.activePage,
        i = t.totalPages,
        o = function (c) {
      return function (e) {
        return {
          active: c === e,
          type: "pageItem",
          value: e
        };
      };
    }(r),
        l = (n = (a = t).boundaryRange, 1 + (a.hideEllipsis ? 0 : 2) + 2 * a.siblingRange + 2 * n >= a.totalPages ? Yo(1, i, o) : function (c, e) {
      var a = c.activePage,
          n = c.boundaryRange,
          t = c.hideEllipsis,
          r = c.siblingRange,
          i = c.totalPages,
          o = t ? 0 : 1,
          l = n,
          f = Yo(1, l, e),
          s = i + 1 - n,
          u = Yo(s, i, e),
          h = Math.min(Math.max(a - r, l + o + 1), s - o - 2 * r - 1),
          m = h + 2 * r,
          v = Yo(h, m, e);
      return [].concat(f, [!t && Bo(l, h, e)], v, [!t && Ro(m, s, e)], u).filter(Boolean);
    }(t, o));

    return [{
      active: !1,
      type: "firstItem",
      value: 1
    }, Eo(r)].concat(l, [ko(r, i), Io(i)]);
  };

  function Fo(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("header", a),
        i = je(Fo, c),
        l = zr(Fo, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  Fo.handledProps = ["as", "children", "className", "content"], Fo.propTypes = {};
  var Wo = Fo;

  var Go = function (c) {
    return function (e) {
      return null == c ? void 0 : c[e];
    };
  }({
    "À": "A",
    "Á": "A",
    "Â": "A",
    "Ã": "A",
    "Ä": "A",
    "Å": "A",
    "à": "a",
    "á": "a",
    "â": "a",
    "ã": "a",
    "ä": "a",
    "å": "a",
    "Ç": "C",
    "ç": "c",
    "Ð": "D",
    "ð": "d",
    "È": "E",
    "É": "E",
    "Ê": "E",
    "Ë": "E",
    "è": "e",
    "é": "e",
    "ê": "e",
    "ë": "e",
    "Ì": "I",
    "Í": "I",
    "Î": "I",
    "Ï": "I",
    "ì": "i",
    "í": "i",
    "î": "i",
    "ï": "i",
    "Ñ": "N",
    "ñ": "n",
    "Ò": "O",
    "Ó": "O",
    "Ô": "O",
    "Õ": "O",
    "Ö": "O",
    "Ø": "O",
    "ò": "o",
    "ó": "o",
    "ô": "o",
    "õ": "o",
    "ö": "o",
    "ø": "o",
    "Ù": "U",
    "Ú": "U",
    "Û": "U",
    "Ü": "U",
    "ù": "u",
    "ú": "u",
    "û": "u",
    "ü": "u",
    "Ý": "Y",
    "ý": "y",
    "ÿ": "y",
    "Æ": "Ae",
    "æ": "ae",
    "Þ": "Th",
    "þ": "th",
    "ß": "ss",
    "Ā": "A",
    "Ă": "A",
    "Ą": "A",
    "ā": "a",
    "ă": "a",
    "ą": "a",
    "Ć": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Č": "C",
    "ć": "c",
    "ĉ": "c",
    "ċ": "c",
    "č": "c",
    "Ď": "D",
    "Đ": "D",
    "ď": "d",
    "đ": "d",
    "Ē": "E",
    "Ĕ": "E",
    "Ė": "E",
    "Ę": "E",
    "Ě": "E",
    "ē": "e",
    "ĕ": "e",
    "ė": "e",
    "ę": "e",
    "ě": "e",
    "Ĝ": "G",
    "Ğ": "G",
    "Ġ": "G",
    "Ģ": "G",
    "ĝ": "g",
    "ğ": "g",
    "ġ": "g",
    "ģ": "g",
    "Ĥ": "H",
    "Ħ": "H",
    "ĥ": "h",
    "ħ": "h",
    "Ĩ": "I",
    "Ī": "I",
    "Ĭ": "I",
    "Į": "I",
    "İ": "I",
    "ĩ": "i",
    "ī": "i",
    "ĭ": "i",
    "į": "i",
    "ı": "i",
    "Ĵ": "J",
    "ĵ": "j",
    "Ķ": "K",
    "ķ": "k",
    "ĸ": "k",
    "Ĺ": "L",
    "Ļ": "L",
    "Ľ": "L",
    "Ŀ": "L",
    "Ł": "L",
    "ĺ": "l",
    "ļ": "l",
    "ľ": "l",
    "ŀ": "l",
    "ł": "l",
    "Ń": "N",
    "Ņ": "N",
    "Ň": "N",
    "Ŋ": "N",
    "ń": "n",
    "ņ": "n",
    "ň": "n",
    "ŋ": "n",
    "Ō": "O",
    "Ŏ": "O",
    "Ő": "O",
    "ō": "o",
    "ŏ": "o",
    "ő": "o",
    "Ŕ": "R",
    "Ŗ": "R",
    "Ř": "R",
    "ŕ": "r",
    "ŗ": "r",
    "ř": "r",
    "Ś": "S",
    "Ŝ": "S",
    "Ş": "S",
    "Š": "S",
    "ś": "s",
    "ŝ": "s",
    "ş": "s",
    "š": "s",
    "Ţ": "T",
    "Ť": "T",
    "Ŧ": "T",
    "ţ": "t",
    "ť": "t",
    "ŧ": "t",
    "Ũ": "U",
    "Ū": "U",
    "Ŭ": "U",
    "Ů": "U",
    "Ű": "U",
    "Ų": "U",
    "ũ": "u",
    "ū": "u",
    "ŭ": "u",
    "ů": "u",
    "ű": "u",
    "ų": "u",
    "Ŵ": "W",
    "ŵ": "w",
    "Ŷ": "Y",
    "ŷ": "y",
    "Ÿ": "Y",
    "Ź": "Z",
    "Ż": "Z",
    "Ž": "Z",
    "ź": "z",
    "ż": "z",
    "ž": "z",
    "Ĳ": "IJ",
    "ĳ": "ij",
    "Œ": "Oe",
    "œ": "oe",
    "ŉ": "'n",
    "ſ": "s"
  }),
      qo = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
      Jo = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g");

  var Ko = function Ko(c) {
    return (c = Xc(c)) && c.replace(qo, Go).replace(Jo, "");
  },
      Xo = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  var _o = function _o(c) {
    return c.match(Xo) || [];
  },
      $o = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  var cl = function cl(c) {
    return $o.test(c);
  },
      el = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
      al = "[" + el + "]",
      nl = "\\d+",
      tl = "[\\u2700-\\u27bf]",
      rl = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
      il = "[^\\ud800-\\udfff" + el + nl + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
      ol = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      ll = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      fl = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
      sl = "(?:" + rl + "|" + il + ")",
      ul = "(?:" + fl + "|" + il + ")",
      hl = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",
      ml = "[\\ufe0e\\ufe0f]?" + hl + ("(?:\\u200d(?:" + ["[^\\ud800-\\udfff]", ol, ll].join("|") + ")[\\ufe0e\\ufe0f]?" + hl + ")*"),
      vl = "(?:" + [tl, ol, ll].join("|") + ")" + ml,
      dl = RegExp([fl + "?" + rl + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [al, fl, "$"].join("|") + ")", ul + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [al, fl + sl, "$"].join("|") + ")", fl + "?" + sl + "+(?:['’](?:d|ll|m|re|s|t|ve))?", fl + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", nl, vl].join("|"), "g");

  var Ml = function Ml(c) {
    return c.match(dl) || [];
  };

  var pl = function pl(c, e, a) {
    return c = Xc(c), void 0 === (e = a ? void 0 : e) ? cl(c) ? Ml(c) : _o(c) : c.match(e) || [];
  },
      zl = RegExp("['’]", "g");

  var Cl = function Cl(c) {
    return function (e) {
      return eo(pl(Ko(e).replace(zl, "")), c, "");
    };
  };

  var Ll = function Ll(c, e, a) {
    var n = c.length;
    return a = void 0 === a ? n : a, !e && a >= n ? c : pe(c, e, a);
  },
      Al = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");

  var Nl = function Nl(c) {
    return Al.test(c);
  };

  var gl = function gl(c) {
    return c.split("");
  },
      Hl = "[\\ud800-\\udfff]",
      Vl = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
      xl = "[^\\ud800-\\udfff]",
      wl = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      yl = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      bl = "(?:" + Vl + "|\\ud83c[\\udffb-\\udfff])" + "?",
      Sl = "[\\ufe0e\\ufe0f]?" + bl + ("(?:\\u200d(?:" + [xl, wl, yl].join("|") + ")[\\ufe0e\\ufe0f]?" + bl + ")*"),
      Tl = "(?:" + [xl + Vl + "?", Vl, wl, yl, Hl].join("|") + ")",
      Dl = RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|" + Tl + Sl, "g");

  var jl = function jl(c) {
    return c.match(Dl) || [];
  };

  var El = function El(c) {
    return Nl(c) ? jl(c) : gl(c);
  };

  var kl = function (c) {
    return function (e) {
      e = Xc(e);
      var a = Nl(e) ? El(e) : void 0,
          n = a ? a[0] : e.charAt(0),
          t = a ? Ll(a, 1).join("") : e.slice(1);
      return n[c]() + t;
    };
  }("toUpperCase"),
      Il = Cl(function (c, e, a) {
    return c + (a ? " " : "") + kl(e);
  }),
      Ol = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleClick = function (c) {
        e.props.disabled || De(e.props, "onClick", c, e.props);
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.active,
          t = c.children,
          r = c.className,
          i = c.color,
          l = c.content,
          f = c.disabled,
          s = c.fitted,
          u = c.header,
          h = c.icon,
          m = c.link,
          v = c.name,
          d = c.onClick,
          M = c.position,
          z = Ie(i, M, ur(a, "active"), ur(f, "disabled"), ur(!0 === h || h && !(v || l), "icon"), ur(u, "header"), ur(m, "link"), mr(s, "fitted"), "item", r),
          C = zr(e, this.props, function () {
        if (d) return "a";
      }),
          L = je(e, this.props);
      return n.isNil(t) ? o.a.createElement(C, Object(p.a)({}, L, {
        className: z,
        onClick: this.handleClick
      }), Pr.create(h, {
        autoGenerateKey: !1
      }), n.isNil(l) ? Il(v) : l) : o.a.createElement(C, Object(p.a)({}, L, {
        className: z,
        onClick: this.handleClick
      }), t);
    }, e;
  }(i.Component);

  function Ql(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.position,
        i = Ie(r, "menu", a),
        l = je(Ql, c),
        f = zr(Ql, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(e) ? t : e);
  }

  Ol.handledProps = ["active", "as", "children", "className", "color", "content", "disabled", "fitted", "header", "icon", "index", "link", "name", "onClick", "position"], Ol.propTypes = {}, Ol.create = Er(Ol, function (c) {
    return {
      content: c,
      name: c
    };
  }), Ql.handledProps = ["as", "children", "className", "content", "position"], Ql.propTypes = {};

  var Zl = Ql,
      Ul = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleItemOverrides = function (c) {
        return {
          onClick: function onClick(a, n) {
            var t = n.index;
            e.setState({
              activeIndex: t
            }), De(c, "onClick", a, n), De(e.props, "onItemClick", a, n);
          }
        };
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.renderItems = function () {
      var c = this,
          e = this.props.items,
          a = this.state.activeIndex;
      return Oi(e, function (e, n) {
        return Ol.create(e, {
          defaultProps: {
            active: parseInt(a, 10) === n,
            index: n
          },
          overrideProps: c.handleItemOverrides
        });
      });
    }, a.render = function () {
      var c = this.props,
          a = c.attached,
          t = c.borderless,
          r = c.children,
          i = c.className,
          l = c.color,
          f = c.compact,
          s = c.fixed,
          u = c.floated,
          h = c.fluid,
          m = c.icon,
          v = c.inverted,
          d = c.pagination,
          M = c.pointing,
          z = c.secondary,
          C = c.size,
          L = c.stackable,
          A = c.tabular,
          N = c.text,
          g = c.vertical,
          H = c.widths,
          V = Ie("ui", l, C, ur(t, "borderless"), ur(f, "compact"), ur(h, "fluid"), ur(v, "inverted"), ur(d, "pagination"), ur(M, "pointing"), ur(z, "secondary"), ur(L, "stackable"), ur(N, "text"), ur(g, "vertical"), mr(a, "attached"), mr(u, "floated"), mr(m, "icon"), mr(A, "tabular"), hr(s, "fixed"), pr(H, "item"), i, "menu"),
          x = je(e, this.props),
          w = zr(e, this.props);
      return o.a.createElement(w, Object(p.a)({}, x, {
        className: V
      }), n.isNil(r) ? this.renderItems() : r);
    }, e;
  }(Mi);

  Ul.handledProps = ["activeIndex", "as", "attached", "borderless", "children", "className", "color", "compact", "defaultActiveIndex", "fixed", "floated", "fluid", "icon", "inverted", "items", "onItemClick", "pagination", "pointing", "secondary", "size", "stackable", "tabular", "text", "vertical", "widths"], Ul.propTypes = {}, Ul.autoControlledProps = ["activeIndex"], Ul.Header = Wo, Ul.Item = Ol, Ul.Menu = Zl, Ul.create = Er(Ul, function (c) {
    return {
      items: c
    };
  });

  var Bl = Ul,
      Rl = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleClick = function (c) {
        De(e.props, "onClick", c, e.props);
      }, e.handleKeyDown = function (c) {
        De(e.props, "onKeyDown", c, e.props), oi.a.getCode(c) === oi.a.Enter && De(e.props, "onClick", c, e.props);
      }, e.handleOverrides = function () {
        return {
          onClick: e.handleClick,
          onKeyDown: e.handleKeyDown
        };
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          e = c.active,
          a = c.type,
          n = this.props.disabled || "ellipsisItem" === a;
      return Ol.create(this.props, {
        defaultProps: {
          active: e,
          "aria-current": e,
          "aria-disabled": n,
          disabled: n,
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown,
          tabIndex: n ? -1 : 0
        },
        overrideProps: this.handleOverrides
      });
    }, e;
  }(i.Component);

  Rl.handledProps = ["active", "disabled", "onClick", "onKeyDown", "type"], Rl.propTypes = {}, Rl.create = Er(Rl, function (c) {
    return {
      content: c
    };
  });

  var Yl = Rl,
      Pl = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleItemClick = function (c, a) {
        var n = a.value;
        +e.state.activePage != +n && (e.setState({
          activePage: n
        }), De(e.props, "onPageChange", c, Object(p.a)({}, e.props, {
          activePage: n
        })));
      }, e.handleItemOverrides = function (c, a, n) {
        return function (t) {
          return {
            active: c,
            type: a,
            key: a + "-" + n,
            onClick: function onClick(c, a) {
              De(t, "onClick", c, a), "ellipsisItem" !== a.type && e.handleItemClick(c, a);
            }
          };
        };
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.getInitialAutoControlledState = function () {
      return {
        activePage: 1
      };
    }, a.render = function () {
      var c = this,
          a = this.props,
          n = a["aria-label"],
          t = a.boundaryRange,
          r = a.disabled,
          i = a.ellipsisItem,
          l = a.siblingRange,
          f = a.totalPages,
          s = this.state.activePage,
          u = Po({
        activePage: s,
        boundaryRange: t,
        hideEllipsis: Ee(i),
        siblingRange: l,
        totalPages: f
      }),
          h = je(e, this.props);
      return o.a.createElement(Bl, Object(p.a)({}, h, {
        "aria-label": n,
        pagination: !0,
        role: "navigation"
      }), Oi(u, function (e) {
        var a = e.active,
            n = e.type,
            t = e.value;
        return Yl.create(c.props[n], {
          defaultProps: {
            content: t,
            disabled: r,
            value: t
          },
          overrideProps: c.handleItemOverrides(a, n, t)
        });
      }));
    }, e;
  }(Mi);

  Pl.handledProps = ["activePage", "aria-label", "boundaryRange", "defaultActivePage", "disabled", "ellipsisItem", "firstItem", "lastItem", "nextItem", "onPageChange", "pageItem", "prevItem", "siblingRange", "totalPages"], Pl.propTypes = {}, Pl.autoControlledProps = ["activePage"], Pl.defaultProps = {
    "aria-label": "Pagination Navigation",
    boundaryRange: 1,
    ellipsisItem: "...",
    firstItem: {
      "aria-label": "First item",
      content: "«"
    },
    lastItem: {
      "aria-label": "Last item",
      content: "»"
    },
    nextItem: {
      "aria-label": "Next item",
      content: "⟩"
    },
    pageItem: {},
    prevItem: {
      "aria-label": "Previous item",
      content: "⟨"
    },
    siblingRange: 1
  }, Pl.Item = Yl;

  var Fl = function Fl(c, e, a) {
    return null == c ? c : Gi(c, e, a);
  },
      Wl = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).inputRef = Object(i.createRef)(), e.labelRef = Object(i.createRef)(), e.canToggle = function () {
        var c = e.props,
            a = c.disabled,
            n = c.radio,
            t = c.readOnly,
            r = e.state.checked;
        return !(a || t || n && r);
      }, e.computeTabIndex = function () {
        var c = e.props,
            a = c.disabled,
            n = c.tabIndex;
        return Ee(n) ? a ? -1 : 0 : n;
      }, e.handleClick = function (c) {
        var a = e.props.id,
            n = e.state,
            t = n.checked,
            r = n.indeterminate,
            i = De(e.inputRef.current, "contains", c.target),
            o = De(e.labelRef.current, "contains", c.target),
            l = !o && !i,
            f = !Ee(a);
        o && f || De(e.props, "onClick", c, Object(p.a)({}, e.props, {
          checked: !t,
          indeterminate: !!r
        })), e.isClickFromMouse && (e.isClickFromMouse = !1, o && !f && e.handleChange(c), l && e.handleChange(c), o && f && c.stopPropagation());
      }, e.handleChange = function (c) {
        var a = e.state.checked;
        e.canToggle() && (De(e.props, "onChange", c, Object(p.a)({}, e.props, {
          checked: !a,
          indeterminate: !1
        })), e.setState({
          checked: !a,
          indeterminate: !1
        }));
      }, e.handleMouseDown = function (c) {
        var a = e.state,
            n = a.checked,
            t = a.indeterminate;
        De(e.props, "onMouseDown", c, Object(p.a)({}, e.props, {
          checked: !!n,
          indeterminate: !!t
        })), c.defaultPrevented || De(e.inputRef.current, "focus"), c.preventDefault();
      }, e.handleMouseUp = function (c) {
        var a = e.state,
            n = a.checked,
            t = a.indeterminate;
        e.isClickFromMouse = !0, De(e.props, "onMouseUp", c, Object(p.a)({}, e.props, {
          checked: !!n,
          indeterminate: !!t
        }));
      }, e.setIndeterminate = function () {
        var c = e.state.indeterminate;
        Fl(e.inputRef, "current.indeterminate", !!c);
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.componentDidMount = function () {
      this.setIndeterminate();
    }, a.componentDidUpdate = function () {
      this.setIndeterminate();
    }, a.render = function () {
      var c = this.props,
          a = c.className,
          n = c.disabled,
          t = c.label,
          r = c.id,
          i = c.name,
          l = c.radio,
          f = c.readOnly,
          s = c.slider,
          u = c.toggle,
          h = c.type,
          m = c.value,
          v = this.state,
          d = v.checked,
          z = v.indeterminate,
          C = Ie("ui", ur(d, "checked"), ur(n, "disabled"), ur(z, "indeterminate"), ur(Ee(t), "fitted"), ur(l, "radio"), ur(f, "read-only"), ur(s, "slider"), ur(u, "toggle"), "checkbox", a),
          L = je(e, this.props),
          A = zr(e, this.props),
          N = ci(L, {
        htmlProps: Xr
      }),
          g = N[0],
          H = N[1],
          V = Zr(t, {
        defaultProps: {
          htmlFor: r
        },
        autoGenerateKey: !1
      }) || o.a.createElement("label", {
        htmlFor: r
      });
      return o.a.createElement(A, Object(p.a)({}, H, {
        className: C,
        onClick: this.handleClick,
        onChange: this.handleChange,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp
      }), o.a.createElement(M, {
        innerRef: this.inputRef
      }, o.a.createElement("input", Object(p.a)({}, g, {
        checked: d,
        className: "hidden",
        disabled: n,
        id: r,
        name: i,
        readOnly: !0,
        tabIndex: this.computeTabIndex(),
        type: h,
        value: m
      }))), o.a.createElement(M, {
        innerRef: this.labelRef
      }, V));
    }, e;
  }(Mi);

  function Gl(c) {
    var e = c.slider,
        a = c.toggle,
        n = c.type,
        t = je(Gl, c),
        r = !(e || a) || void 0;
    return o.a.createElement(Wl, Object(p.a)({}, t, {
      type: n,
      radio: r,
      slider: e,
      toggle: a
    }));
  }

  Wl.handledProps = ["as", "checked", "className", "defaultChecked", "defaultIndeterminate", "disabled", "fitted", "id", "indeterminate", "label", "name", "onChange", "onClick", "onMouseDown", "onMouseUp", "radio", "readOnly", "slider", "tabIndex", "toggle", "type", "value"], Wl.propTypes = {}, Wl.defaultProps = {
    type: "checkbox"
  }, Wl.autoControlledProps = ["checked", "indeterminate"], Gl.handledProps = ["slider", "toggle", "type"], Gl.propTypes = {}, Gl.defaultProps = {
    type: "radio"
  };
  var ql = Gl;

  var Jl = function Jl(c) {
    for (var e = -1, a = null == c ? 0 : c.length, n = 0, t = []; ++e < a;) {
      var r = c[e];
      r && (t[n++] = r);
    }

    return t;
  };

  var Kl = function Kl(c, e) {
    for (var a = -1, n = null == c ? 0 : c.length; ++a < n;) {
      if (!e(c[a], a, c)) return !1;
    }

    return !0;
  };

  var Xl = function Xl(c, e) {
    var a = !0;
    return _n(c, function (c, n, t) {
      return a = !!e(c, n, t);
    }), a;
  };

  var _l = function _l(c, e, a) {
    var n = L(c) ? Kl : Xl;
    return a && ct(c, e, a) && (e = void 0), n(c, Sn(e, 3));
  },
      $l = 200;

  var cf = function cf(c, e, a, n) {
    var t = -1,
        r = lt,
        i = !0,
        o = c.length,
        l = [],
        f = e.length;
    if (!o) return l;
    a && (e = Wc(e, Ta(a))), n ? (r = ft, i = !1) : e.length >= $l && (r = Xe, i = !1, e = new Je(e));

    c: for (; ++t < o;) {
      var s = c[t],
          u = null == a ? s : a(s);

      if (s = n || 0 !== s ? s : 0, i && u == u) {
        for (var h = f; h--;) {
          if (e[h] === u) continue c;
        }

        l.push(s);
      } else r(e, u, n) || l.push(s);
    }

    return l;
  };

  var ef = function ef(c) {
    return E(c) && Ya(c);
  },
      af = Te(function (c, e) {
    return ef(c) ? cf(c, e) : [];
  });

  var nf = function nf(c, e, a) {
    var n = null == c ? 0 : c.length;
    return n ? (e = a || void 0 === e ? 1 : Wn(e), pe(c, 0, (e = n - e) < 0 ? 0 : e)) : [];
  },
      tf = wn("length"),
      rf = "[\\ud800-\\udfff]",
      of = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
      lf = "[^\\ud800-\\udfff]",
      ff = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      sf = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      uf = "(?:" + of + "|\\ud83c[\\udffb-\\udfff])" + "?",
      hf = "[\\ufe0e\\ufe0f]?" + uf + ("(?:\\u200d(?:" + [lf, ff, sf].join("|") + ")[\\ufe0e\\ufe0f]?" + uf + ")*"),
      mf = "(?:" + [lf + of + "?", of, ff, sf, rf].join("|") + ")",
      vf = RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|" + mf + hf, "g");

  var df = function df(c) {
    for (var e = vf.lastIndex = 0; vf.test(c);) {
      ++e;
    }

    return e;
  };

  var Mf = function Mf(c) {
    return Nl(c) ? df(c) : tf(c);
  },
      pf = "[object Map]",
      zf = "[object Set]";

  var Cf = function Cf(c) {
    if (null == c) return 0;
    if (Ya(c)) return Sr(c) ? Mf(c) : c.length;
    var e = rn(c);
    return e == pf || e == zf ? c.size : Ra(c).length;
  },
      Lf = Te(function (c, e) {
    return ef(c) ? cf(c, _i(e, 1, ef, !0)) : [];
  }),
      Af = Te(function (c) {
    return mt(_i(c, 1, ef, !0));
  });

  var Nf = function Nf(c, e) {
    return mn(c, e);
  },
      gf = function (c) {
    function e() {
      return c.apply(this, arguments) || this;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.className,
          n = c.name,
          t = Ie(n, "flag", a),
          r = je(e, this.props),
          i = zr(e, this.props);
      return o.a.createElement(i, Object(p.a)({}, r, {
        className: t
      }));
    }, e;
  }(i.PureComponent);

  gf.handledProps = ["as", "className", "name"], gf.propTypes = {}, gf.defaultProps = {
    as: "i"
  }, gf.create = Er(gf, function (c) {
    return {
      name: c
    };
  });
  var Hf = gf;

  function Vf(c) {
    var e = c.className,
        a = Ie("divider", e),
        n = je(Vf, c),
        t = zr(Vf, c);
    return o.a.createElement(t, Object(p.a)({}, n, {
      className: a
    }));
  }

  Vf.handledProps = ["as", "className"], Vf.propTypes = {};

  var xf = Vf,
      wf = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleClick = function (c) {
        De(e.props, "onClick", c, e.props);
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.active,
          t = c.children,
          r = c.className,
          i = c.content,
          l = c.disabled,
          f = c.description,
          s = c.flag,
          u = c.icon,
          h = c.image,
          m = c.label,
          v = c.selected,
          d = c.text,
          M = Ie(ur(a, "active"), ur(l, "disabled"), ur(v, "selected"), "item", r),
          z = Ee(u) ? n.someByType(t, "DropdownMenu") && "dropdown" : u,
          C = je(e, this.props),
          L = zr(e, this.props),
          A = {
        role: "option",
        "aria-disabled": l,
        "aria-checked": a,
        "aria-selected": v
      };
      if (!n.isNil(t)) return o.a.createElement(L, Object(p.a)({}, C, A, {
        className: M,
        onClick: this.handleClick
      }), t);
      var N = Hf.create(s, {
        autoGenerateKey: !1
      }),
          g = Pr.create(z, {
        autoGenerateKey: !1
      }),
          H = yi.create(h, {
        autoGenerateKey: !1
      }),
          V = ji.create(m, {
        autoGenerateKey: !1
      }),
          x = jr("span", function (c) {
        return {
          children: c
        };
      }, f, {
        defaultProps: {
          className: "description"
        },
        autoGenerateKey: !1
      }),
          w = jr("span", function (c) {
        return {
          children: c
        };
      }, n.isNil(i) ? d : i, {
        defaultProps: {
          className: "text"
        },
        autoGenerateKey: !1
      });
      return o.a.createElement(L, Object(p.a)({}, C, A, {
        className: M,
        onClick: this.handleClick
      }), H, g, N, V, x, w);
    }, e;
  }(i.Component);

  wf.handledProps = ["active", "as", "children", "className", "content", "description", "disabled", "flag", "icon", "image", "label", "onClick", "selected", "text", "value"], wf.propTypes = {}, wf.create = Er(wf, function (c) {
    return c;
  });
  var yf = wf;

  function bf(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.icon,
        i = Ie("header", a),
        l = je(bf, c),
        f = zr(bf, c);
    return n.isNil(e) ? o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), Pr.create(r, {
      autoGenerateKey: !1
    }), t) : o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), e);
  }

  bf.handledProps = ["as", "children", "className", "content", "icon"], bf.propTypes = {}, bf.create = Er(bf, function (c) {
    return {
      content: c
    };
  });
  var Sf = bf;

  function Tf(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.direction,
        i = c.open,
        l = c.scrolling,
        f = Ie(r, ur(i, "visible"), ur(l, "scrolling"), "menu transition", a),
        s = je(Tf, c),
        u = zr(Tf, c);
    return o.a.createElement(u, Object(p.a)({}, s, {
      className: f
    }), n.isNil(e) ? t : e);
  }

  Tf.handledProps = ["as", "children", "className", "content", "direction", "open", "scrolling"], Tf.propTypes = {};

  var Df = Tf,
      jf = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleChange = function (c) {
        var a = An(c, "target.value");
        De(e.props, "onChange", c, Object(p.a)({}, e.props, {
          value: a
        }));
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.autoComplete,
          n = c.className,
          t = c.tabIndex,
          r = c.type,
          i = c.value,
          l = Ie("search", n),
          f = je(e, this.props);
      return o.a.createElement("input", Object(p.a)({}, f, {
        "aria-autocomplete": "list",
        autoComplete: a,
        className: l,
        onChange: this.handleChange,
        tabIndex: t,
        type: r,
        value: i
      }));
    }, e;
  }(i.Component);

  jf.handledProps = ["as", "autoComplete", "className", "tabIndex", "type", "value"], jf.propTypes = {}, jf.defaultProps = {
    autoComplete: "off",
    type: "text"
  }, jf.create = Er(jf, function (c) {
    return {
      type: c
    };
  });
  var Ef = jf;

  function kf(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("divider", a),
        i = je(kf, c),
        l = zr(kf, c);
    return o.a.createElement(l, Object(p.a)({
      "aria-atomic": !0,
      "aria-live": "polite",
      role: "alert"
    }, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  kf.handledProps = ["as", "children", "className", "content"], kf.propTypes = {}, kf.create = Er(kf, function (c) {
    return {
      content: c
    };
  });
  var If = kf,
      Of = /[\\^$.*+?()[\]{}|]/g,
      Qf = RegExp(Of.source);

  var Zf = function Zf(c) {
    return (c = Xc(c)) && Qf.test(c) ? c.replace(Of, "\\$&") : c;
  };

  var Uf = function Uf(c, e) {
    var a = [];
    return _n(c, function (c, n, t) {
      e(c, n, t) && a.push(c);
    }), a;
  };

  var Bf = function Bf(c, e) {
    return (L(c) ? Na : Uf)(c, Sn(e, 3));
  };

  function Rf(c) {
    var e = c.additionLabel,
        a = c.additionPosition,
        n = c.allowAdditions,
        t = c.deburr,
        r = c.multiple,
        i = c.options,
        l = c.search,
        f = c.searchQuery,
        s = c.value,
        u = i;
    if (r && (u = Bf(u, function (c) {
      return !Gr(s, c.value);
    })), l && f) if (W(l)) u = l(u, f);else {
      var h = t ? Ko(f) : f,
          m = new RegExp(Zf(h), "i");
      u = Bf(u, function (c) {
        return m.test(t ? Ko(c.text) : c.text);
      });
    }

    if (n && l && f && !et(u, {
      text: f
    })) {
      var v = {
        key: "addition",
        text: [o.a.isValidElement(e) ? o.a.cloneElement(e, {
          key: "addition-label"
        }) : e || "", o.a.createElement("b", {
          key: "addition-query"
        }, f)],
        value: f,
        className: "addition",
        "data-additional": !0
      };
      "top" === a ? u.unshift(v) : u.push(v);
    }

    return u;
  }

  function Yf(c) {
    var e,
        a = c.additionLabel,
        n = c.additionPosition,
        t = c.allowAdditions,
        r = c.deburr,
        i = c.multiple,
        o = c.options,
        l = c.search,
        f = c.searchQuery,
        s = c.selectedIndex,
        u = c.value,
        h = Rf({
      value: u,
      options: o,
      searchQuery: f,
      additionLabel: a,
      additionPosition: n,
      allowAdditions: t,
      deburr: r,
      multiple: i,
      search: l
    }),
        m = no(h, function (c, e, a) {
      return e.disabled || c.push(a), c;
    }, []);

    if (!s || s < 0) {
      var v = m[0];
      e = i ? v : qn(h, ["value", u]) || m[0];
    } else if (i) e = Jn(m, function (c) {
      return c >= s;
    }), s >= h.length - 1 && (e = m[m.length - 1]);else {
      var d = qn(h, ["value", u]);
      e = Gr(m, d) ? d : void 0;
    }

    return (!e || e < 0) && (e = m[0]), e;
  }

  Rf.handledProps = [];

  var Pf = function Pf(c, e) {
    return Ee(c) ? e : c;
  },
      Ff = function Ff(c) {
    return c ? c.map(function (c) {
      return co(c, ["key", "value"]);
    }) : c;
  };

  function Wf(c) {
    var e = c.flag,
        a = c.image,
        n = c.text;
    return W(n) ? n : {
      content: o.a.createElement(o.a.Fragment, null, Hf.create(e), yi.create(a), n)
    };
  }

  var Gf = function (c) {
    function e() {
      for (var e, a = arguments.length, t = new Array(a), r = 0; r < a; r++) {
        t[r] = arguments[r];
      }

      return (e = c.call.apply(c, [this].concat(t)) || this).searchRef = Object(i.createRef)(), e.sizerRef = Object(i.createRef)(), e.ref = Object(i.createRef)(), e.handleChange = function (c, a) {
        De(e.props, "onChange", c, Object(p.a)({}, e.props, {
          value: a
        }));
      }, e.closeOnChange = function (c) {
        var a = e.props,
            n = a.closeOnChange,
            t = a.multiple;
        (Fr(n) ? !t : n) && e.close(c, st);
      }, e.closeOnEscape = function (c) {
        e.props.closeOnEscape && oi.a.getCode(c) === oi.a.Escape && (c.preventDefault(), e.close(c));
      }, e.moveSelectionOnKeyDown = function (c) {
        var a,
            n = e.props,
            t = n.multiple,
            r = n.selectOnNavigation;

        if (e.state.open) {
          var i = ((a = {})[oi.a.ArrowDown] = 1, a[oi.a.ArrowUp] = -1, a)[oi.a.getCode(c)];

          if (void 0 !== i) {
            c.preventDefault();
            var o = e.getSelectedIndexAfterMove(i);
            !t && r && e.makeSelectedItemActive(c, o), e.setState({
              selectedIndex: o
            });
          }
        }
      }, e.openOnSpace = function (c) {
        var a,
            n,
            t,
            r = e.state.focus && !e.state.open && oi.a.getCode(c) === oi.a.Spacebar,
            i = "INPUT" !== (null == (a = c.target) ? void 0 : a.tagName) && "TEXTAREA" !== (null == (n = c.target) ? void 0 : n.tagName) && !0 !== (null == (t = c.target) ? void 0 : t.isContentEditable);
        r && (i && c.preventDefault(), e.open(c));
      }, e.openOnArrow = function (c) {
        var a = e.state,
            n = a.focus,
            t = a.open;

        if (n && !t) {
          var r = oi.a.getCode(c);
          r !== oi.a.ArrowDown && r !== oi.a.ArrowUp || (c.preventDefault(), e.open(c));
        }
      }, e.makeSelectedItemActive = function (c, a) {
        var n = e.state,
            t = n.open,
            r = n.value,
            i = e.props.multiple,
            o = e.getSelectedItem(a),
            l = An(o, "value"),
            f = An(o, "disabled");
        if (Ee(l) || !t || f) return r;
        var s = i ? Af(r, [l]) : l;
        return (i ? !!Lf(s, r).length : s !== r) && (e.setState({
          value: s
        }), e.handleChange(c, s), o["data-additional"] && De(e.props, "onAddItem", c, Object(p.a)({}, e.props, {
          value: l
        }))), r;
      }, e.selectItemOnEnter = function (c) {
        var a = e.props.search,
            n = e.state,
            t = n.open,
            r = n.selectedIndex;

        if (t && (oi.a.getCode(c) === oi.a.Enter || !a && oi.a.getCode(c) === oi.a.Spacebar)) {
          c.preventDefault();
          var i = Cf(Rf({
            value: e.state.value,
            options: e.props.options,
            searchQuery: e.state.searchQuery,
            additionLabel: e.props.additionLabel,
            additionPosition: e.props.additionPosition,
            allowAdditions: e.props.allowAdditions,
            deburr: e.props.deburr,
            multiple: e.props.multiple,
            search: e.props.search
          }));

          if (!a || 0 !== i) {
            var o = e.makeSelectedItemActive(c, r);
            e.setState({
              selectedIndex: Yf({
                additionLabel: e.props.additionLabel,
                additionPosition: e.props.additionPosition,
                allowAdditions: e.props.allowAdditions,
                deburr: e.props.deburr,
                multiple: e.props.multiple,
                search: e.props.search,
                selectedIndex: r,
                value: o,
                options: e.props.options,
                searchQuery: ""
              })
            }), e.closeOnChange(c), e.clearSearchQuery(), a && De(e.searchRef.current, "focus");
          }
        }
      }, e.removeItemOnBackspace = function (c) {
        var a = e.props,
            n = a.multiple,
            t = a.search,
            r = e.state,
            i = r.searchQuery,
            o = r.value;

        if (oi.a.getCode(c) === oi.a.Backspace && !i && t && n && !oo(o)) {
          c.preventDefault();
          var l = nf(o);
          e.setState({
            value: l
          }), e.handleChange(c, l);
        }
      }, e.closeOnDocumentClick = function (c) {
        e.props.closeOnBlur && (e.ref.current && mi(e.ref.current, c) || e.close());
      }, e.handleMouseDown = function (c) {
        e.isMouseDown = !0, De(e.props, "onMouseDown", c, e.props), document.addEventListener("mouseup", e.handleDocumentMouseUp);
      }, e.handleDocumentMouseUp = function () {
        e.isMouseDown = !1, document.removeEventListener("mouseup", e.handleDocumentMouseUp);
      }, e.handleClick = function (c) {
        var a = e.props,
            n = a.minCharacters,
            t = a.search,
            r = e.state,
            i = r.open,
            o = r.searchQuery;
        if (De(e.props, "onClick", c, e.props), c.stopPropagation(), !t) return e.toggle(c);
        i ? De(e.searchRef.current, "focus") : o.length >= n || 1 === n ? e.open(c) : De(e.searchRef.current, "focus");
      }, e.handleIconClick = function (c) {
        var a = e.props.clearable,
            n = e.hasValue();
        De(e.props, "onClick", c, e.props), c.stopPropagation(), a && n ? e.clearValue(c) : e.toggle(c);
      }, e.handleItemClick = function (c, a) {
        var n = e.props,
            t = n.multiple,
            r = n.search,
            i = e.state.value,
            o = a.value;

        if (c.stopPropagation(), (t || a.disabled) && c.nativeEvent.stopImmediatePropagation(), !a.disabled) {
          var l = a["data-additional"],
              f = t ? Af(e.state.value, [o]) : o;
          (t ? !!Lf(f, i).length : f !== i) && (e.setState({
            value: f
          }), e.handleChange(c, f)), e.clearSearchQuery(), De(r ? e.searchRef.current : e.ref.current, "focus"), e.closeOnChange(c), l && De(e.props, "onAddItem", c, Object(p.a)({}, e.props, {
            value: o
          }));
        }
      }, e.handleFocus = function (c) {
        e.state.focus || (De(e.props, "onFocus", c, e.props), e.setState({
          focus: !0
        }));
      }, e.handleBlur = function (c) {
        var a = An(c, "currentTarget");

        if (!a || !a.contains(document.activeElement)) {
          var n = e.props,
              t = n.closeOnBlur,
              r = n.multiple,
              i = n.selectOnBlur;
          e.isMouseDown || (De(e.props, "onBlur", c, e.props), i && !r && (e.makeSelectedItemActive(c, e.state.selectedIndex), t && e.close()), e.setState({
            focus: !1
          }), e.clearSearchQuery());
        }
      }, e.handleSearchChange = function (c, a) {
        var n = a.value;
        c.stopPropagation();
        var t = e.props.minCharacters,
            r = e.state.open,
            i = n;
        De(e.props, "onSearchChange", c, Object(p.a)({}, e.props, {
          searchQuery: i
        })), e.setState({
          searchQuery: i,
          selectedIndex: 0
        }), !r && i.length >= t ? e.open() : r && 1 !== t && i.length < t && e.close();
      }, e.handleKeyDown = function (c) {
        e.moveSelectionOnKeyDown(c), e.openOnArrow(c), e.openOnSpace(c), e.selectItemOnEnter(c), De(e.props, "onKeyDown", c);
      }, e.getSelectedItem = function (c) {
        var a = Rf({
          value: e.state.value,
          options: e.props.options,
          searchQuery: e.state.searchQuery,
          additionLabel: e.props.additionLabel,
          additionPosition: e.props.additionPosition,
          allowAdditions: e.props.allowAdditions,
          deburr: e.props.deburr,
          multiple: e.props.multiple,
          search: e.props.search
        });
        return An(a, "[" + c + "]");
      }, e.getItemByValue = function (c) {
        var a = e.props.options;
        return Jn(a, {
          value: c
        });
      }, e.getDropdownAriaOptions = function () {
        var c = e.props,
            a = c.loading,
            n = c.disabled,
            t = c.search,
            r = c.multiple,
            i = {
          role: t ? "combobox" : "listbox",
          "aria-busy": a,
          "aria-disabled": n,
          "aria-expanded": !!e.state.open
        };
        return "listbox" === i.role && (i["aria-multiselectable"] = r), i;
      }, e.clearSearchQuery = function () {
        var c = e.state.searchQuery;
        void 0 !== c && "" !== c && e.setState({
          searchQuery: ""
        });
      }, e.handleLabelClick = function (c, a) {
        c.stopPropagation(), e.setState({
          selectedLabel: a.value
        }), De(e.props, "onLabelClick", c, a);
      }, e.handleLabelRemove = function (c, a) {
        c.stopPropagation();
        var n = e.state.value,
            t = af(n, a.value);
        e.setState({
          value: t
        }), e.handleChange(c, t);
      }, e.getSelectedIndexAfterMove = function (c, a) {
        void 0 === a && (a = e.state.selectedIndex);
        var n = Rf({
          value: e.state.value,
          options: e.props.options,
          searchQuery: e.state.searchQuery,
          additionLabel: e.props.additionLabel,
          additionPosition: e.props.additionPosition,
          allowAdditions: e.props.allowAdditions,
          deburr: e.props.deburr,
          multiple: e.props.multiple,
          search: e.props.search
        });

        if (void 0 !== n && !_l(n, "disabled")) {
          var t = n.length - 1,
              r = a + c;
          return !e.props.wrapSelection && (r > t || r < 0) ? r = a : r > t ? r = 0 : r < 0 && (r = t), n[r].disabled ? e.getSelectedIndexAfterMove(c, r) : r;
        }
      }, e.handleIconOverrides = function (c) {
        var a = e.props.clearable;
        return {
          className: Ie(a && e.hasValue() && "clear", c.className),
          onClick: function onClick(a) {
            De(c, "onClick", a, c), e.handleIconClick(a);
          }
        };
      }, e.clearValue = function (c) {
        var a = e.props.multiple ? [] : "";
        e.setState({
          value: a
        }), e.handleChange(c, a);
      }, e.computeSearchInputTabIndex = function () {
        var c = e.props,
            a = c.disabled,
            n = c.tabIndex;
        return Ee(n) ? a ? -1 : 0 : n;
      }, e.computeSearchInputWidth = function () {
        var c = e.state.searchQuery;

        if (e.sizerRef.current && c) {
          e.sizerRef.current.style.display = "inline", e.sizerRef.current.textContent = c;
          var a = Math.ceil(e.sizerRef.current.getBoundingClientRect().width);
          return e.sizerRef.current.style.removeProperty("display"), a;
        }
      }, e.computeTabIndex = function () {
        var c = e.props,
            a = c.disabled,
            n = c.search,
            t = c.tabIndex;
        if (!n) return a ? -1 : Ee(t) ? 0 : t;
      }, e.handleSearchInputOverrides = function (c) {
        return {
          onChange: function onChange(a, n) {
            De(c, "onChange", a, n), e.handleSearchChange(a, n);
          }
        };
      }, e.hasValue = function () {
        var c = e.props.multiple,
            a = e.state.value;
        return c ? !oo(a) : !Ee(a) && "" !== a;
      }, e.scrollSelectedItemIntoView = function () {
        if (e.ref.current) {
          var c = e.ref.current.querySelector(".menu.visible");

          if (c) {
            var a = c.querySelector(".item.selected");

            if (a) {
              var n = a.offsetTop < c.scrollTop,
                  t = a.offsetTop + a.clientHeight > c.scrollTop + c.clientHeight;
              n ? c.scrollTop = a.offsetTop : t && (c.scrollTop = a.offsetTop + a.clientHeight - c.clientHeight);
            }
          }
        }
      }, e.setOpenDirection = function () {
        if (e.ref.current) {
          var c = e.ref.current.querySelector(".menu.visible");

          if (c) {
            var a = e.ref.current.getBoundingClientRect(),
                n = c.clientHeight,
                t = document.documentElement.clientHeight - a.top - a.height - n,
                r = a.top - n,
                i = t < 0 && r > t;
            !i != !e.state.upward && e.setState({
              upward: i
            });
          }
        }
      }, e.open = function (c, a) {
        void 0 === c && (c = null), void 0 === a && (a = !0);
        var n = e.props,
            t = n.disabled,
            r = n.search;
        t || (r && De(e.searchRef.current, "focus"), De(e.props, "onOpen", c, e.props), a && e.setState({
          open: !0
        }), e.scrollSelectedItemIntoView());
      }, e.close = function (c, a) {
        void 0 === a && (a = e.handleClose), e.state.open && (De(e.props, "onClose", c, e.props), e.setState({
          open: !1
        }, a));
      }, e.handleClose = function () {
        var c = document.activeElement === e.searchRef.current;
        !c && e.ref.current && e.ref.current.blur();
        var a = document.activeElement === e.ref.current,
            n = c || a;
        e.setState({
          focus: n
        });
      }, e.toggle = function (c) {
        return e.state.open ? e.close(c) : e.open(c);
      }, e.renderText = function () {
        var c,
            a = e.props,
            n = a.multiple,
            t = a.placeholder,
            r = a.search,
            i = a.text,
            o = e.state,
            l = o.searchQuery,
            f = o.selectedIndex,
            s = o.value,
            u = o.open,
            h = e.hasValue(),
            m = Ie(t && !h && "default", "text", r && l && "filtered"),
            v = t;
        return i ? v = i : u && !n ? c = e.getSelectedItem(f) : h && (c = e.getItemByValue(s)), If.create(c ? Wf(c) : v, {
          defaultProps: {
            className: m
          }
        });
      }, e.renderSearchInput = function () {
        var c = e.props,
            a = c.search,
            n = c.searchInput,
            t = e.state.searchQuery;
        return a && o.a.createElement(M, {
          innerRef: e.searchRef
        }, Ef.create(n, {
          defaultProps: {
            style: {
              width: e.computeSearchInputWidth()
            },
            tabIndex: e.computeSearchInputTabIndex(),
            value: t
          },
          overrideProps: e.handleSearchInputOverrides
        }));
      }, e.renderSearchSizer = function () {
        var c = e.props,
            a = c.search,
            n = c.multiple;
        return a && n && o.a.createElement("span", {
          className: "sizer",
          ref: e.sizerRef
        });
      }, e.renderLabels = function () {
        var c = e.props,
            a = c.multiple,
            n = c.renderLabel,
            t = e.state,
            r = t.selectedLabel,
            i = t.value;

        if (a && !oo(i)) {
          var o = Oi(i, e.getItemByValue);
          return Oi(Jl(o), function (c, a) {
            var t = {
              active: c.value === r,
              as: "a",
              key: Pf(c.key, c.value),
              onClick: e.handleLabelClick,
              onRemove: e.handleLabelRemove,
              value: c.value
            };
            return ji.create(n(c, a, t), {
              defaultProps: t
            });
          });
        }
      }, e.renderOptions = function () {
        var c = e.props,
            a = c.lazyLoad,
            n = c.multiple,
            t = c.search,
            r = c.noResultsMessage,
            i = e.state,
            l = i.open,
            f = i.selectedIndex,
            s = i.value;
        if (a && !l) return null;
        var u = Rf({
          value: e.state.value,
          options: e.props.options,
          searchQuery: e.state.searchQuery,
          additionLabel: e.props.additionLabel,
          additionPosition: e.props.additionPosition,
          allowAdditions: e.props.allowAdditions,
          deburr: e.props.deburr,
          multiple: e.props.multiple,
          search: e.props.search
        });
        if (null !== r && t && oo(u)) return o.a.createElement("div", {
          className: "message"
        }, r);
        var h = n ? function (c) {
          return Gr(s, c);
        } : function (c) {
          return c === s;
        };
        return Oi(u, function (c, a) {
          return yf.create(Object(p.a)({
            active: h(c.value),
            selected: f === a
          }, c, {
            key: Pf(c.key, c.value),
            style: Object(p.a)({}, c.style, {
              pointerEvents: "all"
            })
          }), {
            generateKey: !1,
            overrideProps: function overrideProps(c) {
              return {
                onClick: function onClick(a, n) {
                  null == c.onClick || c.onClick(a, n), e.handleItemClick(a, n);
                }
              };
            }
          });
        });
      }, e.renderMenu = function () {
        var c = e.props,
            a = c.children,
            t = c.direction,
            r = c.header,
            l = e.state.open,
            f = e.getDropdownMenuAriaOptions();

        if (!n.isNil(a)) {
          var s = i.Children.only(a),
              u = Ie(t, ur(l, "visible"), s.props.className);
          return Object(i.cloneElement)(s, Object(p.a)({
            className: u
          }, f));
        }

        return o.a.createElement(Df, Object(p.a)({}, f, {
          direction: t,
          open: l
        }), Sf.create(r, {
          autoGenerateKey: !1
        }), e.renderOptions());
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.getInitialAutoControlledState = function () {
      return {
        focus: !1,
        searchQuery: ""
      };
    }, e.getAutoControlledStateFromProps = function (c, e, a) {
      var n = {
        __options: c.options,
        __value: e.value
      };
      return (!fo()(a.__value, e.value) || !Nf(Ff(c.options), Ff(a.__options))) && (n.selectedIndex = Yf({
        additionLabel: c.additionLabel,
        additionPosition: c.additionPosition,
        allowAdditions: c.allowAdditions,
        deburr: c.deburr,
        multiple: c.multiple,
        search: c.search,
        selectedIndex: e.selectedIndex,
        value: e.value,
        options: c.options,
        searchQuery: e.searchQuery
      })), n;
    }, a.componentDidMount = function () {
      this.state.open && this.open(null, !1);
    }, a.shouldComponentUpdate = function (c, e) {
      return !fo()(c, this.props) || !fo()(e, this.state);
    }, a.componentDidUpdate = function (c, e) {
      var a = this.props,
          n = a.closeOnBlur,
          t = a.minCharacters,
          r = a.openOnFocus,
          i = a.search;

      if (!e.focus && this.state.focus) {
        if (!this.isMouseDown) {
          var o = !i || i && 1 === t && !this.state.open;
          r && o && this.open();
        }
      } else e.focus && !this.state.focus && !this.isMouseDown && n && this.close();

      !e.open && this.state.open ? (this.setOpenDirection(), this.scrollSelectedItemIntoView()) : e.open && this.state.open, e.selectedIndex !== this.state.selectedIndex && this.scrollSelectedItemIntoView();
    }, a.getDropdownMenuAriaOptions = function () {
      var c = this.props,
          e = c.search,
          a = c.multiple,
          n = {};
      return e && (n["aria-multiselectable"] = a, n.role = "listbox"), n;
    }, a.render = function () {
      var c = this.props,
          a = c.basic,
          n = c.button,
          t = c.className,
          r = c.compact,
          i = c.disabled,
          l = c.error,
          f = c.fluid,
          s = c.floating,
          u = c.icon,
          h = c.inline,
          m = c.item,
          v = c.labeled,
          d = c.loading,
          z = c.multiple,
          C = c.pointing,
          L = c.search,
          A = c.selection,
          N = c.scrolling,
          g = c.simple,
          H = c.trigger,
          V = this.state,
          x = V.focus,
          w = V.open,
          y = V.upward,
          b = Ie("ui", ur(w, "active visible"), ur(i, "disabled"), ur(l, "error"), ur(d, "loading"), ur(a, "basic"), ur(n, "button"), ur(r, "compact"), ur(f, "fluid"), ur(s, "floating"), ur(h, "inline"), ur(v, "labeled"), ur(m, "item"), ur(z, "multiple"), ur(L, "search"), ur(A, "selection"), ur(g, "simple"), ur(N, "scrolling"), ur(y, "upward"), mr(C, "pointing"), "dropdown", t),
          S = je(e, this.props),
          T = zr(e, this.props),
          D = this.getDropdownAriaOptions(T, this.props);
      return o.a.createElement(M, {
        innerRef: this.ref
      }, o.a.createElement(T, Object(p.a)({}, S, D, {
        className: b,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        tabIndex: this.computeTabIndex()
      }), this.renderLabels(), this.renderSearchInput(), this.renderSearchSizer(), H || this.renderText(), Pr.create(u, {
        overrideProps: this.handleIconOverrides,
        autoGenerateKey: !1
      }), this.renderMenu(), w && o.a.createElement(ri.a, {
        name: "keydown",
        on: this.closeOnEscape
      }), w && o.a.createElement(ri.a, {
        name: "click",
        on: this.closeOnDocumentClick
      }), x && o.a.createElement(ri.a, {
        name: "keydown",
        on: this.removeItemOnBackspace
      })));
    }, e;
  }(Mi);

  function qf(c) {
    return o.a.createElement(Gf, Object(p.a)({}, c, {
      selection: !0
    }));
  }

  Gf.handledProps = ["additionLabel", "additionPosition", "allowAdditions", "as", "basic", "button", "children", "className", "clearable", "closeOnBlur", "closeOnChange", "closeOnEscape", "compact", "deburr", "defaultOpen", "defaultSearchQuery", "defaultSelectedLabel", "defaultUpward", "defaultValue", "direction", "disabled", "error", "floating", "fluid", "header", "icon", "inline", "item", "labeled", "lazyLoad", "loading", "minCharacters", "multiple", "noResultsMessage", "onAddItem", "onBlur", "onChange", "onClick", "onClose", "onFocus", "onLabelClick", "onMouseDown", "onOpen", "onSearchChange", "open", "openOnFocus", "options", "placeholder", "pointing", "renderLabel", "scrolling", "search", "searchInput", "searchQuery", "selectOnBlur", "selectOnNavigation", "selectedLabel", "selection", "simple", "tabIndex", "text", "trigger", "upward", "value", "wrapSelection"], Gf.propTypes = {}, Gf.defaultProps = {
    additionLabel: "Add ",
    additionPosition: "top",
    closeOnBlur: !0,
    closeOnEscape: !0,
    deburr: !1,
    icon: "dropdown",
    minCharacters: 1,
    noResultsMessage: "No results found.",
    openOnFocus: !0,
    renderLabel: Wf,
    searchInput: "text",
    selectOnBlur: !0,
    selectOnNavigation: !0,
    wrapSelection: !0
  }, Gf.autoControlledProps = ["open", "searchQuery", "selectedLabel", "value", "upward"], Gf.Divider = xf, Gf.Header = Sf, Gf.Item = yf, Gf.Menu = Df, Gf.SearchInput = Ef, Gf.Text = If, qf.handledProps = ["options"], qf.propTypes = {}, qf.Divider = Gf.Divider, qf.Header = Gf.Header, qf.Item = Gf.Item, qf.Menu = Gf.Menu;

  var Jf = qf,
      Kf = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).ref = Object(i.createRef)(), e.focus = function () {
        return e.ref.current.focus();
      }, e.handleChange = function (c) {
        var a = An(c, "target.value");
        De(e.props, "onChange", c, Object(p.a)({}, e.props, {
          value: a
        }));
      }, e.handleInput = function (c) {
        var a = An(c, "target.value");
        De(e.props, "onInput", c, Object(p.a)({}, e.props, {
          value: a
        }));
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.rows,
          n = c.value,
          t = je(e, this.props),
          r = zr(e, this.props);
      return o.a.createElement(M, {
        innerRef: this.ref
      }, o.a.createElement(r, Object(p.a)({}, t, {
        onChange: this.handleChange,
        onInput: this.handleInput,
        rows: a,
        value: n
      })));
    }, e;
  }(i.Component);

  Kf.handledProps = ["as", "onChange", "onInput", "rows", "value"], Kf.propTypes = {}, Kf.defaultProps = {
    as: "textarea",
    rows: 3
  };

  var Xf = Kf,
      _f = function _f(c, e) {
    return "number" == typeof c || "string" == typeof c ? c : c[e];
  };

  var $f = function $f(c, e) {
    var a = {};
    return e = Sn(e, 3), Xn(c, function (c, n, t) {
      Pi(a, n, e(c, n, t));
    }), a;
  };

  var cs = function cs(c, e, a, n) {
    for (var t = -1, r = null == c ? 0 : c.length; ++t < r;) {
      var i = c[t];
      e(n, i, a(i), c);
    }

    return n;
  };

  var es = function es(c, e, a, n) {
    return _n(c, function (c, t, r) {
      e(n, c, a(c), r);
    }), n;
  };

  var as = function (c, e) {
    return function (a, n) {
      var t = L(a) ? cs : es,
          r = e ? e() : {};
      return t(a, c, Sn(n, 2), r);
    };
  }(function (c, e, a) {
    Pi(c, a, e);
  }),
      ns = function ns(c) {
    return as(Bf(i.Children.toArray(c), i.isValidElement), "key");
  },
      ts = function ts(c, e, a) {
    return me(a, c) ? a[c] : e[c];
  },
      rs = function rs(c, e) {
    void 0 === c && (c = {}), void 0 === e && (e = {});

    var a = {},
        n = function (c, e) {
      var a = {},
          n = [];
      return Kr(Pa(c), function (c) {
        me(e, c) ? n.length && (a[c] = n, n = []) : n.push(c);
      }), [a, n];
    }(c, e),
        t = n[0],
        r = n[1];

    return Kr(Pa(e), function (n) {
      me(t, n) && Kr(t[n], function (n) {
        a[n] = ts(n, c, e);
      }), a[n] = ts(n, c, e);
    }), Kr(r, function (n) {
      a[n] = ts(n, c, e);
    }), a;
  };

  function is(c, e, a) {
    void 0 === a && (a = {});
    var n = c.key,
        t = a,
        r = t.animation,
        i = t.directional,
        l = t.duration,
        f = t.transitionOnMount,
        s = void 0 !== f && f,
        u = t.visible,
        h = void 0 === u || u;
    return o.a.createElement(zs, {
      animation: r,
      directional: i,
      duration: l,
      key: n,
      onHide: e,
      reactKey: n,
      transitionOnMount: s,
      visible: h
    }, c);
  }

  is.handledProps = [];

  var os = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).state = {
        handleOnHide: function handleOnHide(c, a) {
          var n = a.reactKey;
          e.setState(function (c) {
            var e = Object(p.a)({}, c.children);
            return delete e[n], {
              children: e
            };
          });
        }
      }, e;
    }

    return Object(f.a)(e, c), e.getDerivedStateFromProps = function (c, e) {
      var a = c.animation,
          n = c.duration,
          t = c.directional,
          r = e.children;
      if (void 0 === r) return {
        children: $f(ns(c.children), function (c) {
          return is(c, e.handleOnHide, {
            animation: a,
            duration: n,
            directional: t
          });
        })
      };
      var i = ns(c.children),
          l = rs(r, i);
      return Kr(l, function (c, f) {
        var s = me(r, f),
            u = me(i, f),
            h = r[f],
            m = !An(h, "props.visible");
        if (!u || s && !m) {
          if (u || !s || m) {
            var v = h.props,
                d = v.visible,
                M = v.transitionOnMount;
            l[f] = is(c, e.handleOnHide, {
              animation: a,
              duration: n,
              directional: t,
              transitionOnMount: M,
              visible: d
            });
          } else l[f] = o.a.cloneElement(h, {
            visible: !1
          });
        } else l[f] = is(c, e.handleOnHide, {
          animation: a,
          duration: n,
          directional: t,
          transitionOnMount: !0
        });
      }), {
        children: l
      };
    }, e.prototype.render = function () {
      var c = this.state.children,
          a = zr(e, this.props),
          n = je(e, this.props);
      return o.a.createElement(a, n, Mt(c));
    }, e;
  }(o.a.Component);

  os.handledProps = ["animation", "as", "children", "directional", "duration"], os.propTypes = {}, os.defaultProps = {
    as: o.a.Fragment,
    animation: "fade",
    duration: 500
  };
  var ls,
      fs,
      ss = "INITIAL",
      us = "ENTERED",
      hs = "ENTERING",
      ms = "EXITED",
      vs = "EXITING",
      ds = "UNMOUNTED";

  var Ms = ((ls = {})[us] = "show", ls[ms] = "hide", ls),
      ps = ((fs = {})[hs] = "show", fs[vs] = "hide", fs),
      zs = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), r = 0; r < a; r++) {
        n[r] = arguments[r];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).state = {
        status: ss
      }, e.handleStart = function (c) {
        var a = e.props.duration,
            n = Ms[c],
            t = _f(a, n);

        e.timeoutId = setTimeout(function () {
          return e.setState({
            status: c
          });
        }, t);
      }, e.updateStatus = function (c) {
        if (c.status !== e.state.status && (clearTimeout(e.timeoutId), e.state.nextStatus && e.handleStart(e.state.nextStatus)), !c.animating && e.state.animating && De(e.props, "onStart", null, Object(p.a)({}, e.props, {
          status: e.state.status
        })), c.animating && !e.state.animating) {
          var a = e.state.status === us ? "onShow" : "onHide";
          De(e.props, "onComplete", null, Object(p.a)({}, e.props, {
            status: e.state.status
          })), De(e.props, a, null, Object(p.a)({}, e.props, {
            status: e.state.status
          }));
        }
      }, e.computeClasses = function () {
        var c = e.props,
            a = c.animation,
            n = c.directional,
            r = c.children,
            i = e.state,
            o = i.animating,
            l = i.status,
            f = An(r, "props.className");
        return (Ee(n) ? Gr(t.DIRECTIONAL_TRANSITIONS, a) : n) ? Ie(a, f, ur(o, "animating"), ur(l === hs, "in"), ur(l === vs, "out"), ur(l === ms, "hidden"), ur(l !== ms, "visible"), "transition") : Ie(a, f, ur(o, "animating transition"));
      }, e.computeStyle = function () {
        var c = e.props,
            a = c.children,
            n = c.duration,
            t = e.state.status,
            r = An(a, "props.style"),
            i = ps[t],
            o = i && _f(n, i) + "ms";
        return Object(p.a)({}, r, {
          animationDuration: o
        });
      }, e;
    }

    Object(f.a)(e, c), e.getDerivedStateFromProps = function (c, e) {
      return function (c) {
        var e = c.mountOnShow,
            a = c.status,
            n = c.transitionOnMount,
            t = c.visible,
            r = c.unmountOnHide;

        if (t) {
          if (a === ss) return n ? {
            animating: !0,
            status: hs,
            nextStatus: us
          } : {
            animating: !1,
            status: us,
            nextStatus: void 0
          };
          if (a === ds) return {
            animating: !0,
            status: hs,
            nextStatus: us
          };
          if (a === ms || a === vs) return {
            animating: !0,
            status: hs,
            nextStatus: us
          };
          if (a === hs) return {};
          if (a === us) return {
            animating: !1,
            status: us,
            nextStatus: void 0
          };
        }

        if (a === ss) return e || r ? {
          animating: !1,
          status: ds,
          nextStatus: void 0
        } : {
          animating: !1,
          status: ms,
          nextStatus: void 0
        };
        if (a === us || a === hs) return {
          animating: !0,
          status: vs,
          nextStatus: r ? ds : ms
        };
        if (a === vs) return {};
        if (a === ms) return {
          animating: !1,
          status: ms,
          nextStatus: void 0
        };
        if (a === ds) return {
          animating: !1,
          status: ds,
          nextStatus: void 0
        };
        throw new Error("Transition:computeStatuses(): an unexpected status transition: { visible: " + t + ", status: " + a + " }");
      }({
        mountOnShow: c.mountOnShow,
        status: e.status,
        transitionOnMount: c.transitionOnMount,
        visible: c.visible,
        unmountOnHide: c.unmountOnHide
      });
    };
    var a = e.prototype;
    return a.componentDidMount = function () {
      this.updateStatus({});
    }, a.componentDidUpdate = function (c, e) {
      this.updateStatus(e);
    }, a.componentWillUnmount = function () {
      clearTimeout(this.timeoutId);
    }, a.render = function () {
      var c = this.props.children;
      return this.state.status === ds ? null : Object(i.cloneElement)(c, {
        className: this.computeClasses(),
        style: this.computeStyle()
      });
    }, e;
  }(i.Component);

  zs.INITIAL = ss, zs.ENTERED = us, zs.ENTERING = hs, zs.EXITED = ms, zs.EXITING = vs, zs.UNMOUNTED = ds, zs.Group = os, zs.handledProps = ["animation", "children", "directional", "duration", "mountOnShow", "onComplete", "onHide", "onShow", "onStart", "reactKey", "transitionOnMount", "unmountOnHide", "visible"], zs.propTypes = {}, zs.defaultProps = {
    animation: "fade",
    duration: 500,
    visible: !0,
    mountOnShow: !0,
    transitionOnMount: !1,
    unmountOnHide: !1
  };

  var Cs = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).state = {}, e.handlePortalClose = function () {
        e.setState({
          portalOpen: -1
        });
      }, e.handlePortalOpen = function () {
        e.setState({
          portalOpen: !0
        });
      }, e.handleTransitionHide = function (c, a) {
        var n = e.state.portalOpen;
        e.setState({
          transitionVisible: !1
        }), De(e.props, "onClose", null, Object(p.a)({}, a, {
          portalOpen: !1,
          transitionVisible: !1
        })), De(e.props, "onHide", null, Object(p.a)({}, a, {
          portalOpen: n,
          transitionVisible: !1
        }));
      }, e.handleTransitionStart = function (c, a) {
        var n = e.state.portalOpen,
            t = a.status === hs;
        De(e.props, "onStart", null, Object(p.a)({}, a, {
          portalOpen: n,
          transitionVisible: t
        })), t && (e.setState({
          transitionVisible: t
        }), De(e.props, "onOpen", null, Object(p.a)({}, a, {
          transitionVisible: t,
          portalOpen: !0
        })));
      }, e;
    }

    return Object(f.a)(e, c), e.getDerivedStateFromProps = function (c, e) {
      return -1 === e.portalOpen ? {
        portalOpen: !1
      } : Fr(c.open) ? null : {
        portalOpen: c.open
      };
    }, e.prototype.render = function () {
      var c = this.props,
          a = c.children,
          n = c.transition,
          t = this.state,
          r = t.portalOpen,
          i = t.transitionVisible,
          l = r || i,
          f = je(e, this.props);
      return o.a.createElement(Li, Object(p.a)({}, f, {
        open: l,
        onOpen: this.handlePortalOpen,
        onClose: this.handlePortalClose
      }), o.a.createElement(zs, Object(p.a)({}, n, {
        transitionOnMount: !0,
        onStart: this.handleTransitionStart,
        onHide: this.handleTransitionHide,
        visible: r
      }), a));
    }, e;
  }(i.Component);

  Cs.handledProps = ["children", "onClose", "onHide", "onOpen", "onStart", "open", "transition"], Cs.propTypes = {}, Cs.defaultProps = {
    transition: {
      animation: "scale",
      duration: 400
    }
  };

  var Ls = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).calculations = {
        bottomPassed: !1,
        bottomVisible: !1,
        fits: !1,
        passing: !1,
        offScreen: !1,
        onScreen: !1,
        topPassed: !1,
        topVisible: !1
      }, e.firedCallbacks = [], e.ref = Object(i.createRef)(), e.fire = function (c, a, n) {
        var t = c.callback,
            r = c.name;
        void 0 === n && (n = !1);
        var i = e.props,
            o = i.continuous,
            l = i.once,
            f = e.calculations[a] !== n,
            s = o || e.calculations[a] !== e.oldCalculations[a];
        f && s && e.execute(t, r), l || (e.firedCallbacks = af(e.firedCallbacks, r));
      }, e.handleUpdate = function () {
        e.ticking || (e.ticking = !0, e.frameId = requestAnimationFrame(e.update));
      }, e.update = function () {
        if (e.mounted) {
          e.ticking = !1, e.oldCalculations = e.calculations, e.calculations = e.computeCalculations(), e.pageYOffset = e.getPageYOffset();
          var c = e.props,
              a = c.onBottomPassed,
              n = c.onBottomPassedReverse,
              t = c.onBottomVisible,
              r = c.onBottomVisibleReverse,
              i = c.onPassing,
              o = c.onPassingReverse,
              l = c.onTopPassed,
              f = c.onTopPassedReverse,
              s = c.onTopVisible,
              u = c.onTopVisibleReverse,
              h = c.onOffScreen,
              m = c.onOnScreen,
              v = c.updateOn,
              d = {
            bottomPassed: {
              callback: a,
              name: "onBottomPassed"
            },
            bottomVisible: {
              callback: t,
              name: "onBottomVisible"
            },
            passing: {
              callback: i,
              name: "onPassing"
            },
            offScreen: {
              callback: h,
              name: "onOffScreen"
            },
            onScreen: {
              callback: m,
              name: "onOnScreen"
            },
            topPassed: {
              callback: l,
              name: "onTopPassed"
            },
            topVisible: {
              callback: s,
              name: "onTopVisible"
            }
          },
              M = {
            bottomPassed: {
              callback: n,
              name: "onBottomPassedReverse"
            },
            bottomVisible: {
              callback: r,
              name: "onBottomVisibleReverse"
            },
            passing: {
              callback: o,
              name: "onPassingReverse"
            },
            topPassed: {
              callback: f,
              name: "onTopPassedReverse"
            },
            topVisible: {
              callback: u,
              name: "onTopVisibleReverse"
            }
          };
          De(e.props, "onUpdate", null, Object(p.a)({}, e.props, {
            calculations: e.calculations
          })), e.fireOnPassed(), Kr(M, function (c, a) {
            return e.fire(c, a, !0);
          }), Kr(d, function (c, a) {
            return e.fire(c, a);
          }), "repaint" === v && e.handleUpdate();
        }
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.componentDidMount = function () {
      if (this.mounted = !0, ni()) {
        var c = this.props,
            e = c.context,
            a = c.fireOnMount,
            n = c.updateOn;
        this.pageYOffset = this.getPageYOffset(), this.attachHandlers(e, n), a && this.update();
      }
    }, a.componentDidUpdate = function (c) {
      (c.continuous !== this.props.continuous || c.once !== this.props.once || c.updateOn !== this.props.updateOn) && (this.firedCallbacks = []), c.context === this.props.context && c.updateOn === this.props.updateOn || (this.unattachHandlers(c.context), this.attachHandlers(this.props.context, this.props.updateOn));
    }, a.componentWillUnmount = function () {
      var c = this.props.context;
      this.unattachHandlers(c), this.mounted = !1;
    }, a.attachHandlers = function (c, e) {
      "events" !== e ? this.handleUpdate() : c && (so.sub("resize", this.handleUpdate, {
        target: c
      }), so.sub("scroll", this.handleUpdate, {
        target: c
      }));
    }, a.unattachHandlers = function (c) {
      c && (so.unsub("resize", this.handleUpdate, {
        target: c
      }), so.unsub("scroll", this.handleUpdate, {
        target: c
      })), this.frameId && cancelAnimationFrame(this.frameId);
    }, a.execute = function (c, e) {
      var a = this.props.continuous;
      c && (!a && Gr(this.firedCallbacks, e) || (c(null, Object(p.a)({}, this.props, {
        calculations: this.calculations
      })), this.firedCallbacks.push(e)));
    }, a.fireOnPassed = function () {
      var c = this,
          e = this.calculations,
          a = e.percentagePassed,
          n = e.pixelsPassed,
          t = this.props.onPassed;
      Kr(t, function (e, t) {
        var r = Number(t);
        if (r && n >= r) c.execute(e, t);else {
          var i = ("" + t).match(/^(\d+)%$/);

          if (i) {
            var o = Number(i[1]) / 100;
            a >= o && c.execute(e, t);
          }
        }
      });
    }, a.computeCalculations = function () {
      var c,
          e = this.props.offset,
          a = this.ref.current.getBoundingClientRect(),
          n = a.bottom,
          t = a.height,
          r = a.top,
          i = a.width,
          o = "number" == typeof (c = e) || "string" == typeof c ? [c, c] : c,
          l = o[0],
          f = o[1],
          s = this.getPageYOffset() > this.pageYOffset ? "down" : "up",
          u = r < l,
          h = n < f,
          m = h ? 0 : Math.max(-1 * r, 0),
          v = m / t,
          d = n >= f && n <= window.innerHeight,
          M = r >= l && r <= window.innerHeight,
          p = (M || u) && !h;
      return {
        bottomPassed: h,
        bottomVisible: d,
        direction: s,
        fits: M && d,
        height: t,
        passing: u && !h,
        percentagePassed: v,
        pixelsPassed: m,
        offScreen: !p,
        onScreen: p,
        topPassed: u,
        topVisible: M,
        width: i
      };
    }, a.getPageYOffset = function () {
      var c = this.props.context;
      return c ? c === window ? window.pageYOffset : c.scrollTop : 0;
    }, a.render = function () {
      var c = this.props.children,
          a = zr(e, this.props),
          n = je(e, this.props);
      return o.a.createElement(M, {
        innerRef: this.ref
      }, o.a.createElement(a, n, c));
    }, e;
  }(i.Component);

  function As(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.icon,
        i = Ie("divider", a),
        l = je(As, c),
        f = zr(As, c);
    return Ee(r) ? Ee(t) ? o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(e) ? "/" : e) : o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), t) : Pr.create(r, {
      defaultProps: Object(p.a)({}, l, {
        className: i
      }),
      autoGenerateKey: !1
    });
  }

  Ls.handledProps = ["as", "children", "context", "continuous", "fireOnMount", "offset", "onBottomPassed", "onBottomPassedReverse", "onBottomVisible", "onBottomVisibleReverse", "onOffScreen", "onOnScreen", "onPassed", "onPassing", "onPassingReverse", "onTopPassed", "onTopPassedReverse", "onTopVisible", "onTopVisibleReverse", "onUpdate", "once", "updateOn"], Ls.propTypes = {}, Ls.defaultProps = {
    context: ni() ? window : null,
    continuous: !1,
    offset: [0, 0],
    once: !0,
    updateOn: "events"
  }, As.handledProps = ["as", "children", "className", "content", "icon"], As.propTypes = {}, As.create = Er(As, function (c) {
    return {
      icon: c
    };
  });

  var Ns = As,
      gs = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).computeElementType = function () {
        var c = e.props,
            a = c.link,
            n = c.onClick;
        if (a || n) return "a";
      }, e.handleClick = function (c) {
        return De(e.props, "onClick", c, e.props);
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.active,
          t = c.children,
          r = c.className,
          i = c.content,
          l = c.href,
          f = Ie(ur(a, "active"), "section", r),
          s = je(e, this.props),
          u = zr(e, this.props, this.computeElementType);
      return o.a.createElement(u, Object(p.a)({}, s, {
        className: f,
        href: l,
        onClick: this.handleClick
      }), n.isNil(t) ? i : t);
    }, e;
  }(i.Component);

  function Hs(c) {
    var e = c.children,
        a = c.className,
        t = c.divider,
        r = c.icon,
        i = c.sections,
        l = c.size,
        f = Ie("ui", l, "breadcrumb", a),
        s = je(Hs, c),
        u = zr(Hs, c);
    if (!n.isNil(e)) return o.a.createElement(u, Object(p.a)({}, s, {
      className: f
    }), e);
    var h = [];
    return Kr(i, function (c, e) {
      var a = gs.create(c);

      if (h.push(a), e !== i.length - 1) {
        var n = a.key + "_divider" || !1;
        h.push(Ns.create({
          content: t,
          icon: r,
          key: n
        }));
      }
    }), o.a.createElement(u, Object(p.a)({}, s, {
      className: f
    }), h);
  }

  gs.handledProps = ["active", "as", "children", "className", "content", "href", "link", "onClick"], gs.propTypes = {}, gs.create = Er(gs, function (c) {
    return {
      content: c,
      link: !0
    };
  }), Hs.handledProps = ["as", "children", "className", "divider", "icon", "sections", "size"], Hs.propTypes = {}, Hs.Divider = Ns, Hs.Section = gs;
  var Vs = Hs;

  function xs(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.control,
        l = c.disabled,
        f = c.error,
        s = c.inline,
        u = c.label,
        h = c.required,
        m = c.type,
        v = c.width,
        d = c.id,
        M = Ie(ur(l, "disabled"), ur(f, "error"), ur(s, "inline"), ur(h, "required"), pr(v, "wide"), "field", a),
        z = je(xs, c),
        C = zr(xs, c),
        L = An(f, "pointing", "above"),
        A = ji.create(f, {
      autoGenerateKey: !1,
      defaultProps: {
        prompt: !0,
        pointing: L,
        id: d ? d + "-error-message" : void 0,
        role: "alert",
        "aria-atomic": !0
      }
    }),
        N = ("below" === L || "right" === L) && A,
        g = ("above" === L || "left" === L) && A;
    if (Ee(r)) return Ee(u) ? o.a.createElement(C, Object(p.a)({}, z, {
      className: M,
      id: d
    }), n.isNil(e) ? t : e) : o.a.createElement(C, Object(p.a)({}, z, {
      className: M,
      id: d
    }), N, Zr(u, {
      autoGenerateKey: !1
    }), g);
    var H = {
      "aria-describedby": d && f ? d + "-error-message" : null,
      "aria-invalid": !!f || void 0
    },
        V = Object(p.a)({}, z, {
      content: t,
      children: e,
      disabled: l,
      required: h,
      type: m,
      id: d
    });
    return "input" !== r || "checkbox" !== m && "radio" !== m ? r === Wl || r === ql ? o.a.createElement(C, {
      className: M
    }, N, Object(i.createElement)(r, Object(p.a)({}, H, V, {
      label: u
    })), g) : o.a.createElement(C, {
      className: M
    }, Zr(u, {
      defaultProps: {
        htmlFor: d
      },
      autoGenerateKey: !1
    }), N, Object(i.createElement)(r, Object(p.a)({}, H, V)), g) : o.a.createElement(C, {
      className: M
    }, o.a.createElement("label", null, N, Object(i.createElement)(r, Object(p.a)({}, H, V)), " ", u, g));
  }

  xs.handledProps = ["as", "children", "className", "content", "control", "disabled", "error", "id", "inline", "label", "required", "type", "width"], xs.propTypes = {};
  var ws = xs;

  function ys(c) {
    var e = c.control,
        a = je(ys, c),
        n = zr(ys, c);
    return o.a.createElement(n, Object(p.a)({}, a, {
      control: e
    }));
  }

  ys.handledProps = ["as", "control"], ys.propTypes = {}, ys.defaultProps = {
    as: ws,
    control: Yi
  };
  var bs = ys;

  function Ss(c) {
    var e = c.control,
        a = je(Ss, c),
        n = zr(Ss, c);
    return o.a.createElement(n, Object(p.a)({}, a, {
      control: e
    }));
  }

  Ss.handledProps = ["as", "control"], Ss.propTypes = {}, Ss.defaultProps = {
    as: ws,
    control: Wl
  };
  var Ts = Ss;

  function Ds(c) {
    var e = c.control,
        a = je(Ds, c),
        n = zr(Ds, c);
    return o.a.createElement(n, Object(p.a)({}, a, {
      control: e
    }));
  }

  Ds.handledProps = ["as", "control"], Ds.propTypes = {}, Ds.defaultProps = {
    as: ws,
    control: Gf
  };
  var js = Ds;

  function Es(c) {
    var e = c.children,
        a = c.className,
        n = c.grouped,
        t = c.inline,
        r = c.unstackable,
        i = c.widths,
        l = Ie(ur(n, "grouped"), ur(t, "inline"), ur(r, "unstackable"), pr(i, null, !0), "fields", a),
        f = je(Es, c),
        s = zr(Es, c);
    return o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), e);
  }

  Es.handledProps = ["as", "children", "className", "grouped", "inline", "unstackable", "widths"], Es.propTypes = {};

  var ks = Es,
      Is = function (c) {
    function e() {
      for (var a, n = arguments.length, t = new Array(n), r = 0; r < n; r++) {
        t[r] = arguments[r];
      }

      return (a = c.call.apply(c, [this].concat(t)) || this).inputRef = Object(i.createRef)(), a.computeIcon = function () {
        var c = a.props,
            e = c.loading,
            n = c.icon;
        return Ee(n) ? e ? "spinner" : void 0 : n;
      }, a.computeTabIndex = function () {
        var c = a.props,
            e = c.disabled,
            n = c.tabIndex;
        return Ee(n) ? e ? -1 : void 0 : n;
      }, a.focus = function (c) {
        return a.inputRef.current.focus(c);
      }, a.select = function () {
        return a.inputRef.current.select();
      }, a.handleChange = function (c) {
        var e = An(c, "target.value");
        De(a.props, "onChange", c, Object(p.a)({}, a.props, {
          value: e
        }));
      }, a.handleChildOverrides = function (c, e) {
        return Object(p.a)({}, e, c.props, {
          ref: function ref(e) {
            u(c.ref, e), a.inputRef.current = e;
          }
        });
      }, a.partitionProps = function () {
        var c = a.props,
            n = c.disabled,
            t = c.type,
            r = a.computeTabIndex(),
            i = je(e, a.props),
            o = ci(i),
            l = o[0],
            f = o[1];
        return [Object(p.a)({}, l, {
          disabled: n,
          type: t,
          tabIndex: r,
          onChange: a.handleChange,
          ref: a.inputRef
        }), f];
      }, a;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this,
          a = this.props,
          t = a.action,
          r = a.actionPosition,
          l = a.children,
          f = a.className,
          s = a.disabled,
          u = a.error,
          h = a.fluid,
          m = a.focus,
          v = a.icon,
          d = a.iconPosition,
          M = a.input,
          z = a.inverted,
          C = a.label,
          L = a.labelPosition,
          A = a.loading,
          N = a.size,
          g = a.transparent,
          H = a.type,
          V = Ie("ui", N, ur(s, "disabled"), ur(u, "error"), ur(h, "fluid"), ur(m, "focus"), ur(z, "inverted"), ur(A, "loading"), ur(g, "transparent"), hr(r, "action") || ur(t, "action"), hr(d, "icon") || ur(v || A, "icon"), hr(L, "labeled") || ur(C, "labeled"), "input", f),
          x = zr(e, this.props),
          w = this.partitionProps(),
          y = w[0],
          b = w[1];

      if (!n.isNil(l)) {
        var S = Oi(i.Children.toArray(l), function (e) {
          return "input" !== e.type ? e : Object(i.cloneElement)(e, c.handleChildOverrides(e, y));
        });
        return o.a.createElement(x, Object(p.a)({}, b, {
          className: V
        }), S);
      }

      var T = Yi.create(t, {
        autoGenerateKey: !1
      }),
          D = ji.create(C, {
        defaultProps: {
          className: Ie("label", Gr(L, "corner") && L)
        },
        autoGenerateKey: !1
      });
      return o.a.createElement(x, Object(p.a)({}, b, {
        className: V
      }), "left" === r && T, "right" !== L && D, Qr(M || H, {
        defaultProps: y,
        autoGenerateKey: !1
      }), Pr.create(this.computeIcon(), {
        autoGenerateKey: !1
      }), "left" !== r && T, "right" === L && D);
    }, e;
  }(i.Component);

  Is.handledProps = ["action", "actionPosition", "as", "children", "className", "disabled", "error", "fluid", "focus", "icon", "iconPosition", "input", "inverted", "label", "labelPosition", "loading", "onChange", "size", "tabIndex", "transparent", "type"], Is.propTypes = {}, Is.defaultProps = {
    type: "text"
  }, Is.create = Er(Is, function (c) {
    return {
      type: c
    };
  });
  var Os = Is;

  function Qs(c) {
    var e = c.control,
        a = je(Qs, c),
        n = zr(Qs, c);
    return o.a.createElement(n, Object(p.a)({}, a, {
      control: e
    }));
  }

  Qs.handledProps = ["as", "control"], Qs.propTypes = {}, Qs.defaultProps = {
    as: ws,
    control: Os
  };
  var Zs = Qs;

  function Us(c) {
    var e = c.control,
        a = je(Us, c),
        n = zr(Us, c);
    return o.a.createElement(n, Object(p.a)({}, a, {
      control: e
    }));
  }

  Us.handledProps = ["as", "control"], Us.propTypes = {}, Us.defaultProps = {
    as: ws,
    control: ql
  };
  var Bs = Us;

  function Rs(c) {
    var e = c.control,
        a = c.options,
        n = je(Rs, c),
        t = zr(Rs, c);
    return o.a.createElement(t, Object(p.a)({}, n, {
      control: e,
      options: a
    }));
  }

  Rs.handledProps = ["as", "control", "options"], Rs.propTypes = {}, Rs.defaultProps = {
    as: ws,
    control: Jf
  };
  var Ys = Rs;

  function Ps(c) {
    var e = c.control,
        a = je(Ps, c),
        n = zr(Ps, c);
    return o.a.createElement(n, Object(p.a)({}, a, {
      control: e
    }));
  }

  Ps.handledProps = ["as", "control"], Ps.propTypes = {}, Ps.defaultProps = {
    as: ws,
    control: Xf
  };

  var Fs = Ps,
      Ws = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleSubmit = function (c) {
        "string" != typeof e.props.action && De(c, "preventDefault");

        for (var a = arguments.length, n = new Array(a > 1 ? a - 1 : 0), t = 1; t < a; t++) {
          n[t - 1] = arguments[t];
        }

        De.apply(void 0, [e.props, "onSubmit", c, e.props].concat(n));
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.action,
          n = c.children,
          t = c.className,
          r = c.error,
          i = c.inverted,
          l = c.loading,
          f = c.reply,
          s = c.size,
          u = c.success,
          h = c.unstackable,
          m = c.warning,
          v = c.widths,
          d = Ie("ui", s, ur(r, "error"), ur(i, "inverted"), ur(l, "loading"), ur(f, "reply"), ur(u, "success"), ur(h, "unstackable"), ur(m, "warning"), pr(v, null, !0), "form", t),
          M = je(e, this.props),
          z = zr(e, this.props);
      return o.a.createElement(z, Object(p.a)({}, M, {
        action: a,
        className: d,
        onSubmit: this.handleSubmit
      }), n);
    }, e;
  }(i.Component);

  Ws.handledProps = ["action", "as", "children", "className", "error", "inverted", "loading", "onSubmit", "reply", "size", "success", "unstackable", "warning", "widths"], Ws.propTypes = {}, Ws.defaultProps = {
    as: "form"
  }, Ws.Field = ws, Ws.Button = bs, Ws.Checkbox = Ts, Ws.Dropdown = js, Ws.Group = ks, Ws.Input = Zs, Ws.Radio = Bs, Ws.Select = Ys, Ws.TextArea = Fs;
  var Gs = Ws;

  function qs(c) {
    var e = c.children,
        a = c.className,
        n = c.computer,
        t = c.color,
        r = c.floated,
        i = c.largeScreen,
        l = c.mobile,
        f = c.only,
        s = c.stretched,
        u = c.tablet,
        h = c.textAlign,
        m = c.verticalAlign,
        v = c.widescreen,
        d = c.width,
        M = Ie(t, ur(s, "stretched"), vr(f, "only"), dr(h), hr(r, "floated"), Mr(m), pr(n, "wide computer"), pr(i, "wide large screen"), pr(l, "wide mobile"), pr(u, "wide tablet"), pr(v, "wide widescreen"), pr(d, "wide"), "column", a),
        z = je(qs, c),
        C = zr(qs, c);
    return o.a.createElement(C, Object(p.a)({}, z, {
      className: M
    }), e);
  }

  qs.handledProps = ["as", "children", "className", "color", "computer", "floated", "largeScreen", "mobile", "only", "stretched", "tablet", "textAlign", "verticalAlign", "widescreen", "width"], qs.propTypes = {}, qs.create = Er(qs, function (c) {
    return {
      children: c
    };
  });
  var Js = qs;

  function Ks(c) {
    var e = c.centered,
        a = c.children,
        n = c.className,
        t = c.color,
        r = c.columns,
        i = c.divided,
        l = c.only,
        f = c.reversed,
        s = c.stretched,
        u = c.textAlign,
        h = c.verticalAlign,
        m = Ie(t, ur(e, "centered"), ur(i, "divided"), ur(s, "stretched"), vr(l, "only"), vr(f, "reversed"), dr(u), Mr(h), pr(r, "column", !0), "row", n),
        v = je(Ks, c),
        d = zr(Ks, c);
    return o.a.createElement(d, Object(p.a)({}, v, {
      className: m
    }), a);
  }

  Ks.handledProps = ["as", "centered", "children", "className", "color", "columns", "divided", "only", "reversed", "stretched", "textAlign", "verticalAlign"], Ks.propTypes = {};
  var Xs = Ks;

  function _s(c) {
    var e = c.celled,
        a = c.centered,
        n = c.children,
        t = c.className,
        r = c.columns,
        i = c.container,
        l = c.divided,
        f = c.doubling,
        s = c.inverted,
        u = c.padded,
        h = c.relaxed,
        m = c.reversed,
        v = c.stackable,
        d = c.stretched,
        M = c.textAlign,
        z = c.verticalAlign,
        C = Ie("ui", ur(a, "centered"), ur(i, "container"), ur(f, "doubling"), ur(s, "inverted"), ur(v, "stackable"), ur(d, "stretched"), mr(e, "celled"), mr(l, "divided"), mr(u, "padded"), mr(h, "relaxed"), vr(m, "reversed"), dr(M), Mr(z), pr(r, "column", !0), "grid", t),
        L = je(_s, c),
        A = zr(_s, c);
    return o.a.createElement(A, Object(p.a)({}, L, {
      className: C
    }), n);
  }

  _s.handledProps = ["as", "celled", "centered", "children", "className", "columns", "container", "divided", "doubling", "inverted", "padded", "relaxed", "reversed", "stackable", "stretched", "textAlign", "verticalAlign"], _s.Column = Js, _s.Row = Xs, _s.propTypes = {};
  var $s = _s;

  function cu(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("content", a),
        i = je(cu, c),
        l = zr(cu, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  cu.handledProps = ["as", "children", "className", "content"], cu.propTypes = {};
  var eu = cu;

  function au(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("header", a),
        i = je(au, c),
        l = zr(au, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  au.handledProps = ["as", "children", "className", "content"], au.propTypes = {}, au.create = Er(au, function (c) {
    return {
      content: c
    };
  });
  var nu = au;

  function tu(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("content", a),
        i = je(tu, c),
        l = zr(tu, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  tu.handledProps = ["as", "children", "className", "content"], tu.propTypes = {}, tu.defaultProps = {
    as: "li"
  }, tu.create = Er(tu, function (c) {
    return {
      content: c
    };
  });
  var ru = tu;

  function iu(c) {
    var e = c.children,
        a = c.className,
        t = c.items,
        r = Ie("list", a),
        i = je(iu, c),
        l = zr(iu, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? Oi(t, ru.create) : e);
  }

  iu.handledProps = ["as", "children", "className", "items"], iu.propTypes = {}, iu.defaultProps = {
    as: "ul"
  }, iu.create = Er(iu, function (c) {
    return {
      items: c
    };
  });

  var ou = iu,
      lu = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleDismiss = function (c) {
        var a = e.props.onDismiss;
        a && a(c, e.props);
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.attached,
          t = c.children,
          r = c.className,
          i = c.color,
          l = c.compact,
          f = c.content,
          s = c.error,
          u = c.floating,
          h = c.header,
          m = c.hidden,
          v = c.icon,
          d = c.info,
          M = c.list,
          z = c.negative,
          C = c.onDismiss,
          L = c.positive,
          A = c.size,
          N = c.success,
          g = c.visible,
          H = c.warning,
          V = Ie("ui", i, A, ur(l, "compact"), ur(s, "error"), ur(u, "floating"), ur(m, "hidden"), ur(v, "icon"), ur(d, "info"), ur(z, "negative"), ur(L, "positive"), ur(N, "success"), ur(g, "visible"), ur(H, "warning"), mr(a, "attached"), "message", r),
          x = C && o.a.createElement(Pr, {
        name: "close",
        onClick: this.handleDismiss
      }),
          w = je(e, this.props),
          y = zr(e, this.props);
      return n.isNil(t) ? o.a.createElement(y, Object(p.a)({}, w, {
        className: V
      }), x, Pr.create(v, {
        autoGenerateKey: !1
      }), (!Ee(h) || !Ee(f) || !Ee(M)) && o.a.createElement(eu, null, nu.create(h, {
        autoGenerateKey: !1
      }), ou.create(M, {
        autoGenerateKey: !1
      }), Ur(f, {
        autoGenerateKey: !1
      }))) : o.a.createElement(y, Object(p.a)({}, w, {
        className: V
      }), x, t);
    }, e;
  }(i.Component);

  function fu(c) {
    var e = c.children,
        a = c.className,
        n = Ie(a),
        t = je(fu, c),
        r = zr(fu, c);
    return o.a.createElement(r, Object(p.a)({}, t, {
      className: n
    }), e);
  }

  lu.handledProps = ["as", "attached", "children", "className", "color", "compact", "content", "error", "floating", "header", "hidden", "icon", "info", "list", "negative", "onDismiss", "positive", "size", "success", "visible", "warning"], lu.propTypes = {}, lu.Content = eu, lu.Header = nu, lu.List = ou, lu.Item = ru, fu.handledProps = ["as", "children", "className"], fu.defaultProps = {
    as: "tbody"
  }, fu.propTypes = {};
  var su = fu;

  function uu(c) {
    var e = c.active,
        a = c.children,
        t = c.className,
        r = c.collapsing,
        i = c.content,
        l = c.disabled,
        f = c.error,
        s = c.icon,
        u = c.negative,
        h = c.positive,
        m = c.selectable,
        v = c.singleLine,
        d = c.textAlign,
        M = c.verticalAlign,
        z = c.warning,
        C = c.width,
        L = Ie(ur(e, "active"), ur(r, "collapsing"), ur(l, "disabled"), ur(f, "error"), ur(u, "negative"), ur(h, "positive"), ur(m, "selectable"), ur(v, "single line"), ur(z, "warning"), dr(d), Mr(M), pr(C, "wide"), t),
        A = je(uu, c),
        N = zr(uu, c);
    return n.isNil(a) ? o.a.createElement(N, Object(p.a)({}, A, {
      className: L
    }), Pr.create(s), i) : o.a.createElement(N, Object(p.a)({}, A, {
      className: L
    }), a);
  }

  uu.handledProps = ["active", "as", "children", "className", "collapsing", "content", "disabled", "error", "icon", "negative", "positive", "selectable", "singleLine", "textAlign", "verticalAlign", "warning", "width"], uu.defaultProps = {
    as: "td"
  }, uu.propTypes = {}, uu.create = Er(uu, function (c) {
    return {
      content: c
    };
  });
  var hu = uu;

  function mu(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.fullWidth,
        i = Ie(ur(r, "full-width"), a),
        l = je(mu, c),
        f = zr(mu, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(e) ? t : e);
  }

  mu.handledProps = ["as", "children", "className", "content", "fullWidth"], mu.defaultProps = {
    as: "thead"
  }, mu.propTypes = {};
  var vu = mu;

  function du(c) {
    var e = c.as,
        a = je(du, c);
    return o.a.createElement(vu, Object(p.a)({}, a, {
      as: e
    }));
  }

  du.handledProps = ["as"], du.propTypes = {}, du.defaultProps = {
    as: "tfoot"
  };
  var Mu = du;

  function pu(c) {
    var e = c.as,
        a = c.className,
        n = c.sorted,
        t = Ie(hr(n, "sorted"), a),
        r = je(pu, c);
    return o.a.createElement(hu, Object(p.a)({}, r, {
      as: e,
      className: t
    }));
  }

  pu.handledProps = ["as", "className", "sorted"], pu.propTypes = {}, pu.defaultProps = {
    as: "th"
  };
  var zu = pu;

  function Cu(c) {
    var e = c.active,
        a = c.cellAs,
        t = c.cells,
        r = c.children,
        i = c.className,
        l = c.disabled,
        f = c.error,
        s = c.negative,
        u = c.positive,
        h = c.textAlign,
        m = c.verticalAlign,
        v = c.warning,
        d = Ie(ur(e, "active"), ur(l, "disabled"), ur(f, "error"), ur(s, "negative"), ur(u, "positive"), ur(v, "warning"), dr(h), Mr(m), i),
        M = je(Cu, c),
        z = zr(Cu, c);
    return n.isNil(r) ? o.a.createElement(z, Object(p.a)({}, M, {
      className: d
    }), Oi(t, function (c) {
      return hu.create(c, {
        defaultProps: {
          as: a
        }
      });
    })) : o.a.createElement(z, Object(p.a)({}, M, {
      className: d
    }), r);
  }

  Cu.handledProps = ["active", "as", "cellAs", "cells", "children", "className", "disabled", "error", "negative", "positive", "textAlign", "verticalAlign", "warning"], Cu.defaultProps = {
    as: "tr",
    cellAs: "td"
  }, Cu.propTypes = {}, Cu.create = Er(Cu, function (c) {
    return {
      cells: c
    };
  });
  var Lu = Cu;

  function Au(c) {
    var e = c.attached,
        a = c.basic,
        t = c.celled,
        r = c.children,
        i = c.className,
        l = c.collapsing,
        f = c.color,
        s = c.columns,
        u = c.compact,
        h = c.definition,
        m = c.fixed,
        v = c.footerRow,
        d = c.headerRow,
        M = c.headerRows,
        z = c.inverted,
        C = c.padded,
        L = c.renderBodyRow,
        A = c.selectable,
        N = c.singleLine,
        g = c.size,
        H = c.sortable,
        V = c.stackable,
        x = c.striped,
        w = c.structured,
        y = c.tableData,
        b = c.textAlign,
        S = c.unstackable,
        T = c.verticalAlign,
        D = Ie("ui", f, g, ur(t, "celled"), ur(l, "collapsing"), ur(h, "definition"), ur(m, "fixed"), ur(z, "inverted"), ur(A, "selectable"), ur(N, "single line"), ur(H, "sortable"), ur(V, "stackable"), ur(x, "striped"), ur(w, "structured"), ur(S, "unstackable"), mr(e, "attached"), mr(a, "basic"), mr(u, "compact"), mr(C, "padded"), dr(b), Mr(T), pr(s, "column"), "table", i),
        j = je(Au, c),
        E = zr(Au, c);
    if (!n.isNil(r)) return o.a.createElement(E, Object(p.a)({}, j, {
      className: D
    }), r);
    var k = {
      defaultProps: {
        cellAs: "th"
      }
    },
        I = (d || M) && o.a.createElement(vu, null, Lu.create(d, k), Oi(M, function (c) {
      return Lu.create(c, k);
    }));
    return o.a.createElement(E, Object(p.a)({}, j, {
      className: D
    }), I, o.a.createElement(su, null, L && Oi(y, function (c, e) {
      return Lu.create(L(c, e));
    })), v && o.a.createElement(Mu, null, Lu.create(v)));
  }

  Au.handledProps = ["as", "attached", "basic", "celled", "children", "className", "collapsing", "color", "columns", "compact", "definition", "fixed", "footerRow", "headerRow", "headerRows", "inverted", "padded", "renderBodyRow", "selectable", "singleLine", "size", "sortable", "stackable", "striped", "structured", "tableData", "textAlign", "unstackable", "verticalAlign"], Au.defaultProps = {
    as: "table"
  }, Au.propTypes = {}, Au.Body = su, Au.Cell = hu, Au.Footer = Mu, Au.Header = vu, Au.HeaderCell = zu, Au.Row = Lu;
  var Nu = Au;

  function gu(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.fluid,
        i = c.text,
        l = c.textAlign,
        f = Ie("ui", ur(i, "text"), ur(r, "fluid"), dr(l), "container", a),
        s = je(gu, c),
        u = zr(gu, c);
    return o.a.createElement(u, Object(p.a)({}, s, {
      className: f
    }), n.isNil(e) ? t : e);
  }

  gu.handledProps = ["as", "children", "className", "content", "fluid", "text", "textAlign"], gu.propTypes = {};
  var Hu = gu;

  function Vu(c) {
    var e = c.children,
        a = c.className,
        t = c.clearing,
        r = c.content,
        i = c.fitted,
        l = c.hidden,
        f = c.horizontal,
        s = c.inverted,
        u = c.section,
        h = c.vertical,
        m = Ie("ui", ur(t, "clearing"), ur(i, "fitted"), ur(l, "hidden"), ur(f, "horizontal"), ur(s, "inverted"), ur(u, "section"), ur(h, "vertical"), "divider", a),
        v = je(Vu, c),
        d = zr(Vu, c);
    return o.a.createElement(d, Object(p.a)({}, v, {
      className: m
    }), n.isNil(e) ? r : e);
  }

  Vu.handledProps = ["as", "children", "className", "clearing", "content", "fitted", "hidden", "horizontal", "inverted", "section", "vertical"], Vu.propTypes = {};
  var xu = Vu;

  function wu(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("sub header", a),
        i = je(wu, c),
        l = zr(wu, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  wu.handledProps = ["as", "children", "className", "content"], wu.propTypes = {}, wu.create = Er(wu, function (c) {
    return {
      content: c
    };
  });
  var yu = wu;

  function bu(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("content", a),
        i = je(bu, c),
        l = zr(bu, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  bu.handledProps = ["as", "children", "className", "content"], bu.propTypes = {};
  var Su = bu;

  function Tu(c) {
    var e = c.attached,
        a = c.block,
        t = c.children,
        r = c.className,
        i = c.color,
        l = c.content,
        f = c.disabled,
        s = c.dividing,
        u = c.floated,
        h = c.icon,
        m = c.image,
        v = c.inverted,
        d = c.size,
        M = c.sub,
        z = c.subheader,
        C = c.textAlign,
        L = Ie("ui", i, d, ur(a, "block"), ur(f, "disabled"), ur(s, "dividing"), hr(u, "floated"), ur(!0 === h, "icon"), ur(!0 === m, "image"), ur(v, "inverted"), ur(M, "sub"), mr(e, "attached"), dr(C), "header", r),
        A = je(Tu, c),
        N = zr(Tu, c);
    if (!n.isNil(t)) return o.a.createElement(N, Object(p.a)({}, A, {
      className: L
    }), t);
    var g = Pr.create(h, {
      autoGenerateKey: !1
    }),
        H = yi.create(m, {
      autoGenerateKey: !1
    }),
        V = yu.create(z, {
      autoGenerateKey: !1
    });
    return g || H ? o.a.createElement(N, Object(p.a)({}, A, {
      className: L
    }), g || H, (l || V) && o.a.createElement(Su, null, l, V)) : o.a.createElement(N, Object(p.a)({}, A, {
      className: L
    }), l, V);
  }

  Tu.handledProps = ["as", "attached", "block", "children", "className", "color", "content", "disabled", "dividing", "floated", "icon", "image", "inverted", "size", "sub", "subheader", "textAlign"], Tu.propTypes = {}, Tu.Content = Su, Tu.Subheader = yu;
  var Du = Tu;

  function ju(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie(a, "description"),
        i = je(ju, c),
        l = zr(ju, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  ju.handledProps = ["as", "children", "className", "content"], ju.propTypes = {}, ju.create = Er(ju, function (c) {
    return {
      content: c
    };
  });
  var Eu = ju;

  function ku(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("header", a),
        i = je(ku, c),
        l = zr(ku, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  ku.handledProps = ["as", "children", "className", "content"], ku.propTypes = {}, ku.create = Er(ku, function (c) {
    return {
      content: c
    };
  });
  var Iu = ku;

  function Ou(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.description,
        i = c.floated,
        l = c.header,
        f = c.verticalAlign,
        s = Ie(hr(i, "floated"), Mr(f), "content", a),
        u = je(Ou, c),
        h = zr(Ou, c);
    return n.isNil(e) ? o.a.createElement(h, Object(p.a)({}, u, {
      className: s
    }), Iu.create(l), Eu.create(r), t) : o.a.createElement(h, Object(p.a)({}, u, {
      className: s
    }), e);
  }

  Ou.handledProps = ["as", "children", "className", "content", "description", "floated", "header", "verticalAlign"], Ou.propTypes = {}, Ou.create = Er(Ou, function (c) {
    return {
      content: c
    };
  });
  var Qu = Ou;

  function Zu(c) {
    var e = c.className,
        a = c.verticalAlign,
        n = Ie(Mr(a), e),
        t = je(Zu, c);
    return o.a.createElement(Pr, Object(p.a)({}, t, {
      className: n
    }));
  }

  Zu.handledProps = ["className", "verticalAlign"], Zu.propTypes = {}, Zu.create = Er(Zu, function (c) {
    return {
      name: c
    };
  });

  var Uu = Zu,
      Bu = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleClick = function (c) {
        e.props.disabled || De(e.props, "onClick", c, e.props);
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.active,
          t = c.children,
          r = c.className,
          l = c.content,
          f = c.description,
          s = c.disabled,
          u = c.header,
          h = c.icon,
          m = c.image,
          v = c.value,
          d = zr(e, this.props),
          M = Ie(ur(a, "active"), ur(s, "disabled"), ur("li" !== d, "item"), r),
          z = je(e, this.props),
          C = "li" === d ? {
        value: v
      } : {
        "data-value": v
      };
      if (!n.isNil(t)) return o.a.createElement(d, Object(p.a)({}, C, {
        role: "listitem",
        className: M,
        onClick: this.handleClick
      }, z), t);
      var L = Uu.create(h, {
        autoGenerateKey: !1
      }),
          A = yi.create(m, {
        autoGenerateKey: !1
      });
      if (!Object(i.isValidElement)(l) && xr(l)) return o.a.createElement(d, Object(p.a)({}, C, {
        role: "listitem",
        className: M,
        onClick: this.handleClick
      }, z), L || A, Qu.create(l, {
        autoGenerateKey: !1,
        defaultProps: {
          header: u,
          description: f
        }
      }));
      var N = Iu.create(u, {
        autoGenerateKey: !1
      }),
          g = Eu.create(f, {
        autoGenerateKey: !1
      });
      return L || A ? o.a.createElement(d, Object(p.a)({}, C, {
        role: "listitem",
        className: M,
        onClick: this.handleClick
      }, z), L || A, (l || N || g) && o.a.createElement(Qu, null, N, g, l)) : o.a.createElement(d, Object(p.a)({}, C, {
        role: "listitem",
        className: M,
        onClick: this.handleClick
      }, z), N, g, l);
    }, e;
  }(i.Component);

  Bu.handledProps = ["active", "as", "children", "className", "content", "description", "disabled", "header", "icon", "image", "onClick", "value"], Bu.propTypes = {}, Bu.create = Er(Bu, function (c) {
    return {
      content: c
    };
  });
  var Ru = Bu;

  function Yu(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = je(Yu, c),
        i = zr(Yu, c),
        l = Ie(ur("ul" !== i && "ol" !== i, "list"), a);
    return o.a.createElement(i, Object(p.a)({}, r, {
      className: l
    }), n.isNil(e) ? t : e);
  }

  Yu.handledProps = ["as", "children", "className", "content"], Yu.propTypes = {};

  var Pu = Yu,
      Fu = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleItemOverrides = function (c) {
        return {
          onClick: function onClick(a, n) {
            De(c, "onClick", a, n), De(e.props, "onItemClick", a, n);
          }
        };
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this,
          a = this.props,
          t = a.animated,
          r = a.bulleted,
          i = a.celled,
          l = a.children,
          f = a.className,
          s = a.content,
          u = a.divided,
          h = a.floated,
          m = a.horizontal,
          v = a.inverted,
          d = a.items,
          M = a.link,
          z = a.ordered,
          C = a.relaxed,
          L = a.selection,
          A = a.size,
          N = a.verticalAlign,
          g = Ie("ui", A, ur(t, "animated"), ur(r, "bulleted"), ur(i, "celled"), ur(u, "divided"), ur(m, "horizontal"), ur(v, "inverted"), ur(M, "link"), ur(z, "ordered"), ur(L, "selection"), mr(C, "relaxed"), hr(h, "floated"), Mr(N), "list", f),
          H = je(e, this.props),
          V = zr(e, this.props);
      return n.isNil(l) ? n.isNil(s) ? o.a.createElement(V, Object(p.a)({
        role: "list",
        className: g
      }, H), Oi(d, function (e) {
        return Ru.create(e, {
          overrideProps: c.handleItemOverrides
        });
      })) : o.a.createElement(V, Object(p.a)({
        role: "list",
        className: g
      }, H), s) : o.a.createElement(V, Object(p.a)({
        role: "list",
        className: g
      }, H), l);
    }, e;
  }(i.Component);

  Fu.handledProps = ["animated", "as", "bulleted", "celled", "children", "className", "content", "divided", "floated", "horizontal", "inverted", "items", "link", "onItemClick", "ordered", "relaxed", "selection", "size", "verticalAlign"], Fu.propTypes = {}, Fu.Content = Qu, Fu.Description = Eu, Fu.Header = Iu, Fu.Icon = Uu, Fu.Item = Ru, Fu.List = Pu;
  var Wu = Fu;

  function Gu(c) {
    var e = c.active,
        a = c.children,
        t = c.className,
        r = c.content,
        i = c.disabled,
        l = c.indeterminate,
        f = c.inline,
        s = c.inverted,
        u = c.size,
        h = Ie("ui", u, ur(e, "active"), ur(i, "disabled"), ur(l, "indeterminate"), ur(s, "inverted"), ur(a || r, "text"), mr(f, "inline"), "loader", t),
        m = je(Gu, c),
        v = zr(Gu, c);
    return o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), n.isNil(a) ? r : a);
  }

  Gu.handledProps = ["active", "as", "children", "className", "content", "disabled", "indeterminate", "inline", "inverted", "size"], Gu.propTypes = {};
  var qu = Gu;

  function Ju(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.image,
        i = Ie(ur(r, "image"), "header", a),
        l = je(Ju, c),
        f = zr(Ju, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(e) ? t : e);
  }

  Ju.handledProps = ["as", "children", "className", "content", "image"], Ju.propTypes = {};
  var Ku = Ju;

  function Xu(c) {
    var e = c.className,
        a = c.square,
        n = c.rectangular,
        t = Ie(ur(a, "square"), ur(n, "rectangular"), "image", e),
        r = je(Xu, c),
        i = zr(Xu, c);
    return o.a.createElement(i, Object(p.a)({}, r, {
      className: t
    }));
  }

  Xu.handledProps = ["as", "className", "rectangular", "square"], Xu.propTypes = {};
  var _u = Xu;

  function $u(c) {
    var e = c.className,
        a = c.length,
        n = Ie("line", a, e),
        t = je($u, c),
        r = zr($u, c);
    return o.a.createElement(r, Object(p.a)({}, t, {
      className: n
    }));
  }

  $u.handledProps = ["as", "className", "length"], $u.propTypes = {};
  var ch = $u;

  function eh(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("paragraph", a),
        i = je(eh, c),
        l = zr(eh, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  eh.handledProps = ["as", "children", "className", "content"], eh.propTypes = {};
  var ah = eh;

  function nh(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.fluid,
        i = c.inverted,
        l = Ie("ui", ur(r, "fluid"), ur(i, "inverted"), "placeholder", a),
        f = je(nh, c),
        s = zr(nh, c);
    return o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), n.isNil(e) ? t : e);
  }

  nh.handledProps = ["as", "children", "className", "content", "fluid", "inverted"], nh.propTypes = {}, nh.Header = Ku, nh.Image = _u, nh.Line = ch, nh.Paragraph = ah;
  var th = nh;

  function rh(c) {
    var e = c.attached,
        a = c.children,
        t = c.className,
        r = c.close,
        i = c.content,
        l = c.dividing,
        f = c.internal,
        s = c.position,
        u = c.size,
        h = Ie("ui", s, u, ur(e, "attached"), ur(l, "dividing"), ur(f, "internal"), mr(r, "close"), "rail", t),
        m = je(rh, c),
        v = zr(rh, c);
    return o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), n.isNil(a) ? i : a);
  }

  rh.handledProps = ["as", "attached", "children", "className", "close", "content", "dividing", "internal", "position", "size"], rh.propTypes = {};
  var ih = rh;

  function oh(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.hidden,
        i = c.visible,
        l = Ie("ui", ur(r, "hidden"), ur(i, "visible"), "content", a),
        f = je(oh, c),
        s = zr(oh, c);
    return o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), n.isNil(e) ? t : e);
  }

  oh.handledProps = ["as", "children", "className", "content", "hidden", "visible"], oh.propTypes = {};
  var lh = oh;

  function fh(c) {
    var e = c.active,
        a = c.animated,
        t = c.children,
        r = c.className,
        i = c.content,
        l = c.disabled,
        f = c.instant,
        s = Ie("ui", a, ur(e, "active"), ur(l, "disabled"), ur(f, "instant"), "reveal", r),
        u = je(fh, c),
        h = zr(fh, c);
    return o.a.createElement(h, Object(p.a)({}, u, {
      className: s
    }), n.isNil(t) ? i : t);
  }

  fh.handledProps = ["active", "animated", "as", "children", "className", "content", "disabled", "instant"], fh.propTypes = {}, fh.Content = lh;
  var sh = fh;

  function uh(c) {
    var e = c.children,
        a = c.className,
        t = c.compact,
        r = c.content,
        i = c.horizontal,
        l = c.piled,
        f = c.raised,
        s = c.size,
        u = c.stacked,
        h = Ie("ui", s, ur(t, "compact"), ur(i, "horizontal"), ur(l, "piled"), ur(f, "raised"), ur(u, "stacked"), "segments", a),
        m = je(uh, c),
        v = zr(uh, c);
    return o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), n.isNil(e) ? r : e);
  }

  uh.handledProps = ["as", "children", "className", "compact", "content", "horizontal", "piled", "raised", "size", "stacked"], uh.propTypes = {};
  var hh = uh;

  function mh(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("inline", a),
        i = je(mh, c),
        l = zr(mh, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  mh.handledProps = ["as", "children", "className", "content"], mh.propTypes = {};
  var vh = mh;

  function dh(c) {
    var e = c.attached,
        a = c.basic,
        t = c.children,
        r = c.circular,
        i = c.className,
        l = c.clearing,
        f = c.color,
        s = c.compact,
        u = c.content,
        h = c.disabled,
        m = c.floated,
        v = c.inverted,
        d = c.loading,
        M = c.placeholder,
        z = c.padded,
        C = c.piled,
        L = c.raised,
        A = c.secondary,
        N = c.size,
        g = c.stacked,
        H = c.tertiary,
        V = c.textAlign,
        x = c.vertical,
        w = Ie("ui", f, N, ur(a, "basic"), ur(r, "circular"), ur(l, "clearing"), ur(s, "compact"), ur(h, "disabled"), ur(v, "inverted"), ur(d, "loading"), ur(M, "placeholder"), ur(C, "piled"), ur(L, "raised"), ur(A, "secondary"), ur(g, "stacked"), ur(H, "tertiary"), ur(x, "vertical"), mr(e, "attached"), mr(z, "padded"), dr(V), hr(m, "floated"), "segment", i),
        y = je(dh, c),
        b = zr(dh, c);
    return o.a.createElement(b, Object(p.a)({}, y, {
      className: w
    }), n.isNil(t) ? u : t);
  }

  dh.handledProps = ["as", "attached", "basic", "children", "circular", "className", "clearing", "color", "compact", "content", "disabled", "floated", "inverted", "loading", "padded", "piled", "placeholder", "raised", "secondary", "size", "stacked", "tertiary", "textAlign", "vertical"], dh.Group = hh, dh.Inline = vh, dh.propTypes = {};
  var Mh = dh;

  function ph(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("description", a),
        i = je(ph, c),
        l = zr(ph, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  ph.handledProps = ["as", "children", "className", "content"], ph.propTypes = {}, ph.create = Er(ph, function (c) {
    return {
      content: c
    };
  });
  var zh = ph;

  function Ch(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("title", a),
        i = je(Ch, c),
        l = zr(Ch, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  Ch.handledProps = ["as", "children", "className", "content"], Ch.propTypes = {}, Ch.create = Er(Ch, function (c) {
    return {
      content: c
    };
  });
  var Lh = Ch;

  function Ah(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.description,
        i = c.title,
        l = Ie("content", a),
        f = je(Ah, c),
        s = zr(Ah, c);
    return n.isNil(e) ? n.isNil(t) ? o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), Lh.create(i, {
      autoGenerateKey: !1
    }), zh.create(r, {
      autoGenerateKey: !1
    })) : o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), t) : o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), e);
  }

  Ah.handledProps = ["as", "children", "className", "content", "description", "title"], Ah.propTypes = {}, Ah.create = Er(Ah, function (c) {
    return {
      content: c
    };
  });
  var Nh = Ah;

  function gh(c) {
    var e = c.attached,
        a = c.children,
        t = c.className,
        r = c.content,
        i = c.fluid,
        l = c.items,
        f = c.ordered,
        s = c.size,
        u = c.stackable,
        h = c.unstackable,
        m = c.vertical,
        v = c.widths,
        d = Ie("ui", s, ur(i, "fluid"), ur(f, "ordered"), ur(h, "unstackable"), ur(m, "vertical"), mr(e, "attached"), hr(u, "stackable"), pr(v), "steps", t),
        M = je(gh, c),
        z = zr(gh, c);
    return n.isNil(a) ? n.isNil(r) ? o.a.createElement(z, Object(p.a)({}, M, {
      className: d
    }), Oi(l, function (c) {
      return xh.create(c);
    })) : o.a.createElement(z, Object(p.a)({}, M, {
      className: d
    }), r) : o.a.createElement(z, Object(p.a)({}, M, {
      className: d
    }), a);
  }

  gh.handledProps = ["as", "attached", "children", "className", "content", "fluid", "items", "ordered", "size", "stackable", "unstackable", "vertical", "widths"], gh.propTypes = {};

  var Hh = gh,
      Vh = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).computeElementType = function () {
        if (e.props.onClick) return "a";
      }, e.handleClick = function (c) {
        e.props.disabled || De(e.props, "onClick", c, e.props);
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.active,
          t = c.children,
          r = c.className,
          i = c.completed,
          l = c.content,
          f = c.description,
          s = c.disabled,
          u = c.href,
          h = c.icon,
          m = c.link,
          v = c.title,
          d = Ie(ur(a, "active"), ur(i, "completed"), ur(s, "disabled"), ur(m, "link"), "step", r),
          M = je(e, this.props),
          z = zr(e, this.props, this.computeElementType);
      return n.isNil(t) ? n.isNil(l) ? o.a.createElement(z, Object(p.a)({}, M, {
        className: d,
        href: u,
        onClick: this.handleClick
      }), Pr.create(h, {
        autoGenerateKey: !1
      }), Nh.create({
        description: f,
        title: v
      }, {
        autoGenerateKey: !1
      })) : o.a.createElement(z, Object(p.a)({}, M, {
        className: d,
        href: u,
        onClick: this.handleClick
      }), l) : o.a.createElement(z, Object(p.a)({}, M, {
        className: d,
        href: u,
        onClick: this.handleClick
      }), t);
    }, e;
  }(i.Component);

  Vh.handledProps = ["active", "as", "children", "className", "completed", "content", "description", "disabled", "href", "icon", "link", "onClick", "ordered", "title"], Vh.propTypes = {}, Vh.Content = Nh, Vh.Description = zh, Vh.Group = Hh, Vh.Title = Lh, Vh.create = Er(Vh, function (c) {
    return {
      content: c
    };
  });

  var xh = Vh,
      wh = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleClick = function (c) {
        return De(e.props, "onClick", c, e.props);
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.active,
          t = c.children,
          r = c.className,
          i = c.content,
          l = c.icon,
          f = Ie(ur(a, "active"), "title", r),
          s = je(e, this.props),
          u = zr(e, this.props),
          h = Ee(l) ? "dropdown" : l;
      return n.isNil(t) ? o.a.createElement(u, Object(p.a)({}, s, {
        className: f,
        onClick: this.handleClick
      }), Pr.create(h, {
        autoGenerateKey: !1
      }), i) : o.a.createElement(u, Object(p.a)({}, s, {
        className: f,
        onClick: this.handleClick
      }), t);
    }, e;
  }(i.Component);

  function yh(c) {
    var e = c.active,
        a = c.children,
        t = c.className,
        r = c.content,
        i = Ie("content", ur(e, "active"), t),
        l = je(yh, c),
        f = zr(yh, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(a) ? r : a);
  }

  wh.handledProps = ["active", "as", "children", "className", "content", "icon", "index", "onClick"], wh.propTypes = {}, wh.create = Er(wh, function (c) {
    return {
      content: c
    };
  }), yh.handledProps = ["active", "as", "children", "className", "content"], yh.propTypes = {}, yh.create = Er(yh, function (c) {
    return {
      content: c
    };
  });

  var bh = yh,
      Sh = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleTitleOverrides = function (c) {
        return {
          onClick: function onClick(a, n) {
            De(c, "onClick", a, n), De(e.props, "onTitleClick", a, n);
          }
        };
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          e = c.active,
          a = c.content,
          n = c.index,
          t = c.title;
      return o.a.createElement(o.a.Fragment, null, wh.create(t, {
        autoGenerateKey: !1,
        defaultProps: {
          active: e,
          index: n
        },
        overrideProps: this.handleTitleOverrides
      }), bh.create(a, {
        autoGenerateKey: !1,
        defaultProps: {
          active: e
        }
      }));
    }, e;
  }(i.Component);

  Sh.handledProps = ["active", "content", "index", "onTitleClick", "title"], Sh.propTypes = {}, Sh.create = Er(Sh, null);

  var Th = Sh,
      Dh = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).computeNewIndex = function (c) {
        var a = e.props.exclusive,
            n = e.state.activeIndex;
        return a ? c === n ? -1 : c : Gr(n, c) ? af(n, c) : [].concat(n, [c]);
      }, e.handleTitleClick = function (c, a) {
        var n = a.index;
        e.setState({
          activeIndex: e.computeNewIndex(n)
        }), De(e.props, "onTitleClick", c, a);
      }, e.isIndexActive = function (c) {
        var a = e.props.exclusive,
            n = e.state.activeIndex;
        return a ? n === c : Gr(n, c);
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.getInitialAutoControlledState = function (c) {
      return {
        activeIndex: c.exclusive ? -1 : []
      };
    }, a.componentDidMount = function () {
      0;
    }, a.componentDidUpdate = function () {
      0;
    }, a.render = function () {
      var c = this,
          a = this.props,
          t = a.className,
          r = a.children,
          i = a.panels,
          l = Ie("accordion", t),
          f = je(e, this.props),
          s = zr(e, this.props);
      return o.a.createElement(s, Object(p.a)({}, f, {
        className: l
      }), n.isNil(r) ? Oi(i, function (e, a) {
        return Th.create(e, {
          defaultProps: {
            active: c.isIndexActive(a),
            index: a,
            onTitleClick: c.handleTitleClick
          }
        });
      }) : r);
    }, e;
  }(Mi);

  function jh(c) {
    var e = c.className,
        a = c.fluid,
        n = c.inverted,
        t = c.styled,
        r = Ie("ui", ur(a, "fluid"), ur(n, "inverted"), ur(t, "styled"), e),
        i = je(jh, c);
    return o.a.createElement(Dh, Object(p.a)({}, i, {
      className: r
    }));
  }

  Dh.handledProps = ["activeIndex", "as", "children", "className", "defaultActiveIndex", "exclusive", "onTitleClick", "panels"], Dh.propTypes = {}, Dh.defaultProps = {
    exclusive: !0
  }, Dh.autoControlledProps = ["activeIndex"], Dh.create = Er(Dh, function (c) {
    return {
      content: c
    };
  }), jh.handledProps = ["className", "fluid", "inverted", "styled"], jh.propTypes = {}, jh.Accordion = Dh, jh.Content = bh, jh.Panel = Th, jh.Title = wh;

  var Eh = jh,
      kh = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleClick = function (c) {
        var a = e.props.onClick,
            n = e.state.active;
        a && a(c, Object(p.a)({}, e.props, {
          active: !0
        })), n || e.setState({
          active: !0
        });
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.getSrc = function () {
      var c = this.props,
          e = c.autoplay,
          a = void 0 === e || e,
          n = c.brandedUI,
          t = void 0 !== n && n,
          r = c.color,
          i = void 0 === r ? "#444444" : r,
          o = c.hd,
          l = void 0 === o || o,
          f = c.id,
          s = c.source,
          u = c.url;
      return "youtube" === s ? ["//www.youtube.com/embed/" + f, "?autohide=true", "&amp;autoplay=" + a, "&amp;color=" + encodeURIComponent(i), "&amp;hq=" + l, "&amp;jsapi=false", "&amp;modestbranding=" + t, "&amp;rel=" + (t ? 0 : 1)].join("") : "vimeo" === s ? ["//player.vimeo.com/video/" + f, "?api=false", "&amp;autoplay=" + a, "&amp;byline=false", "&amp;color=" + encodeURIComponent(i), "&amp;portrait=false", "&amp;title=false"].join("") : u;
    }, a.render = function () {
      var c = this.props,
          a = c.aspectRatio,
          n = c.className,
          t = c.icon,
          r = c.placeholder,
          i = this.state.active,
          l = Ie("ui", a, ur(i, "active"), "embed", n),
          f = je(e, this.props),
          s = zr(e, this.props),
          u = void 0 !== t ? t : "video play";
      return o.a.createElement(s, Object(p.a)({}, f, {
        className: l,
        onClick: this.handleClick
      }), Pr.create(u, {
        autoGenerateKey: !1
      }), r && o.a.createElement("img", {
        className: "placeholder",
        src: r
      }), this.renderEmbed());
    }, a.renderEmbed = function () {
      var c = this.props,
          e = c.children,
          a = c.content,
          t = c.iframe,
          r = c.source;
      return this.state.active ? n.isNil(e) ? n.isNil(a) ? o.a.createElement("div", {
        className: "embed"
      }, Ir(n.isNil(t) ? this.getSrc() : t, {
        defaultProps: {
          allowFullScreen: !1,
          frameBorder: 0,
          height: "100%",
          scrolling: "no",
          src: this.getSrc(),
          title: "Embedded content from " + r + ".",
          width: "100%"
        },
        autoGenerateKey: !1
      })) : o.a.createElement("div", {
        className: "embed"
      }, a) : o.a.createElement("div", {
        className: "embed"
      }, e) : null;
    }, e;
  }(Mi);

  kh.handledProps = ["active", "as", "aspectRatio", "autoplay", "brandedUI", "children", "className", "color", "content", "defaultActive", "hd", "icon", "id", "iframe", "onClick", "placeholder", "source", "url"], kh.propTypes = {}, kh.autoControlledProps = ["active"];

  var Ih = function Ih(c) {
    return E(c) && 1 === c.nodeType && !xr(c);
  },
      Oh = i.createContext();

  i.createContext();

  var Qh = function Qh(c) {
    return Array.isArray(c) ? c[0] : c;
  },
      Zh = function Zh(c, e) {
    if ("function" == typeof c) return function (c) {
      if ("function" == typeof c) {
        for (var e = arguments.length, a = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) {
          a[n - 1] = arguments[n];
        }

        return c.apply(void 0, a);
      }
    }(c, e);
    null != c && (c.current = e);
  },
      Uh = function Uh(c) {
    return c.reduce(function (c, e) {
      var a = e[0],
          n = e[1];
      return c[a] = n, c;
    }, {});
  },
      Bh = "undefined" != typeof window && window.document && window.document.createElement ? i.useLayoutEffect : i.useEffect;

  function Rh(c) {
    if (null == c) return window;

    if ("[object Window]" !== c.toString()) {
      var e = c.ownerDocument;
      return e && e.defaultView || window;
    }

    return c;
  }

  function Yh(c) {
    return c instanceof Rh(c).Element || c instanceof Element;
  }

  function Ph(c) {
    return c instanceof Rh(c).HTMLElement || c instanceof HTMLElement;
  }

  function Fh(c) {
    return "undefined" != typeof ShadowRoot && (c instanceof Rh(c).ShadowRoot || c instanceof ShadowRoot);
  }

  var Wh = Math.max,
      Gh = Math.min,
      qh = Math.round;

  function Jh() {
    var c = navigator.userAgentData;
    return null != c && c.brands && Array.isArray(c.brands) ? c.brands.map(function (c) {
      return c.brand + "/" + c.version;
    }).join(" ") : navigator.userAgent;
  }

  function Kh() {
    return !/^((?!chrome|android).)*safari/i.test(Jh());
  }

  function Xh(c, e, a) {
    void 0 === e && (e = !1), void 0 === a && (a = !1);
    var n = c.getBoundingClientRect(),
        t = 1,
        r = 1;
    e && Ph(c) && (t = c.offsetWidth > 0 && qh(n.width) / c.offsetWidth || 1, r = c.offsetHeight > 0 && qh(n.height) / c.offsetHeight || 1);
    var i = (Yh(c) ? Rh(c) : window).visualViewport,
        o = !Kh() && a,
        l = (n.left + (o && i ? i.offsetLeft : 0)) / t,
        f = (n.top + (o && i ? i.offsetTop : 0)) / r,
        s = n.width / t,
        u = n.height / r;
    return {
      width: s,
      height: u,
      top: f,
      right: l + s,
      bottom: f + u,
      left: l,
      x: l,
      y: f
    };
  }

  function _h(c) {
    var e = Rh(c);
    return {
      scrollLeft: e.pageXOffset,
      scrollTop: e.pageYOffset
    };
  }

  function $h(c) {
    return c ? (c.nodeName || "").toLowerCase() : null;
  }

  function cm(c) {
    return ((Yh(c) ? c.ownerDocument : c.document) || window.document).documentElement;
  }

  function em(c) {
    return Xh(cm(c)).left + _h(c).scrollLeft;
  }

  function am(c) {
    return Rh(c).getComputedStyle(c);
  }

  function nm(c) {
    var e = am(c),
        a = e.overflow,
        n = e.overflowX,
        t = e.overflowY;
    return /auto|scroll|overlay|hidden/.test(a + t + n);
  }

  function tm(c, e, a) {
    void 0 === a && (a = !1);

    var n,
        t,
        r = Ph(e),
        i = Ph(e) && function (c) {
      var e = c.getBoundingClientRect(),
          a = qh(e.width) / c.offsetWidth || 1,
          n = qh(e.height) / c.offsetHeight || 1;
      return 1 !== a || 1 !== n;
    }(e),
        o = cm(e),
        l = Xh(c, i, a),
        f = {
      scrollLeft: 0,
      scrollTop: 0
    },
        s = {
      x: 0,
      y: 0
    };

    return (r || !r && !a) && (("body" !== $h(e) || nm(o)) && (f = (n = e) !== Rh(n) && Ph(n) ? {
      scrollLeft: (t = n).scrollLeft,
      scrollTop: t.scrollTop
    } : _h(n)), Ph(e) ? ((s = Xh(e, !0)).x += e.clientLeft, s.y += e.clientTop) : o && (s.x = em(o))), {
      x: l.left + f.scrollLeft - s.x,
      y: l.top + f.scrollTop - s.y,
      width: l.width,
      height: l.height
    };
  }

  function rm(c) {
    var e = Xh(c),
        a = c.offsetWidth,
        n = c.offsetHeight;
    return Math.abs(e.width - a) <= 1 && (a = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), {
      x: c.offsetLeft,
      y: c.offsetTop,
      width: a,
      height: n
    };
  }

  function im(c) {
    return "html" === $h(c) ? c : c.assignedSlot || c.parentNode || (Fh(c) ? c.host : null) || cm(c);
  }

  function om(c, e) {
    var a;
    void 0 === e && (e = []);

    var n = function c(e) {
      return ["html", "body", "#document"].indexOf($h(e)) >= 0 ? e.ownerDocument.body : Ph(e) && nm(e) ? e : c(im(e));
    }(c),
        t = n === (null == (a = c.ownerDocument) ? void 0 : a.body),
        r = Rh(n),
        i = t ? [r].concat(r.visualViewport || [], nm(n) ? n : []) : n,
        o = e.concat(i);

    return t ? o : o.concat(om(im(i)));
  }

  function lm(c) {
    return ["table", "td", "th"].indexOf($h(c)) >= 0;
  }

  function fm(c) {
    return Ph(c) && "fixed" !== am(c).position ? c.offsetParent : null;
  }

  function sm(c) {
    for (var e = Rh(c), a = fm(c); a && lm(a) && "static" === am(a).position;) {
      a = fm(a);
    }

    return a && ("html" === $h(a) || "body" === $h(a) && "static" === am(a).position) ? e : a || function (c) {
      var e = /firefox/i.test(Jh());
      if (/Trident/i.test(Jh()) && Ph(c) && "fixed" === am(c).position) return null;
      var a = im(c);

      for (Fh(a) && (a = a.host); Ph(a) && ["html", "body"].indexOf($h(a)) < 0;) {
        var n = am(a);
        if ("none" !== n.transform || "none" !== n.perspective || "paint" === n.contain || -1 !== ["transform", "perspective"].indexOf(n.willChange) || e && "filter" === n.willChange || e && n.filter && "none" !== n.filter) return a;
        a = a.parentNode;
      }

      return null;
    }(c) || e;
  }

  var um = "top",
      hm = "bottom",
      mm = "right",
      vm = "left",
      dm = "auto",
      Mm = [um, hm, mm, vm],
      pm = "start",
      zm = "end",
      Cm = "clippingParents",
      Lm = "viewport",
      Am = "popper",
      Nm = "reference",
      gm = Mm.reduce(function (c, e) {
    return c.concat([e + "-" + pm, e + "-" + zm]);
  }, []),
      Hm = [].concat(Mm, [dm]).reduce(function (c, e) {
    return c.concat([e, e + "-" + pm, e + "-" + zm]);
  }, []),
      Vm = ["beforeRead", "read", "afterRead", "beforeMain", "main", "afterMain", "beforeWrite", "write", "afterWrite"];

  function xm(c) {
    var e = new Map(),
        a = new Set(),
        n = [];
    return c.forEach(function (c) {
      e.set(c.name, c);
    }), c.forEach(function (c) {
      a.has(c.name) || function c(t) {
        a.add(t.name), [].concat(t.requires || [], t.requiresIfExists || []).forEach(function (n) {
          if (!a.has(n)) {
            var t = e.get(n);
            t && c(t);
          }
        }), n.push(t);
      }(c);
    }), n;
  }

  var wm = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
  };

  function ym() {
    for (var c = arguments.length, e = new Array(c), a = 0; a < c; a++) {
      e[a] = arguments[a];
    }

    return !e.some(function (c) {
      return !(c && "function" == typeof c.getBoundingClientRect);
    });
  }

  function bm(c) {
    void 0 === c && (c = {});
    var e = c,
        a = e.defaultModifiers,
        n = void 0 === a ? [] : a,
        t = e.defaultOptions,
        r = void 0 === t ? wm : t;
    return function (c, e, a) {
      void 0 === a && (a = r);
      var t,
          i,
          o = {
        placement: "bottom",
        orderedModifiers: [],
        options: Object.assign({}, wm, r),
        modifiersData: {},
        elements: {
          reference: c,
          popper: e
        },
        attributes: {},
        styles: {}
      },
          l = [],
          f = !1,
          s = {
        state: o,
        setOptions: function setOptions(a) {
          var t = "function" == typeof a ? a(o.options) : a;
          u(), o.options = Object.assign({}, r, o.options, t), o.scrollParents = {
            reference: Yh(c) ? om(c) : c.contextElement ? om(c.contextElement) : [],
            popper: om(e)
          };

          var i,
              f,
              h = function (c) {
            var e = xm(c);
            return Vm.reduce(function (c, a) {
              return c.concat(e.filter(function (c) {
                return c.phase === a;
              }));
            }, []);
          }((i = [].concat(n, o.options.modifiers), f = i.reduce(function (c, e) {
            var a = c[e.name];
            return c[e.name] = a ? Object.assign({}, a, e, {
              options: Object.assign({}, a.options, e.options),
              data: Object.assign({}, a.data, e.data)
            }) : e, c;
          }, {}), Object.keys(f).map(function (c) {
            return f[c];
          })));

          return o.orderedModifiers = h.filter(function (c) {
            return c.enabled;
          }), o.orderedModifiers.forEach(function (c) {
            var e = c.name,
                a = c.options,
                n = void 0 === a ? {} : a,
                t = c.effect;

            if ("function" == typeof t) {
              var r = t({
                state: o,
                name: e,
                instance: s,
                options: n
              });
              l.push(r || function () {});
            }
          }), s.update();
        },
        forceUpdate: function forceUpdate() {
          if (!f) {
            var c = o.elements,
                e = c.reference,
                a = c.popper;

            if (ym(e, a)) {
              o.rects = {
                reference: tm(e, sm(a), "fixed" === o.options.strategy),
                popper: rm(a)
              }, o.reset = !1, o.placement = o.options.placement, o.orderedModifiers.forEach(function (c) {
                return o.modifiersData[c.name] = Object.assign({}, c.data);
              });

              for (var n = 0; n < o.orderedModifiers.length; n++) {
                if (!0 !== o.reset) {
                  var t = o.orderedModifiers[n],
                      r = t.fn,
                      i = t.options,
                      l = void 0 === i ? {} : i,
                      u = t.name;
                  "function" == typeof r && (o = r({
                    state: o,
                    options: l,
                    name: u,
                    instance: s
                  }) || o);
                } else o.reset = !1, n = -1;
              }
            }
          }
        },
        update: (t = function t() {
          return new Promise(function (c) {
            s.forceUpdate(), c(o);
          });
        }, function () {
          return i || (i = new Promise(function (c) {
            Promise.resolve().then(function () {
              i = void 0, c(t());
            });
          })), i;
        }),
        destroy: function destroy() {
          u(), f = !0;
        }
      };
      if (!ym(c, e)) return s;

      function u() {
        l.forEach(function (c) {
          return c();
        }), l = [];
      }

      return s.setOptions(a).then(function (c) {
        !f && a.onFirstUpdate && a.onFirstUpdate(c);
      }), s;
    };
  }

  var Sm = {
    passive: !0
  };

  function Tm(c) {
    return c.split("-")[0];
  }

  function Dm(c) {
    return c.split("-")[1];
  }

  function jm(c) {
    return ["top", "bottom"].indexOf(c) >= 0 ? "x" : "y";
  }

  function Em(c) {
    var e,
        a = c.reference,
        n = c.element,
        t = c.placement,
        r = t ? Tm(t) : null,
        i = t ? Dm(t) : null,
        o = a.x + a.width / 2 - n.width / 2,
        l = a.y + a.height / 2 - n.height / 2;

    switch (r) {
      case um:
        e = {
          x: o,
          y: a.y - n.height
        };
        break;

      case hm:
        e = {
          x: o,
          y: a.y + a.height
        };
        break;

      case mm:
        e = {
          x: a.x + a.width,
          y: l
        };
        break;

      case vm:
        e = {
          x: a.x - n.width,
          y: l
        };
        break;

      default:
        e = {
          x: a.x,
          y: a.y
        };
    }

    var f = r ? jm(r) : null;

    if (null != f) {
      var s = "y" === f ? "height" : "width";

      switch (i) {
        case pm:
          e[f] = e[f] - (a[s] / 2 - n[s] / 2);
          break;

        case zm:
          e[f] = e[f] + (a[s] / 2 - n[s] / 2);
      }
    }

    return e;
  }

  var km = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
  };

  function Im(c) {
    var e,
        a = c.popper,
        n = c.popperRect,
        t = c.placement,
        r = c.variation,
        i = c.offsets,
        o = c.position,
        l = c.gpuAcceleration,
        f = c.adaptive,
        s = c.roundOffsets,
        u = c.isFixed,
        h = i.x,
        m = void 0 === h ? 0 : h,
        v = i.y,
        d = void 0 === v ? 0 : v,
        M = "function" == typeof s ? s({
      x: m,
      y: d
    }) : {
      x: m,
      y: d
    };
    m = M.x, d = M.y;
    var p = i.hasOwnProperty("x"),
        z = i.hasOwnProperty("y"),
        C = vm,
        L = um,
        A = window;

    if (f) {
      var N = sm(a),
          g = "clientHeight",
          H = "clientWidth";
      if (N === Rh(a) && "static" !== am(N = cm(a)).position && "absolute" === o && (g = "scrollHeight", H = "scrollWidth"), N = N, t === um || (t === vm || t === mm) && r === zm) L = hm, d -= (u && N === A && A.visualViewport ? A.visualViewport.height : N[g]) - n.height, d *= l ? 1 : -1;
      if (t === vm || (t === um || t === hm) && r === zm) C = mm, m -= (u && N === A && A.visualViewport ? A.visualViewport.width : N[H]) - n.width, m *= l ? 1 : -1;
    }

    var V,
        x = Object.assign({
      position: o
    }, f && km),
        w = !0 === s ? function (c, e) {
      var a = c.x,
          n = c.y,
          t = e.devicePixelRatio || 1;
      return {
        x: qh(a * t) / t || 0,
        y: qh(n * t) / t || 0
      };
    }({
      x: m,
      y: d
    }, Rh(a)) : {
      x: m,
      y: d
    };
    return m = w.x, d = w.y, l ? Object.assign({}, x, ((V = {})[L] = z ? "0" : "", V[C] = p ? "0" : "", V.transform = (A.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + d + "px)" : "translate3d(" + m + "px, " + d + "px, 0)", V)) : Object.assign({}, x, ((e = {})[L] = z ? d + "px" : "", e[C] = p ? m + "px" : "", e.transform = "", e));
  }

  var Om = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  };

  function Qm(c) {
    return c.replace(/left|right|bottom|top/g, function (c) {
      return Om[c];
    });
  }

  var Zm = {
    start: "end",
    end: "start"
  };

  function Um(c) {
    return c.replace(/start|end/g, function (c) {
      return Zm[c];
    });
  }

  function Bm(c, e) {
    var a = e.getRootNode && e.getRootNode();
    if (c.contains(e)) return !0;

    if (a && Fh(a)) {
      var n = e;

      do {
        if (n && c.isSameNode(n)) return !0;
        n = n.parentNode || n.host;
      } while (n);
    }

    return !1;
  }

  function Rm(c) {
    return Object.assign({}, c, {
      left: c.x,
      top: c.y,
      right: c.x + c.width,
      bottom: c.y + c.height
    });
  }

  function Ym(c, e, a) {
    return e === Lm ? Rm(function (c, e) {
      var a = Rh(c),
          n = cm(c),
          t = a.visualViewport,
          r = n.clientWidth,
          i = n.clientHeight,
          o = 0,
          l = 0;

      if (t) {
        r = t.width, i = t.height;
        var f = Kh();
        (f || !f && "fixed" === e) && (o = t.offsetLeft, l = t.offsetTop);
      }

      return {
        width: r,
        height: i,
        x: o + em(c),
        y: l
      };
    }(c, a)) : Yh(e) ? function (c, e) {
      var a = Xh(c, !1, "fixed" === e);
      return a.top = a.top + c.clientTop, a.left = a.left + c.clientLeft, a.bottom = a.top + c.clientHeight, a.right = a.left + c.clientWidth, a.width = c.clientWidth, a.height = c.clientHeight, a.x = a.left, a.y = a.top, a;
    }(e, a) : Rm(function (c) {
      var e,
          a = cm(c),
          n = _h(c),
          t = null == (e = c.ownerDocument) ? void 0 : e.body,
          r = Wh(a.scrollWidth, a.clientWidth, t ? t.scrollWidth : 0, t ? t.clientWidth : 0),
          i = Wh(a.scrollHeight, a.clientHeight, t ? t.scrollHeight : 0, t ? t.clientHeight : 0),
          o = -n.scrollLeft + em(c),
          l = -n.scrollTop;

      return "rtl" === am(t || a).direction && (o += Wh(a.clientWidth, t ? t.clientWidth : 0) - r), {
        width: r,
        height: i,
        x: o,
        y: l
      };
    }(cm(c)));
  }

  function Pm(c, e, a, n) {
    var t = "clippingParents" === e ? function (c) {
      var e = om(im(c)),
          a = ["absolute", "fixed"].indexOf(am(c).position) >= 0 && Ph(c) ? sm(c) : c;
      return Yh(a) ? e.filter(function (c) {
        return Yh(c) && Bm(c, a) && "body" !== $h(c);
      }) : [];
    }(c) : [].concat(e),
        r = [].concat(t, [a]),
        i = r[0],
        o = r.reduce(function (e, a) {
      var t = Ym(c, a, n);
      return e.top = Wh(t.top, e.top), e.right = Gh(t.right, e.right), e.bottom = Gh(t.bottom, e.bottom), e.left = Wh(t.left, e.left), e;
    }, Ym(c, i, n));
    return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
  }

  function Fm(c) {
    return Object.assign({}, {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, c);
  }

  function Wm(c, e) {
    return e.reduce(function (e, a) {
      return e[a] = c, e;
    }, {});
  }

  function Gm(c, e) {
    void 0 === e && (e = {});
    var a = e,
        n = a.placement,
        t = void 0 === n ? c.placement : n,
        r = a.strategy,
        i = void 0 === r ? c.strategy : r,
        o = a.boundary,
        l = void 0 === o ? Cm : o,
        f = a.rootBoundary,
        s = void 0 === f ? Lm : f,
        u = a.elementContext,
        h = void 0 === u ? Am : u,
        m = a.altBoundary,
        v = void 0 !== m && m,
        d = a.padding,
        M = void 0 === d ? 0 : d,
        p = Fm("number" != typeof M ? M : Wm(M, Mm)),
        z = h === Am ? Nm : Am,
        C = c.rects.popper,
        L = c.elements[v ? z : h],
        A = Pm(Yh(L) ? L : L.contextElement || cm(c.elements.popper), l, s, i),
        N = Xh(c.elements.reference),
        g = Em({
      reference: N,
      element: C,
      strategy: "absolute",
      placement: t
    }),
        H = Rm(Object.assign({}, C, g)),
        V = h === Am ? H : N,
        x = {
      top: A.top - V.top + p.top,
      bottom: V.bottom - A.bottom + p.bottom,
      left: A.left - V.left + p.left,
      right: V.right - A.right + p.right
    },
        w = c.modifiersData.offset;

    if (h === Am && w) {
      var y = w[t];
      Object.keys(x).forEach(function (c) {
        var e = [mm, hm].indexOf(c) >= 0 ? 1 : -1,
            a = [um, hm].indexOf(c) >= 0 ? "y" : "x";
        x[c] += y[a] * e;
      });
    }

    return x;
  }

  function qm(c, e, a) {
    return Wh(c, Gh(e, a));
  }

  var Jm = function Jm(c, e) {
    return Fm("number" != typeof (c = "function" == typeof c ? c(Object.assign({}, e.rects, {
      placement: e.placement
    })) : c) ? c : Wm(c, Mm));
  };

  function Km(c, e, a) {
    return void 0 === a && (a = {
      x: 0,
      y: 0
    }), {
      top: c.top - e.height - a.y,
      right: c.right - e.width + a.x,
      bottom: c.bottom - e.height + a.y,
      left: c.left - e.width - a.x
    };
  }

  function Xm(c) {
    return [um, mm, hm, vm].some(function (e) {
      return c[e] >= 0;
    });
  }

  var _m = bm({
    defaultModifiers: [{
      name: "eventListeners",
      enabled: !0,
      phase: "write",
      fn: function fn() {},
      effect: function effect(c) {
        var e = c.state,
            a = c.instance,
            n = c.options,
            t = n.scroll,
            r = void 0 === t || t,
            i = n.resize,
            o = void 0 === i || i,
            l = Rh(e.elements.popper),
            f = [].concat(e.scrollParents.reference, e.scrollParents.popper);
        return r && f.forEach(function (c) {
          c.addEventListener("scroll", a.update, Sm);
        }), o && l.addEventListener("resize", a.update, Sm), function () {
          r && f.forEach(function (c) {
            c.removeEventListener("scroll", a.update, Sm);
          }), o && l.removeEventListener("resize", a.update, Sm);
        };
      },
      data: {}
    }, {
      name: "popperOffsets",
      enabled: !0,
      phase: "read",
      fn: function fn(c) {
        var e = c.state,
            a = c.name;
        e.modifiersData[a] = Em({
          reference: e.rects.reference,
          element: e.rects.popper,
          strategy: "absolute",
          placement: e.placement
        });
      },
      data: {}
    }, {
      name: "computeStyles",
      enabled: !0,
      phase: "beforeWrite",
      fn: function fn(c) {
        var e = c.state,
            a = c.options,
            n = a.gpuAcceleration,
            t = void 0 === n || n,
            r = a.adaptive,
            i = void 0 === r || r,
            o = a.roundOffsets,
            l = void 0 === o || o,
            f = {
          placement: Tm(e.placement),
          variation: Dm(e.placement),
          popper: e.elements.popper,
          popperRect: e.rects.popper,
          gpuAcceleration: t,
          isFixed: "fixed" === e.options.strategy
        };
        null != e.modifiersData.popperOffsets && (e.styles.popper = Object.assign({}, e.styles.popper, Im(Object.assign({}, f, {
          offsets: e.modifiersData.popperOffsets,
          position: e.options.strategy,
          adaptive: i,
          roundOffsets: l
        })))), null != e.modifiersData.arrow && (e.styles.arrow = Object.assign({}, e.styles.arrow, Im(Object.assign({}, f, {
          offsets: e.modifiersData.arrow,
          position: "absolute",
          adaptive: !1,
          roundOffsets: l
        })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
          "data-popper-placement": e.placement
        });
      },
      data: {}
    }, {
      name: "applyStyles",
      enabled: !0,
      phase: "write",
      fn: function fn(c) {
        var e = c.state;
        Object.keys(e.elements).forEach(function (c) {
          var a = e.styles[c] || {},
              n = e.attributes[c] || {},
              t = e.elements[c];
          Ph(t) && $h(t) && (Object.assign(t.style, a), Object.keys(n).forEach(function (c) {
            var e = n[c];
            !1 === e ? t.removeAttribute(c) : t.setAttribute(c, !0 === e ? "" : e);
          }));
        });
      },
      effect: function effect(c) {
        var e = c.state,
            a = {
          popper: {
            position: e.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
          },
          arrow: {
            position: "absolute"
          },
          reference: {}
        };
        return Object.assign(e.elements.popper.style, a.popper), e.styles = a, e.elements.arrow && Object.assign(e.elements.arrow.style, a.arrow), function () {
          Object.keys(e.elements).forEach(function (c) {
            var n = e.elements[c],
                t = e.attributes[c] || {},
                r = Object.keys(e.styles.hasOwnProperty(c) ? e.styles[c] : a[c]).reduce(function (c, e) {
              return c[e] = "", c;
            }, {});
            Ph(n) && $h(n) && (Object.assign(n.style, r), Object.keys(t).forEach(function (c) {
              n.removeAttribute(c);
            }));
          });
        };
      },
      requires: ["computeStyles"]
    }, {
      name: "offset",
      enabled: !0,
      phase: "main",
      requires: ["popperOffsets"],
      fn: function fn(c) {
        var e = c.state,
            a = c.options,
            n = c.name,
            t = a.offset,
            r = void 0 === t ? [0, 0] : t,
            i = Hm.reduce(function (c, a) {
          return c[a] = function (c, e, a) {
            var n = Tm(c),
                t = [vm, um].indexOf(n) >= 0 ? -1 : 1,
                r = "function" == typeof a ? a(Object.assign({}, e, {
              placement: c
            })) : a,
                i = r[0],
                o = r[1];
            return i = i || 0, o = (o || 0) * t, [vm, mm].indexOf(n) >= 0 ? {
              x: o,
              y: i
            } : {
              x: i,
              y: o
            };
          }(a, e.rects, r), c;
        }, {}),
            o = i[e.placement],
            l = o.x,
            f = o.y;
        null != e.modifiersData.popperOffsets && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += f), e.modifiersData[n] = i;
      }
    }, {
      name: "flip",
      enabled: !0,
      phase: "main",
      fn: function fn(c) {
        var e = c.state,
            a = c.options,
            n = c.name;

        if (!e.modifiersData[n]._skip) {
          for (var t = a.mainAxis, r = void 0 === t || t, i = a.altAxis, o = void 0 === i || i, l = a.fallbackPlacements, f = a.padding, s = a.boundary, u = a.rootBoundary, h = a.altBoundary, m = a.flipVariations, v = void 0 === m || m, d = a.allowedAutoPlacements, M = e.options.placement, p = Tm(M), z = l || (p !== M && v ? function (c) {
            if (Tm(c) === dm) return [];
            var e = Qm(c);
            return [Um(c), e, Um(e)];
          }(M) : [Qm(M)]), C = [M].concat(z).reduce(function (c, a) {
            return c.concat(Tm(a) === dm ? function (c, e) {
              void 0 === e && (e = {});
              var a = e,
                  n = a.placement,
                  t = a.boundary,
                  r = a.rootBoundary,
                  i = a.padding,
                  o = a.flipVariations,
                  l = a.allowedAutoPlacements,
                  f = void 0 === l ? Hm : l,
                  s = Dm(n),
                  u = s ? o ? gm : gm.filter(function (c) {
                return Dm(c) === s;
              }) : Mm,
                  h = u.filter(function (c) {
                return f.indexOf(c) >= 0;
              });
              0 === h.length && (h = u);
              var m = h.reduce(function (e, a) {
                return e[a] = Gm(c, {
                  placement: a,
                  boundary: t,
                  rootBoundary: r,
                  padding: i
                })[Tm(a)], e;
              }, {});
              return Object.keys(m).sort(function (c, e) {
                return m[c] - m[e];
              });
            }(e, {
              placement: a,
              boundary: s,
              rootBoundary: u,
              padding: f,
              flipVariations: v,
              allowedAutoPlacements: d
            }) : a);
          }, []), L = e.rects.reference, A = e.rects.popper, N = new Map(), g = !0, H = C[0], V = 0; V < C.length; V++) {
            var x = C[V],
                w = Tm(x),
                y = Dm(x) === pm,
                b = [um, hm].indexOf(w) >= 0,
                S = b ? "width" : "height",
                T = Gm(e, {
              placement: x,
              boundary: s,
              rootBoundary: u,
              altBoundary: h,
              padding: f
            }),
                D = b ? y ? mm : vm : y ? hm : um;
            L[S] > A[S] && (D = Qm(D));
            var j = Qm(D),
                E = [];

            if (r && E.push(T[w] <= 0), o && E.push(T[D] <= 0, T[j] <= 0), E.every(function (c) {
              return c;
            })) {
              H = x, g = !1;
              break;
            }

            N.set(x, E);
          }

          if (g) for (var k = function k(c) {
            var e = C.find(function (e) {
              var a = N.get(e);
              if (a) return a.slice(0, c).every(function (c) {
                return c;
              });
            });
            if (e) return H = e, "break";
          }, I = v ? 3 : 1; I > 0 && "break" !== k(I); I--) {
            ;
          }
          e.placement !== H && (e.modifiersData[n]._skip = !0, e.placement = H, e.reset = !0);
        }
      },
      requiresIfExists: ["offset"],
      data: {
        _skip: !1
      }
    }, {
      name: "preventOverflow",
      enabled: !0,
      phase: "main",
      fn: function fn(c) {
        var e = c.state,
            a = c.options,
            n = c.name,
            t = a.mainAxis,
            r = void 0 === t || t,
            i = a.altAxis,
            o = void 0 !== i && i,
            l = a.boundary,
            f = a.rootBoundary,
            s = a.altBoundary,
            u = a.padding,
            h = a.tether,
            m = void 0 === h || h,
            v = a.tetherOffset,
            d = void 0 === v ? 0 : v,
            M = Gm(e, {
          boundary: l,
          rootBoundary: f,
          padding: u,
          altBoundary: s
        }),
            p = Tm(e.placement),
            z = Dm(e.placement),
            C = !z,
            L = jm(p),
            A = "x" === L ? "y" : "x",
            N = e.modifiersData.popperOffsets,
            g = e.rects.reference,
            H = e.rects.popper,
            V = "function" == typeof d ? d(Object.assign({}, e.rects, {
          placement: e.placement
        })) : d,
            x = "number" == typeof V ? {
          mainAxis: V,
          altAxis: V
        } : Object.assign({
          mainAxis: 0,
          altAxis: 0
        }, V),
            w = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null,
            y = {
          x: 0,
          y: 0
        };

        if (N) {
          if (r) {
            var b,
                S = "y" === L ? um : vm,
                T = "y" === L ? hm : mm,
                D = "y" === L ? "height" : "width",
                j = N[L],
                E = j + M[S],
                k = j - M[T],
                I = m ? -H[D] / 2 : 0,
                O = z === pm ? g[D] : H[D],
                Q = z === pm ? -H[D] : -g[D],
                Z = e.elements.arrow,
                U = m && Z ? rm(Z) : {
              width: 0,
              height: 0
            },
                B = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
                R = B[S],
                Y = B[T],
                P = qm(0, g[D], U[D]),
                F = C ? g[D] / 2 - I - P - R - x.mainAxis : O - P - R - x.mainAxis,
                W = C ? -g[D] / 2 + I + P + Y + x.mainAxis : Q + P + Y + x.mainAxis,
                G = e.elements.arrow && sm(e.elements.arrow),
                q = G ? "y" === L ? G.clientTop || 0 : G.clientLeft || 0 : 0,
                J = null != (b = null == w ? void 0 : w[L]) ? b : 0,
                K = j + W - J,
                X = qm(m ? Gh(E, j + F - J - q) : E, j, m ? Wh(k, K) : k);
            N[L] = X, y[L] = X - j;
          }

          if (o) {
            var _,
                $ = "x" === L ? um : vm,
                cc = "x" === L ? hm : mm,
                ec = N[A],
                ac = "y" === A ? "height" : "width",
                nc = ec + M[$],
                tc = ec - M[cc],
                rc = -1 !== [um, vm].indexOf(p),
                ic = null != (_ = null == w ? void 0 : w[A]) ? _ : 0,
                oc = rc ? nc : ec - g[ac] - H[ac] - ic + x.altAxis,
                lc = rc ? ec + g[ac] + H[ac] - ic - x.altAxis : tc,
                fc = m && rc ? function (c, e, a) {
              var n = qm(c, e, a);
              return n > a ? a : n;
            }(oc, ec, lc) : qm(m ? oc : nc, ec, m ? lc : tc);

            N[A] = fc, y[A] = fc - ec;
          }

          e.modifiersData[n] = y;
        }
      },
      requiresIfExists: ["offset"]
    }, {
      name: "arrow",
      enabled: !0,
      phase: "main",
      fn: function fn(c) {
        var e,
            a = c.state,
            n = c.name,
            t = c.options,
            r = a.elements.arrow,
            i = a.modifiersData.popperOffsets,
            o = Tm(a.placement),
            l = jm(o),
            f = [vm, mm].indexOf(o) >= 0 ? "height" : "width";

        if (r && i) {
          var s = Jm(t.padding, a),
              u = rm(r),
              h = "y" === l ? um : vm,
              m = "y" === l ? hm : mm,
              v = a.rects.reference[f] + a.rects.reference[l] - i[l] - a.rects.popper[f],
              d = i[l] - a.rects.reference[l],
              M = sm(r),
              p = M ? "y" === l ? M.clientHeight || 0 : M.clientWidth || 0 : 0,
              z = v / 2 - d / 2,
              C = s[h],
              L = p - u[f] - s[m],
              A = p / 2 - u[f] / 2 + z,
              N = qm(C, A, L),
              g = l;
          a.modifiersData[n] = ((e = {})[g] = N, e.centerOffset = N - A, e);
        }
      },
      effect: function effect(c) {
        var e = c.state,
            a = c.options.element,
            n = void 0 === a ? "[data-popper-arrow]" : a;
        null != n && ("string" != typeof n || (n = e.elements.popper.querySelector(n))) && Bm(e.elements.popper, n) && (e.elements.arrow = n);
      },
      requires: ["popperOffsets"],
      requiresIfExists: ["preventOverflow"]
    }, {
      name: "hide",
      enabled: !0,
      phase: "main",
      requiresIfExists: ["preventOverflow"],
      fn: function fn(c) {
        var e = c.state,
            a = c.name,
            n = e.rects.reference,
            t = e.rects.popper,
            r = e.modifiersData.preventOverflow,
            i = Gm(e, {
          elementContext: "reference"
        }),
            o = Gm(e, {
          altBoundary: !0
        }),
            l = Km(i, n),
            f = Km(o, t, r),
            s = Xm(l),
            u = Xm(f);
        e.modifiersData[a] = {
          referenceClippingOffsets: l,
          popperEscapeOffsets: f,
          isReferenceHidden: s,
          hasPopperEscaped: u
        }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
          "data-popper-reference-hidden": s,
          "data-popper-escaped": u
        });
      }
    }]
  }),
      $m = a(96),
      cv = a.n($m),
      ev = [],
      av = function av(c, e, a) {
    void 0 === a && (a = {});
    var n = i.useRef(null),
        t = {
      onFirstUpdate: a.onFirstUpdate,
      placement: a.placement || "bottom",
      strategy: a.strategy || "absolute",
      modifiers: a.modifiers || ev
    },
        r = i.useState({
      styles: {
        popper: {
          position: t.strategy,
          left: "0",
          top: "0"
        },
        arrow: {
          position: "absolute"
        }
      },
      attributes: {}
    }),
        o = r[0],
        l = r[1],
        f = i.useMemo(function () {
      return {
        name: "updateState",
        enabled: !0,
        phase: "write",
        fn: function fn(c) {
          var e = c.state,
              a = Object.keys(e.elements);
          s.flushSync(function () {
            l({
              styles: Uh(a.map(function (c) {
                return [c, e.styles[c] || {}];
              })),
              attributes: Uh(a.map(function (c) {
                return [c, e.attributes[c]];
              }))
            });
          });
        },
        requires: ["computeStyles"]
      };
    }, []),
        u = i.useMemo(function () {
      var c = {
        onFirstUpdate: t.onFirstUpdate,
        placement: t.placement,
        strategy: t.strategy,
        modifiers: [].concat(t.modifiers, [f, {
          name: "applyStyles",
          enabled: !1
        }])
      };
      return cv()(n.current, c) ? n.current || c : (n.current = c, c);
    }, [t.onFirstUpdate, t.placement, t.strategy, t.modifiers, f]),
        h = i.useRef();
    return Bh(function () {
      h.current && h.current.setOptions(u);
    }, [u]), Bh(function () {
      if (null != c && null != e) {
        var n = (a.createPopper || _m)(c, e, u);

        return h.current = n, function () {
          n.destroy(), h.current = null;
        };
      }
    }, [c, e, a.createPopper]), {
      state: h.current ? h.current.state : null,
      styles: o.styles,
      attributes: o.attributes,
      update: h.current ? h.current.update : null,
      forceUpdate: h.current ? h.current.forceUpdate : null
    };
  },
      nv = function nv() {},
      tv = function tv() {
    return Promise.resolve(null);
  },
      rv = [];

  function iv(c) {
    var e = c.placement,
        a = void 0 === e ? "bottom" : e,
        n = c.strategy,
        t = void 0 === n ? "absolute" : n,
        r = c.modifiers,
        o = void 0 === r ? rv : r,
        l = c.referenceElement,
        f = c.onFirstUpdate,
        s = c.innerRef,
        u = c.children,
        h = i.useContext(Oh),
        m = i.useState(null),
        v = m[0],
        d = m[1],
        M = i.useState(null),
        p = M[0],
        z = M[1];
    i.useEffect(function () {
      Zh(s, v);
    }, [s, v]);
    var C = i.useMemo(function () {
      return {
        placement: a,
        strategy: t,
        onFirstUpdate: f,
        modifiers: [].concat(o, [{
          name: "arrow",
          enabled: null != p,
          options: {
            element: p
          }
        }])
      };
    }, [a, t, f, o, p]),
        L = av(l || h, v, C),
        A = L.state,
        N = L.styles,
        g = L.forceUpdate,
        H = L.update,
        V = i.useMemo(function () {
      return {
        ref: d,
        style: N.popper,
        placement: A ? A.placement : a,
        hasPopperEscaped: A && A.modifiersData.hide ? A.modifiersData.hide.hasPopperEscaped : null,
        isReferenceHidden: A && A.modifiersData.hide ? A.modifiersData.hide.isReferenceHidden : null,
        arrowProps: {
          style: N.arrow,
          ref: z
        },
        forceUpdate: g || nv,
        update: H || tv
      };
    }, [d, z, a, A, N, H, g]);
    return Qh(u)(V);
  }

  var ov = function ov(c, e, a, n) {
    return Xn(c, function (c, t, r) {
      e(n, a(c), t, r);
    }), n;
  };

  var lv = function lv(c, e) {
    return function (a, n) {
      return ov(a, c, e(n), {});
    };
  },
      fv = Object.prototype.toString,
      sv = lv(function (c, e, a) {
    null != e && "function" != typeof e.toString && (e = fv.call(e)), c[e] = a;
  }, ge(Le)),
      uv = {
    "top center": "top",
    "top left": "top-start",
    "top right": "top-end",
    "bottom center": "bottom",
    "bottom left": "bottom-start",
    "bottom right": "bottom-end",
    "right center": "right",
    "left center": "left"
  },
      hv = (Pa(uv), sv(uv)),
      mv = a(41);

  function vv(c, e) {
    for (var a = 0; a < e.length; a++) {
      var n = e[a];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, Object(mv.a)(n.key), n);
    }
  }

  var dv = function () {
    function c(c) {
      this.ref = c;
    }

    var e, a, n;
    return c.prototype.getBoundingClientRect = function () {
      return De(this.ref.current, "getBoundingClientRect") || {};
    }, e = c, (a = [{
      key: "clientWidth",
      get: function get() {
        return this.getBoundingClientRect().width;
      }
    }, {
      key: "clientHeight",
      get: function get() {
        return this.getBoundingClientRect().height;
      }
    }, {
      key: "parentNode",
      get: function get() {
        return this.ref.current ? this.ref.current.parentNode : void 0;
      }
    }]) && vv(e.prototype, a), n && vv(e, n), Object.defineProperty(e, "prototype", {
      writable: !1
    }), c;
  }(),
      Mv = Bc(function (c) {
    return new dv(h(c) ? c : {
      current: c
    });
  });

  function pv(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("content", a),
        i = je(pv, c),
        l = zr(pv, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  function zv(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("header", a),
        i = je(zv, c),
        l = zr(zv, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  pv.handledProps = ["as", "children", "className", "content"], pv.propTypes = {}, pv.create = Er(pv, function (c) {
    return {
      children: c
    };
  }), zv.handledProps = ["as", "children", "className", "content"], zv.propTypes = {}, zv.create = Er(zv, function (c) {
    return {
      children: c
    };
  });

  var Cv = function (c) {
    function e() {
      for (var a, t = arguments.length, r = new Array(t), i = 0; i < t; i++) {
        r[i] = arguments[i];
      }

      return (a = c.call.apply(c, [this].concat(r)) || this).state = {}, a.open = !1, a.zIndexWasSynced = !1, a.triggerRef = o.a.createRef(), a.elementRef = o.a.createRef(), a.getPortalProps = function () {
        var c = {},
            e = a.props,
            n = e.on,
            t = e.hoverable,
            r = L(n) ? n : [n];
        return t && (c.closeOnPortalMouseLeave = !0, c.mouseLeaveDelay = 300), Gr(r, "hover") && (c.openOnTriggerClick = !1, c.closeOnTriggerClick = !1, c.openOnTriggerMouseEnter = !0, c.closeOnTriggerMouseLeave = !0, c.mouseLeaveDelay = 70, c.mouseEnterDelay = 50), Gr(r, "click") && (c.openOnTriggerClick = !0, c.closeOnTriggerClick = !0, c.closeOnDocumentClick = !0), Gr(r, "focus") && (c.openOnTriggerFocus = !0, c.closeOnTriggerBlur = !0), c;
      }, a.hideOnScroll = function (c) {
        Ih(c.target) && a.elementRef.current.contains(c.target) || (a.setState({
          closed: !0
        }), so.unsub("scroll", a.hideOnScroll, {
          target: window
        }), a.timeoutId = setTimeout(function () {
          a.setState({
            closed: !1
          });
        }, 50), a.handleClose(c));
      }, a.handleClose = function (c) {
        De(a.props, "onClose", c, Object(p.a)({}, a.props, {
          open: !1
        }));
      }, a.handleOpen = function (c) {
        De(a.props, "onOpen", c, Object(p.a)({}, a.props, {
          open: !0
        }));
      }, a.handlePortalMount = function (c) {
        De(a.props, "onMount", c, a.props);
      }, a.handlePortalUnmount = function (c) {
        a.positionUpdate = null, De(a.props, "onUnmount", c, a.props);
      }, a.renderContent = function (c) {
        var t = c.placement,
            r = c.ref,
            i = c.update,
            l = c.style,
            f = a.props,
            s = f.basic,
            u = f.children,
            h = f.className,
            m = f.content,
            v = f.hideOnScroll,
            d = f.flowing,
            M = f.header,
            z = f.inverted,
            C = f.popper,
            L = f.size,
            A = f.style,
            N = f.wide,
            g = a.state.contentRestProps;
        a.positionUpdate = i;
        var H = Ie("ui", hv[t], L, mr(N, "wide"), ur(s, "basic"), ur(d, "flowing"), ur(z, "inverted"), "popup transition visible", h),
            V = zr(e, a.props),
            x = Object(p.a)({
          left: "auto",
          right: "auto",
          position: "initial"
        }, A),
            w = o.a.createElement(V, Object(p.a)({}, g, {
          className: H,
          style: x,
          ref: a.elementRef
        }), n.isNil(u) ? o.a.createElement(o.a.Fragment, null, zv.create(M, {
          autoGenerateKey: !1
        }), pv.create(m, {
          autoGenerateKey: !1
        })) : u, v && o.a.createElement(ri.a, {
          on: a.hideOnScroll,
          name: "scroll",
          target: "window"
        }));
        return kr(C || {}, {
          overrideProps: {
            children: w,
            ref: r,
            style: Object(p.a)({
              display: "flex"
            }, l)
          }
        });
      }, a;
    }

    Object(f.a)(e, c), e.getDerivedStateFromProps = function (c, a) {
      if (a.closed || a.disabled) return {};
      var n = je(e, c);
      return {
        contentRestProps: no(n, function (c, e, a) {
          return Gr(Li.handledProps, a) || (c[a] = e), c;
        }, {}),
        portalRestProps: co(n, Li.handledProps)
      };
    };
    var a = e.prototype;
    return a.componentDidUpdate = function (c) {
      fo()(this.props.popperDependencies, c.popperDependencies) || this.handleUpdate();
    }, a.componentWillUnmount = function () {
      clearTimeout(this.timeoutId);
    }, a.handleUpdate = function () {
      this.positionUpdate && this.positionUpdate();
    }, a.render = function () {
      var c = this,
          e = this.props,
          a = e.context,
          n = e.disabled,
          t = e.eventsEnabled,
          r = e.offset,
          i = e.pinned,
          l = e.popper,
          f = e.popperModifiers,
          s = e.position,
          u = e.positionFixed,
          h = e.trigger,
          m = this.state,
          v = m.closed,
          d = m.portalRestProps;
      if (v || n) return h;
      var M = [{
        name: "arrow",
        enabled: !1
      }, {
        name: "eventListeners",
        options: {
          scroll: !!t,
          resize: !!t
        }
      }, {
        name: "flip",
        enabled: !i
      }, {
        name: "preventOverflow",
        enabled: !!r
      }, {
        name: "offset",
        enabled: !!r,
        options: {
          offset: r
        }
      }].concat(f, [{
        name: "syncZIndex",
        enabled: !0,
        phase: "beforeRead",
        fn: function fn(e) {
          var a,
              n = e.state;

          if (!c.zIndexWasSynced) {
            var t = null == l ? void 0 : null == (a = l.style) ? void 0 : a.zIndex;
            Fr(t) && (n.elements.popper.style.zIndex = window.getComputedStyle(n.elements.popper.firstChild).zIndex), c.zIndexWasSynced = !0;
          }
        },
        effect: function effect() {
          return function () {
            c.zIndexWasSynced = !1;
          };
        }
      }]),
          z = Mv(Ee(a) ? this.triggerRef : a),
          C = Object(p.a)({}, this.getPortalProps(), d);
      return o.a.createElement(Li, Object(p.a)({}, C, {
        onClose: this.handleClose,
        onMount: this.handlePortalMount,
        onOpen: this.handleOpen,
        onUnmount: this.handlePortalUnmount,
        trigger: h,
        triggerRef: this.triggerRef
      }), o.a.createElement(iv, {
        modifiers: M,
        placement: uv[s],
        strategy: u ? "fixed" : null,
        referenceElement: z
      }, this.renderContent));
    }, e;
  }(i.Component);

  Cv.handledProps = ["as", "basic", "children", "className", "content", "context", "disabled", "eventsEnabled", "flowing", "header", "hideOnScroll", "hoverable", "inverted", "offset", "on", "onClose", "onMount", "onOpen", "onUnmount", "pinned", "popper", "popperDependencies", "popperModifiers", "position", "positionFixed", "size", "style", "trigger", "wide"], Cv.propTypes = {}, Cv.defaultProps = {
    disabled: !1,
    eventsEnabled: !0,
    on: ["click", "hover"],
    pinned: !1,
    popperModifiers: [],
    position: "top left"
  }, Cv.Content = pv, Cv.Header = zv;
  var Lv = A.a.isFinite,
      Av = Math.min;

  var Nv = function (c) {
    var e = Math[c];
    return function (c, a) {
      if (c = Rn(c), (a = null == a ? 0 : Av(Wn(a), 292)) && Lv(c)) {
        var n = (Xc(c) + "e").split("e"),
            t = e(n[0] + "e" + (+n[1] + a));
        return +((n = (Xc(t) + "e").split("e"))[0] + "e" + (+n[1] - a));
      }

      return e(c);
    };
  }("round");

  var gv = function gv(c, e, a) {
    return c == c && (void 0 !== a && (c = c <= a ? c : a), void 0 !== e && (c = c >= e ? c : e)), c;
  };

  var Hv = function Hv(c, e, a) {
    return void 0 === a && (a = e, e = void 0), void 0 !== a && (a = (a = Rn(a)) == a ? a : 0), void 0 !== e && (e = (e = Rn(e)) == e ? e : 0), gv(Rn(c), e, a);
  },
      Vv = function (c) {
    function e() {
      for (var e, a = arguments.length, t = new Array(a), r = 0; r < a; r++) {
        t[r] = arguments[r];
      }

      return (e = c.call.apply(c, [this].concat(t)) || this).calculatePercent = function () {
        var c = e.props,
            a = c.percent,
            n = c.total,
            t = c.value;
        return Fr(a) ? Fr(n) || Fr(t) ? void 0 : t / n * 100 : a;
      }, e.computeValueText = function (c) {
        var a = e.props,
            n = a.progress,
            t = a.total,
            r = a.value;
        return "value" === n ? r : "ratio" === n ? r + "/" + t : c + "%";
      }, e.getPercent = function () {
        var c = e.props,
            a = c.precision,
            n = c.progress,
            t = c.total,
            r = c.value,
            i = Hv(e.calculatePercent(), 0, 100);
        return Fr(t) || Fr(r) || "value" !== n ? "value" === n ? r : Fr(a) ? i : Nv(i, a) : r / t * 100;
      }, e.isAutoSuccess = function () {
        var c = e.props,
            a = c.autoSuccess,
            n = c.percent,
            t = c.total,
            r = c.value;
        return a && (n >= 100 || r >= t);
      }, e.renderLabel = function () {
        var c = e.props,
            a = c.children,
            t = c.content,
            r = c.label;
        return n.isNil(a) ? n.isNil(t) ? kr(r, {
          autoGenerateKey: !1,
          defaultProps: {
            className: "label"
          }
        }) : o.a.createElement("div", {
          className: "label"
        }, t) : o.a.createElement("div", {
          className: "label"
        }, a);
      }, e.renderProgress = function (c) {
        var a = e.props,
            n = a.precision;
        if (a.progress || !Fr(n)) return o.a.createElement("div", {
          className: "progress"
        }, e.computeValueText(c));
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.active,
          n = c.attached,
          t = c.className,
          r = c.color,
          i = c.disabled,
          l = c.error,
          f = c.indicating,
          s = c.inverted,
          u = c.size,
          h = c.success,
          m = c.warning,
          v = Ie("ui", r, u, ur(a || f, "active"), ur(i, "disabled"), ur(l, "error"), ur(f, "indicating"), ur(s, "inverted"), ur(h || this.isAutoSuccess(), "success"), ur(m, "warning"), hr(n, "attached"), "progress", t),
          d = je(e, this.props),
          M = zr(e, this.props),
          z = this.getPercent() || 0;
      return o.a.createElement(M, Object(p.a)({}, d, {
        className: v,
        "data-percent": Math.floor(z)
      }), o.a.createElement("div", {
        className: "bar",
        style: {
          width: z + "%"
        }
      }, this.renderProgress(z)), this.renderLabel());
    }, e;
  }(i.Component);

  Vv.handledProps = ["active", "as", "attached", "autoSuccess", "children", "className", "color", "content", "disabled", "error", "indicating", "inverted", "label", "percent", "precision", "progress", "size", "success", "total", "value", "warning"], Vv.propTypes = {};
  var xv = Vv,
      wv = 9007199254740991,
      yv = 4294967295,
      bv = Math.min;

  var Sv = function Sv(c, e) {
    if ((c = Wn(c)) < 1 || c > wv) return [];
    var a = yv,
        n = bv(c, yv);
    e = Jr(e), c -= yv;

    for (var t = wa(n, e); ++a < c;) {
      e(a);
    }

    return t;
  },
      Tv = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleClick = function (c) {
        De(e.props, "onClick", c, e.props);
      }, e.handleKeyUp = function (c) {
        switch (De(e.props, "onKeyUp", c, e.props), oi.a.getCode(c)) {
          case oi.a.Enter:
          case oi.a.Spacebar:
            c.preventDefault(), De(e.props, "onClick", c, e.props);
        }
      }, e.handleMouseEnter = function (c) {
        De(e.props, "onMouseEnter", c, e.props);
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.active,
          n = c.className,
          t = c.selected,
          r = Ie(ur(a, "active"), ur(t, "selected"), "icon", n),
          i = je(e, this.props),
          l = zr(e, this.props);
      return o.a.createElement(l, Object(p.a)({}, i, {
        className: r,
        onClick: this.handleClick,
        onKeyUp: this.handleKeyUp,
        onMouseEnter: this.handleMouseEnter,
        role: "radio"
      }));
    }, e;
  }(i.Component);

  Tv.handledProps = ["active", "as", "className", "index", "onClick", "onKeyUp", "onMouseEnter", "selected"], Tv.propTypes = {}, Tv.defaultProps = {
    as: "i"
  };

  var Dv = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleIconClick = function (c, a) {
        var n = a.index,
            t = e.props,
            r = t.clearable,
            i = t.disabled,
            o = t.maxRating,
            l = t.onRate,
            f = e.state.rating;

        if (!i) {
          var s = n + 1;
          "auto" === r && 1 === o ? s = +!f : !0 === r && s === f && (s = 0), e.setState({
            rating: s,
            isSelecting: !1
          }), l && l(c, Object(p.a)({}, e.props, {
            rating: s
          }));
        }
      }, e.handleIconMouseEnter = function (c, a) {
        var n = a.index;
        e.props.disabled || e.setState({
          selectedIndex: n,
          isSelecting: !0
        });
      }, e.handleMouseLeave = function () {
        for (var c = arguments.length, a = new Array(c), n = 0; n < c; n++) {
          a[n] = arguments[n];
        }

        De.apply(void 0, [e.props, "onMouseLeave"].concat(a)), e.props.disabled || e.setState({
          selectedIndex: -1,
          isSelecting: !1
        });
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this,
          a = this.props,
          n = a.className,
          t = a.disabled,
          r = a.icon,
          i = a.maxRating,
          l = a.size,
          f = this.state,
          s = f.rating,
          u = f.selectedIndex,
          h = f.isSelecting,
          m = Ie("ui", r, l, ur(t, "disabled"), ur(h && !t && u >= 0, "selected"), "rating", n),
          v = je(e, this.props),
          d = zr(e, this.props);
      return o.a.createElement(d, Object(p.a)({}, v, {
        className: m,
        role: "radiogroup",
        onMouseLeave: this.handleMouseLeave,
        tabIndex: t ? 0 : -1
      }), Sv(i, function (e) {
        return o.a.createElement(Tv, {
          tabIndex: t ? -1 : 0,
          active: s >= e + 1,
          "aria-checked": s === e + 1,
          "aria-posinset": e + 1,
          "aria-setsize": i,
          index: e,
          key: e,
          onClick: c.handleIconClick,
          onMouseEnter: c.handleIconMouseEnter,
          selected: u >= e && h
        });
      }));
    }, e;
  }(Mi);

  Dv.handledProps = ["as", "className", "clearable", "defaultRating", "disabled", "icon", "maxRating", "onRate", "rating", "size"], Dv.propTypes = {}, Dv.autoControlledProps = ["rating"], Dv.defaultProps = {
    clearable: "auto",
    maxRating: 1
  }, Dv.Icon = Tv;

  var jv = _a && new _a(),
      Ev = jv ? function (c, e) {
    return jv.set(c, e), c;
  } : Le,
      kv = Object.create,
      Iv = function () {
    function c() {}

    return function (e) {
      if (!U(e)) return {};
      if (kv) return kv(e);
      c.prototype = e;
      var a = new c();
      return c.prototype = void 0, a;
    };
  }();

  var Ov = function Ov(c) {
    return function () {
      var e = arguments;

      switch (e.length) {
        case 0:
          return new c();

        case 1:
          return new c(e[0]);

        case 2:
          return new c(e[0], e[1]);

        case 3:
          return new c(e[0], e[1], e[2]);

        case 4:
          return new c(e[0], e[1], e[2], e[3]);

        case 5:
          return new c(e[0], e[1], e[2], e[3], e[4]);

        case 6:
          return new c(e[0], e[1], e[2], e[3], e[4], e[5]);

        case 7:
          return new c(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
      }

      var a = Iv(c.prototype),
          n = c.apply(a, e);
      return U(n) ? n : a;
    };
  },
      Qv = 1;

  var Zv = function Zv(c, e, a) {
    var n = e & Qv,
        t = Ov(c);
    return function e() {
      return (this && this !== A.a && this instanceof e ? t : c).apply(n ? a : this, arguments);
    };
  },
      Uv = Math.max;

  var Bv = function Bv(c, e, a, n) {
    for (var t = -1, r = c.length, i = a.length, o = -1, l = e.length, f = Uv(r - i, 0), s = Array(l + f), u = !n; ++o < l;) {
      s[o] = e[o];
    }

    for (; ++t < i;) {
      (u || t < r) && (s[a[t]] = c[t]);
    }

    for (; f--;) {
      s[o++] = c[t++];
    }

    return s;
  },
      Rv = Math.max;

  var Yv = function Yv(c, e, a, n) {
    for (var t = -1, r = c.length, i = -1, o = a.length, l = -1, f = e.length, s = Rv(r - o, 0), u = Array(s + f), h = !n; ++t < s;) {
      u[t] = c[t];
    }

    for (var m = t; ++l < f;) {
      u[m + l] = e[l];
    }

    for (; ++i < o;) {
      (h || t < r) && (u[m + a[i]] = c[t++]);
    }

    return u;
  };

  var Pv = function Pv(c, e) {
    for (var a = c.length, n = 0; a--;) {
      c[a] === e && ++n;
    }

    return n;
  };

  var Fv = function Fv() {},
      Wv = 4294967295;

  function Gv(c) {
    this.__wrapped__ = c, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Wv, this.__views__ = [];
  }

  Gv.prototype = Iv(Fv.prototype), Gv.prototype.constructor = Gv;
  var qv = Gv,
      Jv = jv ? function (c) {
    return jv.get(c);
  } : st,
      Kv = {},
      Xv = Object.prototype.hasOwnProperty;

  var _v = function _v(c) {
    for (var e = c.name + "", a = Kv[e], n = Xv.call(Kv, e) ? a.length : 0; n--;) {
      var t = a[n],
          r = t.func;
      if (null == r || r == c) return t.name;
    }

    return e;
  };

  function $v(c, e) {
    this.__wrapped__ = c, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = void 0;
  }

  $v.prototype = Iv(Fv.prototype), $v.prototype.constructor = $v;
  var cd = $v;

  var ed = function ed(c, e) {
    var a = -1,
        n = c.length;

    for (e || (e = Array(n)); ++a < n;) {
      e[a] = c[a];
    }

    return e;
  };

  var ad = function ad(c) {
    if (c instanceof qv) return c.clone();
    var e = new cd(c.__wrapped__, c.__chain__);
    return e.__actions__ = ed(c.__actions__), e.__index__ = c.__index__, e.__values__ = c.__values__, e;
  },
      nd = Object.prototype.hasOwnProperty;

  function td(c) {
    if (E(c) && !L(c) && !(c instanceof qv)) {
      if (c instanceof cd) return c;
      if (nd.call(c, "__wrapped__")) return ad(c);
    }

    return new cd(c);
  }

  td.prototype = Fv.prototype, td.prototype.constructor = td;
  var rd = td;

  var id = function id(c) {
    var e = _v(c),
        a = rd[e];

    if ("function" != typeof a || !(e in qv.prototype)) return !1;
    if (c === a) return !0;
    var n = Jv(a);
    return !!n && c === n[0];
  },
      od = be(Ev),
      ld = /\{\n\/\* \[wrapped with (.+)\] \*/,
      fd = /,? & /;

  var sd = function sd(c) {
    var e = c.match(ld);
    return e ? e[1].split(fd) : [];
  },
      ud = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

  var hd = function hd(c, e) {
    var a = e.length;
    if (!a) return c;
    var n = a - 1;
    return e[n] = (a > 1 ? "& " : "") + e[n], e = e.join(a > 2 ? ", " : " "), c.replace(ud, "{\n/* [wrapped with " + e + "] */\n");
  },
      md = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]];

  var vd = function vd(c, e) {
    return qr(md, function (a) {
      var n = "_." + a[0];
      e & a[1] && !lt(c, n) && c.push(n);
    }), c.sort();
  };

  var dd = function dd(c, e, a) {
    var n = e + "";
    return Se(c, hd(n, vd(sd(n), a)));
  },
      Md = 1,
      pd = 2,
      zd = 4,
      Cd = 8,
      Ld = 32,
      Ad = 64;

  var Nd = function Nd(c, e, a, n, t, r, i, o, l, f) {
    var s = e & Cd;
    e |= s ? Ld : Ad, (e &= ~(s ? Ad : Ld)) & zd || (e &= ~(Md | pd));
    var u = [c, e, t, s ? r : void 0, s ? i : void 0, s ? void 0 : r, s ? void 0 : i, o, l, f],
        h = a.apply(void 0, u);
    return id(c) && od(h, u), h.placeholder = n, dd(h, c, e);
  };

  var gd = function gd(c) {
    return c.placeholder;
  },
      Hd = Math.min;

  var Vd = function Vd(c, e) {
    for (var a = c.length, n = Hd(e.length, a), t = ed(c); n--;) {
      var r = e[n];
      c[n] = oe(r, a) ? t[r] : void 0;
    }

    return c;
  },
      xd = "__lodash_placeholder__";

  var wd = function wd(c, e) {
    for (var a = -1, n = c.length, t = 0, r = []; ++a < n;) {
      var i = c[a];
      i !== e && i !== xd || (c[a] = xd, r[t++] = a);
    }

    return r;
  },
      yd = 1,
      bd = 2,
      Sd = 8,
      Td = 16,
      Dd = 128,
      jd = 512;

  var Ed = function c(e, a, n, t, r, i, o, l, f, s) {
    var u = a & Dd,
        h = a & yd,
        m = a & bd,
        v = a & (Sd | Td),
        d = a & jd,
        M = m ? void 0 : Ov(e);
    return function p() {
      for (var z = arguments.length, C = Array(z), L = z; L--;) {
        C[L] = arguments[L];
      }

      if (v) var N = gd(p),
          g = Pv(C, N);

      if (t && (C = Bv(C, t, r, v)), i && (C = Yv(C, i, o, v)), z -= g, v && z < s) {
        var H = wd(C, N);
        return Nd(e, a, c, p.placeholder, n, C, H, l, f, s - z);
      }

      var V = h ? n : this,
          x = m ? V[e] : e;
      return z = C.length, l ? C = Vd(C, l) : d && z > 1 && C.reverse(), u && f < z && (C.length = f), this && this !== A.a && this instanceof p && (x = M || Ov(x)), x.apply(V, C);
    };
  };

  var kd = function kd(c, e, a) {
    var n = Ov(c);
    return function t() {
      for (var r = arguments.length, i = Array(r), o = r, l = gd(t); o--;) {
        i[o] = arguments[o];
      }

      var f = r < 3 && i[0] !== l && i[r - 1] !== l ? [] : wd(i, l);
      if ((r -= f.length) < a) return Nd(c, e, Ed, t.placeholder, void 0, i, f, void 0, void 0, a - r);
      var s = this && this !== A.a && this instanceof t ? n : c;
      return ve(s, this, i);
    };
  },
      Id = 1;

  var Od = function Od(c, e, a, n) {
    var t = e & Id,
        r = Ov(c);
    return function e() {
      for (var i = -1, o = arguments.length, l = -1, f = n.length, s = Array(f + o), u = this && this !== A.a && this instanceof e ? r : c; ++l < f;) {
        s[l] = n[l];
      }

      for (; o--;) {
        s[l++] = arguments[++i];
      }

      return ve(u, t ? a : this, s);
    };
  },
      Qd = "__lodash_placeholder__",
      Zd = 1,
      Ud = 2,
      Bd = 4,
      Rd = 8,
      Yd = 128,
      Pd = 256,
      Fd = Math.min;

  var Wd = function Wd(c, e) {
    var a = c[1],
        n = e[1],
        t = a | n,
        r = t < (Zd | Ud | Yd),
        i = n == Yd && a == Rd || n == Yd && a == Pd && c[7].length <= e[8] || n == (Yd | Pd) && e[7].length <= e[8] && a == Rd;
    if (!r && !i) return c;
    n & Zd && (c[2] = e[2], t |= a & Zd ? 0 : Bd);
    var o = e[3];

    if (o) {
      var l = c[3];
      c[3] = l ? Bv(l, o, e[4]) : o, c[4] = l ? wd(c[3], Qd) : e[4];
    }

    return (o = e[5]) && (l = c[5], c[5] = l ? Yv(l, o, e[6]) : o, c[6] = l ? wd(c[5], Qd) : e[6]), (o = e[7]) && (c[7] = o), n & Yd && (c[8] = null == c[8] ? e[8] : Fd(c[8], e[8])), null == c[9] && (c[9] = e[9]), c[0] = e[0], c[1] = t, c;
  },
      Gd = "Expected a function",
      qd = 1,
      Jd = 2,
      Kd = 8,
      Xd = 16,
      _d = 32,
      $d = 64,
      cM = Math.max;

  var eM = function eM(c, e, a, n, t, r, i, o) {
    var l = e & Jd;
    if (!l && "function" != typeof c) throw new TypeError(Gd);
    var f = n ? n.length : 0;

    if (f || (e &= ~(_d | $d), n = t = void 0), i = void 0 === i ? i : cM(Wn(i), 0), o = void 0 === o ? o : Wn(o), f -= t ? t.length : 0, e & $d) {
      var s = n,
          u = t;
      n = t = void 0;
    }

    var h = l ? void 0 : Jv(c),
        m = [c, e, a, n, t, s, u, r, i, o];
    if (h && Wd(m, h), c = m[0], e = m[1], a = m[2], n = m[3], t = m[4], !(o = m[9] = void 0 === m[9] ? l ? 0 : c.length : cM(m[9] - f, 0)) && e & (Kd | Xd) && (e &= ~(Kd | Xd)), e && e != qd) v = e == Kd || e == Xd ? kd(c, e, o) : e != _d && e != (qd | _d) || t.length ? Ed.apply(void 0, m) : Od(c, e, a, n);else var v = Zv(c, e, a);
    return dd((h ? Ev : od)(v, m), c, e);
  },
      aM = Te(function (c, e) {
    var a = wd(e, gd(aM));
    return eM(c, 64, void 0, e, a);
  });

  aM.placeholder = {};
  var nM = aM;

  function tM(c) {
    var e = c.categoryContent,
        a = c.resultsContent;
    return o.a.createElement(o.a.Fragment, null, o.a.createElement("div", {
      className: "name"
    }, e), o.a.createElement("div", {
      className: "results"
    }, a));
  }

  tM.handledProps = ["categoryContent", "resultsContent"], tM.propTypes = {};
  var rM = tM;

  function iM(c) {
    var e = c.active,
        a = c.children,
        t = c.className,
        r = c.content,
        i = c.layoutRenderer,
        l = c.renderer,
        f = Ie(ur(e, "active"), "category", t),
        s = je(iM, c),
        u = zr(iM, c),
        h = l(c),
        m = n.isNil(a) ? r : a;
    return o.a.createElement(u, Object(p.a)({}, s, {
      className: f
    }), i({
      categoryContent: h,
      resultsContent: m
    }));
  }

  iM.handledProps = ["active", "as", "children", "className", "content", "layoutRenderer", "name", "renderer", "results"], iM.defaultProps = {
    layoutRenderer: rM,
    renderer: function renderer(c) {
      return c.name;
    }
  }, iM.propTypes = {};

  var oM = iM,
      lM = function lM(c) {
    var e = c.image,
        a = c.price,
        n = c.title,
        t = c.description;
    return [e && o.a.createElement("div", {
      key: "image",
      className: "image"
    }, Or(e, {
      autoGenerateKey: !1
    })), o.a.createElement("div", {
      key: "content",
      className: "content"
    }, a && o.a.createElement("div", {
      className: "price"
    }, a), n && o.a.createElement("div", {
      className: "title"
    }, n), t && o.a.createElement("div", {
      className: "description"
    }, t))];
  };

  lM.handledProps = [];

  var fM = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleClick = function (c) {
        var a = e.props.onClick;
        a && a(c, e.props);
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.active,
          n = c.className,
          t = c.renderer,
          r = Ie(ur(a, "active"), "result", n),
          i = je(e, this.props),
          l = zr(e, this.props);
      return o.a.createElement(l, Object(p.a)({}, i, {
        className: r,
        onClick: this.handleClick
      }), t(this.props));
    }, e;
  }(i.Component);

  function sM(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("results transition", a),
        i = je(sM, c),
        l = zr(sM, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  fM.handledProps = ["active", "as", "className", "content", "description", "id", "image", "onClick", "price", "renderer", "title"], fM.propTypes = {}, fM.defaultProps = {
    renderer: lM
  }, sM.handledProps = ["as", "children", "className", "content"], sM.propTypes = {};

  var uM = sM,
      hM = function hM(c) {
    var e = c.input;
    return Fr(e) ? Object(p.a)({}, c, {
      input: {
        className: "prompt"
      }
    }) : xr(e) ? Object(p.a)({}, c, {
      input: Object(p.a)({}, e, {
        className: Ie(e.className, "prompt")
      })
    }) : c;
  },
      mM = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleResultSelect = function (c, a) {
        De(e.props, "onResultSelect", c, Object(p.a)({}, e.props, {
          result: a
        }));
      }, e.handleSelectionChange = function (c) {
        var a = e.getSelectedResult();
        De(e.props, "onSelectionChange", c, Object(p.a)({}, e.props, {
          result: a
        }));
      }, e.closeOnEscape = function (c) {
        oi.a.getCode(c) === oi.a.Escape && (c.preventDefault(), e.close());
      }, e.moveSelectionOnKeyDown = function (c) {
        switch (oi.a.getCode(c)) {
          case oi.a.ArrowDown:
            c.preventDefault(), e.moveSelectionBy(c, 1);
            break;

          case oi.a.ArrowUp:
            c.preventDefault(), e.moveSelectionBy(c, -1);
        }
      }, e.selectItemOnEnter = function (c) {
        if (oi.a.getCode(c) === oi.a.Enter) {
          var a = e.getSelectedResult();
          a && (c.preventDefault(), e.setValue(a.title), e.handleResultSelect(c, a), e.close());
        }
      }, e.closeOnDocumentClick = function (c) {
        e.close();
      }, e.handleMouseDown = function (c) {
        e.isMouseDown = !0, De(e.props, "onMouseDown", c, e.props), so.sub("mouseup", e.handleDocumentMouseUp);
      }, e.handleDocumentMouseUp = function () {
        e.isMouseDown = !1, so.unsub("mouseup", e.handleDocumentMouseUp);
      }, e.handleInputClick = function (c) {
        c.nativeEvent.stopImmediatePropagation(), e.tryOpen();
      }, e.handleItemClick = function (c, a) {
        var n = a.id,
            t = e.getSelectedResult(n);
        c.nativeEvent.stopImmediatePropagation(), e.setValue(t.title), e.handleResultSelect(c, t), e.close();
      }, e.handleItemMouseDown = function (c) {
        c.preventDefault();
      }, e.handleFocus = function (c) {
        De(e.props, "onFocus", c, e.props), e.setState({
          focus: !0
        });
      }, e.handleBlur = function (c) {
        De(e.props, "onBlur", c, e.props), e.setState({
          focus: !1
        });
      }, e.handleSearchChange = function (c) {
        c.stopPropagation();
        var a = e.props.minCharacters,
            n = e.state.open,
            t = c.target.value;
        De(e.props, "onSearchChange", c, Object(p.a)({}, e.props, {
          value: t
        })), t.length < a ? e.close() : n || e.tryOpen(t), e.setValue(t);
      }, e.getFlattenedResults = function () {
        var c = e.props,
            a = c.category,
            n = c.results;
        return a ? no(n, function (c, e) {
          return c.concat(e.results);
        }, []) : n;
      }, e.getSelectedResult = function (c) {
        void 0 === c && (c = e.state.selectedIndex);
        var a = e.getFlattenedResults();
        return An(a, c);
      }, e.setValue = function (c) {
        var a = e.props.selectFirstResult;
        e.setState({
          value: c,
          selectedIndex: a ? 0 : -1
        });
      }, e.moveSelectionBy = function (c, a) {
        var n = e.state.selectedIndex,
            t = e.getFlattenedResults().length - 1,
            r = n + a;
        r > t ? r = 0 : r < 0 && (r = t), e.setState({
          selectedIndex: r
        }), e.scrollSelectedItemIntoView(), e.handleSelectionChange(c);
      }, e.scrollSelectedItemIntoView = function () {
        if (ni()) {
          var c = document.querySelector(".ui.search.active.visible .results.visible");

          if (c) {
            var e = c.querySelector(".result.active");

            if (e) {
              var a = e.offsetTop < c.scrollTop,
                  n = e.offsetTop + e.clientHeight > c.scrollTop + c.clientHeight;
              a ? c.scrollTop = e.offsetTop : n && (c.scrollTop = e.offsetTop + e.clientHeight - c.clientHeight);
            }
          }
        }
      }, e.tryOpen = function (c) {
        void 0 === c && (c = e.state.value);
        var a = e.props.minCharacters;
        c.length < a || e.open();
      }, e.open = function () {
        e.setState({
          open: !0
        });
      }, e.close = function () {
        e.setState({
          open: !1
        });
      }, e.renderSearchInput = function (c) {
        var a = e.props,
            n = a.icon,
            t = a.input,
            r = a.placeholder,
            i = e.state.value;
        return Os.create(t, {
          autoGenerateKey: !1,
          defaultProps: Object(p.a)({}, c, {
            autoComplete: "off",
            icon: n,
            onChange: e.handleSearchChange,
            onClick: e.handleInputClick,
            tabIndex: "0",
            value: i,
            placeholder: r
          }),
          overrideProps: hM
        });
      }, e.renderNoResults = function () {
        var c = e.props,
            a = c.noResultsDescription,
            n = c.noResultsMessage;
        return o.a.createElement("div", {
          className: "message empty"
        }, o.a.createElement("div", {
          className: "header"
        }, n), a && o.a.createElement("div", {
          className: "description"
        }, a));
      }, e.renderResult = function (c, a, n, t) {
        var i = c.childKey,
            l = Object(r.a)(c, ["childKey"]);
        void 0 === t && (t = 0);
        var f = e.props.resultRenderer,
            s = e.state.selectedIndex,
            u = a + t;
        return o.a.createElement(fM, Object(p.a)({
          key: null != i ? i : l.id || l.title,
          active: s === u,
          onClick: e.handleItemClick,
          onMouseDown: e.handleItemMouseDown,
          renderer: f
        }, l, {
          id: u
        }));
      }, e.renderResults = function () {
        var c = e.props.results;
        return Oi(c, e.renderResult);
      }, e.renderCategories = function () {
        var c = e.props,
            a = c.categoryLayoutRenderer,
            n = c.categoryRenderer,
            t = c.results,
            i = e.state.selectedIndex,
            l = 0;
        return Oi(t, function (c) {
          var t = c.childKey,
              f = Object(r.a)(c, ["childKey"]),
              s = Object(p.a)({
            key: null != t ? t : f.name,
            active: ui(i, l, l + f.results.length),
            layoutRenderer: a,
            renderer: n
          }, f),
              u = nM(e.renderResult, l);
          return l += f.results.length, o.a.createElement(oM, s, f.results.map(u));
        });
      }, e.renderMenuContent = function () {
        var c = e.props,
            a = c.category,
            n = c.showNoResults,
            t = c.results;
        return oo(t) ? n ? e.renderNoResults() : null : a ? e.renderCategories() : e.renderResults();
      }, e.renderResultsMenu = function () {
        var c = e.state.open ? "visible" : "",
            a = e.renderMenuContent();
        if (a) return o.a.createElement(uM, {
          className: c
        }, a);
      }, e;
    }

    Object(f.a)(e, c), e.getAutoControlledStateFromProps = function (c, e) {
      if (void 0 !== e.prevValue && fo()(e.prevValue, e.value)) return {
        prevValue: e.value
      };
      var a = c.selectFirstResult ? 0 : -1;
      return {
        prevValue: e.value,
        selectedIndex: a
      };
    };
    var a = e.prototype;
    return a.shouldComponentUpdate = function (c, e) {
      return !fo()(c, this.props) || !fo()(e, this.state);
    }, a.componentDidUpdate = function (c, e) {
      !e.focus && this.state.focus ? (this.isMouseDown || this.tryOpen(), this.state.open && so.sub("keydown", [this.moveSelectionOnKeyDown, this.selectItemOnEnter])) : e.focus && !this.state.focus && (this.isMouseDown || this.close(), so.unsub("keydown", [this.moveSelectionOnKeyDown, this.selectItemOnEnter])), !e.open && this.state.open ? (this.open(), so.sub("click", this.closeOnDocumentClick), so.sub("keydown", [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter])) : e.open && !this.state.open && (this.close(), so.unsub("click", this.closeOnDocumentClick), so.unsub("keydown", [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]));
    }, a.componentWillUnmount = function () {
      so.unsub("click", this.closeOnDocumentClick), so.unsub("keydown", [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
    }, a.render = function () {
      var c = this.state,
          a = c.searchClasses,
          n = c.focus,
          t = c.open,
          r = this.props,
          i = r.aligned,
          l = r.category,
          f = r.className,
          s = r.fluid,
          u = r.loading,
          h = r.size,
          m = Ie("ui", t && "active visible", h, a, ur(l, "category"), ur(n, "focus"), ur(s, "fluid"), ur(u, "loading"), hr(i, "aligned"), "search", f),
          v = je(e, this.props),
          d = zr(e, this.props),
          M = ci(v, {
        htmlProps: Xr
      }),
          z = M[0],
          C = M[1];
      return o.a.createElement(d, Object(p.a)({}, C, {
        className: m,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onMouseDown: this.handleMouseDown
      }), this.renderSearchInput(z), this.renderResultsMenu());
    }, e;
  }(Mi);

  mM.handledProps = ["aligned", "as", "category", "categoryLayoutRenderer", "categoryRenderer", "className", "defaultOpen", "defaultValue", "fluid", "icon", "input", "loading", "minCharacters", "noResultsDescription", "noResultsMessage", "onBlur", "onFocus", "onMouseDown", "onResultSelect", "onSearchChange", "onSelectionChange", "open", "placeholder", "resultRenderer", "results", "selectFirstResult", "showNoResults", "size", "value"], mM.propTypes = {}, mM.defaultProps = {
    icon: "search",
    input: "text",
    minCharacters: 1,
    noResultsMessage: "No results found.",
    showNoResults: !0
  }, mM.autoControlledProps = ["open", "value"], mM.Category = oM, mM.Result = fM, mM.Results = uM;

  var vM = function vM(c, e) {
    return !!c && !!c[e];
  },
      dM = function dM(c) {
    var e = c.capture,
        a = c.listener,
        n = c.type,
        t = c.target,
        r = c.targetRef,
        o = i.useRef(a);
    o.current = a;
    var l = i.useCallback(function (c) {
      return o.current(c);
    }, []),
        f = i.useRef(void 0);
    i.useEffect(function () {
      var c = void 0 === r ? t : r.current,
          a = function (c) {
        var e, a, n;
        if (c) return "object" == typeof c.window && c.window === c ? c.event : null != (e = null == (a = c.ownerDocument) ? void 0 : null == (n = a.defaultView) ? void 0 : n.event) ? e : void 0;
      }(window),
          i = function i(c) {
        c !== a ? l(c) : a = void 0;
      };

      return vM(c, "addEventListener") && c.addEventListener(n, i, e), f.current = setTimeout(function () {
        a = void 0;
      }, 1), function () {
        clearTimeout(f.current), a = void 0, vM(c, "removeEventListener") && c.removeEventListener(n, i, e);
      };
    }, [e, l, t, r, n]);
  },
      MM = function () {
    function c(c) {
      return dM(c), null;
    }

    return c.defaultProps = {
      capture: !1
    }, c;
  }(),
      pM = {
    current: "undefined" == typeof document ? null : document
  };

  "undefined" == typeof window || window;

  function zM(c) {
    var e = c.className,
        a = c.children,
        t = c.content,
        r = Ie("pushable", e),
        i = je(zM, c),
        l = zr(zM, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(a) ? t : a);
  }

  zM.handledProps = ["as", "children", "className", "content"], zM.propTypes = {};
  var CM = zM;

  function LM(c) {
    var e = c.className,
        a = c.dimmed,
        t = c.children,
        r = c.content,
        i = Ie("pusher", ur(a, "dimmed"), e),
        l = je(LM, c),
        f = zr(LM, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(t) ? r : t);
  }

  LM.handledProps = ["as", "children", "className", "content", "dimmed"], LM.propTypes = {};

  var AM = LM,
      NM = function (c) {
    function e(a) {
      var n;
      return (n = c.call(this, a) || this).ref = Object(i.createRef)(), n.handleAnimationStart = function () {
        var c = n.props.visible ? "onVisible" : "onHide";
        clearTimeout(n.animationTimer), n.animationTimer = setTimeout(n.handleAnimationEnd, e.animationDuration), n.skipNextCallback ? n.skipNextCallback = !1 : De(n.props, c, null, n.props);
      }, n.handleAnimationEnd = function () {
        var c = n.props.visible ? "onShow" : "onHidden";
        n.setState({
          animationTick: 0
        }), De(n.props, c, null, n.props);
      }, n.handleDocumentClick = function (c) {
        mi(n.ref.current, c) || (n.skipNextCallback = !0, De(n.props, "onHide", c, Object(p.a)({}, n.props, {
          visible: !1
        })));
      }, n.state = {
        animationTick: 0,
        visible: a.visible
      }, n;
    }

    Object(f.a)(e, c), e.getDerivedStateFromProps = function (c, e) {
      var a = !!c.visible == !!e.visible ? 0 : 1;
      return {
        animationTick: e.animationTick + a,
        visible: c.visible
      };
    };
    var a = e.prototype;
    return a.componentDidUpdate = function (c, e) {
      this.state.animationTick > e.animationTick && this.handleAnimationStart();
    }, a.componentWillUnmount = function () {
      clearTimeout(this.animationTimer);
    }, a.render = function () {
      var c = this.props,
          a = c.animation,
          t = c.className,
          r = c.children,
          i = c.content,
          l = c.direction,
          f = c.target,
          s = c.visible,
          u = c.width,
          m = this.state.animationTick,
          v = Ie("ui", a, l, u, ur(m > 0, "animating"), ur(s, "visible"), "sidebar", t),
          d = je(e, this.props),
          z = zr(e, this.props),
          C = h(f) ? {
        targetRef: f
      } : {
        target: f
      };
      return o.a.createElement(o.a.Fragment, null, o.a.createElement(M, {
        innerRef: this.ref
      }, o.a.createElement(z, Object(p.a)({}, d, {
        className: v
      }), n.isNil(r) ? i : r)), s && o.a.createElement(MM, Object(p.a)({
        listener: this.handleDocumentClick,
        type: "click"
      }, C)));
    }, e;
  }(i.Component);

  NM.handledProps = ["animation", "as", "children", "className", "content", "direction", "onHidden", "onHide", "onShow", "onVisible", "target", "visible", "width"], NM.propTypes = {}, NM.defaultProps = {
    direction: "left",
    target: pM,
    visible: !1
  }, NM.animationDuration = 500, NM.autoControlledProps = ["visible"], NM.Pushable = CM, NM.Pusher = AM;

  var gM = NM,
      HM = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).state = {
        active: !0,
        sticky: !1
      }, e.stickyRef = Object(i.createRef)(), e.triggerRef = Object(i.createRef)(), e.addListeners = function (c) {
        var a = h(c) ? c.current : c;
        a && (so.sub("resize", e.handleUpdate, {
          target: a
        }), so.sub("scroll", e.handleUpdate, {
          target: a
        }));
      }, e.removeListeners = function (c) {
        var a = h(c) ? c.current : c;
        a && (so.unsub("resize", e.handleUpdate, {
          target: a
        }), so.unsub("scroll", e.handleUpdate, {
          target: a
        }));
      }, e.update = function (c) {
        var a = e.state.pushing;
        if (e.ticking = !1, e.assignRects(), a) return e.didReachStartingPoint() ? e.stickToContextTop(c) : e.didTouchScreenBottom() ? e.stickToScreenBottom(c) : e.stickToContextBottom(c);

        if (e.isOversized()) {
          if (e.contextRect.top > 0) return e.stickToContextTop(c);
          if (e.contextRect.bottom < window.innerHeight) return e.stickToContextBottom(c);
        }

        return e.didTouchScreenTop() ? e.didReachContextBottom() ? e.stickToContextBottom(c) : e.stickToScreenTop(c) : e.stickToContextTop(c);
      }, e.handleUpdate = function (c) {
        e.ticking || (e.ticking = !0, e.frameId = requestAnimationFrame(function () {
          return e.update(c);
        }));
      }, e.assignRects = function () {
        var c = e.props.context,
            a = h(c) ? c.current : c || document.body;
        e.triggerRect = e.triggerRef.current.getBoundingClientRect(), e.contextRect = a.getBoundingClientRect(), e.stickyRect = e.stickyRef.current.getBoundingClientRect();
      }, e.didReachContextBottom = function () {
        var c = e.props.offset;
        return e.stickyRect.height + c >= e.contextRect.bottom;
      }, e.didReachStartingPoint = function () {
        return e.stickyRect.top <= e.triggerRect.top;
      }, e.didTouchScreenTop = function () {
        return e.triggerRect.top < e.props.offset;
      }, e.didTouchScreenBottom = function () {
        var c = e.props.bottomOffset;
        return e.contextRect.bottom + c > window.innerHeight;
      }, e.isOversized = function () {
        return e.stickyRect.height > window.innerHeight;
      }, e.pushing = function (c) {
        e.props.pushing && e.setState({
          pushing: c
        });
      }, e.stick = function (c, a) {
        e.setState({
          bound: a,
          sticky: !0
        }), De(e.props, "onStick", c, e.props);
      }, e.unstick = function (c, a) {
        e.setState({
          bound: a,
          sticky: !1
        }), De(e.props, "onUnstick", c, e.props);
      }, e.stickToContextBottom = function (c) {
        De(e.props, "onBottom", c, e.props), e.stick(c, !0), e.pushing(!0);
      }, e.stickToContextTop = function (c) {
        De(e.props, "onTop", c, e.props), e.unstick(c, !1), e.pushing(!1);
      }, e.stickToScreenBottom = function (c) {
        var a = e.props.bottomOffset;
        e.stick(c, !1), e.setState({
          bottom: a,
          top: null
        });
      }, e.stickToScreenTop = function (c) {
        var a = e.props.offset;
        e.stick(c, !1), e.setState({
          top: a,
          bottom: null
        });
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.componentDidMount = function () {
      ni() && this.state.active && (this.handleUpdate(), this.addListeners(this.props.scrollContext));
    }, e.getDerivedStateFromProps = function (c, e) {
      return e.active === c.active || c.active ? {
        active: c.active
      } : {
        active: c.active,
        sticky: !1
      };
    }, a.componentDidUpdate = function (c, e) {
      if (e.active !== this.state.active) return this.state.active ? (this.handleUpdate(), void this.addListeners(this.props.scrollContext)) : void this.removeListeners(c.scrollContext);
      c.scrollContext !== this.props.scrollContext && (this.removeListeners(c.scrollContext), this.addListeners(this.props.scrollContext));
    }, a.componentWillUnmount = function () {
      ni() && this.state.active && (this.removeListeners(this.props.scrollContext), cancelAnimationFrame(this.frameId));
    }, a.computeStyle = function () {
      var c = this.props.styleElement,
          e = this.state,
          a = e.bottom,
          n = e.bound,
          t = e.sticky,
          r = e.top;
      return t ? Object(p.a)({
        bottom: n ? 0 : a,
        top: n ? void 0 : r,
        width: this.triggerRect.width
      }, c) : c;
    }, a.render = function () {
      var c = this.props,
          a = c.children,
          n = c.className,
          t = this.state,
          r = t.bottom,
          i = t.bound,
          l = t.sticky,
          f = je(e, this.props),
          s = zr(e, this.props),
          u = Ie(l && "ui", l && "stuck-container", l && (i ? "bound-container" : "fixed-container"), n),
          h = Ie("ui", l && (i ? "bound bottom" : "fixed"), l && !i && (null === r ? "top" : "bottom"), "sticky"),
          m = l && this.stickyRect ? {
        height: this.stickyRect.height
      } : {};
      return o.a.createElement(s, Object(p.a)({}, f, {
        className: u
      }), o.a.createElement("div", {
        ref: this.triggerRef,
        style: m
      }), o.a.createElement("div", {
        className: h,
        ref: this.stickyRef,
        style: this.computeStyle()
      }, a));
    }, e;
  }(i.Component);

  function VM(c) {
    var e = c.active,
        a = c.children,
        t = c.className,
        r = c.content,
        i = c.loading,
        l = Ie(ur(e, "active"), ur(i, "loading"), "tab", t),
        f = je(VM, c),
        s = zr(VM, c),
        u = {};
    return s === Mh && (u.attached = "bottom"), o.a.createElement(s, Object(p.a)({}, u, f, {
      className: l
    }), n.isNil(a) ? r : a);
  }

  HM.handledProps = ["active", "as", "bottomOffset", "children", "className", "context", "offset", "onBottom", "onStick", "onTop", "onUnstick", "pushing", "scrollContext", "styleElement"], HM.propTypes = {}, HM.defaultProps = {
    active: !0,
    bottomOffset: 0,
    offset: 0,
    scrollContext: ni() ? window : null
  }, VM.handledProps = ["active", "as", "children", "className", "content", "loading"], VM.defaultProps = {
    as: Mh,
    active: !0
  }, VM.propTypes = {}, VM.create = Er(VM, function (c) {
    return {
      content: c
    };
  });

  var xM = VM,
      wM = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleItemClick = function (c, a) {
        var n = a.index;
        De(e.props, "onTabChange", c, Object(p.a)({}, e.props, {
          activeIndex: n
        })), e.setState({
          activeIndex: n
        });
      }, e;
    }

    Object(f.a)(e, c);
    var a = e.prototype;
    return a.getInitialAutoControlledState = function () {
      return {
        activeIndex: 0
      };
    }, a.renderItems = function () {
      var c = this.props,
          e = c.panes,
          a = c.renderActiveOnly,
          n = this.state.activeIndex;
      return a ? De(An(e, "[" + n + "]"), "render", this.props) : Oi(e, function (c, e) {
        var a = c.pane;
        return xM.create(a, {
          overrideProps: {
            active: e === n
          }
        });
      });
    }, a.renderMenu = function () {
      var c = this.props,
          e = c.menu,
          a = c.panes,
          n = c.menuPosition,
          t = this.state.activeIndex;
      return !0 === e.tabular && "right" === n && (e.tabular = "right"), Bl.create(e, {
        autoGenerateKey: !1,
        overrideProps: {
          items: Oi(a, "menuItem"),
          onItemClick: this.handleItemClick,
          activeIndex: t
        }
      });
    }, a.renderVertical = function (c) {
      var e = this.props,
          a = e.grid,
          n = e.menuPosition,
          t = a.paneWidth,
          i = a.tabWidth,
          l = Object(r.a)(a, ["paneWidth", "tabWidth"]),
          f = n || "right" === c.props.tabular && "right" || "left";
      return o.a.createElement($s, l, "left" === f && Js.create({
        width: i,
        children: c
      }, {
        autoGenerateKey: !1
      }), Js.create({
        width: t,
        children: this.renderItems(),
        stretched: !0
      }, {
        autoGenerateKey: !1
      }), "right" === f && Js.create({
        width: i,
        children: c
      }, {
        autoGenerateKey: !1
      }));
    }, a.render = function () {
      var c = this.renderMenu(),
          a = je(e, this.props),
          n = zr(e, this.props);
      return c.props.vertical ? o.a.createElement(n, a, this.renderVertical(c)) : o.a.createElement(n, a, "bottom" !== c.props.attached && c, this.renderItems(), "bottom" === c.props.attached && c);
    }, e;
  }(Mi);

  wM.handledProps = ["activeIndex", "as", "defaultActiveIndex", "grid", "menu", "menuPosition", "onTabChange", "panes", "renderActiveOnly"], wM.propTypes = {}, wM.autoControlledProps = ["activeIndex"], wM.defaultProps = {
    grid: {
      paneWidth: 12,
      tabWidth: 4
    },
    menu: {
      attached: !0,
      tabular: !0
    },
    renderActiveOnly: !0
  }, wM.Pane = xM;
  var yM = wM;

  function bM(c) {
    var e = c.centered,
        a = c.children,
        t = c.className,
        r = c.content,
        i = c.test,
        l = c.unit,
        f = Ie("ui", l, ur(e, "centered"), ur(i, "test"), "ad", t),
        s = je(bM, c),
        u = zr(bM, c);
    return o.a.createElement(u, Object(p.a)({}, s, {
      className: f,
      "data-text": i
    }), n.isNil(a) ? r : a);
  }

  bM.handledProps = ["as", "centered", "children", "className", "content", "test", "unit"], bM.propTypes = {};
  var SM = bM;

  function TM(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.textAlign,
        i = Ie(dr(r), "description", a),
        l = je(TM, c),
        f = zr(TM, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(e) ? t : e);
  }

  TM.handledProps = ["as", "children", "className", "content", "textAlign"], TM.propTypes = {};
  var DM = TM;

  function jM(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.textAlign,
        i = Ie(dr(r), "header", a),
        l = je(jM, c),
        f = zr(jM, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(e) ? t : e);
  }

  jM.handledProps = ["as", "children", "className", "content", "textAlign"], jM.propTypes = {};
  var EM = jM;

  function kM(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.textAlign,
        i = Ie(dr(r), "meta", a),
        l = je(kM, c),
        f = zr(kM, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(e) ? t : e);
  }

  kM.handledProps = ["as", "children", "className", "content", "textAlign"], kM.propTypes = {};
  var IM = kM;

  function OM(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.description,
        i = c.extra,
        l = c.header,
        f = c.meta,
        s = c.textAlign,
        u = Ie(ur(i, "extra"), dr(s), "content", a),
        h = je(OM, c),
        m = zr(OM, c);
    return n.isNil(e) ? n.isNil(t) ? o.a.createElement(m, Object(p.a)({}, h, {
      className: u
    }), jr(EM, function (c) {
      return {
        content: c
      };
    }, l, {
      autoGenerateKey: !1
    }), jr(IM, function (c) {
      return {
        content: c
      };
    }, f, {
      autoGenerateKey: !1
    }), jr(DM, function (c) {
      return {
        content: c
      };
    }, r, {
      autoGenerateKey: !1
    })) : o.a.createElement(m, Object(p.a)({}, h, {
      className: u
    }), t) : o.a.createElement(m, Object(p.a)({}, h, {
      className: u
    }), e);
  }

  OM.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "meta", "textAlign"], OM.propTypes = {};
  var QM = OM;

  function ZM(c) {
    var e = c.centered,
        a = c.children,
        t = c.className,
        r = c.content,
        i = c.doubling,
        l = c.items,
        f = c.itemsPerRow,
        s = c.stackable,
        u = c.textAlign,
        h = Ie("ui", ur(e, "centered"), ur(i, "doubling"), ur(s, "stackable"), dr(u), pr(f), "cards", t),
        m = je(ZM, c),
        v = zr(ZM, c);
    if (!n.isNil(a)) return o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), a);
    if (!n.isNil(r)) return o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), r);
    var d = Oi(l, function (c) {
      var e,
          a = null != (e = c.key) ? e : [c.header, c.description].join("-");
      return o.a.createElement(BM, Object(p.a)({
        key: a
      }, c));
    });
    return o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), d);
  }

  ZM.handledProps = ["as", "centered", "children", "className", "content", "doubling", "items", "itemsPerRow", "stackable", "textAlign"], ZM.propTypes = {};

  var UM = ZM,
      BM = function (c) {
    function e() {
      for (var e, a = arguments.length, n = new Array(a), t = 0; t < a; t++) {
        n[t] = arguments[t];
      }

      return (e = c.call.apply(c, [this].concat(n)) || this).handleClick = function (c) {
        var a = e.props.onClick;
        a && a(c, e.props);
      }, e;
    }

    return Object(f.a)(e, c), e.prototype.render = function () {
      var c = this.props,
          a = c.centered,
          t = c.children,
          r = c.className,
          i = c.color,
          l = c.content,
          f = c.description,
          s = c.extra,
          u = c.fluid,
          h = c.header,
          m = c.href,
          v = c.image,
          d = c.link,
          M = c.meta,
          z = c.onClick,
          C = c.raised,
          L = Ie("ui", i, ur(a, "centered"), ur(u, "fluid"), ur(d, "link"), ur(C, "raised"), "card", r),
          A = je(e, this.props),
          N = zr(e, this.props, function () {
        if (z) return "a";
      });
      return n.isNil(t) ? n.isNil(l) ? o.a.createElement(N, Object(p.a)({}, A, {
        className: L,
        href: m,
        onClick: this.handleClick
      }), yi.create(v, {
        autoGenerateKey: !1,
        defaultProps: {
          ui: !1,
          wrapped: !0
        }
      }), (f || h || M) && o.a.createElement(QM, {
        description: f,
        header: h,
        meta: M
      }), s && o.a.createElement(QM, {
        extra: !0
      }, s)) : o.a.createElement(N, Object(p.a)({}, A, {
        className: L,
        href: m,
        onClick: this.handleClick
      }), l) : o.a.createElement(N, Object(p.a)({}, A, {
        className: L,
        href: m,
        onClick: this.handleClick
      }), t);
    }, e;
  }(i.Component);

  function RM(c) {
    var e = c.active,
        a = c.className,
        t = c.children,
        r = c.content,
        i = Ie(ur(e, "active"), a),
        l = je(RM, c),
        f = zr(RM, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(t) ? r : t);
  }

  BM.handledProps = ["as", "centered", "children", "className", "color", "content", "description", "extra", "fluid", "header", "href", "image", "link", "meta", "onClick", "raised"], BM.propTypes = {}, BM.Content = QM, BM.Description = DM, BM.Group = UM, BM.Header = EM, BM.Meta = IM, RM.handledProps = ["active", "as", "children", "className", "content"], RM.defaultProps = {
    as: "a"
  }, RM.propTypes = {};
  var YM = RM;

  function PM(c) {
    var e = c.className,
        a = c.children,
        t = c.content,
        r = Ie("actions", e),
        i = je(PM, c),
        l = zr(PM, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(a) ? t : a);
  }

  PM.handledProps = ["as", "children", "className", "content"], PM.propTypes = {};
  var FM = PM;

  function WM(c) {
    var e = c.className,
        a = c.children,
        t = c.content,
        r = Ie("author", e),
        i = je(WM, c),
        l = zr(WM, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(a) ? t : a);
  }

  WM.handledProps = ["as", "children", "className", "content"], WM.propTypes = {};
  var GM = WM;

  function qM(c) {
    var e = c.className,
        a = c.src,
        n = Ie("avatar", e),
        t = je(qM, c),
        r = ci(t, {
      htmlProps: $r
    }),
        i = r[0],
        l = r[1],
        f = zr(qM, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: n
    }), Or(a, {
      autoGenerateKey: !1,
      defaultProps: i
    }));
  }

  qM.handledProps = ["as", "className", "src"], qM.propTypes = {};
  var JM = qM;

  function KM(c) {
    var e = c.className,
        a = c.children,
        t = c.content,
        r = Ie(e, "content"),
        i = je(KM, c),
        l = zr(KM, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(a) ? t : a);
  }

  KM.handledProps = ["as", "children", "className", "content"], KM.propTypes = {};
  var XM = KM;

  function _M(c) {
    var e = c.className,
        a = c.children,
        t = c.collapsed,
        r = c.content,
        i = c.minimal,
        l = c.size,
        f = c.threaded,
        s = Ie("ui", l, ur(t, "collapsed"), ur(i, "minimal"), ur(f, "threaded"), "comments", e),
        u = je(_M, c),
        h = zr(_M, c);
    return o.a.createElement(h, Object(p.a)({}, u, {
      className: s
    }), n.isNil(a) ? r : a);
  }

  _M.handledProps = ["as", "children", "className", "collapsed", "content", "minimal", "size", "threaded"], _M.propTypes = {};
  var $M = _M;

  function cp(c) {
    var e = c.className,
        a = c.children,
        t = c.content,
        r = Ie("metadata", e),
        i = je(cp, c),
        l = zr(cp, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(a) ? t : a);
  }

  cp.handledProps = ["as", "children", "className", "content"], cp.propTypes = {};
  var ep = cp;

  function ap(c) {
    var e = c.className,
        a = c.children,
        t = c.content,
        r = Ie(e, "text"),
        i = je(ap, c),
        l = zr(ap, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(a) ? t : a);
  }

  ap.handledProps = ["as", "children", "className", "content"], ap.propTypes = {};
  var np = ap;

  function tp(c) {
    var e = c.className,
        a = c.children,
        t = c.collapsed,
        r = c.content,
        i = Ie(ur(t, "collapsed"), "comment", e),
        l = je(tp, c),
        f = zr(tp, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(a) ? r : a);
  }

  tp.handledProps = ["as", "children", "className", "collapsed", "content"], tp.propTypes = {}, tp.Author = GM, tp.Action = YM, tp.Actions = FM, tp.Avatar = JM, tp.Content = XM, tp.Group = $M, tp.Metadata = ep, tp.Text = np;
  var rp = tp;

  function ip(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("date", a),
        i = je(ip, c),
        l = zr(ip, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  ip.handledProps = ["as", "children", "className", "content"], ip.propTypes = {};
  var op = ip;

  function lp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.images,
        i = c.text,
        l = Ie(ur(r, "images"), ur(t || i, "text"), "extra", a),
        f = je(lp, c),
        s = zr(lp, c);
    if (!n.isNil(e)) return o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), e);
    var u = Oi(r, function (c, e) {
      var a = [e, c].join("-");
      return Or(c, {
        key: a
      });
    });
    return o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), t, u);
  }

  lp.handledProps = ["as", "children", "className", "content", "images", "text"], lp.propTypes = {};
  var fp = lp;

  function sp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.icon,
        i = Ie("like", a),
        l = je(sp, c),
        f = zr(sp, c);
    return n.isNil(e) ? o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), Pr.create(r, {
      autoGenerateKey: !1
    }), t) : o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), e);
  }

  sp.handledProps = ["as", "children", "className", "content", "icon"], sp.defaultProps = {
    as: "a"
  }, sp.propTypes = {};
  var up = sp;

  function hp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.like,
        i = Ie("meta", a),
        l = je(hp, c),
        f = zr(hp, c);
    return n.isNil(e) ? o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), jr(up, function (c) {
      return {
        content: c
      };
    }, r, {
      autoGenerateKey: !1
    }), t) : o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), e);
  }

  hp.handledProps = ["as", "children", "className", "content", "like"], hp.propTypes = {};
  var mp = hp;

  function vp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("user", a),
        i = je(vp, c),
        l = zr(vp, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  vp.handledProps = ["as", "children", "className", "content"], vp.propTypes = {}, vp.defaultProps = {
    as: "a"
  };
  var dp = vp;

  function Mp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.date,
        i = c.user,
        l = Ie("summary", a),
        f = je(Mp, c),
        s = zr(Mp, c);
    return n.isNil(e) ? o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), jr(dp, function (c) {
      return {
        content: c
      };
    }, i, {
      autoGenerateKey: !1
    }), t && " ", t, t && " ", jr(op, function (c) {
      return {
        content: c
      };
    }, r, {
      autoGenerateKey: !1
    })) : o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), e);
  }

  Mp.handledProps = ["as", "children", "className", "content", "date", "user"], Mp.propTypes = {};
  var pp = Mp;

  function zp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.extraImages,
        i = c.extraText,
        l = c.date,
        f = c.meta,
        s = c.summary,
        u = Ie("content", a),
        h = je(zp, c),
        m = zr(zp, c);
    return n.isNil(e) ? o.a.createElement(m, Object(p.a)({}, h, {
      className: u
    }), jr(op, function (c) {
      return {
        content: c
      };
    }, l, {
      autoGenerateKey: !1
    }), jr(pp, function (c) {
      return {
        content: c
      };
    }, s, {
      autoGenerateKey: !1
    }), t, jr(fp, function (c) {
      return {
        text: !0,
        content: c
      };
    }, i, {
      autoGenerateKey: !1
    }), jr(fp, function (c) {
      return {
        images: c
      };
    }, r, {
      autoGenerateKey: !1
    }), jr(mp, function (c) {
      return {
        content: c
      };
    }, f, {
      autoGenerateKey: !1
    })) : o.a.createElement(m, Object(p.a)({}, h, {
      className: u
    }), e);
  }

  zp.handledProps = ["as", "children", "className", "content", "date", "extraImages", "extraText", "meta", "summary"], zp.propTypes = {};
  var Cp = zp;

  function Lp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.icon,
        i = c.image,
        l = Ie("label", a),
        f = je(Lp, c),
        s = zr(Lp, c);
    return n.isNil(e) ? o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), t, Pr.create(r, {
      autoGenerateKey: !1
    }), Or(i)) : o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), e);
  }

  Lp.handledProps = ["as", "children", "className", "content", "icon", "image"], Lp.propTypes = {};
  var Ap = Lp;

  function Np(c) {
    var e = c.content,
        a = c.children,
        n = c.className,
        t = c.date,
        r = c.extraImages,
        i = c.extraText,
        l = c.image,
        f = c.icon,
        s = c.meta,
        u = c.summary,
        h = Ie("event", n),
        m = je(Np, c),
        v = zr(Np, c),
        d = e || t || r || i || s || u,
        M = {
      content: e,
      date: t,
      extraImages: r,
      extraText: i,
      meta: s,
      summary: u
    };
    return o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), jr(Ap, function (c) {
      return {
        icon: c
      };
    }, f, {
      autoGenerateKey: !1
    }), jr(Ap, function (c) {
      return {
        image: c
      };
    }, l, {
      autoGenerateKey: !1
    }), d && o.a.createElement(Cp, M), a);
  }

  Np.handledProps = ["as", "children", "className", "content", "date", "extraImages", "extraText", "icon", "image", "meta", "summary"], Np.propTypes = {};
  var gp = Np;

  function Hp(c) {
    var e = c.children,
        a = c.className,
        t = c.events,
        i = c.size,
        l = Ie("ui", i, "feed", a),
        f = je(Hp, c),
        s = zr(Hp, c);
    if (!n.isNil(e)) return o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), e);
    var u = Oi(t, function (c) {
      var e = c.childKey,
          a = c.date,
          n = c.meta,
          t = c.summary,
          i = Object(r.a)(c, ["childKey", "date", "meta", "summary"]),
          l = null != e ? e : [a, n, t].join("-");
      return o.a.createElement(gp, Object(p.a)({
        date: a,
        key: l,
        meta: n,
        summary: t
      }, i));
    });
    return o.a.createElement(s, Object(p.a)({}, f, {
      className: l
    }), u);
  }

  Hp.handledProps = ["as", "children", "className", "events", "size"], Hp.propTypes = {}, Hp.Content = Cp, Hp.Date = op, Hp.Event = gp, Hp.Extra = fp, Hp.Label = Ap, Hp.Like = up, Hp.Meta = mp, Hp.Summary = pp, Hp.User = dp;
  var Vp = Hp;

  function xp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("header", a),
        i = je(xp, c),
        l = zr(xp, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  xp.handledProps = ["as", "children", "className", "content"], xp.propTypes = {}, xp.create = Er(xp, function (c) {
    return {
      content: c
    };
  });
  var wp = xp;

  function yp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("description", a),
        i = je(yp, c),
        l = zr(yp, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  yp.handledProps = ["as", "children", "className", "content"], yp.propTypes = {}, yp.create = Er(yp, function (c) {
    return {
      content: c
    };
  });
  var bp = yp;

  function Sp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("extra", a),
        i = je(Sp, c),
        l = zr(Sp, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  Sp.handledProps = ["as", "children", "className", "content"], Sp.propTypes = {}, Sp.create = Er(Sp, function (c) {
    return {
      content: c
    };
  });
  var Tp = Sp;

  function Dp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("meta", a),
        i = je(Dp, c),
        l = zr(Dp, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  Dp.handledProps = ["as", "children", "className", "content"], Dp.propTypes = {}, Dp.create = Er(Dp, function (c) {
    return {
      content: c
    };
  });
  var jp = Dp;

  function Ep(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.description,
        i = c.extra,
        l = c.header,
        f = c.meta,
        s = c.verticalAlign,
        u = Ie(Mr(s), "content", a),
        h = je(Ep, c),
        m = zr(Ep, c);
    return n.isNil(e) ? o.a.createElement(m, Object(p.a)({}, h, {
      className: u
    }), wp.create(l, {
      autoGenerateKey: !1
    }), jp.create(f, {
      autoGenerateKey: !1
    }), bp.create(r, {
      autoGenerateKey: !1
    }), Tp.create(i, {
      autoGenerateKey: !1
    }), t) : o.a.createElement(m, Object(p.a)({}, h, {
      className: u
    }), e);
  }

  Ep.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "meta", "verticalAlign"], Ep.propTypes = {};
  var kp = Ep;

  function Ip(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        i = c.divided,
        l = c.items,
        f = c.link,
        s = c.relaxed,
        u = c.unstackable,
        h = Ie("ui", ur(i, "divided"), ur(f, "link"), ur(u, "unstackable"), mr(s, "relaxed"), "items", a),
        m = je(Ip, c),
        v = zr(Ip, c);
    if (!n.isNil(e)) return o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), e);
    if (!n.isNil(t)) return o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), t);
    var d = Oi(l, function (c) {
      var e = c.childKey,
          a = Object(r.a)(c, ["childKey"]),
          n = null != e ? e : [a.content, a.description, a.header, a.meta].join("-");
      return o.a.createElement(Bp, Object(p.a)({}, a, {
        key: n
      }));
    });
    return o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), d);
  }

  Ip.handledProps = ["as", "children", "className", "content", "divided", "items", "link", "relaxed", "unstackable"], Ip.propTypes = {};
  var Op = Ip;

  function Qp(c) {
    var e = c.size,
        a = je(Qp, c);
    return o.a.createElement(yi, Object(p.a)({}, a, {
      size: e,
      ui: !!e,
      wrapped: !0
    }));
  }

  Qp.handledProps = ["size"], Qp.propTypes = {}, Qp.create = Er(Qp, function (c) {
    return {
      src: c
    };
  });
  var Zp = Qp;

  function Up(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.description,
        i = c.extra,
        l = c.header,
        f = c.image,
        s = c.meta,
        u = Ie("item", a),
        h = je(Up, c),
        m = zr(Up, c);
    return n.isNil(e) ? o.a.createElement(m, Object(p.a)({}, h, {
      className: u
    }), Zp.create(f, {
      autoGenerateKey: !1
    }), o.a.createElement(kp, {
      content: t,
      description: r,
      extra: i,
      header: l,
      meta: s
    })) : o.a.createElement(m, Object(p.a)({}, h, {
      className: u
    }), e);
  }

  Up.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "image", "meta"], Up.Content = kp, Up.Description = bp, Up.Extra = Tp, Up.Group = Op, Up.Header = wp, Up.Image = Zp, Up.Meta = jp, Up.propTypes = {};
  var Bp = Up;

  function Rp(c) {
    var e = c.children,
        a = c.className,
        t = c.color,
        r = c.content,
        i = c.horizontal,
        l = c.inverted,
        f = c.items,
        s = c.size,
        u = c.widths,
        h = Ie("ui", t, s, ur(i, "horizontal"), ur(l, "inverted"), pr(u), "statistics", a),
        m = je(Rp, c),
        v = zr(Rp, c);
    return n.isNil(e) ? n.isNil(r) ? o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), Oi(f, function (c) {
      return Jp.create(c);
    })) : o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), r) : o.a.createElement(v, Object(p.a)({}, m, {
      className: h
    }), e);
  }

  Rp.handledProps = ["as", "children", "className", "color", "content", "horizontal", "inverted", "items", "size", "widths"], Rp.propTypes = {};
  var Yp = Rp;

  function Pp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = Ie("label", a),
        i = je(Pp, c),
        l = zr(Pp, c);
    return o.a.createElement(l, Object(p.a)({}, i, {
      className: r
    }), n.isNil(e) ? t : e);
  }

  Pp.handledProps = ["as", "children", "className", "content"], Pp.propTypes = {}, Pp.create = Er(Pp, function (c) {
    return {
      content: c
    };
  });
  var Fp = Pp;

  function Wp(c) {
    var e = c.children,
        a = c.className,
        t = c.content,
        r = c.text,
        i = Ie(ur(r, "text"), "value", a),
        l = je(Wp, c),
        f = zr(Wp, c);
    return o.a.createElement(f, Object(p.a)({}, l, {
      className: i
    }), n.isNil(e) ? t : e);
  }

  Wp.handledProps = ["as", "children", "className", "content", "text"], Wp.propTypes = {}, Wp.create = Er(Wp, function (c) {
    return {
      content: c
    };
  });
  var Gp = Wp;

  function qp(c) {
    var e = c.children,
        a = c.className,
        t = c.color,
        r = c.content,
        i = c.floated,
        l = c.horizontal,
        f = c.inverted,
        s = c.label,
        u = c.size,
        h = c.text,
        m = c.value,
        v = Ie("ui", t, u, hr(i, "floated"), ur(l, "horizontal"), ur(f, "inverted"), "statistic", a),
        d = je(qp, c),
        M = zr(qp, c);
    return n.isNil(e) ? n.isNil(r) ? o.a.createElement(M, Object(p.a)({}, d, {
      className: v
    }), Gp.create(m, {
      defaultProps: {
        text: h
      },
      autoGenerateKey: !1
    }), Fp.create(s, {
      autoGenerateKey: !1
    })) : o.a.createElement(M, Object(p.a)({}, d, {
      className: v
    }), r) : o.a.createElement(M, Object(p.a)({}, d, {
      className: v
    }), e);
  }

  qp.handledProps = ["as", "children", "className", "color", "content", "floated", "horizontal", "inverted", "label", "size", "text", "value"], qp.propTypes = {}, qp.Group = Yp, qp.Label = Fp, qp.Value = Gp, qp.create = Er(qp, function (c) {
    return {
      content: c
    };
  });
  var Jp = qp;
  a.d(e, "Ref", function () {
    return M;
  }), a.d(e, "Confirm", function () {
    return Do;
  }), a.d(e, "Pagination", function () {
    return Pl;
  }), a.d(e, "PaginationItem", function () {
    return Yl;
  }), a.d(e, "Portal", function () {
    return Li;
  }), a.d(e, "PortalInner", function () {
    return zi;
  }), a.d(e, "Radio", function () {
    return ql;
  }), a.d(e, "Select", function () {
    return Jf;
  }), a.d(e, "TextArea", function () {
    return Xf;
  }), a.d(e, "TransitionablePortal", function () {
    return Cs;
  }), a.d(e, "Visibility", function () {
    return Ls;
  }), a.d(e, "Breadcrumb", function () {
    return Vs;
  }), a.d(e, "BreadcrumbDivider", function () {
    return Ns;
  }), a.d(e, "BreadcrumbSection", function () {
    return gs;
  }), a.d(e, "Form", function () {
    return Gs;
  }), a.d(e, "FormButton", function () {
    return bs;
  }), a.d(e, "FormCheckbox", function () {
    return Ts;
  }), a.d(e, "FormDropdown", function () {
    return js;
  }), a.d(e, "FormField", function () {
    return ws;
  }), a.d(e, "FormGroup", function () {
    return ks;
  }), a.d(e, "FormInput", function () {
    return Zs;
  }), a.d(e, "FormRadio", function () {
    return Bs;
  }), a.d(e, "FormSelect", function () {
    return Ys;
  }), a.d(e, "FormTextArea", function () {
    return Fs;
  }), a.d(e, "Grid", function () {
    return $s;
  }), a.d(e, "GridColumn", function () {
    return Js;
  }), a.d(e, "GridRow", function () {
    return Xs;
  }), a.d(e, "Menu", function () {
    return Bl;
  }), a.d(e, "MenuHeader", function () {
    return Wo;
  }), a.d(e, "MenuItem", function () {
    return Ol;
  }), a.d(e, "MenuMenu", function () {
    return Zl;
  }), a.d(e, "Message", function () {
    return lu;
  }), a.d(e, "MessageContent", function () {
    return eu;
  }), a.d(e, "MessageHeader", function () {
    return nu;
  }), a.d(e, "MessageItem", function () {
    return ru;
  }), a.d(e, "MessageList", function () {
    return ou;
  }), a.d(e, "Table", function () {
    return Nu;
  }), a.d(e, "TableBody", function () {
    return su;
  }), a.d(e, "TableCell", function () {
    return hu;
  }), a.d(e, "TableFooter", function () {
    return Mu;
  }), a.d(e, "TableHeader", function () {
    return vu;
  }), a.d(e, "TableHeaderCell", function () {
    return zu;
  }), a.d(e, "TableRow", function () {
    return Lu;
  }), a.d(e, "Button", function () {
    return Yi;
  }), a.d(e, "ButtonContent", function () {
    return ki;
  }), a.d(e, "ButtonGroup", function () {
    return Zi;
  }), a.d(e, "ButtonOr", function () {
    return Bi;
  }), a.d(e, "Container", function () {
    return Hu;
  }), a.d(e, "Divider", function () {
    return xu;
  }), a.d(e, "Flag", function () {
    return Hf;
  }), a.d(e, "Header", function () {
    return Du;
  }), a.d(e, "HeaderContent", function () {
    return Su;
  }), a.d(e, "HeaderSubheader", function () {
    return yu;
  }), a.d(e, "Icon", function () {
    return Pr;
  }), a.d(e, "IconGroup", function () {
    return Rr;
  }), a.d(e, "Image", function () {
    return yi;
  }), a.d(e, "ImageGroup", function () {
    return xi;
  }), a.d(e, "Input", function () {
    return Os;
  }), a.d(e, "Label", function () {
    return ji;
  }), a.d(e, "LabelDetail", function () {
    return Si;
  }), a.d(e, "LabelGroup", function () {
    return Di;
  }), a.d(e, "List", function () {
    return Wu;
  }), a.d(e, "ListContent", function () {
    return Qu;
  }), a.d(e, "ListDescription", function () {
    return Eu;
  }), a.d(e, "ListHeader", function () {
    return Iu;
  }), a.d(e, "ListIcon", function () {
    return Uu;
  }), a.d(e, "ListItem", function () {
    return Ru;
  }), a.d(e, "ListList", function () {
    return Pu;
  }), a.d(e, "Loader", function () {
    return qu;
  }), a.d(e, "Placeholder", function () {
    return th;
  }), a.d(e, "PlaceholderHeader", function () {
    return Ku;
  }), a.d(e, "PlaceholderImage", function () {
    return _u;
  }), a.d(e, "PlaceholderLine", function () {
    return ch;
  }), a.d(e, "PlaceholderParagraph", function () {
    return ah;
  }), a.d(e, "Rail", function () {
    return ih;
  }), a.d(e, "Reveal", function () {
    return sh;
  }), a.d(e, "RevealContent", function () {
    return lh;
  }), a.d(e, "Segment", function () {
    return Mh;
  }), a.d(e, "SegmentGroup", function () {
    return hh;
  }), a.d(e, "SegmentInline", function () {
    return vh;
  }), a.d(e, "Step", function () {
    return xh;
  }), a.d(e, "StepContent", function () {
    return Nh;
  }), a.d(e, "StepDescription", function () {
    return zh;
  }), a.d(e, "StepGroup", function () {
    return Hh;
  }), a.d(e, "StepTitle", function () {
    return Lh;
  }), a.d(e, "Accordion", function () {
    return Eh;
  }), a.d(e, "AccordionAccordion", function () {
    return Dh;
  }), a.d(e, "AccordionContent", function () {
    return bh;
  }), a.d(e, "AccordionPanel", function () {
    return Th;
  }), a.d(e, "AccordionTitle", function () {
    return wh;
  }), a.d(e, "Checkbox", function () {
    return Wl;
  }), a.d(e, "Dimmer", function () {
    return Hi;
  }), a.d(e, "DimmerDimmable", function () {
    return Ni;
  }), a.d(e, "DimmerInner", function () {
    return gi;
  }), a.d(e, "Dropdown", function () {
    return Gf;
  }), a.d(e, "DropdownDivider", function () {
    return xf;
  }), a.d(e, "DropdownHeader", function () {
    return Sf;
  }), a.d(e, "DropdownItem", function () {
    return yf;
  }), a.d(e, "DropdownMenu", function () {
    return Df;
  }), a.d(e, "DropdownSearchInput", function () {
    return Ef;
  }), a.d(e, "DropdownText", function () {
    return If;
  }), a.d(e, "Embed", function () {
    return kh;
  }), a.d(e, "Modal", function () {
    return So;
  }), a.d(e, "ModalActions", function () {
    return uo;
  }), a.d(e, "ModalContent", function () {
    return mo;
  }), a.d(e, "ModalDescription", function () {
    return Mo;
  }), a.d(e, "ModalDimmer", function () {
    return go;
  }), a.d(e, "ModalHeader", function () {
    return Vo;
  }), a.d(e, "Popup", function () {
    return Cv;
  }), a.d(e, "PopupContent", function () {
    return pv;
  }), a.d(e, "PopupHeader", function () {
    return zv;
  }), a.d(e, "Progress", function () {
    return xv;
  }), a.d(e, "Rating", function () {
    return Dv;
  }), a.d(e, "RatingIcon", function () {
    return Tv;
  }), a.d(e, "Search", function () {
    return mM;
  }), a.d(e, "SearchCategory", function () {
    return oM;
  }), a.d(e, "SearchResult", function () {
    return fM;
  }), a.d(e, "SearchResults", function () {
    return uM;
  }), a.d(e, "Sidebar", function () {
    return gM;
  }), a.d(e, "SidebarPushable", function () {
    return CM;
  }), a.d(e, "SidebarPusher", function () {
    return AM;
  }), a.d(e, "Sticky", function () {
    return HM;
  }), a.d(e, "Tab", function () {
    return yM;
  }), a.d(e, "TabPane", function () {
    return xM;
  }), a.d(e, "Transition", function () {
    return zs;
  }), a.d(e, "TransitionGroup", function () {
    return os;
  }), a.d(e, "Advertisement", function () {
    return SM;
  }), a.d(e, "Card", function () {
    return BM;
  }), a.d(e, "CardContent", function () {
    return QM;
  }), a.d(e, "CardDescription", function () {
    return DM;
  }), a.d(e, "CardGroup", function () {
    return UM;
  }), a.d(e, "CardHeader", function () {
    return EM;
  }), a.d(e, "CardMeta", function () {
    return IM;
  }), a.d(e, "Comment", function () {
    return rp;
  }), a.d(e, "CommentAction", function () {
    return YM;
  }), a.d(e, "CommentActions", function () {
    return FM;
  }), a.d(e, "CommentAuthor", function () {
    return GM;
  }), a.d(e, "CommentAvatar", function () {
    return JM;
  }), a.d(e, "CommentContent", function () {
    return XM;
  }), a.d(e, "CommentGroup", function () {
    return $M;
  }), a.d(e, "CommentMetadata", function () {
    return ep;
  }), a.d(e, "CommentText", function () {
    return np;
  }), a.d(e, "Feed", function () {
    return Vp;
  }), a.d(e, "FeedContent", function () {
    return Cp;
  }), a.d(e, "FeedDate", function () {
    return op;
  }), a.d(e, "FeedEvent", function () {
    return gp;
  }), a.d(e, "FeedExtra", function () {
    return fp;
  }), a.d(e, "FeedLabel", function () {
    return Ap;
  }), a.d(e, "FeedLike", function () {
    return up;
  }), a.d(e, "FeedMeta", function () {
    return mp;
  }), a.d(e, "FeedSummary", function () {
    return pp;
  }), a.d(e, "FeedUser", function () {
    return dp;
  }), a.d(e, "Item", function () {
    return Bp;
  }), a.d(e, "ItemContent", function () {
    return kp;
  }), a.d(e, "ItemDescription", function () {
    return bp;
  }), a.d(e, "ItemExtra", function () {
    return Tp;
  }), a.d(e, "ItemGroup", function () {
    return Op;
  }), a.d(e, "ItemHeader", function () {
    return wp;
  }), a.d(e, "ItemImage", function () {
    return Zp;
  }), a.d(e, "ItemMeta", function () {
    return jp;
  }), a.d(e, "Statistic", function () {
    return Jp;
  }), a.d(e, "StatisticGroup", function () {
    return Yp;
  }), a.d(e, "StatisticLabel", function () {
    return Fp;
  }), a.d(e, "StatisticValue", function () {
    return Gp;
  });
}, function (c, e, a) {
  "use strict";

  (function (c) {
    var n = a(40),
        t = "object" == typeof exports && exports && !exports.nodeType && exports,
        r = t && "object" == typeof c && c && !c.nodeType && c,
        i = r && r.exports === t && n.a.process,
        o = function () {
      try {
        var c = r && r.require && r.require("util").types;

        return c || i && i.binding && i.binding("util");
      } catch (c) {}
    }();

    e.a = o;
  }).call(this, a(86)(c));
}, function (c, e, a) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  var n = Object.getOwnPropertySymbols,
      t = Object.prototype.hasOwnProperty,
      r = Object.prototype.propertyIsEnumerable;
  c.exports = function () {
    try {
      if (!Object.assign) return !1;
      var c = new String("abc");
      if (c[5] = "de", "5" === Object.getOwnPropertyNames(c)[0]) return !1;

      for (var e = {}, a = 0; a < 10; a++) {
        e["_" + String.fromCharCode(a)] = a;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (c) {
        return e[c];
      }).join("")) return !1;
      var n = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (c) {
        n[c] = c;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
    } catch (c) {
      return !1;
    }
  }() ? Object.assign : function (c, e) {
    for (var a, i, o = function (c) {
      if (null == c) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(c);
    }(c), l = 1; l < arguments.length; l++) {
      for (var f in a = Object(arguments[l])) {
        t.call(a, f) && (o[f] = a[f]);
      }

      if (n) {
        i = n(a);

        for (var s = 0; s < i.length; s++) {
          r.call(a, i[s]) && (o[i[s]] = a[i[s]]);
        }
      }
    }

    return o;
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.replaceObjectById = function (c, e, a) {
    return c.map(function (c) {
      return c.id === a ? e : c;
    });
  }, e.lastFrom = function (c) {
    return c.slice(-1)[0] || null;
  };
}, function (c, e) {
  c.exports = function (c, e) {
    for (var a = -1, n = e.length, t = c.length; ++a < n;) {
      c[t + a] = e[a];
    }

    return c;
  };
}, function (c, e, a) {
  (function (e) {
    var a = "object" == typeof e && e && e.Object === Object && e;
    c.exports = a;
  }).call(this, a(18));
}, function (c, e) {
  c.exports = function (c, e) {
    for (var a = -1, n = null == c ? 0 : c.length, t = Array(n); ++a < n;) {
      t[a] = e(c[a], a, c);
    }

    return t;
  };
}, function (c, e, a) {
  var n = a(30),
      t = a(125),
      r = a(126),
      i = a(127),
      o = a(128),
      l = a(129);

  function f(c) {
    var e = this.__data__ = new n(c);
    this.size = e.size;
  }

  f.prototype.clear = t, f.prototype.delete = r, f.prototype.get = i, f.prototype.has = o, f.prototype.set = l, c.exports = f;
}, function (c, e) {
  c.exports = function (c, e) {
    return c === e || c != c && e != e;
  };
}, function (c, e, a) {
  var n = a(24),
      t = a(45),
      r = "[object AsyncFunction]",
      i = "[object Function]",
      o = "[object GeneratorFunction]",
      l = "[object Proxy]";

  c.exports = function (c) {
    if (!t(c)) return !1;
    var e = n(c);
    return e == i || e == o || e == r || e == l;
  };
}, function (c, e) {
  var a = Function.prototype.toString;

  c.exports = function (c) {
    if (null != c) {
      try {
        return a.call(c);
      } catch (c) {}

      try {
        return c + "";
      } catch (c) {}
    }

    return "";
  };
}, function (c, e, a) {
  var n = a(146),
      t = a(25);

  c.exports = function c(e, a, r, i, o) {
    return e === a || (null == e || null == a || !t(e) && !t(a) ? e != e && a != a : n(e, a, r, i, c, o));
  };
}, function (c, e, a) {
  var n = a(147),
      t = a(150),
      r = a(151),
      i = 1,
      o = 2;

  c.exports = function (c, e, a, l, f, s) {
    var u = a & i,
        h = c.length,
        m = e.length;
    if (h != m && !(u && m > h)) return !1;
    var v = s.get(c),
        d = s.get(e);
    if (v && d) return v == e && d == c;
    var M = -1,
        p = !0,
        z = a & o ? new n() : void 0;

    for (s.set(c, e), s.set(e, c); ++M < h;) {
      var C = c[M],
          L = e[M];
      if (l) var A = u ? l(L, C, M, e, c, s) : l(C, L, M, c, e, s);

      if (void 0 !== A) {
        if (A) continue;
        p = !1;
        break;
      }

      if (z) {
        if (!t(e, function (c, e) {
          if (!r(z, e) && (C === c || f(C, c, a, l, s))) return z.push(e);
        })) {
          p = !1;
          break;
        }
      } else if (C !== L && !f(C, L, a, l, s)) {
        p = !1;
        break;
      }
    }

    return s.delete(c), s.delete(e), p;
  };
}, function (c, e, a) {
  (function (c) {
    var n = a(13),
        t = a(164),
        r = e && !e.nodeType && e,
        i = r && "object" == typeof c && c && !c.nodeType && c,
        o = i && i.exports === r ? n.Buffer : void 0,
        l = (o ? o.isBuffer : void 0) || t;
    c.exports = l;
  }).call(this, a(70)(c));
}, function (c, e) {
  c.exports = function (c) {
    return c.webpackPolyfill || (c.deprecate = function () {}, c.paths = [], c.children || (c.children = []), Object.defineProperty(c, "loaded", {
      enumerable: !0,
      get: function get() {
        return c.l;
      }
    }), Object.defineProperty(c, "id", {
      enumerable: !0,
      get: function get() {
        return c.i;
      }
    }), c.webpackPolyfill = 1), c;
  };
}, function (c, e) {
  var a = 9007199254740991,
      n = /^(?:0|[1-9]\d*)$/;

  c.exports = function (c, e) {
    var t = typeof c;
    return !!(e = null == e ? a : e) && ("number" == t || "symbol" != t && n.test(c)) && c > -1 && c % 1 == 0 && c < e;
  };
}, function (c, e, a) {
  var n = a(165),
      t = a(166),
      r = a(167),
      i = r && r.isTypedArray,
      o = i ? t(i) : n;
  c.exports = o;
}, function (c, e, a) {
  var n = a(45);

  c.exports = function (c) {
    return c == c && !n(c);
  };
}, function (c, e) {
  c.exports = function (c, e) {
    return function (a) {
      return null != a && a[c] === e && (void 0 !== e || c in Object(a));
    };
  };
}, function (c, e, a) {
  var n = a(76),
      t = a(34);

  c.exports = function (c, e) {
    for (var a = 0, r = (e = n(e, c)).length; null != c && a < r;) {
      c = c[t(e[a++])];
    }

    return a && a == r ? c : void 0;
  };
}, function (c, e, a) {
  var n = a(11),
      t = a(50),
      r = a(180),
      i = a(183);

  c.exports = function (c, e) {
    return n(c) ? c : t(c, e) ? [c] : r(i(c));
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  },
      t = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      r = m(a(0)),
      i = m(a(52)),
      o = m(a(16)),
      l = m(a(21)),
      f = m(a(216)),
      s = a(14),
      u = a(217),
      h = m(a(54));

  function m(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  function v(c) {
    return function () {
      var e = c.apply(this, arguments);
      return new Promise(function (c, a) {
        return function n(t, r) {
          try {
            var i = e[t](r),
                o = i.value;
          } catch (c) {
            return void a(c);
          }

          if (!i.done) return Promise.resolve(o).then(function (c) {
            n("next", c);
          }, function (c) {
            n("throw", c);
          });
          c(o);
        }("next");
      });
    };
  }

  function d(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  i.default.setAppElement(document.getElementById("root"));

  var M = function (c) {
    function e() {
      for (var c, a, t, i = arguments, l = this, f = arguments.length, h = Array(f), m = 0; m < f; m++) {
        h[m] = arguments[m];
      }

      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), a = t = d(this, (c = e.__proto__ || Object.getPrototypeOf(e)).call.apply(c, [this].concat(h))), t.state = {
        modalIsOpen: !1,
        currentPage: 0
      }, t.openModal = function () {
        t.setState({
          modalIsOpen: !0
        });
      }, t.closeModal = function () {
        t.setState({
          modalIsOpen: !1
        });
      }, t.prevPage = function () {
        var c = t.state.currentPage;
        t.props.pages;
        c <= 0 || t.setState({
          currentPage: c - 1
        });
      }, t.nextPage = function () {
        var c = t.state.currentPage;
        c >= t.props.pages.length - 1 || t.setState({
          currentPage: c + 1
        });
      }, t.prevButton = function () {
        var c = t.props,
            e = c.styles,
            a = c.pages,
            n = t.state.currentPage,
            i = " ",
            o = {};
        return 0 !== n && (o.color = e.primaryColor, i = a[n - 1].title), r.default.createElement("small", {
          className: "underline nav-button",
          style: o,
          onClick: t.prevPage
        }, i);
      }, t.nextButton = function () {
        var c = t.props,
            e = c.styles,
            a = c.pages,
            n = t.state.currentPage,
            i = " ",
            o = {};
        return n !== a.length - 1 && (o.color = e.primaryColor, i = a[n + 1].title), r.default.createElement("small", {
          className: "underline nav-button",
          style: o,
          onClick: t.nextPage
        }, i);
      }, t.renderDots = function () {
        var c = t.props.styles;
        return r.default.createElement("span", null, [].concat(function (c) {
          if (Array.isArray(c)) {
            for (var e = 0, a = Array(c.length); e < c.length; e++) {
              a[e] = c[e];
            }

            return a;
          }

          return Array.from(c);
        }(Array(t.props.pages.length))).map(function (e, a) {
          var n = a === t.state.currentPage ? c.primaryColor : c.lightGray;
          return r.default.createElement(s.FontAwesomeIcon, {
            style: {
              padding: "0 1px"
            },
            icon: u.faCircle,
            color: n
          });
        }));
      }, t.buttonFromProps = function (c, e) {
        var a,
            f,
            s = void 0,
            u = "modal-dialog-buttons-" + e,
            h = c.onClick,
            m = c.validate,
            d = function (c, e) {
          var a = {};

          for (var n in c) {
            e.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(c, n) && (a[n] = c[n]);
          }

          return a;
        }(c, ["onClick", "validate"]);

        return c.appendClose ? (f = v(_regeneratorRuntime.mark(function c() {
          return _regeneratorRuntime.wrap(function (c) {
            for (;;) {
              switch (c.prev = c.next) {
                case 0:
                  if (c.t0 = m, !c.t0) {
                    c.next = 5;
                    break;
                  }

                  return c.next = 4, m.apply(t, i);

                case 4:
                  c.t0 = !c.sent;

                case 5:
                  if (!c.t0) {
                    c.next = 7;
                    break;
                  }

                  return c.abrupt("return");

                case 7:
                  if (!h) {
                    c.next = 10;
                    break;
                  }

                  return c.next = 10, h.apply(t, i);

                case 10:
                  t.closeModal();

                case 11:
                case "end":
                  return c.stop();
              }
            }
          }, c, l);
        })), s = function s() {
          return f.apply(this, arguments);
        }) : (a = v(_regeneratorRuntime.mark(function c() {
          return _regeneratorRuntime.wrap(function (c) {
            for (;;) {
              switch (c.prev = c.next) {
                case 0:
                  if (c.t0 = m, !c.t0) {
                    c.next = 5;
                    break;
                  }

                  return c.next = 4, m.apply(t, i);

                case 4:
                  c.t0 = !c.sent;

                case 5:
                  if (!c.t0) {
                    c.next = 7;
                    break;
                  }

                  return c.abrupt("return");

                case 7:
                  if (!h) {
                    c.next = 10;
                    break;
                  }

                  return c.next = 10, h.apply(t, i);

                case 10:
                case "end":
                  return c.stop();
              }
            }
          }, c, l);
        })), s = function s() {
          return a.apply(this, arguments);
        }), r.default.createElement(o.default, n({
          key: u,
          onClick: s
        }, d));
      }, d(t, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, r.default.Component), t(e, [{
      key: "render",
      value: function value() {
        var c = this,
            e = this.props.styles || {},
            a = this.props,
            t = a.pages,
            u = a.icon,
            m = a.showCostDiagnosis,
            v = a.user,
            d = t[this.state.currentPage],
            M = this.props.t,
            p = r.default.createElement("span", null, this.props.linkText && r.default.createElement("p", null, r.default.createElement("a", {
          className: this.props.className,
          onClick: this.openModal,
          style: n({}, e, {
            cursor: "pointer"
          })
        }, this.props.linkText)), this.props.buttonText && r.default.createElement(o.default, {
          onClick: this.openModal,
          text: this.props.buttonText,
          colorStyle: this.props.colorStyle
        }), this.props.icon && r.default.createElement("span", {
          className: this.props.className,
          onClick: this.openModal,
          style: n({}, e, {
            cursor: "pointer"
          })
        }, r.default.createElement(s.FontAwesomeIcon, {
          icon: this.props.icon
        })), this.props.customElement && r.default.createElement("div", {
          className: this.props.className,
          onClick: this.openModal,
          style: n({}, e, {
            cursor: "pointer"
          })
        }, this.props.customElement), r.default.createElement(i.default, {
          isOpen: this.state.modalIsOpen,
          onAfterOpen: this.afterOpenModal,
          onRequestClose: this.closeModal,
          contentLabel: this.props.contentLabel,
          className: "modal-dialog"
        }, r.default.createElement(r.default.Fragment, null, r.default.createElement(h.default, {
          onClose: this.closeModal
        }), r.default.createElement("div", {
          className: "modal-dialog-content"
        }, d.content), d.buttons && r.default.createElement("div", {
          className: "modal-dialog-buttons"
        }, d.buttons.map(function (e, a) {
          return c.buttonFromProps(e, a);
        })), t.length > 1 && r.default.createElement("div", {
          className: "modal-step-nav"
        }, this.prevButton(), this.renderDots(), this.nextButton()), (window.location.hostname.match(/localhost/) || v && v.email && v.email.match(/caradvise/i)) && m && r.default.createElement("span", {
          className: "flex-centered-content link"
        }, r.default.createElement(l.default, {
          linkText: "Open cost diagnosis"
        }, r.default.createElement(f.default, {
          pe: this.props.pe || {},
          t: M
        }))))));
        return u ? p : r.default.createElement("div", null, p);
      }
    }]), e;
  }();

  e.default = M;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function c(e) {
    var a = [].slice.call(e.querySelectorAll("*"), 0).reduce(function (e, a) {
      return e.concat(a.shadowRoot ? c(a.shadowRoot) : [a]);
    }, []);
    return a.filter(l);
  };
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */

  var n = "none",
      t = "contents",
      r = /input|select|textarea|button|object|iframe/;

  function i(c) {
    var e = c.offsetWidth <= 0 && c.offsetHeight <= 0;
    if (e && !c.innerHTML) return !0;

    try {
      var a = window.getComputedStyle(c),
          r = a.getPropertyValue("display");
      return e ? r !== t && function (c, e) {
        return "visible" !== e.getPropertyValue("overflow") || c.scrollWidth <= 0 && c.scrollHeight <= 0;
      }(c, a) : r === n;
    } catch (c) {
      return console.warn("Failed to inspect element style"), !1;
    }
  }

  function o(c, e) {
    var a = c.nodeName.toLowerCase();
    return (r.test(a) && !c.disabled || "a" === a && c.href || e) && function (c) {
      for (var e = c, a = c.getRootNode && c.getRootNode(); e && e !== document.body;) {
        if (a && e === a && (e = a.host.parentNode), i(e)) return !1;
        e = e.parentNode;
      }

      return !0;
    }(c);
  }

  function l(c) {
    var e = c.getAttribute("tabindex");
    null === e && (e = void 0);
    var a = isNaN(e);
    return (a || e >= 0) && o(c, !a);
  }

  c.exports = e.default;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.resetState = function () {
    o && (o.removeAttribute ? o.removeAttribute("aria-hidden") : null != o.length ? o.forEach(function (c) {
      return c.removeAttribute("aria-hidden");
    }) : document.querySelectorAll(o).forEach(function (c) {
      return c.removeAttribute("aria-hidden");
    }));
    o = null;
  }, e.log = function () {
    0;
  }, e.assertNodeList = l, e.setElement = function (c) {
    var e = c;

    if ("string" == typeof e && i.canUseDOM) {
      var a = document.querySelectorAll(e);
      l(a, e), e = a;
    }

    return o = e || o;
  }, e.validateElement = f, e.hide = function (c) {
    var e = !0,
        a = !1,
        n = void 0;

    try {
      for (var t, r = f(c)[Symbol.iterator](); !(e = (t = r.next()).done); e = !0) {
        var i = t.value;
        i.setAttribute("aria-hidden", "true");
      }
    } catch (c) {
      a = !0, n = c;
    } finally {
      try {
        !e && r.return && r.return();
      } finally {
        if (a) throw n;
      }
    }
  }, e.show = function (c) {
    var e = !0,
        a = !1,
        n = void 0;

    try {
      for (var t, r = f(c)[Symbol.iterator](); !(e = (t = r.next()).done); e = !0) {
        var i = t.value;
        i.removeAttribute("aria-hidden");
      }
    } catch (c) {
      a = !0, n = c;
    } finally {
      try {
        !e && r.return && r.return();
      } finally {
        if (a) throw n;
      }
    }
  }, e.documentNotReadyOrSSRTesting = function () {
    o = null;
  };
  var n,
      t = a(6),
      r = (n = t) && n.__esModule ? n : {
    default: n
  },
      i = a(53);
  var o = null;

  function l(c, e) {
    if (!c || !c.length) throw new Error("react-modal: No elements were found for selector " + e + ".");
  }

  function f(c) {
    var e = c || o;
    return e ? Array.isArray(e) || e instanceof HTMLCollection || e instanceof NodeList ? e : [e] : ((0, r.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
  }
}, function (c, e, a) {
  var n;
  /*!
    Copyright (c) 2015 Jed Watson.
    Based on code that is Copyright 2013-2015, Facebook, Inc.
    All rights reserved.
  */

  /*!
    Copyright (c) 2015 Jed Watson.
    Based on code that is Copyright 2013-2015, Facebook, Inc.
    All rights reserved.
  */

  !function () {
    "use strict";

    var t = !("undefined" == typeof window || !window.document || !window.document.createElement),
        r = {
      canUseDOM: t,
      canUseWorkers: "undefined" != typeof Worker,
      canUseEventListeners: t && !(!window.addEventListener && !window.attachEvent),
      canUseViewport: t && !!window.screen
    };
    void 0 === (n = function () {
      return r;
    }.call(e, a, e, c)) || (c.exports = n);
  }();
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.log = function () {
    console.log("portalOpenInstances ----------"), console.log(t.openInstances.length), t.openInstances.forEach(function (c) {
      return console.log(c);
    }), console.log("end portalOpenInstances ----------");
  }, e.resetState = function () {
    t = new n();
  };

  var n = function c() {
    var e = this;
    !function (c, e) {
      if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
    }(this, c), this.register = function (c) {
      -1 === e.openInstances.indexOf(c) && (e.openInstances.push(c), e.emit("register"));
    }, this.deregister = function (c) {
      var a = e.openInstances.indexOf(c);
      -1 !== a && (e.openInstances.splice(a, 1), e.emit("deregister"));
    }, this.subscribe = function (c) {
      e.subscribers.push(c);
    }, this.emit = function (c) {
      e.subscribers.forEach(function (a) {
        return a(c, e.openInstances.slice());
      });
    }, this.openInstances = [], this.subscribers = [];
  },
      t = new n();

  e.default = t;
}, function (c, e, a) {
  "use strict";

  a.r(e), a.d(e, "far", function () {
    return qe;
  }), a.d(e, "prefix", function () {
    return n;
  }), a.d(e, "faAddressBook", function () {
    return t;
  }), a.d(e, "faAddressCard", function () {
    return r;
  }), a.d(e, "faAngry", function () {
    return i;
  }), a.d(e, "faArrowAltCircleDown", function () {
    return o;
  }), a.d(e, "faArrowAltCircleLeft", function () {
    return l;
  }), a.d(e, "faArrowAltCircleRight", function () {
    return f;
  }), a.d(e, "faArrowAltCircleUp", function () {
    return s;
  }), a.d(e, "faBell", function () {
    return u;
  }), a.d(e, "faBellSlash", function () {
    return h;
  }), a.d(e, "faBookmark", function () {
    return m;
  }), a.d(e, "faBuilding", function () {
    return v;
  }), a.d(e, "faCalendar", function () {
    return d;
  }), a.d(e, "faCalendarAlt", function () {
    return M;
  }), a.d(e, "faCalendarCheck", function () {
    return p;
  }), a.d(e, "faCalendarMinus", function () {
    return z;
  }), a.d(e, "faCalendarPlus", function () {
    return C;
  }), a.d(e, "faCalendarTimes", function () {
    return L;
  }), a.d(e, "faCaretSquareDown", function () {
    return A;
  }), a.d(e, "faCaretSquareLeft", function () {
    return N;
  }), a.d(e, "faCaretSquareRight", function () {
    return g;
  }), a.d(e, "faCaretSquareUp", function () {
    return H;
  }), a.d(e, "faChartBar", function () {
    return V;
  }), a.d(e, "faCheckCircle", function () {
    return x;
  }), a.d(e, "faCheckSquare", function () {
    return w;
  }), a.d(e, "faCircle", function () {
    return y;
  }), a.d(e, "faClipboard", function () {
    return b;
  }), a.d(e, "faClock", function () {
    return S;
  }), a.d(e, "faClone", function () {
    return T;
  }), a.d(e, "faClosedCaptioning", function () {
    return D;
  }), a.d(e, "faComment", function () {
    return j;
  }), a.d(e, "faCommentAlt", function () {
    return E;
  }), a.d(e, "faCommentDots", function () {
    return k;
  }), a.d(e, "faComments", function () {
    return I;
  }), a.d(e, "faCompass", function () {
    return O;
  }), a.d(e, "faCopy", function () {
    return Q;
  }), a.d(e, "faCopyright", function () {
    return Z;
  }), a.d(e, "faCreditCard", function () {
    return U;
  }), a.d(e, "faDizzy", function () {
    return B;
  }), a.d(e, "faDotCircle", function () {
    return R;
  }), a.d(e, "faEdit", function () {
    return Y;
  }), a.d(e, "faEnvelope", function () {
    return P;
  }), a.d(e, "faEnvelopeOpen", function () {
    return F;
  }), a.d(e, "faEye", function () {
    return W;
  }), a.d(e, "faEyeSlash", function () {
    return G;
  }), a.d(e, "faFile", function () {
    return q;
  }), a.d(e, "faFileAlt", function () {
    return J;
  }), a.d(e, "faFileArchive", function () {
    return K;
  }), a.d(e, "faFileAudio", function () {
    return X;
  }), a.d(e, "faFileCode", function () {
    return _;
  }), a.d(e, "faFileExcel", function () {
    return $;
  }), a.d(e, "faFileImage", function () {
    return cc;
  }), a.d(e, "faFilePdf", function () {
    return ec;
  }), a.d(e, "faFilePowerpoint", function () {
    return ac;
  }), a.d(e, "faFileVideo", function () {
    return nc;
  }), a.d(e, "faFileWord", function () {
    return tc;
  }), a.d(e, "faFlag", function () {
    return rc;
  }), a.d(e, "faFlushed", function () {
    return ic;
  }), a.d(e, "faFolder", function () {
    return oc;
  }), a.d(e, "faFolderOpen", function () {
    return lc;
  }), a.d(e, "faFontAwesomeLogoFull", function () {
    return fc;
  }), a.d(e, "faFrown", function () {
    return sc;
  }), a.d(e, "faFrownOpen", function () {
    return uc;
  }), a.d(e, "faFutbol", function () {
    return hc;
  }), a.d(e, "faGem", function () {
    return mc;
  }), a.d(e, "faGrimace", function () {
    return vc;
  }), a.d(e, "faGrin", function () {
    return dc;
  }), a.d(e, "faGrinAlt", function () {
    return Mc;
  }), a.d(e, "faGrinBeam", function () {
    return pc;
  }), a.d(e, "faGrinBeamSweat", function () {
    return zc;
  }), a.d(e, "faGrinHearts", function () {
    return Cc;
  }), a.d(e, "faGrinSquint", function () {
    return Lc;
  }), a.d(e, "faGrinSquintTears", function () {
    return Ac;
  }), a.d(e, "faGrinStars", function () {
    return Nc;
  }), a.d(e, "faGrinTears", function () {
    return gc;
  }), a.d(e, "faGrinTongue", function () {
    return Hc;
  }), a.d(e, "faGrinTongueSquint", function () {
    return Vc;
  }), a.d(e, "faGrinTongueWink", function () {
    return xc;
  }), a.d(e, "faGrinWink", function () {
    return wc;
  }), a.d(e, "faHandLizard", function () {
    return yc;
  }), a.d(e, "faHandPaper", function () {
    return bc;
  }), a.d(e, "faHandPeace", function () {
    return Sc;
  }), a.d(e, "faHandPointDown", function () {
    return Tc;
  }), a.d(e, "faHandPointLeft", function () {
    return Dc;
  }), a.d(e, "faHandPointRight", function () {
    return jc;
  }), a.d(e, "faHandPointUp", function () {
    return Ec;
  }), a.d(e, "faHandPointer", function () {
    return kc;
  }), a.d(e, "faHandRock", function () {
    return Ic;
  }), a.d(e, "faHandScissors", function () {
    return Oc;
  }), a.d(e, "faHandSpock", function () {
    return Qc;
  }), a.d(e, "faHandshake", function () {
    return Zc;
  }), a.d(e, "faHdd", function () {
    return Uc;
  }), a.d(e, "faHeart", function () {
    return Bc;
  }), a.d(e, "faHospital", function () {
    return Rc;
  }), a.d(e, "faHourglass", function () {
    return Yc;
  }), a.d(e, "faIdBadge", function () {
    return Pc;
  }), a.d(e, "faIdCard", function () {
    return Fc;
  }), a.d(e, "faImage", function () {
    return Wc;
  }), a.d(e, "faImages", function () {
    return Gc;
  }), a.d(e, "faKeyboard", function () {
    return qc;
  }), a.d(e, "faKiss", function () {
    return Jc;
  }), a.d(e, "faKissBeam", function () {
    return Kc;
  }), a.d(e, "faKissWinkHeart", function () {
    return Xc;
  }), a.d(e, "faLaugh", function () {
    return _c;
  }), a.d(e, "faLaughBeam", function () {
    return $c;
  }), a.d(e, "faLaughSquint", function () {
    return ce;
  }), a.d(e, "faLaughWink", function () {
    return ee;
  }), a.d(e, "faLemon", function () {
    return ae;
  }), a.d(e, "faLifeRing", function () {
    return ne;
  }), a.d(e, "faLightbulb", function () {
    return te;
  }), a.d(e, "faListAlt", function () {
    return re;
  }), a.d(e, "faMap", function () {
    return ie;
  }), a.d(e, "faMeh", function () {
    return oe;
  }), a.d(e, "faMehBlank", function () {
    return le;
  }), a.d(e, "faMehRollingEyes", function () {
    return fe;
  }), a.d(e, "faMinusSquare", function () {
    return se;
  }), a.d(e, "faMoneyBillAlt", function () {
    return ue;
  }), a.d(e, "faMoon", function () {
    return he;
  }), a.d(e, "faNewspaper", function () {
    return me;
  }), a.d(e, "faObjectGroup", function () {
    return ve;
  }), a.d(e, "faObjectUngroup", function () {
    return de;
  }), a.d(e, "faPaperPlane", function () {
    return Me;
  }), a.d(e, "faPauseCircle", function () {
    return pe;
  }), a.d(e, "faPlayCircle", function () {
    return ze;
  }), a.d(e, "faPlusSquare", function () {
    return Ce;
  }), a.d(e, "faQuestionCircle", function () {
    return Le;
  }), a.d(e, "faRegistered", function () {
    return Ae;
  }), a.d(e, "faSadCry", function () {
    return Ne;
  }), a.d(e, "faSadTear", function () {
    return ge;
  }), a.d(e, "faSave", function () {
    return He;
  }), a.d(e, "faShareSquare", function () {
    return Ve;
  }), a.d(e, "faSmile", function () {
    return xe;
  }), a.d(e, "faSmileBeam", function () {
    return we;
  }), a.d(e, "faSmileWink", function () {
    return ye;
  }), a.d(e, "faSnowflake", function () {
    return be;
  }), a.d(e, "faSquare", function () {
    return Se;
  }), a.d(e, "faStar", function () {
    return Te;
  }), a.d(e, "faStarHalf", function () {
    return De;
  }), a.d(e, "faStickyNote", function () {
    return je;
  }), a.d(e, "faStopCircle", function () {
    return Ee;
  }), a.d(e, "faSun", function () {
    return ke;
  }), a.d(e, "faSurprise", function () {
    return Ie;
  }), a.d(e, "faThumbsDown", function () {
    return Oe;
  }), a.d(e, "faThumbsUp", function () {
    return Qe;
  }), a.d(e, "faTimesCircle", function () {
    return Ze;
  }), a.d(e, "faTired", function () {
    return Ue;
  }), a.d(e, "faTrashAlt", function () {
    return Be;
  }), a.d(e, "faUser", function () {
    return Re;
  }), a.d(e, "faUserCircle", function () {
    return Ye;
  }), a.d(e, "faWindowClose", function () {
    return Pe;
  }), a.d(e, "faWindowMaximize", function () {
    return Fe;
  }), a.d(e, "faWindowMinimize", function () {
    return We;
  }), a.d(e, "faWindowRestore", function () {
    return Ge;
  });
  /*!
   * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
   * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
   */

  var n = "far",
      t = {
    prefix: "far",
    iconName: "address-book",
    icon: [448, 512, [], "f2b9", "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"]
  },
      r = {
    prefix: "far",
    iconName: "address-card",
    icon: [576, 512, [], "f2bb", "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"]
  },
      i = {
    prefix: "far",
    iconName: "angry",
    icon: [496, 512, [], "f556", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-144c-33.6 0-65.2 14.8-86.8 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.2 33.8-3c24.8-29.7 75-29.7 99.8 0 8.1 9.7 23.2 11.9 33.8 3 10.2-8.5 11.5-23.6 3.1-33.8-21.6-25.8-53.2-40.6-86.8-40.6zm-48-72c10.3 0 19.9-6.7 23-17.1 3.8-12.7-3.4-26.1-16.1-29.9l-80-24c-12.8-3.9-26.1 3.4-29.9 16.1-3.8 12.7 3.4 26.1 16.1 29.9l28.2 8.5c-3.1 4.9-5.3 10.4-5.3 16.6 0 17.7 14.3 32 32 32s32-14.4 32-32.1zm199-54.9c-3.8-12.7-17.1-19.9-29.9-16.1l-80 24c-12.7 3.8-19.9 17.2-16.1 29.9 3.1 10.4 12.7 17.1 23 17.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.2-2.2-11.7-5.3-16.6l28.2-8.5c12.7-3.7 19.9-17.1 16.1-29.8z"]
  },
      o = {
    prefix: "far",
    iconName: "arrow-alt-circle-down",
    icon: [512, 512, [], "f358", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"]
  },
      l = {
    prefix: "far",
    iconName: "arrow-alt-circle-left",
    icon: [512, 512, [], "f359", "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"]
  },
      f = {
    prefix: "far",
    iconName: "arrow-alt-circle-right",
    icon: [512, 512, [], "f35a", "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"]
  },
      s = {
    prefix: "far",
    iconName: "arrow-alt-circle-up",
    icon: [512, 512, [], "f35b", "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm20 328h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z"]
  },
      u = {
    prefix: "far",
    iconName: "bell",
    icon: [448, 512, [], "f0f3", "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"]
  },
      h = {
    prefix: "far",
    iconName: "bell-slash",
    icon: [640, 512, [], "f1f6", "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM163.53 368c16.71-22.03 34.48-55.8 41.4-110.58l-45.47-35.55c-3.27 90.73-36.47 120.68-54.84 140.42-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h279.66l-61.4-48H163.53zM320 96c61.86 0 112 50.14 112 112 0 .2-.06.38-.06.58.02 16.84 1.16 31.77 2.79 45.73l59.53 46.54c-8.31-22.13-14.34-51.49-14.34-92.85 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-26.02 5.41-49.45 16.94-69.13 32.72l38.17 29.84C275 103.18 296.65 96 320 96zm0 416c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"]
  },
      m = {
    prefix: "far",
    iconName: "bookmark",
    icon: [384, 512, [], "f02e", "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"]
  },
      v = {
    prefix: "far",
    iconName: "building",
    icon: [448, 512, [], "f1ad", "M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"]
  },
      d = {
    prefix: "far",
    iconName: "calendar",
    icon: [448, 512, [], "f133", "M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"]
  },
      M = {
    prefix: "far",
    iconName: "calendar-alt",
    icon: [448, 512, [], "f073", "M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"]
  },
      p = {
    prefix: "far",
    iconName: "calendar-check",
    icon: [448, 512, [], "f274", "M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"]
  },
      z = {
    prefix: "far",
    iconName: "calendar-minus",
    icon: [448, 512, [], "f272", "M124 328c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H124zm324-216v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"]
  },
      C = {
    prefix: "far",
    iconName: "calendar-plus",
    icon: [448, 512, [], "f271", "M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"]
  },
      L = {
    prefix: "far",
    iconName: "calendar-times",
    icon: [448, 512, [], "f273", "M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0L224 337.9l-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17L257.9 304l53.7 53.7c4.8 4.7 4.8 12.3.1 17zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"]
  },
      A = {
    prefix: "far",
    iconName: "caret-square-down",
    icon: [448, 512, [], "f150", "M125.1 208h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"]
  },
      N = {
    prefix: "far",
    iconName: "caret-square-left",
    icon: [448, 512, [], "f191", "M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"]
  },
      g = {
    prefix: "far",
    iconName: "caret-square-right",
    icon: [448, 512, [], "f152", "M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"]
  },
      H = {
    prefix: "far",
    iconName: "caret-square-up",
    icon: [448, 512, [], "f151", "M322.9 304H125.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"]
  },
      V = {
    prefix: "far",
    iconName: "chart-bar",
    icon: [512, 512, [], "f080", "M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"]
  },
      x = {
    prefix: "far",
    iconName: "check-circle",
    icon: [512, 512, [], "f058", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"]
  },
      w = {
    prefix: "far",
    iconName: "check-square",
    icon: [448, 512, [], "f14a", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"]
  },
      y = {
    prefix: "far",
    iconName: "circle",
    icon: [512, 512, [], "f111", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"]
  },
      b = {
    prefix: "far",
    iconName: "clipboard",
    icon: [384, 512, [], "f328", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"]
  },
      S = {
    prefix: "far",
    iconName: "clock",
    icon: [512, 512, [], "f017", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"]
  },
      T = {
    prefix: "far",
    iconName: "clone",
    icon: [512, 512, [], "f24d", "M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"]
  },
      D = {
    prefix: "far",
    iconName: "closed-captioning",
    icon: [512, 512, [], "f20a", "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-211.1-85.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7zm190.4 0c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 220.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7z"]
  },
      j = {
    prefix: "far",
    iconName: "comment",
    icon: [512, 512, [], "f075", "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"]
  },
      E = {
    prefix: "far",
    iconName: "comment-alt",
    icon: [512, 512, [], "f27a", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z"]
  },
      k = {
    prefix: "far",
    iconName: "comment-dots",
    icon: [512, 512, [], "f4ad", "M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"]
  },
      I = {
    prefix: "far",
    iconName: "comments",
    icon: [576, 512, [], "f086", "M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"]
  },
      O = {
    prefix: "far",
    iconName: "compass",
    icon: [496, 512, [], "f14e", "M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"]
  },
      Q = {
    prefix: "far",
    iconName: "copy",
    icon: [448, 512, [], "f0c5", "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"]
  },
      Z = {
    prefix: "far",
    iconName: "copyright",
    icon: [512, 512, [], "f1f9", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm107.351-101.064c-9.614 9.712-45.53 41.396-104.065 41.396-82.43 0-140.484-61.425-140.484-141.567 0-79.152 60.275-139.401 139.762-139.401 55.531 0 88.738 26.62 97.593 34.779a11.965 11.965 0 0 1 1.936 15.322l-18.155 28.113c-3.841 5.95-11.966 7.282-17.499 2.921-8.595-6.776-31.814-22.538-61.708-22.538-48.303 0-77.916 35.33-77.916 80.082 0 41.589 26.888 83.692 78.277 83.692 32.657 0 56.843-19.039 65.726-27.225 5.27-4.857 13.596-4.039 17.82 1.738l19.865 27.17a11.947 11.947 0 0 1-1.152 15.518z"]
  },
      U = {
    prefix: "far",
    iconName: "credit-card",
    icon: [576, 512, [], "f09d", "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"]
  },
      B = {
    prefix: "far",
    iconName: "dizzy",
    icon: [496, 512, [], "f567", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9c7.8-7.8 7.8-20.5 0-28.3L196.3 192l17.9-17.9c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0L168 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.9 7.7 20.5 7.7 28.4-.2zm160-92.2c-7.8-7.8-20.5-7.8-28.3 0L328 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-17.8-18 17.9-17.9c7.7-7.8 7.7-20.4 0-28.2zM248 272c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"]
  },
      R = {
    prefix: "far",
    iconName: "dot-circle",
    icon: [512, 512, [], "f192", "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"]
  },
      Y = {
    prefix: "far",
    iconName: "edit",
    icon: [576, 512, [], "f044", "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"]
  },
      P = {
    prefix: "far",
    iconName: "envelope",
    icon: [512, 512, [], "f0e0", "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"]
  },
      F = {
    prefix: "far",
    iconName: "envelope-open",
    icon: [512, 512, [], "f2b6", "M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"]
  },
      W = {
    prefix: "far",
    iconName: "eye",
    icon: [576, 512, [], "f06e", "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"]
  },
      G = {
    prefix: "far",
    iconName: "eye-slash",
    icon: [640, 512, [], "f070", "M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z"]
  },
      q = {
    prefix: "far",
    iconName: "file",
    icon: [384, 512, [], "f15b", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"]
  },
      J = {
    prefix: "far",
    iconName: "file-alt",
    icon: [384, 512, [], "f15c", "M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"]
  },
      K = {
    prefix: "far",
    iconName: "file-archive",
    icon: [384, 512, [], "f1c6", "M128.3 160v32h32v-32zm64-96h-32v32h32zm-64 32v32h32V96zm64 32h-32v32h32zm177.6-30.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h79.7v16h32V48H208v104c0 13.3 10.7 24 24 24h104zM194.2 265.7c-1.1-5.6-6-9.7-11.8-9.7h-22.1v-32h-32v32l-19.7 97.1C102 385.6 126.8 416 160 416c33.1 0 57.9-30.2 51.5-62.6zm-33.9 124.4c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zm32-198.1h-32v32h32z"]
  },
      X = {
    prefix: "far",
    iconName: "file-audio",
    icon: [384, 512, [], "f1c7", "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z"]
  },
      _ = {
    prefix: "far",
    iconName: "file-code",
    icon: [384, 512, [], "f1c9", "M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z"]
  },
      $ = {
    prefix: "far",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"]
  },
      cc = {
    prefix: "far",
    iconName: "file-image",
    icon: [384, 512, [], "f1c5", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"]
  },
      ec = {
    prefix: "far",
    iconName: "file-pdf",
    icon: [384, 512, [], "f1c1", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"]
  },
      ac = {
    prefix: "far",
    iconName: "file-powerpoint",
    icon: [384, 512, [], "f1c4", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"]
  },
      nc = {
    prefix: "far",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"]
  },
      tc = {
    prefix: "far",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"]
  },
      rc = {
    prefix: "far",
    iconName: "flag",
    icon: [512, 512, [], "f024", "M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z"]
  },
      ic = {
    prefix: "far",
    iconName: "flushed",
    icon: [496, 512, [], "f579", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm96-312c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 144H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"]
  },
      oc = {
    prefix: "far",
    iconName: "folder",
    icon: [512, 512, [], "f07b", "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"]
  },
      lc = {
    prefix: "far",
    iconName: "folder-open",
    icon: [576, 512, [], "f07c", "M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z"]
  },
      fc = {
    prefix: "far",
    iconName: "font-awesome-logo-full",
    icon: [3992, 512, ["Font Awesome"], "f4e6", "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"]
  },
      sc = {
    prefix: "far",
    iconName: "frown",
    icon: [496, 512, [], "f119", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"]
  },
      uc = {
    prefix: "far",
    iconName: "frown-open",
    icon: [496, 512, [], "f57a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-48-248c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-35.6 0-88.8 21.3-95.8 61.2-2 11.8 9 21.5 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3c11.4 3.5 22.5-6.3 20.5-18.1-7-39.9-60.2-61.2-95.8-61.2z"]
  },
      hc = {
    prefix: "far",
    iconName: "futbol",
    icon: [496, 512, [], "f1e3", "M483.8 179.4C449.8 74.6 352.6 8 248.1 8c-25.4 0-51.2 3.9-76.7 12.2C41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504c25.4 0 51.2-3.9 76.7-12.2 130.2-42.3 201.5-182.2 159.2-312.4zm-74.5 193.7l-52.2 6.4-43.7-60.9 24.4-75.2 71.1-22.1 38.9 36.4c-.2 30.7-7.4 61.1-21.7 89.2-4.7 9.3-10.7 17.8-16.8 26.2zm0-235.4l-10.4 53.1-70.7 22-64.2-46.5V92.5l47.4-26.2c39.2 13 73.4 38 97.9 71.4zM184.9 66.4L232 92.5v73.8l-64.2 46.5-70.6-22-10.1-52.5c24.3-33.4 57.9-58.6 97.8-71.9zM139 379.5L85.9 373c-14.4-20.1-37.3-59.6-37.8-115.3l39-36.4 71.1 22.2 24.3 74.3-43.5 61.7zm48.2 67l-22.4-48.1 43.6-61.7H287l44.3 61.7-22.4 48.1c-6.2 1.8-57.6 20.4-121.7 0z"]
  },
      mc = {
    prefix: "far",
    iconName: "gem",
    icon: [576, 512, [], "f3a5", "M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"]
  },
      vc = {
    prefix: "far",
    iconName: "grimace",
    icon: [496, 512, [], "f57f", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 16H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"]
  },
      dc = {
    prefix: "far",
    iconName: "grin",
    icon: [496, 512, [], "f580", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"]
  },
      Mc = {
    prefix: "far",
    iconName: "grin-alt",
    icon: [496, 512, [], "f581", "M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"]
  },
      pc = {
    prefix: "far",
    iconName: "grin-beam",
    icon: [496, 512, [], "f582", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-235.9-72.9c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3z"]
  },
      zc = {
    prefix: "far",
    iconName: "grin-beam-sweat",
    icon: [496, 512, [], "f583", "M440 160c29.5 0 53.3-26.3 53.3-58.7 0-25-31.7-75.5-46.2-97.3-3.6-5.3-10.7-5.3-14.2 0-14.5 21.8-46.2 72.3-46.2 97.3 0 32.4 23.8 58.7 53.3 58.7zM248 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zm105.3-52.9c-24.6 15.7-46 12.9-46.4 12.9 6.9 20.2 10.8 41.8 10.8 64.3 0 110.3-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56c39.8 0 76.8 11.8 108 31.9 1.7-9.5 6.3-24.1 17.2-45.7C336.4 20.6 293.7 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-27-4.4-52.9-12.4-77.2zM168 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"]
  },
      Cc = {
    prefix: "far",
    iconName: "grin-hearts",
    icon: [496, 512, [], "f584", "M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"]
  },
      Lc = {
    prefix: "far",
    iconName: "grin-squint",
    icon: [496, 512, [], "f585", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-234.7-40.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.4-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.8-4.4-10.2-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48z"]
  },
      Ac = {
    prefix: "far",
    iconName: "grin-squint-tears",
    icon: [512, 512, [], "f586", "M117.1 384.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 479 124.3 420.8 128 395c.8-6.4-4.6-11.8-10.9-10.9zm-41.2-41.7C40.3 268 53 176.1 114.6 114.6 152.4 76.8 202.6 56 256 56c36.2 0 70.8 9.8 101.2 27.7 3.8-20.3 8-36.1 12-48.3C333.8 17.2 294.9 8 256 8 192.5 8 129.1 32.2 80.6 80.6c-74.1 74.1-91.3 183.4-52 274 12.2-4.1 27.7-8.3 47.3-12.2zm352.3-187.6c45 76.6 34.9 176.9-30.8 242.6-37.8 37.8-88 58.6-141.4 58.6-30.5 0-59.8-7-86.4-19.8-3.9 19.5-8 35-12.2 47.2 31.4 13.6 65 20.6 98.7 20.6 63.5 0 126.9-24.2 175.4-72.6 78.1-78.1 93.1-195.4 45.2-288.6-12.3 4-28.2 8.1-48.5 12zm-33.3-26.9c25.8-3.7 84-13.7 100.9-30.6 21.9-21.9 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9C397.7 33 387.7 91.2 384 117c-.8 6.4 4.6 11.8 10.9 10.9zm-187 108.3c-3-3-7.2-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9h.9c5.5 0 10.3-3.7 11.7-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.6-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm52 88.5c-29.1 29.1-59.7 52.9-83.9 65.4-9.2 4.8-10 17.5-1.7 23.4 38.9 27.7 107 6.2 143.7-30.6S416 253 388.3 214.1c-5.8-8.2-18.5-7.6-23.4 1.7-12.3 24.2-36.2 54.7-65.3 83.8z"]
  },
      Nc = {
    prefix: "far",
    iconName: "grin-stars",
    icon: [496, 512, [], "f587", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-227.9-57.5c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.5 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6.1 34.9zm259.7-72.7l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.6 1.8-12.2-4.4-13.2z"]
  },
      gc = {
    prefix: "far",
    iconName: "grin-tears",
    icon: [640, 512, [], "f588", "M117.1 256.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 351 124.3 292.8 128 267c.8-6.4-4.6-11.8-10.9-10.9zm506.7 30.6c-16.9-16.9-75.1-26.9-100.9-30.6-6.3-.9-11.7 4.5-10.8 10.8 3.7 25.8 13.7 84 30.6 100.9 21.9 21.9 57.9 21.5 80.3-.9 22.3-22.3 22.7-58.3.8-80.2zm-126.6 61.7C463.8 412.3 396.9 456 320 456c-76.9 0-143.8-43.7-177.2-107.6-12.5 37.4-25.2 43.9-28.3 46.5C159.1 460.7 234.5 504 320 504s160.9-43.3 205.5-109.1c-3.2-2.7-15.9-9.2-28.3-46.5zM122.7 224.5C137.9 129.2 220.5 56 320 56c99.5 0 182.1 73.2 197.3 168.5 2.1-.2 5.2-2.4 49.5 7C554.4 106 448.7 8 320 8S85.6 106 73.2 231.4c44.5-9.4 47.1-7.2 49.5-6.9zM320 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zM240 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"]
  },
      Hc = {
    prefix: "far",
    iconName: "grin-tongue",
    icon: [496, 512, [], "f589", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      Vc = {
    prefix: "far",
    iconName: "grin-tongue-squint",
    icon: [496, 512, [], "f58a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zm36.9-281.1c-3.8-4.4-10.3-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"]
  },
      xc = {
    prefix: "far",
    iconName: "grin-tongue-wink",
    icon: [496, 512, [], "f58b", "M152 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm176-52c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3z"]
  },
      wc = {
    prefix: "far",
    iconName: "grin-wink",
    icon: [496, 512, [], "f58c", "M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"]
  },
      yc = {
    prefix: "far",
    iconName: "hand-lizard",
    icon: [576, 512, [], "f258", "M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z"]
  },
      bc = {
    prefix: "far",
    iconName: "hand-paper",
    icon: [448, 512, [], "f256", "M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"]
  },
      Sc = {
    prefix: "far",
    iconName: "hand-peace",
    icon: [448, 512, [], "f25b", "M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z"]
  },
      Tc = {
    prefix: "far",
    iconName: "hand-point-down",
    icon: [448, 512, [], "f0a7", "M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z"]
  },
      Dc = {
    prefix: "far",
    iconName: "hand-point-left",
    icon: [512, 512, [], "f0a5", "M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"]
  },
      jc = {
    prefix: "far",
    iconName: "hand-point-right",
    icon: [512, 512, [], "f0a4", "M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"]
  },
      Ec = {
    prefix: "far",
    iconName: "hand-point-up",
    icon: [448, 512, [], "f0a6", "M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"]
  },
      kc = {
    prefix: "far",
    iconName: "hand-pointer",
    icon: [448, 512, [], "f25a", "M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z"]
  },
      Ic = {
    prefix: "far",
    iconName: "hand-rock",
    icon: [512, 512, [], "f255", "M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z"]
  },
      Oc = {
    prefix: "far",
    iconName: "hand-scissors",
    icon: [512, 512, [], "f257", "M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z"]
  },
      Qc = {
    prefix: "far",
    iconName: "hand-spock",
    icon: [512, 512, [], "f259", "M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z"]
  },
      Zc = {
    prefix: "far",
    iconName: "handshake",
    icon: [640, 512, [], "f2b5", "M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"]
  },
      Uc = {
    prefix: "far",
    iconName: "hdd",
    icon: [576, 512, [], "f0a0", "M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"]
  },
      Bc = {
    prefix: "far",
    iconName: "heart",
    icon: [512, 512, [], "f004", "M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"]
  },
      Rc = {
    prefix: "far",
    iconName: "hospital",
    icon: [448, 512, [], "f0f8", "M128 244v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12zm140 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-76 84v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm76 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 124v36H0v-36c0-6.627 5.373-12 12-12h19.5V85.035C31.5 73.418 42.245 64 55.5 64H144V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88.5c13.255 0 24 9.418 24 21.035V464H436c6.627 0 12 5.373 12 12zM79.5 463H192v-67c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v67h112.5V112H304v24c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24v-24H79.5v351zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"]
  },
      Yc = {
    prefix: "far",
    iconName: "hourglass",
    icon: [384, 512, [], "f254", "M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.899 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zM64 48h256c0 101.62-57.307 184-128 184S64 149.621 64 48zm256 416H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"]
  },
      Pc = {
    prefix: "far",
    iconName: "id-badge",
    icon: [384, 512, [], "f2c1", "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"]
  },
      Fc = {
    prefix: "far",
    iconName: "id-card",
    icon: [576, 512, [], "f2c2", "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"]
  },
      Wc = {
    prefix: "far",
    iconName: "image",
    icon: [512, 512, [], "f03e", "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"]
  },
      Gc = {
    prefix: "far",
    iconName: "images",
    icon: [576, 512, [], "f302", "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"]
  },
      qc = {
    prefix: "far",
    iconName: "keyboard",
    icon: [576, 512, [], "f11c", "M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm8 336c0 4.411-3.589 8-8 8H48c-4.411 0-8-3.589-8-8V112c0-4.411 3.589-8 8-8h480c4.411 0 8 3.589 8 8v288zM170 270v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-336 82v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm384 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zM122 188v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-98 158v-16c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"]
  },
      Jc = {
    prefix: "far",
    iconName: "kiss",
    icon: [496, 512, [], "f596", "M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm136 132c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      Kc = {
    prefix: "far",
    iconName: "kiss-beam",
    icon: [496, 512, [], "f597", "M168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm56-148c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zm24-156c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"]
  },
      Xc = {
    prefix: "far",
    iconName: "kiss-wink-heart",
    icon: [504, 512, [], "f598", "M304 308.5c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36 21.7-9.1 35.1-23.4 35.1-36.4zm70.5-83.5l9.5 8.5c3.8 3.3 9.3 4 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 5.8 3.1 11.2.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM136 208.5c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm365.1 194c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zM334 436.3c-26.1 12.5-55.2 19.7-86 19.7-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200c0 22.1-3.7 43.3-10.4 63.2 9 6.4 17 14.2 22.6 23.9 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-2.5-7.3 4.3 17.2-13.4-46.8z"]
  },
      _c = {
    prefix: "far",
    iconName: "laugh",
    icon: [496, 512, [], "f599", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"]
  },
      $c = {
    prefix: "far",
    iconName: "laugh-beam",
    icon: [496, 512, [], "f59a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 152c-23.8 0-52.7 29.3-56 71.4-.7 8.6 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.1-42.1-32-71.4-55.8-71.4zm-201 75.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"]
  },
      ce = {
    prefix: "far",
    iconName: "laugh-squint",
    icon: [496, 512, [], "f59b", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196zm-209.4 58.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"]
  },
      ee = {
    prefix: "far",
    iconName: "laugh-wink",
    icon: [496, 512, [], "f59c", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"]
  },
      ae = {
    prefix: "far",
    iconName: "lemon",
    icon: [512, 512, [], "f094", "M484.112 27.889C455.989-.233 416.108-8.057 387.059 8.865 347.604 31.848 223.504-41.111 91.196 91.197-41.277 223.672 31.923 347.472 8.866 387.058c-16.922 29.051-9.1 68.932 19.022 97.054 28.135 28.135 68.011 35.938 97.057 19.021 39.423-22.97 163.557 49.969 295.858-82.329 132.474-132.477 59.273-256.277 82.331-295.861 16.922-29.05 9.1-68.931-19.022-97.054zm-22.405 72.894c-38.8 66.609 45.6 165.635-74.845 286.08-120.44 120.443-219.475 36.048-286.076 74.843-22.679 13.207-64.035-27.241-50.493-50.488 38.8-66.609-45.6-165.635 74.845-286.08C245.573 4.702 344.616 89.086 411.219 50.292c22.73-13.24 64.005 27.288 50.488 50.491zm-169.861 8.736c1.37 10.96-6.404 20.957-17.365 22.327-54.846 6.855-135.779 87.787-142.635 142.635-1.373 10.989-11.399 18.734-22.326 17.365-10.961-1.37-18.735-11.366-17.365-22.326 9.162-73.286 104.167-168.215 177.365-177.365 10.953-1.368 20.956 6.403 22.326 17.364z"]
  },
      ne = {
    prefix: "far",
    iconName: "life-ring",
    icon: [512, 512, [], "f1cd", "M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"]
  },
      te = {
    prefix: "far",
    iconName: "lightbulb",
    icon: [352, 512, [], "f0eb", "M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"]
  },
      re = {
    prefix: "far",
    iconName: "list-alt",
    icon: [512, 512, [], "f022", "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z"]
  },
      ie = {
    prefix: "far",
    iconName: "map",
    icon: [576, 512, [], "f279", "M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z"]
  },
      oe = {
    prefix: "far",
    iconName: "meh",
    icon: [496, 512, [], "f11a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"]
  },
      le = {
    prefix: "far",
    iconName: "meh-blank",
    icon: [496, 512, [], "f5a4", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      fe = {
    prefix: "far",
    iconName: "meh-rolling-eyes",
    icon: [496, 512, [], "f5a5", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm88-304c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm-104-40c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-112 0c0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40s-40-17.9-40-40zm192 128H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"]
  },
      se = {
    prefix: "far",
    iconName: "minus-square",
    icon: [448, 512, [], "f146", "M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"]
  },
      ue = {
    prefix: "far",
    iconName: "money-bill-alt",
    icon: [640, 512, [], "f3d1", "M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm40 168c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h16v-55.44l-.47.31a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09l15.33-10.22a23.99 23.99 0 0 1 13.31-4.03H328c4.42 0 8 3.58 8 8v88h16c4.42 0 8 3.58 8 8v16zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160z"]
  },
      he = {
    prefix: "far",
    iconName: "moon",
    icon: [512, 512, [], "f186", "M279.135 512c78.756 0 150.982-35.804 198.844-94.775 28.27-34.831-2.558-85.722-46.249-77.401-82.348 15.683-158.272-47.268-158.272-130.792 0-48.424 26.06-92.292 67.434-115.836 38.745-22.05 28.999-80.788-15.022-88.919A257.936 257.936 0 0 0 279.135 0c-141.36 0-256 114.575-256 256 0 141.36 114.576 256 256 256zm0-464c12.985 0 25.689 1.201 38.016 3.478-54.76 31.163-91.693 90.042-91.693 157.554 0 113.848 103.641 199.2 215.252 177.944C402.574 433.964 344.366 464 279.135 464c-114.875 0-208-93.125-208-208s93.125-208 208-208z"]
  },
      me = {
    prefix: "far",
    iconName: "newspaper",
    icon: [576, 512, [], "f1ea", "M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"]
  },
      ve = {
    prefix: "far",
    iconName: "object-group",
    icon: [512, 512, [], "f247", "M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z"]
  },
      de = {
    prefix: "far",
    iconName: "object-ungroup",
    icon: [576, 512, [], "f248", "M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12h-88v-24h12c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h88v24h-12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V224h12zM352 64h32v32h-32V64zm0 256h32v32h-32v-32zM64 352H32v-32h32v32zm0-256H32V64h32v32zm32 216v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h12v160h-12c-6.627 0-12 5.373-12 12v12H96zm128 136h-32v-32h32v32zm280-64h-12c-6.627 0-12 5.373-12 12v12H256v-12c0-6.627-5.373-12-12-12h-12v-24h88v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12v-88h88v12c0 6.627 5.373 12 12 12h12v160zm40 64h-32v-32h32v32zm0-256h-32v-32h32v32z"]
  },
      Me = {
    prefix: "far",
    iconName: "paper-plane",
    icon: [512, 512, [], "f1d8", "M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"]
  },
      pe = {
    prefix: "far",
    iconName: "pause-circle",
    icon: [512, 512, [], "f28b", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"]
  },
      ze = {
    prefix: "far",
    iconName: "play-circle",
    icon: [512, 512, [], "f144", "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"]
  },
      Ce = {
    prefix: "far",
    iconName: "plus-square",
    icon: [448, 512, [], "f0fe", "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"]
  },
      Le = {
    prefix: "far",
    iconName: "question-circle",
    icon: [512, 512, [], "f059", "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"]
  },
      Ae = {
    prefix: "far",
    iconName: "registered",
    icon: [512, 512, [], "f25d", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm110.442-81.791c-53.046-96.284-50.25-91.468-53.271-96.085 24.267-13.879 39.482-41.563 39.482-73.176 0-52.503-30.247-85.252-101.498-85.252h-78.667c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h38.568c6.617 0 12-5.383 12-12v-83.663h31.958l47.515 89.303a11.98 11.98 0 0 0 10.593 6.36h42.81c9.14 0 14.914-9.799 10.51-17.791zM256.933 239.906h-33.875v-64.14h27.377c32.417 0 38.929 12.133 38.929 31.709-.001 20.913-11.518 32.431-32.431 32.431z"]
  },
      Ne = {
    prefix: "far",
    iconName: "sad-cry",
    icon: [496, 512, [], "f5b3", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"]
  },
      ge = {
    prefix: "far",
    iconName: "sad-tear",
    icon: [496, 512, [], "f5b4", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z"]
  },
      He = {
    prefix: "far",
    iconName: "save",
    icon: [448, 512, [], "f0c7", "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"]
  },
      Ve = {
    prefix: "far",
    iconName: "share-square",
    icon: [576, 512, [], "f14d", "M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"]
  },
      xe = {
    prefix: "far",
    iconName: "smile",
    icon: [496, 512, [], "f118", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"]
  },
      we = {
    prefix: "far",
    iconName: "smile-beam",
    icon: [496, 512, [], "f5b8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM136.5 211c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17zM328 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4z"]
  },
      ye = {
    prefix: "far",
    iconName: "smile-wink",
    icon: [496, 512, [], "f4da", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm117.8-146.4c-10.2-8.5-25.3-7.1-33.8 3.1-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1z"]
  },
      be = {
    prefix: "far",
    iconName: "snowflake",
    icon: [448, 512, [], "f2dc", "M440.1 355.2l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.5-4.4 10.1-14.2 5.8-21.9l-7.9-13.9c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5L306 70.4c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7z"]
  },
      Se = {
    prefix: "far",
    iconName: "square",
    icon: [448, 512, [], "f0c8", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"]
  },
      Te = {
    prefix: "far",
    iconName: "star",
    icon: [576, 512, [], "f005", "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"]
  },
      De = {
    prefix: "far",
    iconName: "star-half",
    icon: [576, 512, [], "f089", "M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"]
  },
      je = {
    prefix: "far",
    iconName: "sticky-note",
    icon: [448, 512, [], "f249", "M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z"]
  },
      Ee = {
    prefix: "far",
    iconName: "stop-circle",
    icon: [512, 512, [], "f28d", "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"]
  },
      ke = {
    prefix: "far",
    iconName: "sun",
    icon: [512, 512, [], "f185", "M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"]
  },
      Ie = {
    prefix: "far",
    iconName: "surprise",
    icon: [496, 512, [], "f5c2", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      Oe = {
    prefix: "far",
    iconName: "thumbs-down",
    icon: [512, 512, [], "f165", "M466.27 225.31c4.674-22.647.864-44.538-8.99-62.99 2.958-23.868-4.021-48.565-17.34-66.99C438.986 39.423 404.117 0 327 0c-7 0-15 .01-22.22.01C201.195.01 168.997 40 128 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v240c0 17.673 14.327 32 32 32h64c11.842 0 22.175-6.438 27.708-16h7.052c19.146 16.953 46.013 60.653 68.76 83.4 13.667 13.667 10.153 108.6 71.76 108.6 57.58 0 95.27-31.936 95.27-104.73 0-18.41-3.93-33.73-8.85-46.54h36.48c48.602 0 85.82-41.565 85.82-85.58 0-19.15-4.96-34.99-13.73-49.84zM64 296c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm330.18 16.73H290.19c0 37.82 28.36 55.37 28.36 94.54 0 23.75 0 56.73-47.27 56.73-18.91-18.91-9.46-66.18-37.82-94.54C206.9 342.89 167.28 272 138.92 272H128V85.83c53.611 0 100.001-37.82 171.64-37.82h37.82c35.512 0 60.82 17.12 53.12 65.9 15.2 8.16 26.5 36.44 13.94 57.57 21.581 20.384 18.699 51.065 5.21 65.62 9.45 0 22.36 18.91 22.27 37.81-.09 18.91-16.71 37.82-37.82 37.82z"]
  },
      Qe = {
    prefix: "far",
    iconName: "thumbs-up",
    icon: [512, 512, [], "f164", "M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"]
  },
      Ze = {
    prefix: "far",
    iconName: "times-circle",
    icon: [512, 512, [], "f057", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"]
  },
      Ue = {
    prefix: "far",
    iconName: "tired",
    icon: [496, 512, [], "f5c8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm129.1-303.8c-3.8-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.8 1.6 15.3-2.5 3.8-4.5 3.9-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zM220 208c0-4.2-2.2-8.1-5.8-10.3l-80-48c-5-3-11.5-1.9-15.3 2.5-3.8 4.5-3.9 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.5 4.1 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3zm28 64c-45.4 0-100.9 38.3-107.8 93.3-1.5 11.8 6.9 21.6 15.5 17.9C178.4 373.5 212 368 248 368s69.6 5.5 92.3 15.2c8.5 3.7 17-6 15.5-17.9-6.9-55-62.4-93.3-107.8-93.3z"]
  },
      Be = {
    prefix: "far",
    iconName: "trash-alt",
    icon: [448, 512, [], "f2ed", "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"]
  },
      Re = {
    prefix: "far",
    iconName: "user",
    icon: [448, 512, [], "f007", "M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"]
  },
      Ye = {
    prefix: "far",
    iconName: "user-circle",
    icon: [496, 512, [], "f2bd", "M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"]
  },
      Pe = {
    prefix: "far",
    iconName: "window-close",
    icon: [512, 512, [], "f410", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v340zM356.5 194.6L295.1 256l61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0L256 295.1l-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z"]
  },
      Fe = {
    prefix: "far",
    iconName: "window-maximize",
    icon: [512, 512, [], "f2d0", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"]
  },
      We = {
    prefix: "far",
    iconName: "window-minimize",
    icon: [512, 512, [], "f2d1", "M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z"]
  },
      Ge = {
    prefix: "far",
    iconName: "window-restore",
    icon: [512, 512, [], "f2d2", "M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"]
  },
      qe = {
    faAddressBook: t,
    faAddressCard: r,
    faAngry: i,
    faArrowAltCircleDown: o,
    faArrowAltCircleLeft: l,
    faArrowAltCircleRight: f,
    faArrowAltCircleUp: s,
    faBell: u,
    faBellSlash: h,
    faBookmark: m,
    faBuilding: v,
    faCalendar: d,
    faCalendarAlt: M,
    faCalendarCheck: p,
    faCalendarMinus: z,
    faCalendarPlus: C,
    faCalendarTimes: L,
    faCaretSquareDown: A,
    faCaretSquareLeft: N,
    faCaretSquareRight: g,
    faCaretSquareUp: H,
    faChartBar: V,
    faCheckCircle: x,
    faCheckSquare: w,
    faCircle: y,
    faClipboard: b,
    faClock: S,
    faClone: T,
    faClosedCaptioning: D,
    faComment: j,
    faCommentAlt: E,
    faCommentDots: k,
    faComments: I,
    faCompass: O,
    faCopy: Q,
    faCopyright: Z,
    faCreditCard: U,
    faDizzy: B,
    faDotCircle: R,
    faEdit: Y,
    faEnvelope: P,
    faEnvelopeOpen: F,
    faEye: W,
    faEyeSlash: G,
    faFile: q,
    faFileAlt: J,
    faFileArchive: K,
    faFileAudio: X,
    faFileCode: _,
    faFileExcel: $,
    faFileImage: cc,
    faFilePdf: ec,
    faFilePowerpoint: ac,
    faFileVideo: nc,
    faFileWord: tc,
    faFlag: rc,
    faFlushed: ic,
    faFolder: oc,
    faFolderOpen: lc,
    faFontAwesomeLogoFull: fc,
    faFrown: sc,
    faFrownOpen: uc,
    faFutbol: hc,
    faGem: mc,
    faGrimace: vc,
    faGrin: dc,
    faGrinAlt: Mc,
    faGrinBeam: pc,
    faGrinBeamSweat: zc,
    faGrinHearts: Cc,
    faGrinSquint: Lc,
    faGrinSquintTears: Ac,
    faGrinStars: Nc,
    faGrinTears: gc,
    faGrinTongue: Hc,
    faGrinTongueSquint: Vc,
    faGrinTongueWink: xc,
    faGrinWink: wc,
    faHandLizard: yc,
    faHandPaper: bc,
    faHandPeace: Sc,
    faHandPointDown: Tc,
    faHandPointLeft: Dc,
    faHandPointRight: jc,
    faHandPointUp: Ec,
    faHandPointer: kc,
    faHandRock: Ic,
    faHandScissors: Oc,
    faHandSpock: Qc,
    faHandshake: Zc,
    faHdd: Uc,
    faHeart: Bc,
    faHospital: Rc,
    faHourglass: Yc,
    faIdBadge: Pc,
    faIdCard: Fc,
    faImage: Wc,
    faImages: Gc,
    faKeyboard: qc,
    faKiss: Jc,
    faKissBeam: Kc,
    faKissWinkHeart: Xc,
    faLaugh: _c,
    faLaughBeam: $c,
    faLaughSquint: ce,
    faLaughWink: ee,
    faLemon: ae,
    faLifeRing: ne,
    faLightbulb: te,
    faListAlt: re,
    faMap: ie,
    faMeh: oe,
    faMehBlank: le,
    faMehRollingEyes: fe,
    faMinusSquare: se,
    faMoneyBillAlt: ue,
    faMoon: he,
    faNewspaper: me,
    faObjectGroup: ve,
    faObjectUngroup: de,
    faPaperPlane: Me,
    faPauseCircle: pe,
    faPlayCircle: ze,
    faPlusSquare: Ce,
    faQuestionCircle: Le,
    faRegistered: Ae,
    faSadCry: Ne,
    faSadTear: ge,
    faSave: He,
    faShareSquare: Ve,
    faSmile: xe,
    faSmileBeam: we,
    faSmileWink: ye,
    faSnowflake: be,
    faSquare: Se,
    faStar: Te,
    faStarHalf: De,
    faStickyNote: je,
    faStopCircle: Ee,
    faSun: ke,
    faSurprise: Ie,
    faThumbsDown: Oe,
    faThumbsUp: Qe,
    faTimesCircle: Ze,
    faTired: Ue,
    faTrashAlt: Be,
    faUser: Re,
    faUserCircle: Ye,
    faWindowClose: Pe,
    faWindowMaximize: Fe,
    faWindowMinimize: We,
    faWindowRestore: Ge
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = f(t),
      i = a(303),
      o = f(a(77)),
      l = f(a(84));

  function f(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  function s(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var u = function u(c) {
    var e = c.service,
        a = c.pe,
        n = c.t,
        t = e.name,
        i = e.position,
        o = e.oil_quarts_needed,
        l = e.labor_time_estimate,
        f = a ? a.human_readable_labor_time : l,
        s = void 0;

    if ("Oil Change" === t) {
      var u = i ? n("orderServiceModalInfo:standardLbl") + " " + i + " " : "",
          h = o ? n("orderServiceModalInfo:oilQuartsNeededText", {
        oil_quarts_needed: o
      }) : "";
      s = n("orderServiceModalInfo:oilQuartsNeededDesc", {
        oilDescription: u
      }) + " " + h;
    } else if (a && a.base_vehicle_service) {
      var m = a.base_vehicle_service,
          v = a.oem_parts;
      s = 0 === v && m.base_vehicle_service_prices.length > 0 ? n("orderServiceModalInfo:estimateNotIncludeCostDesc") + " " + m.base_vehicle_service_prices.map(function (c) {
        return c.name;
      }).join(", ") : v > 0 && m.base_vehicle_service_prices.length > 0 ? n("orderServiceModalInfo:estimateIncludeLaborDesc") + " " + m.base_vehicle_service_prices.map(function (c) {
        return c.name;
      }).join(", ") : n("orderServiceModalInfo:estimateIncludeLaborTimeDesc");
    }

    return null == s && null == f ? null : r.default.createElement(r.default.Fragment, null, r.default.createElement("div", {
      className: "modal-title"
    }, n("orderServiceModalInfo:whatIsIncludedText")), r.default.createElement("div", {
      className: "all-caps modal-subtitle"
    }, t), s && r.default.createElement("p", null, s), f && r.default.createElement("p", null, r.default.createElement("div", {
      style: {
        marginTop: "10px",
        fontWeight: "bold"
      }
    }, n("orderServiceModalInfo:workBeginTimeText")), r.default.createElement("div", null, f)));
  },
      h = function h(c) {
    var e = c.service,
        a = c.t,
        n = e.why_do_this,
        t = e.name;
    return r.default.createElement(r.default.Fragment, null, r.default.createElement("div", {
      className: "modal-title"
    }, a("orderServiceModalInfo:whyShouldDoThisText")), r.default.createElement("div", {
      className: "all-caps modal-subtitle"
    }, t), r.default.createElement("p", null, n));
  },
      m = function (c) {
    function e() {
      var c, a, n;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var t = arguments.length, i = Array(t), o = 0; o < t; o++) {
        i[o] = arguments[o];
      }

      return a = n = s(this, (c = e.__proto__ || Object.getPrototypeOf(e)).call.apply(c, [this].concat(i))), n.contentPages = function () {
        var c = n.props.service || {},
            e = n.props,
            a = e.pe,
            t = e.t,
            i = [{
          title: t("orderServiceModalInfo:whatIsIncludedText"),
          content: r.default.createElement(u, {
            service: c,
            pe: a,
            t: t
          })
        }, {
          title: t("orderServiceModalInfo:whyShouldDoThisText"),
          content: c.why_do_this && r.default.createElement(h, {
            service: c,
            t: t
          })
        }].filter(function (c) {
          return null != c.content;
        });
        return 0 === i.length ? [{
          content: r.default.createElement(l.default, {
            subtitle: c.name
          })
        }] : i;
      }, s(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "render",
      value: function value() {
        var c = this.props.user || {},
            e = this.props.styles || {},
            a = this.props,
            n = a.icon,
            t = a.linkText,
            i = a.buttonText,
            l = a.customElement,
            f = a.t;
        return r.default.createElement(o.default, {
          icon: n,
          linkText: t,
          buttonText: i,
          customElement: l,
          styles: e,
          pages: this.contentPages(),
          showCostDiagnosis: !0,
          pe: this.props.pe,
          user: c,
          t: f
        });
      }
    }]), e;
  }();

  e.default = (0, i.connect)(function (c, e) {
    return {
      user: c.user || {}
    };
  }, {})(m);
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (c) {
    var e = c.subtitle,
        a = c.t;
    return r.default.createElement(r.default.Fragment, null, r.default.createElement("div", {
      className: "modal-title"
    }, a("noInformation:noInfoAvailableTitle")), e && r.default.createElement("div", {
      className: "all-caps modal-subtitle"
    }, e), r.default.createElement("div", {
      className: "modal-no-details"
    }, r.default.createElement("p", null, a("noInformation:noInfoAvailableDesc"))));
  };
  var n,
      t = a(0),
      r = (n = t) && n.__esModule ? n : {
    default: n
  };
}, function (c, e, a) {
  var n;
  c.exports = (n = a(0), function (c) {
    function e(n) {
      if (a[n]) return a[n].exports;
      var t = a[n] = {
        exports: {},
        id: n,
        loaded: !1
      };
      return c[n].call(t.exports, t, t.exports, e), t.loaded = !0, t.exports;
    }

    var a = {};
    return e.m = c, e.c = a, e.p = "", e(0);
  }([function (c, e, a) {
    c.exports = a(12);
  }, function (c, e, a) {
    c.exports = a(17)();
  }, function (c, e) {
    "use strict";

    e.__esModule = !0, e.default = function (c) {
      var e = {};

      for (var a in c) {
        Object.prototype.hasOwnProperty.call(c, a) && (e[a] = "number" == typeof c[a] ? c[a] : c[a].val);
      }

      return e;
    }, c.exports = e.default;
  }, function (c, e) {
    c.exports = n;
  }, function (c, e, a) {
    (function (e) {
      (function () {
        var a, n, t;
        "undefined" != typeof performance && null !== performance && performance.now ? c.exports = function () {
          return performance.now();
        } : null != e && e.hrtime ? (c.exports = function () {
          return (a() - t) / 1e6;
        }, n = e.hrtime, t = (a = function a() {
          var c;
          return 1e9 * (c = n())[0] + c[1];
        })()) : Date.now ? (c.exports = function () {
          return Date.now() - t;
        }, t = Date.now()) : (c.exports = function () {
          return new Date().getTime() - t;
        }, t = new Date().getTime());
      }).call(this);
    }).call(e, a(9));
  }, function (c, e, a) {
    (function (e) {
      for (var n = a(19), t = "undefined" == typeof window ? e : window, r = ["moz", "webkit"], i = "AnimationFrame", o = t["request" + i], l = t["cancel" + i] || t["cancelRequest" + i], f = 0; !o && f < r.length; f++) {
        o = t[r[f] + "Request" + i], l = t[r[f] + "Cancel" + i] || t[r[f] + "CancelRequest" + i];
      }

      if (!o || !l) {
        var s = 0,
            u = 0,
            h = [];
        o = function o(c) {
          if (0 === h.length) {
            var e = n(),
                a = Math.max(0, 1e3 / 60 - (e - s));
            s = a + e, setTimeout(function () {
              var c = h.slice(0);
              h.length = 0;

              for (var e = 0; e < c.length; e++) {
                if (!c[e].cancelled) try {
                  c[e].callback(s);
                } catch (c) {
                  setTimeout(function () {
                    throw c;
                  }, 0);
                }
              }
            }, Math.round(a));
          }

          return h.push({
            handle: ++u,
            callback: c,
            cancelled: !1
          }), u;
        }, l = function l(c) {
          for (var e = 0; e < h.length; e++) {
            h[e].handle === c && (h[e].cancelled = !0);
          }
        };
      }

      c.exports = function (c) {
        return o.call(t, c);
      }, c.exports.cancel = function () {
        l.apply(t, arguments);
      }, c.exports.polyfill = function (c) {
        c || (c = t), c.requestAnimationFrame = o, c.cancelAnimationFrame = l;
      };
    }).call(e, function () {
      return this;
    }());
  }, function (c, e) {
    "use strict";

    e.__esModule = !0, e.default = function (c) {
      var e = {};

      for (var a in c) {
        Object.prototype.hasOwnProperty.call(c, a) && (e[a] = 0);
      }

      return e;
    }, c.exports = e.default;
  }, function (c, e) {
    "use strict";

    e.__esModule = !0, e.default = function (c, e, a) {
      for (var n in e) {
        if (Object.prototype.hasOwnProperty.call(e, n)) {
          if (0 !== a[n]) return !1;
          var t = "number" == typeof e[n] ? e[n] : e[n].val;
          if (c[n] !== t) return !1;
        }
      }

      return !0;
    }, c.exports = e.default;
  }, function (c, e) {
    "use strict";

    e.__esModule = !0, e.default = function (c, e, n, t, r, i, o) {
      var l = n + (-r * (e - t) + -i * n) * c,
          f = e + l * c;
      return Math.abs(l) < o && Math.abs(f - t) < o ? (a[0] = t, a[1] = 0, a) : (a[0] = f, a[1] = l, a);
    };
    var a = [0, 0];
    c.exports = e.default;
  }, function (c, e) {
    function a() {
      throw new Error("setTimeout has not been defined");
    }

    function n() {
      throw new Error("clearTimeout has not been defined");
    }

    function t(c) {
      if (f === setTimeout) return setTimeout(c, 0);
      if ((f === a || !f) && setTimeout) return f = setTimeout, setTimeout(c, 0);

      try {
        return f(c, 0);
      } catch (e) {
        try {
          return f.call(null, c, 0);
        } catch (e) {
          return f.call(this, c, 0);
        }
      }
    }

    function r() {
      v && h && (v = !1, h.length ? m = h.concat(m) : d = -1, m.length && i());
    }

    function i() {
      if (!v) {
        var c = t(r);
        v = !0;

        for (var e = m.length; e;) {
          for (h = m, m = []; ++d < e;) {
            h && h[d].run();
          }

          d = -1, e = m.length;
        }

        h = null, v = !1, function (c) {
          if (s === clearTimeout) return clearTimeout(c);
          if ((s === n || !s) && clearTimeout) return s = clearTimeout, clearTimeout(c);

          try {
            s(c);
          } catch (e) {
            try {
              return s.call(null, c);
            } catch (e) {
              return s.call(this, c);
            }
          }
        }(c);
      }
    }

    function o(c, e) {
      this.fun = c, this.array = e;
    }

    function l() {}

    var f,
        s,
        u = c.exports = {};
    !function () {
      try {
        f = "function" == typeof setTimeout ? setTimeout : a;
      } catch (c) {
        f = a;
      }

      try {
        s = "function" == typeof clearTimeout ? clearTimeout : n;
      } catch (c) {
        s = n;
      }
    }();
    var h,
        m = [],
        v = !1,
        d = -1;
    u.nextTick = function (c) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var a = 1; a < arguments.length; a++) {
        e[a - 1] = arguments[a];
      }
      m.push(new o(c, e)), 1 !== m.length || v || t(i);
    }, o.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, u.title = "browser", u.browser = !0, u.env = {}, u.argv = [], u.version = "", u.versions = {}, u.on = l, u.addListener = l, u.once = l, u.off = l, u.removeListener = l, u.removeAllListeners = l, u.emit = l, u.prependListener = l, u.prependOnceListener = l, u.listeners = function (c) {
      return [];
    }, u.binding = function (c) {
      throw new Error("process.binding is not supported");
    }, u.cwd = function () {
      return "/";
    }, u.chdir = function (c) {
      throw new Error("process.chdir is not supported");
    }, u.umask = function () {
      return 0;
    };
  }, function (c, e) {
    "use strict";

    e.__esModule = !0, e.default = {
      noWobble: {
        stiffness: 170,
        damping: 26
      },
      gentle: {
        stiffness: 120,
        damping: 14
      },
      wobbly: {
        stiffness: 180,
        damping: 12
      },
      stiff: {
        stiffness: 210,
        damping: 20
      }
    }, c.exports = e.default;
  }, function (c, e) {
    "use strict";

    function a(c) {
      var e = -1 != c.indexOf("rgb"),
          a = -1 != c.indexOf("rgba"),
          n = c.match(/\d+/g);
      if (e && !a) return {
        r: parseInt(n[0]),
        g: parseInt(n[1]),
        b: parseInt(n[2])
      };

      if (e && a) {
        var t = "0" == n[3] ? "0." + n[4] : n[3];
        return {
          r: parseInt(n[0]),
          g: parseInt(n[1]),
          b: parseInt(n[2]),
          a: parseFloat(t)
        };
      }

      return null;
    }

    function n(c, e, a, n, t) {
      var r = a - e,
          i = t - n,
          o = (c - e) / r;
      return n + o * i;
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.hexToRGB = function (c) {
      var e = c;
      if (t[e]) return t[e];
      3 === (e = e.replace("#", "")).length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]);
      var a = e.match(/.{2}/g),
          n = {
        r: parseInt(a[0], 16),
        g: parseInt(a[1], 16),
        b: parseInt(a[2], 16)
      };
      return t[e] = n, n;
    }, e.rgbToObj = a, e.rgbToHex = function (c, e, a) {
      var n = c.toString(16),
          t = e.toString(16),
          r = a.toString(16);
      return n = n.length < 2 ? "0" + n : n, t = t.length < 2 ? "0" + t : t, r = r.length < 2 ? "0" + r : r, "#" + n + t + r;
    }, e.mapValueInRange = n, e.interpolateColor = function (c, e, t, r, i, o) {
      var l = void 0 === r ? 0 : r,
          f = void 0 === i ? 1 : i,
          s = a(e),
          u = a(t),
          h = Math.floor(n(c, l, f, s.r, u.r)),
          m = Math.floor(n(c, l, f, s.g, u.g)),
          v = Math.floor(n(c, l, f, s.b, u.b)),
          d = null;
      return s.a && u.a && (d = n(c, l, f, s.a, u.a)), d ? "rgb(" + h + "," + m + "," + v + "," + d + ")" : "rgb(" + h + "," + m + "," + v + ")";
    };
    var t = {};
  }, function (c, e, a) {
    "use strict";

    var n = a(13),
        t = function (c) {
      return c && c.__esModule ? c : {
        default: c
      };
    }(n);

    c.exports = t.default;
  }, function (c, e, a) {
    "use strict";

    function n(c) {
      return c && c.__esModule ? c : {
        default: c
      };
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var t = Object.assign || function (c) {
      for (var e = 1; e < arguments.length; e++) {
        var a = arguments[e];

        for (var n in a) {
          Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
        }
      }

      return c;
    },
        r = function () {
      function c(c, e) {
        for (var a = 0; a < e.length; a++) {
          var n = e[a];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
        }
      }

      return function (e, a, n) {
        return a && c(e.prototype, a), n && c(e, n), e;
      };
    }(),
        i = a(3),
        o = n(i),
        l = a(24),
        f = a(1),
        s = n(f),
        u = a(14),
        h = a(11),
        m = {
      active: {
        base: "rgb(1,124,66)",
        hover: "rgb(1,124,66)"
      },
      inactive: {
        base: "rgb(65,66,68)",
        hover: "rgb(65,66,68)"
      },
      activeThumb: {
        base: "rgb(250,250,250)",
        hover: "rgb(250,250,250)"
      },
      inactiveThumb: {
        base: "rgb(250,250,250)",
        hover: "rgb(250,250,250)"
      }
    },
        v = {},
        d = function (c) {
      function e(c) {
        !function (c, e) {
          if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e);

        var a = function (c, e) {
          if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !e || "object" != typeof e && "function" != typeof e ? c : e;
        }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, c));

        return a.state = {
          isHover: !1
        }, a;
      }

      return function (c, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
        c.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: c,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
      }(e, c), r(e, [{
        key: "onMouseOver",
        value: function value() {
          this.setState({
            isHover: !0
          });
        }
      }, {
        key: "onMouseOut",
        value: function value() {
          this.setState({
            isHover: !1
          });
        }
      }, {
        key: "_convertToRgb",
        value: function value(c, e) {
          if (-1 != c.indexOf("#")) {
            var a = (0, h.hexToRGB)(c);
            return "rgb(" + a.r + ", " + a.g + ", " + a.b + ")";
          }

          return -1 == c.indexOf("rgb") ? e : c;
        }
      }, {
        key: "checkAllColors",
        value: function value(c) {
          var e = this;
          return Object.keys(c).forEach(function (a) {
            e.checkColors(c, a);
          }), c;
        }
      }, {
        key: "checkColors",
        value: function value(c, e) {
          c[e] ? c[e].hover ? (c[e].base = this._convertToRgb(c[e].base, m[e].base), c[e].hover = this._convertToRgb(c[e].hover, m[e].hover)) : c[e].base ? (c[e].base = this._convertToRgb(c[e].base, m[e].base), c[e].hover = c[e].base) : (console.warn('Color prop should have a "base" style and a "hover" style!'), c[e] = m[e]) : c[e] = m[e];
        }
      }, {
        key: "interpolateColorWithHover",
        value: function value(c, e, a) {
          var n = this.props.colors;
          return this.checkColors(n, e), this.checkColors(n, a), this.state.isHover ? {
            backgroundColor: (0, h.interpolateColor)(c, n[e].hover, n[a].hover, 0, 400)
          } : {
            backgroundColor: (0, h.interpolateColor)(c, n[e].base, n[a].base, 0, 400)
          };
        }
      }, {
        key: "makeStyle",
        value: function value(c, e) {
          return this.state.isHover ? t({}, c, e) : c;
        }
      }, {
        key: "handleClick",
        value: function value(c) {
          c.target !== this._input && (c.preventDefault(), this._input.focus(), this._input.click());
        }
      }, {
        key: "render",
        value: function value() {
          var c = this,
              e = this.props,
              a = e.internalSpringSetting,
              n = e.internalHoverSpringSetting,
              r = e.value,
              i = e.thumbAnimateRange,
              f = (e.isHover, e.containerStyle),
              s = e.trackStyle,
              h = e.animateTrackStyleToggle,
              m = e.animateTrackStyleHover,
              v = e.thumbStyleHover,
              d = e.trackStyleHover,
              M = e.activeLabelStyle,
              p = e.activeLabelStyleHover,
              z = e.activeLabel,
              C = e.inactiveLabelStyle,
              L = e.inactiveLabelStyleHover,
              A = e.inactiveLabel,
              N = e.thumbStyle,
              g = e.animateThumbStyleHover,
              H = e.animateThumbStyleToggle,
              V = e.thumbIcon,
              x = e.onClick,
              w = e.onToggle,
              y = e.passThroughInputProps,
              b = a,
              S = n;
          return o.default.createElement(l.Motion, {
            style: {
              opacity: (0, l.spring)(r ? 1 : 0, b),
              left: (0, l.spring)(r ? 10 * i[1] : 10 * i[0], b),
              colorNumber: (0, l.spring)(r ? 0 : 400, b),
              toggleNumber: (0, l.spring)(r ? 400 : 0, b),
              hoverNumber: (0, l.spring)(this.state.isHover ? 400 : 0, S)
            }
          }, function (e) {
            var a = e.opacity,
                n = e.left,
                i = e.colorNumber,
                l = e.hoverNumber,
                b = e.toggleNumber;
            return o.default.createElement("div", {
              style: t({}, c.makeStyle(t({}, u.reactToggle, f))),
              onMouseOver: c.onMouseOver.bind(c),
              onMouseOut: c.onMouseOut.bind(c),
              onClick: c.handleClick.bind(c)
            }, o.default.createElement("div", {
              style: t({}, c.makeStyle(t({}, u.reactToggleTrack, s, c.interpolateColorWithHover(i, "active", "inactive"), h(b / 400)), t({}, d, m(l / 400))))
            }, o.default.createElement("div", {
              style: t({}, c.makeStyle(t({}, u.reactToggleOn, M), p), {
                opacity: a
              })
            }, z), o.default.createElement("div", {
              style: t({}, c.makeStyle(t({}, u.reactToggleOff, C), L), {
                opacity: 1 - a
              })
            }, A)), o.default.createElement("div", {
              style: u.reactThumbCenteringContainer
            }, o.default.createElement("div", {
              style: t({}, c.makeStyle(t({}, u.reactToggleThumb, N, c.interpolateColorWithHover(i, "activeThumb", "inactiveThumb"), H(b / 400)), t({}, v, g(l / 400))), {
                position: "relative",
                left: Math.round(n / 10)
              })
            }, V)), o.default.createElement("input", t({
              ref: function ref(e) {
                c._input = e;
              },
              type: "checkbox",
              style: u.reactToggleScreenReaderOnly,
              onClick: function onClick(c) {
                x && x(c), w(r);
              },
              value: r
            }, y)));
          });
        }
      }]), e;
    }(i.Component);

    d.defaultProps = {
      value: !1,
      onToggle: function onToggle() {},
      colors: m,
      passThroughInputProps: {},
      activeLabel: "ON",
      containerStyle: v,
      activeLabelStyle: v,
      activeLabelStyleHover: v,
      inactiveLabel: "OFF",
      inactiveLabelStyle: v,
      inactiveLabelStyleHover: v,
      thumbStyle: v,
      thumbStyleHover: v,
      animateThumbStyleHover: function animateThumbStyleHover() {
        return {};
      },
      animateThumbStyleToggle: function animateThumbStyleToggle() {
        return {};
      },
      trackStyle: v,
      trackStyleHover: v,
      animateTrackStyleHover: function animateTrackStyleHover() {
        return {};
      },
      animateTrackStyleToggle: function animateTrackStyleToggle() {
        return {};
      },
      thumbAnimateRange: [1, 33],
      internalSpringSetting: {
        stiffness: 180,
        damping: 22
      },
      internalHoverSpringSetting: {
        stiffness: 180,
        damping: 20
      }
    }, d.displayName = "Toggle", e.default = d, d.propTypes = {
      value: s.default.bool.isRequired,
      onToggle: s.default.func.isRequired,
      passThroughInputProps: s.default.object,
      onClick: s.default.func,
      colors: s.default.object,
      activeLabel: s.default.oneOfType([s.default.string, s.default.object]),
      containerStyle: s.default.object,
      activeLabelStyle: s.default.object,
      activeLabelStyleHover: s.default.object,
      activeThumbStyle: s.default.object,
      activeThumbStyleHover: s.default.object,
      inactiveLabel: s.default.oneOfType([s.default.string, s.default.object]),
      inactiveLabelStyle: s.default.object,
      inactiveLabelStyleHover: s.default.object,
      thumbStyle: s.default.object,
      thumbStyleHover: s.default.object,
      trackStyle: s.default.object,
      trackStyleHover: s.default.object,
      animateThumbStyleHover: s.default.func,
      animateTrackStyleHover: s.default.func,
      animateTrackStyleToggle: s.default.func,
      animateThumbStyleToggle: s.default.func,
      internalSpringSetting: s.default.object,
      internalHoverSpringSetting: s.default.object,
      thumbIcon: s.default.oneOfType([s.default.string, s.default.object]),
      thumbAnimateRange: s.default.array
    };
  }, function (c, e) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var a = Object.assign || function (c) {
      for (var e = 1; e < arguments.length; e++) {
        var a = arguments[e];

        for (var n in a) {
          Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
        }
      }

      return c;
    },
        n = (e.reactToggle = function (c, e, a) {
      return e in c ? Object.defineProperty(c, e, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : c[e] = a, c;
    }({
      display: "flex",
      width: 52,
      alignItems: "center",
      justifyContent: "flex-start",
      position: "relative",
      cursor: "pointer",
      backgroundColor: "transparent",
      border: 0,
      padding: 0,
      WebkitTouchCallout: "none",
      WebkitUserSelect: "none",
      KhtmlUserSelect: "none",
      MozUserSelect: "none",
      msUserSelect: "none",
      userSelect: "none",
      WebkitTapHighlightColor: "rgba(0,0,0,0)"
    }, "WebkitTapHighlightColor", "transparent"), {
      fontSize: 11,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Helvetica Neue', Helvetica, sans-serif"
    });

    e.reactToggleScreenReaderOnly = {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: 1
    }, e.reactToggleTrack = {
      width: "52px",
      height: "20px",
      padding: 0,
      borderRadius: "26px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, e.reactToggleOn = a({}, n, {
      position: "relative",
      color: "#FAFAFA",
      marginTop: "auto",
      marginBottom: "auto",
      lineHeight: 0,
      opacity: 0,
      width: 26,
      height: 20,
      left: 4
    }), e.reactToggleOff = a({}, n, {
      position: "relative",
      color: "rgba(255,255,255,0.6)",
      bottom: "0px",
      marginTop: "auto",
      marginBottom: "auto",
      paddingRight: 5,
      lineHeight: 0,
      width: 26,
      height: 20
    }), e.reactToggleThumb = {
      width: "18px",
      height: "18px",
      display: "flex",
      alignSelf: "center",
      boxShadow: "0 0 0 1px rgba(0,0,0,0.3)",
      borderRadius: "50%",
      WebkitBoxSizing: "border-box",
      MozBoxSizing: "border-box",
      boxSizing: "border-box"
    }, e.reactThumbCenteringContainer = {
      position: "absolute",
      height: "100%",
      top: 0,
      left: 0,
      display: "flex",
      flex: 1,
      alignSelf: "stretch",
      alignItems: "center",
      justifyContent: "flex-start"
    };
  }, function (c, e) {
    "use strict";

    function a(c) {
      return function () {
        return c;
      };
    }

    var n = function n() {};

    n.thatReturns = a, n.thatReturnsFalse = a(!1), n.thatReturnsTrue = a(!0), n.thatReturnsNull = a(null), n.thatReturnsThis = function () {
      return this;
    }, n.thatReturnsArgument = function (c) {
      return c;
    }, c.exports = n;
  }, function (c, e, a) {
    "use strict";

    var n = function n(c) {};

    c.exports = function (c, e, a, t, r, i, o, l) {
      if (n(e), !c) {
        var f;
        if (void 0 === e) f = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var s = [a, t, r, i, o, l],
              u = 0;
          (f = new Error(e.replace(/%s/g, function () {
            return s[u++];
          }))).name = "Invariant Violation";
        }
        throw f.framesToPop = 1, f;
      }
    };
  }, function (c, e, a) {
    "use strict";

    var n = a(15),
        t = a(16),
        r = a(18);

    c.exports = function () {
      function c(c, e, a, n, i, o) {
        o !== r && t(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function e() {
        return c;
      }

      c.isRequired = c;
      var a = {
        array: c,
        bool: c,
        func: c,
        number: c,
        object: c,
        string: c,
        symbol: c,
        any: c,
        arrayOf: e,
        element: c,
        instanceOf: e,
        node: c,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e
      };
      return a.checkPropTypes = n, a.PropTypes = a, a;
    };
  }, function (c, e) {
    "use strict";

    c.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (c, e, a) {
    (function (e) {
      (function () {
        var a, n, t, r, i, o;
        "undefined" != typeof performance && null !== performance && performance.now ? c.exports = function () {
          return performance.now();
        } : null != e && e.hrtime ? (c.exports = function () {
          return (a() - i) / 1e6;
        }, n = e.hrtime, r = (a = function a() {
          var c;
          return 1e9 * (c = n())[0] + c[1];
        })(), o = 1e9 * e.uptime(), i = r - o) : Date.now ? (c.exports = function () {
          return Date.now() - t;
        }, t = Date.now()) : (c.exports = function () {
          return new Date().getTime() - t;
        }, t = new Date().getTime());
      }).call(this);
    }).call(e, a(9));
  }, function (c, e, a) {
    "use strict";

    function n(c) {
      return c && c.__esModule ? c : {
        default: c
      };
    }

    e.__esModule = !0;

    var t = Object.assign || function (c) {
      for (var e = 1; e < arguments.length; e++) {
        var a = arguments[e];

        for (var n in a) {
          Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
        }
      }

      return c;
    },
        r = function () {
      function c(c, e) {
        for (var a = 0; a < e.length; a++) {
          var n = e[a];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
        }
      }

      return function (e, a, n) {
        return a && c(e.prototype, a), n && c(e, n), e;
      };
    }(),
        i = a(6),
        o = n(i),
        l = a(2),
        f = n(l),
        s = a(8),
        u = n(s),
        h = a(4),
        m = n(h),
        v = a(5),
        d = n(v),
        M = a(7),
        p = n(M),
        z = a(3),
        C = n(z),
        L = a(1),
        A = n(L),
        N = 1e3 / 60,
        g = function (c) {
      function e(a) {
        var n = this;
        (function (c, e) {
          if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
        })(this, e), c.call(this, a), this.wasAnimating = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyle = null, this.clearUnreadPropStyle = function (c) {
          var e = !1,
              a = n.state,
              r = a.currentStyle,
              i = a.currentVelocity,
              o = a.lastIdealStyle,
              l = a.lastIdealVelocity;

          for (var f in c) {
            if (Object.prototype.hasOwnProperty.call(c, f)) {
              var s = c[f];
              "number" == typeof s && (e || (e = !0, r = t({}, r), i = t({}, i), o = t({}, o), l = t({}, l)), r[f] = s, i[f] = 0, o[f] = s, l[f] = 0);
            }
          }

          e && n.setState({
            currentStyle: r,
            currentVelocity: i,
            lastIdealStyle: o,
            lastIdealVelocity: l
          });
        }, this.startAnimationIfNecessary = function () {
          n.animationID = d.default(function (c) {
            var e = n.props.style;
            if (p.default(n.state.currentStyle, e, n.state.currentVelocity)) return n.wasAnimating && n.props.onRest && n.props.onRest(), n.animationID = null, n.wasAnimating = !1, void (n.accumulatedTime = 0);
            n.wasAnimating = !0;
            var a = c || m.default(),
                t = a - n.prevTime;
            if (n.prevTime = a, n.accumulatedTime = n.accumulatedTime + t, n.accumulatedTime > 10 * N && (n.accumulatedTime = 0), 0 === n.accumulatedTime) return n.animationID = null, void n.startAnimationIfNecessary();
            var r = (n.accumulatedTime - Math.floor(n.accumulatedTime / N) * N) / N,
                i = Math.floor(n.accumulatedTime / N),
                o = {},
                l = {},
                f = {},
                s = {};

            for (var h in e) {
              if (Object.prototype.hasOwnProperty.call(e, h)) {
                var v = e[h];
                if ("number" == typeof v) f[h] = v, s[h] = 0, o[h] = v, l[h] = 0;else {
                  for (var d = n.state.lastIdealStyle[h], M = n.state.lastIdealVelocity[h], z = 0; z < i; z++) {
                    var C = u.default(N / 1e3, d, M, v.val, v.stiffness, v.damping, v.precision);
                    d = C[0], M = C[1];
                  }

                  var L = u.default(N / 1e3, d, M, v.val, v.stiffness, v.damping, v.precision),
                      A = L[0],
                      g = L[1];
                  f[h] = d + (A - d) * r, s[h] = M + (g - M) * r, o[h] = d, l[h] = M;
                }
              }
            }

            n.animationID = null, n.accumulatedTime -= i * N, n.setState({
              currentStyle: f,
              currentVelocity: s,
              lastIdealStyle: o,
              lastIdealVelocity: l
            }), n.unreadPropStyle = null, n.startAnimationIfNecessary();
          });
        }, this.state = this.defaultState();
      }

      return function (c, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
        c.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: c,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
      }(e, c), r(e, null, [{
        key: "propTypes",
        value: {
          defaultStyle: A.default.objectOf(A.default.number),
          style: A.default.objectOf(A.default.oneOfType([A.default.number, A.default.object])).isRequired,
          children: A.default.func.isRequired,
          onRest: A.default.func
        },
        enumerable: !0
      }]), e.prototype.defaultState = function () {
        var c = this.props,
            e = c.defaultStyle,
            a = c.style,
            n = e || f.default(a),
            t = o.default(n);
        return {
          currentStyle: n,
          currentVelocity: t,
          lastIdealStyle: n,
          lastIdealVelocity: t
        };
      }, e.prototype.componentDidMount = function () {
        this.prevTime = m.default(), this.startAnimationIfNecessary();
      }, e.prototype.componentWillReceiveProps = function (c) {
        null != this.unreadPropStyle && this.clearUnreadPropStyle(this.unreadPropStyle), this.unreadPropStyle = c.style, null == this.animationID && (this.prevTime = m.default(), this.startAnimationIfNecessary());
      }, e.prototype.componentWillUnmount = function () {
        null != this.animationID && (d.default.cancel(this.animationID), this.animationID = null);
      }, e.prototype.render = function () {
        var c = this.props.children(this.state.currentStyle);
        return c && C.default.Children.only(c);
      }, e;
    }(C.default.Component);

    e.default = g, c.exports = e.default;
  }, function (c, e, a) {
    "use strict";

    function n(c) {
      return c && c.__esModule ? c : {
        default: c
      };
    }

    function t(c, e, a) {
      for (var n = 0; n < c.length; n++) {
        if (!z.default(c[n], e[n], a[n])) return !1;
      }

      return !0;
    }

    e.__esModule = !0;

    var r = Object.assign || function (c) {
      for (var e = 1; e < arguments.length; e++) {
        var a = arguments[e];

        for (var n in a) {
          Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
        }
      }

      return c;
    },
        i = function () {
      function c(c, e) {
        for (var a = 0; a < e.length; a++) {
          var n = e[a];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
        }
      }

      return function (e, a, n) {
        return a && c(e.prototype, a), n && c(e, n), e;
      };
    }(),
        o = a(6),
        l = n(o),
        f = a(2),
        s = n(f),
        u = a(8),
        h = n(u),
        m = a(4),
        v = n(m),
        d = a(5),
        M = n(d),
        p = a(7),
        z = n(p),
        C = a(3),
        L = n(C),
        A = a(1),
        N = n(A),
        g = 1e3 / 60,
        H = function (c) {
      function e(a) {
        var n = this;
        (function (c, e) {
          if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
        })(this, e), c.call(this, a), this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (c) {
          for (var e = n.state, a = e.currentStyles, t = e.currentVelocities, i = e.lastIdealStyles, o = e.lastIdealVelocities, l = !1, f = 0; f < c.length; f++) {
            var s = c[f],
                u = !1;

            for (var h in s) {
              if (Object.prototype.hasOwnProperty.call(s, h)) {
                var m = s[h];
                "number" == typeof m && (u || (u = !0, l = !0, a[f] = r({}, a[f]), t[f] = r({}, t[f]), i[f] = r({}, i[f]), o[f] = r({}, o[f])), a[f][h] = m, t[f][h] = 0, i[f][h] = m, o[f][h] = 0);
              }
            }
          }

          l && n.setState({
            currentStyles: a,
            currentVelocities: t,
            lastIdealStyles: i,
            lastIdealVelocities: o
          });
        }, this.startAnimationIfNecessary = function () {
          n.animationID = M.default(function (c) {
            var e = n.props.styles(n.state.lastIdealStyles);
            if (t(n.state.currentStyles, e, n.state.currentVelocities)) return n.animationID = null, void (n.accumulatedTime = 0);
            var a = c || v.default(),
                r = a - n.prevTime;
            if (n.prevTime = a, n.accumulatedTime = n.accumulatedTime + r, n.accumulatedTime > 10 * g && (n.accumulatedTime = 0), 0 === n.accumulatedTime) return n.animationID = null, void n.startAnimationIfNecessary();

            for (var i = (n.accumulatedTime - Math.floor(n.accumulatedTime / g) * g) / g, o = Math.floor(n.accumulatedTime / g), l = [], f = [], s = [], u = [], m = 0; m < e.length; m++) {
              var d = e[m],
                  M = {},
                  p = {},
                  z = {},
                  C = {};

              for (var L in d) {
                if (Object.prototype.hasOwnProperty.call(d, L)) {
                  var A = d[L];
                  if ("number" == typeof A) M[L] = A, p[L] = 0, z[L] = A, C[L] = 0;else {
                    for (var N = n.state.lastIdealStyles[m][L], H = n.state.lastIdealVelocities[m][L], V = 0; V < o; V++) {
                      var x = h.default(g / 1e3, N, H, A.val, A.stiffness, A.damping, A.precision);
                      N = x[0], H = x[1];
                    }

                    var w = h.default(g / 1e3, N, H, A.val, A.stiffness, A.damping, A.precision),
                        y = w[0],
                        b = w[1];
                    M[L] = N + (y - N) * i, p[L] = H + (b - H) * i, z[L] = N, C[L] = H;
                  }
                }
              }

              s[m] = M, u[m] = p, l[m] = z, f[m] = C;
            }

            n.animationID = null, n.accumulatedTime -= o * g, n.setState({
              currentStyles: s,
              currentVelocities: u,
              lastIdealStyles: l,
              lastIdealVelocities: f
            }), n.unreadPropStyles = null, n.startAnimationIfNecessary();
          });
        }, this.state = this.defaultState();
      }

      return function (c, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
        c.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: c,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
      }(e, c), i(e, null, [{
        key: "propTypes",
        value: {
          defaultStyles: N.default.arrayOf(N.default.objectOf(N.default.number)),
          styles: N.default.func.isRequired,
          children: N.default.func.isRequired
        },
        enumerable: !0
      }]), e.prototype.defaultState = function () {
        var c = this.props,
            e = c.defaultStyles,
            a = c.styles,
            n = e || a().map(s.default),
            t = n.map(function (c) {
          return l.default(c);
        });
        return {
          currentStyles: n,
          currentVelocities: t,
          lastIdealStyles: n,
          lastIdealVelocities: t
        };
      }, e.prototype.componentDidMount = function () {
        this.prevTime = v.default(), this.startAnimationIfNecessary();
      }, e.prototype.componentWillReceiveProps = function (c) {
        null != this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles), this.unreadPropStyles = c.styles(this.state.lastIdealStyles), null == this.animationID && (this.prevTime = v.default(), this.startAnimationIfNecessary());
      }, e.prototype.componentWillUnmount = function () {
        null != this.animationID && (M.default.cancel(this.animationID), this.animationID = null);
      }, e.prototype.render = function () {
        var c = this.props.children(this.state.currentStyles);
        return c && L.default.Children.only(c);
      }, e;
    }(L.default.Component);

    e.default = H, c.exports = e.default;
  }, function (c, e, a) {
    "use strict";

    function n(c) {
      return c && c.__esModule ? c : {
        default: c
      };
    }

    function t(c, e, a) {
      var n = e;
      return null == n ? c.map(function (c, e) {
        return {
          key: c.key,
          data: c.data,
          style: a[e]
        };
      }) : c.map(function (c, e) {
        for (var t = 0; t < n.length; t++) {
          if (n[t].key === c.key) return {
            key: n[t].key,
            data: n[t].data,
            style: a[e]
          };
        }

        return {
          key: c.key,
          data: c.data,
          style: a[e]
        };
      });
    }

    function r(c, e, a, n) {
      if (n.length !== e.length) return !1;

      for (var t = 0; t < n.length; t++) {
        if (n[t].key !== e[t].key) return !1;
      }

      for (var t = 0; t < n.length; t++) {
        if (!N.default(c[t], e[t].style, a[t])) return !1;
      }

      return !0;
    }

    function i(c, e, a, n, t, r, i, o, l) {
      for (var f = M.default(n, t, function (c, n) {
        var t = e(n);
        return null == t ? (a({
          key: n.key,
          data: n.data
        }), null) : N.default(r[c], t, i[c]) ? (a({
          key: n.key,
          data: n.data
        }), null) : {
          key: n.key,
          data: n.data,
          style: t
        };
      }), u = [], h = [], m = [], v = [], d = 0; d < f.length; d++) {
        for (var p = f[d], z = null, C = 0; C < n.length; C++) {
          if (n[C].key === p.key) {
            z = C;
            break;
          }
        }

        if (null == z) {
          var L = c(p);
          u[d] = L, m[d] = L;
          var A = s.default(p.style);
          h[d] = A, v[d] = A;
        } else u[d] = r[z], m[d] = o[z], h[d] = i[z], v[d] = l[z];
      }

      return [f, u, h, m, v];
    }

    e.__esModule = !0;

    var o = Object.assign || function (c) {
      for (var e = 1; e < arguments.length; e++) {
        var a = arguments[e];

        for (var n in a) {
          Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
        }
      }

      return c;
    },
        l = function () {
      function c(c, e) {
        for (var a = 0; a < e.length; a++) {
          var n = e[a];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
        }
      }

      return function (e, a, n) {
        return a && c(e.prototype, a), n && c(e, n), e;
      };
    }(),
        f = a(6),
        s = n(f),
        u = a(2),
        h = n(u),
        m = a(8),
        v = n(m),
        d = a(23),
        M = n(d),
        p = a(4),
        z = n(p),
        C = a(5),
        L = n(C),
        A = a(7),
        N = n(A),
        g = a(3),
        H = n(g),
        V = a(1),
        x = n(V),
        w = 1e3 / 60,
        y = function (c) {
      function e(a) {
        var n = this;
        (function (c, e) {
          if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
        })(this, e), c.call(this, a), this.unmounting = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (c) {
          for (var e = i(n.props.willEnter, n.props.willLeave, n.props.didLeave, n.state.mergedPropsStyles, c, n.state.currentStyles, n.state.currentVelocities, n.state.lastIdealStyles, n.state.lastIdealVelocities), a = e[0], t = e[1], r = e[2], l = e[3], f = e[4], s = 0; s < c.length; s++) {
            var u = c[s].style,
                h = !1;

            for (var m in u) {
              if (Object.prototype.hasOwnProperty.call(u, m)) {
                var v = u[m];
                "number" == typeof v && (h || (h = !0, t[s] = o({}, t[s]), r[s] = o({}, r[s]), l[s] = o({}, l[s]), f[s] = o({}, f[s]), a[s] = {
                  key: a[s].key,
                  data: a[s].data,
                  style: o({}, a[s].style)
                }), t[s][m] = v, r[s][m] = 0, l[s][m] = v, f[s][m] = 0, a[s].style[m] = v);
              }
            }
          }

          n.setState({
            currentStyles: t,
            currentVelocities: r,
            mergedPropsStyles: a,
            lastIdealStyles: l,
            lastIdealVelocities: f
          });
        }, this.startAnimationIfNecessary = function () {
          n.unmounting || (n.animationID = L.default(function (c) {
            if (!n.unmounting) {
              var e = n.props.styles,
                  a = "function" == typeof e ? e(t(n.state.mergedPropsStyles, n.unreadPropStyles, n.state.lastIdealStyles)) : e;
              if (r(n.state.currentStyles, a, n.state.currentVelocities, n.state.mergedPropsStyles)) return n.animationID = null, void (n.accumulatedTime = 0);
              var o = c || z.default(),
                  l = o - n.prevTime;
              if (n.prevTime = o, n.accumulatedTime = n.accumulatedTime + l, n.accumulatedTime > 10 * w && (n.accumulatedTime = 0), 0 === n.accumulatedTime) return n.animationID = null, void n.startAnimationIfNecessary();

              for (var f = (n.accumulatedTime - Math.floor(n.accumulatedTime / w) * w) / w, s = Math.floor(n.accumulatedTime / w), u = i(n.props.willEnter, n.props.willLeave, n.props.didLeave, n.state.mergedPropsStyles, a, n.state.currentStyles, n.state.currentVelocities, n.state.lastIdealStyles, n.state.lastIdealVelocities), h = u[0], m = u[1], d = u[2], M = u[3], p = u[4], C = 0; C < h.length; C++) {
                var L = h[C].style,
                    A = {},
                    N = {},
                    g = {},
                    H = {};

                for (var V in L) {
                  if (Object.prototype.hasOwnProperty.call(L, V)) {
                    var x = L[V];
                    if ("number" == typeof x) A[V] = x, N[V] = 0, g[V] = x, H[V] = 0;else {
                      for (var y = M[C][V], b = p[C][V], S = 0; S < s; S++) {
                        var T = v.default(w / 1e3, y, b, x.val, x.stiffness, x.damping, x.precision);
                        y = T[0], b = T[1];
                      }

                      var D = v.default(w / 1e3, y, b, x.val, x.stiffness, x.damping, x.precision),
                          j = D[0],
                          E = D[1];
                      A[V] = y + (j - y) * f, N[V] = b + (E - b) * f, g[V] = y, H[V] = b;
                    }
                  }
                }

                M[C] = g, p[C] = H, m[C] = A, d[C] = N;
              }

              n.animationID = null, n.accumulatedTime -= s * w, n.setState({
                currentStyles: m,
                currentVelocities: d,
                lastIdealStyles: M,
                lastIdealVelocities: p,
                mergedPropsStyles: h
              }), n.unreadPropStyles = null, n.startAnimationIfNecessary();
            }
          }));
        }, this.state = this.defaultState();
      }

      return function (c, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
        c.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: c,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
      }(e, c), l(e, null, [{
        key: "propTypes",
        value: {
          defaultStyles: x.default.arrayOf(x.default.shape({
            key: x.default.string.isRequired,
            data: x.default.any,
            style: x.default.objectOf(x.default.number).isRequired
          })),
          styles: x.default.oneOfType([x.default.func, x.default.arrayOf(x.default.shape({
            key: x.default.string.isRequired,
            data: x.default.any,
            style: x.default.objectOf(x.default.oneOfType([x.default.number, x.default.object])).isRequired
          }))]).isRequired,
          children: x.default.func.isRequired,
          willEnter: x.default.func,
          willLeave: x.default.func,
          didLeave: x.default.func
        },
        enumerable: !0
      }, {
        key: "defaultProps",
        value: {
          willEnter: function willEnter(c) {
            return h.default(c.style);
          },
          willLeave: function willLeave() {
            return null;
          },
          didLeave: function didLeave() {}
        },
        enumerable: !0
      }]), e.prototype.defaultState = function () {
        var c = this.props,
            e = c.defaultStyles,
            a = c.styles,
            n = c.willEnter,
            t = c.willLeave,
            r = c.didLeave,
            o = "function" == typeof a ? a(e) : a,
            l = void 0;
        l = null == e ? o : e.map(function (c) {
          for (var e = 0; e < o.length; e++) {
            if (o[e].key === c.key) return o[e];
          }

          return c;
        });
        var f = null == e ? o.map(function (c) {
          return h.default(c.style);
        }) : e.map(function (c) {
          return h.default(c.style);
        }),
            u = null == e ? o.map(function (c) {
          return s.default(c.style);
        }) : e.map(function (c) {
          return s.default(c.style);
        }),
            m = i(n, t, r, l, o, f, u, f, u),
            v = m[0],
            d = m[1],
            M = m[2],
            p = m[3],
            z = m[4];
        return {
          currentStyles: d,
          currentVelocities: M,
          lastIdealStyles: p,
          lastIdealVelocities: z,
          mergedPropsStyles: v
        };
      }, e.prototype.componentDidMount = function () {
        this.prevTime = z.default(), this.startAnimationIfNecessary();
      }, e.prototype.componentWillReceiveProps = function (c) {
        this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles);
        var e = c.styles;
        this.unreadPropStyles = "function" == typeof e ? e(t(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles)) : e, null == this.animationID && (this.prevTime = z.default(), this.startAnimationIfNecessary());
      }, e.prototype.componentWillUnmount = function () {
        this.unmounting = !0, null != this.animationID && (L.default.cancel(this.animationID), this.animationID = null);
      }, e.prototype.render = function () {
        var c = t(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles),
            e = this.props.children(c);
        return e && H.default.Children.only(e);
      }, e;
    }(H.default.Component);

    e.default = y, c.exports = e.default;
  }, function (c, e) {
    "use strict";

    e.__esModule = !0, e.default = function (c, e, a) {
      for (var n = {}, t = 0; t < c.length; t++) {
        n[c[t].key] = t;
      }

      for (var r = {}, t = 0; t < e.length; t++) {
        r[e[t].key] = t;
      }

      for (var i = [], t = 0; t < e.length; t++) {
        i[t] = e[t];
      }

      for (var t = 0; t < c.length; t++) {
        if (!Object.prototype.hasOwnProperty.call(r, c[t].key)) {
          var o = a(t, c[t]);
          null != o && i.push(o);
        }
      }

      return i.sort(function (c, a) {
        var t = r[c.key],
            i = r[a.key],
            o = n[c.key],
            l = n[a.key];
        if (null != t && null != i) return r[c.key] - r[a.key];
        if (null != o && null != l) return n[c.key] - n[a.key];

        if (null != t) {
          for (var f = 0; f < e.length; f++) {
            var s = e[f].key;

            if (Object.prototype.hasOwnProperty.call(n, s)) {
              if (t < r[s] && l > n[s]) return -1;
              if (t > r[s] && l < n[s]) return 1;
            }
          }

          return 1;
        }

        for (var f = 0; f < e.length; f++) {
          var s = e[f].key;

          if (Object.prototype.hasOwnProperty.call(n, s)) {
            if (i < r[s] && o > n[s]) return 1;
            if (i > r[s] && o < n[s]) return -1;
          }
        }

        return -1;
      });
    }, c.exports = e.default;
  }, function (c, e, a) {
    "use strict";

    function n(c) {
      return c && c.__esModule ? c.default : c;
    }

    e.__esModule = !0;
    var t = a(20);
    e.Motion = n(t);
    var r = a(21);
    e.StaggeredMotion = n(r);
    var i = a(22);
    e.TransitionMotion = n(i);
    var o = a(26);
    e.spring = n(o);
    var l = a(10);
    e.presets = n(l);
    var f = a(2);
    e.stripStyle = n(f);
    var s = a(25);
    e.reorderKeys = n(s);
  }, function (c, e, a) {
    "use strict";

    e.__esModule = !0, e.default = function () {}, c.exports = e.default;
  }, function (c, e, a) {
    "use strict";

    e.__esModule = !0;

    var n = Object.assign || function (c) {
      for (var e = 1; e < arguments.length; e++) {
        var a = arguments[e];

        for (var n in a) {
          Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
        }
      }

      return c;
    };

    e.default = function (c, e) {
      return n({}, i, e, {
        val: c
      });
    };

    var t = a(10),
        r = function (c) {
      return c && c.__esModule ? c : {
        default: c
      };
    }(t),
        i = n({}, r.default.noWobble, {
      precision: .01
    });

    c.exports = e.default;
  }]));
}, function (c, e) {
  c.exports = function (c) {
    if (!c.webpackPolyfill) {
      var e = Object.create(c);
      e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), Object.defineProperty(e, "exports", {
        enumerable: !0
      }), e.webpackPolyfill = 1;
    }

    return e;
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.findDefault = function (c) {
    return c.filter(function (c) {
      return !0 === c.default;
    })[0];
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  e.TAX_AND_FEES = "This includes applicable sales taxes in your area.", e.TAX_AND_FEES_FR = "Cela inclut les taxes de vente applicables dans votre région.", e.FEES = "The transaction fee includes credit card and administrative fees involved with processing your order.", e.FEES_FR = "Les frais sont utilisés pour garder les lumières allumées afin que nous puissions continuer à vous faire économiser de l'argent.";
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = l(a(0)),
      r = l(a(52)),
      i = l(a(2)),
      o = l(a(54));

  function l(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  function f(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  r.default.setAppElement(document.getElementById("root"));

  var s = function (c) {
    function e() {
      var c, a, n;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var r = arguments.length, i = Array(r), l = 0; l < r; l++) {
        i[l] = arguments[l];
      }

      return a = n = f(this, (c = e.__proto__ || Object.getPrototypeOf(e)).call.apply(c, [this].concat(i))), n.header = function () {
        var c = n.props,
            e = c.header,
            a = c.headerTitle,
            r = c.headerSubtitle,
            i = c.toggleModal;
        return e || t.default.createElement(t.default.Fragment, null, t.default.createElement(o.default, {
          onClose: i
        }), a && t.default.createElement("div", {
          className: "modal-title"
        }, a), r && t.default.createElement("div", {
          className: "all-caps modal-subtitle"
        }, r));
      }, f(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.default.Component), n(e, [{
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.isOpen,
            a = c.toggleModal,
            n = c.children,
            i = c.overflow;
        return t.default.createElement(r.default, {
          isOpen: e,
          onRequestClose: a,
          className: "modal-dialog box-shadow " + (i ? "modal-dialog-overflow" : "")
        }, t.default.createElement(t.default.Fragment, null, this.header(), t.default.createElement("div", {
          className: "modal-dialog-content"
        }, n)));
      }
    }]), e;
  }();

  s.propTypes = {
    toggleModal: i.default.func.isRequired,
    isOpen: i.default.bool.isRequired,
    header: i.default.element,
    headerTitle: i.default.string,
    overflow: i.default.bool
  }, e.default = s;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  };

  e.default = o, e.FullWidthGenericPanel = function (c) {
    return i.default.createElement(o, n({
      style: {
        width: "100%",
        maxWidth: "unset"
      }
    }, c));
  };
  var t,
      r = a(0),
      i = (t = r) && t.__esModule ? t : {
    default: t
  };

  function o(c) {
    var e = c.children,
        a = c.className,
        n = c.style;
    return i.default.createElement("div", {
      className: "generic-panel",
      style: n
    }, i.default.createElement("div", {
      className: "generic-panel-container " + (a || "")
    }, e));
  }
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (c) {
    var e = c.name,
        a = c.vehicle,
        t = c.primaryColor,
        r = c.logo,
        i = c.logoWidth;
    c.gradient;
    return n.default.createElement("div", {
      className: "membership-card",
      style: {
        borderWidth: "1px",
        borderStyle: "dashed",
        borderColor: t
      }
    }, n.default.createElement("div", {
      className: "membership-inner-card"
    }, n.default.createElement("div", {
      className: "membership-content-area"
    }, n.default.createElement("div", {
      className: "membership-top-area"
    }, n.default.createElement("div", {
      className: "membership-instructions-area"
    }, n.default.createElement("div", {
      className: "print-footer-container"
    }, i && n.default.createElement("div", {
      className: "print-footer",
      style: {
        background: r + " no-repeat center"
      }
    }, n.default.createElement("img", {
      src: "images/CarAdvise-Logo.png",
      height: "20"
    }))), n.default.createElement("p", {
      className: "membership-title"
    }, "SHOP INSTRUCTIONS"), n.default.createElement("p", {
      className: "membership-subtitle-print"
    }, "Process as CarAdvise National Account through Auto Integrate.", n.default.createElement("span", {
      className: "membership-phone-number"
    }, " 1-844-923-8473")), n.default.createElement("p", {
      className: "membership-title"
    }, "FLEET MEMBERSHIP ID")), n.default.createElement("div", {
      className: "membership-name-and-vehicle"
    }, n.default.createElement("p", {
      className: "membership-name"
    }, "Driver: ", e), n.default.createElement("p", {
      className: "membership-vehicle"
    }), n.default.createElement("p", {
      className: "membership-vehicle"
    }, a && "VIN: " + (a.vin || ""), n.default.createElement("div", {
      className: "membership-payment-infotext"
    }, "You will receive text messages to approve work. Pay CarAdvise. Do not pay shop."))))), n.default.createElement("div", {
      style: {
        backgroundColor: "#292f36"
      }
    }, n.default.createElement("div", {
      className: "membership-footer-logo-container"
    }, i ? n.default.createElement("div", {
      className: "membership-footer-logo",
      style: {
        width: i,
        background: r + " no-repeat center"
      }
    }) : r))));
  };
  var n = t(a(0));
  t(a(55));

  function t(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  e.JIFFY_LUBE_COMPANY_ID = 2;
}, function (c, e, a) {
  "use strict";

  var n = {
    childContextTypes: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  },
      t = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  },
      r = Object.defineProperty,
      i = Object.getOwnPropertyNames,
      o = Object.getOwnPropertySymbols,
      l = Object.getOwnPropertyDescriptor,
      f = Object.getPrototypeOf,
      s = f && f(Object);

  c.exports = function c(e, a, u) {
    if ("string" != typeof a) {
      if (s) {
        var h = f(a);
        h && h !== s && c(e, h, u);
      }

      var m = i(a);
      o && (m = m.concat(o(a)));

      for (var v = 0; v < m.length; ++v) {
        var d = m[v];

        if (!(n[d] || t[d] || u && u[d])) {
          var M = l(a, d);

          try {
            r(e, d, M);
          } catch (c) {}
        }
      }

      return e;
    }

    return e;
  };
}, function (c, e, a) {
  "use strict";

  var n = a(27),
      t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  },
      r = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  },
      i = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  },
      o = {};

  function l(c) {
    return n.isMemo(c) ? i : o[c.$$typeof] || t;
  }

  o[n.ForwardRef] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, o[n.Memo] = i;
  var f = Object.defineProperty,
      s = Object.getOwnPropertyNames,
      u = Object.getOwnPropertySymbols,
      h = Object.getOwnPropertyDescriptor,
      m = Object.getPrototypeOf,
      v = Object.prototype;

  c.exports = function c(e, a, n) {
    if ("string" != typeof a) {
      if (v) {
        var t = m(a);
        t && t !== v && c(e, t, n);
      }

      var i = s(a);
      u && (i = i.concat(u(a)));

      for (var o = l(e), d = l(a), M = 0; M < i.length; ++M) {
        var p = i[M];

        if (!(r[p] || n && n[p] || d && d[p] || o && o[p])) {
          var z = h(a, p);

          try {
            f(e, p, z);
          } catch (c) {}
        }
      }
    }

    return e;
  };
}, function (c, e, a) {
  "use strict";

  e.a = function () {
    return !1;
  };
}, function (c, e) {
  var a = "undefined" != typeof Element,
      n = "function" == typeof Map,
      t = "function" == typeof Set,
      r = "function" == typeof ArrayBuffer && !!ArrayBuffer.isView;

  c.exports = function (c, e) {
    try {
      return function c(e, i) {
        if (e === i) return !0;

        if (e && i && "object" == typeof e && "object" == typeof i) {
          if (e.constructor !== i.constructor) return !1;
          var o, l, f, s;

          if (Array.isArray(e)) {
            if ((o = e.length) != i.length) return !1;

            for (l = o; 0 != l--;) {
              if (!c(e[l], i[l])) return !1;
            }

            return !0;
          }

          if (n && e instanceof Map && i instanceof Map) {
            if (e.size !== i.size) return !1;

            for (s = e.entries(); !(l = s.next()).done;) {
              if (!i.has(l.value[0])) return !1;
            }

            for (s = e.entries(); !(l = s.next()).done;) {
              if (!c(l.value[1], i.get(l.value[0]))) return !1;
            }

            return !0;
          }

          if (t && e instanceof Set && i instanceof Set) {
            if (e.size !== i.size) return !1;

            for (s = e.entries(); !(l = s.next()).done;) {
              if (!i.has(l.value[0])) return !1;
            }

            return !0;
          }

          if (r && ArrayBuffer.isView(e) && ArrayBuffer.isView(i)) {
            if ((o = e.length) != i.length) return !1;

            for (l = o; 0 != l--;) {
              if (e[l] !== i[l]) return !1;
            }

            return !0;
          }

          if (e.constructor === RegExp) return e.source === i.source && e.flags === i.flags;
          if (e.valueOf !== Object.prototype.valueOf && "function" == typeof e.valueOf && "function" == typeof i.valueOf) return e.valueOf() === i.valueOf();
          if (e.toString !== Object.prototype.toString && "function" == typeof e.toString && "function" == typeof i.toString) return e.toString() === i.toString();
          if ((o = (f = Object.keys(e)).length) !== Object.keys(i).length) return !1;

          for (l = o; 0 != l--;) {
            if (!Object.prototype.hasOwnProperty.call(i, f[l])) return !1;
          }

          if (a && e instanceof Element) return !1;

          for (l = o; 0 != l--;) {
            if (("_owner" !== f[l] && "__v" !== f[l] && "__o" !== f[l] || !e.$$typeof) && !c(e[f[l]], i[f[l]])) return !1;
          }

          return !0;
        }

        return e != e && i != i;
      }(c, e);
    } catch (c) {
      if ((c.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw c;
    }
  };
},,,, function (c, e, a) {
  "use strict";

  var n = vc(a(106)),
      t = vc(a(238)),
      r = vc(a(240)),
      i = vc(a(242)),
      o = vc(a(91)),
      l = mc(a(12)),
      f = mc(a(20)),
      s = mc(a(92)),
      u = mc(a(38)),
      h = mc(a(88)),
      m = mc(a(59)),
      v = mc(a(22)),
      d = mc(a(252)),
      M = mc(a(87)),
      p = mc(a(36)),
      z = vc(a(16)),
      C = vc(a(253)),
      L = vc(a(35)),
      A = vc(a(89)),
      N = vc(a(21)),
      g = vc(a(256)),
      H = vc(a(83)),
      V = a(90),
      x = vc(V);
  a(257);

  var w = vc(a(262)),
      y = vc(a(263)),
      b = vc(a(264)),
      S = vc(a(265)),
      T = vc(a(266)),
      D = vc(a(267)),
      j = vc(a(268)),
      E = vc(a(269)),
      k = vc(a(270)),
      I = vc(a(271)),
      O = vc(a(272)),
      Q = vc(a(273)),
      Z = vc(a(274)),
      U = vc(a(275)),
      B = vc(a(276)),
      R = vc(a(277)),
      Y = vc(a(278)),
      P = vc(a(279)),
      F = vc(a(280)),
      W = vc(a(281)),
      G = vc(a(282)),
      q = vc(a(283)),
      J = vc(a(284)),
      K = vc(a(285)),
      X = vc(a(286)),
      _ = vc(a(287)),
      $ = vc(a(288)),
      cc = vc(a(289)),
      ec = vc(a(290)),
      ac = vc(a(291)),
      nc = vc(a(292)),
      tc = vc(a(293)),
      rc = vc(a(294)),
      ic = vc(a(295)),
      oc = vc(a(296)),
      lc = vc(a(297)),
      fc = vc(a(298)),
      sc = vc(a(299)),
      uc = vc(a(300)),
      hc = vc(a(301));

  function mc(c) {
    if (c && c.__esModule) return c;
    var e = {};
    if (null != c) for (var a in c) {
      Object.prototype.hasOwnProperty.call(c, a) && (e[a] = c[a]);
    }
    return e.default = c, e;
  }

  function vc(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  c.exports = {
    Approvals: {
      ApprovalsForm: n.default,
      ApprovalsEmptyState: t.default,
      ApprovalsInfoModal: r.default
    },
    Membership: {
      MembershipPanel: i.default,
      MembershipCard: o.default
    },
    constants: {
      orders: l,
      services: f,
      shops: s,
      paymentProviders: u,
      tooltips: h
    },
    helpers: {
      arrayHelpers: m,
      shopHelpers: d,
      serviceHelpers: v,
      paymentMethodHelpers: M,
      currencyHelpers: p
    },
    elements: {
      Button: z.default,
      Image: L.default,
      ToggleButton: C.default,
      BaseModalDialog: A.default,
      ModalDialog: N.default,
      PrivacyPolicyAndTerms: g.default,
      OrderServiceModalInfo: H.default,
      FullWidthGenericPanel: V.FullWidthGenericPanel,
      GenericPanel: x.default
    },
    locales: {
      en: {
        enTranslations: w.default,
        enApprovalsEmptyState: b.default,
        enApprovalsForm: T.default,
        enApprovalsFormHeader: j.default,
        enApprovalsFormFields: k.default,
        enApprovalsFormField: O.default,
        enApprovalsInfoModal: Z.default,
        enApprovalsFormNotes: B.default,
        enApprovalsFormTotals: Y.default,
        enApprovalsFormPaymentMethod: F.default,
        enApprovalsFormCancel: G.default,
        enApprovalsFormSubmit: J.default,
        enApprovalToggleButton: X.default,
        enPriceInfoDisplay: $.default,
        enNoInformation: ec.default,
        enOrderServiceComment: oc.default,
        enOrderServiceModalInfo: nc.default,
        enPriceExplanation: rc.default,
        enPrivacyPolicyAndTerms: fc.default,
        enApprovalsFormVanity: uc.default
      },
      fr: {
        frTranslations: y.default,
        frApprovalsEmptyState: S.default,
        frApprovalsForm: D.default,
        frApprovalsFormHeader: E.default,
        frApprovalsFormFields: I.default,
        frApprovalsFormField: Q.default,
        frApprovalsInfoModal: U.default,
        frApprovalsFormNotes: R.default,
        frApprovalsFormTotals: P.default,
        frApprovalsFormPaymentMethod: W.default,
        frApprovalsFormCancel: q.default,
        frApprovalsFormSubmit: K.default,
        frApprovalToggleButton: _.default,
        frPriceInfoDisplay: cc.default,
        frNoInformation: ac.default,
        frOrderServiceComment: lc.default,
        frOrderServiceModalInfo: tc.default,
        frPriceExplanation: ic.default,
        frPrivacyPolicyAndTerms: sc.default,
        frApprovalsFormVanity: hc.default
      }
    }
  };
},,,,,, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    return function (c, e) {
      if (Array.isArray(c)) return c;
      if (Symbol.iterator in Object(c)) return function (c, e) {
        var a = [],
            n = !0,
            t = !1,
            r = void 0;

        try {
          for (var i, o = c[Symbol.iterator](); !(n = (i = o.next()).done) && (a.push(i.value), !e || a.length !== e); n = !0) {
            ;
          }
        } catch (c) {
          t = !0, r = c;
        } finally {
          try {
            !n && o.return && o.return();
          } finally {
            if (t) throw r;
          }
        }

        return a;
      }(c, e);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }(),
      t = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  },
      r = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      i = a(0),
      o = N(i),
      l = N(a(2)),
      f = A(a(59)),
      s = A(a(22)),
      u = a(20),
      h = a(12),
      m = N(a(198)),
      v = N(a(226)),
      d = N(a(227)),
      M = N(a(228)),
      p = N(a(229)),
      z = N(a(235)),
      C = N(a(236)),
      L = N(a(237));

  function A(c) {
    if (c && c.__esModule) return c;
    var e = {};
    if (null != c) for (var a in c) {
      Object.prototype.hasOwnProperty.call(c, a) && (e[a] = c[a]);
    }
    return e.default = c, e;
  }

  function N(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var g = function (c) {
    function e(c) {
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var a = function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, c));

      return a.state = {
        formData: {
          services: s.formatForApprovalsForm(a.props.services),
          customerComments: "",
          approverNotes: ""
        },
        selectedCreditCardId: null
      }, a.handleSubmit = function () {
        var c = a.props,
            e = c.onSubmit,
            n = c.allCreditCardsInfo,
            t = a.state,
            r = t.formData,
            i = t.selectedCreditCardId,
            o = null;
        n && (1 === n.length ? o = n[0].token : n.length > 1 && (o = i)), e(s.formatForApprovalsFormSubmission(r.services), r.customerComments, o, r.approverNotes);
      }, a.rejectionReasonsOptions = function (c) {
        var e = a.props.t;
        return [{
          key: e("approvalsForm:priceLbl"),
          text: e("approvalsForm:priceLbl"),
          value: {
            name: e("approvalsForm:priceLbl"),
            id: "1"
          }
        }, {
          key: e("approvalsForm:notRequiredLbl"),
          text: e("approvalsForm:notRequiredLbl"),
          value: {
            name: e("approvalsForm:notRequiredLbl"),
            id: "2"
          }
        }, {
          key: e("approvalsForm:moreInfoNeededLbl"),
          text: e("approvalsForm:moreInfoNeededLbl"),
          value: {
            name: e("approvalsForm:moreInfoNeededLbl"),
            id: "3"
          }
        }, {
          key: e("approvalsForm:otherLbl"),
          text: e("approvalsForm:otherLbl"),
          value: {
            name: e("approvalsForm:otherLbl"),
            id: "4"
          }
        }];
      }, a.creditCardOptions = function () {
        var c = a.props.allCreditCardsInfo;

        if (c && c.length > 1) {
          var e = [];
          return c.forEach(function (c) {
            var n = {};
            n.key = c.token, n.text = "credit_card" == c.type ? "**** **** **** " + c.last_4 + (null != c.cardholder_name ? "(" + c.cardholder_name + ")" : "") : a.convertEmail(c.email) + " (PayPal) ", n.value = c.token, e.push(n);
          }), e;
        }

        return null;
      }, a.onApprovalChange = function (c, e) {
        var n = void 0;
        n = !0 === e ? u.statuses.approved : u.statuses.saved;
        var r = t({}, c, {
          status_new: n
        }),
            i = a.state.formData.services,
            o = f.replaceObjectById(i, r, r.id);
        a.setState({
          formData: t({}, a.state.formData, {
            services: o
          })
        }), a.debouncedOnApprovalChange(o && o.map(function (c) {
          return {
            id: c.id,
            status: c.status_new
          };
        }));
      }, a.handleChange = function (c, e) {
        var n = e.value;
        a.setState({
          selectedCreditCardId: n
        });
      }, a.onCommentChange = function (c) {
        var e = a.props.customerCommentsCharLimit;
        (!e || c.target.value.length <= e) && a.setState({
          formData: t({}, a.state.formData, {
            customerComments: c.target.value
          })
        });
      }, a.handleApproverNoteChange = function (c) {
        var e = a.props.approverNotesCharLimit;
        (!e || c.target.value.length <= e) && a.setState({
          formData: t({}, a.state.formData, {
            approverNotes: c.target.value
          })
        });
      }, a.handleApproverNotesSave = function () {
        var c = a.props;
        (0, c.onApproversNotesSubmit)(c.order, a.state.formData.approverNotes), a.resetForm();
      }, a.resetForm = function () {
        a.state.formData.approverNotes.length > 0 && a.setState({
          formData: {
            services: s.formatForApprovalsForm(a.props.services),
            approverNotes: ""
          }
        });
      }, a.onRejectionReasonChange = function (c, e, n) {
        var r = t({}, c, {
          rejection_reason: n.value
        }),
            i = a.state.formData.services,
            o = f.replaceObjectById(i, r, r.id);
        a.setState({
          formData: t({}, a.state.formData, {
            services: o
          })
        });
      }, a.priceTotals = function () {
        var c = a.props.order;
        return {
          retail: Number(c.retail_pre_tax_sub_total) || 0,
          shop: Number(c.pre_tax_sub_total) || 0,
          tax: Number(c.tax_amount) || 0,
          previousPayments: Number(c.previous_payments) || 0,
          transactionFee: Number(c.transaction_fee) || 0,
          orderLevelDiscount: Number(c.order_level_promotional_discount) || 0,
          promotionalDiscount: Number(c.promotional_discount) || 0,
          prepayDiscount: Number(c.prepay_discount) || 0,
          totalSavings: Number(c.total_savings) || 0,
          totalRewardsCredit: Number(c.total_rewards_credit) || 0
        };
      }, a.onVanitySubmit = function (c, e) {
        a.props.onVanitySubmit(c, e);
      }, a.debouncedOnApprovalChange = (0, L.default)(a.props.onApprovalChange, 800), a;
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, i.Component), r(e, [{
      key: "convertEmail",
      value: function value(c) {
        var e = c.split("@"),
            a = n(e, 2),
            t = a[0],
            r = a[1];
        return t.substring(0, 2) + "******" + t.substring(t.length - 2) + "@" + r;
      }
    }, {
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.isSubmitting,
            a = c.order,
            n = c.paymentMethods,
            t = c.paymentListEl,
            r = c.user,
            i = c.styles,
            l = c.customHeader,
            f = c.hideChargeMessage,
            s = c.hideSavings,
            u = c.hidePricing,
            L = c.hideRetailPricing,
            A = c.differentPaymentEl,
            N = c.canApprove,
            g = c.loadingSums,
            H = c.onCancel,
            V = c.eligibleForCancelation,
            x = c.currentUserCanCancel,
            w = c.formattedCancelationContacts,
            y = c.contactUsEl,
            b = c.hidePriceRange,
            S = c.priceRanges,
            T = c.customerCommentsCharLimit,
            D = c.paymentProviderTypes,
            j = c.hasPaymentMethod,
            E = c.t,
            k = c.i18n,
            I = c.pricingPromiseBannerEl,
            O = c.pricingPromiseTextEl,
            Q = c.savingsRibbonEl,
            Z = c.allCreditCardsInfo,
            U = c.promotionalCodeLink,
            B = c.pays_through_platform,
            R = c.CreditCardDropdown,
            Y = c.SelectPaymentProvidersView,
            P = c.selectedPaymentProvider,
            F = c.wex_account_number,
            W = c.isVanityLabelSubmitting,
            G = c.canEditVanity,
            q = c.isApprovalNotesSubmitting,
            J = c.approverNotesCharLimit,
            K = this.state.formData;
        return o.default.createElement("div", {
          className: "approvals_form"
        }, l || o.default.createElement(v.default, {
          t: E,
          pricingPromiseBannerEl: I
        }), o.default.createElement(m.default, {
          onApprovalChange: this.onApprovalChange,
          onRejectionReasonChange: this.onRejectionReasonChange,
          order: a,
          canApprove: N,
          services: K.services,
          styles: i,
          hidePricing: u,
          hideRetailPricing: L,
          hidePriceRange: b,
          contactUsEl: y,
          pricingPromiseTextEl: O,
          priceRanges: S,
          rejectionReasonsOptions: this.rejectionReasonsOptions,
          rejectionReasonsDropdown: this.props.rejectionReasonsDropdown,
          t: E,
          i18n: k,
          onVanitySubmit: this.onVanitySubmit,
          isSubmitting: e,
          isVanityLabelSubmitting: W,
          canEditVanity: G
        }), o.default.createElement(C.default, {
          handleApproverChange: this.handleApproverNoteChange,
          approverNotes: this.state.formData.approverNotes,
          isVisible: a.state === h.AWAITING_APPROVAL && N,
          characterLimit: J,
          t: E,
          canAddApprovalNotes: N,
          handleSubmit: this.handleApproverNotesSave,
          isSubmitting: q,
          resetForm: this.resetForm
        }), o.default.createElement(z.default, {
          onCommentChange: this.onCommentChange,
          comments: this.state.formData.customerComments,
          isVisible: a.state === h.AWAITING_APPROVAL && N,
          characterLimit: T,
          t: E
        }), ![h.INITIATED_BY_USER, h.ACTIVE, h.CANCELLED, h.WALK_IN, h.PRICE_REVIEW].includes(a.state) && o.default.createElement(p.default, {
          user: r,
          order: a,
          paymentMethods: n,
          services: K.services,
          priceTotals: this.priceTotals,
          paymentListEl: t,
          paymentProviderTypes: D,
          hasPaymentMethod: j,
          hideSavings: s,
          differentPaymentEl: A,
          savingsRibbonEl: Q,
          loadingSums: g,
          t: E,
          i18n: k,
          allCreditCardsInfo: Z,
          creditCardOptions: this.creditCardOptions,
          CreditCardDropdown: R,
          handleChange: this.handleChange,
          selectedCreditCardId: this.state.selectedCreditCardId,
          promotionalCodeLink: U,
          pays_through_platform: B,
          SelectPaymentProvidersView: Y,
          selectedPaymentProvider: P,
          canApprove: N,
          wex_account_number: F
        }), o.default.createElement(M.default, {
          isSubmitting: e,
          onCancel: H,
          eligibleForCancelation: V,
          currentUserCanCancel: x,
          formattedCancelationContacts: w,
          t: E
        }), o.default.createElement(d.default, {
          isSubmitting: e,
          isVisible: a.state === h.AWAITING_APPROVAL && N,
          onSubmit: this.handleSubmit,
          user: r,
          order: a,
          priceTotals: this.priceTotals,
          services: K.services,
          hideChargeMessage: f,
          paymentProviderTypes: D,
          t: E
        }));
      }
    }]), e;
  }();

  g.propTypes = {
    isSubmitting: l.default.bool.isRequired,
    onSubmit: l.default.func.isRequired,
    order: l.default.object.isRequired,
    paymentMethods: l.default.array.isRequired,
    services: l.default.array.isRequired,
    priceRanges: l.default.array.isRequired,
    user: l.default.object.isRequired,
    paymentListEl: l.default.element.isRequired,
    styles: l.default.object.isRequired,
    contactUsEl: l.default.element,
    pricingPromiseBannerEl: l.default.element,
    pricingPromiseTextEl: l.default.element,
    savingsRibbonEl: l.default.element,
    customHeader: l.default.element,
    hideChargeMessage: l.default.bool,
    hideRetailPricing: l.default.bool,
    hidePricing: l.default.bool,
    hideSavings: l.default.bool,
    hidePriceRange: l.default.bool,
    canApprove: l.default.bool,
    onApprovalChange: l.default.func.isRequired,
    loadingSums: l.default.bool,
    onCancel: l.default.func,
    eligibleForCancelation: l.default.bool,
    currentUserCanCancel: l.default.bool,
    customerCommentsCharLimit: l.default.number,
    formattedCancelationContacts: l.default.string,
    paymentProviderTypes: l.default.array,
    hasPaymentMethod: l.default.bool
  }, e.default = g;
}, function (c, e, a) {
  "use strict";
  /** @license React v16.14.0
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var n = a(58),
      t = "function" == typeof Symbol && Symbol.for,
      r = t ? Symbol.for("react.element") : 60103,
      i = t ? Symbol.for("react.portal") : 60106,
      o = t ? Symbol.for("react.fragment") : 60107,
      l = t ? Symbol.for("react.strict_mode") : 60108,
      f = t ? Symbol.for("react.profiler") : 60114,
      s = t ? Symbol.for("react.provider") : 60109,
      u = t ? Symbol.for("react.context") : 60110,
      h = t ? Symbol.for("react.forward_ref") : 60112,
      m = t ? Symbol.for("react.suspense") : 60113,
      v = t ? Symbol.for("react.memo") : 60115,
      d = t ? Symbol.for("react.lazy") : 60116,
      M = "function" == typeof Symbol && Symbol.iterator;

  function p(c) {
    for (var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + c, a = 1; a < arguments.length; a++) {
      e += "&args[]=" + encodeURIComponent(arguments[a]);
    }

    return "Minified React error #" + c + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }

  var z = {
    isMounted: function isMounted() {
      return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
  },
      C = {};

  function L(c, e, a) {
    this.props = c, this.context = e, this.refs = C, this.updater = a || z;
  }

  function A() {}

  function N(c, e, a) {
    this.props = c, this.context = e, this.refs = C, this.updater = a || z;
  }

  L.prototype.isReactComponent = {}, L.prototype.setState = function (c, e) {
    if ("object" != typeof c && "function" != typeof c && null != c) throw Error(p(85));
    this.updater.enqueueSetState(this, c, e, "setState");
  }, L.prototype.forceUpdate = function (c) {
    this.updater.enqueueForceUpdate(this, c, "forceUpdate");
  }, A.prototype = L.prototype;
  var g = N.prototype = new A();
  g.constructor = N, n(g, L.prototype), g.isPureReactComponent = !0;
  var H = {
    current: null
  },
      V = Object.prototype.hasOwnProperty,
      x = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function w(c, e, a) {
    var n,
        t = {},
        i = null,
        o = null;
    if (null != e) for (n in void 0 !== e.ref && (o = e.ref), void 0 !== e.key && (i = "" + e.key), e) {
      V.call(e, n) && !x.hasOwnProperty(n) && (t[n] = e[n]);
    }
    var l = arguments.length - 2;
    if (1 === l) t.children = a;else if (1 < l) {
      for (var f = Array(l), s = 0; s < l; s++) {
        f[s] = arguments[s + 2];
      }

      t.children = f;
    }
    if (c && c.defaultProps) for (n in l = c.defaultProps) {
      void 0 === t[n] && (t[n] = l[n]);
    }
    return {
      $$typeof: r,
      type: c,
      key: i,
      ref: o,
      props: t,
      _owner: H.current
    };
  }

  function y(c) {
    return "object" == typeof c && null !== c && c.$$typeof === r;
  }

  var b = /\/+/g,
      S = [];

  function T(c, e, a, n) {
    if (S.length) {
      var t = S.pop();
      return t.result = c, t.keyPrefix = e, t.func = a, t.context = n, t.count = 0, t;
    }

    return {
      result: c,
      keyPrefix: e,
      func: a,
      context: n,
      count: 0
    };
  }

  function D(c) {
    c.result = null, c.keyPrefix = null, c.func = null, c.context = null, c.count = 0, 10 > S.length && S.push(c);
  }

  function j(c, e, a) {
    return null == c ? 0 : function c(e, a, n, t) {
      var o = typeof e;
      "undefined" !== o && "boolean" !== o || (e = null);
      var l = !1;
      if (null === e) l = !0;else switch (o) {
        case "string":
        case "number":
          l = !0;
          break;

        case "object":
          switch (e.$$typeof) {
            case r:
            case i:
              l = !0;
          }

      }
      if (l) return n(t, e, "" === a ? "." + E(e, 0) : a), 1;
      if (l = 0, a = "" === a ? "." : a + ":", Array.isArray(e)) for (var f = 0; f < e.length; f++) {
        var s = a + E(o = e[f], f);
        l += c(o, s, n, t);
      } else if (s = null === e || "object" != typeof e ? null : "function" == typeof (s = M && e[M] || e["@@iterator"]) ? s : null, "function" == typeof s) for (e = s.call(e), f = 0; !(o = e.next()).done;) {
        l += c(o = o.value, s = a + E(o, f++), n, t);
      } else if ("object" === o) throw n = "" + e, Error(p(31, "[object Object]" === n ? "object with keys {" + Object.keys(e).join(", ") + "}" : n, ""));
      return l;
    }(c, "", e, a);
  }

  function E(c, e) {
    return "object" == typeof c && null !== c && null != c.key ? function (c) {
      var e = {
        "=": "=0",
        ":": "=2"
      };
      return "$" + ("" + c).replace(/[=:]/g, function (c) {
        return e[c];
      });
    }(c.key) : e.toString(36);
  }

  function k(c, e) {
    c.func.call(c.context, e, c.count++);
  }

  function I(c, e, a) {
    var n = c.result,
        t = c.keyPrefix;
    c = c.func.call(c.context, e, c.count++), Array.isArray(c) ? O(c, n, a, function (c) {
      return c;
    }) : null != c && (y(c) && (c = function (c, e) {
      return {
        $$typeof: r,
        type: c.type,
        key: e,
        ref: c.ref,
        props: c.props,
        _owner: c._owner
      };
    }(c, t + (!c.key || e && e.key === c.key ? "" : ("" + c.key).replace(b, "$&/") + "/") + a)), n.push(c));
  }

  function O(c, e, a, n, t) {
    var r = "";
    null != a && (r = ("" + a).replace(b, "$&/") + "/"), j(c, I, e = T(e, r, n, t)), D(e);
  }

  var Q = {
    current: null
  };

  function Z() {
    var c = Q.current;
    if (null === c) throw Error(p(321));
    return c;
  }

  var U = {
    ReactCurrentDispatcher: Q,
    ReactCurrentBatchConfig: {
      suspense: null
    },
    ReactCurrentOwner: H,
    IsSomeRendererActing: {
      current: !1
    },
    assign: n
  };
  e.Children = {
    map: function map(c, e, a) {
      if (null == c) return c;
      var n = [];
      return O(c, n, null, e, a), n;
    },
    forEach: function forEach(c, e, a) {
      if (null == c) return c;
      j(c, k, e = T(null, null, e, a)), D(e);
    },
    count: function count(c) {
      return j(c, function () {
        return null;
      }, null);
    },
    toArray: function toArray(c) {
      var e = [];
      return O(c, e, null, function (c) {
        return c;
      }), e;
    },
    only: function only(c) {
      if (!y(c)) throw Error(p(143));
      return c;
    }
  }, e.Component = L, e.Fragment = o, e.Profiler = f, e.PureComponent = N, e.StrictMode = l, e.Suspense = m, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = U, e.cloneElement = function (c, e, a) {
    if (null == c) throw Error(p(267, c));
    var t = n({}, c.props),
        i = c.key,
        o = c.ref,
        l = c._owner;

    if (null != e) {
      if (void 0 !== e.ref && (o = e.ref, l = H.current), void 0 !== e.key && (i = "" + e.key), c.type && c.type.defaultProps) var f = c.type.defaultProps;

      for (s in e) {
        V.call(e, s) && !x.hasOwnProperty(s) && (t[s] = void 0 === e[s] && void 0 !== f ? f[s] : e[s]);
      }
    }

    var s = arguments.length - 2;
    if (1 === s) t.children = a;else if (1 < s) {
      f = Array(s);

      for (var u = 0; u < s; u++) {
        f[u] = arguments[u + 2];
      }

      t.children = f;
    }
    return {
      $$typeof: r,
      type: c.type,
      key: i,
      ref: o,
      props: t,
      _owner: l
    };
  }, e.createContext = function (c, e) {
    return void 0 === e && (e = null), (c = {
      $$typeof: u,
      _calculateChangedBits: e,
      _currentValue: c,
      _currentValue2: c,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }).Provider = {
      $$typeof: s,
      _context: c
    }, c.Consumer = c;
  }, e.createElement = w, e.createFactory = function (c) {
    var e = w.bind(null, c);
    return e.type = c, e;
  }, e.createRef = function () {
    return {
      current: null
    };
  }, e.forwardRef = function (c) {
    return {
      $$typeof: h,
      render: c
    };
  }, e.isValidElement = y, e.lazy = function (c) {
    return {
      $$typeof: d,
      _ctor: c,
      _status: -1,
      _result: null
    };
  }, e.memo = function (c, e) {
    return {
      $$typeof: v,
      type: c,
      compare: void 0 === e ? null : e
    };
  }, e.useCallback = function (c, e) {
    return Z().useCallback(c, e);
  }, e.useContext = function (c, e) {
    return Z().useContext(c, e);
  }, e.useDebugValue = function () {}, e.useEffect = function (c, e) {
    return Z().useEffect(c, e);
  }, e.useImperativeHandle = function (c, e, a) {
    return Z().useImperativeHandle(c, e, a);
  }, e.useLayoutEffect = function (c, e) {
    return Z().useLayoutEffect(c, e);
  }, e.useMemo = function (c, e) {
    return Z().useMemo(c, e);
  }, e.useReducer = function (c, e, a) {
    return Z().useReducer(c, e, a);
  }, e.useRef = function (c) {
    return Z().useRef(c);
  }, e.useState = function (c) {
    return Z().useState(c);
  }, e.version = "16.14.0";
}, function (c, e, a) {
  "use strict";

  var n = a(109);

  function t() {}

  function r() {}

  r.resetWarningCache = t, c.exports = function () {
    function c(c, e, a, t, r, i) {
      if (i !== n) {
        var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw o.name = "Invariant Violation", o;
      }
    }

    function e() {
      return c;
    }

    c.isRequired = c;
    var a = {
      array: c,
      bigint: c,
      bool: c,
      func: c,
      number: c,
      object: c,
      string: c,
      symbol: c,
      any: c,
      arrayOf: e,
      element: c,
      elementType: c,
      instanceOf: e,
      node: c,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  };
}, function (c, e, a) {
  "use strict";

  c.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (c, e, a) {
  var n = a(111),
      t = a(116);

  c.exports = function (c, e) {
    return n(t(c, e), 1);
  };
}, function (c, e, a) {
  var n = a(60),
      t = a(112);

  c.exports = function c(e, a, r, i, o) {
    var l = -1,
        f = e.length;

    for (r || (r = t), o || (o = []); ++l < f;) {
      var s = e[l];
      a > 0 && r(s) ? a > 1 ? c(s, a - 1, r, i, o) : n(o, s) : i || (o[o.length] = s);
    }

    return o;
  };
}, function (c, e, a) {
  var n = a(23),
      t = a(43),
      r = a(11),
      i = n ? n.isConcatSpreadable : void 0;

  c.exports = function (c) {
    return r(c) || t(c) || !!(i && c && c[i]);
  };
}, function (c, e, a) {
  var n = a(24),
      t = a(25),
      r = "[object Arguments]";

  c.exports = function (c) {
    return t(c) && n(c) == r;
  };
}, function (c, e, a) {
  var n = a(23),
      t = Object.prototype,
      r = t.hasOwnProperty,
      i = t.toString,
      o = n ? n.toStringTag : void 0;

  c.exports = function (c) {
    var e = r.call(c, o),
        a = c[o];

    try {
      c[o] = void 0;
      var n = !0;
    } catch (c) {}

    var t = i.call(c);
    return n && (e ? c[o] = a : delete c[o]), t;
  };
}, function (c, e) {
  var a = Object.prototype.toString;

  c.exports = function (c) {
    return a.call(c);
  };
}, function (c, e, a) {
  var n = a(62),
      t = a(117),
      r = a(192),
      i = a(11);

  c.exports = function (c, e) {
    return (i(c) ? n : r)(c, t(e, 3));
  };
}, function (c, e, a) {
  var n = a(118),
      t = a(178),
      r = a(188),
      i = a(11),
      o = a(189);

  c.exports = function (c) {
    return "function" == typeof c ? c : null == c ? r : "object" == typeof c ? i(c) ? t(c[0], c[1]) : n(c) : o(c);
  };
}, function (c, e, a) {
  var n = a(119),
      t = a(177),
      r = a(74);

  c.exports = function (c) {
    var e = t(c);
    return 1 == e.length && e[0][2] ? r(e[0][0], e[0][1]) : function (a) {
      return a === c || n(a, c, e);
    };
  };
}, function (c, e, a) {
  var n = a(63),
      t = a(67),
      r = 1,
      i = 2;

  c.exports = function (c, e, a, o) {
    var l = a.length,
        f = l,
        s = !o;
    if (null == c) return !f;

    for (c = Object(c); l--;) {
      var u = a[l];
      if (s && u[2] ? u[1] !== c[u[0]] : !(u[0] in c)) return !1;
    }

    for (; ++l < f;) {
      var h = (u = a[l])[0],
          m = c[h],
          v = u[1];

      if (s && u[2]) {
        if (void 0 === m && !(h in c)) return !1;
      } else {
        var d = new n();
        if (o) var M = o(m, v, h, c, e, d);
        if (!(void 0 === M ? t(v, m, r | i, o, d) : M)) return !1;
      }
    }

    return !0;
  };
}, function (c, e) {
  c.exports = function () {
    this.__data__ = [], this.size = 0;
  };
}, function (c, e, a) {
  var n = a(31),
      t = Array.prototype.splice;

  c.exports = function (c) {
    var e = this.__data__,
        a = n(e, c);
    return !(a < 0 || (a == e.length - 1 ? e.pop() : t.call(e, a, 1), --this.size, 0));
  };
}, function (c, e, a) {
  var n = a(31);

  c.exports = function (c) {
    var e = this.__data__,
        a = n(e, c);
    return a < 0 ? void 0 : e[a][1];
  };
}, function (c, e, a) {
  var n = a(31);

  c.exports = function (c) {
    return n(this.__data__, c) > -1;
  };
}, function (c, e, a) {
  var n = a(31);

  c.exports = function (c, e) {
    var a = this.__data__,
        t = n(a, c);
    return t < 0 ? (++this.size, a.push([c, e])) : a[t][1] = e, this;
  };
}, function (c, e, a) {
  var n = a(30);

  c.exports = function () {
    this.__data__ = new n(), this.size = 0;
  };
}, function (c, e) {
  c.exports = function (c) {
    var e = this.__data__,
        a = e.delete(c);
    return this.size = e.size, a;
  };
}, function (c, e) {
  c.exports = function (c) {
    return this.__data__.get(c);
  };
}, function (c, e) {
  c.exports = function (c) {
    return this.__data__.has(c);
  };
}, function (c, e, a) {
  var n = a(30),
      t = a(44),
      r = a(46),
      i = 200;

  c.exports = function (c, e) {
    var a = this.__data__;

    if (a instanceof n) {
      var o = a.__data__;
      if (!t || o.length < i - 1) return o.push([c, e]), this.size = ++a.size, this;
      a = this.__data__ = new r(o);
    }

    return a.set(c, e), this.size = a.size, this;
  };
}, function (c, e, a) {
  var n = a(65),
      t = a(131),
      r = a(45),
      i = a(66),
      o = /^\[object .+?Constructor\]$/,
      l = Function.prototype,
      f = Object.prototype,
      s = l.toString,
      u = f.hasOwnProperty,
      h = RegExp("^" + s.call(u).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

  c.exports = function (c) {
    return !(!r(c) || t(c)) && (n(c) ? h : o).test(i(c));
  };
}, function (c, e, a) {
  var n,
      t = a(132),
      r = (n = /[^.]+$/.exec(t && t.keys && t.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "";

  c.exports = function (c) {
    return !!r && r in c;
  };
}, function (c, e, a) {
  var n = a(13)["__core-js_shared__"];
  c.exports = n;
}, function (c, e) {
  c.exports = function (c, e) {
    return null == c ? void 0 : c[e];
  };
}, function (c, e, a) {
  var n = a(135),
      t = a(30),
      r = a(44);

  c.exports = function () {
    this.size = 0, this.__data__ = {
      hash: new n(),
      map: new (r || t)(),
      string: new n()
    };
  };
}, function (c, e, a) {
  var n = a(136),
      t = a(137),
      r = a(138),
      i = a(139),
      o = a(140);

  function l(c) {
    var e = -1,
        a = null == c ? 0 : c.length;

    for (this.clear(); ++e < a;) {
      var n = c[e];
      this.set(n[0], n[1]);
    }
  }

  l.prototype.clear = n, l.prototype.delete = t, l.prototype.get = r, l.prototype.has = i, l.prototype.set = o, c.exports = l;
}, function (c, e, a) {
  var n = a(32);

  c.exports = function () {
    this.__data__ = n ? n(null) : {}, this.size = 0;
  };
}, function (c, e) {
  c.exports = function (c) {
    var e = this.has(c) && delete this.__data__[c];
    return this.size -= e ? 1 : 0, e;
  };
}, function (c, e, a) {
  var n = a(32),
      t = "__lodash_hash_undefined__",
      r = Object.prototype.hasOwnProperty;

  c.exports = function (c) {
    var e = this.__data__;

    if (n) {
      var a = e[c];
      return a === t ? void 0 : a;
    }

    return r.call(e, c) ? e[c] : void 0;
  };
}, function (c, e, a) {
  var n = a(32),
      t = Object.prototype.hasOwnProperty;

  c.exports = function (c) {
    var e = this.__data__;
    return n ? void 0 !== e[c] : t.call(e, c);
  };
}, function (c, e, a) {
  var n = a(32),
      t = "__lodash_hash_undefined__";

  c.exports = function (c, e) {
    var a = this.__data__;
    return this.size += this.has(c) ? 0 : 1, a[c] = n && void 0 === e ? t : e, this;
  };
}, function (c, e, a) {
  var n = a(33);

  c.exports = function (c) {
    var e = n(this, c).delete(c);
    return this.size -= e ? 1 : 0, e;
  };
}, function (c, e) {
  c.exports = function (c) {
    var e = typeof c;
    return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== c : null === c;
  };
}, function (c, e, a) {
  var n = a(33);

  c.exports = function (c) {
    return n(this, c).get(c);
  };
}, function (c, e, a) {
  var n = a(33);

  c.exports = function (c) {
    return n(this, c).has(c);
  };
}, function (c, e, a) {
  var n = a(33);

  c.exports = function (c, e) {
    var a = n(this, c),
        t = a.size;
    return a.set(c, e), this.size += a.size == t ? 0 : 1, this;
  };
}, function (c, e, a) {
  var n = a(63),
      t = a(68),
      r = a(152),
      i = a(156),
      o = a(172),
      l = a(11),
      f = a(69),
      s = a(72),
      u = 1,
      h = "[object Arguments]",
      m = "[object Array]",
      v = "[object Object]",
      d = Object.prototype.hasOwnProperty;

  c.exports = function (c, e, a, M, p, z) {
    var C = l(c),
        L = l(e),
        A = C ? m : o(c),
        N = L ? m : o(e),
        g = (A = A == h ? v : A) == v,
        H = (N = N == h ? v : N) == v,
        V = A == N;

    if (V && f(c)) {
      if (!f(e)) return !1;
      C = !0, g = !1;
    }

    if (V && !g) return z || (z = new n()), C || s(c) ? t(c, e, a, M, p, z) : r(c, e, A, a, M, p, z);

    if (!(a & u)) {
      var x = g && d.call(c, "__wrapped__"),
          w = H && d.call(e, "__wrapped__");

      if (x || w) {
        var y = x ? c.value() : c,
            b = w ? e.value() : e;
        return z || (z = new n()), p(y, b, a, M, z);
      }
    }

    return !!V && (z || (z = new n()), i(c, e, a, M, p, z));
  };
}, function (c, e, a) {
  var n = a(46),
      t = a(148),
      r = a(149);

  function i(c) {
    var e = -1,
        a = null == c ? 0 : c.length;

    for (this.__data__ = new n(); ++e < a;) {
      this.add(c[e]);
    }
  }

  i.prototype.add = i.prototype.push = t, i.prototype.has = r, c.exports = i;
}, function (c, e) {
  var a = "__lodash_hash_undefined__";

  c.exports = function (c) {
    return this.__data__.set(c, a), this;
  };
}, function (c, e) {
  c.exports = function (c) {
    return this.__data__.has(c);
  };
}, function (c, e) {
  c.exports = function (c, e) {
    for (var a = -1, n = null == c ? 0 : c.length; ++a < n;) {
      if (e(c[a], a, c)) return !0;
    }

    return !1;
  };
}, function (c, e) {
  c.exports = function (c, e) {
    return c.has(e);
  };
}, function (c, e, a) {
  var n = a(23),
      t = a(153),
      r = a(64),
      i = a(68),
      o = a(154),
      l = a(155),
      f = 1,
      s = 2,
      u = "[object Boolean]",
      h = "[object Date]",
      m = "[object Error]",
      v = "[object Map]",
      d = "[object Number]",
      M = "[object RegExp]",
      p = "[object Set]",
      z = "[object String]",
      C = "[object Symbol]",
      L = "[object ArrayBuffer]",
      A = "[object DataView]",
      N = n ? n.prototype : void 0,
      g = N ? N.valueOf : void 0;

  c.exports = function (c, e, a, n, N, H, V) {
    switch (a) {
      case A:
        if (c.byteLength != e.byteLength || c.byteOffset != e.byteOffset) return !1;
        c = c.buffer, e = e.buffer;

      case L:
        return !(c.byteLength != e.byteLength || !H(new t(c), new t(e)));

      case u:
      case h:
      case d:
        return r(+c, +e);

      case m:
        return c.name == e.name && c.message == e.message;

      case M:
      case z:
        return c == e + "";

      case v:
        var x = o;

      case p:
        var w = n & f;
        if (x || (x = l), c.size != e.size && !w) return !1;
        var y = V.get(c);
        if (y) return y == e;
        n |= s, V.set(c, e);
        var b = i(x(c), x(e), n, N, H, V);
        return V.delete(c), b;

      case C:
        if (g) return g.call(c) == g.call(e);
    }

    return !1;
  };
}, function (c, e, a) {
  var n = a(13).Uint8Array;
  c.exports = n;
}, function (c, e) {
  c.exports = function (c) {
    var e = -1,
        a = Array(c.size);
    return c.forEach(function (c, n) {
      a[++e] = [n, c];
    }), a;
  };
}, function (c, e) {
  c.exports = function (c) {
    var e = -1,
        a = Array(c.size);
    return c.forEach(function (c) {
      a[++e] = c;
    }), a;
  };
}, function (c, e, a) {
  var n = a(157),
      t = 1,
      r = Object.prototype.hasOwnProperty;

  c.exports = function (c, e, a, i, o, l) {
    var f = a & t,
        s = n(c),
        u = s.length;
    if (u != n(e).length && !f) return !1;

    for (var h = u; h--;) {
      var m = s[h];
      if (!(f ? m in e : r.call(e, m))) return !1;
    }

    var v = l.get(c),
        d = l.get(e);
    if (v && d) return v == e && d == c;
    var M = !0;
    l.set(c, e), l.set(e, c);

    for (var p = f; ++h < u;) {
      var z = c[m = s[h]],
          C = e[m];
      if (i) var L = f ? i(C, z, m, e, c, l) : i(z, C, m, c, e, l);

      if (!(void 0 === L ? z === C || o(z, C, a, i, l) : L)) {
        M = !1;
        break;
      }

      p || (p = "constructor" == m);
    }

    if (M && !p) {
      var A = c.constructor,
          N = e.constructor;
      A != N && "constructor" in c && "constructor" in e && !("function" == typeof A && A instanceof A && "function" == typeof N && N instanceof N) && (M = !1);
    }

    return l.delete(c), l.delete(e), M;
  };
}, function (c, e, a) {
  var n = a(158),
      t = a(159),
      r = a(47);

  c.exports = function (c) {
    return n(c, r, t);
  };
}, function (c, e, a) {
  var n = a(60),
      t = a(11);

  c.exports = function (c, e, a) {
    var r = e(c);
    return t(c) ? r : n(r, a(c));
  };
}, function (c, e, a) {
  var n = a(160),
      t = a(161),
      r = Object.prototype.propertyIsEnumerable,
      i = Object.getOwnPropertySymbols,
      o = i ? function (c) {
    return null == c ? [] : (c = Object(c), n(i(c), function (e) {
      return r.call(c, e);
    }));
  } : t;
  c.exports = o;
}, function (c, e) {
  c.exports = function (c, e) {
    for (var a = -1, n = null == c ? 0 : c.length, t = 0, r = []; ++a < n;) {
      var i = c[a];
      e(i, a, c) && (r[t++] = i);
    }

    return r;
  };
}, function (c, e) {
  c.exports = function () {
    return [];
  };
}, function (c, e, a) {
  var n = a(163),
      t = a(43),
      r = a(11),
      i = a(69),
      o = a(71),
      l = a(72),
      f = Object.prototype.hasOwnProperty;

  c.exports = function (c, e) {
    var a = r(c),
        s = !a && t(c),
        u = !a && !s && i(c),
        h = !a && !s && !u && l(c),
        m = a || s || u || h,
        v = m ? n(c.length, String) : [],
        d = v.length;

    for (var M in c) {
      !e && !f.call(c, M) || m && ("length" == M || u && ("offset" == M || "parent" == M) || h && ("buffer" == M || "byteLength" == M || "byteOffset" == M) || o(M, d)) || v.push(M);
    }

    return v;
  };
}, function (c, e) {
  c.exports = function (c, e) {
    for (var a = -1, n = Array(c); ++a < c;) {
      n[a] = e(a);
    }

    return n;
  };
}, function (c, e) {
  c.exports = function () {
    return !1;
  };
}, function (c, e, a) {
  var n = a(24),
      t = a(48),
      r = a(25),
      i = {};
  i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, c.exports = function (c) {
    return r(c) && t(c.length) && !!i[n(c)];
  };
}, function (c, e) {
  c.exports = function (c) {
    return function (e) {
      return c(e);
    };
  };
}, function (c, e, a) {
  (function (c) {
    var n = a(61),
        t = e && !e.nodeType && e,
        r = t && "object" == typeof c && c && !c.nodeType && c,
        i = r && r.exports === t && n.process,
        o = function () {
      try {
        var c = r && r.require && r.require("util").types;

        return c || i && i.binding && i.binding("util");
      } catch (c) {}
    }();

    c.exports = o;
  }).call(this, a(70)(c));
}, function (c, e, a) {
  var n = a(169),
      t = a(170),
      r = Object.prototype.hasOwnProperty;

  c.exports = function (c) {
    if (!n(c)) return t(c);
    var e = [];

    for (var a in Object(c)) {
      r.call(c, a) && "constructor" != a && e.push(a);
    }

    return e;
  };
}, function (c, e) {
  var a = Object.prototype;

  c.exports = function (c) {
    var e = c && c.constructor;
    return c === ("function" == typeof e && e.prototype || a);
  };
}, function (c, e, a) {
  var n = a(171)(Object.keys, Object);
  c.exports = n;
}, function (c, e) {
  c.exports = function (c, e) {
    return function (a) {
      return c(e(a));
    };
  };
}, function (c, e, a) {
  var n = a(173),
      t = a(44),
      r = a(174),
      i = a(175),
      o = a(176),
      l = a(24),
      f = a(66),
      s = f(n),
      u = f(t),
      h = f(r),
      m = f(i),
      v = f(o),
      d = l;
  (n && "[object DataView]" != d(new n(new ArrayBuffer(1))) || t && "[object Map]" != d(new t()) || r && "[object Promise]" != d(r.resolve()) || i && "[object Set]" != d(new i()) || o && "[object WeakMap]" != d(new o())) && (d = function d(c) {
    var e = l(c),
        a = "[object Object]" == e ? c.constructor : void 0,
        n = a ? f(a) : "";
    if (n) switch (n) {
      case s:
        return "[object DataView]";

      case u:
        return "[object Map]";

      case h:
        return "[object Promise]";

      case m:
        return "[object Set]";

      case v:
        return "[object WeakMap]";
    }
    return e;
  }), c.exports = d;
}, function (c, e, a) {
  var n = a(19)(a(13), "DataView");
  c.exports = n;
}, function (c, e, a) {
  var n = a(19)(a(13), "Promise");
  c.exports = n;
}, function (c, e, a) {
  var n = a(19)(a(13), "Set");
  c.exports = n;
}, function (c, e, a) {
  var n = a(19)(a(13), "WeakMap");
  c.exports = n;
}, function (c, e, a) {
  var n = a(73),
      t = a(47);

  c.exports = function (c) {
    for (var e = t(c), a = e.length; a--;) {
      var r = e[a],
          i = c[r];
      e[a] = [r, i, n(i)];
    }

    return e;
  };
}, function (c, e, a) {
  var n = a(67),
      t = a(179),
      r = a(185),
      i = a(50),
      o = a(73),
      l = a(74),
      f = a(34),
      s = 1,
      u = 2;

  c.exports = function (c, e) {
    return i(c) && o(e) ? l(f(c), e) : function (a) {
      var i = t(a, c);
      return void 0 === i && i === e ? r(a, c) : n(e, i, s | u);
    };
  };
}, function (c, e, a) {
  var n = a(75);

  c.exports = function (c, e, a) {
    var t = null == c ? void 0 : n(c, e);
    return void 0 === t ? a : t;
  };
}, function (c, e, a) {
  var n = a(181),
      t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      r = /\\(\\)?/g,
      i = n(function (c) {
    var e = [];
    return 46 === c.charCodeAt(0) && e.push(""), c.replace(t, function (c, a, n, t) {
      e.push(n ? t.replace(r, "$1") : a || c);
    }), e;
  });
  c.exports = i;
}, function (c, e, a) {
  var n = a(182),
      t = 500;

  c.exports = function (c) {
    var e = n(c, function (c) {
      return a.size === t && a.clear(), c;
    }),
        a = e.cache;
    return e;
  };
}, function (c, e, a) {
  var n = a(46),
      t = "Expected a function";

  function r(c, e) {
    if ("function" != typeof c || null != e && "function" != typeof e) throw new TypeError(t);

    var a = function a() {
      var n = arguments,
          t = e ? e.apply(this, n) : n[0],
          r = a.cache;
      if (r.has(t)) return r.get(t);
      var i = c.apply(this, n);
      return a.cache = r.set(t, i) || r, i;
    };

    return a.cache = new (r.Cache || n)(), a;
  }

  r.Cache = n, c.exports = r;
}, function (c, e, a) {
  var n = a(184);

  c.exports = function (c) {
    return null == c ? "" : n(c);
  };
}, function (c, e, a) {
  var n = a(23),
      t = a(62),
      r = a(11),
      i = a(51),
      o = 1 / 0,
      l = n ? n.prototype : void 0,
      f = l ? l.toString : void 0;

  c.exports = function c(e) {
    if ("string" == typeof e) return e;
    if (r(e)) return t(e, c) + "";
    if (i(e)) return f ? f.call(e) : "";
    var a = e + "";
    return "0" == a && 1 / e == -o ? "-0" : a;
  };
}, function (c, e, a) {
  var n = a(186),
      t = a(187);

  c.exports = function (c, e) {
    return null != c && t(c, e, n);
  };
}, function (c, e) {
  c.exports = function (c, e) {
    return null != c && e in Object(c);
  };
}, function (c, e, a) {
  var n = a(76),
      t = a(43),
      r = a(11),
      i = a(71),
      o = a(48),
      l = a(34);

  c.exports = function (c, e, a) {
    for (var f = -1, s = (e = n(e, c)).length, u = !1; ++f < s;) {
      var h = l(e[f]);
      if (!(u = null != c && a(c, h))) break;
      c = c[h];
    }

    return u || ++f != s ? u : !!(s = null == c ? 0 : c.length) && o(s) && i(h, s) && (r(c) || t(c));
  };
}, function (c, e) {
  c.exports = function (c) {
    return c;
  };
}, function (c, e, a) {
  var n = a(190),
      t = a(191),
      r = a(50),
      i = a(34);

  c.exports = function (c) {
    return r(c) ? n(i(c)) : t(c);
  };
}, function (c, e) {
  c.exports = function (c) {
    return function (e) {
      return null == e ? void 0 : e[c];
    };
  };
}, function (c, e, a) {
  var n = a(75);

  c.exports = function (c) {
    return function (e) {
      return n(e, c);
    };
  };
}, function (c, e, a) {
  var n = a(193),
      t = a(49);

  c.exports = function (c, e) {
    var a = -1,
        r = t(c) ? Array(c.length) : [];
    return n(c, function (c, n, t) {
      r[++a] = e(c, n, t);
    }), r;
  };
}, function (c, e, a) {
  var n = a(194),
      t = a(197)(n);
  c.exports = t;
}, function (c, e, a) {
  var n = a(195),
      t = a(47);

  c.exports = function (c, e) {
    return c && n(c, e, t);
  };
}, function (c, e, a) {
  var n = a(196)();
  c.exports = n;
}, function (c, e) {
  c.exports = function (c) {
    return function (e, a, n) {
      for (var t = -1, r = Object(e), i = n(e), o = i.length; o--;) {
        var l = i[c ? o : ++t];
        if (!1 === a(r[l], l, r)) break;
      }

      return e;
    };
  };
}, function (c, e, a) {
  var n = a(49);

  c.exports = function (c, e) {
    return function (a, t) {
      if (null == a) return a;
      if (!n(a)) return c(a, t);

      for (var r = a.length, i = e ? r : -1, o = Object(a); (e ? i-- : ++i < r) && !1 !== t(o[i], i, o);) {
        ;
      }

      return a;
    };
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = s(t),
      i = s(a(2)),
      o = s(a(199)),
      l = s(a(225)),
      f = function (c) {
    if (c && c.__esModule) return c;
    var e = {};
    if (null != c) for (var a in c) {
      Object.prototype.hasOwnProperty.call(c, a) && (e[a] = c[a]);
    }
    return e.default = c, e;
  }(a(22));

  function s(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var u = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.onApprovalChange,
            a = c.order,
            n = c.services,
            t = c.styles,
            i = c.hidePricing,
            s = c.hideRetailPricing,
            u = c.canApprove,
            h = c.contactUsEl,
            m = c.hidePriceRange,
            v = c.priceRanges,
            d = c.t,
            M = c.i18n,
            p = c.pricingPromiseTextEl,
            z = c.onVanitySubmit,
            C = c.isVanityLabelSubmitting,
            L = c.canEditVanity,
            A = f.splitByCategory(n);
        return r.default.createElement("div", {
          className: "approvals_form_fields"
        }, r.default.createElement(l.default, {
          order: a
        }), r.default.createElement(o.default, {
          headerType: "secondary",
          isEditable: u,
          onApprovalChange: e,
          order: a,
          services: A.user_requested,
          title: d("approvalsFormFields:yourServicesTitle"),
          styles: t,
          hidePricing: i,
          hideRetailPricing: s,
          hidePriceRange: m,
          pricingPromiseTextEl: p,
          rejectionReasonsDropdown: this.props.rejectionReasonsDropdown,
          rejectionReasonsOptions: this.props.rejectionReasonsOptions,
          onRejectionReasonChange: this.props.onRejectionReasonChange,
          t: d,
          i18n: M,
          onVanitySubmit: z,
          isVanityLabelSubmitting: C,
          canEditVanity: L
        }), r.default.createElement(o.default, {
          headerType: "secondary",
          isEditable: u,
          onApprovalChange: e,
          order: a,
          services: A.shop_suggested,
          title: d("approvalsFormFields:shopSuggestedServiceTitle"),
          styles: t,
          hidePricing: i,
          hideRetailPricing: s,
          contactUsEl: h,
          pricingPromiseTextEl: p,
          isShopSuggested: !0,
          hidePriceRange: m,
          priceRanges: v,
          rejectionReasonsDropdown: this.props.rejectionReasonsDropdown,
          rejectionReasonsOptions: this.props.rejectionReasonsOptions,
          onRejectionReasonChange: this.props.onRejectionReasonChange,
          t: d,
          i18n: M,
          onVanitySubmit: z,
          isVanityLabelSubmitting: C,
          canEditVanity: L
        }), r.default.createElement(o.default, {
          headerType: "primary",
          isEditable: !1,
          onApprovalChange: e,
          order: a,
          services: A.previously_approved,
          title: d("approvalsFormFields:previouslyApprovedServicesTitle"),
          styles: t,
          hidePricing: i,
          hideRetailPricing: s,
          hidePriceRange: m,
          t: d,
          i18n: M,
          onVanitySubmit: z,
          isVanityLabelSubmitting: C,
          canEditVanity: L
        }), r.default.createElement(o.default, {
          headerType: "primary",
          isEditable: !1,
          onApprovalChange: e,
          order: a,
          services: A.auto_approved,
          title: d("approvalsFormFields:autoApprovedServicesTitle"),
          styles: t,
          hidePricing: i,
          hideRetailPricing: s,
          hidePriceRange: m,
          t: d,
          i18n: M,
          onVanitySubmit: z,
          isVanityLabelSubmitting: C,
          canEditVanity: L
        }));
      }
    }]), e;
  }();

  u.propTypes = {
    onApprovalChange: i.default.func.isRequired,
    canApprove: i.default.bool.isRequired,
    order: i.default.object.isRequired,
    contactUsEl: i.default.element.isRequired,
    pricingPromiseTextEl: i.default.element.isRequired,
    services: i.default.array.isRequired,
    priceRanges: i.default.array.isRequired,
    styles: i.default.object.isRequired,
    hideRetailPricing: i.default.bool,
    hidePriceRange: i.default.bool,
    hidePricing: i.default.bool
  }, e.default = u;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = l(t),
      i = l(a(2)),
      o = (a(12), l(a(200)));

  function l(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var f = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "headerClassName",
      value: function value() {
        var c = this.props.headerType,
            e = "";
        return "primary" === c ? e = "--primary" : "secondary" === c ? e = "--secondary" : "tertiary" === c && (e = "--tertiary"), "approvals_form_fields_section__header" + e;
      }
    }, {
      key: "renderContent",
      value: function value() {
        return this.props.services.length > 0 ? r.default.createElement("div", {
          className: "approvals_form_fields_section"
        }, this.renderHeader(), this.renderFields()) : null;
      }
    }, {
      key: "renderFields",
      value: function value() {
        var c = this,
            e = this.props,
            a = e.isEditable,
            n = e.onApprovalChange,
            t = e.services,
            i = e.styles,
            l = e.hidePricing,
            f = e.hideRetailPricing,
            s = e.order,
            u = e.contactUsEl,
            h = e.isShopSuggested,
            m = e.hidePriceRange,
            v = e.priceRanges,
            d = (e.rejectionReasonsDropdown, e.t),
            M = e.i18n,
            p = e.pricingPromiseTextEl,
            z = e.onVanitySubmit,
            C = e.isVanityLabelSubmitting,
            L = e.canEditVanity;
        return t.map(function (e, t) {
          var A = (v || []).find(function (c) {
            return e && c.name === e.name;
          }) || {};
          return r.default.createElement(o.default, {
            isEditable: a,
            isShopSuggested: h,
            onApprovalChange: n,
            key: e.id,
            orderState: s.state,
            service: e,
            priceRange: A,
            styles: i,
            hideRetailPricing: f,
            hidePricing: l,
            hidePriceRange: m,
            contactUsEl: u,
            pricingPromiseTextEl: p,
            order: s,
            rejectionReasonsDropdown: c.props.rejectionReasonsOptions && s && r.default.cloneElement(c.props.rejectionReasonsDropdown, {
              options: c.props.rejectionReasonsOptions(e),
              onChange: function onChange(a, n) {
                return c.props.onRejectionReasonChange(e, a, n);
              }
            }),
            t: d,
            i18n: M,
            onVanitySubmit: z,
            isVanityLabelSubmitting: C,
            canEditVanity: L
          });
        });
      }
    }, {
      key: "renderHeader",
      value: function value() {
        var c = this.props,
            e = (c.headerType, c.title);
        return r.default.createElement("div", {
          className: this.headerClassName()
        }, e);
      }
    }, {
      key: "render",
      value: function value() {
        return r.default.createElement("div", {
          className: "approvals_form_fields_section__wrapper"
        }, this.renderContent());
      }
    }]), e;
  }();

  f.propTypes = {
    onApprovalChange: i.default.func.isRequired,
    order: i.default.object.isRequired,
    services: i.default.array.isRequired,
    priceRanges: i.default.array.isRequired,
    title: i.default.string.isRequired,
    pricingPromiseTextEl: i.default.element,
    headerType: i.default.string,
    isEditable: i.default.bool,
    isShopSuggested: i.default.bool,
    styles: i.default.object.isRequired,
    hideRetailPricing: i.default.bool,
    hidePricing: i.default.bool,
    hidePriceRange: i.default.bool,
    contactUsEl: i.default.element.isRequired
  }, f.defaultProps = {
    headerType: "primary",
    isEditable: !0
  }, e.default = f;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = A(t),
      i = A(a(2)),
      o = function (c) {
    if (c && c.__esModule) return c;
    var e = {};
    if (null != c) for (var a in c) {
      Object.prototype.hasOwnProperty.call(c, a) && (e[a] = c[a]);
    }
    return e.default = c, e;
  }(a(22)),
      l = a(20),
      f = a(12),
      s = A(a(35)),
      u = A(a(77)),
      h = A(a(21)),
      m = (A(a(83)), A(a(219))),
      v = A(a(220)),
      d = A(a(84)),
      M = A(a(221)),
      p = A(a(222)),
      z = (a(14), a(26), a(82)),
      C = a(36),
      L = A(a(223));

  function A(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var N = function N(c) {
    var e = c.label,
        a = c.icon;
    return r.default.createElement("div", {
      className: "column--2 approvals_form_field__button_column"
    }, r.default.createElement("div", {
      className: "approvals_form_field__approved_badge"
    }, e), a && r.default.createElement(r.default.Fragment, null, " ", r.default.createElement("span", {
      style: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }
    }, a)));
  },
      g = function g(c) {
    var e = c.service,
        a = c.t,
        n = e.why_do_this,
        t = e.what_if_decline;
    return null == n && null == t ? r.default.createElement(d.default, {
      subtitle: e.name,
      t: a
    }) : r.default.createElement(r.default.Fragment, null, n && r.default.createElement("div", null, r.default.createElement("div", {
      className: "modal-title"
    }, a("approvalsFormField:whyShouldIDoThisTitle")), r.default.createElement("p", null, n)), t && r.default.createElement("div", null, r.default.createElement("div", {
      className: "modal-title"
    }, a("approvalsFormField:whatIfIDeclineTitle")), r.default.createElement("p", null, t)));
  },
      H = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "renderButtonColumn",
      value: function value() {
        var c = this.props,
            e = c.isEditable,
            a = c.onApprovalChange,
            n = c.service,
            t = c.styles,
            i = c.orderState,
            s = c.t,
            u = n && n.status,
            v = null;
        n.override_total && 0 === parseFloat(n.override_total) ? v = r.default.createElement("p", null, s("approvalsFormField:autoApproveText")) : n.auto_approved_due_to_user_originated_fixed_price && (v = r.default.createElement("p", null, s("approvalsFormField:wasAutoApprovedText")));
        var d = v && r.default.createElement(h.default, {
          headerTitle: o.formattedName(n),
          icon: z.faQuestionCircle
        }, v);
        return e && i === f.AWAITING_APPROVAL ? r.default.createElement("div", {
          className: "column--2 approvals_form_field__button_column"
        }, r.default.createElement("div", null, r.default.createElement(m.default, {
          onChange: function onChange(c) {
            return a(n, !c);
          },
          value: n.status_new === l.statuses.approved,
          styles: t,
          t: s
        }))) : [f.INITIATED_BY_USER, f.ACTIVE].includes(i) ? null : [l.statuses.approved, l.statuses.completed].includes(u) ? r.default.createElement(r.default.Fragment, null, r.default.createElement(N, {
          label: s("approvalsFormField:approvedLbl"),
          icon: d
        })) : l.SAVED_OR_DELETED_STATUSES.includes(u) ? r.default.createElement(N, {
          label: s("approvalsFormField:savedLbl")
        }) : null;
      }
    }, {
      key: "renderInfoColumn",
      value: function value() {
        var c = this.props,
            e = c.service,
            a = c.orderState,
            n = c.t,
            t = c.onVanitySubmit,
            i = c.isVanityLabelSubmitting,
            l = c.canEditVanity,
            s = (e && e.status_new, o.formattedName(e)),
            u = ![f.INITIATED_BY_USER, f.ACTIVE, f.CANCELLED, f.WALK_IN, f.PRICE_REVIEW].includes(a);
        return r.default.createElement("div", {
          className: "column--7"
        }, r.default.createElement("div", {
          className: "row approvals_form_field__row"
        }, r.default.createElement("div", {
          className: "column--12"
        }, e.quantity ? s + " (" + e.quantity + ")" : s, u && this.renderInfoModal()), r.default.createElement("div", {
          className: "column--8"
        }, r.default.createElement(L.default, {
          service: e,
          t: n,
          onVanitySubmit: t,
          isSubmitting: i,
          canEditVanity: l
        }))));
      }
    }, {
      key: "renderInfoModal",
      value: function value() {
        var c = this.props,
            e = c.styles,
            a = c.contactUsEl,
            n = c.onApprovalChange,
            t = c.isShopSuggested,
            i = c.hidePriceRange,
            o = c.priceRange,
            f = c.t,
            s = c.i18n,
            h = c.pricingPromiseTextEl,
            m = this.props.service || {},
            d = [];
        d = -1 === l.WAITING_FOR_APPROVAL_STATUSES.indexOf(m.status) ? [] : [{
          onClick: function onClick() {
            return n(m, !0);
          },
          text: f("approvalsFormField:approveText"),
          colorStyle: "orange",
          appendClose: !0
        }, {
          onClick: function onClick() {
            return n(m, !1);
          },
          text: f("approvalsFormField:declineText"),
          colorStyle: "white",
          style: {
            color: e.primaryColor,
            marginTop: "10px"
          },
          appendClose: !0
        }];
        var M = [{
          title: f("approvalsFormField:whatWillThisCostTitle"),
          buttons: d,
          content: r.default.createElement(v.default, {
            service: m,
            styles: e,
            contactUsEl: a,
            pricingPromiseTextEl: h,
            onApprovalChange: n,
            isShopSuggested: t,
            hidePriceRange: i,
            priceRange: o,
            t: f,
            i18n: s
          })
        }, {
          title: f("approvalsFormField:whyShouldIDoThisTitle"),
          buttons: d,
          content: m.why_do_this && r.default.createElement(g, {
            service: m,
            t: f
          })
        }].filter(function (c) {
          return null != c.content;
        });
        return r.default.createElement(u.default, {
          customElement: r.default.createElement("div", {
            className: "underline",
            style: {
              color: e.primaryColor
            }
          }, f("approvalsFormField:seeDetailsLbl")),
          styles: e,
          pages: M,
          t: f
        });
      }
    }, {
      key: "renderRetailPriceColumn",
      value: function value() {
        var c = this.props,
            e = c.service,
            a = c.i18n,
            n = o.priceForRetail(e),
            t = "";
        return o.priceForShop(e) < n ? (t = "" + (0, C.numberFormatToCurrency)(n.toFixed(2), a), r.default.createElement("div", {
          className: "column--1 approvals_form_field__price_column"
        }, r.default.createElement("div", {
          className: "approvals_form_field__price_retail"
        }, t))) : null;
      }
    }, {
      key: "renderShopPrice",
      value: function value() {
        var c = this.props,
            e = c.service,
            a = c.i18n;
        return r.default.createElement("div", {
          className: "approvals_form_field__price_shop_wrapper"
        }, r.default.createElement(s.default, {
          className: "approvals_form_field__price_shop_icon",
          src: M.default
        }), r.default.createElement("div", {
          className: "approvals_form_field__price_shop"
        }, "" + (0, C.numberFormatToCurrency)(o.priceForShop(e).toFixed(2), a)));
      }
    }, {
      key: "renderShopPriceColumn",
      value: function value() {
        return r.default.createElement("div", {
          className: "column--2 approvals_form_field__price_column"
        }, this.renderShopPrice());
      }
    }, {
      key: "render",
      value: function value() {
        var c = this.props.service,
            e = c.status_new,
            a = c.description,
            n = this.props,
            t = n.orderState,
            i = n.t;
        n.pricingPromiseTextEl;
        return r.default.createElement("div", {
          className: "approvals_form_field"
        }, r.default.createElement("div", {
          className: "row approvals_form_field__row"
        }, this.renderInfoColumn(), !this.props.hideRetailPricing && this.renderRetailPriceColumn(), !this.props.hidePricing && this.renderShopPriceColumn(), this.renderButtonColumn()), r.default.createElement("div", {
          className: "row approvals_form_field__row"
        }, t === f.AWAITING_APPROVAL && l.SAVED_OR_DELETED_STATUSES.includes(e) && this.props.rejectionReasonsDropdown), a && r.default.createElement("div", null, a), r.default.createElement(p.default, {
          comment: this.props.service.shop_comments,
          t: i
        }), r.default.createElement(p.default, {
          comment: this.props.service.ase_comments,
          isAse: !0,
          t: i
        }));
      }
    }]), e;
  }();

  H.propTypes = {
    onApprovalChange: i.default.func.isRequired,
    orderState: i.default.string.isRequired,
    service: i.default.object.isRequired,
    priceRange: i.default.object.isRequired,
    styles: i.default.object.isRequired,
    contactUsEl: i.default.element.isRequired,
    pricingPromiseTextEl: i.default.element.isRequired,
    isEditable: i.default.bool,
    hideRetailPricing: i.default.bool,
    hidePriceRange: i.default.bool,
    hidePricing: i.default.bool,
    order: i.default.object.isRequired
  }, H.defaultProps = {
    isEditable: !0
  }, e.default = H;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.bodyOpenClassName = e.portalClassName = void 0;

  var n = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  },
      t = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      r = a(0),
      i = v(r),
      o = v(a(15)),
      l = v(a(2)),
      f = v(a(205)),
      s = function (c) {
    if (c && c.__esModule) return c;
    var e = {};
    if (null != c) for (var a in c) {
      Object.prototype.hasOwnProperty.call(c, a) && (e[a] = c[a]);
    }
    return e.default = c, e;
  }(a(79)),
      u = a(53),
      h = v(u),
      m = a(210);

  function v(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  function d(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var M = e.portalClassName = "ReactModalPortal",
      p = e.bodyOpenClassName = "ReactModal__Body--open",
      z = u.canUseDOM && void 0 !== o.default.createPortal,
      C = function C(c) {
    return document.createElement(c);
  },
      L = function L() {
    return z ? o.default.createPortal : o.default.unstable_renderSubtreeIntoContainer;
  };

  function A(c) {
    return c();
  }

  var N = function (c) {
    function e() {
      var c, a, t;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var r = arguments.length, l = Array(r), s = 0; s < r; s++) {
        l[s] = arguments[s];
      }

      return a = t = d(this, (c = e.__proto__ || Object.getPrototypeOf(e)).call.apply(c, [this].concat(l))), t.removePortal = function () {
        !z && o.default.unmountComponentAtNode(t.node);
        var c = A(t.props.parentSelector);
        c && c.contains(t.node) ? c.removeChild(t.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
      }, t.portalRef = function (c) {
        t.portal = c;
      }, t.renderPortal = function (c) {
        var a = L()(t, i.default.createElement(f.default, n({
          defaultStyles: e.defaultStyles
        }, c)), t.node);
        t.portalRef(a);
      }, d(t, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, r.Component), t(e, [{
      key: "componentDidMount",
      value: function value() {
        u.canUseDOM && (z || (this.node = C("div")), this.node.className = this.props.portalClassName, A(this.props.parentSelector).appendChild(this.node), !z && this.renderPortal(this.props));
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function value(c) {
        return {
          prevParent: A(c.parentSelector),
          nextParent: A(this.props.parentSelector)
        };
      }
    }, {
      key: "componentDidUpdate",
      value: function value(c, e, a) {
        if (u.canUseDOM) {
          var n = this.props,
              t = n.isOpen,
              r = n.portalClassName;
          c.portalClassName !== r && (this.node.className = r);
          var i = a.prevParent,
              o = a.nextParent;
          o !== i && (i.removeChild(this.node), o.appendChild(this.node)), (c.isOpen || t) && !z && this.renderPortal(this.props);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        if (u.canUseDOM && this.node && this.portal) {
          var c = this.portal.state,
              e = Date.now(),
              a = c.isOpen && this.props.closeTimeoutMS && (c.closesAt || e + this.props.closeTimeoutMS);
          a ? (c.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, a - e)) : this.removePortal();
        }
      }
    }, {
      key: "render",
      value: function value() {
        return u.canUseDOM && z ? (!this.node && z && (this.node = C("div")), L()(i.default.createElement(f.default, n({
          ref: this.portalRef,
          defaultStyles: e.defaultStyles
        }, this.props)), this.node)) : null;
      }
    }], [{
      key: "setAppElement",
      value: function value(c) {
        s.setElement(c);
      }
    }]), e;
  }();

  N.propTypes = {
    isOpen: l.default.bool.isRequired,
    style: l.default.shape({
      content: l.default.object,
      overlay: l.default.object
    }),
    portalClassName: l.default.string,
    bodyOpenClassName: l.default.string,
    htmlOpenClassName: l.default.string,
    className: l.default.oneOfType([l.default.string, l.default.shape({
      base: l.default.string.isRequired,
      afterOpen: l.default.string.isRequired,
      beforeClose: l.default.string.isRequired
    })]),
    overlayClassName: l.default.oneOfType([l.default.string, l.default.shape({
      base: l.default.string.isRequired,
      afterOpen: l.default.string.isRequired,
      beforeClose: l.default.string.isRequired
    })]),
    appElement: l.default.oneOfType([l.default.instanceOf(h.default), l.default.instanceOf(u.SafeHTMLCollection), l.default.instanceOf(u.SafeNodeList), l.default.arrayOf(l.default.instanceOf(h.default))]),
    onAfterOpen: l.default.func,
    onRequestClose: l.default.func,
    closeTimeoutMS: l.default.number,
    ariaHideApp: l.default.bool,
    shouldFocusAfterRender: l.default.bool,
    shouldCloseOnOverlayClick: l.default.bool,
    shouldReturnFocusAfterClose: l.default.bool,
    preventScroll: l.default.bool,
    parentSelector: l.default.func,
    aria: l.default.object,
    data: l.default.object,
    role: l.default.string,
    contentLabel: l.default.string,
    shouldCloseOnEsc: l.default.bool,
    overlayRef: l.default.func,
    contentRef: l.default.func,
    id: l.default.string,
    overlayElement: l.default.func,
    contentElement: l.default.func
  }, N.defaultProps = {
    isOpen: !1,
    portalClassName: M,
    bodyOpenClassName: p,
    role: "dialog",
    ariaHideApp: !0,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: !0,
    shouldCloseOnEsc: !0,
    shouldCloseOnOverlayClick: !0,
    shouldReturnFocusAfterClose: !0,
    preventScroll: !1,
    parentSelector: function parentSelector() {
      return document.body;
    },
    overlayElement: function overlayElement(c, e) {
      return i.default.createElement("div", c, e);
    },
    contentElement: function contentElement(c, e) {
      return i.default.createElement("div", c, e);
    }
  }, N.defaultStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
      position: "absolute",
      top: "40px",
      left: "40px",
      right: "40px",
      bottom: "40px",
      border: "1px solid #ccc",
      background: "#fff",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "4px",
      outline: "none",
      padding: "20px"
    }
  }, (0, m.polyfill)(N), e.default = N;
}, function (c, e, a) {
  "use strict";
  /** @license React v16.14.0
   * react-dom.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var n = a(0),
      t = a(58),
      r = a(203);

  function i(c) {
    for (var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + c, a = 1; a < arguments.length; a++) {
      e += "&args[]=" + encodeURIComponent(arguments[a]);
    }

    return "Minified React error #" + c + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }

  if (!n) throw Error(i(227));
  var o = !1,
      l = null,
      f = !1,
      s = null,
      u = {
    onError: function onError(c) {
      o = !0, l = c;
    }
  };

  function h(c, e, a, n, t, r, i, f, s) {
    o = !1, l = null, function (c, e, a, n, t, r, i, o, l) {
      var f = Array.prototype.slice.call(arguments, 3);

      try {
        e.apply(a, f);
      } catch (c) {
        this.onError(c);
      }
    }.apply(u, arguments);
  }

  var m = null,
      v = null,
      d = null;

  function M(c, e, a) {
    var n = c.type || "unknown-event";
    c.currentTarget = d(a), function (c, e, a, n, t, r, u, m, v) {
      if (h.apply(this, arguments), o) {
        if (!o) throw Error(i(198));
        var d = l;
        o = !1, l = null, f || (f = !0, s = d);
      }
    }(n, e, void 0, c), c.currentTarget = null;
  }

  var p = null,
      z = {};

  function C() {
    if (p) for (var c in z) {
      var e = z[c],
          a = p.indexOf(c);
      if (!(-1 < a)) throw Error(i(96, c));

      if (!A[a]) {
        if (!e.extractEvents) throw Error(i(97, c));

        for (var n in A[a] = e, a = e.eventTypes) {
          var t = void 0,
              r = a[n],
              o = e,
              l = n;
          if (N.hasOwnProperty(l)) throw Error(i(99, l));
          N[l] = r;
          var f = r.phasedRegistrationNames;

          if (f) {
            for (t in f) {
              f.hasOwnProperty(t) && L(f[t], o, l);
            }

            t = !0;
          } else r.registrationName ? (L(r.registrationName, o, l), t = !0) : t = !1;

          if (!t) throw Error(i(98, n, c));
        }
      }
    }
  }

  function L(c, e, a) {
    if (g[c]) throw Error(i(100, c));
    g[c] = e, H[c] = e.eventTypes[a].dependencies;
  }

  var A = [],
      N = {},
      g = {},
      H = {};

  function V(c) {
    var e,
        a = !1;

    for (e in c) {
      if (c.hasOwnProperty(e)) {
        var n = c[e];

        if (!z.hasOwnProperty(e) || z[e] !== n) {
          if (z[e]) throw Error(i(102, e));
          z[e] = n, a = !0;
        }
      }
    }

    a && C();
  }

  var x = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement),
      w = null,
      y = null,
      b = null;

  function S(c) {
    if (c = v(c)) {
      if ("function" != typeof w) throw Error(i(280));
      var e = c.stateNode;
      e && (e = m(e), w(c.stateNode, c.type, e));
    }
  }

  function T(c) {
    y ? b ? b.push(c) : b = [c] : y = c;
  }

  function D() {
    if (y) {
      var c = y,
          e = b;
      if (b = y = null, S(c), e) for (c = 0; c < e.length; c++) {
        S(e[c]);
      }
    }
  }

  function j(c, e) {
    return c(e);
  }

  function E(c, e, a, n, t) {
    return c(e, a, n, t);
  }

  function k() {}

  var I = j,
      O = !1,
      Q = !1;

  function Z() {
    null === y && null === b || (k(), D());
  }

  function U(c, e, a) {
    if (Q) return c(e, a);
    Q = !0;

    try {
      return I(c, e, a);
    } finally {
      Q = !1, Z();
    }
  }

  var B = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
      R = Object.prototype.hasOwnProperty,
      Y = {},
      P = {};

  function F(c, e, a, n, t, r) {
    this.acceptsBooleans = 2 === e || 3 === e || 4 === e, this.attributeName = n, this.attributeNamespace = t, this.mustUseProperty = a, this.propertyName = c, this.type = e, this.sanitizeURL = r;
  }

  var W = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (c) {
    W[c] = new F(c, 0, !1, c, null, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (c) {
    var e = c[0];
    W[e] = new F(e, 1, !1, c[1], null, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (c) {
    W[c] = new F(c, 2, !1, c.toLowerCase(), null, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (c) {
    W[c] = new F(c, 2, !1, c, null, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (c) {
    W[c] = new F(c, 3, !1, c.toLowerCase(), null, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function (c) {
    W[c] = new F(c, 3, !0, c, null, !1);
  }), ["capture", "download"].forEach(function (c) {
    W[c] = new F(c, 4, !1, c, null, !1);
  }), ["cols", "rows", "size", "span"].forEach(function (c) {
    W[c] = new F(c, 6, !1, c, null, !1);
  }), ["rowSpan", "start"].forEach(function (c) {
    W[c] = new F(c, 5, !1, c.toLowerCase(), null, !1);
  });
  var G = /[\-:]([a-z])/g;

  function q(c) {
    return c[1].toUpperCase();
  }

  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (c) {
    var e = c.replace(G, q);
    W[e] = new F(e, 1, !1, c, null, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (c) {
    var e = c.replace(G, q);
    W[e] = new F(e, 1, !1, c, "http://www.w3.org/1999/xlink", !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function (c) {
    var e = c.replace(G, q);
    W[e] = new F(e, 1, !1, c, "http://www.w3.org/XML/1998/namespace", !1);
  }), ["tabIndex", "crossOrigin"].forEach(function (c) {
    W[c] = new F(c, 1, !1, c.toLowerCase(), null, !1);
  }), W.xlinkHref = new F("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), ["src", "href", "action", "formAction"].forEach(function (c) {
    W[c] = new F(c, 1, !1, c.toLowerCase(), null, !0);
  });
  var J = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

  function K(c, e, a, n) {
    var t = W.hasOwnProperty(e) ? W[e] : null;
    (null !== t ? 0 === t.type : !n && 2 < e.length && ("o" === e[0] || "O" === e[0]) && ("n" === e[1] || "N" === e[1])) || (function (c, e, a, n) {
      if (null == e || function (c, e, a, n) {
        if (null !== a && 0 === a.type) return !1;

        switch (typeof e) {
          case "function":
          case "symbol":
            return !0;

          case "boolean":
            return !n && (null !== a ? !a.acceptsBooleans : "data-" !== (c = c.toLowerCase().slice(0, 5)) && "aria-" !== c);

          default:
            return !1;
        }
      }(c, e, a, n)) return !0;
      if (n) return !1;
      if (null !== a) switch (a.type) {
        case 3:
          return !e;

        case 4:
          return !1 === e;

        case 5:
          return isNaN(e);

        case 6:
          return isNaN(e) || 1 > e;
      }
      return !1;
    }(e, a, t, n) && (a = null), n || null === t ? function (c) {
      return !!R.call(P, c) || !R.call(Y, c) && (B.test(c) ? P[c] = !0 : (Y[c] = !0, !1));
    }(e) && (null === a ? c.removeAttribute(e) : c.setAttribute(e, "" + a)) : t.mustUseProperty ? c[t.propertyName] = null === a ? 3 !== t.type && "" : a : (e = t.attributeName, n = t.attributeNamespace, null === a ? c.removeAttribute(e) : (a = 3 === (t = t.type) || 4 === t && !0 === a ? "" : "" + a, n ? c.setAttributeNS(n, e, a) : c.setAttribute(e, a))));
  }

  J.hasOwnProperty("ReactCurrentDispatcher") || (J.ReactCurrentDispatcher = {
    current: null
  }), J.hasOwnProperty("ReactCurrentBatchConfig") || (J.ReactCurrentBatchConfig = {
    suspense: null
  });

  var X = /^(.*)[\\\/]/,
      _ = "function" == typeof Symbol && Symbol.for,
      $ = _ ? Symbol.for("react.element") : 60103,
      cc = _ ? Symbol.for("react.portal") : 60106,
      ec = _ ? Symbol.for("react.fragment") : 60107,
      ac = _ ? Symbol.for("react.strict_mode") : 60108,
      nc = _ ? Symbol.for("react.profiler") : 60114,
      tc = _ ? Symbol.for("react.provider") : 60109,
      rc = _ ? Symbol.for("react.context") : 60110,
      ic = _ ? Symbol.for("react.concurrent_mode") : 60111,
      oc = _ ? Symbol.for("react.forward_ref") : 60112,
      lc = _ ? Symbol.for("react.suspense") : 60113,
      fc = _ ? Symbol.for("react.suspense_list") : 60120,
      sc = _ ? Symbol.for("react.memo") : 60115,
      uc = _ ? Symbol.for("react.lazy") : 60116,
      hc = _ ? Symbol.for("react.block") : 60121,
      mc = "function" == typeof Symbol && Symbol.iterator;

  function vc(c) {
    return null === c || "object" != typeof c ? null : "function" == typeof (c = mc && c[mc] || c["@@iterator"]) ? c : null;
  }

  function dc(c) {
    if (null == c) return null;
    if ("function" == typeof c) return c.displayName || c.name || null;
    if ("string" == typeof c) return c;

    switch (c) {
      case ec:
        return "Fragment";

      case cc:
        return "Portal";

      case nc:
        return "Profiler";

      case ac:
        return "StrictMode";

      case lc:
        return "Suspense";

      case fc:
        return "SuspenseList";
    }

    if ("object" == typeof c) switch (c.$$typeof) {
      case rc:
        return "Context.Consumer";

      case tc:
        return "Context.Provider";

      case oc:
        var e = c.render;
        return e = e.displayName || e.name || "", c.displayName || ("" !== e ? "ForwardRef(" + e + ")" : "ForwardRef");

      case sc:
        return dc(c.type);

      case hc:
        return dc(c.render);

      case uc:
        if (c = 1 === c._status ? c._result : null) return dc(c);
    }
    return null;
  }

  function Mc(c) {
    var e = "";

    do {
      c: switch (c.tag) {
        case 3:
        case 4:
        case 6:
        case 7:
        case 10:
        case 9:
          var a = "";
          break c;

        default:
          var n = c._debugOwner,
              t = c._debugSource,
              r = dc(c.type);
          a = null, n && (a = dc(n.type)), n = r, r = "", t ? r = " (at " + t.fileName.replace(X, "") + ":" + t.lineNumber + ")" : a && (r = " (created by " + a + ")"), a = "\n    in " + (n || "Unknown") + r;
      }

      e += a, c = c.return;
    } while (c);

    return e;
  }

  function pc(c) {
    switch (typeof c) {
      case "boolean":
      case "number":
      case "object":
      case "string":
      case "undefined":
        return c;

      default:
        return "";
    }
  }

  function zc(c) {
    var e = c.type;
    return (c = c.nodeName) && "input" === c.toLowerCase() && ("checkbox" === e || "radio" === e);
  }

  function Cc(c) {
    c._valueTracker || (c._valueTracker = function (c) {
      var e = zc(c) ? "checked" : "value",
          a = Object.getOwnPropertyDescriptor(c.constructor.prototype, e),
          n = "" + c[e];

      if (!c.hasOwnProperty(e) && void 0 !== a && "function" == typeof a.get && "function" == typeof a.set) {
        var t = a.get,
            r = a.set;
        return Object.defineProperty(c, e, {
          configurable: !0,
          get: function get() {
            return t.call(this);
          },
          set: function set(c) {
            n = "" + c, r.call(this, c);
          }
        }), Object.defineProperty(c, e, {
          enumerable: a.enumerable
        }), {
          getValue: function getValue() {
            return n;
          },
          setValue: function setValue(c) {
            n = "" + c;
          },
          stopTracking: function stopTracking() {
            c._valueTracker = null, delete c[e];
          }
        };
      }
    }(c));
  }

  function Lc(c) {
    if (!c) return !1;
    var e = c._valueTracker;
    if (!e) return !0;
    var a = e.getValue(),
        n = "";
    return c && (n = zc(c) ? c.checked ? "true" : "false" : c.value), (c = n) !== a && (e.setValue(c), !0);
  }

  function Ac(c, e) {
    var a = e.checked;
    return t({}, e, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: null != a ? a : c._wrapperState.initialChecked
    });
  }

  function Nc(c, e) {
    var a = null == e.defaultValue ? "" : e.defaultValue,
        n = null != e.checked ? e.checked : e.defaultChecked;
    a = pc(null != e.value ? e.value : a), c._wrapperState = {
      initialChecked: n,
      initialValue: a,
      controlled: "checkbox" === e.type || "radio" === e.type ? null != e.checked : null != e.value
    };
  }

  function gc(c, e) {
    null != (e = e.checked) && K(c, "checked", e, !1);
  }

  function Hc(c, e) {
    gc(c, e);
    var a = pc(e.value),
        n = e.type;
    if (null != a) "number" === n ? (0 === a && "" === c.value || c.value != a) && (c.value = "" + a) : c.value !== "" + a && (c.value = "" + a);else if ("submit" === n || "reset" === n) return void c.removeAttribute("value");
    e.hasOwnProperty("value") ? xc(c, e.type, a) : e.hasOwnProperty("defaultValue") && xc(c, e.type, pc(e.defaultValue)), null == e.checked && null != e.defaultChecked && (c.defaultChecked = !!e.defaultChecked);
  }

  function Vc(c, e, a) {
    if (e.hasOwnProperty("value") || e.hasOwnProperty("defaultValue")) {
      var n = e.type;
      if (!("submit" !== n && "reset" !== n || void 0 !== e.value && null !== e.value)) return;
      e = "" + c._wrapperState.initialValue, a || e === c.value || (c.value = e), c.defaultValue = e;
    }

    "" !== (a = c.name) && (c.name = ""), c.defaultChecked = !!c._wrapperState.initialChecked, "" !== a && (c.name = a);
  }

  function xc(c, e, a) {
    "number" === e && c.ownerDocument.activeElement === c || (null == a ? c.defaultValue = "" + c._wrapperState.initialValue : c.defaultValue !== "" + a && (c.defaultValue = "" + a));
  }

  function wc(c, e) {
    return c = t({
      children: void 0
    }, e), (e = function (c) {
      var e = "";
      return n.Children.forEach(c, function (c) {
        null != c && (e += c);
      }), e;
    }(e.children)) && (c.children = e), c;
  }

  function yc(c, e, a, n) {
    if (c = c.options, e) {
      e = {};

      for (var t = 0; t < a.length; t++) {
        e["$" + a[t]] = !0;
      }

      for (a = 0; a < c.length; a++) {
        t = e.hasOwnProperty("$" + c[a].value), c[a].selected !== t && (c[a].selected = t), t && n && (c[a].defaultSelected = !0);
      }
    } else {
      for (a = "" + pc(a), e = null, t = 0; t < c.length; t++) {
        if (c[t].value === a) return c[t].selected = !0, void (n && (c[t].defaultSelected = !0));
        null !== e || c[t].disabled || (e = c[t]);
      }

      null !== e && (e.selected = !0);
    }
  }

  function bc(c, e) {
    if (null != e.dangerouslySetInnerHTML) throw Error(i(91));
    return t({}, e, {
      value: void 0,
      defaultValue: void 0,
      children: "" + c._wrapperState.initialValue
    });
  }

  function Sc(c, e) {
    var a = e.value;

    if (null == a) {
      if (a = e.children, e = e.defaultValue, null != a) {
        if (null != e) throw Error(i(92));

        if (Array.isArray(a)) {
          if (!(1 >= a.length)) throw Error(i(93));
          a = a[0];
        }

        e = a;
      }

      null == e && (e = ""), a = e;
    }

    c._wrapperState = {
      initialValue: pc(a)
    };
  }

  function Tc(c, e) {
    var a = pc(e.value),
        n = pc(e.defaultValue);
    null != a && ((a = "" + a) !== c.value && (c.value = a), null == e.defaultValue && c.defaultValue !== a && (c.defaultValue = a)), null != n && (c.defaultValue = "" + n);
  }

  function Dc(c) {
    var e = c.textContent;
    e === c._wrapperState.initialValue && "" !== e && null !== e && (c.value = e);
  }

  var jc = "http://www.w3.org/1999/xhtml",
      Ec = "http://www.w3.org/2000/svg";

  function kc(c) {
    switch (c) {
      case "svg":
        return "http://www.w3.org/2000/svg";

      case "math":
        return "http://www.w3.org/1998/Math/MathML";

      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }

  function Ic(c, e) {
    return null == c || "http://www.w3.org/1999/xhtml" === c ? kc(e) : "http://www.w3.org/2000/svg" === c && "foreignObject" === e ? "http://www.w3.org/1999/xhtml" : c;
  }

  var Oc,
      Qc,
      Zc = (Qc = function Qc(c, e) {
    if (c.namespaceURI !== Ec || "innerHTML" in c) c.innerHTML = e;else {
      for ((Oc = Oc || document.createElement("div")).innerHTML = "<svg>" + e.valueOf().toString() + "</svg>", e = Oc.firstChild; c.firstChild;) {
        c.removeChild(c.firstChild);
      }

      for (; e.firstChild;) {
        c.appendChild(e.firstChild);
      }
    }
  }, "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function (c, e, a, n) {
    MSApp.execUnsafeLocalFunction(function () {
      return Qc(c, e);
    });
  } : Qc);

  function Uc(c, e) {
    if (e) {
      var a = c.firstChild;
      if (a && a === c.lastChild && 3 === a.nodeType) return void (a.nodeValue = e);
    }

    c.textContent = e;
  }

  function Bc(c, e) {
    var a = {};
    return a[c.toLowerCase()] = e.toLowerCase(), a["Webkit" + c] = "webkit" + e, a["Moz" + c] = "moz" + e, a;
  }

  var Rc = {
    animationend: Bc("Animation", "AnimationEnd"),
    animationiteration: Bc("Animation", "AnimationIteration"),
    animationstart: Bc("Animation", "AnimationStart"),
    transitionend: Bc("Transition", "TransitionEnd")
  },
      Yc = {},
      Pc = {};

  function Fc(c) {
    if (Yc[c]) return Yc[c];
    if (!Rc[c]) return c;
    var e,
        a = Rc[c];

    for (e in a) {
      if (a.hasOwnProperty(e) && e in Pc) return Yc[c] = a[e];
    }

    return c;
  }

  x && (Pc = document.createElement("div").style, "AnimationEvent" in window || (delete Rc.animationend.animation, delete Rc.animationiteration.animation, delete Rc.animationstart.animation), "TransitionEvent" in window || delete Rc.transitionend.transition);
  var Wc = Fc("animationend"),
      Gc = Fc("animationiteration"),
      qc = Fc("animationstart"),
      Jc = Fc("transitionend"),
      Kc = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
      Xc = new ("function" == typeof WeakMap ? WeakMap : Map)();

  function _c(c) {
    var e = Xc.get(c);
    return void 0 === e && (e = new Map(), Xc.set(c, e)), e;
  }

  function $c(c) {
    var e = c,
        a = c;
    if (c.alternate) for (; e.return;) {
      e = e.return;
    } else {
      c = e;

      do {
        0 != (1026 & (e = c).effectTag) && (a = e.return), c = e.return;
      } while (c);
    }
    return 3 === e.tag ? a : null;
  }

  function ce(c) {
    if (13 === c.tag) {
      var e = c.memoizedState;
      if (null === e && null !== (c = c.alternate) && (e = c.memoizedState), null !== e) return e.dehydrated;
    }

    return null;
  }

  function ee(c) {
    if ($c(c) !== c) throw Error(i(188));
  }

  function ae(c) {
    if (!(c = function (c) {
      var e = c.alternate;

      if (!e) {
        if (null === (e = $c(c))) throw Error(i(188));
        return e !== c ? null : c;
      }

      for (var a = c, n = e;;) {
        var t = a.return;
        if (null === t) break;
        var r = t.alternate;

        if (null === r) {
          if (null !== (n = t.return)) {
            a = n;
            continue;
          }

          break;
        }

        if (t.child === r.child) {
          for (r = t.child; r;) {
            if (r === a) return ee(t), c;
            if (r === n) return ee(t), e;
            r = r.sibling;
          }

          throw Error(i(188));
        }

        if (a.return !== n.return) a = t, n = r;else {
          for (var o = !1, l = t.child; l;) {
            if (l === a) {
              o = !0, a = t, n = r;
              break;
            }

            if (l === n) {
              o = !0, n = t, a = r;
              break;
            }

            l = l.sibling;
          }

          if (!o) {
            for (l = r.child; l;) {
              if (l === a) {
                o = !0, a = r, n = t;
                break;
              }

              if (l === n) {
                o = !0, n = r, a = t;
                break;
              }

              l = l.sibling;
            }

            if (!o) throw Error(i(189));
          }
        }
        if (a.alternate !== n) throw Error(i(190));
      }

      if (3 !== a.tag) throw Error(i(188));
      return a.stateNode.current === a ? c : e;
    }(c))) return null;

    for (var e = c;;) {
      if (5 === e.tag || 6 === e.tag) return e;
      if (e.child) e.child.return = e, e = e.child;else {
        if (e === c) break;

        for (; !e.sibling;) {
          if (!e.return || e.return === c) return null;
          e = e.return;
        }

        e.sibling.return = e.return, e = e.sibling;
      }
    }

    return null;
  }

  function ne(c, e) {
    if (null == e) throw Error(i(30));
    return null == c ? e : Array.isArray(c) ? Array.isArray(e) ? (c.push.apply(c, e), c) : (c.push(e), c) : Array.isArray(e) ? [c].concat(e) : [c, e];
  }

  function te(c, e, a) {
    Array.isArray(c) ? c.forEach(e, a) : c && e.call(a, c);
  }

  var re = null;

  function ie(c) {
    if (c) {
      var e = c._dispatchListeners,
          a = c._dispatchInstances;
      if (Array.isArray(e)) for (var n = 0; n < e.length && !c.isPropagationStopped(); n++) {
        M(c, e[n], a[n]);
      } else e && M(c, e, a);
      c._dispatchListeners = null, c._dispatchInstances = null, c.isPersistent() || c.constructor.release(c);
    }
  }

  function oe(c) {
    if (null !== c && (re = ne(re, c)), c = re, re = null, c) {
      if (te(c, ie), re) throw Error(i(95));
      if (f) throw c = s, f = !1, s = null, c;
    }
  }

  function le(c) {
    return (c = c.target || c.srcElement || window).correspondingUseElement && (c = c.correspondingUseElement), 3 === c.nodeType ? c.parentNode : c;
  }

  function fe(c) {
    if (!x) return !1;
    var e = (c = "on" + c) in document;
    return e || ((e = document.createElement("div")).setAttribute(c, "return;"), e = "function" == typeof e[c]), e;
  }

  var se = [];

  function ue(c) {
    c.topLevelType = null, c.nativeEvent = null, c.targetInst = null, c.ancestors.length = 0, 10 > se.length && se.push(c);
  }

  function he(c, e, a, n) {
    if (se.length) {
      var t = se.pop();
      return t.topLevelType = c, t.eventSystemFlags = n, t.nativeEvent = e, t.targetInst = a, t;
    }

    return {
      topLevelType: c,
      eventSystemFlags: n,
      nativeEvent: e,
      targetInst: a,
      ancestors: []
    };
  }

  function me(c) {
    var e = c.targetInst,
        a = e;

    do {
      if (!a) {
        c.ancestors.push(a);
        break;
      }

      var n = a;
      if (3 === n.tag) n = n.stateNode.containerInfo;else {
        for (; n.return;) {
          n = n.return;
        }

        n = 3 !== n.tag ? null : n.stateNode.containerInfo;
      }
      if (!n) break;
      5 !== (e = a.tag) && 6 !== e || c.ancestors.push(a), a = ya(n);
    } while (a);

    for (a = 0; a < c.ancestors.length; a++) {
      e = c.ancestors[a];
      var t = le(c.nativeEvent);
      n = c.topLevelType;
      var r = c.nativeEvent,
          i = c.eventSystemFlags;
      0 === a && (i |= 64);

      for (var o = null, l = 0; l < A.length; l++) {
        var f = A[l];
        f && (f = f.extractEvents(n, e, r, t, i)) && (o = ne(o, f));
      }

      oe(o);
    }
  }

  function ve(c, e, a) {
    if (!a.has(c)) {
      switch (c) {
        case "scroll":
          qe(e, "scroll", !0);
          break;

        case "focus":
        case "blur":
          qe(e, "focus", !0), qe(e, "blur", !0), a.set("blur", null), a.set("focus", null);
          break;

        case "cancel":
        case "close":
          fe(c) && qe(e, c, !0);
          break;

        case "invalid":
        case "submit":
        case "reset":
          break;

        default:
          -1 === Kc.indexOf(c) && Ge(c, e);
      }

      a.set(c, null);
    }
  }

  var de,
      Me,
      pe,
      ze = !1,
      Ce = [],
      Le = null,
      Ae = null,
      Ne = null,
      ge = new Map(),
      He = new Map(),
      Ve = [],
      xe = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),
      we = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");

  function ye(c, e, a, n, t) {
    return {
      blockedOn: c,
      topLevelType: e,
      eventSystemFlags: 32 | a,
      nativeEvent: t,
      container: n
    };
  }

  function be(c, e) {
    switch (c) {
      case "focus":
      case "blur":
        Le = null;
        break;

      case "dragenter":
      case "dragleave":
        Ae = null;
        break;

      case "mouseover":
      case "mouseout":
        Ne = null;
        break;

      case "pointerover":
      case "pointerout":
        ge.delete(e.pointerId);
        break;

      case "gotpointercapture":
      case "lostpointercapture":
        He.delete(e.pointerId);
    }
  }

  function Se(c, e, a, n, t, r) {
    return null === c || c.nativeEvent !== r ? (c = ye(e, a, n, t, r), null !== e && null !== (e = ba(e)) && Me(e), c) : (c.eventSystemFlags |= n, c);
  }

  function Te(c) {
    var e = ya(c.target);

    if (null !== e) {
      var a = $c(e);
      if (null !== a) if (13 === (e = a.tag)) {
        if (null !== (e = ce(a))) return c.blockedOn = e, void r.unstable_runWithPriority(c.priority, function () {
          pe(a);
        });
      } else if (3 === e && a.stateNode.hydrate) return void (c.blockedOn = 3 === a.tag ? a.stateNode.containerInfo : null);
    }

    c.blockedOn = null;
  }

  function De(c) {
    if (null !== c.blockedOn) return !1;
    var e = Ke(c.topLevelType, c.eventSystemFlags, c.container, c.nativeEvent);

    if (null !== e) {
      var a = ba(e);
      return null !== a && Me(a), c.blockedOn = e, !1;
    }

    return !0;
  }

  function je(c, e, a) {
    De(c) && a.delete(e);
  }

  function Ee() {
    for (ze = !1; 0 < Ce.length;) {
      var c = Ce[0];

      if (null !== c.blockedOn) {
        null !== (c = ba(c.blockedOn)) && de(c);
        break;
      }

      var e = Ke(c.topLevelType, c.eventSystemFlags, c.container, c.nativeEvent);
      null !== e ? c.blockedOn = e : Ce.shift();
    }

    null !== Le && De(Le) && (Le = null), null !== Ae && De(Ae) && (Ae = null), null !== Ne && De(Ne) && (Ne = null), ge.forEach(je), He.forEach(je);
  }

  function ke(c, e) {
    c.blockedOn === e && (c.blockedOn = null, ze || (ze = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Ee)));
  }

  function Ie(c) {
    function e(e) {
      return ke(e, c);
    }

    if (0 < Ce.length) {
      ke(Ce[0], c);

      for (var a = 1; a < Ce.length; a++) {
        var n = Ce[a];
        n.blockedOn === c && (n.blockedOn = null);
      }
    }

    for (null !== Le && ke(Le, c), null !== Ae && ke(Ae, c), null !== Ne && ke(Ne, c), ge.forEach(e), He.forEach(e), a = 0; a < Ve.length; a++) {
      (n = Ve[a]).blockedOn === c && (n.blockedOn = null);
    }

    for (; 0 < Ve.length && null === (a = Ve[0]).blockedOn;) {
      Te(a), null === a.blockedOn && Ve.shift();
    }
  }

  var Oe = {},
      Qe = new Map(),
      Ze = new Map(),
      Ue = ["abort", "abort", Wc, "animationEnd", Gc, "animationIteration", qc, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", Jc, "transitionEnd", "waiting", "waiting"];

  function Be(c, e) {
    for (var a = 0; a < c.length; a += 2) {
      var n = c[a],
          t = c[a + 1],
          r = "on" + (t[0].toUpperCase() + t.slice(1));
      r = {
        phasedRegistrationNames: {
          bubbled: r,
          captured: r + "Capture"
        },
        dependencies: [n],
        eventPriority: e
      }, Ze.set(n, e), Qe.set(n, r), Oe[t] = r;
    }
  }

  Be("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), Be("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), Be(Ue, 2);

  for (var Re = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Ye = 0; Ye < Re.length; Ye++) {
    Ze.set(Re[Ye], 0);
  }

  var Pe = r.unstable_UserBlockingPriority,
      Fe = r.unstable_runWithPriority,
      We = !0;

  function Ge(c, e) {
    qe(e, c, !1);
  }

  function qe(c, e, a) {
    var n = Ze.get(e);

    switch (void 0 === n ? 2 : n) {
      case 0:
        n = function (c, e, a, n) {
          O || k();
          var t = Je,
              r = O;
          O = !0;

          try {
            E(t, c, e, a, n);
          } finally {
            (O = r) || Z();
          }
        }.bind(null, e, 1, c);

        break;

      case 1:
        n = function (c, e, a, n) {
          Fe(Pe, Je.bind(null, c, e, a, n));
        }.bind(null, e, 1, c);

        break;

      default:
        n = Je.bind(null, e, 1, c);
    }

    a ? c.addEventListener(e, n, !0) : c.addEventListener(e, n, !1);
  }

  function Je(c, e, a, n) {
    if (We) if (0 < Ce.length && -1 < xe.indexOf(c)) c = ye(null, c, e, a, n), Ce.push(c);else {
      var t = Ke(c, e, a, n);
      if (null === t) be(c, n);else if (-1 < xe.indexOf(c)) c = ye(t, c, e, a, n), Ce.push(c);else if (!function (c, e, a, n, t) {
        switch (e) {
          case "focus":
            return Le = Se(Le, c, e, a, n, t), !0;

          case "dragenter":
            return Ae = Se(Ae, c, e, a, n, t), !0;

          case "mouseover":
            return Ne = Se(Ne, c, e, a, n, t), !0;

          case "pointerover":
            var r = t.pointerId;
            return ge.set(r, Se(ge.get(r) || null, c, e, a, n, t)), !0;

          case "gotpointercapture":
            return r = t.pointerId, He.set(r, Se(He.get(r) || null, c, e, a, n, t)), !0;
        }

        return !1;
      }(t, c, e, a, n)) {
        be(c, n), c = he(c, n, null, e);

        try {
          U(me, c);
        } finally {
          ue(c);
        }
      }
    }
  }

  function Ke(c, e, a, n) {
    if (null !== (a = ya(a = le(n)))) {
      var t = $c(a);
      if (null === t) a = null;else {
        var r = t.tag;

        if (13 === r) {
          if (null !== (a = ce(t))) return a;
          a = null;
        } else if (3 === r) {
          if (t.stateNode.hydrate) return 3 === t.tag ? t.stateNode.containerInfo : null;
          a = null;
        } else t !== a && (a = null);
      }
    }

    c = he(c, n, a, e);

    try {
      U(me, c);
    } finally {
      ue(c);
    }

    return null;
  }

  var Xe = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
      _e = ["Webkit", "ms", "Moz", "O"];

  function $e(c, e, a) {
    return null == e || "boolean" == typeof e || "" === e ? "" : a || "number" != typeof e || 0 === e || Xe.hasOwnProperty(c) && Xe[c] ? ("" + e).trim() : e + "px";
  }

  function ca(c, e) {
    for (var a in c = c.style, e) {
      if (e.hasOwnProperty(a)) {
        var n = 0 === a.indexOf("--"),
            t = $e(a, e[a], n);
        "float" === a && (a = "cssFloat"), n ? c.setProperty(a, t) : c[a] = t;
      }
    }
  }

  Object.keys(Xe).forEach(function (c) {
    _e.forEach(function (e) {
      e = e + c.charAt(0).toUpperCase() + c.substring(1), Xe[e] = Xe[c];
    });
  });
  var ea = t({
    menuitem: !0
  }, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  });

  function aa(c, e) {
    if (e) {
      if (ea[c] && (null != e.children || null != e.dangerouslySetInnerHTML)) throw Error(i(137, c, ""));

      if (null != e.dangerouslySetInnerHTML) {
        if (null != e.children) throw Error(i(60));
        if (!("object" == typeof e.dangerouslySetInnerHTML && "__html" in e.dangerouslySetInnerHTML)) throw Error(i(61));
      }

      if (null != e.style && "object" != typeof e.style) throw Error(i(62, ""));
    }
  }

  function na(c, e) {
    if (-1 === c.indexOf("-")) return "string" == typeof e.is;

    switch (c) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;

      default:
        return !0;
    }
  }

  var ta = jc;

  function ra(c, e) {
    var a = _c(c = 9 === c.nodeType || 11 === c.nodeType ? c : c.ownerDocument);

    e = H[e];

    for (var n = 0; n < e.length; n++) {
      ve(e[n], c, a);
    }
  }

  function ia() {}

  function oa(c) {
    if (void 0 === (c = c || ("undefined" != typeof document ? document : void 0))) return null;

    try {
      return c.activeElement || c.body;
    } catch (e) {
      return c.body;
    }
  }

  function la(c) {
    for (; c && c.firstChild;) {
      c = c.firstChild;
    }

    return c;
  }

  function fa(c, e) {
    var a,
        n = la(c);

    for (c = 0; n;) {
      if (3 === n.nodeType) {
        if (a = c + n.textContent.length, c <= e && a >= e) return {
          node: n,
          offset: e - c
        };
        c = a;
      }

      c: {
        for (; n;) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break c;
          }

          n = n.parentNode;
        }

        n = void 0;
      }

      n = la(n);
    }
  }

  function sa() {
    for (var c = window, e = oa(); e instanceof c.HTMLIFrameElement;) {
      try {
        var a = "string" == typeof e.contentWindow.location.href;
      } catch (c) {
        a = !1;
      }

      if (!a) break;
      e = oa((c = e.contentWindow).document);
    }

    return e;
  }

  function ua(c) {
    var e = c && c.nodeName && c.nodeName.toLowerCase();
    return e && ("input" === e && ("text" === c.type || "search" === c.type || "tel" === c.type || "url" === c.type || "password" === c.type) || "textarea" === e || "true" === c.contentEditable);
  }

  var ha = "$",
      ma = "/$",
      va = "$?",
      da = "$!",
      Ma = null,
      pa = null;

  function za(c, e) {
    switch (c) {
      case "button":
      case "input":
      case "select":
      case "textarea":
        return !!e.autoFocus;
    }

    return !1;
  }

  function Ca(c, e) {
    return "textarea" === c || "option" === c || "noscript" === c || "string" == typeof e.children || "number" == typeof e.children || "object" == typeof e.dangerouslySetInnerHTML && null !== e.dangerouslySetInnerHTML && null != e.dangerouslySetInnerHTML.__html;
  }

  var La = "function" == typeof setTimeout ? setTimeout : void 0,
      Aa = "function" == typeof clearTimeout ? clearTimeout : void 0;

  function Na(c) {
    for (; null != c; c = c.nextSibling) {
      var e = c.nodeType;
      if (1 === e || 3 === e) break;
    }

    return c;
  }

  function ga(c) {
    c = c.previousSibling;

    for (var e = 0; c;) {
      if (8 === c.nodeType) {
        var a = c.data;

        if (a === ha || a === da || a === va) {
          if (0 === e) return c;
          e--;
        } else a === ma && e++;
      }

      c = c.previousSibling;
    }

    return null;
  }

  var Ha = Math.random().toString(36).slice(2),
      Va = "__reactInternalInstance$" + Ha,
      xa = "__reactEventHandlers$" + Ha,
      wa = "__reactContainere$" + Ha;

  function ya(c) {
    var e = c[Va];
    if (e) return e;

    for (var a = c.parentNode; a;) {
      if (e = a[wa] || a[Va]) {
        if (a = e.alternate, null !== e.child || null !== a && null !== a.child) for (c = ga(c); null !== c;) {
          if (a = c[Va]) return a;
          c = ga(c);
        }
        return e;
      }

      a = (c = a).parentNode;
    }

    return null;
  }

  function ba(c) {
    return !(c = c[Va] || c[wa]) || 5 !== c.tag && 6 !== c.tag && 13 !== c.tag && 3 !== c.tag ? null : c;
  }

  function Sa(c) {
    if (5 === c.tag || 6 === c.tag) return c.stateNode;
    throw Error(i(33));
  }

  function Ta(c) {
    return c[xa] || null;
  }

  function Da(c) {
    do {
      c = c.return;
    } while (c && 5 !== c.tag);

    return c || null;
  }

  function ja(c, e) {
    var a = c.stateNode;
    if (!a) return null;
    var n = m(a);
    if (!n) return null;
    a = n[e];

    c: switch (e) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (n = !n.disabled) || (n = !("button" === (c = c.type) || "input" === c || "select" === c || "textarea" === c)), c = !n;
        break c;

      default:
        c = !1;
    }

    if (c) return null;
    if (a && "function" != typeof a) throw Error(i(231, e, typeof a));
    return a;
  }

  function Ea(c, e, a) {
    (e = ja(c, a.dispatchConfig.phasedRegistrationNames[e])) && (a._dispatchListeners = ne(a._dispatchListeners, e), a._dispatchInstances = ne(a._dispatchInstances, c));
  }

  function ka(c) {
    if (c && c.dispatchConfig.phasedRegistrationNames) {
      for (var e = c._targetInst, a = []; e;) {
        a.push(e), e = Da(e);
      }

      for (e = a.length; 0 < e--;) {
        Ea(a[e], "captured", c);
      }

      for (e = 0; e < a.length; e++) {
        Ea(a[e], "bubbled", c);
      }
    }
  }

  function Ia(c, e, a) {
    c && a && a.dispatchConfig.registrationName && (e = ja(c, a.dispatchConfig.registrationName)) && (a._dispatchListeners = ne(a._dispatchListeners, e), a._dispatchInstances = ne(a._dispatchInstances, c));
  }

  function Oa(c) {
    c && c.dispatchConfig.registrationName && Ia(c._targetInst, null, c);
  }

  function Qa(c) {
    te(c, ka);
  }

  var Za = null,
      Ua = null,
      Ba = null;

  function Ra() {
    if (Ba) return Ba;
    var c,
        e,
        a = Ua,
        n = a.length,
        t = "value" in Za ? Za.value : Za.textContent,
        r = t.length;

    for (c = 0; c < n && a[c] === t[c]; c++) {
      ;
    }

    var i = n - c;

    for (e = 1; e <= i && a[n - e] === t[r - e]; e++) {
      ;
    }

    return Ba = t.slice(c, 1 < e ? 1 - e : void 0);
  }

  function Ya() {
    return !0;
  }

  function Pa() {
    return !1;
  }

  function Fa(c, e, a, n) {
    for (var t in this.dispatchConfig = c, this._targetInst = e, this.nativeEvent = a, c = this.constructor.Interface) {
      c.hasOwnProperty(t) && ((e = c[t]) ? this[t] = e(a) : "target" === t ? this.target = n : this[t] = a[t]);
    }

    return this.isDefaultPrevented = (null != a.defaultPrevented ? a.defaultPrevented : !1 === a.returnValue) ? Ya : Pa, this.isPropagationStopped = Pa, this;
  }

  function Wa(c, e, a, n) {
    if (this.eventPool.length) {
      var t = this.eventPool.pop();
      return this.call(t, c, e, a, n), t;
    }

    return new this(c, e, a, n);
  }

  function Ga(c) {
    if (!(c instanceof this)) throw Error(i(279));
    c.destructor(), 10 > this.eventPool.length && this.eventPool.push(c);
  }

  function qa(c) {
    c.eventPool = [], c.getPooled = Wa, c.release = Ga;
  }

  t(Fa.prototype, {
    preventDefault: function preventDefault() {
      this.defaultPrevented = !0;
      var c = this.nativeEvent;
      c && (c.preventDefault ? c.preventDefault() : "unknown" != typeof c.returnValue && (c.returnValue = !1), this.isDefaultPrevented = Ya);
    },
    stopPropagation: function stopPropagation() {
      var c = this.nativeEvent;
      c && (c.stopPropagation ? c.stopPropagation() : "unknown" != typeof c.cancelBubble && (c.cancelBubble = !0), this.isPropagationStopped = Ya);
    },
    persist: function persist() {
      this.isPersistent = Ya;
    },
    isPersistent: Pa,
    destructor: function destructor() {
      var c,
          e = this.constructor.Interface;

      for (c in e) {
        this[c] = null;
      }

      this.nativeEvent = this._targetInst = this.dispatchConfig = null, this.isPropagationStopped = this.isDefaultPrevented = Pa, this._dispatchInstances = this._dispatchListeners = null;
    }
  }), Fa.Interface = {
    type: null,
    target: null,
    currentTarget: function currentTarget() {
      return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function timeStamp(c) {
      return c.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
  }, Fa.extend = function (c) {
    function e() {}

    function a() {
      return n.apply(this, arguments);
    }

    var n = this;
    e.prototype = n.prototype;
    var r = new e();
    return t(r, a.prototype), a.prototype = r, a.prototype.constructor = a, a.Interface = t({}, n.Interface, c), a.extend = n.extend, qa(a), a;
  }, qa(Fa);

  var Ja = Fa.extend({
    data: null
  }),
      Ka = Fa.extend({
    data: null
  }),
      Xa = [9, 13, 27, 32],
      _a = x && "CompositionEvent" in window,
      $a = null;

  x && "documentMode" in document && ($a = document.documentMode);
  var cn = x && "TextEvent" in window && !$a,
      en = x && (!_a || $a && 8 < $a && 11 >= $a),
      an = String.fromCharCode(32),
      nn = {
    beforeInput: {
      phasedRegistrationNames: {
        bubbled: "onBeforeInput",
        captured: "onBeforeInputCapture"
      },
      dependencies: ["compositionend", "keypress", "textInput", "paste"]
    },
    compositionEnd: {
      phasedRegistrationNames: {
        bubbled: "onCompositionEnd",
        captured: "onCompositionEndCapture"
      },
      dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
      phasedRegistrationNames: {
        bubbled: "onCompositionStart",
        captured: "onCompositionStartCapture"
      },
      dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
      phasedRegistrationNames: {
        bubbled: "onCompositionUpdate",
        captured: "onCompositionUpdateCapture"
      },
      dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
  },
      tn = !1;

  function rn(c, e) {
    switch (c) {
      case "keyup":
        return -1 !== Xa.indexOf(e.keyCode);

      case "keydown":
        return 229 !== e.keyCode;

      case "keypress":
      case "mousedown":
      case "blur":
        return !0;

      default:
        return !1;
    }
  }

  function on(c) {
    return "object" == typeof (c = c.detail) && "data" in c ? c.data : null;
  }

  var ln = !1;
  var fn = {
    eventTypes: nn,
    extractEvents: function extractEvents(c, e, a, n) {
      var t;
      if (_a) c: {
        switch (c) {
          case "compositionstart":
            var r = nn.compositionStart;
            break c;

          case "compositionend":
            r = nn.compositionEnd;
            break c;

          case "compositionupdate":
            r = nn.compositionUpdate;
            break c;
        }

        r = void 0;
      } else ln ? rn(c, a) && (r = nn.compositionEnd) : "keydown" === c && 229 === a.keyCode && (r = nn.compositionStart);
      return r ? (en && "ko" !== a.locale && (ln || r !== nn.compositionStart ? r === nn.compositionEnd && ln && (t = Ra()) : (Ua = "value" in (Za = n) ? Za.value : Za.textContent, ln = !0)), r = Ja.getPooled(r, e, a, n), t ? r.data = t : null !== (t = on(a)) && (r.data = t), Qa(r), t = r) : t = null, (c = cn ? function (c, e) {
        switch (c) {
          case "compositionend":
            return on(e);

          case "keypress":
            return 32 !== e.which ? null : (tn = !0, an);

          case "textInput":
            return (c = e.data) === an && tn ? null : c;

          default:
            return null;
        }
      }(c, a) : function (c, e) {
        if (ln) return "compositionend" === c || !_a && rn(c, e) ? (c = Ra(), Ba = Ua = Za = null, ln = !1, c) : null;

        switch (c) {
          case "paste":
            return null;

          case "keypress":
            if (!(e.ctrlKey || e.altKey || e.metaKey) || e.ctrlKey && e.altKey) {
              if (e.char && 1 < e.char.length) return e.char;
              if (e.which) return String.fromCharCode(e.which);
            }

            return null;

          case "compositionend":
            return en && "ko" !== e.locale ? null : e.data;

          default:
            return null;
        }
      }(c, a)) ? ((e = Ka.getPooled(nn.beforeInput, e, a, n)).data = c, Qa(e)) : e = null, null === t ? e : null === e ? t : [t, e];
    }
  },
      sn = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };

  function un(c) {
    var e = c && c.nodeName && c.nodeName.toLowerCase();
    return "input" === e ? !!sn[c.type] : "textarea" === e;
  }

  var hn = {
    change: {
      phasedRegistrationNames: {
        bubbled: "onChange",
        captured: "onChangeCapture"
      },
      dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
  };

  function mn(c, e, a) {
    return (c = Fa.getPooled(hn.change, c, e, a)).type = "change", T(a), Qa(c), c;
  }

  var vn = null,
      dn = null;

  function Mn(c) {
    oe(c);
  }

  function pn(c) {
    if (Lc(Sa(c))) return c;
  }

  function zn(c, e) {
    if ("change" === c) return e;
  }

  var Cn = !1;

  function Ln() {
    vn && (vn.detachEvent("onpropertychange", An), dn = vn = null);
  }

  function An(c) {
    if ("value" === c.propertyName && pn(dn)) if (c = mn(dn, c, le(c)), O) oe(c);else {
      O = !0;

      try {
        j(Mn, c);
      } finally {
        O = !1, Z();
      }
    }
  }

  function Nn(c, e, a) {
    "focus" === c ? (Ln(), dn = a, (vn = e).attachEvent("onpropertychange", An)) : "blur" === c && Ln();
  }

  function gn(c) {
    if ("selectionchange" === c || "keyup" === c || "keydown" === c) return pn(dn);
  }

  function Hn(c, e) {
    if ("click" === c) return pn(e);
  }

  function Vn(c, e) {
    if ("input" === c || "change" === c) return pn(e);
  }

  x && (Cn = fe("input") && (!document.documentMode || 9 < document.documentMode));
  var xn = {
    eventTypes: hn,
    _isInputEventSupported: Cn,
    extractEvents: function extractEvents(c, e, a, n) {
      var t = e ? Sa(e) : window,
          r = t.nodeName && t.nodeName.toLowerCase();
      if ("select" === r || "input" === r && "file" === t.type) var i = zn;else if (un(t)) {
        if (Cn) i = Vn;else {
          i = gn;
          var o = Nn;
        }
      } else (r = t.nodeName) && "input" === r.toLowerCase() && ("checkbox" === t.type || "radio" === t.type) && (i = Hn);
      if (i && (i = i(c, e))) return mn(i, a, n);
      o && o(c, t, e), "blur" === c && (c = t._wrapperState) && c.controlled && "number" === t.type && xc(t, "number", t.value);
    }
  },
      wn = Fa.extend({
    view: null,
    detail: null
  }),
      yn = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };

  function bn(c) {
    var e = this.nativeEvent;
    return e.getModifierState ? e.getModifierState(c) : !!(c = yn[c]) && !!e[c];
  }

  function Sn() {
    return bn;
  }

  var Tn = 0,
      Dn = 0,
      jn = !1,
      En = !1,
      kn = wn.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Sn,
    button: null,
    buttons: null,
    relatedTarget: function relatedTarget(c) {
      return c.relatedTarget || (c.fromElement === c.srcElement ? c.toElement : c.fromElement);
    },
    movementX: function movementX(c) {
      if ("movementX" in c) return c.movementX;
      var e = Tn;
      return Tn = c.screenX, jn ? "mousemove" === c.type ? c.screenX - e : 0 : (jn = !0, 0);
    },
    movementY: function movementY(c) {
      if ("movementY" in c) return c.movementY;
      var e = Dn;
      return Dn = c.screenY, En ? "mousemove" === c.type ? c.screenY - e : 0 : (En = !0, 0);
    }
  }),
      In = kn.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
  }),
      On = {
    mouseEnter: {
      registrationName: "onMouseEnter",
      dependencies: ["mouseout", "mouseover"]
    },
    mouseLeave: {
      registrationName: "onMouseLeave",
      dependencies: ["mouseout", "mouseover"]
    },
    pointerEnter: {
      registrationName: "onPointerEnter",
      dependencies: ["pointerout", "pointerover"]
    },
    pointerLeave: {
      registrationName: "onPointerLeave",
      dependencies: ["pointerout", "pointerover"]
    }
  },
      Qn = {
    eventTypes: On,
    extractEvents: function extractEvents(c, e, a, n, t) {
      var r = "mouseover" === c || "pointerover" === c,
          i = "mouseout" === c || "pointerout" === c;
      if (r && 0 == (32 & t) && (a.relatedTarget || a.fromElement) || !i && !r) return null;
      (r = n.window === n ? n : (r = n.ownerDocument) ? r.defaultView || r.parentWindow : window, i) ? (i = e, null !== (e = (e = a.relatedTarget || a.toElement) ? ya(e) : null) && (e !== $c(e) || 5 !== e.tag && 6 !== e.tag) && (e = null)) : i = null;
      if (i === e) return null;
      if ("mouseout" === c || "mouseover" === c) var o = kn,
          l = On.mouseLeave,
          f = On.mouseEnter,
          s = "mouse";else "pointerout" !== c && "pointerover" !== c || (o = In, l = On.pointerLeave, f = On.pointerEnter, s = "pointer");
      if (c = null == i ? r : Sa(i), r = null == e ? r : Sa(e), (l = o.getPooled(l, i, a, n)).type = s + "leave", l.target = c, l.relatedTarget = r, (a = o.getPooled(f, e, a, n)).type = s + "enter", a.target = r, a.relatedTarget = c, s = e, (n = i) && s) c: {
        for (f = s, i = 0, c = o = n; c; c = Da(c)) {
          i++;
        }

        for (c = 0, e = f; e; e = Da(e)) {
          c++;
        }

        for (; 0 < i - c;) {
          o = Da(o), i--;
        }

        for (; 0 < c - i;) {
          f = Da(f), c--;
        }

        for (; i--;) {
          if (o === f || o === f.alternate) break c;
          o = Da(o), f = Da(f);
        }

        o = null;
      } else o = null;

      for (f = o, o = []; n && n !== f && (null === (i = n.alternate) || i !== f);) {
        o.push(n), n = Da(n);
      }

      for (n = []; s && s !== f && (null === (i = s.alternate) || i !== f);) {
        n.push(s), s = Da(s);
      }

      for (s = 0; s < o.length; s++) {
        Ia(o[s], "bubbled", l);
      }

      for (s = n.length; 0 < s--;) {
        Ia(n[s], "captured", a);
      }

      return 0 == (64 & t) ? [l] : [l, a];
    }
  };
  var Zn = "function" == typeof Object.is ? Object.is : function (c, e) {
    return c === e && (0 !== c || 1 / c == 1 / e) || c != c && e != e;
  },
      Un = Object.prototype.hasOwnProperty;

  function Bn(c, e) {
    if (Zn(c, e)) return !0;
    if ("object" != typeof c || null === c || "object" != typeof e || null === e) return !1;
    var a = Object.keys(c),
        n = Object.keys(e);
    if (a.length !== n.length) return !1;

    for (n = 0; n < a.length; n++) {
      if (!Un.call(e, a[n]) || !Zn(c[a[n]], e[a[n]])) return !1;
    }

    return !0;
  }

  var Rn = x && "documentMode" in document && 11 >= document.documentMode,
      Yn = {
    select: {
      phasedRegistrationNames: {
        bubbled: "onSelect",
        captured: "onSelectCapture"
      },
      dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
  },
      Pn = null,
      Fn = null,
      Wn = null,
      Gn = !1;

  function qn(c, e) {
    var a = e.window === e ? e.document : 9 === e.nodeType ? e : e.ownerDocument;
    return Gn || null == Pn || Pn !== oa(a) ? null : ("selectionStart" in (a = Pn) && ua(a) ? a = {
      start: a.selectionStart,
      end: a.selectionEnd
    } : a = {
      anchorNode: (a = (a.ownerDocument && a.ownerDocument.defaultView || window).getSelection()).anchorNode,
      anchorOffset: a.anchorOffset,
      focusNode: a.focusNode,
      focusOffset: a.focusOffset
    }, Wn && Bn(Wn, a) ? null : (Wn = a, (c = Fa.getPooled(Yn.select, Fn, c, e)).type = "select", c.target = Pn, Qa(c), c));
  }

  var Jn = {
    eventTypes: Yn,
    extractEvents: function extractEvents(c, e, a, n, t, r) {
      if (!(r = !(t = r || (n.window === n ? n.document : 9 === n.nodeType ? n : n.ownerDocument)))) {
        c: {
          t = _c(t), r = H.onSelect;

          for (var i = 0; i < r.length; i++) {
            if (!t.has(r[i])) {
              t = !1;
              break c;
            }
          }

          t = !0;
        }

        r = !t;
      }

      if (r) return null;

      switch (t = e ? Sa(e) : window, c) {
        case "focus":
          (un(t) || "true" === t.contentEditable) && (Pn = t, Fn = e, Wn = null);
          break;

        case "blur":
          Wn = Fn = Pn = null;
          break;

        case "mousedown":
          Gn = !0;
          break;

        case "contextmenu":
        case "mouseup":
        case "dragend":
          return Gn = !1, qn(a, n);

        case "selectionchange":
          if (Rn) break;

        case "keydown":
        case "keyup":
          return qn(a, n);
      }

      return null;
    }
  },
      Kn = Fa.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
  }),
      Xn = Fa.extend({
    clipboardData: function clipboardData(c) {
      return "clipboardData" in c ? c.clipboardData : window.clipboardData;
    }
  }),
      _n = wn.extend({
    relatedTarget: null
  });

  function $n(c) {
    var e = c.keyCode;
    return "charCode" in c ? 0 === (c = c.charCode) && 13 === e && (c = 13) : c = e, 10 === c && (c = 13), 32 <= c || 13 === c ? c : 0;
  }

  var ct = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  },
      et = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  },
      at = wn.extend({
    key: function key(c) {
      if (c.key) {
        var e = ct[c.key] || c.key;
        if ("Unidentified" !== e) return e;
      }

      return "keypress" === c.type ? 13 === (c = $n(c)) ? "Enter" : String.fromCharCode(c) : "keydown" === c.type || "keyup" === c.type ? et[c.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Sn,
    charCode: function charCode(c) {
      return "keypress" === c.type ? $n(c) : 0;
    },
    keyCode: function keyCode(c) {
      return "keydown" === c.type || "keyup" === c.type ? c.keyCode : 0;
    },
    which: function which(c) {
      return "keypress" === c.type ? $n(c) : "keydown" === c.type || "keyup" === c.type ? c.keyCode : 0;
    }
  }),
      nt = kn.extend({
    dataTransfer: null
  }),
      tt = wn.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Sn
  }),
      rt = Fa.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
  }),
      it = kn.extend({
    deltaX: function deltaX(c) {
      return "deltaX" in c ? c.deltaX : "wheelDeltaX" in c ? -c.wheelDeltaX : 0;
    },
    deltaY: function deltaY(c) {
      return "deltaY" in c ? c.deltaY : "wheelDeltaY" in c ? -c.wheelDeltaY : "wheelDelta" in c ? -c.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
  }),
      ot = {
    eventTypes: Oe,
    extractEvents: function extractEvents(c, e, a, n) {
      var t = Qe.get(c);
      if (!t) return null;

      switch (c) {
        case "keypress":
          if (0 === $n(a)) return null;

        case "keydown":
        case "keyup":
          c = at;
          break;

        case "blur":
        case "focus":
          c = _n;
          break;

        case "click":
          if (2 === a.button) return null;

        case "auxclick":
        case "dblclick":
        case "mousedown":
        case "mousemove":
        case "mouseup":
        case "mouseout":
        case "mouseover":
        case "contextmenu":
          c = kn;
          break;

        case "drag":
        case "dragend":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "dragstart":
        case "drop":
          c = nt;
          break;

        case "touchcancel":
        case "touchend":
        case "touchmove":
        case "touchstart":
          c = tt;
          break;

        case Wc:
        case Gc:
        case qc:
          c = Kn;
          break;

        case Jc:
          c = rt;
          break;

        case "scroll":
          c = wn;
          break;

        case "wheel":
          c = it;
          break;

        case "copy":
        case "cut":
        case "paste":
          c = Xn;
          break;

        case "gotpointercapture":
        case "lostpointercapture":
        case "pointercancel":
        case "pointerdown":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "pointerup":
          c = In;
          break;

        default:
          c = Fa;
      }

      return Qa(e = c.getPooled(t, e, a, n)), e;
    }
  };
  if (p) throw Error(i(101));
  p = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")), C(), m = Ta, v = ba, d = Sa, V({
    SimpleEventPlugin: ot,
    EnterLeaveEventPlugin: Qn,
    ChangeEventPlugin: xn,
    SelectEventPlugin: Jn,
    BeforeInputEventPlugin: fn
  });
  var lt = [],
      ft = -1;

  function st(c) {
    0 > ft || (c.current = lt[ft], lt[ft] = null, ft--);
  }

  function ut(c, e) {
    lt[++ft] = c.current, c.current = e;
  }

  var ht = {},
      mt = {
    current: ht
  },
      vt = {
    current: !1
  },
      dt = ht;

  function Mt(c, e) {
    var a = c.type.contextTypes;
    if (!a) return ht;
    var n = c.stateNode;
    if (n && n.__reactInternalMemoizedUnmaskedChildContext === e) return n.__reactInternalMemoizedMaskedChildContext;
    var t,
        r = {};

    for (t in a) {
      r[t] = e[t];
    }

    return n && ((c = c.stateNode).__reactInternalMemoizedUnmaskedChildContext = e, c.__reactInternalMemoizedMaskedChildContext = r), r;
  }

  function pt(c) {
    return null != (c = c.childContextTypes);
  }

  function zt() {
    st(vt), st(mt);
  }

  function Ct(c, e, a) {
    if (mt.current !== ht) throw Error(i(168));
    ut(mt, e), ut(vt, a);
  }

  function Lt(c, e, a) {
    var n = c.stateNode;
    if (c = e.childContextTypes, "function" != typeof n.getChildContext) return a;

    for (var r in n = n.getChildContext()) {
      if (!(r in c)) throw Error(i(108, dc(e) || "Unknown", r));
    }

    return t({}, a, {}, n);
  }

  function At(c) {
    return c = (c = c.stateNode) && c.__reactInternalMemoizedMergedChildContext || ht, dt = mt.current, ut(mt, c), ut(vt, vt.current), !0;
  }

  function Nt(c, e, a) {
    var n = c.stateNode;
    if (!n) throw Error(i(169));
    a ? (c = Lt(c, e, dt), n.__reactInternalMemoizedMergedChildContext = c, st(vt), st(mt), ut(mt, c)) : st(vt), ut(vt, a);
  }

  var gt = r.unstable_runWithPriority,
      Ht = r.unstable_scheduleCallback,
      Vt = r.unstable_cancelCallback,
      xt = r.unstable_requestPaint,
      wt = r.unstable_now,
      yt = r.unstable_getCurrentPriorityLevel,
      bt = r.unstable_ImmediatePriority,
      St = r.unstable_UserBlockingPriority,
      Tt = r.unstable_NormalPriority,
      Dt = r.unstable_LowPriority,
      jt = r.unstable_IdlePriority,
      Et = {},
      kt = r.unstable_shouldYield,
      It = void 0 !== xt ? xt : function () {},
      Ot = null,
      Qt = null,
      Zt = !1,
      Ut = wt(),
      Bt = 1e4 > Ut ? wt : function () {
    return wt() - Ut;
  };

  function Rt() {
    switch (yt()) {
      case bt:
        return 99;

      case St:
        return 98;

      case Tt:
        return 97;

      case Dt:
        return 96;

      case jt:
        return 95;

      default:
        throw Error(i(332));
    }
  }

  function Yt(c) {
    switch (c) {
      case 99:
        return bt;

      case 98:
        return St;

      case 97:
        return Tt;

      case 96:
        return Dt;

      case 95:
        return jt;

      default:
        throw Error(i(332));
    }
  }

  function Pt(c, e) {
    return c = Yt(c), gt(c, e);
  }

  function Ft(c, e, a) {
    return c = Yt(c), Ht(c, e, a);
  }

  function Wt(c) {
    return null === Ot ? (Ot = [c], Qt = Ht(bt, qt)) : Ot.push(c), Et;
  }

  function Gt() {
    if (null !== Qt) {
      var c = Qt;
      Qt = null, Vt(c);
    }

    qt();
  }

  function qt() {
    if (!Zt && null !== Ot) {
      Zt = !0;
      var c = 0;

      try {
        var e = Ot;
        Pt(99, function () {
          for (; c < e.length; c++) {
            var a = e[c];

            do {
              a = a(!0);
            } while (null !== a);
          }
        }), Ot = null;
      } catch (e) {
        throw null !== Ot && (Ot = Ot.slice(c + 1)), Ht(bt, Gt), e;
      } finally {
        Zt = !1;
      }
    }
  }

  function Jt(c, e, a) {
    return 1073741821 - (1 + ((1073741821 - c + e / 10) / (a /= 10) | 0)) * a;
  }

  function Kt(c, e) {
    if (c && c.defaultProps) for (var a in e = t({}, e), c = c.defaultProps) {
      void 0 === e[a] && (e[a] = c[a]);
    }
    return e;
  }

  var Xt = {
    current: null
  },
      _t = null,
      $t = null,
      cr = null;

  function er() {
    cr = $t = _t = null;
  }

  function ar(c) {
    var e = Xt.current;
    st(Xt), c.type._context._currentValue = e;
  }

  function nr(c, e) {
    for (; null !== c;) {
      var a = c.alternate;
      if (c.childExpirationTime < e) c.childExpirationTime = e, null !== a && a.childExpirationTime < e && (a.childExpirationTime = e);else {
        if (!(null !== a && a.childExpirationTime < e)) break;
        a.childExpirationTime = e;
      }
      c = c.return;
    }
  }

  function tr(c, e) {
    _t = c, cr = $t = null, null !== (c = c.dependencies) && null !== c.firstContext && (c.expirationTime >= e && (Ti = !0), c.firstContext = null);
  }

  function rr(c, e) {
    if (cr !== c && !1 !== e && 0 !== e) if ("number" == typeof e && 1073741823 !== e || (cr = c, e = 1073741823), e = {
      context: c,
      observedBits: e,
      next: null
    }, null === $t) {
      if (null === _t) throw Error(i(308));
      $t = e, _t.dependencies = {
        expirationTime: 0,
        firstContext: e,
        responders: null
      };
    } else $t = $t.next = e;
    return c._currentValue;
  }

  var ir = !1;

  function or(c) {
    c.updateQueue = {
      baseState: c.memoizedState,
      baseQueue: null,
      shared: {
        pending: null
      },
      effects: null
    };
  }

  function lr(c, e) {
    c = c.updateQueue, e.updateQueue === c && (e.updateQueue = {
      baseState: c.baseState,
      baseQueue: c.baseQueue,
      shared: c.shared,
      effects: c.effects
    });
  }

  function fr(c, e) {
    return (c = {
      expirationTime: c,
      suspenseConfig: e,
      tag: 0,
      payload: null,
      callback: null,
      next: null
    }).next = c;
  }

  function sr(c, e) {
    if (null !== (c = c.updateQueue)) {
      var a = (c = c.shared).pending;
      null === a ? e.next = e : (e.next = a.next, a.next = e), c.pending = e;
    }
  }

  function ur(c, e) {
    var a = c.alternate;
    null !== a && lr(a, c), null === (a = (c = c.updateQueue).baseQueue) ? (c.baseQueue = e.next = e, e.next = e) : (e.next = a.next, a.next = e);
  }

  function hr(c, e, a, n) {
    var r = c.updateQueue;
    ir = !1;
    var i = r.baseQueue,
        o = r.shared.pending;

    if (null !== o) {
      if (null !== i) {
        var l = i.next;
        i.next = o.next, o.next = l;
      }

      i = o, r.shared.pending = null, null !== (l = c.alternate) && null !== (l = l.updateQueue) && (l.baseQueue = o);
    }

    if (null !== i) {
      l = i.next;
      var f = r.baseState,
          s = 0,
          u = null,
          h = null,
          m = null;
      if (null !== l) for (var v = l;;) {
        if ((o = v.expirationTime) < n) {
          var d = {
            expirationTime: v.expirationTime,
            suspenseConfig: v.suspenseConfig,
            tag: v.tag,
            payload: v.payload,
            callback: v.callback,
            next: null
          };
          null === m ? (h = m = d, u = f) : m = m.next = d, o > s && (s = o);
        } else {
          null !== m && (m = m.next = {
            expirationTime: 1073741823,
            suspenseConfig: v.suspenseConfig,
            tag: v.tag,
            payload: v.payload,
            callback: v.callback,
            next: null
          }), dl(o, v.suspenseConfig);

          c: {
            var M = c,
                p = v;

            switch (o = e, d = a, p.tag) {
              case 1:
                if ("function" == typeof (M = p.payload)) {
                  f = M.call(d, f, o);
                  break c;
                }

                f = M;
                break c;

              case 3:
                M.effectTag = -4097 & M.effectTag | 64;

              case 0:
                if (null == (o = "function" == typeof (M = p.payload) ? M.call(d, f, o) : M)) break c;
                f = t({}, f, o);
                break c;

              case 2:
                ir = !0;
            }
          }

          null !== v.callback && (c.effectTag |= 32, null === (o = r.effects) ? r.effects = [v] : o.push(v));
        }

        if (null === (v = v.next) || v === l) {
          if (null === (o = r.shared.pending)) break;
          v = i.next = o.next, o.next = l, r.baseQueue = i = o, r.shared.pending = null;
        }
      }
      null === m ? u = f : m.next = h, r.baseState = u, r.baseQueue = m, Ml(s), c.expirationTime = s, c.memoizedState = f;
    }
  }

  function mr(c, e, a) {
    if (c = e.effects, e.effects = null, null !== c) for (e = 0; e < c.length; e++) {
      var n = c[e],
          t = n.callback;

      if (null !== t) {
        if (n.callback = null, n = t, t = a, "function" != typeof n) throw Error(i(191, n));
        n.call(t);
      }
    }
  }

  var vr = J.ReactCurrentBatchConfig,
      dr = new n.Component().refs;

  function Mr(c, e, a, n) {
    a = null == (a = a(n, e = c.memoizedState)) ? e : t({}, e, a), c.memoizedState = a, 0 === c.expirationTime && (c.updateQueue.baseState = a);
  }

  var pr = {
    isMounted: function isMounted(c) {
      return !!(c = c._reactInternalFiber) && $c(c) === c;
    },
    enqueueSetState: function enqueueSetState(c, e, a) {
      c = c._reactInternalFiber;
      var n = nl(),
          t = vr.suspense;
      (t = fr(n = tl(n, c, t), t)).payload = e, null != a && (t.callback = a), sr(c, t), rl(c, n);
    },
    enqueueReplaceState: function enqueueReplaceState(c, e, a) {
      c = c._reactInternalFiber;
      var n = nl(),
          t = vr.suspense;
      (t = fr(n = tl(n, c, t), t)).tag = 1, t.payload = e, null != a && (t.callback = a), sr(c, t), rl(c, n);
    },
    enqueueForceUpdate: function enqueueForceUpdate(c, e) {
      c = c._reactInternalFiber;
      var a = nl(),
          n = vr.suspense;
      (n = fr(a = tl(a, c, n), n)).tag = 2, null != e && (n.callback = e), sr(c, n), rl(c, a);
    }
  };

  function zr(c, e, a, n, t, r, i) {
    return "function" == typeof (c = c.stateNode).shouldComponentUpdate ? c.shouldComponentUpdate(n, r, i) : !e.prototype || !e.prototype.isPureReactComponent || !Bn(a, n) || !Bn(t, r);
  }

  function Cr(c, e, a) {
    var n = !1,
        t = ht,
        r = e.contextType;
    return "object" == typeof r && null !== r ? r = rr(r) : (t = pt(e) ? dt : mt.current, r = (n = null != (n = e.contextTypes)) ? Mt(c, t) : ht), e = new e(a, r), c.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, e.updater = pr, c.stateNode = e, e._reactInternalFiber = c, n && ((c = c.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, c.__reactInternalMemoizedMaskedChildContext = r), e;
  }

  function Lr(c, e, a, n) {
    c = e.state, "function" == typeof e.componentWillReceiveProps && e.componentWillReceiveProps(a, n), "function" == typeof e.UNSAFE_componentWillReceiveProps && e.UNSAFE_componentWillReceiveProps(a, n), e.state !== c && pr.enqueueReplaceState(e, e.state, null);
  }

  function Ar(c, e, a, n) {
    var t = c.stateNode;
    t.props = a, t.state = c.memoizedState, t.refs = dr, or(c);
    var r = e.contextType;
    "object" == typeof r && null !== r ? t.context = rr(r) : (r = pt(e) ? dt : mt.current, t.context = Mt(c, r)), hr(c, a, t, n), t.state = c.memoizedState, "function" == typeof (r = e.getDerivedStateFromProps) && (Mr(c, e, r, a), t.state = c.memoizedState), "function" == typeof e.getDerivedStateFromProps || "function" == typeof t.getSnapshotBeforeUpdate || "function" != typeof t.UNSAFE_componentWillMount && "function" != typeof t.componentWillMount || (e = t.state, "function" == typeof t.componentWillMount && t.componentWillMount(), "function" == typeof t.UNSAFE_componentWillMount && t.UNSAFE_componentWillMount(), e !== t.state && pr.enqueueReplaceState(t, t.state, null), hr(c, a, t, n), t.state = c.memoizedState), "function" == typeof t.componentDidMount && (c.effectTag |= 4);
  }

  var Nr = Array.isArray;

  function gr(c, e, a) {
    if (null !== (c = a.ref) && "function" != typeof c && "object" != typeof c) {
      if (a._owner) {
        if (a = a._owner) {
          if (1 !== a.tag) throw Error(i(309));
          var n = a.stateNode;
        }

        if (!n) throw Error(i(147, c));
        var t = "" + c;
        return null !== e && null !== e.ref && "function" == typeof e.ref && e.ref._stringRef === t ? e.ref : ((e = function e(c) {
          var e = n.refs;
          e === dr && (e = n.refs = {}), null === c ? delete e[t] : e[t] = c;
        })._stringRef = t, e);
      }

      if ("string" != typeof c) throw Error(i(284));
      if (!a._owner) throw Error(i(290, c));
    }

    return c;
  }

  function Hr(c, e) {
    if ("textarea" !== c.type) throw Error(i(31, "[object Object]" === Object.prototype.toString.call(e) ? "object with keys {" + Object.keys(e).join(", ") + "}" : e, ""));
  }

  function Vr(c) {
    function e(e, a) {
      if (c) {
        var n = e.lastEffect;
        null !== n ? (n.nextEffect = a, e.lastEffect = a) : e.firstEffect = e.lastEffect = a, a.nextEffect = null, a.effectTag = 8;
      }
    }

    function a(a, n) {
      if (!c) return null;

      for (; null !== n;) {
        e(a, n), n = n.sibling;
      }

      return null;
    }

    function n(c, e) {
      for (c = new Map(); null !== e;) {
        null !== e.key ? c.set(e.key, e) : c.set(e.index, e), e = e.sibling;
      }

      return c;
    }

    function t(c, e) {
      return (c = El(c, e)).index = 0, c.sibling = null, c;
    }

    function r(e, a, n) {
      return e.index = n, c ? null !== (n = e.alternate) ? (n = n.index) < a ? (e.effectTag = 2, a) : n : (e.effectTag = 2, a) : a;
    }

    function o(e) {
      return c && null === e.alternate && (e.effectTag = 2), e;
    }

    function l(c, e, a, n) {
      return null === e || 6 !== e.tag ? ((e = Ol(a, c.mode, n)).return = c, e) : ((e = t(e, a)).return = c, e);
    }

    function f(c, e, a, n) {
      return null !== e && e.elementType === a.type ? ((n = t(e, a.props)).ref = gr(c, e, a), n.return = c, n) : ((n = kl(a.type, a.key, a.props, null, c.mode, n)).ref = gr(c, e, a), n.return = c, n);
    }

    function s(c, e, a, n) {
      return null === e || 4 !== e.tag || e.stateNode.containerInfo !== a.containerInfo || e.stateNode.implementation !== a.implementation ? ((e = Ql(a, c.mode, n)).return = c, e) : ((e = t(e, a.children || [])).return = c, e);
    }

    function u(c, e, a, n, r) {
      return null === e || 7 !== e.tag ? ((e = Il(a, c.mode, n, r)).return = c, e) : ((e = t(e, a)).return = c, e);
    }

    function h(c, e, a) {
      if ("string" == typeof e || "number" == typeof e) return (e = Ol("" + e, c.mode, a)).return = c, e;

      if ("object" == typeof e && null !== e) {
        switch (e.$$typeof) {
          case $:
            return (a = kl(e.type, e.key, e.props, null, c.mode, a)).ref = gr(c, null, e), a.return = c, a;

          case cc:
            return (e = Ql(e, c.mode, a)).return = c, e;
        }

        if (Nr(e) || vc(e)) return (e = Il(e, c.mode, a, null)).return = c, e;
        Hr(c, e);
      }

      return null;
    }

    function m(c, e, a, n) {
      var t = null !== e ? e.key : null;
      if ("string" == typeof a || "number" == typeof a) return null !== t ? null : l(c, e, "" + a, n);

      if ("object" == typeof a && null !== a) {
        switch (a.$$typeof) {
          case $:
            return a.key === t ? a.type === ec ? u(c, e, a.props.children, n, t) : f(c, e, a, n) : null;

          case cc:
            return a.key === t ? s(c, e, a, n) : null;
        }

        if (Nr(a) || vc(a)) return null !== t ? null : u(c, e, a, n, null);
        Hr(c, a);
      }

      return null;
    }

    function v(c, e, a, n, t) {
      if ("string" == typeof n || "number" == typeof n) return l(e, c = c.get(a) || null, "" + n, t);

      if ("object" == typeof n && null !== n) {
        switch (n.$$typeof) {
          case $:
            return c = c.get(null === n.key ? a : n.key) || null, n.type === ec ? u(e, c, n.props.children, t, n.key) : f(e, c, n, t);

          case cc:
            return s(e, c = c.get(null === n.key ? a : n.key) || null, n, t);
        }

        if (Nr(n) || vc(n)) return u(e, c = c.get(a) || null, n, t, null);
        Hr(e, n);
      }

      return null;
    }

    function d(t, i, o, l) {
      for (var f = null, s = null, u = i, d = i = 0, M = null; null !== u && d < o.length; d++) {
        u.index > d ? (M = u, u = null) : M = u.sibling;
        var p = m(t, u, o[d], l);

        if (null === p) {
          null === u && (u = M);
          break;
        }

        c && u && null === p.alternate && e(t, u), i = r(p, i, d), null === s ? f = p : s.sibling = p, s = p, u = M;
      }

      if (d === o.length) return a(t, u), f;

      if (null === u) {
        for (; d < o.length; d++) {
          null !== (u = h(t, o[d], l)) && (i = r(u, i, d), null === s ? f = u : s.sibling = u, s = u);
        }

        return f;
      }

      for (u = n(t, u); d < o.length; d++) {
        null !== (M = v(u, t, d, o[d], l)) && (c && null !== M.alternate && u.delete(null === M.key ? d : M.key), i = r(M, i, d), null === s ? f = M : s.sibling = M, s = M);
      }

      return c && u.forEach(function (c) {
        return e(t, c);
      }), f;
    }

    function M(t, o, l, f) {
      var s = vc(l);
      if ("function" != typeof s) throw Error(i(150));
      if (null == (l = s.call(l))) throw Error(i(151));

      for (var u = s = null, d = o, M = o = 0, p = null, z = l.next(); null !== d && !z.done; M++, z = l.next()) {
        d.index > M ? (p = d, d = null) : p = d.sibling;
        var C = m(t, d, z.value, f);

        if (null === C) {
          null === d && (d = p);
          break;
        }

        c && d && null === C.alternate && e(t, d), o = r(C, o, M), null === u ? s = C : u.sibling = C, u = C, d = p;
      }

      if (z.done) return a(t, d), s;

      if (null === d) {
        for (; !z.done; M++, z = l.next()) {
          null !== (z = h(t, z.value, f)) && (o = r(z, o, M), null === u ? s = z : u.sibling = z, u = z);
        }

        return s;
      }

      for (d = n(t, d); !z.done; M++, z = l.next()) {
        null !== (z = v(d, t, M, z.value, f)) && (c && null !== z.alternate && d.delete(null === z.key ? M : z.key), o = r(z, o, M), null === u ? s = z : u.sibling = z, u = z);
      }

      return c && d.forEach(function (c) {
        return e(t, c);
      }), s;
    }

    return function (c, n, r, l) {
      var f = "object" == typeof r && null !== r && r.type === ec && null === r.key;
      f && (r = r.props.children);
      var s = "object" == typeof r && null !== r;
      if (s) switch (r.$$typeof) {
        case $:
          c: {
            for (s = r.key, f = n; null !== f;) {
              if (f.key === s) {
                switch (f.tag) {
                  case 7:
                    if (r.type === ec) {
                      a(c, f.sibling), (n = t(f, r.props.children)).return = c, c = n;
                      break c;
                    }

                    break;

                  default:
                    if (f.elementType === r.type) {
                      a(c, f.sibling), (n = t(f, r.props)).ref = gr(c, f, r), n.return = c, c = n;
                      break c;
                    }

                }

                a(c, f);
                break;
              }

              e(c, f), f = f.sibling;
            }

            r.type === ec ? ((n = Il(r.props.children, c.mode, l, r.key)).return = c, c = n) : ((l = kl(r.type, r.key, r.props, null, c.mode, l)).ref = gr(c, n, r), l.return = c, c = l);
          }

          return o(c);

        case cc:
          c: {
            for (f = r.key; null !== n;) {
              if (n.key === f) {
                if (4 === n.tag && n.stateNode.containerInfo === r.containerInfo && n.stateNode.implementation === r.implementation) {
                  a(c, n.sibling), (n = t(n, r.children || [])).return = c, c = n;
                  break c;
                }

                a(c, n);
                break;
              }

              e(c, n), n = n.sibling;
            }

            (n = Ql(r, c.mode, l)).return = c, c = n;
          }

          return o(c);
      }
      if ("string" == typeof r || "number" == typeof r) return r = "" + r, null !== n && 6 === n.tag ? (a(c, n.sibling), (n = t(n, r)).return = c, c = n) : (a(c, n), (n = Ol(r, c.mode, l)).return = c, c = n), o(c);
      if (Nr(r)) return d(c, n, r, l);
      if (vc(r)) return M(c, n, r, l);
      if (s && Hr(c, r), void 0 === r && !f) switch (c.tag) {
        case 1:
        case 0:
          throw c = c.type, Error(i(152, c.displayName || c.name || "Component"));
      }
      return a(c, n);
    };
  }

  var xr = Vr(!0),
      wr = Vr(!1),
      yr = {},
      br = {
    current: yr
  },
      Sr = {
    current: yr
  },
      Tr = {
    current: yr
  };

  function Dr(c) {
    if (c === yr) throw Error(i(174));
    return c;
  }

  function jr(c, e) {
    switch (ut(Tr, e), ut(Sr, c), ut(br, yr), c = e.nodeType) {
      case 9:
      case 11:
        e = (e = e.documentElement) ? e.namespaceURI : Ic(null, "");
        break;

      default:
        e = Ic(e = (c = 8 === c ? e.parentNode : e).namespaceURI || null, c = c.tagName);
    }

    st(br), ut(br, e);
  }

  function Er() {
    st(br), st(Sr), st(Tr);
  }

  function kr(c) {
    Dr(Tr.current);
    var e = Dr(br.current),
        a = Ic(e, c.type);
    e !== a && (ut(Sr, c), ut(br, a));
  }

  function Ir(c) {
    Sr.current === c && (st(br), st(Sr));
  }

  var Or = {
    current: 0
  };

  function Qr(c) {
    for (var e = c; null !== e;) {
      if (13 === e.tag) {
        var a = e.memoizedState;
        if (null !== a && (null === (a = a.dehydrated) || a.data === va || a.data === da)) return e;
      } else if (19 === e.tag && void 0 !== e.memoizedProps.revealOrder) {
        if (0 != (64 & e.effectTag)) return e;
      } else if (null !== e.child) {
        e.child.return = e, e = e.child;
        continue;
      }

      if (e === c) break;

      for (; null === e.sibling;) {
        if (null === e.return || e.return === c) return null;
        e = e.return;
      }

      e.sibling.return = e.return, e = e.sibling;
    }

    return null;
  }

  function Zr(c, e) {
    return {
      responder: c,
      props: e
    };
  }

  var Ur = J.ReactCurrentDispatcher,
      Br = J.ReactCurrentBatchConfig,
      Rr = 0,
      Yr = null,
      Pr = null,
      Fr = null,
      Wr = !1;

  function Gr() {
    throw Error(i(321));
  }

  function qr(c, e) {
    if (null === e) return !1;

    for (var a = 0; a < e.length && a < c.length; a++) {
      if (!Zn(c[a], e[a])) return !1;
    }

    return !0;
  }

  function Jr(c, e, a, n, t, r) {
    if (Rr = r, Yr = e, e.memoizedState = null, e.updateQueue = null, e.expirationTime = 0, Ur.current = null === c || null === c.memoizedState ? zi : Ci, c = a(n, t), e.expirationTime === Rr) {
      r = 0;

      do {
        if (e.expirationTime = 0, !(25 > r)) throw Error(i(301));
        r += 1, Fr = Pr = null, e.updateQueue = null, Ur.current = Li, c = a(n, t);
      } while (e.expirationTime === Rr);
    }

    if (Ur.current = pi, e = null !== Pr && null !== Pr.next, Rr = 0, Fr = Pr = Yr = null, Wr = !1, e) throw Error(i(300));
    return c;
  }

  function Kr() {
    var c = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return null === Fr ? Yr.memoizedState = Fr = c : Fr = Fr.next = c, Fr;
  }

  function Xr() {
    if (null === Pr) {
      var c = Yr.alternate;
      c = null !== c ? c.memoizedState : null;
    } else c = Pr.next;

    var e = null === Fr ? Yr.memoizedState : Fr.next;
    if (null !== e) Fr = e, Pr = c;else {
      if (null === c) throw Error(i(310));
      c = {
        memoizedState: (Pr = c).memoizedState,
        baseState: Pr.baseState,
        baseQueue: Pr.baseQueue,
        queue: Pr.queue,
        next: null
      }, null === Fr ? Yr.memoizedState = Fr = c : Fr = Fr.next = c;
    }
    return Fr;
  }

  function _r(c, e) {
    return "function" == typeof e ? e(c) : e;
  }

  function $r(c) {
    var e = Xr(),
        a = e.queue;
    if (null === a) throw Error(i(311));
    a.lastRenderedReducer = c;
    var n = Pr,
        t = n.baseQueue,
        r = a.pending;

    if (null !== r) {
      if (null !== t) {
        var o = t.next;
        t.next = r.next, r.next = o;
      }

      n.baseQueue = t = r, a.pending = null;
    }

    if (null !== t) {
      t = t.next, n = n.baseState;
      var l = o = r = null,
          f = t;

      do {
        var s = f.expirationTime;

        if (s < Rr) {
          var u = {
            expirationTime: f.expirationTime,
            suspenseConfig: f.suspenseConfig,
            action: f.action,
            eagerReducer: f.eagerReducer,
            eagerState: f.eagerState,
            next: null
          };
          null === l ? (o = l = u, r = n) : l = l.next = u, s > Yr.expirationTime && (Yr.expirationTime = s, Ml(s));
        } else null !== l && (l = l.next = {
          expirationTime: 1073741823,
          suspenseConfig: f.suspenseConfig,
          action: f.action,
          eagerReducer: f.eagerReducer,
          eagerState: f.eagerState,
          next: null
        }), dl(s, f.suspenseConfig), n = f.eagerReducer === c ? f.eagerState : c(n, f.action);

        f = f.next;
      } while (null !== f && f !== t);

      null === l ? r = n : l.next = o, Zn(n, e.memoizedState) || (Ti = !0), e.memoizedState = n, e.baseState = r, e.baseQueue = l, a.lastRenderedState = n;
    }

    return [e.memoizedState, a.dispatch];
  }

  function ci(c) {
    var e = Xr(),
        a = e.queue;
    if (null === a) throw Error(i(311));
    a.lastRenderedReducer = c;
    var n = a.dispatch,
        t = a.pending,
        r = e.memoizedState;

    if (null !== t) {
      a.pending = null;
      var o = t = t.next;

      do {
        r = c(r, o.action), o = o.next;
      } while (o !== t);

      Zn(r, e.memoizedState) || (Ti = !0), e.memoizedState = r, null === e.baseQueue && (e.baseState = r), a.lastRenderedState = r;
    }

    return [r, n];
  }

  function ei(c) {
    var e = Kr();
    return "function" == typeof c && (c = c()), e.memoizedState = e.baseState = c, c = (c = e.queue = {
      pending: null,
      dispatch: null,
      lastRenderedReducer: _r,
      lastRenderedState: c
    }).dispatch = Mi.bind(null, Yr, c), [e.memoizedState, c];
  }

  function ai(c, e, a, n) {
    return c = {
      tag: c,
      create: e,
      destroy: a,
      deps: n,
      next: null
    }, null === (e = Yr.updateQueue) ? (e = {
      lastEffect: null
    }, Yr.updateQueue = e, e.lastEffect = c.next = c) : null === (a = e.lastEffect) ? e.lastEffect = c.next = c : (n = a.next, a.next = c, c.next = n, e.lastEffect = c), c;
  }

  function ni() {
    return Xr().memoizedState;
  }

  function ti(c, e, a, n) {
    var t = Kr();
    Yr.effectTag |= c, t.memoizedState = ai(1 | e, a, void 0, void 0 === n ? null : n);
  }

  function ri(c, e, a, n) {
    var t = Xr();
    n = void 0 === n ? null : n;
    var r = void 0;

    if (null !== Pr) {
      var i = Pr.memoizedState;
      if (r = i.destroy, null !== n && qr(n, i.deps)) return void ai(e, a, r, n);
    }

    Yr.effectTag |= c, t.memoizedState = ai(1 | e, a, r, n);
  }

  function ii(c, e) {
    return ti(516, 4, c, e);
  }

  function oi(c, e) {
    return ri(516, 4, c, e);
  }

  function li(c, e) {
    return ri(4, 2, c, e);
  }

  function fi(c, e) {
    return "function" == typeof e ? (c = c(), e(c), function () {
      e(null);
    }) : null != e ? (c = c(), e.current = c, function () {
      e.current = null;
    }) : void 0;
  }

  function si(c, e, a) {
    return a = null != a ? a.concat([c]) : null, ri(4, 2, fi.bind(null, e, c), a);
  }

  function ui() {}

  function hi(c, e) {
    return Kr().memoizedState = [c, void 0 === e ? null : e], c;
  }

  function mi(c, e) {
    var a = Xr();
    e = void 0 === e ? null : e;
    var n = a.memoizedState;
    return null !== n && null !== e && qr(e, n[1]) ? n[0] : (a.memoizedState = [c, e], c);
  }

  function vi(c, e) {
    var a = Xr();
    e = void 0 === e ? null : e;
    var n = a.memoizedState;
    return null !== n && null !== e && qr(e, n[1]) ? n[0] : (c = c(), a.memoizedState = [c, e], c);
  }

  function di(c, e, a) {
    var n = Rt();
    Pt(98 > n ? 98 : n, function () {
      c(!0);
    }), Pt(97 < n ? 97 : n, function () {
      var n = Br.suspense;
      Br.suspense = void 0 === e ? null : e;

      try {
        c(!1), a();
      } finally {
        Br.suspense = n;
      }
    });
  }

  function Mi(c, e, a) {
    var n = nl(),
        t = vr.suspense;
    t = {
      expirationTime: n = tl(n, c, t),
      suspenseConfig: t,
      action: a,
      eagerReducer: null,
      eagerState: null,
      next: null
    };
    var r = e.pending;
    if (null === r ? t.next = t : (t.next = r.next, r.next = t), e.pending = t, r = c.alternate, c === Yr || null !== r && r === Yr) Wr = !0, t.expirationTime = Rr, Yr.expirationTime = Rr;else {
      if (0 === c.expirationTime && (null === r || 0 === r.expirationTime) && null !== (r = e.lastRenderedReducer)) try {
        var i = e.lastRenderedState,
            o = r(i, a);
        if (t.eagerReducer = r, t.eagerState = o, Zn(o, i)) return;
      } catch (c) {}
      rl(c, n);
    }
  }

  var pi = {
    readContext: rr,
    useCallback: Gr,
    useContext: Gr,
    useEffect: Gr,
    useImperativeHandle: Gr,
    useLayoutEffect: Gr,
    useMemo: Gr,
    useReducer: Gr,
    useRef: Gr,
    useState: Gr,
    useDebugValue: Gr,
    useResponder: Gr,
    useDeferredValue: Gr,
    useTransition: Gr
  },
      zi = {
    readContext: rr,
    useCallback: hi,
    useContext: rr,
    useEffect: ii,
    useImperativeHandle: function useImperativeHandle(c, e, a) {
      return a = null != a ? a.concat([c]) : null, ti(4, 2, fi.bind(null, e, c), a);
    },
    useLayoutEffect: function useLayoutEffect(c, e) {
      return ti(4, 2, c, e);
    },
    useMemo: function useMemo(c, e) {
      var a = Kr();
      return e = void 0 === e ? null : e, c = c(), a.memoizedState = [c, e], c;
    },
    useReducer: function useReducer(c, e, a) {
      var n = Kr();
      return e = void 0 !== a ? a(e) : e, n.memoizedState = n.baseState = e, c = (c = n.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: c,
        lastRenderedState: e
      }).dispatch = Mi.bind(null, Yr, c), [n.memoizedState, c];
    },
    useRef: function useRef(c) {
      return c = {
        current: c
      }, Kr().memoizedState = c;
    },
    useState: ei,
    useDebugValue: ui,
    useResponder: Zr,
    useDeferredValue: function useDeferredValue(c, e) {
      var a = ei(c),
          n = a[0],
          t = a[1];
      return ii(function () {
        var a = Br.suspense;
        Br.suspense = void 0 === e ? null : e;

        try {
          t(c);
        } finally {
          Br.suspense = a;
        }
      }, [c, e]), n;
    },
    useTransition: function useTransition(c) {
      var e = ei(!1),
          a = e[0];
      return e = e[1], [hi(di.bind(null, e, c), [e, c]), a];
    }
  },
      Ci = {
    readContext: rr,
    useCallback: mi,
    useContext: rr,
    useEffect: oi,
    useImperativeHandle: si,
    useLayoutEffect: li,
    useMemo: vi,
    useReducer: $r,
    useRef: ni,
    useState: function useState() {
      return $r(_r);
    },
    useDebugValue: ui,
    useResponder: Zr,
    useDeferredValue: function useDeferredValue(c, e) {
      var a = $r(_r),
          n = a[0],
          t = a[1];
      return oi(function () {
        var a = Br.suspense;
        Br.suspense = void 0 === e ? null : e;

        try {
          t(c);
        } finally {
          Br.suspense = a;
        }
      }, [c, e]), n;
    },
    useTransition: function useTransition(c) {
      var e = $r(_r),
          a = e[0];
      return e = e[1], [mi(di.bind(null, e, c), [e, c]), a];
    }
  },
      Li = {
    readContext: rr,
    useCallback: mi,
    useContext: rr,
    useEffect: oi,
    useImperativeHandle: si,
    useLayoutEffect: li,
    useMemo: vi,
    useReducer: ci,
    useRef: ni,
    useState: function useState() {
      return ci(_r);
    },
    useDebugValue: ui,
    useResponder: Zr,
    useDeferredValue: function useDeferredValue(c, e) {
      var a = ci(_r),
          n = a[0],
          t = a[1];
      return oi(function () {
        var a = Br.suspense;
        Br.suspense = void 0 === e ? null : e;

        try {
          t(c);
        } finally {
          Br.suspense = a;
        }
      }, [c, e]), n;
    },
    useTransition: function useTransition(c) {
      var e = ci(_r),
          a = e[0];
      return e = e[1], [mi(di.bind(null, e, c), [e, c]), a];
    }
  },
      Ai = null,
      Ni = null,
      gi = !1;

  function Hi(c, e) {
    var a = Dl(5, null, null, 0);
    a.elementType = "DELETED", a.type = "DELETED", a.stateNode = e, a.return = c, a.effectTag = 8, null !== c.lastEffect ? (c.lastEffect.nextEffect = a, c.lastEffect = a) : c.firstEffect = c.lastEffect = a;
  }

  function Vi(c, e) {
    switch (c.tag) {
      case 5:
        var a = c.type;
        return null !== (e = 1 !== e.nodeType || a.toLowerCase() !== e.nodeName.toLowerCase() ? null : e) && (c.stateNode = e, !0);

      case 6:
        return null !== (e = "" === c.pendingProps || 3 !== e.nodeType ? null : e) && (c.stateNode = e, !0);

      case 13:
      default:
        return !1;
    }
  }

  function xi(c) {
    if (gi) {
      var e = Ni;

      if (e) {
        var a = e;

        if (!Vi(c, e)) {
          if (!(e = Na(a.nextSibling)) || !Vi(c, e)) return c.effectTag = -1025 & c.effectTag | 2, gi = !1, void (Ai = c);
          Hi(Ai, a);
        }

        Ai = c, Ni = Na(e.firstChild);
      } else c.effectTag = -1025 & c.effectTag | 2, gi = !1, Ai = c;
    }
  }

  function wi(c) {
    for (c = c.return; null !== c && 5 !== c.tag && 3 !== c.tag && 13 !== c.tag;) {
      c = c.return;
    }

    Ai = c;
  }

  function yi(c) {
    if (c !== Ai) return !1;
    if (!gi) return wi(c), gi = !0, !1;
    var e = c.type;
    if (5 !== c.tag || "head" !== e && "body" !== e && !Ca(e, c.memoizedProps)) for (e = Ni; e;) {
      Hi(c, e), e = Na(e.nextSibling);
    }

    if (wi(c), 13 === c.tag) {
      if (!(c = null !== (c = c.memoizedState) ? c.dehydrated : null)) throw Error(i(317));

      c: {
        for (c = c.nextSibling, e = 0; c;) {
          if (8 === c.nodeType) {
            var a = c.data;

            if (a === ma) {
              if (0 === e) {
                Ni = Na(c.nextSibling);
                break c;
              }

              e--;
            } else a !== ha && a !== da && a !== va || e++;
          }

          c = c.nextSibling;
        }

        Ni = null;
      }
    } else Ni = Ai ? Na(c.stateNode.nextSibling) : null;

    return !0;
  }

  function bi() {
    Ni = Ai = null, gi = !1;
  }

  var Si = J.ReactCurrentOwner,
      Ti = !1;

  function Di(c, e, a, n) {
    e.child = null === c ? wr(e, null, a, n) : xr(e, c.child, a, n);
  }

  function ji(c, e, a, n, t) {
    a = a.render;
    var r = e.ref;
    return tr(e, t), n = Jr(c, e, a, n, r, t), null === c || Ti ? (e.effectTag |= 1, Di(c, e, n, t), e.child) : (e.updateQueue = c.updateQueue, e.effectTag &= -517, c.expirationTime <= t && (c.expirationTime = 0), Ki(c, e, t));
  }

  function Ei(c, e, a, n, t, r) {
    if (null === c) {
      var i = a.type;
      return "function" != typeof i || jl(i) || void 0 !== i.defaultProps || null !== a.compare || void 0 !== a.defaultProps ? ((c = kl(a.type, null, n, null, e.mode, r)).ref = e.ref, c.return = e, e.child = c) : (e.tag = 15, e.type = i, ki(c, e, i, n, t, r));
    }

    return i = c.child, t < r && (t = i.memoizedProps, (a = null !== (a = a.compare) ? a : Bn)(t, n) && c.ref === e.ref) ? Ki(c, e, r) : (e.effectTag |= 1, (c = El(i, n)).ref = e.ref, c.return = e, e.child = c);
  }

  function ki(c, e, a, n, t, r) {
    return null !== c && Bn(c.memoizedProps, n) && c.ref === e.ref && (Ti = !1, t < r) ? (e.expirationTime = c.expirationTime, Ki(c, e, r)) : Oi(c, e, a, n, r);
  }

  function Ii(c, e) {
    var a = e.ref;
    (null === c && null !== a || null !== c && c.ref !== a) && (e.effectTag |= 128);
  }

  function Oi(c, e, a, n, t) {
    var r = pt(a) ? dt : mt.current;
    return r = Mt(e, r), tr(e, t), a = Jr(c, e, a, n, r, t), null === c || Ti ? (e.effectTag |= 1, Di(c, e, a, t), e.child) : (e.updateQueue = c.updateQueue, e.effectTag &= -517, c.expirationTime <= t && (c.expirationTime = 0), Ki(c, e, t));
  }

  function Qi(c, e, a, n, t) {
    if (pt(a)) {
      var r = !0;
      At(e);
    } else r = !1;

    if (tr(e, t), null === e.stateNode) null !== c && (c.alternate = null, e.alternate = null, e.effectTag |= 2), Cr(e, a, n), Ar(e, a, n, t), n = !0;else if (null === c) {
      var i = e.stateNode,
          o = e.memoizedProps;
      i.props = o;
      var l = i.context,
          f = a.contextType;
      "object" == typeof f && null !== f ? f = rr(f) : f = Mt(e, f = pt(a) ? dt : mt.current);
      var s = a.getDerivedStateFromProps,
          u = "function" == typeof s || "function" == typeof i.getSnapshotBeforeUpdate;
      u || "function" != typeof i.UNSAFE_componentWillReceiveProps && "function" != typeof i.componentWillReceiveProps || (o !== n || l !== f) && Lr(e, i, n, f), ir = !1;
      var h = e.memoizedState;
      i.state = h, hr(e, n, i, t), l = e.memoizedState, o !== n || h !== l || vt.current || ir ? ("function" == typeof s && (Mr(e, a, s, n), l = e.memoizedState), (o = ir || zr(e, a, o, n, h, l, f)) ? (u || "function" != typeof i.UNSAFE_componentWillMount && "function" != typeof i.componentWillMount || ("function" == typeof i.componentWillMount && i.componentWillMount(), "function" == typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount()), "function" == typeof i.componentDidMount && (e.effectTag |= 4)) : ("function" == typeof i.componentDidMount && (e.effectTag |= 4), e.memoizedProps = n, e.memoizedState = l), i.props = n, i.state = l, i.context = f, n = o) : ("function" == typeof i.componentDidMount && (e.effectTag |= 4), n = !1);
    } else i = e.stateNode, lr(c, e), o = e.memoizedProps, i.props = e.type === e.elementType ? o : Kt(e.type, o), l = i.context, "object" == typeof (f = a.contextType) && null !== f ? f = rr(f) : f = Mt(e, f = pt(a) ? dt : mt.current), (u = "function" == typeof (s = a.getDerivedStateFromProps) || "function" == typeof i.getSnapshotBeforeUpdate) || "function" != typeof i.UNSAFE_componentWillReceiveProps && "function" != typeof i.componentWillReceiveProps || (o !== n || l !== f) && Lr(e, i, n, f), ir = !1, l = e.memoizedState, i.state = l, hr(e, n, i, t), h = e.memoizedState, o !== n || l !== h || vt.current || ir ? ("function" == typeof s && (Mr(e, a, s, n), h = e.memoizedState), (s = ir || zr(e, a, o, n, l, h, f)) ? (u || "function" != typeof i.UNSAFE_componentWillUpdate && "function" != typeof i.componentWillUpdate || ("function" == typeof i.componentWillUpdate && i.componentWillUpdate(n, h, f), "function" == typeof i.UNSAFE_componentWillUpdate && i.UNSAFE_componentWillUpdate(n, h, f)), "function" == typeof i.componentDidUpdate && (e.effectTag |= 4), "function" == typeof i.getSnapshotBeforeUpdate && (e.effectTag |= 256)) : ("function" != typeof i.componentDidUpdate || o === c.memoizedProps && l === c.memoizedState || (e.effectTag |= 4), "function" != typeof i.getSnapshotBeforeUpdate || o === c.memoizedProps && l === c.memoizedState || (e.effectTag |= 256), e.memoizedProps = n, e.memoizedState = h), i.props = n, i.state = h, i.context = f, n = s) : ("function" != typeof i.componentDidUpdate || o === c.memoizedProps && l === c.memoizedState || (e.effectTag |= 4), "function" != typeof i.getSnapshotBeforeUpdate || o === c.memoizedProps && l === c.memoizedState || (e.effectTag |= 256), n = !1);
    return Zi(c, e, a, n, r, t);
  }

  function Zi(c, e, a, n, t, r) {
    Ii(c, e);
    var i = 0 != (64 & e.effectTag);
    if (!n && !i) return t && Nt(e, a, !1), Ki(c, e, r);
    n = e.stateNode, Si.current = e;
    var o = i && "function" != typeof a.getDerivedStateFromError ? null : n.render();
    return e.effectTag |= 1, null !== c && i ? (e.child = xr(e, c.child, null, r), e.child = xr(e, null, o, r)) : Di(c, e, o, r), e.memoizedState = n.state, t && Nt(e, a, !0), e.child;
  }

  function Ui(c) {
    var e = c.stateNode;
    e.pendingContext ? Ct(0, e.pendingContext, e.pendingContext !== e.context) : e.context && Ct(0, e.context, !1), jr(c, e.containerInfo);
  }

  var Bi,
      Ri,
      Yi,
      Pi,
      Fi = {
    dehydrated: null,
    retryTime: 0
  };

  function Wi(c, e, a) {
    var n,
        t = e.mode,
        r = e.pendingProps,
        i = Or.current,
        o = !1;

    if ((n = 0 != (64 & e.effectTag)) || (n = 0 != (2 & i) && (null === c || null !== c.memoizedState)), n ? (o = !0, e.effectTag &= -65) : null !== c && null === c.memoizedState || void 0 === r.fallback || !0 === r.unstable_avoidThisFallback || (i |= 1), ut(Or, 1 & i), null === c) {
      if (void 0 !== r.fallback && xi(e), o) {
        if (o = r.fallback, (r = Il(null, t, 0, null)).return = e, 0 == (2 & e.mode)) for (c = null !== e.memoizedState ? e.child.child : e.child, r.child = c; null !== c;) {
          c.return = r, c = c.sibling;
        }
        return (a = Il(o, t, a, null)).return = e, r.sibling = a, e.memoizedState = Fi, e.child = r, a;
      }

      return t = r.children, e.memoizedState = null, e.child = wr(e, null, t, a);
    }

    if (null !== c.memoizedState) {
      if (t = (c = c.child).sibling, o) {
        if (r = r.fallback, (a = El(c, c.pendingProps)).return = e, 0 == (2 & e.mode) && (o = null !== e.memoizedState ? e.child.child : e.child) !== c.child) for (a.child = o; null !== o;) {
          o.return = a, o = o.sibling;
        }
        return (t = El(t, r)).return = e, a.sibling = t, a.childExpirationTime = 0, e.memoizedState = Fi, e.child = a, t;
      }

      return a = xr(e, c.child, r.children, a), e.memoizedState = null, e.child = a;
    }

    if (c = c.child, o) {
      if (o = r.fallback, (r = Il(null, t, 0, null)).return = e, r.child = c, null !== c && (c.return = r), 0 == (2 & e.mode)) for (c = null !== e.memoizedState ? e.child.child : e.child, r.child = c; null !== c;) {
        c.return = r, c = c.sibling;
      }
      return (a = Il(o, t, a, null)).return = e, r.sibling = a, a.effectTag |= 2, r.childExpirationTime = 0, e.memoizedState = Fi, e.child = r, a;
    }

    return e.memoizedState = null, e.child = xr(e, c, r.children, a);
  }

  function Gi(c, e) {
    c.expirationTime < e && (c.expirationTime = e);
    var a = c.alternate;
    null !== a && a.expirationTime < e && (a.expirationTime = e), nr(c.return, e);
  }

  function qi(c, e, a, n, t, r) {
    var i = c.memoizedState;
    null === i ? c.memoizedState = {
      isBackwards: e,
      rendering: null,
      renderingStartTime: 0,
      last: n,
      tail: a,
      tailExpiration: 0,
      tailMode: t,
      lastEffect: r
    } : (i.isBackwards = e, i.rendering = null, i.renderingStartTime = 0, i.last = n, i.tail = a, i.tailExpiration = 0, i.tailMode = t, i.lastEffect = r);
  }

  function Ji(c, e, a) {
    var n = e.pendingProps,
        t = n.revealOrder,
        r = n.tail;
    if (Di(c, e, n.children, a), 0 != (2 & (n = Or.current))) n = 1 & n | 2, e.effectTag |= 64;else {
      if (null !== c && 0 != (64 & c.effectTag)) c: for (c = e.child; null !== c;) {
        if (13 === c.tag) null !== c.memoizedState && Gi(c, a);else if (19 === c.tag) Gi(c, a);else if (null !== c.child) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === e) break c;

        for (; null === c.sibling;) {
          if (null === c.return || c.return === e) break c;
          c = c.return;
        }

        c.sibling.return = c.return, c = c.sibling;
      }
      n &= 1;
    }
    if (ut(Or, n), 0 == (2 & e.mode)) e.memoizedState = null;else switch (t) {
      case "forwards":
        for (a = e.child, t = null; null !== a;) {
          null !== (c = a.alternate) && null === Qr(c) && (t = a), a = a.sibling;
        }

        null === (a = t) ? (t = e.child, e.child = null) : (t = a.sibling, a.sibling = null), qi(e, !1, t, a, r, e.lastEffect);
        break;

      case "backwards":
        for (a = null, t = e.child, e.child = null; null !== t;) {
          if (null !== (c = t.alternate) && null === Qr(c)) {
            e.child = t;
            break;
          }

          c = t.sibling, t.sibling = a, a = t, t = c;
        }

        qi(e, !0, a, null, r, e.lastEffect);
        break;

      case "together":
        qi(e, !1, null, null, void 0, e.lastEffect);
        break;

      default:
        e.memoizedState = null;
    }
    return e.child;
  }

  function Ki(c, e, a) {
    null !== c && (e.dependencies = c.dependencies);
    var n = e.expirationTime;
    if (0 !== n && Ml(n), e.childExpirationTime < a) return null;
    if (null !== c && e.child !== c.child) throw Error(i(153));

    if (null !== e.child) {
      for (a = El(c = e.child, c.pendingProps), e.child = a, a.return = e; null !== c.sibling;) {
        c = c.sibling, (a = a.sibling = El(c, c.pendingProps)).return = e;
      }

      a.sibling = null;
    }

    return e.child;
  }

  function Xi(c, e) {
    switch (c.tailMode) {
      case "hidden":
        e = c.tail;

        for (var a = null; null !== e;) {
          null !== e.alternate && (a = e), e = e.sibling;
        }

        null === a ? c.tail = null : a.sibling = null;
        break;

      case "collapsed":
        a = c.tail;

        for (var n = null; null !== a;) {
          null !== a.alternate && (n = a), a = a.sibling;
        }

        null === n ? e || null === c.tail ? c.tail = null : c.tail.sibling = null : n.sibling = null;
    }
  }

  function _i(c, e, a) {
    var n = e.pendingProps;

    switch (e.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return null;

      case 1:
        return pt(e.type) && zt(), null;

      case 3:
        return Er(), st(vt), st(mt), (a = e.stateNode).pendingContext && (a.context = a.pendingContext, a.pendingContext = null), null !== c && null !== c.child || !yi(e) || (e.effectTag |= 4), Ri(e), null;

      case 5:
        Ir(e), a = Dr(Tr.current);
        var r = e.type;
        if (null !== c && null != e.stateNode) Yi(c, e, r, n, a), c.ref !== e.ref && (e.effectTag |= 128);else {
          if (!n) {
            if (null === e.stateNode) throw Error(i(166));
            return null;
          }

          if (c = Dr(br.current), yi(e)) {
            n = e.stateNode, r = e.type;
            var o = e.memoizedProps;

            switch (n[Va] = e, n[xa] = o, r) {
              case "iframe":
              case "object":
              case "embed":
                Ge("load", n);
                break;

              case "video":
              case "audio":
                for (c = 0; c < Kc.length; c++) {
                  Ge(Kc[c], n);
                }

                break;

              case "source":
                Ge("error", n);
                break;

              case "img":
              case "image":
              case "link":
                Ge("error", n), Ge("load", n);
                break;

              case "form":
                Ge("reset", n), Ge("submit", n);
                break;

              case "details":
                Ge("toggle", n);
                break;

              case "input":
                Nc(n, o), Ge("invalid", n), ra(a, "onChange");
                break;

              case "select":
                n._wrapperState = {
                  wasMultiple: !!o.multiple
                }, Ge("invalid", n), ra(a, "onChange");
                break;

              case "textarea":
                Sc(n, o), Ge("invalid", n), ra(a, "onChange");
            }

            for (var l in aa(r, o), c = null, o) {
              if (o.hasOwnProperty(l)) {
                var f = o[l];
                "children" === l ? "string" == typeof f ? n.textContent !== f && (c = ["children", f]) : "number" == typeof f && n.textContent !== "" + f && (c = ["children", "" + f]) : g.hasOwnProperty(l) && null != f && ra(a, l);
              }
            }

            switch (r) {
              case "input":
                Cc(n), Vc(n, o, !0);
                break;

              case "textarea":
                Cc(n), Dc(n);
                break;

              case "select":
              case "option":
                break;

              default:
                "function" == typeof o.onClick && (n.onclick = ia);
            }

            a = c, e.updateQueue = a, null !== a && (e.effectTag |= 4);
          } else {
            switch (l = 9 === a.nodeType ? a : a.ownerDocument, c === ta && (c = kc(r)), c === ta ? "script" === r ? ((c = l.createElement("div")).innerHTML = "<script><\/script>", c = c.removeChild(c.firstChild)) : "string" == typeof n.is ? c = l.createElement(r, {
              is: n.is
            }) : (c = l.createElement(r), "select" === r && (l = c, n.multiple ? l.multiple = !0 : n.size && (l.size = n.size))) : c = l.createElementNS(c, r), c[Va] = e, c[xa] = n, Bi(c, e, !1, !1), e.stateNode = c, l = na(r, n), r) {
              case "iframe":
              case "object":
              case "embed":
                Ge("load", c), f = n;
                break;

              case "video":
              case "audio":
                for (f = 0; f < Kc.length; f++) {
                  Ge(Kc[f], c);
                }

                f = n;
                break;

              case "source":
                Ge("error", c), f = n;
                break;

              case "img":
              case "image":
              case "link":
                Ge("error", c), Ge("load", c), f = n;
                break;

              case "form":
                Ge("reset", c), Ge("submit", c), f = n;
                break;

              case "details":
                Ge("toggle", c), f = n;
                break;

              case "input":
                Nc(c, n), f = Ac(c, n), Ge("invalid", c), ra(a, "onChange");
                break;

              case "option":
                f = wc(c, n);
                break;

              case "select":
                c._wrapperState = {
                  wasMultiple: !!n.multiple
                }, f = t({}, n, {
                  value: void 0
                }), Ge("invalid", c), ra(a, "onChange");
                break;

              case "textarea":
                Sc(c, n), f = bc(c, n), Ge("invalid", c), ra(a, "onChange");
                break;

              default:
                f = n;
            }

            aa(r, f);
            var s = f;

            for (o in s) {
              if (s.hasOwnProperty(o)) {
                var u = s[o];
                "style" === o ? ca(c, u) : "dangerouslySetInnerHTML" === o ? null != (u = u ? u.__html : void 0) && Zc(c, u) : "children" === o ? "string" == typeof u ? ("textarea" !== r || "" !== u) && Uc(c, u) : "number" == typeof u && Uc(c, "" + u) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (g.hasOwnProperty(o) ? null != u && ra(a, o) : null != u && K(c, o, u, l));
              }
            }

            switch (r) {
              case "input":
                Cc(c), Vc(c, n, !1);
                break;

              case "textarea":
                Cc(c), Dc(c);
                break;

              case "option":
                null != n.value && c.setAttribute("value", "" + pc(n.value));
                break;

              case "select":
                c.multiple = !!n.multiple, null != (a = n.value) ? yc(c, !!n.multiple, a, !1) : null != n.defaultValue && yc(c, !!n.multiple, n.defaultValue, !0);
                break;

              default:
                "function" == typeof f.onClick && (c.onclick = ia);
            }

            za(r, n) && (e.effectTag |= 4);
          }

          null !== e.ref && (e.effectTag |= 128);
        }
        return null;

      case 6:
        if (c && null != e.stateNode) Pi(c, e, c.memoizedProps, n);else {
          if ("string" != typeof n && null === e.stateNode) throw Error(i(166));
          a = Dr(Tr.current), Dr(br.current), yi(e) ? (a = e.stateNode, n = e.memoizedProps, a[Va] = e, a.nodeValue !== n && (e.effectTag |= 4)) : ((a = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(n))[Va] = e, e.stateNode = a);
        }
        return null;

      case 13:
        return st(Or), n = e.memoizedState, 0 != (64 & e.effectTag) ? (e.expirationTime = a, e) : (a = null !== n, n = !1, null === c ? void 0 !== e.memoizedProps.fallback && yi(e) : (n = null !== (r = c.memoizedState), a || null === r || null !== (r = c.child.sibling) && (null !== (o = e.firstEffect) ? (e.firstEffect = r, r.nextEffect = o) : (e.firstEffect = e.lastEffect = r, r.nextEffect = null), r.effectTag = 8)), a && !n && 0 != (2 & e.mode) && (null === c && !0 !== e.memoizedProps.unstable_avoidThisFallback || 0 != (1 & Or.current) ? Oo === wo && (Oo = So) : (Oo !== wo && Oo !== So || (Oo = To), 0 !== Ro && null !== Eo && (Bl(Eo, Io), Rl(Eo, Ro)))), (a || n) && (e.effectTag |= 4), null);

      case 4:
        return Er(), Ri(e), null;

      case 10:
        return ar(e), null;

      case 17:
        return pt(e.type) && zt(), null;

      case 19:
        if (st(Or), null === (n = e.memoizedState)) return null;

        if (r = 0 != (64 & e.effectTag), null === (o = n.rendering)) {
          if (r) Xi(n, !1);else if (Oo !== wo || null !== c && 0 != (64 & c.effectTag)) for (o = e.child; null !== o;) {
            if (null !== (c = Qr(o))) {
              for (e.effectTag |= 64, Xi(n, !1), null !== (r = c.updateQueue) && (e.updateQueue = r, e.effectTag |= 4), null === n.lastEffect && (e.firstEffect = null), e.lastEffect = n.lastEffect, n = e.child; null !== n;) {
                o = a, (r = n).effectTag &= 2, r.nextEffect = null, r.firstEffect = null, r.lastEffect = null, null === (c = r.alternate) ? (r.childExpirationTime = 0, r.expirationTime = o, r.child = null, r.memoizedProps = null, r.memoizedState = null, r.updateQueue = null, r.dependencies = null) : (r.childExpirationTime = c.childExpirationTime, r.expirationTime = c.expirationTime, r.child = c.child, r.memoizedProps = c.memoizedProps, r.memoizedState = c.memoizedState, r.updateQueue = c.updateQueue, o = c.dependencies, r.dependencies = null === o ? null : {
                  expirationTime: o.expirationTime,
                  firstContext: o.firstContext,
                  responders: o.responders
                }), n = n.sibling;
              }

              return ut(Or, 1 & Or.current | 2), e.child;
            }

            o = o.sibling;
          }
        } else {
          if (!r) if (null !== (c = Qr(o))) {
            if (e.effectTag |= 64, r = !0, null !== (a = c.updateQueue) && (e.updateQueue = a, e.effectTag |= 4), Xi(n, !0), null === n.tail && "hidden" === n.tailMode && !o.alternate) return null !== (e = e.lastEffect = n.lastEffect) && (e.nextEffect = null), null;
          } else 2 * Bt() - n.renderingStartTime > n.tailExpiration && 1 < a && (e.effectTag |= 64, r = !0, Xi(n, !1), e.expirationTime = e.childExpirationTime = a - 1);
          n.isBackwards ? (o.sibling = e.child, e.child = o) : (null !== (a = n.last) ? a.sibling = o : e.child = o, n.last = o);
        }

        return null !== n.tail ? (0 === n.tailExpiration && (n.tailExpiration = Bt() + 500), a = n.tail, n.rendering = a, n.tail = a.sibling, n.lastEffect = e.lastEffect, n.renderingStartTime = Bt(), a.sibling = null, e = Or.current, ut(Or, r ? 1 & e | 2 : 1 & e), a) : null;
    }

    throw Error(i(156, e.tag));
  }

  function $i(c) {
    switch (c.tag) {
      case 1:
        pt(c.type) && zt();
        var e = c.effectTag;
        return 4096 & e ? (c.effectTag = -4097 & e | 64, c) : null;

      case 3:
        if (Er(), st(vt), st(mt), 0 != (64 & (e = c.effectTag))) throw Error(i(285));
        return c.effectTag = -4097 & e | 64, c;

      case 5:
        return Ir(c), null;

      case 13:
        return st(Or), 4096 & (e = c.effectTag) ? (c.effectTag = -4097 & e | 64, c) : null;

      case 19:
        return st(Or), null;

      case 4:
        return Er(), null;

      case 10:
        return ar(c), null;

      default:
        return null;
    }
  }

  function co(c, e) {
    return {
      value: c,
      source: e,
      stack: Mc(e)
    };
  }

  Bi = function Bi(c, e) {
    for (var a = e.child; null !== a;) {
      if (5 === a.tag || 6 === a.tag) c.appendChild(a.stateNode);else if (4 !== a.tag && null !== a.child) {
        a.child.return = a, a = a.child;
        continue;
      }
      if (a === e) break;

      for (; null === a.sibling;) {
        if (null === a.return || a.return === e) return;
        a = a.return;
      }

      a.sibling.return = a.return, a = a.sibling;
    }
  }, Ri = function Ri() {}, Yi = function Yi(c, e, a, n, r) {
    var i = c.memoizedProps;

    if (i !== n) {
      var o,
          l,
          f = e.stateNode;

      switch (Dr(br.current), c = null, a) {
        case "input":
          i = Ac(f, i), n = Ac(f, n), c = [];
          break;

        case "option":
          i = wc(f, i), n = wc(f, n), c = [];
          break;

        case "select":
          i = t({}, i, {
            value: void 0
          }), n = t({}, n, {
            value: void 0
          }), c = [];
          break;

        case "textarea":
          i = bc(f, i), n = bc(f, n), c = [];
          break;

        default:
          "function" != typeof i.onClick && "function" == typeof n.onClick && (f.onclick = ia);
      }

      for (o in aa(a, n), a = null, i) {
        if (!n.hasOwnProperty(o) && i.hasOwnProperty(o) && null != i[o]) if ("style" === o) for (l in f = i[o]) {
          f.hasOwnProperty(l) && (a || (a = {}), a[l] = "");
        } else "dangerouslySetInnerHTML" !== o && "children" !== o && "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (g.hasOwnProperty(o) ? c || (c = []) : (c = c || []).push(o, null));
      }

      for (o in n) {
        var s = n[o];
        if (f = null != i ? i[o] : void 0, n.hasOwnProperty(o) && s !== f && (null != s || null != f)) if ("style" === o) {
          if (f) {
            for (l in f) {
              !f.hasOwnProperty(l) || s && s.hasOwnProperty(l) || (a || (a = {}), a[l] = "");
            }

            for (l in s) {
              s.hasOwnProperty(l) && f[l] !== s[l] && (a || (a = {}), a[l] = s[l]);
            }
          } else a || (c || (c = []), c.push(o, a)), a = s;
        } else "dangerouslySetInnerHTML" === o ? (s = s ? s.__html : void 0, f = f ? f.__html : void 0, null != s && f !== s && (c = c || []).push(o, s)) : "children" === o ? f === s || "string" != typeof s && "number" != typeof s || (c = c || []).push(o, "" + s) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && (g.hasOwnProperty(o) ? (null != s && ra(r, o), c || f === s || (c = [])) : (c = c || []).push(o, s));
      }

      a && (c = c || []).push("style", a), r = c, (e.updateQueue = r) && (e.effectTag |= 4);
    }
  }, Pi = function Pi(c, e, a, n) {
    a !== n && (e.effectTag |= 4);
  };
  var eo = "function" == typeof WeakSet ? WeakSet : Set;

  function ao(c, e) {
    var a = e.source,
        n = e.stack;
    null === n && null !== a && (n = Mc(a)), null !== a && dc(a.type), e = e.value, null !== c && 1 === c.tag && dc(c.type);

    try {
      console.error(e);
    } catch (c) {
      setTimeout(function () {
        throw c;
      });
    }
  }

  function no(c) {
    var e = c.ref;
    if (null !== e) if ("function" == typeof e) try {
      e(null);
    } catch (e) {
      wl(c, e);
    } else e.current = null;
  }

  function to(c, e) {
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        return;

      case 1:
        if (256 & e.effectTag && null !== c) {
          var a = c.memoizedProps,
              n = c.memoizedState;
          e = (c = e.stateNode).getSnapshotBeforeUpdate(e.elementType === e.type ? a : Kt(e.type, a), n), c.__reactInternalSnapshotBeforeUpdate = e;
        }

        return;

      case 3:
      case 5:
      case 6:
      case 4:
      case 17:
        return;
    }

    throw Error(i(163));
  }

  function ro(c, e) {
    if (null !== (e = null !== (e = e.updateQueue) ? e.lastEffect : null)) {
      var a = e = e.next;

      do {
        if ((a.tag & c) === c) {
          var n = a.destroy;
          a.destroy = void 0, void 0 !== n && n();
        }

        a = a.next;
      } while (a !== e);
    }
  }

  function io(c, e) {
    if (null !== (e = null !== (e = e.updateQueue) ? e.lastEffect : null)) {
      var a = e = e.next;

      do {
        if ((a.tag & c) === c) {
          var n = a.create;
          a.destroy = n();
        }

        a = a.next;
      } while (a !== e);
    }
  }

  function oo(c, e, a) {
    switch (a.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        return void io(3, a);

      case 1:
        if (c = a.stateNode, 4 & a.effectTag) if (null === e) c.componentDidMount();else {
          var n = a.elementType === a.type ? e.memoizedProps : Kt(a.type, e.memoizedProps);
          c.componentDidUpdate(n, e.memoizedState, c.__reactInternalSnapshotBeforeUpdate);
        }
        return void (null !== (e = a.updateQueue) && mr(a, e, c));

      case 3:
        if (null !== (e = a.updateQueue)) {
          if (c = null, null !== a.child) switch (a.child.tag) {
            case 5:
              c = a.child.stateNode;
              break;

            case 1:
              c = a.child.stateNode;
          }
          mr(a, e, c);
        }

        return;

      case 5:
        return c = a.stateNode, void (null === e && 4 & a.effectTag && za(a.type, a.memoizedProps) && c.focus());

      case 6:
      case 4:
      case 12:
        return;

      case 13:
        return void (null === a.memoizedState && (a = a.alternate, null !== a && (a = a.memoizedState, null !== a && (a = a.dehydrated, null !== a && Ie(a)))));

      case 19:
      case 17:
      case 20:
      case 21:
        return;
    }

    throw Error(i(163));
  }

  function lo(c, e, a) {
    switch ("function" == typeof Sl && Sl(e), e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        if (null !== (c = e.updateQueue) && null !== (c = c.lastEffect)) {
          var n = c.next;
          Pt(97 < a ? 97 : a, function () {
            var c = n;

            do {
              var a = c.destroy;

              if (void 0 !== a) {
                var t = e;

                try {
                  a();
                } catch (c) {
                  wl(t, c);
                }
              }

              c = c.next;
            } while (c !== n);
          });
        }

        break;

      case 1:
        no(e), "function" == typeof (a = e.stateNode).componentWillUnmount && function (c, e) {
          try {
            e.props = c.memoizedProps, e.state = c.memoizedState, e.componentWillUnmount();
          } catch (e) {
            wl(c, e);
          }
        }(e, a);
        break;

      case 5:
        no(e);
        break;

      case 4:
        ho(c, e, a);
    }
  }

  function fo(c) {
    var e = c.alternate;
    c.return = null, c.child = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.alternate = null, c.firstEffect = null, c.lastEffect = null, c.pendingProps = null, c.memoizedProps = null, c.stateNode = null, null !== e && fo(e);
  }

  function so(c) {
    return 5 === c.tag || 3 === c.tag || 4 === c.tag;
  }

  function uo(c) {
    c: {
      for (var e = c.return; null !== e;) {
        if (so(e)) {
          var a = e;
          break c;
        }

        e = e.return;
      }

      throw Error(i(160));
    }

    switch (e = a.stateNode, a.tag) {
      case 5:
        var n = !1;
        break;

      case 3:
      case 4:
        e = e.containerInfo, n = !0;
        break;

      default:
        throw Error(i(161));
    }

    16 & a.effectTag && (Uc(e, ""), a.effectTag &= -17);

    c: e: for (a = c;;) {
      for (; null === a.sibling;) {
        if (null === a.return || so(a.return)) {
          a = null;
          break c;
        }

        a = a.return;
      }

      for (a.sibling.return = a.return, a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;) {
        if (2 & a.effectTag) continue e;
        if (null === a.child || 4 === a.tag) continue e;
        a.child.return = a, a = a.child;
      }

      if (!(2 & a.effectTag)) {
        a = a.stateNode;
        break c;
      }
    }

    n ? function c(e, a, n) {
      var t = e.tag,
          r = 5 === t || 6 === t;
      if (r) e = r ? e.stateNode : e.stateNode.instance, a ? 8 === n.nodeType ? n.parentNode.insertBefore(e, a) : n.insertBefore(e, a) : (8 === n.nodeType ? (a = n.parentNode, a.insertBefore(e, n)) : (a = n, a.appendChild(e)), n = n._reactRootContainer, null != n || null !== a.onclick || (a.onclick = ia));else if (4 !== t && (e = e.child, null !== e)) for (c(e, a, n), e = e.sibling; null !== e;) {
        c(e, a, n), e = e.sibling;
      }
    }(c, a, e) : function c(e, a, n) {
      var t = e.tag,
          r = 5 === t || 6 === t;
      if (r) e = r ? e.stateNode : e.stateNode.instance, a ? n.insertBefore(e, a) : n.appendChild(e);else if (4 !== t && (e = e.child, null !== e)) for (c(e, a, n), e = e.sibling; null !== e;) {
        c(e, a, n), e = e.sibling;
      }
    }(c, a, e);
  }

  function ho(c, e, a) {
    for (var n, t, r = e, o = !1;;) {
      if (!o) {
        o = r.return;

        c: for (;;) {
          if (null === o) throw Error(i(160));

          switch (n = o.stateNode, o.tag) {
            case 5:
              t = !1;
              break c;

            case 3:
            case 4:
              n = n.containerInfo, t = !0;
              break c;
          }

          o = o.return;
        }

        o = !0;
      }

      if (5 === r.tag || 6 === r.tag) {
        c: for (var l = c, f = r, s = a, u = f;;) {
          if (lo(l, u, s), null !== u.child && 4 !== u.tag) u.child.return = u, u = u.child;else {
            if (u === f) break c;

            for (; null === u.sibling;) {
              if (null === u.return || u.return === f) break c;
              u = u.return;
            }

            u.sibling.return = u.return, u = u.sibling;
          }
        }

        t ? (l = n, f = r.stateNode, 8 === l.nodeType ? l.parentNode.removeChild(f) : l.removeChild(f)) : n.removeChild(r.stateNode);
      } else if (4 === r.tag) {
        if (null !== r.child) {
          n = r.stateNode.containerInfo, t = !0, r.child.return = r, r = r.child;
          continue;
        }
      } else if (lo(c, r, a), null !== r.child) {
        r.child.return = r, r = r.child;
        continue;
      }

      if (r === e) break;

      for (; null === r.sibling;) {
        if (null === r.return || r.return === e) return;
        4 === (r = r.return).tag && (o = !1);
      }

      r.sibling.return = r.return, r = r.sibling;
    }
  }

  function mo(c, e) {
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        return void ro(3, e);

      case 1:
        return;

      case 5:
        var a = e.stateNode;

        if (null != a) {
          var n = e.memoizedProps,
              t = null !== c ? c.memoizedProps : n;
          c = e.type;
          var r = e.updateQueue;

          if (e.updateQueue = null, null !== r) {
            for (a[xa] = n, "input" === c && "radio" === n.type && null != n.name && gc(a, n), na(c, t), e = na(c, n), t = 0; t < r.length; t += 2) {
              var o = r[t],
                  l = r[t + 1];
              "style" === o ? ca(a, l) : "dangerouslySetInnerHTML" === o ? Zc(a, l) : "children" === o ? Uc(a, l) : K(a, o, l, e);
            }

            switch (c) {
              case "input":
                Hc(a, n);
                break;

              case "textarea":
                Tc(a, n);
                break;

              case "select":
                e = a._wrapperState.wasMultiple, a._wrapperState.wasMultiple = !!n.multiple, null != (c = n.value) ? yc(a, !!n.multiple, c, !1) : e !== !!n.multiple && (null != n.defaultValue ? yc(a, !!n.multiple, n.defaultValue, !0) : yc(a, !!n.multiple, n.multiple ? [] : "", !1));
            }
          }
        }

        return;

      case 6:
        if (null === e.stateNode) throw Error(i(162));
        return void (e.stateNode.nodeValue = e.memoizedProps);

      case 3:
        return void ((e = e.stateNode).hydrate && (e.hydrate = !1, Ie(e.containerInfo)));

      case 12:
        return;

      case 13:
        if (a = e, null === e.memoizedState ? n = !1 : (n = !0, a = e.child, Po = Bt()), null !== a) c: for (c = a;;) {
          if (5 === c.tag) r = c.stateNode, n ? "function" == typeof (r = r.style).setProperty ? r.setProperty("display", "none", "important") : r.display = "none" : (r = c.stateNode, t = null != (t = c.memoizedProps.style) && t.hasOwnProperty("display") ? t.display : null, r.style.display = $e("display", t));else if (6 === c.tag) c.stateNode.nodeValue = n ? "" : c.memoizedProps;else {
            if (13 === c.tag && null !== c.memoizedState && null === c.memoizedState.dehydrated) {
              (r = c.child.sibling).return = c, c = r;
              continue;
            }

            if (null !== c.child) {
              c.child.return = c, c = c.child;
              continue;
            }
          }
          if (c === a) break;

          for (; null === c.sibling;) {
            if (null === c.return || c.return === a) break c;
            c = c.return;
          }

          c.sibling.return = c.return, c = c.sibling;
        }
        return void vo(e);

      case 19:
        return void vo(e);

      case 17:
        return;
    }

    throw Error(i(163));
  }

  function vo(c) {
    var e = c.updateQueue;

    if (null !== e) {
      c.updateQueue = null;
      var a = c.stateNode;
      null === a && (a = c.stateNode = new eo()), e.forEach(function (e) {
        var n = function (c, e) {
          var a = c.stateNode;
          null !== a && a.delete(e), 0 == (e = 0) && (e = tl(e = nl(), c, null)), null !== (c = il(c, e)) && ll(c);
        }.bind(null, c, e);

        a.has(e) || (a.add(e), e.then(n, n));
      });
    }
  }

  var Mo = "function" == typeof WeakMap ? WeakMap : Map;

  function po(c, e, a) {
    (a = fr(a, null)).tag = 3, a.payload = {
      element: null
    };
    var n = e.value;
    return a.callback = function () {
      Go || (Go = !0, qo = n), ao(c, e);
    }, a;
  }

  function zo(c, e, a) {
    (a = fr(a, null)).tag = 3;
    var n = c.type.getDerivedStateFromError;

    if ("function" == typeof n) {
      var t = e.value;

      a.payload = function () {
        return ao(c, e), n(t);
      };
    }

    var r = c.stateNode;
    return null !== r && "function" == typeof r.componentDidCatch && (a.callback = function () {
      "function" != typeof n && (null === Jo ? Jo = new Set([this]) : Jo.add(this), ao(c, e));
      var a = e.stack;
      this.componentDidCatch(e.value, {
        componentStack: null !== a ? a : ""
      });
    }), a;
  }

  var Co,
      Lo = Math.ceil,
      Ao = J.ReactCurrentDispatcher,
      No = J.ReactCurrentOwner,
      go = 0,
      Ho = 8,
      Vo = 16,
      xo = 32,
      wo = 0,
      yo = 1,
      bo = 2,
      So = 3,
      To = 4,
      Do = 5,
      jo = go,
      Eo = null,
      ko = null,
      Io = 0,
      Oo = wo,
      Qo = null,
      Zo = 1073741823,
      Uo = 1073741823,
      Bo = null,
      Ro = 0,
      Yo = !1,
      Po = 0,
      Fo = 500,
      Wo = null,
      Go = !1,
      qo = null,
      Jo = null,
      Ko = !1,
      Xo = null,
      _o = 90,
      $o = null,
      cl = 0,
      el = null,
      al = 0;

  function nl() {
    return (jo & (Vo | xo)) !== go ? 1073741821 - (Bt() / 10 | 0) : 0 !== al ? al : al = 1073741821 - (Bt() / 10 | 0);
  }

  function tl(c, e, a) {
    if (0 == (2 & (e = e.mode))) return 1073741823;
    var n = Rt();
    if (0 == (4 & e)) return 99 === n ? 1073741823 : 1073741822;
    if ((jo & Vo) !== go) return Io;
    if (null !== a) c = Jt(c, 0 | a.timeoutMs || 5e3, 250);else switch (n) {
      case 99:
        c = 1073741823;
        break;

      case 98:
        c = Jt(c, 150, 100);
        break;

      case 97:
      case 96:
        c = Jt(c, 5e3, 250);
        break;

      case 95:
        c = 2;
        break;

      default:
        throw Error(i(326));
    }
    return null !== Eo && c === Io && --c, c;
  }

  function rl(c, e) {
    if (50 < cl) throw cl = 0, el = null, Error(i(185));

    if (null !== (c = il(c, e))) {
      var a = Rt();
      1073741823 === e ? (jo & Ho) !== go && (jo & (Vo | xo)) === go ? fl(c) : (ll(c), jo === go && Gt()) : ll(c), (4 & jo) === go || 98 !== a && 99 !== a || (null === $o ? $o = new Map([[c, e]]) : (void 0 === (a = $o.get(c)) || a > e) && $o.set(c, e));
    }
  }

  function il(c, e) {
    c.expirationTime < e && (c.expirationTime = e);
    var a = c.alternate;
    null !== a && a.expirationTime < e && (a.expirationTime = e);
    var n = c.return,
        t = null;
    if (null === n && 3 === c.tag) t = c.stateNode;else for (; null !== n;) {
      if (a = n.alternate, n.childExpirationTime < e && (n.childExpirationTime = e), null !== a && a.childExpirationTime < e && (a.childExpirationTime = e), null === n.return && 3 === n.tag) {
        t = n.stateNode;
        break;
      }

      n = n.return;
    }
    return null !== t && (Eo === t && (Ml(e), Oo === To && Bl(t, Io)), Rl(t, e)), t;
  }

  function ol(c) {
    var e = c.lastExpiredTime;
    if (0 !== e) return e;
    if (!Ul(c, e = c.firstPendingTime)) return e;
    var a = c.lastPingedTime;
    return 2 >= (c = a > (c = c.nextKnownPendingLevel) ? a : c) && e !== c ? 0 : c;
  }

  function ll(c) {
    if (0 !== c.lastExpiredTime) c.callbackExpirationTime = 1073741823, c.callbackPriority = 99, c.callbackNode = Wt(fl.bind(null, c));else {
      var e = ol(c),
          a = c.callbackNode;
      if (0 === e) null !== a && (c.callbackNode = null, c.callbackExpirationTime = 0, c.callbackPriority = 90);else {
        var n = nl();

        if (1073741823 === e ? n = 99 : 1 === e || 2 === e ? n = 95 : n = 0 >= (n = 10 * (1073741821 - e) - 10 * (1073741821 - n)) ? 99 : 250 >= n ? 98 : 5250 >= n ? 97 : 95, null !== a) {
          var t = c.callbackPriority;
          if (c.callbackExpirationTime === e && t >= n) return;
          a !== Et && Vt(a);
        }

        c.callbackExpirationTime = e, c.callbackPriority = n, e = 1073741823 === e ? Wt(fl.bind(null, c)) : Ft(n, function c(e, a) {
          al = 0;
          if (a) return a = nl(), Yl(e, a), ll(e), null;
          var n = ol(e);

          if (0 !== n) {
            if (a = e.callbackNode, (jo & (Vo | xo)) !== go) throw Error(i(327));

            if (Hl(), e === Eo && n === Io || hl(e, n), null !== ko) {
              var t = jo;
              jo |= Vo;

              for (var r = vl();;) {
                try {
                  zl();
                  break;
                } catch (c) {
                  ml(e, c);
                }
              }

              if (er(), jo = t, Ao.current = r, Oo === yo) throw a = Qo, hl(e, n), Bl(e, n), ll(e), a;
              if (null === ko) switch (r = e.finishedWork = e.current.alternate, e.finishedExpirationTime = n, t = Oo, Eo = null, t) {
                case wo:
                case yo:
                  throw Error(i(345));

                case bo:
                  Yl(e, 2 < n ? 2 : n);
                  break;

                case So:
                  if (Bl(e, n), t = e.lastSuspendedTime, n === t && (e.nextKnownPendingLevel = Al(r)), 1073741823 === Zo && 10 < (r = Po + Fo - Bt())) {
                    if (Yo) {
                      var o = e.lastPingedTime;

                      if (0 === o || o >= n) {
                        e.lastPingedTime = n, hl(e, n);
                        break;
                      }
                    }

                    if (0 !== (o = ol(e)) && o !== n) break;

                    if (0 !== t && t !== n) {
                      e.lastPingedTime = t;
                      break;
                    }

                    e.timeoutHandle = La(Nl.bind(null, e), r);
                    break;
                  }

                  Nl(e);
                  break;

                case To:
                  if (Bl(e, n), t = e.lastSuspendedTime, n === t && (e.nextKnownPendingLevel = Al(r)), Yo && (0 === (r = e.lastPingedTime) || r >= n)) {
                    e.lastPingedTime = n, hl(e, n);
                    break;
                  }

                  if (0 !== (r = ol(e)) && r !== n) break;

                  if (0 !== t && t !== n) {
                    e.lastPingedTime = t;
                    break;
                  }

                  if (1073741823 !== Uo ? t = 10 * (1073741821 - Uo) - Bt() : 1073741823 === Zo ? t = 0 : (t = 10 * (1073741821 - Zo) - 5e3, r = Bt(), n = 10 * (1073741821 - n) - r, 0 > (t = r - t) && (t = 0), t = (120 > t ? 120 : 480 > t ? 480 : 1080 > t ? 1080 : 1920 > t ? 1920 : 3e3 > t ? 3e3 : 4320 > t ? 4320 : 1960 * Lo(t / 1960)) - t, n < t && (t = n)), 10 < t) {
                    e.timeoutHandle = La(Nl.bind(null, e), t);
                    break;
                  }

                  Nl(e);
                  break;

                case Do:
                  if (1073741823 !== Zo && null !== Bo) {
                    o = Zo;
                    var l = Bo;

                    if (0 >= (t = 0 | l.busyMinDurationMs) ? t = 0 : (r = 0 | l.busyDelayMs, o = Bt() - (10 * (1073741821 - o) - (0 | l.timeoutMs || 5e3)), t = o <= r ? 0 : r + t - o), 10 < t) {
                      Bl(e, n), e.timeoutHandle = La(Nl.bind(null, e), t);
                      break;
                    }
                  }

                  Nl(e);
                  break;

                default:
                  throw Error(i(329));
              }
              if (ll(e), e.callbackNode === a) return c.bind(null, e);
            }
          }

          return null;
        }.bind(null, c), {
          timeout: 10 * (1073741821 - e) - Bt()
        }), c.callbackNode = e;
      }
    }
  }

  function fl(c) {
    var e = c.lastExpiredTime;
    if (e = 0 !== e ? e : 1073741823, (jo & (Vo | xo)) !== go) throw Error(i(327));

    if (Hl(), c === Eo && e === Io || hl(c, e), null !== ko) {
      var a = jo;
      jo |= Vo;

      for (var n = vl();;) {
        try {
          pl();
          break;
        } catch (e) {
          ml(c, e);
        }
      }

      if (er(), jo = a, Ao.current = n, Oo === yo) throw a = Qo, hl(c, e), Bl(c, e), ll(c), a;
      if (null !== ko) throw Error(i(261));
      c.finishedWork = c.current.alternate, c.finishedExpirationTime = e, Eo = null, Nl(c), ll(c);
    }

    return null;
  }

  function sl(c, e) {
    var a = jo;
    jo |= 1;

    try {
      return c(e);
    } finally {
      (jo = a) === go && Gt();
    }
  }

  function ul(c, e) {
    var a = jo;
    jo &= -2, jo |= Ho;

    try {
      return c(e);
    } finally {
      (jo = a) === go && Gt();
    }
  }

  function hl(c, e) {
    c.finishedWork = null, c.finishedExpirationTime = 0;
    var a = c.timeoutHandle;
    if (-1 !== a && (c.timeoutHandle = -1, Aa(a)), null !== ko) for (a = ko.return; null !== a;) {
      var n = a;

      switch (n.tag) {
        case 1:
          null != (n = n.type.childContextTypes) && zt();
          break;

        case 3:
          Er(), st(vt), st(mt);
          break;

        case 5:
          Ir(n);
          break;

        case 4:
          Er();
          break;

        case 13:
        case 19:
          st(Or);
          break;

        case 10:
          ar(n);
      }

      a = a.return;
    }
    Eo = c, ko = El(c.current, null), Io = e, Oo = wo, Qo = null, Uo = Zo = 1073741823, Bo = null, Ro = 0, Yo = !1;
  }

  function ml(c, e) {
    for (;;) {
      try {
        if (er(), Ur.current = pi, Wr) for (var a = Yr.memoizedState; null !== a;) {
          var n = a.queue;
          null !== n && (n.pending = null), a = a.next;
        }
        if (Rr = 0, Fr = Pr = Yr = null, Wr = !1, null === ko || null === ko.return) return Oo = yo, Qo = e, ko = null;

        c: {
          var t = c,
              r = ko.return,
              i = ko,
              o = e;

          if (e = Io, i.effectTag |= 2048, i.firstEffect = i.lastEffect = null, null !== o && "object" == typeof o && "function" == typeof o.then) {
            var l = o;

            if (0 == (2 & i.mode)) {
              var f = i.alternate;
              f ? (i.updateQueue = f.updateQueue, i.memoizedState = f.memoizedState, i.expirationTime = f.expirationTime) : (i.updateQueue = null, i.memoizedState = null);
            }

            var s = 0 != (1 & Or.current),
                u = r;

            do {
              var h;

              if (h = 13 === u.tag) {
                var m = u.memoizedState;
                if (null !== m) h = null !== m.dehydrated;else {
                  var v = u.memoizedProps;
                  h = void 0 !== v.fallback && (!0 !== v.unstable_avoidThisFallback || !s);
                }
              }

              if (h) {
                var d = u.updateQueue;

                if (null === d) {
                  var M = new Set();
                  M.add(l), u.updateQueue = M;
                } else d.add(l);

                if (0 == (2 & u.mode)) {
                  if (u.effectTag |= 64, i.effectTag &= -2981, 1 === i.tag) if (null === i.alternate) i.tag = 17;else {
                    var p = fr(1073741823, null);
                    p.tag = 2, sr(i, p);
                  }
                  i.expirationTime = 1073741823;
                  break c;
                }

                o = void 0, i = e;
                var z = t.pingCache;

                if (null === z ? (z = t.pingCache = new Mo(), o = new Set(), z.set(l, o)) : void 0 === (o = z.get(l)) && (o = new Set(), z.set(l, o)), !o.has(i)) {
                  o.add(i);
                  var C = yl.bind(null, t, l, i);
                  l.then(C, C);
                }

                u.effectTag |= 4096, u.expirationTime = e;
                break c;
              }

              u = u.return;
            } while (null !== u);

            o = Error((dc(i.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + Mc(i));
          }

          Oo !== Do && (Oo = bo), o = co(o, i), u = r;

          do {
            switch (u.tag) {
              case 3:
                l = o, u.effectTag |= 4096, u.expirationTime = e, ur(u, po(u, l, e));
                break c;

              case 1:
                l = o;
                var L = u.type,
                    A = u.stateNode;

                if (0 == (64 & u.effectTag) && ("function" == typeof L.getDerivedStateFromError || null !== A && "function" == typeof A.componentDidCatch && (null === Jo || !Jo.has(A)))) {
                  u.effectTag |= 4096, u.expirationTime = e, ur(u, zo(u, l, e));
                  break c;
                }

            }

            u = u.return;
          } while (null !== u);
        }

        ko = Ll(ko);
      } catch (c) {
        e = c;
        continue;
      }

      break;
    }
  }

  function vl() {
    var c = Ao.current;
    return Ao.current = pi, null === c ? pi : c;
  }

  function dl(c, e) {
    c < Zo && 2 < c && (Zo = c), null !== e && c < Uo && 2 < c && (Uo = c, Bo = e);
  }

  function Ml(c) {
    c > Ro && (Ro = c);
  }

  function pl() {
    for (; null !== ko;) {
      ko = Cl(ko);
    }
  }

  function zl() {
    for (; null !== ko && !kt();) {
      ko = Cl(ko);
    }
  }

  function Cl(c) {
    var e = Co(c.alternate, c, Io);
    return c.memoizedProps = c.pendingProps, null === e && (e = Ll(c)), No.current = null, e;
  }

  function Ll(c) {
    ko = c;

    do {
      var e = ko.alternate;

      if (c = ko.return, 0 == (2048 & ko.effectTag)) {
        if (e = _i(e, ko, Io), 1 === Io || 1 !== ko.childExpirationTime) {
          for (var a = 0, n = ko.child; null !== n;) {
            var t = n.expirationTime,
                r = n.childExpirationTime;
            t > a && (a = t), r > a && (a = r), n = n.sibling;
          }

          ko.childExpirationTime = a;
        }

        if (null !== e) return e;
        null !== c && 0 == (2048 & c.effectTag) && (null === c.firstEffect && (c.firstEffect = ko.firstEffect), null !== ko.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = ko.firstEffect), c.lastEffect = ko.lastEffect), 1 < ko.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = ko : c.firstEffect = ko, c.lastEffect = ko));
      } else {
        if (null !== (e = $i(ko))) return e.effectTag &= 2047, e;
        null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 2048);
      }

      if (null !== (e = ko.sibling)) return e;
      ko = c;
    } while (null !== ko);

    return Oo === wo && (Oo = Do), null;
  }

  function Al(c) {
    var e = c.expirationTime;
    return e > (c = c.childExpirationTime) ? e : c;
  }

  function Nl(c) {
    var e = Rt();
    return Pt(99, function (c, e) {
      do {
        Hl();
      } while (null !== Xo);

      if ((jo & (Vo | xo)) !== go) throw Error(i(327));
      var a = c.finishedWork,
          n = c.finishedExpirationTime;
      if (null === a) return null;
      if (c.finishedWork = null, c.finishedExpirationTime = 0, a === c.current) throw Error(i(177));
      c.callbackNode = null, c.callbackExpirationTime = 0, c.callbackPriority = 90, c.nextKnownPendingLevel = 0;
      var t = Al(a);

      if (c.firstPendingTime = t, n <= c.lastSuspendedTime ? c.firstSuspendedTime = c.lastSuspendedTime = c.nextKnownPendingLevel = 0 : n <= c.firstSuspendedTime && (c.firstSuspendedTime = n - 1), n <= c.lastPingedTime && (c.lastPingedTime = 0), n <= c.lastExpiredTime && (c.lastExpiredTime = 0), c === Eo && (ko = Eo = null, Io = 0), 1 < a.effectTag ? null !== a.lastEffect ? (a.lastEffect.nextEffect = a, t = a.firstEffect) : t = a : t = a.firstEffect, null !== t) {
        var r = jo;
        jo |= xo, No.current = null, Ma = We;
        var o = sa();

        if (ua(o)) {
          if ("selectionStart" in o) var l = {
            start: o.selectionStart,
            end: o.selectionEnd
          };else c: {
            var f = (l = (l = o.ownerDocument) && l.defaultView || window).getSelection && l.getSelection();

            if (f && 0 !== f.rangeCount) {
              l = f.anchorNode;
              var s = f.anchorOffset,
                  u = f.focusNode;
              f = f.focusOffset;

              try {
                l.nodeType, u.nodeType;
              } catch (c) {
                l = null;
                break c;
              }

              var h = 0,
                  m = -1,
                  v = -1,
                  d = 0,
                  M = 0,
                  p = o,
                  z = null;

              e: for (;;) {
                for (var C; p !== l || 0 !== s && 3 !== p.nodeType || (m = h + s), p !== u || 0 !== f && 3 !== p.nodeType || (v = h + f), 3 === p.nodeType && (h += p.nodeValue.length), null !== (C = p.firstChild);) {
                  z = p, p = C;
                }

                for (;;) {
                  if (p === o) break e;
                  if (z === l && ++d === s && (m = h), z === u && ++M === f && (v = h), null !== (C = p.nextSibling)) break;
                  z = (p = z).parentNode;
                }

                p = C;
              }

              l = -1 === m || -1 === v ? null : {
                start: m,
                end: v
              };
            } else l = null;
          }
          l = l || {
            start: 0,
            end: 0
          };
        } else l = null;

        pa = {
          activeElementDetached: null,
          focusedElem: o,
          selectionRange: l
        }, We = !1, Wo = t;

        do {
          try {
            gl();
          } catch (c) {
            if (null === Wo) throw Error(i(330));
            wl(Wo, c), Wo = Wo.nextEffect;
          }
        } while (null !== Wo);

        Wo = t;

        do {
          try {
            for (o = c, l = e; null !== Wo;) {
              var L = Wo.effectTag;

              if (16 & L && Uc(Wo.stateNode, ""), 128 & L) {
                var A = Wo.alternate;

                if (null !== A) {
                  var N = A.ref;
                  null !== N && ("function" == typeof N ? N(null) : N.current = null);
                }
              }

              switch (1038 & L) {
                case 2:
                  uo(Wo), Wo.effectTag &= -3;
                  break;

                case 6:
                  uo(Wo), Wo.effectTag &= -3, mo(Wo.alternate, Wo);
                  break;

                case 1024:
                  Wo.effectTag &= -1025;
                  break;

                case 1028:
                  Wo.effectTag &= -1025, mo(Wo.alternate, Wo);
                  break;

                case 4:
                  mo(Wo.alternate, Wo);
                  break;

                case 8:
                  ho(o, s = Wo, l), fo(s);
              }

              Wo = Wo.nextEffect;
            }
          } catch (c) {
            if (null === Wo) throw Error(i(330));
            wl(Wo, c), Wo = Wo.nextEffect;
          }
        } while (null !== Wo);

        if (N = pa, A = sa(), L = N.focusedElem, l = N.selectionRange, A !== L && L && L.ownerDocument && function c(e, a) {
          return !(!e || !a) && (e === a || (!e || 3 !== e.nodeType) && (a && 3 === a.nodeType ? c(e, a.parentNode) : "contains" in e ? e.contains(a) : !!e.compareDocumentPosition && !!(16 & e.compareDocumentPosition(a))));
        }(L.ownerDocument.documentElement, L)) {
          null !== l && ua(L) && (A = l.start, void 0 === (N = l.end) && (N = A), "selectionStart" in L ? (L.selectionStart = A, L.selectionEnd = Math.min(N, L.value.length)) : (N = (A = L.ownerDocument || document) && A.defaultView || window).getSelection && (N = N.getSelection(), s = L.textContent.length, o = Math.min(l.start, s), l = void 0 === l.end ? o : Math.min(l.end, s), !N.extend && o > l && (s = l, l = o, o = s), s = fa(L, o), u = fa(L, l), s && u && (1 !== N.rangeCount || N.anchorNode !== s.node || N.anchorOffset !== s.offset || N.focusNode !== u.node || N.focusOffset !== u.offset) && ((A = A.createRange()).setStart(s.node, s.offset), N.removeAllRanges(), o > l ? (N.addRange(A), N.extend(u.node, u.offset)) : (A.setEnd(u.node, u.offset), N.addRange(A))))), A = [];

          for (N = L; N = N.parentNode;) {
            1 === N.nodeType && A.push({
              element: N,
              left: N.scrollLeft,
              top: N.scrollTop
            });
          }

          for ("function" == typeof L.focus && L.focus(), L = 0; L < A.length; L++) {
            (N = A[L]).element.scrollLeft = N.left, N.element.scrollTop = N.top;
          }
        }

        We = !!Ma, pa = Ma = null, c.current = a, Wo = t;

        do {
          try {
            for (L = c; null !== Wo;) {
              var g = Wo.effectTag;

              if (36 & g && oo(L, Wo.alternate, Wo), 128 & g) {
                A = void 0;
                var H = Wo.ref;

                if (null !== H) {
                  var V = Wo.stateNode;

                  switch (Wo.tag) {
                    case 5:
                      A = V;
                      break;

                    default:
                      A = V;
                  }

                  "function" == typeof H ? H(A) : H.current = A;
                }
              }

              Wo = Wo.nextEffect;
            }
          } catch (c) {
            if (null === Wo) throw Error(i(330));
            wl(Wo, c), Wo = Wo.nextEffect;
          }
        } while (null !== Wo);

        Wo = null, It(), jo = r;
      } else c.current = a;

      if (Ko) Ko = !1, Xo = c, _o = e;else for (Wo = t; null !== Wo;) {
        e = Wo.nextEffect, Wo.nextEffect = null, Wo = e;
      }
      if (0 === (e = c.firstPendingTime) && (Jo = null), 1073741823 === e ? c === el ? cl++ : (cl = 0, el = c) : cl = 0, "function" == typeof bl && bl(a.stateNode, n), ll(c), Go) throw Go = !1, c = qo, qo = null, c;
      return (jo & Ho) !== go ? null : (Gt(), null);
    }.bind(null, c, e)), null;
  }

  function gl() {
    for (; null !== Wo;) {
      var c = Wo.effectTag;
      0 != (256 & c) && to(Wo.alternate, Wo), 0 == (512 & c) || Ko || (Ko = !0, Ft(97, function () {
        return Hl(), null;
      })), Wo = Wo.nextEffect;
    }
  }

  function Hl() {
    if (90 !== _o) {
      var c = 97 < _o ? 97 : _o;
      return _o = 90, Pt(c, Vl);
    }
  }

  function Vl() {
    if (null === Xo) return !1;
    var c = Xo;
    if (Xo = null, (jo & (Vo | xo)) !== go) throw Error(i(331));
    var e = jo;

    for (jo |= xo, c = c.current.firstEffect; null !== c;) {
      try {
        var a = c;
        if (0 != (512 & a.effectTag)) switch (a.tag) {
          case 0:
          case 11:
          case 15:
          case 22:
            ro(5, a), io(5, a);
        }
      } catch (e) {
        if (null === c) throw Error(i(330));
        wl(c, e);
      }

      a = c.nextEffect, c.nextEffect = null, c = a;
    }

    return jo = e, Gt(), !0;
  }

  function xl(c, e, a) {
    sr(c, e = po(c, e = co(a, e), 1073741823)), null !== (c = il(c, 1073741823)) && ll(c);
  }

  function wl(c, e) {
    if (3 === c.tag) xl(c, c, e);else for (var a = c.return; null !== a;) {
      if (3 === a.tag) {
        xl(a, c, e);
        break;
      }

      if (1 === a.tag) {
        var n = a.stateNode;

        if ("function" == typeof a.type.getDerivedStateFromError || "function" == typeof n.componentDidCatch && (null === Jo || !Jo.has(n))) {
          sr(a, c = zo(a, c = co(e, c), 1073741823)), null !== (a = il(a, 1073741823)) && ll(a);
          break;
        }
      }

      a = a.return;
    }
  }

  function yl(c, e, a) {
    var n = c.pingCache;
    null !== n && n.delete(e), Eo === c && Io === a ? Oo === To || Oo === So && 1073741823 === Zo && Bt() - Po < Fo ? hl(c, Io) : Yo = !0 : Ul(c, a) && (0 !== (e = c.lastPingedTime) && e < a || (c.lastPingedTime = a, ll(c)));
  }

  Co = function Co(c, e, a) {
    var n = e.expirationTime;

    if (null !== c) {
      var t = e.pendingProps;
      if (c.memoizedProps !== t || vt.current) Ti = !0;else {
        if (n < a) {
          switch (Ti = !1, e.tag) {
            case 3:
              Ui(e), bi();
              break;

            case 5:
              if (kr(e), 4 & e.mode && 1 !== a && t.hidden) return e.expirationTime = e.childExpirationTime = 1, null;
              break;

            case 1:
              pt(e.type) && At(e);
              break;

            case 4:
              jr(e, e.stateNode.containerInfo);
              break;

            case 10:
              n = e.memoizedProps.value, t = e.type._context, ut(Xt, t._currentValue), t._currentValue = n;
              break;

            case 13:
              if (null !== e.memoizedState) return 0 !== (n = e.child.childExpirationTime) && n >= a ? Wi(c, e, a) : (ut(Or, 1 & Or.current), null !== (e = Ki(c, e, a)) ? e.sibling : null);
              ut(Or, 1 & Or.current);
              break;

            case 19:
              if (n = e.childExpirationTime >= a, 0 != (64 & c.effectTag)) {
                if (n) return Ji(c, e, a);
                e.effectTag |= 64;
              }

              if (null !== (t = e.memoizedState) && (t.rendering = null, t.tail = null), ut(Or, Or.current), !n) return null;
          }

          return Ki(c, e, a);
        }

        Ti = !1;
      }
    } else Ti = !1;

    switch (e.expirationTime = 0, e.tag) {
      case 2:
        if (n = e.type, null !== c && (c.alternate = null, e.alternate = null, e.effectTag |= 2), c = e.pendingProps, t = Mt(e, mt.current), tr(e, a), t = Jr(null, e, n, c, t, a), e.effectTag |= 1, "object" == typeof t && null !== t && "function" == typeof t.render && void 0 === t.$$typeof) {
          if (e.tag = 1, e.memoizedState = null, e.updateQueue = null, pt(n)) {
            var r = !0;
            At(e);
          } else r = !1;

          e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, or(e);
          var o = n.getDerivedStateFromProps;
          "function" == typeof o && Mr(e, n, o, c), t.updater = pr, e.stateNode = t, t._reactInternalFiber = e, Ar(e, n, c, a), e = Zi(null, e, n, !0, r, a);
        } else e.tag = 0, Di(null, e, t, a), e = e.child;

        return e;

      case 16:
        c: {
          if (t = e.elementType, null !== c && (c.alternate = null, e.alternate = null, e.effectTag |= 2), c = e.pendingProps, function (c) {
            if (-1 === c._status) {
              c._status = 0;
              var e = c._ctor;
              e = e(), c._result = e, e.then(function (e) {
                0 === c._status && (e = e.default, c._status = 1, c._result = e);
              }, function (e) {
                0 === c._status && (c._status = 2, c._result = e);
              });
            }
          }(t), 1 !== t._status) throw t._result;

          switch (t = t._result, e.type = t, r = e.tag = function (c) {
            if ("function" == typeof c) return jl(c) ? 1 : 0;

            if (null != c) {
              if ((c = c.$$typeof) === oc) return 11;
              if (c === sc) return 14;
            }

            return 2;
          }(t), c = Kt(t, c), r) {
            case 0:
              e = Oi(null, e, t, c, a);
              break c;

            case 1:
              e = Qi(null, e, t, c, a);
              break c;

            case 11:
              e = ji(null, e, t, c, a);
              break c;

            case 14:
              e = Ei(null, e, t, Kt(t.type, c), n, a);
              break c;
          }

          throw Error(i(306, t, ""));
        }

        return e;

      case 0:
        return n = e.type, t = e.pendingProps, Oi(c, e, n, t = e.elementType === n ? t : Kt(n, t), a);

      case 1:
        return n = e.type, t = e.pendingProps, Qi(c, e, n, t = e.elementType === n ? t : Kt(n, t), a);

      case 3:
        if (Ui(e), n = e.updateQueue, null === c || null === n) throw Error(i(282));
        if (n = e.pendingProps, t = null !== (t = e.memoizedState) ? t.element : null, lr(c, e), hr(e, n, null, a), (n = e.memoizedState.element) === t) bi(), e = Ki(c, e, a);else {
          if ((t = e.stateNode.hydrate) && (Ni = Na(e.stateNode.containerInfo.firstChild), Ai = e, t = gi = !0), t) for (a = wr(e, null, n, a), e.child = a; a;) {
            a.effectTag = -3 & a.effectTag | 1024, a = a.sibling;
          } else Di(c, e, n, a), bi();
          e = e.child;
        }
        return e;

      case 5:
        return kr(e), null === c && xi(e), n = e.type, t = e.pendingProps, r = null !== c ? c.memoizedProps : null, o = t.children, Ca(n, t) ? o = null : null !== r && Ca(n, r) && (e.effectTag |= 16), Ii(c, e), 4 & e.mode && 1 !== a && t.hidden ? (e.expirationTime = e.childExpirationTime = 1, e = null) : (Di(c, e, o, a), e = e.child), e;

      case 6:
        return null === c && xi(e), null;

      case 13:
        return Wi(c, e, a);

      case 4:
        return jr(e, e.stateNode.containerInfo), n = e.pendingProps, null === c ? e.child = xr(e, null, n, a) : Di(c, e, n, a), e.child;

      case 11:
        return n = e.type, t = e.pendingProps, ji(c, e, n, t = e.elementType === n ? t : Kt(n, t), a);

      case 7:
        return Di(c, e, e.pendingProps, a), e.child;

      case 8:
      case 12:
        return Di(c, e, e.pendingProps.children, a), e.child;

      case 10:
        c: {
          n = e.type._context, t = e.pendingProps, o = e.memoizedProps, r = t.value;
          var l = e.type._context;
          if (ut(Xt, l._currentValue), l._currentValue = r, null !== o) if (l = o.value, 0 === (r = Zn(l, r) ? 0 : 0 | ("function" == typeof n._calculateChangedBits ? n._calculateChangedBits(l, r) : 1073741823))) {
            if (o.children === t.children && !vt.current) {
              e = Ki(c, e, a);
              break c;
            }
          } else for (null !== (l = e.child) && (l.return = e); null !== l;) {
            var f = l.dependencies;

            if (null !== f) {
              o = l.child;

              for (var s = f.firstContext; null !== s;) {
                if (s.context === n && 0 != (s.observedBits & r)) {
                  1 === l.tag && ((s = fr(a, null)).tag = 2, sr(l, s)), l.expirationTime < a && (l.expirationTime = a), null !== (s = l.alternate) && s.expirationTime < a && (s.expirationTime = a), nr(l.return, a), f.expirationTime < a && (f.expirationTime = a);
                  break;
                }

                s = s.next;
              }
            } else o = 10 === l.tag && l.type === e.type ? null : l.child;

            if (null !== o) o.return = l;else for (o = l; null !== o;) {
              if (o === e) {
                o = null;
                break;
              }

              if (null !== (l = o.sibling)) {
                l.return = o.return, o = l;
                break;
              }

              o = o.return;
            }
            l = o;
          }
          Di(c, e, t.children, a), e = e.child;
        }

        return e;

      case 9:
        return t = e.type, n = (r = e.pendingProps).children, tr(e, a), n = n(t = rr(t, r.unstable_observedBits)), e.effectTag |= 1, Di(c, e, n, a), e.child;

      case 14:
        return r = Kt(t = e.type, e.pendingProps), Ei(c, e, t, r = Kt(t.type, r), n, a);

      case 15:
        return ki(c, e, e.type, e.pendingProps, n, a);

      case 17:
        return n = e.type, t = e.pendingProps, t = e.elementType === n ? t : Kt(n, t), null !== c && (c.alternate = null, e.alternate = null, e.effectTag |= 2), e.tag = 1, pt(n) ? (c = !0, At(e)) : c = !1, tr(e, a), Cr(e, n, t), Ar(e, n, t, a), Zi(null, e, n, !0, c, a);

      case 19:
        return Ji(c, e, a);
    }

    throw Error(i(156, e.tag));
  };

  var bl = null,
      Sl = null;

  function Tl(c, e, a, n) {
    this.tag = c, this.key = a, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = e, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = n, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
  }

  function Dl(c, e, a, n) {
    return new Tl(c, e, a, n);
  }

  function jl(c) {
    return !(!(c = c.prototype) || !c.isReactComponent);
  }

  function El(c, e) {
    var a = c.alternate;
    return null === a ? ((a = Dl(c.tag, e, c.key, c.mode)).elementType = c.elementType, a.type = c.type, a.stateNode = c.stateNode, a.alternate = c, c.alternate = a) : (a.pendingProps = e, a.effectTag = 0, a.nextEffect = null, a.firstEffect = null, a.lastEffect = null), a.childExpirationTime = c.childExpirationTime, a.expirationTime = c.expirationTime, a.child = c.child, a.memoizedProps = c.memoizedProps, a.memoizedState = c.memoizedState, a.updateQueue = c.updateQueue, e = c.dependencies, a.dependencies = null === e ? null : {
      expirationTime: e.expirationTime,
      firstContext: e.firstContext,
      responders: e.responders
    }, a.sibling = c.sibling, a.index = c.index, a.ref = c.ref, a;
  }

  function kl(c, e, a, n, t, r) {
    var o = 2;
    if (n = c, "function" == typeof c) jl(c) && (o = 1);else if ("string" == typeof c) o = 5;else c: switch (c) {
      case ec:
        return Il(a.children, t, r, e);

      case ic:
        o = 8, t |= 7;
        break;

      case ac:
        o = 8, t |= 1;
        break;

      case nc:
        return (c = Dl(12, a, e, 8 | t)).elementType = nc, c.type = nc, c.expirationTime = r, c;

      case lc:
        return (c = Dl(13, a, e, t)).type = lc, c.elementType = lc, c.expirationTime = r, c;

      case fc:
        return (c = Dl(19, a, e, t)).elementType = fc, c.expirationTime = r, c;

      default:
        if ("object" == typeof c && null !== c) switch (c.$$typeof) {
          case tc:
            o = 10;
            break c;

          case rc:
            o = 9;
            break c;

          case oc:
            o = 11;
            break c;

          case sc:
            o = 14;
            break c;

          case uc:
            o = 16, n = null;
            break c;

          case hc:
            o = 22;
            break c;
        }
        throw Error(i(130, null == c ? c : typeof c, ""));
    }
    return (e = Dl(o, a, e, t)).elementType = c, e.type = n, e.expirationTime = r, e;
  }

  function Il(c, e, a, n) {
    return (c = Dl(7, c, n, e)).expirationTime = a, c;
  }

  function Ol(c, e, a) {
    return (c = Dl(6, c, null, e)).expirationTime = a, c;
  }

  function Ql(c, e, a) {
    return (e = Dl(4, null !== c.children ? c.children : [], c.key, e)).expirationTime = a, e.stateNode = {
      containerInfo: c.containerInfo,
      pendingChildren: null,
      implementation: c.implementation
    }, e;
  }

  function Zl(c, e, a) {
    this.tag = e, this.current = null, this.containerInfo = c, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = a, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
  }

  function Ul(c, e) {
    var a = c.firstSuspendedTime;
    return c = c.lastSuspendedTime, 0 !== a && a >= e && c <= e;
  }

  function Bl(c, e) {
    var a = c.firstSuspendedTime,
        n = c.lastSuspendedTime;
    a < e && (c.firstSuspendedTime = e), (n > e || 0 === a) && (c.lastSuspendedTime = e), e <= c.lastPingedTime && (c.lastPingedTime = 0), e <= c.lastExpiredTime && (c.lastExpiredTime = 0);
  }

  function Rl(c, e) {
    e > c.firstPendingTime && (c.firstPendingTime = e);
    var a = c.firstSuspendedTime;
    0 !== a && (e >= a ? c.firstSuspendedTime = c.lastSuspendedTime = c.nextKnownPendingLevel = 0 : e >= c.lastSuspendedTime && (c.lastSuspendedTime = e + 1), e > c.nextKnownPendingLevel && (c.nextKnownPendingLevel = e));
  }

  function Yl(c, e) {
    var a = c.lastExpiredTime;
    (0 === a || a > e) && (c.lastExpiredTime = e);
  }

  function Pl(c, e, a, n) {
    var t = e.current,
        r = nl(),
        o = vr.suspense;
    r = tl(r, t, o);

    c: if (a) {
      e: {
        if ($c(a = a._reactInternalFiber) !== a || 1 !== a.tag) throw Error(i(170));
        var l = a;

        do {
          switch (l.tag) {
            case 3:
              l = l.stateNode.context;
              break e;

            case 1:
              if (pt(l.type)) {
                l = l.stateNode.__reactInternalMemoizedMergedChildContext;
                break e;
              }

          }

          l = l.return;
        } while (null !== l);

        throw Error(i(171));
      }

      if (1 === a.tag) {
        var f = a.type;

        if (pt(f)) {
          a = Lt(a, f, l);
          break c;
        }
      }

      a = l;
    } else a = ht;

    return null === e.context ? e.context = a : e.pendingContext = a, (e = fr(r, o)).payload = {
      element: c
    }, null !== (n = void 0 === n ? null : n) && (e.callback = n), sr(t, e), rl(t, r), r;
  }

  function Fl(c) {
    if (!(c = c.current).child) return null;

    switch (c.child.tag) {
      case 5:
      default:
        return c.child.stateNode;
    }
  }

  function Wl(c, e) {
    null !== (c = c.memoizedState) && null !== c.dehydrated && c.retryTime < e && (c.retryTime = e);
  }

  function Gl(c, e) {
    Wl(c, e), (c = c.alternate) && Wl(c, e);
  }

  function ql(c, e, a) {
    var n = new Zl(c, e, a = null != a && !0 === a.hydrate),
        t = Dl(3, null, null, 2 === e ? 7 : 1 === e ? 3 : 0);
    n.current = t, t.stateNode = n, or(t), c[wa] = n.current, a && 0 !== e && function (c, e) {
      var a = _c(e);

      xe.forEach(function (c) {
        ve(c, e, a);
      }), we.forEach(function (c) {
        ve(c, e, a);
      });
    }(0, 9 === c.nodeType ? c : c.ownerDocument), this._internalRoot = n;
  }

  function Jl(c) {
    return !(!c || 1 !== c.nodeType && 9 !== c.nodeType && 11 !== c.nodeType && (8 !== c.nodeType || " react-mount-point-unstable " !== c.nodeValue));
  }

  function Kl(c, e, a, n, t) {
    var r = a._reactRootContainer;

    if (r) {
      var i = r._internalRoot;

      if ("function" == typeof t) {
        var o = t;

        t = function t() {
          var c = Fl(i);
          o.call(c);
        };
      }

      Pl(e, i, c, t);
    } else {
      if (r = a._reactRootContainer = function (c, e) {
        if (e || (e = !(!(e = c ? 9 === c.nodeType ? c.documentElement : c.firstChild : null) || 1 !== e.nodeType || !e.hasAttribute("data-reactroot"))), !e) for (var a; a = c.lastChild;) {
          c.removeChild(a);
        }
        return new ql(c, 0, e ? {
          hydrate: !0
        } : void 0);
      }(a, n), i = r._internalRoot, "function" == typeof t) {
        var l = t;

        t = function t() {
          var c = Fl(i);
          l.call(c);
        };
      }

      ul(function () {
        Pl(e, i, c, t);
      });
    }

    return Fl(i);
  }

  function Xl(c, e) {
    var a = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!Jl(e)) throw Error(i(200));
    return function (c, e, a) {
      var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
      return {
        $$typeof: cc,
        key: null == n ? null : "" + n,
        children: c,
        containerInfo: e,
        implementation: a
      };
    }(c, e, null, a);
  }

  ql.prototype.render = function (c) {
    Pl(c, this._internalRoot, null, null);
  }, ql.prototype.unmount = function () {
    var c = this._internalRoot,
        e = c.containerInfo;
    Pl(null, c, null, function () {
      e[wa] = null;
    });
  }, de = function de(c) {
    if (13 === c.tag) {
      var e = Jt(nl(), 150, 100);
      rl(c, e), Gl(c, e);
    }
  }, Me = function Me(c) {
    13 === c.tag && (rl(c, 3), Gl(c, 3));
  }, pe = function pe(c) {
    if (13 === c.tag) {
      var e = nl();
      rl(c, e = tl(e, c, null)), Gl(c, e);
    }
  }, w = function w(c, e, a) {
    switch (e) {
      case "input":
        if (Hc(c, a), e = a.name, "radio" === a.type && null != e) {
          for (a = c; a.parentNode;) {
            a = a.parentNode;
          }

          for (a = a.querySelectorAll("input[name=" + JSON.stringify("" + e) + '][type="radio"]'), e = 0; e < a.length; e++) {
            var n = a[e];

            if (n !== c && n.form === c.form) {
              var t = Ta(n);
              if (!t) throw Error(i(90));
              Lc(n), Hc(n, t);
            }
          }
        }

        break;

      case "textarea":
        Tc(c, a);
        break;

      case "select":
        null != (e = a.value) && yc(c, !!a.multiple, e, !1);
    }
  }, j = sl, E = function E(c, e, a, n, t) {
    var r = jo;
    jo |= 4;

    try {
      return Pt(98, c.bind(null, e, a, n, t));
    } finally {
      (jo = r) === go && Gt();
    }
  }, k = function k() {
    (jo & (1 | Vo | xo)) === go && (function () {
      if (null !== $o) {
        var c = $o;
        $o = null, c.forEach(function (c, e) {
          Yl(e, c), ll(e);
        }), Gt();
      }
    }(), Hl());
  }, I = function I(c, e) {
    var a = jo;
    jo |= 2;

    try {
      return c(e);
    } finally {
      (jo = a) === go && Gt();
    }
  };
  var _l = {
    Events: [ba, Sa, Ta, V, N, Qa, function (c) {
      te(c, Oa);
    }, T, D, Je, oe, Hl, {
      current: !1
    }]
  };
  !function (c) {
    var e = c.findFiberByHostInstance;

    (function (c) {
      if ("undefined" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
      var e = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (e.isDisabled || !e.supportsFiber) return !0;

      try {
        var a = e.inject(c);
        bl = function bl(c) {
          try {
            e.onCommitFiberRoot(a, c, void 0, 64 == (64 & c.current.effectTag));
          } catch (c) {}
        }, Sl = function Sl(c) {
          try {
            e.onCommitFiberUnmount(a, c);
          } catch (c) {}
        };
      } catch (c) {}
    })(t({}, c, {
      overrideHookState: null,
      overrideProps: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: J.ReactCurrentDispatcher,
      findHostInstanceByFiber: function findHostInstanceByFiber(c) {
        return null === (c = ae(c)) ? null : c.stateNode;
      },
      findFiberByHostInstance: function findFiberByHostInstance(c) {
        return e ? e(c) : null;
      },
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null
    }));
  }({
    findFiberByHostInstance: ya,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
  }), e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = _l, e.createPortal = Xl, e.findDOMNode = function (c) {
    if (null == c) return null;
    if (1 === c.nodeType) return c;
    var e = c._reactInternalFiber;

    if (void 0 === e) {
      if ("function" == typeof c.render) throw Error(i(188));
      throw Error(i(268, Object.keys(c)));
    }

    return c = null === (c = ae(e)) ? null : c.stateNode;
  }, e.flushSync = function (c, e) {
    if ((jo & (Vo | xo)) !== go) throw Error(i(187));
    var a = jo;
    jo |= 1;

    try {
      return Pt(99, c.bind(null, e));
    } finally {
      jo = a, Gt();
    }
  }, e.hydrate = function (c, e, a) {
    if (!Jl(e)) throw Error(i(200));
    return Kl(null, c, e, !0, a);
  }, e.render = function (c, e, a) {
    if (!Jl(e)) throw Error(i(200));
    return Kl(null, c, e, !1, a);
  }, e.unmountComponentAtNode = function (c) {
    if (!Jl(c)) throw Error(i(40));
    return !!c._reactRootContainer && (ul(function () {
      Kl(null, null, c, !1, function () {
        c._reactRootContainer = null, c[wa] = null;
      });
    }), !0);
  }, e.unstable_batchedUpdates = sl, e.unstable_createPortal = function (c, e) {
    return Xl(c, e, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
  }, e.unstable_renderSubtreeIntoContainer = function (c, e, a, n) {
    if (!Jl(a)) throw Error(i(200));
    if (null == c || void 0 === c._reactInternalFiber) throw Error(i(38));
    return Kl(c, e, a, !1, n);
  }, e.version = "16.14.0";
}, function (c, e, a) {
  "use strict";

  c.exports = a(204);
}, function (c, e, a) {
  "use strict";
  /** @license React v0.19.1
   * scheduler.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var _n2, t, r, i, o;

  if ("undefined" == typeof window || "function" != typeof MessageChannel) {
    var l = null,
        f = null,
        s = function s() {
      if (null !== l) try {
        var c = e.unstable_now();
        l(!0, c), l = null;
      } catch (c) {
        throw setTimeout(s, 0), c;
      }
    },
        u = Date.now();

    e.unstable_now = function () {
      return Date.now() - u;
    }, _n2 = function n(c) {
      null !== l ? setTimeout(_n2, 0, c) : (l = c, setTimeout(s, 0));
    }, t = function t(c, e) {
      f = setTimeout(c, e);
    }, r = function r() {
      clearTimeout(f);
    }, i = function i() {
      return !1;
    }, o = e.unstable_forceFrameRate = function () {};
  } else {
    var h = window.performance,
        m = window.Date,
        v = window.setTimeout,
        d = window.clearTimeout;

    if ("undefined" != typeof console) {
      var M = window.cancelAnimationFrame;
      "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" != typeof M && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }

    if ("object" == typeof h && "function" == typeof h.now) e.unstable_now = function () {
      return h.now();
    };else {
      var p = m.now();

      e.unstable_now = function () {
        return m.now() - p;
      };
    }
    var z = !1,
        C = null,
        L = -1,
        A = 5,
        N = 0;
    i = function i() {
      return e.unstable_now() >= N;
    }, o = function o() {}, e.unstable_forceFrameRate = function (c) {
      0 > c || 125 < c ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : A = 0 < c ? Math.floor(1e3 / c) : 5;
    };
    var g = new MessageChannel(),
        H = g.port2;
    g.port1.onmessage = function () {
      if (null !== C) {
        var c = e.unstable_now();
        N = c + A;

        try {
          C(!0, c) ? H.postMessage(null) : (z = !1, C = null);
        } catch (c) {
          throw H.postMessage(null), c;
        }
      } else z = !1;
    }, _n2 = function _n2(c) {
      C = c, z || (z = !0, H.postMessage(null));
    }, t = function t(c, a) {
      L = v(function () {
        c(e.unstable_now());
      }, a);
    }, r = function r() {
      d(L), L = -1;
    };
  }

  function V(c, e) {
    var a = c.length;
    c.push(e);

    c: for (;;) {
      var n = a - 1 >>> 1,
          t = c[n];
      if (!(void 0 !== t && 0 < y(t, e))) break c;
      c[n] = e, c[a] = t, a = n;
    }
  }

  function x(c) {
    return void 0 === (c = c[0]) ? null : c;
  }

  function w(c) {
    var e = c[0];

    if (void 0 !== e) {
      var a = c.pop();

      if (a !== e) {
        c[0] = a;

        c: for (var n = 0, t = c.length; n < t;) {
          var r = 2 * (n + 1) - 1,
              i = c[r],
              o = r + 1,
              l = c[o];
          if (void 0 !== i && 0 > y(i, a)) void 0 !== l && 0 > y(l, i) ? (c[n] = l, c[o] = a, n = o) : (c[n] = i, c[r] = a, n = r);else {
            if (!(void 0 !== l && 0 > y(l, a))) break c;
            c[n] = l, c[o] = a, n = o;
          }
        }
      }

      return e;
    }

    return null;
  }

  function y(c, e) {
    var a = c.sortIndex - e.sortIndex;
    return 0 !== a ? a : c.id - e.id;
  }

  var b = [],
      S = [],
      T = 1,
      D = null,
      j = 3,
      E = !1,
      k = !1,
      I = !1;

  function O(c) {
    for (var e = x(S); null !== e;) {
      if (null === e.callback) w(S);else {
        if (!(e.startTime <= c)) break;
        w(S), e.sortIndex = e.expirationTime, V(b, e);
      }
      e = x(S);
    }
  }

  function Q(c) {
    if (I = !1, O(c), !k) if (null !== x(b)) k = !0, _n2(Z);else {
      var e = x(S);
      null !== e && t(Q, e.startTime - c);
    }
  }

  function Z(c, a) {
    k = !1, I && (I = !1, r()), E = !0;
    var n = j;

    try {
      for (O(a), D = x(b); null !== D && (!(D.expirationTime > a) || c && !i());) {
        var o = D.callback;

        if (null !== o) {
          D.callback = null, j = D.priorityLevel;
          var l = o(D.expirationTime <= a);
          a = e.unstable_now(), "function" == typeof l ? D.callback = l : D === x(b) && w(b), O(a);
        } else w(b);

        D = x(b);
      }

      if (null !== D) var f = !0;else {
        var s = x(S);
        null !== s && t(Q, s.startTime - a), f = !1;
      }
      return f;
    } finally {
      D = null, j = n, E = !1;
    }
  }

  function U(c) {
    switch (c) {
      case 1:
        return -1;

      case 2:
        return 250;

      case 5:
        return 1073741823;

      case 4:
        return 1e4;

      default:
        return 5e3;
    }
  }

  var B = o;
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function (c) {
    c.callback = null;
  }, e.unstable_continueExecution = function () {
    k || E || (k = !0, _n2(Z));
  }, e.unstable_getCurrentPriorityLevel = function () {
    return j;
  }, e.unstable_getFirstCallbackNode = function () {
    return x(b);
  }, e.unstable_next = function (c) {
    switch (j) {
      case 1:
      case 2:
      case 3:
        var e = 3;
        break;

      default:
        e = j;
    }

    var a = j;
    j = e;

    try {
      return c();
    } finally {
      j = a;
    }
  }, e.unstable_pauseExecution = function () {}, e.unstable_requestPaint = B, e.unstable_runWithPriority = function (c, e) {
    switch (c) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;

      default:
        c = 3;
    }

    var a = j;
    j = c;

    try {
      return e();
    } finally {
      j = a;
    }
  }, e.unstable_scheduleCallback = function (c, a, i) {
    var o = e.unstable_now();

    if ("object" == typeof i && null !== i) {
      var l = i.delay;
      l = "number" == typeof l && 0 < l ? o + l : o, i = "number" == typeof i.timeout ? i.timeout : U(c);
    } else i = U(c), l = o;

    return c = {
      id: T++,
      callback: a,
      priorityLevel: c,
      startTime: l,
      expirationTime: i = l + i,
      sortIndex: -1
    }, l > o ? (c.sortIndex = l, V(S, c), null === x(b) && c === x(S) && (I ? r() : I = !0, t(Q, l - o))) : (c.sortIndex = i, V(b, c), k || E || (k = !0, _n2(Z))), c;
  }, e.unstable_shouldYield = function () {
    var c = e.unstable_now();
    O(c);
    var a = x(b);
    return a !== D && null !== D && null !== a && null !== a.callback && a.startTime <= c && a.expirationTime < D.expirationTime || i();
  }, e.unstable_wrapCallback = function (c) {
    var e = j;
    return function () {
      var a = j;
      j = e;

      try {
        return c.apply(this, arguments);
      } finally {
        j = a;
      }
    };
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  },
      t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (c) {
    return typeof c;
  } : function (c) {
    return c && "function" == typeof Symbol && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
  },
      r = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      i = a(0),
      o = M(a(2)),
      l = d(a(206)),
      f = M(a(207)),
      s = d(a(79)),
      u = d(a(208)),
      h = a(53),
      m = M(h),
      v = M(a(81));

  function d(c) {
    if (c && c.__esModule) return c;
    var e = {};
    if (null != c) for (var a in c) {
      Object.prototype.hasOwnProperty.call(c, a) && (e[a] = c[a]);
    }
    return e.default = c, e;
  }

  function M(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  a(209);

  var p = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  },
      z = function z(c) {
    return "Tab" === c.code || 9 === c.keyCode;
  },
      C = function C(c) {
    return "Escape" === c.code || 27 === c.keyCode;
  },
      L = 0,
      A = function (c) {
    function e(c) {
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var a = function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, c));

      return a.setOverlayRef = function (c) {
        a.overlay = c, a.props.overlayRef && a.props.overlayRef(c);
      }, a.setContentRef = function (c) {
        a.content = c, a.props.contentRef && a.props.contentRef(c);
      }, a.afterClose = function () {
        var c = a.props,
            e = c.appElement,
            n = c.ariaHideApp,
            t = c.htmlOpenClassName,
            r = c.bodyOpenClassName,
            i = c.parentSelector,
            o = i && i().ownerDocument || document;
        r && u.remove(o.body, r), t && u.remove(o.getElementsByTagName("html")[0], t), n && L > 0 && 0 === (L -= 1) && s.show(e), a.props.shouldFocusAfterRender && (a.props.shouldReturnFocusAfterClose ? (l.returnFocus(a.props.preventScroll), l.teardownScopedFocus()) : l.popWithoutFocus()), a.props.onAfterClose && a.props.onAfterClose(), v.default.deregister(a);
      }, a.open = function () {
        a.beforeOpen(), a.state.afterOpen && a.state.beforeClose ? (clearTimeout(a.closeTimer), a.setState({
          beforeClose: !1
        })) : (a.props.shouldFocusAfterRender && (l.setupScopedFocus(a.node), l.markForFocusLater()), a.setState({
          isOpen: !0
        }, function () {
          a.openAnimationFrame = requestAnimationFrame(function () {
            a.setState({
              afterOpen: !0
            }), a.props.isOpen && a.props.onAfterOpen && a.props.onAfterOpen({
              overlayEl: a.overlay,
              contentEl: a.content
            });
          });
        }));
      }, a.close = function () {
        a.props.closeTimeoutMS > 0 ? a.closeWithTimeout() : a.closeWithoutTimeout();
      }, a.focusContent = function () {
        return a.content && !a.contentHasFocus() && a.content.focus({
          preventScroll: !0
        });
      }, a.closeWithTimeout = function () {
        var c = Date.now() + a.props.closeTimeoutMS;
        a.setState({
          beforeClose: !0,
          closesAt: c
        }, function () {
          a.closeTimer = setTimeout(a.closeWithoutTimeout, a.state.closesAt - Date.now());
        });
      }, a.closeWithoutTimeout = function () {
        a.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, a.afterClose);
      }, a.handleKeyDown = function (c) {
        z(c) && (0, f.default)(a.content, c), a.props.shouldCloseOnEsc && C(c) && (c.stopPropagation(), a.requestClose(c));
      }, a.handleOverlayOnClick = function (c) {
        null === a.shouldClose && (a.shouldClose = !0), a.shouldClose && a.props.shouldCloseOnOverlayClick && (a.ownerHandlesClose() ? a.requestClose(c) : a.focusContent()), a.shouldClose = null;
      }, a.handleContentOnMouseUp = function () {
        a.shouldClose = !1;
      }, a.handleOverlayOnMouseDown = function (c) {
        a.props.shouldCloseOnOverlayClick || c.target != a.overlay || c.preventDefault();
      }, a.handleContentOnClick = function () {
        a.shouldClose = !1;
      }, a.handleContentOnMouseDown = function () {
        a.shouldClose = !1;
      }, a.requestClose = function (c) {
        return a.ownerHandlesClose() && a.props.onRequestClose(c);
      }, a.ownerHandlesClose = function () {
        return a.props.onRequestClose;
      }, a.shouldBeClosed = function () {
        return !a.state.isOpen && !a.state.beforeClose;
      }, a.contentHasFocus = function () {
        return document.activeElement === a.content || a.content.contains(document.activeElement);
      }, a.buildClassName = function (c, e) {
        var n = "object" === (void 0 === e ? "undefined" : t(e)) ? e : {
          base: p[c],
          afterOpen: p[c] + "--after-open",
          beforeClose: p[c] + "--before-close"
        },
            r = n.base;
        return a.state.afterOpen && (r = r + " " + n.afterOpen), a.state.beforeClose && (r = r + " " + n.beforeClose), "string" == typeof e && e ? r + " " + e : r;
      }, a.attributesFromObject = function (c, e) {
        return Object.keys(e).reduce(function (a, n) {
          return a[c + "-" + n] = e[n], a;
        }, {});
      }, a.state = {
        afterOpen: !1,
        beforeClose: !1
      }, a.shouldClose = null, a.moveFromContentToOverlay = null, a;
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, i.Component), r(e, [{
      key: "componentDidMount",
      value: function value() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(c, e) {
        this.props.isOpen && !c.isOpen ? this.open() : !this.props.isOpen && c.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !e.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function value() {
        var c = this.props,
            e = c.appElement,
            a = c.ariaHideApp,
            n = c.htmlOpenClassName,
            t = c.bodyOpenClassName,
            r = c.parentSelector,
            i = r && r().ownerDocument || document;
        t && u.add(i.body, t), n && u.add(i.getElementsByTagName("html")[0], n), a && (L += 1, s.hide(e)), v.default.register(this);
      }
    }, {
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.id,
            a = c.className,
            t = c.overlayClassName,
            r = c.defaultStyles,
            i = c.children,
            o = a ? {} : r.content,
            l = t ? {} : r.overlay;
        if (this.shouldBeClosed()) return null;
        var f = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", t),
          style: n({}, l, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
            s = n({
          id: e,
          ref: this.setContentRef,
          style: n({}, o, this.props.style.content),
          className: this.buildClassName("content", a),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", n({
          modal: !0
        }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }),
            u = this.props.contentElement(s, i);
        return this.props.overlayElement(f, u);
      }
    }]), e;
  }();

  A.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, A.propTypes = {
    isOpen: o.default.bool.isRequired,
    defaultStyles: o.default.shape({
      content: o.default.object,
      overlay: o.default.object
    }),
    style: o.default.shape({
      content: o.default.object,
      overlay: o.default.object
    }),
    className: o.default.oneOfType([o.default.string, o.default.object]),
    overlayClassName: o.default.oneOfType([o.default.string, o.default.object]),
    parentSelector: o.default.func,
    bodyOpenClassName: o.default.string,
    htmlOpenClassName: o.default.string,
    ariaHideApp: o.default.bool,
    appElement: o.default.oneOfType([o.default.instanceOf(m.default), o.default.instanceOf(h.SafeHTMLCollection), o.default.instanceOf(h.SafeNodeList), o.default.arrayOf(o.default.instanceOf(m.default))]),
    onAfterOpen: o.default.func,
    onAfterClose: o.default.func,
    onRequestClose: o.default.func,
    closeTimeoutMS: o.default.number,
    shouldFocusAfterRender: o.default.bool,
    shouldCloseOnOverlayClick: o.default.bool,
    shouldReturnFocusAfterClose: o.default.bool,
    preventScroll: o.default.bool,
    role: o.default.string,
    contentLabel: o.default.string,
    aria: o.default.object,
    data: o.default.object,
    children: o.default.node,
    shouldCloseOnEsc: o.default.bool,
    overlayRef: o.default.func,
    contentRef: o.default.func,
    id: o.default.string,
    overlayElement: o.default.func,
    contentElement: o.default.func,
    testId: o.default.string
  }, e.default = A, c.exports = e.default;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.resetState = function () {
    i = [];
  }, e.log = function () {
    0;
  }, e.handleBlur = f, e.handleFocus = s, e.markForFocusLater = function () {
    i.push(document.activeElement);
  }, e.returnFocus = function () {
    var c = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
        e = null;

    try {
      return void (0 !== i.length && (e = i.pop()).focus({
        preventScroll: c
      }));
    } catch (c) {
      console.warn(["You tried to return focus to", e, "but it is not in the DOM anymore"].join(" "));
    }
  }, e.popWithoutFocus = function () {
    i.length > 0 && i.pop();
  }, e.setupScopedFocus = function (c) {
    o = c, window.addEventListener ? (window.addEventListener("blur", f, !1), document.addEventListener("focus", s, !0)) : (window.attachEvent("onBlur", f), document.attachEvent("onFocus", s));
  }, e.teardownScopedFocus = function () {
    o = null, window.addEventListener ? (window.removeEventListener("blur", f), document.removeEventListener("focus", s)) : (window.detachEvent("onBlur", f), document.detachEvent("onFocus", s));
  };
  var n,
      t = a(78),
      r = (n = t) && n.__esModule ? n : {
    default: n
  };
  var i = [],
      o = null,
      l = !1;

  function f() {
    l = !0;
  }

  function s() {
    if (l) {
      if (l = !1, !o) return;
      setTimeout(function () {
        o.contains(document.activeElement) || ((0, r.default)(o)[0] || o).focus();
      }, 0);
    }
  }
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (c, e) {
    var a = (0, r.default)(c);
    if (!a.length) return void e.preventDefault();

    var n = void 0,
        t = e.shiftKey,
        i = a[0],
        o = a[a.length - 1],
        l = function c() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document;
      return e.activeElement.shadowRoot ? c(e.activeElement.shadowRoot) : e.activeElement;
    }();

    if (c === l) {
      if (!t) return;
      n = o;
    }

    o !== l || t || (n = i);
    i === l && t && (n = o);
    if (n) return e.preventDefault(), void n.focus();
    var f = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    if (null == f || "Chrome" == f[1] || null != /\biPod\b|\biPad\b/g.exec(navigator.userAgent)) return;
    var s = a.indexOf(l);
    s > -1 && (s += t ? -1 : 1);
    if (void 0 === (n = a[s])) return e.preventDefault(), void (n = t ? o : i).focus();
    e.preventDefault(), n.focus();
  };
  var n,
      t = a(78),
      r = (n = t) && n.__esModule ? n : {
    default: n
  };
  c.exports = e.default;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.resetState = function () {
    var c = document.getElementsByTagName("html")[0];

    for (var e in n) {
      r(c, n[e]);
    }

    var a = document.body;

    for (var i in t) {
      r(a, t[i]);
    }

    n = {}, t = {};
  }, e.log = function () {
    0;
  };
  var n = {},
      t = {};

  function r(c, e) {
    c.classList.remove(e);
  }

  e.add = function (c, e) {
    return a = c.classList, r = "html" == c.nodeName.toLowerCase() ? n : t, void e.split(" ").forEach(function (c) {
      !function (c, e) {
        c[e] || (c[e] = 0), c[e] += 1;
      }(r, c), a.add(c);
    });
    var a, r;
  }, e.remove = function (c, e) {
    return a = c.classList, r = "html" == c.nodeName.toLowerCase() ? n : t, void e.split(" ").forEach(function (c) {
      !function (c, e) {
        c[e] && (c[e] -= 1);
      }(r, c), 0 === r[c] && a.remove(c);
    });
    var a, r;
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.resetState = function () {
    for (var c = [i, o], e = 0; e < c.length; e++) {
      var a = c[e];
      a && a.parentNode && a.parentNode.removeChild(a);
    }

    i = o = null, l = [];
  }, e.log = function () {
    console.log("bodyTrap ----------"), console.log(l.length);

    for (var c = [i, o], e = 0; e < c.length; e++) {
      var a = c[e],
          n = a || {};
      console.log(n.nodeName, n.className, n.id);
    }

    console.log("edn bodyTrap ----------");
  };
  var n,
      t = a(81),
      r = (n = t) && n.__esModule ? n : {
    default: n
  };
  var i = void 0,
      o = void 0,
      l = [];

  function f() {
    0 !== l.length && l[l.length - 1].focusContent();
  }

  r.default.subscribe(function (c, e) {
    i || o || ((i = document.createElement("div")).setAttribute("data-react-modal-body-trap", ""), i.style.position = "absolute", i.style.opacity = "0", i.setAttribute("tabindex", "0"), i.addEventListener("focus", f), (o = i.cloneNode()).addEventListener("focus", f)), (l = e).length > 0 ? (document.body.firstChild !== i && document.body.insertBefore(i, document.body.firstChild), document.body.lastChild !== o && document.body.appendChild(o)) : (i.parentElement && i.parentElement.removeChild(i), o.parentElement && o.parentElement.removeChild(o));
  });
}, function (c, e, a) {
  "use strict";

  function n() {
    var c = this.constructor.getDerivedStateFromProps(this.props, this.state);
    null != c && this.setState(c);
  }

  function t(c) {
    this.setState(function (e) {
      var a = this.constructor.getDerivedStateFromProps(c, e);
      return null != a ? a : null;
    }.bind(this));
  }

  function r(c, e) {
    try {
      var a = this.props,
          n = this.state;
      this.props = c, this.state = e, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(a, n);
    } finally {
      this.props = a, this.state = n;
    }
  }

  function i(c) {
    var e = c.prototype;
    if (!e || !e.isReactComponent) throw new Error("Can only polyfill class components");
    if ("function" != typeof c.getDerivedStateFromProps && "function" != typeof e.getSnapshotBeforeUpdate) return c;
    var a = null,
        i = null,
        o = null;

    if ("function" == typeof e.componentWillMount ? a = "componentWillMount" : "function" == typeof e.UNSAFE_componentWillMount && (a = "UNSAFE_componentWillMount"), "function" == typeof e.componentWillReceiveProps ? i = "componentWillReceiveProps" : "function" == typeof e.UNSAFE_componentWillReceiveProps && (i = "UNSAFE_componentWillReceiveProps"), "function" == typeof e.componentWillUpdate ? o = "componentWillUpdate" : "function" == typeof e.UNSAFE_componentWillUpdate && (o = "UNSAFE_componentWillUpdate"), null !== a || null !== i || null !== o) {
      var l = c.displayName || c.name,
          f = "function" == typeof c.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
      throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + l + " uses " + f + " but also contains the following legacy lifecycles:" + (null !== a ? "\n  " + a : "") + (null !== i ? "\n  " + i : "") + (null !== o ? "\n  " + o : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
    }

    if ("function" == typeof c.getDerivedStateFromProps && (e.componentWillMount = n, e.componentWillReceiveProps = t), "function" == typeof e.getSnapshotBeforeUpdate) {
      if ("function" != typeof e.componentDidUpdate) throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
      e.componentWillUpdate = r;
      var s = e.componentDidUpdate;

      e.componentDidUpdate = function (c, e, a) {
        var n = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : a;
        s.call(this, c, e, n);
      };
    }

    return c;
  }

  a.r(e), a.d(e, "polyfill", function () {
    return i;
  }), n.__suppressDeprecationWarning = !0, t.__suppressDeprecationWarning = !0, r.__suppressDeprecationWarning = !0;
}, function (c, e) {
  c.exports = Array.isArray || function (c) {
    return "[object Array]" == Object.prototype.toString.call(c);
  };
}, function (c, e, a) {
  (function (c) {
    var n = void 0 !== c && c || "undefined" != typeof self && self || window,
        t = Function.prototype.apply;

    function r(c, e) {
      this._id = c, this._clearFn = e;
    }

    e.setTimeout = function () {
      return new r(t.call(setTimeout, n, arguments), clearTimeout);
    }, e.setInterval = function () {
      return new r(t.call(setInterval, n, arguments), clearInterval);
    }, e.clearTimeout = e.clearInterval = function (c) {
      c && c.close();
    }, r.prototype.unref = r.prototype.ref = function () {}, r.prototype.close = function () {
      this._clearFn.call(n, this._id);
    }, e.enroll = function (c, e) {
      clearTimeout(c._idleTimeoutId), c._idleTimeout = e;
    }, e.unenroll = function (c) {
      clearTimeout(c._idleTimeoutId), c._idleTimeout = -1;
    }, e._unrefActive = e.active = function (c) {
      clearTimeout(c._idleTimeoutId);
      var e = c._idleTimeout;
      e >= 0 && (c._idleTimeoutId = setTimeout(function () {
        c._onTimeout && c._onTimeout();
      }, e));
    }, a(213), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== c && c.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== c && c.clearImmediate || this && this.clearImmediate;
  }).call(this, a(18));
}, function (c, e, a) {
  (function (c, e) {
    !function (c, a) {
      "use strict";

      if (!c.setImmediate) {
        var n,
            t,
            r,
            i,
            o,
            l = 1,
            f = {},
            s = !1,
            u = c.document,
            h = Object.getPrototypeOf && Object.getPrototypeOf(c);
        h = h && h.setTimeout ? h : c, "[object process]" === {}.toString.call(c.process) ? n = function n(c) {
          e.nextTick(function () {
            v(c);
          });
        } : !function () {
          if (c.postMessage && !c.importScripts) {
            var e = !0,
                a = c.onmessage;
            return c.onmessage = function () {
              e = !1;
            }, c.postMessage("", "*"), c.onmessage = a, e;
          }
        }() ? c.MessageChannel ? ((r = new MessageChannel()).port1.onmessage = function (c) {
          v(c.data);
        }, n = function n(c) {
          r.port2.postMessage(c);
        }) : u && "onreadystatechange" in u.createElement("script") ? (t = u.documentElement, n = function n(c) {
          var e = u.createElement("script");
          e.onreadystatechange = function () {
            v(c), e.onreadystatechange = null, t.removeChild(e), e = null;
          }, t.appendChild(e);
        }) : n = function n(c) {
          setTimeout(v, 0, c);
        } : (i = "setImmediate$" + Math.random() + "$", o = function o(e) {
          e.source === c && "string" == typeof e.data && 0 === e.data.indexOf(i) && v(+e.data.slice(i.length));
        }, c.addEventListener ? c.addEventListener("message", o, !1) : c.attachEvent("onmessage", o), n = function n(e) {
          c.postMessage(i + e, "*");
        }), h.setImmediate = function (c) {
          "function" != typeof c && (c = new Function("" + c));

          for (var e = new Array(arguments.length - 1), a = 0; a < e.length; a++) {
            e[a] = arguments[a + 1];
          }

          var t = {
            callback: c,
            args: e
          };
          return f[l] = t, n(l), l++;
        }, h.clearImmediate = m;
      }

      function m(c) {
        delete f[c];
      }

      function v(c) {
        if (s) setTimeout(v, 0, c);else {
          var e = f[c];

          if (e) {
            s = !0;

            try {
              !function (c) {
                var e = c.callback,
                    n = c.args;

                switch (n.length) {
                  case 0:
                    e();
                    break;

                  case 1:
                    e(n[0]);
                    break;

                  case 2:
                    e(n[0], n[1]);
                    break;

                  case 3:
                    e(n[0], n[1], n[2]);
                    break;

                  default:
                    e.apply(a, n);
                }
              }(e);
            } finally {
              m(c), s = !1;
            }
          }
        }
      }
    }("undefined" == typeof self ? void 0 === c ? this : c : self);
  }).call(this, a(18), a(214));
}, function (c, e) {
  var a,
      n,
      t = c.exports = {};

  function r() {
    throw new Error("setTimeout has not been defined");
  }

  function i() {
    throw new Error("clearTimeout has not been defined");
  }

  function o(c) {
    if (a === setTimeout) return setTimeout(c, 0);
    if ((a === r || !a) && setTimeout) return a = setTimeout, setTimeout(c, 0);

    try {
      return a(c, 0);
    } catch (e) {
      try {
        return a.call(null, c, 0);
      } catch (e) {
        return a.call(this, c, 0);
      }
    }
  }

  !function () {
    try {
      a = "function" == typeof setTimeout ? setTimeout : r;
    } catch (c) {
      a = r;
    }

    try {
      n = "function" == typeof clearTimeout ? clearTimeout : i;
    } catch (c) {
      n = i;
    }
  }();
  var l,
      f = [],
      s = !1,
      u = -1;

  function h() {
    s && l && (s = !1, l.length ? f = l.concat(f) : u = -1, f.length && m());
  }

  function m() {
    if (!s) {
      var c = o(h);
      s = !0;

      for (var e = f.length; e;) {
        for (l = f, f = []; ++u < e;) {
          l && l[u].run();
        }

        u = -1, e = f.length;
      }

      l = null, s = !1, function (c) {
        if (n === clearTimeout) return clearTimeout(c);
        if ((n === i || !n) && clearTimeout) return n = clearTimeout, clearTimeout(c);

        try {
          n(c);
        } catch (e) {
          try {
            return n.call(null, c);
          } catch (e) {
            return n.call(this, c);
          }
        }
      }(c);
    }
  }

  function v(c, e) {
    this.fun = c, this.array = e;
  }

  function d() {}

  t.nextTick = function (c) {
    var e = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var a = 1; a < arguments.length; a++) {
      e[a - 1] = arguments[a];
    }
    f.push(new v(c, e)), 1 !== f.length || s || o(m);
  }, v.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, t.title = "browser", t.browser = !0, t.env = {}, t.argv = [], t.version = "", t.versions = {}, t.on = d, t.addListener = d, t.once = d, t.off = d, t.removeListener = d, t.removeAllListeners = d, t.emit = d, t.prependListener = d, t.prependOnceListener = d, t.listeners = function (c) {
    return [];
  }, t.binding = function (c) {
    throw new Error("process.binding is not supported");
  }, t.cwd = function () {
    return "/";
  }, t.chdir = function (c) {
    throw new Error("process.chdir is not supported");
  }, t.umask = function () {
    return 0;
  };
}, function (c, e, a) {
  "use strict";

  a.r(e), a.d(e, "fal", function () {
    return Hj;
  }), a.d(e, "prefix", function () {
    return n;
  }), a.d(e, "faAbacus", function () {
    return t;
  }), a.d(e, "faAcorn", function () {
    return r;
  }), a.d(e, "faAd", function () {
    return i;
  }), a.d(e, "faAddressBook", function () {
    return o;
  }), a.d(e, "faAddressCard", function () {
    return l;
  }), a.d(e, "faAdjust", function () {
    return f;
  }), a.d(e, "faAirConditioner", function () {
    return s;
  }), a.d(e, "faAirFreshener", function () {
    return u;
  }), a.d(e, "faAlarmClock", function () {
    return h;
  }), a.d(e, "faAlarmExclamation", function () {
    return m;
  }), a.d(e, "faAlarmPlus", function () {
    return v;
  }), a.d(e, "faAlarmSnooze", function () {
    return d;
  }), a.d(e, "faAlbum", function () {
    return M;
  }), a.d(e, "faAlbumCollection", function () {
    return p;
  }), a.d(e, "faAlicorn", function () {
    return z;
  }), a.d(e, "faAlien", function () {
    return C;
  }), a.d(e, "faAlienMonster", function () {
    return L;
  }), a.d(e, "faAlignCenter", function () {
    return A;
  }), a.d(e, "faAlignJustify", function () {
    return N;
  }), a.d(e, "faAlignLeft", function () {
    return g;
  }), a.d(e, "faAlignRight", function () {
    return H;
  }), a.d(e, "faAlignSlash", function () {
    return V;
  }), a.d(e, "faAllergies", function () {
    return x;
  }), a.d(e, "faAmbulance", function () {
    return w;
  }), a.d(e, "faAmericanSignLanguageInterpreting", function () {
    return y;
  }), a.d(e, "faAmpGuitar", function () {
    return b;
  }), a.d(e, "faAnalytics", function () {
    return S;
  }), a.d(e, "faAnchor", function () {
    return T;
  }), a.d(e, "faAngel", function () {
    return D;
  }), a.d(e, "faAngleDoubleDown", function () {
    return j;
  }), a.d(e, "faAngleDoubleLeft", function () {
    return E;
  }), a.d(e, "faAngleDoubleRight", function () {
    return k;
  }), a.d(e, "faAngleDoubleUp", function () {
    return I;
  }), a.d(e, "faAngleDown", function () {
    return O;
  }), a.d(e, "faAngleLeft", function () {
    return Q;
  }), a.d(e, "faAngleRight", function () {
    return Z;
  }), a.d(e, "faAngleUp", function () {
    return U;
  }), a.d(e, "faAngry", function () {
    return B;
  }), a.d(e, "faAnkh", function () {
    return R;
  }), a.d(e, "faAppleAlt", function () {
    return Y;
  }), a.d(e, "faAppleCrate", function () {
    return P;
  }), a.d(e, "faArchive", function () {
    return F;
  }), a.d(e, "faArchway", function () {
    return W;
  }), a.d(e, "faArrowAltCircleDown", function () {
    return G;
  }), a.d(e, "faArrowAltCircleLeft", function () {
    return q;
  }), a.d(e, "faArrowAltCircleRight", function () {
    return J;
  }), a.d(e, "faArrowAltCircleUp", function () {
    return K;
  }), a.d(e, "faArrowAltDown", function () {
    return X;
  }), a.d(e, "faArrowAltFromBottom", function () {
    return _;
  }), a.d(e, "faArrowAltFromLeft", function () {
    return $;
  }), a.d(e, "faArrowAltFromRight", function () {
    return cc;
  }), a.d(e, "faArrowAltFromTop", function () {
    return ec;
  }), a.d(e, "faArrowAltLeft", function () {
    return ac;
  }), a.d(e, "faArrowAltRight", function () {
    return nc;
  }), a.d(e, "faArrowAltSquareDown", function () {
    return tc;
  }), a.d(e, "faArrowAltSquareLeft", function () {
    return rc;
  }), a.d(e, "faArrowAltSquareRight", function () {
    return ic;
  }), a.d(e, "faArrowAltSquareUp", function () {
    return oc;
  }), a.d(e, "faArrowAltToBottom", function () {
    return lc;
  }), a.d(e, "faArrowAltToLeft", function () {
    return fc;
  }), a.d(e, "faArrowAltToRight", function () {
    return sc;
  }), a.d(e, "faArrowAltToTop", function () {
    return uc;
  }), a.d(e, "faArrowAltUp", function () {
    return hc;
  }), a.d(e, "faArrowCircleDown", function () {
    return mc;
  }), a.d(e, "faArrowCircleLeft", function () {
    return vc;
  }), a.d(e, "faArrowCircleRight", function () {
    return dc;
  }), a.d(e, "faArrowCircleUp", function () {
    return Mc;
  }), a.d(e, "faArrowDown", function () {
    return pc;
  }), a.d(e, "faArrowFromBottom", function () {
    return zc;
  }), a.d(e, "faArrowFromLeft", function () {
    return Cc;
  }), a.d(e, "faArrowFromRight", function () {
    return Lc;
  }), a.d(e, "faArrowFromTop", function () {
    return Ac;
  }), a.d(e, "faArrowLeft", function () {
    return Nc;
  }), a.d(e, "faArrowRight", function () {
    return gc;
  }), a.d(e, "faArrowSquareDown", function () {
    return Hc;
  }), a.d(e, "faArrowSquareLeft", function () {
    return Vc;
  }), a.d(e, "faArrowSquareRight", function () {
    return xc;
  }), a.d(e, "faArrowSquareUp", function () {
    return wc;
  }), a.d(e, "faArrowToBottom", function () {
    return yc;
  }), a.d(e, "faArrowToLeft", function () {
    return bc;
  }), a.d(e, "faArrowToRight", function () {
    return Sc;
  }), a.d(e, "faArrowToTop", function () {
    return Tc;
  }), a.d(e, "faArrowUp", function () {
    return Dc;
  }), a.d(e, "faArrows", function () {
    return jc;
  }), a.d(e, "faArrowsAlt", function () {
    return Ec;
  }), a.d(e, "faArrowsAltH", function () {
    return kc;
  }), a.d(e, "faArrowsAltV", function () {
    return Ic;
  }), a.d(e, "faArrowsH", function () {
    return Oc;
  }), a.d(e, "faArrowsV", function () {
    return Qc;
  }), a.d(e, "faAssistiveListeningSystems", function () {
    return Zc;
  }), a.d(e, "faAsterisk", function () {
    return Uc;
  }), a.d(e, "faAt", function () {
    return Bc;
  }), a.d(e, "faAtlas", function () {
    return Rc;
  }), a.d(e, "faAtom", function () {
    return Yc;
  }), a.d(e, "faAtomAlt", function () {
    return Pc;
  }), a.d(e, "faAudioDescription", function () {
    return Fc;
  }), a.d(e, "faAward", function () {
    return Wc;
  }), a.d(e, "faAxe", function () {
    return Gc;
  }), a.d(e, "faAxeBattle", function () {
    return qc;
  }), a.d(e, "faBaby", function () {
    return Jc;
  }), a.d(e, "faBabyCarriage", function () {
    return Kc;
  }), a.d(e, "faBackpack", function () {
    return Xc;
  }), a.d(e, "faBackspace", function () {
    return _c;
  }), a.d(e, "faBackward", function () {
    return $c;
  }), a.d(e, "faBacon", function () {
    return ce;
  }), a.d(e, "faBacteria", function () {
    return ee;
  }), a.d(e, "faBacterium", function () {
    return ae;
  }), a.d(e, "faBadge", function () {
    return ne;
  }), a.d(e, "faBadgeCheck", function () {
    return te;
  }), a.d(e, "faBadgeDollar", function () {
    return re;
  }), a.d(e, "faBadgePercent", function () {
    return ie;
  }), a.d(e, "faBadgeSheriff", function () {
    return oe;
  }), a.d(e, "faBadgerHoney", function () {
    return le;
  }), a.d(e, "faBagsShopping", function () {
    return fe;
  }), a.d(e, "faBahai", function () {
    return se;
  }), a.d(e, "faBalanceScale", function () {
    return ue;
  }), a.d(e, "faBalanceScaleLeft", function () {
    return he;
  }), a.d(e, "faBalanceScaleRight", function () {
    return me;
  }), a.d(e, "faBallPile", function () {
    return ve;
  }), a.d(e, "faBallot", function () {
    return de;
  }), a.d(e, "faBallotCheck", function () {
    return Me;
  }), a.d(e, "faBan", function () {
    return pe;
  }), a.d(e, "faBandAid", function () {
    return ze;
  }), a.d(e, "faBanjo", function () {
    return Ce;
  }), a.d(e, "faBarcode", function () {
    return Le;
  }), a.d(e, "faBarcodeAlt", function () {
    return Ae;
  }), a.d(e, "faBarcodeRead", function () {
    return Ne;
  }), a.d(e, "faBarcodeScan", function () {
    return ge;
  }), a.d(e, "faBars", function () {
    return He;
  }), a.d(e, "faBaseball", function () {
    return Ve;
  }), a.d(e, "faBaseballBall", function () {
    return xe;
  }), a.d(e, "faBasketballBall", function () {
    return we;
  }), a.d(e, "faBasketballHoop", function () {
    return ye;
  }), a.d(e, "faBat", function () {
    return be;
  }), a.d(e, "faBath", function () {
    return Se;
  }), a.d(e, "faBatteryBolt", function () {
    return Te;
  }), a.d(e, "faBatteryEmpty", function () {
    return De;
  }), a.d(e, "faBatteryFull", function () {
    return je;
  }), a.d(e, "faBatteryHalf", function () {
    return Ee;
  }), a.d(e, "faBatteryQuarter", function () {
    return ke;
  }), a.d(e, "faBatterySlash", function () {
    return Ie;
  }), a.d(e, "faBatteryThreeQuarters", function () {
    return Oe;
  }), a.d(e, "faBed", function () {
    return Qe;
  }), a.d(e, "faBedAlt", function () {
    return Ze;
  }), a.d(e, "faBedBunk", function () {
    return Ue;
  }), a.d(e, "faBedEmpty", function () {
    return Be;
  }), a.d(e, "faBeer", function () {
    return Re;
  }), a.d(e, "faBell", function () {
    return Ye;
  }), a.d(e, "faBellExclamation", function () {
    return Pe;
  }), a.d(e, "faBellOn", function () {
    return Fe;
  }), a.d(e, "faBellPlus", function () {
    return We;
  }), a.d(e, "faBellSchool", function () {
    return Ge;
  }), a.d(e, "faBellSchoolSlash", function () {
    return qe;
  }), a.d(e, "faBellSlash", function () {
    return Je;
  }), a.d(e, "faBells", function () {
    return Ke;
  }), a.d(e, "faBetamax", function () {
    return Xe;
  }), a.d(e, "faBezierCurve", function () {
    return _e;
  }), a.d(e, "faBible", function () {
    return $e;
  }), a.d(e, "faBicycle", function () {
    return ca;
  }), a.d(e, "faBiking", function () {
    return ea;
  }), a.d(e, "faBikingMountain", function () {
    return aa;
  }), a.d(e, "faBinoculars", function () {
    return na;
  }), a.d(e, "faBiohazard", function () {
    return ta;
  }), a.d(e, "faBirthdayCake", function () {
    return ra;
  }), a.d(e, "faBlanket", function () {
    return ia;
  }), a.d(e, "faBlender", function () {
    return oa;
  }), a.d(e, "faBlenderPhone", function () {
    return la;
  }), a.d(e, "faBlind", function () {
    return fa;
  }), a.d(e, "faBlinds", function () {
    return sa;
  }), a.d(e, "faBlindsOpen", function () {
    return ua;
  }), a.d(e, "faBlindsRaised", function () {
    return ha;
  }), a.d(e, "faBlog", function () {
    return ma;
  }), a.d(e, "faBold", function () {
    return va;
  }), a.d(e, "faBolt", function () {
    return da;
  }), a.d(e, "faBomb", function () {
    return Ma;
  }), a.d(e, "faBone", function () {
    return pa;
  }), a.d(e, "faBoneBreak", function () {
    return za;
  }), a.d(e, "faBong", function () {
    return Ca;
  }), a.d(e, "faBook", function () {
    return La;
  }), a.d(e, "faBookAlt", function () {
    return Aa;
  }), a.d(e, "faBookDead", function () {
    return Na;
  }), a.d(e, "faBookHeart", function () {
    return ga;
  }), a.d(e, "faBookMedical", function () {
    return Ha;
  }), a.d(e, "faBookOpen", function () {
    return Va;
  }), a.d(e, "faBookReader", function () {
    return xa;
  }), a.d(e, "faBookSpells", function () {
    return wa;
  }), a.d(e, "faBookUser", function () {
    return ya;
  }), a.d(e, "faBookmark", function () {
    return ba;
  }), a.d(e, "faBooks", function () {
    return Sa;
  }), a.d(e, "faBooksMedical", function () {
    return Ta;
  }), a.d(e, "faBoombox", function () {
    return Da;
  }), a.d(e, "faBoot", function () {
    return ja;
  }), a.d(e, "faBoothCurtain", function () {
    return Ea;
  }), a.d(e, "faBorderAll", function () {
    return ka;
  }), a.d(e, "faBorderBottom", function () {
    return Ia;
  }), a.d(e, "faBorderCenterH", function () {
    return Oa;
  }), a.d(e, "faBorderCenterV", function () {
    return Qa;
  }), a.d(e, "faBorderInner", function () {
    return Za;
  }), a.d(e, "faBorderLeft", function () {
    return Ua;
  }), a.d(e, "faBorderNone", function () {
    return Ba;
  }), a.d(e, "faBorderOuter", function () {
    return Ra;
  }), a.d(e, "faBorderRight", function () {
    return Ya;
  }), a.d(e, "faBorderStyle", function () {
    return Pa;
  }), a.d(e, "faBorderStyleAlt", function () {
    return Fa;
  }), a.d(e, "faBorderTop", function () {
    return Wa;
  }), a.d(e, "faBowArrow", function () {
    return Ga;
  }), a.d(e, "faBowlingBall", function () {
    return qa;
  }), a.d(e, "faBowlingPins", function () {
    return Ja;
  }), a.d(e, "faBox", function () {
    return Ka;
  }), a.d(e, "faBoxAlt", function () {
    return Xa;
  }), a.d(e, "faBoxBallot", function () {
    return _a;
  }), a.d(e, "faBoxCheck", function () {
    return $a;
  }), a.d(e, "faBoxFragile", function () {
    return cn;
  }), a.d(e, "faBoxFull", function () {
    return en;
  }), a.d(e, "faBoxHeart", function () {
    return an;
  }), a.d(e, "faBoxOpen", function () {
    return nn;
  }), a.d(e, "faBoxTissue", function () {
    return tn;
  }), a.d(e, "faBoxUp", function () {
    return rn;
  }), a.d(e, "faBoxUsd", function () {
    return on;
  }), a.d(e, "faBoxes", function () {
    return ln;
  }), a.d(e, "faBoxesAlt", function () {
    return fn;
  }), a.d(e, "faBoxingGlove", function () {
    return sn;
  }), a.d(e, "faBrackets", function () {
    return un;
  }), a.d(e, "faBracketsCurly", function () {
    return hn;
  }), a.d(e, "faBraille", function () {
    return mn;
  }), a.d(e, "faBrain", function () {
    return vn;
  }), a.d(e, "faBreadLoaf", function () {
    return dn;
  }), a.d(e, "faBreadSlice", function () {
    return Mn;
  }), a.d(e, "faBriefcase", function () {
    return pn;
  }), a.d(e, "faBriefcaseMedical", function () {
    return zn;
  }), a.d(e, "faBringForward", function () {
    return Cn;
  }), a.d(e, "faBringFront", function () {
    return Ln;
  }), a.d(e, "faBroadcastTower", function () {
    return An;
  }), a.d(e, "faBroom", function () {
    return Nn;
  }), a.d(e, "faBrowser", function () {
    return gn;
  }), a.d(e, "faBrush", function () {
    return Hn;
  }), a.d(e, "faBug", function () {
    return Vn;
  }), a.d(e, "faBuilding", function () {
    return xn;
  }), a.d(e, "faBullhorn", function () {
    return wn;
  }), a.d(e, "faBullseye", function () {
    return yn;
  }), a.d(e, "faBullseyeArrow", function () {
    return bn;
  }), a.d(e, "faBullseyePointer", function () {
    return Sn;
  }), a.d(e, "faBurgerSoda", function () {
    return Tn;
  }), a.d(e, "faBurn", function () {
    return Dn;
  }), a.d(e, "faBurrito", function () {
    return jn;
  }), a.d(e, "faBus", function () {
    return En;
  }), a.d(e, "faBusAlt", function () {
    return kn;
  }), a.d(e, "faBusSchool", function () {
    return In;
  }), a.d(e, "faBusinessTime", function () {
    return On;
  }), a.d(e, "faCabinetFiling", function () {
    return Qn;
  }), a.d(e, "faCactus", function () {
    return Zn;
  }), a.d(e, "faCalculator", function () {
    return Un;
  }), a.d(e, "faCalculatorAlt", function () {
    return Bn;
  }), a.d(e, "faCalendar", function () {
    return Rn;
  }), a.d(e, "faCalendarAlt", function () {
    return Yn;
  }), a.d(e, "faCalendarCheck", function () {
    return Pn;
  }), a.d(e, "faCalendarDay", function () {
    return Fn;
  }), a.d(e, "faCalendarEdit", function () {
    return Wn;
  }), a.d(e, "faCalendarExclamation", function () {
    return Gn;
  }), a.d(e, "faCalendarMinus", function () {
    return qn;
  }), a.d(e, "faCalendarPlus", function () {
    return Jn;
  }), a.d(e, "faCalendarStar", function () {
    return Kn;
  }), a.d(e, "faCalendarTimes", function () {
    return Xn;
  }), a.d(e, "faCalendarWeek", function () {
    return _n;
  }), a.d(e, "faCamcorder", function () {
    return $n;
  }), a.d(e, "faCamera", function () {
    return ct;
  }), a.d(e, "faCameraAlt", function () {
    return et;
  }), a.d(e, "faCameraHome", function () {
    return at;
  }), a.d(e, "faCameraMovie", function () {
    return nt;
  }), a.d(e, "faCameraPolaroid", function () {
    return tt;
  }), a.d(e, "faCameraRetro", function () {
    return rt;
  }), a.d(e, "faCampfire", function () {
    return it;
  }), a.d(e, "faCampground", function () {
    return ot;
  }), a.d(e, "faCandleHolder", function () {
    return lt;
  }), a.d(e, "faCandyCane", function () {
    return ft;
  }), a.d(e, "faCandyCorn", function () {
    return st;
  }), a.d(e, "faCannabis", function () {
    return ut;
  }), a.d(e, "faCapsules", function () {
    return ht;
  }), a.d(e, "faCar", function () {
    return mt;
  }), a.d(e, "faCarAlt", function () {
    return vt;
  }), a.d(e, "faCarBattery", function () {
    return dt;
  }), a.d(e, "faCarBuilding", function () {
    return Mt;
  }), a.d(e, "faCarBump", function () {
    return pt;
  }), a.d(e, "faCarBus", function () {
    return zt;
  }), a.d(e, "faCarCrash", function () {
    return Ct;
  }), a.d(e, "faCarGarage", function () {
    return Lt;
  }), a.d(e, "faCarMechanic", function () {
    return At;
  }), a.d(e, "faCarSide", function () {
    return Nt;
  }), a.d(e, "faCarTilt", function () {
    return gt;
  }), a.d(e, "faCarWash", function () {
    return Ht;
  }), a.d(e, "faCaravan", function () {
    return Vt;
  }), a.d(e, "faCaravanAlt", function () {
    return xt;
  }), a.d(e, "faCaretCircleDown", function () {
    return wt;
  }), a.d(e, "faCaretCircleLeft", function () {
    return yt;
  }), a.d(e, "faCaretCircleRight", function () {
    return bt;
  }), a.d(e, "faCaretCircleUp", function () {
    return St;
  }), a.d(e, "faCaretDown", function () {
    return Tt;
  }), a.d(e, "faCaretLeft", function () {
    return Dt;
  }), a.d(e, "faCaretRight", function () {
    return jt;
  }), a.d(e, "faCaretSquareDown", function () {
    return Et;
  }), a.d(e, "faCaretSquareLeft", function () {
    return kt;
  }), a.d(e, "faCaretSquareRight", function () {
    return It;
  }), a.d(e, "faCaretSquareUp", function () {
    return Ot;
  }), a.d(e, "faCaretUp", function () {
    return Qt;
  }), a.d(e, "faCarrot", function () {
    return Zt;
  }), a.d(e, "faCars", function () {
    return Ut;
  }), a.d(e, "faCartArrowDown", function () {
    return Bt;
  }), a.d(e, "faCartPlus", function () {
    return Rt;
  }), a.d(e, "faCashRegister", function () {
    return Yt;
  }), a.d(e, "faCassetteTape", function () {
    return Pt;
  }), a.d(e, "faCat", function () {
    return Ft;
  }), a.d(e, "faCatSpace", function () {
    return Wt;
  }), a.d(e, "faCauldron", function () {
    return Gt;
  }), a.d(e, "faCctv", function () {
    return qt;
  }), a.d(e, "faCertificate", function () {
    return Jt;
  }), a.d(e, "faChair", function () {
    return Kt;
  }), a.d(e, "faChairOffice", function () {
    return Xt;
  }), a.d(e, "faChalkboard", function () {
    return _t;
  }), a.d(e, "faChalkboardTeacher", function () {
    return $t;
  }), a.d(e, "faChargingStation", function () {
    return cr;
  }), a.d(e, "faChartArea", function () {
    return er;
  }), a.d(e, "faChartBar", function () {
    return ar;
  }), a.d(e, "faChartLine", function () {
    return nr;
  }), a.d(e, "faChartLineDown", function () {
    return tr;
  }), a.d(e, "faChartNetwork", function () {
    return rr;
  }), a.d(e, "faChartPie", function () {
    return ir;
  }), a.d(e, "faChartPieAlt", function () {
    return or;
  }), a.d(e, "faChartScatter", function () {
    return lr;
  }), a.d(e, "faCheck", function () {
    return fr;
  }), a.d(e, "faCheckCircle", function () {
    return sr;
  }), a.d(e, "faCheckDouble", function () {
    return ur;
  }), a.d(e, "faCheckSquare", function () {
    return hr;
  }), a.d(e, "faCheese", function () {
    return mr;
  }), a.d(e, "faCheeseSwiss", function () {
    return vr;
  }), a.d(e, "faCheeseburger", function () {
    return dr;
  }), a.d(e, "faChess", function () {
    return Mr;
  }), a.d(e, "faChessBishop", function () {
    return pr;
  }), a.d(e, "faChessBishopAlt", function () {
    return zr;
  }), a.d(e, "faChessBoard", function () {
    return Cr;
  }), a.d(e, "faChessClock", function () {
    return Lr;
  }), a.d(e, "faChessClockAlt", function () {
    return Ar;
  }), a.d(e, "faChessKing", function () {
    return Nr;
  }), a.d(e, "faChessKingAlt", function () {
    return gr;
  }), a.d(e, "faChessKnight", function () {
    return Hr;
  }), a.d(e, "faChessKnightAlt", function () {
    return Vr;
  }), a.d(e, "faChessPawn", function () {
    return xr;
  }), a.d(e, "faChessPawnAlt", function () {
    return wr;
  }), a.d(e, "faChessQueen", function () {
    return yr;
  }), a.d(e, "faChessQueenAlt", function () {
    return br;
  }), a.d(e, "faChessRook", function () {
    return Sr;
  }), a.d(e, "faChessRookAlt", function () {
    return Tr;
  }), a.d(e, "faChevronCircleDown", function () {
    return Dr;
  }), a.d(e, "faChevronCircleLeft", function () {
    return jr;
  }), a.d(e, "faChevronCircleRight", function () {
    return Er;
  }), a.d(e, "faChevronCircleUp", function () {
    return kr;
  }), a.d(e, "faChevronDoubleDown", function () {
    return Ir;
  }), a.d(e, "faChevronDoubleLeft", function () {
    return Or;
  }), a.d(e, "faChevronDoubleRight", function () {
    return Qr;
  }), a.d(e, "faChevronDoubleUp", function () {
    return Zr;
  }), a.d(e, "faChevronDown", function () {
    return Ur;
  }), a.d(e, "faChevronLeft", function () {
    return Br;
  }), a.d(e, "faChevronRight", function () {
    return Rr;
  }), a.d(e, "faChevronSquareDown", function () {
    return Yr;
  }), a.d(e, "faChevronSquareLeft", function () {
    return Pr;
  }), a.d(e, "faChevronSquareRight", function () {
    return Fr;
  }), a.d(e, "faChevronSquareUp", function () {
    return Wr;
  }), a.d(e, "faChevronUp", function () {
    return Gr;
  }), a.d(e, "faChild", function () {
    return qr;
  }), a.d(e, "faChimney", function () {
    return Jr;
  }), a.d(e, "faChurch", function () {
    return Kr;
  }), a.d(e, "faCircle", function () {
    return Xr;
  }), a.d(e, "faCircleNotch", function () {
    return _r;
  }), a.d(e, "faCity", function () {
    return $r;
  }), a.d(e, "faClarinet", function () {
    return ci;
  }), a.d(e, "faClawMarks", function () {
    return ei;
  }), a.d(e, "faClinicMedical", function () {
    return ai;
  }), a.d(e, "faClipboard", function () {
    return ni;
  }), a.d(e, "faClipboardCheck", function () {
    return ti;
  }), a.d(e, "faClipboardList", function () {
    return ri;
  }), a.d(e, "faClipboardListCheck", function () {
    return ii;
  }), a.d(e, "faClipboardPrescription", function () {
    return oi;
  }), a.d(e, "faClipboardUser", function () {
    return li;
  }), a.d(e, "faClock", function () {
    return fi;
  }), a.d(e, "faClone", function () {
    return si;
  }), a.d(e, "faClosedCaptioning", function () {
    return ui;
  }), a.d(e, "faCloud", function () {
    return hi;
  }), a.d(e, "faCloudDownload", function () {
    return mi;
  }), a.d(e, "faCloudDownloadAlt", function () {
    return vi;
  }), a.d(e, "faCloudDrizzle", function () {
    return di;
  }), a.d(e, "faCloudHail", function () {
    return Mi;
  }), a.d(e, "faCloudHailMixed", function () {
    return pi;
  }), a.d(e, "faCloudMeatball", function () {
    return zi;
  }), a.d(e, "faCloudMoon", function () {
    return Ci;
  }), a.d(e, "faCloudMoonRain", function () {
    return Li;
  }), a.d(e, "faCloudMusic", function () {
    return Ai;
  }), a.d(e, "faCloudRain", function () {
    return Ni;
  }), a.d(e, "faCloudRainbow", function () {
    return gi;
  }), a.d(e, "faCloudShowers", function () {
    return Hi;
  }), a.d(e, "faCloudShowersHeavy", function () {
    return Vi;
  }), a.d(e, "faCloudSleet", function () {
    return xi;
  }), a.d(e, "faCloudSnow", function () {
    return wi;
  }), a.d(e, "faCloudSun", function () {
    return yi;
  }), a.d(e, "faCloudSunRain", function () {
    return bi;
  }), a.d(e, "faCloudUpload", function () {
    return Si;
  }), a.d(e, "faCloudUploadAlt", function () {
    return Ti;
  }), a.d(e, "faClouds", function () {
    return Di;
  }), a.d(e, "faCloudsMoon", function () {
    return ji;
  }), a.d(e, "faCloudsSun", function () {
    return Ei;
  }), a.d(e, "faClub", function () {
    return ki;
  }), a.d(e, "faCocktail", function () {
    return Ii;
  }), a.d(e, "faCode", function () {
    return Oi;
  }), a.d(e, "faCodeBranch", function () {
    return Qi;
  }), a.d(e, "faCodeCommit", function () {
    return Zi;
  }), a.d(e, "faCodeMerge", function () {
    return Ui;
  }), a.d(e, "faCoffee", function () {
    return Bi;
  }), a.d(e, "faCoffeePot", function () {
    return Ri;
  }), a.d(e, "faCoffeeTogo", function () {
    return Yi;
  }), a.d(e, "faCoffin", function () {
    return Pi;
  }), a.d(e, "faCoffinCross", function () {
    return Fi;
  }), a.d(e, "faCog", function () {
    return Wi;
  }), a.d(e, "faCogs", function () {
    return Gi;
  }), a.d(e, "faCoin", function () {
    return qi;
  }), a.d(e, "faCoins", function () {
    return Ji;
  }), a.d(e, "faColumns", function () {
    return Ki;
  }), a.d(e, "faComet", function () {
    return Xi;
  }), a.d(e, "faComment", function () {
    return _i;
  }), a.d(e, "faCommentAlt", function () {
    return $i;
  }), a.d(e, "faCommentAltCheck", function () {
    return co;
  }), a.d(e, "faCommentAltDollar", function () {
    return eo;
  }), a.d(e, "faCommentAltDots", function () {
    return ao;
  }), a.d(e, "faCommentAltEdit", function () {
    return no;
  }), a.d(e, "faCommentAltExclamation", function () {
    return to;
  }), a.d(e, "faCommentAltLines", function () {
    return ro;
  }), a.d(e, "faCommentAltMedical", function () {
    return io;
  }), a.d(e, "faCommentAltMinus", function () {
    return oo;
  }), a.d(e, "faCommentAltMusic", function () {
    return lo;
  }), a.d(e, "faCommentAltPlus", function () {
    return fo;
  }), a.d(e, "faCommentAltSlash", function () {
    return so;
  }), a.d(e, "faCommentAltSmile", function () {
    return uo;
  }), a.d(e, "faCommentAltTimes", function () {
    return ho;
  }), a.d(e, "faCommentCheck", function () {
    return mo;
  }), a.d(e, "faCommentDollar", function () {
    return vo;
  }), a.d(e, "faCommentDots", function () {
    return Mo;
  }), a.d(e, "faCommentEdit", function () {
    return po;
  }), a.d(e, "faCommentExclamation", function () {
    return zo;
  }), a.d(e, "faCommentLines", function () {
    return Co;
  }), a.d(e, "faCommentMedical", function () {
    return Lo;
  }), a.d(e, "faCommentMinus", function () {
    return Ao;
  }), a.d(e, "faCommentMusic", function () {
    return No;
  }), a.d(e, "faCommentPlus", function () {
    return go;
  }), a.d(e, "faCommentSlash", function () {
    return Ho;
  }), a.d(e, "faCommentSmile", function () {
    return Vo;
  }), a.d(e, "faCommentTimes", function () {
    return xo;
  }), a.d(e, "faComments", function () {
    return wo;
  }), a.d(e, "faCommentsAlt", function () {
    return yo;
  }), a.d(e, "faCommentsAltDollar", function () {
    return bo;
  }), a.d(e, "faCommentsDollar", function () {
    return So;
  }), a.d(e, "faCompactDisc", function () {
    return To;
  }), a.d(e, "faCompass", function () {
    return Do;
  }), a.d(e, "faCompassSlash", function () {
    return jo;
  }), a.d(e, "faCompress", function () {
    return Eo;
  }), a.d(e, "faCompressAlt", function () {
    return ko;
  }), a.d(e, "faCompressArrowsAlt", function () {
    return Io;
  }), a.d(e, "faCompressWide", function () {
    return Oo;
  }), a.d(e, "faComputerClassic", function () {
    return Qo;
  }), a.d(e, "faComputerSpeaker", function () {
    return Zo;
  }), a.d(e, "faConciergeBell", function () {
    return Uo;
  }), a.d(e, "faConstruction", function () {
    return Bo;
  }), a.d(e, "faContainerStorage", function () {
    return Ro;
  }), a.d(e, "faConveyorBelt", function () {
    return Yo;
  }), a.d(e, "faConveyorBeltAlt", function () {
    return Po;
  }), a.d(e, "faCookie", function () {
    return Fo;
  }), a.d(e, "faCookieBite", function () {
    return Wo;
  }), a.d(e, "faCopy", function () {
    return Go;
  }), a.d(e, "faCopyright", function () {
    return qo;
  }), a.d(e, "faCorn", function () {
    return Jo;
  }), a.d(e, "faCouch", function () {
    return Ko;
  }), a.d(e, "faCow", function () {
    return Xo;
  }), a.d(e, "faCowbell", function () {
    return _o;
  }), a.d(e, "faCowbellMore", function () {
    return $o;
  }), a.d(e, "faCreditCard", function () {
    return cl;
  }), a.d(e, "faCreditCardBlank", function () {
    return el;
  }), a.d(e, "faCreditCardFront", function () {
    return al;
  }), a.d(e, "faCricket", function () {
    return nl;
  }), a.d(e, "faCroissant", function () {
    return tl;
  }), a.d(e, "faCrop", function () {
    return rl;
  }), a.d(e, "faCropAlt", function () {
    return il;
  }), a.d(e, "faCross", function () {
    return ol;
  }), a.d(e, "faCrosshairs", function () {
    return ll;
  }), a.d(e, "faCrow", function () {
    return fl;
  }), a.d(e, "faCrown", function () {
    return sl;
  }), a.d(e, "faCrutch", function () {
    return ul;
  }), a.d(e, "faCrutches", function () {
    return hl;
  }), a.d(e, "faCube", function () {
    return ml;
  }), a.d(e, "faCubes", function () {
    return vl;
  }), a.d(e, "faCurling", function () {
    return dl;
  }), a.d(e, "faCut", function () {
    return Ml;
  }), a.d(e, "faDagger", function () {
    return pl;
  }), a.d(e, "faDatabase", function () {
    return zl;
  }), a.d(e, "faDeaf", function () {
    return Cl;
  }), a.d(e, "faDebug", function () {
    return Ll;
  }), a.d(e, "faDeer", function () {
    return Al;
  }), a.d(e, "faDeerRudolph", function () {
    return Nl;
  }), a.d(e, "faDemocrat", function () {
    return gl;
  }), a.d(e, "faDesktop", function () {
    return Hl;
  }), a.d(e, "faDesktopAlt", function () {
    return Vl;
  }), a.d(e, "faDewpoint", function () {
    return xl;
  }), a.d(e, "faDharmachakra", function () {
    return wl;
  }), a.d(e, "faDiagnoses", function () {
    return yl;
  }), a.d(e, "faDiamond", function () {
    return bl;
  }), a.d(e, "faDice", function () {
    return Sl;
  }), a.d(e, "faDiceD10", function () {
    return Tl;
  }), a.d(e, "faDiceD12", function () {
    return Dl;
  }), a.d(e, "faDiceD20", function () {
    return jl;
  }), a.d(e, "faDiceD4", function () {
    return El;
  }), a.d(e, "faDiceD6", function () {
    return kl;
  }), a.d(e, "faDiceD8", function () {
    return Il;
  }), a.d(e, "faDiceFive", function () {
    return Ol;
  }), a.d(e, "faDiceFour", function () {
    return Ql;
  }), a.d(e, "faDiceOne", function () {
    return Zl;
  }), a.d(e, "faDiceSix", function () {
    return Ul;
  }), a.d(e, "faDiceThree", function () {
    return Bl;
  }), a.d(e, "faDiceTwo", function () {
    return Rl;
  }), a.d(e, "faDigging", function () {
    return Yl;
  }), a.d(e, "faDigitalTachograph", function () {
    return Pl;
  }), a.d(e, "faDiploma", function () {
    return Fl;
  }), a.d(e, "faDirections", function () {
    return Wl;
  }), a.d(e, "faDiscDrive", function () {
    return Gl;
  }), a.d(e, "faDisease", function () {
    return ql;
  }), a.d(e, "faDivide", function () {
    return Jl;
  }), a.d(e, "faDizzy", function () {
    return Kl;
  }), a.d(e, "faDna", function () {
    return Xl;
  }), a.d(e, "faDoNotEnter", function () {
    return _l;
  }), a.d(e, "faDog", function () {
    return $l;
  }), a.d(e, "faDogLeashed", function () {
    return cf;
  }), a.d(e, "faDollarSign", function () {
    return ef;
  }), a.d(e, "faDolly", function () {
    return af;
  }), a.d(e, "faDollyEmpty", function () {
    return nf;
  }), a.d(e, "faDollyFlatbed", function () {
    return tf;
  }), a.d(e, "faDollyFlatbedAlt", function () {
    return rf;
  }), a.d(e, "faDollyFlatbedEmpty", function () {
    return of;
  }), a.d(e, "faDonate", function () {
    return lf;
  }), a.d(e, "faDoorClosed", function () {
    return ff;
  }), a.d(e, "faDoorOpen", function () {
    return sf;
  }), a.d(e, "faDotCircle", function () {
    return uf;
  }), a.d(e, "faDove", function () {
    return hf;
  }), a.d(e, "faDownload", function () {
    return mf;
  }), a.d(e, "faDraftingCompass", function () {
    return vf;
  }), a.d(e, "faDragon", function () {
    return df;
  }), a.d(e, "faDrawCircle", function () {
    return Mf;
  }), a.d(e, "faDrawPolygon", function () {
    return pf;
  }), a.d(e, "faDrawSquare", function () {
    return zf;
  }), a.d(e, "faDreidel", function () {
    return Cf;
  }), a.d(e, "faDrone", function () {
    return Lf;
  }), a.d(e, "faDroneAlt", function () {
    return Af;
  }), a.d(e, "faDrum", function () {
    return Nf;
  }), a.d(e, "faDrumSteelpan", function () {
    return gf;
  }), a.d(e, "faDrumstick", function () {
    return Hf;
  }), a.d(e, "faDrumstickBite", function () {
    return Vf;
  }), a.d(e, "faDryer", function () {
    return xf;
  }), a.d(e, "faDryerAlt", function () {
    return wf;
  }), a.d(e, "faDuck", function () {
    return yf;
  }), a.d(e, "faDumbbell", function () {
    return bf;
  }), a.d(e, "faDumpster", function () {
    return Sf;
  }), a.d(e, "faDumpsterFire", function () {
    return Tf;
  }), a.d(e, "faDungeon", function () {
    return Df;
  }), a.d(e, "faEar", function () {
    return jf;
  }), a.d(e, "faEarMuffs", function () {
    return Ef;
  }), a.d(e, "faEclipse", function () {
    return kf;
  }), a.d(e, "faEclipseAlt", function () {
    return If;
  }), a.d(e, "faEdit", function () {
    return Of;
  }), a.d(e, "faEgg", function () {
    return Qf;
  }), a.d(e, "faEggFried", function () {
    return Zf;
  }), a.d(e, "faEject", function () {
    return Uf;
  }), a.d(e, "faElephant", function () {
    return Bf;
  }), a.d(e, "faEllipsisH", function () {
    return Rf;
  }), a.d(e, "faEllipsisHAlt", function () {
    return Yf;
  }), a.d(e, "faEllipsisV", function () {
    return Pf;
  }), a.d(e, "faEllipsisVAlt", function () {
    return Ff;
  }), a.d(e, "faEmptySet", function () {
    return Wf;
  }), a.d(e, "faEngineWarning", function () {
    return Gf;
  }), a.d(e, "faEnvelope", function () {
    return qf;
  }), a.d(e, "faEnvelopeOpen", function () {
    return Jf;
  }), a.d(e, "faEnvelopeOpenDollar", function () {
    return Kf;
  }), a.d(e, "faEnvelopeOpenText", function () {
    return Xf;
  }), a.d(e, "faEnvelopeSquare", function () {
    return _f;
  }), a.d(e, "faEquals", function () {
    return $f;
  }), a.d(e, "faEraser", function () {
    return cs;
  }), a.d(e, "faEthernet", function () {
    return es;
  }), a.d(e, "faEuroSign", function () {
    return as;
  }), a.d(e, "faExchange", function () {
    return ns;
  }), a.d(e, "faExchangeAlt", function () {
    return ts;
  }), a.d(e, "faExclamation", function () {
    return rs;
  }), a.d(e, "faExclamationCircle", function () {
    return is;
  }), a.d(e, "faExclamationSquare", function () {
    return os;
  }), a.d(e, "faExclamationTriangle", function () {
    return ls;
  }), a.d(e, "faExpand", function () {
    return fs;
  }), a.d(e, "faExpandAlt", function () {
    return ss;
  }), a.d(e, "faExpandArrows", function () {
    return us;
  }), a.d(e, "faExpandArrowsAlt", function () {
    return hs;
  }), a.d(e, "faExpandWide", function () {
    return ms;
  }), a.d(e, "faExternalLink", function () {
    return vs;
  }), a.d(e, "faExternalLinkAlt", function () {
    return ds;
  }), a.d(e, "faExternalLinkSquare", function () {
    return Ms;
  }), a.d(e, "faExternalLinkSquareAlt", function () {
    return ps;
  }), a.d(e, "faEye", function () {
    return zs;
  }), a.d(e, "faEyeDropper", function () {
    return Cs;
  }), a.d(e, "faEyeEvil", function () {
    return Ls;
  }), a.d(e, "faEyeSlash", function () {
    return As;
  }), a.d(e, "faFan", function () {
    return Ns;
  }), a.d(e, "faFanTable", function () {
    return gs;
  }), a.d(e, "faFarm", function () {
    return Hs;
  }), a.d(e, "faFastBackward", function () {
    return Vs;
  }), a.d(e, "faFastForward", function () {
    return xs;
  }), a.d(e, "faFaucet", function () {
    return ws;
  }), a.d(e, "faFaucetDrip", function () {
    return ys;
  }), a.d(e, "faFax", function () {
    return bs;
  }), a.d(e, "faFeather", function () {
    return Ss;
  }), a.d(e, "faFeatherAlt", function () {
    return Ts;
  }), a.d(e, "faFemale", function () {
    return Ds;
  }), a.d(e, "faFieldHockey", function () {
    return js;
  }), a.d(e, "faFighterJet", function () {
    return Es;
  }), a.d(e, "faFile", function () {
    return ks;
  }), a.d(e, "faFileAlt", function () {
    return Is;
  }), a.d(e, "faFileArchive", function () {
    return Os;
  }), a.d(e, "faFileAudio", function () {
    return Qs;
  }), a.d(e, "faFileCertificate", function () {
    return Zs;
  }), a.d(e, "faFileChartLine", function () {
    return Us;
  }), a.d(e, "faFileChartPie", function () {
    return Bs;
  }), a.d(e, "faFileCheck", function () {
    return Rs;
  }), a.d(e, "faFileCode", function () {
    return Ys;
  }), a.d(e, "faFileContract", function () {
    return Ps;
  }), a.d(e, "faFileCsv", function () {
    return Fs;
  }), a.d(e, "faFileDownload", function () {
    return Ws;
  }), a.d(e, "faFileEdit", function () {
    return Gs;
  }), a.d(e, "faFileExcel", function () {
    return qs;
  }), a.d(e, "faFileExclamation", function () {
    return Js;
  }), a.d(e, "faFileExport", function () {
    return Ks;
  }), a.d(e, "faFileImage", function () {
    return Xs;
  }), a.d(e, "faFileImport", function () {
    return _s;
  }), a.d(e, "faFileInvoice", function () {
    return $s;
  }), a.d(e, "faFileInvoiceDollar", function () {
    return cu;
  }), a.d(e, "faFileMedical", function () {
    return eu;
  }), a.d(e, "faFileMedicalAlt", function () {
    return au;
  }), a.d(e, "faFileMinus", function () {
    return nu;
  }), a.d(e, "faFileMusic", function () {
    return tu;
  }), a.d(e, "faFilePdf", function () {
    return ru;
  }), a.d(e, "faFilePlus", function () {
    return iu;
  }), a.d(e, "faFilePowerpoint", function () {
    return ou;
  }), a.d(e, "faFilePrescription", function () {
    return lu;
  }), a.d(e, "faFileSearch", function () {
    return fu;
  }), a.d(e, "faFileSignature", function () {
    return su;
  }), a.d(e, "faFileSpreadsheet", function () {
    return uu;
  }), a.d(e, "faFileTimes", function () {
    return hu;
  }), a.d(e, "faFileUpload", function () {
    return mu;
  }), a.d(e, "faFileUser", function () {
    return vu;
  }), a.d(e, "faFileVideo", function () {
    return du;
  }), a.d(e, "faFileWord", function () {
    return Mu;
  }), a.d(e, "faFilesMedical", function () {
    return pu;
  }), a.d(e, "faFill", function () {
    return zu;
  }), a.d(e, "faFillDrip", function () {
    return Cu;
  }), a.d(e, "faFilm", function () {
    return Lu;
  }), a.d(e, "faFilmAlt", function () {
    return Au;
  }), a.d(e, "faFilmCanister", function () {
    return Nu;
  }), a.d(e, "faFilter", function () {
    return gu;
  }), a.d(e, "faFingerprint", function () {
    return Hu;
  }), a.d(e, "faFire", function () {
    return Vu;
  }), a.d(e, "faFireAlt", function () {
    return xu;
  }), a.d(e, "faFireExtinguisher", function () {
    return wu;
  }), a.d(e, "faFireSmoke", function () {
    return yu;
  }), a.d(e, "faFireplace", function () {
    return bu;
  }), a.d(e, "faFirstAid", function () {
    return Su;
  }), a.d(e, "faFish", function () {
    return Tu;
  }), a.d(e, "faFishCooked", function () {
    return Du;
  }), a.d(e, "faFistRaised", function () {
    return ju;
  }), a.d(e, "faFlag", function () {
    return Eu;
  }), a.d(e, "faFlagAlt", function () {
    return ku;
  }), a.d(e, "faFlagCheckered", function () {
    return Iu;
  }), a.d(e, "faFlagUsa", function () {
    return Ou;
  }), a.d(e, "faFlame", function () {
    return Qu;
  }), a.d(e, "faFlashlight", function () {
    return Zu;
  }), a.d(e, "faFlask", function () {
    return Uu;
  }), a.d(e, "faFlaskPoison", function () {
    return Bu;
  }), a.d(e, "faFlaskPotion", function () {
    return Ru;
  }), a.d(e, "faFlower", function () {
    return Yu;
  }), a.d(e, "faFlowerDaffodil", function () {
    return Pu;
  }), a.d(e, "faFlowerTulip", function () {
    return Fu;
  }), a.d(e, "faFlushed", function () {
    return Wu;
  }), a.d(e, "faFlute", function () {
    return Gu;
  }), a.d(e, "faFluxCapacitor", function () {
    return qu;
  }), a.d(e, "faFog", function () {
    return Ju;
  }), a.d(e, "faFolder", function () {
    return Ku;
  }), a.d(e, "faFolderDownload", function () {
    return Xu;
  }), a.d(e, "faFolderMinus", function () {
    return _u;
  }), a.d(e, "faFolderOpen", function () {
    return $u;
  }), a.d(e, "faFolderPlus", function () {
    return ch;
  }), a.d(e, "faFolderTimes", function () {
    return eh;
  }), a.d(e, "faFolderTree", function () {
    return ah;
  }), a.d(e, "faFolderUpload", function () {
    return nh;
  }), a.d(e, "faFolders", function () {
    return th;
  }), a.d(e, "faFont", function () {
    return rh;
  }), a.d(e, "faFontAwesomeLogoFull", function () {
    return ih;
  }), a.d(e, "faFontCase", function () {
    return oh;
  }), a.d(e, "faFootballBall", function () {
    return lh;
  }), a.d(e, "faFootballHelmet", function () {
    return fh;
  }), a.d(e, "faForklift", function () {
    return sh;
  }), a.d(e, "faForward", function () {
    return uh;
  }), a.d(e, "faFragile", function () {
    return hh;
  }), a.d(e, "faFrenchFries", function () {
    return mh;
  }), a.d(e, "faFrog", function () {
    return vh;
  }), a.d(e, "faFrostyHead", function () {
    return dh;
  }), a.d(e, "faFrown", function () {
    return Mh;
  }), a.d(e, "faFrownOpen", function () {
    return ph;
  }), a.d(e, "faFunction", function () {
    return zh;
  }), a.d(e, "faFunnelDollar", function () {
    return Ch;
  }), a.d(e, "faFutbol", function () {
    return Lh;
  }), a.d(e, "faGalaxy", function () {
    return Ah;
  }), a.d(e, "faGameBoard", function () {
    return Nh;
  }), a.d(e, "faGameBoardAlt", function () {
    return gh;
  }), a.d(e, "faGameConsoleHandheld", function () {
    return Hh;
  }), a.d(e, "faGamepad", function () {
    return Vh;
  }), a.d(e, "faGamepadAlt", function () {
    return xh;
  }), a.d(e, "faGarage", function () {
    return wh;
  }), a.d(e, "faGarageCar", function () {
    return yh;
  }), a.d(e, "faGarageOpen", function () {
    return bh;
  }), a.d(e, "faGasPump", function () {
    return Sh;
  }), a.d(e, "faGasPumpSlash", function () {
    return Th;
  }), a.d(e, "faGavel", function () {
    return Dh;
  }), a.d(e, "faGem", function () {
    return jh;
  }), a.d(e, "faGenderless", function () {
    return Eh;
  }), a.d(e, "faGhost", function () {
    return kh;
  }), a.d(e, "faGift", function () {
    return Ih;
  }), a.d(e, "faGiftCard", function () {
    return Oh;
  }), a.d(e, "faGifts", function () {
    return Qh;
  }), a.d(e, "faGingerbreadMan", function () {
    return Zh;
  }), a.d(e, "faGlass", function () {
    return Uh;
  }), a.d(e, "faGlassChampagne", function () {
    return Bh;
  }), a.d(e, "faGlassCheers", function () {
    return Rh;
  }), a.d(e, "faGlassCitrus", function () {
    return Yh;
  }), a.d(e, "faGlassMartini", function () {
    return Ph;
  }), a.d(e, "faGlassMartiniAlt", function () {
    return Fh;
  }), a.d(e, "faGlassWhiskey", function () {
    return Wh;
  }), a.d(e, "faGlassWhiskeyRocks", function () {
    return Gh;
  }), a.d(e, "faGlasses", function () {
    return qh;
  }), a.d(e, "faGlassesAlt", function () {
    return Jh;
  }), a.d(e, "faGlobe", function () {
    return Kh;
  }), a.d(e, "faGlobeAfrica", function () {
    return Xh;
  }), a.d(e, "faGlobeAmericas", function () {
    return _h;
  }), a.d(e, "faGlobeAsia", function () {
    return $h;
  }), a.d(e, "faGlobeEurope", function () {
    return cm;
  }), a.d(e, "faGlobeSnow", function () {
    return em;
  }), a.d(e, "faGlobeStand", function () {
    return am;
  }), a.d(e, "faGolfBall", function () {
    return nm;
  }), a.d(e, "faGolfClub", function () {
    return tm;
  }), a.d(e, "faGopuram", function () {
    return rm;
  }), a.d(e, "faGraduationCap", function () {
    return im;
  }), a.d(e, "faGramophone", function () {
    return om;
  }), a.d(e, "faGreaterThan", function () {
    return lm;
  }), a.d(e, "faGreaterThanEqual", function () {
    return fm;
  }), a.d(e, "faGrimace", function () {
    return sm;
  }), a.d(e, "faGrin", function () {
    return um;
  }), a.d(e, "faGrinAlt", function () {
    return hm;
  }), a.d(e, "faGrinBeam", function () {
    return mm;
  }), a.d(e, "faGrinBeamSweat", function () {
    return vm;
  }), a.d(e, "faGrinHearts", function () {
    return dm;
  }), a.d(e, "faGrinSquint", function () {
    return Mm;
  }), a.d(e, "faGrinSquintTears", function () {
    return pm;
  }), a.d(e, "faGrinStars", function () {
    return zm;
  }), a.d(e, "faGrinTears", function () {
    return Cm;
  }), a.d(e, "faGrinTongue", function () {
    return Lm;
  }), a.d(e, "faGrinTongueSquint", function () {
    return Am;
  }), a.d(e, "faGrinTongueWink", function () {
    return Nm;
  }), a.d(e, "faGrinWink", function () {
    return gm;
  }), a.d(e, "faGripHorizontal", function () {
    return Hm;
  }), a.d(e, "faGripLines", function () {
    return Vm;
  }), a.d(e, "faGripLinesVertical", function () {
    return xm;
  }), a.d(e, "faGripVertical", function () {
    return wm;
  }), a.d(e, "faGuitar", function () {
    return ym;
  }), a.d(e, "faGuitarElectric", function () {
    return bm;
  }), a.d(e, "faGuitars", function () {
    return Sm;
  }), a.d(e, "faHSquare", function () {
    return Tm;
  }), a.d(e, "faH1", function () {
    return Dm;
  }), a.d(e, "faH2", function () {
    return jm;
  }), a.d(e, "faH3", function () {
    return Em;
  }), a.d(e, "faH4", function () {
    return km;
  }), a.d(e, "faHamburger", function () {
    return Im;
  }), a.d(e, "faHammer", function () {
    return Om;
  }), a.d(e, "faHammerWar", function () {
    return Qm;
  }), a.d(e, "faHamsa", function () {
    return Zm;
  }), a.d(e, "faHandHeart", function () {
    return Um;
  }), a.d(e, "faHandHolding", function () {
    return Bm;
  }), a.d(e, "faHandHoldingBox", function () {
    return Rm;
  }), a.d(e, "faHandHoldingHeart", function () {
    return Ym;
  }), a.d(e, "faHandHoldingMagic", function () {
    return Pm;
  }), a.d(e, "faHandHoldingMedical", function () {
    return Fm;
  }), a.d(e, "faHandHoldingSeedling", function () {
    return Wm;
  }), a.d(e, "faHandHoldingUsd", function () {
    return Gm;
  });
  a.d(e, "faHandHoldingWater", function () {
    return qm;
  }), a.d(e, "faHandLizard", function () {
    return Jm;
  }), a.d(e, "faHandMiddleFinger", function () {
    return Km;
  }), a.d(e, "faHandPaper", function () {
    return Xm;
  }), a.d(e, "faHandPeace", function () {
    return _m;
  }), a.d(e, "faHandPointDown", function () {
    return $m;
  }), a.d(e, "faHandPointLeft", function () {
    return cv;
  }), a.d(e, "faHandPointRight", function () {
    return ev;
  }), a.d(e, "faHandPointUp", function () {
    return av;
  }), a.d(e, "faHandPointer", function () {
    return nv;
  }), a.d(e, "faHandReceiving", function () {
    return tv;
  }), a.d(e, "faHandRock", function () {
    return rv;
  }), a.d(e, "faHandScissors", function () {
    return iv;
  }), a.d(e, "faHandSparkles", function () {
    return ov;
  }), a.d(e, "faHandSpock", function () {
    return lv;
  }), a.d(e, "faHands", function () {
    return fv;
  }), a.d(e, "faHandsHeart", function () {
    return sv;
  }), a.d(e, "faHandsHelping", function () {
    return uv;
  }), a.d(e, "faHandsUsd", function () {
    return hv;
  }), a.d(e, "faHandsWash", function () {
    return mv;
  }), a.d(e, "faHandshake", function () {
    return vv;
  }), a.d(e, "faHandshakeAlt", function () {
    return dv;
  }), a.d(e, "faHandshakeAltSlash", function () {
    return Mv;
  }), a.d(e, "faHandshakeSlash", function () {
    return pv;
  }), a.d(e, "faHanukiah", function () {
    return zv;
  }), a.d(e, "faHardHat", function () {
    return Cv;
  }), a.d(e, "faHashtag", function () {
    return Lv;
  }), a.d(e, "faHatChef", function () {
    return Av;
  }), a.d(e, "faHatCowboy", function () {
    return Nv;
  }), a.d(e, "faHatCowboySide", function () {
    return gv;
  }), a.d(e, "faHatSanta", function () {
    return Hv;
  }), a.d(e, "faHatWinter", function () {
    return Vv;
  }), a.d(e, "faHatWitch", function () {
    return xv;
  }), a.d(e, "faHatWizard", function () {
    return wv;
  }), a.d(e, "faHdd", function () {
    return yv;
  }), a.d(e, "faHeadSide", function () {
    return bv;
  }), a.d(e, "faHeadSideBrain", function () {
    return Sv;
  }), a.d(e, "faHeadSideCough", function () {
    return Tv;
  }), a.d(e, "faHeadSideCoughSlash", function () {
    return Dv;
  }), a.d(e, "faHeadSideHeadphones", function () {
    return jv;
  }), a.d(e, "faHeadSideMask", function () {
    return Ev;
  }), a.d(e, "faHeadSideMedical", function () {
    return kv;
  }), a.d(e, "faHeadSideVirus", function () {
    return Iv;
  }), a.d(e, "faHeadVr", function () {
    return Ov;
  }), a.d(e, "faHeading", function () {
    return Qv;
  }), a.d(e, "faHeadphones", function () {
    return Zv;
  }), a.d(e, "faHeadphonesAlt", function () {
    return Uv;
  }), a.d(e, "faHeadset", function () {
    return Bv;
  }), a.d(e, "faHeart", function () {
    return Rv;
  }), a.d(e, "faHeartBroken", function () {
    return Yv;
  }), a.d(e, "faHeartCircle", function () {
    return Pv;
  }), a.d(e, "faHeartRate", function () {
    return Fv;
  }), a.d(e, "faHeartSquare", function () {
    return Wv;
  }), a.d(e, "faHeartbeat", function () {
    return Gv;
  }), a.d(e, "faHeat", function () {
    return qv;
  }), a.d(e, "faHelicopter", function () {
    return Jv;
  }), a.d(e, "faHelmetBattle", function () {
    return Kv;
  }), a.d(e, "faHexagon", function () {
    return Xv;
  }), a.d(e, "faHighlighter", function () {
    return _v;
  }), a.d(e, "faHiking", function () {
    return $v;
  }), a.d(e, "faHippo", function () {
    return cd;
  }), a.d(e, "faHistory", function () {
    return ed;
  }), a.d(e, "faHockeyMask", function () {
    return ad;
  }), a.d(e, "faHockeyPuck", function () {
    return nd;
  }), a.d(e, "faHockeySticks", function () {
    return td;
  }), a.d(e, "faHollyBerry", function () {
    return rd;
  }), a.d(e, "faHome", function () {
    return id;
  }), a.d(e, "faHomeAlt", function () {
    return od;
  }), a.d(e, "faHomeHeart", function () {
    return ld;
  }), a.d(e, "faHomeLg", function () {
    return fd;
  }), a.d(e, "faHomeLgAlt", function () {
    return sd;
  }), a.d(e, "faHoodCloak", function () {
    return ud;
  }), a.d(e, "faHorizontalRule", function () {
    return hd;
  }), a.d(e, "faHorse", function () {
    return md;
  }), a.d(e, "faHorseHead", function () {
    return vd;
  }), a.d(e, "faHorseSaddle", function () {
    return dd;
  }), a.d(e, "faHospital", function () {
    return Md;
  }), a.d(e, "faHospitalAlt", function () {
    return pd;
  }), a.d(e, "faHospitalSymbol", function () {
    return zd;
  }), a.d(e, "faHospitalUser", function () {
    return Cd;
  }), a.d(e, "faHospitals", function () {
    return Ld;
  }), a.d(e, "faHotTub", function () {
    return Ad;
  }), a.d(e, "faHotdog", function () {
    return Nd;
  }), a.d(e, "faHotel", function () {
    return gd;
  }), a.d(e, "faHourglass", function () {
    return Hd;
  }), a.d(e, "faHourglassEnd", function () {
    return Vd;
  }), a.d(e, "faHourglassHalf", function () {
    return xd;
  }), a.d(e, "faHourglassStart", function () {
    return wd;
  }), a.d(e, "faHouse", function () {
    return yd;
  }), a.d(e, "faHouseDamage", function () {
    return bd;
  }), a.d(e, "faHouseDay", function () {
    return Sd;
  }), a.d(e, "faHouseFlood", function () {
    return Td;
  }), a.d(e, "faHouseLeave", function () {
    return Dd;
  }), a.d(e, "faHouseNight", function () {
    return jd;
  }), a.d(e, "faHouseReturn", function () {
    return Ed;
  }), a.d(e, "faHouseSignal", function () {
    return kd;
  }), a.d(e, "faHouseUser", function () {
    return Id;
  }), a.d(e, "faHryvnia", function () {
    return Od;
  }), a.d(e, "faHumidity", function () {
    return Qd;
  }), a.d(e, "faHurricane", function () {
    return Zd;
  }), a.d(e, "faICursor", function () {
    return Ud;
  }), a.d(e, "faIceCream", function () {
    return Bd;
  }), a.d(e, "faIceSkate", function () {
    return Rd;
  }), a.d(e, "faIcicles", function () {
    return Yd;
  }), a.d(e, "faIcons", function () {
    return Pd;
  }), a.d(e, "faIconsAlt", function () {
    return Fd;
  }), a.d(e, "faIdBadge", function () {
    return Wd;
  }), a.d(e, "faIdCard", function () {
    return Gd;
  }), a.d(e, "faIdCardAlt", function () {
    return qd;
  }), a.d(e, "faIgloo", function () {
    return Jd;
  }), a.d(e, "faImage", function () {
    return Kd;
  }), a.d(e, "faImagePolaroid", function () {
    return Xd;
  }), a.d(e, "faImages", function () {
    return _d;
  }), a.d(e, "faInbox", function () {
    return $d;
  }), a.d(e, "faInboxIn", function () {
    return cM;
  }), a.d(e, "faInboxOut", function () {
    return eM;
  }), a.d(e, "faIndent", function () {
    return aM;
  }), a.d(e, "faIndustry", function () {
    return nM;
  }), a.d(e, "faIndustryAlt", function () {
    return tM;
  }), a.d(e, "faInfinity", function () {
    return rM;
  }), a.d(e, "faInfo", function () {
    return iM;
  }), a.d(e, "faInfoCircle", function () {
    return oM;
  }), a.d(e, "faInfoSquare", function () {
    return lM;
  }), a.d(e, "faInhaler", function () {
    return fM;
  }), a.d(e, "faIntegral", function () {
    return sM;
  }), a.d(e, "faIntersection", function () {
    return uM;
  }), a.d(e, "faInventory", function () {
    return hM;
  }), a.d(e, "faIslandTropical", function () {
    return mM;
  }), a.d(e, "faItalic", function () {
    return vM;
  }), a.d(e, "faJackOLantern", function () {
    return dM;
  }), a.d(e, "faJedi", function () {
    return MM;
  }), a.d(e, "faJoint", function () {
    return pM;
  }), a.d(e, "faJournalWhills", function () {
    return zM;
  }), a.d(e, "faJoystick", function () {
    return CM;
  }), a.d(e, "faJug", function () {
    return LM;
  }), a.d(e, "faKaaba", function () {
    return AM;
  }), a.d(e, "faKazoo", function () {
    return NM;
  }), a.d(e, "faKerning", function () {
    return gM;
  }), a.d(e, "faKey", function () {
    return HM;
  }), a.d(e, "faKeySkeleton", function () {
    return VM;
  }), a.d(e, "faKeyboard", function () {
    return xM;
  }), a.d(e, "faKeynote", function () {
    return wM;
  }), a.d(e, "faKhanda", function () {
    return yM;
  }), a.d(e, "faKidneys", function () {
    return bM;
  }), a.d(e, "faKiss", function () {
    return SM;
  }), a.d(e, "faKissBeam", function () {
    return TM;
  }), a.d(e, "faKissWinkHeart", function () {
    return DM;
  }), a.d(e, "faKite", function () {
    return jM;
  }), a.d(e, "faKiwiBird", function () {
    return EM;
  }), a.d(e, "faKnifeKitchen", function () {
    return kM;
  }), a.d(e, "faLambda", function () {
    return IM;
  }), a.d(e, "faLamp", function () {
    return OM;
  }), a.d(e, "faLampDesk", function () {
    return QM;
  }), a.d(e, "faLampFloor", function () {
    return ZM;
  }), a.d(e, "faLandmark", function () {
    return UM;
  }), a.d(e, "faLandmarkAlt", function () {
    return BM;
  }), a.d(e, "faLanguage", function () {
    return RM;
  }), a.d(e, "faLaptop", function () {
    return YM;
  }), a.d(e, "faLaptopCode", function () {
    return PM;
  }), a.d(e, "faLaptopHouse", function () {
    return FM;
  }), a.d(e, "faLaptopMedical", function () {
    return WM;
  }), a.d(e, "faLasso", function () {
    return GM;
  }), a.d(e, "faLaugh", function () {
    return qM;
  }), a.d(e, "faLaughBeam", function () {
    return JM;
  }), a.d(e, "faLaughSquint", function () {
    return KM;
  }), a.d(e, "faLaughWink", function () {
    return XM;
  }), a.d(e, "faLayerGroup", function () {
    return _M;
  }), a.d(e, "faLayerMinus", function () {
    return $M;
  }), a.d(e, "faLayerPlus", function () {
    return cp;
  }), a.d(e, "faLeaf", function () {
    return ep;
  }), a.d(e, "faLeafHeart", function () {
    return ap;
  }), a.d(e, "faLeafMaple", function () {
    return np;
  }), a.d(e, "faLeafOak", function () {
    return tp;
  }), a.d(e, "faLemon", function () {
    return rp;
  }), a.d(e, "faLessThan", function () {
    return ip;
  }), a.d(e, "faLessThanEqual", function () {
    return op;
  }), a.d(e, "faLevelDown", function () {
    return lp;
  }), a.d(e, "faLevelDownAlt", function () {
    return fp;
  }), a.d(e, "faLevelUp", function () {
    return sp;
  }), a.d(e, "faLevelUpAlt", function () {
    return up;
  }), a.d(e, "faLifeRing", function () {
    return hp;
  }), a.d(e, "faLightCeiling", function () {
    return mp;
  }), a.d(e, "faLightSwitch", function () {
    return vp;
  }), a.d(e, "faLightSwitchOff", function () {
    return dp;
  }), a.d(e, "faLightSwitchOn", function () {
    return Mp;
  }), a.d(e, "faLightbulb", function () {
    return pp;
  }), a.d(e, "faLightbulbDollar", function () {
    return zp;
  }), a.d(e, "faLightbulbExclamation", function () {
    return Cp;
  }), a.d(e, "faLightbulbOn", function () {
    return Lp;
  }), a.d(e, "faLightbulbSlash", function () {
    return Ap;
  }), a.d(e, "faLightsHoliday", function () {
    return Np;
  }), a.d(e, "faLineColumns", function () {
    return gp;
  }), a.d(e, "faLineHeight", function () {
    return Hp;
  }), a.d(e, "faLink", function () {
    return Vp;
  }), a.d(e, "faLips", function () {
    return xp;
  }), a.d(e, "faLiraSign", function () {
    return wp;
  }), a.d(e, "faList", function () {
    return yp;
  }), a.d(e, "faListAlt", function () {
    return bp;
  }), a.d(e, "faListMusic", function () {
    return Sp;
  }), a.d(e, "faListOl", function () {
    return Tp;
  }), a.d(e, "faListUl", function () {
    return Dp;
  }), a.d(e, "faLocation", function () {
    return jp;
  }), a.d(e, "faLocationArrow", function () {
    return Ep;
  }), a.d(e, "faLocationCircle", function () {
    return kp;
  }), a.d(e, "faLocationSlash", function () {
    return Ip;
  }), a.d(e, "faLock", function () {
    return Op;
  }), a.d(e, "faLockAlt", function () {
    return Qp;
  }), a.d(e, "faLockOpen", function () {
    return Zp;
  }), a.d(e, "faLockOpenAlt", function () {
    return Up;
  }), a.d(e, "faLongArrowAltDown", function () {
    return Bp;
  }), a.d(e, "faLongArrowAltLeft", function () {
    return Rp;
  }), a.d(e, "faLongArrowAltRight", function () {
    return Yp;
  }), a.d(e, "faLongArrowAltUp", function () {
    return Pp;
  }), a.d(e, "faLongArrowDown", function () {
    return Fp;
  }), a.d(e, "faLongArrowLeft", function () {
    return Wp;
  }), a.d(e, "faLongArrowRight", function () {
    return Gp;
  }), a.d(e, "faLongArrowUp", function () {
    return qp;
  }), a.d(e, "faLoveseat", function () {
    return Jp;
  }), a.d(e, "faLowVision", function () {
    return Kp;
  }), a.d(e, "faLuchador", function () {
    return Xp;
  }), a.d(e, "faLuggageCart", function () {
    return _p;
  }), a.d(e, "faLungs", function () {
    return $p;
  }), a.d(e, "faLungsVirus", function () {
    return cz;
  }), a.d(e, "faMace", function () {
    return ez;
  }), a.d(e, "faMagic", function () {
    return az;
  }), a.d(e, "faMagnet", function () {
    return nz;
  }), a.d(e, "faMailBulk", function () {
    return tz;
  }), a.d(e, "faMailbox", function () {
    return rz;
  }), a.d(e, "faMale", function () {
    return iz;
  }), a.d(e, "faMandolin", function () {
    return oz;
  }), a.d(e, "faMap", function () {
    return lz;
  }), a.d(e, "faMapMarked", function () {
    return fz;
  }), a.d(e, "faMapMarkedAlt", function () {
    return sz;
  }), a.d(e, "faMapMarker", function () {
    return uz;
  }), a.d(e, "faMapMarkerAlt", function () {
    return hz;
  }), a.d(e, "faMapMarkerAltSlash", function () {
    return mz;
  }), a.d(e, "faMapMarkerCheck", function () {
    return vz;
  }), a.d(e, "faMapMarkerEdit", function () {
    return dz;
  }), a.d(e, "faMapMarkerExclamation", function () {
    return Mz;
  }), a.d(e, "faMapMarkerMinus", function () {
    return pz;
  }), a.d(e, "faMapMarkerPlus", function () {
    return zz;
  }), a.d(e, "faMapMarkerQuestion", function () {
    return Cz;
  }), a.d(e, "faMapMarkerSlash", function () {
    return Lz;
  }), a.d(e, "faMapMarkerSmile", function () {
    return Az;
  }), a.d(e, "faMapMarkerTimes", function () {
    return Nz;
  }), a.d(e, "faMapPin", function () {
    return gz;
  }), a.d(e, "faMapSigns", function () {
    return Hz;
  }), a.d(e, "faMarker", function () {
    return Vz;
  }), a.d(e, "faMars", function () {
    return xz;
  }), a.d(e, "faMarsDouble", function () {
    return wz;
  }), a.d(e, "faMarsStroke", function () {
    return yz;
  }), a.d(e, "faMarsStrokeH", function () {
    return bz;
  }), a.d(e, "faMarsStrokeV", function () {
    return Sz;
  }), a.d(e, "faMask", function () {
    return Tz;
  }), a.d(e, "faMeat", function () {
    return Dz;
  }), a.d(e, "faMedal", function () {
    return jz;
  }), a.d(e, "faMedkit", function () {
    return Ez;
  }), a.d(e, "faMegaphone", function () {
    return kz;
  }), a.d(e, "faMeh", function () {
    return Iz;
  }), a.d(e, "faMehBlank", function () {
    return Oz;
  }), a.d(e, "faMehRollingEyes", function () {
    return Qz;
  }), a.d(e, "faMemory", function () {
    return Zz;
  }), a.d(e, "faMenorah", function () {
    return Uz;
  }), a.d(e, "faMercury", function () {
    return Bz;
  }), a.d(e, "faMeteor", function () {
    return Rz;
  }), a.d(e, "faMicrochip", function () {
    return Yz;
  }), a.d(e, "faMicrophone", function () {
    return Pz;
  }), a.d(e, "faMicrophoneAlt", function () {
    return Fz;
  }), a.d(e, "faMicrophoneAltSlash", function () {
    return Wz;
  }), a.d(e, "faMicrophoneSlash", function () {
    return Gz;
  }), a.d(e, "faMicrophoneStand", function () {
    return qz;
  }), a.d(e, "faMicroscope", function () {
    return Jz;
  }), a.d(e, "faMicrowave", function () {
    return Kz;
  }), a.d(e, "faMindShare", function () {
    return Xz;
  }), a.d(e, "faMinus", function () {
    return _z;
  }), a.d(e, "faMinusCircle", function () {
    return $z;
  }), a.d(e, "faMinusHexagon", function () {
    return cC;
  }), a.d(e, "faMinusOctagon", function () {
    return eC;
  }), a.d(e, "faMinusSquare", function () {
    return aC;
  }), a.d(e, "faMistletoe", function () {
    return nC;
  }), a.d(e, "faMitten", function () {
    return tC;
  }), a.d(e, "faMobile", function () {
    return rC;
  }), a.d(e, "faMobileAlt", function () {
    return iC;
  }), a.d(e, "faMobileAndroid", function () {
    return oC;
  }), a.d(e, "faMobileAndroidAlt", function () {
    return lC;
  }), a.d(e, "faMoneyBill", function () {
    return fC;
  }), a.d(e, "faMoneyBillAlt", function () {
    return sC;
  }), a.d(e, "faMoneyBillWave", function () {
    return uC;
  }), a.d(e, "faMoneyBillWaveAlt", function () {
    return hC;
  }), a.d(e, "faMoneyCheck", function () {
    return mC;
  }), a.d(e, "faMoneyCheckAlt", function () {
    return vC;
  }), a.d(e, "faMoneyCheckEdit", function () {
    return dC;
  }), a.d(e, "faMoneyCheckEditAlt", function () {
    return MC;
  }), a.d(e, "faMonitorHeartRate", function () {
    return pC;
  }), a.d(e, "faMonkey", function () {
    return zC;
  }), a.d(e, "faMonument", function () {
    return CC;
  }), a.d(e, "faMoon", function () {
    return LC;
  }), a.d(e, "faMoonCloud", function () {
    return AC;
  }), a.d(e, "faMoonStars", function () {
    return NC;
  }), a.d(e, "faMortarPestle", function () {
    return gC;
  }), a.d(e, "faMosque", function () {
    return HC;
  }), a.d(e, "faMotorcycle", function () {
    return VC;
  }), a.d(e, "faMountain", function () {
    return xC;
  }), a.d(e, "faMountains", function () {
    return wC;
  }), a.d(e, "faMouse", function () {
    return yC;
  }), a.d(e, "faMouseAlt", function () {
    return bC;
  }), a.d(e, "faMousePointer", function () {
    return SC;
  }), a.d(e, "faMp3Player", function () {
    return TC;
  }), a.d(e, "faMug", function () {
    return DC;
  }), a.d(e, "faMugHot", function () {
    return jC;
  }), a.d(e, "faMugMarshmallows", function () {
    return EC;
  }), a.d(e, "faMugTea", function () {
    return kC;
  }), a.d(e, "faMusic", function () {
    return IC;
  }), a.d(e, "faMusicAlt", function () {
    return OC;
  }), a.d(e, "faMusicAltSlash", function () {
    return QC;
  }), a.d(e, "faMusicSlash", function () {
    return ZC;
  }), a.d(e, "faNarwhal", function () {
    return UC;
  }), a.d(e, "faNetworkWired", function () {
    return BC;
  }), a.d(e, "faNeuter", function () {
    return RC;
  }), a.d(e, "faNewspaper", function () {
    return YC;
  }), a.d(e, "faNotEqual", function () {
    return PC;
  }), a.d(e, "faNotesMedical", function () {
    return FC;
  }), a.d(e, "faObjectGroup", function () {
    return WC;
  }), a.d(e, "faObjectUngroup", function () {
    return GC;
  }), a.d(e, "faOctagon", function () {
    return qC;
  }), a.d(e, "faOilCan", function () {
    return JC;
  }), a.d(e, "faOilTemp", function () {
    return KC;
  }), a.d(e, "faOm", function () {
    return XC;
  }), a.d(e, "faOmega", function () {
    return _C;
  }), a.d(e, "faOrnament", function () {
    return $C;
  }), a.d(e, "faOtter", function () {
    return cL;
  }), a.d(e, "faOutdent", function () {
    return eL;
  }), a.d(e, "faOutlet", function () {
    return aL;
  }), a.d(e, "faOven", function () {
    return nL;
  }), a.d(e, "faOverline", function () {
    return tL;
  }), a.d(e, "faPageBreak", function () {
    return rL;
  }), a.d(e, "faPager", function () {
    return iL;
  }), a.d(e, "faPaintBrush", function () {
    return oL;
  }), a.d(e, "faPaintBrushAlt", function () {
    return lL;
  }), a.d(e, "faPaintRoller", function () {
    return fL;
  }), a.d(e, "faPalette", function () {
    return sL;
  }), a.d(e, "faPallet", function () {
    return uL;
  }), a.d(e, "faPalletAlt", function () {
    return hL;
  }), a.d(e, "faPaperPlane", function () {
    return mL;
  }), a.d(e, "faPaperclip", function () {
    return vL;
  }), a.d(e, "faParachuteBox", function () {
    return dL;
  }), a.d(e, "faParagraph", function () {
    return ML;
  }), a.d(e, "faParagraphRtl", function () {
    return pL;
  }), a.d(e, "faParking", function () {
    return zL;
  }), a.d(e, "faParkingCircle", function () {
    return CL;
  }), a.d(e, "faParkingCircleSlash", function () {
    return LL;
  }), a.d(e, "faParkingSlash", function () {
    return AL;
  }), a.d(e, "faPassport", function () {
    return NL;
  }), a.d(e, "faPastafarianism", function () {
    return gL;
  }), a.d(e, "faPaste", function () {
    return HL;
  }), a.d(e, "faPause", function () {
    return VL;
  }), a.d(e, "faPauseCircle", function () {
    return xL;
  }), a.d(e, "faPaw", function () {
    return wL;
  }), a.d(e, "faPawAlt", function () {
    return yL;
  }), a.d(e, "faPawClaws", function () {
    return bL;
  }), a.d(e, "faPeace", function () {
    return SL;
  }), a.d(e, "faPegasus", function () {
    return TL;
  }), a.d(e, "faPen", function () {
    return DL;
  }), a.d(e, "faPenAlt", function () {
    return jL;
  }), a.d(e, "faPenFancy", function () {
    return EL;
  }), a.d(e, "faPenNib", function () {
    return kL;
  }), a.d(e, "faPenSquare", function () {
    return IL;
  }), a.d(e, "faPencil", function () {
    return OL;
  }), a.d(e, "faPencilAlt", function () {
    return QL;
  }), a.d(e, "faPencilPaintbrush", function () {
    return ZL;
  }), a.d(e, "faPencilRuler", function () {
    return UL;
  }), a.d(e, "faPennant", function () {
    return BL;
  }), a.d(e, "faPeopleArrows", function () {
    return RL;
  }), a.d(e, "faPeopleCarry", function () {
    return YL;
  }), a.d(e, "faPepperHot", function () {
    return PL;
  }), a.d(e, "faPercent", function () {
    return FL;
  }), a.d(e, "faPercentage", function () {
    return WL;
  }), a.d(e, "faPersonBooth", function () {
    return GL;
  }), a.d(e, "faPersonCarry", function () {
    return qL;
  }), a.d(e, "faPersonDolly", function () {
    return JL;
  }), a.d(e, "faPersonDollyEmpty", function () {
    return KL;
  }), a.d(e, "faPersonSign", function () {
    return XL;
  }), a.d(e, "faPhone", function () {
    return _L;
  }), a.d(e, "faPhoneAlt", function () {
    return $L;
  }), a.d(e, "faPhoneLaptop", function () {
    return cA;
  }), a.d(e, "faPhoneOffice", function () {
    return eA;
  }), a.d(e, "faPhonePlus", function () {
    return aA;
  }), a.d(e, "faPhoneRotary", function () {
    return nA;
  }), a.d(e, "faPhoneSlash", function () {
    return tA;
  }), a.d(e, "faPhoneSquare", function () {
    return rA;
  }), a.d(e, "faPhoneSquareAlt", function () {
    return iA;
  }), a.d(e, "faPhoneVolume", function () {
    return oA;
  }), a.d(e, "faPhotoVideo", function () {
    return lA;
  }), a.d(e, "faPi", function () {
    return fA;
  }), a.d(e, "faPiano", function () {
    return sA;
  }), a.d(e, "faPianoKeyboard", function () {
    return uA;
  }), a.d(e, "faPie", function () {
    return hA;
  }), a.d(e, "faPig", function () {
    return mA;
  }), a.d(e, "faPiggyBank", function () {
    return vA;
  }), a.d(e, "faPills", function () {
    return dA;
  }), a.d(e, "faPizza", function () {
    return MA;
  }), a.d(e, "faPizzaSlice", function () {
    return pA;
  }), a.d(e, "faPlaceOfWorship", function () {
    return zA;
  }), a.d(e, "faPlane", function () {
    return CA;
  }), a.d(e, "faPlaneAlt", function () {
    return LA;
  }), a.d(e, "faPlaneArrival", function () {
    return AA;
  }), a.d(e, "faPlaneDeparture", function () {
    return NA;
  }), a.d(e, "faPlaneSlash", function () {
    return gA;
  }), a.d(e, "faPlanetMoon", function () {
    return HA;
  }), a.d(e, "faPlanetRinged", function () {
    return VA;
  }), a.d(e, "faPlay", function () {
    return xA;
  }), a.d(e, "faPlayCircle", function () {
    return wA;
  }), a.d(e, "faPlug", function () {
    return yA;
  }), a.d(e, "faPlus", function () {
    return bA;
  }), a.d(e, "faPlusCircle", function () {
    return SA;
  }), a.d(e, "faPlusHexagon", function () {
    return TA;
  }), a.d(e, "faPlusOctagon", function () {
    return DA;
  }), a.d(e, "faPlusSquare", function () {
    return jA;
  }), a.d(e, "faPodcast", function () {
    return EA;
  }), a.d(e, "faPodium", function () {
    return kA;
  }), a.d(e, "faPodiumStar", function () {
    return IA;
  }), a.d(e, "faPoliceBox", function () {
    return OA;
  }), a.d(e, "faPoll", function () {
    return QA;
  }), a.d(e, "faPollH", function () {
    return ZA;
  }), a.d(e, "faPollPeople", function () {
    return UA;
  }), a.d(e, "faPoo", function () {
    return BA;
  }), a.d(e, "faPooStorm", function () {
    return RA;
  }), a.d(e, "faPoop", function () {
    return YA;
  }), a.d(e, "faPopcorn", function () {
    return PA;
  }), a.d(e, "faPortalEnter", function () {
    return FA;
  }), a.d(e, "faPortalExit", function () {
    return WA;
  }), a.d(e, "faPortrait", function () {
    return GA;
  }), a.d(e, "faPoundSign", function () {
    return qA;
  }), a.d(e, "faPowerOff", function () {
    return JA;
  }), a.d(e, "faPray", function () {
    return KA;
  }), a.d(e, "faPrayingHands", function () {
    return XA;
  }), a.d(e, "faPrescription", function () {
    return _A;
  }), a.d(e, "faPrescriptionBottle", function () {
    return $A;
  }), a.d(e, "faPrescriptionBottleAlt", function () {
    return cN;
  }), a.d(e, "faPresentation", function () {
    return eN;
  }), a.d(e, "faPrint", function () {
    return aN;
  }), a.d(e, "faPrintSearch", function () {
    return nN;
  }), a.d(e, "faPrintSlash", function () {
    return tN;
  }), a.d(e, "faProcedures", function () {
    return rN;
  }), a.d(e, "faProjectDiagram", function () {
    return iN;
  }), a.d(e, "faProjector", function () {
    return oN;
  }), a.d(e, "faPumpMedical", function () {
    return lN;
  }), a.d(e, "faPumpSoap", function () {
    return fN;
  }), a.d(e, "faPumpkin", function () {
    return sN;
  }), a.d(e, "faPuzzlePiece", function () {
    return uN;
  }), a.d(e, "faQrcode", function () {
    return hN;
  }), a.d(e, "faQuestion", function () {
    return mN;
  }), a.d(e, "faQuestionCircle", function () {
    return vN;
  }), a.d(e, "faQuestionSquare", function () {
    return dN;
  }), a.d(e, "faQuidditch", function () {
    return MN;
  }), a.d(e, "faQuoteLeft", function () {
    return pN;
  }), a.d(e, "faQuoteRight", function () {
    return zN;
  }), a.d(e, "faQuran", function () {
    return CN;
  }), a.d(e, "faRabbit", function () {
    return LN;
  }), a.d(e, "faRabbitFast", function () {
    return AN;
  }), a.d(e, "faRacquet", function () {
    return NN;
  }), a.d(e, "faRadar", function () {
    return gN;
  }), a.d(e, "faRadiation", function () {
    return HN;
  }), a.d(e, "faRadiationAlt", function () {
    return VN;
  }), a.d(e, "faRadio", function () {
    return xN;
  }), a.d(e, "faRadioAlt", function () {
    return wN;
  }), a.d(e, "faRainbow", function () {
    return yN;
  }), a.d(e, "faRaindrops", function () {
    return bN;
  }), a.d(e, "faRam", function () {
    return SN;
  }), a.d(e, "faRampLoading", function () {
    return TN;
  }), a.d(e, "faRandom", function () {
    return DN;
  }), a.d(e, "faRaygun", function () {
    return jN;
  }), a.d(e, "faReceipt", function () {
    return EN;
  }), a.d(e, "faRecordVinyl", function () {
    return kN;
  }), a.d(e, "faRectangleLandscape", function () {
    return IN;
  }), a.d(e, "faRectanglePortrait", function () {
    return ON;
  }), a.d(e, "faRectangleWide", function () {
    return QN;
  }), a.d(e, "faRecycle", function () {
    return ZN;
  }), a.d(e, "faRedo", function () {
    return UN;
  }), a.d(e, "faRedoAlt", function () {
    return BN;
  }), a.d(e, "faRefrigerator", function () {
    return RN;
  }), a.d(e, "faRegistered", function () {
    return YN;
  }), a.d(e, "faRemoveFormat", function () {
    return PN;
  }), a.d(e, "faRepeat", function () {
    return FN;
  }), a.d(e, "faRepeat1", function () {
    return WN;
  }), a.d(e, "faRepeat1Alt", function () {
    return GN;
  }), a.d(e, "faRepeatAlt", function () {
    return qN;
  }), a.d(e, "faReply", function () {
    return JN;
  }), a.d(e, "faReplyAll", function () {
    return KN;
  }), a.d(e, "faRepublican", function () {
    return XN;
  }), a.d(e, "faRestroom", function () {
    return _N;
  }), a.d(e, "faRetweet", function () {
    return $N;
  }), a.d(e, "faRetweetAlt", function () {
    return cg;
  }), a.d(e, "faRibbon", function () {
    return eg;
  }), a.d(e, "faRing", function () {
    return ag;
  }), a.d(e, "faRingsWedding", function () {
    return ng;
  }), a.d(e, "faRoad", function () {
    return tg;
  }), a.d(e, "faRobot", function () {
    return rg;
  }), a.d(e, "faRocket", function () {
    return ig;
  }), a.d(e, "faRocketLaunch", function () {
    return og;
  }), a.d(e, "faRoute", function () {
    return lg;
  }), a.d(e, "faRouteHighway", function () {
    return fg;
  }), a.d(e, "faRouteInterstate", function () {
    return sg;
  }), a.d(e, "faRouter", function () {
    return ug;
  }), a.d(e, "faRss", function () {
    return hg;
  }), a.d(e, "faRssSquare", function () {
    return mg;
  }), a.d(e, "faRubleSign", function () {
    return vg;
  }), a.d(e, "faRuler", function () {
    return dg;
  }), a.d(e, "faRulerCombined", function () {
    return Mg;
  }), a.d(e, "faRulerHorizontal", function () {
    return pg;
  }), a.d(e, "faRulerTriangle", function () {
    return zg;
  }), a.d(e, "faRulerVertical", function () {
    return Cg;
  }), a.d(e, "faRunning", function () {
    return Lg;
  }), a.d(e, "faRupeeSign", function () {
    return Ag;
  }), a.d(e, "faRv", function () {
    return Ng;
  }), a.d(e, "faSack", function () {
    return gg;
  }), a.d(e, "faSackDollar", function () {
    return Hg;
  }), a.d(e, "faSadCry", function () {
    return Vg;
  }), a.d(e, "faSadTear", function () {
    return xg;
  }), a.d(e, "faSalad", function () {
    return wg;
  }), a.d(e, "faSandwich", function () {
    return yg;
  }), a.d(e, "faSatellite", function () {
    return bg;
  }), a.d(e, "faSatelliteDish", function () {
    return Sg;
  }), a.d(e, "faSausage", function () {
    return Tg;
  }), a.d(e, "faSave", function () {
    return Dg;
  }), a.d(e, "faSaxHot", function () {
    return jg;
  }), a.d(e, "faSaxophone", function () {
    return Eg;
  }), a.d(e, "faScalpel", function () {
    return kg;
  }), a.d(e, "faScalpelPath", function () {
    return Ig;
  }), a.d(e, "faScanner", function () {
    return Og;
  }), a.d(e, "faScannerImage", function () {
    return Qg;
  }), a.d(e, "faScannerKeyboard", function () {
    return Zg;
  }), a.d(e, "faScannerTouchscreen", function () {
    return Ug;
  }), a.d(e, "faScarecrow", function () {
    return Bg;
  }), a.d(e, "faScarf", function () {
    return Rg;
  }), a.d(e, "faSchool", function () {
    return Yg;
  }), a.d(e, "faScrewdriver", function () {
    return Pg;
  }), a.d(e, "faScroll", function () {
    return Fg;
  }), a.d(e, "faScrollOld", function () {
    return Wg;
  }), a.d(e, "faScrubber", function () {
    return Gg;
  }), a.d(e, "faScythe", function () {
    return qg;
  }), a.d(e, "faSdCard", function () {
    return Jg;
  }), a.d(e, "faSearch", function () {
    return Kg;
  }), a.d(e, "faSearchDollar", function () {
    return Xg;
  }), a.d(e, "faSearchLocation", function () {
    return _g;
  }), a.d(e, "faSearchMinus", function () {
    return $g;
  }), a.d(e, "faSearchPlus", function () {
    return cH;
  }), a.d(e, "faSeedling", function () {
    return eH;
  }), a.d(e, "faSendBack", function () {
    return aH;
  }), a.d(e, "faSendBackward", function () {
    return nH;
  }), a.d(e, "faSensor", function () {
    return tH;
  }), a.d(e, "faSensorAlert", function () {
    return rH;
  }), a.d(e, "faSensorFire", function () {
    return iH;
  }), a.d(e, "faSensorOn", function () {
    return oH;
  }), a.d(e, "faSensorSmoke", function () {
    return lH;
  }), a.d(e, "faServer", function () {
    return fH;
  }), a.d(e, "faShapes", function () {
    return sH;
  }), a.d(e, "faShare", function () {
    return uH;
  }), a.d(e, "faShareAll", function () {
    return hH;
  }), a.d(e, "faShareAlt", function () {
    return mH;
  }), a.d(e, "faShareAltSquare", function () {
    return vH;
  }), a.d(e, "faShareSquare", function () {
    return dH;
  }), a.d(e, "faSheep", function () {
    return MH;
  }), a.d(e, "faShekelSign", function () {
    return pH;
  }), a.d(e, "faShield", function () {
    return zH;
  }), a.d(e, "faShieldAlt", function () {
    return CH;
  }), a.d(e, "faShieldCheck", function () {
    return LH;
  }), a.d(e, "faShieldCross", function () {
    return AH;
  }), a.d(e, "faShieldVirus", function () {
    return NH;
  }), a.d(e, "faShip", function () {
    return gH;
  }), a.d(e, "faShippingFast", function () {
    return HH;
  }), a.d(e, "faShippingTimed", function () {
    return VH;
  }), a.d(e, "faShishKebab", function () {
    return xH;
  }), a.d(e, "faShoePrints", function () {
    return wH;
  }), a.d(e, "faShoppingBag", function () {
    return yH;
  }), a.d(e, "faShoppingBasket", function () {
    return bH;
  }), a.d(e, "faShoppingCart", function () {
    return SH;
  }), a.d(e, "faShovel", function () {
    return TH;
  }), a.d(e, "faShovelSnow", function () {
    return DH;
  }), a.d(e, "faShower", function () {
    return jH;
  }), a.d(e, "faShredder", function () {
    return EH;
  }), a.d(e, "faShuttleVan", function () {
    return kH;
  }), a.d(e, "faShuttlecock", function () {
    return IH;
  }), a.d(e, "faSickle", function () {
    return OH;
  }), a.d(e, "faSigma", function () {
    return QH;
  }), a.d(e, "faSign", function () {
    return ZH;
  }), a.d(e, "faSignIn", function () {
    return UH;
  }), a.d(e, "faSignInAlt", function () {
    return BH;
  }), a.d(e, "faSignLanguage", function () {
    return RH;
  }), a.d(e, "faSignOut", function () {
    return YH;
  }), a.d(e, "faSignOutAlt", function () {
    return PH;
  }), a.d(e, "faSignal", function () {
    return FH;
  }), a.d(e, "faSignal1", function () {
    return WH;
  }), a.d(e, "faSignal2", function () {
    return GH;
  }), a.d(e, "faSignal3", function () {
    return qH;
  }), a.d(e, "faSignal4", function () {
    return JH;
  }), a.d(e, "faSignalAlt", function () {
    return KH;
  }), a.d(e, "faSignalAlt1", function () {
    return XH;
  }), a.d(e, "faSignalAlt2", function () {
    return _H;
  }), a.d(e, "faSignalAlt3", function () {
    return $H;
  }), a.d(e, "faSignalAltSlash", function () {
    return cV;
  }), a.d(e, "faSignalSlash", function () {
    return eV;
  }), a.d(e, "faSignalStream", function () {
    return aV;
  }), a.d(e, "faSignature", function () {
    return nV;
  }), a.d(e, "faSimCard", function () {
    return tV;
  }), a.d(e, "faSink", function () {
    return rV;
  }), a.d(e, "faSiren", function () {
    return iV;
  }), a.d(e, "faSirenOn", function () {
    return oV;
  }), a.d(e, "faSitemap", function () {
    return lV;
  }), a.d(e, "faSkating", function () {
    return fV;
  }), a.d(e, "faSkeleton", function () {
    return sV;
  }), a.d(e, "faSkiJump", function () {
    return uV;
  }), a.d(e, "faSkiLift", function () {
    return hV;
  }), a.d(e, "faSkiing", function () {
    return mV;
  }), a.d(e, "faSkiingNordic", function () {
    return vV;
  }), a.d(e, "faSkull", function () {
    return dV;
  }), a.d(e, "faSkullCow", function () {
    return MV;
  }), a.d(e, "faSkullCrossbones", function () {
    return pV;
  }), a.d(e, "faSlash", function () {
    return zV;
  }), a.d(e, "faSledding", function () {
    return CV;
  }), a.d(e, "faSleigh", function () {
    return LV;
  }), a.d(e, "faSlidersH", function () {
    return AV;
  }), a.d(e, "faSlidersHSquare", function () {
    return NV;
  }), a.d(e, "faSlidersV", function () {
    return gV;
  }), a.d(e, "faSlidersVSquare", function () {
    return HV;
  }), a.d(e, "faSmile", function () {
    return VV;
  }), a.d(e, "faSmileBeam", function () {
    return xV;
  }), a.d(e, "faSmilePlus", function () {
    return wV;
  }), a.d(e, "faSmileWink", function () {
    return yV;
  }), a.d(e, "faSmog", function () {
    return bV;
  }), a.d(e, "faSmoke", function () {
    return SV;
  }), a.d(e, "faSmoking", function () {
    return TV;
  }), a.d(e, "faSmokingBan", function () {
    return DV;
  }), a.d(e, "faSms", function () {
    return jV;
  }), a.d(e, "faSnake", function () {
    return EV;
  }), a.d(e, "faSnooze", function () {
    return kV;
  }), a.d(e, "faSnowBlowing", function () {
    return IV;
  }), a.d(e, "faSnowboarding", function () {
    return OV;
  }), a.d(e, "faSnowflake", function () {
    return QV;
  }), a.d(e, "faSnowflakes", function () {
    return ZV;
  }), a.d(e, "faSnowman", function () {
    return UV;
  }), a.d(e, "faSnowmobile", function () {
    return BV;
  }), a.d(e, "faSnowplow", function () {
    return RV;
  }), a.d(e, "faSoap", function () {
    return YV;
  }), a.d(e, "faSocks", function () {
    return PV;
  }), a.d(e, "faSolarPanel", function () {
    return FV;
  }), a.d(e, "faSolarSystem", function () {
    return WV;
  }), a.d(e, "faSort", function () {
    return GV;
  }), a.d(e, "faSortAlphaDown", function () {
    return qV;
  }), a.d(e, "faSortAlphaDownAlt", function () {
    return JV;
  }), a.d(e, "faSortAlphaUp", function () {
    return KV;
  }), a.d(e, "faSortAlphaUpAlt", function () {
    return XV;
  }), a.d(e, "faSortAlt", function () {
    return _V;
  }), a.d(e, "faSortAmountDown", function () {
    return $V;
  }), a.d(e, "faSortAmountDownAlt", function () {
    return cx;
  }), a.d(e, "faSortAmountUp", function () {
    return ex;
  }), a.d(e, "faSortAmountUpAlt", function () {
    return ax;
  }), a.d(e, "faSortCircle", function () {
    return nx;
  }), a.d(e, "faSortCircleDown", function () {
    return tx;
  }), a.d(e, "faSortCircleUp", function () {
    return rx;
  }), a.d(e, "faSortDown", function () {
    return ix;
  }), a.d(e, "faSortNumericDown", function () {
    return ox;
  }), a.d(e, "faSortNumericDownAlt", function () {
    return lx;
  }), a.d(e, "faSortNumericUp", function () {
    return fx;
  }), a.d(e, "faSortNumericUpAlt", function () {
    return sx;
  }), a.d(e, "faSortShapesDown", function () {
    return ux;
  }), a.d(e, "faSortShapesDownAlt", function () {
    return hx;
  }), a.d(e, "faSortShapesUp", function () {
    return mx;
  }), a.d(e, "faSortShapesUpAlt", function () {
    return vx;
  }), a.d(e, "faSortSizeDown", function () {
    return dx;
  }), a.d(e, "faSortSizeDownAlt", function () {
    return Mx;
  }), a.d(e, "faSortSizeUp", function () {
    return px;
  }), a.d(e, "faSortSizeUpAlt", function () {
    return zx;
  }), a.d(e, "faSortUp", function () {
    return Cx;
  }), a.d(e, "faSoup", function () {
    return Lx;
  }), a.d(e, "faSpa", function () {
    return Ax;
  }), a.d(e, "faSpaceShuttle", function () {
    return Nx;
  }), a.d(e, "faSpaceStationMoon", function () {
    return gx;
  }), a.d(e, "faSpaceStationMoonAlt", function () {
    return Hx;
  }), a.d(e, "faSpade", function () {
    return Vx;
  }), a.d(e, "faSparkles", function () {
    return xx;
  }), a.d(e, "faSpeaker", function () {
    return wx;
  }), a.d(e, "faSpeakers", function () {
    return yx;
  }), a.d(e, "faSpellCheck", function () {
    return bx;
  }), a.d(e, "faSpider", function () {
    return Sx;
  }), a.d(e, "faSpiderBlackWidow", function () {
    return Tx;
  }), a.d(e, "faSpiderWeb", function () {
    return Dx;
  }), a.d(e, "faSpinner", function () {
    return jx;
  }), a.d(e, "faSpinnerThird", function () {
    return Ex;
  }), a.d(e, "faSplotch", function () {
    return kx;
  }), a.d(e, "faSprayCan", function () {
    return Ix;
  }), a.d(e, "faSprinkler", function () {
    return Ox;
  }), a.d(e, "faSquare", function () {
    return Qx;
  }), a.d(e, "faSquareFull", function () {
    return Zx;
  }), a.d(e, "faSquareRoot", function () {
    return Ux;
  }), a.d(e, "faSquareRootAlt", function () {
    return Bx;
  }), a.d(e, "faSquirrel", function () {
    return Rx;
  }), a.d(e, "faStaff", function () {
    return Yx;
  }), a.d(e, "faStamp", function () {
    return Px;
  }), a.d(e, "faStar", function () {
    return Fx;
  }), a.d(e, "faStarAndCrescent", function () {
    return Wx;
  }), a.d(e, "faStarChristmas", function () {
    return Gx;
  }), a.d(e, "faStarExclamation", function () {
    return qx;
  }), a.d(e, "faStarHalf", function () {
    return Jx;
  }), a.d(e, "faStarHalfAlt", function () {
    return Kx;
  }), a.d(e, "faStarOfDavid", function () {
    return Xx;
  }), a.d(e, "faStarOfLife", function () {
    return _x;
  }), a.d(e, "faStarShooting", function () {
    return $x;
  }), a.d(e, "faStarfighter", function () {
    return cw;
  }), a.d(e, "faStarfighterAlt", function () {
    return ew;
  }), a.d(e, "faStars", function () {
    return aw;
  }), a.d(e, "faStarship", function () {
    return nw;
  }), a.d(e, "faStarshipFreighter", function () {
    return tw;
  }), a.d(e, "faSteak", function () {
    return rw;
  }), a.d(e, "faSteeringWheel", function () {
    return iw;
  }), a.d(e, "faStepBackward", function () {
    return ow;
  }), a.d(e, "faStepForward", function () {
    return lw;
  }), a.d(e, "faStethoscope", function () {
    return fw;
  }), a.d(e, "faStickyNote", function () {
    return sw;
  }), a.d(e, "faStocking", function () {
    return uw;
  }), a.d(e, "faStomach", function () {
    return hw;
  }), a.d(e, "faStop", function () {
    return mw;
  }), a.d(e, "faStopCircle", function () {
    return vw;
  }), a.d(e, "faStopwatch", function () {
    return dw;
  }), a.d(e, "faStopwatch20", function () {
    return Mw;
  }), a.d(e, "faStore", function () {
    return pw;
  }), a.d(e, "faStoreAlt", function () {
    return zw;
  }), a.d(e, "faStoreAltSlash", function () {
    return Cw;
  }), a.d(e, "faStoreSlash", function () {
    return Lw;
  }), a.d(e, "faStream", function () {
    return Aw;
  }), a.d(e, "faStreetView", function () {
    return Nw;
  }), a.d(e, "faStretcher", function () {
    return gw;
  }), a.d(e, "faStrikethrough", function () {
    return Hw;
  }), a.d(e, "faStroopwafel", function () {
    return Vw;
  }), a.d(e, "faSubscript", function () {
    return xw;
  }), a.d(e, "faSubway", function () {
    return ww;
  }), a.d(e, "faSuitcase", function () {
    return yw;
  }), a.d(e, "faSuitcaseRolling", function () {
    return bw;
  }), a.d(e, "faSun", function () {
    return Sw;
  }), a.d(e, "faSunCloud", function () {
    return Tw;
  }), a.d(e, "faSunDust", function () {
    return Dw;
  }), a.d(e, "faSunHaze", function () {
    return jw;
  }), a.d(e, "faSunglasses", function () {
    return Ew;
  }), a.d(e, "faSunrise", function () {
    return kw;
  }), a.d(e, "faSunset", function () {
    return Iw;
  }), a.d(e, "faSuperscript", function () {
    return Ow;
  }), a.d(e, "faSurprise", function () {
    return Qw;
  }), a.d(e, "faSwatchbook", function () {
    return Zw;
  }), a.d(e, "faSwimmer", function () {
    return Uw;
  }), a.d(e, "faSwimmingPool", function () {
    return Bw;
  }), a.d(e, "faSword", function () {
    return Rw;
  }), a.d(e, "faSwordLaser", function () {
    return Yw;
  }), a.d(e, "faSwordLaserAlt", function () {
    return Pw;
  }), a.d(e, "faSwords", function () {
    return Fw;
  }), a.d(e, "faSwordsLaser", function () {
    return Ww;
  }), a.d(e, "faSynagogue", function () {
    return Gw;
  }), a.d(e, "faSync", function () {
    return qw;
  }), a.d(e, "faSyncAlt", function () {
    return Jw;
  }), a.d(e, "faSyringe", function () {
    return Kw;
  }), a.d(e, "faTable", function () {
    return Xw;
  }), a.d(e, "faTableTennis", function () {
    return _w;
  }), a.d(e, "faTablet", function () {
    return $w;
  }), a.d(e, "faTabletAlt", function () {
    return cy;
  }), a.d(e, "faTabletAndroid", function () {
    return ey;
  }), a.d(e, "faTabletAndroidAlt", function () {
    return ay;
  }), a.d(e, "faTabletRugged", function () {
    return ny;
  }), a.d(e, "faTablets", function () {
    return ty;
  }), a.d(e, "faTachometer", function () {
    return ry;
  }), a.d(e, "faTachometerAlt", function () {
    return iy;
  }), a.d(e, "faTachometerAltAverage", function () {
    return oy;
  }), a.d(e, "faTachometerAltFast", function () {
    return ly;
  }), a.d(e, "faTachometerAltFastest", function () {
    return fy;
  }), a.d(e, "faTachometerAltSlow", function () {
    return sy;
  }), a.d(e, "faTachometerAltSlowest", function () {
    return uy;
  }), a.d(e, "faTachometerAverage", function () {
    return hy;
  }), a.d(e, "faTachometerFast", function () {
    return my;
  }), a.d(e, "faTachometerFastest", function () {
    return vy;
  }), a.d(e, "faTachometerSlow", function () {
    return dy;
  }), a.d(e, "faTachometerSlowest", function () {
    return My;
  }), a.d(e, "faTaco", function () {
    return py;
  }), a.d(e, "faTag", function () {
    return zy;
  }), a.d(e, "faTags", function () {
    return Cy;
  }), a.d(e, "faTally", function () {
    return Ly;
  }), a.d(e, "faTanakh", function () {
    return Ay;
  }), a.d(e, "faTape", function () {
    return Ny;
  }), a.d(e, "faTasks", function () {
    return gy;
  }), a.d(e, "faTasksAlt", function () {
    return Hy;
  }), a.d(e, "faTaxi", function () {
    return Vy;
  }), a.d(e, "faTeeth", function () {
    return xy;
  }), a.d(e, "faTeethOpen", function () {
    return wy;
  }), a.d(e, "faTelescope", function () {
    return yy;
  }), a.d(e, "faTemperatureDown", function () {
    return by;
  }), a.d(e, "faTemperatureFrigid", function () {
    return Sy;
  }), a.d(e, "faTemperatureHigh", function () {
    return Ty;
  }), a.d(e, "faTemperatureHot", function () {
    return Dy;
  }), a.d(e, "faTemperatureLow", function () {
    return jy;
  }), a.d(e, "faTemperatureUp", function () {
    return Ey;
  }), a.d(e, "faTenge", function () {
    return ky;
  }), a.d(e, "faTennisBall", function () {
    return Iy;
  }), a.d(e, "faTerminal", function () {
    return Oy;
  });
  a.d(e, "faText", function () {
    return Qy;
  }), a.d(e, "faTextHeight", function () {
    return Zy;
  }), a.d(e, "faTextSize", function () {
    return Uy;
  }), a.d(e, "faTextWidth", function () {
    return By;
  }), a.d(e, "faTh", function () {
    return Ry;
  }), a.d(e, "faThLarge", function () {
    return Yy;
  }), a.d(e, "faThList", function () {
    return Py;
  }), a.d(e, "faTheaterMasks", function () {
    return Fy;
  }), a.d(e, "faThermometer", function () {
    return Wy;
  }), a.d(e, "faThermometerEmpty", function () {
    return Gy;
  }), a.d(e, "faThermometerFull", function () {
    return qy;
  }), a.d(e, "faThermometerHalf", function () {
    return Jy;
  }), a.d(e, "faThermometerQuarter", function () {
    return Ky;
  }), a.d(e, "faThermometerThreeQuarters", function () {
    return Xy;
  }), a.d(e, "faTheta", function () {
    return _y;
  }), a.d(e, "faThumbsDown", function () {
    return $y;
  }), a.d(e, "faThumbsUp", function () {
    return cb;
  }), a.d(e, "faThumbtack", function () {
    return eb;
  }), a.d(e, "faThunderstorm", function () {
    return ab;
  }), a.d(e, "faThunderstormMoon", function () {
    return nb;
  }), a.d(e, "faThunderstormSun", function () {
    return tb;
  }), a.d(e, "faTicket", function () {
    return rb;
  }), a.d(e, "faTicketAlt", function () {
    return ib;
  }), a.d(e, "faTilde", function () {
    return ob;
  }), a.d(e, "faTimes", function () {
    return lb;
  }), a.d(e, "faTimesCircle", function () {
    return fb;
  }), a.d(e, "faTimesHexagon", function () {
    return sb;
  }), a.d(e, "faTimesOctagon", function () {
    return ub;
  }), a.d(e, "faTimesSquare", function () {
    return hb;
  }), a.d(e, "faTint", function () {
    return mb;
  }), a.d(e, "faTintSlash", function () {
    return vb;
  }), a.d(e, "faTire", function () {
    return db;
  }), a.d(e, "faTireFlat", function () {
    return Mb;
  }), a.d(e, "faTirePressureWarning", function () {
    return pb;
  }), a.d(e, "faTireRugged", function () {
    return zb;
  }), a.d(e, "faTired", function () {
    return Cb;
  }), a.d(e, "faToggleOff", function () {
    return Lb;
  }), a.d(e, "faToggleOn", function () {
    return Ab;
  }), a.d(e, "faToilet", function () {
    return Nb;
  }), a.d(e, "faToiletPaper", function () {
    return gb;
  }), a.d(e, "faToiletPaperAlt", function () {
    return Hb;
  }), a.d(e, "faToiletPaperSlash", function () {
    return Vb;
  }), a.d(e, "faTombstone", function () {
    return xb;
  }), a.d(e, "faTombstoneAlt", function () {
    return wb;
  }), a.d(e, "faToolbox", function () {
    return yb;
  }), a.d(e, "faTools", function () {
    return bb;
  }), a.d(e, "faTooth", function () {
    return Sb;
  }), a.d(e, "faToothbrush", function () {
    return Tb;
  }), a.d(e, "faTorah", function () {
    return Db;
  }), a.d(e, "faToriiGate", function () {
    return jb;
  }), a.d(e, "faTornado", function () {
    return Eb;
  }), a.d(e, "faTractor", function () {
    return kb;
  }), a.d(e, "faTrademark", function () {
    return Ib;
  }), a.d(e, "faTrafficCone", function () {
    return Ob;
  }), a.d(e, "faTrafficLight", function () {
    return Qb;
  }), a.d(e, "faTrafficLightGo", function () {
    return Zb;
  }), a.d(e, "faTrafficLightSlow", function () {
    return Ub;
  }), a.d(e, "faTrafficLightStop", function () {
    return Bb;
  }), a.d(e, "faTrailer", function () {
    return Rb;
  }), a.d(e, "faTrain", function () {
    return Yb;
  }), a.d(e, "faTram", function () {
    return Pb;
  }), a.d(e, "faTransgender", function () {
    return Fb;
  }), a.d(e, "faTransgenderAlt", function () {
    return Wb;
  }), a.d(e, "faTransporter", function () {
    return Gb;
  }), a.d(e, "faTransporter1", function () {
    return qb;
  }), a.d(e, "faTransporter2", function () {
    return Jb;
  }), a.d(e, "faTransporter3", function () {
    return Kb;
  }), a.d(e, "faTransporterEmpty", function () {
    return Xb;
  }), a.d(e, "faTrash", function () {
    return _b;
  }), a.d(e, "faTrashAlt", function () {
    return $b;
  }), a.d(e, "faTrashRestore", function () {
    return cS;
  }), a.d(e, "faTrashRestoreAlt", function () {
    return eS;
  }), a.d(e, "faTrashUndo", function () {
    return aS;
  }), a.d(e, "faTrashUndoAlt", function () {
    return nS;
  }), a.d(e, "faTreasureChest", function () {
    return tS;
  }), a.d(e, "faTree", function () {
    return rS;
  }), a.d(e, "faTreeAlt", function () {
    return iS;
  }), a.d(e, "faTreeChristmas", function () {
    return oS;
  }), a.d(e, "faTreeDecorated", function () {
    return lS;
  }), a.d(e, "faTreeLarge", function () {
    return fS;
  }), a.d(e, "faTreePalm", function () {
    return sS;
  }), a.d(e, "faTrees", function () {
    return uS;
  }), a.d(e, "faTriangle", function () {
    return hS;
  }), a.d(e, "faTriangleMusic", function () {
    return mS;
  }), a.d(e, "faTrophy", function () {
    return vS;
  }), a.d(e, "faTrophyAlt", function () {
    return dS;
  }), a.d(e, "faTruck", function () {
    return MS;
  }), a.d(e, "faTruckContainer", function () {
    return pS;
  }), a.d(e, "faTruckCouch", function () {
    return zS;
  }), a.d(e, "faTruckLoading", function () {
    return CS;
  }), a.d(e, "faTruckMonster", function () {
    return LS;
  }), a.d(e, "faTruckMoving", function () {
    return AS;
  }), a.d(e, "faTruckPickup", function () {
    return NS;
  }), a.d(e, "faTruckPlow", function () {
    return gS;
  }), a.d(e, "faTruckRamp", function () {
    return HS;
  }), a.d(e, "faTrumpet", function () {
    return VS;
  }), a.d(e, "faTshirt", function () {
    return xS;
  }), a.d(e, "faTty", function () {
    return wS;
  }), a.d(e, "faTurkey", function () {
    return yS;
  }), a.d(e, "faTurntable", function () {
    return bS;
  }), a.d(e, "faTurtle", function () {
    return SS;
  }), a.d(e, "faTv", function () {
    return TS;
  }), a.d(e, "faTvAlt", function () {
    return DS;
  }), a.d(e, "faTvMusic", function () {
    return jS;
  }), a.d(e, "faTvRetro", function () {
    return ES;
  }), a.d(e, "faTypewriter", function () {
    return kS;
  }), a.d(e, "faUfo", function () {
    return IS;
  }), a.d(e, "faUfoBeam", function () {
    return OS;
  }), a.d(e, "faUmbrella", function () {
    return QS;
  }), a.d(e, "faUmbrellaBeach", function () {
    return ZS;
  }), a.d(e, "faUnderline", function () {
    return US;
  }), a.d(e, "faUndo", function () {
    return BS;
  }), a.d(e, "faUndoAlt", function () {
    return RS;
  }), a.d(e, "faUnicorn", function () {
    return YS;
  }), a.d(e, "faUnion", function () {
    return PS;
  }), a.d(e, "faUniversalAccess", function () {
    return FS;
  }), a.d(e, "faUniversity", function () {
    return WS;
  }), a.d(e, "faUnlink", function () {
    return GS;
  }), a.d(e, "faUnlock", function () {
    return qS;
  }), a.d(e, "faUnlockAlt", function () {
    return JS;
  }), a.d(e, "faUpload", function () {
    return KS;
  }), a.d(e, "faUsbDrive", function () {
    return XS;
  }), a.d(e, "faUsdCircle", function () {
    return _S;
  }), a.d(e, "faUsdSquare", function () {
    return $S;
  }), a.d(e, "faUser", function () {
    return cT;
  }), a.d(e, "faUserAlien", function () {
    return eT;
  }), a.d(e, "faUserAlt", function () {
    return aT;
  }), a.d(e, "faUserAltSlash", function () {
    return nT;
  }), a.d(e, "faUserAstronaut", function () {
    return tT;
  }), a.d(e, "faUserChart", function () {
    return rT;
  }), a.d(e, "faUserCheck", function () {
    return iT;
  }), a.d(e, "faUserCircle", function () {
    return oT;
  }), a.d(e, "faUserClock", function () {
    return lT;
  }), a.d(e, "faUserCog", function () {
    return fT;
  }), a.d(e, "faUserCowboy", function () {
    return sT;
  }), a.d(e, "faUserCrown", function () {
    return uT;
  }), a.d(e, "faUserEdit", function () {
    return hT;
  }), a.d(e, "faUserFriends", function () {
    return mT;
  }), a.d(e, "faUserGraduate", function () {
    return vT;
  }), a.d(e, "faUserHardHat", function () {
    return dT;
  }), a.d(e, "faUserHeadset", function () {
    return MT;
  }), a.d(e, "faUserInjured", function () {
    return pT;
  }), a.d(e, "faUserLock", function () {
    return zT;
  }), a.d(e, "faUserMd", function () {
    return CT;
  }), a.d(e, "faUserMdChat", function () {
    return LT;
  }), a.d(e, "faUserMinus", function () {
    return AT;
  }), a.d(e, "faUserMusic", function () {
    return NT;
  }), a.d(e, "faUserNinja", function () {
    return gT;
  }), a.d(e, "faUserNurse", function () {
    return HT;
  }), a.d(e, "faUserPlus", function () {
    return VT;
  }), a.d(e, "faUserRobot", function () {
    return xT;
  }), a.d(e, "faUserSecret", function () {
    return wT;
  }), a.d(e, "faUserShield", function () {
    return yT;
  }), a.d(e, "faUserSlash", function () {
    return bT;
  }), a.d(e, "faUserTag", function () {
    return ST;
  }), a.d(e, "faUserTie", function () {
    return TT;
  }), a.d(e, "faUserTimes", function () {
    return DT;
  }), a.d(e, "faUserUnlock", function () {
    return jT;
  }), a.d(e, "faUserVisor", function () {
    return ET;
  }), a.d(e, "faUsers", function () {
    return kT;
  }), a.d(e, "faUsersClass", function () {
    return IT;
  }), a.d(e, "faUsersCog", function () {
    return OT;
  }), a.d(e, "faUsersCrown", function () {
    return QT;
  }), a.d(e, "faUsersMedical", function () {
    return ZT;
  }), a.d(e, "faUsersSlash", function () {
    return UT;
  }), a.d(e, "faUtensilFork", function () {
    return BT;
  }), a.d(e, "faUtensilKnife", function () {
    return RT;
  }), a.d(e, "faUtensilSpoon", function () {
    return YT;
  }), a.d(e, "faUtensils", function () {
    return PT;
  }), a.d(e, "faUtensilsAlt", function () {
    return FT;
  }), a.d(e, "faVacuum", function () {
    return WT;
  }), a.d(e, "faVacuumRobot", function () {
    return GT;
  }), a.d(e, "faValueAbsolute", function () {
    return qT;
  }), a.d(e, "faVectorSquare", function () {
    return JT;
  }), a.d(e, "faVenus", function () {
    return KT;
  }), a.d(e, "faVenusDouble", function () {
    return XT;
  }), a.d(e, "faVenusMars", function () {
    return _T;
  }), a.d(e, "faVest", function () {
    return $T;
  }), a.d(e, "faVestPatches", function () {
    return cD;
  }), a.d(e, "faVhs", function () {
    return eD;
  }), a.d(e, "faVial", function () {
    return aD;
  }), a.d(e, "faVials", function () {
    return nD;
  }), a.d(e, "faVideo", function () {
    return tD;
  }), a.d(e, "faVideoPlus", function () {
    return rD;
  }), a.d(e, "faVideoSlash", function () {
    return iD;
  }), a.d(e, "faVihara", function () {
    return oD;
  }), a.d(e, "faViolin", function () {
    return lD;
  }), a.d(e, "faVirus", function () {
    return fD;
  }), a.d(e, "faVirusSlash", function () {
    return sD;
  }), a.d(e, "faViruses", function () {
    return uD;
  }), a.d(e, "faVoicemail", function () {
    return hD;
  }), a.d(e, "faVolcano", function () {
    return mD;
  }), a.d(e, "faVolleyballBall", function () {
    return vD;
  }), a.d(e, "faVolume", function () {
    return dD;
  }), a.d(e, "faVolumeDown", function () {
    return MD;
  }), a.d(e, "faVolumeMute", function () {
    return pD;
  }), a.d(e, "faVolumeOff", function () {
    return zD;
  }), a.d(e, "faVolumeSlash", function () {
    return CD;
  }), a.d(e, "faVolumeUp", function () {
    return LD;
  }), a.d(e, "faVoteNay", function () {
    return AD;
  }), a.d(e, "faVoteYea", function () {
    return ND;
  }), a.d(e, "faVrCardboard", function () {
    return gD;
  }), a.d(e, "faWagonCovered", function () {
    return HD;
  }), a.d(e, "faWalker", function () {
    return VD;
  }), a.d(e, "faWalkieTalkie", function () {
    return xD;
  }), a.d(e, "faWalking", function () {
    return wD;
  }), a.d(e, "faWallet", function () {
    return yD;
  }), a.d(e, "faWand", function () {
    return bD;
  }), a.d(e, "faWandMagic", function () {
    return SD;
  }), a.d(e, "faWarehouse", function () {
    return TD;
  }), a.d(e, "faWarehouseAlt", function () {
    return DD;
  }), a.d(e, "faWasher", function () {
    return jD;
  }), a.d(e, "faWatch", function () {
    return ED;
  }), a.d(e, "faWatchCalculator", function () {
    return kD;
  }), a.d(e, "faWatchFitness", function () {
    return ID;
  }), a.d(e, "faWater", function () {
    return OD;
  }), a.d(e, "faWaterLower", function () {
    return QD;
  }), a.d(e, "faWaterRise", function () {
    return ZD;
  }), a.d(e, "faWaveSine", function () {
    return UD;
  }), a.d(e, "faWaveSquare", function () {
    return BD;
  }), a.d(e, "faWaveTriangle", function () {
    return RD;
  }), a.d(e, "faWaveform", function () {
    return YD;
  }), a.d(e, "faWaveformPath", function () {
    return PD;
  }), a.d(e, "faWebcam", function () {
    return FD;
  }), a.d(e, "faWebcamSlash", function () {
    return WD;
  }), a.d(e, "faWeight", function () {
    return GD;
  }), a.d(e, "faWeightHanging", function () {
    return qD;
  }), a.d(e, "faWhale", function () {
    return JD;
  }), a.d(e, "faWheat", function () {
    return KD;
  }), a.d(e, "faWheelchair", function () {
    return XD;
  }), a.d(e, "faWhistle", function () {
    return _D;
  }), a.d(e, "faWifi", function () {
    return $D;
  }), a.d(e, "faWifi1", function () {
    return cj;
  }), a.d(e, "faWifi2", function () {
    return ej;
  }), a.d(e, "faWifiSlash", function () {
    return aj;
  }), a.d(e, "faWind", function () {
    return nj;
  }), a.d(e, "faWindTurbine", function () {
    return tj;
  }), a.d(e, "faWindWarning", function () {
    return rj;
  }), a.d(e, "faWindow", function () {
    return ij;
  }), a.d(e, "faWindowAlt", function () {
    return oj;
  }), a.d(e, "faWindowClose", function () {
    return lj;
  }), a.d(e, "faWindowFrame", function () {
    return fj;
  }), a.d(e, "faWindowFrameOpen", function () {
    return sj;
  }), a.d(e, "faWindowMaximize", function () {
    return uj;
  }), a.d(e, "faWindowMinimize", function () {
    return hj;
  }), a.d(e, "faWindowRestore", function () {
    return mj;
  }), a.d(e, "faWindsock", function () {
    return vj;
  }), a.d(e, "faWineBottle", function () {
    return dj;
  }), a.d(e, "faWineGlass", function () {
    return Mj;
  }), a.d(e, "faWineGlassAlt", function () {
    return pj;
  }), a.d(e, "faWonSign", function () {
    return zj;
  }), a.d(e, "faWreath", function () {
    return Cj;
  }), a.d(e, "faWrench", function () {
    return Lj;
  }), a.d(e, "faXRay", function () {
    return Aj;
  }), a.d(e, "faYenSign", function () {
    return Nj;
  }), a.d(e, "faYinYang", function () {
    return gj;
  });
  /*!
   * Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com
   * License - https://fontawesome.com/license (Commercial License)
   */

  var n = "fal",
      t = {
    prefix: "fal",
    iconName: "abacus",
    icon: [576, 512, [], "f640", "M560 0c-8.84 0-16 7.16-16 16v64h-64V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v16h-96V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v16h-32V64c0-17.67-14.33-32-32-32H96c-17.67 0-32 14.33-32 32v16H32V16c0-8.84-7.16-16-16-16S0 7.16 0 16v488c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72h32v16c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-16h32v16c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-16h96v16c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-16h64v72c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V16c0-8.84-7.16-16-16-16zM416 64h32v64h-32V64zm-192 0h32v64h-32V64zM96 64h32v64H96V64zm32 384H96v-64h32v64zm128 0h-32v-64h32v64zm192 0h-32v-64h32v64zm96-48h-64v-16c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v16h-96v-16c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v16h-32v-16c0-17.67-14.33-32-32-32H96c-17.67 0-32 14.33-32 32v16H32V272h32v16c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-16h32v16c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-16h32v16c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-16h128v128zM96 288v-64h32v64H96zm128 0v-64h32v64h-32zm128 0v-64h32v64h-32zm192-48H416v-16c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v16h-32v-16c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v16h-32v-16c0-17.67-14.33-32-32-32H96c-17.67 0-32 14.33-32 32v16H32V112h32v16c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-16h32v16c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-16h96v16c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-16h64v128z"]
  },
      r = {
    prefix: "fal",
    iconName: "acorn",
    icon: [448, 512, [], "f6ae", "M352 64H241.12c3.32-14.4 9.75-27.88 19.46-39.28 2.77-3.25 2.81-7.98-.21-11L249.04 2.39c-3.22-3.22-8.62-3.23-11.62.2-15.38 17.51-25.27 38.67-29.1 61.41H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32v32c0 98.06 55.4 187.7 143.11 231.55L224 512l48.89-24.45C360.6 443.7 416 354.06 416 256v-32c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96zm32 192c0 86.49-48.06 164.25-125.42 202.93L224 476.22l-34.58-17.29C112.06 420.25 64 342.49 64 256v-32h320v32zm32-64H32v-32c0-35.29 28.71-64 64-64h256c35.29 0 64 28.71 64 64v32z"]
  },
      i = {
    prefix: "fal",
    iconName: "ad",
    icon: [512, 512, [], "f641", "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm16 336c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16V112c0-8.82 7.18-16 16-16h416c8.82 0 16 7.18 16 16v288zm-72-240h-16c-4.42 0-8 3.58-8 8v64.88c-9.45-5.5-20.28-8.88-32-8.88-35.35 0-64 28.65-64 64s28.65 64 64 64c11.72 0 22.55-3.38 32-8.88v.88c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V168c0-4.42-3.58-8-8-8zm-56 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zM196.97 165.13a8.007 8.007 0 0 0-7.47-5.13h-27.01c-3.31 0-6.28 2.04-7.47 5.13l-67.69 176C85.31 346.37 89.18 352 94.8 352h17.15c3.31 0 6.28-2.04 7.47-5.13L142.07 288h67.86l22.64 58.87a8.007 8.007 0 0 0 7.47 5.13h17.15c5.62 0 9.48-5.63 7.47-10.87l-67.69-176zM154.37 256L176 199.77 197.63 256h-43.26z"]
  },
      o = {
    prefix: "fal",
    iconName: "address-book",
    icon: [448, 512, [], "f2b9", "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h288c35.3 0 64-28.7 64-64v-32h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-52 288c0 17.6-14.4 32-32 32H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h288c17.6 0 32 14.4 32 32v384zM208 272c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm46.8 144c-19.5 0-24.4 7-46.8 7s-27.3-7-46.8-7c-21.2 0-41.8 9.4-53.8 27.4C100.2 326.1 96 339 96 352.9V392c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-39.1c0-7 2.1-13.8 6-19.6 5.6-8.3 15.8-13.2 27.3-13.2 12.4 0 20.8 7 46.8 7 25.9 0 34.3-7 46.8-7 11.5 0 21.7 5 27.3 13.2 3.9 5.8 6 12.6 6 19.6V392c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-39.1c0-13.9-4.2-26.8-11.4-37.5-12.3-18-32.9-27.4-54-27.4z"]
  },
      l = {
    prefix: "fal",
    iconName: "address-card",
    icon: [576, 512, [], "f2bb", "M512 32H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm32 384c0 17.6-14.4 32-32 32H64c-17.6 0-32-14.4-32-32V96c0-17.6 14.4-32 32-32h448c17.6 0 32 14.4 32 32v320zm-72-128H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0-64H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0-64H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM208 288c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm46.8 144c-19.5 0-24.4 7-46.8 7s-27.3-7-46.8-7c-21.2 0-41.8 9.4-53.8 27.4C100.2 342.1 96 355 96 368.9V392c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-23.1c0-7 2.1-13.8 6-19.6 5.6-8.3 15.8-13.2 27.3-13.2 12.4 0 20.8 7 46.8 7 25.9 0 34.3-7 46.8-7 11.5 0 21.7 5 27.3 13.2 3.9 5.8 6 12.6 6 19.6V392c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-23.1c0-13.9-4.2-26.8-11.4-37.5-12.3-18-32.9-27.4-54-27.4z"]
  },
      f = {
    prefix: "fal",
    iconName: "adjust",
    icon: [512, 512, [], "f042", "M256 40c119.945 0 216 97.337 216 216 0 119.945-97.337 216-216 216-119.945 0-216-97.337-216-216 0-119.945 97.337-216 216-216m0-32C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm-32 124.01v247.98c-53.855-13.8-96-63.001-96-123.99 0-60.99 42.145-110.19 96-123.99M256 96c-88.366 0-160 71.634-160 160s71.634 160 160 160V96z"]
  },
      s = {
    prefix: "fal",
    iconName: "air-conditioner",
    icon: [576, 512, [], "f8f4", "M544,0H32A32,32,0,0,0,0,32V192a32,32,0,0,0,32,32H544a32,32,0,0,0,32-32V32A32,32,0,0,0,544,0Zm0,192H32V32H544ZM72,160H504a8,8,0,0,0,8-8V136a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8v16A8,8,0,0,0,72,160ZM224,424a56,56,0,0,1-56,56H152a56.09,56.09,0,0,1-54.79-67.76c5.36-26.18,29.68-44.24,56.4-44.24H168a8,8,0,0,0,8-8V344a8,8,0,0,0-8-8H152a88.09,88.09,0,0,0-87.57,96.78C68.88,478.5,110,512,155.91,512H168a88,88,0,0,0,88-88V256H224ZM420.1,304H408a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8h16a56.09,56.09,0,0,1,54.79,67.76c-5.36,26.18-29.68,44.24-56.4,44.24H408a56,56,0,0,1-56-56V256H320V392a88,88,0,0,0,88,88h16a88.09,88.09,0,0,0,87.57-96.78C507.12,337.5,466,304,420.1,304Z"]
  },
      u = {
    prefix: "fal",
    iconName: "air-freshener",
    icon: [512, 512, [], "f5d0", "M160 240C115.875 240 80 275.875 80 320S115.875 400 160 400S240 364.125 240 320S204.125 240 160 240ZM160 368C133.5 368 112 346.5 112 320S133.5 272 160 272S208 293.5 208 320S186.5 368 160 368ZM224 128V32C224 14.406 209.594 0 192 0H128C110.406 0 96 14.406 96 32V128C43 128 0 171 0 224V448C0 483.203 28.812 512 64 512H256C291.188 512 320 483.203 320 448V224C320 171 277 128 224 128ZM128 32H192V128H128V32ZM288 448C288 465.672 273.688 480 256 480H64C46.312 480 32 465.672 32 448V224C32 188.797 60.812 160 96 160H224C259.188 160 288 188.797 288 224V448ZM496 224H480V208C480 199.156 472.844 192 464 192S448 199.156 448 208V224H432C423.156 224 416 231.156 416 240S423.156 256 432 256H448V272C448 280.844 455.156 288 464 288S480 280.844 480 272V256H496C504.844 256 512 248.844 512 240S504.844 224 496 224ZM432 64H448V80C448 88.844 455.156 96 464 96S480 88.844 480 80V64H496C504.844 64 512 56.844 512 48S504.844 32 496 32H480V16C480 7.156 472.844 0 464 0S448 7.156 448 16V32H432C423.156 32 416 39.156 416 48S423.156 64 432 64ZM416 160H432C440.844 160 448 152.844 448 144S440.844 128 432 128H416V112C416 103.156 408.844 96 400 96S384 103.156 384 112V128H368C359.156 128 352 135.156 352 144S359.156 160 368 160H384V176C384 184.844 391.156 192 400 192S416 184.844 416 176V160ZM352 64H368C376.844 64 384 56.844 384 48S376.844 32 368 32H352V16C352 7.156 344.844 0 336 0S320 7.156 320 16V32H304C295.156 32 288 39.156 288 48S295.156 64 304 64H320V80C320 88.844 327.156 96 336 96S352 88.844 352 80V64Z"]
  },
      h = {
    prefix: "fal",
    iconName: "alarm-clock",
    icon: [512, 512, [], "f34e", "M32 112a80.09 80.09 0 0 1 80-80 79.23 79.23 0 0 1 50 18 253.22 253.22 0 0 1 34.44-10.8C175.89 15.42 145.86 0 112 0A112.14 112.14 0 0 0 0 112c0 25.86 9.17 49.41 24 68.39a255.93 255.93 0 0 1 17.4-31.64A78.94 78.94 0 0 1 32 112zM400 0c-33.86 0-63.89 15.42-84.44 39.25A253.22 253.22 0 0 1 350 50.05a79.23 79.23 0 0 1 50-18 80.09 80.09 0 0 1 80 80 78.94 78.94 0 0 1-9.36 36.75A255.93 255.93 0 0 1 488 180.39c14.79-19 24-42.53 24-68.39A112.14 112.14 0 0 0 400 0zM256 64C132.29 64 32 164.29 32 288a222.89 222.89 0 0 0 54.84 146.54L34.34 487a8 8 0 0 0 0 11.32l11.31 11.31a8 8 0 0 0 11.32 0l52.49-52.5a223.21 223.21 0 0 0 293.08 0L455 509.66a8 8 0 0 0 11.32 0l11.31-11.31a8 8 0 0 0 0-11.32l-52.5-52.49A222.89 222.89 0 0 0 480 288c0-123.71-100.29-224-224-224zm0 416c-105.87 0-192-86.13-192-192S150.13 96 256 96s192 86.13 192 192-86.13 192-192 192zm14.38-183.69V168a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v136a16 16 0 0 0 6 12.48l73.75 59a8 8 0 0 0 11.25-1.25l10-12.5a8 8 0 0 0-1.25-11.25z"]
  },
      m = {
    prefix: "fal",
    iconName: "alarm-exclamation",
    icon: [512, 512, [], "f843", "M256 352a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm-8.5-24h17a8.14 8.14 0 0 0 8-7.5l7-136a8 8 0 0 0-8-8.5h-31a8 8 0 0 0-8 8.5l7 136a8 8 0 0 0 8 7.5zM32 112a80.09 80.09 0 0 1 80-80 79.23 79.23 0 0 1 50 18 253.22 253.22 0 0 1 34.44-10.8C175.89 15.42 145.86 0 112 0A112.14 112.14 0 0 0 0 112c0 25.86 9.17 49.41 24 68.39a255.93 255.93 0 0 1 17.4-31.64A78.94 78.94 0 0 1 32 112zM400 0c-33.86 0-63.89 15.42-84.44 39.25A253.22 253.22 0 0 1 350 50.05a79.23 79.23 0 0 1 50-18 80.09 80.09 0 0 1 80 80 78.94 78.94 0 0 1-9.36 36.75A255.93 255.93 0 0 1 488 180.39c14.79-19 24-42.53 24-68.39A112.14 112.14 0 0 0 400 0zM256 64C132.29 64 32 164.29 32 288a222.89 222.89 0 0 0 54.84 146.54L34.34 487a8 8 0 0 0 0 11.32l11.31 11.31a8 8 0 0 0 11.32 0l52.49-52.5a223.21 223.21 0 0 0 293.08 0L455 509.66a8 8 0 0 0 11.32 0l11.31-11.31a8 8 0 0 0 0-11.32l-52.5-52.49A222.89 222.89 0 0 0 480 288c0-123.71-100.29-224-224-224zm0 416c-105.87 0-192-86.13-192-192S150.13 96 256 96s192 86.13 192 192-86.13 192-192 192z"]
  },
      v = {
    prefix: "fal",
    iconName: "alarm-plus",
    icon: [512, 512, [], "f844", "M344 272h-72v-72a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v72h-72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h72v72a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-72h72a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM32 112a80.09 80.09 0 0 1 80-80 79.23 79.23 0 0 1 50 18 253.22 253.22 0 0 1 34.44-10.8C175.89 15.42 145.86 0 112 0A112.14 112.14 0 0 0 0 112c0 25.86 9.17 49.41 24 68.39a255.93 255.93 0 0 1 17.4-31.64A78.94 78.94 0 0 1 32 112zM400 0c-33.86 0-63.89 15.42-84.44 39.25A253.22 253.22 0 0 1 350 50.05a79.23 79.23 0 0 1 50-18 80.09 80.09 0 0 1 80 80 78.94 78.94 0 0 1-9.36 36.75A255.93 255.93 0 0 1 488 180.39c14.79-19 24-42.53 24-68.39A112.14 112.14 0 0 0 400 0zM256 64C132.29 64 32 164.29 32 288a222.89 222.89 0 0 0 54.84 146.54L34.34 487a8 8 0 0 0 0 11.32l11.31 11.31a8 8 0 0 0 11.32 0l52.49-52.5a223.21 223.21 0 0 0 293.08 0L455 509.66a8 8 0 0 0 11.32 0l11.31-11.31a8 8 0 0 0 0-11.32l-52.5-52.49A222.89 222.89 0 0 0 480 288c0-123.71-100.29-224-224-224zm0 416c-105.87 0-192-86.13-192-192S150.13 96 256 96s192 86.13 192 192-86.13 192-192 192z"]
  },
      d = {
    prefix: "fal",
    iconName: "alarm-snooze",
    icon: [512, 512, [], "f845", "M328 352H225.28L332.5 218a16 16 0 0 0-12.5-26H184a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h102.72L179.5 358a16 16 0 0 0 12.5 26h136a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM32 112a80.09 80.09 0 0 1 80-80 79.23 79.23 0 0 1 50 18 253.22 253.22 0 0 1 34.44-10.8C175.89 15.42 145.86 0 112 0A112.14 112.14 0 0 0 0 112c0 25.86 9.17 49.41 24 68.39a255.93 255.93 0 0 1 17.4-31.64A78.94 78.94 0 0 1 32 112zM400 0c-33.86 0-63.89 15.42-84.44 39.25A253.22 253.22 0 0 1 350 50.05a79.23 79.23 0 0 1 50-18 80.09 80.09 0 0 1 80 80 78.94 78.94 0 0 1-9.36 36.75A255.93 255.93 0 0 1 488 180.39c14.79-19 24-42.53 24-68.39A112.14 112.14 0 0 0 400 0zM256 64C132.29 64 32 164.29 32 288a222.89 222.89 0 0 0 54.84 146.54L34.34 487a8 8 0 0 0 0 11.32l11.31 11.31a8 8 0 0 0 11.32 0l52.49-52.5a223.21 223.21 0 0 0 293.08 0L455 509.66a8 8 0 0 0 11.32 0l11.31-11.31a8 8 0 0 0 0-11.32l-52.5-52.49A222.89 222.89 0 0 0 480 288c0-123.71-100.29-224-224-224zm0 416c-105.87 0-192-86.13-192-192S150.13 96 256 96s192 86.13 192 192-86.13 192-192 192z"]
  },
      M = {
    prefix: "fal",
    iconName: "album",
    icon: [448, 512, [], "f89f", "M224 416c88.22 0 160-71.78 160-160S312.22 96 224 96 64 167.78 64 256s71.78 160 160 160zm0-288A128 128 0 1 1 96 256a128.14 128.14 0 0 1 128-128zm0 152a24 24 0 1 0-24-24 24 24 0 0 0 24 24zM416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm0 416H32V64h384z"]
  },
      p = {
    prefix: "fal",
    iconName: "album-collection",
    icon: [512, 512, [], "f8a0", "M496 80a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v16h480zm-16-64a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16h448zm0 112H32C13.19 128-1.57 145.62.13 166.07l26.18 314.18c1.5 18 15.32 31.75 31.87 31.75h395.64c16.55 0 30.37-13.77 31.86-31.75l26.19-314.18C513.57 145.62 498.82 128 480 128zm-26.21 349.6c-.12 1.47-.69 2.31-.2 2.4l-394.32.27a4 4 0 0 1-1.07-2.68L32 163.41c-.18-2.09.67-3.32.12-3.41h447a5 5 0 0 1 .82 3.41zM256 299.15c-14.55 0-26.25 10.16-26.13 22.6S241.69 344 256 344s26-9.9 26.14-22.23-11.58-22.62-26.14-22.62zM256 192c-92.9 0-164.33 61.88-159.79 134.4C100.51 395 172 448 256 448s155.5-53 159.8-121.6C420.33 253.88 348.9 192 256 192zm0 224c-67.34 0-124.7-41.09-127.86-91.6-1.69-27 11.71-47.29 23.25-59.58C175.77 238.88 213.9 224 256 224s80.23 14.88 104.6 40.82c11.54 12.29 24.95 32.6 23.26 59.58C380.7 374.91 323.34 416 256 416z"]
  },
      z = {
    prefix: "fal",
    iconName: "alicorn",
    icon: [640, 512, [], "f6b0", "M631.98 64h-96.92l-.24-.3c5.39-9.45 8.38-20.32 8.38-31.7 0-17.67-14.33-32-32-32H400c-69.18 0-125.38 55.26-127.59 123.92-35.69-9.21-63.11-34.71-81.51-76.61-4-9.16-13.06-15.16-23.03-15.31-10.53.2-18.84 5.36-23.13 14.39C133.63 69.94 128 95.08 128 121.09c0 75.38 56.56 143.6 132.87 161.9 4.42 1.06 8.86-1.96 9.7-6.43l2.97-15.7c.8-4.22-1.93-8.17-6.1-9.2C205.69 236.47 160 181.6 160 121.09c0-16.31 2.72-32.19 8.06-47.38C197.38 130.23 244.1 160 303.94 160l.06-32c0-53.02 42.98-96 96-96h111.2c0 13.29-8.1 24.66-19.63 29.5l20.39 24.78.05 93.88a16 16 0 0 1-10.83 15.15l-25.52 8.71c-9.33 3.19-16.14-2.76-18.48-6.27L432 160l-48-16v100.21c0 26.67-12.65 50.17-32 65.6V480h-64V318.69l-104.43-23.21-32.12 89.47L175.53 480H118l-21.13-87.86a31.698 31.698 0 0 1 .37-16.18l27.63-93.41C107.46 270.37 96 250.24 96 227.37c0-15.82 5.68-30.18 14.82-41.68-4.94-10.84-8.98-22.04-11.4-33.73-8.09 6.94-15.19 15.02-20.76 24.18C35.11 176.87 0 212.27 0 256v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56c0-21.5 14.23-39.48 33.72-45.59-.96 5.54-1.71 11.15-1.71 16.96 0 24.2 8.9 47.33 24.53 65.24l-21.97 74.27c-3.12 10.77-3.38 22.03-.8 32.74l21.13 87.86C90.34 501.86 103.21 512 118 512h57.53c20.95 0 36.12-19.75 31.02-39.86l-21.68-85.57 19.29-53.73L256 344.36V480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V323.8c20.5-21.5 32-49.75 32-79.59v-50.52l14.55 21.82c19.11 28.67 49.98 20.67 55.45 18.8l25.52-8.71c19.44-6.63 32.5-24.89 32.49-45.44l-.03-64.83 92.45-36.66c6.58-4.4 3.47-14.67-4.45-14.67zM464.01 96c0-8.84-7.16-16-16-16s-16 7.16-16 16 7.16 16 16 16c8.83 0 16-7.16 16-16z"]
  },
      C = {
    prefix: "fal",
    iconName: "alien",
    icon: [448, 512, [], "f8f5", "M224,0C100.28125,0,0,88.0293,0,232.45117c0,111.77735,134.21484,224.59766,194.86328,269.875a48.71553,48.71553,0,0,0,58.27344,0C313.78516,457.04883,448,344.22852,448,232.45117,448,88.0293,347.6875,0,224,0Zm9.99219,476.68359a16.71415,16.71415,0,0,1-19.98633,0C171.30859,444.80859,32,332.99609,32,232.45117,32,114.42773,110.95312,32,224,32s192,82.42773,192,200.45117C416,332.99609,276.69141,444.80859,233.99219,476.68359ZM368,212H320a79.999,79.999,0,0,0-80,80v12a16.00079,16.00079,0,0,0,16,16h48a80.00021,80.00021,0,0,0,80-80V228A15.99954,15.99954,0,0,0,368,212Zm-64,76H272.166A48.06494,48.06494,0,0,1,320,244h31.834A48.06645,48.06645,0,0,1,304,288ZM128,212H80a15.99954,15.99954,0,0,0-16,16v12a80.00021,80.00021,0,0,0,80,80h48a16.00079,16.00079,0,0,0,16-16V292A79.999,79.999,0,0,0,128,212Zm16,76a48.06645,48.06645,0,0,1-47.834-44H128a48.06494,48.06494,0,0,1,47.834,44Z"]
  },
      L = {
    prefix: "fal",
    iconName: "alien-monster",
    icon: [576, 512, [], "f8f6", "M192,320h32V224H192Zm160,0h32V224H352ZM544,112H512a32.03165,32.03165,0,0,0-32,32v16H416V128h32a32.03165,32.03165,0,0,0,32-32V64a32.03165,32.03165,0,0,0-32-32H416a32.03165,32.03165,0,0,0-32,32H352a32.03165,32.03165,0,0,0-32,32v32H256V96a32.03165,32.03165,0,0,0-32-32H192a32.03165,32.03165,0,0,0-32-32H128A32.03165,32.03165,0,0,0,96,64V96a32.03165,32.03165,0,0,0,32,32h32v32H96V144a32.03165,32.03165,0,0,0-32-32H32A32.03165,32.03165,0,0,0,0,144V288a32.03165,32.03165,0,0,0,32,32H64v32a32.03165,32.03165,0,0,0,32,32h32v64a32.03165,32.03165,0,0,0,32,32h80a32.03165,32.03165,0,0,0,32-32V416a32.03165,32.03165,0,0,0-32-32h96a32.03165,32.03165,0,0,0-32,32v32a32.03165,32.03165,0,0,0,32,32h80a32.03165,32.03165,0,0,0,32-32V384h32a32.03165,32.03165,0,0,0,32-32V320h32a32.03165,32.03165,0,0,0,32-32V144A32.03165,32.03165,0,0,0,544,112ZM416,64h32V96H416ZM128,96V64h32V96ZM240,448H160V384h32v32h48Zm176,0H336V416h48V384h32ZM544,288H480v64H96V288H32V144H64V256H96V192h96V96h32v64H352V96h32v96h96v64h32V144h32Z"]
  },
      A = {
    prefix: "fal",
    iconName: "align-center",
    icon: [448, 512, [], "f037", "M344 48H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h240a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8zm96 384H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm-96-128H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h240a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm96-128H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      N = {
    prefix: "fal",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", "M439 48H7a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8zm0 384H7a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-128H7a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-128H7a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      g = {
    prefix: "fal",
    iconName: "align-left",
    icon: [448, 512, [], "f036", "M280 48H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h272a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8zm160 384H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM280 304H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h272a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm160-128H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      H = {
    prefix: "fal",
    iconName: "align-right",
    icon: [448, 512, [], "f038", "M440 48H168a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h272a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8zm0 384H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-128H168a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h272a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-128H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      V = {
    prefix: "fal",
    iconName: "align-slash",
    icon: [640, 512, [], "f846", "M536 304h-77.57l40.64 32H536a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm8-120a8 8 0 0 0-8-8H295.89l40.63 32H536a8 8 0 0 0 8-8zm-8-104a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8H133.34L174 80zM96 328a8 8 0 0 0 8 8h240l-40.64-32H104a8 8 0 0 0-8 8zm541 157.32L23 1.8A7.86 7.86 0 0 0 11.79 3l-10 12.5A7.92 7.92 0 0 0 3 26.71l614 483.52a7.91 7.91 0 0 0 11.18-1.23l10-12.5a7.83 7.83 0 0 0-1.18-11.18zM104 432a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h402.55l-40.64-32zm0-224h77.45l-40.64-32H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8z"]
  },
      x = {
    prefix: "fal",
    iconName: "allergies",
    icon: [448, 512, [], "f461", "M240 416c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-160-32c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm192-96c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-64-32c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-64-32c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm216-176c-8.6 0-16.7 1.9-24 5.4V88c0-30.9-25.1-56-56-56-9.7 0-18.8 2.5-26.7 6.8C278 16.3 256.9 0 232 0s-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8-30.9 0-56 25.1-56 56v152.8c-11.5-11.8-42.1-27.7-72.1-6.7-25.3 17.7-31.5 52.7-13.8 78l113.7 171.3c11.9 17.9 31.8 28.6 53.3 28.6h180.6c30.4 0 56.8-21.6 62.8-51.4l20.6-103.2c4.5-22.7 6.8-45.9 6.8-69V168c.1-30.9-25-56-55.9-56zm24 176.3c0 21.1-2.1 42.1-6.2 62.8l-20.6 103.2c-3 15-16.1 25.7-31.4 25.7H177.2c-10.7 0-20.7-5.4-26.7-14.3L36.3 293.8c-7.6-10.9-5-25.8 5.9-33.4 15.8-11.1 30 1 33.4 5.9l37.8 54.4c4.5 6.4 14.6 3.3 14.6-4.6V88c0-13.3 10.7-24 24-24s24 10.7 24 24v160c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V56c0-13.3 10.7-24 24-24s24 10.7 24 24v192c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V88c0-13.3 10.7-24 24-24s24 10.7 24 24v160c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-80c0-13.3 10.7-24 24-24s24 10.7 24 24v120.3z"]
  },
      w = {
    prefix: "fal",
    iconName: "ambulance",
    icon: [640, 512, [], "f0f9", "M296 192h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm336 192h-24V275.9c0-16.8-6.8-33.3-18.8-45.2l-83.9-83.9c-11.8-12-28.3-18.8-45.2-18.8H416V78.6c0-25.7-22.2-46.6-49.4-46.6H49.4C22.2 32 0 52.9 0 78.6v290.8C0 395.1 22.2 416 49.4 416h16.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h195.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H632c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-488 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm240-96H207.6C193 364.7 170 352 144 352s-49 12.7-63.6 32h-31c-9.6 0-17.4-6.5-17.4-14.6V78.6C32 70.5 39.8 64 49.4 64h317.2c9.6 0 17.4 6.5 17.4 14.6V384zm32-224h44.1c8.4 0 16.7 3.4 22.6 9.4l83.9 83.9c.8.8 1.1 1.9 1.8 2.8H416V160zm80 320c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-96h-16.4C545 364.7 522 352 496 352s-49 12.7-63.6 32H416v-96h160v96z"]
  },
      y = {
    prefix: "fal",
    iconName: "american-sign-language-interpreting",
    icon: [640, 512, [], "f2a3", "M635.9 213.3c0-.1-41.3-83.1-41.3-83.1-9.6-19.3-33.6-28.5-54.4-18l-55.3 28-79-7.4c-5.1-.5-32.5-.7-59.3 15.8-7.5-14.4-18.5-20.5-32.9-26.1 17-32.5-6.9-77-51.8-70.8C263.5 24.2 241.8 0 213.4 0c-11.3 0-22.3 4-31.1 11.2-45 37.2-74.1 89.9-81.7 147.7L68 218.1l-48.1 27.6c-18.2 10.8-25 33.9-15.8 53.1 0 .1 41.3 83.1 41.3 83.1 9.6 19.3 33.6 28.5 54.4 18l55.3-28c81.1 7.5 81.2 7.5 82.7 7.5 19.9 0 39.1-5.7 55.6-15.9 4.7 9.1 12.2 16.4 21.5 21.1 2.6 1.3 7 3.3 11.3 5-16.9 32.3 6.9 77 51.8 70.8-1.6 27.8 20.7 51.5 48.6 51.5 11.3 0 22.4-4 31.1-11.3 45-37.3 74-89.9 81.7-147.6l32.6-59.2s48-27.6 48.1-27.6c18.2-10.7 25-33.8 15.8-52.9zm-339.6-26.9c-20.4-10.3-44.5-11.7-66.1-4-8.4 3-6.3 15.5 2.7 15.5 33.4 0 58.9 15.1 71.9 42.6 9.2 19.4-19.8 34.9-30 14.3-7-14.4-21.2-23.4-37-23.4-22.6 0-40.9 18.5-40.9 41.1 0 25.4 21.2 41.1 40.9 41.1 15.8 0 30-9 37-23.4 0 0 0-.1.1-.1 9.4-20.2 39.4-5.4 30 14.4-12.3 25.9-38.4 42.7-66.7 42.8-4.7-.4-64-5.9-87-8-1.5-.1-3 .1-4.3.8l-61.4 31.1c-4.1 2.1-9.2.5-11.3-3.6v-.1l-41.1-82.8c-2-4.2-.6-9.3 3.3-11.6l53.7-30.8c1.3-.7 2.3-1.8 3-3.1l38-69.1c.5-.9.8-1.9.9-3 5.7-51.7 30.9-98.3 70.9-131.4 16.6-13.9 38.7 11.3 21 26.1-12.5 10.7-23.1 22.4-31.5 34.8-4.9 7.3 3.9 16.1 11.1 11.1 19.9-13.6 41.8-22 65.2-24.8 8.6-1.1 17.1 4.3 18.5 14.6 1.2 9.3-5.1 17.7-14.4 18.7-15.4 1.9-30.2 7-44 15.3-7.7 4.6-3 16.6 5.8 14.7 24.3-5.4 52.8-1.7 76.2 9.7 20.6 10.4 4.6 39.9-14.5 30.5zM248 272.6c-2 3.3-3.6 9.1-10.2 9.1-2.8 0-8.9-2.3-8.9-9.1 0-5.1 3.9-9.1 8.9-9.1 6.6-.1 8.1 5.6 10.2 9.1zm355.8-33.9l-53.7 30.8c-1.3.7-2.3 1.8-3 3.1l-38 69.1c-.5.9-.8 1.9-.9 3-5.7 51.7-30.9 98.3-71 131.5-16.5 13.8-38.7-11.4-21-26.1 12.5-10.7 23.1-22.3 31.5-34.8 5-7.4-4-16-11.1-11.1-19.9 13.6-41.8 22-65.1 24.8-21.6 2.7-26.2-30.8-4.2-33.3 15.4-1.9 30.2-7 44-15.3 7.7-4.6 3-16.6-5.8-14.7-24.3 5.4-52.8 1.7-76.2-9.7-20.8-10.5-4.5-39.8 14.4-30.5 20.4 10.3 44.5 11.7 66.2 4 8.4-3 6.3-15.5-2.7-15.5-33.4 0-58.9-15.1-71.9-42.6-9.4-19.8 20.5-34.6 30-14.4l.1.1c7 14.4 21.2 23.4 37 23.4 22.6 0 40.9-18.5 40.9-41.1 0-25.4-21.2-41.1-40.9-41.1-15.8 0-30 9-37 23.4l-.1.1c-9.4 20.2-39.4 5.5-30-14.4 12.5-26.3 38.6-42.7 68.2-42.8l85.5 8c1.5.1 3-.1 4.4-.8l61.4-31.1c4.1-2.1 9.2-.5 11.3 3.6v.1l41.1 82.8c1.9 4.2.5 9.2-3.4 11.5zm-211.8.7c1.9-3.3 3.5-9.1 10.2-9.1 2.8 0 8.9 2.3 8.9 9.1 0 5.1-3.9 9.1-8.9 9.1-6.6.1-8.1-5.6-10.2-9.1z"]
  },
      b = {
    prefix: "fal",
    iconName: "amp-guitar",
    icon: [512, 512, [], "f8a1", "M464 64h-77.19C357.9 36.07 310.29 0 256 0S154.1 36.07 125.19 64H48a48 48 0 0 0-48 48v352a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V112a48 48 0 0 0-48-48zM256 32c30.15 0 58.63 14.85 81.61 32H174.39c22.99-17.15 51.46-32 81.61-32zm224 432a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V288h448zm0-208H32V112a16 16 0 0 1 16-16h416a16 16 0 0 1 16 16zM112 128a48 48 0 1 0 48 48 48.05 48.05 0 0 0-48-48zm0 64a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm128-64a48 48 0 1 0 48 48 48.05 48.05 0 0 0-48-48zm0 64a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm176 160a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm0 64a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm-32-16a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-32 16a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm-192 0a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm64 0a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm128-64a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-64 64a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm-96-16a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-32-48a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-32 48a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-32-48a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm224 48a16 16 0 1 0-16-16 16 16 0 0 0 16 16zM96 448a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm192-96a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-32 48a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-32-48a16 16 0 1 0-16-16 16 16 0 0 0 16 16z"]
  },
      S = {
    prefix: "fal",
    iconName: "analytics",
    icon: [576, 512, [], "f643", "M80 352H16c-8.84 0-16 7.16-16 16v128c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V368c0-8.84-7.16-16-16-16zM64 480H32v-96h32v96zm496-288h-64c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm-16 288h-32V224h32v256zM502.77 88.68C510.12 93.24 518.71 96 528 96c26.51 0 48-21.49 48-48S554.51 0 528 0s-48 21.49-48 48c0 5.51 1.12 10.71 2.83 15.64l-89.6 71.68c-7.35-4.57-15.94-7.33-25.23-7.33s-17.88 2.76-25.23 7.33l-89.6-71.68C254.88 58.72 256 53.51 256 48c0-26.51-21.49-48-48-48s-48 21.49-48 48c0 7.4 1.81 14.32 4.8 20.58L68.58 164.8C62.32 161.81 55.4 160 48 160c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-7.4-1.81-14.32-4.8-20.58l96.22-96.22C193.68 94.19 200.6 96 208 96c9.29 0 17.88-2.76 25.23-7.33l89.6 71.68c-1.71 4.93-2.83 10.14-2.83 15.65 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.51-1.12-10.72-2.83-15.65l89.6-71.67zM528 32c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 224c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zM208 64c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm160 128c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm-128 0h-64c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm-16 288h-32V224h32v256zm176-160h-64c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V336c0-8.84-7.16-16-16-16zm-16 160h-32V352h32v128z"]
  },
      T = {
    prefix: "fal",
    iconName: "anchor",
    icon: [576, 512, [], "f13d", "M504.485 264.485c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h49.129C461.111 420.749 390.501 473.6 304 479.452V192h52c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-52v-34.016c28.513-7.339 49.336-33.833 47.933-64.947-1.48-32.811-28.101-59.458-60.911-60.967C254.302-1.619 224 27.652 224 64c0 29.821 20.396 54.879 48 61.984V160h-52c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h52v287.452C185.498 473.6 114.888 420.749 97.901 352h49.129c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.03c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.03C-3.074 339.074 2.28 352 12.971 352h52.136C83.963 448.392 182.863 512 288 512c110.901 0 204.938-68.213 222.893-160h52.136c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.03zM256 64c0-17.645 14.355-32 32-32s32 14.355 32 32-14.355 32-32 32-32-14.355-32-32zM61.255 320L80 301.255 98.745 320h-37.49zm416 0L496 301.255 514.745 320h-37.49z"]
  },
      D = {
    prefix: "fal",
    iconName: "angel",
    icon: [576, 512, [], "f779", "M176.7 137.3c.7-11.4 2.9-22.4 6.8-32.6-15-8.6-23.5-17.8-23.5-24.7 0-16.9 48.6-48 128-48s128 31.1 128 48c0 6.9-8.5 16.1-23.5 24.7 3.9 10.3 6.1 21.2 6.8 32.6 30-14.5 48.7-34.8 48.7-57.3 0-44.2-71.6-80-160-80S128 35.8 128 80c0 22.5 18.7 42.8 48.7 57.3zm395.8 327.3L534.3 386c-7.6-15.7-7.6-34.4 0-50.1 16.7-34.2 25.6-36.5 25.6-71.8 0-46.9-43.2-88-92.4-88-23 0-44.5 9.2-60.7 25.7l-67.5 68.1C324 261 306.4 256 288 256s-35.9 5-51.3 13.8l-67.5-68.1c-16.1-16.5-37.7-25.7-60.7-25.7-49.2 0-92.4 41.1-92.4 88 0 35.4 9 37.9 25.6 71.8 7.6 15.7 7.6 34.4 0 50.1L3.6 464.6C-8.1 488.5 11 512 32.6 512h510.8c22.2 0 40.5-24.1 29.1-47.4zM32.6 480l37.9-80.1c11.9-24.5 11.9-53.6 0-78.1C52.6 285 48.2 289.9 48.2 264c0-29.3 28.8-56 60.4-56 14.2 0 27.7 5.7 37.8 16.2l65.1 65.7c-6.3 6.9-11.7 14.8-16.1 23.4L112.1 480H32.6zm115.3 0L224 327.6c12.2-24.4 36.7-39.6 64-39.6 27.3 0 51.8 15.2 64 39.6L428.2 480H147.9zm316 0l-83.3-166.8c-4.3-8.6-9.8-16.4-16.1-23.4l65.1-65.7c10.1-10.4 23.6-16.2 37.8-16.2 31.6 0 60.4 26.7 60.4 56 0 26-4.5 21-22.4 57.8-11.9 24.5-11.9 53.6 0 78.1l37.9 80.1h-79.4zM208 144c0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80-80 35.8-80 80zm128 0c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48z"]
  },
      j = {
    prefix: "fal",
    iconName: "angle-double-down",
    icon: [256, 512, [], "f103", "M119.5 262.9L3.5 145.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 223.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 263c-4.7 4.6-12.3 4.6-17-.1zm17 128l116-117.8c4.7-4.7 4.7-12.3 0-17l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L128 351.3 27.6 249.1c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l116 117.8c4.7 4.6 12.3 4.6 17-.1z"]
  },
      E = {
    prefix: "fal",
    iconName: "angle-double-left",
    icon: [320, 512, [], "f100", "M153.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L192.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L153 264.5c-4.6-4.7-4.6-12.3.1-17zm-128 17l117.8 116c4.7 4.7 12.3 4.7 17 0l7.1-7.1c4.7-4.7 4.7-12.3 0-17L64.7 256l102.2-100.4c4.7-4.7 4.7-12.3 0-17l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L25 247.5c-4.6 4.7-4.6 12.3.1 17z"]
  },
      k = {
    prefix: "fal",
    iconName: "angle-double-right",
    icon: [320, 512, [], "f101", "M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17zm128-17l-117.8-116c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17L255.3 256 153.1 356.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l117.8-116c4.6-4.7 4.6-12.3-.1-17z"]
  },
      I = {
    prefix: "fal",
    iconName: "angle-double-up",
    icon: [256, 512, [], "f102", "M136.5 249.1l116 117.8c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L128 288.7 27.6 390.9c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l116-117.8c4.7-4.6 12.3-4.6 17 .1zm-17-128L3.5 238.9c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0L128 160.7l100.4 102.2c4.7 4.7 12.3 4.7 17 0l7.1-7.1c4.7-4.7 4.7-12.3 0-17L136.5 121c-4.7-4.6-12.3-4.6-17 .1z"]
  },
      O = {
    prefix: "fal",
    iconName: "angle-down",
    icon: [256, 512, [], "f107", "M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"]
  },
      Q = {
    prefix: "fal",
    iconName: "angle-left",
    icon: [192, 512, [], "f104", "M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z"]
  },
      Z = {
    prefix: "fal",
    iconName: "angle-right",
    icon: [192, 512, [], "f105", "M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z"]
  },
      U = {
    prefix: "fal",
    iconName: "angle-up",
    icon: [256, 512, [], "f106", "M136.5 185.1l116 117.8c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L128 224.7 27.6 326.9c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l116-117.8c4.7-4.6 12.3-4.6 17 .1z"]
  },
      B = {
    prefix: "fal",
    iconName: "angry",
    icon: [496, 512, [], "f556", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm0-136c-31.2 0-60.6 13.8-80.6 37.8-5.7 6.8-4.8 16.9 2 22.5s16.9 4.8 22.5-2c27.9-33.4 84.2-33.4 112.1 0 5.3 6.4 15.4 8 22.5 2 6.8-5.7 7.7-15.8 2-22.5-19.9-24-49.3-37.8-80.5-37.8zm-48-96c0-2.9-.9-5.6-1.7-8.2.6.1 1.1.2 1.7.2 6.9 0 13.2-4.5 15.3-11.4 2.6-8.5-2.2-17.4-10.7-19.9l-80-24c-8.4-2.5-17.4 2.3-19.9 10.7-2.6 8.5 2.2 17.4 10.7 19.9l31 9.3c-6.3 5.8-10.5 14.1-10.5 23.4 0 17.7 14.3 32 32 32s32.1-14.3 32.1-32zm171.4-63.3l-80 24c-8.5 2.5-13.3 11.5-10.7 19.9 2.1 6.9 8.4 11.4 15.3 11.4.6 0 1.1-.2 1.7-.2-.7 2.7-1.7 5.3-1.7 8.2 0 17.7 14.3 32 32 32s32-14.3 32-32c0-9.3-4.1-17.5-10.5-23.4l31-9.3c8.5-2.5 13.3-11.5 10.7-19.9-2.4-8.5-11.4-13.2-19.8-10.7z"]
  },
      R = {
    prefix: "fal",
    iconName: "ankh",
    icon: [320, 512, [], "f644", "M312 288h-96.58c36.8-35.94 72.58-96.37 72.58-150.86C288 52.98 230.69 0 160 0S32 52.98 32 137.14c0 54.49 35.78 114.91 72.58 150.86H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h136v184c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V320h136c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM64 137.14C64 75.24 103.48 32 160 32s96 43.24 96 105.14c0 71.78-75.25 149.02-95.79 150.86h-.03C139.25 286.16 64 208.93 64 137.14z"]
  },
      Y = {
    prefix: "fal",
    iconName: "apple-alt",
    icon: [448, 512, [], "f5d1", "M224.48 128c21.33 0 59.54-3.73 83.67-27.86C343.08 65.21 335.26.75 335.26.75S329.08 0 319.52 0c-21.33 0-59.54 3.73-83.66 27.86-34.93 34.93-27.11 99.39-27.11 99.39s6.17.75 15.73.75zm34.01-77.52c11.49-11.5 30.05-15.92 44.67-17.57-1.79 15.7-6.59 33.54-17.64 44.6-11.5 11.49-30.05 15.92-44.66 17.57 1.79-15.78 6.58-33.55 17.63-44.6zm92.69 78.67c-4.46-.79-9.34-1.15-14.53-1.15-36.16 0-87.19 17.57-112.65 31.96C198.54 145.57 147.51 128 111.34 128c-5.19 0-10.07.36-14.53 1.15-81.24 14.3-107.41 124.49-93.09 205.6S65.02 512 160.41 512c12.06 0 24.12-4.61 34.44-10.34 9.04-5.02 19.1-7.52 29.16-7.52 10.06 0 20.12 2.51 29.16 7.52 10.32 5.73 22.38 10.34 34.43 10.34 95.39 0 142.36-96.14 156.68-177.25 14.32-81.11-11.84-191.3-93.1-205.6zm61.58 200.04C408.32 354.37 381.38 480 287.59 480c-4.85 0-11.56-2.24-18.91-6.33-13.61-7.55-29.06-11.54-44.68-11.54s-31.07 3.99-44.69 11.54c-7.34 4.08-14.05 6.32-18.9 6.32C66.62 480 39.69 354.37 35.24 329.18c-6.54-37.03-3.13-78.52 9.13-110.98 8.73-23.13 25.89-51.89 57.99-57.54 14.41-2.54 58.3.26 121.64 36.05 62.92-35.56 107.19-38.6 121.63-36.05 32.12 5.65 49.27 34.41 58 57.54 12.26 32.46 15.67 73.95 9.13 110.99z"]
  },
      P = {
    prefix: "fal",
    iconName: "apple-crate",
    icon: [512, 512, [], "f6b1", "M402.22 50.47c11.29-12.19 14.43-32.03 13.22-50.22-12.88-.86-35.67-.12-50.02 13.28-16.53 16.6-13.77 46.36-13.22 50.22 18.47 1.23 37.77-1.85 50.02-13.28zM496 224h-25.49c2.76-8.11 5.17-16.56 6.74-25.82 13.63-73.34-25.2-156.03-125.56-99.88-65.68-36.75-94.55-7.64-95.74-6.72-1.19-.92-30.28-30.02-95.94 6.72C59.44 42.04 20.98 125.78 34.44 198.18c1.56 9.26 3.98 17.71 6.74 25.82H16c-8.84 0-16 7.16-16 16v256c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16V240c0-8.84-7.16-16-16-16zm-159.94-97.77l15.62 8.74 15.62-8.74c54.74-30.63 67.11-3.69 67.76-2.75 12.04 17.42 14.51 48.48 10.63 69.37-1.98 11.71-5.51 21.76-9.67 31.15h-157.2c2.76-8.11 5.18-16.56 6.74-25.82 4.26-22.9 2.52-56.47-9.98-82.12 14.81-10.61 50.82 4.76 60.48 10.17zm-259.31-2.8c.65-.94 12.87-27.84 67.63 2.8l15.62 8.74 15.62-8.74c54.74-30.63 67.11-3.69 67.76-2.75 12.04 17.42 14.51 48.48 10.63 69.37-1.98 11.71-5.51 21.77-9.67 31.15H75.66c-4.17-9.45-7.73-19.63-9.77-31.66-3.82-20.61-.81-52.02 10.86-68.91zM480 480H32v-96h448v96zm0-128H32v-96h448v96zM80 320c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm0 128c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm352-128c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm0 128c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zM210.53 50.47c11.29-12.19 14.43-32.03 13.22-50.22-12.88-.86-35.67-.12-50.02 13.28-16.53 16.6-13.77 46.36-13.22 50.22 18.47 1.23 37.77-1.85 50.02-13.28z"]
  },
      F = {
    prefix: "fal",
    iconName: "archive",
    icon: [512, 512, [], "f187", "M464 32H48C21.5 32 0 53.5 0 80v64c0 8.8 7.2 16 16 16h16v272c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V160h16c8.8 0 16-7.2 16-16V80c0-26.5-21.5-48-48-48zm-16 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V160h384v272zm32-304H32V80c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v48zM204 256h104c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H204c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12z"]
  },
      W = {
    prefix: "fal",
    iconName: "archway",
    icon: [576, 512, [], "f557", "M568 32c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H8C3.6 0 0 3.6 0 8v16c0 4.4 3.6 8 8 8h24v448H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h168c8.84 0 16-7.16 16-16V320c0-52.94 43.06-96 96-96s96 43.06 96 96v160l.02 16c0 8.84 7.16 16 16 16H568c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-24V32h24zm-56 448h-96V320c0-70.58-57.41-128-128-128s-128 57.42-128 128v160H64V128h448v352zm0-384H64V32h448v64z"]
  },
      G = {
    prefix: "fal",
    iconName: "arrow-alt-circle-down",
    icon: [512, 512, [], "f358", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-88-32h-64V120c0-13.2-10.8-24-24-24h-80c-13.2 0-24 10.8-24 24v104h-64c-28.4 0-42.8 34.5-22.6 54.6l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c20-20.1 5.8-54.6-22.7-54.6zM256 384L128 256h96V128h64v128h96L256 384z"]
  },
      q = {
    prefix: "fal",
    iconName: "arrow-alt-circle-left",
    icon: [512, 512, [], "f359", "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zM256 472c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm32-88v-64h104c13.2 0 24-10.8 24-24v-80c0-13.2-10.8-24-24-24H288v-64c0-28.4-34.5-42.8-54.6-22.6l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c20.1 20 54.6 5.8 54.6-22.7zM128 256l128-128v96h128v64H256v96L128 256z"]
  },
      J = {
    prefix: "fal",
    iconName: "arrow-alt-circle-right",
    icon: [512, 512, [], "f35a", "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zM256 40c118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216zm-32 88v64H120c-13.2 0-24 10.8-24 24v80c0 13.2 10.8 24 24 24h104v64c0 28.4 34.5 42.8 54.6 22.6l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-20.1-20-54.6-5.8-54.6 22.7zm160 128L256 384v-96H128v-64h128v-96l128 128z"]
  },
      K = {
    prefix: "fal",
    iconName: "arrow-alt-circle-up",
    icon: [512, 512, [], "f35b", "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zM40 256c0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216zm88 32h64v104c0 13.2 10.8 24 24 24h80c13.2 0 24-10.8 24-24V288h64c28.4 0 42.8-34.5 22.6-54.6l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-20 20.1-5.8 54.6 22.7 54.6zm128-160l128 128h-96v128h-64V256h-96l128-128z"]
  },
      X = {
    prefix: "fal",
    iconName: "arrow-alt-down",
    icon: [448, 512, [], "f354", "M267.427 64C278.789 64 288 73.211 288 84.572v171.437h116.979c7.125 0 10.695 8.612 5.66 13.653L238.556 441.965c-8.036 8.046-21.076 8.047-29.112 0L37.36 269.662c-5.035-5.041-1.464-13.653 5.66-13.653H160V84.572C160 73.211 169.211 64 180.573 64h86.854m0-32h-86.855C151.584 32 128 55.584 128 84.572v139.437H43.021c-35.507 0-53.497 43.04-28.302 68.266l172.083 172.303c20.55 20.576 53.842 20.58 74.396 0l172.083-172.303c25.091-25.122 7.351-68.266-28.302-68.266H320V84.572C320 55.584 296.416 32 267.427 32z"]
  },
      _ = {
    prefix: "fal",
    iconName: "arrow-alt-from-bottom",
    icon: [384, 512, [], "f346", "M372 480H12c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12zm-218.9-96h77.7c8.8 0 16-7.2 16-16V224h93.9c7.1 0 10.7-8.6 5.7-13.6L203.3 66.8c-6.3-6.3-16.4-6.3-22.7 0l-143 143.6c-5 5-1.5 13.6 5.7 13.6h93.9v144c-.1 8.8 7.1 16 15.9 16m0 32c-26.5 0-48-21.5-48-48V256H43.3c-35.6 0-53.4-43.1-28.3-68.2L158 44.2c18.8-18.8 49.2-18.8 68 0l143.1 143.5c25.2 25.2 7.2 68.2-28.3 68.2h-61.9v112c0 26.5-21.5 48-48 48h-77.8v.1z"]
  },
      $ = {
    prefix: "fal",
    iconName: "arrow-alt-from-left",
    icon: [448, 512, [], "f347", "M0 436V76c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v360c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12zm96-218.9v77.7c0 8.8 7.2 16 16 16h144v93.9c0 7.1 8.6 10.7 13.6 5.7l141.6-143.1c6.3-6.3 6.3-16.4 0-22.7l-141.6-143c-5-5-13.6-1.5-13.6 5.7v93.9H112c-8.8-.1-16 7.1-16 15.9m-32 0c0-26.5 21.5-48 48-48h112v-61.9c0-35.6 43.1-53.4 68.2-28.3L433.9 222c18.8 18.8 18.8 49.2 0 68L292.2 433.1c-25.2 25.2-68.2 7.2-68.2-28.3v-61.9H112c-26.5 0-48-21.5-48-48v-77.8z"]
  },
      cc = {
    prefix: "fal",
    iconName: "arrow-alt-from-right",
    icon: [448, 512, [], "f348", "M448 76v360c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12zm-96 218.9v-77.7c0-8.8-7.2-16-16-16H192v-93.9c0-7.1-8.6-10.7-13.6-5.7L36.7 244.7c-6.3 6.3-6.3 16.4 0 22.7l141.6 143.1c5 5 13.6 1.5 13.6-5.7v-93.9h144c8.9 0 16.1-7.2 16.1-16m32 0c0 26.5-21.5 48-48 48H224v61.9c0 35.6-43.1 53.4-68.2 28.3L14.1 290c-18.8-18.8-18.8-49.2 0-68L155.8 78.9C181 53.8 224 71.8 224 107.3v61.9h112c26.5 0 48 21.5 48 48v77.7z"]
  },
      ec = {
    prefix: "fal",
    iconName: "arrow-alt-from-top",
    icon: [384, 512, [], "f349", "M12 32h360c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H12C5.4 64 0 58.6 0 52v-8c0-6.6 5.4-12 12-12zm218.9 96h-77.7c-8.8 0-16 7.2-16 16v144H43.3c-7.1 0-10.7 8.6-5.7 13.6l143.1 143.5c6.3 6.3 16.4 6.3 22.7 0l143.1-143.5c5-5 1.5-13.6-5.7-13.6h-93.9V144c0-8.8-7.2-16-16-16m0-32c26.5 0 48 21.5 48 48v112h61.9c35.6 0 53.4 43.1 28.3 68.2L226 467.8c-18.8 18.8-49.2 18.8-68 0L14.9 324.2C-10.2 299 7.8 256 43.3 256h61.9V144c0-26.5 21.5-48 48-48h77.7z"]
  },
      ac = {
    prefix: "fal",
    iconName: "arrow-alt-left",
    icon: [448, 512, [], "f355", "M395.4 159.9H256V75c0-35.5-43-53.5-68.3-28.3L15.4 218.8c-20.6 20.6-20.6 53.8 0 74.4l172.3 172.1c25.1 25.1 68.3 7.4 68.3-28.3v-85h139.4c29 0 52.6-23.6 52.6-52.6v-86.9c0-29-23.6-52.6-52.6-52.6zM416 299.4c0 11.4-9.2 20.6-20.6 20.6H224v117c0 7.1-8.6 10.7-13.7 5.7L38 270.6c-8-8-8-21.1 0-29.1L210.3 69.4c5-5 13.7-1.5 13.7 5.7v117h171.4c11.4 0 20.6 9.2 20.6 20.6z"]
  },
      nc = {
    prefix: "fal",
    iconName: "arrow-alt-right",
    icon: [448, 512, [], "f356", "M32 212.57A20.57 20.57 0 0 1 52.57 192H224V75a8 8 0 0 1 13.66-5.66L410 241.44a20.56 20.56 0 0 1 0 29.11L237.66 442.63A8 8 0 0 1 224 437V320H52.57A20.57 20.57 0 0 1 32 299.42v-86.85m-32 0v86.85A52.63 52.63 0 0 0 52.57 352H192v85c0 35.51 43 53.5 68.27 28.3l172.3-172.08a52.55 52.55 0 0 0 0-74.4L260.27 46.71C235.15 21.62 192 39.36 192 75v85H52.57A52.63 52.63 0 0 0 0 212.57z"]
  },
      tc = {
    prefix: "fal",
    iconName: "arrow-alt-square-down",
    icon: [448, 512, [], "f350", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352zm-64-208h-64V120c0-13.2-10.8-24-24-24h-80c-13.2 0-24 10.8-24 24v104H96c-28.4 0-42.8 34.5-22.6 54.6l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c20-20.1 5.8-54.6-22.7-54.6zM224 384L96 256h96V128h64v128h96L224 384z"]
  },
      rc = {
    prefix: "fal",
    iconName: "arrow-alt-square-left",
    icon: [448, 512, [], "f351", "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM48 448c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48zm208-64v-64h104c13.2 0 24-10.8 24-24v-80c0-13.2-10.8-24-24-24H256v-64c0-28.4-34.5-42.8-54.6-22.6l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c20.1 20 54.6 5.8 54.6-22.7zM96 256l128-128v96h128v64H224v96L96 256z"]
  },
      ic = {
    prefix: "fal",
    iconName: "arrow-alt-square-right",
    icon: [448, 512, [], "f352", "M0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80zm400-16c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352zm-208 64v64H88c-13.2 0-24 10.8-24 24v80c0 13.2 10.8 24 24 24h104v64c0 28.4 34.5 42.8 54.6 22.6l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-20.1-20-54.6-5.8-54.6 22.7zm160 128L224 384v-96H96v-64h128v-96l128 128z"]
  },
      oc = {
    prefix: "fal",
    iconName: "arrow-alt-square-up",
    icon: [448, 512, [], "f353", "M48 480h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48zM32 80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80zm64 208h64v104c0 13.2 10.8 24 24 24h80c13.2 0 24-10.8 24-24V288h64c28.4 0 42.8-34.5 22.6-54.6l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128C53.3 253.5 67.5 288 96 288zm128-160l128 128h-96v128h-64V256H96l128-128z"]
  },
      lc = {
    prefix: "fal",
    iconName: "arrow-alt-to-bottom",
    icon: [384, 512, [], "f34a", "M230.9 64c8.8 0 16 7.2 16 16v144h93.9c7.1 0 10.7 8.6 5.7 13.6L203.3 381.2c-6.3 6.3-16.4 6.3-22.7 0l-143-143.6c-5-5-1.5-13.6 5.7-13.6h93.9V80c0-8.8 7.2-16 16-16h77.7m0-32h-77.7c-26.5 0-48 21.5-48 48v112H43.3c-35.5 0-53.5 43-28.3 68.2l143 143.6c18.8 18.8 49.2 18.8 68 0l143.1-143.5c25.1-25.1 7.3-68.2-28.3-68.2h-61.9V80c0-26.5-21.6-48-48-48zM384 468v-8c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12z"]
  },
      fc = {
    prefix: "fal",
    iconName: "arrow-alt-to-left",
    icon: [448, 512, [], "f34b", "M20 64h-8C5.4 64 0 69.4 0 76v360c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm380 105.2H288v-61.9c0-35.5-43-53.5-68.2-28.3L76.2 222c-18.8 18.8-18.8 49.2 0 68l143.5 143.1c25.1 25.1 68.2 7.3 68.2-28.3v-61.9h112c26.6 0 48.1-21.6 48.1-48v-77.7c0-26.5-21.5-48-48-48zm15.9 125.7c0 8.8-7.1 16-15.9 16H256v93.9c0 7.1-8.6 10.7-13.6 5.7L98.8 267.3c-6.3-6.3-6.3-16.4 0-22.7l143.5-143.1c5-5 13.6-1.5 13.6 5.7v93.9h144c8.8 0 16 7.2 16 16z"]
  },
      sc = {
    prefix: "fal",
    iconName: "arrow-alt-to-right",
    icon: [448, 512, [], "f34c", "M32 217.1c0-8.8 7.2-16 16-16h144v-93.9c0-7.1 8.6-10.7 13.6-5.7l143.5 143.1c6.3 6.3 6.3 16.4 0 22.7L205.6 410.4c-5 5-13.6 1.5-13.6-5.7v-93.9H48c-8.8 0-16-7.2-16-16v-77.7m-32 0v77.7c0 26.5 21.5 48 48 48h112v61.9c0 35.5 43 53.5 68.2 28.3l143.6-143c18.8-18.8 18.8-49.2 0-68L228.2 78.9c-25.1-25.1-68.2-7.3-68.2 28.3v61.9H48c-26.5 0-48 21.6-48 48zM436 64h-8c-6.6 0-12 5.4-12 12v360c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12z"]
  },
      uc = {
    prefix: "fal",
    iconName: "arrow-alt-to-top",
    icon: [384, 512, [], "f34d", "M153.1 448c-8.8 0-16-7.2-16-16V288H43.3c-7.1 0-10.7-8.6-5.7-13.6l143.1-143.5c6.3-6.3 16.4-6.3 22.7 0l143.1 143.5c5 5 1.5 13.6-5.7 13.6h-93.9v144c0 8.8-7.2 16-16 16h-77.8m0 32h77.7c26.5 0 48-21.5 48-48V320h61.9c35.5 0 53.5-43 28.3-68.2L226 108.2c-18.8-18.8-49.2-18.8-68 0L14.9 251.8c-25 25.1-7.3 68.2 28.4 68.2h61.9v112c-.1 26.5 21.5 48 47.9 48zM0 44v8c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H12C5.4 32 0 37.4 0 44z"]
  },
      hc = {
    prefix: "fal",
    iconName: "arrow-alt-up",
    icon: [448, 512, [], "f357", "M180.573 448C169.211 448 160 438.789 160 427.428V255.991H43.021c-7.125 0-10.695-8.612-5.66-13.653L209.444 70.035c8.036-8.046 21.076-8.047 29.112 0L410.64 242.338c5.035 5.041 1.464 13.653-5.66 13.653H288v171.437C288 438.79 278.789 448 267.427 448h-86.854m0 32h86.855C296.416 480 320 456.416 320 427.428V287.991h84.979c35.507 0 53.497-43.04 28.302-68.266L261.198 47.422c-20.55-20.576-53.842-20.58-74.396 0L14.719 219.724c-25.091 25.122-7.351 68.266 28.302 68.266H128v139.437C128 456.416 151.584 480 180.573 480z"]
  },
      mc = {
    prefix: "fal",
    iconName: "arrow-circle-down",
    icon: [512, 512, [], "f0ab", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-92.5-4.5l-6.9-6.9c-4.7-4.7-12.5-4.7-17.1.2L273 330.3V140c0-6.6-5.4-12-12-12h-10c-6.6 0-12 5.4-12 12v190.3l-82.5-85.6c-4.7-4.8-12.4-4.9-17.1-.2l-6.9 6.9c-4.7 4.7-4.7 12.3 0 17l115 115.1c4.7 4.7 12.3 4.7 17 0l115-115.1c4.7-4.6 4.7-12.2 0-16.9z"]
  },
      vc = {
    prefix: "fal",
    iconName: "arrow-circle-left",
    icon: [512, 512, [], "f0a8", "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zM256 472c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm-12.5-92.5l-115.1-115c-4.7-4.7-4.7-12.3 0-17l115.1-115c4.7-4.7 12.3-4.7 17 0l6.9 6.9c4.7 4.7 4.7 12.5-.2 17.1L181.7 239H372c6.6 0 12 5.4 12 12v10c0 6.6-5.4 12-12 12H181.7l85.6 82.5c4.8 4.7 4.9 12.4.2 17.1l-6.9 6.9c-4.8 4.7-12.4 4.7-17.1 0z"]
  },
      dc = {
    prefix: "fal",
    iconName: "arrow-circle-right",
    icon: [512, 512, [], "f0a9", "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zM256 40c118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216zm12.5 92.5l115.1 115c4.7 4.7 4.7 12.3 0 17l-115.1 115c-4.7 4.7-12.3 4.7-17 0l-6.9-6.9c-4.7-4.7-4.7-12.5.2-17.1l85.6-82.5H140c-6.6 0-12-5.4-12-12v-10c0-6.6 5.4-12 12-12h190.3l-85.6-82.5c-4.8-4.7-4.9-12.4-.2-17.1l6.9-6.9c4.8-4.7 12.4-4.7 17.1 0z"]
  },
      Mc = {
    prefix: "fal",
    iconName: "arrow-circle-up",
    icon: [512, 512, [], "f0aa", "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zM40 256c0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216zm92.5-12.5l115-115.1c4.7-4.7 12.3-4.7 17 0l115 115.1c4.7 4.7 4.7 12.3 0 17l-6.9 6.9c-4.7 4.7-12.5 4.7-17.1-.2L273 181.7V372c0 6.6-5.4 12-12 12h-10c-6.6 0-12-5.4-12-12V181.7l-82.5 85.6c-4.7 4.8-12.4 4.9-17.1.2l-6.9-6.9c-4.7-4.8-4.7-12.4 0-17.1z"]
  },
      pc = {
    prefix: "fal",
    iconName: "arrow-down",
    icon: [448, 512, [], "f063", "M443.5 248.5l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L241 419.9V44c0-6.6-5.4-12-12-12h-10c-6.6 0-12 5.4-12 12v375.9L28.5 241.4c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.8 4.8-12.3.1-17z"]
  },
      zc = {
    prefix: "fal",
    iconName: "arrow-from-bottom",
    icon: [384, 512, [], "f342", "M35.5 184l148-148.5c4.7-4.7 12.3-4.7 17 0l148 148.5c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L209 92.1V404c0 6.6-5.4 12-12 12h-10c-6.6 0-12-5.4-12-12V92.1L59.6 208c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.6-4.7-12.2 0-16.9zM384 468v-8c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12z"]
  },
      Cc = {
    prefix: "fal",
    iconName: "arrow-from-left",
    icon: [448, 512, [], "f343", "M296 99.5l148.5 148c4.7 4.7 4.7 12.3 0 17L296 412.5c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l116-115.4H76c-6.6 0-12-5.4-12-12v-10c0-6.6 5.4-12 12-12h311.9L272 123.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.6-4.7 12.2-4.7 16.9 0zM12 448h8c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12h-8C5.4 64 0 69.4 0 76v360c0 6.6 5.4 12 12 12z"]
  },
      Lc = {
    prefix: "fal",
    iconName: "arrow-from-right",
    icon: [448, 512, [], "f344", "M152 412.5L3.5 264.5c-4.7-4.7-4.7-12.3 0-17L152 99.5c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L60.1 239H372c6.6 0 12 5.4 12 12v10c0 6.6-5.4 12-12 12H60.1L176 388.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.6 4.7-12.2 4.7-16.9 0zM436 64h-8c-6.6 0-12 5.4-12 12v360c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12z"]
  },
      Ac = {
    prefix: "fal",
    iconName: "arrow-from-top",
    icon: [384, 512, [], "f345", "M348.5 328l-148 148.5c-4.7 4.7-12.3 4.7-17 0L35.5 328c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l115.4 116V108c0-6.6 5.4-12 12-12h10c6.6 0 12 5.4 12 12v311.9L324.4 304c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.6 4.7 12.2 0 16.9zM0 44v8c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H12C5.4 32 0 37.4 0 44z"]
  },
      Nc = {
    prefix: "fal",
    iconName: "arrow-left",
    icon: [448, 512, [], "f060", "M231.536 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113L238.607 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"]
  },
      gc = {
    prefix: "fal",
    iconName: "arrow-right",
    icon: [448, 512, [], "f061", "M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z"]
  },
      Hc = {
    prefix: "fal",
    iconName: "arrow-square-down",
    icon: [448, 512, [], "f339", "M347.5 268.5l-115 115.1c-4.7 4.7-12.3 4.7-17 0l-115-115.1c-4.7-4.7-4.7-12.3 0-17l6.9-6.9c4.7-4.7 12.5-4.7 17.1.2l82.5 85.6V140c0-6.6 5.4-12 12-12h10c6.6 0 12 5.4 12 12v190.3l82.5-85.6c4.7-4.8 12.4-4.9 17.1-.2l6.9 6.9c4.7 4.8 4.7 12.4 0 17.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-32 0c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V80z"]
  },
      Vc = {
    prefix: "fal",
    iconName: "arrow-square-left",
    icon: [448, 512, [], "f33a", "M211.5 379.5l-115.1-115c-4.7-4.7-4.7-12.3 0-17l115.1-115c4.7-4.7 12.3-4.7 17 0l6.9 6.9c4.7 4.7 4.7 12.5-.2 17.1L149.7 239H340c6.6 0 12 5.4 12 12v10c0 6.6-5.4 12-12 12H149.7l85.6 82.5c4.8 4.7 4.9 12.4.2 17.1l-6.9 6.9c-4.8 4.7-12.4 4.7-17.1 0zM400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm0-32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h352z"]
  },
      xc = {
    prefix: "fal",
    iconName: "arrow-square-right",
    icon: [448, 512, [], "f33b", "M236.5 132.5l115.1 115c4.7 4.7 4.7 12.3 0 17l-115.1 115c-4.7 4.7-12.3 4.7-17 0l-6.9-6.9c-4.7-4.7-4.7-12.5.2-17.1l85.6-82.5H108c-6.6 0-12-5.4-12-12v-10c0-6.6 5.4-12 12-12h190.3l-85.6-82.5c-4.8-4.7-4.9-12.4-.2-17.1l6.9-6.9c4.8-4.7 12.4-4.7 17.1 0zM48 32h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 32c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H48z"]
  },
      wc = {
    prefix: "fal",
    iconName: "arrow-square-up",
    icon: [448, 512, [], "f33c", "M100.5 243.5l115-115.1c4.7-4.7 12.3-4.7 17 0l115 115.1c4.7 4.7 4.7 12.3 0 17l-6.9 6.9c-4.7 4.7-12.5 4.7-17.1-.2L241 181.7V372c0 6.6-5.4 12-12 12h-10c-6.6 0-12-5.4-12-12V181.7l-82.5 85.6c-4.7 4.8-12.4 4.9-17.1.2l-6.9-6.9c-4.7-4.8-4.7-12.4 0-17.1zM0 432V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm32 0c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v352z"]
  },
      yc = {
    prefix: "fal",
    iconName: "arrow-to-bottom",
    icon: [384, 512, [], "f33d", "M348.5 264l-148 148.5c-4.7 4.7-12.3 4.7-17 0L35.5 264c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l115.4 116V44c0-6.6 5.4-12 12-12h10c6.6 0 12 5.4 12 12v311.9L324.4 240c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.6 4.7 12.2 0 16.9zM384 468v-8c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12z"]
  },
      bc = {
    prefix: "fal",
    iconName: "arrow-to-left",
    icon: [448, 512, [], "f33e", "M216 412.5l-148.5-148c-4.7-4.7-4.7-12.3 0-17L216 99.5c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L124.1 239H436c6.6 0 12 5.4 12 12v10c0 6.6-5.4 12-12 12H124.1L240 388.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.6 4.7-12.2 4.7-16.9 0zM12 448h8c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12h-8C5.4 64 0 69.4 0 76v360c0 6.6 5.4 12 12 12z"]
  },
      Sc = {
    prefix: "fal",
    iconName: "arrow-to-right",
    icon: [448, 512, [], "f340", "M215 99.5l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l116 115.4H12c-6.6 0-12 5.4-12 12v10c0 6.6 5.4 12 12 12h311.9L208 388.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l148.5-148c4.7-4.7 4.7-12.3 0-17L232 99.5c-4.7-4.7-12.3-4.7-17 0zM448 76v360c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12z"]
  },
      Tc = {
    prefix: "fal",
    iconName: "arrow-to-top",
    icon: [384, 512, [], "f341", "M35.5 248l148-148.5c4.7-4.7 12.3-4.7 17 0l148 148.5c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L209 156.1V468c0 6.6-5.4 12-12 12h-10c-6.6 0-12-5.4-12-12V156.1L59.6 272c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.6-4.7-12.2 0-16.9zM0 44v8c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H12C5.4 32 0 37.4 0 44z"]
  },
      Dc = {
    prefix: "fal",
    iconName: "arrow-up",
    icon: [448, 512, [], "f062", "M4.465 263.536l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L207 92.113V468c0 6.627 5.373 12 12 12h10c6.627 0 12-5.373 12-12V92.113l178.494 178.493c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-211.05-211.05c-4.686-4.686-12.284-4.686-16.971 0L4.465 246.566c-4.687 4.686-4.687 12.284 0 16.97z"]
  },
      jc = {
    prefix: "fal",
    iconName: "arrows",
    icon: [512, 512, [], "f047", "M337.782 434.704l-73.297 73.782c-4.686 4.686-12.284 4.686-16.971 0l-73.296-73.782c-4.686-4.686-4.686-12.284 0-16.97l7.07-7.07c4.686-4.686 12.284-4.686 16.971 0L239 451.887h1V272H60.113v1l41.224 40.741c4.686 4.686 4.686 12.284 0 16.971l-7.071 7.07c-4.686 4.686-12.284 4.686-16.97 0L3.515 264.485c-4.686-4.686-4.686-12.284 0-16.971l73.782-73.297c4.686-4.686 12.284-4.686 16.971 0l7.071 7.071c4.686 4.686 4.686 12.284 0 16.971L60.113 239v1H240V60.113h-1l-40.741 41.224c-4.686 4.686-12.284 4.686-16.971 0l-7.07-7.071c-4.686-4.686-4.687-12.284 0-16.97l73.297-73.782c4.686-4.686 12.284-4.686 16.971 0l73.297 73.782c4.686 4.686 4.686 12.284 0 16.971l-7.071 7.071c-4.686 4.686-12.284 4.686-16.971 0L273 60.113h-1V240h179.887v-1l-41.224-40.741c-4.686-4.686-4.686-12.284 0-16.971l7.071-7.07c4.686-4.686 12.284-4.686 16.97 0l73.782 73.297c4.687 4.686 4.686 12.284 0 16.971l-73.782 73.297c-4.686 4.686-12.284 4.686-16.97 0l-7.071-7.07c-4.686-4.686-4.686-12.284 0-16.971L451.887 273v-1H272v179.887h1l40.741-41.224c4.686-4.686 12.284-4.686 16.971 0l7.07 7.071c4.686 4.685 4.686 12.283 0 16.97z"]
  },
      Ec = {
    prefix: "fal",
    iconName: "arrows-alt",
    icon: [512, 512, [], "f0b2", "M502.3 232.7l-66.5-66.5c-20.7-20.7-56.3-6-56.3 23.3V240H272V132.4h50.5c29.3 0 44.1-35.5 23.3-56.3L279.3 9.7c-12.9-12.9-33.8-12.9-46.6 0l-66.5 66.5c-20.7 20.7-6 56.3 23.3 56.3H240V240H132.4v-50.5c0-29.3-35.5-44.1-56.3-23.3L9.7 232.7c-12.9 12.9-12.9 33.8 0 46.6l66.5 66.5c20.7 20.7 56.3 6 56.3-23.3V272H240v107.6h-50.5c-29.3 0-44.1 35.5-23.3 56.3l66.5 66.5c12.9 12.9 33.8 12.9 46.6 0l66.5-66.5c20.7-20.7 6-56.3-23.3-56.3H272V272h107.6v50.5c0 29.3 35.5 44.1 56.3 23.3l66.5-66.5c12.8-12.9 12.8-33.7-.1-46.6zm-398.7 89.8c0 3.7-4.4 5.5-7 2.9l-66.5-66.5c-1.6-1.6-1.6-4.2 0-5.8l66.5-66.5c2.6-2.6 7-.7 7 2.9zm218.9 85.9c3.7 0 5.5 4.4 2.9 7l-66.5 66.5c-1.6 1.6-4.2 1.6-5.8 0l-66.5-66.5c-2.6-2.6-.7-7 2.9-7zm-133-304.8c-3.7 0-5.5-4.4-2.9-7l66.5-66.5c1.6-1.6 4.2-1.6 5.8 0l66.5 66.5c2.6 2.6.7 7-2.9 7zm292.4 155.3l-66.5 66.5c-2.6 2.6-7 .7-7-2.9V189.6c0-3.7 4.4-5.5 7-2.9l66.5 66.5c1.7 1.5 1.7 4.1 0 5.7z"]
  },
      kc = {
    prefix: "fal",
    iconName: "arrows-alt-h",
    icon: [512, 512, [], "f337", "M502.6 233.4l-64-64c-20.1-20.1-54.6-5.9-54.6 22.6v47H128v-47c0-28.4-34.5-42.8-54.6-22.6l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c20.1 20.1 54.6 5.9 54.6-22.6v-47h256v47c0 28.4 34.5 42.8 54.6 22.6l64-64c12.5-12.6 12.5-32.8 0-45.3zM100 320c0 3.5-4.3 5.4-6.8 2.8l-64-64c-1.6-1.6-1.6-4.1 0-5.6l64-64c2.5-2.5 6.8-.7 6.8 2.8zm382.8-61.2l-64 64c-2.5 2.5-6.8.7-6.8-2.8V192c0-3.5 4.3-5.4 6.8-2.8l64 64c1.6 1.5 1.6 4.1 0 5.6z"]
  },
      Ic = {
    prefix: "fal",
    iconName: "arrows-alt-v",
    icon: [192, 512, [], "f338", "M160 384h-47V128h47c28.4 0 42.8-34.5 22.6-54.6l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64C-10.7 93.5 3.5 128 32 128h47v256H32c-28.4 0-42.8 34.5-22.6 54.6l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c20-20.1 5.8-54.6-22.7-54.6zM32 100c-3.5 0-5.4-4.3-2.8-6.8l64-64c1.6-1.6 4.1-1.6 5.6 0l64 64c2.5 2.5.7 6.8-2.8 6.8zm130.8 318.8l-64 64c-1.6 1.6-4.1 1.6-5.6 0l-64-64c-2.5-2.5-.7-6.8 2.8-6.8h128c3.5 0 5.3 4.3 2.8 6.8z"]
  },
      Oc = {
    prefix: "fal",
    iconName: "arrows-h",
    icon: [512, 512, [], "f07e", "M399.959 170.585c-4.686 4.686-4.686 12.284 0 16.971L451.887 239H60.113l51.928-51.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-84.485 84c-4.686 4.686-4.686 12.284 0 16.971l84.485 84c4.686 4.686 12.284 4.686 16.97 0l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273h391.773l-51.928 51.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l84.485-84c4.687-4.686 4.687-12.284 0-16.971l-84.485-84c-4.686-4.686-12.284-4.686-16.97 0l-7.07 7.071z"]
  },
      Qc = {
    prefix: "fal",
    iconName: "arrows-v",
    icon: [192, 512, [], "f07d", "M181.415 399.959c-4.686-4.686-12.284-4.686-16.971 0L113 451.887V60.113l51.444 51.928c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-84-84.485c-4.686-4.686-12.284-4.686-16.971 0L3.515 88c-4.686 4.686-4.686 12.284 0 16.97l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L79 60.113v391.773l-51.444-51.928c-4.686-4.686-12.284-4.686-16.971 0l-7.07 7.071c-4.686 4.686-4.686 12.284 0 16.97l84 84.485c4.686 4.687 12.284 4.687 16.971 0l84-84.485c4.686-4.686 4.686-12.284 0-16.97l-7.071-7.07z"]
  },
      Zc = {
    prefix: "fal",
    iconName: "assistive-listening-systems",
    icon: [512, 512, [], "f2a2", "M217.6 512c-8.837 0-16-7.163-16-16s7.163-16 16-16c41.172 0 74.667-33.495 74.667-74.666 0-85.174 73.391-93.9 73.391-165.334 0-71.167-57.899-129.066-129.067-129.066-71.167 0-129.066 57.899-129.066 129.066 0 8.837-7.163 16-16 16s-16-7.163-16-16c0-88.812 72.254-161.066 161.066-161.066S397.657 151.188 397.657 240c0 86.857-73.391 96.041-73.391 165.334C324.267 464.149 276.416 512 217.6 512zm115.733-272c0-53.816-43.783-97.6-97.6-97.6s-97.6 43.783-97.6 97.6c0 8.837 7.163 16 16 16s16-7.163 16-16c0-36.172 29.428-65.6 65.6-65.6s65.6 29.428 65.6 65.6c0 8.837 7.163 16 16 16s16-7.163 16-16zm106.47-45.984c8.448-2.591 13.195-11.541 10.604-19.988-14.644-47.732-45.384-89.796-86.559-118.441-7.254-5.046-17.226-3.259-22.271 3.996-5.047 7.254-3.258 17.226 3.996 22.271 35.322 24.574 61.688 60.643 74.242 101.559 2.593 8.453 11.545 13.193 19.988 10.603zm60.888-18.65c8.447-2.594 13.193-11.544 10.601-19.991C492.386 93.787 452.886 39.627 400.059 2.868c-7.253-5.046-17.225-3.259-22.272 3.995-5.047 7.253-3.258 17.225 3.995 22.272 46.978 32.688 82.105 80.855 98.918 135.631 2.593 8.447 11.541 13.192 19.991 10.6zM240 256c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm-64 64c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm-96 96c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm-64 64c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm155.313-75.313l-64-64-22.627 22.627 64 64 22.627-22.627z"]
  },
      Uc = {
    prefix: "fal",
    iconName: "asterisk",
    icon: [512, 512, [], "f069", "M475.31 364.144L288 256l187.31-108.144c5.74-3.314 7.706-10.653 4.392-16.392l-4-6.928c-3.314-5.74-10.653-7.706-16.392-4.392L272 228.287V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v216.287L52.69 120.144c-5.74-3.314-13.079-1.347-16.392 4.392l-4 6.928c-3.314 5.74-1.347 13.079 4.392 16.392L224 256 36.69 364.144c-5.74 3.314-7.706 10.653-4.392 16.392l4 6.928c3.314 5.74 10.653 7.706 16.392 4.392L240 283.713V500c0 6.627 5.373 12 12 12h8c6.627 0 12-5.373 12-12V283.713l187.31 108.143c5.74 3.314 13.079 1.347 16.392-4.392l4-6.928c3.314-5.74 1.347-13.079-4.392-16.392z"]
  },
      Bc = {
    prefix: "fal",
    iconName: "at",
    icon: [512, 512, [], "f1fa", "M256 8C118.941 8 8 118.919 8 256c0 137.058 110.919 248 248 248 52.925 0 104.68-17.078 147.092-48.319 5.501-4.052 6.423-11.924 2.095-17.211l-5.074-6.198c-4.018-4.909-11.193-5.883-16.307-2.129C346.93 457.208 301.974 472 256 472c-119.373 0-216-96.607-216-216 0-119.375 96.607-216 216-216 118.445 0 216 80.024 216 200 0 72.873-52.819 108.241-116.065 108.241-19.734 0-23.695-10.816-19.503-33.868l32.07-164.071c1.449-7.411-4.226-14.302-11.777-14.302h-12.421a12 12 0 0 0-11.781 9.718c-2.294 11.846-2.86 13.464-3.861 25.647-11.729-27.078-38.639-43.023-73.375-43.023-68.044 0-133.176 62.95-133.176 157.027 0 61.587 33.915 98.354 90.723 98.354 39.729 0 70.601-24.278 86.633-46.982-1.211 27.786 17.455 42.213 45.975 42.213C453.089 378.954 504 321.729 504 240 504 103.814 393.863 8 256 8zm-37.92 342.627c-36.681 0-58.58-25.108-58.58-67.166 0-74.69 50.765-121.545 97.217-121.545 38.857 0 58.102 27.79 58.102 65.735 0 58.133-38.369 122.976-96.739 122.976z"]
  },
      Rc = {
    prefix: "fal",
    iconName: "atlas",
    icon: [448, 512, [], "f558", "M448 392V24c0-13.3-10.7-24-24-24H80C35.8 0 0 35.8 0 80v368c0 35.35 28.65 64 64 64h372c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-3.3c-4-20.2-3.2-49.7.4-65.8 8.7-3.6 14.9-12.2 14.9-22.2zm-43.7 88H64c-17.67 0-32-14.33-32-32s14.33-32 32-32h340.3c-2.9 18.8-3.1 43.6 0 64zm11.7-96H64c-11.72 0-22.55 3.38-32 8.88V80c0-26.5 21.5-48 48-48h336v352zm-192-48c70.69 0 128-57.31 128-128S294.69 80 224 80 96 137.31 96 208s57.31 128 128 128zm94.38-144h-39.09c-1.49-27.03-6.54-51.35-14.21-70.41 27.71 13.24 48.02 39.19 53.3 70.41zm-39.09 32h39.09c-5.29 31.22-25.59 57.17-53.3 70.41 7.68-19.06 12.72-43.38 14.21-70.41zM224 113.31c7.69 7.45 20.77 34.42 23.43 78.69h-46.87c2.67-44.26 15.75-71.24 23.44-78.69zM247.43 224c-2.66 44.26-15.74 71.24-23.43 78.69-7.69-7.45-20.77-34.42-23.43-78.69h46.86zm-64.51-102.41c-7.68 19.06-12.72 43.38-14.21 70.41h-39.09c5.28-31.22 25.59-57.17 53.3-70.41zM168.71 224c1.49 27.03 6.54 51.35 14.21 70.41-27.71-13.24-48.02-39.19-53.3-70.41h39.09z"]
  },
      Yc = {
    prefix: "fal",
    iconName: "atom",
    icon: [448, 512, [], "f5d2", "M224,200a56,56,0,1,0,56.00149,56A56.06868,56.06868,0,0,0,224,200Zm0,80a24,24,0,1,1,24.00064-24A24.00651,24.00651,0,0,1,224,280Zm188.72376-24c15.56292-20.26562,26.71946-40.625,31.9071-60,6.03141-22.60938,3.9376-43.42188-6.06266-60.1875-18.21924-30.5-60.34535-42.96875-113.503-38.4375C301.81457,37.8125,265.5636,0,224,0S146.18543,37.8125,122.96607,97.375c-53.18892-4.53125-95.315,7.92188-113.503,38.4375C-.56846,152.57812-2.66227,173.39062,3.36914,196c5.18764,19.375,16.34418,39.73438,31.9071,60-15.56292,20.26562-26.71946,40.625-31.9071,60-6.03141,22.60938-3.9376,43.42188,6.06266,60.1875,15.84417,26.5,49.59507,39.51562,93.03372,39.51562,6.37517,0,13.50036-1.14062,20.25054-1.70312C145.96668,473.92188,182.31139,512,224,512s78.03332-38.07812,101.28394-98c6.75018.5625,13.87537,1.70312,20.25054,1.70312,43.4074,0,77.18955-13.01562,93.00247-39.51562,10.03151-16.76562,12.12532-37.57812,6.09391-60.1875C439.44322,296.625,428.28668,276.26562,412.72376,256ZM36.90128,359.78125c-5.5314-9.29687-6.43767-21.25-2.59382-35.5,3.68682-13.71875,11.59406-28.40625,22.3131-43.29687A400.69639,400.69639,0,0,0,99.93421,319.4375a432.51171,432.51171,0,0,0,12.59408,63.9375C74.80854,385.3125,47.1203,376.84375,36.90128,359.78125Zm59.53283-85.04687Q86.16822,265.42969,77.3086,256q8.85962-9.44532,19.12551-18.73438c-.21875,6.21876-.46876,12.39063-.46876,18.73438S96.21536,268.51562,96.43411,274.73438Zm3.5001-82.17188a397.74293,397.74293,0,0,0-43.31365,38.45312c-10.719-14.89062-18.62628-29.57812-22.3131-43.29687-3.84385-14.25-2.93758-26.20313,2.62507-35.5,9.219-15.46875,32.71962-23.98437,65.158-23.98437,3.31259,0,6.90644.28124,10.43778.45312A431.64065,431.64065,0,0,0,99.93421,192.5625Zm211.75562-25.5c-8.37522-5.32812-16.87545-10.57812-25.81319-15.54688-6.43767-3.57812-12.84409-6.90624-19.28176-10.14062a338.66891,338.66891,0,0,1,36.56347-8.8125C306.00139,141.96875,309.81478,157.42188,311.68983,167.0625ZM224,32c24.06314,0,49.53257,26.03125,68.18931,69.96875A407.59456,407.59456,0,0,0,224,122.3125a405.98246,405.98246,0,0,0-68.18931-20.35938C174.46743,58.01562,199.93686,32,224,32ZM144.84165,132.5625a336.43586,336.43586,0,0,1,36.53222,8.8125c-6.40642,3.23438-12.84409,6.5625-19.25051,10.14062-8.93774,4.96876-17.438,10.21876-25.81319,15.54688C138.18522,157.42188,141.997,141.96875,144.84165,132.5625Zm-8.53148,212.375c8.37522,5.32812,16.87545,10.57812,25.81319,15.54688,6.71893,3.75,13.37535,6.48437,20.09428,9.85937a344.234,344.234,0,0,1-37.376,9.125A355.36907,355.36907,0,0,1,136.31017,344.9375ZM224,480c-24.15689,0-49.72007-26.23438-68.40807-70.48438A402.25348,402.25348,0,0,0,224,389.20312a402.25348,402.25348,0,0,0,68.40807,20.3125C273.72007,453.76562,248.15689,480,224,480Zm79.15835-100.54688a341.68756,341.68756,0,0,1-37.34474-9.10937c6.71893-3.375,13.37536-6.10937,20.063-9.85937,8.93774-4.96876,17.46922-10.21876,25.84444-15.53126C309.31477,357.15625,306.40844,368.625,303.15835,379.45312Zm14.71914-77.39062a471.236,471.236,0,0,1-47.56376,30.48438,475.86157,475.86157,0,0,1-46.28248,22.60937,476.691,476.691,0,0,1-46.345-22.60937,471.236,471.236,0,0,1-47.56376-30.48438c-1.375-14.71875-2.15631-30.07812-2.15631-46.0625s.78127-31.34375,2.15631-46.0625a471.236,471.236,0,0,1,47.56376-30.48438A477.44789,477.44789,0,0,1,224,156.76562a477.44789,477.44789,0,0,1,46.31373,22.6875,471.236,471.236,0,0,1,47.56376,30.48438c1.375,14.71875,2.15631,30.07812,2.15631,46.0625S319.25253,287.34375,317.87749,302.0625Zm28.06325-173.82812c32.40711,0,55.90773,8.51562,65.158,23.96874,5.5314,9.3125,6.43767,21.25,2.59382,35.5-3.68839,13.73438-11.59406,28.40626-22.3131,43.3125a396.1044,396.1044,0,0,0-43.31365-38.45312,435.36835,435.36835,0,0,0-12.56283-63.875C339.003,128.5,342.5969,128.23438,345.94074,128.23438Zm5.62515,109.03124Q361.83179,246.57032,370.6914,256q-8.85962,9.44532-19.12551,18.73438c.21875-6.21876.46876-12.39063.46876-18.73438S351.78464,243.48438,351.56589,237.26562Zm59.50158,122.51563c-10.15652,17.0625-37.84476,25.53125-75.59576,23.5625a432.07594,432.07594,0,0,0,12.59408-63.90625,397.74293,397.74293,0,0,0,43.31365-38.45312c10.719,14.89062,18.62471,29.57812,22.3131,43.29687C417.53639,338.53125,416.63012,350.48438,411.06747,359.78125Z"]
  },
      Pc = {
    prefix: "fal",
    iconName: "atom-alt",
    icon: [448, 512, [], "f5d3", "M394.06157,256.00111c55.56193,84.484,71.15552,164.23356,32.84342,202.46775C412.49888,472.81254,392.40534,480,367.87434,480c-21.18728,0-45.562-5.34372-72.43676-16.06242-23.18726-9.25-47.312-22.71864-71.43677-38.57793-24.156,15.87492-48.28075,29.328-71.43677,38.57793C125.68932,474.65628,101.25207,480,80.12729,480c-24.56225,0-44.6558-7.18746-59.03065-21.53114C-17.21547,420.23467-1.62188,340.48507,53.9088,256.00111-1.62188,171.51715-17.21547,91.76755,21.09664,53.53336,47.90887,26.81474,94.53339,24.92413,152.564,48.06464c23.156,9.25,47.28077,22.71864,71.43677,38.57793,24.12476-15.87492,48.24951-29.328,71.43677-38.57793C353.562,24.89288,400.18651,26.86162,426.905,53.53336,465.21709,91.76755,449.6235,171.51715,394.06157,256.00111ZM195.7511,405.31287A619.164,619.164,0,0,1,130.56427,349.235a620.957,620.957,0,0,1-56.87442-64.96843C30.87779,353.51625,20.81539,412.95346,43.75266,435.844c16.93733,16.828,52.187,16.24992,96.874-1.60937C158.47023,427.094,177.06379,416.87531,195.7511,405.31287ZM73.7211,227.73562a609.0454,609.0454,0,0,1,122.03-121.04627c-18.68731-11.56244-37.24962-21.78114-55.12443-28.92173C117.5644,68.56454,97.03336,63.95518,80.18979,63.95518c-15.78109,0-28.24972,4.06248-36.40588,12.20307C20.81539,99.06439,30.909,158.486,73.7211,227.73562ZM224.00081,386.73484a585.00847,585.00847,0,0,0,70.74928-60.10908,581.92356,581.92356,0,0,0,60.43688-70.609,579.55986,579.55986,0,0,0-60.43688-70.609,585.9904,585.9904,0,0,0-70.74928-60.10908,583.82754,583.82754,0,0,0-70.78052,60.10908,576.41233,576.41233,0,0,0-60.40563,70.609,578.75052,578.75052,0,0,0,60.40563,70.609A586.65879,586.65879,0,0,0,224.00081,386.73484Zm56.12443-130.73373a56.12456,56.12456,0,1,1-56.12443-55.99972A56.1343,56.1343,0,0,1,280.12524,256.00111Zm-32.09342,0a24.04668,24.04668,0,1,0-24.031,23.99988A24.0027,24.0027,0,0,0,248.03182,256.00111Zm4.18745-149.31176a616.29534,616.29534,0,0,1,65.21809,56.07785,620.54665,620.54665,0,0,1,56.84317,64.96842c42.81206-69.24965,52.9057-128.68686,29.93719-151.57737-16.84358-16.79679-52.12447-16.21867-96.84276,1.60937C289.50014,84.90821,270.93783,95.14253,252.21927,106.68935ZM374.28053,284.26659A624.20736,624.20736,0,0,1,317.43736,349.235a622.60731,622.60731,0,0,1-65.21809,56.07785c18.68731,11.56244,37.28087,21.78114,55.15569,28.92173,44.687,17.85929,79.96793,18.42179,96.84276,1.60937C427.18623,412.95346,417.09259,353.51625,374.28053,284.26659Z"]
  },
      Fc = {
    prefix: "fal",
    iconName: "audio-description",
    icon: [512, 512, [], "f29e", "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm16 336c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V112c0-8.822 7.178-16 16-16h416c8.822 0 16 7.178 16 16v288zm-293.411-97.217h-67.335l-13.508 40.974A11.999 11.999 0 0 1 94.35 352H84.01c-8.276 0-14.067-8.18-11.319-15.986l59.155-168a12 12 0 0 1 11.319-8.015h19.514a12 12 0 0 1 11.319 8.015l59.155 168C235.902 343.82 230.11 352 221.834 352h-10.34c-5.18 0-9.775-3.324-11.397-8.243l-13.508-40.974zm-33.802-109.521s-4.327 18.93-8.113 29.746l-17.036 51.38h50.298l-17.037-51.38c-3.515-10.817-7.571-29.746-7.571-29.746h-.541zM263.385 172c0-6.627 5.373-12 12-12h53.443c59.222 0 97.893 35.155 97.893 95.73 0 60.574-38.67 96.27-97.893 96.27h-53.443c-6.627 0-12-5.373-12-12V172zm63.549 149.983c38.941 0 63.819-22.986 63.819-66.253 0-42.727-25.419-65.713-63.819-65.713H298.27v131.966h28.664z"]
  },
      Wc = {
    prefix: "fal",
    iconName: "award",
    icon: [384, 512, [], "f559", "M192 95.95c-52.93 0-96 43.07-96 96s43.07 96 96 96 96-43.07 96-96-43.06-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm175.63 16.38c14.06-14.31 19.59-35.33 14.47-54.86-6.39-24.2-6.39-20.45 0-44.69 5.13-19.52-.41-40.53-14.47-54.86-17.58-17.72-15.57-14.69-21.91-38.59-5.15-19.63-20.37-35.08-39.72-40.34-23.3-6.32-20.62-4.58-37.75-22.22-14.22-14.42-35.12-20.08-54.53-14.82-23.5 6.51-20.1 6.41-43.47 0-19.25-5.31-40.28.4-54.5 14.85-17.3 17.67-14.21 15.77-37.72 22.19-19.37 5.26-34.59 20.71-39.75 40.32-6.36 24.04-4.38 20.87-21.91 38.62C2.31 132.25-3.22 153.27 1.91 172.8c6.39 24.17 6.39 20.42 0 44.69-5.13 19.52.41 40.53 14.47 54.86 17.58 17.72 15.57 14.69 21.91 38.59 2.01 7.64 5.91 14.36 10.62 20.38L1.2 448.7c-4.31 10.57 3.51 22.04 14.79 22.04.55 0-2.91.12 53.32-2.03L105.56 507c3.22 3.4 7.42 5 11.58 5 6.17 0 12.23-3.53 14.86-9.96l52.45-129.03a23.346 23.346 0 0 1 15.11-.01L252 502.04c2.62 6.43 8.69 9.96 14.86 9.96 4.16 0 8.36-1.6 11.58-5l36.25-38.28c56.23 2.15 52.77 2.03 53.32 2.03 11.28 0 19.1-11.47 14.79-22.04l-47.7-117.37c4.71-6.02 8.61-12.74 10.62-20.37 6.36-24.06 4.38-20.89 21.91-38.64zM111.72 466.95c-22.59-23.86-16.56-17.49-29.13-30.77-18.3.7-9.45.36-42.41 1.63l35.55-87.48c.79.26 1.47.75 2.28.97 21.87 5.86 20.46 4.6 31.59 15.91 9.94 10.14 22.79 15.57 35.96 16.5l-33.84 83.24zm232.11-29.15c-32.91-1.26-24.13-.92-42.41-1.62-12.56 13.27-6.54 6.91-29.13 30.77l-33.9-83.4c13.21-.91 26.06-6.21 36.02-16.35 11.41-11.61 9.83-10.19 31.59-15.91.81-.22 1.49-.71 2.28-.96l35.55 87.47zm-29.05-134.99c-2.25 8.58-8.84 15.33-17.22 17.61-23.62 6.25-28.39 6.45-45.97 24.37-8 8.11-20.19 9.61-29.75 3.48-18.13-11.44-41.56-11.45-59.69.02-9.5 6.03-21.75 4.62-29.75-3.52-17.38-17.68-22.12-17.95-45.97-24.36-8.38-2.28-14.97-9.03-17.22-17.62-8.06-30.63-7.53-30.19-30.03-52.87-6.19-6.31-8.63-15.62-6.34-24.31 8.15-30.47 8.2-30.48 0-60.95-2.28-8.69.16-18 6.34-24.3 22.42-22.7 21.94-22.06 30.03-52.91 2.25-8.58 8.84-15.33 17.22-17.59 30.79-8.41 29.68-7.8 52.13-30.62 5.2-5.31 13.82-8.96 23.28-6.41 30.46 8.38 29.85 8.4 60.28 0 8.19-2.27 17.19.19 23.31 6.37 22.29 22.87 21.87 22.44 52.16 30.66 8.34 2.27 14.94 9.02 17.19 17.61 8.06 30.63 7.53 30.19 30.03 52.87 6.19 6.31 8.63 15.62 6.34 24.31-8.19 30.52-8.16 30.54 0 60.95 2.28 8.69-.16 18-6.34 24.3-22.41 22.71-21.94 22.06-30.03 52.91z"]
  },
      Gc = {
    prefix: "fal",
    iconName: "axe",
    icon: [640, 512, [], "f6b2", "M525.74 160l-47.27-47.27 24.16-24.16c12.5-12.5 12.5-32.76 0-45.26L468.69 9.37C462.44 3.12 454.25 0 446.06 0s-16.38 3.12-22.63 9.37l-24.16 24.16-24.15-24.16C368.87 3.12 360.68 0 352.49 0s-16.38 3.12-22.63 9.37l-96.49 96.49c-12.5 12.5-12.5 32.76 0 45.25l24.16 24.16L9.37 423.43c-12.5 12.5-12.5 32.76 0 45.26l33.94 33.94c6.25 6.25 14.44 9.37 22.63 9.37s16.38-3.12 22.63-9.37l248.16-248.16L384 301.74V416h32c123.71 0 224-100.29 224-224v-32H525.74zM446.03 32h.03L480 65.94 455.84 90.1l-33.95-33.96L446.03 32zM65.94 480L32 446.06 280.16 197.9l33.94 33.94L65.94 480zM416 384v-95.51l-160-160L352.46 32h.03l160 160H608c0 105.87-86.13 192-192 192z"]
  },
      qc = {
    prefix: "fal",
    iconName: "axe-battle",
    icon: [512, 512, [], "f6b3", "M512 160.92C505.23 99.15 476.88 44.29 437.8 4.7c-3.18-3.22-7.03-4.7-10.81-4.7-7.07 0-13.95 5.14-15.99 13.66-13.33 55.54-55.26 97.44-107 104.78V80c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v38.44c-51.74-7.35-93.67-49.24-107-104.78C98.96 5.14 92.08 0 85.01 0c-3.79 0-7.63 1.48-10.81 4.7C28.67 50.83 0 117.62 0 192c0 74.38 28.67 141.17 74.2 187.3 3.18 3.23 7.03 4.7 10.81 4.7 7.07 0 13.95-5.14 15.99-13.66 13.33-55.54 55.26-97.44 107-104.78V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V265.56c51.74 7.35 93.67 49.24 107 104.78 2.04 8.52 8.92 13.66 15.99 13.66 3.79 0 7.63-1.48 10.81-4.7 39.08-39.59 67.43-94.45 74.2-156.22L480 192l32-31.08zM78.65 335.56C48.76 295.83 32 244.92 32 192S48.76 88.17 78.65 48.44c6.93 17.01 38.53 89.43 129.35 102.33v82.47c-90.82 12.89-122.41 85.31-129.35 102.32zM272 480h-32V96h32v384zm185.04-265.71l19.29 19.87c-6.38 37.57-21.22 72.49-42.97 101.41-6.94-17.01-38.53-89.43-129.35-102.33v-82.47c90.82-12.9 122.41-85.32 129.35-102.33 21.75 28.92 36.59 63.83 42.97 101.41l-19.29 19.87L435.41 192l21.63 22.29z"]
  },
      Jc = {
    prefix: "fal",
    iconName: "baby",
    icon: [384, 512, [], "f77c", "M374.2 160.3c-17.4-25.2-52-32.1-77.9-14.5l-36.4 25c-29.4 20.2-86 34.3-135.9 0l-36.4-25C61.9 128.2 27.2 135 9.8 160.3c-17.5 25.5-11 60.4 14.4 77.9l36.4 24.9c10.9 7.5 22.8 14.1 35.4 19.8v22.6l-54.3 56.2c-19.2 17.8-23.5 46.4-10 69.3L70 487.1c10.3 15.4 27.9 24.9 46.6 24.9 10 0 19.8-2.7 28.4-7.8 13-7.7 52.3-40.5 2-96.5l18.4-11.6c15.1 5.3 37.9 5.3 53.1 0l18.4 11.6c-50.3 56-11 88.8 2 96.5 8.6 5.1 18.4 7.8 28.4 7.8 18.7 0 36.2-9.5 46.6-24.9l38.3-56.1c13.5-22.9 9.1-51.5-10-69.3L288 305.5v-22.6c12.6-5.6 24.4-12.3 35.4-19.8l36.4-24.9c25.4-17.5 31.9-52.5 14.4-77.9zm-237 283.5c6.7 11.4 2.9 26.1-8.5 32.9-3.8 2.3-8 3.3-12.2 3.3-8.2 0-16.2-4.2-20.7-11.8l-36.6-53.4c-6-10.2-3.7-23.3 5.5-30.8l38.8-41.2c.7.8 1 1.8 1.7 2.6l35.2 35.2-29.4 27.7 26.2 35.5zm82.9-85.2c-13.2 13.2-43.5 12.8-56.2 0L128 322.7V312h128v10.7l-35.9 35.9zm99.1 25.4c9.2 7.5 11.5 20.6 5.5 30.8l-36.6 53.4c-4.5 7.6-12.5 11.8-20.7 11.8-4.1 0-8.3-1.1-12.2-3.3-11.4-6.7-15.2-21.5-8.5-32.9l26.1-35.6-29.4-27.7 35.2-35.2c.7-.7 1.1-1.8 1.7-2.6l38.9 41.3zm22.4-172.2l-36.3 24.9c-15.4 10.5-32 18.5-49.3 24.4V280H128v-18.9c-17.3-5.9-33.9-13.8-49.3-24.4l-36.3-24.9c-26.4-18.2 1.2-57.3 27.2-39.6l36.3 24.9c47.2 32.4 117.3 37.7 172.1 0l36.3-24.9c26.1-17.7 53.7 21.4 27.3 39.6zM192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48z"]
  },
      Kc = {
    prefix: "fal",
    iconName: "baby-carriage",
    icon: [512, 512, [], "f77d", "M504 96h-40c-26.5 0-48 21.5-48 48v48H280.8L174.3 24.5c-8-12.6-21.2-21.2-36.3-23.7-14.8-2.5-29.8 1.2-41.2 10.3C35.3 60.3 0 132 0 208v16c0 67.2 40.3 126.2 101.3 160.5-1.8-.1-3.5-.5-5.3-.5-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64c0-18.1-7.6-34.3-19.6-46 25.9 8.9 54 14 83.6 14s57.8-5 83.6-14c-12 11.6-19.6 27.9-19.6 46 0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64c-1.8 0-3.5.4-5.3.5C407.7 350.2 448 291.2 448 224v-80c0-8.8 7.2-16 16-16h40c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM116.8 36.1c5.9-4.7 12.6-4.4 15.9-3.8 6.2 1 11.5 4.4 14.6 9.3L242.9 192H32.6c4.6-60.2 34.7-116.3 84.2-155.9zM96 480c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm256-64c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zm-128-32c-105.9 0-192-71.8-192-160h384c0 88.2-86.1 160-192 160z"]
  },
      Xc = {
    prefix: "fal",
    iconName: "backpack",
    icon: [448, 512, [], "f5d4", "M320 64h-16V48c0-26.47-21.53-48-48-48h-64c-26.47 0-48 21.53-48 48v16h-16C57.31 64 0 121.31 0 192v256c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V192c0-70.69-57.31-128-128-128zM176 48c0-8.83 7.19-16 16-16h64c8.81 0 16 7.17 16 16v16h-96V48zm160 432H112v-96h224v96zm0-128H112v-32c0-17.67 14.33-32 32-32h160c17.67 0 32 14.33 32 32v32zm80 96c0 17.64-14.36 32-32 32h-16V320c0-35.29-28.71-64-64-64H144c-35.29 0-64 28.71-64 64v160H64c-17.64 0-32-14.36-32-32V192c0-52.94 43.06-96 96-96h192c52.94 0 96 43.06 96 96v256zM312 160H136c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h176c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"]
  },
      _c = {
    prefix: "fal",
    iconName: "backspace",
    icon: [640, 512, [], "f55a", "M469.66 181.65l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0L384 233.37l-63.03-63.03c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31L361.38 256l-63.03 63.03c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0L384 278.63l63.03 63.03c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31L406.63 256l63.03-63.03a8.015 8.015 0 0 0 0-11.32zM576 64H205.26C188.28 64 172 70.74 160 82.74L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm32 320c0 17.64-14.36 32-32 32H205.26c-8.55 0-16.58-3.33-22.63-9.37L32 256l150.63-150.63c6.04-6.04 14.08-9.37 22.63-9.37H576c17.64 0 32 14.36 32 32v256z"]
  },
      $c = {
    prefix: "fal",
    iconName: "backward",
    icon: [512, 512, [], "f04a", "M267.5 281.1l192 159.4c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6L267.5 232c-15.3 12.8-15.3 36.4 0 49.1zm20.5-24.5L480 96v320L288 256.6zM11.5 281.1l192 159.4c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6L11.5 232c-15.3 12.8-15.3 36.4 0 49.1zM32 256.6L224 96v320L32 256.6z"]
  },
      ce = {
    prefix: "fal",
    iconName: "bacon",
    icon: [576, 512, [], "f7e5", "M566.93 104.4L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.11c-29.75 78.82-89.55 94.67-98.72 98.08-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l96.14 95.49a30.73 30.73 0 0 0 21.71 8.9 31.05 31.05 0 0 0 18.47-6.08c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.26 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05zM32.43 386.25c31.64-25.81 57.68-35.51 82.06-44.55 68.47-23.3 100.93-76.1 116.1-116.29l.93-2.5c29.66-79.72 86.61-135.76 169.26-166.54 16.73-6.24 31.22-11.63 48.19-24l34.54 34.11c-18.7 12.78-35 19-51.82 25.28-28.28 10.6-57.57 21.59-97.35 61.37s-50.78 69.01-61.34 97.31c-9.88 26.27-19.16 51.06-54 85.95s-59.66 44.16-85.91 54c-19.66 7.37-39.86 15.13-63.64 32.37zm429-215.9c-68.53 23.35-101 76.16-116.14 116.34l-.88 2.36c-29.77 79.82-86.73 135.89-169.32 166.66-16.93 6.3-31.55 11.74-47.37 24.69l-35.23-34.83c18.67-12.74 34.93-18.91 51.76-25.22 28.28-10.6 57.53-21.57 97.31-61.33s50.75-69 61.35-97.35c9.87-26.26 19.15-51.06 54.06-86s59.69-44.19 86-54c19.65-7.37 39.86-15.15 63.67-32.42l37 36.51c-31.75 25.85-57.79 35.55-82.17 44.59z"]
  },
      ee = {
    prefix: "fal",
    iconName: "bacteria",
    icon: [640, 512, [], "e059", "M128,200a24,24,0,1,0,24,24A24,24,0,0,0,128,200Zm80-72a16,16,0,1,0,16,16A16,16,0,0,0,208,128ZM416,360a24,24,0,1,0,24,24A24,24,0,0,0,416,360ZM615.67,230.76l11.58-3.43a17.73,17.73,0,1,0-10.13-34l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.45,83.45,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.89,17.89,0,0,0,24.94,3.6A17.68,17.68,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21A83.27,83.27,0,0,0,615.67,230.76Zm-32.38,13.79A256.43,256.43,0,0,1,372.49,455.3a52,52,0,0,1-8.61.72c-25,0-47-18.69-51.17-43.48a52,52,0,0,1,42.75-59.83A152.41,152.41,0,0,0,480.71,227.45a52,52,0,1,1,102.58,17.1ZM272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM159.29,284.55A51.78,51.78,0,0,1,108.11,328a52.71,52.71,0,0,1-8.66-.72,52,52,0,0,1-42.74-59.83A256.41,256.41,0,0,1,267.51,56.71c42.95-7.23,58.13,32.87,59.78,42.75a52,52,0,0,1-42.75,59.83A152.41,152.41,0,0,0,159.29,284.55Z"]
  },
      ae = {
    prefix: "fal",
    iconName: "bacterium",
    icon: [512, 512, [], "e05a", "M511.32,100.33a16.31,16.31,0,0,0-20.26-10.86L468.7,96.1C450.61,56.5,414,42.27,413.3,41.94L419,20.19A16.13,16.13,0,0,0,407.38.53,16.44,16.44,0,0,0,403.24,0a16.21,16.21,0,0,0-15.71,12.06L382,33.33A111.51,111.51,0,0,0,366.32,32a101.2,101.2,0,0,0-16.72,1.49A386.14,386.14,0,0,0,301,45.14l-6.32-17.71a16.33,16.33,0,0,0-15.29-10.77,15.77,15.77,0,0,0-5.44,1A16.12,16.12,0,0,0,264,38.26l6.31,17.6a383.18,383.18,0,0,0-73.86,39.38L185.24,80.31A16.38,16.38,0,0,0,162.45,77a15.91,15.91,0,0,0-6.34,10.59,16.07,16.07,0,0,0,3,12l11.25,15a384.18,384.18,0,0,0-58.69,59.46L96.34,162.9a16.29,16.29,0,0,0-22.75,3.52,16,16,0,0,0,3.54,22.51l15.55,11.32a383,383,0,0,0-38.27,74l-18.64-6.41a16.27,16.27,0,0,0-20.67,10,15.85,15.85,0,0,0,.74,12.27,16.11,16.11,0,0,0,9.32,8.23l18.9,6.5a385.28,385.28,0,0,0-10.53,44.72c-2,12.08-1.49,23.88.27,35.35l-22.17,6.57a16.09,16.09,0,0,0-11,20,16.7,16.7,0,0,0,15.86,11.53,15.38,15.38,0,0,0,4.34-.62l22.05-6.51a111.81,111.81,0,0,0,55.65,54l-5.74,21.92a15.87,15.87,0,0,0,1.74,12.2,16.11,16.11,0,0,0,9.93,7.47,15.8,15.8,0,0,0,3.85.48,16.69,16.69,0,0,0,16-12.06l5.52-21.12A111.79,111.79,0,0,0,144.14,480,111.17,111.17,0,0,0,207,460.08l14.08,14.45a16.73,16.73,0,0,0,23,.32,16,16,0,0,0,.32-22.81L231,438.25a111.19,111.19,0,0,0,23.45-51.86A160.61,160.61,0,0,1,261,360.75l14.63,6.85a15.6,15.6,0,0,0,6.61,1.44,16.73,16.73,0,0,0,15-9.2,15.91,15.91,0,0,0,.58-12.28,16.07,16.07,0,0,0-8.39-9.17l-14.64-6.86a160.37,160.37,0,0,1,60.31-58.95l6.61,14.95A16.65,16.65,0,0,0,357,297.06a15.83,15.83,0,0,0,14.91-10.26,16,16,0,0,0-.29-12.31l-6.53-14.73a159.91,159.91,0,0,1,21.36-5.32,111,111,0,0,0,55-26.35l14.93,13.46a16.15,16.15,0,0,0,10.87,4,16.34,16.34,0,0,0,12.11-5.15,16.06,16.06,0,0,0-1.13-22.78l-15.8-14.26a111.11,111.11,0,0,0,16.14-76.54l21.82-6.45a16.12,16.12,0,0,0,9.68-7.84A15.92,15.92,0,0,0,511.32,100.33ZM381.15,222.87C301,236.23,236.27,301,222.91,381.13c-8.21,49.3-61.52,81.75-111.31,59.57a79.9,79.9,0,0,1-39.77-38.52C39.12,333.36,132.8,102,354.91,65c10.49-1.77,62.73-3.69,84.69,44.36C473.43,183.41,403.38,219.17,381.15,222.87ZM160,272a48,48,0,1,0,48,48A48,48,0,0,0,160,272Zm0,64a16,16,0,1,1,16-16A16,16,0,0,1,160,336Zm80-152a24,24,0,1,0,24,24A24,24,0,0,0,240,184Z"]
  },
      ne = {
    prefix: "fal",
    iconName: "badge",
    icon: [512, 512, [], "f335", "M256 512c-35.5 0-68.1-19.4-85.5-49.6-32.1 8.7-69 1.1-95.5-25.4-25.1-25.1-34.5-61.9-25.4-95.5C19.4 324.2 0 291.5 0 256s19.4-68.2 49.6-85.5c-9.1-33.6.3-70.4 25.4-95.5 25.1-25.1 61.9-34.5 95.5-25.4C187.8 19.4 220.5 0 256 0s68.2 19.4 85.5 49.6c33.6-9.1 70.4.3 95.5 25.4 25.1 25.1 34.5 61.9 25.4 95.5 30.2 17.3 49.6 50 49.6 85.5s-19.4 68.2-49.6 85.5c9.1 33.6-.3 70.4-25.4 95.5-26.1 26.1-62.8 34.3-95.5 25.4-17.4 30.2-50 49.6-85.5 49.6zm-68.3-91.1c3.6 9.6 16.2 59.1 68.3 59.1 51 0 63.7-47 68.3-59.1 32.6 14.8 61.2 22.4 90.1-6.5 36-36 11.8-78.3 6.5-90.1 9.6-3.6 59.1-16.2 59.1-68.3 0-51-47-63.7-59.1-68.3 4.4-9.6 30.3-53.4-6.5-90.1-36-36-78.3-11.8-90.1-6.5C320.7 81.5 308.1 32 256 32c-51 0-63.7 47-68.3 59.1-9.3-4.2-53.3-30.4-90.1 6.5-36 36-11.8 78.3-6.5 90.1C81.5 191.3 32 203.9 32 256c0 51 47 63.7 59.1 68.3-4.4 9.6-30.3 53.4 6.5 90.1 28.8 28.7 57.5 21.3 90.1 6.5z"]
  },
      te = {
    prefix: "fal",
    iconName: "badge-check",
    icon: [512, 512, [], "f336", "M345.34 182.46a7.98 7.98 0 0 0-5.66-2.34c-2.05 0-4.1.78-5.66 2.34L226.54 289.94l-48.57-48.57a7.98 7.98 0 0 0-5.66-2.34c-2.05 0-4.1.78-5.66 2.34l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l65.54 65.54c1.56 1.56 3.61 2.34 5.66 2.34s4.09-.78 5.65-2.34l124.45-124.45c3.12-3.12 3.12-8.19 0-11.31l-11.3-11.31zM512 256c0-35.5-19.4-68.2-49.6-85.5 9.1-33.6-.3-70.4-25.4-95.5s-61.9-34.5-95.5-25.4C324.2 19.4 291.5 0 256 0s-68.2 19.4-85.5 49.6c-33.6-9.1-70.4.3-95.5 25.4s-34.5 61.9-25.4 95.5C19.4 187.8 0 220.5 0 256s19.4 68.2 49.6 85.5c-9.1 33.6.3 70.4 25.4 95.5 26.5 26.5 63.4 34.1 95.5 25.4 17.4 30.2 50 49.6 85.5 49.6s68.1-19.4 85.5-49.6c32.7 8.9 69.4.7 95.5-25.4 25.1-25.1 34.5-61.9 25.4-95.5 30.2-17.3 49.6-50 49.6-85.5zm-91.1 68.3c5.3 11.8 29.5 54.1-6.5 90.1-28.9 28.9-57.5 21.3-90.1 6.5C319.7 433 307 480 256 480c-52.1 0-64.7-49.5-68.3-59.1-32.6 14.8-61.3 22.2-90.1-6.5-36.8-36.7-10.9-80.5-6.5-90.1C79 319.7 32 307 32 256c0-52.1 49.5-64.7 59.1-68.3-5.3-11.8-29.5-54.1 6.5-90.1 36.8-36.9 80.8-10.7 90.1-6.5C192.3 79 205 32 256 32c52.1 0 64.7 49.5 68.3 59.1 11.8-5.3 54.1-29.5 90.1 6.5 36.8 36.7 10.9 80.5 6.5 90.1C433 192.3 480 205 480 256c0 52.1-49.5 64.7-59.1 68.3z"]
  },
      re = {
    prefix: "fal",
    iconName: "badge-dollar",
    icon: [512, 512, [], "f645", "M289.94 249.05l-59.06-16.86c-8.75-2.52-14.88-10.61-14.88-19.7 0-11.3 9.19-20.48 20.47-20.48h36.91c8.24 0 16.08 2.56 22.63 7.32 2.99 2.17 7.22 1.46 9.84-1.16l11.42-11.42c3.5-3.5 2.94-9.22-.99-12.23-12.26-9.41-27.18-14.51-42.9-14.51H272v-24c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v24h-3.53c-30.59 0-55.13 26.3-52.24 57.48 2.06 22.16 19.06 40.12 40.45 46.22l56.44 16.11c8.75 2.52 14.88 10.61 14.88 19.7 0 11.3-9.19 20.48-20.47 20.48h-36.91c-8.24 0-16.08-2.56-22.63-7.32-2.99-2.17-7.22-1.46-9.84 1.16l-11.42 11.42c-3.5 3.5-2.94 9.21.99 12.23 12.26 9.41 27.18 14.51 42.9 14.51H240v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24h1.36c22.81 0 44.33-13.59 51.72-35.17 10.15-29.65-7.28-59.8-35.14-67.78zM512 256c0-35.5-19.4-68.2-49.6-85.5 9.1-33.6-.3-70.4-25.4-95.5s-61.9-34.5-95.5-25.4C324.2 19.4 291.5 0 256 0s-68.2 19.4-85.5 49.6c-33.6-9.1-70.4.3-95.5 25.4s-34.5 61.9-25.4 95.5C19.4 187.8 0 220.5 0 256s19.4 68.2 49.6 85.5c-9.1 33.6.3 70.4 25.4 95.5 26.5 26.5 63.4 34.1 95.5 25.4 17.4 30.2 50 49.6 85.5 49.6s68.1-19.4 85.5-49.6c32.7 8.9 69.4.7 95.5-25.4 25.1-25.1 34.5-61.9 25.4-95.5 30.2-17.3 49.6-50 49.6-85.5zm-91.1 68.3c5.3 11.8 29.5 54.1-6.5 90.1-28.9 28.9-57.5 21.3-90.1 6.5C319.7 433 307 480 256 480c-52.1 0-64.7-49.5-68.3-59.1-32.6 14.8-61.3 22.2-90.1-6.5-36.8-36.7-10.9-80.5-6.5-90.1C79 319.7 32 307 32 256c0-52.1 49.5-64.7 59.1-68.3-5.3-11.8-29.5-54.1 6.5-90.1 36.8-36.9 80.8-10.7 90.1-6.5C192.3 79 205 32 256 32c52.1 0 64.7 49.5 68.3 59.1 11.8-5.3 54.1-29.5 90.1 6.5 36.8 36.7 10.9 80.5 6.5 90.1C433 192.3 480 205 480 256c0 52.1-49.5 64.7-59.1 68.3z"]
  },
      ie = {
    prefix: "fal",
    iconName: "badge-percent",
    icon: [512, 512, [], "f646", "M349.66 173.65l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-164.7 164.69c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l164.69-164.69c3.13-3.12 3.13-8.18.01-11.31zM240 192c0-26.47-21.53-48-48-48s-48 21.53-48 48 21.53 48 48 48 48-21.53 48-48zm-64 0c0-8.83 7.19-16 16-16s16 7.17 16 16-7.19 16-16 16-16-7.17-16-16zm144 80c-26.47 0-48 21.53-48 48s21.53 48 48 48 48-21.53 48-48-21.53-48-48-48zm0 64c-8.81 0-16-7.17-16-16s7.19-16 16-16 16 7.17 16 16-7.19 16-16 16zm192-80c0-35.5-19.4-68.2-49.6-85.5 9.1-33.6-.3-70.4-25.4-95.5s-61.9-34.5-95.5-25.4C324.2 19.4 291.5 0 256 0s-68.2 19.4-85.5 49.6c-33.6-9.1-70.4.3-95.5 25.4s-34.5 61.9-25.4 95.5C19.4 187.8 0 220.5 0 256s19.4 68.2 49.6 85.5c-9.1 33.6.3 70.4 25.4 95.5 26.5 26.5 63.4 34.1 95.5 25.4 17.4 30.2 50 49.6 85.5 49.6s68.1-19.4 85.5-49.6c32.7 8.9 69.4.7 95.5-25.4 25.1-25.1 34.5-61.9 25.4-95.5 30.2-17.3 49.6-50 49.6-85.5zm-91.1 68.3c5.3 11.8 29.5 54.1-6.5 90.1-28.9 28.9-57.5 21.3-90.1 6.5C319.7 433 307 480 256 480c-52.1 0-64.7-49.5-68.3-59.1-32.6 14.8-61.3 22.2-90.1-6.5-36.8-36.7-10.9-80.5-6.5-90.1C79 319.7 32 307 32 256c0-52.1 49.5-64.7 59.1-68.3-5.3-11.8-29.5-54.1 6.5-90.1 36.8-36.9 80.8-10.7 90.1-6.5C192.3 79 205 32 256 32c52.1 0 64.7 49.5 68.3 59.1 11.8-5.3 54.1-29.5 90.1 6.5 36.8 36.7 10.9 80.5 6.5 90.1C433 192.3 480 205 480 256c0 52.1-49.5 64.7-59.1 68.3z"]
  },
      oe = {
    prefix: "fal",
    iconName: "badge-sheriff",
    icon: [512, 512, [], "f8a2", "M440 312a48.35 48.35 0 0 0-7.75.78l-33.81-56.84 33.78-56.73A47.94 47.94 0 1 0 395 136h-67.94l-34.24-57.58A47.53 47.53 0 0 0 304 48a48 48 0 0 0-96 0 47.53 47.53 0 0 0 11.28 30.54L185.06 136h-68a47.92 47.92 0 1 0-45 64 48.35 48.35 0 0 0 7.75-.78l33.81 56.84-33.84 56.73A47.6 47.6 0 0 0 72 312a48 48 0 1 0 45.05 64h67.89l34.24 57.58A47.53 47.53 0 0 0 208 464a48 48 0 0 0 96 0 47.53 47.53 0 0 0-11.28-30.54L326.94 376h68A47.92 47.92 0 1 0 440 312zm0-176a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM72 168a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm0 208a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm184 104a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm139-136h-77.16a16 16 0 0 0-13.75 7.81l-38.78 65.13a47 47 0 0 0-18.79 0l-38.74-65.13A15.94 15.94 0 0 0 194 344h-77a47.7 47.7 0 0 0-9.27-15.68l38.16-64.07a16 16 0 0 0 0-16.37l-38.13-64.18a47.77 47.77 0 0 0 9.29-15.7h77.11a16 16 0 0 0 13.75-7.81l38.78-65.13a47 47 0 0 0 18.8 0l38.73 65.13A15.94 15.94 0 0 0 318 168h77a47.63 47.63 0 0 0 9.27 15.68l-38.16 64.07a16 16 0 0 0 0 16.37l38.18 64.18A47.77 47.77 0 0 0 395 344zm45 32a16 16 0 1 1 16-16 16 16 0 0 1-16 16zM256 184a72 72 0 1 0 72 72 72.09 72.09 0 0 0-72-72zm0 112a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"]
  },
      le = {
    prefix: "fal",
    iconName: "badger-honey",
    icon: [640, 512, [], "f6b4", "M622.25 142.55l-2.73-1.55c-22.49-12.74-43.96-27.08-65.15-41.88-55.61-38.87-87.95-35.01-88.92-35.01-19.05 0-38.09 5.21-55.47 15.21-17.09 9.83-35.92 16.78-55.03 16.78H128C57.31 96.1 0 153.39 0 224.06v15.99c0 8.84 7.16 16 16 16h20.03c2.62 11.24 9.82 46.58 54.09 79.65l-23.78 52.46a31.97 31.97 0 0 0-.12 23.77l25.3 57.94A16.002 16.002 0 0 0 106.41 480h76.74c11.63 0 19.38-12.03 14.56-22.62l-22.45-49.36 32.96-55.99h73.69l23.03 115.11c1.5 7.48 8.06 12.86 15.69 12.86h79.36c10.1 0 17.67-9.24 15.69-19.13l-26.99-134.92c45.32-30.5 101.32-61.16 152.42-75.66L560 288.05l22.75-45.49c53.39-4.45 57.25-63.93 57.25-67.2 0-13.94-6.88-26.66-17.75-32.81zM128 128.09h226.96c22.83 0 46.71-7.08 70.99-21.05 12.44-7.16 26.11-10.94 39.51-10.94 3.93 0 26.41-1.64 70.59 29.24 4.79 3.35 10.05 6.98 15.59 10.75H460c-30.88 0-60.31 9.67-91.47 20.93l-100.78 45.82c-9.66 3.47-19.84 5.23-30.25 5.23H192c-45.14 0-78.89-41.04-79.83-78.38 5.18-.87 10.41-1.6 15.83-1.6zm225.13 183.22l27.35 136.7h-46.73l-25.6-127.97H189.93l-50.68 86.08 19.05 41.89h-40.99L96 400.2l33.07-75.35-19.8-14.78C89.1 295 74.36 279.51 67.2 248.79l-5.77-24.72H32c0-35.91 20.07-66.91 49.36-83.36 6.77 54.16 55.27 99.36 110.64 99.36h45.5c14.12 0 27.94-2.39 42.28-7.61l100.78-45.82c27.19-9.78 53.72-18.56 79.44-18.56h20.41c-2.6 3.38-4.41 7.41-4.41 12 0 11.04 8.96 19.99 20 19.99 11.05 0 20-8.95 20-19.99 0-4.59-1.81-8.62-4.41-12h90.88c3.57 2.03 5.53 2.55 5.54 6.95-5.27 73.78-21.42-20.81-254.88 136.28z"]
  },
      fe = {
    prefix: "fal",
    iconName: "bags-shopping",
    icon: [576, 512, [], "f847", "M544 256H224a32 32 0 0 0-32 32v192a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V288a32 32 0 0 0-32-32zm0 224H224V288h320zm-172.63-32.81A96.12 96.12 0 0 0 480 352v-24a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24a64.07 64.07 0 0 1-70.38 63.69c-33.25-3.23-57.62-33.12-57.62-66.53V328a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v20.66c0 48.79 35 92.34 83.37 98.53zM32 192h384v32h32v-32a32 32 0 0 0-32-32h-96V96a96 96 0 0 0-192 0v64H32a32 32 0 0 0-32 32v256a32 32 0 0 0 32 32h128v-32H32zm128-96a64 64 0 0 1 128 0v64H160z"]
  },
      se = {
    prefix: "fal",
    iconName: "bahai",
    icon: [512, 512, [], "f666", "M496.25 202.52l-110-15.44 41.82-104.34c5.26-13.11-4.98-25.55-16.89-25.55-3.2 0-6.52.9-9.69 2.92L307.45 120l-34.1-107.18C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-3.18-2.02-6.5-2.92-9.69-2.92-11.91 0-22.15 12.43-16.89 25.55l41.82 104.34-110 15.44c-17.53 2.46-21.67 26.27-6.03 34.67l98.16 52.66-74.49 83.53c-10.92 12.25-1.72 30.93 13.28 30.93 1.32 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.16 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.55 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c1.39.3 2.75.45 4.07.45 15.01 0 24.2-18.69 13.28-30.93l-74.48-83.54 98.16-52.66c15.65-8.4 11.51-32.21-6.03-34.67zm-106.88 59.05l-35.85 19.24 27.2 30.51 46.79 52.48-68.21-14.86-39.65-8.64 1.5 41.11 2.58 70.71-42.83-55.85L256 363.8l-24.9 32.47-42.83 55.85 2.58-70.71 1.5-41.11-39.65 8.64-68.21 14.86 46.79-52.48 27.2-30.51-35.85-19.24-61.67-33.09 69.11-9.7 40.18-5.64-15.27-38.11-26.27-65.55 59.08 37.62 34.35 21.87 12.45-39.15L256 62.49l21.42 67.34 12.45 39.15 34.35-21.87 59.08-37.62-26.27 65.55-15.27 38.11 40.18 5.64 69.11 9.7-61.68 33.08z"]
  },
      ue = {
    prefix: "fal",
    iconName: "balance-scale",
    icon: [640, 512, [], "f24e", "M634.4 279.09L525.35 103.12C522.18 98.38 517.09 96 512 96s-10.18 2.38-13.35 7.12L389.6 279.09c-3.87 5.78-6.09 12.72-5.51 19.64C389.56 364.4 444.74 416 512 416s122.44-51.6 127.91-117.27c.58-6.92-1.64-13.86-5.51-19.64zM512 384c-41.58 0-77.55-27.13-90.78-64h181.2C589 357.23 553.28 384 512 384zm-90.27-96l90.31-145.76L602.98 288H421.73zM536 480H336V125.74c27.56-7.14 48-31.95 48-61.74h152c4.42 0 8-3.58 8-8V40c0-4.42-3.58-8-8-8H374.89c-.15-.26-4.37-11.11-19.11-21.07C345.57 4.03 333.25 0 320 0s-25.57 4.03-35.78 10.93c-14.74 9.96-18.96 20.81-19.11 21.07H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h152c0 29.79 20.44 54.6 48 61.74V480H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h432c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM288 64c0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32-32-14.33-32-32zm-32.09 234.73c.58-6.92-1.64-13.86-5.51-19.64L141.35 103.12C138.18 98.38 133.09 96 128 96s-10.18 2.38-13.35 7.12L5.6 279.09c-3.87 5.78-6.09 12.72-5.51 19.64C5.56 364.4 60.74 416 128 416s122.44-51.6 127.91-117.27zM128.04 142.24L218.98 288H37.73l90.31-145.76zM37.22 320h181.2C205 357.23 169.28 384 128 384c-41.58 0-77.55-27.13-90.78-64z"]
  },
      he = {
    prefix: "fal",
    iconName: "balance-scale-left",
    icon: [640, 512, [], "f515", "M634.4 247.09L525.35 71.12C522.18 66.38 517.09 64 512 64s-10.18 2.38-13.35 7.12L389.6 247.09c-3.87 5.78-6.09 12.72-5.51 19.64C389.56 332.4 444.74 384 512 384s122.44-51.6 127.91-117.27c.58-6.92-1.64-13.86-5.51-19.64zM512 352c-41.58 0-77.55-27.13-90.78-64h181.2C589 325.23 553.28 352 512 352zm-90.27-96l90.31-145.76L602.98 256H421.73zM536 480H336V125.74c22.29-5.77 39.71-23.13 45.62-45.36l148.29-49.62c4.19-1.4 6.45-5.94 5.05-10.12l-5.08-15.17c-1.4-4.19-5.94-6.45-10.12-5.05L381.34 46.73C373.77 19.83 349.32 0 320 0c-35.35 0-64 28.65-64 64 0 8.21 1.67 15.98 4.54 23.15l-150.45 50.34c-4.19 1.4-6.45 5.94-5.05 10.12l5.08 15.17c1.4 4.19 5.94 6.45 10.12 5.05l160.45-53.68c6.82 5.36 14.67 9.34 23.32 11.58V504c0 4.42 3.58 8 8 8h224c4.42 0 8-3.58 8-8v-16c-.01-4.42-3.59-8-8.01-8zM288 64c0-17.64 14.36-32 32-32s32 14.36 32 32-14.36 32-32 32-32-14.36-32-32zM141.35 199.12c-3.17-4.75-8.26-7.12-13.35-7.12s-10.18 2.38-13.35 7.12L5.6 375.09c-3.87 5.78-6.09 12.72-5.51 19.64C5.56 460.4 60.74 512 128 512s122.44-51.6 127.91-117.27c.58-6.92-1.64-13.86-5.51-19.64L141.35 199.12zM128 480c-41.58 0-77.55-27.13-90.78-64h181.2C205 453.23 169.28 480 128 480zm-90.27-96l90.31-145.76L218.98 384H37.73z"]
  },
      me = {
    prefix: "fal",
    iconName: "balance-scale-right",
    icon: [640, 512, [], "f516", "M634.4 375.09L525.35 199.12c-3.17-4.75-8.26-7.12-13.35-7.12s-10.18 2.38-13.35 7.12L389.6 375.09c-3.87 5.78-6.09 12.72-5.51 19.64C389.56 460.4 444.74 512 512 512c67.27 0 122.45-51.6 127.91-117.27.57-6.92-1.64-13.86-5.51-19.64zM511.96 238.24L602.27 384H421.02l90.94-145.76zM512 480c-41.28 0-77-26.77-90.42-64h181.2c-13.23 36.87-49.2 64-90.78 64zm17.89-317.21l5.08-15.17c1.4-4.19-.86-8.72-5.05-10.12L379.46 87.15C382.33 79.98 384 72.21 384 64c0-35.35-28.65-64-64-64-29.32 0-53.77 19.83-61.34 46.73L120.24.42c-4.19-1.4-8.72.86-10.12 5.05l-5.08 15.17c-1.4 4.19.86 8.72 5.05 10.12l148.29 49.62c5.91 22.23 23.33 39.58 45.62 45.36V480H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h224c4.42 0 8-3.58 8-8V125.74c8.64-2.24 16.5-6.22 23.32-11.58l160.45 53.68c4.18 1.4 8.71-.86 10.12-5.05zM320 96c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm-64.09 170.73c.58-6.92-1.64-13.86-5.51-19.64L141.35 71.12C138.18 66.38 133.09 64 128 64s-10.18 2.38-13.35 7.12L5.6 247.09c-3.87 5.78-6.09 12.72-5.51 19.64C5.56 332.4 60.74 384 128 384s122.44-51.6 127.91-117.27zM127.96 110.24L218.27 256H37.02l90.94-145.76zM37.58 288h181.2c-13.23 36.87-49.2 64-90.78 64-41.28 0-77-26.77-90.42-64z"]
  },
      ve = {
    prefix: "fal",
    iconName: "ball-pile",
    icon: [576, 512, [], "f77e", "M480 320c-10.4 0-20.3 2.1-29.7 5.2 18.2-17.5 29.7-41.9 29.7-69.2 0-53-43-96-96-96-10.4 0-20.3 2.1-29.7 5.2 18.3-17.5 29.7-42 29.7-69.2 0-53-43-96-96-96s-96 43-96 96c0 27.2 11.4 51.7 29.7 69.2-9.4-3.1-19.2-5.2-29.7-5.2-53 0-96 43-96 96 0 27.2 11.4 51.7 29.7 69.2-9.4-3.1-19.2-5.2-29.7-5.2-53 0-96 43-96 96s43 96 96 96 96-43 96-96c0-27.2-11.4-51.7-29.7-69.2 9.4 3.1 19.2 5.2 29.7 5.2s20.3-2.1 29.7-5.2c-18.3 17.5-29.7 42-29.7 69.2 0 53 43 96 96 96s96-43 96-96c0-27.2-11.4-51.7-29.7-69.2 9.4 3.1 19.2 5.2 29.7 5.2s20.3-2.1 29.7-5.2c-18.3 17.5-29.7 42-29.7 69.2 0 53 43 96 96 96s96-43 96-96-43-96-96-96zM288 32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm29.7 293.2c-9.4-3.1-19.3-5.2-29.7-5.2s-20.3 2.1-29.7 5.2c18.2-17.5 29.7-41.9 29.7-69.2s-11.4-51.7-29.7-69.2c9.4 3.1 19.2 5.2 29.7 5.2s20.3-2.1 29.7-5.2c-18.3 17.5-29.7 42-29.7 69.2s11.4 51.7 29.7 69.2zM96 480c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm96-160c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm96 160c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm96-160c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm96 160c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"]
  },
      de = {
    prefix: "fal",
    iconName: "ballot",
    icon: [448, 512, [], "f732", "M144 80h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32zm0 64h-32v-32h32v32zM416 0H32C14.3 0 0 14.4 0 32v448c0 17.6 14.3 32 32 32h384c17.7 0 32-14.4 32-32V32c0-17.6-14.3-32-32-32zm0 480H32V32h384v448zm-72-240H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-200 96h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32zm0 64h-32v-32h32v32zm200-32H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0-256H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-200 96h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32zm0 64h-32v-32h32v32z"]
  },
      Me = {
    prefix: "fal",
    iconName: "ballot-check",
    icon: [448, 512, [], "f733", "M112 432h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32zm0-64h32v32h-32v-32zm0-192h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32zm0-64h32v32h-32v-32zM416 0H32C14.3 0 0 14.4 0 32v448c0 17.6 14.3 32 32 32h384c17.7 0 32-14.4 32-32V32c0-17.6-14.3-32-32-32zm0 480H32V32h384v448zM216 144h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0 128h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0 128h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-97.4-113.6c2.1 2.1 5.5 2.1 7.6 0l64.2-63.6c2.1-2.1 2.1-5.5 0-7.6l-12.6-12.7c-2.1-2.1-5.5-2.1-7.6 0l-47.6 47.2-20.6-20.9c-2.1-2.1-5.5-2.1-7.6 0l-12.7 12.6c-2.1 2.1-2.1 5.5 0 7.6l36.9 37.4z"]
  },
      pe = {
    prefix: "fal",
    iconName: "ban",
    icon: [512, 512, [], "f05e", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zM103.265 408.735c-80.622-80.622-84.149-208.957-10.9-293.743l304.644 304.643c-84.804 73.264-213.138 69.706-293.744-10.9zm316.37-11.727L114.992 92.365c84.804-73.263 213.137-69.705 293.743 10.9 80.622 80.621 84.149 208.957 10.9 293.743z"]
  },
      ze = {
    prefix: "fal",
    iconName: "band-aid",
    icon: [640, 512, [], "f462", "M560 96H80c-44.1 0-80 35.9-80 80v160c0 44.1 35.9 80 80 80h480c44.1 0 80-35.9 80-80V176c0-44.1-35.9-80-80-80zM160 384H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h80v256zm288 0H192V128h256v256zm160-48c0 26.5-21.5 48-48 48h-80V128h80c26.5 0 48 21.5 48 48v160zM272 228c11 0 20-9 20-20s-9-20-20-20-20 9-20 20 9 20 20 20zm96 0c11 0 20-9 20-20s-9-20-20-20-20 9-20 20 9 20 20 20zm-96 96c11 0 20-9 20-20s-9-20-20-20-20 9-20 20 9 20 20 20zm96 0c11 0 20-9 20-20s-9-20-20-20-20 9-20 20 9 20 20 20z"]
  },
      Ce = {
    prefix: "fal",
    iconName: "banjo",
    icon: [512, 512, [], "f8a3", "M121 334.46a8 8 0 0 0-11.32 0l-11.34 11.32a8 8 0 0 0 0 11.31l56.57 56.57a8 8 0 0 0 11.31 0l11.32-11.32a8 8 0 0 0 0-11.31zm380.81-292l-32.3-32.24a34.91 34.91 0 0 0-49.36 0l-50.52 50.52a38.46 38.46 0 0 0-9.29 15.05L339 139.85c-.39.3-1 .18-1.31.54l-94.93 94.93A142.12 142.12 0 0 0 176 209.61V208a16 16 0 0 0-32 0v1.61A142.42 142.42 0 0 0 70.57 240l-1.07-1.07a16 16 0 0 0-22.63 22.57l1.13 1.07A142.42 142.42 0 0 0 17.61 336H16a16 16 0 0 0 0 32h1.61A142.42 142.42 0 0 0 48 441.43l-1.08 1.07a16 16 0 1 0 22.58 22.62l1.07-1.07A142.42 142.42 0 0 0 144 494.39V496a16 16 0 0 0 32 0v-1.61a142.42 142.42 0 0 0 73.43-30.34l1.07 1.07a16 16 0 0 0 22.62-22.62l-1.07-1.07A142.42 142.42 0 0 0 302.39 368H304a16 16 0 0 0 0-32h-1.61a142.12 142.12 0 0 0-25.71-66.74l94.93-94.93c.36-.37.23-.92.54-1.31l64.06-21.36a38.46 38.46 0 0 0 15.05-9.29l50.52-50.52a34.92 34.92 0 0 0 0-49.37zM160 464a112 112 0 1 1 112-112 112.12 112.12 0 0 1-112 112zM479.15 69.22l-50.52 50.52a6.54 6.54 0 0 1-2.53 1.57L373 139l17.7-53.1a6.4 6.4 0 0 1 1.56-2.53l50.52-50.52a2.91 2.91 0 0 1 4.11 0l32.26 32.26a2.92 2.92 0 0 1 0 4.11z"]
  },
      Le = {
    prefix: "fal",
    iconName: "barcode",
    icon: [512, 512, [], "f02a", "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"]
  },
      Ae = {
    prefix: "fal",
    iconName: "barcode-alt",
    icon: [640, 512, [], "f463", "M280 96h-16c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-64 0h-16c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zM592 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm16 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h544c8.8 0 16 7.2 16 16v416zM152 96h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm384 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-128 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8z"]
  },
      Ne = {
    prefix: "fal",
    iconName: "barcode-read",
    icon: [640, 512, [], "f464", "M152 0H8C3.6 0 0 3.6 0 8v152c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V32h120c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zm0 480H32V352c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8v152c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM632 0H488c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h120v128c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zm0 344h-16c-4.4 0-8 3.6-8 8v128H488c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V352c0-4.4-3.6-8-8-8zM152 96h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm336 320h48c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8zM408 96h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-192 0h-16c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm64 0h-16c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8z"]
  },
      ge = {
    prefix: "fal",
    iconName: "barcode-scan",
    icon: [640, 512, [], "f465", "M160 8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v152h96V8zm128 0c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152h64V8zm96 0c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v152h32V8zm96 0c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152h64V8zm96 0c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152h64V8zM416 504c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V352h-64v152zm-64 0c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V352h-32v152zm-288 0c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V352H64v152zm160 0c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V352h-64v152zm288 0c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V352h-64v152zm120-264H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h624c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      He = {
    prefix: "fal",
    iconName: "bars",
    icon: [448, 512, [], "f0c9", "M442 114H6a6 6 0 0 1-6-6V84a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6z"]
  },
      Ve = {
    prefix: "fal",
    iconName: "baseball",
    icon: [640, 512, [], "f432", "M627.2 60.1l-23.6-32.5C581-3.5 538.9-8.2 510 12.8L307.7 159.6c-45.6 33.1-87.3 71.3-124.3 113.8-29 33.3-72.5 78.6-130.3 120.6l-21.6 15.7c-.2-.3-11.3-17.4-25.5-6.2-6.9 5.5-8 15.6-2.5 22.5l64 80c5.2 6.5 15.2 8.3 22.5 2.5.5-.4 12.9-9.5.1-25.5l18.2-13.2c66-47.9 122.3-72.6 155.1-86.5 51.9-22 101.2-49.9 146.8-83l202.3-146.8c29.8-21.7 36.4-63.5 14.7-93.4zM70.1 458l-18.6-23.2c28.9-20.9 71.8-50.7 125-106.3l32.3 44.4C140.6 405.7 99.2 436.8 70.1 458zm523.5-330.4c-247 179.2-243.1 182.5-359.9 233.8L195 308.3c84.9-95.1 86.5-90.2 333.8-269.6 14.8-10.7 36.9-8.7 48.9 7.7l23.6 32.5c11.4 15.6 7.9 37.4-7.7 48.7zM496 352c-44.1 0-80 35.9-80 80s35.9 80 80 80 80-35.9 80-80-35.9-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      xe = {
    prefix: "fal",
    iconName: "baseball-ball",
    icon: [496, 512, [], "f433", "M248 8C111.2 8 0 119.2 0 256s111.2 248 248 248 248-111.2 248-248S384.8 8 248 8zM103.5 416.1c16.7-17.4 30.6-37.2 41.3-59.1L118 344c-9.1 18.8-21.8 35.1-36 50-85.6-102.8-45.3-221.5 0-276 14.2 14.9 26.8 31.2 36 49.8l26.8-13.1c-10.6-21.8-24.5-41.5-41.2-58.9 79.1-71.4 203.1-77.6 289-.1-16.7 17.4-30.6 37.1-41.2 59l26.8 13c9.1-18.7 21.7-35 36-50 78.1 93.7 54.6 210.4.1 275.9-14.3-14.9-26.9-31.2-36-49.9l-26.8 13.1c10.7 21.9 24.5 41.6 41.3 58.9-90 81.5-214.3 68.2-289.3.4zm53.2-88.6l-28.3-9.2c12.2-37.5 14-81.5-.1-124.7l28.3-9.2c16.3 50 14 100.4.1 143.1zm211-9.2l-28.3 9.2c-16.3-50-14-100.5-.1-143.1l28.3 9.2c-12.2 37.6-13.9 81.6.1 124.7z"]
  },
      we = {
    prefix: "fal",
    iconName: "basketball-ball",
    icon: [496, 512, [], "f434", "M423.4 80.6c-96.7-96.7-254.2-96.7-350.9 0s-96.7 254.2 0 350.9c96.8 96.8 254.2 96.7 350.9 0 96.8-96.8 96.8-254.2 0-350.9zM241.2 471.7c-48-1.5-95.6-18.9-134.1-52.1l140.9-141 56.8 56.8c-33.9 38.3-56 85.7-63.6 136.3zm86.7-113.2l61 61c-33.3 28.7-73.2 45.6-114.4 50.6 7.4-41.3 25.8-79.8 53.4-111.6zm22.6-22.6c31.8-27.6 70.3-46 111.6-53.3-5.1 41.2-21.9 81.1-50.6 114.4l-61-61.1zm113.2-86.7c-50.6 7.6-98 29.7-136.3 63.5L270.6 256l140.9-140.9c33.3 38.5 50.7 86.1 52.2 134.1zm-315-69.9c-32.6 28.4-72.6 47.2-115.4 54.1 4.4-42.6 21.6-84 51.2-118.3l64.2 64.2zm-41.6-86.9c34.3-29.6 75.7-46.7 118.3-51.2-6.9 42.8-25.7 82.8-54.1 115.4l-64.2-64.2zm150.6-51.9c47 2.1 93.4 19.4 131.2 52L248 233.4l-54.1-54.1c34.5-38.9 56.7-87.2 63.8-138.8zM32.5 265.7c51.6-7.2 99.9-29.4 138.8-63.8l54.1 54.1-141 140.9c-32.5-37.8-49.8-84.1-51.9-131.2z"]
  },
      ye = {
    prefix: "fal",
    iconName: "basketball-hoop",
    icon: [640, 512, [], "f435", "M640 339.7c0 19.5-10.4 36.9-28.5 44.4l-108.3 44.5 2.5-35.7 93.6-38.4c6-2.5 9.9-8.3 9.9-14.8V216C527.1-8 115.7-8.9 33.2 216v123.7c0 6.5 3.9 12.3 9.9 14.8l93.6 38.4 2.5 35.7L31 384.1c-18.1-7.5-31-24.9-31-44.4l.8-131.4C1.4 206.3 69.3 16 321.2 16s317.3 190.3 317.9 192.3c1.2 7.1.9-9.1.9 131.4zM462.4 512L387 440.4 321.2 512l-65.8-71.6L180 512l-18.2-224h-24.6c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-24.6l-18.2 224zM207.9 352.4l46.7 43.6 44-44-42.1-42.1-48.6 42.5zm113.3-23l41.4-41.4h-82.8l41.4 41.4zm22.6 22.6l44 44 46.7-43.6-48.5-42.5-42.2 42.1zm104.7-64h-39l36.5 31.9 2.5-31.9zm-254.6 0l2.6 31.9L233 288h-39.1zM232 418.6l-29.9-27.9 4.3 53.5 25.6-25.6zm132.4-.8l-43.2-43.2-43.2 43.2 43.2 40.3 43.2-40.3zm71.6 26.4l4.3-53.5-29.9 27.9 25.6 25.6zM465.2 224v-89.9h-288V224h32v-57.9h224V224h32z"]
  },
      be = {
    prefix: "fal",
    iconName: "bat",
    icon: [640, 512, [], "f6b5", "M638.61 287.25L568.3 129.7c-5.48-12.27-17.85-19.4-30.67-19.4-5.81 0-11.7 1.46-17.1 4.57l-104.9 60.44L384 64l-50.11 48h-27.77L256 64l-31.62 111.3-104.9-60.44c-5.4-3.11-11.3-4.57-17.1-4.57-12.83 0-25.2 7.13-30.67 19.4L1.39 287.25c-5.66 12.69 6.94 25.85 20.58 21.48l16.48-5.27a69.132 69.132 0 0 1 21.07-3.29c21.83 0 42.85 10.33 55.46 28.51L153.39 384l12.31-11.82c13.11-12.59 30.14-18.75 47.09-18.75 20.13 0 40.15 8.69 53.36 25.6L320 448l53.86-68.97c13.21-16.91 33.23-25.6 53.36-25.6 16.95 0 33.98 6.16 47.09 18.75l12.3 11.82 38.41-55.33c12.61-18.17 33.63-28.51 55.46-28.51 7.02 0 14.13 1.07 21.07 3.29l16.48 5.27c13.64 4.38 26.24-8.78 20.58-21.47zm-58.13-19.08c-33.5 0-64.6 15.98-83.19 42.76l-17.32 24.95c-15.69-9.41-33.82-14.44-52.76-14.44-31.79 0-60.96 14-80.01 38.4L320 394.67l-27.2-34.83c-19.06-24.4-48.22-38.4-80.02-38.4-18.94 0-37.07 5.03-52.76 14.44l-17.32-24.95c-18.59-26.77-49.68-42.76-83.19-42.76-4.62 0-9.21.31-13.77.92l56.58-126.78 143.47 82.66 26.05-100.06 20.99 19.1h54.33l20.99-19.1 26.05 100.06 143.47-82.66 56.58 126.78c-4.55-.62-9.15-.92-13.77-.92z"]
  },
      Se = {
    prefix: "fal",
    iconName: "bath",
    icon: [512, 512, [], "f2cd", "M504,256H64V61.25a29.26,29.26,0,0,1,49.94-20.69L139.18,65.8A71.49,71.49,0,0,0,128,104c0,20.3,8.8,38.21,22.34,51.26L138.58,167a8,8,0,0,0,0,11.31l11.31,11.32a8,8,0,0,0,11.32,0L285.66,65.21a8,8,0,0,0,0-11.32L274.34,42.58a8,8,0,0,0-11.31,0L251.26,54.34C238.21,40.8,220.3,32,200,32a71.44,71.44,0,0,0-38.2,11.18L136.56,18A61.24,61.24,0,0,0,32,61.25V256H8a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H32v96c0,41.74,26.8,76.9,64,90.12V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V480H384v24a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V474.12c37.2-13.22,64-48.38,64-90.12V288h24a8,8,0,0,0,8-8V264A8,8,0,0,0,504,256ZM228.71,76.9,172.9,132.71A38.67,38.67,0,0,1,160,104a40,40,0,0,1,40-40A38.67,38.67,0,0,1,228.71,76.9ZM448,384a64.07,64.07,0,0,1-64,64H128a64.07,64.07,0,0,1-64-64V288H448Z"]
  },
      Te = {
    prefix: "fal",
    iconName: "battery-bolt",
    icon: [640, 512, [], "f376", "M640 184v144c0 13.255-10.745 24-24 24h-8v16c0 26.51-21.49 48-48 48H400.69l18.028-32H560c8.823 0 16-7.177 16-16v-48h32V192h-32v-48c0-8.823-7.177-16-16-16h-90.776c-13.223-9.205-28.229-14.344-43.41-15.66l3.971-15.195c.101-.381.191-.763.287-1.145H560c26.51 0 48 21.49 48 48v16h8c13.255 0 24 10.745 24 24zM32 368V144c0-8.823 7.177-16 16-16h95.388l3.21-32H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h149.734c.034-.133.063-.267.097-.4l7.71-31.6H48c-8.823 0-16-7.177-16-16zm422.616-145.511L321.664 458.482C314.042 472.12 299.81 480 284.985 480c-27.295 0-47.645-25.901-40.605-52.684L278.374 288h-56.37c-24.74 0-44.15-21.313-41.812-45.964l17.252-172C199.487 48.472 217.595 32 239.255 32h103.557c27.656 0 47.711 26.272 40.563 52.892L363.745 160h54.208c32.032 0 52.288 34.528 36.663 62.489zM417.952 192h-95.646l30.11-115.2.027-.104.028-.103c1.7-6.331-3.078-12.593-9.658-12.593H239.255a9.96 9.96 0 0 0-9.956 9.056l-.008.087-.009.087-17.24 171.881c-.523 5.829 4.089 10.89 9.96 10.89h97.117l-43.653 178.902-.067.275-.072.274c-1.723 6.555 3.374 12.548 9.656 12.548 2.842 0 6.632-1.347 8.744-5.128l.027-.048.027-.048L426.69 206.86c3.693-6.634-1.12-14.86-8.738-14.86z"]
  },
      De = {
    prefix: "fal",
    iconName: "battery-empty",
    icon: [640, 512, [], "f244", "M560 128c8.823 0 16 7.177 16 16v48h32v128h-32v48c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16V144c0-8.823 7.177-16 16-16h512m0-32H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"]
  },
      je = {
    prefix: "fal",
    iconName: "battery-full",
    icon: [640, 512, [], "f240", "M560 128c8.823 0 16 7.177 16 16v48h32v128h-32v48c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16V144c0-8.823 7.177-16 16-16h512m0-32H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zM128 314V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6z"]
  },
      Ee = {
    prefix: "fal",
    iconName: "battery-half",
    icon: [640, 512, [], "f242", "M560 128c8.823 0 16 7.177 16 16v48h32v128h-32v48c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16V144c0-8.823 7.177-16 16-16h512m0-32H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zM128 314V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6z"]
  },
      ke = {
    prefix: "fal",
    iconName: "battery-quarter",
    icon: [640, 512, [], "f243", "M560 128c8.823 0 16 7.177 16 16v48h32v128h-32v48c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16V144c0-8.823 7.177-16 16-16h512m0-32H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zM128 314V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6z"]
  },
      Ie = {
    prefix: "fal",
    iconName: "battery-slash",
    icon: [640, 512, [], "f377", "M637 485.25L23 1.75A8 8 0 0 0 11.76 3l-10 12.51A8 8 0 0 0 3 26.75l614 483.5a8 8 0 0 0 11.24-1.25l10-12.51a8 8 0 0 0-1.24-11.24zM48 384a16 16 0 0 1-16-16V144a16 16 0 0 1 16-16h31.85L40.21 96.79A47.9 47.9 0 0 0 0 144v224a48 48 0 0 0 48 48h397.58L405 384zm568-224h-8v-16a48 48 0 0 0-48-48H194.4l40.6 32h325a16 16 0 0 1 16 16v48h32v128h-32v48a16 16 0 0 1-15.89 16l28.45 22.41A47.81 47.81 0 0 0 608 368v-16h8a24 24 0 0 0 24-24V184a24 24 0 0 0-24-24z"]
  },
      Oe = {
    prefix: "fal",
    iconName: "battery-three-quarters",
    icon: [640, 512, [], "f241", "M560 128c8.823 0 16 7.177 16 16v48h32v128h-32v48c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16V144c0-8.823 7.177-16 16-16h512m0-32H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zM128 314V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm64 0V198a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v116a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6z"]
  },
      Qe = {
    prefix: "fal",
    iconName: "bed",
    icon: [640, 512, [], "f236", "M144 320c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm0-128c26.47 0 48 21.53 48 48s-21.53 48-48 48-48-21.53-48-48 21.53-48 48-48zm384-32H272c-8.84 0-16 7.16-16 16v176H32V72c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v368c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h576v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V272c0-61.86-50.14-112-112-112zm80 192H288V192h240c44.11 0 80 35.89 80 80v80z"]
  },
      Ze = {
    prefix: "fal",
    iconName: "bed-alt",
    icon: [512, 512, [], "f8f7", "M480,226.15V80a48,48,0,0,0-48-48H80A48,48,0,0,0,32,80V226.15C13.74,231,0,246.89,0,266.67V472a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V416H480v56a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V266.67C512,246.89,498.26,231,480,226.15ZM64,192a32,32,0,0,1,32-32H208a32,32,0,0,1,32,32v32H64Zm384,32H272V192a32,32,0,0,1,32-32H416a32,32,0,0,1,32,32ZM80,64H432a16,16,0,0,1,16,16v56.9a63.27,63.27,0,0,0-32-8.9H304a63.9,63.9,0,0,0-48,21.71A63.9,63.9,0,0,0,208,128H96a63.27,63.27,0,0,0-32,8.9V80A16,16,0,0,1,80,64ZM32,384V266.67A10.69,10.69,0,0,1,42.67,256H469.33A10.69,10.69,0,0,1,480,266.67V384Z"]
  },
      Ue = {
    prefix: "fal",
    iconName: "bed-bunk",
    icon: [576, 512, [], "f8f8", "M464,0H240a16,16,0,0,0-16,16V160H32V8a8,8,0,0,0-8-8H8A8,8,0,0,0,0,8V504a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V448H544v56a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V112A112,112,0,0,0,464,0Zm80,376v40H256V288H464a80.09,80.09,0,0,1,80,80Zm0-86.23A111.53,111.53,0,0,0,464,256H240a16,16,0,0,0-16,16V416H32V192H544ZM544,160H256V32H464a80.09,80.09,0,0,1,80,80ZM128,128A64,64,0,1,0,64,64,64,64,0,0,0,128,128Zm0-96A32,32,0,1,1,96,64,32,32,0,0,1,128,32Zm0,352a64,64,0,1,0-64-64A64,64,0,0,0,128,384Zm0-96a32,32,0,1,1-32,32A32,32,0,0,1,128,288Z"]
  },
      Be = {
    prefix: "fal",
    iconName: "bed-empty",
    icon: [640, 512, [], "f8f9", "M528,128H32V72a8,8,0,0,0-8-8H8a8,8,0,0,0-8,8V440a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V384H608v56a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V240A112,112,0,0,0,528,128ZM32,352V160H160V352Zm576,0H192V160H528a80.09,80.09,0,0,1,80,80Z"]
  },
      Re = {
    prefix: "fal",
    iconName: "beer",
    icon: [448, 512, [], "f0fc", "M384 96h-32V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h256c26.51 0 48-21.49 48-48v-22.112l60.621-30.311C434.443 368.666 448 346.731 448 322.334V160c0-35.29-28.71-64-64-64zm-64 336c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h256c8.822 0 16 7.178 16 16v352zm96-109.666c0 12.199-6.778 23.166-17.689 28.622L352 374.112V128h32c17.645 0 32 14.355 32 32v162.334zM192 144v224c0 8.837-7.164 16-16 16s-16-7.163-16-16V144c0-8.837 7.164-16 16-16s16 7.163 16 16zm-64 0v224c0 8.837-7.164 16-16 16s-16-7.163-16-16V144c0-8.837 7.164-16 16-16s16 7.163 16 16zm128 0v224c0 8.837-7.163 16-16 16s-16-7.163-16-16V144c0-8.837 7.163-16 16-16s16 7.163 16 16z"]
  },
      Ye = {
    prefix: "fal",
    iconName: "bell",
    icon: [448, 512, [], "f0f3", "M224 480c-17.66 0-32-14.38-32-32.03h-32c0 35.31 28.72 64.03 64 64.03s64-28.72 64-64.03h-32c0 17.65-14.34 32.03-32 32.03zm209.38-145.19c-27.96-26.62-49.34-54.48-49.34-148.91 0-79.59-63.39-144.5-144.04-152.35V16c0-8.84-7.16-16-16-16s-16 7.16-16 16v17.56C127.35 41.41 63.96 106.31 63.96 185.9c0 94.42-21.39 122.29-49.35 148.91-13.97 13.3-18.38 33.41-11.25 51.23C10.64 404.24 28.16 416 48 416h352c19.84 0 37.36-11.77 44.64-29.97 7.13-17.82 2.71-37.92-11.26-51.22zM400 384H48c-14.23 0-21.34-16.47-11.32-26.01 34.86-33.19 59.28-70.34 59.28-172.08C95.96 118.53 153.23 64 224 64c70.76 0 128.04 54.52 128.04 121.9 0 101.35 24.21 138.7 59.28 172.08C421.38 367.57 414.17 384 400 384z"]
  },
      Pe = {
    prefix: "fal",
    iconName: "bell-exclamation",
    icon: [448, 512, [], "f848", "M433.37 334.81c-28-26.62-49.34-54.48-49.34-148.9 0-79.6-63.37-144.5-144-152.36V16a16 16 0 0 0-32 0v17.56C127.35 41.41 64 106.31 64 185.91c0 94.4-21.41 122.28-49.35 148.9a46.47 46.47 0 0 0-11.27 51.24A47.68 47.68 0 0 0 48 416h352a47.67 47.67 0 0 0 44.62-30 46.47 46.47 0 0 0-11.25-51.19zM400 384H48c-14.22 0-21.35-16.47-11.32-26C71.54 324.8 96 287.66 96 185.91 96 118.53 153.22 64 224 64s128 54.52 128 121.91c0 101.34 24.22 138.68 59.28 172.07C421.37 367.56 414.16 384 400 384zm-176 96a32 32 0 0 1-32-32h-32a64 64 0 1 0 128 0h-32a32 32 0 0 1-32 32zm-8.5-224h17a8.13 8.13 0 0 0 8-7.5l7-112a8 8 0 0 0-8-8.5h-31a8 8 0 0 0-8 8.5l7 112a8 8 0 0 0 8 7.5zm8.5 24a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"]
  },
      Fe = {
    prefix: "fal",
    iconName: "bell-on",
    icon: [640, 512, [], "f8fa", "M528,64a16.17,16.17,0,0,0,7.16-1.69l64-32A16,16,0,0,0,584.84,1.69l-64,32A16,16,0,0,0,528,64ZM80,160H16a16,16,0,0,0,0,32H80a16,16,0,0,0,0-32ZM40.84,30.31l64,32A16.17,16.17,0,0,0,112,64a16,16,0,0,0,7.16-30.31l-64-32A16,16,0,0,0,40.84,30.31ZM624,160H560a16,16,0,0,0,0,32h64a16,16,0,0,0,0-32ZM320,480a32,32,0,0,1-32-32H256a64,64,0,1,0,128,0H352A32,32,0,0,1,320,480ZM480,185.91c0-79.6-63.37-144.5-144-152.36V16a16,16,0,0,0-32,0V33.56c-80.66,7.85-144,72.75-144,152.35,0,94.4-21.41,122.28-49.35,148.9a46.45,46.45,0,0,0-11.24,51.24A47.67,47.67,0,0,0,144,416H496a47.66,47.66,0,0,0,44.62-30,46.49,46.49,0,0,0-11.24-51.22C501.41,308.19,480,280.33,480,185.91ZM496,384H144c-14.22,0-21.34-16.47-11.31-26C167.53,324.8,192,287.66,192,185.91,192,118.53,249.22,64,320,64s128,54.52,128,121.91c0,101.34,24.22,138.68,59.28,172.07C517.38,367.56,510.16,384,496,384Z"]
  },
      We = {
    prefix: "fal",
    iconName: "bell-plus",
    icon: [448, 512, [], "f849", "M224 480a32 32 0 0 1-32-32h-32a64 64 0 1 0 128 0h-32a32 32 0 0 1-32 32zm209.37-145.19c-28-26.62-49.34-54.48-49.34-148.9 0-79.6-63.37-144.5-144-152.36V16a16 16 0 0 0-32 0v17.56C127.35 41.41 64 106.31 64 185.91c0 94.4-21.41 122.28-49.35 148.9a46.47 46.47 0 0 0-11.27 51.24A47.68 47.68 0 0 0 48 416h352a47.67 47.67 0 0 0 44.62-30 46.47 46.47 0 0 0-11.25-51.19zM400 384H48c-14.22 0-21.35-16.47-11.32-26C71.54 324.8 96 287.66 96 185.91 96 118.53 153.22 64 224 64s128 54.52 128 121.91c0 101.34 24.22 138.68 59.28 172.07C421.37 367.56 414.16 384 400 384zM296 224h-56v-56a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h56v56a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      Ge = {
    prefix: "fal",
    iconName: "bell-school",
    icon: [512, 512, [], "f5d5", "M208 128c-44.11 0-80 35.89-80 80s35.89 80 80 80 80-35.89 80-80-35.89-80-80-80zm0 128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm256 48c-26.47 0-48 21.53-48 48 0 20.15 12.51 37.37 30.15 44.48C440.62 416.88 422.13 432 400 432h-48v-74.12c39.38-37.85 64-90.94 64-149.88C416 93.12 322.88 0 208 0S0 93.12 0 208c0 58.93 24.62 112.03 64 149.88V480c0 17.67 14.33 32 32 32h224c17.67 0 32-14.33 32-32v-16h48c39.51 0 72.19-28.84 78.64-66.53C497.92 391.24 512 373.33 512 352c0-26.47-21.53-48-48-48zM320 480H96v-96.91C128.35 403.82 166.72 416 208 416s79.65-12.18 112-32.91V480zm-112-96c-97.05 0-176-78.95-176-176S110.95 32 208 32s176 78.95 176 176-78.95 176-176 176zm256-16c-8.81 0-16-7.17-16-16s7.19-16 16-16 16 7.17 16 16-7.19 16-16 16z"]
  },
      qe = {
    prefix: "fal",
    iconName: "bell-school-slash",
    icon: [640, 512, [], "f5d6", "M272 32c97 0 176 79 176 176 0 26.6-6.1 51.8-16.8 74.5l25.6 20.2c14.6-28.4 23.1-60.5 23.1-94.7C480 93.1 386.9 0 272 0c-51.8 0-99.1 19.1-135.5 50.4l25.7 20.3C192.4 46.5 230.5 32 272 32zm-29.6 101.8l33.8 26.6c19.3 1.7 35.1 14.7 41.1 32.3l33.6 26.4c.5-3.7 1.1-7.4 1.1-11.2 0-44.1-35.9-80-80-80-10.5.1-20.4 2.3-29.6 5.9zM528 336c8.8 0 16 7.2 16 16 0 5.7-3.2 10.4-7.6 13.3l25.3 19.9c8.6-8.6 14.3-20 14.3-33.2 0-26.5-21.5-48-48-48-17.2 0-32.1 9.1-40.6 22.7l25.7 20.2c2.1-6.3 7.9-10.9 14.9-10.9zm109 149.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zM464 432h-48v-39.3l-47.7-37.6C340.6 373.3 307.5 384 272 384c-97 0-176-79-176-176 0-20.8 3.8-40.6 10.4-59.1L80 128.1c-10.2 24.6-16 51.6-16 79.9 0 58.9 24.6 112 64 149.9V480c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32v-16h48c11.9 0 22.9-2.9 33-7.5l-31.5-24.8c-.5.1-.9.3-1.5.3zm-80 0v48H160v-96.9c32.4 20.7 70.7 32.9 112 32.9s79.7-12.2 112-32.9zM281.8 287l-88.9-70c4.6 39.8 38.1 71 79.1 71 3.4 0 6.5-.6 9.8-1z"]
  },
      Je = {
    prefix: "fal",
    iconName: "bell-slash",
    icon: [640, 512, [], "f1f6", "M320 480c-17.7 0-32-14.4-32-32h-32c0 35.3 28.7 64 64 64s64-28.7 64-64h-32c0 17.6-14.3 32-32 32zm0-416c70.8 0 128 54.5 128 121.9 0 63.2 9.4 101.6 25 129.5l70.7 55.7c.7-13.4-4.2-26.6-14.4-36.3-28-26.6-49.3-54.5-49.3-148.9 0-79.6-63.4-144.5-144-152.3V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.6c-43.9 4.2-84.2 26.2-111.5 60.9l24.7 19.4C240.4 83.8 277.7 64 320 64zm317 421.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zM144 384c-14.2 0-21.3-16.5-11.3-26 31.2-29.7 53.9-63 58.3-142.4L159.8 191c-.8 90-21.8 117.7-49.2 143.8-14 13.3-18.4 33.4-11.2 51.2 7.3 18.2 24.8 30 44.6 30h301.6L405 384z"]
  },
      Ke = {
    prefix: "fal",
    iconName: "bells",
    icon: [640, 512, [], "f77f", "M638.4 313.9c-2.1-5.9-6.4-11.2-12.9-14.5-21-10.8-58.3-24.9-87.4-105-.8-2.2-14.7-40.5-15.4-42.6C503 97.6 451.8 64 397.4 64c-15.1 0-30.5 2.6-45.6 8.1-3.6 1.3-6.6 3.3-10 4.8-14.2-16-32.1-29-53.5-36.8-15-5.5-30.5-8.1-45.6-8.1-54.5 0-105.6 33.6-125.3 87.8-.8 2.1-14.6 40.4-15.4 42.6-29.2 80.1-66.4 94.3-87.4 105-6.5 3.3-10.8 8.6-12.9 14.5-4.6 12.9 1 28.8 16 34.2l82 29.9c-2.1 7-3.6 14.3-3.6 22 0 44.2 35.8 80 80 80 32.6 0 60.5-19.6 72.9-47.7l42.1 15.3c-2.8 6.5-7.5 14.8-3.4 26 4.9 13.1 19.6 21.3 34.3 15.9l76-27.7c11.8 29.4 40.5 50.1 74.1 50.1 44.2 0 80-35.8 80-80 0-8.7-1.9-16.8-4.6-24.5l75-27.3c14.9-5.4 20.5-21.3 15.9-34.2zM176 416c-26.5 0-48-21.5-48-48 0-3.9.6-7.5 1.5-11.1l88.9 32.4C210.6 405 194.7 416 176 416zm124.7-30.9L40.1 290.3c24.5-12.8 63.2-38.2 91.8-117 8.3-22.9 5.1-14.1 15.4-42.6C161.9 90.8 200.2 64 242.6 64c44.7 0 70.8 29.1 71.6 29.9-43.3 34.8-62.2 94-42.2 149.1.8 2.1 14.8 40.4 15.6 42.6 16.9 46.4 17.4 77.3 13.1 99.5zM472 448c-19.7 0-36.1-12.2-43.4-29.3l89.3-32.5c1.3 4.4 2.1 9 2.1 13.8 0 26.5-21.5 48-48 48zm-149.5-24.8c10.6-25.6 23.8-69.8-4.8-148.7-9.6-26.3-5.5-15-15.6-42.6-19.1-52.5 8.1-110.8 60.6-129.9 53-19.3 110.9 8.5 129.9 60.6 9.7 26.7 5 13.8 15.4 42.6 28.7 78.8 67.3 104.2 91.8 117l-277.3 101z"]
  },
      Xe = {
    prefix: "fal",
    iconName: "betamax",
    icon: [512, 512, [], "f8a4", "M320 368h96a32 32 0 0 0 32-32v-96a32 32 0 0 0-32-32h-96a32 32 0 0 0-32 32v96a32 32 0 0 0 32 32zm0-128h96v96h-96zm-160 72a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm0 72a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm0-160a64 64 0 1 1-64 64 64.07 64.07 0 0 1 64-64zM496 64H16A16 16 0 0 0 0 80v320a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V80a16 16 0 0 0-16-16zm-16 336a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V160h448zm0-272H32V96h448z"]
  },
      _e = {
    prefix: "fal",
    iconName: "bezier-curve",
    icon: [640, 512, [], "f55b", "M576 176c35.35 0 64-28.65 64-64s-28.65-64-64-64c-29.79 0-54.6 20.44-61.74 48H400V64c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32v32H125.74C118.6 68.44 93.79 48 64 48 28.65 48 0 76.65 0 112s28.65 64 64 64c29.79 0 54.6-20.44 61.74-48h112.81c-80.61 31.51-135.13 105.79-141.27 192H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32h-30.73c5.76-69.41 48.06-129.54 111.08-158.25.96 16.81 14.6 30.25 31.65 30.25h96c17.05 0 30.69-13.44 31.65-30.25 63.02 28.72 105.32 88.84 111.08 158.25H480c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32h-33.27c-6.13-86.21-60.66-160.49-141.27-192h112.81c7.13 27.56 31.94 48 61.73 48zM160 448H64v-96h96v96zM64 144c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm304 16h-96V64h96v96zm208 288h-96v-96h96v96zm0-368c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32z"]
  },
      $e = {
    prefix: "fal",
    iconName: "bible",
    icon: [448, 512, [], "f647", "M448 392V24c0-13.3-10.7-24-24-24H80C35.8 0 0 35.8 0 80v368c0 35.35 28.65 64 64 64h372c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-3.3c-4-20.2-3.2-49.7.4-65.8 8.7-3.6 14.9-12.2 14.9-22.2zm-43.7 88H64c-17.67 0-32-14.33-32-32s14.33-32 32-32h340.3c-2.9 18.8-3.1 43.6 0 64zm11.7-96H64c-11.72 0-22.55 3.38-32 8.88V80c0-26.5 21.5-48 48-48h336v352zM152 224h40v104c0 13.23 10.78 24 24 24h48c13.22 0 24-10.77 24-24V224h40c13.22 0 24-10.77 24-24v-48c0-13.23-10.78-24-24-24h-40V88c0-13.23-10.78-24-24-24h-48c-13.22 0-24 10.77-24 24v40h-40c-13.22 0-24 10.77-24 24v48c0 13.23 10.78 24 24 24zm8-64h64V96h32v64h64v32h-64v128h-32V192h-64v-32z"]
  },
      ca = {
    prefix: "fal",
    iconName: "bicycle",
    icon: [640, 512, [], "f206", "M512.303 192c-19.586-.047-38.147 4.313-54.759 12.132L373.508 71.439A16 16 0 0 0 359.991 64h-67.998c-6.627 0-12 5.373-12 12v8c0 6.627 5.372 12 12 12h59.193l40.532 64H255.994v-20c0-6.627-5.372-12-12-12h-83.998c-8.836 0-16 7.163-16 16s7.163 16 16 16h55.999l-31.808 44.969c-17.085-8.362-36.303-13.035-56.622-12.968C56.937 192.234-.001 249.37 0 320c.001 70.692 57.307 128 127.997 128 59.641 0 109.755-40.793 123.964-96h52.031a16.001 16.001 0 0 0 13.107-6.824l100.744-143.924 12.677 20.018c-28.385 23.449-46.487 58.903-46.531 98.587-.077 69.963 56.843 127.499 126.801 128.138 70.559.644 128.101-55.842 129.193-125.995 1.099-70.503-57.17-129.829-127.68-130zM127.997 416c-52.933 0-95.998-43.065-95.998-96s43.064-96 95.998-96c13.307 0 25.989 2.724 37.521 7.639L98.89 326.824C91.47 337.423 99.083 352 111.997 352h106.506c-13.207 37.248-48.788 64-90.506 64zm95.998-96h-81.268l49.744-71.065c19.354 17.575 31.524 42.925 31.524 71.065zm71.668 0h-39.669c0-39.04-17.483-73.992-45.04-97.47L232.325 192H385.26l-89.597 128zm212.533 95.927c-50.058-1.938-90.528-42.677-92.154-92.747-.961-29.57 11.533-56.303 31.81-74.546l52.759 83.306c3.546 5.599 10.959 7.263 16.558 3.717l6.758-4.281c5.599-3.546 7.263-10.96 3.717-16.558l-52.785-83.346c11.427-4.811 23.972-7.473 37.128-7.473 52.933 0 95.998 43.065 95.998 96 .001 54.194-45.136 98.043-99.789 95.928z"]
  },
      ea = {
    prefix: "fal",
    iconName: "biking",
    icon: [640, 512, [], "f84a", "M120 272a120 120 0 1 0 120 120 120 120 0 0 0-120-120zm0 208a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88zm400-208a120 120 0 1 0 120 120 120 120 0 0 0-120-120zm0 208a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88zM374.31 245.79a48.19 48.19 0 0 0 29.89 10.43H464a48 48 0 0 0 0-96h-42.95l-21.32-17.05a70.18 70.18 0 0 0 8.27.83 72.07 72.07 0 1 0-66.4-44.22 46.67 46.67 0 0 0-48.69 8l-99.25 79c-12.35 10.51-18.45 24.81-17.57 39.94a47.64 47.64 0 0 0 21.24 37.14L272 313.69V400a48 48 0 0 0 96 0V288a47.91 47.91 0 0 0-21.33-39.91l-13.33-9 16.5-12.72zM408 32a40 40 0 1 1-40 40 40 40 0 0 1 40-40zm-79.12 242.69A16 16 0 0 1 336 288v112a16 16 0 0 1-32 0V296.56l-88.88-59.25a16 16 0 0 1-1.53-25.45l100.2-79.78a16 16 0 0 1 20.41-.36l75.62 60.5H464a16 16 0 0 1 0 32h-59.8a16 16 0 0 1-10-3.5l-44.09-35-71.43 55.11z"]
  },
      aa = {
    prefix: "fal",
    iconName: "biking-mountain",
    icon: [640, 512, [], "f84b", "M153.18 178.45l25.31-19.56-35.62-42.39 53.4-41.66A48.72 48.72 0 0 1 233 64.34a54.55 54.55 0 0 1 36.87 21.33l25.31-19.56a86.22 86.22 0 0 0-58.46-33.55 81 81 0 0 0-60.31 17.23L123 91.43c-12.53 10.13-14.56 29-4.5 42zm221.15 67.34a48.17 48.17 0 0 0 29.88 10.43H464a48 48 0 0 0 0-96h-42.94l-21.32-17.05a70.61 70.61 0 0 0 8.26.83 72.07 72.07 0 1 0-66.4-44.22 46.65 46.65 0 0 0-48.68 8l-99.25 79c-12.35 10.51-18.45 24.81-17.57 39.94a47.64 47.64 0 0 0 21.24 37.14L272 313.69V400a48 48 0 1 0 96 0V288a47.91 47.91 0 0 0-21.33-39.91l-13.33-9 16.5-12.72zM408 32a40 40 0 1 1-40 40 40 40 0 0 1 40-40zm-79.11 242.69A16 16 0 0 1 336 288v112a16 16 0 1 1-32 0V296.56l-88.87-59.25a16 16 0 0 1-1.54-25.45l100.2-79.78a16 16 0 0 1 20.4-.36l75.63 60.5H464a16 16 0 0 1 0 32h-59.8a16 16 0 0 1-10-3.5l-44.09-35-71.41 55.14zM128 328a56 56 0 1 0 56 56 56.06 56.06 0 0 0-56-56zm0 80a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm489-67.17c-.09-.19-.15-.38-.25-.57a30 30 0 0 0-4.37-36.87l-19.81-19.8a30.63 30.63 0 0 0-36.88-4.39l-.56-.23A30 30 0 0 0 526 256h-28a30 30 0 0 0-29.15 23l-.59.25a30.13 30.13 0 0 0-36.87 4.39l-19.79 19.8a30.08 30.08 0 0 0-4.37 36.86 4.83 4.83 0 0 0-.25.58A30.06 30.06 0 0 0 384 370v28a30.08 30.08 0 0 0 23 29.17c.06.19.16.39.22.58a30.09 30.09 0 0 0 4.4 36.86l19.79 19.8a30.13 30.13 0 0 0 36.87 4.39l.59.23A30 30 0 0 0 498 512h28a30 30 0 0 0 29.16-23l.59-.23a30.11 30.11 0 0 0 36.88-4.39l19.78-19.8a30.07 30.07 0 0 0 4.37-36.86 3.63 3.63 0 0 0 .25-.58A30.07 30.07 0 0 0 640 398v-28a30 30 0 0 0-23-29.17zM593.6 396l-3.44 11.39a83.81 83.81 0 0 1-6.34 15.27l-5.72 10.53 8.5 8.43 3.18.36-17 19.8-11.66-11.67-10.5 5.7a79.41 79.41 0 0 1-15.25 6.31L524 465.55v11.9l2 2.55-26 2v-16.45l-11.41-3.43a81.43 81.43 0 0 1-15.28-6.32l-10.47-5.68-8.43 8.44-.41 3.22-19.8-16.95 11.8-11.67-5.78-10.55a81.24 81.24 0 0 1-6.32-15.24L430.42 396h-11.88l-2.54 2-2-26h16.41l3.43-11.39a83.15 83.15 0 0 1 6.35-15.27l5.72-10.53-8.5-8.44-3.19-.36 17-19.79 11.65 11.67 10.5-5.7a78.89 78.89 0 0 1 15.22-6.32l11.44-3.4v-11.92L498 288l26-2v16.45l11.4 3.42a82.63 82.63 0 0 1 15.31 6.35l10.53 5.65 8.41-8.48.31-3.17 19.84 16.95-11.68 11.64 5.69 10.52a81.38 81.38 0 0 1 6.28 15.23L593.5 372h14.66l1.84 24zm-360.55-55.16a5.77 5.77 0 0 1-.25-.59 30.13 30.13 0 0 0-4.4-36.86l-19.79-19.8c-9.62-9.65-25.56-11.31-36.87-4.39l-.59-.23A30 30 0 0 0 142 256h-28a30 30 0 0 0-29.15 23l-.56.23a30.11 30.11 0 0 0-36.88 4.39l-19.81 19.8a30.06 30.06 0 0 0-4.37 36.89c-.06.17-.16.36-.22.55A30 30 0 0 0 0 370v28a30.05 30.05 0 0 0 23 29.17 2.63 2.63 0 0 0 .22.55 30.07 30.07 0 0 0 4.37 36.89l19.81 19.8a30.06 30.06 0 0 0 36.88 4.37 5.51 5.51 0 0 0 .59.25A30 30 0 0 0 114 512h28a30 30 0 0 0 29.16-23l.59-.23c11.25 6.9 27.19 5.26 36.84-4.39l19.82-19.8a30.08 30.08 0 0 0 4.37-36.86 5.64 5.64 0 0 0 .25-.58A30.06 30.06 0 0 0 256 398v-28.06a30.15 30.15 0 0 0-22.95-29.1zM209.52 396l-3.41 11.45a80.14 80.14 0 0 1-6.28 15.21l-5.71 10.53 8.5 8.43 3.18.36-17 19.8-11.65-11.67-10.5 5.7a79.67 79.67 0 0 1-15.25 6.31l-11.4 3.43v11.9l2 2.55-26 2v-16.47l-11.44-3.41a82.19 82.19 0 0 1-15.31-6.34l-10.53-5.66-8.41 8.49-.31 3.17-19.81-16.95 11.68-11.64-5.69-10.52a85.12 85.12 0 0 1-6.31-15.3L46.44 396H34.56L32 398l-2-26h16.44l3.43-11.39a83 83 0 0 1 6.35-15.33l5.62-10.5-8.44-8.41-3.18-.37 16.93-19.84 11.63 11.72 10.53-5.69a80.53 80.53 0 0 1 15.28-6.33l11.4-3.42v-11.9L114 288l26-2v16.47l11.44 3.4a82 82 0 0 1 15.25 6.33l10.47 5.67 8.43-8.43.41-3.22 19.75 17-11.56 11.63 5.65 10.47a84.62 84.62 0 0 1 6.32 15.29l3.42 11.39h14.6l1.82 24zM512 328a56 56 0 1 0 56 56 56.06 56.06 0 0 0-56-56zm0 80a24 24 0 1 1 24-24 24 24 0 0 1-24 24z"]
  },
      na = {
    prefix: "fal",
    iconName: "binoculars",
    icon: [512, 512, [], "f1e5", "M511.67 404c-3.46-129.77-61.06-182.16-63.59-275.98-.47-17.64-14.27-32.02-31.92-32.02H416V64c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v32h-64V64c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v32h-.16c-17.65 0-31.45 14.38-31.93 32.02C61.39 221.84 3.79 274.23.33 404L0 432c0 26.51 21.49 48 48 48h128c26.51 0 48-21.49 48-48V288h64v144c0 26.51 21.49 48 48 48h128c26.51 0 48-21.49 48-48l-.33-28zM320 64h64v32h-64V64zm-192 0h64v32h-64V64zm64 368c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16 0 0 .94-41.26 1.48-48H192v48zm0-80H37.48c6.38-37.88 17.59-68.49 28.66-98.22C80.13 216.18 94.6 177.3 95.84 128H192v224zm32-96V128h64v128h-64zm96-128h96.16l-.06.88c1.3 48.42 15.77 87.3 29.76 124.9 11.06 29.73 22.28 60.33 28.66 98.22H320V128zm160 304c0 8.82-7.18 16-16 16H336c-8.82 0-16-7.18-16-16v-48h158.52c.54 6.74 1.48 48 1.48 48z"]
  },
      ta = {
    prefix: "fal",
    iconName: "biohazard",
    icon: [576, 512, [], "f780", "M288.1 96c17.7 0 34.8 2.7 50.9 7.6 6.5-8.5 11.1-18.4 13.1-29.4-20.2-6.5-41.7-10.1-64-10.1-22.4 0-44 3.7-64.2 10.2 1.9 11 6.6 21 13.1 29.4 16.2-5 33.3-7.7 51.1-7.7zm-.1 144.1c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM146.1 423.6c9.7-5.6 17.2-13.6 22.6-22.7-28.5-26.4-48.2-62.2-54.4-102.4-.4 0-.8-.2-1.2-.2-10.4 0-20.7 2.9-30 7.9 7.7 46 30.4 86.9 63 117.4zm428.6-147c-13.8-40.3-41.2-74.1-77.2-95.3-12.2-7.2-25.6-12.8-40.1-16.7 3.5-13.9 5.2-27.4 5.2-40.8 0-42.2-15.1-83.2-42.4-115.5-7.3-8.6-19.7-10.9-29.7-5.2-9.7 5.6-14.1 17.4-10.6 27.9 3.7 11.3 5.5 21.5 5.5 31.1 0 54.7-43.6 99.3-97.3 99.3s-97.3-44.5-97.3-99.3c0-9.6 1.8-19.8 5.4-31 3.5-10.7-.9-22.5-10.7-28-9.8-5.6-22.2-3.5-29.6 5.2-27.4 32.3-42.5 73.3-42.5 115.5 0 13.4 1.7 26.9 5.2 40.8-14.5 4-27.9 9.6-40.1 16.7-36 21.1-63.4 55-77.2 95.3-3.7 10.6.5 22.2 10.2 28.1 9.7 5.8 22.2 3.8 29.7-4.8 7.7-8.8 15.4-15.5 23.6-20.3 22.3-13.1 48.3-16.6 73.2-9.9 25.3 6.8 46.4 23.2 59.5 46.2 26.9 47.5 10.9 108.4-35.7 135.8-8.2 4.8-17.7 8.3-29 10.7-11 2.3-18.8 12.1-18.7 23.4.1 11.2 8.1 20.9 19.1 23.1 11 2.1 22.1 3.2 33.1 3.2 30.4 0 60.4-8 86.9-23.6 12.5-7.3 24.1-16.5 34.7-27.3 10.7 10.9 22.3 20 34.7 27.3 36 21.2 78.6 28.5 119.9 20.4 11.1-2.1 18.9-11.6 19.1-23.1.1-11.3-7.8-21.1-18.7-23.4-11.4-2.4-20.8-5.9-29-10.7-46.6-27.4-62.6-88.3-35.7-135.8 13.1-23 34.2-39.4 59.5-46.2 24.9-6.7 50.9-3.2 73.2 9.9 8.2 4.8 15.9 11.4 23.6 20.3 7.5 8.6 20 10.5 29.8 4.7 9.9-5.9 14-17.4 10.4-28zm-145.1-37.8c-33.7 9-61.7 30.8-79 61.3-35.6 62.6-14.3 143 47.2 179.1.2.1.3.2.4.2-20.8-1.7-41.1-8-59.3-18.7-14.1-8.3-27-19.7-38.4-33.8L288 411.5 275.5 427c-11.4 14.1-24.3 25.5-38.4 33.8-18.2 10.7-38.5 17-59.3 18.7.1-.1.3-.2.4-.2 61.6-36.2 82.8-116.5 47.3-179.1-17.3-30.5-45.4-52.3-79.1-61.3-11-3-22.2-4.4-33.2-4.4-22.3 0-44.3 5.9-64.1 17.4C61 234.4 76.5 219.7 94.7 209c13.9-8.1 29.2-13.6 46.9-16.7l18.5-3.2-6.1-17.8c-5.7-16.7-8.6-32.2-8.6-47.5 0-21.1 4.6-41.9 13.3-60.9.4 72 58.2 130.5 129.3 130.5 71 0 128.9-58.5 129.3-130.5 8.7 19 13.3 39.8 13.3 60.9 0 15.2-2.8 30.7-8.5 47.5L416 189l18.5 3.2c17.7 3.1 33 8.5 46.9 16.7 18.2 10.7 33.7 25.4 45.6 42.9-29.7-17.2-64.3-21.9-97.4-13zm32.3 59.8c-6.2 40.2-25.9 76-54.5 102.5 5.5 9.1 12.9 17.1 22.5 22.8 32.7-30.5 55.4-71.4 63.1-117.4-9.4-5.1-19.7-8-30.2-8-.3 0-.6.1-.9.1z"]
  },
      ra = {
    prefix: "fal",
    iconName: "birthday-cake",
    icon: [448, 512, [], "f1fd", "M96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm48 160h-32V112h-32v144h-96V112h-32v144h-96V112H80v144H48c-26.5 0-48 21.5-48 48v208h448V304c0-26.5-21.5-48-48-48zm16 224H32v-72.043C48.222 398.478 55.928 384 74.75 384c27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 18.488 0 26.245 14.475 42.5 23.955V480zm0-112.374C406.374 359.752 394.783 352 373.5 352c-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-21.463 0-33.101 7.774-42.75 15.658V304c0-8.822 7.178-16 16-16h352c8.822 0 16 7.178 16 16v63.626z"]
  },
      ia = {
    prefix: "fal",
    iconName: "blanket",
    icon: [512, 512, [], "f498", "M446.2 384H104c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h344c35.3 0 64-28.7 64-64V80c0-44.2-35.8-80-80-80H80C35.8 0 0 35.8 0 80v320c0 61.9 50.1 112 112 112h392c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H115.6c-41.8 0-79.1-30.4-83.2-72-4.7-47.7 32.8-88 79.6-88h336c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.5 26.6-33.4 26.6zm1.8-96H112c-31.4 0-59.6 13-80 33.9V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v216.9c-9.5-5.5-20.3-8.9-32-8.9z"]
  },
      oa = {
    prefix: "fal",
    iconName: "blender",
    icon: [512, 512, [], "f517", "M288 400c-13.26 0-24 10.74-24 24 0 13.25 10.74 24 24 24s24-10.75 24-24c0-13.26-10.74-24-24-24zm134.25-55.97L512 0H48C21.53 0 0 21.53 0 48v160c0 26.47 21.53 48 48 48h102.26l7.53 86.56C121.72 356.38 96 391.07 96 432v48c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-48c0-39.4-23.79-73.18-57.75-87.97zM48 224c-8.81 0-16-7.17-16-16V48c0-8.83 7.19-16 16-16h82.78l16.7 192H48zM470.58 32l-16.7 64H296c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h149.54l-16.7 64H296c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h124.49l-29.22 112H189.34L162.9 32h307.68zM448 480H128v-48c0-35.29 28.71-64 64-64h192c35.29 0 64 28.71 64 64v48z"]
  },
      la = {
    prefix: "fal",
    iconName: "blender-phone",
    icon: [576, 512, [], "f6b6", "M486.25 344.03L576 0H192l29.79 342.56C185.72 356.38 160 391.07 160 432v48c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-48c0-39.4-23.79-73.18-57.75-87.97zM534.58 32l-16.7 64H360c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h149.54l-16.7 64H360c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h124.49l-29.22 112H253.34L226.9 32h307.68zM512 480H192v-48c0-35.29 28.71-64 64-64h192c35.29 0 64 28.71 64 64v48zm-160-80c-13.26 0-24 10.74-24 24 0 13.25 10.74 24 24 24s24-10.75 24-24c0-13.26-10.74-24-24-24zm-175.57-82.92l-23.62-57.97c-5.16-12.72-18.06-20.81-32.19-19.33l-28.53 2.8a180.1 180.1 0 0 1-.03-101.06l28.56 2.8c13.72 1.47 27-6.56 32.16-19.28l23.66-58.02c5.72-14.09.44-30.09-12.56-38.05L127.84 6.88c-19.41-11.89-44.91-8.02-60.53 9.44-90.53 101.33-89.62 253.41 2.06 353.72 8.31 9.11 21 13.94 33.81 13.94 8.59 0 17.22-2.17 24.56-6.67l36.09-22.16c13.04-7.98 18.32-23.98 12.6-38.07zm-65.44 32.94c-5.19 3.25-14.34 2.45-18-1.56C12.4 260.3 11.62 126.67 91.18 37.64c3.28-3.69 7.78-5.62 12.25-5.62 2.66 0 5.31.69 7.66 2.14l35.72 20.8-23.06 57.52-53.59-5.25-4.25 11.59c-17.41 47.22-17.41 99.23 0 146.47l4.25 11.59 53-5.72 23.31 57.11-35.48 21.75z"]
  },
      fa = {
    prefix: "fal",
    iconName: "blind",
    icon: [384, 512, [], "f29d", "M206.817 489.959c3.334 8.184-.598 17.521-8.78 20.854-8.166 3.329-17.515-.582-20.854-8.78L110.14 337.476l15.549-46.648 81.128 199.131zM102.663 121.531a4 4 0 0 1 6.562-4.577l112.933 161.912c3.815 5.468 11.307 6.742 16.708 2.976 5.356-3.737 6.796-11.232 2.976-16.708l-120-172a11.978 11.978 0 0 0-9.842-5.13V88H80v.013c-3.294.001-6.574 1.337-8.943 3.985L0 171.415V272c0 6.627 5.373 12 12 12s12-5.373 12-12v-91.415l48-53.646v198.465L16.821 490.936c-2.795 8.383 1.736 17.444 10.119 20.238 8.381 2.794 17.444-1.735 20.238-10.119L120 282.597v-136.21l-17.337-24.856zm280.725 384.343L245.791 286.463a20.279 20.279 0 0 1-6.78 4.245l137.6 219.416a4 4 0 1 0 6.777-4.25zM96 0C73.909 0 56 17.909 56 40s17.909 40 40 40 40-17.909 40-40S118.091 0 96 0z"]
  },
      sa = {
    prefix: "fal",
    iconName: "blinds",
    icon: [512, 512, [], "f8fb", "M500.48,352h-33l8,32H36.5l8-32h-33l-11,44.12A16,16,0,0,0,16,416H496a16,16,0,0,0,15.52-19.88Zm0,96h-33l8,32H36.5l8-32h-33l-11,44.12A16,16,0,0,0,16,512H496a16,16,0,0,0,15.52-19.88ZM496,0H16A16,16,0,0,0,0,16V80A16,16,0,0,0,16,96H128v96H36.5l16-64h-33l-19,76.12A16,16,0,0,0,16,224H128v34.94A47.82,47.82,0,0,0,98.94,288H36.5l8-32h-33l-11,44.12A16,16,0,0,0,16,320H98.94A47.89,47.89,0,1,0,160,258.94V96H496a16,16,0,0,0,16-16V16A16,16,0,0,0,496,0ZM144,320a16,16,0,1,1,16-16A16,16,0,0,1,144,320ZM480,64H32V32H480Zm12.48,64h-33l16,64H192v32H496a16,16,0,0,0,15.52-19.88Zm8,128h-33l8,32H222.39a80.31,80.31,0,0,1,0,32H496a16,16,0,0,0,15.52-19.88Z"]
  },
      ua = {
    prefix: "fal",
    iconName: "blinds-open",
    icon: [512, 512, [], "f8fc", "M496,480H16a16,16,0,0,0,0,32H496a16,16,0,0,0,0-32ZM16,352H80.36a79.29,79.29,0,0,1-14.75-32H16a16,16,0,0,0,0,32Zm480-32H222.39a79.29,79.29,0,0,1-14.75,32H496a16,16,0,0,0,0-32ZM496,0H16A16,16,0,0,0,0,16V80A16,16,0,0,0,16,96H128v64H16a16,16,0,0,0,0,32H128v66.94a48,48,0,1,0,32,0V96H496a16,16,0,0,0,16-16V16A16,16,0,0,0,496,0ZM144,320a16,16,0,1,1,16-16A16,16,0,0,1,144,320ZM480,64H32V32H480Zm16,96H192v32H496a16,16,0,0,0,0-32Z"]
  },
      ha = {
    prefix: "fal",
    iconName: "blinds-raised",
    icon: [512, 512, [], "f8fd", "M500.48,224h-33l8,32H192v32H496a16,16,0,0,0,15.52-19.88Zm0-96h-33l8,32H192v32H496a16,16,0,0,0,15.52-19.88ZM496,0H16A16,16,0,0,0,0,16V80A16,16,0,0,0,16,96H128v64H36.5l8-32h-33l-11,44.12A16,16,0,0,0,16,192H128v64H36.5l8-32h-33l-11,44.12A16,16,0,0,0,16,288H128V418.94a48,48,0,1,0,32,0V96H496a16,16,0,0,0,16-16V16A16,16,0,0,0,496,0ZM144,480a16,16,0,1,1,16-16A16,16,0,0,1,144,480ZM480,64H32V32H480Z"]
  },
      ma = {
    prefix: "fal",
    iconName: "blog",
    icon: [512, 512, [], "f781", "M200.3 0c-4.5-.1-8.2 3.6-8.2 8.1V24c0 4.4 3.5 7.8 7.9 7.9C352.8 35.7 476 159.2 480 312c.1 4.4 3.6 7.9 7.9 7.9h16c4.5 0 8.2-3.7 8.1-8.2C507.7 141.8 370.2 4.3 200.3 0zm0 96c-4.5-.2-8.2 3.6-8.2 8.1v16c0 4.3 3.5 7.8 7.8 8 99.8 4 180.5 84.2 184.2 184 .2 4.3 3.6 7.8 8 7.8h15.8c4.5 0 8.2-3.7 8.1-8.2-4.3-117-98.7-211.4-215.7-215.7zM121 256h-9c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h10.9c47 0 88 38.4 84.9 85.3-2.6 39.9-34.6 71.8-74.4 74.5C86.4 467 48 426 48 378.9V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v233c0 74.2 60.1 138.5 134.3 134.9 65.6-3.2 118.4-56 121.6-121.6C259.4 316.1 195.2 256 121 256z"]
  },
      va = {
    prefix: "fal",
    iconName: "bold",
    icon: [384, 512, [], "f032", "M306 234.12c27.74-20.38 46-53.01 46-90.12A112 112 0 0 0 240 32H40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v384H40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h216a128 128 0 0 0 50-245.88zM96 64h144a80 80 0 0 1 0 160H96zm160 384H96V256h160a96 96 0 0 1 0 192z"]
  },
      da = {
    prefix: "fal",
    iconName: "bolt",
    icon: [320, 512, [], "f0e7", "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.3 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36zM140.3 436.9l33.5-141.6 9.3-39.4h-150L63 32h125.9l-38.7 118-13.8 42h145.7L140.3 436.9z"]
  },
      Ma = {
    prefix: "fal",
    iconName: "bomb",
    icon: [512, 512, [], "f1e2", "M420.7 68.7l-56 56-38.1-38.1c-12.5-12.5-32.8-12.5-45.3 0l-17.1 17.1c-17.9-5-36.8-7.7-56.3-7.7C96 96 3.3 185.9.1 297.8-3.3 415.5 91.1 512 208 512c115.1 0 208-94.2 208-208 0-19.5-2.7-38.4-7.7-56.3l17.1-17.1c12.5-12.5 12.5-32.8 0-45.3l-38.1-38.1 56-56-22.6-22.5zm-48.3 169.6c5.8 20.5 11.6 37.8 11.6 65.7 0 96.2-78.5 176-176 176-24.2 0-47.7-4.8-69.7-14.3-65.2-28.2-108.4-93.4-106.2-167C34.8 204.1 113.2 128 208 128c27.9 0 45.1 5.8 65.7 11.6l30.3-30.3 98.7 98.7s-1.8 1.9-30.3 30.3zM512 72c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12s5.4-12 12-12h24c6.6 0 12 5.4 12 12zm-60-60v24c0 6.6-5.4 12-12 12s-12-5.4-12-12V12c0-6.6 5.4-12 12-12s12 5.4 12 12zm5 43c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0 4.7 4.7 4.7 12.3 0 17l-17 17c-4.7 4.7-12.3 4.7-17 0zm-67.9-16.9c-4.7-4.7-4.7-12.3 0-17 4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17-4.7 4.7-12.3 4.7-17 0l-17-17zm101.8 67.8c4.7 4.7 4.7 12.3 0 17-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17 4.7-4.7 12.3-4.7 17 0l17 17zM192 192c0 8.8-7.2 16-16 16-35.3 0-64 28.7-64 64 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-52.9 43.1-96 96-96 8.8 0 16 7.2 16 16z"]
  },
      pa = {
    prefix: "fal",
    iconName: "bone",
    icon: [640, 512, [], "f5d7", "M600.44 256c28.89-17.75 39.56-44.34 39.56-77.05C640 133.22 601.97 96 555.19 96c-36.5 0-68.81 22.75-80.41 56.59C467.19 175.22 467.57 176 456 176H184c-11.57 0-11.19-.78-18.78-23.41C153.62 118.75 121.31 96 84.81 96 38.03 96 0 133.22 0 178.95c0 32.71 10.67 59.3 39.56 77.05C10.67 273.75 0 300.34 0 333.05 0 378.78 38.03 416 84.81 416c36.5 0 68.81-22.75 80.41-56.59C172.81 336.78 172.43 336 184 336h272c11.57 0 11.19.78 18.78 23.41 11.59 33.84 43.91 56.59 80.41 56.59 46.78 0 84.81-37.22 84.81-82.95 0-32.71-10.67-59.3-39.56-77.05zm-45.25 128c-22.81 0-42.97-14.05-50.16-34.97C496.13 322.4 488.47 304 456 304H184c-32.47 0-40.13 18.4-49.03 45.03-7.19 20.92-27.35 34.97-50.16 34.97C55.69 384 32 361.14 32 333.05c0-23.44 6.88-41.59 29.03-52.36v-.02c9.59-4.66 15.53-14.12 15.53-24.67s-5.94-20.02-15.53-24.67v-.02C38.88 220.54 32 202.39 32 178.95 32 150.86 55.69 128 84.81 128c22.81 0 42.97 14.05 50.16 34.97C143.87 189.6 151.53 208 184 208h272c32.47 0 40.13-18.4 49.03-45.03 7.19-20.92 27.34-34.97 50.16-34.97 29.12 0 52.81 22.86 52.81 50.95 0 23.44-6.88 41.59-29.03 52.36v.02c-9.59 4.66-15.53 14.12-15.53 24.67s5.94 20.02 15.53 24.67v.02c22.15 10.77 29.03 28.92 29.03 52.36 0 28.09-23.69 50.95-52.81 50.95z"]
  },
      za = {
    prefix: "fal",
    iconName: "bone-break",
    icon: [640, 512, [], "f5d8", "M600.44 160C629.33 142.25 640 115.66 640 82.95 640 37.22 601.97 0 555.19 0c-36.5 0-68.81 22.75-80.41 56.59C467.19 79.22 467.57 80 456 80h-88c-17.67 0-32 14.33-32 32h120c32.47 0 40.13-18.4 49.03-45.03C512.22 46.05 532.37 32 555.19 32 584.31 32 608 54.86 608 82.95c0 23.44-6.88 41.59-29.03 52.36v.02c-9.59 4.66-15.53 14.13-15.53 24.67 0 10.55 5.94 20.02 15.53 24.67v.02c22.15 10.77 29.03 28.92 29.03 52.36 0 28.09-23.69 50.95-52.81 50.95-22.81 0-42.97-14.05-50.16-34.97C496.13 226.4 488.47 208 456 208h-56c-17.67 0-32 14.33-32 32h88c11.57 0 11.19.78 18.78 23.41 11.59 33.84 43.91 56.59 80.41 56.59 46.78 0 84.81-37.22 84.81-82.95 0-32.71-10.67-59.3-39.56-77.05zM327.26 297.88c-12.5-12.5-32.76-12.5-45.26 0l-39.6 39.6c-22.96 22.96-15.36 41.39-2.83 66.51 9.71 19.88 5.39 44.06-10.74 60.19-20.6 20.59-53.51 21.18-73.37 1.31-16.58-16.58-24.55-34.27-16.5-57.55l-.01-.01c3.49-10.08.99-20.97-6.46-28.43-7.46-7.46-18.35-9.96-28.43-6.46l-.01-.01c-23.28 8.05-40.98.08-57.55-16.5-19.87-19.87-19.28-52.78 1.31-73.37 16.13-16.13 40.32-20.45 60.19-10.74 25.13 12.53 43.55 20.13 66.51-2.83l84.85-84.85c-12.5-12.5-32.76-12.5-45.25 0l-62.23 62.22c-8.18 8.18-8.47 7.36-29.83-3.27-32.11-15.73-71.05-8.97-96.85 16.84-33.08 33.08-33.65 86.29-1.32 118.63 23.13 23.13 49.48 34.38 82.46 26.51-7.88 32.98 3.38 59.33 26.51 82.46 32.34 32.34 85.55 31.77 118.63-1.31 25.81-25.81 32.57-64.74 16.84-96.87-10.63-21.36-11.45-21.65-3.27-29.83l62.21-62.24z"]
  },
      Ca = {
    prefix: "fal",
    iconName: "bong",
    icon: [448, 512, [], "f55c", "M445.66 224.57l-62.22-62.23c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l19.8 19.8-48.57 48.57c-12.91-13.79-27.58-25.91-44.04-35.44V32h24c4.42 0 8-3.58 8-8V8c0-4.42-3.58-8-8-8H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h24v185.9C38.67 251.11 0 312.97 0 384c0 43.81 14.8 84.07 39.52 116.35C45.34 507.96 54.73 512 64.31 512h255.37c9.58 0 18.97-4.04 24.79-11.65C369.21 468.07 384 427.8 384 384c0-39.04-11.99-75.08-32.03-105.35l51.26-51.26 19.8 19.8c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31a7.994 7.994 0 0 0 .01-11.31zm-333.62 21.02l15.96-9.24V32h128v204.34l15.96 9.24c29.93 17.34 52.83 43.73 66.35 74.41H45.69c13.52-30.68 36.42-57.07 66.35-74.4zM319.69 480l-254.76.89C43.38 452.77 32 419.26 32 384c0-10.88 1.46-21.54 3.63-32h312.75c2.17 10.46 3.63 21.12 3.63 32-.01 35.27-11.39 68.77-32.32 96z"]
  },
      La = {
    prefix: "fal",
    iconName: "book",
    icon: [448, 512, [], "f02d", "M356 160H188c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12zm12 52v-8c0-6.6-5.4-12-12-12H188c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12zm64.7 268h3.3c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H80c-44.2 0-80-35.8-80-80V80C0 35.8 35.8 0 80 0h344c13.3 0 24 10.7 24 24v368c0 10-6.2 18.6-14.9 22.2-3.6 16.1-4.4 45.6-.4 65.8zM128 384h288V32H128v352zm-96 16c13.4-10 30-16 48-16h16V32H80c-26.5 0-48 21.5-48 48v320zm372.3 80c-3.1-20.4-2.9-45.2 0-64H80c-64 0-64 64 0 64h324.3z"]
  },
      Aa = {
    prefix: "fal",
    iconName: "book-alt",
    icon: [448, 512, [], "f5d9", "M448 392V24c0-13.3-10.7-24-24-24H80C35.8 0 0 35.8 0 80v368c0 35.35 28.65 64 64 64h372c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-3.3c-4-20.2-3.2-49.7.4-65.8 8.7-3.6 14.9-12.2 14.9-22.2zm-43.7 88H64c-17.67 0-32-14.33-32-32s14.33-32 32-32h340.3c-2.9 18.8-3.1 43.6 0 64zm11.7-96H64c-11.72 0-22.55 3.38-32 8.88V80c0-26.5 21.5-48 48-48h336v352z"]
  },
      Na = {
    prefix: "fal",
    iconName: "book-dead",
    icon: [448, 512, [], "f6b7", "M216 160c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-88 43.4V216c0 13.2 10.8 24 24 24h80c13.2 0 24-10.8 24-24v-12.6c20.4-15.1 32-36.4 32-59.4 0-44.1-43.1-80-96-80s-96 35.9-96 80c0 23 11.6 44.3 32 59.4zM240 96c35.3 0 64 21.5 64 48 0 14.3-8.8 27.9-24.3 37.2l-7.7 4.7V208h-64v-22.1l-7.7-4.7c-15.4-9.3-24.3-22.9-24.3-37.2 0-26.5 28.7-48 64-48zm208 296V24c0-13.3-10.7-24-24-24H80C35.8 0 0 35.8 0 80v368c0 35.3 28.7 64 64 64h372c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-3.3c-4-20.2-3.2-49.7.4-65.8 8.7-3.6 14.9-12.2 14.9-22.2zm-43.7 88H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h340.3c-2.9 18.8-3.1 43.6 0 64zm11.7-96H64c-11.7 0-22.5 3.4-32 8.9V80c0-26.5 21.5-48 48-48h336zm-291.2-51.6l6.3 14.7c1.7 4.1 6.4 5.9 10.5 4.2l98.3-42.2 98.4 42.1c4.1 1.7 8.8-.1 10.5-4.2l6.3-14.7c1.7-4.1-.1-8.8-4.2-10.5l-70.3-30.1 70.3-30.2c4.1-1.7 5.9-6.4 4.2-10.5l-6.3-14.7c-1.7-4.1-6.4-5.9-10.5-4.2L240 274.4l-98.3-42.1c-4.1-1.7-8.8.1-10.5 4.2l-6.3 14.7c-1.7 4.1.1 8.8 4.2 10.5l70.3 30.2-70.4 30c-4 1.8-5.9 6.5-4.2 10.5z"]
  },
      ga = {
    prefix: "fal",
    iconName: "book-heart",
    icon: [448, 512, [], "f499", "M230.1 307.9c5.5 5.5 14.3 5.5 19.8 0l84.7-85.6c24.6-24.9 23.2-66.1-4.3-89.1-13.9-11.6-47.7-28.5-90.2 14.5-42.6-43-76.4-26.1-90.2-14.5-27.5 23-28.9 64.2-4.3 89.1l84.5 85.6zm-59.8-150.1c13.7-11.5 31.2-3.4 38.4 3.7l31.4 31.7 31.4-31.7c7.1-7.2 24.6-15.2 38.4-3.7 14.4 12 12.3 31.6 2.1 42l-72 72.6-71.8-72.6c-10.3-10.4-12.3-30 2.1-42zM448 392V24c0-13.3-10.7-24-24-24H80C35.8 0 0 35.8 0 80v368c0 35.3 28.7 64 64 64h372c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-3.3c-4-20.2-3.2-49.7.4-65.8 8.7-3.6 14.9-12.2 14.9-22.2zm-43.7 88H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h340.3c-2.9 18.8-3.1 43.6 0 64zm11.7-96H64c-11.7 0-22.5 3.4-32 8.9V80c0-26.5 21.5-48 48-48h336v352z"]
  },
      Ha = {
    prefix: "fal",
    iconName: "book-medical",
    icon: [448, 512, [], "f7e6", "M448 392V24a23.94 23.94 0 0 0-24-24H80A80 80 0 0 0 0 80v368a64 64 0 0 0 64 64h372a12 12 0 0 0 12-12v-8a12 12 0 0 0-12-12h-3.3c-4-20.2-3.2-49.7.4-65.8A24.1 24.1 0 0 0 448 392zm-43.7 88H64a32 32 0 0 1 0-64h340.3a228.6 228.6 0 0 0 0 64zm11.7-96H64a63.33 63.33 0 0 0-32 8.88V80a48 48 0 0 1 48-48h336zM152 240h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8z"]
  },
      Va = {
    prefix: "fal",
    iconName: "book-open",
    icon: [576, 512, [], "f518", "M514.91 32h-.16c-24.08.12-144.75 8.83-219.56 48.09-4.05 2.12-10.33 2.12-14.38 0C205.99 40.83 85.32 32.12 61.25 32h-.16C27.4 32 0 58.47 0 91.01v296.7c0 31.41 25.41 57.28 57.85 58.9 34.77 1.76 122.03 8.26 181.89 30.37 5.27 1.95 10.64 3.02 16.25 3.02h64c5.62 0 10.99-1.08 16.26-3.02 59.87-22.11 147.12-28.61 181.92-30.37 32.41-1.62 57.82-27.48 57.82-58.89V91.01C576 58.47 548.6 32 514.91 32zM272 433c0 8.61-7.14 15.13-15.26 15.13-1.77 0-3.59-.31-5.39-.98-62.45-23.21-148.99-30.33-191.91-32.51-15.39-.77-27.44-12.6-27.44-26.93V91.01c0-14.89 13.06-27 29.09-27 19.28.1 122.46 7.38 192.12 38.29 11.26 5 18.64 15.75 18.66 27.84l.13 100.32V433zm272-45.29c0 14.33-12.05 26.16-27.45 26.93-42.92 2.18-129.46 9.3-191.91 32.51-1.8.67-3.62.98-5.39.98-8.11 0-15.26-6.52-15.26-15.13V230.46l.13-100.32c.01-12.09 7.4-22.84 18.66-27.84 69.66-30.91 172.84-38.19 192.12-38.29 16.03 0 29.09 12.11 29.09 27v296.7z"]
  },
      xa = {
    prefix: "fal",
    iconName: "book-reader",
    icon: [512, 512, [], "f5da", "M459.91 192.02c-.7 0-1.39.02-2.06.05-49.8 2.84-140.51 13-201.84 47.57-61.33-34.57-152.05-44.73-201.84-47.57-.67-.04-1.36-.05-2.06-.05C31.71 192.01 0 206.36 0 242.22v178.05c0 26.69 21.25 48.7 48.34 50.12 34.41 1.81 120.56 9.08 177 37.47 4.68 2.37 9.66 3.5 14.66 3.84v.27h2.27c.09 0 .18.03.26.03h26.94c.09 0 .18-.03.26-.03H272v-.27c5-.34 9.98-1.48 14.66-3.84 56.44-28.39 142.59-35.65 177-37.47 27.09-1.42 48.34-23.44 48.34-50.12V242.22c0-35.86-31.71-50.2-52.09-50.2zM240 479.35c-.09-.04-.18-.02-.28-.07-59.59-29.97-144.43-38.45-189.7-40.84-10.1-.53-18.02-8.51-18.02-18.17V242.22c0-6.05 1.77-10 5.93-13.2 4.47-3.44 10.47-5.01 14.4-5.01 37.01 2.11 129.27 10.58 187.67 43.36v211.98zm240-59.08c0 9.66-7.92 17.64-18.03 18.17-45.27 2.38-130.11 10.86-189.76 40.87-.07.04-.14.02-.22.05V267.37c58.39-32.79 150.66-41.25 187.51-43.35l.39-.01c.2 0 20.09.49 20.09 18.21v178.05zM256 191.99c53.02 0 96-42.98 96-95.99S309.02 0 256 0s-96 42.98-96 95.99 42.98 96 96 96zM256 32c35.29 0 64 28.71 64 64s-28.71 64-64 64-64-28.71-64-64 28.71-64 64-64z"]
  },
      wa = {
    prefix: "fal",
    iconName: "book-spells",
    icon: [448, 512, [], "f6b8", "M64 144c0 6.06 3.44 11.59 8.84 14.31l37.88 18.94 18.97 37.91c2.72 5.42 8.25 8.84 14.31 8.84s11.59-3.42 14.31-8.84l18.94-37.91 37.91-18.94c5.41-2.7 8.84-8.25 8.84-14.31s-3.44-11.61-8.84-14.31l-37.91-18.94-18.94-37.91C155.59 67.42 150.06 64 144 64s-11.59 3.42-14.31 8.84l-18.97 37.91-37.88 18.94C67.44 132.41 64 137.94 64 144zm65.81-7.02a16.15 16.15 0 0 0 7.16-7.16l7.03-14.05 7 14.05c1.56 3.09 4.06 5.61 7.16 7.16l14.03 7.02-14.03 7.02a16.15 16.15 0 0 0-7.16 7.16l-7 14.05-7.03-14.05a16.101 16.101 0 0 0-7.16-7.16L115.78 144l14.03-7.02zM192 256c0 6.06 3.44 11.59 8.84 14.31l48.56 24.28 24.28 48.56c2.72 5.42 8.25 8.84 14.31 8.84s11.59-3.42 14.31-8.84l24.28-48.56 48.56-24.28c5.41-2.72 8.84-8.25 8.84-14.31s-3.44-11.59-8.84-14.31l-48.56-24.28-24.28-48.56c-5.44-10.84-23.19-10.84-28.62 0l-24.28 48.56-48.56 24.28c-5.4 2.72-8.84 8.25-8.84 14.31zm76.5-12.36a16.15 16.15 0 0 0 7.16-7.16l12.34-24.7 12.34 24.7c1.56 3.09 4.06 5.61 7.16 7.16L332.22 256l-24.72 12.36a16.15 16.15 0 0 0-7.16 7.16L288 300.22l-12.34-24.7a16.101 16.101 0 0 0-7.16-7.16L243.78 256l24.72-12.36zM448 392V24c0-13.3-10.7-24-24-24H80C35.8 0 0 35.8 0 80v368c0 35.35 28.65 64 64 64h372c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-3.3c-4-20.2-3.2-49.7.4-65.8 8.7-3.6 14.9-12.2 14.9-22.2zm-43.7 88H64c-17.67 0-32-14.33-32-32s14.33-32 32-32h340.3c-2.9 18.8-3.1 43.6 0 64zm11.7-96H64c-11.72 0-22.55 3.38-32 8.88V80c0-26.5 21.5-48 48-48h336v352z"]
  },
      ya = {
    prefix: "fal",
    iconName: "book-user",
    icon: [448, 512, [], "f7e7", "M240 224a80 80 0 1 0-80-80 80.09 80.09 0 0 0 80 80zm0-128a48 48 0 1 1-48 48 48.05 48.05 0 0 1 48-48zm208 296V24a23.94 23.94 0 0 0-24-24H80A80 80 0 0 0 0 80v368a64 64 0 0 0 64 64h372a12 12 0 0 0 12-12v-8a12 12 0 0 0-12-12h-3.3c-4-20.2-3.2-49.7.4-65.8A24.1 24.1 0 0 0 448 392zm-43.7 88H64a32 32 0 0 1 0-64h340.3a228.6 228.6 0 0 0 0 64zm11.7-96H64a63.33 63.33 0 0 0-32 8.88V80a48 48 0 0 1 48-48h336zm-265.59-32h179.18C349 352 368 339 368 313.59 368 273 330.69 240 284.81 240c-21.5 2.38-22.6 8-44.81 8s-23.31-5.58-44.81-8c-45.88 0-83.19 33-83.19 73.59C112 339 131 352 150.41 352zm44.78-80c4.66 0 18.43 8 44.81 8s40.15-8 44.81-8C313 272 336 290.66 336 313.59c0 3.22.41 6.41-6.41 6.41H150.41c-6.82 0-6.41-3.19-6.41-6.41 0-22.93 23-41.59 51.19-41.59z"]
  },
      ba = {
    prefix: "fal",
    iconName: "bookmark",
    icon: [384, 512, [], "f02e", "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm16 456.287l-160-93.333-160 93.333V48c0-8.822 7.178-16 16-16h288c8.822 0 16 7.178 16 16v408.287z"]
  },
      Sa = {
    prefix: "fal",
    iconName: "books",
    icon: [576, 512, [], "f5db", "M575.33 456.43L399 8.02C397.28 3.1 392.61 0 387.65 0c-3.01 0-4.97 1.03-11.49 3.31-6.46 2.26-9.82 8.24-6.27 18.38-16.46 9.69-59.15 24.09-75.5 26.42-1.33-3.78-1.97-6.62-6.4-9.23V32c0-17.67-14.33-32-32-32h-96c-5.96 0-11.22 2.07-16 4.9C139.22 2.07 133.96 0 128 0H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h96c5.96 0 11.22-2.07 16-4.9 4.78 2.84 10.04 4.9 16 4.9h96c17.67 0 32-14.33 32-32V118.88l151.43 385.1c1.73 4.92 6.4 8.02 11.35 8.02 3 0 4.96-1.03 11.49-3.31 6.44-2.25 9.83-8.23 6.27-18.38 16.46-9.69 59.15-24.09 75.5-26.42 3.65 10.4 10.13 12.65 16.38 10.46l7.55-2.64c6.23-2.19 9.54-9.07 7.36-15.28zM128 480H32v-64h96v64zm0-96H32V128h96v256zm0-288H32V32h96v64zm128 384h-96v-64h96v64zm0-96h-96V128h96v256zm0-288h-96V32h96v64zm203.15 367.54L303.79 74.88c25.22-4.74 64.01-20.33 75.5-26.42l155.36 388.65c-25.23 4.75-64.01 20.33-75.5 26.43z"]
  },
      Ta = {
    prefix: "fal",
    iconName: "books-medical",
    icon: [640, 512, [], "f7e8", "M639.33 456.43L463 8a12 12 0 0 0-11.35-8c-3 0-5 1-11.49 3.31s-9.82 8.24-6.27 18.38c-16.46 9.69-59.15 24.09-75.5 26.42-1.33-3.78-2-6.62-6.4-9.23V32A32 32 0 0 0 320 0h-96c-6 0-11.22 2.07-16 4.9-4.78-2.83-10-4.9-16-4.9H96a32 32 0 0 0-32 32v77.56a158.67 158.67 0 0 1 32-10.33V32h96v77.56a159.52 159.52 0 0 1 32 19.25V128h96v256h-96v-.81a159.52 159.52 0 0 1-32 19.25V480H96v-67.23a158.67 158.67 0 0 1-32-10.33V480a32 32 0 0 0 32 32h96c6 0 11.22-2.07 16-4.9 4.78 2.84 10 4.9 16 4.9h96a32 32 0 0 0 32-32V118.88L503.43 504a12.06 12.06 0 0 0 11.35 8c3 0 5-1 11.49-3.31s9.83-8.23 6.27-18.38c16.46-9.69 59.15-24.09 75.5-26.42 3.65 10.4 10.13 12.65 16.38 10.46l7.55-2.64a12 12 0 0 0 7.36-15.28zM320 480h-96v-64h96zm0-384h-96V32h96zm203.15 367.54L367.79 74.88c25.22-4.74 64-20.33 75.5-26.42l155.36 388.65c-25.23 4.75-64.01 20.33-75.5 26.43zM256 256a128 128 0 1 0-128 128 128 128 0 0 0 128-128zm-224 0a96 96 0 1 1 96 96 96 96 0 0 1-96-96zm117.33 58.67v-37.34h37.34A5.33 5.33 0 0 0 192 272v-32a5.33 5.33 0 0 0-5.33-5.33h-37.34v-37.34A5.33 5.33 0 0 0 144 192h-32a5.33 5.33 0 0 0-5.33 5.33v37.34H69.33A5.33 5.33 0 0 0 64 240v32a5.33 5.33 0 0 0 5.33 5.33h37.34v37.34A5.33 5.33 0 0 0 112 320h32a5.33 5.33 0 0 0 5.33-5.33z"]
  },
      Da = {
    prefix: "fal",
    iconName: "boombox",
    icon: [640, 512, [], "f8a5", "M176 224a112 112 0 1 0 112 112 112 112 0 0 0-112-112zm0 192a80 80 0 1 1 80-80 80.09 80.09 0 0 1-80 80zm288-192a112 112 0 1 0 112 112 112 112 0 0 0-112-112zm0 192a80 80 0 1 1 80-80 80.09 80.09 0 0 1-80 80zm128-256h-16V56a56.07 56.07 0 0 0-56-56H120a56.06 56.06 0 0 0-56 56v104H48a48 48 0 0 0-48 48v256a48 48 0 0 0 48 48h544a48 48 0 0 0 48-48V208a48 48 0 0 0-48-48zM96 56a24 24 0 0 1 24-24h400a24 24 0 0 1 24 24v104h-96v-16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16h-32v-16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16h-32v-16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16H96zm512 408a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V208a16 16 0 0 1 16-16h544a16 16 0 0 1 16 16zM464 304a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm-288 0a32 32 0 1 0 32 32 32 32 0 0 0-32-32z"]
  },
      ja = {
    prefix: "fal",
    iconName: "boot",
    icon: [512, 512, [], "f782", "M415 247.8L352 232V128c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32v434.7c0 8.5 3.4 16.6 9.4 22.6l13.3 13.3c6 6 14.1 9.4 22.6 9.4h37.5c8.5 0 16.6-3.4 22.6-9.4L128 480l22.6 22.6c6 6 14.1 9.4 22.6 9.4h37.5c8.5 0 16.6-3.4 22.6-9.4L256 480l22.6 22.6c6 6 14.1 9.4 22.6 9.4h37.5c8.5 0 16.6-3.4 22.6-9.4L384 480l22.6 22.6c6 6 14.1 9.4 22.6 9.4h37.5c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3c6-6 9.4-14.1 9.4-22.6v-94.8c0-58.7-40-109.9-97-124.1zM32 32h320v64H32V32zm448 434.7L466.7 480h-37.5l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4L338.7 480h-37.5l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4L210.7 480h-37.5l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4L82.7 480H45.3L32 466.7V416h448v50.7zm0-82.7H32V128h288v32h-88c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88v32h-88c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88l87.3 22.8c42.8 10.7 72.7 49 72.7 93.1V384z"]
  },
      Ea = {
    prefix: "fal",
    iconName: "booth-curtain",
    icon: [512, 512, [], "f734", "M0 32v472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V32h64v352c0 35.3 28.7 64 64 64 19.2 0 36.3-8.7 48-22.1 11.7 13.4 28.8 22.1 48 22.1s36.3-8.7 48-22.1c11.7 13.4 28.8 22.1 48 22.1s36.3-8.7 48-22.1c11.7 13.4 28.8 22.1 48 22.1 11.7 0 22.5-3.4 32-8.9V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zm416 0h64v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm-96 0h64v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm-96 0h64v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm-96 0h64v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V32z"]
  },
      ka = {
    prefix: "fal",
    iconName: "border-all",
    icon: [448, 512, [], "f84c", "M432 32H16A16 16 0 0 0 0 48v416a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM32 64h176v176H32zm0 384V272h176v176zm384 0H240V272h176zm0-208H240V64h176z"]
  },
      Ia = {
    prefix: "fal",
    iconName: "border-bottom",
    icon: [448, 512, [], "f84d", "M440 448H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM216 280h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0 96h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm-96-96h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0-200h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm192 200h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0-200h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm-96 104h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0-104h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zM16 80h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v16a16 16 0 0 0 16 16zm416 56h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-104h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 200h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 96h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM16 184h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0 96h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0 96h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16z"]
  },
      Oa = {
    prefix: "fal",
    iconName: "border-center-h",
    icon: [448, 512, [], "f89c", "M440 240H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM216 376h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zM120 80h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm192 0h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm-96 104h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0-104h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zM16 80h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v16a16 16 0 0 0 16 16zm416 56h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-104h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM120 480h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm192 0h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm-96 0h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm-200 0h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm416-48h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-104h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM16 184h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0 192h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16z"]
  },
      Qa = {
    prefix: "fal",
    iconName: "border-center-v",
    icon: [448, 512, [], "f89d", "M208 40v432a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8zm136 224v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16zM48 360v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16zm0-192v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16zm104 96v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16zm-104 0v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16zm0 200v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16zm56-416v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16zM0 48v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48zm448 312v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16zm0-192v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16zm0 96v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16zm0 200v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16zM400 48v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16zm-104 0v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16zM152 464v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16zm192 0v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16z"]
  },
      Za = {
    prefix: "fal",
    iconName: "border-inner",
    icon: [448, 512, [], "f84e", "M439 240H239V40a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v200H7a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h200v200a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V272h200a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM15 184h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H15a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm16 248H15a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM15 80h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H15A16 16 0 0 0-1 48v16a16 16 0 0 0 16 16zm16 248H15a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM311 80h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm-192 0h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm312 56h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM135 432h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM431 32h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 296h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM327 432h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm104 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"]
  },
      Ua = {
    prefix: "fal",
    iconName: "border-left",
    icon: [448, 512, [], "f84f", "M24 32H8a8 8 0 0 0-8 8v432a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8zm208 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 296h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-192h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 96h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM136 32h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 400h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-200h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm96 200h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm200-200h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-96h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-104h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM328 432h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm104-104h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 104h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM328 232h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-200h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Ba = {
    prefix: "fal",
    iconName: "border-none",
    icon: [448, 512, [], "f850", "M432 32h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM32 32H16A16 16 0 0 0 0 48v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm400 400h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-296h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 192h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-96h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-104 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM32 136H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm200 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 192h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-96h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM32 328H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm104 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM32 432H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm104 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm192 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-96 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM136 32h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm192 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-96 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Ra = {
    prefix: "fal",
    iconName: "border-outer",
    icon: [448, 512, [], "f851", "M216 185h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm96 96h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm-96 0h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm-96 0h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm96 96h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zM432 33H16A16 16 0 0 0 0 49v416a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V49a16 16 0 0 0-16-16zm-16 416H32V65h384z"]
  },
      Ya = {
    prefix: "fal",
    iconName: "border-right",
    icon: [448, 512, [], "f852", "M440 32h-16a8 8 0 0 0-8 8v432a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8zM136 432h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM32 32H16A16 16 0 0 0 0 48v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm104 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 200h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM32 328H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 104H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-200H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm200 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm96 96h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-200h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 400h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zM232 32h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 400h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-104h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-96h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"]
  },
      Pa = {
    prefix: "fal",
    iconName: "border-style",
    icon: [448, 512, [], "f853", "M440 32H16A16 16 0 0 0 0 48v424a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V64h408a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8zM232 432h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm96 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-192 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm296-200h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-96h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 296h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-104h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"]
  },
      Fa = {
    prefix: "fal",
    iconName: "border-style-alt",
    icon: [448, 512, [], "f854", "M439 32h-16a8 8 0 0 0-8 8v408H7a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h424a16 16 0 0 0 16-16V40a8 8 0 0 0-8-8zM15 80h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H15A16 16 0 0 0-1 48v16a16 16 0 0 0 16 16zm200 0h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm96 0h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm-192 0h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zM15 376h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H15a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0-96h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H15a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0-96h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H15a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16z"]
  },
      Wa = {
    prefix: "fal",
    iconName: "border-top",
    icon: [448, 512, [], "f855", "M440 32H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8zM32 136H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm200 192h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 104h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-96-200h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-104 0H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 200H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-104H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm104 104h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm296 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-200h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0 96h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-192h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-104 96h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-96 0h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm0-96h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm96 296h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"]
  },
      Ga = {
    prefix: "fal",
    iconName: "bow-arrow",
    icon: [512, 512, [], "f6b9", "M403.77 176.11l-23.47 23.47c50.46 78.99 46.83 182.75-11.62 257.82l-123.1-123.1-22.63 22.63L375.7 509.66c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31a7.985 7.985 0 0 0 0-11.31l-6.76-6.76c70.86-88.04 74.96-212.03 12.21-304.17zM155.08 289.04l22.63-22.63-123.1-123.1c75.07-58.44 178.83-62.08 257.82-11.62l23.47-23.47c-92.14-62.75-216.13-58.65-304.16 12.21l-6.77-6.77c-3.13-3.12-8.19-3.12-11.31 0L2.34 124.99a7.985 7.985 0 0 0 0 11.31l152.74 152.74zM496.36 0c-1.03 0-2.07.1-3.13.31l-128.6 25.72c-12.29 2.46-16.88 17.62-8.02 26.49l40.12 40.12-252.37 252.37-53.63-23.96a20.547 20.547 0 0 0-21.04 4.96L6.03 389.69c-10.8 10.8-6.46 29.2 8.04 34.04l55.66 18.55 18.55 55.65c2.99 8.98 11.19 14.06 19.57 14.06 5.14 0 10.36-1.92 14.47-6.03l63.67-63.67a20.56 20.56 0 0 0 4.97-21.04L167 367.63l252.37-252.37 40.13 40.12c3.16 3.16 7.12 4.61 11.02 4.61 7.04 0 13.88-4.72 15.46-12.63l25.71-128.59C513.67 8.86 505.96 0 496.36 0zM112.77 470.25l-12.7-38.09-5.06-15.18-15.18-5.06-38.09-12.7 44.93-44.93 49.09 21.93 21.93 49.09-44.92 44.94zm347.8-359.03l-59.79-59.78 74.73-14.95-14.94 74.73z"]
  },
      qa = {
    prefix: "fal",
    iconName: "bowling-ball",
    icon: [496, 512, [], "f436", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm-96-312c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112-32c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm-16 64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      Ja = {
    prefix: "fal",
    iconName: "bowling-pins",
    icon: [480, 512, [], "f437", "M475.2 312.2c-13-54.4-49.3-89.2-53.9-137.8-3.4-34.7 21.2-57.4 18.7-99.4-2.6-43.3-32.9-74.9-72-75-39.1.1-69.3 31.7-71.9 75-2.5 42 22 64.8 18.7 99.4-4.6 48.6-41 83.5-53.9 137.8-12.5 52.3.4 139.9 28.2 191.3l4.5 8.4h149l4.5-8.4c27.7-51.4 40.6-139 28.1-191.3zM408 76.9c1.7 28.6-16.1 49.3-18.7 83.1h-42.6c-2.6-33.9-20.5-54.4-18.7-83.1 3.6-60.1 76.4-60.1 80 0zm15.1 403H312.9c-21-45.2-31-118.7-21-160.3 10.7-44.8 41.9-77 52.1-127.7h48c10.2 50.7 41.4 82.9 52.1 127.7 9.9 41.7-.1 115.1-21 160.3zM165.3 174.5c-3.3-34.7 21.2-57.4 18.7-99.4-2.6-43.4-32.9-74.9-72-75-39.1 0-69.3 31.6-72 75-2.6 42 22 64.7 18.7 99.4-4.6 48.7-41 83.5-53.9 137.8-12.5 52.3.4 140 28.2 191.4l4.5 8.4h149l4.5-8.4c27.8-51.4 40.7-139 28.2-191.4-12.9-54.3-49.3-89.2-53.9-137.8zM152 77c1.7 28.7-16.1 49.1-18.7 83H90.7c-2.6-33.9-20.5-54.3-18.7-83 3.6-60.1 76.4-60.1 80 0zm15.1 403H56.9c-21-45.2-31-118.7-21-160.3 10.7-44.8 42-77 52.1-127.7h48c10.2 50.7 41.4 82.9 52.1 127.7 10 41.6 0 115.1-21 160.3z"]
  },
      Ka = {
    prefix: "fal",
    iconName: "box",
    icon: [512, 512, [], "f466", "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V199.8c0-5.2-.8-10.3-2.5-15.2zM32 199.8c0-1.7.3-3.4.8-5.1L83.4 42.9C85.6 36.4 91.7 32 98.6 32H240v168H32v-.2zM480 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V232h448v232zm0-264H272V32h141.4c6.9 0 13 4.4 15.2 10.9l50.6 151.8c.5 1.6.8 3.3.8 5.1v.2z"]
  },
      Xa = {
    prefix: "fal",
    iconName: "box-alt",
    icon: [448, 512, [], "f49a", "M447.9 176c0-10.6-2.6-21-7.6-30.3l-49.1-91.9c-4.3-13-16.5-21.8-30.3-21.8H87.1c-13.8 0-26 8.8-30.4 21.9L7.6 145.8c-5 9.3-7.6 19.7-7.6 30.3C.1 236.6 0 448 0 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32 0 0-.1-211.4-.1-272zm-87-112l50.8 96H286.1l-12-96h86.8zM192 192h64v64h-64v-64zm49.9-128l12 96h-59.8l12-96h35.8zM87.1 64h86.8l-12 96H36.3l50.8-96zM32 448s.1-181.1.1-256H160v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64h127.9c0 74.9.1 256 .1 256H32z"]
  },
      _a = {
    prefix: "fal",
    iconName: "box-ballot",
    icon: [576, 512, [], "f735", "M571.4 276.6l-51.3-128.2c-4.8-12.3-16.6-20.3-29.8-20.3h-42.2V32c0-17.7-14.3-32-32-32h-256c-17.7 0-32 14.3-32 32v96H86c-13.2 0-25 8.1-29.8 20.3L4.6 276.4C1.5 284 0 292.2 0 300.4l.3 179.4c-.1 17.7 14.3 32.2 32 32.2H544c17.7 0 32.1-14.4 32-32.2V300.3c0-8.1-1.6-16.2-4.6-23.7zM160.2 32h256v192h-256V32zM86 160h42.2v64H104c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-23.8v-64h42.2l.1.2 51 127.8h-507L86 160zm458 320l-511.7-.2-.1-159.8H544v160z"]
  },
      $a = {
    prefix: "fal",
    iconName: "box-check",
    icon: [640, 512, [], "f467", "M492.5 133.4L458.9 32.8C452.4 13.2 434.1 0 413.4 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48h400c106 0 192-86 192-192 0-90.7-63-166.5-147.5-186.6zM272 32h141.4c6.9 0 13 4.4 15.2 10.9l28.5 85.5c-3-.1-6-.5-9.1-.5-56.8 0-107.7 24.8-142.8 64H272V32zM83.4 42.9C85.6 36.4 91.7 32 98.6 32H240v160H33.7L83.4 42.9zM48 480c-8.8 0-16-7.2-16-16V224h249.9c-16.4 28.3-25.9 61-25.9 96 0 66.8 34.2 125.6 86 160H48zm400 0c-88.2 0-160-71.8-160-160s71.8-160 160-160 160 71.8 160 160-71.8 160-160 160zm64.6-221.7c-3.1-3.1-8.1-3.1-11.2 0l-69.9 69.3-30.3-30.6c-3.1-3.1-8.1-3.1-11.2 0l-18.7 18.6c-3.1 3.1-3.1 8.1 0 11.2l54.4 54.9c3.1 3.1 8.1 3.1 11.2 0l94.2-93.5c3.1-3.1 3.1-8.1 0-11.2l-18.5-18.7z"]
  },
      cn = {
    prefix: "fal",
    iconName: "box-fragile",
    icon: [448, 512, [], "f49b", "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm24 392c0 13.2-10.8 24-24 24H56c-13.2 0-24-10.8-24-24V88c0-13.2 10.8-24 24-24h336c13.2 0 24 10.8 24 24v336zM304 96H144c-17.7 0-32 14.3-32 32v80c0 56.4 41.8 102.6 96 110.4V384h-40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-40v-65.6c54.2-7.8 96-54 96-110.4v-80c0-17.7-14.3-32-32-32zm0 112c0 44.1-35.9 80-80 80s-80-35.9-80-80v-80h68.8c2.3 6.7 4.8 13.3 7.3 19.9-7.9 8.1-36.3 38.4-36.3 38.4s47.6 34.8 67.2 43.8c2.6 1.2 5.7 1 8.2-.7 3.7-2.6 4.6-7.7 2-11.4-8.9-12.5-29.8-33.7-29.8-33.7L260 156s-9.1-22.1-11.6-28H304v80z"]
  },
      en = {
    prefix: "fal",
    iconName: "box-full",
    icon: [640, 512, [], "f49c", "M638.3 239.8L586.8 137c-2.8-5.6-8.5-9-14.6-9-1 0 4.3-.7-56.3 7l26.2-71.8c6-16.6-2.5-35-19.1-41L467.3 1.9c-16.5-6-34.9 2.5-41 19.1l-42.8 117.7C380.7 61.7 317.7 0 240 0 164.7 0 103.7 58 97.3 131.6 67.8 127.8 69 128 67.8 128c-6.1 0-11.8 3.5-14.6 9L1.7 239.8c-4.6 9.2.3 20.2 10.1 23L64 277.7V425c0 14.7 10 27.5 24.2 31l216.2 54.1c13.6 3.4 25 1.5 31 0L551.8 456c14.2-3.6 24.2-16.4 24.2-31V277.7l52.1-14.9c9.9-2.8 14.7-13.8 10.2-23zM456.4 32L512 52.2l-31.8 87.3-66 8.4L456.4 32zM38.8 237.3l38-76 190.4 24.3-60.1 99.8-168.3-48.1zM304 477L96 425V286.9C219.3 322.1 211 320 214.3 320c5.6 0 11-2.9 14-7.9L304 186.5V477zm16-317c-95.7-12.2-154.6-19.7-191.1-24.4C133.2 77.8 181.1 32 240 32c61.8 0 112 50.2 112 112 0 4.1-.6 8.1-1.1 12.1L320 160zm224 265l-208 52V186.5L411.7 312c3 5 8.4 7.9 14 7.9 3.3 0-5.2 2.1 118.3-33.1V425zM432.9 285.3l-60.1-99.8 190.4-24.3 38 76-168.3 48.1z"]
  },
      an = {
    prefix: "fal",
    iconName: "box-heart",
    icon: [448, 512, [], "f49d", "M447.9 176c0-10.6-2.6-21-7.6-30.3l-49.1-91.9c-4.3-13-16.5-21.8-30.3-21.8H87.1c-13.8 0-26 8.8-30.4 21.9L7.6 145.8c-5 9.3-7.6 19.7-7.6 30.3C.1 236.6 0 448 0 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32 0 0-.1-211.4-.1-272zM240 64h120.9l50.8 96H240V64zM87.1 64H208v96H36.3l50.8-96zM224 448H32s.1-181.1.1-256H416c0 74.9.1 256 .1 256H224zm90.2-210.8c-13.9-11.6-47.7-28.5-90.2 14.5-42.6-43-76.4-26.1-90.2-14.5-27.5 23-28.9 64.2-4.3 89.1l84.7 85.6c5.5 5.5 14.3 5.5 19.8 0l84.7-85.6c24.5-24.9 23-66.1-4.5-89.1zm-18.4 66.5L224 376.4l-71.8-72.6c-10.2-10.3-12.3-30 2.1-42 13.7-11.5 31.2-3.4 38.4 3.7l31.4 31.7 31.4-31.7c7.1-7.2 24.6-15.2 38.4-3.7 14.2 12 12.2 31.6 1.9 41.9z"]
  },
      nn = {
    prefix: "fal",
    iconName: "box-open",
    icon: [608, 512, [], "f49e", "M606.4 143.8L557.5 41c-2.7-5.6-8.1-9-13.9-9C543 32 304 64 304 64S65 32 64.4 32c-5.8 0-11.2 3.5-13.9 9L1.6 143.8c-4.4 9.2.3 20.2 9.6 23l49.5 14.9V393c0 14.7 9.5 27.5 23 31l205.4 54.1c13 3.4 23.7 1.5 29.5 0L524.2 424c13.5-3.6 23-16.4 23-31V181.7l49.5-14.9c9.4-2.8 14-13.8 9.7-23zM73 65.3l180.9 24.3-57.1 99.8-159.9-48.1 36.1-76zm18.2 125.6C208.3 226.1 200.5 224 203.6 224c5.4 0 10.5-2.9 13.3-7.9l71.9-125.5V445L91.2 393V190.9zM516.8 393l-197.6 52V90.5L391.1 216c2.9 5 8 7.9 13.3 7.9 3.1 0-5 2.1 112.4-33.1V393zM411.3 189.3l-57.1-99.8L535 65.3l36.1 76-159.8 48z"]
  },
      tn = {
    prefix: "fal",
    iconName: "box-tissue",
    icon: [512, 512, [], "e05b", "M464,224H405.33L448,96H338.6A70.2,70.2,0,0,1,272,48,70.19,70.19,0,0,0,205.4,0H64l49.78,224H48A48,48,0,0,0,0,272V464a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V272A48,48,0,0,0,464,224ZM103.89,32H205.4a38.15,38.15,0,0,1,36.24,26.12,102.07,102.07,0,0,0,97,69.88h65L350.27,288H160.78ZM480,464a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V416H480Zm0-80H32V272a16,16,0,0,1,16-16h72.89L128,288H112a16,16,0,0,0,0,32H400a16,16,0,0,0,0-32H384l10.67-32H464a16,16,0,0,1,16,16Z"]
  },
      rn = {
    prefix: "fal",
    iconName: "box-up",
    icon: [512, 512, [], "f49f", "M408 384H104c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM448 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 448c0 17.6-14.4 32-32 32H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v384zM108.5 202l35.5-44.4V312c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V157.6l35.5 44.4c4.6 5.8 14.5 8.8 22.5 2.5 6.9-5.5 8-15.6 2.5-22.5l-64-80c-6.1-7.6-18.9-7.6-25 0l-64 80c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5zm256-100c-6.1-7.6-18.9-7.6-25 0l-64 80c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l35.5-44.4V312c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V157.6l35.5 44.4c4.6 5.8 14.5 8.8 22.5 2.5 6.9-5.5 8-15.6 2.5-22.5l-64-80z"]
  },
      on = {
    prefix: "fal",
    iconName: "box-usd",
    icon: [448, 512, [], "f4a0", "M249.4 310.9l-41.6-12.5c-4.2-1.3-7.2-5.6-7.2-10.6 0-6 4.3-10.9 9.7-10.9h25.9c3.9 0 7.7 1.1 11 3.1 3.2 1.9 7.3 1.2 10-1.4l11.4-10.9c3.5-3.4 3.4-9.2-.5-12.1-8.2-6-18-9.6-28.1-10.3V232c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v13.4c-21.9 1.3-39.4 19.6-39.4 42.5 0 19 12.3 35.9 30 41.2l41.6 12.5c4.2 1.3 7.2 5.6 7.2 10.6 0 6-4.3 10.9-9.7 10.9h-25.9c-3.9 0-7.7-1.1-11-3.1-3.2-1.9-7.3-1.2-10 1.4l-11.4 10.9c-3.5 3.4-3.4 9.2.5 12.1 8.2 6 18 9.6 28.1 10.3V408c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-13.4c21.9-1.3 39.4-19.6 39.4-42.5 0-18.9-12.4-35.9-30-41.2zM447.9 176c0-10.6-2.6-21-7.6-30.3l-49.1-91.9c-4.3-13-16.5-21.8-30.3-21.8H87.1c-13.8 0-26 8.8-30.4 21.9L7.6 145.8c-5 9.3-7.6 19.7-7.6 30.3C.1 236.6 0 448 0 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32 0 0-.1-211.4-.1-272zM240 64h120.9l50.8 96H240V64zM87.1 64H208v96H36.3l50.8-96zM32 448s.1-181.1.1-256H416c0 74.9.1 256 .1 256H32z"]
  },
      ln = {
    prefix: "fal",
    iconName: "boxes",
    icon: [640, 512, [], "f468", "M624 224H480V16c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v208H16c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-176 32h64v62.3l-32-10.7-32 10.7V256zM352 32v62.3l-32-10.7-32 10.7V32h64zm-160 0h64v106.7l64-21.3 64 21.3V32h64v192H192V32zm0 224v62.3l-32-10.7-32 10.7V256h64zm-160 0h64v106.7l64-21.3 64 21.3V256h80v224H32V256zm576 224H336V256h80v106.7l64-21.3 64 21.3V256h64v224z"]
  },
      fn = {
    prefix: "fal",
    iconName: "boxes-alt",
    icon: [640, 512, [], "f4a1", "M624 224H480V16c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v208H16c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-112 32v64h-64v-64h64zM288 32h64v64h-64V32zm-96 0h64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V32h64v192H192V32zm-64 224h64v64h-64v-64zm176 224H32V256h64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64h80v224zm304 0H336V256h80v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64h64v224z"]
  },
      sn = {
    prefix: "fal",
    iconName: "boxing-glove",
    icon: [448, 512, [], "f438", "M252.4 360.8l7.2 14.3c2 4 .4 8.8-3.6 10.7L227.8 400l28.2 14.1c4 2 5.6 6.8 3.6 10.7l-7.2 14.3c-2 4-6.8 5.6-10.7 3.6L192 417.9l-49.7 24.8c-4 2-8.8.4-10.7-3.6l-7.2-14.3c-2-4-.4-8.8 3.6-10.7l28.2-14.1-28.2-14.1c-4-2-5.6-6.8-3.6-10.7l7.2-14.3c2-4 6.8-5.6 10.7-3.6l49.7 24.8 49.7-24.8c3.9-2 8.7-.4 10.7 3.5zm134 13.9L352 406.9V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-96l-17.1-96.5C5 227.6 0 166.6 0 106 0 47.6 47.2 0 105.2 0H280c57.3 0 104 47.6 104 106v43.6c37.2 12.6 64 45.9 64 85.4 0 52.8-21.9 102.4-61.6 139.7zm-21.9-23.4C397.7 320.2 416 278.9 416 235c0-32.5-28.7-59-64-59h-31.2c-26.3 0-48.3 20.8-48.8 47.1-.5 24.6 17.6 45.1 41.1 48.4 4 .6 6.9 4.1 6.9 8.1v16c0 4.7-4.1 8.5-8.8 8-40-4.4-71.2-38.4-71.2-79.5 0-11.4 2.5-22.2 6.8-32h-89.5c-30.6 0-59.5-10.9-82.3-30.8-3.5-3.1-3.7-8.4-.4-11.7l11.3-11.3c3-3 7.7-3.1 10.9-.4 16.9 14.4 38.1 22.3 60.5 22.3H272v.4c13.4-10.1 29.9-16.4 48-16.4h32v-38c0-41.5-31.6-74-72-74H105.2C64.8 32 32 65.2 32 106c0 149.6 31.7 252.5 31.8 278H88c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H63.8l.2 64h256v-64h-24c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h33.7l34.8-32.7z"]
  },
      un = {
    prefix: "fal",
    iconName: "brackets",
    icon: [448, 512, [], "f7e9", "M120 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h72a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H48a16 16 0 0 1-16-16V80a16 16 0 0 1 16-16h72a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8zm280 0h-72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h72a16 16 0 0 1 16 16v352a16 16 0 0 1-16 16h-72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h72a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"]
  },
      hn = {
    prefix: "fal",
    iconName: "brackets-curly",
    icon: [576, 512, [], "f7ea", "M571.31 244.69l-45.25-45.25A48 48 0 0 1 512 165.49V80a48 48 0 0 0-48-48h-72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h72a16 16 0 0 1 16 16v85.48a80 80 0 0 0 23.44 56.58L537.38 256l-33.94 33.94A80 80 0 0 0 480 346.52V432a16 16 0 0 1-16 16h-72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h72a48 48 0 0 0 48-48v-85.49a48 48 0 0 1 14.06-33.95l45.25-45.25a16 16 0 0 0 0-22.62zM184 32h-72a48 48 0 0 0-48 48v85.49a48 48 0 0 1-14.06 33.95L4.69 244.69a16 16 0 0 0 0 22.62l45.25 45.25A48 48 0 0 1 64 346.51V432a48 48 0 0 0 48 48h72a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-72a16 16 0 0 1-16-16v-85.48a80 80 0 0 0-23.44-56.58L38.62 256l33.94-33.94A80 80 0 0 0 96 165.48V80a16 16 0 0 1 16-16h72a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8z"]
  },
      mn = {
    prefix: "fal",
    iconName: "braille",
    icon: [640, 512, [], "f2a1", "M64 256c0 17.673-14.327 32-32 32S0 273.673 0 256s14.327-32 32-32 32 14.327 32 32zM32 400c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm0-336C14.327 64 0 78.327 0 96s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm160 176c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm0 160c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm0-336c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm256 176c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm0 160c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm0-336c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm160 176c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm0 160c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zm0-320c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16z"]
  },
      vn = {
    prefix: "fal",
    iconName: "brain",
    icon: [544, 512, [], "f5dc", "M509.6 230.3c17.5-54.5-20.1-93.2-41.1-105.3 2.7-37.7-25.9-74.3-66.7-79.4C390 18.2 362.8 0 332.2 0 307.6 0 286 11.9 272 29.9 258 11.9 236.4 0 211.8 0c-30.6 0-57.7 18.2-69.7 45.6-40.8 5.1-69.3 41.7-66.7 79.4-21 12.2-58.6 50.9-41.1 105.3C12.9 247.4 0 273.4 0 301c0 32.7 17.4 62.4 45.3 78.5-2.3 48.2 36.7 88.7 84.9 87.4 14.2 27.4 42.6 45 74.1 45 27.9 0 52.5-13.8 67.8-34.8 15.2 21 39.9 34.8 67.8 34.8 31.5 0 59.8-17.6 74-45 48.2 1.2 87.2-39.3 84.9-87.4 27.9-16.2 45.3-45.8 45.3-78.5-.1-27.6-13-53.6-34.5-70.7zM255.9 428.5c0 28.4-23.2 51.5-51.7 51.5-31.9 0-44.2-21.8-53.1-48.2-16.3 2.7-18.3 3.2-22.2 3.2-28.5 0-51.7-23.1-51.7-51.5 0-6.2.9-9.1 3.7-23C55.5 350 32.1 336.3 32.1 301c0-33.9 23-46.9 42.9-58.3-12.6-25.7-12.8-29.2-12.8-39.2 0-33.9 21.9-48.5 49.4-59.7-2.5-10.9-4.2-16.6-4.2-22.8 0-24.1 19.6-43.8 45.5-43.8h.4l12.7.3c5.9-22.9 15-45.5 45.8-45.5 24.3 0 44.2 19.7 44.2 44v352.5zm207.1-68c2.8 13.8 3.7 16.8 3.7 23 0 28.4-23.2 51.5-51.7 51.5-3.9 0-5.9-.5-22.2-3.2-8.9 26.4-21.2 48.2-53.1 48.2-28.5 0-51.7-23.1-51.7-51.5V76c0-24.3 19.8-44 44.2-44 30.7 0 39.9 22.5 45.8 45.5l12.7-.3h.4c25.9 0 45.5 19.7 45.5 43.8 0 6.2-1.7 11.9-4.2 22.8 27.5 11.2 49.4 25.8 49.4 59.7 0 10-.2 13.4-12.8 39.2 19.9 11.4 42.9 24.5 42.9 58.3 0 35.3-23.4 49-48.9 59.5z"]
  },
      dn = {
    prefix: "fal",
    iconName: "bread-loaf",
    icon: [640, 512, [], "f7eb", "M400 32H240C107.45 32 0 103.63 0 192c0 35.35 30.86 64 64 64v192a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V256c33.14 0 64-28.65 64-64 0-88.37-107.45-160-240-160zm-16 416H96V224H64c-15.44 0-32-14.36-32-32 0-69.38 95.25-128 208-128s208 58.62 208 128c0 17.64-12.56 32-28 32h-36zm160 0H416V256h128zm36-224H471.68a66.61 66.61 0 0 0 8.32-32c0-52.43-38-98.82-96.44-128H400c112.75 0 208 58.62 208 128 0 17.64-12.56 32-28 32z"]
  },
      Mn = {
    prefix: "fal",
    iconName: "bread-slice",
    icon: [576, 512, [], "f7ec", "M288 0C115.72 0 0 90.88 0 175.75c0 34 26.59 60.63 64 66.58v223.45C64 491.27 86.44 512 114 512h348c27.56 0 50-20.73 50-46.22V242.33c37.41-6 64-32.6 64-66.58C576 90.88 460.28 0 288 0zm208 211.56h-16v254.22c0 7.7-8.25 14.22-18 14.22H114c-9.75 0-18-6.52-18-14.22V211.56H80c-27.38 0-48-15.39-48-35.81C32 117 123.16 32 288 32s256 85 256 143.75c0 20.42-20.62 35.81-48 35.81z"]
  },
      pn = {
    prefix: "fal",
    iconName: "briefcase",
    icon: [512, 512, [], "f0b1", "M464 128H352V56c0-13.26-10.74-24-24-24H184c-13.26 0-24 10.74-24 24v72H48c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zM192 64h128v64H192V64zm288 368c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16V288h160v40c0 13.25 10.75 24 24 24h80c13.25 0 24-10.75 24-24v-40h160v144zM224 320v-32h64v32h-64zm256-64H32v-80c0-8.82 7.18-16 16-16h416c8.82 0 16 7.18 16 16v80z"]
  },
      zn = {
    prefix: "fal",
    iconName: "briefcase-medical",
    icon: [512, 512, [], "f469", "M344 288h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm120-160H352V56c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24v72H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 64h128v64H192V64zm288 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v288z"]
  },
      Cn = {
    prefix: "fal",
    iconName: "bring-forward",
    icon: [512, 512, [], "f856", "M352 304V48a48 48 0 0 0-48-48H48A48 48 0 0 0 0 48v256a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48zm-320 0V48a16 16 0 0 1 16-16h256a16 16 0 0 1 16 16v256a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16zm432-144h-80v32h80a16 16 0 0 1 16 16v256a16 16 0 0 1-16 16H208a16 16 0 0 1-16-16v-80h-32v80a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48V208a48 48 0 0 0-48-48zm-48 256H256v-32h-32v48a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16V240a16 16 0 0 0-16-16h-48v32h32z"]
  },
      Ln = {
    prefix: "fal",
    iconName: "bring-front",
    icon: [640, 512, [], "f857", "M32 208V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v16h32V48a48 48 0 0 0-48-48H48A48 48 0 0 0 0 48v160a48 48 0 0 0 48 48h80v-32H48a16 16 0 0 1-16-16zm448 160V144a48 48 0 0 0-48-48H208a48 48 0 0 0-48 48v224a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48zm-288 0V144a16 16 0 0 1 16-16h224a16 16 0 0 1 16 16v224a16 16 0 0 1-16 16H208a16 16 0 0 1-16-16zm400-112h-80v32h80a16 16 0 0 1 16 16v160a16 16 0 0 1-16 16H432a16 16 0 0 1-16-16v-16h-32v16a48 48 0 0 0 48 48h160a48 48 0 0 0 48-48V304a48 48 0 0 0-48-48zM464 448h96a16 16 0 0 0 16-16v-96a16 16 0 0 0-16-16h-48v32h32v64h-48.41a79.76 79.76 0 0 1-41.25 28.43A15.66 15.66 0 0 0 464 448zM176 64H80a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16h48v-32H96V96h48.41a79.76 79.76 0 0 1 41.25-28.43A15.66 15.66 0 0 0 176 64z"]
  },
      An = {
    prefix: "fal",
    iconName: "broadcast-tower",
    icon: [576, 512, [], "f519", "M40.55 0c-6.2 0-11.97 3.53-14.54 9.17C9.45 45.43 0 85.59 0 128c0 42.4 9.45 82.57 26.01 118.83 2.58 5.64 8.35 9.17 14.54 9.17 11.7 0 19.2-12.08 14.34-22.72C40.26 201.15 32 165.55 32 128s8.26-73.15 22.9-105.28C59.75 12.08 52.26 0 40.55 0zm285.89 178.84C341.87 167.14 352 148.81 352 128c0-35.3-28.72-64-64-64s-64 28.7-64 64c0 20.92 10.23 39.35 25.79 51.03l-137.13 315.4c-1.76 4.05.1 8.77 4.15 10.53l14.7 6.38c4.05 1.76 8.76-.1 10.52-4.15L209.51 352h157.3l67.47 155.19c1.76 4.05 6.47 5.91 10.52 4.15l14.7-6.38a8.005 8.005 0 0 0 4.15-10.53L326.44 178.84zM288 96c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zm-64.58 224l56.03-128.87c2.82.38 5.62.87 8.55.87 3.03 0 5.94-.49 8.86-.9L352.9 320H223.42zM118.99 192c10.7 0 18.1-10.24 15.15-20.53-3.97-13.82-6.14-28.38-6.14-43.47s2.17-29.65 6.14-43.47C137.09 74.24 129.69 64 118.99 64h-.15c-6.93 0-13.28 4.42-15.21 11.07C98.73 91.89 96 109.62 96 128s2.73 36.11 7.63 52.93c1.94 6.66 8.28 11.07 15.21 11.07h.15zM457.16 64h-.15c-10.7 0-18.1 10.24-15.15 20.53C445.83 98.35 448 112.91 448 128s-2.17 29.65-6.14 43.47c-2.95 10.29 4.45 20.53 15.15 20.53h.15c6.94 0 13.28-4.42 15.22-11.07 4.89-16.82 7.62-34.54 7.62-52.93s-2.73-36.11-7.62-52.93C470.44 68.42 464.09 64 457.16 64zm92.83-54.83C547.41 3.53 541.65 0 535.45 0c-11.7 0-19.19 12.08-14.34 22.72C535.74 54.85 544 90.45 544 128s-8.26 73.15-22.9 105.28c-4.85 10.65 2.64 22.72 14.34 22.72 6.2 0 11.97-3.53 14.54-9.17C566.56 210.57 576 170.4 576 128c0-42.41-9.44-82.57-26.01-118.83z"]
  },
      Nn = {
    prefix: "fal",
    iconName: "broom",
    icon: [640, 512, [], "f51a", "M638.26 15.53L628.3 3.02c-2.75-3.45-7.78-4.03-11.24-1.28L372.91 194.67l-45.44-57.08c-4.98-6.25-14.56-5.98-19.18.53l-48.62 68.59c-28.53.32-107.2 4.97-158.01 45.37C38.78 302.06 0 511.39 0 511.39c15.38.67 215.11 6.82 275.65-41.3 50.93-40.48 73.32-116.22 79.99-143.78l77.47-31.27c7.44-3 9.89-12.32 4.9-18.6l-45.17-56.75L636.98 26.76a7.985 7.985 0 0 0 1.28-11.23zM255.73 445.62c-26.7 21.22-109.44 34.4-215.93 34.4h-.6c4.06-17.75 8.96-36.82 14.4-55.92l68.79-54.68c4.96-3.94 1.22-11.88-4.97-10.57l-45.98 9.71c15.01-41.64 32.34-77.31 50.15-91.46 33.6-26.71 89.69-37.24 133.9-38.38l67.77 85.13c-7.19 27.54-27.17 89.69-67.53 121.77zm87.1-148.87l-56.94-71.53 28.4-40.47c2.3-3.28 7.11-3.43 9.61-.29l67.61 84.93c2.52 3.16 1.25 7.85-2.51 9.33l-46.17 18.03z"]
  },
      gn = {
    prefix: "fal",
    iconName: "browser",
    icon: [512, 512, [], "f37e", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM32 80c0-8.8 7.2-16 16-16h48v64H32V80zm448 352c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V160h448v272zm0-304H128V64h336c8.8 0 16 7.2 16 16v48z"]
  },
      Hn = {
    prefix: "fal",
    iconName: "brush",
    icon: [384, 512, [], "f55d", "M352 0H32C14.33 0 0 14.33 0 32v288c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64V32c0-17.67-14.33-32-32-32zm0 320c0 17.64-14.36 32-32 32h-96v96c0 17.64-14.36 32-32 32s-32-14.36-32-32v-96H64c-17.64 0-32-14.36-32-32v-32h320v32zm0-64H32V32h320v224z"]
  },
      Vn = {
    prefix: "fal",
    iconName: "bug",
    icon: [576, 512, [], "f188", "M544,272H480V150.627L523.314,107.314A16,16,0,0,0,500.686,84.687L457.373,128H415a127.00381,127.00381,0,1,0-254,0H118.627L75.314,84.687A16,16,0,1,0,52.686,107.314L96,150.627V272H32a16,16,0,0,0,0,32H96v24a174.98856,174.98856,0,0,0,30.484,98.889L68.687,484.686a15.99972,15.99972,0,1,0,22.627,22.627l55.616-55.616A175.45165,175.45165,0,0,0,272,504h32a175.45165,175.45165,0,0,0,125.07-52.303l55.616,55.616a15.99972,15.99972,0,0,0,22.627-22.627l-57.797-57.797A174.98856,174.98856,0,0,0,480,328V304h64a16,16,0,0,0,0-32ZM288,32.01263A95.99568,95.99568,0,0,1,383,128H193A95.99568,95.99568,0,0,1,288,32.01263ZM448,328c0,79.401-64.598,144-144,144V236a12.00052,12.00052,0,0,0-12-12h-8a12.00052,12.00052,0,0,0-12,12V472c-79.402,0-144-64.599-144-144V160H448Z"]
  },
      xn = {
    prefix: "fal",
    iconName: "building",
    icon: [448, 512, [], "f1ad", "M192 107v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12zm116-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-128 96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm128 0h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-128 96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm128 0h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm140 205v20H0v-20c0-6.627 5.373-12 12-12h20V24C32 10.745 42.745 0 56 0h336c13.255 0 24 10.745 24 24v456h20c6.627 0 12 5.373 12 12zm-64-12V32H64v448h128v-85c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v85h128z"]
  },
      wn = {
    prefix: "fal",
    iconName: "bullhorn",
    icon: [576, 512, [], "f0a1", "M544 184.88V32c0-8.74-6.98-32-31.99-32H512c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64l-.48 32c0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h106.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.12c19.05-11.09 32-31.49 32-55.12.01-23.63-12.94-44.03-31.99-55.12zM223.76 480l-105.89-.03c-14.83-30.56-22.35-62.19-22.36-95.49l.48-32L96 352h99.33c-2.31 10.7-3.81 21.43-3.81 32 0 35.29 11.3 68.78 32.24 96zM64 320c-17.64 0-32-14.36-32-32v-96c0-17.64 14.36-32 32-32h192v160H64zm448.05 126.93c-.04.25-.13.58-.25.9l-84.83-67.87C386.99 348 338.54 328.14 288 322.13V157.87c50.54-6.01 98.99-25.87 138.98-57.84l84.87-67.9c.03.03.06.05.08.05.04 0 .06-.05.07-.17l.05 414.92z"]
  },
      yn = {
    prefix: "fal",
    iconName: "bullseye",
    icon: [496, 512, [], "f140", "M248 92c-90.65 0-164 73.36-164 164 0 90.65 73.36 164 164 164 90.65 0 164-73.36 164-164 0-90.65-73.36-164-164-164zm0 296c-72.79 0-132-59.21-132-132s59.21-132 132-132 132 59.21 132 132-59.21 132-132 132zm0-212c-44.11 0-80 35.89-80 80s35.89 80 80 80 80-35.89 80-80-35.89-80-80-80zm0 128c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm0-296C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216z"]
  },
      bn = {
    prefix: "fal",
    iconName: "bullseye-arrow",
    icon: [496, 512, [], "f648", "M305.05 98.74l23.96 53.62-92.33 92.33c-6.25 6.25-6.25 16.38 0 22.62 3.12 3.12 7.22 4.69 11.31 4.69s8.19-1.56 11.31-4.69l92.33-92.33 53.62 23.96a20.547 20.547 0 0 0 21.04-4.96l63.67-63.67c10.8-10.8 6.46-29.2-8.04-34.04l-55.66-18.55-18.55-55.65C404.73 13.08 396.54 8 388.16 8c-5.14 0-10.36 1.92-14.47 6.03L310.02 77.7a20.582 20.582 0 0 0-4.97 21.04zm78.18-48.99l12.7 38.09 5.06 15.18 15.18 5.06 38.09 12.7-44.93 44.93-49.09-21.93-21.93-49.09 44.92-44.94zm101.2 131.35l-26.18 26.18c3.63 15.69 5.75 31.95 5.75 48.72 0 119.1-96.9 216-216 216S32 375.1 32 256 128.9 40 248 40c16.78 0 33.04 2.11 48.72 5.75l26.18-26.18A247.848 247.848 0 0 0 248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248c0-26.11-4.09-51.26-11.57-74.9zM274.7 108.85a53.056 53.056 0 0 1-2.68-14.44C264.12 93.25 256.23 92 248 92c-90.65 0-164 73.36-164 164 0 90.65 73.36 164 164 164 90.65 0 164-73.36 164-164 0-8.35-1.25-16.35-2.45-24.36-4.89-.21-9.76-.79-14.41-2.34-2.12-.71 1.02.62-20.69-9.07C377.7 231.68 380 243.52 380 256c0 72.79-59.21 132-132 132s-132-59.21-132-132 59.21-132 132-132c12.48 0 24.32 2.3 35.77 5.55-9.69-21.7-8.36-18.56-9.07-20.7zM248 176c-44.11 0-80 35.89-80 80s35.89 80 80 80 80-35.89 80-80c0-3.77-.61-7.38-1.11-11.01l-44.95 44.95-.01-.01c-8.7 8.69-20.7 14.07-33.93 14.07-26.47 0-48-21.53-48-48 0-13.23 5.38-25.23 14.07-33.93l-.01-.01 44.95-44.95c-3.63-.5-7.24-1.11-11.01-1.11z"]
  },
      Sn = {
    prefix: "fal",
    iconName: "bullseye-pointer",
    icon: [496, 512, [], "f649", "M241.5 240.7L20.83 303.41c-15.63 4.44-17.46 25.86-2.82 32.89l55.27 26.54-60.59 60.59c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c6.25 6.25 14.44 9.37 22.63 9.37s16.38-3.12 22.63-9.37l60.59-60.59 26.54 55.27c3.25 6.76 9.56 10.01 15.86 10.01 7.34 0 14.64-4.41 17.04-12.83l62.72-220.67c3.77-13.3-8.53-25.57-21.82-21.79zm-61.35 197.32l-29.7-61.85-92.51 92.51-22.62-22.62 92.51-92.51-61.84-29.71 159.5-45.33-45.34 159.51zM328 256c0-44.11-35.89-80-80-80-33.74 0-62.53 21.07-74.26 50.69C228.07 211.24 236.67 208 248 208c26.47 0 48 21.53 48 48 0 11.26-3.1 19.44-18.69 74.26C306.93 318.53 328 289.74 328 256zm-76.08 163.61C340.71 417.47 412 345.29 412 256c0-90.65-73.36-164-164-164-89.31 0-161.47 71.3-163.61 160.08l32.95-9.36C124.12 176.23 179.76 124 248 124c72.79 0 132 59.21 132 132 0 68.23-52.24 123.88-118.71 130.66l-9.37 32.95zM248 8C111.03 8 0 119.03 0 256c0 7.3.47 14.49 1.09 21.63 3.46-1.97 7-3.87 10.99-5l20.47-5.82c-.18-3.6-.55-7.16-.55-10.81 0-119.1 96.9-216 216-216s216 96.9 216 216-96.9 216-216 216c-3.65 0-7.21-.37-10.81-.55l-5.82 20.46c-1.14 4.02-3.15 7.5-5.14 10.98 7.19.63 14.42 1.1 21.77 1.1 136.97 0 248-111.03 248-248S384.97 8 248 8z"]
  },
      Tn = {
    prefix: "fal",
    iconName: "burger-soda",
    icon: [640, 512, [], "f858", "M640 376a55.65 55.65 0 0 0-18.46-41.26 58.81 58.81 0 0 0 7.37-77.49C594 208 523 176.06 448 176c-75 .06-146 32-180.88 81.25a58.8 58.8 0 0 0 7.36 77.49 55.14 55.14 0 0 0-4.78 77.52A43.79 43.79 0 0 0 256 444a68.08 68.08 0 0 0 68 68h248a68.08 68.08 0 0 0 68-68 43.79 43.79 0 0 0-13.68-31.74A55.49 55.49 0 0 0 640 376zM293.22 275.73C320 237.87 379 208.06 448 208s128 29.87 154.79 67.73C616 294.39 602.62 320 579.57 320H316.43c-23.04 0-36.43-25.62-23.21-44.27zM572 480H324a36 36 0 0 1-36-36 12 12 0 0 1 12-12h296a12 12 0 0 1 12 12 36 36 0 0 1-36 36zm12-80H312a24 24 0 0 1 0-48h272a24 24 0 0 1 0 48zM448 272a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm80 16a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-160 0a16 16 0 1 0-16-16 16 16 0 0 0 16 16zM95.89 479.11L63.89 160H344a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H212.5l24-96H280a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8h-43.5a32 32 0 0 0-31.06 24.25L179.5 128H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v1.68l32 320.61A31.88 31.88 0 0 0 96 512h155.11a99.79 99.79 0 0 1-20.18-32.14z"]
  },
      Dn = {
    prefix: "fal",
    iconName: "burn",
    icon: [384, 512, [], "f46a", "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zM98.9 385.2c0-13.3 4.2-61.2 93.1-161.2 88.9 100 93.1 147.9 93.1 161.2 0 48.5-28.9 84.1-72.4 92.7-6.8.8-13.5 2.1-20.7 2.1s-13.9-1.2-20.7-2.1c-43.5-8.5-72.4-44.2-72.4-92.7zm212 39.7c3.7-12.4 6.2-25.5 6.2-39.7 0-80.9-112.7-195.5-125.1-209.4-12.9 14.5-125.1 128.6-125.1 209.4 0 14.2 2.5 27.3 6.2 39.7-25.8-31.3-41.1-74-41.1-124.4 0-90.8 122.6-215.8 160-251.9 37.4 36 160 161.1 160 251.9 0 50.4-15.3 93.1-41.1 124.4z"]
  },
      jn = {
    prefix: "fal",
    iconName: "burrito",
    icon: [512, 512, [], "f7ed", "M512 123a74.13 74.13 0 0 0-52.26-70.74A74.05 74.05 0 0 0 358.12 6.73a80.49 80.49 0 0 0-106 41.57L34 266.45a116 116 0 0 0 0 164.05L81.5 478a116 116 0 0 0 164.05 0L463.7 259.87a80.49 80.49 0 0 0 41.57-106A73.46 73.46 0 0 0 512 123zM267.55 78.13A174.58 174.58 0 0 1 288 160c0 97.05-79 176-176 176a175.92 175.92 0 0 1-74.51-16.9 83.35 83.35 0 0 1 19.11-30zm-44.63 377.26a84 84 0 0 1-118.79 0L56.6 407.87a83.4 83.4 0 0 1-24.25-55.77A208.34 208.34 0 0 0 112 368c90.14 0 166.86-57.75 195.66-138.11A178.68 178.68 0 0 1 434 244.35zM480 186c0 15.34-7.34 28.66-18.4 37.58-43.1-26.72-95.33-36.5-144.84-28.19A207.56 207.56 0 0 0 320 160c0-39.14-11.29-76.52-31.77-109.4A48.16 48.16 0 0 1 326 32a48.65 48.65 0 0 1 32.84 12.86A41.94 41.94 0 0 1 431 74a42.4 42.4 0 0 1-.78 7.78A41.74 41.74 0 0 1 480 123a41.82 41.82 0 0 1-12.86 30.16A48.65 48.65 0 0 1 480 186z"]
  },
      En = {
    prefix: "fal",
    iconName: "bus",
    icon: [512, 512, [], "f207", "M128 384c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm256 0c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm104-256h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h48c17.67 0 32-14.33 32-32v-32h160v32c0 17.67 14.33 32 32 32h48c17.67 0 32-14.33 32-32v-32c17.67 0 32-14.33 32-32V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM144 480H96v-32h48v32zm272 0h-48v-32h48v32zm32-64H64l-.01-128h384.02L448 416zm.01-160H63.99l-.01-128h384.05l-.02 128zm.02-160H63.97V80.31C67.31 67 131.41 32 256 32s188.69 35 192.03 48.31V96z"]
  },
      kn = {
    prefix: "fal",
    iconName: "bus-alt",
    icon: [512, 512, [], "f55e", "M384 384c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-256 0c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm360-256h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h48c17.67 0 32-14.33 32-32v-32h160v32c0 17.67 14.33 32 32 32h48c17.67 0 32-14.33 32-32v-32c17.67 0 32-14.33 32-32V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zm-424.03 0H240v128H63.99l-.02-128zM144 480H96v-32h48v32zm272 0h-48v-32h48v32zm32-64H64l-.01-128h384.02L448 416zm.01-160H272V128h176.03l-.02 128zm.02-160H320v-8c0-13.26-10.75-24-24-24h-80c-13.25 0-24 10.74-24 24v8H63.97V80.31C67.31 67 131.41 32 256 32s188.69 35 192.03 48.31V96z"]
  },
      In = {
    prefix: "fal",
    iconName: "bus-school",
    icon: [512, 512, [], "f5dd", "M128 320c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm256 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96-192h-32V73.85C448 32.49 362.97 0 256 0S64 32.49 64 73.85V128H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h16.7C38.43 301.37 32 317.82 32 336v80c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h48c17.67 0 32-14.33 32-32v-32h160v32c0 17.67 14.33 32 32 32h48c17.67 0 32-14.33 32-32v-32c17.67 0 32-14.33 32-32v-80c0-18.18-6.43-34.63-16.7-48H480c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM256 32c102.96 0 156.91 30.59 160 41.85V96h-96v-8c0-13.26-10.75-24-24-24h-80c-13.25 0-24 10.74-24 24v8H95.96V74.21C99.09 62.59 153.04 32 256 32zm160 96v129.61a80.321 80.321 0 0 0-16-1.61H272V128h144zm-176 0v128H112c-5.48 0-10.83.57-16 1.61V128h144zM32 256v-96h32v96H32zm112 224H96v-32h48v32zm272 0h-48v-32h48v32zm32-64H64v-80c0-26.47 21.53-48 48-48h288c26.47 0 48 21.53 48 48v80zm32-160h-32v-96h32v96z"]
  },
      On = {
    prefix: "fal",
    iconName: "business-time",
    icon: [640, 512, [], "f64a", "M48 416c-8.82 0-16-7.18-16-16V256h160v40c0 13.25 10.75 24 24 24h80c13.25 0 24-10.75 24-24v-40h40.23c10.06-12.19 21.81-22.9 34.77-32H32v-80c0-8.82 7.18-16 16-16h416c8.82 0 16 7.18 16 16v48.81c5.28-.48 10.6-.81 16-.81s10.72.33 16 .81V144c0-26.51-21.49-48-48-48H352V24c0-13.26-10.74-24-24-24H184c-13.26 0-24 10.74-24 24v72H48c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h291.37a174.574 174.574 0 0 1-12.57-32H48zm176-160h64v32h-64v-32zM192 32h128v64H192V32zm358.29 320H512v-54.29c0-5.34-4.37-9.71-9.71-9.71h-12.57c-5.34 0-9.71 4.37-9.71 9.71v76.57c0 5.34 4.37 9.71 9.71 9.71h60.57c5.34 0 9.71-4.37 9.71-9.71v-12.57c0-5.34-4.37-9.71-9.71-9.71zM496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm0 256c-61.76 0-112-50.24-112-112s50.24-112 112-112 112 50.24 112 112-50.24 112-112 112z"]
  },
      Qn = {
    prefix: "fal",
    iconName: "cabinet-filing",
    icon: [512, 512, [], "f64b", "M464 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zm16 464c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16V272h448v192zm0-224H32V48c0-8.82 7.18-16 16-16h416c8.82 0 16 7.18 16 16v192zM336 96H176c-8.84 0-16 7.16-16 16v40c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24h128v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-40c0-8.84-7.16-16-16-16zM168 416h16c4.42 0 8-3.58 8-8v-24h128v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-40c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v40c0 4.42 3.58 8 8 8z"]
  },
      Zn = {
    prefix: "fal",
    iconName: "cactus",
    icon: [512, 512, [], "f8a7", "M446.54 208.78C419 213.32 400 239.24 400 267.15V296a8 8 0 0 1-8 8h-40V101.43c0-52-38.93-98.58-90.84-101.29A96 96 0 0 0 160 96v96h-40a8 8 0 0 1-8-8v-28.85c0-27.91-19-53.83-46.54-58.37A56.08 56.08 0 0 0 0 152v32a120 120 0 0 0 120 120h40v192a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-80h40a120 120 0 0 0 120-120v-32a56.08 56.08 0 0 0-65.46-55.22zM160 272h-40a88.09 88.09 0 0 1-88-88v-32a24 24 0 0 1 48 0v32a40 40 0 0 0 40 40h40zm160 208H192V96a64 64 0 0 1 128 0zm160-184a88.09 88.09 0 0 1-88 88h-40v-48h40a40 40 0 0 0 40-40v-32a24 24 0 0 1 48 0zM240 128a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm32 224a16 16 0 1 0 16 16 16 16 0 0 0-16-16z"]
  },
      Un = {
    prefix: "fal",
    iconName: "calculator",
    icon: [448, 512, [], "f1ec", "M80 448h288c8.84 0 16-7.16 16-16V240c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16zm208-96v-96h64v160h-64v-64zm-96-96h64v64h-64v-64zm0 96h64v64h-64v-64zm-96-96h64v64H96v-64zm0 96h64v64H96v-64zM400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zm16 464c0 7.93-8.07 16-16 16H48c-7.93 0-16-8.07-16-16V192h384v272zm0-304H32V48c0-7.93 8.07-16 16-16h352c7.93 0 16 8.07 16 16v112z"]
  },
      Bn = {
    prefix: "fal",
    iconName: "calculator-alt",
    icon: [480, 512, [], "f64c", "M72 160h112c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm5.09 247.6l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0L128 390.63l28.29 28.29c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31L150.63 368l28.29-28.29c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0L128 345.37l-28.29-28.29c-3.12-3.12-8.19-3.12-11.31 0L77.09 328.4c-3.12 3.12-3.12 8.19 0 11.31L105.37 368l-28.29 28.28a8.006 8.006 0 0 0 .01 11.32zM448 16H32C14.33 16 0 30.33 0 48v416c0 17.67 14.33 32 32 32h416c17.67 0 32-14.33 32-32V48c0-17.67-14.33-32-32-32zM224 464H32V272h192v192zm0-224H32V48h192v192zm224 224H256V272h192v192zm0-224H256V48h192v192zm-152-80h40v40c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-40h40c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-40V88c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v40h-40c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm0 256h112c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H296c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm0-64h112c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H296c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"]
  },
      Rn = {
    prefix: "fal",
    iconName: "calendar",
    icon: [448, 512, [], "f133", "M400 64h-48V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H128V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM48 96h352c8.822 0 16 7.178 16 16v48H32v-48c0-8.822 7.178-16 16-16zm352 384H48c-8.822 0-16-7.178-16-16V192h384v272c0 8.822-7.178 16-16 16z"]
  },
      Yn = {
    prefix: "fal",
    iconName: "calendar-alt",
    icon: [448, 512, [], "f073", "M400 64h-48V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H128V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h352c8.8 0 16 7.2 16 16v48H32v-48c0-8.8 7.2-16 16-16zm352 384H48c-8.8 0-16-7.2-16-16V192h384v272c0 8.8-7.2 16-16 16zM148 320h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-96 96h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm192 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12z"]
  },
      Pn = {
    prefix: "fal",
    iconName: "calendar-check",
    icon: [448, 512, [], "f274", "M400 64h-48V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H128V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM48 96h352c8.822 0 16 7.178 16 16v48H32v-48c0-8.822 7.178-16 16-16zm352 384H48c-8.822 0-16-7.178-16-16V192h384v272c0 8.822-7.178 16-16 16zm-66.467-194.937l-134.791 133.71c-4.7 4.663-12.288 4.642-16.963-.046l-67.358-67.552c-4.683-4.697-4.672-12.301.024-16.985l8.505-8.48c4.697-4.683 12.301-4.672 16.984.024l50.442 50.587 117.782-116.837c4.709-4.671 12.313-4.641 16.985.068l8.458 8.527c4.672 4.709 4.641 12.313-.068 16.984z"]
  },
      Fn = {
    prefix: "fal",
    iconName: "calendar-day",
    icon: [448, 512, [], "f783", "M400 64h-48V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56H128V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V192h384v272zm0-304H32v-48c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v48zM112 384h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm16-96h64v64h-64v-64z"]
  },
      Wn = {
    prefix: "fal",
    iconName: "calendar-edit",
    icon: [448, 512, [], "f333", "M400 64h-48V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H128V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h352c8.8 0 16 7.2 16 16v48H32v-48c0-8.8 7.2-16 16-16zm352 384H48c-8.8 0-16-7.2-16-16V192h384v272c0 8.8-7.2 16-16 16zM255.7 269.7l34.6 34.6c2.1 2.1 2.1 5.4 0 7.4L159.1 442.9l-35.1 5c-6.9 1-12.9-4.9-11.9-11.9l5-35.1 131.2-131.2c2-2 5.4-2 7.4 0zm75.2 1.4l-19.2 19.2c-2.1 2.1-5.4 2.1-7.4 0l-34.6-34.6c-2.1-2.1-2.1-5.4 0-7.4l19.2-19.2c6.8-6.8 17.9-6.8 24.7 0l17.3 17.3c6.8 6.8 6.8 17.9 0 24.7z"]
  },
      Gn = {
    prefix: "fal",
    iconName: "calendar-exclamation",
    icon: [448, 512, [], "f334", "M400 64h-48V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H128V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h352c8.8 0 16 7.2 16 16v48H32v-48c0-8.8 7.2-16 16-16zm352 384H48c-8.8 0-16-7.2-16-16V192h384v272c0 8.8-7.2 16-16 16zM212.7 224h22.6c6.9 0 12.4 5.8 12 12.7l-6.7 120c-.4 6.4-5.6 11.3-12 11.3h-9.3c-6.4 0-11.6-5-12-11.3l-6.7-120c-.3-6.9 5.2-12.7 12.1-12.7zM252 416c0 15.5-12.5 28-28 28s-28-12.5-28-28 12.5-28 28-28 28 12.5 28 28z"]
  },
      qn = {
    prefix: "fal",
    iconName: "calendar-minus",
    icon: [448, 512, [], "f272", "M400 64h-48V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H128V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h352c8.8 0 16 7.2 16 16v48H32v-48c0-8.8 7.2-16 16-16zm352 384H48c-8.8 0-16-7.2-16-16V192h384v272c0 8.8-7.2 16-16 16zm-92-128H140c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12z"]
  },
      Jn = {
    prefix: "fal",
    iconName: "calendar-plus",
    icon: [448, 512, [], "f271", "M320 332v8c0 6.6-5.4 12-12 12h-68v68c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-68h-68c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h68v-68c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v68h68c6.6 0 12 5.4 12 12zm128-220v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v52h192V12c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-416 0v48h384v-48c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm384 352V192H32v272c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16z"]
  },
      Kn = {
    prefix: "fal",
    iconName: "calendar-star",
    icon: [448, 512, [], "f736", "M149.8 369l-7.9 46.3c-1.8 10.6 2.5 21.1 11.2 27.4 4.9 3.5 10.7 5.4 16.4 5.4 4.4 0 8.9-1.1 13-3.3L224 423l41.5 21.8c9.5 5 20.8 4.2 29.5-2.1 8.7-6.3 13-16.8 11.2-27.4l-7.9-46.3 33.5-32.7c7.7-7.5 10.4-18.5 7.1-28.7s-12-17.5-22.6-19l-46.4-6.8-20.7-42.1C244.3 230 234.7 224 224 224s-20.3 6-25 15.6l-20.7 42.1-46.4 6.8c-10.6 1.5-19.3 8.8-22.6 19s-.6 21.2 7.1 28.7l33.4 32.8zm49.6-58.1L224 261l24.6 49.9 55 8-39.8 38.9 9.4 54.8-49.2-25.8-49.2 25.9 9.4-54.8-39.8-38.9 55-8.1zM400 64h-48V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56H128V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V192h384v272zm0-304H32v-48c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v48z"]
  },
      Xn = {
    prefix: "fal",
    iconName: "calendar-times",
    icon: [448, 512, [], "f273", "M400 64h-48V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H128V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h352c8.8 0 16 7.2 16 16v48H32v-48c0-8.8 7.2-16 16-16zm352 384H48c-8.8 0-16-7.2-16-16V192h384v272c0 8.8-7.2 16-16 16zm-105.3-95.9c4.7 4.7 4.7 12.3 0 17l-5.7 5.7c-4.7 4.7-12.3 4.7-17 0l-48-48.2-48.1 48.1c-4.7 4.7-12.3 4.7-17 0l-5.7-5.7c-4.7-4.7-4.7-12.3 0-17l48.1-48.1-48.1-48.1c-4.7-4.7-4.7-12.3 0-17l5.7-5.7c4.7-4.7 12.3-4.7 17 0l48.1 48.1 48.1-48.1c4.7-4.7 12.3-4.7 17 0l5.7 5.7c4.7 4.7 4.7 12.3 0 17L246.6 336l48.1 48.1z"]
  },
      _n = {
    prefix: "fal",
    iconName: "calendar-week",
    icon: [448, 512, [], "f784", "M400 64h-48V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56H128V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V192h384v272zm0-304H32v-48c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v48zM80 352h288c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm16-96h256v64H96v-64z"]
  },
      $n = {
    prefix: "fal",
    iconName: "camcorder",
    icon: [576, 512, [], "f8a8", "M511.88 160l.12 31.5-.22 256.37L416 381.72V258.23L511.93 192h-.07v-32a32.13 32.13 0 0 0-18.27 5.73L416 219.32V208a48 48 0 0 0-48-48H128v-48a48 48 0 0 1 48-48h168a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8H176a80 80 0 0 0-80 80v48H80a48 48 0 0 0-48 48v224a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48v-11.39l77.59 53.59a32 32 0 0 0 18.26 5.8c16.63 0 32.15-13 32.15-31.59V191.5c0-18.5-15.48-31.5-32.12-31.5zM384 432a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V208a16 16 0 0 1 16-16h288a16 16 0 0 1 16 16zm-38.4-208H102.4a6.41 6.41 0 0 0-6.4 6.4v19.2a6.41 6.41 0 0 0 6.4 6.4h243.2a6.41 6.41 0 0 0 6.4-6.4v-19.2a6.41 6.41 0 0 0-6.4-6.4z"]
  },
      ct = {
    prefix: "fal",
    iconName: "camera",
    icon: [512, 512, [], "f030", "M324.3 64c3.3 0 6.3 2.1 7.5 5.2l22.1 58.8H464c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h110.2l20.1-53.6c2.3-6.2 8.3-10.4 15-10.4h131m0-32h-131c-20 0-37.9 12.4-44.9 31.1L136 96H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48h-88l-14.3-38c-5.8-15.7-20.7-26-37.4-26zM256 408c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88z"]
  },
      et = {
    prefix: "fal",
    iconName: "camera-alt",
    icon: [512, 512, [], "f332", "M256 408c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-32 88c0-17.6 14.4-32 32-32 8.8 0 16-7.2 16-16s-7.2-16-16-16c-35.3 0-64 28.7-64 64 0 8.8 7.2 16 16 16s16-7.2 16-16zM324.3 64c3.3 0 6.3 2.1 7.5 5.2l22.1 58.8H464c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h110.2l20.1-53.6c2.3-6.2 8.3-10.4 15-10.4h131m0-32h-131c-20 0-37.9 12.4-44.9 31.1L136 96H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48h-88l-14.3-38c-5.8-15.7-20.7-26-37.4-26z"]
  },
      at = {
    prefix: "fal",
    iconName: "camera-home",
    icon: [448, 512, [], "f8fe", "M208,128a64.06,64.06,0,0,0-64,64,16,16,0,0,0,32,0,32,32,0,0,1,32-32,16,16,0,0,0,0-32Zm15.94-64a144,144,0,0,0,0,288H224a144,144,0,0,0-.05-288Zm0,256a112,112,0,0,1,0-224H224a112,112,0,0,1-.05,224ZM384,0H64A64,64,0,0,0,0,64V352a64,64,0,0,0,64,64h72.71L76.53,450.83c-6.9,4.33-12.5,14.45-12.5,22.6v11.9A26.68,26.68,0,0,0,90.7,512H357.37A26.68,26.68,0,0,0,384,485.33V473.45c0-8.17-5.65-18.3-12.58-22.62L311.28,416H384a64,64,0,0,0,64-64V64A64,64,0,0,0,384,0ZM352,476.54V480H96v-3.48l56.71-32.82L200.59,416H247.4l47.85,27.7ZM416,352a32,32,0,0,1-32,32H64a32,32,0,0,1-32-32V64A32,32,0,0,1,64,32H384a32,32,0,0,1,32,32Z"]
  },
      nt = {
    prefix: "fal",
    iconName: "camera-movie",
    icon: [576, 512, [], "f8a9", "M368 80a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm0 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zM176 80a64 64 0 1 0 64 64 64.07 64.07 0 0 0-64-64zm0 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm374.29 80a25.67 25.67 0 0 0-14.61 4.59l-87.68 61V304a47.74 47.74 0 0 0-13.34-33.07C480.44 246.81 512 199.34 512 144A144 144 0 0 0 368 0c-37 0-70.48 14.38-96 37.37C246.48 14.38 213.05 0 176 0A144 144 0 0 0 32 144c0 45.52 21.54 85.61 54.51 112H32a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32h64v112a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48v-17.54l87.68 60.94a25.53 25.53 0 0 0 14.6 4.6c13.3 0 25.72-10.36 25.72-25.24V281.23c0-14.83-12.39-25.23-25.71-25.23zM416 464a16 16 0 0 1-16 16H144a16 16 0 0 1-16-16V320H32v-32h368a16 16 0 0 1 16 16zm-48-208H176a112 112 0 1 1 74.58-194.85L272 80.44l21.42-19.29A111.78 111.78 0 1 1 368 256zm176 218.22l-96-66.74v-47l96-66.74z"]
  },
      tt = {
    prefix: "fal",
    iconName: "camera-polaroid",
    icon: [576, 512, [], "f8aa", "M288 128a80 80 0 1 0 80 80 80.12 80.12 0 0 0-80-80zm0 128a48 48 0 1 1 48-48 48.05 48.05 0 0 1-48 48zM104 416h368a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm470.43-87.94a32.12 32.12 0 0 0-3.8-8.06L512 256V80a48 48 0 0 0-48-48H112a48 48 0 0 0-48 48v176L5.38 320A33.45 33.45 0 0 0 0 337.75V448a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32V337.75a31.81 31.81 0 0 0-1.57-9.69zM96 268.44V80a16 16 0 0 1 16-16h352a16 16 0 0 1 16 16v188.44L527.23 320H48.77zM544 448H32v-96h512zM432 104h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8z"]
  },
      rt = {
    prefix: "fal",
    iconName: "camera-retro",
    icon: [512, 512, [], "f083", "M32 58V38c0-3.3 2.7-6 6-6h116c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6zm344 230c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88zm-120 0c0-17.6 14.4-32 32-32 8.8 0 16-7.2 16-16s-7.2-16-16-16c-35.3 0-64 28.7-64 64 0 8.8 7.2 16 16 16s16-7.2 16-16zM512 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h136l33.6-44.8C226.7 39.1 240.9 32 256 32h208c26.5 0 48 21.5 48 48zM224 96h240c5.6 0 11 1 16 2.7V80c0-8.8-7.2-16-16-16H256c-5 0-9.8 2.4-12.8 6.4L224 96zm256 48c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V144z"]
  },
      it = {
    prefix: "fal",
    iconName: "campfire",
    icon: [512, 512, [], "f6ba", "M256 320c79.53 0 144-64.47 144-144 0-33.29-33.42-101.96-80-144-13.37 12.06-25.45 24.75-36.14 37.48C266.34 46.01 244.61 22.21 220 0c-63.17 56.98-108 131.22-108 176 0 79.53 64.47 144 144 144zM220.1 44.42c14.11 14.38 27.04 29.37 38.12 44.21L282.39 121l25.98-30.95c3.56-4.24 7.23-8.41 10.99-12.47C349.96 114.53 368 159.21 368 176c0 61.76-50.24 112-112 112s-112-50.24-112-112c0-27.75 28.05-81.63 76.1-131.58zM295.91 400l211.3-82.02a7.99 7.99 0 0 0 4.12-10.53l-6.4-14.65a8.006 8.006 0 0 0-10.54-4.13L256 382.54 17.61 288.67a8.006 8.006 0 0 0-10.54 4.13l-6.4 14.65a7.999 7.999 0 0 0 4.12 10.53L216.09 400 4.8 482.02a7.994 7.994 0 0 0-4.12 10.53l6.4 14.65c1.77 4.05 6.49 5.9 10.54 4.12L256 417.46l238.39 93.87c4.05 1.77 8.77-.07 10.54-4.12l6.4-14.65a7.999 7.999 0 0 0-4.12-10.53L295.91 400z"]
  },
      ot = {
    prefix: "fal",
    iconName: "campground",
    icon: [640, 512, [], "f6bb", "M632 480h-24L339.74 109.19l63-87.09c2.6-3.57 1.8-8.57-1.77-11.17l-12.93-9.4c-3.57-2.6-8.58-1.81-11.18 1.77L320 81.9 263.14 3.3a7.999 7.999 0 0 0-11.18-1.77l-12.93 9.4c-3.57 2.6-4.37 7.6-1.77 11.17l63 87.09L32 480H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h624c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-409.81 0L320 343.06 417.81 480H222.19zm234.96 0L333.02 306.23c-6.38-8.93-19.66-8.93-26.04 0L182.85 480H71.49L320 136.48 568.51 480H457.15z"]
  },
      lt = {
    prefix: "fal",
    iconName: "candle-holder",
    icon: [448, 512, [], "f6bc", "M160 192c45.93 0 78-32.61 78-79.29C238 82.72 205.41 37.82 160 0c-45.62 38-78 82.84-78 112.71 0 46.68 32.07 79.29 78 79.29zm0-148.93c31.56 30.97 46 58.26 46 69.63 0 29.17-17.63 47.29-46 47.29s-46-18.12-46-47.29c0-11.37 14.44-38.66 46-69.63zM384 384c-35.35 0-64 28.65-64 64 0 11.72 3.38 22.55 8.88 32H256V256c0-17.67-14.33-32-32-32H96c-17.67 0-32 14.33-32 32v224H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h376c35.35 0 64-28.65 64-64s-28.65-64-64-64zm-160 96H96V256h32v48c0 8.84 7.16 16 16 16s16-7.16 16-16v-48h64v224zm160 0c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"]
  },
      ft = {
    prefix: "fal",
    iconName: "candy-cane",
    icon: [512, 512, [], "f786", "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c9.4 15.7 29.3 19.8 43.9 11l27.5-16.4c35.9-21.5 69.6 33 32.8 54.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-205.2 29.4l-32.8-54.9C291.8 47.2 312.6 32.1 352 32v64c-23.6.3-37.3 12.1-59.7 25.4zm91-17.4h.7V36.1c36.7 9.2 67.8 34 84.6 69.5 3.4 7.2 6 14.7 7.9 22.3H408v.1c-.2-.3-.3-.6-.4-.9-5.9-9.9-14.4-17.7-24.3-23.1zM256.8 291.4l82.3-49 64.3 36.2-82.3 49-64.3-36.2zm32.6 55.1l-87.5 52-64.3-36.2 87.5-52 64.3 36.2zM64.8 480l-32.9-54.9 73.9-43.9 64.3 36.2L64.8 480zm368-221.5l-62-34.9 14.6-8.7c20-11.9 30.9-33.2 30.9-54.9h63c-.9 36.5-17.2 72.8-46.5 98.5z"]
  },
      st = {
    prefix: "fal",
    iconName: "candy-corn",
    icon: [640, 512, [], "f6bd", "M480 0C314.19 1.62 315.52 39.54 322.11 72.47 352.45 224.02 416.18 416 479.91 416h.09c63.77-.18 127.53-191.9 157.89-343.53C644.48 39.54 645.81 1.62 480 0zm-.09 383.99c-12.75-.03-39.26-37.06-67.43-108.71 43.78-3.73 91.2-3.73 134.98-.01-28.2 71.64-54.77 108.68-67.55 108.72zm79.07-139.8c-50.83-4.96-107.17-4.96-158 0-9.47-27.05-18.92-57.92-27.95-92.61 66.6-9.76 147.33-9.77 213.93 0-9.04 34.68-18.49 65.56-27.98 92.61zm47.65-178.03c-3.8 19-7.83 36.88-11.94 54.22-71.31-10.82-158.08-10.82-229.39 0-4.11-17.34-8.13-35.23-11.93-54.23-1.98-9.89-1.55-12.44-1.27-13.08.1-.2 12.85-19.9 127.9-21.06 115.06 1.16 127.81 20.87 127.9 21.06.28.65.71 3.2-1.27 13.09zM84.94 205.81c-116.1 118.4-88.35 144.26-60.4 162.89 128.62 85.71 309.43 176.4 354.49 131.34l.06-.06c44.96-45.22-45.52-225.87-131.27-354.56-18.62-27.96-44.48-55.71-162.88 60.39zM356.4 477.4c-9.03 9-53.97 1.56-124.54-29.19 28.32-33.6 61.85-67.12 95.44-95.45 30.71 70.59 38.11 115.57 29.1 124.64zm-42.94-154.77c-39.45 32.44-79.29 72.28-111.72 111.73-25.83-12.43-54.34-27.58-85.25-45.72 40.19-53.99 97.27-111.08 151.27-151.27 18.13 30.91 33.28 59.42 45.7 85.26zm-224.5 49.41c-15.17-9.36-30.66-19.16-46.78-29.91-8.39-5.59-9.89-7.7-10.15-8.35-.07-.21-4.99-23.16 75.55-105.34 82.18-80.54 105.13-75.62 105.34-75.55.64.25 2.75 1.76 8.35 10.15 10.74 16.12 20.54 31.62 29.9 46.78-58.08 42.79-119.43 104.15-162.21 162.22z"]
  },
      ut = {
    prefix: "fal",
    iconName: "cannabis",
    icon: [512, 512, [], "f55f", "M494.42 323.43c-1.2-.6-19.6-9.78-47.96-17.83 48.3-64.24 63.94-129.7 64.72-133.04a31.977 31.977 0 0 0-8.31-29.62 31.997 31.997 0 0 0-22.86-9.61c-2.19 0-4.4.23-6.59.69-3.34.7-66.31 14.35-130.68 55.97-8.59-97.8-57.86-172.39-60.14-175.8C276.64 5.32 266.67 0 256 0s-20.64 5.32-26.58 14.19c-2.29 3.41-51.56 78.01-60.14 175.8-64.37-41.62-127.34-55.27-130.68-55.97-2.19-.46-4.4-.69-6.59-.69-8.51 0-16.78 3.4-22.86 9.61a31.991 31.991 0 0 0-8.31 29.62c.77 3.34 16.42 68.79 64.72 133.04-28.37 8.05-46.77 17.23-47.96 17.83A32 32 0 0 0 0 351.98a32.005 32.005 0 0 0 17.54 28.57c2.3 1.17 54.42 27.19 120.97 29.89-2.84 6.84-4.26 11.06-4.41 11.51A31.999 31.999 0 0 0 164.48 464c3.04 0 6.11-.43 9.12-1.33 1.66-.49 31.46-9.55 66.39-30.71V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72.03c34.94 21.16 64.74 30.21 66.39 30.71 3.01.89 6.08 1.33 9.12 1.33 8.53 0 16.86-3.41 22.97-9.72a31.982 31.982 0 0 0 7.41-32.33c-.15-.45-1.56-4.67-4.41-11.51 66.55-2.71 118.66-28.73 120.97-29.89 10.77-5.45 17.55-16.5 17.54-28.57s-6.79-23.12-17.56-28.56zM362.4 378.66c-17.33 0-31.19-.9-42.49-2.42-.22.12-.4.16-.62.28 19.8 30.01 28.23 55.48 28.23 55.48s-48.08-14.3-91.52-50.5c-43.44 36.2-91.52 50.5-91.52 50.5s8.43-25.47 28.23-55.48c-.22-.12-.4-.16-.62-.28-11.3 1.53-25.16 2.42-42.49 2.42C84.65 378.66 32 352 32 352s40.95-20.67 95.13-25.58c-.85-.8-1.57-1.36-2.43-2.18C53.02 255.98 32 165.33 32 165.33s95.18 20.02 166.85 88.28c.93.89 1.57 1.63 2.48 2.51-.85-11.28-1.33-23.67-1.33-37.46C200 115.57 256 32 256 32s56 83.57 56 186.67c0 13.79-.48 26.18-1.33 37.46.91-.88 1.55-1.62 2.48-2.51C384.82 185.35 480 165.33 480 165.33s-21.02 90.64-92.7 158.9c-.86.82-1.58 1.38-2.43 2.18C439.05 331.33 480 352 480 352s-52.65 26.66-117.6 26.66z"]
  },
      ht = {
    prefix: "fal",
    iconName: "capsules",
    icon: [544, 512, [], "f46b", "M529 296.8L417.5 103.7c-30.8-53.2-99-71.5-152.3-40.8-21.2 12.2-36.5 30.5-45.8 51.3C206.3 67 163.4 32 112 32 50.2 32 0 82.2 0 144v224c0 61.8 50.2 112 112 112s112-50.2 112-112V214.2c.2.3.2.6.4.9l111.5 193.1c20.6 35.7 58.2 55.7 96.8 55.7 18.9 0 38-4.8 55.5-14.9 25.8-14.9 44.2-38.9 51.9-67.7 7.8-28.7 3.8-58.7-11.1-84.5zM112 64c44.1 0 80 35.9 80 80v112H32V144c0-44.1 35.9-80 80-80zm0 384c-44.1 0-80-35.9-80-80v-80h160v80c0 44.1-35.9 80-80 80zM281.2 90.5c40.4-23.3 88.2-6.5 108.8 29.1l47.6 82.4-137.9 79.6-47.7-82.3c-21.9-38.1-8.9-86.9 29.2-108.8zm228.2 282.7c-5.5 20.5-18.7 37.7-37.1 48.4-38 21.9-86.8 8.8-108.8-29.1l-47.9-83 137.9-79.6 47.9 83c10.7 18.2 13.5 39.7 8 60.3z"]
  },
      mt = {
    prefix: "fal",
    iconName: "car",
    icon: [512, 512, [], "f1b9", "M120.81 248c-25.96 0-44.8 16.8-44.8 39.95 0 23.15 18.84 39.95 44.8 39.95l10.14.1c39.21 0 45.06-20.1 45.06-32.08-.01-24.68-31.1-47.92-55.2-47.92zm10.14 56c-3.51 0-7.02-.1-10.14-.1-12.48 0-20.8-6.38-20.8-15.95s8.32-15.95 20.8-15.95 31.2 14.36 31.2 23.93c0 7.17-10.54 8.07-21.06 8.07zm260.24-56c-24.1 0-55.19 23.24-55.19 47.93 0 11.98 5.85 32.08 45.06 32.08l10.14-.1c25.96 0 44.8-16.8 44.8-39.95-.01-23.16-18.85-39.96-44.81-39.96zm0 55.9c-3.12 0-6.63.1-10.14.1-10.53 0-21.06-.9-21.06-8.07 0-9.57 18.72-23.93 31.2-23.93s20.8 6.38 20.8 15.95-8.32 15.95-20.8 15.95zm114.8-140.94c-7.34-11.88-20.06-18.97-34.03-18.97H422.3l-8.07-24.76C403.5 86.29 372.8 64 338.17 64H173.83c-34.64 0-65.33 22.29-76.06 55.22l-8.07 24.76H40.04c-13.97 0-26.69 7.09-34.03 18.97s-8 26.42-1.75 38.91l5.78 11.61c3.96 7.88 9.92 14.09 17 18.55-6.91 11.74-11.03 25.32-11.03 39.97V400c0 26.47 21.53 48 48 48h16c26.47 0 48-21.53 48-48v-16H384v16c0 26.47 21.53 48 48 48h16c26.47 0 48-21.53 48-48V271.99c0-14.66-4.12-28.23-11.03-39.98 7.09-4.46 13.04-10.68 17-18.57l5.78-11.56c6.24-12.5 5.58-27.05-1.76-38.92zM128.2 129.14C134.66 109.32 153 96 173.84 96h164.33c20.84 0 39.18 13.32 45.64 33.13l20.47 62.85H107.73l20.47-62.84zm-89.53 70.02l-5.78-11.59c-1.81-3.59-.34-6.64.34-7.78.87-1.42 2.94-3.8 6.81-3.8h39.24l-6.45 19.82a80.69 80.69 0 0 0-23.01 11.29c-4.71-1-8.94-3.52-11.15-7.94zM96.01 400c0 8.83-7.19 16-16 16h-16c-8.81 0-16-7.17-16-16v-16h48v16zm367.98 0c0 8.83-7.19 16-16 16h-16c-8.81 0-16-7.17-16-16v-16h48v16zm0-80.01v32H48.01v-80c0-26.47 21.53-48 48-48h319.98c26.47 0 48 21.53 48 48v48zm15.12-132.41l-5.78 11.55c-2.21 4.44-6.44 6.97-11.15 7.97-6.94-4.9-14.69-8.76-23.01-11.29l-6.45-19.82h39.24c3.87 0 5.94 2.38 6.81 3.8.69 1.14 2.16 4.18.34 7.79z"]
  },
      vt = {
    prefix: "fal",
    iconName: "car-alt",
    icon: [480, 512, [], "f5de", "M423.18 195.81l-24.94-76.58C387.51 86.29 356.81 64 322.17 64H157.83c-34.64 0-65.34 22.29-76.07 55.22L56.82 195.8C24.02 205.79 0 235.92 0 271.99V400c0 26.47 21.53 48 48 48h16c26.47 0 48-21.53 48-48v-16h256v16c0 26.47 21.53 48 48 48h16c26.47 0 48-21.53 48-48V271.99c0-36.07-24.02-66.2-56.82-76.18zm-310.99-66.67c6.46-19.82 24.8-33.14 45.64-33.14h164.34c20.84 0 39.18 13.32 45.64 33.13l20.47 62.85H91.72l20.47-62.84zM80 400c0 8.83-7.19 16-16 16H48c-8.81 0-16-7.17-16-16v-16h48v16zm368 0c0 8.83-7.19 16-16 16h-16c-8.81 0-16-7.17-16-16v-16h48v16zm0-80.01v32H32v-80c0-26.47 21.53-48 48-48h320c26.47 0 48 21.53 48 48v48zM104.8 248C78.84 248 60 264.8 60 287.95c0 23.15 18.84 39.95 44.8 39.95l10.14.1c39.21 0 45.06-20.1 45.06-32.08 0-24.68-31.1-47.92-55.2-47.92zm10.14 56c-3.51 0-7.02-.1-10.14-.1-12.48 0-20.8-6.38-20.8-15.95S92.32 272 104.8 272s31.2 14.36 31.2 23.93c0 7.17-10.53 8.07-21.06 8.07zm260.26-56c-24.1 0-55.2 23.24-55.2 47.93 0 11.98 5.85 32.08 45.06 32.08l10.14-.1c25.96 0 44.8-16.8 44.8-39.95 0-23.16-18.84-39.96-44.8-39.96zm0 55.9c-3.12 0-6.63.1-10.14.1-10.53 0-21.06-.9-21.06-8.07 0-9.57 18.72-23.93 31.2-23.93s20.8 6.38 20.8 15.95-8.32 15.95-20.8 15.95z"]
  },
      dt = {
    prefix: "fal",
    iconName: "car-battery",
    icon: [512, 512, [], "f5df", "M480 128h-32V80c0-8.84-7.16-16-16-16H304c-8.84 0-16 7.16-16 16v48h-64V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM320 96h96v32h-96V96zM96 96h96v32H96V96zm384 320H32V160h448v256zm-56-160h-40v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v40h-40c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h40v40c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-40h40c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-224 0H88c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h112c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"]
  },
      Mt = {
    prefix: "fal",
    iconName: "car-building",
    icon: [640, 512, [], "f859", "M595.4 294.44l-15.88-68.83A63.71 63.71 0 0 0 517.16 176H344.07a63.7 63.7 0 0 0-62.36 49.61l-16.28 70.55C241 308.44 224 333.49 224 362.67v55.11a46.14 46.14 0 0 0 32 43.75V496a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-32h256v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-34.47a46.14 46.14 0 0 0 32-43.75v-55.11a74.7 74.7 0 0 0-44.6-68.23zM312.89 232.8a32 32 0 0 1 31.18-24.8h173.09a32 32 0 0 1 31.18 24.8l12.73 55.2H300.15zM608 417.78A14.24 14.24 0 0 1 593.78 432H270.22A14.24 14.24 0 0 1 256 417.78v-55.11A42.72 42.72 0 0 1 298.67 320h266.66A42.72 42.72 0 0 1 608 362.67zM320 48v96h32V48a48 48 0 0 0-48-48H48A48 48 0 0 0 0 48v392a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V48a16 16 0 0 1 16-16h256a16 16 0 0 1 16 16zM204 96a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm-56 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm160 64a20 20 0 1 0 20 20 20 20 0 0 0-20-20zm248 0a20 20 0 1 0 20 20 20 20 0 0 0-20-20zM148 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm102.53 122.42a96.81 96.81 0 0 1 5.16-15.95A11.86 11.86 0 0 0 244 192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h37.85z"]
  },
      pt = {
    prefix: "fal",
    iconName: "car-bump",
    icon: [576, 512, [], "f5e0", "M157.56 410.15l233.93-105.9 13.63 28.39c11.28 23.48 40.13 33.68 64.31 22.73l14.62-6.62c24.19-10.95 34.69-38.96 23.41-62.44L446.1 158.56c-15.37-32-50.16-48.79-84.38-44.08L306.3 56.86c-23.84-24.78-61.39-31.85-93.04-17.52L63.1 107.32c-31.65 14.33-50.21 46.8-45.98 80.46l9.84 78.25C1.24 288.46-7.87 325.13 7.5 357.12l61.36 127.75c11.28 23.48 40.13 33.68 64.31 22.73l14.62-6.62c24.19-10.95 34.69-38.96 23.41-62.44l-13.64-28.39zm320.67-110.61c3.76 7.83.25 17.17-7.8 20.81l-14.62 6.62c-8.05 3.65-17.68.26-21.44-7.57l-13.63-28.39 43.86-19.86 13.63 28.39zM76.73 135.71L226.9 67.73c19.04-8.62 41.48-4.4 55.82 10.51l45.49 47.29L57.22 248.21l-8.08-64.22c-2.54-20.26 8.55-39.66 27.59-48.28zm57.43 336.88l-14.62 6.62c-8.05 3.65-17.68.26-21.44-7.58l-13.64-28.39 43.86-19.86 13.63 28.39c3.77 7.84.26 17.18-7.79 20.82zm-63.33-57.73l-34.09-70.97c-11.28-23.48-.78-51.49 23.41-62.44l292.41-132.38c24.19-10.95 53.04-.75 64.31 22.73l20.45 42.58 13.63 28.39-43.86 19.86-29.24 13.24L70.83 414.86zm327.25-217.32c-9.87-20.54-34.24-27.65-57.96-16.91-22.02 9.97-40.54 43.45-30.02 65.35 5.1 10.63 19.01 26.03 54.84 9.81l9.22-4.28c23.73-10.74 33.78-33.43 23.92-53.97zm-34.14 32.68c-2.85 1.29-6.01 2.83-9.22 4.28-9.62 4.36-19.63 7.92-22.69 1.55-4.08-8.49 6.91-28.97 18.31-34.13 11.4-5.16 21.72-2.95 25.8 5.54s-.8 17.6-12.2 22.76zm-270.9 62.27c-23.72 10.74-33.78 33.44-23.91 53.97 9.87 20.54 34.24 27.65 57.96 16.91l9.3-4.11c35.83-16.22 32.61-36.47 27.51-47.09-10.52-21.9-48.83-29.65-70.86-19.68zm33.13 45.48c-3.21 1.45-6.46 2.81-9.3 4.11-11.4 5.16-21.72 2.94-25.8-5.55-4.08-8.49.81-17.59 12.21-22.75s34.62-.17 38.7 8.32c3.05 6.36-6.19 11.52-15.81 15.87zm449.49 154.78c-10.72-51.84-57.56-89.47-111.34-89.47S363.72 440.91 353 492.75c-1.81 8.66 3.75 17.12 12.41 18.92 8.5 1.73 17.09-3.77 18.91-12.42 7.69-37.06 41.31-63.97 80-63.97s72.34 26.91 80.03 63.97c1.56 7.55 8.22 12.75 15.63 12.75 1.09 0 2.19-.11 3.28-.33 8.65-1.79 14.21-10.26 12.4-18.92z"]
  },
      zt = {
    prefix: "fal",
    iconName: "car-bus",
    icon: [640, 512, [], "f85a", "M64 300a20 20 0 1 0 20-20 20 20 0 0 0-20 20zm-32 49.09L31.93 256h209.92l7.39-32H208v-96h144v16h32V70.23C384 30.91 299 0 192 0S0 30.91 0 70.23v278.86A34.91 34.91 0 0 0 34.91 384H32v48a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-48h112v-21.33c0-3.66.93-7.09 1.29-10.67H34.91a2.91 2.91 0 0 1-2.91-2.91zM176 224H32v-96h144zM31.8 71.55C36.41 60.29 90.84 32 192 32s155.59 28.29 160 38.23V96H31.82zm563.6 222.89l-15.88-68.83A63.71 63.71 0 0 0 517.16 176H344.07a63.7 63.7 0 0 0-62.36 49.61l-16.28 70.55C241 308.44 224 333.49 224 362.67v55.11a46.14 46.14 0 0 0 32 43.75V496a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-32h256v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-34.47a46.14 46.14 0 0 0 32-43.75v-55.11a74.7 74.7 0 0 0-44.6-68.23zm-282.51-61.63A32 32 0 0 1 344.07 208h173.09a32 32 0 0 1 31.18 24.81L561.07 288H300.15zM608 417.78A14.24 14.24 0 0 1 593.78 432H270.22A14.24 14.24 0 0 1 256 417.78v-55.11A42.72 42.72 0 0 1 298.67 320h266.66A42.72 42.72 0 0 1 608 362.67zM308 352a20 20 0 1 0 20 20 20 20 0 0 0-20-20zm248 0a20 20 0 1 0 20 20 20 20 0 0 0-20-20z"]
  },
      Ct = {
    prefix: "fal",
    iconName: "car-crash",
    icon: [640, 512, [], "f5e1", "M162.55 84.62c3.72 5.59 9.66 9.39 16.31 10.39 6.44.97 13.41-.86 18.66-5.16l52.16-42.94c6.84-5.63 7.81-15.7 2.19-22.53-5.63-6.86-15.75-7.81-22.5-2.19L184.2 59.37l-32.38-48.69c-5.66-8.52-15.63-12.45-25.66-9.92-9.91 2.48-16.94 10.66-17.91 20.78l-5.66 58.22-57.32-11.55c-10.09-2.11-19.88 2.34-25.13 11.11S15.7 98.84 22.2 106.7l37.16 45.16-48.72 32.39c-8.5 5.66-12.38 15.7-9.91 25.59 2.47 9.91 10.63 16.94 20.81 17.94l58.22 5.64-11.56 57.34c-1.75 8.66 3.88 17.09 12.53 18.84 1.06.22 2.13.31 3.19.31 7.44 0 14.13-5.25 15.66-12.84l13.34-66.25c1.31-6.58-.22-13.45-4.22-18.84-4-5.41-10.13-8.88-16.84-9.53l-44.34-4.3 37.06-24.64c5.63-3.7 9.41-9.66 10.41-16.3a23.68 23.68 0 0 0-5.16-18.7l-28.28-34.38 43.69 8.8c6.44 1.27 13.47-.23 18.88-4.25 5.41-4 8.84-10.14 9.5-16.8l4.28-44.34 24.65 37.08zm118.53 132.42c-25.07-6.72-47.62 4.63-53.61 26.99-5.99 22.36 7.86 43.47 32.93 50.19l9.77 2.72c37.87 10.15 48.73-7.75 51.83-19.32 6.38-23.84-17.64-54.34-40.92-60.58zm-4.71 56.72c-3.39-.91-6.75-1.91-9.77-2.72-12.05-3.23-18.44-11.55-15.96-20.79 2.48-9.24 12.16-13.25 24.22-10.02 12.05 3.23 26.42 21.94 23.94 31.19-1.85 6.92-12.26 5.06-22.43 2.34zm325.74-24.73l-4.27-80.42c-1.84-34.59-25.73-64.06-59.18-73.03L379.92 53.04c-33.46-8.96-68.88 4.62-87.77 33.65l-43.91 67.51c-34.27 1.16-65.27 24.04-74.6 58.88l-37.27 139.09c-6.85 25.57 8.37 51.94 33.94 58.79l15.45 4.14c25.57 6.85 51.94-8.38 58.79-33.94l8.28-30.91 247.28 66.26-8.28 30.91c-6.85 25.57 8.37 51.94 33.94 58.79l15.46 4.14c25.57 6.85 51.94-8.37 58.79-33.94l37.27-139.09c9.32-34.83-6.08-70.16-35.18-88.29zM318.97 104.14c11.37-17.47 32.53-25.59 52.66-20.19l158.74 42.53c20.13 5.39 34.4 23 35.51 43.82l3.51 66.01-286.46-76.76 36.04-55.41zM213.64 372.89c-2.29 8.53-11.08 13.6-19.6 11.31l-15.46-4.14c-8.51-2.28-13.6-11.07-11.31-19.6l8.28-30.91 46.37 12.42-8.28 30.92zm355.46 95.25c-2.29 8.53-11.08 13.59-19.6 11.31l-15.46-4.14c-8.51-2.28-13.6-11.07-11.31-19.6l8.28-30.91 46.36 12.42-8.27 30.92zm37.27-139.1l-12.42 46.37-8.28 30.91-46.37-12.42-30.91-8.28-324.55-86.96 20.71-77.27c6.85-25.56 33.22-40.79 58.79-33.94l309.1 82.82c25.55 6.83 40.78 33.21 33.93 58.77zm-64.11-42.02c-23.28-6.24-59.33 8.16-65.72 32.01-3.1 11.57-2.65 32.5 35.22 42.64l9.82 2.53c25.07 6.72 47.62-4.63 53.61-26.99 5.99-22.36-7.86-43.47-32.93-50.19zm9.75 43.98c-2.48 9.24-12.17 13.25-24.22 10.02-3.01-.81-6.43-1.62-9.82-2.53-10.17-2.72-20.11-6.32-18.25-13.25 2.48-9.24 24.27-18.27 36.33-15.04 12.05 3.24 18.43 11.55 15.96 20.8z"]
  },
      Lt = {
    prefix: "fal",
    iconName: "car-garage",
    icon: [640, 512, [], "f5e2", "M635.88 160L327.78 2.02c-4.88-2.69-10.69-2.69-15.56 0l-308.1 161c-3.87 2.15-5.26 7.02-3.11 10.88l7.78 13.99c2.15 3.86 7.02 5.25 10.88 3.1L320 34.3l300.33 153.68c3.86 2.14 8.73.76 10.87-3.1l7.79-13.99c2.15-3.87.76-8.74-3.11-10.89zm-142.5 101.74l-15.15-46.5c-10.73-32.93-41.43-55.22-76.07-55.22H237.83c-34.64 0-65.34 22.29-76.07 55.22l-15.15 46.5C117.01 273.47 96 302.22 96 336v128c0 26.47 21.53 48 48 48h16c26.47 0 48-21.53 48-48v-16h224v16c0 26.47 21.53 48 48 48h16c26.47 0 48-21.53 48-48V336c0-33.78-21.01-62.53-50.62-74.26zm-301.19-36.59a47.888 47.888 0 0 1 45.64-33.13h164.34c20.84 0 39.18 13.32 45.64 33.13L457.86 256H182.14l10.05-30.85zM176 464c0 8.83-7.19 16-16 16h-16c-8.81 0-16-7.17-16-16v-16h48v16zm336 0c0 8.83-7.19 16-16 16h-16c-8.81 0-16-7.17-16-16v-16h48v16zm0-80v32H128v-80c0-26.47 21.53-48 48-48h288c26.47 0 48 21.53 48 48v48zm-72.8-71.99c-24.1 0-55.2 23.24-55.2 47.93 0 11.98 5.85 32.07 45.06 32.07l10.14-.1c25.96 0 44.8-16.8 44.8-39.95 0-23.15-18.84-39.95-44.8-39.95zm0 55.9c-3.12 0-6.63.1-10.14.1-10.53 0-21.06-.9-21.06-8.07 0-9.57 18.72-23.93 31.2-23.93s20.8 6.38 20.8 15.95-8.33 15.95-20.8 15.95zm-238.4-55.9c-25.96 0-44.8 16.8-44.8 39.95 0 23.15 18.84 39.95 44.8 39.95l10.14.1c39.21 0 45.06-20.1 45.06-32.07 0-24.69-31.1-47.93-55.2-47.93zm10.14 56c-3.51 0-7.02-.1-10.14-.1-12.48 0-20.8-6.38-20.8-15.95s8.32-15.95 20.8-15.95 31.2 14.36 31.2 23.93c0 7.17-10.53 8.07-21.06 8.07z"]
  },
      At = {
    prefix: "fal",
    iconName: "car-mechanic",
    icon: [512, 512, [], "f5e3", "M510.15 53.28C498.82 21.41 468.6 0 434.94 0c-26.03 0-48.97 12.69-63.59 32h-230.7C126.04 12.69 103.09 0 77.06 0 43.4 0 13.18 21.41 1.85 53.28A31.966 31.966 0 0 0 4.29 80a32.036 32.036 0 0 0-2.44 26.72C13.18 138.59 43.4 160 77.06 160c26.02 0 48.95-12.68 63.57-31.97h230.74c14.62 19.29 37.55 31.97 63.57 31.97 33.66 0 63.89-21.41 75.21-53.28A32.04 32.04 0 0 0 507.71 80c4.67-8.08 5.6-17.84 2.44-26.72zM434.94 96H480c-6.61 18.6-24.19 32-45.06 32s-38.45-13.4-45.06-32H122.13c-6.61 18.6-24.19 32-45.06 32S38.61 114.6 32 96h45.06l16-16-16-16H32c6.61-18.6 24.19-32 45.06-32 20.88 0 38.47 13.41 45.07 32.03h267.73C396.47 45.41 414.06 32 434.94 32c20.87 0 38.45 13.4 45.06 32h-45.06l-16 16 16 16zm-5.56 165.74l-15.15-46.5c-10.73-32.93-41.43-55.22-76.07-55.22H173.83c-34.64 0-65.34 22.29-76.07 55.22l-15.15 46.5C53.01 273.47 32 302.22 32 336v128c0 26.47 21.53 48 48 48h16c26.47 0 48-21.53 48-48v-16h224v16c0 26.47 21.53 48 48 48h16c26.47 0 48-21.53 48-48V336c0-33.78-21.01-62.53-50.62-74.26zm-301.19-36.59a47.888 47.888 0 0 1 45.64-33.13h164.34c20.84 0 39.18 13.32 45.64 33.13L393.86 256H118.14l10.05-30.85zM112 464c0 8.83-7.19 16-16 16H80c-8.81 0-16-7.17-16-16v-16h48v16zm336 0c0 8.83-7.19 16-16 16h-16c-8.81 0-16-7.17-16-16v-16h48v16zm0-80v32H64v-80c0-26.47 21.53-48 48-48h288c26.47 0 48 21.53 48 48v48zm-72.8-71.99c-24.1 0-55.2 23.24-55.2 47.93 0 11.98 5.85 32.07 45.06 32.07l10.14-.1c25.96 0 44.8-16.8 44.8-39.95 0-23.15-18.84-39.95-44.8-39.95zm0 55.9c-3.12 0-6.63.1-10.14.1-10.53 0-21.06-.9-21.06-8.07 0-9.57 18.72-23.93 31.2-23.93s20.8 6.38 20.8 15.95-8.32 15.95-20.8 15.95zm-238.4-55.9c-25.96 0-44.8 16.8-44.8 39.95 0 23.15 18.84 39.95 44.8 39.95l10.14.1c39.21 0 45.06-20.1 45.06-32.07 0-24.69-31.1-47.93-55.2-47.93zm10.14 56c-3.51 0-7.02-.1-10.14-.1-12.48 0-20.8-6.38-20.8-15.95s8.32-15.95 20.8-15.95 31.2 14.36 31.2 23.93c0 7.17-10.53 8.07-21.06 8.07z"]
  },
      Nt = {
    prefix: "fal",
    iconName: "car-side",
    icon: [640, 512, [], "f5e4", "M544 192h-16L419.21 56.02A63.99 63.99 0 0 0 369.24 32H171.33c-26.17 0-49.7 15.93-59.42 40.23L64 192c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM288 64h81.24c9.77 0 18.88 4.38 24.99 12.01L487.02 192H288V64zM141.62 84.12C146.51 71.89 158.17 64 171.33 64H256v128H98.46l43.16-107.88zM160 448c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm128-96h-37.88c-13.22-37.2-48.38-64-90.12-64s-76.9 26.8-90.12 64H250.12c-13.22-37.2-48.38-64-90.12-64s-76.9 26.8-90.12 64H32v-96c0-17.64 14.36-32 32-32h480c35.29 0 64 28.71 64 64v64z"]
  },
      gt = {
    prefix: "fal",
    iconName: "car-tilt",
    icon: [640, 512, [], "f5e5", "M179.55 305.94c-18.28 18.28-19.71 43.37-3.42 59.67 16.3 16.3 41.4 14.87 59.68-3.41l7.21-7.07c27.61-27.61 17.58-45.88 9.14-54.31-17.38-17.38-55.64-11.85-72.61 5.12zm46.57 32.29c-2.47 2.47-5.01 4.87-7.21 7.07-8.79 8.79-19.14 10.15-25.88 3.41-6.74-6.74-5.37-17.09 3.41-25.88 8.79-8.79 32.07-11.86 38.81-5.12 5.06 5.06-1.72 13.11-9.13 20.52zM632 480H307.39c13.09-18.64 12.16-44.2-4.48-60.84l-22.53-22.53 180.26-180.25 22.53 22.53c18.64 18.64 48.96 18.64 67.6 0l11.27-11.27c18.64-18.64 18.64-48.96 0-67.6L460.63 58.65c-25.4-25.39-63.53-29.7-93.65-13.63L295.49 8.66c-30.74-15.63-68.05-9.71-92.44 14.68L87.33 139.05c-24.39 24.39-30.31 61.7-14.68 92.45l36.36 71.48c-16.06 30.13-11.76 68.26 13.63 93.65L206.02 480H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h624c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-92.51-297.43c6.22 6.22 6.21 16.33 0 22.53l-11.27 11.27c-6.21 6.21-16.32 6.21-22.53 0l-22.53-22.53 33.8-33.8 22.53 22.53zm-438.43 34.48c-9.41-18.5-5.87-40.79 8.81-55.47L225.58 45.87a47.715 47.715 0 0 1 55.47-8.81l58.67 29.84L130.9 275.72l-29.84-58.67zm100.45 213.38l-56.33-56.33c-18.64-18.63-18.64-48.96 0-67.6L370.5 81.18c18.64-18.64 48.96-18.64 67.6 0l33.8 33.8 22.53 22.53-33.8 33.8-22.53 22.53-236.59 236.59zm78.86 33.79l-11.27 11.27c-2.9 2.9-6.68 4.32-10.5 4.51h-1.53c-3.82-.18-7.6-1.6-10.51-4.51l-22.53-22.53 33.8-33.8 22.53 22.53c6.23 6.22 6.22 16.33.01 22.53zm149.24-352.09c-16.3-16.3-41.39-14.86-59.67 3.41-16.97 16.97-22.5 55.23-5.12 72.61 8.44 8.44 26.71 18.46 54.31-9.14l7.07-7.21c18.28-18.27 19.71-43.36 3.41-59.67zm-20.31 42.78c-2.2 2.2-4.6 4.74-7.07 7.21-7.41 7.41-15.46 14.2-20.51 9.14-6.74-6.74-3.67-30.03 5.12-38.81 8.79-8.79 19.14-10.15 25.88-3.42s5.37 17.09-3.42 25.88z"]
  },
      Ht = {
    prefix: "fal",
    iconName: "car-wash",
    icon: [448, 512, [], "f5e6", "M80 128c26.47 0 48-21.6 48-48.16 0-20.52-24.38-58.12-34.84-73.32-5.94-8.69-20.38-8.69-26.31 0C56.38 21.72 32 59.32 32 79.84 32 106.4 53.53 128 80 128zm0-82.61c9.22 15.57 15.88 29.55 16 34.44 0 8.86-7.19 16.05-16 16.05s-16-7.2-16-16.04c.12-4.89 6.78-18.88 16-34.45zM224 128c26.47 0 48-21.6 48-48.16 0-20.52-24.38-58.12-34.84-73.32-5.94-8.69-20.38-8.69-26.31 0C200.38 21.72 176 59.32 176 79.84c0 26.56 21.53 48.16 48 48.16zm0-82.61c9.22 15.57 15.88 29.55 16 34.44 0 8.86-7.19 16.05-16 16.05s-16-7.2-16-16.04c.12-4.89 6.78-18.88 16-34.45zM368 128c26.47 0 48-21.6 48-48.16 0-20.52-24.38-58.12-34.84-73.32-5.94-8.69-20.38-8.69-26.31 0C344.38 21.72 320 59.32 320 79.84c0 26.56 21.53 48.16 48 48.16zm0-82.61c9.22 15.57 15.88 29.55 16 34.44 0 8.86-7.19 16.05-16 16.05s-16-7.2-16-16.04c.12-4.89 6.78-18.88 16-34.45zm29.38 216.35l-15.15-46.5c-10.73-32.93-41.43-55.22-76.07-55.22H141.83c-34.64 0-65.34 22.29-76.07 55.22l-15.15 46.5C21.01 273.47 0 302.22 0 336v128c0 26.47 21.53 48 48 48h16c26.47 0 48-21.53 48-48v-16h224v16c0 26.47 21.53 48 48 48h16c26.47 0 48-21.53 48-48V336c0-33.78-21.01-62.53-50.62-74.26zM96.19 225.15a47.888 47.888 0 0 1 45.64-33.13h164.34c20.84 0 39.18 13.32 45.64 33.13L361.86 256H86.14l10.05-30.85zM80 464c0 8.83-7.19 16-16 16H48c-8.81 0-16-7.17-16-16v-16h48v16zm336 0c0 8.83-7.19 16-16 16h-16c-8.81 0-16-7.17-16-16v-16h48v16zm0-80v32H32v-80c0-26.47 21.53-48 48-48h288c26.47 0 48 21.53 48 48v48zm-72.8-71.99c-24.1 0-55.2 23.24-55.2 47.93 0 11.98 5.85 32.07 45.06 32.07l10.14-.1c25.96 0 44.8-16.8 44.8-39.95 0-23.15-18.84-39.95-44.8-39.95zm0 55.9c-3.12 0-6.63.1-10.14.1-10.53 0-21.06-.9-21.06-8.07 0-9.57 18.72-23.93 31.2-23.93s20.8 6.38 20.8 15.95-8.32 15.95-20.8 15.95zm-238.4-55.9c-25.96 0-44.8 16.8-44.8 39.95 0 23.15 18.84 39.95 44.8 39.95l10.14.1c39.21 0 45.06-20.1 45.06-32.07 0-24.69-31.1-47.93-55.2-47.93zm10.14 56c-3.51 0-7.02-.1-10.14-.1-12.48 0-20.8-6.38-20.8-15.95s8.32-15.95 20.8-15.95 31.2 14.36 31.2 23.93c0 7.17-10.53 8.07-21.06 8.07z"]
  },
      Vt = {
    prefix: "fal",
    iconName: "caravan",
    icon: [640, 512, [], "f8ff", "M416,240a16,16,0,1,0-16-16A16,16,0,0,0,416,240ZM632,352H576V160A160,160,0,0,0,416,0H96A96,96,0,0,0,0,96V288a96,96,0,0,0,96,96,96,96,0,0,0,192,0H632a8,8,0,0,0,8-8V360A8,8,0,0,0,632,352ZM192,448a64,64,0,1,1,64-64A64.07,64.07,0,0,1,192,448Zm256-96H352V128h96Zm96,0H480V128a32,32,0,0,0-32-32H352a32,32,0,0,0-32,32V352H282.12c-13.22-37.2-48.38-64-90.12-64s-76.9,26.8-90.12,64H96a64.07,64.07,0,0,1-64-64V96A64.07,64.07,0,0,1,96,32H416A128.14,128.14,0,0,1,544,160ZM240,96H112a32,32,0,0,0-32,32v64a32,32,0,0,0,32,32H240a32,32,0,0,0,32-32V128A32,32,0,0,0,240,96Zm0,96H112V128H240Z"]
  },
      xt = {
    prefix: "fal",
    iconName: "caravan-alt",
    icon: [640, 512, [], "e000", "M432,96H368a32,32,0,0,0-32,32v64a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V128A32,32,0,0,0,432,96Zm0,96H368V128h64ZM632,352H576V160A160,160,0,0,0,416,0H96A96,96,0,0,0,0,96V288a96,96,0,0,0,96,96,96,96,0,0,0,192,0H632a8,8,0,0,0,8-8V360A8,8,0,0,0,632,352ZM192,448a64,64,0,1,1,64-64A64.07,64.07,0,0,1,192,448Zm352-96H282.12c-13.22-37.2-48.38-64-90.12-64s-76.9,26.8-90.12,64H96a64.07,64.07,0,0,1-64-64V96A64.07,64.07,0,0,1,96,32H416A128.14,128.14,0,0,1,544,160ZM240,96H112a32,32,0,0,0-32,32v64a32,32,0,0,0,32,32H240a32,32,0,0,0,32-32V128A32,32,0,0,0,240,96Zm0,96H112V128H240Z"]
  },
      wt = {
    prefix: "fal",
    iconName: "caret-circle-down",
    icon: [512, 512, [], "f32d", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-120-32l-96 96-96-96h192m-192-32c-28.4 0-42.8 34.5-22.6 54.6l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c20.1-20.1 5.9-54.6-22.6-54.6H160z"]
  },
      yt = {
    prefix: "fal",
    iconName: "caret-circle-left",
    icon: [512, 512, [], "f32e", "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zM256 472c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm32-120l-96-96 96-96v192m32-192c0-28.4-34.5-42.8-54.6-22.6l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c20.1 20.1 54.6 5.9 54.6-22.6V160z"]
  },
      bt = {
    prefix: "fal",
    iconName: "caret-circle-right",
    icon: [512, 512, [], "f330", "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zM256 40c118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216zm-32 120l96 96-96 96V160m-32 192c0 28.4 34.5 42.8 54.6 22.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-20.1-20.1-54.6-5.9-54.6 22.6V352z"]
  },
      St = {
    prefix: "fal",
    iconName: "caret-circle-up",
    icon: [512, 512, [], "f331", "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zM40 256c0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216zm120 32l96-96 96 96H160m192 32c28.4 0 42.8-34.5 22.6-54.6l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-20.1 20.1-5.9 54.6 22.6 54.6H352z"]
  },
      Tt = {
    prefix: "fal",
    iconName: "caret-down",
    icon: [320, 512, [], "f0d7", "M287.968 160H32.038c-28.425 0-42.767 34.488-22.627 54.627l127.962 128c12.496 12.496 32.758 12.497 45.255 0l127.968-128C330.695 194.528 316.45 160 287.968 160zM160 320L32 192h256L160 320z"]
  },
      Dt = {
    prefix: "fal",
    iconName: "caret-left",
    icon: [192, 512, [], "f0d9", "M192 383.968v-255.93c0-28.425-34.488-42.767-54.627-22.627l-128 127.962c-12.496 12.496-12.497 32.758 0 45.255l128 127.968C157.472 426.695 192 412.45 192 383.968zM32 256l128-128v256L32 256z"]
  },
      jt = {
    prefix: "fal",
    iconName: "caret-right",
    icon: [192, 512, [], "f0da", "M0 128.032v255.93c0 28.425 34.488 42.767 54.627 22.627l128-127.962c12.496-12.496 12.497-32.758 0-45.255l-128-127.968C34.528 85.305 0 99.55 0 128.032zM160 256L32 384V128l128 128z"]
  },
      Et = {
    prefix: "fal",
    iconName: "caret-square-down",
    icon: [448, 512, [], "f150", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352zm-96-208l-96 96-96-96h192m-192-32c-28.4 0-42.8 34.5-22.6 54.6l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c20.1-20.1 5.9-54.6-22.6-54.6H128z"]
  },
      kt = {
    prefix: "fal",
    iconName: "caret-square-left",
    icon: [448, 512, [], "f191", "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM48 448c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48zm208-96l-96-96 96-96v192m32-192c0-28.4-34.5-42.8-54.6-22.6l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c20.1 20.1 54.6 5.9 54.6-22.6V160z"]
  },
      It = {
    prefix: "fal",
    iconName: "caret-square-right",
    icon: [448, 512, [], "f152", "M0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80zm400-16c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352zm-208 96l96 96-96 96V160m-32 192c0 28.4 34.5 42.8 54.6 22.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-20.1-20.1-54.6-5.9-54.6 22.6V352z"]
  },
      Ot = {
    prefix: "fal",
    iconName: "caret-square-up",
    icon: [448, 512, [], "f151", "M48 480h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48zM32 80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80zm96 208l96-96 96 96H128m192 32c28.4 0 42.8-34.5 22.6-54.6l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-20 20.1-5.8 54.6 22.7 54.6h192z"]
  },
      Qt = {
    prefix: "fal",
    iconName: "caret-up",
    icon: [320, 512, [], "f0d8", "M32.032 352h255.93c28.425 0 42.767-34.488 22.627-54.627l-127.962-128c-12.496-12.496-32.758-12.497-45.255 0l-127.968 128C-10.695 317.472 3.55 352 32.032 352zM160 192l128 128H32l128-128z"]
  },
      Zt = {
    prefix: "fal",
    iconName: "carrot",
    icon: [512, 512, [], "f787", "M504.6 138.5c-22.9-27.6-53.4-43.4-86.4-44.8-1.6-32.1-17.1-63.4-44.7-86.3-5.9-4.9-13.1-7.4-20.4-7.4-7.2 0-14.5 2.5-20.4 7.4-27.2 22.6-43.1 53-44.6 85.8-.7 14.5 1.8 28.7 6.6 42.2-13.3-4.4-26.8-7.3-40.3-7.3-48 0-94.1 26.8-116.6 72.8L2.4 478.3c-3 6.2-3.3 13.8 0 20.5 4.1 8.3 12.4 13.1 21 13.1 3.4 0 6.9-.8 10.2-2.4L311.2 374c25-12.2 46.4-32.6 59.6-59.6 15.4-31.5 16.7-66.2 6.5-97.1 11.8 4.1 23.9 6.6 36.4 6.6 34.7 0 67-15.9 90.9-44.7 9.9-11.7 9.9-28.9 0-40.7zm-162.5 162c-9.6 19.7-25.2 35.3-44.9 44.9l-124.8 60.9c-.4-.5-.6-1.1-1.1-1.6l-32-32c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6l25.6 25.6-100.2 49L154 240.6l26.7 26.7c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7c6.2-6.2 6.2-16.4 0-22.6l-32-32c-.7-.7-1.7-1.1-2.5-1.7 17.1-31.5 49.4-51 85.6-51 14.9 0 29.2 3.3 42.7 9.9 23.4 11.4 41 31.3 49.5 56s6.9 51.1-4.5 74.6zM413.8 192c-21.5 0-43.1-8.9-60.6-26.5l-6.7-6.7c-37.2-37.1-35.4-92 6.6-126.8 33.2 27.5 41.5 67.6 25.3 101.6 11.2-5.3 23-8 34.9-8 24.1 0 48.3 11.1 66.7 33.3-18.3 22.1-42.3 33.1-66.2 33.1z"]
  },
      Ut = {
    prefix: "fal",
    iconName: "cars",
    icon: [640, 512, [], "f85b", "M241.85 256H46.22A14.24 14.24 0 0 1 32 241.78v-55.11A42.72 42.72 0 0 1 74.67 144h266.66c.29 0 .53.16.81.16.65 0 1.27-.16 1.93-.16h58.14a75.19 75.19 0 0 0-30.81-25.56l-15.88-68.83A63.71 63.71 0 0 0 293.16 0H120.07a63.7 63.7 0 0 0-62.36 49.61l-16.28 70.55C17 132.44 0 157.49 0 186.67v55.11a46.14 46.14 0 0 0 32 43.75V320a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-32h143.65c4.31-4.29 8.57-8.65 13.64-12.21zM88.89 56.81A32 32 0 0 1 120.07 32h173.09a32 32 0 0 1 31.18 24.81L337.07 112H76.15zM64 196a20 20 0 1 0 20-20 20 20 0 0 0-20 20zm244 156a20 20 0 1 0 20 20 20 20 0 0 0-20-20zm248 0a20 20 0 1 0 20 20 20 20 0 0 0-20-20zm39.4-57.56l-15.88-68.83A63.71 63.71 0 0 0 517.16 176H344.07a63.7 63.7 0 0 0-62.36 49.61l-16.28 70.55C241 308.44 224 333.49 224 362.67v55.11a46.14 46.14 0 0 0 32 43.75V496a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-32h256v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-34.47a46.14 46.14 0 0 0 32-43.75v-55.11a74.7 74.7 0 0 0-44.6-68.23zm-282.51-61.63A32 32 0 0 1 344.07 208h173.09a32 32 0 0 1 31.18 24.81L561.07 288H300.15zM608 417.78A14.24 14.24 0 0 1 593.78 432H270.22A14.24 14.24 0 0 1 256 417.78v-55.11A42.72 42.72 0 0 1 298.67 320h266.66A42.72 42.72 0 0 1 608 362.67z"]
  },
      Bt = {
    prefix: "fal",
    iconName: "cart-arrow-down",
    icon: [576, 512, [], "f218", "M551.991 64H129.28l-8.329-44.423C118.822 8.226 108.911 0 97.362 0H12C5.373 0 0 5.373 0 12v8c0 6.627 5.373 12 12 12h78.72l69.927 372.946C150.305 416.314 144 431.42 144 448c0 35.346 28.654 64 64 64s64-28.654 64-64a63.681 63.681 0 0 0-8.583-32h145.167a63.681 63.681 0 0 0-8.583 32c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64 0-17.993-7.435-34.24-19.388-45.868C506.022 391.891 496.76 384 485.328 384H189.28l-12-64h331.381c11.368 0 21.177-7.976 23.496-19.105l43.331-208C578.592 77.991 567.215 64 551.991 64zM240 448c0 17.645-14.355 32-32 32s-32-14.355-32-32 14.355-32 32-32 32 14.355 32 32zm224 32c-17.645 0-32-14.355-32-32s14.355-32 32-32 32 14.355 32 32-14.355 32-32 32zm38.156-192H171.28l-36-192h406.876l-40 192zm-106.641-75.515l-51.029 51.029c-4.686 4.686-12.284 4.686-16.971 0l-51.029-51.029c-7.56-7.56-2.206-20.485 8.485-20.485H320v-52c0-6.627 5.373-12 12-12h8c6.627 0 12 5.373 12 12v52h35.029c10.691 0 16.045 12.926 8.486 20.485z"]
  },
      Rt = {
    prefix: "fal",
    iconName: "cart-plus",
    icon: [576, 512, [], "f217", "M551.991 64H129.28l-8.329-44.423C118.822 8.226 108.911 0 97.362 0H12C5.373 0 0 5.373 0 12v8c0 6.627 5.373 12 12 12h78.72l69.927 372.946C150.305 416.314 144 431.42 144 448c0 35.346 28.654 64 64 64s64-28.654 64-64a63.681 63.681 0 0 0-8.583-32h145.167a63.681 63.681 0 0 0-8.583 32c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64 0-17.993-7.435-34.24-19.388-45.868C506.022 391.891 496.76 384 485.328 384H189.28l-12-64h331.381c11.368 0 21.177-7.976 23.496-19.105l43.331-208C578.592 77.991 567.215 64 551.991 64zM464 416c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32zm-256 0c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32zm294.156-128H171.28l-36-192h406.876l-40 192zM272 196v-8c0-6.627 5.373-12 12-12h36v-36c0-6.627 5.373-12 12-12h8c6.627 0 12 5.373 12 12v36h36c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-36v36c0 6.627-5.373 12-12 12h-8c-6.627 0-12-5.373-12-12v-36h-36c-6.627 0-12-5.373-12-12z"]
  },
      Yt = {
    prefix: "fal",
    iconName: "cash-register",
    icon: [512, 512, [], "f788", "M232 248c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16zm-96 0c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16zm32 48h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm96 0h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm64-48c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16zm183.4 131.5l-25.5-178.3c-3.4-23.6-23.6-41.2-47.5-41.2H192V96h80c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h80v64H73.6c-23.9 0-44.1 17.6-47.5 41.2L.6 379.5c-.4 3-.6 6-.6 9.1V464c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-75.5c0-3-.2-6-.6-9zM96 64V32h160v32H96zM57.8 205.7c1.1-7.8 7.9-13.7 15.8-13.7h364.7c7.9 0 14.7 5.9 15.8 13.7L479.7 384H32.3l25.5-178.3zM480 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-48h448v48zm-72-232h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-48 64h-16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"]
  },
      Pt = {
    prefix: "fal",
    iconName: "cassette-tape",
    icon: [512, 512, [], "f8ab", "M464 64H48a48 48 0 0 0-48 48v288a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V112a48 48 0 0 0-48-48zM123.78 416l24-48h216.44l24 48zM480 400a16 16 0 0 1-16 16h-40l-40-80H128l-40 80H48a16 16 0 0 1-16-16V112a16 16 0 0 1 16-16h416a16 16 0 0 1 16 16zM368 160H144a64 64 0 0 0 0 128h224a64 64 0 0 0 0-128zm-224 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm168.88 0H199.12a62.1 62.1 0 0 0 0-64h113.76a62.1 62.1 0 0 0 0 64zm55.12 0a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"]
  },
      Ft = {
    prefix: "fal",
    iconName: "cat",
    icon: [576, 512, [], "f6be", "M432 128c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm48 16c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16-16 7.16-16 16zM544.01 0c-9.32 0-18.39 4.08-24.59 11.52L475.68 64h-23.36l-43.74-52.49A32.024 32.024 0 0 0 383.99 0C366.37 0 352 14.3 352 32v128h-16c-103.82 0-194.18 58.53-240 144.27V176c0-44.11-35.88-80-80-80-8.84 0-16 7.16-16 16s7.16 16 16 16c26.47 0 48 21.53 48 48v256c0 44.11 35.88 80 80 80h208c17.66 0 32-14.36 32-32 0-33.05-25.19-60.33-57.38-63.66L416 376.63V480c0 17.64 14.34 32 32 32h32c17.66 0 32-14.36 32-32V260.77c37.7-18.05 64-56.25 64-100.77V32c0-17.7-14.37-32-31.99-32zM480 480h-32V327.38l-144.81 64.37c-3.98-39-30.03-72.23-67.25-84.89-4.33-1.47-8.99 1.34-10.1 5.77l-3.88 15.55c-1.03 4.12 1.41 8.09 5.39 9.57A68.41 68.41 0 0 1 272 401.97V448h48c17.66 0 32 14.36 32 32H144c-26.47 0-48-21.53-48-48 0-132.34 107.66-240 240-240h21.22c13.87 46.1 56.22 80 106.78 80 5.48 0 10.73-.85 16-1.62V480zm64-320c0 44.18-35.82 80-80 80s-80-35.82-80-80V32l53.33 64h53.33L544 32v128z"]
  },
      Wt = {
    prefix: "fal",
    iconName: "cat-space",
    icon: [640, 512, [], "e001", "M512,176a16,16,0,1,0-16-16A15.9908,15.9908,0,0,0,512,176ZM576,32.72461V32l-.46094.3457C548.81445,12.30469,515.97461,0,480,0s-68.81445,12.30469-95.53906,32.3457L384,32v.72461C345.35156,61.93164,320,107.82422,320,160c0,.38086.10938.73242.11133,1.11328A272.01015,272.01015,0,0,0,96,304.26562V176A80.08413,80.08413,0,0,0,16,96a16,16,0,0,0,0,32,48.05249,48.05249,0,0,1,48,48V432a80.08413,80.08413,0,0,0,80,80H352a32.03165,32.03165,0,0,0,32-32,64.0956,64.0956,0,0,0-57.375-63.65625L416,376.625V480a32.03165,32.03165,0,0,0,32,32h32a32.03165,32.03165,0,0,0,32-32V316.77539A160.036,160.036,0,0,0,640,160C640,107.82422,614.64844,61.93164,576,32.72461ZM480,32a126.94015,126.94015,0,0,1,68.78906,20.4082L512,80H448L411.21094,52.4082A126.94015,126.94015,0,0,1,480,32Zm64,64v64a64,64,0,0,1-128,0V96l21.334,16h85.332ZM480,480H448V351.99609A15.99929,15.99929,0,0,0,425.5,337.377L303.1875,391.75a100.1169,100.1169,0,0,0-67.25-84.89062,7.96929,7.96929,0,0,0-10.09375,5.76562l-3.875,15.5625a8.16346,8.16346,0,0,0,5.375,9.5625C252,346.875,272,375.625,272,401.90625V448h48a32.03165,32.03165,0,0,1,32,32H144c-26.94531,0-48.13086-22.27344-47.99609-49.21875.63671-127.52734,101.31054-231.53516,227.36914-238.14063A160.02931,160.02931,0,0,0,480,320Zm0-192A128.14414,128.14414,0,0,1,352,160c0-32.16992,12.334-61.25391,32-83.76367V160a96,96,0,0,0,192,0V76.23633C595.666,98.74609,608,127.83008,608,160A128.14414,128.14414,0,0,1,480,288ZM432,160a16,16,0,1,0,16-16A15.9908,15.9908,0,0,0,432,160ZM162.94531,68.76953l39.71094,16.56055,16.5625,39.71094a5.32345,5.32345,0,0,0,9.53906,0l16.5586-39.71094,39.71484-16.56055a5.336,5.336,0,0,0,0-9.541l-39.71484-16.5586L228.75781,2.957a5.325,5.325,0,0,0-9.53906,0l-16.5625,39.71289-39.71094,16.5586a5.336,5.336,0,0,0,0,9.541Z"]
  },
      Gt = {
    prefix: "fal",
    iconName: "cauldron",
    icon: [448, 512, [], "f6bf", "M272 128c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm0-64c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm176 120v-16c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h46.73C20.78 237.78 0 293.62 0 345.6c0 39.08 11.82 70.65 32 95.53V496c0 8.84 7.16 16 16 16s16-7.16 16-16v-25.34C104.66 498.69 161.28 512 224 512c62.71 0 119.34-13.31 160-41.33V496c0 8.84 7.16 16 16 16s16-7.16 16-16v-54.87c20.18-24.88 32-56.45 32-95.53 0-51.98-20.78-107.82-54.73-153.6H440c4.42 0 8-3.58 8-8zm-32 161.6C416 466.9 281.73 480 224 480S32 466.9 32 345.6c0-52.25 24.14-110.02 63.64-153.6h256.71C391.86 235.58 416 293.35 416 345.6zM160 64c17.67 0 32-14.33 32-32S177.67 0 160 0s-32 14.33-32 32 14.33 32 32 32z"]
  },
      qt = {
    prefix: "fal",
    iconName: "cctv",
    icon: [576, 512, [], "f8ac", "M556.34 243.12l-40.43-17.79a44.91 44.91 0 0 0-18.47-69.25L149.8 3.22a45.59 45.59 0 0 0-56.28 19.61L6 176a45.43 45.43 0 0 0 23.53 65l160.15 66.31L148.93 416H32v-56a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v144a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-56h128a16 16 0 0 0 15-10.37l44.25-118 71.59 29.64a45.33 45.33 0 0 0 39.55-4.16l17.84-11.15 141 62c18.6 8.2 37-2.33 43.34-16.85l40.68-92.63a32.83 32.83 0 0 0-16.91-43.36zm-242.86 74.8a13 13 0 0 1-11.06 1.5L41.5 211.35l-.66-.25c-10-3.65-9.9-14.21-7-19.22L121.3 38.71c1.74-3 8-9.16 16.1-6l347.66 152.87a13.39 13.39 0 0 1 2.13 23.77zm188.61 48.69l-121-53.21 105.41-65.89 57.43 26z"]
  },
      Jt = {
    prefix: "fal",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", "M495.768 272.292l-16.72-16.363 16.719-16.362c30.04-28.786 16.251-79.537-23.83-89.365l-22.768-5.811 6.464-22.698c11.232-39.997-26.115-76.468-65.449-65.451l-22.672 6.461-5.809-22.778C351.926.052 300.89-13.786 272.299 16.142L256 32.934l-16.301-16.791c-28.323-29.647-79.535-16.514-89.405 23.793l-5.807 22.768-22.672-6.461c-39.14-10.992-76.677 25.224-65.449 65.45l6.464 22.698-22.767 5.811c-40.081 9.827-53.87 60.579-23.831 89.365l16.72 16.363-16.719 16.362c-30.04 28.786-16.251 79.537 23.83 89.365l22.768 5.811-6.464 22.698c-11.221 40.203 26.255 76.429 65.449 65.45l22.672-6.461 5.807 22.767c9.93 40.578 60.865 53.609 89.366 23.836L256 479.05l16.254 16.62c28.257 29.9 79.554 16.68 89.452-23.746l5.807-22.767 22.672 6.461c39.472 11.086 76.598-25.509 65.449-65.45l-6.464-22.698 22.767-5.811c40.082-9.829 53.87-60.581 23.831-89.367zm-31.567 58.313l-54.819 13.991 15.453 54.263c4.366 15.605-10.346 30.332-25.953 25.962l-54.245-15.458L330.65 464.2c-3.796 15.884-24.347 21.136-35.285 9.334L256 433.284l-39.366 40.251c-11.051 11.681-31.4 6.919-35.285-9.334l-13.986-54.837-54.245 15.458c-15.603 4.368-30.32-10.354-25.953-25.962l15.453-54.263-54.819-13.991c-15.733-3.762-21.326-23.942-9.331-35.297l40.237-39.379-40.237-39.379c-11.989-11.35-6.407-31.532 9.331-35.296l54.819-13.991L87.165 113c-4.366-15.605 10.346-30.332 25.953-25.962l54.245 15.458 13.986-54.837c3.743-15.664 24.233-21.016 35.285-9.334L256 78.873l39.366-40.548c11.179-11.816 31.583-6.152 35.285 9.334l13.986 54.837 54.245-15.458c15.603-4.368 30.32 10.354 25.953 25.962l-15.453 54.263 54.819 13.991c15.733 3.762 21.326 23.942 9.331 35.296l-40.237 39.379 40.237 39.379c11.989 11.351 6.407 31.533-9.331 35.297z"]
  },
      Kt = {
    prefix: "fal",
    iconName: "chair",
    icon: [448, 512, [], "f6c0", "M446.2 341.5l-22.2-64c-4.5-12.9-16.6-21.5-30.2-21.5H384V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h-9.8c-13.6 0-25.8 8.6-30.2 21.5l-22.2 64C-5.4 362.3 10 384 32 384v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V384h320v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V384c22 0 37.4-21.7 30.2-42.5zM288 37.9c37.2 13.2 64 48.4 64 90.1v128h-64zM192 32h64v224h-64zm-96 96c0-41.7 26.8-76.8 64-90.1V256H96zM32 352l22.2-64h339.6l22.2 64z"]
  },
      Xt = {
    prefix: "fal",
    iconName: "chair-office",
    icon: [384, 512, [], "f6c1", "M32 240v-96c0-8.84-7.16-16-16-16s-16 7.16-16 16v96c0 8.84 7.16 16 16 16s16-7.16 16-16zm314.49 47.03c-6.39-10.63-15.74-18.67-26.49-24.02V64c0-35.35-28.65-64-64-64H128C92.65 0 64 28.65 64 64v199.01c-10.75 5.35-20.1 13.39-26.49 24.02l-14.57 24.24C3.71 343.26 26.75 384 64.07 384H176v33.22c-35.61 5.41-65 28.54-77.85 59.63-6.41 15.51 2.41 35.14 15.02 35.14h157.66c12.61 0 21.44-19.63 15.02-35.14-12.85-31.08-42.24-54.22-77.85-59.63V384h111.93c37.33 0 60.37-40.74 41.14-72.73l-14.58-24.24zM96 64c0-17.64 14.36-32 32-32h128c17.64 0 32 14.36 32 32v192H96V64zm155.6 416H132.4c12.18-19.47 34.96-32 59.6-32s47.42 12.53 59.6 32zm82.25-136.12c-1.38 2.44-5.5 8.12-13.93 8.12H64.07c-8.42 0-12.54-5.68-13.93-8.12-1.38-2.44-4.13-8.9.21-16.12l14.57-24.24C70.69 293.95 81.19 288 92.36 288h199.28c11.17 0 21.67 5.95 27.43 15.52l14.57 24.24c4.34 7.21 1.59 13.68.21 16.12zM368 128c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16s16-7.16 16-16v-96c0-8.84-7.16-16-16-16z"]
  },
      _t = {
    prefix: "fal",
    iconName: "chalkboard",
    icon: [640, 512, [], "f51b", "M632 448h-24V64c0-17.67-14.33-32-32-32H64c-17.67 0-32 14.33-32 32v384H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h624c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-344 0v-64h192v64H288zm224 0v-64c0-17.67-14.33-32-32-32H288c-17.67 0-32 14.33-32 32v64H64V64h512v384h-64z"]
  },
      $t = {
    prefix: "fal",
    iconName: "chalkboard-teacher",
    icon: [640, 512, [], "f51c", "M608 0H192c-17.67 0-32 14.33-32 32v96c-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-41.74-26.8-76.9-64-90.12V32h416v352h-64v-64c0-17.67-14.33-32-32-32H384c-17.67 0-32 14.33-32 32v64h-46.66c-.59-.94-1.03-1.96-1.65-2.88-17.25-25.62-46.67-39.11-76.9-39.11C199 342.02 192.02 352 160 352c-31.97 0-38.95-9.98-66.79-9.98-30.23 0-59.65 13.48-76.9 39.11C6.01 396.42 0 414.84 0 434.67V472c0 22.09 17.91 40 40 40h240c22.09 0 40-17.91 40-40v-37.33c0-6.41-.84-12.6-2.04-18.67H608c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zM224 224c0 35.29-28.71 64-64 64s-64-28.71-64-64 28.71-64 64-64 64 28.71 64 64zm64 248c0 4.41-3.59 8-8 8H40c-4.41 0-8-3.59-8-8v-37.33c0-12.79 3.75-25.13 10.85-35.67 10.53-15.64 29.35-24.98 50.36-24.98 21.8 0 29.99 9.98 66.79 9.98 36.79 0 45.01-9.98 66.79-9.98 21 0 39.83 9.34 50.36 24.98 7.1 10.54 10.85 22.88 10.85 35.67V472zm224-88H384v-64h128v64z"]
  },
      cr = {
    prefix: "fal",
    iconName: "charging-station",
    icon: [576, 512, [], "f5e7", "M560 128h-16V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v48c0 38.7 27.48 70.97 64 78.39V384c0 17.64-14.34 32-32 32s-32-14.36-32-32v-48c0-44.11-35.88-80-80-80h-16V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v416H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h336c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-24V288h16c26.47 0 48 21.53 48 48v48c0 35.3 28.72 64 64 64s64-28.7 64-64V270.39c36.52-7.41 64-39.69 64-78.39v-48c0-8.84-7.16-16-16-16zM288 480H64V64c0-17.64 14.36-32 32-32h160c17.64 0 32 14.36 32 32v416zm256-288c0 26.47-21.53 48-48 48s-48-21.53-48-48v-32h96v32zm-304-16h-16.91l15.88-42.38C242.9 123.13 235.13 112 224 112h-80c-6.53 0-12.44 3.98-14.84 10.06l-32 80C92.94 212.59 100.72 224 112 224h19.5l-19.03 76.12c-3.89 15.5 15.22 26.76 26.84 15.19l112-112C261.35 193.24 254.24 176 240 176zm-82.47 75.84l10-39.97C170.06 201.7 162.35 192 152 192h-16.38l19.22-48h46.06l-15.88 42.38c-3.28 8.75 1.46 21.62 16.34 21.62l-43.83 43.84z"]
  },
      er = {
    prefix: "fal",
    iconName: "chart-area",
    icon: [512, 512, [], "f1fe", "M500 416c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v340h468zM372 162l-84 54-86.5-84.5c-5.1-5.1-13.4-4.6-17.9 1L64 288v96h416l-90.3-216.7c-3-6.9-11.5-9.4-17.7-5.3zM96 299.2l98.7-131.3 89.3 89.3 85.8-57.2 61.7 152H96v-52.8z"]
  },
      ar = {
    prefix: "fal",
    iconName: "chart-bar",
    icon: [512, 512, [], "f080", "M424 352h16c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zm-96 0h16c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm-192 0h16c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm96 0h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v208c0 4.4 3.6 8 8 8zm272 64H32V72c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v360c0 8.84 7.16 16 16 16h488c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"]
  },
      nr = {
    prefix: "fal",
    iconName: "chart-line",
    icon: [512, 512, [], "f201", "M504 416H32V72c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v360c0 8.84 7.16 16 16 16h488c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM98.34 263.03c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l72.69-72.01 84.69 84.69c6.25 6.25 16.38 6.25 22.63 0l93.53-93.53 44.04 44.04c4.95 4.95 11.03 7.16 17 7.16 12.48 0 24.46-9.7 24.46-24.34V112.19c0-8.94-7.25-16.19-16.19-16.19H344.34c-21.64 0-32.47 26.16-17.17 41.46l44.71 44.71-82.22 82.22-84.63-84.63c-6.23-6.23-16.32-6.25-22.57-.05l-84.12 83.32zM362.96 128H448v85.04L362.96 128z"]
  },
      tr = {
    prefix: "fal",
    iconName: "chart-line-down",
    icon: [512, 512, [], "f64d", "M504 416H32V72c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v360c0 8.84 7.16 16 16 16h488c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM182.45 236.29c6.26 6.2 16.35 6.18 22.57-.05l84.63-84.63 82.22 82.22-44.71 44.71c-15.3 15.3-4.46 41.46 17.17 41.46H463.8c8.94 0 16.19-7.25 16.19-16.19V184.34c0-14.64-11.98-24.34-24.46-24.34-5.97 0-12.05 2.21-17 7.16L394.5 211.2l-93.53-93.53c-6.25-6.25-16.38-6.25-22.63 0l-84.69 84.69-72.69-72.01c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l84.11 83.32zM448 202.96V288h-85.04L448 202.96z"]
  },
      rr = {
    prefix: "fal",
    iconName: "chart-network",
    icon: [640, 512, [], "f78a", "M513.6 202.8l-19.2-25.6-48 36 19.2 25.6 48-36zM576 192c13.3 0 25.6-4 35.8-10.9 6.8-4.6 12.7-10.5 17.3-17.3C636 153.6 640 141.3 640 128c0-13.3-4-25.6-10.9-35.8-2.3-3.4-4.9-6.6-7.8-9.5-2.9-2.9-6.1-5.5-9.5-7.8C601.6 68 589.3 64 576 64s-25.6 4-35.8 10.9c-6.8 4.6-12.7 10.5-17.3 17.3C516 102.4 512 114.7 512 128c0 35.3 28.7 64 64 64zm0-96c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM99.8 250.9C89.6 244 77.3 240 64 240s-25.6 4-35.8 10.9c-6.8 4.6-12.7 10.5-17.3 17.3C4 278.4 0 290.7 0 304c0 35.3 28.7 64 64 64s64-28.7 64-64c0-13.3-4-25.6-10.9-35.8-4.6-6.8-10.5-12.7-17.3-17.3zM64 336c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm88-16h48v-32h-48v32zm469.3 82.7c-2.9-2.9-6.1-5.5-9.5-7.8C601.6 388 589.3 384 576 384s-25.6 4-35.8 10.9c-3.3 2.2-6.3 4.7-9.1 7.5l-91.8-55.1c5.6-13.3 8.7-28 8.7-43.3 0-61.9-50.1-112-112-112-11.3 0-21.9 2.2-32.2 5.2l-39.3-84.1C278.8 101.4 288 83.9 288 64c0-13.3-4-25.6-10.9-35.8-4.6-6.8-10.5-12.7-17.3-17.3C249.6 4 237.3 0 224 0s-25.6 4-35.8 10.9c-6.8 4.6-12.7 10.5-17.3 17.3C164 38.4 160 50.7 160 64c0 35.3 28.7 64 64 64 4 0 7.9-.5 11.7-1.2l39 83.6c-30.5 20-50.7 54.4-50.7 93.6 0 61.9 50.1 112 112 112 35 0 65.8-16.4 86.4-41.5l92.4 55.4c-1.7 5.8-2.7 11.8-2.7 18.1 0 35.3 28.7 64 64 64 13.3 0 25.6-4 35.8-10.9 6.8-4.6 12.7-10.5 17.3-17.3C636 473.6 640 461.3 640 448c0-13.3-4-25.6-10.9-35.8-2.3-3.4-5-6.6-7.8-9.5zM224 96c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm112 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm240 96c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"]
  },
      ir = {
    prefix: "fal",
    iconName: "chart-pie",
    icon: [544, 512, [], "f200", "M527.79 288H290.5l158.03 158.03a16.51 16.51 0 0 0 11.62 4.81c3.82 0 7.62-1.35 10.57-4.13 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-67.91 124.12L367.76 320h140.88c-8.12 34.16-24.96 66-48.76 92.12zM224 288V50.71c0-8.83-7.18-16.21-15.74-16.21-.69 0-1.4.05-2.11.15C86.99 51.49-4.1 155.6.14 280.37 4.47 407.53 113.18 512 240.13 512c.98 0 1.93-.01 2.91-.02 50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288zm18.63 191.98l-2.51.02c-109.04 0-204.3-91.92-208-200.72C28.72 179.15 96.33 92.25 192 69.83v231.42l9.37 9.37 141.84 141.84c-30.56 17.62-64.96 27.08-100.58 27.52zM511.96 223.2C503.72 103.74 408.26 8.28 288.8.04c-.35-.03-.7-.04-1.04-.04C279.1 0 272 7.45 272 16.23V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM304 208V33.9c89.25 13.81 160.28 84.85 174.1 174.1H304z"]
  },
      or = {
    prefix: "fal",
    iconName: "chart-pie-alt",
    icon: [512, 512, [], "f64e", "M461.29 288H224V50.71c0-8.83-7.18-16.21-15.74-16.21-.69 0-1.4.05-2.11.15C87.08 51.47-3.96 155.43.13 280.07 4.2 404.1 107.91 507.8 231.93 511.87c2.69.09 5.39.13 8.07.13 121.04 0 220.89-89.66 237.35-206.16 1.33-9.45-6.52-17.84-16.06-17.84zM240 480c-2.33 0-4.68-.04-7.02-.12-107.24-3.52-197.35-93.63-200.87-200.87C28.84 179.02 96.45 92.23 192 69.83V320h250.15C420.27 412.43 336.49 480 240 480zM288.8.04c-.35-.03-.7-.04-1.04-.04C279.1 0 272 7.44 272 16.23V240h223.77c9.14 0 16.82-7.69 16.2-16.8C503.72 103.74 408.26 8.28 288.8.04zM304 208V33.9c89.25 13.81 160.28 84.85 174.1 174.1H304z"]
  },
      lr = {
    prefix: "fal",
    iconName: "chart-scatter",
    icon: [512, 512, [], "f7ee", "M504 416H32V72a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v360a16 16 0 0 0 16 16h488a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM160 312a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm256-160a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm-224 0a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm192 160a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm-96-64a24 24 0 1 0-24-24 24 24 0 0 0 24 24z"]
  },
      fr = {
    prefix: "fal",
    iconName: "check",
    icon: [448, 512, [], "f00c", "M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z"]
  },
      sr = {
    prefix: "fal",
    iconName: "check-circle",
    icon: [512, 512, [], "f058", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z"]
  },
      ur = {
    prefix: "fal",
    iconName: "check-double",
    icon: [448, 512, [], "f560", "M444.96 159l-12.16-11c-2.03-2.67-4.72-4-8.11-4s-6.08 1.33-8.11 4L131.77 428 31.42 329c-2.03-2.67-4.72-4-8.11-4s-6.08 1.33-8.11 4L3.04 340C1.01 342.67 0 345.67 0 349s1.01 6 3.04 8l120.62 119c2.69 2.67 5.57 4 8.62 4s5.92-1.33 8.62-4l304.07-300c2.03-2 3.04-4.67 3.04-8s-1.02-6.33-3.05-9zM127.17 284.03c2.65 2.65 5.48 3.97 8.47 3.97s5.82-1.32 8.47-3.97L365.01 63.8c1.99-2 2.99-4.65 2.99-7.96s-1-6.29-2.99-8.94l-11.96-10.93c-1.99-2.65-4.64-3.97-7.97-3.97s-5.98 1.32-7.97 3.97L135.14 236.34l-72.25-72.03c-1.99-2.65-4.64-3.97-7.97-3.97s-5.98 1.32-7.97 3.97l-11.96 10.93C33 177.89 32 180.87 32 184.18s1 5.96 2.99 7.95l92.18 91.9z"]
  },
      hr = {
    prefix: "fal",
    iconName: "check-square",
    icon: [448, 512, [], "f14a", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 32c8.823 0 16 7.178 16 16v352c0 8.822-7.177 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h352m-34.301 98.293l-8.451-8.52c-4.667-4.705-12.265-4.736-16.97-.068l-163.441 162.13-68.976-69.533c-4.667-4.705-12.265-4.736-16.97-.068l-8.52 8.451c-4.705 4.667-4.736 12.265-.068 16.97l85.878 86.572c4.667 4.705 12.265 4.736 16.97.068l180.48-179.032c4.704-4.667 4.735-12.265.068-16.97z"]
  },
      mr = {
    prefix: "fal",
    iconName: "cheese",
    icon: [512, 512, [], "f7ef", "M299.83 32h-1.49a32.27 32.27 0 0 0-19.64 7L0 255.87V448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V255.87C512 136.05 418 38.2 299.83 32zM480 448H32V287.89h448zM52.13 255.87L298.72 64C400.42 69.62 480 153.78 480 255.87z"]
  },
      vr = {
    prefix: "fal",
    iconName: "cheese-swiss",
    icon: [512, 512, [], "f7f0", "M176 319.9a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 64a16 16 0 1 1 16-16 16 16 0 0 1-16 16.04zM299.83 32h-1.49a32.27 32.27 0 0 0-19.64 7L0 255.87V448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V255.87C512 136.05 418 38.2 299.83 32zM240 127.79a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM480 448H32V287.89h290.94a47.72 47.72 0 0 0 90.12 0H480zM352 271.88a16 16 0 1 1 16 16 16 16 0 0 1-16-16zm61.06-16a47.72 47.72 0 0 0-90.12 0H52.13l140.17-109a47.89 47.89 0 1 0 62.38-48.58l44-34.26C400.42 69.62 480 153.78 480 255.87z"]
  },
      dr = {
    prefix: "fal",
    iconName: "cheeseburger",
    icon: [512, 512, [], "f7f1", "M304 144a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm208 176a63.81 63.81 0 0 0-30.2-54.1c13.5-20.9 18.5-52.9 6.3-79.1C448 100.3 359.5 32.1 256 32c-103.5.1-192 68.3-232.2 154.8-12.5 26.8-9.1 59.9 3.7 80.8a63.46 63.46 0 0 0-16.3 88.3 65.07 65.07 0 0 0 10.1 11.5c-3.1 4.9-5.3 10.4-5.3 16.6v32a64.06 64.06 0 0 0 64 64h352a64.06 64.06 0 0 0 64-64v-32c0-6.2-2.2-11.7-5.3-16.6A64.06 64.06 0 0 0 512 320zM52.81 200.3C90.71 118.9 172.31 64.1 256 64c83.69.1 165.39 54.9 203.19 136.3 5.8 12.5 5.2 29.5-1.4 43.5a5.94 5.94 0 0 1-.4.8A21 21 0 0 1 438.5 256H70.11c-6.1 0-12.2-2.4-16-7.2a14.75 14.75 0 0 1-2.5-4.4c-5.2-13.9-4.8-31.2 1.2-44.1zM464 416a32 32 0 0 1-32 32H80a32 32 0 0 1-32-32v-32h416zm-16-64H64a32 32 0 1 1 0-64h160l96 48 96-48h32a32 32 0 0 1 0 64zm-64-144a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-256 0a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm80-64a16 16 0 1 0-16-16 16 16 0 0 0 16 16z"]
  },
      Mr = {
    prefix: "fal",
    iconName: "chess",
    icon: [512, 512, [], "f439", "M400 320a16 16 0 0 0-32 0v32h32zm103.16 115.57L480 424v-24a16 16 0 0 0-16-16h-1.1l-2.83-82.21 24.6-20.79A32 32 0 0 0 496 256.54V176a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v80.6a32 32 0 0 0 11.35 24.4l24.57 20.76L305.1 384H304a16 16 0 0 0-16 16v24l-23.15 11.57a16 16 0 0 0-8.85 14.31 16 16 0 0 0-8.84-14.31L224 424v-24a16 16 0 0 0-16-16h-6.4c-6-30.16-9.6-60.75-9.6-91.47V256h24a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16.9l31.81-84.78a32 32 0 0 0-30-43.22H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a32 32 0 0 0-30 43.25L56.91 224H40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v36.53c0 30.71-3.56 61.31-9.6 91.47H48a16 16 0 0 0-16 16v24L8.84 435.57c-4.25 2.13-6.7 6.19-7.81 10.68-.3 1.24-1 2.33-1 3.64V496a16 16 0 0 0 16 16H240a16 16 0 0 0 16-16 16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-46.12a16 16 0 0 0-8.84-14.31zM55.09 128h145.85l-36 96H91.09zm113.79 256H87.12A499.15 499.15 0 0 0 96 292.53V256h64v36.53a499.15 499.15 0 0 0 8.88 91.47zM224 480H32v-20.22l32-16V416h128v27.78l32 16zm80-223.4V192h32v32h32v-32h32v32h32v-32h32v64.54l-24.6 20.82-11.84 10 .53 15.5 2.79 81.14h-93.76l2.79-81.1.53-15.52-11.86-10zM480 480H288v-20.22l32-16V416h128v27.78l32 16z"]
  },
      pr = {
    prefix: "fal",
    iconName: "chess-bishop",
    icon: [320, 512, [], "f43a", "M64 400v48h32v-71.41l-22.31-7.09C53.54 363.1 32 342.52 32 304c0-58.29 54.72-162.67 99.6-208h56.8c19.29 19.48 40.19 50 58 83l-84 84a8 8 0 0 0 0 11.32l11.31 11.31a8 8 0 0 0 11.32 0l76.43-76.44C277.09 243.77 288 278.35 288 304c0 38.52-21.54 59.1-41.69 65.5L224 376.59V448h32v-48c33.86-10.76 64-44.36 64-96 0-72.64-66.43-194.57-119-240h-82C66.43 109.43 0 231.36 0 304c0 51.64 30.14 85.24 64 96zm248 80H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h304a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM112 32h96a16 16 0 0 0 0-32h-96a16 16 0 0 0 0 32z"]
  },
      zr = {
    prefix: "fal",
    iconName: "chess-bishop-alt",
    icon: [256, 512, [], "f43b", "M247.16 435.58L224 424v-16a24 24 0 0 0-24-24h1.41a519 519 0 0 1-9.31-96H216a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-9.21c19.63-21.36 17.06-51.75 17.06-52.61 0-49.4-36.44-117.48-70.59-139.39h-1.1a16 16 0 0 0 0-32h-48a16 16 0 0 0 0 32h-1.07c-34.3 22-70.74 90.34-70.74 139.48 0 .7-2.55 31.09 17.1 52.52H40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h23.9a519 519 0 0 1-9.31 96H56a24 24 0 0 0-24 24v16L8.85 435.58A16 16 0 0 0 0 449.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-46.11a16 16 0 0 0-8.84-14.31zm-119-346.69c6.59 0 21.69 11.08 37.59 37.14l-44.68 46.34a6.46 6.46 0 0 0 0 8.82l14.09 14.61a5.92 5.92 0 0 0 8.5 0l37.5-38.89c6.69 16.92 10.69 33.61 10.69 46.57 0 34.42-19.1 36.82-31.69 40.55v12h-64V244c-12.41-3.63-31.69-6-31.69-40.55 0-45.69 43.69-114.56 63.69-114.56zM168.84 384H87.16a552.7 552.7 0 0 0 8.75-96h64.18a552.7 552.7 0 0 0 8.75 96zM224 480H32v-20.22l32-16V416h128v27.78l32 16z"]
  },
      Cr = {
    prefix: "fal",
    iconName: "chess-board",
    icon: [512, 512, [], "f43c", "M320.07 448h64v-64h-64zm-127.95 0h64v-64h-64zM64.18 256.1v64h64v-64zM192.12 64.17h-64v64h64zM448 256.1v-64h-64v64zm0-191.93h-64v64h64zm0 319.88v-64h-64v64zM320 64.17h-64v64h64zm-255.89 64v64h64v-64zm255.89 128v-64h-64v64zm-64-64v-64h-64v64zm-64 0h-64v64h64zM128 384.1H64v64h64zm64-64h-64v64h64zm192.05-127.98v-64h-64v64zm-127.95 64h-64v64h64zm0 64v64h64v-64zm64 0h64v-64h-64zM480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm0 480H32V32h448z"]
  },
      Lr = {
    prefix: "fal",
    iconName: "chess-clock",
    icon: [640, 512, [], "f43d", "M464 416a112 112 0 1 0-112-112 112 112 0 0 0 112 112zm0-192a79.42 79.42 0 0 1 43.85 13.22l-56.52 56.53a12 12 0 0 0 0 17l5.65 5.65a12 12 0 0 0 17 0l56.6-56.6A79.93 79.93 0 1 1 464 224zM176 416A112 112 0 1 0 64 304a112 112 0 0 0 112 112zm-16-190.37V308a12 12 0 0 0 12 12h8a12 12 0 0 0 12-12v-82.37a80 80 0 1 1-32 0zM608 128h-72a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H392a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8H192V64h56a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h56v64H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32zm0 320H32V160h576z"]
  },
      Ar = {
    prefix: "fal",
    iconName: "chess-clock-alt",
    icon: [640, 512, [], "f43e", "M464 416a112 112 0 1 0-112-112 112 112 0 0 0 112 112zm-16-190.37V308a12 12 0 0 0 12 12h8a12 12 0 0 0 12-12v-82.37a80 80 0 1 1-32 0zM608 128H480V64h56a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8H392a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h56v64H248a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32zm0 320H32V160h576zm-432-32A112 112 0 1 0 64 304a112 112 0 0 0 112 112zm0-192a79.42 79.42 0 0 1 43.85 13.22l-56.52 56.53a12 12 0 0 0 0 17l5.65 5.65a12 12 0 0 0 17 0l56.6-56.6A79.93 79.93 0 1 1 176 224z"]
  },
      Nr = {
    prefix: "fal",
    iconName: "chess-king",
    icon: [448, 512, [], "f43f", "M408 480H40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h368a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm31.34-301.88A44 44 0 0 0 403.51 160H240V96h56a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8h-56V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h56v64H44.46a44.46 44.46 0 0 0-42.34 58L79 448h33.75L32.59 208.16A12.42 12.42 0 0 1 44.46 192h359.05c10.57 0 13.67 10.38 12 15.88L335.2 448H369l77-230.28a44.07 44.07 0 0 0-6.68-39.6z"]
  },
      gr = {
    prefix: "fal",
    iconName: "chess-king-alt",
    icon: [320, 512, [], "f440", "M295.16 435.58L272 424v-16a24 24 0 0 0-24-24h-13.09A469.21 469.21 0 0 1 224 284.53V256h24a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16.9l31.81-84.78a32 32 0 0 0-30-43.22H176V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24h-24a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H87.09a32 32 0 0 0-30 43.25L88.91 224H72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v28.53A469.21 469.21 0 0 1 85.09 384H72a24 24 0 0 0-24 24v16l-23.15 11.58A16 16 0 0 0 16 449.89V496a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-46.11a16 16 0 0 0-8.84-14.31zM87.09 128h145.85l-36 96h-73.85zM128 284.53V256h64v28.53A500.84 500.84 0 0 0 202.1 384h-84.2a500.84 500.84 0 0 0 10.1-99.47zM272 480H48v-20.22l32-16V416h160v27.78l32 16z"]
  },
      Hr = {
    prefix: "fal",
    iconName: "chess-knight",
    icon: [384, 512, [], "f441", "M35.48 301.64c38 16.9 36.79 16.47 40.39 17.68A100.72 100.72 0 0 0 32 402.82V448h32v-45.18a69.35 69.35 0 0 1 38.31-62L144.62 316a41.62 41.62 0 0 0 23-37.21v-62.25l-16.16 9.59a20.8 20.8 0 0 0-10.87 13.56l-8 26.57A27.75 27.75 0 0 1 116.32 284l-11.08 4.43a27.68 27.68 0 0 1-21.56-.41l-35.2-15.62A27.74 27.74 0 0 1 32 247.05v-119c0-10.4 6.44-15.06 13.86-22.49L33.55 81c-4.67-9.33 1.63-17 8.85-17H128c106 0 192 86 192 192v192h32V256c0-123.51-100.49-224-224-224H42.4A42.45 42.45 0 0 0 0 74.4a46.92 46.92 0 0 0 4.94 20.9l2.69 5.39A52.56 52.56 0 0 0 0 128.09v119a59.8 59.8 0 0 0 35.48 54.55zM64 164a20 20 0 1 0 20-20 20 20 0 0 0-20 20zm312 316H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h368a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      Vr = {
    prefix: "fal",
    iconName: "chess-knight-alt",
    icon: [320, 512, [], "f442", "M91.73 170.67a14.87 14.87 0 1 0-14.87 14.93 14.91 14.91 0 0 0 14.87-14.93zm219.43 264.91L288 424v-16c0-11.71-8.54-21-19.63-23.12l.88-.88A63.58 63.58 0 0 0 288 338.74V225.88C288 136.62 215.38 64 126.12 64H40a40 40 0 0 0-40 40 43.55 43.55 0 0 0 4.54 19.3l.36.74A47.92 47.92 0 0 0 0 145.22v83.37a53.41 53.41 0 0 0 31.61 48.72l26.68 11.91c-20.56 22.1-35.67 54.56-18.69 101.42A23.81 23.81 0 0 0 32 408v16L8.85 435.58A16 16 0 0 0 0 449.89V496a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-46.11a16 16 0 0 0-8.84-14.31zM44.65 248.09A21.36 21.36 0 0 1 32 228.59v-83.37a16 16 0 0 1 4.66-11.29l6-6L33.19 109a11.29 11.29 0 0 1-1.19-5 8 8 0 0 1 8-8h86.16C197.55 96 256 154.45 256 225.88v112.86a32 32 0 0 1-9.37 22.63L224 384H71.05c-35.32-86.63 73.62-95.47 73.62-133.8v-42.73l-21.26 5.06a15.93 15.93 0 0 0-8.32 10.47L109 243.35A21.26 21.26 0 0 1 96.53 257l-8.48 3.4a21.09 21.09 0 0 1-16.5-.31zM288 480H32v-20.22l14.31-7.16L64 443.78V416h192v27.78l17.69 8.84 14.31 7.16z"]
  },
      xr = {
    prefix: "fal",
    iconName: "chess-pawn",
    icon: [320, 512, [], "f443", "M312 480H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h304a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM56 256h40v32c0 73.62-11.36 128.34-33 160h36.8c18.66-37.54 28.2-91 28.2-160v-32h64v32c0 69 9.54 122.46 28.2 160H257c-21.6-31.66-33-86.38-33-160v-32h40a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-25.78a112 112 0 1 0-156.44 0H56a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm24-112a80 80 0 1 1 80 80 80.09 80.09 0 0 1-80-80z"]
  },
      wr = {
    prefix: "fal",
    iconName: "chess-pawn-alt",
    icon: [256, 512, [], "f444", "M247.16 435.58L224 424v-16a24 24 0 0 0-24-24h1.41a519 519 0 0 1-9.31-96H216a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16.91A95.86 95.86 0 1 0 32 192a95.3 95.3 0 0 0 24.91 64H40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h23.9a519 519 0 0 1-9.31 96H56a24 24 0 0 0-24 24v16L8.85 435.58A16 16 0 0 0 0 449.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-46.11a16 16 0 0 0-8.84-14.31zM160.09 288a552.7 552.7 0 0 0 8.75 96H87.16a552.7 552.7 0 0 0 8.75-96zM128 128a64 64 0 1 1-64 64 64.07 64.07 0 0 1 64-64zm96 352H32v-20.22l32-16V416h128v27.78l32 16z"]
  },
      yr = {
    prefix: "fal",
    iconName: "chess-queen",
    icon: [512, 512, [], "f445", "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm0-80a24 24 0 1 1-24 24 24 24 0 0 1 24-24zm184 448H72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h368a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm64.87-295.84l-28.51-15.92a15.09 15.09 0 0 0-8.45-2.59 17.59 17.59 0 0 0-13.84 7.27A47.48 47.48 0 0 1 416 192a50.79 50.79 0 0 1-9.16-.85C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49-1.12.07-2.23.11-3.33.11a47.47 47.47 0 0 1-38.21-19.26 17.17 17.17 0 0 0-13.61-7.13 15.16 15.16 0 0 0-8.48 2.59l-28.57 16a16 16 0 0 0-5.44 20.47L117.45 448h35.43l-116-243.82 4.12-2.27A78.8 78.8 0 0 0 96 224c1.81 0 3.65-.06 5.49-.19 35.63-2.41 64.68-29.1 72.46-63.81h8.73a80 80 0 0 0 146.64 0H338c6.95 31.66 31.32 56.74 63 62.61a82.66 82.66 0 0 0 15 1.39 78.81 78.81 0 0 0 55-22.09l4.07 2.27L359.11 448h35.44l115.76-243.37a16 16 0 0 0-5.44-20.47z"]
  },
      br = {
    prefix: "fal",
    iconName: "chess-queen-alt",
    icon: [256, 512, [], "f446", "M128 48a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm119.16 387.58L224 424v-16a23.72 23.72 0 0 0-20.95-23.38A469.21 469.21 0 0 1 192 284.53V256h24a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-22.39l50.93-124.23a7.46 7.46 0 0 0-2.54-9.55l-11.16-7.44a7.06 7.06 0 0 0-3.94-1.21 8.18 8.18 0 0 0-6.45 3.4 22.19 22.19 0 0 1-17.78 8.9 23.34 23.34 0 0 1-4.27-.4c-10.8-2-18.13-12.23-18.13-23.21A6.26 6.26 0 0 0 174 64h-18.07a6 6 0 0 0-6 4.62 22.41 22.41 0 0 1-43.86 0 6 6 0 0 0-6-4.62H82a6.26 6.26 0 0 0-6.26 6.26c0 12-8.89 22.75-20.85 23.56-.52 0-1 .05-1.55.05a22.17 22.17 0 0 1-17.84-9 8 8 0 0 0-6.35-3.33 7.13 7.13 0 0 0-4 1.21L14 90.22a7.46 7.46 0 0 0-2.53 9.55L62.39 224H40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v28.53a469.21 469.21 0 0 1-11 100.09A23.72 23.72 0 0 0 32 408v16L8.85 435.58A16 16 0 0 0 0 449.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-46.11a16 16 0 0 0-8.84-14.31zM56.7 125.77h.33a53.69 53.69 0 0 0 37.35-19 54.14 54.14 0 0 0 67.14.07 53.35 53.35 0 0 0 31.08 18.17 55.71 55.71 0 0 0 6.7.83L159 224H97zM170.1 384H85.9A500.84 500.84 0 0 0 96 284.53V256h64v28.53A500.84 500.84 0 0 0 170.1 384zm53.9 96H32v-20.22l32-16V416h128v27.78l32 16z"]
  },
      Sr = {
    prefix: "fal",
    iconName: "chess-rook",
    icon: [384, 512, [], "f447", "M376 480H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h368a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM352 32H32A32 32 0 0 0 0 64v167.34l56 48C56 322 57.57 372.73 45.35 448h32.47C89.44 373.48 88 326.59 88 264.66l-56-48V64h80l.09 64h32V64H240v64h32V64h80v152.66l-56 48c0 62.63-1.41 109 10.18 183.34h32.47C326.43 372.77 328 322.05 328 279.34l56-48V64a32 32 0 0 0-32-32zM192 192a48.05 48.05 0 0 0-48 48v80h96v-80a48.05 48.05 0 0 0-48-48zm16 96h-32v-48a16 16 0 0 1 32 0z"]
  },
      Tr = {
    prefix: "fal",
    iconName: "chess-rook-alt",
    icon: [320, 512, [], "f448", "M311.16 427.58L288 416v-16a16 16 0 0 0-16-16h-.39l-7.27-145.31 30.42-30.78a32 32 0 0 0 9.24-22.49V88a24.07 24.07 0 0 0-24-24H40a24.07 24.07 0 0 0-24 24v97.52A32 32 0 0 0 25.27 208l30.39 30.68L48.39 384H48a16 16 0 0 0-16 16v16L8.85 427.58A16 16 0 0 0 0 441.89V496a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-54.11a16 16 0 0 0-8.84-14.31zM48 185.5V96h48v48h32V96h64v48h32V96h48v89.44l-40.34 40.75L239.59 384H80.41l7.93-157.78zM288 480H32v-28.22l14.31-7.16L64 435.78V416h192v19.78l17.69 8.84 14.31 7.16zM183.59 231.59a23.59 23.59 0 0 0-47.18 0v47.18h47.18z"]
  },
      Dr = {
    prefix: "fal",
    iconName: "chevron-circle-down",
    icon: [512, 512, [], "f13a", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-207.5 86.6l115-115.1c4.7-4.7 4.7-12.3 0-17l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L256 303l-99.5-99.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l115 115.1c4.8 4.6 12.4 4.6 17.1-.1z"]
  },
      jr = {
    prefix: "fal",
    iconName: "chevron-circle-left",
    icon: [512, 512, [], "f137", "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zM256 472c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm-86.6-224.5l115.1-115c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L209 256l99.5 99.5c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0l-115.1-115c-4.6-4.8-4.6-12.4.1-17.1z"]
  },
      Er = {
    prefix: "fal",
    iconName: "chevron-circle-right",
    icon: [512, 512, [], "f138", "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zM256 40c118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216zm86.6 224.5l-115.1 115c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L303 256l-99.5-99.5c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l115.1 115c4.6 4.8 4.6 12.4-.1 17.1z"]
  },
      kr = {
    prefix: "fal",
    iconName: "chevron-circle-up",
    icon: [512, 512, [], "f139", "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zM40 256c0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216zm224.5-86.6l115 115.1c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L256 209l-99.5 99.5c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l115-115.1c4.8-4.6 12.4-4.6 17.1.1z"]
  },
      Ir = {
    prefix: "fal",
    iconName: "chevron-double-down",
    icon: [448, 512, [], "f322", "M443.5 98.5l-211 211.1c-4.7 4.7-12.3 4.7-17 0L4.5 98.5c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L224 269.9 419.5 74.5c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.6 4.6 4.6 12.2-.1 16.9zm0 111l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 397.9 28.5 202.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.8 4.8-12.4.1-17.1z"]
  },
      Or = {
    prefix: "fal",
    iconName: "chevron-double-left",
    icon: [384, 512, [], "f323", "M349.5 475.5l-211.1-211c-4.7-4.7-4.7-12.3 0-17l211.1-211c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L178.1 256l195.5 195.5c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.6-12.3 4.6-17-.1zm-111 0l7.1-7.1c4.7-4.7 4.7-12.3 0-17L50.1 256 245.5 60.5c4.7-4.7 4.7-12.3 0-17l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0l-211.1 211c-4.7 4.7-4.7 12.3 0 17l211.1 211c4.8 4.8 12.4 4.8 17.1.1z"]
  },
      Qr = {
    prefix: "fal",
    iconName: "chevron-double-right",
    icon: [384, 512, [], "f324", "M34.5 36.5l211.1 211c4.7 4.7 4.7 12.3 0 17l-211.1 211c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L205.9 256 10.5 60.5c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.6-4.6 12.2-4.6 16.9.1zm111 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17L333.9 256 138.5 451.5c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l211.1-211c4.7-4.7 4.7-12.3 0-17l-211.1-211c-4.8-4.8-12.4-4.8-17.1-.1z"]
  },
      Zr = {
    prefix: "fal",
    iconName: "chevron-double-up",
    icon: [448, 512, [], "f325", "M4.5 413.5l211-211.1c4.7-4.7 12.3-4.7 17 0l211 211.1c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L224 242.1 28.5 437.5c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.6-4.6-4.6-12.2.1-16.9zm0-111l7.1 7.1c4.7 4.7 12.3 4.7 17 0L224 114.1l195.5 195.5c4.7 4.7 12.3 4.7 17 0l7.1-7.1c4.7-4.7 4.7-12.3 0-17l-211-211.1c-4.7-4.7-12.3-4.7-17 0L4.5 285.5c-4.7 4.7-4.7 12.3 0 17z"]
  },
      Ur = {
    prefix: "fal",
    iconName: "chevron-down",
    icon: [448, 512, [], "f078", "M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z"]
  },
      Br = {
    prefix: "fal",
    iconName: "chevron-left",
    icon: [256, 512, [], "f053", "M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"]
  },
      Rr = {
    prefix: "fal",
    iconName: "chevron-right",
    icon: [256, 512, [], "f054", "M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"]
  },
      Yr = {
    prefix: "fal",
    iconName: "chevron-square-down",
    icon: [448, 512, [], "f329", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352zm-200.5-96.4l-115-115.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L224 296l99.5-99.5c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17l-115 115.1c-4.8 4.5-12.4 4.5-17.1-.1z"]
  },
      Pr = {
    prefix: "fal",
    iconName: "chevron-square-left",
    icon: [448, 512, [], "f32a", "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM48 448c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48zm96.4-200.5l115.1-115c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L184 256l99.5 99.5c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0l-115.1-115c-4.5-4.8-4.5-12.4.1-17.1z"]
  },
      Fr = {
    prefix: "fal",
    iconName: "chevron-square-right",
    icon: [448, 512, [], "f32b", "M0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80zm400-16c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352zm-96.4 200.5l-115.1 115c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L264 256l-99.5-99.5c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l115.1 115c4.5 4.8 4.5 12.4-.1 17.1z"]
  },
      Wr = {
    prefix: "fal",
    iconName: "chevron-square-up",
    icon: [448, 512, [], "f32c", "M48 480h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48zM32 80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80zm200.5 96.4l115 115.1c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L224 216l-99.5 99.5c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l115-115.1c4.8-4.5 12.4-4.5 17.1.1z"]
  },
      Gr = {
    prefix: "fal",
    iconName: "chevron-up",
    icon: [448, 512, [], "f077", "M4.465 366.475l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L224 178.053l195.494 195.493c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-211.05-211.051c-4.686-4.686-12.284-4.686-16.971 0L4.465 349.505c-4.687 4.686-4.687 12.284 0 16.97z"]
  },
      qr = {
    prefix: "fal",
    iconName: "child",
    icon: [448, 512, [], "f1ae", "M413.287 90.746c-23.71-23.707-63.332-27.212-93.318 2.776C318.651 41.725 276.107 0 224 0c-52.104 0-94.647 41.729-95.969 93.521-30.087-30.087-69.711-26.379-93.316-2.778-24.954 24.956-24.954 65.558-.002 90.511L112 258.511V456c0 30.879 25.122 56 56 56h16c15.654 0 29.828-6.456 40-16.846C234.172 505.544 248.346 512 264 512h16c30.878 0 56-25.121 56-56V258.511l77.286-77.256c24.952-24.954 24.952-65.556.001-90.509zM224 32c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zm166.628 126.628L304 245.256V456c0 13.255-10.745 24-24 24h-16c-13.255 0-24-10.745-24-24V344h-32v112c0 13.255-10.745 24-24 24h-16c-13.255 0-24-10.745-24-24V245.256l-86.628-86.628c-12.496-12.497-12.496-32.759 0-45.256 12.498-12.496 32.757-12.497 45.256 0L181.256 192h85.488l78.628-78.628c12.498-12.496 32.757-12.497 45.256 0 12.496 12.497 12.496 32.759 0 45.256z"]
  },
      Jr = {
    prefix: "fal",
    iconName: "chimney",
    icon: [512, 512, [], "f78b", "M480 0H32C14.3 0 0 14.3 0 32v128c0 17.7 14.3 32 32 32v304c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V192c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32zM64 192h96v128H64V192zm0 288V352h256v128H64zm384 0h-96V352h96v128zm0-160H192V192h256v128zm32-160H32V32h448v128z"]
  },
      Kr = {
    prefix: "fal",
    iconName: "church",
    icon: [576, 512, [], "f51d", "M281.71 320.3c-33.28 3.17-57.71 33.02-57.71 66.45V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V385.8c0-15.95 10.86-30.76 26.59-33.36C302.61 349.15 320 364.58 320 384v120c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V384c0-37.42-32.12-67.34-70.29-63.7zm276.86 35.69L448 303.26v-29.14c0-11.24-5.9-21.66-15.54-27.44L304 169.6V96h72c4.42 0 8-3.58 8-8V72c0-4.42-3.58-8-8-8h-72V8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v56h-72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h72v73.6l-128.46 77.08A31.997 31.997 0 0 0 128 274.12v29.15L17.43 355.99C6.96 360.99 0 373.89 0 388.32V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V388.32c0-1.98.45-3.42.8-4.21l95.2-45.4V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V274.12l128-76.8 128 76.8V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V338.71l95.2 45.4c.35.78.8 2.22.8 4.21V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V388.32c0-14.43-6.96-27.33-17.43-32.33z"]
  },
      Xr = {
    prefix: "fal",
    iconName: "circle",
    icon: [512, 512, [], "f111", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"]
  },
      _r = {
    prefix: "fal",
    iconName: "circle-notch",
    icon: [512, 512, [], "f1ce", "M288 24.103v8.169a11.995 11.995 0 0 0 9.698 11.768C396.638 63.425 472 150.461 472 256c0 118.663-96.055 216-216 216-118.663 0-216-96.055-216-216 0-104.534 74.546-192.509 174.297-211.978A11.993 11.993 0 0 0 224 32.253v-8.147c0-7.523-6.845-13.193-14.237-11.798C94.472 34.048 7.364 135.575 8.004 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.789 504 256c0-121.187-86.924-222.067-201.824-243.704C294.807 10.908 288 16.604 288 24.103z"]
  },
      $r = {
    prefix: "fal",
    iconName: "city",
    icon: [640, 512, [], "f64f", "M132 368H92c-6.62 0-12 5.37-12 12v40c0 6.63 5.38 12 12 12h40c6.62 0 12-5.37 12-12v-40c0-6.63-5.38-12-12-12zm0-96H92c-6.62 0-12 5.37-12 12v40c0 6.63 5.38 12 12 12h40c6.62 0 12-5.37 12-12v-40c0-6.63-5.38-12-12-12zm0-96H92c-6.62 0-12 5.37-12 12v40c0 6.63 5.38 12 12 12h40c6.62 0 12-5.37 12-12v-40c0-6.63-5.38-12-12-12zm96 192h-40c-6.62 0-12 5.37-12 12v40c0 6.63 5.38 12 12 12h40c6.62 0 12-5.37 12-12v-40c0-6.63-5.38-12-12-12zm0-96h-40c-6.62 0-12 5.37-12 12v40c0 6.63 5.38 12 12 12h40c6.62 0 12-5.37 12-12v-40c0-6.63-5.38-12-12-12zm0-96h-40c-6.62 0-12 5.37-12 12v40c0 6.63 5.38 12 12 12h40c6.62 0 12-5.37 12-12v-40c0-6.63-5.38-12-12-12zm192 96h-40c-6.62 0-12 5.37-12 12v40c0 6.63 5.38 12 12 12h40c6.62 0 12-5.37 12-12v-40c0-6.63-5.38-12-12-12zm0-96h-40c-6.62 0-12 5.37-12 12v40c0 6.63 5.38 12 12 12h40c6.62 0 12-5.37 12-12v-40c0-6.63-5.38-12-12-12zm0-96h-40c-6.62 0-12 5.37-12 12v40c0 6.63 5.38 12 12 12h40c6.62 0 12-5.37 12-12V92c0-6.63-5.38-12-12-12zm128 288h-40c-6.62 0-12 5.37-12 12v40c0 6.63 5.38 12 12 12h40c6.62 0 12-5.37 12-12v-40c0-6.63-5.38-12-12-12zm0-96h-40c-6.62 0-12 5.37-12 12v40c0 6.63 5.38 12 12 12h40c6.62 0 12-5.37 12-12v-40c0-6.63-5.38-12-12-12zm68-80H512V24c0-13.26-10.75-24-24-24H312c-13.25 0-24 10.74-24 24v72h-64V8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v88h-64V8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v88H24c-13.25 0-24 10.74-24 24v384c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V128h288V32h160v192h128v280c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V216c0-13.26-10.75-24-24-24z"]
  },
      ci = {
    prefix: "fal",
    iconName: "clarinet",
    icon: [640, 512, [], "f8ad", "M272 232a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm96 0a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm96 0a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm152-120a23.73 23.73 0 0 0-13.28 4l-66 44H480v-32h24a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H232a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H101.2a31.92 31.92 0 0 0-10.12 1.64l-69.2 23.07A32 32 0 0 0 0 215.06v81.88a32 32 0 0 0 21.88 30.35l69.2 23.07A31.92 31.92 0 0 0 101.2 352h435.53l66 44A24 24 0 0 0 640 376V136a24 24 0 0 0-24-24zm-232 16h64v32h-64zm-96 0h64v32h-64zm320 233.05L546.42 320H101.2L32 296.94v-81.88L101.2 192h445.22L608 151z"]
  },
      ei = {
    prefix: "fal",
    iconName: "claw-marks",
    icon: [512, 512, [], "f6c2", "M509.64 477.53l-1.47-3.12C463.56 378.88 328.12 141.69 34.58 2.4c-10.75-5.11-23.12-1.86-30 7.86-6.94 9.84-5.84 22.69 2.69 31.23l168.44 168.35c.44 1.06.41 4.81.34 10.25v51.89h55.89c3.69 0 7.28 1.5 9.69 3.9l75.08 77.51c2.62 2.64 4.09 6.15 4.09 9.54l-1.12 53.39 53.02-1.14c3.69 0 7.31 1.5 10.06 4.25l87.8 85.37c4.72 4.77 10.84 7.19 17.03 7.19 4.84 0 9.75-1.48 14.06-4.53 9.77-6.85 13.05-19.15 7.99-29.93zm-104.42-80.87c-8.56-8.56-20.4-13.47-32.84-13.47h-.03l-20 .42.44-20.33c0-12.28-4.78-23.83-13.28-32.33l-75.08-77.51c-8.69-8.69-20.21-13.47-32.49-13.47h-23.9l.03-22.45c.09-8.05.25-20.23-9.5-29.97L64.26 53.23c222.8 119.7 342.4 296.28 396.05 397.03l-55.09-53.6zM29.52 212l-.03-.02a20.536 20.536 0 0 0-25.59 6.75c-5.81 8.23-4.84 19.4 1.06 25.17l71.02 89.17c2.62 2.64 4.09 6.16 4.09 9.91v57h56.99c3.75 0 7.25 1.45 10.84 4.97L266.75 505.9c4 4 9.28 6.06 14.59 6.06 4.12 0 8.28-1.25 11.87-3.78 8.22-5.75 11.09-16.5 6.81-25.56C222.01 317.23 84.85 238.26 29.52 212zm140.06 169.44c-8.69-8.69-20.25-13.47-32.53-13.47h-24.99v-25c0-12.3-4.78-23.84-12.25-31.17L64.6 267.62c52.18 32.22 122.97 87.92 177.46 175.4l-72.48-61.58zm144.19-274.15c1.69 1.67 2.62 3.95 2.75 8.19l5.09 42.9 44.8 5.23c2.34 0 4.62.94 7.62 3.8l104.04 82.75c3.84 3.84 8.9 5.81 14 5.81 4 0 8-1.2 11.5-3.66 7.87-5.55 10.59-15.89 6.5-24.56C445 89.79 330.55 23.88 284.34 1.93c-8.72-4.12-19.06-1.44-24.65 6.45-5.59 7.94-4.69 18.67.44 23.47l53.64 75.44zm137.29 80.63l-55.71-44.33c-7.5-7.52-17.87-11.87-26.71-11.87h-.31l-17.96-2.14-1.97-16c0-10.89-4.25-21.15-10.22-26.84l-21.53-30.25c40.37 25.78 92.42 67.86 134.41 131.43z"]
  },
      ai = {
    prefix: "fal",
    iconName: "clinic-medical",
    icon: [576, 512, [], "f7f2", "M573.48 219.92L310.6 8a35.85 35.85 0 0 0-45.19 0L2.53 219.92a6.71 6.71 0 0 0-1 9.5l14.2 17.49a6.82 6.82 0 0 0 9.6 1L64 216.72V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V216.82l38.8 31.29a6.83 6.83 0 0 0 9.6-1l14.19-17.5a7.13 7.13 0 0 0-1.11-9.69zM480 480H96V190.92l187.71-151.4a6.63 6.63 0 0 1 8.4 0L480 191zM256 216v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8z"]
  },
      ni = {
    prefix: "fal",
    iconName: "clipboard",
    icon: [384, 512, [], "f328", "M336 64h-88.6c.4-2.6.6-5.3.6-8 0-30.9-25.1-56-56-56s-56 25.1-56 56c0 2.7.2 5.4.6 8H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 32c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm160 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h48v20c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V96h48c8.8 0 16 7.2 16 16z"]
  },
      ti = {
    prefix: "fal",
    iconName: "clipboard-check",
    icon: [384, 512, [], "f46c", "M336 64h-88.6c.4-2.6.6-5.3.6-8 0-30.9-25.1-56-56-56s-56 25.1-56 56c0 2.7.2 5.4.6 8H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 32c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm160 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h48v20c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V96h48c8.8 0 16 7.2 16 16v352zm-58.9-236.4c-4.7-4.7-12.3-4.7-17-.1L158.4 344.3 108 293.7c-4.7-4.7-12.3-4.7-17 0l-8.5 8.5c-4.7 4.7-4.7 12.3 0 17l67.4 67.6c4.7 4.7 12.3 4.7 17 0l134.8-133.7c4.7-4.7 4.7-12.3.1-17l-8.7-8.5z"]
  },
      ri = {
    prefix: "fal",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", "M280 240H168c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0 96H168c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM112 232c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM336 64h-88.6c.4-2.6.6-5.3.6-8 0-30.9-25.1-56-56-56s-56 25.1-56 56c0 2.7.2 5.4.6 8H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 32c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm160 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h48v20c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V96h48c8.8 0 16 7.2 16 16v352z"]
  },
      ii = {
    prefix: "fal",
    iconName: "clipboard-list-check",
    icon: [384, 512, [], "f737", "M336 64h-88.6c.4-2.6.6-5.3.6-8 0-30.9-25.1-56-56-56s-56 25.1-56 56c0 2.7.2 5.4.6 8H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 32c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm160 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h48v20c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V96h48c8.8 0 16 7.2 16 16v352zM112 328c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm168 8H168c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-153.8-65.6l64.2-63.6c2.1-2.1 2.1-5.5 0-7.6l-12.6-12.7c-2.1-2.1-5.5-2.1-7.6 0l-47.6 47.2-20.6-20.9c-2.1-2.1-5.5-2.1-7.6 0l-12.7 12.6c-2.1 2.1-2.1 5.5 0 7.6l37.1 37.4c1.9 2.1 5.3 2.1 7.4 0zM280 240h-77.6l-32.3 32H280c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      oi = {
    prefix: "fal",
    iconName: "clipboard-prescription",
    icon: [384, 512, [], "f5e8", "M336 64h-88.6c.4-2.6.6-5.3.6-8 0-30.9-25.1-56-56-56s-56 25.1-56 56c0 2.7.2 5.4.6 8H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 32c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24s-24-10.8-24-24c0-13.3 10.7-24 24-24zm160 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h48v20c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V96h48c8.8 0 16 7.2 16 16zm-66.3-162.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0l-39 39-31.4-31.4c18.5-9.1 31.3-28 31.3-50 0-30.9-25.1-56-56-56h-64c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-40h25.4l48 48-39 39c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l39-39 39 39c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-39-39 39-39c3.2-3.2 3.2-8.2.1-11.3zM168 272h-40v-48h40c13.2 0 24 10.8 24 24s-10.8 24-24 24z"]
  },
      li = {
    prefix: "fal",
    iconName: "clipboard-user",
    icon: [384, 512, [], "f7f3", "M336 64h-88.58a57.06 57.06 0 0 0 .58-8 56 56 0 0 0-112 0 57.06 57.06 0 0 0 .58 8H48a48 48 0 0 0-48 48v352a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V112a48 48 0 0 0-48-48zM192 32a24 24 0 1 1-24 24 24 24 0 0 1 24-24zm160 432a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V112a16 16 0 0 1 16-16h48v20a12 12 0 0 0 12 12h168a12 12 0 0 0 12-12V96h48a16 16 0 0 1 16 16zM236.81 336c-21.5 2.38-22.6 8-44.81 8s-23.31-5.58-44.81-8C101.31 336 64 369 64 409.59 64 435 83 448 102.41 448h179.18C301 448 320 435 320 409.59 320 369 282.69 336 236.81 336zm44.78 80H102.41c-6.82 0-6.41-3.19-6.41-6.41 0-22.93 23-41.59 51.19-41.59 4.66 0 18.43 8 44.81 8s40.15-8 44.81-8C265 368 288 386.66 288 409.59c0 3.22.41 6.41-6.41 6.41zM192 320a80 80 0 1 0-80-80 80.09 80.09 0 0 0 80 80zm0-128a48 48 0 1 1-48 48 48.05 48.05 0 0 1 48-48z"]
  },
      fi = {
    prefix: "fal",
    iconName: "clock",
    icon: [512, 512, [], "f017", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-148.9 88.3l-81.2-59c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h14c6.6 0 12 5.4 12 12v146.3l70.5 51.3c5.4 3.9 6.5 11.4 2.6 16.8l-8.2 11.3c-3.9 5.3-11.4 6.5-16.8 2.6z"]
  },
      si = {
    prefix: "fal",
    iconName: "clone",
    icon: [512, 512, [], "f24d", "M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zm-80 464c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16V144c0-8.82 7.18-16 16-16h48v240c0 26.51 21.49 48 48 48h240v48zm96-96c0 8.82-7.18 16-16 16H144c-8.82 0-16-7.18-16-16V48c0-8.82 7.18-16 16-16h320c8.82 0 16 7.18 16 16v320z"]
  },
      ui = {
    prefix: "fal",
    iconName: "closed-captioning",
    icon: [512, 512, [], "f20a", "M246.2 188.5l-9.8 15.2c-2 3-5.7 3.7-8.6 1.5-40.7-31.2-113-14.3-113 48.5 0 64.8 70.1 85.3 111.6 47.6 2.7-2.4 6.8-1.9 9 1l10.7 14.6c1.8 2.4 1.5 5.8-.6 7.9-49.2 50-165.5 29.4-165.5-70.6 0-96.3 118.3-117.1 165.2-73.5 2.2 2.1 2.6 5.4 1 7.8zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm16 336c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v288zm-49-211.5l-9.8 15.2c-2 3-5.7 3.7-8.6 1.5-40.7-31.2-113-14.3-113 48.5 0 64.8 70.1 85.3 111.6 47.6 2.7-2.4 6.8-1.9 9 1l10.7 14.6c1.8 2.4 1.5 5.8-.6 7.9-49.1 50.1-165.4 29.5-165.4-70.5 0-96.3 118.3-117.1 165.2-73.5 2.1 2 2.5 5.3.9 7.7z"]
  },
      hi = {
    prefix: "fal",
    iconName: "cloud",
    icon: [640, 512, [], "f0c2", "M571.7 238.8c2.8-9.9 4.3-20.2 4.3-30.8 0-61.9-50.1-112-112-112-16.7 0-32.9 3.6-48 10.8-31.6-45-84.3-74.8-144-74.8-94.4 0-171.7 74.5-175.8 168.2C39.2 220.2 0 274.3 0 336c0 79.6 64.4 144 144 144h368c70.7 0 128-57.2 128-128 0-47-25.8-90.8-68.3-113.2zM512 448H144c-61.9 0-112-50.1-112-112 0-56.8 42.2-103.7 97-111-.7-5.6-1-11.3-1-17 0-79.5 64.5-144 144-144 60.3 0 111.9 37 133.4 89.6C420 137.9 440.8 128 464 128c44.2 0 80 35.8 80 80 0 18.5-6.3 35.6-16.9 49.2C573 264.4 608 304.1 608 352c0 53-43 96-96 96z"]
  },
      mi = {
    prefix: "fal",
    iconName: "cloud-download",
    icon: [640, 512, [], "f0ed", "M571.7 238.8c2.8-9.9 4.3-20.2 4.3-30.8 0-61.9-50.1-112-112-112-16.7 0-32.9 3.6-48 10.8-31.6-45-84.3-74.8-144-74.8-94.4 0-171.7 74.5-175.8 168.2C39.2 220.2 0 274.3 0 336c0 79.6 64.4 144 144 144h368c70.7 0 128-57.2 128-128 0-47-25.8-90.8-68.3-113.2zM512 448H144c-61.9 0-112-50.1-112-112 0-56.8 42.2-103.7 97-111-.7-5.6-1-11.3-1-17 0-79.5 64.5-144 144-144 60.3 0 111.9 37 133.4 89.6C420 137.9 440.8 128 464 128c44.2 0 80 35.8 80 80 0 18.5-6.3 35.6-16.9 49.2C573 264.4 608 304.1 608 352c0 53-43 96-96 96zM405.2 254.5c-4.7-4.7-12.3-4.7-17 0L320 322.7V172c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v150.7l-68.2-68.2c-4.7-4.7-12.3-4.7-17 0l-5.7 5.7c-4.7 4.7-4.7 12.3 0 17l98.3 98.3c4.7 4.7 12.3 4.7 17 0l98.3-98.3c4.7-4.7 4.7-12.3 0-17l-5.5-5.7z"]
  },
      vi = {
    prefix: "fal",
    iconName: "cloud-download-alt",
    icon: [640, 512, [], "f381", "M571.7 238.8c2.8-9.9 4.3-20.2 4.3-30.8 0-61.9-50.1-112-112-112-16.7 0-32.9 3.6-48 10.8-31.6-45-84.3-74.8-144-74.8-94.4 0-171.7 74.5-175.8 168.2C39.2 220.2 0 274.3 0 336c0 79.6 64.4 144 144 144h368c70.7 0 128-57.2 128-128 0-47-25.8-90.8-68.3-113.2zM512 448H144c-61.9 0-112-50.1-112-112 0-56.8 42.2-103.7 97-111-.7-5.6-1-11.3-1-17 0-79.5 64.5-144 144-144 60.3 0 111.9 37 133.4 89.6C420 137.9 440.8 128 464 128c44.2 0 80 35.8 80 80 0 18.5-6.3 35.6-16.9 49.2C573 264.4 608 304.1 608 352c0 53-43 96-96 96zM384 248h-64v-84c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v84h-64c-29.2 0-43.2 36.2-21.4 55.8l80 72c12.2 11 30.6 11 42.8 0l80-72c21.7-19.6 7.9-55.8-21.4-55.8zm-80 104l-80-72h160l-80 72z"]
  },
      di = {
    prefix: "fal",
    iconName: "cloud-drizzle",
    icon: [512, 512, [], "f738", "M48 360c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm96 80c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm96-80c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm96 80c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm96-80c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-16.3-247.7C411.8 67.4 373.9 32 328 32c-17.8 0-34.8 5.3-49.2 15.2C256.3 17.7 221.5 0 184 0 117.8 0 64 53.8 64 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104h304c57.3 0 104-46.7 104-104 0-54.8-42.6-99.8-96.3-103.7zM408 288H104c-39.7 0-72-32.3-72-72 0-32.3 21.9-60.7 53.3-69.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8L287 82.1C297.9 70.4 312.4 64 328 64c30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72S447.7 288 408 288z"]
  },
      Mi = {
    prefix: "fal",
    iconName: "cloud-hail",
    icon: [512, 512, [], "f739", "M376 368c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 96c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-64-96c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM56 464c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm64-96c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm295.7-255.7C411.8 67.4 373.9 32 328 32c-17.8 0-34.8 5.3-49.2 15.2C256.3 17.7 221.5 0 184 0 117.8 0 64 53.8 64 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104h304c57.3 0 104-46.7 104-104 0-54.8-42.6-99.8-96.3-103.7zM408 288H104c-39.7 0-72-32.3-72-72 0-32.3 21.9-60.7 53.3-69.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8L287 82.1C297.9 70.4 312.4 64 328 64c30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72S447.7 288 408 288z"]
  },
      pi = {
    prefix: "fal",
    iconName: "cloud-hail-mixed",
    icon: [512, 512, [], "f73a", "M415.7 112.3C411.8 67.4 373.9 32 328 32c-17.8 0-34.8 5.3-49.2 15.2C256.3 17.7 221.5 0 184 0 117.8 0 64 53.8 64 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104h304c57.3 0 104-46.7 104-104 0-54.8-42.6-99.8-96.3-103.7zM408 288H104c-39.7 0-72-32.3-72-72 0-32.3 21.9-60.7 53.3-69.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8L287 82.1C297.9 70.4 312.4 64 328 64c30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72S447.7 288 408 288zm-224.1 82.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM216 464c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM87.2 369.7c-7.9-3.9-17.5-.8-21.5 7.2l-16 32c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l16-32c3.8-8.1.7-17.7-7.2-21.6zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm447.2-94.3c-7.9-3.9-17.5-.8-21.5 7.2l-16 32c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l16-32c3.8-8.1.7-17.7-7.2-21.6zm-192 0c-7.9-3.9-17.5-.8-21.5 7.2l-16 32c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l16-32c3.8-8.1.7-17.7-7.2-21.6zM408 464c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-32.1-93.9c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8z"]
  },
      zi = {
    prefix: "fal",
    iconName: "cloud-meatball",
    icon: [512, 512, [], "f73b", "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm416-64c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM346.5 293.5c-12.2-12.2-29.3-17.9-46.3-16.3-21.8-26.6-66.7-26.6-88.4 0-16.9-1.6-34 4.1-46.3 16.3-12.2 12.2-18 29.2-16.3 46.3-13.3 10.9-21.2 27-21.2 44.2s7.9 33.3 21.2 44.2c-1.7 17.1 4.1 34.1 16.3 46.3 12.3 12.3 30.5 19 46.5 16.6 10.9 13.1 26.8 20.9 44 20.9s33.1-7.8 44-20.9c16.2 2.4 34.2-4.3 46.5-16.6 12.2-12.2 18-29.2 16.3-46.3 13.3-10.9 21.2-27 21.2-44.2s-7.9-33.3-21.2-44.2c1.7-17.1-4.1-34.1-16.3-46.3zm-8.8 113.2l-11.9 6.2 4.1 12.8c3 9.5.8 19.5-5.9 26.2-4.9 4.9-11.4 7.6-18.4 7.6-2 0-4.5-.7-7.8-1.7l-12.8-4.1-6.2 12c-9.2 17.7-36.2 17.7-45.4 0l-6.2-12-12.8 4.1c-3.2 1-5.8 1.7-7.8 1.7-6.9 0-13.5-2.7-18.4-7.6-6.7-6.7-8.9-16.7-5.9-26.2l4.1-12.8-11.9-6.2c-8.8-4.6-14.3-13.3-14.3-22.7s5.5-18.1 14.3-22.7l11.9-6.2-4.1-12.8c-3-9.5-.8-19.5 5.9-26.2 6.7-6.7 16.7-8.9 26.2-5.9l12.8 4.1 6.2-11.9c9.2-17.7 36.2-17.7 45.4 0l6.2 11.9 12.8-4.1c9.4-3 19.5-.8 26.2 5.9 6.7 6.7 8.9 16.7 5.9 26.2l-4.1 12.8 11.9 6.2c8.8 4.6 14.3 13.3 14.3 22.7s-5.5 18.1-14.3 22.7zM512 216c0-54.8-42.6-99.8-96.3-103.7C411.8 67.4 373.9 32 328 32c-17.8 0-34.8 5.3-49.2 15.2C256.3 17.7 221.5 0 184 0 117.8 0 64 53.8 64 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104h14.3c1.8-11.4 5.7-22.2 11.6-32H104c-39.7 0-72-32.3-72-72 0-32.3 21.9-60.7 53.3-69.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8L287 82.1C297.9 70.4 312.4 64 328 64c30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72s-32.3 72-72 72h-25.9c5.9 9.8 9.8 20.6 11.6 32H408c57.3-.1 104-46.8 104-104.1z"]
  },
      Ci = {
    prefix: "fal",
    iconName: "cloud-moon",
    icon: [640, 512, [], "f6c3", "M351.5 313.6c-4.5-41.3-39.6-73.6-82.1-73.6-13.9 0-27.3 3.5-39.5 10.3-18.3-16.8-41.9-26.3-66.8-26.3-53.7 0-97.5 42.8-99.2 96.2-38.3 14.3-64 50.7-64 92.7C0 467.5 44.5 512 99.2 512h249.6c54.7 0 99.2-44.5 99.2-99.2 0-53.8-43-97.7-96.5-99.2zM348.8 480H99.2C62.1 480 32 449.9 32 412.8c0-31.6 21.5-58.5 52.4-65.4l14-5.9-2-14.6c-.2-1.2-.4-2.5-.4-3.8 0-37.1 30.1-67.2 67.2-67.2 20.1 0 39 9.2 52 25.2l10.1 12.5 12.4-10.1C247 276 258 272 269.4 272c27.9 0 50.6 22.7 50.6 50.6 0 1.5-.2 2.8-.7 6.4l-2.6 21.3 21.2-3.6c3.6-.6 7.2-1.2 11-1.2 37.1 0 67.2 30.2 67.2 67.2S385.9 480 348.8 480zm288.8-192.8c-4.1-8.6-12.4-13.9-21.8-13.9-1.5 0-3 .1-4.6.4-7.7 1.5-15.5 2.2-23.2 2.2-67 0-121.5-54.7-121.5-121.9 0-43.7 23.6-84.3 61.6-106 8.9-5.1 13.6-15 11.9-25.1-1.7-10.2-9.4-17.9-19.5-19.8-11.5-2-23.2-3.1-35-3.1-105.7 0-191.8 86.1-191.8 192 0 6.5.4 12.8 1.1 19.2 12.7 2.9 24.6 7.8 35.4 14.6-2.6-10.9-4.5-22-4.5-33.7 0-88.2 71.7-160 159.8-160 3 0 5.9.1 8.9.2-37.4 28.9-59.9 73.9-59.9 121.9C434.5 239 503.4 308 588 308c2.6 0 5.2-.1 7.8-.2C566.2 336.1 527 352 485.5 352c-7.5 0-14.8-.7-21.9-1.9 5.7 10.3 9.7 21.5 12.5 33.1 3.1.2 6.2.7 9.4.7 58.1 0 112.4-25.9 149-71.1 6-7.2 7.2-17.1 3.1-25.6z"]
  },
      Li = {
    prefix: "fal",
    iconName: "cloud-moon-rain",
    icon: [576, 512, [], "f73c", "M573.9 237.5c-3.6-7.7-11.5-12.6-19.9-12.6h-1.4l-2.8.4c-6.3 1.2-12.6 1.8-18.9 1.8-54.4 0-98.7-44-98.7-98.2 0-35.2 19.2-67.9 50.1-85.3 8.2-4.6 12.4-13.6 10.9-22.8-1.6-9.3-8.5-16.3-17.8-18C465.7.9 455.8 0 446 0c-67.1 0-123.6 41.4-147.7 99.5 10.2 2.5 20 6.3 29 11.4 19.1-45.6 63.9-78 116.5-78.9-27.3 24.4-43.5 59.6-43.5 96.8 0 70.7 57 128.5 127.6 130.1-22.3 18.2-50.3 28.4-79.8 28.8v.2c0 11-1.5 21.7-4.1 31.9.7 0 1.4.1 2.1.1 48.7 0 94.3-21.6 125-59.2 5.3-6.5 6.4-15.5 2.8-23.2zm-222.6-40.2C346 158.2 312.5 128 272 128c-8.6 0-17 1.4-25.2 4.3-19.7-23-48.2-36.3-78.8-36.3-56.5 0-102.7 45.3-104 101.6C26.2 210.9 0 246.9 0 288c0 52.9 43.1 96 96 96h224c52.9 0 96-43.1 96-96 0-1.3-.3-2.6-.3-4-1.7-39.6-27.5-74-64.4-86.7zM320 352H96c-35.3 0-64-28.7-64-64 0-30.6 21.8-57 52-62.8l14.5-2.8-2-18c-.2-1.5-.4-2.9-.4-4.4 0-39.7 32.3-72 72-72 24.3 0 46.8 12.2 60.2 32.8l8.1 12.4 13-7.1c32.7-17.8 70.7 8.2 70.8 40.4l-.2 16.2 12.8 2.6c29.8 6 51.3 32.3 51.3 62.7-.1 35.3-28.8 64-64.1 64zm-149.8 66.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.4-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.4-7.7 1.7-17.4-6-21.8zm192 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.4-7.7 1.7-17.4-6-21.8zm96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.4-7.7 1.7-17.4-6-21.8z"]
  },
      Ai = {
    prefix: "fal",
    iconName: "cloud-music",
    icon: [640, 512, [], "f8ae", "M571.69 238.8A112 112 0 0 0 464 96a110.64 110.64 0 0 0-48 10.8A175.82 175.82 0 0 0 272 32c-94.41 0-171.69 74.5-175.81 168.2A144 144 0 0 0 144 480h368a128 128 0 0 0 59.69-241.2zM512 448H144a112 112 0 0 1-15-223 139.16 139.16 0 0 1-1-17 144.05 144.05 0 0 1 277.41-54.41A80 80 0 0 1 527.09 257.2 96 96 0 0 1 512 448zM363.19 176.75l-128 47.25A16 16 0 0 0 224 239.25V338a69.34 69.34 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32V259.16l96-37.52V306a69.34 69.34 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32V192a16 16 0 0 0-20.81-15.25z"]
  },
      Ni = {
    prefix: "fal",
    iconName: "cloud-rain",
    icon: [512, 512, [], "f73d", "M118.5 369.2c-2.8-10.2-11.8-17.1-22.3-17.2-11.6.7-19.7 6.8-22.7 17.1-4.7 16.3-11.8 26.9-18.8 37.1-8.6 12.7-17.4 25.8-17.4 45.3 0 33.4 26.3 60.5 58.7 60.5s58.7-27.1 58.7-60.5c0-19.6-8.8-32.6-17.4-45.2-7-10.3-14.1-20.8-18.8-37.1zM96 480c-14.7 0-26.7-12.8-26.7-28.5 0-9.3 4.1-15.8 11.9-27.3 4.6-6.8 9.9-14.7 14.7-24.6 4.8 9.9 10.2 17.8 14.8 24.6 7.8 11.5 11.9 18 11.9 27.3.1 15.7-11.9 28.5-26.6 28.5zm182.5-110.8c-2.8-10.2-11.8-17.1-22.3-17.2h-.2c-10.5 0-19.5 6.8-22.5 17.1-4.7 16.3-11.8 26.9-18.8 37.1-8.6 12.7-17.4 25.8-17.4 45.3 0 33.4 26.3 60.5 58.7 60.5s58.7-27.1 58.7-60.5c0-19.6-8.8-32.6-17.4-45.2-7-10.3-14.1-20.8-18.8-37.1zM256 480c-14.7 0-26.7-12.8-26.7-28.5 0-9.3 4.1-15.8 11.9-27.3 4.6-6.8 9.9-14.7 14.7-24.6 4.8 9.9 10.2 17.8 14.8 24.6 7.8 11.5 11.9 18 11.9 27.3.1 15.7-11.9 28.5-26.6 28.5zm182.5-110.8c-2.8-10.2-11.8-17.1-22.3-17.2-10.4.7-19.7 6.8-22.7 17.1-4.7 16.3-11.8 26.9-18.8 37.1-8.6 12.7-17.4 25.8-17.4 45.3 0 33.4 26.3 60.5 58.7 60.5s58.7-27.1 58.7-60.5c0-19.6-8.8-32.6-17.4-45.2-7-10.3-14.1-20.8-18.8-37.1zM416 480c-14.7 0-26.7-12.8-26.7-28.5 0-9.3 4.1-15.8 11.9-27.3 4.6-6.8 9.9-14.7 14.7-24.6 4.8 9.9 10.2 17.8 14.8 24.6 7.8 11.5 11.9 18 11.9 27.3.1 15.7-11.9 28.5-26.6 28.5zm-.3-367.7C411.8 67.4 373.9 32 328 32c-17.8 0-34.8 5.3-49.2 15.2C256.3 17.7 221.5 0 184 0 117.8 0 64 53.8 64 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104h304c57.3 0 104-46.7 104-104 0-54.8-42.6-99.8-96.3-103.7zM408 288H104c-39.7 0-72-32.3-72-72 0-32.3 21.9-60.7 53.3-69.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8L287 82.1C297.9 70.4 312.4 64 328 64c30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72S447.7 288 408 288z"]
  },
      gi = {
    prefix: "fal",
    iconName: "cloud-rainbow",
    icon: [576, 512, [], "f73e", "M568.2 32c4.3-.1 7.8-3.5 7.8-7.9v-16c0-4.5-3.7-8.2-8.2-8.1-140.6 2.9-265.9 80.3-331.7 204.2-16-7.8-33.7-12.2-52.1-12.2-66.2 0-120 53.8-120 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104h304c57.3 0 104-46.7 104-104 0-38.8-21.6-72.4-53.1-90.2 25.3-36.1 65.8-59.1 109.5-61.5 4.3-.2 7.7-3.6 7.7-7.9v-16c0-4.5-3.8-8.3-8.3-8.1-56.8 2.7-109 33.6-139.8 82.1-4.1-.8-8.1-1.8-12.4-2.1-2.3-26.3-16.3-49-36.6-63.6 45.6-58.7 114.3-94.3 189.2-96.6 4.3-.1 7.8-3.6 7.8-7.9v-16c0-4.5-3.8-8.3-8.3-8.1-87.1 2.5-166.7 45-218.2 114.8-6.9-1.8-14-3-21.5-3-17.8 0-34.8 5.3-49.2 15.2-4.7-6.2-10.2-11.5-15.9-16.6C322.8 107.2 438.2 34.8 568.2 32zM287 274.1c10.8-11.7 25.4-18.1 41-18.1 30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72s-32.3 72-72 72H104c-39.7 0-72-32.3-72-72 0-32.3 21.9-60.7 53.3-69.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8 15.2-16.6z"]
  },
      Hi = {
    prefix: "fal",
    iconName: "cloud-showers",
    icon: [512, 512, [], "f73f", "M415.7 112.3C411.8 67.4 373.9 32 328 32c-17.8 0-34.8 5.3-49.2 15.2C256.3 17.7 221.5 0 184 0 117.8 0 64 53.8 64 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104h304c57.3 0 104-46.7 104-104 0-54.8-42.6-99.8-96.3-103.7zM408 288H104c-39.7 0-72-32.3-72-72 0-32.3 21.9-60.7 53.3-69.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8L287 82.1C297.9 70.4 312.4 64 328 64c30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72S447.7 288 408 288zM48 368c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96 32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96-32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96 32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96-32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"]
  },
      Vi = {
    prefix: "fal",
    iconName: "cloud-showers-heavy",
    icon: [512, 512, [], "f740", "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm39.8-257.8C411.8 67.4 373.9 32 328 32c-17.8 0-34.8 5.3-49.2 15.2C256.3 17.7 221.5 0 184 0 117.9 0 64 53.8 64 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104h304c57.3 0 104-46.7 104-104 0-54.8-42.6-99.8-96.3-103.7zM408 288H104c-39.7 0-72-32.3-72-72 0-32.3 21.9-60.7 53.3-69.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8L287 82.1C297.9 70.4 312.4 64 328 64c30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72S447.7 288 408 288z"]
  },
      xi = {
    prefix: "fal",
    iconName: "cloud-sleet",
    icon: [512, 512, [], "f741", "M87.2 353.7c-7.9-3.9-17.5-.7-21.5 7.2l-64 128c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l64-128c3.8-8.1.7-17.7-7.2-21.6zm256 0c-7.9-3.9-17.5-.7-21.5 7.2l-64 128c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l64-128c3.8-8.1.7-17.7-7.2-21.6zm151.7 35.4l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V360c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zm-256 0l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V360c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zM512 216c0-54.8-42.6-99.8-96.3-103.7C411.8 67.4 373.9 32 328 32c-17.8 0-34.8 5.3-49.2 15.2C256.3 17.7 221.5 0 184 0 117.8 0 64 53.8 64 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104h304c57.3 0 104-46.7 104-104zm-480 0c0-32.3 21.9-60.7 53.3-69.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8L287 82.1C297.9 70.4 312.4 64 328 64c30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72s-32.3 72-72 72H104c-39.7-.1-72-32.4-72-72.1z"]
  },
      wi = {
    prefix: "fal",
    iconName: "cloud-snow",
    icon: [512, 512, [], "f742", "M126.9 389.1l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V360c0-4.4-3.6-8-8-8H56c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16L4 432c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zm384 0l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V360c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zm-192 32l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V392c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zM104 320h304c57.3 0 104-46.7 104-104 0-54.8-42.6-99.8-96.3-103.7-4-44.9-41.8-80.3-87.7-80.3-17.8 0-34.8 5.3-49.2 15.2C256.3 17.7 221.5 0 184 0 117.8 0 64 53.8 64 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104zM85.3 146.8l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8L287 82.1C297.9 70.4 312.4 64 328 64c30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72s-32.3 72-72 72H104c-39.7 0-72-32.3-72-72 0-32.4 21.9-60.8 53.3-69.3z"]
  },
      yi = {
    prefix: "fal",
    iconName: "cloud-sun",
    icon: [640, 512, [], "f6c4", "M543.7 304.3C539.8 259.4 502 224 456 224c-17.8 0-34.8 5.3-49.2 15.2-22.5-29.5-57.3-47.2-94.8-47.2-66.2 0-120 53.8-120 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104h304c57.3 0 104-46.7 104-104 0-54.8-42.6-99.8-96.3-103.7zM536 480H232c-39.7 0-72-32.3-72-72 0-32.3 21.9-60.7 53.3-69.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8 15.2-16.5c10.8-11.7 25.4-18.1 41-18.1 30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72S575.7 480 536 480zM92.6 323l12.5-63.2c1.2-6.3-1.4-12.8-6.8-16.4l-53.5-35.8 53.5-35.8c5.4-3.6 8-10.1 6.8-16.4L92.6 92.1l63.2 12.5c6.4 1.3 12.8-1.5 16.4-6.8L208 44.3l35.8 53.5c3.6 5.3 9.9 8.1 16.4 6.8l63.2-12.5-12.5 63.2c-.3 1.6-.1 3.2 0 4.8.4 0 .7-.1 1.1-.1 10.1 0 20 1.1 29.6 3 .2-.5.5-.9.6-1.5l17.2-86.7c1-5.2-.6-10.6-4.4-14.4s-9.2-5.5-14.4-4.4l-76.2 15.1-43.1-64.4c-6-8.9-20.6-8.9-26.6 0l-43.2 64.5-76.1-15.1c-5.3-1.1-10.7.6-14.4 4.4-3.8 3.8-5.4 9.2-4.4 14.4l15.1 76.2-64.6 43.1c-4.4 3-7.1 8-7.1 13.3s2.7 10.3 7.1 13.3L71.6 264l-15.1 76.2c-1 5.2.6 10.6 4.4 14.4 3 3 7.1 4.7 11.3 4.7 1 0 2.1-.1 3.1-.3l32.8-6.5c6.2-13.8 14.6-26.5 25.1-37.6L92.6 323zM208 149.7c18.5 0 34.8 8.9 45.4 22.4 10.2-4.3 20.8-7.6 31.9-9.6-15.6-26.6-44.2-44.8-77.3-44.8-49.5 0-89.8 40.3-89.8 89.8 0 33 18.1 61.7 44.8 77.3 2-11.1 5.3-21.7 9.6-31.9-13.6-10.6-22.4-26.9-22.4-45.4 0-31.8 25.9-57.8 57.8-57.8z"]
  },
      bi = {
    prefix: "fal",
    iconName: "cloud-sun-rain",
    icon: [640, 512, [], "f743", "M298.2 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.4-7.7 1.7-17.4-6-21.8zM192 140c26.4 0 48 20 51.1 45.6 4.8-3.6 9.8-6.9 15.1-9.9 1.5-8.4 3.9-16.5 6.8-24.3-14.3-25.7-41.5-43.4-73-43.4-46.2 0-83.7 37.6-83.7 83.8s37.5 83.8 83.7 83.8c.3 0 .6-.1.9-.1 1.1-11.4 3.7-22.4 7.7-32.8-2.8.5-5.6.9-8.5.9-28.5 0-51.7-23.2-51.7-51.7-.1-28.6 23.1-51.9 51.6-51.9zm-31.7 151.7c-3.6-5.3-9.9-8.1-16.4-6.8l-56 11.1L99 240c1.2-6.4-1.4-12.8-6.8-16.4l-47.4-31.8L92.2 160c5.4-3.6 8-10.1 6.8-16.4l-11.1-56 56 11.1c6.5 1.3 12.8-1.4 16.4-6.8L192 44.4l31.8 47.5c3.6 5.3 10 8.1 16.4 6.8L319.6 83c8.7-1.7 14.3-10.1 12.6-18.8-1.7-8.7-10.3-14.5-18.8-12.6l-68.9 13.6-39.2-58.5c-5.9-8.9-20.6-8.9-26.6 0l-39.1 58.5-69-13.7c-5.3-1.1-10.7.6-14.4 4.4-3.8 3.8-5.4 9.2-4.4 14.5l13.7 69-58.4 39.1c-4.4 3-7.1 7.9-7.1 13.3 0 5.3 2.7 10.3 7.1 13.3l58.4 39.1-13.7 69c-1 5.3.6 10.7 4.4 14.5 3.8 3.8 9 5.5 14.4 4.4l68.9-13.7 39.1 58.5c3.1 4.6 8.2 7.1 13.3 7.1 3.1 0 6.2-.9 8.9-2.7 7.3-4.9 9.3-14.9 4.4-22.2l-44.9-67.4zm329.9 126.4c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.4-7.7 1.7-17.4-6-21.8zm85.1-220.8C570 158.2 536.5 128 496 128c-8.6 0-17 1.4-25.2 4.3C451.1 109.4 422.6 96 392 96c-56.5 0-102.7 45.3-104 101.6-37.8 13.3-64 49.3-64 90.4 0 52.9 43.1 96 96 96h224c52.9 0 96-43.1 96-96 0-41.3-26.6-77.6-64.7-90.7zM560 208.8zM544 352H320c-35.3 0-64-28.7-64-64 0-30.6 21.8-57 52-62.8l14.5-2.8-2-18c-.2-1.5-.4-2.9-.4-4.4 0-39.7 32.3-72 72-72 24.3 0 46.8 12.2 60.2 32.8l8.1 12.4 13-7.1c32.7-17.8 70.7 8.2 70.8 40.4l-.2 16.2 12.8 2.6c29.8 6 51.3 32.3 51.3 62.7-.1 35.3-28.8 64-64.1 64zm42.2 66.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.4-7.7 1.7-17.4-6-21.8zm-192 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.4-7.7 1.7-17.4-6-21.8z"]
  },
      Si = {
    prefix: "fal",
    iconName: "cloud-upload",
    icon: [640, 512, [], "f0ee", "M312.5 168.5c-4.7-4.7-12.3-4.7-17 0l-98.3 98.3c-4.7 4.7-4.7 12.3 0 17l5.7 5.7c4.7 4.7 12.3 4.7 17 0l68.2-68.2V372c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V221.3l68.2 68.2c4.7 4.7 12.3 4.7 17 0l5.7-5.7c4.7-4.7 4.7-12.3 0-17l-98.5-98.3zm259.2 70.3c2.8-9.9 4.3-20.2 4.3-30.8 0-61.9-50.1-112-112-112-16.7 0-32.9 3.6-48 10.8-31.6-45-84.3-74.8-144-74.8-94.4 0-171.7 74.5-175.8 168.2C39.2 220.2 0 274.3 0 336c0 79.6 64.4 144 144 144h368c70.7 0 128-57.2 128-128 0-47-25.8-90.8-68.3-113.2zM512 448H144c-61.9 0-112-50.1-112-112 0-56.8 42.2-103.7 97-111-.7-5.6-1-11.3-1-17 0-79.5 64.5-144 144-144 60.3 0 111.9 37 133.4 89.6C420 137.9 440.8 128 464 128c44.2 0 80 35.8 80 80 0 18.5-6.3 35.6-16.9 49.2C573 264.4 608 304.1 608 352c0 53-43 96-96 96z"]
  },
      Ti = {
    prefix: "fal",
    iconName: "cloud-upload-alt",
    icon: [640, 512, [], "f382", "M405.4 232.2l-80-72c-12.2-11-30.6-11-42.8 0l-80 72c-21.7 19.6-7.9 55.8 21.4 55.8h64v84c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-84h64c29.2 0 43.1-36.2 21.4-55.8zM224 256l80-72 80 72H224zm347.7-17.2c2.8-9.9 4.3-20.2 4.3-30.8 0-61.9-50.1-112-112-112-16.7 0-32.9 3.6-48 10.8-31.6-45-84.3-74.8-144-74.8-94.4 0-171.7 74.5-175.8 168.2C39.2 220.2 0 274.3 0 336c0 79.6 64.4 144 144 144h368c70.7 0 128-57.2 128-128 0-47-25.8-90.8-68.3-113.2zM512 448H144c-61.9 0-112-50.1-112-112 0-56.8 42.2-103.7 97-111-.7-5.6-1-11.3-1-17 0-79.5 64.5-144 144-144 60.3 0 111.9 37 133.4 89.6C420 137.9 440.8 128 464 128c44.2 0 80 35.8 80 80 0 18.5-6.3 35.6-16.9 49.2C573 264.4 608 304.1 608 352c0 53-43 96-96 96z"]
  },
      Di = {
    prefix: "fal",
    iconName: "clouds",
    icon: [640, 512, [], "f744", "M543.7 304.3C539.8 259.4 502 224 456 224c-7.1 0-14 1.1-20.7 2.7 7.9-15.3 12.7-32.4 12.7-50.7 0-61.8-50.2-112-112-112-10.5 0-20.9 1.5-31 4.5C283 27 239.4 0 192 0 130.2 0 78.2 43.9 66.9 103.8c-39.4 11.8-66.9 48-66.9 90 0 52 42.3 94.2 94.2 94.2h100.2c-1.6 7.8-2.4 15.8-2.4 24v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104h304c57.3 0 104-46.7 104-104 0-54.8-42.6-99.8-96.3-103.7zM94.2 256C59.9 256 32 228.1 32 193.8c0-30.3 21.8-56 51.8-61.1l12-2 1.2-12.1c5-49.4 45.8-86.6 95-86.6 39.5 0 75.5 25 89.6 62.3l6 16 15.5-7c10.6-4.8 21.7-7.3 32.9-7.3 44.1 0 80 35.9 80 80 0 19.9-7.4 38.1-19.7 52.2-22.2-22.5-52-36.2-84.3-36.2-45.8 0-85.3 26.1-105.5 64H94.2zM536 480H232c-39.7 0-72-32.3-72-72 0-32.3 21.9-60.7 53.3-69.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8 15.2-16.5c10.8-11.7 25.4-18.1 41-18.1 30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72S575.7 480 536 480z"]
  },
      ji = {
    prefix: "fal",
    iconName: "clouds-moon",
    icon: [640, 512, [], "f745", "M462.6 321.1c-7-37-39.6-65.1-78.6-65.1 0-52.9-43.1-96-96-96h-5.5C269.2 122.2 233 96 192 96s-77.2 26.2-90.5 64H96c-52.9 0-96 43.1-96 96s43.1 96 96 96h40.8c-15.4 17.1-24.8 39.5-24.8 64 0 52.9 43.1 96 96 96h240c52.9 0 96-43.1 96-96 0-48-35.4-87.8-81.4-94.9zM96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64h30.7l2.6-12.8c6-29.7 32.4-51.2 62.7-51.2s56.7 21.5 62.7 51.2l2.6 12.8H288c35.3 0 64 28.7 64 64 0 2.6-.7 5-1 7.4-.4.2-.9.3-1.4.5-17.8-24.7-46.7-39.9-77.6-39.9-52.9 0-96 43.1-96 96H96zm352 160H208c-35.3 0-64-28.7-64-64 0-31 22.2-57.4 52.8-62.8l16.5-2.9-3.6-16.3c-1.1-5-1.7-9.6-1.7-13.9 0-35.3 28.7-64 64-64 24.6 0 47.2 14.5 57.7 37l8.6 18.4 15.8-12.7c8.8-7 19.1-10.7 29.8-10.7 26.5 0 48 21.5 48 48v16h16c35.3 0 64 28.7 64 64S483.3 480 448 480zm189.8-230.6c-3.8-8.1-12-13.3-20.9-13.3h-1.5l-2.9.4c-6.6 1.2-13.2 1.9-19.8 1.9-57.2 0-103.7-46.2-103.7-103.1 0-37 20.1-71.3 52.6-89.6 8.6-4.8 13.1-14.2 11.4-23.9-1.6-9.7-9-17.1-18.7-18.9C524.2.9 513.8 0 503.5 0c-83 0-151.8 59.8-166 138.2 10.9 4.6 21 10.7 30.2 18.1C373.7 86.8 431.9 32 503.5 32h1.9C475 57.4 457 95.2 457 135.3c0 74.5 60.9 135.1 135.7 135.1h1c-23.5 20.5-53.5 32-85.1 33.2 13.1 7.2 24.7 16.6 34.5 27.7 35.7-8.5 67.9-28.4 91.6-57.4 5.8-7 6.9-16.4 3.1-24.5z"]
  },
      Ei = {
    prefix: "fal",
    iconName: "clouds-sun",
    icon: [640, 512, [], "f746", "M640 258.3c0-51.6-40.2-93.5-89.6-93.5h-.5c-16.6-40.7-55.3-69.2-99.4-69.2-46.4 0-86.2 30.1-101.5 74.2-25.3 8.8-45.2 29.1-54.7 54.9-48.3 5-86.3 45.5-86.3 95.1 0 1.8.1 3.7.2 5.6-38 13.2-64.2 49.2-64.2 90.5 0 53 43.1 96.1 96 96.1h240c52.9 0 96-43.1 96-96.1 0-24.7-9.4-47.1-24.8-64.1 49-.5 88.8-42.2 88.8-93.5zM480 480H240c-35.3 0-64-28.7-64-64.1 0-31 22.2-57.5 52.8-62.9l16.5-2.9-3.6-16.3c-1.1-5-1.7-9.6-1.7-13.9 0-35.3 28.7-64.1 64-64.1 24.6 0 47.2 14.5 57.8 37l8.6 18.4 15.8-12.7c8.8-7 19.1-10.7 29.8-10.7 26.5 0 48 21.5 48 48v16h16c35.3 0 64 28.7 64 64.1S515.3 480 480 480zm70.4-160.2h-56.1c-7.5-36.5-39.7-64.1-78.3-64.1-12 0-23.7 2.7-34.4 7.9-13-18-32-30.8-53.2-36.5 9.6-17.3 26.7-29.1 46.7-30.1 5.6-39.3 37-69.4 75.3-69.4 40.3 0 72.9 33.3 75.9 75.5 7.4-3.7 15.3-6.3 24-6.3 31.8 0 57.6 27.5 57.6 61.5.1 34-25.7 61.5-57.5 61.5zm-384.9-7.7c-2.1-1-4.3-1.7-6.6-1.7-1 0-2.1.1-3.1.3l-63.2 12.5 12.5-63.2c1.2-6.3-1.4-12.8-6.8-16.5l-53.5-35.8 53.5-35.8c5.4-3.6 8-10.1 6.8-16.5L92.6 92.2l63.2 12.5c6.5 1.3 12.8-1.5 16.4-6.8L208 44.4 243.8 98c3.6 5.3 9.9 8.1 16.4 6.8l63.2-12.5-12.1 61.2c4.2-2.8 8.4-5.5 13-7.8 7.3-15.7 17.5-29.4 29.3-41.2l5.8-29.5c1-5.2-.6-10.6-4.4-14.4-3.8-3.8-9-5.5-14.4-4.4l-76.2 15.1-43.1-64.6c-6-8.9-20.6-8.9-26.6 0l-43.2 64.6-76.2-15.2c-5.3-1.1-10.6.7-14.4 4.4-3.8 3.8-5.4 9.2-4.4 14.4l15.1 76.3-64.5 43.2c-4.4 3-7.1 8-7.1 13.3C0 213 2.7 218 7.1 221l64.5 43.2-15.1 76.2c-1 5.3.6 10.7 4.4 14.4s9.2 5.4 14.4 4.4l56.3-11.1c8.8-14 20.3-26.3 33.9-36zM208 149.8c28.8 0 52.5 21.2 56.9 48.8 2.4-.8 4.8-1.8 7.3-2.4 5-9 11.2-17.1 18-24.5-13.9-31.7-45.5-53.9-82.2-53.9-49.5 0-89.8 40.3-89.8 89.9 0 39.5 25.7 72.7 61.1 84.8 2.3-10.6 5.9-20.6 10.6-30.1-23-7.6-39.8-29.1-39.8-54.7.1-31.9 26-57.9 57.9-57.9z"]
  },
      ki = {
    prefix: "fal",
    iconName: "club",
    icon: [512, 512, [], "f327", "M256 32c64.9 0 109.1 65.6 85.7 125.4l-16 41c-1.7 4.3 1.9 8.7 6.4 8.1l43.7-5.8c55.4-7.3 103.8 35.7 104.2 90.5.4 51.7-42.8 93.2-94.5 92.7-41-.4-54.6-11.3-87.2-45.2-3.7-3.9-10.3-1.2-10.3 4.2v25c0 40.6 0 52.6 29.1 89.3 7.3 9.2.7 22.7-11 22.7H205.8c-11.7 0-18.3-13.5-11-22.7C224 420.6 224 408.6 224 368v-25c0-5.4-6.6-8.1-10.3-4.2-32.3 33.7-45.9 44.7-87.1 45.2-51.8.5-95-41.1-94.5-92.8.5-54.8 49-97.7 104.2-90.3l43.7 5.8c4.5.6 8-3.9 6.4-8.1l-16-41C146.8 97.5 191.2 32 256 32m0-32c-87.4 0-147.1 88.2-115.5 169.1C65.6 159.2 0 217.6 0 292c0 68.4 55.6 124 124 124 35.5 0 52-8 76-32 0 24-9.7 27.6-30.2 53.4-23.9 30.1-2.4 74.6 36 74.6h100.3c38.5 0 60-44.5 36-74.6-19-24.1-30.1-29.4-30.1-53.4 24 24 48.9 32 76 32 68.4 0 124-55.6 124-124 0-74.5-65.8-132.8-140.5-122.9C403.1 88.4 343.5 0 256 0z"]
  },
      Ii = {
    prefix: "fal",
    iconName: "cocktail",
    icon: [576, 512, [], "f561", "M391.32 128H24.68c-21.95 0-32.94 26.53-17.42 42.05L192 354.79V480h-53.33c-14.73 0-26.67 11.94-26.67 26.67 0 2.95 2.39 5.33 5.33 5.33h181.33c2.95 0 5.33-2.39 5.33-5.33 0-14.73-11.94-26.67-26.67-26.67H224V354.79l107.7-107.7 22.66-22.66 54.37-54.37c15.52-15.53 4.53-42.06-17.41-42.06zM208 325.53L42.47 160h331.06L208 325.53zM432 0c-62.55 0-114.89 40.23-134.61 96h34.31c17.95-37.68 55.83-64 100.3-64 61.76 0 112 50.24 112 112s-50.24 112-112 112c-18.49 0-35.68-4.93-51.06-12.9l-23.52 23.52C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0zm0 192c-.04 0-.08-.01-.13-.01-.2.21-.3.48-.51.69L405.04 219c8.46 3.05 17.46 5 26.96 5 44.12 0 80-35.89 80-80s-35.88-80-80-80c-26.05 0-49.01 12.68-63.62 32H432c26.47 0 48 21.53 48 48s-21.53 48-48 48z"]
  },
      Oi = {
    prefix: "fal",
    iconName: "code",
    icon: [576, 512, [], "f121", "M228.5 511.8l-25-7.1c-3.2-.9-5-4.2-4.1-7.4L340.1 4.4c.9-3.2 4.2-5 7.4-4.1l25 7.1c3.2.9 5 4.2 4.1 7.4L235.9 507.6c-.9 3.2-4.3 5.1-7.4 4.2zm-75.6-125.3l18.5-20.9c1.9-2.1 1.6-5.3-.5-7.1L49.9 256l121-102.5c2.1-1.8 2.4-5 .5-7.1l-18.5-20.9c-1.8-2.1-5-2.3-7.1-.4L1.7 252.3c-2.3 2-2.3 5.5 0 7.5L145.8 387c2.1 1.8 5.3 1.6 7.1-.5zm277.3.4l144.1-127.2c2.3-2 2.3-5.5 0-7.5L430.2 125.1c-2.1-1.8-5.2-1.6-7.1.4l-18.5 20.9c-1.9 2.1-1.6 5.3.5 7.1l121 102.5-121 102.5c-2.1 1.8-2.4 5-.5 7.1l18.5 20.9c1.8 2.1 5 2.3 7.1.4z"]
  },
      Qi = {
    prefix: "fal",
    iconName: "code-branch",
    icon: [384, 512, [], "f126", "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 39.2 28.2 71.8 65.5 78.7-.8 17.2-5 30.4-12.7 40-17.5 21.8-53.1 25.2-90.7 28.7-28.2 2.6-57.4 5.4-80.4 16.9-3.4 1.7-6.7 3.6-9.7 5.7V158.4c36.5-7.4 64-39.7 64-78.4 0-44.2-35.8-80-80-80S0 35.8 0 80c0 38.7 27.5 71 64 78.4v195.2C27.5 361 0 393.3 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-36.9-24.9-67.9-58.9-77.2 5-9.6 12.3-14.6 19-18 17.5-8.8 42.5-11.2 68.9-13.7 42.6-4 86.7-8.1 112.7-40.5 12.4-15.5 19-35.5 19.8-60.7C357.3 214 384 182.1 384 144zM32 80c0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48zm96 352c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-26.4 21.4-47.9 47.8-48h.6c26.3.2 47.6 21.7 47.6 48zm187.8-241.5L304 192c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48c0 22.4-15.4 41.2-36.2 46.5z"]
  },
      Zi = {
    prefix: "fal",
    iconName: "code-commit",
    icon: [640, 512, [], "f386", "M320 128c34.19 0 66.33 13.31 90.51 37.49S448 221.81 448 256s-13.31 66.33-37.49 90.51S354.19 384 320 384s-66.33-13.31-90.51-37.49S192 290.19 192 256s13.31-66.33 37.49-90.51S285.81 128 320 128m0-32c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160S408.37 96 320 96zm308 144H511.33c.44 5.3.67 10.63.67 16s-.23 10.7-.67 16H628c6.63 0 12-5.37 12-12v-8c0-6.63-5.37-12-12-12zm-500 16c0-5.37.23-10.7.67-16H12c-6.63 0-12 5.37-12 12v8c0 6.63 5.37 12 12 12h116.67c-.44-5.3-.67-10.63-.67-16z"]
  },
      Ui = {
    prefix: "fal",
    iconName: "code-merge",
    icon: [384, 512, [], "f387", "M304 192c-41.7 0-76 32-79.7 72.8-25.2-1.3-61.6-7.9-88.8-31.7-20.3-17.8-32.8-43-37.5-75.1 35.5-8.2 62-40 62-77.9 0-44.2-35.8-80-80-80S0 35.8 0 80c0 38.7 27.5 71 64 78.4v195.2C27.5 361 0 393.3 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-38.7-27.5-71-64-78.4V237.4c5.5 7.2 11.7 13.9 18.6 19.9C151 289 197.9 296.1 228 297c10.5 31.9 40.5 55 76 55 44.2 0 80-35.8 80-80s-35.8-80-80-80zM32 80c0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48zm96 352c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zm176-112c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      Bi = {
    prefix: "fal",
    iconName: "coffee",
    icon: [576, 512, [], "f0f4", "M517.9 448H26.1c-24.5 0-33.1-32-20-32h531.8c13.1 0 4.5 32-20 32zM576 159.1c.5 53.4-42.7 96.9-96 96.9h-32v32c0 53-43 96-96 96H160c-53 0-96-43-96-96V76c0-6.6 5.4-12 12-12h402.8c52.8 0 96.7 42.2 97.2 95.1zM416 96H96v192c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V96zm128 64c0-35.3-28.7-64-64-64h-32v128h32c35.3 0 64-28.7 64-64z"]
  },
      Ri = {
    prefix: "fal",
    iconName: "coffee-pot",
    icon: [512, 512, [], "e002", "M431.45,177.65,437.33,160h0L480,32H80A80,80,0,0,0,0,112V216a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V112A48,48,0,0,1,80,64h26.67l32,96h0l6.05,18.16C95.41,217.9,64,277.69,64,344.62c0,51.47,18.62,84.77,49.64,117.71A57.18,57.18,0,0,0,155.17,480H420.84a57.08,57.08,0,0,0,41.45-17.6c31-32.95,49.69-66.24,49.71-117.72C512,278.37,481.37,217.83,431.45,177.65ZM140.4,64H435.6l-32,96H172.4Zm38.15,128h219.7c21,16.92,54.68,42.08,72.5,96H105.39C123.5,234,158.21,208.39,178.55,192ZM439,440.45A24.92,24.92,0,0,1,420.84,448H155.17a25,25,0,0,1-18.23-7.62C107.1,408.71,96,382.75,96,344.62A178.3,178.3,0,0,1,97.9,320H478.13A180.47,180.47,0,0,1,480,344.67C480,382.79,468.88,408.75,439,440.45Z"]
  },
      Yi = {
    prefix: "fal",
    iconName: "coffee-togo",
    icon: [448, 512, [], "f6c5", "M432 64h-16l-23.16-46.31A32 32 0 0 0 364.22 0H83.78a32 32 0 0 0-28.62 17.69L32 64H16C7.16 64 0 71.16 0 80v64c0 8.84 7.16 16 16 16h18.67l26.89 322.66C62.94 499.24 76.8 512 93.44 512h261.11c16.64 0 30.51-12.76 31.89-29.34L413.33 160H432c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16zm-77.44 416H93.44l-5.33-64h271.78l-5.33 64zm8-96H85.44L74.78 256h298.45l-10.67 128zm13.33-160H72.11l-5.33-64h314.45l-5.34 64zM416 128H32V96h19.78l32-64h280.45l32 64H416v32z"]
  },
      Pi = {
    prefix: "fal",
    iconName: "coffin",
    icon: [384, 512, [], "f6c6", "M370.62,112.7,271.83,13.47A45.65,45.65,0,0,0,239.38,0H144.62a45.63,45.63,0,0,0-32.47,13.5L13.39,112.7a46.34,46.34,0,0,0-12,43.64L81.2,477.14A45.83,45.83,0,0,0,125.71,512H258.29a45.83,45.83,0,0,0,44.51-34.86l79.85-320.77a46.39,46.39,0,0,0-12-43.67ZM271.73,469.42A13.83,13.83,0,0,1,258.29,480H125.71a13.82,13.82,0,0,1-13.44-10.58L32.42,148.59a14.16,14.16,0,0,1,3.66-13.33l98.73-99.17A13.84,13.84,0,0,1,144.62,32h94.76a13.78,13.78,0,0,1,9.78,4.06l98.76,99.2a14.22,14.22,0,0,1,3.66,13.36l-79.85,320.8Z"]
  },
      Fi = {
    prefix: "fal",
    iconName: "coffin-cross",
    icon: [384, 512, [], "e051", "M370.62 112.7l-98.79-99.23C263.13 4.78 251.6 0 239.38 0h-94.76c-12.22 0-23.75 4.78-32.47 13.5l-98.76 99.2C2.07 124.08-2.52 140.81 1.35 156.34l79.85 320.8c5.1 20.52 23.41 34.86 44.51 34.86h132.58c21.1 0 39.41-14.34 44.51-34.86l79.85-320.77c3.87-15.56-.72-32.29-12.03-43.67zm-98.89 356.72c-1.53 6.23-7.06 10.58-13.44 10.58H125.71c-6.38 0-11.91-4.34-13.44-10.58L32.42 148.59c-1.19-4.75.22-9.86 3.66-13.33l98.73-99.17c2.66-2.64 6.13-4.09 9.81-4.09h94.76c3.69 0 7.16 1.45 9.78 4.06l98.76 99.2c3.44 3.47 4.84 8.58 3.66 13.36l-79.85 320.8zm.28-325.42h-32v-32c0-8.84-7.16-16-16-16H160c-8.84 0-16 7.16-16 16v32h-32c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h32v96c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-96h32c8.84 0 16-7.16 16-16v-64c.01-8.84-7.15-16-15.99-16zm-16 64H208v112h-32V208h-48.01v-32H176v-48h32v48h48.01v32z"]
  },
      Wi = {
    prefix: "fal",
    iconName: "cog",
    icon: [512, 512, [], "f013", "M482.696 299.276l-32.61-18.827a195.168 195.168 0 0 0 0-48.899l32.61-18.827c9.576-5.528 14.195-16.902 11.046-27.501-11.214-37.749-31.175-71.728-57.535-99.595-7.634-8.07-19.817-9.836-29.437-4.282l-32.562 18.798a194.125 194.125 0 0 0-42.339-24.48V38.049c0-11.13-7.652-20.804-18.484-23.367-37.644-8.909-77.118-8.91-114.77 0-10.831 2.563-18.484 12.236-18.484 23.367v37.614a194.101 194.101 0 0 0-42.339 24.48L105.23 81.345c-9.621-5.554-21.804-3.788-29.437 4.282-26.36 27.867-46.321 61.847-57.535 99.595-3.149 10.599 1.47 21.972 11.046 27.501l32.61 18.827a195.168 195.168 0 0 0 0 48.899l-32.61 18.827c-9.576 5.528-14.195 16.902-11.046 27.501 11.214 37.748 31.175 71.728 57.535 99.595 7.634 8.07 19.817 9.836 29.437 4.283l32.562-18.798a194.08 194.08 0 0 0 42.339 24.479v37.614c0 11.13 7.652 20.804 18.484 23.367 37.645 8.909 77.118 8.91 114.77 0 10.831-2.563 18.484-12.236 18.484-23.367v-37.614a194.138 194.138 0 0 0 42.339-24.479l32.562 18.798c9.62 5.554 21.803 3.788 29.437-4.283 26.36-27.867 46.321-61.847 57.535-99.595 3.149-10.599-1.47-21.972-11.046-27.501zm-65.479 100.461l-46.309-26.74c-26.988 23.071-36.559 28.876-71.039 41.059v53.479a217.145 217.145 0 0 1-87.738 0v-53.479c-33.621-11.879-43.355-17.395-71.039-41.059l-46.309 26.74c-19.71-22.09-34.689-47.989-43.929-75.958l46.329-26.74c-6.535-35.417-6.538-46.644 0-82.079l-46.329-26.74c9.24-27.969 24.22-53.869 43.929-75.969l46.309 26.76c27.377-23.434 37.063-29.065 71.039-41.069V44.464a216.79 216.79 0 0 1 87.738 0v53.479c33.978 12.005 43.665 17.637 71.039 41.069l46.309-26.76c19.709 22.099 34.689 47.999 43.929 75.969l-46.329 26.74c6.536 35.426 6.538 46.644 0 82.079l46.329 26.74c-9.24 27.968-24.219 53.868-43.929 75.957zM256 160c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"]
  },
      Gi = {
    prefix: "fal",
    iconName: "cogs",
    icon: [640, 512, [], "f085", "M538.6 196.4l-2.5-3.9c-4.1.3-8.1.3-12.2 0l-2.5 4c-5.8 9.2-17.1 13.4-27.5 10.1-13.8-4.3-23-8.8-34.3-18.1-9-7.4-11.2-20.3-5.4-30.4l2.5-4.3c-2.3-3.4-4.3-6.9-6.1-10.6h-9.1c-11.6 0-21.4-8.2-23.6-19.6-2.6-13.7-2.7-24.2.1-38.5 2.1-11.3 12.1-19.5 23.6-19.5h9c1.8-3.7 3.8-7.2 6.1-10.6l-2.6-4.5c-5.8-10-3.6-22.7 5.2-30.3 10.6-9.1 19.7-14.3 33.5-19 10.8-3.7 22.7.7 28.5 10.6l2.6 4.4c4.1-.3 8.1-.3 12.2 0l2.6-4.4c5.8-9.9 17.7-14.3 28.6-10.5 13.3 4.5 22.3 9.6 33.5 19.1 8.8 7.5 10.9 20.2 5.1 30.2l-2.6 4.4c2.3 3.4 4.3 6.9 6.1 10.6h5.1c11.6 0 21.4 8.2 23.6 19.6 2.6 13.7 2.7 24.2-.1 38.5-2.1 11.3-12.1 19.5-23.6 19.5h-5c-1.8 3.7-3.8 7.2-6.1 10.6l2.5 4.3c5.9 10.2 3.5 23.1-5.5 30.5-10.7 8.8-19.9 13.4-34 17.9-10.5 3.3-21.9-.8-27.7-10.1zm12.2-34.5l10.6 18.3c6.7-2.8 12.9-6.4 18.7-10.8l-10.6-18.3 6.4-7.5c4.8-5.7 8.6-12.1 11-19.1l3.3-9.3h21.1c.9-7.1.9-14.4 0-21.5h-21.1l-3.3-9.3c-2.5-7-6.2-13.4-11-19.1l-6.4-7.5L580 39.4c-5.7-4.4-12-8-18.7-10.8l-10.6 18.3-9.7-1.8c-7.3-1.4-14.8-1.4-22.1 0l-9.7 1.8-10.6-18.3C492 31.3 485.7 35 480 39.4l10.6 18.3-6.4 7.5c-4.8 5.7-8.6 12.1-11 19.1l-3.3 9.3h-21.1c-.9 7.1-.9 14.4 0 21.5h21.1l3.3 9.3c2.5 7 6.2 13.4 11 19.1l6.4 7.5-10.6 18.4c5.7 4.4 12 8 18.7 10.8l10.6-18.3 9.7 1.8c7.3 1.4 14.8 1.4 22.1 0l9.7-1.8zM145.3 454.4v-31.6c-12.9-5.5-25.1-12.6-36.4-21.1l-27.5 15.9c-9.8 5.6-22.1 3.7-29.7-4.6-24.2-26.3-38.5-49.5-50.6-88.1-3.4-10.7 1.1-22.3 10.8-28L39.2 281c-1.7-14-1.7-28.1 0-42.1l-27.3-15.8c-9.7-5.6-14.2-17.3-10.8-28 12.1-38.4 26.2-61.6 50.6-88.1 7.6-8.3 20-10.2 29.7-4.6l27.4 15.9c11.3-8.5 23.5-15.5 36.4-21.1V65.6c0-11.3 7.8-21 18.8-23.4 34.7-7.8 62-8.7 101.7 0 11 2.4 18.9 12.2 18.9 23.4v31.6c12.9 5.5 25.1 12.6 36.4 21l27.4-15.8c9.8-5.6 22.2-3.7 29.8 4.6 26.9 29.6 41.5 55.9 52.1 88.5 3.4 10.5-.8 21.9-10.2 27.7l-25 15.8c1.7 14 1.7 28.1 0 42.1l28.1 17.5c8.6 5.4 13 15.6 10.8 25.5-6.9 31.3-33 64.6-55.9 89.2-7.6 8.2-19.9 10-29.6 4.4L321 401.8c-11.3 8.5-23.5 15.5-36.4 21.1v31.6c0 11.2-7.8 21-18.8 23.4-37.5 8.3-64.9 8.2-101.9 0-10.8-2.5-18.6-12.3-18.6-23.5zm32-6.2c24.8 5 50.5 5 75.3 0v-47.7l10.7-3.8c16.8-5.9 32.3-14.9 45.9-26.5l8.6-7.4 41.4 23.9c16.8-19.1 34-41.3 42.1-65.2l-41.4-23.9 2.1-11.1c3.2-17.6 3.2-35.5 0-53.1l-2.1-11.1 41.4-23.9c-8.1-23.9-25.3-46.2-42.1-65.2l-41.4 23.9-8.6-7.4c-13.6-11.7-29-20.6-45.9-26.5l-10.7-3.8V71.8c-24.8-5-50.5-5-75.3 0v47.7l-10.7 3.8c-16.8 5.9-32.3 14.9-45.9 26.5l-8.6 7.4-41.4-23.9A192.19 192.19 0 0 0 33 198.5l41.4 23.9-2.1 11.1c-3.2 17.6-3.2 35.5 0 53.1l2.1 11.1L33 321.6c8.1 23.9 20.9 46.2 37.7 65.2l41.4-23.9 8.6 7.4c13.6 11.7 29 20.6 45.9 26.5l10.7 3.8v47.6zm38.4-105.3c-45.7 0-82.9-37.2-82.9-82.9s37.2-82.9 82.9-82.9 82.9 37.2 82.9 82.9-37.2 82.9-82.9 82.9zm0-133.8c-28 0-50.9 22.8-50.9 50.9s22.8 50.9 50.9 50.9c28 0 50.9-22.8 50.9-50.9s-22.8-50.9-50.9-50.9zm322.9 291.7l-2.5-3.9c-4.1.3-8.1.3-12.2 0l-2.5 4c-5.8 9.2-17.1 13.4-27.5 10.1-13.8-4.3-23-8.8-34.3-18.1-9-7.4-11.2-20.3-5.4-30.4l2.5-4.3c-2.3-3.4-4.3-6.9-6.1-10.6h-9.1c-11.6 0-21.4-8.2-23.6-19.6-2.6-13.7-2.7-24.2.1-38.5 2.1-11.3 12.1-19.5 23.6-19.5h9c1.8-3.7 3.8-7.2 6.1-10.6l-2.6-4.5c-5.8-10-3.6-22.7 5.2-30.3 10.6-9.1 19.7-14.3 33.5-19 10.8-3.7 22.7.7 28.5 10.6l2.6 4.4c4.1-.3 8.1-.3 12.2 0l2.6-4.4c5.8-9.9 17.7-14.3 28.6-10.5 13.3 4.5 22.3 9.6 33.5 19.1 8.8 7.5 10.9 20.2 5.1 30.2l-2.6 4.4c2.3 3.4 4.3 6.9 6.1 10.6h5.1c11.6 0 21.4 8.2 23.6 19.6 2.6 13.7 2.7 24.2-.1 38.5-2.1 11.3-12.1 19.5-23.6 19.5h-5c-1.8 3.7-3.8 7.2-6.1 10.6l2.5 4.3c5.9 10.2 3.5 23.1-5.5 30.5-10.7 8.8-19.9 13.4-34 17.9-10.5 3.2-21.9-.9-27.7-10.1zm12.2-34.6l10.6 18.3c6.7-2.8 12.9-6.4 18.7-10.8l-10.6-18.3 6.4-7.5c4.8-5.7 8.6-12.1 11-19.1l3.3-9.3h21.1c.9-7.1.9-14.4 0-21.5h-21.1l-3.3-9.3c-2.5-7-6.2-13.4-11-19.1l-6.4-7.5 10.6-18.3c-5.7-4.4-12-8-18.7-10.8l-10.6 18.3-9.7-1.8c-7.3-1.4-14.8-1.4-22.1 0l-9.7 1.8-10.6-18.3c-6.7 2.8-12.9 6.4-18.7 10.8l10.6 18.3-6.4 7.5c-4.8 5.7-8.6 12.1-11 19.1l-3.3 9.3h-21.1c-.9 7.1-.9 14.4 0 21.5h21.1l3.3 9.3c2.5 7 6.2 13.4 11 19.1l6.4 7.5-10.6 18.3c5.7 4.4 12 8 18.7 10.8l10.6-18.3 9.7 1.8c7.3 1.4 14.8 1.4 22.1 0l9.7-1.8zM560 408c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm0-304.3c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.4 32-32z"]
  },
      qi = {
    prefix: "fal",
    iconName: "coin",
    icon: [512, 512, [], "f85c", "M256 64C114.67 64 0 128.44 0 208v112c0 70.72 114.67 128 256 128s256-57.28 256-128V208c0-79.56-114.67-144-256-144zM64 366.61C43.69 352 32 335.68 32 320v-42.34A183.65 183.65 0 0 0 64 303zm80 35.32A306.25 306.25 0 0 1 96 385v-64.69a327.39 327.39 0 0 0 48 17zm96 13.68a450 450 0 0 1-64-6.61v-64.27a442.1 442.1 0 0 0 64 6.53zm96-6.61a450 450 0 0 1-64 6.64v-64.38a442.1 442.1 0 0 0 64-6.53zm80-24a306.25 306.25 0 0 1-48 16.9v-64.6a327.39 327.39 0 0 0 48-17zm64-65c0 15.68-11.69 32-32 46.61V303a183.65 183.65 0 0 0 32-25.37zm-224 0c-132 0-224-59-224-112S124 96 256 96s224 59 224 112-92 112-224 112z"]
  },
      Ji = {
    prefix: "fal",
    iconName: "coins",
    icon: [512, 512, [], "f51e", "M336 32c-48.6 0-92.6 9-124.5 23.4-.9.4-51.5 21-51.5 56.6v16.7C76.1 132.2 0 163.4 0 208v192c0 44.2 78.8 80 176 80s176-35.8 176-80v-16.4c89.7-3.7 160-37.9 160-79.6V112c0-37-62.1-80-176-80zm-16 368c0 13.9-50.5 48-144 48S32 413.9 32 400v-50.1c31.8 20.6 84.4 34.1 144 34.1s112.2-13.5 144-34.1V400zm0-96c0 13.9-50.5 48-144 48S32 317.9 32 304v-50.1c31.8 20.6 84.4 34.1 144 34.1s112.2-13.5 144-34.1V304zm-144-48c-81 0-146.7-21.5-146.7-48S95 160 176 160s146.7 21.5 146.7 48S257 256 176 256zm304 48c0 13.1-45 43.6-128 47.3v-64.1c52.8-2.2 99.1-14.6 128-33.3V304zm0-96c0 13.1-45.1 43.4-128 47.2V208c0-5.6-1.7-11-4.1-16.3 54.6-1.7 102.4-14.5 132.1-33.8V208zm-144-48c-7.3 0-14-.5-20.9-.9-36.9-21.7-85-28.2-115.6-30-6.3-5.3-10.1-11-10.1-17.1 0-26.5 65.7-48 146.7-48s146.7 21.5 146.7 48S417 160 336 160z"]
  },
      Ki = {
    prefix: "fal",
    iconName: "columns",
    icon: [512, 512, [], "f0db", "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM240 448H48c-8.837 0-16-7.163-16-16V96h208v352zm240-16c0 8.837-7.163 16-16 16H272V96h208v336z"]
  },
      Xi = {
    prefix: "fal",
    iconName: "comet",
    icon: [512, 512, [], "e003", "M236.90992,256.02578,205.6384,192.55713a15.29617,15.29617,0,0,0-27.45706,0l-31.27152,63.46865L77.04451,266.223a15.3143,15.3143,0,0,0-8.46875,26.13668l50.60356,49.33391-12,69.72841a15.3707,15.3707,0,0,0,15.08595,17.9531,14.985,14.985,0,0,0,7.11329-1.81641L191.90987,394.631l62.53131,32.92768A15.26524,15.26524,0,0,0,276.64043,411.422l-11.92775-69.72841,50.5938-49.33391a15.347,15.347,0,0,0-8.53126-26.13668Zm5.46289,62.75772-12.03712,11.73435,2.83594,16.57029,6.22266,36.38081L206.82,366.31663l-14.91017-7.85155-14.91017,7.85155-32.53715,17.13278,6.25392-36.32806L153.57,330.53153l-12.05274-11.75194L115.08362,293.0101l36.4473-5.32031,16.64846-2.42968,7.43555-15.09177,16.29494-33.07222,16.29494,33.07222,7.43555,15.09177,16.64846,2.42968,36.50589,5.32812ZM504.754,7.23124a24.64079,24.64079,0,0,0-24.5-6.20116C447.97068,10.825,371.3749,34.616,312.87484,59.92256c-.8125-2.90624-1.71875-5.5-2.40625-7.90428a31.09684,31.09684,0,0,0-17.72073-19.58981,30.52225,30.52225,0,0,0-26.375,1.18749C223.154,56.11007,116.36877,114.79943,58.05621,173.08255c-77.40828,77.3866-77.40828,203.45086,0,280.83746a198.87425,198.87425,0,0,0,280.91241,0c58.28326-58.28311,116.90832-165.05444,139.50405-208.24578a31.37146,31.37146,0,0,0,1.1875-26.40035,31.034,31.034,0,0,0-19.59572-17.69919c-2.40626-.6875-5-1.5-7.90626-2.39062,25.002-58.18741,49.002-134.96659,58.81451-167.365A24.76358,24.76358,0,0,0,504.754,7.23124Zm-89.2833,195.2497-7.90626,16.90232,18,5.18554c9.68751,2.81249,18.40627,5.40624,24.40628,6.20311-21.81253,41.89447-78.59579,145.37088-133.72085,200.45087-64.877,64.89053-170.69158,64.98428-235.59985,0s-64.90827-170.66185,0-235.53675C135.74575,140.59041,239.24781,83.80729,279.87285,61.51631c2,6.59179,4.59376,15.29295,7.375,24.99215l5.21875,17.99607,16.90823-7.90429c51.375-24.08785,126.28333-48.28508,166.69158-60.67178C463.752,76.30926,439.37692,151.49274,415.47065,202.48094Z"]
  },
      _i = {
    prefix: "fal",
    iconName: "comment",
    icon: [512, 512, [], "f075", "M256 64c123.5 0 224 79 224 176S379.5 416 256 416c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176m0-32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26 3.8 8.8 12.4 14.5 22 14.5 61.5 0 110-25.7 139.1-46.3 29 9.1 60.2 14.3 93 14.3 141.4 0 256-93.1 256-208S397.4 32 256 32z"]
  },
      $i = {
    prefix: "fal",
    iconName: "comment-alt",
    icon: [512, 512, [], "f27a", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288z"]
  },
      co = {
    prefix: "fal",
    iconName: "comment-alt-check",
    icon: [512, 512, [], "f4a2", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM345.3 134.5c-1.6-1.6-3.6-2.3-5.7-2.3-2 0-4.1.8-5.7 2.3L226.5 241.9 178 193.4c-1.6-1.6-3.6-2.3-5.7-2.3-2 0-4.1.8-5.7 2.3l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l65.5 65.5c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3L356.7 157c3.1-3.1 3.1-8.2 0-11.3l-11.4-11.2z"]
  },
      eo = {
    prefix: "fal",
    iconName: "comment-alt-dollar",
    icon: [512, 512, [], "f650", "M448 0H64C28.65 0 0 28.65 0 64v288c0 35.35 28.65 64 64 64h96v83.98c0 7.1 5.83 12.02 12.05 12.02 2.41 0 4.87-.74 7.08-2.37L304 416h144c35.35 0 64-28.65 64-64V64c0-35.35-28.65-64-64-64zm32 352c0 17.64-14.36 32-32 32H293.34l-8.53 6.4L192 459.98V384H64c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h384c17.64 0 32 14.36 32 32v288zM289.94 201.05l-59.06-16.86c-8.75-2.52-14.88-10.61-14.88-19.7 0-11.3 9.19-20.48 20.47-20.48h36.91c8.24 0 16.08 2.56 22.63 7.32 2.99 2.17 7.22 1.46 9.84-1.16l11.42-11.42c3.5-3.5 2.94-9.22-.99-12.23-12.26-9.41-27.18-14.51-42.9-14.51H272V88c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v24h-3.53c-30.59 0-55.13 26.3-52.24 57.48 2.06 22.16 19.06 40.12 40.45 46.22l56.44 16.11c8.75 2.52 14.88 10.61 14.88 19.7 0 11.3-9.19 20.48-20.47 20.48h-36.91c-8.24 0-16.08-2.56-22.63-7.32-2.99-2.17-7.22-1.46-9.84 1.16l-11.42 11.42c-3.5 3.5-2.94 9.21.99 12.23 12.26 9.41 27.18 14.51 42.9 14.51H240v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24h1.36c22.81 0 44.33-13.59 51.72-35.17 10.15-29.64-7.28-59.79-35.14-67.77z"]
  },
      ao = {
    prefix: "fal",
    iconName: "comment-alt-dots",
    icon: [512, 512, [], "f4a3", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM128 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z"]
  },
      no = {
    prefix: "fal",
    iconName: "comment-alt-edit",
    icon: [512, 512, [], "f4a4", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM336 105.4c-12.5-12.5-32.8-12.5-45.2 0l-126.1 126c-2 2-3.4 4.5-4.2 7.3l-16 61.2c-1.4 5.5.1 11.3 4.2 15.4 3 3 7.1 4.7 11.3 4.7 1.3 0 2.7-.2 4-.5l61.2-16c2.8-.7 5.3-2.2 7.3-4.2l126.1-126.1c12.5-12.5 12.5-32.8 0-45.2L336 105.4zM213 273.6l-30.6 8 8-30.6 75-75 22.6 22.6-75 75zm97.6-97.6L288 153.4l25.4-25.4 22.6 22.6-25.4 25.4z"]
  },
      to = {
    prefix: "fal",
    iconName: "comment-alt-exclamation",
    icon: [512, 512, [], "f4a5", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zm-224-88c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-8.5-24h17c4.2 0 7.7-3.3 8-7.5l7-112c.3-4.6-3.4-8.5-8-8.5h-31c-4.6 0-8.3 3.9-8 8.5l7 112c.3 4.2 3.8 7.5 8 7.5z"]
  },
      ro = {
    prefix: "fal",
    iconName: "comment-alt-lines",
    icon: [512, 512, [], "f4a6", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM280 240H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm96-96H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      io = {
    prefix: "fal",
    iconName: "comment-alt-medical",
    icon: [512, 512, [], "f7f4", "M448 0H64A64 64 0 0 0 0 64v288a64 64 0 0 0 64 64h96v84a12 12 0 0 0 12.05 12 11.84 11.84 0 0 0 7.08-2.37L304 416h144a64 64 0 0 0 64-64V64a64 64 0 0 0-64-64zm32 352a32 32 0 0 1-32 32H293.34l-8.54 6.4L192 460v-76H64a32 32 0 0 1-32-32V64a32 32 0 0 1 32-32h384a32 32 0 0 1 32 32zM344 176h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8z"]
  },
      oo = {
    prefix: "fal",
    iconName: "comment-alt-minus",
    icon: [512, 512, [], "f4a7", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM344 192H168c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      lo = {
    prefix: "fal",
    iconName: "comment-alt-music",
    icon: [512, 512, [], "f8af", "M448 0H64A64.05 64.05 0 0 0 0 64v288a64.05 64.05 0 0 0 64 64h96v84a12 12 0 0 0 12 12 11.35 11.35 0 0 0 7.09-2.41L304 416h144a64.05 64.05 0 0 0 64-64V64a64.05 64.05 0 0 0-64-64zm32 352a32.11 32.11 0 0 1-32 32H293.31l-8.5 6.41L192 460v-76H64a32.11 32.11 0 0 1-32-32V64a32.11 32.11 0 0 1 32-32h384a32.11 32.11 0 0 1 32 32zM331.19 96.75l-128 47.25A16 16 0 0 0 192 159.25V258a69.89 69.89 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32V179.16l96-37.52V226a69.89 69.89 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32V112a16 16 0 0 0-20.81-15.25z"]
  },
      fo = {
    prefix: "fal",
    iconName: "comment-alt-plus",
    icon: [512, 512, [], "f4a8", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM344 192h-72v-72c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v72h-72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h72v72c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-72h72c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      so = {
    prefix: "fal",
    iconName: "comment-alt-slash",
    icon: [640, 512, [], "f4a9", "M637 485.2l-96.7-76.1-22.5-17.7-443.2-349-5.2-4.1L23 1.8C19.6-1 14.5-.4 11.8 3l-10 12.5C-1 19-.4 24 3 26.8l61 48L96 100l360.7 284 15.9 12.5L617 510.2c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.2-8.5-1.2-11.3zM368 384h-10.7l-8.5 6.4L256 460v-76H128c-17.6 0-32-14.4-32-32V161.1l-32-25.2V352c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L368 416h51.7l-40.6-32H368zM512 32c17.6 0 32 14.4 32 32v286.9l28.2 22.2c2.3-6.6 3.8-13.7 3.8-21.1V64c0-35.3-28.7-64-64-64H128c-8.4 0-16.4 1.7-23.7 4.7L139 32h373z"]
  },
      uo = {
    prefix: "fal",
    iconName: "comment-alt-smile",
    icon: [512, 512, [], "f4aa", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM331.8 237.3C313 259.4 285.4 272 256 272s-57-12.6-75.8-34.6c-5.7-6.7-15.8-7.4-22.5-1.8-6.8 5.8-7.5 15.8-1.8 22.6C180.7 287.3 217.2 304 256 304s75.3-16.7 100.2-45.9c5.8-6.7 4.9-16.8-1.8-22.6-6.7-5.7-16.8-4.9-22.6 1.8zM192 184c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zm128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24z"]
  },
      ho = {
    prefix: "fal",
    iconName: "comment-alt-times",
    icon: [512, 512, [], "f4ab", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM329.5 145.8l-11.3-11.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3L256 185.4l-50.9-50.9c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l50.9 50.9-50.9 50.9c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l50.9-50.9 50.9 50.9c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-51-50.9 50.9-50.9c3.2-3.1 3.2-8.2 0-11.3z"]
  },
      mo = {
    prefix: "fal",
    iconName: "comment-check",
    icon: [512, 512, [], "f4ac", "M345.3 166.5c-1.6-1.6-3.6-2.3-5.7-2.3-2 0-4.1.8-5.7 2.3L226.5 273.9 178 225.4c-1.6-1.6-3.6-2.3-5.7-2.3-2 0-4.1.8-5.7 2.3l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l65.5 65.5c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3L356.7 189c3.1-3.1 3.1-8.2 0-11.3l-11.4-11.2zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 384c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176s224 79 224 176-100.5 176-224 176z"]
  },
      vo = {
    prefix: "fal",
    iconName: "comment-dollar",
    icon: [512, 512, [], "f651", "M256 32C114.62 32 0 125.12 0 240c0 47.55 19.86 91.23 52.9 126.27C38 405.72 6.97 439.06 6.54 439.5c-6.56 6.95-8.38 17.19-4.59 25.98S14.39 480 23.98 480c61.51 0 110.02-25.72 139.15-46.33C191.95 442.8 223.2 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm0 384c-28.33 0-56.32-4.32-83.21-12.84l-15.16-4.8-12.99 9.19c-23.02 16.29-58.53 35.34-102.62 39.59 11.99-15.09 29.82-40.44 40.81-69.55l7.07-18.71-13.72-14.55C47.28 313.67 32 277.6 32 240c0-97.05 100.49-176 224-176s224 78.95 224 176-100.49 176-224 176zm33.94-182.95l-59.06-16.86c-8.75-2.52-14.88-10.61-14.88-19.7 0-11.3 9.19-20.48 20.47-20.48h36.91c8.24 0 16.08 2.56 22.63 7.32 2.99 2.17 7.22 1.46 9.84-1.16l11.42-11.42c3.5-3.5 2.94-9.22-.99-12.23-12.26-9.41-27.18-14.51-42.9-14.51H272v-24c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v24h-3.53c-30.59 0-55.13 26.3-52.24 57.48 2.06 22.16 19.06 40.12 40.45 46.22l56.44 16.11c8.75 2.52 14.88 10.61 14.88 19.7 0 11.3-9.19 20.48-20.47 20.48h-36.91c-8.24 0-16.08-2.56-22.63-7.32-2.99-2.17-7.22-1.46-9.84 1.16l-11.42 11.42c-3.5 3.5-2.94 9.21.99 12.23 12.26 9.41 27.18 14.51 42.9 14.51H240v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24h1.36c22.81 0 44.33-13.59 51.72-35.17 10.15-29.65-7.28-59.8-35.14-67.78z"]
  },
      Mo = {
    prefix: "fal",
    iconName: "comment-dots",
    icon: [512, 512, [], "f4ad", "M128 216c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 384c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176s224 79 224 176-100.5 176-224 176z"]
  },
      po = {
    prefix: "fal",
    iconName: "comment-edit",
    icon: [512, 512, [], "f4ae", "M336 137.4c-12.5-12.5-32.8-12.5-45.2 0l-126.1 126c-2 2-3.4 4.5-4.2 7.3l-16 61.2c-1.4 5.5.1 11.3 4.2 15.4 3 3 7.1 4.7 11.3 4.7 1.3 0 2.7-.2 4-.5l61.2-16c2.8-.7 5.3-2.2 7.3-4.2l126.1-126.1c12.5-12.5 12.5-32.8 0-45.2L336 137.4zM213 305.6l-30.6 8 8-30.6 75-75 22.6 22.6-75 75zm97.6-97.6L288 185.4l25.4-25.4 22.6 22.6-25.4 25.4zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 384c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176s224 79 224 176-100.5 176-224 176z"]
  },
      zo = {
    prefix: "fal",
    iconName: "comment-exclamation",
    icon: [512, 512, [], "f4af", "M256 296c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-8.5-24h17c4.2 0 7.7-3.3 8-7.5l7-112c.3-4.6-3.4-8.5-8-8.5h-31c-4.6 0-8.3 3.9-8 8.5l7 112c.3 4.2 3.8 7.5 8 7.5zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 384c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176s224 79 224 176-100.5 176-224 176z"]
  },
      Co = {
    prefix: "fal",
    iconName: "comment-lines",
    icon: [512, 512, [], "f4b0", "M280 272H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm96-96H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 384c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176s224 79 224 176-100.5 176-224 176z"]
  },
      Lo = {
    prefix: "fal",
    iconName: "comment-medical",
    icon: [512, 512, [], "f7f5", "M344 208h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8zM256 32C114.62 32 0 125.12 0 240c0 47.55 19.86 91.23 52.9 126.27C38 405.72 7 439.06 6.54 439.5A24 24 0 0 0 24 480c61.51 0 110-25.72 139.15-46.33A307.33 307.33 0 0 0 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm0 384a275.11 275.11 0 0 1-83.21-12.84l-15.16-4.8-13 9.18c-23 16.29-58.53 35.34-102.63 39.59 12-15.13 29.84-40.44 40.84-69.55l7.06-18.71-13.72-14.56C47.28 313.67 32 277.6 32 240c0-97 100.49-176 224-176s224 79 224 176-100.49 176-224 176z"]
  },
      Ao = {
    prefix: "fal",
    iconName: "comment-minus",
    icon: [512, 512, [], "f4b1", "M344 224H168c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 384c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176s224 79 224 176-100.5 176-224 176z"]
  },
      No = {
    prefix: "fal",
    iconName: "comment-music",
    icon: [512, 512, [], "f8b0", "M256 32C114.64 32 .07 125.09.07 240 .07 287.59 20 331.2 53 366.3c-14.91 39.4-45.9 72.79-46.4 73.2A24 24 0 0 0 24 480c61.49 0 110-25.7 139.07-46.3A309.89 309.89 0 0 0 256 448c141.39 0 256-93.09 256-208S397.42 32 256 32zm0 384a275.44 275.44 0 0 1-83.17-12.8l-15.22-4.79-13 9.18c-23 16.32-58.49 35.32-102.58 39.61 12-15.11 29.81-40.4 40.81-69.61L90 358.91 76.24 344.3C47.37 313.7 32.06 277.59 32.06 240c0-97 100.49-176 224-176s224 79 224 176S379.52 416 256 416zm75.18-287.25L203.23 176A16 16 0 0 0 192 191.25V290a69.82 69.82 0 0 0-16-2c-26.49 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32V211.16l96-37.52V258a69.8 69.8 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32V144a16 16 0 0 0-20.79-15.25z"]
  },
      go = {
    prefix: "fal",
    iconName: "comment-plus",
    icon: [512, 512, [], "f4b2", "M344 224h-72v-72c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v72h-72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h72v72c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-72h72c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 384c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176s224 79 224 176-100.5 176-224 176z"]
  },
      Ho = {
    prefix: "fal",
    iconName: "comment-slash",
    icon: [640, 512, [], "f4b3", "M320 64c123.5 0 224 79 224 176 0 31.8-11 61.6-29.9 87.4l25 19.7C562.4 315.8 576 279.2 576 240c0-114.9-114.6-208-256-208-51.2 0-98.7 12.3-138.7 33.3l27.8 21.9C241.9 72.5 279.7 64 320 64zm317 421.2L164.8 113.4 138.9 93 23 1.8C19.6-1 14.5-.4 11.8 3l-10 12.5C-1 19-.4 24 3 26.8l112.5 88.6 25.1 19.8 476.4 375c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.2-8.5-1.2-11.3zM320 416c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C111.3 313.7 96 277.6 96 240c0-23.3 5.9-45.6 16.5-66l-25.4-20C72.4 180.3 64 209.3 64 240c0 47.6 19.9 91.2 52.9 126.3-14.9 39.4-45.9 72.8-46.4 73.2-6.6 7-8.4 17.2-4.6 26S78.4 480 88 480c61.5 0 110-25.7 139.1-46.3C256 442.8 287.2 448 320 448c40.6 0 78.9-7.9 113-21.6l-29.5-23.2c-25.9 8.2-54 12.8-83.5 12.8z"]
  },
      Vo = {
    prefix: "fal",
    iconName: "comment-smile",
    icon: [512, 512, [], "f4b4", "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 384c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176s224 79 224 176-100.5 176-224 176zm75.8-130.7C313 307.4 285.4 320 256 320s-57-12.6-75.8-34.6c-5.7-6.7-15.8-7.4-22.5-1.8-6.8 5.8-7.5 15.8-1.8 22.6C180.7 335.3 217.2 352 256 352s75.3-16.7 100.2-45.9c5.8-6.7 4.9-16.8-1.8-22.6-6.7-5.7-16.8-4.9-22.6 1.8zM192 216c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zm128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24z"]
  },
      xo = {
    prefix: "fal",
    iconName: "comment-times",
    icon: [512, 512, [], "f4b5", "M329.5 177.8l-11.3-11.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3L256 217.4l-50.9-50.9c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l50.9 50.9-50.9 50.9c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l50.9-50.9 50.9 50.9c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-51-50.9 50.9-50.9c3.2-3.1 3.2-8.2 0-11.3zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 384c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176s224 79 224 176-100.5 176-224 176z"]
  },
      wo = {
    prefix: "fal",
    iconName: "comments",
    icon: [576, 512, [], "f086", "M569.9 441.1c-.5-.4-22.6-24.2-37.9-54.9 27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.4 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.1 2.1 18.4 3.7 28 4.8 31.5 57.5 105.5 98 191.8 98 20.8 0 40.8-2.4 59.8-6.8 28.5 18.5 71.6 38.8 125.2 38.8 9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25zM155.4 314l-13.2-3-11.4 7.4c-20.1 13.1-50.5 28.2-87.7 32.5 8.8-11.3 20.2-27.6 29.5-46.4L83 283.7l-16.5-16.3C50.7 251.9 32 226.2 32 192c0-70.6 79-128 176-128s176 57.4 176 128-79 128-176 128c-17.7 0-35.4-2-52.6-6zm289.8 100.4l-11.4-7.4-13.2 3.1c-17.2 4-34.9 6-52.6 6-65.1 0-122-25.9-152.4-64.3C326.9 348.6 416 278.4 416 192c0-9.5-1.3-18.7-3.3-27.7C488.1 178.8 544 228.7 544 288c0 34.2-18.7 59.9-34.5 75.4L493 379.7l10.3 20.7c9.4 18.9 20.8 35.2 29.5 46.4-37.1-4.2-67.5-19.4-87.6-32.4z"]
  },
      yo = {
    prefix: "fal",
    iconName: "comments-alt",
    icon: [576, 512, [], "f4b6", "M512 160h-96V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v160c0 35.3 28.7 64 64 64h32v52c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4l76.9-43.5V384c0 35.3 28.7 64 64 64h96l108.9 61.6c2.2 1.6 4.7 2.4 7.1 2.4 6.2 0 12-4.9 12-12v-52h32c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64zM64 256c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h288c17.6 0 32 14.4 32 32v160c0 17.6-14.4 32-32 32H215.6l-7.3 4.2-80.3 45.4V256zm480 128c0 17.6-14.4 32-32 32h-64v49.6l-80.2-45.4-7.3-4.2H256c-17.6 0-32-14.4-32-32v-96h128c35.3 0 64-28.7 64-64v-32h96c17.6 0 32 14.4 32 32z"]
  },
      bo = {
    prefix: "fal",
    iconName: "comments-alt-dollar",
    icon: [576, 512, [], "f652", "M224 234.6c21.85-1.29 39.38-19.62 39.38-42.46 0-18.98-12.34-35.94-30-41.23l-41.56-12.47c-4.22-1.27-7.19-5.62-7.19-10.58 0-6.03 4.34-10.94 9.66-10.94h25.94c3.9 0 7.65 1.08 10.96 3.1 3.17 1.93 7.31 1.15 10-1.4l11.44-10.87c3.53-3.36 3.38-9.22-.54-12.11-8.18-6.03-17.97-9.58-28.08-10.32V72c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v13.4c-21.85 1.29-39.38 19.62-39.38 42.46 0 18.98 12.34 35.94 30 41.23l41.56 12.47c4.22 1.27 7.19 5.62 7.19 10.58 0 6.03-4.34 10.94-9.66 10.94h-25.94c-3.9 0-7.65-1.08-10.96-3.1-3.17-1.94-7.31-1.15-10 1.4l-11.44 10.87c-3.53 3.36-3.38 9.22.54 12.11 8.18 6.03 17.97 9.58 28.08 10.32V248c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-13.4zM512 160h-96V64c0-35.35-28.65-64-64-64H64C28.65 0 0 28.65 0 64v192c0 35.35 28.65 64 64 64h32v51.98c0 7.1 5.83 12.02 12.05 12.02 2.41 0 4.87-.74 7.08-2.37L192 338.12V384c0 35.35 28.65 64 64 64h96l108.87 61.63c2.21 1.63 4.68 2.37 7.08 2.37 6.22 0 12.05-4.92 12.05-12.02V448h32c35.35 0 64-28.65 64-64V224c0-35.35-28.65-64-64-64zM128 337.57V288H64c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h288c17.64 0 32 14.36 32 32v192c0 17.64-14.36 32-32 32H215.57L128 337.57zM544 384c0 17.64-14.36 32-32 32h-64v49.57L360.43 416H256c-17.64 0-32-14.36-32-32v-64h128c35.35 0 64-28.65 64-64v-64h96c17.64 0 32 14.36 32 32v160z"]
  },
      So = {
    prefix: "fal",
    iconName: "comments-dollar",
    icon: [576, 512, [], "f653", "M532.01 386.17C559.48 359.05 576 325.04 576 288c0-80.02-76.45-146.13-176.18-157.94 0 .01.01.02.01.03C368.37 72.47 294.34 32 208 32 93.12 32 0 103.63 0 192c0 37.04 16.52 71.05 43.99 98.17-15.3 30.74-37.34 54.53-37.7 54.89-6.31 6.69-8.05 16.53-4.42 24.99A23.085 23.085 0 0 0 23.06 384c53.54 0 96.67-20.24 125.17-38.78 9.08 2.09 18.45 3.68 28 4.82C207.74 407.59 281.73 448 368 448c20.79 0 40.83-2.41 59.77-6.78C456.27 459.76 499.4 480 552.94 480c9.22 0 17.55-5.5 21.18-13.96 3.64-8.46 1.89-18.3-4.42-24.99-.35-.36-22.39-24.14-37.69-54.88zm-376.59-72.13l-13.24-3.05-11.39 7.41c-20.07 13.06-50.49 28.25-87.68 32.47 8.77-11.3 20.17-27.61 29.54-46.44l10.32-20.75-16.49-16.28C50.75 251.87 32 226.19 32 192c0-70.58 78.95-128 176-128s176 57.42 176 128-78.95 128-176 128c-17.73 0-35.42-2.01-52.58-5.96zm289.8 100.35l-11.39-7.41-13.24 3.05A234.318 234.318 0 0 1 368 416c-65.14 0-122-25.94-152.43-64.29C326.91 348.62 416 278.4 416 192c0-9.45-1.27-18.66-3.32-27.66C488.12 178.78 544 228.67 544 288c0 34.19-18.75 59.87-34.47 75.39l-16.49 16.28 10.32 20.75c9.38 18.86 20.81 35.19 29.53 46.44-37.19-4.22-67.6-19.41-87.67-32.47zM233.38 182.91l-41.56-12.47c-4.22-1.27-7.19-5.62-7.19-10.58 0-6.03 4.34-10.94 9.66-10.94h25.94c3.9 0 7.65 1.08 10.96 3.1 3.17 1.93 7.31 1.15 10-1.4l11.44-10.87c3.53-3.36 3.38-9.22-.54-12.11-8.18-6.03-17.97-9.58-28.08-10.32V104c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v13.4c-21.85 1.29-39.38 19.62-39.38 42.46 0 18.98 12.34 35.94 30 41.23l41.56 12.47c4.22 1.27 7.19 5.62 7.19 10.58 0 6.03-4.34 10.94-9.66 10.94h-25.94c-3.9 0-7.65-1.08-10.96-3.1-3.17-1.94-7.31-1.15-10 1.4l-11.44 10.87c-3.53 3.36-3.38 9.22.54 12.11 8.18 6.03 17.97 9.58 28.08 10.32V280c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-13.4c21.85-1.29 39.38-19.62 39.38-42.46 0-18.98-12.35-35.94-30-41.23z"]
  },
      To = {
    prefix: "fal",
    iconName: "compact-disc",
    icon: [496, 512, [], "f51f", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm0-312c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 160c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm0-88c-13.2 0-24 10.8-24 24s10.8 24 24 24 24-10.8 24-24-10.8-24-24-24zm-8-144c-88.2 0-160 71.8-160 160h32c0-70.6 57.4-128 128-128V88z"]
  },
      Do = {
    prefix: "fal",
    iconName: "compass",
    icon: [496, 512, [], "f14e", "M264.97 272.97c9.38-9.37 9.38-24.57 0-33.94-9.37-9.37-24.57-9.37-33.94 0-9.38 9.37-9.38 24.57 0 33.94 9.37 9.37 24.57 9.37 33.94 0zM351.44 125c-2.26 0-4.51.37-6.71 1.16l-154.9 55.85c-7.49 2.7-13.1 8.31-15.8 15.8l-55.85 154.91c-5.65 15.67 10.33 34.27 26.4 34.27 2.26 0 4.51-.37 6.71-1.16l154.9-55.85c7.49-2.7 13.1-8.31 15.8-15.8l55.85-154.9c5.64-15.67-10.33-34.28-26.4-34.28zm-58.65 175.79l-140.1 50.51 50.51-140.11 140.11-50.51-50.52 140.11zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216z"]
  },
      jo = {
    prefix: "fal",
    iconName: "compass-slash",
    icon: [640, 512, [], "f5e9", "M322 474.1c-58 0-114.6-23.3-155.2-63.9C126.5 370 104.3 315.6 104 257c-.1-33.2 7.1-65 20.5-93.9l-25.8-20.3c-47.4 94.3-31.2 213.4 45.4 290 48.4 48.4 113.1 73.3 177.9 73.3 57.6 0 115.1-20 161.2-60.5l-25.5-20C420 457 372.5 474.1 322 474.1zm89.1-207.4l38.7-107.4c5.6-15.7-10.3-34.3-26.4-34.3-2.3 0-4.5.4-6.7 1.2l-126.2 45.5 29.6 23.3 95.2-34.3-30.7 85.1zM317.3 40c58.2 0 113.2 23 154.9 64.7 66 66 80.4 164.1 43.7 244.4l25.8 20.3C587.9 276 572.4 159.6 494.8 82 445.6 32.9 381.4 8 317.3 8 260.5 8 203.9 27.8 158 67.3l25.5 20.1C221.4 56.7 268 40 317.3 40zm-88.4 205.3l-38.7 107.4c-5.7 15.7 10.3 34.3 26.4 34.3 2.3 0 4.5-.4 6.7-1.2l126.2-45.5-29.6-23.3-95.2 34.3 30.7-85.1zM637 485.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3z"]
  },
      Eo = {
    prefix: "fal",
    iconName: "compress",
    icon: [448, 512, [], "f066", "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v116h116c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v116H12c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h116v116c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12zm160 0V352h116c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12z"]
  },
      ko = {
    prefix: "fal",
    iconName: "compress-alt",
    icon: [448, 512, [], "f422", "M9.171 476.485l-5.656-5.656c-4.686-4.686-4.686-12.284 0-16.971L169.373 288H108c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h100c8.837 0 16 7.163 16 16v100c0 6.627-5.373 12-12 12h-8c-6.627 0-12-5.373-12-12v-61.373L26.142 476.485c-4.687 4.687-12.285 4.687-16.971 0zM240 256h100c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-61.373L444.485 58.142c4.686-4.686 4.686-12.284 0-16.971l-5.656-5.656c-4.686-4.686-12.284-4.686-16.971 0L256 201.373V140c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v100c0 8.837 7.163 16 16 16z"]
  },
      Io = {
    prefix: "fal",
    iconName: "compress-arrows-alt",
    icon: [512, 512, [], "f78c", "M312 224h112c21.4 0 32.1-25.9 17-41l-44.7-44.7L509.7 25c3.1-3.1 3.1-8.2 0-11.3L498.3 2.3c-3.1-3.1-8.2-3.1-11.3 0L373.6 115.7 329 71.1c-4.9-4.9-10.9-7.1-16.8-7.1-12.3 0-24.2 9.6-24.2 24.1v112c0 13.2 10.7 23.9 24 23.9zm8-116.7l84.7 84.7H320v-84.7zm76.3 266.3l44.7-44.7c4.9-4.9 7.1-10.9 7.1-16.8 0-12.3-9.6-24.2-24.1-24.2H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l44.7-44.7L487 509.7c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3L396.3 373.6zM320 404.7V320h84.7L320 404.7zM200 288H88c-21.4 0-32.1 25.9-17 41l44.7 44.7L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l113.4-113.4 44.7 44.7c4.9 4.9 10.9 7.1 16.8 7.1 12.3 0 24.2-9.6 24.2-24.1V312c0-13.3-10.7-24-24-24zm-8 116.7L107.3 320H192v84.7zm-9-333.6l-44.7 44.7L25 2.3c-3.1-3.1-8.2-3.1-11.3 0L2.3 13.7c-3.1 3.1-3.1 8.2 0 11.3l113.4 113.4L71.1 183c-4.9 4.9-7.1 10.9-7.1 16.8 0 12.3 9.6 24.2 24.1 24.2h112c13.3 0 24-10.7 24-24V88c-.1-21.3-26-32-41.1-16.9zm9 120.9h-84.7l84.7-84.7V192z"]
  },
      Oo = {
    prefix: "fal",
    iconName: "compress-wide",
    icon: [512, 512, [], "f326", "M500 224H376c-13.3 0-24-10.7-24-24V76c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v116h116c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12zm-340-24V76c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v116H12c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 236V312c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h116v116c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12zm224 0V320h116c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H376c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12z"]
  },
      Qo = {
    prefix: "fal",
    iconName: "computer-classic",
    icon: [448, 512, [], "f8b1", "M376 320H232a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM416 0H32A32 32 0 0 0 0 32v400a16 16 0 0 0 16 16h16v48a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-48h16a16 16 0 0 0 16-16V32a32 32 0 0 0-32-32zm-32 480H64v-32h320zm32-64H32V32h384zM96 256h256a32 32 0 0 0 32-32V96a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32zm0-160h256v128H96zM80 356a20 20 0 1 0-20-20 20 20 0 0 0 20 20z"]
  },
      Zo = {
    prefix: "fal",
    iconName: "computer-speaker",
    icon: [640, 512, [], "f8b2", "M480 192a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm0-64a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm0 96a96 96 0 1 0 96 96 96.1 96.1 0 0 0-96-96zm0 160a64 64 0 1 1 64-64 64.08 64.08 0 0 1-64 64zm0-88a24 24 0 1 0 24 24 24 24 0 0 0-24-24zM592 32H368a48 48 0 0 0-48 48v352a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm16 400a16 16 0 0 1-16 16H368a16 16 0 0 1-16-16V80a16 16 0 0 1 16-16h224a16 16 0 0 1 16 16zm-504 16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h200.41a79.15 79.15 0 0 1-14.79-32zM0 64v288a32 32 0 0 0 32 32h256v-32H32V64h257.62a79.15 79.15 0 0 1 14.79-32H32A32 32 0 0 0 0 64z"]
  },
      Uo = {
    prefix: "fal",
    iconName: "concierge-bell",
    icon: [512, 512, [], "f562", "M504 416h-24v-64c0-118.31-91.79-214.96-208-223.19V96h40c4.42 0 8-3.58 8-8V72c0-4.42-3.58-8-8-8H200c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h40v32.81C123.79 137.04 32 233.69 32 352v64H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h496c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-56 0H64v-64c0-100.17 78.3-184.19 178.26-191.27 16.87-1.19 10.33-1.21 27.48 0C369.7 167.81 448 251.83 448 352v64z"]
  },
      Bo = {
    prefix: "fal",
    iconName: "construction",
    icon: [640, 512, [], "f85d", "M289.38 372l-83-53.81-29.75 109.4a16 16 0 0 0 11.23 19.69 15.75 15.75 0 0 0 4.22.56A16 16 0 0 0 207.45 436l18.25-67.06 46.31 30v32.85a16 16 0 1 0 32 0v-32.85A32 32 0 0 0 289.38 372zM308 215.22a28.08 28.08 0 1 0-28-28.07 28 28 0 0 0 28 28.07zm168.87 117.17a10.92 10.92 0 0 0-8.4-6.13 16.3 16.3 0 0 0-5-1.23h-.07a1400.59 1400.59 0 0 0-7.31 1.76 15.78 15.78 0 0 0-6 5.35l-28.34 42.44-79.45-49-10.55-52.87c-3.72-18.66-18.11-33.4-35.56-37.24l-24.57-7.3a47.44 47.44 0 0 0-10.45-1.17 48 48 0 0 0-38.35 19.27l-11.6 15.53a16.07 16.07 0 0 0 4.4 23.28l103.94 64.14a.6.6 0 0 0 .11.06l70.65 43.6H369a19.14 19.14 0 0 0-18.21 12.54L336 447.83h185.49A16 16 0 0 0 535 423.12zm-229.53-65.46l1.09-1.47a16 16 0 0 1 12.74-6.46 14.86 14.86 0 0 1 2.66.23l23.3 6.92 1.11.33 1.13.25c5.21 1.15 9.86 6.27 11 12.19l4.72 23.62zm185.45 148.82l3.38-5.07 27-40.37 29.08 45.44zm199.51 22.74L361.43 20.91C343.37-7 296.63-7 278.57 20.91L7.7 438.49a46.38 46.38 0 0 0-1.94 48A49.12 49.12 0 0 0 49.13 512h541.74a49.12 49.12 0 0 0 43.37-25.54 46.38 46.38 0 0 0-1.94-47.97zm-26.18 32.67a17 17 0 0 1-15.25 8.76H49.13a17 17 0 0 1-15.25-8.76 14.59 14.59 0 0 1 .63-15.16L305.38 38.4a17.78 17.78 0 0 1 29.24 0L605.49 456a14.59 14.59 0 0 1 .63 15.16z"]
  },
      Ro = {
    prefix: "fal",
    iconName: "container-storage",
    icon: [640, 512, [], "f4b7", "M632 64c4.4 0 8-3.6 8-8V40c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h8v384H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h624c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-8V64h8zm-40 384H48V64h544v384zm-472-64h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zm96 0h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zm96 0h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zm96 0h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zm96 0h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8z"]
  },
      Yo = {
    prefix: "fal",
    iconName: "conveyor-belt",
    icon: [640, 512, [], "f46e", "M544 320H96c-53 0-96 43-96 96s43 96 96 96h448c53 0 96-43 96-96s-43-96-96-96zm0 160H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h448c35.3 0 64 28.7 64 64s-28.7 64-64 64zM144 368c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm352-64c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm-176-64c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM144 288h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zM288 32h64v76.2l-32-16-32 16V32zm-128 0h96v128l64-32 64 32V32h96v224H160V32z"]
  },
      Po = {
    prefix: "fal",
    iconName: "conveyor-belt-alt",
    icon: [640, 512, [], "f46f", "M544 320H96c-53 0-96 43-96 96s43 96 96 96h448c53 0 96-43 96-96s-43-96-96-96zm0 160H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h448c35.3 0 64 28.7 64 64s-28.7 64-64 64zM144 368c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm352-64c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm-176-64c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM112 288h416c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H384V16c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zM384 96h128v160H384V96zM128 32h224v224H128V32z"]
  },
      Fo = {
    prefix: "fal",
    iconName: "cookie",
    icon: [512, 512, [], "f563", "M352 328c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm-8-200c0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24s24-10.75 24-24zm-160 64c0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24s24-10.75 24-24zm8 136c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm96-96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm222.37 22.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15C250.11.54 243.22 0 236.34 0c-20.72 0-41.25 4.88-59.89 14.38l-69.12 35.21a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.87A132.602 132.602 0 0 0 1.62 257.2l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c6.86 1.09 13.75 1.62 20.63 1.62 20.72 0 41.25-4.88 59.88-14.38l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87a132.56 132.56 0 0 0 12.82-80.93zm-41.33 66.41l-35.1 68.88c-9.68 19-24.83 34.15-43.8 43.82l-69.12 35.21c-13.98 7.13-29.67 10.89-45.36 10.89-5.21 0-10.47-.41-15.63-1.23l-76.69-12.14c-20.99-3.33-40.04-13.04-55.09-28.08L73.5 383.79c-15.09-15.09-24.84-34.22-28.18-55.33L33.24 252.2c-3.35-21.12.02-42.36 9.72-61.4l35.1-68.88c9.68-19 24.83-34.15 43.8-43.82l69.12-35.21C204.97 35.77 220.65 32 236.34 32c5.21 0 10.47.41 15.62 1.23l76.7 12.15c20.99 3.32 40.04 13.03 55.08 28.08l54.76 54.75c15.09 15.09 24.84 34.22 28.18 55.33l12.08 76.26c3.35 21.12-.02 42.36-9.72 61.4z"]
  },
      Wo = {
    prefix: "fal",
    iconName: "cookie-bite",
    icon: [512, 512, [], "f564", "M352 328c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zM184 192c0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24s24-10.75 24-24zm8 136c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm96-96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm222.52 23.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45C249.57.5 242.9 0 236.26 0c-20.68 0-41.18 4.85-59.79 14.33l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.28a132.555 132.555 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.14c6.86 1.09 13.76 1.62 20.64 1.62 20.72 0 41.25-4.88 59.89-14.38l69.13-35.22a132.221 132.221 0 0 0 57.79-57.81l35.1-68.88c12.56-24.63 17.01-52.57 12.91-79.9zm-41.42 65.36L434 390.07c-9.68 19-24.83 34.15-43.81 43.82l-69.13 35.22C307.08 476.23 291.39 480 275.7 480c-5.21 0-10.47-.41-15.63-1.23l-76.7-12.14c-21-3.33-40.05-13.04-55.09-28.08l-54.77-54.76c-15.1-15.09-24.84-34.23-28.18-55.33l-12.08-76.27c-3.35-21.12.02-42.36 9.72-61.41l35.1-68.88c9.68-19 24.83-34.15 43.81-43.82L191 42.85c11.33-5.77 23.8-9.33 36.51-10.46 13.15 63.15 63.84 112.95 127.25 124.86 11.91 63.42 61.71 114.11 124.87 127.25-1.1 12.73-4.64 25.14-10.53 36.68z"]
  },
      Go = {
    prefix: "fal",
    iconName: "copy",
    icon: [448, 512, [], "f0c5", "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM352 32.491a15.88 15.88 0 0 1 7.431 4.195l51.882 51.883A15.885 15.885 0 0 1 415.508 96H352V32.491zM288 464c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h80v240c0 26.51 21.49 48 48 48h112v48zm128-96c0 8.822-7.178 16-16 16H176c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v240z"]
  },
      qo = {
    prefix: "fal",
    iconName: "copyright",
    icon: [512, 512, [], "f1f9", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm216 248c0 118.663-96.055 216-216 216-118.663 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.663 0 216 96.055 216 216zM360.474 357.366c-9.414 9.142-44.455 38.966-100.106 38.966-77.825 0-136.513-60.551-136.513-140.846 0-77.951 58.345-137.596 135.431-137.596 53.547 0 85.508 24.785 94.028 32.381a11.96 11.96 0 0 1 1.721 16.001l-8.763 12.08c-4.034 5.561-11.877 6.579-17.203 2.329-8.921-7.122-33.509-23.688-69.062-23.688-54.32 0-94.161 41.791-94.161 98.131 0 58.209 40.791 102.104 94.882 102.104 39.538 0 66.522-22.074 73.851-28.84 5.068-4.681 13.054-4.108 17.423 1.239l9.414 11.534c3.969 4.861 3.564 11.828-.942 16.205z"]
  },
      Jo = {
    prefix: "fal",
    iconName: "corn",
    icon: [512, 512, [], "f6c7", "M446.02 0c-12.95 0-25.27 3.8-35.67 10.62-15.35-4.08-28.15-1.5-34.89.49a65.477 65.477 0 0 0-27.61 15.95c-6.24-.44-17.55-.39-30.47 5.1-10.02 4.51-18.52 11.13-25.04 19.2a64.994 64.994 0 0 0-29.68 8.99c-8.75 4.96-16.12 11.98-21.61 20.32-10.18 1.49-19.83 5.37-28.32 11.43-.09.06-.15.16-.24.23-6.96-9.54-14.48-18.74-22.99-27.24l-21.13-21.14c-9.04-9.04-24.5-4.36-27 8.17l-23.76 118.81-80.55 80.56C16.98 271.58 2.98 297.65.47 325.94c-3.1 34.91 9.09 68.28 33.5 92.69l62.21 62.23.28-.28c27.38 25.57 64.77 36.9 103.31 28.88 22.86-4.75 43.42-17.25 59.93-33.76l81.32-81.34 118.8-23.76c12.53-2.51 17.21-17.97 8.18-27l-21.14-21.14c-8.66-8.66-18.02-16.31-27.74-23.36 4.96-7.75 8.43-16.21 9.79-25.06a64.739 64.739 0 0 0 20.94-22.24c5.29-8.9 8.26-18.84 8.84-28.94 8.11-6.41 14.68-14.7 19.02-24.35 4.47-9.93 6.33-20.58 5.63-31.05a66.545 66.545 0 0 0 16.12-26.97 66.217 66.217 0 0 0 .79-34.51C528.26 65.2 504.65 0 446.02 0zM56.6 277.21l90.49-90.51 19.79-98.99c48.33 48.33 65.35 115.45 52.51 177.72-35.47 10.72-67.98 30.09-94.92 57.04L54.06 392.9c-29.96-32.98-29.3-83.86 2.54-115.69zm367.63 67.88l-98.98 19.8-90.5 90.51c-16.4 16.4-37.89 24.6-59.39 24.6-21.49 0-42.99-8.2-59.39-24.6l-39.59-39.6 70.7-70.71c38.27-38.27 88.42-57.41 138.57-57.41 50.16 0 100.31 19.14 138.58 57.41zm37.16-246.25c7.5 8.31 10.98 20.36 7.5 32.15-3.49 11.25-12.33 19.55-22.77 22.76 5.88 9.11 7.23 20.9 2.41 31.61-4.83 10.71-14.46 17.41-25.17 19.29 4.83 9.64 4.55 21.42-1.33 31.33-5.63 9.91-15.81 15.8-26.52 16.61 3.58 9.45 2.61 20.32-3.29 29.45-32.44-17.2-68.79-26.36-106.55-26.36-10.82 0-21.46 1.01-31.98 2.48 1.53-10.48 2.6-21.08 2.6-31.87 0-37.79-9.16-74.16-26.38-106.63 13.48-11.22 27.58-7.41 32.49-5.56.81-10.44 6.7-20.63 16.61-26.25 15.82-9.39 30.92-1.53 31.33-1.33 1.88-10.45 8.84-20.09 19.55-24.91 13.46-5.71 25.43-1.32 31.61 2.68 3.22-10.71 11.78-19.28 23.03-22.5 3-.89 18.64-5.03 32.14 8.03C422.33 38.99 433.44 32 446.02 32c.52 0 33.85-.95 33.85 37.92-.54 12.85-8.03 23.56-18.48 28.92z"]
  },
      Ko = {
    prefix: "fal",
    iconName: "couch",
    icon: [640, 512, [], "f4b8", "M576 193.9v-33.7c0-53.1-43-96.2-96-96.2H160c-53 0-96 43.1-96 96.2v33.7c-36.5 7.5-64 39.8-64 78.6 0 25.1 12.1 48.8 32 63.8v79.6c0 17.7 14.3 32.1 32 32.1h64c17.3 0 31.3-14.7 31.8-32h320.4c.5 17.3 14.5 32 31.8 32h64c17.7 0 32-14.4 32-32.1v-79.6c19.9-15.1 32-38.7 32-63.8 0-38.7-27.5-71.1-64-78.6zm-448 222H64v-97.4c-17.1-10-32-21.1-32-46 0-26.5 21.5-48.1 48-48.1h32c8.8 0 16 7.2 16 16v175.5zM480 384H160v-95.5h320V384zm0-143.6V256H160v-15.6c0-26.5-21.5-48.1-48-48.1H96v-32.1c0-35.4 28.7-64.1 64-64.1h320c35.3 0 64 28.8 64 64.1v32.1h-16c-26.5 0-48 21.6-48 48.1zm96 78.1v97.4h-64V240.4c0-8.8 7.2-16 16-16h32c26.5 0 48 21.6 48 48.1 0 23.9-13.9 35.4-32 46z"]
  },
      Xo = {
    prefix: "fal",
    iconName: "cow",
    icon: [640, 512, [], "f6c8", "M634.06 279.67L624 265.54v-54.96c0-19.35-15.74-35.09-35.08-35.09-9.08 0-14.25 2.94-23.61 7.65l-56.6-79.46A96.029 96.029 0 0 0 430.95 64H112c-44.12 0-80 35.89-80 80v88.88C12.95 243.96 0 264.37 0 288v32c35.35 0 64-28.65 64-64V144c0-23.89 17.59-43.59 40.46-47.24C99.23 106.04 96 116.59 96 128v288c0 17.67 14.33 32 32 32h48c17.67 0 32-14.33 32-32v-51.58c7.31 2.92 15.62 4.97 24.04 6.85V392c0 8.84 7.16 16 16 16s16-7.16 16-16v-16.71c2.73.12 5.18.71 7.96.71 2.81 0 5.29-.61 8.04-.72V392c0 8.84 7.16 16 16 16s16-7.16 16-16v-20.75c8.39-1.88 16.68-3.92 23.96-6.83V416c0 17.67 14.33 32 32 32h47.96c17.67 0 32-14.32 32-31.99l.04-143.97L479.96 288v41.98c0 12.32 3.55 24.38 10.24 34.72l35.46 54.9a62.073 62.073 0 0 0 52.15 28.4h.11c34.29 0 62.08-27.79 62.08-62.08v-87.69c0-6.65-2.08-13.14-5.94-18.56zM212.73 96h118.54c17.54 0 27.12 19.78 15.89 32.8-40.1 46.51-57.96 47.2-75.11 47.2h-1.09c-17.2 0-33.82-.43-74.13-47.2-11.22-13.02-1.64-32.8 15.9-32.8zm-4.14 234.19C211.57 297.65 238.71 272 272 272s60.43 25.65 63.41 58.19c-14.2 5.68-57.45 27.73-126.82 0zM608 385.92c0 16.59-13.49 30.08-30.19 30.08-10.26 0-19.7-5.14-25.27-13.76l-35.46-54.9a31.939 31.939 0 0 1-5.12-17.36v-61.77l-95.95-47.92-.01 51.74-.04 143.97H368v-80c0-30.87-25.45-96-96-96-70.86 0-96 64.55-96 96v80h-48V128c0-17.64 14.36-32 32-32h4.29c-7.71 18.18-4.71 38.6 8.3 53.7 42.25 49.01 67.17 58.3 98.37 58.3 32.93 0 58.19-9.29 100.44-58.3 13.01-15.1 16.02-35.52 8.3-53.7h51.25c20.46 0 39.83 9.89 51.69 26.26l78.66 110.42c4.49-17.23 18.92-24.62 22.69-24.62 4.2 0 8 3.37 8 8.01v59.7l16 22.46v87.69zM568 304c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"]
  },
      _o = {
    prefix: "fal",
    iconName: "cowbell",
    icon: [448, 512, [], "f8b3", "M384.19 122.35A32 32 0 0 0 352.64 96h-16V48a48.1 48.1 0 0 0-48.12-48H160.29a48.1 48.1 0 0 0-48.09 48v48H95.36a32 32 0 0 0-31.55 26.35l-63.3 352A32 32 0 0 0 32.07 512h383.86a32 32 0 0 0 31.56-37.65zM144.2 48a16.07 16.07 0 0 1 16.09-16h128.23a16.07 16.07 0 0 1 16.09 16v48H144.2zM32 480l63.36-352H352.7l63.23 352z"]
  },
      $o = {
    prefix: "fal",
    iconName: "cowbell-more",
    icon: [640, 512, [], "f8b4", "M480 192a160 160 0 1 0 160 160 160 160 0 0 0-160-160zm0 288a128 128 0 1 1 128-128 128.14 128.14 0 0 1-128 128zm72-144h-56v-56a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h56v56a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM32 480l63.36-352h257.33l12.63 70.26a192.21 192.21 0 0 1 29.28-18.05l-10.41-57.87A32 32 0 0 0 352.64 96h-16V48a48.1 48.1 0 0 0-48.12-48H160.29a48.1 48.1 0 0 0-48.09 48v48H95.36a32 32 0 0 0-31.56 26.35l-63.29 352A32 32 0 0 0 32.07 512H374a192.56 192.56 0 0 1-36.77-32zM144.2 48a16.07 16.07 0 0 1 16.09-16h128.23a16.07 16.07 0 0 1 16.09 16v48H144.2z"]
  },
      cl = {
    prefix: "fal",
    iconName: "credit-card",
    icon: [576, 512, [], "f09d", "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM48 64h480c8.8 0 16 7.2 16 16v48H32V80c0-8.8 7.2-16 16-16zm480 384H48c-8.8 0-16-7.2-16-16V224h512v208c0 8.8-7.2 16-16 16zm-336-84v8c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v8c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"]
  },
      el = {
    prefix: "fal",
    iconName: "credit-card-blank",
    icon: [576, 512, [], "f389", "M528 31H48C21.5 31 0 52.5 0 79v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V79c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V79c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v352zm-352-68v8c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v8c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"]
  },
      al = {
    prefix: "fal",
    iconName: "credit-card-front",
    icon: [576, 512, [], "f38a", "M528 31H48C21.5 31 0 52.5 0 79v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V79c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V79c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v352zm-352-68v8c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v8c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12zM488 95h-80c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm-8 64h-64v-32h64v32zM260 319h-56c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm28-12v-40c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12zm-192 0v-40c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12zm384-40v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12z"]
  },
      nl = {
    prefix: "fal",
    iconName: "cricket",
    icon: [640, 512, [], "f449", "M632.8 30.2l-9.2-13.1C617.5 8.3 608.3 2.5 597.8.6c-10.5-2-21.1.5-29.9 6.6L419.1 112c-14.5 10.1-34.4 6.6-44.6-7.9L365.3 91c-10.1-14.5-30-18-44.5-7.9L20.6 293.4c-14 9.8-21.8 25.9-20.5 42C6.2 410.4 52.5 476.6 121 508c20.8 9.5 39.4.1 46.5-4.9l300.1-210.2c14.4-10.1 18.2-29.9 7.9-44.6l-9.2-13.1c-10.1-14.5-6.6-34.4 7.9-44.6L622.9 85.9c18.1-12.7 22.5-37.6 9.9-55.7zM149.1 476.9c-4.6 3.3-10.4 4-14.8 2C53.2 441.6 32.9 362.4 32 332.7c-.4-4.8 2.3-9.9 6.9-13.2l225.3-157.7-23.6 133.7 133.7 23.6-225.2 157.8zm293.6-205.6l-31.3 21.9-133.7-23.6 23.6-133.7 31.3-21.9c3.6-2.5 8.6-1.7 11.1 2l100.9 144.2c2.6 3.6 1.7 8.5-1.9 11.1zM604.6 59.7l-175 123.1-18.4-26.2 175-123.1c3.3-2.3 8.4-2 11.1 2l9.2 13.1c2.6 3.6 1.7 8.6-1.9 11.1zM496 352c-44.1 0-80 35.9-80 80s35.9 80 80 80 80-35.9 80-80-35.9-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      tl = {
    prefix: "fal",
    iconName: "croissant",
    icon: [512, 512, [], "f7f6", "M508.1 175.66c-11.51-30.34-29.86-56.51-52.36-78.17a59.19 59.19 0 0 0-.27-12.12 60.35 60.35 0 0 0-23.13-40.11A222.19 222.19 0 0 0 298.37 0a217.65 217.65 0 0 0-58.26 8.4C229.86 2.58 215.22-3 196.19 1.8A266.7 266.7 0 0 0 1.78 196.18a59.74 59.74 0 0 0 6.63 45c-17.76 65.52-5.22 136 36.84 191.13a60.4 60.4 0 0 0 40.11 23.13c9.18 1.16 9.09 0 11.4-.16 21.78 22.72 48.24 41.2 78.88 52.81 42.54 16.12 87-19.95 79.5-65.18l-14.54-87.23a58.85 58.85 0 0 0 17.47-31.43 59.4 59.4 0 0 0 26.33-15.11l24.77-24.77A59.82 59.82 0 0 0 324.35 258a58.82 58.82 0 0 0 31.32-17.41l87.24 14.54c45.43 7.6 81.25-37.13 65.19-79.47zM298.37 32a190.06 190.06 0 0 1 114.57 38.7c13.92 10.62 13.47 28.81 5 39.54l-84 107c-1.55 2-9.2 9.34-9.91 7.06l-56-182c-.77-2.48-2.3-4.47-3.35-6.79A181.18 181.18 0 0 1 298.36 32zM35.26 265.11a60.1 60.1 0 0 0 7.09 3l182 56c2.26.69-5.09 8.35-7.07 9.9l-107 84c-14.08 11.05-31.58 5.4-39.55-5a188.09 188.09 0 0 1-35.47-147.9zM187 478.17a181.28 181.28 0 0 1-57-35.09l82-64.32 11.57 69.42c3.48 20.82-17.01 37.4-36.57 29.99zm99.56-216.42l-24.77 24.76c-4 4-14.4 11.15-28 7l-182-56a28 28 0 0 1-18.93-33.55A234.75 234.75 0 0 1 204 32.84a28 28 0 0 1 33.5 18.93l56 182a28 28 0 0 1-6.96 27.98zm161.63-38.14L378.76 212l64.34-82a182.08 182.08 0 0 1 35.08 57c7.49 19.76-9.36 40.05-30.01 36.61z"]
  },
      rl = {
    prefix: "fal",
    iconName: "crop",
    icon: [512, 512, [], "f125", "M488 320h-72V118.62l93.66-93.66c3.12-3.12 3.12-8.19 0-11.31L498.35 2.34c-3.12-3.12-8.19-3.12-11.31 0L393.37 96H192V24c0-13.26-10.75-24-24-24h-48c-13.25 0-24 10.74-24 24v72H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h72v192c0 17.67 14.33 32 32 32h192v72c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-72h72c13.25 0 24-10.75 24-24v-48c0-13.25-10.75-24-24-24zM96 160H32v-32h64v32zm96-32h169.37l-32 32H192v-32zm105.38 64L192 297.38V192h105.38zM320 384H128V32h32v320h160v32zm-105.38-64L320 214.63V320H214.62zM352 480V182.63l32-32V480h-32zm128-96h-64v-32h64v32z"]
  },
      il = {
    prefix: "fal",
    iconName: "crop-alt",
    icon: [512, 512, [], "f565", "M488 320h-72V128c0-17.67-14.33-32-32-32H192V24c0-13.26-10.75-24-24-24h-48c-13.25 0-24 10.74-24 24v72H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h72v192c0 17.67 14.33 32 32 32h192v72c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-72h72c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM96 160H32v-32h64v32zm224 224H128V32h32v320h160v32zm0-64H192V192h128v128zm64 160h-32V160H192v-32h192v352zm96-96h-64v-32h64v32z"]
  },
      ol = {
    prefix: "fal",
    iconName: "cross",
    icon: [384, 512, [], "f654", "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 96H224v256h-64V224H32v-64h128V32h64v128h128v64z"]
  },
      ll = {
    prefix: "fal",
    iconName: "crosshairs",
    icon: [512, 512, [], "f05b", "M506 240h-34.591C463.608 133.462 378.538 48.392 272 40.591V6a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v34.591C133.462 48.392 48.392 133.462 40.591 240H6a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h34.591C48.392 378.538 133.462 463.608 240 471.409V506a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6v-34.591C378.538 463.608 463.608 378.538 471.409 272H506a6 6 0 0 0 6-6v-20a6 6 0 0 0-6-6zM272 439.305V374a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v65.305C151.282 431.711 80.315 361.031 72.695 272H138a6 6 0 0 0 6-6v-20a6 6 0 0 0-6-6H72.695C80.289 151.282 150.969 80.316 240 72.695V138a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V72.695C360.718 80.289 431.685 150.969 439.305 240H374a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h65.305C431.711 360.718 361.031 431.684 272 439.305zM280 256c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"]
  },
      fl = {
    prefix: "fal",
    iconName: "crow",
    icon: [640, 512, [], "f520", "M416 72c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm104-8h-13.88C492.9 26.8 457.74 0 416 0c-53.02 0-96 42.98-96 96v39.6L11.38 393.57C4.21 399.28 0 408.23 0 417.74 0 435.26 13.53 448 28.45 448c4.22 0 8.54-1.02 12.71-3.23L168 384h109.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l6.83-2.49c6.23-2.27 9.44-9.15 7.17-15.38L310.82 384h20.47c13.89 0 27.36-1.82 40.35-4.98l46.25 125.08c2.27 6.23 9.15 9.44 15.38 7.17l6.83-2.49c6.23-2.27 9.44-9.15 7.17-15.38l-45.98-124.36C466.33 339.98 512 271.67 512 192v-30.93L640 144c0-44.18-53.73-80-120-80zm-40 128c0 88.22-66.71 160-148.71 160h-57.03l45.33-12.95c48.03-13.73 88.41-47.23 110.72-91.89 3.94-7.91.75-17.52-7.16-21.47-7.91-3.89-17.47-.77-21.47 7.16-18.31 36.66-51.44 64.16-90.91 75.42-192.18 54.91-115.72 27.27-266.62 99.61L352 150.56V96c0-35.29 28.71-64 64-64s64 28.71 64 64v96zm32-63.22V96h8c30.83 0 56.88 9.49 72.46 22.05L512 128.78z"]
  },
      sl = {
    prefix: "fal",
    iconName: "crown",
    icon: [640, 512, [], "f521", "M536 480H104c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm48-320c-30.9 0-56 25.1-56 56 0 7.6 1.5 14.8 4.3 21.4L476 271.2c-5.2 3.1-10.8 4.6-16.4 4.6-11.1 0-21.9-5.8-27.8-16.1l-74.4-130.2c11.3-10.3 18.6-25 18.6-41.5 0-30.9-25.1-56-56-56s-56 25.1-56 56c0 16.5 7.3 31.2 18.6 41.4l-74.4 130.2c-5.9 10.4-16.7 16.1-27.8 16.1-5.6 0-11.3-1.5-16.4-4.6l-56.3-33.8c2.7-6.6 4.3-13.8 4.3-21.4 0-30.9-25.1-56-56-56S0 185.1 0 216s25.1 56 56 56c2 0 3.9-.4 5.8-.6L128 448h384l66.2-176.6c1.9.2 3.8.6 5.8.6 30.9 0 56-25.1 56-56s-25.1-56-56-56zM320 64c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM56 240c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zm433.8 176H150.2l-56-149.4 53.4 32c10 6 21.3 9.1 32.9 9.1 22.9 0 44.2-12.4 55.6-32.3l75.6-132.3c2.8.4 5.5.8 8.4.8s5.6-.4 8.4-.8L404 275.5c11.4 19.9 32.7 32.2 55.6 32.2 11.6 0 22.9-3.2 32.9-9.1l53.4-32L489.8 416zM584 240c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24z"]
  },
      ul = {
    prefix: "fal",
    iconName: "crutch",
    icon: [512, 512, [], "f7f7", "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0l-42.2 42.15a16 16 0 0 0 0 22.63l22.63 22.63-112.74 112.72A80 80 0 0 0 150 243.45l-28.8 124.73L2.34 487a8 8 0 0 0 0 11.31l11.32 11.32a8 8 0 0 0 11.31 0l118.87-118.84L268.56 362a79.85 79.85 0 0 0 38.56-21.4l112.76-112.72 22.63 22.63a16 16 0 0 0 22.63 0l42.17-42.18a16 16 0 0 0 0-22.62zM284.5 318a47.79 47.79 0 0 1-23.12 12.81l-104.29 24.08 24.1-104.27A47.78 47.78 0 0 1 194 227.48l21.43-21.42 90.51 90.51zm44.07-44.08l-90.51-90.51 68.69-68.68 90.5 90.5zm125.25-57.37L295.43 58.18 315 38.63 473.37 197z"]
  },
      hl = {
    prefix: "fal",
    iconName: "crutches",
    icon: [640, 512, [], "f7f8", "M635.31 185.71l-181-181a16 16 0 0 0-22.62 0l-42.2 42.15a16 16 0 0 0 0 22.63l22.63 22.63-112.74 112.72A80 80 0 0 0 278 243.45l-28.8 124.73L130.34 487a8 8 0 0 0 0 11.31l11.32 11.32a8 8 0 0 0 11.31 0l118.87-118.84L396.56 362a79.85 79.85 0 0 0 38.56-21.4l112.75-112.72 22.64 22.63a16 16 0 0 0 22.63 0l42.17-42.18a16 16 0 0 0 0-22.62zM412.5 318a47.77 47.77 0 0 1-23.13 12.81l-104.28 24.08 24.1-104.27A47.86 47.86 0 0 1 322 227.48l21.43-21.42 90.51 90.51zm44.07-44.08l-90.51-90.51 68.69-68.68 90.5 90.5zm125.25-57.37L423.43 58.18 443 38.63 601.37 197zM220 352.07l7.79-33.74c-.11-.11-.26-.17-.37-.28l-112.67-112.8 90.5-90.5 69.63 69.62c.66-.69 1.19-1.48 1.87-2.16l20.62-20.61-69.49-69.48 22.63-22.63a16 16 0 0 0 0-22.63L208.33 4.69a16 16 0 0 0-22.62 0l-181 181a16 16 0 0 0 0 22.62l42.17 42.18a16 16 0 0 0 22.63 0l22.64-22.63 112.73 112.76A78.72 78.72 0 0 0 220 352.07zM58.18 216.57L38.63 197 197 38.63l19.55 19.55zM413 390.37c-3.07 1-6.09 2.1-9.24 2.83l-27 6.22L487 509.66a8 8 0 0 0 11.31 0l11.32-11.32a8 8 0 0 0 0-11.31z"]
  },
      ml = {
    prefix: "fal",
    iconName: "cube",
    icon: [512, 512, [], "f1b2", "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 34.2l224 84v.3l-224 97.1-224-97.1v-.3l224-84zM32 153.4l208 90.1v224.7l-208-104V153.4zm240 314.8V243.5l208-90.1v210.9L272 468.2z"]
  },
      vl = {
    prefix: "fal",
    iconName: "cubes",
    icon: [512, 512, [], "f1b3", "M488.6 256.7L388 219V107.9c0-15-9.3-28.4-23.4-33.7l-96-36c-8.1-3.1-17.1-3.1-25.3 0l-96 36c-14.1 5.3-23.4 18.7-23.4 33.7V219L23.4 256.7C9.3 262 0 275.4 0 290.4v101.3c0 13.6 7.7 26.1 19.9 32.2l96 48c10.1 5.1 22.1 5.1 32.2 0L256 418l107.9 54c10.1 5.1 22.1 5.1 32.2 0l96-48c12.2-6.1 19.9-18.6 19.9-32.2V290.4c0-15-9.3-28.4-23.4-33.7zM16.5 403.8V295.1l107.2 46.5v115.8zm231 0l-107.2 53.6V341.6l107.2-46.5zm0-126.7l-115.5 50-115.5-50v-.2L131 234l107.6 39.6 8.9 3.3zm.3-19.7L195 239.6l-54.5-20.4V112.5L247.8 159zM140.5 94.5v-.1L256 51l115.5 43.3v.2l-115.5 50zM264.2 159l107.2-46.5v106.7L317 239.6l-52.8 17.8zm107.6 298.4l-107.2-53.6V295.1l107.2 46.5zm123.7-53.6l-107.2 53.6V341.6l107.2-46.5zm0-126.7l-115.5 50L264.5 277v-.2l8.9-3.3L381 234l114.5 42.9z"]
  },
      dl = {
    prefix: "fal",
    iconName: "curling",
    icon: [640, 512, [], "f44a", "M517.9 194.2c-18-39.9-57.6-66.2-101.9-66.2H304c0-17.7 14.3-32 32-32h128c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H336c-70.6 0-128 57.4-128 128v1.2c-37.7 5.4-70.2 30.1-86 65.1C53 204.9 0 264 0 336v32c0 79.5 64.5 144 144 144h352c79.5 0 144-64.5 144-144v-32c0-72-53.1-131.2-122.1-141.8zM240 160v-32c0-52.9 43.1-96 96-96h128v32H336c-35.3 0-64 28.7-64 64v32h144c25.6 0 49.1 12.3 64 32H160c26.8-35.6 64.3-32 80-32zm256 320H144c-61.8 0-112-50.2-112-112h576c0 61.8-50.2 112-112 112zM32 336c0-61.8 50.2-112 112-112h352c61.8 0 112 50.2 112 112H32z"]
  },
      Ml = {
    prefix: "fal",
    iconName: "cut",
    icon: [448, 512, [], "f0c4", "M249.52 256L446.83 58.83a3.996 3.996 0 0 0 0-5.65c-12.5-12.5-32.76-12.5-45.25 0L224.06 230.56l-48.64-48.61C185.88 166.57 192 148 192 128c0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c20.01 0 38.58-6.12 53.96-16.6l48.63 48.6-48.63 48.6C134.58 294.12 116.01 288 96 288c-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-20-6.12-38.57-16.58-53.95l48.64-48.61 177.52 177.38c12.5 12.5 32.76 12.5 45.25 0a3.996 3.996 0 0 0 0-5.65L249.52 256zM96 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm0 256c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"]
  },
      pl = {
    prefix: "fal",
    iconName: "dagger",
    icon: [384, 512, [], "f6cb", "M335.21 127.96H240V16c0-8.83-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v111.97H48.79c-26.32 0-48.34 20.85-48.78 47.17C-.44 202 21.22 223.93 48 223.93c26.51 0 48-21.48 48-47.99 0-5.64-1.15-10.97-2.94-16H128v268.92l50.69 76.01c6.33 9.5 20.29 9.5 26.63 0l50.68-76V159.95h34.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.5 21.49 47.99 48 47.99 26.78 0 48.44-21.93 47.99-48.81-.44-26.31-22.46-47.17-48.78-47.17zM64 175.95c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM176 31.99h32v95.97h-32V31.99zm48 387.19l-32 47.99-32-47.99V159.95h64v259.23zm112-227.24c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"]
  },
      zl = {
    prefix: "fal",
    iconName: "database",
    icon: [448, 512, [], "f1c0", "M224 32c106 0 192 28.75 192 64v32c0 35.25-86 64-192 64S32 163.25 32 128V96c0-35.25 86-64 192-64m192 149.5V224c0 35.25-86 64-192 64S32 259.25 32 224v-42.5c41.25 29 116.75 42.5 192 42.5s150.749-13.5 192-42.5m0 96V320c0 35.25-86 64-192 64S32 355.25 32 320v-42.5c41.25 29 116.75 42.5 192 42.5s150.749-13.5 192-42.5m0 96V416c0 35.25-86 64-192 64S32 451.25 32 416v-42.5c41.25 29 116.75 42.5 192 42.5s150.749-13.5 192-42.5M224 0C145.858 0 0 18.801 0 96v320c0 77.338 146.096 96 224 96 78.142 0 224-18.801 224-96V96c0-77.338-146.096-96-224-96z"]
  },
      Cl = {
    prefix: "fal",
    iconName: "deaf",
    icon: [512, 512, [], "f2a4", "M409.171 108.485l-5.656-5.656c-4.686-4.686-4.686-12.284 0-16.971l82.344-82.344c4.686-4.686 12.284-4.686 16.971 0l5.656 5.656c4.686 4.686 4.686 12.284 0 16.971l-82.344 82.344c-4.687 4.687-12.285 4.687-16.971 0zm-383.029 400l186.344-186.344c4.686-4.686 4.686-12.284 0-16.971l-5.656-5.656c-4.686-4.686-12.284-4.686-16.971 0L3.515 485.858c-4.686 4.686-4.686 12.284 0 16.971l5.656 5.656c4.686 4.687 12.284 4.687 16.971 0zm317.534-103.151c0-69.293 73.391-78.477 73.391-165.334 0-88.812-72.255-161.066-161.067-161.066S94.933 151.188 94.933 240c0 8.837 7.163 16 16 16s16-7.163 16-16c0-71.167 57.899-129.066 129.066-129.066 71.168 0 129.067 57.899 129.067 129.066 0 71.434-73.391 80.16-73.391 165.334 0 41.171-33.495 74.666-74.667 74.666-8.837 0-16 7.163-16 16s7.163 16 16 16c58.818 0 106.668-47.851 106.668-106.666zM336.743 256c-8.837 0-16-7.163-16-16 0-36.172-29.428-65.6-65.6-65.6s-65.6 29.428-65.6 65.6c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-53.816 43.783-97.6 97.6-97.6s97.6 43.783 97.6 97.6c0 8.837-7.163 16-16 16z"]
  },
      Ll = {
    prefix: "fal",
    iconName: "debug",
    icon: [512, 512, [], "f7f9", "M130.25 311.84l45.88-6.55a79.17 79.17 0 0 0 3.1 20l-44.11 29.4a16 16 0 0 0-4.43 22.19c3.41 5.09 12.87 10.64 22.19 4.43L194 353.93c14.62 18.19 36.81 30.07 62 30.07a79.26 79.26 0 0 0 45.63-14.49l-23.29-23.29A47.3 47.3 0 0 1 256 352a48.05 48.05 0 0 1-48-48v-28.12l-32-32V273l-50.25 7.18a16 16 0 0 0-13.59 18.11c1.97 13.58 15.36 13.95 18.09 13.55zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-119.1 0-216-96.9-216-216a214.87 214.87 0 0 1 52.56-140.81l304.25 304.25A214.87 214.87 0 0 1 256 472zm-44.16-282.78A48 48 0 0 1 304 208v73.38zm207.6 207.59l-84.37-84.36a67.57 67.57 0 0 0 .8-7.16l45.88 6.55c2.73.4 16.12 0 18.09-13.57a16 16 0 0 0-13.59-18.11L336 273v-26l50.25-7.18a16 16 0 1 0-4.5-31.68L336 214.69c0-17.31-1.41-21.43-3.23-28l44.11-29.4a16 16 0 0 0-17.76-26.62l-41.07 27.38C303.38 139.88 281.19 128 256 128c-28.64 0-53.4 15.26-67.46 37.92l-73.35-73.36A214.87 214.87 0 0 1 256 40c119.1 0 216 96.9 216 216a214.87 214.87 0 0 1-52.56 140.81z"]
  },
      Al = {
    prefix: "fal",
    iconName: "deer",
    icon: [512, 512, [], "f78e", "M400 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm88.7-26.7l-91.9-25.8 11.1-5.6c12.4-6.2 23-15.6 30.7-27.1l18.1-27.2c2.5-3.7 1.5-8.6-2.2-11.1l-13.3-8.9c-3.7-2.5-8.6-1.5-11.1 2.2l-18 27.2c-4.6 7-11 12.6-18.5 16.3L351 94.6l-33.8-9.5 8.3-10.3c6.8-8.5 10.5-19.1 10.5-30V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v36.8c0 3.6-1.2 7.1-3.5 10l-16.8 20.9-16.1-4.5c-6.9-1.9-11.7-8.2-11.7-15.4V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v47.8c0 21.5 14.3 40.4 35 46.2l78.9 22.2L304 192H96c-53 0-96 43-96 96v32h32v27.5l-11.9 31.8c-4.6 12.2-5.3 25.4-2.2 38l23 72.4C45.1 503 57.5 512 71.4 512h47.7c20.8 0 36.1-19.5 31.1-39.7l-17-68.6 19.4-51.7H256v128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V320l32-64h48c26.5 0 48-21.5 48-48v-43.9c0-14.3-9.6-26.9-23.3-30.8zM480 208c0 8.8-7.2 16-16 16h-67.8L352 312.4V480h-64V320H130.4l-30.7 81.8 19.4 78.2H71.4l-22.6-71.2c-1.4-6.1-.9-12.3 1.3-18.2l14-37.2V288H32c0-35.3 28.7-64 64-64h227.8l33.7-67.4c6.9-13.7 22.5-20.6 37.3-16.5l73.6 20.7c6.9 1.9 11.7 8.2 11.7 15.4V208z"]
  },
      Nl = {
    prefix: "fal",
    iconName: "deer-rudolph",
    icon: [512, 512, [], "f78f", "M368 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm112-48c-13.3 0-24.6 8.1-29.5 19.5l-85.7-24.1 11.1-5.6c12.4-6.2 23-15.6 30.7-27.1l18.1-27.2c2.5-3.7 1.5-8.6-2.2-11.1l-13.3-8.9c-3.7-2.5-8.6-1.5-11.1 2.2l-18 27.3c-4.6 7-11 12.6-18.5 16.3L319 94.6l-33.8-9.5 8.3-10.3c6.8-8.5 10.5-19.1 10.5-30V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v36.8c0 3.6-1.2 7.1-3.5 10l-16.8 20.9-16.1-4.5c-6.9-1.9-11.7-8.2-11.7-15.4V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v47.8c0 21.5 14.3 40.4 35 46.2l78.9 22.2L272 192H96c-53 0-96 43-96 96v32h32v27.5l-11.9 31.8c-4.6 12.2-5.3 25.4-2.2 38l23 72.4C45.1 503 57.5 512 71.4 512h47.7c20.8 0 36.1-19.5 31.1-39.7l-17-68.6 19.4-51.7H224v128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V320l32-64h48c26.5 0 48-21.5 48-48v-32c17.7 0 32-14.3 32-32s-14.3-32-32-32zm-32 96c0 8.8-7.2 16-16 16h-67.8L320 312.4V480h-64V320H130.4l-30.7 81.8 19.4 78.2H71.4l-22.6-71.2c-1.4-6.1-.9-12.3 1.3-18.2l14-37.2V288H32c0-35.3 28.7-64 64-64h195.8l33.7-67.4c6.9-13.7 22.5-20.6 37.3-16.5l73.6 20.7c6.9 1.9 11.7 8.2 11.7 15.4V208z"]
  },
      gl = {
    prefix: "fal",
    iconName: "democrat",
    icon: [640, 512, [], "f747", "M283.7 226.8l-8.2-16.5c-1.5-3-5.7-3-7.2 0l-8.2 16.5-18.2 2.7c-3.3.5-4.6 4.5-2.2 6.8l13.2 12.9-3.1 18.2c-.6 3.3 2.9 5.7 5.8 4.2l16.3-8.6 16.3 8.6c2.9 1.5 6.4-.9 5.8-4.2l-3.1-18.2 13.2-12.9c2.4-2.3 1.1-6.3-2.2-6.8l-18.2-2.7zm96 0l-8.2-16.5c-1.5-3-5.7-3-7.2 0l-8.2 16.5-18.2 2.7c-3.3.5-4.6 4.5-2.2 6.8l13.2 12.9-3.1 18.2c-.6 3.3 2.9 5.7 5.8 4.2l16.3-8.6 16.3 8.6c2.9 1.5 6.4-.9 5.8-4.2l-3.1-18.2 13.2-12.9c2.4-2.3 1.1-6.3-2.2-6.8l-18.2-2.7zm259-.6l-15.2-22.8C579.6 137.7 516.3 144 485.2 144H271.8L247 111.6c17.3-28 17.5-64.4-1.2-92.7C238.2 7.4 225.4.6 211.6.5c-11 0-21.3 4.3-29.1 12l-14.9 14.9-15.8-15.8C144.3 4.1 134.4 0 123.8 0 110.6 0 98.3 6.6 91 17.6 76.2 40 74.7 68.1 85.5 91.5l-75.2 91.9c-11.7 14.3-13.6 33.9-4.8 50l15.9 29.1C30 278.3 46.9 288 65.6 288H100c12.8 0 24.8-4.5 34.1-12.7l14.6-12.2 27.2 63.5v138.7c0 25.7 20.9 46.7 46.7 46.7h50.6c25.7 0 46.7-20.9 46.7-46.7V416h113.3v49.3c0 25.7 20.9 46.7 46.7 46.7h49.3c25.7 0 46.7-20.9 46.7-46.7V234.8c0-16.4-4.7-31.6-12.4-44.9 13 7.8 24.5 18.2 33.2 31.3L612 244c2.4 3.7 7.4 4.7 11.1 2.2l13.3-8.9c3.7-2.4 4.7-7.4 2.3-11.1zM544 465.3c0 8.1-6.6 14.7-14.7 14.7H480c-8.1 0-14.7-6.6-14.7-14.7V384H288v81.3c0 8.1-6.6 14.7-14.7 14.7h-50.6c-8.1 0-14.7-6.6-14.7-14.7V336h336v129.3zm0-161.3H201.1l-39.8-93-48.1 40.1c-3.4 3.1-8.2 4.9-13.1 4.9H65.6c-6.9 0-13.3-3.4-16.2-8.7l-15.9-29.1c-2.6-4.7-2-10.1 1.5-14.4l82.9-101.2c3.1-3.8 8.2-6 13.7-6.3-2.8-1.7-5.8-3.1-8.3-5.5-15.1-15.1-16.9-38.3-5.6-55.4 1.4-2.2 3.8-3.3 6.2-3.3 1.9 0 3.8.7 5.3 2.2l38.5 38.5 37.5-37.5c1.8-1.8 4.1-2.7 6.4-2.7 2.9 0 5.8 1.4 7.5 4 13.8 20.9 11.5 49.4-6.9 67.8-2.1 2.1-4.4 3.9-6.8 5.5L256 176h229.3c32.5 0 58.8 26.3 58.8 58.8V304zm-68.3-77.2l-8.2-16.5c-1.5-3-5.7-3-7.2 0l-8.2 16.5-18.2 2.7c-3.3.5-4.6 4.5-2.2 6.8l13.2 12.9-3.1 18.2c-.6 3.3 2.9 5.7 5.8 4.2l16.3-8.6 16.3 8.6c2.9 1.5 6.4-.9 5.8-4.2l-3.1-18.2 13.2-12.9c2.4-2.3 1.1-6.3-2.2-6.8l-18.2-2.7z"]
  },
      Hl = {
    prefix: "fal",
    iconName: "desktop",
    icon: [576, 512, [], "f108", "M528 0H48C21.5 0 0 21.5 0 48v288c0 26.5 21.5 48 48 48h192l-24 96h-72c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-72l-24-96h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM249 480l16-64h46l16 64h-78zm295-144c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v288z"]
  },
      Vl = {
    prefix: "fal",
    iconName: "desktop-alt",
    icon: [576, 512, [], "f390", "M528 0H48C21.5 0 0 21.5 0 48v288c0 26.5 21.5 48 48 48h192l-24 96h-72c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-72l-24-96h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM249 480l16-64h46l16 64h-78zm295-144c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-48h512v48zm0-80H32V48c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v208z"]
  },
      xl = {
    prefix: "fal",
    iconName: "dewpoint",
    icon: [448, 512, [], "f748", "M176 0c-12.4 0-24.7 6.8-29.2 20.7C100 168.6 0 240.8 0 345c0 92.3 78.7 167 176 167s176-74.7 176-167c0-104.8-99.8-175.8-146.8-324.3C201.2 7.1 188.6 0 176 0zm144 345c0 74.4-64.6 135-144 135S32 419.5 32 345c0-47.5 26.1-89.2 59.2-142 29.2-46.6 62.2-99.3 84.8-168.6 22.7 69.7 55.7 122.3 84.9 168.8 33 52.6 59.1 94.1 59.1 141.8zM384 0c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm0 96c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      wl = {
    prefix: "fal",
    iconName: "dharmachakra",
    icon: [512, 512, [], "f655", "M503.67 232.35l-24.81 1.03c-4.5-44.89-22.28-85.84-49.31-118.94l18.31-16.84c3.35-3.08 3.46-8.33.24-11.54l-22.15-22.15c-3.21-3.21-8.46-3.11-11.54.24l-16.84 18.31c-33.1-27.03-74.05-44.81-118.94-49.31l1.03-24.81a7.997 7.997 0 0 0-7.99-8.33h-31.32c-4.55 0-8.18 3.79-7.99 8.33l1.03 24.81c-44.88 4.5-85.84 22.28-118.94 49.31L97.6 64.15c-3.08-3.35-8.33-3.46-11.54-.24L63.91 86.05a7.99 7.99 0 0 0 .24 11.54l18.31 16.84c-27.04 33.1-44.81 74.05-49.31 118.94l-24.81-1.03c-4.55-.18-8.34 3.45-8.34 8v31.32c0 4.55 3.79 8.18 8.33 7.99l24.81-1.03c4.5 44.89 22.28 85.84 49.31 118.94l-18.3 16.84c-3.35 3.08-3.46 8.33-.24 11.54l22.15 22.15c3.21 3.22 8.46 3.11 11.54-.24l16.84-18.31c33.1 27.04 74.05 44.81 118.94 49.31l-1.03 24.81a7.997 7.997 0 0 0 7.99 8.33h31.32c4.55 0 8.18-3.79 7.99-8.33l-1.03-24.81c44.89-4.5 85.84-22.28 118.94-49.31l16.84 18.31c3.08 3.35 8.33 3.46 11.54.24l22.15-22.15a7.99 7.99 0 0 0-.24-11.54l-18.31-16.84c27.04-33.1 44.81-74.05 49.31-118.94l24.81 1.03c4.55.19 8.33-3.44 8.33-7.99v-31.32c.01-4.55-3.78-8.18-8.32-7.99zm-56.92 2.37l-96.49 4.02c-2.48-13.64-7.74-26.27-15.34-37.24l70.91-65.24c22.13 27.64 36.82 61.45 40.92 98.46zM256 320c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm119.74-213.83l-65.24 70.91c-10.97-7.6-23.6-12.86-37.24-15.34l4.02-96.49c37.01 4.1 70.82 18.79 98.46 40.92zM234.72 65.25l4.02 96.49c-13.64 2.48-26.27 7.74-37.24 15.34l-65.24-70.91c27.64-22.13 61.45-36.82 98.46-40.92zm-128.55 71.01l70.91 65.24c-7.6 10.97-12.86 23.6-15.34 37.24l-96.49-4.02c4.1-37.01 18.79-70.82 40.92-98.46zM65.25 277.28l96.49-4.02c2.48 13.64 7.74 26.27 15.34 37.24l-70.91 65.24c-22.13-27.64-36.82-61.45-40.92-98.46zm71.01 128.55l65.24-70.91c10.97 7.6 23.6 12.86 37.24 15.34l-4.02 96.49c-37.01-4.1-70.82-18.79-98.46-40.92zm141.02 40.92l-4.02-96.49c13.64-2.48 26.27-7.74 37.24-15.34l65.24 70.91c-27.64 22.13-61.45 36.82-98.46 40.92zm128.55-71.01l-70.91-65.24c7.6-10.97 12.86-23.6 15.34-37.24l96.49 4.02c-4.1 37.01-18.79 70.82-40.92 98.46z"]
  },
      yl = {
    prefix: "fal",
    iconName: "diagnoses",
    icon: [640, 512, [], "f470", "M160 256c0 .5-.1 1-.1 1.4 46.7-18.1 103-33.4 160.1-33.4 44.9 0 89 9.6 128.6 22.4-1.3-9.8-.4-20.1 6.6-31.5C413.7 201.7 367.4 192 320 192c-61.1 0-120.5 16-170 35 6.2 8.1 10 18 10 29zm336 0c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm88.6 72.4l-17.8 26.7c-5 7.5-14.5 9-21.4 4.9-22.4-13.2-71.7-39.7-129.4-56.7V444c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4v-95.8c37.9 14.9 67.8 31.5 81.2 39.4 20.4 12 49.1 8.1 64.3-14.7l17.8-26.7c13.1-19.7 11.4-51.8-15.1-67.7-12.4-7.4-30.9-17.7-53.2-28.5-2.3 11-8.6 20.5-17.1 27.3 23.2 11.1 42.2 21.6 53.9 28.6 7.8 4.7 9.9 14.9 4.8 22.5zM416 96c0-52.9-43.1-96-96-96s-96 43.1-96 96 43.1 96 96 96 96-43.1 96-96zm-96 64c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zM46.5 372.9c15 22.6 43.7 26.9 64.3 14.7 13.3-7.9 43.3-24.6 81.2-39.4V444c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V303.4c-57.7 16.9-107.1 43.5-129.4 56.7-7 4.1-16.4 2.5-21.4-4.9l-17.8-26.7c-5.1-7.6-2.9-17.8 4.9-22.5 5.7-3.4 13.4-7.8 22.1-12.5-8.5-6.8-14.8-16.2-17.2-27.1-8.2 4.5-15.5 8.7-21.3 12.2-26.4 15.8-28.3 47.8-15.1 67.7zM632 480H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h624c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM112 272c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm144 32c0 8.8 7.2 16 16 16s16-7.2 16-16-7.2-16-16-16-16 7.2-16 16zm96 96c0 8.8 7.2 16 16 16s16-7.2 16-16-7.2-16-16-16-16 7.2-16 16z"]
  },
      bl = {
    prefix: "fal",
    iconName: "diamond",
    icon: [448, 512, [], "f219", "M253 13.4c-15.3-17.9-42.8-17.9-58.1 0L9.3 230.9c-12.4 14.5-12.4 35.6 0 50.2L195 498.6c15.3 17.9 42.8 17.9 58.1 0l185.6-217.5c12.4-14.5 12.4-35.6 0-50.2L253 13.4zm161.4 246.9L228.7 477.8c-2.5 2.9-6.9 2.9-9.4 0L33.6 260.3c-2.1-2.5-2.1-6.2 0-8.6L219.3 34.2c2.5-2.9 6.9-2.9 9.4 0l185.7 217.5c2.1 2.5 2.1 6.1 0 8.6z"]
  },
      Sl = {
    prefix: "fal",
    iconName: "dice",
    icon: [640, 512, [], "f522", "M480 328c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zM224 200c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm96 0c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm-192 0c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm96 96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm0-192c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm352 88H439.38c-2.89-5.17-6.26-10.15-10.65-14.54L270.54 19.28C257.69 6.42 240.84 0 224 0s-33.69 6.42-46.54 19.28L19.28 177.46c-25.7 25.7-25.7 67.38 0 93.08l158.18 158.18C190.31 441.57 207.16 448 224 448s33.69-6.43 46.54-19.28L320 379.26V448c0 35.35 28.65 64 64 64h192c35.35 0 64-28.65 64-64V256c0-35.35-28.65-64-64-64zM247.27 405.45c-6.21 6.21-14.48 9.64-23.27 9.64s-17.05-3.42-23.27-9.64L42.55 247.27c-6.21-6.22-9.64-14.48-9.64-23.27s3.42-17.05 9.64-23.27L200.73 42.55c6.21-6.21 14.48-9.64 23.27-9.64s17.05 3.42 23.27 9.64l158.18 158.18c6.22 6.21 9.64 14.48 9.64 23.27s-3.42 17.05-9.64 23.27L247.27 405.45zM608 448c0 17.64-14.36 32-32 32H384c-17.64 0-32-14.36-32-32V347.26l76.72-76.72C441.57 257.69 448 240.84 448 224h128c17.64 0 32 14.36 32 32v192z"]
  },
      Tl = {
    prefix: "fal",
    iconName: "dice-d10",
    icon: [512, 512, [], "f6cd", "M503.88 261.29L279.8 10.64C273.45 3.55 264.72 0 256 0s-17.45 3.55-23.8 10.64L8.12 261.29c-11.81 13.21-10.6 33.5 2.69 45.22l224.08 197.52c6.03 5.32 13.57 7.97 21.11 7.97 7.54 0 15.08-2.66 21.11-7.97L501.19 306.5c13.29-11.71 14.49-32.01 2.69-45.21zM256 297.95l-75.86-50.57 75.86-177 75.86 177L256 297.95zm-107.28-58.24L47.69 264.97 220.97 71.12l-72.25 168.59zm214.56 0L291.03 71.12 464.5 265.01l-101.22-25.3zM31.91 282.62l.01.04-.03-.02.02-.02zm17.03 15.03l108.34-27.09 82.76 55.19v140.22L48.94 297.65zM271.96 465.9V325.75l82.76-55.19 108.2 27.06L271.96 465.9z"]
  },
      Dl = {
    prefix: "fal",
    iconName: "dice-d12",
    icon: [512, 512, [], "f6ce", "M505.24 178.49l-47.7-95.41a63.972 63.972 0 0 0-28.62-28.62l-95.41-47.7A63.905 63.905 0 0 0 304.89 0h-97.78c-9.94 0-19.73 2.31-28.62 6.76l-95.41 47.7a63.972 63.972 0 0 0-28.62 28.62l-47.7 95.41A63.874 63.874 0 0 0 0 207.11v97.78c0 9.94 2.31 19.73 6.76 28.62l47.7 95.41a63.972 63.972 0 0 0 28.62 28.62l95.41 47.7a64.07 64.07 0 0 0 28.62 6.76h97.78c9.94 0 19.73-2.31 28.62-6.76l95.41-47.7a63.972 63.972 0 0 0 28.62-28.62l47.7-95.41a64.07 64.07 0 0 0 6.76-28.62v-97.78c0-9.94-2.31-19.74-6.76-28.62zm-29.55 12.44l-95.58 109.23L272 246.11V140.22l156.94-42.8 46.75 93.51zM308.8 480H203.2l-55.29-152.06L256 273.89l108.09 54.05L308.8 480zM199.55 32h112.89l82.85 41.42L256 111.41 116.71 73.42 199.55 32zM83.06 97.42L240 140.22V246.1l-108.11 54.05-95.58-109.22 46.75-93.51zM32 312.45v-77.88l81.99 93.7 48.42 133.16-74.56-37.28L32 312.45zm392.15 111.7l-74.56 37.28 48.42-133.16 81.99-93.7v77.88l-55.85 111.7z"]
  },
      jl = {
    prefix: "fal",
    iconName: "dice-d20",
    icon: [448, 512, [], "f6cf", "M431.88 116.13L239.88 4.3a31.478 31.478 0 0 0-31.76 0l-192 111.84C6.15 121.94 0 132.75 0 144.46v223.09c0 11.71 6.15 22.51 16.12 28.32l192 111.83a31.478 31.478 0 0 0 31.76 0l192-111.83c9.97-5.81 16.12-16.62 16.12-28.32V144.46c0-11.71-6.15-22.52-16.12-28.33zM224 57.62L318.7 176H129.3L224 57.62zM124.62 208h198.75L224 369.47 124.62 208zm68.28 171.99L55.92 362.87l44.43-133.28 92.55 150.4zm154.75-150.41l44.43 133.28-136.98 17.13 92.55-150.41zm7.17-59.69L262.67 54.72l138.01 80.78-45.86 34.39zm-261.64 0l-46.24-34.68 138.54-80.7-92.3 115.38zm-16.01 27.98l-45.13 135.4.17-169.12 44.96 33.72zM208 414.12v56.43L85.4 398.8 208 414.12zm155.6-15.45L240 470.84v-56.72l123.6-15.45zm7.23-200.8l45.15-33.86-.17 168.79-44.98-134.93zM224.14 480h.17l-.09.05-.08-.05z"]
  },
      El = {
    prefix: "fal",
    iconName: "dice-d4",
    icon: [512, 512, [], "f6d0", "M504.9 289.03L280.84 11.86C274.45 3.96 265.23 0 256 0s-18.45 3.96-24.85 11.86L7.1 289.03c-11.31 14-8.84 34.57 5.47 45.49l224.05 170.94c5.72 4.37 12.55 6.55 19.38 6.55s13.66-2.18 19.38-6.55l224.05-170.94c14.31-10.92 16.78-31.5 5.47-45.49zM31.99 309.14L240 51.75v416.04L31.99 309.14zM256.02 480h.03l-.01.01-.02-.01zM272 467.82v-416l208.02 257.26L272 467.82z"]
  },
      kl = {
    prefix: "fal",
    iconName: "dice-d6",
    icon: [448, 512, [], "f6d1", "M431.88 116.13L239.88 4.3a31.478 31.478 0 0 0-31.76 0l-192 111.84C6.15 121.94 0 132.75 0 144.46v223.09c0 11.71 6.15 22.51 16.12 28.32l192 111.83a31.478 31.478 0 0 0 31.76 0l192-111.83c9.97-5.81 16.12-16.62 16.12-28.32V144.46c0-11.71-6.15-22.52-16.12-28.33zM224 32.08l175.75 102.86L224 237.48 47.83 134.7 224 32.08zM32.21 162.65L208 265.18v205.37L32 367.54l.21-204.89zM240 470.84V265.18l175.98-102.64-.21 205.67L240 470.84z"]
  },
      Il = {
    prefix: "fal",
    iconName: "dice-d8",
    icon: [512, 512, [], "f6d2", "M502.1 232.1L279.9 9.9C273.3 3.3 264.6 0 256 0s-17.3 3.3-23.9 9.9L9.9 232.1c-13.2 13.2-13.2 34.5 0 47.7L232.1 502c6.6 6.6 15.2 9.9 23.9 9.9s17.3-3.3 23.9-9.9l222.2-222.2c13.2-13.1 13.2-34.5 0-47.7zM240 464.7L61.2 285.9 240 362.5zm0-137L43.7 243.6 240 47.3zm32 137V362.5l178.8-76.6zm0-137V47.3l196.3 196.3z"]
  },
      Ol = {
    prefix: "fal",
    iconName: "dice-five",
    icon: [448, 512, [], "f523", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zm32 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32v320zM128 136c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm96 96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm-96 96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm192-192c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm0 192c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      Ql = {
    prefix: "fal",
    iconName: "dice-four",
    icon: [448, 512, [], "f524", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zm32 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32v320zM128 136c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm0 192c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm192-192c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm0 192c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      Zl = {
    prefix: "fal",
    iconName: "dice-one",
    icon: [448, 512, [], "f525", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zm32 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32v320zM224 232c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      Ul = {
    prefix: "fal",
    iconName: "dice-six",
    icon: [448, 512, [], "f526", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zm32 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32v320zM128 136c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm0 96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm192 0c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm-192 96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm192-192c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm0 192c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      Bl = {
    prefix: "fal",
    iconName: "dice-three",
    icon: [448, 512, [], "f527", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zm32 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32v320zM128 136c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm96 96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm96 96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      Rl = {
    prefix: "fal",
    iconName: "dice-two",
    icon: [448, 512, [], "f528", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zm32 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32v320zM128 136c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm192 192c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      Yl = {
    prefix: "fal",
    iconName: "digging",
    icon: [576, 512, [], "f85e", "M208 464a16 16 0 0 1-32 0V325.11l-47.75-25L63 469.74A16 16 0 0 1 48 480a16.28 16.28 0 0 1-5.75-1.07 16 16 0 0 1-9.18-20.68l66.59-173.14-28.54-14.95L3.2 446.75a48 48 0 0 0 27.6 62A47.47 47.47 0 0 0 48 512a48 48 0 0 0 44.82-30.78l50.69-131.8.49.24V464a48 48 0 0 0 96 0V358.63l-32-16.76zm103.06-48a32 32 0 0 0-30.35 21.88L256 512h320L474.07 305.68a32 32 0 0 0-56.07-2.15l-36 61.4-14.73-7.6a46.66 46.66 0 0 0-2.11-21.67c-10.16-28.14-18.47-51.81-25.47-71.84-22.73-64.81-35.05-99-56.65-122.69 30.45-8.4 53-36 53-69.13a72 72 0 0 0-144 0 71.26 71.26 0 0 0 4.91 25.56A145.19 145.19 0 0 0 176.73 96H104a48 48 0 0 0-36.87 17.26l-40 48a48 48 0 0 0 6.16 67.61 47.46 47.46 0 0 0 35.57 10.67l296.88 153L352 416zM264 32a40 40 0 1 1-40 40 40 40 0 0 1 40-40zm-58.81 241.77l26.65-26.37c4.56 12.27 10.09 27.83 17.23 48.18.11.31.24.69.35 1zM290.88 318c-4.22-11.9-8.18-23.12-11.62-33-16.79-47.85-25.92-73.31-34.85-88.83l-64.55 64.53-74.63-38.49L167.45 160H111.5l-35.2 42.24a16 16 0 1 1-24.57-20.5l34.68-42.09a32 32 0 0 1 24.7-11.65h64.36c17.49 0 34.93 3.48 50.65 11.17 43.35 21.2 49.94 39.93 83.32 135.24 6.42 18.28 14.07 40.06 23.05 65zm79.45 130l9.27-15.81L445.31 320h.12l79.07 160H300.41l10.66-32h59.26z"]
  },
      Pl = {
    prefix: "fal",
    iconName: "digital-tachograph",
    icon: [640, 512, [], "f566", "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zm0 288H32V128h576v256zM80 272h208c8.84 0 16-7.16 16-16v-80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80c0 8.84 7.16 16 16 16zm8-88h192v64H88v-64zM72 360h224c4.42 0 8-3.58 8-8v-8c0-4.42-3.58-8-8-8H72c-4.42 0-8 3.58-8 8v8c0 4.42 3.58 8 8 8zm272 0h224c4.42 0 8-3.58 8-8v-8c0-4.42-3.58-8-8-8H344c-4.42 0-8 3.58-8 8v8c0 4.42 3.58 8 8 8zM80 288c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H80zm64 0c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-16z"]
  },
      Fl = {
    prefix: "fal",
    iconName: "diploma",
    icon: [640, 512, [], "f5ea", "M608.64 47.56C603.02 38.01 591.58 32 579.27 32c-2.53 0-5.1.25-7.66.78L444.65 75.56A390.24 390.24 0 0 1 320 96c-42.38 0-84.48-6.9-124.65-20.44L68.39 32.78c-2.56-.53-5.13-.78-7.65-.78-12.31 0-23.75 6.01-29.38 15.56-41.81 70.94-41.81 217.95 0 288.89C36.99 345.99 48.42 352 60.74 352c2.53 0 5.09-.25 7.65-.78l126.96-42.78c4.29-1.45 8.74-2.3 13.08-3.56l-56.23 94.79a31.992 31.992 0 0 0-.29 32.16 32.007 32.007 0 0 0 27.81 16.16h20.2l15.61 19.81a32.009 32.009 0 0 0 25.13 12.19c11.56 0 22.23-6.24 27.9-16.32l51.47-91.57 51.53 91.5a32.004 32.004 0 0 0 53.03 4.1l15.52-19.71 20.35-.01a31.997 31.997 0 0 0 27.49-48.35l-56.3-94.73c4.32 1.25 8.73 2.1 13 3.54l126.96 42.78c2.56.53 5.13.78 7.66.78 12.31 0 23.75-6.01 29.38-15.55 41.8-70.94 41.8-217.95-.01-288.89zM185.13 278.11L60.74 320.03V320c-.8 0-1.45-.16-1.75-.16-.16 0-.23.05-.16.2-35.92-61.18-35.89-195.18-.53-255.43.15-.12.87-.51 2.82-.51l124.02 41.79c17.99 6.06 36.34 10.58 54.87 14.15v131.62l-8.35 14.07c-15.68 3.34-31.25 7.23-46.53 12.38zM424.56 416l-25.12 31.91L320 306.84 240.66 448l-25.22-32h-35.72L272 260.44v-135.5c15.91 1.82 31.9 3.07 48 3.07s32.09-1.25 48-3.07v135.5l92.44 155.55-35.88.01zm157.14-96.61c-.15.11-.87.5-2.83.5l-124-41.79c-15.27-5.14-30.83-9.04-46.5-12.38L400 251.65v-131.6c18.52-3.58 36.88-8.09 54.87-14.15L579.18 64h.09c.8 0 1.45.16 1.75.16.16 0 .22-.05.16-.2 35.91 61.18 35.88 195.19.52 255.43z"]
  },
      Wl = {
    prefix: "fal",
    iconName: "directions",
    icon: [512, 512, [], "f5eb", "M502.61 233.32L278.68 9.39C272.42 3.13 264.21 0 256 0s-16.42 3.13-22.68 9.39L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c6.26 6.26 14.47 9.39 22.68 9.39s16.42-3.13 22.68-9.39l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zM255.95 479.98L32.02 255.95 255.95 32.01c.01 0 .02-.01.05-.01l.05.02 223.93 224.03-224.03 223.93zM330.89 224H208c-26.51 0-48 21.49-48 48v40c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-40c0-8.84 7.16-16 16-16h122.89l-54.63 50.43c-3.25 3-3.45 8.06-.45 11.3l10.84 11.74c3 3.25 8.06 3.45 11.3.45l78.4-72.36c4.87-4.52 7.66-10.94 7.66-17.58s-2.78-13.06-7.72-17.62l-78.34-72.31c-3.25-3-8.31-2.79-11.3.45l-10.84 11.74c-3 3.25-2.79 8.31.45 11.3L330.89 224z"]
  },
      Gl = {
    prefix: "fal",
    iconName: "disc-drive",
    icon: [512, 512, [], "f8b5", "M256 224a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm248 224h-24V96a64 64 0 0 0-64-64H96a64 64 0 0 0-64 64v352H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h496a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm-56 0H64V96a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32zM256 96a160 160 0 1 0 160 160A160 160 0 0 0 256 96zm0 288a128 128 0 1 1 128-128 128.14 128.14 0 0 1-128 128z"]
  },
      ql = {
    prefix: "fal",
    iconName: "disease",
    icon: [512, 512, [], "f7fa", "M463.92 185.06L401 163.75c-13-4.41-22.5-13.58-25.4-24.53l-15-56.16c-6.28-23.38-25.56-41.41-51.6-48.24-28.7-7.5-58.83.18-78.39 20.18l-43.25 44.29c-9.19 9.38-23.5 14.4-38.12 13.16l-67.38-5.22c-31.31-2.42-60.43 12.11-74.18 37-11.68 21.19-9.94 45.63 4.75 65.4l36.12 48.69c6.81 9.19 7.88 20.09 2.91 29.92L24.8 341.17c-10.68 21.22-8.25 45.26 6.5 64.33 17.85 23.06 49.19 33.65 80.06 27L177 418.36c14.54-3.13 29.57-.08 40.57 8.07l50.9 37.91A81.26 81.26 0 0 0 316.86 480a83.83 83.83 0 0 0 34.71-7.48c23.44-10.66 38.5-31 40.28-54.35l4.44-57.46c.81-10.87 8.28-20.92 20-26.86l58.13-29.47c24.87-12.62 39.21-36.22 37.43-61.58-1.85-26.22-20.25-48.33-47.93-57.74zm-4 90.79l-58.13 29.47c-21.75 11.05-35.75 30.85-37.4 53L360 415.73c-1.25 16.66-15.53 24.89-21.62 27.67-16.72 7.63-36.66 5.82-50.78-4.71l-50.94-37.93c-13.66-10.15-31-15.59-48.56-15.59a83.84 83.84 0 0 0-17.84 1.9l-65.6 14.19c-23 5-40.15-5.19-48-15.36-4.18-5.4-10.15-16.55-3.22-30.34L80 302.66c10.47-20.72 8.31-44.4-5.78-63.41l-36.1-48.69c-9.72-13.09-5.69-24.93-2.44-30.83 7.75-14 25.34-21.9 43.68-20.59l67.38 5.22c24.31 1.87 47.78-6.61 63.5-22.71l43.24-44.26c11.38-11.64 30.07-16.19 47.52-11.6 14.75 3.86 25.53 13.41 28.75 25.54l15 56.14c5.72 21.33 22.94 38.73 46.09 46.59l62.84 21.32c15.53 5.26 25.38 16.36 26.31 29.69.83 12.47-6.67 23.98-20.07 30.78zM160 192a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm128 96a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm16-96a16 16 0 1 0 16 16 16 16 0 0 0-16-16z"]
  },
      Jl = {
    prefix: "fal",
    iconName: "divide",
    icon: [384, 512, [], "f529", "M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8zM192 336c-26.46 0-48 21.54-48 48s21.54 48 48 48 48-21.54 48-48-21.54-48-48-48zm0-160c26.46 0 48-21.54 48-48s-21.54-48-48-48-48 21.54-48 48 21.54 48 48 48z"]
  },
      Kl = {
    prefix: "fal",
    iconName: "dizzy",
    icon: [496, 512, [], "f567", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm0-184c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm0 96c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm-28.7-140.7c6.2-6.2 6.2-16.4 0-22.6L190.6 192l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L168 169.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l28.7 28.7-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6 6.2 6.2 16.4 6.3 22.6 0l28.7-28.7 28.7 28.7c6.2 6.3 16.4 6.3 22.6 0zm160-102.6c-6.2-6.2-16.4-6.2-22.6 0L328 169.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l28.7 28.7-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6 6.2 6.2 16.4 6.3 22.6 0l28.7-28.7 28.7 28.7c6.2 6.2 16.4 6.3 22.6 0 6.2-6.2 6.2-16.4 0-22.6L350.6 192l28.7-28.7c6.3-6.2 6.3-16.4 0-22.6z"]
  },
      Xl = {
    prefix: "fal",
    iconName: "dna",
    icon: [384, 512, [], "f471", "M0 503.5c-.3 4.6 3.3 8.5 8 8.5h16.1c4.2 0 7.7-3.1 8-7.3.4-5.6 1.4-14.1 3.5-24.7h312.6c2.2 10.7 3.3 19.3 3.7 24.8.4 4.1 3.8 7.2 8 7.2H376c4.7 0 8.3-3.9 8-8.5-2.3-31.5-18.5-142-132.2-227.9-9.3 6.3-19.2 12.4-29.6 18.3 26 18.4 46.6 38.2 63.2 58.2H97.7c24.1-28.8 57-57.5 102-82C360.9 182.3 381.4 44.4 384 8.5c.3-4.6-3.3-8.5-8-8.5h-16.1c-4.2 0-7.7 3.1-8 7.3-.4 5.6-1.4 14.2-3.5 24.8H35.8c-2.2-10.7-3.2-19.3-3.7-24.8-.4-4.1-3.8-7.2-8-7.2L8 0C3.4 0-.3 3.9 0 8.5c2.5 34 21.7 159.5 161 247.3C21.3 343.6 2.5 469.5 0 503.5zM340 64c-6.3 19.2-15.9 41.2-30.4 64H75c-14.4-22.9-24.1-44.8-30.5-64H340zM192 237.4c-40.7-23.3-71.2-50.2-93.8-77.4h188.1c-22.7 27.1-53.4 53.9-94.3 77.4zM44 448c6.3-19.2 15.9-41.1 30.4-64h234.5c14.5 22.9 24.2 44.9 30.6 64H44z"]
  },
      _l = {
    prefix: "fal",
    iconName: "do-not-enter",
    icon: [496, 512, [], "f5ec", "M394.67 192H101.33C93.97 192 88 199.16 88 208v96c0 8.84 5.97 16 13.33 16h293.33c7.36 0 13.33-7.16 13.33-16v-96c.01-8.84-5.96-16-13.32-16zM376 288H120v-64h256v64zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216z"]
  },
      $l = {
    prefix: "fal",
    iconName: "dog",
    icon: [576, 512, [], "f6d3", "M528,96H464l-7.16-14.31C452,71.92,439.13,64,428.22,64H358.59L331.31,36.72A15.57,15.57,0,0,0,320.13,32,16,16,0,0,0,304,48V224H192a95.53,95.53,0,0,0-52.94,16H112a48.05,48.05,0,0,1-48-48,16,16,0,0,0-32,0,79.94,79.94,0,0,0,77.47,79.73A95.08,95.08,0,0,0,96,320V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V384h96v96a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V240h32a64,64,0,0,0,64-64V112A16,16,0,0,0,528,96ZM416,480H352V352H192V480H128V320a64.07,64.07,0,0,1,64-64H310.06L416,282.48Zm96-304a32,32,0,0,1-32,32H416v41.52l-80-20V86.66L345.34,96h82.88l16,32H512Zm-96-48a16,16,0,1,1-16-16A16,16,0,0,1,416,128Z"]
  },
      cf = {
    prefix: "fal",
    iconName: "dog-leashed",
    icon: [576, 512, [], "f6d4", "M544,112v64a64,64,0,0,1-64,64H448V480a32,32,0,0,1-32,32H352a32,32,0,0,1-32-32V384H224v96a32,32,0,0,1-32,32H128a32,32,0,0,1-32-32V320a95,95,0,0,1,13.46-48.26A80,80,0,0,1,32,192a16,16,0,0,1,32,0,48.05,48.05,0,0,0,48,48h27.05A95.48,95.48,0,0,1,192,224h79.94L34.88,26.45a8,8,0,0,1-1-11.27L44.11,2.88a8,8,0,0,1,11.27-1L304,209V48a16,16,0,0,1,16.12-16,15.67,15.67,0,0,1,11.2,4.72L358.6,64h69.62c10.92,0,23.74,7.93,28.62,17.69L464,96h64A16,16,0,0,1,544,112ZM288,256H192a64.07,64.07,0,0,0-64,64V480h64V352h96Zm128,26.48-96-24V352h32V480h64ZM512,128H444.22l-16-32H345.34L336,86.66V229.52l80,20V208h64a32,32,0,0,0,32-32Zm-96,0a16,16,0,1,1-16-16A16,16,0,0,1,416,128Z"]
  },
      ef = {
    prefix: "fal",
    iconName: "dollar-sign",
    icon: [256, 512, [], "f155", "M191.9 259.3L73.7 222.2C49.2 214.5 32 189 32 160.3 32 124.8 57.6 96 89 96h73.8c22.2 0 43.3 8.6 60.1 24.5 3.1 2.9 7.8 3.2 11 .3l11.9-10.8c3.4-3.1 3.6-8.4.4-11.6-22.8-22-52.7-34.5-83.3-34.5H144V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56H89c-49.1 0-89 43.2-89 96.3 0 42.6 26.4 80.6 64.1 92.4l118.2 37.1c24.6 7.7 41.7 33.2 41.7 61.9 0 35.4-25.6 64.3-57 64.3H93.2c-22.2 0-43.3-8.6-60.1-24.5-3.1-2.9-7.8-3.2-11-.3L10.3 402c-3.3 3-3.6 8.4-.3 11.5 22.8 22 52.7 34.5 83.3 34.5H112v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56h23c49.1 0 89-43.2 89-96.3 0-42.5-26.4-80.5-64.1-92.4z"]
  },
      af = {
    prefix: "fal",
    iconName: "dolly",
    icon: [576, 512, [], "f472", "M575.6 309.8l-5.1-15.2c-1.4-4.2-5.9-6.5-10.1-5.1L526 301.1 451.5 77.9c-2.7-8.1-8.4-14.7-16-18.5-7.7-3.8-16.3-4.4-24.4-1.7L176.3 136l-18-50.7C146.9 53.3 116.7 32 82.8 32H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h74.8c20.3 0 38.4 12.8 45.2 31.9l96.7 271.9c-23.3 17.2-37.2 46.5-31.4 78.9 5.6 31.3 30.4 57 61.5 63.5 51.7 10.7 97.2-28.4 97.2-78.2 0-13.1-3.4-25.2-9-36.1l227.5-76c4.2-1.4 6.5-5.9 5.1-10.1zM187 166.1l106.4-35.5 25 74.9c1.4 4.2 5.9 6.5 10.1 5.1l15.2-5.1c4.2-1.4 6.5-5.9 5.1-10.1l-25-74.9L421.2 88l74.5 223.3-174.4 58.1C307.6 358.7 290.7 352 272 352c-6.3 0-12.3.9-18.1 2.3L187 166.1zM272 480c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      nf = {
    prefix: "fal",
    iconName: "dolly-empty",
    icon: [576, 512, [], "f473", "M570.5 294.6c-1.4-4.2-5.9-6.5-10.1-5.1l-239.1 79.8C307.6 358.7 290.7 352 272 352c-6.3 0-12.3.9-18.1 2.3l-95.7-269C146.9 53.3 116.7 32 82.8 32H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h74.8c20.3 0 38.4 12.8 45.2 31.9l96.7 271.9c-23.3 17.2-37.2 46.5-31.4 78.9 5.6 31.3 30.4 57.1 61.5 63.5C306.5 521 352 481.8 352 432c0-13.1-3.4-25.2-9-36.1l227.5-76c4.2-1.4 6.5-5.9 5.1-10.1l-5.1-15.2zM272 480c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      tf = {
    prefix: "fal",
    iconName: "dolly-flatbed",
    icon: [640, 512, [], "f474", "M208 352h384c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zM352 96h96v80.7l-36.1-14.4-11.9-4.8-11.9 4.8-36.1 14.4V96zm-128 0h96v128l80-32 80 32V96h96v224H224V96zm408 320H128V8c0-4.4-3.6-8-8-8H8C3.6 0 0 3.6 0 8v16c0 4.4 3.6 8 8 8h88v408c0 4.4 3.6 8 8 8h58.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H632c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-424 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      rf = {
    prefix: "fal",
    iconName: "dolly-flatbed-alt",
    icon: [640, 512, [], "f475", "M208 352h384c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zM416 96h96v96h-96V96zm0 128h160v96H416v-96zM224 96h160v224H224V96zm408 320H128V8c0-4.4-3.6-8-8-8H8C3.6 0 0 3.6 0 8v16c0 4.4 3.6 8 8 8h88v408c0 4.4 3.6 8 8 8h58.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H632c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-424 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      of = {
    prefix: "fal",
    iconName: "dolly-flatbed-empty",
    icon: [640, 512, [], "f476", "M632 416H128V8c0-4.4-3.6-8-8-8H8C3.6 0 0 3.6 0 8v16c0 4.4 3.6 8 8 8h88v408c0 4.4 3.6 8 8 8h58.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H632c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-408 48c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zm288 0c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16z"]
  },
      lf = {
    prefix: "fal",
    iconName: "donate",
    icon: [512, 512, [], "f4b9", "M224.7 215.7l56.4 16.1c8.8 2.5 14.9 10.6 14.9 19.7 0 11.3-9.2 20.5-20.5 20.5h-36.9c-8.2 0-16.1-2.6-22.6-7.3-3-2.2-7.2-1.5-9.8 1.2l-11.4 11.4c-3.5 3.5-2.9 9.2 1 12.2 12.3 9.4 27.2 14.5 42.9 14.5h1.4v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-24h1.4c22.8 0 44.3-13.6 51.7-35.2 10.1-29.6-7.3-59.8-35.1-67.8L231 184.1c-8.8-2.5-14.9-10.6-14.9-19.7 0-11.3 9.2-20.5 20.5-20.5h36.9c8.2 0 16.1 2.6 22.6 7.3 3 2.2 7.2 1.5 9.8-1.2l11.4-11.4c3.5-3.5 2.9-9.2-1-12.2-12.3-9.4-27.2-14.5-42.9-14.5H272V88c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24h-3.5c-30.6 0-55.1 26.3-52.2 57.5 2 22.1 19 40.1 40.4 46.2zM480 288h-32c10.3-24.6 16-51.6 16-80C464 93.1 370.9 0 256 0S48 93.1 48 208c0 28.4 5.7 55.4 16 80H32c-17.7 0-32 14.4-32 32v160c0 17.6 14.3 32 32 32h448c17.7 0 32-14.4 32-32V320c0-17.6-14.3-32-32-32zM256 32c97 0 176 79 176 176s-79 176-176 176S80 305 80 208 159 32 256 32zm224 448H32V320h48.9c16.6 25.8 38.6 47.7 64.6 64H104c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-41.5c26-16.3 48-38.2 64.6-64H480v160z"]
  },
      ff = {
    prefix: "fal",
    iconName: "door-closed",
    icon: [640, 512, [], "f52a", "M400 288c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm232 192H512V32c0-17.67-14.33-32-32-32H160c-17.67 0-32 14.33-32 32v448H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h624c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-152 0H160V32h320v448z"]
  },
      sf = {
    prefix: "fal",
    iconName: "door-open",
    icon: [640, 512, [], "f52b", "M288 288c13.25 0 24-14.33 24-32s-10.75-32-24-32-24 14.33-24 32 10.75 32 24 32zm344 192H512V96c0-17.67-14.33-32-32-32h-96V33.18C384 14.42 369.2 0 352.06 0c-2.57 0-5.19.32-7.83 1.01l-192 49.74C137.99 54.44 128 67.7 128 82.92V480H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h624c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM352 33.18V480H160l.26-398.27 191.8-49.69-.06 1.14zM480 480h-96V96h96v384z"]
  },
      uf = {
    prefix: "fal",
    iconName: "dot-circle",
    icon: [512, 512, [], "f192", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.663 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.663 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm0-296c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80zm0 128c-26.467 0-48-21.533-48-48s21.533-48 48-48 48 21.533 48 48-21.533 48-48 48z"]
  },
      hf = {
    prefix: "fal",
    iconName: "dove",
    icon: [512, 512, [], "f4ba", "M368 160.1c0 8.8 7.2 16 16 16s16-7.2 16-16-7.2-16-16-16-16 7.1-16 16zM384 64c-46.5 0-85.3 33.1-94.1 77.1-29.2-36.6-48.9-80.3-56-127.3C231.8.6 215-5.1 206 5.5c-35.3 41.7-53 88.5-58.7 122.3-25.3-24.4-46-53.3-60.4-86-5.5-12.6-23.3-13.1-29.1-.7-16 34-25.3 71.9-25.8 112-.6 42.9 9.8 130.2 110.6 211.8L13.8 397.1C1.5 400.2-3.9 414.3 3 425c19.9 30.7 68.9 82.6 174.8 87 13.4.6 22.7-6.8 25.2-9l63.9-54.8H320c88.4 0 160-71.7 160-160.1V160l32-96H384zm-174.1-9.7c14.1 50.3 41.2 96 78.1 133V200c-41.1-7.4-78.8-24.3-111.3-47.8 3.2-41.8 19.4-75.8 33.2-97.9zM448 154.7v133.5c0 70.6-57.4 128.1-128 128.1h-64.9s-75.2 63.8-76 63.8c-74.6-3.1-115.8-32.4-137.4-56.9l170.8-42.7C164.9 341.8 62.4 276.4 64 153.5c.3-22.7 3.7-44.9 10.3-66.4C156.4 226.2 300 235.9 320 238.2v-78.1c0-35.4 28.7-64.1 64-64.1h83.6L448 154.7z"]
  },
      mf = {
    prefix: "fal",
    iconName: "download",
    icon: [512, 512, [], "f019", "M452 432c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20zm-84-20c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20zm144-48v104c0 24.3-19.7 44-44 44H44c-24.3 0-44-19.7-44-44V364c0-24.3 19.7-44 44-44h99.4L87 263.6c-25.2-25.2-7.3-68.3 28.3-68.3H168V40c0-22.1 17.9-40 40-40h96c22.1 0 40 17.9 40 40v155.3h52.7c35.6 0 53.4 43.1 28.3 68.3L368.6 320H468c24.3 0 44 19.7 44 44zm-261.7 17.7c3.1 3.1 8.2 3.1 11.3 0L402.3 241c5-5 1.5-13.7-5.7-13.7H312V40c0-4.4-3.6-8-8-8h-96c-4.4 0-8 3.6-8 8v187.3h-84.7c-7.1 0-10.7 8.6-5.7 13.7l140.7 140.7zM480 364c0-6.6-5.4-12-12-12H336.6l-52.3 52.3c-15.6 15.6-41 15.6-56.6 0L175.4 352H44c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12V364z"]
  },
      vf = {
    prefix: "fal",
    iconName: "drafting-compass",
    icon: [512, 512, [], "f568", "M433.86 304.31c21.47-18.17 40.59-39.34 55.75-63.8 2.38-3.83 1.01-8.95-2.89-11.21l-13.86-8.03c-3.73-2.16-8.41-.89-10.69 2.77-12.29 19.75-27.49 37.08-44.51 52.2l-77.71-134.59C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66L96.11 273.19c-15.81-14.44-30.21-30.57-41.77-49.14-2.28-3.66-6.96-4.94-10.69-2.77l-13.86 8.03c-3.9 2.26-5.27 7.37-2.89 11.21 14.43 23.29 32.76 43.22 53 60.76L0 439.66l7.02 58.25c1.01 8.35 8.11 14.1 15.88 14.1 2.08 0 4.21-.41 6.29-1.3l53.95-23.04 78.85-136.57c30.37 11.71 62.83 18.33 96.26 18.33 32.07 0 63.27-6.12 92.63-16.82l77.98 135.06 53.95 23.04c2.07.88 4.2 1.3 6.29 1.3 7.77 0 14.88-5.75 15.88-14.1l7.02-58.25-78.14-135.35zm-41.75-8.32c-8.87 5.97-18.11 11.3-27.69 16.04l-73.26-126.89c10.11-3.99 19.19-9.78 27.28-16.76l73.67 127.61zM256 32c35.35 0 64 28.65 64 64s-28.65 64-64 64-64-28.65-64-64 28.65-64 64-64zM60.76 462.42l-24.52 10.47-3.19-26.47 160.52-278.04c8.09 6.98 17.17 12.77 27.28 16.76L60.76 462.42zm197.49-125.01c-27.73 0-54.72-5.11-80.11-14.3l75.81-131.31c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l76.54 132.57c-24.33 8.22-49.96 13.04-76.32 13.04zm217.51 135.48l-24.52-10.47-70.82-122.66c9.54-4.82 18.74-10.2 27.66-16.1l70.87 122.76-3.19 26.47z"]
  },
      df = {
    prefix: "fal",
    iconName: "dragon",
    icon: [640, 512, [], "f6d5", "M481.01 119.95c14.92.86 27.35-9.89 30.88-24.58L453.47 80c-6.49 27.12 15.51 39.26 27.54 39.95zm54.5 131.8c-29.84-16.98-55.61-31.64-55.61-51.38V192h16.96l28.62 22.03c8.34 6.42 18.74 9.97 29.27 9.97h29.18c21.15 0 40.09-14.17 46.02-34.45l7.4-25.16c5.84-19.8 1.88-41.44-10.62-57.91L569.8 31.59C554.78 11.81 530.98 0 506.14 0H297.16c-19.47 0-33.09 24.04-15.4 41.25l37.49 30.25-32.55 13.42c-16.19 7.94-19.14 32.81 1.13 42.64l48.11 19.25v50.89l-190.3-47.88c-19.18-4.86-39.68 2.83-50.99 19.08L3.76 299.12c-5.03 7.91-5 17.72.03 25.59 1.69 2.62 9.54 13.11 24.99 10.91l115.02-21.8-12.07 17.3c-5.03 7.91-5 17.72.03 25.59 6.7 10.45 17.87 11.86 24.15 11.05l202.87-27.39c8.33 16.71 18.17 32.35 31.17 45.73-130.55 8.75-252.39 36.8-364.13 61.33C10.86 450.7.01 464.1.01 479.31c0 18 14.75 32.64 32.87 32.64l474.01.05c42.65 0 83.14-19.77 108.29-52.89 23.4-30.8 30.49-68.73 19.9-106.8-14.5-52.15-61.68-79-99.57-100.56zM41.72 300.62l79.17-113.41c3.75-5.39 10.59-7.86 17-6.36l84.07 21.02L170 276.3 41.72 300.62zm127.18 33.1l86.23-123.48 80.79 20.5c0 47.9 8.68 72.63 10.6 79L168.9 333.72zM506.89 480H32c230.53-56.77 352.62-62.36 400.47-64.02 15.54-.53 21.22-20.83 8.22-29.34-48.96-32.23-72.76-80.92-72.76-148.83V135.98c0-6.55-3.97-12.42-10.06-14.86l-38.15-15.23 36.71-15.09c5.22-2.16 8.94-6.91 9.75-12.5s-1.41-11.2-5.81-14.75L321.15 32h184.99c14.9 0 29.18 7.08 38.18 18.95l56.92 74.91c6.38 8.38 8.4 19.39 5.44 29.48l-7.4 25.19c-2 6.75-8.31 11.47-15.34 11.47h-29.18c-3.56 0-6.9-1.14-9.75-3.33l-32.96-25.36a16.01 16.01 0 0 0-9.75-3.31h-38.4c-8.84 0-16 7.16-16 16v24.38c0 38.34 34.87 58.19 71.8 79.19 36.18 20.59 73.58 41.89 84.57 81.33 19.36 69.86-41.14 119.1-97.38 119.1z"]
  },
      Mf = {
    prefix: "fal",
    iconName: "draw-circle",
    icon: [512, 512, [], "f5ed", "M512 256c0-33.51-25.84-60.69-58.63-63.46-20.48-63.5-70.41-113.43-133.91-133.91C316.69 25.84 289.51 0 256 0s-60.69 25.84-63.46 58.63c-63.5 20.48-113.43 70.41-133.91 133.91C25.84 195.31 0 222.49 0 256c0 33.51 25.84 60.69 58.63 63.46 20.48 63.5 70.41 113.43 133.91 133.91C195.31 486.16 222.49 512 256 512s60.69-25.84 63.46-58.63c63.5-20.48 113.43-70.41 133.91-133.91C486.16 316.69 512 289.51 512 256zM256 32c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32zM32 256c0-17.64 14.36-32 32-32s32 14.36 32 32-14.36 32-32 32-32-14.36-32-32zm224 224c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm58.12-58.47C304.04 399.43 281.88 384 256 384s-48.04 15.43-58.12 37.53c-50.16-17.67-89.73-57.24-107.4-107.4C112.57 304.04 128 281.88 128 256c0-25.88-15.43-48.04-37.53-58.12 17.67-50.17 57.24-89.73 107.4-107.4C207.96 112.57 230.12 128 256 128s48.04-15.43 58.12-37.53c50.16 17.67 89.73 57.24 107.4 107.4C399.43 207.96 384 230.12 384 256c0 25.88 15.43 48.04 37.53 58.12-17.68 50.17-57.25 89.74-107.41 107.41zM448 288c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"]
  },
      pf = {
    prefix: "fal",
    iconName: "draw-polygon",
    icon: [448, 512, [], "f5ee", "M384 352c-6.3 0-12.26 1.19-18.01 2.89l-32.42-54.02C344.95 289.31 352 273.49 352 256s-7.05-33.31-18.42-44.87L366 157.11c5.75 1.7 11.71 2.89 18.01 2.89 35.35 0 64-28.65 64-64s-28.65-64-64-64c-29.79 0-54.6 20.45-61.74 48H125.74C118.6 52.45 93.79 32 64 32 28.65 32 0 60.65 0 96c0 29.79 20.44 54.6 48 61.74v196.53C20.44 361.4 0 386.21 0 416c0 35.35 28.65 64 64 64 29.79 0 54.6-20.44 61.74-48h196.53c7.14 27.56 31.95 48 61.74 48 35.35 0 64-28.65 64-64-.01-35.35-28.66-64-64.01-64zm-304 2.26V157.74c22.41-5.8 39.93-23.32 45.74-45.74h196.53c2.86 11.04 8.4 20.99 16.16 28.87l-32.42 54.02c-5.75-1.7-11.71-2.89-18.01-2.89-35.35 0-64 28.65-64 64s28.65 64 64 64c6.3 0 12.26-1.19 18.01-2.89l32.42 54.02c-7.76 7.88-13.3 17.83-16.16 28.87H125.74A63.814 63.814 0 0 0 80 354.26zM288 288c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm96-224c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32zM32 96c0-17.64 14.36-32 32-32s32 14.36 32 32-14.36 32-32 32-32-14.36-32-32zm32 352c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm320 0c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"]
  },
      zf = {
    prefix: "fal",
    iconName: "draw-square",
    icon: [448, 512, [], "f5ef", "M400 354.26V157.74c27.56-7.14 48-31.95 48-61.74 0-35.35-28.65-64-64-64-29.79 0-54.6 20.45-61.74 48H125.74C118.6 52.45 93.79 32 64 32 28.65 32 0 60.65 0 96c0 29.79 20.44 54.6 48 61.74v196.53C20.44 361.4 0 386.21 0 416c0 35.35 28.65 64 64 64 29.79 0 54.6-20.44 61.74-48h196.53c7.14 27.56 31.95 48 61.74 48 35.35 0 64-28.65 64-64-.01-29.79-20.45-54.6-48.01-61.74zM322.26 400H125.74c-5.8-22.41-23.32-39.93-45.74-45.74V157.74c22.41-5.8 39.93-23.32 45.74-45.74h196.53c5.8 22.41 23.32 39.93 45.74 45.74v196.53c-22.42 5.8-39.94 23.32-45.75 45.73zM384 64c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32zM32 96c0-17.64 14.36-32 32-32s32 14.36 32 32-14.36 32-32 32-32-14.36-32-32zm32 352c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm320 0c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"]
  },
      Cf = {
    prefix: "fal",
    iconName: "dreidel",
    icon: [448, 512, [], "f792", "M438.6 64L416 41.4c-12.5-12.5-32.8-12.5-45.3 0L278.1 134l-60.6-60.6c-6.5-6.5-15.1-9.8-23.6-9.8s-17.1 3.3-23.6 9.8L19.6 224C7 236.5 0 253.5 0 271.3v141.8c0 37 29.9 66.9 66.9 66.9h141.8c17.7 0 34.7-7 47.3-19.6l150.7-150.7c13.1-13.1 13.1-34.2 0-47.3l-60.6-60.6 92.6-92.6c12.4-12.4 12.4-32.7-.1-45.2zM233.4 437.8c-6.6 6.6-15.3 10.2-24.7 10.2H66.9C47.6 448 32 432.4 32 413.1V271.3c0-9.3 3.6-18.1 10.2-24.7l59.4-59.4 191.2 191.2-59.4 59.4zM384 287.1l-68.7 68.7-191.1-191.2L192.9 96c.1-.1.4-.4 1-.4l1 .4L384 285.1c.6.5.6 1.5 0 2zm-60.6-107.9l-22.6-22.6L393.4 64 416 86.6l-92.6 92.6z"]
  },
      Lf = {
    prefix: "fal",
    iconName: "drone",
    icon: [512, 512, [], "f85f", "M302.87,128c6.68,0,12.75-2.57,18.11-6.35a78.8574,78.8574,0,0,1-1-9.65,80,80,0,1,1,80,80,78.64886,78.64886,0,0,1-9.65-1c-3.79,5.36-6.35,11.43-6.35,18.11v13.26a112.703,112.703,0,0,0,15.9099,1.13245c59.63853,0,111.624-48.159,111.624-111.90443,0-59.6385-48.15906-111.62393-111.90445-111.62393-58.38959,0-111.60974,46.99339-111.60974,111.764L288,112a110.99719,110.99719,0,0,0,1.61,16ZM400,431.99994a32,32,0,0,0,0-64c-2.77,0-5.24.91-7.8,1.57l-21.45-21.45A64,64,0,0,1,352,302.87V209.13a63.99991,63.99991,0,0,1,18.75-45.25l21.45-21.45c2.56.66,5,1.57,7.8,1.57a32,32,0,1,0-32-32c0,2.77.91,5.24,1.57,7.8l-21.45,21.45A63.99991,63.99991,0,0,1,302.87,160H209.13a63.99991,63.99991,0,0,1-45.25-18.75L142.43,119.8c.66-2.56,1.57-5.03,1.57-7.8a32,32,0,1,0-32,32c2.8,0,5.24-.91,7.8-1.57l21.45,21.45A63.99991,63.99991,0,0,1,160,209.13v93.74a64,64,0,0,1-18.75,45.24993L119.8,369.57c-2.56-.66-5.03-1.57-7.8-1.57a32,32,0,1,0,32,32c0-2.8-.91-5.24-1.57-7.8l21.45-21.46A63.99973,63.99973,0,0,1,209.13,352h93.74a63.99973,63.99973,0,0,1,45.25,18.74l21.45,21.46c-.66,2.56-1.57,5-1.57,7.8A32,32,0,0,0,400,431.99994ZM320,320H192V192H320Zm192.00593,79.60957c0-58.38963-46.9934-111.60983-111.764-111.60983L400,288a110.99719,110.99719,0,0,0-16,1.61v13.26c0,6.68,2.57,12.75,6.35,18.11a78.84341,78.84341,0,0,1,9.65-1,80,80,0,1,1-80,80,78.66278,78.66278,0,0,1,1-9.65c-5.36-3.78-11.43-6.35-18.11-6.35h-13.28a112.70134,112.70134,0,0,0-1.13248,15.91c0,59.6385,48.159,111.624,111.90439,111.624C460.03838,511.51394,512.00593,463.34218,512.00593,399.60957ZM209.11,383.98c-6.68,0-12.75,2.57-18.11,6.35a78.66278,78.66278,0,0,1,1,9.65,80,80,0,1,1-80-80,78.84341,78.84341,0,0,1,9.65,1c3.78-5.36,6.35-11.43,6.35-18.11V289.61A110.99719,110.99719,0,0,0,112,288l-.24189-.00026c-65.16452,0-111.764,53.56054-111.764,111.60983,0,64.98207,53.23282,111.90437,111.624,111.90437,64.98206,0,111.90439-53.23282,111.90439-111.624A112.70134,112.70134,0,0,0,222.39,383.98ZM112.11012,223.50245A112.703,112.703,0,0,0,128.02,222.37V209.11c0-6.68-2.56-12.75-6.35-18.11a78.64886,78.64886,0,0,1-9.65,1,80,80,0,1,1,80-80,78.8574,78.8574,0,0,1-1,9.65c5.36,3.78,11.43,6.35,18.11,6.35h13.26A110.99719,110.99719,0,0,0,224,112l.00031-.26192c0-65.16448-53.56048-111.764-111.60974-111.764C47.4085-.02591.48612,53.20687.48612,111.598.48612,176.58012,53.71894,223.50245,112.11012,223.50245Z"]
  },
      Af = {
    prefix: "fal",
    iconName: "drone-alt",
    icon: [640, 512, [], "f860", "M624.21 127.93l-112.21.22V112a16 16 0 0 0-32 0v16.21l-112.3.23a15.75 15.75 0 1 0 .09 31.49L480 159.7v67.39l-95.09-25.93a247.11 247.11 0 0 0-129.82 0L160 227.09v-67.45l112.44-.23a15.74 15.74 0 1 0-.1-31.48l-112.34.22V112a16 16 0 0 0-32 0v16.21l-112.3.23a15.75 15.75 0 1 0 .1 31.49l112.2-.23V288a16 16 0 0 0 16 16h54.51a193.92 193.92 0 0 0-52.22 102.71 8.08 8.08 0 0 0 8 9.29h16.38a7.89 7.89 0 0 0 7.73-6.56 162 162 0 0 1 57.47-96.29l27.84 25.3A52.75 52.75 0 0 0 299.38 352h41.24a52.7 52.7 0 0 0 35.63-13.53l28.29-25.7a162 162 0 0 1 58 96.67 7.9 7.9 0 0 0 7.74 6.56h16.38a8.07 8.07 0 0 0 8-9.29A193.91 193.91 0 0 0 442.42 304H496a16 16 0 0 0 16-16V159.64l112.31-.23a15.74 15.74 0 1 0-.1-31.48zM480 272h-72a16 16 0 0 0-10.75 4.16l-42.53 38.64a21.18 21.18 0 0 1-14.1 5.2h-41.24a21.23 21.23 0 0 1-14.13-5.22l-42.5-38.62A16 16 0 0 0 232 272h-72v-11.73L263.53 232a215.1 215.1 0 0 1 112.94 0L480 260.27z"]
  },
      Nf = {
    prefix: "fal",
    iconName: "drum",
    icon: [512, 512, [], "f569", "M414.51 117.78l90-56.22a16 16 0 0 0-16.94-27.13l-115.89 72.41C335.19 99.56 295.14 96 256 96 132.7 96 0 131 0 208v160c0 61.85 114.62 112 256 112s256-50.15 256-112V208c0-42.48-40.52-72.13-97.49-90.22zM96 421.46C55.12 405.34 32 384.74 32 368V265.91c16.53 13 38.55 23.58 64 31.8zm144 26.19c-43.14-1.19-80.93-7-112-15.6V306.43c34.85 8 73.52 12.34 112 13.28zm144-15.6c-31.07 8.55-68.86 14.41-112 15.6V319.71c38.48-.94 77.15-5.3 112-13.28zM480 368c0 16.74-23.12 37.34-64 53.46V297.71c25.45-8.22 47.47-18.79 64-31.8zm-224-80c-123.71 0-224-35.82-224-80s100.29-80 224-80a598.54 598.54 0 0 1 74.44 4.61l-98.91 61.82a16 16 0 0 0 16.94 27.13l129.11-80.7C439.16 155.12 480 179.83 480 208c0 44.18-100.29 80-224 80z"]
  },
      gf = {
    prefix: "fal",
    iconName: "drum-steelpan",
    icon: [576, 512, [], "f56a", "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm0 32c25.68 0 50.43 1.46 73.82 4.09l-15.45 60.08C341.86 145.72 315.67 160 288 160s-53.86-14.27-58.37-31.82l-15.45-60.09C237.57 65.46 262.32 64 288 64zm94.84 185.12c-29.35 4.4-61.3 6.88-94.84 6.88-33.79 0-65.96-2.52-95.49-6.97 20.07-19.65 33.38-45.44 37.12-73.47C245.95 185.92 266.66 192 288 192c21.02 0 41.47-5.87 57.68-15.95 3.64 28.08 17.05 53.74 37.16 73.07zM178.26 73.37l16.97 60.04c12.05 42.66-7.64 86.71-44.73 107.47C79.32 223.84 32 194.02 32 160c0-38.27 59.87-71.21 146.26-86.63zM544 352c0 39.14-99.73 96-256 96S32 391.14 32 352V218.47C79.81 259.73 176.38 288 288 288s208.19-28.27 256-69.54V352zM425.61 240.87c-36.04-18.69-56.55-59.84-46.96-101.16l15.56-66.98C482.52 87.87 544 121.21 544 160c0 34-47.28 63.81-118.39 80.87z"]
  },
      Hf = {
    prefix: "fal",
    iconName: "drumstick",
    icon: [512, 512, [], "f6d6", "M471.25 57.59A169.77 169.77 0 0 0 348.47.06c-46.9-1.28-92.87 16.63-126 49.65C195.63 76.34 160 119.94 160 190.56v69.3l-43.34 43.35c-3.13 3.14-9.11 5.32-17.22 2.06A72.53 72.53 0 0 0 0 372.66c0 21.53 15.58 69.06 67.71 71.67 2 39.37 34.35 67.67 71.68 67.67 51.85 0 86.26-52.22 67.39-99.41-1-2.53-3.88-11.28 2.06-17.21l43.3-43.38h70.12c38.87 0 73-10.19 104.34-31.16 46.44-31 77-79.68 84-133.5 6.14-48.13-7.82-94.23-39.35-129.75zm-285 315.14c-13.1 13.08-16.62 32.86-9.16 51.74 23.47 58.7-74.37 78.88-77.4 18.26l-1.45-28.91-28.91-1.45c-50.62-2.54-49-80.3 3.21-80.3a40 40 0 0 1 15 2.89c17.72 7.13 38 4.7 51.81-9.12l26-26a80.2 80.2 0 0 0 46.93 46.87zm292.59-189.44c-5.66 44-31.81 85.46-70 111C382.93 311.6 354.62 320 322.28 320h-81.9A48.24 48.24 0 0 1 192 272v-81.45c0-45.29 16.35-81.73 53-118.15A137.74 137.74 0 0 1 343 32q2.21 0 4.5.06a137.92 137.92 0 0 1 99.81 46.79c25.31 28.49 36.53 65.59 31.53 104.44z"]
  },
      Vf = {
    prefix: "fal",
    iconName: "drumstick-bite",
    icon: [512, 512, [], "f6d7", "M471.39 57.58A169.89 169.89 0 0 0 348.54.06C301-1.15 255.67 16.72 222.51 49.7c-26.82 26.63-62.46 70.23-62.46 140.85v69.29l-43.39 43.37c-3.13 3.14-9.11 5.32-17.22 2.06A72.53 72.53 0 0 0 0 372.66c0 21.53 15.58 69.06 67.71 71.67 2 39.37 34.35 67.67 71.68 67.67 51.85 0 86.26-52.22 67.39-99.41-1-2.53-3.88-11.28 2.06-17.21L252.23 352h70.15a189.76 189.76 0 0 0 50.39-6.83 16 16 0 0 0 9.5-23.74A94.12 94.12 0 0 1 368.11 272a96.13 96.13 0 0 1 96-96c8.35 0 17 1.42 27.29 4.49a16 16 0 0 0 20.6-15.36c0-40.48-14.07-77.67-40.61-107.55zM186.23 372.73c-13.1 13.08-16.62 32.86-9.16 51.74 23.47 58.7-74.37 78.88-77.4 18.26l-1.45-28.91-28.91-1.45c-50.62-2.54-49-80.3 3.21-80.3a40 40 0 0 1 15 2.89c17.72 7.13 38 4.7 51.81-9.12l26-26a80.24 80.24 0 0 0 47 46.88zM464.14 144a128.16 128.16 0 0 0-128 128 125.53 125.53 0 0 0 9 46.35 155.14 155.14 0 0 1-22.76 1.65h-81.93a48.24 48.24 0 0 1-48.39-48v-81.44c0-45.29 16.35-81.73 53-118.16a137.79 137.79 0 0 1 98-40.41q2.25 0 4.5.06a138 138 0 0 1 99.87 46.79 127.18 127.18 0 0 1 31 66.13 109 109 0 0 0-14.29-.97z"]
  },
      xf = {
    prefix: "fal",
    iconName: "dryer",
    icon: [448, 512, [], "f861", "M384-1H64A64 64 0 0 0 0 63v416a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V63a64 64 0 0 0-64-64zm32 480H32V63a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32zM80 95a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm64 0a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm80 32a160 160 0 1 0 160 160 160 160 0 0 0-160-160zm0 288a128 128 0 1 1 128-128 128.14 128.14 0 0 1-128 128zm-7.11-156.42c0-20.12-10.63-30.75-18.39-38.51-5.18-5.18-8.21-8.4-9.43-13a7.11 7.11 0 0 0-6.82-5.4h-14.51a7.25 7.25 0 0 0-7.06 8.47c2.45 14.79 11.11 23.45 17.71 30 7 7 10.06 10.4 10.06 18.4S185.36 270 178.39 277c-7.77 7.75-18.39 18.38-18.39 38.5s10.62 30.72 18.39 38.47c5.17 5.18 8.21 8.39 9.42 13a7.13 7.13 0 0 0 6.83 5.39h14.5a7.25 7.25 0 0 0 7.07-8.47c-2.46-14.76-11.12-23.42-17.71-30-7-7-10.05-10.39-10.05-18.36s3.08-11.43 10.05-18.4c7.76-7.8 18.39-18.42 18.39-38.55zm71.11 0c0-20.12-10.62-30.75-18.39-38.51-5.18-5.18-8.21-8.4-9.43-13a7.11 7.11 0 0 0-6.82-5.4h-14.51a7.25 7.25 0 0 0-7.06 8.47c2.46 14.79 11.12 23.45 17.71 30 7 7 10.05 10.4 10.05 18.4S256.47 270 249.5 277c-7.76 7.76-18.39 18.39-18.39 38.51s10.63 30.71 18.39 38.49c5.17 5.18 8.21 8.39 9.43 13a7.11 7.11 0 0 0 6.82 5.39h14.51a7.25 7.25 0 0 0 7.06-8.47c-2.46-14.76-11.12-23.42-17.71-30-7-7-10.06-10.39-10.06-18.36s3.09-11.43 10.06-18.4c7.77-7.83 18.39-18.45 18.39-38.58z"]
  },
      wf = {
    prefix: "fal",
    iconName: "dryer-alt",
    icon: [448, 512, [], "f862", "M384-1H64A64 64 0 0 0 0 63v416a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V63a64 64 0 0 0-64-64zm32 480H32V63a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32zM80 95a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm64 0a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm80 32a160 160 0 1 0 160 160 160 160 0 0 0-160-160zm0 288a128 128 0 1 1 128-128 128.14 128.14 0 0 1-128 128zm0-224a96 96 0 1 0 96 96 96 96 0 0 0-96-96zm0 160a64 64 0 0 1-61.73-48H200a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-37.73A63.9 63.9 0 1 1 224 351z"]
  },
      yf = {
    prefix: "fal",
    iconName: "duck",
    icon: [576, 512, [], "f6d8", "M432 256c70.69 0 144-57.31 144-128h-97.57c-.44-3.21-.56-6.36-1.29-9.61-9.02-40.55-41.61-73.73-82.06-83.21C385.9 33.02 376.83 32 368 32c-61.86 0-112 50.14-112 112v112h-60.73c-25.68 0-49.79-10.07-69.95-25.99-5-3.95-11.13-6.02-17.35-6.02-3.61 0-7.24.7-10.71 2.12C86.77 230.47 80 240.6 80 251.95c0 1.39.37 2.67.41 4.05H32.25C12.87 256-2.72 273.21.4 292.34 17.76 398.77 110.13 480 221.47 480h99.94c68.24 0 128.85-55.86 126.53-124.06-1.01-29.74-13.09-56.53-31.93-76.98V256H432zm46.73-96h59.79c-11.59 32.68-56.4 57.25-91.47 62.8 16.7-16.61 28.14-38.37 31.68-62.8zm-86.27 140.64c14.44 15.68 22.78 35.7 23.49 56.38.75 22.18-7.95 43.83-24.5 60.96-18.44 19.08-43.97 30.02-70.04 30.02h-99.94c-94.97 0-174.05-69.31-189.33-160h52.82c16.21 64.17 73.95 112 143.09 112H248c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-19.96c-60.8 0-110.84-47-115.66-106.59 21.26 17.65 49.09 26.59 82.88 26.59H288V144c0-44.18 35.82-80 80-80s80 35.82 80 80c0 33.83-21.07 62.6-50.75 74.3-12.82 6.12-11.61 5.54-13.25 6.33v66.83l8.46 9.18zM368 128c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"]
  },
      bf = {
    prefix: "fal",
    iconName: "dumbbell",
    icon: [640, 512, [], "f44b", "M632 240h-24v-96c0-26.5-21.5-48-48-48h-32c-5.6 0-11 1.2-16 2.9V80c0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48v160H256V80c0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48v18.9c-5-1.8-10.4-2.9-16-2.9H80c-26.5 0-48 21.5-48 48v96H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h24v96c0 26.5 21.5 48 48 48h32c5.6 0 11-1.2 16-2.9V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V272h128v160c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-18.9c5 1.8 10.4 2.9 16 2.9h32c26.5 0 48-21.5 48-48v-96h24c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM112 384H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16zm112 48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v352zm256 0c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v352zm96-64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v224z"]
  },
      Sf = {
    prefix: "fal",
    iconName: "dumpster",
    icon: [576, 512, [], "f793", "M568 256h-34.7l7.1-64H560c10.4 0 18-12.2 15.5-24.9l-24-120C549.7 38.2 543.3 32 536 32H40c-7.3 0-13.7 6.2-15.5 15.1l-24 120C-2 179.8 5.6 192 16 192h19.5l7.1 64H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h38.2L64 448v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h256v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16l17.8-160H568c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-26.6-96h-78.7l-19.2-96h78.7l19.2 96zm-395.5 0l19.2-96H272v96H145.9zM304 64h106.9l19.2 96H304V64zM53.8 64h78.7l-19.2 96H34.6l19.2-96zM480 448h-32v-32H128v32H96L67.8 192h440.5L480 448z"]
  },
      Tf = {
    prefix: "fal",
    iconName: "dumpster-fire",
    icon: [640, 512, [], "f794", "M551.1 163.2c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-57 283.4c-4.7.5-9.2 1.4-14.1 1.4s-9.4-.9-14.1-1.4c-31.8-6.4-55.8-34.2-55.8-67.4 0-14 15.4-46.1 44.5-78.3 7.1 7.6 13.6 15.3 19.4 23l24.1 31.9 25.9-30.5c.1-.1.1-.2.2-.2 16.2 22.2 25.5 46.1 25.5 54.1.1 33.2-23.9 61-55.6 67.4zm85.5-46.6c1.4-6.7 2.2-13.7 2.2-20.8 0-23.3-23.6-71.4-56.6-100.8-9.5 8.4-18 17.3-25.6 26.2-12.4-16.4-27.8-33.1-45.2-48.6-44.7 39.9-76.4 91.9-76.4 123.2 0 7.1.8 14.1 2.2 20.8-17.5-21.6-28.4-48.7-28.4-78.4 0-31.6 32.5-93.2 88.1-149.5 16.8 16.7 32.2 34.3 45.3 51.6l24.1 31.9 25.9-30.5c4.9-5.8 9.9-11.4 15.1-16.8 34.3 39.9 57.5 91.4 57.5 113.3.2 29.8-10.7 56.8-28.2 78.4zM128 416v32H96L67.8 192h272.8c7.5-10.7 15.5-21.4 24.3-32H304V64h106.9l8 40c6-5.3 13.6-8 21.1-8 3.5 0 7 .7 10.3 1.9L443.5 64h78.7l14.3 71.3c4.6-2.4 9.5-4.1 14.6-4.1 6.6 0 12.9 2.4 18.5 6.4l-18.1-90.5C549.7 38.2 543.3 32 536 32H40c-7.3 0-13.7 6.2-15.5 15.1l-24 120C-2 179.8 5.6 192 16 192h19.5l7.1 64H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h38.2L64 448v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h176.8c-8.8-9.8-16.7-20.5-23.3-32H128zm37.1-352H272v96H145.9l19.2-96zM34.6 160l19.2-96h78.7l-19.2 96H34.6z"]
  },
      Df = {
    prefix: "fal",
    iconName: "dungeon",
    icon: [512, 512, [], "f6d9", "M240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zM512 296c0-9.08-3.04-17.47-8.16-24.19 5.46-7.31 8.33-16.36 7.98-25.49-1.32-35.19-9.76-69.17-25.09-100.97-4.49-9.32-12.48-16.41-21.94-19.99.86-10.14-2.16-20.28-8.51-28.26-21.34-26.85-47.37-48.83-77.36-65.33a40.004 40.004 0 0 0-19.19-4.93c-3.45 0-6.83.45-10.09 1.31-5.17-8.82-13.55-15.38-23.4-18.2C303.29 3.35 279.65 0 256 0s-47.29 3.35-70.25 9.95c-9.83 2.82-18.22 9.38-23.39 18.2-3.26-.86-6.64-1.31-10.09-1.31-6.69 0-13.33 1.7-19.19 4.92-30 16.5-56.03 38.48-77.37 65.34-6.34 7.98-9.36 18.11-8.5 28.25-9.47 3.59-17.45 10.67-21.94 19.99C9.95 177.15 1.51 211.12.18 246.33c-.35 9.12 2.52 18.17 7.98 25.48A39.772 39.772 0 0 0 0 296v64c0 9 2.99 17.31 8.02 24C2.99 390.69 0 399 0 408v64c0 22.05 17.94 40 40 40h64c22.06 0 40-17.95 40-40v-64c0-9-2.99-17.31-8.02-24 5.03-6.69 8.02-15 8.02-24v-64c0-8.92-2.93-17.16-7.88-23.82a40.01 40.01 0 0 0 8.04-21.96c.71-12.54 3.74-25.12 9.02-37.4 2.66-6.19 3.67-12.68 3.2-18.97 6-2.32 11.44-6.08 15.78-11.05 7.3-8.34 15.78-15.54 25.21-21.41 5.7-3.54 10.24-8.31 13.44-13.78 3.14.77 6.42 1.18 9.77 1.18 3.37 0 6.74-.42 10.01-1.26 9.42-2.41 17.48-3.53 25.39-3.53 7.92 0 15.99 1.12 25.41 3.53 3.28.84 6.65 1.26 10.02 1.26 3.36 0 6.63-.4 9.78-1.18 3.2 5.46 7.74 10.23 13.44 13.77 9.44 5.87 17.92 13.07 25.22 21.41 4.35 4.97 9.79 8.74 15.79 11.05-.48 6.29.54 12.78 3.2 18.97 5.28 12.28 8.31 24.86 9.02 37.39.46 8.26 3.39 15.81 8.04 21.96a39.793 39.793 0 0 0-7.88 23.82v64c0 9 2.99 17.31 8.02 24-5.03 6.69-8.02 15-8.02 24v64c0 22.05 17.94 40 40 40h64c22.06 0 40-17.95 40-40v-64c0-9-2.99-17.31-8.02-24 5.03-6.69 8.02-15 8.02-24V296zM112 472c0 4.42-3.58 8-8 8H40c-4.42 0-8-3.58-8-8v-64c0-4.42 3.58-8 8-8h64c4.42 0 8 3.58 8 8v64zm0-112c0 4.42-3.58 8-8 8H40c-4.42 0-8-3.58-8-8v-64c0-4.42 3.58-8 8-8h64c4.42 0 8 3.58 8 8v64zm11.78-159.82c-6.44 14.99-10.61 31.16-11.57 48.23-.24 4.22-3.51 7.58-7.74 7.58H40.41c-4.57 0-8.42-3.9-8.25-8.47 1.19-31.53 8.97-61.38 21.94-88.3 1.39-2.88 4.32-4.49 7.32-4.49 1.5 0 3.01.4 4.37 1.25l55.04 34.4c3.32 2.08 4.5 6.2 2.95 9.8zm56.7-65.97a143.632 143.632 0 0 0-32.4 27.51c-1.59 1.82-3.81 2.8-6.05 2.8-1.39 0-2.8-.38-4.08-1.18l-55-34.38c-4.07-2.54-5.16-8.21-2.17-11.97a225.31 225.31 0 0 1 67.73-57.21c1.2-.66 2.49-.96 3.77-.96 3.27 0 6.45 1.99 7.72 5.24l23.79 60.57c1.4 3.6-.04 7.55-3.31 9.58zm118.38-22.33c-1.21 3.08-4.24 4.91-7.45 4.91-.7 0-1.4-.08-2.09-.26-11.83-3.02-22.6-4.52-33.33-4.52-10.79 0-21.54 1.52-33.3 4.52-.7.18-1.4.26-2.09.26-3.21 0-6.23-1.83-7.44-4.92l-23.73-60.41c-1.72-4.39.64-9.47 5.17-10.77C214.11 35.09 234.69 32 256 32s41.89 3.09 61.42 8.7c4.53 1.3 6.9 6.38 5.17 10.77l-23.73 60.41zm75.19 51.47c-1.28.8-2.68 1.18-4.08 1.18-2.25 0-4.46-.98-6.05-2.8a144.07 144.07 0 0 0-32.4-27.51c-3.27-2.04-4.71-5.99-3.31-9.57L352 64.08c1.27-3.24 4.46-5.24 7.72-5.24 1.28 0 2.57.31 3.77.96a225.31 225.31 0 0 1 67.73 57.21c2.99 3.76 1.9 9.43-2.17 11.97l-55 34.37zm14.17 36.83c-1.55-3.61-.37-7.72 2.96-9.8l55.04-34.4a8.181 8.181 0 0 1 4.37-1.25c3 0 5.94 1.61 7.32 4.49 12.97 26.91 20.75 56.77 21.94 88.3.17 4.57-3.68 8.47-8.25 8.47h-64.06c-4.23 0-7.5-3.36-7.74-7.58-.97-17.07-5.14-33.23-11.58-48.23zM480 472c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-64c0-4.42 3.58-8 8-8h64c4.42 0 8 3.58 8 8v64zm0-112c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-64c0-4.42 3.58-8 8-8h64c4.42 0 8 3.58 8 8v64zM304 189.36V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"]
  },
      jf = {
    prefix: "fal",
    iconName: "ear",
    icon: [384, 512, [], "f5f0", "M192 96c-52.94 0-96 43.06-96 96 0 35.3 28.72 64 64 64 17.66 0 32 14.36 32 32s-14.34 32-32 32h-24c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h24c35.28 0 64-28.7 64-64s-28.72-64-64-64c-17.66 0-32-14.36-32-32 0-35.3 28.72-64 64-64s64 28.7 64 64v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24c0-52.94-43.06-96-96-96zm0-96C85.96 0 0 85.96 0 192v176c0 79.53 64.47 144 144 144s144-64.47 144-144v-9.9c57.33-33.21 96-95.08 96-166.1C384 85.96 298.04 0 192 0zm79.96 330.41L256 339.66V368c0 61.76-50.24 112-112 112S32 429.76 32 368V192c0-88.22 71.78-160 160-160s160 71.78 160 160c0 56.78-30.67 109.81-80.04 138.41z"]
  },
      Ef = {
    prefix: "fal",
    iconName: "ear-muffs",
    icon: [640, 512, [], "f795", "M640 352c0-15.1-6.1-28.9-16-39 .4-24.1-14.4-45-35.8-53.3-7.2-18.5-24.1-31.6-44.2-34.5V224C544 100.5 443.5 0 320 0S96 100.5 96 224v1.2c-20.2 3-37 16.1-44.2 34.5-21.3 8.4-36.2 29.2-35.8 53.3-9.9 10.1-16 23.9-16 39 0 5.5.8 10.8 2.4 16C.8 373.2 0 378.5 0 384c0 15.1 6.1 28.9 16 39-.4 24.1 14.4 45 35.8 53.3C59.9 497.1 80.2 512 104 512c5.5 0 10.8-.8 16-2.4 5.2 1.6 10.5 2.4 16 2.4 30.9 0 56-25.1 56-56 0-7.7-1.6-15.2-4.5-22 2.2-5.2 8.9-23.1 0-44 2.2-5.2 8.9-23.1 0-44 2.2-5.2 8.9-23.1 0-44 2.9-6.8 4.5-14.3 4.5-22 0-30.9-25.1-56-56-56-2.7 0-5.3.8-8 1.2V224c0-105.9 86.1-192 192-192s192 86.1 192 192v1.2c-2.7-.4-5.3-1.2-8-1.2-30.9 0-56 25.1-56 56 0 7.7 1.6 15.2 4.5 22-2.2 5.2-8.9 23.1 0 44-2.2 5.2-8.9 23.1 0 44-2.2 5.2-8.9 23.1 0 44-2.9 6.8-4.5 14.3-4.5 22 0 30.9 25.1 56 56 56 5.5 0 10.8-.8 16-2.4 5.2 1.6 10.5 2.4 16 2.4 23.7 0 44.1-14.9 52.2-35.8 21.3-8.3 36.2-29.1 35.8-53.3 9.9-10.1 16-23.9 16-39 0-5.5-.8-10.8-2.4-16 1.6-5.1 2.4-10.4 2.4-15.9zm-504-96c13.3 0 24 10.7 24 24 0 9.9-6 18.3-14.5 22 8.5 3.7 14.5 12.1 14.5 22s-6 18.3-14.5 22c8.5 3.7 14.5 12.1 14.5 22s-6 18.3-14.5 22c8.5 3.7 14.5 12.1 14.5 22s-6 18.3-14.5 22c8.5 3.7 14.5 12.1 14.5 22 0 13.3-10.7 24-24 24-6.2 0-11.7-2.5-16-6.4-4.3 3.9-9.8 6.4-16 6.4-13.3 0-24-10.7-24-24 0-4 1.2-7.7 3-11-3.3 1.8-7 3-11 3-13.3 0-24-10.7-24-24 0-6.3 2.6-12 6.6-16.3C42 406.9 32 396.7 32 384c0-6.2 2.5-11.7 6.4-16-3.9-4.3-6.4-9.8-6.4-16 0-12.7 10-22.9 22.6-23.7-4-4.3-6.6-10-6.6-16.3 0-13.3 10.7-24 24-24 4 0 7.7 1.2 11 3-1.8-3.3-3-7-3-11 0-13.3 10.7-24 24-24 6.2 0 11.7 2.5 16 6.4 4.3-3.9 9.8-6.4 16-6.4zm472 128c0 12.7-10 22.9-22.6 23.7 4 4.3 6.6 10 6.6 16.3 0 13.3-10.7 24-24 24-4 0-7.7-1.2-11-3 1.8 3.3 3 7 3 11 0 13.3-10.7 24-24 24-6.2 0-11.7-2.5-16-6.4-4.3 3.9-9.8 6.4-16 6.4-13.3 0-24-10.7-24-24 0-9.9 6-18.3 14.5-22-8.5-3.7-14.5-12.1-14.5-22s6-18.3 14.5-22c-8.5-3.7-14.5-12.1-14.5-22s6-18.3 14.5-22c-8.5-3.7-14.5-12.1-14.5-22s6-18.3 14.5-22c-8.5-3.7-14.5-12.1-14.5-22 0-13.3 10.7-24 24-24 6.2 0 11.7 2.5 16 6.4 4.3-3.9 9.8-6.4 16-6.4 13.3 0 24 10.7 24 24 0 4-1.2 7.7-3 11 3.3-1.8 7-3 11-3 13.3 0 24 10.7 24 24 0 6.3-2.6 12-6.6 16.3 12.6.8 22.6 11 22.6 23.7 0 6.2-2.5 11.7-6.4 16 3.9 4.3 6.4 9.8 6.4 16z"]
  },
      kf = {
    prefix: "fal",
    iconName: "eclipse",
    icon: [640, 512, [], "f749", "M256 467.4l-48.4-71.6c-3-4.4-8-7-13.2-7-1 0-2 .1-3 .3l-84.8 16.4 16.4-84.8c1.2-6.3-1.4-12.7-6.8-16.3L44.6 256l71.6-48.4c5.3-3.6 8-10 6.8-16.3l-16.4-84.8 84.8 16.4c6.2 1.1 12.7-1.5 16.3-6.8L256 44.6l35.1 51.9c7.6-7.5 15.9-14.4 24.6-20.7L269.2 7c-3-4.4-7.9-7-13.2-7s-10.3 2.6-13.2 7L187 89.4 89.3 70.6c-5.2-1-10.6.7-14.3 4.4s-5.4 9.1-4.4 14.3L89.4 187 7 242.8c-4.4 3-7 7.9-7 13.2s2.6 10.3 7 13.2L89.4 325l-18.9 97.7c-1 5.2.7 10.6 4.4 14.3s9.2 5.4 14.3 4.4l97.7-18.9 55.8 82.4c3 4.4 7.9 7 13.2 7s10.3-2.6 13.2-7l46.4-68.6c-8.7-6.4-17-13.2-24.6-20.7L256 467.4zm-17.8-289.2c4.4-11.8 9.7-23.1 15.9-33.9-28.5.4-55.9 11.1-77.3 32.5-37.8 37.8-43.5 94-14.5 143.2 7.2 12.2 17.5 22.4 29.7 29.7 20.1 11.9 41.5 17.8 62.3 18.2-6.3-10.8-11.6-22.1-16-34-9.6-2-19.7-5.7-30-11.8-7.5-4.4-14-10.9-18.4-18.4-25.9-43.9-11.1-83.6 9.6-104.3 9.4-9.3 22.8-17.5 38.7-21.2zM448 64c-106 0-192 86-192 192s86 192 192 192 192-86 192-192S554 64 448 64zm0 352c-88.2 0-160-71.8-160-160S359.8 96 448 96s160 71.8 160 160-71.8 160-160 160z"]
  },
      If = {
    prefix: "fal",
    iconName: "eclipse-alt",
    icon: [512, 512, [], "f74a", "M512 256c0-5.3-2.6-10.3-7-13.2L422.5 187l18.9-97.7c1-5.2-.7-10.6-4.4-14.3s-9.1-5.3-14.3-4.4L325 89.4 269.2 7c-3-4.4-7.9-7-13.2-7s-10.3 2.6-13.2 7L187 89.4 89.3 70.6c-5.2-1-10.6.7-14.3 4.4s-5.4 9.1-4.4 14.3L89.4 187 7 242.8c-4.4 3-7 7.9-7 13.2s2.6 10.3 7 13.2L89.4 325l-18.9 97.7c-1 5.2.7 10.6 4.4 14.3s9.1 5.4 14.3 4.4l97.7-18.9 55.8 82.4c3 4.4 7.9 7 13.2 7s10.3-2.6 13.2-7l55.8-82.4 97.7 18.9c5.2 1 10.6-.7 14.3-4.4s5.4-9.1 4.4-14.3L422.6 325l82.4-55.8c4.4-2.9 7-7.9 7-13.2zm-116.1 48.4c-5.3 3.6-8 10-6.8 16.3l16.4 84.8-84.8-16.4c-6.3-1.2-12.7 1.5-16.3 6.8L256 467.4l-48.4-71.6c-3-4.4-8-7-13.2-7-1 0-2 .1-3 .3l-84.8 16.4 16.4-84.8c1.2-6.3-1.4-12.7-6.8-16.3L44.6 256l71.6-48.4c5.3-3.6 8-10 6.8-16.3l-16.4-84.8 84.8 16.4c6.2 1.1 12.7-1.5 16.3-6.8L256 44.6l48.4 71.6c3.6 5.3 10.1 7.9 16.3 6.8l84.8-16.4-16.4 84.8c-1.2 6.3 1.4 12.7 6.8 16.3l71.6 48.4-71.6 48.3zM327 293.1c-1 0-2.9.2-3.9.4-3.7.7-7.5 1.1-11.3 1.1-32.5 0-59-26.6-59-59.2 0-21.2 11.5-41 29.9-51.5 7.6-4.3 11.5-12.6 10.1-21.2-1.4-8.6-7.9-15.2-16.5-16.7-6.7-1.2-13.6-1.9-20.4-1.9C194.2 144 144 194.2 144 256c0 61.8 50.2 112 111.9 112 33.9 0 65.6-15.1 86.9-41.5 5-6.2 6-14.5 2.6-21.7-3.4-7.1-10.6-11.7-18.4-11.7zM255.9 336c-44.1 0-79.9-35.9-79.9-80 0-39.3 28.4-72 65.7-78.7a91.288 91.288 0 0 0-20.9 58.1c0 44.9 32.6 82.4 75.3 89.9-12.1 6.9-25.9 10.7-40.2 10.7z"]
  },
      Of = {
    prefix: "fal",
    iconName: "edit",
    icon: [576, 512, [], "f044", "M417.8 315.5l20-20c3.8-3.8 10.2-1.1 10.2 4.2V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h292.3c5.3 0 8 6.5 4.2 10.2l-20 20c-1.1 1.1-2.7 1.8-4.2 1.8H48c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V319.7c0-1.6.6-3.1 1.8-4.2zm145.9-191.2L251.2 436.8l-99.9 11.1c-13.4 1.5-24.7-9.8-23.2-23.2l11.1-99.9L451.7 12.3c16.4-16.4 43-16.4 59.4 0l52.6 52.6c16.4 16.4 16.4 43 0 59.4zm-93.6 48.4L403.4 106 169.8 339.5l-8.3 75.1 75.1-8.3 233.5-233.6zm71-85.2l-52.6-52.6c-3.8-3.8-10.2-4-14.1 0L426 83.3l66.7 66.7 48.4-48.4c3.9-3.8 3.9-10.2 0-14.1z"]
  },
      Qf = {
    prefix: "fal",
    iconName: "egg",
    icon: [384, 512, [], "f7fb", "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0zm0 480c-88.22 0-160-71.78-160-160 0-100.72 82.24-288 160-288s160 187.28 160 288c0 88.22-71.78 160-160 160z"]
  },
      Zf = {
    prefix: "fal",
    iconName: "egg-fried",
    icon: [512, 512, [], "f7fc", "M224 112.12c-70.56 0-128 57.48-128 128.15s57.41 128.12 128 128.12 128-57.47 128-128.12-57.41-128.15-128-128.15zm0 224.24a96.15 96.15 0 0 1-96-96.09c0-53 43.07-96.12 96-96.12s96 43.13 96 96.12a96.15 96.15 0 0 1-96 96.09zm0-168.18a72.13 72.13 0 0 0-72 72.09 16 16 0 1 0 32 0 40.08 40.08 0 0 1 40-40.06 16 16 0 0 0 0-32zm254.32-17.73c-39.5-40.71-100.73-46.29-144.39-82.24S255.63 0 200.55 0a157.76 157.76 0 0 0-25.16 2.1c-86.78 14-111.71 80-125 157.13-11.1 64.34-54.41 127-50 192.91s52.83 128.45 114.97 150.75c17.64 6.32 33.83 9.11 48.92 9.11 64.66 0 108.94-51.18 155.72-95.56 43.68-41.44 93.4-37.72 140.93-73.89 56.28-42.82 71.71-140.55 17.39-192.1zm1.52 89.31c-1.69 31-16.35 60.6-38.27 77.28-18.12 13.79-37.53 20.88-58.09 28.4-26.8 9.79-57.19 20.9-85.49 47.75-5.47 5.19-10.91 10.47-16.35 15.76-37.59 36.52-73.1 71-117.36 71-12.09 0-24.56-2.37-38.12-7.24C75.24 454.46 35.74 402.85 32.24 350c-2.16-32.48 10.67-66.45 24.25-102.41 10-26.58 20.41-54.06 25.4-82.92C97 77.3 122.78 43 180.48 33.73A126.07 126.07 0 0 1 200.55 32c39.59 0 66.48 22.31 103.7 53.19L313.6 93c23.67 19.49 50 30.66 75.45 41.47s49.5 21 67.25 39.27c22.45 21.26 24.39 50.49 23.54 66.02z"]
  },
      Uf = {
    prefix: "fal",
    iconName: "eject",
    icon: [448, 512, [], "f052", "M435.322 239.565L259.383 47.558c-19.014-20.743-51.751-20.745-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435zM399.939 288H48.053c-13.866 0-21.169-16.585-11.791-26.816L212.205 69.181c6.323-6.897 17.248-6.918 23.585-.005l175.943 192.012c9.371 10.223 2.076 26.812-11.794 26.812zM448 400v32c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-48-16H48c-8.822 0-16 7.178-16 16v32c0 8.823 7.178 16 16 16h352c8.822 0 16-7.177 16-16v-32c0-8.822-7.178-16-16-16z"]
  },
      Bf = {
    prefix: "fal",
    iconName: "elephant",
    icon: [640, 512, [], "f6da", "M512 31.97h-45.81C460.54 26.16 437.16 0 391.99 0c-38.08 0-62.5 18.23-75.55 31.97H192C85.96 31.97 0 117.93 0 223.98v128.01h32V480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-80.01c48.43 24.21 83.07 38.47 160 0V480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V287.98h96v32h-32c-17.67 0-32 14.33-32 32v11.27c0 41.84 30.02 80.06 71.64 84.3 47.85 4.88 88.36-32.71 88.36-79.58v-208c0-70.7-57.31-128-128-128zM416 480h-64V348.21l-46.31 23.16c-54.82 27.41-76.47 27.46-131.38 0L128 348.21V480H64V319.99H32v-96.01c0-88.23 71.78-160.01 160-160.01h104.39c-1.1 2.71-2.7 5.19-3.55 8-8.96 29.48-5.42 59.87 9.94 85.47 11.53 19.19 28.91 34.05 49.22 42.53 0 40.15 27.18 73.73 64 84.26V480zm192-112.01c0 26.47-21.53 48-48 48s-48-21.53-48-48v-16h32v16c0 8.83 7.19 16 16 16s16-7.17 16-16V255.98H440c-30.88 0-56-25.12-56-56v-21.32l-19.67-8.21c-28.75-12.01-53.9-46.29-40.87-89.17C332.04 53.02 358.41 32 391.99 32c32.86 0 46.72 17.61 60.7 31.97H512c52.94 0 96 43.07 96 96.01v208.01zm-80-240.02c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"]
  },
      Rf = {
    prefix: "fal",
    iconName: "ellipsis-h",
    icon: [320, 512, [], "f141", "M192 256c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm88-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-240 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      Yf = {
    prefix: "fal",
    iconName: "ellipsis-h-alt",
    icon: [512, 512, [], "f39b", "M256 184c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm176-112c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM80 184c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"]
  },
      Pf = {
    prefix: "fal",
    iconName: "ellipsis-v",
    icon: [64, 512, [], "f142", "M32 224c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM0 136c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm0 240c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32z"]
  },
      Ff = {
    prefix: "fal",
    iconName: "ellipsis-v-alt",
    icon: [192, 512, [], "f39c", "M96 152c39.8 0 72-32.2 72-72S135.8 8 96 8 24 40.2 24 80s32.2 72 72 72zm0-112c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0 64c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"]
  },
      Wf = {
    prefix: "fal",
    iconName: "empty-set",
    icon: [448, 512, [], "f656", "M445.66 45.65l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-75.12 75.12C314.46 81.15 271.26 64 224 64 117.96 64 32 149.96 32 256c0 47.26 17.15 90.46 45.46 123.91L2.34 455.03c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l75.12-75.12C133.54 430.85 176.74 448 224 448c106.04 0 192-85.96 192-192 0-47.26-17.15-90.46-45.46-123.91l75.12-75.12a8.015 8.015 0 0 0 0-11.32zM64 256c0-88.22 71.78-160 160-160 38.34 0 73.1 14.12 100.69 36.69l-224 224C78.11 329.1 64 294.34 64 256zm320 0c0 88.22-71.78 160-160 160-38.34 0-73.1-14.12-100.69-36.69l224-224C369.89 182.9 384 217.66 384 256z"]
  },
      Gf = {
    prefix: "fal",
    iconName: "engine-warning",
    icon: [640, 512, [], "f5f2", "M320 32C196.3 32 96 132.3 96 256c0 123.76 100.3 224 224 224s224-100.24 224-224c0-123.7-100.3-224-224-224zm0 416c-105.87 0-192-86.13-192-192S214.13 64 320 64s192 86.13 192 192-86.13 192-192 192zm18.64-320.02h-37.28c-7.9 0-14.08 6.82-13.29 14.69l10.69 149.29c.68 6.83 6.43 12.03 13.29 12.03h15.9c6.87 0 12.61-5.2 13.29-12.03l10.69-149.29c.79-7.86-5.39-14.69-13.29-14.69zM320 328c-13.26 0-24 10.74-24 24 0 13.25 10.74 24 24 24s24-10.75 24-24c0-13.26-10.74-24-24-24zM90.69 69.17l-12.4-10.11c-3.49-2.85-8.75-2.31-11.51 1.25C23.65 116.12 0 185.28 0 256c0 70.74 23.65 139.88 66.75 195.65 2.76 3.57 8.01 4.1 11.51 1.25l12.4-10.11c3.36-2.73 3.84-7.58 1.19-11.01C53.2 381.66 32 319.54 32 256c0-63.53 21.2-125.65 59.88-175.82 2.65-3.43 2.17-8.28-1.19-11.01zm482.53-8.86c-2.76-3.57-8.01-4.1-11.51-1.25l-12.4 10.11c-3.36 2.73-3.83 7.58-1.19 11.01C586.8 130.35 608 192.47 608 256c0 63.54-21.2 125.66-59.85 175.79-2.64 3.43-2.17 8.27 1.19 11.01l12.4 10.11c3.49 2.85 8.75 2.31 11.51-1.25C616.35 395.88 640 326.74 640 256c0-70.72-23.65-139.88-66.78-195.69z"]
  },
      qf = {
    prefix: "fal",
    iconName: "envelope",
    icon: [512, 512, [], "f0e0", "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z"]
  },
      Jf = {
    prefix: "fal",
    iconName: "envelope-open",
    icon: [512, 512, [], "f2b6", "M349.32 52.26C328.278 35.495 292.938 0 256 0c-36.665 0-71.446 34.769-93.31 52.26-34.586 27.455-109.525 87.898-145.097 117.015A47.99 47.99 0 0 0 0 206.416V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V206.413a47.989 47.989 0 0 0-17.597-37.144C458.832 140.157 383.906 79.715 349.32 52.26zM464 480H48c-8.837 0-16-7.163-16-16V206.161c0-4.806 2.155-9.353 5.878-12.392C64.16 172.315 159.658 95.526 182.59 77.32 200.211 63.27 232.317 32 256 32c23.686 0 55.789 31.27 73.41 45.32 22.932 18.207 118.436 95.008 144.714 116.468a15.99 15.99 0 0 1 5.876 12.39V464c0 8.837-7.163 16-16 16zm-8.753-216.312c4.189 5.156 3.393 12.732-1.776 16.905-22.827 18.426-55.135 44.236-104.156 83.148-21.045 16.8-56.871 52.518-93.318 52.258-36.58.264-72.826-35.908-93.318-52.263-49.015-38.908-81.321-64.716-104.149-83.143-5.169-4.173-5.966-11.749-1.776-16.905l5.047-6.212c4.169-5.131 11.704-5.925 16.848-1.772 22.763 18.376 55.014 44.143 103.938 82.978 16.85 13.437 50.201 45.69 73.413 45.315 23.219.371 56.562-31.877 73.413-45.315 48.929-38.839 81.178-64.605 103.938-82.978 5.145-4.153 12.679-3.359 16.848 1.772l5.048 6.212z"]
  },
      Kf = {
    prefix: "fal",
    iconName: "envelope-open-dollar",
    icon: [512, 512, [], "f657", "M494.59 164.52c-1.98-1.63-22.19-17.91-46.59-37.53V96c0-17.67-14.33-32-32-32h-46.47c-4.13-3.31-7.71-6.16-10.2-8.14C337.23 38.19 299.44 0 256 0c-43.21 0-80.64 37.72-103.34 55.86-2.53 2.01-6.1 4.87-10.2 8.14H96c-17.67 0-32 14.33-32 32v30.98c-24.52 19.71-44.75 36.01-46.48 37.43A48.002 48.002 0 0 0 0 201.48V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.51c0-14.31-6.38-27.88-17.41-36.99zM256 32c21.77 0 44.64 16.72 63.14 32H192.9c18.53-15.27 41.42-32 63.1-32zM96 96h320v173.35c-32.33 26-65.3 52.44-86.59 69.34-16.85 13.43-50.19 45.68-73.41 45.31-23.21.38-56.56-31.88-73.41-45.32-21.29-16.9-54.24-43.33-86.59-69.34V96zM32 201.48c0-4.8 2.13-9.31 5.84-12.36 1.24-1.02 11.62-9.38 26.16-21.08v75.55c-11.53-9.28-22.51-18.13-32-25.78v-16.33zM480 464c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16V258.91c42.75 34.44 99.31 79.92 130.68 104.82 20.49 16.36 56.74 52.53 93.32 52.26 36.45.26 72.27-35.46 93.31-52.26C380.72 338.8 437.24 293.34 480 258.9V464zm0-246.19c-9.62 7.75-20.27 16.34-32 25.79v-75.54c14.44 11.62 24.8 19.97 26.2 21.12 3.69 3.05 5.8 7.54 5.8 12.33v16.3zm-251.09 22.77l45 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.11c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V328c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.62-.63 42.67-20.54 42.67-45.07 0-19.97-12.98-37.81-31.58-43.39l-45-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V136c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.62.63-42.67 20.55-42.67 45.07 0 19.97 12.98 37.81 31.58 43.39z"]
  },
      Xf = {
    prefix: "fal",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", "M352 248v-16c0-4.42-3.58-8-8-8H168c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h176c4.42 0 8-3.58 8-8zm-184-56h176c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H168c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm326.59-27.48c-1.98-1.63-22.19-17.91-46.59-37.53V96c0-17.67-14.33-32-32-32h-46.47c-4.13-3.31-7.71-6.16-10.2-8.14C337.23 38.19 299.44 0 256 0c-43.21 0-80.64 37.72-103.34 55.86-2.53 2.01-6.1 4.87-10.2 8.14H96c-17.67 0-32 14.33-32 32v30.98c-24.52 19.71-44.75 36.01-46.48 37.43A48.002 48.002 0 0 0 0 201.48V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.51c0-14.31-6.38-27.88-17.41-36.99zM256 32c21.77 0 44.64 16.72 63.14 32H192.9c18.53-15.27 41.42-32 63.1-32zM96 96h320v173.35c-32.33 26-65.3 52.44-86.59 69.34-16.85 13.43-50.19 45.68-73.41 45.31-23.21.38-56.56-31.88-73.41-45.32-21.29-16.9-54.24-43.33-86.59-69.34V96zM32 201.48c0-4.8 2.13-9.31 5.84-12.36 1.24-1.02 11.62-9.38 26.16-21.08v75.55c-11.53-9.28-22.51-18.13-32-25.78v-16.33zM480 464c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16V258.91c42.75 34.44 99.31 79.92 130.68 104.82 20.49 16.36 56.74 52.53 93.32 52.26 36.45.26 72.27-35.46 93.31-52.26C380.72 338.8 437.24 293.34 480 258.9V464zm0-246.19c-9.62 7.75-20.27 16.34-32 25.79v-75.54c14.44 11.62 24.8 19.97 26.2 21.12 3.69 3.05 5.8 7.54 5.8 12.33v16.3z"]
  },
      _f = {
    prefix: "fal",
    iconName: "envelope-square",
    icon: [448, 512, [], "f199", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm16 400c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h352c8.822 0 16 7.178 16 16v352zm-64-304H96c-17.673 0-32 14.327-32 32v192c0 17.673 14.327 32 32 32h256c17.673 0 32-14.327 32-32V160c0-17.673-14.327-32-32-32zm0 32v33.855c-14.136 11.628-36.566 29.664-82.117 65.821C259.426 268.015 238.748 288 224.256 288l-.256-.002-.256.002c-14.492 0-35.17-19.984-45.628-28.324-45.544-36.152-67.978-54.192-82.117-65.822V160H352zM96 352V235.092c14.109 11.367 33.624 26.948 62.221 49.648 13.777 11.01 37.902 35.26 65.523 35.26l.253-.001.258.001c27.529 0 51.392-23.975 65.541-35.274 28.583-22.689 48.099-38.27 62.203-49.634V352H96z"]
  },
      $f = {
    prefix: "fal",
    iconName: "equals",
    icon: [384, 512, [], "f52c", "M376 304H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8zm0-144H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"]
  },
      cs = {
    prefix: "fal",
    iconName: "eraser",
    icon: [512, 512, [], "f12d", "M497.94 273.94a48 48 0 0 0 0-67.88l-160-160a48 48 0 0 0-67.88 0l-256 256a48 48 0 0 0 0 67.88l96 96A48 48 0 0 0 144 480h356a12 12 0 0 0 12-12v-8a12 12 0 0 0-12-12H323.88l174.06-174.06zM292.69 68.69a16 16 0 0 1 22.62 0l160 160a16 16 0 0 1 0 22.62L358.63 368 176 185.37zM144 448a15.88 15.88 0 0 1-11.31-4.69l-96-96a16 16 0 0 1 0-22.62L153.37 208 336 390.63l-52.69 52.68A15.88 15.88 0 0 1 272 448z"]
  },
      es = {
    prefix: "fal",
    iconName: "ethernet",
    icon: [512, 512, [], "f796", "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16zm-16 224h-64V288h-32v128h-64V288h-32v128h-64V288h-32v128h-64V288H96v128H32V224h64v-64h64V96h192v64h64v64h64v192z"]
  },
      as = {
    prefix: "fal",
    iconName: "euro-sign",
    icon: [320, 512, [], "f153", "M303.625 444.131c-1.543-6.481-8.063-10.445-14.538-8.874-10.014 2.43-25.689 5.304-43.827 5.304-80.726 0-141.733-46.614-160.837-120.561h155.241a12 12 0 0 0 11.784-9.731l1.541-8c1.425-7.402-4.246-14.269-11.784-14.269H77.646c-1.849-20.951-1.849-43.664.616-64h178.657a12 12 0 0 0 11.784-9.731l1.541-8c1.425-7.402-4.246-14.269-11.784-14.269H85.04c20.951-70.25 80.111-120.561 159.604-120.561 14.725 0 28.452 2.194 37.551 4.086 6.282 1.306 12.47-2.581 14.05-8.799l3.93-15.475c1.689-6.652-2.529-13.383-9.262-14.718C280.423 34.452 264.068 32 245.26 32 143.582 32 63.472 100.181 39.439 192H12c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h21.893c-2.466 17.87-1.849 49.827-.617 64H12c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h26.207c21.568 96.749 101.678 160 207.053 160 22.511 0 41.595-3.426 53.081-6.106 6.47-1.51 10.465-7.999 8.926-14.462l-3.642-15.301z"]
  },
      ns = {
    prefix: "fal",
    iconName: "exchange",
    icon: [512, 512, [], "f0ec", "M508.485 184.485l-92.485 92c-4.687 4.686-12.284 4.686-16.97 0l-7.071-7.07c-4.687-4.686-4.687-12.284 0-16.971L452.893 192H12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h440.905l-60.946-60.444c-4.687-4.686-4.687-12.284 0-16.971l7.07-7.07c4.687-4.686 12.284-4.686 16.971 0l92.485 92c4.687 4.686 4.686 12.284 0 16.97zm-504.97 160l92.485 92c4.687 4.686 12.284 4.686 16.971 0l7.07-7.07c4.687-4.686 4.687-12.284 0-16.971L59.095 352H500c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12H59.107l60.934-60.444c4.687-4.686 4.687-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.687-16.97 0l-92.485 92c-4.686 4.686-4.687 12.284 0 16.97z"]
  },
      ts = {
    prefix: "fal",
    iconName: "exchange-alt",
    icon: [512, 512, [], "f362", "M12 192h372v56c0 29.552 36.528 43.072 55.917 21.26l64-72c10.777-12.124 10.777-30.395 0-42.519l-64-72C420.535 60.936 384 74.436 384 104v56H12c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12zm404-88l64 72-64 72V104zm84 216H128v-56c0-29.552-36.528-43.072-55.917-21.26l-64 72c-10.777 12.124-10.777 30.395 0 42.519l64 72C91.465 451.064 128 437.564 128 408v-56h372c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12zM96 408l-64-72 64-72v144z"]
  },
      rs = {
    prefix: "fal",
    iconName: "exclamation",
    icon: [192, 512, [], "f12a", "M139.315 32c6.889 0 12.364 5.787 11.982 12.666l-14.667 264c-.353 6.359-5.613 11.334-11.982 11.334H67.352c-6.369 0-11.628-4.975-11.982-11.334l-14.667-264C40.321 37.787 45.796 32 52.685 32h86.63M96 352c35.29 0 64 28.71 64 64s-28.71 64-64 64-64-28.71-64-64 28.71-64 64-64M139.315 0h-86.63C27.457 0 7.353 21.246 8.753 46.441l14.667 264c.652 11.728 5.864 22.178 13.854 29.665C14.613 357.682 0 385.168 0 416c0 52.935 43.065 96 96 96s96-43.065 96-96c0-30.832-14.613-58.318-37.274-75.894 7.991-7.487 13.203-17.937 13.854-29.665l14.667-264C184.647 21.251 164.548 0 139.315 0z"]
  },
      is = {
    prefix: "fal",
    iconName: "exclamation-circle",
    icon: [512, 512, [], "f06a", "M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"]
  },
      os = {
    prefix: "fal",
    iconName: "exclamation-square",
    icon: [448, 512, [], "f321", "M219.5 320h9c6.4 0 11.7-5.1 12-11.5l7-168c.3-6.8-5.2-12.5-12-12.5h-23c-6.8 0-12.3 5.7-12 12.5l7 168c.3 6.4 5.6 11.5 12 11.5zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16zm-192-92c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28z"]
  },
      ls = {
    prefix: "fal",
    iconName: "exclamation-triangle",
    icon: [576, 512, [], "f071", "M270.2 160h35.5c3.4 0 6.1 2.8 6 6.2l-7.5 196c-.1 3.2-2.8 5.8-6 5.8h-20.5c-3.2 0-5.9-2.5-6-5.8l-7.5-196c-.1-3.4 2.6-6.2 6-6.2zM288 388c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zm281.5 52L329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.8 0 60-40 41.5-72zM528 480H48c-12.3 0-20-13.3-13.9-24l240-416c6.1-10.6 21.6-10.7 27.7 0l240 416c6.2 10.6-1.5 24-13.8 24z"]
  },
      fs = {
    prefix: "fal",
    iconName: "expand",
    icon: [448, 512, [], "f065", "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H32v116c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12zM300 32h124c13.3 0 24 10.7 24 24v124c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12V64H300c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12zm148 300v124c0 13.3-10.7 24-24 24H300c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h116V332c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12zM148 480H24c-13.3 0-24-10.7-24-24V332c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v116h116c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12z"]
  },
      ss = {
    prefix: "fal",
    iconName: "expand-alt",
    icon: [448, 512, [], "f424", "M198.829 275.515l5.656 5.656c4.686 4.686 4.686 12.284 0 16.971L54.627 448H116c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12H12c-6.627 0-12-5.373-12-12V364c0-6.627 5.373-12 12-12h8c6.627 0 12 5.373 12 12v61.373l149.858-149.858c4.687-4.687 12.285-4.687 16.971 0zM436 32H332c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h61.373L243.515 213.858c-4.686 4.686-4.686 12.284 0 16.971l5.656 5.656c4.686 4.686 12.284 4.686 16.971 0L416 86.627V148c0 6.627 5.373 12 12 12h8c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12z"]
  },
      us = {
    prefix: "fal",
    iconName: "expand-arrows",
    icon: [448, 512, [], "f31d", "M447.7 364l.3 104c0 6.6-5.4 12-12 12l-104-.3c-6.6 0-12-5.4-12-12v-10c0-6.6 5.4-12 12-12l58 .3.7-.7L224 278.6 57.3 445.3l.7.7 58-.3c6.6 0 12 5.4 12 12v10c0 6.6-5.4 12-12 12L12 480c-6.6 0-12-5.4-12-12l.3-104c0-6.6 5.4-12 12-12h10c6.6 0 12 5.4 12 12l-.3 58 .7.7L201.4 256 34.7 89.3l-.7.7.3 58c0 6.6-5.4 12-12 12h-10c-6.6 0-12-5.4-12-12L0 44c0-6.6 5.4-12 12-12l104 .3c6.6 0 12 5.4 12 12v10c0 6.6-5.4 12-12 12L58 66l-.7.7L224 233.4 390.7 66.7l-.7-.7-58 .3c-6.6 0-12-5.4-12-12v-10c0-6.6 5.4-12 12-12l104-.3c6.6 0 12 5.4 12 12l-.3 104c0 6.6-5.4 12-12 12h-10c-6.6 0-12-5.4-12-12l.3-58-.7-.7L246.6 256l166.7 166.7.7-.7-.3-58c0-6.6 5.4-12 12-12h10c6.6 0 12 5.4 12 12z"]
  },
      hs = {
    prefix: "fal",
    iconName: "expand-arrows-alt",
    icon: [448, 512, [], "f31e", "M391.7 329.7L356 365.4 246.6 256 356 146.6l35.7 35.7c20.7 20.7 56.3 6 56.3-23.3V65c0-18.2-14.8-33-33-33h-94c-29.3 0-44.1 35.5-23.3 56.3l35.7 35.7L224 233.4 114.6 124l35.7-35.7C171 67.6 156.3 32 127 32H33C14.8 32 0 46.8 0 65v94c0 29.3 35.5 44.1 56.3 23.3L92 146.6 201.4 256 92 365.4l-35.7-35.7C35.6 309 0 323.7 0 353v94c0 18.2 14.8 33 33 33h94c29.3 0 44.1-35.5 23.3-56.3L114.6 388 224 278.6 333.4 388l-35.7 35.7c-20.7 20.7-6 56.3 23.3 56.3h94c18.2 0 33-14.8 33-33v-94c0-29.3-35.6-44.1-56.3-23.3zM321 60.9h94c2.3 0 4.1 1.9 4.1 4.1v94c0 3.7-4.4 5.5-7 2.9l-94-94c-2.6-2.6-.8-7 2.9-7zm-285.1 101c-2.6 2.6-7 .8-7-2.9V65c0-2.3 1.9-4.1 4.1-4.1h94c3.7 0 5.5 4.4 2.9 7l-94 94zM127 451.1H33c-2.3 0-4.1-1.9-4.1-4.1v-94c0-3.7 4.4-5.5 7-2.9l94 94c2.6 2.6.8 7-2.9 7zm288 0h-94c-3.7 0-5.5-4.4-2.9-7l94-94c2.6-2.6 7-.8 7 2.9v94c.1 2.3-1.8 4.1-4.1 4.1z"]
  },
      ms = {
    prefix: "fal",
    iconName: "expand-wide",
    icon: [512, 512, [], "f320", "M0 212V88c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H32v116c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12zM364 64h124c13.3 0 24 10.7 24 24v124c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12V96H364c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12zm148 236v124c0 13.3-10.7 24-24 24H364c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h116V300c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12zM148 448H24c-13.3 0-24-10.7-24-24V300c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v116h116c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12z"]
  },
      vs = {
    prefix: "fal",
    iconName: "external-link",
    icon: [512, 512, [], "f08e", "M440,256H424a8,8,0,0,0-8,8V464a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V112A16,16,0,0,1,48,96H248a8,8,0,0,0,8-8V72a8,8,0,0,0-8-8H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V264A8,8,0,0,0,440,256ZM500,0,364,.34a12,12,0,0,0-12,12v10a12,12,0,0,0,12,12L454,34l.7.71L131.51,357.86a12,12,0,0,0,0,17l5.66,5.66a12,12,0,0,0,17,0L477.29,57.34l.71.7-.34,90a12,12,0,0,0,12,12h10a12,12,0,0,0,12-12L512,12A12,12,0,0,0,500,0Z"]
  },
      ds = {
    prefix: "fal",
    iconName: "external-link-alt",
    icon: [512, 512, [], "f35d", "M440,256H424a8,8,0,0,0-8,8V464a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V112A16,16,0,0,1,48,96H248a8,8,0,0,0,8-8V72a8,8,0,0,0-8-8H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V264A8,8,0,0,0,440,256ZM480,0h-.06L383.78.17c-28.45,0-42.66,34.54-22.58,54.62l35.28,35.28-265,265a12,12,0,0,0,0,17l8.49,8.49a12,12,0,0,0,17,0l265-265,35.28,35.27c20,20,54.57,6,54.62-22.57L512,32.05A32,32,0,0,0,480,0Zm-.17,128.17-96-96L480,32Z"]
  },
      Ms = {
    prefix: "fal",
    iconName: "external-link-square",
    icon: [448, 512, [], "f14c", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm16 400c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h352c8.822 0 16 7.178 16 16v352zM99.515 374.828c-4.686-4.686-4.686-12.284 0-16.971l195.15-195.15-.707-.707-89.958.342c-6.627 0-12-5.373-12-12v-9.999c0-6.628 5.372-12 12-12L340 128c6.627 0 12 5.372 12 12l-.343 136c0 6.627-5.373 12-12 12h-9.999c-6.627 0-12-5.373-12-12l.342-89.958-.707-.707-195.15 195.15c-4.686 4.686-12.284 4.686-16.971 0l-5.657-5.657z"]
  },
      ps = {
    prefix: "fal",
    iconName: "external-link-square-alt",
    icon: [448, 512, [], "f360", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm16 400c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h352c8.822 0 16 7.178 16 16v352zm-96-304h-.056l-96.167.167c-28.442.049-42.66 34.539-22.572 54.627l35.272 35.272L98.545 356c-4.686 4.686-4.686 12.284 0 16.97l8.484 8.485c4.687 4.686 12.285 4.686 16.971 0l137.934-137.934 35.272 35.272c20.023 20.023 54.578 5.98 54.627-22.572l.167-96.166c.03-17.702-14.325-32.055-32-32.055zm-.167 128.167l-96-96L320 160l-.167 96.167z"]
  },
      zs = {
    prefix: "fal",
    iconName: "eye",
    icon: [576, 512, [], "f06e", "M288 288a64 64 0 0 0 0-128c-1 0-1.88.24-2.85.29a47.5 47.5 0 0 1-60.86 60.86c0 1-.29 1.88-.29 2.85a64 64 0 0 0 64 64zm284.52-46.6C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 96a128 128 0 1 1-128 128A128.14 128.14 0 0 1 288 96zm0 320c-107.36 0-205.46-61.31-256-160a294.78 294.78 0 0 1 129.78-129.33C140.91 153.69 128 187.17 128 224a160 160 0 0 0 320 0c0-36.83-12.91-70.31-33.78-97.33A294.78 294.78 0 0 1 544 256c-50.53 98.69-148.64 160-256 160z"]
  },
      Cs = {
    prefix: "fal",
    iconName: "eye-dropper",
    icon: [512, 512, [], "f1fb", "M483.61 26.62c-35.51-35.65-92.84-35.33-128.04 0l-82.63 82.94-17-17.06c-9.37-9.41-24.57-9.41-33.95 0l-40.98 41.14c-9.37 9.41-9.38 24.67 0 34.08l16.98 17.05-147.3 149.84a64.38 64.38 0 0 0-18.76 45.44v33.74l-27 39.79c-7.98 12.7-6.13 29.25 4.44 39.86l9.11 9.14c10.57 10.61 27.06 12.46 39.71 4.46l39.65-27.1h33.62a63.91 63.91 0 0 0 45.27-18.82l149.31-147.85L343 330.31c9.38 9.41 24.58 9.41 33.95 0l40.98-41.14c9.38-9.41 9.37-24.67 0-34.08l-16.95-17.02 82.63-82.94c29.67-29.77 45.24-83.1 0-128.51zM154.09 440.41c-6.05 6.07-14.08 7.41-22.63 7.41H88.59l-47.47 32.05-9.11-9.14 31.94-47.65v-43.03c0-8.58 3.33-16.65 9.38-22.72l147.3-149.85 82.77 83.08-149.31 149.85zm306.89-307.99L355.71 238.07l33.93 34.06-29.67 29.78L209.3 150.67l29.67-29.77 33.97 34.1L378.21 49.34c22.82-22.91 59.95-22.91 82.77 0 39.39 39.53 6.91 76.14 0 83.08z"]
  },
      Ls = {
    prefix: "fal",
    iconName: "eye-evil",
    icon: [640, 512, [], "f6db", "M627.03 239.08L514.87 208.7c-4.74-6.5-10.02-13.27-15.92-20.25 1.37-2.11 55.26-88.1 55.26-88.1 8.9-14.26-6.04-31.37-22.45-25.42l-119.65 43.32c-9.73-4.86-20.03-9.01-30.84-12.44l-44.39-95.07C333.54 3.58 326.77 0 320 0s-13.54 3.58-16.88 10.73l-44.39 95.07c-10.81 3.43-21.11 7.58-30.84 12.44C98.03 71.23 106.35 73.72 101.5 73.72c-13.37 0-23.41 14.32-15.72 26.63 0 0 53.89 86 55.26 88.1-5.9 6.98-11.18 13.75-15.92 20.25L12.97 239.08c-17.29 4.68-17.29 29.15 0 33.84l112.16 30.38c4.72 6.48 9.98 13.22 15.86 20.18-1.37 2.13-55.2 88.17-55.2 88.17-8.93 14.31 6.07 31.35 22.45 25.43l119.65-43.32c9.73 4.86 20.04 9.01 30.85 12.44l44.39 95.07c3.33 7.15 10.1 10.73 16.87 10.73s13.54-3.58 16.88-10.73l44.39-95.07c10.81-3.43 21.11-7.58 30.85-12.44l119.65 43.32c16.42 5.95 31.35-11.16 22.45-25.43 0 0-53.83-86.04-55.2-88.17 5.88-6.96 11.13-13.7 15.86-20.18l112.16-30.38c17.28-4.69 17.28-29.15-.01-33.84zm-131.39 36.27c-14.98 20.55-12.65 17.51-36.32 45.52l45.78 72.51-95-34.39c-24.77 12.38-24.11 12.13-51.89 20.95L320 461.78l-38.21-81.84c-27.76-8.81-27.08-8.56-51.89-20.95l-95 34.39 45.78-72.51c-23.7-28.04-21.34-24.96-36.32-45.52L72.91 256l71.45-19.35c14.93-20.48 12.55-17.39 36.49-45.72l-45.95-72.32 95 34.4c24.69-12.33 24-12.1 51.88-20.96L320 50.22l38.21 81.84c27.82 8.84 27.08 8.57 51.88 20.96l95-34.4-45.95 72.32c23.84 28.21 21.47 25.12 36.49 45.72L567.09 256l-71.45 19.35zM320 213.33c-32.82 0-62.7-8.79-86.45-23.09C222.48 206.77 216 226.62 216 248c0 57.44 46.56 104 104 104s104-46.56 104-104c0-21.38-6.48-41.23-17.55-57.75-23.75 14.29-53.63 23.08-86.45 23.08zM320 320c-39.7 0-72-32.3-72-72 0-5.03.52-10 1.54-14.85 12.42 4.53 25.52 7.48 38.91 9.5-.08.94-.45 1.71-.45 2.69 0 28.45 32 42.67 32 42.67s32-14.22 32-42.67c0-.97-.38-1.75-.45-2.69 13.39-2.01 26.49-4.97 38.91-9.5C391.48 238 392 242.97 392 248c0 39.7-32.3 72-72 72z"]
  },
      As = {
    prefix: "fal",
    iconName: "eye-slash",
    icon: [640, 512, [], "f070", "M637 485.25L23 1.75A8 8 0 0 0 11.76 3l-10 12.51A8 8 0 0 0 3 26.75l614 483.5a8 8 0 0 0 11.25-1.25l10-12.51a8 8 0 0 0-1.25-11.24zM320 96a128.14 128.14 0 0 1 128 128c0 21.62-5.9 41.69-15.4 59.57l25.45 20C471.65 280.09 480 253.14 480 224c0-36.83-12.91-70.31-33.78-97.33A294.88 294.88 0 0 1 576.05 256a299.73 299.73 0 0 1-67.77 87.16l25.32 19.94c28.47-26.28 52.87-57.26 70.93-92.51a32.35 32.35 0 0 0 0-29.19C550.3 135.59 442.94 64 320 64a311.23 311.23 0 0 0-130.12 28.43l45.77 36C258.24 108.52 287.56 96 320 96zm60.86 146.83A63.15 63.15 0 0 0 320 160c-1 0-1.89.24-2.85.29a45.11 45.11 0 0 1-.24 32.19zm-217.62-49.16A154.29 154.29 0 0 0 160 224a159.39 159.39 0 0 0 226.27 145.29L356.69 346c-11.7 3.53-23.85 6-36.68 6A128.15 128.15 0 0 1 192 224c0-2.44.59-4.72.72-7.12zM320 416c-107.36 0-205.47-61.31-256-160 17.43-34 41.09-62.72 68.31-86.72l-25.86-20.37c-28.48 26.28-52.87 57.25-70.93 92.5a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448a311.25 311.25 0 0 0 130.12-28.43l-29.25-23C389.06 408.84 355.15 416 320 416z"]
  },
      Ns = {
    prefix: "fal",
    iconName: "fan",
    icon: [512, 512, [], "f863", "M346.54 120a238.17 238.17 0 0 0-53.94 6l9.24-91.74A30.93 30.93 0 0 0 294 10.41 31.73 31.73 0 0 0 270.51 0a31.94 31.94 0 0 0-4 .25C183 10.72 120 81.75 120 165.47a238.24 238.24 0 0 0 6 53.94l-91.74-9.25-.8-.08-2.35-.08a31 31 0 0 0-23.19 10.52 31.76 31.76 0 0 0-7.67 25C10.72 329 81.75 392 165.46 392a238.11 238.11 0 0 0 53.94-6l-9.24 91.74a30.92 30.92 0 0 0 7.84 23.85 31.78 31.78 0 0 0 27.5 10.16C329 501.28 392 430.25 392 346.53a238.15 238.15 0 0 0-6-53.93l91.74 9.24.8.08 2.33.08a31 31 0 0 0 23.19-10.51 31.79 31.79 0 0 0 7.67-25C501.28 183 430.25 120 346.54 120zm19 138.37l-25.33-2.55 8.69 23.93c7.37 20.25 11.1 42.76 11.1 66.78 0 67.62-50.94 125-118 134.43l11.63-115.41 2.55-25.33-23.93 8.69C212 356.27 189.49 360 165.46 360 97.85 360 40.47 309.06 31 242l115.42 11.63 25.33 2.55-8.69-23.93C155.73 212 152 189.49 152 165.47c0-67.42 50.64-124.66 117.9-133.39l-11.53 114.37-2.55 25.33 23.93-8.68c20.25-7.37 42.76-11.1 66.79-11.1 67.61 0 125 50.94 134.43 118zM256 224a32 32 0 1 0 32 32 32 32 0 0 0-32-32z"]
  },
      gs = {
    prefix: "fal",
    iconName: "fan-table",
    icon: [448, 512, [], "e004", "M224,209.42A14.58,14.58,0,1,0,238.58,224,14.58,14.58,0,0,0,224,209.42ZM448,224C448,100.29,347.71,0,224,0S0,100.29,0,224C0,342.31,91.79,439,208,447.19V480H88a24,24,0,0,0-24,24,8,8,0,0,0,8,8H376a8,8,0,0,0,8-8,24,24,0,0,0-24-24H240V447.19C356.21,439,448,342.31,448,224ZM224,413.54c-104.51,0-189.54-85-189.54-189.54S119.49,34.46,224,34.46s189.54,85,189.54,189.54S328.51,413.54,224,413.54ZM383.21,243.33a101.68,101.68,0,0,0-140.28-94.15L222,93.23c-8-21.36-34.11-32.76-56-20.11a101.76,101.76,0,0,0-37.24,139,99.86,99.86,0,0,0,25.93,29.45l-38.1,46.28a39,39,0,0,0,10.69,58.59,101.54,101.54,0,0,0,50.64,13.61h0c28.88,0,66.61-13.37,88.27-50.9A99.43,99.43,0,0,0,278.68,272c12.35,2,31.56,5.23,59.13,9.83C358.83,285.33,383.21,269.94,383.21,243.33Zm-39.65,6.94c-1.62,0-76.85-12.91-78.95-12.91-.12,0-.05,0-.19,0-10,0-17.43,8.59-17,18.47a68.27,68.27,0,0,1-9,37.3c-19.49,33.76-54.1,34.9-59.81,34.9a69.57,69.57,0,0,1-35.48-9.38,7,7,0,0,1-1.91-10.49l49-59.48c7.82-9.5,2.77-21.62-5.83-26.06a68.35,68.35,0,0,1-28-26.54,69.75,69.75,0,0,1,25.53-95.27A7,7,0,0,1,192,104.45l27,72a16.94,16.94,0,0,0,25.2,8,69.67,69.67,0,0,1,107,58.9C351.21,247,348.63,250.27,343.56,250.27Z"]
  },
      Hs = {
    prefix: "fal",
    iconName: "farm",
    icon: [576, 512, [], "f864", "M154.71 192l16-32H32v-43.28c0-41.84 30-80 71.64-84.29A80.09 80.09 0 0 1 192 112v6.56a63.81 63.81 0 0 1 28.7-26.95c-11-49-51.24-88.76-102.68-91.45A112 112 0 0 0 0 112v384a16 16 0 0 0 16 16h112v-32H32V192zM408 224h-80a8 8 0 0 0-8 8v80a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-80a8 8 0 0 0-8-8zm-24 64h-32v-32h32zm188.62-41.78l-55.49-111a32.05 32.05 0 0 0-15.62-14.93L381 66.76a32 32 0 0 0-26 0l-120.51 53.56c-6.69 3-13.47 10.62-15.62 14.93l-55.49 111a32.08 32.08 0 0 0-3.38 14.29V496a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-80h96v80a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V260.54a32.08 32.08 0 0 0-3.38-14.32zM544 480h-96v-80a16 16 0 0 0-16-16H304a16 16 0 0 0-16 16v80h-96V260.54l55.49-111L368 96l120.51 53.56 55.49 111z"]
  },
      Vs = {
    prefix: "fal",
    iconName: "fast-backward",
    icon: [512, 512, [], "f049", "M12 447h8c6.6 0 12-5.4 12-12V277.3c.9 1 1.9 2 3 2.9l200.5 159.4c20.6 17.2 52.5 2.8 52.5-24.6V297.2l171.5 142.4c20.6 17.2 52.5 2.8 52.5-24.6V95c0-27.4-31.9-41.8-52.5-24.6L288 213.9V95.1c0-27.4-31.9-41.8-52.5-24.6L35 231c-1.1.9-2.1 1.9-3 2.9V75c0-6.6-5.4-12-12-12h-8C5.4 63 0 68.4 0 75v360c0 6.6 5.4 12 12 12zm280.5-191.4l.2-.1.2-.1L480 95v320L292.7 255.8l-.1-.1-.1-.1zM61 255.2l194.8-160 .1-.1.1-.1v320l-.1-.1-.1-.1L61 256v-.8z"]
  },
      xs = {
    prefix: "fal",
    iconName: "fast-forward",
    icon: [512, 512, [], "f050", "M500 63h-8c-6.6 0-12 5.4-12 12v157.7c-.9-1-1.9-2-3-2.9L276.5 70.4C255.9 53.3 224 67.6 224 95v117.8L52.5 70.4C31.9 53.3 0 67.6 0 95v320c0 27.4 31.9 41.8 52.5 24.6L224 296.2V415c0 27.4 31.9 41.8 52.5 24.6L477 279c1.1-.9 2.1-1.9 3-2.9V435c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V75c0-6.6-5.4-12-12-12zM219.5 254.4l-.2.1-.2.1L32 415V95l187.3 159.2.1.1.1.1zm231.5.5l-194.8 160-.1.1h-.1V95l.1.1.1.1L451 254v.9z"]
  },
      ws = {
    prefix: "fal",
    iconName: "faucet",
    icon: [512, 512, [], "e005", "M368,240H307.71A127.34,127.34,0,0,0,224,193.23V178.75l-16-1.69-16,1.69v14.48A127.34,127.34,0,0,0,108.29,240H8a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H125.31C142,243.43,172.56,224,208,224s66.05,19.43,82.69,48H368A112.14,112.14,0,0,1,480,384v32H384V384a16,16,0,0,0-16-16H290.69c-16.64,28.57-47.25,48-82.69,48S142,396.57,125.31,368H8a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H108.29a127.56,127.56,0,0,0,199.42,0H352v16a32,32,0,0,0,32,32h96a32,32,0,0,0,32-32V384C512,304.6,447.4,240,368,240ZM65.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.8L224,109.43V72a8,8,0,0,0-8-8H200a8,8,0,0,0-8,8v37.43L65.59,96.09c-9.42-1-17.59,6.81-17.59,16.8v30.22C48,153.1,56.17,160.91,65.59,159.91Z"]
  },
      ys = {
    prefix: "fal",
    iconName: "faucet-drip",
    icon: [512, 512, [], "e006", "M65.59,95.91,208,80.88l142.41,15c9.42,1,17.59-6.81,17.59-16.8V48.89c0-10-8.17-17.8-17.59-16.8L224,45.43V8a8,8,0,0,0-8-8H200a8,8,0,0,0-8,8V45.43L65.59,32.09C56.17,31.09,48,38.9,48,48.89V79.11C48,89.1,56.17,96.91,65.59,95.91ZM368,176H307.71A127.34,127.34,0,0,0,224,129.23V114.75l-16-1.69-16,1.69v14.48A127.34,127.34,0,0,0,108.29,176H8a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H125.31C142,179.43,172.56,160,208,160s66.05,19.43,82.69,48H368A112.14,112.14,0,0,1,480,320v32H384V320a16,16,0,0,0-16-16H290.69c-16.64,28.57-47.25,48-82.69,48S142,332.57,125.31,304H8a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H108.29a127.56,127.56,0,0,0,199.42,0H352v16a32,32,0,0,0,32,32h96a32,32,0,0,0,32-32V320C512,240.6,447.4,176,368,176Zm32,304a32,32,0,0,0,64,0c0-17.67-32-64-32-64S400,462.33,400,480Z"]
  },
      bs = {
    prefix: "fal",
    iconName: "fax",
    icon: [512, 512, [], "f1ac", "M392 304h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0 128h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zM80 128H48a48 48 0 0 0-48 48v288a48 48 0 0 0 48 48h32a48 48 0 0 0 48-48V176a48 48 0 0 0-48-48zm16 336a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V176a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm296-96h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-128 64h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0-64h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm216-205.06v-53.69a32 32 0 0 0-9.38-22.63L393.38 9.38A32 32 0 0 0 370.75 0H208a48 48 0 0 0-48 48v416a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48V208a47.87 47.87 0 0 0-32-45.06zM384 45.25L434.75 96H384zM192 48a16 16 0 0 1 16-16h144v64a32 32 0 0 0 32 32h64v64H192zm288 416a16 16 0 0 1-16 16H208a16 16 0 0 1-16-16V224h288zm-152-32h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0-64h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0-64h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-64 0h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8z"]
  },
      Ss = {
    prefix: "fal",
    iconName: "feather",
    icon: [512, 512, [], "f52d", "M467.11 44.89C438.25 16.03 401.61 0 361.61 0c-46.7 0-97.96 21.85-146.76 70.65l-85.74 85.74c-79.32 79.32-71.83 210.7-53.54 257.4L4.69 484.66A15.962 15.962 0 0 0 0 495.98C0 504.52 6.87 512 16.02 512c4.1 0 8.2-1.56 11.32-4.69l70.93-70.93c17.2 6.76 45.79 12.08 79.23 12.08 57.18 0 128.03-15.48 178.11-65.56l85.74-85.74c90.6-90.61 88.31-189.72 25.76-252.27zM151.76 179.04L237.5 93.3c40.08-40.08 83-61.27 124.11-61.27 30.97 0 59.62 12.28 82.85 35.51 42.32 42.32 45.75 100.1 13.13 156.69H310.42l37.24-37.24c6.26-6.26 6.26-16.39 0-22.65s-16.39-6.26-22.65 0L101.19 388.16c-9.9-43.33-13.3-145.26 50.57-209.12zm25.74 237.38c-23.3 0-40.97-2.79-53.49-5.79l58.75-58.75 158.19.37-7.99 7.99c-48.88 48.88-118.38 56.18-155.46 56.18zm195.38-96.09H214.32l64.07-64.07h156.34c-5.11 6.12-61.85 64.07-61.85 64.07z"]
  },
      Ts = {
    prefix: "fal",
    iconName: "feather-alt",
    icon: [512, 512, [], "f56b", "M71.46 287.61c-4.86 42.01-7.27 84.27-7.38 126.56l-.03 11.16-59.36 59.36A15.922 15.922 0 0 0 0 496c0 9.14 7.47 16 16 16 4.09 0 8.19-1.56 11.31-4.69l59.36-59.36 11.16-.03c42.29-.12 84.55-2.53 126.56-7.38C473.8 415.13 508.44 51.72 512 0 460.28 3.56 96.87 38.2 71.46 287.61zm31.83 3.24C122.75 99.86 374.98 48.66 476.23 35.77 470.56 80.23 457.47 153.8 428.4 224H310.62l36.69-36.69c6.25-6.25 6.25-16.38 0-22.62s-16.38-6.25-22.62 0L96.74 392.64c.75-34.17 2.68-68.26 6.55-101.79zM214.62 320l64-64h135.11c-11.37 22.73-24.86 44.31-40.38 64H214.62zm6.1 88.75c-33.16 3.83-67.2 5.76-101.36 6.51L182.62 352h161.44c-32.76 30.25-73.12 51.63-123.34 56.75z"]
  },
      Ds = {
    prefix: "fal",
    iconName: "female",
    icon: [256, 512, [], "f182", "M254.648 340.891l-39.909-164.276a48.18 48.18 0 0 0-16.794-26.583 47.458 47.458 0 0 0-4.554-3.208C207.438 131.225 216 110.594 216 88c0-48.523-39.477-88-88-88S40 39.477 40 88c0 22.594 8.562 43.225 22.609 58.824a47.405 47.405 0 0 0-4.554 3.208 48.184 48.184 0 0 0-16.794 26.583L1.352 340.891C-5.868 370.559 16.716 400 48.047 400H61v59c0 29.224 23.776 53 53 53h28c29.224 0 53-23.776 53-53v-59h12.952c31.329 0 53.917-29.436 46.696-59.109zM128 32c30.928 0 56 25.072 56 56s-25.072 56-56 56-56-25.072-56-56 25.072-56 56-56zm80 336h-45v91c0 11.598-9.402 21-21 21h-28c-11.598 0-21-9.402-21-21v-91H48c-10.259 0-17.877-9.539-15.602-19.546l40-164.454A16 16 0 0 1 88 171.546h12.351a88.015 88.015 0 0 0 55.299 0H168A16 16 0 0 1 183.602 184l40 164.454C225.876 358.458 218.262 368 208 368z"]
  },
      js = {
    prefix: "fal",
    iconName: "field-hockey",
    icon: [640, 512, [], "f44c", "M619.5 117.2L563.8 173 496 105.2l84.6-84.7c7.6-7.6 2.2-20.5-8.5-20.5h-11.3c-3.2 0-6.2 1.3-8.5 3.5L214.4 341.8c-29.4 29.5-75.5-14.8-45.2-45.2 31.2-31.2 31.2-81.9 0-113.1-31.2-31.2-81.7-31.3-113 0C19.9 219.7 0 267.9 0 319.2c0 106.5 86.1 191.9 191.8 191.9 89.4 0 134-54.5 164.1-84.7 12.3 50.4 58.4 87.7 113 85.5 57.9-2.3 104.8-49.3 107.2-107.3 2.2-54.6-35-100.8-85.4-113.1l145.9-146c2.2-2.3 3.5-5.3 3.5-8.5v-11.3c-.1-10.7-13-16.1-20.6-8.5zM191.8 479.1C103 479.1 32 407.3 32 319.2c0-42.8 16.6-82.9 46.8-113.2 18.7-18.8 49-18.8 67.8 0 18.7 18.7 18.7 49.2 0 67.9-24.9 24.9-24.9 65.5.1 90.6 25 24.9 65.5 24.9 90.3-.1l236.4-236.7 67.8 67.9-93.9 94.1c-48 7.4-85.7 45.2-93.1 93.2-50.1 50.2-84.5 96.2-162.4 96.2zM544.1 400c0 44.1-35.8 80-79.9 80s-79.9-35.9-79.9-80 35.8-80 79.9-80 79.9 35.9 79.9 80z"]
  },
      Es = {
    prefix: "fal",
    iconName: "fighter-jet",
    icon: [640, 512, [], "f0fb", "M526.785 195.932l-102.96-11.267L382.163 168H367.31L283.183 63.609C304.102 62.027 320 55.759 320 48c0-9-21.383-16-47.189-16H144v32h16v120h-1.63l-64-72H36.462L8 140.11v67.647l-8 .988v94.511l8 .988v67.647L36.462 400H94.37l64-72H160v120h-16v32h128.811c25.806 0 47.189-7 47.189-16 0-7.759-15.898-14.027-36.817-15.609L367.31 344h14.853l41.663-16.665 102.96-11.267C598.984 300.222 640 293.159 640 256c0-37.458-41.863-44.407-113.215-60.068zm-5.185 88.512L416 296l-40 16h-24L242.4 448H192V296h-48l-64 72H49.6l-9.6-9.481V304h8v-16h41.6v-5.926L32 274.963v-37.926l57.6-7.111V224H48v-16h-8v-54.519L49.6 144H80l64 72h48V64h50.4L352 200h24l40 16 105.6 11.556C608 246.519 608 251.185 608 256s0 9.481-86.4 28.444z"]
  },
      ks = {
    prefix: "fal",
    iconName: "file",
    icon: [384, 512, [], "f15b", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16z"]
  },
      Is = {
    prefix: "fal",
    iconName: "file-alt",
    icon: [384, 512, [], "f15c", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zm-48-244v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12z"]
  },
      Os = {
    prefix: "fal",
    iconName: "file-archive",
    icon: [384, 512, [], "f1c6", "M128 96v32h32V96zm65.9 169.6c-1.1-5.6-6-9.6-11.8-9.6H160v-32h-32v32l-19.4 97.2c-6.5 32.5 18.3 62.8 51.4 62.8s57.9-30.3 51.4-62.8zm-33.6 124.5c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zM128 160v32h32v-32zm64-96h-32v32h32zm177.9 33.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 32.5c2.8.7 5.4 2.1 7.4 4.2l83.9 83.9c2 2 3.5 4.6 4.2 7.4H256zM352 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h79.7v32h32V32H224v104c0 13.3 10.7 24 24 24h104zM192 192h-32v32h32zm0-64h-32v32h32z"]
  },
      Qs = {
    prefix: "fal",
    iconName: "file-audio",
    icon: [384, 512, [], "f1c7", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zm-77.6-66.6c38.5-26 61.6-69.3 61.6-115.7 0-24.7-6.5-48.9-18.9-70.1-12-20.6-29.1-37.8-49.6-50-7.1-4.2-16.3-1.9-20.6 5.2-4.2 7.1-1.9 16.3 5.2 20.6 33.1 19.7 53.7 55.8 53.7 94.3 0 36.5-18.1 70.4-48.3 90.9-6.9 4.6-8.7 14-4 20.8 2.9 4.3 7.6 6.6 12.4 6.6 3.1 0 6-.8 8.5-2.6zm-26.6-38.3c26-17.3 41.5-46.2 41.5-77.4 0-32.9-17.7-63.7-46.2-80.3-7.2-4.2-16.3-1.7-20.5 5.4-4.2 7.2-1.7 16.3 5.4 20.5 19.3 11.2 31.3 32 31.3 54.3 0 21.1-10.5 40.7-28.1 52.4-6.9 4.6-8.8 13.9-4.2 20.8 2.9 4.4 7.7 6.7 12.5 6.7 2.8.1 5.7-.7 8.3-2.4zm-27-38.2c13.7-8.5 21.8-23.1 21.8-39.2 0-17-9.3-32.5-24.2-40.6-7.3-3.9-16.4-1.2-20.3 6.1-3.9 7.3-1.2 16.4 6.1 20.3 5.2 2.8 8.5 8.3 8.5 14.2 0 5.6-2.9 10.8-7.6 13.7-7 4.4-9.2 13.6-4.8 20.7 2.8 4.6 7.7 7.1 12.8 7.1 2.5 0 5.2-.7 7.7-2.3zM138 266.7v74.7L112 322H94v-36h18l26-19.3m17.9-50.7c-2.9 0-6 1.1-8.4 3.5L104 256H76c-6.6 0-12 5.4-12 12v72c0 6.6 5.4 12 12 12h28l43.5 36.5c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V228c0-7.2-5.9-12-12.1-12z"]
  },
      Zs = {
    prefix: "fal",
    iconName: "file-certificate",
    icon: [512, 512, [], "f5f3", "M497.9 97.98L414.02 14.1c-9-9-21.19-14.1-33.89-14.1H176c-26.5.1-47.99 21.6-47.99 48.09V165.7c-5.97 0-11.94-1.68-24.13-5.03-1.7-.46-3.36-.66-4.96-.66-5.56 0-10.43 2.5-13.66 5.79-17.95 18.26-17.07 17.77-41.7 24.5-6.7 1.81-11.97 7.21-13.78 14.07-6.47 24.67-6.09 24.16-24.02 42.32-4.95 5.04-6.9 12.48-5.08 19.43 6.56 24.38 6.52 24.39 0 48.76-1.82 6.95.12 14.4 5.08 19.45 18 18.15 17.58 17.79 24.02 42.29 1.8 6.88 7.08 12.27 13.78 14.1 1.8.48 2.92.8 4.46 1.21V496c0 5.55 2.87 10.69 7.59 13.61 4.66 2.91 10.59 3.16 15.56.7l56.84-28.42 56.84 28.42c2.25 1.12 4.72 1.69 7.16 1.69h272c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM384.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zM33.28 316.68c5.7-22.3 5.7-30.23.01-52.39 15.65-16.2 19.56-22.98 25.63-45.06 21.57-6.13 28.06-9.92 43.88-25.69 9.8 2.62 16.82 4.15 25.21 4.15 8.28 0 15.25-1.49 25.19-4.16 15.56 15.51 22.49 19.58 43.86 25.68 5.98 21.95 9.71 28.63 25.65 45.07-5.77 22.45-5.76 30 0 52.4-15.62 16.17-19.55 22.96-25.61 44.96-14.63 3.92-24 7.36-37.25 19.36-9.94-4.53-20.78-6.89-31.85-6.89s-21.9 2.36-31.85 6.9c-13.18-11.88-22.56-15.34-37.23-19.33-5.97-21.89-9.72-28.57-25.64-45zm101.89 133.01c-4.5-2.25-9.81-2.25-14.31 0l-40.84 20.42V409.9c.12.12.19.17.31.29 3.75 3.82 8.68 5.79 13.64 5.79 3.5 0 7.02-.98 10.16-2.97 7.25-4.59 15.56-6.88 23.87-6.88s16.62 2.29 23.87 6.86c3.16 2.02 6.68 3.01 10.17 3.01 4.96 0 9.87-1.99 13.63-5.79.13-.13.21-.18.34-.32v60.22l-40.84-20.42zm344.84 14.32c0 8.8-7.2 16-16 16h-256V391.9c1.54-.4 2.65-.71 4.44-1.19 6.7-1.82 11.97-7.22 13.77-14.08 6.47-24.68 6.09-24.16 24.03-42.32 4.95-5.04 6.9-12.49 5.07-19.44-6.53-24.33-6.55-24.34 0-48.76 1.83-6.95-.12-14.4-5.07-19.45-18-18.15-17.58-17.79-24.03-42.29-1.8-6.87-7.07-12.27-13.75-14.09-24.23-6.57-23.89-6.23-41.72-24.52-2.94-2.97-6.78-4.52-10.74-5.16V48.09c0-8.8 7.2-16.09 16-16.09h176.03v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01z"]
  },
      Us = {
    prefix: "fal",
    iconName: "file-chart-line",
    icon: [384, 512, [], "f659", "M136 320h-16c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8zm64-96h-16c-4.4 0-8 3.6-8 8v192c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm40 72v128c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8zM369.9 97.98L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01z"]
  },
      Bs = {
    prefix: "fal",
    iconName: "file-chart-pie",
    icon: [384, 512, [], "f65a", "M369.9 97.98L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01zM192 192v128h127.99c.01 0 0-.01 0-.02-.01-70.68-57.29-127.97-127.97-127.98H192zm32 37.49c27.22 9.66 48.85 31.28 58.5 58.51H224v-58.51zM176 416c-44.12 0-80-35.89-80-80 0-38.63 27.52-70.95 64-78.38v-32c-54.13 7.85-96 54.11-96 110.38 0 61.75 50.25 112 112 112 56.27 0 102.54-41.87 110.38-96h-32c-7.43 36.47-39.74 64-78.38 64z"]
  },
      Rs = {
    prefix: "fal",
    iconName: "file-check",
    icon: [384, 512, [], "f316", "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zm-22.627 22.628a15.89 15.89 0 0 1 4.195 7.431H256V32.491a15.88 15.88 0 0 1 7.431 4.195l83.883 83.883zM336 480H48c-8.837 0-16-7.163-16-16V48c0-8.837 7.163-16 16-16h176v104c0 13.255 10.745 24 24 24h104v304c0 8.837-7.163 16-16 16zm-34.467-210.949l-134.791 133.71c-4.7 4.663-12.288 4.642-16.963-.046l-67.358-67.552c-4.683-4.697-4.672-12.301.024-16.985l8.505-8.48c4.697-4.683 12.301-4.672 16.984.024l50.442 50.587 117.782-116.837c4.709-4.671 12.313-4.641 16.985.068l8.458 8.527c4.672 4.709 4.641 12.313-.068 16.984z"]
  },
      Ys = {
    prefix: "fal",
    iconName: "file-code",
    icon: [384, 512, [], "f1c9", "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zm-22.627 22.628a15.89 15.89 0 0 1 4.195 7.431H256V32.491a15.88 15.88 0 0 1 7.431 4.195l83.883 83.883zM336 480H48c-8.837 0-16-7.163-16-16V48c0-8.837 7.163-16 16-16h176v104c0 13.255 10.745 24 24 24h104v304c0 8.837-7.163 16-16 16zm-161.471-67.404l-25.928-7.527a5.1 5.1 0 0 1-3.476-6.32l58.027-199.869a5.1 5.1 0 0 1 6.32-3.476l25.927 7.527a5.1 5.1 0 0 1 3.476 6.32L180.849 409.12a5.1 5.1 0 0 1-6.32 3.476zm-48.446-47.674l18.492-19.724a5.101 5.101 0 0 0-.351-7.317L105.725 304l38.498-33.881a5.1 5.1 0 0 0 .351-7.317l-18.492-19.724a5.1 5.1 0 0 0-7.209-.233L57.61 300.279a5.1 5.1 0 0 0 0 7.441l61.263 57.434a5.1 5.1 0 0 0 7.21-.232zm139.043.232l61.262-57.434a5.1 5.1 0 0 0 0-7.441l-61.262-57.434a5.1 5.1 0 0 0-7.209.233l-18.492 19.724a5.101 5.101 0 0 0 .351 7.317L278.275 304l-38.499 33.881a5.1 5.1 0 0 0-.351 7.317l18.492 19.724a5.1 5.1 0 0 0 7.209.232z"]
  },
      Ps = {
    prefix: "fal",
    iconName: "file-contract",
    icon: [384, 512, [], "f56c", "M196.66 363.33l-13.88-41.62c-3.28-9.81-12.44-16.41-22.78-16.41s-19.5 6.59-22.78 16.41L119 376.36c-1.5 4.58-5.78 7.64-10.59 7.64H96c-8.84 0-16 7.16-16 16s7.16 16 16 16h12.41c18.62 0 35.09-11.88 40.97-29.53L160 354.58l16.81 50.48a15.994 15.994 0 0 0 14.06 10.89c.38.03.75.05 1.12.05 6.03 0 11.59-3.41 14.31-8.86l7.66-15.33c2.78-5.59 7.94-6.19 10.03-6.19s7.25.59 10.19 6.53c7.38 14.7 22.19 23.84 38.62 23.84H288c8.84 0 16-7.16 16-16s-7.16-16-16-16h-15.19c-4.28 0-8.12-2.38-10.16-6.5-11.96-23.85-46.24-30.33-65.99-14.16zM72 96h112c4.42 0 8-3.58 8-8V72c0-4.42-3.58-8-8-8H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm120 56v-16c0-4.42-3.58-8-8-8H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h112c4.42 0 8-3.58 8-8zm177.9-54.02L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01z"]
  },
      Fs = {
    prefix: "fal",
    iconName: "file-csv",
    icon: [384, 512, [], "f6dd", "M369.9 97.98L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01zM120 256h-8c-26.51 0-48 21.49-48 48v32c0 26.51 21.49 48 48 48h8c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-8c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h8c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm112 0c-4.42 0-8 3.58-8 8v20.8c0 35.48 12.88 68.89 36.28 94.09 3.02 3.25 7.27 5.11 11.72 5.11s8.7-1.86 11.72-5.11c23.41-25.2 36.28-58.61 36.28-94.09V264c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v20.8c0 20.27-5.7 40.17-16 56.88-10.3-16.7-16-36.61-16-56.88V264c0-4.42-3.58-8-8-8h-16zm-52.55 42.47c-1.38-1.19-2.12-2.55-2.12-3.84 0-3.12 4.45-6.62 10.41-6.62H200c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-12.27c-23.39 0-42.41 17.33-42.41 38.62 0 10.66 4.86 20.92 13.33 28.14l21.89 18.77c1.38 1.19 2.12 2.55 2.12 3.84 0 3.12-4.45 6.62-10.41 6.62H160c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h12.27c23.39 0 42.41-17.33 42.41-38.62 0-10.66-4.86-20.92-13.33-28.14l-21.9-18.77z"]
  },
      Ws = {
    prefix: "fal",
    iconName: "file-download",
    icon: [384, 512, [], "f56d", "M369.9 97.98L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01zM208 216c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v88.02h-52.66c-11 0-20.59 6.41-25 16.72-4.5 10.52-2.38 22.62 5.44 30.81l68.12 71.78c5.34 5.59 12.47 8.69 20.09 8.69s14.75-3.09 20.09-8.7l68.12-71.75c7.81-8.2 9.94-20.31 5.44-30.83-4.41-10.31-14-16.72-25-16.72H208V216zm42.84 120.02l-58.84 62-58.84-62h117.68z"]
  },
      Gs = {
    prefix: "fal",
    iconName: "file-edit",
    icon: [384, 512, [], "f31c", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zM219.2 247.2l29.6 29.6c1.8 1.8 1.8 4.6 0 6.4L136.4 395.6l-30.1 4.3c-5.9.8-11-4.2-10.2-10.2l4.3-30.1 112.4-112.4c1.8-1.8 4.6-1.8 6.4 0zm64.4 1.2l-16.4 16.4c-1.8 1.8-4.6 1.8-6.4 0l-29.6-29.6c-1.8-1.8-1.8-4.6 0-6.4l16.4-16.4c5.9-5.9 15.4-5.9 21.2 0l14.8 14.8c5.9 5.8 5.9 15.3 0 21.2z"]
  },
      qs = {
    prefix: "fal",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zM211.7 308l50.5-81.8c4.8-8-.9-18.2-10.3-18.2h-4.1c-4.1 0-7.9 2.1-10.1 5.5-31 48.5-36.4 53.5-45.7 74.5-17.2-32.2-8.4-16-45.8-74.5-2.2-3.4-6-5.5-10.1-5.5H132c-9.4 0-15.1 10.3-10.2 18.2L173 308l-59.1 89.5c-5.1 8 .6 18.5 10.1 18.5h3.5c4.1 0 7.9-2.1 10.1-5.5 37.2-58 45.3-62.5 54.4-82.5 31.5 56.7 44.3 67.2 54.4 82.6 2.2 3.4 6 5.4 10 5.4h3.6c9.5 0 15.2-10.4 10.1-18.4L211.7 308z"]
  },
      Js = {
    prefix: "fal",
    iconName: "file-exclamation",
    icon: [384, 512, [], "f31a", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zM180.7 192h22.6c6.9 0 12.4 5.8 12 12.7l-6.7 120c-.4 6.4-5.6 11.3-12 11.3h-9.3c-6.4 0-11.6-5-12-11.3l-6.7-120c-.3-6.9 5.2-12.7 12.1-12.7zM220 384c0 15.5-12.5 28-28 28s-28-12.5-28-28 12.5-28 28-28 28 12.5 28 28z"]
  },
      Ks = {
    prefix: "fal",
    iconName: "file-export",
    icon: [576, 512, [], "f56e", "M567.31 283.89l-71.78-68.16c-8.28-7.8-20.41-9.88-30.84-5.38-10.31 4.42-16.69 13.98-16.69 24.97V288h-64V131.97c0-12.7-5.1-25-14.1-33.99L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V352h-31.99v112.01c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v128H168c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h280v52.67c0 10.98 6.38 20.55 16.69 24.97 14.93 6.45 26.88-1.61 30.88-5.39l71.72-68.12c5.62-5.33 8.72-12.48 8.72-20.12s-3.1-14.81-8.7-20.12zM256.03 128.07V32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48zM480 362.88V245.12L542 304l-62 58.88z"]
  },
      Xs = {
    prefix: "fal",
    iconName: "file-image",
    icon: [384, 512, [], "f1c5", "M159 336l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0l-39 39L63 448h256V304l-55.5-55.5c-4.7-4.7-12.3-4.7-17 0L159 336zm96-50.7l32 32V416H95.1l.3-67.2 15.6-15.6 48 48c20.3-20.3 77.7-77.6 96-95.9zM127 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm0-96c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zm242.9-62.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5zM352 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304z"]
  },
      _s = {
    prefix: "fal",
    iconName: "file-import",
    icon: [512, 512, [], "f56f", "M497.9 97.98L414.02 14.1c-9-9-21.2-14.1-33.89-14.1H175.99C149.5.1 128 21.6 128 48.09V288H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h248v52.67c0 10.98 6.38 20.55 16.69 24.97 14.93 6.45 26.88-1.61 30.88-5.39l71.72-68.12c5.62-5.33 8.72-12.48 8.72-20.12s-3.09-14.8-8.69-20.11l-71.78-68.16c-8.28-7.8-20.41-9.88-30.84-5.38-10.31 4.42-16.69 13.98-16.69 24.97V288H160V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01c0 8.8-7.2 16-16 16H175.99c-8.8 0-16-7.2-16-16V352H128v112.01c0 26.49 21.5 47.99 47.99 47.99h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM288 245.12L350 304l-62 58.88V245.12zm96.03-117.05V32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48z"]
  },
      $s = {
    prefix: "fal",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", "M312 416h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM64 240v96c0 8.84 8.19 16 18.29 16h219.43c10.1 0 18.29-7.16 18.29-16v-96c0-8.84-8.19-16-18.29-16H82.29C72.19 224 64 231.16 64 240zm32 16h192v64H96v-64zM72 96h112c4.42 0 8-3.58 8-8V72c0-4.42-3.58-8-8-8H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm0 64h112c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm297.9-62.02L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01z"]
  },
      cu = {
    prefix: "fal",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", "M219.09 327.42l-45-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V232c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v24.12c-23.62.63-42.67 20.55-42.67 45.07 0 19.97 12.98 37.81 31.58 43.39l45 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.11c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V440c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24.12c23.62-.63 42.67-20.54 42.67-45.07 0-19.97-12.98-37.81-31.58-43.39zM72 96h112c4.42 0 8-3.58 8-8V72c0-4.42-3.58-8-8-8H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm120 56v-16c0-4.42-3.58-8-8-8H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h112c4.42 0 8-3.58 8-8zm177.9-54.02L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01z"]
  },
      eu = {
    prefix: "fal",
    iconName: "file-medical",
    icon: [384, 512, [], "f477", "M224 232c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-56v-56zM369.9 98L286 14.1C277 5.1 264.8 0 252.1 0H48C21.5.1 0 21.6 0 48.1V464c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V132c0-12.7-5.1-25-14.1-34zM256 32.6c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9c2.1 2.1 3.5 4.6 4.2 7.4H256V32.6zM352 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48.1C32 39.3 39.2 32 48 32h176v104.1c0 13.3 10.7 23.9 24 23.9h104v304z"]
  },
      au = {
    prefix: "fal",
    iconName: "file-medical-alt",
    icon: [448, 512, [], "f478", "M433.9 98L350 14.1C341 5.1 328.8 0 316.1 0h-204c-26.5.1-48 21.6-48 48.1V288H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h126.1l34.7 69.5c2.9 5.9 11.4 5.9 14.3 0L240 275.8l22.1 44.2H352c8.8 0 16-7.2 16-16s-7.2-16-16-16h-70.1l-34.7-69.5c-2.9-5.9-11.4-5.9-14.3 0L176 332.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H96V48.1c0-8.8 7.3-16.1 16.1-16.1h176v104.1c0 13.3 10.7 23.9 24 23.9h104v304c0 8.8-7.2 16-16 16h-288c-8.8 0-16.1-7.2-16.1-16V352H64.1v112c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V132c0-12.7-5.1-25-14.1-34zM320 128.1V32.6c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9c2.1 2.1 3.5 4.6 4.2 7.4H320z"]
  },
      nu = {
    prefix: "fal",
    iconName: "file-minus",
    icon: [384, 512, [], "f318", "M369.9,97.9,286,14A48,48,0,0,0,252.1-.1H48A48.16,48.16,0,0,0,0,48V464a48,48,0,0,0,48,48H336a48,48,0,0,0,48-48V131.9A48.23,48.23,0,0,0,369.9,97.9Zm-22.6,22.7a15.73,15.73,0,0,1,4.2,7.4H256V32.5a15.73,15.73,0,0,1,7.4,4.2ZM336,480H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H224V136a23.94,23.94,0,0,0,24,24H352V464A16,16,0,0,1,336,480ZM288,300v8a12,12,0,0,1-12,12H108a12,12,0,0,1-12-12v-8a12,12,0,0,1,12-12H276A12,12,0,0,1,288,300Z"]
  },
      tu = {
    prefix: "fal",
    iconName: "file-music",
    icon: [384, 512, [], "f8b6", "M369.91 98L286 14.09A48 48 0 0 0 252.09 0H48A48.15 48.15 0 0 0 0 48.08V464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V132a48.22 48.22 0 0 0-14.09-34zM256 32.59a15.63 15.63 0 0 1 7.41 4.2l83.9 83.88a15.63 15.63 0 0 1 4.19 7.4H256zM352 464a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V48.08a16 16 0 0 1 16-16h176v104a23.93 23.93 0 0 0 24 24h104zM128 271.2v98.69a69.34 69.34 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.32 48-32V291.11l96-37.51v84.29a69.34 69.34 0 0 0-16-1.95c-26.5 0-48 14.32-48 32s21.5 32 48 32 48-14.33 48-32V224a16 16 0 0 0-20.81-15.24l-128 47.24A16 16 0 0 0 128 271.2z"]
  },
      ru = {
    prefix: "fal",
    iconName: "file-pdf",
    icon: [384, 512, [], "f1c1", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zm-22-171.2c-13.5-13.3-55-9.2-73.7-6.7-21.2-12.8-35.2-30.4-45.1-56.6 4.3-18 12-47.2 6.4-64.9-4.4-28.1-39.7-24.7-44.6-6.8-5 18.3-.3 44.4 8.4 77.8-11.9 28.4-29.7 66.9-42.1 88.6-20.8 10.7-54.1 29.3-58.8 52.4-3.5 16.8 22.9 39.4 53.1 6.4 9.1-9.9 19.3-24.8 31.3-45.5 26.7-8.8 56.1-19.8 82-24 21.9 12 47.6 19.9 64.6 19.9 27.7.1 28.9-30.2 18.5-40.6zm-229.2 89c5.9-15.9 28.6-34.4 35.5-40.8-22.1 35.3-35.5 41.5-35.5 40.8zM180 175.5c8.7 0 7.8 37.5 2.1 47.6-5.2-16.3-5-47.6-2.1-47.6zm-28.4 159.3c11.3-19.8 21-43.2 28.8-63.7 9.7 17.7 22.1 31.7 35.1 41.5-24.3 4.7-45.4 15.1-63.9 22.2zm153.4-5.9s-5.8 7-43.5-9.1c41-3 47.7 6.4 43.5 9.1z"]
  },
      iu = {
    prefix: "fal",
    iconName: "file-plus",
    icon: [384, 512, [], "f319", "M369.9,97.9,286,14A48,48,0,0,0,252.1-.1H48A48.16,48.16,0,0,0,0,48V464a48,48,0,0,0,48,48H336a48,48,0,0,0,48-48V131.9A48.23,48.23,0,0,0,369.9,97.9Zm-22.6,22.7a15.73,15.73,0,0,1,4.2,7.4H256V32.5a15.73,15.73,0,0,1,7.4,4.2ZM336,480H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H224V136a23.94,23.94,0,0,0,24,24H352V464A16,16,0,0,1,336,480ZM288,300v8a12,12,0,0,1-12,12H208v68a12,12,0,0,1-12,12h-8a12,12,0,0,1-12-12V320H108a12,12,0,0,1-12-12v-8a12,12,0,0,1,12-12h68V220a12,12,0,0,1,12-12h8a12,12,0,0,1,12,12v68h68A12,12,0,0,1,288,300Z"]
  },
      ou = {
    prefix: "fal",
    iconName: "file-powerpoint",
    icon: [384, 512, [], "f1c4", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zM204.3 208H140c-6.6 0-12 5.4-12 12v184c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-60.4h44.3c38.7 0 67.7-27.3 67.7-69 0-38.6-23.8-66.6-67.7-66.6zm26 97.7c-7.5 7.6-17.8 11.4-31 11.4H160V233h39.7c12.9 0 23.1 3.7 30.6 11.1 15.3 15.1 15 46.5 0 61.6z"]
  },
      lu = {
    prefix: "fal",
    iconName: "file-prescription",
    icon: [384, 512, [], "f572", "M369.9 98L286 14.1C277 5.1 264.8 0 252.1 0H48C21.5.1 0 21.6 0 48.1V464c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V132c0-12.7-5.1-25-14.1-34zM256 32.6c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9c2.1 2.1 3.5 4.6 4.2 7.4H256zM352 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48.1C32 39.3 39.2 32 48 32h176v104.1c0 13.3 10.7 23.9 24 23.9h104zM192.7 298c18.5-9.1 31.3-28 31.3-50 0-30.9-25.1-56-56-56h-64c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-40h25.4l48 48-39 39c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l39-39 39 39c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-39-39 39-39c3.1-3.1 3.1-8.2 0-11.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0l-39 39zM168 272h-40v-48h40c13.2 0 24 10.8 24 24s-10.8 24-24 24z"]
  },
      fu = {
    prefix: "fal",
    iconName: "file-search",
    icon: [640, 512, [], "f865", "M605.65 487.05l-88.89-88.88c16.86-21.68 27.31-48.58 27.31-78.17a128 128 0 1 0-128 128c29.55 0 56.43-10.42 78.1-27.24l88.9 88.89a8 8 0 0 0 11.32 0l11.31-11.31a8 8 0 0 0-.05-11.29zM416.05 416a96 96 0 1 1 96-96 96.12 96.12 0 0 1-96 96zM368 480H80a16 16 0 0 1-16-16V48.09a16 16 0 0 1 16-16h176v104a23.93 23.93 0 0 0 24 24l136-.09v-28a48.23 48.23 0 0 0-14.1-34L318 14.1A48 48 0 0 0 284.08 0H80a48.16 48.16 0 0 0-48 48.09V464a48 48 0 0 0 48 48h288a47.87 47.87 0 0 0 45.15-32.29 159.9 159.9 0 0 1-33.92-4.36A15.91 15.91 0 0 1 368 480zM288 32.59a15.73 15.73 0 0 1 7.4 4.2l83.9 83.89a15.75 15.75 0 0 1 4.2 7.39H288z"]
  },
      su = {
    prefix: "fal",
    iconName: "file-signature",
    icon: [576, 512, [], "f573", "M560.83 135.96l-24.79-24.79c-20.23-20.24-53-20.26-73.26 0L384 189.72v-57.75c0-12.7-5.1-25-14.1-33.99L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99v-80.54c6.29-4.68 12.62-9.35 18.18-14.95l158.64-159.3c9.79-9.78 15.17-22.79 15.17-36.63s-5.38-26.84-15.16-36.63zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v61.53l-48.51 48.24c-30.14 29.96-47.42 71.51-47.47 114-3.93-.29-7.47-2.42-9.36-6.27-11.97-23.86-46.25-30.34-66-14.17l-13.88-41.62c-3.28-9.81-12.44-16.41-22.78-16.41s-19.5 6.59-22.78 16.41L103 376.36c-1.5 4.58-5.78 7.64-10.59 7.64H80c-8.84 0-16 7.16-16 16s7.16 16 16 16h12.41c18.62 0 35.09-11.88 40.97-29.53L144 354.58l16.81 50.48c4.54 13.51 23.14 14.83 29.5 2.08l7.66-15.33c4.01-8.07 15.8-8.59 20.22.34C225.44 406.61 239.9 415.7 256 416h32c22.05-.01 43.95-4.9 64.01-13.6v61.61zm27.48-118.05A129.012 129.012 0 0 1 288 384v-.03c0-34.35 13.7-67.29 38.06-91.51l120.55-119.87 52.8 52.8-119.92 120.57zM538.2 186.6l-21.19 21.19-52.8-52.8 21.2-21.19c7.73-7.73 20.27-7.74 28.01 0l24.79 24.79c7.72 7.73 7.72 20.27-.01 28.01z"]
  },
      uu = {
    prefix: "fal",
    iconName: "file-spreadsheet",
    icon: [384, 512, [], "f65b", "M369.9 97.98L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01zM64 208v224c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16zm224 208h-80v-48h80v48zm0-80h-80v-48h80v48zM96 224h192v32H96v-32zm0 64h80v48H96v-48zm0 80h80v48H96v-48z"]
  },
      hu = {
    prefix: "fal",
    iconName: "file-times",
    icon: [384, 512, [], "f317", "M369.9,97.9,286,14A48,48,0,0,0,252.1-.1H48A48.16,48.16,0,0,0,0,48V464a48,48,0,0,0,48,48H336a48,48,0,0,0,48-48V131.9A48.23,48.23,0,0,0,369.9,97.9Zm-22.6,22.7a15.73,15.73,0,0,1,4.2,7.4H256V32.5a15.73,15.73,0,0,1,7.4,4.2ZM336,480H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H224V136a23.94,23.94,0,0,0,24,24H352V464A16,16,0,0,1,336,480ZM262.71,369.05l-5.66,5.66a12,12,0,0,1-17,0L192,326.63l-48.08,48.08a12,12,0,0,1-17,0l-5.66-5.66a12,12,0,0,1,0-17L169.37,304l-48.08-48.08a12,12,0,0,1,0-17l5.66-5.66a12,12,0,0,1,17,0L192,281.37l48.08-48.08a12,12,0,0,1,17,0l5.66,5.66a12,12,0,0,1,0,17L214.63,304l48.08,48.08A12,12,0,0,1,262.71,369.05Z"]
  },
      mu = {
    prefix: "fal",
    iconName: "file-upload",
    icon: [384, 512, [], "f574", "M369.9 97.98L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01zm-180.1-247.32l-68.12 71.75c-7.81 8.2-9.94 20.31-5.44 30.83 4.41 10.31 14 16.72 25 16.72H176V424c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-88.02h52.66c11 0 20.59-6.41 25-16.72 4.5-10.52 2.38-22.62-5.44-30.81l-68.12-71.78c-10.69-11.19-29.51-11.2-40.19.02zm-38.75 87.29l58.84-62 58.84 62H133.16z"]
  },
      vu = {
    prefix: "fal",
    iconName: "file-user",
    icon: [384, 512, [], "f65c", "M369.9 97.98L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zM272 480.01H112v-31.15c0-18.38 13.05-32.86 33.25-32.86 12.45 0 20.8 6.99 46.75 6.99 25.5 0 34.56-6.99 46.75-6.99 20.16 0 33.25 14.43 33.25 32.86v31.15zm80.01-16c0 8.8-7.2 16-16 16H304v-31.15c0-13.88-4.21-26.77-11.41-37.48-12.08-17.94-32.67-27.38-53.84-27.38-19.46 0-24.36 6.99-46.75 6.99-22.41 0-27.26-6.99-46.75-6.99-21.17 0-41.76 9.44-53.83 27.38-7.21 10.7-11.42 23.6-11.42 37.48v31.15H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01zM112 288c0 44.18 35.82 80 80 80s80-35.82 80-80c0-44.19-35.82-80-80-80s-80 35.81-80 80zm128 0c0 26.47-21.53 48-48 48s-48-21.53-48-48 21.53-48 48-48 48 21.53 48 48z"]
  },
      du = {
    prefix: "fal",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", "M224 280.593C224 267.01 212.989 256 199.407 256H88.593C75.011 256 64 267.01 64 280.593v110.815C64 404.99 75.011 416 88.593 416h110.814C212.989 416 224 404.99 224 391.407V381l27.971 27.971a23.998 23.998 0 0 0 16.97 7.029H296c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-27.059a24.003 24.003 0 0 0-16.97 7.029L224 291v-10.407zM192 384H96v-96h96v96zm80.255-96H288v96h-15.745L224 342.826v-13.652L272.255 288zm97.686-190.059l-83.883-83.882A47.996 47.996 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM256 32.491a15.888 15.888 0 0 1 7.432 4.195l83.882 83.882a15.882 15.882 0 0 1 4.195 7.431H256V32.491zM352 464c0 8.837-7.164 16-16 16H48c-8.836 0-16-7.163-16-16V48c0-8.837 7.164-16 16-16h176v104c0 13.255 10.745 24 24 24h104v304z"]
  },
      Mu = {
    prefix: "fal",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zm-53.6-246.5c-6.8 32.8-32.5 139.7-33.4 150.3-5.8-29.1-.7 1.6-41.8-150.9-1.4-5.2-6.2-8.9-11.6-8.9h-6.4c-5.4 0-10.2 3.6-11.6 8.9-38.3 142.3-37.4 140.6-39.4 154.7-4.1-23.9 2.1-2.9-34.4-154.4-1.3-5.4-6.1-9.2-11.7-9.2h-7.2c-7.8 0-13.5 7.3-11.6 14.9 9.5 38 34.5 137.4 42.2 168 1.3 5.3 6.1 9.1 11.6 9.1h17c5.4 0 10.2-3.7 11.6-8.9 34.2-127.7 33.5-123.4 36.7-142.9 6.5 31.1.2 7 36.7 142.9 1.4 5.2 6.2 8.9 11.6 8.9h14c5.5 0 13.7-3.7 15.1-9l42.8-168c1.9-7.6-3.8-15-11.6-15h-6.8c-5.7 0-10.6 4-11.8 9.5z"]
  },
      pu = {
    prefix: "fal",
    iconName: "files-medical",
    icon: [448, 512, [], "f7fd", "M433.94 65.94l-51.88-51.88A48 48 0 0 0 348.12 0H176a48 48 0 0 0-48 48v48H48a48 48 0 0 0-48 48v320a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48v-48h80a48 48 0 0 0 48-48V99.88a48 48 0 0 0-14.06-33.94zM352 32.49a15.88 15.88 0 0 1 7.43 4.2l51.88 51.88a16 16 0 0 1 4.2 7.43H352zM288 464a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V144a16 16 0 0 1 16-16h80v240a48 48 0 0 0 48 48h112zm128-96a16 16 0 0 1-16 16H176a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h144v72a24.07 24.07 0 0 0 24 24h72zM314.67 182.67A6.67 6.67 0 0 0 308 176h-40a6.67 6.67 0 0 0-6.67 6.67v46.66h-46.66A6.67 6.67 0 0 0 208 236v40a6.67 6.67 0 0 0 6.67 6.67h46.66v46.66A6.67 6.67 0 0 0 268 336h40a6.67 6.67 0 0 0 6.67-6.67v-46.66h46.66A6.67 6.67 0 0 0 368 276v-40a6.67 6.67 0 0 0-6.67-6.67h-46.66z"]
  },
      zu = {
    prefix: "fal",
    iconName: "fill",
    icon: [512, 512, [], "f575", "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-92.85 92.85L56.97 2.35c-3.12-3.12-8.19-3.12-11.31 0L34.34 13.66c-3.12 3.12-3.12 8.19 0 11.31l99.88 99.87-106.1 106.1c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.49 12.49-32.75 0-45.25zm-244.2 244.2C246.34 473.34 230.27 480 213.18 480s-33.16-6.66-45.24-18.74l-117.2-117.2c-6.88-6.88-11.77-15.14-14.91-24.06h363.85L258.43 461.26zM431.68 288H33.06c2.2-12.96 8.2-24.94 17.69-34.43l106.09-106.11 87.85 87.85c6.25 6.25 16.38 6.25 22.62 0 6.25-6.25 6.25-16.38 0-22.62l-87.85-87.85L272.29 32h.02L480 239.68 431.68 288z"]
  },
      Cu = {
    prefix: "fal",
    iconName: "fill-drip",
    icon: [576, 512, [], "f576", "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm0 160c-17.64 0-32-14.36-32-31.96.26-9.78 13.57-37.67 32.01-68.73 18.43 31.04 31.73 58.91 31.99 68.69 0 17.64-14.36 32-32 32zm-9.37-262.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-92.85 92.85L56.97 2.35c-3.12-3.12-8.19-3.12-11.31 0L34.34 13.66c-3.12 3.12-3.12 8.19 0 11.31l99.88 99.88-106.1 106.1c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.76.01-45.26zm-244.2 244.2C246.34 473.34 230.27 480 213.18 480s-33.16-6.66-45.24-18.74l-117.2-117.2c-6.88-6.88-11.77-15.14-14.91-24.06h363.85L258.43 461.26zM431.68 288H33.06c2.2-12.96 8.2-24.94 17.69-34.43l106.09-106.11 87.85 87.85c6.25 6.25 16.38 6.25 22.62 0 6.25-6.25 6.25-16.38 0-22.62l-87.85-87.85L272.29 32h.02L480 239.68 431.68 288z"]
  },
      Lu = {
    prefix: "fal",
    iconName: "film",
    icon: [512, 512, [], "f008", "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm288 224c0 6.6-5.4 12-12 12H140c-6.6 0-12-5.4-12-12V284c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v120zm0-176c0 6.6-5.4 12-12 12H140c-6.6 0-12-5.4-12-12V108c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v120zm96 144c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"]
  },
      Au = {
    prefix: "fal",
    iconName: "film-alt",
    icon: [512, 512, [], "f3a0", "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm288 224c0 6.6-5.4 12-12 12H140c-6.6 0-12-5.4-12-12V108c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v296zm96-32c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"]
  },
      Nu = {
    prefix: "fal",
    iconName: "film-canister",
    icon: [576, 512, [], "f8b7", "M544 96H320V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-88V16a16 16 0 0 0-16-16H112a16 16 0 0 0-16 16v16H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v416H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h336a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-24v-32h160a32 32 0 0 0 32-32v-64a32 32 0 0 1 32-32 32 32 0 0 0 32-32V128a32 32 0 0 0-32-32zM288 480H64V64h224zm256-192a64.07 64.07 0 0 0-64 64v64H320V128h224zm-64-80h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zM368 384h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0-176h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16z"]
  },
      gu = {
    prefix: "fal",
    iconName: "filter",
    icon: [512, 512, [], "f0b0", "M479.968 0H32.038C3.613 0-10.729 34.487 9.41 54.627L192 237.255V424a31.996 31.996 0 0 0 10.928 24.082l64 55.983c20.438 17.883 53.072 3.68 53.072-24.082V237.255L502.595 54.627C522.695 34.528 508.45 0 479.968 0zM288 224v256l-64-56V224L32 32h448L288 224z"]
  },
      Hu = {
    prefix: "fal",
    iconName: "fingerprint",
    icon: [512, 512, [], "f577", "M256 169.92c-28.28.41-52.84 9.62-71.37 28.17-18 18-27.69 41.94-27.28 67.44.78 50.23-3.91 100.5-14 149.39-1.81 8.66 3.78 17.12 12.41 18.91 8.5 1.66 17.09-3.77 18.91-12.44 10.56-51.17 15.5-103.78 14.69-156.35-.25-16.77 6.09-32.5 17.91-44.31 18.66-18.66 42.27-18.8 48.75-18.8 37.12.55 66.41 30.19 66.97 66.06.78 50.37-2.97 100.86-11.12 150.06-1.44 8.72 4.44 16.95 13.16 18.39.91.16 1.78.22 2.66.22 7.69 0 14.47-5.55 15.75-13.39 8.47-51.08 12.34-103.48 11.56-155.79-.87-53-44.81-96.76-99-97.56zm-.09 86.09c-8.84.14-15.87 7.41-15.75 16.25 1.12 73.39-8.22 144.99-27.78 215.07l-1.22 4.33c-1.85 6.63 1.74 20.34 15.41 20.34 7 0 13.41-4.61 15.41-11.66l1.22-4.37c20.41-73.08 30.16-147.74 28.97-224.21-.14-8.84-8.23-15.9-16.26-15.75zM112.66 149.79c-25.19 30.98-38.72 70.11-38.09 110.15.62 39.56-2.62 79.14-9.59 117.61-1.56 8.7 4.19 17.03 12.91 18.61.97.17 1.91.25 2.87.25 7.56 0 14.31-5.42 15.72-13.14 7.34-40.53 10.72-82.18 10.09-123.82-.53-33.01 10.19-63.95 30.91-89.47 5.59-6.86 4.53-16.94-2.31-22.51-6.85-5.55-16.91-4.57-22.51 2.32zm399.22 103.03c-.25-16.5-2.19-33.03-5.75-49.14-1.91-8.61-10.34-14-19.06-12.17-8.62 1.91-14.09 10.44-12.19 19.08 3.09 14 4.78 28.39 5 42.73.12 7.66.16 15.31.09 22.97-.06 8.83 7.03 16.05 15.87 16.12h.12c8.78 0 15.94-7.08 16-15.87.07-7.91.04-15.81-.08-23.72zM252.6.05C182.63-1.29 118.32 24.88 70.32 72.91 24.04 119.22-.87 180.76.16 246.2c.12 7.55.06 15.09-.16 22.62-.25 8.83 6.72 16.2 15.56 16.45H16c8.62 0 15.75-6.87 16-15.55.22-8 .28-16.02.16-24.03-.9-56.69 20.69-110.04 60.78-150.16 41.78-41.84 98.9-64.37 159.15-63.48 74.69 1.09 144.87 38.23 187.75 99.32 5.12 7.23 15.12 8.97 22.28 3.91 7.25-5.08 9-15.05 3.91-22.28C417.28 43.52 337.5 1.3 252.6.05zm1.28 84.93a182.36 182.36 0 0 0-45.19 4.91c-8.59 2.03-13.91 10.66-11.87 19.26 2.03 8.58 10.75 13.87 19.25 11.86 12.12-2.86 25.09-4.25 37.31-4.03 82.78 1.22 151.12 67.56 152.37 147.89.62 39.65-1.34 79.59-5.81 118.7-1 8.78 5.31 16.7 14.09 17.7.62.08 1.22.11 1.84.11 8 0 14.94-6.02 15.87-14.19 4.62-40.47 6.62-81.79 6-122.82-1.49-97.44-83.99-177.92-183.86-179.39z"]
  },
      Vu = {
    prefix: "fal",
    iconName: "fire",
    icon: [384, 512, [], "f06d", "M216 24.01c0-23.8-31.16-33.11-44.15-13.04C76.55 158.25 200 238.73 200 288c0 22.06-17.94 40-40 40s-40-17.94-40-40V182.13c0-19.39-21.85-30.76-37.73-19.68C30.75 198.38 0 257.28 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-192.85-168-295.99zM192 480c-88.22 0-160-71.78-160-160 0-46.94 20.68-97.75 56-128v96c0 39.7 32.3 72 72 72s72-32.3 72-72c0-65.11-112-128-45.41-248C208 160 352 175.3 352 320c0 88.22-71.78 160-160 160z"]
  },
      xu = {
    prefix: "fal",
    iconName: "fire-alt",
    icon: [448, 512, [], "f7e4", "M448 281.6c0-53.27-51.98-163.13-124.44-230.4-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512c.53 0 1.04-.08 1.58-.08.32 0 .6.08.92.08 1.88 0 3.71-.35 5.58-.42C352.02 507.17 448 406.04 448 281.6zm-416 0c0-50.22 47.51-147.44 136.05-237.09 27.38 27.45 52.44 56.6 73.39 85.47l24.41 33.62 26.27-32.19a573.83 573.83 0 0 1 30.99-34.95C379.72 159.83 416 245.74 416 281.6c0 54.69-21.53 104.28-56.28 140.21 12.51-35.29 10.88-75.92-8.03-112.02a357.34 357.34 0 0 0-10.83-19.19l-22.63-37.4-28.82 32.87-25.86 29.5c-24.93-31.78-59.31-75.5-63.7-80.54l-24.65-28.39-24.08 28.87C108.16 287 80 324.21 80 370.41c0 19.02 3.62 36.66 9.77 52.79C54.17 387.17 32 337.03 32 281.6zm193.54 198.32C162.86 479.49 112 437.87 112 370.41c0-33.78 21.27-63.55 63.69-114.41 6.06 6.98 86.48 109.68 86.48 109.68l51.3-58.52a334.43 334.43 0 0 1 9.87 17.48c23.92 45.66 13.83 104.1-29.26 134.24-17.62 12.33-39.14 19.71-62.37 20.73-2.06.07-4.09.29-6.17.31z"]
  },
      wu = {
    prefix: "fal",
    iconName: "fire-extinguisher",
    icon: [448, 512, [], "f134", "M429.627 32.177l-160 24C254.178 58.494 256 74.414 256 80h-61.396C212.106 43.162 185.315 0 144 0c-43.131 0-69.629 46.603-48.775 83.504-42.891 9.634-75.08 39.064-94.077 86.554-3.282 8.205.708 17.517 8.913 20.798 8.21 3.282 17.518-.713 20.798-8.913C62.582 102.637 120.434 112 176 112v33.353c-45.574 7.763-80 48.123-80 95.853V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-47.566-34.599-87.046-80-94.665V112h48c0 4.893-2.181 21.452 13.627 23.823l160 24C439.275 161.264 448 153.803 448 144V48c0-9.775-8.695-17.269-18.373-15.823zM256 240v240H128V241.205c0-35.694 28.49-64.944 63.501-65.203L192 176c35.29 0 64 28.71 64 64zM144 32c13.234 0 24 10.766 24 24s-10.766 24-24 24-24-10.766-24-24 10.766-24 24-24zm272 93.421l-128-19.2V85.779l128-19.2v58.842z"]
  },
      yu = {
    prefix: "fal",
    iconName: "fire-smoke",
    icon: [576, 512, [], "f74b", "M464 288c-25.5 0-50 8.9-69.8 24.8C370.8 277.7 331.1 256 288 256s-82.8 21.7-106.2 56.8C162 296.9 137.5 288 112 288 50.2 288 0 338.2 0 400s50.2 112 112 112h352c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 192H112c-44.1 0-80-35.9-80-80s35.9-80 80-80c23.5 0 45.8 10.7 61.2 29.2l16.5 19.9 10.4-23.7C215.6 310.6 250 288 288 288s72.4 22.6 87.8 57.4l10.4 23.7 16.5-19.9c15.4-18.6 37.8-29.2 61.2-29.2 44.1 0 80 35.9 80 80s-35.8 80-79.9 80zm-63.1-209.2c1.7-.8 3.4-1.4 5.1-2.2 7.3-28.9 4.4-60.7-9.7-88.4-3.2-6.3-6.8-13-10.8-19.7L320 192s-78.1-81.4-84.7-89.3c-46.3 57.4-69.5 91-69.5 129.1 0 13.5 2.3 25.8 5.6 37.4 1.2.6 2.5 1 3.7 1.6 7.5-7.4 15.8-13.8 24.6-19.6-1.1-6.1-1.8-12.4-1.8-19.4 0-21.7 12.4-44.3 39.6-80 21 22.1 48.2 50.5 59.5 62.3l16.1 16.7 20.9-10.1 37.6-18.1c6.4 16 7.9 32.8 5.6 48.7 8.4 5.8 16.4 12.2 23.7 19.5zM112 256c6.3 0 12.4.5 18.6 1.3-1.3-8.2-2.6-16.4-2.6-25 0-39.9 41.2-117.9 111.4-187.8 15.3 16.9 28.8 35.2 42 53.1 4.4 6 8.7 11.9 13.1 17.6l24.1 31.9 25.9-30.5c7.3-8.6 17.4-19.3 28.3-30 46 50.8 75.3 117.6 75.3 145.6 0 8.6-1.2 16.8-2.6 25 6.1-.8 12.3-1.3 18.6-1.3 4.8 0 9.4 1 14.1 1.4 1.1-8.2 1.9-16.6 1.9-25.1 0-43.9-44.6-134.6-106.7-190.1C355.5 58.2 334.2 79.2 320 96c-23.4-31-47.2-66.7-80-96C155.8 75.2 96 173.2 96 232.3c0 8.5.8 16.9 1.9 25.1 4.7-.4 9.3-1.4 14.1-1.4z"]
  },
      bu = {
    prefix: "fal",
    iconName: "fireplace",
    icon: [640, 512, [], "f79a", "M624 0H16C7.2 0 0 7.2 0 16v96c0 8.8 7.2 16 16 16h16v352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V358.9c0-83.6 61.1-158.2 144.3-166.1 5.3-.5 10.5-.8 15.7-.8 88.4 0 160 71.6 160 160v128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V128h16c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm-48 480h-64V352c0-105.9-86.1-192-192-192-6.2 0-12.4.3-18.8.9-97.1 9.3-173.2 96.2-173.2 198V480H64V128h512v352zm32-384H32V32h576v64zM342.3 311.6c-14-18.8-31.4-37.8-51.1-55.6-50.5 45.6-86.4 105-86.4 140.8 0 63.6 51.6 115.2 115.2 115.2s115.2-51.6 115.2-115.2c0-26.6-26.7-81.6-64-115.2-10.7 9.6-20.4 19.8-28.9 30zM320 480c-45.9 0-83.2-37.3-83.2-83.2 0-19.6 20.4-58.9 54.5-96 9.3 9.8 17.8 19.9 25.3 29.9l24.2 32.4 26-30.9 3.6-4.2c20.5 26.9 32.8 57.4 32.8 68.8 0 45.9-37.3 83.2-83.2 83.2z"]
  },
      Su = {
    prefix: "fal",
    iconName: "first-aid",
    icon: [576, 512, [], "f479", "M200 288h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM96 448H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h48v384zm352 0H128V64h320v384zm96-16c0 8.8-7.2 16-16 16h-48V64h48c8.8 0 16 7.2 16 16v352z"]
  },
      Tu = {
    prefix: "fal",
    iconName: "fish",
    icon: [640, 512, [], "f578", "M363.44 80c-99.96 0-187.27 60.25-235.86 111.79l-97.04-72.66c-3.65-2.73-7.78-3.94-11.8-3.94-10.85 0-20.87 8.78-18.36 20.06L27.27 256 .39 376.74c-2.51 11.28 7.52 20.06 18.36 20.06 4.02 0 8.15-1.21 11.8-3.94l97.04-72.66C176.17 371.75 263.48 432 363.44 432 516.18 432 640 291.2 640 256c0-35.2-123.82-176-276.56-176zm0 320c-86.02 0-166.21-52.56-212.57-101.74l-19.6-20.79-22.87 17.12-68.33 51.17 18.43-82.8 1.55-6.95-1.55-6.95-18.43-82.8 68.33 51.17 22.87 17.12 19.6-20.79C197.23 164.56 277.42 112 363.44 112 489 112 595.86 223.33 607.5 256 595.86 288.67 489 400 363.44 400zM448 232c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      Du = {
    prefix: "fal",
    iconName: "fish-cooked",
    icon: [640, 512, [], "f7fe", "M363.44 64c-100 0-187.26 65.72-235.85 122l-97-85.67C17.08 89.28-3 101 .4 117.89L27.27 256 .39 394.12C-3 411 17.06 422.72 30.54 411.71l97-85.65C176.17 382.28 263.48 448 363.44 448 516.18 448 640 294.4 640 256S516.18 64 363.44 64zm0 352c-85.4 0-165.33-57.27-211.65-110.87l-20.35-23.55c-31.19 25.48-12.24 8.88-92.08 81.61C61.12 249.3 58.13 264.82 59.93 256c-1.8-8.81 1.2 6.73-20.56-107.19 80 72.85 61 56.21 92.08 81.62l20.35-23.55C198.12 153.28 278 96 363.44 96c128.19 0 236.08 126.49 244.35 160-8.27 33.51-116.16 160-244.35 160zm-21.78-250.35l-11.31-11.31a8 8 0 0 0-11.32 0L234.35 239a8 8 0 0 0 0 11.31l11.31 11.31a8 8 0 0 0 11.31 0L341.66 177a8 8 0 0 0 0-11.35zm112 16l-11.31-11.31a8 8 0 0 0-11.32 0L282.35 319a8 8 0 0 0 0 11.31l11.31 11.31a8 8 0 0 0 11.31 0L453.66 193a8 8 0 0 0 0-11.35zm36.69 68.69a8 8 0 0 0-11.32 0L394.35 335a8 8 0 0 0 0 11.31l11.31 11.31a8 8 0 0 0 11.31 0L501.66 273a8 8 0 0 0 0-11.32z"]
  },
      ju = {
    prefix: "fal",
    iconName: "fist-raised",
    icon: [384, 512, [], "f6de", "M350.82 167.94c.46-2.63 1.18-5.18 1.18-7.94V80c0-26.51-21.49-48-48-48h-16c-6.32 0-12.32 1.29-17.85 3.52C264.62 15.12 246.12 0 224 0h-16c-22.12 0-40.62 15.12-46.15 35.52C156.32 33.29 150.32 32 144 32h-16c-22.12 0-40.62 15.12-46.15 35.52C76.32 65.29 70.32 64 64 64H48C21.49 64 0 85.49 0 112v186.98c0 38.17 15.16 74.78 42.15 101.77L64 422.62V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-94.63l-31.22-31.23A111.97 111.97 0 0 1 32 298.98v-45.93c5.03 1.79 10.36 2.95 16 2.95h16c12.34 0 23.49-4.81 32-12.48 8.51 7.68 19.66 12.48 32 12.48h16c13.16 0 25.09-5.34 33.77-13.95.24.3 9.34 14.63 30.62 23.65-19.67 15.79-33.92 35.74-57.27 70.77a7.992 7.992 0 0 0 2.22 11.09l13.31 8.88a7.992 7.992 0 0 0 11.09-2.22l6.31-9.47c31.91-47.87 51.56-70.29 96.12-72.56 4.25-.22 7.82-3.67 7.82-7.93V248c0-4.42-3.58-8-8-8h-40.67c-26.16 0-47.36-21.21-47.36-47.36v-.74c0-8.78 7.12-15.9 15.9-15.9H288c35.35 0 64 28.65 64 64v88.32c0 25.41-10.09 49.77-28.06 67.74L288 432v72c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-58.75l26.51-26.51c24-24 37.49-56.56 37.49-90.51V240c0-28.87-13.01-54.46-33.18-72.06zM80 208c0 8.84-7.16 16-16 16H48c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v96zm80 0c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16V80c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v128zm80-64h-32.03c-5.58 0-10.92 1.1-15.97 2.85V48c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v96zm80 5.88c-10.05-3.57-20.72-5.88-32-5.88h-16V80c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v69.88z"]
  },
      Eu = {
    prefix: "fal",
    iconName: "flag",
    icon: [512, 512, [], "f024", "M344.348 74.667C287.742 74.667 242.446 40 172.522 40c-28.487 0-53.675 5.322-76.965 14.449C99.553 24.713 75.808-1.127 46.071.038 21.532.999 1.433 20.75.076 45.271-1.146 67.34 12.553 86.382 32 93.258V500c0 6.627 5.373 12 12 12h8c6.627 0 12-5.373 12-12V378.398c31.423-14.539 72.066-29.064 135.652-29.064 56.606 0 101.902 34.667 171.826 34.667 51.31 0 91.933-17.238 130.008-42.953 6.589-4.45 10.514-11.909 10.514-19.86V59.521c0-17.549-18.206-29.152-34.122-21.76-36.78 17.084-86.263 36.906-133.53 36.906zM48 28c11.028 0 20 8.972 20 20s-8.972 20-20 20-20-8.972-20-20 8.972-20 20-20zm432 289.333C456.883 334.03 415.452 352 371.478 352c-63.615 0-108.247-34.667-171.826-34.667-46.016 0-102.279 10.186-135.652 26V106.667C87.117 89.971 128.548 72 172.522 72c63.615 0 108.247 34.667 171.826 34.667 45.92 0 102.217-18.813 135.652-34.667v245.333z"]
  },
      ku = {
    prefix: "fal",
    iconName: "flag-alt",
    icon: [512, 512, [], "f74c", "M472.5 0c-7 0-14.3 1.5-21.2 4.6-50.5 22.7-87.8 30.3-119.1 30.3C266.1 34.9 227.7.4 151.4.4 119.8.4 81.2 6.9 32 23.6V16c0-8.8-7.2-16-16-16S0 7.2 0 16v488c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V403.6c44.2-15.8 81.6-22 114.5-22 81.2 0 137.8 34.4 219.1 34.4 35.3 0 75.1-6.5 123.7-25 14-5.4 22.8-17.9 22.8-31.2V33.4C512 13 493.4 0 472.5 0zm-107 384c-75.6 0-133-34.4-219.1-34.4-36.7 0-74.4 6.5-114.5 19.8V57.2c46-16.7 85.3-24.8 119.4-24.8 69.5 0 108.4 34.5 180.8 34.5 39.8 0 81.8-10.5 132.1-33.1 9.4-4.2 15.7-.5 15.7 5.6v320.1c-.8 2.5-58.8 24.5-114.4 24.5z"]
  },
      Iu = {
    prefix: "fal",
    iconName: "flag-checkered",
    icon: [512, 512, [], "f11e", "M464 96.3c-22.5 8.9-49.7 17.4-76.8 22.2v72.6c26.8-4.4 51.7-13.8 76.8-23.7zm0 212.5v-71.1c-16.8 10.6-46.8 21.5-76.8 25.5v72c30.7-3.2 58.6-14.9 76.8-26.4zM80 186.3c16.2-10.2 46.9-20.7 76.8-25V88.8C126.1 92 98.2 103.7 80 115.2zm0 133.5c23.1-7.7 50.3-13.1 76.8-16v-71.7c-26 2.7-52 8.4-76.8 16.6zm230.4-63.1c-25.1-6.9-49.6-16.6-76.8-22.2v69.7c27.7 4.7 52 14 76.8 21.4v-68.9c27.5 7.6 49.7 10.1 76.8 6.5v-72.1c-24.4 4-48.6 3.6-76.8-2.5zM477.9 37.8c-36.8 17.1-86.3 36.9-133.5 36.9-56.7 0-102-34.7-171.9-34.7-28.5 0-53.7 5.3-77 14.4C99.6 24.7 75.8-1.1 46.1 0 21.5 1 1.4 20.8.1 45.3c-1.2 22.1 12.5 41.1 31.9 48V500c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V378.4c31.4-14.5 72.1-29.1 135.7-29.1 56.6 0 101.9 34.7 171.8 34.7 51.3 0 91.9-17.2 130-43 6.6-4.5 10.5-11.9 10.5-19.9V59.5c0-17.5-18.2-29.1-34.1-21.7zM48 68c-11 0-20-9-20-20s9-20 20-20 20 9 20 20-9 20-20 20zm432 249.3C456.9 334 415.5 352 371.5 352c-63.6 0-108.2-34.7-171.8-34.7-46 0-102.3 10.2-135.7 26V106.7C87.1 90 128.5 72 172.5 72c63.6 0 108.2 34.7 171.8 34.7 45.9 0 102.2-18.8 135.7-34.7zM310.4 119.7c-27.7-4.7-52.3-14.2-76.8-21.4v67.9c25.3 6.7 49.6 16.4 76.8 22.4zm-153.6 41.5v70.9c34.2-3.6 56.2-1.7 76.8 2.5v-68.4c-29.7-7.8-51.3-8.7-76.8-5z"]
  },
      Ou = {
    prefix: "fal",
    iconName: "flag-usa",
    icon: [512, 512, [], "f74d", "M472.5 0c-7 0-14.3 1.5-21.2 4.6-50.5 22.7-87.8 30.3-119.1 30.3C266.1 34.9 227.7.4 151.4.4 119.8.4 81.2 6.9 32 23.6V16c0-8.8-7.2-16-16-16S0 7.2 0 16v488c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V403.6c44.2-15.8 81.6-22 114.5-22 81.2 0 137.8 34.4 219.1 34.4 35.3 0 75.1-6.5 123.7-25 14-5.4 22.8-17.9 22.8-31.2V33.4C512 13 493.4 0 472.5 0zM256 54.3c58.3 17.5 113.9 21.8 208.3-20.5 9.4-4.2 15.7-.5 15.7 5.6v52.4c-98.8 41.7-153.2 28.3-224 16.1V54.3zm0 86c34.5 6.1 64.2 12 98.8 12 35.2 0 75.8-7 125.2-26.3v61.6c-103.5 33.4-162.8 18.4-224 4v-51.3zM32 57.2c46-16.7 85.3-24.8 119.4-24.8 27.7 0 50.5 5.5 72.6 12.1v140c-51.1-10.4-108.6-14.8-192 10.4V57.2zm0 171.1c100.6-32.4 159.1-19.2 220.4-4.7 57.5 13.6 120.2 30 227.7-2.4v54.5c-100.5 32.4-159 19.2-220.4 4.7-61-14.4-124.5-28.6-227.7 2.5v-54.6zM365.5 384c-75.6 0-133-34.4-219.1-34.4-36.7 0-74.4 6.5-114.5 19.8v-53.1c100.6-32.4 159-19.2 220.3-4.7 58.8 13.8 120.5 29.9 227.7-2.4v50.3c-.8 2.5-58.8 24.5-114.4 24.5zM96 64c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm72 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-72 24c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm72 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"]
  },
      Qu = {
    prefix: "fal",
    iconName: "flame",
    icon: [384, 512, [], "f6df", "M192 0C79.7 101.33 0 220.92 0 300.55 0 425.05 78.95 512 192 512s192-86.95 192-211.45C384 220.6 303.78 100.86 192 0zm0 480c-95.7 0-160-72.12-160-179.45 0-63.08 63.42-164.08 160-256.83 96.58 92.76 160 193.76 160 256.83C352 407.88 287.7 480 192 480zm60.1-267.1c-26.52-22.66-51.57-44.08-51.57-77.63 0-4.54-3.77-6.25-5.38-6.78-.96-.3-2.05-.49-3.2-.49-2.57 0-5.39.95-7.38 3.67C111.36 231.23 224 224 224 296c0 30.93-25.07 56-56 56s-56-25.07-56-56v-40c0-2.05-.78-4.1-2.34-5.66S106.05 248 104 248s-4.09.78-5.66 2.34C89.84 258.6 64 285.98 64 330.11c0 65 57.42 117.89 128 117.89s128-52.89 128-117.89c0-59.17-34.52-88.67-67.9-117.21zM192 416c-45.26 0-83.29-28.16-93.38-65.93C114.74 370.71 139.85 384 168 384c48.52 0 88-39.48 88-88 0-20.66-6.08-36.85-14.51-50.01 26.69 23.29 46.51 44.58 46.51 84.12 0 47.36-43.06 85.89-96 85.89z"]
  },
      Zu = {
    prefix: "fal",
    iconName: "flashlight",
    icon: [640, 512, [], "f8b8", "M288 208h-32a48 48 0 0 0 0 96h32a48 48 0 0 0 0-96zm0 64h-32a16 16 0 0 1 0-32h32a16 16 0 0 1 0 32zM608 96h-32c-59 0-116.52 17-166.59 48H64a64 64 0 0 0-64 64v96a64 64 0 0 0 64 64h345.42C459.48 399 517 416 576 416h32a32 32 0 0 0 32-32V128a32 32 0 0 0-32-32zm-96 280.49a289.65 289.65 0 0 1-85.74-35.7l-7.74-4.79H64a32 32 0 0 1-32-32v-96a32 32 0 0 1 32-32h354.52l7.73-4.79a289.7 289.7 0 0 1 85.75-35.7zm96 7.51h-32a275.75 275.75 0 0 1-32-1.88V129.88a275.75 275.75 0 0 1 32-1.88h32z"]
  },
      Uu = {
    prefix: "fal",
    iconName: "flask",
    icon: [448, 512, [], "f0c3", "M434.9 410.7L288 218.6V32h26c3.3 0 6-2.7 6-6V6c0-3.3-2.7-6-6-6H134c-3.3 0-6 2.7-6 6v20c0 3.3 2.7 6 6 6h26v186.6L13.1 410.7C-18.6 452.2 11 512 63.1 512h321.8c52.2 0 81.7-59.8 50-101.3zm-50 69.3H63.1c-25.7 0-40.3-29.4-24.6-49.8l150.2-196.5c2.1-2.8 3.3-6.2 3.3-9.7V32h64v192c0 3.5 1.2 6.9 3.3 9.7l150.2 196.5c15.6 20.4 1.2 49.8-24.6 49.8z"]
  },
      Bu = {
    prefix: "fal",
    iconName: "flask-poison",
    icon: [416, 512, [], "f6e0", "M288 159.99V32h24c4.42 0 8-3.58 8-8V8c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h24v127.99C52.85 191.35 0 265.48 0 352c0 53.79 20.43 102.79 53.94 139.7 11.95 13.17 29.21 20.3 47 20.3h214.04c18.06 0 35.49-7.44 47.58-20.85 12.92-14.34 53.24-61.93 53.14-139.15h.3c0-86.52-52.85-160.65-128-192.01zm50.79 309.73c-5.89 6.53-14.56 10.28-23.81 10.28H100.94c-9.15 0-17.65-3.57-23.3-9.8C48.21 437.77 32 395.8 32 352c0-71.25 42.52-135.02 108.32-162.47l19.68-8.21V32h96v149.31l19.68 8.21c62.56 26.1 104.07 85.02 108.01 151.99l.01 10.53c.07 55.99-24.38 94.91-44.91 117.68zM176 304c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm64 0c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm-32-80c-70.69 0-128 42.98-128 96 0 30.19 18.89 56.78 48 74.3V432c0 8.84 7.16 16 16 16h128c8.84 0 16-7.16 16-16v-37.7c29.11-17.53 48-44.12 48-74.3 0-53.02-57.31-96-128-96zm63.49 142.89L256 376.22V416h-96v-39.78l-15.49-9.33C123.85 354.45 112 337.36 112 320c0-34.69 43.96-64 96-64s96 29.31 96 64c0 17.36-11.85 34.45-32.51 46.89z"]
  },
      Ru = {
    prefix: "fal",
    iconName: "flask-potion",
    icon: [416, 512, [], "f6e1", "M416 352c0-86.52-52.85-160.65-128-192.01V32h24c4.42 0 8-3.58 8-8V8c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h24v127.99C52.85 191.35 0 265.48 0 352c0 53.79 20.43 102.79 53.94 139.7 11.95 13.17 29.21 20.3 47 20.3h214.04c18.06 0 35.49-7.44 47.58-20.85 12.92-14.34 53.24-61.93 53.14-139.15h.3zM140.32 189.53l19.68-8.21V32h96v149.32l19.68 8.21C336.49 214.9 377.11 271.36 382.97 336h-51.35c-28.66 0-57.41-7.59-83.09-21.97-61.81-34.56-135.62-34.56-197.44 0l-16.6 9.29c9.73-59.28 49.03-110.1 105.83-133.79zm198.47 280.19c-5.89 6.53-14.56 10.28-23.81 10.28H100.94c-9.15 0-17.65-3.57-23.3-9.8-27.4-30.19-42.74-68.76-44.81-109.27l33.89-18.96c52.09-29.11 114.22-29.08 166.19 0C263.38 359 297.5 368 331.62 368h50.99c-3.45 37.65-18.35 73.46-43.82 101.72z"]
  },
      Yu = {
    prefix: "fal",
    iconName: "flower",
    icon: [512, 512, [], "f7ff", "M461.5 256c30.7-26.8 50.5-65.8 50.5-109.7C512 65.5 446.5 0 365.7 0 321.8 0 282.8 19.8 256 50.5 229.2 19.8 190.2 0 146.3 0 65.5 0 0 65.5 0 146.3c0 43.9 19.8 82.9 50.5 109.7C19.8 282.8 0 321.8 0 365.7 0 446.5 65.5 512 146.3 512c43.9 0 82.9-19.8 109.7-50.5 26.8 30.7 65.8 50.5 109.7 50.5 80.8 0 146.3-65.5 146.3-146.3 0-43.9-19.8-82.9-50.5-109.7zm-95.8 224c-32.9 0-63.3-14-85.6-39.5L256 412.9l-24.1 27.6C209.6 466 179.2 480 146.3 480 83.3 480 32 428.7 32 365.7c0-32.9 14-63.3 39.5-85.6L99.1 256l-27.6-24.1C46 209.6 32 179.2 32 146.3 32 83.3 83.3 32 146.3 32c32.9 0 63.3 14 85.6 39.5L256 99.1l24.1-27.6C302.4 46 332.8 32 365.7 32c63 0 114.3 51.3 114.3 114.3 0 32.9-14 63.3-39.5 85.6L412.9 256l27.6 24.1c25.5 22.3 39.5 52.7 39.5 85.6 0 63-51.3 114.3-114.3 114.3zM256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 160c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"]
  },
      Pu = {
    prefix: "fal",
    iconName: "flower-daffodil",
    icon: [512, 512, [], "f800", "M288 144a32 32 0 1 0-32 32 32 32 0 0 0 32-32zm207.87 144H448.6A224 224 0 0 0 272 374v-96.54A85.76 85.76 0 0 0 312.87 288 87.22 87.22 0 0 0 400 200.89 85.82 85.82 0 0 0 378.62 144 85.82 85.82 0 0 0 400 87.11 87.22 87.22 0 0 0 312.87 0 85.8 85.8 0 0 0 256 21.36 85.8 85.8 0 0 0 199.13 0 87.22 87.22 0 0 0 112 87.11 85.82 85.82 0 0 0 133.38 144 85.82 85.82 0 0 0 112 200.89 87.22 87.22 0 0 0 199.13 288 85.64 85.64 0 0 0 240 277.46V374a224 224 0 0 0-176.6-86H16.13c-9.19 0-17 9-16.06 19.65C10.06 422.15 106.43 512 223.83 512h64.34c117.4 0 213.77-89.85 223.76-204.35.92-10.65-6.87-19.65-16.06-19.65zM240 480h-16.17c-93.89 0-174.52-69.14-189.94-160H63.4a192.45 192.45 0 0 1 165 93.35C242 436.09 240 454.05 240 480zm16-263.61l-12.84 17.22a54.58 54.58 0 0 1-44 22.39A55.17 55.17 0 0 1 144 200.89a54.59 54.59 0 0 1 22.41-44.06L183.63 144l-17.22-12.83A54.59 54.59 0 0 1 144 87.11 55.17 55.17 0 0 1 199.13 32a54.58 54.58 0 0 1 44 22.39L256 71.61l12.84-17.22a54.58 54.58 0 0 1 44-22.39A55.17 55.17 0 0 1 368 87.11a54.59 54.59 0 0 1-22.41 44.06L328.37 144l17.22 12.83A54.59 54.59 0 0 1 368 200.89 55.17 55.17 0 0 1 312.87 256a54.58 54.58 0 0 1-44-22.39zM288 480h-16c0-26-2-43.9 11.63-66.65A192.45 192.45 0 0 1 448.6 320h29.51C462.69 410.86 382.05 480 288 480z"]
  },
      Fu = {
    prefix: "fal",
    iconName: "flower-tulip",
    icon: [512, 512, [], "f801", "M495.87 288H448.6A224 224 0 0 0 272 374v-86a144 144 0 0 0 144-144V16a16 16 0 0 0-25.45-12.88l-73.91 53.64-48.35-51a16 16 0 0 0-24.58 0l-48.35 51-73.91-53.64A16 16 0 0 0 96 16v128a144 144 0 0 0 144 144v86a224 224 0 0 0-176.6-86H16.13c-9.19 0-17 9-16.06 19.65C10.06 422.15 106.43 512 223.83 512h64.34c117.4 0 213.77-89.85 223.76-204.35.92-10.65-6.87-19.65-16.06-19.65zM128 144V47.41l71.28 51.73L256 39.3l56.72 59.84L384 47.41V144a112 112 0 0 1-112 112h-32a112 112 0 0 1-112-112zm112 336h-16.17c-93.89 0-174.52-69.14-189.94-160H63.4a192.45 192.45 0 0 1 165 93.35C242 436.09 240 454.05 240 480zm48 0h-16c0-26-2-43.9 11.63-66.65A192.45 192.45 0 0 1 448.6 320h29.51C462.69 410.86 382.05 480 288 480z"]
  },
      Wu = {
    prefix: "fal",
    iconName: "flushed",
    icon: [496, 512, [], "f579", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm96-328c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 168H184c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16z"]
  },
      Gu = {
    prefix: "fal",
    iconName: "flute",
    icon: [640, 512, [], "f8b9", "M512 280a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm-192 0a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm96 0a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm192-120H32a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM112 320H32V192h80zm496 0H144V192h464z"]
  },
      qu = {
    prefix: "fal",
    iconName: "flux-capacitor",
    icon: [448, 512, [], "f8ba", "M448,112V400a80.15451,80.15451,0,0,1-80,80H80A80.15451,80.15451,0,0,1,0,400V112A80.15451,80.15451,0,0,1,80,32H368A80.15451,80.15451,0,0,1,448,112Zm-32,0a48.0927,48.0927,0,0,0-48-48H80a48.0927,48.0927,0,0,0-48,48V400a48.0927,48.0927,0,0,0,48,48H368a48.0927,48.0927,0,0,0,48-48Zm-32,64a80.034,80.034,0,0,1-80,80,92.12951,92.12951,0,0,1-11.18751-1l45.125-45.0625c7.625-7.73438,13.78126-22.8125,13.78126-33.65625a48.01238,48.01238,0,0,0-48-48c-10.84375,0-25.90626,6.17187-33.65626,13.78125L224,188.125l-46.06251-46.10938c-7.75-7.60937-22.81249-13.78124-33.65624-13.78124a48.01238,48.01238,0,0,0-48,48c0,10.84374,6.15625,25.9375,13.78125,33.67187L155.1875,255A92.12916,92.12916,0,0,1,144,256a80,80,0,1,1,80-80,80,80,0,0,1,160,0ZM208,336V262.625l-75.3125-75.3125a18.38329,18.38329,0,0,1-4.375-11.01562,15.97086,15.97086,0,0,1,16-16,18.49292,18.49292,0,0,1,11,4.39062L224,233.375l68.68749-68.6875a18.49294,18.49294,0,0,1,11-4.39062,15.97086,15.97086,0,0,1,16,16,18.38323,18.38323,0,0,1-4.375,11.01562L240,262.625V336a16,16,0,0,1-32,0Zm96,0a80.00157,80.00157,0,1,1-129.93751-62L176,275.875V336a48,48,0,0,0,96,0V275.875L273.93749,274A79.34533,79.34533,0,0,1,304,336Z"]
  },
      Ju = {
    prefix: "fal",
    iconName: "fog",
    icon: [640, 512, [], "f74e", "M168 320h304c57.3 0 104-46.7 104-104 0-54.8-42.6-99.8-96.3-103.7C475.8 67.4 437.9 32 392 32c-17.8 0-34.8 5.3-49.2 15.2C320.3 17.7 285.5 0 248 0c-66.2 0-120 53.8-120 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104zm-18.7-173.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8L351 82.1C361.9 70.4 376.4 64 392 64c30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72s-32.3 72-72 72H168c-39.7 0-72-32.3-72-72 0-32.4 21.9-60.8 53.3-69.3zM216 480H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm416 0H296c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h336c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-56-72v-16c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8z"]
  },
      Ku = {
    prefix: "fal",
    iconName: "folder",
    icon: [512, 512, [], "f07b", "M194.74 96l54.63 54.63c6 6 14.14 9.37 22.63 9.37h192c8.84 0 16 7.16 16 16v224c0 8.84-7.16 16-16 16H48c-8.84 0-16-7.16-16-16V112c0-8.84 7.16-16 16-16h146.74M48 64C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48z"]
  },
      Xu = {
    prefix: "fal",
    iconName: "folder-download",
    icon: [512, 512, [], "e053", "M464,128H272L217.37,73.37A32,32,0,0,0,194.74,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM314.85,288,256,350l-58.84-62ZM480,400a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V112A16,16,0,0,1,48,96H194.74L240,141.27V256H187.35a26.94,26.94,0,0,0-25,16.72,28.38,28.38,0,0,0,5.44,30.81l68.12,71.78c10.69,11.19,29.51,11.2,40.19,0l68.12-71.75a28.43,28.43,0,0,0,5.44-30.83,26.94,26.94,0,0,0-25-16.72H272V160H464a16,16,0,0,1,16,16Z"]
  },
      _u = {
    prefix: "fal",
    iconName: "folder-minus",
    icon: [512, 512, [], "f65d", "M344 272H168c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h176c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM194.74 96l54.63 54.63c6 6 14.14 9.37 22.63 9.37h192c8.84 0 16 7.16 16 16v224c0 8.84-7.16 16-16 16H48c-8.84 0-16-7.16-16-16V112c0-8.84 7.16-16 16-16h146.74M48 64C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48z"]
  },
      $u = {
    prefix: "fal",
    iconName: "folder-open",
    icon: [576, 512, [], "f07c", "M527.95 224H480v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h385.057c28.068 0 54.135-14.733 68.599-38.84l67.453-112.464C588.24 264.812 565.285 224 527.95 224zM48 96h146.745l64 64H432c8.837 0 16 7.163 16 16v48H171.177c-28.068 0-54.135 14.733-68.599 38.84L32 380.47V112c0-8.837 7.163-16 16-16zm493.695 184.232l-67.479 112.464A47.997 47.997 0 0 1 433.057 416H44.823l82.017-136.696A48 48 0 0 1 168 256h359.975c12.437 0 20.119 13.568 13.72 24.232z"]
  },
      ch = {
    prefix: "fal",
    iconName: "folder-plus",
    icon: [512, 512, [], "f65e", "M464,128H272L217.37,73.37A32,32,0,0,0,194.74,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128Zm16,272a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V112A16,16,0,0,1,48,96H194.74l54.63,54.63A32,32,0,0,0,272,160H464a16,16,0,0,1,16,16ZM339.5,272h-68V204a12,12,0,0,0-12-12h-8a12,12,0,0,0-12,12v68h-68a12,12,0,0,0-12,12v8a12,12,0,0,0,12,12h68v68a12,12,0,0,0,12,12h8a12,12,0,0,0,12-12V304h68a12,12,0,0,0,12-12v-8A12,12,0,0,0,339.5,272Z"]
  },
      eh = {
    prefix: "fal",
    iconName: "folder-times",
    icon: [512, 512, [], "f65f", "M329.54 225.77l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0L256 265.37l-50.91-50.91c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l50.9 50.92-50.91 50.91c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l50.92-50.9 50.91 50.91c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31L278.63 288l50.91-50.91a8.015 8.015 0 0 0 0-11.32zM194.74 96l54.63 54.63c6 6 14.14 9.37 22.63 9.37h192c8.84 0 16 7.16 16 16v224c0 8.84-7.16 16-16 16H48c-8.84 0-16-7.16-16-16V112c0-8.84 7.16-16 16-16h146.74M48 64C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48z"]
  },
      ah = {
    prefix: "fal",
    iconName: "folder-tree",
    icon: [576, 512, [], "f802", "M288 224h224a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32H400L368 0h-80a32 32 0 0 0-32 32v64H64V8a8 8 0 0 0-8-8H40a8 8 0 0 0-8 8v392a16 16 0 0 0 16 16h208v64a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V352a32 32 0 0 0-32-32H400l-32-32h-80a32 32 0 0 0-32 32v64H64V128h192v64a32 32 0 0 0 32 32zm0 96h66.74l32 32H512v128H288zm0-288h66.74l32 32H512v128H288z"]
  },
      nh = {
    prefix: "fal",
    iconName: "folder-upload",
    icon: [512, 512, [], "e054", "M464,128H272L217.37,73.37A32,32,0,0,0,194.74,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128Zm16,272a16,16,0,0,1-16,16H272V319.7h52.66a26.94,26.94,0,0,0,25-16.72,28.38,28.38,0,0,0-5.44-30.81l-68.12-71.78c-10.69-11.19-29.51-11.2-40.19,0l-68.12,71.75A28.43,28.43,0,0,0,162.34,303a26.94,26.94,0,0,0,25,16.72H240V416H48a16,16,0,0,1-16-16V112A16,16,0,0,1,48,96H194.74l54.63,54.63A32,32,0,0,0,272,160H464a16,16,0,0,1,16,16ZM197.15,287.7l58.84-62,58.84,62Z"]
  },
      th = {
    prefix: "fal",
    iconName: "folders",
    icon: [640, 512, [], "f660", "M592 64H400L345.37 9.37c-6-6-14.14-9.37-22.63-9.37H176c-26.51 0-48 21.49-48 48v80H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48v-80h80c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM480 464c0 8.84-7.16 16-16 16H48c-8.84 0-16-7.16-16-16V176c0-8.84 7.16-16 16-16h80v176c0 26.51 21.49 48 48 48h304v80zm128-128c0 8.84-7.16 16-16 16H176c-8.84 0-16-7.16-16-16V48c0-8.84 7.16-16 16-16h146.74l54.63 54.63c6 6 14.14 9.37 22.63 9.37h192c8.84 0 16 7.16 16 16v224z"]
  },
      rh = {
    prefix: "fal",
    iconName: "font",
    icon: [448, 512, [], "f031", "M424 448h-36.6L247.13 42.77A16 16 0 0 0 232 32h-16a16 16 0 0 0-15.12 10.77L60.6 448H24a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H94.48l44.3-128h170.44l44.31 128H312a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM149.86 288L224 73.8 298.14 288z"]
  },
      ih = {
    prefix: "fal",
    iconName: "font-awesome-logo-full",
    icon: [3992, 512, ["Font Awesome"], "f4e6", "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"]
  },
      oh = {
    prefix: "fal",
    iconName: "font-case",
    icon: [640, 512, [], "f866", "M632 160h-16a8 8 0 0 0-8 8v36.14C584.54 177.3 550.45 160 512 160a128 128 0 0 0-128 128v32a128 128 0 0 0 128 128c38.45 0 72.54-17.3 96-44.14V440a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8zm-24 160a96 96 0 0 1-192 0v-32a96 96 0 0 1 192 0zM200.57 73.86A16 16 0 0 0 185.79 64h-19.58a16 16 0 0 0-14.77 9.86L.57 436.93A8 8 0 0 0 8 448h17.29a8 8 0 0 0 7.39-4.93L83.82 320h184.37l51.13 123.07a8 8 0 0 0 7.39 4.93h17.34a8 8 0 0 0 7.39-11.07zM97.11 288L176 98.16 254.89 288z"]
  },
      lh = {
    prefix: "fal",
    iconName: "football-ball",
    icon: [496, 512, [], "f44e", "M344.2 182.5l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.7 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.4-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.3c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.3 3 3.3 8 .2 11.2zm57.3 227.2C263.6 547.9 75.7 495.3 51.9 488.9c-18.2-4.9-32.4-19.1-37.2-37.3-17.1-64.7-42.9-226.4 79.8-349.3C232.4-35.9 420.3 16.7 444.1 23.1c18.2 4.9 32.4 19.1 37.2 37.3 17.1 64.7 42.9 226.4-79.8 349.3zM435.9 54c-20.3-5.4-50.8-11.4-86.3-13.2l113.9 113.9c-1.6-35.7-7.7-66.1-13-86.1-1.9-7.1-7.5-12.7-14.6-14.6zM60.1 458c20.3 5.4 50.8 11.4 86.3 13.2L32.6 357.3c1.6 35.7 7.7 66.1 13 86.1 1.8 7.1 7.4 12.7 14.5 14.6zm402.7-258.8L304.6 41.1c-74.2 5.3-137.2 33.3-187.5 83.7-58.4 58.5-79.3 127.3-83.9 187.9l158.1 158.1c74.2-5.3 137.2-33.3 187.5-83.7 58.5-58.4 79.4-127.2 84-187.9z"]
  },
      fh = {
    prefix: "fal",
    iconName: "football-helmet",
    icon: [512, 512, [], "f44f", "M480 320H355.5l-15.2-76 136.8-17.8c9-1.2 15.6-9.8 13.9-18.7C468.4 93.8 368.3 8 248 8 114.9 8 18.2 109.5 2.6 219.9-7.6 292 13.3 361.2 53.7 412.1c3.1 3.9 7.8 6.1 12.8 6.1H120l85.7 42.9c9.3 4.7 19.4 6.9 29.3 6.9 46.5 0 78.1-49.2 60.9-92.1l-9.5-23.9h42.9l9.5 49.4c9.5 47.4 48 83.2 95.9 89.2 44 5.5 42.5 5.4 45.3 5.4 22.5 0 32-19.7 32-32V352c0-17.7-14.3-32-32-32zm-206.4 0l-10.3-25.7c-17.9-44.9 45.1-46.2 45.2-46.2l14.4 71.9h-49.3zm11.2-101.1c-41.4 5.4-66.7 48.4-51.2 87.2l32.6 83.7c5 12.5 2.1 26.7-7.4 36.2-12.8 12.8-29.3 11-38.8 6.3-88.6-44.3-82.9-43.6-92.5-48.4H74.1c-33.9-45.8-48-102.2-39.9-159.6C47.5 130.6 131.2 40 248 40c96.8 0 181.4 64.9 207.5 156.7l-170.7 22.2zM480 464l-41.3-5.2c-25.9-3.2-48-18.7-60.1-40.7H480V464zm0-80H368.3l-6.4-32H480v32zm-304-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z"]
  },
      sh = {
    prefix: "fal",
    iconName: "forklift",
    icon: [640, 512, [], "f47a", "M416 368.4v-99.2c0-8.7-1.8-17.2-5.2-25.2L332.5 61.1C324.9 43.4 307.6 32 288.3 32H144c-26.5 0-48 21.5-48 48v112H48c-26.5 0-48 21.5-48 48v192c0 44.2 35.8 80 80 80 38.7 0 71-27.5 78.4-64h131.2c7.4 36.5 39.7 64 78.4 64 44.2 0 80-35.8 80-80 0-26.1-12.7-49-32-63.6zM128 80c0-8.8 7.2-16 16-16h144.3c6.4 0 12.2 3.8 14.7 9.7l78.4 182.8c1.7 4 2.6 8.2 2.6 12.6V288H247.7c-11.4 0-22.5-4.1-31.2-11.5L128 200.6V80zM80 480c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm209.6-64H158.4c-7.4-36.5-39.7-64-78.4-64-18.1 0-34.6 6.2-48 16.4V240c0-8.8 7.2-16 16-16h58.1l89.5 76.7c14.5 12.4 33 19.3 52 19.3H384v33.6c-5.2-1.1-10.5-1.6-16-1.6-38.7 0-71 27.5-78.4 64zm78.4 64c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm264-64H512V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v432c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      uh = {
    prefix: "fal",
    iconName: "forward",
    icon: [512, 512, [], "f04e", "M244.5 230.9L52.5 71.4C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160.5c15.3-12.9 15.3-36.5 0-49.2zM224 255.4L32 416V96l192 159.4zm276.5-24.5l-192-159.4C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160.5c15.3-12.9 15.3-36.5 0-49.2zM480 255.4L288 416V96l192 159.4z"]
  },
      hh = {
    prefix: "fal",
    iconName: "fragile",
    icon: [288, 512, [], "f4bb", "M213.9 480H160V350.3c76.7-8.7 134.6-77.6 127.4-157.6l-16-178.1C270.7 6.3 263.9 0 255.7 0H32.3c-8.2 0-15 6.3-15.7 14.6L.6 192.7c-7.2 80 50.7 148.9 127.4 157.6V480H74.1c-24.5 0-33.2 32-20 32h179.8c13.1 0 4.5-32-20-32zM32.5 195.5L47.1 32h71.8L154 90.5c-82.7 49.6-60.8 36.5-86.3 51.8 27.1 21 12.5 9.7 113.5 87.9 3.3 2.5 8 2.3 11-.7 3.3-3.2 3.3-8.5 0-11.8l-70.5-70.6c72.1-43.3 58.3-35 76.2-45.7L156.3 32h84.6l14.6 163.5C260.6 252.7 218.8 320 144 320S27.3 252.9 32.5 195.5z"]
  },
      mh = {
    prefix: "fal",
    iconName: "french-fries",
    icon: [512, 512, [], "f803", "M437.29 88.14a31.71 31.71 0 0 0-30.47-6.76l-9.9 3 2.58-14.77a32 32 0 0 0-40.69-36.19l-34.25 10.21A31.61 31.61 0 0 0 304 63.17V48a31.86 31.86 0 0 0-17.69-28.63l-32-16A32 32 0 0 0 208 32v15.72l-4-21.56a32 32 0 0 0-50.81-19.62l-28.47 21.59a31.65 31.65 0 0 0-12.16 31.39L117.32 85l-12.14-3.63a32 32 0 0 0-40.68 36.16L84 228.87a31.5 31.5 0 0 0-9 7.13 32 32 0 0 0-6.28 27l49.78 224a32 32 0 0 0 31.23 25h212.54a32 32 0 0 0 31.24-25.06l49.78-224A30 30 0 0 0 428 228.87l19.5-111.31a31.75 31.75 0 0 0-10.21-29.42zm-46.53 31.44L416 112l-20.19 115.52A31.68 31.68 0 0 0 380 243.81c-3.19 7.73-8.38 14.83-14.73 21.39zm-57-45.3L368 64l-39.44 225.6a163.15 163.15 0 0 1-24.56 8.32v-53.67zM272 48v255.17c-5.28.41-10.57.84-16 .84s-10.72-.43-16-.84V32zm-99.47-16L208 221.71v76.21a169.52 169.52 0 0 1-19.49-6.24L144 53.64zm-71.94 64.71L96 112l27.94 8.36 28 149.89c-9-7.85-16-16.7-20-26.47a31.68 31.68 0 0 0-15.82-16.31L95.93 112zM362.27 480H149.73L100 256c19.44 47.11 83.53 80 156.05 80s136.62-32.88 156.05-80z"]
  },
      vh = {
    prefix: "fal",
    iconName: "frog",
    icon: [576, 512, [], "f52e", "M368 120c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm186.67 328h-67.48L384.31 332.27l161.98-91.6A58.16 58.16 0 0 0 576 189.94c0-21.39-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.27-98.99-41.27C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.89 29.08 480 64 480h309.33c5.89 0 10.67-4.78 10.67-10.67 0-11.78-9.55-21.33-21.33-21.33h-62.66l34.46-45.92a103.734 103.734 0 0 0 17.49-56.06L472.81 480h92.52c5.89 0 10.67-4.78 10.67-10.67 0-11.78-9.55-21.33-21.33-21.33zM346.84 313.08c-6.21-19.81-18.03-38-35.61-51.5-37.91-29.12-91.51-26.62-129.75 2.07l-31.07 23.31c-7.06 5.3-8.5 15.33-3.22 22.41 5.31 7.08 15.34 8.45 22.41 3.19l32.57-24.44c23.53-17.65 55.72-21.33 81.24-6.71 37 21.2 47.35 68.58 24.96 102.19L260.03 448H64c-17.59 0-31.95-13.96-32-31.12-.45-149.77 111.53-273.36 260.48-287.48l24.1-2.29 4.36-23.81C325.1 80.53 344.9 64 368 64c23.07 0 42.87 16.5 47.06 39.24l3.46 18.71 18.08 5.9c.56.18 56.15 18.43 93.54 38.92 8.55 4.68 13.86 13.56 13.86 23.17 0 9.45-5.12 18.2-13.37 22.82L346.84 313.08z"]
  },
      dh = {
    prefix: "fal",
    iconName: "frosty-head",
    icon: [384, 512, [], "f79b", "M376 224h-56V32c0-17.7-14.3-32-32-32H96C78.3 0 64 14.3 64 32v192H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h37.5C27 284 16 317.5 16 353.7c0 62.8 32.8 117.5 82 148.8 10.7 6.8 23.6 9.5 36.2 9.5h21.6c-4.4-6.3-11.8-17-20.8-32h-.7c-5.5 0-13.2-.8-19-4.5C73.1 448.7 48 403.2 48 353.7c0-37.9 14.9-72 38.8-97.7h211.7c17.6 19.5 30.2 43.7 35.1 70.4 10.3 57.1-12.6 112.9-59.7 145.7-7.4 5.1-15.9 7.8-24.8 7.8-9 15-16.5 25.7-20.8 32h20.8c15.4 0 30.5-4.8 43.1-13.6 53.9-37.6 86.1-104.1 72.8-177.7-4.3-23.6-13.9-45.3-26.9-64.7H376c4.4 0 8-3.6 8-8v-16c0-4.3-3.6-7.9-8-7.9zm-88 0H96v-64h192v64zm0-96H96V32h192v96zm-42.7 277.3c0-29.4-23.9-53.3-53.3-53.3s-53.3 23.9-53.3 53.3c0 27.6 39.2 82.3 53.3 102.8 14.2-20.5 53.3-75.2 53.3-102.8zM192 384c11.8 0 21.3 9.6 21.3 21.3 0 6.7-9.7 26-21.3 45.2-11.6-19.1-21.3-38.5-21.3-45.2 0-11.7 9.5-21.3 21.3-21.3zm64-32c11.8 0 21.3-9.6 21.3-21.3 0-11.8-9.6-21.3-21.3-21.3-11.8 0-21.3 9.6-21.3 21.3 0 11.7 9.5 21.3 21.3 21.3zm-106.7-21.3c0-11.8-9.6-21.3-21.3-21.3-11.8 0-21.3 9.6-21.3 21.3 0 11.8 9.6 21.3 21.3 21.3 11.8 0 21.3-9.6 21.3-21.3z"]
  },
      Mh = {
    prefix: "fal",
    iconName: "frown",
    icon: [496, 512, [], "f119", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm0-152c-44.4 0-86.2 19.6-114.8 53.8-5.7 6.8-4.8 16.9 2 22.5 6.8 5.7 16.9 4.8 22.5-2 22.4-26.8 55.3-42.2 90.2-42.2s67.8 15.4 90.2 42.2c5.3 6.4 15.4 8 22.5 2 6.8-5.7 7.7-15.8 2-22.5C334.2 339.6 292.4 320 248 320zm-80-80c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"]
  },
      ph = {
    prefix: "fal",
    iconName: "frown-open",
    icon: [496, 512, [], "f57a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm-80-232c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-39.7 0-102.6 23.7-111.5 74.5-1.9 10.9 2 22.2 10.3 29.5 8.2 7.3 19.9 9.9 30.6 6.6 29.3-9 56.4-14.6 70.6-14.6s41.3 5.6 70.6 14.6c7.7 2.4 20.1 2.6 30.6-6.6 8.2-7.3 12.2-18.6 10.3-29.5-8.9-50.8-71.8-74.5-111.5-74.5zm0 64c-17.7 0-46.9 5.8-80 16 5.2-29.7 50.1-48 80-48s74.8 18.3 80 48c-33.1-10.2-62.3-16-80-16z"]
  },
      zh = {
    prefix: "fal",
    iconName: "function",
    icon: [640, 512, [], "f661", "M308.8 106.6l-12.7-9.1c-3.6-2.6-8.6-1.8-11.2 1.8-39.9 56.9-61 122-61 188.7s21.1 131.8 61 188.7c2.5 3.6 7.6 4.4 11.2 1.8l12.7-9.1c3.4-2.5 4.2-7.2 1.7-10.6-36.2-51.6-55.2-110.5-55.2-170.8s19.1-119.1 55.2-170.8c2.5-3.4 1.8-8.1-1.7-10.6zM224 40c0-4.4-3.6-8-8-8h-56c-44.2 0-80 35.8-80 80v80H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h72v144c0 26.5-21.5 48-48 48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h24c44.2 0 80-35.8 80-80V224h72c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-72v-80c0-26.5 21.5-48 48-48h56c4.4 0 8-3.6 8-8zm355 59.3c-2.5-3.6-7.6-4.4-11.2-1.8l-12.7 9.1c-3.4 2.5-4.2 7.2-1.7 10.6 36.2 51.6 55.2 110.5 55.2 170.8s-19.1 119.1-55.2 170.8c-2.4 3.5-1.7 8.2 1.7 10.6l12.7 9.1c3.6 2.6 8.7 1.8 11.2-1.8 39.9-56.9 61-122 61-188.7s-21.1-131.8-61-188.7zm-69.3 122.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0l-55 55-55-55c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l55 55-55 55c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l55-55 55 55c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-55-55 55-55c3.1-3.1 3.1-8.1 0-11.3z"]
  },
      Ch = {
    prefix: "fal",
    iconName: "funnel-dollar",
    icon: [640, 512, [], "f662", "M464.02 160c-4.7 0-9.32.34-13.93.7L568.06 46.09C585.02 29.13 573.01 0 548.97 0H27.03C3.05 0-9.05 29.1 7.94 46.09L224 256v182c0 8.81 4.3 17.07 11.52 22.12l74 46.98c4.82 3.37 10.15 4.9 15.36 4.9 13.99 0 27.12-11.03 27.12-27.02v-13.22c30.43 25.12 69.46 40.21 112.02 40.21 97.34 0 175.98-78.78 175.98-175.98C640 238.64 561.22 160 464.02 160zM320 474l-63.74-38.25-.26-.22V242.47L39.35 32h497.29l-150.7 146.41c-58.01 28.78-97.9 88.42-97.9 157.56 0 37.65 11.88 72.42 31.96 101.01V474zm144.02 5.96c-79.39 0-143.98-64.59-143.98-143.98S384.63 192 464.02 192 608 256.59 608 335.98s-64.59 143.98-143.98 143.98zm27.11-152.54l-45-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V240c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.62.63-42.67 20.55-42.67 45.07 0 19.97 12.98 37.81 31.58 43.39l45 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19H450.8c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V432c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.62-.63 42.67-20.54 42.67-45.07 0-19.97-12.98-37.81-31.58-43.39z"]
  },
      Lh = {
    prefix: "fal",
    iconName: "futbol",
    icon: [496, 512, [], "f1e3", "M483.7 179.4C449.7 74.6 352.5 8 248.1 8 81.2 8-40 171.4 12.3 332.6 46.3 437.4 143.7 504 248 504c166.9 0 288-163.4 235.7-324.6zm-43 173.7l-94.3 11.6-17.8-24.9 33.7-104.1 28.9-9 69.6 65c-3.6 21.1-10.3 41.8-20.1 61.4zM35.6 291.5l69.4-64.9 28.9 9 33.9 103.7-18.1 25.2-94.2-11.6c-13-26-17.2-45.2-19.9-61.4zm196.5-180.7v32.9L146.2 206l-31.5-9.8-18-93.9c15.3-15.1 32.8-27.8 52-37.8l83.4 46.3zm149.4 85.4L350 206l-85.9-62.3v-32.9l83.6-46.4c19.1 10 36.7 22.7 52 37.9l-18.2 93.9zm-215.4 35l82-59.5 82.1 59.6-31.1 96H197.5l-31.4-96.1zm297.7 19.5L412.7 203l13.3-68.3c34.5 50.8 37.3 97.2 37.8 116zM309.2 49.2l-61.1 33.9-61-33.8c71.5-21.2 122-.1 122.1-.1zM70.3 134.1L83.5 203l-51.1 47.5c.8-31.8 8.7-63.4 23.6-92.6 4.2-8.3 9.1-16.2 14.3-23.8zm7.5 254l68.7 8.4 29.2 62.7c-38.8-13.8-72.7-38.5-97.9-71.1zm137.9 81.3l-40.1-86 17.4-24.2h110.2l17.3 24.2-40.1 86c-22.7 3.5-42.4 3.4-64.7 0zm104.8-10.2l29.2-62.7 69-8.5c-25 32.6-58.8 57.1-98.2 71.2z"]
  },
      Ah = {
    prefix: "fal",
    iconName: "galaxy",
    icon: [512, 512, [], "e008", "M255.99959,192.00854a63.9983,63.9983,0,1,0,63.99865,63.9983A64.07181,64.07181,0,0,0,255.99959,192.00854Zm0,95.99744a31.99915,31.99915,0,1,1,31.99932-31.99914A31.99832,31.99832,0,0,1,255.99959,288.006Zm250.46349-21.09319-.03125-.01562C489.18219,193.74287,428.121,134.74445,354.59127,120.073a206.301,206.301,0,0,0-40.28627-4.02919,196.07944,196.07944,0,0,0-20.55621,1.07614A106.75469,106.75469,0,0,1,344.56023,71.293C374.41507,58.54141,383.58285.01953,313.95735,0a204.93571,204.93571,0,0,0-47.083,5.5604c-73.12347,17.29641-132.12223,78.326-146.80942,151.87094a202.428,202.428,0,0,0-2.84369,60.87338A106.56506,106.56506,0,0,1,71.28471,167.478C56.4569,132.69372,4.77439,140.39274,1.00494,178.19641a201.27566,201.27566,0,0,0,4.5624,66.92009C22.817,318.2708,83.8782,377.26922,157.4079,391.94071a204.38064,204.38064,0,0,0,40.18276,4.035,197.5223,197.5223,0,0,0,20.65972-1.082,106.75465,106.75465,0,0,1-50.81144,45.8269C137.61535,453.45859,128.43781,512,198.0008,512a205.81012,205.81012,0,0,0,47.124-5.54673c73.12347-17.29641,132.12223-78.326,146.80942-151.87094a202.428,202.428,0,0,0,2.84369-60.87338,106.56506,106.56506,0,0,1,45.93654,50.82677c14.904,34.96391,66.524,26.93483,70.27978-10.71846A201.96274,201.96274,0,0,0,506.46308,266.91279Zm-27.31,63.72877c-.4414,4.40418-6.95689,6.13656-9.01739,1.31247a138.94319,138.94319,0,0,0-59.73312-66.17011c-22.59719-12.64224-50.163,5.48618-47.44823,31.27651a170.17135,170.17135,0,0,1-2.40034,51.25449c-12.279,61.4925-61.62761,112.5302-122.75133,126.98879a169.93235,169.93235,0,0,1-56.40506,3.85732,4.69412,4.69412,0,0,1-1.36912-9.02124,139.25291,139.25291,0,0,0,66.11385-59.56091c11.97436-21.29631-3.44524-47.68427-27.88613-47.68427-4.89443,0-24.96237,3.59951-54.58675-2.33588C102.15516,348.28562,51.1367,298.94124,36.70341,237.73584a169.4596,169.4596,0,0,1-3.85735-56.36568c.4375-4.37293,6.95884-6.13851,9.01739-1.31051a138.952,138.952,0,0,0,59.73313,66.1701C124.1,258.81731,151.7713,240.849,149.0448,214.95129a170.17168,170.17168,0,0,1,2.40034-51.25449C167.1245,85.17937,242.46667,23.808,330.60349,32.85069a4.69617,4.69617,0,0,1,1.36716,9.02319,139.24308,139.24308,0,0,0-66.11385,59.56091c-11.97436,21.29631,3.44524,47.68427,27.88614,47.68427,4.7831,0,24.79635-3.58584,54.58674,2.33393C428.58386,167.46428,487.97128,243.86849,479.15311,330.64156Z"]
  },
      Nh = {
    prefix: "fal",
    iconName: "game-board",
    icon: [512, 512, [], "f867", "M256 160h-96v96h96zm-32 64h-32v-32h32zm224 32v-96h-96v96zm-64-64h32v32h-32zM352 64h-96v96h96zm-32 64h-32V96h32zM160 256H64v96h96zm-32 64H96v-32h32zm32 128h96v-96h-96zm32-64h32v32h-32zm256 64v-96h-96v96zm-64-64h32v32h-32zm-128-32h96v-96h-96zm32-64h32v32h-32zM480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm0 480H32V32h448zM64 64v96h96V64zm64 64H96V96h32z"]
  },
      gh = {
    prefix: "fal",
    iconName: "game-board-alt",
    icon: [512, 512, [], "f868", "M480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm0 480H32V32h448zm-32-32V256H256v192zM288 288h128v128H288zM256 64H64v192h192zm-32 160H96V96h128z"]
  },
      Hh = {
    prefix: "fal",
    iconName: "game-console-handheld",
    icon: [384, 512, [], "f8bb", "M232 336a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm40-24a24 24 0 1 0 24-24 24 24 0 0 0-24 24zM352 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h256a96 96 0 0 0 96-96V32a32 32 0 0 0-32-32zm0 416a64.07 64.07 0 0 1-64 64H32V32h320zM112 224h144a32 32 0 0 0 32-32V80a16 16 0 0 0-16-16H112a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16zm16-128h128v96H128zM72 352h24v24a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-24h24a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-24v-24a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8z"]
  },
      Vh = {
    prefix: "fal",
    iconName: "gamepad",
    icon: [640, 512, [], "f11b", "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM480 384a127 127 0 0 1-91.37-38.4l-9.43-9.6H260.8l-9.41 9.6A127 127 0 0 1 160 384c-70.57 0-128-57.42-128-128s57.43-128 128-128h320c70.61 0 128 57.42 128 128s-57.43 128-128 128zM222.18 236.36h-42.54v-42.54a9.86 9.86 0 0 0-9.82-9.82h-19.64a9.86 9.86 0 0 0-9.82 9.82v42.54H97.82a9.86 9.86 0 0 0-9.82 9.82v19.64a9.86 9.86 0 0 0 9.82 9.82h42.54v42.54a9.86 9.86 0 0 0 9.82 9.82h19.64a9.86 9.86 0 0 0 9.82-9.82v-42.54h42.54a9.86 9.86 0 0 0 9.82-9.82v-19.64a9.86 9.86 0 0 0-9.82-9.82zM448 256a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm64-64a32 32 0 1 0 32 32 32 32 0 0 0-32-32z"]
  },
      xh = {
    prefix: "fal",
    iconName: "gamepad-alt",
    icon: [640, 512, [], "f8bc", "M638.59 368.22l-33.37-211.59c-8.86-50.26-48.4-90.77-100.66-103.13h-.07a803.14 803.14 0 0 0-369 0C83.17 65.86 43.64 106.36 34.78 156.63L1.41 368.22C-8.9 426.73 38.8 480 101.51 480c49.67 0 93.77-30.07 109.48-74.64l7.52-21.36h203l7.49 21.36C444.72 449.93 488.82 480 538.49 480c62.71 0 110.41-53.27 100.1-111.78zm-45.11 54.88c-13.28 15.82-33.33 24.9-55 24.9-36.2 0-68.07-21.41-79.29-53.27l-7.53-21.36-7.52-21.37H195.86l-7.53 21.37-7.53 21.36C169.58 426.59 137.71 448 101.51 448c-21.66 0-41.71-9.08-55-24.9A59.93 59.93 0 0 1 33 373.2l33.28-211c6.66-37.7 36.72-68.14 76.53-77.57a771.07 771.07 0 0 1 354.38 0c39.84 9.42 69.87 39.86 76.42 77l33.47 212.15c3.11 17.64-1.72 35.16-13.6 49.32zm-339.3-218.74h-42.54v-42.54a9.86 9.86 0 0 0-9.82-9.82h-19.64a9.86 9.86 0 0 0-9.82 9.82v42.54h-42.54a9.86 9.86 0 0 0-9.82 9.82v19.64a9.86 9.86 0 0 0 9.82 9.82h42.54v42.54a9.86 9.86 0 0 0 9.82 9.82h19.64a9.86 9.86 0 0 0 9.82-9.82v-42.54h42.54a9.86 9.86 0 0 0 9.82-9.82v-19.64a9.86 9.86 0 0 0-9.82-9.82zM416 224a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm64-64a32 32 0 1 0 32 32 32 32 0 0 0-32-32z"]
  },
      wh = {
    prefix: "fal",
    iconName: "garage",
    icon: [640, 512, [], "e009", "M368,416H272a16,16,0,0,0,0,32h96a16,16,0,0,0,0-32ZM610.59,118.33,338.59,3.75a48,48,0,0,0-37.18,0l-272,114.58A47.84,47.84,0,0,0,0,162.53V504a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V162.53a16,16,0,0,1,9.81-14.79l272-114.6a15.75,15.75,0,0,1,12.38,0l272,114.6A15.91,15.91,0,0,1,608,162.53V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V162.53A47.84,47.84,0,0,0,610.59,118.33ZM512,192H128a32,32,0,0,0-32,32V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V352H512V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V224A32,32,0,0,0,512,192Zm0,128H128V224H512Z"]
  },
      yh = {
    prefix: "fal",
    iconName: "garage-car",
    icon: [640, 512, [], "e00a", "M240,384a16,16,0,1,0,16,16A16,16,0,0,0,240,384Zm160,0a16,16,0,1,0,16,16A16,16,0,0,0,400,384ZM610.59,118.33,338.59,3.75a48,48,0,0,0-37.18,0l-272,114.58A47.84,47.84,0,0,0,0,162.53V504a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V162.53a16,16,0,0,1,9.81-14.79l272-114.6a15.75,15.75,0,0,1,12.38,0l272,114.6A15.91,15.91,0,0,1,608,162.53V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V162.53A47.84,47.84,0,0,0,610.59,118.33ZM512,192H128a32,32,0,0,0-32,32V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V224H512V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V224A32,32,0,0,0,512,192ZM443.92,337.69l-9.42-37.75A58,58,0,0,0,378.22,256H261.78A58,58,0,0,0,205.5,300l-9.42,37.73A47.88,47.88,0,0,0,160,384v48a32,32,0,0,0,32,32v32a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V464H400v32a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V464a32,32,0,0,0,32-32V384A47.88,47.88,0,0,0,443.92,337.69Zm-207.36-30A26,26,0,0,1,261.78,288H378.22a26,26,0,0,1,25.22,19.69L410.51,336h-181ZM448,432H192V384a16,16,0,0,1,16-16H432a16,16,0,0,1,16,16Z"]
  },
      bh = {
    prefix: "fal",
    iconName: "garage-open",
    icon: [640, 512, [], "e00b", "M610.59,118.33,338.59,3.75a48,48,0,0,0-37.18,0l-272,114.58A47.84,47.84,0,0,0,0,162.53V504a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V162.53a16,16,0,0,1,9.81-14.79l272-114.6a15.75,15.75,0,0,1,12.38,0l272,114.6A15.91,15.91,0,0,1,608,162.53V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V162.53A47.84,47.84,0,0,0,610.59,118.33ZM512,192H128a32,32,0,0,0-32,32V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V288H512V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V224A32,32,0,0,0,512,192Zm0,64H128V224H512Zm-68.08,81.67L439.51,320h-33l4,16h-181l4-16h-33l-4.41,17.67A47.88,47.88,0,0,0,160,384v48a32,32,0,0,0,32,32v32a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V464H400v32a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V464a32,32,0,0,0,32-32V384A47.88,47.88,0,0,0,443.92,337.69ZM448,432H192V384a16,16,0,0,1,16-16H432a16,16,0,0,1,16,16ZM240,384a16,16,0,1,0,16,16A16,16,0,0,0,240,384Zm160,0a16,16,0,1,0,16,16A16,16,0,0,0,400,384Z"]
  },
      Sh = {
    prefix: "fal",
    iconName: "gas-pump",
    icon: [512, 512, [], "f52f", "M502.6 120L409 26.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3L416 78.6V160c0 26.5 21.5 48 48 48h16v174.2c0 15.9-10.9 30.8-26.6 33.4-20 3.3-37.4-12.1-37.4-31.6v-48c0-44.2-35.8-80-80-80h-16V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v416H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h336c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-24V288h16c26.5 0 48 21.5 48 48v44.4c0 31.9 21.7 61.5 53.2 66.7 40.1 6.6 74.8-24.3 74.8-63.1V142.6c0-8.5-3.4-16.6-9.4-22.6zM480 176h-16c-8.8 0-16-7.2-16-16v-49.4l32 32V176zM288 480H64V224h224v256zm0-288H64V64c0-17.6 14.4-32 32-32h160c17.6 0 32 14.4 32 32v128z"]
  },
      Th = {
    prefix: "fal",
    iconName: "gas-pump-slash",
    icon: [640, 512, [], "f5f4", "M480 78.6V160c0 26.5 21.5 48 48 48h16v163.3l30.7 24.2c.7-3.8 1.3-7.5 1.3-11.5V142.6c0-8.5-3.4-16.6-9.4-22.6L473 26.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3zm32 32l32 32V176h-16c-8.8 0-16-7.2-16-16zm125 374.6L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zM408 480h-24V367.5l-32-25.2V480H128V165.9l-32-25.2V480H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h336c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM160 32h160c17.6 0 32 14.4 32 32v156.1l32 25.2V64c0-35.3-28.6-64-64-64H160c-21.8 0-41 10.9-52.5 27.5l25.6 20.2C138.7 38.5 148.4 32 160 32z"]
  },
      Dh = {
    prefix: "fal",
    iconName: "gavel",
    icon: [512, 512, [], "f0e3", "M500.892 186.561l-20.633-20.643c-12.912-12.912-32.416-14.337-46.732-5.448L351.53 78.474c8.888-14.315 7.465-33.82-5.448-46.731L325.44 11.108c-14.808-14.808-38.781-14.813-53.592 0L158.315 124.633c-14.774 14.775-14.774 38.815 0 53.591l20.643 20.644c12.659 12.657 32.118 14.473 46.725 5.439l29.692 29.692-58.803 58.803-8.082-8.082c-16.933-16.934-44.484-16.932-61.417 0L12.699 399.073c-16.932 16.933-16.932 44.484 0 61.417l38.81 38.811c16.931 16.932 44.482 16.933 61.417 0L227.28 384.927c16.932-16.933 16.932-44.484 0-61.417l-8.081-8.081 58.803-58.803 29.692 29.692c-9.031 14.607-7.218 34.067 5.44 46.725l20.643 20.643c14.776 14.776 38.815 14.776 53.591 0l113.525-113.533c14.808-14.809 14.811-38.781-.001-53.592zM204.653 362.3L90.3 476.652c-4.456 4.458-11.707 4.457-16.163 0v.001l-38.79-38.79c-4.456-4.456-4.456-11.707 0-16.163L149.7 307.348c4.456-4.457 11.706-4.458 16.162-.001l38.79 38.79c4.456 4.456 4.456 11.707.001 16.163zm273.62-144.776L364.74 331.058a5.896 5.896 0 0 1-8.337 0l-20.643-20.643a5.902 5.902 0 0 1-.001-8.336l16.478-16.474-125.842-125.841-16.474 16.475a5.902 5.902 0 0 1-8.336.001l-20.643-20.643a5.903 5.903 0 0 1 0-8.337L294.476 33.727a5.896 5.896 0 0 1 8.337 0l20.643 20.644a5.893 5.893 0 0 1-.001 8.336l-16.472 16.475L432.82 205.019l16.477-16.473a5.893 5.893 0 0 1 8.335 0l20.643 20.643v.001a5.893 5.893 0 0 1-.002 8.334z"]
  },
      jh = {
    prefix: "fal",
    iconName: "gem",
    icon: [576, 512, [], "f3a5", "M463.7 0H112.3c-4.2 0-8.1 2.2-10.3 5.8L1.7 168.6c-2.7 4.4-2.2 10.1 1.2 14l276 325.2c4.8 5.6 13.4 5.6 18.2 0l276-325.2c3.4-3.9 3.8-9.6 1.2-14L474 5.8c-2.2-3.6-6.1-5.8-10.3-5.8zm-13.6 36l74.3 124h-83L384.6 36h65.5zM345 36l56.8 124H174.1L231 36h114zm-219.1 0h65.5l-56.8 124h-83l74.3-124zM61.2 192h73L216 384 61.2 192zm112 0h229.5L288 455.8 173.2 192zM360 384l81.8-192h73L360 384z"]
  },
      Eh = {
    prefix: "fal",
    iconName: "genderless",
    icon: [288, 512, [], "f22d", "M144 144c61.9 0 112 50 112 112 0 61.9-50 112-112 112-61.9 0-112-50-112-112 0-61.9 50-112 112-112m0-32C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"]
  },
      kh = {
    prefix: "fal",
    iconName: "ghost",
    icon: [384, 512, [], "f6e2", "M192 0c-1.96 0-3.93.03-5.91.09C81.01 3.24 0 94.92 0 200.05v263.92C0 473.61 7.89 480 16.12 480c3.93 0 7.94-1.46 11.2-4.72l24.92-18.53c2.86-2.12 6.21-3.16 9.54-3.16 4.43 0 8.82 1.83 11.97 5.38l42.95 48.35c3.12 3.12 7.22 4.69 11.31 4.69s8.19-1.56 11.31-4.69l40.72-45.85c3.18-3.58 7.57-5.38 11.96-5.38s8.78 1.79 11.96 5.38l40.72 45.85c3.12 3.12 7.22 4.69 11.31 4.69s8.19-1.56 11.31-4.69l42.95-48.35a15.994 15.994 0 0 1 21.51-2.22l24.92 18.53c3.26 3.26 7.27 4.72 11.2 4.72 8.22 0 16.12-6.39 16.12-16.03V192C384 85.96 298.04 0 192 0zm160 431.92l-1.13-.84c-8.34-6.21-18.24-9.48-28.64-9.48-13.71 0-26.79 5.88-35.89 16.12L256 471.87l-28.11-31.65c-9.1-10.25-22.18-16.12-35.89-16.12s-26.79 5.88-35.89 16.12L128 471.87l-30.34-34.15a48.017 48.017 0 0 0-35.89-16.12c-10.39 0-20.29 3.28-28.63 9.48l-1.14.84V200.05C32 110 101.56 34.64 187.05 32.08L192 32c88.22 0 160 71.78 160 160v239.92zM128 160c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm128 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
  },
      Ih = {
    prefix: "fal",
    iconName: "gift",
    icon: [512, 512, [], "f06b", "M464 144h-39.3c9.5-13.4 15.3-29.9 15.3-48 0-44.1-33.4-80-74.5-80-42.3 0-66.8 25.4-109.5 95.8C213.3 41.4 188.8 16 146.5 16 105.4 16 72 51.9 72 96c0 18.1 5.8 34.6 15.3 48H48c-26.5 0-48 21.5-48 48v96c0 8.8 7.2 16 16 16h16v144c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304h16c8.8 0 16-7.2 16-16v-96c0-26.5-21.5-48-48-48zm-187.8-3.6c49.5-83.3 66-92.4 89.3-92.4 23.4 0 42.5 21.5 42.5 48s-19.1 48-42.5 48H274l2.2-3.6zM146.5 48c23.4 0 39.8 9.1 89.3 92.4l2.1 3.6h-91.5c-23.4 0-42.5-21.5-42.5-48 .1-26.5 19.2-48 42.6-48zM192 464H80c-8.8 0-16-7.2-16-16V304h128v160zm0-192H32v-80c0-8.8 7.2-16 16-16h144v96zm96 192h-64V176h64v288zm160-16c0 8.8-7.2 16-16 16H320V304h128v144zm32-176H320v-96h144c8.8 0 16 7.2 16 16v80z"]
  },
      Oh = {
    prefix: "fal",
    iconName: "gift-card",
    icon: [576, 512, [], "f663", "M528 128h-71.3c9.5-13.4 15.3-29.9 15.3-48 0-44.1-33.4-80-74.5-80-42.3 0-66.8 25.4-109.5 95.8C245.3 25.4 220.8 0 178.5 0 137.4 0 104 35.9 104 80c0 18.1 5.8 34.6 15.3 48H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-219.8-3.6c49.5-83.3 66-92.4 89.3-92.4 23.4 0 42.5 21.5 42.5 48s-19.1 48-42.5 48H306l2.2-3.6zM178.5 32c23.4 0 39.8 9.1 89.3 92.4l2.1 3.6h-91.5c-23.4 0-42.5-21.5-42.5-48 .1-26.5 19.2-48 42.6-48zM544 464c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16v-32h512v32zm0-64H32v-64h512v64zm0-96H32V176c0-8.84 7.16-16 16-16h201.38l-79.03 79.03c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0L288 166.62l95.03 95.03c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31L326.62 160H528c8.84 0 16 7.16 16 16v128z"]
  },
      Qh = {
    prefix: "fal",
    iconName: "gifts",
    icon: [640, 512, [], "f79c", "M608 224h-27.3c7.1-10 11.3-21.5 11.3-33.9 0-30.5-25.3-62.1-67.8-62.1-42.9 0-74.6 34.8-92.2 62.2-17.7-27.4-49.3-62.2-92.2-62.2-7.2 0-13.6 1.2-19.8 2.8V128c0-17.7-14.3-32-32-32h-70.4l43.1-30.8c3.6-2.6 4.4-7.6 1.9-11.2l-9.3-13c-2.6-3.6-7.6-4.4-11.2-1.9l-53.1 38 22.8-60.7c1.6-4.1-.5-8.7-4.7-10.3l-15-5.6c-4.1-1.6-8.8.5-10.3 4.7L160 63.3 138.2 5.2C136.6 1.1 132-1 127.9.5l-15 5.6c-4.1 1.6-6.2 6.2-4.7 10.3L131 77.1 78 39.2c-3.6-2.6-8.6-1.7-11.2 1.9l-9.3 13c-2.6 3.6-1.7 8.6 1.9 11.2l43 30.7H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-268.2-64c37.6 0 66 45.9 74.7 64H357c-21.9 0-34.4-6.2-41.1-11.4-7.8-6-11.9-13.8-11.9-22.5 0-14.8 13.4-30.1 35.8-30.1zM224 256v224H32V128h256v22c-10.3 11.4-16 25.8-16 40.1 0 12.4 4.1 23.9 11.3 33.9H256c-17.7 0-32 14.3-32 32zm192 224H256v-96h160v96zm0-128H256v-96h160v96zm108.2-192c22.4 0 35.8 15.3 35.8 30.1 0 8.7-4.1 16.5-11.9 22.5-6.7 5.2-19.2 11.4-41.1 11.4h-57.5c8.7-18.1 37.1-64 74.7-64zM608 480H448v-96h160v96zm0-128H448v-96h160v96z"]
  },
      Zh = {
    prefix: "fal",
    iconName: "gingerbread-man",
    icon: [448, 512, [], "f79d", "M224 336c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zM192 88c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm32 184c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm0-64c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm32-120c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm192 152c0-44.1-35.9-80-80-80h-39.6c10.3-23.1 12.6-49.4 5.8-75.6-9.9-38.8-41.4-70.4-80-80.5C244.2 1.3 234.1 0 224 0c-30.5 0-59.1 11.9-80.6 33.4C121.9 54.9 110 83.5 110 114c0 16 3.4 31.7 9.8 46H80c-44.1 0-80 35.9-80 80s35.9 80 80 80h27.9l-58 61.6c-27.8 34.2-22.6 84.7 11.6 112.5C75.8 505.6 93.7 512 112 512c24.2 0 46.9-10.8 62.1-29.6l49.9-51.6 49.9 51.6c15.2 18.8 37.9 29.6 62.1 29.6 18.3 0 36.2-6.4 50.4-17.9 34.2-27.8 39.4-78.3 11.6-112.5L340 320h28c44.1 0 80-35.9 80-80zm-143.4 87.1l68.6 74.6c16.7 20.6 13.6 50.8-7 67.5-8.9 7.2-19.6 10.8-30.2 10.8-14 0-27.8-6.1-37.3-17.7l-49.9-51.6c-6.4-7.9-15.6-11.8-24.8-11.8s-18.4 3.9-24.8 11.8l-49.9 51.6C139.8 474 126 480 112 480c-10.6 0-21.3-3.5-30.2-10.8-20.6-16.7-23.7-46.9-7-67.5l68.6-74.6c12.7-15.7 1.6-39.1-18.6-39.1H80c-26.5 0-48-21.5-48-48s21.5-48 48-48h81.6c9.3 0 14.2-11.5 7.3-17.7C152.4 159.4 142 138 142 114c0-45.3 36.7-82 82-82 7.2 0 14.6.9 22.1 2.9 27.6 7.2 50.1 29.8 57.1 57.5 8.3 32.5-2.7 62.7-24 81.9-6.9 6.3-2.2 17.8 7.2 17.8H368c26.5 0 48 21.5 48 48s-21.5 48-48 48h-44.7c-20.2-.1-31.4 23.3-18.7 39z"]
  },
      Uh = {
    prefix: "fal",
    iconName: "glass",
    icon: [384, 512, [], "f804", "M352 0H32A32 32 0 0 0 .06 34l32 448A32 32 0 0 0 64 512h256a32 32 0 0 0 31.94-30l32-448A32 32 0 0 0 352 0zm0 32l-9.15 128H41.14L32 32zM64 479.72L43.43 192h297.14L320 480z"]
  },
      Bh = {
    prefix: "fal",
    iconName: "glass-champagne",
    icon: [256, 512, [], "f79e", "M255 212.3L228 27.4C225.7 11.7 212.2 0 196.3 0H59.7C43.8 0 30.3 11.7 28 27.4L1 212.3c-9 68.8 41.9 129.5 111 138V480H58.7C43.9 480 32 491.9 32 506.7c0 2.9 2.4 5.3 5.3 5.3h181.3c3 0 5.3-2.4 5.3-5.3 0-14.7-11.9-26.7-26.7-26.7H144V350.3c69-8.4 120-69.2 111-138zM196.3 32l14 96H45.7l14-96h136.6zM32.7 216.9L41 160h174l8.2 56.5c3.4 25.7-4.3 50.8-21.8 70.7-18.2 20.8-45 32.8-73.4 32.8s-55.2-12-73.5-32.8c-17.4-19.9-25.1-45-21.8-70.3z"]
  },
      Rh = {
    prefix: "fal",
    iconName: "glass-cheers",
    icon: [640, 512, [], "f79f", "M605.4 437l-35 13-46-123.4c57-32.2 79.5-103.5 46.8-160.1L484.3 16c-5.9-10.2-16.6-16-27.7-16-4.1 0-8.2.8-12.2 2.4l-120.6 50c-1.4.6-6.1.6-7.5 0l-120.6-50c-4-1.7-8.1-2.4-12.2-2.4-11.1 0-21.9 5.8-27.7 16l-87 150.5c-32.7 56.6-10.2 127.9 46.8 160.1L69.6 450l-35-13c-13.8-5.1-29.1 1.9-34.3 15.7-1 2.8.4 5.8 3.1 6.9l139.9 52.2c2.8 1 5.8-.4 6.9-3.1 5.1-13.8-1.9-29.2-15.7-34.3l-35-13L145.1 339c71.1 18.7 129.8-25.6 144.6-80.7L320 145.8 350.1 258c14.9 55.4 73.8 99.4 144.6 80.7l45.6 122.4-35 13c-13.8 5.1-20.8 20.5-15.7 34.3 1 2.8 4.1 4.2 6.9 3.1l139.9-52.2c2.8-1 4.2-4.1 3.1-6.9-5-13.6-20.3-20.6-34.1-15.4zM259 249.8c-15.8 58.8-77.9 71-117.7 54.5-48.6-20.1-70.6-77-44.7-121.8l25.5-44.2 150.2 62.2-13.3 49.3zm21.6-80.5l-142.4-59L183.4 32 304 82l-23.4 87.3zM336 82l120.6-50 45.2 78.3-142.4 59L336 82zm45 167.8l-13.2-49.3L518 138.3l25.5 44.2c25.9 44.9 3.9 101.7-44.7 121.8C458 321.2 396.4 307 381 249.8z"]
  },
      Yh = {
    prefix: "fal",
    iconName: "glass-citrus",
    icon: [512, 512, [], "f869", "M368 0c-62.61 0-115.35 40.2-135.18 96h34.37c18-37.73 56.21-64 100.81-64a112 112 0 0 1 112 112c0 59.54-46.6 107.76-105.25 111.32l-3.22 32.32C449.39 285.73 512 222.32 512 144A144 144 0 0 0 368 0zm-48 128H32A32 32 0 0 0 .16 163.18l32 320A32 32 0 0 0 64 512h224a32 32 0 0 0 31.84-28.82l32-320A32 32 0 0 0 320 128zm-32 352H64L44.8 288h262.4zm22.4-224H41.6L32 160h288z"]
  },
      Ph = {
    prefix: "fal",
    iconName: "glass-martini",
    icon: [512, 512, [], "f000", "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L240 287.64V480h-53.33c-14.73 0-26.67 11.94-26.67 26.67 0 2.95 2.39 5.33 5.33 5.33h181.33c2.95 0 5.33-2.39 5.33-5.33 0-14.73-11.94-26.67-26.67-26.67H272V287.64L502.05 57.6zM256.06 258.33L32.58 34.97c-.51-.51-.82-.82-.38-1.89.44-1.08.88-1.08 1.6-1.08h444.4c.72 0 1.16 0 1.6 1.07.45 1.07.14 1.38-.38 1.89L418.39 96 256.06 258.33z"]
  },
      Fh = {
    prefix: "fal",
    iconName: "glass-martini-alt",
    icon: [512, 512, [], "f57b", "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L240 287.64V480h-53.33c-14.73 0-26.67 11.94-26.67 26.67 0 2.95 2.39 5.33 5.33 5.33h181.33c2.95 0 5.33-2.39 5.33-5.33 0-14.73-11.94-26.67-26.67-26.67H272V287.64L502.05 57.6zM32.2 33.07c.44-1.07.88-1.07 1.6-1.07h444.4c.72 0 1.16 0 1.6 1.07.45 1.07.14 1.38-.38 1.89L418.39 96H93.61L32.58 34.97c-.52-.51-.82-.82-.38-1.9zm223.86 225.26L125.61 128H386.4L256.06 258.33z"]
  },
      Wh = {
    prefix: "fal",
    iconName: "glass-whiskey",
    icon: [512, 512, [], "f7a0", "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-55.6 388.5c-2.2 15.7-15.9 27.5-31.7 27.5h-273c-15.8 0-29.4-11.8-31.7-27.9L67.2 288H445l-20.6 132.5zM450 256H62.2L32 64h448l-30 192z"]
  },
      Gh = {
    prefix: "fal",
    iconName: "glass-whiskey-rocks",
    icon: [512, 512, [], "f7a1", "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-55.6 388.5c-2.2 15.7-15.9 27.5-31.7 27.5h-273c-15.8 0-29.4-11.8-31.7-27.9L67.2 288H96v48c0 26.5 21.5 48 48 48h96c14 0 26.5-6.2 35.3-15.9l10.8 10.8c9.1 9.1 21.1 14.1 33.9 14.1 12.8 0 24.9-5 33.9-14.1l57-57c9.4-9.4 14-21.7 14-33.9H445l-20.6 132.5zM251.7 299.3c-6.2-6.2-6.2-16.4 0-22.6l57-57c3.1-3.1 7.2-4.7 11.3-4.7 4.1 0 8.2 1.6 11.3 4.7l57 57c6.2 6.2 6.2 16.4 0 22.6l-57 57c-3.1 3.1-7.2 4.7-11.3 4.7-4.1 0-8.2-1.6-11.3-4.7l-57-57zm-22.6-45.2c-18.7 18.7-18.7 49.2 0 67.9l23.5 23.5c-2.9 3.9-7.3 6.6-12.6 6.6h-96c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h96c5.2 0 9.7 2.7 12.6 6.6l-23.5 23.4zM450 256h-37.8c-.5-.6-.7-1.4-1.3-1.9l-57-57c-9-9.1-21.1-14.1-33.9-14.1-12.8 0-24.9 5-33.9 14.1l-10.8 10.8C266.5 198.2 254 192 240 192h-96c-26.5 0-48 21.5-48 48v16H62.2L32 64h448l-30 192z"]
  },
      qh = {
    prefix: "fal",
    iconName: "glasses",
    icon: [576, 512, [], "f530", "M574.21 280.58l-45.49-188c-5.38-21.55-19.62-40.05-39.09-50.73-19.47-10.66-42.66-12.8-63.81-5.77l-22.85 7.62c-4.19 1.4-6.46 5.93-5.06 10.12L402.97 69c1.4 4.19 5.93 6.46 10.12 5.06l21.79-7.27c10.1-3.37 21.16-3.95 31.23-.48 16.15 5.56 27.57 18.12 31.51 33.84l40.61 171.44c-22.35-7.63-53.24-15.06-89.57-15.06-37.34 0-80.26 8-125 31.48h-71.31c-44.74-23.48-87.66-31.49-125-31.48-36.33 0-67.22 7.44-89.58 15.07l40.57-171.24c3.36-13.44 11.99-24.44 24.29-30.9 12.24-6.43 26.88-6.51 39.99-2.14l20.28 6.77c4.19 1.4 8.72-.87 10.12-5.06l5.06-15.18c1.4-4.19-.87-8.72-5.06-10.12l-22.85-7.61c-21.09-7.06-44.31-4.95-63.81 5.75-19.45 10.68-33.7 29.18-39.11 50.91L1.8 280.58C.6 285.51 0 290.56 0 295.64v73.64C0 430.43 50.14 480 112 480h36.08c58.61 0 107.3-44.67 111.69-102.44l4.37-57.56h47.72l4.37 57.56C320.61 435.34 369.31 480 427.92 480H464c61.86 0 112-49.57 112-110.72v-73.65c0-5.07-.6-10.12-1.79-15.05zm-346.35 94.56C224.76 416 189.72 448 148.08 448H112c-44.11 0-80-35.31-80-78.72v-61.3c18.79-7.97 53.21-19.46 95.37-19.46 36.35 0 71.64 8.44 105.16 25.13l-4.67 61.49zM544 369.28c0 43.41-35.89 78.72-80 78.72h-36.08c-41.63 0-76.68-32-79.78-72.86l-4.67-61.49c33.53-16.68 68.83-25.13 105.19-25.13 42.16 0 76.56 11.49 95.34 19.46v61.3z"]
  },
      Jh = {
    prefix: "fal",
    iconName: "glasses-alt",
    icon: [576, 512, [], "f5f5", "M572.39 302.63L528.75 92.78c-5.41-21.73-19.66-40.23-39.12-50.92-19.5-10.7-42.72-12.81-63.81-5.75l-22.85 7.61c-4.19 1.4-6.46 5.93-5.06 10.12l5.06 15.18c1.4 4.19 5.93 6.46 10.12 5.06l20.28-6.77c13.11-4.37 27.75-4.29 39.99 2.14 12.3 6.46 20.94 17.46 24.29 30.9l30.45 140.84C504.32 220.78 473.79 208 440 208c-66.89 0-122.21 48.38-133.58 112h-36.84C258.21 256.38 202.89 208 136 208c-33.79 0-64.32 12.78-88.1 33.18l30.45-140.84c3.36-13.44 11.99-24.44 24.29-30.9 12.24-6.43 26.88-6.51 39.99-2.14l20.28 6.77c4.19 1.4 8.72-.87 10.12-5.06l5.06-15.18c1.4-4.19-.87-8.72-5.06-10.12l-22.85-7.61c-21.09-7.06-44.31-4.95-63.81 5.75-19.46 10.7-33.71 29.2-39.12 50.93L3.61 302.63A172.5 172.5 0 0 0 0 336v8c0 75.11 60.89 136 136 136 72.37 0 130.97-56.69 135.19-128h33.61c4.22 71.31 62.82 128 135.19 128 75.11 0 136-60.89 136-136v-8c-.1-11.21-1.32-22.39-3.6-33.37zM136 448c-57.35 0-104-46.65-104-104s46.65-104 104-104 104 46.65 104 104-46.65 104-104 104zm304 0c-57.35 0-104-46.65-104-104s46.65-104 104-104 104 46.65 104 104-46.65 104-104 104z"]
  },
      Kh = {
    prefix: "fal",
    iconName: "globe",
    icon: [496, 512, [], "f0ac", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm193.2 152h-82.5c-9-44.4-24.1-82.2-43.2-109.1 55 18.2 100.2 57.9 125.7 109.1zM336 256c0 22.9-1.6 44.2-4.3 64H164.3c-2.7-19.8-4.3-41.1-4.3-64s1.6-44.2 4.3-64h167.4c2.7 19.8 4.3 41.1 4.3 64zM248 40c26.9 0 61.4 44.1 78.1 120H169.9C186.6 84.1 221.1 40 248 40zm-67.5 10.9c-19 26.8-34.2 64.6-43.2 109.1H54.8c25.5-51.2 70.7-90.9 125.7-109.1zM32 256c0-22.3 3.4-43.8 9.7-64h90.5c-2.6 20.5-4.2 41.8-4.2 64s1.5 43.5 4.2 64H41.7c-6.3-20.2-9.7-41.7-9.7-64zm22.8 96h82.5c9 44.4 24.1 82.2 43.2 109.1-55-18.2-100.2-57.9-125.7-109.1zM248 472c-26.9 0-61.4-44.1-78.1-120h156.2c-16.7 75.9-51.2 120-78.1 120zm67.5-10.9c19-26.8 34.2-64.6 43.2-109.1h82.5c-25.5 51.2-70.7 90.9-125.7 109.1zM363.8 320c2.6-20.5 4.2-41.8 4.2-64s-1.5-43.5-4.2-64h90.5c6.3 20.2 9.7 41.7 9.7 64s-3.4 43.8-9.7 64h-90.5z"]
  },
      Xh = {
    prefix: "fal",
    iconName: "globe-africa",
    icon: [496, 512, [], "f57c", "M248 8C111.04 8 0 119.03 0 256s111.04 248 248 248 248-111.03 248-248S384.96 8 248 8zm193.21 152H423.5c-17.38 0-31.5 14.12-31.5 31.5l.28 6.47-12.62 6.69c-2.66.48-8.41.66-15.09.97-32.31 1.52-46.88 2.67-52.91 14.61l-4 10.12 18.44 27.61A31.427 31.427 0 0 0 352.29 272l7.72-.5.09 11.02-18.81 25.09a31.937 31.937 0 0 0-5.66 12.97l-4.19 22.56c-10.38 9.5-19.62 20.3-27.47 32.08l-13.03 19.53c-4.66 6.98-16.53 6.33-20.28-1.28a62.926 62.926 0 0 1-6.66-28.09V335.5c0-17.38-14.12-31.5-31.5-31.5h-25.88c-10.31 0-20-4.02-27.31-11.31-7.28-7.3-11.31-17-11.31-27.31v-14.06c0-12.09 5.78-23.66 15.44-30.91l27.62-20.69c10.94-8.27 27.72-10.42 41.31-3.64l14.72 7.36c7.5 3.73 16.03 4.38 24.06 1.7l47.31-15.77a31.466 31.466 0 0 0 21.53-29.88c0-17.38-14.12-31.5-31.5-31.5l-9.72.16-6.94-6.94c-5.94-5.94-13.84-9.22-22.25-9.22l-89.58.51-.38-3.92 14.44-3.61c7.66-1.91 14.25-6.56 18.56-13.06L240.28 80h24.22c17.38 0 31.5-14.12 31.5-31.5v-2.94C359.74 60.1 412.7 102.86 441.21 160zM248 472c-119.1 0-216-96.9-216-216S128.9 40 248 40c5.54 0 10.96.42 16.39.83l.11 7.17h-24.22c-10.53 0-20.34 5.25-26.19 14.02l-7.78 11.92-14.47 3.61C177.81 81.08 168 93.64 168 108.09v4.41c0 17.38 14.12 31.5 31.5 31.5l89.72-.16 6.94 6.94c5.94 5.95 13.84 9.22 22.25 9.22l9.94-.97-46.94 15.78-14.72-7.36c-22.34-11.17-53.38-9.5-74.84 6.67l-27.59 20.69c-17.7 13.27-28.26 34.39-28.26 56.5v14.06c0 18.86 7.34 36.59 20.69 49.94S187.75 336 206.62 336l25.38-.5v29.88c0 14.69 3.47 29.38 10.03 42.42 7.44 14.92 22.44 24.2 39.12 24.2 14.66 0 28.25-7.28 36.41-19.48l13.03-19.55c6.44-9.64 14-18.47 22.41-26.17 5.09-4.62 8.47-10.66 9.75-17.45l4.22-22.62 18.75-25c4.06-5.42 6.28-12.12 6.28-18.89V271.5c0-17.38-14.12-31.5-31.5-31.5l-7.78.2-1.22-1.83c5.38-.34 10.81-.61 14.53-.78 15.88-.73 20.66-1.05 25.16-3.3l15.41-7.7c10.75-5.38 17.41-16.17 17.41-28.17l-.5-6.42h30.81c6.29 20.23 9.69 41.73 9.69 64C464 375.1 367.1 472 248 472z"]
  },
      _h = {
    prefix: "fal",
    iconName: "globe-americas",
    icon: [496, 512, [], "f57d", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm215.72 253.45l-42.82-10.71c-1.97-.5-3.66-1.67-4.75-3.33l-17.97-26.97a8.05 8.05 0 0 1 0-8.88l19.59-29.39c.78-1.16 1.81-2.09 3.06-2.7l23.97-11.99C457.03 194.53 464 224.44 464 256c0 1.84-.23 3.62-.28 5.45zM32 256c0-11.92 1.22-23.53 3.09-34.93 7.16 10.6 14.52 21.46 19.91 29.36 5.88 8.67 12.81 16.61 21.38 24.34 10.72 9.69 22.56 17.83 35.16 24.16 13.81 6.97 34.06 17.95 48.28 25.83 5.03 2.8 8.19 8.16 8.19 13.97v32.02c0 12.81 5 24.88 14.06 33.94 12.66 12.66 18.91 31.67 17.94 39.94v21.81C103.95 444.53 32 358.59 32 256zm199.92 215.19l-.08-24.44c2.5-18.58-9.44-46.98-27.16-64.69-2.97-2.98-4.69-7.11-4.69-11.31v-32.02c0-17.47-9.47-33.55-24.72-41.97-14.5-8.03-35.19-19.27-49.34-26.41-10.06-5.05-19.53-11.56-28.94-20.05a100.36 100.36 0 0 1-15.56-17.89c-9.66-14.19-25.54-37.72-35.4-52.35 25.98-68.87 85.98-121.14 159.56-135.85L257.38 96l-15.03 15.03c-9.03 9.03-9.34 23.53-.94 32.94l-5.72.03c-6.25 0-12.19 2.41-16.72 6.8l-9.91 9.64c-7.56 7.3-9.47 18.53-4.75 27.95l4 7.98c-6.94-2.75-14.78-3.12-22.03-.66l-31.19 10.39A27.893 27.893 0 0 0 136 232.6c0 10.66 5.91 20.23 15.44 25l11.09 5.55c10.72 5.36 22.62 8.38 34.62 8.8 2.38 2.3 6.25 7.56 8.69 10.89 5.91 8.08 11.5 15.72 19 19.47l3.38 1.69h70.53c4.22 0 8.34 1.7 11.31 4.69l13.69 13.69a14.66 14.66 0 0 1 4.25 10.27c0 8.05-3.28 15.92-9.06 21.66l-11.34 11.33a39.93 39.93 0 0 0-10.25 17.88l-1.12 4.41c-.94 3.69-1.84 7.38-3.19 11l-26.78 72.17c-6.03.51-12.09.92-18.25.92-5.44-.02-10.76-.44-16.09-.83zm70.82-6.49L323 410.09c1.78-4.7 3.03-9.53 4.25-14.36l1.03-4.05c.34-1.31 1.06-2.55 4.09-5.58l9.19-9.16c11.72-11.64 18.44-27.8 18.44-44.31 0-12.25-4.97-24.23-13.62-32.89l-13.69-13.69c-8.94-8.94-21.31-14.06-33.94-14.06h-60.94c-1.91-2.23-4.34-5.59-6.16-8.06C223.44 252.72 214.12 240 200 240c-8 0-16-1.89-23.16-5.47l-2.34-1.17 21.91-7.3 9.28 8.06c4.38 3.78 9.94 5.88 15.72 5.88h5.66c8.38 0 16-4.25 20.41-11.39 4.41-7.12 4.81-15.86 1.06-23.34l-12.97-25.95 3.38-3.31h5.75c6.41 0 12.44-2.5 16.97-7.03l8-8c9.03-9.03 9.34-23.53.94-32.94l9.41-9.41c6.03-6.05 9.38-14.08 9.38-22.62s-3.34-16.58-9.38-22.62l-33.31-33.31c.44 0 .87-.07 1.31-.07 76.13 0 143.04 39.68 181.52 99.35l-22.98 11.49a39.974 39.974 0 0 0-15.38 13.58l-19.59 29.39c-9 13.48-9 30.89 0 44.38l17.97 26.97c5.53 8.28 13.88 14.17 23.59 16.61l47.38 11.84c-14.72 83.15-77.04 149.87-157.79 171.08z"]
  },
      $h = {
    prefix: "fal",
    iconName: "globe-asia",
    icon: [496, 512, [], "f57e", "M248 8C111.04 8 0 119.03 0 256s111.04 248 248 248 248-111.03 248-248S384.96 8 248 8zm0 32c18.88 0 37.09 2.68 54.55 7.25l-51.93 43.78c-7.12 4.72-11.19 12.94-10.69 21.44.53 8.53 5.62 16.19 13.25 20.02l10.81 5.41v64.19c-1.75-.55-3.56-.88-5.44-.94-7.12 0-14.47 3.56-18.25 9.91L222.62 240c-8.53 0-16.59 3.33-22.62 9.38l-5.66 5.66c-4.53 4.53-7.03 10.56-7.03 16.97s2.5 12.44 7.03 16.97l5.66 5.66V304h-22.12l-22.59-45.23a23.997 23.997 0 0 0-17.66-12.95c-7.38-1.23-15.38 1.28-20.78 6.72L97.38 272H32.81c-.39-5.3-.81-10.6-.81-16 0-119.1 96.9-216 216-216zM37.56 304h59.81c8.53 0 16.59-3.33 22.62-9.38l11.62-11.61 17.62 35.31c5.47 10.91 16.44 17.67 28.62 17.67H200c17.66 0 32-14.36 32-32v-9.38c0-8.34-3.34-16.53-9.22-22.47l.16-.16c11.19 0 21.72-5.97 27.44-15.53l10.84-18.06c3.16 1.03 6.75 1.59 10.78 1.59 13.22 0 24-10.77 24-24v-78.11c0-12.16-6.72-23.09-17.56-28.56l59.07-49.67C412.01 93.76 464 168.84 464 256c0 22.71-3.57 44.58-10.09 65.16-1.32-1.77-2.38-3.7-3.96-5.29l-4.88-4.88V308c0-19.85-16.15-36-36-36H403c-5.5 0-10.79 1.27-15.55 3.57a40.04 40.04 0 0 0-16.56-3.57H358.8c-8.37 0-16.39 2.57-23.21 7.42l-23.72 16.9-38.25 15.14c-15.28 6.11-25.14 20.69-25.14 37.14v10.21c0 10.68 4.16 20.73 11.71 28.28L272.11 399c9.06 9.06 21.12 14.06 33.94 14.06h10.34c3.92 0 7.84-.48 11.64-1.43l18.39-4.6 10.91 10.91c5.38 5.38 11.89 9.13 18.93 11.45C340.34 456.03 296.06 472 248 472c-102.59 0-188.53-71.95-210.44-168zM409 399.49c-.87.14-1.68.51-2.57.51h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.78 26.78 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a8.05 8.05 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.17 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v18.75A216.64 216.64 0 0 1 409 399.49z"]
  },
      cm = {
    prefix: "fal",
    iconName: "globe-europe",
    icon: [496, 512, [], "f7a2", "M184 119.2c0-7-5.7-12.7-12.7-12.7h-.1c-3.4 0-6.6 1.3-8.9 3.7l-28.5 28.5c-2.4 2.4-3.7 5.6-3.7 8.9v.1c0 7 5.7 12.7 12.7 12.7h18c3.4 0 6.6-1.3 8.9-3.7l10.5-10.5c2.4-2.4 3.7-5.6 3.7-8.9v-18.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm48 458.4V432c0-26.5-21.5-48-48-48h-20.2c-3.9 0-13.1-3.1-16.2-5.4l-22.2-16.7c-3.4-2.5-5.4-6.6-5.4-10.8v-23.9c0-4.7 2.5-9.1 6.5-11.6l42.9-25.7c2.1-1.3 4.5-1.9 6.9-1.9h31.2c3.2 0 6.3 1.2 8.8 3.2l52.2 44.8h30.2l17.3 17.3c9.5 9.5 22.1 14.7 35.5 14.7h16.8c-29.9 49.1-78.7 85.3-136.3 98.4zM448.5 336h-32.9c-4.8 0-9.5-1.9-12.9-5.3l-17.3-17.3c-6-6-14.1-9.4-22.6-9.4h-18.3l-43.2-37.1c-8.2-7.1-18.7-10.9-29.6-10.9h-31.2c-8.2 0-16.3 2.2-23.4 6.5l-42.9 25.7c-13.7 8.2-22.1 23-22.1 39v23.9c0 14.3 6.7 27.8 18.2 36.4l22.2 16.7c8.6 6.5 24.6 11.8 35.4 11.8h20.2c8.8 0 16 7.2 16 16v39.2c-5.3.4-10.6.8-16 .8-119.1 0-216-96.9-216-216 0-118.9 96.5-215.6 215.3-216L232 51.1c-10.2 7.7-16 19.2-16 31.4v23.2c0 6.4 3.1 17 5.9 22.3-.8 2.1-21.1 15-24.6 18.5-8.6 8.6-13.3 20-13.3 32.1V195c0 25 20.4 45.4 45.4 45.4h25.3c11 0 21.2-3.9 29.2-10.6 3.9 1.4 8.2 2.1 12.6 2.1h13.4c25.6 0 32.2-20.2 36.1-21.5 5.1 9.1 13.5 16.2 23.5 19.5-4.3 14.2-.9 30.3 10.1 41.6l18.2 19.1c8.7 8.9 20.6 13.9 32.7 13.9h27.7c-2.4 10.8-5.7 21.3-9.7 31.5zm-17.8-63.6c-3.6 0-7.1-1.5-9.6-4L402.6 249a9.93 9.93 0 0 1 .1-14c12.6-12.6 10.5-8.6 10.5-17.8 0-2.5-1-4.9-2.8-6.7l-7.9-7.9c-1.8-1.8-4.2-2.8-6.7-2.8h-13.4c-8.5 0-12.6-10.3-6.7-16.2l7.9-7.3c1.8-1.8 4.2-2.8 6.7-2.8h8.3c5.2 0 9.5-4.2 9.5-9.5v-10.2c0-5.2-4.2-9.5-9.5-9.5h-28.2c-7.4 0-13.4 6-13.4 13.4v5.6c0 5.8-3.7 10.9-9.2 12.7l-26.5 8.8c-4.3 1.4-4.6 5-4.6 8.2 0 3.7-3 6.7-6.7 6.7h-13.4c-3.7 0-6.7-3-6.7-6.7 0-8.4-12.5-8.6-15.3-3-9 12.4-11.5 18.2-19.9 18.2h-25.3c-7.4 0-13.4-6-13.4-13.4v-16.4c0-3.6 1.4-7 3.9-9.5 19.5-14 29.6-17.6 29.6-31.5 0-2.9 1.8-5.5 4.6-6.4l33.6-11.2c1.4-.5 2.7-1.2 3.7-2.3L313.9 95c5-5 3.5-14.9-6.7-14.9h-17.4L276.4 99v6.7c0 3.7-3 6.7-6.7 6.7h-15c-3.7 0-6.7-3-6.7-6.7V82.5c0-2.1 1-4.1 2.7-5.4l44-31.9C391.4 66.7 464 153 464 256c0 5.5-.4 11-.8 16.4h-32.5z"]
  },
      em = {
    prefix: "fal",
    iconName: "globe-snow",
    icon: [448, 512, [], "f7a3", "M224 96c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-112 80c0-8.8-7.2-16-16-16s-16 7.2-16 16 7.2 16 16 16 16-7.2 16-16zm208-16c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm43.3 239c51.5-41 84.7-104 84.7-175C448 100.3 347.7 0 224 0S0 100.3 0 224c0 71 33.2 134 84.7 175l-46.3 61.8C22.6 481.9 37.6 512 64 512h320c26.4 0 41.4-30.1 25.6-51.2L363.3 399zM32 224c0-105.9 86.1-192 192-192s192 86.1 192 192c0 66.7-34.3 125.6-86.1 160H240v-32h80c12.3 0 23.5-7 28.8-18.1 5.3-11.1 3.8-24.2-3.8-33.8l-19.7-24.6c1.3-1.7 2.4-3.5 3.3-5.4 5.3-11 3.9-24.2-3.7-33.8L249.1 140c-6.1-7.7-15.3-12.2-25.1-12.2s-19.1 4.5-25.1 12.2l-76 96.3c-7.6 9.6-9 22.8-3.6 33.8.9 1.9 2.1 3.7 3.3 5.4L103 300c-7.7 9.6-9.2 22.8-3.8 33.8C104.5 345 115.7 352 128 352h80v32h-89.9C66.3 349.6 32 290.7 32 224zm116 32.1l76-96.3 75.9 96.2h-31l51.1 64h-80v-88c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v88h-80l51.1-64-31.1.1zM64 480l48-64h224l48 64H64z"]
  },
      am = {
    prefix: "fal",
    iconName: "globe-stand",
    icon: [448, 512, [], "f5f6", "M360.21 480H240.14v-50.41c50.37-6.61 99.04-29.15 137.79-67.89 87.21-87.16 92.85-224.41 17.84-318.61l18.14-18.12a7.985 7.985 0 0 0 0-11.31L402.58 2.34a8.015 8.015 0 0 0-11.32 0l-39.45 39.43c1.14 1.09 2.36 2.04 3.48 3.15 39.31 39.29 60.96 91.52 60.96 147.08s-21.65 107.79-60.96 147.08C315.98 378.36 263.71 400 208.12 400s-107.86-21.64-147.17-60.92c-1.11-1.11-2.07-2.34-3.15-3.47L2.35 391.03a7.985 7.985 0 0 0 0 11.31l11.32 11.31a8.015 8.015 0 0 0 11.32 0l34.14-34.12c43.54 34.62 96.26 51.83 149 51.97V480H88.04c-13.26 0-24.01 10.74-24.01 24 0 4.42 3.58 8 8 8h304.19c4.42 0 8-3.58 8-8 .01-13.26-10.74-24-24.01-24zM208.12 368c45.07 0 90.14-17.18 124.53-51.55 68.77-68.73 68.77-180.17 0-248.9C298.26 33.18 253.19 16 208.12 16S117.98 33.18 83.59 67.55c-68.77 68.73-68.77 180.17 0 248.9C117.98 350.82 163.05 368 208.12 368zM106.23 90.18C133.45 62.98 169.63 48 208.12 48s74.67 14.98 101.89 42.18c27.21 27.2 42.2 63.36 42.2 101.82 0 38.46-14.99 74.62-42.2 101.82-27.22 27.2-63.4 42.18-101.89 42.18s-74.67-14.98-101.89-42.18c-27.21-27.2-42.2-63.36-42.2-101.82 0-38.46 14.99-74.62 42.2-101.82z"]
  },
      nm = {
    prefix: "fal",
    iconName: "golf-ball",
    icon: [416, 512, [], "f450", "M416 208C416 91.7 320.5-2.3 203.7 0 91.6 2.3.9 94.2 0 206.3-.5 273.5 31 333 80 371.4V416c0 26.5 21.5 48 48 48 7.3 0 32-4 32 16v26c0 3.3 2.7 6 6 6h20c3.3 0 6-2.7 6-6v-26c0-26.5-21.5-48-48-48-7.3 0-32 4-32-16v-16h192v16c0 20-24.6 16-32 16-26.5 0-48 21.5-48 48v26c0 3.3 2.7 6 6 6h20c3.3 0 6-2.7 6-6v-26c0-20 24.6-16 32-16 26.5 0 48-21.5 48-48v-44.6c48.6-38 80-96.9 80-163.4zm-384 0c0-97 79-176 176-176s176 79 176 176c0 71-42.4 132.2-103.1 160H135.1C74.4 340.2 32 279 32 208zm240 14.9c0 18.3-14.8 33.1-33.1 33.1-14.4 0-26.3-9.3-30.9-22.1 26.3 9.4 51.5-15.2 41.9-41.9 12.8 4.6 22.1 16.5 22.1 30.9zm80 16c0 18.3-14.8 33.1-33.1 33.1-14.4 0-26.3-9.3-30.9-22.1 26.3 9.4 51.5-15.2 41.9-41.9 12.8 4.6 22.1 16.5 22.1 30.9zm-64 64c0 18.3-14.8 33.1-33.1 33.1-14.4 0-26.3-9.3-30.9-22.1 26.3 9.4 51.5-15.2 41.9-41.9 12.8 4.6 22.1 16.5 22.1 30.9z"]
  },
      tm = {
    prefix: "fal",
    iconName: "golf-club",
    icon: [640, 512, [], "f451", "M633.2 6.4l-10.8-5.2c-6-2.9-13.1-.4-16 5.6L473 280.7C44 200.2 72.8 205.1 63.9 205.1c-34.5 0-63.9 28-63.9 64V448c0 35.3 28.7 64 64 64h299.1c24.6 0 47-14.1 57.7-36.3l218-453.3c2.9-5.9.4-13.1-5.6-16zm-183.9 323L393.5 444c-10.7 22-33.1 36-57.5 36H64c-17.7 0-32-14.3-32-32v-16h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H32v-64h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H32v-34.9c0-17.7 14.3-32 31.9-32 4.5 0-19.7-4.3 374 69.6 10.4 1.9 16.1 13.2 11.4 22.7z"]
  },
      rm = {
    prefix: "fal",
    iconName: "gopuram",
    icon: [512, 512, [], "f664", "M277.3 416h-42.7c-23.6 0-42.7 19.1-42.7 42.7V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-45.3c0-5.9 4.8-10.7 10.7-10.7h42.7c5.9 0 10.7 4.8 10.7 10.7V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-45.3c0-23.6-19.1-42.7-42.7-42.7zM496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v136c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V384h64v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V384h256v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V384h64v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V368c0-8.8-7.2-16-16-16zM128 64h256v64H128zm133.3 128h-10.7c-5.9 0-10.7 4.8-10.7 10.7V224h-48v-64h128v64h-48v-21.3c.1-5.9-4.7-10.7-10.6-10.7zM128 352H64v-96h64zm32-128H96v-64h64zm112 128h-32v-26.7c0-3 2.4-5.3 5.3-5.3h21.3c3 0 5.3 2.4 5.3 5.3V352zm80 0h-48v-26.7c0-20.6-16.8-37.3-37.3-37.3h-21.3c-20.6 0-37.3 16.8-37.3 37.3V352h-48v-96h192v96zm0-128v-64h64v64zm96 128h-64v-96h64z"]
  },
      im = {
    prefix: "fal",
    iconName: "graduation-cap",
    icon: [640, 512, [], "f19d", "M612.16 153.99l-265-85.68c-17.81-5.75-36.5-5.75-54.31 0l-265 85.68C10.94 159.46 0 174.38 0 192s10.94 32.54 27.84 38.01l29.71 9.6c-3.3 6.18-5.74 12.83-7.33 19.8C39.53 264.59 32 275.32 32 288c0 12.73 7.57 23.52 18.33 28.67L32.28 428.53C30.67 438.52 36.19 448 43.62 448h40.75c7.43 0 12.96-9.48 11.34-19.47L77.67 316.67C88.43 311.52 96 300.73 96 288c0-10.6-5.49-19.54-13.43-25.37 1.49-4.66 3.8-8.86 6.57-12.81l53.47 17.29L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.61-116.89L612.16 230c16.9-5.46 27.84-20.38 27.84-38s-10.94-32.54-27.84-38.01zM479.48 381.86C468.72 393.19 414.04 416 320 416c-94.04 0-148.72-22.81-159.48-34.14l13.09-104.73 119.24 38.55c2.6.84 25.72 9.23 54.31 0l119.24-38.55 13.08 104.73zm122.8-182.28l-265 85.68c-11.31 3.66-23.25 3.66-34.56 0l-175.67-56.8 195.89-36.74c8.69-1.62 14.41-9.98 12.78-18.67-1.62-8.7-10.16-14.39-18.66-12.77l-203.78 38.2c-12.4 2.32-23.51 7.65-33.08 14.83l-42.49-13.74c-7.85-2.55-7.46-12.74 0-15.15l265-85.68c15.1-4.88 27.84-2.17 34.56 0l265 85.68c7.39 2.39 7.91 12.6.01 15.16z"]
  },
      om = {
    prefix: "fal",
    iconName: "gramophone",
    icon: [384, 512, [], "f8bd", "M45.51 314.12a32 32 0 0 0 36.57.28c59.69-40.87 119.58-66.14 178-75 1.45-.18 75.92-10.49 75.92 40.6a40 40 0 0 1-40 40H192a32 32 0 0 0-32 32h130.41c36.73 0 70.27-25.2 76.48-61.4 7.82-45.66-10.28-55.79-88.76-118.51C232 135.21 192.72 83.42 161.45 18.17A32 32 0 0 0 132.61 0a29.52 29.52 0 0 0-3 .14 32 32 0 0 0-28 23.58l-68.59 256a32 32 0 0 0 12.49 34.4zM132.57 32C166 101.63 208.2 157.17 258.15 197.09l11.32 9c-4.58.4-9.32 1-14.18 1.7C192.06 217.4 127.7 244.38 64 288zM376 480h-24v-64a32 32 0 0 0-32-32H64a32 32 0 0 0-32 32v64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h368a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm-56 0H64v-64h256z"]
  },
      lm = {
    prefix: "fal",
    iconName: "greater-than",
    icon: [320, 512, [], "f531", "M320 250.17c0-3.02-1.7-5.78-4.4-7.14L25.87 96.85c-3.95-1.98-8.76-.37-10.73 3.58L.84 129.05a8.006 8.006 0 0 0 3.58 10.73L236.87 256 4.42 372.22C.47 374.19-1.13 379 .84 382.95l14.29 28.62c1.97 3.95 6.78 5.56 10.73 3.58l289.71-144.92a8.007 8.007 0 0 0 4.42-7.15v-12.91z"]
  },
      fm = {
    prefix: "fal",
    iconName: "greater-than-equal",
    icon: [384, 512, [], "f532", "M32.84 318.95l14.29 28.62a7.986 7.986 0 0 0 10.73 3.58l289.71-144.92a7.996 7.996 0 0 0 4.42-7.15v-12.91c0-3.02-1.7-5.78-4.4-7.14L57.87 32.85c-3.95-1.98-8.76-.37-10.73 3.58l-14.3 28.62a8.006 8.006 0 0 0 3.58 10.73L268.87 192 36.42 308.22a8.006 8.006 0 0 0-3.58 10.73zM376 432H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"]
  },
      sm = {
    prefix: "fal",
    iconName: "grimace",
    icon: [496, 512, [], "f57f", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm-80-232c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 32H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"]
  },
      um = {
    prefix: "fal",
    iconName: "grin",
    icon: [496, 512, [], "f580", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm123.1-151.2C340.9 330.5 296 336 248 336s-92.9-5.5-123.1-15.2c-5.3-1.7-11.1-.5-15.3 3.1-4.2 3.7-6.2 9.2-5.3 14.8 9.2 55 83.2 93.3 143.8 93.3s134.5-38.3 143.8-93.3c.9-5.5-1.1-11.1-5.3-14.8-4.3-3.7-10.2-4.9-15.5-3.1zM248 400c-35 0-77-16.3-98.5-40.3 57.5 10.8 139.6 10.8 197.1 0C325 383.7 283 400 248 400zm-80-160c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"]
  },
      hm = {
    prefix: "fal",
    iconName: "grin-alt",
    icon: [496, 512, [], "f581", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm-63.7-216c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm160 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm26.8 64.8C340.9 330.5 296 336 248 336s-92.9-5.5-123.1-15.2c-5.3-1.7-11.2-.5-15.3 3.1-4.2 3.7-6.2 9.2-5.3 14.8 9.2 55 83.2 93.3 143.8 93.3s134.5-38.3 143.8-93.3c.9-5.5-1.1-11.1-5.3-14.8-4.3-3.7-10.2-4.9-15.5-3.1zM248 400c-35 0-77-16.3-98.5-40.3 57.5 10.8 139.6 10.8 197.1 0C325 383.7 283 400 248 400z"]
  },
      mm = {
    prefix: "fal",
    iconName: "grin-beam",
    icon: [496, 512, [], "f582", "M117.7 247.7c3.4 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.4 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm93.4 73.1C340.9 330.5 296 336 248 336s-92.9-5.5-123.1-15.2c-5.3-1.7-11.1-.5-15.3 3.1-4.2 3.7-6.2 9.2-5.3 14.8 9.2 55 83.2 93.3 143.8 93.3s134.5-38.3 143.8-93.3c.9-5.5-1.1-11.1-5.3-14.8-4.3-3.7-10.2-4.9-15.5-3.1zM248 400c-35 0-77-16.3-98.5-40.3 57.5 10.8 139.6 10.8 197.1 0C325 383.7 283 400 248 400zm0-392C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216z"]
  },
      vm = {
    prefix: "fal",
    iconName: "grin-beam-sweat",
    icon: [504, 512, [], "f583", "M277.7 247.7c3.4 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm-160 0c3.4 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm253.4 73.1C340.9 330.5 296 336 248 336s-92.9-5.5-123.1-15.2c-5.3-1.7-11.1-.5-15.3 3.1-4.2 3.7-6.2 9.2-5.3 14.8 9.2 55 83.2 93.3 143.8 93.3s134.5-38.3 143.8-93.3c.9-5.5-1.1-11.1-5.3-14.8-4.3-3.7-10.2-4.9-15.5-3.1zM248 400c-35 0-77-16.3-98.5-40.3 57.5 10.8 139.6 10.8 197.1 0C325 383.7 283 400 248 400zm256-282.7c0-27.2-28-72.9-51.4-106.4C448.8 5.4 440.4 0 432 0c-8.4 0-16.8 5.4-20.6 10.8-8.4 12-17.3 25.5-25.3 39.2-39.5-26.5-87-42-138.1-42C111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-29.6-5.5-57.9-15-84.3 14.1-13.6 23-32.9 23-54.4zM248 472c-119.1 0-216-96.9-216-216S128.9 40 248 40c45.7 0 88 14.4 123 38.7-6.6 14.5-11 28-11 38.6 0 41.2 32.3 74.7 72 74.7 7.4 0 14.3-1.5 21-3.6 7 21.3 11 44 11 67.6 0 119.1-96.9 216-216 216zm184-312c-22.1 0-40-19.2-40-42.7 0-12.9 15.5-43.8 40-79.9 24.5 36.2 40 67 40 79.9 0 23.5-17.9 42.7-40 42.7z"]
  },
      dm = {
    prefix: "fal",
    iconName: "grin-hearts",
    icon: [496, 512, [], "f584", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm123.1-151.2C340.9 330.5 296 336 248 336s-92.9-5.5-123.1-15.2c-11.6-3.7-22.6 6.3-20.7 17.9 9.2 55 83.2 93.3 143.8 93.3s134.5-38.3 143.8-93.3c1.9-11.6-9-21.6-20.7-17.9zM248 400c-35 0-77-16.3-98.5-40.3 57.5 10.8 139.6 10.8 197.1 0C325 383.7 283 400 248 400zm-61.8-128.8c14.3 3.7 27.2-5.5 30.5-17.6l20.5-73.9c4.1-14.7 1.7-30.4-6.5-43.2-8.2-12.8-21.6-21.5-36.8-23.9-25.2-4.1-49.4 10.7-59.3 34-25.2-3-50.2 11-59.1 34.3-5.5 14.4-4.7 30.3 2.3 43.8 6.9 13.5 19.4 23.4 34.2 27.2l74.2 19.3zm-80.7-78.8c5.2-13.8 20.4-15.5 28.5-13.4l22.8 5.9 6.2-22.7c3.3-11.9 14.7-19.7 25.9-18 13.1 2.1 20.9 14.6 17.5 27l-18.7 67.3-67.6-17.5c-12.1-3.1-19.4-15.9-14.6-28.6zM420.4 181c-8.9-23.3-34.1-37.3-59-34.3-9.9-23.3-34.7-38.2-59.3-34-15.2 2.4-28.6 11.1-36.8 23.9-8.2 12.8-10.6 28.5-6.5 43.2l20.4 73.8c3.4 12.3 16.5 21.3 30.5 17.6l74.2-19.2a53.47 53.47 0 0 0 34.2-27.2c6.9-13.5 7.8-29.5 2.3-43.8zm-44.5 40l-67.7 17.5-18.7-67.3c-3.4-12.3 4.4-24.9 17.5-27 13.7-2.2 23.4 9 25.8 17.9l6.2 22.7 23-5.8c12-3.1 24.5 2.8 28.5 13.4 4.8 12.7-2.5 25.5-14.6 28.6z"]
  },
      Mm = {
    prefix: "fal",
    iconName: "grin-squint",
    icon: [496, 512, [], "f585", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zM118.9 263.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.5-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.9-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48zm9.3 54.5C340.9 330.5 296 336 248 336s-92.9-5.5-123.1-15.2c-5.3-1.7-11.2-.5-15.3 3.1-4.2 3.7-6.2 9.2-5.3 14.8 9.2 55 83.2 93.3 143.8 93.3s134.5-38.3 143.8-93.3c.9-5.5-1.1-11.1-5.3-14.8-4.3-3.7-10.2-4.9-15.5-3.1zM248 400c-35 0-77-16.3-98.5-40.3 57.5 10.8 139.6 10.8 197.1 0C325 383.7 283 400 248 400z"]
  },
      pm = {
    prefix: "fal",
    iconName: "grin-squint-tears",
    icon: [512, 512, [], "f586", "M402 206.1c-5.6.4-10.5 3.7-13.1 8.6-14.6 28.3-42.4 63.9-76.3 97.8-33.9 34-69.6 61.8-97.8 76.3-5 2.5-8.3 7.5-8.7 13.1-.4 5.6 2.2 10.9 6.7 14.2 14.3 10.2 32.1 14.7 51 14.7 41 0 87.4-21 116.7-50.4 42.9-42.8 68-122.2 35.7-167.7-3.3-4.5-9-7.1-14.2-6.6zm-44.2 151.7c-24.8 24.7-64.9 43.1-98.2 41.1 24.1-16.5 50.4-38.6 75.5-63.8 25.1-25.1 47.3-51.4 63.8-75.5 1.8 32.2-16.3 73.5-41.1 98.2zM207.9 236.2c-3-3-7.3-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9 8.6.4 11.9-6.2 12.6-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.7-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm243.6-86.5c28.1-28.2 27.7-74.3-.9-102.9-29.2-29.2-75.3-28.3-102.9-.8-4.5 4.5-8.5 10.9-12.1 18.5C338.2 18.9 297.2 8 256 8 192.5 8 129 32.2 80.6 80.6c-79.9 79.9-93 200.4-41 294.6-8 3.8-14.4 7.8-18.7 12.2-28.1 28.2-27.7 74.3.9 102.9 28.5 28.5 74.5 29.2 102.9.8 4.5-4.5 8.5-10.9 12.1-18.5 37 20.5 78 31.4 119.2 31.4 63.5 0 127-24.2 175.4-72.6 79.9-79.9 93-200.3 41-294.6 8-3.8 14.4-7.9 18.8-12.2zM410 43.5c7.4-7.4 17.4-11.5 28-11.5h.4c11 .1 21.3 4.5 29.2 12.4 16.1 16.1 16.5 42 .9 57.6-6.6 6.6-32.3 16.8-83.3 24.8 8-51 18.2-76.7 24.8-83.3zm-308 425c-15.7 15.7-41.5 15.3-57.6-.8s-16.5-42-.9-57.6c6.6-6.6 32.3-16.8 83.3-24.8-8 50.8-18.2 76.6-24.8 83.2zm306.8-59.8C368 449.5 313.7 472 256 472c-38.8 0-75.8-10.8-108.4-29.9 5.4-19.7 9.4-41.6 12.2-60.9 1.2-8-1.5-15.9-7.2-21.7-5.8-5.8-13.7-8.4-21.7-7.3-23.8 3.4-43.9 7.5-60.6 12-48.1-82.7-37.7-190.3 33-261C144 62.4 198.3 40 256 40c38.8 0 75.8 10.8 108.4 29.9-5.4 19.7-9.4 41.6-12.2 60.9-1.2 8 1.5 15.9 7.2 21.7 4.9 4.9 11.3 7.5 18 7.5 1.2 0 2.4-.1 3.7-.3 23.8-3.4 43.9-7.5 60.6-12 48.2 82.6 37.8 190.3-32.9 261z"]
  },
      zm = {
    prefix: "fal",
    iconName: "grin-stars",
    icon: [496, 512, [], "f587", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm123.1-151.2C340.9 330.5 296 336 248 336s-92.9-5.5-123.1-15.2c-11.6-3.7-22.6 6.3-20.7 17.9 9.2 55 83.2 93.3 143.8 93.3s134.5-38.3 143.8-93.3c1.9-11.6-9-21.6-20.7-17.9zM248 400c-35 0-77-16.3-98.5-40.3 57.5 10.8 139.6 10.8 197.1 0C325 383.7 283 400 248 400zm162.1-252l-35.3-5.1-15.8-32.1c-9.5-18.8-36.3-18.9-45.9 0l-15.8 32.1-35.5 5.1c-5.4.8-10 3.6-13.8 7.4-3.8-3.8-8.4-6.6-13.9-7.4l-35.3-5.1-15.8-32.1c-9.5-18.8-36.3-18.9-45.9 0l-15.8 32.1-35.5 5.1c-20.2 3-29.6 28.2-14.1 43.7l25.7 24.9-6.1 35.6c-3.4 21.4 19.2 36.3 36.9 26.5l31.8-16.5 31.5 16.3c18.5 10.2 40.6-5.2 37.2-26.6l-6.1-35.4L248 192l25.4 24.6-6.1 35.6c-3.4 21.4 19.2 36.3 36.9 26.5l31.8-16.5 31.5 16.3c18.5 10.2 40.6-5.2 37.2-26.6l-6.1-35.4 25.9-25.1c14.9-14.9 6.3-40.3-14.4-43.4zm-221.9 57.5l6.7 38.9-34.9-18.2-34.9 18.1 6.7-38.9-28.5-27.7 39.2-5.6 17.5-35.5 17.5 35.5 39.2 5.6-28.5 27.8zm176 0l6.7 38.9-34.9-18.2-34.9 18.1 6.7-38.9-28.5-27.7 39.2-5.6 17.5-35.5 17.5 35.5 39.2 5.6-28.5 27.8z"]
  },
      Cm = {
    prefix: "fal",
    iconName: "grin-tears",
    icon: [640, 512, [], "f588", "M349.7 247.7c3.4 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm93.4 73.1C412.9 330.5 368 336 320 336s-92.9-5.5-123.1-15.2c-5.3-1.7-11.1-.5-15.3 3.1-4.2 3.7-6.3 9.2-5.3 14.8 9.3 55 83.2 93.3 143.8 93.3s134.5-38.3 143.8-93.3c.9-5.5-1.1-11.1-5.3-14.8-4.3-3.7-10.1-4.9-15.5-3.1zM320 400c-35 0-77-16.3-98.5-40.3 57.5 10.8 139.6 10.8 197.1 0C397 383.7 355 400 320 400zM189.7 247.7c3.4 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm429.5 11.7c-9.2-9.2-26.8-17.2-52.4-23.9C556.3 108.1 450 8 320 8S83.7 108.1 73.2 235.4c-25.6 6.7-43.2 14.7-52.4 23.9-28.1 28.2-27.7 74.3.9 102.9 11.8 11.8 44.2 32.9 82.7 14.7 42.5 75.5 122.7 127 215.5 127s173.1-51.5 215.5-127c38.4 18.1 70.8-2.8 82.7-14.7 28.8-28.5 29.2-74.7 1.1-102.8zM102 340.5c-15.5 15.5-41.4 15.5-57.7-.9-16.1-16.1-16.5-42-.9-57.6 6.6-6.6 32.3-16.8 83.3-24.8-7.9 51-18.1 76.7-24.7 83.3zM320 472c-82.6 0-154.1-46.9-190.4-115.2 15.6-22.2 25-67.5 30.1-103.6 1.2-8-1.5-15.9-7.2-21.7-5.8-5.8-13.7-8.4-21.7-7.3-8.7 1.3-16.8 2.6-24.6 4C119.9 122.3 210.3 40 320 40s200.1 82.3 213.8 188.3c-7.8-1.4-15.9-2.8-24.6-4-7.9-1.1-15.9 1.5-21.7 7.3-5.8 5.8-8.4 13.6-7.2 21.7 5.2 36.1 14.5 81.4 30.1 103.6C474.1 425.1 402.6 472 320 472zm275.7-132.4c-16.4 16.5-42.3 16.2-57.6.8-6.6-6.6-16.8-32.3-24.8-83.3 51 8 76.7 18.2 83.3 24.8 15.6 15.8 15.2 41.6-.9 57.7z"]
  },
      Lm = {
    prefix: "fal",
    iconName: "grin-tongue",
    icon: [496, 512, [], "f589", "M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM248 8C111 8 0 119 0 256c0 121.1 86.8 221.8 201.6 243.5 13.8 7.7 29.5 12.5 46.4 12.5s32.6-4.8 46.4-12.5C409.2 477.8 496 377.1 496 256 496 119 385 8 248 8zm64 408c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-31c18.9-9.5 22.7-12.2 32-12.2h.3c9.8.1 18.2 7 20.4 16.6l2.7 11.6c2.1 9.2 15.2 9.2 17.3 0l2.7-11.6c2.2-9.6 10.6-16.5 20.4-16.6h.3c9.2 0 12.9 2.7 32 12.2v32zm24.6 36.8c4.7-11.3 7.4-23.7 7.4-36.8v-13.6c24.7-16.1 43.4-38 47.8-63.8 2-11.6-9-21.6-20.7-17.9C340.9 330.5 296 336 248 336s-92.9-5.5-123.1-15.2c-11.6-3.7-22.6 6.3-20.7 17.9 4.3 25.8 23 47.6 47.8 63.8V416c0 13 2.7 25.4 7.4 36.8C84.4 418.9 32 343.5 32 256c0-119.1 96.9-216 216-216s216 96.9 216 216c0 87.5-52.4 162.9-127.4 196.8zM328 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      Am = {
    prefix: "fal",
    iconName: "grin-tongue-squint",
    icon: [496, 512, [], "f58a", "M248 8C111 8 0 119 0 256c0 121.1 86.8 221.8 201.6 243.5 13.8 7.7 29.5 12.5 46.4 12.5s32.6-4.8 46.4-12.5C409.2 477.8 496 377.1 496 256 496 119 385 8 248 8zm64 408c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-31c18.9-9.5 22.7-12.2 32-12.2h.3c9.8.1 18.2 7 20.4 16.6l2.7 11.6c2.1 9.2 15.2 9.2 17.3 0l2.7-11.6c2.2-9.6 10.6-16.5 20.4-16.6h.3c9.2 0 12.9 2.7 32 12.2v32zm24.6 36.8c4.7-11.3 7.4-23.7 7.4-36.8v-13.6c24.7-16.1 43.4-38 47.8-63.8 2-11.6-9-21.6-20.7-17.9C340.9 330.5 296 336 248 336s-92.9-5.5-123.1-15.2c-11.6-3.7-22.6 6.3-20.7 17.9 4.3 25.8 23 47.6 47.8 63.8V416c0 13 2.7 25.4 7.4 36.8C84.4 418.9 32 343.5 32 256c0-119.1 96.9-216 216-216s216 96.9 216 216c0 87.5-52.4 162.9-127.4 196.8zm40.5-300.6c-3.8-4.4-10.2-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"]
  },
      Nm = {
    prefix: "fal",
    iconName: "grin-tongue-wink",
    icon: [496, 512, [], "f58b", "M248 8C111 8 0 119 0 256c0 121.1 86.8 221.8 201.6 243.5 13.8 7.7 29.5 12.5 46.4 12.5s32.6-4.8 46.4-12.5C409.2 477.8 496 377.1 496 256 496 119 385 8 248 8zm64 408c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-31c18.9-9.5 22.7-12.2 32-12.2h.3c9.8.1 18.2 7 20.4 16.6l2.7 11.6c2.1 9.2 15.2 9.2 17.3 0l2.7-11.6c2.2-9.6 10.6-16.5 20.4-16.6h.3c9.2 0 12.9 2.7 32 12.2v32zm24.6 36.8c4.7-11.3 7.4-23.7 7.4-36.8v-13.6c24.7-16.1 43.4-38 47.8-63.8 2-11.6-9-21.6-20.7-17.9C340.9 330.5 296 336 248 336s-92.9-5.5-123.1-15.2c-11.6-3.7-22.6 6.3-20.7 17.9 4.3 25.8 23 47.6 47.8 63.8V416c0 13 2.7 25.4 7.4 36.8C84.4 418.9 32 343.5 32 256c0-119.1 96.9-216 216-216s216 96.9 216 216c0 87.5-52.4 162.9-127.4 196.8zM344 128c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm-192-76c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm192 4c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z"]
  },
      gm = {
    prefix: "fal",
    iconName: "grin-wink",
    icon: [496, 512, [], "f58c", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm152.7 400.7c-19.8 19.8-43 35.4-68.7 46.3-26.6 11.3-54.9 17-84.1 17s-57.5-5.7-84.1-17c-25.7-10.9-48.8-26.5-68.7-46.3s-35.4-43-46.3-68.7c-11.3-26.6-17-54.9-17-84.1s5.7-57.5 17-84.1c10.9-25.7 26.5-48.8 46.3-68.7s43-35.4 68.7-46.3c26.6-11.3 54.9-17 84.1-17s57.5 5.7 84.1 17c25.7 10.9 48.8 26.5 68.7 46.3s35.4 43 46.3 68.7c11.3 26.6 17 54.9 17 84.1s-5.7 57.5-17 84.1c-10.8 25.8-26.4 48.9-46.3 68.7zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm120-7l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-4-25.2-34.2-42.1-59.9-42.1S272 197 268 222.2c-1.6 11.1 11.6 18.2 20 10.8zm88.1 87c-1.6 0-3.3.3-4.9.8C340.9 330.5 296 336 248 336s-92.9-5.5-123.1-15.2c-1.7-.5-3.3-.8-4.9-.8-9.4 0-17.4 8.6-15.7 18.7 9.2 55 83.2 93.3 143.8 93.3s134.5-38.3 143.8-93.3c1.6-10.2-6.4-18.7-15.8-18.7zm-53.5 58.6C300.4 392 272.5 400 248 400s-52.4-8-74.6-21.4c-9.4-5.7-17.3-12.1-23.5-18.8 28.6 5.3 62.7 8.2 98 8.2 35.4 0 69.4-2.9 98-8.2-6 6.7-13.9 13.1-23.3 18.8z"]
  },
      Hm = {
    prefix: "fal",
    iconName: "grip-horizontal",
    icon: [448, 512, [], "f58d", "M424 96h-80c-13.22 0-24 10.77-24 24v80c0 13.23 10.78 24 24 24h80c13.22 0 24-10.77 24-24v-80c0-13.23-10.78-24-24-24zm-8 96h-64v-64h64v64zM264 96h-80c-13.22 0-24 10.77-24 24v80c0 13.23 10.78 24 24 24h80c13.22 0 24-10.77 24-24v-80c0-13.23-10.78-24-24-24zm-8 96h-64v-64h64v64zM104 96H24c-13.22 0-24 10.77-24 24v80c0 13.23 10.78 24 24 24h80c13.22 0 24-10.77 24-24v-80c0-13.23-10.78-24-24-24zm-8 96H32v-64h64v64zm328 96h-80c-13.22 0-24 10.77-24 24v80c0 13.23 10.78 24 24 24h80c13.22 0 24-10.77 24-24v-80c0-13.23-10.78-24-24-24zm-8 96h-64v-64h64v64zm-152-96h-80c-13.22 0-24 10.77-24 24v80c0 13.23 10.78 24 24 24h80c13.22 0 24-10.77 24-24v-80c0-13.23-10.78-24-24-24zm-8 96h-64v-64h64v64zm-152-96H24c-13.22 0-24 10.77-24 24v80c0 13.23 10.78 24 24 24h80c13.22 0 24-10.77 24-24v-80c0-13.23-10.78-24-24-24zm-8 96H32v-64h64v64z"]
  },
      Vm = {
    prefix: "fal",
    iconName: "grip-lines",
    icon: [448, 512, [], "f7a4", "M440 192H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0 96H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      xm = {
    prefix: "fal",
    iconName: "grip-lines-vertical",
    icon: [256, 512, [], "f7a5", "M192 472V40c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v432c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8zm-96 0V40c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v432c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8z"]
  },
      wm = {
    prefix: "fal",
    iconName: "grip-vertical",
    icon: [320, 512, [], "f58e", "M104 32H24C10.78 32 0 42.77 0 56v80c0 13.23 10.78 24 24 24h80c13.22 0 24-10.77 24-24V56c0-13.23-10.78-24-24-24zm-8 96H32V64h64v64zm8 64H24c-13.22 0-24 10.77-24 24v80c0 13.23 10.78 24 24 24h80c13.22 0 24-10.77 24-24v-80c0-13.23-10.78-24-24-24zm-8 96H32v-64h64v64zm8 64H24c-13.22 0-24 10.77-24 24v80c0 13.23 10.78 24 24 24h80c13.22 0 24-10.77 24-24v-80c0-13.23-10.78-24-24-24zm-8 96H32v-64h64v64zM296 32h-80c-13.22 0-24 10.77-24 24v80c0 13.23 10.78 24 24 24h80c13.22 0 24-10.77 24-24V56c0-13.23-10.78-24-24-24zm-8 96h-64V64h64v64zm8 64h-80c-13.22 0-24 10.77-24 24v80c0 13.23 10.78 24 24 24h80c13.22 0 24-10.77 24-24v-80c0-13.23-10.78-24-24-24zm-8 96h-64v-64h64v64zm8 64h-80c-13.22 0-24 10.77-24 24v80c0 13.23 10.78 24 24 24h80c13.22 0 24-10.77 24-24v-80c0-13.23-10.78-24-24-24zm-8 96h-64v-64h64v64z"]
  },
      ym = {
    prefix: "fal",
    iconName: "guitar",
    icon: [512, 512, [], "f7a6", "M160 288a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm0 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zM501.78 42.49l-32.27-32.27a34.91 34.91 0 0 0-49.36 0l-50.52 50.53a38.46 38.46 0 0 0-9.29 15L339 139.87c-.39.31-1 .18-1.31.54L291.09 187c-13.79-11.17-29.47-19.89-46.72-23.91a115.75 115.75 0 0 0-26.1-3.07c-24.17 0-46.86 8.19-63.76 25.1a82.52 82.52 0 0 0-20.24 33.47c-6 18.56-23.2 32.69-42.15 34.46-23.69 2.27-45.72 11.45-62.59 28.44C-16.1 327-7.9 409 47.57 464.45 78.9 495.77 118.66 512 155.53 512c28.45 0 55.17-9.65 75-29.48 17-16.88 26.17-38.9 28.45-62.7 1.76-18.86 15.89-36.14 34.43-42.15a82.72 82.72 0 0 0 33.47-20.24c22.87-22.89 29.73-56.36 22-89.76-4-17.26-12.67-33-23.83-46.75l46.56-46.57c.36-.36.24-.91.54-1.3l64.06-21.36a38.6 38.6 0 0 0 15.05-9.3l50.52-50.53a34.92 34.92 0 0 0 0-49.37zM304.25 334.8a50.44 50.44 0 0 1-20.73 12.42c-30.79 10-53.46 38-56.4 69.54-1.17 12.11-5.43 29.41-19.23 43.13-16.61 16.62-37.64 20.11-52.36 20.11-30 0-61.07-13.92-85.32-38.18S32 386.37 32 356.39c0-14.69 3.51-35.67 20.22-52.34 13.64-13.72 30.88-18 42.89-19.13 31.64-3 59.61-25.65 69.61-56.52a50.32 50.32 0 0 1 12.42-20.65c13-13 29.53-15.72 41.13-15.72a83.63 83.63 0 0 1 18.85 2.23c10.31 2.4 20.86 7.82 31.11 15.6l-52.71 52.72a12 12 0 0 0 0 17l17 17a12 12 0 0 0 17 0l52.71-52.72c7.76 10.23 13.16 20.76 15.55 31.06 5.47 23.93.56 45.77-13.53 59.88zm174.9-265.57l-50.52 50.52a6.45 6.45 0 0 1-2.53 1.58L373 139l17.7-53.12a6.61 6.61 0 0 1 1.57-2.53l50.52-50.53a2.81 2.81 0 0 1 2.05-.85 2.85 2.85 0 0 1 2.06.85l32.26 32.27a2.92 2.92 0 0 1-.01 4.14z"]
  },
      bm = {
    prefix: "fal",
    iconName: "guitar-electric",
    icon: [512, 512, [], "f8be", "M129 330.35a8 8 0 0 0-11.31 0l-11.31 11.31a8 8 0 0 0 0 11.31L159 405.66a8 8 0 0 0 11.32 0l11.31-11.31a8 8 0 0 0 0-11.32zm64-64a8 8 0 0 0-11.31 0l-11.31 11.32a8 8 0 0 0 0 11.31L223 341.66a8 8 0 0 0 11.32 0l11.31-11.31a8 8 0 0 0 0-11.32zM511.21 39.57a48.14 48.14 0 0 0-37.8-38.26A58.42 58.42 0 0 0 462.57 0c-14.8 0-27.14 10.61-95.83 54.94a32.15 32.15 0 0 0-14.74 27v44.59l-83.23 83.17a12.46 12.46 0 0 1-1.77-12.78l15.9-34.17a41.31 41.31 0 0 0-66.67-46.65L181 151.34a95.94 95.94 0 0 0-22.42 35.47 47.67 47.67 0 0 1-24.74 27.11l-70.29 32.57c-31 12.38-54.45 40.37-61.43 74.36a102.65 102.65 0 0 0 28 93.48l67.51 67.5A102.9 102.9 0 0 0 266 447.28l32.05-69.15a47.69 47.69 0 0 1 27.12-24.74A96 96 0 0 0 360.65 331l19.84-19.83a42.28 42.28 0 0 0 0-59.82A40.82 40.82 0 0 0 350.94 239a44.65 44.65 0 0 0-13.21 2l-21.8 6.95a13.07 13.07 0 0 1-4 .65c-4.75 0-7.94-2.89-9.58-4.54L451.72 94.63A47.44 47.44 0 0 0 464 96.42a48.05 48.05 0 0 0 47.21-56.85zm-199.28 241a45.34 45.34 0 0 0 13.72-2.16l21.8-6.95a12.94 12.94 0 0 1 3.49-.46 8.85 8.85 0 0 1 6.92 3 10.12 10.12 0 0 1 3 7.28 10.27 10.27 0 0 1-3 7.28L338 308.34a64 64 0 0 1-23.57 14.9A79.89 79.89 0 0 0 269 364.67l-32 69.15-.36.78-.32.79a70.89 70.89 0 0 1-116 23.81l-67.53-67.5a70.73 70.73 0 0 1-19.32-64.41c4.73-23.08 20.8-42.65 41.93-51.08l.81-.32.78-.37L147.31 243a79.84 79.84 0 0 0 41.44-45.42 63.85 63.85 0 0 1 14.9-23.58l35.25-35.24a9.28 9.28 0 0 1 13.17 0 9.47 9.47 0 0 1 1.86 10.52L238 183.42a44.48 44.48 0 0 0 5.16 45.51l36.53 37.7c11.53 11.5 23.89 13.91 32.24 13.91zm164.35-221.9A16 16 0 0 1 464 64.42a17.52 17.52 0 0 1-4.07-.71L442.12 59 384 117.08l.07-35.25C398.37 72.61 457.78 33.71 463 32a35.26 35.26 0 0 1 4.45.73 16.14 16.14 0 0 1 12.27 12.44 15.92 15.92 0 0 1-3.44 13.5z"]
  },
      Sm = {
    prefix: "fal",
    iconName: "guitars",
    icon: [512, 512, [], "f8bf", "M80 320a48 48 0 1 0 48-48 48 48 0 0 0-48 48zm64 0a16 16 0 1 1-16-16 16 16 0 0 1 16 16zm264 16h-80a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm96.67 50.93l-30.3-50.64c-7.5-20.46-11.6-29.58-2.24-49.27a81.26 81.26 0 0 0 7.87-34.81v-31.87a20.76 20.76 0 0 0-20.77-20.77 20.77 20.77 0 0 0-18.47 11.25l-11.95 23.12c-6 11.67-12.13 19.87-24.81 22.06h-12V89.38a47.32 47.32 0 0 0 9.94-7.38 48 48 0 0 0-60.59-73.95 58.88 58.88 0 0 0-8.59 6.74c-10.46 10.47-11.68 26.69-28.91 106.61a32.1 32.1 0 0 0 8.63 29.48L344 182.41V256h-12c-12.72-3.5-18.48-14-23.15-26.85l-14.67-40.22A19.64 19.64 0 0 0 275.72 176 19.69 19.69 0 0 0 256 195.68v56.62a81.19 81.19 0 0 0 7.83 34.81c9.35 19.68 5.42 28.81-2.1 49.26L231.36 387c-25.38 59.16 18 125 82.33 125h108.47c64.41-.07 107.84-65.91 82.51-125.07zM335.13 128.14c3.58-16.61 18.07-86.13 20.57-91a35.47 35.47 0 0 1 3.66-2.62 16 16 0 0 1 20 24.82 17.79 17.79 0 0 1-3.38 2.38L360 71v82.17zM470.37 454a56.87 56.87 0 0 1-48.18 26h-108.5A57.62 57.62 0 0 1 260 401.44l29.14-48.62 1.55-2.58 1-2.83.72-2c7.75-21 15.07-40.88.26-72.06a49.46 49.46 0 0 1-4-12.42c6.81 10.4 17.56 21.15 34.74 25.88l4.17 1.15h79.07l2.7-.47a59.52 59.52 0 0 0 36.41-21.07 50.41 50.41 0 0 1-2.63 6.83c-14.75 31-7.49 50.7.18 71.53l.92 2.49 1 2.82 1.54 2.59L476 401.31a56.74 56.74 0 0 1-5.63 52.69zM408 400.12h-80a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM128 480c-26.82 0-51.76-8.35-70.24-23.5C41.13 442.87 32 425.29 32 406.89c-.05-16.47 7.82-29.49 14.4-37.45 19.06-23 22.58-56.66 8.73-83.8a42.07 42.07 0 0 1-4.9-19.64c0-15.45 8.29-27 15.24-33.95A72.47 72.47 0 0 1 78.33 222c6.67-4.15 15.33-6.79 25.67-8.43V224a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-10.47c10.34 1.64 19 4.28 25.67 8.43a72.47 72.47 0 0 1 12.86 10.12c6.95 7 15.25 18.5 15.24 33.95a42.07 42.07 0 0 1-4.9 19.61c-13.08 25.65-10.16 56.83 6.23 79.62l19.39-32.35c-2.89-10.73-2.31-22.54 2.87-32.67a79.15 79.15 0 0 0 2.8-7.43c-5-12.95-8.16-26.66-8.16-40.52v-29.61a91.15 91.15 0 0 0-10.86-13.22 103.66 103.66 0 0 0-18.58-14.67c-12.84-8-27.55-12-42.58-13.83v-54.22l16.62-33.23a29.12 29.12 0 0 0 3.07-13v-54.1A26.41 26.41 0 0 0 145.28 0h-34.56A26.41 26.41 0 0 0 84.3 26.41v54.08a29.12 29.12 0 0 0 3.07 13L104 126.74V181c-15 1.84-29.74 5.84-42.58 13.83a103.66 103.66 0 0 0-18.58 14.67c-15.39 15.39-24.62 35-24.61 56.58a74.36 74.36 0 0 0 8.41 34.2c8 15.65 6 35.59-4.88 48.78C8.11 365.55-.07 385.43 0 407c-.07 58 57.34 105 128 105 31.64 0 60.25-9.78 82.61-25.39a121.63 121.63 0 0 1-13.27-29.5C179 471.82 154.42 480 128 480zm11.7-448v48.49l-11.64 22.79-.05-.11v.11l-11.7-22.79V32z"]
  },
      Tm = {
    prefix: "fal",
    iconName: "h-square",
    icon: [448, 512, [], "f0fd", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm16 400c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h352c8.822 0 16 7.178 16 16v352zm-80-292v232c0 6.627-5.373 12-12 12h-8c-6.627 0-12-5.373-12-12V272H144v100c0 6.627-5.373 12-12 12h-8c-6.627 0-12-5.373-12-12V140c0-6.627 5.373-12 12-12h8c6.627 0 12 5.373 12 12v100h160V140c0-6.627 5.373-12 12-12h8c6.627 0 12 5.373 12 12z"]
  },
      Dm = {
    prefix: "fal",
    iconName: "h1",
    icon: [576, 512, [], "f313", "M312 96H200a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h40v112H80V128h40a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h40v256H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H80V272h160v112h-40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-40V128h40a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm256 288h-70.34V112a16 16 0 0 0-16-16h-16a16 16 0 0 0-11.31 4.69L412 143a8 8 0 0 0 0 11.31l11.31 11.31a8 8 0 0 0 11.32 0l31-31V384H392a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h176a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      jm = {
    prefix: "fal",
    iconName: "h2",
    icon: [576, 512, [], "f314", "M312 96H200a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h40v112H80V128h40a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h40v256H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H80V272h160v112h-40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-40V128h40a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm240 288H406.07c3.84-78.76 159.24-94.63 159.24-198.94 0-50-36.93-89.06-97.75-89.06-38.5 0-73 20.77-91.81 48.46A11.83 11.83 0 0 0 379 161l7.15 4.75a12.1 12.1 0 0 0 16.35-2.84c14.5-19 37.72-33.76 63.28-33.76 37.31 0 63.37 23.72 63.37 57.7 0 82.34-161.12 97-161.12 207.31 0 4.22.19 7.81.5 11.18a12 12 0 0 0 12 10.69H552a8 8 0 0 0 8-8V392a8 8 0 0 0-8-8z"]
  },
      Em = {
    prefix: "fal",
    iconName: "h3",
    icon: [576, 512, [], "f315", "M476.8 223.64l90.74-101.26a11.69 11.69 0 0 0 3-7.81v-6.71A12.1 12.1 0 0 0 558.26 96H391a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h130.37c-3.27 3.13-7.65 7.56-12.42 12.95l-76.32 86.44a11.68 11.68 0 0 0-2 12.26l2.75 6.42a12.24 12.24 0 0 0 11.32 7.31h15.11c42.44 0 78.76 22.91 78.78 64.29a62.89 62.89 0 0 1-20.54 46c-36.94 33.66-92 18.39-124.16-9.63a12.52 12.52 0 0 0-17.76 1.49l-6.44 7.9a11.56 11.56 0 0 0 1.34 16.1c22.64 20 59 36.46 96.44 36.46C527.74 416 575 372.42 575 316.71c.1-57.3-44.9-88.62-98.2-93.07zM311 96H199a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h40v112H79V128h40a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H7a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h40v256H7a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H79V272h160v112h-40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-40V128h40a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      km = {
    prefix: "fal",
    iconName: "h4",
    icon: [576, 512, [], "f86a", "M312 96H200a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h40v112H80V128h40a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h40v256H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H80V272h160v112h-40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-40V128h40a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm256 144h-24V104a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v136H384V104a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v152a16 16 0 0 0 16 16h144v136a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V272h24a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      Im = {
    prefix: "fal",
    iconName: "hamburger",
    icon: [512, 512, [], "f805", "M384 208a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-176-64a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm96 0a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-176 64a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm384 112a63.84 63.84 0 0 0-30.17-54.1c13.54-20.94 18.48-52.94 6.35-79.07C448 100.27 359.55 32.13 256 32c-103.54.13-192 68.26-232.18 154.82-12.45 26.81-9.11 59.87 3.66 80.75a63.51 63.51 0 0 0-6.14 99.79C18.25 372.28 16 377.76 16 384v32a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-32c0-6.24-2.25-11.72-5.34-16.64A63.64 63.64 0 0 0 512 320zM52.85 200.3C90.66 118.9 172.3 64.13 256 64c83.72.13 165.37 54.9 203.16 136.31 5.79 12.47 5.24 29.54-1.41 43.48-.14.28-.27.56-.41.83a21.07 21.07 0 0 1-18.9 11.38H70.1c-6.12 0-12.24-2.39-16-7.22a16.5 16.5 0 0 1-2.49-4.4c-5.25-13.87-4.76-31.18 1.24-44.08zM464 416a32 32 0 0 1-32 32H80a32 32 0 0 1-32-32v-32h416zm-16-64H64a32 32 0 0 1 0-64h384a32 32 0 0 1 0 64z"]
  },
      Om = {
    prefix: "fal",
    iconName: "hammer",
    icon: [576, 512, [], "f6e3", "M573.65 200.92l-11.34-11.31c-3.13-3.12-8.21-3.12-11.34 0l-17.01 16.97-52.98-52.86c5.64-21.31.36-44.9-16.39-61.61l-45.36-45.25C387.92 15.62 346.88 0 305.84 0c-41.04 0-82.09 15.62-113.4 46.86l68.66 68.5c-4.42 16.71-1.88 34.7 7.4 49.8L21.47 395.26c-27.95 26.04-28.71 70.01-1.67 96.99C33.02 505.44 50.32 512 67.59 512c18.05 0 36.09-7.17 49.42-21.42l233.13-249.14c12.84 5.06 26.84 6.3 40.12 2.8l52.98 52.86-17.01 16.97a7.985 7.985 0 0 0 0 11.31l11.34 11.31c3.13 3.12 8.21 3.12 11.34 0l124.74-124.45a7.997 7.997 0 0 0 0-11.32zM93.57 468.74C86.78 476 77.55 480 67.59 480c-9.48 0-18.4-3.69-25.11-10.38-6.87-6.86-10.57-15.97-10.4-25.67.17-9.7 4.17-18.68 11.28-25.3l246.37-229.47 33.85 33.77L93.57 468.74zm372.35-194.28l-52.98-52.85-13.04-13.01-17.83 4.7c-11.3 2.98-22.84-.03-30.87-8.04l-51.03-50.91c-8.03-8.01-11.04-19.53-8.06-30.8l4.71-17.79-13.04-13.01-43.14-43.05c19.54-11.54 41.9-17.7 65.2-17.7 34.27 0 66.48 13.32 90.72 37.49l45.36 45.26c8.03 8.01 11.04 19.53 8.06 30.8l-4.71 17.79 13.04 13.01 52.98 52.86-45.37 45.25z"]
  },
      Qm = {
    prefix: "fal",
    iconName: "hammer-war",
    icon: [384, 512, [], "f6e4", "M352.07 32c-1.75 0-3.53.14-5.33.44L240 50.23V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v34.23L37.26 32.44c-1.79-.3-3.58-.44-5.33-.44C14.64 32 0 46.05 0 64.01v191.98C0 273.95 14.64 288 31.94 288c1.75 0 3.53-.14 5.33-.44L144 269.77V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V269.77l106.74 17.79c1.79.3 3.57.44 5.33.44 17.3 0 31.94-14.05 31.94-32.01V64.01C384 46.05 369.36 32 352.07 32zM176 32h32v23.57l-16 2.67-16-2.67V32zm32 448h-32V264.43l16-2.67 16 2.67V480zm144-224.01L197.26 230.2l-5.26-.88-5.26.88L32 255.99V64.01L186.74 89.8l5.26.88 5.26-.88L352 64.01v191.98z"]
  },
      Zm = {
    prefix: "fal",
    iconName: "hamsa",
    icon: [512, 512, [], "f665", "M256 328c-13.25 0-24 10.74-24 24s10.75 24 24 24 24-10.74 24-24-10.75-24-24-24zm195.95-104H416V96c0-35.29-28.71-64-64-64-13.16 0-25.41 3.99-35.6 10.84C307.65 17.91 283.88 0 256 0s-51.65 17.91-60.4 42.84A63.603 63.603 0 0 0 160 32c-35.29 0-64 28.71-64 64v128H60.06C18.96 224 .05 261.31 0 288c-.03 15.18 5.04 30.12 14.79 42.06L104.6 440.1c37.33 45.7 92.52 71.9 151.41 71.9s114.08-26.21 151.4-71.89l89.8-110.04c9.74-11.94 14.81-26.88 14.79-42.07-.05-26.76-19.31-64-60.05-64zm20.48 85.83L385.05 416.9c-24.74 30.29-58.67 52.64-97.07 60.03-60.8 11.71-120.68-10.67-158.59-57.07l-89.8-110.03c-7.6-9.31-9.65-22.89-5.19-34.58C38.81 263.56 48.9 256 60.06 256H128V97.95c0-15.96 10.8-30.84 26.53-33.49C174.52 61.1 192 76.61 192 96v120c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V65.95c0-15.96 10.8-30.84 26.53-33.49C270.52 29.1 288 44.61 288 64v152c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V97.95c0-15.96 10.8-30.84 26.53-33.49C366.52 61.1 384 76.61 384 96v160h67.95c11.16 0 21.25 7.56 25.67 19.25 4.46 11.69 2.41 25.27-5.19 34.58zM256 272c-18.79 0-57.96 1.82-112.12 69.86-4.59 5.77-4.59 14.51 0 20.27C198.07 430.22 237.24 432 256 432c18.79 0 57.96-1.82 112.12-69.87 4.59-5.77 4.59-14.51 0-20.27C313.93 273.78 274.76 272 256 272zm0 128c-44.18 0-80-48-80-48s35.82-48 80-48 80 48 80 48-35.82 48-80 48z"]
  },
      Um = {
    prefix: "fal",
    iconName: "hand-heart",
    icon: [448, 512, [], "f4bc", "M392 112c-8.6 0-16.7 1.9-24 5.4V88c0-30.9-25.1-56-56-56-9.7 0-18.8 2.5-26.7 6.8C278 16.3 256.9 0 232 0s-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8-30.9 0-56 25.1-56 56v152.8c-11.5-11.8-42.1-27.7-72.1-6.7-25.3 17.7-31.5 52.7-13.8 78l113.7 171.3c11.9 17.9 31.8 28.6 53.3 28.6h180.6c30.4 0 56.8-21.6 62.8-51.4l20.6-103.2c4.5-22.7 6.8-45.9 6.8-69V168c.1-30.9-25-56-55.9-56zm24 176.3c0 21.1-2.1 42.1-6.2 62.8l-20.6 103.2c-3 15-16.1 25.7-31.4 25.7H177.2c-10.7 0-20.7-5.4-26.7-14.3L36.3 293.8c-7.6-10.9-5-25.8 5.9-33.4 15.8-11.1 30 1 33.4 5.9l37.8 54.4c4.5 6.4 14.6 3.3 14.6-4.6V88c0-13.3 10.7-24 24-24s24 10.7 24 24v160c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V56c0-13.3 10.7-24 24-24s24 10.7 24 24v192c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V88c0-13.3 10.7-24 24-24s24 10.7 24 24v160c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-80c0-13.3 10.7-24 24-24s24 10.7 24 24v120.3zM333.3 299c-6.1-4.9-16.6-11-30.3-11-13.1 0-29.2 5.6-47 23.1-17.8-17.5-33.9-23.1-47-23.1-13.7 0-24.3 6.1-30.3 11-23.6 19.1-24.8 53.5-3.7 74.2l72.6 71.3c4.7 4.6 12.3 4.6 17 0l72.6-71.3c20.9-20.7 19.7-55.1-3.9-74.2zm-18.7 51.4L256 408l-58.6-57.6c-12-11.8-2.1-30.4 11.6-30.4 6.7 0 15.5 5 24.6 13.9L256 356l22.4-22.1c9.1-9 17.9-13.9 24.6-13.9 13.7 0 23.6 18.6 11.6 30.4z"]
  },
      Bm = {
    prefix: "fal",
    iconName: "hand-holding",
    icon: [576, 512, [], "f4bd", "M558.3 333.6c-9.6-8.6-22.1-13.4-35.2-13.4-12.5 0-24.8 4.3-34.6 12.2l-61.6 49.3c-1.9 1.5-4.2 2.3-6.7 2.3h-41.6c4.6-9.6 6.5-20.7 4.8-32.3-4-27.9-29.6-47.7-57.8-47.7H181.3c-20.8 0-41 6.7-57.6 19.2L85.3 352H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88l46.9-35.2c11.1-8.3 24.6-12.8 38.4-12.8H328c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88c-8.8 0-16 7.2-16 16s7.2 16 16 16h180.2c9.7 0 19.1-3.3 26.7-9.3l61.6-49.2c4.2-3.4 9.5-5.2 14.6-5.2 5 0 9.9 1.7 13.8 5.2 10.1 9.1 9.3 24.5-.9 32.6l-100.8 80.7c-7.6 6.1-17 9.3-26.7 9.3H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h400.5c17 0 33.4-5.8 46.6-16.4L556 415c12.2-9.8 19.5-24.4 20-40s-6-30.8-17.7-41.4z"]
  },
      Rm = {
    prefix: "fal",
    iconName: "hand-holding-box",
    icon: [576, 512, [], "f47b", "M112 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zM256 32h64v76.2l-32-16-32 16V32zm-128 0h96v128l64-32 64 32V32h96v192H128V32zm430.3 301.6c-9.6-8.6-22.1-13.4-35.2-13.4-12.5 0-24.8 4.3-34.6 12.2l-61.6 49.3c-1.9 1.5-4.2 2.3-6.7 2.3h-41.6c4.6-9.6 6.5-20.7 4.8-32.3-4-27.9-29.6-47.7-57.8-47.7H181.3c-20.8 0-41 6.7-57.6 19.2L85.3 352H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88l46.9-35.2c11.1-8.3 24.6-12.8 38.4-12.8H328c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88c-8.8 0-16 7.2-16 16s7.2 16 16 16h180.2c9.7 0 19.1-3.3 26.7-9.3l61.6-49.2c4.2-3.4 9.5-5.2 14.6-5.2 5 0 9.9 1.7 13.8 5.2 10.1 9.1 9.3 24.5-.9 32.6l-100.8 80.7c-7.6 6.1-17 9.3-26.7 9.3H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h400.5c17 0 33.4-5.8 46.6-16.4L556 415c12.2-9.8 19.5-24.4 20-40s-6-30.8-17.7-41.4z"]
  },
      Ym = {
    prefix: "fal",
    iconName: "hand-holding-heart",
    icon: [576, 512, [], "f4be", "M558.3 333.6c-19.7-17.7-49.4-17.6-69.9-1.2l-61.6 49.3c-1.9 1.5-4.2 2.3-6.7 2.3h-41.6c4.6-9.6 6.5-20.7 4.8-32.3-4-27.9-29.6-47.7-57.8-47.7H181.3c-20.8 0-41 6.7-57.6 19.2L85.3 352H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88l46.9-35.2c11.1-8.3 24.6-12.8 38.4-12.8H328c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88c-8.8 0-16 7.2-16 16s7.2 16 16 16h180.2c9.7 0 19.1-3.3 26.7-9.3l61.6-49.2c7.7-6.1 20-7.6 28.4 0 10.1 9.1 9.3 24.5-.9 32.6l-100.8 80.7c-7.6 6.1-17 9.3-26.7 9.3H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h400.5c17 0 33.4-5.8 46.6-16.4L556 415c12.2-9.8 19.5-24.4 20-40s-6-30.8-17.7-41.4zm-283-83.1c7 7.4 18.4 7.4 25.5 0l108.9-114.1c31.6-33.2 29.8-88.1-5.6-118.7-35.3-30.6-81.4-17-104.9 7.7L288 37l-11.1-11.6c-23-24.1-69.3-38.6-104.9-7.7-35.3 30.6-37.2 85.6-5.6 118.7l108.9 114.1zM192.4 41.9c20.8-18 48.2-8.7 61.9 5.7L288 82.9l33.7-35.3c13.5-14.1 41-23.7 61.9-5.7 23.8 20.6 20.2 54.5 3.4 72.1l-99 103.8L189 114c-16.7-17.4-20.3-51.5 3.4-72.1z"]
  },
      Pm = {
    prefix: "fal",
    iconName: "hand-holding-magic",
    icon: [576, 512, [], "f6e5", "M558.3 333.65c-9.58-8.65-22.09-13.41-35.23-13.41-12.51 0-24.81 4.32-34.62 12.17l-61.57 49.25a10.68 10.68 0 0 1-6.66 2.34h-41.63c4.56-9.58 6.48-20.66 4.81-32.27-4.02-27.93-29.62-47.73-57.83-47.73H181.33c-20.77 0-40.98 6.74-57.6 19.2L85.33 352H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h88l46.93-35.2a63.99 63.99 0 0 1 38.4-12.8H328c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24h-88c-8.84 0-16 7.16-16 16s7.16 16 16 16h180.22c9.69 0 19.09-3.3 26.65-9.35l61.56-49.25c4.22-3.38 9.46-5.16 14.63-5.16 4.99 0 9.91 1.66 13.78 5.16 10.05 9.08 9.26 24.51-.87 32.59l-100.83 80.66a42.656 42.656 0 0 1-26.65 9.35H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h400.51c16.95 0 33.4-5.77 46.63-16.36l100.83-80.67c12.23-9.76 19.52-24.36 20-40.03s-5.96-30.72-17.67-41.29zM208 224h72c39.69 0 72-32.3 72-72s-32.31-72-72-72h-15.31C233 80 204.81 98.78 192 126.61c17.72-7.86 41.88-14.61 72.69-14.61H280c22.06 0 40 17.94 40 40s-17.94 40-40 40h-72c-27.47 0-48-25.34-48-48V80c0-26.47 21.53-48 48-48h160c26.47 0 48 21.53 48 48v69.23c0 36.12-16.63 72.41-46.84 102.2L348.31 272c57.09-14.78 99.25-64.27 99.69-121.33V80c0-44.11-35.88-80-80-80H208c-44.13 0-80 35.89-80 80v64c0 42.61 37.38 80 80 80z"]
  },
      Fm = {
    prefix: "fal",
    iconName: "hand-holding-medical",
    icon: [576, 512, [], "e05c", "M160,192h48v48a16,16,0,0,0,16,16h96a16,16,0,0,0,16-16V192h48a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H336V16A16,16,0,0,0,320,0H224a16,16,0,0,0-16,16V64H160a16,16,0,0,0-16,16v96A16,16,0,0,0,160,192Zm16-96h64V32h64V96h64v64H304v64H240V160H176ZM558.27,333.5a52.68,52.68,0,0,0-35.2-13.39,55.26,55.26,0,0,0-34.59,12.2l-61.59,49.3a10.72,10.72,0,0,1-6.71,2.3h-41.6a55.68,55.68,0,0,0,4.81-32.3c-4-27.91-29.61-47.7-57.81-47.7H181.29a95.61,95.61,0,0,0-57.59,19.2l-38.41,28.8H8a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H96l46.9-35.21a64.21,64.21,0,0,1,38.39-12.79H328a24,24,0,0,1,0,48H240a16,16,0,0,0,0,32H420.18a43.14,43.14,0,0,0,26.71-9.3l61.59-49.2a23.44,23.44,0,0,1,14.59-5.21,20.51,20.51,0,0,1,13.81,5.21A21.25,21.25,0,0,1,536,390L435.18,470.7a42.47,42.47,0,0,1-26.7,9.3H8a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H408.48a74.34,74.34,0,0,0,46.59-16.39L556,414.91a53.39,53.39,0,0,0,2.3-81.41Z"]
  },
      Wm = {
    prefix: "fal",
    iconName: "hand-holding-seedling",
    icon: [576, 512, [], "f4bf", "M248.9 192H272v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56h23.1C411.4 192 480 113 480 16V0h-55.1C364.9 0 313 40.1 288 98.1 263 40.1 211.1 0 151.1 0H96v16c0 97 68.6 176 152.9 176zm176-160h22.4c-6.7 71.9-58 128-120.1 128h-22.4c6.6-71.9 58-128 120.1-128zm-273.8 0c62.1 0 113.4 56.1 120.1 128h-22.4c-62.1 0-113.4-56.1-120.1-128h22.4zm407.2 301.6c-9.6-8.6-22.1-13.4-35.2-13.4-12.5 0-24.8 4.3-34.6 12.2l-61.6 49.3c-1.9 1.5-4.2 2.3-6.7 2.3h-41.6c4.6-9.6 6.5-20.7 4.8-32.3-4-27.9-29.6-47.7-57.8-47.7H181.3c-20.8 0-41 6.7-57.6 19.2L85.3 352H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88l46.9-35.2c11.1-8.3 24.6-12.8 38.4-12.8H328c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88c-8.8 0-16 7.2-16 16s7.2 16 16 16h180.2c9.7 0 19.1-3.3 26.7-9.3l61.6-49.2c4.2-3.4 9.5-5.2 14.6-5.2 5 0 9.9 1.7 13.8 5.2 10.1 9.1 9.3 24.5-.9 32.6l-100.8 80.7c-7.6 6.1-17 9.3-26.7 9.3H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h400.5c17 0 33.4-5.8 46.6-16.4L556 415c12.2-9.8 19.5-24.4 20-40s-6-30.8-17.7-41.4z"]
  },
      Gm = {
    prefix: "fal",
    iconName: "hand-holding-usd",
    icon: [576, 512, [], "f4c0", "M256.7 135.7l56.4 16.1c8.8 2.5 14.9 10.6 14.9 19.7 0 11.3-9.2 20.5-20.5 20.5h-36.9c-8.2 0-16.1-2.6-22.6-7.3-3-2.2-7.2-1.5-9.8 1.2l-11.4 11.4c-3.5 3.5-2.9 9.2 1 12.2 12.3 9.4 27.2 14.5 42.9 14.5h1.4v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-24h1.4c22.8 0 44.3-13.6 51.7-35.2 10.1-29.6-7.3-59.8-35.1-67.8L263 104.1c-8.8-2.5-14.9-10.6-14.9-19.7 0-11.3 9.2-20.5 20.5-20.5h36.9c8.2 0 16.1 2.6 22.6 7.3 3 2.2 7.2 1.5 9.8-1.2l11.4-11.4c3.5-3.5 2.9-9.2-1-12.2C336 37.1 321.1 32 305.4 32H304V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24h-3.5c-30.6 0-55.1 26.3-52.2 57.5 2 22.1 19 40.1 40.4 46.2zm301.6 197.9c-19.7-17.7-49.4-17.6-69.9-1.2l-61.6 49.3c-1.9 1.5-4.2 2.3-6.7 2.3h-41.6c4.6-9.6 6.5-20.7 4.8-32.3-4-27.9-29.6-47.7-57.8-47.7H181.3c-20.8 0-41 6.7-57.6 19.2L85.3 352H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88l46.9-35.2c11.1-8.3 24.6-12.8 38.4-12.8H328c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88c-8.8 0-16 7.2-16 16s7.2 16 16 16h180.2c9.7 0 19.1-3.3 26.7-9.3l61.6-49.2c7.7-6.1 20-7.6 28.4 0 10.1 9.1 9.3 24.5-.9 32.6l-100.8 80.7c-7.6 6.1-17 9.3-26.7 9.3H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h400.5c17 0 33.4-5.8 46.6-16.4L556 415c12.2-9.8 19.5-24.4 20-40s-6-30.8-17.7-41.4z"]
  },
      qm = {
    prefix: "fal",
    iconName: "hand-holding-water",
    icon: [576, 512, [], "f4c1", "M558.3 333.6c-9.6-8.6-22.1-13.4-35.2-13.4-12.5 0-24.8 4.3-34.6 12.2l-61.6 49.3c-1.9 1.5-4.2 2.3-6.7 2.3h-41.6c4.6-9.6 6.5-20.7 4.8-32.3-4-27.9-29.6-47.7-57.8-47.7H181.3c-20.8 0-41 6.7-57.6 19.2L85.3 352H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88l46.9-35.2c11.1-8.3 24.6-12.8 38.4-12.8H328c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88c-8.8 0-16 7.2-16 16s7.2 16 16 16h180.2c9.7 0 19.1-3.3 26.7-9.3l61.6-49.2c4.2-3.4 9.5-5.2 14.6-5.2 5 0 9.9 1.7 13.8 5.2 10.1 9.1 9.3 24.5-.9 32.6l-100.8 80.7c-7.6 6.1-17 9.3-26.7 9.3H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h400.5c17 0 33.4-5.8 46.6-16.4L556 415c12.2-9.8 19.5-24.4 20-40s-6-30.8-17.7-41.4zM288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-3.2-4.3-8-6.4-12.8-6.4s-9.6 2.1-12.8 6.4C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm0-213c44.1 61.4 64 103.5 64 119 0 34.2-28.7 62-64 62s-64-27.8-64-62c0-15.5 19.9-57.6 64-119z"]
  },
      Jm = {
    prefix: "fal",
    iconName: "hand-lizard",
    icon: [576, 512, [], "f258", "M558.232 297.931L406.298 61.41C394.468 42.994 374.338 32 352.45 32H48C21.532 32 0 53.532 0 80v8c0 39.701 32.299 72 72 72h216.103l-23.189 58.93a7.954 7.954 0 0 1-7.444 5.07H144c-44.112 0-80 35.888-80 80 0 26.468 21.532 48 48 48h125.848a31.98 31.98 0 0 1 16.822 4.778l93.536 57.799a7.948 7.948 0 0 1 3.794 6.805V480h224V358.463c0-21.506-6.144-42.439-17.768-60.532zM544 448H384v-26.618c0-13.966-7.093-26.687-18.973-34.027l-93.537-57.799A63.96 63.96 0 0 0 237.847 320H112c-8.822 0-16-7.178-16-16 0-26.468 21.532-48 48-48h113.469c16.551 0 31.161-9.952 37.222-25.353l25.34-64.394c7.227-18.362-6.334-38.254-26.055-38.254H72c-22.056 0-40-17.944-40-40v-8c0-8.822 7.178-16 16-16h304.45c10.943 0 21.009 5.497 26.924 14.705l151.935 236.521A79.854 79.854 0 0 1 544 358.463V448z"]
  },
      Km = {
    prefix: "fal",
    iconName: "hand-middle-finger",
    icon: [512, 512, [], "f806", "M479.94 312.94a63.91 63.91 0 0 0-48.47-62L415.94 247c0-26.64-17.73-44.92-39.23-48.91-30.84-5.73-31.43-6.11-37.6-6.11a50.84 50.84 0 0 0-19.11 3.74V64a64 64 0 0 0-127.94-.57c0 .21-.09.36-.09.57v131.72a50.84 50.84 0 0 0-19.15-3.72c-6.39 0-8.41.67-30.53 5.09A57.76 57.76 0 0 0 96 253.57v14.65l-28.63 14.31A63.66 63.66 0 0 0 32 339.78v63A63.58 63.58 0 0 0 50.75 448l26.5 26.51a127.15 127.15 0 0 0 90.5 37.49H352a128 128 0 0 0 128-128.08zM352 480H167.76a96 96 0 0 1-67.88-28.12l-26.51-26.51A32 32 0 0 1 64 402.74v-63a32 32 0 0 1 17.69-28.63L96 304v32a16 16 0 0 0 32 0v-82.43a25.64 25.64 0 0 1 20.62-25.11c19.45-3.89 21.11-4.46 24.21-4.46A19.21 19.21 0 0 1 192 243.21 12.79 12.79 0 0 0 204.77 256h6.41A12.79 12.79 0 0 0 224 243.21V65.37c0-16.71 12.22-31.64 28.86-33.22A32 32 0 0 1 288 64v179.21A12.79 12.79 0 0 0 300.75 256h6.41A12.79 12.79 0 0 0 320 243.21 19.21 19.21 0 0 1 339.11 224c2.88 0 3.31.29 31.69 5.56a16.06 16.06 0 0 1 13.14 15.74V272l39.76 9.94a32 32 0 0 1 24.24 31l.06 71A96 96 0 0 1 352 480z"]
  },
      Xm = {
    prefix: "fal",
    iconName: "hand-paper",
    icon: [448, 512, [], "f256", "M369.4 119.1V96.3c0-42.8-42.8-72.8-82.3-56.5-19.8-54.2-94.4-52.2-112.5.8-38.4-15.8-81.8 12.8-81.8 55.9v145.7c-20.3-13.7-47.6-13.9-68.4 1.5-26.6 19.6-32.4 57.1-13.1 83.9l125 174.4c4.5 6.3 11.8 10 19.5 10H388c11.2 0 20.9-7.7 23.4-18.6l31.4-135.6c3.4-14.8 5.2-30 5.2-45.3V176.2c0-41.5-40.6-70.1-78.6-57.1zM416 312.5c0 12.8-1.5 25.6-4.4 38l-30 129.4H159.9l-122.6-171c-9-12.6-6.3-30.4 6.1-39.5 12.3-9.1 29.6-6.4 38.6 6.2l28.3 39.4c4.5 6.3 14.5 3.1 14.5-4.7V96.5c0-38 55.4-36.9 55.4.7V256c0 4.4 3.6 8 8 8h7.1c4.4 0 8-3.6 8-8V60.2c0-38 55.4-36.9 55.4.7v195c0 4.4 3.6 8 8 8h7.1c4.4 0 8-3.6 8-8V95.6c0-38 55.4-36.9 55.4.7V256c0 4.4 3.6 8 8 8h7.1c4.4 0 8-3.6 8-8v-79c0-37.6 55.4-38.8 55.4-.7v136.2z"]
  },
      _m = {
    prefix: "fal",
    iconName: "hand-peace",
    icon: [448, 512, [], "f25b", "M363.642 201.124c-13.07-27.616-44.381-40.855-72.775-31.297V67.5c0-37.22-29.991-67.5-66.855-67.5s-66.855 30.28-66.855 67.5L160 176l-30.852-89.568C115.645 51.546 76.664 34.523 42.319 48.22 8.02 61.896-8.796 100.93 4.609 135.568L65.068 291.78c-29.161 23.68-49.333 51.547-28.683 88.228l57.139 101.5C104.112 500.316 124.007 512 145.445 512h214.273c13.464 0 26.679-4.662 37.21-13.128 10.455-8.405 17.889-20.266 20.933-33.4l28.57-123.25A60.856 60.856 0 0 0 448 328.5V256c0-43.874-45.136-72.88-84.358-54.876zM71.039 328.153l27.757-22.54a8.002 8.002 0 0 0 2.418-9.098L34.453 124.019C17.447 80.08 82.438 54.403 99.305 97.981l62.274 160.906a8 8 0 0 0 7.461 5.112h12.117a8 8 0 0 0 8-8V67.5c0-46.929 69.709-47.021 69.709 0V256a8 8 0 0 0 8 8h7.143a8 8 0 0 0 8-8v-29c0-37.351 55.425-37.41 55.425 0v29a8 8 0 0 0 8 8h7.143a8 8 0 0 0 8-8c0-37.35 55.424-37.41 55.424 0v72.5c0 2.186-.25 4.371-.742 6.496l-28.57 123.25C383.72 471.055 372.629 480 359.719 480H145.445c-9.898 0-19.108-5.437-24.035-14.189l-57.14-101.5c-6.863-12.192-4.016-27.398 6.769-36.158z"]
  },
      $m = {
    prefix: "fal",
    iconName: "hand-point-down",
    icon: [448, 512, [], "f0a7", "M185.6 512c38.484 0 70.4-32.063 70.4-70.4v-56.817c.351-.009.703-.02 1.054-.033 14.187-.536 27.727-4.655 39.582-11.885 23.339 4.644 48.386-2.335 65.494-16.635 49.786 1.625 85.87-29.026 85.87-88.631v-23.236c0-54.11-34.281-90.452-42.038-125.102C412.139 113.428 416 105.167 416 96V32c0-17.673-14.327-32-32-32H160c-17.673 0-32 14.327-32 32v64c0 11.62 6.194 21.792 15.459 27.397-10.075 18.05-49.384 49.858-67.144 60.919C53.853 198.2 0 207.454 0 256c0 41.313 29.922 73.6 70.4 73.6 17.79 0 32.611-4.354 44.8-9.791V441.6c0 37.63 32.239 70.4 70.4 70.4zM384 32v64H160V32h224zM185.6 480c-20.4 0-38.4-18.3-38.4-38.4V268.8c-18.9 0-38.4 28.8-76.8 28.8C48 297.6 32 280 32 256s35.686-28.704 61.2-44.5c23.443-14.595 72.556-53.665 83.262-83.5h198.677C384.733 167.68 416 200.026 416 244.364V267.6c0 44.208-24.215 62.317-66.9 55.201-8.728 15.94-37.068 26.347-58.5 14.1-19.882 21.125-50.597 19.404-66.6 5.4V441.6c0 20.7-17.7 38.4-38.4 38.4zM332 64c0-11.046 8.954-20 20-20s20 8.954 20 20-8.954 20-20 20-20-8.954-20-20z"]
  },
      cv = {
    prefix: "fal",
    iconName: "hand-point-left",
    icon: [512, 512, [], "f0a5", "M0 217.6C0 256.084 32.063 288 70.4 288h56.817c.009.351.02.703.033 1.054.536 14.187 4.655 27.727 11.885 39.582-4.644 23.339 2.335 48.386 16.635 65.494-1.625 49.786 29.026 85.87 88.631 85.87h23.236c54.11 0 90.452-34.281 125.102-42.038C398.572 444.139 406.833 448 416 448h64c17.673 0 32-14.327 32-32V192c0-17.673-14.327-32-32-32h-64c-11.62 0-21.792 6.194-27.397 15.459-18.051-10.075-49.858-49.384-60.919-67.144C313.8 85.853 304.546 32 256 32c-41.313 0-73.6 29.922-73.6 70.4 0 17.79 4.354 32.611 9.791 44.8H70.4C32.77 147.2 0 179.439 0 217.6zM480 416h-64V192h64v224zM32 217.6c0-20.4 18.3-38.4 38.4-38.4h172.8c0-18.9-28.8-38.4-28.8-76.8C214.4 80 232 64 256 64s28.704 35.686 44.5 61.2c14.595 23.443 53.665 72.556 83.5 83.262v198.677C344.32 416.733 311.974 448 267.636 448H244.4c-44.208 0-62.317-24.215-55.201-66.9-15.94-8.728-26.347-37.068-14.1-58.5-21.125-19.882-19.404-50.597-5.4-66.6H70.4C49.7 256 32 238.3 32 217.6zM448 364c11.046 0 20 8.954 20 20s-8.954 20-20 20-20-8.954-20-20 8.954-20 20-20z"]
  },
      ev = {
    prefix: "fal",
    iconName: "hand-point-right",
    icon: [512, 512, [], "f0a4", "M441.6 147.2H319.809c5.437-12.189 9.791-27.01 9.791-44.8 0-40.478-32.286-70.4-73.6-70.4-48.546 0-57.8 53.853-71.683 76.315-11.062 17.761-42.869 57.069-60.919 67.144C117.792 166.194 107.62 160 96 160H32c-17.673 0-32 14.327-32 32v224c0 17.673 14.327 32 32 32h64c9.167 0 17.428-3.861 23.262-10.038C153.911 445.719 190.254 480 244.364 480H267.6c59.606 0 90.256-36.084 88.631-85.87 14.3-17.108 21.279-42.155 16.635-65.494 7.229-11.856 11.348-25.395 11.885-39.582.013-.351.024-.703.033-1.054H441.6c38.337 0 70.4-31.916 70.4-70.4 0-38.161-32.77-70.4-70.4-70.4zM32 192h64v224H32V192zm409.6 64h-99.301c14.004 16.003 15.726 46.718-5.4 66.6 12.247 21.431 1.841 49.771-14.1 58.5 7.116 42.685-10.993 66.9-55.201 66.9h-23.236c-44.337 0-76.684-31.267-116.364-40.861V208.462c29.835-10.706 68.904-59.818 83.5-83.262C227.296 99.686 232 64 256 64s41.6 16 41.6 38.4c0 38.4-28.8 57.9-28.8 76.8h172.8c20.1 0 38.4 18 38.4 38.4 0 20.7-17.7 38.4-38.4 38.4zM84 384c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20 20 8.954 20 20z"]
  },
      av = {
    prefix: "fal",
    iconName: "hand-point-up",
    icon: [448, 512, [], "f0a6", "M115.2 70.4v121.792c-12.189-5.437-27.01-9.791-44.8-9.791C29.922 182.4 0 214.687 0 256c0 48.546 53.853 57.8 76.315 71.683 17.761 11.062 57.069 42.869 67.144 60.919C134.194 394.208 128 404.38 128 416v64c0 17.673 14.327 32 32 32h224c17.673 0 32-14.327 32-32v-64c0-9.167-3.861-17.428-10.038-23.262C413.719 358.089 448 321.746 448 267.636V244.4c0-59.606-36.084-90.256-85.87-88.631-17.108-14.3-42.155-21.279-65.494-16.635-11.856-7.229-25.395-11.348-39.582-11.885a92.713 92.713 0 0 0-1.054-.033V70.4C256 32.063 224.084 0 185.6 0c-38.161 0-70.4 32.77-70.4 70.4zM160 480v-64h224v64H160zm64-409.6v99.301c16.003-14.004 46.718-15.726 66.6 5.4 21.431-12.247 49.771-1.841 58.5 14.1 42.685-7.116 66.9 10.993 66.9 55.201v23.236c0 44.337-31.267 76.684-40.861 116.364H176.462c-10.706-29.835-59.818-68.904-83.262-83.5C67.686 284.704 32 280 32 256s16-41.6 38.4-41.6c38.4 0 57.9 28.8 76.8 28.8V70.4c0-20.1 18-38.4 38.4-38.4 20.7 0 38.4 17.7 38.4 38.4zM352 428c11.046 0 20 8.954 20 20s-8.954 20-20 20-20-8.954-20-20 8.954-20 20-20z"]
  },
      nv = {
    prefix: "fal",
    iconName: "hand-pointer",
    icon: [448, 512, [], "f25a", "M360.543 188.156c-17.46-28.491-54.291-37.063-82.138-19.693-15.965-20.831-42.672-28.278-66.119-20.385V60.25c0-33.222-26.788-60.25-59.714-60.25S92.857 27.028 92.857 60.25v181.902c-20.338-13.673-47.578-13.89-68.389 1.472-26.556 19.605-32.368 57.08-13.132 83.926l114.271 159.5C136.803 502.673 154.893 512 174 512h185.714c27.714 0 51.832-19.294 58.145-46.528l28.571-123.25a60.769 60.769 0 0 0 1.57-13.723v-87c0-45.365-48.011-74.312-87.457-53.343zM82.097 275.588l28.258 39.439a7.999 7.999 0 1 0 14.503-4.659V60.25c0-37.35 55.428-37.41 55.428 0V241.5a8 8 0 0 0 8 8h7.144a8 8 0 0 0 8-8v-36.25c0-37.35 55.429-37.41 55.429 0v36.25a8 8 0 0 0 8 8H274a8 8 0 0 0 8-8v-21.75c0-37.351 55.429-37.408 55.429 0v21.75a8 8 0 0 0 8 8h7.143a8 8 0 0 0 8-8c0-37.35 55.429-37.41 55.429 0v87c0 2.186-.25 4.371-.742 6.496l-28.573 123.251C383.717 471.055 372.626 480 359.715 480H174c-8.813 0-17.181-4.332-22.381-11.588l-114.283-159.5c-22.213-31.004 23.801-62.575 44.761-33.324zM180.285 401v-87a8 8 0 0 1 8-8h7.144a8 8 0 0 1 8 8v87a8 8 0 0 1-8 8h-7.144a8 8 0 0 1-8-8zm78.572 0v-87a8 8 0 0 1 8-8H274a8 8 0 0 1 8 8v87a8 8 0 0 1-8 8h-7.143a8 8 0 0 1-8-8zm78.572 0v-87a8 8 0 0 1 8-8h7.143a8 8 0 0 1 8 8v87a8 8 0 0 1-8 8h-7.143a8 8 0 0 1-8-8z"]
  },
      tv = {
    prefix: "fal",
    iconName: "hand-receiving",
    icon: [640, 512, [], "f47c", "M439.2 105.6L342.9 9.3C336.7 3.1 328.6 0 320.5 0s-16.2 3.1-22.4 9.3l-96.4 96.4c-12.3 12.3-12.3 32.4 0 44.7l96.4 96.4c6.2 6.2 14.3 9.3 22.4 9.3s16.2-3.1 22.4-9.3l96.4-96.4c12.3-12.4 12.3-32.4-.1-44.8zM320.5 224.4L224.1 128l96.3-96.4 96.4 96.4-96.3 96.4zM220 248.8c-14-19.2-49.1-31.4-74.5-3.9-15.6 16.8-15.9 42.8-2.5 61.3l28.6 39.3c6.5 8.9-6.5 19.1-13.6 10.7l-62-73.3V145.8c0-26-21.2-49.3-47.2-49.7C21.9 95.6 0 117.2 0 144v170.4c0 10.9 3.7 21.5 10.5 30l107 133.7c5.4 6.8 8.9 17.5 10.1 27 .5 4 4 6.9 8 6.9h16c4.8 0 8.5-3.9 8-8.7-1.6-16-7.5-33.3-17.1-45.2l-107-133.7c-2.3-2.8-3.5-6.4-3.5-10V144c0-21 32-21.6 32 .7v149.7l64.6 77.5c36.9 44.2 96.8-2.7 70.8-42.4-.2-.3-.4-.5-.5-.8l-30.6-42.2c-4.7-6.5-4.2-16.7 3.5-22.3 7-5.1 17.1-3.8 22.4 3.5l42.4 58.4c12.7 16.9 19.5 37.4 19.5 58v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-120c0-27.7-9-54.6-25.6-76.8L220 248.8zM640 144c0-26.8-21.9-48.4-48.8-48-26 .4-47.2 23.7-47.2 49.7v137.1l-62 73.3c-7.1 8.4-20.1-1.7-13.6-10.7l28.6-39.3c13.4-18.5 13.1-44.6-2.5-61.3-25.5-27.4-60.6-15.3-74.5 3.9l-42.4 58.4C361 329.3 352 356.3 352 384v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V384c0-20.6 6.8-41.1 19.5-58l42.4-58.4c5.3-7.3 15.3-8.7 22.4-3.5 7.8 5.6 8.3 15.8 3.5 22.3l-30.6 42.2c-.2.3-.4.5-.5.8-26.1 39.7 33.9 86.7 70.8 42.4l64.6-77.5V144.6c0-22.3 32-21.7 32-.7v170.4c0 3.6-1.2 7.2-3.5 10L497.6 458c-9.5 11.9-15.5 29.2-17.1 45.2-.5 4.8 3.2 8.7 8 8.7h16c4 0 7.5-2.9 8-6.9 1.2-9.6 4.6-20.2 10.1-27l107-133.7c6.8-8.5 10.5-19.1 10.5-30L640 144z"]
  },
      rv = {
    prefix: "fal",
    iconName: "hand-rock",
    icon: [512, 512, [], "f255", "M412.055 83.099C394.09 42.33 342.756 30.157 308.44 57.07c-28.257-34.829-80.888-32.701-106.878 2.23C157.639 26.987 94.25 58.222 94.25 113.143v10.078C50.599 104.318 0 135.857 0 184.571v59.326c0 31.379 13.628 61.31 37.389 82.119l101.2 88.626C147.059 422.06 145 429.788 145 456c0 13.255 10.745 24 24 24h261c13.255 0 24-10.745 24-24 0-24.785-1.14-33.765 4.887-47.867l44.364-103.808c5.805-13.583 8.749-27.948 8.749-42.694V142.42c0-51.69-55.549-83.525-99.945-59.321zM159.67 390.568l-101.2-88.626C41.648 287.21 32 266.054 32 243.897v-59.326c0-19.525 16.327-35.242 36.112-34.852 19.237.316 34.888 16.267 34.888 35.557v42.946c0 2.306.995 4.5 2.729 6.019l7.25 6.349a8 8 0 0 0 13.271-6.018V113.143c0-45.246 71-47.412 71 .706v27.865a8 8 0 0 0 8 8h7.25a8 8 0 0 0 8-8V98.857c0-45.23 71-47.429 71 .705v42.151a8 8 0 0 0 8 8h7.25a8 8 0 0 0 8-8V109.57c0-46.004 71-46.504 71 .705v31.438a8 8 0 0 0 8 8H401a8 8 0 0 0 8-8c0-45.242 71-47.428 71 .706V261.63a76.236 76.236 0 0 1-6.174 30.119l-44.365 103.808C420.883 415.63 422 429.933 422 448H177c0-19.081 2.866-39.746-17.33-57.432z"]
  },
      iv = {
    prefix: "fal",
    iconName: "hand-scissors",
    icon: [512, 512, [], "f257", "M256 480h72.5c4.615 0 9.232-.528 13.722-1.569l123.25-28.57c13.133-3.044 24.995-10.478 33.4-20.933 8.466-10.531 13.128-23.746 13.128-37.21V177.445c0-21.438-11.684-41.333-30.492-51.92l-101.5-57.139c-36.681-20.651-64.548-.478-88.228 28.683l-156.211-60.46c-34.639-13.405-73.672 3.411-87.35 37.709-13.696 34.345 3.326 73.326 38.212 86.829L176 192l-108.5-2.843c-37.22 0-67.5 29.991-67.5 66.855s30.28 66.854 67.5 66.854h102.327c-9.558 28.393 3.681 59.705 31.297 72.775C183.12 434.864 212.126 480 256 480zM364.311 96.271l101.5 57.14c8.753 4.927 14.189 14.137 14.189 24.035v214.272c0 12.91-8.945 24.001-21.754 26.97l-123.25 28.57a28.843 28.843 0 0 1-6.496.742H256c-37.41 0-37.35-55.424 0-55.424a8 8 0 0 0 8-8v-7.143a8 8 0 0 0-8-8h-29c-37.41 0-37.351-55.425 0-55.425h29a8 8 0 0 0 8-8v-7.143a8 8 0 0 0-8-8H67.5c-47.021 0-46.929-69.709 0-69.709H256a8 8 0 0 0 8-8V201.04a8 8 0 0 0-5.112-7.461L97.981 131.305c-43.579-16.867-17.902-81.857 26.037-64.852l172.497 66.761a8.002 8.002 0 0 0 9.098-2.418l22.54-27.757c8.76-10.785 23.966-13.632 36.158-6.768z"]
  },
      ov = {
    prefix: "fal",
    iconName: "hand-sparkles",
    icon: [640, 512, [], "e05d", "M307.58,288a4,4,0,0,0-7.15,0L288,317.79l-29.79,12.42a4,4,0,0,0,0,7.15L288,349.78l12.42,29.78a4,4,0,0,0,7.15,0L320,349.78l29.79-12.42a4,4,0,0,0,0-7.15L320,317.79ZM106.66,168.46l.09-.05,49.55-20.66a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,65.48a6.65,6.65,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,135.82a7.29,7.29,0,0,0-3.68,6H0a7.32,7.32,0,0,0,3.68,6l49.57,20.67.07,0L74,218.08a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM640,429.78a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L566,353.48a6.65,6.65,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,423.82a7.29,7.29,0,0,0-3.68,6h0a7.32,7.32,0,0,0,3.68,6l49.57,20.67.07,0L554,506.08a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.32,7.32,0,0,0,3.68-6h0ZM453.89,480H273.3a32.3,32.3,0,0,1-26.71-14.3L132.39,293.8a23.92,23.92,0,0,1,5.91-33.39c15.79-11.11,30,1,33.39,5.89l37.81,54.4a8,8,0,0,0,14.59-4.61V88a24,24,0,1,1,48,0V248a8,8,0,0,0,8,8H292.3a35.81,35.81,0,0,1,7.78-1.66c2.26-1.41,4-3.49,4-6.34V56a24,24,0,0,1,48,0V248a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V88a24,24,0,0,1,48,0V248a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V168a24,24,0,0,1,48,0V288.3a321.9,321.9,0,0,1-6.2,62.79l-6.27,31.42,9.25-3.86,15.63-37.49.41-1,.47-.95a38.75,38.75,0,0,1,16.93-16.7c1.1-11.35,1.69-22.75,1.69-34.12V168a55.89,55.89,0,0,0-55.91-56,55.24,55.24,0,0,0-24,5.41V88a56,56,0,0,0-82.7-49.2,56,56,0,0,0-106.59,0A56,56,0,0,0,192.09,88V240.8C180.59,229,150,213.09,120,234.09a56.09,56.09,0,0,0-13.81,78l113.7,171.32A63.88,63.88,0,0,0,273.19,512H453.8a64.21,64.21,0,0,0,54.9-31.16l-30.47-12.7A31.57,31.57,0,0,1,453.89,480Z"]
  },
      lv = {
    prefix: "fal",
    iconName: "hand-spock",
    icon: [512, 512, [], "f259", "M503.03886,115.67818a59.82954,59.82954,0,0,0-37.35993-27.03135,60.44007,60.44007,0,0,0-33.70576,1.64649c.08593-26.49815-16.33728-50.40449-41.75234-58.467C344.205,17.23249,317.34857,55.80686,312.964,77.139L291.47649,181.89913,256.33524,45.22479A60.245,60.245,0,1,0,139.64431,75.24248l3.74205,14.55279a60.14487,60.14487,0,0,0-75.66708,74.55888C108.98335,303.634,106.626,295.65543,107.02249,297.05192l-5.49394-5.1719a60.24146,60.24146,0,1,0-82.5633,87.74643l98.14084,92.36363A146.6781,146.6781,0,0,0,217.99879,512H333.41632a117.845,117.845,0,0,0,115.02693-90.85386L510.33546,161.2096A59.83169,59.83169,0,0,0,503.03886,115.67818Zm-23.83309,38.11928L417.31356,413.73205a85.95272,85.95272,0,0,1-83.89724,66.26783H217.99879A114.79622,114.79622,0,0,1,139.035,448.68726l-98.1428-92.36754c-27.206-25.59385,11.5191-66.8108,38.70753-41.13688l54.91005,51.67989c5.43534,5.12111,13.48191.70313,13.48191-5.8262a264.52145,264.52145,0,0,0-10.90584-75.19559L98.40367,155.274c-10.67929-36.08607,43.56086-51.87129,54.18156-16.045L186.25584,252.8662c5.78884,19.57234,34.942,11.08012,29.96762-8.28909L170.63728,67.27956c-9.36683-36.45913,45.39283-50.30683,54.70693-14.086l50.834,197.70778c4.60725,17.91218,30.28988,17.14264,33.98115-.83985L344.30654,83.58235c7.46066-36.2931,63.11286-26.49619,54.994,13.0899L368.63375,246.17282c-3.83775,18.7364,24.45807,25.40634,28.98133,6.4219l26.63963-111.88129C433.07469,103.768,487.79334,117.813,479.20577,153.79746Z"]
  },
      fv = {
    prefix: "fal",
    iconName: "hands",
    icon: [640, 512, [], "f4c2", "M220 248.8c-14-19.2-49.1-31.4-74.5-3.9-15.6 16.8-15.9 42.8-2.5 61.3l28.6 39.3c6.5 8.9-6.5 19.1-13.6 10.7l-62-73.3V145.8c0-26-21.2-49.3-47.2-49.7C21.9 95.6 0 117.2 0 144v170.4c0 10.9 3.7 21.5 10.5 30l107 133.7c5.4 6.8 8.9 17.5 10.1 27 .5 4 4 6.9 8 6.9h16c4.8 0 8.5-3.9 8-8.7-1.6-16-7.5-33.3-17.1-45.2l-107-133.7c-2.3-2.8-3.5-6.4-3.5-10V144c0-21 32-21.6 32 .7v149.7l64.6 77.5c36.9 44.2 96.8-2.7 70.8-42.4-.2-.3-.4-.5-.5-.8l-30.6-42.2c-4.7-6.5-4.2-16.7 3.5-22.3 7-5.1 17.1-3.8 22.4 3.5l42.4 58.4c12.7 16.9 19.5 37.4 19.5 58v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-120c0-27.7-9-54.6-25.6-76.8L220 248.8zM640 144c0-26.8-21.9-48.4-48.8-48-26 .4-47.2 23.7-47.2 49.7v137.1l-62 73.3c-7.1 8.4-20.1-1.7-13.6-10.7l28.6-39.3c13.4-18.5 13.1-44.6-2.5-61.3-25.5-27.4-60.6-15.3-74.5 3.9l-42.4 58.4C361 329.3 352 356.3 352 384v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V384c0-20.6 6.8-41.1 19.5-58l42.4-58.4c5.3-7.3 15.3-8.7 22.4-3.5 7.8 5.6 8.3 15.8 3.5 22.3l-30.6 42.2c-.2.3-.4.5-.5.8-26.1 39.7 33.9 86.7 70.8 42.4l64.6-77.5V144.6c0-22.3 32-21.7 32-.7v170.4c0 3.6-1.2 7.2-3.5 10L497.6 458c-9.5 11.9-15.5 29.2-17.1 45.2-.5 4.8 3.2 8.7 8 8.7h16c4 0 7.5-2.9 8-6.9 1.2-9.6 4.6-20.2 10.1-27l107-133.7c6.8-8.5 10.5-19.1 10.5-30L640 144z"]
  },
      sv = {
    prefix: "fal",
    iconName: "hands-heart",
    icon: [640, 512, [], "f4c3", "M436 17.6C421.6 5.1 405.4 0 389.6 0 366.8 0 345 10.7 331 25.3L320 37l-11.1-11.6C295.2 11 273.3 0 250.2 0c-15.7 0-31.8 5.1-46.3 17.6-35.3 30.6-37.2 85.6-5.6 118.7l108.9 114.1c7 7.4 18.4 7.4 25.5 0l108.9-114.1c31.6-33.1 29.8-88.1-5.6-118.7zm-17 96.5l-99 103.8-99-103.8c-16.7-17.5-20.4-51.6 3.4-72.1 8.2-7.1 17.3-9.9 26.3-9.9 13.9 0 27.3 6.9 35.6 15.6L320 82.9l33.7-35.3C361.9 39 375.4 32 389.3 32c8.9 0 18.1 2.8 26.2 9.9 23.9 20.7 20.2 54.6 3.5 72.2zM220 248.8c-14-19.2-49.1-31.4-74.5-3.9-15.6 16.8-15.9 42.8-2.5 61.3l28.6 39.3c6.5 8.9-6.5 19.1-13.6 10.7l-62-73.3V145.8c0-26-21.2-49.3-47.2-49.7C21.9 95.6 0 117.2 0 144v170.4c0 10.9 3.7 21.5 10.5 30l107 133.7c5.4 6.8 8.9 17.5 10.1 27 .5 4 4 6.9 8 6.9h16c4.8 0 8.5-3.9 8-8.7-1.6-16-7.5-33.3-17.1-45.2l-107-133.7c-2.3-2.8-3.5-6.4-3.5-10V144c0-21 32-21.6 32 .7v149.7l64.6 77.5c36.9 44.2 96.8-2.7 70.8-42.4-.2-.3-.4-.5-.5-.8l-30.6-42.2c-4.7-6.5-4.2-16.7 3.5-22.3 7-5.1 17.1-3.8 22.4 3.5l42.4 58.4c12.7 16.9 19.5 37.4 19.5 58v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-120c0-27.7-9-54.6-25.6-76.8L220 248.8zM640 144c0-26.8-21.9-48.4-48.8-48-26 .4-47.2 23.7-47.2 49.7v137.1l-62 73.3c-7.1 8.4-20.1-1.7-13.6-10.7l28.6-39.3c13.4-18.5 13.1-44.6-2.5-61.3-25.5-27.4-60.6-15.3-74.5 3.9l-42.4 58.4C361 329.3 352 356.3 352 384v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V384c0-20.6 6.8-41.1 19.5-58l42.4-58.4c5.3-7.3 15.3-8.7 22.4-3.5 7.8 5.6 8.3 15.8 3.5 22.3l-30.6 42.2c-.2.3-.4.5-.5.8-26.1 39.7 33.9 86.7 70.8 42.4l64.6-77.5V144.6c0-22.3 32-21.7 32-.7v170.4c0 3.6-1.2 7.2-3.5 10L497.6 458c-9.5 11.9-15.5 29.2-17.1 45.2-.5 4.8 3.2 8.7 8 8.7h16c4 0 7.5-2.9 8-6.9 1.2-9.6 4.6-20.2 10.1-27l107-133.7c6.8-8.5 10.5-19.1 10.5-30L640 144z"]
  },
      uv = {
    prefix: "fal",
    iconName: "hands-helping",
    icon: [640, 512, [], "f4c4", "M638.9 209.7l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-108 63V240c0-26.5-21.5-48-48-48H320v62.2c0 16-10.9 30.8-26.6 33.3-20 3.3-37.4-12.2-37.4-31.6v-94.3c0-13.8 7.1-26.6 18.8-33.9l33.4-20.9c11.4-7.1 24.6-10.9 38.1-10.9h103.2l118.5-67c3.8-2.2 5.2-7.1 3-10.9l-8-14c-2.2-3.8-7.1-5.2-10.9-3l-111 63h-94.7c-19.5 0-38.6 5.5-55.1 15.8l-33.5 20.9c-17.5 11-28.7 28.6-32.2 48.5l-62.5 37c-21.6 13-35.1 36.7-35.1 61.9v38.6L4 357.1c-3.8 2.2-5.2 7.1-3 10.9l8 13.9c2.2 3.8 7.1 5.2 10.9 3L160 305.3v-57.2c0-14 7.5-27.2 19.4-34.4l44.6-26.4v65.9c0 33.4 24.3 63.3 57.6 66.5 38.1 3.7 70.4-26.3 70.4-63.7v-32h112c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-24v36c0 19.8-16 35.8-35.8 35.8h-16.1v16c0 22.2-18 40.2-40.2 40.2H238.5l-115.6 67.3c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.8c2.2 3.8 7.1 5.1 10.9 2.9L247.1 448h100.8c34.8 0 64-24.8 70.8-57.7 30.4-6.7 53.3-33.9 53.3-66.3v-4.7c13.6-2.3 24.6-10.6 31.8-21.7l132.2-77c3.8-2.2 5.1-7.1 2.9-10.9z"]
  },
      hv = {
    prefix: "fal",
    iconName: "hands-usd",
    icon: [640, 512, [], "f4c5", "M640 144c0-26.8-21.9-48.4-48.8-48-26 .4-47.2 23.7-47.2 49.7v137.1l-62 73.3c-7.1 8.4-20.1-1.7-13.6-10.7l28.6-39.3c13.4-18.5 13.1-44.6-2.5-61.3-25.5-27.4-60.6-15.3-74.5 3.9l-42.4 58.4C361 329.3 352 356.3 352 384v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V384c0-20.6 6.8-41.1 19.5-58l42.4-58.4c5.3-7.3 15.3-8.7 22.4-3.5 7.8 5.6 8.3 15.8 3.5 22.3l-30.6 42.2c-.2.3-.4.5-.5.8-26.1 39.7 33.9 86.7 70.8 42.4l64.6-77.5V144.6c0-22.3 32-21.7 32-.7v170.4c0 3.6-1.2 7.2-3.5 10L497.6 458c-9.5 11.9-15.5 29.2-17.1 45.2-.5 4.8 3.2 8.7 8 8.7h16c4 0 7.5-2.9 8-6.9 1.2-9.6 4.6-20.2 10.1-27l107-133.7c6.8-8.5 10.5-19.1 10.5-30L640 144zM220 248.8c-14-19.2-49.1-31.4-74.5-3.9-15.6 16.8-15.9 42.8-2.5 61.3l28.6 39.3c6.5 8.9-6.5 19.1-13.6 10.7l-62-73.3V145.8c0-26-21.2-49.3-47.2-49.7C21.9 95.6 0 117.2 0 144v170.4c0 10.9 3.7 21.5 10.5 30l107 133.7c5.4 6.8 8.9 17.5 10.1 27 .5 4 4 6.9 8 6.9h16c4.8 0 8.5-3.9 8-8.7-1.6-16-7.5-33.3-17.1-45.2l-107-133.7c-2.3-2.8-3.5-6.4-3.5-10V144c0-21 32-21.6 32 .7v149.7l64.6 77.5c36.9 44.2 96.8-2.7 70.8-42.4-.2-.3-.4-.5-.5-.8l-30.6-42.2c-4.7-6.5-4.2-16.7 3.5-22.3 7-5.1 17.1-3.8 22.4 3.5l42.4 58.4c12.7 16.9 19.5 37.4 19.5 58v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-120c0-27.7-9-54.6-25.6-76.8L220 248.8zm169.1-60c10.1-29.6-7.3-59.8-35.1-67.8l-59.1-16.9c-8.8-2.5-14.9-10.6-14.9-19.7 0-11.3 9.2-20.5 20.5-20.5h36.9c8.2 0 16.1 2.6 22.6 7.3 3 2.2 7.2 1.5 9.8-1.2l11.4-11.4c3.5-3.5 2.9-9.2-1-12.2C368 37.1 353.1 32 337.4 32H336V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24h-3.5c-30.6 0-55.1 26.3-52.2 57.5 2.1 22.2 19.1 40.1 40.5 46.2l56.4 16.1c8.8 2.5 14.9 10.6 14.9 19.7 0 11.3-9.2 20.5-20.5 20.5h-36.9c-8.2 0-16.1-2.6-22.6-7.3-3-2.2-7.2-1.5-9.8 1.2l-11.4 11.4c-3.5 3.5-2.9 9.2 1 12.2 12.3 9.4 27.2 14.5 42.9 14.5h1.4v24c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-24h1.4c22.6 0 44.1-13.6 51.5-35.2z"]
  },
      mv = {
    prefix: "fal",
    iconName: "hands-wash",
    icon: [576, 512, [], "e05e", "M416,160a64,64,0,1,0,64-64A64.06,64.06,0,0,0,416,160Zm96,0a32,32,0,1,1-32-32A32,32,0,0,1,512,160ZM432,96a48,48,0,1,0-48-48A48.05,48.05,0,0,0,432,96Zm0-64a16,16,0,1,1-16,16A16,16,0,0,1,432,32Zm83.22,268a53.5,53.5,0,0,0-.2-19.25C510.26,256,488,238,462.21,238H375.94a53.21,53.21,0,0,0-8.3-31.58l2.45-7.75,13.44-42.54a53,53,0,0,0-43.24-68.47,53.12,53.12,0,0,0-45-43.57A53.08,53.08,0,0,0,249,.35,52.23,52.23,0,0,0,243,0h0a53.09,53.09,0,0,0-37.38,15.82,53.62,53.62,0,0,0-18.49-5.64,52.05,52.05,0,0,0-6-.35c-22.85,0-43.71,15.55-50.75,37.82l-26,82.26A53.15,53.15,0,0,0,86,126.48c-29.54,0-53.64,23.53-54,52.46V278c.53,33.33,13.29,64.23,34,88.73A79.87,79.87,0,0,0,112,512c24.09,0,45.47-10.93,60.15-27.84C194.78,501.28,222.42,512,253,512H435a53,53,0,0,0,52.26-61.86,53.09,53.09,0,0,0,28-56,52.84,52.84,0,0,0,0-94.1ZM333,119.14a19.44,19.44,0,0,1,2.27.13A21,21,0,0,1,353,146.49l-12.24,38.74a51.92,51.92,0,0,0-33.22-.94l-11.67,3.6,16.84-53.3C315.56,125.64,323.76,119.14,333,119.14ZM64,278V179.36c.15-11.63,10.17-20.88,21.71-20.88h.08a21,21,0,0,1,20.88,21.13l1.82,43.79L161,57.29c2.83-9,11-15.46,20.23-15.46a21.4,21.4,0,0,1,2.26.13,21,21,0,0,1,17.8,27.22L167.52,176a7,7,0,0,0,13.35,4.22L222.8,47.46c2.83-9,11-15.46,20.23-15.46a19.32,19.32,0,0,1,2.27.13,21,21,0,0,1,17.79,27.22L225.14,179.92a7,7,0,0,0,13.35,4.22L267.77,91c2.82-9,11-15.45,20.23-15.45a19.15,19.15,0,0,1,2.26.13,21,21,0,0,1,17.79,27.22l-28.43,90L213.1,213.45C154.75,232.9,116,286.47,116,347v5.43c-1.35-.06-2.63-.4-4-.4a79.54,79.54,0,0,0-15.3,1.55A107.58,107.58,0,0,1,64,278Zm48,202a48,48,0,1,1,48-48A48,48,0,0,1,112,480ZM491,368H351a7,7,0,0,0,0,14H462.21c10.16,0,19.47,6.86,21.39,16.84A21,21,0,0,1,463,424H351a7,7,0,0,0,0,14h83.21c10.16,0,19.47,6.86,21.39,16.84A21,21,0,0,1,435,480H253a103.56,103.56,0,0,1-65.27-23.41A79,79,0,0,0,192,432c0-31.1-18-57.81-44-71V347a108.4,108.4,0,0,1,74.54-103l94.25-29.09A21.43,21.43,0,0,1,323,214a21,21,0,0,1,6.24,41.06L288,270H462.21c10.16,0,19.47,6.86,21.39,16.84A21,21,0,0,1,463,312H351a7,7,0,0,0,0,14H490.21c10.16,0,19.47,6.86,21.39,16.84A21,21,0,0,1,491,368Z"]
  },
      vv = {
    prefix: "fal",
    iconName: "handshake",
    icon: [640, 512, [], "f2b5", "M16 319.8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16c0 8.9 7.2 16 16 16zM632 128l-113.5.2-51.2-49.9c-9.1-9.1-21.1-14.1-33.9-14.1h-101c-10.4 0-20.1 3.9-28.3 10-8.4-6.5-18.7-10.3-29.3-10.3h-69.5c-12.7 0-24.9 5.1-33.9 14.1l-50 50H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56v191.9H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56c17.6 0 31.8-14.2 31.9-31.7h33.2l81.5 78c29.8 24.1 71.8 23.4 101-.2l7.2 6.2c9.6 7.8 21.3 11.9 33.5 11.9 16 0 31.1-7 41.4-19.6l21.9-26.9c16.4 8.9 42.9 9 60-12l9.5-11.7c6.2-7.6 9.6-16.6 10.5-25.7h48.6c.1 17.5 14.4 31.7 31.9 31.7h56c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-56V160.2l56-.2c4.4 0 8-3.6 8-8v-16c-.1-4.5-3.7-8-8.1-8zM460.2 357.6l-9.5 11.7c-5.4 6.6-15.4 8.1-22.5 2.3l-17.8-14.4-41.5 51c-7.5 9.3-21 10.2-29.4 3.4l-30.6-26.1-10.4 12.8c-16.7 20.5-47 23.7-66.6 7.9L142 320.1H96V159.9h38.6l59.3-59.3c3-3 7.1-4.7 11.3-4.7h69.5c.9 2.2.3.7 1.1 2.9l-59 54.2c-28.2 25.9-29.6 69.2-4.2 96.9 14.3 15.6 58.6 39.3 96.9 4.2l22.8-20.9 125.6 101.9c6.8 5.6 7.8 15.7 2.3 22.5zm83.8-37.5h-57.2c-2.5-3.5-5.3-6.9-8.8-9.8l-121.9-99 28.4-26.1c6.5-6 7-16.1 1-22.6s-16.1-6.9-22.6-1l-75.1 68.8c-14.4 13.1-38.6 12-51.7-2.2-13.6-14.8-12.7-38 2.2-51.7l83.1-76.2c3-2.7 6.8-4.2 10.8-4.2h101c4.3 0 8.3 1.7 11.4 4.8l60.7 59.1H544v160.1zm80-32.2c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16c0-8.9-7.2-16-16-16z"]
  },
      dv = {
    prefix: "fal",
    iconName: "handshake-alt",
    icon: [640, 512, [], "f4c6", "M238.4 176.6l83.1-76.2c3-2.7 6.8-4.2 10.8-4.2h101c4.3 0 8.3 1.7 11.4 4.8l60.7 59.1H632c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H518.5l-51.2-49.9c-9.1-9.1-21.1-14.1-33.9-14.1h-101c-10.4 0-20.1 3.9-28.3 10-8.4-6.5-18.7-10.3-29.3-10.3h-69.5c-12.7 0-24.9 5.1-34 14.1L121.4 128H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h126.6l59.3-59.3c3-3 7.1-4.7 11.3-4.7h69.5c.9 2.2.3.7 1.1 2.9l-59 54.1c-28.2 25.9-29.6 69.2-4.2 96.9 14.3 15.6 58.6 39.3 96.9 4.2l22.8-20.9 125.6 101.9c6.8 5.5 7.9 15.7 2.3 22.5l-9.5 11.7c-5.4 6.6-15.4 8.1-22.5 2.3l-17.8-14.4-41.5 51c-7.5 9.3-21 10.2-29.4 3.4l-30.6-26.1-10.4 12.8c-16.7 20.5-47 23.7-66.6 7.9L142 320.1H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h121.2l81.5 78c29.8 24.1 71.8 23.4 101-.2l7.2 6.2c9.6 7.8 21.3 11.9 33.5 11.9 16 0 31.1-7 41.4-19.6l21.9-26.9c16.4 8.9 42.9 9 60-12l9.5-11.7c6.2-7.6 9.6-16.6 10.5-25.7H632c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H486.8c-2.5-3.5-5.3-6.9-8.8-9.8l-121.9-99 28.4-26.1c6.5-6 7-16.1 1-22.6s-16.1-6.9-22.6-1l-75.1 68.8c-14.4 13.1-38.6 12-51.7-2.2-13.5-14.7-12.6-37.9 2.3-51.6z"]
  },
      Mv = {
    prefix: "fal",
    iconName: "handshake-alt-slash",
    icon: [640, 512, [], "e05f", "M385.5,162.59a16.07,16.07,0,0,0-22.59-1l-27.47,25.17,25.5,20.08L384.5,185.2A16,16,0,0,0,385.5,162.59ZM368.91,408.2a21.14,21.14,0,0,1-29.41,3.39L308.91,385.5,298.5,398.3c-16.7,20.5-47,23.7-66.59,7.9L142,320.09H8a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H129.2l81.5,78a80.23,80.23,0,0,0,101-.18l7.21,6.18a53.33,53.33,0,0,0,74.89-7.68l16.29-20-25.2-19.84ZM632,320.09H504.76l40.63,32H632a8,8,0,0,0,8-8v-16A8,8,0,0,0,632,320.09ZM8,160H94.65L54,128H8a8,8,0,0,0-8,8v16A8,8,0,0,0,8,160Zm624-31.91H518.5L467.3,78.2a47.55,47.55,0,0,0-33.89-14.11h-101c-10.41,0-20.11,3.91-28.32,10A48.06,48.06,0,0,0,274.8,63.8H205.3a47.57,47.57,0,0,0-20.13,4.63l35,27.57H274.7c.89,2.2.3.7,1.1,2.91l-24,22L277.27,141l44.23-40.55a16,16,0,0,1,10.8-4.21h101a16,16,0,0,1,11.4,4.8l60.71,59.09H632a8,8,0,0,0,8-8v-16A8,8,0,0,0,632,128.09ZM23,1.8A7.88,7.88,0,0,0,11.77,3l-10,12.5A7.94,7.94,0,0,0,3,26.71L617,510.23A8,8,0,0,0,628.2,509l10-12.5a7.86,7.86,0,0,0-1.21-11.2Z"]
  },
      pv = {
    prefix: "fal",
    iconName: "handshake-slash",
    icon: [640, 512, [], "e060", "M16,319.89a16,16,0,1,0-16-16A16.05,16.05,0,0,0,16,319.89Zm369.44-157.2a16.07,16.07,0,0,0-22.59-1l-27.36,25.07L361,206.85l23.45-21.55A16,16,0,0,0,385.44,162.69ZM368.85,408.3a21.15,21.15,0,0,1-29.4,3.39l-30.59-26.1-10.4,12.8c-16.7,20.5-47,23.7-66.59,7.91L142,320.19H96V161L54.22,128.09H8a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H64V352H8a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H64a31.89,31.89,0,0,0,31.9-31.7h33.18l81.49,78a80.23,80.23,0,0,0,101-.21l7.2,6.21a53.36,53.36,0,0,0,74.9-7.71l16.45-20.22-25.18-19.82ZM623.91,288a16,16,0,1,0,16,16A16,16,0,0,0,623.91,288ZM640,136.09a8.09,8.09,0,0,0-8.09-8l-113.49.21L467.23,78.39A47.58,47.58,0,0,0,433.34,64.3h-101c-10.41,0-20.11,3.89-28.31,10A48.09,48.09,0,0,0,274.76,64H205.27a47.62,47.62,0,0,0-19.92,4.52L220.24,96h54.42c.89,2.19.3.69,1.1,2.89l-23.93,22,25.39,20,44.14-40.48a16.06,16.06,0,0,1,10.79-4.2h101A15.9,15.9,0,0,1,444.53,101l60.69,59.09h38.7v160.1h-39l81,63.81H632a8,8,0,0,0,8-8V360a8,8,0,0,0-8-8H576V160.3l56-.21a8,8,0,0,0,8-8ZM23.07,1.8A7.87,7.87,0,0,0,11.87,3l-10,12.5a7.93,7.93,0,0,0,1.2,11.2L617,510.23A7.94,7.94,0,0,0,628.2,509l10-12.5a7.86,7.86,0,0,0-1.21-11.2Z"]
  },
      zv = {
    prefix: "fal",
    iconName: "hanukiah",
    icon: [624, 512, [], "f6e6", "M232 128c13.25 0 24-11.94 24-26.67S232 48 232 48s-24 38.61-24 53.33S218.75 128 232 128zm160 0c13.25 0 24-11.94 24-26.67S392 48 392 48s-24 38.61-24 53.33S378.75 128 392 128zm-8 32c-4.42 0-8 3.58-8 8v136h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v136h32V168c0-4.42-3.58-8-8-8h-16zm8-32c13.25 0 24-11.94 24-26.67S456 48 456 48s-24 38.61-24 53.33S442.75 128 456 128zm64 0c13.25 0 24-11.94 24-26.67S520 48 520 48s-24 38.61-24 53.33S506.75 128 520 128zm-8 32c-4.42 0-8 3.58-8 8v136h32V168c0-4.42-3.58-8-8-8h-16zM312 80c13.25 0 24-11.94 24-26.67S312 0 312 0s-24 38.61-24 53.33S298.75 80 312 80zm-88 80c-4.42 0-8 3.58-8 8v136h32V168c0-4.42-3.58-8-8-8h-16zm384 0h-16c-4.42 0-8 3.58-8 8v136c0 26.51-21.49 48-48 48H328V120c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v232H88c-26.51 0-48-21.49-48-48V168c0-4.42-3.58-8-8-8H16c-4.42 0-8 3.58-8 8v136c0 44.18 35.82 80 80 80h208v96H96c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h432c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H328v-96h208c44.18 0 80-35.82 80-80V168c0-4.42-3.58-8-8-8zM48 101.33C48 86.61 24 48 24 48S0 86.61 0 101.33 10.75 128 24 128s24-11.94 24-26.67zM600 48s-24 38.61-24 53.33S586.75 128 600 128s24-11.94 24-26.67S600 48 600 48zM96 160c-4.42 0-8 3.58-8 8v136h32V168c0-4.42-3.58-8-8-8H96zm8-32c13.25 0 24-11.94 24-26.67S104 48 104 48s-24 38.61-24 53.33S90.75 128 104 128zm64 0c13.25 0 24-11.94 24-26.67S168 48 168 48s-24 38.61-24 53.33S154.75 128 168 128zm-8 32c-4.42 0-8 3.58-8 8v136h32V168c0-4.42-3.58-8-8-8h-16z"]
  },
      Cv = {
    prefix: "fal",
    iconName: "hard-hat",
    icon: [512, 512, [], "f807", "M480 352v-32c0-101.34-67.66-186.11-160-213.75V96a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32v10.25C99.66 133.89 32 218.66 32 320v32a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32zM64 320c0-78.76 48.24-145.4 116.28-174.88l26 104.07A9 9 0 0 0 224 247V96h64v151a9 9 0 0 0 17.7 2.18l26-104.07C399.76 174.6 448 241.24 448 320v32H64zm416 96H32v-32h448z"]
  },
      Lv = {
    prefix: "fal",
    iconName: "hashtag",
    icon: [448, 512, [], "f292", "M446.381 182.109l1.429-8c1.313-7.355-4.342-14.109-11.813-14.109h-98.601l20.338-113.891C359.047 38.754 353.392 32 345.92 32h-8.127a12 12 0 0 0-11.813 9.891L304.89 160H177.396l20.338-113.891C199.047 38.754 193.392 32 185.92 32h-8.127a12 12 0 0 0-11.813 9.891L144.89 160H42.003a12 12 0 0 0-11.813 9.891l-1.429 8C27.448 185.246 33.103 192 40.575 192h98.6l-22.857 128H13.432a12 12 0 0 0-11.813 9.891l-1.429 8C-1.123 345.246 4.532 352 12.003 352h98.601L90.266 465.891C88.953 473.246 94.608 480 102.08 480h8.127a12 12 0 0 0 11.813-9.891L143.11 352h127.494l-20.338 113.891C248.953 473.246 254.608 480 262.08 480h8.127a12 12 0 0 0 11.813-9.891L303.11 352h102.886a12 12 0 0 0 11.813-9.891l1.429-8c1.313-7.355-4.342-14.109-11.813-14.109h-98.601l22.857-128h102.886a12 12 0 0 0 11.814-9.891zM276.318 320H148.825l22.857-128h127.494l-22.858 128z"]
  },
      Av = {
    prefix: "fal",
    iconName: "hat-chef",
    icon: [512, 512, [], "f86b", "M416 32a95.17 95.17 0 0 0-57.73 19.74C334.93 20.5 298 0 256 0s-78.93 20.5-102.27 51.74A95.56 95.56 0 0 0 0 128c0 41.74 64 224 64 224v128a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V352s64-182.26 64-224a96 96 0 0 0-96-96zm0 448H96v-96h320zm0-128h-44.09L384 201.25a8 8 0 0 0-7.33-8.61l-16-1.28h-.65a8 8 0 0 0-8 7.37L339.8 352h-68.46V200a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v152H172.2l-12.27-153.3a8 8 0 0 0-8-7.37h-.65l-16 1.28a8 8 0 0 0-7.33 8.61L140.09 352H96S32 150.7 32 128a64.07 64.07 0 0 1 64-64 63.22 63.22 0 0 1 38.39 13.24l25.68 19.48 19.3-25.83C197.83 46.18 225.77 32 256 32s58.17 14.18 76.63 38.89l19.3 25.83 25.68-19.48A63.22 63.22 0 0 1 416 64a64.07 64.07 0 0 1 64 64c0 22.7-64 224-64 224z"]
  },
      Nv = {
    prefix: "fal",
    iconName: "hat-cowboy",
    icon: [640, 512, [], "f8c0", "M626.38 258.52a26.15 26.15 0 0 0-10.93-2.36 25.84 25.84 0 0 0-20.38 9.61c-.37.48-23.28 30.85-85.94 55.42C498.86 250.73 465.52 64 400.33 64c-15.56 0-29.44 7.41-41.11 17.45a59.08 59.08 0 0 1-78.43 0C269.12 71.41 255.24 64 239.68 64c-65.31 0-98.58 187-108.78 257.18-62.08-24.34-85.16-54.38-86-55.38a25.39 25.39 0 0 0-20.3-9.8 26.35 26.35 0 0 0-10.78 2.29C2.73 263.22-2.62 274.85 1.26 285.5 2 287.44 75.36 480 320 480s318-192.56 318.75-194.5c3.85-10.56-1.47-21.98-12.37-26.98zM239.68 96c5.95 0 12.76 3.27 20.25 9.71a91.05 91.05 0 0 0 120.15 0c7.49-6.44 14.3-9.71 20.25-9.71 13.92 0 43.34 53.8 65.29 160.79-38 10-85.38 17.15-145.61 17.15s-107.58-7.19-145.62-17.17C196.34 149.79 225.76 96 239.68 96zm-71.24 192.45c40.25 10.29 89.68 17.49 151.57 17.49 61.62 0 111.26-7.15 151.57-17.43 2.39 13.77 4.7 28 6.78 43.28C438.49 343.47 386.64 352 320 352s-118.48-8.55-158.36-20.24c2.1-15.25 4.36-29.54 6.8-43.31zM320 448c-150.92 0-229.54-78.79-264.78-130.23C96.68 347 177.31 384 320 384s223.72-37.53 264.91-66.48C549.66 369.09 471 448 320 448z"]
  },
      gv = {
    prefix: "fal",
    iconName: "hat-cowboy-side",
    icon: [640, 512, [], "f8c1", "M638.22 392.71c-19.22-89.6-78.13-152.45-150.7-165.52l-19.12-110a64 64 0 0 0-63-53.2c-9.36 0 3.23-2.11-204.55 42a64 64 0 0 0-50.35 55.78l-7.19 67.15C75 245.51 20.17 306.91 1.76 392.74c-4.41 20.76-.44 42.45 10.9 59.49C24.44 469.88 42.38 480 61.88 480h516.25c19.47 0 37.41-10.12 49.19-27.75 11.37-17.04 15.34-38.75 10.9-59.54zM182.31 165.17a31.92 31.92 0 0 1 25.17-27.89l191.19-40.55c19.37-4.1 35.36 9.43 38.2 26L465.62 288H316.29l-29.5-25.42c-49-39.23-95.31-38.59-110.83-38.14zM61.88 448c-20.64 0-33.66-25.81-28.88-48.55C51.45 313.65 110.66 256 180.38 256c30.76 0 60.63 10.91 85.52 30.82C445.63 441.68 429.43 431.65 453.76 448zm323.38-100.57L353.43 320h117.75l19.53 112.31c-32.94-15.81-57.71-43.76-105.45-84.88zM578.13 448c-5.41 0-29.46.33-53-4.38l-31.7-182.3c54.43 15.26 98.13 66.69 113.45 138.1 5.69 26.35-11 48.58-28.75 48.58z"]
  },
      Hv = {
    prefix: "fal",
    iconName: "hat-santa",
    icon: [640, 512, [], "f7a7", "M627.2 189.5c-.9-12.3-6.1-24.2-15.3-33.4-9-9-20.7-14.4-33.3-15.3-9.3-8.1-21.5-12.8-34.5-12.8s-25.2 4.7-34.5 12.8c-4.3.3-8.3 1.8-12.3 3.2C419.7 65.6 379.9 32 305.2 32c-68.6 0-130.4 41.2-156.8 104.5L58.7 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48h-11.4l-61-142.2c-2.4-5.5 1.9-11.2 7.3-11.2 1 0 2 .2 3 .6l47.1 18.9c-.2 2-1.1 3.9-1.1 6 0 13.1 4.7 25.1 12.8 34.5.9 12.3 6.1 24.2 15.3 33.4 9.1 9.1 20.9 14.5 33.6 15.5 9.3 8 21.3 12.7 34.3 12.7s25-4.7 34.3-12.7c12.7-1 24.5-6.4 33.6-15.5 9.2-9.2 14.4-21.1 15.3-33.4 8.1-9.3 12.8-21.4 12.8-34.5s-4.6-25.2-12.7-34.6zM480 400v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16zm-81.1-233.4c-13.5 0-25.9 6.7-33.4 18-7.4 11.2-8.7 25.3-3.3 37.7L417.8 352H93.3L178 148.8C199.5 97.3 249.4 64 305.2 64c61.3 0 93.9 26.6 165.9 99.3-5.4 7.6-9.2 16-10.1 25.1l-47.3-18.9c-4.7-2-9.7-2.9-14.8-2.9zm193.7 77.5c4.4 8.1 3.5 18.3-3.4 25.1-4.2 4.2-9.6 6.2-15.1 6.2-3.5 0-6.9-1.2-10-2.9-2.6 8.8-10.5 15.4-20.1 15.4s-17.5-6.6-20.1-15.4c-3.2 1.7-6.5 2.9-10 2.9-5.5 0-10.9-2.1-15.1-6.2-6.8-6.8-7.7-17-3.4-25.1-8.8-2.6-15.4-10.5-15.4-20.1s6.6-17.5 15.4-20.1c-4.4-8.1-3.5-18.3 3.4-25.1 4.1-4.1 9.3-6 14.6-6 3.6 0 7.2.9 10.5 2.7 2.6-8.8 10.5-15.4 20.1-15.4s17.5 6.6 20.1 15.4c3.3-1.8 6.9-2.7 10.5-2.7 5.3 0 10.6 2 14.6 6 6.8 6.8 7.8 17 3.4 25.1 8.8 2.6 15.4 10.5 15.4 20.1s-6.6 17.5-15.4 20.1z"]
  },
      Vv = {
    prefix: "fal",
    iconName: "hat-winter",
    icon: [512, 512, [], "f7a8", "M489.9 386c-11.8-73.4-47.4-193.5-154.1-257.4v-.7c10-7.8 16.2-19.8 16.2-33.1s-6.1-25.2-16.2-33.1c1.6-12.7-2.6-25.5-12-34.8-9.4-9.3-22.2-13.4-34.8-11.9-15.6-20-50.4-20-66.1.1-12.6-1.4-25.4 2.6-34.8 11.9-9.4 9.4-13.5 22.2-12 34.8-10 7.8-16.2 19.8-16.2 33.1s6.1 25.2 16.2 33.1v.7C69.5 192.5 33.9 312.6 22.1 386 9.3 390.2 0 401.8 0 416v64c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-64c0-14.2-9.3-25.8-22.1-30zm-33.1-2H55.2c2.6-14.4 6-30.1 10.8-47.1l62-31 64 32 64-32 64 32 64-32 62 31c4.8 17 8.3 32.7 10.8 47.1zm-257-298.9l19-5.6-9.4-17.4c-1.8-3.3-2.5-8.5 1.4-12.4 3.9-4 9.2-3.2 12.5-1.5l17.4 9.4 5.6-19c1.2-3.9 4.6-7.8 9.8-7.8s8.7 3.9 9.8 7.8l5.6 19 17.4-9.4c3.3-1.8 8.5-2.5 12.5 1.5 3.9 3.9 3.2 9.1 1.4 12.4l-9.4 17.4 19 5.6c3.9 1.1 7.8 4.6 7.8 9.8s-3.9 8.7-7.8 9.8l-19 5.6 9.4 17.4c1.8 3.3 2.5 8.5-1.4 12.4-2.9 2.9-5.6 5.2-12.5 1.5l-17.4-9.5-5.6 19c-1.2 3.9-4.6 7.8-9.8 7.8s-8.7-3.9-9.8-7.8l-5.6-19-17.4 9.5c-6.9 3.8-9.6 1.4-12.5-1.5-3.9-3.9-3.2-9.1-1.4-12.4l9.4-17.4-19-5.6c-3.9-1.1-7.8-4.6-7.8-9.8s3.9-8.7 7.8-9.8zm-13.3 75.6c.6.7 1 1.5 1.7 2.1 9.2 9.2 22 13.7 35 12.2 7.8 9.9 19.7 15.9 32.9 15.9s25.1-6 32.9-15.9c13 1.6 25.8-3 35-12.2.7-.7 1.1-1.4 1.7-2.1 52.4 33.8 85.1 83.6 105.2 132.8L384 270.1l-64 32-64-32-64 32-64-32-46.7 23.4c20.1-49.2 52.7-99 105.2-132.8zM480 480H32v-64h448v64z"]
  },
      xv = {
    prefix: "fal",
    iconName: "hat-witch",
    icon: [576, 512, [], "f6e7", "M573.99 439.89l-10.49-12.03c-2.83-3.25-7.65-3.55-10.97-.8-15.37 12.7-32.56 22.48-50.42 30.75L393.59 214.36a64.009 64.009 0 0 1-1.89-45.45l6.35-19.04C402.4 136.81 414.62 128 428.4 128h39.2c13.77 0 26 8.81 30.36 21.88L512 192l30.36-77.24c3.83-11.5.84-24.18-7.73-32.75L465.28 9.37A31.974 31.974 0 0 0 442.64 0c-5.43 0-10.9 1.38-15.87 4.22L260.43 107.18a128.004 128.004 0 0 0-53.47 59.15L74.07 457.89c-17.93-8.28-35.18-18.09-50.61-30.84-3.32-2.74-8.14-2.45-10.97.8L2.01 439.89c-2.96 3.39-2.62 8.68.84 11.55C50.01 490.55 109.39 512 170.92 512h234.16c61.53 0 120.9-21.45 168.07-60.56 3.46-2.87 3.8-8.15.84-11.55zM236.21 179.33c8.36-18.81 22.23-34.15 41.07-44.94L442.65 32.01l69.32 72.6-2.68 6.81A63.876 63.876 0 0 0 467.6 96h-39.2a63.913 63.913 0 0 0-60.71 43.76l-6.35 19.04c-7.44 22.33-6.44 46.54 3.02 68.6l82.35 184.73c-13.42 2.34-27.01 3.88-40.83 3.88H352v-4c0-15.44-12.56-28-28-28h-72c-15.44 0-28 12.56-28 28v4h-53.87c-13.56 0-26.91-1.45-40.1-3.71l106.18-232.97zM103.99 469.41l12.52-27.47c17.58 3.59 35.42 6.06 53.61 6.06H224v32h-53.08c-22.96 0-45.34-4.07-66.93-10.59zM256 480v-64h64v64h-64zm96 0v-32h53.87c18.35 0 36.34-2.52 54.07-6.17l12.27 27.52C450.57 475.91 428.1 480 405.07 480H352z"]
  },
      wv = {
    prefix: "fal",
    iconName: "hat-wizard",
    icon: [512, 512, [], "f6e8", "M288 192l-16-32-16 32-32 16 32 16 16 32 16-32 32-16-32-16zm216 288h-24L379.18 247.34a73.068 73.068 0 0 1-2.21-52.44L442.67 0 223.83 123.68c-27.61 15.6-49.46 39.51-62.37 68.25L32 480H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h496c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-436.92 0l31.72-70.6 55.86 27.93L176 480H67.08zM192 440.45l-13.48-26.97L151.55 400l26.96-13.48L192 359.55l13.48 26.96L232.45 400l-26.96 13.48L192 440.45zM208 480l21.33-42.67L304 400l-74.67-37.33L192 288l-37.33 74.67-44.96 22.48 80.94-180.11c10.19-22.67 27.11-41.18 48.93-53.51l146.08-82.55-39 115.7c-8.32 24.69-7.2 51.47 3.17 75.38l23.7 54.7L352 304l-16-32-16 32-32 16 32 16 16 32 16-32 25.26-12.63L445.12 480H208z"]
  },
      yv = {
    prefix: "fal",
    iconName: "hdd",
    icon: [576, 512, [], "f0a0", "M566.819 227.377L462.377 83.768A48.001 48.001 0 0 0 423.557 64H152.443a47.998 47.998 0 0 0-38.819 19.768L9.181 227.377A47.996 47.996 0 0 0 0 255.609V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V255.609a47.996 47.996 0 0 0-9.181-28.232zM139.503 102.589A16.048 16.048 0 0 1 152.443 96h271.115c5.102 0 9.939 2.463 12.94 6.589L524.796 224H51.204l88.299-121.411zM544 272v128c0 8.823-7.178 16-16 16H48c-8.822 0-16-7.177-16-16V272c0-8.837 7.163-16 16-16h480c8.837 0 16 7.163 16 16zm-56 64c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24zm-64 0c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"]
  },
      bv = {
    prefix: "fal",
    iconName: "head-side",
    icon: [512, 512, [], "f6e9", "M509.21 275c-20.94-47.12-48.44-151.73-73.08-186.75C397.68 33.6 334.56 0 266.09 0h-66.08C95.47 0 4.12 80.08.14 184.55-2.13 244.33 23.1 298.14 64 334.82V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V320.54L85.36 311c-35.65-31.97-55.06-77.62-53.25-125.23C35.35 100.98 110.66 32 200.01 32h66.08c57.19 0 110.97 27.91 143.86 74.66 12.52 17.8 29.11 66.74 42.45 106.07 9.73 28.71 18.93 55.83 27.57 75.27H416v96c0 17.64-14.36 32-32 32h-96v88c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h64c35.35 0 64-28.65 64-64v-64h31.96c23.16 0 38.65-23.84 29.25-45zM352 192c0-17.67-14.33-32-32-32s-32 14.33-32 32 14.33 32 32 32 32-14.33 32-32z"]
  },
      Sv = {
    prefix: "fal",
    iconName: "head-side-brain",
    icon: [512, 512, [], "f808", "M509.21 275c-20.94-47.12-48.44-151.73-73.08-186.75A207.94 207.94 0 0 0 266.09 0H200C95.47 0 4.12 80.08.14 184.55A191.3 191.3 0 0 0 64 334.82V504a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V320.54L85.36 311a159.67 159.67 0 0 1-53.25-125.23C35.35 101 110.66 32 200 32h66.08A176.08 176.08 0 0 1 410 106.66c12.52 17.8 29.11 66.74 42.45 106.07 9.73 28.71 18.93 55.83 27.57 75.27H416v96a32 32 0 0 1-32 32h-96v88a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-56h64a64 64 0 0 0 64-64v-64h32a32 32 0 0 0 29.21-45zM313.6 192c21.21 0 38.4-16.48 38.4-36.8s-17.19-36.8-38.4-36.8H311a38.09 38.09 0 0 0-35.8-25.6c-7.1 0-13.38 2.45-19.08 5.81C249.35 87.68 237.8 80 224 80s-25.34 7.68-32.11 18.61c-5.71-3.36-12-5.81-19.09-5.81a38.4 38.4 0 0 0-38.4 38.4A38.4 38.4 0 0 0 96 169.6c0 16.85 11 30.74 26.11 35.92-.06.86-.51 1.6-.51 2.48a38.4 38.4 0 0 0 38.4 38.4 37.91 37.91 0 0 0 12.8-2.58V288H224v-44.18a37.91 37.91 0 0 0 12.8 2.58 38.4 38.4 0 0 0 38.4-38.4 37.84 37.84 0 0 0-3.73-16z"]
  },
      Tv = {
    prefix: "fal",
    iconName: "head-side-cough",
    icon: [640, 512, [], "e061", "M488,360a24,24,0,1,0,24,24A24,24,0,0,0,488,360Zm-10.8-85c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,234.1,0H196.74C92.49,0,3.67,81.11.11,185.29A191.32,191.32,0,0,0,64,334.81V504a8,8,0,0,0,8,8H88a8,8,0,0,0,8-8V320.55l-5.69-5.11C70.46,297.63,54.08,276,44,251.31-1.34,139.68,88.37,32,200,32H234.1A176.07,176.07,0,0,1,378,106.66c12.52,17.79,29.11,66.75,42.46,106.07,9.72,28.71,18.92,55.83,27.56,75.27H384v48H338c-26.28,0-49.2,20.25-50,46.52A48,48,0,0,0,336,432h48v16a32,32,0,0,1-32,32H296a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8h56a64,64,0,0,0,64-64V416a16,16,0,0,0-16-16H336.85c-8,0-15.35-5.45-16.63-13.32A16,16,0,0,1,336,368h64a16,16,0,0,0,16-16V320H448A32,32,0,0,0,477.2,275ZM320,192a32,32,0,1,0-32,32A32,32,0,0,0,320,192ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm0,56a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm0,104a24,24,0,1,0,24,24A24,24,0,0,0,616,464ZM552,320a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm0,96a24,24,0,1,0,24,24A24,24,0,0,0,552,416Z"]
  },
      Dv = {
    prefix: "fal",
    iconName: "head-side-cough-slash",
    icon: [640, 512, [], "e062", "M427,320H448a32,32,0,0,0,29.25-45c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,234.1,0H196.74A198.73,198.73,0,0,0,74.44,42.34L23,1.82A7.87,7.87,0,0,0,11.77,3l-10,12.5A8,8,0,0,0,3,26.73l614,483.5a7.66,7.66,0,0,0,2.84,1l.35-.07c3,.73,6.05.35,8-2.14l10-12.5a7.86,7.86,0,0,0-1.21-11.2ZM301.25,221A31.89,31.89,0,0,0,288,160c-15.63,0-28,11.42-30.83,26.23L101.6,63.73C129.48,44.12,163.34,32,200,32H234.1A176.07,176.07,0,0,1,378,106.66c12.52,17.79,29.11,66.75,42.46,106.07,9.72,28.71,18.92,55.83,27.56,75.27H386.4ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368Zm64-8a24,24,0,1,0,24,24A24,24,0,0,0,616,360ZM44,251.31c-20.94-51.5-12.9-102,12.55-141.63L30.79,89.36A186,186,0,0,0,.11,185.29,191.32,191.32,0,0,0,64,334.81V504a8,8,0,0,0,8,8H88a8,8,0,0,0,8-8V320.55l-5.69-5.11C70.46,297.63,54.08,276,44,251.31ZM400,400H336.85c-8,0-15.35-5.45-16.63-13.32A16,16,0,0,1,336,368h48.64L344,336h-6c-26.28,0-49.2,20.25-50,46.52A48,48,0,0,0,336,432h48v16a32,32,0,0,1-32,32H296a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8h56a64,64,0,0,0,64-64V416A16,16,0,0,0,400,400Z"]
  },
      jv = {
    prefix: "fal",
    iconName: "head-side-headphones",
    icon: [512, 512, [], "f8c2", "M509.21 275c-20.94-47.12-48.44-151.73-73.09-186.75A207.88 207.88 0 0 0 266.09 0H200C95.48 0 4.14 80.08.14 184.55A191.34 191.34 0 0 0 64 334.81V504a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V320.55L85.38 311a159.63 159.63 0 0 1-53.24-125.23C34.65 119.6 81.29 63.56 144 41.92v74.35a112 112 0 1 0 128 0V32.36a175.82 175.82 0 0 1 137.92 74.3c12.53 17.79 29.12 66.75 42.47 106.07 9.72 28.71 18.93 55.83 27.56 75.27H416v96a32 32 0 0 1-32 32h-96v88a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-56h64a64 64 0 0 0 64-64v-64h32a32 32 0 0 0 29.21-45zM176 34.29c7.9-1.11 15.8-2.29 24-2.29h40v69.2c-10.2-3.06-20.8-5.2-32-5.2s-21.8 2.14-32 5.2zM288 208a80 80 0 1 1-80-80 80.08 80.08 0 0 1 80 80zm-80-48a48 48 0 1 0 48 48 48.05 48.05 0 0 0-48-48zm0 64a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"]
  },
      Ev = {
    prefix: "fal",
    iconName: "head-side-mask",
    icon: [512, 512, [], "e063", "M512,288a31.66,31.66,0,0,0-2.77-13c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H197.68C93.48,0,4,80.61.13,184.74-2.08,244.4,23.08,298.13,64,334.88V504a8,8,0,0,0,8,8H88a8,8,0,0,0,8-8l0-183.4-10.61-9.53a159.87,159.87,0,0,1-52.79-133l.68-.31L224,316.51V504a8,8,0,0,0,8,8H401.88a64,64,0,0,0,60.71-43.76l47.77-143.31A32,32,0,0,0,512,314.81Zm-44.38,64H336a16,16,0,0,0,0,32H456.94l-10.67,32H336a16,16,0,0,0,0,32h99.6l-3.38,10.12A32,32,0,0,1,401.88,480H256V320H478.27Zm12.16-64H239.21L40.69,143.61C62.58,79.4,126.15,32,200,32h66.15a176.21,176.21,0,0,1,143.82,74.66c12.48,17.75,29,66.57,42.35,105.8,9.78,28.83,19,56.06,27.49,75.48ZM320,160a32,32,0,1,0,32,32A32.07,32.07,0,0,0,320,160Z"]
  },
      kv = {
    prefix: "fal",
    iconName: "head-side-medical",
    icon: [512, 512, [], "f809", "M336 216v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8zm173.21 59c-20.94-47.12-48.44-151.73-73.08-186.75A207.94 207.94 0 0 0 266.09 0H200C95.47 0 4.12 80.08.14 184.55A191.3 191.3 0 0 0 64 334.82V504a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V320.54L85.36 311a159.67 159.67 0 0 1-53.25-125.23C35.35 101 110.66 32 200 32h66.08A176.08 176.08 0 0 1 410 106.66c12.52 17.8 29.11 66.74 42.45 106.07 9.73 28.71 18.93 55.83 27.57 75.27H416v96a32 32 0 0 1-32 32h-96v88a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-56h64a64 64 0 0 0 64-64v-64h32a32 32 0 0 0 29.21-45z"]
  },
      Iv = {
    prefix: "fal",
    iconName: "head-side-virus",
    icon: [512, 512, [], "e064", "M256,224a16,16,0,1,0,16,16A16,16,0,0,0,256,224Zm253.2,51c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H200C95.47,0,4.13,80.08.14,184.55A191.27,191.27,0,0,0,64,334.81V504a8,8,0,0,0,8,8H88a8,8,0,0,0,8-8V320.55L85.36,311A159.66,159.66,0,0,1,32.11,185.77C35.34,101,110.66,32,200,32h66.07A176.08,176.08,0,0,1,410,106.66c12.52,17.79,29.11,66.75,42.46,106.07,9.72,28.71,18.92,55.83,27.56,75.27H416v96a32,32,0,0,1-32,32H288v88a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192Zm86.63,125.25,8.57,8.58a16,16,0,1,0,22.63-22.62l-8.58-8.58C313.09,274.47,327.37,240,355.88,240H368a16,16,0,0,0,0-32H355.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,0,0-22.63-22.63l-8.57,8.58a31.35,31.35,0,0,1-22.4,9.44c-16.45,0-32.23-12.78-32.23-32.07V96a16,16,0,0,0-32,0v12.12c0,19.29-15.78,32.07-32.23,32.07a31.35,31.35,0,0,1-22.4-9.44l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H112a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.58a31.34,31.34,0,0,1,22.4-9.43c16.45,0,32.23,12.77,32.23,32.06V352a16,16,0,0,0,32,0V339.88c0-19.29,15.78-32.06,32.23-32.06A31.38,31.38,0,0,1,310.63,317.25Zm-66.53-24c-1.47,1.37-2.86,2.81-4.18,4.29a64.18,64.18,0,0,0-48.15-21.7c-1.25,0-2.5,0-3.74.11A64.3,64.3,0,0,0,166.5,224,64.3,64.3,0,0,0,188,172.08c1.24.07,2.49.11,3.74.11A64.2,64.2,0,0,0,240,150.39a64.18,64.18,0,0,0,48.23,21.8c1.25,0,2.5,0,3.73-.11A64.38,64.38,0,0,0,313.49,224,64.38,64.38,0,0,0,292,275.93c-1.23-.08-2.48-.11-3.73-.11A64.46,64.46,0,0,0,244.1,293.23Z"]
  },
      Ov = {
    prefix: "fal",
    iconName: "head-vr",
    icon: [512, 512, [], "f6ea", "M480 64h-96.49C345.04 23.98 291.6 0 234.09 0h-34.08C127.59 0 61.92 38.7 26.82 97.04 11.71 99.61 0 112.16 0 128v64c0 17.67 14.33 32 32 32h184c.72 0 1.18-.59 1.85-.77 18.99 20.1 46.27 32.77 75.58 32.77H480c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM32 192v-64h165.66c-4.1 11.56-6.21 24.05-5.53 37.16.5 9.5 2.89 18.37 6.1 26.84H32zm184.57-95.76c-.22-.02-.35-.24-.57-.24H67.08c30.83-38.58 79.05-64 132.94-64h34.08c36.29 0 70.79 11.79 99.82 32H288c-28.47 0-53.85 12.56-71.43 32.24zM384 224h-96c-35.29 0-64-28.71-64-64s28.71-64 64-64h96v128zm96 0h-64V96h64v128zM46.19 256H11.26c10.86 30.54 29.07 57.59 52.74 78.82V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V320.54L85.37 311c-17.27-15.49-30.15-34.41-39.18-55zM384 288v96c0 17.64-14.36 32-32 32h-64v88c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h32c35.35 0 64-28.65 64-64v-64h31.96c18.45 0 31.79-15.15 31.8-32H384z"]
  },
      Qv = {
    prefix: "fal",
    iconName: "heading",
    icon: [512, 512, [], "f1dc", "M416 64v384h56a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H328a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h56V272H128v176h56a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H40a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h56V64H40a8 8 0 0 1-8-8V40a8 8 0 0 1 8-8h144a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8h-56v176h256V64h-56a8 8 0 0 1-8-8V40a8 8 0 0 1 8-8h144a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8z"]
  },
      Zv = {
    prefix: "fal",
    iconName: "headphones",
    icon: [512, 512, [], "f025", "M256 32C114.517 32 0 146.497 0 288v51.429a16.003 16.003 0 0 0 8.213 13.978l23.804 13.262c-.005.443-.017.886-.017 1.331 0 61.856 50.144 112 112 112h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-49.675 0-91.79 32.343-106.453 77.118L32 330.027V288C32 164.205 132.184 64 256 64c123.796 0 224 100.184 224 224v42.027l-5.547 3.09C459.79 288.343 417.676 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c61.856 0 112-50.144 112-112 0-.445-.012-.888-.017-1.332l23.804-13.262A16.002 16.002 0 0 0 512 339.428V288c0-141.482-114.497-256-256-256zM144 288h16v160h-16c-44.112 0-80-35.888-80-80s35.888-80 80-80zm224 160h-16V288h16c44.112 0 80 35.888 80 80s-35.888 80-80 80z"]
  },
      Uv = {
    prefix: "fal",
    iconName: "headphones-alt",
    icon: [512, 512, [], "f58f", "M384 288h-32c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h32c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zm32 127.88c0 17.68-14.36 32.06-32 32.06h-32V320.06h32c17.64 0 32 14.38 32 32.06v63.76zM160 288h-32c-35.35 0-64 28.71-64 64.12v63.76C64 451.29 92.65 480 128 480h32c17.67 0 32-14.35 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm0 159.94h-32c-17.64 0-32-14.38-32-32.06v-63.76c0-17.68 14.36-32.06 32-32.06h32v127.88zM256 32C114.84 32 0 146.85 0 288v120c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V288C32 164.48 132.5 64 256 64s224 100.48 224 224v120c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V288c0-141.15-114.84-256-256-256z"]
  },
      Bv = {
    prefix: "fal",
    iconName: "headset",
    icon: [512, 512, [], "f590", "M192 224c0-17.67-14.33-32-32-32h-32c-35.35 0-64 28.65-64 64v63.64c0 35.35 28.65 64 64 64h32c17.67 0 32-14.33 32-32V224zm-32 127.64h-32c-17.64 0-32-14.36-32-32V256c0-17.64 14.36-32 32-32h32v127.64zm224 32c35.35 0 64-28.65 64-64V256c0-35.35-28.65-64-64-64h-32c-17.67 0-32 14.33-32 32v127.64c0 17.67 14.33 32 32 32h32zM352 224h32c17.64 0 32 14.36 32 32v63.64c0 17.64-14.36 32-32 32h-32V224zM256 0C113.97 0 3.92 117.82.1 256L0 280c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8l.09-24C35.43 135.19 131.63 32 256 32c123.5 0 224 100.48 224 224v176c0 26.47-21.53 48-48 48h-82.94c1.79-5.03 2.94-10.36 2.94-16 0-26.51-21.49-48-48-48h-64c-26.51 0-48 21.49-48 48s21.49 48 48 48h192c44.12 0 80-35.89 80-80V256C512 114.85 397.16 0 256 0zm48 480h-64c-8.82 0-16-7.18-16-16s7.18-16 16-16h64c8.82 0 16 7.18 16 16s-7.18 16-16 16z"]
  },
      Rv = {
    prefix: "fal",
    iconName: "heart",
    icon: [512, 512, [], "f004", "M462.3 62.7c-54.5-46.4-136-38.7-186.6 13.5L256 96.6l-19.7-20.3C195.5 34.1 113.2 8.7 49.7 62.7c-62.8 53.6-66.1 149.8-9.9 207.8l193.5 199.8c6.2 6.4 14.4 9.7 22.6 9.7 8.2 0 16.4-3.2 22.6-9.7L472 270.5c56.4-58 53.1-154.2-9.7-207.8zm-13.1 185.6L256.4 448.1 62.8 248.3c-38.4-39.6-46.4-115.1 7.7-161.2 54.8-46.8 119.2-12.9 142.8 11.5l42.7 44.1 42.7-44.1c23.2-24 88.2-58 142.8-11.5 54 46 46.1 121.5 7.7 161.2z"]
  },
      Yv = {
    prefix: "fal",
    iconName: "heart-broken",
    icon: [512, 512, [], "f7a9", "M473.7 73.9c-39.6-41.2-83.8-41.7-95.5-41.7-28.7 0-57.5 9.4-81.3 28.2-5.2 4.1-7 11.4-4.9 17.6l25 75.4-85.8 57.2c-6.2 4.1-8.7 12-6.1 18.9l22.1 58.8-78-78 79.7-53.2c6-4 8.6-11.5 6.3-18.3l-17.4-52.5c-1.7-5-4.6-9.8-8.4-13.4-43.9-41.6-80.9-41.1-95-41.1-12 0-54.1 0-96.1 41.9C-10.4 123.7-12.5 203 31 256l212.1 218.5c3.5 3.6 8.2 5.5 12.8 5.5 4.7 0 9.3-1.8 12.8-5.5L481 256c43.5-53 41.4-132.3-7.3-182.1zM457 234.8l-201 207-201-207C22.3 194 25 133.4 61 96.6 81.1 76.4 103.8 64 134.4 64c27.3 0 51.6 10.3 72.8 32l13.7 41.5-85.8 57.2c-8.4 5.6-9.6 17.5-2.4 24.6l130.9 130.9c15.2 15.2 40.4-1 32.9-21.2l-37-98.8 85.4-57c6-4 8.6-11.5 6.3-18.4L326 79c15.6-9.7 33.6-14.8 52.2-14.8 26.7 0 51.3 9.9 72.6 32.1 36.3 37.1 38.9 97.7 6.2 138.5z"]
  },
      Pv = {
    prefix: "fal",
    iconName: "heart-circle",
    icon: [496, 512, [], "f4c7", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm116-318.4c-41.9-36.3-89.5-8.4-104.9 7.7L248 172.9l-11.1-11.6c-26.6-27.9-72.5-35.9-104.9-7.7-35.3 30.6-37.2 85.6-5.6 118.7l108.9 114.1c7 7.4 18.4 7.4 25.5 0l108.9-114.1c31.5-33.2 29.7-88.1-5.7-118.7zm-17 96.5l-99 103.8-99-103.8c-16.7-17.5-20.4-51.6 3.4-72.1 22.2-19.3 50-6.8 61.9 5.7L248 219l33.7-35.3c8.7-9.2 37.5-26.8 61.9-5.7 23.8 20.5 20.1 54.5 3.4 72.1z"]
  },
      Fv = {
    prefix: "fal",
    iconName: "heart-rate",
    icon: [640, 512, [], "f5f8", "M480 224c-6.53 0-12.44 3.98-14.84 10.06l-45.62 114.05-84-335.98C333.72 4.86 327.69.17 319.62 0c-7.5.19-13.84 5.53-15.31 12.86l-82.06 410.23-46.72-186.97A16.005 16.005 0 0 0 160 224H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h139.5l60.97 243.88c1.78 7.14 8.22 12.12 15.53 12.12h.38c7.5-.19 13.84-5.53 15.31-12.86l82.06-410.23 78.72 314.97c1.69 6.73 7.53 11.62 14.44 12.09 7.62.28 13.38-3.59 15.94-10.03l60-149.94H632c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H480z"]
  },
      Wv = {
    prefix: "fal",
    iconName: "heart-square",
    icon: [448, 512, [], "f4c8", "M340 145.6c-14.4-12.5-30.6-17.6-46.4-17.6-22.8 0-44.6 10.7-58.6 25.3l-11 11.6-11.1-11.6C199.2 139 177.3 128 154.2 128c-15.7 0-31.8 5.1-46.3 17.6-35.3 30.6-37.2 85.6-5.6 118.7l108.9 114.1c7 7.4 18.4 7.4 25.5 0l108.9-114.1c31.6-33.2 29.8-88.1-5.6-118.7zm-17 96.5l-99 103.8-99-103.8c-16.7-17.5-20.4-51.6 3.4-72.1 8.2-7.1 17.3-9.9 26.3-9.9 13.9 0 27.3 6.9 35.6 15.6L224 211l33.7-35.3c8.2-8.6 21.7-15.5 35.6-15.5 8.9 0 18.1 2.8 26.2 9.9 23.9 20.4 20.2 54.4 3.5 72zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352z"]
  },
      Gv = {
    prefix: "fal",
    iconName: "heartbeat",
    icon: [512, 512, [], "f21e", "M468.7 76.5C423.6 32.2 375 32 362.3 32c-12.7 0-61.5.2-106.3 44.4C211.3 32.3 162.5 32 149.7 32c-12.7 0-61.4.2-106.4 44.5C15.4 104 0 140.7 0 179.9 0 214.1 12.3 246 33.8 272h120.8l29.9-71.8 56.9 126.4c5.5 12.3 22.9 12.7 28.9.6l49.7-99.4 22.1 44.2h136c21.5-26 33.8-57.9 33.8-92.1.1-39.2-15.3-75.9-43.2-103.4zM462.5 240H361.9l-27.6-55.2c-5.9-11.8-22.7-11.8-28.6 0l-48.9 97.9-58.2-129.3c-5.8-12.8-24-12.5-29.4.4L133.3 240H49.5c-9.2-14.6-42.6-82.7 18.3-142.7C90.4 75.1 120 64 149.7 64c33.9 0 54.5 6.3 106.3 57.3C311 67.1 330.5 64 362.3 64c29.7 0 59.3 11.1 81.8 33.3 61 60.1 27.5 128.2 18.4 142.7zM268.7 443.4c-6.2 6.1-16.2 6.1-22.4 0L108.9 304H64l159.9 162.2c18.7 18.5 48.6 18.4 67.3 0L448 304h-44.5L268.7 443.4z"]
  },
      qv = {
    prefix: "fal",
    iconName: "heat",
    icon: [448, 512, [], "e00c", "M192,153.59V48a16,16,0,0,0-32,0V152.25A202.63,202.63,0,0,0,210.26,286C238.49,318.19,256,358.38,256,401.23V464a16,16,0,0,0,32,0V402.41a202.44,202.44,0,0,0-50.27-133.7C209.51,236.53,192,196.39,192,153.59ZM64,132.4V112a16,16,0,0,0-32,0v16A257.68,257.68,0,0,0,82.29,280.39C110.65,318.68,128,364,128,411.6V464a16,16,0,0,0,32,0V416a257.68,257.68,0,0,0-50.29-152.39C81.35,225.32,64,180,64,132.4ZM365.71,263.61C337.35,225.32,320,180,320,132.4V112a16,16,0,0,0-32,0v16a257.68,257.68,0,0,0,50.29,152.39C366.65,318.68,384,364,384,411.6V464a16,16,0,0,0,32,0V416A257.68,257.68,0,0,0,365.71,263.61Z"]
  },
      Jv = {
    prefix: "fal",
    iconName: "helicopter",
    icon: [640, 512, [], "f533", "M304 416h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h184c4.42 0 8-3.58 8-8V40c0-4.42-3.58-8-8-8H136c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h216v96H128l-43.2-57.6C81.78 98.37 77.03 96 72 96H16.01C5.6 96-2.04 105.78.49 115.88L32 224l160 64 86.4 115.2A31.992 31.992 0 0 0 304 416zm112-221.11C506.66 210.2 576 289.05 576 384H416V194.89zm-203.78 66.73l-8.33-3.33-145.54-58.21L37.33 128H64l38.4 51.2L112 192h272v192h-80l-86.4-115.2-5.38-7.18zm425.44 208.03l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-7.6 7.6c-9 9-21.2 14.05-33.93 14.05H232c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h341.48c21.22 0 41.58-8.43 56.58-23.44l7.59-7.59c3.13-3.12 3.13-8.18.01-11.31z"]
  },
      Kv = {
    prefix: "fal",
    iconName: "helmet-battle",
    icon: [512, 512, [], "f6eb", "M510.28 223.37L429.41 4.53C428.26 1.42 425.63 0 423 0c-3.5 0-7.01 2.52-7.01 6.93v106.39C361.41 35.29 255.99 0 255.99 0S150.6 35.28 96.01 113.3V6.93C96.01 2.52 92.51 0 89 0c-2.63 0-5.27 1.42-6.42 4.53L1.72 223.37c-3.86 15.05-1.16 30.91 7.41 43.51C18.12 280.11 32.66 288 48.02 288c3.29 0 6.48-.42 9.57-1.11-7.39 45.62-19.22 81.5-24.72 104.64-3.43 14.43 3.59 29.37 16.32 35.24L239.99 512V256l-80-16v-16h191.99v16l-80 16v256l190.81-85.23c12.73-5.87 19.75-20.81 16.32-35.24-5.5-23.14-17.33-59.02-24.72-104.64 3.1.69 6.29 1.11 9.59 1.11 15.36 0 29.9-7.89 38.89-21.12 8.57-12.6 11.27-28.46 7.41-43.51zM64.01 236.89c0 10.36-7.33 19.11-16 19.11-4.75 0-9.4-2.66-12.42-7.11-3.18-4.67-4.3-10.55-3.16-16.31l31.58-85.47v89.78zm239.98 225.77V282.23l80-16V192H128v74.23l80 16v180.43L64.13 398.4c1.51-6.3 3.52-13.55 5.76-21.7C80.28 338.95 96 281.89 96 210.82 96 106.62 219.41 49 256.04 34.2c36.68 14.71 159.95 71.96 159.95 176.63 0 71.07 15.71 128.12 26.11 165.88 2.24 8.15 4.25 15.4 5.76 21.7l-143.87 64.25zm172.42-213.77c-3.02 4.45-7.67 7.11-12.42 7.11-8.67 0-16-8.75-16-19.11v-89.77l31.58 85.47c1.14 5.76.01 11.63-3.16 16.3z"]
  },
      Xv = {
    prefix: "fal",
    iconName: "hexagon",
    icon: [576, 512, [], "f312", "M441.5 39.8C432.9 25.1 417.1 16 400 16H176c-17.1 0-32.9 9.1-41.5 23.8l-112 192c-8.7 14.9-8.7 33.4 0 48.4l112 192c8.6 14.7 24.4 23.8 41.5 23.8h224c17.1 0 32.9-9.1 41.5-23.8l112-192c8.7-14.9 8.7-33.4 0-48.4l-112-192zm84.3 224.3l-112 192c-2.9 4.9-8.2 7.9-13.8 7.9H176c-5.7 0-11-3-13.8-7.9l-112-192c-2.9-5-2.9-11.2 0-16.1l112-192c2.8-5 8.1-8 13.8-8h224c5.7 0 11 3 13.8 7.9l112 192c2.9 5 2.9 11.2 0 16.2z"]
  },
      _v = {
    prefix: "fal",
    iconName: "highlighter",
    icon: [544, 512, [], "f591", "M528.61 75.91l-60.49-60.52C457.91 5.16 444.45 0 430.98 0a52.38 52.38 0 0 0-34.75 13.15L110.59 261.8c-10.29 9.08-14.33 23.35-10.33 36.49l12.49 41.02-36.54 36.56c-6.74 6.75-6.74 17.68 0 24.43l.25.26L0 479.98 99.88 512l43.99-44.01.02.02c6.75 6.75 17.69 6.75 24.44 0l36.46-36.47 40.91 12.53c18.01 5.51 31.41-4.54 36.51-10.32l248.65-285.9c18.35-20.82 17.37-52.32-2.25-71.94zM91.05 475.55l-32.21-10.33 40.26-42.03 22.14 22.15-30.19 30.21zm167.16-62.99c-.63.72-1.4.94-2.32.94-.26 0-.54-.02-.83-.05l-40.91-12.53-18.39-5.63-39.65 39.67-46.85-46.88 39.71-39.72-5.6-18.38-12.49-41.02c-.34-1.13.01-2.36.73-3l44.97-39.15 120.74 120.8-39.11 44.95zm248.51-285.73L318.36 343.4l-117.6-117.66L417.4 37.15c4.5-3.97 17.55-9.68 28.1.88l60.48 60.52c7.65 7.65 8.04 20 .74 28.28z"]
  },
      $v = {
    prefix: "fal",
    iconName: "hiking",
    icon: [384, 512, [], "f6ec", "M376 160h-16c-4.42 0-8 3.58-8 8v26.95c-5.03-1.79-10.36-2.95-16-2.95h-30.16l-43.08-55.18-1.22-1.56-1.4-1.4c5.11-3.04 10-6.52 14.39-10.9C288.3 109.2 295.57 91.57 295.57 72s-7.28-37.2-21.04-50.96C260.77 7.28 243.15 0 223.58 0c-19.58 0-37.2 7.28-50.96 21.04S151.58 52.42 151.58 72c0 18.07 6.46 34.33 18.24 47.57l-45.84-13.16c-44.78-10.62-90.62 15.75-102 59.09L.92 247.08c-1.94 7.5-.78 15.28 3.22 21.94 4.09 6.83 10.66 11.61 17.81 13.31l80.26 22.95-36.78 147.08c-6.38 25.73 9.31 51.81 34.97 58.2 3.8.95 7.71 1.43 11.61 1.43 22.09 0 41.25-14.97 46.58-36.4l27.13-108.52 38.28 25.9V464c0 26.47 21.53 48 48 48s48-21.53 48-48v-79.53c0-25.75-12.51-50.08-33.47-65.08L238 287.59l5.02-20.06 1.52 1.95c9.17 11.77 22.97 18.52 37.88 18.52H336c5.64 0 10.97-1.15 16-2.95V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V168c0-4.42-3.58-8-8-8zM195.24 43.67C203.02 35.89 212.47 32 223.58 32s20.56 3.89 28.33 11.67c7.77 7.77 11.67 17.23 11.67 28.33s-3.89 20.56-11.67 28.33c-7.77 7.77-17.23 11.67-28.33 11.67-11.11 0-20.56-3.89-28.33-11.67-7.77-7.77-11.67-17.23-11.67-28.33s3.89-20.56 11.66-28.33zM31.92 255.09l.12-.45.22.53-.34-.08zm.75-2.98l20.28-78.56c6.94-26.61 35.44-42.78 62.9-36.2l28.98 8.32a74.842 74.842 0 0 0-10.06 23.01l-26.28 105.1-75.82-21.67zm94.87 215.77c-1.81 7.28-8.34 12.12-15.53 12.12-1.28 0-2.56-.16-3.87-.48-8.59-2.14-13.78-10.83-11.66-19.39l32.8-131.2 28.23 19.08-29.97 119.87zM336 256h-53.59c-4.94 0-9.59-2.28-12.62-6.17l-41.88-53.81-25.96 103.86c-.17.68-.83 1.01-1.08 1.65l67.04 43.88c12.59 9.02 20.09 23.61 20.09 39.06V464c0 8.84-7.16 16-16 16s-16-7.16-16-16v-79.53c0-5.16-2.5-10.03-6.72-13.03L145.1 301.02a16.002 16.002 0 0 1-6.22-16.89l26.94-107.72a42.682 42.682 0 0 1 41.5-32.41c11.41 0 22.12 4.44 30.22 12.52L290.23 224H336c8.84 0 16 7.16 16 16s-7.16 16-16 16z"]
  },
      cd = {
    prefix: "fal",
    iconName: "hippo",
    icon: [640, 512, [], "f6ed", "M584.11 96.29c-28.85-1.51-54.65 17.18-79.6 26.54C489.98 88.27 455.83 64 416 64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v40.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.63 0 224v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-59.42c24.66 7.19 51.56 11.42 80 11.42s55.34-4.24 80-11.42V448c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V288h96v48c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-48c17.67 0 32-14.33 32-32v-96.42c0-32.17-23.76-61.6-55.89-63.29zM384 448h-64V345.92c-120.03 34.98-142.84 23.65-224 0V448H32V224c0-70.58 71.78-128 160-128 40.32 0 78.98 12.29 108.84 34.62L320 144.93V208c0 38.63 27.52 70.95 64 78.38V448zm192-128h-32v-32h32v32zm32-64H400c-26.47 0-48-21.53-48-48V64h32v32h32c25.83 0 49 15.4 59.02 39.23l11.93 28.36c72.91-27.35 75.75-35.88 95.48-35.35 13.86.73 25.57 15.08 25.57 31.34V256zm-176.19-96c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"]
  },
      ed = {
    prefix: "fal",
    iconName: "history",
    icon: [512, 512, [], "f1da", "M20 24h10c6.627 0 12 5.373 12 12v94.625C85.196 57.047 165.239 7.715 256.793 8.001 393.18 8.428 504.213 120.009 504 256.396 503.786 393.181 392.834 504 256 504c-63.926 0-122.202-24.187-166.178-63.908-5.113-4.618-5.354-12.561-.482-17.433l7.069-7.069c4.503-4.503 11.749-4.714 16.482-.454C150.782 449.238 200.935 470 256 470c117.744 0 214-95.331 214-214 0-117.744-95.331-214-214-214-82.862 0-154.737 47.077-190.289 116H164c6.627 0 12 5.373 12 12v10c0 6.627-5.373 12-12 12H20c-6.627 0-12-5.373-12-12V36c0-6.627 5.373-12 12-12zm321.647 315.235l4.706-6.47c3.898-5.36 2.713-12.865-2.647-16.763L272 263.853V116c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v164.147l84.884 61.734c5.36 3.899 12.865 2.714 16.763-2.646z"]
  },
      ad = {
    prefix: "fal",
    iconName: "hockey-mask",
    icon: [448, 512, [], "f6ee", "M376.61 54.46C335.13 18.15 279.56 0 224 0 168.43 0 112.87 18.15 71.39 54.46 7.36 110.5-31.01 224.44 32.63 416 64.53 512 224 512 224 512s159.47 0 191.37-96c63.64-191.56 25.27-305.5-38.76-361.54zM385 405.91c-20.08 60.43-123.06 73.97-161 74.09-1.36 0-137.06-2.02-161-74.09C-4.54 202.62 52.47 113.54 92.47 78.54 126.25 48.96 174.2 32 224 32s97.74 16.96 131.53 46.54c40 35 97.01 124.08 29.47 327.37zM272 112c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.17 16 16 16zm-96 0c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm16 304c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm0-64c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm0-64c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm-20-112h-72c-19.88 0-36 14.33-36 32 0 35.35 32.23 64 72 64 39.76 0 72-28.65 72-64 0-17.67-16.12-32-36-32zm-36 64c-33.59 0-48.06-32-36-32h72c11.72 0-2.9 32-36 32zm88-112c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm32 288c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm0-64c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm0-64c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm92-112h-72c-19.88 0-36 14.33-36 32 0 35.35 32.24 64 72 64s72-28.65 72-64c0-17.67-16.12-32-36-32zm-36 64c-33.6 0-48.06-32-36-32h72c11.72 0-2.91 32-36 32z"]
  },
      nd = {
    prefix: "fal",
    iconName: "hockey-puck",
    icon: [544, 512, [], "f453", "M272 64C141 64 0 99 0 176v144c0 84 136.8 128 272 128s272-44 272-128V176c0-77-141-112-272-112zm240 256c0 53-107.5 96-240 96S32 373 32 320v-87.7c95.7 74 383.6 74.5 480 0V320zm-240-64c-132.5 0-240-35.8-240-80s107.5-80 240-80 240 35.8 240 80-107.5 80-240 80z"]
  },
      td = {
    prefix: "fal",
    iconName: "hockey-sticks",
    icon: [640, 512, [], "f454", "M624 352H410.6c-3 0-5.8-1.7-7.2-4.4L373.6 288l118-236.2c3.9-7.9.7-17.5-7.2-21.5L427.3 1.7c-7.9-4-17.5-.8-21.5 7.2L320 180.6 234.2 8.8c-3.9-7.9-13.6-11.1-21.5-7.2l-57.3 28.6c-7.9 4-11.1 13.6-7.2 21.5l118 236.2-29.8 59.6c-1.4 2.7-4.1 4.4-7.2 4.4H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h186.3c36.4 0 69.6-20.6 85.9-53.1l31.8-63.6 31.8 63.6c16.3 32.5 49.5 53.1 85.9 53.1H624c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM184.1 51.8l28.6-14.3 89.4 178.9-17.9 35.8L184.1 51.8zM32 480v-96h32v96H32zm227.6-35.4c-10.9 21.8-32.8 35.4-57.2 35.4H96v-96h133.4c15.3 0 29-8.5 35.8-22.1L427.3 37.5l28.6 14.3-196.3 392.8zM437.7 480c-24.4 0-46.3-13.6-57.2-35.4L338 359.5l17.9-35.8 19.1 38.1c6.8 13.6 20.5 22.1 35.8 22.1H544v96H437.7zm170.3 0h-32v-96h32v96z"]
  },
      rd = {
    prefix: "fal",
    iconName: "holly-berry",
    icon: [448, 512, [], "f7aa", "M443.9 343.6c-5-8.7-13.8-14.4-23.7-15.4-14.3-1.5-29-4.5-43.8-8.9-7.4-2.2-11.8-9.8-10-17.4 3.6-15.1 8.4-29.4 14.3-42.6 4.1-9.1 3.5-19.7-1.6-28.3-5-8.6-13.8-14.2-23.5-15.1-14.6-1.4-29.2-4.6-43.7-8.8 19.1-11 32.1-31.5 32.1-55.1 0-34.3-27-62-60.8-63.7 3.1-7.5 4.8-15.7 4.8-24.3 0-35.3-28.7-64-64-64s-64 28.6-64 64c0 8.6 1.8 16.8 4.8 24.3C131 90 104 117.7 104 152c0 23.7 13 44.1 32.1 55.2-14.5 4.2-29.1 7.4-43.7 8.8-9.7.9-18.6 6.6-23.5 15.1-5.1 8.7-5.6 19.2-1.6 28.3 5.9 13.2 10.7 27.5 14.3 42.6 1.8 7.5-2.6 15.2-10 17.4-14.8 4.4-29.6 7.4-43.8 8.9-9.8 1-18.7 6.8-23.7 15.4-4.9 8.6-5.5 19.1-1.4 28 14.5 31.7 22.2 68.1 22.4 105.2.1 12.8 6.6 24.2 17.5 30.4C48.1 510.4 54 512 60 512c6 0 12.1-1.6 17.7-4.8 32.2-18.4 67.4-29.9 101.9-33.1 9.7-.9 18.5-6.6 23.5-15.2 5-8.7 5.6-19.2 1.5-28.3-5.9-13.2-10.7-27.5-14.2-42.6-1.8-7.5 2.6-15.2 10-17.4 7.9-2.4 15.8-4.3 23.6-5.8 7.8 1.5 15.7 3.4 23.6 5.8 7.4 2.2 11.7 9.8 10 17.4-3.6 15.1-8.4 29.4-14.2 42.6-4.1 9.1-3.5 19.6 1.5 28.3 5 8.6 13.8 14.2 23.6 15.2 34.5 3.2 69.8 14.7 101.9 33.1 5.5 3.2 11.6 4.8 17.6 4.8 6 0 12-1.6 17.4-4.7 10.9-6.3 17.4-17.7 17.5-30.4.2-37.1 7.9-73.5 22.4-105.2 4.1-9 3.5-19.5-1.4-28.1zM280 120c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zm-144 32c0-17.6 14.4-32 32-32s32 14.4 32 32-14.4 32-32 32-32-14.4-32-32zm55.2 188.1c-23.6 7.1-37.6 31.4-31.9 55.4 4 17 9.5 33.3 17.3 46.8-39.6 3.7-78.3 16.3-118 37.4-1-.6-1.5-1.5-1.5-2.9C57 434.5 48.5 394.7 31 360c16.3-1.7 33-5.1 49.8-10.1 23.6-7.1 37.6-31.4 31.9-55.4-4-17-9.5-33.3-17.3-46.8 40.6-3.8 81.8-17.5 119.5-39.3-.5 42.9 8 85 24.6 121.8-15.9 1.7-32.1 5-48.3 9.9zM224 96c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm166.9 380.7c0 1.3-.5 2.3-4.6 2.8-36.6-21-75.3-33.5-113.8-35.8 6.7-15 12.2-31.2 16.2-48.3 4.7-19.8-4.1-39.6-20.5-50 4.5-8.4 5-18.5 1.1-27.1-14.2-31.1-21.6-66.6-22.1-103.2 33.6 17.7 69.6 29 104.4 31.1-6.7 15-12.2 31.2-16.2 48.3-5.7 24 8.3 48.3 31.9 55.4 16.8 5 33.5 8.4 48.9 8.4-16.7 36.4-25.2 76.2-25.3 118.4z"]
  },
      id = {
    prefix: "fal",
    iconName: "home",
    icon: [576, 512, [], "f015", "M541 229.16l-61-49.83v-77.4a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v51.33L308.19 39.14a32.16 32.16 0 0 0-40.38 0L35 229.16a8 8 0 0 0-1.16 11.24l10.1 12.41a8 8 0 0 0 11.2 1.19L96 220.62v243a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-128l64 .3V464a16 16 0 0 0 16 16l128-.33a16 16 0 0 0 16-16V220.62L520.86 254a8 8 0 0 0 11.25-1.16l10.1-12.41a8 8 0 0 0-1.21-11.27zm-93.11 218.59h.1l-96 .3V319.88a16.05 16.05 0 0 0-15.95-16l-96-.27a16 16 0 0 0-16.05 16v128.14H128V194.51L288 63.94l160 130.57z"]
  },
      od = {
    prefix: "fal",
    iconName: "home-alt",
    icon: [576, 512, [], "f80a", "M541 229.16l-232.85-190a32.16 32.16 0 0 0-40.38 0L35 229.16a8 8 0 0 0-1.16 11.24l10.1 12.41a8 8 0 0 0 11.2 1.19L96 220.62v243a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-128l64 .3V464a16 16 0 0 0 16 16l128-.33a16 16 0 0 0 16-16V220.62L520.86 254a8 8 0 0 0 11.25-1.16l10.1-12.41a8 8 0 0 0-1.21-11.27zm-93.11 218.59h.1l-96 .3V319.88a16.05 16.05 0 0 0-15.95-16l-96-.27a16 16 0 0 0-16.05 16v128.14H128V194.51L288 63.94l160 130.57z"]
  },
      ld = {
    prefix: "fal",
    iconName: "home-heart",
    icon: [576, 512, [], "f4c9", "M573.5 219.9L512 170.4V72c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v72.6L310.6 8c-13.2-10.7-32.1-10.7-45.2 0L2.5 219.9c-2.9 2.4-3.4 6.6-1 9.5l14.2 17.5c2.4 2.9 6.6 3.4 9.6 1L64 216.7V496c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V216.8l38.8 31.3c2.9 2.4 7.2 1.9 9.6-1l14.2-17.5c2.3-3 1.7-7.3-1.1-9.7zM480 480H96V190.9L283.7 39.5c2.5-2 6-2 8.4 0L480 191v289zM276.9 201.5c-26.6-27.9-72.5-35.9-104.9-7.7-35.3 30.6-37.2 85.6-5.6 118.7l108.9 114.1c7 7.4 18.4 7.4 25.5 0l108.9-114.1c31.6-33.2 29.8-88.1-5.6-118.7-41.9-36.3-89.5-8.4-104.9 7.7L288 213.2l-11.1-11.7zm44.8 22.3c8.7-9.2 37.5-26.8 61.9-5.7 23.8 20.6 20.2 54.5 3.4 72.1L288 394l-99-103.8c-16.7-17.5-20.4-51.6 3.4-72.1 22.2-19.3 50-6.8 61.9 5.7l33.7 35.3 33.7-35.3z"]
  },
      fd = {
    prefix: "fal",
    iconName: "home-lg",
    icon: [576, 512, [], "f80b", "M573.48 219.91L512 170.42V72a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v72.6L310.6 8a35.85 35.85 0 0 0-45.19 0L2.53 219.91a6.71 6.71 0 0 0-1 9.5l14.2 17.5a6.82 6.82 0 0 0 9.6 1L64 216.72V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V216.82l38.8 31.29a6.83 6.83 0 0 0 9.6-1l14.19-17.5a7.14 7.14 0 0 0-1.11-9.7zM336 480h-96V320h96zm144 0H368V304a16 16 0 0 0-16-16H224a16 16 0 0 0-16 16v176H96V190.92l187.71-151.4a6.63 6.63 0 0 1 8.4 0L480 191z"]
  },
      sd = {
    prefix: "fal",
    iconName: "home-lg-alt",
    icon: [576, 512, [], "f80c", "M573.48 219.91L310.6 8a35.85 35.85 0 0 0-45.19 0L2.53 219.91a6.71 6.71 0 0 0-1 9.5l14.2 17.5a6.82 6.82 0 0 0 9.6 1L64 216.72V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V216.82l38.8 31.29a6.83 6.83 0 0 0 9.6-1l14.19-17.5a7.14 7.14 0 0 0-1.11-9.7zM240 480V320h96v160zm240 0H368V304a16 16 0 0 0-16-16H224a16 16 0 0 0-16 16v176H96V190.92l187.71-151.4a6.63 6.63 0 0 1 8.4 0L480 191z"]
  },
      ud = {
    prefix: "fal",
    iconName: "hood-cloak",
    icon: [576, 512, [], "f6ef", "M569.65 460.85C511.98 383.87 511.98 320 511.98 320v-64c0-84.03-46.36-123.05-101.17-182.7l39.75-39.75C462.94 21.17 454.17 0 436.66 0H287.57C191.98 0 64.02 109.45 64.02 256v64s0 63.87-57.67 140.85C-9.42 481.9 6.02 512 32.32 512h511.35c26.31 0 41.75-30.1 25.98-51.15zM191.98 480V320c0-52.94 43.06-96 95.99-96s95.99 43.06 95.99 96v160H191.98zm223.98.01V320c0-70.69-57.3-128-127.99-128s-127.99 57.31-127.99 128v160.02l-128.02.01C95.29 395.5 96.02 323.04 96.02 320v-64c0-129.94 114.42-224 191.55-224h119.28L366.5 72.36s32.84 35.6 38.68 41.82c45.05 47.98 74.81 79.68 74.81 141.81v64c0 3.04.73 75.5 63.69 160l-127.72.02z"]
  },
      hd = {
    prefix: "fal",
    iconName: "horizontal-rule",
    icon: [640, 512, [], "f86c", "M640 247.5v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h624a8 8 0 0 1 8 8z"]
  },
      md = {
    prefix: "fal",
    iconName: "horse",
    icon: [576, 512, [], "f6f0", "M575.95 86.27c-.01-9.62-3.67-15.92-9.14-22.56 5.39-9.45 8.38-20.32 8.38-31.71 0-17.67-14.33-32-32-32H432c-70.58 0-128 57.42-128 128H163.36c-35.98 0-67.27 19.42-84.71 48.13C35.11 176.87 0 212.28 0 256v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56c0-21.5 14.23-39.48 33.71-45.59-.96 5.54-1.71 11.15-1.71 16.96 0 24.2 8.9 47.33 24.53 65.24l-21.97 74.28c-3.12 10.77-3.38 22.03-.8 32.74l21.13 87.86C90.34 501.86 103.2 512 118 512h57.53c20.95 0 36.12-19.75 31.02-39.86l-21.68-85.57 19.29-53.73L288 351.47V480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V323.81c20.5-21.51 32-49.75 32-79.6v-50.52l14.55 21.82c19.11 28.67 49.98 20.67 55.45 18.8l25.52-8.71c19.44-6.63 32.5-24.9 32.49-45.45l-.06-93.88zm-42.78 109.04l-25.52 8.71c-9.33 3.19-16.14-2.76-18.48-6.27L464 160l-48-16v100.21c0 26.67-12.64 50.17-32 65.6V480h-64V325.8l-136.43-30.32-32.12 89.47L175.53 480H118l-21.13-87.86a31.698 31.698 0 0 1 .37-16.18l27.63-93.41C107.45 270.37 96 250.24 96 227.37c0-37.21 30.16-67.37 67.37-67.37H336v-32c0-53.02 42.98-96 96-96h111.19c0 13.29-8.11 24.67-19.63 29.5l20.39 24.78.05 93.88a16 16 0 0 1-10.83 15.15zM480 80c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"]
  },
      vd = {
    prefix: "fal",
    iconName: "horse-head",
    icon: [512, 512, [], "f7ab", "M296 176c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm211.9 123.2C435 142 432.3 124.5 390.4 97.8c10.2-19.9 12.5-43.4 6.1-68.1C391.8 12.2 375.9 0 357.6 0c-13 0-11.9 2.1-81.2 32.3C118.8 101.2 0 139.1 0 380.9V464c0 26.5 21.5 48 48 48h224c30.5 0 54.3-28.6 46.6-59.6l-18.3-73.3c6.5-2.4 12.6-5.4 18.5-8.8l14.7 20.6c11.4 15.8 29.6 25.2 48.9 25.2h30.1c15.6 0 30.3-5.9 41.6-16.7l40.5-35.7c16.7-17 22-42.2 13.3-64.5zM471.8 341l-39.6 34.8c-5.2 5.2-12.4 8.2-19.8 8.2h-30.1c-9 0-17.5-4.3-22.7-11.6L323.7 327c-17.3 17.1-40.6 28.2-66.9 28.2-39.2 0-72.6-23.7-87.4-57.4-2.2-5.1-8.9-6.3-12.9-2.4l-12.1 12.1c-2.4 2.4-3.1 6.2-1.6 9.3 21.1 41.6 64.2 70.3 114 70.3 4.2 0 8.1-.8 12.2-1.2l18.5 74.1c2.6 10.4-5.4 19.9-15.5 19.9H48c-8.8 0-16-7.2-16-16v-83.1c0-249.6 119.5-255.3 323-348.5 17.5-6.3 25.2 51.3-19.4 77.4 37.3 7.2 68.3 33.2 81.3 69.3l61.2 131.8c4 10.5 1.6 22.3-6.3 30.2z"]
  },
      dd = {
    prefix: "fal",
    iconName: "horse-saddle",
    icon: [576, 512, [], "f8c3", "M575.94 86.27c0-9.61-3.66-15.93-9.13-22.57a63.91 63.91 0 0 0 8.38-31.7 32 32 0 0 0-32-32H432a128.14 128.14 0 0 0-128 128H163.37c-36 0-67.28 19.42-84.71 48.12A80 80 0 0 0 0 256v56a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-56a47.82 47.82 0 0 1 33.72-45.59 97.81 97.81 0 0 0-1.72 17 99.36 99.36 0 0 0 24.53 65.23l-22 74.28a64 64 0 0 0-.81 32.73l21.12 87.86A32 32 0 0 0 118 512h57.53a32 32 0 0 0 31-39.86l-21.69-85.58 19.29-53.72L288 351.47V480a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32V323.81a115 115 0 0 0 32-79.61v-50.51l14.56 21.83c19.1 28.67 50 20.67 55.44 18.79l25.53-8.72A47.91 47.91 0 0 0 576 180.16zM224 304.47l-40.44-9L151.44 385l24.09 95H118l-21.13-87.86a33 33 0 0 1 .38-16.14l27.62-93.4A67 67 0 0 1 144 163.17V176a95.83 95.83 0 0 0 80 94.39zM176 176v-16h128v16a64 64 0 0 1-128 0zm368 4.17c0 6.31-4.84 13.1-10.84 15.14l-25.5 8.69c-9.35 3.18-16.16-2.75-18.5-6.27L464 160l-48-16v100.2c0 26.68-12.63 50.18-32 65.61V480h-64V325.8l-64-14.22v-41.19A95.83 95.83 0 0 0 336 176v-48a96 96 0 0 1 96-96h111.19a32 32 0 0 1-19.63 29.5l20.38 24.78.06 93.88zM480 80a16 16 0 1 0 16 16 16 16 0 0 0-16-16z"]
  },
      Md = {
    prefix: "fal",
    iconName: "hospital",
    icon: [448, 512, [], "f0f8", "M180 352h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm88 0h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-128-96h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm128 0h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 256H0v-20c0-6.627 5.373-12 12-12h20V85c0-11.598 10.745-21 24-21h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88c13.255 0 24 9.402 24 21v395h20c6.627 0 12 5.373 12 12v20zM64 480h128v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84h128V96h-80v40c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24V96H64v384zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"]
  },
      pd = {
    prefix: "fal",
    iconName: "hospital-alt",
    icon: [576, 512, [], "f47d", "M468 384h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0-128h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zM308 384h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0-128h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zM148 384h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm0-128h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm182-144h-26V86c0-3.3-2.7-6-6-6h-20c-3.3 0-6 2.7-6 6v26h-26c-3.3 0-6 2.7-6 6v20c0 3.3 2.7 6 6 6h26v26c0 3.3 2.7 6 6 6h20c3.3 0 6-2.7 6-6v-26h26c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6zm198 16H416V48c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v328c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V176c0-8.8 7.2-16 16-16h144V48c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v112h144c8.8 0 16 7.2 16 16v328c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V176c0-26.5-21.5-48-48-48z"]
  },
      zd = {
    prefix: "fal",
    iconName: "hospital-symbol",
    icon: [512, 512, [], "f47e", "M344 144h-16c-4.4 0-8 3.6-8 8v88H192v-88c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v208c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-88h128v88c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 480C132.5 480 32 379.5 32 256S132.5 32 256 32s224 100.5 224 224-100.5 224-224 224z"]
  },
      Cd = {
    prefix: "fal",
    iconName: "hospital-user",
    icon: [640, 512, [], "f80d", "M148 192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm96-96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0-96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm-52-256h26a6 6 0 0 0 6-6v-20a6 6 0 0 0-6-6h-26V70a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm288 192a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm0-160a64 64 0 1 1-64 64 64.07 64.07 0 0 1 64-64zm143.69 221.13C606.44 355.5 577 342 546.79 342 519 342 512 352 480 352s-38.95-10-66.79-10c-30.23 0-59.65 13.48-76.9 39.11A95.5 95.5 0 0 0 320 434.67V472a40 40 0 0 0 40 40h240a40 40 0 0 0 40-40v-37.33a95.5 95.5 0 0 0-16.31-53.54zM608 472a8 8 0 0 1-8 8H360a8 8 0 0 1-8-8v-37.33A63.61 63.61 0 0 1 362.85 399c10.53-15.64 29.35-25 50.36-25 21.8 0 30 10 66.79 10s45-10 66.79-10c21 0 39.83 9.34 50.36 25A63.61 63.61 0 0 1 608 434.67zM320 128v222.31a119.48 119.48 0 0 1 32-25V128a32 32 0 0 0-32-32h-16V32a32 32 0 0 0-32-32H80a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v376a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V128h48V32h192v96z"]
  },
      Ld = {
    prefix: "fal",
    iconName: "hospitals",
    icon: [640, 512, [], "f80e", "M148 192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm96-96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0-96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm-52-256h26a6 6 0 0 0 6-6v-20a6 6 0 0 0-6-6h-26V70a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm276 64h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm96-96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0-96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm-52-256h26a6 6 0 0 0 6-6v-20a6 6 0 0 0-6-6h-26V70a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6zm128-32h-16V32a32 32 0 0 0-32-32H400a32 32 0 0 0-32 32v64h-64V32a32 32 0 0 0-32-32H80a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v376a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V128h48V32h192v96h48v376a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V128h48V32h192v96h48v376a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V128a32 32 0 0 0-32-32z"]
  },
      Ad = {
    prefix: "fal",
    iconName: "hot-tub",
    icon: [512, 512, [], "f593", "M80 144c39.76 0 72-32.24 72-72 0-39.77-32.24-72-72-72S8 32.23 8 72c0 39.76 32.24 72 72 72zm0-112c22.06 0 40 17.94 40 40s-17.94 40-40 40-40-17.94-40-40 17.94-40 40-40zm255.58 184.28c.25 4.29 3.63 7.72 7.93 7.72h15.98c4.54 0 8.34-3.8 8.11-8.34-2.03-40.37-18.75-77.44-45.6-100.42-19.77-16.92-32.18-44.75-33.96-75.52-.25-4.29-3.63-7.71-7.93-7.71h-15.98c-4.54 0-8.34 3.8-8.11 8.34 2.03 40.37 18.75 77.44 45.6 100.42 19.76 16.91 32.17 44.74 33.96 75.51zm96 0c.25 4.29 3.63 7.72 7.93 7.72h15.98c4.54 0 8.34-3.8 8.11-8.34-2.03-40.37-18.75-77.44-45.6-100.42-19.77-16.92-32.18-44.75-33.96-75.52-.25-4.29-3.63-7.71-7.93-7.71h-15.98c-4.54 0-8.34 3.8-8.11 8.34 2.03 40.37 18.75 77.44 45.6 100.42 19.76 16.91 32.17 44.74 33.96 75.51zM104 448h16c4.42 0 8-3.58 8-8V328c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v112c0 4.42 3.58 8 8 8zm96 0h16c4.42 0 8-3.58 8-8V328c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v112c0 4.42 3.58 8 8 8zm96 0h16c4.42 0 8-3.58 8-8V328c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v112c0 4.42 3.58 8 8 8zm96 0h16c4.42 0 8-3.58 8-8V328c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v112c0 4.42 3.58 8 8 8zm88-192H272l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM32 224c0-17.64 14.36-32 32-32h58.67c6.88 0 13.7 2.27 19.2 6.4l76.8 57.6H32v-32zm448 224c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V288h448v160z"]
  },
      Nd = {
    prefix: "fal",
    iconName: "hotdog",
    icon: [512, 512, [], "f80f", "M469.96 179.21l13.62-13.63C501.91 147.27 512 122.91 512 97s-10.09-50.27-28.42-68.59C465.28 10.1 440.92 0 415 0s-50.28 10.1-68.6 28.43l-13.62 13.62-22.15-22.15C297.44 6.69 280.37 0 263.83 0c-14.79 0-29.16 5.35-39.98 16.17L16.17 223.85c-22.94 22.94-21.27 61.8 3.72 86.79l22.15 22.15-13.63 13.63C10.09 364.73 0 389.09 0 415s10.09 50.27 28.42 68.59C46.72 501.9 71.08 512 97 512s50.28-10.1 68.6-28.43l13.62-13.62 22.15 22.15c13.2 13.2 30.26 19.89 46.81 19.89 14.79 0 29.16-5.35 39.98-16.17l207.68-207.68c22.94-22.94 21.27-61.8-3.72-86.79l-22.16-22.14zM38.8 246.47L246.47 38.8c10.91-10.91 29.79-8.02 41.54 3.72l22.15 22.15L64.67 310.16l-22.15-22.15c-12.48-12.48-14.15-31.11-3.72-41.54zm104.16 214.49c-25.36 25.38-66.54 25.4-91.91 0-25.39-25.38-25.39-66.54 0-91.91l318-318c25.36-25.38 66.54-25.4 91.91 0 25.39 25.38 25.39 66.54 0 91.91l-318 318zM473.2 265.53L265.52 473.2c-10.89 10.89-29.77 8.04-41.53-3.72l-22.15-22.15 245.49-245.49 22.15 22.15c12.48 12.48 14.15 31.11 3.72 41.54zM416 96c-12.4 12.41-21.76 14.01-34.71 16.23-14.4 2.47-32.33 5.55-51.92 25.14-19.6 19.6-22.67 37.52-25.14 51.92-2.22 12.95-3.83 22.3-16.23 34.71-12.4 12.4-21.76 14.01-34.71 16.23-14.4 2.47-32.33 5.55-51.92 25.14-19.6 19.6-22.67 37.52-25.14 51.92C174 330.25 172.4 339.6 160 352c-12.4 12.4-21.76 14.01-34.7 16.23-14.4 2.47-32.33 5.54-51.92 25.14-6.25 6.25-6.25 16.38 0 22.63 3.12 3.12 7.22 4.69 11.31 4.69S92.88 419.12 96 416c12.4-12.4 21.76-14.01 34.7-16.23 14.4-2.47 32.33-5.54 51.92-25.14 19.6-19.6 22.67-37.52 25.14-51.92 2.22-12.95 3.83-22.3 16.23-34.71 12.4-12.4 21.76-14.01 34.71-16.23 14.4-2.47 32.33-5.55 51.92-25.14s22.67-37.52 25.14-51.92c2.22-12.95 3.83-22.3 16.23-34.71s21.76-14.01 34.71-16.23c14.4-2.47 32.33-5.55 51.92-25.14 6.25-6.25 6.25-16.38 0-22.63-6.24-6.25-16.37-6.25-22.62 0z"]
  },
      gd = {
    prefix: "fal",
    iconName: "hotel",
    icon: [576, 512, [], "f594", "M396.8 224h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm-128-96h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm128 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm-256 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm128 96h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zM568 32c4.42 0 8-3.58 8-8V8c0-4.42-3.58-8-8-8H8C3.58 0 0 3.58 0 8v16c0 4.42 3.58 8 8 8h23.98v448H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h560c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-24V32h24zM320 480h-64v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80zm192 0H352v-80c0-26.47-21.53-48-48-48h-32c-26.47 0-48 21.53-48 48v80H63.98V32H512v448zM140.8 224h38.4c6.4 0 12.8-6.4 12.8-12.8v-38.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8zm26.31 157.66l16.25 2.26c4.3.6 8.11-2.24 9.07-6.36 9.96-42.83 49.74-74.28 95.58-74.28s85.61 31.45 95.58 74.28c.96 4.12 4.77 6.96 9.07 6.36l16.25-2.26c4.6-.64 7.9-4.92 6.94-9.34C403.22 314.29 349.72 271.5 288 271.5s-115.22 42.79-127.83 100.81c-.96 4.43 2.34 8.71 6.94 9.35z"]
  },
      Hd = {
    prefix: "fal",
    iconName: "hourglass",
    icon: [384, 512, [], "f254", "M368 32h4c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v8c0 6.627 5.373 12 12 12h4c0 91.821 44.108 193.657 129.646 224C59.832 286.441 16 388.477 16 480h-4c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-4c0-91.821-44.108-193.657-129.646-224C324.168 225.559 368 123.523 368 32zM48 32h288c0 110.457-64.471 200-144 200S48 142.457 48 32zm288 448H48c0-110.457 64.471-200 144-200s144 89.543 144 200z"]
  },
      Vd = {
    prefix: "fal",
    iconName: "hourglass-end",
    icon: [384, 512, [], "f253", "M368 32h4c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v8c0 6.627 5.373 12 12 12h4c0 91.821 44.108 193.657 129.646 224C59.832 286.441 16 388.477 16 480h-4c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-4c0-91.821-44.108-193.657-129.646-224C324.168 225.559 368 123.523 368 32zM48 32h288c0 110.457-64.471 200-144 200S48 142.457 48 32zm288 448H48c0-110.457 64.471-200 144-200s144 89.543 144 200zM98.379 416h187.243a12.01 12.01 0 0 1 11.602 8.903 199.464 199.464 0 0 1 2.059 8.43c1.664 7.522-4 14.667-11.704 14.667H96.422c-7.704 0-13.368-7.145-11.704-14.667.62-2.804 1.307-5.616 2.059-8.43A12.01 12.01 0 0 1 98.379 416zm15.962-50.912a141.625 141.625 0 0 1 6.774-8.739c2.301-2.738 5.671-4.348 9.248-4.348h123.276c3.576 0 6.947 1.61 9.248 4.348a142.319 142.319 0 0 1 6.774 8.739c5.657 7.91-.088 18.912-9.813 18.912H124.153c-9.724 0-15.469-11.003-9.812-18.912z"]
  },
      xd = {
    prefix: "fal",
    iconName: "hourglass-half",
    icon: [384, 512, [], "f252", "M368 32h4c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v8c0 6.627 5.373 12 12 12h4c0 91.821 44.108 193.657 129.646 224C59.832 286.441 16 388.477 16 480h-4c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-4c0-91.821-44.108-193.657-129.646-224C324.168 225.559 368 123.523 368 32zM48 32h288c0 110.457-64.471 200-144 200S48 142.457 48 32zm288 448H48c0-110.457 64.471-200 144-200s144 89.543 144 200zm-66.34-333.088a141.625 141.625 0 0 1-6.774 8.739c-2.301 2.738-5.671 4.348-9.248 4.348H130.362c-3.576 0-6.947-1.61-9.248-4.348a142.319 142.319 0 0 1-6.774-8.739c-5.657-7.91.088-18.912 9.813-18.912h135.694c9.725 0 15.469 11.003 9.813 18.912zM98.379 416h187.243a12.01 12.01 0 0 1 11.602 8.903 199.464 199.464 0 0 1 2.059 8.43c1.664 7.522-4 14.667-11.704 14.667H96.422c-7.704 0-13.368-7.145-11.704-14.667.62-2.804 1.307-5.616 2.059-8.43A12.01 12.01 0 0 1 98.379 416z"]
  },
      wd = {
    prefix: "fal",
    iconName: "hourglass-start",
    icon: [384, 512, [], "f251", "M368 32h4c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v8c0 6.627 5.373 12 12 12h4c0 91.821 44.108 193.657 129.646 224C59.832 286.441 16 388.477 16 480h-4c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-4c0-91.821-44.108-193.657-129.646-224C324.168 225.559 368 123.523 368 32zM48 32h288c0 110.457-64.471 200-144 200S48 142.457 48 32zm288 448H48c0-110.457 64.471-200 144-200s144 89.543 144 200zM285.621 96H98.379a12.01 12.01 0 0 1-11.602-8.903 199.464 199.464 0 0 1-2.059-8.43C83.054 71.145 88.718 64 96.422 64h191.157c7.704 0 13.368 7.145 11.704 14.667a199.464 199.464 0 0 1-2.059 8.43A12.013 12.013 0 0 1 285.621 96zm-15.961 50.912a141.625 141.625 0 0 1-6.774 8.739c-2.301 2.738-5.671 4.348-9.248 4.348H130.362c-3.576 0-6.947-1.61-9.248-4.348a142.319 142.319 0 0 1-6.774-8.739c-5.657-7.91.088-18.912 9.813-18.912h135.694c9.725 0 15.469 11.003 9.813 18.912z"]
  },
      yd = {
    prefix: "fal",
    iconName: "house",
    icon: [576, 512, [], "e00d", "M570.53,242,512,190.75V48a16,16,0,0,0-16-16H400a16,16,0,0,0-16,16V78.75L298.53,4a16,16,0,0,0-21.06,0L5.47,242a16,16,0,0,0,21.07,24.09L64,233.27V464a48.05,48.05,0,0,0,48,48H464a48.05,48.05,0,0,0,48-48V233.27l37.46,32.79A16,16,0,0,0,570.53,242ZM480,464a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V205.27l192-168,192,168Zm0-301.25-64-56V64h64ZM208,218.67V325.34A26.75,26.75,0,0,0,234.66,352H341.3A26.76,26.76,0,0,0,368,325.34V218.67A26.75,26.75,0,0,0,341.3,192H234.66A26.74,26.74,0,0,0,208,218.67ZM240,224h96v96H240Z"]
  },
      bd = {
    prefix: "fal",
    iconName: "house-damage",
    icon: [576, 512, [], "f6f1", "M573.51 219.94L512 170.35V72c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v72.55L310.63 8.01c-13.16-10.69-32.06-10.69-45.22 0L2.53 219.94c-2.92 2.36-3.37 6.64-1.01 9.45l14.17 17.55a6.788 6.788 0 0 0 9.56 1.01L64 216.7V496c0 8.84 7.16 16 16 16h149.57l-14.55-32-22.69-49.91 104.11-71.99L236.28 224l148.05 153.86-104.11 71.99L299.59 480l20.55 32H496c8.84 0 16-7.16 16-16V216.78l38.79 31.28c2.93 2.36 7.2 1.91 9.56-1.01l14.17-17.55c2.36-2.92 1.8-7.2-1.01-9.56zM480 480H337.63l-13.76-21.42 78.67-54.4a31.976 31.976 0 0 0 13.64-23.13c.94-9.34-2.28-18.62-8.78-25.38L259.34 201.81c-6.22-6.47-14.61-9.81-23.07-9.81-6.2 0-12.44 1.8-17.9 5.48-12.89 8.71-17.66 25.42-11.29 39.62l49.27 109.82-82.22 56.85c-12.73 8.81-17.34 25.47-10.93 39.56L179.87 480H96V190.9L283.74 39.51a6.635 6.635 0 0 1 8.44 0L480 190.98V480z"]
  },
      Sd = {
    prefix: "fal",
    iconName: "house-day",
    icon: [640, 512, [], "e00e", "M120,176a56,56,0,1,0,56-56A56.09,56.09,0,0,0,120,176Zm80,0a24,24,0,1,1-24-24A24,24,0,0,1,200,176ZM634.53,296,576,244.75V144a16,16,0,0,0-32,0v72.75L410.53,100a16,16,0,0,0-21.06,0l-224,196a16,16,0,0,0,21.06,24.09L224,287.28V464a48.05,48.05,0,0,0,48,48H528a48.06,48.06,0,0,0,48-48V287.28l37.46,32.78A16,16,0,0,0,634.53,296ZM544,464a16,16,0,0,1-16,16H272a16,16,0,0,1-16-16V264a15.43,15.43,0,0,0-.81-4L400,133.27l144,126ZM78.72,272.19l22-66.16L38.41,174.89l62.34-31.22-22-66.08,66.15,22L176,37.3l31.22,62.42,66.06-22.06-22,66.09,25,12.51,26.06-22.75-12-6,16.57-49.61a26.74,26.74,0,0,0-6.6-27.54A26.4,26.4,0,0,0,273,44L223.4,60.56,200,13.73c-9.19-18.31-38.81-18.31-48,0L128.62,60.52,79,44A26.82,26.82,0,0,0,45.06,77.89l16.56,49.59L14.84,150.89a26.83,26.83,0,0,0,0,48l46.78,23.36L45.06,271.92a26.67,26.67,0,0,0,6.6,27.53A26.31,26.31,0,0,0,79,305.81l41.94-14,31.11-27.15-7.27-14.56ZM336,277.33v85.34A21.39,21.39,0,0,0,357.37,384h85.3A21.39,21.39,0,0,0,464,362.67V277.33A21.39,21.39,0,0,0,442.67,256h-85.3A21.39,21.39,0,0,0,336,277.33ZM368,288H432v64H368Z"]
  },
      Td = {
    prefix: "fal",
    iconName: "house-flood",
    icon: [576, 512, [], "f74f", "M252 193c-15.4 0-28 12.6-28 28v72c0 15.4 12.6 28 28 28h72c15.4 0 28-12.6 28-28v-72c0-15.4-12.6-28-28-28h-72zm68 96h-64v-64h64v64zm248.3 160c-29.5-1.5-57.7-11.6-78.2-28.3-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.2-171.8-.1-5.9-4.8-14.3-4.7-20.2.1-20.2 16.6-48.4 26.7-78.2 28.2-4.3.2-7.7 3.6-7.7 7.9v16c0 4.5 3.8 8.3 8.3 8.1 32.3-1.5 63.3-11.4 87.8-27.9 53.8 36.1 139.2 35.8 192 0 53.7 36.1 139.2 35.8 192 0 24.6 16.5 55.6 26.4 87.6 27.9 4.5.2 8.3-3.6 8.3-8.1v-16c0-4.3-3.4-7.7-7.7-7.9zM45.9 252.4c2.1 2.6 5.9 3 8.5.9L96 219.8v165.4c10.9 0 21.6 3.8 30.2 10.7.5.4 1.2.7 1.8 1.1V194L284.1 68.1c2.2-1.8 5.3-1.8 7.5 0l156 125.9v203.3c.6-.4 1.3-.8 1.9-1.2 8.5-7 19.2-10.8 30.2-10.9V219.9l41.6 33.5c2.6 2.1 6.4 1.7 8.5-.9l12.6-15.6c2.1-2.6 1.6-6.4-.9-8.5l-61.8-49.7v-75.9c0-3.3-2.7-6-6-6h-20c-3.3 0-6 2.7-6 6v50.1L307.9 40.1c-11.7-9.5-28.5-9.5-40.2 0L34.2 228.4c-2.6 2.1-3 5.9-.9 8.4l12.6 15.6z"]
  },
      Dd = {
    prefix: "fal",
    iconName: "house-leave",
    icon: [640, 512, [], "e00f", "M112,384a16,16,0,0,1-16-16V168a15.35,15.35,0,0,0-.81-4L240,37.27l108.4,94.85a135.51,135.51,0,0,1,27-18.88L250.53,4a16,16,0,0,0-21.06,0L5.47,200a16,16,0,0,0,21.07,24.1L64,191.28V368a48.05,48.05,0,0,0,48,48H299.31a82.32,82.32,0,0,1,10.91-15.37l15-16.63Zm69.33-224A21.39,21.39,0,0,0,160,181.34v85.33A21.39,21.39,0,0,0,181.33,288h85.3A21.39,21.39,0,0,0,288,266.67V181.34A21.39,21.39,0,0,0,266.63,160ZM256,256H192V192h64Zm369.54-8.7-19.6-21.09-8.71-28.5c-7.88-26.11-23.28-47.8-43.19-62.8A74,74,0,1,0,451.32,116.3c-14.72,3.8-28.4,9.8-45.31,17.41l-8.59,3.8c-24,10.5-43.4,30.09-54.9,55.2l-11.81,28c-7.28,17.2-5.69,35.7,4.22,50.7A52.78,52.78,0,0,0,378.42,295a48.24,48.24,0,0,0,32.91-12.9c.18,1.4.37,2.7.59,4.11L397.7,325.1l-16.28,44.61L334,422.1c-18.69,20.4-18.69,52.4,0,72.9a50,50,0,0,0,74.4,0l46.68-51.2a111.23,111.23,0,0,0,22-36.5l8.72-23.89,10.59,10.69a4,4,0,0,1,.91,1.9l15.59,74.2C518,494.5,539,512,562.82,512a50.1,50.1,0,0,0,12.09-1.5c27.4-6.91,44-34.59,38-62.91L597.31,373.5a114.57,114.57,0,0,0-14.72-36.7,49.59,49.59,0,0,0,5.5.3c20.31,0,38.91-12.6,47.41-32.19S640.18,263.3,625.5,247.3ZM512,32a42,42,0,1,1-42,42A42,42,0,0,1,512,32ZM447,396.3a78,78,0,0,1-15.59,25.9L384.7,473.41a18.19,18.19,0,0,1-13.59,6.18,18.54,18.54,0,0,1-13.59-6.18,22.43,22.43,0,0,1,0-29.71l46.68-51.2a35.57,35.57,0,0,0,7.13-11.79l16.28-44.61.09.11,1,1.2,29,29.3Zm141.08-91.09c-4.4,0-9-1.8-13-6.21L551.6,273.71a50.14,50.14,0,0,1-11-19.41c-11.41-37.5-11.5-39.89-17.5-48.5l-20.91,91.7,43,43.41A78.39,78.39,0,0,1,566,380.21l15.59,74.09c2.41,11.29-4,22.61-14.4,25.2a16.49,16.49,0,0,1-4.37.5c-9.41,0-16.72-7.59-18.63-16.3L528.6,389.5a34.7,34.7,0,0,0-9.5-17.79L456,307.8c-11.59-13.8-15.69-31.2-11.91-47.7l15.82-69.3c-9,3.2-18.1,7.3-35.41,15a36.13,36.13,0,0,0-18.31,18.41L395,250.8c-3.69,8.7-10.1,12.3-16.6,12.3-12.5,0-25.21-13.39-18.21-29.89L371.7,206c8.32-18.2,21.91-31.9,38.63-39.2C444.51,151.71,459,144,486.91,144c36.28,0,68.28,25.29,79.78,63L577,240.91a6.9,6.9,0,0,0,1.59,2.8L602,269C616.09,284.3,602.91,305.21,588.09,305.21Z"]
  },
      jd = {
    prefix: "fal",
    iconName: "house-night",
    icon: [640, 512, [], "e010", "M112,224a111.5,111.5,0,0,0,87-41.45,20.51,20.51,0,0,0-19.75-33.08A59.2,59.2,0,0,1,138.84,39.85a20.3,20.3,0,0,0,10.07-21.27,20.26,20.26,0,0,0-16.47-16.7A136,136,0,0,0,112,0a112,112,0,0,0,0,224ZM97.78,33.27a91.21,91.21,0,0,0,54.47,147.9A80,80,0,1,1,97.78,33.27Zm97.15,35.51,39.72,16.56,16.56,39.72a5.33,5.33,0,0,0,9.55,0l16.56-39.72L317,68.78a5.33,5.33,0,0,0,0-9.54L277.32,42.68,260.76,3a5.33,5.33,0,0,0-9.55,0L234.65,42.68,194.93,59.24a5.34,5.34,0,0,0,0,9.54ZM157,379.24l-39.72-16.57L100.76,323a5.34,5.34,0,0,0-9.55,0L74.65,362.67,34.93,379.24a5.34,5.34,0,0,0,0,9.54l39.72,16.56,16.56,39.72a5.33,5.33,0,0,0,9.55,0l16.56-39.72L157,388.78a5.33,5.33,0,0,0,0-9.54Zm179-101.9v85.33A21.39,21.39,0,0,0,357.36,384h85.31A21.39,21.39,0,0,0,464,362.67V277.34A21.4,21.4,0,0,0,442.67,256H357.36A21.4,21.4,0,0,0,336,277.34ZM368,288H432v64H368Zm266.49,8L576,244.75V144a16,16,0,0,0-32,0v72.75L410.53,100a16,16,0,0,0-21.07,0l-224,196a16,16,0,0,0,21.07,24.09L224,287.28V464a48.05,48.05,0,0,0,48,48H528a48.06,48.06,0,0,0,48-48V287.28l37.46,32.78A16,16,0,0,0,634.53,296ZM544,464a16,16,0,0,1-16,16H272a16,16,0,0,1-16-16V264a15.94,15.94,0,0,0-.81-4L400,133.27l144,126Z"]
  },
      Ed = {
    prefix: "fal",
    iconName: "house-return",
    icon: [640, 512, [], "e011", "M96,368V168a15.35,15.35,0,0,0-.81-4L240,37.27,357.21,139.84c1.34-1.8,2.3-3.87,3.72-5.6a105.83,105.83,0,0,1-18-49.42L250.53,4a16,16,0,0,0-21.06,0L5.47,200a16,16,0,0,0,21.07,24.1L64,191.28V368a48.05,48.05,0,0,0,48,48H321.14l6.74-32H112A16,16,0,0,1,96,368Zm85.33-208A21.39,21.39,0,0,0,160,181.34v85.33A21.39,21.39,0,0,0,181.33,288h85.3A21.39,21.39,0,0,0,288,266.67V181.34A21.39,21.39,0,0,0,266.63,160ZM256,256H192V192h64ZM626,422.1l-47.4-52.39L562.3,325.1l-14.21-38.89c.21-1.41.4-2.71.59-4.11a48.21,48.21,0,0,0,32.9,12.9,52.8,52.8,0,0,0,43.5-23.59c9.9-15,11.5-33.5,4.22-50.7l-11.81-28c-11.5-25.11-30.91-44.7-54.91-55.2l-8.59-3.8c-16.9-7.61-30.59-13.61-45.31-17.41A74,74,0,1,0,406,134.91c-19.9,15-35.31,36.69-43.18,62.8l-8.72,28.5L334.51,247.3c-14.69,16-18.6,38.11-10,57.61s27.09,32.19,47.4,32.19a49.33,49.33,0,0,0,5.5-.3,114.57,114.57,0,0,0-14.72,36.7L347.1,447.59c-6,28.32,10.59,56,38,62.91a50,50,0,0,0,12.09,1.5c23.81,0,44.81-17.5,49.9-41.8L462.68,396a4,4,0,0,1,.91-1.9l10.59-10.69,8.72,23.89a111.4,111.4,0,0,0,22,36.5L551.59,495A50,50,0,0,0,626,495C644.67,474.5,644.67,442.5,626,422.1ZM448,32a42,42,0,1,1-42,42A42,42,0,0,1,448,32Zm-7.1,339.7a34.61,34.61,0,0,0-9.49,17.79l-15.6,74.2c-1.9,8.71-9.22,16.3-18.62,16.3a16.44,16.44,0,0,1-4.37-.5c-10.41-2.59-16.82-13.91-14.41-25.2L394,380.21a78.55,78.55,0,0,1,20.81-39.3l43-43.41-20.9-91.7c-6,8.61-6.1,11-17.5,48.5a50.14,50.14,0,0,1-11,19.41L384.91,299c-4,4.41-8.59,6.21-13,6.21-14.81,0-28-20.91-13.9-36.21l23.4-25.29a6.9,6.9,0,0,0,1.59-2.8L393.32,207c11.49-37.7,43.49-63,79.77-63,27.9,0,42.4,7.7,76.59,22.79,16.72,7.3,30.31,21,38.62,39.2l11.5,27.21c7,16.5-5.72,29.89-18.22,29.89-6.5,0-12.9-3.6-16.59-12.3L553.8,224.21a36.13,36.13,0,0,0-18.31-18.41c-17.31-7.7-26.4-11.8-35.4-15l15.81,69.3c3.78,16.5-.31,33.9-11.91,47.7Zm161.59,101.7a18.58,18.58,0,0,1-13.59,6.18,18.23,18.23,0,0,1-13.6-6.18L528.59,422.2A78,78,0,0,1,513,396.3l-10.68-29.59,29-29.3,1-1.2.1-.11,16.28,44.61a35.55,35.55,0,0,0,7.12,11.79l46.69,51.2A22.43,22.43,0,0,1,602.49,473.41Z"]
  },
      kd = {
    prefix: "fal",
    iconName: "house-signal",
    icon: [640, 512, [], "e012", "M0,224v32c141.38,0,256,114.62,256,256h32C288,352.94,159.06,224,0,224Zm0,96v32A160,160,0,0,1,160,512h32C192,406,106,320,0,320Zm0,96v32a64,64,0,0,1,64,64H96A96,96,0,0,0,0,416ZM634.53,200,576,148.76V48a16,16,0,1,0-32,0v72.74L410.53,4a16,16,0,0,0-21.06,0L224,148.76h0L165.47,200a16,16,0,1,0,21.06,24.09L224,191.29h0v70.79a337.37,337.37,0,0,1,32,32.61V168a15.35,15.35,0,0,0-.81-4L400,37.27l144,126V368a16,16,0,0,1-16,16H310.61a333,333,0,0,1,11.29,32H528a48.05,48.05,0,0,0,48-48V191.28l37.46,32.79A16,16,0,0,0,634.53,200ZM442.67,288A21.39,21.39,0,0,0,464,266.67V181.34A21.39,21.39,0,0,0,442.67,160h-85.3A21.39,21.39,0,0,0,336,181.34v85.33A21.39,21.39,0,0,0,357.37,288ZM368,192H432v64H368Z"]
  },
      Id = {
    prefix: "fal",
    iconName: "house-user",
    icon: [576, 512, [], "e065", "M570.93,242l-58.57-51.26V48a16,16,0,0,0-16-16H400.28a16,16,0,0,0-16,16V78.71L298.74,4a16,16,0,0,0-21.08,0L5.47,242A18.2,18.2,0,0,0,0,254a16,16,0,0,0,16,16,18.56,18.56,0,0,0,10.56-3.95l37.48-32.83V464a48.1,48.1,0,0,0,48,48H464.33a48.11,48.11,0,0,0,48-48V233.24L549.84,266A18.65,18.65,0,0,0,560,269.65a16,16,0,0,0,16-16A18.26,18.26,0,0,0,570.93,242ZM175.72,480a80.12,80.12,0,0,1,80.05-80h64a80.12,80.12,0,0,1,80.06,80Zm304.62-16a16,16,0,0,1-16,16H431.9A112.18,112.18,0,0,0,319.82,368h-64A112.17,112.17,0,0,0,143.7,480H112.08a16,16,0,0,1-16-16V205.24l192.13-168,192.14,168Zm0-301.28-64-56V64h64ZM207.74,256a80.06,80.06,0,1,0,80.06-80A80.13,80.13,0,0,0,207.74,256Zm128.09,0a48,48,0,1,1-48-48A48.07,48.07,0,0,1,335.83,256Z"]
  },
      Od = {
    prefix: "fal",
    iconName: "hryvnia",
    icon: [384, 512, [], "f6f2", "M376 224c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-96.54l12.73-12.59c16.23-16.05 25.53-38.73 25.53-62.22 0-46.97-36.14-85.19-80.58-85.19h-84.42c-22.05 0-43.2 7.77-59.56 21.84l-33.51 28.8a8.008 8.008 0 0 0-.86 11.28l10.42 12.14c2.88 3.35 7.93 3.74 11.28.86l33.52-28.81C124.59 69.02 138.33 64 152.72 64h84.42c26.78 0 48.58 23.86 48.58 53.19 0 15-5.84 29.39-16.03 39.47L233.96 192H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h193.6l-64.71 64H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h96.54l-12.73 12.59c-16.23 16.05-25.53 38.73-25.53 62.22 0 46.97 36.14 85.19 80.58 85.19h84.42c22.05 0 43.2-7.77 59.56-21.84l33.52-28.8a8.008 8.008 0 0 0 .86-11.28l-10.42-12.14a8.01 8.01 0 0 0-11.29-.86l-33.52 28.81c-10.58 9.09-24.31 14.11-38.7 14.11h-84.42c-26.78 0-48.58-23.86-48.58-53.19 0-15 5.84-29.39 16.03-39.47L150.04 320H376c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H182.4l64.71-64H376z"]
  },
      Qd = {
    prefix: "fal",
    iconName: "humidity",
    icon: [384, 512, [], "f750", "M160 292c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm92 60c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zM223.9 22.1C219.5 7.5 205.8 0 192 0c-13.5 0-27 7.2-31.8 22.1C109.1 179.8 0 222.7 0 333.9 0 432.3 85.9 512 192 512s192-79.7 192-178.1c0-111.7-108.9-153.3-160.1-311.8zM192 480c-88.2 0-160-65.5-160-146.1 0-47.6 25-80.4 59.6-125.9 32.6-42.8 73.1-96 98.6-175.7.1-.1.8-.3 1.8-.3.7 0 1.2.1 1.4.1h.1c26 80.4 66.5 133.4 99.1 176.1C327.1 253.4 352 286 352 333.9c0 80.6-71.8 146.1-160 146.1zm61-212.2l-12.5-10c-3.5-2.8-8.5-2.2-11.2 1.2l-99.5 134c-2.8 3.5-2.2 8.5 1.2 11.2l12.5 10c3.5 2.8 8.5 2.2 11.2-1.2l99.5-134c2.8-3.4 2.2-8.5-1.2-11.2z"]
  },
      Zd = {
    prefix: "fal",
    iconName: "hurricane",
    icon: [384, 512, [], "f751", "M176 96l24.5-74.8C204 10.6 195.9 0 185.1 0c-.7 0-1.3 0-2 .1C80 12.4 0 101.6 0 208c0 114.9 93.1 208 208 208l-24.5 74.8c-3.5 10.6 4.6 21.2 15.4 21.2.7 0 1.3 0 2-.1C304 499.6 384 410.4 384 304c0-114.9-93.1-208-208-208zm46.3 379.2l16.1-49.3 13.7-42H208c-97 0-176-79-176-176 0-81.1 54.2-150.7 129.7-171.2L145.6 86l-13.7 42H176c97 0 176 79 176 176 0 81.1-54.2 150.7-129.7 171.2zM192 184c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"]
  },
      Ud = {
    prefix: "fal",
    iconName: "i-cursor",
    icon: [192, 512, [], "f246", "M96 38.223C75.091 13.528 39.824 1.336 6.191.005 2.805-.129 0 2.617 0 6.006v20.013c0 3.191 2.498 5.847 5.686 5.989C46.519 33.825 80 55.127 80 80v160H38a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h42v160c0 24.873-33.481 46.175-74.314 47.992-3.188.141-5.686 2.797-5.686 5.989v20.013c0 3.389 2.806 6.135 6.192 6.002C40.03 510.658 75.193 498.351 96 473.777c20.909 24.695 56.176 36.887 89.809 38.218 3.386.134 6.191-2.612 6.191-6.001v-20.013c0-3.191-2.498-5.847-5.686-5.989C145.481 478.175 112 456.873 112 432V272h42a6 6 0 0 0 6-6v-20a6 6 0 0 0-6-6h-42V80c0-24.873 33.481-46.175 74.314-47.992 3.188-.142 5.686-2.798 5.686-5.989V6.006c0-3.389-2.806-6.135-6.192-6.002C151.97 1.342 116.807 13.648 96 38.223z"]
  },
      Bd = {
    prefix: "fal",
    iconName: "ice-cream",
    icon: [448, 512, [], "f810", "M380.91 129.3C366.57 55.65 301.85 0 224 0S81.43 55.65 67.09 129.3A79.87 79.87 0 0 0 80 288h6l95 196.65a47.54 47.54 0 0 0 86.06 0L362 288h6a79.87 79.87 0 0 0 12.91-158.7zM238.22 470.73c-4.06 8.38-11.28 9.27-14.22 9.27s-10.16-.89-14.22-9.27L121.5 288h205zM368 256H80a47.86 47.86 0 0 1-7.75-95.12l22-3.59 4.25-21.88a127.86 127.86 0 0 1 251 0l4.25 21.88 22 3.59A47.86 47.86 0 0 1 368 256z"]
  },
      Rd = {
    prefix: "fal",
    iconName: "ice-skate",
    icon: [576, 512, [], "f7ac", "M568 416h-16c-4.4 0-8 3.6-8 8v8c0 26.5-21.5 48-48 48h-80v-64h32c35.3 0 64-28.7 64-64v-37c0-44.1-30-82.5-72.7-93.1L320 192V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24h-83.7c-8.1 0-16.2 1.6-23.8 4.6L52.1 88C40 92.8 32 104.6 32 117.7V352c0 35.3 28.7 64 64 64v64H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h488c44.2 0 80-35.8 80-80v-8c0-4.4-3.6-8-8-8zM64 352V117.7l128.4-51.4c3.8-1.5 7.8-2.3 11.9-2.3H288v64h-56c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56v32h-56c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h84.1l115.5 28.9C460.1 260 480 285.5 480 315v37c0 17.6-14.4 32-32 32H96c-17.6 0-32-14.4-32-32zm320 128H128v-64h256v64z"]
  },
      Yd = {
    prefix: "fal",
    iconName: "icicles",
    icon: [512, 512, [], "f7ad", "M466 0H46C16.3 0-7.3 28.5 2.1 59.8l88.7 249.4c2.3 6.7 7.9 11.3 15.7 10.8 7-.2 13.1-5.1 14.9-11.9l23.5-77 35.3 172.1c1.5 7.5 8.1 12.9 15.7 12.9 7.7 0 14.2-5.4 15.7-13L248 221.6l22.3 86c1.6 7.2 8 12.4 15.5 12.5h.1c7.4 0 13.8-5 15.5-12.2l32.3-119.3 56.5 310.3c1.4 7.6 7.9 13.1 15.6 13.1h.2c7.6 0 14.2-5.4 15.7-12.8l89.5-444.5v-.2C516.6 25.8 494.4 0 466 0zm-59.2 411l-54.9-301.8c-3.1-17-27.2-17.6-31.3-1l-34 138.3-24.1-106c-3.7-16.3-27.9-16.8-31.3.5l-35.3 182L163 157c-3.5-17.6-27.2-15.8-31.2-1l-27.7 104.7L32.6 50C30 41.2 36.4 32 46 32h420c11.1 0 14.9 10.5 13.8 16.5l-73 362.5z"]
  },
      Pd = {
    prefix: "fal",
    iconName: "icons",
    icon: [512, 512, [], "f86d", "M106.66 215.41a29.89 29.89 0 0 0 42.59 0l84.66-85.62a76.63 76.63 0 0 0-5.41-112.62C199.84-6.75 156.41-4.67 128 21.38 99.66-4.73 56.22-6.86 27.47 17.19A76.7 76.7 0 0 0 22 129.8zM48 41.73a41.14 41.14 0 0 1 26.53-9.39A47.2 47.2 0 0 1 108 46.55l20 20.17 20-20.19c16.69-16.86 43-18.94 60-4.81a44.62 44.62 0 0 1 3.19 65.56l-81.72 85.64-84.69-85.61a44.71 44.71 0 0 1-12.72-33.47A44.12 44.12 0 0 1 48 41.73zM260.57 288h-48l-7.08-14.21A27.4 27.4 0 0 0 179.83 256h-71.71a27.4 27.4 0 0 0-25.66 17.75l-7 14.21h-48A27.42 27.42 0 0 0 0 315.35v169.26A27.42 27.42 0 0 0 27.43 512h233.14A27.42 27.42 0 0 0 288 484.61V315.35A27.42 27.42 0 0 0 260.57 288zM256 480H32V320h63.3l8.81-17.81 7-14.15h65.73l7.09 14.21 8.84 17.75H256zM484.62 0a24.05 24.05 0 0 0-3.93.33L343.55 23.18C330 25.44 320 38.94 320 54.86V166.8a81.36 81.36 0 0 0-32-6.47c-35.88 0-64 21.08-64 48s28.12 48 64 48 64-21.08 64-48V54.86a4.45 4.45 0 0 1 0-.65l128-21.33V135a80 80 0 0 0-32-6.65c-35.35 0-64 21.49-64 48s28.65 48 64 48 64-21.49 64-48V32c0-17.91-12.51-32-27.38-32zM288 224.33c-19.25 0-32-9.63-32-16s12.75-16 32-16 32 9.62 32 16-12.75 16-32 16zm160-32c-19.85 0-32-10.36-32-16s12.15-16 32-16 32 10.36 32 16-12.15 16-32 16zM144 336a64 64 0 1 0 64 64 64.07 64.07 0 0 0-64-64zm0 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm280.19-152.84a16 16 0 0 0-28.63-14.32L328 400h110.31l-52.2 88.06a16 16 0 0 0 6 21.83A15.8 15.8 0 0 0 400 512a16 16 0 0 0 13.91-8.06L493.44 368H379.75z"]
  },
      Fd = {
    prefix: "fal",
    iconName: "icons-alt",
    icon: [512, 512, [], "f86e", "M480.84 0a23.6 23.6 0 0 0-3.9.33L340.87 23.18c-13.41 2.26-23.37 15.76-23.37 31.68V166.8a80.15 80.15 0 0 0-31.75-6.47c-35.59 0-63.5 21.08-63.5 48s27.91 48 63.5 48 63.5-21.08 63.5-48V54.86a4.45 4.45 0 0 1 0-.65l127-21.33V135a78.79 78.79 0 0 0-31.75-6.65c-35.07 0-63.5 21.49-63.5 48s28.43 48 63.5 48 63.5-21.49 63.5-48V32c0-17.91-12.41-32-27.16-32zM285.75 224.33c-19.1 0-31.75-9.63-31.75-16s12.65-16 31.75-16 31.75 9.62 31.75 16-12.65 16-31.75 16zm158.75-32c-19.7 0-31.75-10.36-31.75-16s12.05-16 31.75-16 31.75 10.36 31.75 16-12.05 16-31.75 16zM7.94 96h87.31v120a8 8 0 0 0 7.94 8h15.87a8 8 0 0 0 7.94-8V96h87.31a8 8 0 0 0 7.94-8V72a8 8 0 0 0-7.94-8H7.94A8 8 0 0 0 0 72v16a8 8 0 0 0 7.94 8zm325.44 288a48 48 0 1 0-47.63-48 47.81 47.81 0 0 0 47.63 48zm0-64a16 16 0 1 1-15.88 16 16 16 0 0 1 15.88-16zM7.94 32h206.37a8 8 0 0 0 7.94-8V8.33a8 8 0 0 0-7.94-8H7.94a8 8 0 0 0-7.94 8V24a8 8 0 0 0 7.94 8zm452.44 384A48 48 0 1 0 508 464a47.81 47.81 0 0 0-47.62-48zm0 64a16 16 0 1 1 15.87-16 16 16 0 0 1-15.87 16zm34.07-189.66a7.89 7.89 0 0 0-11.22 0L288.08 487a8.05 8.05 0 0 0 0 11.32l11.22 11.31a7.89 7.89 0 0 0 11.22 0L505.67 313a8 8 0 0 0 0-11.32zM181.32 448.13l37.2-24.13a8.05 8.05 0 0 0 2.53-11l-8.41-13.58a7.9 7.9 0 0 0-10.94-2.55L158.35 425l-43.93-44.28A63.79 63.79 0 0 0 158.75 320c0-35.3-28.49-64-63.5-64s-63.5 28.7-63.5 64a63.91 63.91 0 0 0 30.57 54.45l-30.1 18.25C1.28 411.45-9.2 451.31 8.81 481.55 20.57 501.19 41.49 512 63.26 512a66.67 66.67 0 0 0 34.63-9.75l56.11-36.4 43.47 43.81a7.89 7.89 0 0 0 11.22 0l11.22-11.31a8 8 0 0 0 0-11.32zM95.25 288a32 32 0 1 1-31.75 32 31.87 31.87 0 0 1 31.75-32zM81.31 475c-15.91 9.66-36.22 5.22-45.27-9.9s-3.38-35.27 12.55-44.94l37.48-22.73 45 45.31z"]
  },
      Wd = {
    prefix: "fal",
    iconName: "id-badge",
    icon: [384, 512, [], "f2c1", "M320 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 448c0 17.6-14.4 32-32 32H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h256c17.6 0 32 14.4 32 32v384zM144 96h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 208c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm46.8 144c-19.5 0-24.4 7-46.8 7s-27.3-7-46.8-7c-21.2 0-41.8 9.4-53.8 27.4C84.2 358.1 80 371 80 384.9V424c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-39.1c0-14 9-32.9 33.2-32.9 12.4 0 20.8 7 46.8 7 25.9 0 34.3-7 46.8-7 24.3 0 33.2 18.9 33.2 32.9V424c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-39.1c0-13.9-4.2-26.8-11.4-37.5-12.1-18-32.7-27.4-53.8-27.4z"]
  },
      Gd = {
    prefix: "fal",
    iconName: "id-card",
    icon: [576, 512, [], "f2c2", "M360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0 128h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168-32c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM512 32H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM272 448H112v-15.1c0-7 2.1-13.8 6-19.6 5.6-8.3 15.8-13.2 27.3-13.2 12.4 0 20.8 7 46.8 7 25.9 0 34.3-7 46.8-7 11.5 0 21.7 5 27.3 13.2 3.9 5.8 6 12.6 6 19.6V448h-.2zm272-32c0 17.6-14.4 32-32 32H304v-15.1c0-13.9-4.2-26.8-11.4-37.5-12.1-17.9-32.7-27.4-53.8-27.4-19.5 0-24.4 7-46.8 7s-27.3-7-46.8-7c-21.2 0-41.8 9.4-53.8 27.4C84.2 406.1 80 419 80 432.9V448H64c-17.6 0-32-14.4-32-32V160h512v256zm0-288H32V96c0-17.6 14.4-32 32-32h448c17.6 0 32 14.4 32 32v32z"]
  },
      qd = {
    prefix: "fal",
    iconName: "id-card-alt",
    icon: [576, 512, [], "f47f", "M288 208c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM512 64H352V32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v32H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM256 32h64v96h-64V32zm128 448H192v-21.9c0-9 2.6-17.6 7.6-25 7.2-10.7 20.3-17.2 35-17.2 15.9 0 23.5 8 53.4 8s37.6-8 53.4-8c14.7 0 27.7 6.4 35 17.2 5 7.4 7.6 16 7.6 25V480zm160-32c0 17.6-14.4 32-32 32h-96v-21.9c0-15.9-4.8-30.6-13-42.8-13.8-20.5-37.3-31.3-61.5-31.3-22.2 0-27.8 8-53.4 8-25.6 0-31.2-8-53.4-8-24.2 0-47.7 10.8-61.5 31.3-8.2 12.2-13 27-13 42.8V480H64c-17.6 0-32-14.4-32-32V128c0-17.6 14.4-32 32-32h160v64h128V96h160c17.6 0 32 14.4 32 32v320z"]
  },
      Jd = {
    prefix: "fal",
    iconName: "igloo",
    icon: [576, 512, [], "f7ae", "M288 32C128.9 32 0 160.9 0 320v128c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V320c0-159.1-128.9-288-288-288zm199.5 128H352V72.4c54.2 14 101.5 45.2 135.5 87.6zM448 320h-49.8c-22.2-38.1-63-64-110.2-64s-88 25.9-110.2 64H128V192h320v128zM288 64c10.9 0 21.5.9 32 2.2V160H88.5c46.9-58.4 118.9-96 199.5-96zM66.6 192H96v128H32c0-46.7 12.7-90.3 34.6-128zM32 448v-96h132.5c-2.7 10.3-4.5 20.9-4.5 32v64H32zm160 0v-64c0-53 43-96 96-96s96 43 96 96v64H192zm352 0H416v-64c0-11.1-1.9-21.7-4.5-32H544v96zm-64-128V192h29.4c21.9 37.7 34.6 81.3 34.6 128h-64z"]
  },
      Kd = {
    prefix: "fal",
    iconName: "image",
    icon: [512, 512, [], "f03e", "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm16 336c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V112c0-8.822 7.178-16 16-16h416c8.822 0 16 7.178 16 16v288zM112 232c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56 25.072 56 56 56zm0-80c13.234 0 24 10.766 24 24s-10.766 24-24 24-24-10.766-24-24 10.766-24 24-24zm207.029 23.029L224 270.059l-31.029-31.029c-9.373-9.373-24.569-9.373-33.941 0l-88 88A23.998 23.998 0 0 0 64 344v28c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-92c0-6.365-2.529-12.47-7.029-16.971l-88-88c-9.373-9.372-24.569-9.372-33.942 0zM416 352H96v-4.686l80-80 48 48 112-112 80 80V352z"]
  },
      Xd = {
    prefix: "fal",
    iconName: "image-polaroid",
    icon: [448, 512, [], "f8c4", "M112 192a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm0-64a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm304-96H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm0 416H32v-80h384zM85.2 336l52-69.33 40 53.33-12 16zm120 0l76-101.33 76 101.33zm210.8 0h-18.8L294 198.41c-6.06-8.07-19.56-8.07-25.62 0l-71.19 94.91L150 230.41c-6.06-8.07-19.56-8.07-25.62 0L45.18 336H32V64h384z"]
  },
      _d = {
    prefix: "fal",
    iconName: "images",
    icon: [576, 512, [], "f302", "M528 32H112c-26.51 0-48 21.49-48 48v16H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48v-16h16c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-48 400c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V144c0-8.822 7.178-16 16-16h16v240c0 26.51 21.49 48 48 48h368v16zm64-64c0 8.822-7.178 16-16 16H112c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h416c8.822 0 16 7.178 16 16v288zM176 200c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56 25.072 56 56 56zm0-80c13.234 0 24 10.766 24 24s-10.766 24-24 24-24-10.766-24-24 10.766-24 24-24zm240.971 23.029c-9.373-9.373-24.568-9.373-33.941 0L288 238.059l-31.029-31.03c-9.373-9.373-24.569-9.373-33.941 0l-88 88A24.002 24.002 0 0 0 128 312v28c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-92c0-6.365-2.529-12.47-7.029-16.971l-88-88zM480 320H160v-4.686l80-80 48 48 112-112 80 80V320z"]
  },
      $d = {
    prefix: "fal",
    iconName: "inbox",
    icon: [576, 512, [], "f01c", "M566.819 227.377L462.377 83.768A48.001 48.001 0 0 0 423.557 64H152.443a47.998 47.998 0 0 0-38.819 19.768L9.181 227.377A47.996 47.996 0 0 0 0 255.609V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V255.609a47.996 47.996 0 0 0-9.181-28.232zM139.503 102.589A16.048 16.048 0 0 1 152.443 96h271.115c5.102 0 9.939 2.463 12.94 6.589L524.796 224H388.223l-32 64H219.777l-32-64H51.204l88.299-121.411zM544 272v128c0 8.823-7.178 16-16 16H48c-8.822 0-16-7.177-16-16V272c0-8.837 7.163-16 16-16h120l32 64h176l32-64h120c8.837 0 16 7.163 16 16z"]
  },
      cM = {
    prefix: "fal",
    iconName: "inbox-in",
    icon: [576, 512, [], "f310", "M560.8 329.8l-94.6-88.7c-2.4-2.3-6.2-2.1-8.5.3L444.1 256c-2.3 2.4-2.1 6.2.3 8.5l59.3 55.6H388.2l-32 64H219.8l-32-64H72.4l59.3-55.6c2.4-2.3 2.5-6.1.3-8.5l-13.7-14.6c-2.3-2.4-6.1-2.5-8.5-.3l-94.6 88.7c-9.7 9-15.2 21.7-15.2 35V464c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48v-99.2c0-13.3-5.5-26-15.2-35zM544 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h120l32 64h176l32-64h120c8.8 0 16 7.2 16 16v96zM416 128h-64V24c0-13.2-10.8-24-24-24h-80c-13.2 0-24 10.8-24 24v104h-64c-28.4 0-42.8 34.5-22.6 54.6l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c20-20.1 5.8-54.6-22.7-54.6zM288 288L160 160h96V32h64v128h96L288 288z"]
  },
      eM = {
    prefix: "fal",
    iconName: "inbox-out",
    icon: [576, 512, [], "f311", "M560.8 329.8l-94.6-88.7c-2.4-2.3-6.2-2.1-8.5.3L444.1 256c-2.3 2.4-2.1 6.2.3 8.5l59.3 55.6H388.2l-32 64H219.8l-32-64H72.4l59.3-55.6c2.4-2.3 2.5-6.1.3-8.5l-13.7-14.6c-2.3-2.4-6.1-2.5-8.5-.3l-94.6 88.7C5.5 338.9 0 351.5 0 364.8V464c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48v-99.2c0-13.3-5.5-25.9-15.2-35zM544 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h120l32 64h176l32-64h120c8.8 0 16 7.2 16 16v96zM160 192h64v104c0 13.2 10.8 24 24 24h80c13.2 0 24-10.8 24-24V192h64c28.4 0 42.8-34.5 22.6-54.6l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-20 20.1-5.8 54.6 22.7 54.6zM288 32l128 128h-96v128h-64V160h-96L288 32z"]
  },
      aM = {
    prefix: "fal",
    iconName: "indent",
    icon: [448, 512, [], "f03c", "M27.31 148.7a15.63 15.63 0 0 0-11.17-4.7A16 16 0 0 0 0 160v192a16 16 0 0 0 16.13 16 15.58 15.58 0 0 0 11.18-4.7l96-96a16 16 0 0 0 0-22.62zM32 313.36V198.64L89.37 256zM440 48H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8zm0 384H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-128H200a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h240a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-128H200a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h240a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      nM = {
    prefix: "fal",
    iconName: "industry",
    icon: [512, 512, [], "f275", "M477.267 162.534L320 241.167V184c0-18.007-18.948-29.359-34.733-21.466L128 241.167V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184c0-18.007-18.948-29.359-34.733-21.466zM107.578 287.155L288 196.944V280c0 5.949 6.268 9.81 11.578 7.155L480 196.944V448H32V64h64v216c0 5.947 6.269 9.811 11.578 7.155z"]
  },
      tM = {
    prefix: "fal",
    iconName: "industry-alt",
    icon: [512, 512, [], "f3b3", "M404 384h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm-116-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-128 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm352-188v272c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h80c13.255 0 24 10.745 24 24v185.167l157.267-78.633C301.052 154.641 320 165.993 320 184v57.167l157.267-78.633C493.052 154.641 512 165.993 512 184zM96 280V64H32v384h448V196.944l-180.422 90.211C294.268 289.81 288 285.949 288 280v-83.056l-180.422 90.211C102.269 289.811 96 285.947 96 280z"]
  },
      rM = {
    prefix: "fal",
    iconName: "infinity",
    icon: [640, 512, [], "f534", "M488.88 96C406.31 96 346.21 178.45 320 222.45 293.79 178.45 233.69 96 151.12 96 67.78 96 0 167.78 0 256s67.78 160 151.12 160c82.56 0 142.67-82.45 168.88-126.46C346.21 333.55 406.31 416 488.88 416 572.22 416 640 344.22 640 256S572.22 96 488.88 96zM151.12 384C85.44 384 32 326.58 32 256s53.44-128 119.12-128c78.03 0 136.47 100.61 150.94 128-14.47 27.39-72.9 128-150.94 128zm337.76 0c-78.03 0-136.47-100.61-150.94-128 14.47-27.39 72.91-128 150.94-128C554.56 128 608 185.42 608 256s-53.44 128-119.12 128z"]
  },
      iM = {
    prefix: "fal",
    iconName: "info",
    icon: [256, 512, [], "f129", "M208 368.667V208c0-15.495-7.38-29.299-18.811-38.081C210.442 152.296 224 125.701 224 96c0-52.935-43.065-96-96-96S32 43.065 32 96c0 24.564 9.274 47.004 24.504 64H56c-26.467 0-48 21.533-48 48v48c0 23.742 17.327 43.514 40 47.333v65.333C25.327 372.486 8 392.258 8 416v48c0 26.467 21.533 48 48 48h144c26.467 0 48-21.533 48-48v-48c0-23.742-17.327-43.514-40-47.333zM128 32c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64 28.654-64 64-64zm88 432c0 8.837-7.163 16-16 16H56c-8.837 0-16-7.163-16-16v-48c0-8.837 7.163-16 16-16h24V272H56c-8.837 0-16-7.163-16-16v-48c0-8.837 7.163-16 16-16h104c8.837 0 16 7.163 16 16v192h24c8.837 0 16 7.163 16 16v48z"]
  },
      oM = {
    prefix: "fal",
    iconName: "info-circle",
    icon: [512, 512, [], "f05a", "M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"]
  },
      lM = {
    prefix: "fal",
    iconName: "info-square",
    icon: [448, 512, [], "f30f", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm16 400c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h352c8.822 0 16 7.178 16 16v352zm-228-80h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"]
  },
      fM = {
    prefix: "fal",
    iconName: "inhaler",
    icon: [640, 512, [], "f5f9", "M24 264c-13.25 0-24 10.75-24 24s10.75 24 24 24 24-10.75 24-24-10.75-24-24-24zm0 96c-13.25 0-24 10.75-24 24s10.75 24 24 24 24-10.75 24-24-10.75-24-24-24zm0 96c-13.25 0-24 10.75-24 24s10.75 24 24 24 24-10.75 24-24-10.75-24-24-24zM616.27 38.02L478.47 1.1c-2.77-.74-5.56-1.1-8.3-1.1-14.13 0-27.06 9.43-30.89 23.72l-24.97 93.21-5.11-5.11c-3.21-3.21-7.26-4.7-11.25-4.7-6.87 0-13.56 4.39-15.54 11.95L346.49 256H224c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h270.62c29.09 0 54.53-19.62 61.91-47.76l37.96-144.71c2.88-11-.28-22.71-8.32-30.75l-3.11-3.11L638.9 77.21c4.58-17.07-5.55-34.61-22.63-39.19zm-90.7 418.1c-3.69 14.06-16.42 23.88-30.95 23.88H224V288h147.18l6.26-23.88 28.84-109.96 157.25 157.25-37.96 144.71zm31.35-196.58L440.45 143.07l29.77-111.06L608 68.93l-51.08 190.61zM120 312c-13.25 0-24 10.75-24 24s10.75 24 24 24 24-10.75 24-24-10.75-24-24-24zm0 96c-13.25 0-24 10.75-24 24s10.75 24 24 24 24-10.75 24-24-10.75-24-24-24z"]
  },
      sM = {
    prefix: "fal",
    iconName: "integral",
    icon: [366, 512, [], "f667", "M88.46 479.84c-19.3-1.3-36.8-11.91-48.88-27.02L1.75 405.54A8.007 8.007 0 0 1 3 394.29l12.5-10a7.983 7.983 0 0 1 11.23 1.25l39.72 49.65c7.69 9.64 19.93 14.41 32.42 12.33 14.06-2.34 24.72-14.1 27.93-27.99l76.85-333.31c6.43-27.9 28.9-50.51 57.32-53.77 23.05-2.64 45.12 6.59 59.38 24.38l43.9 54.92a7.995 7.995 0 0 1-1.25 11.24l-12.5 10c-3.45 2.76-8.48 2.2-11.23-1.25l-43.9-54.92c-7.7-9.62-19.83-14.39-32.29-12.37-14.09 2.29-24.83 14.02-28.04 27.95l-77.55 336.31c-7.31 31.69-36.1 53.35-69.03 51.13z"]
  },
      uM = {
    prefix: "fal",
    iconName: "intersection",
    icon: [320, 512, [], "f668", "M149.35 64.35C64.31 69.85 0 144.26 0 229.48V440c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V228.52c0-68.11 51.28-127.67 119.24-132.22C225.76 91.3 288 150.52 288 224v216c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V224c0-91.89-77.46-165.69-170.65-159.65z"]
  },
      hM = {
    prefix: "fal",
    iconName: "inventory",
    icon: [640, 512, [], "f480", "M632 0h-16c-4.4 0-8 4.1-8 9.1V192h-64V48c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v144H32V9.1c0-5-3.6-9.1-8-9.1H8C3.6 0 0 4.1 0 9.1V512h32v-32h576v32h32V9.1c0-5-3.6-9.1-8-9.1zM384 64h128v128H384V64zM256 448H128V320h128v128zm32 0V320h128v128H288zm320 0H448V304c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v144H32V224h576v224z"]
  },
      mM = {
    prefix: "fal",
    iconName: "island-tropical",
    icon: [448, 512, [], "f811", "M299.39 32c-15.4 0-30 2.55-43.94 6.23C228.22 14.67 190.46 0 148.62 0 73.38 0 11.08 47.24.24 108.86A16.51 16.51 0 0 0 16.8 128h73.45C57.94 177.87 55.12 238.52 85 281.15c7.13 10.17 19.58 7.49 25.24 1.84l83.13-83.14c-8.85 57-25.63 110.52-41.67 152.15h-20.51C58.84 352 0 410.86 0 483.2A28.85 28.85 0 0 0 28.81 512h326.38A28.85 28.85 0 0 0 384 483.2c0-62.2-43.62-114.2-101.81-127.61 9.7-74.31 4.43-147.08-1.9-195.59H431.2a16.51 16.51 0 0 0 16.56-19.14C436.92 79.25 374.62 32 299.39 32zm52.55 448H32.06a99.3 99.3 0 0 1 99.13-96h121.62a99.3 99.3 0 0 1 99.13 96zM250.12 352h-64.27c17.86-48.47 30.69-116.82 37.11-181.72L233.23 160H248c6.26 46.64 11.77 119 2.12 192zM220 128L102.22 245.76c-18.69-49 7.89-121.36 73-150.68a8 8 0 0 0 4.28-10.22l-6-14.91a8 8 0 0 0-10.58-4.46A169.86 169.86 0 0 0 117.24 96h-79.9c16.44-37.53 60.83-64 111.28-64 32.72 0 63.21 10.8 85.87 30.42l12.76 11c10.81-2.8 31.44-9.42 52.14-9.42 50.45 0 94.83 26.48 111.27 64z"]
  },
      vM = {
    prefix: "fal",
    iconName: "italic",
    icon: [320, 512, [], "f033", "M320 40v16a8 8 0 0 1-8 8h-87.5l-96 384H216a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h87.5l96-384H104a8 8 0 0 1-8-8V40a8 8 0 0 1 8-8h208a8 8 0 0 1 8 8z"]
  },
      dM = {
    prefix: "fal",
    iconName: "jack-o-lantern",
    icon: [576, 512, [], "f30e", "M494.75 110.52C460.24 77.96 409.33 71.33 368 90.9V51.8c0-12.2-6.78-23.17-17.69-28.62L310.69 3.36c-7.97-3.97-17.38-4.45-25.66-1.27-8.31 3.16-15 9.72-18.34 18.03l-28.7 71.75c-4.78 2.44-9.4 5.19-13.74 8.38-43.41-30.29-103.78-26.76-143 10.26C28.84 159.92 0 225.78 0 295.95c0 70.16 28.84 136 81.25 185.4 39.19 36.98 99.53 40.6 143 10.28 36.56 26.9 90.94 26.9 127.5 0 19.5 13.59 42.38 20.36 65.22 20.36 28.12 0 56.16-10.23 77.78-30.63C547.16 431.96 576 366.11 576 295.94s-28.84-136.02-81.25-185.42zM296.41 31.99L336 51.8v39.11c-18.21-8.78-38.95-11.99-59.17-10.01l19.58-48.91zm176.4 426.09c-30.16 28.42-79.78 28.87-110.62 1.06l-11-9.9-10.75 10.2c-14.5 13.76-31.66 20.46-52.44 20.46s-37.94-6.7-52.44-20.46l-10.75-10.2-11 9.9c-30.84 27.81-80.47 27.35-110.62-1.06C57.28 414.79 32 357.21 32 295.94s25.28-118.85 71.19-162.16c30.12-28.4 79.75-28.9 110.62-1.05l11 9.9 10.75-10.2c14.5-13.76 31.66-20.46 52.44-20.46s37.94 6.7 52.44 20.46l10.75 10.2 11-9.9c30.81-27.82 80.44-27.4 110.62 1.06C518.72 177.09 544 234.67 544 295.94s-25.28 118.85-71.19 162.14zm1.66-179.15c-10.62-8.39-24.81-9.28-36.28-2.27-53.41 32.73-116.03 46.65-180.53 39.9L240 314.7v29.23h-32v-36.79l-10.97-3.64c-22.56-7.48-41.91-16.26-59.16-26.81-11.47-7.05-25.75-6.08-36.28 2.31-10.81 8.62-14.91 22.68-10.47 35.84 5.5 16.18 12.38 30.18 21.09 42.9 33.84 48.52 94.66 74.17 175.78 74.17 11.69 0 22.78-.7 33.56-1.75l14.44-1.41v-36.84h32v31.15l21.97-8.81c31.72-12.72 56.69-31.93 74.31-57.18 8.47-12.31 15.22-26.14 20.69-42.34 4.45-13.14.32-27.2-10.49-35.8zm-19.81 25.6c-4.5 13.33-9.97 24.59-16.69 34.32-10.56 15.14-24.69 27.62-42.12 37.31-5.53-9.69-15.94-16.23-27.84-16.23h-32c-17.66 0-32 14.36-32 31.99v7.53c-5.22.3-10.53.47-16 .47-70.22 0-121.94-20.92-149.47-60.39-6.97-10.15-12.56-21.59-17.34-35.56 16.44 10.08 34.47 18.65 54.81 26.09v13.87c0 17.64 14.34 31.99 32 31.99h32c15.56 0 28.56-11.17 31.44-25.92 63.41 4.78 128.84-12.58 183.5-46.07l-.29.6zm-205.51-48.58c2.85 0 4.86-1.11 6-3.33s1.14-4.44 0-6.66L214 179.29c-1.71-2.23-3.86-3.33-6.43-3.33s-4.43 1.11-5.57 3.33l-41.15 66.65c-1.14 2.23-1.14 4.44 0 6.66s3.15 3.33 6 3.33h82.3zm160 0c2.85 0 4.86-1.11 6-3.33s1.14-4.44 0-6.66L374 179.29c-1.71-2.23-3.86-3.33-6.43-3.33s-4.43 1.11-5.57 3.33l-41.15 66.65c-1.14 2.23-1.14 4.44 0 6.66s3.15 3.33 6 3.33h82.3z"]
  },
      MM = {
    prefix: "fal",
    iconName: "jedi",
    icon: [576, 512, [], "f669", "M560,241.23438C560,390.53125,437.97065,512,288.00423,512,141.569,512,22.78961,394.76562,16.28971,253.95312c-4.24993-92.54687,38.46815-179.84374,114.31072-233.5a23.72023,23.72023,0,0,1,13.74979-4.40624,24.075,24.075,0,0,1,22.31215,32.9375,126.06511,126.06511,0,0,0-8.96861,46.65624c0,41.10938,19.1872,78.90626,52.62418,103.67188a24.08535,24.08535,0,0,1,1.81248,37.375,111.64354,111.64354,0,0,0-37.21818,83.29688c0,56.5625,42.3431,102.42187,97.09224,110.21874V358.625l-20.68717,20.6875a15.99817,15.99817,0,1,1-22.62465-22.625L249.37984,336H224.00523a16,16,0,0,1,0-32h25.37461l-20.68718-20.6875a15.99817,15.99817,0,1,1,22.62465-22.625l20.68717,20.6875V16a15.99975,15.99975,0,1,1,31.9995,0V281.375l20.68718-20.6875a15.99817,15.99817,0,0,1,22.62465,22.625L326.62863,304h25.37461a16,16,0,0,1,0,32H326.62863l20.68718,20.70312a15.99265,15.99265,0,0,1-22.62465,22.60938L303.97274,358.625v71.67188C387.47144,418.98438,400.94,342.15625,401.00248,320A111.45108,111.45108,0,0,0,363.878,236.70312a24.04818,24.04818,0,0,1,1.81247-37.39062c33.40573-24.76562,52.59294-62.54688,52.59294-103.65625A125.851,125.851,0,0,0,409.2836,48.9375,24.075,24.075,0,0,1,431.59575,16a23.66572,23.66572,0,0,1,13.71854,4.40625A271.02474,271.02474,0,0,1,560,241.23438Zm-33.74947,27.5625L490.50108,300.0625a16.00686,16.00686,0,0,1-21.06217-24.10938l57.6866-50.46874a237.50982,237.50982,0,0,0-5.18742-36.82813L491.28232,219.3125a15.99265,15.99265,0,0,1-22.62465-22.60938l42.40559-42.40624a239.45023,239.45023,0,0,0-64.374-92.07813,157.73669,157.73669,0,0,1,3.56245,33.4375,159.43294,159.43294,0,0,1-58.28034,123.6875A142.8669,142.8669,0,0,1,433.002,320.01562c-.1875,87.89063-72.84262,143.82813-145.029,143.82813-79.99875,0-145.06024-64.8125-145.06024-144.46875a143.69178,143.69178,0,0,1,41.09311-100.03125,159.36344,159.36344,0,0,1-58.31159-123.6875V95.5625a189.99126,189.99126,0,0,1,3.59369-33.375,237.7374,237.7374,0,0,0-64.53024,91.96875L107.2883,196.6875a15.99817,15.99817,0,0,1-22.62465,22.625l-30.49953-30.5a235.49408,235.49408,0,0,0-5.62491,36.39062l57.96785,50.75a16.001,16.001,0,0,1-21.06217,24.09376L49.82044,268.84375C60.789,362.34375,142.78774,480,288.00423,480,410.93982,480,512.46949,387.48438,526.25053,268.79688Z"]
  },
      pM = {
    prefix: "fal",
    iconName: "joint",
    icon: [640, 512, [], "f595", "M556.44 93.48C548.9 88.45 544 80.33 544 71.26V8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v62.31c0 20.16 10.28 38.78 27.02 50.01 43.2 28.98 68.98 77.3 68.98 129.36V280c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-30.31c0-62.93-31.24-121.31-83.56-156.21zm-52.87 80.13C528.9 190.71 544 219.1 544 249.69V280c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-30.31c0-41.96-21.08-80.88-56.31-103.78C494.07 129.25 480 99.53 480 68.97V8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v67.03c0 40.32 22.15 76.02 55.57 98.58zM616 352H278.94C180.3 352 83.65 379.72 0 432c83.65 52.28 180.3 80 278.94 80H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24zM278.94 480c-73.85 0-146.33-16.47-212.51-48 60.11-28.64 125.5-44.14 192.32-46.88l81.3 94.88h-61.11zm103.27 0l-82.27-96h117.85l82.27 96H382.21zM608 480h-65.79l-82.27-96H608v96z"]
  },
      zM = {
    prefix: "fal",
    iconName: "journal-whills",
    icon: [448, 512, [], "f66a", "M433.09375,414.20312C429.5,430.29688,428.68749,459.79688,432.68749,480H436a12.04337,12.04337,0,0,1,12,12v8a12.04337,12.04337,0,0,1-12,12H64A64.00317,64.00317,0,0,1,0,448V80A79.964,79.964,0,0,1,80,0H424a23.95631,23.95631,0,0,1,24,24V392A24.14194,24.14194,0,0,1,433.09375,414.20312ZM416,32H80A48.01238,48.01238,0,0,0,32,80V392.875A63.29355,63.29355,0,0,1,64,384H416ZM404.28125,416H64a32,32,0,0,0,0,64H404.28125A229.78513,229.78513,0,0,1,404.28125,416ZM100,206.95312c0-50.1875,27.5625-96.8125,71.93749-121.6875a11.95085,11.95085,0,0,1,14.5,2.14063,13.58423,13.58423,0,0,1,3.375,8.29687A13.90947,13.90947,0,0,1,188,101.98438,60.027,60.027,0,0,0,201.46875,180.875a11.82582,11.82582,0,0,1,4.40625,8.5625,11.95519,11.95519,0,0,1-3.31251,9.03125A51.74024,51.74024,0,0,0,228,284.84375V259.3125l-6.34375,6.34375a7.99915,7.99915,0,0,1-11.3125-11.3125L220.68749,244H208a8,8,0,0,1,0-16h12.68749l-10.34374-10.34375a7.99915,7.99915,0,0,1,11.3125-11.3125L228,212.6875V84a12,12,0,0,1,24,0V212.6875l6.34375-6.34375a7.99915,7.99915,0,0,1,11.3125,11.3125L259.31249,228H272a8,8,0,0,1,0,16H259.31249L269.625,254.32812a7.99915,7.99915,0,1,1-11.31251,11.3125l-6.34374-6.34374v25.53124a51.76724,51.76724,0,0,0,25.46874-86.375,11.92036,11.92036,0,0,1-3.31249-9.01562,13.5281,13.5281,0,0,1,4.375-8.5625,60.027,60.027,0,0,0,13.46875-78.89062A11.99016,11.99016,0,0,1,308.06249,85.25C352.43749,110.14062,380,156.76562,380,206.95312c0,77.20313-62.81251,140-140,140S100,284.15625,100,206.95312Zm50,46.3125a8.03978,8.03978,0,0,1-11.3125.75l-6.84375-6c16.65625,43.6875,58.65625,74.9375,108.125,74.9375s91.46874-31.25,108.125-74.9375l-6.84375,6a8.005,8.005,0,1,1-10.56251-12.03124l23.84376-20.875c.59375-4.6875,1.4375-9.3125,1.4375-14.15626a115.1298,115.1298,0,0,0-2.0625-21.5625L341.625,197.65625a7.99915,7.99915,0,0,1-11.31251-11.3125L348.75,167.90625a115.65937,115.65937,0,0,0-23.78125-39.20313c.125,1.70313.1875,3.39063.1875,5.09376a84.38526,84.38526,0,0,1-22.71876,57.42187,76.01587,76.01587,0,1,1-124.90624,0,84.21054,84.21054,0,0,1-22.71875-57.42187c0-1.70313.09375-3.39063.15625-5.09376a116.81117,116.81117,0,0,0-23.78125,39.20313l18.46875,18.4375a7.99915,7.99915,0,0,1-11.3125,11.3125L126.0625,185.39062A112.56957,112.56957,0,0,0,124,206.95312c0,4.84376.84375,9.46876,1.4375,14.15626l23.84375,20.875A7.97419,7.97419,0,0,1,150,253.26562Z"]
  },
      CM = {
    prefix: "fal",
    iconName: "joystick",
    icon: [448, 512, [], "f8c5", "M200 64a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm216 288H240V222.39c54.21-7.83 96-54 96-110.39a112 112 0 0 0-224 0c0 56.38 41.79 102.56 96 110.39V352h-80v-16a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v16H32a32 32 0 0 0-32 32v96a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-96a32 32 0 0 0-32-32zM144 112a80 80 0 1 1 80 80 80.09 80.09 0 0 1-80-80zm272 368H32v-96h384z"]
  },
      LM = {
    prefix: "fal",
    iconName: "jug",
    icon: [448, 512, [], "f8c6", "M304 272H144a48.05 48.05 0 0 0-48 48v64a48.05 48.05 0 0 0 48 48h160a48 48 0 0 0 48-48v-64a48 48 0 0 0-48-48zm16 112a16 16 0 0 1-16 16H144a16 16 0 0 1-16-16v-64a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16zm128-248a71.75 71.75 0 0 0-137.71-28.48A32 32 0 0 1 304 88.78V32h8a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H136a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h8v56.78a32 32 0 0 1-7 20l-76.95 96.16a128 128 0 0 0-28 80V448a64 64 0 0 0 64 64H352a64 64 0 0 0 64-64V284.9a128 128 0 0 0-26.88-78.22A71.93 71.93 0 0 0 448 136zm-64 312a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V284.9a96.39 96.39 0 0 1 21-60l77-96.14a64.22 64.22 0 0 0 14-40V32h96v56.78a64.23 64.23 0 0 0 14 40l76.93 96.18a96.34 96.34 0 0 1 21 60zm-8-272a39.41 39.41 0 0 1-13.41-2.71l-25.49-31.87c-.27-1.85-1.1-3.5-1.1-5.42a40 40 0 1 1 40 40z"]
  },
      AM = {
    prefix: "fal",
    iconName: "kaaba",
    icon: [576, 512, [], "f66b", "M261.89 166.54l-96 26.18a7.997 7.997 0 0 0-5.89 7.72v16.58c0 5.28 5.02 9.11 10.11 7.72l96-26.18a7.997 7.997 0 0 0 5.89-7.72v-16.57c0-5.29-5.02-9.12-10.11-7.73zm48 32.01l96 26.18c5.09 1.39 10.11-2.44 10.11-7.72v-16.58c0-3.61-2.41-6.77-5.89-7.72l-96-26.18c-5.09-1.39-10.11 2.44-10.11 7.72v16.57a8 8 0 0 0 5.89 7.73zM554.12 83.51L318.36 4.93C308.51 1.64 298.25 0 288 0s-20.51 1.64-30.36 4.93L21.88 83.51A32.006 32.006 0 0 0 0 113.87v310.8c0 15 10.42 27.98 25.06 31.24l242.12 53.8c6.86 1.53 13.84 2.29 20.83 2.29s13.97-.76 20.83-2.29l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24v-310.8c-.02-13.77-8.83-26-21.9-30.36zM544 229.3l-85.89-23.49c-5.09-1.39-10.11 2.44-10.11 7.72v16.58c0 3.61 2.41 6.77 5.89 7.72L544 262.08v162.59l-242.12 53.8a63.984 63.984 0 0 1-27.77 0L32 424.67V262.3l90.11-24.48a7.997 7.997 0 0 0 5.89-7.72v-16.58c0-5.28-5.02-9.11-10.11-7.72L32 229.14V186.7l242.25-72.68c9-2.69 18.47-2.7 27.53.02L544 186.69v42.61zm0-76.02L311 83.39c-15.09-4.56-31-4.55-45.97-.02L32 153.29v-39.41l235.76-78.59c7.57-2.53 22.71-5.92 40.48 0L544 113.87v39.41z"]
  },
      NM = {
    prefix: "fal",
    iconName: "kazoo",
    icon: [640, 512, [], "f8c7", "M467.91 216.4l-11.31-11.31a8 8 0 0 0-11.32 0L417 233.37l-28.29-28.28a8 8 0 0 0-11.31 0l-11.31 11.31a8 8 0 0 0 0 11.31L394.37 256l-28.28 28.28a8 8 0 0 0 0 11.32l11.31 11.31a8 8 0 0 0 11.31 0L417 278.63l28.28 28.28a8 8 0 0 0 11.32 0l11.31-11.31a8 8 0 0 0 0-11.32L439.62 256l28.29-28.29a8 8 0 0 0 0-11.31zM609 128H481.68c-19.53-9.89-41.29-16-64.68-16s-45.15 6.11-64.68 16H242.93a128.18 128.18 0 0 0-35.16 4.92L24.21 185.37A32 32 0 0 0 1 216.14v79.72a32 32 0 0 0 23.21 30.77l183.56 52.44a127.81 127.81 0 0 0 35.16 4.93h109.39c19.53 9.89 41.29 16 64.68 16s45.15-6.11 64.68-16H609a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32zM242.93 352a95.64 95.64 0 0 1-26.37-3.7L33 295.86v-79.72l183.56-52.45a95.9 95.9 0 0 1 26.37-3.69h66.83a143.73 143.73 0 0 0 0 192zM417 368a112 112 0 1 1 112-112 112.12 112.12 0 0 1-112 112zm192-16h-84.76a143.73 143.73 0 0 0 0-192H609z"]
  },
      gM = {
    prefix: "fal",
    iconName: "kerning",
    icon: [640, 512, [], "f86f", "M416.54 0h-17A8 8 0 0 0 392 5.32l-176.28 496a8 8 0 0 0 7.55 10.68h17a8 8 0 0 0 7.54-5.32l176.29-496A8 8 0 0 0 416.54 0zm-131 96h-17.02a8 8 0 0 0-7.5 5.19L160 371 59 101.19A8 8 0 0 0 51.49 96H34.43a8 8 0 0 0-7.49 10.8l113.8 304a8 8 0 0 0 7.5 5.2h23.53a8 8 0 0 0 7.49-5.2l113.81-304a8 8 0 0 0-7.5-10.8zm327.52 309.2l-113.8-304a8 8 0 0 0-7.49-5.2h-23.53a8 8 0 0 0-7.5 5.2l-113.8 304a8 8 0 0 0 7.49 10.8h17.06a8 8 0 0 0 7.49-5.2L413 320h134l34 90.8a8 8 0 0 0 7.5 5.2h17.05a8 8 0 0 0 7.51-10.8zM425 288l55-147 55 147z"]
  },
      HM = {
    prefix: "fal",
    iconName: "key",
    icon: [512, 512, [], "f084", "M336 32c79.529 0 144 64.471 144 144s-64.471 144-144 144c-18.968 0-37.076-3.675-53.661-10.339L240 352h-48v64h-64v64H32v-80l170.339-170.339C195.675 213.076 192 194.968 192 176c0-79.529 64.471-144 144-144m0-32c-97.184 0-176 78.769-176 176 0 15.307 1.945 30.352 5.798 44.947L7.029 379.716A24.003 24.003 0 0 0 0 396.686V488c0 13.255 10.745 24 24 24h112c13.255 0 24-10.745 24-24v-40h40c13.255 0 24-10.745 24-24v-40h19.314c6.365 0 12.47-2.529 16.971-7.029l30.769-30.769C305.648 350.055 320.693 352 336 352c97.184 0 176-78.769 176-176C512 78.816 433.231 0 336 0zm48 108c11.028 0 20 8.972 20 20s-8.972 20-20 20-20-8.972-20-20 8.972-20 20-20m0-28c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"]
  },
      VM = {
    prefix: "fal",
    iconName: "key-skeleton",
    icon: [512, 512, [], "f6f3", "M329.37 137.37c-12.49 12.5-12.49 32.76 0 45.26 12.5 12.5 32.76 12.5 45.26 0 12.49-12.5 12.49-32.76 0-45.26-12.5-12.49-32.76-12.49-45.26 0zm64-64c-12.49 12.5-12.49 32.76 0 45.26 12.5 12.5 32.76 12.5 45.26 0s12.5-32.76 0-45.26c-12.5-12.49-32.76-12.49-45.26 0zM448 0H320c-35.35 0-64 28.65-64 64v128c0 11.85 3.44 22.8 9.05 32.32L2.34 487.03c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l48.7-48.7 46.4 46.4c6.16 6.16 16.2 6.22 22.43 0l44.86-44.86c6.19-6.19 6.19-16.23 0-22.43l-46.4-46.4 28.71-28.72 46.4 46.4c6.16 6.16 16.2 6.22 22.43 0l44.86-44.86c6.19-6.19 6.19-16.23 0-22.43l-46.4-46.4 50.72-50.72c9.52 5.61 20.47 9.05 32.32 9.05h128c35.35 0 64-28.65 64-64V64C512 28.65 483.35 0 448 0zM153.71 451.28l-22.43 22.43-35.18-35.18 22.43-22.43 35.18 35.18zm96-96l-22.43 22.43-35.19-35.19 22.43-22.43 35.19 35.19zM480 192c0 17.64-14.36 32-32 32H320c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h128c17.64 0 32 14.36 32 32v128z"]
  },
      xM = {
    prefix: "fal",
    iconName: "keyboard",
    icon: [576, 512, [], "f11c", "M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm16 336c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16V112c0-8.823 7.177-16 16-16h480c8.823 0 16 7.177 16 16v288zM168 268v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm-336 80v-24c0-6.627-5.373-12-12-12H84c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm384 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zM120 188v-24c0-6.627-5.373-12-12-12H84c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm-96 152v-8c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"]
  },
      wM = {
    prefix: "fal",
    iconName: "keynote",
    icon: [512, 512, [], "f66c", "M505.24 274.49l-48.4-96.8A32 32 0 0 0 428.22 160H128v-16c0-39.77 29.25-72.6 67.34-78.72C202.29 83.22 219.6 96 240 96h64c26.51 0 48-21.49 48-48S330.51 0 304 0h-64c-21.37 0-39.27 14.06-45.48 33.36C139.17 40.12 96 86.87 96 144v16H83.78a32 32 0 0 0-28.62 17.69l-48.4 96.8A63.874 63.874 0 0 0 0 303.11V352c0 17.67 14.33 32 32 32h160v96h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-56v-96h160c17.67 0 32-14.33 32-32v-48.89c0-9.94-2.31-19.74-6.76-28.62zM240 32h64c8.82 0 16 7.18 16 16s-7.18 16-16 16h-64c-8.82 0-16-7.18-16-16s7.18-16 16-16zM83.78 192h344.45l48 96H35.78l48-96zM288 480h-64v-96h64v96zm192-128H32v-32h448v32z"]
  },
      yM = {
    prefix: "fal",
    iconName: "khanda",
    icon: [512, 512, [], "f66d", "M415.81 66a16.095 16.095 0 0 0-7.76-1.99c-4.28 0-8.51 1.71-11.6 5.01a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.17-5.14 1.24-11.54-3.57-16.04L255.86 0l-58.99 52.81c-4.75 4.44-5.77 10.81-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-3-3.21-7.34-4.8-11.69-4.8-2.89 0-5.8.7-8.33 2.1C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c3.12 3.65 7.6 5.59 12.15 5.59 2.55 0 5.13-.61 7.5-1.88l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c2.38 1.26 4.95 1.88 7.5 1.88 4.55 0 9.03-1.94 12.15-5.59l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zM115.73 379.85L68.1 324.23c-11.38-13.29-19.78-26.73-24.98-39.96-21.09-53.63-11.41-110.92 22.11-152.16a197.139 197.139 0 0 0-4.95 44c.22 63.87 32.09 123.19 84.73 158.32l24.28 16.91-53.56 28.51zm184.21-270.48c21.58 14.34 35.86 38.83 35.86 66.63 0 28.76-15.38 53.81-38.21 67.91l-12.27-26.93c-8.75-24.52-8.75-51.04 0-75.56l14.62-32.05zm-44.08-66.43l27.85 24.93-27.48 60.28-.38.83-.38-.83-27.49-60.26 27.88-24.95zm-41.75 200.97c-22.83-14.1-38.21-39.15-38.21-67.91 0-27.81 14.29-52.29 35.86-66.63l14.61 32.06c8.75 24.52 8.75 51.03 0 75.56l-12.26 26.92zm41.75 69.43l-27.84-22.81 27.46-60.28.37-.82.37.82 27.47 60.28-27.83 22.81zm219.16-47.84c-5.5 21.29-17.13 42.41-34.57 62.77l-44.17 51.57-53.57-28.51 23.52-16.38c53.31-35.6 85.27-95.01 85.5-159.02 0-14.7-1.64-29.26-4.85-43.43 29.44 36.32 40.6 84.75 28.14 133z"]
  },
      bM = {
    prefix: "fal",
    iconName: "kidneys",
    icon: [608, 512, [], "f5fb", "M248.4 224.84l-56.12-29.54c4.75-9.17 10.65-18.07 18.84-26.14 36.75-36.24 41.81-100.27 7.33-138.91C200.55 10.21 176.29 0 151.92 0c-21.63 0-43.33 8.04-60.74 24.39-77.1 72.43-108.5 179.1-81.85 278.4C30.18 380.45 84.84 384 100.09 384c77.87 0 99.25-79.77 87.85-122.11-4.33-16.25-5.97-22.32-5.01-35.72l51.87 27.3c5.15 2.71 8.4 8.25 8.4 14.31V504c0 4.42 3.4 8 7.6 8H266c4.2 0 7.6-3.58 7.6-8V267.77c0-18.18-9.76-34.8-25.2-42.93zm-92.72 34.45l3.02 11.32c21.86 81.24-95.2 116.37-117.08 34.76l-3.03-11.27c-23.45-87.4 4.46-181.6 72.83-245.83C122.59 37.78 136.97 32 151.92 32c34.53 0 62.78 30.46 60.78 67.63-.92 17.06-8.1 32.73-20.22 44.11-33.91 31.83-47.67 75.05-36.8 115.55zm361.14-234.9C499.41 8.04 477.71 0 456.08 0c-24.36 0-48.63 10.21-66.51 30.25-34.48 38.64-29.42 102.67 7.33 138.91 8.19 8.08 14.09 16.98 18.83 26.14l-56.12 29.54c-15.45 8.13-25.2 24.75-25.2 42.93V504c0 4.42 3.4 8 7.6 8h15.2c4.2 0 7.6-3.58 7.6-8V267.78c0-6.06 3.25-11.6 8.41-14.31l51.86-27.3c.96 13.4-.68 19.47-5.01 35.72C408.66 304.23 430.04 384 507.91 384c15.25 0 69.91-3.55 90.76-81.21 26.65-99.3-4.75-205.98-81.85-278.4zm52.6 269.7l-3.03 11.27c-21.89 81.61-138.95 46.49-117.08-34.76l3.02-11.32c10.86-40.5-2.89-83.71-36.81-115.55-12.12-11.38-19.3-27.05-20.22-44.11-2-37.17 26.25-67.63 60.78-67.63 14.95 0 29.33 5.78 40.5 16.27 68.38 64.24 96.29 158.43 72.84 245.83z"]
  },
      SM = {
    prefix: "fal",
    iconName: "kiss",
    icon: [496, 512, [], "f596", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm56-164c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      TM = {
    prefix: "fal",
    iconName: "kiss-beam",
    icon: [496, 512, [], "f597", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm56-164c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zm160 0c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"]
  },
      DM = {
    prefix: "fal",
    iconName: "kiss-wink-heart",
    icon: [504, 512, [], "f598", "M499.6 392.3c-5.2-13.6-15.2-24.3-27.4-31.8 15-31.8 23.8-67 23.8-104.5C496 119 385 8 248 8S0 119 0 256s111 248 248 248c36.1 0 70.2-8.1 101.2-22.1 9.5 11.6 24.7 17.8 40.7 13.7l65.4-16.9c37.5-9.8 58.3-49.8 44.3-86.4zm-176.4 10.1l13.8 49.9c-27.2 12.5-57.2 19.7-89 19.7-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216c0 33.9-8 65.9-22 94.4-1-.1-18.6-30.4-56.1-30.4-41.9 0-74.5 39.8-62.7 82.4zm124 45.3l-65.4 16.9c-4 1.1-8.5-1.3-9.8-5.6l-18-65.1c-5.2-18.9 6.9-38.3 26.8-41.4 17.7-2.8 34 9.5 38.6 26l1.8 6.6 6.7-1.7c14.3-3.7 34.7 1.7 41.8 20.4 7.2 18.8-3.5 38.9-22.5 43.9zM304 308c0-19.2-28.7-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.7 13.5 20.7 21.5s-7.7 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.7 13.5 20.7 21.5s-7.7 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm235.8 46.1c-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-1.8 10.9 11.3 18.4 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.6 7.5 21.6.2 19.8-10.8z"]
  },
      jM = {
    prefix: "fal",
    iconName: "kite",
    icon: [640, 512, [], "f6f4", "M608 0H345.5c-14.9 0-27.8 10.3-31.2 24.8l-83.5 361.8-88.2 88.2c-10.5 10.4-30.6 2-30.6-12.7V356.6l12 9.2c7.4 5.7 16.2 8.7 25.3 8.7 23.5 0 42.7-19.9 42.7-44.3V278c0-24.4-19.2-44.3-42.7-44.3-9.2 0-17.9 3-25.3 8.7l-12 9.2V224c0-44.2-35.8-80-80-80H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h24c26.5 0 48 21.5 48 48v27.4l-12-9.2c-7.4-5.7-16.2-8.7-25.3-8.7-23.5.1-42.7 20-42.7 44.4v52.2c0 24.4 19.2 44.3 42.7 44.3 9.2 0 17.9-3 25.3-8.7l12-9.2v103.1c0 25.7 18.3 48.9 43.8 52 15.5 1.8 30.5-3.4 41.4-14.3l88.2-88.2 361.8-83.5c14.5-3.4 24.8-16.3 24.8-31.2V32c0-17.7-14.3-32-32-32zM48.6 340.3c-7.1 5.4-16.6-.4-16.6-10.2v-52.2c0-9.8 9.5-15.6 16.6-10.2L96 304l47.4-36.3c7.1-5.4 16.6.4 16.6 10.2v52.2c0 9.8-9.5 15.6-16.6 10.2L96 304zM585.4 32L476 141.4 366.6 32zM340.9 51.6L453.4 164 273.5 343.9zm-44.8 314.9L476 186.6 588.4 299zM608 273.4L498.6 164 608 54.6z"]
  },
      EM = {
    prefix: "fal",
    iconName: "kiwi-bird",
    icon: [576, 512, [], "f535", "M463.99 200c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm98.61 76.02c9.13-17.26 14.34-36.92 13.23-58.04C572.66 157.41 518.3 112 457.65 112h-9.37c-52.82 0-104.26-16.25-147.74-46.24C269.69 44.48 232.32 32 191.99 32c-14.56 0-29.5 1.62-44.67 5.05C76.36 53.08 19.49 110.89 4.43 182.07c-18.61 87.96 23.2 168.34 91.56 207.96V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-66.93c20.02 7.08 41.56 10.93 64 10.93 10.94 0 21.57-1.14 32-2.91V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-67.44c14.23-5.07 27.88-11.38 40.34-19.5C342.08 355.25 393.88 336 448.48 336h15.51c2.58 0 4.99-.61 7.53-.78l74.44 136.44c2.84 5.25 8.28 8.34 14.03 8.34 1.5 0 3-.2 4.5-.64 7.22-2.12 12-9 11.47-16.5L562.6 276.02zm-58.45 52.14c10.54-4.07 20.18-9.66 28.9-16.54l5.73 80.07-34.63-63.53zm17.88-49.1C506.77 295.14 486.16 304 463.99 304h-15.51c-57.3 0-114.36 18.25-169.62 54.25C253.01 375.1 222.97 384 191.99 384c-48.47 0-93.81-21.63-124.37-59.33-30.56-37.71-42.18-87.27-31.88-135.98 12.44-58.81 60.12-107.2 118.64-120.42C166.9 65.44 179.56 64 191.99 64c32.47 0 63.72 9.72 90.38 28.1 49.23 33.95 106.6 51.9 165.91 51.9h9.37c45.36 0 84.04 33.94 86.22 75.65 1.17 22.24-6.59 43.34-21.84 59.41z"]
  },
      kM = {
    prefix: "fal",
    iconName: "knife-kitchen",
    icon: [576, 512, [], "f6f5", "M566.64 65.94L511 9.37C504.76 3.12 496.59 0 488.41 0s-16.35 3.12-22.58 9.37L4.58 464.14C-3.36 472.1-.6 486.3 9.9 489.83 51.69 503.86 98.5 512 144.82 512c72.96 0 144.73-20.19 193.87-69.35l100.45-100.04c11.72-11.67 12.18-30.39 2.11-43.16l11.59-68.83 113.8-119.42c12.48-12.5 12.48-32.76 0-45.26zM317.34 419.6C278.4 458.55 217.13 480 144.82 480c-32.83 0-66.58-4.38-98.97-12.77l261.67-262.38 110.33 114.66L317.34 419.6zm104.7-202.14l-10.5 50.25-81.36-84.55C378.55 136.89 488.22 32 488.41 32l56.36 56.68-122.73 128.78zM432 128c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm32-32c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16-16 7.16-16 16z"]
  },
      IM = {
    prefix: "fal",
    iconName: "lambda",
    icon: [448, 512, [], "f66e", "M440 448h-72.63c-3.12 0-5.96-1.81-7.26-4.65L178.83 50.59A31.999 31.999 0 0 0 149.78 32H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h136.63c3.12 0 5.96 1.81 7.26 4.65l7.79 16.88L.62 468.92C-1.57 474.19 2.3 480 8.01 480h17.36a7.99 7.99 0 0 0 7.38-4.92l145.17-350.05 155.25 336.38A31.999 31.999 0 0 0 362.22 480H440c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"]
  },
      OM = {
    prefix: "fal",
    iconName: "lamp",
    icon: [416, 512, [], "f4ca", "M413.7 237.8l-71.9-216C337.3 8.6 327.2 0 316 0H112c-10.6 0-20.3 7.7-25 19.9l-84 216C-6.3 259.8 7.2 288 28 288h92.7C86.3 327.8 64 383.9 64 423.6c0 26.1 9.7 50.3 26.2 70.1 9.9 11.9 26.1 18.3 42.7 18.3h150.3c16.6 0 32.8-6.4 42.7-18.3 16.5-19.8 26.2-43.9 26.2-70.1 0-39.7-22.3-95.8-56.7-135.6H388c20.1 0 33.6-26.4 25.7-50.2zM320 423.6c0 17.6-6.5 34.8-18.8 49.6-3.4 4.1-10.5 6.8-18 6.8H132.9c-7.5 0-14.6-2.7-18-6.8-12.3-14.8-18.8-32-18.8-49.6 0-41.7 31-106 70.4-135.6h83.1C289 317.6 320 381.9 320 423.6zM377.4 256H38.6c-4.3 0-7.3-4.2-5.9-8.2 0-.1.1-.2.1-.3L116.7 32h194.7l71.9 215.9v.1c1.4 4-1.7 8-5.9 8z"]
  },
      QM = {
    prefix: "fal",
    iconName: "lamp-desk",
    icon: [512, 512, [], "e014", "M494.42,64H369.14L328.57,23.43A80,80,0,0,0,215.43,136.57l4.69,4.68L116.69,244.67a16.06,16.06,0,0,0-4.07,15.8L158,416H80c-35.09,0-68.12,23.22-78.53,55.2A30.19,30.19,0,0,0,6,498.55,32.64,32.64,0,0,0,32.27,512H351.73A32.64,32.64,0,0,0,378,498.55a30.21,30.21,0,0,0,4.47-27.36C372,439.2,339,416,304,416H191.35L146,260.59l96.74-96.71L256,177.14V302.42A17.53,17.53,0,0,0,273.67,320,17.18,17.18,0,0,0,286,314.82l60.16-60.16C358.6,265.24,374.39,272,392,272a72.08,72.08,0,0,0,72-72c0-17.61-6.75-33.4-17.33-45.87L506.82,94C517.88,82.9,510.05,64,494.42,64ZM304,448c21.6,0,41.84,13.94,47.75,32H31.93c6.25-19.19,26.46-32,48.09-32Zm88-208a38.92,38.92,0,0,1-23.37-7.83l55.54-55.54A38.94,38.94,0,0,1,432,200,40,40,0,0,1,392,240ZM288,267.53V163.88l-49.94-49.94a48,48,0,0,1,67.88-67.88L355.88,96H459.53Z"]
  },
      ZM = {
    prefix: "fal",
    iconName: "lamp-floor",
    icon: [384, 512, [], "e015", "M381.38,179.39l-68.57-160A32,32,0,0,0,283.39,0H100.61A32,32,0,0,0,71.19,19.39l-68.57,160A32,32,0,0,0,32,224H176V416H144c-35.09,0-68.12,23.22-78.53,55.2a30.16,30.16,0,0,0,4.47,27.35A32.63,32.63,0,0,0,96.25,512h191.5a32.63,32.63,0,0,0,26.31-13.45,30.18,30.18,0,0,0,4.47-27.36C308.06,439.2,275.06,416,240,416H208V224H352A32,32,0,0,0,381.38,179.39ZM240,448c21.59,0,41.84,13.94,47.75,32L95.91,480c6.25-19.19,26.47-32,48.09-32ZM32,192,100.61,32H283.39L352,192Z"]
  },
      UM = {
    prefix: "fal",
    iconName: "landmark",
    icon: [576, 512, [], "f66f", "M565.62 92.11L299.24 2.04C295.62.68 291.81 0 288 0s-7.62.68-11.24 2.04L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM544 128H32v-9.42L288 32l256 86.56V128zm24 352h-24v-64c0-17.67-16.37-32-36.57-32H496V192h-32v192h-96V192h-32v192h-96V192h-32v192h-96V192H80v192H68.57C48.37 384 32 398.33 32 416v64H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h560c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-56 0H64v-62.72c.7-.52 2.21-1.28 4.57-1.28h438.86c2.37 0 3.87.76 4.57 1.28V480z"]
  },
      BM = {
    prefix: "fal",
    iconName: "landmark-alt",
    icon: [512, 512, [], "f752", "M504 480h-24v-80c0-8.8-7.2-16-16-16h-16V256h24c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-24c0-100.5-77.6-183-176-191.2V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24.8C141.6 41 64 123.5 64 224H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h24v128H48c-8.8 0-16 7.2-16 16v80H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM256 64c88.2 0 160 71.8 160 160H96c0-88.2 71.8-160 160-160zm160 192v128h-80V256h80zm-112 0v128h-96V256h96zm-208 0h80v128H96V256zm352 224H64v-64h384v64z"]
  },
      RM = {
    prefix: "fal",
    iconName: "language",
    icon: [640, 512, [], "f1ab", "M616 96H24c-13.255 0-24 10.745-24 24v272c0 13.255 10.745 24 24 24h592c13.255 0 24-10.745 24-24V120c0-13.255-10.745-24-24-24zM304 384H32V128h272v256zm304 0H336V128h272v256zM91.088 352h10.34a12 12 0 0 0 11.397-8.243l13.508-40.973h67.335l13.508 40.973A12.001 12.001 0 0 0 218.573 352h10.339c8.276 0 14.067-8.18 11.319-15.985l-59.155-168A12 12 0 0 0 169.757 160h-19.513a12 12 0 0 0-11.319 8.014l-59.155 168C77.021 343.82 82.812 352 91.088 352zm60.663-128.991c3.787-10.818 8.113-29.747 8.113-29.747h.541s4.057 18.929 7.572 29.747l17.036 51.38h-50.298l17.036-51.38zM384 212v-8c0-6.627 5.373-12 12-12h68v-20c0-6.627 5.373-12 12-12h8c6.627 0 12 5.373 12 12v20h68c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-15.699c-7.505 24.802-23.432 50.942-44.896 74.842 10.013 9.083 20.475 17.265 30.924 24.086 5.312 3.467 6.987 10.475 3.84 15.982l-3.987 6.976c-3.429 6.001-11.188 7.844-16.993 4.091-13.145-8.5-25.396-18.237-36.56-28.5-11.744 10.454-24.506 20.146-37.992 28.68-5.761 3.646-13.409 1.698-16.791-4.221l-3.972-6.95c-3.197-5.594-1.379-12.672 4.058-16.129 11.382-7.237 22.22-15.428 32.24-24.227-10.026-11.272-18.671-22.562-25.687-33.033-3.833-5.721-2.11-13.48 3.803-17.01l6.867-4.099c5.469-3.264 12.55-1.701 16.092 3.592 6.379 9.531 13.719 18.947 21.677 27.953 15.017-16.935 26.721-34.905 33.549-52.033H396c-6.627 0-12-5.373-12-12z"]
  },
      YM = {
    prefix: "fal",
    iconName: "laptop",
    icon: [640, 512, [], "f109", "M624 368h-48V96c0-35.3-28.72-64-64-64H128c-35.28 0-64 28.7-64 64v272H16c-8.84 0-16 7.16-16 16v48c0 44.11 35.88 80 80 80h480c44.12 0 80-35.89 80-80v-48c0-8.84-7.16-16-16-16zM96 96c0-17.67 14.33-32 32-32h384c17.67 0 32 14.33 32 32v272H391.13c-4.06 0-7.02 3.13-7.92 7.09C379.98 389.35 367.23 400 352 400h-64c-15.23 0-27.98-10.65-31.21-24.91-.9-3.96-3.86-7.09-7.92-7.09H96V96zm512 336c0 26.47-21.53 48-48 48H80c-26.47 0-48-21.53-48-48v-32h194.75c6.59 18.62 24.38 32 45.25 32h96c20.88 0 38.66-13.38 45.25-32H608v32z"]
  },
      PM = {
    prefix: "fal",
    iconName: "laptop-code",
    icon: [640, 512, [], "f5fc", "M266.34 277.65l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31L230.62 208l47.03-47.03c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-64 64c-3.12 3.12-3.12 8.19 0 11.31l64 64c3.13 3.12 8.19 3.12 11.31-.01zm96-11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l64-64c3.12-3.12 3.12-8.19 0-11.31l-64-64c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31L409.38 208l-47.03 47.03a7.994 7.994 0 0 0-.01 11.31zM624 368h-48V96c0-35.3-28.72-64-64-64H128c-35.28 0-64 28.7-64 64v272H16c-8.84 0-16 7.16-16 16v48c0 44.11 35.88 80 80 80h480c44.12 0 80-35.89 80-80v-48c0-8.84-7.16-16-16-16zM96 96c0-17.67 14.33-32 32-32h384c17.67 0 32 14.33 32 32v272H391.13c-4.06 0-7.02 3.13-7.92 7.09C379.98 389.35 367.23 400 352 400h-64c-15.23 0-27.98-10.65-31.21-24.91-.9-3.96-3.86-7.09-7.92-7.09H96V96zm512 336c0 26.47-21.53 48-48 48H80c-26.47 0-48-21.53-48-48v-32h194.75c6.59 18.62 24.38 32 45.25 32h96c20.88 0 38.66-13.38 45.25-32H608v32z"]
  },
      FM = {
    prefix: "fal",
    iconName: "laptop-house",
    icon: [640, 512, [], "e066", "M624,416H592V288c0-17.68-12.9-32-28.81-32H332.73c-15.91,0-28.8,14.32-28.8,32V416h-32a16,16,0,0,0-16,16v37.34A42.82,42.82,0,0,0,298.53,512H597.39A42.83,42.83,0,0,0,640,469.33V432A16,16,0,0,0,624,416ZM335.93,288H560V416h-224ZM608,469.26A10.76,10.76,0,0,1,597.39,480H298.64a10.78,10.78,0,0,1-10.72-10.67V448H608ZM197.28,160A21.41,21.41,0,0,0,175.9,181.3v85.35A21.42,21.42,0,0,0,197.28,288h74.64a64.32,64.32,0,0,1,32-56V181.3A21.44,21.44,0,0,0,282.59,160Zm74.64,96h-64V192h64Zm-176,112V168a18.8,18.8,0,0,0-.81-4L239.91,37.22l144,126V224h32V191.25L453.34,224h20a15.71,15.71,0,0,0,6.2-12.33A18.31,18.31,0,0,0,474.49,200L416,148.72V48a16,16,0,0,0-32,0v72.75L250.45,4a16,16,0,0,0-21.07,0L5.33,200A18.24,18.24,0,0,0,0,211.89a16,16,0,0,0,16,16,18.62,18.62,0,0,0,10.4-3.83l37.47-32.82V368a48.1,48.1,0,0,0,48,48h112V384h-112A16,16,0,0,1,95.88,368Z"]
  },
      WM = {
    prefix: "fal",
    iconName: "laptop-medical",
    icon: [640, 512, [], "f812", "M624 368h-48V96a64.07 64.07 0 0 0-64-64H128a64.07 64.07 0 0 0-64 64v272H16a16 16 0 0 0-16 16v48a80.09 80.09 0 0 0 80 80h480a80.09 80.09 0 0 0 80-80v-48a16 16 0 0 0-16-16zM96 96a32 32 0 0 1 32-32h384a32 32 0 0 1 32 32v272H391.13c-4.06 0-7 3.13-7.92 7.09A32 32 0 0 1 352 400h-64a32 32 0 0 1-31.21-24.91c-.9-4-3.86-7.09-7.92-7.09H96zm512 336a48.05 48.05 0 0 1-48 48H80a48.05 48.05 0 0 1-48-48v-32h194.75A48.06 48.06 0 0 0 272 432h96a48 48 0 0 0 45.25-32H608zM288 312a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h56z"]
  },
      GM = {
    prefix: "fal",
    iconName: "lasso",
    icon: [576, 512, [], "f8c8", "M288 0C126.5 0 0 77.31 0 176c0 46.78 29.06 90.62 81.81 123.45 4.54 2.82 9.51 5.58 14.7 8.34C93.28 333.29 117.4 352 144 352a55.73 55.73 0 0 0 19.65-3.58c17.26 15.75 29.07 36.41 28.32 67.77C191.11 451.85 161 480 125.38 480H40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h84.61c54.33 0 99.47-44.5 99.39-98.83 0-29.05-8.41-51.28-21.06-68.84A464.82 464.82 0 0 0 288 352c161.5 0 288-77.31 288-176S449.5 0 288 0zm0 320a422.74 422.74 0 0 1-96.36-11c-1.86-20.67-22.35-37-47.64-37a53.72 53.72 0 0 0-29.64 8.76c-5.36-2.8-11-5.6-15.64-8.46C55.69 245.52 32 211.33 32 176 32 97.94 149.22 32 288 32s256 65.94 256 144-117.22 144-256 144z"]
  },
      qM = {
    prefix: "fal",
    iconName: "laugh",
    icon: [496, 512, [], "f599", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm152.7 400.7c-19.8 19.8-43 35.4-68.7 46.3-26.6 11.3-54.9 17-84.1 17s-57.5-5.7-84.1-17c-25.7-10.9-48.8-26.5-68.7-46.3-19.8-19.8-35.4-43-46.3-68.7-11.3-26.6-17-54.9-17-84.1s5.7-57.5 17-84.1c10.9-25.7 26.5-48.8 46.3-68.7 19.8-19.8 43-35.4 68.7-46.3 26.6-11.3 54.9-17 84.1-17s57.5 5.7 84.1 17c25.7 10.9 48.8 26.5 68.7 46.3 19.8 19.8 35.4 43 46.3 68.7 11.3 26.6 17 54.9 17 84.1s-5.7 57.5-17 84.1c-10.8 25.8-26.4 48.9-46.3 68.7zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm215 64H113c-9.6 0-17.1 8.4-15.9 18 8.8 71 69.4 126 142.9 126h16c73.4 0 134-55 142.9-126 1.2-9.6-6.3-18-15.9-18zM256 400h-16c-50.2 0-93.5-33.3-107.4-80h230.8c-13.9 46.7-57.2 80-107.4 80z"]
  },
      JM = {
    prefix: "fal",
    iconName: "laugh-beam",
    icon: [496, 512, [], "f59a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm152.7 400.7c-19.8 19.8-43 35.4-68.7 46.3-26.6 11.3-54.9 17-84.1 17s-57.5-5.7-84.1-17c-25.7-10.9-48.8-26.5-68.7-46.3-19.8-19.8-35.4-43-46.3-68.7-11.3-26.6-17-54.9-17-84.1s5.7-57.5 17-84.1c10.9-25.7 26.5-48.8 46.3-68.7 19.8-19.8 43-35.4 68.7-46.3 26.6-11.3 54.9-17 84.1-17s57.5 5.7 84.1 17c25.7 10.9 48.8 26.5 68.7 46.3 19.8 19.8 35.4 43 46.3 68.7 11.3 26.6 17 54.9 17 84.1s-5.7 57.5-17 84.1c-10.8 25.8-26.4 48.9-46.3 68.7zM287 227.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.6 11 11.9 15.1 4.5zm-160 0l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM383 288H113c-9.6 0-17.1 8.4-15.9 18 8.8 71 69.4 126 142.9 126h16c73.4 0 134-55 142.9-126 1.2-9.6-6.3-18-15.9-18zM256 400h-16c-50.2 0-93.5-33.3-107.4-80h230.8c-13.9 46.7-57.2 80-107.4 80z"]
  },
      KM = {
    prefix: "fal",
    iconName: "laugh-squint",
    icon: [496, 512, [], "f59b", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm152.7 400.7c-19.8 19.8-43 35.4-68.7 46.3-26.6 11.3-54.9 17-84.1 17s-57.5-5.7-84.1-17c-25.7-10.9-48.8-26.5-68.7-46.3-19.8-19.8-35.4-43-46.3-68.7-11.3-26.6-17-54.9-17-84.1s5.7-57.5 17-84.1c10.9-25.7 26.5-48.8 46.3-68.7 19.8-19.8 43-35.4 68.7-46.3 26.6-11.3 54.9-17 84.1-17s57.5 5.7 84.1 17c25.7 10.9 48.8 26.5 68.7 46.3 19.8 19.8 35.4 43 46.3 68.7 11.3 26.6 17 54.9 17 84.1s-5.7 57.5-17 84.1c-10.8 25.8-26.4 48.9-46.3 68.7zM281.8 206.3l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.7 4.7-7.7 15.9 0 20.6zm-147.6 48l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM383 288H113c-9.6 0-17.1 8.4-15.9 18 8.8 71 69.4 126 142.9 126h16c73.4 0 134-55 142.9-126 1.2-9.6-6.3-18-15.9-18zM256 400h-16c-50.2 0-93.5-33.3-107.4-80h230.8c-13.9 46.7-57.2 80-107.4 80z"]
  },
      XM = {
    prefix: "fal",
    iconName: "laugh-wink",
    icon: [496, 512, [], "f59c", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm152.7 400.7c-19.8 19.8-43 35.4-68.7 46.3-26.6 11.3-54.9 17-84.1 17s-57.5-5.7-84.1-17c-25.7-10.9-48.8-26.5-68.7-46.3s-35.4-43-46.3-68.7c-11.3-26.6-17-54.9-17-84.1s5.7-57.5 17-84.1c10.9-25.7 26.5-48.8 46.3-68.7s43-35.4 68.7-46.3c26.6-11.3 54.9-17 84.1-17s57.5 5.7 84.1 17c25.7 10.9 48.8 26.5 68.7 46.3s35.4 43 46.3 68.7c11.3 26.6 17 54.9 17 84.1s-5.7 57.5-17 84.1c-10.8 25.8-26.4 48.9-46.3 68.7zM288 217l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-4-25.2-34.2-42.1-59.9-42.1S272 181 268 206.2c-1.6 11.1 11.6 18.2 20 10.8zm-120 7c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm215 64H113c-9.6 0-17.1 8.4-15.9 18 8.8 71 69.4 126 142.9 126h16c73.4 0 134-55 142.9-126 1.2-9.6-6.3-18-15.9-18zM256 400h-16c-50.2 0-93.5-33.3-107.4-80h230.8c-13.9 46.7-57.2 80-107.4 80z"]
  },
      _M = {
    prefix: "fal",
    iconName: "layer-group",
    icon: [512, 512, [], "f5fd", "M512 256.01c0-9.98-5.81-18.94-14.77-22.81l-99.74-43.27 99.7-43.26c9-3.89 14.81-12.84 14.81-22.81s-5.81-18.92-14.77-22.79L271.94 3.33c-10.1-4.44-21.71-4.45-31.87-.02L14.81 101.06C5.81 104.95 0 113.9 0 123.87s5.81 18.92 14.77 22.79l99.73 43.28-99.7 43.26C5.81 237.08 0 246.03 0 256.01c0 9.97 5.81 18.92 14.77 22.79l99.72 43.26-99.69 43.25C5.81 369.21 0 378.16 0 388.14c0 9.97 5.81 18.92 14.77 22.79l225.32 97.76a40.066 40.066 0 0 0 15.9 3.31c5.42 0 10.84-1.1 15.9-3.31l225.29-97.74c9-3.89 14.81-12.84 14.81-22.81 0-9.98-5.81-18.94-14.77-22.81l-99.72-43.26 99.69-43.25c9-3.89 14.81-12.84 14.81-22.81zM45.23 123.87l208.03-90.26.03-.02c1.74-.71 3.65-.76 5.45.02l208.03 90.26-208.03 90.27c-1.81.77-3.74.77-5.48 0L45.23 123.87zm421.54 264.27L258.74 478.4c-1.81.77-3.74.77-5.48 0L45.23 388.13l110.76-48.06 84.11 36.49a40.066 40.066 0 0 0 15.9 3.31c5.42 0 10.84-1.1 15.9-3.31l84.11-36.49 110.76 48.07zm-208.03-41.87c-1.81.77-3.74.77-5.48 0L45.23 256 156 207.94l84.1 36.5a40.066 40.066 0 0 0 15.9 3.31c5.42 0 10.84-1.1 15.9-3.31l84.1-36.49 110.77 48.07-208.03 90.25z"]
  },
      $M = {
    prefix: "fal",
    iconName: "layer-minus",
    icon: [512, 512, [], "f5fe", "M512 253.21c0-10.08-5.81-19.13-14.77-23.04L271.9 131.33c-10.06-4.43-21.74-4.43-31.81 0L14.81 230.15C5.81 234.08 0 243.13 0 253.21c0 10.08 5.81 19.13 14.77 23.04L114.5 320l-99.7 43.73C5.81 367.65 0 376.7 0 386.79c0 10.08 5.81 19.13 14.77 23.04l225.32 98.82c5.06 2.22 10.48 3.34 15.9 3.34s10.84-1.11 15.9-3.34l225.29-98.81c9-3.93 14.81-12.98 14.81-23.06 0-10.09-5.81-19.14-14.77-23.06l-99.72-43.75 99.69-43.73c9-3.91 14.81-12.96 14.81-23.03zm-45.19 133.57l-208.06 91.26c-1.81.78-3.74.78-5.48 0L45.23 386.78 156 338.2l84.1 36.89c5.06 2.22 10.48 3.34 15.9 3.34s10.84-1.11 15.9-3.34l84.12-36.9 110.79 48.59zm-208.07-42.31c-1.81.78-3.74.78-5.48 0L45.23 253.21l208.03-91.26c1.81-.78 3.74-.78 5.48 0l208.03 91.26-208.03 91.26zM504 64H296c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8V72c0-4.42-3.58-8-8-8z"]
  },
      cp = {
    prefix: "fal",
    iconName: "layer-plus",
    icon: [512, 512, [], "f5ff", "M504 96h-88V8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v88h-88c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h88v88c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-88h88c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-6.77 270.71l-99.72-42.87 99.72-42.87c8.35-3.6 12.19-13.23 8.58-21.52-3.65-8.29-13.32-12.13-21.74-8.48l-225.32 96.86c-1.81.77-3.74.77-5.48 0L45.23 258.4l193.45-83.16c8.35-3.59 12.19-13.23 8.58-21.52-3.65-8.28-13.26-12.13-21.74-8.48L14.81 235.81C5.81 239.66 0 248.52 0 258.4c0 9.87 5.81 18.74 14.77 22.58l99.73 42.87-99.7 42.85C5.81 370.55 0 379.42 0 389.31c0 9.87 5.81 18.74 14.77 22.58l225.32 96.84c5.06 2.17 10.48 3.28 15.9 3.28s10.84-1.09 15.9-3.28l225.29-96.83c9-3.85 14.81-12.72 14.81-22.59.01-9.89-5.8-18.76-14.76-22.6zM258.74 478.72c-1.81.77-3.74.77-5.48 0L45.23 389.29 156 341.68l84.1 36.15c5.06 2.17 10.48 3.28 15.9 3.28s10.84-1.09 15.9-3.28l84.12-36.16 110.78 47.62-208.06 89.43z"]
  },
      ep = {
    prefix: "fal",
    iconName: "leaf",
    icon: [576, 512, [], "f06c", "M546.2 9.7c-2.9-6.5-8.6-9.7-14.3-9.7-5.3 0-10.7 2.8-14 8.5C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 20.9 3.4 40.9 9.6 59.7C29.3 413 1.4 489.4.9 490.7c-2.9 8.3 1.5 17.5 9.8 20.4 7.9 2.8 17.4-1.1 20.4-9.8.4-1.2 23.9-65.1 87.6-122.7C151.1 438.9 214.7 480 288 480c6.9 0 13.7-.4 20.4-1.1C465.5 467.5 576 326.8 576 154.3c0-50.2-10.8-102.2-29.8-144.6zM305 447.1c-5.9.6-11.6.9-17 .9-63.3 0-117.6-37.2-143.5-90.6C196.3 319 268.6 288 368 288c8.8 0 16-7.2 16-16s-7.2-16-16-16c-102.8 0-179 31-234.8 70.4-3.1-12.4-5.2-25.1-5.2-38.4 0-88.2 71.8-160 160-160h80c63.3 0 121-28.4 159.7-77.2 10.5 32.3 16.3 68.7 16.3 103.5 0 159.6-100.1 282.7-239 292.8z"]
  },
      ap = {
    prefix: "fal",
    iconName: "leaf-heart",
    icon: [576, 512, [], "f4cb", "M426.2 205.2c-13.9-11.6-47.7-28.5-90.2 14.5-42.6-43-76.4-26.1-90.2-14.5-27.5 23-28.9 64.2-4.3 89.1l84.7 85.6c5.4 5.5 14.3 5.6 19.8 0l84.7-85.6c24.5-24.9 23-66.1-4.5-89.1zm-18.4 66.6L336 344.4l-71.8-72.6c-10.2-10.3-12.3-30 2.1-42 13.7-11.5 31.2-3.4 38.4 3.7l31.4 31.7 31.4-31.7c7.1-7.2 24.6-15.2 38.4-3.7 14.2 12 12.2 31.6 1.9 42zM546.2 9.7c-2.9-6.5-8.6-9.7-14.3-9.7-5.3 0-10.7 2.8-14 8.5C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 20.7 3.4 40.6 9.4 59.2C29.3 412.2 2 487.5.9 490.7c-2.9 8.3 1.5 17.4 9.8 20.4 7.6 2.7 17.3-.8 20.4-9.8.2-.7 24.2-65.4 87.5-122.9 15.5 29 75.2 112.6 189.8 100.5C465.5 467.6 576 326.8 576 154.3c0-50.2-10.8-102.2-29.8-144.6zM305 447.1c-97 10.2-177-66.4-177-159.1 0-88.2 71.8-160 160-160h80c63.3 0 121-28.4 159.7-77.2 10.5 32.3 16.3 68.7 16.3 103.5 0 159.6-100.1 282.7-239 292.8z"]
  },
      np = {
    prefix: "fal",
    iconName: "leaf-maple",
    icon: [512, 512, [], "f6f6", "M496.06 163.47l-27.34-16.41 8.44-75.97c2.14-19.5-13.61-38.41-36.25-36.27l-75.97 8.45-16.41-27.34C342.62 6.11 332.28.16 320.81 0c-10.59-.02-21.97 5.53-28.12 15.2l-42.91 67.45c-8.33-22.52-32.9-24.41-42.53-19.2l-13.81 7.41-35.09-39.72c-6.17-7.71-15.42-12.31-25.62-12.31-10.03 0-19.37 4.47-25.16 11.7L72 70.86l-13.81-7.41c-18.48-9.99-50.1 8.62-43.72 37.31l29.41 142.69-24 10.3c-26.45 11.34-26.45 49 0 60.34l108.79 46.62L4.69 484.69c-6.25 6.25-6.25 16.38 0 22.62C7.81 510.44 11.91 512 16 512s8.19-1.56 11.31-4.69l123.98-123.98 46.62 108.74c5.19 12.18 17.11 19.92 30.19 19.92 13.12 0 24.97-7.8 30.19-19.91l10.25-23.98L411 497.5c23.83 5.29 47.82-17.22 38.97-40l-8.84-17.5 39.75-35.09c16.65-13.35 16.07-38.02.34-50.97l-40.09-35.38 7.41-13.8c6.34-11.73 1.1-35.19-19.22-42.52l67.5-42.94c20.67-13.17 20.05-43.34-.76-55.83zM342.94 279.28c-15.25 9.71-5.02 33.47 12.56 29l62.78-14.8-17.34 32.3 60.43 53.51-60.43 53.49 17.78 33.12-169.32-34.42-22.06 48.02-51.68-120.54L331.3 203.32c6.25-6.25 6.25-16.38 0-22.62-6.25-6.25-16.37-6.25-22.62 0L153.16 336.21 32.5 283.16l48-20.58L46.87 93.69l32.31 17.36 54.66-59.33 52.41 59.33 33.41-17.95.16.47-16.09 62.94c-4.45 17.53 19.18 27.83 29 12.56L321.1 32.41l26.97 44.94 97.28-9.78-10.69 96.37 44.97 28.38-136.69 86.96z"]
  },
      tp = {
    prefix: "fal",
    iconName: "leaf-oak",
    icon: [512, 512, [], "f6f7", "M511.52 207.17c-4.14-37.69-37.21-54.28-44.63-58.83 14.26-48.71-4.46-75.76-16.31-86.93-11.18-11.85-38.21-30.57-86.93-16.31-4.55-7.41-21.14-40.48-58.83-44.63-46.25-5.04-64.93 30.95-85.61 67.47-27.94-22.58-51.06-18.94-58.25-17.53-73.71 14.56-55.51 117.73-54.29 129.09-34.93-9.76-74.01 11.67-74.01 65.41 0 38.62 28.68 72.88 21.39 92.19-13.25 36.77-11.6 70.13 3.85 94.38L4.69 484.69c-6.25 6.25-6.25 16.38 0 22.62C7.81 510.44 11.91 512 16 512s8.19-1.56 11.31-4.69l53.21-53.21c24.24 15.45 57.61 17.09 94.38 3.85 19.31-7.29 53.57 21.39 92.19 21.39 53.74 0 75.17-39.08 65.41-74.01 11.37 1.23 114.53 19.42 129.09-54.28 1.42-7.19 5.05-30.31-17.53-58.26 36.51-20.69 72.51-39.37 67.46-85.62zm-41.18 30.61c-5.96 6.43-12.2 10.09-75.13 45.99 23.41 28.45 22.54 27.29 25.54 31.12 21.12 27.08 4.55 45.26-10.47 53.84-24 13.73-40.15 8.24-139.22-1.97 0 0 26.31 37.53 27.06 38.86 16.36 28.49-10.66 48.05-44.53 40.27-15.59-3.58-31.98-12.57-50-17.59-37.01-10.42-70.39 16.78-99.94 2.68l227.66-227.66c6.25-6.25 6.25-16.38 0-22.62-6.25-6.25-16.38-6.25-22.63 0L81.02 408.35c-14.09-29.55 13.1-62.93 2.68-99.94-5.02-18.02-14-34.41-17.59-50-7.79-33.87 11.77-60.89 40.26-44.53 1.33.75 38.86 27.06 38.86 27.06-10.21-99.07-15.7-115.21-1.96-139.22 8.58-15.03 26.76-31.59 53.84-10.47 3.84 2.99 2.68 2.12 31.13 25.53 35.9-62.92 39.56-69.16 45.99-75.12 19.92-18.42 48.37-9 59.66 17.06 6.3 14.35 22.94 21.65 38.73 17.1 24.38-7.15 43.5-4.29 55.35 8.22 12.51 11.85 15.37 30.97 8.22 55.34-4.56 15.8 2.75 32.44 17.09 38.73 26.06 11.3 35.48 39.75 17.06 59.67z"]
  },
      rp = {
    prefix: "fal",
    iconName: "lemon",
    icon: [512, 512, [], "f094", "M489.038 22.963C473.784 7.709 454.948 0 437.954 0c-8.734 0-16.98 2.035-24.007 6.129-58.912 34.315-181.245-53.083-321.073 86.745C-46.948 232.697 40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.08 23.08 54.378 28.899 75.095 16.832 58.902-34.31 181.245 53.081 321.068-86.743C558.949 279.304 471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM478.22 81.95c-44.546 76.475 49.666 183.163-81.721 314.55-131.434 131.434-238.029 37.148-314.547 81.72-20.528 11.956-60.128-27.64-48.171-48.167 44.547-76.475-49.667-183.163 81.721-314.55C246.942-15.939 353.523 78.359 430.053 33.78c19.978-11.637 60.439 27.102 48.167 48.17zm-218.749 29.669c-31.89 7.086-64.973 26.511-93.157 54.694-28.184 28.185-47.608 61.268-54.694 93.157-1.657 7.457-8.271 12.533-15.604 12.533-1.149 0-2.316-.125-3.485-.385-8.626-1.917-14.065-10.464-12.148-19.09 8.391-37.756 30.872-76.41 63.306-108.843 32.433-32.434 71.087-54.915 108.843-63.306 8.628-1.919 17.173 3.522 19.09 12.148s-3.525 17.175-12.151 19.092z"]
  },
      ip = {
    prefix: "fal",
    iconName: "less-than",
    icon: [320, 512, [], "f536", "M0 261.83c0 3.02 1.7 5.78 4.4 7.14l289.73 146.18c3.95 1.98 8.76.37 10.73-3.58l14.29-28.62c1.97-3.95.37-8.75-3.58-10.73L83.13 256l232.44-116.22c3.95-1.97 5.55-6.78 3.58-10.73l-14.29-28.62c-1.97-3.95-6.78-5.56-10.73-3.58L4.42 241.77A7.985 7.985 0 0 0 0 248.92v12.91z"]
  },
      op = {
    prefix: "fal",
    iconName: "less-than-equal",
    icon: [384, 512, [], "f537", "M347.58 308.22L115.13 192 347.58 75.78c3.95-1.97 5.55-6.78 3.58-10.73l-14.29-28.62a7.986 7.986 0 0 0-10.73-3.58L36.4 179.02a7.992 7.992 0 0 0-4.4 7.14v12.91c0 3.03 1.71 5.8 4.42 7.15l289.71 144.92c3.95 1.98 8.76.38 10.73-3.58l14.29-28.62c1.98-3.94.38-8.74-3.57-10.72zM0 440v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8z"]
  },
      lp = {
    prefix: "fal",
    iconName: "level-down",
    icon: [256, 512, [], "f149", "M252.478 408.503l-99.974 99.975c-4.697 4.697-12.311 4.697-17.008 0l-99.974-99.975c-4.696-4.697-4.696-12.311 0-17.008l8.503-8.503c4.697-4.697 12.311-4.697 17.007 0L126 447.959V36H24.024a11.996 11.996 0 0 1-8.485-3.515l-12-12C-4.021 12.926 1.333 0 12.024 0H138c13.255 0 24 10.745 24 24v423.959l64.967-64.966c4.697-4.697 12.311-4.697 17.007 0l8.503 8.503c4.697 4.696 4.697 12.31.001 17.007z"]
  },
      fp = {
    prefix: "fal",
    iconName: "level-down-alt",
    icon: [256, 512, [], "f3be", "M216.01 384h-53.986V24c0-13.255-10.745-24-24-24h-118C9.333 0 3.979 12.926 11.539 20.485l12 12A12 12 0 0 0 32.024 36h94v348H72.037c-29.564 0-43.064 36.535-21.26 55.917l71.987 64c12.125 10.777 30.395 10.777 42.52 0l71.986-64C259.082 420.528 245.562 384 216.01 384zm.014 32l-72 64-72-64h144z"]
  },
      sp = {
    prefix: "fal",
    iconName: "level-up",
    icon: [256, 512, [], "f148", "M252.478 103.497L152.504 3.522c-4.697-4.697-12.311-4.697-17.008 0l-99.974 99.975c-4.696 4.697-4.696 12.311 0 17.008l8.503 8.503c4.697 4.697 12.311 4.697 17.007 0L126 64.041V476H24.024a11.996 11.996 0 0 0-8.485 3.515l-12 12C-4.021 499.074 1.333 512 12.024 512H138c13.255 0 24-10.745 24-24V64.041l64.967 64.966c4.697 4.697 12.311 4.697 17.007 0l8.503-8.503c4.697-4.696 4.697-12.31.001-17.007z"]
  },
      up = {
    prefix: "fal",
    iconName: "level-up-alt",
    icon: [256, 512, [], "f3bf", "M237.27 72.083l-71.986-64c-12.125-10.777-30.395-10.777-42.52 0l-71.987 64C28.973 91.465 42.473 128 72.037 128h53.987v348h-94a11.996 11.996 0 0 0-8.485 3.515l-12 12C3.979 499.074 9.333 512 20.024 512h118c13.255 0 24-10.745 24-24V128h53.986c29.552 0 43.072-36.528 21.26-55.917zM72.024 96l72-64 72 64h-144z"]
  },
      hp = {
    prefix: "fal",
    iconName: "life-ring",
    icon: [512, 512, [], "f1cd", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm168.766 113.176l-62.885 62.885a128.711 128.711 0 0 0-33.941-33.941l62.885-62.885a217.323 217.323 0 0 1 33.941 33.941zM256 352c-52.935 0-96-43.065-96-96s43.065-96 96-96 96 43.065 96 96-43.065 96-96 96zM363.952 68.853l-66.14 66.14c-26.99-9.325-56.618-9.33-83.624 0l-66.139-66.14c66.716-38.524 149.23-38.499 215.903 0zM121.176 87.234l62.885 62.885a128.711 128.711 0 0 0-33.941 33.941l-62.885-62.885a217.323 217.323 0 0 1 33.941-33.941zm-52.323 60.814l66.139 66.14c-9.325 26.99-9.33 56.618 0 83.624l-66.139 66.14c-38.523-66.715-38.5-149.229 0-215.904zm18.381 242.776l62.885-62.885a128.711 128.711 0 0 0 33.941 33.941l-62.885 62.885a217.366 217.366 0 0 1-33.941-33.941zm60.814 52.323l66.139-66.14c26.99 9.325 56.618 9.33 83.624 0l66.14 66.14c-66.716 38.524-149.23 38.499-215.903 0zm242.776-18.381l-62.885-62.885a128.711 128.711 0 0 0 33.941-33.941l62.885 62.885a217.323 217.323 0 0 1-33.941 33.941zm52.323-60.814l-66.14-66.14c9.325-26.99 9.33-56.618 0-83.624l66.14-66.14c38.523 66.715 38.5 149.229 0 215.904z"]
  },
      mp = {
    prefix: "fal",
    iconName: "light-ceiling",
    icon: [512, 512, [], "e016", "M272,192.74V0H240V192.74C117.11,200.21,17.4,292.62.32,411.64-2.43,430.83,13,448,32.56,448H177.62a80,80,0,0,0,156.76,0H479.44c19.56,0,35-17.18,32.24-36.37C494.6,292.62,394.89,200.21,272,192.74ZM256,480a48,48,0,0,1-45.24-32h90.48A48,48,0,0,1,256,480ZM32,416.18C47.72,306.62,144,224,256,224s208.28,82.61,223.44,192Z"]
  },
      vp = {
    prefix: "fal",
    iconName: "light-switch",
    icon: [384, 512, [], "e017", "M256,96H128a32,32,0,0,0-32,32V384a32,32,0,0,0,32,32H256a32,32,0,0,0,32-32V128A32,32,0,0,0,256,96Zm0,288H128V272H256Zm0-144H128V128H256ZM320,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H320a64,64,0,0,0,64-64V64A64,64,0,0,0,320,0Zm32,448a32,32,0,0,1-32,32H214.38a23.7,23.7,0,0,0,1.61-8,24,24,0,0,0-48,0,23.47,23.47,0,0,0,1.62,8H64a32,32,0,0,1-32-32V64A32,32,0,0,1,64,32H169.61A23.47,23.47,0,0,0,168,40a24,24,0,0,0,48,0,23.7,23.7,0,0,0-1.61-8H320a32,32,0,0,1,32,32Z"]
  },
      dp = {
    prefix: "fal",
    iconName: "light-switch-off",
    icon: [384, 512, [], "e018", "M256,96H128a32,32,0,0,0-32,32V384a32,32,0,0,0,32,32H256a32,32,0,0,0,32-32V128A32,32,0,0,0,256,96Zm0,288H128V272H256Zm0-144H128V128H256Zm-32,80H160v32h64ZM320,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H320a64,64,0,0,0,64-64V64A64,64,0,0,0,320,0Zm32,448a32,32,0,0,1-32,32H214.38a23.7,23.7,0,0,0,1.61-8,24,24,0,0,0-48,0,23.47,23.47,0,0,0,1.62,8H64a32,32,0,0,1-32-32V64A32,32,0,0,1,64,32H169.61A23.47,23.47,0,0,0,168,40a24,24,0,0,0,48,0,23.7,23.7,0,0,0-1.61-8H320a32,32,0,0,1,32,32Z"]
  },
      Mp = {
    prefix: "fal",
    iconName: "light-switch-on",
    icon: [384, 512, [], "e019", "M224,160H160v32h64ZM320,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H320a64,64,0,0,0,64-64V64A64,64,0,0,0,320,0Zm32,448a32,32,0,0,1-32,32H214.39a23.47,23.47,0,0,0,1.62-8,24,24,0,0,0-48,0,23.7,23.7,0,0,0,1.61,8H64a32,32,0,0,1-32-32V64A32,32,0,0,1,64,32H169.62A23.7,23.7,0,0,0,168,40a24,24,0,0,0,48,0,23.47,23.47,0,0,0-1.62-8H320a32,32,0,0,1,32,32ZM256,96H128a32,32,0,0,0-32,32V384a32,32,0,0,0,32,32H256a32,32,0,0,0,32-32V128A32,32,0,0,0,256,96Zm0,288H128V272H256Zm0-144H128V128H256Z"]
  },
      pp = {
    prefix: "fal",
    iconName: "lightbulb",
    icon: [352, 512, [], "f0eb", "M176 0C73.05 0-.12 83.54 0 176.24c.06 44.28 16.5 84.67 43.56 115.54C69.21 321.03 93.85 368.68 96 384l.06 75.18c0 3.15.94 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84L256 384c2.26-15.72 26.99-63.19 52.44-92.22C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0zm47.94 454.31L206.85 480h-61.71l-17.09-25.69-.01-6.31h95.9v6.31zm.04-38.31h-95.97l-.07-32h96.08l-.04 32zm60.4-145.32c-13.99 15.96-36.33 48.1-50.58 81.31H118.21c-14.26-33.22-36.59-65.35-50.58-81.31C44.5 244.3 32.13 210.85 32.05 176 31.87 99.01 92.43 32 176 32c79.4 0 144 64.6 144 144 0 34.85-12.65 68.48-35.62 94.68zM176 64c-61.75 0-112 50.25-112 112 0 8.84 7.16 16 16 16s16-7.16 16-16c0-44.11 35.88-80 80-80 8.84 0 16-7.16 16-16s-7.16-16-16-16z"]
  },
      zp = {
    prefix: "fal",
    iconName: "lightbulb-dollar",
    icon: [352, 512, [], "f670", "M203.09 183.42l-45-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V96c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.62.63-42.67 20.55-42.67 45.07 0 19.97 12.98 37.81 31.58 43.39l45 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.11c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V288c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.62-.63 42.67-20.54 42.67-45.07 0-19.97-12.98-37.81-31.58-43.39zM176 0C73.05 0-.12 83.54 0 176.24c.06 44.28 16.5 84.67 43.56 115.54C69.21 321.03 93.85 368.68 96 384l.06 75.18c0 3.15.94 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84L256 384c2.26-15.72 26.99-63.19 52.44-92.22C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0zm47.94 454.31L206.85 480h-61.71l-17.09-25.69-.01-6.31h95.9v6.31zm.04-38.31h-95.97l-.07-32h96.08l-.04 32zm60.4-145.32c-13.99 15.96-36.33 48.1-50.58 81.31H118.21c-14.26-33.22-36.59-65.35-50.58-81.31C44.5 244.3 32.13 210.85 32.05 176 31.87 99.01 92.43 32 176 32c79.4 0 144 64.6 144 144 0 34.85-12.65 68.48-35.62 94.68z"]
  },
      Cp = {
    prefix: "fal",
    iconName: "lightbulb-exclamation",
    icon: [352, 512, [], "f671", "M176 248c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm-16.47-31.5c.26 4.22 3.76 7.5 7.98 7.5h16.97a8 8 0 0 0 7.98-7.5l7-112c.29-4.61-3.37-8.5-7.98-8.5h-30.97c-4.61 0-8.27 3.89-7.98 8.5l7 112zM176 0C73.05 0-.12 83.54 0 176.24c.06 44.28 16.5 84.67 43.56 115.54C69.21 321.03 93.85 368.68 96 384l.06 75.18c0 3.15.94 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84L256 384c2.26-15.72 26.99-63.19 52.44-92.22C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0zm47.94 454.31L206.85 480h-61.71l-17.09-25.69-.01-6.31h95.9v6.31zm.04-38.31h-95.97l-.07-32h96.08l-.04 32zm60.4-145.32c-13.99 15.96-36.33 48.1-50.58 81.31H118.21c-14.26-33.22-36.59-65.35-50.58-81.31C44.5 244.3 32.13 210.85 32.05 176 31.87 99.01 92.43 32 176 32c79.4 0 144 64.6 144 144 0 34.85-12.65 68.48-35.62 94.68z"]
  },
      Lp = {
    prefix: "fal",
    iconName: "lightbulb-on",
    icon: [640, 512, [], "f672", "M320,64A112.14,112.14,0,0,0,208,176a16,16,0,0,0,32,0,80.09,80.09,0,0,1,80-80,16,16,0,0,0,0-32Zm0-64C217.06,0,143.88,83.55,144,176.23a175,175,0,0,0,43.56,115.55C213.22,321,237.84,368.69,240,384l.06,75.19a15.88,15.88,0,0,0,2.69,8.83l24.5,36.84A16,16,0,0,0,280.56,512h78.85a16,16,0,0,0,13.34-7.14L397.25,468a16.17,16.17,0,0,0,2.69-8.83L400,384c2.25-15.72,27-63.19,52.44-92.22A175.9,175.9,0,0,0,320,0Zm47.94,454.31L350.84,480H289.12l-17.06-25.69,0-6.31h95.91ZM368,416H272l-.06-32H368Zm60.41-145.31c-14,15.95-36.32,48.09-50.57,81.29H262.22c-14.28-33.21-36.6-65.34-50.6-81.29A143.47,143.47,0,0,1,176.06,176C175.88,99,236.44,32,320,32c79.41,0,144,64.59,144,144A143.69,143.69,0,0,1,428.38,270.69ZM96,176a16,16,0,0,0-16-16H16a16,16,0,0,0,0,32H80A16,16,0,0,0,96,176ZM528,64a16.17,16.17,0,0,0,7.16-1.69l64-32A16,16,0,0,0,584.84,1.69l-64,32A16,16,0,0,0,528,64Zm96,96H560a16,16,0,0,0,0,32h64a16,16,0,0,0,0-32ZM119.16,33.69l-64-32A16,16,0,0,0,40.84,30.31l64,32A16.17,16.17,0,0,0,112,64a16,16,0,0,0,7.16-30.31Zm480,288-64-32a16,16,0,0,0-14.32,28.63l64,32a16,16,0,0,0,14.32-28.63ZM112,288a16.17,16.17,0,0,0-7.16,1.69l-64,32a16,16,0,0,0,14.32,28.63l64-32A16,16,0,0,0,112,288Z"]
  },
      Ap = {
    prefix: "fal",
    iconName: "lightbulb-slash",
    icon: [640, 512, [], "f673", "M224 119.3l25.4 20C262.7 113.7 289.2 96 320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-41 0-76.5 22.4-96 55.3zM320 32c79.4 0 144 64.6 144 144 0 59.1-35.3 94.4-40.3 100.5l25 19.7c2.9-3.5 47.3-47.1 47.3-120.3C496 78.8 417.2 0 320 0c-75.1 0-123.2 43.4-146.9 79.2L198.3 99c19.2-30.3 58.8-67 121.7-67zm317 453.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zM262.2 352c-14.3-33.2-36.6-65.4-50.6-81.3-16.2-18.5-27-40.6-32.1-64.2l-35.3-27.8c.7 43.3 16.8 82.8 43.3 113.1 25.7 29.3 50.3 76.9 52.4 92.2l.1 75.2c0 3.1.9 6.2 2.7 8.8l24.5 36.8c3 4.5 8 7.1 13.3 7.1h78.9c5.4 0 10.4-2.7 13.3-7.1l24.5-36.8c1.7-2.6 2.7-5.7 2.7-8.8l.1-75.2c.1-.4.9-2.6 1-3.1L364.3 352zm105.7 102.3l-17 25.7h-61.7l-17.1-25.7V448H368v6.3zm.1-38.3h-96l-.1-32H368z"]
  },
      Np = {
    prefix: "fal",
    iconName: "lights-holiday",
    icon: [640, 512, [], "f7b2", "M638.3 77l-4.1-7c-3.4-5.7-10.6-7.6-16.5-4.4-83.2 46-188.4 71.3-297.8 71.3S105.4 111.6 22.2 65.6C16.4 62.3 9.1 64.2 5.8 70l-4.1 7C-1.7 82.9.2 90.5 6.2 93.8c44.5 24.7 94.9 43.6 148.6 56.4l-9.7 23.1-7.4-3.1c-12.2-5.1-26.3.6-31.4 12.8l-21.6 51.4c-18.2 5.5-34.4 19.8-45.4 45.9-20.6 48.9 7.9 129.6 21.2 135.2 13.3 5.6 90.9-30.4 111.5-79.3 11-26.1 9.9-47.6 1.1-64.5l21.6-51.4c5.1-12.2-.6-26.3-12.8-31.4l-7.4-3.1 12.2-28.9c38 7.1 77.3 11.1 117.3 12V192h-8c-13.2 0-24 10.8-24 24v55.8c-14.6 12.2-24 31.6-24 59.9 0 53 57.6 116.4 72 116.4s72-63.3 72-116.4c0-28.3-9.4-47.7-24-59.9V216c0-13.2-10.8-24-24-24h-8v-23.2c40-.9 79.3-4.8 117.3-12l12.2 28.9-7.4 3.1c-12.2 5.1-17.9 19.2-12.8 31.4l21.6 51.4c-8.8 16.9-9.9 38.4 1.1 64.5 20.6 48.9 98.2 84.9 111.5 79.3 13.3-5.6 41.8-86.3 21.2-135.2-11-26.1-27.2-40.3-45.4-45.9L533.8 183c-5.1-12.2-19.2-17.9-31.4-12.8l-7.4 3.1-9.7-23.1c53.8-12.8 104.1-31.8 148.6-56.4 5.9-3.4 7.8-11 4.4-16.8zM142.5 323.7c-10.5 25-46.3 47.6-67.2 56.4-8.3-21.2-17.1-62.5-6.6-87.5 11.6-27.4 28.6-35.3 53.8-24.7s31.5 28.4 20 55.8zm6.6-77.7c-4.4-2.8-9.1-5.4-14.2-7.5-5.1-2.1-10.2-3.7-15.3-4.9l13-30.8 29.5 12.4-13 30.8zm422.2 46.7c10.5 25 1.7 66.3-6.6 87.5-20.9-8.9-56.6-31.4-67.2-56.4-11.6-27.4-5.2-45.1 19.9-55.7 25.2-10.7 42.3-2.9 53.9 24.6zm-63.9-89.9l13 30.8c-5.1 1.2-10.2 2.7-15.3 4.9-5.1 2.1-9.8 4.7-14.2 7.5l-13-30.8 29.5-12.4zM304 224h32v33.4c-5.2-.9-10.5-1.4-16-1.4s-10.8.5-16 1.4V224zm56 107.6c0 27.1-24.2 61.8-40 78.1-15.8-16.3-40-51-40-78.1 0-29.8 12.7-43.6 40-43.6s40 13.9 40 43.6z"]
  },
      gp = {
    prefix: "fal",
    iconName: "line-columns",
    icon: [512, 512, [], "f870", "M504 304H296a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h208a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0 128H296a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h208a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-256H296a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h208a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-128H296a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h208a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8zM216 432H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h208a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-128H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h208a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-256H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h208a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8zm0 128H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h208a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      Hp = {
    prefix: "fal",
    iconName: "line-height",
    icon: [640, 512, [], "f871", "M175 144c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.63 0l-80 80C-5.64 126-.64 144 15 144h64v224H15C.71 368-6.31 385.31 3.71 395.31l80 80a16 16 0 0 0 22.63 0l80-80C195.65 386 190.65 368 175 368h-64V144zm-38.62 256L95 441.37 53.65 400h82.73zM79 112H53.63L95 70.63 136.36 112H79zm552 128H263a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h368a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0 128H263a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h368a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-256H263a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h368a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      Vp = {
    prefix: "fal",
    iconName: "link",
    icon: [512, 512, [], "f0c1", "M301.148 394.702l-79.2 79.19c-50.778 50.799-133.037 50.824-183.84 0-50.799-50.778-50.824-133.037 0-183.84l79.19-79.2a132.833 132.833 0 0 1 3.532-3.403c7.55-7.005 19.795-2.004 20.208 8.286.193 4.807.598 9.607 1.216 14.384.481 3.717-.746 7.447-3.397 10.096-16.48 16.469-75.142 75.128-75.3 75.286-36.738 36.759-36.731 96.188 0 132.94 36.759 36.738 96.188 36.731 132.94 0l79.2-79.2.36-.36c36.301-36.672 36.14-96.07-.37-132.58-8.214-8.214-17.577-14.58-27.585-19.109-4.566-2.066-7.426-6.667-7.134-11.67a62.197 62.197 0 0 1 2.826-15.259c2.103-6.601 9.531-9.961 15.919-7.28 15.073 6.324 29.187 15.62 41.435 27.868 50.688 50.689 50.679 133.17 0 183.851zm-90.296-93.554c12.248 12.248 26.362 21.544 41.435 27.868 6.388 2.68 13.816-.68 15.919-7.28a62.197 62.197 0 0 0 2.826-15.259c.292-5.003-2.569-9.604-7.134-11.67-10.008-4.528-19.371-10.894-27.585-19.109-36.51-36.51-36.671-95.908-.37-132.58l.36-.36 79.2-79.2c36.752-36.731 96.181-36.738 132.94 0 36.731 36.752 36.738 96.181 0 132.94-.157.157-58.819 58.817-75.3 75.286-2.651 2.65-3.878 6.379-3.397 10.096a163.156 163.156 0 0 1 1.216 14.384c.413 10.291 12.659 15.291 20.208 8.286a131.324 131.324 0 0 0 3.532-3.403l79.19-79.2c50.824-50.803 50.799-133.062 0-183.84-50.802-50.824-133.062-50.799-183.84 0l-79.2 79.19c-50.679 50.682-50.688 133.163 0 183.851z"]
  },
      xp = {
    prefix: "fal",
    iconName: "lips",
    icon: [640, 512, [], "f600", "M545.25 219c-17.56-7.56-65.56-25.33-131.97-26.89-29.09-.26-43.57 13.79-93.28 13.79-49.64 0-64.6-14.04-93.28-13.79-66.41 1.56-114.41 19.33-131.97 26.89-6.13 2.62-10.53 8.09-11.72 14.62-1.22 6.53.94 13.22 5.78 17.89 115.97 113.38 347.91 111.91 462.38 0 4.84-4.67 7-11.36 5.78-17.89-1.19-6.53-5.59-12-11.72-14.62zM320 304c-100.16 0-164.34-38.81-194.19-62.55 91.6-30.58 135.94-10.52 137.28-10.19 17.59 4.41 37.25 6.61 56.91 6.61s39.31-2.21 56.91-6.61c1.34-.33 45.68-20.39 137.28 10.19C484.34 265.19 420.16 304 320 304zm311.14-108.32C579.47 109.99 466.31 32 417.72 32c0 0-32.57 0-97.72 50-65.15-50-97.72-50-97.72-50-48.59 0-161.75 77.99-213.42 163.68-10.32 17.11-11.63 37.99-3.89 56.38C32.95 318.51 117.59 480 279.28 480h81.43c161.69 0 246.33-161.49 274.32-227.95 7.74-18.38 6.43-39.26-3.89-56.37zm-25.6 43.95C579.16 302.28 502.49 448 360.72 448h-81.43C137.51 448 60.84 302.28 34.46 239.63c-3.85-9.15-3.19-19.14 1.8-27.43 48.4-80.28 151.23-146.83 184.99-148.18 27.32 4.25 64.82 32.28 98.74 58.31 33.92-26.04 71.42-54.07 98.74-58.31 33.77 1.35 136.59 67.9 184.99 148.18 5.01 8.29 5.67 18.29 1.82 27.43z"]
  },
      wp = {
    prefix: "fal",
    iconName: "lira-sign",
    icon: [384, 512, [], "f195", "M371.994 255.681h-16.255c-6.398 0-11.706 5.02-11.983 11.412-4.877 112.517-82.255 173.397-188.949 173.397h-46.834V240.396l170.631-37.918a12 12 0 0 0 9.397-11.714v-8.195c0-7.677-7.109-13.38-14.603-11.714l-165.425 36.761v-47.219l170.631-37.918a12 12 0 0 0 9.397-11.714v-8.195c0-7.677-7.109-13.38-14.603-11.714l-165.425 36.761V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v93.387L9.397 149.521A12 12 0 0 0 0 161.235v8.196c0 7.677 7.109 13.379 14.603 11.714L64 170.168v47.219L9.397 229.521A12 12 0 0 0 0 241.235v8.195c0 7.677 7.109 13.38 14.603 11.714L64 250.168V468c0 6.627 5.373 12 12 12h83.268c130.519 0 219.608-76.854 224.724-211.914.256-6.78-5.213-12.405-11.998-12.405z"]
  },
      yp = {
    prefix: "fal",
    iconName: "list",
    icon: [512, 512, [], "f03a", "M88 56H40a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h48a16 16 0 0 0 16-16V72a16 16 0 0 0-16-16zm0 160H40a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h48a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16zm0 160H40a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h48a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16zm416 24H168a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h336a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-320H168a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h336a8 8 0 0 0 8-8V88a8 8 0 0 0-8-8zm0 160H168a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h336a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      bp = {
    prefix: "fal",
    iconName: "list-alt",
    icon: [512, 512, [], "f022", "M464 64c8.823 0 16 7.178 16 16v352c0 8.822-7.177 16-16 16H48c-8.823 0-16-7.178-16-16V80c0-8.822 7.177-16 16-16h416m0-32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-336 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm288-148v-24a6 6 0 0 0-6-6H198a6 6 0 0 0-6 6v24a6 6 0 0 0 6 6h212a6 6 0 0 0 6-6zm0 96v-24a6 6 0 0 0-6-6H198a6 6 0 0 0-6 6v24a6 6 0 0 0 6 6h212a6 6 0 0 0 6-6zm0 96v-24a6 6 0 0 0-6-6H198a6 6 0 0 0-6 6v24a6 6 0 0 0 6 6h212a6 6 0 0 0 6-6z"]
  },
      Sp = {
    prefix: "fal",
    iconName: "list-music",
    icon: [512, 512, [], "f8c9", "M8 224h272a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm152 104a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8zM8 96h272a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zM470 1.64l-96.59 31.88C360.72 37.74 352 50 352 64v312.13C331.66 361.28 303.38 352 272 352c-61.86 0-112 35.82-112 80s50.14 80 112 80 112-35.82 112-80V192l106.12-35.37A32 32 0 0 0 512 126.27V32a32 32 0 0 0-42-30.36zM272 480c-47.14 0-80-25.3-80-48s32.86-48 80-48 80 25.3 80 48-32.86 48-80 48zm208-353.72l-96 32V64h-.56v-.13L480 32z"]
  },
      Tp = {
    prefix: "fal",
    iconName: "list-ol",
    icon: [512, 512, [], "f0cb", "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.84a154.82 154.82 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.3 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.73 6.13-3.2 11.72 2.62 15.94 7.71 4.69 20.39 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM12.1 320H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.33c3.28-10.29 48.33-18.68 48.33-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.45 18.75-4.38 5.59-3 10.84 2.79 15.37l8.58 6.88c5.61 4.56 11 2.47 16.13-2.44a13.4 13.4 0 0 1 9.45-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.1 320zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm488-80H168a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h336a8 8 0 0 0 8-8V88a8 8 0 0 0-8-8zm0 320H168a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h336a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-160H168a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h336a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      Dp = {
    prefix: "fal",
    iconName: "list-ul",
    icon: [512, 512, [], "f0ca", "M32.39 224C14.73 224 0 238.33 0 256s14.73 32 32.39 32a32 32 0 0 0 0-64zm0-160C14.73 64 0 78.33 0 96s14.73 32 32.39 32a32 32 0 0 0 0-64zm0 320C14.73 384 0 398.33 0 416s14.73 32 32.39 32a32 32 0 0 0 0-64zM504 80H136a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h368a8 8 0 0 0 8-8V88a8 8 0 0 0-8-8zm0 160H136a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h368a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0 160H136a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h368a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      jp = {
    prefix: "fal",
    iconName: "location",
    icon: [512, 512, [], "f601", "M504 240h-56.81C439.48 146.76 365.24 72.52 272 64.81V8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v56.81C146.76 72.52 72.52 146.76 64.81 240H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56.81c7.71 93.24 81.95 167.48 175.19 175.19V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56.81c93.24-7.71 167.48-81.95 175.19-175.19H504c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM256 416c-88.22 0-160-71.78-160-160S167.78 96 256 96s160 71.78 160 160-71.78 160-160 160zm0-256c-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96-42.98-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"]
  },
      Ep = {
    prefix: "fal",
    iconName: "location-arrow",
    icon: [512, 512, [], "f124", "M461.9 0c-5.73 0-11.59 1.1-17.39 3.52L28.74 195.41c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 30.01 24.21 47.93 48.74 47.93 17.3 0 34.75-8.9 44.01-28.74l191.9-415.78C522.06 34.89 494.14 0 461.9 0zm17.55 54.08L287.6 469.74c-3.18 6.82-8.24 10.28-15.03 10.28-5.8 0-16.76-3.33-16.76-15.94v-207.9H47.93c-11.45 0-14.64-8.83-15.49-12.63-1.1-4.93-1.27-13.98 9.7-19.1L456.82 33.04c1.71-.71 3.37-1.05 5.09-1.05 5.42 0 11.49 3.65 15.11 9.08 2.19 3.29 4.32 8.41 2.43 13.01z"]
  },
      kp = {
    prefix: "fal",
    iconName: "location-circle",
    icon: [496, 512, [], "f602", "M307.75 147l-181.94 84c-16.38 7.64-24.78 24.53-20.91 42.05 3.88 17.36 18.34 29.03 36.06 29.03h60.97v60.95c0 17.72 11.66 32.22 29.03 36.06 2.84.62 5.69.94 8.44.94 14.31 0 27.22-8.14 33.62-21.91L357 196.22l.25-.55c5.69-13.64 2.34-29.48-8.5-40.34-10.91-10.92-26.72-14.27-41-8.33zM244 364.67c-1.28 2.72-3.28 3.89-6.12 3.17-2.59-.58-3.94-2.2-3.94-4.81v-92.95h-92.97c-2.59 0-4.22-1.33-4.81-3.97-.62-2.78.44-4.84 3.12-6.08l181.31-83.72c.53-.22 1-.3 1.5-.3 1.91 0 3.47 1.39 4 1.92.62.62 2.56 2.83 1.69 5.25L244 364.67zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216z"]
  },
      Ip = {
    prefix: "fal",
    iconName: "location-slash",
    icon: [640, 512, [], "f603", "M284.5 167l32.2 25.4c1.1-.1 2.1-.3 3.3-.3 31.3 0 57.3 22.6 62.8 52.4l31.8 25.1c.6-4.4 1.4-8.8 1.4-13.4 0-53-43-96-96-96-12.6-.2-24.5 2.4-35.5 6.8zM320 96c88.2 0 160 71.8 160 160 0 19.9-4.1 38.8-10.8 56.4l26.2 20.6c8.3-19 14-39.4 15.8-61H568c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-56.8c-7.7-93.2-82-167.5-175.2-175.2V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56.8c-37.5 3.1-71.6 17.3-99.9 38.8l25.8 20.3C255.6 106.4 286.6 96 320 96zm0 320c-88.2 0-160-71.8-160-160 0-19.9 4.1-38.8 10.8-56.4L144.6 179c-8.3 19-14 39.4-15.8 61H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56.8c7.7 93.2 82 167.5 175.2 175.2V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56.8c37.5-3.1 71.6-17.3 99.9-38.9L410.1 388c-25.7 17.6-56.7 28-90.1 28zm317 69.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zM355.5 345l-32.2-25.4c-1.1.1-2.1.3-3.3.3-31.3 0-57.3-22.6-62.8-52.4l-31.8-25.1c-.6 4.4-1.4 8.8-1.4 13.4 0 53 43 96 96 96 12.6.2 24.5-2.4 35.5-6.8z"]
  },
      Op = {
    prefix: "fal",
    iconName: "lock",
    icon: [448, 512, [], "f023", "M400 224h-16v-62.5C384 73.1 312.9.3 224.5 0 136-.3 64 71.6 64 160v64H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zM96 160c0-70.6 57.4-128 128-128s128 57.4 128 128v64H96v-64zm304 320H48c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16z"]
  },
      Qp = {
    prefix: "fal",
    iconName: "lock-alt",
    icon: [448, 512, [], "f30d", "M224 420c-11 0-20-9-20-20v-64c0-11 9-20 20-20s20 9 20 20v64c0 11-9 20-20 20zm224-148v192c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48h16v-64C64 71.6 136-.3 224.5 0 312.9.3 384 73.1 384 161.5V224h16c26.5 0 48 21.5 48 48zM96 224h256v-64c0-70.6-57.4-128-128-128S96 89.4 96 160v64zm320 240V272c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16z"]
  },
      Zp = {
    prefix: "fal",
    iconName: "lock-open",
    icon: [640, 512, [], "f3c1", "M480.5 0C392-.3 320 71.6 320 160v64H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-62.6c0-70.7 56.7-129 127.3-129.4C550.2 31.6 608 89.2 608 160v84c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-82.5C640 73.1 568.9.3 480.5 0zM400 256c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h352z"]
  },
      Up = {
    prefix: "fal",
    iconName: "lock-open-alt",
    icon: [640, 512, [], "f3c2", "M227 417c-11 0-20-9-20-20v-64c0-11 9-20 20-20s20 9 20 20v64c0 11-9 20-20 20zM480.5 0C392-.3 320 71.6 320 160v64H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-62.6c0-70.7 56.7-129 127.3-129.4C550.2 31.6 608 89.2 608 160v84c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-82.5C640 73.1 568.9.3 480.5 0zM400 256c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h352z"]
  },
      Bp = {
    prefix: "fal",
    iconName: "long-arrow-alt-down",
    icon: [256, 512, [], "f309", "M223.351 320H145V44c0-6.627-5.373-12-12-12h-10c-6.627 0-12 5.373-12 12v276H32.652c-29.388 0-43.268 34.591-23.231 54.627l95.952 96c12.497 12.496 32.757 12.497 45.255 0l95.955-96C266.56 354.65 252.85 320 223.351 320zM128 448l-96-96h192l-96 96z"]
  },
      Rp = {
    prefix: "fal",
    iconName: "long-arrow-alt-left",
    icon: [448, 512, [], "f30a", "M160 351.351V273h276c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H160v-78.348c0-29.388-34.591-43.268-54.627-23.231l-96 95.952c-12.496 12.497-12.497 32.757 0 45.255l96 95.955C125.35 394.56 160 380.85 160 351.351zM32 256l96-96v192l-96-96z"]
  },
      Yp = {
    prefix: "fal",
    iconName: "long-arrow-alt-right",
    icon: [448, 512, [], "f30b", "M288 160.649V239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h276v78.348c0 29.388 34.591 43.268 54.627 23.231l96-95.952c12.496-12.497 12.497-32.757 0-45.255l-96-95.955C322.65 117.44 288 131.15 288 160.649zM416 256l-96 96V160l96 96z"]
  },
      Pp = {
    prefix: "fal",
    iconName: "long-arrow-alt-up",
    icon: [256, 512, [], "f30c", "M32.649 192H111v276c0 6.627 5.373 12 12 12h10c6.627 0 12-5.373 12-12V192h78.348c29.388 0 43.268-34.591 23.231-54.627l-95.952-96c-12.497-12.496-32.757-12.497-45.255 0l-95.955 96C-10.56 157.35 3.15 192 32.649 192zM128 64l96 96H32l96-96z"]
  },
      Fp = {
    prefix: "fal",
    iconName: "long-arrow-down",
    icon: [256, 512, [], "f175", "M252.485 343.03l-7.07-7.071c-4.686-4.686-12.284-4.686-16.971 0L145 419.887V44c0-6.627-5.373-12-12-12h-10c-6.627 0-12 5.373-12 12v375.887l-83.444-83.928c-4.686-4.686-12.284-4.686-16.971 0l-7.07 7.071c-4.686 4.686-4.686 12.284 0 16.97l116 116.485c4.686 4.686 12.284 4.686 16.971 0l116-116.485c4.686-4.686 4.686-12.284-.001-16.97z"]
  },
      Wp = {
    prefix: "fal",
    iconName: "long-arrow-left",
    icon: [448, 512, [], "f177", "M136.97 380.485l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113l83.928-83.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-116.485 116c-4.686 4.686-4.686 12.284 0 16.971l116.485 116c4.686 4.686 12.284 4.686 16.97-.001z"]
  },
      Gp = {
    prefix: "fal",
    iconName: "long-arrow-right",
    icon: [448, 512, [], "f178", "M311.03 131.515l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887l-83.928 83.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l116.485-116c4.686-4.686 4.686-12.284 0-16.971L328 131.515c-4.686-4.687-12.284-4.687-16.97 0z"]
  },
      qp = {
    prefix: "fal",
    iconName: "long-arrow-up",
    icon: [256, 512, [], "f176", "M3.515 168.97l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L111 92.113V468c0 6.627 5.373 12 12 12h10c6.627 0 12-5.373 12-12V92.113l83.444 83.928c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-116-116.485c-4.686-4.686-12.284-4.686-16.971 0L3.515 152c-4.687 4.686-4.687 12.284 0 16.97z"]
  },
      Jp = {
    prefix: "fal",
    iconName: "loveseat",
    icon: [512, 512, [], "f4cc", "M448 193.9v-33.7c0-53.1-43-96.2-96-96.2H160c-53 0-96 43.1-96 96.2v33.7c-36.5 7.5-64 39.8-64 78.6 0 25.1 12.1 48.8 32 63.8v79.6c0 17.7 14.3 32.1 32 32.1h64c17.3 0 31.3-14.7 31.8-32h192.4c.5 17.3 14.5 32 31.8 32h64c17.7 0 32-14.4 32-32.1v-79.6c19.9-15.1 32-38.7 32-63.8 0-38.7-27.5-71.1-64-78.6zm-320 222H64v-97.4c-17.1-10-32-21.1-32-46 0-26.5 21.5-48.1 48-48.1h32c8.8 0 16 7.2 16 16v175.5zM352 384H160v-95.5h192V384zm0-143.6V256H160v-15.6c0-26.5-21.5-48.1-48-48.1H96v-32.1c0-35.4 28.7-64.1 64-64.1h192c35.3 0 64 28.8 64 64.1v32.1h-16c-26.5 0-48 21.6-48 48.1zm96 78.1v97.4h-64V240.4c0-8.8 7.2-16 16-16h32c26.5 0 48 21.6 48 48.1 0 23.9-13.9 35.4-32 46z"]
  },
      Kp = {
    prefix: "fal",
    iconName: "low-vision",
    icon: [576, 512, [], "f2a8", "M569.348 231.63C512.998 135.99 407.86 72 288 72c-36.303 0-71.26 5.877-103.93 16.722L121.889 4.913c-4-5.391-11.612-6.519-17.003-2.519l-6.507 4.828c-5.391 4-6.519 11.613-2.519 17.004l56.926 76.726C91.489 128.594 40.334 174.447 6.637 231.631c-8.979 15.238-8.719 33.949.004 48.739 30.605 51.943 75.611 94.537 129.537 122.627C29.589 259.268 39.873 273.724 34.215 264.124a16.006 16.006 0 0 1 0-16.247 287.008 287.008 0 0 1 16.929-25.491L204.72 429.39c15 3.91 30.42 6.78 46.18 8.54L72.243 197.124a293.367 293.367 0 0 1 33.449-30.602L308.14 439.39c12.42-.74 24.66-2.18 36.68-4.27L131.942 148.202a293.06 293.06 0 0 1 7.594-4.553 292.057 292.057 0 0 1 32.824-16.313l281.751 379.751c4 5.391 11.612 6.519 17.003 2.519l6.507-4.828c5.391-4 6.519-11.613 2.519-17.004l-56.917-76.714c61.284-27.629 112.419-73.491 146.124-130.69a47.961 47.961 0 0 0 .001-48.74zM362.31 328.959l-38.511-51.906c27.52-18.592 35.914-54.676 20.671-83.193v.02c0 14.56-11.8 26.36-26.35 26.36-14.56 0-26.36-11.8-26.36-26.36 0-14.55 11.8-26.35 26.36-26.35h.02c-22.278-11.908-50.192-9.748-70.538 6.823l-34.7-46.77C233.992 112.746 259.945 104 288 104c70.69 0 128 55.52 128 124 0 41.637-21.187 78.478-53.69 100.959zm179.47-64.839c-31.903 54.148-80.569 96.241-138.133 120.555l-22.24-29.975c74.24-52.148 88.248-153.521 32.713-222.709 54.32 25.45 98.59 66.55 127.66 115.89a15.958 15.958 0 0 1 0 16.239z"]
  },
      Xp = {
    prefix: "fal",
    iconName: "luchador",
    icon: [448, 512, [], "f455", "M224 0C100.3 0 0 100.3 0 224v128c0 88.4 71.6 160 160 160h128c88.4 0 160-71.6 160-160V224C448 100.3 347.7 0 224 0zm192 352c0 70.6-57.4 128-128 128H160c-70.6 0-128-57.4-128-128V224c0-105.9 86.1-192 192-192s192 86.1 192 192v128zM226.5 226.2c-.9-.7-4.2-.7-5.1 0C213.3 188.3 182 160 144 160H76c-6.6 0-12 5.4-12 12v30.7c0 47.1 35.8 85.3 80 85.3h22.4c-7.4 12.2-12.5 23.5-15.8 32.9-30.9 4.6-54.6 31-54.6 63.1 0 35.5 29.4 64 64.9 64H287c35.5 0 64.9-28.5 64.9-64 0-32.1-23.7-58.5-54.6-63.1-3.3-9.5-8.4-20.7-15.8-32.9H304c44.2 0 80-38.2 80-85.3V172c0-6.6-5.4-12-12-12h-68c-37.9 0-69.3 28.3-77.5 66.2zm36.2 93.8h-77.4c6.8-14.8 18.5-33.4 38.7-53.3 20.2 19.9 31.9 38.5 38.7 53.3zM144 256c-26.5 0-48-23.9-48-53.3V192h48c26.5 0 48 23.9 48 53.3v8.7c-.6.7-1.2 1.3-1.8 2H144zm176 128c0 17.6-14.4 32-32 32H160c-17.6 0-32-14.4-32-32s14.4-32 32-32h128c17.6 0 32 14.4 32 32zm32-181.3c0 29.4-21.5 53.3-48 53.3h-46.2c-.6-.7-1.2-1.3-1.8-2v-8.7c0-29.4 21.5-53.3 48-53.3h48v10.7z"]
  },
      _p = {
    prefix: "fal",
    iconName: "luggage-cart",
    icon: [640, 512, [], "f59d", "M224 352h320c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32h-64V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v48h-64c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32zm256-224h64v192h-64V128zM320 48c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v48H320V48zm0 80h128v192H320V128zm-96 0h64v192h-64V128zm408 288H128V8c0-4.42-3.58-8-8-8H8C3.58 0 0 3.58 0 8v16c0 4.42 3.58 8 8 8h88v408c0 4.42 3.58 8 8 8h58.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H632c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-424 64c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm288 0c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"]
  },
      $p = {
    prefix: "fal",
    iconName: "lungs",
    icon: [640, 512, [], "f604", "M636.11 390.15c-21.68-81.3-56.08-159.15-102.08-231.02C511.89 124.56 497.93 96 453.92 96c-38.72 0-70.1 29.42-70.1 65.71v75.36l-47.81-31.85V8c0-4.42-3.59-8-8.01-8h-16.01c-4.42 0-8.01 3.58-8.01 8v197.22l-47.81 31.85v-75.36c0-36.29-31.38-65.71-70.1-65.71-44.01 0-57.97 28.56-80.1 63.13-46 71.87-80.4 149.72-102.08 231.02C1.3 399.84 0 409.79 0 419.79 0 472.11 45.66 512 98.13 512c18.1 0 24.47-2.87 86.74-19.55 42.21-11.3 71.31-47.47 71.31-88.61v-89.87l-32.02 21.33v68.54c0 26.47-19.56 50.2-47.57 57.7C112.18 478.79 110.55 480 98.13 480c-36.45 0-66.11-27.01-66.11-60.21 0-7.2.95-14.4 2.81-21.39 20.85-78.18 53.86-152.87 98.12-222.01 27.82-43.94 32.14-48.38 53.13-48.38 21 0 38.08 15.12 38.08 33.71v96.69l-98.51 65.63c-3.68 2.45-4.67 7.42-2.22 11.1l8.88 13.31c2.45 3.68 7.42 4.67 11.1 2.22L320 233.01l176.59 117.65c3.68 2.45 8.65 1.46 11.1-2.22l8.88-13.31a8.006 8.006 0 0 0-2.22-11.1l-98.51-65.63v-96.69c0-18.59 17.08-33.71 38.08-33.71 20.99 0 25.31 4.44 53.13 48.38 44.25 69.14 77.27 143.84 98.12 222.01a83.248 83.248 0 0 1 2.81 21.39c0 33.2-29.66 60.21-66.11 60.21-12.42 0-14.05-1.21-78.45-18.46-28.01-7.5-47.57-31.23-47.57-57.7V335.3l-32.02-21.33v89.87c0 41.15 29.1 77.31 71.31 88.61 62.27 16.68 68.64 19.55 86.74 19.55 52.47 0 98.13-39.89 98.13-92.21-.01-10-1.31-19.95-3.9-29.64z"]
  },
      cz = {
    prefix: "fal",
    iconName: "lungs-virus",
    icon: [640, 512, [], "e067", "M421.83,421.83a16,16,0,0,0,0-22.62l-8.57-8.58C393.1,370.47,407.38,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.5,0-42.78-34.47-22.62-54.63l8.57-8.57a16,16,0,0,0-22.62-22.63l-8.58,8.58a31.31,31.31,0,0,1-22.39,9.44c-16.45,0-32.23-12.78-32.23-32.07V192a16,16,0,0,0-32,0v12.12c0,19.29-15.78,32.07-32.23,32.07a31.35,31.35,0,0,1-22.4-9.44l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.58a31.38,31.38,0,0,1,22.4-9.43c16.45,0,32.23,12.77,32.23,32.06V448a16,16,0,0,0,32,0V435.88c0-19.29,15.78-32.06,32.23-32.06a31.31,31.31,0,0,1,22.39,9.43l8.58,8.58a16,16,0,0,0,22.62,0Zm-45.07-78.32A64,64,0,0,0,372,371.93c-1.24-.08-2.48-.11-3.73-.11A64.15,64.15,0,0,0,320,393.62a64.17,64.17,0,0,0-48.23-21.8c-1.25,0-2.5,0-3.74.11A64.33,64.33,0,0,0,246.52,320,64.33,64.33,0,0,0,268,268.08c1.24.07,2.49.11,3.74.11A64.2,64.2,0,0,0,320,246.39a64.18,64.18,0,0,0,48.23,21.8c1.25,0,2.49,0,3.73-.11A64.38,64.38,0,0,0,393.5,320,64.11,64.11,0,0,0,376.76,343.51ZM304,288a16,16,0,1,0,16,16A16,16,0,0,0,304,288Zm32,32a16,16,0,1,0,16,16A16,16,0,0,0,336,320ZM204.13,272l-.15-.15-.23.15ZM336,147V8a8,8,0,0,0-8-8H312a8,8,0,0,0-8,8V147a44.88,44.88,0,0,1,32,0ZM201.16,449.07a67.76,67.76,0,0,1-24.57,12.48C112.18,478.8,110.54,480,98.12,480,61.69,480,32,453,32,419.8a83.14,83.14,0,0,1,2.82-21.39,788.37,788.37,0,0,1,98.12-222C160.76,132.45,165.09,128,186.07,128s38.08,15.1,38.08,33.7V182a43.15,43.15,0,0,1,32,7.56V161.7c0-36.28-31.38-65.7-70.11-65.7-44,0-58,28.56-80.09,63.12a820.64,820.64,0,0,0-102.08,231A114.64,114.64,0,0,0,0,419.8C0,472.11,45.66,512,98.12,512c18.11,0,24.47-2.88,86.75-19.55a98.18,98.18,0,0,0,52.57-34.71,45.76,45.76,0,0,1-36.28-8.67Zm434.93-58.91A820.61,820.61,0,0,0,534,159.12C511.88,124.56,497.93,96,453.91,96c-38.72,0-70.11,29.42-70.11,65.7v27.91a47.62,47.62,0,0,1,26.72-8.12,46.57,46.57,0,0,1,5.31.52V161.7c0-18.58,17.08-33.7,38.08-33.7s25.31,4.44,53.12,48.37a789.06,789.06,0,0,1,98.13,222A101.48,101.48,0,0,1,608,419.78C608,453,578.3,480,541.86,480c-12.42,0-14.06-1.2-78.45-18.45a67.76,67.76,0,0,1-24.56-12.46,45.79,45.79,0,0,1-36.29,8.67,98.15,98.15,0,0,0,52.57,34.71C517.39,509.12,523.77,512,541.86,512c52.47,0,98.14-39.89,98.14-92.2A115.09,115.09,0,0,0,636.09,390.16ZM435.88,272h.36l-.21-.14Z"]
  },
      ez = {
    prefix: "fal",
    iconName: "mace",
    icon: [512, 512, [], "f6f8", "M501.02 198.92l-71.37-14.29c-9.77-52.76-51.8-93.84-104.93-102.54l-15.77-71.25c-3.21-14.52-11.27-14.44-14.18.14l-14.29 71.39c-52.64 9.81-93.62 51.75-102.36 104.75l-71.26 15.77c-14.52 3.21-14.44 11.27.14 14.18l71.37 14.29c1.7 9.17 4.68 17.81 8.22 26.17L4.69 439.43c-6.25 6.25-6.25 16.38 0 22.63l45.26 45.26c6.25 6.25 16.38 6.25 22.63 0l182-182.02c9.04 3.8 18.43 6.92 28.38 8.58l15.78 71.28c3.21 14.52 11.27 14.44 14.18-.14l14.29-71.36c52.79-9.7 93.92-51.68 102.68-104.79l71.26-15.77c14.53-3.21 14.44-11.26-.13-14.18zM61.25 473.37l-22.63-22.63 164.53-164.53c6.58 8.45 14.27 15.96 22.74 22.51L61.25 473.37zM304 304c-53.02 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96zm0-144c-26.47 0-48 21.53-48 48s21.53 48 48 48 48-21.53 48-48-21.53-48-48-48zm0 64c-8.81 0-16-7.17-16-16s7.19-16 16-16 16 7.17 16 16-7.19 16-16 16z"]
  },
      az = {
    prefix: "fal",
    iconName: "magic",
    icon: [512, 512, [], "f0d0", "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm0-96c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm352 224l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm0 96c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm70.63-306.04L434.04 9.37C427.79 3.12 419.6 0 411.41 0s-16.38 3.12-22.63 9.37L9.37 388.79c-12.5 12.5-12.5 32.76 0 45.25l68.59 68.59c6.25 6.25 14.44 9.37 22.63 9.37s16.38-3.12 22.63-9.37l379.41-379.41c12.49-12.5 12.49-32.76 0-45.26zM100.59 480L32 411.41l258.38-258.4 68.6 68.6L100.59 480zm281.02-281.02l-68.6-68.6L411.38 32h.03L480 100.59l-98.39 98.39z"]
  },
      nz = {
    prefix: "fal",
    iconName: "magnet",
    icon: [512, 512, [], "f076", "M372 32c-19.9 0-36 16.1-36 36v172c0 64-40 96-79.9 96-40 0-80.1-32-80.1-96V68c0-19.9-16.1-36-36-36H36.4C16.4 32 .2 48.3.4 68.4c.3 24.5.6 58.4.7 91.6H0v32h1.1C1 218.3.7 242 0 257.3 0 408 136.2 504 256.8 504 377.5 504 512 408 512 257.3V68c0-19.9-16.1-36-36-36H372zM36.5 68H140v92H37.1c-.1-33.4-.4-67.4-.6-92zM476 258.1c-.1 30.4-6.6 59.3-19.4 85.8-11.9 24.9-29 47.2-50.8 66.3-20.6 18.1-45.2 32.9-71.2 42.9-25.5 9.8-52.4 15-77.9 15-25.5 0-52.5-5.2-78.2-15-26.2-10-51-24.9-71.8-43-22-19.2-39.2-41.5-51.3-66.3-12.9-26.5-19.4-55.3-19.6-85.6.7-15.9 1-39.7 1.1-66.1H140v48c0 49.2 18.9 79.7 34.8 96.6 10.8 11.5 23.5 20.4 37.8 26.5 13.8 5.9 28.5 8.9 43.5 8.9s29.7-3 43.5-8.9c14.3-6.1 27-15 37.7-26.5 15.8-16.9 34.7-47.4 34.7-96.6v-48h102.9c.1 26.2.4 50.1 1.1 66zM372 160V68h103.5c-.3 24.6-.6 58.6-.6 92H372z"]
  },
      tz = {
    prefix: "fal",
    iconName: "mail-bulk",
    icon: [640, 512, [], "f674", "M592 96H240c-26.47 0-48 21.53-48 48v16h32v-16c0-8.84 7.16-16 16-16h352c8.84 0 16 7.16 16 16v224c0 8.84-7.16 16-16 16H416v32h176c26.47 0 48-21.53 48-48V144c0-26.47-21.53-48-48-48zM96 48c0-8.84 7.16-16 16-16h288c8.84 0 16 7.16 16 16v16h32V48c0-26.47-21.53-48-48-48H112C85.53 0 64 21.53 64 48v112h32V48zm464 208c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h64zm-48-64h32v32h-32v-32zm-176 0H48c-26.47 0-48 21.53-48 48v224c0 26.47 21.53 48 48 48h288c26.47 0 48-21.53 48-48V240c0-26.47-21.53-48-48-48zm16 272c0 8.84-7.16 16-16 16H48c-8.84 0-16-7.16-16-16V313.6c12.8 9.6 32 25.6 96 70.4 12.8 9.6 38.4 32 64 32s51.2-22.4 64-32c64-44.8 83.2-60.8 96-70.4V464zm0-188.8c-25.6 19.2-22.4 19.2-115.2 86.4-9.6 3.2-28.8 22.4-44.8 22.4s-35.2-19.2-44.8-25.6C54.4 291.2 57.6 291.2 32 272v-32c0-8.84 7.16-16 16-16h288c8.84 0 16 7.16 16 16v35.2z"]
  },
      rz = {
    prefix: "fal",
    iconName: "mailbox",
    icon: [576, 512, [], "f813", "M432 64H144A144 144 0 0 0 0 208v208a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32V208A144 144 0 0 0 432 64zM256 416H32V208a112 112 0 0 1 224 0zm288 0H288V208c0-45.52-21.54-85.61-54.51-112H432a112.12 112.12 0 0 1 112 112zm-48-224H328a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h88v80a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-96a16 16 0 0 0-16-16zm-16 96h-32v-64h32zm-296-96h-80a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      iz = {
    prefix: "fal",
    iconName: "male",
    icon: [256, 512, [], "f183", "M198.746 140.274C209.582 125.647 216 107.56 216 88c0-48.523-39.477-88-88-88S40 39.477 40 88c0 19.56 6.418 37.647 17.254 52.274C28.585 150.478 8 177.873 8 210v105c0 24.74 17.041 45.576 40 51.387V459c0 29.224 23.776 53 53 53h54c29.224 0 53-23.776 53-53v-92.613c22.959-5.812 40-26.647 40-51.387V210c0-32.127-20.585-59.522-49.254-69.726zM128 32c30.928 0 56 25.072 56 56s-25.072 56-56 56-56-25.072-56-56 25.072-56 56-56zm88 283c0 11.598-9.402 21-21 21h-19v123c0 11.598-9.402 21-21 21h-54c-11.598 0-21-9.402-21-21V336H61c-11.598 0-21-9.402-21-21V210c0-23.196 18.804-42 42-42h9.36c22.711 10.443 49.59 10.894 73.28 0H174c23.196 0 42 18.804 42 42v105z"]
  },
      oz = {
    prefix: "fal",
    iconName: "mandolin",
    icon: [512, 512, [], "f6f9", "M507.31 50.67l-46-46a16 16 0 0 0-19.81-2.25l-64 40.07a32 32 0 0 0-14 19.11L345.07 133l-59.23 59.23c-6.75-.13-13.36-.2-19.75-.2-177.4 0-220.3 49.21-235.35 64.26-46.81 46.78-39.52 150.35 17.53 207.44C80.22 495.65 126.73 512 169.69 512c33.81 0 65.42-10.12 86-30.74 15.59-15.59 67.83-61.13 64-255.09L379 166.93l71.37-18.46a32 32 0 0 0 19.11-14l40.07-64a16 16 0 0 0-2.24-19.8zM234.73 457l-1.64 1.63c-13.57 13.58-36.68 21.37-63.4 21.37-36.93 0-74.78-14.91-98.78-38.89-47.55-47.58-49.42-130.34-17.55-162.2l1.64-1.65c12.66-12.81 50.81-51 198.86-53l-35.51 35.51a16 16 0 0 0 0 22.62l11.32 11.31a16 16 0 0 0 22.62 0l35.52-35.51c-2 147.93-39.99 185.89-53.08 198.81zm207.64-339.51l-64.55 16.69 16.69-64.55 53.2-33.31 28 28zM160 288a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm0 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"]
  },
      lz = {
    prefix: "fal",
    iconName: "map",
    icon: [576, 512, [], "f279", "M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM30.63 118.18L176 67.61V387.8L31.91 441.05l-1.28-322.87zM208 387.71V67.8l160 56.48v319.91l-160-56.48zm192 56.68V124.2l144.09-53.26 1.28 322.87L400 444.39z"]
  },
      fz = {
    prefix: "fal",
    iconName: "map-marked",
    icon: [576, 512, [], "f59f", "M560 160c-2 0-4 .4-6 1.2L384 224l-10.3-3.6C397 185.5 416 149.2 416 123 416 55 358.7 0 288 0S160 55.1 160 123c0 11.8 4 25.8 10.4 40.6L20.1 216C8 220.8 0 232.6 0 245.7V496c0 9.2 7.5 16 16 16 2 0 4-.4 6-1.2L192 448l172 60.7c13 4.3 27 4.4 40 .2L555.9 456c12.2-4.9 20.1-16.6 20.1-29.7V176c0-9.2-7.5-16-16-16zM176 419.8L31.9 473l-1.3-226.9L176 195.6zM288 32c52.9 0 96 40.8 96 91 0 27-38.1 88.9-96 156.8-57.9-67.9-96-129.8-96-156.8 0-50.2 43.1-91 96-91zm-80 387.7V228.8c24.4 35.3 52.1 68 67.7 85.7 3.2 3.7 7.8 5.5 12.3 5.5s9-1.8 12.3-5.5c12.8-14.5 33.7-39.1 54.3-66.9l13.4 4.7v223.9zm192 56.7V252.2L544.1 199l1.3 226.9z"]
  },
      sz = {
    prefix: "fal",
    iconName: "map-marked-alt",
    icon: [576, 512, [], "f5a0", "M560 160c-2 0-4 .4-6 1.2L384 224l-10.3-3.6C397 185.5 416 149.2 416 123 416 55 358.7 0 288 0S160 55.1 160 123c0 11.8 4 25.8 10.4 40.6L20.1 216C8 220.8 0 232.6 0 245.7V496c0 9.2 7.5 16 16 16 2 0 4-.4 6-1.2L192 448l172 60.7c13 4.3 27 4.4 40 .2L555.9 456c12.2-4.9 20.1-16.6 20.1-29.7V176c0-9.2-7.5-16-16-16zM176 419.8L31.9 473l-1.3-226.9L176 195.6zM288 32c52.9 0 96 40.8 96 91 0 27-38.1 88.9-96 156.8-57.9-67.9-96-129.8-96-156.8 0-50.2 43.1-91 96-91zm80 444.2l-160-56.5V228.8c24.4 35.3 52.1 68 67.7 85.7 3.2 3.7 7.8 5.5 12.3 5.5s9-1.8 12.3-5.5c12.8-14.5 33.7-39.1 54.3-66.9l13.4 4.7zm32 .2V252.2L544.1 199l1.3 226.9zM312 128c0-13.3-10.8-24-24-24s-24 10.7-24 24c0 13.2 10.8 24 24 24s24-10.7 24-24z"]
  },
      uz = {
    prefix: "fal",
    iconName: "map-marker",
    icon: [384, 512, [], "f041", "M192 0C85.961 0 0 85.961 0 192c0 77.413 26.97 99.031 172.268 309.67 9.534 13.772 29.929 13.774 39.465 0C357.03 291.031 384 269.413 384 192 384 85.961 298.039 0 192 0zm0 473.931C52.705 272.488 32 256.494 32 192c0-42.738 16.643-82.917 46.863-113.137S149.262 32 192 32s82.917 16.643 113.137 46.863S352 149.262 352 192c0 64.49-20.692 80.47-160 281.931z"]
  },
      hz = {
    prefix: "fal",
    iconName: "map-marker-alt",
    icon: [384, 512, [], "f3c5", "M192 96c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm0-256C85.961 0 0 85.961 0 192c0 77.413 26.97 99.031 172.268 309.67 9.534 13.772 29.929 13.774 39.465 0C357.03 291.031 384 269.413 384 192 384 85.961 298.039 0 192 0zm0 473.931C52.705 272.488 32 256.494 32 192c0-42.738 16.643-82.917 46.863-113.137S149.262 32 192 32s82.917 16.643 113.137 46.863S352 149.262 352 192c0 64.49-20.692 80.47-160 281.931z"]
  },
      mz = {
    prefix: "fal",
    iconName: "map-marker-alt-slash",
    icon: [640, 512, [], "f605", "M320 32c88.2 0 160 71.8 160 160 0 34.7-4.7 54.1-34.8 101.5l25.3 19.9C503.9 261.2 512 235.2 512 192 512 86.4 425.6 0 320 0c-61.7 0-116.7 29.7-151.9 75.3l25.4 20C222.7 57.1 268.3 32 320 32zm74 221.1c13.6-16.5 22-37.6 22-61.1 0-53.8-42.2-96-96-96-31.9 0-59.5 15.1-76.8 38.4l25.1 19.8c11.5-15.9 30.1-26.2 51.7-26.2 35.9 0 64 28.1 64 64 0 16-5.8 30.2-15.2 41.3zm-21.5 146.2c-15.5 22-33.1 46.9-52.5 74.7-19.7-28.2-37.1-52.9-52.5-74.7C170.6 262 160 245.1 160 192c0-.3.1-.5.1-.8l-30.3-23.9c-1.1 8.1-1.8 16.3-1.8 24.7 0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6c30.8-44.1 56-79.7 77-109.6L391 373c-5.8 8.3-11.9 17-18.5 26.3zM637 485.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3z"]
  },
      vz = {
    prefix: "fal",
    iconName: "map-marker-check",
    icon: [384, 512, [], "f606", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm.01 474c-19.67-28.17-37.09-52.85-52.49-74.69C42.64 261.97 32 245.11 32 192c0-88.22 71.78-160 160-160s160 71.78 160 160c0 53.11-10.64 69.97-107.52 207.31-15.52 22.01-33.09 46.92-52.47 74.69zm89.33-339.54a7.98 7.98 0 0 0-5.66-2.34c-2.05 0-4.1.78-5.66 2.34L162.54 241.94l-48.57-48.57a7.98 7.98 0 0 0-5.66-2.34c-2.05 0-4.1.78-5.66 2.34l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l65.54 65.54c1.56 1.56 3.61 2.34 5.66 2.34s4.09-.78 5.65-2.34l124.45-124.45c3.12-3.12 3.12-8.19 0-11.31l-11.3-11.31z"]
  },
      dz = {
    prefix: "fal",
    iconName: "map-marker-edit",
    icon: [384, 512, [], "f607", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm.01 474c-19.67-28.17-37.09-52.85-52.49-74.69C42.64 261.97 32 245.11 32 192c0-88.22 71.78-160 160-160s160 71.78 160 160c0 53.11-10.64 69.97-107.52 207.31-15.52 22.01-33.09 46.92-52.47 74.69zm64.01-368.65c-12.5-12.47-32.75-12.47-45.25 0l-94.09 94.09c-2 2.02-3.44 4.51-4.16 7.27l-16 61.25c-1.44 5.5.12 11.34 4.16 15.36 3.03 3.05 7.12 4.69 11.31 4.69 1.34 0 2.72-.17 4.03-.52l61.25-16c2.75-.72 5.28-2.15 7.28-4.17l94.09-94.09c12.47-12.47 12.47-32.78 0-45.25l-22.62-22.63zM165 241.61l-30.62 8 8-30.61 91.03-91.03 22.62 22.62L165 241.61z"]
  },
      Mz = {
    prefix: "fal",
    iconName: "map-marker-exclamation",
    icon: [384, 512, [], "f608", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm.01 474c-19.67-28.17-37.09-52.85-52.49-74.69C42.64 261.97 32 245.11 32 192c0-88.22 71.78-160 160-160s160 71.78 160 160c0 53.11-10.64 69.97-107.52 207.31-15.52 22.01-33.09 46.92-52.47 74.69zm-8.49-234h16.97a8 8 0 0 0 7.98-7.5l7-112c.29-4.61-3.37-8.5-7.98-8.5h-30.97c-4.61 0-8.27 3.89-7.98 8.5l7 112c.25 4.21 3.75 7.5 7.98 7.5zm8.48 24c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      pz = {
    prefix: "fal",
    iconName: "map-marker-minus",
    icon: [384, 512, [], "f609", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm.01 474c-19.67-28.17-37.09-52.85-52.49-74.69C42.64 261.97 32 245.11 32 192c0-88.22 71.78-160 160-160s160 71.78 160 160c0 53.11-10.64 69.97-107.52 207.31-15.52 22.01-33.09 46.92-52.47 74.69zM280 176H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h176c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"]
  },
      zz = {
    prefix: "fal",
    iconName: "map-marker-plus",
    icon: [384, 512, [], "f60a", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm.01 474c-19.67-28.17-37.09-52.85-52.49-74.69C42.64 261.97 32 245.11 32 192c0-88.22 71.78-160 160-160s160 71.78 160 160c0 53.11-10.64 69.97-107.52 207.31-15.52 22.01-33.09 46.92-52.47 74.69zM280 176h-72v-72c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v72h-72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h72v72c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72h72c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"]
  },
      Cz = {
    prefix: "fal",
    iconName: "map-marker-question",
    icon: [384, 512, [], "f60b", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm.01 474.01c-19.67-28.17-37.09-52.85-52.49-74.69C42.64 261.97 32 245.11 32 192c0-88.22 71.78-160 160-160s160 71.78 160 160c0 53.11-10.64 69.97-107.52 207.31-15.52 22.01-33.09 46.92-52.47 74.7zM192 296c-13.26 0-24 10.74-24 24 0 13.25 10.74 24 24 24s24-10.75 24-24c0-13.26-10.74-24-24-24zm.68-200c-41.09 0-75.02 31.12-79.5 71.01-.54 4.77 3.2 8.99 8 8.99h16.13c3.95 0 7.29-2.9 7.85-6.81 3.31-23.26 23.36-41.19 47.52-41.19 31.19 0 48 24.73 48 48 0 20.62-20.84 32.53-55.16 49.69a15.996 15.996 0 0 0-8.84 14.31v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-14.14c31.66-16.09 64-35.56 64-73.86 0-39.33-29.94-80-80-80z"]
  },
      Lz = {
    prefix: "fal",
    iconName: "map-marker-slash",
    icon: [640, 512, [], "f60c", "M320 32c88.2 0 160 71.8 160 160 0 34.7-4.7 54.1-34.8 101.5l25.3 19.9C503.9 261.2 512 235.2 512 192 512 86.4 425.6 0 320 0c-61.7 0-116.7 29.7-151.9 75.3l25.4 20C222.7 57.1 268.3 32 320 32zm52.5 367.3c-15.5 22-33.1 46.9-52.5 74.7-19.7-28.2-37.1-52.9-52.5-74.7C170.6 262 160 245.1 160 192c0-.3.1-.5.1-.8l-30.3-23.9c-1.1 8.1-1.8 16.3-1.8 24.7 0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6c30.8-44.1 56-79.7 77-109.6L391 373c-5.8 8.3-11.9 17-18.5 26.3zM637 485.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3z"]
  },
      Az = {
    prefix: "fal",
    iconName: "map-marker-smile",
    icon: [384, 512, [], "f60d", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm.01 474c-19.67-28.17-37.09-52.85-52.49-74.69C42.64 261.97 32 245.11 32 192c0-88.22 71.78-160 160-160s160 71.78 160 160c0 53.11-10.64 69.97-107.52 207.31-15.52 22.01-33.09 46.91-52.47 74.69zM256 184c13.25 0 24-10.75 24-24 0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24zm11.84 53.34C249.03 259.38 221.41 272 192 272s-57.03-12.62-75.84-34.64c-5.72-6.73-15.84-7.44-22.53-1.78-6.75 5.75-7.53 15.84-1.78 22.56C116.72 287.28 153.22 304 192 304s75.28-16.72 100.16-45.88c5.75-6.72 4.94-16.83-1.78-22.56-6.66-5.72-16.79-4.94-22.54 1.78zM128 184c13.25 0 24-10.75 24-24 0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24z"]
  },
      Nz = {
    prefix: "fal",
    iconName: "map-marker-times",
    icon: [384, 512, [], "f60e", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6s14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm.01 474c-19.67-28.17-37.09-52.85-52.49-74.69C42.64 261.97 32 245.11 32 192c0-88.22 71.78-160 160-160s160 71.78 160 160c0 53.11-10.64 69.97-107.52 207.31-15.52 22.01-33.09 46.92-52.47 74.69zm73.53-344.23l-11.31-11.31c-1.56-1.56-3.61-2.34-5.66-2.34s-4.1.78-5.66 2.34L192 169.37l-50.91-50.91c-1.56-1.56-3.61-2.34-5.66-2.34s-4.09.78-5.66 2.34l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31L169.37 192l-50.91 50.91c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c1.56 1.56 3.61 2.34 5.66 2.34s4.1-.78 5.66-2.34l50.91-50.9 50.91 50.91c1.56 1.56 3.61 2.34 5.66 2.34s4.09-.78 5.66-2.34l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31L214.63 192l50.91-50.91a8.015 8.015 0 0 0 0-11.32z"]
  },
      gz = {
    prefix: "fal",
    iconName: "map-pin",
    icon: [288, 512, [], "f276", "M144 0C64.47 0 0 64.47 0 144c0 74.05 56.1 134.33 128 142.39v206.43l11.01 16.51c2.38 3.56 7.61 3.56 9.98 0L160 492.82V286.39c71.9-8.05 128-68.34 128-142.39C288 64.47 223.53 0 144 0zm0 256c-61.76 0-112-50.24-112-112S82.24 32 144 32s112 50.24 112 112-50.24 112-112 112zm0-192c-44.12 0-80 35.89-80 80 0 8.84 7.16 16 16 16s16-7.16 16-16c0-26.47 21.53-48 48-48 8.84 0 16-7.16 16-16s-7.16-16-16-16z"]
  },
      Hz = {
    prefix: "fal",
    iconName: "map-signs",
    icon: [512, 512, [], "f277", "M441.37 192c8.49 0 16.62-4.21 22.63-11.72l43.31-54.14c6.25-7.81 6.25-20.47 0-28.29L464 43.71C458 36.21 449.86 32 441.37 32H272V8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v24H56c-13.25 0-24 13.43-24 30v100c0 16.57 10.75 30 24 30h184v32H70.63C62.14 224 54 228.21 48 235.71L4.69 289.86c-6.25 7.81-6.25 20.47 0 28.29L48 372.28c6 7.5 14.14 11.72 22.63 11.72H240v120c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V384h184c13.25 0 24-13.43 24-30V254c0-16.57-10.75-30-24-30H272v-32h169.37zm6.38 160h-375l-38.4-48 38.45-48h375.19l-.24 96zM64.25 64h375l38.4 48-38.45 48H64.01l.24-96z"]
  },
      Vz = {
    prefix: "fal",
    iconName: "marker",
    icon: [512, 512, [], "f5a1", "M421.4 0c-23.17 0-46.33 8.84-64 26.52l-6.28 6.28-23.43-23.43c-12.5-12.5-32.75-12.5-45.25 0L152.36 139.48c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0L305.07 32l23.42 23.43-234.55 234.6A327.069 327.069 0 0 0 .18 485.12l-.03.23C-1.45 499.72 9.88 512 23.94 512c.89 0 1.78-.05 2.69-.15a326.972 326.972 0 0 0 195.3-93.8L485.4 154.54C542.54 97.38 501.35 0 421.4 0zM199.31 395.42c-44.99 45-103.91 74.41-166.07 83.39 9.13-62.64 38.49-121.32 83.32-166.16l78.71-78.72 82.75 82.77-78.71 78.72zm263.46-263.51L300.64 294.07l-82.75-82.77L380.02 49.14C391.07 38.09 405.77 32 421.4 32c32.32 0 58.52 26.16 58.52 58.53-.01 15.63-6.09 30.33-17.15 41.38z"]
  },
      xz = {
    prefix: "fal",
    iconName: "mars",
    icon: [384, 512, [], "f222", "M372 64h-88c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h45.4l-95.5 95.5C209.2 171.8 178 160 144 160 64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-34-11.8-65.2-31.5-89.9l95.5-95.5V164c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zM144 416c-61.9 0-112-50-112-112 0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112z"]
  },
      wz = {
    prefix: "fal",
    iconName: "mars-double",
    icon: [512, 512, [], "f227", "M288 208c0-34-11.8-65.2-31.5-89.9L320 54.6V100c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V12c0-6.6-5.4-12-12-12h-88c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h45.4l-63.5 63.5C209.2 75.8 178 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144zM144 320c-61.9 0-112-50-112-112 0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112zm368-148v88c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-45.4l-63.5 63.5C436.2 302.8 448 334 448 368c0 79.5-64.5 144-144 144-74.4 0-135.6-56.4-143.2-128.8 10.7-1 21.2-3 31.6-6C197 434.7 245.1 480 304 480c62 0 112-50.1 112-112 0-59-45.4-107-102.8-111.6 3-10.4 4.9-20.9 6-31.6 28.1 2.9 53.8 14 74.7 30.7l63.5-63.5H412c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h88c6.6 0 12 5.4 12 12z"]
  },
      yz = {
    prefix: "fal",
    iconName: "mars-stroke",
    icon: [384, 512, [], "f229", "M372 64h-88c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h45.4l-49.6 49.6-31.1-31.1c-4.7-4.7-12.3-4.7-17 0l-5.7 5.7c-4.7 4.7-4.7 12.3 0 17l31.1 31.1-23.3 23.3C209.2 171.8 178 160 144 160 64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-34-11.8-65.2-31.5-89.9l23.3-23.3 31.1 31.1c4.7 4.7 12.3 4.7 17 0l5.7-5.7c4.7-4.7 4.7-12.3 0-17l-31.1-31.1 49.6-49.6V164c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V76c-.1-6.6-5.5-12-12.1-12zM144 416c-61.9 0-112-50-112-112 0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112z"]
  },
      bz = {
    prefix: "fal",
    iconName: "mars-stroke-h",
    icon: [480, 512, [], "f22b", "M474.9 247.5l-62.2-62.2c-4.7-4.7-12.3-4.7-17 0L390 191c-4.7 4.7-4.7 12.3 0 17l32.1 32.1H352v-44c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v44h-32.9c-3.5-31.4-17.2-61.8-41.3-85.8-56.2-56.2-147.4-56.2-203.6 0-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 24-24 37.8-54.5 41.3-85.8H320v44c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-44h70.2l-32.1 32.1c-4.7 4.7-4.7 12.3 0 17l5.7 5.7c4.7 4.7 12.3 4.7 17 0l62.2-62.2c4.6-4.9 4.6-12.5-.1-17.2zM144 368c-61.9 0-112-50-112-112 0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112z"]
  },
      Sz = {
    prefix: "fal",
    iconName: "mars-stroke-v",
    icon: [288, 512, [], "f22a", "M245.8 234.2c-24-24-54.5-37.8-85.8-41.3V160h44c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-44V57.8l32.1 32.1c4.7 4.7 12.3 4.7 17 0l5.7-5.7c4.7-4.7 4.7-12.3 0-17L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L73.3 67.3c-4.7 4.7-4.7 12.3 0 17L79 90c4.7 4.7 12.3 4.7 17 0l32-32.2V128H84c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h44v32.9c-31.4 3.5-61.8 17.2-85.8 41.3-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zM144 448c-61.9 0-112-50-112-112 0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112z"]
  },
      Tz = {
    prefix: "fal",
    iconName: "mask",
    icon: [640, 512, [], "f6fa", "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c7.83-11.5 19.57-17.25 31.31-17.25 11.74 0 23.49 5.75 31.31 17.25l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zm158.46 349.09c-29.61 0-57.92-15.61-75.72-41.76l-25.73-37.79c-13.56-19.92-34.34-31.34-57-31.34-22.67 0-43.44 11.42-57 31.34l-25.73 37.79c-17.8 26.15-46.11 41.76-75.73 41.76C84.32 413.09 32 340.54 32 272.77c0-31.04 10.25-75.99 59.07-113.92 50.48-39.22 129.87-59.94 229.6-59.94 100.06 0 179.35 20.29 229.31 58.66C597.93 194.41 608 238.62 608 269.21c0 68.05-52.92 143.88-128.87 143.88zM192 186.18c-46.93 0-77.44 29.93-91.52 47.89-5.97 7.62-5.97 18.78 0 26.39 14.08 17.96 44.59 47.89 91.52 47.89s77.44-29.93 91.52-47.89c5.97-7.62 5.97-18.78 0-26.39-14.08-17.96-44.59-47.89-91.52-47.89zm0 87.27c-26.83 0-46.54-13.8-58.82-26.18 12.28-12.38 32-26.18 58.82-26.18s46.54 13.8 58.82 26.18c-12.28 12.38-31.99 26.18-58.82 26.18zm256-87.27c-46.93 0-77.44 29.93-91.52 47.89-5.97 7.62-5.97 18.78 0 26.39 14.08 17.96 44.59 47.89 91.52 47.89s77.44-29.93 91.52-47.89c5.97-7.62 5.97-18.78 0-26.39-14.08-17.96-44.59-47.89-91.52-47.89zm0 87.27c-26.83 0-46.54-13.8-58.82-26.18 12.28-12.38 32-26.18 58.82-26.18 26.83 0 46.54 13.8 58.82 26.18-12.28 12.38-31.99 26.18-58.82 26.18z"]
  },
      Dz = {
    prefix: "fal",
    iconName: "meat",
    icon: [512, 512, [], "f814", "M343 115.9c-9.81 9.8-5.83 29.67 8.88 44.37s34.57 18.68 44.38 8.87 5.83-29.67-8.88-44.37-34.63-18.67-44.38-8.87zm100.67-47.32l-.05-.06C388.15 13.07 330.39 0 298.94 0 260.32 0 237 19.06 230.22 25.85 191.52 64.53 128 139.63 128 209.45v82.28l-11.47 11.48c-3.14 3.14-9.11 5.32-17.21 2.06A72.48 72.48 0 0 0 0 372.66c0 21.53 15.57 69.06 67.66 71.67C69.63 483.7 102 512 139.28 512c51.81 0 86.19-52.22 67.34-99.41-1-2.53-3.88-11.28 2-17.21L220.05 384h82.59c69.84 0 145-63.46 183.65-102.15 55.27-55.27 12.22-158.4-42.62-213.27zM302.64 352H206.8l-20.72 20.73c-13.08 13.08-16.61 32.86-9.15 51.74 23.45 58.7-74.31 78.88-77.34 18.26l-1.45-28.91-28.88-1.45c-50.58-2.54-49-80.3 3.2-80.3a40 40 0 0 1 15 2.89c17.7 7.13 38 4.7 51.76-9.12L160 305v-95.55c0-37.67 27-88.94 73.31-140.37a118.4 118.4 0 0 0 1.08 40.14c7.35 36.69 29.64 75.82 61.17 107.33 40 40 89.81 63.82 133.32 63.82a102.3 102.3 0 0 0 13.57-1.08C391.22 325.19 340.19 352 302.64 352zm161-115.42C440.24 260 374 249.7 318.17 193.91 264.46 140.22 250.94 73 275.49 48.46 298.92 25 365.19 35.35 421 91.13c53.84 53.87 66.93 121.19 42.67 145.45z"]
  },
      jz = {
    prefix: "fal",
    iconName: "medal",
    icon: [576, 512, [], "f5a2", "M332.37 275.41l-19.75-40.05c-9.44-18.81-39.91-18.86-49.28.08l-19.72 39.97-44.06 6.44c-10.44 1.5-18.94 8.67-22.22 18.7-3.25 10.02-.59 20.83 6.97 28.17l31.91 31.09-7.56 43.92c-3.91 22.74 20.25 39.5 39.87 28.97L288 411.97l39.44 20.72c19.35 10.13 43.87-5.88 39.91-28.95l-7.56-43.92 31.91-31.09c7.56-7.34 10.22-18.16 6.97-28.17-3.28-10.03-11.78-17.19-22.19-18.7l-44.11-6.45zm-6.96 73.25l8.84 51.45-46.25-24.3-46.34 24.91 8.94-52.06-37.41-36.47 51.69-7.53L288 257.78l23.12 46.88 51.69 7.53-37.4 36.47zM559.97 0H402.12c-11.24 0-21.66 5.9-27.44 15.54L288 160 201.32 15.54A31.997 31.997 0 0 0 173.88 0H16.03C3.08 0-4.5 14.57 2.92 25.18l144.12 205.88C125.14 260.4 112 296.65 112 336c0 97.05 78.95 176 176 176s176-78.95 176-176c0-39.35-13.14-75.6-35.04-104.94L573.08 25.18C580.5 14.57 572.92 0 559.97 0zM46.76 32h127.12l78.93 131.55c-31.95 6.51-60.65 21.84-83.78 43.13L46.76 32zM432 336c0 79.53-64.47 144-144 144s-144-64.47-144-144 64.47-144 144-144 144 64.47 144 144zm-25.03-129.32c-23.13-21.29-51.83-36.62-83.78-43.13L402.12 32h127.12L406.97 206.68z"]
  },
      Ez = {
    prefix: "fal",
    iconName: "medkit",
    icon: [512, 512, [], "f0fa", "M464 96H352V56c0-13.255-10.745-24-24-24H184c-13.255 0-24 10.745-24 24v40H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V144c0-26.51-21.49-48-48-48zM192 64h128v32H192V64zm192 64v320H128V128h256zM32 432V144c0-8.822 7.178-16 16-16h48v320H48c-8.822 0-16-7.178-16-16zm448 0c0 8.822-7.178 16-16 16h-48V128h48c8.822 0 16 7.178 16 16v288zM352 272v32c0 6.627-5.373 12-12 12h-56v56c0 6.627-5.373 12-12 12h-32c-6.627 0-12-5.373-12-12v-56h-56c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h56v-56c0-6.627 5.373-12 12-12h32c6.627 0 12 5.373 12 12v56h56c6.627 0 12 5.373 12 12z"]
  },
      kz = {
    prefix: "fal",
    iconName: "megaphone",
    icon: [576, 512, [], "f675", "M568 32h-16c-4.42 0-8 3.58-8 8v19.33L32 179.8V168c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v176c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-11.8l130.58 30.72c-1.56 6.8-2.58 13.8-2.58 21.07 0 53.02 42.98 96 96 96 45.13 0 82.45-31.3 92.64-73.29L544 452.67V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V40c0-4.42-3.58-8-8-8zM256 448c-35.29 0-64-28.71-64-64 0-4.75.72-9.31 1.76-13.74l124.13 29.21C310.92 427.27 285.93 448 256 448zM32 299.33v-86.66L544 92.2v327.6L32 299.33z"]
  },
      Iz = {
    prefix: "fal",
    iconName: "meh",
    icon: [496, 512, [], "f11a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm-80-232c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm16 160H152c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16z"]
  },
      Oz = {
    prefix: "fal",
    iconName: "meh-blank",
    icon: [496, 512, [], "f5a4", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm-80-296c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      Qz = {
    prefix: "fal",
    iconName: "meh-rolling-eyes",
    icon: [496, 512, [], "f5a5", "M224 224c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-72 40c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm192-112c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm64-104H184c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16z"]
  },
      Zz = {
    prefix: "fal",
    iconName: "memory",
    icon: [640, 512, [], "f538", "M496 272h32V144h-96v128h64zm-32-96h32v64h-32v-64zm-128 96h32V144h-96v128h64zm-32-96h32v64h-32v-64zm-128 96h32V144h-96v128h64zm-32-96h32v64h-32v-64zm488-16h8V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v64h8c13.26 0 24 10.74 24 24 0 13.25-10.74 24-24 24H0v240h640V208h-8c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24zm-24 256h-80v-16c0-8.84-7.16-16-16-16s-16 7.16-16 16v16h-96v-16c0-8.84-7.16-16-16-16s-16 7.16-16 16v16h-96v-16c0-8.84-7.16-16-16-16s-16 7.16-16 16v16h-96v-16c0-8.84-7.16-16-16-16s-16 7.16-16 16v16H32v-64h576v64zm0-282.59c-18.91 9-32 28.3-32 50.59s13.09 41.59 32 50.59V320H32v-85.41c18.9-9 32-28.3 32-50.59s-13.1-41.59-32-50.59V96h576v37.41z"]
  },
      Uz = {
    prefix: "fal",
    iconName: "menorah",
    icon: [640, 512, [], "f676", "M608 0s-32 46.33-32 64 14.33 32 32 32 32-14.33 32-32-32-64-32-64zm-96 96c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zM64 64C64 46.33 32 0 32 0S0 46.33 0 64s14.33 32 32 32 32-14.33 32-32zm552 64h-16c-4.42 0-8 3.58-8 8v168c0 26.51-21.49 48-48 48H336V136c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v216H96c-26.51 0-48-21.49-48-48V136c0-4.42-3.58-8-8-8H24c-4.42 0-8 3.58-8 8v168c0 44.18 35.82 80 80 80h208v96H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h432c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H336v-96h208c44.18 0 80-35.82 80-80V136c0-4.42-3.58-8-8-8zm-112 0c-4.42 0-8 3.58-8 8v184h32V136c0-4.42-3.58-8-8-8h-16zm-384 0c-4.42 0-8 3.58-8 8v184h32V136c0-4.42-3.58-8-8-8h-16zm288 0c-4.42 0-8 3.58-8 8v184h32V136c0-4.42-3.58-8-8-8h-16zm-192 0c-4.42 0-8 3.58-8 8v184h32V136c0-4.42-3.58-8-8-8h-16z"]
  },
      Bz = {
    prefix: "fal",
    iconName: "mercury",
    icon: [288, 512, [], "f223", "M288 208c0-57-33.1-106.2-81.1-129.6 24-14.9 40.9-37.9 45.3-64.5C253.4 6.6 247.7 0 240.3 0h-8.1c-5.7 0-10.7 4.1-11.8 9.7C214.8 40.4 182.7 64 144 64S73.2 40.4 67.6 9.7C66.6 4 61.6 0 55.8 0h-8.1c-7.4 0-13.1 6.6-11.9 13.9 4.4 26.6 21.3 49.7 45.3 64.5C33.1 101.8 0 151 0 208c0 74.2 56.2 135.3 128.3 143.1-.2.9-.3 1.8-.3 2.7V416H76c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h52v52c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-52h52c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-52v-62.2c0-.9-.1-1.8-.3-2.7C231.8 343.3 288 282.2 288 208zM144 320c-61.9 0-112-50-112-112 0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112z"]
  },
      Rz = {
    prefix: "fal",
    iconName: "meteor",
    icon: [512, 512, [], "f753", "M510.97268,31.81922C501.16,64.21764,477.1594,140.996,452.15883,199.185c2.90631.89041,5.50012,1.70271,7.90643,2.39a31.03387,31.03387,0,0,1,19.5942,17.69885,31.36973,31.36973,0,0,1-1.18753,26.39987c-22.59427,43.19268-81.22061,149.96374-139.5032,208.24652a198.87529,198.87529,0,0,1-280.91271,0c-77.408-77.38754-77.408-203.45081,0-280.83835C116.36986,114.79916,223.15357,56.11022,266.37331,33.61566a30.5167,30.5167,0,0,1,26.3756-1.18721,31.09638,31.09638,0,0,1,17.71916,19.589c.68752,2.40567,1.59379,4.99879,2.40631,7.90434,58.50134-25.30638,135.09685-49.0975,167.37884-58.892a24.72164,24.72164,0,0,1,30.71946,30.78943ZM476.06563,35.9276C435.65845,48.31523,360.75048,72.51251,309.3743,96.60043l-16.90664,7.90434-5.21887-17.99565c-2.78132-9.70078-5.37513-18.4018-7.37517-24.99395C239.24769,83.80665,135.74531,140.5898,80.65029,195.68585c-64.90774,64.87494-64.90774,170.55252,0,235.53681s170.72267,64.89056,235.59916,0c55.12627-55.08044,111.90883-158.55542,133.72183-200.45154-6.00014-.79668-14.71909-3.38981-24.40681-6.20163l-18.00042-5.18624,7.90643-16.90217C439.37728,151.49341,463.75284,76.30847,476.06563,35.9276Zm-148.19091,276.027c0,70.57668-57.40757,127.96906-128.00294,127.96906a127.96906,127.96906,0,1,1,0-255.93812C270.46715,183.98556,327.96847,241.47166,327.87472,311.95462Zm-32.00073.09372a96.00221,96.00221,0,1,0-96.00221,95.9768C252.873,408.02514,295.96774,364.94181,295.874,312.04834Zm-88.002-32.086a24.00055,24.00055,0,1,1-24.00055-23.9942A23.95369,23.95369,0,0,1,207.872,279.96235Zm32.00074,72.07633a16.00037,16.00037,0,1,1-16.00037-15.99614A16.04933,16.04933,0,0,1,239.8727,352.03868Z"]
  },
      Yz = {
    prefix: "fal",
    iconName: "microchip",
    icon: [512, 512, [], "f2db", "M368 0H144c-26.51 0-48 21.49-48 48v416c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zm16 464c0 8.822-7.178 16-16 16H144c-8.822 0-16-7.178-16-16V48c0-8.822 7.178-16 16-16h224c8.822 0 16 7.178 16 16v416zm128-358v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"]
  },
      Pz = {
    prefix: "fal",
    iconName: "microphone",
    icon: [320, 512, [], "f130", "M160 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S64 42.98 64 96v160c0 53.02 42.98 96 96 96zM96 96c0-35.29 28.71-64 64-64s64 28.71 64 64v160c0 35.29-28.71 64-64 64s-64-28.71-64-64V96zm216 96h-16c-4.42 0-8 3.58-8 8v56c0 73.46-62.2 132.68-136.73 127.71C83.3 379.18 32 319.61 32 251.49V200c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v50.34c0 83.39 61.65 156.12 144 164.43V480H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h176c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-72v-65.01C256.71 406.9 320 338.8 320 256v-56c0-4.42-3.58-8-8-8z"]
  },
      Fz = {
    prefix: "fal",
    iconName: "microphone-alt",
    icon: [320, 512, [], "f3c9", "M160 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S64 42.98 64 96v160c0 53.02 42.98 96 96 96zM96 96c0-35.29 28.71-64 64-64s64 28.71 64 64h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v32h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v32h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56c0 35.29-28.71 64-64 64s-64-28.71-64-64V96zm216 96h-16c-4.42 0-8 3.58-8 8v56c0 73.46-62.2 132.68-136.73 127.71C83.3 379.18 32 319.61 32 251.49V200c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v50.34c0 83.39 61.64 156.12 144 164.43V480H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h176c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-72v-65.01C256.71 406.9 320 338.8 320 256v-56c0-4.42-3.58-8-8-8z"]
  },
      Wz = {
    prefix: "fal",
    iconName: "microphone-alt-slash",
    icon: [640, 512, [], "f539", "M256 96c0-35.3 28.7-64 64-64s64 28.7 64 64h-56c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56v32h-56c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56v32h-27l57.7 45.4c.6-4.4 1.3-8.8 1.3-13.4V96c0-53-43-96-96-96s-96 43-96 96v23.3l32 25.2zm224 160v-56c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56c0 12.3-2.3 24-5.6 35.3l27 21.3C476.2 295 480 276 480 256zm-160 96c12.6 0 24.5-2.6 35.5-7l-32.2-25.4c-1.1.1-2.1.3-3.3.3-31.3 0-57.3-22.6-62.8-52.4l-33.2-26V256c0 53 43 96 96 96zm317 133.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zM408 480h-72v-65c27.2-2.7 52.1-12.7 73.6-27.3l-26.4-20.8c-21 12-45.6 18.6-71.9 16.8-68-4.5-119.3-64.1-119.3-132.2v-35.2l-28.5-22.5c-2 1.5-3.5 3.5-3.5 6.1v50.3c0 83.4 61.6 156.1 144 164.4V480h-72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      Gz = {
    prefix: "fal",
    iconName: "microphone-slash",
    icon: [640, 512, [], "f131", "M256 96c0-35.3 28.7-64 64-64s64 28.7 64 64v149.3l30.7 24.1c.6-4.4 1.3-8.8 1.3-13.4V96c0-53-43-96-96-96s-96 43-96 96v23.3l32 25.2zm224 160v-56c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56c0 12.3-2.3 24-5.6 35.3l27 21.3C476.2 295 480 276 480 256zm-72 224h-72v-65c27.2-2.7 52.1-12.7 73.6-27.3l-26.4-20.8c-21 12-45.6 18.6-71.9 16.8-68-4.5-119.3-64.1-119.3-132.2v-35.2l-28.5-22.5c-2 1.5-3.5 3.5-3.5 6.1v50.3c0 83.4 61.7 156.1 144 164.4V480h-72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-88-128c12.6 0 24.5-2.6 35.5-7l-32.2-25.4c-1.1.1-2.1.3-3.3.3-31.3 0-57.3-22.6-62.8-52.4l-33.2-26V256c0 53 43 96 96 96zm317 133.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3z"]
  },
      qz = {
    prefix: "fal",
    iconName: "microphone-stand",
    icon: [512, 512, [], "f8cb", "M475.78 33.5a122.38 122.38 0 0 0-170.45 2.13l-28.77 28.68a121 121 0 0 0-35.66 85.08L12.06 406.85a47.88 47.88 0 0 0 2 65.71l25.46 25.38a48.27 48.27 0 0 0 65.93 2l150.42-133.6V504a8 8 0 0 0 8 8H280a8 8 0 0 0 8-8V338l75.85-66.08a121.82 121.82 0 0 0 85.37-35.54l25.09-25C523 162.86 525.64 80.79 475.78 33.5zM84.25 476a16.08 16.08 0 0 1-22-.68l-25.44-25.39a16 16 0 0 1-.72-21.86l219.39-246.83 76.4 76.13zM426.5 213.74a89.56 89.56 0 0 1-62.92 26.17h-3.8L273 153.42v-3.78a88.92 88.92 0 0 1 26.27-62.7l11.06-11 127.24 126.77zm33.28-34.14L333.52 53.77A89.34 89.34 0 0 1 459.78 179.6z"]
  },
      Jz = {
    prefix: "fal",
    iconName: "microscope",
    icon: [512, 512, [], "f610", "M456 416h-40.99C454.22 386.81 480 340.52 480 288c0-88.22-71.78-160-160-160V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32v48c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-48c17.67 0 32-14.33 32-32V160c70.59 0 128 57.42 128 128s-57.41 128-128 128H56c-30.88 0-56 25.12-56 56 0 22.06 17.94 40 40 40h432c22.06 0 40-17.94 40-40 0-30.88-25.12-56-56-56zm-200-64h-64v-32h64v32zm32-64H160V64h32V32h64v32h32v224zm184 192H40c-4.42 0-8-3.58-8-8 0-13.26 10.75-24 24-24h400c13.25 0 24 10.74 24 24 0 4.42-3.58 8-8 8z"]
  },
      Kz = {
    prefix: "fal",
    iconName: "microwave",
    icon: [512, 512, [], "e01b", "M480,64H32A32,32,0,0,0,0,96V416a32,32,0,0,0,32,32H48l24,32h48l24-32H368l24,32h48l24-32h16a32,32,0,0,0,32-32V96A32,32,0,0,0,480,64Zm0,352H32V96H480ZM432,256a16,16,0,1,0-16-16A16,16,0,0,0,432,256Zm0-64a16,16,0,1,0-16-16A16,16,0,0,0,432,192ZM96,384H352a32,32,0,0,0,32-32V160a32,32,0,0,0-32-32H96a32,32,0,0,0-32,32V352A32,32,0,0,0,96,384Zm0-224H352V352H96Z"]
  },
      Xz = {
    prefix: "fal",
    iconName: "mind-share",
    icon: [640, 512, [], "f677", "M288.1 272.6V76c0-24.3 19.8-44 44.2-44 30.7 0 39.9 22.5 45.8 45.5l12.7-.3h.4c25.9 0 45.5 19.7 45.5 43.8 0 6.2-1.7 11.9-4.2 22.8 22.4 9.1 40.8 20.7 47 42.9 2.8-1.7 5.2-3.7 8.3-5 3.6-1.5 7.3-2.6 11.1-3.4 3.7-.8 7.5-1.2 11.3-1.3-8.5-26.1-28.2-44.4-41.5-52 2.7-37.7-25.9-74.3-66.7-79.4C390 18.2 362.8 0 332.2 0 307.6 0 286 11.9 272 29.9 258 11.9 236.4 0 211.8 0c-30.6 0-57.7 18.2-69.7 45.6-40.8 5.1-69.3 41.7-66.7 79.4-21 12.2-58.6 50.9-41.1 105.3C12.9 247.4 0 273.4 0 301c0 32.7 17.4 62.4 45.3 78.5-2.3 48.2 36.7 88.7 84.9 87.4 14.2 27.4 42.6 45 74.1 45 19.1 0 36.5-6.8 50.6-17.7-6.3-8.7-11.8-17.9-16.2-27.6-9.1 8.2-21.1 13.3-34.3 13.3-31.9 0-44.2-21.8-53.1-48.2-16.3 2.7-18.3 3.2-22.2 3.2-28.5 0-51.7-23.1-51.7-51.5 0-6.2.9-9.1 3.7-23-25.6-10.4-49-24.1-49-59.4 0-33.9 23-46.9 42.9-58.3-12.6-25.7-12.8-29.2-12.8-39.2 0-33.9 21.9-48.5 49.4-59.7-2.5-10.9-4.2-16.6-4.2-22.8 0-24.1 19.6-43.8 45.5-43.8h.4l12.7.3c5.9-22.9 15-45.5 45.8-45.5 24.3 0 44.2 19.7 44.2 44v228.4c9-12.1 20-22.7 32.1-31.8zm342.2 40.6l-96-95.2c-9.2-9.2-22.4-11.7-34.3-6.8-12.1 5.1-19.9 17-19.9 30.4v31.2h-97.2c-6.1-.1-12 0-18.1 1-53.8 7.9-97.5 50.6-106.7 103.9 0 .2-.1.5-.2.7-8.4 50.3 13.2 100.9 55.2 128.8 4.8 3.2 10.2 4.8 15.6 4.8 18.7 0 32.6-18.9 26.3-37.6-4.3-12.8-4.9-39.6 7.4-56.9 8.1-11.2 20.4-16.7 37.7-16.7h80V432c0 13.4 7.8 25.3 19.9 30.4 11.9 5 25.1 2.4 34.3-6.8l96-95.2c6.2-6.2 9.7-14.6 9.7-23.5s-3.4-17.4-9.7-23.7zM512 432v-63.2H400c-34.8 0-53.8 16.3-63.7 30-17 23.7-18.3 54.4-14.5 75-25.5-21.8-38.1-56-32.4-90.1 6.7-40.2 39.6-72.3 80-78.2 4.4-.7 8.7-.6 14.7-.6h128l-.3-64.1 96 95.2-95.8 96z"]
  },
      _z = {
    prefix: "fal",
    iconName: "minus",
    icon: [384, 512, [], "f068", "M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"]
  },
      $z = {
    prefix: "fal",
    iconName: "minus-circle",
    icon: [512, 512, [], "f056", "M140 274c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v12c0 6.6-5.4 12-12 12H140zm364-18c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z"]
  },
      cC = {
    prefix: "fal",
    iconName: "minus-hexagon",
    icon: [576, 512, [], "f307", "M441.5 39.8C432.9 25.1 417.1 16 400 16H176c-17.1 0-32.9 9.1-41.5 23.8l-112 192c-8.7 14.9-8.7 33.4 0 48.4l112 192c8.6 14.7 24.4 23.8 41.5 23.8h224c17.1 0 32.9-9.1 41.5-23.8l112-192c8.7-14.9 8.7-33.4 0-48.4l-112-192zm84.3 224.3l-112 192c-2.9 4.9-8.2 7.9-13.8 7.9H176c-5.7 0-11-3-13.8-7.9l-112-192c-2.9-5-2.9-11.2 0-16.1l112-192c2.8-5 8.1-8 13.8-8h224c5.7 0 11 3 13.8 7.9l112 192c2.9 5 2.9 11.2 0 16.2zM172 274c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v12c0 6.6-5.4 12-12 12H172z"]
  },
      eC = {
    prefix: "fal",
    iconName: "minus-octagon",
    icon: [512, 512, [], "f308", "M361.5 14.1c-9-9-21.2-14.1-33.9-14.1H184.5c-12.7 0-24.9 5.1-33.9 14.1L14.1 150.5c-9 9-14.1 21.2-14.1 33.9v143.1c0 12.7 5.1 24.9 14.1 33.9l136.5 136.5c9 9 21.2 14.1 33.9 14.1h143.1c12.7 0 24.9-5.1 33.9-14.1L498 361.4c9-9 14.1-21.2 14.1-33.9v-143c0-12.7-5.1-24.9-14.1-33.9L361.5 14.1zM480 327.5c0 4.3-1.7 8.3-4.7 11.3L338.9 475.3c-3 3-7 4.7-11.3 4.7H184.5c-4.3 0-8.3-1.7-11.3-4.7L36.7 338.9c-3-3-4.7-7-4.7-11.3V184.5c0-4.3 1.7-8.3 4.7-11.3L173.1 36.7c3-3 7-4.7 11.3-4.7h143.1c4.3 0 8.3 1.7 11.3 4.7l136.5 136.5c3 3 4.7 7 4.7 11.3v143zM140 274c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v12c0 6.6-5.4 12-12 12H140z"]
  },
      aC = {
    prefix: "fal",
    iconName: "minus-square",
    icon: [448, 512, [], "f146", "M400 64c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352m0-32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-60 242c6.6 0 12-5.4 12-12v-12c0-6.6-5.4-12-12-12H108c-6.6 0-12 5.4-12 12v12c0 6.6 5.4 12 12 12h232z"]
  },
      nC = {
    prefix: "fal",
    iconName: "mistletoe",
    icon: [576, 512, [], "f7b4", "M542.1 197.4c-29-29-104.4-41.3-143.9-45.8L304 57.4V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v49.4l-94.2 94.2c-39.5 4.6-114.9 16.9-143.9 45.8-40 40-45.4 99.4-12.1 132.7C36.5 344.8 56.3 352 77.2 352c26.6 0 55-11.5 77.4-33.9 14.9-14.9 25.3-42 32.6-70.2 5.6 4.9 12.7 8.1 20.8 8.1 17.7 0 32-14.3 32-32s-14.3-32-32-32c-3.6 0-6.9 1-10.2 2.1 1.1-7.3 1.9-13.9 2.6-19.9l71.6-71.6v170.5c-27.3 30.4-80 94.5-80 136.4 0 56.6 43 102.4 96 102.4s96-45.8 96-102.4c0-41.9-52.7-106-80-136.4V102.6l71.6 71.6c4.6 39.5 16.9 114.9 45.8 143.9 22.4 22.4 50.8 33.9 77.4 33.9 20.9 0 40.7-7.2 55.4-21.8 33.3-33.4 27.9-92.8-12.1-132.8zM132 295.5C116.4 311.1 96.4 320 77.2 320c-9.2 0-22.4-2.2-32.7-12.5C24 287.1 29.6 247 56.5 220c16.5-16.5 66.2-28.7 110.4-35-6.1 44.2-18.3 93.9-34.9 110.5zm220 114.1c0 38.8-28.7 70.4-64 70.4s-64-31.6-64-70.4c0-23.5 32.9-70.4 64-106.4 31.1 36 64 82.8 64 106.4zm179.5-102.1C521.2 317.8 508 320 498.8 320c-19.2 0-39.2-8.9-54.8-24.5-16.5-16.5-28.7-66.2-35-110.4 44.2 6.2 93.8 18.4 110.4 35 27 26.9 32.6 67 12.1 87.4zM384 64c17.7 0 32-14.3 32-32S401.7 0 384 0s-32 14.3-32 32 14.3 32 32 32z"]
  },
      tC = {
    prefix: "fal",
    iconName: "mitten",
    icon: [448, 512, [], "f7b5", "M420.9 197.6c-13.5-11.4-30.6-17.6-48.2-17.6-21.9 0-42.5 9.5-56.9 26.1l-20.4-89C279.7 48.1 219.8 0 149.8 0c-11.3 0-22.7 1.3-33.8 3.9C35.6 22.6-14.7 103.9 3.8 185l44.6 195c.4 1.9 1.1 3.7 1.6 5.6-9.4 3.1-18 11.8-18 22.4v80c0 13.3 10.7 24 23.8 24h303.1c13.1 0 25.2-10.7 25.2-24v-80c0-11.4-9.4-20.4-19.9-22.9l66.4-80.4c26.6-32.2 22.2-80.2-9.7-107.1zM352 480H64v-64h288v64zm54.2-195.8L323.7 384H82.9c-1.2-3.7-2.7-7.4-3.6-11.3l-44.6-195C20.1 113.8 59.7 49.8 123.1 35c8.8-2 17.7-3.1 26.6-3.1 55.2 0 102.4 37.9 114.8 92.3L292 244.6l7.2 31.4 20.5-24.8 19.4-23.5c8.3-10.1 20.5-15.8 33.5-15.8 10.2 0 20 3.6 27.9 10.2 18.6 15.6 21.1 43.4 5.7 62.1z"]
  },
      rC = {
    prefix: "fal",
    iconName: "mobile",
    icon: [320, 512, [], "f10b", "M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zM320 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-32 0c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V48z"]
  },
      iC = {
    prefix: "fal",
    iconName: "mobile-alt",
    icon: [320, 512, [], "f3cd", "M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm32-320H96v240h128V96m20-32c6.6 0 12 5.4 12 12v280c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h168zm76-16v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-32 0c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V48z"]
  },
      oC = {
    prefix: "fal",
    iconName: "mobile-android",
    icon: [320, 512, [], "f3ce", "M196 448h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12zM320 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-32 0c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V48z"]
  },
      lC = {
    prefix: "fal",
    iconName: "mobile-android-alt",
    icon: [320, 512, [], "f3cf", "M224 96v240H96V96h128m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM244 64H76c-6.6 0-12 5.4-12 12v280c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-48 352h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"]
  },
      fC = {
    prefix: "fal",
    iconName: "money-bill",
    icon: [640, 512, [], "f0d6", "M320 144c-53 0-96 50.1-96 112 0 61.8 43 112 96 112s96-50.1 96-112-43-112-96-112zm0 192c-35.3 0-64-35.9-64-80s28.7-80 64-80 64 35.9 64 80-28.7 80-64 80zM608 64H32C14.3 64 0 78.3 0 96v320c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM32 96h64c0 35.3-28.7 64-64 64V96zm0 320v-64c35.3 0 64 28.7 64 64H32zm576 0h-64c0-35.3 28.7-64 64-64v64zm0-96c-52.9 0-96 43.1-96 96H128c0-52.9-43.1-96-96-96V192c52.9 0 96-43.1 96-96h384c0 52.9 43.1 96 96 96v128zm0-160c-35.3 0-64-28.7-64-64h64v64z"]
  },
      sC = {
    prefix: "fal",
    iconName: "money-bill-alt",
    icon: [640, 512, [], "f3d1", "M608 64H32C14.3 64 0 78.3 0 96v320c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM32 96h64c0 35.3-28.7 64-64 64zm0 320v-64c35.3 0 64 28.7 64 64zm576 0h-64c0-35.3 28.7-64 64-64zm0-96c-52.9 0-96 43.1-96 96H128c0-52.9-43.1-96-96-96V192c52.9 0 96-43.1 96-96h384c0 52.9 43.1 96 96 96zm0-160c-35.3 0-64-28.7-64-64h64zm-288-32c-61.9 0-112 57.3-112 128s50.1 128 112 128c61.8 0 112-57.3 112-128s-50.1-128-112-128zm0 224c-44.1 0-80-43.1-80-96s35.9-96 80-96 80 43.1 80 96-35.9 96-80 96zm32-63.9h-16v-88c0-4.4-3.6-8-8-8h-13.7c-4.7 0-9.4 1.4-13.3 4l-15.3 10.2c-3.7 2.5-4.6 7.4-2.2 11.1l8.9 13.3c2.5 3.7 7.4 4.6 11.1 2.2l.5-.3V288h-16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-7.9z"]
  },
      uC = {
    prefix: "fal",
    iconName: "money-bill-wave",
    icon: [640, 512, [], "f53a", "M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm0 192c-35.29 0-64-35.89-64-80s28.71-80 64-80 64 35.89 64 80-28.71 80-64 80zM621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34C70.34 94.34 46.9 79 32.25 79 15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.33-62.35 369.5-62.35 64.91 0 88.34 15.35 103 15.35 17.21 0 32.25-13.32 32.25-31.81V83.93c0-12.64-7.23-24.6-18.84-29.47zm-588.21 56.8c20.22 6.42 41.03 10.53 62.67 12.89-1.97 33.41-29.23 60.04-62.89 60.43l.22-73.32zM32 428.07l.13-42.54c33.58.07 60.88 26.31 63.38 59.43-22.45-3.04-43.63-8.45-63.51-16.89zm575.05-27.33c-20.16-6.4-40.9-10.51-62.47-12.87 2.89-32.5 29.69-58.14 62.69-58.52l-.22 71.39zm.31-103.54c-50 .34-90.59 39.32-94.58 88.6-70.73-1.43-137.18 15.82-200.6 31.87-75.07 19-126.54 31.21-184.41 29.87-1.23-52.02-43.48-94.01-95.55-94.13l.41-136.67c50.65-.34 91.72-40.32 94.78-90.52 70.53 1.41 137.02-15.83 200.4-31.87C402.6 75.41 454.3 63.13 512.03 64.46c.18 52.93 43.01 95.94 95.74 96.07l-.41 136.67zm.51-168.8c-34.24-.07-62.04-27.34-63.58-61.38 22.53 3.03 43.78 8.45 63.71 16.91l-.13 44.47z"]
  },
      hC = {
    prefix: "fal",
    iconName: "money-bill-wave-alt",
    icon: [640, 512, [], "f53b", "M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm0 192c-35.29 0-64-35.89-64-80s28.71-80 64-80 64 35.89 64 80-28.71 80-64 80zM621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34C70.34 94.34 46.9 79 32.25 79 15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.33-62.35 369.5-62.35 64.91 0 88.34 15.35 103 15.35 17.21 0 32.25-13.32 32.25-31.81V83.93c0-12.64-7.23-24.6-18.84-29.47zm-22.69 344c-16.94-4.79-45.28-12.8-93.72-12.8-65.57 0-130.15 16.34-192.6 32.15-61.35 15.53-119.3 30.2-176.9 30.2-37.96 0-71.99-6.53-103.25-19.93l-.49-317.1c1.55.18 6.25 1.51 10.02 2.57 16.93 4.79 45.28 12.8 93.71 12.8 65.57 0 130.14-16.35 192.59-32.15C389.2 78.66 447.15 64 504.75 64c37.97 0 72 6.54 103.25 19.93l.49 317.1c-1.55-.18-6.25-1.51-10.02-2.57z"]
  },
      mC = {
    prefix: "fal",
    iconName: "money-check",
    icon: [640, 512, [], "f53c", "M624 32H16C7.16 32 0 39.16 0 48v400c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V48c0-8.84-7.16-16-16-16zm-16 416H32V160h576v288zm0-320H32V64h576v64zM104 384h144c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm288 0h144c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H392c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm-288-96h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm296 0h128c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16H400c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16zm16-64h96v32h-96v-32z"]
  },
      vC = {
    prefix: "fal",
    iconName: "money-check-alt",
    icon: [640, 512, [], "f53d", "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 416H32V64h576v384zM296 320h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm240-32h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-240-64h240c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H296c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm-161.28 33.72l42.19 11.44c4.19 1.14 7.09 4.55 7.09 8.3 0 4.8-4.5 8.7-10.06 8.7H147.6c-4.15 0-8.23-1.04-11.77-2.95-3.08-1.67-6.84-1.37-9.24 1.18l-12.07 12.73c-3.11 3.28-2.6 8.64 1.13 11.19 8.3 5.65 18.06 8.88 28.35 9.52V328c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-10.25c22.18-1.1 40-18.57 40-40.3 0-18.17-12.62-34.28-30.72-39.17l-42.19-11.44c-4.19-1.14-7.09-4.55-7.09-8.3 0-4.8 4.5-8.7 10.06-8.7h26.34c4.15 0 8.23 1.04 11.77 2.95 3.08 1.66 6.84 1.37 9.24-1.18l12.07-12.73c3.11-3.28 2.6-8.64-1.13-11.19-8.3-5.65-18.06-8.88-28.35-9.52V168c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v10.25c-22.18 1.1-40 18.57-40 40.3 0 18.17 12.62 34.28 30.72 39.17z"]
  },
      dC = {
    prefix: "fal",
    iconName: "money-check-edit",
    icon: [640, 512, [], "f872", "M425.23 406.49A32.06 32.06 0 0 0 448 416h64a32 32 0 0 0 32-32v-64a32 32 0 0 0-9.5-22.76L246.68 12.07a41.15 41.15 0 0 0-58.24 0l-48.38 48.4A41.48 41.48 0 0 0 128 89.89 40.68 40.68 0 0 0 140.34 119zM289.46 100L512 320v64h-64L228.1 161.4l61.36-61.4zM162.69 83.09l48.39-48.4A9.21 9.21 0 0 1 217.6 32a9 9 0 0 1 6.45 2.69l44.53 44.54-61.36 61.38-44.53-44.54a9.18 9.18 0 0 1 0-12.98zM128 408a8 8 0 0 0 8 8h253.61l-31.71-32H136a8 8 0 0 0-8 8zm8-88h158.49l-31.71-32H136a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm472-192H409.15l32.3 32H608v320H32V160h104l-18-18.12A73.25 73.25 0 0 1 107.13 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"]
  },
      MC = {
    prefix: "fal",
    iconName: "money-check-edit-alt",
    icon: [640, 512, [], "f873", "M425.23 406.49A32.06 32.06 0 0 0 448 416h64a32 32 0 0 0 32-32v-64a32 32 0 0 0-9.5-22.76L246.68 12.07a41.15 41.15 0 0 0-58.24 0l-48.38 48.4A41.48 41.48 0 0 0 128 89.89 40.68 40.68 0 0 0 140.34 119zM289.46 100L512 320v64h-64L228.1 161.4l61.36-61.4zM162.69 83.09l48.39-48.4A9.21 9.21 0 0 1 217.6 32a9 9 0 0 1 6.45 2.69l44.53 44.54-61.36 61.38-44.53-44.54a9.18 9.18 0 0 1 0-12.98zM224 408a8 8 0 0 0 8 8h157.61l-31.71-32H232a8 8 0 0 0-8 8zm8-88h62.49l-31.71-32H232a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm376-192H409.15l32.3 32H608v320H32V160h104l-18-18.12A73.25 73.25 0 0 1 107.13 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32zM136 424h16a8 8 0 0 0 8-8v-16.12c23.62-.63 42.67-20.54 42.67-45.07 0-20-13-37.81-31.58-43.39l-45-13.5c-5.16-1.54-8.77-6.78-8.77-12.73 0-7.27 5.29-13.19 11.79-13.19h28.11a24 24 0 0 1 12.82 3.72 8.21 8.21 0 0 0 10.13-.73l11.75-11.21a8 8 0 0 0-.57-12.14A57.15 57.15 0 0 0 160 240.29V224a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16.12c-23.62.63-42.67 20.55-42.67 45.07 0 20 13 37.81 31.58 43.39l45 13.5c5.16 1.54 8.77 6.78 8.77 12.73 0 7.27-5.29 13.19-11.79 13.19h-28.12a24.08 24.08 0 0 1-12.77-3.72 8.21 8.21 0 0 0-10.13.73l-11.8 11.21a8 8 0 0 0 .57 12.14A57.23 57.23 0 0 0 128 399.71V416a8 8 0 0 0 8 8z"]
  },
      pC = {
    prefix: "fal",
    iconName: "monitor-heart-rate",
    icon: [576, 512, [], "f611", "M544 0H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm0 480H32V272h134.12l43.56 87.16c2.72 5.45 8.28 8.84 14.31 8.84.38 0 .75-.02 1.12-.05 6.47-.45 12-4.75 14.06-10.89L288 210.59l16.81 50.45c2.18 6.54 8.3 10.95 15.19 10.95h152c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H331.53l-28.34-85.06c-4.38-13.06-26-13.06-30.38 0L221.03 310.3l-30.72-61.45a15.996 15.996 0 0 0-14.31-8.84H32V32h512v448z"]
  },
      zC = {
    prefix: "fal",
    iconName: "monkey",
    icon: [640, 512, [], "f6fb", "M576 192c35.35 0 64-28.65 64-64 0-41.85-35.37-64-64-64h-5.88C556.9 26.8 521.74 0 480 0s-76.9 26.8-90.12 64H384c-28.22 0-64 21.93-64 64 0 35.35 28.65 64 64 64h5.88C391.02 195.2 192 218.88 192 416v32c0 11.71 3.39 22.55 8.9 32H176c-26.47 0-48-21.53-48-48V192c0-35.3-28.72-64-64-64S0 156.7 0 192v48c0 8.84 7.16 16 16 16s16-7.16 16-16v-48c0-17.64 14.34-32 32-32s32 14.36 32 32v240c0 44.11 35.88 80 80 80h240c17.67 0 32-14.33 32-32 0-26.5-16.19-49.3-39.21-59l72.48-54.79L512 458.36V480c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-26.8c0-8.62-1.38-17.15-4.11-25.33l-65.42-192.21c14.4-11.15 25.44-26.16 31.65-43.65H576zm0-96c14.22 0 32 11.05 32 32 0 17.64-14.36 32-32 32V96zm-192 64c-17.64 0-32-14.36-32-32 0-20.84 17.57-32 32-32v64zm189.53 277.98c1.63 4.9 2.47 10.04 2.47 15.21V480h-32v-26.83L497.54 313.8 320 448h64c17.66 0 32 14.36 32 32H256c-17.67 0-32-14.33-32-32v-32c0-103.74 82.34-188.04 185.2-191.66C426.76 243.66 451.84 256 480 256c10.48 0 20.38-2.1 29.82-5.2l63.71 187.18zM544 160c0 35.29-28.71 64-64 64s-64-28.71-64-64V96c0-35.29 28.71-64 64-64s64 28.71 64 64v64zm-96-64c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm64 0c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"]
  },
      CC = {
    prefix: "fal",
    iconName: "monument",
    icon: [384, 512, [], "f5a6", "M368 416h-48l-30.86-315.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69C200.19 1.56 196.09 0 192 0s-8.19 1.56-11.31 4.69L104.08 81.3a31.97 31.97 0 0 0-9.21 19.44L64 416H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM126.71 103.92l65.3-65.3 65.29 65.23L287.85 416H96.15l30.56-312.08zM352 480H32v-32h320v32zM232 256h-80c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      LC = {
    prefix: "fal",
    iconName: "moon",
    icon: [512, 512, [], "f186", "M448.964 365.617C348.188 384.809 255.14 307.765 255.14 205.419c0-58.893 31.561-112.832 82.574-141.862 25.83-14.7 19.333-53.859-10.015-59.28A258.114 258.114 0 0 0 280.947 0c-141.334 0-256 114.546-256 256 0 141.334 114.547 256 256 256 78.931 0 151.079-35.924 198.85-94.783 18.846-23.22-1.706-57.149-30.833-51.6zM280.947 480c-123.712 0-224-100.288-224-224s100.288-224 224-224c13.984 0 27.665 1.294 40.94 3.745-58.972 33.56-98.747 96.969-98.747 169.674 0 122.606 111.613 214.523 231.81 191.632C413.881 447.653 351.196 480 280.947 480z"]
  },
      AC = {
    prefix: "fal",
    iconName: "moon-cloud",
    icon: [576, 512, [], "f754", "M320 300.8c0-45.4-36.6-82.4-81.8-83.2-16.1-34.1-50.8-57.6-90.2-57.6-41.7 0-77.6 25.2-92.5 62.5C23 233.9 0 264.6 0 300.8 0 346.7 37.3 384 83.2 384h153.6c45.9 0 83.2-37.3 83.2-83.2zM236.8 352H83.2C54.9 352 32 329.1 32 300.8c0-27.5 21.8-49.8 49-51 4.9-32.7 32.9-57.8 67-57.8 35.8 0 64.8 27.8 67.5 62.9 6.5-3.1 13.6-5.3 21.3-5.3 28.3 0 51.2 22.9 51.2 51.2S265.1 352 236.8 352zm336.8-.8c-4.1-8.6-12.4-13.9-21.8-13.9-1.5 0-3 .1-4.6.4-7.7 1.5-15.5 2.2-23.2 2.2-67 0-121.5-54.7-121.5-121.9 0-43.7 23.6-84.3 61.6-106 8.9-5.1 13.6-15 11.9-25.1-1.7-10.2-9.4-17.9-19.5-19.8-11.5-2.1-23.3-3.2-35-3.2-76.6 0-142.7 45.3-173.4 110.5 3.5 4.1 6.8 8.5 9.8 13 5.9 1.1 11.6 2.8 17.1 4.8C299.7 135.8 356 96 421.5 96c3 0 5.9.1 8.9.2-37.4 28.9-59.9 73.9-59.9 121.9C370.5 303 439.4 372 524 372c2.6 0 5.2-.1 7.8-.2C502.2 400.1 463 416 421.5 416c-38.4 0-73.2-14.2-100.8-36.9-7.6 8.1-16.3 14.9-25.9 20.6 33.8 29.9 78.1 48.2 126.7 48.2 58.1 0 112.4-25.9 149-71.1 6-7.2 7.2-17.1 3.1-25.6z"]
  },
      NC = {
    prefix: "fal",
    iconName: "moon-stars",
    icon: [512, 512, [], "f755", "M333.9 426.2c-.6 0-1.2.1-1.8.2-9.6 1.8-19.2 2.7-28.6 2.7-81.3 0-150-66.1-150-150.4 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7-11.6-2.1-23.3-3.2-35-3.2C85.9 128 0 213.9 0 320c0 106 85.8 192 191.8 192 59.2 0 113.2-26.9 149-71.1 4.9-6 .3-14.7-6.9-14.7zM191.8 480C103.7 480 32 408.2 32 320c0-78.5 56.8-144 131.4-157.5-26.6 32.2-41.8 73.2-41.8 116.2 0 89.8 65.1 164.7 150.5 179.7-24 14-51.6 21.6-80.3 21.6zm311.4-286.3l-48.6-24.3-24.3-48.6c-5.4-10.8-23.2-10.8-28.6 0l-24.3 48.6-48.6 24.3c-5.4 2.7-8.8 8.2-8.8 14.3s3.4 11.6 8.8 14.3l48.6 24.3 24.3 48.6c2.7 5.4 8.2 8.8 14.3 8.8s11.6-3.4 14.3-8.8l24.3-48.6 48.6-24.3c5.4-2.7 8.8-8.2 8.8-14.3s-3.4-11.6-8.8-14.3zm-67.7 26.7c-3.1 1.5-5.6 4.1-7.2 7.2L416 252.2l-12.3-24.7c-1.6-3.1-4.1-5.6-7.2-7.2L371.8 208l24.7-12.4c3.1-1.5 5.6-4.1 7.2-7.2l12.3-24.7 12.3 24.7c1.6 3.1 4.1 5.6 7.2 7.2l24.7 12.4-24.7 12.4zM304 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32z"]
  },
      gC = {
    prefix: "fal",
    iconName: "mortar-pestle",
    icon: [512, 512, [], "f5a7", "M504 192H390.63L497.36 85.27c24.11-24.11 17.51-64.75-12.98-80A49.957 49.957 0 0 0 462.05 0c-10.62 0-21.16 3.38-29.98 9.99L189.39 192H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h24v32c0 81.42 50.76 150.83 122.29 178.75-12.76 16.78-21.7 36.63-24.92 58.44-1.45 9.83 5.98 18.81 15.92 18.81h221.42c9.94 0 17.37-8.97 15.92-18.81-3.21-21.81-12.15-41.67-24.92-58.44C429.24 406.83 480 337.42 480 256v-32h24c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM451.26 35.59c17.58-13.18 39.21 11.31 23.47 27.05L345.38 192H242.72L451.26 35.59zM448 256c0 66.31-40.01 124.77-101.92 148.94l-39.51 15.42 25.68 33.76c6.08 8 10.87 16.75 14.19 25.88H165.57c3.32-9.13 8.1-17.88 14.19-25.88l25.68-33.76-39.51-15.42C104.01 380.77 64 322.31 64 256v-32h384v32z"]
  },
      HC = {
    prefix: "fal",
    iconName: "mosque",
    icon: [640, 512, [], "f678", "M240 384c-29.53 0-48 25.06-48 49.89V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72c0-8.83 7.19-16 16-16s16 7.17 16 16v72c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72c0-26.47-21.53-48-48-48zm352-128h-6.17c3.77-8.64 6.17-17.59 6.17-26.91 0-53.93-43.52-95.46-90.74-124.66C459.48 78.59 426.39 52.01 384 0c-42.25 51.85-74.61 78.05-117.26 104.43-47.22 29.2-90.74 70.73-90.74 124.66 0 9.32 2.4 18.27 6.17 26.91H176c-5.64 0-10.97 1.15-16 2.95V120C160 40 80 0 80 0S0 40 0 120v392h32V192h96v312c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V304c0-8.84 7.16-16 16-16h416c8.84 0 16 7.16 16 16v200c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V304c0-26.51-21.49-48-48-48zm-464-96H32v-40c0-40.6 29.55-68.62 48-82.15C98.45 51.38 128 79.4 128 120v40zm421.07 96H218.93c-7.26-9.22-10.93-18.24-10.93-26.91 0-33.03 24.56-65.27 73-95.84 40.99-25.86 74.89-53.45 103-83.86 28.11 30.41 62.02 58 103 83.86 48.44 30.56 73 62.81 73 95.84 0 8.67-3.67 17.69-10.93 26.91zM384 320c-61.02 30.51-64 76.2-64 89.89V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-94.11c0-27.19 20.69-45.33 32-53.22 11.31 7.89 32 26.03 32 53.22V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-94.11c0-13.71-2.98-59.38-64-89.89zm144 64c-29.53 0-48 25.06-48 49.89V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72c0-8.83 7.19-16 16-16s16 7.17 16 16v72c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72c0-26.47-21.53-48-48-48z"]
  },
      VC = {
    prefix: "fal",
    iconName: "motorcycle",
    icon: [640, 512, [], "f21c", "M512.238 192c-17.943-.033-35.025 3.631-50.534 10.266L435.799 160H520c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24h-60a24.002 24.002 0 0 0-19.2 9.6l-31.893 42.524-27.265-44.485A16.005 16.005 0 0 0 368 64h-76c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h67.04l39.226 64H217.584c-16.679-19.064-41.794-32-89.584-32H80.452c-8.616 0-16.029 6.621-16.433 15.227C63.586 152.416 70.907 160 80 160h48c24.268 0 40.146 8.239 51.566 19.951l-10.364 18.843a127.7 127.7 0 0 0-39.723-6.786C58.709 191.202.272 248.724.001 319.499-.27 390.422 57.141 448 128 448c59.641 0 109.745-40.795 123.956-96h84.776c9.384 0 16.781-8.057 15.936-17.438-5.123-56.79 20.187-110.805 64.631-143.511l16.791 27.395c-30.629 23.533-50.314 60.604-50.086 102.267.38 69.638 57.194 126.66 126.83 127.281 70.58.629 128.112-55.871 129.153-126.057 1.052-71.012-56.729-129.808-127.749-129.937zM462 92h54v40h-84l30-40zM128 416c-52.935 0-96-43.065-96-96s43.065-96 96-96a95.687 95.687 0 0 1 25.45 3.436L97.98 328.289C92.126 338.933 99.838 352 112 352h106.499c-13.208 37.247-48.781 64-90.499 64zm192-96H139.061l70.399-128h159.467C337.778 226.865 320 272.362 320 320zm188.206 95.926c-49.822-1.93-90.199-42.305-92.132-92.127-1.214-31.294 12.642-59.467 34.879-77.836l57.496 93.808c3.463 5.651 10.852 7.424 16.502 3.96l6.821-4.181c5.65-3.463 7.423-10.851 3.96-16.502l-57.051-93.083A95.57 95.57 0 0 1 512 224c52.935 0 96 43.065 96 96 0 54.194-45.139 98.043-99.794 95.926z"]
  },
      xC = {
    prefix: "fal",
    iconName: "mountain",
    icon: [640, 512, [], "f6fc", "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 32l102.86 160H313.38L256 249.38l-46.14-46.05L320 32zM32 480l160.19-249.19L256 294.62 326.62 224h116.8L608 480H32z"]
  },
      wC = {
    prefix: "fal",
    iconName: "mountains",
    icon: [640, 512, [], "f6fd", "M635.73 406.91l-194.04-297.6C435.9 100.44 425.95 96 416 96c-9.95 0-19.9 4.44-25.69 13.31l-52 79.76-70.79-110.55C261.32 68.84 250.66 64 240 64s-21.32 4.84-27.52 14.52L4.58 403.18C-7.99 422.81 6.81 448 30.92 448h580.22c22.5 0 36.32-23.09 24.59-41.09zM33.71 417.02L239.03 96.17c.08-.04.44-.17.97-.17l.57-.22L445.63 416l-411.92 1.02zM479.65 416c-.39-4.33-1.58-8.7-4.22-12.82L357.24 218.62 416 128.51 603.45 416h-123.8z"]
  },
      yC = {
    prefix: "fal",
    iconName: "mouse",
    icon: [384, 512, [], "f8cc", "M224 0h-64A160 160 0 0 0 0 160v192a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V160A160 160 0 0 0 224 0zM32 160A128.14 128.14 0 0 1 160 32h16v160H32zm320 192a128.14 128.14 0 0 1-128 128h-64A128.14 128.14 0 0 1 32 352V224h320zm0-160H208V32h16a128.14 128.14 0 0 1 128 128z"]
  },
      bC = {
    prefix: "fal",
    iconName: "mouse-alt",
    icon: [384, 512, [], "f8cd", "M224 0h-64A160 160 0 0 0 0 160v192a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V160A160 160 0 0 0 224 0zm128 352a128.14 128.14 0 0 1-128 128h-64A128.14 128.14 0 0 1 32 352V160A128.14 128.14 0 0 1 160 32h64a128.14 128.14 0 0 1 128 128zM192 80a48.05 48.05 0 0 0-48 48v32a48 48 0 0 0 96 0v-32a48.05 48.05 0 0 0-48-48zm16 80a16 16 0 0 1-32 0v-32a16 16 0 0 1 32 0z"]
  },
      SC = {
    prefix: "fal",
    iconName: "mouse-pointer",
    icon: [320, 512, [], "f245", "M154.149 488.438l-41.915-101.865-46.788 52.8C42.432 465.345 0 448.788 0 413.5V38.561c0-34.714 41.401-51.675 64.794-26.59L309.547 274.41c22.697 24.335 6.074 65.09-27.195 65.09h-65.71l42.809 104.037c8.149 19.807-1.035 42.511-20.474 50.61l-36 15.001c-19.036 7.928-40.808-1.217-48.828-20.71zm-31.84-161.482l61.435 149.307c1.182 2.877 4.117 4.518 6.926 3.347l35.999-15c3.114-1.298 4.604-5.455 3.188-8.896L168.872 307.5h113.479c5.009 0 7.62-7.16 3.793-11.266L41.392 33.795C37.785 29.932 32 32.879 32 38.561V413.5c0 5.775 5.935 8.67 9.497 4.65l80.812-91.194z"]
  },
      TC = {
    prefix: "fal",
    iconName: "mp3-player",
    icon: [384, 512, [], "f8ce", "M64 192h256V64H64zm32-96h192v64H96zM336 0H48A48 48 0 0 0 0 48v416a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm16 464a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h288a16 16 0 0 1 16 16zM192 224a112 112 0 1 0 112 112 112.14 112.14 0 0 0-112-112zm0 192a80 80 0 1 1 80-80 80.08 80.08 0 0 1-80 80zm0-104a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"]
  },
      DC = {
    prefix: "fal",
    iconName: "mug",
    icon: [576, 512, [], "f874", "M480 64H64a32 32 0 0 0-32 32v256a96 96 0 0 0 96 96h192a96 96 0 0 0 96-96v-96h64a96 96 0 0 0 0-192zm-96 288a64.07 64.07 0 0 1-64 64H128a64.07 64.07 0 0 1-64-64V96h320zm96-128h-64V96h64a64 64 0 0 1 0 128z"]
  },
      jC = {
    prefix: "fal",
    iconName: "mug-hot",
    icon: [512, 512, [], "f7b6", "M416 192.1H32c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96h192c53 0 96-43 96-96v-32h32c52.9 0 96-43 96-96s-43.1-95.9-96-95.9zM352 416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V224.1h320V416zm64-64h-32V224h32c35.3 0 64 28.7 64 64s-28.7 64-64 64zM191.3 78.5c17.3 17.2 30.4 40.7 32.2 73.4.2 4.3 3.7 7.8 8 7.8h16c4.5 0 8.2-3.7 8-8.2-2.1-42.1-19.3-73.3-41.6-95.5-18.4-18.7-21.1-38.2-21.9-48.9-.3-4.1-3.9-7.1-8-7.1l-16 .1c-4.7 0-8.2 4-7.9 8.7.9 14.9 5.2 43.6 31.2 69.7zm-95.6 0c17.3 17.2 30.4 40.7 32.2 73.4.2 4.3 3.7 7.8 8 7.8h16c4.5 0 8.2-3.7 8-8.2-2.1-42.1-19.3-73.3-41.6-95.5-18.3-18.7-21-38.2-21.8-48.9C96.2 3 92.6 0 88.4 0l-16 .1c-4.7 0-8.2 4-7.9 8.7 1 14.9 5.2 43.6 31.2 69.7z"]
  },
      EC = {
    prefix: "fal",
    iconName: "mug-marshmallows",
    icon: [512, 512, [], "f7b7", "M416 160h-64c12.5-12.5 12.5-32.8 0-45.3l-73.4-73.4c-6.2-6.2-14.4-9.4-22.6-9.4s-16.4 3.1-22.6 9.4L206.7 68c-4.5-2.4-9.3-4-14.7-4H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96v-32h32c52.9 0 96-43.1 96-96s-43.1-96-96-96zM256 64l73.4 73.4-22.7 22.6H205.3l-22.6-22.6L256 64zM64 96h114.7L160 114.7c-12.5 12.5-12.5 32.8 0 45.3H64V96zm288 288c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h224v192zm64-64h-32V192h32c35.3 0 64 28.7 64 64s-28.7 64-64 64z"]
  },
      kC = {
    prefix: "fal",
    iconName: "mug-tea",
    icon: [640, 512, [], "f875", "M601.9 448H6.1c-13.1 0-4.5 32 20 32h555.8c24.5 0 33.1-32 20-32zM544 32H128a32 32 0 0 0-32 32v224a96 96 0 0 0 96 96h192a96 96 0 0 0 96-96v-64h64a96 96 0 0 0 0-192zm-96 256a64.07 64.07 0 0 1-64 64H192a64.07 64.07 0 0 1-64-64V64h96v32l-38.63 38.63a32 32 0 0 0-9.37 22.62V224a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-66.75a32 32 0 0 0-9.37-22.62L256 96V64h192zM240 125.25l32 32V224h-64v-66.75zM544 192h-64V64h64a64 64 0 0 1 0 128z"]
  },
      IC = {
    prefix: "fal",
    iconName: "music",
    icon: [512, 512, [], "f001", "M481.44 0a29.38 29.38 0 0 0-9.25 1.5l-290.78 96C168.72 101.72 160 114 160 128v244.75C143 360 120.69 352 96 352c-53 0-96 35.81-96 80s43 80 96 80 96-35.81 96-80V256l288-96v148.75C463 296 440.69 288 416 288c-53 0-96 35.81-96 80s43 80 96 80 96-35.81 96-80V32c0-18.25-14.31-32-30.56-32zM96 480c-34.69 0-64-22-64-48s29.31-48 64-48 64 22 64 48-29.31 48-64 48zm320-64c-34.69 0-64-22-64-48s29.31-48 64-48 64 22 64 48-29.31 48-64 48zm64-289.72l-288 96V128h-.56v-.12L480 32.62z"]
  },
      OC = {
    prefix: "fal",
    iconName: "music-alt",
    icon: [384, 512, [], "f8cf", "M342 1.64L213.41 33.52C200.72 37.74 192 50 192 64v312.13C171.66 361.28 143.38 352 112 352 50.14 352 0 387.82 0 432s50.14 80 112 80 112-35.82 112-80V192l138.12-35.37A32 32 0 0 0 384 126.27V32a32 32 0 0 0-42-30.36zM112 480c-47.14 0-80-25.3-80-48s32.86-48 80-48 80 25.3 80 48-32.86 48-80 48zm240-353.72l-128 32V64h-.56v-.13L352 32z"]
  },
      QC = {
    prefix: "fal",
    iconName: "music-alt-slash",
    icon: [640, 512, [], "f8d0", "M637 485.34L23 1.82A7.85 7.85 0 0 0 11.79 3l-10 12.5A7.92 7.92 0 0 0 3 26.73l614 483.48a7.89 7.89 0 0 0 11.18-1.21l10-12.5a7.82 7.82 0 0 0-1.18-11.16zM320 376.13C299.65 361.28 271.37 352 240 352c-61.86 0-112 35.82-112 80s50.15 80 112 80 112-35.82 112-80v-89.72l-32-25.2zM240 480c-47.15 0-80-25.3-80-48s32.86-48 80-48 80 25.3 80 48-32.87 48-80 48zm112-288l138.12-35.37A32 32 0 0 0 512 126.27V32a32 32 0 0 0-42-30.36L341.4 33.52C328.71 37.74 320 50 320 64v131l32 25.2zm-.56-128.11L480 32v94.26l-128 32V64h-.56z"]
  },
      ZC = {
    prefix: "fal",
    iconName: "music-slash",
    icon: [640, 512, [], "f8d1", "M637 485.34L23 1.82A7.85 7.85 0 0 0 11.79 3l-10 12.5A7.92 7.92 0 0 0 3 26.73l614 483.48a7.89 7.89 0 0 0 11.18-1.21l10-12.5a7.82 7.82 0 0 0-1.18-11.16zM256 128h-.56v-.12L544 32.62v93.66l-218.7 72.9 30.08 23.69L544 160v148.75C527 296 504.71 288 480 288a112.39 112.39 0 0 0-34.78 5.61l33.63 26.48c.39 0 .76-.09 1.15-.09 34.69 0 64 22 64 48 0 1-.34 2-.43 3.06l27.33 21.52A67.33 67.33 0 0 0 576 368V32c0-18.25-14.31-32-30.56-32a29.38 29.38 0 0 0-9.25 1.5l-290.79 96c-10.28 3.42-17.68 12.21-20.22 22.83L256 144.6zm-32 244.75C207 360 184.7 352 160 352c-53 0-96 35.81-96 80s43 80 96 80 96-35.81 96-80V266.7l-32-25.2zM160 480c-34.69 0-64-22-64-48s29.32-48 64-48 64 22 64 48-29.3 48-64 48z"]
  },
      UC = {
    prefix: "fal",
    iconName: "narwhal",
    icon: [640, 512, [], "f6fe", "M594.39 224.44l44.9-191.9c2.72-11.5-2.59-23.5-13-29.25-6.19-3.37-13.38-4.22-20.19-2.22-6.78 1.98-12.41 6.48-15.75 12.62l-99.19 179.69C296.64 207.72 223.11 416 179.87 416c-10.96 0-19.87-8.92-19.87-19.88V288l47.37-24.9c10.39-5.93 16.62-15.93 16.62-26.62v-92.45c0-9.41-9.01-16.03-18.72-16.03-3.47 0-7.03.85-10.3 2.71L112 178.13l-82.98-47.42c-3.27-1.87-6.83-2.71-10.3-2.71C9.01 128 0 134.61 0 144.03v92.45c0 10.7 6.24 20.69 16.62 26.62L64 288v108.12c0 64 51.88 115.87 115.87 115.87H560c44.18 0 80-35.82 80-80V320.54c0-39.11-18.68-72.86-45.61-96.1zm4.65-160.26l-33.11 141.37c-12.23-6.06-25.11-10.06-38.37-11.9l71.48-129.47zM608 432c0 26.47-21.53 48-48 48H179.87C133.63 480 96 442.37 96 396.13V268.67l-64-33.84v-65.56l80 45.71 80-45.71v65.76l-64 33.64v127.46c0 28.6 23.27 51.87 51.87 51.87 29.8 0 49.95-25.95 80.45-65.23C309.41 319.55 383.6 224 512 224c45.41 0 96 39.65 96 96.54V432zm-176-80c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"]
  },
      BC = {
    prefix: "fal",
    iconName: "network-wired",
    icon: [640, 512, [], "f6ff", "M632 240H336v-80h80c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h80v80H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h120v80H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32h-64v-80h320v80h-64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32h-64v-80h120c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM224 384v96H64v-96h160zm0-256V32h192v96H224zm352 256v96H416v-96h160z"]
  },
      RC = {
    prefix: "fal",
    iconName: "neuter",
    icon: [288, 512, [], "f22c", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 74.1 56 135.2 128 143.1V468c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V319.1c72-7.9 128-69 128-143.1zM144 288c-61.9 0-112-50-112-112 0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112z"]
  },
      YC = {
    prefix: "fal",
    iconName: "newspaper",
    icon: [576, 512, [], "f1ea", "M552 64H88c-13.234 0-24 10.767-24 24v8H24c-13.255 0-24 10.745-24 24v280c0 26.51 21.49 48 48 48h504c13.233 0 24-10.767 24-24V88c0-13.233-10.767-24-24-24zM32 400V128h32v272c0 8.822-7.178 16-16 16s-16-7.178-16-16zm512 16H93.258A47.897 47.897 0 0 0 96 400V96h448v320zm-404-96h168c6.627 0 12-5.373 12-12V140c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12zm20-160h128v128H160V160zm-32 212v-8c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12H140c-6.627 0-12-5.373-12-12zm224 0v-8c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-64v-8c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-128v-8c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 64v-8c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"]
  },
      PC = {
    prefix: "fal",
    iconName: "not-equal",
    icon: [384, 512, [], "f53e", "M376 160h-54.06l38.56-38.56 21.16-21.16c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L254.06 160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h198.06l-96 96H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h54.06L2.34 411.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L129.94 352H376c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8H177.94l96-96H376c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"]
  },
      FC = {
    prefix: "fal",
    iconName: "notes-medical",
    icon: [384, 512, [], "f481", "M336 64h-88.6c.4-2.6.6-5.3.6-8 0-30.9-25.1-56-56-56s-56 25.1-56 56c0 2.7.2 5.4.6 8H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 32c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm160 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h48v20c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V96h48c8.8 0 16 7.2 16 16v352zm-72-176h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"]
  },
      WC = {
    prefix: "fal",
    iconName: "object-group",
    icon: [512, 512, [], "f247", "M404 192h-84v-52c0-6.6-5.4-12-12-12H108c-6.6 0-12 5.4-12 12v168c0 6.6 5.4 12 12 12h84v52c0 6.6 5.4 12 12 12h200c6.6 0 12-5.4 12-12V204c0-6.6-5.4-12-12-12zm-276 96V160h160v128zm256 64H224v-32h84c6.6 0 12-5.4 12-12v-84h64zm116-224c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12h-72c-6.6 0-12 5.4-12 12v20H96V44c0-6.6-5.4-12-12-12H12C5.4 32 0 37.4 0 44v72c0 6.6 5.4 12 12 12h20v256H12c-6.6 0-12 5.4-12 12v72c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-20h320v20c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-72c0-6.6-5.4-12-12-12h-20V128zM32 64h32v32H32zm32 384H32v-32h32zm352-52v20H96v-20c0-6.6-5.4-12-12-12H64V128h20c6.6 0 12-5.4 12-12V96h320v20c0 6.6 5.4 12 12 12h20v256h-20c-6.6 0-12 5.4-12 12zm64 52h-32v-32h32zM448 96V64h32v32z"]
  },
      GC = {
    prefix: "fal",
    iconName: "object-ungroup",
    icon: [576, 512, [], "f248", "M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v20h-96v-32h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v20H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h20v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-20h96v32h-20c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-20h224v20c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-20V224h20zm-180 96v32h-32v-32h32zM352 64h32v32h-32V64zM32 64h32v32H32V64zm32 288H32v-32h32v32zm20-64H64V128h20c6.627 0 12-5.373 12-12V96h224v20c0 6.627 5.373 12 12 12h20v160h-20c-6.627 0-12 5.373-12 12v20H96v-20c0-6.627-5.373-12-12-12zm140 160h-32v-32h32v32zm256-52v20H256v-20c0-6.627-5.373-12-12-12h-20v-32h96v20c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-20v-96h96v20c0 6.627 5.373 12 12 12h20v160h-20c-6.627 0-12 5.373-12 12zm64 52h-32v-32h32v32zm-32-256v-32h32v32h-32z"]
  },
      qC = {
    prefix: "fal",
    iconName: "octagon",
    icon: [512, 512, [], "f306", "M361.5 14.1c-9-9-21.2-14.1-33.9-14.1H184.5c-12.7 0-24.9 5.1-33.9 14.1L14.1 150.5c-9 9-14.1 21.2-14.1 33.9v143.1c0 12.7 5.1 24.9 14.1 33.9l136.5 136.5c9 9 21.2 14.1 33.9 14.1h143.1c12.7 0 24.9-5.1 33.9-14.1L498 361.4c9-9 14.1-21.2 14.1-33.9v-143c0-12.7-5.1-24.9-14.1-33.9L361.5 14.1zM480 327.5c0 4.3-1.7 8.3-4.7 11.3L338.9 475.3c-3 3-7 4.7-11.3 4.7H184.5c-4.3 0-8.3-1.7-11.3-4.7L36.7 338.9c-3-3-4.7-7-4.7-11.3V184.5c0-4.3 1.7-8.3 4.7-11.3L173.1 36.7c3-3 7-4.7 11.3-4.7h143.1c4.3 0 8.3 1.7 11.3 4.7l136.5 136.5c3 3 4.7 7 4.7 11.3v143z"]
  },
      JC = {
    prefix: "fal",
    iconName: "oil-can",
    icon: [640, 512, [], "f613", "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H272v-64h72c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H168c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h72v64h-64v-.02L37.72 166.84C16.54 162.98 0 179.92 0 198.33v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.44V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.74-5.48-9.03-10.19-7.69zM96 304.91l-64-11.64.04-94.94L96 209.96v94.95zM402.63 384H128V224h208.89c4.97 0 9.87 1.16 14.31 3.38l56.15 28.07c3.64 1.82 7.83 2.18 11.72 1.02l155.35-46.28L402.63 384zm176.21-89.09C568.38 310.06 544 347.53 544 367.98c0 26.47 21.53 48 48 48s48-21.53 48-48c0-20.45-24.38-57.92-34.84-73.08-5.94-8.65-20.38-8.65-26.32.01zM592 383.98c-8.81 0-16-7.17-16-15.98.12-4.89 6.78-18.83 16-34.34 9.22 15.52 15.88 29.45 16 34.33 0 8.82-7.19 15.99-16 15.99z"]
  },
      KC = {
    prefix: "fal",
    iconName: "oil-temp",
    icon: [640, 512, [], "f614", "M8 384h24c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84 2.45 0 4.69-.46 7.1-.56-7.34-9.65-12.99-20.48-16.9-32.22-21.05-1.84-37.38-8.9-46.28-17.12-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm624-32h-24c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1-8.9 8.21-25.23 15.28-46.28 17.12-3.91 11.75-9.57 22.57-16.9 32.22 2.41.1 4.65.56 7.1.56 38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84h24c4.42 0 8-3.58 8-8v-16c.01-4.42-3.57-8-7.99-8zm-312 48.02c44.12 0 80-35.89 80-80.02 0-38.63-27.52-70.95-64-78.38V160h72c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-72V96h72c4.42 0 8-3.58 8-8V72c0-4.42-3.58-8-8-8h-72V32h72c4.42 0 8-3.58 8-8V8c0-4.42-3.58-8-8-8h-80c-13.2 0-24 10.8-24 24v217.62c-36.48 7.43-64 39.75-64 78.38 0 44.12 35.88 80.02 80 80.02zM320 272c26.47 0 48 21.53 48 48s-21.53 48.02-48 48.02-48-21.55-48-48.02 21.53-48 48-48zm312 208h-24c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 471.58 442.04 480 416 480s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 471.58 250.04 480 224 480s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 471.58 58.04 480 32 480H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h24c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h24c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"]
  },
      XC = {
    prefix: "fal",
    iconName: "om",
    icon: [448, 512, [], "f679", "M296.62 92.94c4.08 4.07 10.68 4.07 14.76 0l21.56-21.56a10.43 10.43 0 0 0 0-14.76l-21.56-21.56a10.43 10.43 0 0 0-14.76 0l-21.56 21.56a10.43 10.43 0 0 0 0 14.76l21.56 21.56zM310.56 160c56.59 0 69.84-14.42 71.92-17.31a8.073 8.073 0 0 0 1.52-4.72V112c0-6.58-7.35-10.29-12.5-6.46-20.05 14.86-41.94 22.4-65.06 22.4-39.69 0-69.59-22.14-69.89-22.37-6.99-5.25-16.15 3.37-11.23 10.87 1.17 1.78 29.21 43.56 85.24 43.56zm44.54 48.47c-19.97 2.1-38.29 12.09-52.49 26.29l-22.03 22.03a51.918 51.918 0 0 1-36.7 15.2h-72.56c17.23-20.68 25.74-48.87 17.53-79.42-8.62-32.11-35.75-57.32-68.49-63.13-31.19-5.53-61.18 4.98-81.39 27.25-3.07 3.38-2.29 8.78 1.36 11.53l12.86 9.67c3.37 2.53 7.91 1.83 10.86-1.19 12.67-12.95 30.8-19.04 49.66-15.91 21.57 3.58 39.66 20.39 44.68 41.67C167.06 239.18 139.29 272 104 272l-31.99.17c-5.96.03-9.81 6.31-7.15 11.64l8.04 16.09c1.27 2.53 3.8 4.05 6.59 4.28l37.3-.17c37.59 0 71.22 27.41 74.86 64.82C195.83 411.73 162.06 448 120 448h-8c-57.58 0-89.46-30.88-103.13-51.13-2.71-4.02-8.86-1.91-8.87 2.78C-.04 418.05 27.36 480 115.44 480c58.2 0 109.54-47.6 108.54-105.79-.47-27.26-11.6-51.9-29.24-70.21h49.13c22.25 0 43.59-8.84 59.32-24.57l23.14-23.15c7.28-7.28 16.31-12.9 26.38-15.06 33.54-7.2 63.28 18.31 63.28 50.65V376c0 22.09-17.91 40-40 40h-24c-20.68 0-32.6-12.97-40.55-22.47-2.5-2.99-7.45-1.29-7.45 2.56v19.3s-2.4 32.62 48 32.62h24c39.77 0 72-32.24 72-72v-84.12c.01-49.24-42.61-88.7-92.89-83.42z"]
  },
      _C = {
    prefix: "fal",
    iconName: "omega",
    icon: [448, 512, [], "f67a", "M448 256c0-132.21-114.54-237.67-249.8-222.55-101.56 11.34-184.1 93-196.48 194.43-11.37 93.2 34.7 176.53 107.34 220.12H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h144c4.42 0 8-3.58 8-8v-24.31c0-6.57-4.1-12.29-10.16-14.83C77.6 402.47 27.63 329.3 32.3 245.13c5.4-97.34 86.31-177 183.72-180.97C325.51 59.7 416 147.48 416 256c0 79.56-48.73 147.79-117.84 176.86-6.06 2.55-10.16 8.26-10.16 14.83V472c0 4.42 3.58 8 8 8h144c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H338.94C404.19 408.85 448 337.63 448 256z"]
  },
      $C = {
    prefix: "fal",
    iconName: "ornament",
    icon: [384, 512, [], "f7b8", "M288 153.9V96c0-17.7-14.3-32-32-32h-18.9c1.8-5 2.9-10.4 2.9-16 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 5.6 1.2 11 2.9 16H128c-17.7 0-32 14.3-32 32v57.9C38.7 187.1 0 249 0 320c0 106 86 192 192 192s192-86 192-192c0-71-38.7-132.9-96-166.1zM176 48c0-8.8 7.2-16 16-16s16 7.2 16 16-7.2 16-16 16-16-7.2-16-16zm-48 48h128v43.2c-20-7.1-41.5-11.2-64-11.2s-44 4.1-64 11.2V96zm64 64c52.1 0 97.9 25.4 127.2 64H64.8c29.3-38.6 75.1-64 127.2-64zm0 320c-52.1 0-97.9-25.4-127.2-64h254.4c-29.3 38.6-75.1 64-127.2 64zm146.4-96H45.6C36.9 364.4 32 342.8 32 320s4.9-44.4 13.6-64h292.9c8.6 19.6 13.6 41.2 13.6 64s-5 44.4-13.7 64z"]
  },
      cL = {
    prefix: "fal",
    iconName: "otter",
    icon: [640, 512, [], "f700", "M512 56c-8.84 0-16 7.16-16 16s7.17 16 16 16c8.84 0 16-7.16 16-16s-7.16-16-16-16zm80-24h-17.14L561.6 18.74C549.52 6.66 533.44 0 516.35 0h-20.49c-11.12 0-22.1 2.91-31.75 8.43L310.86 96H288C182.13 96 96 182.13 96 288v1.14C41.79 296.93 0 343.67 0 400c0 61.76 50.24 112 112 112h144c26.47 0 48-21.53 48-48s-21.53-48-48-48H112c-8.82 0-16-7.18-16-16s7.18-16 16-16h208c17.67 0 32-14.33 32-32 0-23-12.19-43.2-30.45-54.48l48.61-25.85 47.32 94.64A32 32 0 0 0 446.1 384H544c17.67 0 32-14.33 32-32 0-35.29-28.71-64-64-64h-26.33l-30.71-61.42 44.82-23.84C512.99 195.71 529.04 192 544 192c52.93 0 96-43.06 96-96V80c0-26.47-21.53-48-48-48zm-48 128c-20.26 0-41.36 4.97-59.25 14.49l-4.19 2.23 16.9-21.96C506.5 143 520.72 136 535.5 136h58.09c-11.73 14.52-29.47 24-49.59 24zm63.19-56H535.5c-24.66 0-48.34 11.67-63.41 31.23l-59.71 77.74L465.89 320H512c17.66 0 32 14.36 32 32h-97.89l-62-123.99L211.13 320H288c17.66 0 32 14.36 32 32H112c-26.47 0-48 21.53-48 48s21.53 48 48 48h144c8.84 0 16 7.16 16 16s-7.16 16-16 16H112c-44.12 0-80-35.89-80-80s35.88-80 80-80h16v-32c0-88.37 71.63-160 160-160h31.36l160.62-91.79A32.048 32.048 0 0 1 495.86 32h20.49c8.55 0 16.58 3.33 22.62 9.37L561.6 64H592c8.84 0 16 7.16 16 16 0 0-.47 21.35-.81 24z"]
  },
      eL = {
    prefix: "fal",
    iconName: "outdent",
    icon: [448, 512, [], "f03b", "M100.69 363.29a15.63 15.63 0 0 0 11.17 4.7A16 16 0 0 0 128 352V160a16 16 0 0 0-16.13-16 15.66 15.66 0 0 0-11.18 4.7l-96 96a16 16 0 0 0 0 22.62zM96 198.64v114.72L38.63 256zM440 48H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8zm0 384H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-128H200a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h240a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-128H200a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h240a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      aL = {
    prefix: "fal",
    iconName: "outlet",
    icon: [512, 512, [], "e01c", "M448,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H448a64,64,0,0,0,64-64V64A64,64,0,0,0,448,0Zm32,448a32,32,0,0,1-32,32H64a32,32,0,0,1-32-32V64A32,32,0,0,1,64,32H448a32,32,0,0,1,32,32ZM369.85,96H142.15a22.86,22.86,0,0,0-16.41,6.7C87.71,141.71,64,195.9,64,256s23.71,114.28,61.74,153.29A22.87,22.87,0,0,0,142.15,416h227.7a22.87,22.87,0,0,0,16.41-6.71c38-39,61.74-93.19,61.74-153.29s-23.71-114.29-61.74-153.3A22.86,22.86,0,0,0,369.85,96Zm-3.68,288H145.83C113.66,349.51,96,304.22,96,256s17.67-93.51,49.83-128H366.17C398.33,162.48,416,207.77,416,256S398.34,349.51,366.17,384ZM192,176a16,16,0,0,0-16,16v80a16,16,0,0,0,32,0V192A16,16,0,0,0,192,176Zm64,128a32,32,0,0,0-32,32v16h64V336A32,32,0,0,0,256,304Zm64-128a16,16,0,0,0-16,16v80a16,16,0,0,0,32,0V192A16,16,0,0,0,320,176Z"]
  },
      nL = {
    prefix: "fal",
    iconName: "oven",
    icon: [448, 512, [], "e01d", "M384,0H64A64,64,0,0,0,0,64V480a32,32,0,0,0,32,32H416a32,32,0,0,0,32-32V64A64,64,0,0,0,384,0Zm32,480H32V160H416Zm0-352H32V64A32,32,0,0,1,64,32H384a32,32,0,0,1,32,32ZM368,64a16,16,0,1,0,16,16A16,16,0,0,0,368,64Zm-64,0a16,16,0,1,0,16,16A16,16,0,0,0,304,64ZM144,64a16,16,0,1,0,16,16A16,16,0,0,0,144,64ZM80,64A16,16,0,1,0,96,80,16,16,0,0,0,80,64Zm0,384H368a16,16,0,0,0,16-16V208a16,16,0,0,0-16-16H80a16,16,0,0,0-16,16V432A16,16,0,0,0,80,448ZM96,224H352V416H96Zm208,32H144a16,16,0,0,0,0,32H304a16,16,0,0,0,0-32Z"]
  },
      tL = {
    prefix: "fal",
    iconName: "overline",
    icon: [448, 512, [], "f876", "M439 0H7a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8zM223 96A160 160 0 0 0 63 256v96a160 160 0 0 0 320 0v-96A160 160 0 0 0 223 96zm128 256a128 128 0 0 1-256 0v-96a128 128 0 0 1 256 0z"]
  },
      rL = {
    prefix: "fal",
    iconName: "page-break",
    icon: [576, 512, [], "f877", "M232 272a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM128 32h192v112a16 16 0 0 0 16 16h112v64h32v-82.77a31.93 31.93 0 0 0-9.35-22.6C447 94.92 384.8 32.78 361.23 9.23A31.54 31.54 0 0 0 338.75 0H128a32 32 0 0 0-32 32v192h32zm224 13.25L434.77 128H352zM568 272H424a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm-408 24v-16a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8zm288 184H128V352H96v128a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V352h-32z"]
  },
      iL = {
    prefix: "fal",
    iconName: "pager",
    icon: [512, 512, [], "f815", "M272 320h-80v32h80a16 16 0 0 0 0-32zM448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zm32 320a32 32 0 0 1-32 32H64a32 32 0 0 1-32-32V128a32 32 0 0 1 32-32h384a32 32 0 0 1 32 32zM64 336a16 16 0 0 0 16 16h80v-32H80a16 16 0 0 0-16 16zm360-208H88a24 24 0 0 0-24 24v112a24 24 0 0 0 24 24h336a24 24 0 0 0 24-24V152a24 24 0 0 0-24-24zm-8 128H96v-96h320z"]
  },
      oL = {
    prefix: "fal",
    iconName: "paint-brush",
    icon: [512, 512, [], "f1fc", "M455.59 0c-15.81 0-30.62 6.99-41.93 17.15C195.73 211.82 169.77 216.5 179.98 281.99c-41.52 4.96-78.59 24.05-100.32 81.32-2.68 7.08-9.12 11.38-16.64 11.38-12.67 0-51.85-31.56-63.02-39.19C0 429.45 43.26 512 146 512c117.18 0 152.72-87.75 145.06-145.89 56.9-7.01 97.15-62.51 206.45-266.49C505.2 84.65 512 68.48 512 51.66 512 21.52 484.89 0 455.59 0zM236.52 445.55C216.47 468.41 186.02 480 146 480c-63.78 0-92.29-38.83-104.75-78.69 8.02 3.65 14.98 5.39 21.77 5.39 20.92 0 39.2-12.58 46.56-32.03 6.65-17.52 16.05-53.95 83.76-62.04l65.08 50.62c4.03 30.68-1.25 58.75-21.9 82.3zM469.31 84.5c-118.4 220.96-143.69 245.11-194.08 251.31l-62-48.22c-8.8-56.43-14.8-35.28 221.82-246.64 6.33-5.69 13.81-8.95 20.54-8.95C467.38 32 480 39.9 480 51.66c0 10.58-5.54 22.79-10.69 32.84z"]
  },
      lL = {
    prefix: "fal",
    iconName: "paint-brush-alt",
    icon: [512, 512, [], "f5a9", "M489.17 144.05C547.44 80.02 483.28 0 418.52 0c-23.39 0-46.87 10.44-64.68 35.85L187.9 284.01c-45.13 2.9-86.1 20.09-109.34 81.34-2.65 6.99-9 11.22-16.41 11.22-12.49 0-51.14-31.13-62.15-38.65C0 430.58 42.67 512 144 512c141.21 0 145.89-117.04 142.91-145.49l.02-.02 202.24-222.44zM230.96 449.18C212.54 469.63 183.28 480 144 480c-62.08 0-90.15-37.47-102.57-76.29 7.55 3.32 14.15 4.86 20.72 4.86 20.81 0 39-12.52 46.33-31.87 6.86-18.09 17.63-56.66 89.31-61.26L254.68 366c2.96 28.21-4.08 61.37-23.72 83.18zm39.4-112.03l-49.86-44.32L380.05 54.22C390.38 39.47 403.33 32 418.52 32c22.9 0 47.56 16.71 57.36 38.88 7.94 17.96 4.45 35.34-10.39 51.64L270.36 337.15z"]
  },
      fL = {
    prefix: "fal",
    iconName: "paint-roller",
    icon: [512, 512, [], "f5aa", "M464 64h-48V48c0-26.51-21.49-48-48-48H48C21.49 0 0 21.49 0 48v64c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48V96h48c8.81 0 16 7.17 16 16v96c0 8.83-7.19 16-16 16H256c-26.47 0-48 21.53-48 48v48h-16c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-16v-48c0-8.83 7.19-16 16-16h208c26.47 0 48-21.53 48-48v-96c0-26.47-21.53-48-48-48zm-80 0v48c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16V48c0-8.82 7.18-16 16-16h320c8.82 0 16 7.18 16 16v16zM256 480h-64V352h64v128z"]
  },
      sL = {
    prefix: "fal",
    iconName: "palette",
    icon: [512, 512, [], "f53f", "M112 264c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm32-112c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM256 0c-16.9 0-34.2 1.6-51.7 5C104.9 24.4 24.8 104.3 5.2 203.4-29.4 378.5 116.4 512 239.5 512c8.3 0 16.5-.6 24.6-1.9 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.6 113.9 397.1 0 256 0zm191.1 288h-79.7c-35.3 0-67.4 17.9-85.7 47.8-18.2 29.7-19.6 66-3.7 97.2 4.9 9.6 4.8 21.6-.1 31.3-2.4 4.6-7.9 12.6-18.7 14.3-6.3 1-12.9 1.5-19.7 1.5-54.6 0-114.1-31.3-155.5-81.6-44-53.6-60.9-120.6-47.4-188.7 17.1-86.6 87-156.2 173.9-173.2 15.2-3 30.5-4.5 45.5-4.5 123.1 0 223.6 99.9 224 222.6 0 18.3-14.8 33.3-32.9 33.3zM368 136c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM240 88c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z"]
  },
      uL = {
    prefix: "fal",
    iconName: "pallet",
    icon: [640, 512, [], "f482", "M144 288h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zM288 32h64v76.2l-32-16-32 16V32zm-128 0h96v128l64-32 64 32V32h96v224H160V32zm472 320c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56v128H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h624c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-56V352h56zM160 480H96V352h64v128zm288 0H192V352h256v128zm96 0h-64V352h64v128z"]
  },
      hL = {
    prefix: "fal",
    iconName: "pallet-alt",
    icon: [640, 512, [], "f483", "M112 288h416c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H352V16c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zM352 96h160v160H352V96zM128 32h192v224H128V32zm504 320c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56v128H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h624c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-56V352h56zM160 480H96V352h64v128zm288 0H192V352h256v128zm96 0h-64V352h64v128z"]
  },
      mL = {
    prefix: "fal",
    iconName: "paper-plane",
    icon: [512, 512, [], "f1d8", "M464 4.3L16 262.7C-7 276-4.7 309.9 19.8 320L160 378v102c0 30.2 37.8 43.3 56.7 20.3l60.7-73.8 126.4 52.2c19.1 7.9 40.7-4.2 43.8-24.7l64-417.1C515.7 10.2 487-9 464 4.3zM192 480v-88.8l54.5 22.5L192 480zm224-30.9l-206.2-85.2 199.5-235.8c4.8-5.6-2.9-13.2-8.5-8.4L145.5 337.3 32 290.5 480 32l-64 417.1z"]
  },
      vL = {
    prefix: "fal",
    iconName: "paperclip",
    icon: [512, 512, [], "f0c6", "M149.106 512c-33.076 0-66.153-12.59-91.333-37.771-50.364-50.361-50.364-132.305-.002-182.665L319.842 29.498c39.331-39.331 103.328-39.331 142.66 0 39.331 39.332 39.331 103.327 0 142.657l-222.63 222.626c-28.297 28.301-74.347 28.303-102.65 0-28.3-28.301-28.3-74.349 0-102.649l170.301-170.298c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971l-170.3 170.297c-15.821 15.821-15.821 41.563.001 57.385 15.821 15.82 41.564 15.82 57.385 0l222.63-222.626c26.851-26.851 26.851-70.541 0-97.394-26.855-26.851-70.544-26.849-97.395 0L80.404 314.196c-37.882 37.882-37.882 99.519 0 137.401 37.884 37.881 99.523 37.882 137.404.001l217.743-217.739c4.686-4.686 12.284-4.686 16.97 0l5.661 5.661c4.686 4.686 4.686 12.284 0 16.971L240.44 474.229C215.26 499.41 182.183 512 149.106 512z"]
  },
      dL = {
    prefix: "fal",
    iconName: "parachute-box",
    icon: [512, 512, [], "f4cd", "M511.9 204.2C499.2 80.9 368.8 0 256 0S12.8 80.9.1 204.2C-1 214.9 6.9 224 16.1 224h32.5L160 345.4V480c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V345.4L463.3 224h32.5c9.3 0 17.2-9.1 16.1-19.8zM256 32c51.8 0 112 64 112 160H144c0-96 60.2-160 112-160zM34.3 192C47.7 126.9 101 76.8 163.4 51.1c-30.1 32.7-51.4 81-51.4 140.1v.8H34.3zm145.8 128L92 224h148v96h-59.9zM320 472c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v112zm11.9-152H272v-96h147.9l-88 96zM400 192v-.8c0-59.1-21.3-107.3-51.4-140.1 62.3 25.7 115.7 75.8 129.1 140.9H400z"]
  },
      ML = {
    prefix: "fal",
    iconName: "paragraph",
    icon: [448, 512, [], "f1dd", "M440 32H224A160 160 0 0 0 64.35 202.65c5.5 85 79.91 149.35 165.13 149.35H256v120a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V64h64v408a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V64h56a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8zM256 320h-32a128 128 0 0 1 0-256h32z"]
  },
      pL = {
    prefix: "fal",
    iconName: "paragraph-rtl",
    icon: [384, 512, [], "f878", "M176 224h48v88a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V32h32v280a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V32h24a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H179.37C116.72 0 63.68 50 64 112.66 64.33 176.33 112.22 224 176 224zM119.12 57a85.55 85.55 0 0 1 60.25-25H224v160h-48c-46.12 0-79.76-33.44-80-79.51A77.8 77.8 0 0 1 119.12 57zM376 400H112v-64a16 16 0 0 0-16.12-16 15.66 15.66 0 0 0-11.19 4.7l-80 80a16 16 0 0 0 0 22.63l80 80A16.16 16.16 0 0 0 96.17 512c8 0 15.83-5.69 15.83-16v-64h264a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm-296 0v57.37L38.63 416 80 374.64z"]
  },
      zL = {
    prefix: "fal",
    iconName: "parking",
    icon: [448, 512, [], "f540", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352zM244.1 127.9H152c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-72h72c51.4 0 92.7-44.3 87.6-96.8-4.4-45.7-45.5-79.2-91.5-79.2zM248 272h-72V160h72c30.9 0 56 25.1 56 56s-25.1 56-56 56z"]
  },
      CL = {
    prefix: "fal",
    iconName: "parking-circle",
    icon: [496, 512, [], "f615", "M268.1 127.91H176c-4.42 0-8 3.58-8 8v240c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72h72c51.43 0 92.68-44.32 87.57-96.78-4.45-45.71-45.54-79.22-91.47-79.22zm3.9 144h-72v-112h72c30.88 0 56 25.12 56 56s-25.12 56-56 56zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216z"]
  },
      LL = {
    prefix: "fal",
    iconName: "parking-circle-slash",
    icon: [496, 512, [], "f616", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 464c-119.1 0-216-96.9-216-216 0-44.65 13.62-86.17 36.92-120.65l338.14 266.27C367.54 444.75 310.96 472 248 472zm-48-274.17v-37.91h72c30.88 0 56 25.12 56 56 0 24.55-15.99 45.23-38.02 52.77L200 197.83zm117.54 92.55c27.62-16.75 45.47-47.9 42.03-83.25-4.45-45.72-45.54-79.22-91.48-79.22H176c-4.42 0-8 3.58-8 8v36.72l-79.06-62.26C128.46 67.25 185.04 40 248 40c119.1 0 216 96.9 216 216 0 44.65-13.62 86.17-36.92 120.64l-109.54-86.26zM168 375.91c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72h31.25L168 254.11v121.8z"]
  },
      AL = {
    prefix: "fal",
    iconName: "parking-slash",
    icon: [640, 512, [], "f617", "M496 64c8.8 0 16 7.2 16 16v266.1l32 25.2V80c0-26.5-21.5-48-48-48H144.1c-8.4 0-16.2 2.4-23.1 6.2L153.8 64zm-82.2 204.8c12.9-16.9 20.1-38.3 17.8-61.6-4.5-45.7-45.5-79.2-91.5-79.2H248c-3.3 0-5.5 2.2-6.8 5l34.3 27H344c30.9 0 56 25.1 56 56 0 12.5-4.2 23.9-11.2 33.2zM637 485.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zM264.1 383.9c4.4 0 8-3.6 8-8v-72h31.2l-63.2-49.7v121.7c0 4.4 3.6 8 8 8zm-120 64c-8.8 0-16-7.2-16-16V166l-32-25.2v291.1c0 26.5 21.5 48 48 48H496c8.4 0 16.1-2.3 23-6.1l-32.9-25.9z"]
  },
      NL = {
    prefix: "fal",
    iconName: "passport",
    icon: [448, 512, [], "f5ab", "M416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm0 480H64c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h352v448zm-304-64h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16s7.2 16 16 16zm112-96c70.69 0 128-57.31 128-128S294.69 64 224 64 96 121.31 96 192s57.31 128 128 128zm94.38-144h-39.09c-1.49-27.03-6.54-51.35-14.21-70.41 27.71 13.24 48.02 39.19 53.3 70.41zm-39.09 32h39.09c-5.29 31.22-25.59 57.17-53.3 70.41 7.68-19.06 12.72-43.38 14.21-70.41zM224 97.31c7.69 7.45 20.77 34.42 23.43 78.69h-46.87c2.67-44.26 15.75-71.24 23.44-78.69zM247.43 208c-2.66 44.26-15.74 71.24-23.43 78.69-7.69-7.45-20.77-34.42-23.43-78.69h46.86zm-64.51-102.41c-7.68 19.06-12.72 43.38-14.21 70.41h-39.09c5.28-31.22 25.59-57.17 53.3-70.41zM168.71 208c1.49 27.03 6.54 51.35 14.21 70.41-27.71-13.24-48.02-39.19-53.3-70.41h39.09z"]
  },
      gL = {
    prefix: "fal",
    iconName: "pastafarianism",
    icon: [640, 512, [], "f67b", "M629.28 355.14c-29.93-10.97-52.59 3.78-70.75 15.61-16.97 11-27.2 16.95-40.3 12.2-13.1-4.8-16.61-15.83-21.61-34.89-3.35-12.71-7.23-27.35-16.85-39.25 7.51-9.17 13.47-17.9 18.21-25.65 9.74 11.26 22.76 20.84 42.18 20.84 30.03 0 44.88-22.84 55.71-39.52 11.08-17.03 17-24.48 27.49-24.48 9.2 0 16.64-7.16 16.64-16s-7.44-16-16.64-16c-30.03 0-44.88 22.84-55.71 39.52-11.08 17.03-17 24.48-27.49 24.48-46.08 0-20.68-62.88-119.11-118.33l21.13-42.26c1.94.2 3.82.59 5.82.59 30.93 0 56-25.07 56-56S478.93 0 448 0s-56 25.07-56 56c0 17.42 8.12 32.78 20.58 43.05l-20.56 41.11C371.26 132.66 347.38 128 320 128s-51.26 4.66-72.03 12.16l-20.56-41.11C239.88 88.78 248 73.42 248 56c0-30.93-25.07-56-56-56s-56 25.07-56 56 25.07 56 56 56c1.99 0 3.88-.38 5.82-.59l21.13 42.26C120.52 209.12 145.92 272 99.84 272c-10.5 0-16.41-7.45-27.49-24.48C61.52 230.84 46.67 208 16.64 208 7.44 208 0 215.16 0 224s7.44 16 16.64 16c10.5 0 16.41 7.45 27.49 24.48C54.96 281.16 69.81 304 99.84 304c19.42 0 32.44-9.58 42.18-20.84 4.74 7.75 10.7 16.48 18.21 25.65-9.62 11.9-13.5 26.54-16.85 39.25-5.01 19.06-8.52 30.09-21.61 34.89-13.1 4.75-23.33-1.2-40.3-12.2-18.17-11.83-40.82-26.58-70.75-15.61-8.61 3.14-12.9 12.39-9.62 20.66 3.25 8.27 12.87 12.41 21.45 9.25 13.1-4.83 23.34 1.17 40.3 12.2 13.68 8.91 29.9 19.45 49.86 19.45 6.53 0 13.52-1.14 20.9-3.84 29.93-10.97 36.66-36.45 42.05-56.92 2.51-9.57 4.65-17.11 7.82-22.85 19.39 17.36 44.71 33.15 76.63 42.41-12.45 50.02-36.41 102.84-68.11 102.84-8.84 0-16 7.53-16 16.83 0 9.3 7.16 16.83 16 16.83 60.44 0 89.31-88.06 99.63-129.86 9.04 1.14 18.43 1.86 28.37 1.86s19.33-.73 28.37-1.86C358.69 423.94 387.56 512 448 512c8.84 0 16-7.53 16-16.83 0-9.3-7.16-16.83-16-16.83-31.7 0-55.66-52.82-68.11-102.85 31.92-9.26 57.24-25.04 76.63-42.41 3.16 5.75 5.3 13.28 7.82 22.85 5.39 20.47 12.12 45.95 42.05 56.92 7.38 2.7 14.37 3.84 20.9 3.84 19.96 0 36.17-10.55 49.86-19.45 16.96-11.03 27.2-17.03 40.3-12.2 8.58 3.16 18.2-.98 21.45-9.25 3.28-8.26-1.01-17.51-9.62-20.65zM448 32c13.23 0 24 10.77 24 24s-10.77 24-24 24-24-10.77-24-24 10.77-24 24-24zM192 80c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm128 272c-97.04 0-142.39-68.26-156.81-96.01C177.55 228.36 222.88 160 320 160s142.45 68.36 156.81 95.99C462.39 283.74 417.04 352 320 352z"]
  },
      HL = {
    prefix: "fal",
    iconName: "paste",
    icon: [448, 512, [], "f0ea", "M433.941 193.941l-51.882-51.882A48 48 0 0 0 348.118 128H320V80c0-26.51-21.49-48-48-48h-66.752C198.643 13.377 180.858 0 160 0s-38.643 13.377-45.248 32H48C21.49 32 0 53.49 0 80v288c0 26.51 21.49 48 48 48h80v48c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V227.882a48 48 0 0 0-14.059-33.941zm-22.627 22.627a15.888 15.888 0 0 1 4.195 7.432H352v-63.509a15.88 15.88 0 0 1 7.431 4.195l51.883 51.882zM160 30c9.941 0 18 8.059 18 18s-8.059 18-18 18-18-8.059-18-18 8.059-18 18-18zM48 384c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h66.752c6.605 18.623 24.389 32 45.248 32s38.643-13.377 45.248-32H272c8.822 0 16 7.178 16 16v48H176c-26.51 0-48 21.49-48 48v208H48zm352 96H176c-8.822 0-16-7.178-16-16V176c0-8.822 7.178-16 16-16h144v72c0 13.2 10.8 24 24 24h72v208c0 8.822-7.178 16-16 16z"]
  },
      VL = {
    prefix: "fal",
    iconName: "pause",
    icon: [448, 512, [], "f04c", "M48 479h96c26.5 0 48-21.5 48-48V79c0-26.5-21.5-48-48-48H48C21.5 31 0 52.5 0 79v352c0 26.5 21.5 48 48 48zM32 79c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V79zm272 400h96c26.5 0 48-21.5 48-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48zM288 79c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16V79z"]
  },
      xL = {
    prefix: "fal",
    iconName: "pause-circle",
    icon: [512, 512, [], "f28b", "M218 160h-20c-3.3 0-6 2.7-6 6v180c0 3.3 2.7 6 6 6h20c3.3 0 6-2.7 6-6V166c0-3.3-2.7-6-6-6zm96 0h-20c-3.3 0-6 2.7-6 6v180c0 3.3 2.7 6 6 6h20c3.3 0 6-2.7 6-6V166c0-3.3-2.7-6-6-6zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216z"]
  },
      wL = {
    prefix: "fal",
    iconName: "paw",
    icon: [512, 512, [], "f1b0", "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm120.26 224c-20.3 0-37.81-5.77-56.35-11.88-19.68-6.49-40.02-13.19-63.91-13.19-23.65 0-43.85 6.67-63.39 13.12-18.64 6.15-36.25 11.96-56.87 11.96C96 448 96 430.12 96 424.25 96 361.35 196.19 256 256 256s160 105.35 160 168.25c0 5.87 0 23.75-39.74 23.75zm98.57-286.73c-3.57-.86-7.2-1.27-10.81-1.27-25.85 0-51.62 21-60.74 51.39-10.4 34.65 4.77 68.38 33.89 75.34 3.58.86 7.2 1.27 10.81 1.27 25.85 0 51.62-21 60.74-51.39 10.4-34.65-4.77-68.38-33.89-75.34zm3.24 66.14C472.7 245.3 458.55 256 447.98 256c-1.16 0-2.29-.13-3.37-.39-3.7-.88-6.72-3.32-8.98-7.25-4.13-7.18-4.76-17.55-1.7-27.76 5.37-17.9 19.52-28.6 30.1-28.6 1.16 0 2.29.13 3.37.39 3.7.88 6.72 3.33 8.98 7.25 4.12 7.18 4.76 17.55 1.69 27.77zm-159.51-36.8c3.55.93 7.15 1.38 10.76 1.38 27.84 0 56.22-26.82 66.7-65.25 11.84-43.42-3.64-85.21-34.58-93.36a41.92 41.92 0 0 0-10.76-1.39c-27.84 0-56.22 26.82-66.7 65.26-11.84 43.42 3.64 85.22 34.58 93.36zm-3.71-84.93C322.27 78.48 340.43 64 350.68 64c.91 0 1.77.11 2.61.33 4.13 1.09 7.12 5 8.9 8.09 5.08 8.8 8.52 25.48 2.95 45.91-7.42 27.19-25.57 41.67-35.83 41.67-.91 0-1.77-.11-2.62-.33-4.12-1.08-7.12-4.99-8.9-8.08-5.07-8.81-8.51-25.48-2.94-45.91zM182.68 192c3.61 0 7.21-.45 10.76-1.38 30.94-8.14 46.42-49.94 34.58-93.36C217.54 58.82 189.16 32 161.32 32c-3.61 0-7.21.45-10.76 1.39-30.94 8.14-46.42 49.94-34.58 93.36 10.48 38.43 38.87 65.25 66.7 65.25zM149.8 72.42c1.78-3.09 4.78-7 8.9-8.09.85-.22 1.7-.33 2.61-.33 10.26 0 28.41 14.48 35.83 41.68 5.57 20.43 2.13 37.11-2.95 45.91-1.78 3.09-4.77 7-8.9 8.08-.85.22-1.7.33-2.61.33-10.26 0-28.41-14.48-35.83-41.68-5.57-20.42-2.13-37.1 2.95-45.9zM74.84 286.73c29.12-6.96 44.29-40.69 33.88-75.34C99.6 181 73.83 160 47.98 160c-3.62 0-7.24.41-10.81 1.27-29.12 6.96-44.29 40.69-33.89 75.34C12.4 267 38.18 288 64.02 288c3.62 0 7.24-.41 10.82-1.27zM33.93 227.4c-3.06-10.21-2.43-20.59 1.7-27.76 2.26-3.93 5.28-6.37 8.98-7.25 1.08-.26 2.21-.39 3.37-.39 10.57 0 24.72 10.7 30.09 28.59 3.06 10.21 2.43 20.59-1.7 27.77-2.26 3.93-5.28 6.37-8.98 7.25-1.1.26-2.2.39-3.37.39-10.57 0-24.72-10.7-30.09-28.6z"]
  },
      yL = {
    prefix: "fal",
    iconName: "paw-alt",
    icon: [448, 512, [], "f701", "M367.31 300.78c-26.29-14.84-47.14-61.41-67.17-97.83C284.41 174.31 254.21 160 224 160s-60.41 14.31-76.15 42.95c-20.29 36.96-40.12 82.56-67.17 97.83C51.63 317.18 32 348.18 32 383.95c0 53.01 42.98 95.98 96 95.98 1.31.04 2.6.07 3.87.07 48.88 0 68.92-32.06 92.13-32.06S267.25 480 316.13 480c1.27 0 2.56-.02 3.87-.07 53.02 0 96-42.97 96-95.98 0-35.77-19.63-66.77-48.69-83.17zm-48.39 147.17l-2.79.05c-20.12 0-33.04-7.72-46.73-15.89-12.71-7.58-27.1-16.17-45.39-16.17s-32.69 8.59-45.39 16.17C164.93 440.28 152 448 131.88 448l-3.87-.07c-35.29 0-64-28.7-64-63.98 0-22.82 12.42-44.02 32.42-55.31 30.46-17.2 50.03-54.48 68.96-90.53 3.52-6.71 7.02-13.37 10.52-19.75C184.97 201.85 202.95 192 224 192s39.03 9.85 48.1 26.36c3.31 6.02 6.64 12.32 10.02 18.71 19.4 36.69 39.46 74.63 69.46 91.57 20 11.29 32.42 32.49 32.42 55.31 0 35.28-28.71 63.98-65.08 64zM112 200c0-30.93-25.07-56-56-56S0 169.07 0 200s25.07 56 56 56 56-25.07 56-56zm-80 0c0-13.23 10.77-24 24-24s24 10.77 24 24-10.77 24-24 24-24-10.77-24-24zm360-56c-30.93 0-56 25.07-56 56s25.07 56 56 56 56-25.07 56-56-25.07-56-56-56zm0 80c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm-96-80c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0-80c13.23 0 24 10.77 24 24s-10.77 24-24 24-24-10.77-24-24 10.77-24 24-24zm-144 80c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0-80c13.23 0 24 10.77 24 24s-10.77 24-24 24-24-10.77-24-24 10.77-24 24-24z"]
  },
      bL = {
    prefix: "fal",
    iconName: "paw-claws",
    icon: [512, 512, [], "f702", "M318.55 222.61c40.16 10.56 69.55-34.86 77.46-63.87 8.44-30.94 3.01-61.05-12.01-78.75L320 0v74.96c-15.94 11.26-29.49 30.37-36.02 54.29-11.84 43.42 3.64 85.22 34.57 93.36zm-3.7-84.93c18.22-66.79 66.59-47.08 50.29 12.65-18.19 66.71-66.59 47.12-50.29-12.65zm178.65 52.69L448 128v66.94c-19.83 6.55-37.51 24.43-44.72 48.46-10.4 34.65 4.77 68.38 33.89 75.34 30.46 7.29 61.64-17.11 71.55-50.13 8.85-29.51-1.55-59.5-15.22-78.24zm-15.43 69.03c-12.72 42.35-56.89 35.65-44.15-6.81 12.69-42.26 56.91-35.72 44.15 6.81zM256 256c-79.41 0-191.99 122.76-191.99 200.25 0 34.91 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.84 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C447.99 378.76 335.41 256 256 256zm120.26 224c-20.3 0-37.81-5.77-56.34-11.88-19.68-6.49-40.02-13.19-63.91-13.19-23.65 0-43.85 6.67-63.39 13.12-18.64 6.15-36.25 11.96-56.87 11.96-39.74 0-39.74-17.88-39.74-23.75C96.01 393.35 196.19 288 256 288s159.99 105.35 159.99 168.25c0 5.87 0 23.75-39.73 23.75zM108.73 243.39c-7.21-24.03-24.89-41.91-44.72-48.46V128L18.5 190.37C4.81 209.13-5.57 239.11 3.29 268.61c10 33.3 41.36 57.35 71.55 50.13 29.11-6.97 44.29-40.7 33.89-75.35zM33.94 259.4c-12.84-42.77 31.51-48.87 44.15-6.81 12.8 42.69-31.5 48.95-44.15 6.81zm159.51-36.79c30.94-8.14 46.42-49.94 34.58-93.36-6.53-23.92-20.07-43.04-36.02-54.29V0L128 79.99c-15.02 17.7-20.45 47.82-12.01 78.75 7.65 28.05 37.08 74.5 77.46 63.87zm3.7-84.93c16.2 59.39-32 79.74-50.3 12.65-16.19-59.39 32-79.75 50.3-12.65z"]
  },
      SL = {
    prefix: "fal",
    iconName: "peace",
    icon: [496, 512, [], "f67c", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm216 248c0 45.24-14.04 87.23-37.9 121.97L264 248.3V40.81C375.63 49.05 464 142.3 464 256zM232 40.81V248.3L69.9 377.97C46.04 343.23 32 301.24 32 256c0-113.7 88.37-206.95 200-215.19zM90.05 402.85L232 289.3v181.89c-55.93-4.13-105.9-29.59-141.95-68.34zM264 471.19V289.3l141.95 113.55C369.9 441.6 319.93 467.06 264 471.19z"]
  },
      TL = {
    prefix: "fal",
    iconName: "pegasus",
    icon: [576, 512, [], "f703", "M575.95 86.27c-.01-9.62-3.67-15.92-9.14-22.56 5.39-9.45 8.38-20.32 8.38-31.71 0-17.67-14.33-32-32-32H432c-69.18 0-125.38 55.26-127.59 123.92-35.69-9.21-63.11-34.71-81.5-76.6-4-9.16-13.06-15.16-23.03-15.31-10.53.2-18.84 5.36-23.13 14.39C165.63 69.94 160 95.08 160 121.09c0 75.38 56.56 143.6 132.87 161.9 4.42 1.06 8.86-1.96 9.7-6.43l2.97-15.7c.8-4.22-1.93-8.17-6.1-9.2C237.69 236.47 192 181.6 192 121.09c0-16.31 2.72-32.19 8.06-47.38C229.38 130.23 276.1 160 335.94 160l.06-32c0-53.02 42.98-96 96-96h111.19c0 13.29-8.11 24.67-19.63 29.5l20.39 24.78.05 93.88a16 16 0 0 1-10.83 15.15l-25.52 8.71c-9.35 3.19-16.15-2.77-18.48-6.27L464 160l-48-16v100.21c0 26.67-12.64 50.17-32 65.6V480h-64V325.8l-136.43-30.32-32.12 89.47L175.53 480H118l-21.13-87.86a31.698 31.698 0 0 1 .37-16.18l27.63-93.41C107.45 270.37 96 250.24 96 227.37c0-27.2 16.21-50.49 39.41-61.13-3.19-10.36-5.22-21.01-6.18-31.92a100.202 100.202 0 0 0-50.57 41.82C35.11 176.87 0 212.28 0 256v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56c0-21.5 14.23-39.48 33.71-45.59-.96 5.54-1.71 11.15-1.71 16.96 0 24.2 8.9 47.33 24.53 65.24l-21.97 74.28c-3.12 10.77-3.38 22.03-.8 32.74l21.13 87.86C90.34 501.86 103.2 512 118 512h57.53c20.95 0 36.12-19.75 31.02-39.86l-21.68-85.57 19.29-53.73L288 351.47V480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V323.81c20.5-21.51 32-49.75 32-79.6v-50.52l14.55 21.82c19.11 28.67 49.98 20.67 55.45 18.8l25.52-8.71c19.44-6.63 32.5-24.9 32.49-45.45l-.06-93.88zM496.01 96c0-8.84-7.16-16-16-16s-16 7.16-16 16 7.16 16 16 16 16-7.16 16-16z"]
  },
      DL = {
    prefix: "fal",
    iconName: "pen",
    icon: [512, 512, [], "f304", "M493.25 56.26l-37.51-37.51C443.25 6.25 426.87 0 410.49 0s-32.76 6.25-45.26 18.74L12.85 371.12.15 485.34C-1.45 499.72 9.88 512 23.95 512c.89 0 1.78-.05 2.69-.15l114.14-12.61 352.48-352.48c24.99-24.99 24.99-65.51-.01-90.5zM126.09 468.68l-93.03 10.31 10.36-93.17 263.89-263.89 82.77 82.77-263.99 263.98zm344.54-344.54l-57.93 57.93-82.77-82.77 57.93-57.93c6.04-6.04 14.08-9.37 22.63-9.37 8.55 0 16.58 3.33 22.63 9.37l37.51 37.51c12.47 12.48 12.47 32.78 0 45.26z"]
  },
      jL = {
    prefix: "fal",
    iconName: "pen-alt",
    icon: [512, 512, [], "f305", "M493.25 56.26l-37.51-37.51C443.24 6.25 426.86 0 410.49 0c-16.38 0-32.76 6.25-45.25 18.74l-67.88 67.88L274.74 64c-12.5-12.5-32.76-12.5-45.25 0L99.37 194.12c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0L252.1 86.63l22.62 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.12l-.03.23C-1.45 499.72 9.88 512 23.95 512c5.73 0 111.06-6.99 198.03-93.95l271.28-271.28c24.99-25 24.99-65.52-.01-90.51zm-293.9 339.16c-45 45-103.93 74.41-166.1 83.39 9.13-62.64 38.5-121.32 83.34-166.16l180.77-180.77.01.01.01-.01 82.76 82.76-180.79 180.78zm271.28-271.28l-67.88 67.88-82.77-82.77 67.88-67.88c12.5-12.5 32.74-12.51 45.25 0l37.51 37.51c12.51 12.5 12.52 32.74.01 45.26z"]
  },
      EL = {
    prefix: "fal",
    iconName: "pen-fancy",
    icon: [512, 512, [], "f5ac", "M424.86 0c-23.46 0-46.85 9.64-63.71 28.72L169.93 240 84.1 268.62a34.005 34.005 0 0 0-21.5 21.5L0 478l33.99 34 187.79-62.62a34.005 34.005 0 0 0 21.5-21.5l28.6-85.88 211.19-191.3C544.5 96.38 500.08 0 424.86 0zM212.93 417.75c-.2.59-145.42 49.34-145.42 49.34l68.63-68.66c2.56.66 5.03 1.57 7.8 1.57 17.67 0 31.99-14.33 31.99-32s-14.32-32-31.99-32-31.99 14.33-31.99 32c0 2.77.91 5.24 1.57 7.8l-68.64 68.67S93.6 299.18 94.2 298.98l88.54-29.53 59.69 59.71-29.5 88.59zM461.6 126.97L264.26 305.74l-58.09-58.11L385.11 49.92A53.057 53.057 0 0 1 424.86 32c29.1 0 55.87 25.55 54.91 56.61-.45 14.78-6.81 28.31-18.17 38.36z"]
  },
      kL = {
    prefix: "fal",
    iconName: "pen-nib",
    icon: [512, 512, [], "f5ad", "M493.87 95.6L416.4 18.13C404.32 6.04 388.48 0 372.64 0c-15.84 0-31.68 6.04-43.76 18.13l-92.45 92.45-99.83 28.21a64.003 64.003 0 0 0-43.31 41.35L0 460l52 52 279.86-93.29a64.003 64.003 0 0 0 41.35-43.31l28.21-99.83 92.45-92.45c24.17-24.17 24.17-63.35 0-87.52zM342.42 366.7a31.985 31.985 0 0 1-20.68 21.66l-261.1 87.03-.7-.7L175.7 358.93c9.52 5.62 20.47 9.07 32.3 9.07 35.28 0 64-28.7 64-64s-28.72-64-64-64-64 28.7-64 64c0 11.83 3.45 22.79 9.07 32.31L37.32 452.06l-.71-.7 87.03-261.1a31.986 31.986 0 0 1 21.66-20.68l99.83-28.21 1.25-.36 124.6 124.6-.35 1.25-28.21 99.84zM176 304c0-17.64 14.34-32 32-32s32 14.36 32 32-14.34 32-32 32-32-14.36-32-32zm295.25-143.51l-80.06 80.06-119.75-119.73 80.07-80.06c11.67-11.67 30.58-11.69 42.27 0l77.47 77.47c11.65 11.65 11.65 30.61 0 42.26z"]
  },
      IL = {
    prefix: "fal",
    iconName: "pen-square",
    icon: [448, 512, [], "f14b", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352zm-67.1-324.3c-15.6-15.6-40.9-15.6-56.6 0L72 328l-7.9 71.4C63 409 71.1 417 80.7 416l71.3-8 220.3-220.3c15.6-15.6 15.6-40.9 0-56.6l-23.4-23.4zM137.3 377.4l-39.1 4.3 4.3-39.1 162.7-162.7 34.7 34.7-162.6 162.8zm212.4-212.3l-27 27-34.7-34.7 27-27c3.1-3.1 8.2-3.1 11.3 0l23.4 23.4c3.1 3.1 3.1 8.2 0 11.3z"]
  },
      OL = {
    prefix: "fal",
    iconName: "pencil",
    icon: [512, 512, [], "f040", "M493.255 56.236l-37.49-37.49c-24.993-24.993-65.515-24.994-90.51 0L12.838 371.162.151 485.346c-1.698 15.286 11.22 28.203 26.504 26.504l114.184-12.687 352.417-352.417c24.992-24.994 24.992-65.517-.001-90.51zm-95.196 140.45L174 420.745V386h-48v-48H91.255l224.059-224.059 82.745 82.745zM126.147 468.598l-58.995 6.555-30.305-30.305 6.555-58.995L63.255 366H98v48h48v34.745l-19.853 19.853zm344.48-344.48l-49.941 49.941-82.745-82.745 49.941-49.941c12.505-12.505 32.748-12.507 45.255 0l37.49 37.49c12.506 12.506 12.507 32.747 0 45.255z"]
  },
      QL = {
    prefix: "fal",
    iconName: "pencil-alt",
    icon: [512, 512, [], "f303", "M493.255 56.236l-37.49-37.49c-24.993-24.993-65.515-24.994-90.51 0L12.838 371.162.151 485.346c-1.698 15.286 11.22 28.203 26.504 26.504l114.184-12.687 352.417-352.417c24.992-24.994 24.992-65.517-.001-90.51zM164.686 347.313c6.249 6.249 16.379 6.248 22.627 0L368 166.627l30.059 30.059L174 420.745V386h-48v-48H91.255l224.059-224.059L345.373 144 164.686 324.687c-6.249 6.248-6.249 16.378 0 22.626zm-38.539 121.285l-58.995 6.555-30.305-30.305 6.555-58.995L63.255 366H98v48h48v34.745l-19.853 19.853zm344.48-344.48l-49.941 49.941-82.745-82.745 49.941-49.941c12.505-12.505 32.748-12.507 45.255 0l37.49 37.49c12.506 12.506 12.507 32.747 0 45.255z"]
  },
      ZL = {
    prefix: "fal",
    iconName: "pencil-paintbrush",
    icon: [512, 512, [], "f618", "M433.43 365.35c-20.56-54.19-55.01-73.83-93.93-79.66l158.43-158.45c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25C443.3 4.69 431 0 418.71 0s-24.59 4.69-33.97 14.07l-144.52 144.5-82.07-122.72C140.34 10.44 116.87 0 93.48 0 28.72 0-35.44 80.02 22.83 144.05l110.43 121.46L19.09 379.66.35 487.11c-2.72 15.63 11.22 26.9 24.59 24.56l107.44-18.84 93.71-93.72C232.1 444.02 260.26 512 368 512c101.33 0 144-81.42 144-174.07-11.01 7.52-49.66 38.65-62.15 38.65-7.42 0-13.77-4.24-16.42-11.23zM407.36 36.7c4.09-4.09 18.61-4.09 22.7 0l45.25 45.24c6.25 6.25 6.25 16.42 0 22.67l-46.03 46.03-67.94-67.94 46.02-46zM46.51 122.52c-14.84-16.31-18.33-33.68-10.39-51.64C45.92 48.71 70.58 32 93.48 32c15.2 0 28.14 7.47 38.47 22.22l85.2 127.42-61.23 61.22L46.51 122.52zm70.38 340.54L34.5 477.5l14.38-82.37 289.83-289.8 67.94 67.94-289.76 289.79zM368 480c-39.28 0-68.54-10.37-86.96-30.82-19.21-21.33-26.21-53.48-23.74-81.28l16.87-16.87 40.03-35.59c71.69 4.61 82.45 43.17 89.31 61.26 7.33 19.35 25.52 31.87 46.33 31.87 6.57 0 13.17-1.55 20.72-4.86C458.15 442.53 430.08 480 368 480z"]
  },
      UL = {
    prefix: "fal",
    iconName: "pencil-ruler",
    icon: [512, 512, [], "f5ae", "M502.71 368.14L379.88 245.31l49.4-49.4 68.65-68.66c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25C443.3 4.69 431 0 418.71 0s-24.59 4.69-33.97 14.07l-68.65 68.64-49.4 49.4L143.87 9.29C137.68 3.1 129.56 0 121.44 0s-16.23 3.1-22.43 9.29L9.31 99c-12.38 12.39-12.39 32.47 0 44.86l122.8 122.8-113.01 113L.34 487.11c-2.72 15.63 11.22 26.9 24.59 24.56l107.44-18.84 112.94-112.96L368.14 502.7a31.621 31.621 0 0 0 22.42 9.29c8.12 0 16.24-3.1 22.43-9.29l89.72-89.7c12.39-12.39 12.39-32.47 0-44.86zM407.36 36.7c4.09-4.09 18.6-4.09 22.69 0l45.25 45.24c6.25 6.25 6.25 16.42 0 22.67l-46.03 46.03-67.94-67.94 46.03-46zM31.93 121.63l89.51-89.52L177.39 88l-39.03 39.03c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l39.04-39.04 44.1 44.05-89.5 89.49L31.93 121.63zm84.96 341.43L34.5 477.51l14.37-82.37 289.83-289.8 67.94 67.94-289.75 289.78zm273.88 17.02l-122.86-122.8 89.47-89.48 44.12 44.07-39.15 39.16c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l39.17-39.17 55.94 55.88-89.31 89.72z"]
  },
      BL = {
    prefix: "fal",
    iconName: "pennant",
    icon: [576, 512, [], "f456", "M552 191.3c-30 6.2-115.6 12.5-260.7-63.6-87-45.7-158.1-51.8-210-45.2 9-8.8 14.7-21 14.7-34.5C96 21.5 74.5 0 48 0S0 21.5 0 48c0 20.8 13.4 38.4 32 45.1V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-79.6c40.2-27.2 102-56.4 179.5-60.2 28.7-1.4 76-5.8 137.9-18.8 4.4-.9 109.4-23.8 190-121.7 11.8-14.3-.7-36.2-19.4-32.4zM48 32c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm326.9 282.1c-59.9 12.5-105.4 16.8-133 18.2-84.8 4.2-145.3 35.1-177.9 54.2V117.7c47.2-10.6 119.5-10.5 212.4 38.3 118.9 62.4 202.3 72.4 249.5 70.4-69.5 69.7-150.1 87.5-151 87.7z"]
  },
      RL = {
    prefix: "fal",
    iconName: "people-arrows",
    icon: [576, 512, [], "e068", "M480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm0-96a32,32,0,1,1-32,32A32,32,0,0,1,480,32Zm32,128H448a63.55,63.55,0,0,0-50.15,24.51,62.7,62.7,0,0,1,32.67,13.41c5.1-3.44,10.88-5.92,17.48-5.92h64a32,32,0,0,1,32,32V352H512V480H448V393.8l-12,11.81a65.12,65.12,0,0,1-20,13.44V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V384a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM128,393.81V480H64V352H32V224a32,32,0,0,1,32-32h64c6.6,0,12.39,2.49,17.49,5.92a62.6,62.6,0,0,1,32.71-13.34A63.57,63.57,0,0,0,128,160H64A64,64,0,0,0,0,224V352a32,32,0,0,0,32,32v96a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V419.07a65.42,65.42,0,0,1-20-13.46ZM96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0-96A32,32,0,1,1,64,64,32,32,0,0,1,96,32ZM472.89,304a32,32,0,0,0-9.55-22.8l-56.89-56C385.64,204.71,352,220.52,352,248v40H224V248c0-27.41-33.82-43.11-54.45-22.8l-56.89,56a32,32,0,0,0,0,45.6l56.89,56c21.3,21,54.45,4,54.45-22.8V320H352v40c0,27,33.36,43.57,54.45,22.8l56.89-56A32,32,0,0,0,472.89,304ZM192,360l-56.89-56L192,248Zm192,0V248l56.89,56Z"]
  },
      YL = {
    prefix: "fal",
    iconName: "people-carry",
    icon: [640, 512, [], "f4ce", "M635.9 444.4l-52.2-117.3c19.4-22 25-48.2 19.4-72.4l-18.4-80.2c-5-21.7-19.3-40-38.4-51.1 24.5-24 28.4-60.4 11.4-88.6C542.8 10.2 517.7 0 496 0c-33.2 0-61.9 22.5-69.9 54.8-3.5 14.1-6.2 52.1 29.3 76.4-17.3 13.2-30.8 30.5-39.4 50.5V160c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v21.8c-8.5-20-22-37.3-39.4-50.5 35.4-24.3 32.8-62.2 29.3-76.4C206 22.5 177.2 0 144 0c-21.8 0-46.8 10.3-61.6 34.7-17 28.1-13.2 64.5 11.4 88.6-19.1 11.2-33.4 29.4-38.4 51.1L37 254.6c-5.5 24.1-.2 50.3 19.4 72.4L4.1 444.4c-10.7 24.1.2 52.6 24.3 63.3 29 12.8 54.9-5.2 63.4-24.3l29.7-66.7 6.9 53.3c1.1 8.6 13 46.1 53.3 41.5 26.7-3.5 45.3-27.6 42-53.8l-10.5-81.5c-1.6-12.7-7-24.6-15.5-34.2l-41.2-46.6 4.2-16.9c4.6 6 10.2 11.4 16.7 16.1 1.7 1.2-2.7-1.6 47.7 30.4 2.2 6.2 8 10.8 14.9 10.8h160c7 0 12.8-4.5 14.9-10.8 50.4-32.1 46.1-29.2 47.7-30.4 6.5-4.8 12.1-10.2 16.7-16.1l4.2 16.9-41.1 46.6c-8.5 9.6-13.9 21.5-15.5 34.2l-10.5 81.5c-3.4 26.2 15.2 50.3 42 53.8 40.5 4.6 52.1-32.7 53.3-41.5l6.9-53.3 29.7 66.7c8.5 19.1 34.4 37.1 63.4 24.3 24-10.8 34.9-39.2 24.2-63.3zm-178.7-382C461.6 44.2 478 32 496 32c24.4 0 45.4 22.8 38.9 49.5C530.3 99.8 514 112 496 112c-24.4 0-45.4-22.9-38.8-49.6zM144 32c18 0 34.3 12.2 38.8 30.4C189.5 89.6 168 112 144 112c-18 0-34.3-12.2-38.8-30.4C98.5 54.4 120 32 144 32zM62.6 470.4c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l46.2-103.9 23.3 26.4zm207.1-173.9c-5 7.8-15 9.4-22.1 4.9l-51.1-32.5c-9.1-6.6-15-14.7-18.1-24.1L167.1 211c-2.3-6.9-6-12.8-9.3-17.2-2.7-3.6-8.3-2.4-9.4 1.9L121.3 304l52.4 59.3c4.2 4.8 6.9 10.8 7.8 17.1l10.5 81.5c1.1 8.6-4.9 16.8-13.5 17.9-14.1 1.8-17.9-11-18.2-13.8l-9.2-71.8c-.8-6.3-3.5-12.3-7.8-17.1l-64.2-72.7c-10.3-11.6-14.3-27.5-10.8-42.6l18.4-80.2c3.5-15 14-27.7 28.2-33.8 23-9.9 41.1 2.1 41.7 2.4 19.4 11.4 33.9 29.4 41 50.7l11.7 34.9c1.8 2.3 3.5 4.5 5.3 6.8l50.2 31.8c7.4 4.7 9.7 14.6 4.9 22.1zm69.2 7.4h-37.7c7.3-20.6-.2-44.2-19.3-56.5L256 231.1V176h128v55l-25.8 16.4c-19.2 12.2-26.6 35.9-19.3 56.5zm158 73.1c-4.2 4.8-6.9 10.7-7.8 17.1l-9.2 71.8c-.4 2.8-4.2 15.6-18.2 13.8-8.6-1.1-14.6-9.2-13.5-17.9l10.5-81.5c.8-6.3 3.5-12.3 7.8-17.1l52.4-59.3-27.1-108.2c-1.1-4.4-6.7-5.5-9.4-1.9-3.3 4.4-7 10.3-9.3 17.2l-11.3 33.8c-3.1 9.4-9 17.5-17.9 24.1l-51.1 32.5c-7 4.4-17.1 3-22.1-4.9-4.7-7.5-2.5-17.3 4.9-22.1l50.2-31.8c1.8-2.3 3.5-4.5 5.3-6.8l11.7-34.9c7.1-21.3 21.6-39.3 41-50.7.5-.3 18.7-12.3 41.7-2.4 14.2 6.1 24.8 18.8 28.2 33.8l18.4 80.2c3.5 15.1-.6 30.9-10.8 42.6zm101.6 101.5c-8.1 3.6-17.5 0-21.1-8.1l-40.3-90.6 23.3-26.4 46.2 103.9c3.6 8.1 0 17.6-8.1 21.2z"]
  },
      PL = {
    prefix: "fal",
    iconName: "pepper-hot",
    icon: [512, 512, [], "f816", "M452.4 135.6c43.74-64.2 25.25-112.11 13.43-131.86A7.69 7.69 0 0 0 459.19 0a7.86 7.86 0 0 0-5.57 2.32l-12 12a7.92 7.92 0 0 0-1.27 9.35c8.24 15.58 16.74 47.65-13.81 93C402.26 102 378.48 96 348.34 96c-29.43 0-58.78 8.66-84.87 25-12.06 7.59-9.55 23.21 1.47 27.93-22.94 24.82-35.7 58.31-48 93.47-10.74 30.6-21.71 61.62-40.23 88.54-25.17 36.56-68.77 52.64-113.16 53-41.41.33-59.58 35.09-62.58 52.88A64.06 64.06 0 0 0 64 512c185 0 341.43-87.14 416.23-195.48a15.1 15.1 0 0 0 10.82 4.62c6.23 0 12.54-4 14.89-13.11C510.06 292 512 278.2 512 264.72a169.7 169.7 0 0 0-59.6-129.12zM348.34 128C443 128 480 218.68 480 264.72c0 1.73 0 3.47-.13 5.24L452 241a32 32 0 0 0-23.07-9.82H368v-51.73A32 32 0 0 0 348.61 150L311 133.92a122.85 122.85 0 0 1 37.34-5.92zM64 480c-14 0-35.77-12.48-31.51-37.82.71-4.17 7.72-26 31.28-26.19 59.59-.47 110.35-24.83 139.27-66.85 21.13-30.69 33.31-65.43 44.06-96.09 24.07-68.62 36.32-76.9 48.46-90l40.44 16.4v51.71a32 32 0 0 0 32 32h60.94s14.62 15.9 28.24 30.41C370.7 418.86 211.88 480 64 480z"]
  },
      FL = {
    prefix: "fal",
    iconName: "percent",
    icon: [384, 512, [], "f295", "M96 224c53 0 96-43 96-96s-43-96-96-96S0 75 0 128s43 96 96 96zm0-156c33.1 0 60 26.9 60 60s-26.9 60-60 60-60-26.9-60-60 26.9-60 60-60zm192 220c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 156c-33.1 0-60-26.9-60-60s26.9-60 60-60 60 26.9 60 60-26.9 60-60 60zm59.8-412H378c5 0 7.8 5.7 4.8 9.6L41 477.6c-1.1 1.5-2.9 2.4-4.8 2.4H6c-5 0-7.8-5.7-4.8-9.6L343 34.4c1.1-1.5 2.9-2.4 4.8-2.4z"]
  },
      WL = {
    prefix: "fal",
    iconName: "percentage",
    icon: [320, 512, [], "f541", "M317.66 132.28c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L296.5 153.44l21.16-21.16zM64 224c16.38 0 32.76-6.25 45.25-18.74 24.99-24.99 24.99-65.52 0-90.51C96.76 102.25 80.38 96 64 96s-32.76 6.25-45.26 18.75c-24.99 24.99-24.99 65.52 0 90.51C31.24 217.75 47.62 224 64 224zm-22.62-86.63C47.42 131.33 55.45 128 64 128s16.58 3.33 22.63 9.37c12.48 12.48 12.47 32.78 0 45.25C80.59 188.67 72.55 192 64 192c-8.55 0-16.58-3.33-22.62-9.37-12.48-12.48-12.48-32.78 0-45.26zM256 288c-16.38 0-32.76 6.25-45.26 18.75-24.99 24.99-24.99 65.52 0 90.51C223.24 409.75 239.62 416 256 416s32.76-6.25 45.25-18.74c24.99-24.99 24.99-65.52 0-90.51C288.76 294.25 272.38 288 256 288zm22.63 86.63c-6.04 6.04-14.08 9.37-22.63 9.37-8.55 0-16.58-3.33-22.62-9.37-12.48-12.48-12.48-32.78 0-45.26 6.04-6.04 14.08-9.37 22.62-9.37 8.55 0 16.58 3.33 22.63 9.37 12.48 12.48 12.47 32.78 0 45.26z"]
  },
      GL = {
    prefix: "fal",
    iconName: "person-booth",
    icon: [576, 512, [], "f756", "M224.1 504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V320h-32v184zM544 0H256.1c-17.7 0-32 14.3-32 32v128h32V32l79.2 205.1c-5.4 21.2-23.5 93.2-23.5 117.1 0 34.1 27.7 61.8 61.7 61.8 12.3 0 24-3.9 34-10.6 9.2 6.6 20.4 10.6 32.5 10.6 15.7 0 29.8-6.5 40-16.9 10.2 10.4 24.3 16.9 40 16.9 8.6 0 16.7-2.1 24-5.6V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V32c0-17.7-14.3-32-32-32zM373.5 384c-16.4 0-29.7-13.4-29.7-29.8 0-16.9 14.6-78.9 23.8-114 .8-3.2.7-6.7-.5-9.8L290.9 32h93.2v328c0 7 1.4 13.6 3.8 19.7-4.5 2.6-9.2 4.3-14.4 4.3zm90.5-24c0 13.3-10.7 24-24 24s-24-10.7-24-24V32h48v328zm80 0c0 13.3-10.7 24-24 24-13.2 0-24-10.7-24-24V32h48v328zM240.1 192h-44.3l-40.5-40.6c-8.5-8.5-18.6-14.6-29.6-18.5 20.4-12.7 34.1-35.2 34.1-60.9 0-39.7-32.3-72-72-72s-72 32.3-72 72c0 26.2 14.2 49 35.2 61.6-10.2 4-19.6 9.9-27.6 17.9C8.3 166.6 0 186.8.1 208.2L.2 304 0 463.9c0 26.5 21.5 48 47.9 48.1 25.5 0 46.4-19.9 48-45 1.6 25.1 22.4 45 47.9 45 26.5 0 48-21.5 48-48v-56.5c0-36.8-13.5-43.2-48-76.9v-55.8c11.1 8.4 24.8 13.1 38.8 13.1h57.6c26.5 0 48-21.5 48-48S266.6 192 240.1 192zM47.8 72c0-22.1 17.9-40 40-40s40 17.9 40 40-17.9 40-40 40-40-17.9-40-40zm192.3 184h-57.6c-8.4 0-16.6-3.4-22.6-9.4l-48.2-48.2v145.7c42.1 41.2 48 42.1 48 63.4V464c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-78.2 15.5-45.8-63.6-121.9L64 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l.2-160-.2-95.9c0-26.2 21.2-48.1 48-48.1h18.7c12.8 0 24.9 5 33.9 14.1l49.9 49.9h57.6c8.8 0 16 7.2 16 16s-7.1 16-16 16z"]
  },
      qL = {
    prefix: "fal",
    iconName: "person-carry",
    icon: [384, 512, [], "f4cf", "M368 96H208c-8.8 0-16 7.2-16 16v76.1l-52.7-52.7c-2.4-2.4-5.1-4.2-7.7-6.3 28.1-21.5 31.4-53.5 26.3-74.4C150 22.5 121.2 0 88 0 41.7 0 6.8 43.5 18.1 89.2c3.4 13.8 10.7 25.6 20.4 34.8C15.6 138.1 0 163.4 0 192v272c0 26.5 21.5 48 48 48s48-21.5 48-48v-66l3.6 3.1 13.1 71.5c4.4 23.8 27.8 43.8 56 38.5 25.7-4.7 43.3-29.5 38.4-55.8L193 378.7c-3.4-18.3-13-35.1-27.2-47.1L128 299.1v-39.2l28.1 28.1H368c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16zM88 32c18 0 34.3 12.2 38.8 30.5C133.5 89.6 112 112 88 112c-18 0-34.3-12.2-38.8-30.5C42.5 54.4 64 32 88 32zM64 464c0 8.8-7.2 16-16 16s-16-7.2-16-16V343.2l32 27.4V464zm105.4-208l-59.7-59.7c-1.6-1.6-3.6-2.4-5.6-2.4-4.1 0-8.1 3.2-8.1 8v111.9l49.2 42.1c8.6 7.3 14.4 17.5 16.5 28.6l14.1 76.6c1.6 8.7-4.2 17-12.8 18.6-1 .2-2 .3-2.9.3-7.6 0-14.3-5.4-15.7-13.1l-14.1-76.5c-.7-3.9-2.8-7.5-5.8-10.1l-75.6-64.7C38.1 306.3 32 293.1 32 279v-87c0-25.6 20.3-47.2 45.9-48H80c15.4 0 27.8 5.1 36.7 14.1l65.9 65.9H224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-54.6zm182.6 0h-82.9c1.8-5 2.9-10.4 2.9-16 0-26.5-21.5-48-48-48v-64h128v128z"]
  },
      JL = {
    prefix: "fal",
    iconName: "person-dolly",
    icon: [512, 512, [], "f4d0", "M507.6 391.8c-1.1-4.3-5.5-6.8-9.8-5.7l-20.3 5.4-40.7-151.8c-4.6-17.1-22.1-27.2-39.2-22.6l-127.1 34c.9-3.6 1.5-7.3 1.5-11.2 0-23.6-17.2-43.2-39.7-47.2L208 101.9c-1.1-4.3-5.5-6.8-9.8-5.7l-15.5 4.1c-4.3 1.1-6.8 5.5-5.7 9.8l21.8 81.8h-3l-56.6-56.6c-2.4-2.4-5.1-4.2-7.7-6.3 7.1-5.4 13.2-12 18-19.9 10-16.4 12.9-35.8 8.3-54.5C150 22.5 121.2 0 88 0 66.3 0 41.2 10.3 26.4 34.7c-10 16.4-12.9 35.8-8.3 54.5 3.4 13.8 10.7 25.6 20.4 34.8C15.6 138.1 0 163.4 0 192v272c0 26.5 21.5 48 48 48s48-21.5 48-48v-66l3.6 3.1 13.1 71.5c4.4 23.8 27.8 43.8 56 38.5 12.5-2.3 23.4-9.4 30.7-19.9 7.3-10.6 10-23.3 7.7-35.9L193 378.7c-3.4-18.3-13-35.1-27.2-47.1L128 299.1v-39.2l28.1 28.1H224c.2 0 .4-.1.6-.1l28.5 106.5C235.6 405.8 224 425.5 224 448c0 35.3 28.7 64 64 64 31.7 0 57.8-23.1 62.9-53.4L506.1 417c4.3-1.1 6.8-5.5 5.7-9.8l-4.2-15.4zM88 32c18 0 34.3 12.2 38.8 30.5C133.5 89.6 112 112 88 112c-18 0-34.3-12.2-38.8-30.5C42.5 54.4 64 32 88 32zM64 464c0 8.8-7.2 16-16 16s-16-7.2-16-16V343.2l32 27.4V464zm105.4-208l-59.7-59.7c-1.6-1.6-3.6-2.4-5.6-2.4-4.1 0-8.1 3.2-8.1 8v111.9l49.2 42.1c8.6 7.3 14.4 17.5 16.5 28.6l14.1 76.6c1.6 8.7-4.2 17-12.8 18.6-1 .2-2 .3-2.9.3-7.6 0-14.3-5.4-15.7-13.1l-14.1-76.5c-.7-3.9-2.8-7.5-5.8-10.1l-75.6-64.7C38.1 306.3 32 293.1 32 279v-87c0-25.6 20.3-47.2 45.9-48H80c15.4 0 27.8 5.1 36.7 14.1l65.9 65.9H224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-54.6zM288 480c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm60-53.8c-8.9-24.6-32.3-42.3-60-42.3-1.5 0-2.9.3-4.4.4l-25.9-96.6L405.9 248l40.7 151.8-98.6 26.4z"]
  },
      KL = {
    prefix: "fal",
    iconName: "person-dolly-empty",
    icon: [512, 512, [], "f4d1", "M507.6 391.8c-1.1-4.3-5.5-6.8-9.8-5.7L348 426.2c-8.9-24.6-32.3-42.3-60-42.3-1.5 0-2.9.3-4.4.4l-28.9-107.8c10.5-8.8 17.3-21.9 17.3-36.6 0-23.6-17.2-43.2-39.7-47.2l-25.1-90.9c-1.1-4.3-5.5-6.8-9.8-5.7l-15.5 4.1c-4.3 1.1-6.8 5.5-5.7 9.8l22.6 81.8h-3l-56.6-56.6c-2.4-2.4-5.1-4.2-7.7-6.3 7.1-5.4 13.2-12 18-19.9 10-16.4 12.9-35.8 8.3-54.5C150 22.5 121.2 0 88 0 66.3 0 41.2 10.3 26.4 34.7c-10 16.4-12.9 35.8-8.3 54.5 3.4 13.8 10.7 25.6 20.4 34.8C15.6 138.1 0 163.4 0 192v272c0 26.5 21.5 48 48 48s48-21.5 48-48v-66l3.6 3.1 13.1 71.5c4.4 23.8 27.8 43.8 56 38.5 12.5-2.3 23.4-9.4 30.7-19.9 7.3-10.6 10-23.3 7.7-35.9L193 378.7c-3.4-18.3-13-35.1-27.2-47.1L128 299.1v-39.2l28.1 28.1H224c.2 0 .4-.1.6-.1l28.5 106.5C235.6 405.8 224 425.5 224 448c0 35.3 28.7 64 64 64 31.7 0 57.8-23.1 62.9-53.4L506.1 417c4.3-1.1 6.8-5.5 5.7-9.8l-4.2-15.4zM88 32c18 0 34.3 12.2 38.8 30.5C133.5 89.6 112 112 88 112c-18 0-34.3-12.2-38.8-30.5C42.5 54.4 64 32 88 32zM64 464c0 8.8-7.2 16-16 16s-16-7.2-16-16V343.2l32 27.4V464zm105.4-208l-59.7-59.7c-1.6-1.6-3.6-2.4-5.6-2.4-4.1 0-8.1 3.2-8.1 8v111.9l49.2 42.1c8.6 7.3 14.4 17.5 16.5 28.6l14.1 76.6c1.6 8.7-4.2 17-12.8 18.6-1 .2-2 .3-2.9.3-7.6 0-14.3-5.4-15.7-13.1l-14.1-76.5c-.7-3.9-2.8-7.5-5.8-10.1l-75.6-64.7C38.1 306.3 32 293.1 32 279v-87c0-25.6 20.3-47.2 45.9-48H80c15.4 0 27.8 5.1 36.7 14.1l65.9 65.9H224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-54.6zM288 480c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"]
  },
      XL = {
    prefix: "fal",
    iconName: "person-sign",
    icon: [512, 512, [], "f757", "M501.5 66.6l-71.7-26.1 9.5-23.2c1.7-4.1-.2-8.8-4.3-10.5L420.2.6c-4.1-1.7-8.8.2-10.5 4.3l-10 24.7L321.1 1c-8.9-3.2-18 2.7-20.5 9.6L264.1 111c-3 8.3 1.2 17.5 9.6 20.5l73.6 26.8-22.5 55.4c-3.7-1.8-7.3-3.9-11.5-4.8L253.6 197l-10.1-16.1c-11.9-19-28.8-33.5-48.4-42.5 12.8-13 20.7-30.8 20.7-50.4 0-39.7-32.3-72-72-72S72 48.3 72 88c0 20.8 9 39.4 23.1 52.6-22.8 11.3-41.9 29.7-53.8 53.5L5 266.5c-11.8 23.7-2.2 52.6 21.5 64.4.7.3 26.5 14.1 51-5L49.1 453.6c-5.7 25.8 10.6 51.5 36.4 57.3 3.6.8 7 1.1 10.4 1.1 22.3 0 42-15.8 46.8-37.6l17.2-77.5 15.9 19.9V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-52.8c0-18.1-6.2-35.8-17.5-50l-46.5-58.1v-20.3c6.3 3.2 13.1 5.5 20.1 6.9l60.8 12.2-.3.8c-1.7 4.1.2 8.8 4.3 10.5l14.8 6.2c4.1 1.7 8.8-.2 10.5-4.3l6.7-16.6c13-6.4 23.1-18.1 26.2-33.1 1.8-8.8.9-17.8-2.1-26l28.6-70.2 76.6 27.9c8.9 3.3 18-2.8 20.5-9.6L511 87.1c3.1-8.3-1.2-17.4-9.5-20.5zM143.9 48c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm157.2 223.7h-.4l-66.4-13.3c-12.9-2.6-24.3-10.5-31.3-21.6-14.6-23.3-16.3-28-27.1-35.6v113.2l53.5 66.9c6.8 8.5 10.5 19.1 10.5 30V464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-52.8c0-3.6-1.2-7.2-3.5-10L152.2 336h-11.5l-29.2 131.5c-1.7 7.7-9.6 14.2-19.1 12.2-8.6-1.9-14.1-10.5-12.2-19.1l31.6-142.3V206c-5.3 4.7-10.1 10-13.4 16.7l-36.2 72.5c-3.1 6.2-12.1 11.9-21.5 7.2-7.9-4-11.1-13.6-7.2-21.5l36.2-72.5c14.9-29.8 44.9-48.4 78.2-48.4 28 0 53.5 14.2 68.3 37.9l13.7 21.9c2.3 3.7 6.1 6.3 10.4 7.2l66.4 13.3c2.2.4 4.2 1.3 5.9 2.5l-11.5 28.9zm148.8-110.1l-150.3-54.7 25.6-70.4 150.3 54.7-25.6 70.4z"]
  },
      _L = {
    prefix: "fal",
    iconName: "phone",
    icon: [512, 512, [], "f095", "M487.8 24.1L387 .8c-14.7-3.4-29.8 4.2-35.8 18.1l-46.5 108.5c-5.5 12.7-1.8 27.7 8.9 36.5l53.9 44.1c-34 69.2-90.3 125.6-159.6 159.6l-44.1-53.9c-8.8-10.7-23.8-14.4-36.5-8.9L18.9 351.3C5 357.3-2.6 372.3.8 387L24 487.7C27.3 502 39.9 512 54.5 512 306.7 512 512 307.8 512 54.5c0-14.6-10-27.2-24.2-30.4zM55.1 480l-23-99.6 107.4-46 59.5 72.8c103.6-48.6 159.7-104.9 208.1-208.1l-72.8-59.5 46-107.4 99.6 23C479.7 289.7 289.6 479.7 55.1 480z"]
  },
      $L = {
    prefix: "fal",
    iconName: "phone-alt",
    icon: [512, 512, [], "f879", "M493.09 351.3L384.7 304.8a31.36 31.36 0 0 0-36.5 8.9l-44.1 53.9A350 350 0 0 1 144.5 208l53.9-44.1a31.35 31.35 0 0 0 8.9-36.49l-46.5-108.5A31.33 31.33 0 0 0 125 .81L24.2 24.11A31.05 31.05 0 0 0 0 54.51C0 307.8 205.3 512 457.49 512A31.23 31.23 0 0 0 488 487.7L511.19 387a31.21 31.21 0 0 0-18.1-35.7zM456.89 480C222.4 479.7 32.3 289.7 32.1 55.21l99.6-23 46 107.39-72.8 59.5C153.3 302.3 209.4 358.6 313 407.2l59.5-72.8 107.39 46z"]
  },
      cA = {
    prefix: "fal",
    iconName: "phone-laptop",
    icon: [640, 512, [], "f87a", "M608 128H416a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32zm0 352H416V160h192zM96 32h384v64h32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v256H16a16 16 0 0 0-16 16v16a64.14 64.14 0 0 0 63.91 64H352v-32H63.91A32 32 0 0 1 32 320h320v-32H96z"]
  },
      eA = {
    prefix: "fal",
    iconName: "phone-office",
    icon: [576, 512, [], "f67d", "M352 320h-32c-17.66 0-32 14.36-32 32v32c0 17.64 14.34 32 32 32h32c17.66 0 32-14.36 32-32v-32c0-17.64-14.34-32-32-32zm0 64h-32v-32h32v32zm0-192h-32c-17.66 0-32 14.36-32 32v32c0 17.64 14.34 32 32 32h32c17.66 0 32-14.36 32-32v-32c0-17.64-14.34-32-32-32zm0 64h-32v-32h32v32zm128 64h-32c-17.66 0-32 14.36-32 32v32c0 17.64 14.34 32 32 32h32c17.66 0 32-14.36 32-32v-32c0-17.64-14.34-32-32-32zm0 64h-32v-32h32v32zm0-192h-32c-17.66 0-32 14.36-32 32v32c0 17.64 14.34 32 32 32h32c17.66 0 32-14.36 32-32v-32c0-17.64-14.34-32-32-32zm0 64h-32v-32h32v32zm32-224H237.06C230.45 13.4 212.87 0 192 0h-64c-20.87 0-38.45 13.4-45.06 32H64C28.65 32 0 60.65 0 96v352c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM320 64h160v64H320V64zM112 48c0-8.82 7.18-16 16-16h64c8.82 0 16 7.18 16 16v336c0 8.82-7.18 16-16 16h-64c-8.82 0-16-7.18-16-16V48zm432 400c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h16v320c0 26.51 21.49 48 48 48h64c26.51 0 48-21.49 48-48V64h48v64c0 17.64 14.34 32 32 32h160c17.66 0 32-14.36 32-32V64c17.64 0 32 14.36 32 32v352z"]
  },
      aA = {
    prefix: "fal",
    iconName: "phone-plus",
    icon: [512, 512, [], "f4d2", "M8 128h88v88c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-88h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-88V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v88H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zM487.8 24.1L387 .8c-14.7-3.4-29.8 4.2-35.8 18.1l-46.5 108.5c-5.5 12.7-1.8 27.7 8.9 36.5l53.9 44.1c-34 69.2-90.3 125.6-159.6 159.6l-44.1-53.9c-8.8-10.7-23.8-14.4-36.5-8.9L18.9 351.3c-13.9 6-21.5 21-18.1 35.8L24 487.9C27.3 502 39.9 512 54.5 512 306.7 512 512 307.8 512 54.5c0-14.6-10-27.2-24.2-30.4zM55.1 480l-23-99.6 107.4-46 59.5 72.8c103.6-48.6 159.7-104.9 208.1-208.1l-72.8-59.5 46-107.4 99.6 23C479.7 289.7 289.6 479.7 55.1 480z"]
  },
      nA = {
    prefix: "fal",
    iconName: "phone-rotary",
    icon: [512, 512, [], "f8d3", "M256 240a80 80 0 1 0 80 80 80 80 0 0 0-80-80zm0 128a48 48 0 1 1 48-48 48.05 48.05 0 0 1-48 48zm114.43-175.75A64 64 0 0 0 314.86 160H197.14a64 64 0 0 0-55.57 32.25L36.21 376.62A32 32 0 0 0 32 392.5V448a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-55.5a32 32 0 0 0-4.21-15.88zM448 448H64v-55.5l105.36-184.38A32.07 32.07 0 0 1 197.14 192h117.72a32.07 32.07 0 0 1 27.78 16.12L448 392.5zm52.27-329.8C431.72 63.21 344.81 32 256 32S80.28 63.21 11.73 118.2A32.17 32.17 0 0 0 0 143.29V208a16 16 0 0 0 16 16h70.11a16 16 0 0 0 14.31-8.85L128 152c39.9-17.28 83.23-24 128-24 44.77 0 88.08 6.72 128 24l27.58 63.15a16 16 0 0 0 14.31 8.85H496a16 16 0 0 0 16-16v-64.71a32.17 32.17 0 0 0-11.73-25.09zM480 192h-43.61l-23.07-52.81-5-11.55-11.57-5C355.33 104.71 309.3 96 256 96s-99.32 8.71-140.71 26.63l-11.57 5-5 11.55L75.61 192H31.94l-.18-48.84A359.7 359.7 0 0 1 256 64a357.89 357.89 0 0 1 224 79.29z"]
  },
      tA = {
    prefix: "fal",
    iconName: "phone-slash",
    icon: [640, 512, [], "f3dd", "M637 485.2L462.6 347.9l-21.2-16.7-35.4-27.8-17.4-13.7L23 1.8C19.6-1 14.5-.4 11.8 3l-10 12.5C-1 19-.4 24 3 26.8l355.7 280.1 10.9 8.6 69 54.3 6.4 5 172 135.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.6 2.2-8.6-1.2-11.4zM431.6 208c-8.8 17.8-19 34.7-30.6 50.7l24.6 19.4c16.4-23.1 31.4-48.9 45.6-79l-72.8-59.5 46-107.4 99.6 23c-.1 94-31.1 180.6-82.8 251l25.1 19.8C542.4 249.9 576 156.4 576 54.5c0-14.6-10-27.2-24.2-30.4L451 .8c-14.7-3.4-29.8 4.2-35.8 18.1l-46.5 108.5c-5.5 12.7-1.8 27.7 8.9 36.5l54 44.1zM119.1 480l-23-99.6 107.4-46 59.5 72.8c38.1-17.9 69.6-36.8 96.8-58.7L334 328.1c-19.2 15.1-39.9 28.5-62 39.4l-44.1-53.9c-8.8-10.7-23.8-14.4-36.5-8.9L82.9 351.3c-13.9 6-21.5 21-18.1 35.7L88 487.7c3.3 14.3 15.8 24.2 30.4 24.2 116.1 0 222-43.7 302.8-115.1l-25.5-20C321.5 440.9 224.9 479.9 119.1 480z"]
  },
      rA = {
    prefix: "fal",
    iconName: "phone-square",
    icon: [448, 512, [], "f098", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm16 400c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h352c8.822 0 16 7.178 16 16v352zm-54.867-321.745l-58.499-13.493a29.473 29.473 0 0 0-33.748 17.123l-27.001 62.995c-5.146 12.012-1.678 26.179 8.435 34.451l24.129 19.742a192.006 192.006 0 0 1-75.376 75.375l-19.74-24.127c-8.273-10.115-22.44-13.582-34.453-8.435l-62.992 26.998c-13.138 5.63-20.34 19.824-17.125 33.748l13.494 58.501C81.363 406.597 93.184 416 107 416c153.033 0 277-123.819 277-277 0-13.818-9.403-25.639-22.867-28.745zM108.987 383.992l-12.579-54.518 59.348-25.435 34.601 42.288c61.893-29.035 94.185-60.484 123.973-123.971l-42.29-34.602 25.436-59.348 54.518 12.579c-1.057 133.704-109.058 241.949-243.007 243.007z"]
  },
      iA = {
    prefix: "fal",
    iconName: "phone-square-alt",
    icon: [448, 512, [], "f87b", "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm16 400a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V80a16 16 0 0 1 16-16h352a16 16 0 0 1 16 16zm-49.89-131.12l-63-27a29.63 29.63 0 0 0-34.45 8.43l-19.74 24.13c-26.82-14.79-60.59-48.56-75.38-75.38l24.13-19.74a29.65 29.65 0 0 0 8.44-34.45l-27-63C174.89 104 162.75 96 152 96a35.39 35.39 0 0 0-6.65.76l-58.5 13.49A29.37 29.37 0 0 0 64 139c0 153.18 124 277 277 277a29.35 29.35 0 0 0 28.74-22.87l13.5-58.5a29.49 29.49 0 0 0-17.13-33.75zM339 384C205.06 382.93 97.06 274.69 96 141l54.51-12.58L176 187.75l-42.29 34.61c29.79 63.48 62.08 94.93 124 124L292.24 304l59.35 25.43z"]
  },
      oA = {
    prefix: "fal",
    iconName: "phone-volume",
    icon: [448, 512, [], "f2a0", "M154.9 187.8c14.7 1.5 28.7-7 34.2-20.7l32.5-81c6-14.9.4-31.9-13.3-40.5l-65-40.5c-13.2-8.2-30.1-6.3-41.1 4.7C-34.3 146-34 366.4 102.2 502.3c11 11 27.9 12.9 41.1 4.7l65-40.5C222 458 227.5 441 221.6 426l-32.5-81c-5.5-13.6-19.5-22.1-34.2-20.7l-43.2 4.3c-14.5-47.2-14.5-97.9 0-145.1zM89.8 362.9l68.4-6.8c.5-.1 1 .2 1.2.7l32.5 81c.2.5 0 1.1-.5 1.4l-65 40.5c-.5.3-1.1.2-1.5-.2C1 356 1.1 155.9 124.9 32.4c.4-.4 1-.5 1.5-.2l65 40.5c.5.3.7.9.5 1.4l-32.5 81c-.2.5-.7.8-1.2.7L89.8 149c-28.7 79.1-27.6 137.9 0 213.9zm202.4-270l-6 5.7c-3.9 3.7-4.8 9.6-2.3 14.4 4.9 9.4 4.9 20.6 0 29.9-2.5 4.8-1.6 10.7 2.3 14.4l6 5.7c5.6 5.4 14.8 4.1 18.7-2.6 11.8-20 11.8-45 0-65.1-3.9-6.5-13-7.8-18.7-2.4zM357 49.2c-4.4-5.6-12.7-6.3-17.9-1.3l-5.8 5.6c-4.4 4.2-5 11.1-1.3 15.9 26.5 34.6 26.5 82.6 0 117.1-3.7 4.8-3.1 11.7 1.3 15.9l5.8 5.6c5.2 4.9 13.5 4.3 17.9-1.3 36.1-46.2 36.1-111.1 0-157.5zm45.9-44.9c-4.5-5.3-12.5-5.7-17.6-.9L379.5 9c-4.6 4.4-5 11.5-.9 16.4 49.7 59.5 49.6 145.9 0 205.4-4 4.8-3.6 12 .9 16.4l5.8 5.6c5 4.8 13.1 4.4 17.6-.9 60.2-71.8 60.1-176.1 0-247.6z"]
  },
      lA = {
    prefix: "fal",
    iconName: "photo-video",
    icon: [640, 512, [], "f87c", "M608 0H160c-17.67 0-32 13.13-32 29.33V128h128V32h256v288h-32v32h128c17.67 0 32-13.13 32-29.33V29.33C640 13.13 625.67 0 608 0zM224 96h-64V32h64zm384 224h-64v-64h64zm0-96h-64v-96h64zm0-128h-64V32h64zm-192 64H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zm0 320H32v-24l81.69-61.26 80 40 126.84-95.14L416 403.23zm0-115.23l-96.53-64.36-129.16 96.86-80-40L32 416V192h384zM112 320a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm0-64a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"]
  },
      fA = {
    prefix: "fal",
    iconName: "pi",
    icon: [448, 512, [], "f67e", "M444.79 385.6l-12.82-9.6a7.997 7.997 0 0 0-11.2 1.61l-20.75 27.72C395 412.02 387 416 378.66 416c-14.69 0-26.66-11.97-26.66-26.67V128h88c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H27.33c-4.24 0-8.31 1.69-11.31 4.69L2.36 114.34C-2.68 119.38.89 128 8.02 128H128v131.46c0 32.99-9.27 65.31-26.75 93.28l-46.58 74.53a8 8 0 0 0 2.54 11.02l13.56 8.48a8.006 8.006 0 0 0 11.03-2.54l46.6-74.57A207.927 207.927 0 0 0 160 259.47V128h160v258.87c0 20.63 9.6 40.73 27.02 51.79 27.57 17.5 61.15 9.08 78.61-14.12l20.78-27.73c2.64-3.55 1.92-8.56-1.62-11.21z"]
  },
      sA = {
    prefix: "fal",
    iconName: "piano",
    icon: [512, 512, [], "f8d4", "M476.62,270.31l-57.24-28.62A64,64,0,0,1,384,184.45,184.45,184.45,0,0,0,199.55,0h-15.1A184.45,184.45,0,0,0,0,184.45H0V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V327.55A64,64,0,0,0,476.62,270.31ZM480,480H32V384H80v40a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V384h32v40a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V384h32v40a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V384h96v40a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V384h32v40a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V384h48Zm0-128H32V184.45C32,100.39,100.39,32,184.45,32h15.1C283.61,32,352,100.39,352,184.45a95.49,95.49,0,0,0,53.07,85.86l57.24,28.62A31.83,31.83,0,0,1,480,327.55Z"]
  },
      uA = {
    prefix: "fal",
    iconName: "piano-keyboard",
    icon: [576, 512, [], "f8d5", "M544 64H32A32 32 0 0 0 0 96v320a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32V96a32 32 0 0 0-32-32zM128 416H32V224h64v96a16 16 0 0 0 16 16h16zm144 0H160v-80h16a16 16 0 0 0 16-16v-96h48v96a16 16 0 0 0 16 16h16zM128 304v-80h32v80zm288 112H304v-80h16a16 16 0 0 0 16-16v-96h48v96a16 16 0 0 0 16 16h16zM272 304v-80h32v80zm272 112h-96v-80h16a16 16 0 0 0 16-16v-96h64zM416 304v-80h32v80zm128-112H32V96h512z"]
  },
      hA = {
    prefix: "fal",
    iconName: "pie",
    icon: [576, 512, [], "f705", "M528.49 228.23C490.58 129.67 394.93 64 288 64S85.41 129.67 47.53 228.23C5 229.87 0 265.64 0 274.14A46.09 46.09 0 0 0 46.22 320c2.72 0 4.77-.6 7.32-.76L86 416.56A46 46 0 0 0 129.63 448h316.74A46 46 0 0 0 490 416.55l32.43-97.31c2.54.17 4.6.76 7.32.76A46.09 46.09 0 0 0 576 274.14c0-8.77-5.15-44.14-47.51-45.91zm-68.84 178.18a14 14 0 0 1-13.28 9.59H129.62a14 14 0 0 1-13.28-9.58l-31.26-93.79a127.07 127.07 0 0 0 29.2-16.69c9.09-6.74 12.6-9.43 25.41.06 12.12 9 32.47 24 67.94 24s55.84-15.06 68-24.08c9.07-6.71 12.51-9.4 25.21.05 12.15 9 32.46 24 67.93 24s55.81-15.06 67.94-24.06c10.88-8.07 14.12-8.2 25.12 0a126.91 126.91 0 0 0 29.08 16.69l-31.26 93.8zM529.77 288c-24.94 0-38.19-9.84-48.91-17.81-29.71-22-50.06-9.69-63.22.06C407 278.16 393.74 288 368.77 288s-38.22-9.84-48.94-17.77c-31.82-23.68-53.5-7.25-63.3 0-10.66 7.93-23.91 17.77-48.91 17.77s-38.25-9.84-49-17.77c-6.78-5-29.71-25-63.47 0-10.68 7.9-24 17.74-49 17.74a13.87 13.87 0 1 1 0-27.74c5.39 0 11.08.48 26.75-8.17C126.23 98.14 271.72 96 288 96c16 0 161.72 2 215 156 15.75 8.91 20.57 8.31 26.78 8.31a13.87 13.87 0 1 1 0 27.74zM199.16 145.69a16.07 16.07 0 0 0-21.47 7.16l-16 32a16 16 0 0 0 7.16 21.47c9.54 4.7 18.36-1 21.47-7.16l16-32a16 16 0 0 0-7.16-21.47zm199.14 7.15a16 16 0 1 0-28.63 14.31l16 32c3.1 6.17 11.93 11.86 21.47 7.16a16 16 0 0 0 7.16-21.47zM288 144a16 16 0 0 0-16 16v32a16 16 0 1 0 32 0v-32a16 16 0 0 0-16-16z"]
  },
      mA = {
    prefix: "fal",
    iconName: "pig",
    icon: [576, 512, [], "f706", "M560 192h-29.5c-11.1-25.3-28.7-46.9-50.5-63.4V64h-16c-46.68 0-83.15 27.22-89.39 32H223.99c-41.32 0-82.57 17.33-111.74 45.92-22.43 21.87-38.56 50.15-45.07 82.08h-11.2c-14.8 0-26.5-13.5-23.5-28.8 2.2-11.4 12.9-19.2 24.5-19.2h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6-4.4 34.2 22.2 63.4 55.5 63.4h8c0 52.2 25.4 98.1 64 127.3V464c0 8.8 7.2 16 16 16h112c8.8 0 16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16h112c8.8 0 16-7.2 16-16v-80.9c11.7-9 22.4-19.3 31.3-31.1H560c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16zm-16 128h-48.7c-17 22.4-17 24.1-47.3 47.3V448h-80v-64H239.99v64h-80v-80.7c-64.9-49-64-93.5-64-111.3 0-70.6 57.4-128 128.01-128h161.71c16.9-13.5 33.2-26.5 62.3-30.8v47.3c39.7 30.1 44 39.3 61.6 79.5H544v96zm-112.01-96c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.19-16-16-16z"]
  },
      vA = {
    prefix: "fal",
    iconName: "piggy-bank",
    icon: [576, 512, [], "f4d3", "M432 256c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm128-32h-29.5c-11.1-25.3-28.7-46.9-50.5-63.4V96h-16c-30.3 0-57.8 10.1-80.9 26.2.4-3.4.9-6.7.9-10.2C384 50.1 333.9 0 272 0S160 50.1 160 112c0 9.7 1.6 18.9 4 27.9C115 159.7 78 203 67.2 256H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h8c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h112c8.8 0 16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16h112c8.8 0 16-7.2 16-16v-80.9c11.7-9 22.4-19.3 31.3-31.1H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zM272 32c44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16H224c-10.1 0-19.9 1.2-29.5 3-1.6-6.1-2.5-12.4-2.5-19 0-44.2 35.8-80 80-80zm272 320h-48.7c-17 22.4-17 24.1-47.3 47.3V480h-80v-64H240v64h-80v-80.7c-64.9-49-64-93.5-64-111.3 0-70.6 57.4-128 128-128h161.7c16.9-13.5 33.2-26.5 62.3-30.8v47.3c39.7 30.1 44 39.3 61.6 79.5H544v96z"]
  },
      dA = {
    prefix: "fal",
    iconName: "pills",
    icon: [576, 512, [], "f484", "M112 32C50.2 32 0 82.2 0 144v224c0 61.8 50.2 112 112 112s112-50.2 112-112V144c0-61.8-50.2-112-112-112zm80 336c0 44.1-35.9 80-80 80s-80-35.9-80-80v-80h160v80zm0-112H32V144c0-44.1 35.9-80 80-80s80 35.9 80 80v112zm224-96c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 288c-70.7 0-128-57.3-128-128 0-29.6 10.4-56.4 27.3-78.1l178.9 178.9C472.4 437.6 445.6 448 416 448zm100.7-49.9L337.9 219.3c21.7-16.8 48.5-27.3 78.1-27.3 70.7 0 128 57.3 128 128 0 29.6-10.4 56.4-27.3 78.1z"]
  },
      MA = {
    prefix: "fal",
    iconName: "pizza",
    icon: [576, 512, [], "f817", "M523.2 100.13a15.43 15.43 0 0 0-12.36-6 16.42 16.42 0 0 0-11.61 4.78L342.17 256l157.06 157.06a16.42 16.42 0 0 0 11.61 4.78 15.4 15.4 0 0 0 12.36-6 256.47 256.47 0 0 0 0-311.71zm-62 229.69L387.42 256l73.87-73.87A157.51 157.51 0 0 1 480 256a155.93 155.93 0 0 1-18.76 73.82zm47.31 47.3l-23.61-23.6A190.2 190.2 0 0 0 512 256c0-35.68-10.2-68.79-27.17-97.41l23.72-23.71a224.58 224.58 0 0 1 0 242.24zM256.45 256L425.6 86.85c6.46-6.46 6.45-17.36-.42-23.39A255.13 255.13 0 0 0 256.46 0C175.37 0 94.29 38.28 42.65 114.84c-56.87 84.3-56.87 198 0 282.34C94.3 473.72 175.38 512 256.45 512a255.14 255.14 0 0 0 168.73-63.46c6.87-6 6.88-16.93.42-23.39zm7.55-64a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm44.61-33.41a47.93 47.93 0 1 0-62 62L211.2 256l132.42 132.42c-25.23 17-55 27.58-87.62 27.58-18.23 0-35.46-3.71-51.8-9.35a47.87 47.87 0 1 0-73.84-52.77C109.16 326.73 96 293 96 256c0-88.22 71.78-160 160-160 32.64 0 62.5 10.49 87.73 27.47zM192 368a16 16 0 1 1-16-16 16 16 0 0 1 16 16zm64.45 112c-75.82 0-144.08-36.71-187.27-100.72-49.74-73.73-49.75-172.8 0-246.54C112.36 68.72 180.62 32 256.46 32a223.62 223.62 0 0 1 134.15 44.59l-23.74 23.74C335.48 77.87 297.55 64 256 64 150 64 64 150 64 256s86 192 192 192c41.55 0 79.58-13.77 111-36.21l23.62 23.62A223.65 223.65 0 0 1 256.45 480z"]
  },
      pA = {
    prefix: "fal",
    iconName: "pizza-slice",
    icon: [512, 512, [], "f818", "M158.87.15c-1.09-.1-2.18-.15-3.26-.15a32.85 32.85 0 0 0-32.07 24.27L.55 491.63A16.24 16.24 0 0 0 16.15 512a16.54 16.54 0 0 0 4.4-.61l467.6-129.66c15.72-4.35 25.49-19.67 23.62-35.89C490.89 165.08 340.78 17.32 158.87.15zM38.49 473.21L133 113.91c148.3 14 248.38 112.63 264.45 259.75zM428.65 365C409.38 206.37 301.13 99.81 141.26 82.67l13.24-50.31a1.54 1.54 0 0 1 1.11-.36h.25c165.67 15.63 305 152.13 323.74 318.89zM192 176a48 48 0 1 0 48 48 48.05 48.05 0 0 0-48-48zm0 64a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm-48 80a48 48 0 1 0 48 48 48.05 48.05 0 0 0-48-48zm0 64a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm96-64a48 48 0 1 0 48-48 48.05 48.05 0 0 0-48 48zm64 0a16 16 0 1 1-16-16 16 16 0 0 1 16 16z"]
  },
      zA = {
    prefix: "fal",
    iconName: "place-of-worship",
    icon: [576, 512, [], "f67f", "M558.57 355.99L448 303.26v-29.14c0-11.24-5.9-21.65-15.53-27.44L384 217.6V102.63c0-8.49-3.37-16.63-9.38-22.63L299.31 4.69C296.19 1.56 292.09 0 288 0s-8.19 1.56-11.31 4.69L201.37 80c-6 6-9.37 14.14-9.37 22.62V217.6l-48.47 29.08A31.988 31.988 0 0 0 128 274.12v29.15L17.43 355.99C6.96 360.99 0 373.89 0 388.32V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8 0 0-.35-119.22 0-120l96-45.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V274.12l64-38.4V102.63l64-64 64 64v133.09l64 38.4V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V338.71L544 384c.35.78 0 120 0 120 0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V388.32c0-14.43-6.96-27.33-17.43-32.33zM281.71 320.3c-33.28 3.17-57.71 33.02-57.71 66.45V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V385.8c0-15.95 10.86-30.76 26.59-33.36C302.61 349.15 320 364.58 320 384v120c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V384c0-37.42-32.12-67.34-70.29-63.7z"]
  },
      CA = {
    prefix: "fal",
    iconName: "plane",
    icon: [576, 512, [], "f072", "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-88.36c-10.63 0-18.3 10.17-15.38 20.39L192 192h-64l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H72c5.04 0 9.78-2.37 12.8-6.4L128 320h64l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h88.36c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64zm0 96H347.14L237.43 480h-57.86l54.86-192H112l-48 64H37.35l27.98-96-28-96H64l48 64h122.42L179.57 32h57.87l109.71 192H480c26.24 0 62.61 21.75 64 31.91-1.39 10.34-37.76 32.09-64 32.09z"]
  },
      LA = {
    prefix: "fal",
    iconName: "plane-alt",
    icon: [576, 512, [], "f3de", "M462.5 192.319H353.904l-33.695-64.33c6.53-.113 11.79-5.433 11.79-11.99V76c0-6.627-5.373-12-12-12h-33.307l-26.298-50.208C255.257 4.858 245.982 0 236.714 0h-54.175c-17.549 0-30.473 16.313-26.563 33.331l27.989 160.119c-20.696 1.057-40.83 2.827-58.722 5.169l-31.987-57.441-.259-.447c-4.896-8.161-13.85-13.23-23.366-13.23H29.723c-17.213 0-30.09 15.749-26.721 32.594l13.41 67.052C5.51 235.553 0 245.225 0 256.001c0 10.775 5.51 20.447 16.412 28.854l-13.41 67.049c-3.375 16.877 9.542 32.597 26.722 32.595l39.911-.001c9.516-.002 18.467-5.072 23.362-13.23l32.245-57.887c17.892 2.342 38.025 4.112 58.723 5.169l-27.989 160.119C152.064 495.694 164.999 512 182.539 512h54.175c9.003 0 18.012-4.512 23.456-13.372L286.689 448H320c6.627 0 12-5.373 12-12v-40c0-6.558-5.262-11.878-11.793-11.99l33.697-64.332 108.596.002c48.364 0 113.5-16.362 113.5-63.68 0-47.602-65.772-63.681-113.5-63.681zm0 95.361l-128.441-.001L233.849 480h-45.621l33.588-192.14c-45.335-1.352-67.17-2.232-113.778-9.356l-41.205 73.994-31.315.001L55 256.001 35.517 159.5h31.315l41.206 73.996c46.89-7.168 68.859-8.017 113.777-9.356L188.228 32h45.621l100.21 192.319H462.5c32.513 0 81.5 10.7 81.5 31.681 0 23.203-56.152 31.68-81.5 31.68z"]
  },
      AA = {
    prefix: "fal",
    iconName: "plane-arrival",
    icon: [640, 512, [], "f5af", "M632 480H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h624c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-51.56-177.46c-19.46-20.21-45.93-35.35-76.55-43.77l-96.94-26.68L310.5 46.83c-2.19-4.23-4.15-8.58-6.18-12.89-3.14-6.64-8.97-11.67-16.05-13.62C269.1 15.05 216.78 0 216.78 0c-.28 0-10.77-.48-18.69 8.65-5.41 6.25-7.37 16.41-5.09 24.35l42.32 151.85-87.29-24.02-26.88-67.79c-2.92-7.47-9.18-13.18-16.75-15.26C59.87 65.53 61.43 65.64 57 65.64c-13.55 0-24.77 11.34-25 25.29l.29 107.22c.25 11.54 5.21 22.55 13.62 30.21l93.32 83.17c8.42 7.67 18.62 13.31 29.49 16.3l295.95 81.45c16.21 4.46 32.32 6.73 47.88 6.73 13.79 0 27.15-1.79 39.71-5.33 30.87-8.69 49.14-23.15 54.31-43 5.17-19.85-3.61-41.76-26.13-65.14zm-4.86 57.07c-2.01 7.72-13.67 15.1-32.01 20.26-30.85 8.68-60.03 1.41-70.42-1.45L177.2 296.97c-6.03-1.66-11.72-4.81-16.43-9.1L67.45 204.7c-1.93-1.76-3.11-4.46-3.17-7.23l-.1-97.57 28.35 7.8 31.54 79.72 157.85 43.44-54.51-194.65 48.8 13.98 108.76 209.03 110.44 30.4c25.08 6.9 46.51 19.04 61.99 35.11 13.64 14.18 20.28 26.88 18.18 34.88z"]
  },
      NA = {
    prefix: "fal",
    iconName: "plane-departure",
    icon: [640, 512, [], "f5b0", "M80.52 339.28A40.69 40.69 0 0 0 110.06 352l127.06-.17a73.86 73.86 0 0 0 32.45-7.61l283.1-140.31c29.18-14.46 52.82-34.58 68.36-58.18 18-27.27 22.38-50.28 13.16-68.4-11.59-22.86-42-30.76-72.7-30.76-26 0-52.45 6.61-78.76 19.64l-92.71 46-208.71-76.54A25.67 25.67 0 0 0 168 32a26 26 0 0 0-11.45 2.68l-64 31.7a25.07 25.07 0 0 0-13.8 19.32A24 24 0 0 0 90.2 109l136.53 84.1-83.95 41.61L76 201.83a25.86 25.86 0 0 0-22.84 0l-39.07 19.38A25.11 25.11 0 0 0 .51 238.8a24.87 24.87 0 0 0 5.67 21.41zM64.6 231.87l78.22 38.51 149.94-74.31L118.54 89.23l49.28-24.42 224.09 82.12 105-52c21.85-10.83 43.58-16.32 64.59-16.32 16.3 0 39.32 3.6 44.23 13.28 3.41 6.71-.84 20.26-11.36 36.26-12.43 18.87-31.74 35.17-55.85 47.12L255.41 315.54a41.63 41.63 0 0 1-18.32 4.29l-127 .17a8.77 8.77 0 0 1-6.29-2.66l-67.3-71.53 28.1-13.94zM632 448H9.1a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8H632a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      gA = {
    prefix: "fal",
    iconName: "plane-slash",
    icon: [640, 512, [], "e069", "M269.44,480H211.56l53.18-186.06L257.2,288H144L96,352H69.34l28-96-28-96H94.66L54,128H48a16,16,0,0,0-15.54,19.88L64,256,32.48,364.13A16,16,0,0,0,48,384h56a16,16,0,0,0,12.8-6.41L160,320h64L175,491.59A16,16,0,0,0,190.34,512H278.7a16,16,0,0,0,13.89-8.06l74.12-129.71-25.41-20ZM189.72,72l42.94,33.81L211.56,32h57.88L376.23,218.89l6.5,5.11H512c26.23,0,62.61,21.75,64,31.91C574.61,266.25,538.23,288,512,288H464l40.64,32H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.72,0H190.34A16,16,0,0,0,175,20.39ZM637,485.32,23,1.8A7.88,7.88,0,0,0,11.77,3l-10,12.5A7.94,7.94,0,0,0,3,26.71L617,510.23A8,8,0,0,0,628.2,509l10-12.5A7.86,7.86,0,0,0,637,485.32Z"]
  },
      HA = {
    prefix: "fal",
    iconName: "planet-moon",
    icon: [576, 512, [], "e01f", "M224,64C100.28711,64,0,164.28516,0,288,0,411.71289,100.28711,512,224,512S448,411.71289,448,288C448,164.28516,347.71289,64,224,64ZM55.03906,202.86133A168.37236,168.37236,0,0,1,208,104c16.42969.23242,24,9.5918,24,20.62109a55.68,55.68,0,0,1-8.79492,30.26368l-47.916,55.26562c-14.0332,16.18555-14.373,43.09961,1.29492,57.707A44.99741,44.99741,0,0,0,207.45312,280H272a24.02624,24.02624,0,0,1,24,24v16.89062a56.29763,56.29763,0,0,1-5.91406,25.04883l-40.32227,64.64844a20.736,20.736,0,0,1-15.0625,11.14063c-3.28515.55273-6.60156,1.01171-10.7832,1.41406a8.10651,8.10651,0,0,1-7.91992-8.07422c-.00586-70.99024-.01172-44.60742.04492-55.06836H208a24.0275,24.0275,0,0,1-24-24V300.68555L127.0332,243.7168A40.0085,40.0085,0,0,0,98.74609,232l-25.02539-.00195C58.207,231.99805,49.11133,215.93945,55.03906,202.86133ZM224,480C118.13086,480,32,393.86914,32,288a191.85276,191.85276,0,0,1,4.28516-40.10742A51.99721,51.99721,0,0,0,73.7207,263.99805L98.74609,264a7.94986,7.94986,0,0,1,5.65821,2.34375L152,313.94141V336a56.07819,56.07819,0,0,0,31.99805,50.5918c-.002,1.70312-.002.41992,0,28.47851A40.04816,40.04816,0,0,0,223.918,455.14258c4.89062,0,14.47656-1.58594,16.082-1.85547a52.83521,52.83521,0,0,0,38.38281-28.38672L318.709,360.252A88.49462,88.49462,0,0,0,328,320.89062V304a56.0629,56.0629,0,0,0-56-56H207.45312a13.22277,13.22277,0,0,1-9.4121-3.90039,8.02588,8.02588,0,0,1-.38477-10.89649l49.72656-57.35546.99414-1.14649.8418-1.26172A87.73535,87.73535,0,0,0,264,124.62109,52.59039,52.59039,0,0,0,257.25781,99.082C347.30273,114.90039,416,193.49219,416,288,416,393.86914,329.86914,480,224,480ZM512,0a64,64,0,1,0,64,64A64.00067,64.00067,0,0,0,512,0Zm0,96a32,32,0,1,1,32-32A32.03667,32.03667,0,0,1,512,96Z"]
  },
      VA = {
    prefix: "fal",
    iconName: "planet-ringed",
    icon: [512, 512, [], "e020", "M500.46078,11.36064c-28.37693-28.41319-93.93158-.6778-167.29286,51.54847A207.12926,207.12926,0,0,0,256,47.95048c-114.87493,0-207.99987,93.13494-207.99987,208.0222a207.22913,207.22913,0,0,0,15.09765,77.563c-9.41992,13.29049-18.27733,26.34657-25.84373,38.79711C-1.36507,435.89032-9.99788,479.04336,11.53922,500.59449,19.35757,508.41759,29.97085,512,42.81264,512c33.78513,0,82.90424-25.01634,136.12882-62.92273A207.12538,207.12538,0,0,0,256,463.99488c114.87493,0,207.99987-93.13494,207.99987-208.0222a207.20185,207.20185,0,0,0-15.043-77.41256c9.459-13.35689,18.18163-26.41883,25.789-38.93579C513.36507,76.06676,521.99788,32.91372,500.46078,11.36064ZM256,79.9539c67.666,0,126.43937,38.43965,155.88271,94.58431-30.19529,40.71528-67.73042,84.216-110.41985,126.93347-46.56442,46.60458-89.31635,83.001-126.4921,110.59188-56.34958-29.37814-94.97065-88.26138-94.97065-156.09088C80.00011,158.91545,158.95319,79.9539,256,79.9539ZM34.27163,477.84792c-4.082-4.06684-6.53125-27.94439,30.45506-88.80049,4.57031-7.51838,9.60546-15.2653,14.92577-23.14114a208.7054,208.7054,0,0,0,66.53706,66.50123C84.69347,473.74006,43.38686,486.888,34.27163,477.84792ZM431.99989,255.97268c0,97.05723-78.95308,176.01878-175.99989,176.01878a175.07568,175.07568,0,0,1-45.74606-6.24285c38.29294-29.91921,77.56635-65.12218,113.94133-101.53232,38.1074-38.131,72.5898-77.1,101.48235-114.30712A175.20682,175.20682,0,0,1,431.99989,255.97268ZM366.01165,79.6609c49-32.92734,85.38276-48.302,102.48626-48.302,4.30078,0,7.41015.94151,9.23046,2.74834,4.082,4.06879,6.53125,27.94634-30.45506,88.80244-4.42968,7.28789-10.04491,15.13638-15.15428,22.75243A208.73991,208.73991,0,0,0,366.01165,79.6609Z"]
  },
      xA = {
    prefix: "fal",
    iconName: "play",
    icon: [448, 512, [], "f04b", "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6zm-16.2 55.1l-352 208C45.6 483.9 32 476.6 32 464V47.9c0-16.3 16.4-18.4 24.1-13.8l352 208.1c10.5 6.2 10.5 21.4.1 27.6z"]
  },
      wA = {
    prefix: "fal",
    iconName: "play-circle",
    icon: [512, 512, [], "f144", "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zM40 256c0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216zm331.7-18l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM192 335.8V176.9c0-4.7 5.1-7.6 9.1-5.1l134.5 81.7c3.9 2.4 3.8 8.1-.1 10.3L201 341c-4 2.3-9-.6-9-5.2z"]
  },
      yA = {
    prefix: "fal",
    iconName: "plug",
    icon: [384, 512, [], "f1e6", "M352,128H304V16a16,16,0,0,0-32,0V128H112V16a16,16,0,0,0-32,0V128H32A32,32,0,0,0,0,160v32a32,32,0,0,0,32,32v32c0,82.75,63.37,150.22,144,158.38V512h32V414.38c80.63-8.16,144-75.63,144-158.38V224a32,32,0,0,0,32-32V160A32,32,0,0,0,352,128ZM320,256a128,128,0,0,1-256,0V224H320Zm32-64H32V160H352Z"]
  },
      bA = {
    prefix: "fal",
    iconName: "plus",
    icon: [384, 512, [], "f067", "M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"]
  },
      SA = {
    prefix: "fal",
    iconName: "plus-circle",
    icon: [512, 512, [], "f055", "M384 250v12c0 6.6-5.4 12-12 12h-98v98c0 6.6-5.4 12-12 12h-12c-6.6 0-12-5.4-12-12v-98h-98c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h98v-98c0-6.6 5.4-12 12-12h12c6.6 0 12 5.4 12 12v98h98c6.6 0 12 5.4 12 12zm120 6c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z"]
  },
      TA = {
    prefix: "fal",
    iconName: "plus-hexagon",
    icon: [576, 512, [], "f300", "M441.5 39.8C432.9 25.1 417.1 16 400 16H176c-17.1 0-32.9 9.1-41.5 23.8l-112 192c-8.7 14.9-8.7 33.4 0 48.4l112 192c8.6 14.7 24.4 23.8 41.5 23.8h224c17.1 0 32.9-9.1 41.5-23.8l112-192c8.7-14.9 8.7-33.4 0-48.4l-112-192zm84.3 224.3l-112 192c-2.9 4.9-8.2 7.9-13.8 7.9H176c-5.7 0-11-3-13.8-7.9l-112-192c-2.9-5-2.9-11.2 0-16.1l112-192c2.8-5 8.1-8 13.8-8h224c5.7 0 11 3 13.8 7.9l112 192c2.9 5 2.9 11.2 0 16.2zM416 250v12c0 6.6-5.4 12-12 12h-98v98c0 6.6-5.4 12-12 12h-12c-6.6 0-12-5.4-12-12v-98h-98c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h98v-98c0-6.6 5.4-12 12-12h12c6.6 0 12 5.4 12 12v98h98c6.6 0 12 5.4 12 12z"]
  },
      DA = {
    prefix: "fal",
    iconName: "plus-octagon",
    icon: [512, 512, [], "f301", "M361.5 14.1c-9-9-21.2-14.1-33.9-14.1H184.5c-12.7 0-24.9 5.1-33.9 14.1L14.1 150.5c-9 9-14.1 21.2-14.1 33.9v143.1c0 12.7 5.1 24.9 14.1 33.9l136.5 136.5c9 9 21.2 14.1 33.9 14.1h143.1c12.7 0 24.9-5.1 33.9-14.1L498 361.4c9-9 14.1-21.2 14.1-33.9v-143c0-12.7-5.1-24.9-14.1-33.9L361.5 14.1zM480 327.5c0 4.3-1.7 8.3-4.7 11.3L338.9 475.3c-3 3-7 4.7-11.3 4.7H184.5c-4.3 0-8.3-1.7-11.3-4.7L36.7 338.9c-3-3-4.7-7-4.7-11.3V184.5c0-4.3 1.7-8.3 4.7-11.3L173.1 36.7c3-3 7-4.7 11.3-4.7h143.1c4.3 0 8.3 1.7 11.3 4.7l136.5 136.5c3 3 4.7 7 4.7 11.3v143zM384 250v12c0 6.6-5.4 12-12 12h-98v98c0 6.6-5.4 12-12 12h-12c-6.6 0-12-5.4-12-12v-98h-98c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h98v-98c0-6.6 5.4-12 12-12h12c6.6 0 12 5.4 12 12v98h98c6.6 0 12 5.4 12 12z"]
  },
      jA = {
    prefix: "fal",
    iconName: "plus-square",
    icon: [448, 512, [], "f0fe", "M400 64c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352m0-32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-60 206h-98v-98c0-6.6-5.4-12-12-12h-12c-6.6 0-12 5.4-12 12v98h-98c-6.6 0-12 5.4-12 12v12c0 6.6 5.4 12 12 12h98v98c0 6.6 5.4 12 12 12h12c6.6 0 12-5.4 12-12v-98h98c6.6 0 12-5.4 12-12v-12c0-6.6-5.4-12-12-12z"]
  },
      EA = {
    prefix: "fal",
    iconName: "podcast",
    icon: [448, 512, [], "f2ce", "M326.011 313.366a81.658 81.658 0 0 0-11.127-16.147c-1.855-2.1-1.913-5.215-.264-7.481C328.06 271.264 336 248.543 336 224c0-63.221-52.653-114.375-116.41-111.915-57.732 2.228-104.69 48.724-107.458 106.433-1.278 26.636 6.812 51.377 21.248 71.22 1.648 2.266 1.592 5.381-.263 7.481a81.609 81.609 0 0 0-11.126 16.145c-2.003 3.816-7.25 4.422-9.961 1.072C92.009 289.7 80 258.228 80 224c0-79.795 65.238-144.638 145.178-143.995 77.583.624 141.19 63.4 142.79 140.969.73 35.358-11.362 67.926-31.928 93.377-2.738 3.388-8.004 2.873-10.029-.985zM224 0C100.206 0 0 100.185 0 224c0 82.003 43.765 152.553 107.599 191.485 4.324 2.637 9.775-.93 9.078-5.945-1.244-8.944-2.312-17.741-3.111-26.038a6.025 6.025 0 0 0-2.461-4.291c-48.212-35.164-79.495-92.212-79.101-156.409.636-103.637 84.348-188.625 187.964-190.76C327.674 29.822 416 116.79 416 224c0 63.708-31.192 120.265-79.104 155.21a6.027 6.027 0 0 0-2.462 4.292c-.799 8.297-1.866 17.092-3.11 26.035-.698 5.015 4.753 8.584 9.075 5.947C403.607 376.922 448 306.75 448 224 448 100.204 347.814 0 224 0zm64 355.75c0 32.949-12.871 104.179-20.571 132.813C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.438C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75 32.858 0 64 8.594 64 43.75zm-32 0c0-16.317-64-16.3-64 0 0 27.677 11.48 93.805 19.01 122.747 6.038 2.017 19.948 2.016 25.981 0C244.513 449.601 256 383.437 256 355.75zM288 224c0 35.346-28.654 64-64 64s-64-28.654-64-64 28.654-64 64-64 64 28.654 64 64zm-32 0c0-17.645-14.355-32-32-32s-32 14.355-32 32 14.355 32 32 32 32-14.355 32-32z"]
  },
      kA = {
    prefix: "fal",
    iconName: "podium",
    icon: [448, 512, [], "f680", "M440 160H96v-16c0-39.77 29.25-72.6 67.34-78.72C170.29 83.22 187.6 96 208 96h64c26.51 0 48-21.49 48-48S298.51 0 272 0h-64c-21.37 0-39.27 14.06-45.48 33.36C107.17 40.12 64 86.87 64 144v16H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56.09l.01 1.77L96 480H40c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-55.9L384 192h56c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM208 32h64c8.82 0 16 7.18 16 16s-7.18 16-16 16h-64c-8.82 0-16-7.18-16-16s7.18-16 16-16zm112 448H127.91l-.01-1.77L96 192h255.9L320 480z"]
  },
      IA = {
    prefix: "fal",
    iconName: "podium-star",
    icon: [448, 512, [], "f758", "M440 160H96v-16c0-39.8 29.2-72.6 67.3-78.7 7 17.9 24.3 30.7 44.7 30.7h64c26.5 0 48-21.5 48-48S298.5 0 272 0h-64c-21.4 0-39.3 14.1-45.5 33.4C107.2 40.1 64 86.9 64 144v16H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56.1v1.8L96 480H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-55.9L384 192h56c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM208 32h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 448H127.9v-1.8L96 192h255.9L320 480zM164.1 346.1l-5.6 32.7c-1.6 9.5 2.2 18.9 10.1 24.5 4.4 3.2 9.5 4.8 14.6 4.8 4 0 7.9-1 11.6-2.9l29.3-15.4 29.2 15.4c8.4 4.4 18.5 3.8 26.3-1.9 7.8-5.6 11.6-15 10-24.5l-5.6-32.6 23.7-23.1c6.9-6.7 9.3-16.5 6.3-25.7-3-9.1-10.7-15.6-20.2-17l-32.7-4.8-14.6-29.7c-4.2-8.6-12.8-13.9-22.4-13.9-9.6 0-18.2 5.3-22.4 13.9L187 275.6l-32.7 4.8c-9.5 1.4-17.2 7.9-20.2 17s-.5 19 6.3 25.6l23.7 23.1zm44.1-41.3l15.8-32 15.8 32 35.3 5.2-25.6 25 6 35.2-31.5-16.7-31.6 16.6 6-35.2-25.6-25 35.4-5.1z"]
  },
      OA = {
    prefix: "fal",
    iconName: "police-box",
    icon: [384, 512, [], "e021", "M97.59961,336h76.80078A9.60081,9.60081,0,0,0,184,326.40039V249.59961A9.60081,9.60081,0,0,0,174.40039,240H97.59961A9.60081,9.60081,0,0,0,88,249.59961v76.80078A9.60081,9.60081,0,0,0,97.59961,336ZM112,264h48v48H112ZM97.59961,448h76.80078A9.60081,9.60081,0,0,0,184,438.40039V361.59961A9.60081,9.60081,0,0,0,174.40039,352H97.59961A9.60081,9.60081,0,0,0,88,361.59961v76.80078A9.60081,9.60081,0,0,0,97.59961,448ZM112,376h48v48H112Zm97.59961,72h76.80078A9.60081,9.60081,0,0,0,296,438.40039V361.59961A9.60081,9.60081,0,0,0,286.40039,352H209.59961A9.60081,9.60081,0,0,0,200,361.59961v76.80078A9.60081,9.60081,0,0,0,209.59961,448ZM224,376h48v48H224ZM97.59961,224h76.80078A9.60081,9.60081,0,0,0,184,214.40039V137.59961A9.60081,9.60081,0,0,0,174.40039,128H97.59961A9.60081,9.60081,0,0,0,88,137.59961v76.80078A9.60081,9.60081,0,0,0,97.59961,224ZM140,152h20v20H140Zm0,28h20v20H140Zm-28-28h20v20H112Zm0,28h20v20H112Zm97.59961,44h76.80078A9.60081,9.60081,0,0,0,296,214.40039V137.59961A9.60081,9.60081,0,0,0,286.40039,128H209.59961A9.60081,9.60081,0,0,0,200,137.59961v76.80078A9.60081,9.60081,0,0,0,209.59961,224ZM252,152h20v20H252Zm0,28h20v20H252Zm-28-28h20v20H224Zm0,28h20v20H224ZM209.59961,336h76.80078A9.60081,9.60081,0,0,0,296,326.40039V249.59961A9.60081,9.60081,0,0,0,286.40039,240H209.59961A9.60081,9.60081,0,0,0,200,249.59961v76.80078A9.60081,9.60081,0,0,0,209.59961,336ZM224,264h48v48H224ZM376,480H352V88a23.99993,23.99993,0,0,0-24-24h-8.02148V48a15.99829,15.99829,0,0,0-16-16H208V16a16,16,0,0,0-32,0V32H80A15.99954,15.99954,0,0,0,64,48V64H56A23.99993,23.99993,0,0,0,32,88V480H8a8.00039,8.00039,0,0,0-8,8v16a8.00039,8.00039,0,0,0,8,8H376a8.00039,8.00039,0,0,0,8-8V488A8.00039,8.00039,0,0,0,376,480Zm-56,0H64V96H320Z"]
  },
      QA = {
    prefix: "fal",
    iconName: "poll",
    icon: [448, 512, [], "f681", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16V80c0-8.82 7.18-16 16-16h352c8.82 0 16 7.18 16 16v352zM136 224h-16c-4.42 0-8 3.58-8 8v144c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V232c0-4.42-3.58-8-8-8zm96-96h-16c-4.42 0-8 3.58-8 8v240c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V136c0-4.42-3.58-8-8-8zm96 160h-16c-4.42 0-8 3.58-8 8v80c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-80c0-4.42-3.58-8-8-8z"]
  },
      ZA = {
    prefix: "fal",
    iconName: "poll-h",
    icon: [448, 512, [], "f682", "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM48 448c-8.82 0-16-7.18-16-16V80c0-8.82 7.18-16 16-16h352c8.82 0 16 7.18 16 16v352c0 8.82-7.18 16-16 16H48zm208-280v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h144c4.42 0 8-3.58 8-8zm96 96v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8zm-160 96v-16c0-4.42-3.58-8-8-8h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8z"]
  },
      UA = {
    prefix: "fal",
    iconName: "poll-people",
    icon: [640, 512, [], "f759", "M145.8 391.7c8.8-11 14.2-24.7 14.2-39.7 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 15.1 5.5 28.8 14.2 39.7C19 404.5 0 432 0 464v17.6C0 498.4 13.6 512 30.4 512h131.2c16.8 0 30.4-13.6 30.4-30.4V464c0-32-19-59.5-46.2-72.3zM96 320c17.7 0 32 14.4 32 32s-14.3 32-32 32-32-14.4-32-32 14.3-32 32-32zM32 481.6V464c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48l1.6 16L32 481.6zm113.8-377.9C154.6 92.7 160 79 160 64c0-35.3-28.7-64-64-64S32 28.7 32 64c0 15.1 5.5 28.8 14.2 39.7C19 116.5 0 144 0 176v17.6C0 210.4 13.6 224 30.4 224h131.2c16.8 0 30.4-13.6 30.4-30.4V176c0-32-19-59.5-46.2-72.3zM96 32c17.7 0 32 14.4 32 32s-14.3 32-32 32-32-14.4-32-32 14.3-32 32-32zM32 193.6V176c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48l1.6 16L32 193.6zM616 32H248c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24h368c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24zM480 160H256V64h224v96zm128 0h-96V64h96v96zm8 160H248c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24h368c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24zM320 448h-64v-96h64v96zm288 0H352v-96h256v96z"]
  },
      BA = {
    prefix: "fal",
    iconName: "poo",
    icon: [512, 512, [], "f2fe", "M343.7 368H168.3c-5.8 0-9.8 5.7-7.8 11 10.5 27.9 58.4 53 95.5 53s85-25.1 95.5-53c2-5.3-2-11-7.8-11zM192 320c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm128-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm156.2 86.7c5.1-11.7 7.8-24.5 7.8-37.7 0-39.2-23.9-72.9-57.8-87.4 1.2-5.7 1.8-11.6 1.8-17.6 0-37.2-23.3-69.2-56-82v-2C372 52 320 0 256 0c-6.8 0-12.7.9-18.2 1.7-11 1.7-20.2 9-24.5 19.3-4.3 10.2-2.9 22 3.5 31 3.3 4.6 7.2 12.1 7.2 22 0 21-17 38-38 38h-14c-48.5 0-88 39.5-88 88 0 5.9.6 11.8 1.8 17.6C51.9 232.1 28 265.8 28 305c0 13.2 2.7 26 7.8 37.7C13.8 360.1 0 387 0 417c0 52.4 42.6 95 95 95h322c52.4 0 95-42.6 95-95 0-30-13.8-56.9-35.8-74.3zM417 480H95c-34.8 0-63-28.2-63-63 0-31.4 23-57.2 53.1-62C69.9 343.5 60 325.5 60 305c0-34.8 28.2-63 63-63h12.3c-11.7-10.3-19.3-25.2-19.3-42 0-30.9 25.1-56 56-56h14c38.7 0 70-31.3 70-70 0-15.2-5-29.2-13.2-40.7 4.3-.7 8.7-1.3 13.2-1.3 46.4 0 84 37.6 84 84 0 9.9-2 19.2-5.1 28h5.1c30.9 0 56 25.1 56 56 0 16.8-7.6 31.7-19.3 42H389c34.8 0 63 28.2 63 63 0 20.5-9.9 38.5-25.1 50 30 4.8 53.1 30.6 53.1 62 0 34.8-28.2 63-63 63z"]
  },
      RA = {
    prefix: "fal",
    iconName: "poo-storm",
    icon: [448, 512, [], "f75a", "M351.9 208.8zM320 304h-59.5l11-44.1c1.2-4.8.1-9.8-2.9-13.7s-7.7-6.2-12.6-6.2h-80c-7.3 0-13.8 5-15.5 12.1l-32 128C126 390.3 133.7 400 144 400h61.6l-13.4 93.7c-1.6 11.1 7.7 18.2 15.8 18.2 8.5 0 12.7-6.2 13.6-7.6 3.4-5.3 111.9-175.8 111.9-175.8 6.8-10.7-1-24.5-13.5-24.5zm-85.7 121.2l5.6-38.9c.7-4.6-.7-9.2-3.8-12.7-3-3.5-7.5-5.5-12.1-5.5h-59.5l24-96h47l-11 44.1c-2.5 10.2 5.2 19.9 15.5 19.9h50.8c-24.1 37.9-42.6 66.9-56.5 89.1zm158.6-227.4c.1-1.9.2-3.8.2-5.8 0-36-22.8-66.8-54.9-79.3v-.7C338.3 50.2 287 0 224 0c-6.5 0-12.4.8-17.8 1.6-11.1 1.7-20.5 9.1-24.7 19.4s-2.8 22.2 3.8 31.2c3.1 4.1 6.7 10.9 6.7 19.7 0 19.1-16.4 34.7-36.6 34.7h-13.7c-47.9 0-86.9 38.3-86.9 85.3 0 1.9.1 3.8.2 5.8-32.6 16.5-55 49.9-55 87.6 0 52.9 42.7 95.8 96 98.2 0-3.7.5-7.5 1.4-11.2l5.1-20.4h-1.9C62.9 352 32 322 32 285.3c0-34.8 27.9-63.3 63-66.1-5-8-8.2-17.2-8.2-27.2 0-29.5 24.6-53.3 54.9-53.3h13.7c37.9 0 68.6-29.8 68.6-66.7 0-14.5-4.9-27.8-12.9-38.7 4.2-.6 8.5-1.3 12.9-1.3 45.4 0 82.3 35.8 82.3 80 0 9.4-2 18.3-5 26.7h5c30.3 0 54.9 23.9 54.9 53.3 0 10.1-3.2 19.2-8.2 27.2 35.1 2.8 63 31.3 63 66.1 0 33.4-25.7 61-58.9 65.7-4 6.3-11.5 18.1-21 33h11.3c55.5 0 100.6-44.3 100.6-98.7 0-37.7-22.4-71.1-55.1-87.5z"]
  },
      YA = {
    prefix: "fal",
    iconName: "poop",
    icon: [512, 512, [], "f619", "M476.17 342.71C481.28 331 484 318.22 484 305c0-39.19-23.86-72.92-57.81-87.42A86.68 86.68 0 0 0 428 200c0-37.25-23.26-69.16-56.02-81.99.01-.67.02-1.34.02-2.01C372 52.04 319.96 0 256 0c-6.79 0-12.73.85-18.24 1.73a31.995 31.995 0 0 0-24.51 19.28 32.005 32.005 0 0 0 3.53 30.98C220.08 56.58 224 64.12 224 74c0 20.95-17.05 38-38 38h-14c-48.52 0-88 39.48-88 88 0 5.95.62 11.84 1.81 17.58C51.86 232.08 28 265.81 28 305c0 13.22 2.71 25.99 7.83 37.71C13.77 360.14 0 387.04 0 417c0 52.38 42.62 95 95 95h322c52.38 0 95-42.62 95-95 0-29.96-13.77-56.86-35.83-74.29zM417 480H95c-34.79 0-63-28.21-63-63 0-31.39 23.02-57.21 53.06-62C69.93 343.49 60 325.48 60 305c0-34.79 28.21-63 63-63h12.31C123.57 231.74 116 216.82 116 200c0-30.93 25.07-56 56-56h14c38.66 0 70-31.34 70-70 0-15.21-4.98-29.19-13.22-40.67 4.34-.69 8.69-1.33 13.22-1.33 46.39 0 84 37.61 84 84 0 9.87-2.02 19.2-5.14 28H340c30.93 0 56 25.07 56 56 0 16.82-7.57 31.74-19.31 42H389c34.79 0 63 28.21 63 63 0 20.48-9.93 38.49-25.06 50 30.04 4.79 53.06 30.61 53.06 62 0 34.79-28.21 63-63 63z"]
  },
      PA = {
    prefix: "fal",
    iconName: "popcorn",
    icon: [512, 512, [], "f819", "M440.17 138.22a68 68 0 0 0-19.8-22.31 66.9 66.9 0 0 0-49.47-61.38 67.33 67.33 0 0 0-68-35.65A67.69 67.69 0 0 0 255.94 0a65.92 65.92 0 0 0-46.47 18.89 67.18 67.18 0 0 0-68 35.64C110.7 62.78 93 90 91.74 116a65.84 65.84 0 0 0-19.83 22.78 64.67 64.67 0 0 0-3.37 54.86l39.76 290.68A32 32 0 0 0 140 512h232.35a32 32 0 0 0 31.73-27.68l40.08-293c5.92-17.13 5.3-36.23-3.99-53.1zM140 480l-39.28-288H176l16.22 288zm148.06 0h-63.78l-16.21-288h96.24zm84.26 0h-52.16l16.21-288h75.28zM98 160c4.42-15.78 17.82-23.38 29.78-24.57-13.9-26.22 9.64-56.43 38.11-50.43.55-29.22 34.33-44.9 56.37-27.17 11.74-41.86 67.59-25.63 67.59 0C312.6 40 345.94 56 346.49 85c28.57-6 51.45 23.81 38.15 50.45 12 1.2 25.44 9.11 29.74 24.57z"]
  },
      FA = {
    prefix: "fal",
    iconName: "portal-enter",
    icon: [512, 512, [], "e022", "M448,0c-49.10352,0-60.52539,142.78711-63.17578,216h-3.35547l-9.03126-27.125c-8.125-24.3125-24.18749-44-44.5-58.03125C347,117.90625,360,96.73438,360,72a72,72,0,0,0-144,0,71.00847,71.00847,0,0,0,4.18749,23.71875A112.98756,112.98756,0,0,0,135.4375,108.5L89.25,132.5625a52.01084,52.01084,0,0,0,52.4375,89.82812l18.9375-9.84374L101.75,344H52a52,52,0,0,0,0,104h62.90625A83.90044,83.90044,0,0,0,192.125,397.07812l19.31249-39.73437,43.68751,19.625L235.5,445.70312A52.05212,52.05212,0,0,0,271.18749,510,52.89215,52.89215,0,0,0,285.5,512a52.24717,52.24717,0,0,0,50-37.6875l24.375-85.40625a84.15978,84.15978,0,0,0-12-71.10937A85.07673,85.07673,0,0,0,367.09375,320H396a51.95957,51.95957,0,0,0,20.75977-99.60938C419.97852,111.33594,437.041,48.01172,448,33.875,460.125,49.51562,480,124.45312,480,256s-19.875,206.48438-32,222.125c-8.75586-11.29492-21.46094-53.98438-27.89648-126.125H388.168c6.18359,73.043,21.54687,160,59.832,160,62.21875,0,64-229.79688,64-256S510.21875,0,448,0ZM288,32a40,40,0,1,1-40,40A39.997,39.997,0,0,1,288,32ZM162.6875,384.48438C155.25,401.875,133.875,416,114.9375,416H52a20,20,0,0,1,0-40h62.90625a11.9977,11.9977,0,0,0,11.03125-7.28125l26.71875-56.875A83.10126,83.10126,0,0,0,182.625,343.26562ZM396,288H367.03125c-20.6875,0-42.78125-15.92188-49.3125-35.54688L304.125,211.65625a43.28918,43.28918,0,0,0-15-20.67187l-41.46875,103.6875,52.78124,23.71874A52.30819,52.30819,0,0,1,329.125,380.125L304.71875,465.5c-7.22492,25.37752-45.81231,14.7403-38.46875-11l24.40625-85.375a12.07949,12.07949,0,0,0-6.625-14.25s-85.8125-39.04688-88.71875-41.17188a52.12113,52.12113,0,0,1-18.5-57.875l37.75-87.5625s-16.90624-3.78124-20.5-3.78124a43.34675,43.34675,0,0,0-22.5,6.3125l-45.25,23.51562a23.5854,23.5854,0,0,1-10.28125,2.84375,19.9989,19.9989,0,0,1-10.3125-37.14063l45.25-23.53124A83.78091,83.78091,0,0,1,194.09375,124.5a85.03565,85.03565,0,0,1,20.5,2.53125l68.1875,17.04687A83.59572,83.59572,0,0,1,342.09375,199l13.59374,40.79688A11.979,11.979,0,0,0,367.06249,248H396a20,20,0,0,1,0,40Z"]
  },
      WA = {
    prefix: "fal",
    iconName: "portal-exit",
    icon: [512, 512, [], "e023", "M460,216H445.46875l-9.03125-27.125c-8.125-24.3125-24.1875-44-44.5-58.03125C411,117.90625,424,96.73438,424,72a72,72,0,0,0-144,0,71.00848,71.00848,0,0,0,4.1875,23.71875A112.98758,112.98758,0,0,0,199.4375,108.5L153.25,132.5625a51.63613,51.63613,0,0,0-15.418,14.24414C129.09766,71.17773,109.79688,0,72,0,15.15625,0,0,160.92188,0,256S15.15625,512,72,512c22.94727,0,38.99023-26.44922,50.082-64h56.82422A83.90044,83.90044,0,0,0,256.125,397.07812l19.3125-39.73437,43.6875,19.625L299.5,445.70312A52.05212,52.05212,0,0,0,335.1875,510,52.892,52.892,0,0,0,349.5,512a52.24717,52.24717,0,0,0,50-37.6875l24.375-85.40625a84.15978,84.15978,0,0,0-12-71.10937A85.07673,85.07673,0,0,0,431.09375,320H460a52,52,0,0,0,0-104ZM352,32a40,40,0,1,1-40,40A39.997,39.997,0,0,1,352,32ZM72.65625,480.09375C58.46875,474.60938,32,392.79688,32,256,32,121.32812,57.65625,39.95312,72,32.21875,86.34375,39.95312,112,121.32812,112,256c0,16.86133-.418,32.84961-1.14648,48h31.9082C143.582,287.01562,144,270.67969,144,256c0-13.10352-.32422-27.51758-.96875-42.5293a51.69161,51.69161,0,0,0,62.65625,8.91992l18.9375-9.84374L165.75,344H116a51.81787,51.81787,0,0,0-24.86914,97.377C84.47656,464.63086,77.57812,477.99805,72.65625,480.09375ZM226.6875,384.48438C219.25,401.875,197.875,416,178.9375,416H116a20,20,0,0,1,0-40h62.90625a11.9977,11.9977,0,0,0,11.03125-7.28125l26.71875-56.875A83.10126,83.10126,0,0,0,246.625,343.26562ZM460,288H431.03125c-20.6875,0-42.78125-15.92188-49.3125-35.54688L368.125,211.65625a43.28905,43.28905,0,0,0-15-20.67187l-41.46875,103.6875,52.78125,23.71874A52.3082,52.3082,0,0,1,393.125,380.125L368.71875,465.5A19.97861,19.97861,0,0,1,349.5,480a20.38928,20.38928,0,0,1-5.5-.76562A20.014,20.014,0,0,1,330.25,454.5l24.40625-85.375a12.07948,12.07948,0,0,0-6.625-14.25s-85.8125-39.04688-88.71875-41.17188a52.12113,52.12113,0,0,1-18.5-57.875l37.75-87.5625s-16.90625-3.78124-20.5-3.78124a43.34675,43.34675,0,0,0-22.5,6.3125l-45.25,23.51562a23.5854,23.5854,0,0,1-10.28125,2.84375,19.9989,19.9989,0,0,1-10.3125-37.14063l45.25-23.53124A83.78091,83.78091,0,0,1,258.09375,124.5a85.03559,85.03559,0,0,1,20.5,2.53125l68.1875,17.04687A83.59571,83.59571,0,0,1,406.09375,199l13.59375,40.79688A11.979,11.979,0,0,0,431.0625,248H460a20,20,0,0,1,0,40Z"]
  },
      GA = {
    prefix: "fal",
    iconName: "portrait",
    icon: [384, 512, [], "f3e0", "M320 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 448c0 17.6-14.4 32-32 32H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h256c17.6 0 32 14.4 32 32v384zM192 288c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm46.8 144c-19.5 0-24.4 7-46.8 7s-27.3-7-46.8-7c-21.2 0-41.8 9.4-53.8 27.4C84.2 342.1 80 355 80 368.9V408c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-39.1c0-14 9-32.9 33.2-32.9 12.4 0 20.8 7 46.8 7 25.9 0 34.3-7 46.8-7 24.3 0 33.2 18.9 33.2 32.9V408c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-39.1c0-13.9-4.2-26.8-11.4-37.5-12.1-18-32.7-27.4-53.8-27.4z"]
  },
      qA = {
    prefix: "fal",
    iconName: "pound-sign",
    icon: [320, 512, [], "f154", "M308 368h-16.101c-6.627 0-12 5.373-12 12v62.406H97.556V288H204c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12H97.556V150.423c0-41.981 30.702-78.322 85.84-78.322 27.902 0 51.392 12.351 63.42 20.131 5.111 3.306 11.893 2.213 15.753-2.494l10.665-13.006c4.488-5.474 3.283-13.605-2.583-17.568C255.331 48.814 224.167 32 183.396 32 107.58 32 53.695 82.126 53.695 147.916V256H20c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h33.695v155.032H12c-6.627 0-12 5.373-12 12V468c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12v-88c0-6.627-5.373-12-12-12z"]
  },
      JA = {
    prefix: "fal",
    iconName: "power-off",
    icon: [512, 512, [], "f011", "M388.5 46.3C457.9 90.3 504 167.8 504 256c0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 168 54 90.3 123.5 46.3c5.8-3.7 13.5-1.8 16.9 4.2l3.9 7c3.1 5.6 1.3 12.6-4.1 16C79.9 112 40 179.6 40 256c0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216 0-77-40.1-144.2-100.3-182.4-5.4-3.4-7.2-10.5-4.1-16l3.9-7c3.4-6.1 11.2-7.9 17-4.3zM272 276V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v264c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12z"]
  },
      KA = {
    prefix: "fal",
    iconName: "pray",
    icon: [384, 512, [], "f683", "M240 144c39.7 0 72-32.3 72-72S279.7 0 240 0s-72 32.3-72 72 32.3 72 72 72zm0-112c22.05 0 40 17.95 40 40s-17.95 40-40 40-40-17.95-40-40 17.95-40 40-40zm-20.75 294.89c20.49 24.41 55.05 20.13 70.56 3.05l80.13-88c18.74-18.75 18.74-49.14 0-67.88-18.75-18.75-49.14-18.75-67.88 0l-42.31 49.69-31.31-35.16C213.2 170.43 190.46 160 166.06 160c-38.53 0-61.85 24.24-71.17 41.53l-49.38 92.04C22.5 336.5 31.8 385.77 66.94 416H48c-26.47 0-48 21.53-48 48s21.53 48 48 48h202.03c20.84 0 39.37-13.29 46.1-33.07 6.47-19.02.51-39.11-15.18-51.19L178.2 352.79l24.49-45.62 16.56 19.72zm-82.44 35.33l124.61 90.88c11.1 8.54 3.3 26.9-11.4 26.9H48c-8.81 0-16-7.17-16-16s7.19-16 16-16h138.25l-90.03-50.02c-32-20.44-39.72-57.17-22.5-89.28l49.34-91.98c13.71-25.43 56.55-36.54 80.88-7.55l54.34 64.67 66.4-77.16c6.25-6.25 16.38-6.25 22.63 0s6.25 16.38 0 22.63l-81.19 89.11c-7.66 6.34-17.61 3.55-22.38-2.12l-46.94-55.84-59.99 111.76z"]
  },
      XA = {
    prefix: "fal",
    iconName: "praying-hands",
    icon: [640, 512, [], "f684", "M502.58 340.23l127.06 39.99c5.14 1.58 10.35-2.26 10.35-7.65v-16.74c0-3.51-2.29-6.61-5.65-7.65L512 309.64v-66.51c0-22.28-5.81-44.17-16.87-63.51L408.65 28.26C398.71 10.83 380.07 0 359.99 0 345.2 0 330.73 6.01 320 16.94 309.27 6.01 294.8 0 280.01 0c-20.08 0-38.72 10.83-48.66 28.26l-86.49 151.37A128.015 128.015 0 0 0 128 243.14v66.51L5.65 348.18A8.011 8.011 0 0 0 0 355.83v16.74c0 5.38 5.21 9.23 10.35 7.65l127.06-39.99c13.42-4.13 22.58-16.54 22.58-30.58v-66.51c0-16.71 4.36-33.13 12.65-47.63l86.51-151.4c6.93-12.16 21.84-15.16 32.75-8.94 11.5 6.58 15.5 21.25 8.94 32.75l-64.19 112.33A96.022 96.022 0 0 0 224 227.88v84.13c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64c0-13.25 10.75-24 24-24s24 10.75 24 24v86.08c0 35.86-23.87 67.34-58.39 77.03L5.84 479.68a8.008 8.008 0 0 0-5.84 7.7V504c0 5.3 5.06 9.13 10.16 7.7l244.09-69.77c28.41-7.97 51.4-26.63 65.75-50.73 14.35 24.09 37.34 42.76 65.75 50.73l244.09 69.77c5.1 1.43 10.16-2.4 10.16-7.7v-16.62c0-3.59-2.39-6.73-5.84-7.7l-239.77-68.56c-34.53-9.69-58.39-41.17-58.39-77.03v-86.08c0-13.25 10.75-24 24-24s24 10.75 24 24v64c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-84.13c0-16.71-4.36-33.13-12.65-47.63L339.16 67.92c-6.56-11.5-2.56-26.17 8.94-32.75 10.97-6.26 25.87-3.14 32.75 8.94l86.51 151.4a95.994 95.994 0 0 1 12.65 47.63v66.51c-.01 14.04 9.15 26.44 22.57 30.58zM374.27 193.85c-6.35-1.68-13.14-2.26-20.16-1.54-13.66 1.4-25.37 8.22-34.11 17.95-8.73-9.73-20.45-16.55-34.11-17.95-7.01-.72-13.8-.14-20.16 1.54L320 98.89l54.27 94.96z"]
  },
      _A = {
    prefix: "fal",
    iconName: "prescription",
    icon: [384, 512, [], "f5b1", "M278.63 352l103.03-103.03c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0L256 329.37 150.63 224H160c53.02 0 96-42.98 96-96s-42.98-96-96-96H8c-4.42 0-8 3.58-8 8v272c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-88h73.37l128 128-103.03 103.03c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0L256 374.63l103.03 103.03c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31L278.63 352zM32 192V64h128c35.29 0 64 28.71 64 64s-28.71 64-64 64H32z"]
  },
      $A = {
    prefix: "fal",
    iconName: "prescription-bottle",
    icon: [384, 512, [], "f485", "M360 0H24C10.8 0 0 10.8 0 24v80c0 13.2 10.8 24 24 24h8v352c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128h8c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zm-40 480H64v-64h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H64v-64h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H64v-64h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H64v-64h256v352zm32-384H32V32h320v64z"]
  },
      cN = {
    prefix: "fal",
    iconName: "prescription-bottle-alt",
    icon: [384, 512, [], "f486", "M104 320h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM360 0H24C10.8 0 0 10.8 0 24v80c0 13.2 10.8 24 24 24h8v352c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128h8c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zm-40 480H64V128h256v352zm32-384H32V32h320v64z"]
  },
      eN = {
    prefix: "fal",
    iconName: "presentation",
    icon: [576, 512, [], "f685", "M568 0H8C3.58 0 0 3.59 0 8.02v16.04c0 4.43 3.58 8.02 8 8.02h24v287.78c0 17.69 14.34 32.09 32 32.09h208v49.13l-85.66 85.89c-3.12 3.13-3.12 8.21 0 11.34l11.31 11.34a7.985 7.985 0 0 0 11.31 0L288 430.41l79.03 79.24a7.985 7.985 0 0 0 11.31 0l11.31-11.34c3.12-3.13 3.12-8.21 0-11.34L304 401.08v-49.13h208c17.66 0 32-14.4 32-32.09V32.09h24c4.42 0 8-3.59 8-8.02V8.02c0-4.43-3.58-8.02-8-8.02zm-56 320H64V32h448v288z"]
  },
      aN = {
    prefix: "fal",
    iconName: "print",
    icon: [512, 512, [], "f02f", "M432 192h-16v-82.75c0-8.49-3.37-16.62-9.37-22.63L329.37 9.37c-6-6-14.14-9.37-22.63-9.37H126.48C109.64 0 96 14.33 96 32v160H80c-44.18 0-80 35.82-80 80v96c0 8.84 7.16 16 16 16h80v112c0 8.84 7.16 16 16 16h288c8.84 0 16-7.16 16-16V384h80c8.84 0 16-7.16 16-16v-96c0-44.18-35.82-80-80-80zM320 45.25L370.75 96H320V45.25zM128.12 32H288v64c0 17.67 14.33 32 32 32h64v64H128.02l.1-160zM384 480H128v-96h256v96zm96-128H32v-80c0-26.47 21.53-48 48-48h352c26.47 0 48 21.53 48 48v80zm-80-88c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      nN = {
    prefix: "fal",
    iconName: "print-search",
    icon: [640, 512, [], "f81a", "M637.66 487l-89-89c39-50.21 35.94-122.46-10.17-168.57a128 128 0 0 0-181 181c46.11 46.11 118.36 49.13 168.57 10.17l89 89a8 8 0 0 0 11.32 0l11.31-11.31a8 8 0 0 0-.03-11.29zM448 416a96 96 0 1 1 96-96 96 96 0 0 1-96 96zm-64 64H128v-96h173.75a159.68 159.68 0 0 1-10.33-32H32v-80a48.05 48.05 0 0 1 48-48h240.88c11.62-15.39 13.51-18.17 32.06-32H128l.1-160H288v64a32 32 0 0 0 32 32h64v45.56a157.9 157.9 0 0 1 32-10.32v-54a32 32 0 0 0-9.37-22.63L329.37 9.37A32 32 0 0 0 306.74 0H126.48C109.64 0 96 14.33 96 32v160H80a80 80 0 0 0-80 80v96a16 16 0 0 0 16 16h80v112a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-19.24a157.9 157.9 0 0 1-32-10.32zM320 45.25L370.75 96H320z"]
  },
      tN = {
    prefix: "fal",
    iconName: "print-slash",
    icon: [640, 512, [], "f686", "M637 485.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zM192.1 32H352v64c0 17.7 14.3 32 32 32h64v64H316.3l40.6 32h139c26.5 0 48 21.5 48 48v80h-24.5l40.6 32c8.8-.1 15.9-7.2 15.9-16v-96c0-44.2-35.8-80-80-80h-16v-82.8c0-8.5-3.4-16.6-9.4-22.6L393.4 9.4c-6-6-14.1-9.4-22.6-9.4H190.5C173.6 0 160 14.3 160 32v36.9l32.1 25.3zM384 45.2L434.8 96H384zM448 480H192v-96h213l-40.6-32H96v-80c0-26.5 21.5-48 48-48h57.8L160 191.1v.9h-16c-44.2 0-80 35.8-80 80v96c0 8.8 7.2 16 16 16h80v112c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16v-52.9l-32-25.2zm-8-192c0 .6.3 1.1.3 1.6l27.4 21.6c11.4-1.9 20.2-11.3 20.2-23.2 0-13.3-10.8-24-24-24S440 274.7 440 288z"]
  },
      rN = {
    prefix: "fal",
    iconName: "procedures",
    icon: [640, 512, [], "f487", "M144 384c44.1 0 80-35.9 80-80s-35.9-80-80-80-80 35.9-80 80 35.9 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm384-32H272c-8.8 0-16 7.2-16 16v176H32V136c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8v368c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56h576v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V336c0-61.9-50.1-112-112-112zm80 192H288V256h240c44.2 0 80 35.8 80 80v80zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"]
  },
      iN = {
    prefix: "fal",
    iconName: "project-diagram",
    icon: [640, 512, [], "f542", "M592 0h-96c-26.51 0-48 21.49-48 48v32H192V48c0-26.51-21.49-48-48-48H48C21.49 0 0 21.49 0 48v96c0 26.51 21.49 48 48 48h94.86l88.76 150.21c-4.77 7.46-7.63 16.27-7.63 25.79v96c0 26.51 21.49 48 48 48h96c26.51 0 48-21.49 48-48v-96c0-26.51-21.49-48-48-48h-96c-5.2 0-10.11 1.04-14.8 2.57l-83.43-141.18C184.8 172.59 192 159.2 192 144v-32h256v32c0 26.51 21.49 48 48 48h96c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM32 144V48c0-8.82 7.18-16 16-16h96c8.82 0 16 7.18 16 16v96c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16zm336 208c8.82 0 16 7.18 16 16v96c0 8.82-7.18 16-16 16h-96c-8.82 0-16-7.18-16-16v-96c0-8.82 7.18-16 16-16h96zm240-208c0 8.82-7.18 16-16 16h-96c-8.82 0-16-7.18-16-16V48c0-8.82 7.18-16 16-16h96c8.82 0 16 7.18 16 16v96z"]
  },
      oN = {
    prefix: "fal",
    iconName: "projector",
    icon: [640, 512, [], "f8d6", "M337.54 136.17a8 8 0 0 0 11.31 0l11.31-11.32a8 8 0 0 0 0-11.31L281 34.34a8 8 0 0 0-11.31 0l-11.35 11.32a8 8 0 0 0 0 11.31zm177.61 0a8 8 0 0 0 11.31 0L605.66 57a8 8 0 0 0 0-11.31l-11.32-11.35a8 8 0 0 0-11.31 0l-79.19 79.2a8 8 0 0 0 0 11.31zM424 128h16a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v112a8 8 0 0 0 8 8zm168 64H480.68c-19.52-9.89-41.29-16-64.68-16s-45.16 6.11-64.68 16H48a48 48 0 0 0-48 48v160a48 48 0 0 0 48 48h48v56a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-56h223.32c19.52 9.89 41.29 16 64.68 16s45.16-6.11 64.68-16H512v56a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-56h48a48 48 0 0 0 48-48V240a48 48 0 0 0-48-48zM48 416a16 16 0 0 1-16-16V240a16 16 0 0 1 16-16h261.37C286.38 249.52 272 283 272 320s14.38 70.48 37.37 96zm368 16a112 112 0 1 1 112-112 112.16 112.16 0 0 1-112 112zm192-32a16 16 0 0 1-16 16h-69.37c23-25.52 37.37-58.95 37.37-96s-14.38-70.48-37.37-96H592a16 16 0 0 1 16 16zM104 296a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm80 0a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"]
  },
      lN = {
    prefix: "fal",
    iconName: "pump-medical",
    icon: [384, 512, [], "e06a", "M226.67,277.33h-40v-40A13.33,13.33,0,0,0,173.33,224H146.67a13.33,13.33,0,0,0-13.34,13.33v40h-40A13.33,13.33,0,0,0,80,290.67v26.66a13.33,13.33,0,0,0,13.33,13.34h40v40A13.33,13.33,0,0,0,146.67,384h26.66a13.33,13.33,0,0,0,13.34-13.33v-40h40A13.33,13.33,0,0,0,240,317.33V290.67A13.33,13.33,0,0,0,226.67,277.33ZM379.31,100.69l-48-48A16,16,0,0,0,320,48H240V32A32,32,0,0,0,208,0H112A32,32,0,0,0,80,32v96.41a63.83,63.83,0,0,0-59.37,57.8L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-256A63.83,63.83,0,0,0,240,128.41V80h73.38l43.31,43.31a16,16,0,0,0,22.62-22.62ZM112,32h96v96H112ZM267.47,188.74,287.86,445.1A32,32,0,0,1,256,480H64a32,32,0,0,1-31.84-35.26L52.5,189.1A32,32,0,0,1,82.19,160H237.81A32,32,0,0,1,267.47,188.74Z"]
  },
      fN = {
    prefix: "fal",
    iconName: "pump-soap",
    icon: [384, 512, [], "e06b", "M379.31,100.69l-48-48A16,16,0,0,0,320,48H240V32A32,32,0,0,0,208,0H112A32,32,0,0,0,80,32v96.41a63.83,63.83,0,0,0-59.37,57.8L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-256A63.83,63.83,0,0,0,240,128.41V80h73.38l43.31,43.31a16,16,0,0,0,22.62-22.62ZM112,32h96v96H112ZM267.47,188.74,287.86,445.1A32,32,0,0,1,256,480H64a32,32,0,0,1-31.84-35.26L52.5,189.1A32,32,0,0,1,82.19,160H237.81A32,32,0,0,1,267.47,188.74ZM139.22,234.39C102.58,283.31,84,319.27,84,341.25,84,382.47,118.09,416,160,416s76-33.53,76-74.75c0-22-18.58-57.94-55.23-106.86C170.86,221.17,149.16,221.17,139.22,234.39ZM160,384c-24.27,0-44-19.17-44-42.75,0-9.89,11.64-36.91,44-81.14,32.36,44.23,44,71.25,44,81.14C204,364.83,184.27,384,160,384Z"]
  },
      sN = {
    prefix: "fal",
    iconName: "pumpkin",
    icon: [576, 512, [], "f707", "M494.75 110.52C460.24 77.96 409.33 71.33 368 90.9V51.8c0-12.2-6.78-23.17-17.69-28.62L310.69 3.36c-7.97-3.97-17.38-4.45-25.66-1.27-8.31 3.16-15 9.72-18.34 18.03l-28.7 71.75c-4.78 2.44-9.4 5.19-13.74 8.38-43.41-30.29-103.78-26.76-143 10.26C28.84 159.92 0 225.78 0 295.95c0 70.16 28.84 136 81.25 185.4 39.19 36.98 99.53 40.6 143 10.28C252.04 512.08 286.62 512 288 512c6.57 0 37.2-.83 63.75-20.37 19.5 13.59 42.38 20.36 65.22 20.36 28.12 0 56.16-10.23 77.78-30.63C547.16 431.96 576 366.11 576 295.94s-28.84-136.02-81.25-185.42zM288 479.9c-121.09 0-124.26-367.9 0-367.9 121.22 0 124.21 367.9 0 367.9zm8.41-447.91L336 51.8v39.11c-18.21-8.78-38.95-11.99-59.17-10.01l19.58-48.91zM103.19 458.08C57.28 414.79 32 357.21 32 295.94s25.28-118.85 71.19-162.15c27.8-26.21 72.02-28.34 102.97-6.68-28.62 41.25-42.21 104.24-42.21 167.23 0 52.79 9.19 102.67 25.88 140.47 5.17 11.71 10.89 21.14 16.78 29.63-30.94 21.97-75.46 19.99-103.42-6.36zm369.62 0c-27.75 26.15-71.82 28.31-102.74 6.86 28.51-41.31 41.97-104.37 41.97-167.27 0-64.23-13.7-128.43-42.56-170.31 30.92-21.91 75.37-19.93 103.33 6.44C518.72 177.09 544 234.67 544 295.94s-25.28 118.85-71.19 162.14z"]
  },
      uN = {
    prefix: "fal",
    iconName: "puzzle-piece",
    icon: [576, 512, [], "f12e", "M506.584 256c-52.307 0-72.012 46.513-87.263 27.506-20.125-25.082-2.028-107.233 3.475-131.942-34.229 6.371-137.243 24.274-163.836 2.178-16.619-13.81 31.313-43.496 31.313-86.443C290.272 26.025 256.447 0 214.842 0c-43.559 0-84.792 25.609-84.792 68.824 0 53.02 45.898 71.605 24.351 88.606C125.985 179.846 35.346 160.524 0 152.041v345.313c33.315 8.012 70.681 14.649 106.163 14.646 42.28 0 85.837-11.839 85.837-54.125 0-29.344-32-40.832-32-73.875 0-24.437 22.534-32 46.978-32C245.675 352 256 372.114 256 384c0 28.783-34.272 36.348-34.272 76.58 0 13.748 5.013 25.445 14.498 33.828 35.153 31.069 106.717 6.319 187.085 6.285-.958-3.426-26.807-86.724-7.702-111.907 16.715-22.023 48.578 29.106 92.52 29.106C550.227 417.893 576 377.616 576 336c0-42.835-26.227-80-69.416-80zm1.544 129.893c-30.002 0-41.364-33.893-81.513-33.893-53.566 0-54.841 64.979-44.272 117.816-36.396 3.424-107.025 16.434-124.926.614C237.293 452.645 288 428.279 288 384c0-37.683-33.317-64-81.022-64-74.981 0-102.885 59.829-56.167 122.037 4.726 6.293 9.189 12.237 9.189 15.838 0 33.69-94.005 20.629-128 13.925V191.971c63.255 11.657 160 18.136 160-46.505 0-28.567-29.95-42.982-29.95-76.642C162.05 44.146 190.265 32 214.842 32c20.035 0 43.43 9.244 43.43 35.298 0 29.426-34.272 40.752-34.272 80.61 0 57.828 100.845 50.931 158.22 43.093C374.142 245.294 373.959 320 429.086 320c29.143 0 43.674-32 77.498-32C531.543 288 544 311.301 544 336c0 34.413-20.977 49.893-35.872 49.893z"]
  },
      hN = {
    prefix: "fal",
    iconName: "qrcode",
    icon: [448, 512, [], "f029", "M0 224h192V32H0v192zM32 64h128v128H32V64zm224-32v192h192V32H256zm160 160H288V64h128v128zM0 480h192V288H0v192zm32-160h128v128H32V320zM64 96h64v64H64V96zm320 64h-64V96h64v64zM64 352h64v64H64v-64zm352-64h32v128H320v-32h-32v96h-32V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"]
  },
      mN = {
    prefix: "fal",
    iconName: "question",
    icon: [384, 512, [], "f128", "M200.343 0C124.032 0 69.761 31.599 28.195 93.302c-14.213 21.099-9.458 49.674 10.825 65.054l42.034 31.872c20.709 15.703 50.346 12.165 66.679-8.51 21.473-27.181 28.371-31.96 46.132-31.96 10.218 0 25.289 6.999 25.289 18.242 0 25.731-109.3 20.744-109.3 122.251V304c0 16.007 7.883 30.199 19.963 38.924C109.139 360.547 96 386.766 96 416c0 52.935 43.065 96 96 96s96-43.065 96-96c0-29.234-13.139-55.453-33.817-73.076 12.08-8.726 19.963-22.917 19.963-38.924v-4.705c25.386-18.99 104.286-44.504 104.286-139.423C378.432 68.793 288.351 0 200.343 0zM192 480c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm50.146-186.406V304c0 8.837-7.163 16-16 16h-68.292c-8.836 0-16-7.163-16-16v-13.749c0-86.782 109.3-57.326 109.3-122.251 0-32-31.679-50.242-57.289-50.242-33.783 0-49.167 16.18-71.242 44.123-5.403 6.84-15.284 8.119-22.235 2.848l-42.034-31.872c-6.757-5.124-8.357-14.644-3.62-21.677C88.876 60.499 132.358 32 200.343 32c70.663 0 146.089 55.158 146.089 127.872 0 96.555-104.286 98.041-104.286 133.722z"]
  },
      vN = {
    prefix: "fal",
    iconName: "question-circle",
    icon: [512, 512, [], "f059", "M256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28zm7.67-24h-16c-6.627 0-12-5.373-12-12v-.381c0-70.343 77.44-63.619 77.44-107.408 0-20.016-17.761-40.211-57.44-40.211-29.144 0-44.265 9.649-59.211 28.692-3.908 4.98-11.054 5.995-16.248 2.376l-13.134-9.15c-5.625-3.919-6.86-11.771-2.645-17.177C185.658 133.514 210.842 116 255.67 116c52.32 0 97.44 29.751 97.44 80.211 0 67.414-77.44 63.849-77.44 107.408V304c0 6.627-5.373 12-12 12zM256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8z"]
  },
      dN = {
    prefix: "fal",
    iconName: "question-square",
    icon: [448, 512, [], "f2fd", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm16 400c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h352c8.822 0 16 7.178 16 16v352zm-192-92c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28zm7.67-24h-16c-6.627 0-12-5.373-12-12v-.381c0-70.343 77.44-63.619 77.44-107.408 0-20.016-17.761-40.211-57.44-40.211-29.144 0-44.265 9.649-59.211 28.692-3.908 4.98-11.054 5.995-16.248 2.376l-13.134-9.15c-5.625-3.919-6.86-11.771-2.645-17.177C153.658 133.514 178.842 116 223.67 116c52.32 0 97.44 29.751 97.44 80.211 0 67.414-77.44 63.849-77.44 107.408V304c0 6.627-5.373 12-12 12z"]
  },
      MN = {
    prefix: "fal",
    iconName: "quidditch",
    icon: [640, 512, [], "f458", "M638.3 15.5L628.3 3c-2.8-3.5-7.8-4-11.2-1.3l-244.2 193-45.4-57.1c-5-6.3-14.6-6-19.2.5l-48.6 68.6c-28.5.3-107.2 5-158 45.4C38.8 302.1 0 511.4 0 511.4c15.4.7 215.1 6.8 275.6-41.3 50.9-40.5 73.3-116.2 80-143.8l77.5-31.3c7.4-3 9.9-12.3 4.9-18.6l-45.2-56.7L637 26.8c3.4-2.8 4-7.8 1.3-11.3zM255.7 445.6C229 466.8 146.3 480 39.8 480h-.6c4.1-17.8 9-36.8 14.4-55.9l68.8-54.7c5-3.9 1.2-11.9-5-10.6l-46 9.7c15-41.6 32.3-77.3 50.1-91.5 33.6-26.7 89.7-37.2 133.9-38.4l67.8 85.1c-7.1 27.7-27.1 89.8-67.5 121.9zm87.1-148.8l-56.9-71.5 28.4-40.5c2.3-3.3 7.1-3.4 9.6-.3l67.6 84.9c2.5 3.2 1.3 7.9-2.5 9.3l-46.2 18.1zM496 351.5c-44.1 0-80 35.8-80 79.9s35.9 80.6 80 80.6 80-36.5 80-80.6-35.8-79.9-80-79.9zm0 127.9c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      pN = {
    prefix: "fal",
    iconName: "quote-left",
    icon: [512, 512, [], "f10d", "M448 224h-64v-24c0-30.9 25.1-56 56-56h16c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40h-16c-92.6 0-168 75.4-168 168v216c0 35.3 28.7 64 64 64h112c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64zm32 192c0 17.7-14.3 32-32 32H336c-17.7 0-32-14.3-32-32V200c0-75.1 60.9-136 136-136h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-16c-48.6 0-88 39.4-88 88v56h96c17.7 0 32 14.3 32 32v128zM176 224h-64v-24c0-30.9 25.1-56 56-56h16c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40h-16C75.4 32 0 107.4 0 200v216c0 35.3 28.7 64 64 64h112c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64zm32 192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V200c0-75.1 60.9-136 136-136h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-16c-48.6 0-88 39.4-88 88v56h96c17.7 0 32 14.3 32 32v128z"]
  },
      zN = {
    prefix: "fal",
    iconName: "quote-right",
    icon: [512, 512, [], "f10e", "M176 32H64C28.7 32 0 60.7 0 96v128c0 35.3 28.7 64 64 64h64v24c0 30.9-25.1 56-56 56H56c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c92.6 0 168-75.4 168-168V96c0-35.3-28.7-64-64-64zm32 280c0 75.1-60.9 136-136 136H56c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h16c48.6 0 88-39.4 88-88v-56H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h112c17.7 0 32 14.3 32 32v216zM448 32H336c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64h64v24c0 30.9-25.1 56-56 56h-16c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c92.6 0 168-75.4 168-168V96c0-35.3-28.7-64-64-64zm32 280c0 75.1-60.9 136-136 136h-16c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h16c48.6 0 88-39.4 88-88v-56h-96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h112c17.7 0 32 14.3 32 32v216z"]
  },
      CN = {
    prefix: "fal",
    iconName: "quran",
    icon: [448, 512, [], "f687", "M246.25 338.38c15.03 0 29.97-2.72 44.03-7.97a18.75 18.75 0 0 0 12.78-17.8c0-10.34-8.44-18.77-18.81-18.77l-4.12.2c-45.69 0-82.88-37.17-82.88-82.86s37.19-82.86 82.84-82.86l4.16.2c8.94 0 16.66-6.34 18.38-15.06 1.84-9.12-3.12-18.08-11.78-21.28-14.5-5.44-29.5-8.19-44.59-8.19-70.12 0-127.19 57.06-127.19 127.19s57.05 127.2 127.18 127.2zm0-230.38c1.84 0 3.66.05 5.5.16-45.19 12.45-78.5 53.94-78.5 103.03 0 49.11 33.28 90.58 78.5 103.03-58.72 3.66-108.69-44.3-108.69-103.03 0-56.89 46.28-103.19 103.19-103.19zM448 392V24c0-13.3-10.7-24-24-24H80C35.8 0 0 35.8 0 80v368c0 35.35 28.65 64 64 64h372c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-3.3c-4-20.2-3.2-49.7.4-65.8 8.7-3.6 14.9-12.2 14.9-22.2zm-43.7 88H64c-17.67 0-32-14.33-32-32s14.33-32 32-32h340.3c-2.9 18.8-3.1 43.6 0 64zm11.7-96H64c-11.72 0-22.55 3.38-32 8.88V80c0-26.5 21.5-48 48-48h336v352zM292.72 155.27l-10.16 20.58-22.72 3.3c-6.03.86-11.06 5.09-12.94 10.89s-.31 12.16 4.06 16.41l16.47 16.03-3.91 22.62c-1.03 6 1.44 12.06 6.38 15.66 4.94 3.58 11.5 4.05 16.88 1.2l20.28-10.69 20.28 10.69a16.055 16.055 0 0 0 16.88-1.21c4.94-3.59 7.41-9.66 6.38-15.66l-3.91-22.62 16.47-16.03c4.38-4.25 5.94-10.61 4.06-16.41s-6.91-10.03-12.94-10.89l-22.72-3.3-10.16-20.58c-5.37-10.93-23.31-10.93-28.68.01zm24.22 39.41l22.12 3.2-16.03 15.6 3.78 22.02-19.75-10.41-19.75 10.41 3.78-22.02-16.03-15.6 22.12-3.2 9.88-20.03 9.88 20.03z"]
  },
      LN = {
    prefix: "fal",
    iconName: "rabbit",
    icon: [512, 512, [], "f708", "M505.92 450.8a33.63 33.63 0 0 0-2.09-2.96L389.44 304h1.92c48.89 0 88.66-39.77 88.66-88.65 0-28.56-13.88-55.53-37.12-72.14-.61-.43-1.23-.85-1.87-1.24l-24.69-15.15c.27-.97.54-1.94.8-2.91C431.04 71.99 431.09 12.54 389.5 1.4 386.03.47 382.45 0 378.84 0 361.27 0 347.12 10.35 336 24.48 324.88 10.35 310.74.01 293.17 0h-.02c-3.6 0-7.19.47-10.65 1.4-41.6 11.14-41.55 70.59-27.64 122.52 2.3 8.58 5.03 16.98 8.17 25.11-2.69 6.53-4.63 13.43-5.81 20.63-.82 5.04-1.24 10.2-1.24 15.34v41.67c-67.32 11.34-122.72 57.92-146.87 119.97C98.03 339.8 85.33 336 71.97 336c-19.23 0-37.32 7.49-50.92 21.09-28.07 28.07-28.07 73.75 0 101.82C34.65 472.51 52.74 480 71.97 480c10.32 0 19.99-2.86 29.12-6.96 9.77 22.88 32.48 38.96 58.89 38.96H320c17.68 0 32-14.33 32-32 0-23.25-12.46-43.64-31.06-54.85l15.81-9.88 65.11 80.17c7.51 10.42 19.44 16.56 32.42 16.56H472c14.54 0 27.94-7.9 34.99-20.61 7.05-12.71 6.63-28.27-1.07-40.59zM95.97 416v23.03c-7.13 5.55-15.41 8.97-24 8.97-10.24 0-20.48-3.91-28.29-11.72-15.62-15.62-15.62-40.95 0-56.57C51.5 371.9 61.73 368 71.97 368c10 0 19.95 3.86 27.69 11.32-2.32 11.89-3.69 24.12-3.69 36.68zM472 480h-37.72c-2.76 0-5.32-1.42-6.79-3.76l-83.73-103.09L223.99 448H288c17.66 0 32 14.36 32 32H159.98c-17.68 0-32-14.33-32-32v-32c0-88.37 71.64-160 160.02-160v-71.01c0-3.47.28-6.87.82-10.19 1.53-9.35 4.93-17.49 9.61-24.3-4.77-10.19-9.16-21.9-12.64-34.87-11.32-42.25-9.08-79.55 5-83.32.77-.21 1.56-.31 2.37-.31 13.62 0 32.03 28.8 42.84 67.4C346.82 60.8 365.22 32 378.84 32c.81 0 1.6.1 2.37.31 14.08 3.77 16.32 41.08 5 83.32-2.41 9-5.3 17.34-8.41 25.11l46.48 28.51a56.632 56.632 0 0 1 23.72 46.1c0 31.29-25.37 56.65-56.66 56.65H352v36.34l126.78 159.42c3.33 5.33-.5 12.24-6.78 12.24zM368 192c0-8.84-7.16-16-16-16s-16 7.16-16 16 7.16 16 16 16 16-7.16 16-16z"]
  },
      AN = {
    prefix: "fal",
    iconName: "rabbit-fast",
    icon: [640, 512, [], "f709", "M511.99 223.99c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16c0-8.83-7.16-16-16-16zm90.89-32.78c-.61-.43-58.52-35.99-58.52-35.99-2.54-1.57-9.73-5.07-18.35-7.52a261.57 261.57 0 0 0-4.89-22.02c-5.89-21.97-28.67-93.67-74.52-93.68h-.01c-37.96 0-44.2 41.84-44.49 43.33-32.09-17.15-55.46-13.15-69.7 1.09-8.71 8.71-20.55 28.35-4.36 63.28-31.09-16.38-61.55-27.7-88.06-27.7-45.73 0-86.28 18.33-117.89 52.43C108.58 151.29 90.85 144 71.97 144c-19.23 0-37.32 7.49-50.91 21.09-28.07 28.07-28.07 73.75 0 101.82C34.66 280.51 52.74 288 71.98 288c12.73 0 24.8-3.57 35.51-9.8 3.59 6.33 7.69 12.45 12.83 18.02l54.04 58.54-25.01 13.52a47.925 47.925 0 0 0-21.38 39.94v23.73c0 17.3 8.94 32.83 23.91 41.51 7.53 4.36 15.81 6.55 24.1 6.55 8.16 0 16.34-2.12 23.81-6.39l55.19-31.53 25.49 27.61a32.008 32.008 0 0 0 23.52 10.29H464c17.68 0 32-14.33 32-32 0-35.29-28.71-64-64-64h-48l70.4-32h96.96c48.88 0 88.65-39.77 88.65-88.65-.01-28.56-13.89-55.53-37.13-72.13zM96.26 246.93c-24.53 19.16-46.88 3.04-52.58-2.65-15.62-15.62-15.62-40.95 0-56.57 15.61-15.61 40.95-15.63 56.57 0 1.31 1.31 2.21 2.83 3.25 4.27-7.81 17.43-10.34 36.49-7.24 54.95zm87.65 198.9c-10.53 6.09-23.94-1.52-23.94-13.89v-23.73c0-5.36 2.66-10.34 5.84-12.55L196.74 379l35.96 38.96-48.79 27.87zm367.44-125.84H447.99l-64 26.67v-2.26c0-49.75-33.41-94.03-81.22-107.68l-42.38-12.11c-20.46-5.8-29.09 24.97-8.81 30.78l42.38 12.11c34.19 9.75 58.04 41.37 58.04 76.9v71.59h80c17.66 0 32 14.36 32 32H303.98L143.83 274.51c-22.36-24.22-22.66-61.37-.81-86.06 20.15-22.76 51.33-44.45 96.96-44.45 57.33 0 152.74 75.22 208.01 111.99 0-31.16-.53-30.77 3.54-43.01-15.31-3.53-37.75-17.86-59.17-39.28-30.93-30.92-47.64-64.35-37.33-74.65 10.74-10.74 45.14 7.8 74.66 37.33 3.25 3.25 6.25 6.54 9.18 9.81-11.63-44.51-8.08-82.19 7.72-82.19 13.94 0 32.92 30.05 43.61 69.97 4.1 15.28 6.36 29.86 6.98 42.49 14.17-1.01 24.77 3.23 30.44 6.03l56.65 34.75a56.632 56.632 0 0 1 23.72 46.1c.01 31.29-25.36 56.65-56.64 56.65z"]
  },
      NN = {
    prefix: "fal",
    iconName: "racquet",
    icon: [640, 512, [], "f45a", "M615.5 59.6C560.6-17.9 433.3-19.2 332.7 52c-57.2 40.5-94.4 96-106.5 150.6-10.7 48.2-34.6 91.7-66.1 129.2-17.9-10-32.2.2-33.9 1.4L13.6 412c-14.4 10.1-18 30-7.8 44.5l29.4 41.9c9.9 14.1 29.7 18.2 44.5 7.8l112.6-78.8c9.5-6.7 13.7-17.6 13-28.4 36-13.7 73.8-21.7 112.3-21.7 31.6 0 112.3 21.8 211.5-48.4 101.8-72.2 140.6-192.8 86.4-269.3zM61.3 480l-29.4-41.8 112.6-78.8 29.4 41.9L61.3 480zm130-109.6l-9.7-13.9c18.7-21.7 34.8-44.9 47.4-69.6 11 33.1 29.1 49.8 44.4 61.5-27.6 3.9-55.2 11.5-82.1 22zm319.2-67.6c-85.6 60.6-194 62.4-238.3-.1-43.9-62-8.5-162.7 79-224.7 84.7-60 193.6-63.1 238.3 0 42 59.4 11.1 161.1-79 224.8z"]
  },
      gN = {
    prefix: "fal",
    iconName: "radar",
    icon: [512, 512, [], "e024", "M503.99585,264.19238C499.67236,397.36719,390.32422,504,256.06445,504,113.42725,504-1.092,383.64551,8.56958,238.97461c8.21411-122.999,108.14771-222.498,231.19507-230.44727,69.12842-4.46582,132.34009,19.71875,179.76977,61.42188l35.61524-35.60547a8.00327,8.00327,0,0,1,11.31689,0L477.78,45.65625a7.99914,7.99914,0,0,1-.00049,11.31348L265.03735,269.65625a8.003,8.003,0,0,1-11.31738,0L242.40649,258.3457a7.999,7.999,0,0,1,0-11.31445l45.89478-45.88281A62.51727,62.51727,0,0,0,256.06445,192a64.02183,64.02183,0,1,0,63.63306,71.02637A7.92009,7.92009,0,0,1,327.59277,256h16.08716a8.07465,8.07465,0,0,1,8.00928,8.82227,96.02921,96.02921,0,0,1-191.6311-10.73633c.93481-47.99121,38.821-88.7041,86.584-93.60156,24.45117-2.50684,46.55884,4.9082,64.52832,17.80078L345.228,144.23633C320.63379,124.48633,289.99316,112,256.06445,112c-70.7351,0-129.41064,51.33594-141.47021,118.63477,7.9414,5.82421,13.437,14.76367,13.437,25.36523,0,10.59961-5.49561,19.541-13.437,25.36523A143.92586,143.92586,0,0,0,230.69263,397.43359C236.51831,389.49414,245.46,384,256.06445,384c10.60425,0,19.5459,5.49414,25.37183,13.43359,64.83618-11.6123,114.85986-66.457,118.45776-133.668A8.05439,8.05439,0,0,1,407.866,256h16.031a7.97388,7.97388,0,0,1,8.02442,8.21484c-3.84912,83.64551-66.17969,151.876-147.02735,165.22461a31.67056,31.67056,0,0,1-57.65942,0A175.8776,175.8776,0,0,1,82.58008,284.82227a31.65708,31.65708,0,0,1,0-57.64649C96.3667,143.7168,168.68042,80,256.06445,80c42.8274,0,81.55811,15.9082,112.06226,41.34375l28.65576-28.64844C358.93091,60.02539,309.87915,40,256.06445,40,128.794,40,26.87354,150.583,41.38818,280.68848c11.05469,99.09082,90.85987,178.87695,189.97608,189.93164C358.82837,484.83594,467.561,387.37988,471.98071,263.81934A8.00326,8.00326,0,0,1,479.93213,256h16.01269A8.02725,8.02725,0,0,1,503.99585,264.19238Z"]
  },
      HN = {
    prefix: "fal",
    iconName: "radiation",
    icon: [496, 512, [], "f7b9", "M247.9 320c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm0-96c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zm51.2 113.2c-14.9 9.2-32.4 14.8-51.2 14.8s-36.3-5.6-51.2-14.8L133.8 437c-10.2 16.2-4.2 38.2 13.5 45.9C178 496.4 212 504 247.9 504s69.9-7.6 100.7-21.1c17.6-7.7 23.7-29.7 13.5-45.9l-63-99.8zM247.9 472c-30.4 0-59.8-6.2-86.8-18.1l47.9-76c12.6 4 25.7 6.1 38.8 6.1 13.3 0 26.4-2.1 39-6.1l48.6 75.8c-27.7 12.1-57.1 18.3-87.5 18.3zM32.5 256H151c0-34.3 18.3-64.2 45.7-81.2l-62.8-99.6c-6.2-9.8-17-15.3-27.8-15.3-7.1 0-14.2 2.3-20.1 7.3-45.2 38-76.7 91.7-85.7 152.5-2.9 19.2 12.6 36.3 32.2 36.3zm73.9-163.8l47.9 75.8c-15.2 15.7-26 35-31.5 56H32.5l-.3.4c7.6-51.6 34.2-98.7 74.2-132.2zM344.8 256h118.5c19.6 0 35.1-17.1 32.3-36.3-9-60.9-40.5-114.5-85.7-152.5-5.9-4.9-13-7.3-20.1-7.3-10.8 0-21.6 5.4-27.8 15.3l-62.8 99.6c27.3 17 45.6 46.9 45.6 81.2zm44.1-164.4c40.5 34.1 67 81.2 74.4 132.4H373c-5.5-21.1-16.4-40.3-31.6-56.1l47.5-76.3z"]
  },
      VN = {
    prefix: "fal",
    iconName: "radiation-alt",
    icon: [496, 512, [], "f7ba", "M217 256c0 17.1 13.9 31 31 31s31-13.9 31-31-13.9-31-31-31-31 13.9-31 31zm31 248c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-464c119.1 0 216 96.9 216 216s-96.9 216-216 216S32 375.1 32 256 128.9 40 248 40zM69.3 264.2c4.4 4.6 10.6 7.3 17 7.3h99.8c-1.2-5-2.1-10.1-2.1-15.5 0-28.4 18.7-52.3 44.4-60.6l-52.7-84.3c-3.4-5.4-9-9.2-15.2-10.5-1.5-.3-3.1-.5-4.7-.5-4.7 0-9.3 1.4-13.2 4.1-47.9 33.2-76.9 85.3-79.7 142.9-.3 6.3 2 12.5 6.4 17.1zm84.2-128.3l30.5 48.8c-15.9 14.2-26.8 33.4-30.5 54.8H95.7c4.3-40.9 24.9-77.8 57.8-103.6zM312 256c0 5.4-.9 10.5-2.1 15.5h99.8c6.4 0 12.6-2.7 17-7.3s6.7-10.8 6.4-17.1c-2.8-57.5-31.8-109.6-79.7-142.9-3.9-2.7-8.5-4.1-13.2-4.1-1.5 0-3.1.2-4.7.5-6.3 1.3-11.8 5.1-15.2 10.5l-52.7 84.3c25.7 8.3 44.4 32.1 44.4 60.6zm30.5-120.1c32.8 25.7 53.5 62.7 57.9 103.5h-57.8c-3.7-21.4-14.6-40.6-30.5-54.8l30.4-48.7zM294 300.4c-11.6 12.1-27.9 19.6-46 19.6s-34.4-7.6-46-19.7l-52.5 84.1c-3.4 5.4-4.5 12.1-2.9 18.2 1.5 6.1 5.6 11.4 11 14.5 27.8 15.9 59.1 23.7 90.4 23.7s62.6-7.9 90.5-23.7c5.4-3.1 9.4-8.3 10.9-14.4 1.6-6.2.5-12.8-2.8-18.2L294 300.4zm-46 108.4c-23.1 0-45.9-5.2-66.5-15.2l30.4-48.6c11.3 4.6 23.5 7 36.1 7s24.8-2.4 36.1-7l30.4 48.6c-20.5 10-43.4 15.2-66.5 15.2z"]
  },
      xN = {
    prefix: "fal",
    iconName: "radio",
    icon: [512, 512, [], "f8d7", "M216 304H72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm-16 64H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM88 272h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm360-144H184.51L506.3 31a8 8 0 0 0 5.36-10L507 5.69a8 8 0 0 0-10-5.35L73.56 128H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zm32 320a32 32 0 0 1-32 32H64a32 32 0 0 1-32-32V192a32 32 0 0 1 32-32h384a32 32 0 0 1 32 32zM352 224a96 96 0 1 0 96 96 96 96 0 0 0-96-96zm0 160a64 64 0 1 1 64-64 64.07 64.07 0 0 1-64 64z"]
  },
      wN = {
    prefix: "fal",
    iconName: "radio-alt",
    icon: [512, 512, [], "f8d8", "M448 128H184.51L506.3 31a8 8 0 0 0 5.36-10L507 5.69a8 8 0 0 0-10-5.35L73.56 128H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zm32 320a32 32 0 0 1-32 32H64a32 32 0 0 1-32-32V256h448zm0-224H32v-32a32 32 0 0 1 32-32h384a32 32 0 0 1 32 32zM216 384H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm152 64a80 80 0 1 0-80-80 80 80 0 0 0 80 80zm0-128a48 48 0 1 1-48 48 48.05 48.05 0 0 1 48-48zM72 352h176a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8z"]
  },
      yN = {
    prefix: "fal",
    iconName: "rainbow",
    icon: [576, 512, [], "f75b", "M288 224.4c-52.9.1-96 42.6-96 95.5V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V319.9c0-35.3 28.8-63.6 64-63.7 35.2 0 64 28.4 64 63.7V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V319.9c0-53-43.1-95.5-96-95.5zM288 32C129.2 32 0 161 0 319.9V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V319.9C32 178.6 146.9 64.1 288 64c141.1 0 256 114.6 256 255.9V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V319.9C576 161 446.8 32 288 32zm0 95.8c-105.9 0-192 86.1-192 192V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V319.9c0-88.3 71.8-159.9 160-159.9s160 71.6 160 159.9V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V319.9c0-106-86.1-192-192-192.1z"]
  },
      bN = {
    prefix: "fal",
    iconName: "raindrops",
    icon: [448, 512, [], "f75c", "M406.6 252.7c-18.4-25.7-39.2-55-52.6-99.4-4.3-15-17.8-25.1-33.6-25.3-14.4-.3-29.6 10-34.2 25.2-13.4 44.3-34.2 73.6-52.6 99.5-21.3 30-41.5 58.4-41.5 100 0 70.2 57.4 127.3 128 127.3s128-57.1 128-127.3c-.1-41.8-20.2-70.1-41.5-100zM320 448c-52.9 0-96-42.7-96-95.3 0-31.4 15.7-53.5 35.6-81.5 18.8-26.5 42.2-59.4 57.1-108.7.2-.8.8-2.5 3.2-2.5 1.3.5 2.8.7 3.2 2.1l.1.3c15 49.5 38.4 82.4 57.2 108.8 20.6 28.9 35.5 49.8 35.5 81.4.1 52.7-43 95.4-95.9 95.4zm-80-306.1c0-21.4-9.8-35.8-19.2-49.8-7.9-11.6-16-23.6-21.4-42.2-2.9-10.6-12.2-17.8-23.1-17.9-12.4-.1-20.5 7-23.6 17.8-5.3 18.6-13.5 30.7-21.4 42.3-9.5 14-19.3 28.5-19.3 49.8 0 36.4 28.7 66.1 64 66.1s64-29.7 64-66.1zM176 176c-17.7 0-32-15.3-32-34.1 0-11 4.7-18.5 13.8-31.9 5.7-8.5 12.4-18.3 18.2-31.2 5.8 12.9 12.5 22.8 18.3 31.2 9 13.3 13.7 20.7 13.7 31.8 0 18.9-14.3 34.2-32 34.2zm-88.6 49.9c-2.9-10.6-12.2-17.8-23.1-17.9-10.1 1.2-20.5 7-23.6 17.8-5.3 18.6-13.5 30.7-21.4 42.3C9.8 282.1 0 296.6 0 317.9 0 354.3 28.7 384 64 384s64-29.7 64-66.1c0-21.4-9.8-35.8-19.2-49.8-7.9-11.6-16-23.6-21.4-42.2zM64 352c-17.7 0-32-15.3-32-34.1 0-11 4.7-18.5 13.8-31.9 5.7-8.5 12.4-18.3 18.2-31.2 5.8 12.9 12.5 22.8 18.3 31.2 9 13.3 13.7 20.7 13.7 31.8 0 18.9-14.3 34.2-32 34.2z"]
  },
      SN = {
    prefix: "fal",
    iconName: "ram",
    icon: [640, 512, [], "f70a", "M496 96c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm117.31 11.61L576 89.27V80c0-26.47-21.53-48-48-48h-83.92C421.67 12.19 392.6 0 360.94 0c-55.25 0-100.16 43.04-104.16 97.29-13.17-1.89-26.9.05-38.37 6.79-18.31-10.89-43.09-10.45-61.16 1-12.28-6.66-26.56-8.7-40.88-5.67-17.03 3.84-31.41 14.97-39.62 30.16-16.94.88-33.06 9.11-44.12 23.12-10.81 13.95-15.06 31.86-12.12 48.95C7.62 213.09 0 229.81 0 247.69c0 17.91 7.5 34.59 20.19 46-3.06 17.3 1.25 35.27 12.12 48.98 10.78 14.02 26.78 22.3 43.78 23.16 4.83 9.1 11.99 16.48 20.41 21.98.14 3.96.33 7.93 1.26 11.81l21.12 87.86C122.34 501.86 135.21 512 150 512h57.53c20.95 0 36.12-19.76 31.02-39.86l-20.29-80.07a57.854 57.854 0 0 0 29.3 7.93c10.62 0 20.88-2.84 29.91-8.17 9.16 5.31 20.62 8.56 31.84 8.02 3.67-.12 7.17-1 10.69-1.77V480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V356.83c5.69-3.63 11.01-7.98 15.38-13.51 10.81-13.95 15.06-31.86 12.12-48.95 12.88-11.45 20.5-28.17 20.5-46.05 0-8.54-1.81-16.77-4.97-24.31h92.63c14.91 0 28.81-8.03 36.28-21.02 17.97-31.55 20.06-45.08 20.06-52.52 0-18.35-10.22-34.77-26.69-42.86zM150 480l-19.82-82.44c9.14-.19 18.15-2.34 26.38-6.72 9.03 5.79 19.79 8.77 30.64 8.92L207.53 480H150zm266 0h-64v-84.09c8.85 2.29 18.22 2.72 27.62.68 15.13-3.41 27.89-12.78 36.38-25.42V480zm176.16-292.92c-1.75 3.08-4.94 4.92-8.5 4.92H444.55c-.06 3.56-.52 7.18-1.95 10.81l-5.16 13.02 12.22 6.84c18.61 10.44 19.64 40.06-.31 51.28l-12.22 6.84 5.16 13.02c8.51 21.38-9.05 44.04-30.59 40.3l-14.16-2.52-4.03 13.78c-5.48 18.83-28.59 28.04-44.84 13.67l-11.44-10.14-10.66 10.95c-8.68 8.94-25.64 12.3-38.12.45l-11.06-10.53-11.03 10.58c-10.31 9.92-27.25 9.91-37.16.16l-11.06-10.92-11.22 10.77c-10.59 10.09-28.12 9.72-38-.47l-10.44-10.83-11.44 9.77c-17.44 14.83-39.91 4.28-45.06-13.95L98 330.92l-14.25 2.56c-21.2 3.8-38.89-18.69-30.34-40.3l5.16-13.02-12.22-6.84c-18.61-10.44-19.64-40.06.31-51.28l12.22-6.84-5.16-13.02c-8.56-21.51 9.19-44.04 30.59-40.3l14.16 2.52 4.03-13.78c5.54-19.02 28.75-27.9 44.84-13.67l11.44 10.14 10.66-10.95c9.91-10.23 27.62-10.58 37.56-.69l11.09 10.97 11.25-10.77c8.42-8.09 21.16-9.19 31.28-4.01 11.35 34.96 43.84 60.46 82.54 60.46 39.98 0 72.5-32.39 72.84-72.3v-1.33c-.34-28.95-20.7-53.18-47.9-59.32-.12-.03-2.69-.6-4.26-.84-4.99-.78-9.59 2.87-9.59 7.92V82.5c0 3.68 2.5 6.94 6.1 7.69.04.01.07 0 .11 0 .01 0 0 .04.01.05 13.44 2.76 23.59 14.69 23.59 28.95 0 22.56-18.34 40.92-40.91 40.92-30.41 0-55.16-24.75-55.16-55.16C288 64.72 320.72 32 360.94 32c27.84 0 53.29 12.34 70.88 32H528c8.81 0 16 7.17 16 16v29.17l55.19 27.16c5.44 2.67 8.81 8.09 8.81 14.14 0 3.28-3.34 14.7-15.84 36.61z"]
  },
      TN = {
    prefix: "fal",
    iconName: "ramp-loading",
    icon: [384, 512, [], "f4d4", "M384 352V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32v320c0 17.7 14.3 32 32 32h6.9L3.2 467.4C-5.9 488.5 9.6 512 32.6 512h318.9c23 0 38.5-23.5 29.4-44.6L345.1 384h6.9c17.7 0 32-14.3 32-32zm-32.6 128H32.6l68.6-160h181.7l68.5 160zm-20-128l-19.1-44.6c-5-11.8-16.6-19.4-29.4-19.4H101.1c-12.8 0-24.4 7.6-29.4 19.4L52.6 352H32V32h320v320h-20.6z"]
  },
      DN = {
    prefix: "fal",
    iconName: "random",
    icon: [512, 512, [], "f074", "M0 128v-8c0-6.6 5.4-12 12-12h105.8c3.3 0 6.5 1.4 8.8 3.9l89.7 97-21.8 23.6L109 140H12c-6.6 0-12-5.4-12-12zm502.6 278.6l-64 64c-20.1 20.1-54.6 5.8-54.6-22.6v-44h-25.7c-3.3 0-6.5-1.4-8.8-3.9l-89.7-97 21.8-23.6L367 372h17v-52c0-28.5 34.5-42.7 54.6-22.6l64 64c12.5 12.5 12.5 32.7 0 45.2zm-19.8-25.4l-64-64c-2.5-2.5-6.8-.7-6.8 2.8v128c0 3.6 4.3 5.4 6.8 2.8l64-64c1.6-1.5 1.6-4.1 0-5.6zm19.8-230.6l-64 64c-20.1 20.1-54.6 5.8-54.6-22.6v-52h-17L126.6 400.1c-2.3 2.5-5.5 3.9-8.8 3.9H12c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h97l240.4-260.1c2.3-2.5 5.5-3.9 8.8-3.9H384V64c0-28.5 34.5-42.7 54.6-22.6l64 64c12.5 12.5 12.5 32.7 0 45.2zm-19.8-25.4l-64-64c-2.5-2.5-6.8-.7-6.8 2.8v128c0 3.6 4.3 5.4 6.8 2.8l64-64c1.6-1.5 1.6-4.1 0-5.6z"]
  },
      jN = {
    prefix: "fal",
    iconName: "raygun",
    icon: [576, 512, [], "e025", "M112,159.99684A16.00015,16.00015,0,1,0,128,175.997,16.00087,16.00087,0,0,0,112,159.99684ZM552.84375,97.69941l-96,47.99457A16.03507,16.03507,0,0,0,448,160.00661v-.00977H416V79.99613a16,16,0,1,0-32,0v80.00071H352V47.99584a16,16,0,1,0-32,0v49.7856A111.56316,111.56316,0,0,0,239.98047,63.996H195.40625L54.5,1.37042A15.99873,15.99873,0,0,0,32,15.99555l-.02734,81.8191A111.51592,111.51592,0,0,0,0,175.997c0,60.4771,48.03125,109.42481,107.99219,111.59475L38.4668,407.962a47.9323,47.9323,0,0,0,17.59375,65.57871l55.40625,31.99248a47.91657,47.91657,0,0,0,65.59375-17.59L304.377,267.41187A112.314,112.314,0,0,0,320,254.21253v49.78561a16,16,0,1,0,32,0v-112.001h32v80.00072a16,16,0,1,0,32,0V191.99713h32v-.041a15.97529,15.97529,0,0,0,8.84375,14.31067l96,48.0434A16.01141,16.01141,0,0,0,576,239.99951V112.01009A16.01117,16.01117,0,0,0,552.84375,97.69941ZM64,40.60515,116.61328,63.996h-4.59375A110.97556,110.97556,0,0,0,63.98438,75.20116Zm85.35742,431.32613a15.91027,15.91027,0,0,1-21.88672,5.89849L72.07617,445.84316a15.93689,15.93689,0,0,1-5.89844-21.883L144.71094,287.998h95.26953c.02734,0,.05078-.00781.07812-.00781h15.49024Zm90.62305-215.93357H112.01953a80.00072,80.00072,0,1,1,0-160.00144H239.98047a80.00072,80.00072,0,1,1,0,160.00144ZM544,214.095l-64-32.02764v-12.172L544,137.899ZM176,159.99684A16.00015,16.00015,0,1,0,192,175.997,16.00087,16.00087,0,0,0,176,159.99684Zm64,0A16.00015,16.00015,0,1,0,256,175.997,16.00087,16.00087,0,0,0,240,159.99684Z"]
  },
      EN = {
    prefix: "fal",
    iconName: "receipt",
    icon: [448, 512, [], "f543", "M344 240H104c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0 96H104c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM418.1 0c-5.8 0-11.8 1.8-17.3 5.7L357.3 37 318.7 9.2c-8.4-6-18.2-9.1-28.1-9.1-9.8 0-19.6 3-28 9.1L224 37 185.4 9.2C177 3.2 167.1.1 157.3.1s-19.6 3-28 9.1L90.7 37 47.2 5.7C41.8 1.8 35.8 0 29.9 0 14.4.1 0 12.3 0 29.9v452.3C0 499.5 14.3 512 29.9 512c5.8 0 11.8-1.8 17.3-5.7L90.7 475l38.6 27.8c8.4 6 18.2 9.1 28.1 9.1 9.8 0 19.6-3 28-9.1L224 475l38.6 27.8c8.4 6 18.3 9.1 28.1 9.1s19.6-3 28-9.1l38.6-27.8 43.5 31.3c5.4 3.9 11.4 5.7 17.3 5.7 15.5 0 29.8-12.2 29.8-29.8V29.9C448 12.5 433.7 0 418.1 0zM416 477.8L376 449l-18.7-13.5-18.7 13.5-38.6 27.8c-2.8 2-6 3-9.3 3-3.4 0-6.6-1.1-9.4-3.1L242.7 449 224 435.5 205.3 449l-38.6 27.8c-2.8 2-6 3-9.4 3-3.4 0-6.6-1.1-9.4-3.1L109.3 449l-18.7-13.5L72 449l-40 29.4V34.2L72 63l18.7 13.5L109.4 63 148 35.2c2.8-2 6-3 9.3-3 3.4 0 6.6 1.1 9.4 3.1L205.3 63 224 76.5 242.7 63l38.6-27.8c2.8-2 6-3 9.4-3 3.4 0 6.6 1.1 9.4 3.1L338.7 63l18.7 13.5L376 63l40-28.8v443.6zM344 144H104c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      kN = {
    prefix: "fal",
    iconName: "record-vinyl",
    icon: [512, 512, [], "f8d9", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-119.1 0-216-96.9-216-216S136.9 40 256 40s216 96.9 216 216-96.9 216-216 216zm0-320a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 176a72 72 0 1 1 72-72 72.08 72.08 0 0 1-72 72zm0-96a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"]
  },
      IN = {
    prefix: "fal",
    iconName: "rectangle-landscape",
    icon: [512, 512, [], "f2fa", "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm16 336c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v288z"]
  },
      ON = {
    prefix: "fal",
    iconName: "rectangle-portrait",
    icon: [384, 512, [], "f2fb", "M384 464V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48z"]
  },
      QN = {
    prefix: "fal",
    iconName: "rectangle-wide",
    icon: [640, 512, [], "f2fc", "M592 96H48c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48zm16 272c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h544c8.8 0 16 7.2 16 16v224z"]
  },
      ZN = {
    prefix: "fal",
    iconName: "recycle",
    icon: [512, 512, [], "f1b8", "M201.728 62.049l-43.385 69.459c-3.511 5.622-10.916 7.332-16.537 3.819l-6.781-4.237c-5.619-3.511-7.329-10.912-3.819-16.533l43.387-69.48c37.575-60.12 125.263-60.084 162.816 0l46.217 74.015 12.037-52.14c1.491-6.458 7.934-10.484 14.392-8.993l7.794 1.799c6.458 1.491 10.484 7.934 8.993 14.392l-21.633 93.702c-1.491 6.458-7.934 10.484-14.392 8.993l-93.702-21.633c-6.458-1.491-10.484-7.934-8.993-14.392l1.799-7.794c1.491-6.458 7.934-10.484 14.392-8.993l52.202 12.052-46.251-74.047c-25.002-40.006-83.467-40.099-108.536.011zm295.56 239.071l-52.939-84.78c-3.511-5.623-10.916-7.334-16.538-3.821l-6.767 4.228c-5.62 3.512-7.329 10.913-3.819 16.534l52.966 84.798c26.605 42.568-4.054 97.92-54.272 97.92H310.627l37.858-37.858c4.686-4.686 4.686-12.284 0-16.97l-5.656-5.656c-4.686-4.686-12.284-4.686-16.97 0l-68 68c-4.686 4.686-4.686 12.284 0 16.971l68 68c4.686 4.686 12.284 4.686 16.97 0l5.656-5.657c4.686-4.686 4.686-12.284 0-16.971L310.627 448H415.88c75.274 0 121.335-82.997 81.408-146.88zM41.813 318.069l55.803-89.339 12.044 52.166c1.491 6.458 7.934 10.484 14.392 8.993l7.794-1.799c6.458-1.491 10.484-7.934 8.993-14.392l-21.633-93.702c-1.491-6.458-7.934-10.484-14.392-8.993l-93.702 21.633c-6.458 1.491-10.484 7.934-8.993 14.392l1.799 7.794c1.491 6.458 7.934 10.484 14.392 8.993l52.193-12.05-55.796 89.355C-25.188 364.952 20.781 448 96.115 448H196c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12H96.078c-50.199 0-80.887-55.335-54.265-97.931z"]
  },
      UN = {
    prefix: "fal",
    iconName: "redo",
    icon: [512, 512, [], "f01e", "M492 8h-10c-6.627 0-12 5.373-12 12v110.625C426.804 57.047 346.761 7.715 255.207 8.001 118.82 8.428 7.787 120.009 8 256.396 8.214 393.181 119.166 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.354-12.561.482-17.433l-7.069-7.069c-4.503-4.503-11.749-4.714-16.482-.454C361.218 449.238 311.065 470 256 470c-117.744 0-214-95.331-214-214 0-117.744 95.331-214 214-214 82.862 0 154.737 47.077 190.289 116H332c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12z"]
  },
      BN = {
    prefix: "fal",
    iconName: "redo-alt",
    icon: [512, 512, [], "f2f9", "M457.4 9.4l-50.1 50.1C365.4 27.2 312.8 8 255.8 8 119.2 8.1 7.7 119.8 8 256.5S119.2 504 256 504c63.9 0 122.2-24.2 166.2-63.9 5.1-4.6 5.4-12.6.5-17.4l-7.1-7.1c-4.5-4.5-11.7-4.7-16.5-.5-39 35.1-89.4 54.9-143.1 54.9-118 0-214-95.6-214-214 0-118 95.6-214 214-214 46.5 0 90.7 14.9 127 41.7l-53.6 53.6c-20.1 20.1-5.9 54.6 22.6 54.6h128c17.7 0 32-14.3 32-32V32c0-28.5-34.6-42.7-54.6-22.6zM480 160H352L480 32z"]
  },
      RN = {
    prefix: "fal",
    iconName: "refrigerator",
    icon: [384, 512, [], "e026", "M336,0H48A48,48,0,0,0,0,48V464a48,48,0,0,0,48,48H336a48,48,0,0,0,48-48V48A48,48,0,0,0,336,0Zm16,464a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V192H256V376a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V192h64Zm0-304H288V104a8,8,0,0,0-8-8H264a8,8,0,0,0-8,8v56H32V48A16,16,0,0,1,48,32H336a16,16,0,0,1,16,16Z"]
  },
      YN = {
    prefix: "fal",
    iconName: "registered",
    icon: [512, 512, [], "f25d", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm216 248c0 118.663-96.055 216-216 216-118.663 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.663 0 216 96.055 216 216zM359.387 374.293c-56.637-104.76-51.795-95.919-53.681-99.047 27.113-11.899 44.118-39.432 44.118-72.825 0-57.934-36.794-80.198-93.917-80.198h-71.086c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h16.908c6.617 0 12-5.383 12-12v-94.854h51.111l54.004 100.532a11.983 11.983 0 0 0 10.57 6.321h19.416c9.1.001 14.878-9.717 10.557-17.706zm-93.371-127.528H213.73v-86.161h43.261c20.716 0 51.203 1.092 51.203 42.539-.001 27.314-15.768 43.622-42.178 43.622z"]
  },
      PN = {
    prefix: "fal",
    iconName: "remove-format",
    icon: [640, 512, [], "f87d", "M192 64h176l-44.56 133.68 25.35 20L400 64h176v56a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v21l32 25.19zm152 384h-72l44.55-133.64-25.35-20L240 448h-72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h176a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm293 37.31L23 1.8A7.86 7.86 0 0 0 11.79 3l-10 12.5A7.92 7.92 0 0 0 3 26.71l614 483.52a7.91 7.91 0 0 0 11.18-1.23l10-12.5a7.83 7.83 0 0 0-1.18-11.18z"]
  },
      FN = {
    prefix: "fal",
    iconName: "repeat",
    icon: [512, 512, [], "f363", "M512 256c0 88.225-71.775 160-160 160H110.628l68.201 68.201c4.686 4.686 4.686 12.284 0 16.971l-5.656 5.656c-4.686 4.686-12.284 4.686-16.971 0l-98.343-98.343c-4.686-4.686-4.686-12.284 0-16.971l98.343-98.343c4.686-4.686 12.284-4.686 16.971 0l5.656 5.656c4.686 4.686 4.686 12.284 0 16.971L110.628 384H352c70.579 0 128-57.421 128-128 0-28.555-9.403-54.952-25.271-76.268-3.567-4.792-3.118-11.462 1.106-15.686l5.705-5.705c5.16-5.16 13.678-4.547 18.083 1.271C499.935 186.438 512 219.835 512 256zM57.271 332.268C41.403 310.952 32 284.555 32 256c0-70.579 57.421-128 128-128h241.372l-68.201 68.201c-4.686 4.686-4.686 12.284 0 16.971l5.656 5.656c4.686 4.686 12.284 4.686 16.971 0l98.343-98.343c4.686-4.686 4.686-12.284 0-16.971L355.799 5.172c-4.686-4.686-12.284-4.686-16.971 0l-5.656 5.656c-4.686 4.686-4.686 12.284 0 16.971L401.372 96H160C71.775 96 0 167.775 0 256c0 36.165 12.065 69.562 32.376 96.387 4.405 5.818 12.923 6.432 18.083 1.271l5.705-5.705c4.225-4.224 4.674-10.893 1.107-15.685z"]
  },
      WN = {
    prefix: "fal",
    iconName: "repeat-1",
    icon: [512, 512, [], "f365", "M512 256c0 88.225-71.775 160-160 160H110.628l68.201 68.201c4.686 4.686 4.686 12.284 0 16.971l-5.656 5.656c-4.686 4.686-12.284 4.686-16.971 0l-98.343-98.343c-4.686-4.686-4.686-12.284 0-16.971l98.343-98.343c4.686-4.686 12.284-4.686 16.971 0l5.656 5.656c4.686 4.686 4.686 12.284 0 16.971L110.628 384H352c70.579 0 128-57.421 128-128 0-28.555-9.403-54.952-25.271-76.268-3.567-4.792-3.118-11.462 1.106-15.686l5.705-5.705c5.16-5.16 13.678-4.547 18.083 1.271C499.935 186.438 512 219.835 512 256zM57.271 332.268C41.403 310.952 32 284.555 32 256c0-70.579 57.421-128 128-128h241.372l-68.201 68.201c-4.686 4.686-4.686 12.284 0 16.971l5.656 5.656c4.686 4.686 12.284 4.686 16.971 0l98.343-98.343c4.686-4.686 4.686-12.284 0-16.971L355.799 5.172c-4.686-4.686-12.284-4.686-16.971 0l-5.656 5.656c-4.686 4.686-4.686 12.284 0 16.971L401.372 96H160C71.775 96 0 167.775 0 256c0 36.165 12.065 69.562 32.376 96.387 4.405 5.818 12.923 6.432 18.083 1.271l5.705-5.705c4.225-4.224 4.674-10.893 1.107-15.685zm172.224-29.275c0-6.444 3.401-9.847 9.847-9.847h17.365v-53.348c0-4.834.179-9.847.179-9.847h-.359s-1.79 3.939-3.938 5.729l-1.611 1.432c-4.655 4.298-9.489 4.117-13.786-.537l-4.654-5.013c-4.475-4.654-4.297-9.487.358-13.963l22.2-20.767c3.759-3.401 7.161-4.833 12.173-4.833h10.205c6.444 0 9.846 3.4 9.846 9.846v91.301h17.544c6.444 0 9.847 3.402 9.847 9.847v7.162c0 6.444-3.402 9.846-9.847 9.846h-65.522c-6.445 0-9.847-3.402-9.847-9.846v-7.162z"]
  },
      GN = {
    prefix: "fal",
    iconName: "repeat-1-alt",
    icon: [512, 512, [], "f366", "M54.027 327.713C40.129 307.242 32 282.553 32 256c0-70.579 57.421-128 128-128h160v63.969c0 29.239 36.192 43.177 55.785 21.407l72-79.968c10.952-12.169 10.953-30.644 0-42.814l-72-79.974C356.226-11.114 320 2.738 320 32.026V96H160C71.775 96 0 167.775 0 256c0 33.913 10.612 65.391 28.683 91.299 4.427 6.348 13.606 6.936 18.785 1.185l5.488-6.096c3.667-4.073 4.149-10.14 1.071-14.675zM352 32l72 80-72 80V32zm131.317 132.701c-4.427-6.348-13.606-6.936-18.785-1.185l-5.488 6.096c-3.667 4.073-4.149 10.14-1.071 14.675C471.871 204.758 480 229.447 480 256c0 70.579-57.421 128-128 128H192v-63.969c0-29.239-36.192-43.177-55.785-21.407l-72 79.969c-10.952 12.169-10.953 30.644 0 42.814l72 79.974C155.774 523.113 192 509.264 192 479.974V416h160c88.225 0 160-71.775 160-160 0-33.913-10.612-65.391-28.683-91.299zM160 480l-72-80 72-80v160zm69.495-177.007c0-6.444 3.401-9.847 9.847-9.847h17.365v-53.348c0-4.834.179-9.847.179-9.847h-.359s-1.79 3.939-3.938 5.729l-1.611 1.432c-4.655 4.298-9.489 4.117-13.786-.537l-4.654-5.013c-4.475-4.654-4.297-9.487.358-13.963l22.2-20.767c3.759-3.401 7.161-4.833 12.173-4.833h10.205c6.444 0 9.846 3.4 9.846 9.846v91.301h17.544c6.444 0 9.847 3.402 9.847 9.847v7.162c0 6.443-3.402 9.846-9.847 9.846h-65.522c-6.445 0-9.847-3.402-9.847-9.846v-7.162z"]
  },
      qN = {
    prefix: "fal",
    iconName: "repeat-alt",
    icon: [512, 512, [], "f364", "M54.027 327.713C40.129 307.242 32 282.553 32 256c0-70.579 57.421-128 128-128h160v63.969c0 29.239 36.192 43.177 55.785 21.407l72-79.968c10.952-12.169 10.953-30.644 0-42.814l-72-79.974C356.226-11.114 320 2.738 320 32.026V96H160C71.775 96 0 167.775 0 256c0 33.913 10.612 65.391 28.683 91.299 4.427 6.348 13.606 6.936 18.785 1.185l5.488-6.096c3.667-4.073 4.149-10.14 1.071-14.675zM352 32l72 80-72 80V32zm131.317 132.701c-4.427-6.348-13.606-6.936-18.785-1.185l-5.488 6.096c-3.667 4.073-4.149 10.14-1.071 14.675C471.871 204.758 480 229.447 480 256c0 70.579-57.421 128-128 128H192v-63.969c0-29.239-36.192-43.177-55.785-21.407l-72 79.969c-10.952 12.169-10.953 30.644 0 42.814l72 79.974C155.774 523.113 192 509.264 192 479.974V416h160c88.225 0 160-71.775 160-160 0-33.913-10.612-65.391-28.683-91.299zM160 480l-72-80 72-80v160z"]
  },
      JN = {
    prefix: "fal",
    iconName: "reply",
    icon: [576, 512, [], "f3e5", "M11.093 251.65l175.998 184C211.81 461.494 256 444.239 256 408v-87.84c154.425 1.812 219.063 16.728 181.19 151.091-8.341 29.518 25.447 52.232 49.68 34.51C520.16 481.421 576 426.17 576 331.19c0-171.087-154.548-201.035-320-203.02V40.016c0-36.27-44.216-53.466-68.91-27.65L11.093 196.35c-14.791 15.47-14.791 39.83 0 55.3zm23.127-33.18l176-184C215.149 29.31 224 32.738 224 40v120c157.114 0 320 11.18 320 171.19 0 74.4-40 122.17-76.02 148.51C519.313 297.707 395.396 288 224 288v120c0 7.26-8.847 10.69-13.78 5.53l-176-184a7.978 7.978 0 0 1 0-11.06z"]
  },
      KN = {
    prefix: "fal",
    iconName: "reply-all",
    icon: [576, 512, [], "f122", "M105.368 246.631l160.002 159.98c20.02 20.01 54.63 5.98 54.63-22.63v-71.15c121.58 4.36 148.9 28.23 121.2 126.42-8.35 29.59 25.5 52.21 49.69 34.51 51.57-37.71 85.11-90.99 85.11-155.97 0-152.9-140.5-177.23-256-181.07v-72.69c0-28.59-34.59-42.67-54.63-22.63l-160.002 159.97c-12.491 12.5-12.491 32.76 0 45.26zM128 224.001l160-160v104.1c130.165 1.345 256 18.265 256 149.69 0 65.1-40.49 107.16-72 130.21 40.979-145.267-38.329-166.574-184-167.9v103.9l-160-160zM9.372 201.373l160-159.974c13.467-13.467 33.495-11.506 45.189-.105L32 224.001l182.564 182.712c-11.699 11.403-31.738 13.347-45.191-.106l-160-159.978c-12.497-12.498-12.497-32.759-.001-45.256z"]
  },
      XN = {
    prefix: "fal",
    iconName: "republican",
    icon: [640, 512, [], "f75e", "M173 160.2l-27.4-4-12.2-24.8c-2.2-4.4-8.5-4.5-10.7 0l-12.2 24.8-27.4 4c-4.9.7-6.9 6.8-3.3 10.2l19.8 19.3-4.8 27.3c-.8 4.9 4.3 8.6 8.7 6.3l24.5-12.9 24.5 12.9c4.3 2.3 9.5-1.4 8.7-6.3l-4.7-27.3 19.8-19.3c3.5-3.5 1.6-9.5-3.3-10.2zm128 0l-27.4-4-12.2-24.8c-2.2-4.4-8.5-4.5-10.7 0l-12.2 24.8-27.4 4c-4.9.7-6.9 6.8-3.3 10.2l19.8 19.3-4.7 27.3c-.8 4.9 4.3 8.6 8.7 6.3l24.5-12.9 24.5 12.9c4.3 2.3 9.5-1.4 8.7-6.3l-4.7-27.3 19.8-19.3c3.4-3.5 1.5-9.5-3.4-10.2zM608 256h-32c-17.7 0-32 14.3-32 32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-48h128v48c0 26.5 21.5 48 48 48h64c22.3 0 40.9-15.3 46.3-35.9 24.4 26.2 60.9 41.1 100.9 34.3 54.6-9.2 92.9-59.6 92.9-115V288c-.1-17.7-14.4-32-32.1-32zM32 192c0-70.6 57.4-128 128-128h192c70.6 0 128 57.4 128 128v64H32v-64zm576 176c0 44.1-35.9 80-80 80s-80-35.9-80-80v-16h-32v80c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-80H128v80c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V288h448v80c0 26.5 21.5 48 48 48s48-21.5 48-48v-80h32v80zM429 160.2l-27.4-4-12.2-24.8c-2.2-4.4-8.5-4.5-10.7 0l-12.2 24.8-27.4 4c-4.9.7-6.9 6.8-3.3 10.2l19.8 19.3-4.7 27.3c-.8 4.9 4.3 8.6 8.7 6.3l24.5-12.9 24.5 12.9c4.3 2.3 9.5-1.4 8.7-6.3l-4.7-27.3 19.8-19.3c3.4-3.5 1.5-9.5-3.4-10.2z"]
  },
      _N = {
    prefix: "fal",
    iconName: "restroom",
    icon: [640, 512, [], "f7bd", "M328 0h-16c-4.4 0-8 3.6-8 8v496c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zM128 160c44.2 0 80-35.8 80-80S172.2 0 128 0 48 35.8 48 80s35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm32 144H96c-44.2 0-80 35.8-80 80v101.3C16 372 27.9 384 42.7 384H56v96c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32v-96h13.3c14.7 0 26.7-11.9 26.7-26.7V256c0-44.2-35.8-80-80-80zm48 176h-40v128H88V352H48v-96c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v96zm304-192c44.2 0 80-35.8 80-80S556.2 0 512 0s-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm126.1 327l-44.9-121.4C583.1 201.3 549.7 176 512 176s-71.1 25.3-81.2 61.6L385.9 359c-3.5 9.4-2.2 20 3.6 28.3 5.8 8.3 15.2 13.2 25.3 13.2H440v79.6c0 17.6 14.3 31.9 31.9 31.9H552c17.6 0 31.9-14.3 31.9-31.9v-79.6h25.2c10.1 0 19.5-4.9 25.3-13.2 5.8-8.3 7.2-18.9 3.7-28.3zm-86.1 9.5l.1 111.5h-80.2l.1-111.5h-56l45.3-121c6.7-23.8 27.4-39.5 50.8-39.5s44.1 15.7 50.8 39.5l45.3 121H552z"]
  },
      $N = {
    prefix: "fal",
    iconName: "retweet",
    icon: [640, 512, [], "f079", "M634.828 363.799l-98.343 98.343c-4.686 4.686-12.284 4.686-16.971 0l-98.343-98.343c-4.686-4.686-4.686-12.284 0-16.971l5.656-5.656c4.686-4.686 12.284-4.686 16.971 0l68.202 68.2V128H260.024a11.996 11.996 0 0 1-8.485-3.515l-8-8c-7.56-7.56-2.206-20.485 8.485-20.485H520c13.255 0 24 10.745 24 24v289.372l68.201-68.201c4.686-4.686 12.284-4.686 16.971 0l5.656 5.656c4.686 4.687 4.686 12.285 0 16.972zm-246.367 23.716a12.002 12.002 0 0 0-8.485-3.515H128V102.628l68.201 68.2c4.686 4.686 12.284 4.686 16.97 0l5.657-5.657c4.686-4.686 4.687-12.284 0-16.971l-98.343-98.343c-4.686-4.686-12.284-4.686-16.971 0L5.172 148.201c-4.686 4.686-4.686 12.285 0 16.971l5.657 5.657c4.686 4.686 12.284 4.686 16.97 0L96 102.628V392c0 13.255 10.745 24 24 24h267.976c10.691 0 16.045-12.926 8.485-20.485l-8-8z"]
  },
      cg = {
    prefix: "fal",
    iconName: "retweet-alt",
    icon: [640, 512, [], "f361", "M607.974 320H544V120c0-13.255-10.745-24-24-24H252.024c-10.998 0-16.202 13.562-8.028 20.919l8.889 8a12 12 0 0 0 8.028 3.081H512v192h-63.968c-29.239 0-43.177 36.192-21.407 55.785l79.969 72c12.169 10.952 30.644 10.953 42.814 0l79.974-72C651.113 356.226 637.264 320 607.974 320zM528 424l-80-72h160l-80 72zm-131.997-28.92l-8.889-8a12 12 0 0 0-8.028-3.08H128V192h63.968c29.239 0 43.177-36.192 21.407-55.785l-79.968-72c-12.169-10.952-30.644-10.953-42.814 0l-79.974 72C-11.114 155.774 2.738 192 32.026 192H96v200c0 13.255 10.745 24 24 24h267.976c10.998 0 16.202-13.562 8.027-20.92zM32 160l80-72 80 72H32z"]
  },
      eg = {
    prefix: "fal",
    iconName: "ribbon",
    icon: [448, 512, [], "f4d6", "M439.5 407.7L323.7 285.9l42.4-45.4c33.4-35.7 37.4-87.3 10.2-131.5l-39.5-64.1c-5.5-9-12.8-16.3-21.5-21.9C299.1 12.5 270.2 0 224 0c-46.1 0-75.1 12.5-91.2 22.9-8.8 5.6-16 13.1-21.5 22.1l-42.2 68.5c-25.1 40.7-19.9 91.8 13 127l44.2 47.3L8.4 407.9c-14.9 16.1-8.1 38.8 5.1 47.2l66.9 51.5c16.5 10.7 33.8 3.6 41.9-5l101.7-109 101.7 109c15.6 16.7 35.7 9 43 4.3l64.8-50c16.3-10.7 19.7-33.4 6-48.2zM328.4 92.3l20.6 33.4c19.7 32 17.3 67.6-6.3 92.9l-41.1 44-54.8-57.6 52-56.3c16-15.5 24.7-37 29.6-56.4zm-103.6 89.5l-45.1-47.4c26.7-8 62.2-8 88.9 0l-43.8 47.4zm-74.6-132C162.7 41.6 185.7 32 224 32s61.3 9.7 73.9 17.8c1.9 1.2 3 3.2 4.6 4.7-1 13.7-4.5 35.3-13.5 53.3-18.6-7.7-40.2-11.8-65-11.8-24.8 0-46.5 4.1-65.2 11.9-9.7-19.4-12.5-43-13.3-54.6 1.5-1.3 3-2.5 4.7-3.5zM98.9 480.5L31.6 430l116.5-118.8 54.1 58L98.9 480.5zm250.2-.8L105.4 218.6c-22.9-24.5-26.6-60-9.1-88.4l23.2-37.6c4.9 19.2 13.7 40.5 29.3 55.6L415 429.8l-65.9 49.9z"]
  },
      ag = {
    prefix: "fal",
    iconName: "ring",
    icon: [512, 512, [], "f70b", "M256 64C87.93 64 0 128.39 0 192v114.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V192c0-63.61-87.93-128-256-128zm224 242.13C480 358.1 388.01 416 256 416S32 358.1 32 306.13v-50.12C71.33 292.63 146.55 320 256 320s184.67-27.37 224-63.99v50.12zM89.32 255.97C130.3 236.37 189.74 224 256 224s125.7 12.37 166.68 31.97C381.67 275.59 322.29 288 256 288s-125.67-12.41-166.68-32.03zm364.88-19.31C411.3 210.2 345.06 192 256 192s-155.3 18.2-198.2 44.66C41.39 223.32 32 208.14 32 192c0-53.02 100.29-96 224-96s224 42.98 224 96c0 16.14-9.39 31.32-25.8 44.66z"]
  },
      ng = {
    prefix: "fal",
    iconName: "rings-wedding",
    icon: [512, 512, [], "f81b", "M351.64 160.79a206.88 206.88 0 0 1 18 35.6C432.81 211.65 480 268.25 480 336c0 79.4-64.6 144-144 144s-144-64.6-144-144c0-66.45 45.53-121.62 106.86-138C312 219.67 320 244.83 320 272c0 55-31.37 102.36-76.83 126.59a112.52 112.52 0 0 0 23.06 24.32C317.54 392.16 352 336.17 352 272c0-76.38-48.75-141.22-116.76-165.56L278 44.22 217.19 0h-82.38L74 44.22l42.76 62.22C48.75 130.78 0 195.62 0 272a176 176 0 0 0 176 176 169.3 169.3 0 0 0 23-1.64A175.93 175.93 0 0 0 512 336c0-91.92-70.5-167.28-160.36-175.21zM118 51.78L145.22 32h61.56L234 51.78l-31.89 46.37A175.63 175.63 0 0 0 176 96a175.63 175.63 0 0 0-26.11 2.15zM176 416c-79.4 0-144-64.6-144-144s64.6-144 144-144a143.52 143.52 0 0 1 101.89 42.37C209.35 194.42 160 259.24 160 336a175.09 175.09 0 0 0 19.21 79.68c-1.09.03-2.11.32-3.21.32z"]
  },
      tg = {
    prefix: "fal",
    iconName: "road",
    icon: [576, 512, [], "f018", "M279.47 192h17.06c5.81 0 10.35-6.17 9.73-13.26l-3.75-43.58c-.35-4.07-3.15-7.16-6.49-7.16h-16.05c-3.34 0-6.14 3.09-6.49 7.16l-3.75 43.58c-.61 7.09 3.93 13.26 9.74 13.26zm-6.02 112h29.1c7.75 0 13.79-8.23 12.98-17.68l-4.13-48c-.7-8.14-6.3-14.32-12.98-14.32h-20.83c-6.68 0-12.28 6.18-12.98 14.32l-4.13 48c-.82 9.45 5.22 17.68 12.97 17.68zm10.66-208h7.79c3.88 0 6.9-4.12 6.49-8.84l-1.38-16c-.35-4.07-3.15-7.16-6.49-7.16h-5.03c-3.34 0-6.14 3.09-6.49 7.16l-1.38 16c-.41 4.72 2.61 8.84 6.49 8.84zm23.95 240h-40.12c-6.68 0-12.28 6.18-12.98 14.32l-6.89 80c-.81 9.45 5.23 17.68 12.98 17.68h53.89c7.75 0 13.79-8.23 12.98-17.68l-6.89-80c-.69-8.14-6.29-14.32-12.97-14.32zM157.35 64a7.99 7.99 0 0 0-7.38 4.92L1.25 425.85C-3.14 436.38 4.6 448 16.02 448h28c7.11 0 13.37-4.69 15.36-11.52L165.03 74.24c1.49-5.12-2.35-10.24-7.68-10.24zm417.4 361.85L426.04 68.92a8 8 0 0 0-7.38-4.92c-5.33 0-9.17 5.12-7.68 10.24l105.65 362.24A15.996 15.996 0 0 0 531.99 448h28c11.41 0 19.16-11.62 14.76-22.15z"]
  },
      rg = {
    prefix: "fal",
    iconName: "robot",
    icon: [640, 512, [], "f544", "M192,416h64V384H192ZM576,224H544V192a95.99975,95.99975,0,0,0-96-96H336V16a16,16,0,0,0-32,0V96H192a95.99975,95.99975,0,0,0-96,96v32H64a31.99908,31.99908,0,0,0-32,32V384a32.00033,32.00033,0,0,0,32,32H96a95.99975,95.99975,0,0,0,96,96H448a95.99975,95.99975,0,0,0,96-96h32a32.00033,32.00033,0,0,0,32-32V256A31.99908,31.99908,0,0,0,576,224ZM96,384H64V256H96Zm416,32a64.18916,64.18916,0,0,1-64,64H192a64.18916,64.18916,0,0,1-64-64V192a63.99942,63.99942,0,0,1,64-64H448a63.99942,63.99942,0,0,1,64,64Zm64-32H544V256h32ZM416,192a64,64,0,1,0,64,64A64.07333,64.07333,0,0,0,416,192Zm0,96a32,32,0,1,1,32-32A31.97162,31.97162,0,0,1,416,288ZM384,416h64V384H384Zm-96,0h64V384H288ZM224,192a64,64,0,1,0,64,64A64.07333,64.07333,0,0,0,224,192Zm0,96a32,32,0,1,1,32-32A31.97162,31.97162,0,0,1,224,288Z"]
  },
      ig = {
    prefix: "fal",
    iconName: "rocket",
    icon: [512, 512, [], "f135", "M505.07337,19.34375C503.85462,13.73438,498.32338,8.20312,492.72964,7c-32.62885-7-58.162-7-83.57017-7C305.39988,0,242.95858,55.09375,196.236,128H94.82015c-16.34567.01562-35.53314,11.875-42.87883,26.48438L2.53125,253.29688A28.125,28.125,0,0,0,0,264a24.00659,24.00659,0,0,0,24.00191,24h92.63266l-10.59373,21.42188c-9.33592,18.91015,4.27733,34.77539,6.15624,36.625l53.75381,53.71874c1.85352,1.86329,17.789,15.47852,36.62885,6.14063l21.37692-10.57813V488a24.14815,24.14815,0,0,0,24.00191,24,28.02956,28.02956,0,0,0,10.625-2.53125l98.72835-49.39063c14.625-7.3125,26.50191-26.5,26.50191-42.85937V315.70312C456.6008,268.9375,511.98156,206.25,511.98156,103,512.07531,77.46875,512.07531,52,505.07337,19.34375ZM36.94134,256l43.59759-87.20312c2.46874-4.82813,8.84373-8.78126,14.28122-8.79688h85.19517c-13.93943,28.0625-31.72065,64-47.56632,96ZM351.84316,417.1875c-.03125,5.4375-4.002,11.84375-8.87694,14.26562L255.95855,475V379.48438c32.00386-15.82813,67.81825-33.59376,95.88461-47.54688Zm14.625-128.28125c-39.50383,19.78125-135.88649,67.4375-177.92157,88.23437l-53.81632-53.54687c20.87692-42.23437,68.537-138.59375,88.22642-178.1875C273.17923,67,330.65374,32,409.15947,32c21.53317,0,42.00384,0,66.63075,4.29688,4.34374,24.85937,4.25,45.20312,4.18749,66.6875C479.97771,181.0625,444.97582,238.45312,366.46813,288.90625ZM367.98962,88.0293a55.99512,55.99512,0,1,0,55.99209,55.99414A56.01691,56.01691,0,0,0,367.98962,88.0293Zm0,79.99218a23.998,23.998,0,1,1,23.99605-23.998A24.02247,24.02247,0,0,1,367.98962,168.02148Z"]
  },
      og = {
    prefix: "fal",
    iconName: "rocket-launch",
    icon: [512, 512, [], "e027", "M368.05829,88.0293a55.99512,55.99512,0,1,0,55.99215,55.99414A56.01694,56.01694,0,0,0,368.05829,88.0293Zm0,79.99218a23.998,23.998,0,1,1,23.99608-23.998A24.02247,24.02247,0,0,1,368.05829,168.02148ZM505.1656,19.29492C503.98982,13.832,498.18123,8.0293,492.71835,6.86133,460.63244,0,435.48793,0,410.45084,0,307.26342,0,245.38261,55.19727,199.18734,127.98828H95.01555c-16.293,0-35.58786,11.92188-42.87692,26.4961L2.73242,253.27344A28.4,28.4,0,0,0,.2168,263.97656a24.00493,24.00493,0,0,0,23.99607,23.998H128.13466a95.98845,95.98845,0,0,1,95.98625,95.99023V487.95508a24.00243,24.00243,0,0,0,23.99608,23.998,28.53884,28.53884,0,0,0,10.70116-2.51562l98.71671-49.40039c14.55663-7.28516,26.46678-26.5625,26.46678-42.83984V312.76758C456.568,266.46094,511.982,204.37109,511.982,101.69336,512.0738,76.54492,512.0738,51.39648,505.1656,19.29492ZM37.15427,255.97656l43.60152-87.18164c1.85156-3.70508,10.11523-8.81054,14.25976-8.81054h85.08c-13.93554,28.06054-31.71287,63.99609-47.55465,95.99218l.0664.45313C131.08778,256.377,61.01753,255.97656,37.15427,255.97656Zm314.8513,161.22071c0,4.13085-5.09179,12.375-8.789,14.22461L256.115,475.01172c0-23.90234-.4043-94.06055-.46094-95.60938l.36719.04688c31.99606-15.82617,67.80267-33.58984,95.85929-47.541l.125.002Zm-102.078-70.51368a127.62739,127.62739,0,0,0-84.6347-84.55468c52.02731-103.98633,99.76945-230.13282,245.158-230.13282,21.164,0,41.29684,0,65.41987,4.1875,4.26562,24.377,4.1914,44.38477,4.11523,65.50977C479.98594,246.66406,353.00752,295.1543,249.92753,346.68359Zm-147.494-26.71289C54.35347,319.9707,2.03125,359.31836.168,480H0v32H32v-.23242C203.617,508.42969,216.8885,396.74414,165.80065,345.40039,150.85925,330.38477,127.22255,319.9707,102.43351,319.9707Zm52.914,109.39844c-12.83593,31.14844-57.63667,49.42969-123.36709,50.55078.06446-3.55469-1.11914-127.88867,70.45307-127.88867,15.09569,0,31.11521,6.29492,40.81051,16.03906C156.05456,380.94336,164.6483,406.80273,155.34753,429.36914Z"]
  },
      lg = {
    prefix: "fal",
    iconName: "route",
    icon: [512, 512, [], "f4d7", "M432 352H320c-26.5 0-48-21.5-48-48s21.5-48 48-48h96s96-107 96-160-43-96-96-96-96 43-96 96c0 34.6 40.9 92.2 69.3 128H320c-44.1 0-80 35.9-80 80s35.9 80 80 80h112c26.5 0 48 21.5 48 48s-21.5 48-48 48H122.7c28.4-35.8 69.3-93.4 69.3-128 0-53-43-96-96-96S0 299 0 352s96 160 96 160h336c44.1 0 80-35.9 80-80s-35.9-80-80-80zM352 96c0-35.3 28.7-64 64-64s64 28.7 64 64c0 20.4-30.1 68-64 110.4-34-42.6-64-90.6-64-110.4zM32 352c0-35.3 28.7-64 64-64s64 28.7 64 64c0 20.4-30.1 68-64 110.4-34-42.6-64-90.6-64-110.4zm64-16c-21.2 0-21.1 32 0 32 21.2 0 21.1-32 0-32zM416 80c-21.2 0-21.1 32 0 32 21.2 0 21.1-32 0-32z"]
  },
      fg = {
    prefix: "fal",
    iconName: "route-highway",
    icon: [448, 512, [], "f61a", "M428.4 269.21c-30.48-45.42-11.8-104.47 13-155.4 3.96-8.13 3.34-17.75-1.87-25.13l-41.17-58.36c-4.56-6.47-11.8-10.14-19.28-10.14-2.74 0-5.52.49-8.21 1.52-15.37 5.88-32.67 8.89-50.26 8.89-29.51 0-59.81-8.47-83.16-26.11C233.48 1.5 228.74 0 224 0s-9.48 1.5-13.44 4.49C187.21 22.13 156.9 30.6 127.39 30.6c-17.59 0-34.89-3.01-50.25-8.89a22.929 22.929 0 0 0-8.21-1.52c-7.48 0-14.72 3.67-19.28 10.13L8.47 88.69c-5.21 7.38-5.83 16.99-1.87 25.13 24.8 50.92 43.47 109.97 13 155.4-37.94 56.52-18.55 139.43 38.81 166.03L223.97 512l165.62-76.76c57.37-26.6 76.75-109.51 38.81-166.03zM72.17 53.91c17.17 5.7 36.12 8.69 55.22 8.69 35.63 0 69.64-10.04 96.61-28.38 26.97 18.35 60.97 28.38 96.61 28.38 19.11 0 38.06-2.99 55.23-8.69l35 49.62c-8.03 16.78-16.01 36.09-21.86 56.48H59.03c-5.86-20.38-13.83-39.7-21.86-56.48l35-49.62zm340.44 306.03c-6 21.44-19.29 38.3-36.47 46.27l-152.16 70.52-152.1-70.52c-17.19-7.97-30.48-24.83-36.48-46.27-7.03-25.12-3-52.37 10.78-72.89 20.25-30.18 24.07-63.23 19.87-95.04h315.92c-4.21 31.81-.38 64.86 19.87 95.05 13.77 20.51 17.79 47.76 10.77 72.88z"]
  },
      sg = {
    prefix: "fal",
    iconName: "route-interstate",
    icon: [480, 512, [], "f61b", "M464.83 55.14c-3.07-9.95-11.66-16.67-20.94-16.67-1.73 0-3.49.23-5.24.72-18.23 5.12-37.74 7.96-58.1 7.96-49.12 0-93.61-16.07-126.17-42.11C250.18 1.68 245.09 0 240 0s-10.18 1.68-14.38 5.03c-32.56 26.04-77.05 42.11-126.17 42.11-20.36 0-39.87-2.84-58.1-7.96-1.75-.49-3.51-.72-5.24-.72-9.28 0-17.87 6.73-20.94 16.67C-21.83 175.11-6.68 410.34 240 512 486.68 410.34 501.83 175.11 464.83 55.14zM43.37 72.73c18.29 4.25 37.11 6.41 56.08 6.41 52.1 0 101.71-15.86 140.55-44.79 38.83 28.93 88.45 44.79 140.55 44.79 18.96 0 37.77-2.15 56.05-6.4 4.63 17.18 10.92 48.28 11.28 87.26H32.07c.16-31.56 4.17-61.38 11.3-87.27zm196.64 404.45C97.11 413.26 42.04 296.52 33.32 192h413.33c-2.14 27.18-7.29 56.82-18.08 87.95-30.84 88.91-94.24 155.21-188.56 197.23z"]
  },
      ug = {
    prefix: "fal",
    iconName: "router",
    icon: [576, 512, [], "f8da", "M173.93 96.81a8.12 8.12 0 0 0 11.23.07C230.55 55 289.48 32 352 32s121.45 23 166.83 64.88a8.12 8.12 0 0 0 11.23-.07l11.53-11.34a8 8 0 0 0-.11-11.56C490 26.18 423 0 352 0S214 26.18 162.52 73.91a8 8 0 0 0-.11 11.56zM352 112a179.26 179.26 0 0 0-120.38 45.8 8 8 0 0 0-.15 11.64l11.53 11.3a8.21 8.21 0 0 0 11.22.14 148.17 148.17 0 0 1 195.64 0 8.21 8.21 0 0 0 11.22-.14l11.49-11.3a8 8 0 0 0-.15-11.64A179.26 179.26 0 0 0 352 112zm176 208H368v-88a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v88H48a48 48 0 0 0-48 48v96a48 48 0 0 0 48 48h480a48 48 0 0 0 48-48v-96a48 48 0 0 0-48-48zm16 144a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h480a16 16 0 0 1 16 16zm-360-72a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm-80 0a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"]
  },
      hg = {
    prefix: "fal",
    iconName: "rss",
    icon: [448, 512, [], "f09e", "M80 352c26.467 0 48 21.533 48 48s-21.533 48-48 48-48-21.533-48-48 21.533-48 48-48m0-32c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80zm367.996 147.615c-6.448-237.848-198.06-429.164-435.61-435.61C5.609 31.821 0 37.229 0 44.007v8.006c0 6.482 5.146 11.816 11.626 11.994 220.81 6.05 398.319 183.913 404.367 404.367.178 6.48 5.512 11.626 11.994 11.626h8.007c6.778 0 12.185-5.609 12.002-12.385zm-144.245-.05c-6.347-158.132-133.207-284.97-291.316-291.316C5.643 175.976 0 181.45 0 188.247v8.005c0 6.459 5.114 11.72 11.567 11.989 141.134 5.891 254.301 119.079 260.192 260.192.269 6.453 5.531 11.567 11.989 11.567h8.005c6.798 0 12.271-5.643 11.998-12.435z"]
  },
      mg = {
    prefix: "fal",
    iconName: "rss-square",
    icon: [448, 512, [], "f143", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm16 400c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h352c8.822 0 16 7.178 16 16v352zM144 320c8.822 0 16 7.177 16 16s-7.178 16-16 16-16-7.177-16-16 7.178-16 16-16m0-32c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm195.981 96h-8.019c-6.369 0-11.678-4.969-11.993-11.33-5.676-114.835-97.728-206.959-212.639-212.639-6.362-.314-11.33-5.623-11.33-11.993v-8.019c0-6.826 5.683-12.331 12.502-12.006 131.615 6.279 237.203 111.811 243.485 243.485.325 6.819-5.18 12.502-12.006 12.502zm-72.006 0h-8.045c-6.298 0-11.53-4.859-11.986-11.14-5.463-75.234-65.751-135.364-140.824-140.805-6.274-.454-11.12-5.695-11.12-11.985v-8.045c0-7.003 5.957-12.482 12.943-11.995 91.397 6.367 164.66 79.629 171.027 171.027.487 6.986-4.992 12.943-11.995 12.943z"]
  },
      vg = {
    prefix: "fal",
    iconName: "ruble-sign",
    icon: [384, 512, [], "f158", "M245.712 287.809c80.296 0 138.288-50.323 138.288-128.803C384 81.125 326.009 32 245.712 32H108c-6.627 0-12 5.373-12 12v204H12c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h84v58H12c-6.627 0-12 5.373-12 12v14c0 6.627 5.373 12 12 12h84v84c0 6.627 5.373 12 12 12h19.971c6.627 0 12-5.373 12-12v-84H308c6.627 0 12-5.373 12-12v-14c0-6.627-5.373-12-12-12H139.971v-58.191h105.741zM139.971 71.594h104.643c59.266 0 98.14 31.979 98.14 87.215 0 55.818-38.873 88.96-98.777 88.96H139.971V71.594z"]
  },
      dg = {
    prefix: "fal",
    iconName: "ruler",
    icon: [640, 512, [], "f545", "M635.7 165.8L556.1 27.9C550.2 17.7 539.5 12 528.5 12c-5.4 0-10.9 1.4-15.9 4.3L15.9 302.8C.7 311.5-4.5 331 4.3 346.2L83.9 484c5.9 10.2 16.6 15.9 27.6 15.9 5.4 0 10.9-1.4 15.9-4.3L624 209.1c15.3-8.6 20.5-28.1 11.7-43.3zM111.5 468.2L31.9 330.3l69-39.8 43.8 75.8c2.2 3.8 7.1 5.1 10.9 2.9l13.8-8c3.8-2.2 5.1-7.1 2.9-10.9l-43.8-75.8 55.2-31.8 27.9 48.2c2.2 3.8 7.1 5.1 10.9 2.9l13.8-8c3.8-2.2 5.1-7.1 2.9-10.9l-27.9-48.2 55.2-31.8 43.8 75.8c2.2 3.8 7.1 5.1 10.9 2.9l13.8-8c3.8-2.2 5.1-7.1 2.9-10.9L294 179.1l55.2-31.8 27.9 48.2c2.2 3.8 7.1 5.1 10.9 2.9l13.8-8c3.8-2.2 5.1-7.1 2.9-10.9l-27.9-48.2L432 99.5l43.8 75.8c2.2 3.8 7.1 5.1 10.9 2.9l13.8-8c3.8-2.2 5.1-7.1 2.9-10.9l-43.8-75.8 69-39.8 79.6 137.8-496.7 286.7z"]
  },
      Mg = {
    prefix: "fal",
    iconName: "ruler-combined",
    icon: [512, 512, [], "f546", "M480 320H192V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM32 32h128v64h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v48h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v48h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v41.38l-128 128V32zm448 448H54.62l128-128H224v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h48v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h48v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h64v128z"]
  },
      pg = {
    prefix: "fal",
    iconName: "ruler-horizontal",
    icon: [640, 512, [], "f547", "M608 128H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zm0 224H32V160h80v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h64v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h64v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h64v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h64v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h80v192z"]
  },
      zg = {
    prefix: "fal",
    iconName: "ruler-triangle",
    icon: [512, 512, [], "f61c", "M501.65 452.08L59.91 10.35C52.76 3.2 43.97 0 35.35 0 17.31 0 0 14.01 0 35.17V476.9C0 496.29 15.71 512 35.1 512h441.73c31.27 0 46.93-37.8 24.82-59.92zm-21.96 26.01c-.79 1.91-2.04 1.91-2.86 1.91H35.1c-1.71 0-3.1-1.39-3.1-3.1V35.17c0-3.13 3.21-3.17 3.36-3.17.48 0 1.03.08 1.93.98l73.79 73.79-16.97 16.97c-3.12 3.12-3.12 8.19 0 11.31l11.32 11.31a7.98 7.98 0 0 0 5.66 2.34c2.05 0 4.09-.78 5.66-2.34l16.97-16.97 45.26 45.26-16.97 16.97c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31a7.98 7.98 0 0 0 5.66 2.34c2.05 0 4.1-.78 5.66-2.34l16.97-16.97 45.26 45.26-16.97 16.97c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31a7.98 7.98 0 0 0 5.66 2.34c2.05 0 4.1-.78 5.66-2.34l16.97-16.97 45.25 45.25-16.97 16.97c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c1.56 1.56 3.61 2.34 5.66 2.34s4.09-.78 5.66-2.34l16.97-16.97 45.25 45.25-16.97 16.97c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c1.56 1.56 3.61 2.34 5.66 2.34s4.09-.78 5.66-2.34l16.97-16.97 73.79 73.79c.55.61 1.44 1.5.64 3.41zM123.31 228.68c-4.56-4.56-11.5-5.95-17.44-3.47A15.999 15.999 0 0 0 96 239.99v160c0 8.84 7.16 16 16 16h160c6.47 0 12.31-3.89 14.78-9.88a16.048 16.048 0 0 0-3.47-17.44l-160-159.99zM128 383.99V278.62L233.37 384H128z"]
  },
      Cg = {
    prefix: "fal",
    iconName: "ruler-vertical",
    icon: [256, 512, [], "f548", "M224 0H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zM32 480V32h192v64h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v64h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v64h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v64h-56c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v64H32z"]
  },
      Lg = {
    prefix: "fal",
    iconName: "running",
    icon: [448, 512, [], "f70c", "M396 216h-14.53l-9.04-27.12c-8.11-24.31-24.18-44-44.5-58.04C347 117.91 360 96.73 360 72c0-39.7-32.3-72-72-72s-72 32.3-72 72c0 8.34 1.56 16.28 4.2 23.72-8.62-1.98-17.37-3.22-26.13-3.22-20.55 0-40.8 5.53-58.64 16l-46.19 24.07C64.7 147.31 56.7 179.3 71.4 203.88c9.39 15.62 26.48 25.27 44.63 25.27 8.98 0 17.82-2.33 25.65-6.76l18.95-9.85L101.75 344H52c-28.67 0-52 23.33-52 52s23.33 52 52 52h62.91c33.65 0 63.95-19.99 77.2-50.92l19.32-39.74 43.7 19.63-19.64 68.74c-7.87 27.58 8.15 56.42 35.71 64.29 4.8 1.34 9.55 2 14.31 2 23.07 0 43.62-15.5 49.98-37.69l24.4-85.4c7.11-24.86 2.02-50.92-12.01-71.12 6.2 1.45 12.63 2.21 19.2 2.21H396c28.67 0 52-23.33 52-52s-23.33-52-52-52zM288 32c22.09 0 40 17.91 40 40s-17.91 40-40 40-40-17.91-40-40 17.91-40 40-40zM162.69 384.48A51.915 51.915 0 0 1 114.91 416H52c-11.05 0-20-8.95-20-20s8.95-20 20-20h62.91c4.8 0 9.12-2.86 11.03-7.28l26.72-56.88c6.9 12.72 17.07 23.57 29.98 31.43l-19.95 41.21zM396 288h-28.94a51.94 51.94 0 0 1-49.33-35.55l-13.59-40.8c-2.83-8.46-8.21-15.43-15-20.67l-41.47 103.69 52.78 23.72c23.41 10.55 35.72 37.09 28.67 61.73l-24.39 85.38c-2.52 8.78-10.52 14.5-19.22 14.5-1.83 0-3.67-.25-5.52-.77-10.61-3.03-16.77-14.11-13.73-24.73l24.39-85.38c1.64-5.69-1.22-11.81-6.62-14.25 0 0-85.82-39.04-88.71-41.16-17.8-13.09-25.42-36.48-18.51-57.88l37.75-87.57s-16.9-3.77-20.5-3.77c-7.88 0-15.59 2.14-22.5 6.31l-45.25 23.52a20.137 20.137 0 0 1-10.29 2.84c-6.8 0-13.41-3.46-17.16-9.7-5.67-9.48-2.61-21.77 6.86-27.45l45.26-23.52c13.24-7.93 28.06-11.99 43.1-11.99 6.83 0 13.72.84 20.51 2.53l68.19 17.05c28 6.98 50.17 27.52 59.31 54.92l13.59 40.8c1.64 4.91 6.22 8.2 11.39 8.2H396c11.05 0 20 8.95 20 20s-8.95 20-20 20z"]
  },
      Ag = {
    prefix: "fal",
    iconName: "rupee-sign",
    icon: [320, 512, [], "f156", "M320 60V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v16c0 6.627 5.373 12 12 12h72.614c47.093 0 81.306 20.121 93.376 56H12c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h170.387c-4.043 50.107-41.849 79.554-98.41 79.554H12c-6.627 0-12 5.373-12 12v15.807c0 2.985 1.113 5.863 3.121 8.072l175.132 192.639a11.998 11.998 0 0 0 8.879 3.928h21.584c10.399 0 15.876-12.326 8.905-20.043L62.306 288h23.407c77.219 0 133.799-46.579 138.024-120H308c6.627 0 12-5.373 12-12v-16c0-6.627-5.373-12-12-12h-87.338c-4.96-22.088-15.287-40.969-29.818-56H308c6.627 0 12-5.373 12-12z"]
  },
      Ng = {
    prefix: "fal",
    iconName: "rv",
    icon: [640, 512, [], "f7be", "M304 128H112c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm-16 96H128v-64h160v64zm288.1-32H600c22.1 0 40-17.9 40-40 0-66.3-53.7-120-120-120H384V16c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v16H64C28.7 32 0 60.7 0 96v197.5c0 17 6.7 33.2 18.7 45.2l69.7 69.7c2.8 2.8 6.1 4.6 9.7 5.9C96.8 420 96 425.9 96 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.6 0 32-14.4 32-32V282.4c0-17-6.7-33.2-18.7-45.2L576.1 192zm18.7 64H416v-64h101.5c8.6 0 16.7 3.4 22.8 9.4l54.5 54.6zM176 480c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm208-96H239.6C225 364.7 202 352 176 352s-49 12.7-63.6 32h-3.1l-67.9-67.9c-6-6-9.4-14.1-9.4-22.6V96c0-17.7 14.3-32 32-32h456c48.5 0 88 39.5 88 88 0 4.4-3.6 8-8 8H384v224zm112 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm112-96h-48.4C545 364.7 522 352 496 352s-49 12.7-63.6 32H416v-96h192v96z"]
  },
      gg = {
    prefix: "fal",
    iconName: "sack",
    icon: [512, 512, [], "f81c", "M334.89 121.63l43.72-71.89C392.77 28.47 377.53 0 352 0H160.15c-25.56 0-40.8 28.5-26.61 49.76l43.57 71.88C-9.27 240.59.08 392.36.08 412c0 55.23 49.11 100 109.68 100h292.5c60.58 0 109.68-44.77 109.68-100 0-19.28 8.28-172-177.05-290.37zM160.15 32H352l-49.13 80h-93.73zM480 412c0 37.49-34.85 68-77.69 68H109.76c-42.84 0-77.69-30.51-77.69-68v-3.36c-.93-59.86 20-173 168.91-264.64h110.1C459.64 235.46 480.76 348.94 480 409z"]
  },
      Hg = {
    prefix: "fal",
    iconName: "sack-dollar",
    icon: [512, 512, [], "f81d", "M334.89 121.63l43.72-71.89C392.77 28.47 377.53 0 352 0H160.15c-25.56 0-40.8 28.5-26.61 49.76l43.57 71.88C-9.27 240.59.08 392.36.08 412c0 55.23 49.11 100 109.68 100h292.5c60.58 0 109.68-44.77 109.68-100 0-19.28 8.28-172-177.05-290.37zM160.15 32H352l-49.13 80h-93.73zM480 412c0 37.49-34.85 68-77.69 68H109.76c-42.84 0-77.69-30.51-77.69-68v-3.36c-.93-59.86 20-173 168.91-264.64h110.1C459.64 235.46 480.76 348.94 480 409zM285.61 310.74l-49-14.54c-5.66-1.62-9.57-7.22-9.57-13.68 0-7.86 5.76-14.21 12.84-14.21h30.57a26.78 26.78 0 0 1 13.93 4 8.92 8.92 0 0 0 11-.75l12.73-12.17a8.54 8.54 0 0 0-.65-13 63.12 63.12 0 0 0-34.17-12.17v-17.6a8.68 8.68 0 0 0-8.7-8.62H247.2a8.69 8.69 0 0 0-8.71 8.62v17.44c-25.79.75-46.46 22.19-46.46 48.57 0 21.54 14.14 40.71 34.38 46.74l49 14.54c5.66 1.61 9.58 7.21 9.58 13.67 0 7.87-5.77 14.22-12.84 14.22h-30.61a26.72 26.72 0 0 1-13.93-4 8.92 8.92 0 0 0-11 .76l-12.84 12.06a8.55 8.55 0 0 0 .65 13 63.2 63.2 0 0 0 34.17 12.17v17.55a8.69 8.69 0 0 0 8.71 8.62h17.41a8.69 8.69 0 0 0 8.7-8.62V406c25.68-.64 46.46-22.18 46.57-48.56.02-21.5-14.13-40.67-34.37-46.7z"]
  },
      Vg = {
    prefix: "fal",
    iconName: "sad-cry",
    icon: [496, 512, [], "f5b3", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm128 421.6V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v177.2c-29 14.5-61.5 22.8-96 22.8s-67-8.3-96-22.8V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v157.6C66.7 390.2 32 327.2 32 256c0-119.1 96.9-216 216-216s216 96.9 216 216c0 71.2-34.7 134.2-88 173.6zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 108c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64zm0 96c-13 0-24-14.7-24-32s11-32 24-32 24 14.7 24 32-11 32-24 32z"]
  },
      xg = {
    prefix: "fal",
    iconName: "sad-tear",
    icon: [496, 512, [], "f5b4", "M168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm0-152c-11.2 0-22 1.7-32.7 4.1-7.2-12.6-16.1-26.5-28.1-42.4-9-12.1-29.4-12-38.4 0-29.7 39.6-44.8 69-44.8 87.3 0 34.7 28.7 63 64 63s64-28.3 64-63c0-4.4-1-9.5-2.7-15.1 6.1-1.2 12.3-1.9 18.7-1.9 34.9 0 67.8 15.4 90.2 42.2 5.3 6.4 15.4 8 22.5 2 6.8-5.7 7.7-15.8 2-22.5C334.2 339.6 292.4 320 248 320zm-80 80c-17.7 0-32-13.9-32-31 0-7.7 10-28.8 32-59.5 22 30.7 32 51.8 32 59.5 0 17.1-14.3 31-32 31z"]
  },
      wg = {
    prefix: "fal",
    iconName: "salad",
    icon: [512, 512, [], "f81e", "M495.82 288h5A110.13 110.13 0 0 0 512 240c0-33.16-14.77-62.69-37.75-83.21C459 103.33 410.38 64 352 64c-3.63 0-7.05.77-10.61 1.07C323.6 26.74 285 0 240 0s-83.6 26.74-101.39 65.07c-3.56-.3-7-1.07-10.61-1.07A128 128 0 0 0 0 192c0 38.58 17.43 72.66 44.52 96H16.18C7 288-.74 295.72.06 304.84 6.7 381.21 58.18 444.23 128 468.69V480a32.16 32.16 0 0 0 32.21 32h192.25c17.7 0 31.54-14.33 31.54-32v-11.51c69.49-24.62 121.32-87.49 127.94-163.65.8-9.12-6.94-16.84-16.12-16.84zM480 240a78.45 78.45 0 0 1-16.71 48H336.71A78.51 78.51 0 0 1 320 240a80 80 0 0 1 160 0zM32 192c0-35.13 23-104.78 128-96 27.87-63.73 65.28-64 80-64 14.18 0 52 0 80 64 35.07-2.93 76.19-1.1 106 35.35a110.79 110.79 0 0 0-26-3.35 112.12 112.12 0 0 0-112 112 110.27 110.27 0 0 0 11.09 48H256V104a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v161.37l-111-111a8 8 0 0 0-11.31 0l-11.35 11.29a8 8 0 0 0 0 11.31l111 111H128A96.11 96.11 0 0 1 32 192zm341.79 246.34L352 445.89V480H160v-34l-21.23-7.51C85.11 419.7 45.74 374.27 34.59 320h442.82c-11.12 54.07-50.27 99.43-103.62 118.34z"]
  },
      yg = {
    prefix: "fal",
    iconName: "sandwich",
    icon: [512, 512, [], "f81f", "M480 32H32A32 32 0 0 0 0 64v96a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm0 128H32V64h448zm0 160H32a32 32 0 0 0-32 32v96a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32v-96a32 32 0 0 0-32-32zm-84.85 32L352 380.77 308.85 352zM480 448H32v-96h219.16l92 61.32a16 16 0 0 0 17.76 0l92-61.32H480zm24.16-192.19c-23-1.11-35.09-7.19-48.94-14.12-12.09-6.05-68.1-37.12-142.19 0-64.15 32.14-112.55.58-113.72 0-12.1-6.06-68.18-37.12-142.4 0-13.88 6.92-26 13-49.07 14.13a8.08 8.08 0 0 0-7.84 8v16a8 8 0 0 0 8.29 8c30.52-1.32 47.67-9.88 62.93-17.51 1.17-.58 49.49-32.14 113.78 0 74.14 37.07 130.06 6.15 142.34 0 64.15-32.14 112.4-.58 113.57 0 15.23 7.62 32.34 16.19 62.8 17.51a8 8 0 0 0 8.29-8v-16a8.1 8.1 0 0 0-7.84-8.01z"]
  },
      bg = {
    prefix: "fal",
    iconName: "satellite",
    icon: [512, 512, [], "f7bf", "M502.62516,264.79688a31.98911,31.98911,0,0,1,0,45.10937l-96.6858,96.6875a31.8365,31.8365,0,0,1-44.99921,0l-45.99919-46c9.99982,48.20313,3.68743,99-20.12465,143.3125A15.39834,15.39834,0,0,1,280.94156,512a16.79636,16.79636,0,0,1-11.906-4.90625L148.13139,386.5l-37.81184,37.79688c.71874,2.5,1.625,5,1.625,7.79687a31.99944,31.99944,0,1,1-31.99944-32c2.78121,0,5.28116.90625,7.78112,1.60937l37.90558-37.90624L4.9464,243.09375C-2.67846,235.5-1.366,222.40625,8.0401,217.29688a211.415,211.415,0,0,1,142.59124-20.89063l-45.3117-45.3125a32.02746,32.02746,0,0,1,0-45.09375l96.717-96.70312A31.56644,31.56644,0,0,1,224.5363,0a32.04621,32.04621,0,0,1,22.59335,9.29688l70.81126,70.90624,70.78-70.79687a31.87473,31.87473,0,0,1,45.218,0L502.62516,78a32.04531,32.04531,0,0,1,0,45.29688l-70.81125,70.79687Zm-267.3078,11.79687a179.96533,179.96533,0,0,0-191.99663-40.5L275.94164,468.70312C301.1287,403.29688,285.72272,327,235.31736,276.59375Zm-107.27937-148,70.68626,70.8125,96.59205-96.60937-70.78-70.70313Zm91.49839,95.20313A209.36433,209.36433,0,0,1,258.03571,254c11.906,11.90625,21.40587,25.09375,29.90572,38.79688L480.03181,100.70312,411.31427,32Zm260.58918,63.5L409.3143,216.59375l-96.59205,96.60937L383.62725,384Z"]
  },
      Sg = {
    prefix: "fal",
    iconName: "satellite-dish",
    icon: [512, 512, [], "f7c0", "M346.58818,455.90644c8.31269,8.3906,6.90641,22.7968-3.50008,28.39053A233.00967,233.00967,0,0,1,68.17549,443.79711c-74.408-74.39037-87.90828-186.70249-40.50093-274.88969a16.87606,16.87606,0,0,1,15.2191-8.90622,18.51882,18.51882,0,0,1,13.09405,5.40623L189.99081,299.407l35.59457-35.60926c-.68752-2.59374-1.59379-5-1.59379-7.79685a32.00074,32.00074,0,1,1,32.00074,31.9999c-2.81256,0-5.21887-.90625-7.81268-1.59375l-35.59457,35.59363Zm-36.5946,8.68747L47.39376,202.00106c-30.71946,74.0935-14.12533,161.70257,43.376,219.20238a199.69239,199.69239,0,0,0,142.00329,58.79667C254.92981,480.00011,289.52436,473.09388,309.99358,464.59391Zm202.00467-152.8901a8.08961,8.08961,0,0,1-8.09394,8.2031H487.90394a7.97613,7.97613,0,0,1-7.90643-7.90623C475.90367,159.20433,352.68207,35.70475,199.89729,31.90789a7.9254,7.9254,0,0,1-7.90644-7.90622V8.09547A8.07635,8.07635,0,0,1,200.17854.00175C370.18247,4.29861,507.68565,141.79814,511.99825,311.70381Zm-96.096,0a8.11591,8.11591,0,0,1-8.12519,8.2031H391.99548a8.03981,8.03981,0,0,1-8.00019-7.81248c-3.59383-99.79653-84.31445-179.99938-184.223-183.99937a8.098,8.098,0,0,1-7.78143-8V104.09514a8.00862,8.00862,0,0,1,8.18769-8.09372C317.18125,100.29828,411.68343,194.70421,415.90228,311.70381Z"]
  },
      Tg = {
    prefix: "fal",
    iconName: "sausage",
    icon: [512, 512, [], "f820", "M455.72 72.83l14.92-44.75A21.34 21.34 0 0 0 450.4 0h-68.8a21.34 21.34 0 0 0-20.24 28.08l14.92 44.75A95.83 95.83 0 0 0 320 160c0 88.22-71.78 160-160 160a95.83 95.83 0 0 0-87.17 56.28l-44.75-14.92C10.49 355.5 0 371.25 0 381.6v68.8c0 9.64 10.48 26.1 28.08 20.24l44.75-14.92A95.83 95.83 0 0 0 160 512c194.09 0 352-157.91 352-352a95.83 95.83 0 0 0-56.28-87.17zM64 424.94L32 435.6v-39.2l32 10.66zM435.6 32l-10.66 32h-17.88L396.4 32zM160 480a64 64 0 0 1 0-128c105.87 0 192-86.13 192-192a64 64 0 0 1 128 0c0 176.45-143.55 320-320 320zm240-320a16 16 0 0 0-16 16c0 114.69-93.31 208-208 208a16 16 0 0 0 0 32c132.34 0 240-107.66 240-240a16 16 0 0 0-16-16z"]
  },
      Dg = {
    prefix: "fal",
    iconName: "save",
    icon: [448, 512, [], "f0c7", "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM288 64v96H96V64h192zm128 368c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h16v104c0 13.255 10.745 24 24 24h208c13.255 0 24-10.745 24-24V64.491a15.888 15.888 0 0 1 7.432 4.195l83.882 83.882A15.895 15.895 0 0 1 416 163.882V432zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 144c-30.879 0-56-25.121-56-56s25.121-56 56-56 56 25.121 56 56-25.121 56-56 56z"]
  },
      jg = {
    prefix: "fal",
    iconName: "sax-hot",
    icon: [640, 512, [], "f8db", "M143.93 168.1c-18-26.76-33.27-49.41-34.11-50.57l-10.27-14.22-10.06 14.44C69.64 146.25 56.67 167 56.21 192h32.11c.32-9.61 3.92-19.13 11.6-32 6.19 9.18 13.73 20.4 21.52 32H192l-32-48zM37.41 192l-.14-.44c-3.6-11.44-5.27-21.18-5.27-30.64 0-23.82 24-71.55 64.15-115.63a392.69 392.69 0 0 1 30.71 37l24.39 33.6 26.28-32.13q3.25-4 6.62-7.84c25.13 32.53 39.85 70.43 39.85 85 0 9.46-1.68 19.2-5.27 30.64l-.14.44h32.95c2.55-10 4.46-20.25 4.46-31.08 0-30.45-29.72-93.23-71.12-131.66a343 343 0 0 0-32.12 34.27A442.25 442.25 0 0 0 96 0C39.85 52.1 0 120 0 160.92 0 171.75 1.91 182 4.46 192zM120 304a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm515.28-171.27L592 73.37A32 32 0 0 0 569.33 64H522.5a64 64 0 0 0-45.25 18.74l-29.76 27.62-23.09-23.1a8 8 0 0 0-11.32 0l-11.31 11.32a8 8 0 0 0 0 11.31L424 132.13l-23.48 21.78-21.39-21.39a8 8 0 0 0-11.31 0l-11.32 11.31a8 8 0 0 0 0 11.32l20.55 20.54-23.48 21.78-19.69-19.7a8 8 0 0 0-11.32 0l-11.31 11.32a8 8 0 0 0 0 11.31l18.85 18.85L248 296a25.41 25.41 0 0 1-39.76-31l5.48-9H232a8 8 0 0 0 8-8v-16a7.8 7.8 0 0 0-7-7.57l.27-.43H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h4.93C6.08 290.78 0 329.24 0 352c0 70.24 57.33 160 160 160 94.44 0 103.7-35.78 376-352h88c14.22 0 21.36-17.19 11.28-27.27zM536 128h-14.68l-9.58 11.13c-49.65 57.66-90.57 106-124.86 146.53C234 466.3 221 480 160 480c-83.52 0-128-74.34-128-128 0-21.08 6.5-60.82 13.6-96h132.26c-9 21.26-5.13 45.92 11.57 62.62A57 57 0 0 0 230 335.44c15.33 0 29.75-6 39.73-16l230.14-214.07A31.83 31.83 0 0 1 522.5 96h46.36l23.37 32z"]
  },
      Eg = {
    prefix: "fal",
    iconName: "saxophone",
    icon: [640, 512, [], "f8dc", "M635.28 100.73L592 41.37A32 32 0 0 0 569.33 32H522.5a64 64 0 0 0-45.25 18.74l-29.77 27.62-23.09-23.1a8 8 0 0 0-11.31 0l-11.31 11.32a8 8 0 0 0 0 11.31L424 100.13l-23.48 21.78-21.39-21.39a8 8 0 0 0-11.31 0l-11.32 11.31a8 8 0 0 0 0 11.32l20.54 20.54-23.47 21.78-19.7-19.7a8 8 0 0 0-11.31 0l-11.31 11.32a8 8 0 0 0 0 11.31l18.85 18.85L256 256a25.41 25.41 0 0 1-39.76-31L256 160h8a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h19.46C18.64 191.92 0 280.13 0 320c0 70.24 57.33 160 160 160 94.44 0 103.69-35.78 376-352h88c14.22 0 21.36-17.19 11.28-27.27zM536 96h-14.68l-9.58 11.13c-49.65 57.66-90.57 106-124.86 146.53C234 434.3 221 448 160 448c-83.52 0-128-74.34-128-128 0-34.34 17.27-118.78 26.3-151.48l2.36-8.52h157.81l-29.67 48.49a57.41 57.41 0 0 0 49.2 86.95c15.33 0 29.75-6 39.73-16L499.87 73.37A31.83 31.83 0 0 1 522.5 64h46.36l23.37 32zM104 288a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm16-80a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"]
  },
      kg = {
    prefix: "fal",
    iconName: "scalpel",
    icon: [544, 512, [], "f61d", "M511.45 13.17C498.87 4.19 484.31 0 469.7 0c-23.06 0-46.27 10.44-62.13 28.97L183.68 290.6c-5.79 6.77-4.9 15.34-.5 21.57L0 512h.37c101.37 0 198.37-34.12 272.96-94.68.23-.19.46-.37.69-.56 30.39-24.9 47.16-59.96 52.22-96.75h17.57c10.41 0 20.3-4.55 27.08-12.47l154.47-180.49c29.31-34.23 23.6-87.13-13.91-113.88zm-258.28 379.3c-49.49 40.19-109.26 67.52-173.46 79.93L219.41 320h75.21c-4.94 28.79-19.33 54.35-41.45 72.47zm247.88-286.23L346.58 286.73c-.69.81-1.7 1.28-2.77 1.28H228.02L431.88 49.78C441.41 38.64 455.54 32 469.7 32c8.54 0 16.54 2.5 23.17 7.22 10.54 7.52 17.22 18.75 18.79 31.62 1.56 12.79-2.3 25.7-10.61 35.4z"]
  },
      Ig = {
    prefix: "fal",
    iconName: "scalpel-path",
    icon: [640, 512, [], "f61e", "M344 480h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm144 0h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm144 0h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM511.45 13.17C498.87 4.19 484.31 0 469.7 0c-23.06 0-46.27 10.44-62.13 28.97L183.68 290.6c-5.79 6.77-4.9 15.34-.5 21.57L0 512h.38c101.37 0 198.38-34.12 272.96-94.68.23-.19.46-.37.69-.56 30.39-24.9 47.16-59.96 52.22-96.75h17.57c10.41 0 20.3-4.55 27.08-12.47l154.47-180.49c29.3-34.23 23.59-87.13-13.92-113.88zm-258.28 379.3c-49.49 40.19-109.26 67.52-173.46 79.93L219.41 320h75.21c-4.94 28.79-19.33 54.35-41.45 72.47zm247.88-286.23L346.58 286.73c-.69.81-1.7 1.28-2.77 1.28H228.02L431.88 49.78C441.41 38.64 455.54 32 469.7 32c8.54 0 16.54 2.5 23.17 7.22 10.54 7.52 17.22 18.75 18.79 31.62 1.56 12.79-2.3 25.7-10.61 35.4z"]
  },
      Og = {
    prefix: "fal",
    iconName: "scanner",
    icon: [640, 512, [], "f488", "M368 64H112C50.1 64 0 114.1 0 176c0 50.3 33.3 92.3 78.9 106.5L6.4 408C-6.9 431 1 460.3 24 473.6l55.4 32c7.6 4.4 15.8 6.4 24 6.4 16.6 0 32.7-8.6 41.6-24l60-104h67c26.5 0 48-21.5 48-48v-48h48c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM117.3 472c-2.9 5-8.1 8-13.9 8-2.8 0-5.5-.7-8-2.2l-55.4-32c-5-2.9-6.8-7.3-7.5-9.7s-1.3-7.1 1.6-12.1l78.5-136h110.8L117.3 472zM288 336c0 8.8-7.2 16-16 16h-48.5l37-64H288v48zm64-80H112c-44.1 0-80-35.9-80-80s35.9-80 80-80h240v160zm280 192H456c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-384H456c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8zm0 288H456c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0-192H456c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-160H456c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zm0 288H456c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      Qg = {
    prefix: "fal",
    iconName: "scanner-image",
    icon: [640, 512, [], "f8f3", "M80 408h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8H80a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8zm96 0h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8zm444.69-138.88L17.52 32.66A8 8 0 0 0 7 36.83L.66 51.52A8 8 0 0 0 4.83 62l576.39 226H32a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V298.5a32.08 32.08 0 0 0-19.31-29.38zM608 384v64H32V320h576z"]
  },
      Zg = {
    prefix: "fal",
    iconName: "scanner-keyboard",
    icon: [576, 512, [], "f489", "M400 96H16c-8.8 0-16 7.2-16 16v169.4c0 4.2 1.7 8.3 4.7 11.3L32 320v144c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V320l27.3-27.3c3-3 4.7-7.1 4.7-11.3V112c0-8.8-7.2-16-16-16zm-16 178.7l-32 32V464c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V306.7l-9.4-9.4L32 274.7V128h352v146.7zM96 256h224c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16zm16-64h192v32H112v-32zm72 128h-80c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm128 0h-80c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-128 64h-80c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm128 0h-80c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM256 8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h64V8zm64 0c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56h32V8zm248-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zm-96 0h-16c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zm-64 0h-48c-4.4 0-8 3.6-8 8v56h64V8c0-4.4-3.6-8-8-8z"]
  },
      Ug = {
    prefix: "fal",
    iconName: "scanner-touchscreen",
    icon: [576, 512, [], "f48a", "M400 96H16c-8.8 0-16 7.2-16 16v169.4c0 4.2 1.7 8.3 4.7 11.3L32 320v144c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V320l27.3-27.3c3-3 4.7-7.1 4.7-11.3V112c0-8.8-7.2-16-16-16zm-16 178.7l-32 32V464c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V306.7l-9.4-9.4L32 274.7V128h352v146.7zM112 448h192c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm16-256h160v224H128V192zM320 8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56h32V8zm-64 0c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h64V8zm312-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zm-96 0h-16c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zm-64 0h-48c-4.4 0-8 3.6-8 8v56h64V8c0-4.4-3.6-8-8-8z"]
  },
      Bg = {
    prefix: "fal",
    iconName: "scarecrow",
    icon: [448, 512, [], "f70d", "M256 120c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-64-16c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm253.7 82.3L419.3 160l18.3-18.3c5-5 1.5-13.7-5.7-13.7H320V96c0-53-43-96-96-96s-96 43-96 96v32H16c-7.1 0-10.7 8.6-5.7 13.7L28.7 160 2.3 186.3c-3.1 3.1-3.1 8.2 0 11.3L28.7 224l-18.3 18.3c-5 5-1.5 13.7 5.7 13.7h106.1l-26 141.3c-2.1 12.7 11.1 22.9 22.9 16.9l32.7-24.2c9.1-6.8 17-1.3 24.1 2.5V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V392.5c7.6-4 15.1-9.2 24.1-2.5l32.7 24.2c11.9 6 25-4.3 22.9-16.9L325.9 256H432c7.1 0 10.7-8.6 5.7-13.7L419.3 224l26.3-26.3c3.2-3.2 3.2-8.2.1-11.4zM160 96c0-35.3 28.7-64 64-64s64 28.7 64 64v32c0 17.6-14.4 32-32 32h-64c-17.6 0-32-14.4-32-32zm80 384h-32v-70.4c9.2 4.9 11.2 6.5 16 6.5 4.7 0 6.5-1.5 16-6.5zm134.1-256h-86.6l25.4 138.7c-7.8-5.1-16.9-7.8-26.3-7.8-7.9 0-15.7 2-22.6 5.6l-40 21.3-40-21.3c-7-3.7-14.7-5.6-22.6-5.6-9.4 0-18.5 2.7-26.3 7.8L160.5 224H73.9l-32-32 32-32h62.9c11.1 19 31.5 32 55.1 32h64c23.6 0 44-13 55.1-32h63l32 32z"]
  },
      Rg = {
    prefix: "fal",
    iconName: "scarf",
    icon: [512, 512, [], "f7c1", "M509.7 395.7l-68.8-68.6-74.4-74.1 24.1-24.7c48.6-53.7 13-113.3 11.5-115.8l-43.6-73.1c-4.3-7.2-9.9-13.3-16.8-18C320.1 6.9 288.3 0 256.6 0h-1.2c-31.7 0-63.6 6.9-85.2 21.5-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.1c-1.5 2.5-37.1 62.1 11.5 115.8l24.1 24.7-74.3 74.2-68.8 68.4c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l68.8-68.6 22.6 22.6-68.8 68.6c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l68.8-68.6 22.5 22.5-68.7 69.7c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0L256 366l140.5 143.7c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-68.7-69.7 22.5-22.5 68.8 68.6c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-68.8-68.6 22.6-22.6 68.8 68.6c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.3-3.1 3.3-8.1.2-11.3zM184 394.6l-67.5-67.4 51.4-51.3 66 67.5-49.9 51.2zm144 0L145.1 206.8c-31.9-35.2-10.4-73.6-7.7-77.9l43.6-73C192 37.4 233.3 32 255.4 32h1.2c22.1 0 63.4 5.4 74.5 23.8l43.6 73c2.6 4.3 24.1 42.7-7.7 77.9l-23 23.6-65.3-65.2 41.8-41.7c8.2-8.2 11.3-20.2 8.2-31.4-3.2-11.2-12.2-19.7-23.5-22.4-17.9-4.2-34.2-5.3-49.1-5.2-14.8 0-31.1 1-49.1 5.2-11.3 2.6-20.3 11.2-23.5 22.4-3.2 11.2-.1 23.2 8.2 31.4l203.9 203.7-67.6 67.5zM214.2 100.9c11.4-2.7 25.8-4.5 41.8-4.6 16 0 30.4 1.9 41.8 4.6L256 142.6l-41.8-41.7z"]
  },
      Yg = {
    prefix: "fal",
    iconName: "school",
    icon: [640, 512, [], "f549", "M352 192h-16v-32c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v56c0 4.42 3.58 8 8 8h40c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm16 128h-96c-26.51 0-48 21.49-48 48v136c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v136c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V368c0-26.51-21.49-48-48-48zm240-128h-96v-53.34c0-10.7-5.35-20.69-14.25-26.62l-160-106.67C332.38 1.79 326.19 0 320 0s-12.38 1.79-17.75 5.37l-160 106.67A32.02 32.02 0 0 0 128 138.67V192H32c-17.67 0-32 14.33-32 32v280c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V224h96v280c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V138.67L320 32l160 106.67V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V224h96v280c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V224c0-17.67-14.33-32-32-32zM320 96c-52.94 0-96 43.06-96 96s43.06 96 96 96 96-43.06 96-96-43.06-96-96-96zm0 160c-35.28 0-64-28.7-64-64s28.72-64 64-64 64 28.7 64 64-28.72 64-64 64z"]
  },
      Pg = {
    prefix: "fal",
    iconName: "screwdriver",
    icon: [512, 512, [], "f54a", "M416 192l96-128-64-64-128 96v73.38l-98.49 98.49c-12.24-7.85-26.24-11.86-40.27-11.86-19.13 0-38.26 7.3-52.86 21.89L10.95 395.33c-14.6 14.6-14.6 38.27 0 52.87l52.86 52.86c7.3 7.3 16.87 10.95 26.43 10.95 9.57 0 19.13-3.65 26.43-10.95L234.1 383.63c25.3-25.3 28.59-64.2 10.03-93.13l98.5-98.5H416zm-64-80l93-69.75L469.75 67 400 160h-48v-48zM211.41 360.92L93.98 478.36a5.192 5.192 0 0 1-3.74 1.55c-1 0-2.46-.27-3.74-1.55L33.65 425.5a5.3 5.3 0 0 1 0-7.48l117.43-117.43c8.06-8.06 18.77-12.5 30.17-12.5 11.4 0 22.11 4.44 30.17 12.5 16.62 16.63 16.62 43.7-.01 60.33z"]
  },
      Fg = {
    prefix: "fal",
    iconName: "scroll",
    icon: [640, 512, [], "f70e", "M608 352h-64V112C544 50.25 493.75 0 432 0H80C35.88 0 0 35.89 0 80v80c0 17.64 14.34 32 32 32h96v224c0 51.11 40.25 92.62 90.66 95.46v.54h312C590.94 512 640 462.95 640 402.67V384c0-17.64-14.34-32-32-32zM128 160H32V80c0-26.47 21.53-48 48-48s48 21.53 48 48v80zm160 256c0 35.3-28.72 64-64 64s-64-28.7-64-64V80c0-18-5.97-34.62-16.03-48H432c44.12 0 80 35.89 80 80v240H320c-17.66 0-32 14.36-32 32v32zm320-13.33c0 42.64-34.69 77.33-77.34 77.33H295.03c15.35-17.02 24.97-39.32 24.97-64v-32h288v18.67z"]
  },
      Wg = {
    prefix: "fal",
    iconName: "scroll-old",
    icon: [640, 512, [], "f70f", "M616 352h-72v-73.38L521.38 256 544 233.38v-82.75L521.38 128l22.25-22.28-.97-7.77C535.59 42.11 488.03 0 432 0H80C35.88 0 0 35.89 0 80v88c0 13.23 10.78 24 24 24h104v41.38L150.62 256 128 278.62v132.81c0 51.28 37.84 95.23 86.16 100.08 1.5.15 3 .14 4.5.23v.26h312C590.94 512 640 462.95 640 402.67V376c0-13.23-10.78-24-24-24zM128 160H32V80c0-26.47 21.53-48 48-48s48 21.53 48 48v80zm32 251.44V291.88L195.88 256 160 220.12V80c0-18-5.97-34.62-16.03-48H432c37.41 0 69.56 26.39 77.59 62.5L476.12 128 512 163.88v56.25L476.12 256 512 291.88V352h-73.38L416 374.62 393.38 352H320c-17.66 0-32 14.36-32 32v32c0 18.05-7.69 35.34-21.06 47.47-13.59 12.3-31.12 18.09-49.59 16.2-32.16-3.22-57.35-33.19-57.35-68.23zm448-8.77c0 42.64-34.69 77.33-77.34 77.33H294.83c15.82-17.55 25.17-40.18 25.17-64v-32h60.12L416 419.88 451.88 384H608v18.67z"]
  },
      Gg = {
    prefix: "fal",
    iconName: "scrubber",
    icon: [496, 512, [], "f2f8", "M248 40c119.3 0 216 96.6 216 216 0 119.3-96.6 216-216 216-119.3 0-216-96.6-216-216 0-119.3 96.6-216 216-216m0-32C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 216c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32m0-32c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"]
  },
      qg = {
    prefix: "fal",
    iconName: "scythe",
    icon: [640, 512, [], "f710", "M608 0H338.84C192 0 64 64 0 224h560.18l-13.06 64H392a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h148.6l-36.54 179.1a8 8 0 0 0 6.2 9.47l15.65 3.26a7.68 7.68 0 0 0 1.64.17 8 8 0 0 0 7.82-6.37L639.22 39A32 32 0 0 0 608 0zm-35.62 192H50.4C122.62 61.06 244.73 32 338.84 32H608z"]
  },
      Jg = {
    prefix: "fal",
    iconName: "sd-card",
    icon: [384, 512, [], "f7c2", "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 448c0 17.6-14.4 32-32 32H64c-17.6 0-32-14.4-32-32V141.3L141.3 32H320c17.6 0 32 14.4 32 32v384zm-64-288h32V64h-32v96zm-64 0h32V64h-32v96zm-64 0h32V64h-32v96z"]
  },
      Kg = {
    prefix: "fal",
    iconName: "search",
    icon: [512, 512, [], "f002", "M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"]
  },
      Xg = {
    prefix: "fal",
    iconName: "search-dollar",
    icon: [512, 512, [], "f688", "M235.09 199.42l-45-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.62.63-42.67 20.55-42.67 45.07 0 19.97 12.98 37.81 31.58 43.39l45 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.11c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.62-.63 42.67-20.54 42.67-45.07 0-19.97-12.98-37.81-31.58-43.39zm273.38 282.16l-128.99-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3c34.3-37.1 55.3-86.6 55.3-141.09C415.98 93.1 322.88 0 207.99 0S0 93.1 0 207.99c0 114.89 93.1 207.99 207.99 207.99 54.5 0 103.99-21 141.09-55.2v10.2c0 3.2 1.3 6.2 3.5 8.5l128.99 128.99c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.71-4.69 4.71-12.29 0-16.99zm-300.48-97.6C110.7 383.98 32 305.29 32 207.99 32 110.69 110.7 32 207.99 32s175.99 78.7 175.99 175.99c0 97.3-78.69 175.99-175.99 175.99z"]
  },
      _g = {
    prefix: "fal",
    iconName: "search-location",
    icon: [512, 512, [], "f689", "M208 96c-49.53 0-89.81 40.3-89.81 89.83 0 34.66 38.34 87.2 70.53 125.2 4.81 5.7 11.84 8.97 19.28 8.97s14.47-3.27 19.31-8.97c32.16-38 70.5-90.55 70.5-125.2C297.81 136.3 257.53 96 208 96zm0 188.23c-35.31-42.7-57.81-80.89-57.81-98.41 0-31.89 25.94-57.83 57.81-57.83s57.81 25.94 57.81 57.83c0 17.52-22.5 55.71-57.81 98.41zM208 160c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm300.47 321.58l-128.99-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3c34.3-37.1 55.3-86.6 55.3-141.09C415.98 93.1 322.88 0 207.99 0S0 93.1 0 207.99c0 114.89 93.1 207.99 207.99 207.99 54.5 0 103.99-21 141.09-55.2v10.2c0 3.2 1.3 6.2 3.5 8.5l128.99 128.99c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.71-4.69 4.71-12.29 0-16.99zm-300.48-97.6C110.7 383.98 32 305.29 32 207.99 32 110.69 110.7 32 207.99 32s175.99 78.7 175.99 175.99c0 97.3-78.69 175.99-175.99 175.99z"]
  },
      $g = {
    prefix: "fal",
    iconName: "search-minus",
    icon: [512, 512, [], "f010", "M307.8 223.8h-200c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12zM508.3 497L497 508.3c-4.7 4.7-12.3 4.7-17 0l-129-129c-2.3-2.3-3.5-5.3-3.5-8.5v-8.5C310.6 395.7 261.7 416 208 416 93.8 416 1.5 324.9 0 210.7-1.5 93.7 93.7-1.5 210.7 0 324.9 1.5 416 93.8 416 208c0 53.7-20.3 102.6-53.7 139.5h8.5c3.2 0 6.2 1.3 8.5 3.5l129 129c4.7 4.7 4.7 12.3 0 17zM384 208c0-97.3-78.7-176-176-176S32 110.7 32 208s78.7 176 176 176 176-78.7 176-176z"]
  },
      cH = {
    prefix: "fal",
    iconName: "search-plus",
    icon: [512, 512, [], "f00e", "M319.8 204v8c0 6.6-5.4 12-12 12h-84v84c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-84h-84c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h84v-84c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12zm188.5 293L497 508.3c-4.7 4.7-12.3 4.7-17 0l-129-129c-2.3-2.3-3.5-5.3-3.5-8.5v-8.5C310.6 395.7 261.7 416 208 416 93.8 416 1.5 324.9 0 210.7-1.5 93.7 93.7-1.5 210.7 0 324.9 1.5 416 93.8 416 208c0 53.7-20.3 102.6-53.7 139.5h8.5c3.2 0 6.2 1.3 8.5 3.5l129 129c4.7 4.7 4.7 12.3 0 17zM384 208c0-97.3-78.7-176-176-176S32 110.7 32 208s78.7 176 176 176 176-78.7 176-176z"]
  },
      eH = {
    prefix: "fal",
    iconName: "seedling",
    icon: [512, 512, [], "f4d8", "M442.7 32c-95.9 0-176.4 79.4-197.2 185.7C210.5 145.1 144.8 96 69.3 96H0v16c0 132.3 90.9 240 202.7 240H240v120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V288h37.3C421.1 288 512 180.3 512 48V32h-69.3zm-240 288C113 320 39.2 235.2 32.5 128h36.8c89.7 0 163.4 84.8 170.2 192h-36.8zm106.6-64h-36.8C279.2 148.8 353 64 442.7 64h36.8c-6.7 107.2-80.5 192-170.2 192z"]
  },
      aH = {
    prefix: "fal",
    iconName: "send-back",
    icon: [640, 512, [], "f87e", "M175 64H79a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm-16 96H95V96h64zm288-16v80h32v-80a48 48 0 0 0-48-48H287v32h144a16 16 0 0 1 16 16zm112 176h-96a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-96a16 16 0 0 0-16-16zm-16 96h-64v-64h64zm48-160H431a48 48 0 0 0-48 48v160a48 48 0 0 0 48 48h160a48 48 0 0 0 48-48V304a48 48 0 0 0-48-48zm16 208a16 16 0 0 1-16 16H431a16 16 0 0 1-16-16V304a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16zm-416-96v-80h-32v80a48 48 0 0 0 48 48h144v-32H207a16 16 0 0 1-16-16zm64-160V48a48 48 0 0 0-48-48H47A48 48 0 0 0-1 48v160a48 48 0 0 0 48 48h160a48 48 0 0 0 48-48zm-224 0V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v160a16 16 0 0 1-16 16H47a16 16 0 0 1-16-16z"]
  },
      nH = {
    prefix: "fal",
    iconName: "send-backward",
    icon: [512, 512, [], "f87f", "M464,160H208a48,48,0,0,0-48,48V464a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V208A48,48,0,0,0,464,160Zm16,304a16,16,0,0,1-16,16H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16H464a16,16,0,0,1,16,16ZM32,304V48A16,16,0,0,1,48,32H304a16,16,0,0,1,16,16v80h32V48A48,48,0,0,0,304,0H48A48,48,0,0,0,0,48V304a48,48,0,0,0,48,48h80V320H48A16,16,0,0,1,32,304Zm400-80H240a16,16,0,0,0-16,16V432a16,16,0,0,0,16,16H432a16,16,0,0,0,16-16V240A16,16,0,0,0,432,224ZM416,416H256V256H416Z"]
  },
      tH = {
    prefix: "fal",
    iconName: "sensor",
    icon: [448, 512, [], "e028", "M384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32Zm32,384a32,32,0,0,1-32,32H64a32,32,0,0,1-32-32V96A32,32,0,0,1,64,64H384a32,32,0,0,1,32,32ZM112,128a16,16,0,0,0-16,16V272a16,16,0,0,0,32,0V144A16,16,0,0,0,112,128Zm64,0a16,16,0,0,0-16,16V272a16,16,0,0,0,32,0V144A16,16,0,0,0,176,128Zm64,0a16,16,0,0,0-16,16V272a16,16,0,0,0,32,0V144A16,16,0,0,0,240,128Z"]
  },
      rH = {
    prefix: "fal",
    iconName: "sensor-alert",
    icon: [640, 512, [], "e029", "M629.89,368.26l-117.31-203a74.6,74.6,0,0,0-129.15,0l-117.32,203A74.49,74.49,0,0,0,330.68,480H565.32a74.49,74.49,0,0,0,64.57-111.74ZM565.32,448H330.68c-32.76,0-53.25-35.4-36.88-63.73l117.33-203a42.61,42.61,0,0,1,73.75,0l117.32,203C618.57,412.6,598.08,448,565.32,448ZM448,368.17a20,20,0,1,0,20,20A20,20,0,0,0,448,368.17ZM462,248.43h-27.9a10,10,0,0,0-9.95,11l8,79.82a10,10,0,0,0,9.95,9H454a10,10,0,0,0,9.95-9l8-79.82A10,10,0,0,0,462,248.43ZM233.86,448H64a32,32,0,0,1-32-32V96A32,32,0,0,1,64,64H384a32,32,0,0,1,32,32v5a107.62,107.62,0,0,1,32-5,64,64,0,0,0-64-64H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H254.47a108.3,108.3,0,0,1-16.16-21.31C236.33,455.27,235.43,451.55,233.86,448ZM224,144V272a16,16,0,0,0,32,0V144a16,16,0,0,0-32,0Zm-64,0V272a16,16,0,0,0,32,0V144a16,16,0,0,0-32,0Zm-64,0V272a16,16,0,0,0,32,0V144a16,16,0,0,0-32,0Z"]
  },
      iH = {
    prefix: "fal",
    iconName: "sensor-fire",
    icon: [640, 512, [], "e02a", "M544,154.44C531.25,166,522.08,174,508.59,188.5c-26.35-32.29-51-53.82-64.59-66.06C325.57,229.47,320,304.05,320,320c0,88.22,71.78,160,160,160s160-71.78,160-160C640,243.09,551.71,161.41,544,154.44ZM480,448A128.13,128.13,0,0,1,352,320c0-38.25,38.88-102.72,92-154.12a461.15,461.15,0,0,1,51,57.18l12.09,16.22,13-15.5c7.53-9,15.5-17.56,23.75-25.66C583.34,239.06,608,295.72,608,320A128.13,128.13,0,0,1,480,448ZM160,144V272a16,16,0,0,0,32,0V144a16,16,0,0,0-32,0ZM64,448a32,32,0,0,1-32-32V96A32,32,0,0,1,64,64H384a32,32,0,0,1,32,32v8.61c8.47-7.65,2.43-2.86,30.11-23.4A63.9,63.9,0,0,0,384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H374.1a193.09,193.09,0,0,1-36.8-32ZM224,144V272a16,16,0,0,0,32,0V144a16,16,0,0,0-32,0ZM96,144V272a16,16,0,0,0,32,0V144a16,16,0,0,0-32,0ZM524.11,257l-25.94,28.75c-17.21-21.26-11.36-14.29-39.89-46.36C417.4,287,398.63,305.84,398.63,337c0,45,35.45,79,82.47,79a84.65,84.65,0,0,0,47.77-14.58c31.94-21.73,41.85-64.36,23.08-99.19C548.74,296.24,548.68,296.33,524.11,257Zm-43,127c-27.83,0-50.47-17.9-50.47-47,0-14.48,9.37-27.25,28.08-49,2.67,3,38.11,47,38.11,47l22.62-25.07C546.3,353,514.05,384,481.1,384Z"]
  },
      oH = {
    prefix: "fal",
    iconName: "sensor-on",
    icon: [640, 512, [], "e02b", "M528,144a16.16,16.16,0,0,0,7.16-1.68l64-32a16,16,0,0,0-14.32-28.63l-64,32A16,16,0,0,0,528,144Zm96,96H528a16,16,0,1,0,0,32h96a16,16,0,0,0,0-32ZM384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32Zm32,384a32,32,0,0,1-32,32H64a32,32,0,0,1-32-32V96A32,32,0,0,1,64,64H384a32,32,0,0,1,32,32ZM112,128a16,16,0,0,0-16,16V272a16,16,0,0,0,32,0V144A16,16,0,0,0,112,128Zm64,0a16,16,0,0,0-16,16V272a16,16,0,0,0,32,0V144A16,16,0,0,0,176,128Zm64,0a16,16,0,0,0-16,16V272a16,16,0,0,0,32,0V144A16,16,0,0,0,240,128ZM599.16,401.7l-64-32a16,16,0,0,0-14.32,28.63l64,32a16,16,0,0,0,14.32-28.63Z"]
  },
      lH = {
    prefix: "fal",
    iconName: "sensor-smoke",
    icon: [640, 512, [], "e02c", "M586.25,293.61a72.1,72.1,0,0,0-71.58-64.28,71.34,71.34,0,0,0-22.29,3.55,98.67,98.67,0,0,0-168.77,54.79A98.67,98.67,0,0,0,354.67,480H541.33a98.59,98.59,0,0,0,44.92-186.39ZM541.33,448H354.67a66.67,66.67,0,1,1,0-133.33c.46,0,.9.12,1.36.13a66.6,66.6,0,0,1,127.19-37.92,39.83,39.83,0,0,1,68.67,38.85A66.55,66.55,0,0,1,541.33,448ZM224,144V272a16,16,0,0,0,32,0V144a16,16,0,0,0-32,0ZM64,448a32,32,0,0,1-32-32V96A32,32,0,0,1,64,64H384a32,32,0,0,1,32,32v75.11c1.8-.07,3.52-.44,5.33-.44a131.76,131.76,0,0,1,26.67,3V96a64,64,0,0,0-64-64H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H270a130.94,130.94,0,0,1-27.06-32Zm96-304V272a16,16,0,0,0,32,0V144a16,16,0,0,0-32,0Zm-64,0V272a16,16,0,0,0,32,0V144a16,16,0,0,0-32,0Z"]
  },
      fH = {
    prefix: "fal",
    iconName: "server",
    icon: [512, 512, [], "f233", "M376 256c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm-40 24c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24zm176-128c0 12.296-4.629 23.507-12.232 32 7.603 8.493 12.232 19.704 12.232 32v80c0 12.296-4.629 23.507-12.232 32 7.603 8.493 12.232 19.704 12.232 32v80c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-80c0-12.296 4.629-23.507 12.232-32C4.629 319.507 0 308.296 0 296v-80c0-12.296 4.629-23.507 12.232-32C4.629 175.507 0 164.296 0 152V72c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v80zm-480 0c0 8.822 7.178 16 16 16h416c8.822 0 16-7.178 16-16V72c0-8.822-7.178-16-16-16H48c-8.822 0-16 7.178-16 16v80zm432 48H48c-8.822 0-16 7.178-16 16v80c0 8.822 7.178 16 16 16h416c8.822 0 16-7.178 16-16v-80c0-8.822-7.178-16-16-16zm16 160c0-8.822-7.178-16-16-16H48c-8.822 0-16 7.178-16 16v80c0 8.822 7.178 16 16 16h416c8.822 0 16-7.178 16-16v-80zm-80-224c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24zm-64 0c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24zm64 240c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"]
  },
      sH = {
    prefix: "fal",
    iconName: "shapes",
    icon: [512, 512, [], "f61f", "M480 288H320c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V320c0-17.67-14.33-32-32-32zm0 192H320V320h160v160zM128 256C57.31 256 0 313.31 0 384s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 224c-52.93 0-96-43.07-96-96 0-52.94 43.07-96 96-96 52.94 0 96 43.06 96 96 0 52.93-43.06 96-96 96zm378.98-278.86L400.07 18.29C392.95 6.1 380.47 0 368 0s-24.95 6.1-32.07 18.29L229.02 201.14c-14.26 24.38 3.56 54.86 32.07 54.86h213.82c28.51 0 46.33-30.48 32.07-54.86zm-27.6 20.39c-.94 1.64-2.45 2.47-4.47 2.47H261.09c-2.02 0-3.53-.83-4.47-2.47-1.21-2.12-.35-3.6.02-4.23L363.55 34.44c.95-1.62 2.44-2.44 4.45-2.44s3.5.82 4.45 2.44L479.36 217.3c.37.63 1.24 2.11.02 4.23z"]
  },
      uH = {
    prefix: "fal",
    iconName: "share",
    icon: [576, 512, [], "f064", "M564.907 196.35L388.91 12.366C364.216-13.45 320 3.746 320 40.016v88.154C154.548 130.155 0 160.103 0 331.19c0 94.98 55.84 150.231 89.13 174.571 24.233 17.722 58.021-4.992 49.68-34.51C100.937 336.887 165.575 321.972 320 320.16V408c0 36.239 44.19 53.494 68.91 27.65l175.998-184c14.79-15.47 14.79-39.83-.001-55.3zm-23.127 33.18l-176 184c-4.933 5.16-13.78 1.73-13.78-5.53V288c-171.396 0-295.313 9.707-243.98 191.7C72 453.36 32 405.59 32 331.19 32 171.18 194.886 160 352 160V40c0-7.262 8.851-10.69 13.78-5.53l176 184a7.978 7.978 0 0 1 0 11.06z"]
  },
      hH = {
    prefix: "fal",
    iconName: "share-all",
    icon: [576, 512, [], "f367", "M470.632 201.371L310.63 41.4C290.59 21.36 256 35.44 256 64.03v72.69C140.5 140.56 0 164.89 0 317.79c0 64.98 33.54 118.26 85.11 155.97 24.19 17.7 58.04-4.92 49.69-34.51-27.7-98.19-.38-122.06 121.2-126.42v71.15c0 28.61 34.61 42.64 54.63 22.63l160.002-159.98c12.491-12.499 12.491-32.759 0-45.259zM288 384.001v-103.9c-145.671 1.326-224.979 22.633-184 167.9-31.51-23.05-72-65.11-72-130.21 0-131.425 125.835-148.345 256-149.69v-104.1l160 160-160 160zm278.628-137.373l-160 159.978c-13.454 13.454-33.492 11.509-45.191.106L544 224.001 361.438 41.294c11.695-11.401 31.723-13.362 45.189.105l160 159.974c12.497 12.497 12.497 32.758.001 45.255z"]
  },
      mH = {
    prefix: "fal",
    iconName: "share-alt",
    icon: [448, 512, [], "f1e0", "M352 320c-28.6 0-54.2 12.5-71.8 32.3l-95.5-59.7c9.6-23.4 9.7-49.8 0-73.2l95.5-59.7c17.6 19.8 43.2 32.3 71.8 32.3 53 0 96-43 96-96S405 0 352 0s-96 43-96 96c0 13 2.6 25.3 7.2 36.6l-95.5 59.7C150.2 172.5 124.6 160 96 160c-53 0-96 43-96 96s43 96 96 96c28.6 0 54.2-12.5 71.8-32.3l95.5 59.7c-4.7 11.3-7.2 23.6-7.2 36.6 0 53 43 96 96 96s96-43 96-96c-.1-53-43.1-96-96.1-96zm0-288c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm256 160c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"]
  },
      vH = {
    prefix: "fal",
    iconName: "share-alt-square",
    icon: [448, 512, [], "f1e1", "M288 232c30.9 0 56-25.1 56-56s-25.1-56-56-56-56 25.1-56 56c0 3.2.3 6.5.9 9.7l-53.6 26.8c-9.6-7.8-21.9-12.5-35.2-12.5-30.9 0-56 25.1-56 56s25.1 56 56 56c13.4 0 25.6-4.7 35.2-12.5l53.6 26.8c-.5 3.1-.9 6.4-.9 9.7 0 30.9 25.1 56 56 56s56-25.1 56-56-25.1-56-56-56c-16.1 0-30.6 6.8-40.8 17.7l-49.7-24.9c3.4-11 3.4-22.7 0-33.6l49.7-24.9c10.2 10.9 24.7 17.7 40.8 17.7zm0-80c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM144 280c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24zm144 32c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16z"]
  },
      dH = {
    prefix: "fal",
    iconName: "share-square",
    icon: [576, 512, [], "f14d", "M566.633 169.37L406.63 9.392C386.626-10.612 352 3.395 352 32.022v72.538C210.132 108.474 88 143.455 88 286.3c0 84.74 49.78 133.742 79.45 155.462 24.196 17.695 58.033-4.917 49.7-34.51C188.286 304.843 225.497 284.074 352 280.54V352c0 28.655 34.654 42.606 54.63 22.63l160.003-160c12.489-12.5 12.489-32.76 0-45.26zM384 352V248.04c-141.718.777-240.762 15.03-197.65 167.96C154.91 393 120 351.28 120 286.3c0-134.037 131.645-149.387 264-150.26V32l160 160-160 160zm37.095 52.186c2.216-1.582 4.298-3.323 6.735-5.584 7.68-7.128 20.17-1.692 20.17 8.787V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h172.146c6.612 0 11.954 5.412 11.852 12.04-.084 5.446-4.045 10.087-9.331 11.396-9.462 2.343-18.465 4.974-27.074 7.914-1.25.427-2.555.65-3.876.65H48c-8.837 0-16 7.163-16 16v352c0 8.837 7.163 16 16 16h352c8.837 0 16-7.163 16-16v-50.002c0-3.905 1.916-7.543 5.095-9.812z"]
  },
      MH = {
    prefix: "fal",
    iconName: "sheep",
    icon: [640, 512, [], "f711", "M496 96c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm117.31 11.61L576 89.27V80c0-26.47-21.53-48-48-48h-50.75C470.66 13.38 452.88 0 432 0c-26.47 0-48 21.53-48 48v53.01c-1.24-.36-2.38-.97-3.66-1.25-14.03-3.38-28.38-1.34-40.94 5.41-9.03-5.7-19.72-8.89-31.53-9.17-10.78 0-20.94 2.78-29.91 8.12-18-10.59-41.62-10.58-59.56-.05-18.31-10.89-43.09-10.45-61.16 1-12.28-6.66-26.56-8.7-40.88-5.67-17.03 3.84-31.41 14.97-39.62 30.16-16.94.88-33.06 9.11-44.12 23.12-10.81 13.95-15.06 31.86-12.12 48.95C7.62 213.09 0 229.81 0 247.69c0 17.91 7.5 34.59 20.19 46-3.06 17.3 1.25 35.27 12.12 48.98 10.78 14.02 26.78 22.3 43.78 23.16 4.83 9.1 11.99 16.48 20.41 21.98.14 3.96.33 7.93 1.26 11.81l21.12 87.86C122.34 501.86 135.21 512 150 512h57.53c20.95 0 36.12-19.76 31.02-39.86l-20.29-80.07a57.854 57.854 0 0 0 29.3 7.93c10.62 0 20.88-2.84 29.91-8.17 9.16 5.31 20.62 8.56 31.84 8.02 3.67-.12 7.17-1 10.69-1.77V480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V356.83c5.69-3.63 11.01-7.98 15.38-13.51 10.81-13.95 15.06-31.86 12.12-48.95 12.88-11.45 20.5-28.17 20.5-46.05 0-8.54-1.81-16.77-4.97-24.31h92.63c14.91 0 28.81-8.03 36.28-21.02 17.97-31.55 20.06-45.08 20.06-52.52 0-18.35-10.22-34.77-26.69-42.86zM150 480l-19.82-82.44c9.14-.19 18.15-2.34 26.38-6.72 9.03 5.79 19.79 8.77 30.64 8.92L207.53 480H150zm266 0h-64v-84.09c8.85 2.29 18.22 2.72 27.62.68 15.13-3.41 27.89-12.78 36.38-25.42V480zm33.34-206.05l-12.22 6.84 5.16 13.02c8.51 21.38-9.05 44.04-30.59 40.3l-14.16-2.52-4.03 13.78c-5.48 18.83-28.59 28.04-44.84 13.67l-11.44-10.14-10.66 10.95c-8.68 8.94-25.64 12.3-38.12.45l-11.06-10.53-11.03 10.58c-10.31 9.92-27.25 9.91-37.16.16l-11.06-10.92-11.22 10.77c-10.59 10.09-28.12 9.72-38-.47l-10.44-10.83-11.44 9.77c-17.43 14.83-39.91 4.28-45.06-13.95L98 330.92l-14.25 2.56c-21.2 3.8-38.89-18.69-30.34-40.3l5.16-13.02-12.22-6.84c-18.61-10.44-19.64-40.06.31-51.28l12.22-6.84-5.16-13.02c-8.56-21.51 9.19-44.04 30.59-40.3l14.16 2.52 4.03-13.78c5.54-19.02 28.75-27.9 44.84-13.67l11.44 10.14 10.66-10.95c9.91-10.23 27.62-10.58 37.56-.69l11.09 10.97 11.25-10.77c10.28-9.88 27.25-9.89 37.66.02l11.06 10.56 11.06-10.59c10.49-10.05 27.6-10.21 37.97.48l10.44 10.8 11.44-9.75c17.4-14.87 39.91-4.26 45.06 13.95l3.97 13.95 14.25-2.56c21.24-3.85 38.87 18.75 30.34 40.3l-5.16 13.02 12.22 6.84c18.62 10.44 19.64 40.07-.31 51.28zm142.82-86.87c-1.75 3.08-4.94 4.92-8.5 4.92H476.55c.14-13.93-4.14-27.67-12.86-38.67-10.78-14.02-26.78-22.3-43.78-23.16-1.1-2.08-2.59-3.87-3.91-5.79V48c0-8.83 7.19-16 16-16s16 7.17 16 16v16h80c8.81 0 16 7.17 16 16v29.17l55.19 27.16c5.44 2.67 8.81 8.09 8.81 14.14 0 3.28-3.34 14.7-15.84 36.61z"]
  },
      pH = {
    prefix: "fal",
    iconName: "shekel-sign",
    icon: [384, 512, [], "f20b", "M224 152v208c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V152c0-66.28-53.73-120-120-120H16C7.16 32 0 39.16 0 48v424c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V80h104c39.76 0 72 32.23 72 72zM376 32h-32c-4.42 0-8 3.58-8 8v320c0 39.76-32.24 72-72 72H160V152c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v312c0 8.84 7.16 16 16 16h136c66.27 0 120-53.73 120-120V40c0-4.42-3.58-8-8-8z"]
  },
      zH = {
    prefix: "fal",
    iconName: "shield",
    icon: [512, 512, [], "f132", "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM262.2 478.8c-3.9 1.6-8.3 1.6-12.3 0C152 440 48 304 48 128c0-6.5 3.9-12.3 9.8-14.8l192-80c3.8-1.6 8.3-1.7 12.3 0l192 80c6 2.5 9.8 8.3 9.8 14.8.1 176-103.9 312-201.7 350.8z"]
  },
      CH = {
    prefix: "fal",
    iconName: "shield-alt",
    icon: [512, 512, [], "f3ed", "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM262.2 478.8c-4 1.6-8.4 1.6-12.3 0C152 440 48 304 48 128c0-6.5 3.9-12.3 9.8-14.8l192-80c3.9-1.6 8.4-1.6 12.3 0l192 80c6 2.5 9.9 8.3 9.8 14.8.1 176-103.9 312-201.7 350.8zM256 411V100l-142.7 59.5c10.1 120.1 77.1 215 142.7 251.5zm-32-66.8c-36.4-39.9-65.8-97.8-76.1-164.5L224 148z"]
  },
      LH = {
    prefix: "fal",
    iconName: "shield-check",
    icon: [512, 512, [], "f2f7", "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM262.2 478.8c-4 1.6-8.4 1.6-12.3 0C152 440 48 304 48 128c0-6.5 3.9-12.3 9.8-14.8l192-80c3.9-1.6 8.4-1.6 12.3 0l192 80c6 2.5 9.9 8.3 9.8 14.8.1 176-103.9 312-201.7 350.8zm136.2-325c-4.7-4.7-12.3-4.7-17-.1L218 315.8l-69-69.5c-4.7-4.7-12.3-4.7-17-.1l-8.5 8.5c-4.7 4.7-4.7 12.3-.1 17l85.9 86.6c4.7 4.7 12.3 4.7 17 .1l180.5-179c4.7-4.7 4.7-12.3.1-17z"]
  },
      AH = {
    prefix: "fal",
    iconName: "shield-cross",
    icon: [448, 512, [], "f712", "M420.43 83.69l-179.2-80C235.72 1.23 229.86 0 224 0s-11.72 1.23-17.23 3.69l-179.2 80C10.88 91.14 0 108.62 0 128c0 198.49 106.86 335.71 206.77 380.31 5.51 2.46 11.37 3.69 17.23 3.69s11.72-1.23 17.23-3.69C321.13 472.64 448 349.28 448 128c0-19.38-10.88-36.86-27.57-44.31zM32 128c0-6.72 3.46-12.79 8.62-15.09L176 52.47V144H32.53c-.17-5.34-.53-10.56-.53-16zm144 324.7C120.23 410.83 68.46 337.57 45.13 240H176v212.7zm96-.56V240h131.28C378.36 345.18 321.12 414.46 272 452.14zM409.58 208H240v265.19c-4.09 2.22-8.07 4.23-11.81 5.9-1.57.7-4.69 1.64-8.37 0-3.92-1.75-7.87-3.88-11.81-5.96V208H38.69a478.05 478.05 0 0 1-4.15-32H208V38.19l11.81-5.27c3.68-1.64 6.79-.71 8.37 0L240 38.19V176h173.54c-1.02 10.95-2.29 21.67-3.96 32zm5.84-64H272V52.47l135.39 60.44c5.15 2.3 8.61 8.36 8.61 15.09 0 5.5-.42 10.64-.58 16z"]
  },
      NH = {
    prefix: "fal",
    iconName: "shield-virus",
    icon: [512, 512, [], "e06c", "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.12,48.12,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM262.13,478.77a16.1,16.1,0,0,1-12.32,0C152.61,438.27,48,311.21,48,128a15.9,15.9,0,0,1,9.9-14.76L249.76,33.27A30,30,0,0,1,256.05,32a30.64,30.64,0,0,1,6.14,1.21l192,80A16.1,16.1,0,0,1,464,128C464,338.91,331.93,449.68,262.13,478.77ZM384,224H371.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58a31.32,31.32,0,0,1-22.4,9.43c-16.45,0-32.23-12.77-32.23-32.06V112a16,16,0,0,0-32,0v12.12c0,19.29-15.78,32.06-32.23,32.06a31.34,31.34,0,0,1-22.4-9.43l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H128a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58a31.3,31.3,0,0,1,22.4-9.43c16.45,0,32.23,12.77,32.23,32.06V368a16,16,0,0,0,32,0V355.88c0-19.29,15.78-32.07,32.23-32.06a31.34,31.34,0,0,1,22.4,9.43l8.57,8.58a16,16,0,0,0,22.63-22.63l-8.58-8.57C329.09,290.47,343.37,256,371.88,256H384a16,16,0,0,0,0-32Zm-71.25,39.51A64.17,64.17,0,0,0,308,291.92c-1.23-.07-2.48-.1-3.73-.1a64.37,64.37,0,0,0-44.12,17.41c-1.48,1.37-2.87,2.81-4.19,4.29a64.18,64.18,0,0,0-48.15-21.7c-1.25,0-2.49,0-3.73.11A64.38,64.38,0,0,0,182.51,240,64.38,64.38,0,0,0,204,188.08c1.23.07,2.48.1,3.73.1A64.17,64.17,0,0,0,256,166.38a64.17,64.17,0,0,0,48.23,21.8c1.25,0,2.5,0,3.73-.1A64.38,64.38,0,0,0,329.49,240,64.11,64.11,0,0,0,312.75,263.51ZM240,208a16,16,0,1,0,16,16A16,16,0,0,0,240,208Z"]
  },
      gH = {
    prefix: "fal",
    iconName: "ship",
    icon: [640, 512, [], "f21a", "M480 366.077l85.182-78.083c18.063-16.557 12.34-44.442-8.577-53.406L480 201.756V80c0-8.837-7.163-16-16-16h-48V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-48c-8.837 0-16 7.163-16 16v121.756l-76.055 32.595c-22.484 9.636-26.373 37.834-9.568 53.238L160 366.077C160 402.167 109.048 480 12 480c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12 65.489 0 117.316-28.984 150.756-73.148C173.036 480.79 210.938 512 256 512h128c45.062 0 82.964-31.21 93.244-73.148C510.878 483.273 562.822 512 628 512c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12-93.623 0-148-74.786-148-113.923zM256 32h128v32H256V32zm-64 64h256v92.042l-115.395-49.455a31.999 31.999 0 0 0-25.211 0L192 188.042V96zm256 256v64c0 35.346-28.654 64-64 64H256c-35.346 0-64-28.654-64-64v-64l-96-88 224-96 224 96-96 88z"]
  },
      HH = {
    prefix: "fal",
    iconName: "shipping-fast",
    icon: [640, 512, [], "f48b", "M280 192c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240zm352 192h-24V275.9c0-16.8-6.8-33.3-18.8-45.2l-83.9-83.9c-11.8-12-28.3-18.8-45.2-18.8H416V78.6c0-25.7-22.2-46.6-49.4-46.6H113.4C86.2 32 64 52.9 64 78.6V96H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H96V78.6c0-8.1 7.8-14.6 17.4-14.6h253.2c9.6 0 17.4 6.5 17.4 14.6V384H207.6C193 364.7 170 352 144 352c-18.1 0-34.6 6.2-48 16.4V288H64v144c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h195.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H632c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-488 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm272-320h44.1c8.4 0 16.7 3.4 22.6 9.4l83.9 83.9c.8.8 1.1 1.9 1.8 2.8H416V160zm80 320c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-96h-16.4C545 364.7 522 352 496 352s-49 12.7-63.6 32H416v-96h160v96zM256 248v-16c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8z"]
  },
      VH = {
    prefix: "fal",
    iconName: "shipping-timed",
    icon: [640, 512, [], "f48c", "M208 96c-66.2 0-120 53.8-120 120s53.8 120 120 120 120-53.8 120-120S274.2 96 208 96zm0 208c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm40-80h-24v-56c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm384 160h-24V275.9c0-16.8-6.8-33.3-18.8-45.2l-83.9-83.9c-11.8-12-28.3-18.8-45.2-18.8H416V78.6c0-25.7-22.2-46.6-49.4-46.6H49.4C22.2 32 0 52.9 0 78.6v290.8C0 395.1 22.2 416 49.4 416h16.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h195.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H632c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-488 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm240-96H207.6C193 364.7 170 352 144 352s-49 12.7-63.6 32h-31c-9.6 0-17.4-6.5-17.4-14.6V78.6C32 70.5 39.8 64 49.4 64h317.2c9.6 0 17.4 6.5 17.4 14.6V384zm32-224h44.1c8.4 0 16.7 3.4 22.6 9.4l83.9 83.9c.8.8 1.1 1.9 1.8 2.8H416V160zm80 320c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-96h-16.4C545 364.7 522 352 496 352s-49 12.7-63.6 32H416v-96h160v96z"]
  },
      xH = {
    prefix: "fal",
    iconName: "shish-kebab",
    icon: [512, 512, [], "f821", "M511.21 84.17c-3.75-29.74-21.09-55.74-47.52-71.32a94.9 94.9 0 0 0-96.22.5c-23.7 14.27-39.82 36.62-45.41 63s.18 53.93 14.87 76.37l-25.78 25.76-42.44-42.45a62.59 62.59 0 0 0-88.54 0l-42.31 42.31A62.3 62.3 0 0 0 119.62 226 62.39 62.39 0 0 0 72 244.28l-42.3 42.3a62.68 62.68 0 0 0 0 88.54L72 417.45 2.34 487a8 8 0 0 0 0 11.32l11.31 11.31a8 8 0 0 0 11.32 0l69.64-69.58 42.27 42.27a62.57 62.57 0 0 0 88.54 0l42.3-42.3A62.4 62.4 0 0 0 286 392.38a62.34 62.34 0 0 0 47.67-18.25l42.29-42.3a62.56 62.56 0 0 0 0-88.54l-42.15-42.15 25.78-25.75c10.85-10.84 13.08-27.69 5.53-40.07-6.3-10.35-12.12-21.3-13-33.39-1.79-25.28 10-47.52 30.85-60.55 19.09-11.92 44.05-12.64 63.6-1.48 18.32 10.48 30.35 28.1 32.92 48.31A63.64 63.64 0 0 1 466.18 136a8 8 0 0 0 .3 10.76l11.44 11.44a8 8 0 0 0 11.64-.25 95.23 95.23 0 0 0 21.65-73.78zM245.09 417.42l-42.3 42.3a30.6 30.6 0 0 1-43.28 0L52.28 352.49a30.6 30.6 0 0 1 0-43.28l42.3-42.3a30.59 30.59 0 0 1 43.28 0l107.23 107.23a30.59 30.59 0 0 1 0 43.28zm108.22-151.5a30.62 30.62 0 0 1 0 43.29L311 351.51a30.62 30.62 0 0 1-43.29 0L160.49 244.28a30.62 30.62 0 0 1 0-43.29l42.3-42.3a30.62 30.62 0 0 1 43.29 0z"]
  },
      wH = {
    prefix: "fal",
    iconName: "shoe-prints",
    icon: [640, 512, [], "f54b", "M337.46 272c-34.91 0-76.16 14.06-104.73 34.29-24.79 17.55-44.52 34.29-104.73 34.29H64c-35.35 0-64 30.7-64 68.57S28.65 480 64 480h64l57.53 14.82C217.42 504.3 250.17 512 293.3 512 403.84 512 512 456.84 512 374.86 512 306.29 427.82 272 337.46 272zM112 448H64c-17.05 0-32-18.16-32-38.86 0-20.17 14.36-36.57 32-36.57h48V448zm81.51 15.84L144 451.08v-79.11c55.33-2.95 80.75-20.66 103.08-36.62C338.33 270.38 480 316.73 480 374.86c0 62.15-121.49 137.92-286.49 88.98zM421.29 0c-43.42 0-76.17 7.78-107.77 17.17L256 32h-64c-35.35 0-64 32.98-64 70.86 0 37.87 28.65 68.57 64 68.57h64c60.2 0 79.94 16.73 104.73 34.29C389.3 225.94 430.54 240 465.46 240 555.82 240 640 205.71 640 137.14 640 55.84 533.12 0 421.29 0zM240 139.43h-48c-17.64 0-32-16.4-32-36.57C160 82.16 174.95 64 192 64h48v75.43zM465.46 208c-27.58 0-62.24-11.41-86.24-28.4-23.71-16.89-48.76-36.45-107.22-39.56V60.92l50.65-13.07C352.05 39.1 381.72 32 421.29 32 473.38 32 608 58.02 608 137.14c0 46.52-71.71 70.86-142.54 70.86z"]
  },
      yH = {
    prefix: "fal",
    iconName: "shopping-bag",
    icon: [448, 512, [], "f290", "M352 128C352 57.421 294.579 0 224 0 153.42 0 96 57.421 96 128H0v304c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V128h-96zM224 32c52.935 0 96 43.065 96 96H128c0-52.935 43.065-96 96-96zm192 400c0 26.467-21.533 48-48 48H80c-26.467 0-48-21.533-48-48V160h64v48c0 8.837 7.164 16 16 16s16-7.163 16-16v-48h192v48c0 8.837 7.163 16 16 16s16-7.163 16-16v-48h64v272z"]
  },
      bH = {
    prefix: "fal",
    iconName: "shopping-basket",
    icon: [576, 512, [], "f291", "M564 192h-76.875L347.893 37.297c-5.91-6.568-16.027-7.101-22.596-1.189s-7.101 16.028-1.189 22.596L444.075 192h-312.15L251.893 58.703c5.912-6.567 5.379-16.685-1.189-22.596-6.569-5.912-16.686-5.38-22.596 1.189L88.875 192H12c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h16.444L58.25 438.603C61.546 462.334 81.836 480 105.794 480h364.412c23.958 0 44.248-17.666 47.544-41.397L547.556 224H564c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12zm-77.946 242.201c-1.093 7.867-7.906 13.799-15.848 13.799H105.794c-7.942 0-14.755-5.932-15.848-13.799L60.752 224h454.497l-29.195 210.201zM304 280v112c0 8.837-7.163 16-16 16-8.836 0-16-7.163-16-16V280c0-8.837 7.164-16 16-16 8.837 0 16 7.163 16 16zm112 0v112c0 8.837-7.163 16-16 16s-16-7.163-16-16V280c0-8.837 7.163-16 16-16s16 7.163 16 16zm-224 0v112c0 8.837-7.164 16-16 16s-16-7.163-16-16V280c0-8.837 7.164-16 16-16s16 7.163 16 16z"]
  },
      SH = {
    prefix: "fal",
    iconName: "shopping-cart",
    icon: [576, 512, [], "f07a", "M551.991 64H129.28l-8.329-44.423C118.822 8.226 108.911 0 97.362 0H12C5.373 0 0 5.373 0 12v8c0 6.627 5.373 12 12 12h78.72l69.927 372.946C150.305 416.314 144 431.42 144 448c0 35.346 28.654 64 64 64s64-28.654 64-64a63.681 63.681 0 0 0-8.583-32h145.167a63.681 63.681 0 0 0-8.583 32c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64 0-17.993-7.435-34.24-19.388-45.868C506.022 391.891 496.76 384 485.328 384H189.28l-12-64h331.381c11.368 0 21.177-7.976 23.496-19.105l43.331-208C578.592 77.991 567.215 64 551.991 64zM240 448c0 17.645-14.355 32-32 32s-32-14.355-32-32 14.355-32 32-32 32 14.355 32 32zm224 32c-17.645 0-32-14.355-32-32s14.355-32 32-32 32 14.355 32 32-14.355 32-32 32zm38.156-192H171.28l-36-192h406.876l-40 192z"]
  },
      TH = {
    prefix: "fal",
    iconName: "shovel",
    icon: [512, 512, [], "f713", "M501.55 86.12l-75.67-75.67C418.91 3.48 409.76 0 400.6 0s-18.3 3.48-25.27 10.45l-29.2 29.19C329.21 56.57 320 79.24 320 102.68c0 24.51 9.79 41.81 15.96 50.74L208.67 280.7l-56.57-56.57c-6.25-6.25-14.44-9.37-22.63-9.37s-16.38 3.12-22.63 9.37l-67.88 67.88C-11.02 342-6.29 473.03 16.34 495.66c9.87 9.87 40.39 16.34 75.8 16.34 45.75 0 99.67-10.79 127.85-38.97l67.88-67.88c12.5-12.5 12.5-32.76 0-45.25l-56.57-56.57 127.28-127.28c8.92 6.16 26.26 15.96 50.76 15.96 23.41 0 46.09-9.22 63.01-26.13l29.19-29.2c13.94-13.95 13.94-36.62.01-50.56zM197.36 450.41C160.69 487.07 63 483.13 39.2 472.67c-10.64-22.12-13.59-122.04 22.4-158.03l67.85-67.88h.03l135.76 135.77-67.88 67.88zm281.56-336.37l-29.19 29.19c-52.79 52.79-134.1-27.84-80.96-80.96l29.2-29.2c1.45-1.45 3.84-1.45 5.29 0l75.67 75.68c1.44 1.45 1.44 3.84-.01 5.29z"]
  },
      DH = {
    prefix: "fal",
    iconName: "shovel-snow",
    icon: [512, 512, [], "f7c3", "M180.7 244.7l-80 80c-6.2 6.2-6.2 16.4 0 22.6 3.1 3.1 7.2 4.7 11.3 4.7 4.1 0 8.2-1.6 11.3-4.7l80-80c6.2-6.2 6.2-16.4 0-22.6-6.2-6.3-16.4-6.3-22.6 0zm-16 166.6c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7l80-80c6.2-6.2 6.2-16.4 0-22.6-6.2-6.3-16.4-6.3-22.6 0l-80 80c-6.3 6.2-6.3 16.4 0 22.6zM502.6 65.9L446.1 9.4C439.8 3.1 431.6 0 423.4 0S407 3.1 400.8 9.4l-17 17c-24.2 24.2-27.4 61.3-10 89.1L267.6 221.8l-47.2-47.2c-9.7-9.7-22.5-14.6-35.3-14.6-10.7 0-21.5 3.4-30.5 10.4L19.4 274.9c-23.8 18.4-26.1 53.5-4.8 74.8l147.7 147.7c9.8 9.8 22.6 14.6 35.3 14.6 14.8 0 29.6-6.6 39.5-19.4l104.5-135.2c15.4-19.9 13.6-48.1-4.2-65.8l-47.2-47.2 106.3-106.3c11.7 7.3 24.9 11.1 38.2 11.1 18.4 0 36.9-7 50.9-21.1l17-17c12.5-12.4 12.5-32.7 0-45.2zM314.7 314.2c6.4 6.4 7 16.5 1.5 23.6L211.8 473c-3.4 4.4-8.6 7-14.2 7-2.8 0-8.1-.7-12.7-5.3L37.3 327.1c-5-5-5.4-10.8-5.2-13.8.2-3 1.3-8.7 6.9-13l135.2-104.5c4-3.1 8.2-3.7 10.9-3.7 4.8 0 9.3 1.9 12.7 5.3l116.9 116.8zM463 105.5c-7.6 7.6-17.6 11.7-28.3 11.7s-20.7-4.2-28.3-11.7c-7.6-7.6-11.7-17.6-11.7-28.3s4.2-20.7 11.7-28.3l16.9-17L480 88.6l-17 16.9z"]
  },
      jH = {
    prefix: "fal",
    iconName: "shower",
    icon: [512, 512, [], "f2cc", "M336,320a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm32-128a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm0,96a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm64,32a16,16,0,1,0-16-16A16,16,0,0,0,400,256Zm32-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224ZM304,256a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm0,64a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm0,64a16,16,0,1,0,16,16A16,16,0,0,0,304,384ZM432,256a16,16,0,1,0,16,16A16,16,0,0,0,432,256ZM381.66,104.64,370.34,93.32a8,8,0,0,0-11.31,0l-5.91,5.91A110.48,110.48,0,0,0,205.25,86.62L181.81,63.2A106.5,106.5,0,0,0,0,138.52V472a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V138.52A74.5,74.5,0,0,1,159.19,85.83l23.43,23.42a110.48,110.48,0,0,0,12.61,147.87L189.32,263a8,8,0,0,0,0,11.31l11.32,11.32a8,8,0,0,0,11.31,0L381.66,116A8,8,0,0,0,381.66,104.64ZM218,234.34A78.84,78.84,0,0,1,192,176a80.09,80.09,0,0,1,80-80,78.84,78.84,0,0,1,58.34,26ZM496,192a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224ZM336,352a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Z"]
  },
      EH = {
    prefix: "fal",
    iconName: "shredder",
    icon: [512, 512, [], "f68a", "M432 192h-16v-82.75c0-8.49-3.37-16.62-9.37-22.63L329.37 9.37c-6-6-14.14-9.37-22.63-9.37H126.48C109.64 0 96 14.33 96 32v160H80c-44.18 0-80 35.82-80 80v96c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-96c0-44.18-35.82-80-80-80zM320 45.25L370.75 96H320V45.25zM128.12 32H288v64c0 17.67 14.33 32 32 32h64v64H128.02l.1-160zM480 352H32v-80c0-26.47 21.53-48 48-48h352c26.47 0 48 21.53 48 48v80zm-80-88c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zM48 504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-88H48v88zm96 0c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-88h-32v88zm96 0c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-88h-32v88zm96 0c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-88h-32v88zm96 0c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-88h-32v88z"]
  },
      kH = {
    prefix: "fal",
    iconName: "shuttle-van",
    icon: [640, 512, [], "f5b6", "M625.17 238.2L499.19 87.03A64.006 64.006 0 0 0 450.02 64H48C21.49 64 0 85.49 0 112v272c0 17.67 14.33 32 32 32h33.62c7.43 36.47 39.75 64 78.38 64s70.95-27.53 78.38-64h195.24c7.43 36.47 39.75 64 78.38 64s70.95-27.53 78.38-64H608c17.67 0 32-14.33 32-32V279.17c0-14.97-5.25-29.47-14.83-40.97zM352 96h98.02c9.53 0 18.48 4.2 24.58 11.51L571.68 224H352V96zm-160 0h128v128H192V96zM32 112c0-8.82 7.18-16 16-16h112v128H32V112zm112 336c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm352 0c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm112-64h-33.62c-7.43-36.47-39.75-64-78.38-64s-70.95 27.53-78.38 64H222.38c-7.43-36.47-39.75-64-78.38-64s-70.95 27.53-78.38 64H32V256h566.35l2.23 2.68a32.093 32.093 0 0 1 7.42 20.49V384z"]
  },
      IH = {
    prefix: "fal",
    iconName: "shuttlecock",
    icon: [512, 512, [], "f45b", "M480 192h-61.6l10.4-72.6c3-20.8-14.5-39.1-36.2-36.2L320 93.6V32c0-17.7-14.3-32-32-32h-43.1c-12.2 0-23.5 7.1-28.8 18.1l-118 245.8-67 67c-41.4 41.4-41.4 108.6 0 150 20.7 20.7 47.8 31.1 75 31.1 27.1 0 54.3-10.4 75-31.1l67-67 245.8-118c11-5.3 18.1-16.6 18.1-28.8V224c0-17.7-14.3-32-32-32zm-82.9-77.1l-11.4 80.2L294 218l22.9-91.7 80.2-11.4zM244.9 32H288v70.3l-102.4 53.3L244.9 32zm35 110.6l-22.3 89.2-87.8 87.8-42.4-42.4 35.2-73.5 117.3-61.1zM32 406c0-18.6 7-36 19.5-49.6l104.2 104.2C142 473 124.6 480 106 480c-40.9 0-74-33.1-74-74zm146.5 32.2L73.8 333.5l32.2-32.2L210.7 406l-32.2 32.2zm56.3-53.5l-42.4-42.4 87.8-87.8 89.2-22.3-61.1 117.3-73.5 35.2zM480 267l-123.6 59.4L409.7 224H480v43z"]
  },
      OH = {
    prefix: "fal",
    iconName: "sickle",
    icon: [512, 512, [], "f822", "M511.54 160.28C500.73 104.84 445.48 0 313.94 0c-92 0-170.24 64.23-190.24 156.2-6.23 28.67-7.3 64.76-1.57 97.92l-49.55 49.54a16 16 0 0 0 0 22.63l11.31 11.31-79.2 79.2a16 16 0 0 0 0 22.63l67.88 67.88a16 16 0 0 0 22.62 0l79.2-79.2 11.31 11.31a16 16 0 0 0 22.62 0l45.24-45.26a16 16 0 0 0 0-22.63l-3.15-3.15 27.28-27.27a16 16 0 0 0 .94-21.59c-20.63-24.58-29.28-55.84-24.34-88.08a120.9 120.9 0 0 1 54.53-83.5c35.91-23 83.16-24.66 120.38-4.05A124.34 124.34 0 0 1 469.51 179a23.25 23.25 0 0 0 28.31 7.61 23.52 23.52 0 0 0 13.72-26.28zM197 405.49l-22.63-22.63-22.63 22.63-67.85 67.88-45.26-45.25 67.88-67.88 22.63-22.62L106.52 315l22.63-22.63 90.51 90.51zm247.73-289.58C397.48 89.72 337.38 91.72 291.6 121a153 153 0 0 0-68.93 105.62c-5.56 36.48 2.44 72.08 22.58 101.72l-17.43 17.43L161 279c-14.11-33.36-13.43-82.15-6.09-116 16.78-77.13 82.15-131 159-131C401.07 32 448.38 86.47 469 132.33a162.22 162.22 0 0 0-24.28-16.42z"]
  },
      QH = {
    prefix: "fal",
    iconName: "sigma",
    icon: [320, 512, [], "f68b", "M296 160h16c4.42 0 8-3.58 8-8V96c0-17.67-14.32-32-31.99-32H33.39C22.2 64 11.2 69.12 5.19 78.56c-7.69 12.08-6.76 26.87 2.8 38.5L138.09 256 7.3 395.73c-8.81 10.77-9.82 25.69-2.07 37.78C11.3 442.96 22.38 448 33.61 448h254.4c17.67 0 31.99-14.33 31.99-32v-56c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v56l-256.65.81 130.07-138.92c11.53-12.28 11.53-31.5.03-43.77L32.05 96h255.96v56c0 4.42 3.58 8 7.99 8z"]
  },
      ZH = {
    prefix: "fal",
    iconName: "sign",
    icon: [512, 512, [], "f4d9", "M504 64H96V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v56H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h56v408c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h96v48h-16c-17.7 0-32 14.3-32 32v176c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V176c0-17.7-14.3-32-32-32h-16V96h56c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8zm-40 288H176V176h288v176zm-48-208H224V96h192v48z"]
  },
      UH = {
    prefix: "fal",
    iconName: "sign-in",
    icon: [512, 512, [], "f090", "M184 83.5l164.5 164c4.7 4.7 4.7 12.3 0 17L184 428.5c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l132-131.4H12c-6.6 0-12-5.4-12-12v-10c0-6.6 5.4-12 12-12h279.9L160 107.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.6-4.7 12.2-4.7 16.9 0zM512 400V112c0-26.5-21.5-48-48-48H332c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h132c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H332c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h132c26.5 0 48-21.5 48-48z"]
  },
      BH = {
    prefix: "fal",
    iconName: "sign-in-alt",
    icon: [512, 512, [], "f2f6", "M32 217.1c0-8.8 7.2-16 16-16h144v-93.9c0-7.1 8.6-10.7 13.6-5.7l141.6 143.1c6.3 6.3 6.3 16.4 0 22.7L205.6 410.4c-5 5-13.6 1.5-13.6-5.7v-93.9H48c-8.8 0-16-7.2-16-16v-77.7m-32 0v77.7c0 26.5 21.5 48 48 48h112v61.9c0 35.5 43 53.5 68.2 28.3l141.7-143c18.8-18.8 18.8-49.2 0-68L228.2 78.9c-25.1-25.1-68.2-7.3-68.2 28.3v61.9H48c-26.5 0-48 21.6-48 48zM512 400V112c0-26.5-21.5-48-48-48H332c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h132c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H332c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h132c26.5 0 48-21.5 48-48z"]
  },
      RH = {
    prefix: "fal",
    iconName: "sign-language",
    icon: [448, 512, [], "f2a7", "M447.971 255.391l-4.467-138.16c-1.57-48.503-65.102-66.816-91.36-24.961l-55.919-72.891C286.778 7.064 272.495.001 257.039 0c-15.93-.001-30.091 7.625-39.007 19.206-35.993-16.888-76.766 13.785-69.427 54.289-30.125 13.048-39.039 51.157-19.364 76.804l4.816 6.277c-25.733 14.752-33.109 49.561-14.534 73.773l8.418 10.973h-52.92c-32.727 0-55.982 31.248-47.933 62.349C11.542 311.644.374 327.898.01 347.221c-.371 19.654 10.668 36.491 26.55 44.946-8.624 32.448 16.301 62.869 48.328 62.869h7.246C77.853 485.01 100.941 512 131.143 512h95.892c11.305 0 22.617-1.333 33.62-3.96l71.85-17.159c24.568-5.867 42.026-28.037 42.026-53.589V342.06l52.546-41.529c13.648-10.787 21.459-27.662 20.894-45.14zm-334.334 207.07c-.091-4.771 1.736-9.31 5.145-12.782 3.457-3.524 8.026-5.465 12.865-5.465h55.619a8 8 0 0 0 8-8v-5.178a8 8 0 0 0-8-8H74.887c-23.423 0-24.037-35.786-.504-35.786h112.883a8 8 0 0 0 8-8v-5.179a8 8 0 0 0-8-8H50.014c-23.426 0-24.034-35.785-.504-35.785h137.756a8 8 0 0 0 8-8v-5.179a8 8 0 0 0-8-8H75.525c-23.429 0-24.033-35.786-.504-35.786h150.505c7.685 0 10.959-9.854 4.751-14.437l-27.755-20.486c-19.135-14.124 2.039-42.644 20.507-29.008l110.145 81.305c5.859 4.325 9.357 11.312 9.357 18.691V437.29c0 10.771-7.18 20.01-17.459 22.465l-71.85 17.159a112.86 112.86 0 0 1-26.187 3.085h-95.893c-9.47.001-17.323-7.866-17.505-17.538zm59.145-273.264l7.578 9.878c-11.571 15.417-10.662 36.638 1.045 50.996h-6.421l-30.072-39.2c-14.556-18.97 13.442-40.482 27.87-21.674zm174.094 82.761l-110.144-81.304c-11.634-8.586-26.841-10.128-39.76-4.64l-42.344-55.195c-14.408-18.782 12.669-41.491 27.252-22.479l69.353 90.401a7.995 7.995 0 0 0 5.36 3.069 7.983 7.983 0 0 0 5.948-1.662l4.025-3.182a8.001 8.001 0 0 0 1.387-11.146L183.63 75.904c-14.411-18.788 12.672-41.488 27.251-22.481l84.634 110.321a7.995 7.995 0 0 0 5.36 3.069 7.983 7.983 0 0 0 5.948-1.662l4.025-3.182a8.001 8.001 0 0 0 1.387-11.146l-68.651-89.487c-14.396-18.768 12.642-41.525 27.251-22.481l92.467 120.532a8.001 8.001 0 0 0 14.344-5.128l-1.126-34.813c-.784-24.211 34.249-24.39 35-1.182l4.468 138.16c.239 7.377-3.033 14.479-8.753 19l-41.574 32.858c-.341-14.339-7.308-27.851-18.785-36.324z"]
  },
      YH = {
    prefix: "fal",
    iconName: "sign-out",
    icon: [512, 512, [], "f08b", "M48 64h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48zm279 19.5l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l132 131.4H172c-6.6 0-12 5.4-12 12v10c0 6.6 5.4 12 12 12h279.9L320 404.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l164.5-164c4.7-4.7 4.7-12.3 0-17L344 83.5c-4.7-4.7-12.3-4.7-17 0z"]
  },
      PH = {
    prefix: "fal",
    iconName: "sign-out-alt",
    icon: [512, 512, [], "f2f5", "M160 217.1c0-8.8 7.2-16 16-16h144v-93.9c0-7.1 8.6-10.7 13.6-5.7l141.6 143.1c6.3 6.3 6.3 16.4 0 22.7L333.6 410.4c-5 5-13.6 1.5-13.6-5.7v-93.9H176c-8.8 0-16-7.2-16-16v-77.7m-32 0v77.7c0 26.5 21.5 48 48 48h112v61.9c0 35.5 43 53.5 68.2 28.3l141.7-143c18.8-18.8 18.8-49.2 0-68L356.2 78.9c-25.1-25.1-68.2-7.3-68.2 28.3v61.9H176c-26.5 0-48 21.6-48 48zM0 112v288c0 26.5 21.5 48 48 48h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48C21.5 64 0 85.5 0 112z"]
  },
      FH = {
    prefix: "fal",
    iconName: "signal",
    icon: [640, 512, [], "f012", "M208 288h-32c-4.42 0-8 3.58-8 8v208c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V296c0-4.42-3.58-8-8-8zM80 384H48c-4.42 0-8 3.58-8 8v112c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V392c0-4.42-3.58-8-8-8zm256-192h-32c-4.42 0-8 3.58-8 8v304c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V200c0-4.42-3.58-8-8-8zm128-96h-32c-4.42 0-8 3.58-8 8v400c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V104c0-4.42-3.58-8-8-8zM592 0h-32c-4.42 0-8 3.58-8 8v496c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V8c0-4.42-3.58-8-8-8z"]
  },
      WH = {
    prefix: "fal",
    iconName: "signal-1",
    icon: [640, 512, [], "f68c", "M80 384H48c-4.42 0-8 3.58-8 8v112c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V392c0-4.42-3.58-8-8-8z"]
  },
      GH = {
    prefix: "fal",
    iconName: "signal-2",
    icon: [640, 512, [], "f68d", "M208 288h-32c-4.42 0-8 3.58-8 8v208c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V296c0-4.42-3.58-8-8-8zM80 384H48c-4.42 0-8 3.58-8 8v112c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V392c0-4.42-3.58-8-8-8z"]
  },
      qH = {
    prefix: "fal",
    iconName: "signal-3",
    icon: [640, 512, [], "f68e", "M208 288h-32c-4.42 0-8 3.58-8 8v208c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V296c0-4.42-3.58-8-8-8zM80 384H48c-4.42 0-8 3.58-8 8v112c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V392c0-4.42-3.58-8-8-8zm256-192h-32c-4.42 0-8 3.58-8 8v304c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V200c0-4.42-3.58-8-8-8z"]
  },
      JH = {
    prefix: "fal",
    iconName: "signal-4",
    icon: [640, 512, [], "f68f", "M208 288h-32c-4.42 0-8 3.58-8 8v208c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V296c0-4.42-3.58-8-8-8zM80 384H48c-4.42 0-8 3.58-8 8v112c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V392c0-4.42-3.58-8-8-8zm256-192h-32c-4.42 0-8 3.58-8 8v304c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V200c0-4.42-3.58-8-8-8zm128-96h-32c-4.42 0-8 3.58-8 8v400c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V104c0-4.42-3.58-8-8-8z"]
  },
      KH = {
    prefix: "fal",
    iconName: "signal-alt",
    icon: [640, 512, [], "f690", "M576 32v448h-32V32h32M416 160v320h-32V160h32M256 288v192h-32V288h32M96 416v64H64v-64h32M576 0h-32c-17.67 0-32 14.33-32 32v448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zM416 128h-32c-17.67 0-32 14.33-32 32v320c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM256 256h-32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V288c0-17.67-14.33-32-32-32zM96 384H64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
  },
      XH = {
    prefix: "fal",
    iconName: "signal-alt-1",
    icon: [640, 512, [], "f691", "M96 416v64H64v-64h32m0-32H64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
  },
      _H = {
    prefix: "fal",
    iconName: "signal-alt-2",
    icon: [640, 512, [], "f692", "M256 288v192h-32V288h32M96 416v64H64v-64h32m160-160h-32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V288c0-17.67-14.33-32-32-32zM96 384H64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
  },
      $H = {
    prefix: "fal",
    iconName: "signal-alt-3",
    icon: [640, 512, [], "f693", "M416 160v320h-32V160h32M256 288v192h-32V288h32M96 416v64H64v-64h32m320-288h-32c-17.67 0-32 14.33-32 32v320c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM256 256h-32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V288c0-17.67-14.33-32-32-32zM96 384H64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
  },
      cV = {
    prefix: "fal",
    iconName: "signal-alt-slash",
    icon: [640, 512, [], "f694", "M384 160h32v110.5l32 25.2V160c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v60.1l32 25.2zM544 32h32v364.5l32 25.2V32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v314.1l32 25.2zm93 453.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zM224 256c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V291.9L242.4 256zm32 224h-32V288h32zm160 0h-32V367.5l-32-25.2V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-62.1l-32-25.2zM96 384H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32zm0 96H64v-64h32z"]
  },
      eV = {
    prefix: "fal",
    iconName: "signal-slash",
    icon: [640, 512, [], "f695", "M80 384H48c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8zm392-280c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v172.8l48 37.8zM600 8c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v369.6l48 37.8zM424 504c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-67.2L424 399zM208 288h-32c-4.4 0-8 3.6-8 8v208c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8zm429 197.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zM296 504c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V336l-48-37.8z"]
  },
      aV = {
    prefix: "fal",
    iconName: "signal-stream",
    icon: [576, 512, [], "f8dd", "M96.81 77.93L85.47 66.41a8 8 0 0 0-11.55.1C26.18 118 0 185 0 256s26.18 138 73.92 189.49a8 8 0 0 0 11.55.09l11.34-11.51a8.13 8.13 0 0 0 .07-11.24C55 377.45 32 318.51 32 256S55 134.55 96.88 89.17a8.13 8.13 0 0 0-.07-11.24zm83.93 69l-11.3-11.49a8 8 0 0 0-11.64.15 181.1 181.1 0 0 0 0 240.76 8 8 0 0 0 11.64.15l11.3-11.5a8.21 8.21 0 0 0 .14-11.22 148.17 148.17 0 0 1 0-195.64 8.21 8.21 0 0 0-.14-11.14zm321.35-80.42a8 8 0 0 0-11.56-.1l-11.34 11.52a8.13 8.13 0 0 0-.07 11.24C521 134.55 544 193.49 544 256s-23 121.45-64.88 166.83a8.13 8.13 0 0 0 .07 11.24l11.34 11.51a8 8 0 0 0 11.56-.09C549.82 394 576 327 576 256s-26.18-138-73.91-189.49zM288 192a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm0 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm118.56-152.53L395.26 147a8.21 8.21 0 0 0-.14 11.22 148.17 148.17 0 0 1 0 195.64 8.21 8.21 0 0 0 .14 11.22l11.3 11.49a8 8 0 0 0 11.64-.15 181.1 181.1 0 0 0 0-240.76 8 8 0 0 0-11.64-.19z"]
  },
      nV = {
    prefix: "fal",
    iconName: "signature",
    icon: [640, 512, [], "f5b7", "M630.1 206.8c-32.7 8.4-77.1 30.8-108.7 49.6-14.7 8.8-29.9 17.9-41.5 23.4-31.3 15.2-58.3 28.2-84.1 28.2-12.9 0-23-4.3-29.9-12.7-11.3-13.8-11.3-35.3-7.9-63.3 3.3-26.9.6-47.8-7.6-57.3-4.4-5-10-6.9-18.7-6.3C307 170 257 210.8 169.6 300.9l-54.4 56 70-187.6c11.8-31.6 3.6-66.1-20.9-87.8C145 64.3 112 54.3 77.3 78L3.5 127.8c-3.5 2.3-4.5 7-2.5 10.6l9.2 16.2c2.3 4.1 7.6 5.3 11.5 2.7L97.5 106c6.6-4.5 14-6.8 21.4-6.8 9.1 0 17.6 3.4 24.8 9.8 13.2 11.7 17.6 30.2 11.3 47.1L55.2 423.7c-1.9 5.2-1 12.6 2.2 17.7 2.4 3.7 6.6 6.1 11.3 6.6 4.9.3 9.7-1.4 13-4.9C125 396.8 239.5 278.4 298 228.4l20.4-17.4c3.4-2.9 8.5-.3 8.2 4.1l-2.1 27.9c-2 27.3-2.4 55.9 16.8 78.6 12.4 14.5 30.7 21.9 54.6 21.9 32.7 0 64.1-15.1 97.3-31.1 10.2-4.9 24.9-14.1 39.2-23 30.9-19.3 72.3-40.5 101.8-47.7 3.5-.9 5.9-4 5.9-7.6v-17.3c-.1-7.4-5-11.2-10-10z"]
  },
      tV = {
    prefix: "fal",
    iconName: "sim-card",
    icon: [384, 512, [], "f7c4", "M64 240v160c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48zm152 24h-48v-40h48v40zm72 0h-40v-40h24c8.8 0 16 7.2 16 16v24zm-40 112h40v24c0 8.8-7.2 16-16 16h-24v-40zm-80 0h48v40h-48v-40zm-72 0h40v40h-24c-8.8 0-16-7.2-16-16v-24zm0-80h192v48H96v-48zm0-56c0-8.8 7.2-16 16-16h24v40H96v-24zM0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm32 0c0-17.6 14.4-32 32-32h178.7L352 141.3V448c0 17.6-14.4 32-32 32H64c-17.6 0-32-14.4-32-32V64z"]
  },
      rV = {
    prefix: "fal",
    iconName: "sink",
    icon: [512, 512, [], "e06d", "M504,288H416V256h56a8,8,0,0,0,8-8V232a8,8,0,0,0-8-8H400a16,16,0,0,0-16,16v48H304V112a16,16,0,0,1,32,0v16a32,32,0,0,0,32,32h32a32,32,0,0,0,32-32V114.26c0-20.8-4.79-41.61-15.56-59.4A112.58,112.58,0,0,0,297.81,2.12C245.77,12.23,208,60,208,115.77V288H128V240a16,16,0,0,0-16-16H40a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H96v32H8a8,8,0,0,0-8,8v16a8,8,0,0,0,8,8H32v96a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V320h24a8,8,0,0,0,8-8V296A8,8,0,0,0,504,288ZM240,115.77c0-40.45,26.88-75,63.91-82.24A80.17,80.17,0,0,1,400,112v16H368V112a48,48,0,0,0-96,0V288H240ZM448,416a64.07,64.07,0,0,1-64,64H128a64.07,64.07,0,0,1-64-64V320H448Z"]
  },
      iV = {
    prefix: "fal",
    iconName: "siren",
    icon: [448, 512, [], "e02d", "M416,320h-1.88L390.88,134.08A80.13,80.13,0,0,0,311.5,64h-175a80.13,80.13,0,0,0-79.38,70.08L33.88,320H32A32,32,0,0,0,0,352v64a32,32,0,0,0,32,32H416a32,32,0,0,0,32-32V352A32,32,0,0,0,416,320ZM88.88,138.05A48.07,48.07,0,0,1,136.5,96h175a48.07,48.07,0,0,1,47.62,42.05l22.76,182H135.82l24.11-180.82a8,8,0,0,0-6.87-9l-15.86-2.13a8,8,0,0,0-9,6.87L103.54,320H66.12ZM416,416H32V352H416Z"]
  },
      oV = {
    prefix: "fal",
    iconName: "siren-on",
    icon: [640, 512, [], "e02e", "M512,320h-1.88L486.88,134.07A80.13,80.13,0,0,0,407.5,64h-175a80.13,80.13,0,0,0-79.38,70.08L129.88,320H128a32,32,0,0,0-32,32v64a32,32,0,0,0,32,32H512a32,32,0,0,0,32-32V352A32,32,0,0,0,512,320ZM184.88,138A48.07,48.07,0,0,1,232.5,96h175A48.07,48.07,0,0,1,455.12,138l22.76,182H231.82l24.11-180.83a8,8,0,0,0-6.87-9l-15.86-2.13a8,8,0,0,0-9,6.87L199.54,320H162.12ZM512,416H128V352H512ZM80,160H16a16,16,0,0,0,0,32H80a16,16,0,0,0,0-32Zm544,0H560a16,16,0,0,0,0,32h64a16,16,0,0,0,0-32ZM40.84,30.3l64,32a16,16,0,0,0,14.32-28.63l-64-32A16,16,0,0,0,40.84,30.3ZM528,64a16.17,16.17,0,0,0,7.16-1.69l64-32A16,16,0,0,0,584.84,1.67l-64,32A16,16,0,0,0,528,64Z"]
  },
      lV = {
    prefix: "fal",
    iconName: "sitemap",
    icon: [640, 512, [], "f0e8", "M608 352h-32v-97.59c0-16.77-13.62-30.41-30.41-30.41H336v-64h48c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h48v64H94.41C77.62 224 64 237.64 64 254.41V352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32H96v-96h208v96h-32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32h-32v-96h208v96h-32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-480 32v96H32v-96h96zm240 0v96h-96v-96h96zM256 128V32h128v96H256zm352 352h-96v-96h96v96z"]
  },
      fV = {
    prefix: "fal",
    iconName: "skating",
    icon: [448, 512, [], "f7c5", "M384 0c-35.3 0-64 28.7-64 64 0 12.7 3.8 24.5 10.3 34.5-5.4-1.5-11.1-2.5-16.9-2.5H144c-26.5 0-48 21.5-48 48s21.5 48 48 48h48.5a80.063 80.063 0 0 0-17.4 46.7c-.2 4.5.2 9.1.8 13.5l-91 91c-9.1 9.1-14.1 21.1-14.1 33.9s5 24.9 14.1 33.9c18.7 18.8 49.1 18.8 67.9 0l79.2-79.2 40 40V416c0 26.5 21.5 48 48 48s48-21.5 48-48v-57.4c0-16.9-6.8-33.4-18.8-45.3L299.9 264l58.7-58.7c18.4-18.4 23.8-45.7 13.9-69.7-1.6-3.8-4-7-6.2-10.3 5.7 1.6 11.5 2.8 17.7 2.8 35.3 0 64-28.7 64-64S419.3 0 384 0zM130.2 388.5c-6.2 6.2-16.4 6.3-22.6 0-6.2-6.2-6.2-16.4 0-22.6l80.8-80.8c6.7 10.3 5.3 8.4 21.1 24.2l-79.3 79.2zM336 182.6L254.6 264l72 72c6 6 9.4 14.2 9.4 22.6V416c0 8.8-7.2 16-16 16s-16-7.2-16-16v-57.4l-82.9-82.9-.3-.3c-.1-.1-.1-.1-.2-.1-.2-.2-.2-.4-.4-.6-21.4-22.6-14.6-53.9 3.5-69.4l53.8-45.4H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h169.4c28.5.1 42.7 34.6 22.6 54.7zM384 96c-17.7 0-32-14.4-32-32s14.3-32 32-32 32 14.4 32 32-14.3 32-32 32zM117.8 456.6c-6.2 6.2-16.4 6.2-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.3 9.4 21.7 14 33.9 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.3-6.3-22.6 0zM400 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16z"]
  },
      sV = {
    prefix: "fal",
    iconName: "skeleton",
    icon: [512, 512, [], "f620", "M504 160H272V96h168c4.42 0 8-3.58 8-8V72c0-4.42-3.58-8-8-8H272V8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v56H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h168v64H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h232v64H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h168v64H112c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80c0-18.1-6.23-34.6-16.36-48h160.72C326.23 397.4 320 413.9 320 432c0 44.18 35.82 80 80 80s80-35.82 80-80-35.82-80-80-80H272v-64h168c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H272v-64h232c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM160 432c0 26.47-21.53 48-48 48s-48-21.53-48-48 21.53-48 48-48 48 21.53 48 48zm288 0c0 26.47-21.53 48-48 48s-48-21.53-48-48 21.53-48 48-48 48 21.53 48 48z"]
  },
      uV = {
    prefix: "fal",
    iconName: "ski-jump",
    icon: [512, 512, [], "f7c7", "M510.8 191.5c-1.5-8.7-10.1-14.5-18.4-13.1-8.7 1.5-14.6 9.7-13.1 18.5 3.8 22.6-7 45.5-26.3 56.5L201.1 382.9 247.9 269l116.7-90.8c12.5-9.7 21.5-29.3 18.4-50.3 36 .7 65-28.5 65-63.9 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6.9 10.9 2.3 16H160c-26.5 0-48 21.5-48 48s21.5 48 48 48h39.8c-33.7 36.9-37.7 45.5-63.7 111-7.2 18.1-16.3 40.9-28.5 70.7-4.9 11.8-4.9 24.9.1 36.7 4.5 10.9 13 19.2 23.6 24.3l-122.6 63c-7.9 4-11 13.7-6.9 21.5 2.8 5.5 8.4 8.7 14.2 8.7 2.5 0 5-.6 7.3-1.8l444.9-228.8c31.5-17.8 48.7-54 42.6-89.8zM384 32c17.7 0 32 14.4 32 32s-14.3 32-32 32-32-14.4-32-32 14.4-32 32-32zM137.2 369.9c70-170.2 36.9-116 135.2-225.9H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h168c21.4 0 32.1 25.9 17 41l-121.9 94.8c-.8.8-2.2 2.8-3.1 5l-53.3 129.3c-3.3 8.1-12.5 12.1-20.9 8.7-8-3.4-11.9-12.7-8.6-20.9z"]
  },
      hV = {
    prefix: "fal",
    iconName: "ski-lift",
    icon: [512, 512, [], "f7c8", "M496 296.3c-8.8 0-16 7.2-16 16 0 18.3-11.5 34.9-28.7 41.2l-128.7 47.6c8.3-8.6 13.4-20.3 13.4-33.1V248c0-14.6-6.5-28.2-17.8-37.3-9.6-7.9-24.5-13.2-40.6-9.5l-76.3 16.4-27-46.3c-6.9-14-19.2-24.2-33.4-29.5C152.6 130 160 113.9 160 96c0-35.3-28.7-64-64-64S32 60.7 32 96c0 28.3 18.5 52 44 60.5-5.2 5.5-9.5 11.9-12.4 19-7 17.4-4.9 37.3 2.4 50.2l43.2 76.2c8.8 17.4 29.8 30.6 53.5 24.9l77.2-18.4v59.7c0 24.9 19.2 45.3 43.5 47.5L106.3 481c-8.3 3.1-12.5 12.3-9.5 20.6 1.9 5.1 9.6 13.5 20.5 9.5l344.9-127.4c29.7-11 49.6-39.6 49.6-71.2.2-9.1-7-16.2-15.8-16.2zM64 96c0-17.6 14.3-32 32-32s32 14.4 32 32-14.3 32-32 32-32-14.4-32-32zm240 271.9c0 8.8-7.2 16-16 16s-16-7.2-16-16V267.8l-116.7 27.8c-6.4 1.5-14.3-1.1-17.8-8.7l-43.8-77.1c-6.7-14.8.3-32.3 15.4-38.4 22.2-8.9 34.8 10.6 36.6 14.7l39.4 67.4 99.4-21.3c9.5-2.2 19.3 5.2 19.3 15.6v120.1zM256 0h-32v184l32-8V0zm-74.9 383.1c8.4-2.8 12.9-11.8 10.1-20.2-2.8-8.4-11.9-12.9-20.2-10.1-33.4 11.1-70-4.4-85.2-36.2L30.4 201.1c-3.8-8-13.4-11.3-21.3-7.5-8 3.8-11.3 13.4-7.5 21.3l55.2 115.5c17.3 36.2 53.8 58 92.1 58 10.7-.1 21.6-1.7 32.2-5.3z"]
  },
      mV = {
    prefix: "fal",
    iconName: "skiing",
    icon: [512, 512, [], "f7c9", "M507.3 465.7c-6.2-6.3-16.4-6.3-22.6 0-14.4 14.5-36.6 18.4-54.2 10.3l-130.1-69.7c4.4-3.2 8.4-7 11.5-11.6l.5-.8.5-.8 40.3-68.4c16.3-25.2 12.8-58.7-8.5-80l-49.5-49.5L426.5 267c33.6 16.7 58.1-9 64.4-21.4 11.8-23.7 2.2-52.6-21.5-64.4L423.3 158l-10.1-30.2c1 0 1.9.3 2.8.3 35.3 0 64-28.7 64-64S451.3 0 416 0c-34.3 0-62.2 27.2-63.7 61.1-15-3.8-31.4-4.4-49.6 2.9l-83.4 33.4c-5.1 2-9.7 4.9-14.2 7.8l-40-22.9c1.1-15.2-6.7-30.2-21.1-37.6l-11.1 21.8-34.6-7c-5.3-1.1-8.5 5.6-4.5 9.1l26.1 22.9c.1.1.1.2.1.3l-11.5 22.4c13.7 7 29.5 4.8 41-3.8L182 129c-5.2 8.1-9.5 16.9-11.5 26.7-5.4 26.4 2.7 53.6 21.8 72.6l66.9 66.9-27.8 47.2c-4.6 7.2-6.8 15.2-7.2 23.1L23.6 257.9c-7.7-4.1-17.5-1.3-21.7 6.5-4.2 7.8-1.2 17.5 6.5 21.7l407.8 218.5c10.8 5 22.3 7.4 33.7 7.4 21.1 0 41.9-8.2 57.3-23.7 6.4-6.2 6.4-16.4.1-22.6zM416 32c17.7 0 32 14.4 32 32s-14.3 32-32 32-32-14.4-32-32 14.3-32 32-32zM314.6 93.8c32.8-13.1 57.4 11.6 63.3 29.4l19.2 57.5 58.1 29c19 9.5 4.6 38-14.3 28.6l-28.3-14.1-39.8-22.8c-2.6-3.1-4.7-6.6-6-10.6l-18.1-54.4-50.1 22.4-60.2-34.5 76.2-30.5zm-55.9 265.4l40.7-69.1-84.4-84.5c-11.4-11.4-16.3-27.7-13.1-43.6 1.3-6.4 4.1-12.1 7.7-17.3l52.7 30.2-22.7 10.1 82.4 82.4c10.8 10.8 12.4 27.8 4 40.4l-40.7 69.1c-11.9 17.7-38.3-.2-26.6-17.7z"]
  },
      vV = {
    prefix: "fal",
    iconName: "skiing-nordic",
    icon: [576, 512, [], "f7ca", "M560 432c-8.8 0-16 7.2-16 16 0 17.6-14.3 32-32 32h-70.7L467 300c17-7.4 29-24.3 29-44 0-26.5-21.5-48-48-48h-34.1l-21.7-44.3c-7.8-15.9-19.2-29.6-32.9-40.2C383.2 114.2 400 91 400 64c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 10 2.3 19.5 6.4 27.9l-29.6-8.8c-33-7.9-67.4-.7-94.4 20l-39.6 30.4c-10.2 7.8-16.7 19.1-18.4 31.8-1.7 12.7 1.7 25.3 9.5 35.5 3.6 4.8 8.1 8.5 12.9 11.5L65.3 480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h496c35.3 0 64-28.7 64-64 0-8.8-7.2-16-16-16zm-322.4-77.6l-55.1 116.4c-9 18.9-38.1 5.7-28.9-13.7l57.2-120.7c8.3 7.8 13.4 10.1 26.8 18zm27.7 16.4l31.9 18.8-23 60c-3.1 10.1-2.7 20.6.8 30.4h-61.4l51.7-109.2zm103.4-50.5l-49.4-29.2 12.8-32.1 4.4 9.1c10.7 21.8 33.2 35.9 57.5 35.9h40.1L409 480h-43.9c.1-.3.3-.6.4-.9l32.1-86.3c7.8-27.7-4-57.5-28.9-72.5zM336 32c17.7 0 32 14.4 32 32s-14.3 32-32 32-32-14.4-32-32 14.3-32 32-32zM134.3 158.9l39.6-30.4c19.3-14.7 43.9-19.9 66.6-14.5l71.7 21.3c21.9 5.6 41.1 21.5 51.3 42.5L394 240h54c21.2 0 21.2 32 0 32h-54c-12.1 0-23.4-7-28.8-17.9l-36.1-73.8-49.8 124.5 73 43c12.5 7.5 18.4 22.5 14.9 35.1l-31.9 85.9c-6.4 20.7-36.4 9.9-30.8-8.6l32.3-84.4-96.7-57c-20.7-12.2-29.2-38.1-19.7-60.2l44.5-103.9c-34.7-10.3-34.7-10.8-42.2-10.8-10.2 0-20.8 3.6-29.3 10.1l-39.7 30.4c-17 12.9-36-12.8-19.4-25.5zm15.8 60.1c8.1-1 16.1-4 23.1-9.3l39.7-30.4c2.7-2.1 5.8-3.1 8.1-3.5l-30.1 70.1c-8.4 19.6-8.1 40.9-1 59.7l-65.3 137.9c-5.5 11.6-6.1 24.5-1.8 36.6H97.9L150.1 219z"]
  },
      dV = {
    prefix: "fal",
    iconName: "skull",
    icon: [512, 512, [], "f54c", "M352 184c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 184c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.7 6.9 15.2 18.1 13.5 29.9l-7.1 21.3C90.6 480 113.8 512 146.5 512h219c32.7 0 55.9-32 45.6-63.1l-7.1-21.3c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm142.9 371.6c-19.7 14-29.9 37.2-26.6 60.4l.4 2.8.9 2.8 7.1 21.3c2.2 6.8-.4 11.9-2.2 14.4-1.8 2.5-5.8 6.6-13 6.6H320v-56c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56h-64v-56c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56h-45.5c-7.1 0-11.2-4.2-13-6.6-1.8-2.5-4.5-7.7-2.2-14.4l7.1-21.3.9-2.8.4-2.8c3.3-23.2-6.9-46.4-26.6-60.4C61.5 334.9 32 281.1 32 224 32 118.1 132.5 32 256 32s224 86.1 224 192c0 57.1-29.5 110.9-81.1 147.6z"]
  },
      MV = {
    prefix: "fal",
    iconName: "skull-cow",
    icon: [640, 512, [], "f8de", "M603.26,4.58a16,16,0,0,0-26.21,17c6.07,16.12,19.6,67.59,2.88,91.7C573.13,123.05,561.4,128,544,128l-73-.18A63.73,63.73,0,0,0,416,96H224a63.71,63.71,0,0,0-55.12,32H96c-17.35,0-29.08-4.93-35.88-14.7C43.35,89.22,56.49,38.92,63,21.57a16,16,0,0,0-26.19-17C13.05,27.81,0,60.17,0,95.7,0,166.18,57.43,224,128,224H160v80a64,64,0,0,0,64,64l26.4,118.93A32,32,0,0,0,281.6,512h76.66A32,32,0,0,0,389.49,487L416,368a64,64,0,0,0,64-64V224h32c70.59,0,128-57.83,128-128.3C640,60.18,627,27.82,603.26,4.58ZM160,192H128c-35.51,0-66.56-19.77-83.19-48.45C55.44,152.38,71.6,160,96,160h64ZM448,304a32,32,0,0,1-32,32H390.3l-5.58,25.05L358.26,480H281.6L255.2,361.07,249.64,336H224a32,32,0,0,1-32-32V160a32,32,0,0,1,32-32H416a32,32,0,0,1,32,32Zm64-112H480V160c0-.07,0-.13,0-.19L544,160c24.36,0,40.5-7.6,51.11-16.43C578.52,172.23,547.47,192,512,192ZM256,224a32,32,0,1,0,32,32A32,32,0,0,0,256,224Zm128,0a32,32,0,1,0,32,32A32,32,0,0,0,384,224Z"]
  },
      pV = {
    prefix: "fal",
    iconName: "skull-crossbones",
    icon: [448, 512, [], "f714", "M264 160c13.24 0 24-10.76 24-24s-10.76-24-24-24-24 10.76-24 24 10.76 24 24 24zm-80 0c13.24 0 24-10.76 24-24s-10.76-24-24-24-24 10.76-24 24 10.76 24 24 24zm-48.97 67.93l-6.41 30.24c-3.21 15.15 6.5 29.82 19.73 29.82h151.3c13.23 0 22.94-14.67 19.73-29.82l-6.41-30.24C346.25 204.49 368 168.67 368 128 368 57.31 303.53 0 224 0S80 57.31 80 128c0 40.67 21.75 76.49 55.03 99.93zM224 32c61.76 0 112 43.06 112 96 0 28.32-15.11 55.21-41.46 73.77l-17.25 12.15 4.37 20.64 4.54 21.43H161.79l4.54-21.43 4.37-20.64-17.25-12.15C127.11 183.21 112 156.32 112 128c0-52.94 50.24-96 112-96zm45.12 384l174.03-65.94c4.06-1.74 5.94-6.45 4.2-10.51l-6.31-14.71a7.996 7.996 0 0 0-10.5-4.2L224 398.91 17.47 320.65a7.996 7.996 0 0 0-10.5 4.2L.66 339.56c-1.74 4.06.14 8.77 4.2 10.51L178.88 416 4.85 481.94c-4.06 1.74-5.94 6.45-4.2 10.51l6.31 14.7a7.996 7.996 0 0 0 10.5 4.2L224 433.09l206.53 78.26a7.996 7.996 0 0 0 10.5-4.2l6.31-14.7c1.74-4.06-.14-8.77-4.2-10.51L269.12 416z"]
  },
      zV = {
    prefix: "fal",
    iconName: "slash",
    icon: [640, 512, [], "f715", "M637 485.3L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.5 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.2z"]
  },
      CV = {
    prefix: "fal",
    iconName: "sledding",
    icon: [512, 512, [], "f7cb", "M507.3 433.1c-6.2-6.3-16.4-6.3-22.6 0-15.1 15.1-38.2 19.2-57 10.6l-60.6-31.3c10.3-8.8 16.9-21.7 16.9-36.3v-88c0-26.5-21.5-48-48-48h-12.1l18.7-18.7c17.8-17.8 23.1-44 14.5-67.4 8.2 3.8 17.3 6.1 26.9 6.1 35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64c0 8 1.7 15.6 4.3 22.7-8.4-3.9-17.3-6.7-27-6.7H160c-26.5 0-48 21.5-48 48s21.5 48 48 48h28.1l-18.7 18.7c-18.4 18.4-23.8 45.8-13.9 69.8 1.4 3.4 3.7 6.2 5.6 9.3L23.4 234.6c-7.7-4-17.5-1-21.6 6.9-4.1 7.8-1 17.5 6.9 21.6l405 209.3c11.1 5.1 23 7.6 34.7 7.6 21.7 0 43.1-8.4 58.9-24.3 6.3-6.3 6.3-16.4 0-22.6zM384 64c17.7 0 32 14.4 32 32s-14.3 32-32 32-32-14.4-32-32 14.3-32 32-32zM192 249.4l73.4-73.4H160c-8.8 0-16-7.2-16-16s7.2-16 16-16h137.4c13 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L246.6 272H336c8.8 0 16 7.2 16 16v88c0 8.8-7.2 16-16 16s-16-7.2-16-16v-72H214.6c-28.5 0-42.8-34.4-22.6-54.6zm96 86.6v35.4L219.5 336H288z"]
  },
      LV = {
    prefix: "fal",
    iconName: "sleigh",
    icon: [640, 512, [], "f7cc", "M615.8 364.9l-14.3-11.2c-3.4-2.8-8.5-2.2-11.2 1.2l-10 12.5c-2.8 3.4-2.2 8.5 1.2 11.2l13.5 10.5c6.3 5.1 11.1 12.1 12.5 20 3.8 20.6-12.1 38.7-32.1 38.7H448v-64h10c65.1 0 118-52.9 118-118V128.5h24c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H480c-17.7 0-32 14.3-32 32V177c0 28.1-29.4 39.2-42.1 42.7-48.1 13.3-137-3.8-184.2-83.1C169.5 48.7 122 32 52.7 32H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h24v168c0 64 39.9 118.6 96 141v75H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h532c35.5 0 66-27.3 67.9-60.8 1.2-21.2-7.6-41-24.1-54.3zM64 232V64.4c53.4 1.8 88.2 17.9 130.3 88.5C236.5 224.1 309.8 256 372 256c15 0 29.3-1.8 42.4-5.5 41.1-11.3 65.6-38.8 65.6-73.5v-48.5h64V266c0 47.4-38.6 86-86 86H184c-66.2 0-120-53.8-120-120zm96 216v-66.4c7.9 1.3 15.8 2.4 24 2.4h232v64H160z"]
  },
      AV = {
    prefix: "fal",
    iconName: "sliders-h",
    icon: [512, 512, [], "f1de", "M504 384H192v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h312c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-344 64h-32v-96h32v96zM504 96H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h152v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h248c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-280 64h-32V64h32v96zm280 80h-88v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h312v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-120 64h-32v-96h32v96z"]
  },
      NV = {
    prefix: "fal",
    iconName: "sliders-h-square",
    icon: [448, 512, [], "f3f0", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352zm-92-272H224v-40c0-13.2-10.8-24-24-24h-48c-13.2 0-24 10.8-24 24v40H92c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h36v40c0 13.2 10.8 24 24 24h48c13.2 0 24-10.8 24-24v-40h100c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12zm-132 64h-32v-96h32v96zm148 96h-20v-40c0-13.2-10.8-24-24-24h-48c-13.2 0-24 10.8-24 24v40H108c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h116v40c0 13.2 10.8 24 24 24h48c13.2 0 24-10.8 24-24v-40h20c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12zm-52 64h-32v-96h32v96z"]
  },
      gV = {
    prefix: "fal",
    iconName: "sliders-v",
    icon: [448, 512, [], "f3f1", "M160 168v-48c0-13.3-10.7-24-24-24H96V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v88H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h40v312c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V192h40c13.3 0 24-10.7 24-24zm-32-8H32v-32h96v32zm152 160h-40V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v312h-40c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h40v88c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-88h40c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm-8 64h-96v-32h96v32zm152-224h-40V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v152h-40c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h40v248c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V256h40c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm-8 64h-96v-32h96v32z"]
  },
      HV = {
    prefix: "fal",
    iconName: "sliders-v-square",
    icon: [448, 512, [], "f3f2", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352zM200 160h-40v-32c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v32H88c-13.2 0-24 10.8-24 24v48c0 13.2 10.8 24 24 24h40v116c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V256h40c13.2 0 24-10.8 24-24v-48c0-13.2-10.8-24-24-24zm-8 64H96v-32h96v32zm168 32h-40V128c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v128h-40c-13.2 0-24 10.8-24 24v48c0 13.2 10.8 24 24 24h40v20c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-20h40c13.2 0 24-10.8 24-24v-48c0-13.2-10.8-24-24-24zm-8 64h-96v-32h96v32z"]
  },
      VV = {
    prefix: "fal",
    iconName: "smile",
    icon: [496, 512, [], "f118", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm90.2-146.2C315.8 352.6 282.9 368 248 368s-67.8-15.4-90.2-42.2c-5.7-6.8-15.8-7.7-22.5-2-6.8 5.7-7.7 15.7-2 22.5C161.7 380.4 203.6 400 248 400s86.3-19.6 114.8-53.8c5.7-6.8 4.8-16.9-2-22.5-6.8-5.6-16.9-4.7-22.6 2.1zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"]
  },
      xV = {
    prefix: "fal",
    iconName: "smile-beam",
    icon: [496, 512, [], "f5b8", "M168 205.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm80-304c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4zm10.2 157.8C315.8 352.6 282.9 368 248 368s-67.8-15.4-90.2-42.2c-5.7-6.8-15.8-7.7-22.5-2-6.8 5.7-7.7 15.7-2 22.5C161.7 380.4 203.6 400 248 400s86.3-19.6 114.8-53.8c5.7-6.8 4.8-16.9-2-22.5-6.9-5.6-16.9-4.7-22.6 2.1z"]
  },
      wV = {
    prefix: "fal",
    iconName: "smile-plus",
    icon: [640, 512, [], "f5b9", "M208 96C93.1 96 0 189.1 0 304s93.1 208 208 208 208-93.1 208-208S322.9 96 208 96zm0 384c-97 0-176-79-176-176s79-176 176-176 176 79 176 176-79 176-176 176zm75.8-130.7C265 371.4 237.4 384 208 384s-57-12.6-75.8-34.6c-5.7-6.7-15.9-7.5-22.5-1.8-6.8 5.8-7.5 15.8-1.8 22.6C132.7 399.3 169.2 416 208 416s75.3-16.7 100.2-45.9c5.8-6.7 4.9-16.8-1.8-22.6-6.6-5.6-16.8-4.9-22.6 1.8zM144 280c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zm128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zM632 96h-88V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v88h-88c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88v88c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-88h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      yV = {
    prefix: "fal",
    iconName: "smile-wink",
    icon: [496, 512, [], "f4da", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm152.7 400.7c-19.8 19.8-43 35.4-68.7 46.3-26.6 11.3-54.9 17-84.1 17s-57.5-5.7-84.1-17c-25.7-10.9-48.8-26.5-68.7-46.3-19.8-19.8-35.4-43-46.3-68.7-11.3-26.6-17-54.9-17-84.1s5.7-57.5 17-84.1c10.9-25.7 26.5-48.8 46.3-68.7 19.8-19.8 43-35.4 68.7-46.3 26.6-11.3 54.9-17 84.1-17s57.5 5.7 84.1 17c25.7 10.9 48.8 26.5 68.7 46.3 19.8 19.8 35.4 43 46.3 68.7 11.3 26.6 17 54.9 17 84.1s-5.7 57.5-17 84.1c-10.8 25.8-26.4 48.9-46.3 68.7zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm10.2 145.8C315.8 352.6 282.9 368 248 368s-67.8-15.4-90.2-42.2c-13.5-16.2-38.2 4.2-24.6 20.5C161.7 380.4 203.5 400 248 400s86.3-19.6 114.8-53.8c13.5-16.2-11.1-36.7-24.6-20.4z"]
  },
      bV = {
    prefix: "fal",
    iconName: "smog",
    icon: [640, 512, [], "f75f", "M179.2 288h105.2c24.3 20.7 54.6 32 86.8 32 32.2 0 62.5-11.3 86.8-32h28.4c67.1 0 121.6-53.4 121.6-119.1S553.4 49.8 486.4 49.8c-9.2 0-18.4 1.1-27.4 3.2-27.6-33.2-69.1-53-113.4-53-30.2 0-58.9 8.9-83.2 25.4C238.1 8.9 209.4 0 179.2 0 98 0 32 64.6 32 144s66 144 147.2 144zm0-256c32.8 0 62.2 13.5 83.2 34.9 21-21.4 50.4-34.9 83.2-34.9 43.9 0 81.6 24.1 101 59.2 12-5.8 25.4-9.4 39.8-9.4 49.5 0 89.6 39 89.6 87.1S535.9 256 486.4 256h-41.1c-18.7 19.6-44.9 32-74.1 32s-55.4-12.4-74.1-32H179.2C115.6 256 64 205.9 64 144S115.6 32 179.2 32zM632 384H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-64 96H232c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h336c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-416 0H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      SV = {
    prefix: "fal",
    iconName: "smoke",
    icon: [640, 512, [], "f760", "M640 240c0-79.4-64.6-144-144-144-20.5 0-40.3 4.7-58.6 13-25.2-45.7-73.6-77-129.4-77-20.5 0-40.6 4.5-59.9 13.2C220.8 16.3 183.6 0 144 0 64.6 0 0 64.6 0 144c0 40.8 17.3 77.3 44.7 103.4C17.1 275.5 0 313.9 0 356.3 0 442.2 69.8 512 155.7 512h361.5c67.7 0 122.8-55.1 122.8-122.8 0-26.9-9-51.7-23.7-71.9 14.6-22.4 23.7-48.6 23.7-77.3zm-32 0c0 19.6-5.4 37.9-14.4 53.8-21-16.9-47.4-27.5-76.5-27.5-23.1 0-45.1 6.5-64.7 18.8-26.3-32.6-65.5-51.7-107.9-51.7-25.5 0-50.1 7.1-72 20.5-8.2-9.3-17.4-17.5-27.4-24.6 12.9-40.2 50.3-69.5 94.7-69.5 17 0 33.5 4.5 49.2 13.5l11.8 6.7 8.6-10.5c21.6-26.5 53.1-41.7 86.5-41.7C557.8 128 608 178.2 608 240zM32 144C32 82.2 82.2 32 144 32c34.1 0 66 15.7 87.6 43.1l8.4 10.7 11.9-6.6c18-10 36.9-15.1 56.1-15.1 44.3 0 82.5 25.1 101.9 61.8-5.7 4.4-11.4 8.7-16.5 14-17.1-7.8-35-11.8-53.4-11.8-56.4 0-104 35.8-122.8 85.6-19.2-8.4-40.1-13-61.5-13-32 0-61.7 9.7-86.4 26.3C46.5 206.5 32 177 32 144zm485.2 336H155.7C87.5 480 32 424.5 32 356.3s55.5-123.7 123.7-123.7c39.8 0 77.5 19.6 100.7 52.3l9.7 13.6 13.2-10.2c19.3-15 41.9-22.9 65.4-22.9 36.9 0 70.8 18.9 90.7 50.6l9.8 15.6 14.1-11.8c16.8-14.1 36.9-21.6 58-21.6 50.1 0 90.8 40.7 90.8 90.8s-40.9 91-90.9 91z"]
  },
      TV = {
    prefix: "fal",
    iconName: "smoking",
    icon: [640, 512, [], "f48d", "M632 352h-16c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm-64 0h-16c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm-80 0H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h440c13.2 0 24-10.8 24-24V376c0-13.2-10.8-24-24-24zM192 480H48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h144v96zm288 0H224v-96h256v96zm76.4-386.5c-7.5-5-12.4-13.2-12.4-22.2V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v62.3c0 20.2 10.3 38.8 27 50 43.2 29 69 77.3 69 129.4V280c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-30.3c0-62.9-31.2-121.3-83.6-156.2zm-36.7 52.4C494.1 129.3 480 99.5 480 69V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v67c0 40.3 22.2 76 55.6 98.6 25.3 17.1 40.4 45.5 40.4 76.1V280c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-30.3c0-42-21.1-80.9-56.3-103.8z"]
  },
      DV = {
    prefix: "fal",
    iconName: "smoking-ban",
    icon: [512, 512, [], "f54d", "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 480C132.5 480 32 379.5 32 256c0-56 20.8-107.2 54.9-146.5l315.6 315.6C363.2 459.2 312 480 256 480zm22.6-224H384v32h-73.4l-32-32zm146.5 146.5L342.6 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H246.6L109.5 86.9C148.8 52.8 200 32 256 32c123.5 0 224 100.5 224 224 0 56-20.8 107.2-54.9 146.5zM112 320h140.1l-32-32H128v-32h60.1l-32-32H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16zm240-192c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.5-30.9-31.2-54.6-63.3-54.6z"]
  },
      jV = {
    prefix: "fal",
    iconName: "sms",
    icon: [512, 512, [], "f7cd", "M304 176h-16c-6.1 0-11.6 3.4-14.3 8.8L256 220.2l-17.7-35.4c-2.7-5.4-8.2-8.8-14.3-8.8h-16c-8.8 0-16 7.2-16 16v104c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-68.2l24.8 55.8c2.9 5.9 11.4 5.9 14.3 0l24.8-55.8V296c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V192c.1-8.8-7.1-16-15.9-16zm-168.6 42.5c-1.4-1.2-2.1-2.5-2.1-3.8 0-3.1 4.5-6.6 10.4-6.6H156c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-12.2c-23.4 0-42.4 17.3-42.4 38.6 0 10.7 4.9 20.9 13.3 28.1l21.9 18.8c1.4 1.2 2.1 2.5 2.1 3.8 0 3.1-4.5 6.6-10.4 6.6H116c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h12.3c23.4 0 42.4-17.3 42.4-38.6 0-10.7-4.9-20.9-13.3-28.1l-22-18.8zm240 0c-1.4-1.2-2.1-2.5-2.1-3.8 0-3.1 4.5-6.6 10.4-6.6H396c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-12.3c-23.4 0-42.4 17.3-42.4 38.6 0 10.7 4.9 20.9 13.3 28.1l21.9 18.8c1.4 1.2 2.1 2.5 2.1 3.8 0 3.1-4.5 6.6-10.4 6.6H356c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h12.3c23.4 0 42.4-17.3 42.4-38.6 0-10.7-4.9-20.9-13.3-28.1l-22-18.8zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26 3.8 8.8 12.4 14.5 22 14.5 61.5 0 110-25.7 139.1-46.3 29 9.1 60.2 14.3 93 14.3 141.4 0 256-93.1 256-208S397.4 32 256 32zm0 384c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.4 313.7 32.1 277.6 32.1 240c0-97 100.5-176 224-176s224 79 224 176S379.5 416 256 416z"]
  },
      EV = {
    prefix: "fal",
    iconName: "snake",
    icon: [640, 512, [], "f716", "M528 248c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm0-16c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm90.96-53.03l-47.87-17.52c-46.68-17.13-47.57-17.46-57.9-17.46-28.31 0-53.19 18.27-61.67 44.42l-1.3 4.42C394.94 199.65 352 246.91 352 304v72c0 22.06-17.94 40-40 40s-40-17.94-40-40V136C272 61.01 210.99 0 136 0S0 61.01 0 136v223.53c0 43.6 5.42 84.48 17.06 128.63C20.76 502.21 33.47 512 48 512s27.24-9.79 30.94-23.84C90.58 444.01 96 403.14 96 359.53V136c0-22.06 17.94-40 40-40s40 17.94 40 40v240c0 74.99 61.01 136 136 136s136-61.01 136-136v-72c0-4.12 1.57-7.89 4.14-10.73 9.43 25.59 33.59 42.73 59.88 42.73h.09c11.42 0 12.43-.37 59.07-17.48l47.78-17.49c12.63-4.61 21.04-16.62 21.04-30.06v-61.93c0-13.45-8.41-25.46-21.04-30.07zm-10.96 92c-88.03 32.11-88.77 33.04-94.81 33.04h-1.18c-13.44 0-25.79-9.17-30.05-22.29l-7.58-25.71V256H464c-26.47 0-48 21.53-48 48v72c0 57.34-46.66 104-104 104s-104-46.66-104-104V136c0-39.7-32.31-72-72-72s-72 32.3-72 72v223.53c0 42.02-5.37 80.14-16 120.47-10.63-40.33-16-78.46-16-120.47V136C32 78.66 78.66 32 136 32s104 46.66 104 104v240c0 39.7 32.31 72 72 72s72-32.3 72-72v-72c0-44.11 35.88-80 80-80h10.39l7.58-25.71c4.26-13.12 16.61-22.29 30.05-22.29h1.18c6.03 0 6.78.93 94.81 33.04v61.93z"]
  },
      kV = {
    prefix: "fal",
    iconName: "snooze",
    icon: [448, 512, [], "f880", "M176 272H24a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h131.19L3.72 469.75A16.06 16.06 0 0 0 0 480v16a16 16 0 0 0 16 16h168a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H36.81l151.48-165.77A15.94 15.94 0 0 0 192 304v-16a16 16 0 0 0-16-16zM272 0H168a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h78l-98.56 125.2a16.07 16.07 0 0 0-3.44 9.91V176a16 16 0 0 0 16 16h120a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-94l98.56-125.2a16.07 16.07 0 0 0 3.44-9.91V16a16 16 0 0 0-16-16zm176 248.89V240a16 16 0 0 0-16-16H328a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h78l-98.56 125.2a16.07 16.07 0 0 0-3.44 9.91V400a16 16 0 0 0 16 16h120a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-94l98.59-125.2a16.07 16.07 0 0 0 3.41-9.91z"]
  },
      IV = {
    prefix: "fal",
    iconName: "snow-blowing",
    icon: [640, 512, [], "f761", "M351 115.8l-7.6-13.2c-2.1-3.6-6.7-4.9-10.4-2.8l-40.6 23.5 8-29.9c1.1-4.1-1.3-8.2-5.4-9.3l-14.7-3.9c-4.1-1.1-8.2 1.3-9.3 5.4l-15.9 59.3-63.1 36.3v-78.6L237.7 57c3.1-3.1 3.1-8.2 0-11.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0l-23 23V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v49.4l-23-23c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l45.7 45.7v78.6l-63.1-36.4L81 85.5c-1.1-4.1-5.3-6.5-9.3-5.4l-14.7 4c-4.1 1.1-6.5 5.3-5.4 9.3l8 29.9L19 99.8c-3.6-2.1-8.3-.9-10.4 2.8L1 115.8c-2.1 3.6-.9 8.3 2.8 10.4l40.6 23.5-29.9 8c-4.1 1.1-6.5 5.3-5.4 9.3l3.9 14.7c1.1 4.1 5.3 6.5 9.3 5.4l59.3-15.9 63.9 36.9L81.6 245l-59.2-16c-4.1-1.1-8.2 1.3-9.3 5.4l-3.9 14.7c-1.1 4.1 1.3 8.2 5.4 9.3l29.9 8-40.7 23.5C.2 292-1.1 296.6 1 300.3l7.6 13.2c2.1 3.6 6.7 4.9 10.4 2.8l40.6-23.5-8 29.9c-1.1 4.1 1.3 8.2 5.4 9.3l14.7 3.9c4.1 1.1 8.2-1.3 9.3-5.4l15.9-59.3 63.1-36.4v78.6L114.3 359c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l23-23V408c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-49.4l23 23c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3L192 313.4v-78.6l63.1 36.4 15.9 59.3c1.1 4.1 5.3 6.5 9.3 5.4L295 332c4.1-1.1 6.5-5.3 5.4-9.3l-8-29.9 40.6 23.5c3.6 2.1 8.3.9 10.4-2.8l7.6-13.2c2.1-3.6.9-8.3-2.8-10.4l-40.6-23.5 29.9-8c4.1-1.1 6.5-5.3 5.4-9.3l-3.9-14.7c-1.1-4.1-5.3-6.5-9.3-5.4l-59.3 15.9-64-36.9 63.9-36.9 59.3 15.9c4.1 1.1 8.2-1.3 9.3-5.4l3.9-14.7c1.1-4.1-1.3-8.2-5.4-9.3l-29.9-8 40.6-23.5c3.7-2.1 5-6.7 2.9-10.3zM392 288h152c59.8 0 106.8-54.6 93.8-116.7-7.6-36.3-36.9-65.6-73.2-73.2-59.1-12.3-111.5 29.8-116.3 85.4-.4 4.6 3.5 8.4 8 8.4h16.2c4.2 0 7.4-3.3 7.9-7.4 4.2-36.6 39.5-63.8 78.7-54.8 23.1 5.3 41.8 24.1 47.2 47.2 9.6 41.8-22.1 79.1-62.3 79.1H392c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm147.7 32H376c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h164.8c33.4 0 63.3 24.4 66.5 57.6C611 447.7 581 480 543.6 480c-32.8 0-59.9-24.8-63.6-56.5-.5-4.2-3.7-7.4-7.9-7.4H456c-4.6 0-8.4 3.9-8 8.4 4.3 49.1 45.5 87.6 95.6 87.6 54 0 97.6-44.6 96-98.9-1.5-52.7-47.4-93.2-99.9-93.2z"]
  },
      OV = {
    prefix: "fal",
    iconName: "snowboarding",
    icon: [512, 512, [], "f7ce", "M492.8 177.6L425.4 127c30.8-4.6 54.6-31 54.6-63 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 6.6 1.3 12.9 3.2 19-1.8-.7-3.5-1.6-5.3-2.2l-47.6-15.4L283 26.5C274.8 10.2 258.3 0 240 0c-7.3 0-14.7 1.7-21.3 5-23.8 11.9-33.4 40.8-21.6 64.4l25.4 50.8c2.6 5.2 5.8 9.9 9.6 14.1l-11.8 5.9C193 153.8 176 181.3 176 211.8v41.6l-63.2 21.1c-25.1 8.3-38.7 35.5-30.4 60.7 4.3 12.9 13.9 22.5 25.7 28l-51.3-18.7c-11.7-4.3-21-12.8-26.3-24.1-3.8-8-13.3-11.4-21.3-7.7S-2.3 326 1.5 334c8.9 19 24.6 33.4 44.3 40.6l364.8 132.8c8.8 3.2 17.9 4.8 26.9 4.8 11.3 0 22.6-2.5 33.2-7.4 8-3.7 11.5-13.2 7.8-21.2s-13.3-11.4-21.3-7.7c-11.3 5.2-23.9 5.8-35.7 1.5l-84.6-30.8c18.4-3.7 33.8-17.4 37.9-36.3l21.9-102c5.2-24.4-4.4-49.8-24.5-64.9L341.1 221l30.7-14.2 63.4 47.6c8.4 6.3 18.3 9.6 28.8 9.6 15 0 29.4-7.2 38.4-19.2 15.9-21.2 11.6-51.4-9.6-67.2zM416 32c17.7 0 32 14.4 32 32s-14.3 32-32 32-32-14.4-32-32 14.4-32 32-32zM291.3 429.7l-174.7-63.6c2.6.6 12.5 4 26.6-.7l85.1-28.3c22.2-7.4 38.2-26 42.6-48.3l27.7 19.7-17.4 81.4c-5.2 23.7 7.5 36.6 10.1 39.8zm185.5-204.1c-5.3 7.1-15.3 8.5-22.4 3.2l-78.7-59-98.1 45.2 75.6 53.8c10.3 7.7 15 20.4 12.4 32.5l-21.8 102c-2 9.3-11.1 14-19 12.3-8.7-1.8-14.2-10.3-12.3-19l21.8-102-94.2-67v48.8c0 13.8-8.8 26-21.9 30.4-92 30.7-86.5 29.2-90.1 29.2-6.7 0-12.9-4.2-15.2-10.9-2.8-8.4 1.8-17.5 10.1-20.2l85.1-28.4v-64.7c0-18.3 10.2-34.7 26.5-42.9l71-35.5-37.1-12.4c-7.6-2.5-13.8-7.9-17.3-15.1l-25.4-50.8c-3.9-7.9-.8-17.5 7.2-21.5 9.4-4.7 18.3.8 21.5 7.2l25.4 50.8L340 111c13.1 4.3 25.3 10.7 36.3 19l97.5 73.1c6.9 5.4 8.3 15.4 3 22.5z"]
  },
      QV = {
    prefix: "fal",
    iconName: "snowflake",
    icon: [448, 512, [], "f2dc", "M388.1 333.5l52.7-14.3c4.2-1.1 6.7-5.5 5.6-9.8l-4.1-15.5c-1.1-4.3-5.5-6.8-9.7-5.7l-83.2 22.6-93.8-54.8 93.8-54.8 83.2 22.6c4.2 1.1 8.6-1.4 9.7-5.7l4.1-15.5c1.1-4.3-1.4-8.7-5.6-9.8l-52.7-14.3 55.9-32.7c3.8-2.2 5.1-7.1 2.9-10.9L439 121c-2.2-3.8-7-5.1-10.8-2.9l-55.9 32.7 14.1-53.3c1.1-4.3-1.4-8.7-5.6-9.8l-15.3-4.1c-4.2-1.1-8.6 1.4-9.7 5.7l-22.3 84.2-93.8 54.8V118.6l61-61.6c3.1-3.1 3.1-8.2 0-11.3l-11.2-11.3c-3.1-3.1-8.1-3.1-11.2 0l-38.6 39V8c0-4.4-3.5-8-7.9-8H216c-4.4 0-7.9 3.6-7.9 8v65.4l-38.6-39c-3.1-3.1-8.1-3.1-11.2 0l-11.2 11.3c-3.1 3.1-3.1 8.2 0 11.3l60.9 61.7v109.7l-93.8-54.8-22.1-84.4c-1.1-4.3-5.5-6.8-9.7-5.7l-15.3 4.1c-4.2 1.1-6.7 5.5-5.6 9.8l14.1 53.3L19.7 118c-3.8-2.2-8.6-.9-10.8 2.9L1 134.8c-2.2 3.8-.9 8.7 2.9 10.9l55.9 32.7-52.6 14.4c-4.2 1.1-6.7 5.5-5.6 9.8l4.1 15.5c1.1 4.3 5.5 6.8 9.7 5.7l83.2-22.6 93.8 54.8-93.8 54.8-83.2-22.6c-4.2-1.1-8.6 1.4-9.7 5.7l-4.1 15.5c-1.1 4.3 1.4 8.7 5.6 9.8l52.7 14.3L4 366.1c-3.8 2.2-5.1 7.1-2.9 10.9L9 390.9c2.2 3.8 7 5.1 10.8 2.9l55.9-32.7-14.1 53.3c-1.1 4.3 1.4 8.7 5.6 9.8l15.3 4.1c4.2 1.1 8.6-1.4 9.7-5.7l22.3-84.2 93.8-54.8v109.7l-61 61.7c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.3c3.1 3.1 8.1 3.1 11.2 0l38.6-39V504c0 4.4 3.5 8 7.9 8H232c4.4 0 7.9-3.6 7.9-8v-65.4l38.6 39c3.1 3.1 8.1 3.1 11.2 0l11.2-11.3c3.1-3.1 3.1-8.2 0-11.3L240 393.3V283.7l93.8 54.8 22.3 84.2c1.1 4.3 5.5 6.8 9.7 5.7l15.3-4.1c4.2-1.1 6.7-5.5 5.6-9.8l-14.1-53.3 55.9 32.7c3.8 2.2 8.6.9 10.8-2.9l7.9-13.9c2.2-3.8.9-8.7-2.9-10.9l-56.2-32.7z"]
  },
      ZV = {
    prefix: "fal",
    iconName: "snowflakes",
    icon: [640, 512, [], "f7cf", "M527.9 120c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V91.6l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9L576 64l27.9-16c3.8-2.2 5.1-7.1 2.9-10.9l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V120zm80.2 136l27.9-16c3.8-2.2 5.1-7.1 2.9-10.9l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V200c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V312c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16zm-220.2 77.5l52.7-14.3c4.2-1.1 6.7-5.5 5.6-9.8l-4.1-15.5c-1.1-4.3-5.5-6.8-9.7-5.7l-83.1 22.6-93.8-54.8 93.7-54.8 83.1 22.6c4.2 1.1 8.6-1.4 9.7-5.7l4.1-15.5c1.1-4.3-1.4-8.7-5.6-9.8l-52.7-14.3 55.9-32.7c3.8-2.2 5.1-7.1 2.9-10.9l-7.9-13.9c-2.2-3.8-7-5.1-10.8-2.9L372 150.8l14.1-53.3c1.1-4.3-1.4-8.7-5.6-9.8l-15.3-4.1c-4.2-1.1-8.6 1.4-9.7 5.7l-22.3 84.2-93.7 54.8V118.6l61-61.6c3.1-3.1 3.1-8.2 0-11.3l-11.2-11.3c-3.1-3.1-8.1-3.1-11.2 0l-38.6 39V8c0-4.4-3.5-8-7.9-8h-15.8c-4.4 0-7.9 3.6-7.9 8v65.4l-38.6-39c-3.1-3.1-8.1-3.1-11.2 0l-11.2 11.3c-3.1 3.1-3.1 8.2 0 11.3l60.9 61.7v109.7l-93.7-54.8-22-84.4c-1.1-4.3-5.5-6.8-9.7-5.7l-15.3 4.1c-4.2 1.1-6.7 5.5-5.6 9.8l14.1 53.3L19.8 118c-3.8-2.2-8.6-.9-10.8 2.9l-7.9 13.9c-2.2 3.8-.9 8.7 2.9 10.9l55.9 32.7-52.6 14.4c-4.2 1.1-6.7 5.5-5.6 9.8l4.1 15.5c1.1 4.3 5.5 6.8 9.7 5.7l83.1-22.6 93.7 54.8-93.7 54.8-83.1-22.6c-4.2-1.1-8.6 1.4-9.7 5.7l-4.1 15.5c-1.1 4.3 1.4 8.7 5.6 9.8L60 333.5 4.1 366.1C.3 368.3-1 373.2 1.2 377l7.9 13.9c2.2 3.8 7 5.1 10.8 2.9l55.9-32.7-14.1 53.3c-1.1 4.3 1.4 8.7 5.6 9.8l15.3 4.1c4.2 1.1 8.6-1.4 9.7-5.7l22.3-84.2 93.7-54.8v109.7l-61 61.7c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.3c3.1 3.1 8.1 3.1 11.2 0l38.6-39V504c0 4.4 3.5 8 7.9 8H232c4.4 0 7.9-3.6 7.9-8v-65.4l38.6 39c3.1 3.1 8.1 3.1 11.2 0l11.2-11.3c3.1-3.1 3.1-8.2 0-11.3L240 393.3V283.7l93.7 54.8 22.3 84.2c1.1 4.3 5.5 6.8 9.7 5.7l15.3-4.1c4.2-1.1 6.7-5.5 5.6-9.8l-14.1-53.3 55.9 32.7c3.8 2.2 8.6.9 10.8-2.9l7.9-13.9c2.2-3.8.9-8.7-2.9-10.9l-56.3-32.7z"]
  },
      UV = {
    prefix: "fal",
    iconName: "snowman",
    icon: [512, 512, [], "f7d0", "M256 336c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zM224 72c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm287.3 75.5l-6.3-14.7c-1.7-4.1-6.4-5.9-10.5-4.2l-46.5 20V104c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v58.3l-53.4 22.9c-4.6-8.6-9.8-16.9-16.4-24.2 10.4-16.7 15.8-35.4 15.8-55C362 47.5 314.4 0 256 0S150 47.5 150 106c0 19.5 5.4 38.3 15.8 55-6.6 7.4-11.8 15.6-16.4 24.2L96 162.3V104c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v44.6l-46.5-19.9c-4.1-1.7-8.8.1-10.5 4.2L.7 147.6c-1.7 4.1.1 8.8 4.2 10.5l133.3 57.1c-1.9 8.4-3.2 17-3.2 25.8 0 7.2.8 14.5 2.4 22.4-25.8 29-39.9 66-39.9 105.1 0 54.2 27.6 104 73.8 133.4 10.5 6.6 23.6 10.1 37.9 10.1h93c15.8 0 31-4.8 44-13.8 51.8-35.9 76.9-96.8 65.6-159.1-5.1-28.1-17.9-54.1-37.2-75.8 1.6-7.9 2.4-15.1 2.4-22.3 0-8.8-1.3-17.4-3.2-25.8l133.3-57.1c4.1-1.8 6-6.5 4.2-10.6zm-131 197.3c9 49.8-11 98.5-52.4 127.1-7.6 5.3-16.6 8.1-25.8 8.1h-93c-5.7 0-14-.9-20.8-5.2-36.9-23.4-58.9-63.2-58.9-106.3 0-13.3-.5-51.6 43.3-95.7-5.8-21.5-5.8-25.5-5.8-31.8 0-25.5 10.7-49 30.2-66.3l11.5-10.2-9.7-11.9c-11.2-13.6-17-29.7-17-46.6 0-40.8 33.2-74 74-74s74 33.2 74 74c0 16.9-5.9 33-17 46.6l-9.7 11.9 11.5 10.2C334.2 192 345 215.5 345 241c0 6.6-.3 11.1-5.8 31.7 37.1 37.1 39.9 65.2 41.1 72.1zM256 272c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm32-200c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-32 136c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm0-96c-8.8 0-16 7.2-16 16s16 32 16 32 16-23.2 16-32-7.2-16-16-16z"]
  },
      BV = {
    prefix: "fal",
    iconName: "snowmobile",
    icon: [640, 512, [], "f7d1", "M639.2 466.7l-7.2-14.3c-2-4-6.8-5.6-10.7-3.6l-57.7 26.1c-3.9 2-8.1 3.2-12.4 4L496 405.3l72.9-48.6c4.5-3 7.1-8 7.1-13.3V265c0-5.6-2.9-10.8-7.8-13.7l-138.1-82.9-47.8-95.6c-4-7.9-13.5-11.1-21.5-7.2-7.9 4-11.1 13.6-7.2 21.5l46.8 93.6-16.9 22.6c-2.4-24.2-22.7-43.3-47.5-43.3h-38.8l-41.1-33.8c-.1-.1-.3-.2-.4-.3 27.7-7 48.4-32 48.4-61.8 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 15.6 5.8 29.7 15.1 40.8-10.1 1.2-43.6 7-61.9 43.4L104 198.6c-11.3 22.7-11.4 48.7-.1 71.3 3.4 6.8 7.8 12.7 12.7 18.1H112c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-2.7 5.4-3.7 11.1-3.3 16.6C20.5 393.4 0 418.2 0 448c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64 0-11.7-3.4-22.5-8.9-32H464l48 64h-88c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h118.2c12.4 0 24.6-2.9 35.7-8.4l57.7-26.1c3.9-2 5.5-6.8 3.6-10.8zM240 32c17.7 0 32 14.4 32 32s-14.3 32-32 32-32-14.4-32-32 14.3-32 32-32zM132.7 212.9l25.2-50.4c7-13.9 19.8-23.4 35.2-25.9 4.7-.8 24.7-3.5 41.7 13.4l46.6 38.3c2.8 2.3 6.5 3.6 10.2 3.6H336c8.8 0 16 7.2 16 16s-7.2 16-16 16h-44.5c-11.1 0-21.9-3.9-30.5-10.9l-43-35.3-37 74 76.5 14.3c26.6 5 35.4 38.7 14.6 56l-69.9 58.3c-7.1 5.9-17.1 4.5-22.5-2-5.7-6.8-4.8-16.9 2-22.5l69.9-58.2-84.9-15.9c-14.9-2.8-27.4-12.2-34.2-25.8-6.7-13.8-6.6-29.4.2-43zm212 42.2l-15.1 20.1c-3.9 5.2-9.5 8.4-15.5 10.4-.1-.3-.8-14.5-13.6-29.6H336c3 0 5.8-.4 8.7-.9zm-115.8-27h-.2v-.1l.2.1zM112 320h62.6l-13.3 11.1c-15.8 13.2-20.8 34.5-14.3 52.9H80l32-64zm144 160H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h192c17.7 0 32 14.3 32 32s-14.3 32-32 32zm-8.2-96l44.9-37.4c9-7.5 15.3-17.1 19-27.5 17.1-2.1 33.1-10.7 43.5-24.7l69.1-92.1L544 274.1v60.8L470.3 384H247.8z"]
  },
      RV = {
    prefix: "fal",
    iconName: "snowplow",
    icon: [640, 512, [], "f7d2", "M360 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm212.4 47.4c-9-9-14.1-21.2-14.1-34v-139c0-12.7 5.1-25 14.1-34l65.2-63.6c3.1-3.1 3.1-8.2 0-11.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0l-65.3 63.6c-15 15-23.4 35.4-23.4 56.6V304h-96.1v-66.9c0-8.7-1.8-17.2-5.2-25.2L346.7 29.1C339.1 11.4 321.8 0 302.5 0H158.2c-26.5 0-48 21.5-48 48v80h-16c-26.5 0-48 21.5-48 48v133.7C18.3 330.1 0 362.8 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-23.8-7.6-45.8-20.3-64h66.6v53.5c0 21.2 8.4 41.6 23.4 56.6l65.2 63.6c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-65.1-63.7zM142.2 128V48c0-8.8 7.2-16 16-16h144.3c6.5 0 12.3 3.8 14.8 9.7L395.4 224H214.2l-72-95.7v-.3zm-64 48c0-8.8 7.2-16 16-16H126l67.4 89.6c3 4 7.8 6.4 12.8 6.4h192v36.6c-9.7-2.7-19.7-4.6-30.2-4.6H112c-11.9 0-23.1 2.3-33.8 5.8V176zM368 480H112c-44.1 0-80-35.9-80-80s35.9-80 80-80h256c44.1 0 80 35.9 80 80s-35.9 80-80 80zM120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z"]
  },
      YV = {
    prefix: "fal",
    iconName: "soap",
    icon: [512, 512, [], "e06e", "M400,96a48,48,0,1,0-48-48A48.05,48.05,0,0,0,400,96Zm0-64a16,16,0,1,1-16,16A16,16,0,0,1,400,32ZM224,128a64,64,0,1,0-64-64A64,64,0,0,0,224,128Zm0-96a32,32,0,1,1-32,32A32,32,0,0,1,224,32ZM352,272H160a80,80,0,0,0,0,160H352a80,80,0,0,0,0-160Zm0,128H160a48,48,0,0,1,0-96H352a48,48,0,0,1,0,96Zm64-208H384a64,64,0,0,0-128,0H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96-32a32,32,0,1,1-32,32A32,32,0,0,1,320,160ZM480,416a64.07,64.07,0,0,1-64,64H96a64.07,64.07,0,0,1-64-64V288a64.07,64.07,0,0,1,64-64H264.88a63.47,63.47,0,0,0,110.24,0H416a64.07,64.07,0,0,1,64,64Z"]
  },
      PV = {
    prefix: "fal",
    iconName: "socks",
    icon: [512, 512, [], "f696", "M448 0h-95.83c-11.87 0-22.84 3.43-32.37 9.04C310.43 3.49 299.71 0 288 0h-95.83c-35.32 0-63.96 28.46-64 63.78C128.1 137.27 128 248 128 248l-79.77 59.39c-45.97 34.49-62.82 98.49-34.06 148.25C35.46 492.47 73.8 512 112.09 512c23.38 0 46.97-7.3 67.09-22.41l13.76-10.32c21.47 21.46 50.13 32.72 79.14 32.72 23.38 0 46.97-7.3 67.09-22.41l121.61-91.2a128.006 128.006 0 0 0 51.21-102.4V64C512 28.65 483.35 0 448 0zm-95.83 32H448c17.64 0 32 14.36 32 32v32H320.14l.03-32.18c.02-17.55 14.38-31.82 32-31.82zm-160 0H288c2.91 0 5.68.47 8.31 1.24-5.02 9.1-8.13 19.4-8.14 30.54L288.14 96h-128l.03-32.18c.02-17.55 14.38-31.82 32-31.82zm-18.32 421.6L159.97 464c-13.94 10.46-30.5 16-47.88 16-28.98 0-55.61-15.09-70.22-40.38-19.78-34.21-8.55-81.05 25.56-106.64L159.98 264l.13-136h128c-.06 60.63-.11 120-.11 120l-79.16 59.39c-45.37 34.03-62.18 96.75-34.99 146.21zM480 295.99c0 30.06-14.36 58.77-38.4 76.8L319.97 464c-13.94 10.46-30.5 16-47.88 16-28.98 0-55-15.09-69.62-40.38-19.78-34.21-8.55-81.05 25.56-106.64L319.98 264l.13-136H480v167.99z"]
  },
      FV = {
    prefix: "fal",
    iconName: "solar-panel",
    icon: [640, 512, [], "f5ba", "M586.22 26.74C583.65 11.31 570.3 0 554.66 0H85.34C69.7 0 56.35 11.31 53.78 26.74l-53.33 320C-2.81 366.24 12.23 384 32.01 384H224v96h-40c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h272c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-40v-96h191.99c19.77 0 34.81-17.76 31.56-37.26l-53.33-320zM578.66 176h-138.6l-14.4-144h129l24 144zm-170.73 0H232.07l14.4-144h147.07l14.39 144zM85.34 32h129l-14.4 144H61.34l24-144zM56.01 208h140.73l-14.4 144H32.01l24-144zM384 480H256v-96h128v96zM214.48 352l14.4-144h182.25l14.4 144H214.48zm243.17 0l-14.4-144h140.74l24 144H457.65z"]
  },
      WV = {
    prefix: "fal",
    iconName: "solar-system",
    icon: [512, 512, [], "e02f", "M380.38574,123.71484c-12.63061-12.62695-31.37817-14.52343-46.441-6.73632C310.32861,103.71484,283.90894,96,256.06494,96A159.97282,159.97282,0,1,0,389.146,167.08984,39.99385,39.99385,0,0,0,380.38574,123.71484ZM346.59082,346.51562c-48.32629,48.34376-132.72546,48.34376-181.05176,0A128,128,0,0,1,256.06494,128c20.54492,0,40.09741,5.33594,57.88184,14.41406-3.27832,13.16992-.44544,27.57227,9.85241,37.86914a39.76141,39.76141,0,0,0,41.24817,9.19532,127.01793,127.01793,0,0,1-18.45654,157.0371ZM437.234,74.98047A255.4604,255.4604,0,0,0,147.06494,24.59766c.4397.42187.95935.70312,1.39111,1.13476A87.01815,87.01815,0,0,1,165.7832,51.05273,223.59876,223.59876,0,0,1,446.85205,372.9082a56.40228,56.40228,0,1,0,24.45227,21.15039C535.08618,294.95312,524.0166,161.69922,437.234,74.98047ZM424.113,448a24,24,0,1,1,24.00683-24A24.00468,24.00468,0,0,1,424.113,448Zm-79.18677,13.63477A224.11,224.11,0,0,1,31.92065,256c0-41.99609,12.22229-81.83008,33.74805-116.69531a56.61059,56.61059,0,1,0-24.98376-21.6211c-63.88941,99.11524-52.57556,232.57618,34.24621,319.33594a255.43887,255.43887,0,0,0,289.01441,50.91992c-.65259-.61328-1.41455-1.03711-2.05152-1.67383A86.959,86.959,0,0,1,344.92627,461.63477ZM88.01685,64A24,24,0,1,1,64.01,88,24.00335,24.00335,0,0,1,88.01685,64ZM256.06494,176a80,80,0,1,0,80.023,80A80.10313,80.10313,0,0,0,256.06494,176Zm0,128a48,48,0,1,1,48.0138-48A48.0067,48.0067,0,0,1,256.06494,304Z"]
  },
      GV = {
    prefix: "fal",
    iconName: "sort",
    icon: [320, 512, [], "f0dc", "M288 288H32c-28.4 0-42.8 34.5-22.6 54.6l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c20-20.1 5.7-54.6-22.7-54.6zM160 448L32 320h256L160 448zM32 224h256c28.4 0 42.8-34.5 22.6-54.6l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128C-10.7 189.5 3.6 224 32 224zM160 64l128 128H32L160 64z"]
  },
      qV = {
    prefix: "fal",
    iconName: "sort-alpha-down",
    icon: [448, 512, [], "f15d", "M432 288H304a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8l87.68.07-92.76 131.79a16 16 0 0 0-2.92 9.21V472a8 8 0 0 0 8 8h128a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-87.81l92.89-131.86a16 16 0 0 0 2.92-9.21V296a8 8 0 0 0-8-8zm15.29-80.06l-59.76-168A11.87 11.87 0 0 0 376.37 32h-16.74a11.87 11.87 0 0 0-11.16 7.94l-59.76 168A12 12 0 0 0 299.88 224H311a11.86 11.86 0 0 0 11.21-8.09l15.1-44.27h60.85L413.5 216a11.88 11.88 0 0 0 11.2 8h11.42a12 12 0 0 0 11.17-16.06zm-99.9-67.36s19.62-56.87 20.5-60c.87 3.14 20.24 60 20.24 60zm-148.46 231a11.93 11.93 0 0 0-16.91-.09l-54 52.67V40a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v383.92l-53.94-52.35a12 12 0 0 0-16.92 0l-5.64 5.66a12 12 0 0 0 0 17l84.06 82.3a11.94 11.94 0 0 0 16.87 0l84-82.32a12 12 0 0 0 .09-17z"]
  },
      JV = {
    prefix: "fal",
    iconName: "sort-alpha-down-alt",
    icon: [448, 512, [], "f881", "M304 224h128a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-87.81l92.89-131.86a16 16 0 0 0 2.92-9.21V40a8 8 0 0 0-8-8H304a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8l87.68.07-92.76 131.79a16 16 0 0 0-2.92 9.21V216a8 8 0 0 0 8 8zm143.29 239.94l-59.76-168a11.87 11.87 0 0 0-11.16-7.94h-16.74a11.87 11.87 0 0 0-11.16 7.94l-59.76 168A12 12 0 0 0 299.88 480H311a11.86 11.86 0 0 0 11.21-8.09l15.1-44.27h60.85L413.5 472a11.88 11.88 0 0 0 11.2 8h11.42a12 12 0 0 0 11.17-16.06zm-99.9-67.36s19.62-56.87 20.5-60c.87 3.14 20.24 60 20.24 60zm-148.46-25a11.93 11.93 0 0 0-16.91-.09l-54 52.67V40a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v383.92l-53.94-52.35a12 12 0 0 0-16.92 0l-5.64 5.66a12 12 0 0 0 0 17l84.06 82.3a11.94 11.94 0 0 0 16.87 0l84-82.32a12 12 0 0 0 .09-17z"]
  },
      KV = {
    prefix: "fal",
    iconName: "sort-alpha-up",
    icon: [448, 512, [], "f15e", "M120.44 35.51a11.94 11.94 0 0 0-16.87 0l-84 82.32a12 12 0 0 0-.09 17l5.61 5.68a11.93 11.93 0 0 0 16.91.09l54-52.74V472a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V88.08l53.94 52.35a12 12 0 0 0 16.92 0l5.64-5.66a12 12 0 0 0 0-17zm326.85 172.43l-59.76-168A11.87 11.87 0 0 0 376.37 32h-16.74a11.87 11.87 0 0 0-11.16 7.94l-59.76 168A12 12 0 0 0 299.88 224H311a11.86 11.86 0 0 0 11.21-8.09l15.1-44.27h60.85L413.5 216a11.88 11.88 0 0 0 11.2 8h11.42a12 12 0 0 0 11.17-16.06zm-99.9-67.36s19.62-56.87 20.5-60c.87 3.14 20.24 60 20.24 60zM432 288H304a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8l87.68.07-92.76 131.79a16 16 0 0 0-2.92 9.21V472a8 8 0 0 0 8 8h128a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-87.81l92.89-131.86a16 16 0 0 0 2.92-9.21V296a8 8 0 0 0-8-8z"]
  },
      XV = {
    prefix: "fal",
    iconName: "sort-alpha-up-alt",
    icon: [448, 512, [], "f882", "M304 224h128a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-87.81l92.89-131.86a16 16 0 0 0 2.92-9.21V40a8 8 0 0 0-8-8H304a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8l87.68.07-92.76 131.79a16 16 0 0 0-2.92 9.21V216a8 8 0 0 0 8 8zM120.44 35.51a11.94 11.94 0 0 0-16.87 0l-84 82.32a12 12 0 0 0-.09 17l5.61 5.68a11.93 11.93 0 0 0 16.91.09l54-52.74V472a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V88.08l53.94 52.35a12 12 0 0 0 16.92 0l5.64-5.66a12 12 0 0 0 0-17zm326.85 428.43l-59.76-168a11.87 11.87 0 0 0-11.16-7.94h-16.74a11.87 11.87 0 0 0-11.16 7.94l-59.76 168A12 12 0 0 0 299.88 480H311a11.86 11.86 0 0 0 11.21-8.09l15.1-44.27h60.85L413.5 472a11.88 11.88 0 0 0 11.2 8h11.42a12 12 0 0 0 11.17-16.06zm-99.9-67.36s19.62-56.87 20.5-60c.87 3.14 20.24 60 20.24 60z"]
  },
      _V = {
    prefix: "fal",
    iconName: "sort-alt",
    icon: [384, 512, [], "f883", "M364.5 117.81l-84.06-82.3a11.94 11.94 0 0 0-16.87 0l-84 82.32a12 12 0 0 0-.09 17l5.61 5.68a11.93 11.93 0 0 0 16.91.09l54-52.67V472a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V88.08l53.94 52.35a12 12 0 0 0 16.92 0l5.64-5.66a12 12 0 0 0 0-16.96zM198.93 371.56a11.93 11.93 0 0 0-16.91-.09l-54 52.67V40a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v383.92l-53.94-52.35a12 12 0 0 0-16.92 0l-5.64 5.66a12 12 0 0 0 0 17l84.06 82.3a11.94 11.94 0 0 0 16.87 0l84-82.32a12 12 0 0 0 .09-17z"]
  },
      $V = {
    prefix: "fal",
    iconName: "sort-amount-down",
    icon: [512, 512, [], "f160", "M376 288H264a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm-64 96h-48a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM504 96H264a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h240a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm-64 96H264a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h176a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM198.93 371.56a11.93 11.93 0 0 0-16.91-.09l-54 52.67V40a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v383.92l-53.94-52.35a12 12 0 0 0-16.92 0l-5.64 5.66a12 12 0 0 0 0 17l84.06 82.3a11.94 11.94 0 0 0 16.87 0l84-82.32a12 12 0 0 0 .09-17z"]
  },
      cx = {
    prefix: "fal",
    iconName: "sort-amount-down-alt",
    icon: [512, 512, [], "f884", "M264 320h176a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H264a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0-192h48a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0 96h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H264a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm240 160H264a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h240a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm-305.07-12.44a11.93 11.93 0 0 0-16.91-.09l-54 52.67V40a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v383.92l-53.94-52.35a12 12 0 0 0-16.92 0l-5.64 5.66a12 12 0 0 0 0 17l84.06 82.3a11.94 11.94 0 0 0 16.87 0l84-82.32a12 12 0 0 0 .09-17z"]
  },
      ex = {
    prefix: "fal",
    iconName: "sort-amount-up",
    icon: [512, 512, [], "f161", "M312 384h-48a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm64-96H264a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM504 96H264a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h240a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm-64 96H264a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h176a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM120.44 35.51a11.94 11.94 0 0 0-16.87 0l-84 82.32a12 12 0 0 0-.09 17l5.61 5.68a11.93 11.93 0 0 0 16.91.09l54-52.74V472a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V88.08l53.94 52.35a12 12 0 0 0 16.92 0l5.64-5.66a12 12 0 0 0 0-17z"]
  },
      ax = {
    prefix: "fal",
    iconName: "sort-amount-up-alt",
    icon: [512, 512, [], "f885", "M264 224h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H264a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0 96h176a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H264a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0-192h48a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm240 256H264a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h240a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM120.44 35.51a11.94 11.94 0 0 0-16.87 0l-84 82.32a12 12 0 0 0-.09 17l5.61 5.68a11.93 11.93 0 0 0 16.91.09l54-52.74V472a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V88.08l53.94 52.35a12 12 0 0 0 16.92 0l5.64-5.66a12 12 0 0 0 0-17z"]
  },
      nx = {
    prefix: "fal",
    iconName: "sort-circle",
    icon: [512, 512, [], "e030", "M164.75,224H347.11c16.4,0,24.59-19.85,13-31.41L269,101.41a18.36,18.36,0,0,0-13-5.41,18.15,18.15,0,0,0-13,5.41l-91.25,91.18C140.16,204.15,148.35,224,164.75,224ZM256,133.67,314.3,192H197.59ZM347.11,288H164.75c-16.4,0-24.59,19.85-13,31.41L243,410.59a18.15,18.15,0,0,0,13,5.41,18.34,18.34,0,0,0,13-5.41l91.18-91.18C371.7,307.85,363.52,288,347.11,288ZM256,378.33,197.59,320H314.3ZM350.88,26.94A247.21,247.21,0,0,0,256.1,8C158.8,8,66.49,65.64,26.94,161.12c-52.4,126.51,7.67,271.54,134.18,323.94A247.21,247.21,0,0,0,255.9,504c97.3,0,189.61-57.64,229.16-153.12C537.46,224.37,477.39,79.34,350.88,26.94ZM455.5,338.64A215.73,215.73,0,0,1,173.37,455.5C63.36,409.93,10.94,283.37,56.5,173.36A215.73,215.73,0,0,1,338.63,56.5C448.64,102.07,501.06,228.63,455.5,338.64Z"]
  },
      tx = {
    prefix: "fal",
    iconName: "sort-circle-down",
    icon: [512, 512, [], "e031", "M350.88,26.94A247.21,247.21,0,0,0,256.1,8C158.8,8,66.49,65.64,26.94,161.12c-52.4,126.51,7.67,271.54,134.18,323.94A247.21,247.21,0,0,0,255.9,504c97.3,0,189.61-57.64,229.16-153.12C537.46,224.37,477.39,79.34,350.88,26.94ZM455.5,338.64A215.73,215.73,0,0,1,173.37,455.5C63.36,409.93,10.94,283.37,56.5,173.36A215.73,215.73,0,0,1,338.63,56.5C448.64,102.07,501.06,228.63,455.5,338.64ZM347.25,288H164.89c-16.4,0-24.59,19.85-13,31.41L243,410.59a18.36,18.36,0,0,0,13,5.41,18.15,18.15,0,0,0,13-5.41l91.25-91.18C371.84,307.85,363.65,288,347.25,288ZM256,378.33,197.7,320H314.41Zm11.27-277.64a16,16,0,0,0-22.62,0l-96,96a16,16,0,0,0,22.62,22.62L256,134.63l84.69,84.68a16,16,0,0,0,22.62-22.62Z"]
  },
      rx = {
    prefix: "fal",
    iconName: "sort-circle-up",
    icon: [512, 512, [], "e032", "M161.12,485.06A247.21,247.21,0,0,0,255.9,504c97.3,0,189.61-57.64,229.16-153.12,52.4-126.51-7.67-271.54-134.18-323.94A247.21,247.21,0,0,0,256.1,8C158.8,8,66.49,65.64,26.94,161.12-25.46,287.63,34.61,432.66,161.12,485.06ZM56.5,173.36A215.74,215.74,0,0,1,338.64,56.5c110,45.57,162.42,172.13,116.86,282.14A215.73,215.73,0,0,1,173.37,455.5C63.36,409.93,10.94,283.37,56.5,173.36ZM164.75,224H347.11c16.4,0,24.59-19.85,13-31.41L269,101.41a18.36,18.36,0,0,0-13-5.41,18.15,18.15,0,0,0-13,5.41l-91.25,91.18C140.17,204.15,148.35,224,164.75,224ZM256,133.67,314.3,192H197.59ZM244.69,411.31a16,16,0,0,0,22.62,0l96-96a16,16,0,0,0-22.62-22.62L256,377.37l-84.69-84.68a16,16,0,0,0-22.62,22.62Z"]
  },
      ix = {
    prefix: "fal",
    iconName: "sort-down",
    icon: [320, 512, [], "f0dd", "M287.968 288H32.038c-28.425 0-42.767 34.488-22.627 54.627l127.962 128c12.496 12.496 32.758 12.497 45.255 0l127.968-128C330.695 322.528 316.45 288 287.968 288zM160 448L32 320h256L160 448z"]
  },
      ox = {
    prefix: "fal",
    iconName: "sort-numeric-down",
    icon: [448, 512, [], "f162", "M344.49 257.48a72 72 0 1 0 52.16 132c-8.84 31.22-35.92 54.86-69.08 58a8.07 8.07 0 0 0-7.57 7.92v16.07a8 8 0 0 0 8.38 8.05A112.15 112.15 0 0 0 432 367.86v-40a72.13 72.13 0 0 0-87.51-70.38zM360 367.86a40 40 0 1 1 40-40 40 40 0 0 1-40 40zM424 192h-40V48a16 16 0 0 0-16-16h-12a16 16 0 0 0-13.57 7.52l-20 32A16 16 0 0 0 336 96h16v96h-40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM198.93 371.56a11.93 11.93 0 0 0-16.91-.09l-54 52.67V40a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v383.92l-53.94-52.35a12 12 0 0 0-16.92 0l-5.64 5.66a12 12 0 0 0 0 17l84.06 82.3a11.94 11.94 0 0 0 16.87 0l84-82.32a12 12 0 0 0 .09-17z"]
  },
      lx = {
    prefix: "fal",
    iconName: "sort-numeric-down-alt",
    icon: [448, 512, [], "f886", "M424 448h-40V304a16 16 0 0 0-16-16h-12a16 16 0 0 0-13.57 7.52l-20 32A16 16 0 0 0 336 352h16v96h-40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM344.49 33.92A72 72 0 0 0 360 176.29a71.13 71.13 0 0 0 36.65-10.37c-8.84 31.22-35.92 54.86-69.08 58a8.08 8.08 0 0 0-7.57 7.92v16.07a8 8 0 0 0 8.38 8.06A112.16 112.16 0 0 0 432 144.29v-40a72.13 72.13 0 0 0-87.51-70.37zM360 144.29a40 40 0 1 1 40-40 40 40 0 0 1-40 40zM198.93 371.56a11.93 11.93 0 0 0-16.91-.09l-54 52.67V40a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v383.92l-53.94-52.35a12 12 0 0 0-16.92 0l-5.64 5.66a12 12 0 0 0 0 17l84.06 82.3a11.94 11.94 0 0 0 16.87 0l84-82.32a12 12 0 0 0 .09-17z"]
  },
      fx = {
    prefix: "fal",
    iconName: "sort-numeric-up",
    icon: [448, 512, [], "f163", "M424 192h-40V48a16 16 0 0 0-16-16h-12a16 16 0 0 0-13.57 7.52l-20 32A16 16 0 0 0 336 96h16v96h-40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm-79.51 65.48a72 72 0 1 0 52.16 132c-8.84 31.22-35.92 54.86-69.08 58a8.07 8.07 0 0 0-7.57 7.92v16.07a8 8 0 0 0 8.38 8.05A112.15 112.15 0 0 0 432 367.86v-40a72.13 72.13 0 0 0-87.51-70.38zM360 367.86a40 40 0 1 1 40-40 40 40 0 0 1-40 40zM120.44 35.51a11.94 11.94 0 0 0-16.87 0l-84 82.32a12 12 0 0 0-.09 17l5.61 5.68a11.93 11.93 0 0 0 16.91.09l54-52.74V472a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V88.08l53.94 52.35a12 12 0 0 0 16.92 0l5.64-5.66a12 12 0 0 0 0-17z"]
  },
      sx = {
    prefix: "fal",
    iconName: "sort-numeric-up-alt",
    icon: [448, 512, [], "f887", "M120.44 35.51a11.94 11.94 0 0 0-16.87 0l-84 82.32a12 12 0 0 0-.09 17l5.61 5.68a11.93 11.93 0 0 0 16.91.09l54-52.74V472a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V88.08l53.94 52.35a12 12 0 0 0 16.92 0l5.64-5.66a12 12 0 0 0 0-17zm224.05-1.59A72 72 0 0 0 360 176.29a71.13 71.13 0 0 0 36.65-10.37c-8.84 31.22-35.92 54.86-69.08 58a8.08 8.08 0 0 0-7.57 7.92v16.07a8 8 0 0 0 8.38 8.06A112.16 112.16 0 0 0 432 144.29v-40a72.13 72.13 0 0 0-87.51-70.37zM360 144.29a40 40 0 1 1 40-40 40 40 0 0 1-40 40zM424 448h-40V304a16 16 0 0 0-16-16h-12a16 16 0 0 0-13.57 7.52l-20 32A16 16 0 0 0 336 352h16v96h-40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      ux = {
    prefix: "fal",
    iconName: "sort-shapes-down",
    icon: [448, 512, [], "f888", "M444.1 182.86L361 45.71a29.56 29.56 0 0 0-49.9 0l-83.2 137.15c-11.08 18.28 2.77 41.14 24.95 41.14h166.3c22.18 0 36.03-22.86 24.95-41.14zM259.77 192L336 66.28 412.23 192zM264 480h144a24 24 0 0 0 24-24V312a24 24 0 0 0-24-24H264a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24zm8-160h128v128H272zm-73.07 51.56a11.93 11.93 0 0 0-16.91-.09l-54 52.67V40a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v383.92l-53.94-52.35a12 12 0 0 0-16.92 0l-5.64 5.66a12 12 0 0 0 0 17l84.06 82.3a11.94 11.94 0 0 0 16.87 0l84-82.32a12 12 0 0 0 .09-17z"]
  },
      hx = {
    prefix: "fal",
    iconName: "sort-shapes-down-alt",
    icon: [448, 512, [], "f889", "M444.1 438.86L361 301.71a29.56 29.56 0 0 0-49.9 0l-83.2 137.15c-11.08 18.28 2.77 41.14 24.95 41.14h166.3c22.18 0 36.03-22.86 24.95-41.14zM259.77 448L336 322.28 412.23 448zM264 224h144a24 24 0 0 0 24-24V56a24 24 0 0 0-24-24H264a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24zm8-160h128v128H272zm-73.07 304.56a11.93 11.93 0 0 0-16.91-.09l-54 52.67V37a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v383.92l-53.94-52.35a12 12 0 0 0-16.92 0l-5.64 5.66a12 12 0 0 0 0 17l84.06 82.3a11.94 11.94 0 0 0 16.87 0l84-82.32a12 12 0 0 0 .09-17z"]
  },
      mx = {
    prefix: "fal",
    iconName: "sort-shapes-up",
    icon: [448, 512, [], "f88a", "M264 480h144a24 24 0 0 0 24-24V312a24 24 0 0 0-24-24H264a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24zm8-160h128v128H272zM120.44 35.51a11.94 11.94 0 0 0-16.87 0l-84 82.32a12 12 0 0 0-.09 17l5.61 5.68a11.93 11.93 0 0 0 16.91.09l54-52.74V472a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V88.08l53.94 52.35a12 12 0 0 0 16.92 0l5.64-5.66a12 12 0 0 0 0-17zM444.1 182.86L361 45.71a29.56 29.56 0 0 0-49.9 0l-83.2 137.15c-11.08 18.28 2.77 41.14 24.95 41.14h166.3c22.18 0 36.03-22.86 24.95-41.14zM259.77 192L336 66.28 412.23 192z"]
  },
      vx = {
    prefix: "fal",
    iconName: "sort-shapes-up-alt",
    icon: [448, 512, [], "f88b", "M444.1 438.86L361 301.71a29.56 29.56 0 0 0-49.9 0l-83.2 137.15c-11.08 18.28 2.77 41.14 24.95 41.14h166.3c22.18 0 36.03-22.86 24.95-41.14zM259.77 448L336 322.28 412.23 448zM264 224h144a24 24 0 0 0 24-24V56a24 24 0 0 0-24-24H264a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24zm8-160h128v128H272zM120.44 35.51a11.94 11.94 0 0 0-16.87 0l-84 82.32a12 12 0 0 0-.09 17l5.61 5.68a11.93 11.93 0 0 0 16.91.09l54-52.74V472a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V88.08l53.94 52.35a12 12 0 0 0 16.92 0l5.64-5.66a12 12 0 0 0 0-17z"]
  },
      dx = {
    prefix: "fal",
    iconName: "sort-size-down",
    icon: [512, 512, [], "f88c", "M198.93 371.56a11.93 11.93 0 0 0-16.91-.09l-54 52.67V40a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v383.92l-53.94-52.35a12 12 0 0 0-16.92 0l-5.64 5.66a12 12 0 0 0 0 17l84.06 82.3a11.94 11.94 0 0 0 16.87 0l84-82.32a12 12 0 0 0 .09-17zM484 32H284a28 28 0 0 0-28 28v168a28 28 0 0 0 28 28h200a28 28 0 0 0 28-28V60a28 28 0 0 0-28-28zm-4 192H288V64h192zm-52 96H276a20 20 0 0 0-20 20v120a20 20 0 0 0 20 20h152a20 20 0 0 0 20-20V340a20 20 0 0 0-20-20zm-12 128H288v-96h128z"]
  },
      Mx = {
    prefix: "fal",
    iconName: "sort-size-down-alt",
    icon: [512, 512, [], "f88d", "M198.93 371.56a11.93 11.93 0 0 0-16.91-.09l-54 52.67V40a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v383.92l-53.94-52.35a12 12 0 0 0-16.92 0l-5.64 5.66a12 12 0 0 0 0 17l84.06 82.3a11.94 11.94 0 0 0 16.87 0l84-82.32a12 12 0 0 0 .09-17zM276 192h152a20 20 0 0 0 20-20V52a20 20 0 0 0-20-20H276a20 20 0 0 0-20 20v120a20 20 0 0 0 20 20zm12-128h128v96H288zm196 192H284a28 28 0 0 0-28 28v168a28 28 0 0 0 28 28h200a28 28 0 0 0 28-28V284a28 28 0 0 0-28-28zm-4 192H288V288h192z"]
  },
      px = {
    prefix: "fal",
    iconName: "sort-size-up",
    icon: [512, 512, [], "f88e", "M25.07 140.44a11.93 11.93 0 0 0 16.91.09L96 87.86V472a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V88.08l53.94 52.35a12 12 0 0 0 16.92 0l5.64-5.66a12 12 0 0 0 0-17l-84.06-82.3a11.94 11.94 0 0 0-16.87 0l-84 82.32a12 12 0 0 0-.09 17zM484 32H284a28 28 0 0 0-28 28v168a28 28 0 0 0 28 28h200a28 28 0 0 0 28-28V60a28 28 0 0 0-28-28zm-4 192H288V64h192zm-52 96H276a20 20 0 0 0-20 20v120a20 20 0 0 0 20 20h152a20 20 0 0 0 20-20V340a20 20 0 0 0-20-20zm-12 128H288v-96h128z"]
  },
      zx = {
    prefix: "fal",
    iconName: "sort-size-up-alt",
    icon: [512, 512, [], "f88f", "M25.07 140.44a11.93 11.93 0 0 0 16.91.09L96 87.86V472a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V88.08l53.94 52.35a12 12 0 0 0 16.92 0l5.64-5.66a12 12 0 0 0 0-17l-84.06-82.3a11.94 11.94 0 0 0-16.87 0l-84 82.32a12 12 0 0 0-.09 17zM276 192h152a20 20 0 0 0 20-20V52a20 20 0 0 0-20-20H276a20 20 0 0 0-20 20v120a20 20 0 0 0 20 20zm12-128h128v96H288zm196 192H284a28 28 0 0 0-28 28v168a28 28 0 0 0 28 28h200a28 28 0 0 0 28-28V284a28 28 0 0 0-28-28zm-4 192H288V288h192z"]
  },
      Cx = {
    prefix: "fal",
    iconName: "sort-up",
    icon: [320, 512, [], "f0de", "M32.032 224h255.93c28.425 0 42.767-34.488 22.627-54.627l-127.962-128c-12.496-12.496-32.758-12.497-45.255 0l-127.968 128C-10.695 189.472 3.55 224 32.032 224zM160 64l128 128H32L160 64z"]
  },
      Lx = {
    prefix: "fal",
    iconName: "soup",
    icon: [512, 512, [], "f823", "M319.5 151.9a8.12 8.12 0 0 0 8 7.8h16a7.94 7.94 0 0 0 8-8.2c-2.1-42.1-19.3-73.3-41.6-95.5-18.4-18.7-21.1-38.2-21.9-48.9a7.87 7.87 0 0 0-8-7.1l-16 .1a8 8 0 0 0-7.9 8.7 105.46 105.46 0 0 0 31.2 69.7c17.3 17.2 30.4 40.7 32.2 73.4zm-111.5 0a8.12 8.12 0 0 0 8 7.8h16a7.94 7.94 0 0 0 8-8.2c-2.1-42.1-19.3-73.3-41.6-95.5-18.3-18.7-21-38.2-21.8-48.9a7.9 7.9 0 0 0-8.1-7.1l-16 .1a8 8 0 0 0-7.9 8.7c1 14.9 5.2 43.6 31.2 69.7 17.29 17.2 30.39 40.7 32.2 73.4zM480 192H32a32 32 0 0 0-32 32c0 94.7 51.56 177.16 128 221.45V480a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32v-34.55C460.44 401.16 512 318.7 512 224a32 32 0 0 0-32-32zM352 427v53H160v-53C27.66 350.33 32 241.22 32 224h448c0 17.46 3.37 126.89-128 203z"]
  },
      Ax = {
    prefix: "fal",
    iconName: "spa",
    icon: [576, 512, [], "f5bb", "M568.28 192.08h-.04c-22.64.1-92 4.29-158.85 42.35-19.43-81.58-60.36-153.88-112.52-199.29-2.4-2.09-5.63-3.14-8.85-3.14s-6.44 1.04-8.85 3.14C227 80.55 186.05 152.85 166.6 234.44 99.76 196.37 30.4 192.19 7.75 192.08h-.04c-4.39 0-7.76 3.41-7.72 7.82.23 27.94 7.14 126.2 88.77 199.41 58.23 56.73 131.07 74.8 176.96 80.46.01.3 44.52.3 44.52 0 45.89-5.66 118.73-23.73 176.96-80.46 81.64-73.2 88.54-171.47 88.77-199.41.07-4.41-3.29-7.82-7.69-7.82zM110.13 375.47c-55.22-49.52-71.61-112.28-76.32-149.92 40.84 4.1 110.91 19.31 166.44 73.44 25.37 22.72 44.4 49.96 58.17 83.28 8.5 20.57 13.57 41.3 13.57 65.82-42.77-1.15-114.58-26.6-161.86-72.62zm111.46-100.34c-8.51-8.3-17.45-15.42-26.46-22.15 15.13-71.58 48.71-138.15 92.9-182.33 44.17 44.17 77.74 110.74 92.85 182.32-9.02 6.73-17.95 13.85-26.47 22.15-33.12 29.65-53.36 63.34-66.41 94.91-13.05-31.57-33.29-65.26-66.41-94.9zM464.9 376.37c-44.61 43.46-116.13 70.51-160.9 71.71 0-24.31 4.98-45.03 13.57-65.82 13.77-33.33 32.8-60.57 59.17-84.22 54.78-53.42 124.71-68.46 165.44-72.52-4.74 37.68-21.29 100.62-77.28 150.85z"]
  },
      Nx = {
    prefix: "fal",
    iconName: "space-shuttle",
    icon: [640, 512, [], "f197", "M448 168C208 168 240 32 96.003 32H80c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v144c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64h16.003C240 480 208 344 448 344c106.039 0 192-39.399 192-88s-85.961-88-192-88zm-152 0H166.495c-11.973-5.241-25.014-8-38.495-8V67.183C187.971 80.409 219.668 148.917 296 168zM127.046 320H64v-48h48c17.673 0 32-7.163 32-16s-14.327-16-32-16H64v-48h64c35.629 0 64.458 29.114 63.994 64.85-.456 35.171-29.775 63.15-64.948 63.15zM64 96c0-19.851 10.359-32 16-32h16v96H64V96zm0 320v-64h32v96H80c-5.641 0-16-12.149-16-32zm64 28.817v-92.829c13.196-.126 26.009-2.869 37.816-7.989H296c-76.327 19.083-108.024 87.591-168 100.818zM448 312H205.781c24.716-33.856 23.823-79.277.215-112H448c41.469 0 88 0 128 24v64c-40 24-86.45 24-128 24zm40.014-16c-4.426 0-8.014-3.582-8.014-8v-64c0-4.418 3.588-8 8.014-8 31.998 0 31.965 80 0 80z"]
  },
      gx = {
    prefix: "fal",
    iconName: "space-station-moon",
    icon: [512, 512, [], "e033", "M256,8C119.0332,8,8,119.0332,8,256S119.0332,504,256,504,504,392.9668,504,256,392.9668,8,256,8Zm0,464c-93.57227,0-173.207-59.918-203.14648-143.31445A892.19066,892.19066,0,0,0,256,352a892.19066,892.19066,0,0,0,203.14648-23.31445C429.207,412.082,349.57227,472,256,472ZM43.50391,293.64062A215.62336,215.62336,0,0,1,40,256C40,136.89648,136.89648,40,256,40s216,96.89648,216,216a215.62336,215.62336,0,0,1-3.50391,37.64062C337.67578,327.79883,174.32422,327.79883,43.50391,293.64062ZM200,80a88,88,0,1,0,88,88A87.99936,87.99936,0,0,0,200,80Zm0,144a56,56,0,1,1,56-56A56.06416,56.06416,0,0,1,200,224Zm0-80a24,24,0,1,0,24,24A23.99993,23.99993,0,0,0,200,144Z"]
  },
      Hx = {
    prefix: "fal",
    iconName: "space-station-moon-alt",
    icon: [512, 512, [], "e034", "M224.03985,168.00007a24.00456,24.00456,0,1,1-24.00456-24A24.00346,24.00346,0,0,1,224.03985,168.00007ZM496.85531,314.44538a8.20823,8.20823,0,0,1-5.64755,5.91992,810.55026,810.55026,0,0,1-107.13753,22.53125v41.10352h56.01063a7.99991,7.99991,0,0,1,8.00152,8v17.91211a8.25737,8.25737,0,0,1-1.91247,5.30273,247.48223,247.48223,0,0,1-190.124,88.78516c-140.99161,0-254.5073-117.61133-247.75993-260.05859C14.2891,117.20905,118.82261,13.43366,245.61426,8.21491A246.96216,246.96216,0,0,1,413.10309,64.19734a8.22137,8.22137,0,0,1,2.97322,6.34765v49.45508a8.00116,8.00116,0,0,1-8.00152,8H384.07023v32h56.01063a7.99991,7.99991,0,0,1,8.00152,8v56l46.671-.00195a7.91467,7.91467,0,0,1,7.94487,6.99609A243.9077,243.9077,0,0,1,496.85531,314.44538ZM368.06719,416.00007a16.00152,16.00152,0,0,1-16.003-16v-53.541a909.15658,909.15658,0,0,1-96.01822,5.541A882.06521,882.06521,0,0,1,52.8511,328.66023c29.93928,83.4082,109.595,143.33984,203.19483,143.33984a215.14345,215.14345,0,0,0,145.09785-56Zm104.01975-160H392.07175a8.00115,8.00115,0,0,1-8.00152-8v-16a7.99991,7.99991,0,0,1,8.00152-8h24.00456v-32H360.06567a8.00116,8.00116,0,0,1-8.00152-8v-56H328.0596a8.00115,8.00115,0,0,1-8.00152-8v-16a7.99991,7.99991,0,0,1,8.00152-8h56.01063V82.15046a216.05674,216.05674,0,0,0-128.0243-42.15039c-119.12613,0-216.041,96.89648-216.041,216A215.721,215.721,0,0,0,43.45674,293.295c65.4343,17.24024,137.39132,26.70508,212.58919,26.70508a826.14433,826.14433,0,0,0,212.7103-27.52148A209.22142,209.22142,0,0,0,472.08694,256.00007Zm-184.03494-88a88.01671,88.01671,0,1,1-88.01671-88A88.009,88.009,0,0,1,288.052,168.00007Zm-32.00607,0a56.01064,56.01064,0,1,0-56.01064,56A56.06823,56.06823,0,0,0,256.04593,168.00007Z"]
  },
      Vx = {
    prefix: "fal",
    iconName: "spade",
    icon: [512, 512, [], "f2f4", "M471.4 200.3C456.1 186.4 327 57.7 278.6 9.3c-12.5-12.5-32.7-12.5-45.2 0-48.4 48.4-177.5 177-192.8 191C15.1 223.5 0 256.4 0 292c0 68.4 55.6 124 124 124 35.5 0 52-8 76-32 0 24-9.7 27.6-30.2 53.4-23.9 30.1-2.4 74.6 36 74.6h100.3c38.5 0 60-44.5 36-74.6-19-24.1-30.1-29.4-30.1-53.4 24 24 48.9 32 76 32 68.4 0 124-55.6 124-124 0-35.7-15.2-68.5-40.6-91.7zM385.5 384c-41-.4-54.6-11.3-87.2-45.2-3.7-3.9-10.3-1.2-10.3 4.2v25c0 40.6 0 52.6 29.1 89.3 7.3 9.2.7 22.7-11 22.7H205.8c-11.7 0-18.3-13.5-11-22.7C224 420.6 224 408.6 224 368v-25c0-5.4-6.6-8.1-10.3-4.2-32.3 33.7-45.9 44.7-87.1 45.2-51.8.5-95-41-94.5-92.8.2-26 11.4-50.1 30.1-67.2C81.3 206.5 256 32 256 32s174.7 174.5 193.9 192c19 17.3 29.9 41.6 30.1 67.3.4 51.8-42.7 93.2-94.5 92.7z"]
  },
      xx = {
    prefix: "fal",
    iconName: "sparkles",
    icon: [512, 512, [], "f890", "M328.84 109.75l48.57 24.32 24.28 48.63a16 16 0 0 0 28.62 0l24.28-48.63 48.57-24.32a16 16 0 0 0 0-28.66l-48.57-24.32-24.28-48.63c-5.43-10.85-23.19-10.85-28.62 0l-24.28 48.63-48.57 24.32a16 16 0 0 0 0 28.66zM396.5 83a16.1 16.1 0 0 0 7.16-7.16L416 51.14l12.34 24.74A16.1 16.1 0 0 0 435.5 83l24.72 12.38-24.72 12.42a16.2 16.2 0 0 0-7.16 7.16L416 139.7 403.66 115a16.2 16.2 0 0 0-7.16-7.16l-24.72-12.42zm106.66 318.53l-48.57-24.31-24.28-48.63c-5.43-10.86-23.19-10.86-28.62 0l-24.28 48.63-48.57 24.31a16 16 0 0 0 0 28.67l48.57 24.31 24.28 48.63a16 16 0 0 0 28.62 0l24.28-48.63 48.57-24.31a16 16 0 0 0 0-28.67zm-67.66 26.71a16.17 16.17 0 0 0-7.16 7.17L416 460.15l-12.34-24.74a16.17 16.17 0 0 0-7.16-7.17l-24.72-12.37 24.72-12.38a16.17 16.17 0 0 0 7.16-7.17L416 371.59l12.34 24.73a16.17 16.17 0 0 0 7.16 7.17l24.72 12.38zM384 255.64a16.06 16.06 0 0 0-8.84-14.33L262.59 185 206.31 72.23c-5.43-10.86-23.19-10.86-28.62 0L121.41 185 8.84 241.31a16 16 0 0 0 0 28.67l112.57 56.36 56.28 112.71a16 16 0 0 0 28.62 0l56.28-112.71L375.16 270a16.09 16.09 0 0 0 8.84-14.36zm-140.5 44.43a16.1 16.1 0 0 0-7.16 7.16L192 396.06l-44.34-88.83a16.1 16.1 0 0 0-7.16-7.16l-88.72-44.43 88.72-44.42a16.2 16.2 0 0 0 7.16-7.16L192 115.23l44.34 88.83a16.2 16.2 0 0 0 7.16 7.16l88.72 44.42z"]
  },
      wx = {
    prefix: "fal",
    iconName: "speaker",
    icon: [384, 512, [], "f8df", "M192 192a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm0-96a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm0 128a112 112 0 1 0 112 112 112 112 0 0 0-112-112zm0 192a80 80 0 1 1 80-80 80.09 80.09 0 0 1-80 80zm0-112a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM336 0H48A48 48 0 0 0 0 48v416a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm16 464a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h288a16 16 0 0 1 16 16z"]
  },
      yx = {
    prefix: "fal",
    iconName: "speakers",
    icon: [640, 512, [], "f8e0", "M592 0H304a48 48 0 0 0-48 48v416a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm16 464a16 16 0 0 1-16 16H304a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h288a16 16 0 0 1 16 16zM448 224a112 112 0 1 0 112 112 112 112 0 0 0-112-112zm0 192a80 80 0 1 1 80-80 80.09 80.09 0 0 1-80 80zm0-112a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm0-112a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm0-96a32 32 0 1 1-32 32 32 32 0 0 1 32-32zM224 229.2c-10.2-3.06-20.8-5.2-32-5.2a112 112 0 0 0 0 224c11.2 0 21.8-2.14 32-5.2v-33.58a80 80 0 1 1 0-146.44zM160 336a32 32 0 1 0 32-32 32 32 0 0 0-32 32zM240.41 0H48A48 48 0 0 0 0 48v416a48 48 0 0 0 48 48h192.41a79.15 79.15 0 0 1-14.79-32H48a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h177.62a79.15 79.15 0 0 1 14.79-32zM224 128a32 32 0 1 1-32-32 32 32 0 0 1 32 32V72.88A63.33 63.33 0 0 0 192 64a64 64 0 0 0 0 128 63.33 63.33 0 0 0 32-8.88z"]
  },
      bx = {
    prefix: "fal",
    iconName: "spell-check",
    icon: [576, 512, [], "f891", "M272 256h88a72 72 0 0 0 30.63-137.16A72 72 0 0 0 336 0h-64a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm16-224h48a40 40 0 0 1 0 80h-48zm0 112h72a40 40 0 0 1 0 80h-72zm-63.93 101.34l-89-234.67A16 16 0 0 0 120 0h-16a16 16 0 0 0-15.09 10.67l-89 234.67A8 8 0 0 0 7.47 256h17a8 8 0 0 0 7.53-5.34L60.54 176h102.92L192 250.66a8 8 0 0 0 7.55 5.34h17a8 8 0 0 0 7.52-10.66zM72.78 144L112 41.41 151.22 144zm499.5 135L561 267.72a12 12 0 0 0-17 0L354.8 460.41l-99-99a12 12 0 0 0-17 0l-11.31 11.31a12 12 0 0 0 0 17L346.3 508.48a12 12 0 0 0 17 0L572.28 296a12 12 0 0 0 0-17z"]
  },
      Sx = {
    prefix: "fal",
    iconName: "spider",
    icon: [576, 512, [], "f717", "M574.7 352.5l-54.8-82.2c-5.9-8.9-15.9-14.2-26.6-14.2H379.5l90.1-30c6.8-2.3 12.6-6.7 16.5-12.6l56.5-84.8c2.5-3.7 1.5-8.6-2.2-11.1l-13.3-8.9c-3.7-2.5-8.6-1.5-11.1 2.2l-55 82.5c-1 1.5-2.4 2.6-4.1 3.1l-83.1 27.7L426.9 118c5.8-11.4 6.7-24.5 2.6-36.7L404.2 5.5c-1.4-4.2-5.9-6.5-10.1-5.1l-15.2 5.1c-4.2 1.4-6.5 5.9-5.1 10.1l25.3 75.8c1.4 4 1.1 8.4-.9 12.2l-36.5 73.1-4.1-20.5c-2.2-11-17.4-60.1-69.6-60.1s-67.4 49.2-69.6 60.1l-4.1 20.5-36.5-73.1c-1.9-3.8-2.3-8.2-.9-12.2l25.3-75.8c1.4-4.2-.9-8.7-5.1-10.1L181.9.4c-4.2-1.4-8.7.9-10.1 5.1l-25.3 75.8c-4.1 12.2-3.1 25.2 2.6 36.7l53.1 106.2-83.1-27.7c-1.7-.6-3.1-1.7-4.1-3.1l-55-82.5c-2.4-3.7-7.4-4.7-11.1-2.2l-13.3 8.9c-3.7 2.4-4.7 7.4-2.2 11.1l56.5 84.8c3.9 5.9 9.8 10.4 16.5 12.6l90.1 30H82.8c-10.7 0-20.7 5.3-26.6 14.2L1.3 352.5c-2.5 3.7-1.5 8.6 2.2 11.1l13.3 8.9c3.7 2.5 8.6 1.5 11.1-2.2l52.4-78.7c1.5-2.2 4-3.6 6.7-3.6h102.1l-69.8 111.7c-4.8 7.6-7.3 16.4-7.3 25.5V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-81.1c0-1.5.4-3 1.2-4.2l46.9-75.1c0 1-.2 2-.2 3 0 53.1 40.8 101.4 96 101.4s96-48.4 96-101.4c0-1-.1-2-.1-3l46.9 75.1c.8 1.3 1.2 2.7 1.2 4.2V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-78.8c0-9-2.5-17.8-7.3-25.5L386.9 288H489c2.7 0 5.2 1.3 6.7 3.6l52.4 78.7c2.4 3.7 7.4 4.7 11.1 2.2l13.3-8.9c3.6-2.5 4.6-7.5 2.2-11.1zM288 416c-39.5 0-64-36-64-69.4 0-36.8 3.7-73.7 10.9-109.7l14.9-74.4c.7-3.5 7.8-34.4 38.2-34.4s37.5 30.9 38.2 34.4l14.9 74.4c7.2 36.1 10.9 72.9 10.9 109.7 0 33.4-24.5 69.4-64 69.4z"]
  },
      Tx = {
    prefix: "fal",
    iconName: "spider-black-widow",
    icon: [576, 512, [], "f718", "M320 272h-64c-6.6 0-10.4 7.5-6.4 12.8L276 320l-26.4 35.2c-4 5.3-.2 12.8 6.4 12.8h64c6.6 0 10.4-7.5 6.4-12.8L300 320l26.4-35.2c4-5.3.2-12.8-6.4-12.8zm254.7 80.5l-54.8-82.2c-5.9-8.9-15.9-14.2-26.6-14.2H379.5l90.1-30c6.8-2.3 12.6-6.7 16.5-12.6l56.5-84.8c2.5-3.7 1.5-8.6-2.2-11.1l-13.3-8.9c-3.7-2.5-8.6-1.5-11.1 2.2l-55 82.5c-1 1.5-2.4 2.6-4.1 3.1l-83.1 27.7L426.9 118c5.8-11.4 6.7-24.5 2.6-36.7L404.2 5.5c-1.4-4.2-5.9-6.5-10.1-5.1l-15.2 5.1c-4.2 1.4-6.5 5.9-5.1 10.1l25.3 75.8c1.4 4 1.1 8.4-.9 12.2l-36.5 73.1-4.1-20.5c-2.2-11-17.4-60.1-69.6-60.1s-67.4 49.2-69.6 60.1l-4.1 20.5-36.5-73.1c-1.9-3.8-2.3-8.2-.9-12.2l25.3-75.8c1.4-4.2-.9-8.7-5.1-10.1L181.9.4c-4.2-1.4-8.7.9-10.1 5.1l-25.3 75.8c-4.1 12.2-3.1 25.2 2.6 36.7l53.1 106.2-83.1-27.7c-1.7-.6-3.1-1.7-4.1-3.1l-55-82.5c-2.4-3.7-7.4-4.7-11.1-2.2l-13.3 8.9c-3.7 2.4-4.7 7.4-2.2 11.1l56.5 84.8c3.9 5.9 9.8 10.4 16.5 12.6l90.1 30H82.8c-10.7 0-20.7 5.3-26.6 14.2L1.3 352.5c-2.5 3.7-1.5 8.6 2.2 11.1l13.3 8.9c3.7 2.5 8.6 1.5 11.1-2.2l52.4-78.7c1.5-2.2 4-3.6 6.7-3.6h102.1l-69.8 111.7c-4.8 7.6-7.3 16.4-7.3 25.5V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-81.1c0-1.5.4-3 1.2-4.2l46.9-75.1c0 1-.2 2-.2 3 0 53.1 40.8 101.4 96 101.4s96-48.4 96-101.4c0-1-.1-2-.1-3l46.9 75.1c.8 1.3 1.2 2.7 1.2 4.2V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-78.8c0-9-2.5-17.8-7.3-25.5L386.9 288H489c2.7 0 5.2 1.3 6.7 3.6l52.4 78.7c2.4 3.7 7.4 4.7 11.1 2.2l13.3-8.9c3.6-2.5 4.6-7.5 2.2-11.1zM288 416c-39.5 0-64-36-64-69.4 0-36.8 3.7-73.7 10.9-109.7l14.9-74.4c.7-3.5 7.8-34.4 38.2-34.4s37.5 30.9 38.2 34.4l14.9 74.4c7.2 36.1 10.9 72.9 10.9 109.7 0 33.4-24.5 69.4-64 69.4z"]
  },
      Dx = {
    prefix: "fal",
    iconName: "spider-web",
    icon: [576, 512, [], "f719", "M571.62 245.02C509.87 179.63 464.12 98.93 439.4 11.65c-2.37-8.33-10.84-13.3-19.31-11.16-86.44 21.78-177.75 21.78-264.18 0-8.5-2.11-16.94 2.83-19.31 11.16C111.88 98.93 66.13 179.63 4.38 245.02c-5.84 6.16-5.84 15.81 0 21.97 61.75 65.39 107.5 146.09 132.22 233.37 2.37 8.31 10.81 13.23 19.31 11.16 86.44-21.78 177.75-21.78 264.18 0 1.31.33 2.62.48 3.91.48 7 0 13.41-4.61 15.41-11.64 24.72-87.28 70.47-167.98 132.22-233.37 5.83-6.16 5.83-15.81-.01-21.97zm-46.23-5.01h-69.84c-31.47-35.4-55.14-77.87-69.23-123.78l34.42-60.24c23.74 67.2 59.24 129.67 104.65 184.02zm-264.97 0h-98.7a366.476 366.476 0 0 0 48.97-87.02l49.73 87.02zm-23.85-106.28c34.09 5.26 68.77 5.26 102.86 0l-51.43 90-51.43-90zm23.85 138.28l-49.73 87.02a366.476 366.476 0 0 0-48.97-87.02h98.7zM288 288.28l51.43 90.01c-17.04-2.63-34.2-4.38-51.43-4.38s-34.39 1.75-51.43 4.38L288 288.28zm27.58-16.27h98.69a366.824 366.824 0 0 0-48.97 87.02l-49.72-87.02zm0-32l49.73-87.02c12.33 31.22 28.83 60.51 48.97 87.02h-98.7zm78.43-201.79L360.3 97.21c-47.38 11.59-97.21 11.59-144.59 0L182 38.22a573.332 573.332 0 0 0 212.01 0zM155.26 55.99l34.42 60.24c-14.1 45.92-37.77 88.38-69.23 123.78H50.61c45.41-54.35 80.91-116.82 104.65-184.02zM50.61 272.01h69.84c31.47 35.4 55.14 77.87 69.23 123.78l-34.42 60.24c-23.74-67.2-59.24-129.68-104.65-184.02zM182 473.79l33.71-58.99c47.38-11.59 97.21-11.59 144.59 0l33.7 58.99c-35-6.59-70.44-10.61-106-10.61s-71.01 4.02-106 10.61zm238.74-17.77l-34.42-60.24c14.1-45.92 37.77-88.38 69.23-123.78h69.84c-45.41 54.35-80.91 116.83-104.65 184.02z"]
  },
      jx = {
    prefix: "fal",
    iconName: "spinner",
    icon: [512, 512, [], "f110", "M288 32c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-32 416c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm256-192c0-17.673-14.327-32-32-32s-32 14.327-32 32 14.327 32 32 32 32-14.327 32-32zm-448 0c0-17.673-14.327-32-32-32S0 238.327 0 256s14.327 32 32 32 32-14.327 32-32zm33.608 126.392c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm316.784 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM97.608 65.608c-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32s32-14.327 32-32c0-17.673-14.327-32-32-32z"]
  },
      Ex = {
    prefix: "fal",
    iconName: "spinner-third",
    icon: [512, 512, [], "f3f4", "M460.115 373.846l-6.941-4.008c-5.546-3.202-7.564-10.177-4.661-15.886 32.971-64.838 31.167-142.731-5.415-205.954-36.504-63.356-103.118-103.876-175.8-107.701C260.952 39.963 256 34.676 256 28.321v-8.012c0-6.904 5.808-12.337 12.703-11.982 83.552 4.306 160.157 50.861 202.106 123.67 42.069 72.703 44.083 162.322 6.034 236.838-3.14 6.149-10.75 8.462-16.728 5.011z"]
  },
      kx = {
    prefix: "fal",
    iconName: "splotch",
    icon: [512, 512, [], "f5bc", "M463.94 185.08l-62.91-21.31c-12.97-4.41-22.5-13.58-25.41-24.53l-15-56.14c-6.25-23.38-25.5-41.41-51.53-48.23-28.84-7.58-58.94.17-78.47 20.17l-43.25 44.28c-9.16 9.38-23.56 14.38-38.13 13.16l-67.44-5.22c-31.41-2.41-60.44 12.14-74.16 37.05-11.69 21.17-9.91 45.61 4.75 65.36l36.13 48.69c6.81 9.16 7.88 20.06 2.91 29.91l-26.66 52.92c-10.69 21.22-8.25 45.27 6.5 64.33 17.88 23.06 49.22 33.63 80.06 27.03l65.59-14.17c14.38-3.09 29.56-.11 40.56 8.08l50.94 37.92c13.88 10.33 31.03 15.64 48.41 15.64 11.81 0 23.72-2.45 34.72-7.47 23.44-10.67 38.5-30.98 40.31-54.34l4.41-57.45c.81-10.89 8.28-20.92 20-26.86l58.09-29.48c24.94-12.61 39.28-36.22 37.47-61.58-1.83-26.25-20.2-48.36-47.89-57.76zm-4.03 90.78l-58.09 29.48c-21.78 11.02-35.78 30.83-37.47 52.97l-4.41 57.44c-1.25 16.66-15.53 24.89-21.63 27.66-16.78 7.61-36.69 5.77-50.75-4.7l-50.94-37.92c-13.66-10.17-30.94-15.61-48.53-15.61-6 0-12 .62-17.91 1.91l-65.59 14.17c-22.94 4.98-40.16-5.19-48-15.34-4.19-5.41-10.19-16.55-3.25-30.34L80 302.67c10.47-20.75 8.31-44.45-5.78-63.41l-36.13-48.67c-9.72-13.08-5.69-24.92-2.44-30.83 7.72-13.97 25.25-21.88 43.69-20.61l67.41 5.22c24.34 1.84 47.78-6.61 63.5-22.7L253.5 77.4c11.38-11.64 30.06-16.19 47.47-11.59 14.75 3.86 25.5 13.41 28.72 25.53l15 56.14c5.72 21.33 22.94 38.73 46.09 46.59l62.84 21.31c15.53 5.27 25.38 16.36 26.31 29.69.89 12.48-6.58 23.98-20.02 30.79z"]
  },
      Ix = {
    prefix: "fal",
    iconName: "spray-can",
    icon: [512, 512, [], "f5bd", "M224 128V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96c-53.02 0-96 42.98-96 96v256c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V224c0-53.02-42.98-96-96-96zm-96-96h64v96h-64V32zm160 448H32V224c0-35.29 28.71-64 64-64h128c35.29 0 64 28.71 64 64v256zM160 240c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80-35.82-80-80-80zm0 128c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zM488 80c13.25 0 24-10.75 24-24 0-13.26-10.75-24-24-24s-24 10.74-24 24c0 13.25 10.75 24 24 24zm0 48c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm-96-96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm0 96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm-96-96c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm192 192c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      Ox = {
    prefix: "fal",
    iconName: "sprinkler",
    icon: [512, 512, [], "e035", "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm0,224a16,16,0,1,0,16,16A16,16,0,0,0,16,224Zm0-112a16,16,0,1,0,16,16A16,16,0,0,0,16,112Zm128,32a16,16,0,1,0-16-16A16,16,0,0,0,144,144ZM496,32a16,16,0,1,0-16-16A16,16,0,0,0,496,32ZM368,144a16,16,0,1,0-16-16A16,16,0,0,0,368,144Zm64,16a16,16,0,1,0,16,16A16,16,0,0,0,432,160Zm0-96a16,16,0,1,0,16,16A16,16,0,0,0,432,64Zm64,160a16,16,0,1,0,16,16A16,16,0,0,0,496,224ZM80,160a16,16,0,1,0,16,16A16,16,0,0,0,80,160Zm416-48a16,16,0,1,0,16,16A16,16,0,0,0,496,112ZM398.19,256H272V72a8,8,0,0,0-8-8H248a8,8,0,0,0-8,8V256H113.81a17.77,17.77,0,0,0-14.22,28.44L192,387.56V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V374.3L144.93,288H367.07L288,374.3V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V387.56l92.41-103.12A17.77,17.77,0,0,0,398.19,256ZM80,64A16,16,0,1,0,96,80,16,16,0,0,0,80,64Z"]
  },
      Qx = {
    prefix: "fal",
    iconName: "square",
    icon: [448, 512, [], "f0c8", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352z"]
  },
      Zx = {
    prefix: "fal",
    iconName: "square-full",
    icon: [512, 512, [], "f45c", "M480 32v448H32V32h448m32-32H0v512h512V0z"]
  },
      Ux = {
    prefix: "fal",
    iconName: "square-root",
    icon: [512, 512, [], "f697", "M160.13 477.29c-9.51-3.62-16.88-11.43-21.15-20.66L58.06 281.3c-2.62-5.67-8.29-9.3-14.53-9.3H8c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h35.53c18.62 0 35.75 10.94 43.59 27.88l81.31 176.2c2.31 5.16 11.12 4.39 12.66-1.09l101.1-375.46C287.78 46.61 306.84 32 328.53 32H504c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H328.53c-7.22 0-13.59 4.86-15.44 11.83L211.97 451.31c-5.8 21.47-29.03 34.68-51.84 25.98z"]
  },
      Bx = {
    prefix: "fal",
    iconName: "square-root-alt",
    icon: [512, 512, [], "f698", "M509.16 248.97L454.12 304l55.03 55.03c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-55.03-55.03-55.03 55.03c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31L408.88 304l-55.03-55.03c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l55.03 55.03 55.03-55.03c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.13 3.12 3.13 8.18.01 11.31zM211.97 451.31L313.09 75.83c1.84-6.97 8.22-11.83 15.44-11.83H504c4.42 0 8-3.58 8-8V40c0-4.42-3.58-8-8-8H328.53c-21.69 0-40.75 14.61-46.34 35.53l-101.1 375.45c-1.53 5.48-10.34 6.25-12.66 1.09l-81.31-176.2C79.28 250.94 62.16 240 43.53 240H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h35.53c6.24 0 11.92 3.63 14.53 9.3l80.92 175.33c4.26 9.24 11.64 17.04 21.15 20.66 22.81 8.7 46.04-4.51 51.84-25.98z"]
  },
      Rx = {
    prefix: "fal",
    iconName: "squirrel",
    icon: [512, 512, [], "f71a", "M400 160c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm63.74 258.19C473.95 401.69 480 384.36 480 368c0-34.12-28.88-70.66-76.78-78.47l9.91-49.53h50.72c28.81 0 48.16-22.05 48.16-54.86 0-59.81-42.62-111.17-96.16-119.84V32h-16c-50.13 0-84.09 41.08-105.37 80.06C270.98 51.21 207.09 0 144 0 64.59 0 0 64.59 0 144c0 71.06 51.75 130.27 119.53 141.92l-13.72 28.41c-6.5 17.19-9.81 34.58-9.81 51.69C96 446.52 161.47 512 241.97 512H480c17.68 0 32-14.33 32-32 0-29.83-20.6-54.74-48.26-61.81zM241.97 480C179.12 480 128 428.86 128 366.02c0-13.22 2.59-26.8 7.19-39.05L169.5 256h-21.58C91 256 40.21 215.21 32.95 158.76 24.17 90.46 77.4 32 144 32c62.22 0 128 65.8 128 128l-59.7 146.46c-1.7 4.08.23 8.76 4.31 10.46l14.79 6.16c4.08 1.7 8.76-.23 10.46-4.31l76.46-183.61c11.44-22.88 33.97-59.09 65.53-68.73V96h16c42.69 0 80.16 41.66 80.16 89.14 0 8.53-2.09 22.86-16.16 22.86h-76.97l-22.41 112H384c39.53 0 64 24.92 64 48 0 14.86-8.43 32.39-22.26 48H392c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56c17.66 0 32 14.36 32 32H241.97z"]
  },
      Yx = {
    prefix: "fal",
    iconName: "staff",
    icon: [512, 512, [], "f71b", "M432 0h-76.23c-30.3 0-58 17.12-71.55 44.22l-16 32c-3.95 7.9-.75 17.51 7.15 21.46l57.25 28.63c2.3 1.15 4.74 1.69 7.14 1.69 5.87 0 11.52-3.24 14.32-8.85L365.67 96H416v75.8l-157.29 44.94a176.122 176.122 0 0 0-76.11 44.78L156.12 288H112c-8.84 0-16 7.16-16 16v44.12L7.03 437.1c-9.37 9.37-9.37 24.57 0 33.94l33.93 33.93c4.69 4.69 10.83 7.03 16.97 7.03s12.28-2.34 16.97-7.03l175.55-175.55a80.111 80.111 0 0 1 34.62-20.37l84.82-24.24 32.25 18.62c2.52 1.46 5.27 2.15 7.98 2.15 5.53 0 10.91-2.87 13.87-8l19.51-33.8 10.46-2.99c34.34-9.81 58.02-41.21 58.02-76.92V80C512 35.82 476.18 0 432 0zm48 183.86c0 21.32-14.32 40.3-34.81 46.15L434.73 233l-12.45 3.56-6.47 11.21-11.51 19.94-18.4-10.61-11.75-6.78-13.04 3.73-84.82 24.24a112.273 112.273 0 0 0-48.46 28.52L57.93 476.69l-22.62-22.62 83.31-83.32 9.37-9.37V320h41.38l9.37-9.37 26.48-26.48a144.372 144.372 0 0 1 62.27-36.64l157.29-44.94 23.21-6.63V64H345.88l-8.84 17.69-4.42 8.85L304 76.22l8.84-17.69C321.02 42.17 337.47 32 355.77 32H432c26.47 0 48 21.53 48 48v103.86z"]
  },
      Px = {
    prefix: "fal",
    iconName: "stamp",
    icon: [512, 512, [], "f5bf", "M416 256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.42 21.46-77.73 9.11-17.61 12.9-38.38 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C267.41.49 261.65 0 256 0c-53.02 0-96 42.98-96 96 0 14.16 3.12 27.54 8.68 39.57C182.02 164.43 192 194.71 192 226.5v.06c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32v64c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-64c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96zm32 224H64v-64h384v64zm32-96H32v-32c0-35.29 28.71-64 64-64h66.56c33.88 0 61.44-27.56 61.44-61.5 0-32.42-8.35-65.58-26.27-104.35-3.8-8.23-5.73-17.03-5.73-26.15 0-35.29 28.71-64 64-64 3.88 0 7.83.35 11.76 1.03 25.24 4.39 46.79 26.02 51.22 51.42 2.45 14.04.39 27.95-5.95 40.21C296.19 157.23 288 187.47 288 217.1v9.46c0 33.88 27.56 61.44 61.44 61.44H416c35.29 0 64 28.71 64 64v32z"]
  },
      Fx = {
    prefix: "fal",
    iconName: "star",
    icon: [576, 512, [], "f005", "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM405.8 317.9l27.8 162L288 403.5 142.5 480l27.8-162L52.5 203.1l162.7-23.6L288 32l72.8 147.5 162.7 23.6-117.7 114.8z"]
  },
      Wx = {
    prefix: "fal",
    iconName: "star-and-crescent",
    icon: [512, 512, [], "f699", "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zM32 256c0-116.55 89.46-212.59 203.33-223.05C149.02 70.22 88.47 156.17 88.47 256c0 99.83 60.55 185.78 146.87 223.05C121.47 468.59 32 372.55 32 256zm471.46-42.14l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99zm-72.08 47.94l-12.05 11.74 2.84 16.58 5.5 32.05-28.78-15.13-14.89-7.83-14.89 7.83-28.78 15.13 5.5-32.05 2.84-16.58-12.05-11.74-23.28-22.7 32.18-4.68 16.65-2.42 7.45-15.09L384 187.76l14.39 29.16 7.45 15.09 16.65 2.42 32.18 4.68-23.29 22.69z"]
  },
      Gx = {
    prefix: "fal",
    iconName: "star-christmas",
    icon: [512, 512, [], "f7d4", "M493.7 232.4l-140.2-35 66.9-83.3c5.2-6.5 4.7-15.5-1.1-21.3-5.9-5.8-14.8-6.3-21.3-1.1l-83.4 66.7-35-140c-6.1-24.4-41-24.4-47.2 0l-35 140.2-83.3-67c-6.5-5.2-15.5-4.8-21.3 1.1-5.8 5.8-6.3 14.8-1.1 21.4l66.7 83.4-140 35C7.5 235.2 0 244.7 0 256c0 10.2 6.5 20.7 18.4 23.6l140.2 35-66.9 83.3c-5.2 6.5-4.7 15.5 1.1 21.3 5.6 5.5 14.5 6.5 21.3 1.1l83.4-66.7 35 140c3 11.9 13.3 18.4 23.6 18.4 4.5 0 19.4-2.1 23.6-18.4l35-140.2 83.3 67c6.9 5.5 15.8 4.4 21.3-1.1 5.8-5.8 6.3-14.8 1.1-21.3l-66.7-83.4 139.9-35c11.7-2.9 18.5-13.1 18.5-23.6-.1-10.3-6.6-20.6-18.4-23.6zM296 296l-40 160-40-160-160-40 160-40 40-160 40 160 160 40-160 40z"]
  },
      qx = {
    prefix: "fal",
    iconName: "star-exclamation",
    icon: [576, 512, [], "f2f3", "M260.2 158.3c-.2-3.4 2.5-6.3 6-6.3h43.6c3.4 0 6.2 2.9 6 6.3l-7.3 132c-.2 3.2-2.8 5.7-6 5.7h-28.9c-3.2 0-5.8-2.5-6-5.7l-7.4-132zM288 320c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm257.9-94L440.1 329l25 145.5c4.5 26.2-23.1 46-46.4 33.7L288 439.6l-130.7 68.7c-23.4 12.3-50.9-7.6-46.4-33.7l25-145.5L30.1 226c-19-18.5-8.5-50.8 17.7-54.6L194 150.2l65.3-132.4c11.8-23.8 45.7-23.7 57.4 0L382 150.2l146.1 21.2c26.2 3.8 36.7 36.1 17.8 54.6zm-22.4-22.9l-162.7-23.7L288 32l-72.8 147.4-162.7 23.7 117.7 114.8-27.8 162L288 403.4l145.5 76.5-27.8-162 117.8-114.8z"]
  },
      Jx = {
    prefix: "fal",
    iconName: "star-half",
    icon: [576, 512, [], "f089", "M288 403.4l-145.5 76.5 27.8-162L52.5 203.1l162.7-23.6L288 32V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-36.2z"]
  },
      Kx = {
    prefix: "fal",
    iconName: "star-half-alt",
    icon: [536, 512, [], "f5c0", "M417.28 158.22l-55.12-8.03-24.64-49.84-28.74 14.16 32.1 64.94 71.78 10.44 4.62-31.67zm-12.87 267.09l9.44 54.62-49-25.7-14.9 28.31 49.02 25.72c4.7 2.45 9.68 3.7 14.79 3.7 9.35 0 18.6-4.33 24.71-11.56 4.87-5.72 7.44-12.72 7.44-20.22l-9.89-60.28-31.61 5.41zM275.3 407.58c-4.5-2.35-9.91-2.79-14.77-.25l-138.38 72.62 27.9-162.03L32.07 203.14l163.04-23.7L267.91 32c.03 0 .05-.02.08-.02V32l20.46 41.39 28.74-14.16-20.46-41.41C291.28 6.83 280.24 0 267.91 0c-12.45 0-23.15 6.66-28.68 17.81l-65.41 132.38L27.4 171.48c-12.1 1.78-22 10.12-25.82 21.81-3.79 11.67-.67 24.25 8.12 32.78l105.9 103-25.06 145.5c-1.6 9.45.88 18.64 6.97 25.84 6.12 7.25 15.34 11.58 24.67 11.58 5.1 0 10.08-1.25 14.86-3.75l130.95-68.7 49.32 25.87 14.9-28.31-56.77-29.78-.14.26zM534.37 193.3c-3.77-11.67-13.68-20.03-25.85-21.81l-54.95-8-4.63 31.66 54.95 8.02-39.67 38.59 22.39 22.91 39.61-38.53c6.31-6.08 9.79-14.17 9.79-22.8-.01-3.42-.57-6.82-1.64-10.04zM385.92 317.92l12.29 71.36 31.59-5.41-9.44-54.8 39.89-38.8-22.39-22.91-51.94 50.56z"]
  },
      Xx = {
    prefix: "fal",
    iconName: "star-of-david",
    icon: [464, 512, [], "f69a", "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm21.21-112c2.1 0 3.63.83 4.56 2.46 1.08 1.89.32 3.16-.04 3.78l-44.34 74.48L339.01 144h87.88zm-58.45 112l-66.67 112H162.23L95.56 256l66.67-112h139.54l66.67 112zM227.49 34.38c.94-1.58 2.46-2.38 4.51-2.38s3.57.8 4.51 2.38L282.72 112H181.28l46.21-77.62zM32.6 150.24c-.37-.61-1.12-1.88-.05-3.78.93-1.64 2.46-2.46 4.56-2.46h87.88l-48.05 80.72-44.34-74.48zM37.11 368c-2.1 0-3.63-.83-4.56-2.46-1.08-1.89-.32-3.17.04-3.78l44.34-74.48L124.99 368H37.11zm199.4 109.61c-.94 1.58-2.46 2.39-4.51 2.39s-3.57-.8-4.51-2.38L181.28 400h101.44l-46.21 77.61zm194.94-112.07c-.93 1.63-2.46 2.46-4.56 2.46h-87.88l48.05-80.72 44.34 74.48c.36.61 1.12 1.88.05 3.78z"]
  },
      _x = {
    prefix: "fal",
    iconName: "star-of-life",
    icon: [480, 512, [], "f621", "M271.74 32v168.58l47.6-27.71 97.18-56.57 31.74 55.43-97.18 56.57-47.61 27.7 47.6 27.71 97.18 56.57-31.74 55.43-97.18-56.57-47.6-27.71V480h-63.47V311.42l-47.6 27.71-97.18 56.57-31.74-55.43 97.18-56.57 47.6-27.71-47.6-27.71-97.18-56.57 31.74-55.43 97.18 56.57 47.6 27.71V32h63.48m0-32h-63.47c-17.53 0-31.74 14.33-31.74 32v113.15L79.35 88.57c-5-2.91-10.46-4.29-15.84-4.29-10.97 0-21.63 5.74-27.51 16.01L4.26 155.71c-8.76 15.3-3.56 34.88 11.62 43.71L113.06 256l-97.18 56.57C.7 321.41-4.5 340.98 4.26 356.28L36 411.71a31.68 31.68 0 0 0 27.52 16.01c5.38 0 10.84-1.38 15.84-4.29l97.18-56.57V480c0 17.67 14.21 32 31.74 32h63.47c17.53 0 31.74-14.33 31.74-32V366.85l97.18 56.57c5 2.91 10.45 4.29 15.84 4.29a31.68 31.68 0 0 0 27.52-16.01l31.74-55.43c8.76-15.31 3.56-34.88-11.62-43.71L366.94 256l97.18-56.57c15.18-8.84 20.38-28.41 11.62-43.71L444 100.29a31.677 31.677 0 0 0-27.51-16.01c-5.38 0-10.84 1.38-15.84 4.29l-97.18 56.57V32c0-17.67-14.21-32-31.73-32z"]
  },
      $x = {
    prefix: "fal",
    iconName: "star-shooting",
    icon: [512, 512, [], "e036", "M364.294,267.28691,259.4951,251.99064l-46.90716-95.19941a22.9468,22.9468,0,0,0-41.18829,0l-46.90716,95.19941L19.69358,267.28691C.89634,269.98993-6.71318,293.19215,6.99021,306.4885l75.90772,73.99711L64.89758,485.07527A23.05232,23.05232,0,0,0,87.525,512a22.46219,22.46219,0,0,0,10.67013-2.72255l93.7987-49.38869,93.79869,49.38869A22.89785,22.89785,0,0,0,319.09,485.07527L301.199,380.48561l75.89209-73.99711C390.70077,293.19215,383.09125,269.98993,364.294,267.28691ZM278.85876,357.5744l-12.03734,11.73587,2.836,16.56966,14.80107,86.53177-77.55424-40.83629-14.91044-7.85126-14.91045,7.85126L99.5506,472.4l14.885-86.48686,2.85357-16.58919-12.053-11.7515-62.843-61.26127,86.72238-12.65771,16.64681-2.42959,7.43569-15.09121L191.9938,187.3955l38.79567,78.73716,7.43569,15.09121,16.64876,2.42959,86.80442,12.66943ZM498.34544,194.33469a8.00345,8.00345,0,0,0-11.31467,0l-68.68884,68.68676a7.99644,7.99644,0,0,0,0,11.31206l11.31077,11.31206a8.00347,8.00347,0,0,0,11.31467,0L509.6562,216.9588a7.99643,7.99643,0,0,0,0-11.31206ZM314.34187,186.337l11.31077,11.31011a7.99994,7.99994,0,0,0,11.31467,0L509.6562,24.96631a7.99643,7.99643,0,0,0,0-11.31206L498.34544,2.34219a8.00347,8.00347,0,0,0-11.31467,0L314.34187,175.02294A7.9988,7.9988,0,0,0,314.34187,186.337ZM237.649,93.65308a8.00347,8.00347,0,0,0,11.31467,0l68.68883-68.68677a7.99644,7.99644,0,0,0,0-11.31206L306.34172,2.34219a8.00348,8.00348,0,0,0-11.31468,0L226.33821,71.029a7.99644,7.99644,0,0,0,0,11.31206Z"]
  },
      cw = {
    prefix: "fal",
    iconName: "starfighter",
    icon: [640, 512, [], "e037", "M288,256v48a16.00079,16.00079,0,0,0,16,16h32a16.00079,16.00079,0,0,0,16-16V256a32,32,0,0,0-64,0ZM624,128V112a16,16,0,0,0-32,0v16H576v32h16V352H512V320a47.99987,47.99987,0,0,0-48-48H432a47.46463,47.46463,0,0,0-22.45508,5.81836L369.9375,27.01562A31.842,31.842,0,0,0,338.3125,0h-36.625a31.84226,31.84226,0,0,0-31.625,27L230.61719,277.90625A47.46045,47.46045,0,0,0,208,272H176a47.99987,47.99987,0,0,0-48,48v32H48V160H64V128H48V112a16,16,0,0,0-32,0v16H0v32H16V432a16,16,0,0,0,32,0v-8.88867l92.72266,41.21094A47.66212,47.66212,0,0,0,168,479.19336V496a16.00079,16.00079,0,0,0,16,16h16a16.00079,16.00079,0,0,0,16-16V479.19336a47.278,47.278,0,0,0,18.47656-7.83789A31.68121,31.68121,0,0,0,256,480H384a31.686,31.686,0,0,0,21.52539-8.64453A47.26957,47.26957,0,0,0,424,479.19336V496a16.00079,16.00079,0,0,0,16,16h16a16.00079,16.00079,0,0,0,16-16V479.19336a47.66212,47.66212,0,0,0,27.27734-14.87109L592,423.11133V432a16,16,0,0,0,32,0V160h16V128ZM128,423.64844,64,395.20312V384h64ZM224,432a16.01833,16.01833,0,0,1-16,16H176a16.01833,16.01833,0,0,1-16-16V320a16.01833,16.01833,0,0,1,16-16h32a16.01833,16.01833,0,0,1,16,16Zm160,0v16H256l-.02344-15.86914c0-.04688.02344-.084.02344-.13086V321.3125L301.6875,32h36.625L384,320Zm96,0a16.01833,16.01833,0,0,1-16,16H432a16.01833,16.01833,0,0,1-16-16V320a16.01833,16.01833,0,0,1,16-16h32a16.01833,16.01833,0,0,1,16,16Zm96-36.79688-64,28.44532V384h64Z"]
  },
      ew = {
    prefix: "fal",
    iconName: "starfighter-alt",
    icon: [576, 512, [], "e038", "M568,32H552a8.00039,8.00039,0,0,0-8,8V191.01367l-84.65234-21.16211C427.70312,107.17773,362.87305,64,288,64S148.29688,107.17773,116.65234,169.85156L32,191.01367V40a8.00039,8.00039,0,0,0-8-8H8a8.00039,8.00039,0,0,0-8,8V472a8.00039,8.00039,0,0,0,8,8H24a8.00039,8.00039,0,0,0,8-8V320.98438l84.65234,21.16406C148.29688,404.82227,213.127,448,288,448s139.70312-43.17773,171.34766-105.85156L544,320.98438V472a8.00039,8.00039,0,0,0,8,8h16a8.00039,8.00039,0,0,0,8-8V40A8.00039,8.00039,0,0,0,568,32ZM102.75391,305.6875,32,288V224l70.75391-17.6875a186.14869,186.14869,0,0,0,0,99.375ZM288,416A160,160,0,1,1,448,256,160.00042,160.00042,0,0,1,288,416ZM544,288l-70.75391,17.6875a186.14869,186.14869,0,0,0,0-99.375L544,224ZM288,128A128,128,0,1,0,416,256,127.99883,127.99883,0,0,0,288,128Zm12,33.21094a94.89277,94.89277,0,0,1,46.57617,19.22851l-22.62695,22.627A63.59685,63.59685,0,0,0,300,193.21094Zm-24,0v32a63.59685,63.59685,0,0,0-23.94922,9.85547l-22.62695-22.627A94.89277,94.89277,0,0,1,276,161.21094Zm-63.56055,36.21289,22.627,22.62695A63.59685,63.59685,0,0,0,225.21094,244h-32A94.89277,94.89277,0,0,1,212.43945,197.42383ZM193.21094,268h32a63.59685,63.59685,0,0,0,9.85547,23.94922l-22.627,22.62695A94.89277,94.89277,0,0,1,193.21094,268ZM276,350.78906a94.89277,94.89277,0,0,1-46.57617-19.22851l22.62695-22.627A63.59685,63.59685,0,0,0,276,318.78906ZM256,256a32,32,0,1,1,32,32A31.99908,31.99908,0,0,1,256,256Zm44,94.78906v-32a63.59685,63.59685,0,0,0,23.94922-9.85547l22.62695,22.627A94.89277,94.89277,0,0,1,300,350.78906Zm63.56055-36.21289-22.627-22.62695A63.59685,63.59685,0,0,0,350.78906,268h32A94.89277,94.89277,0,0,1,363.56055,314.57617ZM350.78906,244a63.59685,63.59685,0,0,0-9.85547-23.94922l22.627-22.62695A94.89277,94.89277,0,0,1,382.78906,244Z"]
  },
      aw = {
    prefix: "fal",
    iconName: "stars",
    icon: [512, 512, [], "f762", "M509.05273,219.03853l-39.71289-16.56934-16.55859-39.73866a5.32506,5.32506,0,0,0-9.541,0l-16.56054,39.73866-39.71094,16.56934a5.33947,5.33947,0,0,0,0,9.54721L426.67969,245.157l16.56054,39.73671a5.3235,5.3235,0,0,0,9.541,0L469.33984,245.157l39.71289-16.57129a5.33947,5.33947,0,0,0,0-9.54721ZM364.30049,267.08,259.38106,251.77833,212.46892,156.549a22.735,22.735,0,0,0-20.59634-12.7878A22.40581,22.40581,0,0,0,171.37,156.549l-46.91214,95.22933L19.6322,267.08C.84859,269.76557-6.65235,293.06155,6.94311,306.349l75.91578,74.05684L64.85663,485.01914A23.00313,23.00313,0,0,0,87.45322,512a22.60025,22.60025,0,0,0,10.68884-2.6856l93.82428-49.37123,93.82429,49.37123A23.38328,23.38328,0,0,0,296.38571,512a23.09547,23.09547,0,0,0,22.69035-26.88718l-17.9085-104.61329,75.91578-74.05685C390.6788,293.06155,383.0841,269.87487,364.30049,267.08ZM266.78824,369.28873l17.596,103.14558-92.51162-48.7779L99.361,472.43431l17.596-103.14558L42.26,296.1531l103.388-15.08305,46.31831-93.83969,46.19331,93.83969L341.57888,296.1531ZM423.1875,81.33009,374.59375,57.01744,350.3125,8.17327c-5.40625-10.89769-23.21875-10.89769-28.625,0L297.40625,56.81419,248.8125,81.12683A16.04689,16.04689,0,0,0,240,95.433a16.46336,16.46336,0,0,0,8.8125,14.50941L297.40625,134.255,321.6875,182.896A16.07056,16.07056,0,0,0,336,191.79235a15.87374,15.87374,0,0,0,14.3125-8.8964L374.59375,134.255l48.59375-24.31264a16.0185,16.0185,0,0,0,0-28.6123ZM355.5,107.94109a16.19316,16.19316,0,0,0-7.1875,7.2078L336,139.86805l-12.3125-24.71916a16.75685,16.75685,0,0,0-7.1875-7.2078L291.8125,95.54243,316.5,83.12813a16.11584,16.11584,0,0,0,7.1875-7.2078L336,51.20117l12.3125,24.71916a16.59161,16.59161,0,0,0,7.1875,7.2078l24.6875,12.4143Z"]
  },
      nw = {
    prefix: "fal",
    iconName: "starship",
    icon: [640, 512, [], "e039", "M448,64c-83.91992,0-155.07812,53.92969-181.18945,128.95312L214.916,197.76367,158.959,160h47.44727a48,48,0,0,0,0-96H32A32.03165,32.03165,0,0,0,0,96v32a32.03165,32.03165,0,0,0,32,32h69.76953l62.86328,42.42383-22.22656,2.06055C115.9375,206.9375,96,229.07812,96,256s19.9375,49.0625,46.40625,51.51562l22.22656,2.06055L101.76953,352H32A32.03165,32.03165,0,0,0,0,384v32a32.03165,32.03165,0,0,0,32,32H206.40625a48,48,0,0,0,0-96H158.959l55.957-37.76367,51.89453,4.81055C292.92188,394.07031,364.08008,448,448,448c106.03906,0,192-85.96094,192-192S554.03906,64,448,64ZM32,128V96H206.40625a16,16,0,0,1,0,32ZM206.40625,384a16,16,0,0,1,0,32H32V384Zm52.18945-97.86133-113.252-10.498C135.46875,274.73438,128,266.28125,128,256s7.46875-18.73438,17.34375-19.64062l113.252-10.498A192.3155,192.3155,0,0,0,256,256,192.3155,192.3155,0,0,0,258.5957,286.13867ZM448,416A160,160,0,1,1,608,256,160.00042,160.00042,0,0,1,448,416Zm0-224a64,64,0,1,0,64,64A63.99942,63.99942,0,0,0,448,192Zm0,96a32,32,0,1,1,32-32A32.00033,32.00033,0,0,1,448,288Z"]
  },
      tw = {
    prefix: "fal",
    iconName: "starship-freighter",
    icon: [576, 512, [], "e03a", "M79.99855,240a16,16,0,1,0,16,16A15.99954,15.99954,0,0,0,79.99855,240Zm31.998-64a16,16,0,1,0-15.998-16A16.00079,16.00079,0,0,0,111.99656,176Zm0,160a16,16,0,1,0,16,16A15.99912,15.99912,0,0,0,111.99656,336ZM560,240a16.00078,16.00078,0,0,0,16-16V166.39844A31.99434,31.99434,0,0,0,554.95315,136.332L311.32644,47.5625A257.78772,257.78772,0,0,0,224.434,32c-29.15232,0-58.11713,5.41406-85.21476,17.15039C-4.09512,111.22266.01425,256,.01425,256S-4.34121,400.666,139.21919,462.84961C166.31291,474.584,195.28554,480,224.434,480c27.60544,0,55.3183-5.01367,81.79093-13.96094l16.33006,22.67969A55.93881,55.93881,0,0,0,367.99044,512h55.998a55.8466,55.8466,0,0,0,33.33981-100.76172L554.95315,375.668A32.00422,32.00422,0,0,0,576,345.59961V288a15.99954,15.99954,0,0,0-16-16H447.98841V256.23242c0-.07812.01172-.1543.01172-.23242,0-.05664-.01172-.10938-.01172-.166V240ZM224.434,448c-25.87107,0-50.26167-4.88281-72.496-14.51367C30.897,381.05664,31.90094,261.85742,32.00055,256.96289l.01953-.9375-.01562-.7793c-.09375-5.05468-.90625-124.39257,119.93347-176.73047,22.1699-9.60546,46.49019-14.47851,72.27336-14.50585.26367,0,.51367.03906.77735.041a214.74426,214.74426,0,0,1,30.32418,2.73438c90.91983,15.01172,160.56039,93.90039,160.67562,188.98242v.35742c-.02734,43.52344-15.293,83.15039-39.84761,115.35547L314.68,286.12109A94.74314,94.74314,0,0,0,319.99245,256a95.998,95.998,0,1,0-95.998,96c.03906,0,.07812-.01172.11718-.01172l62.05853,86.19531C265.60774,444.17578,244.92807,448,224.434,448Zm63.55853-192a63.998,63.998,0,1,1-63.998-64A64.00022,64.00022,0,0,1,287.99248,256Zm135.996,224h-55.998a23.97442,23.97442,0,0,1-19.46873-9.98438L258.69954,345.25977a95.83327,95.83327,0,0,0,38.78512-28.24415L380.27168,432h43.71675a24,24,0,0,1,0,48ZM544,304v41.60156L396.26581,399.42969l-.15821-.22071A223.08951,223.08951,0,0,0,442.70131,304ZM442.27162,208a222.53941,222.53941,0,0,0-46.68941-95.67969L544,166.39844V208Z"]
  },
      rw = {
    prefix: "fal",
    iconName: "steak",
    icon: [576, 512, [], "f824", "M466.81 118.83C435.3 82.94 401.42 64 368.85 64c-41.87 0-78.51 32.73-93.33 83.38l-.63 2.19c-17.44 60.74-69.45 110.34-154.6 147.41-57.29 24.9-56.54 60.8-53.57 75.07 10.7 51.39 91.56 74.8 162.16 74.8 97.65 0 188.59-39.8 249.5-109.2 48.92-55.73 43.62-155.94-11.57-218.82zm-12.48 197.71c-64.24 73.19-152.69 98.31-225.45 98.31-105.46 0-177.94-52.81-95.81-88.57 146.41-63.75 166.92-148.6 173.16-170C317 119.66 341.54 96 368.85 96c22.76 0 49 15.62 73.91 44 44.37 50.49 49.78 133 11.57 176.54zM384 191.92a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM514.92 76.65C467.92 23.11 416.28 0 368.85 0 298.27 0 237 51.17 214.1 129.39 165 269.32 1.37 212.32 0 351.63-1.13 467.49 126.32 512 239.31 512q8.41 0 16.69-.32c87.78-3.41 187.32-37.1 270.49-131.85C596.78 299.75 591.6 164 514.92 76.65zm-12.47 282.07C418.8 454 321.59 477.11 254.75 479.7q-7.65.3-15.44.3c-77 0-143.78-21.08-178.76-56.4C41.06 403.92 31.73 380.48 32 352c.48-49.57 23.49-61.67 75.5-84.31 48.37-21.11 108.57-47.32 136.79-127.69l.28-.8.24-.82C263.72 73.75 312.41 32 368.85 32c42.06 0 84.26 22.74 122 65.76 66.36 75.58 71.55 192.65 11.6 260.96z"]
  },
      iw = {
    prefix: "fal",
    iconName: "steering-wheel",
    icon: [496, 512, [], "f622", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 32c119.1 0 215.99 96.89 216 215.98H358.38C350.94 219.52 318.64 192 280 192h-64c-38.64 0-70.94 27.52-78.38 63.98H32C32.01 136.89 128.9 40 248 40zm-5.66 299.7l-67.5-67.48c-4.62-4.62-5.94-11.6-3.55-17.68 7-17.86 24.41-30.54 44.71-30.54h64c20.3 0 37.71 12.68 44.71 30.54 2.39 6.09 1.07 13.06-3.55 17.68l-67.5 67.48a7.997 7.997 0 0 1-11.32 0zm-207.7-51.72h110.72L232 374.61v96.58c-100.94-7.46-182.6-84.45-197.36-183.21zM264 471.19v-96.58l86.64-86.63h110.72C446.6 386.74 364.94 463.73 264 471.19z"]
  },
      ow = {
    prefix: "fal",
    iconName: "step-backward",
    icon: [448, 512, [], "f048", "M76 479h8c6.6 0 12-5.4 12-12V276.7c1.1 1.2 2.2 2.4 3.5 3.4l232 191.4c20.6 17.2 52.5 2.8 52.5-24.6V63c0-27.4-31.9-41.8-52.5-24.6L99.5 231c-1.3 1.1-2.4 2.2-3.5 3.4V43c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v424c0 6.6 5.4 12 12 12zm40.5-223.4L351.8 63.2l.1-.1.1-.1v384l-.1-.1-.2-.1-235.2-191.2z"]
  },
      lw = {
    prefix: "fal",
    iconName: "step-forward",
    icon: [448, 512, [], "f051", "M372 31h-8c-6.6 0-12 5.4-12 12v190.3c-1.1-1.2-2.2-2.4-3.5-3.4l-232-191.4C95.9 21.3 64 35.6 64 63v384c0 27.4 31.9 41.8 52.5 24.6l232-192.6c1.3-1.1 2.4-2.2 3.5-3.4V467c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V43c0-6.6-5.4-12-12-12zm-40.5 223.4L96.2 446.8l-.1.1-.1.1V63l.1.1.2.1 235.2 191.2z"]
  },
      fw = {
    prefix: "fal",
    iconName: "stethoscope",
    icon: [512, 512, [], "f0f1", "M430.1 96.5c-43.6 1-78.7 37.5-78.1 81.1.5 38.2 27.8 69.9 64 77.2v105.6c0 65.9-57.4 119.5-128 119.5s-128-53.6-128-119.5v-8.9c71.9-8 128-69.1 128-143.1V25.8c0-5.5-3.7-10.3-9.1-11.6L223.5.4c-6.4-1.6-12.9 2.3-14.6 8.7l-1.9 7.8c-1.6 6.4 2.3 12.9 8.7 14.6l40.3 10v165.8c0 61.8-49.5 112.9-111.3 113.2-62.1.4-112.7-50-112.7-112v-167l40.2-10.1c6.4-1.6 10.3-8.1 8.7-14.6L79 9.1C77.4 2.7 70.9-1.2 64.4.4L9.1 14.2C3.7 15.5 0 20.3 0 25.8v182.6c0 74 56.1 135.1 128 143.1v8.9C128 444 199.8 512 288 512s160-68 160-151.5V254.9c36.5-7.4 64-39.7 64-78.4 0-44.9-36.9-81.1-81.9-80zm1.9 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm23.5-48c0 13-10.5 23.5-23.5 23.5s-23.5-10.5-23.5-23.5S419 153 432 153s23.5 10.5 23.5 23.5z"]
  },
      sw = {
    prefix: "fal",
    iconName: "sticky-note",
    icon: [448, 512, [], "f249", "M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-120.569 95.196a15.89 15.89 0 0 1-7.431 4.195v-95.509h95.509a15.88 15.88 0 0 1-4.195 7.431l-83.883 83.883zM416 80v239.988H312c-13.255 0-24 10.745-24 24v104H48c-8.837 0-16-7.163-16-16V80c0-8.837 7.163-16 16-16h352c8.837 0 16 7.163 16 16z"]
  },
      uw = {
    prefix: "fal",
    iconName: "stocking",
    icon: [384, 512, [], "f7d5", "M352 0H96C78.3 0 64 14.3 64 32v64c0 17.7 14.3 32 32 32v123.5l-39 26C-1.8 316.7-17.7 396.2 21.5 455c24.7 37 65.2 57 106.6 57 24.4 0 49.1-7 70.9-21.5l81.7-54.5c44.6-29.7 71.2-79.5 71.2-133.1V128c17.7 0 32-14.3 32-32V32C384 14.3 369.7 0 352 0zm-32 302.9c0 42.9-21.3 82.7-57 106.5l-81.8 54.5C165.4 474.5 147 480 128.1 480c-32.2 0-62.2-16-80-42.8-14.2-21.3-19.3-46.9-14.3-72.1 5-25.1 19.5-46.8 40.9-61l39-26 14.2-9.5V128h192v174.9zM352 96H96V32h256v64z"]
  },
      hw = {
    prefix: "fal",
    iconName: "stomach",
    icon: [512, 512, [], "f623", "M401.07 98.27C342.35 87.67 289.25 115.23 261.1 160H240c-44.18 0-80-35.82-80-80V8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v72c0 61.86 50.14 112 112 112h6.7c-3.95 12.73-6.7 25.99-6.7 40v56c0 44.18-35.82 80-80 80h-48C50.14 368 0 418.14 0 480v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24c0-32.35 19.31-60.29 47.01-72.88 11.13-5.06 24.36-2.05 33.4 6.19l62.31 56.78C208 497.11 249.94 512 292.78 512 413.66 512 512 413.66 512 292.78v-55.83c0-66.45-45.53-126.88-110.93-138.68zM376 128c57.34 0 104 46.66 104 104v60.78c0 12.07-1.25 23.85-3.45 35.29-31.33 15.03-68.19 7.84-92.77-18.9-29.66-32.24-72.22-43.89-111.78-32.91V232c0-57.34 46.66-104 104-104zm-83.22 352c-35.53 0-70.28-12.34-97.19-34.16L145.31 400H160c53.87 0 98.94-38.26 109.58-89.01 30.84-13.68 66.61-6.31 90.64 19.84 22.47 24.44 52.38 37.25 82.75 37.25 7.49 0 14.97-1.24 22.41-2.81C436.99 432.61 370.32 480 292.78 480z"]
  },
      mw = {
    prefix: "fal",
    iconName: "stop",
    icon: [448, 512, [], "f04d", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352z"]
  },
      vw = {
    prefix: "fal",
    iconName: "stop-circle",
    icon: [512, 512, [], "f28d", "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zM40 256c0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216zm296-96H176c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16zm-16 160H192V192h128v128z"]
  },
      dw = {
    prefix: "fal",
    iconName: "stopwatch",
    icon: [448, 512, [], "f2f2", "M393.3 141.3l17.5-17.5c4.7-4.7 4.7-12.3 0-17l-5.7-5.7c-4.7-4.7-12.3-4.7-17 0l-17.5 17.5c-35.8-31-81.5-50.9-131.7-54.2V32h25c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-80c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h23v32.6C91.2 73.3 0 170 0 288c0 123.7 100.3 224 224 224s224-100.3 224-224c0-56.1-20.6-107.4-54.7-146.7zM224 480c-106.1 0-192-85.9-192-192S117.9 96 224 96s192 85.9 192 192-85.9 192-192 192zm4-128h-8c-6.6 0-12-5.4-12-12V172c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v168c0 6.6-5.4 12-12 12z"]
  },
      Mw = {
    prefix: "fal",
    iconName: "stopwatch-20",
    icon: [448, 512, [], "e06f", "M393.3,141.3l17.5-17.5a12,12,0,0,0,0-17l-5.71-5.71a12,12,0,0,0-17,0l-17.5,17.5A223.09,223.09,0,0,0,238.91,64.41V32h25a12,12,0,0,0,12-12V12a12,12,0,0,0-12-12h-80a12,12,0,0,0-12,12v8a12,12,0,0,0,12,12h23V64.59C91.2,73.3,0,170,0,288,0,411.7,100.3,512,224,512S448,411.7,448,288A223,223,0,0,0,393.3,141.3ZM224,480A192,192,0,1,1,416,288,191.93,191.93,0,0,1,224,480ZM178.48,307.91l2.41-3.32C201,277.09,212,262,212,229.05c0-39.46-15.91-57.05-51.58-57.05C125.14,172,108,190.41,108,228.25v4.06a4.21,4.21,0,0,0,4.33,4.07h24.9a4.21,4.21,0,0,0,4.33-4.07v-5.23c0-8,0-26.67,16.69-26.67,16.2,0,16.2,15.67,16.2,28.26,0,25-6.73,34.58-24.75,60.27l-3.06,4.37c-23.44,33.46-35.06,55.36-37.75,89.39a12.06,12.06,0,0,0,3.22,9.22,12.64,12.64,0,0,0,9.41,4.08h82.84a4.21,4.21,0,0,0,4.33-4.06V369.62a4.21,4.21,0,0,0-4.33-4.07H150.75l.52-4.46C153.34,342.91,169.22,320,178.48,307.91ZM288.19,172C254.05,172,236,192.48,236,231.22V336.56c0,40.55,16.12,59.44,50.77,59.44,36.31,0,53.23-19,53.23-59.69v-107C340,203.16,331,172,288.19,172Zm16.7,169c0,16.78-5.72,25.28-17,25.28s-17.24-8.28-17.24-24.61V225.73c0-19.84,9.38-24,17.24-24s17,4.05,17,23.34Z"]
  },
      pw = {
    prefix: "fal",
    iconName: "store",
    icon: [616, 512, [], "f54e", "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-29.6 47.2-10 110.6 38 130.8v227.4c0 19.4 14.3 35.2 32 35.2h448c17.7 0 32-15.8 32-35.2V249.4c48-20.2 67.6-83.6 38-130.8zm-70 358.2c0 2-.8 3.1-.2 3.2l-446.6.3c-.3-.2-1.2-1.3-1.2-3.5V352h448zM84 320v-64h2.5c29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.9 33.1h2.5v64zm494.2-126.5c-7.8 16.6-22.1 27.5-39.3 29.8-3.1.4-6.2.6-9.4.6-19.3 0-37-8-50-22.5L455.7 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5s-37-8-50-22.5L308 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5s-37-8-50-22.5L160.3 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5-3.2 0-6.3-.2-9.4-.6-17.2-2.3-31.5-13.2-39.3-29.8-8.7-18.6-7.5-40.8 3.3-57.9L106 32h404l64.9 103.6c10.8 17.2 12 39.3 3.3 57.9z"]
  },
      zw = {
    prefix: "fal",
    iconName: "store-alt",
    icon: [640, 512, [], "f54f", "M635.7 176.1l-91.4-160C538.6 6.2 528 0 516.5 0h-393C112 0 101.4 6.2 95.7 16.1l-91.4 160C-7.9 197.5 7.4 224 32 224h32v254.5C64 497 78.3 512 96 512h256c17.7 0 32-15 32-33.5V224h160v280c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V224h32c24.6 0 39.9-26.5 27.7-47.9zM352 478.5c0 .9-.3 1.4-.2 1.5l-255.2.2s-.6-.5-.6-1.7V352h256v126.5zm0-158.5H96v-96h256v96zM32.1 192l91.4-160h393L608 192H32.1z"]
  },
      Cw = {
    prefix: "fal",
    iconName: "store-alt-slash",
    icon: [640, 512, [], "e070", "M516.51,32,608,192H342.09L384,225v-1H544V351l32,25.2V224h32c24.6,0,39.91-26.5,27.71-47.91l-91.41-160A32.15,32.15,0,0,0,516.51,0h-393a31.85,31.85,0,0,0-17.92,5.76L138.91,32ZM352,478.5c0,.91-.29,1.41-.2,1.5l-255.2.2a2.23,2.23,0,0,1-.6-1.7V352H338.48l-40.64-32H96V224h79.92l-40.64-32H32.11l32-56-25.44-20L4.31,176.09C-7.89,197.5,7.42,224,32,224H64V478.5C64,497,78.31,512,96,512H352c17.71,0,32-15,32-33.5V387.86l-32-25.2ZM23,1.8A7.88,7.88,0,0,0,11.77,3l-10,12.5A7.94,7.94,0,0,0,3,26.71L617,510.23A8,8,0,0,0,628.2,509l10-12.5a7.86,7.86,0,0,0-1.21-11.2Z"]
  },
      Lw = {
    prefix: "fal",
    iconName: "store-slash",
    icon: [640, 512, [], "e071", "M97.2,480.3a4.53,4.53,0,0,1-1.2-3.5V352H338.48l-40.64-32H96V256h2.5a98.65,98.65,0,0,0,73.24-32.59C165.67,218.43,148,202,148,202A66.31,66.31,0,0,1,98.5,224.09a71.51,71.51,0,0,1-9.41-.59c-17.18-2.3-31.5-13.2-39.29-29.8-8.71-18.61-7.5-40.79,3.29-57.9l3.58-5.72-25.36-20L26,118.59C-3.59,165.8,16,229.2,64,249.41V476.8C64,496.2,78.3,512,96,512H541.66l-40.6-32ZM522,32l64.91,103.59a61,61,0,0,1,3.29,57.91c-7.79,16.59-22.11,27.5-39.29,29.8a73.26,73.26,0,0,1-9.41.61,66.35,66.35,0,0,1-50-22.5L467.7,175l-23.79,26.59a66.37,66.37,0,0,1-50,22.5,67.35,67.35,0,0,1-12.76-1.33l37.68,29.67a99.3,99.3,0,0,0,48.67-29.52A99.14,99.14,0,0,0,541.41,256h2.5v64H504.64L576,376.2V249.41c48-20.21,67.59-83.61,38-130.82L549.09,15A32,32,0,0,0,522,0H118a31.92,31.92,0,0,0-14.92,3.78L138.91,32ZM637,485.32,23,1.8A7.88,7.88,0,0,0,11.77,3l-10,12.5A7.94,7.94,0,0,0,3,26.71L617,510.23A8,8,0,0,0,628.2,509l10-12.5A7.86,7.86,0,0,0,637,485.32Z"]
  },
      Aw = {
    prefix: "fal",
    iconName: "stream",
    icon: [512, 512, [], "f550", "M8 128h432c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8zm496 112H72c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h432c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-64 144H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h432c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"]
  },
      Nw = {
    prefix: "fal",
    iconName: "street-view",
    icon: [512, 512, [], "f21d", "M368 360.15v30.87c62.27 8.42 104 23.6 104 40.99 0 26.51-96.71 48-216 48S40 458.51 40 432c0-17.38 41.73-32.56 104-40.99v-30.87C58.82 373.14 0 400.39 0 432c0 44.18 114.62 80 256 80s256-35.82 256-80c0-31.61-58.82-58.86-144-71.85zM176 320v80c0 26.47 21.53 48 48 48h64c26.47 0 48-21.53 48-48v-80c26.47 0 48-21.53 48-48v-64c0-34.53-22.11-63.75-52.82-74.93C339.14 119.84 344 104.54 344 88c0-48.52-39.48-88-88-88s-88 39.48-88 88c0 16.54 4.86 31.84 12.82 45.07C150.11 144.25 128 173.47 128 208v64c0 26.47 21.53 48 48 48zm80-288c30.93 0 56 25.07 56 56s-25.07 56-56 56-56-25.07-56-56 25.07-56 56-56zm-96 176c0-25.76 20.44-46.68 45.93-47.79C220.17 170.11 237.38 176 256 176s35.83-5.89 50.07-15.79C331.56 161.32 352 182.24 352 208v64c0 8.83-7.19 16-16 16h-32v112c0 8.83-7.19 16-16 16h-64c-8.81 0-16-7.17-16-16V288h-32c-8.81 0-16-7.17-16-16v-64z"]
  },
      gw = {
    prefix: "fal",
    iconName: "stretcher",
    icon: [640, 512, [], "f825", "M608 128H192L79.84 10.74a32 32 0 0 0-45.18-2.65L10.74 29.35a32 32 0 0 0-2.66 45.17l121.7 128A64 64 0 0 0 177.62 224h23.18l143.11 125.81-51.84 45.36A65.88 65.88 0 1 0 313 419.38L368 371l55 48.39a63.26 63.26 0 1 0 20.89-24.21l-51.84-45.36L535.2 224H608a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32zM256 480a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm224-64a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm-112-87.27L248.3 224h239.4zM608 192H177.62c-9.14 0-17.85-3.92-24.65-11.53L32 53.26 55.89 32l122.44 128H608z"]
  },
      Hw = {
    prefix: "fal",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", "M361.36 320a72.48 72.48 0 0 1 21 68.24c-4.86 23-21.55 42.13-43.07 51.52a98.75 98.75 0 0 1-39.35 8.24H234a78.37 78.37 0 0 1-74.58-53.5 8.07 8.07 0 0 0-9.43-5.56l-15.65 3.65a8 8 0 0 0-6 10A110.28 110.28 0 0 0 234 480h66a130.93 130.93 0 0 0 52.12-10.91c33.54-14.6 58.16-46.18 63-82.44A104.52 104.52 0 0 0 401.79 320zm-192.11-96h68.28l-39.37-19.61c-24.78-12.33-40-37.46-39.29-66.71a72.2 72.2 0 0 1 40.23-63.34A98.53 98.53 0 0 1 242.91 64h47.86a108.83 108.83 0 0 1 95.51 56.91 8 8 0 0 0 10.33 3.69l14.6-6.62a8.06 8.06 0 0 0 3.92-11A140.86 140.86 0 0 0 290.77 32h-47.86a130.84 130.84 0 0 0-58.16 13.73c-35.72 17.86-57.9 53.82-57.9 95.21a102.1 102.1 0 0 0 42.4 83.06zM504 256H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h496a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      Vw = {
    prefix: "fal",
    iconName: "stroopwafel",
    icon: [512, 512, [], "f551", "M256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm0 480C132.49 480 32 379.51 32 256S132.49 32 256 32s224 100.49 224 224-100.49 224-224 224zm158.39-224l28.28-28.28c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-28.28 28.28-45.26-45.25 22.63-22.63 16.97 16.97c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31l-16.97-16.97 5.66-5.66c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-5.66 5.66-16.97-16.97c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l16.97 16.97-22.63 22.63-45.26-45.25 28.29-28.28c3.12-3.12 3.12-8.19 0-11.31L295.6 69.32c-3.12-3.12-8.19-3.12-11.31 0L256 97.61l-28.29-28.29c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l28.29 28.28-45.25 45.25-22.63-22.63 16.97-16.97c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-16.97 16.97-5.66-5.66c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66-16.97 16.97c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l16.97-16.97 22.63 22.63-45.25 45.25-28.29-28.28c-3.12-3.12-8.19-3.12-11.31 0L69.32 216.4c-3.12 3.12-3.12 8.19 0 11.31L97.61 256l-28.29 28.29c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l28.29-28.28 45.25 45.25-22.63 22.63-16.97-16.97c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31l16.97 16.97-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l5.66-5.66 16.97 16.97c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31l-16.97-16.97 22.63-22.63 45.26 45.26-28.29 28.29c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0L256 414.39l28.29 28.29c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31l-28.29-28.29 45.26-45.26 22.63 22.63-16.97 16.97c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0l16.97-16.97 5.66 5.66c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31l-5.66-5.66 16.97-16.97c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0l-16.97 16.97-22.63-22.63 45.25-45.25 28.29 28.28c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31L414.39 256zM256 142.86l45.25 45.25L256 233.37l-45.25-45.25L256 142.86zM142.86 256l45.25-45.26L233.37 256l-45.26 45.26L142.86 256zM256 369.14l-45.26-45.26L256 278.62l45.26 45.26L256 369.14zm67.88-67.89L278.63 256l45.26-45.25L369.14 256l-45.26 45.25z"]
  },
      xw = {
    prefix: "fal",
    iconName: "subscript",
    icon: [512, 512, [], "f12c", "M344 64h-56a16 16 0 0 0-13.49 7.41L176 226.2 77.5 71.41A16 16 0 0 0 64 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h47.22L157 256 55.22 416H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h56a16 16 0 0 0 13.5-7.41L176 285.8l98.51 154.79A16 16 0 0 0 288 448h56a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-47.22L195 256 296.78 96H344a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zm160 416h-40V304a16 16 0 0 0-16-16h-16a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 416 352h16v128h-40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      ww = {
    prefix: "fal",
    iconName: "subway",
    icon: [448, 512, [], "f239", "M112 384c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm0-64c8.823 0 16 7.177 16 16s-7.177 16-16 16-16-7.177-16-16 7.177-16 16-16zm224 64c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm0-64c8.823 0 16 7.177 16 16s-7.177 16-16 16-16-7.177-16-16 7.177-16 16-16zM320 0H128C64 0 0 42.981 0 96v256c0 47.169 50.656 86.391 106.9 94.473l-55.285 55.285c-3.78 3.78-1.103 10.243 4.243 10.243h25.798c3.182 0 6.235-1.264 8.485-3.515L150.627 448h146.745l60.486 60.485a12.002 12.002 0 0 0 8.485 3.515h25.798c5.345 0 8.022-6.463 4.243-10.243L341.1 446.472C397.344 438.391 448 399.169 448 352V96c0-53.019-63-96-128-96zM32 128h176v96H32v-96zm384 224c0 32.299-47.552 64-96 64H128c-48.448 0-96-31.701-96-64v-96h384v96zm0-128H240v-96h176v96zM32 96c0-32.299 47.552-64 96-64h192c58.237 0 96 37.881 96 64H32z"]
  },
      yw = {
    prefix: "fal",
    iconName: "suitcase",
    icon: [512, 512, [], "f0f2", "M464 128H352V80c0-26.47-21.53-48-48-48h-96c-26.47 0-48 21.53-48 48v48H48c-26.5 0-48 21.5-48 48v256c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 80c0-8.83 7.19-16 16-16h96c8.81 0 16 7.17 16 16v48H192V80zM96 448H48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48v288zm288 0H128V160h256v288zm96-16c0 8.8-7.2 16-16 16h-48V160h48c8.8 0 16 7.2 16 16v256z"]
  },
      bw = {
    prefix: "fal",
    iconName: "suitcase-rolling",
    icon: [384, 512, [], "f5c1", "M336 160h-48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v112H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zM128 48c0-8.82 7.18-16 16-16h96c8.82 0 16 7.18 16 16v112H128V48zm224 384c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16V208c0-8.82 7.18-16 16-16h288c8.82 0 16 7.18 16 16v224zm-72-80H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h176c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm0-96H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h176c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"]
  },
      Sw = {
    prefix: "fal",
    iconName: "sun",
    icon: [512, 512, [], "f185", "M256 143.7c-61.8 0-112 50.3-112 112.1s50.2 112.1 112 112.1 112-50.3 112-112.1-50.2-112.1-112-112.1zm0 192.2c-44.1 0-80-35.9-80-80.1s35.9-80.1 80-80.1 80 35.9 80 80.1-35.9 80.1-80 80.1zm256-80.1c0-5.3-2.7-10.3-7.1-13.3L422 187l19.4-97.9c1-5.2-.6-10.7-4.4-14.4-3.8-3.8-9.1-5.5-14.4-4.4l-97.8 19.4-55.5-83c-6-8.9-20.6-8.9-26.6 0l-55.5 83-97.8-19.5c-5.3-1.1-10.6.6-14.4 4.4-3.8 3.8-5.4 9.2-4.4 14.4L90 187 7.1 242.5c-4.4 3-7.1 8-7.1 13.3 0 5.3 2.7 10.3 7.1 13.3L90 324.6l-19.4 97.9c-1 5.2.6 10.7 4.4 14.4 3.8 3.8 9.1 5.5 14.4 4.4l97.8-19.4 55.5 83c3 4.5 8 7.1 13.3 7.1s10.3-2.7 13.3-7.1l55.5-83 97.8 19.4c5.4 1.2 10.7-.6 14.4-4.4 3.8-3.8 5.4-9.2 4.4-14.4L422 324.6l82.9-55.5c4.4-3 7.1-8 7.1-13.3zm-116.7 48.1c-5.4 3.6-8 10.1-6.8 16.4l16.8 84.9-84.8-16.8c-6.6-1.4-12.8 1.4-16.4 6.8l-48.1 72-48.1-71.9c-3-4.5-8-7.1-13.3-7.1-1 0-2.1.1-3.1.3l-84.8 16.8 16.8-84.9c1.2-6.3-1.4-12.8-6.8-16.4l-71.9-48.1 71.9-48.2c5.4-3.6 8-10.1 6.8-16.4l-16.8-84.9 84.8 16.8c6.5 1.3 12.8-1.4 16.4-6.8l48.1-72 48.1 72c3.6 5.4 9.9 8.1 16.4 6.8l84.8-16.8-16.8 84.9c-1.2 6.3 1.4 12.8 6.8 16.4l71.9 48.2-71.9 48z"]
  },
      Tw = {
    prefix: "fal",
    iconName: "sun-cloud",
    icon: [640, 512, [], "f763", "M558.2 185.6C542.1 151.5 507.4 128 468 128c-41.7 0-77.6 25.2-92.5 62.5-32.5 11.4-55.5 42.1-55.5 78.3 0 45.9 37.3 83.2 83.2 83.2h153.6c45.9 0 83.2-37.3 83.2-83.2 0-45.4-36.6-82.4-81.8-83.2zM556.8 320H403.2c-28.3 0-51.2-22.9-51.2-51.2 0-27.5 21.8-49.8 49-51 4.9-32.7 32.9-57.8 67-57.8 35.8 0 64.8 27.8 67.5 62.9 6.5-3.1 13.6-5.3 21.3-5.3 28.3 0 51.2 22.9 51.2 51.2S585.1 320 556.8 320zm-153.6 64c-.7 0-1.4-.2-2.1-.2l4.3 21.6-84.8-16.8c-6.6-1.3-12.8 1.4-16.4 6.8L256 467.2l-48.1-71.9c-3.6-5.3-9.9-8.1-16.4-6.8l-84.8 16.8 16.8-84.8c1.2-6.3-1.4-12.8-6.8-16.4L44.8 256l71.9-48.1c5.4-3.6 8-10.1 6.8-16.4l-16.8-84.8 84.8 16.8c6.5 1.3 12.8-1.5 16.4-6.8L256 44.8l48.1 71.9c3.6 5.3 9.9 8.1 16.4 6.8L428.8 102c8.7-1.7 14.3-10.1 12.6-18.8-1.7-8.7-10.1-14.4-18.8-12.6L324.8 90 269.3 7.1c-3-4.4-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1L187.2 90 89.4 70.6c-5.3-1.1-10.6.6-14.4 4.4s-5.4 9.2-4.4 14.4L90 187.2 7.1 242.7c-4.4 3-7.1 7.9-7.1 13.3s2.7 10.3 7.1 13.3L90 324.8l-19.4 97.8c-1 5.2.6 10.7 4.4 14.4 3.8 3.8 9.1 5.4 14.4 4.4l97.8-19.4 55.5 82.9c3 4.4 8 7.1 13.3 7.1s10.3-2.7 13.3-7.1l55.4-82.9 97.8 19.4c5.4 1.1 10.7-.6 14.4-4.4 3.8-3.8 5.4-9.2 4.4-14.4l-7.6-38.6h-30.5zM256 179.7c21 0 40 8.5 53.8 22.3 6.2-8.7 13.6-16.4 22-23.1-19.5-19.2-46.3-31.1-75.8-31.1-59.7 0-108.3 48.6-108.3 108.3S196.3 364.3 256 364.3c22.8 0 44-7.2 61.5-19.3-7.1-8-13.1-16.9-17.8-26.6-12.4 8.7-27.4 13.9-43.7 13.9-42.1 0-76.3-34.2-76.3-76.3s34.2-76.3 76.3-76.3z"]
  },
      Dw = {
    prefix: "fal",
    iconName: "sun-dust",
    icon: [512, 512, [], "f764", "M123.5 191.5l-16.8-84.8 84.8 16.8c6.4 1.2 12.7-1.2 16.4-6.8L256 44.8l48.1 71.9c3.8 5.6 10.6 8.3 17.2 6.6l85.7-21.5c2.9-.7 5.4-2.2 7.4-4.2 3.8-3.8 5.6-9.5 4.2-15.2-2.1-8.6-10.8-13.8-19.4-11.6l-74.8 18.7-55.1-82.4c-3-4.4-7.9-7.1-13.3-7.1-5.3 0-10.3 2.5-13.3 7.1L187.3 90 89.6 70.6h-.1c-1-.2-2 0-3 0-1.1 0-2.1-.2-3.2 0-2.1.4-4.1 1.3-5.8 2.4-.5.3-.8.9-1.3 1.3-1.1.9-2.2 1.9-3.1 3.1-1.2 1.7-2 3.7-2.4 5.8-.2 1.1 0 2.1 0 3.1s-.2 2.1 0 3.1v.1L90 187.3 7.1 242.7c-4.5 3-7.1 7.9-7.1 13.3 0 5.3 2.7 10.3 7.1 13.3l82.4 55.1-18.7 74.8c-2.2 8.6 3 17.3 11.6 19.4 5.7 1.4 11.4-.4 15.2-4.2 2-2 3.5-4.5 4.2-7.4l21.5-85.7c1.7-6.6-1-13.4-6.6-17.2L44.8 256l71.9-48.1c5.5-3.6 8-10.1 6.8-16.4zm183.4 2.8c3.3 2.7 8 2.8 11-.3l11.3-11.3c3.2-3.2 3.2-8.6-.2-11.6-43.9-37.9-110.6-36-152.2 5.7-41.7 41.7-43.6 108.3-5.7 152.2 3 3.5 8.4 3.5 11.6.2l11.3-11.3c3-3 3-7.7.3-11-26-31.4-24.3-78.1 5.1-107.5 29.4-29.4 76.2-31 107.5-5.1zm183.8 275c-11.8 0-21.3 9.6-21.3 21.3 0 11.8 9.5 21.3 21.3 21.3s21.3-9.6 21.3-21.3c0-11.7-9.6-21.3-21.3-21.3zm0-170.6c-11.8 0-21.3 9.6-21.3 21.3 0 11.8 9.5 21.3 21.3 21.3S512 331.7 512 320c0-11.8-9.6-21.3-21.3-21.3zm0-128c11.8 0 21.3-9.6 21.3-21.3 0-11.8-9.6-21.3-21.3-21.3-11.8 0-21.3 9.6-21.3 21.3-.1 11.7 9.5 21.3 21.3 21.3zM149.3 469.3c-11.8 0-21.3 9.6-21.3 21.3 0 11.8 9.6 21.3 21.3 21.3 11.8 0 21.3-9.6 21.3-21.3.1-11.7-9.5-21.3-21.3-21.3zm85.4-85.3c-11.8 0-21.3 9.6-21.3 21.3 0 11.8 9.5 21.3 21.3 21.3S256 417 256 405.3c0-11.7-9.6-21.3-21.3-21.3zm85.3-85.3c-11.8 0-21.3 9.6-21.3 21.3 0 11.8 9.6 21.3 21.3 21.3s21.3-9.6 21.3-21.3c0-11.8-9.5-21.3-21.3-21.3zm85.3-85.4c-11.8 0-21.3 9.6-21.3 21.3 0 11.8 9.6 21.3 21.3 21.3 11.8 0 21.3-9.6 21.3-21.3.1-11.7-9.5-21.3-21.3-21.3zm-85.3 256c-11.8 0-21.3 9.6-21.3 21.3 0 11.8 9.6 21.3 21.3 21.3s21.3-9.6 21.3-21.3c0-11.7-9.5-21.3-21.3-21.3zm85.3-85.3c-11.8 0-21.3 9.6-21.3 21.3 0 11.8 9.6 21.3 21.3 21.3 11.8 0 21.3-9.6 21.3-21.3.1-11.7-9.5-21.3-21.3-21.3z"]
  },
      jw = {
    prefix: "fal",
    iconName: "sun-haze",
    icon: [640, 512, [], "f765", "M216 480H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm416 0H296c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h336c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-56-56v-16c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8zm56-104.1H488c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM72 352h336c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm136.3-104.5c-.3 4.5 3.5 8.4 8.1 8.4h16c4.3 0 7.6-3.4 8-7.6 3.8-40.6 38.1-72.4 79.6-72.4s75.8 31.8 79.6 72.4c.4 4.2 3.7 7.6 8 7.6h16c4.6 0 8.4-3.8 8.1-8.4-4.3-57.9-52.8-103.6-111.7-103.6s-107.4 45.8-111.7 103.6zM96 255.9c2.8 0 5.7-.7 8.2-2.3l75.8-45.4c5.8-3.5 8.8-10.2 7.5-16.8l-16.8-84.9 84.8 16.8c6.5 1.3 12.8-1.4 16.4-6.8L320 44.7l48.1 71.9c3.6 5.4 9.9 8.1 16.4 6.8l84.8-16.8-16.8 84.9c-1.3 6.6 1.7 13.4 7.5 16.8l75.8 45.4c2.6 1.5 5.4 2.3 8.2 2.3 5.4 0 10.7-2.8 13.7-7.8 4.6-7.6 2.1-17.4-5.5-21.9l-66.1-39.6 19.3-97.3c1-5.2-.6-10.6-4.4-14.4s-9.1-5.5-14.4-4.4L388.8 90 333.4 7.1l-.1-.1c-.6-.9-1.4-1.4-2.1-2.1-.8-.8-1.3-1.7-2.3-2.3-1.8-1.2-3.8-2-5.8-2.4-.6-.1-1.2 0-1.8 0-1.4-.1-2.9-.3-4.3 0-2 .4-4 1.2-5.8 2.4-.9.6-1.5 1.5-2.2 2.2-.7.7-1.6 1.3-2.2 2.2l-.1.1-55.4 82.8-97.8-19.4c-5.3-1.1-10.6.6-14.4 4.4-3.8 3.8-5.4 9.2-4.4 14.4l19.3 97.3-66.1 39.6c-7.6 4.5-10.1 14.4-5.5 21.9 2.9 5.1 8.2 7.8 13.6 7.8z"]
  },
      Ew = {
    prefix: "fal",
    iconName: "sunglasses",
    icon: [576, 512, [], "f892", "M107.16 305.63L48 355.73v13.55C48 403.87 76.71 432 112 432h36.09c33.3 0 61.34-25.51 63.83-58.08l3.83-50.48a216.87 216.87 0 0 0-88.37-18.92c-7.03 0-13.69.48-20.22 1.11zm467.06-25.05l-45.5-188a80 80 0 0 0-102.91-56.5L403 43.71a8 8 0 0 0-5.06 10.1L403 69a8 8 0 0 0 10.12 5.06l21.79-7.26c10.09-3.38 21.15-3.95 31.24-.49 16.13 5.57 27.57 18.13 31.5 33.85l40.6 171.43a277.85 277.85 0 0 0-89.56-15.06c-37.35 0-80.25 8-125 31.49h-71.35c-44.72-23.49-87.65-31.5-125-31.49a278.55 278.55 0 0 0-89.56 15.06l40.56-171.23a47.54 47.54 0 0 1 24.28-30.9c12.26-6.43 26.88-6.5 40-2.15l20.29 6.79A8 8 0 0 0 173 69l5.06-15.18A8 8 0 0 0 173 43.74l-22.87-7.61A79.93 79.93 0 0 0 47.25 92.78L1.81 280.58A62.68 62.68 0 0 0 0 295.64v73.64C0 430.44 50.12 480 112 480h36.09c58.6 0 107.29-44.67 111.69-102.44l4.34-57.56h47.76l4.34 57.56C320.62 435.34 369.31 480 427.91 480H464c61.88 0 112-49.56 112-110.72v-73.65a64.18 64.18 0 0 0-1.78-15.05zm-346.34 94.56C224.75 416 189.72 448 148.09 448H112c-44.12 0-80-35.31-80-78.72V308a248.65 248.65 0 0 1 95.38-19.47c36.34 0 71.62 8.43 105.15 25.14zM544 369.28c0 43.41-35.88 78.72-80 78.72h-36.09c-41.63 0-76.66-32-79.79-72.86l-4.65-61.48C377 297 412.31 288.52 448.66 288.52A248.46 248.46 0 0 1 544 308zm-115.12-63.72l-65.69 56.6.89 11.77c2.49 32.56 30.53 58.07 63.83 58.07H464c35.29 0 64-28.13 64-62.72v-50.41a233.52 233.52 0 0 0-79.34-14.35c-6.66 0-13.22.48-19.78 1.04z"]
  },
      kw = {
    prefix: "fal",
    iconName: "sunrise",
    icon: [576, 512, [], "f766", "M95.8 448h38.5l-44-66 86-17.2c6.3-1.3 11.3-6.2 12.6-12.6l17.2-86 73 48.7c5.4 3.6 12.4 3.6 17.8 0l73-48.7 17.2 86c1.2 6.3 6.2 11.3 12.6 12.6l86 17.2-44 66h38.5l45.5-68.1c3-4.4 3.5-10.1 1.5-15s-6.4-8.5-11.7-9.6l-99-19.8-19.8-99c-1-5.2-4.6-9.6-9.6-11.7-5-2.1-10.6-1.5-15 1.5l-84 56-84-56c-4.4-2.9-10.1-3.5-15-1.5s-8.5 6.4-9.6 11.7l-19.8 99-99 19.8c-5.2 1-9.6 4.6-11.7 9.6s-1.5 10.6 1.5 15L95.8 448zm101.9-330.3c3.1 3.1 8.2 3.1 11.3 0l63-63V216c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V54.6l63 63c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3L299.3 4.7C296.2 1.6 292.1 0 288 0s-8.2 1.6-11.3 4.7L186.3 95c-3.1 3.1-3.1 8.2 0 11.3l11.4 11.4zM568 480H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM287.8 352c-56.3 0-102.5 41.9-110.4 96h32c7.4-36.5 39.7-64 78.4-64s70.9 27.5 78.4 64h32c-7.8-54.1-54.1-96-110.4-96z"]
  },
      Iw = {
    prefix: "fal",
    iconName: "sunset",
    icon: [576, 512, [], "f767", "M276.7 219.3c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7l90.3-90.3c3.1-3.1 3.1-8.2 0-11.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0l-63 63V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v161.4l-63-63c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l90.3 90.3zM95.8 448h38.5l-44-66 86-17.2c6.3-1.3 11.3-6.2 12.6-12.6l17.2-86 73 48.7c5.4 3.6 12.4 3.6 17.8 0l73-48.7 17.2 86c1.2 6.3 6.2 11.3 12.6 12.6l86 17.2-44 66h38.5l45.5-68.1c3-4.4 3.5-10.1 1.5-15s-6.4-8.5-11.7-9.6l-99-19.8-19.8-99c-1-5.2-4.6-9.6-9.6-11.7-5-2.1-10.6-1.5-15 1.5l-84 56-84-56c-4.4-2.9-10.1-3.5-15-1.5s-8.5 6.4-9.6 11.7l-19.8 99-99 19.8c-5.2 1-9.6 4.6-11.7 9.6s-1.5 10.6 1.5 15L95.8 448zm192-96c-56.3 0-102.5 41.9-110.4 96h32c7.4-36.5 39.7-64 78.4-64s70.9 27.5 78.4 64h32c-7.8-54.1-54.1-96-110.4-96zM568 480H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      Ow = {
    prefix: "fal",
    iconName: "superscript",
    icon: [512, 512, [], "f12b", "M344 64h-56a16 16 0 0 0-13.49 7.41L176 226.2 77.5 71.41A16 16 0 0 0 64 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h47.22L157 256 55.22 416H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h56a16 16 0 0 0 13.5-7.41L176 285.8l98.51 154.79A16 16 0 0 0 288 448h56a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-47.22L195 256 296.78 96H344a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zm160 128h-40V16a16 16 0 0 0-16-16h-16a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 416 64h16v128h-40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      Qw = {
    prefix: "fal",
    iconName: "surprise",
    icon: [496, 512, [], "f5c2", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm0-184c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm0 96c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm-48-176c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      Zw = {
    prefix: "fal",
    iconName: "swatchbook",
    icon: [512, 512, [], "f5c3", "M96 432c8.84 0 16-7.16 16-16s-7.16-16-16-16-16 7.16-16 16 7.16 16 16 16zm384-112H327.77l107.65-107.65c12.5-12.5 12.5-32.76 0-45.26l-90.52-90.5c-6.25-6.25-14.44-9.37-22.63-9.37s-16.38 3.12-22.63 9.37L192 184.23V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v384c0 53.02 42.98 96 96 96h384c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zm-320 96c0 35.29-28.71 64-64 64s-64-28.71-64-64V288h128v128zm0-160H32v-96h128v96zm0-128H32V32h128v96zm32 101.47L322.24 99.22h.03l90.51 90.51L192 410.51V229.47zM480 480H167.76l128-128H480v128z"]
  },
      Uw = {
    prefix: "fal",
    iconName: "swimmer",
    icon: [640, 512, [], "f5c4", "M128 288c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zm0-160c35.29 0 64 28.71 64 64s-28.71 64-64 64-64-28.71-64-64 28.71-64 64-64zm61.61 214.58c2.73 2.52 10.45 6.69 22.56 8.5l42.24-60.29c15.47-22.12 32.69-42.73 50.76-62.52l154.55 107c11.11-7.99 23.08-12.79 35.44-14.37L327.4 204.75c23.24-22.91 48.13-44.19 74.91-63.31 10.97-7.83 24.91-10.69 38.47-7.77l100.38 18.08c8.59 1.53 17-4.19 18.59-12.91 1.56-8.7-4.22-17.03-12.91-18.59l-99.88-17.97a80.012 80.012 0 0 0-63.28 13.12c-60.56 43.25-112.88 96.09-155.5 157.03l-45.38 64.81c2.29 1.76 4.62 3.32 6.81 5.34zM632 384h-24c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 375.58 442.04 384 416 384s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 375.58 250.04 384 224 384s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 375.58 58.04 384 32 384H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h24c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h24c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"]
  },
      Bw = {
    prefix: "fal",
    iconName: "swimming-pool",
    icon: [640, 512, [], "f5c5", "M632 448h-24c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 439.58 442.04 448 416 448s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 439.58 250.04 448 224 448s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 439.58 58.04 448 32 448H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h24c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h24c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-440-39.79V256h224v160c16.38 0 26.97-4.45 32-7.79V112c0-26.47 21.53-48 48-48s48 21.53 48 48v8c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-8c0-44.11-35.88-80-80-80s-80 35.89-80 80v112H192V112c0-26.47 21.53-48 48-48s48 21.53 48 48v8c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-8c0-44.11-35.88-80-80-80s-80 35.89-80 80v276.5c10.41 3.73 20.44 9.62 29.61 18.07.5.47 1.55 1.08 2.39 1.64z"]
  },
      Rw = {
    prefix: "fal",
    iconName: "sword",
    icon: [512, 512, [], "f71c", "M496.04 0c-.76 0-1.53.05-2.31.17L400 16 165.26 250.74l-39.15-39.15a15.887 15.887 0 0 0-11.31-4.68c-4.09 0-8.19 1.56-11.31 4.68l-34.79 34.8a16.005 16.005 0 0 0-2 20.19l45.9 68.84-39.79 39.79-16.76-8.38a13.82 13.82 0 0 0-6.21-1.47c-3.61 0-7.16 1.4-9.83 4.07L4.07 405.36c-5.42 5.43-5.42 14.22 0 19.64L87 507.93c2.71 2.71 6.27 4.07 9.82 4.07 3.55 0 7.11-1.36 9.82-4.07L142.57 472a13.889 13.889 0 0 0 2.6-16.03l-8.38-16.76 39.78-39.78 68.84 45.9c2.71 1.8 5.8 2.68 8.87 2.68 4.13 0 8.23-1.59 11.32-4.69l34.8-34.79c6.25-6.25 6.25-16.38 0-22.63l-39.15-39.15L496 112l15.83-93.73C513.23 8.49 505.57 0 496.04 0zM266.47 397.2l-14.21 14.21-57.92-38.62-21.83-14.55-18.55 18.55-39.78 39.78-16.31 16.31 10.31 20.63 2.54 5.09-13.9 13.9-57.32-57.32 13.9-13.9 5.08 2.54 20.63 10.32 16.31-16.31 39.79-39.79 18.55-18.55-14.55-21.83-38.62-57.92 14.21-14.21L266.47 397.2zM466.15 96.6L238.63 324.11l-50.74-50.74L415.4 45.85l61.06-10.32-10.31 61.07z"]
  },
      Yw = {
    prefix: "fal",
    iconName: "sword-laser",
    icon: [512, 512, [], "e03b", "M502.43507,11.94728A36.44142,36.44142,0,0,0,477.06206.00781C476.80229.002,476.54253,0,476.28081,0A38.64416,38.64416,0,0,0,450.6285,9.586L196.34371,243.305,182.192,229.15328a8.00293,8.00293,0,0,0-11.31443,0L159.56312,240.4697a7.9971,7.9971,0,0,0,.00195,11.31251l5.65564,5.65566-56.56828,56.56844-1.17578-1.17579a7.99588,7.99588,0,0,0-11.30858,0l-80.1698,80.1759a54.62117,54.62117,0,0,0,0,77.2462l25.75,25.75a54.61844,54.61844,0,0,0,77.244-.00195l80.16981-80.1759a7.99594,7.99594,0,0,0,0-11.30861l56.56828-56.56844,5.65759,5.65761a7.99882,7.99882,0,0,0,11.31248.002l11.31444-11.31642a7.99713,7.99713,0,0,0,0-11.31252l-15.34508-15.34512L502.46632,61.21884A36.55287,36.55287,0,0,0,502.43507,11.94728ZM96.36534,473.37372a22.64678,22.64678,0,0,1-31.99019.00391l-25.75-25.75394a22.62156,22.62156,0,0,1,.00195-31.99224l63.19718-63.19931,6.82811,6.83009,45.2558,45.254,5.65428,5.65626Zm80.16981-91.4845-45.25384-45.254,11.31248-11.31447,45.25579,45.25592Zm22.62692-22.627-45.25384-45.25592,11.31248-11.31252,45.25579,45.254Zm22.62692-22.627-45.25384-45.25593,11.31443-11.31251,45.25384,45.254ZM478.90385,39.56646,246.02333,292.98675l-27.03317-27.0352L472.09136,33.32036a6.83032,6.83032,0,0,1,3.86523-1.31445,4.39513,4.39513,0,0,1,2.82812,1.498A4.47664,4.47664,0,0,1,478.90385,39.56646Z"]
  },
      Pw = {
    prefix: "fal",
    iconName: "sword-laser-alt",
    icon: [512, 512, [], "e03c", "M502.4353,11.9454A36.44741,36.44741,0,0,0,477.06225.0079a38.76627,38.76627,0,0,0-26.37109,9.51563L181.19507,255.39462l.541.59375H159.60913a15.99221,15.99221,0,0,0-11.31055,4.68555L15.99585,392.99814a54.63336,54.63336,0,0,0,0,77.252l25.748,25.75a54.60508,54.60508,0,0,0,77.23633,0L331.64038,283.30087c9.54492-9.54492,3.39062-25.05078-9.36914-26.71094L502.46655,61.213A36.54769,36.54769,0,0,0,502.4353,11.9454ZM38.62671,447.62509a22.648,22.648,0,0,1-.002-31.99414l65.19141-65.18945L125.58764,372.213l-81.1875,81.1875Zm57.74218,25.748a22.62382,22.62382,0,0,1-31.99414.002l-5.77539-5.77539,81.1875-81.1875,21.77149,21.77148Zm87.81446-87.81446L126.44116,327.8165l39.81641-39.81641H281.74194ZM478.8435,39.63486,279.32788,255.98837H228.033l244.1875-222.791a5.12736,5.12736,0,0,1,6.56054.29687A4.71587,4.71587,0,0,1,478.8435,39.63486Z"]
  },
      Fw = {
    prefix: "fal",
    iconName: "swords",
    icon: [512, 512, [], "f71d", "M507.3 443.32l-55.88-55.88L486 329.91a16.007 16.007 0 0 0-2-20.19l-34.8-34.8c-6.21-6.21-16.35-6.28-22.63 0l-27.83 27.84L112 16.01 18.27.18C7.06-1.45-1.25 8.38.17 18.28L16 112.01l286.75 286.75-27.84 27.83c-6.25 6.25-6.25 16.38 0 22.63l34.8 34.79c5.4 5.4 13.86 6.22 20.19 2l57.52-34.58 55.88 55.88c6.25 6.25 16.38 6.25 22.63 0l41.37-41.37c6.25-6.24 6.25-16.38 0-22.62zM45.85 96.61L35.54 35.54 96.6 45.87 376.13 325.4l-50.74 50.74L45.85 96.61zm408.77 376.76l-63.11-63.12-68.44 41.86-14.21-14.21L437.9 308.87l14.21 14.21-41.85 68.44 63.11 63.11-18.75 18.74zM415.39 45.85l61.07-10.31-10.33 61.06-114.14 114.14 22.63 22.63L495.99 112l15.83-93.73c1.63-11.21-8.2-19.52-18.1-18.1L399.99 16 278.62 137.37 301.24 160 415.39 45.85zM237.07 426.58l-27.84-27.83 24.12-24.12L210.73 352l-24.12 24.12-50.74-50.74L160 301.25l-22.63-22.63-24.13 24.13-27.83-27.84c-6.25-6.25-16.38-6.25-22.63 0l-34.79 34.8c-5.4 5.4-6.22 13.86-2 20.19l34.58 57.52-55.89 55.89c-6.25 6.25-6.25 16.38 0 22.63l41.37 41.37c6.25 6.25 16.38 6.25 22.63 0l55.88-55.88 57.53 34.58a16.007 16.007 0 0 0 20.19-2l34.8-34.8c.87-.87 1.34-1.96 1.97-2.97-.48-2.73-.81-5.5-.81-8.33s.34-5.61.81-8.35c-.63-1.01-1.1-2.1-1.98-2.98zm-48.15 25.52l-68.44-41.85-63.11 63.11-18.75-18.75 63.12-63.11-41.86-68.44 14.21-14.21L203.13 437.9l-14.21 14.2z"]
  },
      Ww = {
    prefix: "fal",
    iconName: "swords-laser",
    icon: [640, 512, [], "e03d", "M472.09186,33.29631a6.83342,6.83342,0,0,1,3.86523-1.31351,4.39616,4.39616,0,0,1,2.82813,1.497,4.471,4.471,0,0,1,.11914,6.05813L382.41807,144.45835l2.33984,2.15665a47.48026,47.48026,0,0,1,15.627-2.64068,46.70058,46.70058,0,0,1,21.11718,5.24232l80.96481-88.042A36.60564,36.60564,0,0,0,477.06256.00781C476.8028.002,476.543,0,476.28131,0A38.6606,38.6606,0,0,0,450.629,9.579l-107.4648,98.70228,23.60155,21.75189ZM275.73842,260.4626l-29.71483,32.31264-27.0332-27.01567,33.49609-30.76493L230.92008,211.373l-34.57616,31.7564-14.15234-14.14215a8.00705,8.00705,0,0,0-11.31445,0L159.56268,240.2955a7.98725,7.98725,0,0,0,.002,11.30435l5.65624,5.65218-56.56833,56.5276-1.17578-1.17493a8,8,0,0,0-11.30859,0l-80.1699,80.118a54.55385,54.55385,0,0,0,0,77.19044l25.75,25.73144a54.64644,54.64644,0,0,0,77.24411-.002l80.16989-80.118a7.98608,7.98608,0,0,0,0-11.30044l56.56834-56.52761,5.6582,5.65218a8.00291,8.00291,0,0,0,11.31249.00195l11.31445-11.30825a7.98725,7.98725,0,0,0,0-11.30435l-15.3457-15.3327,28.71874-31.22748ZM96.36544,473.032a22.6584,22.6584,0,0,1-31.99022.0039l-25.75-25.73535a22.59366,22.59366,0,0,1,.002-31.96914l63.19724-63.15368,6.82813,6.82516,45.25584,45.2213,5.65429,5.65217Zm80.16989-91.41846-45.25389-45.22131,11.3125-11.3063,45.25584,45.22326Zm22.627-22.61065-45.25389-45.22326,11.31249-11.30435,45.25585,45.2213Zm22.62694-22.61066L176.53533,291.169l11.31445-11.30435,45.25389,45.2213ZM624,393.10525,411.30087,180.59831c-9.54492-9.538-25.05077-3.38818-26.71093,9.36239L189.21306,9.89521a36.62975,36.62975,0,0,0-61.205,25.386,38.72144,38.72144,0,0,0,9.51562,26.3521l245.871,269.30193.59375-.54062v22.111a15.97489,15.97489,0,0,0,4.68554,11.3024L520.99809,496.01543a54.6612,54.6612,0,0,0,77.25193,0L624,470.28593a54.538,54.538,0,0,0,0-77.18068ZM383.98838,284.13109,161.19745,40.11951a5.12086,5.12086,0,0,1,.29687-6.55582,4.71845,4.71845,0,0,1,6.14063-.06245L383.98838,232.87312ZM416.00009,345.862V230.4608l97.55855,97.4883-57.74216,57.70059ZM575.625,473.40088a22.65957,22.65957,0,0,1-31.99412.002l-65.18943-65.14444,21.77147-21.7558,81.18747,81.129Zm25.75-25.7295-5.77538,5.77123-81.18747-81.129,21.77147-21.7558,65.18943,65.14249a22.596,22.596,0,0,1,.00195,31.97109Z"]
  },
      Gw = {
    prefix: "fal",
    iconName: "synagogue",
    icon: [640, 512, [], "f69b", "M406.38 150.77a13.18 13.18 0 0 0-11.56-6.84h-37.15l-26.5-41.72c-4.88-7.66-17.44-7.67-22.31-.02l-26.51 41.73h-37.14c-4.81 0-9.25 2.62-11.56 6.84-2.31 4.19-2.12 9.3.44 13.31l17.73 27.91-17.73 27.91c-2.56 4.03-2.75 9.14-.44 13.33a13.18 13.18 0 0 0 11.56 6.84h37.15l26.5 41.72c2.44 3.83 6.59 6.12 11.16 6.12s8.72-2.28 11.16-6.11l26.51-41.73h37.14c4.81 0 9.25-2.62 11.56-6.84 2.31-4.19 2.12-9.3-.44-13.31L388.22 192l17.73-27.91c2.55-4.03 2.74-9.14.43-13.32zM320 114.47l18.71 29.45h-37.42L320 114.47zm-69.62 45.45h21.79l-10.9 17.15-10.89-17.15zm0 64.16l10.9-17.16 10.9 17.16h-21.8zM320 269.53l-18.71-29.45h37.42L320 269.53zm28.87-45.45h-57.75L270.75 192l20.38-32.08h57.75L369.25 192l-20.38 32.08zm40.75 0h-21.79l10.9-17.15 10.89 17.15zm-10.9-47l-10.9-17.16h21.8l-10.9 17.16zM313.71 320.3c-33.28 3.17-57.71 33.02-57.71 66.45V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V385.8c0-15.95 10.86-30.76 26.59-33.36C334.61 349.15 352 364.58 352 384v120c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V384c0-37.42-32.12-67.34-70.29-63.7zm318.28-52.01l-76-71.78c-6.6-6.23-17.4-6.23-24 0l-52 49.11V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4C334.15 2.34 327.07 0 320 0s-14.15 2.34-19.99 7.01l-128 102.4A32.005 32.005 0 0 0 160 134.4v111.23l-52-49.11c-6.6-6.23-17.4-6.23-24 0L8 268.3c-5.15 4.86-8 11.13-8 17.63V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V289.64l64-60.45 64 60.45V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V134.4L320 32l128 102.4V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V289.64l64-60.45 64 60.45V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V285.93c0-6.5-2.85-12.77-8.01-17.64z"]
  },
      qw = {
    prefix: "fal",
    iconName: "sync",
    icon: [512, 512, [], "f021", "M492 8h-10c-6.627 0-12 5.373-12 12v110.627C426.929 57.261 347.224 8 256 8 123.228 8 14.824 112.338 8.31 243.493 7.971 250.311 13.475 256 20.301 256h10.016c6.353 0 11.646-4.949 11.977-11.293C48.157 132.216 141.097 42 256 42c82.862 0 154.737 47.077 190.289 116H332c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-.301 248h-10.015c-6.352 0-11.647 4.949-11.977 11.293C463.841 380.158 370.546 470 256 470c-82.608 0-154.672-46.952-190.299-116H180c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H20c-6.627 0-12 5.373-12 12v160c0 6.627 5.373 12 12 12h10c6.627 0 12-5.373 12-12V381.373C85.071 454.739 164.777 504 256 504c132.773 0 241.176-104.338 247.69-235.493.339-6.818-5.165-12.507-11.991-12.507z"]
  },
      Jw = {
    prefix: "fal",
    iconName: "sync-alt",
    icon: [512, 512, [], "f2f1", "M457.373 9.387l-50.095 50.102C365.411 27.211 312.953 8 256 8 123.228 8 14.824 112.338 8.31 243.493 7.971 250.311 13.475 256 20.301 256h10.015c6.352 0 11.647-4.949 11.977-11.293C48.159 131.913 141.389 42 256 42c47.554 0 91.487 15.512 127.02 41.75l-53.615 53.622c-20.1 20.1-5.855 54.628 22.627 54.628H480c17.673 0 32-14.327 32-32V32.015c0-28.475-34.564-42.691-54.627-22.628zM480 160H352L480 32v128zm11.699 96h-10.014c-6.353 0-11.647 4.949-11.977 11.293C463.84 380.203 370.504 470 256 470c-47.525 0-91.468-15.509-127.016-41.757l53.612-53.616c20.099-20.1 5.855-54.627-22.627-54.627H32c-17.673 0-32 14.327-32 32v127.978c0 28.614 34.615 42.641 54.627 22.627l50.092-50.096C146.587 484.788 199.046 504 256 504c132.773 0 241.176-104.338 247.69-235.493.339-6.818-5.165-12.507-11.991-12.507zM32 480V352h128L32 480z"]
  },
      Kw = {
    prefix: "fal",
    iconName: "syringe",
    icon: [512, 512, [], "f48e", "M509.7 81.5L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l17 17L84.5 291.7c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l227.2-227.2 17 17c3.1 3.1 8.2 3.1 11.3 0L487 206c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4zm-84.9 96.2L197.7 404.9c-10.4 10.4-24.6 15.4-39.2 13.8l-58.5-6.5-6.5-58.5c-1.6-14.6 3.4-28.9 13.8-39.2l23.5-23.5 39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6 45.3-45.3 39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6 45.3-45.3 39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3L289 132.4l45.3-45.3 90.5 90.6z"]
  },
      Xw = {
    prefix: "fal",
    iconName: "table",
    icon: [512, 512, [], "f0ce", "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM160 448H48c-8.837 0-16-7.163-16-16v-80h128v96zm0-128H32v-96h128v96zm0-128H32V96h128v96zm160 256H192v-96h128v96zm0-128H192v-96h128v96zm0-128H192V96h128v96zm160 160v80c0 8.837-7.163 16-16 16H352v-96h128zm0-32H352v-96h128v96zm0-128H352V96h128v96z"]
  },
      _w = {
    prefix: "fal",
    iconName: "table-tennis",
    icon: [512, 512, [], "f45d", "M482.8 325.2c47.1-83.1 36.2-190.6-34.5-261.4C407.2 22.7 352.6 0 294.5 0c-105.8 0-153 63.1-219.3 129.5-49.2 49.3-49.2 129.6 0 179l20.2 20.3-83.6 72.6c-15.1 13.2-15.7 36.3-1.8 50.3l50.1 50.1c17.5 17.6 40.7 9.4 50.3-1.8l72.4-83.6c15.9 15.9 58.9 70.6 132.5 56.1 20.6 24 50.7 39.5 84.7 39.5 61.8 0 112-50.2 112-112 0-28.8-11.3-54.9-29.2-74.8zM163.4 86.5c72.5-72.7 189.8-72.7 262.3 0 58.9 59 69 147.8 32 218-56.7-34.4-124.3-12.3-154.5 40.1l-199-199 59.2-59.1zm17.8 282.9L82.8 479.3l-50.1-50.2 109.6-98.6-44.5-44.6c-31.2-31.3-35.6-79-13.9-115.4L290.4 377c-2 9.6-6.3 34.1 5.7 64.2-51.7 1.5-70.5-27.3-114.9-71.8zM400 480c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      $w = {
    prefix: "fal",
    iconName: "tablet",
    icon: [448, 512, [], "f10a", "M256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-21.3 14.3-32 32-32s32 14.3 32 32zM448 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h352c26.5 0 48 21.5 48 48zm-32 0c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V48z"]
  },
      cy = {
    prefix: "fal",
    iconName: "tablet-alt",
    icon: [448, 512, [], "f3fa", "M352 96v256H96V96h256m20-32H76c-6.6 0-12 5.4-12 12v296c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm28-64H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm16 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v416zm-192-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      ey = {
    prefix: "fal",
    iconName: "tablet-android",
    icon: [448, 512, [], "f3fb", "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm16 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v416zm-140-16H172c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12z"]
  },
      ay = {
    prefix: "fal",
    iconName: "tablet-android-alt",
    icon: [448, 512, [], "f3fc", "M352 96v256H96V96h256m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM372 64H76c-6.6 0-12 5.4-12 12v296c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-96 352H172c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h104c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"]
  },
      ny = {
    prefix: "fal",
    iconName: "tablet-rugged",
    icon: [448, 512, [], "f48f", "M439.2 164.4c5.4-2.7 8.8-8.2 8.8-14.3V73.9c0-6.1-3.4-11.6-8.8-14.3L416 48c0-26.5-21.5-48-48-48H80C53.5 0 32 21.5 32 48L8.8 59.6C3.4 62.3 0 67.8 0 73.9v76.2c0 6.1 3.4 11.6 8.8 14.3L32 176v16L8.8 203.6c-5.4 2.7-8.8 8.2-8.8 14.3v76.2c0 6.1 3.4 11.6 8.8 14.3L32 320v16L8.8 347.6c-5.4 2.7-8.8 8.2-8.8 14.3v76.2c0 6.1 3.4 11.6 8.8 14.3L32 464c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48l23.2-11.6c5.4-2.7 8.8-8.2 8.8-14.3v-76.2c0-6.1-3.4-11.6-8.8-14.3L416 336v-16l23.2-11.6c5.4-2.7 8.8-8.2 8.8-14.3v-76.2c0-6.1-3.4-11.6-8.8-14.3L416 192v-16l23.2-11.6zm-37.5 56.2l14.3 7.2v56.4l-14.3 7.2-17.7 8.8v55.6l17.7 8.8 14.3 7.2v56.4l-14.3 7.2-17.7 8.8V464c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-19.8l-17.7-8.8-14.3-7.2v-56.4l14.3-7.2 17.7-8.8v-55.6l-17.7-8.8-14.3-7.2v-56.4l14.3-7.2 17.7-8.8v-55.6l-17.7-8.8-14.3-7.2V83.8l14.3-7.2L64 67.8V48c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v19.8l17.7 8.8 14.3 7.2v56.4l-14.3 7.2-17.7 8.8v55.6l17.7 8.8zM336 64H112c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zm-16 352H128V96h192v320z"]
  },
      ty = {
    prefix: "fal",
    iconName: "tablets",
    icon: [640, 512, [], "f490", "M480 0c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160S568.4 0 480 0zm0 288c-70.7 0-128-57.3-128-128 0-29.6 10.4-56.4 27.3-78.1l178.9 178.9C536.4 277.6 509.6 288 480 288zm100.7-49.9L401.9 59.3C423.6 42.4 450.4 32 480 32c70.7 0 128 57.3 128 128 0 29.6-10.4 56.4-27.3 78.1zM160 192C71.6 192 0 263.6 0 352s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 288c-65.2 0-118.4-48.9-126.4-112h252.8c-8 63.1-61.2 112-126.4 112zM33.6 336c8-63.1 61.2-112 126.4-112s118.4 48.9 126.4 112H33.6z"]
  },
      ry = {
    prefix: "fal",
    iconName: "tachometer",
    icon: [576, 512, [], "f0e4", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm221.5 416l-442.8.68C44 409.75 32 365.26 32 320 32 178.84 146.84 64 288 64s256 114.84 256 256c0 45.26-12 89.75-34.5 128zM365.22 128.88c-8.19-2.78-17.44 1.55-20.34 9.89l-51.83 149.74c-1.69-.13-3.31-.51-5.04-.51-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64c0-22.25-11.38-41.82-28.62-53.29l51.74-149.48c2.87-8.34-1.54-17.46-9.91-20.35zM288 384c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"]
  },
      iy = {
    prefix: "fal",
    iconName: "tachometer-alt",
    icon: [576, 512, [], "f3fd", "M288 152c13.26 0 24-10.74 24-24s-10.74-24-24-24-24 10.74-24 24 10.74 24 24 24zm-136 8c-13.26 0-24 10.74-24 24s10.74 24 24 24 24-10.74 24-24-10.74-24-24-24zm272 0c-13.26 0-24 10.74-24 24s10.74 24 24 24 24-10.74 24-24-10.74-24-24-24zm56 136c-13.26 0-24 10.74-24 24s10.74 24 24 24 24-10.74 24-24-10.74-24-24-24zM288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm221.5 416l-442.8.68C44 409.75 32 365.26 32 320 32 178.84 146.84 64 288 64s256 114.84 256 256c0 45.26-12 89.75-34.5 128zM96 296c-13.26 0-24 10.74-24 24s10.74 24 24 24 24-10.74 24-24-10.74-24-24-24zm269.22-167.12c-8.19-2.78-17.44 1.55-20.34 9.89l-51.83 149.74c-1.69-.13-3.31-.51-5.04-.51-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64c0-22.25-11.38-41.82-28.62-53.29l51.74-149.48c2.87-8.34-1.54-17.46-9.91-20.35zM288 384c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"]
  },
      oy = {
    prefix: "fal",
    iconName: "tachometer-alt-average",
    icon: [576, 512, [], "f624", "M304 290.26V128c0-8.84-7.16-16-16-16s-16 7.16-16 16v162.26c-27.56 7.14-48 31.95-48 61.74 0 35.35 28.65 64 64 64s64-28.65 64-64c0-29.79-20.44-54.6-48-61.74zM288 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm-168-64c0 13.26-10.74 24-24 24s-24-10.74-24-24 10.74-24 24-24 24 10.74 24 24zm56-136c0 13.26-10.74 24-24 24s-24-10.74-24-24 10.74-24 24-24 24 10.74 24 24zm272 0c0 13.26-10.74 24-24 24s-24-10.74-24-24 10.74-24 24-24 24 10.74 24 24zM288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm221.5 416l-442.8.68C44 409.75 32 365.26 32 320 32 178.84 146.84 64 288 64s256 114.84 256 256c0 45.26-12 89.75-34.5 128zM504 320c0 13.26-10.74 24-24 24s-24-10.74-24-24 10.74-24 24-24 24 10.74 24 24z"]
  },
      ly = {
    prefix: "fal",
    iconName: "tachometer-alt-fast",
    icon: [576, 512, [], "f625", "M120 320c0 13.26-10.74 24-24 24s-24-10.74-24-24 10.74-24 24-24 24 10.74 24 24zm168-168c13.26 0 24-10.74 24-24s-10.74-24-24-24-24 10.74-24 24 10.74 24 24 24zm-136 8c-13.26 0-24 10.74-24 24s10.74 24 24 24 24-10.74 24-24-10.74-24-24-24zm282.06 11.56c6.88 5.56 7.94 15.64 2.38 22.5l-97.14 120C347.18 324.7 352 337.74 352 352c0 35.35-28.65 64-64 64s-64-28.65-64-64 28.65-64 64-64c9.47 0 18.38 2.18 26.47 5.88l97.09-119.94c5.56-6.88 15.6-7.92 22.5-2.38zM320 352c0-17.67-14.33-32-32-32s-32 14.33-32 32 14.33 32 32 32 32-14.33 32-32zm160-56c-13.26 0-24 10.74-24 24s10.74 24 24 24 24-10.74 24-24-10.74-24-24-24zm96 24c0 52.8-14.25 102.26-39.06 144.8-5.61 9.62-16.3 15.2-27.44 15.2h-443c-11.14 0-21.83-5.58-27.44-15.2C14.25 422.26 0 372.8 0 320 0 160.94 128.94 32 288 32s288 128.94 288 288zm-32 0c0-141.16-114.84-256-256-256S32 178.84 32 320c0 45.26 12 89.75 34.7 128.68l442.8-.68C532 409.75 544 365.26 544 320z"]
  },
      fy = {
    prefix: "fal",
    iconName: "tachometer-alt-fastest",
    icon: [576, 512, [], "f626", "M120 320c0 13.26-10.74 24-24 24s-24-10.74-24-24 10.74-24 24-24 24 10.74 24 24zm168-168c13.26 0 24-10.74 24-24s-10.74-24-24-24-24 10.74-24 24 10.74 24 24 24zm136 56c13.26 0 24-10.74 24-24s-10.74-24-24-24-24 10.74-24 24 10.74 24 24 24zm71.78 109.38c1.47 8.72-4.44 16.95-13.16 18.41l-131.2 21.87C348.53 390.3 321.41 416 288 416c-35.35 0-64-28.65-64-64s28.65-64 64-64c26.09 0 48.44 15.66 58.41 38.05l130.97-21.83c8.53-1.49 16.93 4.44 18.4 13.16zM320 352c0-17.67-14.33-32-32-32s-32 14.33-32 32 14.33 32 32 32 32-14.33 32-32zM152 160c-13.26 0-24 10.74-24 24s10.74 24 24 24 24-10.74 24-24-10.74-24-24-24zm424 160c0 52.8-14.25 102.26-39.06 144.8-5.61 9.62-16.3 15.2-27.44 15.2h-443c-11.14 0-21.83-5.58-27.44-15.2C14.25 422.26 0 372.8 0 320 0 160.94 128.94 32 288 32s288 128.94 288 288zm-32 0c0-141.16-114.84-256-256-256S32 178.84 32 320c0 45.26 12 89.75 34.7 128.68l442.8-.68C532 409.75 544 365.26 544 320z"]
  },
      sy = {
    prefix: "fal",
    iconName: "tachometer-alt-slow",
    icon: [576, 512, [], "f627", "M120 320c0 13.26-10.74 24-24 24s-24-10.74-24-24 10.74-24 24-24 24 10.74 24 24zm168-168c13.26 0 24-10.74 24-24s-10.74-24-24-24-24 10.74-24 24 10.74 24 24 24zm64 200c0 35.35-28.65 64-64 64s-64-28.65-64-64c0-14.26 4.82-27.3 12.71-37.94l-97.14-120c-5.56-6.86-4.5-16.94 2.38-22.5 6.88-5.55 16.97-4.5 22.5 2.38l97.09 119.94c8.09-3.69 17-5.88 26.47-5.88 35.34 0 63.99 28.65 63.99 64zm-32 0c0-17.67-14.33-32-32-32s-32 14.33-32 32 14.33 32 32 32 32-14.33 32-32zm256-32c0 52.8-14.25 102.26-39.06 144.8-5.61 9.62-16.3 15.2-27.44 15.2h-443c-11.14 0-21.83-5.58-27.44-15.2C14.25 422.26 0 372.8 0 320 0 160.94 128.94 32 288 32s288 128.94 288 288zm-32 0c0-141.16-114.84-256-256-256S32 178.84 32 320c0 45.26 12 89.75 34.7 128.68l442.8-.68C532 409.75 544 365.26 544 320zM424 160c-13.26 0-24 10.74-24 24s10.74 24 24 24 24-10.74 24-24-10.74-24-24-24zm56 136c-13.26 0-24 10.74-24 24s10.74 24 24 24 24-10.74 24-24-10.74-24-24-24z"]
  },
      uy = {
    prefix: "fal",
    iconName: "tachometer-alt-slowest",
    icon: [576, 512, [], "f628", "M128 184c0-13.26 10.74-24 24-24s24 10.74 24 24-10.74 24-24 24-24-10.74-24-24zm160-32c13.26 0 24-10.74 24-24s-10.74-24-24-24-24 10.74-24 24 10.74 24 24 24zm288 168c0 52.8-14.25 102.26-39.06 144.8-5.61 9.62-16.3 15.2-27.44 15.2h-443c-11.14 0-21.83-5.58-27.44-15.2C14.25 422.26 0 372.8 0 320 0 160.94 128.94 32 288 32s288 128.94 288 288zm-32 0c0-141.16-114.84-256-256-256S32 178.84 32 320c0 45.26 12 89.75 34.7 128.68l442.8-.68C532 409.75 544 365.26 544 320zm-192 32c0 35.35-28.65 64-64 64-33.41 0-60.53-25.7-63.43-58.35l-131.2-21.87c-8.72-1.45-14.62-9.69-13.16-18.41s9.88-14.64 18.41-13.16l130.97 21.83C239.56 303.66 261.91 288 288 288c35.35 0 64 28.65 64 64zm-32 0c0-17.67-14.33-32-32-32s-32 14.33-32 32 14.33 32 32 32 32-14.33 32-32zm160-56c-13.26 0-24 10.74-24 24s10.74 24 24 24 24-10.74 24-24-10.74-24-24-24zm-56-136c-13.26 0-24 10.74-24 24s10.74 24 24 24 24-10.74 24-24-10.74-24-24-24z"]
  },
      hy = {
    prefix: "fal",
    iconName: "tachometer-average",
    icon: [576, 512, [], "f629", "M304 290.26V128c0-8.84-7.16-16-16-16s-16 7.16-16 16v162.26c-27.56 7.14-48 31.95-48 61.74 0 35.35 28.65 64 64 64s64-28.65 64-64c0-29.79-20.44-54.6-48-61.74zM288 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-352C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm221.5 416l-442.8.68C44 409.75 32 365.26 32 320 32 178.84 146.84 64 288 64s256 114.84 256 256c0 45.26-12 89.75-34.5 128z"]
  },
      my = {
    prefix: "fal",
    iconName: "tachometer-fast",
    icon: [576, 512, [], "f62a", "M411.56 173.94l-97.09 119.94c-8.09-3.69-17-5.88-26.47-5.88-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64c0-14.26-4.82-27.3-12.71-37.94l97.14-120c5.56-6.86 4.5-16.94-2.38-22.5-6.89-5.54-16.93-4.5-22.49 2.38zM288 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-352C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm221.5 416l-442.8.68C44 409.75 32 365.26 32 320 32 178.84 146.84 64 288 64s256 114.84 256 256c0 45.26-12 89.75-34.5 128z"]
  },
      vy = {
    prefix: "fal",
    iconName: "tachometer-fastest",
    icon: [576, 512, [], "f62b", "M477.38 304.22l-130.97 21.83C336.44 303.66 314.09 288 288 288c-35.35 0-64 28.65-64 64s28.65 64 64 64c33.41 0 60.53-25.7 63.43-58.35l131.2-21.87c8.72-1.45 14.62-9.69 13.16-18.41s-9.88-14.64-18.41-13.15zM288 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-352C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm221.5 416l-442.8.68C44 409.75 32 365.26 32 320 32 178.84 146.84 64 288 64s256 114.84 256 256c0 45.26-12 89.75-34.5 128z"]
  },
      dy = {
    prefix: "fal",
    iconName: "tachometer-slow",
    icon: [576, 512, [], "f62c", "M288 288c-9.47 0-18.38 2.18-26.47 5.88l-97.09-119.94c-5.53-6.88-15.62-7.92-22.5-2.38-6.88 5.56-7.94 15.64-2.38 22.5l97.14 120C228.82 324.7 224 337.74 224 352c0 35.35 28.65 64 64 64s64-28.65 64-64-28.65-64-64-64zm0 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-352C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm221.5 416l-442.8.68C44 409.75 32 365.26 32 320 32 178.84 146.84 64 288 64s256 114.84 256 256c0 45.26-12 89.75-34.5 128z"]
  },
      My = {
    prefix: "fal",
    iconName: "tachometer-slowest",
    icon: [576, 512, [], "f62d", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm221.5 416l-442.8.68C44 409.75 32 365.26 32 320 32 178.84 146.84 64 288 64s256 114.84 256 256c0 45.26-12 89.75-34.5 128zM288 288c-26.09 0-48.44 15.66-58.41 38.05L98.62 304.22c-8.53-1.48-16.94 4.44-18.41 13.16s4.44 16.95 13.16 18.41l131.2 21.87C227.47 390.3 254.59 416 288 416c35.35 0 64-28.65 64-64s-28.65-64-64-64zm0 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      py = {
    prefix: "fal",
    iconName: "taco",
    icon: [512, 512, [], "f826", "M511.47 407.64a309.9 309.9 0 0 0-14.63-62.14c7.7-19.83 1.06-27.47 7.5-49.89 5.32-18.45 12.55-43.48 3-69.58-10.11-27.73-33.39-41.74-48.79-51-3.35-2-8.64-5.19-11.12-7.13-.87-2.68-2.43-10.2-3.43-14.9-4.11-19.32-9.73-45.75-31.76-63.74-20.51-16.74-44.58-16.74-52.49-16.74-11.43 0-21.5 1.41-29.26 1.34C316.54 62.7 293.75 32 257.42 32c-37.66 0-64.67 32.84-75.88 41.86-8.22.07-17.45-1.35-29.26-1.35h-.11c-8 0-32 .08-52.38 16.75-22 18-27.66 44.41-31.76 63.71-1 4.47-2.44 11.52-3.66 15-2.57 2-7.64 5-10.86 6.94-15.45 9.33-38.73 23.34-48.85 51.09-9.54 26.06-2.32 51.08 3 69.35 6.47 22.56-.11 30.37 7.55 50.09a310.2 310.2 0 0 0-14.68 62.2C-3.86 442.58 21 480 60.49 480h391c39.51 0 64.38-37.34 59.98-72.36zm-60 40.36h-391c-17.11 0-30.62-17.19-28.21-36.38C47.87 287.47 142.09 192 256 192s208.13 95.47 223.72 219.62c2.41 19.19-11.1 36.38-28.21 36.38zm21-156c-46.43-79.73-127-132-216.52-132S85.92 212.27 39.49 292c-3.65-15.68-11.61-36.31-4.77-55C41 219.83 56.38 210.56 70 202.38c22.08-13.26 23.44-14.83 29.35-42.75 3.46-16.27 7.39-34.73 20.69-45.58 9.49-7.75 20.91-9.54 32.26-9.54 39.31 0 35.55 8 60.68-16C231.39 70.81 245.37 64 257.42 64c15.25 0 27.42 10.9 41.62 24.51 25.13 24.08 21.36 16 60.69 16 11.34 0 22.77 1.79 32.26 9.53 13.3 10.86 17.23 29.31 20.69 45.58 5.91 27.91 7.25 29.48 29.34 42.75 13.6 8.19 29 17.46 35.26 34.61 5.72 15.58 1.56 28.02-4.76 55.02zM112 352a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm64-64a16 16 0 1 0 16 16 16 16 0 0 0-16-16z"]
  },
      zy = {
    prefix: "fal",
    iconName: "tag",
    icon: [512, 512, [], "f02b", "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.745 18.745 49.137 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zm-22.627 45.255L271.196 475.314c-6.243 6.243-16.375 6.253-22.627 0L36.686 263.431A15.895 15.895 0 0 1 32 252.117V48c0-8.822 7.178-16 16-16h204.118c4.274 0 8.292 1.664 11.314 4.686l211.882 211.882c6.238 6.239 6.238 16.39 0 22.628zM144 124c11.028 0 20 8.972 20 20s-8.972 20-20 20-20-8.972-20-20 8.972-20 20-20m0-28c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"]
  },
      Cy = {
    prefix: "fal",
    iconName: "tags",
    icon: [640, 512, [], "f02c", "M625.941 293.823L421.823 497.941c-18.746 18.746-49.138 18.745-67.882 0l-1.775-1.775 22.627-22.627 1.775 1.775c6.253 6.253 16.384 6.243 22.627 0l204.118-204.118c6.238-6.239 6.238-16.389 0-22.627L391.431 36.686A15.895 15.895 0 0 0 380.117 32h-19.549l-32-32h51.549a48 48 0 0 1 33.941 14.059L625.94 225.941c18.746 18.745 18.746 49.137.001 67.882zM252.118 32H48c-8.822 0-16 7.178-16 16v204.118c0 4.274 1.664 8.292 4.686 11.314l211.882 211.882c6.253 6.253 16.384 6.243 22.627 0l204.118-204.118c6.238-6.239 6.238-16.389 0-22.627L263.431 36.686A15.895 15.895 0 0 0 252.118 32m0-32a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.746 18.746-49.138 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118V48C0 21.49 21.49 0 48 0h204.118zM144 124c-11.028 0-20 8.972-20 20s8.972 20 20 20 20-8.972 20-20-8.972-20-20-20m0-28c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.49-48 48-48z"]
  },
      Ly = {
    prefix: "fal",
    iconName: "tally",
    icon: [640, 512, [], "f69c", "M634.79 149.58c-1.33-4.21-5.83-6.54-10.04-5.21L528 174.49V40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v144.45l-96 29.88V40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v184.3l-96 29.88V40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v224.15l-96 29.88V40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v263.99L5.58 337.12a8.005 8.005 0 0 0-5.21 10.04l4.84 15.25c1.33 4.21 5.83 6.54 10.04 5.21L112 337.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V327.54l96-29.88V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V287.7l96-29.88V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V247.85l96-29.88V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V208.01l106.42-33.13a8.005 8.005 0 0 0 5.21-10.04l-4.84-15.26z"]
  },
      Ay = {
    prefix: "fal",
    iconName: "tanakh",
    icon: [448, 512, [], "f827", "M368 0H24A23.94 23.94 0 0 0 0 24v368a24.1 24.1 0 0 0 14.9 22.2c3.6 16.1 4.4 45.6.4 65.8H12a12 12 0 0 0-12 12v8a12 12 0 0 0 12 12h372a64 64 0 0 0 64-64V80a80 80 0 0 0-80-80zm16 480H43.7a228.6 228.6 0 0 0 0-64H384a32 32 0 0 1 0 64zm32-87.12a63.33 63.33 0 0 0-32-8.88H32V32h336a48 48 0 0 1 48 48zM314.58 208l27.7-46.32a20 20 0 0 0-17.19-30.26h-56.35L241 85.16c-3.59-6.07-9.87-10.38-17-9.68a20 20 0 0 0-17.22 9.8l-27.6 46.16h-56.3a20.14 20.14 0 0 0-17.5 10.15 19.68 19.68 0 0 0 .21 20L133.42 208l-27.7 46.32a20 20 0 0 0 17.19 30.26h56.35L207 330.84a19.64 19.64 0 0 0 16.94 9.68h.06a20 20 0 0 0 17.22-9.8l27.6-46.16h56.3a20.14 20.14 0 0 0 17.5-10.15 19.68 19.68 0 0 0-.21-20zm3.48-52.58l-17.47 29.21-17.49-29.19zM224 103.38l16.8 28.06h-33.62zm-94 52.06h34.91l-17.51 29.17zm0 105.12l17.47-29.21 17.49 29.21zm94 52.06l-16.8-28.06h33.59zm31.15-52.06h-62.28L161.39 208l31.43-52.54h62.31L286.61 208zm28 0l17.45-29.17 17.46 29.17z"]
  },
      Ny = {
    prefix: "fal",
    iconName: "tape",
    icon: [640, 512, [], "f4db", "M632 448H338.9C404.2 408.8 448 337.6 448 256c0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h408c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM32 256c0-105.9 86.1-192 192-192s192 86.1 192 192-86.1 192-192 192S32 361.9 32 256zm192-96c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 160c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"]
  },
      gy = {
    prefix: "fal",
    iconName: "tasks",
    icon: [512, 512, [], "f0ae", "M145.35 207a8 8 0 0 0-11.35 0l-71 71-39-39a8 8 0 0 0-11.31 0L1.35 250.34a8 8 0 0 0 0 11.32l56 56a8 8 0 0 0 11.31 0l88-88a8 8 0 0 0 0-11.32zM62.93 384c-17.67 0-32.4 14.33-32.4 32s14.73 32 32.4 32a32 32 0 0 0 0-64zm82.42-337A8 8 0 0 0 134 47l-71 71-39-39a8 8 0 0 0-11.31 0L1.35 90.34a8 8 0 0 0 0 11.32l56 56a8 8 0 0 0 11.31 0l88-88a8 8 0 0 0 0-11.32zM503 400H199a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h304a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm0-320H199a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h304a8 8 0 0 0 8-8V88a8 8 0 0 0-8-8zm0 160H199a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h304a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      Hy = {
    prefix: "fal",
    iconName: "tasks-alt",
    icon: [512, 512, [], "f828", "M488 191H24c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h464c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24zm-360 96H32v-64h96v64zm352 0H160v-64h320v64zm8-256H24C10.7 31 0 41.7 0 55v80c0 13.3 10.7 24 24 24h464c13.3 0 24-10.7 24-24V55c0-13.3-10.7-24-24-24zm-168 96H32V63h288v64zm160 0H352V63h128v64zm8 224H24c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h464c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24zm-232 96H32v-64h224v64zm224 0H288v-64h192v64z"]
  },
      Vy = {
    prefix: "fal",
    iconName: "taxi",
    icon: [512, 512, [], "f1ba", "M96 288c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm320 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-88 32H184c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h144c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm119.11-90.4l-13.32-68.79C426.53 123.25 393.5 96 355.25 96H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-3.25c-38.25 0-71.28 27.25-78.53 64.8L64.9 229.6C27.23 242.58 0 277.93 0 320v32c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h48c17.67 0 32-14.33 32-32v-32h224v32c0 17.67 14.33 32 32 32h48c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.49 32-55.12v-32c0-42.07-27.23-77.42-64.89-90.4zM192 64h128v32H192V64zm-82.34 102.88C114 144.34 133.81 128 156.75 128h198.5c22.94 0 42.75 16.34 47.09 38.89L413.4 224H98.6l11.06-57.12zM112 448H64v-32h48v32zm336 0h-48v-32h48v32zm32-96c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32v-32c0-35.29 28.71-64 64-64h320c35.29 0 64 28.71 64 64v32z"]
  },
      xy = {
    prefix: "fal",
    iconName: "teeth",
    icon: [640, 512, [], "f62e", "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zm64 416c0 35.29-28.71 64-64 64H96c-35.29 0-64-28.71-64-64V288h34.5c-1.37 4.25-2.5 8.62-2.5 13.33v53.33c0 39.7 32.3 72 72 72 22.7 0 42.73-10.77 55.94-27.23C206.53 419.08 229.71 432 256 432c26.26 0 49.4-12.89 64-32.49 14.6 19.6 37.74 32.49 64 32.49 26.29 0 49.47-12.92 64.06-32.57 13.21 16.46 33.24 27.23 55.94 27.23 39.7 0 72-32.3 72-72v-53.33c0-4.71-1.13-9.09-2.5-13.33H608v128zM109.33 288h53.33c7.36 0 13.33 5.97 13.33 13.33v53.34c0 22.09-17.91 40-40 40s-40-17.91-40-40v-53.33c.01-7.37 5.98-13.34 13.34-13.34zM96 242.67v-53.33c0-22.09 17.91-40 40-40s40 17.91 40 40v53.33c0 7.36-5.97 13.33-13.33 13.33h-53.33c-7.37 0-13.34-5.97-13.34-13.33zM221.71 288h68.57c7.57 0 13.71 6.14 13.71 13.71V352c0 26.51-21.49 48-48 48s-48-21.49-48-48v-50.29c.01-7.57 6.15-13.71 13.72-13.71zM208 242.29v-75.42c0-26.51 21.49-48 48-48s48 21.49 48 48v75.43c0 7.57-6.14 13.71-13.71 13.71h-68.57c-7.58-.01-13.72-6.15-13.72-13.72zM349.71 288h68.57c7.57 0 13.71 6.14 13.71 13.71V352c0 26.51-21.49 48-48 48s-48-21.49-48-48v-50.29c.01-7.57 6.15-13.71 13.72-13.71zM336 242.29v-75.43c0-26.51 21.49-48 48-48s48 21.49 48 48v75.42c0 7.57-6.14 13.71-13.71 13.71h-68.57c-7.58.01-13.72-6.13-13.72-13.7zm208 .38c0 7.36-5.97 13.33-13.33 13.33h-53.33c-7.36 0-13.33-5.97-13.33-13.33v-53.33c0-22.09 17.91-40 40-40s40 17.91 40 40v53.33zM477.33 288h53.33c7.36 0 13.33 5.97 13.33 13.33v53.33c0 22.09-17.91 40-40 40s-40-17.91-40-40v-53.33c.01-7.36 5.98-13.33 13.34-13.33zM608 256h-34.5c1.37-4.25 2.5-8.62 2.5-13.33v-53.33c0-39.7-32.3-72-72-72-17.9 0-34.1 6.81-46.71 17.66-12.35-28.28-40.52-48.14-73.29-48.14-26.26 0-49.4 12.89-64 32.49-14.6-19.6-37.74-32.49-64-32.49-32.78 0-60.95 19.86-73.29 48.14-12.61-10.85-28.8-17.66-46.71-17.66-39.7 0-72 32.3-72 72v53.33c0 4.71 1.13 9.09 2.5 13.33H32V96c0-35.29 28.71-64 64-64h448c35.29 0 64 28.71 64 64v160z"]
  },
      wy = {
    prefix: "fal",
    iconName: "teeth-open",
    icon: [640, 512, [], "f62f", "M576 304H64c-35.34 0-64 28.65-64 64v48c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-48c0-35.35-28.66-64-64-64zm-112 64v-18.67c0-7.36 5.97-13.33 13.33-13.33h53.33c7.36 0 13.33 5.97 13.33 13.33v21.33c0 22.09-17.91 40-40 40s-40-17.91-40-40V368zm-128-18.29c0-7.57 6.14-13.71 13.71-13.71h68.57c7.57 0 13.71 6.14 13.71 13.71V368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-18.29zm-128 0c0-7.57 6.14-13.71 13.71-13.71h68.57c7.57 0 13.71 6.14 13.71 13.71V368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-18.29zm-112-.38c0-7.36 5.97-13.33 13.33-13.33h53.33c7.36 0 13.33 5.97 13.33 13.33v21.34c0 22.09-17.91 40-40 40s-40-17.91-40-40v-21.34zM608 416c0 35.29-28.71 64-64 64H96c-35.29 0-64-28.71-64-64v-48c0-17.64 14.36-32 32-32h2.23c-1.32 4.24-2.23 8.66-2.23 13.33v21.33c0 39.7 32.3 72 72 72 22.7 0 42.73-10.77 55.94-27.23C206.53 435.08 229.71 448 256 448c26.26 0 49.4-12.89 64-32.49 14.6 19.6 37.74 32.49 64 32.49 26.29 0 49.47-12.92 64.06-32.57 13.21 16.46 33.24 27.23 55.94 27.23 39.7 0 72-32.3 72-72v-21.33c0-4.67-.91-9.09-2.23-13.33H576c17.64 0 32 14.36 32 32v48zM544 0H96C42.98 0 0 42.98 0 96v80c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM176 194.67c0 7.36-5.97 13.33-13.33 13.33h-53.33c-7.36 0-13.33-5.97-13.33-13.33v-21.33c0-22.09 17.91-40 40-40s40 17.91 40 40v21.33zm128-.38c0 7.57-6.14 13.71-13.71 13.71h-68.57c-7.57 0-13.71-6.14-13.71-13.71v-43.43c0-26.51 21.49-48 48-48s48 21.49 48 48v43.43zm128 0c0 7.57-6.14 13.71-13.71 13.71h-68.57c-7.57 0-13.71-6.14-13.71-13.71v-43.43c0-26.51 21.49-48 48-48s48 21.49 48 48v43.43zm112 .38c0 7.36-5.97 13.33-13.33 13.33h-53.33c-7.36 0-13.33-5.97-13.33-13.33v-21.33c0-22.09 17.91-40 40-40s40 17.91 40 40v21.33zM608 176c0 17.64-14.36 32-32 32h-2.23c1.32-4.24 2.23-8.66 2.23-13.33v-21.33c0-39.7-32.3-72-72-72-17.84 0-34.19 6.52-46.78 17.31C444.8 90.53 416.66 70.86 384 70.86c-26.14 0-49.39 12.6-64 32.05-14.61-19.45-37.86-32.05-64-32.05-32.66 0-60.8 19.67-73.22 47.78-12.59-10.79-28.94-17.31-46.78-17.31-39.7 0-72 32.3-72 72v21.33c0 4.67.91 9.09 2.23 13.33H64c-17.64 0-32-14.36-32-32V96c0-35.29 28.71-64 64-64h448c35.29 0 64 28.71 64 64v80z"]
  },
      yy = {
    prefix: "fal",
    iconName: "telescope",
    icon: [640, 512, [], "e03e", "M637.55438,197.1457,564.08568,19.76077A31.99673,31.99673,0,0,0,522.27907,2.44239L413.69712,47.4229c-15.24413,6.31446-22.5078,23.01956-17.96483,38.502L75.09384,241.41332c-8.76561,4.25-13.07225,13.584-9.85155,21.35744l8.74413,21.1094L9.881,310.43487a16.00153,16.00153,0,0,0-8.66015,20.90432l20.05663,48.42192a15.99879,15.99879,0,0,0,20.90428,8.66016l64.10542-26.55471,8.74218,21.10744c4.05469,9.79493,15.416,10.44337,22.06444,8.13868l133.89834-46.45121c1.28125,1.543,2.877,2.77344,4.291,4.19336L224.416,501.46826a8.0008,8.0008,0,0,0,7.58984,10.53126h16.84569a8.0008,8.0008,0,0,0,7.58984-5.47071l47-140.97865c12.43749,3.4336,21.67772,3.08789,33.11521-.00586l47.00192,140.98451a8.0008,8.0008,0,0,0,7.58983,5.47071H407.994a8.00079,8.00079,0,0,0,7.58983-10.53126l-50.67965-152.047a63.91267,63.91267,0,0,0,18.94335-43.91215l90.52728-31.40628c6.7207,8.53321,21.11717,16.53517,37.28317,9.832l108.58391-44.97856A31.999,31.999,0,0,0,637.55438,197.1457ZM44.71691,352.73374,36.90637,333.8763l49.32418-20.43166,7.81055,18.85744Zm275.283-16.73439a32,32,0,1,1,32-32A32.03165,32.03165,0,0,1,319.99992,335.99935Zm56.32027-61.75006a63.69444,63.69444,0,0,0-119.14835,41.334L138.76372,356.66148,100.63094,264.593,407.39829,115.83117l53.46481,129.088Zm123.09171-19.877L425.9432,76.98739l108.58-44.97856,73.4687,177.383Z"]
  },
      by = {
    prefix: "fal",
    iconName: "temperature-down",
    icon: [512, 512, [], "e03f", "M160,354.91V304a16,16,0,1,0-32,0v50.91a48,48,0,1,0,32,0ZM224,80A80,80,0,1,0,64,80V321.91a112,112,0,1,0,160,0ZM144,480A79.87,79.87,0,0,1,96,336.2V80a48,48,0,1,1,96,0V336.2A79.87,79.87,0,0,1,144,480ZM492.53,377.17l-5.62-5.69a12,12,0,0,0-16.91-.07l-54,52.73V40a8,8,0,0,0-8-8H392a8,8,0,0,0-8,8V423.92l-53.94-52.36a12,12,0,0,0-16.93,0l-5.63,5.67a12,12,0,0,0,0,17l84.06,82.25a11.91,11.91,0,0,0,16.87,0l84-82.31a12,12,0,0,0,.09-17Z"]
  },
      Sy = {
    prefix: "fal",
    iconName: "temperature-frigid",
    icon: [512, 512, [], "f768", "M416 354.9V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1zm64-33V80c0-44.1-35.9-80-80-80s-80 35.9-80 80v241.9c-20.3 20.8-32 48.9-32 78.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-29.2-11.7-57.4-32-78.1zM400 480c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V80c0-26.5 21.5-48 48-48s48 21.5 48 48v256.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zM277.1 326c3.4-5.6 6.8-11.1 10.9-16.2v-14.2L222.9 256l65.1-39.5v-37.1L208 228v-93.3L253.7 89c3.1-3.1 3.1-8.2 0-11.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0l-23 23V40c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v49.4l-23-23c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l45.7 45.7V228l-77.7-46.5-16.1-62.4c-1.1-4.3-5.3-6.8-9.4-5.7l-14.9 4.1c-4.1 1.1-6.6 5.5-5.5 9.8l8.1 31.5-41.2-24.7c-3.7-2.2-8.4-.9-10.5 2.9l-8 13.9c-2.1 3.8-.9 8.7 2.8 10.9L45 186.5 14.8 195c-4.1 1.1-6.6 5.5-5.5 9.8l4 15.5c1.1 4.3 5.3 6.8 9.4 5.7l60.2-16.7 78.2 46.8-78.2 46.8-60.2-16.7c-4.1-1.1-8.3 1.4-9.4 5.7l-4 15.5c-1.1 4.3 1.3 8.7 5.5 9.8l30.3 8.4-41.2 24.5c-3.7 2.2-5 7.1-2.8 10.9l7.7 13.9c2.1 3.8 6.9 5.1 10.5 2.9l41.2-24.7-8.1 31.5c-1.1 4.3 1.3 8.7 5.5 9.8l14.9 4.1c4.1 1.1 8.3-1.4 9.4-5.7l16.1-62.4 77.7-46.5v93.3L130.3 423c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l23-23V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-49.4l23 23c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3L208 377.4v-93.3l69.1 41.9z"]
  },
      Ty = {
    prefix: "fal",
    iconName: "temperature-high",
    icon: [384, 512, [], "f769", "M320 0c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm0 96c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM192 80c0-44.1-35.9-80-80-80S32 35.9 32 80v241.9C11.7 342.6 0 370.8 0 400c0 61.8 50.2 112 112 112s112-50.2 112-112c0-29.2-11.7-57.4-32-78.1V80zm-80 400c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V80c0-26.5 21.5-48 48-48s48 21.5 48 48v256.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v274.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"]
  },
      Dy = {
    prefix: "fal",
    iconName: "temperature-hot",
    icon: [576, 512, [], "f76a", "M128 240c0 52.9 43.1 96 96 96s96-43.1 96-96-43.1-96-96-96-96 43.1-96 96zm160 0c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64 64 28.7 64 64zm192 114.9V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v274.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1zm64-33V80c0-44.1-35.9-80-80-80s-80 35.9-80 80v241.9c-20.3 20.8-32 48.9-32 78.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-29.2-11.7-57.4-32-78.1zM464 480c-44.1 0-80-35.9-80-80 0-25.5 12.3-48.9 32-63.8V80c0-26.5 21.5-48 48-48s48 21.5 48 48v256.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zM263.9 359.6L224 419.2l-39.9-59.7c-3.6-5.4-10-8.2-16.4-6.8l-70.4 14 13.9-70.4c1.3-6.3-1.4-12.8-6.8-16.4L44.8 240l59.7-39.9c5.4-3.6 8-10.1 6.8-16.4l-13.9-70.4 70.4 14c6.4 1.3 12.8-1.4 16.4-6.8L224 60.8l39.9 59.7c3.6 5.4 9.9 8.1 16.4 6.8L352 113V80.4l-67.4 13.4-47.3-70.7c-6-8.9-20.6-8.9-26.6 0l-47.3 70.7-83.3-16.6c-5.3-1.1-10.7.6-14.4 4.4-3.8 3.8-5.4 9.2-4.4 14.4l16.5 83.4-70.7 47.3c-4.4 3-7.1 8-7.1 13.3s2.7 10.3 7.1 13.3l70.7 47.3L61.3 384c-1 5.2.6 10.7 4.4 14.4 3.8 3.8 9.1 5.5 14.4 4.4l83.3-16.5 47.3 70.7c3 4.5 8 7.1 13.3 7.1 5.3 0 10.3-2.7 13.3-7.1l47.3-70.7 36 7.1c.5-10.7 2.3-21.3 5.2-31.6l-45.5-9c-6.5-1.4-12.8 1.4-16.4 6.8z"]
  },
      jy = {
    prefix: "fal",
    iconName: "temperature-low",
    icon: [384, 512, [], "f76b", "M128 354.9V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1zM320 0c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm0 96c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM192 80c0-44.1-35.9-80-80-80S32 35.9 32 80v241.9C11.7 342.6 0 370.8 0 400c0 61.8 50.2 112 112 112s112-50.2 112-112c0-29.2-11.7-57.4-32-78.1V80zm-80 400c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V80c0-26.5 21.5-48 48-48s48 21.5 48 48v256.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80z"]
  },
      Ey = {
    prefix: "fal",
    iconName: "temperature-up",
    icon: [512, 512, [], "e040", "M224,80A80,80,0,1,0,64,80V321.91a112,112,0,1,0,160,0ZM144,480A79.87,79.87,0,0,1,96,336.2V80a48,48,0,1,1,96,0V336.2A79.87,79.87,0,0,1,144,480Zm16-125.09V80a16,16,0,1,0-32,0V354.91a48,48,0,1,0,32,0ZM492.47,117.75,408.41,35.5a11.91,11.91,0,0,0-16.87,0l-84,82.31a13.88,13.88,0,0,0-3.56,8.55,13.82,13.82,0,0,0,3.47,8.45l5.62,5.69a11.94,11.94,0,0,0,16.91.08l54-52.74V472a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V88.06l53.94,52.36a12,12,0,0,0,16.93,0l5.63-5.67a13.83,13.83,0,0,0,3.53-8.5A13.85,13.85,0,0,0,492.47,117.75Z"]
  },
      ky = {
    prefix: "fal",
    iconName: "tenge",
    icon: [384, 512, [], "f7d7", "M376 128H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h168v312c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V160h168c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0-96H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8V40c0-4.4-3.6-8-8-8z"]
  },
      Iy = {
    prefix: "fal",
    iconName: "tennis-ball",
    icon: [496, 512, [], "f45e", "M248 8C111.2 8 0 119.2 0 256s111.2 248 248 248 248-111.2 248-248S384.8 8 248 8zm-12.5 32.6c-5.5 9.7-9.3 20.5-9.3 32.4 0 41.3-18.5 87.6-46 115.1s-73.8 46-115 46c-12 0-22.8 3.8-32.5 9.4 6.2-109.1 93.7-196.6 202.8-202.9zm-201 246.6c4.9-12.6 16.6-21.1 30.6-21.1 50 0 104-21.8 137.6-55.4 33.6-33.6 55.4-87.7 55.4-137.7 0-14 8.4-25.7 21-30.5 94.1 13.7 168.6 88.2 182.3 182.3-4.9 12.5-16.6 20.9-30.6 21-50 0-104 21.8-137.6 55.4-33.6 33.6-55.4 87.7-55.4 137.7 0 14-8.5 25.8-21.1 30.6-94-13.7-168.5-88.2-182.2-182.3zm226 184.2c5.6-9.7 9.3-20.5 9.4-32.5 0-41.3 18.5-87.6 46-115.1s73.8-46 115-46c11.9 0 22.8-3.8 32.4-9.3-6.2 109.1-93.7 196.6-202.8 202.9z"]
  },
      Oy = {
    prefix: "fal",
    iconName: "terminal",
    icon: [640, 512, [], "f120", "M34.495 36.465l211.051 211.05c4.686 4.686 4.686 12.284 0 16.971L34.495 475.535c-4.686 4.686-12.284 4.686-16.97 0l-7.071-7.07c-4.686-4.686-4.686-12.284 0-16.971L205.947 256 10.454 60.506c-4.686-4.686-4.686-12.284 0-16.971l7.071-7.07c4.686-4.687 12.284-4.687 16.97 0zM640 468v-10c0-6.627-5.373-12-12-12H300c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h328c6.627 0 12-5.373 12-12z"]
  },
      Qy = {
    prefix: "fal",
    iconName: "text",
    icon: [448, 512, [], "f893", "M448 48v72a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8V64H240v384h72a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H136a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h72V64H32v56a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V48a16 16 0 0 1 16-16h416a16 16 0 0 1 16 16z"]
  },
      Zy = {
    prefix: "fal",
    iconName: "text-height",
    icon: [576, 512, [], "f034", "M560 368h-64V144h64c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.63 0l-80 80C379.36 126 384.36 144 400 144h64v224h-64c-14.31 0-21.33 17.32-11.31 27.32l80 80a16 16 0 0 0 22.63 0l80-80C580.64 386 575.64 368 560 368zM438.63 112L480 70.62 521.36 112h-82.73zM480 441.36L438.64 400h82.74zM304 32H16A16 16 0 0 0 0 48v72a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V64h112v384H72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h176a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-72V64h112v56a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V48a16 16 0 0 0-16-16z"]
  },
      Uy = {
    prefix: "fal",
    iconName: "text-size",
    icon: [640, 512, [], "f894", "M624 32H272a16 16 0 0 0-16 16v72a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V64h144v384h-72a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h176a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-72V64h144v56a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V48a16 16 0 0 0-16-16zM304 224H16a16 16 0 0 0-16 16v56a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-40h112v192H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-56V256h112v40a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-56a16 16 0 0 0-16-16z"]
  },
      By = {
    prefix: "fal",
    iconName: "text-width",
    icon: [448, 512, [], "f035", "M362.31 292.69a16.12 16.12 0 0 0-11.48-4.69c-8 0-15.83 5.69-15.83 16v64H111v-64a16 16 0 0 0-16.12-16 15.63 15.63 0 0 0-11.19 4.71l-80 80a16 16 0 0 0 0 22.63l80 80A16.16 16.16 0 0 0 95.17 480c8 0 15.83-5.69 15.83-16v-64h224v64a16 16 0 0 0 16.13 16 15.64 15.64 0 0 0 11.18-4.7l80-80a16 16 0 0 0 0-22.63zM79 368v57.37L37.63 384 79 342.64zm288 57.36v-82.73L408.37 384zM431 32H15A16 16 0 0 0-1 48v72a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V64h176v192h-40a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-40V64h176v56a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V48a16 16 0 0 0-16-16z"]
  },
      Ry = {
    prefix: "fal",
    iconName: "th",
    icon: [512, 512, [], "f00a", "M0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80zm320-16v106.667H192V64h128zm160 245.333H352V202.667h128v106.666zm-160 0H192V202.667h128v106.666zM32 202.667h128v106.667H32V202.667zM160 64v106.667H32V80c0-8.837 7.163-16 16-16h112zM32 432v-90.667h128V448H48c-8.837 0-16-7.163-16-16zm160 16V341.333h128V448H192zm160 0V341.333h128V432c0 8.837-7.163 16-16 16H352zm128-277.333H352V64h112c8.837 0 16 7.163 16 16v90.667z"]
  },
      Yy = {
    prefix: "fal",
    iconName: "th-large",
    icon: [512, 512, [], "f009", "M0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80zm240-16v176H32V80c0-8.837 7.163-16 16-16h192zM32 432V272h208v176H48c-8.837 0-16-7.163-16-16zm240 16V272h208v160c0 8.837-7.163 16-16 16H272zm208-208H272V64h192c8.837 0 16 7.163 16 16v160z"]
  },
      Py = {
    prefix: "fal",
    iconName: "th-list",
    icon: [512, 512, [], "f00b", "M0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80zm480 0v90.667H192V64h272c8.837 0 16 7.163 16 16zm0 229.333H192V202.667h288v106.666zM32 202.667h128v106.667H32V202.667zM160 64v106.667H32V80c0-8.837 7.163-16 16-16h112zM32 432v-90.667h128V448H48c-8.837 0-16-7.163-16-16zm160 16V341.333h288V432c0 8.837-7.163 16-16 16H192z"]
  },
      Fy = {
    prefix: "fal",
    iconName: "theater-masks",
    icon: [640, 512, [], "f630", "M151.06 206.02c19.34-3.41 35.78-17.86 45.16-39.67 3.47-8.12-.28-17.53-8.41-21.02-8.12-3.5-17.53.25-21.03 8.39-2.94 6.89-9.62 18.73-21.28 20.78-11.69 2.16-22.03-6.81-27.16-12.25-6.09-6.44-16.22-6.72-22.62-.69-6.44 6.06-6.75 16.19-.69 22.62 5.17 5.5 26.31 27.14 56.03 21.84zm362.78 2.12c-19.41-3.48-39.47 4.25-56.03 21.81-6.06 6.44-5.75 16.56.69 22.62 6.41 6.03 16.53 5.75 22.62-.69 5.12-5.47 15.38-14.34 27.16-12.25 11.66 2.06 18.34 13.91 21.28 20.78 3.54 8.19 13.02 11.85 21.03 8.39 8.12-3.48 11.88-12.89 8.41-21.02-9.37-21.78-25.81-36.23-45.16-39.64zm5.69 110.61c-26.31 15.94-63.06 21.23-100.88 14.58-37.81-6.67-70.53-24.23-89.81-48.2-9.15-11.34-27.25-5.52-28.41 8.7-5.25 63.08 38.69 119.08 102.19 130.27 21.1 3.72 115.04 6.5 140.62-87.45 3.77-13.83-11.24-25.35-23.71-17.9zm-111.34 73.84c-33.19-5.86-59.19-28.08-70.28-56.95 21.34 14.09 47.22 24.27 75.19 29.19 28.03 4.98 55.75 4.25 80.66-1.72-20.35 23.33-52.38 35.3-85.57 29.48zm-68.88-165.7c5.12-5.44 15.5-14.55 27.16-12.25 11.66 2.05 18.34 13.89 21.28 20.78 3.54 8.19 13.02 11.85 21.03 8.39 8.12-3.48 11.88-12.89 8.41-21.02-9.5-22.14-25.53-36.23-45.16-39.69-19.59-3.36-39.5 4.31-56.03 21.84-6.06 6.44-5.75 16.56.69 22.62 6.44 6.05 16.53 5.77 22.62-.67zM606.8 119.91c-41.73-23.22-120-58.55-227.1-56.93-5.87-33.25-28.59-53.11-54.53-57.26C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.47 33.2 57.21 9.03 70.65-3.92 98.72 1.05 126.9l31.73 179.96C47.01 387.58 169.11 449.3 237.23 449.3c13.85 0 23.86-1.88 43.61-11.66 2.58 2.98 62.79 74.36 121.93 74.36 68.12 0 190.22-61.71 204.45-142.44l31.73-179.96c4.97-28.17-7.98-56.24-32.15-69.69zM237.23 417.29c-57.45 0-162.04-54.21-172.94-115.99L32.57 121.34c-2.61-14.79 3.9-29.33 16.19-36.17C74.2 71.02 178.25 14.61 320.12 37.32c13.48 2.16 24.17 13.06 27.18 27.22-10.83.94-21.66 2.15-32.47 3.88-27.31 4.37-49.08 26.32-54.04 54.49L237.12 257.1c-67.24 3.06-100.25 46.03-101.65 47.78-5.53 6.89-4.44 16.97 2.44 22.5 7.9 6.32 17.79 3.41 22.5-2.44 1.02-1.27 22.34-29.55 70.95-35.12l-2.3 13.07c-6.25 35.42 8.43 74.42 32.1 109.1-10.52 4.48-16.13 5.3-23.93 5.3zm370.21-233.25L575.7 364.01C564.81 425.79 460.21 480 402.77 480c-39.05 0-86.86-50.33-99.56-65.31-31.81-37.54-47.76-77.26-42.64-106.25l31.73-179.96c2.61-14.79 13.7-26.23 27.59-28.45 142.14-22.74 246.27 33.89 271.36 47.85 12.29 6.83 18.79 21.37 16.19 36.16z"]
  },
      Wy = {
    prefix: "fal",
    iconName: "thermometer",
    icon: [512, 512, [], "f491", "M476.4 20.5C438.9-10.3 381.1-5.9 345 30.3L137.2 238.6c-6 6-8.9 14.2-8.9 22.7v55L14 430c-25.3 25.3-10.6 57.3 0 68 18.7 18.8 49.1 18.7 67.8 0l113.5-114.1h54.9c8.5 0 16.6-2.9 22.6-8.9l211-211.9c34.6-34.8 43-101.2-7.4-142.6zM59.2 475.3c-15 15-37.5-7.7-22.6-22.6l30.5-30.2 22.6 22.6-30.5 30.2zm401.9-334.9L250.1 352h-54.9c-8.5 0-16.6 3.7-22.6 9.7l-60.4 60.8-22.5-22.6 60.6-61c6-6 9.8-14.2 9.8-22.7v-55l34.5-34.9 39.5 39.6c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6 45.2-45.3 39.5 39.6c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3L285 135.7l45.2-45.3 39.5 39.6c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6L367.5 53c24.7-24.7 63.6-28.1 88.6-7.6 33.1 26.9 28.6 71.4 5 95z"]
  },
      Gy = {
    prefix: "fal",
    iconName: "thermometer-empty",
    icon: [256, 512, [], "f2cb", "M176 384c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm48-84.653c19.912 22.564 32 52.195 32 84.653 0 70.696-57.302 128-128 128-.299 0-.61-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.756 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM224 384c0-39.894-22.814-62.144-32-72.553V96c0-35.29-28.71-64-64-64S64 60.71 64 96v215.447c-9.467 10.728-31.797 32.582-31.999 72.049-.269 52.706 42.619 96.135 95.312 96.501L128 480c52.935 0 96-43.065 96-96z"]
  },
      qy = {
    prefix: "fal",
    iconName: "thermometer-full",
    icon: [256, 512, [], "f2c7", "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 384l-.687-.002c-52.693-.366-95.581-43.795-95.312-96.501.202-39.467 22.532-61.321 31.999-72.05V96c0-35.29 28.71-64 64-64s64 28.71 64 64v215.447c9.186 10.409 32 32.659 32 72.553 0 52.935-43.065 96-96 96zm48-96c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-20.898 13.359-38.667 32-45.258V96c0-8.837 7.164-16 16-16 8.837 0 16 7.163 16 16v242.742c18.641 6.591 32 24.36 32 45.258z"]
  },
      Jy = {
    prefix: "fal",
    iconName: "thermometer-half",
    icon: [256, 512, [], "f2c9", "M176 384c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-20.898 13.359-38.667 32-45.258V208c0-8.837 7.163-16 16-16s16 7.163 16 16v130.742c18.641 6.591 32 24.36 32 45.258zm48-84.653c19.912 22.564 32 52.195 32 84.653 0 70.696-57.302 128-128 128-.299 0-.61-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.756 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM224 384c0-39.894-22.814-62.144-32-72.553V96c0-35.29-28.71-64-64-64S64 60.71 64 96v215.447c-9.467 10.728-31.797 32.582-31.999 72.049-.269 52.706 42.619 96.135 95.312 96.501L128 480c52.935 0 96-43.065 96-96z"]
  },
      Ky = {
    prefix: "fal",
    iconName: "thermometer-quarter",
    icon: [256, 512, [], "f2ca", "M176 384c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-20.898 13.359-38.667 32-45.258V272c0-8.837 7.163-16 16-16s16 7.163 16 16v66.742c18.641 6.591 32 24.36 32 45.258zm48-84.653c19.912 22.564 32 52.195 32 84.653 0 70.696-57.302 128-128 128-.299 0-.61-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.756 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM224 384c0-39.894-22.814-62.144-32-72.553V96c0-35.29-28.71-64-64-64S64 60.71 64 96v215.447c-9.467 10.728-31.797 32.582-31.999 72.049-.269 52.706 42.619 96.135 95.312 96.501L128 480c52.935 0 96-43.065 96-96z"]
  },
      Xy = {
    prefix: "fal",
    iconName: "thermometer-three-quarters",
    icon: [256, 512, [], "f2c8", "M176 384c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-20.898 13.359-38.667 32-45.258V144c0-8.837 7.163-16 16-16s16 7.163 16 16v194.742c18.641 6.591 32 24.36 32 45.258zm48-84.653c19.912 22.564 32 52.195 32 84.653 0 70.696-57.302 128-128 128-.299 0-.61-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.756 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM224 384c0-39.894-22.814-62.144-32-72.553V96c0-35.29-28.71-64-64-64S64 60.71 64 96v215.447c-9.467 10.728-31.797 32.582-31.999 72.049-.269 52.706 42.619 96.135 95.312 96.501L128 480c52.935 0 96-43.065 96-96z"]
  },
      _y = {
    prefix: "fal",
    iconName: "theta",
    icon: [352, 512, [], "f69e", "M176 32C78.8 32 0 132.29 0 256s78.8 224 176 224 176-100.29 176-224S273.2 32 176 32zm0 32c75.35 0 137.26 77.61 143.39 176H32.61C38.74 141.61 100.65 64 176 64zm0 384c-75.35 0-137.26-77.61-143.39-176H319.4c-6.14 98.39-68.05 176-143.4 176z"]
  },
      $y = {
    prefix: "fal",
    iconName: "thumbs-down",
    icon: [512, 512, [], "f165", "M496.656 226.317c5.498-22.336 2.828-49.88-9.627-69.405 4.314-23.768-3.099-49.377-18.225-67.105C470.724 35.902 437.75 0 378.468.014c-3.363-.03-35.508-.003-41.013 0C260.593-.007 195.917 40 160 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v256c0 17.673 14.327 32 32 32h96c17.673 0 32-14.327 32-32v-12.481c.85.266 1.653.549 2.382.856C184 320 219.986 377.25 243.556 400.82c9.9 9.9 13.118 26.44 16.525 43.951C265.784 474.082 276.915 512 306.91 512c59.608 0 82.909-34.672 82.909-93.08 0-30.906-11.975-52.449-20.695-69.817h70.15c40.654 0 72.726-34.896 72.727-72.571-.001-20.532-5.418-37.341-15.345-50.215zM128 320H32V64h96v256zm311.273-2.898H327.274c0 40.727 30.545 59.628 30.545 101.817 0 25.574 0 61.091-50.909 61.091-20.363-20.364-10.182-71.272-40.727-101.817-28.607-28.607-71.272-101.818-101.818-101.818H160V72.74h4.365c34.701 0 101.818-40.727 173.09-40.727 3.48 0 37.415-.03 40.727 0 38.251.368 65.505 18.434 57.212 70.974 16.367 8.78 28.538 39.235 15.015 61.996C472 176 472 224 456.017 235.648 472 240 480.1 256.012 480 276.375c-.1 20.364-17.997 40.727-40.727 40.727zM104 272c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"]
  },
      cb = {
    prefix: "fal",
    iconName: "thumbs-up",
    icon: [512, 512, [], "f164", "M496.656 285.683C506.583 272.809 512 256 512 235.468c-.001-37.674-32.073-72.571-72.727-72.571h-70.15c8.72-17.368 20.695-38.911 20.695-69.817C389.819 34.672 366.518 0 306.91 0c-29.995 0-41.126 37.918-46.829 67.228-3.407 17.511-6.626 34.052-16.525 43.951C219.986 134.75 184 192 162.382 203.625c-2.189.922-4.986 1.648-8.032 2.223C148.577 197.484 138.931 192 128 192H32c-17.673 0-32 14.327-32 32v256c0 17.673 14.327 32 32 32h96c17.673 0 32-14.327 32-32v-8.74c32.495 0 100.687 40.747 177.455 40.726 5.505.003 37.65.03 41.013 0 59.282.014 92.255-35.887 90.335-89.793 15.127-17.727 22.539-43.337 18.225-67.105 12.456-19.526 15.126-47.07 9.628-69.405zM32 480V224h96v256H32zm424.017-203.648C472 288 472 336 450.41 347.017c13.522 22.76 1.352 53.216-15.015 61.996 8.293 52.54-18.961 70.606-57.212 70.974-3.312.03-37.247 0-40.727 0-72.929 0-134.742-40.727-177.455-40.727V235.625c37.708 0 72.305-67.939 106.183-101.818 30.545-30.545 20.363-81.454 40.727-101.817 50.909 0 50.909 35.517 50.909 61.091 0 42.189-30.545 61.09-30.545 101.817h111.999c22.73 0 40.627 20.364 40.727 40.727.099 20.363-8.001 36.375-23.984 40.727zM104 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"]
  },
      eb = {
    prefix: "fal",
    iconName: "thumbtack",
    icon: [384, 512, [], "f08d", "M300.8 203.9L290.7 128H328c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24H56C42.8 0 32 10.8 32 24v80c0 13.2 10.8 24 24 24h37.3l-10.1 75.9C34.9 231.5 0 278.4 0 335.2c0 8.8 7.2 16 16 16h160V472c0 .7.1 1.3.2 1.9l8 32c2 8 13.5 8.1 15.5 0l8-32c.2-.6.2-1.3.2-1.9V351.2h160c8.8 0 16-7.2 16-16 .1-56.8-34.8-103.7-83.1-131.3zM33.3 319.2c6.8-42.9 39.6-76.4 79.5-94.5L128 96H64V32h256v64h-64l15.3 128.8c40 18.2 72.7 51.8 79.5 94.5H33.3z"]
  },
      ab = {
    prefix: "fal",
    iconName: "thunderstorm",
    icon: [512, 512, [], "f76c", "M368 256h-73.8l25-74.9c1.6-4.9.8-10.2-2.2-14.4-3-4.2-7.8-6.6-13-6.6H192c-7.7 0-14.3 5.5-15.8 13.1l-32 176c-.8 4.7.4 9.5 3.5 13.1s7.5 5.8 12.3 5.8h80v128c0 7.4 5.1 13.9 12.3 15.6 1.2.3 2.5.4 3.7.4 6 0 11.6-3.3 14.3-8.8l112-224c2.5-5 2.2-10.8-.7-15.6-2.9-4.8-8.1-7.7-13.6-7.7zm-96 172.2V352c0-8.8-7.2-16-16-16h-76.8l26.2-144h76.5l-25 74.9c-1.6 4.9-.8 10.2 2.2 14.4 3 4.2 7.8 6.6 13 6.6h70.1L272 428.2zm143.7-315.9C411.8 67.4 373.9 32 328 32c-17.8 0-34.8 5.3-49.2 15.2C256.3 17.7 221.5 0 184 0 117.8 0 64 53.8 64 120v.4c-38.3 16-64 53.5-64 95.6 0 57.3 46.7 104 104 104h13l5.8-32H104c-39.7 0-72-32.3-72-72 0-32.3 21.9-60.7 53.3-69.2l13.3-3.6-2-17.2c-.3-2-.6-4-.6-6 0-48.5 39.5-88 88-88 32.2 0 61.8 17.9 77.2 46.8l10.6 19.8L287 82.1C297.9 70.4 312.4 64 328 64c30.9 0 56 25.1 56 56 0 1.6-.3 3.1-.8 6.9l-2.5 20 23.5-2.4c1.2-.2 2.5-.4 3.8-.4 39.7 0 72 32.3 72 72 0 38-29.7 68.9-67 71.5-.7 2-1.1 4-2.1 6L397.7 320H408c57.3 0 104-46.7 104-104 0-54.8-42.6-99.8-96.3-103.7z"]
  },
      nb = {
    prefix: "fal",
    iconName: "thunderstorm-moon",
    icon: [576, 512, [], "f76d", "M573.9 237.5c-3.6-7.7-11.5-12.6-19.9-12.6h-1.4l-2.7.4c-6.3 1.2-12.6 1.8-18.9 1.8-54.4 0-98.7-44-98.7-98.2 0-35.2 19.2-67.9 50.1-85.3 8.2-4.6 12.4-13.6 10.9-22.8-1.6-9.3-8.5-16.3-17.8-18C465.7.9 455.8 0 446 0c-67.1 0-124.7 41.1-148.8 99.2 10.5 2.5 20.5 6.3 29.7 11.5 19.2-45.5 64.2-77.8 116.8-78.7-27.3 24.4-43.5 59.6-43.5 96.8 0 70.7 57 128.5 127.6 130.1-22.3 18.2-50.3 28.4-79.8 28.8v.2c0 11-1.8 21.5-4.5 31.8.8 0 1.6.2 2.4.2 48.7 0 94.3-21.6 125-59.2 5.5-6.5 6.6-15.5 3-23.2zM304 304h-59.5l11-44.1c1.2-4.8.1-9.8-2.9-13.7s-7.7-6.2-12.6-6.2h-80c-7.3 0-13.8 5-15.5 12.1l-32 128C110 390.3 117.7 400 128 400h61.6l-13.4 93.7c-1.6 11.1 7.7 18.2 15.8 18.2 8.5 0 12.7-6.2 13.6-7.6 3.4-5.3 111.9-175.8 111.9-175.8 6.8-10.7-1-24.5-13.5-24.5zm-85.7 121.2l5.6-38.9c.7-4.6-.7-9.2-3.8-12.7-3-3.5-7.5-5.5-12.1-5.5h-59.5l24-96h47l-11 44.1c-2.5 10.2 5.2 19.9 15.5 19.9h50.8c-24.1 37.9-42.6 66.9-56.5 89.1zm133-227.9C346 158.2 312.5 128 272 128c-8.6 0-17 1.4-25.2 4.3-19.7-23-48.2-36.3-78.8-36.3-56.5 0-102.7 45.3-104 101.6C26.2 210.9 0 246.9 0 288c0 47.5 34.7 86.8 80.1 94.4.1-3.4.5-6.7 1.3-10.1l5.3-21.3C55.9 346.5 32 320.1 32 288c0-30.6 21.8-57 52-62.8l14.5-2.8-2-18c-.2-1.5-.4-2.9-.4-4.4 0-39.7 32.3-72 72-72 24.3 0 46.8 12.2 60.2 32.8l8.1 12.4 13-7.1c32.7-17.8 70.7 8.2 70.8 40.4l-.2 16.2 12.8 2.6c29.8 6 51.3 32.3 51.3 62.7 0 27-16.9 50-40.5 59.4-2.8 4.3-11.6 18.2-23.3 36.6 52.9-.1 95.8-43.1 95.8-96-.1-41.3-26.7-77.6-64.8-90.7z"]
  },
      tb = {
    prefix: "fal",
    iconName: "thunderstorm-sun",
    icon: [640, 512, [], "f76e", "M160.3 291.7c-3.6-5.3-9.9-8.1-16.4-6.8l-56 11.1L99 240c1.2-6.4-1.4-12.8-6.8-16.4l-47.4-31.8L92.2 160c5.4-3.6 8-10.1 6.8-16.4l-11.1-56 56 11.1c6.5 1.3 12.8-1.4 16.4-6.8L192 44.4l31.8 47.5c3.6 5.3 10 8.1 16.4 6.8L319.6 83c8.7-1.7 14.3-10.1 12.6-18.8-1.7-8.7-10.3-14.5-18.8-12.6l-68.9 13.6-39.2-58.5c-5.9-8.9-20.6-8.9-26.6 0l-39.1 58.5-69-13.7c-5.3-1.1-10.7.6-14.4 4.4-3.8 3.8-5.4 9.2-4.4 14.5l13.7 69-58.4 39.1c-4.4 3-7.1 7.9-7.1 13.3 0 5.3 2.7 10.3 7.1 13.3l58.4 39.1-13.7 69c-1 5.3.6 10.7 4.4 14.5 3.8 3.8 9 5.5 14.4 4.4l68.9-13.7 39.1 58.5c3.1 4.6 8.2 7.1 13.3 7.1 3.1 0 6.2-.9 8.9-2.7 7.3-4.9 9.3-14.9 4.4-22.2l-44.9-67.4zM192 140c26.4 0 48 20 51.1 45.6 4.8-3.6 9.8-6.9 15.1-9.9 1.5-8.4 3.9-16.5 6.8-24.3-14.3-25.7-41.5-43.4-73-43.4-46.2 0-83.7 37.6-83.7 83.8s37.5 83.8 83.7 83.8c.3 0 .6-.1.9-.1 1.1-11.4 3.7-22.4 7.7-32.8-2.8.5-5.6.9-8.5.9-28.5 0-51.7-23.2-51.7-51.7-.1-28.6 23.1-51.9 51.6-51.9zm336 164h-59.5l11-44.1c1.2-4.8.1-9.8-2.9-13.7-3-3.9-7.7-6.2-12.6-6.2h-80c-7.3 0-13.8 5-15.5 12.1l-32 128C334 390.3 341.7 400 352 400h61.6l-13.4 93.7c-1.6 11.1 7.7 18.2 15.8 18.2 8.5 0 12.7-6.2 13.6-7.6 3.4-5.3 111.9-175.8 111.9-175.8 6.8-10.7-1-24.5-13.5-24.5zm-85.7 121.2l5.6-38.9c.7-4.6-.7-9.2-3.8-12.7-3-3.5-7.5-5.5-12.1-5.5h-59.5l24-96h47l-11 44.1c-2.5 10.2 5.2 19.9 15.5 19.9h50.8c-24.1 37.9-42.6 66.9-56.5 89.1zm133-227.9C570 158.2 536.5 128 496 128c-8.6 0-17 1.4-25.2 4.3-19.7-23-48.2-36.3-78.8-36.3-56.5 0-102.7 45.3-104 101.6-37.8 13.3-64 49.3-64 90.4 0 47.5 34.8 86.8 80.1 94.4.1-3.4.5-6.7 1.3-10.1l5.3-21.3c-30.9-4.5-54.8-30.9-54.8-63.1 0-30.6 21.8-57 52-62.8l14.5-2.8-2-18c-.2-1.5-.4-2.9-.4-4.4 0-39.7 32.3-72 72-72 24.3 0 46.8 12.2 60.2 32.7l8.1 12.4 13-7.1c32.7-17.8 70.7 8.2 70.8 40.4l-.2 16.2 12.8 2.6c29.8 6 51.3 32.3 51.3 62.7 0 27-16.9 50-40.5 59.4-2.8 4.3-11.6 18.2-23.3 36.6 52.9-.1 95.8-43.1 95.8-96 0-41.1-26.6-77.4-64.7-90.5zM560 208.8z"]
  },
      rb = {
    prefix: "fal",
    iconName: "ticket",
    icon: [576, 512, [], "f145", "M544 224h32V112c0-26.51-21.49-48-48-48H48C21.49 64 0 85.49 0 112v112h32c17.673 0 32 14.327 32 32s-14.327 32-32 32H0v112c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V288h-32c-17.673 0-32-14.327-32-32s14.327-32 32-32zm0 96v80c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16v-80c35.29 0 64-28.71 64-64s-28.71-64-64-64v-80c0-8.823 7.177-16 16-16h480c8.823 0 16 7.177 16 16v80c-35.29 0-64 28.71-64 64s28.71 64 64 64z"]
  },
      ib = {
    prefix: "fal",
    iconName: "ticket-alt",
    icon: [576, 512, [], "f3ff", "M424 160H152c-13.255 0-24 10.745-24 24v144c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24zm-8 160H160V192h256v128zm128-96h32V112c0-26.51-21.49-48-48-48H48C21.49 64 0 85.49 0 112v112h32c17.673 0 32 14.327 32 32s-14.327 32-32 32H0v112c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V288h-32c-17.673 0-32-14.327-32-32s14.327-32 32-32zm0 96v80c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16v-80c35.29 0 64-28.71 64-64s-28.71-64-64-64v-80c0-8.823 7.177-16 16-16h480c8.823 0 16 7.177 16 16v80c-35.29 0-64 28.71-64 64s28.71 64 64 64z"]
  },
      ob = {
    prefix: "fal",
    iconName: "tilde",
    icon: [448, 512, [], "f69f", "M416 168v71.85c0 35.91-23.16 69.16-58.01 77.84-31.8 7.91-64.07-4.93-81.96-30.74L200.75 178.4c-21.13-30.46-55.42-50.58-92.49-50.38C48.5 128.32 0 177.02 0 236.84V312c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-71.85c0-35.91 23.16-69.16 58.01-77.84 31.8-7.91 64.07 4.93 81.96 30.74l75.28 108.55c21.13 30.46 55.42 50.58 92.49 50.38 59.76-.3 108.26-49 108.26-108.82V168c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8z"]
  },
      lb = {
    prefix: "fal",
    iconName: "times",
    icon: [320, 512, [], "f00d", "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"]
  },
      fb = {
    prefix: "fal",
    iconName: "times-circle",
    icon: [512, 512, [], "f057", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"]
  },
      sb = {
    prefix: "fal",
    iconName: "times-hexagon",
    icon: [576, 512, [], "f2ee", "M441.5 39.8C432.9 25.1 417.1 16 400 16H176c-17.1 0-32.9 9.1-41.5 23.8l-112 192c-8.7 14.9-8.7 33.4 0 48.4l112 192c8.6 14.7 24.4 23.8 41.5 23.8h224c17.1 0 32.9-9.1 41.5-23.8l112-192c8.7-14.9 8.7-33.4 0-48.4l-112-192zm84.3 224.3l-112 192c-2.9 4.9-8.2 7.9-13.8 7.9H176c-5.7 0-11-3-13.8-7.9l-112-192c-2.9-5-2.9-11.2 0-16.1l112-192c2.8-5 8.1-8 13.8-8h224c5.7 0 11 3 13.8 7.9l112 192c2.9 5 2.9 11.2 0 16.2zm-143 78.2l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L288 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.7 4.7 4.7 12.3 0 17L313.5 256l69.3 69.3c4.6 4.7 4.6 12.3 0 17z"]
  },
      ub = {
    prefix: "fal",
    iconName: "times-octagon",
    icon: [512, 512, [], "f2f0", "M361.5 14.1c-9-9-21.2-14.1-33.9-14.1H184.5c-12.7 0-24.9 5.1-33.9 14.1L14.1 150.5c-9 9-14.1 21.2-14.1 33.9v143.1c0 12.7 5.1 24.9 14.1 33.9l136.5 136.5c9 9 21.2 14.1 33.9 14.1h143.1c12.7 0 24.9-5.1 33.9-14.1L498 361.4c9-9 14.1-21.2 14.1-33.9v-143c0-12.7-5.1-24.9-14.1-33.9L361.5 14.1zM480 327.5c0 4.3-1.7 8.3-4.7 11.3L338.9 475.3c-3 3-7 4.7-11.3 4.7H184.5c-4.3 0-8.3-1.7-11.3-4.7L36.7 338.9c-3-3-4.7-7-4.7-11.3V184.5c0-4.3 1.7-8.3 4.7-11.3L173.1 36.7c3-3 7-4.7 11.3-4.7h143.1c4.3 0 8.3 1.7 11.3 4.7l136.5 136.5c3 3 4.7 7 4.7 11.3v143zm-129.2 14.8l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.7 4.7 4.7 12.3 0 17L281.5 256l69.3 69.3c4.6 4.7 4.6 12.3 0 17z"]
  },
      hb = {
    prefix: "fal",
    iconName: "times-square",
    icon: [448, 512, [], "f2d3", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352zm-97.2-245.3L249.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L224 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"]
  },
      mb = {
    prefix: "fal",
    iconName: "tint",
    icon: [352, 512, [], "f043", "M205.22 22.09C201.21 7.53 188.61 0 175.97 0c-12.35 0-24.74 7.2-29.19 22.09C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 480c-79.4 0-144-65.54-144-146.09 0-48.36 23-81.32 54.84-126.94 29.18-41.81 65.34-93.63 89.18-170.91 23.83 77.52 60.06 129.31 89.3 171.08C297.06 252.52 320 285.3 320 333.91 320 414.46 255.4 480 176 480zm0-64c-44.12 0-80-35.89-80-80 0-8.84-7.16-16-16-16s-16 7.16-16 16c0 61.75 50.25 112 112 112 8.84 0 16-7.16 16-16s-7.16-16-16-16z"]
  },
      vb = {
    prefix: "fal",
    iconName: "tint-slash",
    icon: [640, 512, [], "f5c7", "M320 480c-79.4 0-144-65.5-144-146.1 0-33.4 11.1-59.5 28.4-87.5l-25.3-20c-20.5 32.7-35.1 65.1-35.1 107.4 0 98.4 78.7 178.1 176 178.1 55.5 0 104.9-26 137.1-66.5l-25.7-20.2C405 458.4 365.2 480 320 480zm0-443.9c23.8 77.5 60.1 129.3 89.3 171.1 18.4 26.4 33.7 48.5 43.5 71.9l41.8 32.9c-12-96-101.6-142.2-145.3-289.9C345.2 7.5 332.6 0 320 0c-12.4 0-24.7 7.2-29.2 22.1-11.3 38.2-25.8 69.6-41.2 97l25.4 20c16.5-28.9 32.5-62.4 45-103zm317 449.1L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3z"]
  },
      db = {
    prefix: "fal",
    iconName: "tire",
    icon: [512, 512, [], "f631", "M256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm0 480C132.49 480 32 379.51 32 256S132.49 32 256 32s224 100.49 224 224-100.49 224-224 224zm0-384c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160S344.37 96 256 96zm0 32c22.34 0 43.04 6.26 61.34 16.36l-37.57 51.71c-7.37-2.93-15.35-4.65-23.77-4.65s-16.39 1.72-23.77 4.65l-37.57-51.71c18.3-10.1 39-16.36 61.34-16.36zM128 256c0-36.74 15.77-69.67 40.64-93.03l37.82 52.06c-9.25 11.18-15.04 25.33-15.04 40.97 0 1.38.32 2.67.41 4.03l-61.4 19.95c-1.49-7.79-2.43-15.77-2.43-23.98zm112 126.38a127.631 127.631 0 0 1-99.45-72.05l61.03-19.83c8.68 13.66 22.32 23.71 38.42 27.84v64.04zm-16-126.4c0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32-32-14.32-32-32zm48 126.4v-64.04c16.1-4.13 29.74-14.17 38.42-27.84l61.03 19.83A127.631 127.631 0 0 1 272 382.38zm48.17-122.35c.09-1.36.41-2.65.41-4.03 0-15.64-5.79-29.79-15.04-40.97l37.82-52.06C368.23 186.33 384 219.26 384 256c0 8.21-.94 16.19-2.42 23.97l-61.41-19.94z"]
  },
      Mb = {
    prefix: "fal",
    iconName: "tire-flat",
    icon: [512, 512, [], "f632", "M256 128c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm0 32c22.34 0 43.04 6.26 61.34 16.36l-37.57 51.71c-7.37-2.93-15.35-4.65-23.77-4.65s-16.39 1.72-23.77 4.65l-37.57-51.71c18.3-10.1 39-16.36 61.34-16.36zM128 288c0-36.74 15.77-69.67 40.64-93.03l37.82 52.06c-9.25 11.18-15.04 25.33-15.04 40.97 0 1.38.32 2.67.41 4.03l-61.4 19.95c-1.49-7.79-2.43-15.77-2.43-23.98zm112 126.38a127.631 127.631 0 0 1-99.45-72.05l61.03-19.83c8.68 13.66 22.32 23.71 38.42 27.84v64.04zm-16-126.4c0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32-32-14.32-32-32zm48 126.4v-64.04c16.1-4.13 29.74-14.17 38.42-27.84l61.03 19.83A127.631 127.631 0 0 1 272 414.38zm48.17-122.35c.09-1.36.41-2.65.41-4.03 0-15.64-5.79-29.79-15.04-40.97l37.82-52.06C368.23 218.33 384 251.26 384 288c0 8.21-.94 16.19-2.42 23.97l-61.41-19.94zm156.59 125.69C499.75 378.83 512 334.39 512 288c0-141.16-114.84-256-256-256S0 146.84 0 288c0 46.39 12.25 90.83 35.24 129.72C14.95 423.32 0 441.95 0 464c0 26.47 21.53 48 48 48h416c26.47 0 48-21.53 48-48 0-22.05-14.95-40.68-35.24-46.28zM464 480H48c-8.84 0-16-7.16-16-16s7.16-16 16-16h48c8.84 0 16-7.16 16-16s-7.16-16-16-16H72.35C46.97 379.72 32 335.64 32 288 32 164.29 132.29 64 256 64s224 100.29 224 224c0 47.64-14.97 91.72-40.35 128H416c-8.84 0-16 7.16-16 16s7.16 16 16 16h48c8.84 0 16 7.16 16 16s-7.16 16-16 16z"]
  },
      pb = {
    prefix: "fal",
    iconName: "tire-pressure-warning",
    icon: [512, 512, [], "f633", "M256 296.02c-13.26 0-24 10.74-24 24 0 13.25 10.74 24 24 24s24-10.75 24-24c0-13.26-10.74-24-24-24zm-7.95-24h15.9c6.87 0 12.61-5.2 13.29-12.03l10.69-149.29c.79-7.87-5.39-14.69-13.29-14.69h-37.28c-7.9 0-14.08 6.82-13.29 14.69l10.69 149.29c.68 6.82 6.43 12.03 13.29 12.03zm223.46-139.11c-11.05-18.29-16.88-37.79-16.88-56.43V40c0-22.06-17.94-40-40-40h-16c-22.06 0-40 17.94-40 40v36.48c0 36.08 10.59 72.72 30.62 105.97 17.5 29.05 26.75 62.42 26.75 96.48 0 38.15-12.41 68.63-41.48 101.94-1.73 1.99-4.34 3.12-7.14 3.12H144.62c-2.81 0-5.41-1.14-7.14-3.12C108.41 347.57 96 317.08 96 278.94c0-34.07 9.25-67.43 26.75-96.47 20.04-33.27 30.62-69.92 30.62-105.99V40c0-22.06-17.94-40-40-40h-16c-22.06 0-40 17.94-40 40v36.48c0 18.63-5.83 38.14-16.87 56.42C14 176.89 0 227.38 0 278.94c0 61.68 20.7 114.12 65.14 165.05 4.48 5.14 9.55 9.62 14.86 13.73V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-29.75c10.28 3.34 20.94 5.62 32 5.69V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24h32v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24h32v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24h32v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24.07c11.06-.07 21.72-2.34 32-5.69V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-46.28c5.31-4.12 10.39-8.6 14.88-13.75C491.3 393.06 512 340.62 512 278.94c0-51.55-14-102.05-40.49-146.03zm-48.76 290.04C408.88 438.88 388.69 448 367.38 448H144.62c-21.31 0-41.5-9.12-55.38-25.05C50.19 378.19 32 332.42 32 278.94c0-45.72 12.41-90.5 35.91-129.5 14.06-23.3 21.47-48.53 21.47-72.95V40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v36.48c0 30.25-9 61.19-26.03 89.47C74.84 199.97 64 239.05 64 278.94c0 45.92 15.22 83.86 49.38 122.98 7.81 8.95 19.19 14.08 31.25 14.08h222.75c12.06 0 23.44-5.12 31.25-14.08C432.78 362.8 448 324.86 448 278.94c0-39.89-10.84-78.97-31.34-113-17.03-28.27-26.03-59.2-26.03-89.45V40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v36.48c0 24.42 7.41 49.66 21.47 72.94 23.5 39.02 35.91 83.8 35.91 129.52-.01 53.48-18.2 99.25-57.26 144.01z"]
  },
      zb = {
    prefix: "fal",
    iconName: "tire-rugged",
    icon: [512, 512, [], "f634", "M467.12 169.93c-.32-.79-.64-1.57-.97-2.36 13.48-22.99 10.37-53.09-9.33-72.79l-39.6-39.6c-11.33-11.33-26.4-17.57-42.43-17.57-10.86 0-21.27 2.86-30.39 8.23-.78-.32-1.55-.64-2.33-.96C335.35 19.09 311.87 0 284 0h-56c-27.87 0-51.35 19.09-58.07 44.88-.78.32-1.56.64-2.33.96-9.11-5.37-19.53-8.23-30.39-8.23-16.03 0-31.1 6.24-42.43 17.58l-39.6 39.59c-19.7 19.7-22.81 49.81-9.33 72.79-.33.78-.65 1.57-.97 2.36C19.09 176.65 0 200.13 0 228v56c0 27.86 19.09 51.35 44.88 58.07.32.79.64 1.57.97 2.36-13.48 22.99-10.37 53.09 9.33 72.79l39.6 39.6c11.33 11.33 26.4 17.57 42.43 17.57 10.86 0 21.27-2.86 30.39-8.23.78.32 1.55.64 2.33.96C176.65 492.91 200.13 512 228 512h56c27.87 0 51.35-19.09 58.07-44.88l2.34-.96c9.11 5.37 19.53 8.23 30.38 8.23 16.03 0 31.09-6.24 42.43-17.57l39.6-39.6c19.7-19.7 22.81-49.8 9.33-72.79.33-.78.65-1.57.97-2.36C492.91 335.35 512 311.86 512 284v-56c0-27.87-19.09-51.35-44.88-58.07zM480 284c0 15.46-12.54 28-28 28h-8.22c-3.88 13.02-8.98 25.51-15.34 37.24l5.76 5.76c10.93 10.93 10.93 28.66 0 39.6l-39.6 39.6c-5.47 5.47-12.63 8.2-19.8 8.2s-14.33-2.73-19.8-8.2l-5.76-5.76c-11.73 6.36-24.22 11.46-37.24 15.34V452c0 15.46-12.54 28-28 28h-56c-15.46 0-28-12.54-28-28v-8.22c-13.02-3.88-25.51-8.98-37.24-15.34L157 434.2c-5.47 5.47-12.63 8.2-19.8 8.2s-14.33-2.73-19.8-8.2l-39.6-39.6c-10.93-10.93-10.93-28.66 0-39.6l5.76-5.76C77.21 337.51 72.1 325.02 68.22 312H60c-15.46 0-28-12.54-28-28v-56c0-15.46 12.54-28 28-28h8.22c3.88-13.02 8.98-25.51 15.34-37.24L77.8 157c-10.93-10.94-10.93-28.67 0-39.6l39.6-39.6c5.47-5.47 12.63-8.2 19.8-8.2s14.33 2.73 19.8 8.2l5.76 5.76C174.49 77.2 186.98 72.1 200 68.22V60c0-15.46 12.54-28 28-28h56c15.46 0 28 12.54 28 28v8.22c13.02 3.88 25.51 8.98 37.24 15.34L355 77.8c5.47-5.47 12.63-8.2 19.8-8.2s14.33 2.73 19.8 8.2l39.6 39.6c10.93 10.93 10.93 28.66 0 39.6l-5.76 5.76c6.36 11.73 11.46 24.22 15.34 37.24H452c15.46 0 28 12.54 28 28v56zM256 95.98c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm0 288c-70.58 0-128-57.42-128-128s57.42-128 128-128 128 57.42 128 128-57.42 128-128 128zM256 160c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm0 143.98c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24-10.75-24-24-24zM328 232c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm-144 0c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      Cb = {
    prefix: "fal",
    iconName: "tired",
    icon: [496, 512, [], "f5c8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm113.8-322.3l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.6 6.9 24-7.7 15.4-18L343.6 208l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18zM134.2 266.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.6 10.3 3.8 24.9 15.4 18zM248 272c-51.9 0-115.3 43.8-123.2 106.7-.8 6.3.9 12.7 4.6 16.9.6.7 5.8 6.7 13.2 3.6 25.9-11.1 64.4-17.4 105.5-17.4s79.6 6.3 105.5 17.4c5.5 2.4 10.5-.5 13.2-3.6 3.6-4.2 5.3-10.6 4.6-16.9C363.3 315.8 299.9 272 248 272zm0 77.7c-30.6 0-59.5 3.2-84.3 9.1 15.8-32.5 53-54.8 84.3-54.8 31.3 0 68.5 22.3 84.3 54.8-24.8-5.9-53.6-9.1-84.3-9.1z"]
  },
      Lb = {
    prefix: "fal",
    iconName: "toggle-off",
    icon: [576, 512, [], "f204", "M384 96c42.738 0 82.917 16.643 113.137 46.863S544 213.262 544 256s-16.643 82.917-46.863 113.137S426.738 416 384 416H192c-42.738 0-82.917-16.643-113.137-46.863S32 298.738 32 256s16.643-82.917 46.863-113.137S149.262 96 192 96h192m0-32H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zm-192 96c52.935 0 96 43.065 96 96s-43.065 96-96 96-96-43.065-96-96 43.065-96 96-96m0-32c-70.692 0-128 57.307-128 128s57.308 128 128 128 128-57.307 128-128-57.308-128-128-128z"]
  },
      Ab = {
    prefix: "fal",
    iconName: "toggle-on",
    icon: [576, 512, [], "f205", "M384 96c88.426 0 160 71.561 160 160 0 88.426-71.561 160-160 160H192c-88.426 0-160-71.561-160-160 0-88.425 71.561-160 160-160h192m0-32H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zm0 304c61.856 0 112-50.144 112-112s-50.144-112-112-112-112 50.144-112 112c0 28.404 10.574 54.339 27.999 74.082C320.522 353.335 350.548 368 384 368z"]
  },
      Nb = {
    prefix: "fal",
    iconName: "toilet",
    icon: [384, 512, [], "f7d8", "M376 32c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H8C3.6 0 0 3.6 0 8v16c0 4.4 3.6 8 8 8h24v172.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V32h24zM64 32h256v160.4c-34-10.2-78.8-16.4-128-16.4s-94 6.2-128 16.4V32zm128 176c83.9 0 152 14.3 152 32s-68.1 32-152 32-152-14.3-152-32 68.1-32 152-32zM96 480l19.5-63.9C139 426.3 164.8 432 192 432s53-5.7 76.5-15.9L288 480H96zm96-80c-75.2 0-138.1-52.3-155.1-122.4 34.9 16 91.3 26.4 155.1 26.4s120.2-10.4 155.1-26.4C330.1 347.7 267.2 400 192 400zM152 64h-48c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8z"]
  },
      gb = {
    prefix: "fal",
    iconName: "toilet-paper",
    icon: [576, 512, [], "f71e", "M112 192c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.17-16-16-16zm64 0c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.17-16-16-16zm64 0c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.17-16-16-16zm64 0c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.17-16-16-16zM464 0H144C82.14 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h312.92c13.77 0 26-8.81 30.36-21.88 11.16-33.48 21.59-63.54 24.11-106.12H464c61.86 0 112-85.96 112-192S525.86 0 464 0zM352 192v172.07c0 46.83-9.67 75.79-21.9 112.45l-1.16 3.48H38.29c.54-1.61 1.08-3.18 1.61-4.72C55.44 429.55 64 404.37 64 364.07V192c0-94.29 42.16-160 80-160h258.14C371.93 66.39 352 125.18 352 192zm112 160c-37.84 0-80-65.71-80-160s42.16-160 80-160 80 65.71 80 160-42.16 160-80 160zm0-208c-13.25 0-24 21.49-24 48s10.75 48 24 48c13.26 0 24-21.49 24-48s-10.74-48-24-48z"]
  },
      Hb = {
    prefix: "fal",
    iconName: "toilet-paper-alt",
    icon: [576, 512, [], "f71f", "M464 0H144C82.14 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h312.92c13.77 0 26-8.81 30.36-21.88 11.16-33.48 21.59-63.54 24.11-106.12H464c61.86 0 112-85.96 112-192S525.86 0 464 0zM352 192v172.07c0 46.83-9.67 75.79-21.9 112.45l-1.16 3.48H38.29c.54-1.61 1.08-3.18 1.61-4.72C55.44 429.55 64 404.37 64 364.07V192c0-94.29 42.16-160 80-160h258.14C371.93 66.39 352 125.18 352 192zm112 160c-37.84 0-80-65.71-80-160s42.16-160 80-160 80 65.71 80 160-42.16 160-80 160zm0-208c-13.25 0-24 21.49-24 48s10.75 48 24 48c13.26 0 24-21.49 24-48s-10.74-48-24-48z"]
  },
      Vb = {
    prefix: "fal",
    iconName: "toilet-paper-slash",
    icon: [640, 512, [], "e072", "M472,192c0,26.52,10.75,48,24,48s24-21.48,24-48-10.73-48-24-48S472,165.48,472,192ZM176,32H434.14C403.94,66.39,384,125.19,384,192v33l39,30.71A285.69,285.69,0,0,1,416,192c0-94.3,42.16-160,80-160s80,65.7,80,160c0,68.5-22.32,121.52-49,145.62l25.43,20C585.64,324.33,608,262.71,608,192,608,86,557.86,0,496,0H176c-18.35,0-35.62,7.71-50.9,21.12l26,20.45C159.27,35.66,167.72,32,176,32ZM362.09,476.52,360.94,480H70.3c.53-1.61,1.07-3.19,1.61-4.72C87.44,429.55,96,404.38,96,364.06V192c0-10.29.7-20.08,1.65-29.64L68.37,139.3A322.2,322.2,0,0,0,64,192V364.06c0,41.13-9.8,62.78-31.17,126.88A16,16,0,0,0,48,512H360.94a32,32,0,0,0,30.36-21.87C400,464,408.11,439.8,412.53,410.31L382.79,386.9C380.15,420.87,372.16,446.36,362.09,476.52Zm274.9,8.8L23,1.8A7.88,7.88,0,0,0,11.77,3l-10,12.5A7.94,7.94,0,0,0,3,26.71L216,194.42h0l3.92,3.09h0L617,510.23A8,8,0,0,0,628.2,509l10-12.5A7.86,7.86,0,0,0,637,485.32Z"]
  },
      xb = {
    prefix: "fal",
    iconName: "tombstone",
    icon: [512, 512, [], "f720", "M496 416h-48V200.05C448 94.92 366.99 3.24 261.9.09 153.17-3.17 64 84 64 192v224H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM96 192c0-88.22 71.78-160 160-160s160 71.78 160 160v224H96V192zm383.95 288H32.01l.04-32h447.94l-.04 32zM336.02 144h-32v-32c0-8.84-7.16-16-16-16h-64.01c-8.85 0-16 7.16-16 16v32h-32c-8.85 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h32v96c0 8.84 7.16 16 16 16h64.01c8.85 0 16-7.16 16-16v-96h32c8.85 0 16-7.16 16-16v-64c0-8.84-7.15-16-16-16zm-16 64h-48.01v112h-32V208H192v-32h48.01v-48h32v48h48.01v32z"]
  },
      wb = {
    prefix: "fal",
    iconName: "tombstone-alt",
    icon: [512, 512, [], "f721", "M496 416h-48V200.05C448 94.92 366.99 3.24 261.9.09 153.17-3.17 64 84 64 192v224H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM96 192c0-88.22 71.78-160 160-160s160 71.78 160 160v224H96V192zm383.95 288H32.01l.04-32h447.94l-.04 32z"]
  },
      yb = {
    prefix: "fal",
    iconName: "toolbox",
    icon: [512, 512, [], "f552", "M502.63 214.63l-45.25-45.26c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.47-21.53-48-48-48H176c-26.47 0-48 21.53-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V448c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V237.25c0-8.48-3.37-16.62-9.37-22.62zM160 80c0-8.83 7.19-16 16-16h160c8.81 0 16 7.17 16 16v80H160V80zm320 368H32v-96h96v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24h192v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24h96v96zm-96-128v-24c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v24H160v-24c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v24H32v-82.75L77.25 192h357.49L480 237.25V320h-96z"]
  },
      bb = {
    prefix: "fal",
    iconName: "tools",
    icon: [512, 512, [], "f7d9", "M502.6 389.5L378.2 265c-15.6-15.6-36.1-23.4-56.6-23.4-15.4 0-30.8 4.4-44.1 13.3L192 169.4V96L64 0 0 64l96 128h73.4l85.5 85.5c-20.6 31.1-17.2 73.3 10.2 100.7l124.5 124.5c6.2 6.2 14.4 9.4 22.6 9.4 8.2 0 16.4-3.1 22.6-9.4l67.9-67.9c12.4-12.6 12.4-32.8-.1-45.3zM160 158.1v1.9h-48L42.3 67 67 42.3l93 69.7v46.1zM412.1 480L287.7 355.5c-9.1-9.1-14.1-21.1-14.1-33.9 0-12.8 5-24.9 14.1-33.9 9.1-9.1 21.1-14.1 33.9-14.1 12.8 0 24.9 5 33.9 14.1L480 412.1 412.1 480zM64 432c0 8.8 7.2 16 16 16s16-7.2 16-16-7.2-16-16-16-16 7.2-16 16zM276.8 66.9C299.5 44.2 329.4 32 360.6 32c6.9 0 13.8.6 20.7 1.8L312 103.2l13.8 83 83.1 13.8 69.3-69.3c6.7 38.2-5.3 76.8-33.1 104.5-8.9 8.9-19.1 16-30 21.5l23.6 23.6c10.4-6.2 20.2-13.6 29-22.5 37.8-37.8 52.7-91.4 39.7-143.3-2.3-9.5-9.7-17-19.1-19.6-9.5-2.6-19.7 0-26.7 7l-63.9 63.9-44.2-7.4-7.4-44.2L410 50.3c6.9-6.9 9.6-17.1 7-26.5-2.6-9.5-10.2-16.8-19.7-19.2C345.6-8.3 292 6.5 254.1 44.3c-12.9 12.9-22.9 27.9-30.1 44v67.8l22.1 22.1c-9.6-40.4 1.6-82.2 30.7-111.3zM107 467.1c-16.6 16.6-45.6 16.6-62.2 0-17.1-17.1-17.1-45.1 0-62.2l146.1-146.1-22.6-22.6L22.2 382.3c-29.6 29.6-29.6 77.8 0 107.5C36.5 504.1 55.6 512 75.9 512c20.3 0 39.4-7.9 53.7-22.3L231.4 388c-6.7-9.2-11.8-19.3-15.5-29.8L107 467.1z"]
  },
      Sb = {
    prefix: "fal",
    iconName: "tooth",
    icon: [448, 512, [], "f5c9", "M443.94 96.25c-11.03-45.28-47.12-82.08-92.02-93.73-27.93-7.22-57.56 1.12-89.08 24.34-12.58 9.24-44.2 24.48-77.59.06l-.4-.28c-.06-.04-.13-.04-.19-.08C153.32 3.6 123.92-4.66 96.05 2.54c-44.87 11.64-80.99 48.44-92 93.72-9.61 39.48-1.97 78.7 21.5 110.44 20.51 27.73 32.06 61.84 36.29 107.34 3.62 38.69 9.25 89.61 20.93 140.31l7.81 33.97c3.22 13.95 15.4 23.69 29.65 23.69 14.03 0 26.18-9.55 29.53-23.16l34.5-138.44c4.56-18.33 20.9-31.14 39.74-31.14s35.18 12.81 39.74 31.16l34.5 138.41a30.348 30.348 0 0 0 29.53 23.17c14.25 0 26.43-9.73 29.65-23.69l7.81-33.97c11.69-50.72 17.31-101.64 20.93-140.31 4.28-45.56 15.81-79.66 36.31-107.34 23.47-31.76 31.1-70.98 21.47-110.45zm-47.21 91.41c-24.09 32.56-37.59 71.76-42.43 123.39-3.5 37.7-9 87.23-20.25 136.11l-6.34 27.59-32.9-132.06c-8.12-32.64-37.25-55.42-70.8-55.42s-62.68 22.78-70.8 55.41l-31.43 138.45-7.81-33.97c-11.25-48.86-16.75-98.39-20.25-136.09-4.81-51.56-18.31-90.78-42.45-123.41-17.72-23.97-23.45-53.75-16.12-83.84 8.26-33.98 35.32-61.58 68.94-70.3 24.3-6.27 48.55 9.13 62.12 19.14.07.05.15.08.21.13.03.02.04.05.07.07l80.33 56.25c10.7 7.43 20.15-.87 22.28-3.94 5.09-7.23 3.31-17.2-3.91-22.28L245.5 69.11c13.05-3.13 25.54-8.55 36.31-16.47 23.5-17.36 43.74-23.89 62.09-19.14 33.62 8.73 60.71 36.33 68.99 70.31 7.3 30.1 1.59 59.88-16.16 83.85z"]
  },
      Tb = {
    prefix: "fal",
    iconName: "toothbrush",
    icon: [640, 512, [], "f635", "M624 416H448V224h-32v192h-32V224h-32v192h-32V224h-32v192h-32V224h-32v192h-32V224h-32v192h-32V224H96v192H64V224H32v192H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-16 64H32v-32h576v32zM64 192h352c35.35 0 64-28.65 64-64C480 57.31 422.69 0 352 0c23.62 23.62 6.89 64-26.51 64H64C28.65 64 0 92.65 0 128s28.65 64 64 64zm0-96h261.49c28.21 0 53.41-16.84 64.2-42.9 1.59-3.84 2.82-7.76 3.69-11.72C425.66 56.87 448 89.88 448 128c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32s14.36-32 32-32z"]
  },
      Db = {
    prefix: "fal",
    iconName: "torah",
    icon: [640, 512, [], "f6a0", "M210.64 255l-33.39 55.86a24.16 24.16 0 0 0 20.69 36.58H266l33.44 55.87A23.72 23.72 0 0 0 320 415a24.13 24.13 0 0 0 20.76-11.86l33.31-55.68h68a24.31 24.31 0 0 0 21.13-12.25 23.67 23.67 0 0 0-.28-24.15L429.35 255l33.42-55.86a24.16 24.16 0 0 0-20.7-36.58H374l-33.45-55.87A23.71 23.71 0 0 0 320.06 95a24.11 24.11 0 0 0-20.83 11.86l-33.31 55.68h-68a24.3 24.3 0 0 0-21.13 12.26 23.67 23.67 0 0 0 .28 24.12zm-4.14 63.46l21-35.24 21.1 35.24zm113.56 62.87l-20.29-33.89h40.55zm113.49-62.87H391.4l21.06-35.22zm-.06-126.92l-21 35.24-21.11-35.24zM320 128.69l20.22 33.87h-40.54zm-37.65 62.83h75.22l38 63.48-37.92 63.46h-75.23l-38-63.46zm-33.76 0l-21 35.22-21.1-35.22zM576-1c-28.32 0-51.57 13.22-60.2 32H124.2C115.57 12.22 92.32-1 64-1 28.12-1 0 20.08 0 47v416c0 26.92 28.12 48 64 48 28.32 0 51.57-13.22 60.2-32h391.6c8.63 18.78 31.88 32 60.2 32 35.88 0 64-21.08 64-48V47c0-26.92-28.12-48-64-48zM96 63v400c0 6.38-12.75 16-32 16s-32-9.62-32-16V47c0-6.37 12.75-16 32-16s32 9.63 32 16zm416 384H128V63h384zm96 16c0 6.38-12.75 16-32 16s-32-9.62-32-16V47c0-6.37 12.75-16 32-16s32 9.63 32 16z"]
  },
      jb = {
    prefix: "fal",
    iconName: "torii-gate",
    icon: [512, 512, [], "f6a1", "M480 160c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32h-240.9A303.17 303.17 0 0 1 0 0v128c0 17.67 14.33 32 32 32h32v96H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h56v216c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V288h320v216c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V288h56c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8h-56v-96h32zM32 128V47.56C65.39 58.38 100.49 64 135.55 64h240.89c35.07 0 70.17-5.62 103.55-16.44V128H32zm64 32h144v96H96v-96zm320 96H272v-96h144v96z"]
  },
      Eb = {
    prefix: "fal",
    iconName: "tornado",
    icon: [512, 512, [], "f76f", "M429.1 25.2c7.4-10.6 0-25.2-12.9-25.2h-400C7.1 0-.3 7.6 0 16.5c13.3 352.7 452 219.8 331.7 472.6-5 10.6 2.6 22.9 14.3 22.9h27.4c7.9 0 15.8-3 21.7-8.3 320.6-286.7-138.9-229.8 34-478.5zM386.7 32c-13.7 23.5-22 44.6-26.4 64H45.5C39.4 77.1 35 56 33 32h353.7zM58.4 128h298c-.1 24.5 6.8 45.5 17.2 64h-265c-19.9-17.3-37.1-38.1-50.2-64zm95.3 96h242.6c11.1 12.9 23.2 24.5 34.4 35.2 11.2 10.7 20.2 19.9 27.9 28.8H287.7c-15.9-8-32.7-15.5-49.8-23-28.6-12.6-57.5-25.3-84.2-41zm185.2 96h138.8c1.2 4.4 2.4 8.7 2.4 13.3-.2 14.4-6.8 31.4-19.1 50.7h-80.5c-1-4-1.6-8.1-3-11.9-7.9-21.2-21.5-37.9-38.6-52.1zm34.5 160h-2.9c8.9-23.3 13.2-44.4 13.6-64h53.1c-16.6 19.5-37.8 40.8-63.8 64z"]
  },
      kb = {
    prefix: "fal",
    iconName: "tractor",
    icon: [640, 512, [], "f722", "M176 256c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80-35.82-80-80-80zm0 120c-22.06 0-40-17.94-40-40s17.94-40 40-40 40 17.94 40 40-17.94 40-40 40zm432-184h-64v-10.95c0-22.36 7.8-43.5 22.13-60.33 2.77-3.25 2.81-7.98-.21-11l-11.33-11.33c-3.22-3.22-8.62-3.23-11.63.2-20.02 22.82-30.96 51.79-30.96 82.46V192H368.57L284.73 18.1A32.02 32.02 0 0 0 255.9 0H128c-17.67 0-32 14.33-32 32v155.75c-10.76-1.46-22.02 1.41-30.31 9.65l-28.28 28.28c-12.81 12.83-13.94 33-3.31 47.09-1.12 2.5-2.19 5.03-3.16 7.58C13.47 282.83 0 297.86 0 316v40c0 18.14 13.47 33.17 30.94 35.64.97 2.55 2.03 5.08 3.16 7.58-4.69 6.2-7.22 13.7-7.22 21.61-.03 9.62 3.72 18.69 10.53 25.48l28.28 28.28c12.88 12.83 33.03 13.94 47.09 3.33 2.5 1.11 5.03 2.16 7.56 3.14C122.81 498.52 137.88 512 156 512h40c18.12 0 33.19-13.48 35.66-30.94 2.53-.98 5.06-2.03 7.56-3.14 14.12 10.61 34.28 9.5 47.09-3.33l28.28-28.28c6.81-6.8 10.56-15.86 10.53-25.48 0-7.91-2.53-15.44-7.22-21.61 1.12-2.5 2.19-5.03 3.16-7.58 6.35-.9 11.82-3.88 16.66-7.64h84.15c-3.57 10.05-5.88 20.72-5.88 32 0 53.02 42.98 96 96 96s96-42.98 96-96c0-26.51-10.74-50.51-28.12-67.88l50.74-50.74c6-6 9.37-14.14 9.37-22.63V224c.02-17.67-14.31-32-31.98-32zM128 32h127.9l77.14 160h-54.6c-10.94-6.21-24.08-6.16-35.06 0h-9.17c-.86-.35-1.7-.73-2.56-1.06C229.19 173.48 214.12 160 196 160h-40c-11.53 0-21.4 5.81-28 14.27V32zm192 324c0 2.2-1.78 4-4 4h-18.41c-7.11 23.63-6.71 22.85-18.62 44.98l12.97 13.03.03 5.67-28.28 28.28c-1.56 1.61-4.09 1.55-5.66 0l-13-13c-21.74 11.68-21.66 11.65-45.03 18.61V476c0 2.2-1.78 4-4 4h-40c-2.22 0-4-1.8-4-4v-18.42c-23.37-6.96-23.29-6.93-45.03-18.61l-13 13a3.972 3.972 0 0 1-5.66 0l-28.28-28.28.03-5.67 12.97-13.03C61.11 382.84 61.51 383.6 54.41 360H36c-2.22 0-4-1.8-4-4v-40c0-2.2 1.78-4 4-4h18.41c7.15-23.77 6.72-22.83 18.62-45.02l-13-13a4.02 4.02 0 0 1 0-5.67l28.28-28.28c1.59-1.56 4.12-1.53 5.66 0l13 13c21.74-11.68 21.66-11.65 45.03-18.61V196c0-2.2 1.78-4 4-4h40c2.22 0 4 1.8 4 4v18.42c23.37 6.96 23.29 6.93 45.03 18.61l13-13c1.56-1.53 4.09-1.56 5.66 0l28.28 28.28a4.02 4.02 0 0 1 0 5.67l-13 13c11.91 22.2 11.48 21.28 18.62 45.02H316c2.22 0 4 1.8 4 4v40zm192 124c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm96-205.26l-54.85 54.85c-12.51-5.97-26.36-9.6-41.15-9.6-28.32 0-53.51 12.49-71.09 32H352v-36c0-18.14-13.47-33.17-30.94-35.64-.97-2.55-2.03-5.08-3.16-7.58 10.62-14.09 9.5-34.27-3.31-47.09l-1.69-1.69H608v50.75z"]
  },
      Ib = {
    prefix: "fal",
    iconName: "trademark",
    icon: [640, 512, [], "f25c", "M264.1 96H23.9c-6.6 0-12 5.4-12 12v15c0 6.6 5.4 12 12 12h97.7v269c0 6.6 5.4 12 12 12h20.9c6.6 0 12-5.4 12-12V135h97.7c6.6 0 12-5.4 12-12v-15c-.1-6.6-5.4-12-12.1-12zM640 403l-23.9-296c-.5-6.2-5.7-11-12-11H576c-4.8 0-9.2 2.9-11 7.3l-70.3 165.8c-7.3 17.7-15.9 43.1-15.9 43.1h-.9s-8.6-25.4-15.9-43.1l-70.3-165.8c-1.9-4.4-6.2-7.3-11-7.3h-28.1c-6.3 0-11.5 4.8-12 11l-23.9 296c-.6 7 5 13 12 13h20.7c6.3 0 11.5-4.8 12-11.1L376 214.3c1.4-19.5.9-48 .9-48h.9s10 30.8 17.2 48l60.3 137c1.9 4.4 6.2 7.2 11 7.2h24.3c4.7 0 9-2.8 11-7.1l60.7-137c7.7-17.7 17.2-47.1 17.2-47.1h.9s-.9 27.6.5 47.1l15 190.6c.5 6.2 5.7 11.1 12 11.1H628c7-.1 12.5-6.1 12-13.1z"]
  },
      Ob = {
    prefix: "fal",
    iconName: "traffic-cone",
    icon: [512, 512, [], "f636", "M504 480h-23.02L294.54 11.52A18.284 18.284 0 0 0 277.55 0h-43.11c-7.49 0-14.22 4.57-16.99 11.52L31.02 480H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h496c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM382.87 320H129.13l50.94-128h151.85l50.95 128zM243.75 32h24.5l50.94 128H192.81l50.94-128zM65.46 480l50.94-128h279.2l50.94 128H65.46z"]
  },
      Qb = {
    prefix: "fal",
    iconName: "traffic-light",
    icon: [416, 512, [], "f637", "M416 64V48h-80V28.44C336 12.73 323.27 0 307.55 0h-199.1C92.73 0 80 12.73 80 28.44V48H0v16c0 50.55 33.89 92.77 80 106.57V176H0v16c0 50.55 33.89 92.77 80 106.57V304H0v16c0 53.54 38.07 97.51 88.38 108.43C106.49 477.13 153 512 208 512s101.51-34.87 119.62-83.57C377.93 417.51 416 373.54 416 320v-16h-80v-5.43c46.11-13.8 80-56.02 80-106.57v-16h-80v-5.43c46.11-13.8 80-56.02 80-106.57zm-80 16h46.41c-5.24 25.62-23.05 46.21-46.41 56.56V80zM33.59 80H80v56.56C56.64 126.21 38.84 105.62 33.59 80zm0 128H80v56.56C56.64 254.21 38.84 233.62 33.59 208zm0 128H80v48c0 3.04.69 5.9.9 8.89-23.79-10.2-42-30.95-47.31-56.89zM304 384c0 52.93-43.06 96-96 96s-96-43.07-96-96V32h192v352zm78.41-48c-5.31 25.94-23.51 46.69-47.3 56.89.21-2.99.9-5.84.9-8.89v-48h46.4zm0-128c-5.24 25.62-23.05 46.21-46.41 56.56V208h46.41zM208 184c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0-88c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32zm0 216c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0-88c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32zm0 216c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0-88c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32z"]
  },
      Zb = {
    prefix: "fal",
    iconName: "traffic-light-go",
    icon: [416, 512, [], "f638", "M416 64V48h-80V28.44C336 12.73 323.27 0 307.55 0h-199.1C92.73 0 80 12.73 80 28.44V48H0v16c0 50.55 33.89 92.77 80 106.57V176H0v16c0 50.55 33.89 92.77 80 106.57V304H0v16c0 53.54 38.07 97.51 88.38 108.43C106.49 477.13 153 512 208 512s101.51-34.87 119.62-83.57C377.93 417.51 416 373.54 416 320v-16h-80v-5.43c46.11-13.8 80-56.02 80-106.57v-16h-80v-5.43c46.11-13.8 80-56.02 80-106.57zm-80 16h46.41c-5.24 25.62-23.05 46.21-46.41 56.56V80zM33.59 80H80v56.56C56.64 126.21 38.84 105.62 33.59 80zm0 128H80v56.56C56.64 254.21 38.84 233.62 33.59 208zm0 128H80v48c0 3.04.69 5.9.9 8.89-23.79-10.2-42-30.95-47.31-56.89zM304 384c0 52.93-43.06 96-96 96s-96-43.07-96-96V32h192v352zm78.41-48c-5.31 25.94-23.51 46.69-47.3 56.89.21-2.99.9-5.84.9-8.89v-48h46.4zm0-128c-5.24 25.62-23.05 46.21-46.41 56.56V208h46.41zM208 184c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0-88c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32zm0 216c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0-88c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32zm0 216c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56z"]
  },
      Ub = {
    prefix: "fal",
    iconName: "traffic-light-slow",
    icon: [416, 512, [], "f639", "M416 64V48h-80V28.44C336 12.73 323.27 0 307.55 0h-199.1C92.73 0 80 12.73 80 28.44V48H0v16c0 50.55 33.89 92.77 80 106.57V176H0v16c0 50.55 33.89 92.77 80 106.57V304H0v16c0 53.54 38.07 97.51 88.38 108.43C106.49 477.13 153 512 208 512s101.51-34.87 119.62-83.57C377.93 417.51 416 373.54 416 320v-16h-80v-5.43c46.11-13.8 80-56.02 80-106.57v-16h-80v-5.43c46.11-13.8 80-56.02 80-106.57zm-80 16h46.41c-5.24 25.62-23.05 46.21-46.41 56.56V80zM33.59 80H80v56.56C56.64 126.21 38.84 105.62 33.59 80zm0 128H80v56.56C56.64 254.21 38.84 233.62 33.59 208zm0 128H80v48c0 3.04.69 5.9.9 8.89-23.79-10.2-42-30.95-47.31-56.89zM304 384c0 52.93-43.06 96-96 96s-96-43.07-96-96V32h192v352zm78.41-48c-5.31 25.94-23.51 46.69-47.3 56.89.21-2.99.9-5.84.9-8.89v-48h46.4zm0-128c-5.24 25.62-23.05 46.21-46.41 56.56V208h46.41zM208 184c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0-88c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32zm0 216c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0 128c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0-88c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32z"]
  },
      Bb = {
    prefix: "fal",
    iconName: "traffic-light-stop",
    icon: [416, 512, [], "f63a", "M416 64V48h-80V28.44C336 12.73 323.27 0 307.55 0h-199.1C92.73 0 80 12.73 80 28.44V48H0v16c0 50.55 33.89 92.77 80 106.57V176H0v16c0 50.55 33.89 92.77 80 106.57V304H0v16c0 53.54 38.07 97.51 88.38 108.43C106.49 477.13 153 512 208 512s101.51-34.87 119.62-83.57C377.93 417.51 416 373.54 416 320v-16h-80v-5.43c46.11-13.8 80-56.02 80-106.57v-16h-80v-5.43c46.11-13.8 80-56.02 80-106.57zm-80 16h46.41c-5.24 25.62-23.05 46.21-46.41 56.56V80zM33.59 80H80v56.56C56.64 126.21 38.84 105.62 33.59 80zm0 128H80v56.56C56.64 254.21 38.84 233.62 33.59 208zm0 128H80v48c0 3.04.69 5.9.9 8.89-23.79-10.2-42-30.95-47.31-56.89zM304 384c0 52.93-43.06 96-96 96s-96-43.07-96-96V32h192v352zm78.41-48c-5.31 25.94-23.51 46.69-47.3 56.89.21-2.99.9-5.84.9-8.89v-48h46.4zm0-128c-5.24 25.62-23.05 46.21-46.41 56.56V208h46.41zM208 184c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0 128c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0-88c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32zm0 216c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56zm0-88c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32z"]
  },
      Rb = {
    prefix: "fal",
    iconName: "trailer",
    icon: [640, 512, [], "e041", "M632,352H544V96a32,32,0,0,0-32-32H32A32,32,0,0,0,0,96V352a32,32,0,0,0,32,32H68.58c7.59,0,13.69-5.44,15.64-12.78C96.91,323.36,140.14,288,192,288s95.09,35.36,107.78,83.22c2,7.34,8.05,12.78,15.64,12.78H632a8,8,0,0,0,8-8V360A8,8,0,0,0,632,352Zm-120,0H326.61c-19.72-55.77-72.06-96-134.61-96S77.11,296.23,57.39,352H32V96H512ZM192,320a80,80,0,1,0,80,80A80,80,0,0,0,192,320Zm0,128a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,448ZM360,320h16a8,8,0,0,0,8-8V136a8,8,0,0,0-8-8H360a8,8,0,0,0-8,8V312A8,8,0,0,0,360,320Zm96,0h16a8,8,0,0,0,8-8V136a8,8,0,0,0-8-8H456a8,8,0,0,0-8,8V312A8,8,0,0,0,456,320ZM96,136a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V279.45A177.09,177.09,0,0,1,96,252.6Zm96,0a8,8,0,0,0-8-8H168a8,8,0,0,0-8,8v91.05A175.77,175.77,0,0,1,192,224Zm96,0a8,8,0,0,0-8-8H264a8,8,0,0,0-8,8V236.18a175,175,0,0,1,32,16.42Z"]
  },
      Yb = {
    prefix: "fal",
    iconName: "train",
    icon: [448, 512, [], "f238", "M224 320c8.823 0 16 7.177 16 16s-7.177 16-16 16-16-7.177-16-16 7.177-16 16-16m0-32c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM320 0H128C64 0 0 42.981 0 96v256c0 47.169 50.656 86.391 106.9 94.473l-55.285 55.285c-3.78 3.78-1.103 10.243 4.243 10.243h25.798c3.183 0 6.235-1.264 8.485-3.515L150.627 448h146.745l60.486 60.485a12.002 12.002 0 0 0 8.485 3.515h25.798c5.345 0 8.022-6.463 4.243-10.243L341.1 446.472C397.344 438.391 448 399.169 448 352V96c0-53.019-63-96-128-96zM32 128h384v96H32v-96zm96-96h192c58.237 0 96 37.881 96 64H32c0-32.299 47.552-64 96-64zm192 384H128c-48.448 0-96-31.701-96-64v-96h384v96c0 32.299-47.552 64-96 64z"]
  },
      Pb = {
    prefix: "fal",
    iconName: "tram",
    icon: [512, 512, [], "f7da", "M511.6 76.4c-2-8.6-10.5-13.9-19.2-11.9l-480 112c-8.6 2-14 10.6-12 19.2C2.2 203 8.7 208 16 208c1.2 0 2.4-.1 3.6-.4L240 156.2V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-75.3l227.6-53.1c8.6-2 14-10.6 12-19.2zM64 256h96v96H64v-96zm288 0h96v96h-96v-96zm96 128v96H64v-96h384zM320 256v96H192v-96h128zM176 128c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm0-64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm128 32c26.5 0 48-21.5 48-48S330.5 0 304 0s-48 21.5-48 48 21.5 48 48 48zm0-64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"]
  },
      Fb = {
    prefix: "fal",
    iconName: "transgender",
    icon: [384, 512, [], "f224", "M160 383.1c72-8 128-69 128-143.1 0-34-11.8-65.2-31.5-89.9L352 54.6V100c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V12c0-6.6-5.4-12-12-12h-88c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h45.4l-95.5 95.5C209.2 107.8 178 96 144 96 64.5 96 0 160.5 0 240c0 74.1 56 135.2 128 143.1V424H76c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h52v44c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-44h52c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-52v-40.9zM144 352c-61.9 0-112-50-112-112 0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112z"]
  },
      Wb = {
    prefix: "fal",
    iconName: "transgender-alt",
    icon: [480, 512, [], "f225", "M468 0h-88c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h45.4l-95.5 95.5C305.2 107.8 274 96 240 96s-65.2 11.8-89.9 31.5l-28.9-28.9 31.1-31.1c4.7-4.7 4.7-12.3 0-17l-5.7-5.7c-4.7-4.7-12.3-4.7-17 0L98.6 76l-44-44H100c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H12C5.4 0 0 5.4 0 12v88c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V54.6l44 44-31.1 31.1c-4.7 4.7-4.7 12.3 0 17l5.7 5.7c4.7 4.7 12.3 4.7 17 0l31.1-31.1 28.9 28.9C107.8 174.8 96 206 96 240c0 74.1 56 135.2 128 143.1V424h-52c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h52v44c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-44h52c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-52v-40.9c72-8 128-69 128-143.1 0-34-11.8-65.2-31.5-89.9L448 54.6V100c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V12c0-6.6-5.4-12-12-12zM240 352c-61.9 0-112-50-112-112 0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112z"]
  },
      Gb = {
    prefix: "fal",
    iconName: "transporter",
    icon: [512, 512, [], "e042", "M509.789,44.43164l-29.786-12.41992L467.5828,2.22656a3.99313,3.99313,0,0,0-7.15449,0L448.00806,32.01172l-29.786,12.41992a4.00079,4.00079,0,0,0,0,7.1543l29.786,12.41992L460.42831,93.791a3.9947,3.9947,0,0,0,7.15449,0l12.42025-29.78516,29.786-12.41992a3.99921,3.99921,0,0,0,0-7.1543ZM95.98694,111.99609a4.37766,4.37766,0,0,0-2.211-3.57617L63.99194,96,51.57169,66.21484a3.99471,3.99471,0,0,0-7.15644,0L31.995,96,2.211,108.41992a3.99921,3.99921,0,0,0,0,7.1543l29.784,12.41992L44.41525,157.7793a3.99628,3.99628,0,0,0,7.15644,0l12.42025-29.78516,29.784-12.41992A4.38918,4.38918,0,0,0,95.98694,111.99609Zm263.02265,34.541a95.381,95.381,0,0,0-46.73953-30.17773A71.27468,71.27468,0,0,0,327.99509,72,72.0822,72.0822,0,0,0,255.99316,0H255.96A72.0822,72.0822,0,0,0,183.958,72a71.28393,71.28393,0,0,0,15.73479,44.375,95.36491,95.36491,0,0,0-46.6946,30.16406L84.98274,228.1543a55.97446,55.97446,0,0,0,7.16621,78.873,56.12369,56.12369,0,0,0,67.85532,2.92774V416h-.00976A63.999,63.999,0,0,0,95.9928,480v16a15.99975,15.99975,0,0,0,16.00042,16h288.0077a16.001,16.001,0,0,0,16.00042-16V480a64.00028,64.00028,0,0,0-63.99194-63.998V309.96875a56.00117,56.00117,0,0,0,74.99419-81.84766ZM255.96,32l.01758.002.01562-.002a40,40,0,1,1,0,80l-.01562-.00195L255.96,112a40,40,0,1,1,0-80ZM384.00049,480H127.99365a32.03709,32.03709,0,0,1,32.00086-32H351.99963A32.03709,32.03709,0,0,1,384.00049,480Zm15.38517-197.5625a24.00925,24.00925,0,0,1-33.8134-3.07812l-45.5852-54.69922V256h.02149V416H271.9975V320H239.99664v96H192.00513V224.70117l-45.56372,54.65821a23.99729,23.99729,0,1,1-36.876-30.71876l68.01548-81.61328A64.0009,64.0009,0,0,1,226.74824,144h58.51328a64.00441,64.00441,0,0,1,49.16538,23.02539l68.02135,81.61523A23.976,23.976,0,0,1,399.38566,282.4375Z"]
  },
      qb = {
    prefix: "fal",
    iconName: "transporter-1",
    icon: [512, 512, [], "e043", "M159.99451,309.95508V320h32.00085V224.70117l-45.56372,54.65821c-5.174,6.20117-20.22514,14.34374-33.8134,3.07812a23.976,23.976,0,0,1-3.06258-33.79688l68.01549-81.61328A64.0009,64.0009,0,0,1,226.73848,144h58.51328a64.0044,64.0044,0,0,1,49.16537,23.02539l68.02135,81.61523a23.976,23.976,0,0,1-3.06258,33.79688c-13.58044,11.26953-28.47928,3.32617-33.8134-3.07812l-45.58521-54.69922V256h.02149v64h32.00085V309.96875a56.00117,56.00117,0,0,0,74.99419-81.84766l-67.994-81.584a95.381,95.381,0,0,0-46.73953-30.17773A71.27468,71.27468,0,0,0,327.98532,72,72.0822,72.0822,0,0,0,255.9834,0h-.03321a72.0822,72.0822,0,0,0-72.00192,72,71.28394,71.28394,0,0,0,15.7348,44.375,95.365,95.365,0,0,0-46.69461,30.16406L84.973,228.1543a55.97448,55.97448,0,0,0,7.16621,78.873,56.12371,56.12371,0,0,0,67.85533,2.92774ZM255.95019,32l.01758.002L255.9834,32a40,40,0,1,1,0,80l-.01563-.00195L255.95019,112a40,40,0,1,1,0-80Zm64.04859,352h32.00085V352H319.99878ZM95.98694,144a4.38058,4.38058,0,0,0-2.20905-3.57812L63.99194,128.002,51.57169,98.21875a3.99313,3.99313,0,0,0-7.15449,0L31.997,128.002,2.211,140.42188a4.00078,4.00078,0,0,0,0,7.15624l29.786,12.41993,12.42025,29.7832a3.99313,3.99313,0,0,0,7.15449,0l12.42025-29.7832,29.786-12.41993A4.39161,4.39161,0,0,0,95.98694,144ZM351.99963,416.002V416H159.98474A63.999,63.999,0,0,0,95.983,480v16a15.99975,15.99975,0,0,0,16.00043,16H399.99115a16.001,16.001,0,0,0,16.00043-16V480A64.00028,64.00028,0,0,0,351.99963,416.002ZM127.98389,480a32.03709,32.03709,0,0,1,32.00085-32H351.98987a32.03709,32.03709,0,0,1,32.00085,32ZM509.789,364.41992,480.005,352l-12.42026-29.78516a3.99471,3.99471,0,0,0-7.15644,0L448.00806,352l-29.784,12.41992a3.99921,3.99921,0,0,0,0,7.1543l29.784,12.41992,12.42025,29.78516a3.99628,3.99628,0,0,0,7.15644,0L480.005,383.99414l29.784-12.41992a3.99921,3.99921,0,0,0,0-7.1543ZM159.99451,384h32.00085V352H159.99451Zm111.99322,0V352H239.98688v32Z"]
  },
      Jb = {
    prefix: "fal",
    iconName: "transporter-2",
    icon: [512, 512, [], "e044", "M191.99609,256V224.70117L165.90545,256Zm79.99268,128V352h-32.001v32ZM352.001,352H320v32h32.001ZM319.97851,224.66016V256h26.118ZM177.57183,167.02734A64.00122,64.00122,0,0,1,226.73934,144h58.51351a64.00476,64.00476,0,0,1,49.16556,23.02539L355.2335,192H396.891l-37.88983-45.46289a95.38141,95.38141,0,0,0-46.73971-30.17773A71.2745,71.2745,0,0,0,327.98657,72a72.08234,72.08234,0,0,0-72.0022-72h-.0332A72.08235,72.08235,0,0,0,183.949,72a71.28375,71.28375,0,0,0,15.73486,44.375A95.36539,95.36539,0,0,0,152.989,146.53906L115.10312,192h41.65752ZM255.95117,32l.01758.002.01562-.002a40,40,0,1,1,0,80l-.01562-.00195L255.95117,112a40,40,0,1,1,0-80ZM130.09186,224H88.43629c-13.88714,16.6582-14.895,26.08984-15.74071,32h32.874C107.681,250.08984,107.30406,251.3418,130.09186,224ZM320,320h32.001V309.96875A55.675,55.675,0,0,0,434.45271,288H320Zm32.001,96.002V416H159.98535a63.99914,63.99914,0,0,0-64.002,64v16a15.99979,15.99979,0,0,0,16.00049,16H399.99268a16.001,16.001,0,0,0,16.00048-16V480A64.00039,64.00039,0,0,0,352.001,416.002ZM127.98437,480a32.03716,32.03716,0,0,1,32.001-32H351.99121a32.03716,32.03716,0,0,1,32.001,32ZM381.90423,224c22.75656,27.30469,22.4128,26.0957,24.52419,32h32.87014c-.85745-5.99219-1.91607-15.41211-15.73681-32ZM159.99512,309.95508V320h32.001V288H77.54143a55.62546,55.62546,0,0,0,14.5981,19.02734,56.12409,56.12409,0,0,0,67.85559,2.92774Zm0,74.04492h32.001V352h-32.001ZM509.791,140.416l-29.78607-12.41993-12.4203-29.7832a3.99315,3.99315,0,0,0-7.15451,0l-12.4203,29.7832L418.2237,140.416a4.00079,4.00079,0,0,0,0,7.15625l29.78607,12.41992,12.4203,29.7832a3.99315,3.99315,0,0,0,7.15451,0l12.4203-29.7832L509.791,147.57227a4.00237,4.00237,0,0,0,0-7.15625ZM95.9873,48a4.37811,4.37811,0,0,0-2.211-3.57812L63.99023,32.002,51.56993,2.21875a3.99315,3.99315,0,0,0-7.15451,0L31.99512,32.002,2.20905,44.42188a4.00078,4.00078,0,0,0,0,7.15429L31.99512,63.99609l12.4203,29.78516a3.99315,3.99315,0,0,0,7.15451,0l12.4203-29.78516L93.7763,51.57617A4.38313,4.38313,0,0,0,95.9873,48Z"]
  },
      Kb = {
    prefix: "fal",
    iconName: "transporter-3",
    icon: [512, 512, [], "e045", "M191.99609,287.99658H77.54143a55.62634,55.62634,0,0,0,14.5981,19.02764,56.12343,56.12343,0,0,0,67.85559,2.92778v10.04507h32.001Zm63.98828-256.0039h-.0332l.01758.002Zm56.27711,84.36066a73.90664,73.90664,0,0,0,11.44566-20.35969H287.15329c-7.31663,9.48648-18.26813,16.00025-31.16892,16.00025l-.01562-.002-.01758.002c-12.90078,0-23.85229-6.51377-31.16892-16.00025H188.2284A73.92186,73.92186,0,0,0,199.68383,116.369a99.67188,99.67188,0,0,0-25.58867,11.62518H337.88922A99.67424,99.67424,0,0,0,312.26148,116.35334ZM271.98877,383.99805V351.99756h-32.001v32.00049ZM255.95117,31.99268H196.13684a71.52385,71.52385,0,0,0-11.37925,32.00048h32.81546C221.40324,45.87765,236.77285,31.99268,255.95117,31.99268Zm64.02734,192.66309v31.34032h26.118ZM352.001,351.99756H320v32.00049h32.001ZM294.3625,63.99316H327.178A71.52373,71.52373,0,0,0,315.7987,31.99268H255.98437C275.16269,31.99268,290.5323,45.87765,294.3625,63.99316Zm40.05591,103.027,20.81509,24.975H396.891l-26.66878-32.00049H327.1135A63.421,63.421,0,0,1,334.41841,167.02013ZM320,319.99707h32.001v-10.0314a55.67477,55.67477,0,0,0,82.45173-21.96909H320Zm61.90423-96.00146,20.53579,24.641a23.60865,23.60865,0,0,1,3.9884,7.35948h32.87014c-.85745-5.99228-1.91607-15.41234-15.73681-32.00048ZM159.99512,383.99805h32.001V351.99756h-32.001ZM352.001,416.00049v-.002H159.98535a63.99963,63.99963,0,0,0-64.002,64.001v16.00025A15.99991,15.99991,0,0,0,111.98389,512H399.99268a16.00115,16.00115,0,0,0,16.00048-16.00024V479.99951A64.00087,64.00087,0,0,0,352.001,416.00049Zm-224.01661,63.999a32.0374,32.0374,0,0,1,32.001-32.00049H351.99121a32.0374,32.0374,0,0,1,32.001,32.00049Zm49.58746-312.97743a63.29146,63.29146,0,0,1,7.30686-7.02745H141.7719l-26.66878,32.00049h41.65752Zm14.42426,57.67471-26.09064,31.2993h26.09064Zm-82.44,23.93982,20.53578-24.641H88.43629c-13.88714,16.65845-14.895,26.09024-15.74071,32.00048h32.874A23.60261,23.60261,0,0,1,109.55608,248.63661ZM509.791,44.42451,480.00488,32.00439,467.58458,2.21878a3.99313,3.99313,0,0,0-7.15451,0l-12.4203,29.78561L418.2237,44.42451a3.99929,3.99929,0,0,0,0,7.1544L448.00977,63.999l12.4203,29.78561a3.99469,3.99469,0,0,0,7.15451,0L480.00488,63.999,509.791,51.57891a4.00087,4.00087,0,0,0,0-7.1544ZM93.7763,364.42158,63.99023,352.00146l-12.4203-29.78365a3.99312,3.99312,0,0,0-7.15451,0l-12.4203,29.78365L2.20905,364.42158a4.00246,4.00246,0,0,0,0,7.15636l29.78607,12.42011,12.4203,29.78365a3.99312,3.99312,0,0,0,7.15451,0l12.4203-29.78365L93.7763,371.57794a4.00088,4.00088,0,0,0,0-7.15636Z"]
  },
      Xb = {
    prefix: "fal",
    iconName: "transporter-empty",
    icon: [512, 512, [], "e046", "M509.791,268.419l-29.78607-12.42-12.4203-29.78527a3.99315,3.99315,0,0,0-7.15451,0L448.00977,255.999l-29.78607,12.42a3.99924,3.99924,0,0,0,0,7.15433l29.78607,12.42,12.4203,29.78527a3.99471,3.99471,0,0,0,7.15451,0l12.4203-29.78527,29.78607-12.42a4.00082,4.00082,0,0,0,0-7.15433ZM93.7763,44.422l-29.78607-12.42L51.56993,2.21876a3.99314,3.99314,0,0,0-7.15451,0L31.99512,32.00208,2.20905,44.422a4.0024,4.0024,0,0,0,0,7.15628l29.78607,12.42,12.4203,29.78332a3.99314,3.99314,0,0,0,7.15451,0l12.4203-29.78332,29.78607-12.42a4.00082,4.00082,0,0,0,0-7.15628ZM352.001,416.00159v-.002H159.98535a63.99927,63.99927,0,0,0-64.002,64.00025v16.00006A15.99982,15.99982,0,0,0,111.98389,512H399.99268a16.00106,16.00106,0,0,0,16.00048-16.00006V479.99988A64.0005,64.0005,0,0,0,352.001,416.00159ZM127.98437,479.99988a32.03721,32.03721,0,0,1,32.001-32.00012H351.99121a32.03721,32.03721,0,0,1,32.001,32.00012Z"]
  },
      _b = {
    prefix: "fal",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", "M440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h18.9l33.2 372.3a48 48 0 0 0 47.8 43.7h232.2a48 48 0 0 0 47.8-43.7L421.1 96H440a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zm184.8 427a15.91 15.91 0 0 1-15.9 14.6H107.9A15.91 15.91 0 0 1 92 465.4L59 96h330z"]
  },
      $b = {
    prefix: "fal",
    iconName: "trash-alt",
    icon: [448, 512, [], "f2ed", "M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z"]
  },
      cS = {
    prefix: "fal",
    iconName: "trash-restore",
    icon: [448, 512, [], "f829", "M440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h18.9l33.2 372.3a48 48 0 0 0 47.8 43.7h232.2a48 48 0 0 0 47.8-43.7L421.1 96H440a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zm184.8 427a15.91 15.91 0 0 1-15.9 14.6H107.9A15.91 15.91 0 0 1 92 465.4L59 96h330zM155.33 288H208v120a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V288h52.66a26.94 26.94 0 0 0 25-16.72 28.38 28.38 0 0 0-5.44-30.81l-68.12-71.78c-10.69-11.19-29.51-11.2-40.19 0l-68.12 71.75a28.43 28.43 0 0 0-5.44 30.83A26.94 26.94 0 0 0 155.33 288zM224 194l58.84 62h-117.7z"]
  },
      eS = {
    prefix: "fal",
    iconName: "trash-restore-alt",
    icon: [448, 512, [], "f82a", "M440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zM155.35 288H208v120a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V288h52.66a26.94 26.94 0 0 0 25-16.72 28.38 28.38 0 0 0-5.44-30.81l-68.12-71.8c-10.69-11.19-29.51-11.2-40.19 0l-68.12 71.75a28.43 28.43 0 0 0-5.44 30.83 26.94 26.94 0 0 0 25 16.75zM224 194l58.84 62H165.16z"]
  },
      aS = {
    prefix: "fal",
    iconName: "trash-undo",
    icon: [448, 512, [], "f895", "M440 64H336l-33.59-44.8C294.44 8.59 277.25 0 264 0h-80c-13.25 0-30.44 8.59-38.41 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h18.91l33.18 372.3c2.19 24.12 23.6 43.7 47.82 43.7h232.18c24.22 0 45.63-19.58 47.82-43.7L421.09 96H440a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.19 38.41A18.15 18.15 0 0 1 184 32h80a18.15 18.15 0 0 1 12.81 6.41L296 64H152zm184.81 427A16.2 16.2 0 0 1 340.16 480H107.84A16.2 16.2 0 0 1 92 465.41L59 96h330zM192.75 360.34A28 28 0 0 0 240 340v-52h16a48.05 48.05 0 0 1 48 48 16 16 0 0 0 32 0 80.09 80.09 0 0 0-80-80h-16v-52a28 28 0 0 0-47.25-20.34l-72 68a28 28 0 0 0 0 40.68zM208 213.28v117.44L145.81 272z"]
  },
      nS = {
    prefix: "fal",
    iconName: "trash-undo-alt",
    icon: [448, 512, [], "f896", "M440 64H336l-33.59-44.8C294.44 8.59 277.25 0 264 0h-80c-13.25 0-30.44 8.59-38.41 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.19 38.41A18.15 18.15 0 0 1 184 32h80a18.15 18.15 0 0 1 12.81 6.41L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zM192.75 360.34A28 28 0 0 0 240 340v-52h16a48.05 48.05 0 0 1 48 48 16 16 0 0 0 32 0 80.09 80.09 0 0 0-80-80h-16v-52a28 28 0 0 0-47.25-20.34l-72 68a28 28 0 0 0 0 40.68zM208 213.28v117.44L145.81 272z"]
  },
      tS = {
    prefix: "fal",
    iconName: "treasure-chest",
    icon: [576, 512, [], "f723", "M480 32H96C42.98 32 0 74.98 0 128v320c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V128c0-53.02-42.98-96-96-96zM96 448H32V288h64v160zm0-192H32V128c0-35.29 28.71-64 64-64v192zm352 192H128V288h64v48c0 26.47 21.53 48 48 48h96c26.47 0 48-21.53 48-48v-48h64v160zM224 336V208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v128c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16zm224-80h-64v-48c0-26.47-21.53-48-48-48h-96c-26.47 0-48 21.53-48 48v48h-64V64h320v192zm96 192h-64V288h64v160zm0-192h-64V64c35.29 0 64 28.71 64 64v128zm-256 64c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16s-16 7.16-16 16v64c0 8.84 7.16 16 16 16z"]
  },
      rS = {
    prefix: "fal",
    iconName: "tree",
    icon: [448, 512, [], "f1bb", "M444.09 389.46l-74.12-85.55H400c6.22 0 11.91-3.61 14.5-9.27 2.62-5.66 1.75-12.32-2.28-17.07l-72.5-85.71H368c6.31 0 12.03-3.72 14.62-9.49 2.56-5.78 1.5-12.52-2.72-17.23L235.9 5.07c-6.12-6.75-17.69-6.75-23.81 0l-144 160.07a16.06 16.06 0 0 0-2.72 17.23c2.59 5.77 8.31 9.49 14.62 9.49h28.28l-72.5 85.71c-4.03 4.75-4.91 11.41-2.28 17.07 2.59 5.66 8.28 9.27 14.5 9.27h30.03L3.91 389.46c-4.09 4.74-5.06 11.44-2.47 17.13 2.62 5.71 8.31 9.36 14.56 9.36h160v24.46l-24.2 48.42c-5.32 10.64 2.42 23.17 14.31 23.17h115.78c11.89 0 19.63-12.52 14.31-23.17L272 440.41v-24.46h160c6.25 0 11.94-3.66 14.56-9.36 2.6-5.69 1.63-12.39-2.47-17.13zM192 479.98l16-32.01v-32.02h32v32.02l16 32.01h-64zM50.78 384l96-112H82.5l94.78-112h-61.34L224 39.92 332.06 160h-61.34l94.78 112h-64.28l96 112H50.78z"]
  },
      iS = {
    prefix: "fal",
    iconName: "tree-alt",
    icon: [512, 512, [], "f400", "M459.94 202.98c2.69-8.86 4.06-17.89 4.06-26.98 0-52.94-43.06-96-96-96-5.75 0-11.44.53-17.09 1.56C343.94 35.45 304.03 0 256 0s-87.94 35.45-94.91 81.56A95.058 95.058 0 0 0 144 80c-52.94 0-96 43.06-96 96 0 9.09 1.38 18.12 4.06 26.98C20.34 219.17 0 251.53 0 288c0 52.94 43.06 96 96 96h112v56.45l-24.2 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h115.78c11.89 0 19.63-12.52 14.31-23.16l-24.2-48.4V384h112c52.94 0 96-43.06 96-96 0-36.47-20.34-68.83-52.06-85.02zM224 480l16-32v-64h32v64l16 32h-64zm192-128H96c-35.28 0-64-28.7-64-64 0-28.12 18.28-52.59 45.47-60.88l18.16-5.53-8.53-16.97C82.41 195.25 80 185.61 80 176c0-35.3 28.72-64 64-64 14.34 0 19.95 2.94 51.16 16.98-2.9-31.7-2.28-25.42-3.16-32.98 0-35.3 28.72-64 64-64s64 28.7 63.75 66.42l-2.91 30.56C345.08 116.28 352.1 112 368 112c35.28 0 64 28.7 64 64 0 9.61-2.41 19.25-7.09 28.62l-8.53 16.97 18.16 5.53C461.72 235.41 480 259.88 480 288c0 35.3-28.72 64-64 64z"]
  },
      oS = {
    prefix: "fal",
    iconName: "tree-christmas",
    icon: [512, 512, [], "f7db", "M304 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm-32-144c0-26.5-21.5-48-48-48s-48 21.5-48 48 21.5 48 48 48 48-21.5 48-48zm-48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm281.3 172.4l-84.5-108.7c10.5-1.6 19.7-8.3 24.3-18.1 5.3-11.2 3.6-24.5-4.4-34.1l-134.1-161 27.9-13.9c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-33.1-16.6-16.6-33.1C279.2 6.8 268.1 0 256 0c-12.1 0-23.2 6.8-28.6 17.7l-16.6 33.1-33.1 16.6C166.8 72.8 160 83.9 160 96s6.8 23.2 17.7 28.6l27.9 13.9-134.1 161c-7.9 9.5-9.7 22.8-4.4 34.1 4.6 9.8 13.8 16.5 24.3 18.1L6.7 460.4c-7.5 9.6-8.9 22.7-3.5 33.7S19.8 512 32 512h448c12.2 0 23.4-7 28.7-17.9s4.1-24.1-3.4-33.7zM192 96l42.7-21.3L256 32l21.3 42.7L320 96l-42.7 21.3L256 160l-21.3-42.7L192 96zM32 480l124.4-160H96l127.6-153.2 3.7 7.5c5.4 10.8 16.5 17.7 28.6 17.7 12.1 0 23.2-6.8 28.6-17.7l3.7-7.5L416 320h-60.4L480 480H32z"]
  },
      lS = {
    prefix: "fal",
    iconName: "tree-decorated",
    icon: [512, 512, [], "f7dc", "M505.3 460.4L445.9 384h2.1c12.1 0 23.2-6.8 28.6-17.7 5.4-10.8 4.3-23.8-3-33.5l-82.2-109.7c9.3-2.2 17.2-8.5 21.5-17.3 5.3-11.1 3.8-24.2-3.9-33.9L281 12c-6.1-7.6-15.3-12-25-12s-18.9 4.4-25 12L103 172c-7.7 9.6-9.2 22.8-3.9 33.9 4.2 8.8 12.2 15.1 21.5 17.3L38.4 332.8c-7.3 9.7-8.4 22.7-3 33.5C40.8 377.2 51.9 384 64 384h2.1L6.7 460.4c-7.5 9.6-8.9 22.7-3.5 33.7C8.6 505 19.8 512 32 512h448c12.2 0 23.4-7 28.7-17.9 5.4-11 4.1-24.1-3.4-33.7zM32 480l99.6-128H64l120-160h-56L256 32l128 160h-56l120 160h-67.6L480 480H32zm272-128c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM192 256c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm80-96c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm0-64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"]
  },
      fS = {
    prefix: "fal",
    iconName: "tree-large",
    icon: [512, 512, [], "f7dd", "M505.3 460.4L445.9 384h2.1c12.1 0 23.2-6.8 28.6-17.7 5.4-10.8 4.3-23.8-3-33.5l-82.2-109.7c9.3-2.2 17.2-8.5 21.5-17.3 5.3-11.1 3.8-24.2-3.9-33.9L281 12c-6.1-7.6-15.3-12-25-12s-18.9 4.4-25 12L103 172c-7.7 9.6-9.2 22.8-3.9 33.9 4.2 8.8 12.2 15.1 21.5 17.3L38.4 332.8c-7.3 9.7-8.4 22.7-3 33.5C40.8 377.2 51.9 384 64 384h2.1L6.7 460.4c-7.5 9.6-8.9 22.7-3.5 33.7S19.8 512 32 512h448c12.2 0 23.4-7 28.7-17.9s4.1-24.1-3.4-33.7zM32 480l99.6-128H64l120-160h-56L256 32l128 160h-56l120 160h-67.6L480 480H32z"]
  },
      sS = {
    prefix: "fal",
    iconName: "tree-palm",
    icon: [640, 512, [], "f82b", "M464.75 64c-44.62 0-87.12 14.79-119.87 39.86C323.48 44 255.61 0 175.25 0 87.35 0 13.85 51.27.54 121.89-3.14 141.44 12.45 160 34 160h59.63L128 132.48l13.29 10.65c-.57.56-1.22 1-1.79 1.54-62.19 62.19-77.88 150.39-37.35 209.72 11 16.08 34.89 19.05 51.1 2.77l120.63-132.22c3 101.71-20.34 201.93-32.72 246.59A31.84 31.84 0 0 0 271.63 512h90.43a31.66 31.66 0 0 0 31.38-26.77c15-93 1.68-192.71-12.49-261.23h89.67L496 198.62 521.37 224H606c21.46 0 37.14-18.44 33.46-38.11C626.15 115.27 552.65 64 464.75 64zM128 91.52L82.41 128 32 127.83C42.29 73.2 103.88 32 175.25 32c53.68 0 100.35 22.88 125.34 56.57-43.22-8.29-92.35 3.48-134.31 33.55zm.59 244.82c-31.37-45.89-16.94-118.56 33.53-169 32.5-32.49 73.47-49.8 110.84-49.8a104.67 104.67 0 0 1 46.22 10.23zM362.06 480l-90.06.05c14.13-50.91 42.32-171.45 32.29-288.46l28.14-30.84C344.55 202.9 382.73 351 362.06 480zm172.56-288L496 153.38 457.37 192h-83.53c-8.77-36.44-15.86-57.13-16.15-58 27.79-24 66.41-38 107.06-38 71.37 0 133 41.2 141.25 96z"]
  },
      uS = {
    prefix: "fal",
    iconName: "trees",
    icon: [640, 512, [], "f724", "M636.09 389.46l-74.12-85.55H592c6.22 0 11.91-3.61 14.5-9.27 2.62-5.66 1.75-12.32-2.28-17.07l-72.5-85.71H560c6.31 0 12.03-3.72 14.62-9.49 2.56-5.78 1.5-12.52-2.72-17.23L427.9 5.07c-6.12-6.75-17.69-6.75-23.81 0L320 98.55 235.91 5.07c-6.12-6.75-17.69-6.75-23.81 0l-144 160.07a16.06 16.06 0 0 0-2.72 17.23c2.59 5.77 8.31 9.49 14.62 9.49h28.28l-72.5 85.71c-4.03 4.75-4.91 11.41-2.28 17.07 2.59 5.66 8.28 9.27 14.5 9.27h30.03L3.91 389.46c-4.09 4.74-5.06 11.44-2.47 17.13 2.62 5.71 8.31 9.36 14.56 9.36h160v24.46l-24.2 48.42c-5.32 10.64 2.42 23.17 14.31 23.17h115.78c11.89 0 19.63-12.52 14.31-23.17L272 440.41v-24.46h96v24.46l-24.2 48.42c-5.32 10.64 2.42 23.17 14.31 23.17h115.78c11.89 0 19.63-12.52 14.31-23.17L464 440.41v-24.46h160c6.25 0 11.94-3.66 14.56-9.36 2.6-5.69 1.63-12.39-2.47-17.13zM192 479.98l16-32.01v-32.02h32v32.02l16 32.01h-64zM50.78 384l96-112H82.5l94.78-112h-61.34L224 39.92 332.06 160h-61.34l94.78 112h-64.28l96 112H50.78zM384 479.98l16-32.01v-32.02h32v32.02l16 32.01h-64zM439.36 384l-69.39-80.1H400c6.22 0 11.91-3.61 14.5-9.27 2.62-5.66 1.75-12.32-2.28-17.07l-72.5-85.71H368c6.31 0 12.03-3.72 14.62-9.49 2.56-5.78 1.5-12.52-2.72-17.23l-38.29-42.56L416 39.92 524.06 160h-61.34l94.78 112h-64.28l96 112H439.36z"]
  },
      hS = {
    prefix: "fal",
    iconName: "triangle",
    icon: [576, 512, [], "f2ec", "M329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.9 0 60-40 41.6-72l-240-416zM528 480H48c-12.3 0-20-13.3-13.9-24l240-416c6.1-10.6 21.6-10.7 27.7 0l240 416c6.2 10.6-1.5 24-13.8 24z"]
  },
      mS = {
    prefix: "fal",
    iconName: "triangle-music",
    icon: [512, 512, [], "f8e2", "M256.07 256A64.69 64.69 0 1 0 311 287.68L509.66 89a8 8 0 0 0 0-11.31l-11.31-11.35a8 8 0 0 0-11.31 0L288.38 265.05a63.34 63.34 0 0 0-32.31-9.05zm0 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zM413 230.88l-23.25 23.25 80.83 130.81a60.79 60.79 0 0 1 1.42 62.39A64.17 64.17 0 0 1 415.86 480H96.14A64.18 64.18 0 0 1 40 447.31a60.79 60.79 0 0 1 1.43-62.39l159.87-258.7a64.69 64.69 0 0 1 109.47 0l27.2 44L361.18 147 338 109.38C323.26 85.61 299.22 70.54 272.06 66V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v58c-27.21 4.49-51.31 19.57-66 43.4L14.19 368.09A92.46 92.46 0 0 0 12 462.91 96.16 96.16 0 0 0 96.14 512h319.72A96.16 96.16 0 0 0 500 462.91a92.46 92.46 0 0 0-2.16-94.82z"]
  },
      vS = {
    prefix: "fal",
    iconName: "trophy",
    icon: [576, 512, [], "f091", "M448 64V12c0-6.6-5.4-12-12-12H140c-6.6 0-12 5.4-12 12v52H12C5.4 64 0 69.4 0 76v61.6C0 199.7 68.1 272 160.7 285.7c29.4 60.7 73.7 90.3 111.3 96.9V480h-86c-14.4 0-26 11.7-26 26.1 0 3.3 2.7 5.9 6 5.9h244c3.3 0 6-2.6 6-5.9 0-14.4-11.6-26.1-26-26.1h-86v-97.4c37.7-6.6 81.9-36.2 111.3-96.9C508 272 576 199.6 576 137.6V76c0-6.6-5.4-12-12-12H448zM32 137.6V96h96v24c0 51.8 7 94.9 18.5 130.2C77.9 232.5 32 178 32 137.6zM288 352c-72 0-128-104-128-232V32h256v88c0 128-56 232-128 232zm256-214.4c0 40.4-46 94.9-114.5 112.6C441 214.9 448 171.8 448 120V96h96v41.6z"]
  },
      dS = {
    prefix: "fal",
    iconName: "trophy-alt",
    icon: [576, 512, [], "f2eb", "M370.5 138.9l-50.2-7.3-22.5-45.5c-4-8.1-15.7-8.2-19.7 0l-22.5 45.5-50.2 7.3c-9 1.3-12.6 12.4-6.1 18.8l36.3 35.4-8.6 50c-1.5 8.9 7.9 15.8 16 11.6l44.9-23.6 44.9 23.6c8 4.2 17.5-2.6 16-11.6l-8.6-50 36.3-35.4c6.7-6.4 3-17.5-6-18.8zm-60.3 44.4l5.2 30.6-27.4-14.4-27.5 14.4 5.2-30.6-22.2-21.6 30.7-4.5 13.7-27.8 13.7 27.8 30.7 4.5-22.1 21.6zM448 64V12c0-6.6-5.4-12-12-12H140c-6.6 0-12 5.4-12 12v52H12C5.4 64 0 69.4 0 76v61.6C0 199.7 68.1 272 160.7 285.7c29.4 60.7 73.7 90.3 111.3 96.9V480h-86c-14.4 0-26 11.7-26 26.1 0 3.3 2.7 5.9 6 5.9h244c3.3 0 6-2.6 6-5.9 0-14.4-11.6-26.1-26-26.1h-86v-97.4c37.7-6.6 81.9-36.2 111.3-96.9C508 272 576 199.6 576 137.6V76c0-6.6-5.4-12-12-12H448zM32 137.6V96h96v24c0 51.8 7 94.9 18.5 130.2C77.9 232.5 32 178 32 137.6zM288 352c-72 0-128-104-128-232V32h256v88c0 128-56 232-128 232zm256-214.4c0 40.4-46 94.9-114.5 112.6C441 214.9 448 171.8 448 120V96h96v41.6z"]
  },
      MS = {
    prefix: "fal",
    iconName: "truck",
    icon: [640, 512, [], "f0d1", "M632 384h-24V275.9c0-16.8-6.8-33.3-18.8-45.2l-83.9-83.9c-11.8-12-28.3-18.8-45.2-18.8H416V78.6c0-25.7-22.2-46.6-49.4-46.6H49.4C22.2 32 0 52.9 0 78.6v290.8C0 395.1 22.2 416 49.4 416h16.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16h195.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H632c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zM460.1 160c8.4 0 16.7 3.4 22.6 9.4l83.9 83.9c.8.8 1.1 1.9 1.8 2.8H416v-96h44.1zM144 480c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm63.6-96C193 364.7 170 352 144 352s-49 12.7-63.6 32h-31c-9.6 0-17.4-6.5-17.4-14.6V78.6C32 70.5 39.8 64 49.4 64h317.2c9.6 0 17.4 6.5 17.4 14.6V384H207.6zM496 480c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-128c-26.1 0-49 12.7-63.6 32H416v-96h160v96h-16.4c-14.6-19.3-37.5-32-63.6-32z"]
  },
      pS = {
    prefix: "fal",
    iconName: "truck-container",
    icon: [640, 512, [], "f4dc", "M32 320h336c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v224c0 17.7 14.3 32 32 32zm0-256h336v224H32V64zm589.3 141.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H448c-8.8 0-16 7.2-16 16v208H228.7c-12.3-9.9-27.7-16-44.7-16-22.8 0-42.8 10.8-56 27.3-13.2-16.6-33.2-27.4-56-27.4-39.8 0-72 32.2-72 72s32.2 72 72 72c22.8 0 42.8-10.8 56-27.3 13.2 16.5 33.2 27.3 56 27.3 39.8 0 72-32.2 72-72 0-8.5-1.7-16.5-4.4-24h198c-2.7 13.2-2.2 27.6 2.8 42.4 8.4 25.1 29.9 44.9 55.6 51.1 52.8 12.8 100-26.9 100-77.6 0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16V250.5c0-17-6.7-33.2-18.7-45.2zM72 448c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm112 0c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm280-288h53.5c8.5 0 16.6 3.3 22.6 9.4l54.6 54.6H464v-64zm64 288c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-96h-16.4c-14.6-19.3-37.5-32-63.6-32s-49 12.7-63.6 32h-.4v-96h144v96zm-504-96h16c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm96 0h16c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm96 0h16c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8z"]
  },
      zS = {
    prefix: "fal",
    iconName: "truck-couch",
    icon: [640, 512, [], "f4dd", "M416 32h224V0H416c-35.3 0-64 28.7-64 64v307.9L5.9 480.8c-4.3 1.2-6.8 5.6-5.6 9.8L4.5 506c1.2 4.3 5.6 6.8 9.8 5.6L367.2 400H416c0 61.9 50.1 112 112 112s112-50.1 112-112-50.1-112-112-112c-50.6 0-92.8 33.9-106.7 80H384V64c0-17.6 14.4-32 32-32zm112 288c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zM3 325.7l21.4 68.8c5.3 16.8 23.2 26.2 40 21h.1L320 336.1v-33.5L55 385l-21.4-68.8c-4-12.8 3.2-26.1 15.8-30 12.6-3.9 26.1 3.2 30 15.8l11.9 38.2 213.9-66.5-11.9-38.2c-3.9-12.6 3.1-26.1 15.8-30.1 3.7-1.1 7.3-1.3 10.8-.7v-45.3l-2.2-7c-13.1-42.1-58-65.7-100-52.7h-.1L64.9 147.3C22.7 160.4-.9 205.2 12.3 247.4l6.4 20.6C1.6 283.8-3.1 306.1 3 325.7zm71.4-147.8l152.8-47.5h.1c25.2-7.8 52.1 6.4 60 31.6l5 16.1c-24.7 11.8-37.8 40.1-29.5 67l2.4 7.6-152.8 47.5-2.4-7.6c-8.3-26.9-35.2-42.7-62.2-38.5l-5-16.1c-7.9-25.4 6.3-52.2 31.6-60.1z"]
  },
      CS = {
    prefix: "fal",
    iconName: "truck-loading",
    icon: [640, 512, [], "f4de", "M100.4 414.6l213.4-68.2c16.8-5.4 26.1-23.4 20.7-40.2L276 123.3c-5.4-16.9-23.5-26.2-40.2-20.8L22.5 170.7C5.7 176-3.7 194 1.7 210.9l58.4 182.9c5.3 16.6 23.2 26.2 40.3 20.8zm53.7-252.4l19.5 61-30.4 9.8-19.5-61 30.4-9.8zm-61 19.5l29.3 91.4 91.4-29.2-29.2-91.4 60.9-19.5L304 315.9 90.6 384.1 32.2 201.2l60.9-19.5zM416 32h224V0H416c-35.3 0-64 28.7-64 64v307.9L5.9 480.8c-4.3 1.2-6.8 5.6-5.6 9.8L4.5 506c1.2 4.3 5.6 6.8 9.8 5.6L367.2 400H416c0 61.9 50.1 112 112 112s112-50.1 112-112-50.1-112-112-112c-50.6 0-92.8 33.9-106.7 80H384V64c0-17.6 14.4-32 32-32zm112 288c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80z"]
  },
      LS = {
    prefix: "fal",
    iconName: "truck-monster",
    icon: [640, 512, [], "f63b", "M632 256h-24v-80c0-26.51-21.49-48-48-48h-57.6L419.21 24.02A63.99 63.99 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H80c-26.51 0-48 21.49-48 48v80H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h24v.88c9.09-12.21 19.85-22.98 32-32.15V176c0-8.82 7.18-16 16-16h480c8.82 0 16 7.18 16 16v80.72c12.15 9.18 22.91 19.94 32 32.15V288h24c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM256 128V32h113.24c9.77 0 18.88 4.38 24.99 12.01L461.42 128H256zm16 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zM160 464c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm432-112h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.68-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67a110.85 110.85 0 0 0-20.89-8.65V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.68-3.67c3.58-6.61 6.45-13.56 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zM480 464c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80z"]
  },
      AS = {
    prefix: "fal",
    iconName: "truck-moving",
    icon: [640, 512, [], "f4df", "M621.3 205.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H464V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16V250.5c0-17-6.7-33.2-18.7-45.2zM80 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm128 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm224-96H271.6c-14.6-19.3-37.5-32-63.6-32s-49 12.7-63.6 32h-.7C129 332.7 106 320 80 320c-18.1 0-34.6 6.2-48 16.4V64h400zm32-192h53.5c8.5 0 16.6 3.3 22.6 9.4l54.6 54.6H464zm64 288c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-96h-16.4c-14.6-19.3-37.5-32-63.6-32s-49 12.7-63.6 32h-.4v-96h144z"]
  },
      NS = {
    prefix: "fal",
    iconName: "truck-pickup",
    icon: [640, 512, [], "f63c", "M632 352h-24V224c0-26.51-21.49-48-48-48h-44.8L419.21 56.02A63.99 63.99 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v112H80c-26.51 0-48 21.49-48 48v128H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h72c0 53.02 42.98 96 96 96s96-42.98 96-96h96c0 53.02 42.98 96 96 96s96-42.98 96-96h72c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM256 64h113.24c9.78 0 18.88 4.38 24.99 12.01L474.22 176H256V64zm-80 384c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm288 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm112-96h-21.88c-13.22-37.2-48.38-64-90.12-64s-76.9 26.8-90.12 64H266.12c-13.22-37.2-48.38-64-90.12-64s-76.9 26.8-90.12 64H64V224c0-8.82 7.18-16 16-16h480c8.82 0 16 7.18 16 16v128z"]
  },
      gS = {
    prefix: "fal",
    iconName: "truck-plow",
    icon: [640, 512, [], "f7de", "M572.4 391.4c-9-9-14.1-21.2-14.1-34v-139c0-12.7 5.1-25 14.1-34l65.2-63.6c3.1-3.1 3.1-8.2 0-11.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0l-65.3 63.6c-15 15-23.4 35.4-23.4 56.6V272H480v-32c0-26.5-21.5-48-48-48h-38.9L306.4 47.6C300.7 38 290.1 32 278.9 32H152c-13.2 0-24 10.8-24 24v136H48c-26.5 0-48 21.5-48 48v96c0 21 13.5 38.6 32.3 45.2 0 1-.3 1.9-.3 2.8 0 53 43 96 96 96s96-43 96-96h64c0 53 43 96 96 96s96-43 96-96v-80h46.3v53.5c0 21.2 8.4 41.6 23.4 56.6l65.2 63.6c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-65.1-63.7zM160 64h118.9l76.8 128H160V64zm-32 384c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm165.9-96h-75.8c-13.2-37.2-48.4-64-90.1-64-40.6 0-75.1 25.2-89.1 60.8-4.1-2.9-6.9-7.4-6.9-12.8v-96c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v72.9c-17-15.3-39.3-24.9-64-24.9-41.7 0-76.9 26.8-90.1 64zm90.1 96c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"]
  },
      HS = {
    prefix: "fal",
    iconName: "truck-ramp",
    icon: [640, 512, [], "f4e0", "M416 32h224V0H416c-35.3 0-64 28.7-64 64v307.9L5.9 480.8c-4.3 1.2-6.8 5.6-5.6 9.8L4.5 506c1.2 4.3 5.6 6.8 9.8 5.6L367.2 400H416c0 61.9 50.1 112 112 112s112-50.1 112-112-50.1-112-112-112c-50.7 0-93 33.9-106.8 80H384V64c0-17.6 14.4-32 32-32zm112 288c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80z"]
  },
      VS = {
    prefix: "fal",
    iconName: "trumpet",
    icon: [640, 512, [], "f8e3", "M617.38 65.36l-.09-.07a32.32 32.32 0 0 0-35.85 12.94c-.44.66-44.93 66.33-112.36 102-14.57 7.67-31.95 11.77-50.3 11.77h-50.36v-24a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24h-32v-24a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24h-31.8v-24a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H33v-8a8 8 0 0 0-8-8H9a8 8 0 0 0-8 8v112a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-8h48.49a103.74 103.74 0 0 0 87.25 160h239.62A103.93 103.93 0 0 0 512.2 344a100.34 100.34 0 0 0-1.83-16.84c43.6 34.41 70.73 74.07 71.1 74.63A32 32 0 0 0 608.05 416a32.85 32.85 0 0 0 9.33-1.41A31.83 31.83 0 0 0 640 384V96a31.82 31.82 0 0 0-22.62-30.64zM168.74 416a71.74 71.74 0 0 1-44.63-128h84.56v128zm71.88 0V288h31.95v128zm63.9 0V288h32v128zm103.84 0h-39.94V288h50.36a108.77 108.77 0 0 1 44 9.43A71.65 71.65 0 0 1 408.36 416zM484 271.45C464.87 261.32 442.31 256 418.78 256H33v-32h385.78c23.53 0 46.09-5.34 65.21-15.47C559.38 168.62 607.77 96.42 608 96l.16 288.25c-.39-.73-48.78-72.92-124.16-112.8z"]
  },
      xS = {
    prefix: "fal",
    iconName: "tshirt",
    icon: [608, 512, [], "f553", "M606.4 111.6c-2.6-7.8-8-14.1-15.2-17.8L403.8 0l-7.9 11.1c-15.7 22-51.8 36.2-91.9 36.2s-76.2-14.2-91.9-36.2L204.2 0 16.8 93.8c-7.3 3.7-12.7 10-15.2 17.8-2.6 7.8-2 16.1 1.7 23.4l51.5 104c3.6 7.4 9.8 12.9 17.5 15.4 7.7 2.7 16 2 23.2-1.6l48.6-24v237.8c0 25 20.1 45.3 44.8 45.3h230.4c24.7 0 44.8-20.3 44.8-45.3V228.9l48.5 24c7.2 3.7 15.5 4.3 23.3 1.6 7.7-2.6 13.9-8.1 17.5-15.4L604.9 135c3.5-7.3 4.1-15.6 1.5-23.4zm-79.7 112.3L432 177.1v289.7c0 7.1-5.7 12.9-12.8 12.9H188.8c-7.1 0-12.8-5.8-12.8-12.9V177.1l-92.6 47.6-52.3-101.9 164.1-82.2c24 24.3 64.2 39 108.9 39S389 64.9 413 40.6L575.5 122l-48.8 101.9z"]
  },
      wS = {
    prefix: "fal",
    iconName: "tty",
    icon: [512, 512, [], "f1e4", "M364 464H148c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h216c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12zm-180-68c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v24zm-48-24c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-24zm-60 84H52c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12zM52 312h24c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12H52c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12zm216-48h-24c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12zm-96 0h-24c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12zm288 0h-24c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12zm42.2-161.7C366.1-34.2 145.6-33.9 9.8 102.3c-11 11-12.9 27.9-4.7 41.1l40.5 65c8.5 13.7 25.5 19.2 40.5 13.3l81-32.5c13.6-5.5 22.1-19.5 20.7-34.2l-4.3-43.2c47.2-14.5 97.9-14.5 145.1 0l-4.3 43.2c-1.5 14.7 7 28.7 20.7 34.2l81 32.5c14.9 6 31.9.4 40.5-13.3l40.5-65c8.2-13.2 6.2-30.1-4.8-41.1zm-22.4 24.1l-40.5 65c-.3.5-.9.7-1.4.5l-81-32.5c-.5-.2-.8-.7-.7-1.2l6.8-68.4c-79-28.6-137.8-27.5-213.8 0l6.8 68.4c.1.5-.2 1-.7 1.2l-81 32.5c-.5.2-1.1 0-1.4-.5l-40.5-65c-.3-.5-.2-1.1.2-1.5C156 1 356.1 1.1 479.6 124.9c.4.4.5 1.1.2 1.5zM460 456h-24c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12zm-180-60c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v24zm144-24c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-24zm-60-60c6.6 0 12-5.4 12-12v-24c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h24z"]
  },
      yS = {
    prefix: "fal",
    iconName: "turkey",
    icon: [640, 512, [], "f725", "M579.77 75.55c5.52-33.13-19.71-70.89-58.88-75.13-46.18-5.18-83.29 38.92-71.17 83.83 2.9 11.06.5 21.06-6.46 26.76-11.92 9.79-15 12.73-29.5 21.66C375.87 110.18 333.51 96 288.56 96 129.74 96 0 269.14 0 384s129.74 128 288.56 128 287.55-13.12 287.55-128c0-52.74-27.36-117.63-72.09-172.54 4-3.64 1.55-2.23 10-9.17 10.76-8.89 24.4-2.62 28.3-.5a64.79 64.79 0 0 0 24.27 7.62c36 4.05 69.16-22.41 73-59.79 3.73-35.33-20.59-69.71-59.82-74.07zM544.17 384c0 70.88-66.89 96-255.6 96S32 454.89 32 384c0-98.75 118-256 256.61-256 31.18 0 61.14 8.26 89 21.71-23.1 7.91-38.83 9.48-58.87 10.15-56.86 1.94-106.69 40-121.2 92.7-12 43.54-1.31 89.2 28.58 122.13A125.85 125.85 0 0 0 319.73 416c77.87 0 113.27-63.53 122.68-102 7.09-29 20.95-55.83 39.38-78.88 38.61 48.37 62.38 104.5 62.38 148.88zm13.51-210.27C480.61 131.64 419.44 273.48 411 307.89c-9.58 39.08-38.63 68.34-74 74.54-33.2 5.91-65.09-4.78-87.28-29.23-22.5-24.78-30.48-59.2-21.4-92.12 4-14.51 23.43-67 98.92-69.48C374.53 190 500.46 151.48 480.58 76a35.38 35.38 0 0 1 11.95-36.43c23.12-18.73 58.91-.63 55.6 31.46a35.05 35.05 0 0 1-5.34 15 16 16 0 0 0 19.13 23.45 33.57 33.57 0 0 1 15.29-2.08c18.94 2 32.67 19.48 30.67 38.86-2.67 25.41-29.58 38.76-50.2 27.43z"]
  },
      bS = {
    prefix: "fal",
    iconName: "turntable",
    icon: [576, 512, [], "f8e4", "M484.59 304.5l-4.74-2.37c0-.48.15-.93.15-1.41V136a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v152a31.57 31.57 0 0 0-34 15l.53.31c-4.59 7.27-12 21.85-27.18 52.08a32 32 0 0 0 14.31 42.92l28.62 14.31a31.78 31.78 0 0 0 14.28 3.4 32.31 32.31 0 0 0 10.19-1.66 31.78 31.78 0 0 0 18.44-16l25.66-50.91a32 32 0 0 0-14.29-42.95zm-40 79.5L416 369.73s23.59-46.79 25.78-50.78l-.13-.07v-.07l28.62 14.31zM224 232a24 24 0 1 0 24 24 24 24 0 0 0-24-24zM512 32H64A64 64 0 0 0 0 96v320a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V96a64 64 0 0 0-64-64zm32 384a32 32 0 0 1-32 32H64a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h448a32 32 0 0 1 32 32zM224 96a160 160 0 1 0 160 160A160 160 0 0 0 224 96zm0 288a128 128 0 1 1 128-128 128.14 128.14 0 0 1-128 128z"]
  },
      SS = {
    prefix: "fal",
    iconName: "turtle",
    icon: [576, 512, [], "f726", "M464 128c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm81.59-19.77C510.52 83.36 487.21 63.89 458.64 64c-70.67.28-74.64 70.17-74.64 73v71.19c-.02 6.89-2.07 13.4-4.99 19.59C306.47-5.44 87.67 22.02 33.15 241.28c-1.28 5.16-1.28 10.24-.52 15.11C14.53 257.47 0 272.21 0 290.59c0 14.91 9.5 28.11 23.66 32.81l47.69 15.91L36.31 400c-5.78 10.02-5.78 21.98 0 32s16.16 16 27.72 16h36.94c11.38 0 22-6.12 27.72-16l33.88-58.66C183.78 379.75 204.75 384 240 384s56.22-4.25 77.44-10.66l33.88 58.69c5.72 9.84 16.34 15.97 27.72 15.97h36.94c11.56 0 21.94-5.98 27.72-16 5.78-10.02 5.78-21.98 0-32l-38.47-66.64c17.81-9.58 32.88-22.28 44.91-37.91 12.75-16.58 21.47-35.19 26.03-55.45h27.19c40.06 0 72.66-32.59 72.66-72.66-.02-23.39-11.4-45.48-30.43-59.11zM351.8 249.01c.89 3.59-1.52 6.99-4.04 6.99H68.25c-2.53 0-4.93-3.42-4.04-7 50.42-202.79 236.99-203.48 287.59.01zM503.34 208h-54.75l-1.75 14c-2.53 20.03-9.97 38.17-22.09 53.94-19.88 25.87-43.07 33.45-65.25 42.25L415.97 416H379l-46.75-81.05C303.17 344.49 284.62 352 240 352c-45.86 0-64.64-8-92.25-17.05L100.97 416H64l54.66-94.63L32 288h303.06c29.22 0 51.64-15.08 64.38-31.59 10.78-14.05 16.53-30.7 16.56-48.19V137c0-26.99 22.44-40.55 42.26-41 19.93-.45 36.75 15.44 68.71 38.26 10.66 7.62 17.03 20 17.03 33.08 0 22.43-18.25 40.66-40.66 40.66z"]
  },
      TS = {
    prefix: "fal",
    iconName: "tv",
    icon: [640, 512, [], "f26c", "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h256v64H136a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h368a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H336v-64h256a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm16 368a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h544a16 16 0 0 1 16 16z"]
  },
      DS = {
    prefix: "fal",
    iconName: "tv-alt",
    icon: [640, 512, [], "f8e5", "M536 480H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM608 0H32A32 32 0 0 0 0 32v352a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm0 384H32V32h576z"]
  },
      jS = {
    prefix: "fal",
    iconName: "tv-music",
    icon: [640, 512, [], "f8e6", "M608 0H32A32 32 0 0 0 0 32v352a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm0 384H32V32h576zm-72 96H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zM240 320c26.5 0 48-14.33 48-32V179.16l96-37.52V226a69.89 69.89 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32V112a16 16 0 0 0-20.81-15.25l-128 47.25A16 16 0 0 0 256 159.25V258a69.89 69.89 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32z"]
  },
      ES = {
    prefix: "fal",
    iconName: "tv-retro",
    icon: [512, 512, [], "f401", "M416 243v-8c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12zm96-100v288c0 26.5-21.5 48-48 48h-16v33h-16l-11-33H91l-11 33H64v-33H48c-26.5 0-48-21.5-48-48V143c0-26.5 21.5-48 48-48h160.1l-74.8-67.1c-6.6-5.9-7.2-16-1.3-22.6 5.9-6.6 16-7.2 22.6-1.3L256 95h.8L357.3 4.1c6.6-5.9 16.7-5.4 22.6 1.2 5.9 6.6 5.4 16.7-1.2 22.6L304.5 95H464c26.5 0 48 21.5 48 48zm-32 0c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V143zm-256 49c-68.8 0-106.2 2.3-125.3 4.3-1.3 14.4-2.7 41.5-2.7 90.7 0 50.5 1.4 78 2.7 92.8 19.2 1.9 56.5 4.2 125.3 4.2s106.1-2.3 125.3-4.2c1.3-14.7 2.7-42.3 2.7-92.8 0-49.2-1.4-76.3-2.7-90.7-19.1-2-56.5-4.3-125.3-4.3m0-32c128 0 152 8 152 8s8 0 8 119c0 121-8 121-8 121s-24 8-152 8-152-8-152-8-8 0-8-121c0-119 8-119 8-119s24-8 152-8zm204 159h8c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12z"]
  },
      kS = {
    prefix: "fal",
    iconName: "typewriter",
    icon: [512, 512, [], "f8e7", "M312 384h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm64 0h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-256 0h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm360-192h-32v-82.73a32.07 32.07 0 0 0-9.38-22.65L361.38 9.38A32 32 0 0 0 338.75 0H112a48 48 0 0 0-48 48v144H32a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32v128a64 64 0 0 0 64 64h320a64 64 0 0 0 64-64V320a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32zM352 45.25L402.75 96H352zM96 48a16 16 0 0 1 16-16h208v64a32 32 0 0 0 32 32h64v64h-50.75a32 32 0 0 0-22.62 9.37l-13.26 13.26a32 32 0 0 1-22.62 9.37h-101.5a32 32 0 0 1-22.62-9.37l-13.26-13.26a32 32 0 0 0-22.62-9.37H96zm352 400a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V320h384zm32-160H32v-64h114.75L160 237.25A63.58 63.58 0 0 0 205.25 256h101.5A63.58 63.58 0 0 0 352 237.25L365.25 224H480zM144 440a8 8 0 0 0 8 8h208a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H152a8 8 0 0 0-8 8zm40-56h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm64 0h16a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8z"]
  },
      IS = {
    prefix: "fal",
    iconName: "ufo",
    icon: [640, 512, [], "e047", "M320,344a24,24,0,1,0,24,24A23.99993,23.99993,0,0,0,320,344ZM128,296a24,24,0,1,0,24,24A23.99993,23.99993,0,0,0,128,296Zm384,0a24,24,0,1,0,24,24A23.99993,23.99993,0,0,0,512,296Zm-21.00391-83.79883C479.42969,128.63672,407.25977,64,320,64S160.57031,128.63672,149.00391,212.20117C59.7207,234.9043,0,274.54688,0,320c0,70.69141,143.26953,128,320,128s320-57.30859,320-128C640,274.54688,580.2793,234.9043,490.99609,212.20117ZM320,96c77.76172,0,140.80078,62.51562,140.80078,139.63672,0,6.26953-1.05273,12.25586-1.86133,18.30664A299.64457,299.64457,0,0,1,320,288a299.64457,299.64457,0,0,1-138.93945-34.05664c-.8086-6.05078-1.86133-12.03711-1.86133-18.30664C179.19922,158.51562,242.23828,96,320,96Zm0,320c-175.80664,0-288-56.85742-288-96,0-24.00977,42.82031-54.46875,116.05859-74.58984.543,5.31.12628,4.44162,1.28321,12.77148a31.99835,31.99835,0,0,0,16.92578,24.13672A333.93177,333.93177,0,0,0,320,320a333.93177,333.93177,0,0,0,153.73242-37.68164,31.99835,31.99835,0,0,0,16.92578-24.13672c1.15479-8.31444.74077-7.466,1.28321-12.77344C565.17969,265.5293,608,295.99023,608,320,608,359.14258,495.80664,416,320,416Z"]
  },
      OS = {
    prefix: "fal",
    iconName: "ufo-beam",
    icon: [640, 512, [], "e048", "M320,216.00007a24,24,0,1,0,24,24A23.99993,23.99993,0,0,0,320,216.00007Zm-168-32a24,24,0,1,0,24,24A23.99993,23.99993,0,0,0,152,184.00007Zm336,0a24,24,0,1,0,24,24A23.99993,23.99993,0,0,0,488,184.00007Zm120,24c0-40.92969-56.92578-76.45312-141.21875-95.98633C449.06445,47.33015,389.36523.00007,320,.00007S190.93555,47.33015,173.21875,112.01374C88.92578,131.547,32,167.07038,32,208.00007c0,61.85547,128.94141,112,288,112S608,269.85554,608,208.00007Zm-288-176a119.89847,119.89847,0,0,1,119.79883,110.957c-35.75586,10.84571-76.4961,17.043-119.79883,17.043s-84.043-6.19726-119.79883-17.043A119.89847,119.89847,0,0,1,320,32.00007Zm0,256c-165.64062,0-256-52.84765-256-80,0-17.13672,36.58008-44.332,104.79492-62.1875,1.17774,12.77539,9.51172,23.94336,22.11719,27.76758C231.209,185.80281,274.64062,192.00007,320,192.00007s88.791-6.19726,129.08789-18.41992c12.60547-3.82422,20.93945-14.99219,22.11719-27.76758C539.41992,163.668,576,190.86335,576,208.00007,576,235.15242,485.64062,288.00007,320,288.00007Zm200.9082,34.252c-9.98828,3.41016-20.30664,6.59571-31.08984,9.42579L578.5293,507.57624a8.00084,8.00084,0,0,0,10.73242,3.57813l14.31445-7.1582a8.00142,8.00142,0,0,0,3.57813-10.73243ZM32.8457,493.26374a8.00142,8.00142,0,0,0,3.57813,10.73243l14.31445,7.1582a8.00084,8.00084,0,0,0,10.73242-3.57813l88.71094-175.89843c-10.7832-2.83008-21.10156-6.01563-31.08984-9.42579Z"]
  },
      QS = {
    prefix: "fal",
    iconName: "umbrella",
    icon: [576, 512, [], "f0e9", "M575.2 253.8C545.9 130.8 430.5 54.5 304 48.4V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v32.4C146 54.4 30.9 129.9.8 253.7c-6 23.9 22.8 44.1 44.1 25.1 49.5-46.1 89.9-27.7 125.4 27.7 11.4 17.8 34.8 16.9 45.6 0 15.2-23.5 31.2-45 56.2-51.5v193.1c0 17.7-14.3 32-32 32-13.6 0-25.7-8.6-30.2-21.3-3-8.3-12.1-12.7-20.4-9.8-8.3 2.9-12.7 12.1-9.7 20.4 9 25.5 33.3 42.7 60.4 42.7 35.3 0 64-28.7 64-64V255.2c30.1 8.3 44.6 33.3 56.2 51.2 10.8 17 34.3 17.7 45.6 0 36.2-55.9 76.6-73 125.4-27.7 20.9 18.9 49.7-1 43.8-24.9zm-191.9 28.7C359 242.8 325.4 221 288 221c-44.5 0-71.6 27-94.7 61.5-41.6-67.8-107.5-77.5-156.1-39.3C72.1 138.7 178.8 80 288 80c109.3 0 217 59.3 251.2 163.7-58.3-43.9-114.1-21.9-155.9 38.8z"]
  },
      ZS = {
    prefix: "fal",
    iconName: "umbrella-beach",
    icon: [640, 512, [], "f5ca", "M443.48 18.08C409.77 5.81 375.31 0 341.41 0c-90.47 0-176.84 41.45-233.44 112.33-6.7 8.39-2.67 21.04 7.42 24.71l236.15 85.95L257.99 480H8c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h560c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H292.03l89.56-246.07 236.75 86.17c1.83.67 3.7.98 5.53.98 8.27 0 15.82-6.35 16.04-15.14 3.03-124.66-72.77-242.85-196.43-287.86zm-295.31 96.84C198.11 62.64 268.77 32 341.42 32c7.81 0 15.6.35 23.36 1.04-36.87 23.16-73.76 66.62-103.06 123.21l-113.55-41.33zm315.21 114.73l-171.12-62.28C332.69 90.93 384.89 46.1 420.4 46.09c4.35 0 8.32.68 12.13 2.06 19.56 7.12 33.97 35.16 38.56 75 3.66 31.83.53 68.45-7.71 106.5zm30.8 11.21c13.83-61.57 13.67-118.28.7-159.64 65.33 46.08 107.58 119.45 112.61 200.89l-113.31-41.25z"]
  },
      US = {
    prefix: "fal",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", "M440 0H296a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h56v224a128 128 0 0 1-256 0V32h56a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h56v224c0 88.22 71.78 160 160 160s160-71.78 160-160V32h56a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8zm0 480H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h432a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      BS = {
    prefix: "fal",
    iconName: "undo",
    icon: [512, 512, [], "f0e2", "M20 8h10c6.627 0 12 5.373 12 12v110.625C85.196 57.047 165.239 7.715 256.793 8.001 393.18 8.428 504.213 120.009 504 256.396 503.786 393.181 392.834 504 256 504c-63.926 0-122.202-24.187-166.178-63.908-5.113-4.618-5.354-12.561-.482-17.433l7.069-7.069c4.503-4.503 11.749-4.714 16.482-.454C150.782 449.238 200.935 470 256 470c117.744 0 214-95.331 214-214 0-117.744-95.331-214-214-214-82.862 0-154.737 47.077-190.289 116H180c6.627 0 12 5.373 12 12v10c0 6.627-5.373 12-12 12H20c-6.627 0-12-5.373-12-12V20c0-6.627 5.373-12 12-12z"]
  },
      RS = {
    prefix: "fal",
    iconName: "undo-alt",
    icon: [512, 512, [], "f2ea", "M256.2 8c-57 0-109.5 19.2-151.5 51.5L54.6 9.4C34.6-10.7 0 3.5 0 32v128c0 17.7 14.3 32 32 32h128c28.5 0 42.7-34.5 22.6-54.6L129 83.7C165.3 56.9 209.5 42 256 42c118.4 0 214 96 214 214 0 118.4-96 214-214 214-53.7 0-104.2-19.8-143.1-54.9-4.7-4.3-12-4-16.5.5l-7.1 7.1c-4.9 4.9-4.6 12.8.5 17.4 44 39.7 102.3 63.9 166.2 63.9 136.8 0 247.7-110.8 248-247.5S392.8 8.1 256.2 8zM160 160H32V32z"]
  },
      YS = {
    prefix: "fal",
    iconName: "unicorn",
    icon: [640, 512, [], "f727", "M448 80c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm183.98-16h-96.93l-.24-.3c5.39-9.45 8.38-20.32 8.38-31.7 0-17.67-14.33-32-32-32H400c-70.58 0-128 57.42-128 128H163.36c-35.98 0-67.27 19.42-84.7 48.13C35.11 176.87 0 212.28 0 256v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56c0-21.5 14.23-39.48 33.71-45.59-.96 5.54-1.71 11.15-1.71 16.96 0 24.2 8.9 47.33 24.53 65.24l-21.97 74.27c-3.12 10.77-3.38 22.03-.8 32.74l21.13 87.86C90.34 501.86 103.21 512 118 512h57.53c20.95 0 36.12-19.76 31.02-39.86l-21.68-85.57 19.29-53.73L256 344.36V480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V323.8c20.5-21.5 32-49.75 32-79.59v-50.52l14.55 21.82c19.11 28.67 49.98 20.67 55.45 18.8l25.52-8.71c19.44-6.63 32.5-24.89 32.49-45.44l-.03-64.83 92.46-36.67c6.57-4.39 3.46-14.66-4.46-14.66zM501.17 195.31l-25.52 8.71c-9.33 3.19-16.14-2.76-18.48-6.27L432 160l-48-16v100.21c0 26.67-12.65 50.17-32 65.6V480h-64V318.69l-104.43-23.21-32.12 89.47L175.53 480H118l-21.13-87.86a31.698 31.698 0 0 1 .37-16.18l27.63-93.41C107.45 270.37 96 250.24 96 227.37c0-37.21 30.16-67.37 67.37-67.37H304v-32c0-53.02 42.98-96 96-96h111.19c0 13.29-8.1 24.66-19.63 29.5l20.39 24.78.05 93.88a16 16 0 0 1-10.83 15.15z"]
  },
      PS = {
    prefix: "fal",
    iconName: "union",
    icon: [320, 512, [], "f6a2", "M170.65 447.65C255.69 442.15 320 367.74 320 282.52V72c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v211.48c0 68.11-51.28 127.67-119.24 132.22C94.24 420.7 32 361.48 32 288V72c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v216c0 91.89 77.46 165.69 170.65 159.65z"]
  },
      FS = {
    prefix: "fal",
    iconName: "universal-access",
    icon: [512, 512, [], "f29a", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.663 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.663 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm139.701-299.677c2.03 8.601-3.296 17.218-11.896 19.249-31.006 7.321-59.956 13.775-88.689 17.114.535 114.852 13.167 139.988 27.255 176.036 4.02 10.289-1.063 21.888-11.352 25.906-10.296 4.022-21.89-1.069-25.906-11.352-9.319-23.841-18.551-44.565-24.271-87.277h-9.685c-5.728 42.773-14.986 63.515-24.27 87.276-4.023 10.299-15.633 15.369-25.906 11.353-10.289-4.019-15.371-15.617-11.353-25.906 14.103-36.083 26.72-61.235 27.255-176.036-28.734-3.339-57.683-9.793-88.689-17.114-8.6-2.031-13.926-10.648-11.895-19.249 2.03-8.6 10.647-13.926 19.249-11.896 105.222 24.845 135.48 24.893 240.904 0 8.599-2.022 17.218 3.297 19.249 11.896zm-177.895-42.517c0-21.094 17.1-38.193 38.194-38.193s38.194 17.1 38.194 38.193S277.094 168 256 168s-38.194-17.1-38.194-38.194z"]
  },
      WS = {
    prefix: "fal",
    iconName: "university",
    icon: [512, 512, [], "f19c", "M496 448h-16v-40c0-13.255-10.745-24-24-24h-40V208h-32v176h-64V208h-32v176h-64V208h-32v176h-64V208H96v176H56c-13.255 0-24 10.745-24 24v40H16c-8.837 0-16 7.163-16 16v8a8 8 0 0 0 8 8h496a8 8 0 0 0 8-8v-8c0-8.837-7.163-16-16-16zM64 416h384v32H64v-32zm440.267-280L271.179 34.463a48.004 48.004 0 0 0-30.358 0L7.733 136A11.999 11.999 0 0 0 0 147.216V156c0 6.627 5.373 12 12 12h20v12c0 6.627 5.373 12 12 12h424c6.627 0 12-5.373 12-12v-12h20c6.627 0 12-5.373 12-12v-8.784c0-4.982-3.077-9.445-7.733-11.216zM448 160H64v-13.606l187.943-81.871a16.004 16.004 0 0 1 8.114 0L448 146.394V160z"]
  },
      GS = {
    prefix: "fal",
    iconName: "unlink",
    icon: [512, 512, [], "f127", "M207.889 137.235c-4.686-4.686-4.686-12.284 0-16.971l82.159-82.159c50.81-50.813 133.046-50.803 183.848 0 50.812 50.81 50.802 133.048-.001 183.847l-82.159 82.159c-4.686 4.686-12.284 4.686-16.971 0l-8.485-8.485c-4.686-4.686-4.686-12.284 0-16.971l82.159-82.159c36.739-36.741 36.735-96.2 0-132.936-36.741-36.741-96.199-36.736-132.937-.001l-82.159 82.159c-4.686 4.686-12.284 4.686-16.971 0l-8.483-8.483zm-11.391 311.294c-36.65 36.65-96.286 36.651-132.937-.001-36.736-36.736-36.739-96.194 0-132.936l82.19-82.19c4.686-4.686 4.686-12.284 0-16.971l-8.485-8.485c-4.686-4.686-12.284-4.686-16.971 0l-82.19 82.189c-50.802 50.8-50.813 133.038 0 183.848 50.686 50.688 133.162 50.687 183.847 0l82.19-82.19c4.686-4.686 4.686-12.284 0-16.971l-8.484-8.484c-4.686-4.686-12.284-4.686-16.971 0l-82.189 82.191zM11.999 3.515L3.514 12c-4.686 4.686-4.686 12.284 0 16.971L483.03 508.485c4.686 4.686 12.284 4.686 16.971 0l8.485-8.485c4.686-4.686 4.686-12.284 0-16.971L28.97 3.515c-4.686-4.687-12.284-4.687-16.971 0z"]
  },
      qS = {
    prefix: "fal",
    iconName: "unlock",
    icon: [384, 512, [], "f09c", "M336 256H96v-96c0-70.6 25.4-128 96-128s96 57.4 96 128v20c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-18.5C320 73.1 280.9.3 192.5 0 104-.3 64 71.6 64 160v96H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm16 208c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v160z"]
  },
      JS = {
    prefix: "fal",
    iconName: "unlock-alt",
    icon: [384, 512, [], "f13e", "M336 256H96v-96c0-70.6 25.4-128 96-128s96 57.4 96 128v20c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-18.5C320 73.1 280.9.3 192.5 0 104-.3 64 71.6 64 160v96H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm16 208c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v160zm-160-32c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 8.8-7.2 16-16 16z"]
  },
      KS = {
    prefix: "fal",
    iconName: "upload",
    icon: [512, 512, [], "f093", "M452 432c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20zm-84-20c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20zm144-48v104c0 24.3-19.7 44-44 44H44c-24.3 0-44-19.7-44-44V364c0-24.3 19.7-44 44-44h124v-99.3h-52.7c-35.6 0-53.4-43.1-28.3-68.3L227.7 11.7c15.6-15.6 40.9-15.6 56.6 0L425 152.4c25.2 25.2 7.3 68.3-28.3 68.3H344V320h124c24.3 0 44 19.7 44 44zM200 188.7V376c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8V188.7h84.7c7.1 0 10.7-8.6 5.7-13.7L261.7 34.3c-3.1-3.1-8.2-3.1-11.3 0L109.7 175c-5 5-1.5 13.7 5.7 13.7H200zM480 364c0-6.6-5.4-12-12-12H344v24c0 22.1-17.9 40-40 40h-96c-22.1 0-40-17.9-40-40v-24H44c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12V364z"]
  },
      XS = {
    prefix: "fal",
    iconName: "usb-drive",
    icon: [640, 512, [], "f8e9", "M536 240h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm0 80h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm88-192H480v-16a16 16 0 0 0-16-16H64a64 64 0 0 0-64 64v192a64 64 0 0 0 64 64h400a16 16 0 0 0 16-16v-16h144a16 16 0 0 0 16-16V144a16 16 0 0 0-16-16zM448 384H64a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h384zm160-32H480V160h128z"]
  },
      _S = {
    prefix: "fal",
    iconName: "usd-circle",
    icon: [496, 512, [], "f2e8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216zm40.3-221.3l-72-20.2c-12.1-3.4-20.6-14.4-20.6-26.7 0-15.3 12.8-27.8 28.5-27.8h45c11.2 0 21.9 3.6 30.6 10.1 3.2 2.4 7.6 2 10.4-.8l11.3-11.5c3.4-3.4 3-9-.8-12-14.6-11.6-32.6-17.9-51.6-17.9H264v-40c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v40h-7.8c-33.3 0-60.5 26.8-60.5 59.8 0 26.6 18.1 50.2 43.9 57.5l72 20.2c12.1 3.4 20.6 14.4 20.6 26.7 0 15.3-12.8 27.8-28.5 27.8h-45c-11.2 0-21.9-3.6-30.6-10.1-3.2-2.4-7.6-2-10.4.8l-11.3 11.5c-3.4 3.4-3 9 .8 12 14.6 11.6 32.6 17.9 51.6 17.9h5.2v40c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-40h7.8c33.3 0 60.5-26.8 60.5-59.8-.1-26.6-18.1-50.2-44-57.5z"]
  },
      $S = {
    prefix: "fal",
    iconName: "usd-square",
    icon: [448, 512, [], "f2e9", "M264.3 250.7l-72-20.2c-12.1-3.4-20.6-14.4-20.6-26.7 0-15.3 12.8-27.8 28.5-27.8h45c11.2 0 21.9 3.6 30.6 10.1 3.2 2.4 7.6 2 10.4-.8l11.3-11.5c3.4-3.4 3-9-.8-12-14.6-11.6-32.6-17.9-51.6-17.9H240v-40c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v40h-7.8c-33.3 0-60.5 26.8-60.5 59.8 0 26.6 18.1 50.2 43.9 57.5l72 20.2c12.1 3.4 20.6 14.4 20.6 26.7 0 15.3-12.8 27.8-28.5 27.8h-45c-11.2 0-21.9-3.6-30.6-10.1-3.2-2.4-7.6-2-10.4.8l-11.3 11.5c-3.4 3.4-3 9 .8 12 14.6 11.6 32.6 17.9 51.6 17.9h5.2v40c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-40h7.8c33.3 0 60.5-26.8 60.5-59.8-.1-26.6-18.1-50.2-44-57.5zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352z"]
  },
      cT = {
    prefix: "fal",
    iconName: "user",
    icon: [448, 512, [], "f007", "M313.6 288c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zM416 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 56.5 0 102.4 45.9 102.4 102.4V464zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"]
  },
      eT = {
    prefix: "fal",
    iconName: "user-alien",
    icon: [448, 512, [], "e04a", "M252,288h40a60.00047,60.00047,0,0,0,60-60V204a12.0006,12.0006,0,0,0-12-12H300a60.00047,60.00047,0,0,0-60,60v24A12.0006,12.0006,0,0,0,252,288Zm20-36a28.03146,28.03146,0,0,1,28-28h20v4a28.03146,28.03146,0,0,1-28,28H272Zm-76,36a12.0006,12.0006,0,0,0,12-12V252a60.00047,60.00047,0,0,0-60-60H108a12.0006,12.0006,0,0,0-12,12v24a60.00047,60.00047,0,0,0,60,60Zm-68-60v-4h20a28.03146,28.03146,0,0,1,28,28v4H156A28.03146,28.03146,0,0,1,128,228ZM352,352h-8.81445c39.14843-43.77734,72.8789-96.6582,72.8789-149.36719C416.06445,76.73633,330.05273,0,224,0,117.918,0,31.93555,76.73633,31.93555,202.63281c0,52.709,33.73047,105.58985,72.8789,149.36719H96A95.99975,95.99975,0,0,0,0,448v16a47.99987,47.99987,0,0,0,48,48H400a47.99987,47.99987,0,0,0,48-48V448A95.99975,95.99975,0,0,0,352,352ZM63.93555,202.63281C63.93555,100.57227,128.25977,32,224,32s160.06445,68.57227,160.06445,170.63281c0,87.58789-121.332,185.05664-158.51953,212.84571a2.5483,2.5483,0,0,1-3.0918-.002C185.26758,387.68945,63.93555,290.2207,63.93555,202.63281ZM416,464a16.01833,16.01833,0,0,1-16,16H48a16.01833,16.01833,0,0,1-16-16V448a64.07333,64.07333,0,0,1,64-64h39.79883a744.84828,744.84828,0,0,0,67.5,57.11133,34.54892,34.54892,0,0,0,41.40234,0A744.84828,744.84828,0,0,0,312.20117,384H352a64.07333,64.07333,0,0,1,64,64Z"]
  },
      aT = {
    prefix: "fal",
    iconName: "user-alt",
    icon: [512, 512, [], "f406", "M256 32c61.8 0 112 50.2 112 112s-50.2 112-112 112-112-50.2-112-112S194.2 32 256 32m128 320c52.9 0 96 43.1 96 96v32H32v-32c0-52.9 43.1-96 96-96 85 0 67.3 16 128 16 60.9 0 42.9-16 128-16M256 0c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144S335.5 0 256 0zm128 320c-92.4 0-71 16-128 16-56.8 0-35.7-16-128-16C57.3 320 0 377.3 0 448v32c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-32c0-70.7-57.3-128-128-128z"]
  },
      nT = {
    prefix: "fal",
    iconName: "user-alt-slash",
    icon: [640, 512, [], "f4fa", "M637 485.2L23 1.8C19.6-1 14.5-.4 11.8 3l-10 12.5C-1 19-.4 24 3 26.8l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.6 2.2-8.6-1.2-11.4zM320 32c61.8 0 112 50.2 112 112 0 34.8-16.3 65.6-41.3 86.2l25.6 20.2C445.4 224 464 186.3 464 144 464 64.5 399.5 0 320 0c-54.6 0-101.4 30.7-125.9 75.4l25.4 20C237.7 58 275.7 32 320 32zM96 480v-32c0-52.9 43.1-96 96-96h36.8c22.4 0 40.3 16 91.2 16 11.7 0 23.3-1.1 34.8-3.1l-36.9-29.1c-46.2-.6-59.3-15.8-89.2-15.8H192c-70.7 0-128 57.3-128 128v32c0 17.7 14.3 32 32 32h445.6L501 480H96z"]
  },
      tT = {
    prefix: "fal",
    iconName: "user-astronaut",
    icon: [448, 512, [], "f4fb", "M288 128H160c-35.3 0-64 28.7-64 64v16c0 61.8 50.2 112 112 112h32c61.8 0 112-50.2 112-112v-16c0-35.3-28.7-64-64-64zm32 80c0 44.1-35.9 80-80 80h-32c-44.1 0-80-35.9-80-80v-16c0-17.6 14.3-32 32-32h128c17.7 0 32 14.4 32 32v16zm-128-32l-12 36-36 12 36 12 12 36 12-36 36-12-36-12-12-36zm112 224H144c-26.5 0-48 21.5-48 48v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56c0-26.5-21.5-48-48-48zm-32 48c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v40c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-40c0-8.8-7.2-16-16-16zm183.2-119.7c20.3-20.1 35.9-44.8 45.7-72.3H416c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-11.2C378.5 53.5 307.6 0 224 0S69.5 53.5 43.2 128H32c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h11.2c9.7 27.5 25.4 52.2 45.7 72.3C37.1 347 0 396.2 0 454.4V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-49.6c0-51.6 38.5-94 88.3-101C150.2 372.7 185.8 384 224 384s73.8-11.3 103.7-30.6c49.8 6.9 88.3 49.3 88.3 101V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-49.6c0-58.2-37.1-107.4-88.8-126.1zM224 352c-88.2 0-160-71.8-160-160S135.8 32 224 32s160 71.8 160 160-71.8 160-160 160z"]
  },
      rT = {
    prefix: "fal",
    iconName: "user-chart",
    icon: [640, 512, [], "f6a3", "M608 0H192c-17.67 0-32 14.33-32 32v96c-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-41.74-26.8-76.9-64-90.12V32h416v352H305.34c-.59-.94-1.03-1.96-1.65-2.88-17.25-25.62-46.67-39.11-76.9-39.11C199 342.02 192.02 352 160 352c-31.97 0-38.95-9.98-66.79-9.98-30.23 0-59.65 13.48-76.9 39.11C6.01 396.42 0 414.84 0 434.67V472c0 22.09 17.91 40 40 40h240c22.09 0 40-17.91 40-40v-37.33c0-6.41-.84-12.6-2.04-18.67H608c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zM224 224c0 35.29-28.71 64-64 64s-64-28.71-64-64 28.71-64 64-64 64 28.71 64 64zm64 248c0 4.41-3.59 8-8 8H40c-4.41 0-8-3.59-8-8v-37.33c0-12.79 3.75-25.13 10.85-35.67 10.53-15.64 29.35-24.98 50.36-24.98 21.8 0 29.99 9.98 66.79 9.98 36.79 0 45.01-9.98 66.79-9.98 21 0 39.83 9.34 50.36 24.98 7.1 10.54 10.85 22.88 10.85 35.67V472zm50.62-319.31c-9.38-9.38-24.56-9.38-33.94 0l-25.49 25.49c4.56 11.72 7.3 24.17 8.21 37.04l34.25-34.25L384.69 244c4.69 4.69 10.81 7.02 16.97 7.02s12.28-2.33 16.97-7.02l58.97-58.97 33.24 33.24c3.96 3.96 8.82 5.73 13.6 5.73 9.99 0 19.57-7.76 19.57-19.47v-95.58c0-7.15-5.8-12.95-12.95-12.95h-95.58c-17.31 0-25.98 20.93-13.74 33.17l33.24 33.24-53.31 53.31-63.05-63.03zM512 128v46.18L465.82 128H512z"]
  },
      iT = {
    prefix: "fal",
    iconName: "user-check",
    icon: [640, 512, [], "f4fc", "M637.7 144.6l-14.1-14.2c-3.1-3.1-8.2-3.2-11.3 0L497.1 242.1l-53.3-53.4c-3.1-3.1-8.2-3.1-11.3 0l-14.2 14.1c-3.1 3.1-3.1 8.2 0 11.3l70.2 70.4c4.7 4.7 12.3 4.7 17 0l132.1-128.6c3.2-3.1 3.2-8.2.1-11.3zM313.6 288c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zM416 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 56.5 0 102.4 45.9 102.4 102.4V464zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"]
  },
      oT = {
    prefix: "fal",
    iconName: "user-circle",
    icon: [496, 512, [], "f2bd", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm128 421.6c-35.9 26.5-80.1 42.4-128 42.4s-92.1-15.9-128-42.4V416c0-35.3 28.7-64 64-64 11.1 0 27.5 11.4 64 11.4 36.6 0 52.8-11.4 64-11.4 35.3 0 64 28.7 64 64v13.6zm30.6-27.5c-6.8-46.4-46.3-82.1-94.6-82.1-20.5 0-30.4 11.4-64 11.4S204.6 320 184 320c-48.3 0-87.8 35.7-94.6 82.1C53.9 363.6 32 312.4 32 256c0-119.1 96.9-216 216-216s216 96.9 216 216c0 56.4-21.9 107.6-57.4 146.1zM248 120c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 144c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"]
  },
      lT = {
    prefix: "fal",
    iconName: "user-clock",
    icon: [640, 512, [], "f4fd", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm272 192c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm0 256c-61.8 0-112-50.2-112-112s50.2-112 112-112 112 50.2 112 112-50.2 112-112 112zm-135.8 0H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 4.4 0 8.6.8 12.9 1.3 2.9-10.7 6.9-21 11.7-30.8-8-1.5-16.1-2.5-24.5-2.5-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h346.9c-12.9-9.1-24.7-19.8-34.7-32zm190.1-128H512v-54.3c0-5.3-4.4-9.7-9.7-9.7h-12.6c-5.3 0-9.7 4.4-9.7 9.7v76.6c0 5.3 4.4 9.7 9.7 9.7h60.6c5.3 0 9.7-4.4 9.7-9.7v-12.6c0-5.3-4.4-9.7-9.7-9.7z"]
  },
      fT = {
    prefix: "fal",
    iconName: "user-cog",
    icon: [640, 512, [], "f4fe", "M628.3 358.3l-16.5-9.5c.8-8.5.8-17.1 0-25.6l16.6-9.5c9.5-5.5 13.8-16.7 10.5-27-7.2-23.4-19.9-45.4-36.7-63.5-7.4-8.1-19.3-9.9-28.7-4.4l-16.5 9.5c-7-5-14.4-9.3-22.2-12.8v-19c0-11-7.5-20.3-18.2-22.7-23.9-5.4-49.3-5.4-73.2 0-10.7 2.4-18.2 11.8-18.2 22.7v19c-7.8 3.5-15.2 7.8-22.2 12.8l-16.5-9.5c-9.5-5.5-21.3-3.7-28.7 4.4-16.7 18.1-29.4 40.1-36.7 63.4-3.3 10.4 1.2 21.8 10.6 27.2l16.5 9.5c-.8 8.5-.8 17.1 0 25.6l-16.6 9.5c-9.3 5.4-13.8 16.9-10.5 27.1 7.2 23.4 19.9 45.4 36.7 63.5 7.4 8 19.2 9.8 28.7 4.4l16.5-9.5c7 5 14.4 9.3 22.2 12.8v19c0 11 7.5 20.3 18.2 22.7 12 2.7 24.3 4 36.6 4s24.7-1.3 36.6-4c10.7-2.4 18.2-11.8 18.2-22.7v-19c7.8-3.5 15.2-7.8 22.2-12.8l16.5 9.5c9.4 5.4 21.3 3.6 28.7-4.4 16.7-18.1 29.4-40.1 36.7-63.4 3.3-10.4-1.2-21.9-10.6-27.3zm-51.6 7.2l29.4 17c-5.2 14.3-13 27.8-22.8 39.5l-29.4-17c-21.4 18.3-24.5 20.1-51.1 29.5v34c-15.1 2.6-30.6 2.6-45.6 0v-34c-26.9-9.5-30.2-11.7-51.1-29.5l-29.4 17c-9.8-11.8-17.6-25.2-22.8-39.5l29.4-17c-4.9-26.8-5.2-30.6 0-59l-29.4-17c5.2-14.3 13-27.7 22.8-39.5l29.4 17c21.4-18.3 24.5-20.1 51.1-29.5v-34c15.1-2.5 30.7-2.5 45.6 0v34c26.8 9.5 30.2 11.6 51.1 29.5l29.4-17c9.8 11.8 17.6 25.2 22.8 39.5l-29.4 17c4.9 26.8 5.2 30.6 0 59zm-96.7-94c-35.6 0-64.5 29-64.5 64.5s28.9 64.5 64.5 64.5 64.5-29 64.5-64.5-28.9-64.5-64.5-64.5zm0 97c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5 32.5 14.6 32.5 32.5-14.6 32.5-32.5 32.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zM48 480c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 19.2 0 38-3.3 56.5-8.7.5-11.6 1.8-23 4.2-34-8.9 2.7-30.1 10.7-60.7 10.7-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h337c-16-8.6-30.6-19.5-43.5-32H48z"]
  },
      sT = {
    prefix: "fal",
    iconName: "user-cowboy",
    icon: [448, 512, [], "f8ea", "M99.46 165.1A150.52 150.52 0 0 0 96 192a128 128 0 0 0 256 0 150.48 150.48 0 0 0-3.5-27.07c72.19-35.62 97.88-93.86 98.25-94.7a16 16 0 0 0-29.47-12.53c-1.16 2.67-19.77 43.52-71.21 72.78C336.2 80.21 314.75 0 278.1 0c-10.33 0-19.55 4.45-27.3 10.47a42.32 42.32 0 0 1-26 8.93 42.32 42.32 0 0 1-26-8.93C191 4.45 181.76 0 171.43 0c-36.78 0-58.26 80.78-68.08 131-52.26-29.32-71.51-70.75-72.69-73.44a16 16 0 0 0-29.28 13c1.52 3.38 27.44 59.81 98.08 94.54zm73.4-132.88a19.71 19.71 0 0 1 6.23 3.51 74.77 74.77 0 0 0 45.67 15.67 74.83 74.83 0 0 0 45.68-15.66 19.57 19.57 0 0 1 6.23-3.52c9.17 6.89 26.59 41.8 39.5 112.27v.06C291.24 153.84 260.85 160 224 160c-36.13 0-66-6-90.71-15.1 12.9-70.71 30.37-105.77 39.57-112.68zm-43.27 145C156.07 186.12 187.12 192 224 192s67.91-5.92 94.4-14.87A95 95 0 0 1 320 192a96 96 0 0 1-192 0 95.31 95.31 0 0 1 1.59-14.8zm184 174.8c-28.72 0-42.43 16-89.59 16s-60.88-16-89.56-16A134.46 134.46 0 0 0 0 486.41 25.61 25.61 0 0 0 25.59 512H422.4a25.61 25.61 0 0 0 25.6-25.59A134.46 134.46 0 0 0 313.59 352zM32.19 480c3.4-52.94 49.18-95.95 102.25-96 19.81 0 38.93 16 89.56 16 51 0 69.59-16 89.59-16 53 .06 98.85 43.08 102.22 96z"]
  },
      uT = {
    prefix: "fal",
    iconName: "user-crown",
    icon: [448, 512, [], "f6a4", "M313.6 320c-28.71 0-42.6 16-89.6 16-47.09 0-60.82-16-89.6-16C60.17 320 0 380.17 0 454.4v9.6c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-9.6c0-74.23-60.17-134.4-134.4-134.4zM416 464c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16v-9.6C32 397.94 77.94 352 134.4 352c19.38 0 39.33 16 89.6 16 49.4 0 70.66-16 89.6-16 56.46 0 102.4 45.94 102.4 102.4v9.6zM224 288c70.7 0 128-57.31 128-128V0l-64 32-64-32-64 32L96 0v160c0 70.69 57.31 128 128 128zM128 51.78l32 16 64-32 64 32 32-16V112H128V51.78zm0 92.22h192v16c0 52.93-43.06 96-96 96s-96-43.07-96-96v-16z"]
  },
      hT = {
    prefix: "fal",
    iconName: "user-edit",
    icon: [640, 512, [], "f4ff", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm406.6 204.1l-34.7-34.7c-6.3-6.3-14.5-9.4-22.8-9.4-8.2 0-16.5 3.1-22.8 9.4L327.8 424l-7.6 68.2c-1.2 10.7 7.2 19.8 17.7 19.8.7 0 1.3 0 2-.1l68.2-7.6 222.5-222.5c12.5-12.7 12.5-33.1 0-45.7zM393.3 473.7l-39.4 4.5 4.4-39.5 156.9-156.9 35 35-156.9 156.9zm179.5-179.5l-35-35L573 224h.1l.2.1 34.7 35-35.2 35.1zM134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 20.7 0 39.9 6.3 56 16.9l22.8-22.8c-22.2-16.2-49.3-26-78.8-26-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h243.5c-2.8-7.4-4.1-15.4-3.2-23.4l1-8.6H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320z"]
  },
      mT = {
    prefix: "fal",
    iconName: "user-friends",
    icon: [640, 512, [], "f500", "M480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm0-160c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm80.1 212c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9C7.2 341.3 0 363.4 0 387.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM352 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zm271.7-114.9C606.4 291.5 577 278 546.8 278c-27.8 0-34.8 10-66.8 10s-39-10-66.8-10c-13.2 0-26.1 3-38.1 8.1 15.2 15.4 18.5 23.6 20.2 26.6 5.7-1.6 11.6-2.6 17.9-2.6 21.8 0 30 10 66.8 10s45-10 66.8-10c21 0 39.8 9.3 50.4 25 7.1 10.5 10.9 22.9 10.9 35.7V408c0 4.4-3.6 8-8 8H416c0 17.7.3 22.5-1.6 32H600c22.1 0 40-17.9 40-40v-37.3c0-19.9-6-38.3-16.3-53.6z"]
  },
      vT = {
    prefix: "fal",
    iconName: "user-graduate",
    icon: [448, 512, [], "f501", "M319.4 320.6L224 400l-95.4-79.4C110.2 321.4 0 336.1 0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48 0-127.9-110.1-142.6-128.6-143.4zM208 480H48c-8.8 0-16-7.2-16-16 0-99.6 84.1-109.9 86.4-110.3l89.6 74.6V480zm208-16c0 8.8-7.2 16-16 16H240v-51.7l89.6-74.6c2.3.4 86.4 10.7 86.4 110.3zM13.2 100l6.8 2v37.6c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3v-30.5L90.7 123C84 139.4 80 157.2 80 176c0 79.5 64.5 144 144 144s144-64.5 144-144c0-18.8-4-36.6-10.7-53l77.5-23c17.6-5.2 17.6-34.8 0-40L240.9 2.5C235.3.8 229.7 0 224 0s-11.3.8-16.9 2.5L13.2 60c-17.6 5.2-17.6 34.8 0 40zM224 288c-61.8 0-112-50.2-112-112 0-15.7 3.7-30.3 9.6-43.8l85.5 25.4c14.8 4.4 27.2 2 33.8 0l85.5-25.4c5.9 13.5 9.6 28.2 9.6 43.8 0 61.8-50.2 112-112 112zm-7.8-254.9c.8-.2 7.3-2.4 15.6 0l158 46.9-158 46.9c-.8.2-7.3 2.4-15.6 0L58.2 80l158-46.9z"]
  },
      dT = {
    prefix: "fal",
    iconName: "user-hard-hat",
    icon: [448, 512, [], "f82c", "M313.6 352c-28.72 0-42.45 16-89.6 16s-60.88-16-89.56-16A134.4 134.4 0 0 0 0 486.4 25.6 25.6 0 0 0 25.6 512h396.8a25.6 25.6 0 0 0 25.6-25.6A134.4 134.4 0 0 0 313.6 352zM32.2 480a102.54 102.54 0 0 1 102.24-96c19.82 0 38.92 16 89.56 16 51 0 69.6-16 89.6-16a102.53 102.53 0 0 1 102.2 96zM88 160h12.66A124.32 124.32 0 0 0 96 192a128 128 0 0 0 256 0 124.32 124.32 0 0 0-4.66-32H360a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-8c0-51.52-35-94.46-82.33-107.52A31.89 31.89 0 0 0 240 0h-32a31.89 31.89 0 0 0-29.67 20.48C131 33.54 96 76.48 96 128h-8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zM272 54.91A79.94 79.94 0 0 1 320 128h-48zM208 32h32v96h-32zm-80 96a79.94 79.94 0 0 1 48-73.09V128zm6 32h180a92 92 0 0 1 6 32 96 96 0 0 1-192 0 92 92 0 0 1 6-32z"]
  },
      MT = {
    prefix: "fal",
    iconName: "user-headset",
    icon: [448, 512, [], "f82d", "M320 352h-4.7c-12.16 0-24 2.9-35.5 6.8a173.76 173.76 0 0 1-111.64 0c-11.48-3.9-23.29-6.78-35.42-6.78H128A128 128 0 0 0 0 480a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32 128 128 0 0 0-128-128zM32 480a96.1 96.1 0 0 1 96-96h4.74c6.92 0 14.92 1.62 25.16 5.09a205.75 205.75 0 0 0 132.16 0c10.31-3.49 18.33-5.11 25.24-5.11h4.7a96.1 96.1 0 0 1 96 96zm16-256a16 16 0 0 0 16-16v-16c0-88.22 71.78-160 160-160s160 71.78 160 160v16a80.09 80.09 0 0 1-80 80h-32a32 32 0 0 0-32-32h-32a32 32 0 0 0 0 64h96a112.14 112.14 0 0 0 112-112v-16C416 86.12 329.88 0 224 0S32 86.12 32 192v16a16 16 0 0 0 16 16zM224 96a95.57 95.57 0 0 1 71.23 159.76c0 .09.13.15.18.24H304a47.89 47.89 0 0 0 40.55-22.58C349 220.36 352 206.58 352 192a128 128 0 0 0-256 0c0 40.42 19.1 76 48.35 99.47-.06-1.17-.35-2.28-.35-3.47a63.25 63.25 0 0 1 8.93-32A95.58 95.58 0 0 1 224 96z"]
  },
      pT = {
    prefix: "fal",
    iconName: "user-injured",
    icon: [448, 512, [], "f728", "M313.6 288c-11.04 0-21.78 2.6-32.2 6.24-18 6.28-37.28 9.76-57.4 9.76-20.11 0-39.4-3.48-57.39-9.76-10.42-3.64-21.17-6.24-32.21-6.24C60.17 288 0 348.17 0 422.4V464c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4zM80 480H48c-8.82 0-16-7.18-16-16v-41.6c0-36.43 19.26-68.26 48-86.42V480zm32 0V322.64c7.23-1.62 14.69-2.64 22.4-2.64 1.47 0 3.18.36 4.75.52L210.04 480H112zm160 0h-26.93l-28.45-64H272c17.66 0 32 14.36 32 32s-14.34 32-32 32zm144-16c0 8.82-7.18 16-16 16h-72.9c5.51-9.45 8.9-20.29 8.9-32 0-35.3-28.72-64-64-64h-69.6l-23.9-53.76c14.96 3.41 30.11 5.76 45.5 5.76 23.12 0 45.98-3.89 67.95-11.55 8.69-3.04 15.57-4.45 21.65-4.45 56.46 0 102.4 45.94 102.4 102.4V464zM224 256c70.7 0 128-57.31 128-128C352 57.3 294.7 0 224 0 153.31 0 96 57.3 96 128c0 70.69 57.31 128 128 128zm90.1-160h-74.11l49.93-37.45c10.84 10.3 19.06 23.09 24.18 37.45zM224 32c13.38 0 26.1 2.78 37.68 7.75l-75 56.25H133.9c13.25-37.17 48.44-64 90.1-64zm96 96c0 52.93-43.06 96-96 96s-96-43.07-96-96h192z"]
  },
      zT = {
    prefix: "fal",
    iconName: "user-lock",
    icon: [640, 512, [], "f502", "M48 480a16 16 0 0 1-16-16v-41.6A102.47 102.47 0 0 1 134.4 320c19.6 0 39.1 16 89.6 16s70-16 89.6-16c2.7 0 5.3.6 7.9.8a79.45 79.45 0 0 1 13.1-30.7 132.34 132.34 0 0 0-21.1-2.1c-28.7 0-42.5 16-89.6 16s-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464a48 48 0 0 0 48 48h288.4a78.34 78.34 0 0 1-14.8-32zm176-224A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm0-224a96 96 0 1 1-96 96 96.15 96.15 0 0 1 96-96zm272 336a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm96-80h-16v-48a80 80 0 0 0-160 0v48h-16a48 48 0 0 0-48 48v128a48 48 0 0 0 48 48h192a48 48 0 0 0 48-48V336a48 48 0 0 0-48-48zm-144-48a48 48 0 0 1 96 0v48h-96zm160 224a16 16 0 0 1-16 16H400a16 16 0 0 1-16-16V336a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"]
  },
      CT = {
    prefix: "fal",
    iconName: "user-md",
    icon: [448, 512, [], "f0f0", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm93.7 256.1c-33.8-1-44.3 15.9-93.7 15.9-49.3 0-59.8-16.9-93.6-15.9C58 290.2 0 349.5 0 422.4V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-81.6c0-54.3 42.6-98.4 96-101.8v81.7c-23.1 6.9-40 28.3-40 53.7 0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7v-76.9c20.8 6.8 42.2 10.5 64 10.5 21.8 0 43.2-3.7 64-10.5v68.8c-28.2 7.5-48 34.5-48 64.6V488c0 4.2 1.7 8.3 4.7 11.3l10.3 10.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-5.7-5.7V456c0-19.4 17.4-34.8 37.4-31.6 15.7 2.6 26.6 17.4 26.6 33.3v23.6l-5.7 5.7c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l10.3-10.3c3-3 4.7-7.1 4.7-11.3v-32c0-29.7-20.5-54.5-48-61.6v-73.7c53.4 3.4 96 47.5 96 101.8V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-81.6c.2-72.9-57.8-132.2-130.1-134.3zM168 456c0 13.2-10.8 24-24 24s-24-10.8-24-24 10.8-24 24-24 24 10.8 24 24z"]
  },
      LT = {
    prefix: "fal",
    iconName: "user-md-chat",
    icon: [640, 512, [], "f82e", "M512 0c-70.69 0-128 50.17-128 112 0 28.76 12.75 54.72 33.11 74.55a312.08 312.08 0 0 1-31.29 55.37 9.86 9.86 0 0 0-1.25 9.07c1.09 3.13 3.43 5 6.1 5 39.85 0 72.35-17.13 95.23-34.36A146 146 0 0 0 512 224c70.7 0 128-50.14 128-112S582.7 0 512 0zm0 192a114.76 114.76 0 0 1-20.38-1.84l-13.78-2.5-11.18 8.42a155.47 155.47 0 0 1-26.13 16.07c2-4.08 4-8.35 5.91-12.79l8.87-20.28-15.87-15.45C428.75 153.24 416 135.83 416 112c0-44.11 43.06-80 96-80s96 35.89 96 80-43.06 80-96 80zm-194.31 96.1c-33.8-1-44.3 15.9-93.7 15.9s-59.79-16.9-93.59-15.9A134.33 134.33 0 0 0 0 422.4V504a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-81.6c0-54.3 42.6-98.4 96-101.8v81.7a56 56 0 1 0 32 0v-76.9a200.3 200.3 0 0 0 128 0v68.8c-28.2 7.5-48 34.5-48 64.6V488a16.06 16.06 0 0 0 4.7 11.3l10.3 10.3a8 8 0 0 0 11.3 0l11.3-11.3a8 8 0 0 0 0-11.3l-5.7-5.7V456a32.14 32.14 0 0 1 37.4-31.6c15.7 2.6 26.6 17.4 26.6 33.3v23.6l-5.7 5.7a8 8 0 0 0 0 11.3l11.3 11.3a8 8 0 0 0 11.3 0l10.3-10.3a16.06 16.06 0 0 0 4.7-11.3v-32a63.8 63.8 0 0 0-48-61.6v-73.7c53.4 3.4 96 47.5 96 101.8V504a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-81.6a134 134 0 0 0-130.11-134.3zM168 456a24 24 0 1 1-24-24 24.06 24.06 0 0 1 24 24zm56-200A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm0-224a96 96 0 1 1-96 96 96.15 96.15 0 0 1 96-96z"]
  },
      AT = {
    prefix: "fal",
    iconName: "user-minus",
    icon: [640, 512, [], "f503", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm408 192H424c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-318.4 64c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zM416 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 56.5 0 102.4 45.9 102.4 102.4V464z"]
  },
      NT = {
    prefix: "fal",
    iconName: "user-music",
    icon: [640, 512, [], "f8eb", "M598 97.64l-96.56 31.88C488.72 133.73 480 146 480 160v216.13C459.66 361.28 431.38 352 400 352c-61.86 0-112 35.82-112 80s50.14 80 112 80 112-35.82 112-80V288l106.12-35.37A32 32 0 0 0 640 222.27V128a32 32 0 0 0-42-30.36zM400 480c-47.14 0-80-25.3-80-48s32.86-48 80-48 80 25.3 80 48-32.86 48-80 48zm208-257.72l-96 32V160h-.56v-.13L608 128zM269.91 480H48a16 16 0 0 1-16-16v-41.59A102.49 102.49 0 0 1 134.41 320c19.59 0 39.09 16 89.59 16s70-16 89.59-16a101.48 101.48 0 0 1 36.64 7.06 184.33 184.33 0 0 1 49.49-7c-23.38-19.69-53.17-32-86.13-32-28.68 0-42.5 16-89.59 16s-60.81-16-89.59-16A134.43 134.43 0 0 0 0 422.41V464a48 48 0 0 0 48 48h250.42a113.81 113.81 0 0 1-28.51-32zM224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm0-224a96 96 0 1 1-96 96 96.14 96.14 0 0 1 96-96z"]
  },
      gT = {
    prefix: "fal",
    iconName: "user-ninja",
    icon: [448, 512, [], "f504", "M319.4 288.6L224 368l-95.4-79.4C57.1 291.7 0 350.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.2-57.1-130.7-128.6-133.8zM208 480H48c-8.8 0-16-7.2-16-16v-41.6c0-50.8 37.1-93 86.4-100.7 89.9 74.8 83.2 69.2 89.6 74.6V480zm208-16c0 8.8-7.2 16-16 16H240v-83.7c6.3-5.3-.2.2 89.6-74.6 49.3 7.7 86.4 49.9 86.4 100.7V464zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zM224 32c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm48 64h-96c-17.7 0-32 14.3-32 32h160c0-17.7-14.3-32-32-32z"]
  },
      HT = {
    prefix: "fal",
    iconName: "user-nurse",
    icon: [448, 512, [], "f82f", "M319.41,318,224,413.39,128.59,318C57.09,321.09,0,379.59,0,451.8A58.23,58.23,0,0,0,58.2,510H389.8A58.23,58.23,0,0,0,448,451.8C448,379.59,390.91,321.09,319.41,318ZM208,478H58.2A26.28,26.28,0,0,1,32,451.8c0-47.46,38-92.44,84.73-100.41L208,442.66Zm181.8,0H240V442.64l91.25-91.25C378,359.36,416,404.34,416,451.8A26.28,26.28,0,0,1,389.8,478ZM224,302A128,128,0,0,0,352,174V63.82a32,32,0,0,0-20.76-30L246.47,2.07a64.06,64.06,0,0,0-44.94,0L116.76,33.86A32,32,0,0,0,96,63.82V174A128,128,0,0,0,224,302ZM128,63.82,212.77,32a32,32,0,0,1,22.47,0L320,63.82V142H128ZM320,174a96,96,0,0,1-192,0ZM259,72.67H237.33V51a5,5,0,0,0-5-5H215.67a5,5,0,0,0-5,5V72.67H189a5,5,0,0,0-5,5V94.33a5,5,0,0,0,5,5h21.67V121a5,5,0,0,0,5,5h16.66a5,5,0,0,0,5-5V99.33H259a5,5,0,0,0,5-5V77.67A5,5,0,0,0,259,72.67Z"]
  },
      VT = {
    prefix: "fal",
    iconName: "user-plus",
    icon: [640, 512, [], "f234", "M632 224h-88v-88c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v88h-88c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88v88c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-88h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-318.4 64c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zM416 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 56.5 0 102.4 45.9 102.4 102.4V464zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"]
  },
      xT = {
    prefix: "fal",
    iconName: "user-robot",
    icon: [448, 512, [], "e04b", "M144,288h32V256H144Zm128,0h32V256H272Zm-64,0h32V256H208Zm48,144a16,16,0,1,0,16,16A15.99954,15.99954,0,0,0,256,432ZM384,272h32a31.99908,31.99908,0,0,0,32-32V176a31.99908,31.99908,0,0,0-32-32H384V128a64.00067,64.00067,0,0,0-64-64H241.99926V18a18,18,0,1,0-36,0V64H128a64.00067,64.00067,0,0,0-64,64v16H32A31.99908,31.99908,0,0,0,0,176v64a31.99908,31.99908,0,0,0,32,32H64v16a63.57126,63.57126,0,0,0,10.32617,34.67383A95.88682,95.88682,0,0,0,0,416v64a31.99908,31.99908,0,0,0,32,32H416a31.99908,31.99908,0,0,0,32-32V416a95.88682,95.88682,0,0,0-74.32617-93.32617A63.57126,63.57126,0,0,0,384,288Zm0-96h32v64H384ZM64,240H32V176H64ZM96,128a32.03667,32.03667,0,0,1,32-32H320a32.03667,32.03667,0,0,1,32,32V288a32.03667,32.03667,0,0,1-32,32H128a32.03667,32.03667,0,0,1-32-32ZM320,480H208V448a16,16,0,0,0-32,0v32H128V432a16.00079,16.00079,0,0,1,16-16H304a16.00079,16.00079,0,0,1,16,16Zm96-64v64H352V432a48.055,48.055,0,0,0-48-48H144a48.055,48.055,0,0,0-48,48v48H32V416a64.07333,64.07333,0,0,1,64-64H352A64.07333,64.07333,0,0,1,416,416ZM288,224a48,48,0,1,0-48-48A47.99737,47.99737,0,0,0,288,224Zm0-64a16,16,0,1,1-16,16A16.01833,16.01833,0,0,1,288,160ZM160,224a48,48,0,1,0-48-48A47.99737,47.99737,0,0,0,160,224Zm0-64a16,16,0,1,1-16,16A16.01833,16.01833,0,0,1,160,160Z"]
  },
      wT = {
    prefix: "fal",
    iconName: "user-secret",
    icon: [448, 512, [], "f21b", "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-43.2c1.5-7.8 2.4-15.8 2.4-24 0-7.2-.9-14.2-2.2-21.1 40.5-9.8 66.2-24.2 66.2-40.2 0-16.5-27-31.2-69.3-41-8.9-33.6-27.4-67.9-41.3-85.4-6.3-8-15.7-12.3-25.3-12.3-9.5 0-12.3 2.4-41.8 17.2-12.8 6.4-24.3 2.1-28.6 0C179.9 2.3 177.3 0 167.9 0c-9.6 0-18.9 4.3-25.2 12.2-13.9 17.5-32.4 51.8-41.3 85.4C59 107.4 32 122.2 32 138.7c0 16.1 25.7 30.5 66.2 40.2-1.3 6.9-2.2 13.9-2.2 21.1 0 8.2.9 16.2 2.4 24H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM128 200c0-2.7.3-5.3.6-7.9 1.3.8 5.1 3.3 5.8 5.4 3.9 11.9 7 24.6 16.5 33.4 8 7.4 47 25.1 64-25 2.8-8.4 15.4-8.4 18.3 0 16 47.4 53.9 34.4 64 25 9.5-8.8 12.7-21.5 16.5-33.4.7-2.1 4.4-4.6 5.8-5.4.3 2.6.6 5.2.6 7.9 0 52.9-43.1 96-96 96S128 252.9 128 200zm-.7-75.5c.7-2.7 12.3-57 40.5-92.5 28.7 14.4 37.7 20.5 56.2 20.5 18.6 0 27.7-6.3 56.2-20.5l.1.1c28.1 35.4 39.7 89.6 40.4 92.4 21.4 4.9 35.8 7.9 51 14.2-24.3 9.9-75.4 21.3-147.7 21.3s-123.4-11.4-147.7-21.3c15.2-6.3 29.9-9.3 51-14.2zM44.8 480c-7.1 0-12.8-5.7-12.8-12.8v-44.8c0-36.5 19.2-69.5 51.4-88.2L108 320l-27.4-64h28.9c4.7 9.6 64.3 108.5 64.3 108.5L142.9 480H44.8zm131.2 0l32-120-21.9-38.4c12.1 3.8 24.6 6.4 37.9 6.4s25.9-2.6 37.9-6.4L240 360l32 120h-96zm240-12.8c0 7.1-5.7 12.8-12.8 12.8h-98.1l-30.8-115.5s59.6-98.9 64.3-108.5h31l-25 65.6 22.5 13.9c30.6 18.9 48.9 51.4 48.9 86.9v44.8z"]
  },
      yT = {
    prefix: "fal",
    iconName: "user-shield",
    icon: [640, 512, [], "f505", "M622.3 271.1l-115.2-45c-3.5-1.4-7.3-2.1-11.1-2.1s-7.5.7-11.1 2.1l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 3.5 1.4 7.3 2.1 11.1 2.1s7.5-.7 11.1-2.1C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM480 472c-48.2-26.8-94.6-87.6-96-172.1l96-37.5V472zm16.6 8.1c-.1 0-.2-.1-.2-.1h.5c-.2 0-.3.1-.3.1zm15.4-7.6V262.4l96 37.5c-1.5 94.8-57.1 150.2-96 172.6zM48 480c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 2.6 0 5 .6 7.5.8-.7-8.1-1.1-16.3-1.1-24.8 0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-10.3-8.2-20.2-17.6-29.7-28H48zm176-224c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"]
  },
      bT = {
    prefix: "fal",
    iconName: "user-slash",
    icon: [640, 512, [], "f506", "M637 485.2L23 1.8C19.6-1 14.5-.4 11.8 3l-10 12.5C-1 19-.4 24 3 26.8l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.6 2.2-8.6-1.2-11.4zM320 32c52.9 0 96 43.1 96 96 0 35.9-20 66.9-49.3 83.3l26.8 21.1C426.4 209.3 448 171.2 448 128 448 57.3 390.7 0 320 0c-54 0-100 33.6-118.8 81l26.8 21.1C239.4 61.8 276.1 32 320 32zm176 448H144c-8.8 0-16-7.2-16-16v-41.6c0-56.5 45.9-102.4 102.4-102.4 6.1 0 13 1.4 21.7 4.4 21.3 7.4 43.4 11.1 65.8 11.4l-51.6-40.6c-17.5-5.7-26.8-7.2-35.9-7.2C156.2 288 96 348.2 96 422.4V464c0 26.5 21.5 48 48 48h352c11.9 0 22.6-4.5 30.9-11.6l-27-21.2c-1.2.3-2.5.8-3.9.8z"]
  },
      ST = {
    prefix: "fal",
    iconName: "user-tag",
    icon: [640, 512, [], "f507", "M223.9 256c70.7 0 128-57.3 128-128S294.6 0 223.9 0C153.3 0 96 57.3 96 128s57.3 128 127.9 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96c.1-52.9 43.1-96 96-96zm406.7 332.8l-90.2-90.3c-12-12-28.3-18.7-45.2-18.7h-79.3c-17.7 0-32 14.3-32 32v79.3c0 17 6.7 33.3 18.7 45.3l90.2 90.3c6.2 6.2 14.4 9.4 22.6 9.4 8.2 0 16.4-3.1 22.6-9.4l92.5-92.5c12.6-12.6 12.6-32.9.1-45.4zM515.5 480l-90.2-90.3c-6-6-9.4-14.1-9.4-22.6v-79.3h79.3c8.5 0 16.6 3.3 22.6 9.4l90.2 90.3-92.5 92.5zm-51.6-160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-64 160H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.3 0 70-16 89.6-16 13.6 0 26.5 2.8 38.4 7.6v-33.4c-12.2-3.7-25-6.2-38.4-6.2-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h351.9c15.6 0 29.3-7.6 38.1-19.1l-23.2-23.2c-2.4 6-8.1 10.3-14.9 10.3z"]
  },
      TT = {
    prefix: "fal",
    iconName: "user-tie",
    icon: [448, 512, [], "f508", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm91.9 272.2L276.2 442l-33.9-101.7 25-25c10.1-10.1 2.9-27.3-11.3-27.3h-64c-14.3 0-21.4 17.2-11.3 27.3l25 25L171.8 442l-39.7-137.7C58.9 305.5 0 365 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-73.4-58.9-132.9-132.1-134.2zM48 480c-8.8 0-16-7.2-16-16v-25.6c0-47.2 32.8-87.5 76.9-98.9L149.5 480H48zm144.9 0l31.1-93.4 31.1 93.4h-62.2zM416 464c0 8.8-7.2 16-16 16H298.5L339 339.5c44.1 11.4 76.9 51.7 76.9 98.9V464z"]
  },
      DT = {
    prefix: "fal",
    iconName: "user-times",
    icon: [640, 512, [], "f235", "M582.6 240l55-55c3.1-3.1 3.1-8.2 0-11.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0l-55 55-55-55c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l55 55-55 55c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l55-55 55 55c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-55-55zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm89.6 256c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zM416 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 56.5 0 102.4 45.9 102.4 102.4V464z"]
  },
      jT = {
    prefix: "fal",
    iconName: "user-unlock",
    icon: [640, 512, [], "e058", "M592,288H448V208.79c0-26.32,20.86-48.34,47.18-48.78A48,48,0,0,1,544,208v8a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8v-7c0-43.28-34-79.51-77.26-80.95A80,80,0,0,0,416,208v80H400a48,48,0,0,0-48,48V464a48,48,0,0,0,48,48H592a48,48,0,0,0,48-48V336A48,48,0,0,0,592,288Zm16,176a16,16,0,0,1-16,16H400a16,16,0,0,1-16-16V336a16,16,0,0,1,16-16H592a16,16,0,0,1,16,16ZM224,256A128,128,0,1,0,96,128,128,128,0,0,0,224,256Zm0-224a96,96,0,1,1-96,96A96,96,0,0,1,224,32ZM496,368a32,32,0,1,0,32,32A32,32,0,0,0,496,368ZM48,480a16,16,0,0,1-16-16V422.4A102.47,102.47,0,0,1,134.4,320c19.6,0,39.1,16,89.6,16s70-16,89.6-16c2.7,0,5.3.6,7.9.8a79.38,79.38,0,0,1,13.1-30.7,132.22,132.22,0,0,0-21.1-2.1c-28.7,0-42.5,16-89.6,16s-60.8-16-89.6-16C60.2,288,0,348.2,0,422.4V464a48,48,0,0,0,48,48H336.4a78.37,78.37,0,0,1-14.8-32Z"]
  },
      ET = {
    prefix: "fal",
    iconName: "user-visor",
    icon: [448, 512, [], "e04c", "M98.50586,152.8457a127.91341,127.91341,0,0,0,250.98828.002C360.37305,145.69141,368,133.97266,368,120V104c0-19.57422-14.38672-35.14648-32.98047-38.58008C313.04883,26.54688,271.834,0,224,0S134.95312,26.54688,112.98242,65.41992C94.38867,68.85352,80,84.42578,80,104v16C80,133.9707,87.62695,145.69141,98.50586,152.8457ZM224,224c-41.63281,0-76.834-26.8457-90.0957-64H314.0957C300.834,197.1543,265.63281,224,224,224Zm0-192c28.24023,0,53.42188,12.50586,71.00977,32H152.99023C170.57812,44.50586,195.75977,32,224,32ZM112,104a8.01545,8.01545,0,0,1,8-8H328a8.01545,8.01545,0,0,1,8,8v16a8.01545,8.01545,0,0,1-8,8H120a8.01545,8.01545,0,0,1-8-8ZM322.875,352h-.125a3.9709,3.9709,0,0,0-3.03125,1.39062c-19.8125,22.98438-31.8125,53.09376-35.6875,89.5a3.9982,3.9982,0,0,0,6.4375,3.57813c24.84375-19.32813,33.75-23.8125,37.03125-24.8125a6.629,6.629,0,0,1,1.375-.375c2.625,2.32813,8.1875,8.57813,19.875,25.03125A3.94519,3.94519,0,0,0,352,448a4.06435,4.06435,0,0,0,1.28125-.20312A4.01157,4.01157,0,0,0,356,443.875c-1.15625-35.32812-11.28125-65.70312-30.0625-90.29688A4.02082,4.02082,0,0,0,322.875,352Zm-9.28125-64c-28.6875,0-42.5,16-89.59375,16s-60.8125-16-89.59375-16A134.43133,134.43133,0,0,0,0,422.40625V464a48.01238,48.01238,0,0,0,48,48H400a48.01238,48.01238,0,0,0,48-48V422.40625A134.43133,134.43133,0,0,0,313.59375,288ZM416,464a16.041,16.041,0,0,1-16,16H48a16.041,16.041,0,0,1-16-16V422.40625A102.47984,102.47984,0,0,1,134.40625,320C153.99922,320,173.5,336,224,336c50.40625,0,69.99922-16,89.59375-16A102.47984,102.47984,0,0,1,416,422.40625Z"]
  },
      kT = {
    prefix: "fal",
    iconName: "users",
    icon: [640, 512, [], "f0c0", "M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"]
  },
      IT = {
    prefix: "fal",
    iconName: "users-class",
    icon: [640, 512, [], "f63d", "M544 224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm-304-48c0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80-80 35.8-80 80zm128 0c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zM96 384c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm468 160h-40c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zm-448 0H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zm224 0h-40c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM64 48c0-8.83 7.19-16 16-16h480c8.81 0 16 7.17 16 16v149.22c11.51 3.46 22.37 8.36 32 15.11V48c0-26.47-21.53-48-48-48H80C53.53 0 32 21.53 32 48v164.33c9.63-6.75 20.49-11.64 32-15.11V48z"]
  },
      OT = {
    prefix: "fal",
    iconName: "users-cog",
    icon: [640, 512, [], "f509", "M287.4 250.6c2.9-10.4 6.5-20.4 10.9-30-33.6-9.5-58.4-40.1-58.4-76.7 0-44.1 35.9-80 80-80 36.6 0 67.1 24.8 76.7 58.4 9.6-4.4 19.6-8.1 30-10.9C412.6 65.6 370.4 32 320 32c-61.9 0-112 50.1-112 112 0 50.4 33.6 92.6 79.4 106.6zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm61.1 172.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4zM176 448c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 14.3 0 18.8 2.4 40.7 7.2-.2-3.8-1.4-13.4.6-32.6-16.3-4.3-26.4-6.6-41.3-6.6-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h209c-16-8.6-30.6-19.5-43.5-32H176zm304-208.5c-35.6 0-64.5 29-64.5 64.5s28.9 64.5 64.5 64.5 64.5-29 64.5-64.5-28.9-64.5-64.5-64.5zm0 97c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5 32.5 14.6 32.5 32.5-14.6 32.5-32.5 32.5zm148.3-10.2l-16.5-9.5c.8-8.5.8-17.1 0-25.6l16.6-9.5c9.5-5.5 13.8-16.7 10.5-27-7.2-23.4-19.9-45.4-36.7-63.5-7.4-8.1-19.3-9.9-28.8-4.4l-16.5 9.5c-7-5-14.4-9.3-22.2-12.8v-19c0-11-7.5-20.3-18.2-22.7-23.9-5.4-49.3-5.4-73.3 0-10.7 2.4-18.2 11.8-18.2 22.7v19c-7.8 3.5-15.3 7.8-22.2 12.8l-16.5-9.5c-9.5-5.5-21.3-3.7-28.7 4.4-16.8 18.1-29.4 40.1-36.7 63.4-3.3 10.4 1.2 21.8 10.6 27.2l16.5 9.5c-.8 8.5-.8 17.1 0 25.6l-16.6 9.5c-9.3 5.4-13.8 16.9-10.5 27.1 7.3 23.4 19.9 45.4 36.7 63.5 7.4 8 19.2 9.8 28.8 4.4l16.5-9.5c7 5 14.4 9.3 22.2 12.8v19c0 11 7.5 20.3 18.2 22.7 12 2.7 24.3 4 36.6 4s24.7-1.3 36.6-4c10.7-2.4 18.2-11.8 18.2-22.7v-19c7.8-3.5 15.2-7.8 22.2-12.8l16.5 9.5c9.4 5.4 21.3 3.6 28.7-4.4 16.8-18.1 29.4-40.1 36.7-63.4 3.4-10.4-1.1-21.9-10.5-27.3zm-51.6 7.2l29.4 17c-5.3 14.3-13 27.8-22.8 39.5l-29.4-17c-21.4 18.3-24.5 20.1-51.1 29.5v34c-15.1 2.6-30.6 2.6-45.6 0v-34c-26.9-9.5-30.2-11.7-51.1-29.5l-29.4 17c-9.8-11.8-17.6-25.2-22.8-39.5l29.4-17c-4.9-26.8-5.2-30.6 0-59l-29.4-17c5.2-14.3 13-27.7 22.8-39.5l29.4 17c21.4-18.3 24.5-20.1 51.1-29.5v-34c15.1-2.5 30.7-2.5 45.6 0v34c26.8 9.5 30.2 11.6 51.1 29.5l29.4-17c9.8 11.8 17.6 25.2 22.8 39.5l-29.4 17c4.9 26.8 5.2 30.6 0 59z"]
  },
      QT = {
    prefix: "fal",
    iconName: "users-crown",
    icon: [640, 512, [], "f6a5", "M564 288h-40c-15.18 0-29.27 4.83-41.15 12.93 9.38 6.37 17.93 13.87 25.45 22.37 4.89-2.05 10.15-3.3 15.7-3.3h40c24.25 0 44 21.53 44 48 0 8.84 7.16 16 16 16s16-7.16 16-16c0-44.11-34.09-80-76-80zm-20-32c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80zm0-128c26.47 0 48 21.53 48 48s-21.53 48-48 48-48-21.53-48-48 21.53-48 48-48zM400.15 308.02c-11.88 0-23.87 1.73-35.49 5.26-14.16 4.3-29.1 6.72-44.66 6.72s-30.5-2.42-44.66-6.71a122.209 122.209 0 0 0-35.49-5.26c-36.29 0-71.58 16.18-92.28 46.93C135.21 373.3 128 395.41 128 419.2V432c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-12.8c0-23.79-7.21-45.9-19.57-64.25-20.7-30.75-56-46.93-92.28-46.93zM480 432c0 8.82-7.18 16-16 16H176c-8.82 0-16-7.18-16-16v-12.8c0-16.63 4.88-32.67 14.11-46.38 13.83-20.54 38.4-32.8 65.74-32.8 8.9 0 17.71 1.31 26.19 3.88 17.69 5.37 35.84 8.1 53.96 8.1s36.27-2.72 53.96-8.1a89.887 89.887 0 0 1 26.19-3.88c27.34 0 51.91 12.26 65.74 32.8 9.23 13.71 14.11 29.75 14.11 46.38V432zM96 256c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80zm0-128c26.47 0 48 21.53 48 48s-21.53 48-48 48-48-21.53-48-48 21.53-48 48-48zm61.15 172.93C145.27 292.83 131.18 288 116 288H76c-41.91 0-76 35.89-76 80 0 8.84 7.16 16 16 16s16-7.16 16-16c0-26.47 19.75-48 44-48h40c5.55 0 10.81 1.25 15.7 3.3 7.52-8.5 16.07-16 25.45-22.37zM320 288c61.86 0 112-50.14 112-112V32l-56 28-56-28-56 28-56-28v144c0 61.86 50.14 112 112 112zM240 83.78l24 12 56-28 56 28 24-12V128H240V83.78zm0 76.22h160v16c0 44.11-35.89 80-80 80s-80-35.89-80-80v-16z"]
  },
      ZT = {
    prefix: "fal",
    iconName: "users-medical",
    icon: [640, 512, [], "f830", "M512 224a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 224a96 96 0 1 1 96-96 96 96 0 0 1-96 96zm58.67-117.33h-37.34v-37.34A5.33 5.33 0 0 0 528 288h-32a5.33 5.33 0 0 0-5.33 5.33v37.34h-37.34A5.33 5.33 0 0 0 448 336v32a5.33 5.33 0 0 0 5.33 5.33h37.34v37.34A5.33 5.33 0 0 0 496 416h32a5.33 5.33 0 0 0 5.33-5.33v-37.34h37.34A5.33 5.33 0 0 0 576 368v-32a5.33 5.33 0 0 0-5.33-5.33zM320 256a112 112 0 1 0-112-112 111.94 111.94 0 0 0 112 112zm0-192a80 80 0 1 1-80 80 80.11 80.11 0 0 1 80-80zM96 224a80 80 0 1 0-80-80 80 80 0 0 0 80 80zm0-128a48 48 0 1 1-48 48 48 48 0 0 1 48-48zm288.81 352H176a16 16 0 0 1-16-16v-44.8a83.08 83.08 0 0 1 14.1-46.4c13.8-20.5 38.4-32.8 65.7-32.8s37.2 12 80.2 12a164.08 164.08 0 0 0 36.33-3.66A157.66 157.66 0 0 1 370 279.85c-13.87 3.51-26.11 8.15-50 8.15-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9a114.59 114.59 0 0 0-19.6 64.3V432a48 48 0 0 0 48 48h241a161 161 0 0 1-32.19-32zM157.1 268.9A72.83 72.83 0 0 0 116 256H76c-41.9 0-76 35.9-76 80a16 16 0 0 0 32 0c0-26.5 19.8-48 44-48h40a39.79 39.79 0 0 1 15.7 3.3 138.76 138.76 0 0 1 25.4-22.4z"]
  },
      UT = {
    prefix: "fal",
    iconName: "users-slash",
    icon: [640, 512, [], "e073", "M320,64a79.94,79.94,0,0,1,45,146.05l25.67,20.21C415.71,209.73,432,178.94,432,144A111.93,111.93,0,0,0,320,32c-44.42,0-82.41,26-100.53,63.44l25.91,20.4A80,80,0,0,1,320,64ZM544,224a80,80,0,1,0-80-80A80,80,0,0,0,544,224Zm0-128a48,48,0,1,1-48,48A48,48,0,0,1,544,96Zm20,160H524a72.22,72.22,0,0,0-41.09,12.91A135.38,135.38,0,0,1,508.3,291.3,39.79,39.79,0,0,1,524,288h40c24.2,0,44,21.5,44,48a16,16,0,0,0,32,0C640,291.91,605.91,256,564,256ZM176,448a16,16,0,0,1-16-16V387.2a83.2,83.2,0,0,1,14.09-46.4C187.91,320.3,212.5,308,239.8,308c21.3,0,32.15,7.19,56,10.42L242.09,276.1c-.77,0-1.39-.1-2.18-.1-36.32,0-71.61,16.2-92.32,46.91A114.63,114.63,0,0,0,128,387.2V432a48,48,0,0,0,48,48H464a47.73,47.73,0,0,0,26.7-8.13L460.39,448ZM26,106a79.12,79.12,0,0,0-10,38,79.7,79.7,0,0,0,133.45,59.15L123.83,183a47.86,47.86,0,0,1-72.28-56.92Zm131.06,163A72.73,72.73,0,0,0,116,256H76c-41.91,0-76,35.91-76,80a16,16,0,0,0,32,0c0-26.5,19.8-48,44-48h40a39.79,39.79,0,0,1,15.7,3.3A138.6,138.6,0,0,1,157.09,268.91ZM23,1.8A7.88,7.88,0,0,0,11.77,3l-10,12.5A7.94,7.94,0,0,0,3,26.71L617,510.23A8,8,0,0,0,628.2,509l10-12.5a7.86,7.86,0,0,0-1.21-11.2Z"]
  },
      BT = {
    prefix: "fal",
    iconName: "utensil-fork",
    icon: [512, 512, [], "f2e3", "M458.5 107.1c.4-27.4-27.3-54-53.6-53.6.4-34.4-43.8-68.7-75.3-46.5-8.8 6.1-80.1 55.7-105.2 80.7-42.1 42.1-51.5 97.7-32 145.8L13 395c-16.8 15.1-17.5 41.2-1.5 57.2l48.3 48.3c16.2 16.2 42.3 15 57.2-1.5l161.4-179.2c49 19.8 104.3 9.4 145.8-32 25.1-25.1 74.5-96.4 80.6-105.2 22-31.3-10.2-76-46.3-75.5zm20.2 57s-53.2 77-77.2 101c-38.1 38.1-89.2 41.9-130.4 14.8l-178 197.6c-2.8 3.2-7.7 3.3-10.7.3l-48.3-48.3c-3-3-2.9-7.9.3-10.7l197.6-178c-27.1-41.3-23.2-92.4 14.8-130.4 23.9-23.9 101-77.2 101-77.2 9.2-6.7 30.6 15 23.6 24l-98.6 98.6c-8.5 10 13.3 32.2 23.6 24l105-93.1c9.1-6.5 30.3 14.7 23.8 23.8l-93.1 105c-8.2 10.3 14 32.1 24 23.6l98.6-98.6c9.1-7 30.7 14.4 24 23.6z"]
  },
      RT = {
    prefix: "fal",
    iconName: "utensil-knife",
    icon: [512, 512, [], "f2e4", "M72.9 498.4l-48.3-48.3C7 432.5 6.2 404.5 23.3 387.4l375-375C415.2-4.5 443.4-4 461 13.7c20.8 20.6 40 60.8 40 122.3 0 102.8-67.6 225.8-231.9 205.2L138.1 497c-16.6 19.7-46.7 19.9-65.2 1.4zM421 35L46 410c-4.6 4.6-3.7 12.5 1.3 17.5l48.3 48.3c5.4 5.4 13.8 5.7 18 .7L256.1 307c82.8 12.7 153.2-4 191.3-79.3 14.7-29 21.7-61.4 21.7-91.7 0-48-11.3-80.4-30.6-99.7-5.2-5.2-13-5.8-17.5-1.3z"]
  },
      YT = {
    prefix: "fal",
    iconName: "utensil-spoon",
    icon: [512, 512, [], "f2e5", "M60.3 499.8l-48.1-48.1C-4.6 435-4 407.4 13.8 391.5L206 219c-22.3-53.2-10.6-111.8 35.2-157.7C303.3-.8 416.7-26 477.3 34.6c60.7 60.7 35.3 174.2-26.7 236.1-45.8 45.9-104.4 57.7-157.6 35.3L120.5 498.2c-15.9 17.7-43.4 18.5-60.2 1.6zM263.8 83.9c-45.7 45.7-44.5 92.6-18.4 142.7L35.2 415.3c-4.1 3.6-4.2 9.9-.4 13.8l48.1 48.1c3.9 3.9 10.2 3.6 13.8-.4l188.7-210.3c49.5 25.8 96.7 27.7 142.7-18.4 49.3-49.4 74-143.7 26.7-191-45.4-45.3-139-25.2-191 26.8z"]
  },
      PT = {
    prefix: "fal",
    iconName: "utensils",
    icon: [480, 512, [], "f2e7", "M344.1 470.3l14.2-164.8c-42.1-33.1-70.4-77-70.4-129.5C288 81.7 376.1 0 440 0c22.1 0 40 17.3 40 38.5v435c0 21.2-17.9 38.5-40 38.5h-56c-22.8 0-41.8-18.7-39.9-41.7zM320 176c0 51 32.2 85.5 71.8 114.5L376 473.1c-.3 3.7 3.4 6.9 8 6.9h56c4.3 0 8-3 8-6.5v-435c0-3.5-3.7-6.5-8-6.5-44.6 0-120 65.8-120 144zM240.7 33.8C237.4 14.3 219.5 0 194.6 0c-11.9 0-24.1 3.4-33.3 11.2C152.9 4.1 141.3 0 128 0s-24.9 4.1-33.3 11.2C85.5 3.4 73.3 0 61.4 0 36.2 0 18.6 14.5 15.3 33.8 13.5 43.2 0 118.4 0 149.9c0 50.9 26.7 91.6 71 110.7L59.6 471.4C58.4 493.4 75.9 512 98 512h60c22 0 39.6-18.5 38.4-40.6L185 260.6c44.2-19.1 71-59.8 71-110.7 0-31.5-13.5-106.7-15.3-116.1zM152.3 240l12.2 233.1c.2 3.7-2.7 6.9-6.5 6.9H98c-3.7 0-6.7-3.1-6.5-6.9L103.7 240C61.3 231.2 32 197 32 149.9c0-29.7 14.8-110.6 14.8-110.6 1.6-9.9 28.3-9.7 29.5.2V162c.9 11.5 28.2 11.7 29.5.2l7.4-122.9c1.6-9.7 27.9-9.7 29.5 0l7.4 122.9c1.3 11.4 28.6 11.2 29.5-.2V39.6c1.2-9.9 27.9-10.1 29.5-.2 0 0 14.8 80.9 14.8 110.6.1 46.8-29 81.2-71.6 90z"]
  },
      FT = {
    prefix: "fal",
    iconName: "utensils-alt",
    icon: [576, 512, [], "f2e6", "M0 60c0 142.9 69.8 215.8 188.6 226.5L84.2 379.1c-25.8 22.9-27 63-2.6 87.3l28 28c24.6 24.6 64.6 23.1 87.3-2.6L290 386.7c96.3 113.5 89.4 105.4 90.3 106.3 22.9 24.4 61.9 25.7 86.2 1.4l28-28c24.1-24.1 23.2-63.3-1.6-86.4L384.8 279.7l7.2-7.7c38.8 12.1 77.1 7 110.3-26.1 20.9-20.9 61.7-79.7 66.8-87.1 20.1-28.5-7.3-66.8-37.4-70.6-2.8-22.1-23.6-41.5-43.9-44-3.9-31-42.6-57.1-70.6-37.4-7.4 5.1-66.2 46-87.1 66.9C298 105.8 291.4 144 304 184l-11.2 10.3-192-178.2C62.6-19.4 0 7.7 0 60zm379.7 177.2l-18.4 20.7-44.9-41.7 22.5-19.9c-18.8-33-15.4-70.7 13.9-100C372.3 76.7 435.6 33 435.6 33c7.6-5.5 25.1 12.3 19.4 19.7l-81 80.9c-7 8.2 10.9 26.4 19.4 19.7l86.1-76.4c7.4-5.4 24.9 12 19.5 19.5l-76.4 86.1C416 191 434.1 209 442.4 202l80.9-80.9c7.4-5.8 25.2 11.8 19.7 19.4 0 0-43.7 63.2-63.3 82.9-29.6 29.4-67.3 32.4-100 13.8zm-161 65.5l50.4 59.3L173 470.6c-10.7 12-29.3 12.7-40.8 1.2l-28-28c-11.4-11.4-10.8-30.1 1.2-40.8l113.3-100.3zM32 60c0-24.4 29.1-37.2 47.1-20.5l392 364c11.6 10.8 12 29.1.7 40.3l-28 28c-11.2 11.2-29.4 10.9-40.2-.6L221 256C81 256 32 177.2 32 60z"]
  },
      WT = {
    prefix: "fal",
    iconName: "vacuum",
    icon: [640, 512, [], "e04d", "M352,400a16,16,0,1,0,16,16A16,16,0,0,0,352,400ZM640,112A112.14,112.14,0,0,0,528,0H302.16A112.4,112.4,0,0,0,192.5,89.31L124.91,416H80A80,80,0,0,0,0,496a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V432a16,16,0,0,0-16-16H157.57L223.81,95.78A80.33,80.33,0,0,1,302.16,32H528a80,80,0,0,1,0,160H494.82A191.28,191.28,0,0,0,352,128a32,32,0,0,0-32,32V325.9c-37.17,13.25-64,48.44-64,90.1a96.1,96.1,0,0,0,96,96H480a64,64,0,0,0,64-64V320a190.78,190.78,0,0,0-25.9-96H528A112.14,112.14,0,0,0,640,112ZM192,448v32H34.74A48.1,48.1,0,0,1,80,448Zm160,32a64,64,0,1,1,64-64A64.07,64.07,0,0,1,352,480Zm160-32a32,32,0,0,1-32,32H423a95.58,95.58,0,0,0-71-160h0l0-160h0c88.22,0,160,71.78,160,160Z"]
  },
      GT = {
    prefix: "fal",
    iconName: "vacuum-robot",
    icon: [512, 512, [], "e04e", "M431.36,80.64a248,248,0,0,0-350.72,0c-96.85,96.85-96.85,253.87,0,350.72a248,248,0,0,0,350.72,0C528.21,334.51,528.21,177.49,431.36,80.64ZM408.74,408.73a216,216,0,0,1-305.48,0c-84.21-84.21-84.21-221.25,0-305.47a216,216,0,0,1,305.48,0C493,187.48,493,324.52,408.74,408.73ZM140.12,304a16,16,0,0,0-22.63,22.63l67.88,67.88A16,16,0,0,0,208,371.88Zm22.62-67.88a16,16,0,0,0-22.62,22.62L253.25,371.88a16,16,0,0,0,22.63-22.63Zm67.89-22.63A16,16,0,0,0,208,236.12L275.88,304a16,16,0,0,0,22.63-22.63Zm149.82-81.94c-68.62-68.63-180.28-68.63-248.9,0a16,16,0,0,0,22.62,22.62c56.16-56.15,147.5-56.15,203.66,0s56.14,147.5,0,203.66a16,16,0,1,0,22.62,22.62C449.08,311.83,449.08,200.17,380.45,131.55Z"]
  },
      qT = {
    prefix: "fal",
    iconName: "value-absolute",
    icon: [448, 512, [], "f6a6", "M24 32H8c-4.4 0-8 3.6-8 8v432c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V40c0-4.4-3.6-8-8-8zm416 0h-16c-4.4 0-8 3.6-8 8v432c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V40c0-4.4-3.6-8-8-8zM325.7 165.6l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0l-79 79-79-79c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l79 79-79 79c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l79-79 79 79c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-79-79 79-79c3.1-3.1 3.1-8.1 0-11.3z"]
  },
      JT = {
    prefix: "fal",
    iconName: "vector-square",
    icon: [512, 512, [], "f5cb", "M486.4 128c14.14 0 25.6-11.46 25.6-25.6V25.6C512 11.46 500.54 0 486.4 0h-76.8C395.46 0 384 11.46 384 25.6V48H128V25.6C128 11.46 116.54 0 102.4 0H25.6C11.46 0 0 11.46 0 25.6v76.8C0 116.54 11.46 128 25.6 128H48v256H25.6C11.46 384 0 395.46 0 409.6v76.8C0 500.54 11.46 512 25.6 512h76.8c14.14 0 25.6-11.46 25.6-25.6V464h256v22.4c0 14.14 11.46 25.6 25.6 25.6h76.8c14.14 0 25.6-11.46 25.6-25.6v-76.8c0-14.14-11.46-25.6-25.6-25.6H464V128h22.4zM416 32h64v64h-64V32zM32 96V32h64v64H32zm64 384H32v-64h64v64zm384-64v64h-64v-64h64zm-48-32h-22.4c-14.14 0-25.6 11.46-25.6 25.6V432H128v-22.4c0-14.14-11.46-25.6-25.6-25.6H80V128h22.4c14.14 0 25.6-11.46 25.6-25.6V80h256v22.4c0 14.14 11.46 25.6 25.6 25.6H432v256z"]
  },
      KT = {
    prefix: "fal",
    iconName: "venus",
    icon: [288, 512, [], "f221", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 74.1 56 135.2 128 143.1V384H76c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h52v52c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-52h52c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-52v-64.9c72-7.9 128-69 128-143.1zm-256 0c0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112-61.9 0-112-50-112-112z"]
  },
      XT = {
    prefix: "fal",
    iconName: "venus-double",
    icon: [512, 512, [], "f226", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 74.1 56 135.2 128 143.1V384H76c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h52v52c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-52h52c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-52v-64.9c72-7.9 128-69 128-143.1zm-256 0c0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112-61.9 0-112-50-112-112zm352 143.1V384h52c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12h-52v52c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-52h-52c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h52v-64.9c-27.4-3-52.6-13.8-73.2-30 6.9-8.2 13-17 18.3-26.3 19.9 16.3 44.7 25.2 70.8 25.2 62 0 112-50.1 112-112 0-62-50.1-112-112-112-26.1 0-50.9 8.9-70.8 25.2-5.3-9.3-11.4-18.2-18.3-26.3C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 74.1-56 135.2-128 143.1z"]
  },
      _T = {
    prefix: "fal",
    iconName: "venus-mars",
    icon: [576, 512, [], "f228", "M288 208c0-79.5-64.5-144-144-144S0 128.5 0 208c0 74.1 56 135.2 128 143.1V416H76c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h52v52c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-52h52c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-52v-64.9c72-7.9 128-69 128-143.1zm-256 0c0-61.9 50-112 112-112 61.9 0 112 50 112 112 0 61.9-50 112-112 112-61.9 0-112-50-112-112zM576 12v88c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12V54.6l-63.5 63.5C500.2 142.8 512 174 512 208c0 79.5-64.5 144-144 144-33.7 0-64.6-11.6-89.2-30.9 6.9-8.2 13-17 18.3-26.3 19.9 16.3 44.7 25.2 70.8 25.2 62 0 112-50.1 112-112 0-62-50.1-112-112-112-26.1 0-50.9 8.9-70.8 25.2-5.3-9.3-11.4-18.2-18.3-26.3C303.4 75.6 334.3 64 368 64c34 0 65.2 11.8 89.9 31.5L521.4 32H476c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h88c6.6 0 12 5.4 12 12z"]
  },
      $T = {
    prefix: "fal",
    iconName: "vest",
    icon: [448, 512, [], "e085", "M60.688,396.688a16,16,0,1,0,22.624,22.624l48-48a16,16,0,0,0-22.624-22.624ZM434.562,231,384,155.156V48A48.052,48.052,0,0,0,336,0H320a15.991,15.991,0,0,0-8.871,2.693l0,0-.018.011-.019.012L286.125,19.359a111.712,111.712,0,0,1-124.25,0l-25-16.671L136.8,2.8A15.9,15.9,0,0,0,128,0H112A48.052,48.052,0,0,0,64,48V155.156L13.438,231A79.628,79.628,0,0,0,0,275.375V464a48.052,48.052,0,0,0,48,48H400a48.052,48.052,0,0,0,48-48V275.375A79.628,79.628,0,0,0,434.562,231ZM193.2,281.906A15.989,15.989,0,0,0,192,288V480H48a16.011,16.011,0,0,1-16-16V275.375a47.759,47.759,0,0,1,8.062-26.625l53.25-79.875A16.016,16.016,0,0,0,96,160V48a16.011,16.011,0,0,1,16-16h4.672l82.82,234.633ZM158.4,54.039A143.466,143.466,0,0,0,224,70.234a143.511,143.511,0,0,0,62.254-14.306l-68.486,166.32ZM416,464a16.011,16.011,0,0,1-16,16H224V291.172L330.719,32H336a16.011,16.011,0,0,1,16,16V160a16.016,16.016,0,0,0,2.688,8.875l53.25,79.875A47.759,47.759,0,0,1,416,275.375ZM339.312,348.688a16,16,0,0,0-22.624,22.624l48,48a16,16,0,0,0,22.624-22.624Z"]
  },
      cD = {
    prefix: "fal",
    iconName: "vest-patches",
    icon: [448, 512, [], "e086", "M352.375,287.7c-4-16.844-18.156-29.953-35.5-31.531a40.263,40.263,0,0,0-31.156,10.406,41.271,41.271,0,0,0-13.5,30.063L272,345.156A22.648,22.648,0,0,0,294.656,368h.094l48.594-.219a40.944,40.944,0,0,0,40.5-44.593C382.281,305.859,369.188,291.719,352.375,287.7Zm-2.656,45.109a8.983,8.983,0,0,1-6.563,2.969l-39.125.172.188-39.062A8.987,8.987,0,0,1,313.156,288a7.687,7.687,0,0,1,.844.047c4.156.375,7.531,4.594,7.5,9.265l-.25,21.36,21.344-.125c4.812,0,9,3.359,9.375,7.5A8.765,8.765,0,0,1,349.719,332.812ZM112,352a48,48,0,1,0,48,48A48,48,0,0,0,112,352Zm0,64a16,16,0,1,1,16-16A16.019,16.019,0,0,1,112,416ZM96.5,239.516a12.01,12.01,0,0,0-17,16.968L95.016,272,79.5,287.516a12.01,12.01,0,0,0,17,16.968l15.5-15.5,15.5,15.5a12.01,12.01,0,0,0,17-16.968L128.984,272,144.5,256.484a12.01,12.01,0,0,0-17-16.968l-15.5,15.5ZM434.562,231,384,155.156V48A48.052,48.052,0,0,0,336,0H320a15.991,15.991,0,0,0-8.871,2.693l0,0-.018.011-.019.012L286.125,19.359a111.712,111.712,0,0,1-124.25,0l-25-16.671L136.8,2.8A15.9,15.9,0,0,0,128,0H112A48.052,48.052,0,0,0,64,48V155.156L13.438,231A79.628,79.628,0,0,0,0,275.375V464a48.052,48.052,0,0,0,48,48H400a48.052,48.052,0,0,0,48-48V275.375A79.628,79.628,0,0,0,434.562,231ZM193.2,281.906A15.989,15.989,0,0,0,192,288V480H48a16.011,16.011,0,0,1-16-16V275.375a47.759,47.759,0,0,1,8.062-26.625l53.25-79.875A16.016,16.016,0,0,0,96,160V48a16.011,16.011,0,0,1,16-16h4.672l82.82,234.633ZM158.4,54.039A143.466,143.466,0,0,0,224,70.234a143.511,143.511,0,0,0,62.254-14.306l-68.486,166.32ZM416,464a16.011,16.011,0,0,1-16,16H224V291.172L330.719,32H336a16.011,16.011,0,0,1,16,16V160a16.016,16.016,0,0,0,2.688,8.875l53.25,79.875A47.759,47.759,0,0,1,416,275.375Z"]
  },
      eD = {
    prefix: "fal",
    iconName: "vhs",
    icon: [512, 512, [], "f8ec", "M496 64H16A16 16 0 0 0 0 80v320a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V80a16 16 0 0 0-16-16zm-16 336a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V192h59.45A130.66 130.66 0 0 0 113 374.12c7.88 6.38 18.31 9.88 29.38 9.88h227.24c11.07 0 21.5-3.5 29.38-9.86A130.68 130.68 0 0 0 420.55 192H480zm-320-78.39V352h-17.62C131.86 352 96 321.73 96 272c0-49.51 35.41-80 46.38-80H160v30.39a63.27 63.27 0 0 0 0 99.22zM192 352V192h128v160zm160-129.61V192h17.62c10.52 0 46.38 30.27 46.38 80 0 49.51-35.41 80-46.38 80H352v-30.39a63.27 63.27 0 0 0 0-99.22zM480 160H32V96h448z"]
  },
      aD = {
    prefix: "fal",
    iconName: "vial",
    icon: [480, 512, [], "f492", "M477.7 188L308 18.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l17 17L28.1 332.1c-37.5 37.5-37.6 98.2 0 135.7 37.5 37.5 98.2 37.6 135.7 0L438 193.6l17 17c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.2-3.1 3.2-8.1.1-11.3zM141.3 445.2c-24.2 24.2-66.3 24.2-90.5 0-25-25-25-65.5 0-90.5l66.7-66.7h181L141.3 445.2zM330.5 256h-181L324.9 80.6l90.5 90.5-84.9 84.9z"]
  },
      nD = {
    prefix: "fal",
    iconName: "vials",
    icon: [640, 512, [], "f493", "M72 32h24v304c0 44.1 35.9 80 80 80s80-35.9 80-80V32h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm56 0h96v128h-96V32zm0 160h96v144c0 63.5-96 63.5-96 0V192zM360 32h24v304c0 44.1 35.9 80 80 80s80-35.9 80-80V32h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm56 0h96v128h-96V32zm0 160h96v144c0 63.5-96 63.5-96 0V192zm216 288H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h624c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      tD = {
    prefix: "fal",
    iconName: "video",
    icon: [576, 512, [], "f03d", "M543.9 96c-6.2 0-12.5 1.8-18.2 5.7L416 171.6v-59.8c0-26.4-23.2-47.8-51.8-47.8H51.8C23.2 64 0 85.4 0 111.8v288.4C0 426.6 23.2 448 51.8 448h312.4c28.6 0 51.8-21.4 51.8-47.8v-59.8l109.6 69.9c5.7 4 12.1 5.7 18.2 5.7 16.6 0 32.1-13 32.1-31.5v-257c.1-18.5-15.4-31.5-32-31.5zM384 400.2c0 8.6-9.1 15.8-19.8 15.8H51.8c-10.7 0-19.8-7.2-19.8-15.8V111.8c0-8.6 9.1-15.8 19.8-15.8h312.4c10.7 0 19.8 7.2 19.8 15.8v288.4zm160-15.7l-1.2-1.3L416 302.4v-92.9L544 128v256.5z"]
  },
      rD = {
    prefix: "fal",
    iconName: "video-plus",
    icon: [576, 512, [], "f4e1", "M543.9 96c-6.2 0-12.5 1.8-18.2 5.7L416 171.6v-59.8c0-26.4-23.2-47.8-51.8-47.8H51.8C23.2 64 0 85.4 0 111.8v288.4C0 426.6 23.2 448 51.8 448h312.4c28.6 0 51.8-21.4 51.8-47.8v-59.8l109.6 69.9c5.7 4 12.1 5.7 18.2 5.7 16.6 0 32.1-13 32.1-31.5v-257c.1-18.5-15.4-31.5-32-31.5zM384 192v208.2c0 8.6-9.1 15.8-19.8 15.8H51.8c-10.7 0-19.8-7.2-19.8-15.8V111.8c0-8.6 9.1-15.8 19.8-15.8h312.4c10.7 0 19.8 7.2 19.8 15.8V192zm160 192.5l-1.2-1.3L416 302.4v-92.9L544 128v256.5zM296 240h-72v-72c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v72h-72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h72v72c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-72h72c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"]
  },
      iD = {
    prefix: "fal",
    iconName: "video-slash",
    icon: [640, 512, [], "f4e2", "M637 485.2L142.7 96l-16.2-12.7L23 1.8C19.6-1 14.5-.4 11.8 3l-10 12.5C-1 19-.4 24 3 26.8L438.9 370l9.1 7.2 169 133.1c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.6 2.2-8.6-1.2-11.4zM396.2 416H83.8c-10.7 0-19.8-7.2-19.8-15.8V135.9l-31.9-25.1c0 .4-.1.7-.1 1.1v288.4c0 26.4 23.2 47.8 51.8 47.8h312.4c16.6 0 31.2-7.3 40.7-18.5l-25.3-19.9c-3.7 3.7-9.1 6.3-15.4 6.3zm0-320c10.7 0 19.8 7.2 19.8 15.8v138.3l32 25.2v-65.8L576 128v248.1l28.4 22.4c2.1-4.2 3.6-8.8 3.6-14v-257C608 109 592.5 96 575.9 96c-6.2 0-12.5 1.8-18.2 5.7L448 171.6v-59.8c0-26.4-23.2-47.8-51.8-47.8H179.6l40.6 32h176z"]
  },
      oD = {
    prefix: "fal",
    iconName: "vihara",
    icon: [640, 512, [], "f6a7", "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-10.22 6.82-9.27 22.13 1.72 27.62L64 448v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h208v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56h208v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56l55.15-19.67c10.99-5.49 11.95-20.81 1.73-27.62zM320 35.36L449.06 96h-258.1L320 35.36zM192 128h256v64H192v-64zM94.6 253.94L166.4 224h307.2l71.81 29.94L539 256H101.01l-6.41-2.06zM128 288h384v64H128v-64zm442.47 128H69.53l-14.38-5.13L104.19 384H535.8l49.04 26.87-14.37 5.13z"]
  },
      lD = {
    prefix: "fal",
    iconName: "violin",
    icon: [640, 512, [], "f8ed", "M472 96a24 24 0 1 0-24-24 24 24 0 0 0 24 24zM349.66 13.66L338.34 2.34a8 8 0 0 0-11.31 0L2.34 327a8 8 0 0 0 0 11.32l11.32 11.31a8 8 0 0 0 11.31 0L349.66 25a8 8 0 0 0 0-11.34zM520 48a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm96 48a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm-48 48a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm-86.86 48.8L635.31 38.62a16 16 0 0 0 0-22.62L624 4.69a16 16 0 0 0-22.62 0l-154.2 154.19c-15.44-12.84-33.06-23-52.59-27.53a128.23 128.23 0 0 0-28.69-3.3c-21.11 0-47.55 5.52-69.35 27.33-3.68 3.69-6.5 7.9-9.4 12.05A63.51 63.51 0 0 1 224.36 240a64.53 64.53 0 0 1-23.16-4.35c-15.23 5.15-29.31 13.11-41 24.86-38.2 38.13-41.2 99.6-13.3 153.55L138 420a22.41 22.41 0 0 0-3.41 34.48l50.95 50.95a22.22 22.22 0 0 0 8.06 5.06 20.75 20.75 0 0 0 2.93.56 22.54 22.54 0 0 0 4.83.94c.36 0 .67-.23 1-.25a22.35 22.35 0 0 0 6.54-1.59 20.62 20.62 0 0 0 3.2-1A22 22 0 0 0 220 502l5.81-8.71c23.39 12.11 48.14 18.61 71.88 18.61 31 0 60.18-10.53 81.8-32.16 11.75-11.68 19.71-25.77 24.87-41-16.1-42.18 15-86.46 59.09-86.46a68.11 68.11 0 0 1 8.93.6c4.21-2.94 8.48-5.8 12.23-9.54 24.94-25 32.43-61.48 24-97.91-4.52-19.55-14.61-37.18-27.47-52.63zM199.86 474.53l-34.39-34.39 80.08-53.39 7.7 7.7zm262.52-154.26a95.45 95.45 0 0 0-91.83 117 67.49 67.49 0 0 1-13.7 19.86C338 476 314.28 479.92 297.68 479.92c-17.76 0-36.41-4.72-54.08-13.32l40.64-61a22.4 22.4 0 0 0-2.8-28.26l-18.83-18.83a25.73 25.73 0 0 0-14.85-6.36c-.34 0-.65-.2-1-.2a22.17 22.17 0 0 0-3.51.51 21.39 21.39 0 0 0-2.27.33 22.39 22.39 0 0 0-6.64 2.92l-60.78 40.52C153 354.45 156 309.9 182.91 283a67 67 0 0 1 19.68-13.58 95.34 95.34 0 0 0 93.78-30.33 94 94 0 0 0 23.42-61.72c11.83-11.52 27.34-17.36 46.11-17.36a96.24 96.24 0 0 1 21.44 2.46c12.24 2.86 24.64 9.55 36.92 19.29l-99.57 99.58a16 16 0 0 0 0 22.62L336 315.31a16 16 0 0 0 22.62 0l99.59-99.59c9.72 12.26 16.39 24.65 19.22 36.9 6.22 26.92.73 51.54-15.05 67.65z"]
  },
      fD = {
    prefix: "fal",
    iconName: "virus",
    icon: [512, 512, [], "e074", "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22A55.74,55.74,0,0,1,341.74,107c-29.24,0-57.29-22.7-57.29-57V28.44a28.45,28.45,0,0,0-56.9,0V50c0,34.29-28.05,57-57.29,57a55.7,55.7,0,0,1-39.82-16.77L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25A55.7,55.7,0,0,1,170.25,405c29.25,0,57.3,22.7,57.3,57v21.54a28.45,28.45,0,0,0,56.9,0V462c0-34.29,28.05-57,57.3-57a55.7,55.7,0,0,1,39.81,16.77L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM379.88,307.32c-10.64,25.71-8.94,53.3,3.84,76.44a86.92,86.92,0,0,0-42-10.75A89.42,89.42,0,0,0,256,437.11,89.42,89.42,0,0,0,170.25,373a86.92,86.92,0,0,0-42,10.75c12.78-23.14,14.48-50.73,3.84-76.44s-31.33-44-56.69-51.32c25.36-7.34,46.05-25.63,56.69-51.32s8.94-53.3-3.84-76.44a87,87,0,0,0,42,10.75A89.42,89.42,0,0,0,256,74.88,89.42,89.42,0,0,0,341.74,139a87,87,0,0,0,42-10.75c-12.78,23.14-14.48,50.73-3.84,76.44s31.33,44,56.69,51.32C411.21,263.33,390.52,281.63,379.88,307.32ZM224,176a48,48,0,1,0,48,48A48,48,0,0,0,224,176Zm0,64a16,16,0,1,1,16-16A16,16,0,0,1,224,240Zm80,48a16,16,0,1,0,16,16A16,16,0,0,0,304,288Z"]
  },
      sD = {
    prefix: "fal",
    iconName: "virus-slash",
    icon: [640, 512, [], "e075", "M320,437.11A89.42,89.42,0,0,0,234.26,373a87,87,0,0,0-42,10.75c12.79-23.14,14.49-50.73,3.84-76.44s-31.32-44-56.68-51.32c16.55-4.79,30.76-14.64,41.84-27.78l-25.12-19.78A55.23,55.23,0,0,1,114,227.55H92.45a28.45,28.45,0,1,0,0,56.89H114c50.68,0,76.06,61.28,40.22,97.12L139,396.8A28.44,28.44,0,1,0,179.2,437l15.24-15.25A55.7,55.7,0,0,1,234.26,405c29.25,0,57.3,22.7,57.3,57v21.54a28.45,28.45,0,1,0,56.89,0V462c0-34.29,28.06-57,57.31-57h0l-32.57-25.64A89.36,89.36,0,0,0,320,437.11Zm0-362.23A89.42,89.42,0,0,0,405.76,139a87,87,0,0,0,42-10.75C435,151.38,433.25,179,443.9,204.68s31.32,44,56.68,51.32c-16.58,4.79-30.8,14.66-41.88,27.83l25.11,19.77A55.26,55.26,0,0,1,526,284.44h21.55a28.45,28.45,0,1,0,0-56.89H526c-50.68,0-76.06-61.27-40.23-97.11L501,115.19A28.44,28.44,0,1,0,460.82,75L445.57,90.22A55.74,55.74,0,0,1,405.76,107c-29.25,0-57.31-22.7-57.31-57V28.44a28.45,28.45,0,0,0-56.89,0V50c0,34.29-28.05,57-57.3,57h-.15l32.62,25.69A89.41,89.41,0,0,0,320,74.88ZM637,485.32,23,1.82A7.87,7.87,0,0,0,11.77,3l-10,12.5A8,8,0,0,0,3,26.73l614,483.5A8,8,0,0,0,628.2,509l10-12.5A7.86,7.86,0,0,0,637,485.32Z"]
  },
      uD = {
    prefix: "fal",
    iconName: "viruses",
    icon: [640, 512, [], "e076", "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58a31.34,31.34,0,0,1-22.4,9.43c-16.45,0-32.23-12.77-32.23-32.06V240a16,16,0,0,0-32,0v12.12c0,19.29-15.78,32.06-32.23,32.06a31.34,31.34,0,0,1-22.4-9.43l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58a31.34,31.34,0,0,1,22.4-9.43c16.45,0,32.23,12.77,32.23,32.06V496a16,16,0,0,0,32,0V483.88c0-19.29,15.78-32.06,32.23-32.06a31.32,31.32,0,0,1,22.4,9.43l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32Zm-71.25,39.51A64.17,64.17,0,0,0,548,419.92c-1.23-.07-2.48-.1-3.73-.1A64.19,64.19,0,0,0,496,441.61a64.19,64.19,0,0,0-48.23-21.79c-1.25,0-2.5,0-3.73.1A64.38,64.38,0,0,0,422.51,368,64.38,64.38,0,0,0,444,316.08c1.23.07,2.48.1,3.73.1A64.19,64.19,0,0,0,496,294.39a64.19,64.19,0,0,0,48.23,21.79c1.25,0,2.5,0,3.73-.1A64.38,64.38,0,0,0,569.49,368,64.11,64.11,0,0,0,552.75,391.51ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,1,0,297.6,56.23L286.17,67.66a41.78,41.78,0,0,1-29.86,12.58c-21.94,0-43-17-43-42.75V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,25.72-21,42.75-43,42.75A41.74,41.74,0,0,1,97.83,67.66L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43a41.75,41.75,0,0,1,29.86-12.59c21.94,0,43,17,43,42.76v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-25.72,21-42.76,43-42.76a41.75,41.75,0,0,1,29.86,12.59l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33Zm-69,14.09A74.56,74.56,0,0,0,274,273.9a73.24,73.24,0,0,0-17.66-2.15A75,75,0,0,0,192,308.11a75,75,0,0,0-64.31-36.36A73.24,73.24,0,0,0,110,273.9,74.88,74.88,0,0,0,76,192a74.89,74.89,0,0,0,34-81.9,73.24,73.24,0,0,0,17.66,2.15A75.07,75.07,0,0,0,192,75.89a75.07,75.07,0,0,0,64.31,36.36A73.24,73.24,0,0,0,274,110.1,74.89,74.89,0,0,0,308,192,74.52,74.52,0,0,0,277.52,227.42ZM160,128a32,32,0,1,0,32,32A32,32,0,0,0,160,128Zm64,80a16,16,0,1,0,16,16A16,16,0,0,0,224,208ZM480,336a16,16,0,1,0,16,16A16,16,0,0,0,480,336Z"]
  },
      hD = {
    prefix: "fal",
    iconName: "voicemail",
    icon: [640, 512, [], "f897", "M640 272a144 144 0 0 0-288 0c0 45.52 21.54 85.61 54.51 112h-173c33-26.39 54.51-66.48 54.51-112A144 144 0 0 0 0 272c0 74.05 56.1 134.33 128 142.39V416h384v-1.61c71.9-8.06 128-68.34 128-142.39zm-608 0a112 112 0 1 1 112 112A112.12 112.12 0 0 1 32 272zm464 112a112 112 0 1 1 112-112 112.12 112.12 0 0 1-112 112z"]
  },
      mD = {
    prefix: "fal",
    iconName: "volcano",
    icon: [512, 512, [], "f770", "M505.5 460.6l-175.9-225c-4.9-6.3-12.1-9.7-19.8-11.1l16.4-49.4H352c44.1 0 80-36 80-80.2s-35.9-80.2-80-80.2c-13.1 0-26 3.4-37.6 9.6-29.9-32.6-86.9-32.6-116.9 0-11.6-6.3-24.5-9.6-37.6-9.6-44.1 0-80 36-80 80.2s35.9 80.2 80 80.2h25.8l16.4 49.4c-7.7 1.4-14.9 4.8-19.8 11.1L6.5 460.6C-9.4 481.8 5.7 512 32.1 512H480c26.3 0 41.4-30.2 25.5-51.4zM160 143.1c-26.5 0-48-21.6-48-48.1s21.5-48.1 48-48.1c14.2 0 24.6 6.3 30.8 11.6l14.4 12.2 9.7-16.2c17.7-29.7 64.5-29.7 82.2 0l9.7 16.2 14.4-12.2c6.2-5.3 16.7-11.6 30.8-11.6 26.5 0 48 21.6 48 48.1s-21.5 48.1-48 48.1h-48.9l-26.7 80.2h-40.9l-26.7-80.2H160zm47.6 112.3h96.8l51 65.2-35 41c-6.7 7.9-19.7 7.8-26.3 0L268.8 332c-9.6-11.2-23.1-17-38.3-17.3-14.8.3-28.5 7-37.7 18.6-6.6 8.3-20.5 8.3-27.1 0l-9.6-12 51.5-65.9zm-175.9 225l104.1-133.2 4.9 6.1c18.8 23.5 58.3 23.6 77.1 0 3.3-4.1 8.1-6.5 13.3-6.5 5.3.1 10.1 2.2 13.4 6.1l25.3 29.5c9.4 11 23.1 17.3 37.5 17.3 14.4 0 28.1-6.3 37.5-17.3l30.8-36.1L480 479.9l-448.3.5z"]
  },
      vD = {
    prefix: "fal",
    iconName: "volleyball-ball",
    icon: [496, 512, [], "f45f", "M248 8C111.2 8 0 119.2 0 256s111.2 248 248 248 248-111.2 248-248S384.8 8 248 8zm172 378.1c-85.6 22.4-176.5 4.8-247.7-46.9 21.3-25.6 47.1-47.5 76.5-64.8 84.3 47.1 159.8 45.1 207.5 37.9-7.3 27-19.8 52-36.3 73.8zm42.8-107.2c-24.4 4.6-48.9 6.4-73.2 4.9 8.7-81.6-13.6-162.9-61.8-228.3 59.2 23.6 148.2 98.2 135 223.4zM274.4 41.8c62.3 62.9 92.6 150.4 83.4 238.1-32.8-5.6-64.5-17-94.2-33.7-1-72.8-25.7-142.2-70.9-198.9 40.2-10.5 69.3-7 81.7-5.5zM160.5 58.7c16.1 18.8 30 39.1 40.8 60.8C126.4 152.7 67.1 212.7 34.5 287 14 145.8 123.2 75.3 160.5 58.7zM49.2 340.4c23.3-85.5 84-155.6 164.6-191.5 11.5 31.2 17.5 64.4 17.9 98.4-62.6 37.2-110.3 93.5-136.8 160.9-19.2-19.4-34.9-42.3-45.7-67.8zm71.7 89.9c8.1-23.2 18.8-45.2 32.1-65.3 47.5 34.6 125.7 71.9 228.5 60.5-52.5 41.4-160.7 77.9-260.6 4.8z"]
  },
      dD = {
    prefix: "fal",
    iconName: "volume",
    icon: [480, 512, [], "f6a8", "M342.91 193.57c-7.81-3.8-17.5-.48-21.34 7.5-3.81 7.97-.44 17.53 7.53 21.34C343.22 229.2 352 242.06 352 256c0 13.94-8.78 26.8-22.9 33.58-7.97 3.81-11.34 13.38-7.53 21.34 3.86 8.05 13.54 11.29 21.34 7.5C368.25 306.28 384 282.36 384 256s-15.75-50.29-41.09-62.43zM231.81 64c-5.91 0-11.92 2.18-16.78 7.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c4.87 4.87 10.88 7.05 16.78 7.05 12.33 0 24.19-9.52 24.19-24.02V88.02C256 73.51 244.13 64 231.81 64zM224 404.67L139.31 320H32V192h107.31L224 107.33v297.34zm256-148.68c0-66.12-34.02-126.62-88.81-157.87-7.69-4.38-17.59-1.78-22.04 5.89-4.45 7.66-1.77 17.44 5.96 21.86 44.77 25.55 72.61 75.4 72.61 130.12s-27.84 104.58-72.61 130.12c-7.72 4.42-10.4 14.2-5.96 21.86 4.3 7.38 14.06 10.44 22.04 5.89C445.98 382.62 480 322.12 480 255.99z"]
  },
      MD = {
    prefix: "fal",
    iconName: "volume-down",
    icon: [384, 512, [], "f027", "M342.91 194.57c-7.81-3.8-17.5-.48-21.34 7.5-3.81 7.97-.44 17.53 7.53 21.34C343.22 230.2 352 243.06 352 257c0 13.94-8.78 26.8-22.9 33.58-7.97 3.81-11.34 13.38-7.53 21.34 3.86 8.05 13.54 11.29 21.34 7.5C368.25 307.28 384 283.36 384 257s-15.75-50.29-41.09-62.43zM231.81 65c-5.91 0-11.92 2.18-16.78 7.05L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c4.87 4.87 10.88 7.05 16.78 7.05 12.33 0 24.19-9.52 24.19-24.02V89.02C256 74.51 244.13 65 231.81 65zM224 405.67L139.31 321H32V193h107.31L224 108.33v297.34z"]
  },
      pD = {
    prefix: "fal",
    iconName: "volume-mute",
    icon: [512, 512, [], "f6a9", "M454.63 256l55.03-55.03c3.12-3.12 3.12-8.19 0-11.31l-11.31-11.31c-3.12-3.12-8.19-3.12-11.31 0L432 233.37l-55.03-55.03c-3.12-3.12-8.19-3.12-11.31 0l-11.31 11.31c-3.12 3.12-3.12 8.19 0 11.31L409.37 256l-55.03 55.03c-3.12 3.12-3.12 8.19 0 11.31l11.31 11.31c3.12 3.12 8.19 3.12 11.31 0L432 278.63l55.03 55.03c3.12 3.12 8.19 3.12 11.31 0l11.31-11.31c3.12-3.12 3.12-8.19 0-11.31L454.63 256zM231.81 64c-5.91 0-11.92 2.18-16.78 7.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c4.87 4.87 10.88 7.05 16.78 7.05 12.33 0 24.19-9.52 24.19-24.02V88.02C256 73.51 244.13 64 231.81 64zM224 404.67l-75.32-75.3-9.37-9.37H32V192h107.31l9.37-9.37 75.32-75.3v297.34z"]
  },
      zD = {
    prefix: "fal",
    iconName: "volume-off",
    icon: [256, 512, [], "f026", "M231.81 64a23.44 23.44 0 0 0-16.78 7l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441a23.47 23.47 0 0 0 16.81 7c12.33 0 24.19-9.52 24.19-24V88c0-14.51-11.86-24-24.19-24zM224 404.67L139.31 320H32V192h107.31L224 107.33v297.34z"]
  },
      CD = {
    prefix: "fal",
    iconName: "volume-slash",
    icon: [640, 512, [], "f2e2", "M256 107.3v37.2l32 25.2V88c0-14.5-11.9-24-24.2-24-5.9 0-11.9 2.2-16.8 7l-37.1 37.1 25.3 19.9zm152 18.6c44.4 25.5 72 75.4 72 130.1 0 19.8-3.7 39-10.5 56.6l25.9 20.4c10.6-23.6 16.6-49.8 16.6-77 0-66.1-33.7-126.6-88-157.9-7.6-4.4-17.4-1.8-21.8 5.9-4.5 7.7-1.8 17.5 5.8 21.9zm30.8-95.7C523.4 74.7 576 161.2 576 256c0 41.8-10.7 81.7-29.4 117.3l25.5 20.1C595 352 608 305.1 608 256c0-106.7-59.1-204.1-154.2-254.2-7.9-4.1-17.5-1.1-21.6 6.7-4.2 7.9-1.2 17.5 6.6 21.7zm-77.7 192.2c9.5 4.5 16.3 12 19.9 20.5l33.1 26c.9-4.3 1.9-8.5 1.9-13 0-26.4-15.8-50.3-41.1-62.4-7.8-3.8-17.5-.5-21.3 7.5s-.5 17.6 7.5 21.4zM637 485.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zm-198.2-3.4c-7.8 4.1-10.8 13.8-6.7 21.6 2.8 5.3 8.2 8.6 14.2 8.5 2.5 0 5.1-.6 7.5-1.8 21.7-11.4 41.2-25.5 58.8-41.4l-25.7-20.2c-14.7 12.6-30.5 24.1-48.1 33.3zM256 404.7L171.3 320H64V192h97.1l-40.6-32H56c-13.3 0-24 10.7-24 24v144c0 13.2 10.7 24 24 24h102.1l89 89c4.9 4.9 10.9 7 16.8 7 12.3 0 24.2-9.5 24.2-24V291.9l-32-25.2v138z"]
  },
      LD = {
    prefix: "fal",
    iconName: "volume-up",
    icon: [576, 512, [], "f028", "M342.91 193.57c-7.81-3.8-17.5-.48-21.34 7.5-3.81 7.97-.44 17.53 7.53 21.34C343.22 229.2 352 242.06 352 256s-8.78 26.8-22.9 33.58c-7.97 3.81-11.34 13.38-7.53 21.34 3.86 8.05 13.54 11.29 21.34 7.5C368.25 306.28 384 282.36 384 256s-15.75-50.29-41.09-62.43zM231.81 64c-5.91 0-11.92 2.18-16.78 7.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c4.87 4.87 10.88 7.05 16.78 7.05 12.33 0 24.19-9.52 24.19-24.02V88.02C256 73.51 244.13 64 231.81 64zM224 404.67L139.31 320H32V192h107.31L224 107.33v297.34zM421.51 1.83c-7.89-4.08-17.53-1.12-21.66 6.7-4.13 7.81-1.13 17.5 6.7 21.61 84.76 44.55 137.4 131.1 137.4 225.85s-52.64 181.3-137.4 225.85c-7.82 4.11-10.83 13.8-6.7 21.61 4.1 7.75 13.68 10.84 21.66 6.7C516.78 460.06 576 362.67 576 255.99c0-106.67-59.22-204.06-154.49-254.16zM480 255.99c0-66.12-34.02-126.62-88.81-157.87-7.69-4.38-17.59-1.78-22.04 5.89-4.45 7.66-1.77 17.44 5.96 21.86 44.77 25.55 72.61 75.4 72.61 130.12s-27.84 104.58-72.61 130.12c-7.72 4.42-10.4 14.2-5.96 21.86 4.3 7.38 14.06 10.44 22.04 5.89C445.98 382.62 480 322.12 480 255.99z"]
  },
      AD = {
    prefix: "fal",
    iconName: "vote-nay",
    icon: [640, 512, [], "f771", "M393.5 153.8l-11.3-11.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3L320 193.4l-50.9-50.9c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l50.9 50.9-50.9 50.9c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l50.9-50.9 50.9 50.9c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-51-50.9 50.9-50.9c3.2-3.1 3.2-8.2 0-11.3zM608 288h-64V62.5c0-16.8-14.3-30.5-32-30.5H128c-17.7 0-32 13.7-32 30.5V288H32c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32zM128 64h384v304H128V64zm480 384H32V320h64v48H73.6c-5.3 0-9.6 3.6-9.6 8v16c0 4.4 4.3 8 9.6 8h492.8c5.3 0 9.6-3.6 9.6-8v-16c0-4.4-4.3-8-9.6-8H544v-48h64v128z"]
  },
      ND = {
    prefix: "fal",
    iconName: "vote-yea",
    icon: [640, 512, [], "f772", "M409.3 138.6c-1.6-1.6-3.6-2.3-5.7-2.3-2 0-4.1.8-5.7 2.3L290.5 246.1 242 197.5c-1.6-1.6-3.6-2.3-5.7-2.3-2 0-4.1.8-5.7 2.3l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l65.5 65.5c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l124.5-124.5c3.1-3.1 3.1-8.2 0-11.3l-11.4-11.2zM608 288h-64V62.5c0-16.8-14.3-30.5-32-30.5H128c-17.7 0-32 13.7-32 30.5V288H32c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32zM128 64h384v304H128V64zm480 384H32V320h64v48H73.6c-5.3 0-9.6 3.6-9.6 8v16c0 4.4 4.3 8 9.6 8h492.8c5.3 0 9.6-3.6 9.6-8v-16c0-4.4-4.3-8-9.6-8H544v-48h64v128z"]
  },
      gD = {
    prefix: "fal",
    iconName: "vr-cardboard",
    icon: [640, 512, [], "f729", "M592 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h165.82c25.19 0 48.03-14.77 58.36-37.74l16.56-36.8C294.66 360.31 306.76 352 320 352s25.34 8.31 31.26 21.46l16.56 36.8C378.15 433.23 401 448 426.18 448H592c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm16 336c0 8.82-7.18 16-16 16H426.18c-12.57 0-24.02-7.41-29.18-18.87l-16.56-36.8C369.42 335.83 345.69 320 320 320s-49.42 15.83-60.44 40.33L243 397.13c-5.16 11.46-16.61 18.87-29.18 18.87H48c-8.82 0-16-7.18-16-16V112c0-8.82 7.18-16 16-16h544c8.82 0 16 7.18 16 16v288zM176 160c-44.18 0-80 35.81-80 80 0 44.18 35.82 80 80 80s80-35.82 80-80-35.82-80-80-80zm0 128c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288-128c-44.18 0-80 35.81-80 80 0 44.18 35.82 80 80 80s80-35.82 80-80-35.82-80-80-80zm0 128c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"]
  },
      HD = {
    prefix: "fal",
    iconName: "wagon-covered",
    icon: [640, 512, [], "f8ee", "M544.15,256l91-169.67A62.18,62.18,0,0,0,577.68,0C560.75,0,426.09,32,410.05,32A63.67,63.67,0,0,0,368,16H272A63.67,63.67,0,0,0,230,32C213.92,32,79.49,0,62.39,0A62.18,62.18,0,0,0,4.75,85.85L96,256v65.83A111.88,111.88,0,0,0,176,512c56.37,0,102.56-41.79,110.39-96h67.22c7.83,54.21,54,96,110.39,96a111.88,111.88,0,0,0,80-190.22V256ZM572,32.51c3.35-.61,18.45-2.66,29.24,10.71a30.14,30.14,0,0,1,4.78,29.54L525,224H432V79.59A62.62,62.62,0,0,0,429.2,62ZM244.71,64c5.54-9.5,15.46-16.21,27.29-16.21h96c11.83,0,21.75,6.71,27.29,16.21,2.06,3.54,4.71,9.85,4.71,15.59V224H240V79.59C240,73.85,242.65,67.54,244.71,64Zm-206-20.76A30.53,30.53,0,0,1,67.31,32.38l143.5,29.56A62.48,62.48,0,0,0,208,79.59V224H115.18L33.79,72.29A29.78,29.78,0,0,1,38.75,43.24ZM254.38,384H192V321.62A80.22,80.22,0,0,1,254.38,384ZM160,384H97.62A80.22,80.22,0,0,1,160,321.62ZM97.62,416H160v62.38A80.22,80.22,0,0,1,97.62,416ZM192,478.38V416h62.38A80.22,80.22,0,0,1,192,478.38ZM542.38,384H480V321.62A80.22,80.22,0,0,1,542.38,384ZM448,384H385.62A80.22,80.22,0,0,1,448,321.62Zm-62.38,32H448v62.38A80.22,80.22,0,0,1,385.62,416ZM480,478.38V416h62.38A80.22,80.22,0,0,1,480,478.38Zm32.12-179.13A111,111,0,0,0,464,288c-56.38,0-102.56,41.79-110.39,96H286.39c-7.83-54.21-54-96-110.39-96a111,111,0,0,0-48.12,11.25V256H512.12Z"]
  },
      VD = {
    prefix: "fal",
    iconName: "walker",
    icon: [448, 512, [], "f831", "M400.85 386.53V80a80 80 0 0 0-80-80h-134a79.92 79.92 0 0 0-77.63 60.61L.24 498.18a8 8 0 0 0 5.83 9.7l15.53 3.88a8 8 0 0 0 9.7-5.82L85.57 288h283.28v98a64.18 64.18 0 1 0 32 .53zM140.26 68.36A47.92 47.92 0 0 1 186.82 32h134a48 48 0 0 1 48 48v112H109.47zM93.53 256l8-32h267.32v32zM384 480a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"]
  },
      xD = {
    prefix: "fal",
    iconName: "walkie-talkie",
    icon: [384, 512, [], "f8ef", "M104 192h176a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm248-96h-32V80a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16h-32V80a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16H96V8a8 8 0 0 0-8-8H72a8 8 0 0 0-8 8v88H32a32.09 32.09 0 0 0-32 32v178.74a32 32 0 0 0 9.38 22.63L32 352v112a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48V352l22.62-22.63a32 32 0 0 0 9.38-22.63V128a32.09 32.09 0 0 0-32-32zm0 210.75l-22.63 22.62-9.37 9.38V464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V338.75l-9.37-9.38L32 306.74V128h320zM104 256h176a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm0 64h176a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8z"]
  },
      wD = {
    prefix: "fal",
    iconName: "walking",
    icon: [320, 512, [], "f554", "M305.5 247.3l-19.6-21.1-8.7-28.5c-7.9-26.1-23.3-47.8-43.2-62.8 19.3-13.4 32-35.7 32-60.9 0-40.8-33.2-74-74-74s-74 33.2-74 74c0 15.7 4.9 30.3 13.3 42.3-14.7 3.8-28.4 9.8-45.3 17.4l-8.6 3.8c-24 10.5-43.4 30.1-54.9 55.2l-11.8 28c-7.3 17.2-5.7 35.7 4.2 50.7C24.6 286 41.2 295 58.4 295c12.5 0 24-4.7 32.9-12.9.2 1.4.4 2.7.6 4.1l-14.2 38.9-16.3 44.6L14 422.1c-18.7 20.4-18.7 52.4 0 72.9 9.6 10.5 23.2 16.6 37.2 16.6 14 0 27.6-6 37.2-16.6l46.7-51.2c9.6-10.6 17-22.9 22-36.5l8.7-23.9 10.6 10.7c.5.5.8 1.3.9 1.9l15.6 74.2C198 494.5 219 512 242.8 512c4 0 8.1-.5 12.1-1.5 27.4-6.9 44-34.6 38-62.9l-15.6-74.1c-2.8-13.2-7.8-25.6-14.7-36.7 1.8.2 3.6.3 5.5.3 20.3 0 38.9-12.6 47.4-32.2 8.6-19.5 4.7-41.6-10-57.6zM192 32c23.2 0 42 18.8 42 42s-18.8 42-42 42-42-18.8-42-42 18.8-42 42-42zm-65 364.3c-3.5 9.7-8.8 18.4-15.6 25.9l-46.7 51.2c-3.7 4.1-8.6 6.2-13.6 6.2-4.9 0-9.8-2.1-13.6-6.2-7.5-8.2-7.5-21.5 0-29.7l46.7-51.2c3.1-3.4 5.5-7.4 7.1-11.8l16.3-44.6.1.1 1 1.2 29 29.3-10.7 29.6zm141.1-91.1c-4.4 0-9-1.8-13-6.2l-23.5-25.3c-5-5.4-8.8-12.1-11-19.4-11.4-37.5-11.5-39.9-17.5-48.5l-20.9 91.7 43 43.4c10.4 10.6 17.7 24.2 20.8 39.3l15.6 74.1c2.4 11.3-4 22.6-14.4 25.2-1.5.4-3 .5-4.4.5-9.4 0-16.7-7.6-18.6-16.3l-15.6-74.2c-1.4-6.9-4.7-13-9.5-17.8L136 307.8c-11.6-13.8-15.7-31.2-11.9-47.7l15.8-69.3c-9 3.2-18.1 7.3-35.4 15-8 3.5-14.5 10-18.3 18.4L75 250.8c-3.7 8.7-10.1 12.3-16.6 12.3-12.5 0-25.2-13.4-18.2-29.9L51.7 206c8.3-18.2 21.9-31.9 38.6-39.2 34.2-15.1 48.7-22.8 76.6-22.8 36.3 0 68.3 25.3 79.8 63l10.3 33.9c.3 1 .8 2 1.6 2.8L282 269c14.1 15.3.9 36.2-13.9 36.2z"]
  },
      yD = {
    prefix: "fal",
    iconName: "wallet",
    icon: [512, 512, [], "f555", "M384 256c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm80-160h-16V80c0-26.51-21.49-48-48-48H96C42.98 32 0 74.98 0 128v256c0 53.02 42.98 96 96 96h352c35.35 0 64-28.65 64-64V144c0-26.51-21.49-48-48-48zm16 320c0 17.64-14.36 32-32 32H96c-35.29 0-64-28.71-64-64V128c0-35.29 28.71-64 64-64h304c8.82 0 16 7.18 16 16v16H112c-8.84 0-16 7.16-16 16s7.16 16 16 16h352c8.82 0 16 7.18 16 16v272z"]
  },
      bD = {
    prefix: "fal",
    iconName: "wand",
    icon: [512, 512, [], "f72a", "M400 192c8.84 0 16-7.16 16-16v-27.96l91.87-101.83c5.72-6.32 5.48-16.02-.55-22.05L487.84 4.69A15.97 15.97 0 0 0 476.52 0c-3.84 0-7.68 1.37-10.73 4.13L186.6 256H144c-8.84 0-16 7.16-16 16v36.87L10.53 414.84c-13.57 12.28-14.1 33.42-1.16 46.36l41.43 41.43c6.26 6.27 14.45 9.37 22.62 9.37 8.71 0 17.4-3.53 23.73-10.53L376.34 192H400zM73.43 480l-41.46-41.4L455.35 56.65 73.43 480z"]
  },
      SD = {
    prefix: "fal",
    iconName: "wand-magic",
    icon: [512, 512, [], "f72b", "M458.66 341.33L432 288l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67zM432 384c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zm176 96c8.84 0 16-7.16 16-16v-27.96l91.87-101.83c5.72-6.32 5.48-16.02-.55-22.05L487.84 4.69A15.97 15.97 0 0 0 476.52 0c-3.84 0-7.68 1.37-10.73 4.13L186.6 256H144c-8.84 0-16 7.16-16 16v36.87L10.53 414.84c-13.57 12.28-14.1 33.42-1.16 46.36l41.43 41.43c6.26 6.27 14.45 9.37 22.62 9.37 8.71 0 17.4-3.53 23.73-10.53L376.34 192H400zM73.43 480l-41.46-41.4L455.35 56.65 73.43 480zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm0-96c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16z"]
  },
      TD = {
    prefix: "fal",
    iconName: "warehouse",
    icon: [640, 512, [], "f494", "M512 224H128c-17.7 0-32 14.4-32 32v248c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56h384v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V256c0-17.6-14.3-32-32-32zm0 192H128v-64h384v64zm0-96H128v-64h384v64zm98.6-201.7L338.6 3.7c-11.8-5-25.3-5-37.2 0l-272 114.6C11.5 125.8 0 143.2 0 162.5V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V162.5c0-6.5 3.8-12.2 9.8-14.8l272-114.6c3.9-1.7 8.5-1.7 12.4 0l272 114.6c6 2.5 9.8 8.3 9.8 14.8V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V162.5c0-19.3-11.5-36.7-29.4-44.2z"]
  },
      DD = {
    prefix: "fal",
    iconName: "warehouse-alt",
    icon: [640, 512, [], "f495", "M528 352H352V240c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM320 480H128v-96h192v96zm0-128H128v-96h192v96zm192 128H352v-96h160v96zm98.6-361.7L338.6 3.7c-11.8-5-25.3-5-37.2 0l-272 114.6C11.5 125.8 0 143.2 0 162.5V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V162.5c0-6.5 3.8-12.2 9.8-14.8l272-114.6c3.9-1.7 8.5-1.7 12.4 0l272 114.6c6 2.5 9.8 8.3 9.8 14.8V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V162.5c0-19.3-11.5-36.7-29.4-44.2z"]
  },
      jD = {
    prefix: "fal",
    iconName: "washer",
    icon: [446, 512, [], "f898", "M384-1H64A64 64 0 0 0 0 63v416a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V63a64 64 0 0 0-64-64zm32 480H32V63a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32zM80 95a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm64 0a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm80 32a160 160 0 1 0 160 160 160 160 0 0 0-160-160zm0 288a128 128 0 1 1 128-128 128.14 128.14 0 0 1-128 128zm36.87-131.66a51.23 51.23 0 0 1-73.74 0A51.81 51.81 0 0 1 150 299c-7.71 0-14.74-2.15-21.31-5.16C132.27 343.53 173.41 383 224 383s91.73-39.47 95.31-89.16c-6.57 3-13.6 5.16-21.31 5.16a51.81 51.81 0 0 1-37.13-15.66z"]
  },
      ED = {
    prefix: "fal",
    iconName: "watch",
    icon: [384, 512, [], "f2e1", "M320 112.9V24c0-13.2-10.8-24-24-24H88C74.8 0 64 10.8 64 24v88.9C24.7 148.1 0 199.1 0 256s24.7 107.9 64 143.1V488c0 13.2 10.8 24 24 24h208c13.2 0 24-10.8 24-24v-88.9c39.3-35.2 64-86.2 64-143.1s-24.7-107.9-64-143.1zM96 32h192v57.7C259.8 73.3 227 64 192 64s-67.8 9.3-96 25.7V32zm192 448H96v-57.7c28.2 16.3 61 25.7 96 25.7s67.8-9.4 96-25.7V480zm-96-64c-88.6 0-160-71.8-160-160S103.5 96 192 96c88.4 0 160 71.6 160 160s-71.6 160-160 160zm49-92.2l-60.1-43.7c-3.1-2.3-4.9-5.9-4.9-9.7V150.3c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v109.9l51.8 37.7c5.4 3.9 6.5 11.4 2.6 16.8l-4.7 6.5c-3.8 5.3-11.3 6.5-16.7 2.6z"]
  },
      kD = {
    prefix: "fal",
    iconName: "watch-calculator",
    icon: [384, 512, [], "f8f0", "M136 232h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm72 72h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm-72 0h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm144 0h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm-72-72h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zM320 81.61V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v49.61A80 80 0 0 0 0 160v192a80 80 0 0 0 64 78.39V480a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32v-49.61A80 80 0 0 0 384 352V160a80 80 0 0 0-64-78.39zM96 32h192v48H96zm192 448H96v-48h192zm64-128a48.05 48.05 0 0 1-48 48H80a48.05 48.05 0 0 1-48-48V160a48.05 48.05 0 0 1 48-48h224a48.05 48.05 0 0 1 48 48zm-72-192H104a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h176a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm0 72h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8z"]
  },
      ID = {
    prefix: "fal",
    iconName: "watch-fitness",
    icon: [384, 512, [], "f63e", "M248.42 168.01c-15.76 0-35.02 6.7-56.42 27.74-21.4-21.04-40.66-27.74-56.42-27.74-16.47 0-29.11 7.31-36.38 13.22-28.27 22.95-29.75 64.17-4.45 89.04l87.08 85.59c5.61 5.52 14.73 5.53 20.36 0l87.08-85.59c25.3-24.87 23.81-66.09-4.46-89.04-7.28-5.91-19.93-13.22-36.39-13.22zm18.41 79.44L192 321l-74.83-73.55c-11.77-11.57-11.19-30.51 2.2-41.38 11.1-9.02 27.15-10.16 50.2 12.5L192 240.63l22.43-22.05c22.96-22.57 39.01-21.58 50.2-12.49 13.42 10.88 13.94 29.81 2.2 41.36zM320 81.61V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v49.61C27.48 89.03 0 121.3 0 160v192c0 38.7 27.48 70.97 64 78.39V480c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-49.61c36.52-7.41 64-39.69 64-78.39V160c0-38.7-27.48-70.97-64-78.39zM96 32h192v48H96V32zm192 448H96v-48h192v48zm64-128c0 26.47-21.53 48-48 48H80c-26.47 0-48-21.53-48-48V160c0-26.47 21.53-48 48-48h224c26.47 0 48 21.53 48 48v192z"]
  },
      OD = {
    prefix: "fal",
    iconName: "water",
    icon: [576, 512, [], "f773", "M568.3 416c-29.5-1.5-57.7-11.6-78.2-28.3-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.7-20.2.1-20.2 16.6-48.4 26.7-78.2 28.2-4.3.2-7.7 3.6-7.7 7.9v16c0 4.5 3.8 8.3 8.3 8.1 32.3-1.5 63.3-11.4 87.8-27.9 53.8 36.1 139.2 35.8 192 0 53.7 36.1 139.2 35.8 192 0 24.6 16.5 55.6 26.4 87.6 27.9 4.5.2 8.3-3.6 8.3-8.1v-16c0-4.3-3.4-7.7-7.7-7.9zm0-106.7c-29.5-1.5-57.7-11.6-78.2-28.3-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.7-20.2.1-20.2 16.6-48.3 26.7-78.1 28.2-4.3.2-7.7 3.6-7.7 7.9v16c0 4.5 3.8 8.3 8.3 8.1 32.3-1.5 63.3-11.4 87.8-27.9 53.8 36.1 139.2 35.8 192 0 53.7 36.1 139.2 35.8 192 0 24.6 16.5 55.6 26.4 87.6 27.9 4.5.2 8.3-3.6 8.3-8.1v-16c-.1-4.3-3.5-7.7-7.8-7.9zm0-106.7c-29.5-1.5-57.7-11.6-78.2-28.3-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.7-20.2.1-20.2 16.6-48.4 26.7-78.2 28.2-4.3.2-7.7 3.6-7.7 7.9v16c0 4.5 3.8 8.3 8.3 8.1 32.3-1.5 63.3-11.4 87.8-27.9 53.8 36.1 139.2 35.8 192 0 53.7 36.1 139.2 35.8 192 0 24.6 16.5 55.6 26.4 87.6 27.9 4.5.2 8.3-3.6 8.3-8.1v-16c0-4.3-3.4-7.7-7.7-7.9zm0-106.7c-29.5-1.5-57.7-11.6-78.2-28.3-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.7-20.2.1C65.7 84.3 37.5 94.4 7.7 95.9c-4.3.2-7.7 3.6-7.7 7.9v16c0 4.5 3.8 8.3 8.3 8.1 32.3-1.5 63.3-11.4 87.8-27.9 53.8 36.1 139.2 35.8 192 0 53.7 36.1 139.2 35.8 192 0 24.6 16.5 55.6 26.4 87.6 27.9 4.5.2 8.3-3.6 8.3-8.1v-16c0-4.3-3.4-7.7-7.7-7.9z"]
  },
      QD = {
    prefix: "fal",
    iconName: "water-lower",
    icon: [576, 512, [], "f774", "M276.7 235.7c3.1 2.9 7.2 4.4 11.3 4.4s8.2-1.5 11.3-4.4l90.3-84.7c3.1-2.9 3.1-7.7 0-10.6l-11.3-10.6c-3.1-2.9-8.2-2.9-11.3 0l-63 59.1V7.5c0-4.1-3.6-7.5-8-7.5h-16c-4.4 0-8 3.4-8 7.5v181.3l-63-59.1c-3.1-2.9-8.2-2.9-11.3 0l-11.3 10.6c-3.1 2.9-3.1 7.7 0 10.6l90.3 84.8zM568.3 450c-29.5-1.4-57.7-10.9-78.2-26.5-5.9-4.5-14.3-4.5-20.2.1-43.7 33.6-127 34-171.8-.1-5.9-4.5-14.3-4.5-20.2.1-43.7 33.6-127 34-171.8-.1-5.9-4.5-14.3-4.4-20.2.1-20.2 15.6-48.3 25-78.1 26.4-4.3.2-7.7 3.4-7.7 7.4v15c0 4.2 3.8 7.8 8.3 7.6 32.3-1.4 63.3-10.6 87.8-26.2 53.8 33.9 139.2 33.5 192 0 53.7 33.9 139.2 33.5 192 0 24.6 15.5 55.6 24.8 87.6 26.2 4.5.2 8.3-3.3 8.3-7.6v-15c-.1-4-3.5-7.2-7.8-7.4zm0-119.9c-29.5-1.4-57.7-10.9-78.2-26.5-5.9-4.5-14.3-4.5-20.2.1-43.7 33.6-127 34-171.8-.1-5.9-4.5-14.3-4.5-20.2.1-43.7 33.6-127 34-171.8-.1-5.9-4.5-14.3-4.4-20.2.1-20.2 15.6-48.3 25-78.1 26.4-4.3.2-7.7 3.4-7.7 7.4v15c0 4.2 3.8 7.8 8.3 7.6 32.3-1.4 63.3-10.6 87.8-26.2 53.8 33.9 139.2 33.5 192 0 53.7 33.9 139.2 33.5 192 0 24.6 15.5 55.6 24.8 87.6 26.2 4.5.2 8.3-3.3 8.3-7.6v-15c-.1-4-3.5-7.2-7.8-7.4z"]
  },
      ZD = {
    prefix: "fal",
    iconName: "water-rise",
    icon: [576, 512, [], "f775", "M197.7 117.7c3.1 3.1 8.2 3.1 11.3 0l63-63v193.4c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V54.6l63 63c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3L299.3 4.7C296.2 1.6 292.1 0 288 0s-8.2 1.6-11.3 4.7l-90.3 90.4c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3zM568.3 480c-29.5-1.5-57.7-11.6-78.2-28.3-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.7-20.2.1-20.2 16.6-48.4 26.7-78.2 28.2-4.3.2-7.7 3.6-7.7 7.9v16c0 4.5 3.8 8.3 8.3 8.1 32.3-1.5 63.3-11.4 87.8-27.9 53.8 36.1 139.2 35.8 192 0 53.7 36.1 139.2 35.8 192 0 24.6 16.5 55.6 26.4 87.6 27.9 4.5.2 8.3-3.6 8.3-8.1v-16c0-4.3-3.4-7.7-7.7-7.9zm0-128.1c-29.5-1.5-57.7-11.6-78.2-28.3-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.8-20.2.1-43.7 35.9-127 36.3-171.8-.1-5.9-4.8-14.3-4.7-20.2.1-20.2 16.6-48.3 26.7-78.1 28.2-4.3.2-7.7 3.6-7.7 7.9v16c0 4.5 3.8 8.3 8.3 8.1 32.3-1.5 63.3-11.4 87.8-27.9 53.8 36.1 139.2 35.8 192 0 53.7 36.1 139.2 35.8 192 0 24.6 16.5 55.6 26.4 87.6 27.9 4.5.2 8.3-3.6 8.3-8.1v-16c-.1-4.3-3.5-7.6-7.8-7.9z"]
  },
      UD = {
    prefix: "fal",
    iconName: "wave-sine",
    icon: [640, 512, [], "f899", "M634.1 260.56l-15.4-4.27a8 8 0 0 0-9.77 5.33C592.08 317.9 521.8 448 464 448c-57.47 0-93.81-100.38-129-197.45C296.16 143.11 255.94 32 176 32 87.29 32 13.05 198.62.33 241.55a7.92 7.92 0 0 0 5.57 9.89l15.4 4.26a7.93 7.93 0 0 0 9.77-5.32C47.92 194.1 118.2 64 176 64c57.47 0 93.81 100.38 129 197.45C343.84 368.89 384.06 480 464 480c88.71 0 163-166.62 175.67-209.55a7.92 7.92 0 0 0-5.57-9.89z"]
  },
      BD = {
    prefix: "fal",
    iconName: "wave-square",
    icon: [640, 512, [], "f83e", "M632 240H496a32 32 0 0 0-32 32v176H336V64a32 32 0 0 0-32-32H176a32 32 0 0 0-32 32v176H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h136a32 32 0 0 0 32-32V64h128v384a32 32 0 0 0 32 32h128a32 32 0 0 0 32-32V272h136a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8z"]
  },
      RD = {
    prefix: "fal",
    iconName: "wave-triangle",
    icon: [640, 512, [], "f89a", "M636.73 235.05l-12.91-9.47a8 8 0 0 0-11.18 1.72L464.38 436.44 189.16 38.93A16 16 0 0 0 176.22 32c-6.22-.43-10 2.38-13.13 6.54L1.55 265.82A8 8 0 0 0 3.27 277l12.91 9.47a8 8 0 0 0 11.18-1.72L175.62 75.6l275.22 397.51a16 16 0 0 0 12.94 6.89h.22a16 16 0 0 0 12.91-6.53l161.54-227.24a8 8 0 0 0-1.72-11.18z"]
  },
      YD = {
    prefix: "fal",
    iconName: "waveform",
    icon: [640, 512, [], "f8f1", "M232 96h-16a8 8 0 0 0-8 8v304a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V104a8 8 0 0 0-8-8zm-96 96h-16a8 8 0 0 0-8 8v112a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V200a8 8 0 0 0-8-8zm-96 32H24a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8zm384-96h-16a8 8 0 0 0-8 8v240a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V136a8 8 0 0 0-8-8zm192 96h-16a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8zM520 64h-16a8 8 0 0 0-8 8v368a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM328 0h-16a8 8 0 0 0-8 8v496a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8z"]
  },
      PD = {
    prefix: "fal",
    iconName: "waveform-path",
    icon: [640, 512, [], "f8f2", "M632 276h-61.72l-14.44-93.83A12 12 0 0 0 544.25 172c-4.69.11-10.91 4.11-12 9.66L498 353 459.88 86.3a12 12 0 0 0-23.76-.16L385 412.42l-53.06-402a12 12 0 0 0-23.82 0l-53.12 402-51.12-326.28a12 12 0 0 0-23.76.16L142 353l-34.25-171.36c-1.16-5.81-7.87-9.53-12.19-9.64a12 12 0 0 0-11.44 10.17L69.72 276H8a8 8 0 0 0-8 8v8a8 8 0 0 0 8 8h72a12 12 0 0 0 11.84-10.17l5.72-36.91 34.69 173.44c1.16 5.92 5.56 9.34 12.37 9.64a11.92 11.92 0 0 0 11.26-10.3L192.56 169l51.56 332.91c.5 3.08 2.63 10.14 11.6 10.14h.37a12.09 12.09 0 0 0 11.82-10.42L320 106.78l52.09 394.8a12 12 0 0 0 23.79.28L447.44 169l36.68 256.7a12 12 0 0 0 11.57 10.3c4.75-.25 10.81-3.39 12.09-9.66l34.66-173.42 5.72 36.91A11.88 11.88 0 0 0 560 300h72a8 8 0 0 0 8-8v-8a8 8 0 0 0-8-8z"]
  },
      FD = {
    prefix: "fal",
    iconName: "webcam",
    icon: [448, 512, [], "f832", "M401 438.6l-49.19-30.75C409.88 367.39 448 300.19 448 224 448 100.29 347.71 0 224 0S0 100.29 0 224c0 76.19 38.12 143.39 96.23 183.85L47 438.6a32 32 0 0 0-15 27.14V480a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32v-14.26a32 32 0 0 0-15-27.14zM32 224c0-106 86-192 192-192s192 86 192 192-86 192-192 192S32 330 32 224zm352 256H64v-14.26L127.62 426a221.84 221.84 0 0 0 192.76 0L384 465.74zm0-256a160 160 0 1 0-160 160 160 160 0 0 0 160-160zm-288 0a128 128 0 1 1 128 128A128.14 128.14 0 0 1 96 224zm144-80a16 16 0 0 0-16-16 96.1 96.1 0 0 0-96 96 16 16 0 0 0 32 0 64.07 64.07 0 0 1 64-64 16 16 0 0 0 16-16z"]
  },
      WD = {
    prefix: "fal",
    iconName: "webcam-slash",
    icon: [640, 512, [], "f833", "M637 485.25L23 1.75A8 8 0 0 0 11.76 3l-10 12.51A8 8 0 0 0 3 26.75l614 483.5a8 8 0 0 0 11.25-1.25l10-12.51a8 8 0 0 0-1.25-11.24zM320 32c106 0 192 86 192 192a190.79 190.79 0 0 1-28.24 99.86l25.12 19.78A222 222 0 0 0 544 224C544 100.29 443.72 0 320 0a223.19 223.19 0 0 0-160.81 68.27l25.19 19.84A191.38 191.38 0 0 1 320 32zM163.07 193.53A159.34 159.34 0 0 0 320 384a158.7 158.7 0 0 0 66.24-14.73L356.69 346c-11.7 3.53-23.85 6-36.68 6A128.15 128.15 0 0 1 192 224c0-2.44.59-4.72.72-7.12zM458 303.6c13.6-23.53 22-50.47 22-79.6a159.65 159.65 0 0 0-270-115.72l25.65 20.2C258.24 108.52 287.56 96 320 96a128.14 128.14 0 0 1 128 128c0 21.62-5.9 41.69-15.4 59.57zm-196.79-155l26.15 20.59A63.31 63.31 0 0 1 320 160a16 16 0 0 0 0-32 95.06 95.06 0 0 0-58.75 20.64zM320 416c-106 0-192-86-192-192a191.88 191.88 0 0 1 7.39-52.27l-26.83-21.13A223.05 223.05 0 0 0 96 224c0 76.19 38.12 143.39 96.24 183.85L143 438.6a32 32 0 0 0-15 27.14V480a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32v-11.7l-97.87-77.06A190.94 190.94 0 0 1 320 416zm160 49.74V480H160v-14.26L223.63 426a221.82 221.82 0 0 0 192.75 0z"]
  },
      GD = {
    prefix: "fal",
    iconName: "weight",
    icon: [512, 512, [], "f496", "M448 64h-64.81C353.95 25.38 308.07 0 256 0s-97.95 25.38-127.19 64H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 32c70.69 0 128 57.31 128 128s-57.31 128-128 128-128-57.31-128-128S185.31 32 256 32zm224 416c0 17.67-14.33 32-32 32H64c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h45.56C100.94 115.63 96 137.22 96 160c0 88.22 71.78 160 160 160s160-71.78 160-160c0-22.78-4.94-44.37-13.56-64H448c17.67 0 32 14.33 32 32v320zM256 256c26.47 0 48-21.53 48-48 0-13.92-6.05-26.36-15.54-35.13l30.24-70.57c3.48-8.11-.28-17.52-8.41-21-8.08-3.48-17.52.27-21 8.41l-30.26 70.6C223.57 158 208 188.65 208 208c0 26.47 21.53 48 48 48zm0-64c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16z"]
  },
      qD = {
    prefix: "fal",
    iconName: "weight-hanging",
    icon: [512, 512, [], "f5cd", "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-86.74C329.77 114.6 336 98.09 336 80c0-44.18-35.82-80-80-80s-80 35.82-80 80c0 18.09 6.23 34.6 16.36 48h-86.74c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM208 80c0-26.47 21.53-48 48-48s48 21.53 48 48-21.53 48-48 48-48-21.53-48-48zm267.27 393.92c-2.17 2.77-5.88 6.08-11.3 6.08H48.03c-5.42 0-9.13-3.3-11.3-6.08-4.29-5.49-5.77-13.08-3.96-20.3l73.03-292.13c.21-.83.52-1.32.43-1.48h299.31c.2.26.47.72.66 1.48l73.03 292.13c1.81 7.22.33 14.81-3.96 20.3z"]
  },
      JD = {
    prefix: "fal",
    iconName: "whale",
    icon: [640, 512, [], "f72c", "M432 288c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16zm80-160c-210.5 0-287.35 224-332.12 224-10.96 0-19.88-8.92-19.88-19.88V224l47.38-24.9c10.39-5.93 16.62-15.93 16.62-26.62V80.03c0-9.41-9.01-16.03-18.72-16.03-3.47 0-7.03.85-10.3 2.71L112 114.13 29.02 66.71A20.781 20.781 0 0 0 18.72 64C9.01 64 0 70.61 0 80.03v92.45c0 10.7 6.24 20.69 16.62 26.62L64 224v108.12c0 64 51.88 115.88 115.88 115.88H560c44.18 0 80-35.82 80-80V256.54C640 183.59 576 128 512 128zm96 240c0 26.47-21.53 48-48 48H179.88C133.63 416 96 378.37 96 332.12V204.67l-64-33.84v-65.56l80 45.71 80-45.71v65.76l-64 33.64v127.46c0 28.6 23.27 51.88 51.88 51.88 29.8 0 49.95-25.95 80.45-65.23C309.41 255.54 383.6 160 512 160c45.41 0 96 39.65 96 96.54V368z"]
  },
      KD = {
    prefix: "fal",
    iconName: "wheat",
    icon: [512, 512, [], "f72d", "M454.06 171.37c-4.44-4.43-9.24-8.25-14.25-11.64 14.69-5.26 28.28-12.24 39.23-22.42 26.58-28.86 34.78-75.04 32.64-120.09-.44-9.23-8.03-16.47-17.26-16.91-4.28-.19-8.76-.31-13.4-.31-34.31 0-76.99 6.42-105.77 33.15-10.84 10.88-18.32 24.1-23.46 37.97-3.19-4.56-6.61-9.01-10.68-13.07l-34.45-34.43c-6.24-6.24-16.37-6.25-22.62 0L250.33 57.3c-17.5 17.49-26.49 40.07-27.66 62.97l-6.34-6.33c-6.24-6.24-16.37-6.25-22.62 0L160 147.63c-17.58 17.57-26.59 40.28-27.69 63.3l-6.48-6.48c-6.24-6.24-16.37-6.25-22.62 0L69.5 238.14c-37.51 37.49-37.51 98.3 0 135.8l22.96 22.95-87.76 87.8c-6.25 6.25-6.25 16.38 0 22.62C7.81 510.44 11.91 512 16 512s8.19-1.56 11.31-4.69l87.55-87.59 22.84 22.83c18.74 18.73 43.3 28.1 67.87 28.1s49.12-9.37 67.87-28.1l33.77-33.75c6.25-6.25 6.25-16.38 0-22.63l-6.47-6.47c22.98-1.11 45.66-10.11 63.21-27.66l33.77-33.75c6.25-6.25 6.25-16.38 0-22.63l-6.33-6.32c22.87-1.19 45.42-10.16 62.89-27.62l33.77-33.75c6.25-6.25 6.25-16.38 0-22.63l-33.99-33.97zM397.03 56.59c21.59-20.06 56.82-24.48 82.96-24.59-.21 36.03-8.62 65.65-23.67 82.71-21.99 19.63-56.99 23.78-82.66 23.78h-.38c-.34-25.94 3.95-61.99 23.75-81.9zM272.95 79.94l22.4-22.39 23.14 23.12c24.38 24.37 25.42 64.13.69 89.69-.29.25-.66.34-.93.62l-22.38 22.39-22.92-22.91c-25.01-24.99-25.04-65.49 0-90.52zm-90.33 90.33l22.4-22.39 23.14 23.13c13.62 13.62 33.75 53.21 1.95 88.16l-24.55 24.56-22.94-22.93c-25.02-25-25.04-65.5 0-90.53zM92.11 351.31c-25.02-25-25.04-65.5 0-90.53l22.4-22.39 23.14 23.13c23.78 23.76 25.63 62.42 1.75 88.4l-24.33 24.34-22.96-22.95zm158.7 68.61c-25 24.98-65.46 25.01-90.49 0l-22.66-22.65 22.45-22.43c24.99-24.98 65.46-25.02 90.49 0l22.66 22.65-22.45 22.43zm90.51-90.51c-25 24.98-65.46 25.01-90.49 0l-22.66-22.65 22.45-22.43c24.99-24.98 65.46-25.02 90.49 0l22.66 22.65-22.45 22.43zm90.33-90.33c-25 24.98-65.46 25.01-90.49 0l-22.66-22.65L340.95 194c24.99-24.98 65.46-25.02 90.49 0l22.66 22.65-22.45 22.43z"]
  },
      XD = {
    prefix: "fal",
    iconName: "wheelchair",
    icon: [448, 512, [], "f193", "M443.875 396.323l3.151 7.353c2.611 6.092-.211 13.146-6.303 15.757l-42.421 19.273c-7.658 3.284-17.345.3-21.175-8.797L317.376 288H176a16 16 0 0 1-15.839-13.737C125.779 33.586 128.211 51.165 128 48c0-27.13 22.508-49.003 49.87-47.964 24.878.945 45.15 21.216 46.095 46.094C225.004 73.491 203.131 96 176 96c-3.115 0-6.156-.307-9.105-.874L176.162 160H308c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12H180.734l9.143 64H328a16 16 0 0 1 14.746 9.791l57.752 137.159 27.621-12.929c6.091-2.611 13.146.211 15.756 6.302zm-127.488-28.211C301.755 432.107 244.366 480 176 480c-79.401 0-144-64.599-144-144 0-58.714 35.326-109.325 85.836-131.717l-4.671-32.679C47.059 196.957 0 261.081 0 336c0 97.047 78.953 176 176 176 69.906 0 130.418-40.969 158.801-100.155l-18.414-43.733z"]
  },
      _D = {
    prefix: "fal",
    iconName: "whistle",
    icon: [640, 512, [], "f460", "M210 189.4c-35.7 0-64.6 28.9-64.6 64.6 0 35.7 28.9 64.6 64.6 64.6s64.6-28.9 64.6-64.6c0-35.7-28.9-64.6-64.6-64.6zm0 96.9c-17.8 0-32.3-14.5-32.3-32.3 0-17.8 14.5-32.3 32.3-32.3s32.3 14.5 32.3 32.3c0 17.8-14.5 32.3-32.3 32.3zm254.2-83.7L436.5 219c-2.9 1.7-6.5 1.5-9.2-.6L401.9 198c-2.7-2.1-3.7-5.7-2.6-8.9l10.3-29.8c2.2-6.5.1-13.6-5.2-17.9-68-54.4-107.8-97.3-194.5-97.3-33 0-66 7.8-96.1 23.3C101.5 52.8 83.8 44 64.6 44 29 44 0 73 0 108.6c0 19.5 8.7 37.5 23.2 49.6-40.5 79-27.8 178.2 38.3 244.3 41 41 94.7 61.5 148.5 61.5s107.5-20.5 148.5-61.5c10.1-10.1 18.9-20.9 26.5-32.4l151.9 86.8c7.1 4 16 2.2 20.9-4.3l79-105.3c5.2-7 4-16.9-2.8-22.3L482.5 203.8c-5.2-4.2-12.5-4.7-18.3-1.2zm-431.9-94c0-17.8 14.5-32.3 32.3-32.3 8.1 0 15.8 3 21.6 8.3-8.6 6.3-17 13.1-24.7 20.9-7.7 7.7-14.4 16-20.7 24.5-5.2-5.8-8.5-13.2-8.5-21.4zm512.5 307.5c-2.4 3.3-6.9 4.2-10.5 2.2l-159.5-91.2c-13.2 19.9-57 104.2-164.1 104.6-158 .6-238.3-191.4-126.4-303.3 82.3-82.3 183.4-48 220.5-24.5 9.2 6.7 70.5 55.6 70.5 55.6l-12.1 35.2c-2.2 6.5-.1 13.6 5.2 17.9l51.9 41.5c5.2 4.2 12.5 4.7 18.3 1.3l32.5-19.2 124.4 99.5c3.4 2.7 4 7.7 1.4 11.2l-52.1 69.2z"]
  },
      $D = {
    prefix: "fal",
    iconName: "wifi",
    icon: [640, 512, [], "f1eb", "M320 320c-44.18 0-80 35.82-80 80 0 44.19 35.83 80 80 80 44.19 0 80-35.84 80-80 0-44.18-35.82-80-80-80zm0 128c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm316.21-290.05C459.22-9.9 180.95-10.06 3.79 157.95c-4.94 4.69-5.08 12.51-.26 17.32l5.69 5.69c4.61 4.61 12.07 4.74 16.8.25 164.99-156.39 423.64-155.76 587.97 0 4.73 4.48 12.19 4.35 16.8-.25l5.69-5.69c4.81-4.81 4.67-12.63-.27-17.32zM526.02 270.31c-117.34-104.48-294.86-104.34-412.04 0-5.05 4.5-5.32 12.31-.65 17.2l5.53 5.79c4.46 4.67 11.82 4.96 16.66.67 105.17-93.38 264-93.21 368.98 0 4.83 4.29 12.19 4.01 16.66-.67l5.53-5.79c4.65-4.89 4.38-12.7-.67-17.2z"]
  },
      cj = {
    prefix: "fal",
    iconName: "wifi-1",
    icon: [640, 512, [], "f6aa", "M320 320c-44.18 0-80 35.82-80 80 0 44.19 35.83 80 80 80 44.19 0 80-35.84 80-80 0-44.18-35.82-80-80-80zm0 128c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"]
  },
      ej = {
    prefix: "fal",
    iconName: "wifi-2",
    icon: [640, 512, [], "f6ab", "M526.02 270.31c-117.34-104.48-294.86-104.34-412.04 0-5.05 4.5-5.32 12.31-.65 17.2l5.53 5.79c4.46 4.67 11.82 4.96 16.66.67 105.17-93.38 264-93.21 368.98 0 4.83 4.29 12.19 4.01 16.66-.67l5.53-5.79c4.65-4.89 4.38-12.7-.67-17.2zM320 320c-44.18 0-80 35.82-80 80 0 44.19 35.83 80 80 80 44.19 0 80-35.84 80-80 0-44.18-35.82-80-80-80zm0 128c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"]
  },
      aj = {
    prefix: "fal",
    iconName: "wifi-slash",
    icon: [640, 512, [], "f6ac", "M324.2 320.4c-1.4-.1-2.8-.4-4.2-.4-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80c0-8-1.5-15.5-3.7-22.8zM320 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM3.8 158c-4.9 4.7-5.1 12.5-.3 17.3l5.7 5.7c4.6 4.6 12.1 4.7 16.8.3 19.1-18.1 39.5-33.9 60.8-47.8l-26.4-20.8C40.8 126.3 21.7 141 3.8 158zM614 181.3c4.7 4.5 12.2 4.4 16.8-.3l5.7-5.7c4.8-4.8 4.7-12.6-.3-17.3C503.6 32.2 314.1.6 152.9 63.3l30.2 23.8C328.9 37.9 495.8 69.2 614 181.3zm-297.5 10.8l44.6 35.2c51.8 7.7 101.8 29.8 143.3 66.7 4.8 4.3 12.2 4 16.6-.7l5.5-5.8c4.7-4.9 4.4-12.7-.7-17.2-59.4-53-134.4-79-209.3-78.2zM637 485.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zM114 270.3c-5 4.5-5.3 12.3-.6 17.2l5.5 5.8c4.5 4.7 11.8 5 16.7.7 25.8-23 55.7-40.9 88.1-52.8L195 218.6c-29 12.7-56.4 29.8-81 51.7z"]
  },
      nj = {
    prefix: "fal",
    iconName: "wind",
    icon: [512, 512, [], "f72e", "M8 224h344c59.8 0 106.8-54.6 93.8-116.7-7.6-36.3-36.9-65.6-73.2-73.2-59.1-12.3-111.5 29.8-116.3 85.4-.4 4.6 3.5 8.4 8 8.4h16.2c4.2 0 7.4-3.3 7.9-7.4 4.3-36.6 39.5-63.8 78.7-54.8 23.1 5.3 41.8 24.1 47.2 47.2 9.6 41.8-22.1 79.1-62.3 79.1H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm148 32H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h149.1c33.4 0 63.3 24.4 66.5 57.6 3.7 38.1-26.3 70.4-63.7 70.4-32.8 0-59.9-24.8-63.6-56.5-.5-4.2-3.7-7.4-7.9-7.4h-16c-4.6 0-8.4 3.9-8 8.4 4.3 49.1 45.5 87.6 95.6 87.6 54 0 97.6-44.6 96-98.9-1.6-52.7-47.5-93.2-100-93.2zm239.3 0H243.8c10.5 9.2 19.4 19.9 26.4 32h126.2c41.8 0 79.1 30.4 83.2 72 4.7 47.7-32.9 88-79.6 88-36.5 0-67.3-24.5-76.9-58-1-3.5-4-6-7.7-6h-16.1c-5 0-9 4.6-7.9 9.5C302.9 443 347 480 400 480c63 0 113.9-52 112-115.4-1.9-61.3-55.4-108.6-116.7-108.6z"]
  },
      tj = {
    prefix: "fal",
    iconName: "wind-turbine",
    icon: [514, 512, [], "f89b", "M323.48 430.84a45.94 45.94 0 0 0 77.94-47l-67.74-155.58a16.75 16.75 0 0 1-.22-12.89L393.92 62.7A45.82 45.82 0 0 0 314.18 19L218 152.06a16.9 16.9 0 0 1-11 6.74L39.45 185.34a45.93 45.93 0 0 0 2.24 91L207 294.27 195 480h-32.3a36.94 36.94 0 0 0-33 20.42 8 8 0 0 0 7.11 11.58h240a8 8 0 0 0 7.15-11.58 36.93 36.93 0 0 0-33-20.42h-32.33l-3.86-59.58 7 8.3zM227 480l9.83-151.64 43.16 51L286.56 480zm17-199.46a48.85 48.85 0 0 0-32.84-18l-166-18a13.83 13.83 0 0 1-12.35-13.44v-.2a13.82 13.82 0 0 1 11.65-14L212 190.41a48.75 48.75 0 0 0 31.91-19.6l96.2-133.09a13.83 13.83 0 0 1 24.06 13.19l-60.46 152.68a48.77 48.77 0 0 0 .64 37.45l67.73 155.52a13.82 13.82 0 0 1-5.49 17.33l-.17.1a13.83 13.83 0 0 1-18-3.17zM256.8 200a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"]
  },
      rj = {
    prefix: "fal",
    iconName: "wind-warning",
    icon: [640, 512, [], "f776", "M192 0C86 0 0 86 0 192s86 192 192 192 192-86 192-192S298 0 192 0zm0 352c-88.2 0-160-71.8-160-160S103.8 32 192 32s160 71.8 160 160-71.8 160-160 160zm-8.5-144h17c4.2 0 7.7-3.3 8-7.5l7-112c.3-4.6-3.4-8.5-8-8.5h-31c-4.6 0-8.3 3.9-8 8.5l7 112c.3 4.2 3.8 7.5 8 7.5zm8.5 24c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm347.7 88H375.6c-8 11.5-17.1 22.2-27.1 32h192.4c33.4 0 63.3 24.4 66.5 57.6 3.7 38.1-26.3 70.4-63.7 70.4-32.8 0-59.9-24.8-63.6-56.5-.5-4.2-3.7-7.4-7.9-7.4h-16.1c-4.6 0-8.4 3.9-8 8.4 4.3 49.1 45.5 87.6 95.6 87.6 54 0 97.6-44.6 96-98.9-1.6-52.7-47.5-93.2-100-93.2zm98.1-148.7c-7.6-36.3-36.9-65.6-73.2-73.2-59.1-12.3-111.5 29.8-116.3 85.4-.4 4.6 3.5 8.4 8 8.4h16.2c4.2 0 7.4-3.3 7.9-7.4 4.2-36.6 39.5-63.8 78.7-54.8 23.1 5.3 41.8 24.1 47.2 47.2 9.6 41.8-22.1 79.1-62.3 79.1H406.6c-3.3 11.1-7.6 21.7-12.5 32H544c59.8 0 106.8-54.6 93.8-116.7z"]
  },
      ij = {
    prefix: "fal",
    iconName: "window",
    icon: [512, 512, [], "f40e", "M96 160c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-32c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm192-48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48zm-32 144H32v208c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V224zm0-32V80c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v112h448z"]
  },
      oj = {
    prefix: "fal",
    iconName: "window-alt",
    icon: [512, 512, [], "f40f", "M224 160c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-32c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm64-48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48zm-32 144H32v208c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V224zm0-32V80c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v112h448z"]
  },
      lj = {
    prefix: "fal",
    iconName: "window-close",
    icon: [512, 512, [], "f410", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v352zM348.6 188.3L280.9 256l67.7 67.7c4.6 4.6 4.6 12 0 16.6l-8.3 8.3c-4.6 4.6-12 4.6-16.6 0L256 280.9l-67.7 67.7c-4.6 4.6-12 4.6-16.6 0l-8.3-8.3c-4.6-4.6-4.6-12 0-16.6l67.7-67.7-67.7-67.7c-4.6-4.6-4.6-12 0-16.6l8.3-8.3c4.6-4.6 12-4.6 16.6 0l67.7 67.7 67.7-67.7c4.6-4.6 12-4.6 16.6 0l8.3 8.3c4.5 4.6 4.5 12 0 16.6z"]
  },
      fj = {
    prefix: "fal",
    iconName: "window-frame",
    icon: [512, 512, [], "e04f", "M496,416H480V32A32,32,0,0,0,448,0H64A32,32,0,0,0,32,32V416H16A16,16,0,0,0,0,432v64a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V432A16,16,0,0,0,496,416ZM272,32H448V208H272Zm0,208H448V416H272ZM64,32H240V208H64Zm0,208H240V416H64ZM480,480H32V448H480Z"]
  },
      sj = {
    prefix: "fal",
    iconName: "window-frame-open",
    icon: [512, 512, [], "e050", "M480,32A32,32,0,0,0,448,0H64A32,32,0,0,0,32,32V256H480ZM240,224H64V32H240Zm208,0H272V32H448Zm48,192H480V288H448V416H64V288H32V416H16A16,16,0,0,0,0,432v64a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V432A16,16,0,0,0,496,416Zm-16,64H32V448H480Z"]
  },
      uj = {
    prefix: "fal",
    iconName: "window-maximize",
    icon: [512, 512, [], "f2d0", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V192h448v240zM32 160V80c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v80H32z"]
  },
      hj = {
    prefix: "fal",
    iconName: "window-minimize",
    icon: [512, 512, [], "f2d1", "M496 480H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h480c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
  },
      mj = {
    prefix: "fal",
    iconName: "window-restore",
    icon: [512, 512, [], "f2d2", "M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM32 144c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16v80H32v-80zm352 320c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V256h352v208zm96-96c0 8.8-7.2 16-16 16h-48V144c0-26.5-21.5-48-48-48H128V48c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16v320z"]
  },
      vj = {
    prefix: "fal",
    iconName: "windsock",
    icon: [512, 512, [], "f777", "M497.3 158L64 100.3v-7.2C82.6 86.5 96 68.9 96 48 96 21.5 74.5 0 48 0S0 21.5 0 48c0 20.9 13.4 38.5 32 45.1v410.3c0 4.8 3.6 8.6 8 8.6h16c4.4 0 8-3.9 8-8.6v-99.7L497.3 346c8.4-1.1 14.7-7.9 14.7-15.8V173.9c0-8-6.3-14.7-14.7-15.9zM48 32c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm256 132.5l80 10.7v153.6l-80 10.7v-175zm-32 179.2l-96 12.8v-209l96 12.8v183.4zM64 132.5l80 10.7v217.6l-80 10.7v-239zM480 316l-64 8.5v-145l64 8.5v128z"]
  },
      dj = {
    prefix: "fal",
    iconName: "wine-bottle",
    icon: [512, 512, [], "f72f", "M502.91 72.46L439.3 8.81c-11.75-11.75-32.12-11.74-43.87-.01l-21.25 21.25c-7.91 7.94-10.63 19.17-8.13 29.36l-56.44 56.47c-48.66-16.23-102.17-3.88-138.89 32.85L22.2 297.29c-29.6 29.66-29.6 77.89 0 107.54l84.88 84.89C121.43 504.09 140.49 512 160.8 512s39.41-7.91 53.76-22.28l148.52-148.57c36.69-36.71 49.04-90.22 32.82-138.97l56.41-56.44c10.28 2.5 21.75-.55 29.41-8.19l21.19-21.2c5.84-5.86 9.09-13.65 9.09-21.95s-3.25-16.08-9.09-21.94zm-184.7 268.3l-89.39 89.42-147.1-147.16 89.4-89.43 147.09 147.17zm-188.5 126.32l-84.88-84.89c-17.13-17.17-17.13-45.1 0-62.27l14.27-14.27 147.1 147.17-14.26 14.27c-16.63 16.63-45.6 16.63-62.23-.01zm330.82-352.14l-11.34-11.35-90.82 90.89 4.19 9.93c16.55 39.1 7.98 83.65-21.73 113.69L193.79 170.99c50.83-50.29 111.75-22.55 113.63-21.76l9.91 4.21 90.79-89.46-11.28-11.32 19.81-21.23 62.94 63-19.06 20.51z"]
  },
      Mj = {
    prefix: "fal",
    iconName: "wine-glass",
    icon: [288, 512, [], "f4e3", "M287.4 192.66L271.44 14.55C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.57 272.67 51.27 341.55 128 350.27V480H74.67C59.94 480 48 491.94 48 506.67c0 2.95 2.39 5.33 5.33 5.33h181.34c2.95 0 5.33-2.39 5.33-5.33 0-14.73-11.94-26.67-26.67-26.67H160V350.27c76.73-8.72 134.57-77.6 127.4-157.61zM144 318.27c-44.18 0-84.74-25.67-102.45-66.15-7.49-17.13-10.88-36.44-9.07-56.6L47.12 32h193.76l14.65 163.51c1.81 20.16-1.58 39.47-9.07 56.6-17.72 40.48-58.28 66.16-102.46 66.16z"]
  },
      pj = {
    prefix: "fal",
    iconName: "wine-glass-alt",
    icon: [288, 512, [], "f5ce", "M213.34 480H160V350.27c76.73-8.72 134.57-77.6 127.4-157.61L271.44 14.55C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.57 272.67 51.27 341.55 128 350.27V480H74.67C59.94 480 48 491.94 48 506.67c0 2.95 2.39 5.33 5.33 5.33h181.34c2.95 0 5.33-2.39 5.33-5.33 0-14.73-11.94-26.67-26.66-26.67zm27.54-448l8.6 96H38.52l8.6-96h193.76zM32.47 195.51L35.66 160h216.69l3.18 35.51c1.81 20.16-1.58 39.48-9.07 56.6-17.71 40.48-58.27 66.15-102.45 66.15s-84.74-25.67-102.45-66.15c-7.51-17.12-10.89-36.44-9.09-56.6z"]
  },
      zj = {
    prefix: "fal",
    iconName: "won-sign",
    icon: [576, 512, [], "f159", "M564 160c6.627 0 12-5.373 12-12v-16c0-6.627-5.373-12-12-12h-53.813l17.23-72.328c1.797-7.541-3.921-14.781-11.673-14.781h-16.275a11.999 11.999 0 0 0-11.691 9.296L469.781 120H327.096l-18.92-77.94a12 12 0 0 0-11.662-9.169h-18.723a12.001 12.001 0 0 0-11.662 9.169L247.209 120H106.656L89.318 42.278a12 12 0 0 0-11.712-9.387H61.313c-7.722 0-13.434 7.188-11.69 14.71L66.41 120H12c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h63.685l12.984 56H12c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h85.943l49.783 214.71a12 12 0 0 0 11.69 9.29h28.302c5.539 0 10.357-3.79 11.662-9.173L251.463 256h71.378l52.084 214.827A12 12 0 0 0 386.587 480h28.361a12 12 0 0 0 11.673-9.219L477.788 256H564c6.627 0 12-5.373 12-12v-16c0-6.627-5.373-12-12-12h-76.683l13.341-56H564zM286.582 98.399h1.14s1.484 9.036 3.793 21.601h-8.726a1280.842 1280.842 0 0 0 3.793-21.601zM115.579 160h121.919l-13.595 56H128.07l-12.491-56zm68.477 220.147c-5.696 22.896-8.544 47.7-9.114 47.7h-1.139s-3.987-24.804-9.113-47.7L136.995 256h77.199l-30.138 124.147zM261.161 216l12.321-50.82c.405-1.696.808-3.427 1.208-5.18h24.926c.4 1.753.803 3.484 1.208 5.18l12.32 50.82h-51.983zm148.454 164.147c-5.127 22.896-9.113 47.7-9.113 47.7h-1.14c-.569 0-3.418-24.804-9.113-47.7L360.111 256h78.216l-28.712 124.147zM447.579 216h-97.178l-13.595-56H460.53l-12.951 56z"]
  },
      Cj = {
    prefix: "fal",
    iconName: "wreath",
    icon: [448, 512, [], "f7e2", "M310.8 193.4c-2.3-22.1-10.3-34.6-31.4-44.5-1.4-.7-.9-.3-1.9-1.5-15.8-18.2-30.5-22.3-52.1-17.6-1.7.4-.9.3-2.6 0-21.6-4.7-36.3-.6-52.1 17.6-1 1.2-.5.8-1.9 1.5-21.1 9.9-29.1 22.4-31.5 44.5-.2 2.3 0 1.5-.9 3.2-11 19.8-11.2 34.7 0 54.9 1 1.7.7.9.9 3.2 2.4 22.8 10.9 34.8 31.4 44.5 1.4.7.9.3 1.9 1.5 15.8 18.2 30.5 22.3 52.1 17.6 1.6-.3.9-.4 2.6 0 21.6 4.7 36.3.6 52.1-17.6 1-1.2.6-.8 1.9-1.5 21.1-9.9 29.1-22.4 31.5-44.5.2-2.3 0-1.5.9-3.2 10.9-19.7 11.2-34.6 0-54.9-.9-1.7-.6-.9-.9-3.2zm-30.4 49.7c-2 6.5-.8 14.7-4.6 20.1-3.8 5.4-11.7 6.8-16.9 10.8-5.2 3.9-8.8 11.4-15 13.5-6 2-13.2-1.7-19.8-1.7-6.6 0-13.8 3.7-19.8 1.7-6.2-2.1-9.9-9.5-15-13.5-5.2-4-13.1-5.3-16.9-10.8-3.8-5.4-2.6-13.6-4.6-20.1-1.9-6.2-7.6-12.2-7.6-19.1 0-6.9 5.7-12.8 7.6-19.1 2-6.5.8-14.7 4.6-20.1 3.8-5.4 11.7-6.8 16.9-10.8 5.2-3.9 8.8-11.4 15-13.5 6-2 13.2 1.7 19.8 1.7 6.6 0 13.8-3.7 19.8-1.7 6.2 2.1 9.9 9.5 15 13.5 5.2 4 13.1 5.3 16.9 10.8 3.8 5.4 2.6 13.6 4.6 20.1 1.9 6.2 7.6 12.2 7.6 19.1s-5.7 12.8-7.6 19.1zM448 224c0-15.3-4.7-29.8-13.2-41.9 3.2-14.4 2-29.7-3.8-43.8-5.9-14.4-16.1-26.1-28.8-34-2.4-14.6-9.2-28.1-19.8-38.7-10.5-10.5-24-17.4-38.7-19.8-7.9-12.7-19.6-22.8-34-28.8-18.6-7.7-35.1-5.8-43.8-3.8C253.8 4.7 239.3 0 224 0s-29.8 4.7-41.9 13.2c-8.7-1.9-25.2-3.9-43.8 3.8-14.3 5.9-26 16-33.9 28.8-14.7 2.4-28.1 9.2-38.7 19.8C55 76.2 48.3 89.7 45.8 104.3c-12.7 7.9-22.8 19.6-28.8 34-5.8 14.1-7.1 29.4-3.8 43.8C4.7 194.2 0 208.7 0 224c0 15.3 4.7 29.8 13.2 41.9-3.2 14.4-2 29.7 3.8 43.8 5.9 14.2 16 25.9 28.7 33.7 2.4 14.7 9.2 28.3 19.8 39C78.1 394.9 94.1 400 112 400v78.6c0 9.5 3.6 19 10.7 25.3 8.6 7.6 20.5 10.1 32.5 6l68.8-28.6 69.9 29c3.3 1.1 6.7 1.6 10.1 1.6 6.7 0 13.2-2.1 18.8-6 8.3-6 13.3-15.7 13.3-26v-80c17.8 0 33.8-5 46.4-17.6 10.7-10.7 17.4-24.3 19.8-39 12.8-7.9 22.8-19.5 28.7-33.7 5.8-14.1 7-29.4 3.8-43.8 8.5-12 13.2-26.5 13.2-41.8zM224 446.7L144 480l-1.1-96.4 81.1 33.7 80-33.3 1.1 96.4-81.1-33.7zm173.2-188.2c7.6 11.1 9.7 25.7 4.2 39-5.6 13.6-17.8 22.1-31.3 24.4 2.9 13.3 0 27.6-10.3 37.9-7.4 7.4-16.9 11-26.6 11.6-2.3-5.2-5.7-9.9-10.5-13.3-8.3-6-19-7.7-28.8-4.4l-69.9 29-69.9-29c-9.9-3.3-20.6-1.6-28.8 4.4-4.7 3.4-8.2 8.1-10.5 13.3-9.7-.6-19.2-4.2-26.6-11.6-10.3-10.3-13.3-24.6-10.3-37.9-13.5-2.3-25.7-10.8-31.3-24.4-5.5-13.4-3.5-27.9 4.2-39-11.3-7.4-18.8-20-18.8-34.5s7.5-27.1 18.8-34.5c-7.6-11.1-9.7-25.7-4.2-39 5.6-13.6 17.7-22.5 31.2-24.7-2.8-13.2.2-27.3 10.4-37.6C103 73.4 121.8 77 125.8 77.8c2.3-13.5 11.1-25.6 24.7-31.2 14.1-5.8 28.6-3 39 4.2 7.3-11.3 20-18.8 34.5-18.8s27.1 7.5 34.5 18.8c10.5-7.2 25-9.9 39-4.1 13.6 5.6 22.4 17.7 24.7 31.2 4-.9 22.8-4.4 37.6 10.4 10.2 10.2 13.2 24.4 10.4 37.5 13.5 2.3 25.6 11.1 31.2 24.7 5.5 13.4 3.5 27.9-4.2 39 11.3 7.3 18.8 20 18.8 34.5s-7.5 27.1-18.8 34.5z"]
  },
      Lj = {
    prefix: "fal",
    iconName: "wrench",
    icon: [512, 512, [], "f0ad", "M507.42 114.49c-2.34-9.47-9.66-16.98-19.06-19.61-9.47-2.61-19.65 0-26.65 6.98l-63.87 63.87-44.25-7.36-7.38-44.24 63.87-63.87c6.94-6.92 9.62-17.09 7-26.54-2.62-9.47-10.19-16.83-19.75-19.2C345.6-8.31 291.95 6.54 254.14 44.3c-37.84 37.87-52.21 92.52-38.62 144.7L22.19 382.29c-29.59 29.63-29.59 77.83 0 107.45C36.54 504.09 55.63 512 75.94 512s39.37-7.91 53.71-22.26l193.14-193.11c52.03 13.73 106.8-.72 144.89-38.82 37.81-37.81 52.68-91.39 39.74-143.32zm-62.36 120.7c-31.87 31.81-78.43 42.63-121.77 28.23l-9.38-3.14-206.88 206.84c-16.62 16.62-45.59 16.62-62.21 0-17.12-17.14-17.12-45.06 0-62.21l207.01-206.98-3.09-9.34c-14.31-43.45-3.56-90.06 28.03-121.67C299.48 44.2 329.44 32 360.56 32c6.87 0 13.81.59 20.72 1.81l-69.31 69.35 13.81 83.02L408.84 200l69.3-69.35c6.72 38.25-5.34 76.79-33.08 104.54zM80 416c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"]
  },
      Aj = {
    prefix: "fal",
    iconName: "x-ray",
    icon: [640, 512, [], "f497", "M168 224h136v32H200c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h104v32h-64c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48v-16h64v16c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48h-64v-32h104c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H336v-32h136c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H336v-32h104c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H336v-24c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24H200c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h104v32H168c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm72 160c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm160-32c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zM632 32c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H8C3.6 0 0 3.6 0 8v16c0 4.4 3.6 8 8 8h56v448H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h624c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-56V32h56zm-88 448H96V32h448v448z"]
  },
      Nj = {
    prefix: "fal",
    iconName: "yen-sign",
    icon: [320, 512, [], "f157", "M307.982 32h-22.525a12 12 0 0 0-10.398 6.01l-87.337 153.306c-13.382 25.492-27.402 56.718-27.402 56.718h-1.274s-14.02-31.226-27.403-56.718L45.038 38.042A12 12 0 0 0 34.621 32H12.018c-9.237 0-15.01 9.998-10.394 17.998L100.974 224H44c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h75.442l18.573 32.182V320H44c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h94.014v116c0 6.627 5.373 12 12 12h20.608c6.627 0 12-5.373 12-12V352H276c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-93.377v-31.818l17.7-32.182H276c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-58.062L318.35 50.042c4.662-8-1.109-18.042-10.368-18.042z"]
  },
      gj = {
    prefix: "fal",
    iconName: "yin-yang",
    icon: [496, 512, [], "f6ad", "M232 192c26.47 0 48-21.53 48-48s-21.53-48-48-48-48 21.53-48 48 21.53 48 48 48zm0-64c8.81 0 16 7.17 16 16s-7.19 16-16 16-16-7.17-16-16 7.19-16 16-16zm32 192c-26.47 0-48 21.53-48 48s21.53 48 48 48 48-21.53 48-48-21.53-48-48-48zm0 64c-8.81 0-16-7.17-16-16s7.19-16 16-16 16 7.17 16 16-7.19 16-16 16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248c136.75 0 248-111.25 248-248S384.75 8 248 8zM32 256c0-119.1 96.9-216 216-216 55.12 0 100 44.86 100 100s-44.88 100-100 100c-72.78 0-132 59.22-132 132 0 24.96 7.37 48.08 19.46 68.01C73.53 401.99 32 333.84 32 256zm216 216c-55.12 0-100-44.86-100-100s44.88-100 100-100c72.78 0 132-59.22 132-132 0-24.83-6.88-48.08-18.84-67.94C422.81 110.14 464 178.34 464 256c0 119.11-96.91 216-216 216z"]
  },
      Hj = {
    faAbacus: t,
    faAcorn: r,
    faAd: i,
    faAddressBook: o,
    faAddressCard: l,
    faAdjust: f,
    faAirConditioner: s,
    faAirFreshener: u,
    faAlarmClock: h,
    faAlarmExclamation: m,
    faAlarmPlus: v,
    faAlarmSnooze: d,
    faAlbum: M,
    faAlbumCollection: p,
    faAlicorn: z,
    faAlien: C,
    faAlienMonster: L,
    faAlignCenter: A,
    faAlignJustify: N,
    faAlignLeft: g,
    faAlignRight: H,
    faAlignSlash: V,
    faAllergies: x,
    faAmbulance: w,
    faAmericanSignLanguageInterpreting: y,
    faAmpGuitar: b,
    faAnalytics: S,
    faAnchor: T,
    faAngel: D,
    faAngleDoubleDown: j,
    faAngleDoubleLeft: E,
    faAngleDoubleRight: k,
    faAngleDoubleUp: I,
    faAngleDown: O,
    faAngleLeft: Q,
    faAngleRight: Z,
    faAngleUp: U,
    faAngry: B,
    faAnkh: R,
    faAppleAlt: Y,
    faAppleCrate: P,
    faArchive: F,
    faArchway: W,
    faArrowAltCircleDown: G,
    faArrowAltCircleLeft: q,
    faArrowAltCircleRight: J,
    faArrowAltCircleUp: K,
    faArrowAltDown: X,
    faArrowAltFromBottom: _,
    faArrowAltFromLeft: $,
    faArrowAltFromRight: cc,
    faArrowAltFromTop: ec,
    faArrowAltLeft: ac,
    faArrowAltRight: nc,
    faArrowAltSquareDown: tc,
    faArrowAltSquareLeft: rc,
    faArrowAltSquareRight: ic,
    faArrowAltSquareUp: oc,
    faArrowAltToBottom: lc,
    faArrowAltToLeft: fc,
    faArrowAltToRight: sc,
    faArrowAltToTop: uc,
    faArrowAltUp: hc,
    faArrowCircleDown: mc,
    faArrowCircleLeft: vc,
    faArrowCircleRight: dc,
    faArrowCircleUp: Mc,
    faArrowDown: pc,
    faArrowFromBottom: zc,
    faArrowFromLeft: Cc,
    faArrowFromRight: Lc,
    faArrowFromTop: Ac,
    faArrowLeft: Nc,
    faArrowRight: gc,
    faArrowSquareDown: Hc,
    faArrowSquareLeft: Vc,
    faArrowSquareRight: xc,
    faArrowSquareUp: wc,
    faArrowToBottom: yc,
    faArrowToLeft: bc,
    faArrowToRight: Sc,
    faArrowToTop: Tc,
    faArrowUp: Dc,
    faArrows: jc,
    faArrowsAlt: Ec,
    faArrowsAltH: kc,
    faArrowsAltV: Ic,
    faArrowsH: Oc,
    faArrowsV: Qc,
    faAssistiveListeningSystems: Zc,
    faAsterisk: Uc,
    faAt: Bc,
    faAtlas: Rc,
    faAtom: Yc,
    faAtomAlt: Pc,
    faAudioDescription: Fc,
    faAward: Wc,
    faAxe: Gc,
    faAxeBattle: qc,
    faBaby: Jc,
    faBabyCarriage: Kc,
    faBackpack: Xc,
    faBackspace: _c,
    faBackward: $c,
    faBacon: ce,
    faBacteria: ee,
    faBacterium: ae,
    faBadge: ne,
    faBadgeCheck: te,
    faBadgeDollar: re,
    faBadgePercent: ie,
    faBadgeSheriff: oe,
    faBadgerHoney: le,
    faBagsShopping: fe,
    faBahai: se,
    faBalanceScale: ue,
    faBalanceScaleLeft: he,
    faBalanceScaleRight: me,
    faBallPile: ve,
    faBallot: de,
    faBallotCheck: Me,
    faBan: pe,
    faBandAid: ze,
    faBanjo: Ce,
    faBarcode: Le,
    faBarcodeAlt: Ae,
    faBarcodeRead: Ne,
    faBarcodeScan: ge,
    faBars: He,
    faBaseball: Ve,
    faBaseballBall: xe,
    faBasketballBall: we,
    faBasketballHoop: ye,
    faBat: be,
    faBath: Se,
    faBatteryBolt: Te,
    faBatteryEmpty: De,
    faBatteryFull: je,
    faBatteryHalf: Ee,
    faBatteryQuarter: ke,
    faBatterySlash: Ie,
    faBatteryThreeQuarters: Oe,
    faBed: Qe,
    faBedAlt: Ze,
    faBedBunk: Ue,
    faBedEmpty: Be,
    faBeer: Re,
    faBell: Ye,
    faBellExclamation: Pe,
    faBellOn: Fe,
    faBellPlus: We,
    faBellSchool: Ge,
    faBellSchoolSlash: qe,
    faBellSlash: Je,
    faBells: Ke,
    faBetamax: Xe,
    faBezierCurve: _e,
    faBible: $e,
    faBicycle: ca,
    faBiking: ea,
    faBikingMountain: aa,
    faBinoculars: na,
    faBiohazard: ta,
    faBirthdayCake: ra,
    faBlanket: ia,
    faBlender: oa,
    faBlenderPhone: la,
    faBlind: fa,
    faBlinds: sa,
    faBlindsOpen: ua,
    faBlindsRaised: ha,
    faBlog: ma,
    faBold: va,
    faBolt: da,
    faBomb: Ma,
    faBone: pa,
    faBoneBreak: za,
    faBong: Ca,
    faBook: La,
    faBookAlt: Aa,
    faBookDead: Na,
    faBookHeart: ga,
    faBookMedical: Ha,
    faBookOpen: Va,
    faBookReader: xa,
    faBookSpells: wa,
    faBookUser: ya,
    faBookmark: ba,
    faBooks: Sa,
    faBooksMedical: Ta,
    faBoombox: Da,
    faBoot: ja,
    faBoothCurtain: Ea,
    faBorderAll: ka,
    faBorderBottom: Ia,
    faBorderCenterH: Oa,
    faBorderCenterV: Qa,
    faBorderInner: Za,
    faBorderLeft: Ua,
    faBorderNone: Ba,
    faBorderOuter: Ra,
    faBorderRight: Ya,
    faBorderStyle: Pa,
    faBorderStyleAlt: Fa,
    faBorderTop: Wa,
    faBowArrow: Ga,
    faBowlingBall: qa,
    faBowlingPins: Ja,
    faBox: Ka,
    faBoxAlt: Xa,
    faBoxBallot: _a,
    faBoxCheck: $a,
    faBoxFragile: cn,
    faBoxFull: en,
    faBoxHeart: an,
    faBoxOpen: nn,
    faBoxTissue: tn,
    faBoxUp: rn,
    faBoxUsd: on,
    faBoxes: ln,
    faBoxesAlt: fn,
    faBoxingGlove: sn,
    faBrackets: un,
    faBracketsCurly: hn,
    faBraille: mn,
    faBrain: vn,
    faBreadLoaf: dn,
    faBreadSlice: Mn,
    faBriefcase: pn,
    faBriefcaseMedical: zn,
    faBringForward: Cn,
    faBringFront: Ln,
    faBroadcastTower: An,
    faBroom: Nn,
    faBrowser: gn,
    faBrush: Hn,
    faBug: Vn,
    faBuilding: xn,
    faBullhorn: wn,
    faBullseye: yn,
    faBullseyeArrow: bn,
    faBullseyePointer: Sn,
    faBurgerSoda: Tn,
    faBurn: Dn,
    faBurrito: jn,
    faBus: En,
    faBusAlt: kn,
    faBusSchool: In,
    faBusinessTime: On,
    faCabinetFiling: Qn,
    faCactus: Zn,
    faCalculator: Un,
    faCalculatorAlt: Bn,
    faCalendar: Rn,
    faCalendarAlt: Yn,
    faCalendarCheck: Pn,
    faCalendarDay: Fn,
    faCalendarEdit: Wn,
    faCalendarExclamation: Gn,
    faCalendarMinus: qn,
    faCalendarPlus: Jn,
    faCalendarStar: Kn,
    faCalendarTimes: Xn,
    faCalendarWeek: _n,
    faCamcorder: $n,
    faCamera: ct,
    faCameraAlt: et,
    faCameraHome: at,
    faCameraMovie: nt,
    faCameraPolaroid: tt,
    faCameraRetro: rt,
    faCampfire: it,
    faCampground: ot,
    faCandleHolder: lt,
    faCandyCane: ft,
    faCandyCorn: st,
    faCannabis: ut,
    faCapsules: ht,
    faCar: mt,
    faCarAlt: vt,
    faCarBattery: dt,
    faCarBuilding: Mt,
    faCarBump: pt,
    faCarBus: zt,
    faCarCrash: Ct,
    faCarGarage: Lt,
    faCarMechanic: At,
    faCarSide: Nt,
    faCarTilt: gt,
    faCarWash: Ht,
    faCaravan: Vt,
    faCaravanAlt: xt,
    faCaretCircleDown: wt,
    faCaretCircleLeft: yt,
    faCaretCircleRight: bt,
    faCaretCircleUp: St,
    faCaretDown: Tt,
    faCaretLeft: Dt,
    faCaretRight: jt,
    faCaretSquareDown: Et,
    faCaretSquareLeft: kt,
    faCaretSquareRight: It,
    faCaretSquareUp: Ot,
    faCaretUp: Qt,
    faCarrot: Zt,
    faCars: Ut,
    faCartArrowDown: Bt,
    faCartPlus: Rt,
    faCashRegister: Yt,
    faCassetteTape: Pt,
    faCat: Ft,
    faCatSpace: Wt,
    faCauldron: Gt,
    faCctv: qt,
    faCertificate: Jt,
    faChair: Kt,
    faChairOffice: Xt,
    faChalkboard: _t,
    faChalkboardTeacher: $t,
    faChargingStation: cr,
    faChartArea: er,
    faChartBar: ar,
    faChartLine: nr,
    faChartLineDown: tr,
    faChartNetwork: rr,
    faChartPie: ir,
    faChartPieAlt: or,
    faChartScatter: lr,
    faCheck: fr,
    faCheckCircle: sr,
    faCheckDouble: ur,
    faCheckSquare: hr,
    faCheese: mr,
    faCheeseSwiss: vr,
    faCheeseburger: dr,
    faChess: Mr,
    faChessBishop: pr,
    faChessBishopAlt: zr,
    faChessBoard: Cr,
    faChessClock: Lr,
    faChessClockAlt: Ar,
    faChessKing: Nr,
    faChessKingAlt: gr,
    faChessKnight: Hr,
    faChessKnightAlt: Vr,
    faChessPawn: xr,
    faChessPawnAlt: wr,
    faChessQueen: yr,
    faChessQueenAlt: br,
    faChessRook: Sr,
    faChessRookAlt: Tr,
    faChevronCircleDown: Dr,
    faChevronCircleLeft: jr,
    faChevronCircleRight: Er,
    faChevronCircleUp: kr,
    faChevronDoubleDown: Ir,
    faChevronDoubleLeft: Or,
    faChevronDoubleRight: Qr,
    faChevronDoubleUp: Zr,
    faChevronDown: Ur,
    faChevronLeft: Br,
    faChevronRight: Rr,
    faChevronSquareDown: Yr,
    faChevronSquareLeft: Pr,
    faChevronSquareRight: Fr,
    faChevronSquareUp: Wr,
    faChevronUp: Gr,
    faChild: qr,
    faChimney: Jr,
    faChurch: Kr,
    faCircle: Xr,
    faCircleNotch: _r,
    faCity: $r,
    faClarinet: ci,
    faClawMarks: ei,
    faClinicMedical: ai,
    faClipboard: ni,
    faClipboardCheck: ti,
    faClipboardList: ri,
    faClipboardListCheck: ii,
    faClipboardPrescription: oi,
    faClipboardUser: li,
    faClock: fi,
    faClone: si,
    faClosedCaptioning: ui,
    faCloud: hi,
    faCloudDownload: mi,
    faCloudDownloadAlt: vi,
    faCloudDrizzle: di,
    faCloudHail: Mi,
    faCloudHailMixed: pi,
    faCloudMeatball: zi,
    faCloudMoon: Ci,
    faCloudMoonRain: Li,
    faCloudMusic: Ai,
    faCloudRain: Ni,
    faCloudRainbow: gi,
    faCloudShowers: Hi,
    faCloudShowersHeavy: Vi,
    faCloudSleet: xi,
    faCloudSnow: wi,
    faCloudSun: yi,
    faCloudSunRain: bi,
    faCloudUpload: Si,
    faCloudUploadAlt: Ti,
    faClouds: Di,
    faCloudsMoon: ji,
    faCloudsSun: Ei,
    faClub: ki,
    faCocktail: Ii,
    faCode: Oi,
    faCodeBranch: Qi,
    faCodeCommit: Zi,
    faCodeMerge: Ui,
    faCoffee: Bi,
    faCoffeePot: Ri,
    faCoffeeTogo: Yi,
    faCoffin: Pi,
    faCoffinCross: Fi,
    faCog: Wi,
    faCogs: Gi,
    faCoin: qi,
    faCoins: Ji,
    faColumns: Ki,
    faComet: Xi,
    faComment: _i,
    faCommentAlt: $i,
    faCommentAltCheck: co,
    faCommentAltDollar: eo,
    faCommentAltDots: ao,
    faCommentAltEdit: no,
    faCommentAltExclamation: to,
    faCommentAltLines: ro,
    faCommentAltMedical: io,
    faCommentAltMinus: oo,
    faCommentAltMusic: lo,
    faCommentAltPlus: fo,
    faCommentAltSlash: so,
    faCommentAltSmile: uo,
    faCommentAltTimes: ho,
    faCommentCheck: mo,
    faCommentDollar: vo,
    faCommentDots: Mo,
    faCommentEdit: po,
    faCommentExclamation: zo,
    faCommentLines: Co,
    faCommentMedical: Lo,
    faCommentMinus: Ao,
    faCommentMusic: No,
    faCommentPlus: go,
    faCommentSlash: Ho,
    faCommentSmile: Vo,
    faCommentTimes: xo,
    faComments: wo,
    faCommentsAlt: yo,
    faCommentsAltDollar: bo,
    faCommentsDollar: So,
    faCompactDisc: To,
    faCompass: Do,
    faCompassSlash: jo,
    faCompress: Eo,
    faCompressAlt: ko,
    faCompressArrowsAlt: Io,
    faCompressWide: Oo,
    faComputerClassic: Qo,
    faComputerSpeaker: Zo,
    faConciergeBell: Uo,
    faConstruction: Bo,
    faContainerStorage: Ro,
    faConveyorBelt: Yo,
    faConveyorBeltAlt: Po,
    faCookie: Fo,
    faCookieBite: Wo,
    faCopy: Go,
    faCopyright: qo,
    faCorn: Jo,
    faCouch: Ko,
    faCow: Xo,
    faCowbell: _o,
    faCowbellMore: $o,
    faCreditCard: cl,
    faCreditCardBlank: el,
    faCreditCardFront: al,
    faCricket: nl,
    faCroissant: tl,
    faCrop: rl,
    faCropAlt: il,
    faCross: ol,
    faCrosshairs: ll,
    faCrow: fl,
    faCrown: sl,
    faCrutch: ul,
    faCrutches: hl,
    faCube: ml,
    faCubes: vl,
    faCurling: dl,
    faCut: Ml,
    faDagger: pl,
    faDatabase: zl,
    faDeaf: Cl,
    faDebug: Ll,
    faDeer: Al,
    faDeerRudolph: Nl,
    faDemocrat: gl,
    faDesktop: Hl,
    faDesktopAlt: Vl,
    faDewpoint: xl,
    faDharmachakra: wl,
    faDiagnoses: yl,
    faDiamond: bl,
    faDice: Sl,
    faDiceD10: Tl,
    faDiceD12: Dl,
    faDiceD20: jl,
    faDiceD4: El,
    faDiceD6: kl,
    faDiceD8: Il,
    faDiceFive: Ol,
    faDiceFour: Ql,
    faDiceOne: Zl,
    faDiceSix: Ul,
    faDiceThree: Bl,
    faDiceTwo: Rl,
    faDigging: Yl,
    faDigitalTachograph: Pl,
    faDiploma: Fl,
    faDirections: Wl,
    faDiscDrive: Gl,
    faDisease: ql,
    faDivide: Jl,
    faDizzy: Kl,
    faDna: Xl,
    faDoNotEnter: _l,
    faDog: $l,
    faDogLeashed: cf,
    faDollarSign: ef,
    faDolly: af,
    faDollyEmpty: nf,
    faDollyFlatbed: tf,
    faDollyFlatbedAlt: rf,
    faDollyFlatbedEmpty: of,
    faDonate: lf,
    faDoorClosed: ff,
    faDoorOpen: sf,
    faDotCircle: uf,
    faDove: hf,
    faDownload: mf,
    faDraftingCompass: vf,
    faDragon: df,
    faDrawCircle: Mf,
    faDrawPolygon: pf,
    faDrawSquare: zf,
    faDreidel: Cf,
    faDrone: Lf,
    faDroneAlt: Af,
    faDrum: Nf,
    faDrumSteelpan: gf,
    faDrumstick: Hf,
    faDrumstickBite: Vf,
    faDryer: xf,
    faDryerAlt: wf,
    faDuck: yf,
    faDumbbell: bf,
    faDumpster: Sf,
    faDumpsterFire: Tf,
    faDungeon: Df,
    faEar: jf,
    faEarMuffs: Ef,
    faEclipse: kf,
    faEclipseAlt: If,
    faEdit: Of,
    faEgg: Qf,
    faEggFried: Zf,
    faEject: Uf,
    faElephant: Bf,
    faEllipsisH: Rf,
    faEllipsisHAlt: Yf,
    faEllipsisV: Pf,
    faEllipsisVAlt: Ff,
    faEmptySet: Wf,
    faEngineWarning: Gf,
    faEnvelope: qf,
    faEnvelopeOpen: Jf,
    faEnvelopeOpenDollar: Kf,
    faEnvelopeOpenText: Xf,
    faEnvelopeSquare: _f,
    faEquals: $f,
    faEraser: cs,
    faEthernet: es,
    faEuroSign: as,
    faExchange: ns,
    faExchangeAlt: ts,
    faExclamation: rs,
    faExclamationCircle: is,
    faExclamationSquare: os,
    faExclamationTriangle: ls,
    faExpand: fs,
    faExpandAlt: ss,
    faExpandArrows: us,
    faExpandArrowsAlt: hs,
    faExpandWide: ms,
    faExternalLink: vs,
    faExternalLinkAlt: ds,
    faExternalLinkSquare: Ms,
    faExternalLinkSquareAlt: ps,
    faEye: zs,
    faEyeDropper: Cs,
    faEyeEvil: Ls,
    faEyeSlash: As,
    faFan: Ns,
    faFanTable: gs,
    faFarm: Hs,
    faFastBackward: Vs,
    faFastForward: xs,
    faFaucet: ws,
    faFaucetDrip: ys,
    faFax: bs,
    faFeather: Ss,
    faFeatherAlt: Ts,
    faFemale: Ds,
    faFieldHockey: js,
    faFighterJet: Es,
    faFile: ks,
    faFileAlt: Is,
    faFileArchive: Os,
    faFileAudio: Qs,
    faFileCertificate: Zs,
    faFileChartLine: Us,
    faFileChartPie: Bs,
    faFileCheck: Rs,
    faFileCode: Ys,
    faFileContract: Ps,
    faFileCsv: Fs,
    faFileDownload: Ws,
    faFileEdit: Gs,
    faFileExcel: qs,
    faFileExclamation: Js,
    faFileExport: Ks,
    faFileImage: Xs,
    faFileImport: _s,
    faFileInvoice: $s,
    faFileInvoiceDollar: cu,
    faFileMedical: eu,
    faFileMedicalAlt: au,
    faFileMinus: nu,
    faFileMusic: tu,
    faFilePdf: ru,
    faFilePlus: iu,
    faFilePowerpoint: ou,
    faFilePrescription: lu,
    faFileSearch: fu,
    faFileSignature: su,
    faFileSpreadsheet: uu,
    faFileTimes: hu,
    faFileUpload: mu,
    faFileUser: vu,
    faFileVideo: du,
    faFileWord: Mu,
    faFilesMedical: pu,
    faFill: zu,
    faFillDrip: Cu,
    faFilm: Lu,
    faFilmAlt: Au,
    faFilmCanister: Nu,
    faFilter: gu,
    faFingerprint: Hu,
    faFire: Vu,
    faFireAlt: xu,
    faFireExtinguisher: wu,
    faFireSmoke: yu,
    faFireplace: bu,
    faFirstAid: Su,
    faFish: Tu,
    faFishCooked: Du,
    faFistRaised: ju,
    faFlag: Eu,
    faFlagAlt: ku,
    faFlagCheckered: Iu,
    faFlagUsa: Ou,
    faFlame: Qu,
    faFlashlight: Zu,
    faFlask: Uu,
    faFlaskPoison: Bu,
    faFlaskPotion: Ru,
    faFlower: Yu,
    faFlowerDaffodil: Pu,
    faFlowerTulip: Fu,
    faFlushed: Wu,
    faFlute: Gu,
    faFluxCapacitor: qu,
    faFog: Ju,
    faFolder: Ku,
    faFolderDownload: Xu,
    faFolderMinus: _u,
    faFolderOpen: $u,
    faFolderPlus: ch,
    faFolderTimes: eh,
    faFolderTree: ah,
    faFolderUpload: nh,
    faFolders: th,
    faFont: rh,
    faFontAwesomeLogoFull: ih,
    faFontCase: oh,
    faFootballBall: lh,
    faFootballHelmet: fh,
    faForklift: sh,
    faForward: uh,
    faFragile: hh,
    faFrenchFries: mh,
    faFrog: vh,
    faFrostyHead: dh,
    faFrown: Mh,
    faFrownOpen: ph,
    faFunction: zh,
    faFunnelDollar: Ch,
    faFutbol: Lh,
    faGalaxy: Ah,
    faGameBoard: Nh,
    faGameBoardAlt: gh,
    faGameConsoleHandheld: Hh,
    faGamepad: Vh,
    faGamepadAlt: xh,
    faGarage: wh,
    faGarageCar: yh,
    faGarageOpen: bh,
    faGasPump: Sh,
    faGasPumpSlash: Th,
    faGavel: Dh,
    faGem: jh,
    faGenderless: Eh,
    faGhost: kh,
    faGift: Ih,
    faGiftCard: Oh,
    faGifts: Qh,
    faGingerbreadMan: Zh,
    faGlass: Uh,
    faGlassChampagne: Bh,
    faGlassCheers: Rh,
    faGlassCitrus: Yh,
    faGlassMartini: Ph,
    faGlassMartiniAlt: Fh,
    faGlassWhiskey: Wh,
    faGlassWhiskeyRocks: Gh,
    faGlasses: qh,
    faGlassesAlt: Jh,
    faGlobe: Kh,
    faGlobeAfrica: Xh,
    faGlobeAmericas: _h,
    faGlobeAsia: $h,
    faGlobeEurope: cm,
    faGlobeSnow: em,
    faGlobeStand: am,
    faGolfBall: nm,
    faGolfClub: tm,
    faGopuram: rm,
    faGraduationCap: im,
    faGramophone: om,
    faGreaterThan: lm,
    faGreaterThanEqual: fm,
    faGrimace: sm,
    faGrin: um,
    faGrinAlt: hm,
    faGrinBeam: mm,
    faGrinBeamSweat: vm,
    faGrinHearts: dm,
    faGrinSquint: Mm,
    faGrinSquintTears: pm,
    faGrinStars: zm,
    faGrinTears: Cm,
    faGrinTongue: Lm,
    faGrinTongueSquint: Am,
    faGrinTongueWink: Nm,
    faGrinWink: gm,
    faGripHorizontal: Hm,
    faGripLines: Vm,
    faGripLinesVertical: xm,
    faGripVertical: wm,
    faGuitar: ym,
    faGuitarElectric: bm,
    faGuitars: Sm,
    faHSquare: Tm,
    faH1: Dm,
    faH2: jm,
    faH3: Em,
    faH4: km,
    faHamburger: Im,
    faHammer: Om,
    faHammerWar: Qm,
    faHamsa: Zm,
    faHandHeart: Um,
    faHandHolding: Bm,
    faHandHoldingBox: Rm,
    faHandHoldingHeart: Ym,
    faHandHoldingMagic: Pm,
    faHandHoldingMedical: Fm,
    faHandHoldingSeedling: Wm,
    faHandHoldingUsd: Gm,
    faHandHoldingWater: qm,
    faHandLizard: Jm,
    faHandMiddleFinger: Km,
    faHandPaper: Xm,
    faHandPeace: _m,
    faHandPointDown: $m,
    faHandPointLeft: cv,
    faHandPointRight: ev,
    faHandPointUp: av,
    faHandPointer: nv,
    faHandReceiving: tv,
    faHandRock: rv,
    faHandScissors: iv,
    faHandSparkles: ov,
    faHandSpock: lv,
    faHands: fv,
    faHandsHeart: sv,
    faHandsHelping: uv,
    faHandsUsd: hv,
    faHandsWash: mv,
    faHandshake: vv,
    faHandshakeAlt: dv,
    faHandshakeAltSlash: Mv,
    faHandshakeSlash: pv,
    faHanukiah: zv,
    faHardHat: Cv,
    faHashtag: Lv,
    faHatChef: Av,
    faHatCowboy: Nv,
    faHatCowboySide: gv,
    faHatSanta: Hv,
    faHatWinter: Vv,
    faHatWitch: xv,
    faHatWizard: wv,
    faHdd: yv,
    faHeadSide: bv,
    faHeadSideBrain: Sv,
    faHeadSideCough: Tv,
    faHeadSideCoughSlash: Dv,
    faHeadSideHeadphones: jv,
    faHeadSideMask: Ev,
    faHeadSideMedical: kv,
    faHeadSideVirus: Iv,
    faHeadVr: Ov,
    faHeading: Qv,
    faHeadphones: Zv,
    faHeadphonesAlt: Uv,
    faHeadset: Bv,
    faHeart: Rv,
    faHeartBroken: Yv,
    faHeartCircle: Pv,
    faHeartRate: Fv,
    faHeartSquare: Wv,
    faHeartbeat: Gv,
    faHeat: qv,
    faHelicopter: Jv,
    faHelmetBattle: Kv,
    faHexagon: Xv,
    faHighlighter: _v,
    faHiking: $v,
    faHippo: cd,
    faHistory: ed,
    faHockeyMask: ad,
    faHockeyPuck: nd,
    faHockeySticks: td,
    faHollyBerry: rd,
    faHome: id,
    faHomeAlt: od,
    faHomeHeart: ld,
    faHomeLg: fd,
    faHomeLgAlt: sd,
    faHoodCloak: ud,
    faHorizontalRule: hd,
    faHorse: md,
    faHorseHead: vd,
    faHorseSaddle: dd,
    faHospital: Md,
    faHospitalAlt: pd,
    faHospitalSymbol: zd,
    faHospitalUser: Cd,
    faHospitals: Ld,
    faHotTub: Ad,
    faHotdog: Nd,
    faHotel: gd,
    faHourglass: Hd,
    faHourglassEnd: Vd,
    faHourglassHalf: xd,
    faHourglassStart: wd,
    faHouse: yd,
    faHouseDamage: bd,
    faHouseDay: Sd,
    faHouseFlood: Td,
    faHouseLeave: Dd,
    faHouseNight: jd,
    faHouseReturn: Ed,
    faHouseSignal: kd,
    faHouseUser: Id,
    faHryvnia: Od,
    faHumidity: Qd,
    faHurricane: Zd,
    faICursor: Ud,
    faIceCream: Bd,
    faIceSkate: Rd,
    faIcicles: Yd,
    faIcons: Pd,
    faIconsAlt: Fd,
    faIdBadge: Wd,
    faIdCard: Gd,
    faIdCardAlt: qd,
    faIgloo: Jd,
    faImage: Kd,
    faImagePolaroid: Xd,
    faImages: _d,
    faInbox: $d,
    faInboxIn: cM,
    faInboxOut: eM,
    faIndent: aM,
    faIndustry: nM,
    faIndustryAlt: tM,
    faInfinity: rM,
    faInfo: iM,
    faInfoCircle: oM,
    faInfoSquare: lM,
    faInhaler: fM,
    faIntegral: sM,
    faIntersection: uM,
    faInventory: hM,
    faIslandTropical: mM,
    faItalic: vM,
    faJackOLantern: dM,
    faJedi: MM,
    faJoint: pM,
    faJournalWhills: zM,
    faJoystick: CM,
    faJug: LM,
    faKaaba: AM,
    faKazoo: NM,
    faKerning: gM,
    faKey: HM,
    faKeySkeleton: VM,
    faKeyboard: xM,
    faKeynote: wM,
    faKhanda: yM,
    faKidneys: bM,
    faKiss: SM,
    faKissBeam: TM,
    faKissWinkHeart: DM,
    faKite: jM,
    faKiwiBird: EM,
    faKnifeKitchen: kM,
    faLambda: IM,
    faLamp: OM,
    faLampDesk: QM,
    faLampFloor: ZM,
    faLandmark: UM,
    faLandmarkAlt: BM,
    faLanguage: RM,
    faLaptop: YM,
    faLaptopCode: PM,
    faLaptopHouse: FM,
    faLaptopMedical: WM,
    faLasso: GM,
    faLaugh: qM,
    faLaughBeam: JM,
    faLaughSquint: KM,
    faLaughWink: XM,
    faLayerGroup: _M,
    faLayerMinus: $M,
    faLayerPlus: cp,
    faLeaf: ep,
    faLeafHeart: ap,
    faLeafMaple: np,
    faLeafOak: tp,
    faLemon: rp,
    faLessThan: ip,
    faLessThanEqual: op,
    faLevelDown: lp,
    faLevelDownAlt: fp,
    faLevelUp: sp,
    faLevelUpAlt: up,
    faLifeRing: hp,
    faLightCeiling: mp,
    faLightSwitch: vp,
    faLightSwitchOff: dp,
    faLightSwitchOn: Mp,
    faLightbulb: pp,
    faLightbulbDollar: zp,
    faLightbulbExclamation: Cp,
    faLightbulbOn: Lp,
    faLightbulbSlash: Ap,
    faLightsHoliday: Np,
    faLineColumns: gp,
    faLineHeight: Hp,
    faLink: Vp,
    faLips: xp,
    faLiraSign: wp,
    faList: yp,
    faListAlt: bp,
    faListMusic: Sp,
    faListOl: Tp,
    faListUl: Dp,
    faLocation: jp,
    faLocationArrow: Ep,
    faLocationCircle: kp,
    faLocationSlash: Ip,
    faLock: Op,
    faLockAlt: Qp,
    faLockOpen: Zp,
    faLockOpenAlt: Up,
    faLongArrowAltDown: Bp,
    faLongArrowAltLeft: Rp,
    faLongArrowAltRight: Yp,
    faLongArrowAltUp: Pp,
    faLongArrowDown: Fp,
    faLongArrowLeft: Wp,
    faLongArrowRight: Gp,
    faLongArrowUp: qp,
    faLoveseat: Jp,
    faLowVision: Kp,
    faLuchador: Xp,
    faLuggageCart: _p,
    faLungs: $p,
    faLungsVirus: cz,
    faMace: ez,
    faMagic: az,
    faMagnet: nz,
    faMailBulk: tz,
    faMailbox: rz,
    faMale: iz,
    faMandolin: oz,
    faMap: lz,
    faMapMarked: fz,
    faMapMarkedAlt: sz,
    faMapMarker: uz,
    faMapMarkerAlt: hz,
    faMapMarkerAltSlash: mz,
    faMapMarkerCheck: vz,
    faMapMarkerEdit: dz,
    faMapMarkerExclamation: Mz,
    faMapMarkerMinus: pz,
    faMapMarkerPlus: zz,
    faMapMarkerQuestion: Cz,
    faMapMarkerSlash: Lz,
    faMapMarkerSmile: Az,
    faMapMarkerTimes: Nz,
    faMapPin: gz,
    faMapSigns: Hz,
    faMarker: Vz,
    faMars: xz,
    faMarsDouble: wz,
    faMarsStroke: yz,
    faMarsStrokeH: bz,
    faMarsStrokeV: Sz,
    faMask: Tz,
    faMeat: Dz,
    faMedal: jz,
    faMedkit: Ez,
    faMegaphone: kz,
    faMeh: Iz,
    faMehBlank: Oz,
    faMehRollingEyes: Qz,
    faMemory: Zz,
    faMenorah: Uz,
    faMercury: Bz,
    faMeteor: Rz,
    faMicrochip: Yz,
    faMicrophone: Pz,
    faMicrophoneAlt: Fz,
    faMicrophoneAltSlash: Wz,
    faMicrophoneSlash: Gz,
    faMicrophoneStand: qz,
    faMicroscope: Jz,
    faMicrowave: Kz,
    faMindShare: Xz,
    faMinus: _z,
    faMinusCircle: $z,
    faMinusHexagon: cC,
    faMinusOctagon: eC,
    faMinusSquare: aC,
    faMistletoe: nC,
    faMitten: tC,
    faMobile: rC,
    faMobileAlt: iC,
    faMobileAndroid: oC,
    faMobileAndroidAlt: lC,
    faMoneyBill: fC,
    faMoneyBillAlt: sC,
    faMoneyBillWave: uC,
    faMoneyBillWaveAlt: hC,
    faMoneyCheck: mC,
    faMoneyCheckAlt: vC,
    faMoneyCheckEdit: dC,
    faMoneyCheckEditAlt: MC,
    faMonitorHeartRate: pC,
    faMonkey: zC,
    faMonument: CC,
    faMoon: LC,
    faMoonCloud: AC,
    faMoonStars: NC,
    faMortarPestle: gC,
    faMosque: HC,
    faMotorcycle: VC,
    faMountain: xC,
    faMountains: wC,
    faMouse: yC,
    faMouseAlt: bC,
    faMousePointer: SC,
    faMp3Player: TC,
    faMug: DC,
    faMugHot: jC,
    faMugMarshmallows: EC,
    faMugTea: kC,
    faMusic: IC,
    faMusicAlt: OC,
    faMusicAltSlash: QC,
    faMusicSlash: ZC,
    faNarwhal: UC,
    faNetworkWired: BC,
    faNeuter: RC,
    faNewspaper: YC,
    faNotEqual: PC,
    faNotesMedical: FC,
    faObjectGroup: WC,
    faObjectUngroup: GC,
    faOctagon: qC,
    faOilCan: JC,
    faOilTemp: KC,
    faOm: XC,
    faOmega: _C,
    faOrnament: $C,
    faOtter: cL,
    faOutdent: eL,
    faOutlet: aL,
    faOven: nL,
    faOverline: tL,
    faPageBreak: rL,
    faPager: iL,
    faPaintBrush: oL,
    faPaintBrushAlt: lL,
    faPaintRoller: fL,
    faPalette: sL,
    faPallet: uL,
    faPalletAlt: hL,
    faPaperPlane: mL,
    faPaperclip: vL,
    faParachuteBox: dL,
    faParagraph: ML,
    faParagraphRtl: pL,
    faParking: zL,
    faParkingCircle: CL,
    faParkingCircleSlash: LL,
    faParkingSlash: AL,
    faPassport: NL,
    faPastafarianism: gL,
    faPaste: HL,
    faPause: VL,
    faPauseCircle: xL,
    faPaw: wL,
    faPawAlt: yL,
    faPawClaws: bL,
    faPeace: SL,
    faPegasus: TL,
    faPen: DL,
    faPenAlt: jL,
    faPenFancy: EL,
    faPenNib: kL,
    faPenSquare: IL,
    faPencil: OL,
    faPencilAlt: QL,
    faPencilPaintbrush: ZL,
    faPencilRuler: UL,
    faPennant: BL,
    faPeopleArrows: RL,
    faPeopleCarry: YL,
    faPepperHot: PL,
    faPercent: FL,
    faPercentage: WL,
    faPersonBooth: GL,
    faPersonCarry: qL,
    faPersonDolly: JL,
    faPersonDollyEmpty: KL,
    faPersonSign: XL,
    faPhone: _L,
    faPhoneAlt: $L,
    faPhoneLaptop: cA,
    faPhoneOffice: eA,
    faPhonePlus: aA,
    faPhoneRotary: nA,
    faPhoneSlash: tA,
    faPhoneSquare: rA,
    faPhoneSquareAlt: iA,
    faPhoneVolume: oA,
    faPhotoVideo: lA,
    faPi: fA,
    faPiano: sA,
    faPianoKeyboard: uA,
    faPie: hA,
    faPig: mA,
    faPiggyBank: vA,
    faPills: dA,
    faPizza: MA,
    faPizzaSlice: pA,
    faPlaceOfWorship: zA,
    faPlane: CA,
    faPlaneAlt: LA,
    faPlaneArrival: AA,
    faPlaneDeparture: NA,
    faPlaneSlash: gA,
    faPlanetMoon: HA,
    faPlanetRinged: VA,
    faPlay: xA,
    faPlayCircle: wA,
    faPlug: yA,
    faPlus: bA,
    faPlusCircle: SA,
    faPlusHexagon: TA,
    faPlusOctagon: DA,
    faPlusSquare: jA,
    faPodcast: EA,
    faPodium: kA,
    faPodiumStar: IA,
    faPoliceBox: OA,
    faPoll: QA,
    faPollH: ZA,
    faPollPeople: UA,
    faPoo: BA,
    faPooStorm: RA,
    faPoop: YA,
    faPopcorn: PA,
    faPortalEnter: FA,
    faPortalExit: WA,
    faPortrait: GA,
    faPoundSign: qA,
    faPowerOff: JA,
    faPray: KA,
    faPrayingHands: XA,
    faPrescription: _A,
    faPrescriptionBottle: $A,
    faPrescriptionBottleAlt: cN,
    faPresentation: eN,
    faPrint: aN,
    faPrintSearch: nN,
    faPrintSlash: tN,
    faProcedures: rN,
    faProjectDiagram: iN,
    faProjector: oN,
    faPumpMedical: lN,
    faPumpSoap: fN,
    faPumpkin: sN,
    faPuzzlePiece: uN,
    faQrcode: hN,
    faQuestion: mN,
    faQuestionCircle: vN,
    faQuestionSquare: dN,
    faQuidditch: MN,
    faQuoteLeft: pN,
    faQuoteRight: zN,
    faQuran: CN,
    faRabbit: LN,
    faRabbitFast: AN,
    faRacquet: NN,
    faRadar: gN,
    faRadiation: HN,
    faRadiationAlt: VN,
    faRadio: xN,
    faRadioAlt: wN,
    faRainbow: yN,
    faRaindrops: bN,
    faRam: SN,
    faRampLoading: TN,
    faRandom: DN,
    faRaygun: jN,
    faReceipt: EN,
    faRecordVinyl: kN,
    faRectangleLandscape: IN,
    faRectanglePortrait: ON,
    faRectangleWide: QN,
    faRecycle: ZN,
    faRedo: UN,
    faRedoAlt: BN,
    faRefrigerator: RN,
    faRegistered: YN,
    faRemoveFormat: PN,
    faRepeat: FN,
    faRepeat1: WN,
    faRepeat1Alt: GN,
    faRepeatAlt: qN,
    faReply: JN,
    faReplyAll: KN,
    faRepublican: XN,
    faRestroom: _N,
    faRetweet: $N,
    faRetweetAlt: cg,
    faRibbon: eg,
    faRing: ag,
    faRingsWedding: ng,
    faRoad: tg,
    faRobot: rg,
    faRocket: ig,
    faRocketLaunch: og,
    faRoute: lg,
    faRouteHighway: fg,
    faRouteInterstate: sg,
    faRouter: ug,
    faRss: hg,
    faRssSquare: mg,
    faRubleSign: vg,
    faRuler: dg,
    faRulerCombined: Mg,
    faRulerHorizontal: pg,
    faRulerTriangle: zg,
    faRulerVertical: Cg,
    faRunning: Lg,
    faRupeeSign: Ag,
    faRv: Ng,
    faSack: gg,
    faSackDollar: Hg,
    faSadCry: Vg,
    faSadTear: xg,
    faSalad: wg,
    faSandwich: yg,
    faSatellite: bg,
    faSatelliteDish: Sg,
    faSausage: Tg,
    faSave: Dg,
    faSaxHot: jg,
    faSaxophone: Eg,
    faScalpel: kg,
    faScalpelPath: Ig,
    faScanner: Og,
    faScannerImage: Qg,
    faScannerKeyboard: Zg,
    faScannerTouchscreen: Ug,
    faScarecrow: Bg,
    faScarf: Rg,
    faSchool: Yg,
    faScrewdriver: Pg,
    faScroll: Fg,
    faScrollOld: Wg,
    faScrubber: Gg,
    faScythe: qg,
    faSdCard: Jg,
    faSearch: Kg,
    faSearchDollar: Xg,
    faSearchLocation: _g,
    faSearchMinus: $g,
    faSearchPlus: cH,
    faSeedling: eH,
    faSendBack: aH,
    faSendBackward: nH,
    faSensor: tH,
    faSensorAlert: rH,
    faSensorFire: iH,
    faSensorOn: oH,
    faSensorSmoke: lH,
    faServer: fH,
    faShapes: sH,
    faShare: uH,
    faShareAll: hH,
    faShareAlt: mH,
    faShareAltSquare: vH,
    faShareSquare: dH,
    faSheep: MH,
    faShekelSign: pH,
    faShield: zH,
    faShieldAlt: CH,
    faShieldCheck: LH,
    faShieldCross: AH,
    faShieldVirus: NH,
    faShip: gH,
    faShippingFast: HH,
    faShippingTimed: VH,
    faShishKebab: xH,
    faShoePrints: wH,
    faShoppingBag: yH,
    faShoppingBasket: bH,
    faShoppingCart: SH,
    faShovel: TH,
    faShovelSnow: DH,
    faShower: jH,
    faShredder: EH,
    faShuttleVan: kH,
    faShuttlecock: IH,
    faSickle: OH,
    faSigma: QH,
    faSign: ZH,
    faSignIn: UH,
    faSignInAlt: BH,
    faSignLanguage: RH,
    faSignOut: YH,
    faSignOutAlt: PH,
    faSignal: FH,
    faSignal1: WH,
    faSignal2: GH,
    faSignal3: qH,
    faSignal4: JH,
    faSignalAlt: KH,
    faSignalAlt1: XH,
    faSignalAlt2: _H,
    faSignalAlt3: $H,
    faSignalAltSlash: cV,
    faSignalSlash: eV,
    faSignalStream: aV,
    faSignature: nV,
    faSimCard: tV,
    faSink: rV,
    faSiren: iV,
    faSirenOn: oV,
    faSitemap: lV,
    faSkating: fV,
    faSkeleton: sV,
    faSkiJump: uV,
    faSkiLift: hV,
    faSkiing: mV,
    faSkiingNordic: vV,
    faSkull: dV,
    faSkullCow: MV,
    faSkullCrossbones: pV,
    faSlash: zV,
    faSledding: CV,
    faSleigh: LV,
    faSlidersH: AV,
    faSlidersHSquare: NV,
    faSlidersV: gV,
    faSlidersVSquare: HV,
    faSmile: VV,
    faSmileBeam: xV,
    faSmilePlus: wV,
    faSmileWink: yV,
    faSmog: bV,
    faSmoke: SV,
    faSmoking: TV,
    faSmokingBan: DV,
    faSms: jV,
    faSnake: EV,
    faSnooze: kV,
    faSnowBlowing: IV,
    faSnowboarding: OV,
    faSnowflake: QV,
    faSnowflakes: ZV,
    faSnowman: UV,
    faSnowmobile: BV,
    faSnowplow: RV,
    faSoap: YV,
    faSocks: PV,
    faSolarPanel: FV,
    faSolarSystem: WV,
    faSort: GV,
    faSortAlphaDown: qV,
    faSortAlphaDownAlt: JV,
    faSortAlphaUp: KV,
    faSortAlphaUpAlt: XV,
    faSortAlt: _V,
    faSortAmountDown: $V,
    faSortAmountDownAlt: cx,
    faSortAmountUp: ex,
    faSortAmountUpAlt: ax,
    faSortCircle: nx,
    faSortCircleDown: tx,
    faSortCircleUp: rx,
    faSortDown: ix,
    faSortNumericDown: ox,
    faSortNumericDownAlt: lx,
    faSortNumericUp: fx,
    faSortNumericUpAlt: sx,
    faSortShapesDown: ux,
    faSortShapesDownAlt: hx,
    faSortShapesUp: mx,
    faSortShapesUpAlt: vx,
    faSortSizeDown: dx,
    faSortSizeDownAlt: Mx,
    faSortSizeUp: px,
    faSortSizeUpAlt: zx,
    faSortUp: Cx,
    faSoup: Lx,
    faSpa: Ax,
    faSpaceShuttle: Nx,
    faSpaceStationMoon: gx,
    faSpaceStationMoonAlt: Hx,
    faSpade: Vx,
    faSparkles: xx,
    faSpeaker: wx,
    faSpeakers: yx,
    faSpellCheck: bx,
    faSpider: Sx,
    faSpiderBlackWidow: Tx,
    faSpiderWeb: Dx,
    faSpinner: jx,
    faSpinnerThird: Ex,
    faSplotch: kx,
    faSprayCan: Ix,
    faSprinkler: Ox,
    faSquare: Qx,
    faSquareFull: Zx,
    faSquareRoot: Ux,
    faSquareRootAlt: Bx,
    faSquirrel: Rx,
    faStaff: Yx,
    faStamp: Px,
    faStar: Fx,
    faStarAndCrescent: Wx,
    faStarChristmas: Gx,
    faStarExclamation: qx,
    faStarHalf: Jx,
    faStarHalfAlt: Kx,
    faStarOfDavid: Xx,
    faStarOfLife: _x,
    faStarShooting: $x,
    faStarfighter: cw,
    faStarfighterAlt: ew,
    faStars: aw,
    faStarship: nw,
    faStarshipFreighter: tw,
    faSteak: rw,
    faSteeringWheel: iw,
    faStepBackward: ow,
    faStepForward: lw,
    faStethoscope: fw,
    faStickyNote: sw,
    faStocking: uw,
    faStomach: hw,
    faStop: mw,
    faStopCircle: vw,
    faStopwatch: dw,
    faStopwatch20: Mw,
    faStore: pw,
    faStoreAlt: zw,
    faStoreAltSlash: Cw,
    faStoreSlash: Lw,
    faStream: Aw,
    faStreetView: Nw,
    faStretcher: gw,
    faStrikethrough: Hw,
    faStroopwafel: Vw,
    faSubscript: xw,
    faSubway: ww,
    faSuitcase: yw,
    faSuitcaseRolling: bw,
    faSun: Sw,
    faSunCloud: Tw,
    faSunDust: Dw,
    faSunHaze: jw,
    faSunglasses: Ew,
    faSunrise: kw,
    faSunset: Iw,
    faSuperscript: Ow,
    faSurprise: Qw,
    faSwatchbook: Zw,
    faSwimmer: Uw,
    faSwimmingPool: Bw,
    faSword: Rw,
    faSwordLaser: Yw,
    faSwordLaserAlt: Pw,
    faSwords: Fw,
    faSwordsLaser: Ww,
    faSynagogue: Gw,
    faSync: qw,
    faSyncAlt: Jw,
    faSyringe: Kw,
    faTable: Xw,
    faTableTennis: _w,
    faTablet: $w,
    faTabletAlt: cy,
    faTabletAndroid: ey,
    faTabletAndroidAlt: ay,
    faTabletRugged: ny,
    faTablets: ty,
    faTachometer: ry,
    faTachometerAlt: iy,
    faTachometerAltAverage: oy,
    faTachometerAltFast: ly,
    faTachometerAltFastest: fy,
    faTachometerAltSlow: sy,
    faTachometerAltSlowest: uy,
    faTachometerAverage: hy,
    faTachometerFast: my,
    faTachometerFastest: vy,
    faTachometerSlow: dy,
    faTachometerSlowest: My,
    faTaco: py,
    faTag: zy,
    faTags: Cy,
    faTally: Ly,
    faTanakh: Ay,
    faTape: Ny,
    faTasks: gy,
    faTasksAlt: Hy,
    faTaxi: Vy,
    faTeeth: xy,
    faTeethOpen: wy,
    faTelescope: yy,
    faTemperatureDown: by,
    faTemperatureFrigid: Sy,
    faTemperatureHigh: Ty,
    faTemperatureHot: Dy,
    faTemperatureLow: jy,
    faTemperatureUp: Ey,
    faTenge: ky,
    faTennisBall: Iy,
    faTerminal: Oy,
    faText: Qy,
    faTextHeight: Zy,
    faTextSize: Uy,
    faTextWidth: By,
    faTh: Ry,
    faThLarge: Yy,
    faThList: Py,
    faTheaterMasks: Fy,
    faThermometer: Wy,
    faThermometerEmpty: Gy,
    faThermometerFull: qy,
    faThermometerHalf: Jy,
    faThermometerQuarter: Ky,
    faThermometerThreeQuarters: Xy,
    faTheta: _y,
    faThumbsDown: $y,
    faThumbsUp: cb,
    faThumbtack: eb,
    faThunderstorm: ab,
    faThunderstormMoon: nb,
    faThunderstormSun: tb,
    faTicket: rb,
    faTicketAlt: ib,
    faTilde: ob,
    faTimes: lb,
    faTimesCircle: fb,
    faTimesHexagon: sb,
    faTimesOctagon: ub,
    faTimesSquare: hb,
    faTint: mb,
    faTintSlash: vb,
    faTire: db,
    faTireFlat: Mb,
    faTirePressureWarning: pb,
    faTireRugged: zb,
    faTired: Cb,
    faToggleOff: Lb,
    faToggleOn: Ab,
    faToilet: Nb,
    faToiletPaper: gb,
    faToiletPaperAlt: Hb,
    faToiletPaperSlash: Vb,
    faTombstone: xb,
    faTombstoneAlt: wb,
    faToolbox: yb,
    faTools: bb,
    faTooth: Sb,
    faToothbrush: Tb,
    faTorah: Db,
    faToriiGate: jb,
    faTornado: Eb,
    faTractor: kb,
    faTrademark: Ib,
    faTrafficCone: Ob,
    faTrafficLight: Qb,
    faTrafficLightGo: Zb,
    faTrafficLightSlow: Ub,
    faTrafficLightStop: Bb,
    faTrailer: Rb,
    faTrain: Yb,
    faTram: Pb,
    faTransgender: Fb,
    faTransgenderAlt: Wb,
    faTransporter: Gb,
    faTransporter1: qb,
    faTransporter2: Jb,
    faTransporter3: Kb,
    faTransporterEmpty: Xb,
    faTrash: _b,
    faTrashAlt: $b,
    faTrashRestore: cS,
    faTrashRestoreAlt: eS,
    faTrashUndo: aS,
    faTrashUndoAlt: nS,
    faTreasureChest: tS,
    faTree: rS,
    faTreeAlt: iS,
    faTreeChristmas: oS,
    faTreeDecorated: lS,
    faTreeLarge: fS,
    faTreePalm: sS,
    faTrees: uS,
    faTriangle: hS,
    faTriangleMusic: mS,
    faTrophy: vS,
    faTrophyAlt: dS,
    faTruck: MS,
    faTruckContainer: pS,
    faTruckCouch: zS,
    faTruckLoading: CS,
    faTruckMonster: LS,
    faTruckMoving: AS,
    faTruckPickup: NS,
    faTruckPlow: gS,
    faTruckRamp: HS,
    faTrumpet: VS,
    faTshirt: xS,
    faTty: wS,
    faTurkey: yS,
    faTurntable: bS,
    faTurtle: SS,
    faTv: TS,
    faTvAlt: DS,
    faTvMusic: jS,
    faTvRetro: ES,
    faTypewriter: kS,
    faUfo: IS,
    faUfoBeam: OS,
    faUmbrella: QS,
    faUmbrellaBeach: ZS,
    faUnderline: US,
    faUndo: BS,
    faUndoAlt: RS,
    faUnicorn: YS,
    faUnion: PS,
    faUniversalAccess: FS,
    faUniversity: WS,
    faUnlink: GS,
    faUnlock: qS,
    faUnlockAlt: JS,
    faUpload: KS,
    faUsbDrive: XS,
    faUsdCircle: _S,
    faUsdSquare: $S,
    faUser: cT,
    faUserAlien: eT,
    faUserAlt: aT,
    faUserAltSlash: nT,
    faUserAstronaut: tT,
    faUserChart: rT,
    faUserCheck: iT,
    faUserCircle: oT,
    faUserClock: lT,
    faUserCog: fT,
    faUserCowboy: sT,
    faUserCrown: uT,
    faUserEdit: hT,
    faUserFriends: mT,
    faUserGraduate: vT,
    faUserHardHat: dT,
    faUserHeadset: MT,
    faUserInjured: pT,
    faUserLock: zT,
    faUserMd: CT,
    faUserMdChat: LT,
    faUserMinus: AT,
    faUserMusic: NT,
    faUserNinja: gT,
    faUserNurse: HT,
    faUserPlus: VT,
    faUserRobot: xT,
    faUserSecret: wT,
    faUserShield: yT,
    faUserSlash: bT,
    faUserTag: ST,
    faUserTie: TT,
    faUserTimes: DT,
    faUserUnlock: jT,
    faUserVisor: ET,
    faUsers: kT,
    faUsersClass: IT,
    faUsersCog: OT,
    faUsersCrown: QT,
    faUsersMedical: ZT,
    faUsersSlash: UT,
    faUtensilFork: BT,
    faUtensilKnife: RT,
    faUtensilSpoon: YT,
    faUtensils: PT,
    faUtensilsAlt: FT,
    faVacuum: WT,
    faVacuumRobot: GT,
    faValueAbsolute: qT,
    faVectorSquare: JT,
    faVenus: KT,
    faVenusDouble: XT,
    faVenusMars: _T,
    faVest: $T,
    faVestPatches: cD,
    faVhs: eD,
    faVial: aD,
    faVials: nD,
    faVideo: tD,
    faVideoPlus: rD,
    faVideoSlash: iD,
    faVihara: oD,
    faViolin: lD,
    faVirus: fD,
    faVirusSlash: sD,
    faViruses: uD,
    faVoicemail: hD,
    faVolcano: mD,
    faVolleyballBall: vD,
    faVolume: dD,
    faVolumeDown: MD,
    faVolumeMute: pD,
    faVolumeOff: zD,
    faVolumeSlash: CD,
    faVolumeUp: LD,
    faVoteNay: AD,
    faVoteYea: ND,
    faVrCardboard: gD,
    faWagonCovered: HD,
    faWalker: VD,
    faWalkieTalkie: xD,
    faWalking: wD,
    faWallet: yD,
    faWand: bD,
    faWandMagic: SD,
    faWarehouse: TD,
    faWarehouseAlt: DD,
    faWasher: jD,
    faWatch: ED,
    faWatchCalculator: kD,
    faWatchFitness: ID,
    faWater: OD,
    faWaterLower: QD,
    faWaterRise: ZD,
    faWaveSine: UD,
    faWaveSquare: BD,
    faWaveTriangle: RD,
    faWaveform: YD,
    faWaveformPath: PD,
    faWebcam: FD,
    faWebcamSlash: WD,
    faWeight: GD,
    faWeightHanging: qD,
    faWhale: JD,
    faWheat: KD,
    faWheelchair: XD,
    faWhistle: _D,
    faWifi: $D,
    faWifi1: cj,
    faWifi2: ej,
    faWifiSlash: aj,
    faWind: nj,
    faWindTurbine: tj,
    faWindWarning: rj,
    faWindow: ij,
    faWindowAlt: oj,
    faWindowClose: lj,
    faWindowFrame: fj,
    faWindowFrameOpen: sj,
    faWindowMaximize: uj,
    faWindowMinimize: hj,
    faWindowRestore: mj,
    faWindsock: vj,
    faWineBottle: dj,
    faWineGlass: Mj,
    faWineGlassAlt: pj,
    faWonSign: zj,
    faWreath: Cj,
    faWrench: Lj,
    faXRay: Aj,
    faYenSign: Nj,
    faYinYang: gj
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = l(t),
      i = l(a(21)),
      o = a(82);

  function l(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var f = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.PureComponent), n(e, [{
      key: "regionDialog",
      value: function value() {
        var c = this.props.t;
        return r.default.createElement(i.default, {
          icon: o.faQuestionCircle
        }, r.default.createElement("small", null, r.default.createElement("p", null, c("priceExplanation:regionInfo")), r.default.createElement("p", null, c("priceExplanation:region0Text")), r.default.createElement("p", null, c("priceExplanation:region1Text")), r.default.createElement("p", null, c("priceExplanation:region2Text")), r.default.createElement("p", null, c("priceExplanation:region3Text")), r.default.createElement("p", null, c("priceExplanation:region4Text")), r.default.createElement("table", null, [{
          state: "GA",
          cities: ["ATLANTA"]
        }, {
          state: "TX",
          cities: ["AUSTIN", "DALLAS", "FORT WORTH", "HOUSTON", "SAN ANTONIO"]
        }, {
          state: "MA",
          cities: ["BOSTON"]
        }, {
          state: "OH",
          cities: ["CLEVELAND"]
        }, {
          state: "CO",
          cities: ["DENVER", "COLORADO SPRINGS"]
        }, {
          state: "MI",
          cities: ["DETROIT"]
        }, {
          state: "MO",
          cities: ["KANSAS CITY", "ST LOUIS"]
        }, {
          state: "NV",
          cities: ["LAS VEGAS", "RENO"]
        }, {
          state: "TN",
          cities: ["MEMPHIS", "NASHVILLE"]
        }, {
          state: "FL",
          cities: ["MIAMI", "FORT LAUDERDALE"]
        }, {
          state: "WI",
          cities: ["MILWAUKEE", "MADISON"]
        }, {
          state: "MN",
          cities: ["MINNEAPOLIS", "ST PAUL", "SAINT PAUL"]
        }, {
          state: "PA",
          cities: ["PHILADELPHIA", "PITTSBURGH"]
        }, {
          state: "OR",
          cities: ["PORTLAND"]
        }, {
          state: "UT",
          cities: ["SALT LAKE CITY"]
        }, {
          state: "WA",
          cities: ["SEATTLE"]
        }].map(function (c) {
          return r.default.createElement("tr", null, r.default.createElement("td", null, c.state), r.default.createElement("td", null, c.cities.join(", ")));
        })), r.default.createElement("p", null, c("priceExplanation:region5Text")), r.default.createElement("table", null, [{
          state: "IL",
          cities: ["CHICAGO"]
        }, {
          state: "CA",
          cities: ["LOS ANGELES", "SAN DIEGO", "SAN FRANCISCO"]
        }, {
          state: "TX",
          cities: ["MIDLAND", "ODESSA"]
        }, {
          state: "NY",
          cities: ["NEW YORK"]
        }, {
          state: "MD",
          cities: ["BALTIMORE"]
        }, {
          state: "ND",
          cities: ["BISMARK", "MINOT", "DICKINSON", "WILLISTON"]
        }].map(function (c) {
          return r.default.createElement("tr", null, r.default.createElement("td", null, c.state), r.default.createElement("td", null, c.cities.join(", ")));
        }))));
      }
    }, {
      key: "shopPricingLogic",
      value: function value(c) {
        var e = this.props.t;
        return c.used_shop_labor_rate ? e("priceExplanation:shopLaborRateDesc", {
          shop_labor_rate: c.shop_labor_rate,
          shop_price_estimate: c.shop_price_estimate
        }) : c.used_statistical_model ? e("priceExplanation:statisticalModelDesc", {
          shop_price_estimate: c.shop_price_estimate,
          statistical_estimate_stdev: c.statistical_estimate_stdev
        }) : e("priceExplanation:shopPricingEntryDesc", {
          shop_pricing_id: c.shop_pricing_id,
          shop_price_estimate: c.shop_price_estimate
        });
      }
    }, {
      key: "render",
      value: function value() {
        var c = this.props.t,
            e = this.props.pe;
        return r.default.createElement("div", null, r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:markupUsedLbl")), " ", e.markup, "%"), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:serviceDefinitionLbl")), " ", e.service_definition_id), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:regionUsedLbl"), this.regionDialog(), ":"), " ", e.region_id_used), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:baseVehicleServiceLbl")), " ", e.base_vehicle_service_id), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:fallbackBaseVehicleServiceLbl")), " ", e.fallback_base_vehicle_service_id), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:oemPartsLbl")), " $", e.oem_parts, " - from ", e.base_vehicle_service && e.base_vehicle_service.base_vehicle_service_prices.map(function (c) {
          return c.name + " - " + c.position + " - $" + c.price;
        }).join(", ")), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:oemManHoursLbl")), " ", e.oem_labor, " man-hours"), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:savedLbl")), " ", e.saved), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:extraQuartsLbl")), " ", e.extra_quarts), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:extraQuartsPriceLbl")), " ", e.extra_quarts_price), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:retailPricingLogicLbl")), " ", e.used_retail_labor_rate ? c("priceExplanation:retailPricingDesc1", {
          retail_labor_rate: e.retail_labor_rate,
          retail_price_estimate: e.retail_price_estimate
        }) : c("priceExplanation:retailPricingDesc2", {
          retail_pricing_id: e.retail_pricing_id,
          retail_price_estimate: e.retail_price_estimate
        })), e.used_retail_labor_rate && r.default.createElement("small", null, c("priceExplanation:mathHereIsLbl"), " ", e.retail_labor_rate, "*", e.oem_labor, " + ", e.oem_parts, " = ", e.retail_price_estimate), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:shopPricingLbl")), " ", this.shopPricingLogic(e)), e.used_shop_labor_rate && r.default.createElement("small", null, c("priceExplanation:mathHereIsLbl"), " ", e.shop_labor_rate, "*", e.oem_labor, " + ", e.oem_parts, " = ", e.shop_price_estimate), r.default.createElement("p", null, r.default.createElement("strong", null, "N: ", e.n)), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:laborAvgLbl"), " ", e.labor_average)), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:partsAvgLbl"), " ", e.parts_average)), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:partsStdevLbl"), " ", e.parts_stdev)), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:laborStdevLbl"), " ", e.labor_stdev)), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:estimateLbl"), " ", e.statistical_estimate)), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:stdevLbl"), " ", e.statistical_estimate_stdev)), r.default.createElement("p", null, r.default.createElement("strong", null, c("priceExplanation:significantLbl"), " ", e.significant)));
      }
    }]), e;
  }();

  e.default = f;
}, function (c, e, a) {
  "use strict";

  a.r(e), a.d(e, "fas", function () {
    return Hj;
  }), a.d(e, "prefix", function () {
    return n;
  }), a.d(e, "faAbacus", function () {
    return t;
  }), a.d(e, "faAcorn", function () {
    return r;
  }), a.d(e, "faAd", function () {
    return i;
  }), a.d(e, "faAddressBook", function () {
    return o;
  }), a.d(e, "faAddressCard", function () {
    return l;
  }), a.d(e, "faAdjust", function () {
    return f;
  }), a.d(e, "faAirConditioner", function () {
    return s;
  }), a.d(e, "faAirFreshener", function () {
    return u;
  }), a.d(e, "faAlarmClock", function () {
    return h;
  }), a.d(e, "faAlarmExclamation", function () {
    return m;
  }), a.d(e, "faAlarmPlus", function () {
    return v;
  }), a.d(e, "faAlarmSnooze", function () {
    return d;
  }), a.d(e, "faAlbum", function () {
    return M;
  }), a.d(e, "faAlbumCollection", function () {
    return p;
  }), a.d(e, "faAlicorn", function () {
    return z;
  }), a.d(e, "faAlien", function () {
    return C;
  }), a.d(e, "faAlienMonster", function () {
    return L;
  }), a.d(e, "faAlignCenter", function () {
    return A;
  }), a.d(e, "faAlignJustify", function () {
    return N;
  }), a.d(e, "faAlignLeft", function () {
    return g;
  }), a.d(e, "faAlignRight", function () {
    return H;
  }), a.d(e, "faAlignSlash", function () {
    return V;
  }), a.d(e, "faAllergies", function () {
    return x;
  }), a.d(e, "faAmbulance", function () {
    return w;
  }), a.d(e, "faAmericanSignLanguageInterpreting", function () {
    return y;
  }), a.d(e, "faAmpGuitar", function () {
    return b;
  }), a.d(e, "faAnalytics", function () {
    return S;
  }), a.d(e, "faAnchor", function () {
    return T;
  }), a.d(e, "faAngel", function () {
    return D;
  }), a.d(e, "faAngleDoubleDown", function () {
    return j;
  }), a.d(e, "faAngleDoubleLeft", function () {
    return E;
  }), a.d(e, "faAngleDoubleRight", function () {
    return k;
  }), a.d(e, "faAngleDoubleUp", function () {
    return I;
  }), a.d(e, "faAngleDown", function () {
    return O;
  }), a.d(e, "faAngleLeft", function () {
    return Q;
  }), a.d(e, "faAngleRight", function () {
    return Z;
  }), a.d(e, "faAngleUp", function () {
    return U;
  }), a.d(e, "faAngry", function () {
    return B;
  }), a.d(e, "faAnkh", function () {
    return R;
  }), a.d(e, "faAppleAlt", function () {
    return Y;
  }), a.d(e, "faAppleCrate", function () {
    return P;
  }), a.d(e, "faArchive", function () {
    return F;
  }), a.d(e, "faArchway", function () {
    return W;
  }), a.d(e, "faArrowAltCircleDown", function () {
    return G;
  }), a.d(e, "faArrowAltCircleLeft", function () {
    return q;
  }), a.d(e, "faArrowAltCircleRight", function () {
    return J;
  }), a.d(e, "faArrowAltCircleUp", function () {
    return K;
  }), a.d(e, "faArrowAltDown", function () {
    return X;
  }), a.d(e, "faArrowAltFromBottom", function () {
    return _;
  }), a.d(e, "faArrowAltFromLeft", function () {
    return $;
  }), a.d(e, "faArrowAltFromRight", function () {
    return cc;
  }), a.d(e, "faArrowAltFromTop", function () {
    return ec;
  }), a.d(e, "faArrowAltLeft", function () {
    return ac;
  }), a.d(e, "faArrowAltRight", function () {
    return nc;
  }), a.d(e, "faArrowAltSquareDown", function () {
    return tc;
  }), a.d(e, "faArrowAltSquareLeft", function () {
    return rc;
  }), a.d(e, "faArrowAltSquareRight", function () {
    return ic;
  }), a.d(e, "faArrowAltSquareUp", function () {
    return oc;
  }), a.d(e, "faArrowAltToBottom", function () {
    return lc;
  }), a.d(e, "faArrowAltToLeft", function () {
    return fc;
  }), a.d(e, "faArrowAltToRight", function () {
    return sc;
  }), a.d(e, "faArrowAltToTop", function () {
    return uc;
  }), a.d(e, "faArrowAltUp", function () {
    return hc;
  }), a.d(e, "faArrowCircleDown", function () {
    return mc;
  }), a.d(e, "faArrowCircleLeft", function () {
    return vc;
  }), a.d(e, "faArrowCircleRight", function () {
    return dc;
  }), a.d(e, "faArrowCircleUp", function () {
    return Mc;
  }), a.d(e, "faArrowDown", function () {
    return pc;
  }), a.d(e, "faArrowFromBottom", function () {
    return zc;
  }), a.d(e, "faArrowFromLeft", function () {
    return Cc;
  }), a.d(e, "faArrowFromRight", function () {
    return Lc;
  }), a.d(e, "faArrowFromTop", function () {
    return Ac;
  }), a.d(e, "faArrowLeft", function () {
    return Nc;
  }), a.d(e, "faArrowRight", function () {
    return gc;
  }), a.d(e, "faArrowSquareDown", function () {
    return Hc;
  }), a.d(e, "faArrowSquareLeft", function () {
    return Vc;
  }), a.d(e, "faArrowSquareRight", function () {
    return xc;
  }), a.d(e, "faArrowSquareUp", function () {
    return wc;
  }), a.d(e, "faArrowToBottom", function () {
    return yc;
  }), a.d(e, "faArrowToLeft", function () {
    return bc;
  }), a.d(e, "faArrowToRight", function () {
    return Sc;
  }), a.d(e, "faArrowToTop", function () {
    return Tc;
  }), a.d(e, "faArrowUp", function () {
    return Dc;
  }), a.d(e, "faArrows", function () {
    return jc;
  }), a.d(e, "faArrowsAlt", function () {
    return Ec;
  }), a.d(e, "faArrowsAltH", function () {
    return kc;
  }), a.d(e, "faArrowsAltV", function () {
    return Ic;
  }), a.d(e, "faArrowsH", function () {
    return Oc;
  }), a.d(e, "faArrowsV", function () {
    return Qc;
  }), a.d(e, "faAssistiveListeningSystems", function () {
    return Zc;
  }), a.d(e, "faAsterisk", function () {
    return Uc;
  }), a.d(e, "faAt", function () {
    return Bc;
  }), a.d(e, "faAtlas", function () {
    return Rc;
  }), a.d(e, "faAtom", function () {
    return Yc;
  }), a.d(e, "faAtomAlt", function () {
    return Pc;
  }), a.d(e, "faAudioDescription", function () {
    return Fc;
  }), a.d(e, "faAward", function () {
    return Wc;
  }), a.d(e, "faAxe", function () {
    return Gc;
  }), a.d(e, "faAxeBattle", function () {
    return qc;
  }), a.d(e, "faBaby", function () {
    return Jc;
  }), a.d(e, "faBabyCarriage", function () {
    return Kc;
  }), a.d(e, "faBackpack", function () {
    return Xc;
  }), a.d(e, "faBackspace", function () {
    return _c;
  }), a.d(e, "faBackward", function () {
    return $c;
  }), a.d(e, "faBacon", function () {
    return ce;
  }), a.d(e, "faBacteria", function () {
    return ee;
  }), a.d(e, "faBacterium", function () {
    return ae;
  }), a.d(e, "faBadge", function () {
    return ne;
  }), a.d(e, "faBadgeCheck", function () {
    return te;
  }), a.d(e, "faBadgeDollar", function () {
    return re;
  }), a.d(e, "faBadgePercent", function () {
    return ie;
  }), a.d(e, "faBadgeSheriff", function () {
    return oe;
  }), a.d(e, "faBadgerHoney", function () {
    return le;
  }), a.d(e, "faBagsShopping", function () {
    return fe;
  }), a.d(e, "faBahai", function () {
    return se;
  }), a.d(e, "faBalanceScale", function () {
    return ue;
  }), a.d(e, "faBalanceScaleLeft", function () {
    return he;
  }), a.d(e, "faBalanceScaleRight", function () {
    return me;
  }), a.d(e, "faBallPile", function () {
    return ve;
  }), a.d(e, "faBallot", function () {
    return de;
  }), a.d(e, "faBallotCheck", function () {
    return Me;
  }), a.d(e, "faBan", function () {
    return pe;
  }), a.d(e, "faBandAid", function () {
    return ze;
  }), a.d(e, "faBanjo", function () {
    return Ce;
  }), a.d(e, "faBarcode", function () {
    return Le;
  }), a.d(e, "faBarcodeAlt", function () {
    return Ae;
  }), a.d(e, "faBarcodeRead", function () {
    return Ne;
  }), a.d(e, "faBarcodeScan", function () {
    return ge;
  }), a.d(e, "faBars", function () {
    return He;
  }), a.d(e, "faBaseball", function () {
    return Ve;
  }), a.d(e, "faBaseballBall", function () {
    return xe;
  }), a.d(e, "faBasketballBall", function () {
    return we;
  }), a.d(e, "faBasketballHoop", function () {
    return ye;
  }), a.d(e, "faBat", function () {
    return be;
  }), a.d(e, "faBath", function () {
    return Se;
  }), a.d(e, "faBatteryBolt", function () {
    return Te;
  }), a.d(e, "faBatteryEmpty", function () {
    return De;
  }), a.d(e, "faBatteryFull", function () {
    return je;
  }), a.d(e, "faBatteryHalf", function () {
    return Ee;
  }), a.d(e, "faBatteryQuarter", function () {
    return ke;
  }), a.d(e, "faBatterySlash", function () {
    return Ie;
  }), a.d(e, "faBatteryThreeQuarters", function () {
    return Oe;
  }), a.d(e, "faBed", function () {
    return Qe;
  }), a.d(e, "faBedAlt", function () {
    return Ze;
  }), a.d(e, "faBedBunk", function () {
    return Ue;
  }), a.d(e, "faBedEmpty", function () {
    return Be;
  }), a.d(e, "faBeer", function () {
    return Re;
  }), a.d(e, "faBell", function () {
    return Ye;
  }), a.d(e, "faBellExclamation", function () {
    return Pe;
  }), a.d(e, "faBellOn", function () {
    return Fe;
  }), a.d(e, "faBellPlus", function () {
    return We;
  }), a.d(e, "faBellSchool", function () {
    return Ge;
  }), a.d(e, "faBellSchoolSlash", function () {
    return qe;
  }), a.d(e, "faBellSlash", function () {
    return Je;
  }), a.d(e, "faBells", function () {
    return Ke;
  }), a.d(e, "faBetamax", function () {
    return Xe;
  }), a.d(e, "faBezierCurve", function () {
    return _e;
  }), a.d(e, "faBible", function () {
    return $e;
  }), a.d(e, "faBicycle", function () {
    return ca;
  }), a.d(e, "faBiking", function () {
    return ea;
  }), a.d(e, "faBikingMountain", function () {
    return aa;
  }), a.d(e, "faBinoculars", function () {
    return na;
  }), a.d(e, "faBiohazard", function () {
    return ta;
  }), a.d(e, "faBirthdayCake", function () {
    return ra;
  }), a.d(e, "faBlanket", function () {
    return ia;
  }), a.d(e, "faBlender", function () {
    return oa;
  }), a.d(e, "faBlenderPhone", function () {
    return la;
  }), a.d(e, "faBlind", function () {
    return fa;
  }), a.d(e, "faBlinds", function () {
    return sa;
  }), a.d(e, "faBlindsOpen", function () {
    return ua;
  }), a.d(e, "faBlindsRaised", function () {
    return ha;
  }), a.d(e, "faBlog", function () {
    return ma;
  }), a.d(e, "faBold", function () {
    return va;
  }), a.d(e, "faBolt", function () {
    return da;
  }), a.d(e, "faBomb", function () {
    return Ma;
  }), a.d(e, "faBone", function () {
    return pa;
  }), a.d(e, "faBoneBreak", function () {
    return za;
  }), a.d(e, "faBong", function () {
    return Ca;
  }), a.d(e, "faBook", function () {
    return La;
  }), a.d(e, "faBookAlt", function () {
    return Aa;
  }), a.d(e, "faBookDead", function () {
    return Na;
  }), a.d(e, "faBookHeart", function () {
    return ga;
  }), a.d(e, "faBookMedical", function () {
    return Ha;
  }), a.d(e, "faBookOpen", function () {
    return Va;
  }), a.d(e, "faBookReader", function () {
    return xa;
  }), a.d(e, "faBookSpells", function () {
    return wa;
  }), a.d(e, "faBookUser", function () {
    return ya;
  }), a.d(e, "faBookmark", function () {
    return ba;
  }), a.d(e, "faBooks", function () {
    return Sa;
  }), a.d(e, "faBooksMedical", function () {
    return Ta;
  }), a.d(e, "faBoombox", function () {
    return Da;
  }), a.d(e, "faBoot", function () {
    return ja;
  }), a.d(e, "faBoothCurtain", function () {
    return Ea;
  }), a.d(e, "faBorderAll", function () {
    return ka;
  }), a.d(e, "faBorderBottom", function () {
    return Ia;
  }), a.d(e, "faBorderCenterH", function () {
    return Oa;
  }), a.d(e, "faBorderCenterV", function () {
    return Qa;
  }), a.d(e, "faBorderInner", function () {
    return Za;
  }), a.d(e, "faBorderLeft", function () {
    return Ua;
  }), a.d(e, "faBorderNone", function () {
    return Ba;
  }), a.d(e, "faBorderOuter", function () {
    return Ra;
  }), a.d(e, "faBorderRight", function () {
    return Ya;
  }), a.d(e, "faBorderStyle", function () {
    return Pa;
  }), a.d(e, "faBorderStyleAlt", function () {
    return Fa;
  }), a.d(e, "faBorderTop", function () {
    return Wa;
  }), a.d(e, "faBowArrow", function () {
    return Ga;
  }), a.d(e, "faBowlingBall", function () {
    return qa;
  }), a.d(e, "faBowlingPins", function () {
    return Ja;
  }), a.d(e, "faBox", function () {
    return Ka;
  }), a.d(e, "faBoxAlt", function () {
    return Xa;
  }), a.d(e, "faBoxBallot", function () {
    return _a;
  }), a.d(e, "faBoxCheck", function () {
    return $a;
  }), a.d(e, "faBoxFragile", function () {
    return cn;
  }), a.d(e, "faBoxFull", function () {
    return en;
  }), a.d(e, "faBoxHeart", function () {
    return an;
  }), a.d(e, "faBoxOpen", function () {
    return nn;
  }), a.d(e, "faBoxTissue", function () {
    return tn;
  }), a.d(e, "faBoxUp", function () {
    return rn;
  }), a.d(e, "faBoxUsd", function () {
    return on;
  }), a.d(e, "faBoxes", function () {
    return ln;
  }), a.d(e, "faBoxesAlt", function () {
    return fn;
  }), a.d(e, "faBoxingGlove", function () {
    return sn;
  }), a.d(e, "faBrackets", function () {
    return un;
  }), a.d(e, "faBracketsCurly", function () {
    return hn;
  }), a.d(e, "faBraille", function () {
    return mn;
  }), a.d(e, "faBrain", function () {
    return vn;
  }), a.d(e, "faBreadLoaf", function () {
    return dn;
  }), a.d(e, "faBreadSlice", function () {
    return Mn;
  }), a.d(e, "faBriefcase", function () {
    return pn;
  }), a.d(e, "faBriefcaseMedical", function () {
    return zn;
  }), a.d(e, "faBringForward", function () {
    return Cn;
  }), a.d(e, "faBringFront", function () {
    return Ln;
  }), a.d(e, "faBroadcastTower", function () {
    return An;
  }), a.d(e, "faBroom", function () {
    return Nn;
  }), a.d(e, "faBrowser", function () {
    return gn;
  }), a.d(e, "faBrush", function () {
    return Hn;
  }), a.d(e, "faBug", function () {
    return Vn;
  }), a.d(e, "faBuilding", function () {
    return xn;
  }), a.d(e, "faBullhorn", function () {
    return wn;
  }), a.d(e, "faBullseye", function () {
    return yn;
  }), a.d(e, "faBullseyeArrow", function () {
    return bn;
  }), a.d(e, "faBullseyePointer", function () {
    return Sn;
  }), a.d(e, "faBurgerSoda", function () {
    return Tn;
  }), a.d(e, "faBurn", function () {
    return Dn;
  }), a.d(e, "faBurrito", function () {
    return jn;
  }), a.d(e, "faBus", function () {
    return En;
  }), a.d(e, "faBusAlt", function () {
    return kn;
  }), a.d(e, "faBusSchool", function () {
    return In;
  }), a.d(e, "faBusinessTime", function () {
    return On;
  }), a.d(e, "faCabinetFiling", function () {
    return Qn;
  }), a.d(e, "faCactus", function () {
    return Zn;
  }), a.d(e, "faCalculator", function () {
    return Un;
  }), a.d(e, "faCalculatorAlt", function () {
    return Bn;
  }), a.d(e, "faCalendar", function () {
    return Rn;
  }), a.d(e, "faCalendarAlt", function () {
    return Yn;
  }), a.d(e, "faCalendarCheck", function () {
    return Pn;
  }), a.d(e, "faCalendarDay", function () {
    return Fn;
  }), a.d(e, "faCalendarEdit", function () {
    return Wn;
  }), a.d(e, "faCalendarExclamation", function () {
    return Gn;
  }), a.d(e, "faCalendarMinus", function () {
    return qn;
  }), a.d(e, "faCalendarPlus", function () {
    return Jn;
  }), a.d(e, "faCalendarStar", function () {
    return Kn;
  }), a.d(e, "faCalendarTimes", function () {
    return Xn;
  }), a.d(e, "faCalendarWeek", function () {
    return _n;
  }), a.d(e, "faCamcorder", function () {
    return $n;
  }), a.d(e, "faCamera", function () {
    return ct;
  }), a.d(e, "faCameraAlt", function () {
    return et;
  }), a.d(e, "faCameraHome", function () {
    return at;
  }), a.d(e, "faCameraMovie", function () {
    return nt;
  }), a.d(e, "faCameraPolaroid", function () {
    return tt;
  }), a.d(e, "faCameraRetro", function () {
    return rt;
  }), a.d(e, "faCampfire", function () {
    return it;
  }), a.d(e, "faCampground", function () {
    return ot;
  }), a.d(e, "faCandleHolder", function () {
    return lt;
  }), a.d(e, "faCandyCane", function () {
    return ft;
  }), a.d(e, "faCandyCorn", function () {
    return st;
  }), a.d(e, "faCannabis", function () {
    return ut;
  }), a.d(e, "faCapsules", function () {
    return ht;
  }), a.d(e, "faCar", function () {
    return mt;
  }), a.d(e, "faCarAlt", function () {
    return vt;
  }), a.d(e, "faCarBattery", function () {
    return dt;
  }), a.d(e, "faCarBuilding", function () {
    return Mt;
  }), a.d(e, "faCarBump", function () {
    return pt;
  }), a.d(e, "faCarBus", function () {
    return zt;
  }), a.d(e, "faCarCrash", function () {
    return Ct;
  }), a.d(e, "faCarGarage", function () {
    return Lt;
  }), a.d(e, "faCarMechanic", function () {
    return At;
  }), a.d(e, "faCarSide", function () {
    return Nt;
  }), a.d(e, "faCarTilt", function () {
    return gt;
  }), a.d(e, "faCarWash", function () {
    return Ht;
  }), a.d(e, "faCaravan", function () {
    return Vt;
  }), a.d(e, "faCaravanAlt", function () {
    return xt;
  }), a.d(e, "faCaretCircleDown", function () {
    return wt;
  }), a.d(e, "faCaretCircleLeft", function () {
    return yt;
  }), a.d(e, "faCaretCircleRight", function () {
    return bt;
  }), a.d(e, "faCaretCircleUp", function () {
    return St;
  }), a.d(e, "faCaretDown", function () {
    return Tt;
  }), a.d(e, "faCaretLeft", function () {
    return Dt;
  }), a.d(e, "faCaretRight", function () {
    return jt;
  }), a.d(e, "faCaretSquareDown", function () {
    return Et;
  }), a.d(e, "faCaretSquareLeft", function () {
    return kt;
  }), a.d(e, "faCaretSquareRight", function () {
    return It;
  }), a.d(e, "faCaretSquareUp", function () {
    return Ot;
  }), a.d(e, "faCaretUp", function () {
    return Qt;
  }), a.d(e, "faCarrot", function () {
    return Zt;
  }), a.d(e, "faCars", function () {
    return Ut;
  }), a.d(e, "faCartArrowDown", function () {
    return Bt;
  }), a.d(e, "faCartPlus", function () {
    return Rt;
  }), a.d(e, "faCashRegister", function () {
    return Yt;
  }), a.d(e, "faCassetteTape", function () {
    return Pt;
  }), a.d(e, "faCat", function () {
    return Ft;
  }), a.d(e, "faCatSpace", function () {
    return Wt;
  }), a.d(e, "faCauldron", function () {
    return Gt;
  }), a.d(e, "faCctv", function () {
    return qt;
  }), a.d(e, "faCertificate", function () {
    return Jt;
  }), a.d(e, "faChair", function () {
    return Kt;
  }), a.d(e, "faChairOffice", function () {
    return Xt;
  }), a.d(e, "faChalkboard", function () {
    return _t;
  }), a.d(e, "faChalkboardTeacher", function () {
    return $t;
  }), a.d(e, "faChargingStation", function () {
    return cr;
  }), a.d(e, "faChartArea", function () {
    return er;
  }), a.d(e, "faChartBar", function () {
    return ar;
  }), a.d(e, "faChartLine", function () {
    return nr;
  }), a.d(e, "faChartLineDown", function () {
    return tr;
  }), a.d(e, "faChartNetwork", function () {
    return rr;
  }), a.d(e, "faChartPie", function () {
    return ir;
  }), a.d(e, "faChartPieAlt", function () {
    return or;
  }), a.d(e, "faChartScatter", function () {
    return lr;
  }), a.d(e, "faCheck", function () {
    return fr;
  }), a.d(e, "faCheckCircle", function () {
    return sr;
  }), a.d(e, "faCheckDouble", function () {
    return ur;
  }), a.d(e, "faCheckSquare", function () {
    return hr;
  }), a.d(e, "faCheese", function () {
    return mr;
  }), a.d(e, "faCheeseSwiss", function () {
    return vr;
  }), a.d(e, "faCheeseburger", function () {
    return dr;
  }), a.d(e, "faChess", function () {
    return Mr;
  }), a.d(e, "faChessBishop", function () {
    return pr;
  }), a.d(e, "faChessBishopAlt", function () {
    return zr;
  }), a.d(e, "faChessBoard", function () {
    return Cr;
  }), a.d(e, "faChessClock", function () {
    return Lr;
  }), a.d(e, "faChessClockAlt", function () {
    return Ar;
  }), a.d(e, "faChessKing", function () {
    return Nr;
  }), a.d(e, "faChessKingAlt", function () {
    return gr;
  }), a.d(e, "faChessKnight", function () {
    return Hr;
  }), a.d(e, "faChessKnightAlt", function () {
    return Vr;
  }), a.d(e, "faChessPawn", function () {
    return xr;
  }), a.d(e, "faChessPawnAlt", function () {
    return wr;
  }), a.d(e, "faChessQueen", function () {
    return yr;
  }), a.d(e, "faChessQueenAlt", function () {
    return br;
  }), a.d(e, "faChessRook", function () {
    return Sr;
  }), a.d(e, "faChessRookAlt", function () {
    return Tr;
  }), a.d(e, "faChevronCircleDown", function () {
    return Dr;
  }), a.d(e, "faChevronCircleLeft", function () {
    return jr;
  }), a.d(e, "faChevronCircleRight", function () {
    return Er;
  }), a.d(e, "faChevronCircleUp", function () {
    return kr;
  }), a.d(e, "faChevronDoubleDown", function () {
    return Ir;
  }), a.d(e, "faChevronDoubleLeft", function () {
    return Or;
  }), a.d(e, "faChevronDoubleRight", function () {
    return Qr;
  }), a.d(e, "faChevronDoubleUp", function () {
    return Zr;
  }), a.d(e, "faChevronDown", function () {
    return Ur;
  }), a.d(e, "faChevronLeft", function () {
    return Br;
  }), a.d(e, "faChevronRight", function () {
    return Rr;
  }), a.d(e, "faChevronSquareDown", function () {
    return Yr;
  }), a.d(e, "faChevronSquareLeft", function () {
    return Pr;
  }), a.d(e, "faChevronSquareRight", function () {
    return Fr;
  }), a.d(e, "faChevronSquareUp", function () {
    return Wr;
  }), a.d(e, "faChevronUp", function () {
    return Gr;
  }), a.d(e, "faChild", function () {
    return qr;
  }), a.d(e, "faChimney", function () {
    return Jr;
  }), a.d(e, "faChurch", function () {
    return Kr;
  }), a.d(e, "faCircle", function () {
    return Xr;
  }), a.d(e, "faCircleNotch", function () {
    return _r;
  }), a.d(e, "faCity", function () {
    return $r;
  }), a.d(e, "faClarinet", function () {
    return ci;
  }), a.d(e, "faClawMarks", function () {
    return ei;
  }), a.d(e, "faClinicMedical", function () {
    return ai;
  }), a.d(e, "faClipboard", function () {
    return ni;
  }), a.d(e, "faClipboardCheck", function () {
    return ti;
  }), a.d(e, "faClipboardList", function () {
    return ri;
  }), a.d(e, "faClipboardListCheck", function () {
    return ii;
  }), a.d(e, "faClipboardPrescription", function () {
    return oi;
  }), a.d(e, "faClipboardUser", function () {
    return li;
  }), a.d(e, "faClock", function () {
    return fi;
  }), a.d(e, "faClone", function () {
    return si;
  }), a.d(e, "faClosedCaptioning", function () {
    return ui;
  }), a.d(e, "faCloud", function () {
    return hi;
  }), a.d(e, "faCloudDownload", function () {
    return mi;
  }), a.d(e, "faCloudDownloadAlt", function () {
    return vi;
  }), a.d(e, "faCloudDrizzle", function () {
    return di;
  }), a.d(e, "faCloudHail", function () {
    return Mi;
  }), a.d(e, "faCloudHailMixed", function () {
    return pi;
  }), a.d(e, "faCloudMeatball", function () {
    return zi;
  }), a.d(e, "faCloudMoon", function () {
    return Ci;
  }), a.d(e, "faCloudMoonRain", function () {
    return Li;
  }), a.d(e, "faCloudMusic", function () {
    return Ai;
  }), a.d(e, "faCloudRain", function () {
    return Ni;
  }), a.d(e, "faCloudRainbow", function () {
    return gi;
  }), a.d(e, "faCloudShowers", function () {
    return Hi;
  }), a.d(e, "faCloudShowersHeavy", function () {
    return Vi;
  }), a.d(e, "faCloudSleet", function () {
    return xi;
  }), a.d(e, "faCloudSnow", function () {
    return wi;
  }), a.d(e, "faCloudSun", function () {
    return yi;
  }), a.d(e, "faCloudSunRain", function () {
    return bi;
  }), a.d(e, "faCloudUpload", function () {
    return Si;
  }), a.d(e, "faCloudUploadAlt", function () {
    return Ti;
  }), a.d(e, "faClouds", function () {
    return Di;
  }), a.d(e, "faCloudsMoon", function () {
    return ji;
  }), a.d(e, "faCloudsSun", function () {
    return Ei;
  }), a.d(e, "faClub", function () {
    return ki;
  }), a.d(e, "faCocktail", function () {
    return Ii;
  }), a.d(e, "faCode", function () {
    return Oi;
  }), a.d(e, "faCodeBranch", function () {
    return Qi;
  }), a.d(e, "faCodeCommit", function () {
    return Zi;
  }), a.d(e, "faCodeMerge", function () {
    return Ui;
  }), a.d(e, "faCoffee", function () {
    return Bi;
  }), a.d(e, "faCoffeePot", function () {
    return Ri;
  }), a.d(e, "faCoffeeTogo", function () {
    return Yi;
  }), a.d(e, "faCoffin", function () {
    return Pi;
  }), a.d(e, "faCoffinCross", function () {
    return Fi;
  }), a.d(e, "faCog", function () {
    return Wi;
  }), a.d(e, "faCogs", function () {
    return Gi;
  }), a.d(e, "faCoin", function () {
    return qi;
  }), a.d(e, "faCoins", function () {
    return Ji;
  }), a.d(e, "faColumns", function () {
    return Ki;
  }), a.d(e, "faComet", function () {
    return Xi;
  }), a.d(e, "faComment", function () {
    return _i;
  }), a.d(e, "faCommentAlt", function () {
    return $i;
  }), a.d(e, "faCommentAltCheck", function () {
    return co;
  }), a.d(e, "faCommentAltDollar", function () {
    return eo;
  }), a.d(e, "faCommentAltDots", function () {
    return ao;
  }), a.d(e, "faCommentAltEdit", function () {
    return no;
  }), a.d(e, "faCommentAltExclamation", function () {
    return to;
  }), a.d(e, "faCommentAltLines", function () {
    return ro;
  }), a.d(e, "faCommentAltMedical", function () {
    return io;
  }), a.d(e, "faCommentAltMinus", function () {
    return oo;
  }), a.d(e, "faCommentAltMusic", function () {
    return lo;
  }), a.d(e, "faCommentAltPlus", function () {
    return fo;
  }), a.d(e, "faCommentAltSlash", function () {
    return so;
  }), a.d(e, "faCommentAltSmile", function () {
    return uo;
  }), a.d(e, "faCommentAltTimes", function () {
    return ho;
  }), a.d(e, "faCommentCheck", function () {
    return mo;
  }), a.d(e, "faCommentDollar", function () {
    return vo;
  }), a.d(e, "faCommentDots", function () {
    return Mo;
  }), a.d(e, "faCommentEdit", function () {
    return po;
  }), a.d(e, "faCommentExclamation", function () {
    return zo;
  }), a.d(e, "faCommentLines", function () {
    return Co;
  }), a.d(e, "faCommentMedical", function () {
    return Lo;
  }), a.d(e, "faCommentMinus", function () {
    return Ao;
  }), a.d(e, "faCommentMusic", function () {
    return No;
  }), a.d(e, "faCommentPlus", function () {
    return go;
  }), a.d(e, "faCommentSlash", function () {
    return Ho;
  }), a.d(e, "faCommentSmile", function () {
    return Vo;
  }), a.d(e, "faCommentTimes", function () {
    return xo;
  }), a.d(e, "faComments", function () {
    return wo;
  }), a.d(e, "faCommentsAlt", function () {
    return yo;
  }), a.d(e, "faCommentsAltDollar", function () {
    return bo;
  }), a.d(e, "faCommentsDollar", function () {
    return So;
  }), a.d(e, "faCompactDisc", function () {
    return To;
  }), a.d(e, "faCompass", function () {
    return Do;
  }), a.d(e, "faCompassSlash", function () {
    return jo;
  }), a.d(e, "faCompress", function () {
    return Eo;
  }), a.d(e, "faCompressAlt", function () {
    return ko;
  }), a.d(e, "faCompressArrowsAlt", function () {
    return Io;
  }), a.d(e, "faCompressWide", function () {
    return Oo;
  }), a.d(e, "faComputerClassic", function () {
    return Qo;
  }), a.d(e, "faComputerSpeaker", function () {
    return Zo;
  }), a.d(e, "faConciergeBell", function () {
    return Uo;
  }), a.d(e, "faConstruction", function () {
    return Bo;
  }), a.d(e, "faContainerStorage", function () {
    return Ro;
  }), a.d(e, "faConveyorBelt", function () {
    return Yo;
  }), a.d(e, "faConveyorBeltAlt", function () {
    return Po;
  }), a.d(e, "faCookie", function () {
    return Fo;
  }), a.d(e, "faCookieBite", function () {
    return Wo;
  }), a.d(e, "faCopy", function () {
    return Go;
  }), a.d(e, "faCopyright", function () {
    return qo;
  }), a.d(e, "faCorn", function () {
    return Jo;
  }), a.d(e, "faCouch", function () {
    return Ko;
  }), a.d(e, "faCow", function () {
    return Xo;
  }), a.d(e, "faCowbell", function () {
    return _o;
  }), a.d(e, "faCowbellMore", function () {
    return $o;
  }), a.d(e, "faCreditCard", function () {
    return cl;
  }), a.d(e, "faCreditCardBlank", function () {
    return el;
  }), a.d(e, "faCreditCardFront", function () {
    return al;
  }), a.d(e, "faCricket", function () {
    return nl;
  }), a.d(e, "faCroissant", function () {
    return tl;
  }), a.d(e, "faCrop", function () {
    return rl;
  }), a.d(e, "faCropAlt", function () {
    return il;
  }), a.d(e, "faCross", function () {
    return ol;
  }), a.d(e, "faCrosshairs", function () {
    return ll;
  }), a.d(e, "faCrow", function () {
    return fl;
  }), a.d(e, "faCrown", function () {
    return sl;
  }), a.d(e, "faCrutch", function () {
    return ul;
  }), a.d(e, "faCrutches", function () {
    return hl;
  }), a.d(e, "faCube", function () {
    return ml;
  }), a.d(e, "faCubes", function () {
    return vl;
  }), a.d(e, "faCurling", function () {
    return dl;
  }), a.d(e, "faCut", function () {
    return Ml;
  }), a.d(e, "faDagger", function () {
    return pl;
  }), a.d(e, "faDatabase", function () {
    return zl;
  }), a.d(e, "faDeaf", function () {
    return Cl;
  }), a.d(e, "faDebug", function () {
    return Ll;
  }), a.d(e, "faDeer", function () {
    return Al;
  }), a.d(e, "faDeerRudolph", function () {
    return Nl;
  }), a.d(e, "faDemocrat", function () {
    return gl;
  }), a.d(e, "faDesktop", function () {
    return Hl;
  }), a.d(e, "faDesktopAlt", function () {
    return Vl;
  }), a.d(e, "faDewpoint", function () {
    return xl;
  }), a.d(e, "faDharmachakra", function () {
    return wl;
  }), a.d(e, "faDiagnoses", function () {
    return yl;
  }), a.d(e, "faDiamond", function () {
    return bl;
  }), a.d(e, "faDice", function () {
    return Sl;
  }), a.d(e, "faDiceD10", function () {
    return Tl;
  }), a.d(e, "faDiceD12", function () {
    return Dl;
  }), a.d(e, "faDiceD20", function () {
    return jl;
  }), a.d(e, "faDiceD4", function () {
    return El;
  }), a.d(e, "faDiceD6", function () {
    return kl;
  }), a.d(e, "faDiceD8", function () {
    return Il;
  }), a.d(e, "faDiceFive", function () {
    return Ol;
  }), a.d(e, "faDiceFour", function () {
    return Ql;
  }), a.d(e, "faDiceOne", function () {
    return Zl;
  }), a.d(e, "faDiceSix", function () {
    return Ul;
  }), a.d(e, "faDiceThree", function () {
    return Bl;
  }), a.d(e, "faDiceTwo", function () {
    return Rl;
  }), a.d(e, "faDigging", function () {
    return Yl;
  }), a.d(e, "faDigitalTachograph", function () {
    return Pl;
  }), a.d(e, "faDiploma", function () {
    return Fl;
  }), a.d(e, "faDirections", function () {
    return Wl;
  }), a.d(e, "faDiscDrive", function () {
    return Gl;
  }), a.d(e, "faDisease", function () {
    return ql;
  }), a.d(e, "faDivide", function () {
    return Jl;
  }), a.d(e, "faDizzy", function () {
    return Kl;
  }), a.d(e, "faDna", function () {
    return Xl;
  }), a.d(e, "faDoNotEnter", function () {
    return _l;
  }), a.d(e, "faDog", function () {
    return $l;
  }), a.d(e, "faDogLeashed", function () {
    return cf;
  }), a.d(e, "faDollarSign", function () {
    return ef;
  }), a.d(e, "faDolly", function () {
    return af;
  }), a.d(e, "faDollyEmpty", function () {
    return nf;
  }), a.d(e, "faDollyFlatbed", function () {
    return tf;
  }), a.d(e, "faDollyFlatbedAlt", function () {
    return rf;
  }), a.d(e, "faDollyFlatbedEmpty", function () {
    return of;
  }), a.d(e, "faDonate", function () {
    return lf;
  }), a.d(e, "faDoorClosed", function () {
    return ff;
  }), a.d(e, "faDoorOpen", function () {
    return sf;
  }), a.d(e, "faDotCircle", function () {
    return uf;
  }), a.d(e, "faDove", function () {
    return hf;
  }), a.d(e, "faDownload", function () {
    return mf;
  }), a.d(e, "faDraftingCompass", function () {
    return vf;
  }), a.d(e, "faDragon", function () {
    return df;
  }), a.d(e, "faDrawCircle", function () {
    return Mf;
  }), a.d(e, "faDrawPolygon", function () {
    return pf;
  }), a.d(e, "faDrawSquare", function () {
    return zf;
  }), a.d(e, "faDreidel", function () {
    return Cf;
  }), a.d(e, "faDrone", function () {
    return Lf;
  }), a.d(e, "faDroneAlt", function () {
    return Af;
  }), a.d(e, "faDrum", function () {
    return Nf;
  }), a.d(e, "faDrumSteelpan", function () {
    return gf;
  }), a.d(e, "faDrumstick", function () {
    return Hf;
  }), a.d(e, "faDrumstickBite", function () {
    return Vf;
  }), a.d(e, "faDryer", function () {
    return xf;
  }), a.d(e, "faDryerAlt", function () {
    return wf;
  }), a.d(e, "faDuck", function () {
    return yf;
  }), a.d(e, "faDumbbell", function () {
    return bf;
  }), a.d(e, "faDumpster", function () {
    return Sf;
  }), a.d(e, "faDumpsterFire", function () {
    return Tf;
  }), a.d(e, "faDungeon", function () {
    return Df;
  }), a.d(e, "faEar", function () {
    return jf;
  }), a.d(e, "faEarMuffs", function () {
    return Ef;
  }), a.d(e, "faEclipse", function () {
    return kf;
  }), a.d(e, "faEclipseAlt", function () {
    return If;
  }), a.d(e, "faEdit", function () {
    return Of;
  }), a.d(e, "faEgg", function () {
    return Qf;
  }), a.d(e, "faEggFried", function () {
    return Zf;
  }), a.d(e, "faEject", function () {
    return Uf;
  }), a.d(e, "faElephant", function () {
    return Bf;
  }), a.d(e, "faEllipsisH", function () {
    return Rf;
  }), a.d(e, "faEllipsisHAlt", function () {
    return Yf;
  }), a.d(e, "faEllipsisV", function () {
    return Pf;
  }), a.d(e, "faEllipsisVAlt", function () {
    return Ff;
  }), a.d(e, "faEmptySet", function () {
    return Wf;
  }), a.d(e, "faEngineWarning", function () {
    return Gf;
  }), a.d(e, "faEnvelope", function () {
    return qf;
  }), a.d(e, "faEnvelopeOpen", function () {
    return Jf;
  }), a.d(e, "faEnvelopeOpenDollar", function () {
    return Kf;
  }), a.d(e, "faEnvelopeOpenText", function () {
    return Xf;
  }), a.d(e, "faEnvelopeSquare", function () {
    return _f;
  }), a.d(e, "faEquals", function () {
    return $f;
  }), a.d(e, "faEraser", function () {
    return cs;
  }), a.d(e, "faEthernet", function () {
    return es;
  }), a.d(e, "faEuroSign", function () {
    return as;
  }), a.d(e, "faExchange", function () {
    return ns;
  }), a.d(e, "faExchangeAlt", function () {
    return ts;
  }), a.d(e, "faExclamation", function () {
    return rs;
  }), a.d(e, "faExclamationCircle", function () {
    return is;
  }), a.d(e, "faExclamationSquare", function () {
    return os;
  }), a.d(e, "faExclamationTriangle", function () {
    return ls;
  }), a.d(e, "faExpand", function () {
    return fs;
  }), a.d(e, "faExpandAlt", function () {
    return ss;
  }), a.d(e, "faExpandArrows", function () {
    return us;
  }), a.d(e, "faExpandArrowsAlt", function () {
    return hs;
  }), a.d(e, "faExpandWide", function () {
    return ms;
  }), a.d(e, "faExternalLink", function () {
    return vs;
  }), a.d(e, "faExternalLinkAlt", function () {
    return ds;
  }), a.d(e, "faExternalLinkSquare", function () {
    return Ms;
  }), a.d(e, "faExternalLinkSquareAlt", function () {
    return ps;
  }), a.d(e, "faEye", function () {
    return zs;
  }), a.d(e, "faEyeDropper", function () {
    return Cs;
  }), a.d(e, "faEyeEvil", function () {
    return Ls;
  }), a.d(e, "faEyeSlash", function () {
    return As;
  }), a.d(e, "faFan", function () {
    return Ns;
  }), a.d(e, "faFanTable", function () {
    return gs;
  }), a.d(e, "faFarm", function () {
    return Hs;
  }), a.d(e, "faFastBackward", function () {
    return Vs;
  }), a.d(e, "faFastForward", function () {
    return xs;
  }), a.d(e, "faFaucet", function () {
    return ws;
  }), a.d(e, "faFaucetDrip", function () {
    return ys;
  }), a.d(e, "faFax", function () {
    return bs;
  }), a.d(e, "faFeather", function () {
    return Ss;
  }), a.d(e, "faFeatherAlt", function () {
    return Ts;
  }), a.d(e, "faFemale", function () {
    return Ds;
  }), a.d(e, "faFieldHockey", function () {
    return js;
  }), a.d(e, "faFighterJet", function () {
    return Es;
  }), a.d(e, "faFile", function () {
    return ks;
  }), a.d(e, "faFileAlt", function () {
    return Is;
  }), a.d(e, "faFileArchive", function () {
    return Os;
  }), a.d(e, "faFileAudio", function () {
    return Qs;
  }), a.d(e, "faFileCertificate", function () {
    return Zs;
  }), a.d(e, "faFileChartLine", function () {
    return Us;
  }), a.d(e, "faFileChartPie", function () {
    return Bs;
  }), a.d(e, "faFileCheck", function () {
    return Rs;
  }), a.d(e, "faFileCode", function () {
    return Ys;
  }), a.d(e, "faFileContract", function () {
    return Ps;
  }), a.d(e, "faFileCsv", function () {
    return Fs;
  }), a.d(e, "faFileDownload", function () {
    return Ws;
  }), a.d(e, "faFileEdit", function () {
    return Gs;
  }), a.d(e, "faFileExcel", function () {
    return qs;
  }), a.d(e, "faFileExclamation", function () {
    return Js;
  }), a.d(e, "faFileExport", function () {
    return Ks;
  }), a.d(e, "faFileImage", function () {
    return Xs;
  }), a.d(e, "faFileImport", function () {
    return _s;
  }), a.d(e, "faFileInvoice", function () {
    return $s;
  }), a.d(e, "faFileInvoiceDollar", function () {
    return cu;
  }), a.d(e, "faFileMedical", function () {
    return eu;
  }), a.d(e, "faFileMedicalAlt", function () {
    return au;
  }), a.d(e, "faFileMinus", function () {
    return nu;
  }), a.d(e, "faFileMusic", function () {
    return tu;
  }), a.d(e, "faFilePdf", function () {
    return ru;
  }), a.d(e, "faFilePlus", function () {
    return iu;
  }), a.d(e, "faFilePowerpoint", function () {
    return ou;
  }), a.d(e, "faFilePrescription", function () {
    return lu;
  }), a.d(e, "faFileSearch", function () {
    return fu;
  }), a.d(e, "faFileSignature", function () {
    return su;
  }), a.d(e, "faFileSpreadsheet", function () {
    return uu;
  }), a.d(e, "faFileTimes", function () {
    return hu;
  }), a.d(e, "faFileUpload", function () {
    return mu;
  }), a.d(e, "faFileUser", function () {
    return vu;
  }), a.d(e, "faFileVideo", function () {
    return du;
  }), a.d(e, "faFileWord", function () {
    return Mu;
  }), a.d(e, "faFilesMedical", function () {
    return pu;
  }), a.d(e, "faFill", function () {
    return zu;
  }), a.d(e, "faFillDrip", function () {
    return Cu;
  }), a.d(e, "faFilm", function () {
    return Lu;
  }), a.d(e, "faFilmAlt", function () {
    return Au;
  }), a.d(e, "faFilmCanister", function () {
    return Nu;
  }), a.d(e, "faFilter", function () {
    return gu;
  }), a.d(e, "faFingerprint", function () {
    return Hu;
  }), a.d(e, "faFire", function () {
    return Vu;
  }), a.d(e, "faFireAlt", function () {
    return xu;
  }), a.d(e, "faFireExtinguisher", function () {
    return wu;
  }), a.d(e, "faFireSmoke", function () {
    return yu;
  }), a.d(e, "faFireplace", function () {
    return bu;
  }), a.d(e, "faFirstAid", function () {
    return Su;
  }), a.d(e, "faFish", function () {
    return Tu;
  }), a.d(e, "faFishCooked", function () {
    return Du;
  }), a.d(e, "faFistRaised", function () {
    return ju;
  }), a.d(e, "faFlag", function () {
    return Eu;
  }), a.d(e, "faFlagAlt", function () {
    return ku;
  }), a.d(e, "faFlagCheckered", function () {
    return Iu;
  }), a.d(e, "faFlagUsa", function () {
    return Ou;
  }), a.d(e, "faFlame", function () {
    return Qu;
  }), a.d(e, "faFlashlight", function () {
    return Zu;
  }), a.d(e, "faFlask", function () {
    return Uu;
  }), a.d(e, "faFlaskPoison", function () {
    return Bu;
  }), a.d(e, "faFlaskPotion", function () {
    return Ru;
  }), a.d(e, "faFlower", function () {
    return Yu;
  }), a.d(e, "faFlowerDaffodil", function () {
    return Pu;
  }), a.d(e, "faFlowerTulip", function () {
    return Fu;
  }), a.d(e, "faFlushed", function () {
    return Wu;
  }), a.d(e, "faFlute", function () {
    return Gu;
  }), a.d(e, "faFluxCapacitor", function () {
    return qu;
  }), a.d(e, "faFog", function () {
    return Ju;
  }), a.d(e, "faFolder", function () {
    return Ku;
  }), a.d(e, "faFolderDownload", function () {
    return Xu;
  }), a.d(e, "faFolderMinus", function () {
    return _u;
  }), a.d(e, "faFolderOpen", function () {
    return $u;
  }), a.d(e, "faFolderPlus", function () {
    return ch;
  }), a.d(e, "faFolderTimes", function () {
    return eh;
  }), a.d(e, "faFolderTree", function () {
    return ah;
  }), a.d(e, "faFolderUpload", function () {
    return nh;
  }), a.d(e, "faFolders", function () {
    return th;
  }), a.d(e, "faFont", function () {
    return rh;
  }), a.d(e, "faFontAwesomeLogoFull", function () {
    return ih;
  }), a.d(e, "faFontCase", function () {
    return oh;
  }), a.d(e, "faFootballBall", function () {
    return lh;
  }), a.d(e, "faFootballHelmet", function () {
    return fh;
  }), a.d(e, "faForklift", function () {
    return sh;
  }), a.d(e, "faForward", function () {
    return uh;
  }), a.d(e, "faFragile", function () {
    return hh;
  }), a.d(e, "faFrenchFries", function () {
    return mh;
  }), a.d(e, "faFrog", function () {
    return vh;
  }), a.d(e, "faFrostyHead", function () {
    return dh;
  }), a.d(e, "faFrown", function () {
    return Mh;
  }), a.d(e, "faFrownOpen", function () {
    return ph;
  }), a.d(e, "faFunction", function () {
    return zh;
  }), a.d(e, "faFunnelDollar", function () {
    return Ch;
  }), a.d(e, "faFutbol", function () {
    return Lh;
  }), a.d(e, "faGalaxy", function () {
    return Ah;
  }), a.d(e, "faGameBoard", function () {
    return Nh;
  }), a.d(e, "faGameBoardAlt", function () {
    return gh;
  }), a.d(e, "faGameConsoleHandheld", function () {
    return Hh;
  }), a.d(e, "faGamepad", function () {
    return Vh;
  }), a.d(e, "faGamepadAlt", function () {
    return xh;
  }), a.d(e, "faGarage", function () {
    return wh;
  }), a.d(e, "faGarageCar", function () {
    return yh;
  }), a.d(e, "faGarageOpen", function () {
    return bh;
  }), a.d(e, "faGasPump", function () {
    return Sh;
  }), a.d(e, "faGasPumpSlash", function () {
    return Th;
  }), a.d(e, "faGavel", function () {
    return Dh;
  }), a.d(e, "faGem", function () {
    return jh;
  }), a.d(e, "faGenderless", function () {
    return Eh;
  }), a.d(e, "faGhost", function () {
    return kh;
  }), a.d(e, "faGift", function () {
    return Ih;
  }), a.d(e, "faGiftCard", function () {
    return Oh;
  }), a.d(e, "faGifts", function () {
    return Qh;
  }), a.d(e, "faGingerbreadMan", function () {
    return Zh;
  }), a.d(e, "faGlass", function () {
    return Uh;
  }), a.d(e, "faGlassChampagne", function () {
    return Bh;
  }), a.d(e, "faGlassCheers", function () {
    return Rh;
  }), a.d(e, "faGlassCitrus", function () {
    return Yh;
  }), a.d(e, "faGlassMartini", function () {
    return Ph;
  }), a.d(e, "faGlassMartiniAlt", function () {
    return Fh;
  }), a.d(e, "faGlassWhiskey", function () {
    return Wh;
  }), a.d(e, "faGlassWhiskeyRocks", function () {
    return Gh;
  }), a.d(e, "faGlasses", function () {
    return qh;
  }), a.d(e, "faGlassesAlt", function () {
    return Jh;
  }), a.d(e, "faGlobe", function () {
    return Kh;
  }), a.d(e, "faGlobeAfrica", function () {
    return Xh;
  }), a.d(e, "faGlobeAmericas", function () {
    return _h;
  }), a.d(e, "faGlobeAsia", function () {
    return $h;
  }), a.d(e, "faGlobeEurope", function () {
    return cm;
  }), a.d(e, "faGlobeSnow", function () {
    return em;
  }), a.d(e, "faGlobeStand", function () {
    return am;
  }), a.d(e, "faGolfBall", function () {
    return nm;
  }), a.d(e, "faGolfClub", function () {
    return tm;
  }), a.d(e, "faGopuram", function () {
    return rm;
  }), a.d(e, "faGraduationCap", function () {
    return im;
  }), a.d(e, "faGramophone", function () {
    return om;
  }), a.d(e, "faGreaterThan", function () {
    return lm;
  }), a.d(e, "faGreaterThanEqual", function () {
    return fm;
  }), a.d(e, "faGrimace", function () {
    return sm;
  }), a.d(e, "faGrin", function () {
    return um;
  }), a.d(e, "faGrinAlt", function () {
    return hm;
  }), a.d(e, "faGrinBeam", function () {
    return mm;
  }), a.d(e, "faGrinBeamSweat", function () {
    return vm;
  }), a.d(e, "faGrinHearts", function () {
    return dm;
  }), a.d(e, "faGrinSquint", function () {
    return Mm;
  }), a.d(e, "faGrinSquintTears", function () {
    return pm;
  }), a.d(e, "faGrinStars", function () {
    return zm;
  }), a.d(e, "faGrinTears", function () {
    return Cm;
  }), a.d(e, "faGrinTongue", function () {
    return Lm;
  }), a.d(e, "faGrinTongueSquint", function () {
    return Am;
  }), a.d(e, "faGrinTongueWink", function () {
    return Nm;
  }), a.d(e, "faGrinWink", function () {
    return gm;
  }), a.d(e, "faGripHorizontal", function () {
    return Hm;
  }), a.d(e, "faGripLines", function () {
    return Vm;
  }), a.d(e, "faGripLinesVertical", function () {
    return xm;
  }), a.d(e, "faGripVertical", function () {
    return wm;
  }), a.d(e, "faGuitar", function () {
    return ym;
  }), a.d(e, "faGuitarElectric", function () {
    return bm;
  }), a.d(e, "faGuitars", function () {
    return Sm;
  }), a.d(e, "faHSquare", function () {
    return Tm;
  }), a.d(e, "faH1", function () {
    return Dm;
  }), a.d(e, "faH2", function () {
    return jm;
  }), a.d(e, "faH3", function () {
    return Em;
  }), a.d(e, "faH4", function () {
    return km;
  }), a.d(e, "faHamburger", function () {
    return Im;
  }), a.d(e, "faHammer", function () {
    return Om;
  }), a.d(e, "faHammerWar", function () {
    return Qm;
  }), a.d(e, "faHamsa", function () {
    return Zm;
  }), a.d(e, "faHandHeart", function () {
    return Um;
  }), a.d(e, "faHandHolding", function () {
    return Bm;
  }), a.d(e, "faHandHoldingBox", function () {
    return Rm;
  }), a.d(e, "faHandHoldingHeart", function () {
    return Ym;
  }), a.d(e, "faHandHoldingMagic", function () {
    return Pm;
  }), a.d(e, "faHandHoldingMedical", function () {
    return Fm;
  }), a.d(e, "faHandHoldingSeedling", function () {
    return Wm;
  }), a.d(e, "faHandHoldingUsd", function () {
    return Gm;
  });
  a.d(e, "faHandHoldingWater", function () {
    return qm;
  }), a.d(e, "faHandLizard", function () {
    return Jm;
  }), a.d(e, "faHandMiddleFinger", function () {
    return Km;
  }), a.d(e, "faHandPaper", function () {
    return Xm;
  }), a.d(e, "faHandPeace", function () {
    return _m;
  }), a.d(e, "faHandPointDown", function () {
    return $m;
  }), a.d(e, "faHandPointLeft", function () {
    return cv;
  }), a.d(e, "faHandPointRight", function () {
    return ev;
  }), a.d(e, "faHandPointUp", function () {
    return av;
  }), a.d(e, "faHandPointer", function () {
    return nv;
  }), a.d(e, "faHandReceiving", function () {
    return tv;
  }), a.d(e, "faHandRock", function () {
    return rv;
  }), a.d(e, "faHandScissors", function () {
    return iv;
  }), a.d(e, "faHandSparkles", function () {
    return ov;
  }), a.d(e, "faHandSpock", function () {
    return lv;
  }), a.d(e, "faHands", function () {
    return fv;
  }), a.d(e, "faHandsHeart", function () {
    return sv;
  }), a.d(e, "faHandsHelping", function () {
    return uv;
  }), a.d(e, "faHandsUsd", function () {
    return hv;
  }), a.d(e, "faHandsWash", function () {
    return mv;
  }), a.d(e, "faHandshake", function () {
    return vv;
  }), a.d(e, "faHandshakeAlt", function () {
    return dv;
  }), a.d(e, "faHandshakeAltSlash", function () {
    return Mv;
  }), a.d(e, "faHandshakeSlash", function () {
    return pv;
  }), a.d(e, "faHanukiah", function () {
    return zv;
  }), a.d(e, "faHardHat", function () {
    return Cv;
  }), a.d(e, "faHashtag", function () {
    return Lv;
  }), a.d(e, "faHatChef", function () {
    return Av;
  }), a.d(e, "faHatCowboy", function () {
    return Nv;
  }), a.d(e, "faHatCowboySide", function () {
    return gv;
  }), a.d(e, "faHatSanta", function () {
    return Hv;
  }), a.d(e, "faHatWinter", function () {
    return Vv;
  }), a.d(e, "faHatWitch", function () {
    return xv;
  }), a.d(e, "faHatWizard", function () {
    return wv;
  }), a.d(e, "faHdd", function () {
    return yv;
  }), a.d(e, "faHeadSide", function () {
    return bv;
  }), a.d(e, "faHeadSideBrain", function () {
    return Sv;
  }), a.d(e, "faHeadSideCough", function () {
    return Tv;
  }), a.d(e, "faHeadSideCoughSlash", function () {
    return Dv;
  }), a.d(e, "faHeadSideHeadphones", function () {
    return jv;
  }), a.d(e, "faHeadSideMask", function () {
    return Ev;
  }), a.d(e, "faHeadSideMedical", function () {
    return kv;
  }), a.d(e, "faHeadSideVirus", function () {
    return Iv;
  }), a.d(e, "faHeadVr", function () {
    return Ov;
  }), a.d(e, "faHeading", function () {
    return Qv;
  }), a.d(e, "faHeadphones", function () {
    return Zv;
  }), a.d(e, "faHeadphonesAlt", function () {
    return Uv;
  }), a.d(e, "faHeadset", function () {
    return Bv;
  }), a.d(e, "faHeart", function () {
    return Rv;
  }), a.d(e, "faHeartBroken", function () {
    return Yv;
  }), a.d(e, "faHeartCircle", function () {
    return Pv;
  }), a.d(e, "faHeartRate", function () {
    return Fv;
  }), a.d(e, "faHeartSquare", function () {
    return Wv;
  }), a.d(e, "faHeartbeat", function () {
    return Gv;
  }), a.d(e, "faHeat", function () {
    return qv;
  }), a.d(e, "faHelicopter", function () {
    return Jv;
  }), a.d(e, "faHelmetBattle", function () {
    return Kv;
  }), a.d(e, "faHexagon", function () {
    return Xv;
  }), a.d(e, "faHighlighter", function () {
    return _v;
  }), a.d(e, "faHiking", function () {
    return $v;
  }), a.d(e, "faHippo", function () {
    return cd;
  }), a.d(e, "faHistory", function () {
    return ed;
  }), a.d(e, "faHockeyMask", function () {
    return ad;
  }), a.d(e, "faHockeyPuck", function () {
    return nd;
  }), a.d(e, "faHockeySticks", function () {
    return td;
  }), a.d(e, "faHollyBerry", function () {
    return rd;
  }), a.d(e, "faHome", function () {
    return id;
  }), a.d(e, "faHomeAlt", function () {
    return od;
  }), a.d(e, "faHomeHeart", function () {
    return ld;
  }), a.d(e, "faHomeLg", function () {
    return fd;
  }), a.d(e, "faHomeLgAlt", function () {
    return sd;
  }), a.d(e, "faHoodCloak", function () {
    return ud;
  }), a.d(e, "faHorizontalRule", function () {
    return hd;
  }), a.d(e, "faHorse", function () {
    return md;
  }), a.d(e, "faHorseHead", function () {
    return vd;
  }), a.d(e, "faHorseSaddle", function () {
    return dd;
  }), a.d(e, "faHospital", function () {
    return Md;
  }), a.d(e, "faHospitalAlt", function () {
    return pd;
  }), a.d(e, "faHospitalSymbol", function () {
    return zd;
  }), a.d(e, "faHospitalUser", function () {
    return Cd;
  }), a.d(e, "faHospitals", function () {
    return Ld;
  }), a.d(e, "faHotTub", function () {
    return Ad;
  }), a.d(e, "faHotdog", function () {
    return Nd;
  }), a.d(e, "faHotel", function () {
    return gd;
  }), a.d(e, "faHourglass", function () {
    return Hd;
  }), a.d(e, "faHourglassEnd", function () {
    return Vd;
  }), a.d(e, "faHourglassHalf", function () {
    return xd;
  }), a.d(e, "faHourglassStart", function () {
    return wd;
  }), a.d(e, "faHouse", function () {
    return yd;
  }), a.d(e, "faHouseDamage", function () {
    return bd;
  }), a.d(e, "faHouseDay", function () {
    return Sd;
  }), a.d(e, "faHouseFlood", function () {
    return Td;
  }), a.d(e, "faHouseLeave", function () {
    return Dd;
  }), a.d(e, "faHouseNight", function () {
    return jd;
  }), a.d(e, "faHouseReturn", function () {
    return Ed;
  }), a.d(e, "faHouseSignal", function () {
    return kd;
  }), a.d(e, "faHouseUser", function () {
    return Id;
  }), a.d(e, "faHryvnia", function () {
    return Od;
  }), a.d(e, "faHumidity", function () {
    return Qd;
  }), a.d(e, "faHurricane", function () {
    return Zd;
  }), a.d(e, "faICursor", function () {
    return Ud;
  }), a.d(e, "faIceCream", function () {
    return Bd;
  }), a.d(e, "faIceSkate", function () {
    return Rd;
  }), a.d(e, "faIcicles", function () {
    return Yd;
  }), a.d(e, "faIcons", function () {
    return Pd;
  }), a.d(e, "faIconsAlt", function () {
    return Fd;
  }), a.d(e, "faIdBadge", function () {
    return Wd;
  }), a.d(e, "faIdCard", function () {
    return Gd;
  }), a.d(e, "faIdCardAlt", function () {
    return qd;
  }), a.d(e, "faIgloo", function () {
    return Jd;
  }), a.d(e, "faImage", function () {
    return Kd;
  }), a.d(e, "faImagePolaroid", function () {
    return Xd;
  }), a.d(e, "faImages", function () {
    return _d;
  }), a.d(e, "faInbox", function () {
    return $d;
  }), a.d(e, "faInboxIn", function () {
    return cM;
  }), a.d(e, "faInboxOut", function () {
    return eM;
  }), a.d(e, "faIndent", function () {
    return aM;
  }), a.d(e, "faIndustry", function () {
    return nM;
  }), a.d(e, "faIndustryAlt", function () {
    return tM;
  }), a.d(e, "faInfinity", function () {
    return rM;
  }), a.d(e, "faInfo", function () {
    return iM;
  }), a.d(e, "faInfoCircle", function () {
    return oM;
  }), a.d(e, "faInfoSquare", function () {
    return lM;
  }), a.d(e, "faInhaler", function () {
    return fM;
  }), a.d(e, "faIntegral", function () {
    return sM;
  }), a.d(e, "faIntersection", function () {
    return uM;
  }), a.d(e, "faInventory", function () {
    return hM;
  }), a.d(e, "faIslandTropical", function () {
    return mM;
  }), a.d(e, "faItalic", function () {
    return vM;
  }), a.d(e, "faJackOLantern", function () {
    return dM;
  }), a.d(e, "faJedi", function () {
    return MM;
  }), a.d(e, "faJoint", function () {
    return pM;
  }), a.d(e, "faJournalWhills", function () {
    return zM;
  }), a.d(e, "faJoystick", function () {
    return CM;
  }), a.d(e, "faJug", function () {
    return LM;
  }), a.d(e, "faKaaba", function () {
    return AM;
  }), a.d(e, "faKazoo", function () {
    return NM;
  }), a.d(e, "faKerning", function () {
    return gM;
  }), a.d(e, "faKey", function () {
    return HM;
  }), a.d(e, "faKeySkeleton", function () {
    return VM;
  }), a.d(e, "faKeyboard", function () {
    return xM;
  }), a.d(e, "faKeynote", function () {
    return wM;
  }), a.d(e, "faKhanda", function () {
    return yM;
  }), a.d(e, "faKidneys", function () {
    return bM;
  }), a.d(e, "faKiss", function () {
    return SM;
  }), a.d(e, "faKissBeam", function () {
    return TM;
  }), a.d(e, "faKissWinkHeart", function () {
    return DM;
  }), a.d(e, "faKite", function () {
    return jM;
  }), a.d(e, "faKiwiBird", function () {
    return EM;
  }), a.d(e, "faKnifeKitchen", function () {
    return kM;
  }), a.d(e, "faLambda", function () {
    return IM;
  }), a.d(e, "faLamp", function () {
    return OM;
  }), a.d(e, "faLampDesk", function () {
    return QM;
  }), a.d(e, "faLampFloor", function () {
    return ZM;
  }), a.d(e, "faLandmark", function () {
    return UM;
  }), a.d(e, "faLandmarkAlt", function () {
    return BM;
  }), a.d(e, "faLanguage", function () {
    return RM;
  }), a.d(e, "faLaptop", function () {
    return YM;
  }), a.d(e, "faLaptopCode", function () {
    return PM;
  }), a.d(e, "faLaptopHouse", function () {
    return FM;
  }), a.d(e, "faLaptopMedical", function () {
    return WM;
  }), a.d(e, "faLasso", function () {
    return GM;
  }), a.d(e, "faLaugh", function () {
    return qM;
  }), a.d(e, "faLaughBeam", function () {
    return JM;
  }), a.d(e, "faLaughSquint", function () {
    return KM;
  }), a.d(e, "faLaughWink", function () {
    return XM;
  }), a.d(e, "faLayerGroup", function () {
    return _M;
  }), a.d(e, "faLayerMinus", function () {
    return $M;
  }), a.d(e, "faLayerPlus", function () {
    return cp;
  }), a.d(e, "faLeaf", function () {
    return ep;
  }), a.d(e, "faLeafHeart", function () {
    return ap;
  }), a.d(e, "faLeafMaple", function () {
    return np;
  }), a.d(e, "faLeafOak", function () {
    return tp;
  }), a.d(e, "faLemon", function () {
    return rp;
  }), a.d(e, "faLessThan", function () {
    return ip;
  }), a.d(e, "faLessThanEqual", function () {
    return op;
  }), a.d(e, "faLevelDown", function () {
    return lp;
  }), a.d(e, "faLevelDownAlt", function () {
    return fp;
  }), a.d(e, "faLevelUp", function () {
    return sp;
  }), a.d(e, "faLevelUpAlt", function () {
    return up;
  }), a.d(e, "faLifeRing", function () {
    return hp;
  }), a.d(e, "faLightCeiling", function () {
    return mp;
  }), a.d(e, "faLightSwitch", function () {
    return vp;
  }), a.d(e, "faLightSwitchOff", function () {
    return dp;
  }), a.d(e, "faLightSwitchOn", function () {
    return Mp;
  }), a.d(e, "faLightbulb", function () {
    return pp;
  }), a.d(e, "faLightbulbDollar", function () {
    return zp;
  }), a.d(e, "faLightbulbExclamation", function () {
    return Cp;
  }), a.d(e, "faLightbulbOn", function () {
    return Lp;
  }), a.d(e, "faLightbulbSlash", function () {
    return Ap;
  }), a.d(e, "faLightsHoliday", function () {
    return Np;
  }), a.d(e, "faLineColumns", function () {
    return gp;
  }), a.d(e, "faLineHeight", function () {
    return Hp;
  }), a.d(e, "faLink", function () {
    return Vp;
  }), a.d(e, "faLips", function () {
    return xp;
  }), a.d(e, "faLiraSign", function () {
    return wp;
  }), a.d(e, "faList", function () {
    return yp;
  }), a.d(e, "faListAlt", function () {
    return bp;
  }), a.d(e, "faListMusic", function () {
    return Sp;
  }), a.d(e, "faListOl", function () {
    return Tp;
  }), a.d(e, "faListUl", function () {
    return Dp;
  }), a.d(e, "faLocation", function () {
    return jp;
  }), a.d(e, "faLocationArrow", function () {
    return Ep;
  }), a.d(e, "faLocationCircle", function () {
    return kp;
  }), a.d(e, "faLocationSlash", function () {
    return Ip;
  }), a.d(e, "faLock", function () {
    return Op;
  }), a.d(e, "faLockAlt", function () {
    return Qp;
  }), a.d(e, "faLockOpen", function () {
    return Zp;
  }), a.d(e, "faLockOpenAlt", function () {
    return Up;
  }), a.d(e, "faLongArrowAltDown", function () {
    return Bp;
  }), a.d(e, "faLongArrowAltLeft", function () {
    return Rp;
  }), a.d(e, "faLongArrowAltRight", function () {
    return Yp;
  }), a.d(e, "faLongArrowAltUp", function () {
    return Pp;
  }), a.d(e, "faLongArrowDown", function () {
    return Fp;
  }), a.d(e, "faLongArrowLeft", function () {
    return Wp;
  }), a.d(e, "faLongArrowRight", function () {
    return Gp;
  }), a.d(e, "faLongArrowUp", function () {
    return qp;
  }), a.d(e, "faLoveseat", function () {
    return Jp;
  }), a.d(e, "faLowVision", function () {
    return Kp;
  }), a.d(e, "faLuchador", function () {
    return Xp;
  }), a.d(e, "faLuggageCart", function () {
    return _p;
  }), a.d(e, "faLungs", function () {
    return $p;
  }), a.d(e, "faLungsVirus", function () {
    return cz;
  }), a.d(e, "faMace", function () {
    return ez;
  }), a.d(e, "faMagic", function () {
    return az;
  }), a.d(e, "faMagnet", function () {
    return nz;
  }), a.d(e, "faMailBulk", function () {
    return tz;
  }), a.d(e, "faMailbox", function () {
    return rz;
  }), a.d(e, "faMale", function () {
    return iz;
  }), a.d(e, "faMandolin", function () {
    return oz;
  }), a.d(e, "faMap", function () {
    return lz;
  }), a.d(e, "faMapMarked", function () {
    return fz;
  }), a.d(e, "faMapMarkedAlt", function () {
    return sz;
  }), a.d(e, "faMapMarker", function () {
    return uz;
  }), a.d(e, "faMapMarkerAlt", function () {
    return hz;
  }), a.d(e, "faMapMarkerAltSlash", function () {
    return mz;
  }), a.d(e, "faMapMarkerCheck", function () {
    return vz;
  }), a.d(e, "faMapMarkerEdit", function () {
    return dz;
  }), a.d(e, "faMapMarkerExclamation", function () {
    return Mz;
  }), a.d(e, "faMapMarkerMinus", function () {
    return pz;
  }), a.d(e, "faMapMarkerPlus", function () {
    return zz;
  }), a.d(e, "faMapMarkerQuestion", function () {
    return Cz;
  }), a.d(e, "faMapMarkerSlash", function () {
    return Lz;
  }), a.d(e, "faMapMarkerSmile", function () {
    return Az;
  }), a.d(e, "faMapMarkerTimes", function () {
    return Nz;
  }), a.d(e, "faMapPin", function () {
    return gz;
  }), a.d(e, "faMapSigns", function () {
    return Hz;
  }), a.d(e, "faMarker", function () {
    return Vz;
  }), a.d(e, "faMars", function () {
    return xz;
  }), a.d(e, "faMarsDouble", function () {
    return wz;
  }), a.d(e, "faMarsStroke", function () {
    return yz;
  }), a.d(e, "faMarsStrokeH", function () {
    return bz;
  }), a.d(e, "faMarsStrokeV", function () {
    return Sz;
  }), a.d(e, "faMask", function () {
    return Tz;
  }), a.d(e, "faMeat", function () {
    return Dz;
  }), a.d(e, "faMedal", function () {
    return jz;
  }), a.d(e, "faMedkit", function () {
    return Ez;
  }), a.d(e, "faMegaphone", function () {
    return kz;
  }), a.d(e, "faMeh", function () {
    return Iz;
  }), a.d(e, "faMehBlank", function () {
    return Oz;
  }), a.d(e, "faMehRollingEyes", function () {
    return Qz;
  }), a.d(e, "faMemory", function () {
    return Zz;
  }), a.d(e, "faMenorah", function () {
    return Uz;
  }), a.d(e, "faMercury", function () {
    return Bz;
  }), a.d(e, "faMeteor", function () {
    return Rz;
  }), a.d(e, "faMicrochip", function () {
    return Yz;
  }), a.d(e, "faMicrophone", function () {
    return Pz;
  }), a.d(e, "faMicrophoneAlt", function () {
    return Fz;
  }), a.d(e, "faMicrophoneAltSlash", function () {
    return Wz;
  }), a.d(e, "faMicrophoneSlash", function () {
    return Gz;
  }), a.d(e, "faMicrophoneStand", function () {
    return qz;
  }), a.d(e, "faMicroscope", function () {
    return Jz;
  }), a.d(e, "faMicrowave", function () {
    return Kz;
  }), a.d(e, "faMindShare", function () {
    return Xz;
  }), a.d(e, "faMinus", function () {
    return _z;
  }), a.d(e, "faMinusCircle", function () {
    return $z;
  }), a.d(e, "faMinusHexagon", function () {
    return cC;
  }), a.d(e, "faMinusOctagon", function () {
    return eC;
  }), a.d(e, "faMinusSquare", function () {
    return aC;
  }), a.d(e, "faMistletoe", function () {
    return nC;
  }), a.d(e, "faMitten", function () {
    return tC;
  }), a.d(e, "faMobile", function () {
    return rC;
  }), a.d(e, "faMobileAlt", function () {
    return iC;
  }), a.d(e, "faMobileAndroid", function () {
    return oC;
  }), a.d(e, "faMobileAndroidAlt", function () {
    return lC;
  }), a.d(e, "faMoneyBill", function () {
    return fC;
  }), a.d(e, "faMoneyBillAlt", function () {
    return sC;
  }), a.d(e, "faMoneyBillWave", function () {
    return uC;
  }), a.d(e, "faMoneyBillWaveAlt", function () {
    return hC;
  }), a.d(e, "faMoneyCheck", function () {
    return mC;
  }), a.d(e, "faMoneyCheckAlt", function () {
    return vC;
  }), a.d(e, "faMoneyCheckEdit", function () {
    return dC;
  }), a.d(e, "faMoneyCheckEditAlt", function () {
    return MC;
  }), a.d(e, "faMonitorHeartRate", function () {
    return pC;
  }), a.d(e, "faMonkey", function () {
    return zC;
  }), a.d(e, "faMonument", function () {
    return CC;
  }), a.d(e, "faMoon", function () {
    return LC;
  }), a.d(e, "faMoonCloud", function () {
    return AC;
  }), a.d(e, "faMoonStars", function () {
    return NC;
  }), a.d(e, "faMortarPestle", function () {
    return gC;
  }), a.d(e, "faMosque", function () {
    return HC;
  }), a.d(e, "faMotorcycle", function () {
    return VC;
  }), a.d(e, "faMountain", function () {
    return xC;
  }), a.d(e, "faMountains", function () {
    return wC;
  }), a.d(e, "faMouse", function () {
    return yC;
  }), a.d(e, "faMouseAlt", function () {
    return bC;
  }), a.d(e, "faMousePointer", function () {
    return SC;
  }), a.d(e, "faMp3Player", function () {
    return TC;
  }), a.d(e, "faMug", function () {
    return DC;
  }), a.d(e, "faMugHot", function () {
    return jC;
  }), a.d(e, "faMugMarshmallows", function () {
    return EC;
  }), a.d(e, "faMugTea", function () {
    return kC;
  }), a.d(e, "faMusic", function () {
    return IC;
  }), a.d(e, "faMusicAlt", function () {
    return OC;
  }), a.d(e, "faMusicAltSlash", function () {
    return QC;
  }), a.d(e, "faMusicSlash", function () {
    return ZC;
  }), a.d(e, "faNarwhal", function () {
    return UC;
  }), a.d(e, "faNetworkWired", function () {
    return BC;
  }), a.d(e, "faNeuter", function () {
    return RC;
  }), a.d(e, "faNewspaper", function () {
    return YC;
  }), a.d(e, "faNotEqual", function () {
    return PC;
  }), a.d(e, "faNotesMedical", function () {
    return FC;
  }), a.d(e, "faObjectGroup", function () {
    return WC;
  }), a.d(e, "faObjectUngroup", function () {
    return GC;
  }), a.d(e, "faOctagon", function () {
    return qC;
  }), a.d(e, "faOilCan", function () {
    return JC;
  }), a.d(e, "faOilTemp", function () {
    return KC;
  }), a.d(e, "faOm", function () {
    return XC;
  }), a.d(e, "faOmega", function () {
    return _C;
  }), a.d(e, "faOrnament", function () {
    return $C;
  }), a.d(e, "faOtter", function () {
    return cL;
  }), a.d(e, "faOutdent", function () {
    return eL;
  }), a.d(e, "faOutlet", function () {
    return aL;
  }), a.d(e, "faOven", function () {
    return nL;
  }), a.d(e, "faOverline", function () {
    return tL;
  }), a.d(e, "faPageBreak", function () {
    return rL;
  }), a.d(e, "faPager", function () {
    return iL;
  }), a.d(e, "faPaintBrush", function () {
    return oL;
  }), a.d(e, "faPaintBrushAlt", function () {
    return lL;
  }), a.d(e, "faPaintRoller", function () {
    return fL;
  }), a.d(e, "faPalette", function () {
    return sL;
  }), a.d(e, "faPallet", function () {
    return uL;
  }), a.d(e, "faPalletAlt", function () {
    return hL;
  }), a.d(e, "faPaperPlane", function () {
    return mL;
  }), a.d(e, "faPaperclip", function () {
    return vL;
  }), a.d(e, "faParachuteBox", function () {
    return dL;
  }), a.d(e, "faParagraph", function () {
    return ML;
  }), a.d(e, "faParagraphRtl", function () {
    return pL;
  }), a.d(e, "faParking", function () {
    return zL;
  }), a.d(e, "faParkingCircle", function () {
    return CL;
  }), a.d(e, "faParkingCircleSlash", function () {
    return LL;
  }), a.d(e, "faParkingSlash", function () {
    return AL;
  }), a.d(e, "faPassport", function () {
    return NL;
  }), a.d(e, "faPastafarianism", function () {
    return gL;
  }), a.d(e, "faPaste", function () {
    return HL;
  }), a.d(e, "faPause", function () {
    return VL;
  }), a.d(e, "faPauseCircle", function () {
    return xL;
  }), a.d(e, "faPaw", function () {
    return wL;
  }), a.d(e, "faPawAlt", function () {
    return yL;
  }), a.d(e, "faPawClaws", function () {
    return bL;
  }), a.d(e, "faPeace", function () {
    return SL;
  }), a.d(e, "faPegasus", function () {
    return TL;
  }), a.d(e, "faPen", function () {
    return DL;
  }), a.d(e, "faPenAlt", function () {
    return jL;
  }), a.d(e, "faPenFancy", function () {
    return EL;
  }), a.d(e, "faPenNib", function () {
    return kL;
  }), a.d(e, "faPenSquare", function () {
    return IL;
  }), a.d(e, "faPencil", function () {
    return OL;
  }), a.d(e, "faPencilAlt", function () {
    return QL;
  }), a.d(e, "faPencilPaintbrush", function () {
    return ZL;
  }), a.d(e, "faPencilRuler", function () {
    return UL;
  }), a.d(e, "faPennant", function () {
    return BL;
  }), a.d(e, "faPeopleArrows", function () {
    return RL;
  }), a.d(e, "faPeopleCarry", function () {
    return YL;
  }), a.d(e, "faPepperHot", function () {
    return PL;
  }), a.d(e, "faPercent", function () {
    return FL;
  }), a.d(e, "faPercentage", function () {
    return WL;
  }), a.d(e, "faPersonBooth", function () {
    return GL;
  }), a.d(e, "faPersonCarry", function () {
    return qL;
  }), a.d(e, "faPersonDolly", function () {
    return JL;
  }), a.d(e, "faPersonDollyEmpty", function () {
    return KL;
  }), a.d(e, "faPersonSign", function () {
    return XL;
  }), a.d(e, "faPhone", function () {
    return _L;
  }), a.d(e, "faPhoneAlt", function () {
    return $L;
  }), a.d(e, "faPhoneLaptop", function () {
    return cA;
  }), a.d(e, "faPhoneOffice", function () {
    return eA;
  }), a.d(e, "faPhonePlus", function () {
    return aA;
  }), a.d(e, "faPhoneRotary", function () {
    return nA;
  }), a.d(e, "faPhoneSlash", function () {
    return tA;
  }), a.d(e, "faPhoneSquare", function () {
    return rA;
  }), a.d(e, "faPhoneSquareAlt", function () {
    return iA;
  }), a.d(e, "faPhoneVolume", function () {
    return oA;
  }), a.d(e, "faPhotoVideo", function () {
    return lA;
  }), a.d(e, "faPi", function () {
    return fA;
  }), a.d(e, "faPiano", function () {
    return sA;
  }), a.d(e, "faPianoKeyboard", function () {
    return uA;
  }), a.d(e, "faPie", function () {
    return hA;
  }), a.d(e, "faPig", function () {
    return mA;
  }), a.d(e, "faPiggyBank", function () {
    return vA;
  }), a.d(e, "faPills", function () {
    return dA;
  }), a.d(e, "faPizza", function () {
    return MA;
  }), a.d(e, "faPizzaSlice", function () {
    return pA;
  }), a.d(e, "faPlaceOfWorship", function () {
    return zA;
  }), a.d(e, "faPlane", function () {
    return CA;
  }), a.d(e, "faPlaneAlt", function () {
    return LA;
  }), a.d(e, "faPlaneArrival", function () {
    return AA;
  }), a.d(e, "faPlaneDeparture", function () {
    return NA;
  }), a.d(e, "faPlaneSlash", function () {
    return gA;
  }), a.d(e, "faPlanetMoon", function () {
    return HA;
  }), a.d(e, "faPlanetRinged", function () {
    return VA;
  }), a.d(e, "faPlay", function () {
    return xA;
  }), a.d(e, "faPlayCircle", function () {
    return wA;
  }), a.d(e, "faPlug", function () {
    return yA;
  }), a.d(e, "faPlus", function () {
    return bA;
  }), a.d(e, "faPlusCircle", function () {
    return SA;
  }), a.d(e, "faPlusHexagon", function () {
    return TA;
  }), a.d(e, "faPlusOctagon", function () {
    return DA;
  }), a.d(e, "faPlusSquare", function () {
    return jA;
  }), a.d(e, "faPodcast", function () {
    return EA;
  }), a.d(e, "faPodium", function () {
    return kA;
  }), a.d(e, "faPodiumStar", function () {
    return IA;
  }), a.d(e, "faPoliceBox", function () {
    return OA;
  }), a.d(e, "faPoll", function () {
    return QA;
  }), a.d(e, "faPollH", function () {
    return ZA;
  }), a.d(e, "faPollPeople", function () {
    return UA;
  }), a.d(e, "faPoo", function () {
    return BA;
  }), a.d(e, "faPooStorm", function () {
    return RA;
  }), a.d(e, "faPoop", function () {
    return YA;
  }), a.d(e, "faPopcorn", function () {
    return PA;
  }), a.d(e, "faPortalEnter", function () {
    return FA;
  }), a.d(e, "faPortalExit", function () {
    return WA;
  }), a.d(e, "faPortrait", function () {
    return GA;
  }), a.d(e, "faPoundSign", function () {
    return qA;
  }), a.d(e, "faPowerOff", function () {
    return JA;
  }), a.d(e, "faPray", function () {
    return KA;
  }), a.d(e, "faPrayingHands", function () {
    return XA;
  }), a.d(e, "faPrescription", function () {
    return _A;
  }), a.d(e, "faPrescriptionBottle", function () {
    return $A;
  }), a.d(e, "faPrescriptionBottleAlt", function () {
    return cN;
  }), a.d(e, "faPresentation", function () {
    return eN;
  }), a.d(e, "faPrint", function () {
    return aN;
  }), a.d(e, "faPrintSearch", function () {
    return nN;
  }), a.d(e, "faPrintSlash", function () {
    return tN;
  }), a.d(e, "faProcedures", function () {
    return rN;
  }), a.d(e, "faProjectDiagram", function () {
    return iN;
  }), a.d(e, "faProjector", function () {
    return oN;
  }), a.d(e, "faPumpMedical", function () {
    return lN;
  }), a.d(e, "faPumpSoap", function () {
    return fN;
  }), a.d(e, "faPumpkin", function () {
    return sN;
  }), a.d(e, "faPuzzlePiece", function () {
    return uN;
  }), a.d(e, "faQrcode", function () {
    return hN;
  }), a.d(e, "faQuestion", function () {
    return mN;
  }), a.d(e, "faQuestionCircle", function () {
    return vN;
  }), a.d(e, "faQuestionSquare", function () {
    return dN;
  }), a.d(e, "faQuidditch", function () {
    return MN;
  }), a.d(e, "faQuoteLeft", function () {
    return pN;
  }), a.d(e, "faQuoteRight", function () {
    return zN;
  }), a.d(e, "faQuran", function () {
    return CN;
  }), a.d(e, "faRabbit", function () {
    return LN;
  }), a.d(e, "faRabbitFast", function () {
    return AN;
  }), a.d(e, "faRacquet", function () {
    return NN;
  }), a.d(e, "faRadar", function () {
    return gN;
  }), a.d(e, "faRadiation", function () {
    return HN;
  }), a.d(e, "faRadiationAlt", function () {
    return VN;
  }), a.d(e, "faRadio", function () {
    return xN;
  }), a.d(e, "faRadioAlt", function () {
    return wN;
  }), a.d(e, "faRainbow", function () {
    return yN;
  }), a.d(e, "faRaindrops", function () {
    return bN;
  }), a.d(e, "faRam", function () {
    return SN;
  }), a.d(e, "faRampLoading", function () {
    return TN;
  }), a.d(e, "faRandom", function () {
    return DN;
  }), a.d(e, "faRaygun", function () {
    return jN;
  }), a.d(e, "faReceipt", function () {
    return EN;
  }), a.d(e, "faRecordVinyl", function () {
    return kN;
  }), a.d(e, "faRectangleLandscape", function () {
    return IN;
  }), a.d(e, "faRectanglePortrait", function () {
    return ON;
  }), a.d(e, "faRectangleWide", function () {
    return QN;
  }), a.d(e, "faRecycle", function () {
    return ZN;
  }), a.d(e, "faRedo", function () {
    return UN;
  }), a.d(e, "faRedoAlt", function () {
    return BN;
  }), a.d(e, "faRefrigerator", function () {
    return RN;
  }), a.d(e, "faRegistered", function () {
    return YN;
  }), a.d(e, "faRemoveFormat", function () {
    return PN;
  }), a.d(e, "faRepeat", function () {
    return FN;
  }), a.d(e, "faRepeat1", function () {
    return WN;
  }), a.d(e, "faRepeat1Alt", function () {
    return GN;
  }), a.d(e, "faRepeatAlt", function () {
    return qN;
  }), a.d(e, "faReply", function () {
    return JN;
  }), a.d(e, "faReplyAll", function () {
    return KN;
  }), a.d(e, "faRepublican", function () {
    return XN;
  }), a.d(e, "faRestroom", function () {
    return _N;
  }), a.d(e, "faRetweet", function () {
    return $N;
  }), a.d(e, "faRetweetAlt", function () {
    return cg;
  }), a.d(e, "faRibbon", function () {
    return eg;
  }), a.d(e, "faRing", function () {
    return ag;
  }), a.d(e, "faRingsWedding", function () {
    return ng;
  }), a.d(e, "faRoad", function () {
    return tg;
  }), a.d(e, "faRobot", function () {
    return rg;
  }), a.d(e, "faRocket", function () {
    return ig;
  }), a.d(e, "faRocketLaunch", function () {
    return og;
  }), a.d(e, "faRoute", function () {
    return lg;
  }), a.d(e, "faRouteHighway", function () {
    return fg;
  }), a.d(e, "faRouteInterstate", function () {
    return sg;
  }), a.d(e, "faRouter", function () {
    return ug;
  }), a.d(e, "faRss", function () {
    return hg;
  }), a.d(e, "faRssSquare", function () {
    return mg;
  }), a.d(e, "faRubleSign", function () {
    return vg;
  }), a.d(e, "faRuler", function () {
    return dg;
  }), a.d(e, "faRulerCombined", function () {
    return Mg;
  }), a.d(e, "faRulerHorizontal", function () {
    return pg;
  }), a.d(e, "faRulerTriangle", function () {
    return zg;
  }), a.d(e, "faRulerVertical", function () {
    return Cg;
  }), a.d(e, "faRunning", function () {
    return Lg;
  }), a.d(e, "faRupeeSign", function () {
    return Ag;
  }), a.d(e, "faRv", function () {
    return Ng;
  }), a.d(e, "faSack", function () {
    return gg;
  }), a.d(e, "faSackDollar", function () {
    return Hg;
  }), a.d(e, "faSadCry", function () {
    return Vg;
  }), a.d(e, "faSadTear", function () {
    return xg;
  }), a.d(e, "faSalad", function () {
    return wg;
  }), a.d(e, "faSandwich", function () {
    return yg;
  }), a.d(e, "faSatellite", function () {
    return bg;
  }), a.d(e, "faSatelliteDish", function () {
    return Sg;
  }), a.d(e, "faSausage", function () {
    return Tg;
  }), a.d(e, "faSave", function () {
    return Dg;
  }), a.d(e, "faSaxHot", function () {
    return jg;
  }), a.d(e, "faSaxophone", function () {
    return Eg;
  }), a.d(e, "faScalpel", function () {
    return kg;
  }), a.d(e, "faScalpelPath", function () {
    return Ig;
  }), a.d(e, "faScanner", function () {
    return Og;
  }), a.d(e, "faScannerImage", function () {
    return Qg;
  }), a.d(e, "faScannerKeyboard", function () {
    return Zg;
  }), a.d(e, "faScannerTouchscreen", function () {
    return Ug;
  }), a.d(e, "faScarecrow", function () {
    return Bg;
  }), a.d(e, "faScarf", function () {
    return Rg;
  }), a.d(e, "faSchool", function () {
    return Yg;
  }), a.d(e, "faScrewdriver", function () {
    return Pg;
  }), a.d(e, "faScroll", function () {
    return Fg;
  }), a.d(e, "faScrollOld", function () {
    return Wg;
  }), a.d(e, "faScrubber", function () {
    return Gg;
  }), a.d(e, "faScythe", function () {
    return qg;
  }), a.d(e, "faSdCard", function () {
    return Jg;
  }), a.d(e, "faSearch", function () {
    return Kg;
  }), a.d(e, "faSearchDollar", function () {
    return Xg;
  }), a.d(e, "faSearchLocation", function () {
    return _g;
  }), a.d(e, "faSearchMinus", function () {
    return $g;
  }), a.d(e, "faSearchPlus", function () {
    return cH;
  }), a.d(e, "faSeedling", function () {
    return eH;
  }), a.d(e, "faSendBack", function () {
    return aH;
  }), a.d(e, "faSendBackward", function () {
    return nH;
  }), a.d(e, "faSensor", function () {
    return tH;
  }), a.d(e, "faSensorAlert", function () {
    return rH;
  }), a.d(e, "faSensorFire", function () {
    return iH;
  }), a.d(e, "faSensorOn", function () {
    return oH;
  }), a.d(e, "faSensorSmoke", function () {
    return lH;
  }), a.d(e, "faServer", function () {
    return fH;
  }), a.d(e, "faShapes", function () {
    return sH;
  }), a.d(e, "faShare", function () {
    return uH;
  }), a.d(e, "faShareAll", function () {
    return hH;
  }), a.d(e, "faShareAlt", function () {
    return mH;
  }), a.d(e, "faShareAltSquare", function () {
    return vH;
  }), a.d(e, "faShareSquare", function () {
    return dH;
  }), a.d(e, "faSheep", function () {
    return MH;
  }), a.d(e, "faShekelSign", function () {
    return pH;
  }), a.d(e, "faShield", function () {
    return zH;
  }), a.d(e, "faShieldAlt", function () {
    return CH;
  }), a.d(e, "faShieldCheck", function () {
    return LH;
  }), a.d(e, "faShieldCross", function () {
    return AH;
  }), a.d(e, "faShieldVirus", function () {
    return NH;
  }), a.d(e, "faShip", function () {
    return gH;
  }), a.d(e, "faShippingFast", function () {
    return HH;
  }), a.d(e, "faShippingTimed", function () {
    return VH;
  }), a.d(e, "faShishKebab", function () {
    return xH;
  }), a.d(e, "faShoePrints", function () {
    return wH;
  }), a.d(e, "faShoppingBag", function () {
    return yH;
  }), a.d(e, "faShoppingBasket", function () {
    return bH;
  }), a.d(e, "faShoppingCart", function () {
    return SH;
  }), a.d(e, "faShovel", function () {
    return TH;
  }), a.d(e, "faShovelSnow", function () {
    return DH;
  }), a.d(e, "faShower", function () {
    return jH;
  }), a.d(e, "faShredder", function () {
    return EH;
  }), a.d(e, "faShuttleVan", function () {
    return kH;
  }), a.d(e, "faShuttlecock", function () {
    return IH;
  }), a.d(e, "faSickle", function () {
    return OH;
  }), a.d(e, "faSigma", function () {
    return QH;
  }), a.d(e, "faSign", function () {
    return ZH;
  }), a.d(e, "faSignIn", function () {
    return UH;
  }), a.d(e, "faSignInAlt", function () {
    return BH;
  }), a.d(e, "faSignLanguage", function () {
    return RH;
  }), a.d(e, "faSignOut", function () {
    return YH;
  }), a.d(e, "faSignOutAlt", function () {
    return PH;
  }), a.d(e, "faSignal", function () {
    return FH;
  }), a.d(e, "faSignal1", function () {
    return WH;
  }), a.d(e, "faSignal2", function () {
    return GH;
  }), a.d(e, "faSignal3", function () {
    return qH;
  }), a.d(e, "faSignal4", function () {
    return JH;
  }), a.d(e, "faSignalAlt", function () {
    return KH;
  }), a.d(e, "faSignalAlt1", function () {
    return XH;
  }), a.d(e, "faSignalAlt2", function () {
    return _H;
  }), a.d(e, "faSignalAlt3", function () {
    return $H;
  }), a.d(e, "faSignalAltSlash", function () {
    return cV;
  }), a.d(e, "faSignalSlash", function () {
    return eV;
  }), a.d(e, "faSignalStream", function () {
    return aV;
  }), a.d(e, "faSignature", function () {
    return nV;
  }), a.d(e, "faSimCard", function () {
    return tV;
  }), a.d(e, "faSink", function () {
    return rV;
  }), a.d(e, "faSiren", function () {
    return iV;
  }), a.d(e, "faSirenOn", function () {
    return oV;
  }), a.d(e, "faSitemap", function () {
    return lV;
  }), a.d(e, "faSkating", function () {
    return fV;
  }), a.d(e, "faSkeleton", function () {
    return sV;
  }), a.d(e, "faSkiJump", function () {
    return uV;
  }), a.d(e, "faSkiLift", function () {
    return hV;
  }), a.d(e, "faSkiing", function () {
    return mV;
  }), a.d(e, "faSkiingNordic", function () {
    return vV;
  }), a.d(e, "faSkull", function () {
    return dV;
  }), a.d(e, "faSkullCow", function () {
    return MV;
  }), a.d(e, "faSkullCrossbones", function () {
    return pV;
  }), a.d(e, "faSlash", function () {
    return zV;
  }), a.d(e, "faSledding", function () {
    return CV;
  }), a.d(e, "faSleigh", function () {
    return LV;
  }), a.d(e, "faSlidersH", function () {
    return AV;
  }), a.d(e, "faSlidersHSquare", function () {
    return NV;
  }), a.d(e, "faSlidersV", function () {
    return gV;
  }), a.d(e, "faSlidersVSquare", function () {
    return HV;
  }), a.d(e, "faSmile", function () {
    return VV;
  }), a.d(e, "faSmileBeam", function () {
    return xV;
  }), a.d(e, "faSmilePlus", function () {
    return wV;
  }), a.d(e, "faSmileWink", function () {
    return yV;
  }), a.d(e, "faSmog", function () {
    return bV;
  }), a.d(e, "faSmoke", function () {
    return SV;
  }), a.d(e, "faSmoking", function () {
    return TV;
  }), a.d(e, "faSmokingBan", function () {
    return DV;
  }), a.d(e, "faSms", function () {
    return jV;
  }), a.d(e, "faSnake", function () {
    return EV;
  }), a.d(e, "faSnooze", function () {
    return kV;
  }), a.d(e, "faSnowBlowing", function () {
    return IV;
  }), a.d(e, "faSnowboarding", function () {
    return OV;
  }), a.d(e, "faSnowflake", function () {
    return QV;
  }), a.d(e, "faSnowflakes", function () {
    return ZV;
  }), a.d(e, "faSnowman", function () {
    return UV;
  }), a.d(e, "faSnowmobile", function () {
    return BV;
  }), a.d(e, "faSnowplow", function () {
    return RV;
  }), a.d(e, "faSoap", function () {
    return YV;
  }), a.d(e, "faSocks", function () {
    return PV;
  }), a.d(e, "faSolarPanel", function () {
    return FV;
  }), a.d(e, "faSolarSystem", function () {
    return WV;
  }), a.d(e, "faSort", function () {
    return GV;
  }), a.d(e, "faSortAlphaDown", function () {
    return qV;
  }), a.d(e, "faSortAlphaDownAlt", function () {
    return JV;
  }), a.d(e, "faSortAlphaUp", function () {
    return KV;
  }), a.d(e, "faSortAlphaUpAlt", function () {
    return XV;
  }), a.d(e, "faSortAlt", function () {
    return _V;
  }), a.d(e, "faSortAmountDown", function () {
    return $V;
  }), a.d(e, "faSortAmountDownAlt", function () {
    return cx;
  }), a.d(e, "faSortAmountUp", function () {
    return ex;
  }), a.d(e, "faSortAmountUpAlt", function () {
    return ax;
  }), a.d(e, "faSortCircle", function () {
    return nx;
  }), a.d(e, "faSortCircleDown", function () {
    return tx;
  }), a.d(e, "faSortCircleUp", function () {
    return rx;
  }), a.d(e, "faSortDown", function () {
    return ix;
  }), a.d(e, "faSortNumericDown", function () {
    return ox;
  }), a.d(e, "faSortNumericDownAlt", function () {
    return lx;
  }), a.d(e, "faSortNumericUp", function () {
    return fx;
  }), a.d(e, "faSortNumericUpAlt", function () {
    return sx;
  }), a.d(e, "faSortShapesDown", function () {
    return ux;
  }), a.d(e, "faSortShapesDownAlt", function () {
    return hx;
  }), a.d(e, "faSortShapesUp", function () {
    return mx;
  }), a.d(e, "faSortShapesUpAlt", function () {
    return vx;
  }), a.d(e, "faSortSizeDown", function () {
    return dx;
  }), a.d(e, "faSortSizeDownAlt", function () {
    return Mx;
  }), a.d(e, "faSortSizeUp", function () {
    return px;
  }), a.d(e, "faSortSizeUpAlt", function () {
    return zx;
  }), a.d(e, "faSortUp", function () {
    return Cx;
  }), a.d(e, "faSoup", function () {
    return Lx;
  }), a.d(e, "faSpa", function () {
    return Ax;
  }), a.d(e, "faSpaceShuttle", function () {
    return Nx;
  }), a.d(e, "faSpaceStationMoon", function () {
    return gx;
  }), a.d(e, "faSpaceStationMoonAlt", function () {
    return Hx;
  }), a.d(e, "faSpade", function () {
    return Vx;
  }), a.d(e, "faSparkles", function () {
    return xx;
  }), a.d(e, "faSpeaker", function () {
    return wx;
  }), a.d(e, "faSpeakers", function () {
    return yx;
  }), a.d(e, "faSpellCheck", function () {
    return bx;
  }), a.d(e, "faSpider", function () {
    return Sx;
  }), a.d(e, "faSpiderBlackWidow", function () {
    return Tx;
  }), a.d(e, "faSpiderWeb", function () {
    return Dx;
  }), a.d(e, "faSpinner", function () {
    return jx;
  }), a.d(e, "faSpinnerThird", function () {
    return Ex;
  }), a.d(e, "faSplotch", function () {
    return kx;
  }), a.d(e, "faSprayCan", function () {
    return Ix;
  }), a.d(e, "faSprinkler", function () {
    return Ox;
  }), a.d(e, "faSquare", function () {
    return Qx;
  }), a.d(e, "faSquareFull", function () {
    return Zx;
  }), a.d(e, "faSquareRoot", function () {
    return Ux;
  }), a.d(e, "faSquareRootAlt", function () {
    return Bx;
  }), a.d(e, "faSquirrel", function () {
    return Rx;
  }), a.d(e, "faStaff", function () {
    return Yx;
  }), a.d(e, "faStamp", function () {
    return Px;
  }), a.d(e, "faStar", function () {
    return Fx;
  }), a.d(e, "faStarAndCrescent", function () {
    return Wx;
  }), a.d(e, "faStarChristmas", function () {
    return Gx;
  }), a.d(e, "faStarExclamation", function () {
    return qx;
  }), a.d(e, "faStarHalf", function () {
    return Jx;
  }), a.d(e, "faStarHalfAlt", function () {
    return Kx;
  }), a.d(e, "faStarOfDavid", function () {
    return Xx;
  }), a.d(e, "faStarOfLife", function () {
    return _x;
  }), a.d(e, "faStarShooting", function () {
    return $x;
  }), a.d(e, "faStarfighter", function () {
    return cw;
  }), a.d(e, "faStarfighterAlt", function () {
    return ew;
  }), a.d(e, "faStars", function () {
    return aw;
  }), a.d(e, "faStarship", function () {
    return nw;
  }), a.d(e, "faStarshipFreighter", function () {
    return tw;
  }), a.d(e, "faSteak", function () {
    return rw;
  }), a.d(e, "faSteeringWheel", function () {
    return iw;
  }), a.d(e, "faStepBackward", function () {
    return ow;
  }), a.d(e, "faStepForward", function () {
    return lw;
  }), a.d(e, "faStethoscope", function () {
    return fw;
  }), a.d(e, "faStickyNote", function () {
    return sw;
  }), a.d(e, "faStocking", function () {
    return uw;
  }), a.d(e, "faStomach", function () {
    return hw;
  }), a.d(e, "faStop", function () {
    return mw;
  }), a.d(e, "faStopCircle", function () {
    return vw;
  }), a.d(e, "faStopwatch", function () {
    return dw;
  }), a.d(e, "faStopwatch20", function () {
    return Mw;
  }), a.d(e, "faStore", function () {
    return pw;
  }), a.d(e, "faStoreAlt", function () {
    return zw;
  }), a.d(e, "faStoreAltSlash", function () {
    return Cw;
  }), a.d(e, "faStoreSlash", function () {
    return Lw;
  }), a.d(e, "faStream", function () {
    return Aw;
  }), a.d(e, "faStreetView", function () {
    return Nw;
  }), a.d(e, "faStretcher", function () {
    return gw;
  }), a.d(e, "faStrikethrough", function () {
    return Hw;
  }), a.d(e, "faStroopwafel", function () {
    return Vw;
  }), a.d(e, "faSubscript", function () {
    return xw;
  }), a.d(e, "faSubway", function () {
    return ww;
  }), a.d(e, "faSuitcase", function () {
    return yw;
  }), a.d(e, "faSuitcaseRolling", function () {
    return bw;
  }), a.d(e, "faSun", function () {
    return Sw;
  }), a.d(e, "faSunCloud", function () {
    return Tw;
  }), a.d(e, "faSunDust", function () {
    return Dw;
  }), a.d(e, "faSunHaze", function () {
    return jw;
  }), a.d(e, "faSunglasses", function () {
    return Ew;
  }), a.d(e, "faSunrise", function () {
    return kw;
  }), a.d(e, "faSunset", function () {
    return Iw;
  }), a.d(e, "faSuperscript", function () {
    return Ow;
  }), a.d(e, "faSurprise", function () {
    return Qw;
  }), a.d(e, "faSwatchbook", function () {
    return Zw;
  }), a.d(e, "faSwimmer", function () {
    return Uw;
  }), a.d(e, "faSwimmingPool", function () {
    return Bw;
  }), a.d(e, "faSword", function () {
    return Rw;
  }), a.d(e, "faSwordLaser", function () {
    return Yw;
  }), a.d(e, "faSwordLaserAlt", function () {
    return Pw;
  }), a.d(e, "faSwords", function () {
    return Fw;
  }), a.d(e, "faSwordsLaser", function () {
    return Ww;
  }), a.d(e, "faSynagogue", function () {
    return Gw;
  }), a.d(e, "faSync", function () {
    return qw;
  }), a.d(e, "faSyncAlt", function () {
    return Jw;
  }), a.d(e, "faSyringe", function () {
    return Kw;
  }), a.d(e, "faTable", function () {
    return Xw;
  }), a.d(e, "faTableTennis", function () {
    return _w;
  }), a.d(e, "faTablet", function () {
    return $w;
  }), a.d(e, "faTabletAlt", function () {
    return cy;
  }), a.d(e, "faTabletAndroid", function () {
    return ey;
  }), a.d(e, "faTabletAndroidAlt", function () {
    return ay;
  }), a.d(e, "faTabletRugged", function () {
    return ny;
  }), a.d(e, "faTablets", function () {
    return ty;
  }), a.d(e, "faTachometer", function () {
    return ry;
  }), a.d(e, "faTachometerAlt", function () {
    return iy;
  }), a.d(e, "faTachometerAltAverage", function () {
    return oy;
  }), a.d(e, "faTachometerAltFast", function () {
    return ly;
  }), a.d(e, "faTachometerAltFastest", function () {
    return fy;
  }), a.d(e, "faTachometerAltSlow", function () {
    return sy;
  }), a.d(e, "faTachometerAltSlowest", function () {
    return uy;
  }), a.d(e, "faTachometerAverage", function () {
    return hy;
  }), a.d(e, "faTachometerFast", function () {
    return my;
  }), a.d(e, "faTachometerFastest", function () {
    return vy;
  }), a.d(e, "faTachometerSlow", function () {
    return dy;
  }), a.d(e, "faTachometerSlowest", function () {
    return My;
  }), a.d(e, "faTaco", function () {
    return py;
  }), a.d(e, "faTag", function () {
    return zy;
  }), a.d(e, "faTags", function () {
    return Cy;
  }), a.d(e, "faTally", function () {
    return Ly;
  }), a.d(e, "faTanakh", function () {
    return Ay;
  }), a.d(e, "faTape", function () {
    return Ny;
  }), a.d(e, "faTasks", function () {
    return gy;
  }), a.d(e, "faTasksAlt", function () {
    return Hy;
  }), a.d(e, "faTaxi", function () {
    return Vy;
  }), a.d(e, "faTeeth", function () {
    return xy;
  }), a.d(e, "faTeethOpen", function () {
    return wy;
  }), a.d(e, "faTelescope", function () {
    return yy;
  }), a.d(e, "faTemperatureDown", function () {
    return by;
  }), a.d(e, "faTemperatureFrigid", function () {
    return Sy;
  }), a.d(e, "faTemperatureHigh", function () {
    return Ty;
  }), a.d(e, "faTemperatureHot", function () {
    return Dy;
  }), a.d(e, "faTemperatureLow", function () {
    return jy;
  }), a.d(e, "faTemperatureUp", function () {
    return Ey;
  }), a.d(e, "faTenge", function () {
    return ky;
  }), a.d(e, "faTennisBall", function () {
    return Iy;
  }), a.d(e, "faTerminal", function () {
    return Oy;
  });
  a.d(e, "faText", function () {
    return Qy;
  }), a.d(e, "faTextHeight", function () {
    return Zy;
  }), a.d(e, "faTextSize", function () {
    return Uy;
  }), a.d(e, "faTextWidth", function () {
    return By;
  }), a.d(e, "faTh", function () {
    return Ry;
  }), a.d(e, "faThLarge", function () {
    return Yy;
  }), a.d(e, "faThList", function () {
    return Py;
  }), a.d(e, "faTheaterMasks", function () {
    return Fy;
  }), a.d(e, "faThermometer", function () {
    return Wy;
  }), a.d(e, "faThermometerEmpty", function () {
    return Gy;
  }), a.d(e, "faThermometerFull", function () {
    return qy;
  }), a.d(e, "faThermometerHalf", function () {
    return Jy;
  }), a.d(e, "faThermometerQuarter", function () {
    return Ky;
  }), a.d(e, "faThermometerThreeQuarters", function () {
    return Xy;
  }), a.d(e, "faTheta", function () {
    return _y;
  }), a.d(e, "faThumbsDown", function () {
    return $y;
  }), a.d(e, "faThumbsUp", function () {
    return cb;
  }), a.d(e, "faThumbtack", function () {
    return eb;
  }), a.d(e, "faThunderstorm", function () {
    return ab;
  }), a.d(e, "faThunderstormMoon", function () {
    return nb;
  }), a.d(e, "faThunderstormSun", function () {
    return tb;
  }), a.d(e, "faTicket", function () {
    return rb;
  }), a.d(e, "faTicketAlt", function () {
    return ib;
  }), a.d(e, "faTilde", function () {
    return ob;
  }), a.d(e, "faTimes", function () {
    return lb;
  }), a.d(e, "faTimesCircle", function () {
    return fb;
  }), a.d(e, "faTimesHexagon", function () {
    return sb;
  }), a.d(e, "faTimesOctagon", function () {
    return ub;
  }), a.d(e, "faTimesSquare", function () {
    return hb;
  }), a.d(e, "faTint", function () {
    return mb;
  }), a.d(e, "faTintSlash", function () {
    return vb;
  }), a.d(e, "faTire", function () {
    return db;
  }), a.d(e, "faTireFlat", function () {
    return Mb;
  }), a.d(e, "faTirePressureWarning", function () {
    return pb;
  }), a.d(e, "faTireRugged", function () {
    return zb;
  }), a.d(e, "faTired", function () {
    return Cb;
  }), a.d(e, "faToggleOff", function () {
    return Lb;
  }), a.d(e, "faToggleOn", function () {
    return Ab;
  }), a.d(e, "faToilet", function () {
    return Nb;
  }), a.d(e, "faToiletPaper", function () {
    return gb;
  }), a.d(e, "faToiletPaperAlt", function () {
    return Hb;
  }), a.d(e, "faToiletPaperSlash", function () {
    return Vb;
  }), a.d(e, "faTombstone", function () {
    return xb;
  }), a.d(e, "faTombstoneAlt", function () {
    return wb;
  }), a.d(e, "faToolbox", function () {
    return yb;
  }), a.d(e, "faTools", function () {
    return bb;
  }), a.d(e, "faTooth", function () {
    return Sb;
  }), a.d(e, "faToothbrush", function () {
    return Tb;
  }), a.d(e, "faTorah", function () {
    return Db;
  }), a.d(e, "faToriiGate", function () {
    return jb;
  }), a.d(e, "faTornado", function () {
    return Eb;
  }), a.d(e, "faTractor", function () {
    return kb;
  }), a.d(e, "faTrademark", function () {
    return Ib;
  }), a.d(e, "faTrafficCone", function () {
    return Ob;
  }), a.d(e, "faTrafficLight", function () {
    return Qb;
  }), a.d(e, "faTrafficLightGo", function () {
    return Zb;
  }), a.d(e, "faTrafficLightSlow", function () {
    return Ub;
  }), a.d(e, "faTrafficLightStop", function () {
    return Bb;
  }), a.d(e, "faTrailer", function () {
    return Rb;
  }), a.d(e, "faTrain", function () {
    return Yb;
  }), a.d(e, "faTram", function () {
    return Pb;
  }), a.d(e, "faTransgender", function () {
    return Fb;
  }), a.d(e, "faTransgenderAlt", function () {
    return Wb;
  }), a.d(e, "faTransporter", function () {
    return Gb;
  }), a.d(e, "faTransporter1", function () {
    return qb;
  }), a.d(e, "faTransporter2", function () {
    return Jb;
  }), a.d(e, "faTransporter3", function () {
    return Kb;
  }), a.d(e, "faTransporterEmpty", function () {
    return Xb;
  }), a.d(e, "faTrash", function () {
    return _b;
  }), a.d(e, "faTrashAlt", function () {
    return $b;
  }), a.d(e, "faTrashRestore", function () {
    return cS;
  }), a.d(e, "faTrashRestoreAlt", function () {
    return eS;
  }), a.d(e, "faTrashUndo", function () {
    return aS;
  }), a.d(e, "faTrashUndoAlt", function () {
    return nS;
  }), a.d(e, "faTreasureChest", function () {
    return tS;
  }), a.d(e, "faTree", function () {
    return rS;
  }), a.d(e, "faTreeAlt", function () {
    return iS;
  }), a.d(e, "faTreeChristmas", function () {
    return oS;
  }), a.d(e, "faTreeDecorated", function () {
    return lS;
  }), a.d(e, "faTreeLarge", function () {
    return fS;
  }), a.d(e, "faTreePalm", function () {
    return sS;
  }), a.d(e, "faTrees", function () {
    return uS;
  }), a.d(e, "faTriangle", function () {
    return hS;
  }), a.d(e, "faTriangleMusic", function () {
    return mS;
  }), a.d(e, "faTrophy", function () {
    return vS;
  }), a.d(e, "faTrophyAlt", function () {
    return dS;
  }), a.d(e, "faTruck", function () {
    return MS;
  }), a.d(e, "faTruckContainer", function () {
    return pS;
  }), a.d(e, "faTruckCouch", function () {
    return zS;
  }), a.d(e, "faTruckLoading", function () {
    return CS;
  }), a.d(e, "faTruckMonster", function () {
    return LS;
  }), a.d(e, "faTruckMoving", function () {
    return AS;
  }), a.d(e, "faTruckPickup", function () {
    return NS;
  }), a.d(e, "faTruckPlow", function () {
    return gS;
  }), a.d(e, "faTruckRamp", function () {
    return HS;
  }), a.d(e, "faTrumpet", function () {
    return VS;
  }), a.d(e, "faTshirt", function () {
    return xS;
  }), a.d(e, "faTty", function () {
    return wS;
  }), a.d(e, "faTurkey", function () {
    return yS;
  }), a.d(e, "faTurntable", function () {
    return bS;
  }), a.d(e, "faTurtle", function () {
    return SS;
  }), a.d(e, "faTv", function () {
    return TS;
  }), a.d(e, "faTvAlt", function () {
    return DS;
  }), a.d(e, "faTvMusic", function () {
    return jS;
  }), a.d(e, "faTvRetro", function () {
    return ES;
  }), a.d(e, "faTypewriter", function () {
    return kS;
  }), a.d(e, "faUfo", function () {
    return IS;
  }), a.d(e, "faUfoBeam", function () {
    return OS;
  }), a.d(e, "faUmbrella", function () {
    return QS;
  }), a.d(e, "faUmbrellaBeach", function () {
    return ZS;
  }), a.d(e, "faUnderline", function () {
    return US;
  }), a.d(e, "faUndo", function () {
    return BS;
  }), a.d(e, "faUndoAlt", function () {
    return RS;
  }), a.d(e, "faUnicorn", function () {
    return YS;
  }), a.d(e, "faUnion", function () {
    return PS;
  }), a.d(e, "faUniversalAccess", function () {
    return FS;
  }), a.d(e, "faUniversity", function () {
    return WS;
  }), a.d(e, "faUnlink", function () {
    return GS;
  }), a.d(e, "faUnlock", function () {
    return qS;
  }), a.d(e, "faUnlockAlt", function () {
    return JS;
  }), a.d(e, "faUpload", function () {
    return KS;
  }), a.d(e, "faUsbDrive", function () {
    return XS;
  }), a.d(e, "faUsdCircle", function () {
    return _S;
  }), a.d(e, "faUsdSquare", function () {
    return $S;
  }), a.d(e, "faUser", function () {
    return cT;
  }), a.d(e, "faUserAlien", function () {
    return eT;
  }), a.d(e, "faUserAlt", function () {
    return aT;
  }), a.d(e, "faUserAltSlash", function () {
    return nT;
  }), a.d(e, "faUserAstronaut", function () {
    return tT;
  }), a.d(e, "faUserChart", function () {
    return rT;
  }), a.d(e, "faUserCheck", function () {
    return iT;
  }), a.d(e, "faUserCircle", function () {
    return oT;
  }), a.d(e, "faUserClock", function () {
    return lT;
  }), a.d(e, "faUserCog", function () {
    return fT;
  }), a.d(e, "faUserCowboy", function () {
    return sT;
  }), a.d(e, "faUserCrown", function () {
    return uT;
  }), a.d(e, "faUserEdit", function () {
    return hT;
  }), a.d(e, "faUserFriends", function () {
    return mT;
  }), a.d(e, "faUserGraduate", function () {
    return vT;
  }), a.d(e, "faUserHardHat", function () {
    return dT;
  }), a.d(e, "faUserHeadset", function () {
    return MT;
  }), a.d(e, "faUserInjured", function () {
    return pT;
  }), a.d(e, "faUserLock", function () {
    return zT;
  }), a.d(e, "faUserMd", function () {
    return CT;
  }), a.d(e, "faUserMdChat", function () {
    return LT;
  }), a.d(e, "faUserMinus", function () {
    return AT;
  }), a.d(e, "faUserMusic", function () {
    return NT;
  }), a.d(e, "faUserNinja", function () {
    return gT;
  }), a.d(e, "faUserNurse", function () {
    return HT;
  }), a.d(e, "faUserPlus", function () {
    return VT;
  }), a.d(e, "faUserRobot", function () {
    return xT;
  }), a.d(e, "faUserSecret", function () {
    return wT;
  }), a.d(e, "faUserShield", function () {
    return yT;
  }), a.d(e, "faUserSlash", function () {
    return bT;
  }), a.d(e, "faUserTag", function () {
    return ST;
  }), a.d(e, "faUserTie", function () {
    return TT;
  }), a.d(e, "faUserTimes", function () {
    return DT;
  }), a.d(e, "faUserUnlock", function () {
    return jT;
  }), a.d(e, "faUserVisor", function () {
    return ET;
  }), a.d(e, "faUsers", function () {
    return kT;
  }), a.d(e, "faUsersClass", function () {
    return IT;
  }), a.d(e, "faUsersCog", function () {
    return OT;
  }), a.d(e, "faUsersCrown", function () {
    return QT;
  }), a.d(e, "faUsersMedical", function () {
    return ZT;
  }), a.d(e, "faUsersSlash", function () {
    return UT;
  }), a.d(e, "faUtensilFork", function () {
    return BT;
  }), a.d(e, "faUtensilKnife", function () {
    return RT;
  }), a.d(e, "faUtensilSpoon", function () {
    return YT;
  }), a.d(e, "faUtensils", function () {
    return PT;
  }), a.d(e, "faUtensilsAlt", function () {
    return FT;
  }), a.d(e, "faVacuum", function () {
    return WT;
  }), a.d(e, "faVacuumRobot", function () {
    return GT;
  }), a.d(e, "faValueAbsolute", function () {
    return qT;
  }), a.d(e, "faVectorSquare", function () {
    return JT;
  }), a.d(e, "faVenus", function () {
    return KT;
  }), a.d(e, "faVenusDouble", function () {
    return XT;
  }), a.d(e, "faVenusMars", function () {
    return _T;
  }), a.d(e, "faVest", function () {
    return $T;
  }), a.d(e, "faVestPatches", function () {
    return cD;
  }), a.d(e, "faVhs", function () {
    return eD;
  }), a.d(e, "faVial", function () {
    return aD;
  }), a.d(e, "faVials", function () {
    return nD;
  }), a.d(e, "faVideo", function () {
    return tD;
  }), a.d(e, "faVideoPlus", function () {
    return rD;
  }), a.d(e, "faVideoSlash", function () {
    return iD;
  }), a.d(e, "faVihara", function () {
    return oD;
  }), a.d(e, "faViolin", function () {
    return lD;
  }), a.d(e, "faVirus", function () {
    return fD;
  }), a.d(e, "faVirusSlash", function () {
    return sD;
  }), a.d(e, "faViruses", function () {
    return uD;
  }), a.d(e, "faVoicemail", function () {
    return hD;
  }), a.d(e, "faVolcano", function () {
    return mD;
  }), a.d(e, "faVolleyballBall", function () {
    return vD;
  }), a.d(e, "faVolume", function () {
    return dD;
  }), a.d(e, "faVolumeDown", function () {
    return MD;
  }), a.d(e, "faVolumeMute", function () {
    return pD;
  }), a.d(e, "faVolumeOff", function () {
    return zD;
  }), a.d(e, "faVolumeSlash", function () {
    return CD;
  }), a.d(e, "faVolumeUp", function () {
    return LD;
  }), a.d(e, "faVoteNay", function () {
    return AD;
  }), a.d(e, "faVoteYea", function () {
    return ND;
  }), a.d(e, "faVrCardboard", function () {
    return gD;
  }), a.d(e, "faWagonCovered", function () {
    return HD;
  }), a.d(e, "faWalker", function () {
    return VD;
  }), a.d(e, "faWalkieTalkie", function () {
    return xD;
  }), a.d(e, "faWalking", function () {
    return wD;
  }), a.d(e, "faWallet", function () {
    return yD;
  }), a.d(e, "faWand", function () {
    return bD;
  }), a.d(e, "faWandMagic", function () {
    return SD;
  }), a.d(e, "faWarehouse", function () {
    return TD;
  }), a.d(e, "faWarehouseAlt", function () {
    return DD;
  }), a.d(e, "faWasher", function () {
    return jD;
  }), a.d(e, "faWatch", function () {
    return ED;
  }), a.d(e, "faWatchCalculator", function () {
    return kD;
  }), a.d(e, "faWatchFitness", function () {
    return ID;
  }), a.d(e, "faWater", function () {
    return OD;
  }), a.d(e, "faWaterLower", function () {
    return QD;
  }), a.d(e, "faWaterRise", function () {
    return ZD;
  }), a.d(e, "faWaveSine", function () {
    return UD;
  }), a.d(e, "faWaveSquare", function () {
    return BD;
  }), a.d(e, "faWaveTriangle", function () {
    return RD;
  }), a.d(e, "faWaveform", function () {
    return YD;
  }), a.d(e, "faWaveformPath", function () {
    return PD;
  }), a.d(e, "faWebcam", function () {
    return FD;
  }), a.d(e, "faWebcamSlash", function () {
    return WD;
  }), a.d(e, "faWeight", function () {
    return GD;
  }), a.d(e, "faWeightHanging", function () {
    return qD;
  }), a.d(e, "faWhale", function () {
    return JD;
  }), a.d(e, "faWheat", function () {
    return KD;
  }), a.d(e, "faWheelchair", function () {
    return XD;
  }), a.d(e, "faWhistle", function () {
    return _D;
  }), a.d(e, "faWifi", function () {
    return $D;
  }), a.d(e, "faWifi1", function () {
    return cj;
  }), a.d(e, "faWifi2", function () {
    return ej;
  }), a.d(e, "faWifiSlash", function () {
    return aj;
  }), a.d(e, "faWind", function () {
    return nj;
  }), a.d(e, "faWindTurbine", function () {
    return tj;
  }), a.d(e, "faWindWarning", function () {
    return rj;
  }), a.d(e, "faWindow", function () {
    return ij;
  }), a.d(e, "faWindowAlt", function () {
    return oj;
  }), a.d(e, "faWindowClose", function () {
    return lj;
  }), a.d(e, "faWindowFrame", function () {
    return fj;
  }), a.d(e, "faWindowFrameOpen", function () {
    return sj;
  }), a.d(e, "faWindowMaximize", function () {
    return uj;
  }), a.d(e, "faWindowMinimize", function () {
    return hj;
  }), a.d(e, "faWindowRestore", function () {
    return mj;
  }), a.d(e, "faWindsock", function () {
    return vj;
  }), a.d(e, "faWineBottle", function () {
    return dj;
  }), a.d(e, "faWineGlass", function () {
    return Mj;
  }), a.d(e, "faWineGlassAlt", function () {
    return pj;
  }), a.d(e, "faWonSign", function () {
    return zj;
  }), a.d(e, "faWreath", function () {
    return Cj;
  }), a.d(e, "faWrench", function () {
    return Lj;
  }), a.d(e, "faXRay", function () {
    return Aj;
  }), a.d(e, "faYenSign", function () {
    return Nj;
  }), a.d(e, "faYinYang", function () {
    return gj;
  });
  /*!
   * Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com
   * License - https://fontawesome.com/license (Commercial License)
   */

  var n = "fas",
      t = {
    prefix: "fas",
    iconName: "abacus",
    icon: [576, 512, [], "f640", "M32 0C14.33 0 0 14.33 0 32v464c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V32C64 14.33 49.67 0 32 0zm512 0c-17.67 0-32 14.33-32 32v464c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V32c0-17.67-14.33-32-32-32zm-80 32h-32c-8.84 0-16 7.16-16 16v24H256V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v24h-32V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-24h32v24c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-24h160v24c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16zM352 208c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v24h-32v-24c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v24h-32v-24c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-24h32v24c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-24h32v24c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-24h128v-48H352v-24zm112 144h-32c-8.84 0-16 7.16-16 16v24H256v-24c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v24h-32v-24c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-24h32v24c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-24h160v24c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16z"]
  },
      r = {
    prefix: "fas",
    iconName: "acorn",
    icon: [448, 512, [], "f6ae", "M175.11 487.55L224 512l48.89-24.45C360.6 443.7 416 354.06 416 256H32c0 98.06 55.4 187.7 143.11 231.55zM352 64H251.5c3.4-9.4 8.47-18.18 15.16-26.04 5.56-6.52 5.31-15.91-.62-21.86L254.69 4.78c-3.12-3.16-7.72-5.14-11.97-4.72-4.38.14-8.5 2.08-11.31 5.3-14.75 16.8-24.55 37.06-29.39 58.65H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32C448 106.98 405.02 64 352 64z"]
  },
      i = {
    prefix: "fas",
    iconName: "ad",
    icon: [512, 512, [], "f641", "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"]
  },
      o = {
    prefix: "fas",
    iconName: "address-book",
    icon: [448, 512, [], "f2b9", "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"]
  },
      l = {
    prefix: "fas",
    iconName: "address-card",
    icon: [576, 512, [], "f2bb", "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"]
  },
      f = {
    prefix: "fas",
    iconName: "adjust",
    icon: [512, 512, [], "f042", "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"]
  },
      s = {
    prefix: "fas",
    iconName: "air-conditioner",
    icon: [576, 512, [], "f8f4", "M544,0H32A32,32,0,0,0,0,32V192a32,32,0,0,0,32,32H544a32,32,0,0,0,32-32V32A32,32,0,0,0,544,0ZM512,160H64V128H512ZM216,424a40,40,0,0,1-40,40h-6.22c-20,0-38.18-13.88-41.28-33.61-2.88-18.41,6.92-34.22,21.84-41.47,5.73-2.78,9.66-8.25,9.66-14.63V356.67a16.1,16.1,0,0,0-21.42-15.17A87.55,87.55,0,0,0,80.7,435.24C86.26,479.82,126.55,512,171.47,512H176a88,88,0,0,0,88-88V256H216ZM437.42,309.5A16.1,16.1,0,0,0,416,324.67v17.62c0,6.38,3.93,11.85,9.66,14.63,14.92,7.25,24.72,23.06,21.84,41.47C444.4,418.12,426.2,432,406.22,432H400a40,40,0,0,1-40-40V256H312V392a88,88,0,0,0,88,88h4.53c44.92,0,85.21-32.18,90.77-76.76A87.55,87.55,0,0,0,437.42,309.5Z"]
  },
      u = {
    prefix: "fas",
    iconName: "air-freshener",
    icon: [512, 512, [], "f5d0", "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"]
  },
      h = {
    prefix: "fas",
    iconName: "alarm-clock",
    icon: [512, 512, [], "f34e", "M96 0A96 96 0 0 0 0 96a94.81 94.81 0 0 0 15.3 51.26L161.2 25.68A95.63 95.63 0 0 0 96 0zm320 0a95.66 95.66 0 0 0-65.18 25.66l145.89 121.57A94.85 94.85 0 0 0 512 96a96 96 0 0 0-96-96zM256 64C132.3 64 32 164.29 32 288a222.7 222.7 0 0 0 44.79 134l-40.1 40.09a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0L122 467.22a222.82 222.82 0 0 0 268 0l40.1 40.09a16 16 0 0 0 22.62 0l22.63-22.62a16 16 0 0 0 0-22.63L435.25 422A222.69 222.69 0 0 0 480 288c0-123.71-100.26-224-224-224zm90 291.51l-20 25a16 16 0 0 1-22.49 2.5L239 331.39a40 40 0 0 1-15-31.23V176a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v112.62l55.5 44.4a16 16 0 0 1 2.5 22.49z"]
  },
      m = {
    prefix: "fas",
    iconName: "alarm-exclamation",
    icon: [512, 512, [], "f843", "M96 0A96 96 0 0 0 0 96a94.81 94.81 0 0 0 15.3 51.26L161.2 25.68A95.63 95.63 0 0 0 96 0zm320 0a95.66 95.66 0 0 0-65.18 25.66l145.89 121.57A94.85 94.85 0 0 0 512 96a96 96 0 0 0-96-96zM256 64C132.3 64 32 164.29 32 288a222.7 222.7 0 0 0 44.79 134l-40.1 40.09a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0L122 467.22a222.82 222.82 0 0 0 268 0l40.1 40.09a16 16 0 0 0 22.62 0l22.63-22.62a16 16 0 0 0 0-22.63L435.25 422A222.69 222.69 0 0 0 480 288c0-123.71-100.26-224-224-224zm0 352a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm25.4-110.4a16 16 0 0 1-15.9 14.4h-19a16 16 0 0 1-15.9-14.4l-12.8-128a16.06 16.06 0 0 1 15.9-17.6h44.6a16 16 0 0 1 15.9 17.6z"]
  },
      v = {
    prefix: "fas",
    iconName: "alarm-plus",
    icon: [512, 512, [], "f844", "M96 0A96 96 0 0 0 0 96a94.81 94.81 0 0 0 15.3 51.26L161.2 25.68A95.63 95.63 0 0 0 96 0zm320 0a95.66 95.66 0 0 0-65.18 25.66l145.89 121.57A94.85 94.85 0 0 0 512 96a96 96 0 0 0-96-96zM256 64C132.3 64 32 164.29 32 288a222.7 222.7 0 0 0 44.79 134l-40.1 40.09a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0L122 467.22a222.82 222.82 0 0 0 268 0l40.1 40.09a16 16 0 0 0 22.62 0l22.63-22.62a16 16 0 0 0 0-22.63L435.25 422A222.69 222.69 0 0 0 480 288c0-123.71-100.26-224-224-224zm112 232a16 16 0 0 1-16 16h-72v72a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-72h-72a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h72v-72a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16v72h72a16 16 0 0 1 16 16z"]
  },
      d = {
    prefix: "fas",
    iconName: "alarm-snooze",
    icon: [512, 512, [], "f845", "M96 0A96 96 0 0 0 0 96a94.81 94.81 0 0 0 15.3 51.26L161.2 25.68A95.63 95.63 0 0 0 96 0zm320 0a95.66 95.66 0 0 0-65.18 25.66l145.89 121.57A94.85 94.85 0 0 0 512 96a96 96 0 0 0-96-96zM256 64C132.3 64 32 164.29 32 288a222.7 222.7 0 0 0 44.79 134l-40.1 40.09a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0L122 467.22a222.82 222.82 0 0 0 268 0l40.1 40.09a16 16 0 0 0 22.62 0l22.63-22.62a16 16 0 0 0 0-22.63L435.25 422A222.69 222.69 0 0 0 480 288c0-123.71-100.26-224-224-224zm82.7 159l-96.8 121H320a16 16 0 0 1 16 16v16a16 16 0 0 1-16 16H192a24 24 0 0 1-18.74-39L270 232h-78a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h128a24 24 0 0 1 18.73 39z"]
  },
      M = {
    prefix: "fas",
    iconName: "album",
    icon: [448, 512, [], "f89f", "M224 224a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zM224 416a160 160 0 1 1 160-160 160 160 0 0 1-160 160z"]
  },
      p = {
    prefix: "fas",
    iconName: "album-collection",
    icon: [512, 512, [], "f8a0", "M496 104a24 24 0 0 0-24-24H40a24 24 0 0 0-24 24v24h480zm-16-80a24 24 0 0 0-24-24H56a24 24 0 0 0-24 24v24h448zM256 325.65c-16.63 0-30 9.93-29.86 22.09s13.5 21.72 29.86 21.72 29.73-9.68 29.87-21.72-13.23-22.09-29.87-22.09zM480 160H32A32 32 0 0 0 .13 194.9l26.19 288A32 32 0 0 0 58.18 512h395.64a32 32 0 0 0 31.86-29.1l26.19-288A32 32 0 0 0 480 160zM256 472.89c-94.26 0-174.39-54.53-179.21-125.15C71.71 273.1 151.82 209.4 256 209.4s184.29 63.7 179.21 138.34c-4.82 70.63-84.95 125.15-179.21 125.15z"]
  },
      z = {
    prefix: "fas",
    iconName: "alicorn",
    icon: [640, 512, [], "f6b0", "M631.98 32H531.73c5.93-6.14 10.4-13.63 12.18-22.36 1.01-4.96-2.88-9.64-7.94-9.64H416c-70.69 0-128 57.31-128 128h-.08c-63.92 0-104.2-36.78-127.66-90.27-3.22-7.35-13.61-7.76-17.04-.5C133.49 57.82 128 80.8 128 105.1c0 67.04 51.01 133.09 128 147.74v3.17c-76.89 0-133.8-49.67-152.67-108.99-5.58 4.17-10.75 8.86-15.33 14.1V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59 102.04 22.33V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74L544 83.3l92.42-36.65c6.59-4.38 3.48-14.65-4.44-14.65zM480 96c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      C = {
    prefix: "fas",
    iconName: "alien",
    icon: [448, 512, [], "f8f5", "M224,0C100.28125,0,0,88.0293,0,232.45117,0,344.22852,134.21484,457.04883,194.86328,502.32422a48.70766,48.70766,0,0,0,58.27344,0C313.78516,457.04883,448,344.22852,448,232.45117,448,88.0293,347.71875,0,224,0ZM176,320H144a80.00021,80.00021,0,0,1-80-80,15.99954,15.99954,0,0,1,16-16h32a79.999,79.999,0,0,1,80,80A16.00079,16.00079,0,0,1,176,320Zm128,0H272a16.00079,16.00079,0,0,1-16-16,79.999,79.999,0,0,1,80-80h32a15.99954,15.99954,0,0,1,16,16A80.00021,80.00021,0,0,1,304,320Z"]
  },
      L = {
    prefix: "fas",
    iconName: "alien-monster",
    icon: [576, 512, [], "f8f6", "M560,128H528a15.99954,15.99954,0,0,0-16,16v80H480V176a15.99954,15.99954,0,0,0-16-16H416V96h48a16.00079,16.00079,0,0,0,16-16V48a15.99954,15.99954,0,0,0-16-16H432a15.99954,15.99954,0,0,0-16,16V64H368a15.99954,15.99954,0,0,0-16,16v48H224V80a15.99954,15.99954,0,0,0-16-16H160V48a15.99954,15.99954,0,0,0-16-16H112A15.99954,15.99954,0,0,0,96,48V80a16.00079,16.00079,0,0,0,16,16h48v64H112a15.99954,15.99954,0,0,0-16,16v48H64V144a15.99954,15.99954,0,0,0-16-16H16A15.99954,15.99954,0,0,0,0,144V272a16.00079,16.00079,0,0,0,16,16H64v80a16.00079,16.00079,0,0,0,16,16h48v80a16.00079,16.00079,0,0,0,16,16h96a16.00079,16.00079,0,0,0,16-16V432a15.99954,15.99954,0,0,0-16-16H192V384H384v32H336a15.99954,15.99954,0,0,0-16,16v32a16.00079,16.00079,0,0,0,16,16h96a16.00079,16.00079,0,0,0,16-16V384h48a16.00079,16.00079,0,0,0,16-16V288h48a16.00079,16.00079,0,0,0,16-16V144A15.99954,15.99954,0,0,0,560,128ZM224,320H160V224h64Zm192,0H352V224h64Z"]
  },
      A = {
    prefix: "fas",
    iconName: "align-center",
    icon: [448, 512, [], "f037", "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"]
  },
      N = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      g = {
    prefix: "fas",
    iconName: "align-left",
    icon: [448, 512, [], "f036", "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      H = {
    prefix: "fas",
    iconName: "align-right",
    icon: [448, 512, [], "f038", "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"]
  },
      V = {
    prefix: "fas",
    iconName: "align-slash",
    icon: [640, 512, [], "f846", "M633.82 458.1L496.54 352H528a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H413.73l-82.81-64H528a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H248.12l-82.81-64H528a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H112a15.82 15.82 0 0 0-15 11.18L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM112 416a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h340.83L370 416zm0-64h175.21l-82.8-64H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16z"]
  },
      x = {
    prefix: "fas",
    iconName: "allergies",
    icon: [448, 512, [], "f461", "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      w = {
    prefix: "fas",
    iconName: "ambulance",
    icon: [640, 512, [], "f0f9", "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"]
  },
      y = {
    prefix: "fas",
    iconName: "american-sign-language-interpreting",
    icon: [640, 512, [], "f2a3", "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"]
  },
      b = {
    prefix: "fas",
    iconName: "amp-guitar",
    icon: [512, 512, [], "f8a1", "M120 224a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm272 0a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm72-144h-61.5C377.75 52.71 321.51 0 256 0S134.25 52.71 109.5 80H48a48 48 0 0 0-48 48v336a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V128a48 48 0 0 0-48-48zM256 48c26.9 0 54 14.79 76.25 32h-152.5C202 62.77 229.1 48 256 48zM96 400a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm32 48a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm-16-112a16 16 0 1 1 16 16 16 16 0 0 1-16-16zm48 64a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm32 48a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm-16-112a16 16 0 1 1 16 16 16 16 0 0 1-16-16zm48 64a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm32 48a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm-16-112a16 16 0 1 1 16 16 16 16 0 0 1-16-16zm48 64a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm32 48a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm-16-112a16 16 0 1 1 16 16 16 16 0 0 1-16-16zm48 64a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm32 48a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm-16-112a16 16 0 1 1 16 16 16 16 0 0 1-16-16zm48 64a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm32-144H64V144h384zm-248-32a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm112 0a24 24 0 1 0-24-24 24 24 0 0 0 24 24z"]
  },
      S = {
    prefix: "fas",
    iconName: "analytics",
    icon: [576, 512, [], "f643", "M510.62 92.63C516.03 94.74 521.85 96 528 96c26.51 0 48-21.49 48-48S554.51 0 528 0s-48 21.49-48 48c0 2.43.37 4.76.71 7.09l-95.34 76.27c-5.4-2.11-11.23-3.37-17.38-3.37s-11.97 1.26-17.38 3.37L255.29 55.1c.35-2.33.71-4.67.71-7.1 0-26.51-21.49-48-48-48s-48 21.49-48 48c0 4.27.74 8.34 1.78 12.28l-101.5 101.5C56.34 160.74 52.27 160 48 160c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-4.27-.74-8.34-1.78-12.28l101.5-101.5C199.66 95.26 203.73 96 208 96c6.15 0 11.97-1.26 17.38-3.37l95.34 76.27c-.35 2.33-.71 4.67-.71 7.1 0 26.51 21.49 48 48 48s48-21.49 48-48c0-2.43-.37-4.76-.71-7.09l95.32-76.28zM400 320h-64c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V336c0-8.84-7.16-16-16-16zm160-128h-64c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm-320 0h-64c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zM80 352H16c-8.84 0-16 7.16-16 16v128c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V368c0-8.84-7.16-16-16-16z"]
  },
      T = {
    prefix: "fas",
    iconName: "anchor",
    icon: [576, 512, [], "f13d", "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"]
  },
      D = {
    prefix: "fas",
    iconName: "angel",
    icon: [576, 512, [], "f779", "M208 144c0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80-80 35.8-80 80zm-23.5-42.6c4.1-9.9 9.9-18.9 16.6-27.1-5.8-4.1-9.1-7.9-9.1-10.3 0-8 34-32 96-32s96 24 96 32c0 2.3-3.3 6.1-9.1 10.3 6.6 8.3 12.4 17.2 16.6 27.1C406.7 90.9 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9.3 26.9 24.5 37.4zm387.3 351.7l-38.2-78.6c-6.6-13.5-6.6-29.6 0-43.1 4.8-9.8 8.7-16.7 11.9-22.1C555 292.7 560 282.8 560 256c0-51.1-46.9-96-100.4-96-24.8 0-49 10.3-66.3 28.1l-72.7 73.4c-10.3-3.4-21.2-5.4-32.5-5.4s-22.1 2-32.5 5.4L183 188.2c-17.5-18-41.7-28.2-66.5-28.2C63 160 16 204.9 16 256c0 26.8 5 36.7 14.5 53.2 3.2 5.5 7.1 12.3 11.9 22.1 6.6 13.5 6.6 29.6 0 43.1L4.2 453.1C-2.1 466-1.3 480.9 6.3 493c7.5 11.9 20.2 19 34.2 19h495.1c13.9 0 26.7-7.1 34.2-19 7.5-12.1 8.3-27.1 2-39.9zM195.4 313.2L120 464H52.2l33.4-68.6c13-26.6 13-58.5 0-85.1-5.4-11.2-9.9-18.9-13.5-25.1-7.2-12.4-8.1-14-8.1-29.2 0-24.7 25.5-48 52.4-48 12.1 0 23.5 4.9 32.2 13.9l65.1 65.6c-7.2 7.5-13.5 16.1-18.3 25.7zM456 464l-75.4-150.8c-4.8-9.6-11.1-18.2-18.4-25.7l65.3-65.8c8.6-8.8 20-13.7 32.1-13.7 27 0 52.4 23.3 52.4 48 0 15.2-.9 16.8-8.1 29.2-3.6 6.2-8 14-13.5 25.1-13 26.6-13 58.5 0 85.1l33.4 68.6H456z"]
  },
      j = {
    prefix: "fas",
    iconName: "angle-double-down",
    icon: [320, 512, [], "f103", "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"]
  },
      E = {
    prefix: "fas",
    iconName: "angle-double-left",
    icon: [448, 512, [], "f100", "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"]
  },
      k = {
    prefix: "fas",
    iconName: "angle-double-right",
    icon: [448, 512, [], "f101", "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"]
  },
      I = {
    prefix: "fas",
    iconName: "angle-double-up",
    icon: [320, 512, [], "f102", "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"]
  },
      O = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [320, 512, [], "f107", "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"]
  },
      Q = {
    prefix: "fas",
    iconName: "angle-left",
    icon: [256, 512, [], "f104", "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"]
  },
      Z = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [256, 512, [], "f105", "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"]
  },
      U = {
    prefix: "fas",
    iconName: "angle-up",
    icon: [320, 512, [], "f106", "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"]
  },
      B = {
    prefix: "fas",
    iconName: "angry",
    icon: [496, 512, [], "f556", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"]
  },
      R = {
    prefix: "fas",
    iconName: "ankh",
    icon: [320, 512, [], "f644", "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"]
  },
      Y = {
    prefix: "fas",
    iconName: "apple-alt",
    icon: [448, 512, [], "f5d1", "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"]
  },
      P = {
    prefix: "fas",
    iconName: "apple-crate",
    icon: [512, 512, [], "f6b1", "M318.2 192h159.79c5.26-39.47-5.15-102.65-53.82-111.39-18.13-3.03-51.9 6.18-72.49 17.69-17.01-9.52-42.45-16.98-61.15-17.79 1.82 2.21 3.83 4.17 5.5 6.58 20.84 30.15 25.74 72.3 22.17 104.91zM210.53 50.47c11.29-12.19 14.43-32.03 13.22-50.22-12.88-.86-35.67-.12-50.02 13.28-16.53 16.6-13.77 46.36-13.22 50.22 18.47 1.23 37.77-1.85 50.02-13.28zm191.69 0c11.29-12.19 14.43-32.03 13.22-50.22-12.88-.86-35.67-.12-50.02 13.28-16.53 16.6-13.77 46.36-13.22 50.22 18.47 1.23 37.77-1.85 50.02-13.28zM286.3 192c5.26-39.47-5.15-102.65-53.82-111.39-18.13-3.03-51.9 6.18-72.48 17.69-20.66-11.56-54.43-20.71-72.48-17.69C38.91 89.34 28.53 152.88 33.7 192h252.6zM496 224H16c-8.84 0-16 7.16-16 16v112h512V240c0-8.84-7.16-16-16-16zM64 304c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm384 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM0 496c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16V384H0v112zm448-64c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm-384 0c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16z"]
  },
      F = {
    prefix: "fas",
    iconName: "archive",
    icon: [512, 512, [], "f187", "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"]
  },
      W = {
    prefix: "fas",
    iconName: "archway",
    icon: [576, 512, [], "f557", "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"]
  },
      G = {
    prefix: "fas",
    iconName: "arrow-alt-circle-down",
    icon: [512, 512, [], "f358", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"]
  },
      q = {
    prefix: "fas",
    iconName: "arrow-alt-circle-left",
    icon: [512, 512, [], "f359", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"]
  },
      J = {
    prefix: "fas",
    iconName: "arrow-alt-circle-right",
    icon: [512, 512, [], "f35a", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"]
  },
      K = {
    prefix: "fas",
    iconName: "arrow-alt-circle-up",
    icon: [512, 512, [], "f35b", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"]
  },
      X = {
    prefix: "fas",
    iconName: "arrow-alt-down",
    icon: [448, 512, [], "f354", "M176 32h96c13.3 0 24 10.7 24 24v200h103.8c21.4 0 32.1 25.8 17 41L241 473c-9.4 9.4-24.6 9.4-34 0L31.3 297c-15.1-15.1-4.4-41 17-41H152V56c0-13.3 10.7-24 24-24z"]
  },
      _ = {
    prefix: "fas",
    iconName: "arrow-alt-from-bottom",
    icon: [384, 512, [], "f346", "M360 480H24c-13.3 0-24-10.7-24-24v-24c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24v24c0 13.3-10.7 24-24 24zM256 360V224h87.7c17.8 0 26.7-21.5 14.1-34.1L205.7 37.7c-7.5-7.5-19.8-7.5-27.3 0L26.1 189.9C13.5 202.5 22.5 224 40.3 224H128v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24z"]
  },
      $ = {
    prefix: "fas",
    iconName: "arrow-alt-from-left",
    icon: [448, 512, [], "f347", "M0 424V88c0-13.3 10.7-24 24-24h24c13.3 0 24 10.7 24 24v336c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm120-104h136v87.7c0 17.8 21.5 26.7 34.1 14.1l152.2-152.2c7.5-7.5 7.5-19.8 0-27.3L290.1 90.1c-12.6-12.6-34.1-3.7-34.1 14.1V192H120c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24z"]
  },
      cc = {
    prefix: "fas",
    iconName: "arrow-alt-from-right",
    icon: [448, 512, [], "f348", "M448 88v336c0 13.3-10.7 24-24 24h-24c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24h24c13.3 0 24 10.7 24 24zM328 192H192v-87.7c0-17.8-21.5-26.7-34.1-14.1L5.7 242.3c-7.5 7.5-7.5 19.8 0 27.3l152.2 152.2c12.6 12.6 34.1 3.7 34.1-14.1V320h136c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24z"]
  },
      ec = {
    prefix: "fas",
    iconName: "arrow-alt-from-top",
    icon: [384, 512, [], "f349", "M24 32h336c13.3 0 24 10.7 24 24v24c0 13.3-10.7 24-24 24H24C10.7 104 0 93.3 0 80V56c0-13.3 10.7-24 24-24zm104 120v136H40.3c-17.8 0-26.7 21.5-14.1 34.1l152.2 152.2c7.5 7.5 19.8 7.5 27.3 0l152.2-152.2c12.6-12.6 3.7-34.1-14.1-34.1H256V152c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24z"]
  },
      ac = {
    prefix: "fas",
    iconName: "arrow-alt-left",
    icon: [448, 512, [], "f355", "M448 208v96c0 13.3-10.7 24-24 24H224v103.8c0 21.4-25.8 32.1-41 17L7 273c-9.4-9.4-9.4-24.6 0-34L183 63.3c15.1-15.1 41-4.4 41 17V184h200c13.3 0 24 10.7 24 24z"]
  },
      nc = {
    prefix: "fas",
    iconName: "arrow-alt-right",
    icon: [448, 512, [], "f356", "M0 304v-96c0-13.3 10.7-24 24-24h200V80.2c0-21.4 25.8-32.1 41-17L441 239c9.4 9.4 9.4 24.6 0 34L265 448.7c-15.1 15.1-41 4.4-41-17V328H24c-13.3 0-24-10.7-24-24z"]
  },
      tc = {
    prefix: "fas",
    iconName: "arrow-alt-square-down",
    icon: [448, 512, [], "f350", "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-268 60v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H268V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"]
  },
      rc = {
    prefix: "fas",
    iconName: "arrow-alt-square-left",
    icon: [448, 512, [], "f351", "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm-60-268H224v-70.9c0-10.7-13-16.1-20.5-8.5L89.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"]
  },
      ic = {
    prefix: "fas",
    iconName: "arrow-alt-square-right",
    icon: [448, 512, [], "f352", "M48 32h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm60 268h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H108c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"]
  },
      oc = {
    prefix: "fas",
    iconName: "arrow-alt-square-up",
    icon: [448, 512, [], "f353", "M0 432V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm268-60V256h70.9c10.7 0 16.1-13 8.5-20.5L232.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3C93 243 98.4 256 109.1 256H180v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"]
  },
      lc = {
    prefix: "fas",
    iconName: "arrow-alt-to-bottom",
    icon: [384, 512, [], "f34a", "M360 480H24c-13.3 0-24-10.7-24-24v-24c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24v24c0 13.3-10.7 24-24 24zM128 56v136H40.3c-17.8 0-26.7 21.5-14.1 34.1l152.2 152.2c7.5 7.5 19.8 7.5 27.3 0l152.2-152.2c12.6-12.6 3.7-34.1-14.1-34.1H256V56c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24z"]
  },
      fc = {
    prefix: "fas",
    iconName: "arrow-alt-to-left",
    icon: [448, 512, [], "f34b", "M0 424V88c0-13.3 10.7-24 24-24h24c13.3 0 24 10.7 24 24v336c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm424-232H288v-87.7c0-17.8-21.5-26.7-34.1-14.1L101.7 242.3c-7.5 7.5-7.5 19.8 0 27.3l152.2 152.2c12.6 12.6 34.1 3.7 34.1-14.1V320h136c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24z"]
  },
      sc = {
    prefix: "fas",
    iconName: "arrow-alt-to-right",
    icon: [448, 512, [], "f34c", "M448 88v336c0 13.3-10.7 24-24 24h-24c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24h24c13.3 0 24 10.7 24 24zM24 320h136v87.7c0 17.8 21.5 26.7 34.1 14.1l152.2-152.2c7.5-7.5 7.5-19.8 0-27.3L194.1 90.1c-12.6-12.6-34.1-3.7-34.1 14.1V192H24c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24z"]
  },
      uc = {
    prefix: "fas",
    iconName: "arrow-alt-to-top",
    icon: [384, 512, [], "f34d", "M24 32h336c13.3 0 24 10.7 24 24v24c0 13.3-10.7 24-24 24H24C10.7 104 0 93.3 0 80V56c0-13.3 10.7-24 24-24zm232 424V320h87.7c17.8 0 26.7-21.5 14.1-34.1L205.7 133.7c-7.5-7.5-19.8-7.5-27.3 0L26.1 285.9C13.5 298.5 22.5 320 40.3 320H128v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24z"]
  },
      hc = {
    prefix: "fas",
    iconName: "arrow-alt-up",
    icon: [448, 512, [], "f357", "M272 480h-96c-13.3 0-24-10.7-24-24V256H48.2c-21.4 0-32.1-25.8-17-41L207 39c9.4-9.4 24.6-9.4 34 0l175.8 176c15.1 15.1 4.4 41-17 41H296v200c0 13.3-10.7 24-24 24z"]
  },
      mc = {
    prefix: "fas",
    iconName: "arrow-circle-down",
    icon: [512, 512, [], "f0ab", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"]
  },
      vc = {
    prefix: "fas",
    iconName: "arrow-circle-left",
    icon: [512, 512, [], "f0a8", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"]
  },
      dc = {
    prefix: "fas",
    iconName: "arrow-circle-right",
    icon: [512, 512, [], "f0a9", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"]
  },
      Mc = {
    prefix: "fas",
    iconName: "arrow-circle-up",
    icon: [512, 512, [], "f0aa", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"]
  },
      pc = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [448, 512, [], "f063", "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"]
  },
      zc = {
    prefix: "fas",
    iconName: "arrow-from-bottom",
    icon: [384, 512, [], "f342", "M360 480H24c-13.3 0-24-10.7-24-24v-24c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24v24c0 13.3-10.7 24-24 24zM90.4 216.5l65.6-65.6V360c0 13.3 10.7 24 24 24h24c13.3 0 24-10.7 24-24V150.9l65.6 65.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L209 30.1c-9.4-9.4-24.6-9.4-33.9 0L39.5 165.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0z"]
  },
      Cc = {
    prefix: "fas",
    iconName: "arrow-from-left",
    icon: [448, 512, [], "f343", "M0 424V88c0-13.3 10.7-24 24-24h24c13.3 0 24 10.7 24 24v336c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm254.5-269.6l65.6 65.6H120c-13.3 0-24 10.7-24 24v24c0 13.3 10.7 24 24 24h200.1l-65.6 65.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L441 273c9.4-9.4 9.4-24.6 0-33.9L305.5 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6-.1 33.9z"]
  },
      Lc = {
    prefix: "fas",
    iconName: "arrow-from-right",
    icon: [448, 512, [], "f344", "M448 88v336c0 13.3-10.7 24-24 24h-24c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24h24c13.3 0 24 10.7 24 24zM193.5 357.6L127.9 292H328c13.3 0 24-10.7 24-24v-24c0-13.3-10.7-24-24-24H127.9l65.6-65.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.3 9.4-24.5.1-33.8z"]
  },
      Ac = {
    prefix: "fas",
    iconName: "arrow-from-top",
    icon: [384, 512, [], "f345", "M24 32h336c13.3 0 24 10.7 24 24v24c0 13.3-10.7 24-24 24H24C10.7 104 0 93.3 0 80V56c0-13.3 10.7-24 24-24zm269.6 263.5L228 361.1V152c0-13.3-10.7-24-24-24h-24c-13.3 0-24 10.7-24 24v209.1l-65.6-65.6c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L175 481.9c9.4 9.4 24.6 9.4 33.9 0l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.3-9.4-24.5-9.4-33.8 0z"]
  },
      Nc = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [448, 512, [], "f060", "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"]
  },
      gc = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [448, 512, [], "f061", "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"]
  },
      Hc = {
    prefix: "fas",
    iconName: "arrow-square-down",
    icon: [448, 512, [], "f339", "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM328.4 227.1L256 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L207 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"]
  },
      Vc = {
    prefix: "fas",
    iconName: "arrow-square-left",
    icon: [448, 512, [], "f33a", "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM252.9 360.4L177.4 288H360c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H177.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L75.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"]
  },
      xc = {
    prefix: "fas",
    iconName: "arrow-square-right",
    icon: [448, 512, [], "f33b", "M48 32h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm147.1 119.6l75.5 72.4H88c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L372.3 273c9.4-9.4 9.4-24.6 0-33.9L239.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"]
  },
      wc = {
    prefix: "fas",
    iconName: "arrow-square-up",
    icon: [448, 512, [], "f33c", "M0 432V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48zm119.6-147.1l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L241 107.7c-9.4-9.4-24.6-9.4-33.9 0L74.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"]
  },
      yc = {
    prefix: "fas",
    iconName: "arrow-to-bottom",
    icon: [384, 512, [], "f33d", "M360 480H24c-13.3 0-24-10.7-24-24v-24c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24v24c0 13.3-10.7 24-24 24zm-66.4-280.5L228 265.1V56c0-13.3-10.7-24-24-24h-24c-13.3 0-24 10.7-24 24v209.1l-65.6-65.6c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L175 385.9c9.4 9.4 24.6 9.4 33.9 0l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.3-9.4-24.5-9.4-33.8 0z"]
  },
      bc = {
    prefix: "fas",
    iconName: "arrow-to-left",
    icon: [448, 512, [], "f33e", "M0 424V88c0-13.3 10.7-24 24-24h24c13.3 0 24 10.7 24 24v336c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm280.5-66.4L214.9 292H424c13.3 0 24-10.7 24-24v-24c0-13.3-10.7-24-24-24H214.9l65.6-65.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L94.1 239c-9.4 9.4-9.4 24.6 0 33.9l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.3 9.4-24.5 0-33.8z"]
  },
      Sc = {
    prefix: "fas",
    iconName: "arrow-to-right",
    icon: [448, 512, [], "f340", "M448 88v336c0 13.3-10.7 24-24 24h-24c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24h24c13.3 0 24 10.7 24 24zm-280.5 66.4l65.6 65.6H24c-13.3 0-24 10.7-24 24v24c0 13.3 10.7 24 24 24h209.1l-65.6 65.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L353.9 273c9.4-9.4 9.4-24.6 0-33.9L218.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9z"]
  },
      Tc = {
    prefix: "fas",
    iconName: "arrow-to-top",
    icon: [384, 512, [], "f341", "M24 32h336c13.3 0 24 10.7 24 24v24c0 13.3-10.7 24-24 24H24C10.7 104 0 93.3 0 80V56c0-13.3 10.7-24 24-24zm66.4 280.5l65.6-65.6V456c0 13.3 10.7 24 24 24h24c13.3 0 24-10.7 24-24V246.9l65.6 65.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L209 126.1c-9.4-9.4-24.6-9.4-33.9 0L39.5 261.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0z"]
  },
      Dc = {
    prefix: "fas",
    iconName: "arrow-up",
    icon: [448, 512, [], "f062", "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"]
  },
      jc = {
    prefix: "fas",
    iconName: "arrows",
    icon: [512, 512, [], "f047", "M352.634 428.621l-74.007 74.007c-12.497 12.497-32.758 12.497-45.255 0l-74.007-74.007c-9.373-9.373-9.373-24.569 0-33.941l10.84-10.84c9.556-9.556 25.113-9.341 34.402.474L228 410.365V284H101.635l26.051 23.392c9.815 9.289 10.03 24.846.474 34.402l-10.84 10.84c-9.373 9.373-24.569 9.373-33.941 0L9.373 278.627c-12.497-12.497-12.497-32.758 0-45.255l74.007-74.007c9.373-9.373 24.569-9.373 33.941 0l10.84 10.84c9.556 9.556 9.341 25.114-.474 34.402L101.635 228H228V101.635l-23.392 26.051c-9.289 9.815-24.846 10.03-34.402.474l-10.84-10.84c-9.373-9.373-9.373-24.569 0-33.941l74.007-74.007c12.497-12.497 32.758-12.497 45.255 0l74.007 74.007c9.373 9.373 9.373 24.569 0 33.941l-10.84 10.84c-9.556 9.556-25.113 9.341-34.402-.474L284 101.635V228h126.365l-26.051-23.392c-9.815-9.289-10.03-24.846-.474-34.402l10.84-10.84c9.373-9.373 24.569-9.373 33.941 0l74.007 74.007c12.497 12.497 12.497 32.758 0 45.255l-74.007 74.007c-9.373 9.373-24.569 9.373-33.941 0l-10.84-10.84c-9.556-9.556-9.341-25.113.474-34.402L410.365 284H284v126.365l23.392-26.051c9.289-9.815 24.846-10.03 34.402-.474l10.84 10.84c9.373 9.372 9.373 24.568 0 33.941z"]
  },
      Ec = {
    prefix: "fas",
    iconName: "arrows-alt",
    icon: [512, 512, [], "f0b2", "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"]
  },
      kc = {
    prefix: "fas",
    iconName: "arrows-alt-h",
    icon: [512, 512, [], "f337", "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"]
  },
      Ic = {
    prefix: "fas",
    iconName: "arrows-alt-v",
    icon: [256, 512, [], "f338", "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"]
  },
      Oc = {
    prefix: "fas",
    iconName: "arrows-h",
    icon: [512, 512, [], "f07e", "M105.815 288h300.371l-46.208 43.728c-9.815 9.289-10.03 24.846-.474 34.402l10.84 10.84c9.373 9.373 24.569 9.373 33.941 0l98.343-98.343c12.497-12.497 12.497-32.758 0-45.255l-98.343-98.343c-9.373-9.373-24.569-9.373-33.941 0l-10.84 10.84c-9.556 9.556-9.341 25.113.474 34.402L406.186 224H105.815l46.208-43.728c9.815-9.289 10.03-24.846.474-34.402l-10.84-10.84c-9.373-9.373-24.569-9.373-33.941 0L9.373 233.372c-12.497 12.497-12.497 32.758 0 45.255l98.343 98.343c9.373 9.373 24.569 9.373 33.941 0l10.84-10.84c9.556-9.556 9.341-25.113-.474-34.402L105.815 288z"]
  },
      Qc = {
    prefix: "fas",
    iconName: "arrows-v",
    icon: [256, 512, [], "f07d", "M160 406.186V105.815l43.728 46.208c9.289 9.815 24.846 10.03 34.402.474l10.84-10.84c9.373-9.373 9.373-24.569 0-33.941L150.627 9.373c-12.497-12.497-32.758-12.497-45.255 0L7.029 107.715c-9.373 9.373-9.373 24.569 0 33.941l10.84 10.84c9.556 9.556 25.113 9.341 34.402-.474L96 105.815v300.371l-43.728-46.208c-9.289-9.815-24.846-10.03-34.402-.474l-10.84 10.84c-9.373 9.373-9.373 24.569 0 33.941l98.343 98.343c12.497 12.497 32.758 12.497 45.255 0l98.343-98.343c9.373-9.373 9.373-24.569 0-33.941l-10.84-10.84c-9.556-9.556-25.113-9.341-34.402.474L160 406.186z"]
  },
      Zc = {
    prefix: "fas",
    iconName: "assistive-listening-systems",
    icon: [512, 512, [], "f2a2", "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"]
  },
      Uc = {
    prefix: "fas",
    iconName: "asterisk",
    icon: [512, 512, [], "f069", "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"]
  },
      Bc = {
    prefix: "fas",
    iconName: "at",
    icon: [512, 512, [], "f1fa", "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"]
  },
      Rc = {
    prefix: "fas",
    iconName: "atlas",
    icon: [448, 512, [], "f558", "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"]
  },
      Yc = {
    prefix: "fas",
    iconName: "atom",
    icon: [448, 512, [], "f5d2", "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"]
  },
      Pc = {
    prefix: "fas",
    iconName: "atom-alt",
    icon: [448, 512, [], "f5d3", "M400.87913,256.00022c47.5017,76.32937,66.25237,155.12752,22.2508,199.12823-41.439,41.42255-115.89477,29.188-199.13212-22.60974-83.58112,52.0321-157.8494,63.89166-199.13212,22.60974C-19.13589,411.12774-.38522,332.32959,47.11648,256.00022-.38522,179.67086-19.13589,100.87271,24.86569,56.872,68.86726,12.93378,147.65133,31.65283,223.98218,79.12235,300.29741,31.62158,379.0971,12.85565,423.12993,56.872,467.1315,100.87271,448.39646,179.67086,400.87913,256.00022ZM167.38641,391.68992c-26.07906-21.48472-50.36118-43.89133-79.19033-78.86065-24.86027,47.23514-30.423,84.68887-18.07877,97.04845C82.50837,422.26855,120.041,416.65908,167.38641,391.68992ZM88.19608,199.17118a561.57489,561.57489,0,0,1,79.1747-79.12629c-31.00111-16.35964-57.78331-24.40664-76.00271-24.40664-9.67223,0-16.93811,2.20316-21.25076,6.48448C57.77311,114.49793,63.35144,151.936,88.19608,199.17118Zm234.74277,56.84467a511.44441,511.44441,0,0,0-98.92542-99.42349,511.2289,511.2289,0,0,0-98.941,99.42349c25.90717,34.01618,54.11131,64.7823,98.92541,98.92348C258.06153,328.98578,288.797,300.81345,322.93885,256.01585Zm-66.92427-.01563a32.01677,32.01677,0,1,1-32.01677-32.01614A32.00909,32.00909,0,0,1,256.01458,256.00022ZM377.87831,102.13835c-4.31265-4.29694-11.57854-6.48448-21.25076-6.48448-18.20378,0-45.00161,8.03138-76.00272,24.391a563.57476,563.57476,0,0,1,79.17471,79.12629C384.64418,151.936,390.2225,114.49793,377.87831,102.13835ZM359.79954,312.82927c-28.92291,35.09432-53.205,57.46968-79.17471,78.86065,47.32982,24.93791,84.84679,30.51612,97.25348,18.1878C390.2225,397.51814,384.64418,360.06441,359.79954,312.82927Z"]
  },
      Fc = {
    prefix: "fas",
    iconName: "audio-description",
    icon: [512, 512, [], "f29e", "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"]
  },
      Wc = {
    prefix: "fas",
    iconName: "award",
    icon: [384, 512, [], "f559", "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"]
  },
      Gc = {
    prefix: "fas",
    iconName: "axe",
    icon: [640, 512, [], "f6b2", "M4.69 439.43c-6.25 6.25-6.25 16.38 0 22.63l45.26 45.25c6.25 6.25 16.38 6.25 22.63 0l235.87-235.87-67.88-67.88L4.69 439.43zM525.74 160l-52.93-52.93 34.5-34.5c6.25-6.25 6.25-16.38 0-22.63L462.06 4.69c-6.25-6.25-16.38-6.25-22.63 0l-34.5 34.5-29.81-29.82C368.87 3.12 360.68 0 352.49 0s-16.38 3.12-22.63 9.37l-96.49 96.49c-12.5 12.5-12.5 32.76 0 45.25L384 301.74V416h32c123.71 0 224-100.29 224-224v-32H525.74zM448 348.79v-37.94c39.28-16.25 70.6-47.56 86.84-86.84h37.94C560.03 286.6 510.6 336.03 448 348.79z"]
  },
      qc = {
    prefix: "fas",
    iconName: "axe-battle",
    icon: [512, 512, [], "f6b3", "M512 160.92C505.16 99.16 478.4 44.29 438.94 4.7c-9.21-9.25-23.89-4.12-27.06 8.96-12.03 49.67-47.25 88.27-91.88 101.23v154.22c44.63 12.96 79.85 51.56 91.88 101.23 3.17 13.08 17.85 18.21 27.06 8.96 39.46-39.59 66.22-94.45 73.06-156.22L449.24 192 512 160.92zM101 13.66C97.86.58 83.32-4.54 74.2 4.7 28.67 50.83 0 117.62 0 192c0 74.38 28.67 141.17 74.2 187.3 9.13 9.25 23.66 4.12 26.8-8.96 11.92-49.67 46.79-88.27 91-101.23V114.89c-44.21-12.96-79.08-51.56-91-101.23zM272 64h-32c-8.84 0-16 7.16-16 16v416c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16z"]
  },
      Jc = {
    prefix: "fas",
    iconName: "baby",
    icon: [384, 512, [], "f77c", "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"]
  },
      Kc = {
    prefix: "fas",
    iconName: "baby-carriage",
    icon: [512, 512, [], "f77d", "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"]
  },
      Xc = {
    prefix: "fas",
    iconName: "backpack",
    icon: [448, 512, [], "f5d4", "M320 320H128c-17.67 0-32 14.33-32 32v32h256v-32c0-17.67-14.33-32-32-32zM96 512h256v-96H96v96zM320 80h-8V56c0-30.88-25.12-56-56-56h-64c-30.88 0-56 25.12-56 56v24h-8C57.31 80 0 137.31 0 208v240c0 35.35 28.65 64 64 64V352c0-35.29 28.71-64 64-64h192c35.29 0 64 28.71 64 64v160c35.35 0 64-28.65 64-64V208c0-70.69-57.31-128-128-128zM184 56c0-4.41 3.59-8 8-8h64c4.41 0 8 3.59 8 8v24h-80V56zm136 144c0 4.42-3.58 8-8 8H136c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16z"]
  },
      _c = {
    prefix: "fas",
    iconName: "backspace",
    icon: [640, 512, [], "f55a", "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"]
  },
      $c = {
    prefix: "fas",
    iconName: "backward",
    icon: [512, 512, [], "f04a", "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"]
  },
      ce = {
    prefix: "fas",
    iconName: "bacon",
    icon: [576, 512, [], "f7e5", "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"]
  },
      ee = {
    prefix: "fas",
    iconName: "bacteria",
    icon: [640, 512, [], "e059", "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"]
  },
      ae = {
    prefix: "fas",
    iconName: "bacterium",
    icon: [512, 512, [], "e05a", "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"]
  },
      ne = {
    prefix: "fas",
    iconName: "badge",
    icon: [512, 512, [], "f335", "M512 256c0-37.7-23.7-69.9-57.1-82.4 14.7-32.4 8.8-71.9-17.9-98.6-26.7-26.7-66.2-32.6-98.6-17.9C325.9 23.7 293.7 0 256 0s-69.9 23.7-82.4 57.1c-32.4-14.7-72-8.8-98.6 17.9-26.7 26.7-32.6 66.2-17.9 98.6C23.7 186.1 0 218.3 0 256s23.7 69.9 57.1 82.4c-14.7 32.4-8.8 72 17.9 98.6 26.6 26.6 66.1 32.7 98.6 17.9 12.5 33.3 44.7 57.1 82.4 57.1s69.9-23.7 82.4-57.1c32.6 14.8 72 8.7 98.6-17.9 26.7-26.7 32.6-66.2 17.9-98.6 33.4-12.5 57.1-44.7 57.1-82.4z"]
  },
      te = {
    prefix: "fas",
    iconName: "badge-check",
    icon: [512, 512, [], "f336", "M512 256c0-37.7-23.7-69.9-57.1-82.4 14.7-32.4 8.8-71.9-17.9-98.6-26.7-26.7-66.2-32.6-98.6-17.9C325.9 23.7 293.7 0 256 0s-69.9 23.7-82.4 57.1c-32.4-14.7-72-8.8-98.6 17.9-26.7 26.7-32.6 66.2-17.9 98.6C23.7 186.1 0 218.3 0 256s23.7 69.9 57.1 82.4c-14.7 32.4-8.8 72 17.9 98.6 26.6 26.6 66.1 32.7 98.6 17.9 12.5 33.3 44.7 57.1 82.4 57.1s69.9-23.7 82.4-57.1c32.6 14.8 72 8.7 98.6-17.9 26.7-26.7 32.6-66.2 17.9-98.6 33.4-12.5 57.1-44.7 57.1-82.4zm-144.8-44.25L236.16 341.74c-4.31 4.28-11.28 4.25-15.55-.06l-75.72-76.33c-4.28-4.31-4.25-11.28.06-15.56l26.03-25.82c4.31-4.28 11.28-4.25 15.56.06l42.15 42.49 97.2-96.42c4.31-4.28 11.28-4.25 15.55.06l25.82 26.03c4.28 4.32 4.26 11.29-.06 15.56z"]
  },
      re = {
    prefix: "fas",
    iconName: "badge-dollar",
    icon: [512, 512, [], "f645", "M512 256c0-37.7-23.7-69.9-57.1-82.4 14.7-32.4 8.8-71.9-17.9-98.6-26.7-26.7-66.2-32.6-98.6-17.9C325.9 23.7 293.7 0 256 0s-69.9 23.7-82.4 57.1c-32.4-14.7-72-8.8-98.6 17.9-26.7 26.7-32.6 66.2-17.9 98.6C23.7 186.1 0 218.3 0 256s23.7 69.9 57.1 82.4c-14.7 32.4-8.8 72 17.9 98.6 26.6 26.6 66.1 32.7 98.6 17.9 12.5 33.3 44.7 57.1 82.4 57.1s69.9-23.7 82.4-57.1c32.6 14.8 72 8.7 98.6-17.9 26.7-26.7 32.6-66.2 17.9-98.6 33.4-12.5 57.1-44.7 57.1-82.4zm-232 94.44V368c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V144c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"]
  },
      ie = {
    prefix: "fas",
    iconName: "badge-percent",
    icon: [512, 512, [], "f646", "M512 256c0-37.7-23.7-69.9-57.1-82.4 14.7-32.4 8.8-71.9-17.9-98.6-26.7-26.7-66.2-32.6-98.6-17.9C325.9 23.7 293.7 0 256 0s-69.9 23.7-82.4 57.1c-32.4-14.7-72-8.8-98.6 17.9-26.7 26.7-32.6 66.2-17.9 98.6C23.7 186.1 0 218.3 0 256s23.7 69.9 57.1 82.4c-14.7 32.4-8.8 72 17.9 98.6 26.6 26.6 66.1 32.7 98.6 17.9 12.5 33.3 44.7 57.1 82.4 57.1s69.9-23.7 82.4-57.1c32.6 14.8 72 8.7 98.6-17.9 26.7-26.7 32.6-66.2 17.9-98.6 33.4-12.5 57.1-44.7 57.1-82.4zm-320-96c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zm12.28 181.65c-6.25 6.25-16.38 6.25-22.63 0l-11.31-11.31c-6.25-6.25-6.25-16.38 0-22.63l137.37-137.37c6.25-6.25 16.38-6.25 22.63 0l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63L204.28 341.65zM320 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      oe = {
    prefix: "fas",
    iconName: "badge-sheriff",
    icon: [512, 512, [], "f8a2", "M440 320c-4 0-7.58 1.18-11.21 2.26l-39.46-66.32 39.43-66.21C432.4 190.82 436 192 440 192a40 40 0 0 0 0-80c-19.25 0-34.57 13.88-38.38 32h-78.88l-43.15-72.55C289.3 64.16 296 53.09 296 40a40 40 0 0 0-80 0c0 13.15 6.76 24.26 16.56 31.55L189.41 144h-79c-3.81-18.12-19.13-32-38.38-32a40 40 0 0 0 0 80c4 0 7.58-1.18 11.21-2.26l39.46 66.32-39.46 66.21C79.6 321.18 76 320 72 320a40 40 0 0 0 0 80c19.25 0 34.57-13.88 38.38-32h78.88l43.15 72.55C222.7 447.84 216 458.91 216 472a40 40 0 0 0 80 0c0-13.15-6.76-24.26-16.56-31.55L322.59 368h79c3.81 18.12 19.13 32 38.38 32a40 40 0 0 0 0-80zm-184 0a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"]
  },
      le = {
    prefix: "fas",
    iconName: "badger-honey",
    icon: [640, 512, [], "f6b4", "M622.25 142.47c-57.65-32.65-70.98-50.67-115.56-69.92C493.37 66.8 479.4 64 465.45 64c-19.05 0-38.09 5.21-55.47 15.21C392.89 89.05 374.05 96 354.95 96H128C57.31 96 0 153.31 0 224v16c0 8.84 7.16 16 16 16h20.03c7.79 33.38 28.05 64.24 53.53 81.18l-21.49 57.3a63.945 63.945 0 0 0-2.16 37.99L80 467.88A16.002 16.002 0 0 0 95.52 480h63.77c10.41 0 18.05-9.78 15.52-19.88l-15.55-41.26L192.22 352h105.69l23.03 115.14c1.5 7.48 8.06 12.86 15.69 12.86H400c10.1 0 17.67-9.24 15.69-19.14l-27-134.96c45.38-30.54 101.24-61.08 152.48-75.55L560 288l22.65-45.3c28.46-2.37 36.45-9.47 41.19-19.81 7-15.27 16.16-35.79 16.16-47.62 0-13.93-6.88-26.65-17.75-32.8zM515.19 160c.28 1.34.81 2.58.81 4 0 11.04-8.96 20-20 20s-20-8.96-20-20c0-1.42.53-2.66.81-4H460c-29.06 0-57.86 13.05-84.85 26.01l-101.98 61.75c-11.34 5.44-23.44 8.24-35.65 8.24H192c-42.49 0-78.12-41.48-90.76-90.66C113.52 152.13 130.03 144 148.3 144h206.65c25.67 0 52.24-7.8 78.97-23.19 10.02-5.77 20.92-8.81 31.53-8.81 7.65 0 15.12 1.55 22.21 4.62 26.87 11.6 36.43 20.42 71.41 43.38h-43.88z"]
  },
      fe = {
    prefix: "fas",
    iconName: "bags-shopping",
    icon: [576, 512, [], "f847", "M448 224v-32a32 32 0 0 0-32-32h-96V96a96 96 0 0 0-192 0v64H32a32 32 0 0 0-32 32v256a32 32 0 0 0 32 32h128V256a32 32 0 0 1 32-32zM176 96a48 48 0 0 1 96 0v64h-96zm368 160H224a32 32 0 0 0-32 32v192a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V288a32 32 0 0 0-32-32zm-64 96a96.12 96.12 0 0 1-108.63 95.19C323 441 288 397.45 288 348.66V328a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v21.16c0 33.41 24.37 63.3 57.62 66.53A64.07 64.07 0 0 0 448 352v-24a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8z"]
  },
      se = {
    prefix: "fas",
    iconName: "bahai",
    icon: [512, 512, [], "f666", "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"]
  },
      ue = {
    prefix: "fas",
    iconName: "balance-scale",
    icon: [640, 512, [], "f24e", "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      he = {
    prefix: "fas",
    iconName: "balance-scale-left",
    icon: [640, 512, [], "f515", "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"]
  },
      me = {
    prefix: "fas",
    iconName: "balance-scale-right",
    icon: [640, 512, [], "f516", "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"]
  },
      ve = {
    prefix: "fas",
    iconName: "ball-pile",
    icon: [576, 512, [], "f77e", "M80 352c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm208-192c44.2 0 80-35.8 80-80S332.2 0 288 0s-80 35.8-80 80 35.8 80 80 80zm-32 88c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm32 104c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm208 0c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm-16-104c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80z"]
  },
      de = {
    prefix: "fas",
    iconName: "ballot",
    icon: [384, 512, [], "f732", "M360 0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm0-128c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm0-128c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm192 248c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-128c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-128c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"]
  },
      Me = {
    prefix: "fas",
    iconName: "ballot-check",
    icon: [384, 512, [], "f733", "M360 0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24zM64 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm1.6 129.4l12.7-12.6c2.1-2.1 5.5-2.1 7.6 0l20.6 20.8 47.6-47.2c2.1-2.1 5.5-2.1 7.6 0l12.6 12.7c2.1 2.1 2.1 5.5 0 7.6l-64.2 63.6c-2.1 2.1-5.5 2.1-7.6 0L65.6 249c-2.1-2.1-2.1-5.5 0-7.6zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm192-8c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-128c0 4.4-4.3 8-9.6 8H170.2s29.2-30.2 30.4-32h109.7c5.3 0 9.6 3.6 9.6 8v16zm0-128c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"]
  },
      pe = {
    prefix: "fas",
    iconName: "ban",
    icon: [512, 512, [], "f05e", "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"]
  },
      ze = {
    prefix: "fas",
    iconName: "band-aid",
    icon: [640, 512, [], "f462", "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"]
  },
      Ce = {
    prefix: "fas",
    iconName: "banjo",
    icon: [512, 512, [], "f8a3", "M502.63 39L473.05 9.37a32 32 0 0 0-45.26 0l-46.31 46.32A35.26 35.26 0 0 0 373 69.48l-12.19 36.59L286 180.79c-19.93-13.49-43.08-22.24-67.86-26.15v-.46a26.18 26.18 0 0 0-52.36 0v.46a166.32 166.32 0 0 0-72.28 29.82l-.23-.23a26.18 26.18 0 0 0-37 37l.23.22a166.31 166.31 0 0 0-29.84 72.34h-.46a26.18 26.18 0 0 0 0 52.36h.46a166.31 166.31 0 0 0 29.84 72.34l-.23.22a26.18 26.18 0 1 0 37 37l.23-.23a166.32 166.32 0 0 0 72.32 29.82v.46a26.18 26.18 0 0 0 52.36 0v-.46a166.32 166.32 0 0 0 72.32-29.82l.23.23a26.18 26.18 0 1 0 37-37l-.23-.22a166.31 166.31 0 0 0 29.84-72.34h.46a26.18 26.18 0 0 0 0-52.36h-.46c-3.9-24.74-12.62-47.87-26.07-67.78l74.88-74.88 36.35-12.11a35.26 35.26 0 0 0 13.79-8.53l46.32-46.31a32 32 0 0 0 .02-45.18zM192 432a112 112 0 1 1 112-112 112.12 112.12 0 0 1-112 112zm-39-125.65a8 8 0 0 0-11.32 0l-11.31 11.31a8 8 0 0 0 0 11.31L183 381.66a8 8 0 0 0 11.31 0l11.31-11.31a8 8 0 0 0 0-11.32z"]
  },
      Le = {
    prefix: "fas",
    iconName: "barcode",
    icon: [512, 512, [], "f02a", "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"]
  },
      Ae = {
    prefix: "fas",
    iconName: "barcode-alt",
    icon: [640, 512, [], "f463", "M592 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 408c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V104c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm64 0c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V104c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v304zm64 0c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V104c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v304zm128 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V104c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm128 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V104c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z"]
  },
      Ne = {
    prefix: "fas",
    iconName: "barcode-read",
    icon: [640, 512, [], "f464", "M184 128h-48c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-40 320H64v-80c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm104-320h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zM16 160h32c8.8 0 16-7.2 16-16V64h80c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v128c0 8.8 7.2 16 16 16zm392-32h-48c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-96 0h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zM624 0H496c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 352h-32c-8.8 0-16 7.2-16 16v80h-80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-112 24V136c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8z"]
  },
      ge = {
    prefix: "fas",
    iconName: "barcode-scan",
    icon: [640, 512, [], "f465", "M288 8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152h64V8zM160 8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v152h96V8zM64 504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V352H64v152zM480 8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152h64V8zm96 0c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152h64V8zM384 8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v152h32V8zm128 496c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V352h-64v152zm-288 0c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V352h-64v152zm192 0c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V352h-64v152zm-64 0c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V352h-32v152zm280-280H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h624c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"]
  },
      He = {
    prefix: "fas",
    iconName: "bars",
    icon: [448, 512, [], "f0c9", "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"]
  },
      Ve = {
    prefix: "fas",
    iconName: "baseball",
    icon: [640, 512, [], "f432", "M629.6 56l-23.9-33.4c-17.6-24.6-51.5-30-75.8-12.2l-212 156.3c-69.1 50.9-112.4 99.8-137.2 128.3l62.2 86.7c34.6-15.2 93.7-41.8 162.8-92.7l212.1-156.2c24.1-17.8 29.4-52.2 11.8-76.8zM145.5 433.1l-43.2-60.3c-30 26-47 38.2-56 44.8-19.2-24.1-36.6-9-37.4-8.4-10.3 8.3-12 23.4-3.7 33.7l47.9 60c7.8 9.8 22.8 12.5 33.7 3.7 2.8-2.2 17.5-16.5 2.3-35.6 8.2-5.9 24.6-18.2 56.4-37.9zm-22.6-78.3l46 64.1c15.9-9.1 32.3-17.5 48.8-25.5l-55.8-77.8c-12.6 13.5-25.5 26.6-39 39.2zm372-2.8c-44.1 0-79.8 35.8-79.8 80s35.7 80 79.8 80 79.8-35.8 79.8-80-35.7-80-79.8-80z"]
  },
      xe = {
    prefix: "fas",
    iconName: "baseball-ball",
    icon: [496, 512, [], "f433", "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"]
  },
      we = {
    prefix: "fas",
    iconName: "basketball-ball",
    icon: [496, 512, [], "f434", "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"]
  },
      ye = {
    prefix: "fas",
    iconName: "basketball-hoop",
    icon: [640, 512, [], "f435", "M208 160h224v48H208v-48zm431.9 176.9c0 22.8-13.6 43.2-34.7 51.8L501 431.6l9-143.6h-30.6l-18.2 224-75.4-71.6L320 512l-65.8-71.6-75.4 71.6-18.2-224H130l9 143.6-104.3-42.8C13.6 380.1 0 359.8 0 336.9L1.2 207C1.8 205 68.7 8 320 8s318.1 197 318.8 199c1.6 10.2 1.1-8.5 1.1 129.9zm-433.2 15.5l46.7 43.6 44-44-42.1-42.1-48.6 42.5zm113.3-23l41.4-41.4h-82.8l41.4 41.4zm22.6 22.6l44 44 46.7-43.6-48.6-42.5-42.1 42.1zm-149.9-64l2.6 31.9 36.5-31.9h-39.1zm38.1 130.6l-29.9-27.9 4.3 53.5 25.6-25.6zm132.4-.8L320 374.6l-43.2 43.2 43.2 40.3 43.2-40.3zm71.6 26.4l4.3-53.5-29.9 27.9 25.6 25.6zM447.3 288h-39l36.5 31.9 2.5-31.9zm96.7-72c0-4.4-3.6-8-8-8h-72v-80H176v80h-72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-16z"]
  },
      be = {
    prefix: "fas",
    iconName: "bat",
    icon: [640, 512, [], "f6b5", "M558.44 129.7c-7.64-17.82-29.25-24.81-45.88-14.83L411.83 175.3 384 64l-42.67 32h-42.67L256 64l-27.83 111.3-100.74-60.44c-16.63-9.98-38.24-2.99-45.88 14.83L0 320l49.62-16.54c27.38-9.13 57.48 1.2 73.49 25.21L160 384l11.82-11.82c27.54-27.54 73.09-24.3 96.46 6.85L320 448l51.72-68.97c23.37-31.16 68.91-34.39 96.46-6.85L480 384l36.88-55.33c16.01-24.01 46.11-34.34 73.49-25.21L640 320l-81.56-190.3z"]
  },
      Se = {
    prefix: "fas",
    iconName: "bath",
    icon: [512, 512, [], "f2cd", "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"]
  },
      Te = {
    prefix: "fas",
    iconName: "battery-bolt",
    icon: [640, 512, [], "f376", "M64 352h178.778l-14.173 64H48c-26.51 0-48-21.49-48-48V144c0-26.51 21.49-48 48-48h115.944l-7.663 64H64v192zm364.778-160h-92.321l27.694-133.589C367.4 45.087 358.205 32 345.6 32H236.8c-9.623 0-17.76 7.792-19.031 18.225L192.171 264c-1.535 12.59 7.432 23.775 19.031 23.775h94.961l-36.847 166.382C266.44 467.443 275.728 480 287.993 480c6.68 0 13.101-3.827 16.623-10.481l140.778-245.997C452.79 209.55 443.564 192 428.778 192zM616 160h-8v-16c0-26.51-21.49-48-48-48H405.38l-9.951 48h33.349c16.112 0 31.233 5.762 43.115 16H544v64h32v64h-32v64H427.174l-36.626 64H560c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24z"]
  },
      De = {
    prefix: "fas",
    iconName: "battery-empty",
    icon: [640, 512, [], "f244", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"]
  },
      je = {
    prefix: "fas",
    iconName: "battery-full",
    icon: [640, 512, [], "f240", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"]
  },
      Ee = {
    prefix: "fas",
    iconName: "battery-half",
    icon: [640, 512, [], "f242", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"]
  },
      ke = {
    prefix: "fas",
    iconName: "battery-quarter",
    icon: [640, 512, [], "f243", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"]
  },
      Ie = {
    prefix: "fas",
    iconName: "battery-slash",
    icon: [640, 512, [], "f377", "M64 352V179.48l-62.13-48A47.23 47.23 0 0 0 0 144v224a48 48 0 0 0 48 48h322l-82.81-64zm544 16v-16h8a24 24 0 0 0 24-24V184a24 24 0 0 0-24-24h-8v-16a48 48 0 0 0-48-48H165.31L45.47 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.35 454.73a16 16 0 0 0 22.47-2.81l19.64-25.27a16 16 0 0 0-2.81-22.45l-58.14-44.94A47.85 47.85 0 0 0 608 368zm-32-80h-32v64h-47.46L248.12 160H544v64h32z"]
  },
      Oe = {
    prefix: "fas",
    iconName: "battery-three-quarters",
    icon: [640, 512, [], "f241", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"]
  },
      Qe = {
    prefix: "fas",
    iconName: "bed",
    icon: [640, 512, [], "f236", "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"]
  },
      Ze = {
    prefix: "fas",
    iconName: "bed-alt",
    icon: [512, 512, [], "f8f7", "M80,160a32,32,0,0,1,32-32h96a32,32,0,0,1,32,32v32h32V160a32,32,0,0,1,32-32h96a32,32,0,0,1,32,32v32h48V64a32,32,0,0,0-32-32H64A32,32,0,0,0,32,64V192H80Zm368,64H64A64,64,0,0,0,0,288V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V416H448v48a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V288A64,64,0,0,0,448,224Z"]
  },
      Ue = {
    prefix: "fas",
    iconName: "bed-bunk",
    icon: [576, 512, [], "f8f8", "M464,0H240a16,16,0,0,0-16,16V128H64V16A16,16,0,0,0,48,0H16A16,16,0,0,0,0,16V496a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V448H512v48a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V112A112,112,0,0,0,464,0Zm48,267.19A110.9,110.9,0,0,0,464,256H240a16,16,0,0,0-16,16V384H64V192H512ZM144,352a48,48,0,1,0-48-48A48.05,48.05,0,0,0,144,352Zm0-256A48,48,0,1,0,96,48,48.05,48.05,0,0,0,144,96Z"]
  },
      Be = {
    prefix: "fas",
    iconName: "bed-empty",
    icon: [640, 512, [], "f8f9", "M112,256h96a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H112a16,16,0,0,0-16,16v96A16,16,0,0,0,112,256ZM528,128H272a16,16,0,0,0-16,16V288H64V80A16,16,0,0,0,48,64H16A16,16,0,0,0,0,80V432a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V384H576v48a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V240A112,112,0,0,0,528,128Z"]
  },
      Re = {
    prefix: "fas",
    iconName: "beer",
    icon: [448, 512, [], "f0fc", "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"]
  },
      Ye = {
    prefix: "fas",
    iconName: "bell",
    icon: [448, 512, [], "f0f3", "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"]
  },
      Pe = {
    prefix: "fas",
    iconName: "bell-exclamation",
    icon: [448, 512, [], "f848", "M224 512a64 64 0 0 0 64-64H160a64 64 0 0 0 64 64zm215.39-149.71c-19.32-20.76-55.47-52-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32a32 32 0 1 0-64 0v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29A31.24 31.24 0 0 0 0 384c.11 16.4 13 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32a31.23 31.23 0 0 0-8.61-21.71zM224 352a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm25.4-110.4a16 16 0 0 1-15.9 14.4h-19a16 16 0 0 1-15.9-14.4l-12.8-96a16.06 16.06 0 0 1 15.9-17.6h44.6a16 16 0 0 1 15.9 17.6z"]
  },
      Fe = {
    prefix: "fas",
    iconName: "bell-on",
    icon: [640, 512, [], "f8fa", "M112,192a24,24,0,0,0-24-24H24a24,24,0,0,0,0,48H88A24,24,0,0,0,112,192ZM51.66,64.78l55.42,32a24,24,0,1,0,24-41.56l-55.42-32a24,24,0,1,0-24,41.56ZM520.94,100a23.8,23.8,0,0,0,12-3.22l55.42-32a24,24,0,0,0-24-41.56l-55.42,32a24,24,0,0,0,12,44.78ZM320,512a64,64,0,0,0,64-64H256A64,64,0,0,0,320,512ZM616,168H552a24,24,0,0,0,0,48h64a24,24,0,0,0,0-48ZM479.92,208c0-77.69-54.48-139.91-127.94-155.16V32a32,32,0,1,0-64,0V52.84C214.56,68.09,160.08,130.31,160.08,208c0,102.31-36.14,133.53-55.47,154.28A31.28,31.28,0,0,0,96,384c.11,16.41,13,32,32.09,32H511.91c19.11,0,32-15.59,32.09-32a31.23,31.23,0,0,0-8.61-21.72C516.06,341.53,479.92,310.31,479.92,208Z"]
  },
      We = {
    prefix: "fas",
    iconName: "bell-plus",
    icon: [448, 512, [], "f849", "M224 512a64 64 0 0 0 64-64H160a64 64 0 0 0 64 64zm215.39-149.71c-19.32-20.76-55.47-52-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32a32 32 0 1 0-64 0v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29A31.24 31.24 0 0 0 0 384c.11 16.4 13 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32a31.23 31.23 0 0 0-8.61-21.71zM320 248a16 16 0 0 1-16 16h-56v56a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-56h-56a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h56v-56a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16v56h56a16 16 0 0 1 16 16z"]
  },
      Ge = {
    prefix: "fas",
    iconName: "bell-school",
    icon: [512, 512, [], "f5d5", "M416 208C416 93.12 322.88 0 208 0S0 93.12 0 208s93.12 208 208 208 208-93.12 208-208zm-288 0c0-44.11 35.89-80 80-80s80 35.89 80 80-35.89 80-80 80-80-35.89-80-80zm128 0c0-26.51-21.49-48-48-48s-48 21.49-48 48 21.49 48 48 48 48-21.49 48-48zm208 112c-26.51 0-48 21.49-48 48 0 16.43 8.27 30.89 20.86 39.55C430.78 421.9 416.55 432 400 432h-48v-32.46C311.83 429.82 262.06 448 208 448s-103.83-18.18-144-48.46V480c0 17.67 14.33 32 32 32h224c17.67 0 32-14.33 32-32h48c42.2 0 77.48-29.87 85.98-69.56 15.39-8 26.02-23.9 26.02-42.44 0-26.51-21.49-48-48-48z"]
  },
      qe = {
    prefix: "fas",
    iconName: "bell-school-slash",
    icon: [640, 512, [], "f5d6", "M272 448c-54.06 0-103.83-18.18-144-48.46V480c0 17.67 14.33 32 32 32h224c17.67 0 32-14.33 32-32v-28.47l-37.66-29.11C346.23 438.51 310.29 448 272 448zm78.19-47.33L65.95 180.99C64.8 189.85 64 198.82 64 208c0 114.88 93.12 208 208 208 27.68 0 54.04-5.52 78.19-15.33zm283.63 57.43l-72.26-55.85C570.45 393.54 576 381.43 576 368c0-26.51-21.49-48-48-48-17.82 0-33.2 9.83-41.48 24.25l-36.81-28.45C468.88 284.38 480 247.52 480 208 480 93.12 386.87 0 272 0c-58.54 0-111.06 24.5-148.8 63.45L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM346.64 236.15l-27.35-21.14c.34-2.31.71-4.61.71-7.01 0-26.51-21.49-48-48-48-6.7 0-13.07 1.39-18.87 3.87l-27-20.87c12.98-9.29 28.68-15 45.87-15 44.11 0 80 35.89 80 80 0 9.95-2.02 19.37-5.36 28.15z"]
  },
      Je = {
    prefix: "fas",
    iconName: "bell-slash",
    icon: [640, 512, [], "f1f6", "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"]
  },
      Ke = {
    prefix: "fas",
    iconName: "bells",
    icon: [640, 512, [], "f77f", "M242 253.9c-27.9-76.7 5-160.6 73.7-199.8-8.5-5.6-17.5-10.5-27.4-14.1-69.3-25.1-145.8 10.6-171 79.8-.8 2.1-14.7 40.4-15.4 42.6-29.2 80.1-66.4 94.3-87.4 105-20.1 10.3-19.5 40.6 3 48.8l243.3 88.6c8.4-19.2 19.5-45.6-3.3-108.2-9.8-27-6.2-17.1-15.5-42.7zM138.1 444.2c27.6 10.1 57.5-.3 73.8-23.2L96.5 379c-2.3 27.9 13.9 55.1 41.6 65.2zm363.8 32c27.6-10.1 43.9-37.2 41.6-65.2l-115.4 42c16.3 22.8 46.2 33.2 73.8 23.2zm123.7-176.8c-21-10.7-58.3-24.9-87.4-105-.8-2.2-14.7-40.5-15.4-42.6-25.3-69.2-101.8-104.9-171-79.7-69.2 25.2-104.9 101.7-79.7 170.9.8 2.1 14.8 40.4 15.6 42.6 29.2 80.1 9.7 114.9.5 136.6-8.8 20.7 11.2 43.6 33.7 35.4l300.6-109.4c20.5-7.5 24.9-37.6 3.1-48.8z"]
  },
      Xe = {
    prefix: "fas",
    iconName: "betamax",
    icon: [512, 512, [], "f8a4", "M496 64H16A16 16 0 0 0 0 80v48h512V80a16 16 0 0 0-16-16zM0 400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V160H0zm288-176h160v160H288zm-144 0a80 80 0 1 1-80 80 80 80 0 0 1 80-80zm0 112a32 32 0 1 0-32-32 32 32 0 0 0 32 32z"]
  },
      _e = {
    prefix: "fas",
    iconName: "bezier-curve",
    icon: [640, 512, [], "f55b", "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"]
  },
      $e = {
    prefix: "fas",
    iconName: "bible",
    icon: [448, 512, [], "f647", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"]
  },
      ca = {
    prefix: "fas",
    iconName: "bicycle",
    icon: [640, 512, [], "f206", "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"]
  },
      ea = {
    prefix: "fas",
    iconName: "biking",
    icon: [640, 512, [], "f84a", "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"]
  },
      aa = {
    prefix: "fas",
    iconName: "biking-mountain",
    icon: [640, 512, [], "f84b", "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-227.29 74.16c5.65 6.8 15.39 7.81 21.77 2.26L298.8 83.51c6.38-5.54 7-15.54 1.35-22.33-28.2-33.95-76.91-39-108.81-11.3l-58.12 48.76c-6.37 5.55-7 15.54-1.34 22.34zM240 352h-5.2a110.19 110.19 0 0 0-8.65-20.89l3.67-3.67a16 16 0 0 0 0-22.63l-22.63-22.63a16 16 0 0 0-22.63 0l-3.67 3.67A110.45 110.45 0 0 0 160 277.2V272a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v5.2a110.19 110.19 0 0 0-20.89 8.65l-3.67-3.67a16 16 0 0 0-22.63 0l-22.63 22.63a16 16 0 0 0 0 22.63l3.67 3.67A110.45 110.45 0 0 0 21.2 352H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h5.2a110.19 110.19 0 0 0 8.65 20.89l-3.67 3.67a16 16 0 0 0 0 22.63l22.63 22.63a16 16 0 0 0 22.63 0l3.67-3.67A110.94 110.94 0 0 0 96 490.8v5.2a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-5.2a110.47 110.47 0 0 0 20.89-8.65l3.67 3.67a16 16 0 0 0 22.63 0l22.63-22.63a16 16 0 0 0 0-22.63l-3.67-3.67a110.45 110.45 0 0 0 8.66-20.89H240a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-112 96a64 64 0 1 1 64-64 64 64 0 0 1-64 64zm496-96h-5.2a110.19 110.19 0 0 0-8.65-20.89l3.67-3.67a16 16 0 0 0 0-22.63l-22.63-22.63a16 16 0 0 0-22.63 0l-3.67 3.67A110.45 110.45 0 0 0 544 277.2V272a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v5.2a110.1 110.1 0 0 0-20.88 8.65l-3.67-3.67a16 16 0 0 0-22.63 0l-22.63 22.63a16 16 0 0 0 0 22.63l3.67 3.67a110.45 110.45 0 0 0-8.67 20.89H400a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h5.2a110.19 110.19 0 0 0 8.65 20.89l-3.67 3.67a16 16 0 0 0 0 22.63l22.63 22.63a16 16 0 0 0 22.63 0l3.67-3.67A111.13 111.13 0 0 0 480 490.8v5.2a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-5.2a110.56 110.56 0 0 0 20.9-8.65l3.67 3.67a16 16 0 0 0 22.63 0l22.63-22.63a16 16 0 0 0 0-22.63l-3.67-3.67A110.45 110.45 0 0 0 618.8 416h5.2a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-112 96a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM396 217a32 32 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.07 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.35-27.57 58.24-49.92z"]
  },
      na = {
    prefix: "fas",
    iconName: "binoculars",
    icon: [512, 512, [], "f1e5", "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"]
  },
      ta = {
    prefix: "fas",
    iconName: "biohazard",
    icon: [576, 512, [], "f780", "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      ra = {
    prefix: "fas",
    iconName: "birthday-cake",
    icon: [448, 512, [], "f1fd", "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"]
  },
      ia = {
    prefix: "fas",
    iconName: "blanket",
    icon: [512, 512, [], "f498", "M512 96c0-52.9-43.1-96-96-96H96C43.1 0 0 43.1 0 96v288c0 70.7 57.3 128 128 128h368c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h304c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h299.3c41.8 0 80.1-30 84.3-71.6.3-2.9.4-248.4.4-248.4z"]
  },
      oa = {
    prefix: "fas",
    iconName: "blender",
    icon: [512, 512, [], "f517", "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"]
  },
      la = {
    prefix: "fas",
    iconName: "blender-phone",
    icon: [576, 512, [], "f6b6", "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      fa = {
    prefix: "fas",
    iconName: "blind",
    icon: [384, 512, [], "f29d", "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"]
  },
      sa = {
    prefix: "fas",
    iconName: "blinds",
    icon: [512, 512, [], "f8fb", "M96,226.94V160H16L0,256H66.94A47.82,47.82,0,0,1,96,226.94ZM157.06,288a47.73,47.73,0,0,1-90.12,0H16L0,384H512l-16-96ZM16,416,0,512H512l-16-96ZM512,48V16A16,16,0,0,0,496,0H16A16,16,0,0,0,0,16V48A15.85,15.85,0,0,0,10.84,63L0,128H96V64h32v64H512L501.16,63A15.85,15.85,0,0,0,512,48ZM128,160v66.94A47.82,47.82,0,0,1,157.06,256H512l-16-96Z"]
  },
      ua = {
    prefix: "fas",
    iconName: "blinds-open",
    icon: [512, 512, [], "f8fc", "M16,464,0,512H512l-16-48ZM64,208.21V192H16L0,240H39.16A80.21,80.21,0,0,1,64,208.21ZM175.59,320a79.18,79.18,0,0,1-127.18,0H16L0,368H512l-16-48ZM160,192v16.21A80.12,80.12,0,0,1,184.84,240H512l-16-48ZM512,48V16A16,16,0,0,0,496,0H16A16,16,0,0,0,0,16V48A16,16,0,0,0,16,64L0,112H64V64H96V226.94a48,48,0,1,0,32,0V64h32v48H512L496,64A16,16,0,0,0,512,48Z"]
  },
      ha = {
    prefix: "fas",
    iconName: "blinds-raised",
    icon: [512, 512, [], "f8fd", "M16,160,0,224H96V160ZM512,48V16A16,16,0,0,0,496,0H16A16,16,0,0,0,0,16V48A16,16,0,0,0,16,64L0,128H96V64h32v64H512L496,64A16,16,0,0,0,512,48ZM496,160H128v64H512ZM96,224V418.94a48,48,0,1,0,32,0V224Z"]
  },
      ma = {
    prefix: "fas",
    iconName: "blog",
    icon: [512, 512, [], "f781", "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"]
  },
      va = {
    prefix: "fas",
    iconName: "bold",
    icon: [384, 512, [], "f032", "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"]
  },
      da = {
    prefix: "fas",
    iconName: "bolt",
    icon: [320, 512, [], "f0e7", "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"]
  },
      Ma = {
    prefix: "fas",
    iconName: "bomb",
    icon: [512, 512, [], "f1e2", "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"]
  },
      pa = {
    prefix: "fas",
    iconName: "bone",
    icon: [640, 512, [], "f5d7", "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"]
  },
      za = {
    prefix: "fas",
    iconName: "bone-break",
    icon: [640, 512, [], "f5d8", "M598.88 148.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 33.3 606.7 0 565.62 0c-32.02 0-60.44 20.49-70.57 50.86l-7.75 23.26A32.006 32.006 0 0 1 456.94 96H352l32 64-32 64h104.94c13.77 0 26 8.81 30.36 21.88l7.75 23.26C505.17 299.51 533.6 320 565.61 320c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88zM320 282.51L256 256l-26.51-64-62.97 62.97c-9.74 9.74-24.62 12.15-36.94 5.99L107.65 250c-28.64-14.32-63.22-8.71-85.87 13.93-29.05 29.05-29.05 76.15 0 105.2l5.4 5.4c19.92 19.92 49.39 26.88 76.12 17.97 10-3.33 19.51 6.18 16.18 16.18-8.91 26.73-1.95 56.2 17.97 76.12l5.4 5.4c29.05 29.05 76.15 29.05 105.2 0 22.64-22.64 28.25-57.23 13.93-85.87l-10.96-21.93c-6.16-12.32-3.75-27.2 5.99-36.94L320 282.51z"]
  },
      Ca = {
    prefix: "fas",
    iconName: "bong",
    icon: [448, 512, [], "f55c", "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"]
  },
      La = {
    prefix: "fas",
    iconName: "book",
    icon: [448, 512, [], "f02d", "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"]
  },
      Aa = {
    prefix: "fas",
    iconName: "book-alt",
    icon: [448, 512, [], "f5d9", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"]
  },
      Na = {
    prefix: "fas",
    iconName: "book-dead",
    icon: [448, 512, [], "f6b7", "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"]
  },
      ga = {
    prefix: "fas",
    iconName: "book-heart",
    icon: [448, 512, [], "f499", "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM149.8 109.1c24-20 59.7-16.4 81.6 5.8l8.6 8.7 8.6-8.7c22-22.2 57.7-25.8 81.6-5.8 27.5 23 28.9 64.2 4.3 89.1l-84.7 85.6c-5.5 5.5-14.3 5.5-19.8 0l-84.7-85.6c-24.5-24.9-23-66.1 4.5-89.1zM381.4 448H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"]
  },
      Ha = {
    prefix: "fas",
    iconName: "book-medical",
    icon: [448, 512, [], "f7e6", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"]
  },
      Va = {
    prefix: "fas",
    iconName: "book-open",
    icon: [576, 512, [], "f518", "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"]
  },
      xa = {
    prefix: "fas",
    iconName: "book-reader",
    icon: [512, 512, [], "f5da", "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"]
  },
      wa = {
    prefix: "fas",
    iconName: "book-spells",
    icon: [448, 512, [], "f6b8", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM272 160l26.66 53.33L352 240l-53.34 26.67L272 320l-26.66-53.33L192 240l53.34-26.67L272 160zM160 96l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16zm220.8 352H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"]
  },
      ya = {
    prefix: "fas",
    iconName: "book-user",
    icon: [448, 512, [], "f7e7", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM240 64a64 64 0 1 1-64 64 64 64 0 0 1 64-64zM128 281.6c0-31.81 30.09-57.6 67.2-57.6h5a103.25 103.25 0 0 0 79.7 0h4.95c37.11 0 67.2 25.79 67.2 57.6v19.2c0 10.61-10 19.2-22.4 19.2H150.4c-12.4 0-22.4-8.6-22.4-19.2zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"]
  },
      ba = {
    prefix: "fas",
    iconName: "bookmark",
    icon: [384, 512, [], "f02e", "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"]
  },
      Sa = {
    prefix: "fas",
    iconName: "books",
    icon: [576, 512, [], "f5db", "M575.11 443.25L461.51 19.06C458.2 6.7 445.61-3.18 430.15.96L414.7 5.1c-6.18 1.66-11.53 6.4-16.06 14.24-14.03 6.94-52.3 17.21-68 18.22-7.84-4.53-14.85-5.96-21.03-4.3l-15.46 4.14c-2.42.65-4.2 1.95-6.15 3.08V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v64h128l101.66 396.94c3.31 12.36 15.9 22.24 31.36 18.1l15.45-4.14c6.18-1.66 11.53-6.4 16.06-14.24 13.91-6.88 52.18-17.2 68-18.22 7.84 4.53 14.85 5.96 21.03 4.3l15.46-4.14c15.45-4.14 21.41-18.99 18.09-31.35zm-134.4-7.06L348.64 92.37l61.82-16.56 92.07 343.82-61.82 16.56zM0 384h128V128H0v256zM96 0H32C14.33 0 0 14.33 0 32v64h128V32c0-17.67-14.33-32-32-32zM0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64H0v64zm160-96h128V128H160v256zm0 96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64H160v64z"]
  },
      Ta = {
    prefix: "fas",
    iconName: "books-medical",
    icon: [640, 512, [], "f7e8", "M128 128a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm64 144a5.33 5.33 0 0 1-5.33 5.33h-37.34v37.34A5.33 5.33 0 0 1 144 320h-32a5.33 5.33 0 0 1-5.33-5.33v-37.34H69.33A5.33 5.33 0 0 1 64 272v-32a5.33 5.33 0 0 1 5.33-5.33h37.34v-37.34A5.33 5.33 0 0 1 112 192h32a5.33 5.33 0 0 1 5.33 5.33v37.34h37.34A5.33 5.33 0 0 1 192 240zM64 480a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-64H64zM192 32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64h128zm447.11 411.25L525.51 19.06C522.2 6.7 509.61-3.18 494.15 1L478.7 5.1q-9.27 2.49-16.06 14.24c-14 6.94-52.3 17.21-68 18.22q-11.76-6.8-21-4.3l-15.49 4.14c-2.42.65-4.2 2-6.15 3.08V32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32v64h128l101.66 396.94C457 505.3 469.56 515.18 485 511l15.45-4.14q9.27-2.49 16.06-14.24c13.91-6.88 52.18-17.2 68-18.22q11.76 6.8 21 4.3l15.49-4.1c15.47-4.14 21.43-18.99 18.11-31.35zm-134.4-7.06L412.64 92.37l61.82-16.56 92.07 343.82zM224 128.81c38.62 29.24 64 75.12 64 127.19s-25.38 98-64 127.19v.81h128V128H224zM224 480a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-64H224z"]
  },
      Da = {
    prefix: "fas",
    iconName: "boombox",
    icon: [640, 512, [], "f8a5", "M463 256a80 80 0 1 0 80 80 80.09 80.09 0 0 0-80-80zm-288 0a80 80 0 1 0 80 80 80.09 80.09 0 0 0-80-80zm432-93.06V56a56.06 56.06 0 0 0-56-56H87a56.06 56.06 0 0 0-56 56v106.94A47.86 47.86 0 0 0-1 208v256a48 48 0 0 0 48 48h544a48 48 0 0 0 48-48V208a47.86 47.86 0 0 0-32-45.06zM175 448a112 112 0 1 1 112-112 112 112 0 0 1-112 112zm160-320h-32a16 16 0 0 0-16 16v16h-32v-16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16H79V56a8 8 0 0 1 8-8h464a8 8 0 0 1 8 8v104H447v-16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16h-32v-16a16 16 0 0 0-16-16zm128 320a112 112 0 1 1 112-112 112 112 0 0 1-112 112z"]
  },
      ja = {
    prefix: "fas",
    iconName: "boot",
    icon: [512, 512, [], "f782", "M0 480l32 32h64l32-32 32 32h64l32-32 32 32h64l32-32 32 32h64l32-32v-32H0v32zM352 80V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v80h336c8.8 0 16-7.2 16-16zm87.3 205.8L320 256h-56c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h56v-32h-56c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h56v-32H0v288h512v-37c0-44.1-30-82.5-72.7-93.2z"]
  },
      Ea = {
    prefix: "fas",
    iconName: "booth-curtain",
    icon: [512, 512, [], "f734", "M480 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32zM0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V64h32V0H32C14.3 0 0 14.3 0 32zM416 0H128v400c0 26.5 21.5 48 48 48 14.7 0 27.9-6.6 36.7-17 5.7-6.8 16.9-6.8 22.6 0 8.8 10.4 22 17 36.7 17s27.9-6.6 36.7-17c5.7-6.8 16.9-6.8 22.6 0 8.8 10.4 22 17 36.7 17 26.5 0 48-21.5 48-48V0z"]
  },
      ka = {
    prefix: "fas",
    iconName: "border-all",
    icon: [448, 512, [], "f84c", "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"]
  },
      Ia = {
    prefix: "fas",
    iconName: "border-bottom",
    icon: [448, 512, [], "f84d", "M208 288h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm96 0h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm128-64h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-320 64h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm320 32h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM208 384h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-192h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-96h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm96 0h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm128-64h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM16 288h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 96h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-192h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-96h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16zm96 0h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm320 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      Oa = {
    prefix: "fas",
    iconName: "border-center-h",
    icon: [448, 512, [], "f89c", "M208 480h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm96 0h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm128-64h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-320 64h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm320-160h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM208 384h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-192h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-96h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm96 0h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm128-64h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM16 480h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-96h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-192h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-96h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16zm96 0h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm320 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      Qa = {
    prefix: "fas",
    iconName: "border-center-v",
    icon: [448, 512, [], "f89d", "M448 272v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm0-96v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zM384 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16zm64 320v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zM288 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16zM96 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16zm256 224v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm-192 0v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm-96 0v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm0-96v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zM0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48zm448 416v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm-96 0v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm-192 0v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm-96 0v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zm0-96v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16zM192 48v416a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16z"]
  },
      Za = {
    prefix: "fas",
    iconName: "border-inner",
    icon: [448, 512, [], "f84e", "M48 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 192h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm288-96h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM48 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm64-224h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-96 0h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16zm320 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 192H256V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v176H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h176v176a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V288h176a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM144 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm288-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      Ua = {
    prefix: "fas",
    iconName: "border-left",
    icon: [448, 512, [], "f84f", "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-96 0H16A16 16 0 0 0 0 48v416a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Ba = {
    prefix: "fas",
    iconName: "border-none",
    icon: [448, 512, [], "f850", "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Ra = {
    prefix: "fas",
    iconName: "border-outer",
    icon: [448, 512, [], "f851", "M208 288h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm96 0h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-192 0h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm96 96h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-192h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 384H64V96h320z"]
  },
      Ya = {
    prefix: "fas",
    iconName: "border-right",
    icon: [448, 512, [], "f852", "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm288 0h-32a16 16 0 0 0-16 16v416a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Pa = {
    prefix: "fas",
    iconName: "border-style",
    icon: [448, 512, [], "f853", "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Fa = {
    prefix: "fas",
    iconName: "border-style-alt",
    icon: [448, 512, [], "f854", "M208 96h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm96 0h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-192 0h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 288h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-96h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-96h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16zm0 288h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM432 32h-32a16 16 0 0 0-16 16v368H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h400a32 32 0 0 0 32-32V48a16 16 0 0 0-16-16z"]
  },
      Wa = {
    prefix: "fas",
    iconName: "border-top",
    icon: [448, 512, [], "f855", "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm384-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      Ga = {
    prefix: "fas",
    iconName: "bow-arrow",
    icon: [512, 512, [], "f6b9", "M145.78 287.03l45.26-45.25-90.58-90.58C128.24 136.08 159.49 128 192 128c32.03 0 62.86 7.79 90.33 22.47l46.61-46.61C288.35 78.03 241.3 64 192 64c-49.78 0-97.29 14.27-138.16 40.59l-3.9-3.9c-6.25-6.25-16.38-6.25-22.63 0L4.69 123.31c-6.25 6.25-6.25 16.38 0 22.63l141.09 141.09zm262.36-104.64L361.53 229c14.68 27.47 22.47 58.3 22.47 90.33 0 32.51-8.08 63.77-23.2 91.55l-90.58-90.58-45.26 45.26 141.76 141.76c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-4.57-4.57C433.74 416.63 448 369.11 448 319.33c0-49.29-14.03-96.35-39.86-136.94zM493.22.31L364.63 26.03c-12.29 2.46-16.88 17.62-8.02 26.49l34.47 34.47-250.64 250.63-49.7-16.57a20.578 20.578 0 0 0-21.04 4.96L6.03 389.69c-10.8 10.8-6.46 29.2 8.04 34.04l55.66 18.55 18.55 55.65c4.83 14.5 23.23 18.84 34.04 8.04l63.67-63.67a20.56 20.56 0 0 0 4.97-21.04l-16.57-49.7 250.64-250.64 34.47 34.47c8.86 8.86 24.03 4.27 26.49-8.02l25.72-128.59C513.88 7.8 504.2-1.88 493.22.31z"]
  },
      qa = {
    prefix: "fas",
    iconName: "bowling-ball",
    icon: [496, 512, [], "f436", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Ja = {
    prefix: "fas",
    iconName: "bowling-pins",
    icon: [448, 512, [], "f437", "M314.8 160c-.8-35.8-20.9-59.1-18.8-96 1.9-34.2 22.7-63.9 56-64 33.4.1 54.1 29.7 56 64 2.1 36.9-18 60.3-18.8 96h-74.4zm128.9 160c-10.8-48.1-39.9-82.8-50.7-128h-81.9c-10.8 45.2-39.9 79.9-50.7 128-11.5 51.1.6 140.5 26.7 192h130c26-51.5 38-141 26.6-192zM133.2 160c.8-35.8 20.9-59.1 18.8-96C150.1 29.8 129.3.1 96 0 62.6.1 41.9 29.8 40 64c-2.1 36.9 18 60.2 18.8 96h74.4zm3.7 32H55.1c-10.8 45.2-40 79.9-50.7 128-11.5 51.1.5 140.5 26.6 192h130c26.1-51.5 38.1-140.9 26.7-192-10.8-48.1-40-82.8-50.8-128z"]
  },
      Ka = {
    prefix: "fas",
    iconName: "box",
    icon: [512, 512, [], "f466", "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"]
  },
      Xa = {
    prefix: "fas",
    iconName: "box-alt",
    icon: [448, 512, [], "f49a", "M446.7 160c.4-.5.5-.7.9-1.2L391.3 53.9C386.9 40.8 374.7 32 360.9 32H256l32 128h158.7zM160 160l32-128H87.1c-13.8 0-26 8.8-30.4 21.9L.4 158.8c.4.5.5.7.9 1.2H160zm128 32v80c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-80H0v256c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V192H288z"]
  },
      _a = {
    prefix: "fas",
    iconName: "box-ballot",
    icon: [576, 512, [], "f735", "M432 192l-.5-175.4c0-8.8-7.2-16-16-16L159.7 0c-8.9 0-16.2 7.2-16.2 16.2L144 192h288zM0 320v160c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V320H0zm574.7-32c.4-.5.5-.7.8-1.2L520 148.2c-4.9-12.1-16.6-20.1-29.7-20.1h-26.6l.2 64 16 32H95.5l16-32h.5l-.2-64H85.7c-13.1 0-24.8 8-29.7 20.1L.4 286.8c.3.5.5.7.8 1.2h573.5z"]
  },
      $a = {
    prefix: "fas",
    iconName: "box-check",
    icon: [640, 512, [], "f467", "M240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zm235.2 81.7l-16.3-48.8C452.4 13.2 434.1 0 413.4 0H272v157.4C315.9 109.9 378.4 80 448 80c9.2 0 18.3.6 27.2 1.7zM208 320c0-34.1 7.3-66.6 20.2-96H0v240c0 26.5 21.5 48 48 48h256.6C246.1 468.2 208 398.6 208 320zm240-192c-106 0-192 86-192 192s86 192 192 192 192-86 192-192-86-192-192-192zm114.1 147.8l-131 130c-4.3 4.3-11.3 4.3-15.6-.1l-75.7-76.3c-4.3-4.3-4.2-11.3.1-15.6l26-25.8c4.3-4.3 11.3-4.2 15.6.1l42.1 42.5 97.2-96.4c4.3-4.3 11.3-4.2 15.6.1l25.8 26c4.2 4.3 4.2 11.3-.1 15.5z"]
  },
      cn = {
    prefix: "fas",
    iconName: "box-fragile",
    icon: [448, 512, [], "f49b", "M416 32H32C14.3 32 0 46.3 0 64v384c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zm-96 160c0 47.5-34.6 86.7-80 94.4V384h40c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h40v-97.6c-45.4-7.7-80-46.8-80-94.4v-80c0-8.8 7.2-16 16-16h60.4l24.5 27.6-64 32 91 68.4-37-59.6 64-32L260.1 96H304c8.8 0 16 7.2 16 16v80z"]
  },
      en = {
    prefix: "fas",
    iconName: "box-full",
    icon: [640, 512, [], "f49c", "M384.3 360.6L320 254l-64.2 106.6c-6.4 10.7-26.1 29.8-54.7 21.6L64 343v82c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 456c14.2-3.6 24.2-16.4 24.2-31v-82l-137 39.1c-28.5 8.2-48.2-10.7-54.7-21.5zM194.2 143.7c-1.3-5.1-2.2-10.3-2.2-15.7 0-35.3 28.7-64 64-64s64 28.7 64 64c0 11.2-3.1 21.5-8.2 30.7l8.2 1L475.3 140 511 41.7c3-8.3-1.3-17.5-9.6-20.5L445.9 1c-8.3-3-17.5 1.3-20.5 9.6L383.7 125C382 55.7 325.7 0 256 0c-70.7 0-128 57.3-128 128 0 2.5.6 4.9.7 7.4zM53.2 169L1.7 271.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 192 69.8 160.1c-6.9-.8-13.5 2.7-16.6 8.9zm585.1 102.8L586.8 169c-3.1-6.2-9.8-9.8-16.7-8.9L320 192l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1z"]
  },
      an = {
    prefix: "fas",
    iconName: "box-heart",
    icon: [448, 512, [], "f49d", "M447.6 158.8L391.3 53.9C386.9 40.8 374.7 32 360.9 32H240v128h206.7c.4-.5.5-.7.9-1.2zM0 192v256c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V192H0zm305.1 149.2l-72.6 71.4c-4.7 4.6-12.3 4.6-17 0l-72.6-71.4c-21.1-20.7-19.8-55.1 3.7-74.2 20.5-16.7 51.1-13.7 70 4.8l7.4 7.3 7.4-7.3c18.8-18.5 49.4-21.5 70-4.8 23.5 19.1 24.7 53.4 3.7 74.2zM208 160V32H87.1c-13.8 0-26 8.8-30.4 21.9L.4 158.8c.4.5.5.7.9 1.2H208z"]
  },
      nn = {
    prefix: "fas",
    iconName: "box-open",
    icon: [640, 512, [], "f49e", "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"]
  },
      tn = {
    prefix: "fas",
    iconName: "box-tissue",
    icon: [512, 512, [], "e05b", "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"]
  },
      rn = {
    prefix: "fas",
    iconName: "box-up",
    icon: [448, 512, [], "f49f", "M416 32H32C14.3 32 0 46.3 0 64v384c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zM57.8 179l64-80c3-3.8 9.5-3.8 12.5 0l64 80c4.2 5.2.4 13-6.2 13h-32v112c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V192H64c-6.7 0-10.4-7.8-6.2-13zM384 408c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v16zm0-216h-32v112c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V192h-32c-6.7 0-10.4-7.8-6.2-13l64-80c3-3.8 9.5-3.8 12.5 0l64 80c4.1 5.2.4 13-6.3 13z"]
  },
      on = {
    prefix: "fas",
    iconName: "box-usd",
    icon: [448, 512, [], "f4a0", "M447.6 158.8L391.3 53.9C386.9 40.8 374.7 32 360.9 32H240v128h206.7c.4-.5.5-.7.9-1.2zM208 160V32H87.1c-13.8 0-26 8.8-30.4 21.9L.4 158.8c.4.5.5.7.9 1.2H208zM0 192v256c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V192H0zm240 223.9V432c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16.3c-11.3-.6-22.3-4.5-31.4-11.3-3.9-2.9-4.1-8.8-.6-12.1l11.8-11.2c2.8-2.6 6.9-2.8 10.1-.7 3.9 2.4 8.3 3.7 12.8 3.7h28.1c6.5 0 11.8-5.9 11.8-13.2 0-6-3.6-11.2-8.8-12.7l-45-13.5c-18.6-5.6-31.6-23.4-31.6-43.4 0-24.5 19-44.4 42.7-45.1V240c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16.3c11.3.6 22.3 4.5 31.4 11.3 3.9 2.9 4.1 8.8.6 12.1L260.2 291c-2.8 2.6-6.9 2.8-10.1.7-3.9-2.4-8.3-3.7-12.8-3.7h-28.1c-6.5 0-11.8 5.9-11.8 13.2 0 6 3.6 11.2 8.8 12.7l45 13.5c18.6 5.6 31.6 23.4 31.6 43.4-.1 24.5-19.2 44.5-42.8 45.1z"]
  },
      ln = {
    prefix: "fas",
    iconName: "boxes",
    icon: [576, 512, [], "f468", "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
  },
      fn = {
    prefix: "fas",
    iconName: "boxes-alt",
    icon: [576, 512, [], "f4a1", "M240 288h-80v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-64-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm384 64h-80v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"]
  },
      sn = {
    prefix: "fas",
    iconName: "boxing-glove",
    icon: [448, 512, [], "f438", "M384 160h-31.1c-26.3 0-48.3 20.8-48.8 47.1-.5 24.6 17.6 45.1 41.1 48.4 4 .6 6.9 4.1 6.9 8.1v16c0 4.7-4.1 8.5-8.8 8-40-4.4-71.2-38.4-71.2-79.5 0-5.5.6-10.8 1.6-16H141.2c-30.6 0-59.5-10.9-82.3-30.8-3.5-3.1-3.7-8.4-.4-11.7l11.3-11.3c3-3 7.7-3.1 10.9-.4 16.9 14.4 38.1 22.3 60.5 22.3H288v.5c28.4-38.1 66.9-32.5 96-32.5V96c0-53-43-96-96-96H96C43.3 0 0 43.1 0 95.9c0 63.9 5.3 127.8 15.8 190.8L32 384h40c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32v-64h-40c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h40l58.5-58.5C450.8 285.1 448 237.8 448 224c0-35.3-28.7-64-64-64zM260.8 441.6l-9.6 12.8c-2.6 3.5-7.7 4.3-11.2 1.6l-48-36-48 36c-3.5 2.7-8.6 1.9-11.2-1.6l-9.6-12.8c-2.6-3.5-1.9-8.5 1.6-11.2l40.5-30.4-40.5-30.4c-3.5-2.6-4.3-7.7-1.6-11.2l9.6-12.8c2.6-3.5 7.7-4.3 11.2-1.6l48 36 48-36c3.5-2.7 8.6-1.9 11.2 1.6l9.6 12.8c2.6 3.5 1.9 8.5-1.6 11.2L218.7 400l40.5 30.4c3.5 2.6 4.2 7.7 1.6 11.2z"]
  },
      un = {
    prefix: "fas",
    iconName: "brackets",
    icon: [448, 512, [], "f7e9", "M144 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h112a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H64V96h80a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm272 0H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h80v320h-80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h112a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32z"]
  },
      hn = {
    prefix: "fas",
    iconName: "brackets-curly",
    icon: [576, 512, [], "f7ea", "M208 32h-48a96 96 0 0 0-96 96v37.48a32.06 32.06 0 0 1-9.38 22.65L9.37 233.37a32 32 0 0 0 0 45.26l45.25 45.25A32 32 0 0 1 64 346.51V384a96 96 0 0 0 96 96h48a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-48a32 32 0 0 1-32-32v-37.48a96 96 0 0 0-28.13-67.89L77.25 256l22.63-22.63A96 96 0 0 0 128 165.48V128a32 32 0 0 1 32-32h48a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm358.63 201.37l-45.25-45.24a32.06 32.06 0 0 1-9.38-22.65V128a96 96 0 0 0-96-96h-48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h48a32 32 0 0 1 32 32v37.47a96 96 0 0 0 28.13 67.91L498.75 256l-22.62 22.63A96 96 0 0 0 448 346.52V384a32 32 0 0 1-32 32h-48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h48a96 96 0 0 0 96-96v-37.49a32 32 0 0 1 9.38-22.63l45.25-45.25a32 32 0 0 0 0-45.26z"]
  },
      mn = {
    prefix: "fas",
    iconName: "braille",
    icon: [640, 512, [], "f2a1", "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"]
  },
      vn = {
    prefix: "fas",
    iconName: "brain",
    icon: [576, 512, [], "f5dc", "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"]
  },
      dn = {
    prefix: "fas",
    iconName: "bread-loaf",
    icon: [640, 512, [], "f7eb", "M480 192c0-88.37-107.45-160-240-160S0 103.63 0 192c0 35.35 26.86 64 60 64h4v192a32 32 0 0 0 32 32h288a32 32 0 0 0 32-32V256h4c33.14 0 60-28.65 60-64zM400 32c-2.43 0-4.78.2-7.19.24C465.2 66.39 512 124.62 512 192c0 42.75-26.92 79.06-64 91.46V448a63.27 63.27 0 0 1-8.9 32H544a32 32 0 0 0 32-32V256h4c33.14 0 60-28.65 60-64 0-88.37-107.45-160-240-160z"]
  },
      Mn = {
    prefix: "fas",
    iconName: "bread-slice",
    icon: [576, 512, [], "f7ec", "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"]
  },
      pn = {
    prefix: "fas",
    iconName: "briefcase",
    icon: [512, 512, [], "f0b1", "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"]
  },
      zn = {
    prefix: "fas",
    iconName: "briefcase-medical",
    icon: [512, 512, [], "f469", "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"]
  },
      Cn = {
    prefix: "fas",
    iconName: "bring-forward",
    icon: [512, 512, [], "f856", "M352 304V48a48 48 0 0 0-48-48H48A48 48 0 0 0 0 48v256a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48zm112-144h-80v64h64v224H224v-64h-64v80a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48V208a48 48 0 0 0-48-48z"]
  },
      Ln = {
    prefix: "fas",
    iconName: "bring-front",
    icon: [640, 512, [], "f857", "M480 368V144a48 48 0 0 0-48-48H208a48 48 0 0 0-48 48v224a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48zM64 64h192V32a32 32 0 0 0-32-32H32A32 32 0 0 0 0 32v192a32 32 0 0 0 32 32h96v-64H64zm544 192h-96v64h64v128H384v32a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32V288a32 32 0 0 0-32-32z"]
  },
      An = {
    prefix: "fas",
    iconName: "broadcast-tower",
    icon: [640, 512, [], "f519", "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"]
  },
      Nn = {
    prefix: "fas",
    iconName: "broom",
    icon: [640, 512, [], "f51a", "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"]
  },
      gn = {
    prefix: "fas",
    iconName: "browser",
    icon: [512, 512, [], "f37e", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM128 148c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm320 0c0 6.6-5.4 12-12 12H188c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h248c6.6 0 12 5.4 12 12v40z"]
  },
      Hn = {
    prefix: "fas",
    iconName: "brush",
    icon: [384, 512, [], "f55d", "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"]
  },
      Vn = {
    prefix: "fas",
    iconName: "bug",
    icon: [512, 512, [], "f188", "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"]
  },
      xn = {
    prefix: "fas",
    iconName: "building",
    icon: [448, 512, [], "f1ad", "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"]
  },
      wn = {
    prefix: "fas",
    iconName: "bullhorn",
    icon: [576, 512, [], "f0a1", "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"]
  },
      yn = {
    prefix: "fas",
    iconName: "bullseye",
    icon: [496, 512, [], "f140", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"]
  },
      bn = {
    prefix: "fas",
    iconName: "bullseye-arrow",
    icon: [496, 512, [], "f648", "M305.05 98.74l16.57 49.7-90.59 90.59c-9.38 9.38-9.38 24.56 0 33.94 9.37 9.37 24.56 9.38 33.94 0l90.59-90.59 49.7 16.57c7.39 2.46 15.53.54 21.04-4.96l63.67-63.67c10.8-10.8 6.46-29.2-8.04-34.04l-55.66-18.55-18.55-55.65c-4.83-14.5-23.23-18.84-34.04-8.04L310.02 77.7a20.582 20.582 0 0 0-4.97 21.04zm-75.17 96.19l55.14-55.14-2.12-6.38c-11.17-3.17-22.72-5.41-34.9-5.41-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128c0-12.18-2.24-23.73-5.42-34.89l-6.37-2.12-55.14 55.14C301.19 300.55 276.95 320 248 320c-35.29 0-64-28.71-64-64 0-28.95 19.45-53.19 45.88-61.07zm254.55-13.83l-35.5 35.5c-5.5 5.5-12.07 9.48-19.17 12.07 1.33 8.94 2.25 18.02 2.25 27.33 0 101.69-82.29 184-184 184-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 9.42 0 18.6.93 27.63 2.29 2.58-7.02 6.23-13.69 11.76-19.22l35.5-35.5A247.848 247.848 0 0 0 248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248c0-26.11-4.09-51.26-11.57-74.9z"]
  },
      Sn = {
    prefix: "fas",
    iconName: "bullseye-pointer",
    icon: [496, 512, [], "f649", "M242.16 240.67L27.98 301.55c-15.17 4.31-16.95 25.1-2.73 31.92l68.47 32.89-89.17 89.17c-6.07 6.06-6.07 15.9 0 21.96l21.96 21.96c6.07 6.06 15.9 6.06 21.96 0l89.17-89.17 32.89 68.47c6.83 14.22 27.61 12.44 31.92-2.73l60.87-214.18c3.68-12.91-8.25-24.83-21.16-21.17zm40.91 68.76l-20.79 73.13C326.16 375.37 376 321.8 376 256c0-70.69-57.31-128-128-128-65.8 0-119.38 49.84-126.56 113.72l73.13-20.78C206.02 203.54 225.66 192 248 192c35.29 0 64 28.71 64 64 0 22.34-11.54 41.98-28.93 53.43zM248 8C111.03 8 0 119.03 0 256c0 8.39.44 16.67 1.26 24.85 5.22-4.39 11.05-8.11 17.98-10.08l44.87-12.75c-.01-.68-.1-1.33-.1-2.01 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184-.68 0-1.34-.09-2.01-.1l-12.75 44.87c-1.97 6.94-5.69 12.77-10.06 17.98 8.17.81 16.45 1.25 24.83 1.25 136.97 0 248-111.03 248-248S384.97 8 248 8z"]
  },
      Tn = {
    prefix: "fas",
    iconName: "burger-soda",
    icon: [640, 512, [], "f858", "M352 176v-32a16 16 0 0 0-16-16H206.74l20-80H272a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-51.5a40 40 0 0 0-38.81 30.3L157.26 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16zm-88.45 142.22a64.71 64.71 0 0 1 3.74-66.82c6.72-9.87 15.07-18.86 24.09-27.4H38.27l25.78 258.29A31.88 31.88 0 0 0 96 512h160a31.59 31.59 0 0 0 13.65-3.36A79.55 79.55 0 0 1 256 464a47.93 47.93 0 0 1 17-36.61 63.91 63.91 0 0 1 4.58-91.27 64 64 0 0 1-14.03-17.9zM624 448H304a16 16 0 0 0-16 16 48 48 0 0 0 48 48h256a48 48 0 0 0 48-48 16 16 0 0 0-16-16zm-16-96H320a32 32 0 0 0 0 64h288a32 32 0 0 0 0-64zm-314.26-82.59c-14.53 21.32.19 50.59 25.54 50.59h289.45c25.35 0 40-29.27 25.53-50.59C604.8 226.13 539.94 192.07 464 192s-140.79 34.13-170.26 77.41zM544 240a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-80-16a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-80 16a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"]
  },
      Dn = {
    prefix: "fas",
    iconName: "burn",
    icon: [384, 512, [], "f46a", "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"]
  },
      jn = {
    prefix: "fas",
    iconName: "burrito",
    icon: [512, 512, [], "f7ed", "M307.29 230.32C278.33 310.45 201.65 368 111.57 368A206.93 206.93 0 0 1 .72 335.76c-3.72 33.8 6.86 68.88 32.74 94.74L81 478a116.2 116.2 0 0 0 164.22 0l216-215.73A175.28 175.28 0 0 0 351.83 224c-15.22 0-30.04 2.53-44.54 6.32zM287.76 160a174.91 174.91 0 0 0-38.33-109.28l-216 215.73A115.28 115.28 0 0 0 9 302.83 175.18 175.18 0 0 0 111.57 336c97.14 0 176.19-78.95 176.19-176zM512 123a74.14 74.14 0 0 0-52.31-70.74A74.18 74.18 0 0 0 358 6.73 80.14 80.14 0 0 0 325.8 0c-22.06 0-42 9.37-56.81 24.26A204.24 204.24 0 0 1 316.61 195a209.73 209.73 0 0 1 35.22-3 207.25 207.25 0 0 1 135.88 50.75C502.63 228 512 208 512 186a80.08 80.08 0 0 0-6.74-32.12A73.35 73.35 0 0 0 512 123z"]
  },
      En = {
    prefix: "fas",
    iconName: "bus",
    icon: [512, 512, [], "f207", "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      kn = {
    prefix: "fas",
    iconName: "bus-alt",
    icon: [512, 512, [], "f55e", "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      In = {
    prefix: "fas",
    iconName: "bus-school",
    icon: [512, 512, [], "f5dd", "M488 112h-24V80c0-44.8-92.11-80-208-80S48 35.2 48 80v32H24c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h24v20.9c-9.39 5.57-16 15.38-16 27.1v128c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32c17.67 0 32-14.33 32-32V288c0-11.72-6.61-21.52-16-27.1V240h24c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 312c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-128h-96c-17.67 0-32-14.33-32-32v-64c0-17.67 14.33-32 32-32h96v128zm32 0V128h96c17.67 0 32 14.33 32 32v64c0 17.67-14.33 32-32 32h-96zm128 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      On = {
    prefix: "fas",
    iconName: "business-time",
    icon: [640, 512, [], "f64a", "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"]
  },
      Qn = {
    prefix: "fas",
    iconName: "cabinet-filing",
    icon: [512, 512, [], "f64b", "M480 0H32C14.33 0 0 14.33 0 32v192h512V32c0-17.67-14.33-32-32-32zM352 152c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24H192v24c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40c0-8.84 7.16-16 16-16h160c8.84 0 16 7.16 16 16v40zM0 480c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V256H0v224zm160-112c0-8.84 7.16-16 16-16h160c8.84 0 16 7.16 16 16v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24H192v24c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40z"]
  },
      Zn = {
    prefix: "fas",
    iconName: "cactus",
    icon: [512, 512, [], "f8a7", "M464 224a48 48 0 0 0-48 48v64a16 16 0 0 1-16 16h-48V101.43c0-52-38.93-98.58-90.84-101.29A96 96 0 0 0 160 96v128h-48a16 16 0 0 1-16-16v-64a48 48 0 0 0-96 0v64a112 112 0 0 0 112 112h48v160a32 32 0 0 0 32 32h128a32 32 0 0 0 32-32v-32h48a112 112 0 0 0 112-112v-64a48 48 0 0 0-48-48zm-240-48a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm64 224a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"]
  },
      Un = {
    prefix: "fas",
    iconName: "calculator",
    icon: [448, 512, [], "f1ec", "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"]
  },
      Bn = {
    prefix: "fas",
    iconName: "calculator-alt",
    icon: [512, 512, [], "f64c", "M192 288H32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V320c0-17.67-14.33-32-32-32zm-29.09 140.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L112 422.63l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L61.09 439.6c-3.12-3.12-3.12-8.19 0-11.31L89.37 400l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.3 28.28 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L134.63 400l28.28 28.29zM480 0H320c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-16 120c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40V56c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16zm16 168H320c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V320c0-17.67-14.33-32-32-32zm-16 152c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm0-64c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zM192 0H32C14.33 0 0 14.33 0 32v160c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-16 120c0 4.42-3.58 8-8 8H56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16z"]
  },
      Rn = {
    prefix: "fas",
    iconName: "calendar",
    icon: [448, 512, [], "f133", "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"]
  },
      Yn = {
    prefix: "fas",
    iconName: "calendar-alt",
    icon: [448, 512, [], "f073", "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"]
  },
      Pn = {
    prefix: "fas",
    iconName: "calendar-check",
    icon: [448, 512, [], "f274", "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"]
  },
      Fn = {
    prefix: "fas",
    iconName: "calendar-day",
    icon: [448, 512, [], "f783", "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"]
  },
      Wn = {
    prefix: "fas",
    iconName: "calendar-edit",
    icon: [448, 512, [], "f333", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm208.4 109.6l-95 95-5.4 48.2c-.7 6.4 4.7 11.9 11.2 11.2l48.2-5.4 95-95c2-2 2-5.2 0-7.2l-46.8-46.8c-2-2-5.2-2-7.2 0zm109.7-30.3l-25.4-25.4c-7.9-7.9-20.7-7.9-28.6 0l-26 26c-2 2-2 5.2 0 7.2l46.8 46.8c2 2 5.2 2 7.2 0l26-26c7.9-7.9 7.9-20.7 0-28.6z"]
  },
      Gn = {
    prefix: "fas",
    iconName: "calendar-exclamation",
    icon: [448, 512, [], "f334", "M0 148v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zm448 56v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12h424c6.6 0 12 5.4 12 12zM224 392c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zm-39.2-139.2l7.2 112c.4 6.3 5.6 11.2 12 11.2h40c6.3 0 11.6-4.9 12-11.2l7.2-112c.4-6.9-5-12.8-12-12.8h-54.4c-6.9 0-12.4 5.9-12 12.8z"]
  },
      qn = {
    prefix: "fas",
    iconName: "calendar-minus",
    icon: [448, 512, [], "f272", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"]
  },
      Jn = {
    prefix: "fas",
    iconName: "calendar-plus",
    icon: [448, 512, [], "f271", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"]
  },
      Kn = {
    prefix: "fas",
    iconName: "calendar-star",
    icon: [448, 512, [], "f736", "M400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48zM0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm134.1-143.7l54.7-8 24.5-49.6c4.4-9 17.1-8.8 21.5 0l24.5 49.6 54.7 8c9.8 1.4 13.7 13.5 6.6 20.5L281 379.4l9.4 54.6c1.7 9.9-8.7 17.2-17.4 12.6l-49-25.8-48.9 25.8c-8.7 4.6-19.1-2.8-17.4-12.6l9.4-54.6-39.6-38.6c-7.2-7-3.2-19.1 6.6-20.5z"]
  },
      Xn = {
    prefix: "fas",
    iconName: "calendar-times",
    icon: [448, 512, [], "f273", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"]
  },
      _n = {
    prefix: "fas",
    iconName: "calendar-week",
    icon: [448, 512, [], "f784", "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"]
  },
      $n = {
    prefix: "fas",
    iconName: "camcorder",
    icon: [576, 512, [], "f8a8", "M525.59 165.7L416 241.3v157.4l109.59 75.5c21.21 14.6 50.41-.29 50.41-25.79V191.5c0-25.41-29.09-40.41-50.41-25.8zM336.2 160H96v-32a32 32 0 0 1 32-32h176a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H128a96 96 0 0 0-96 96v34.89A47.66 47.66 0 0 0 0 207.8v224.4A47.81 47.81 0 0 0 47.8 480h288.4a47.81 47.81 0 0 0 47.8-47.8V207.8a47.81 47.81 0 0 0-47.8-47.8zM320 249.6a6.41 6.41 0 0 1-6.4 6.4H70.4a6.41 6.41 0 0 1-6.4-6.4v-19.2a6.41 6.41 0 0 1 6.4-6.4h243.2a6.41 6.41 0 0 1 6.4 6.4z"]
  },
      ct = {
    prefix: "fas",
    iconName: "camera",
    icon: [512, 512, [], "f030", "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"]
  },
      et = {
    prefix: "fas",
    iconName: "camera-alt",
    icon: [512, 512, [], "f332", "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88zm-120 0c0-17.6 14.4-32 32-32 8.8 0 16-7.2 16-16s-7.2-16-16-16c-35.3 0-64 28.7-64 64 0 8.8 7.2 16 16 16s16-7.2 16-16z"]
  },
      at = {
    prefix: "fas",
    iconName: "camera-home",
    icon: [448, 512, [], "f8fe", "M384,0H64A64,64,0,0,0,0,64V352a64,64,0,0,0,64,64h72.71L76.53,450.83c-6.9,4.33-12.5,14.45-12.5,22.6v11.9A26.68,26.68,0,0,0,90.7,512H357.37A26.68,26.68,0,0,0,384,485.33V473.45c0-8.17-5.65-18.3-12.58-22.62L311.28,416H384a64,64,0,0,0,64-64V64A64,64,0,0,0,384,0ZM224,352h-.05a144,144,0,1,1,.05,0Zm0-256h-.05a112,112,0,1,0,.05,0Zm0,80a32,32,0,0,0-32,32,16,16,0,0,1-32,0,64.06,64.06,0,0,1,64-64,16,16,0,0,1,0,32Z"]
  },
      nt = {
    prefix: "fas",
    iconName: "camera-movie",
    icon: [576, 512, [], "f8a9", "M535.68 260.59L448 321.05V447l87.66 60.39c17 11.68 40.32-.23 40.32-20.63V281.22c.02-20.32-23.25-32.32-40.3-20.63zM368.2 288H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h48v112.2a47.81 47.81 0 0 0 47.8 47.8h256.4a47.81 47.81 0 0 0 47.8-47.8V335.8a47.81 47.81 0 0 0-47.8-47.8zM352 0c-48.57 0-90.31 27.37-112 67.23C218.31 27.37 176.57 0 128 0a128 128 0 0 0 0 256h224a128 128 0 0 0 0-256zM128 192a64 64 0 1 1 64-64 64.07 64.07 0 0 1-64 64zm224 0a64 64 0 1 1 64-64 64.07 64.07 0 0 1-64 64z"]
  },
      tt = {
    prefix: "fas",
    iconName: "camera-polaroid",
    icon: [576, 512, [], "f8aa", "M570.63 343.94L512 256V80a48 48 0 0 0-48-48H112a48 48 0 0 0-48 48v176L5.38 343.94A32 32 0 0 0 0 361.69V448a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32v-86.31a32 32 0 0 0-5.37-17.75zM392 112a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v32a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8zm-104 16a64 64 0 1 1-64 64 64.1 64.1 0 0 1 64-64zm192 280a8 8 0 0 1-8 8H104a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h368a8 8 0 0 1 8 8z"]
  },
      rt = {
    prefix: "fas",
    iconName: "camera-retro",
    icon: [512, 512, [], "f083", "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"]
  },
      it = {
    prefix: "fas",
    iconName: "campfire",
    icon: [512, 512, [], "f6ba", "M501 450.17l-139.97-44.68L501 360.81c8.26-2.64 12.86-11.61 10.28-20.04l-9.35-30.55c-2.58-8.43-11.37-13.13-19.62-10.5L256 371.96 29.69 299.72c-8.26-2.63-17.04 2.07-19.62 10.5L.72 340.77c-2.58 8.43 2.02 17.41 10.28 20.04l139.97 44.68L11 450.17C2.74 452.8-1.86 461.78.72 470.21l9.35 30.55c2.58 8.43 11.37 13.13 19.62 10.5L256 439.02l226.31 72.24c8.26 2.63 17.04-2.07 19.62-10.5l9.35-30.55c2.58-8.43-2.02-17.4-10.28-20.04zM256 320c79.53 0 144-64.47 144-144 0-33.29-33.42-101.96-80-144-13.37 12.06-25.45 24.75-36.14 37.48C266.34 46.01 244.61 22.21 220 0c-63.17 56.98-108 131.22-108 176 0 79.53 64.47 144 144 144zM220.5 92.48c4.23 5.09 60.42 80.06 60.42 80.06l35.84-42.72c2.53 4.37 4.83 8.65 6.89 12.76 16.71 33.33 9.66 75.99-20.44 97.99C289.97 250.26 273.64 256 256 256c-44.11 0-80-30.49-80-80 0-24.66 14.86-46.39 44.5-83.52z"]
  },
      ot = {
    prefix: "fas",
    iconName: "campground",
    icon: [640, 512, [], "f6bb", "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"]
  },
      lt = {
    prefix: "fas",
    iconName: "candle-holder",
    icon: [448, 512, [], "f6bc", "M160 192c45.93 0 78-32.61 78-79.29C238 82.72 205.41 37.82 160 0c-45.62 38-78 82.84-78 112.71 0 46.68 32.07 79.29 78 79.29zm216 176c-39.7 0-72 32.3-72 72 0 8.46 1.73 16.46 4.42 24H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h360c39.7 0 72-32.3 72-72s-32.3-72-72-72zm0 96c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zM256 256c0-17.67-14.33-32-32-32h-64v48c0 8.84-7.16 16-16 16s-16-7.16-16-16v-48H96c-17.67 0-32 14.33-32 32v176h192V256z"]
  },
      ft = {
    prefix: "fas",
    iconName: "candy-cane",
    icon: [512, 512, [], "f786", "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"]
  },
      st = {
    prefix: "fas",
    iconName: "candy-corn",
    icon: [640, 512, [], "f6bd", "M187.09 307.14c-43.74 43.74-71.71 81.05-88.97 107.56 115.85 67.98 243.97 122.28 280.91 85.33l.06-.06c36.88-37.09-17.38-165.27-85.4-281.18-26.45 17.31-63.38 45.14-106.6 88.35zM326 446.95c-19.61-3.51-50.11-14.01-87.69-30.88 8.55-9.53 17.64-19.32 28.02-29.7 10.04-10.04 19.56-18.92 28.81-27.24 16.87 37.64 27.36 68.18 30.86 87.82zm-48.89-255.73c-9.69-15.74-19.51-31.14-29.28-45.81-18.62-27.95-44.49-55.7-162.89 60.4-116.1 118.4-88.35 144.27-60.4 162.89 14.73 9.81 30.2 19.68 46.01 29.41 18.29-28.22 47.93-67.63 93.91-113.61 45.46-45.46 84.5-74.94 112.65-93.28zM480 0C314.19 1.62 315.52 39.54 322.11 72.47c3.47 17.35 7.44 35.27 11.74 53.33 32.89-7.02 81.71-13.93 146.74-13.93 64.29 0 112.75 6.76 145.62 13.7 4.28-17.98 8.22-35.81 11.68-53.1C644.48 39.54 645.81 1.62 480 0zM341.62 157.03C375.47 287.01 427.67 416 479.91 416h.09c52.3-.15 104.57-129.16 138.44-259.21-30.94-6.47-76.74-12.91-137.85-12.91-61.87 0-108.03 6.6-138.97 13.15zm138.33 183.93c-11.38-16.35-25.53-45.33-40.17-83.84 12.78-.69 26.14-1.19 40.81-1.19 14.2 0 27.21.45 39.63 1.11-14.68 38.55-28.86 67.56-40.27 83.92z"]
  },
      ut = {
    prefix: "fas",
    iconName: "cannabis",
    icon: [512, 512, [], "f55f", "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"]
  },
      ht = {
    prefix: "fas",
    iconName: "capsules",
    icon: [576, 512, [], "f46b", "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"]
  },
      mt = {
    prefix: "fas",
    iconName: "car",
    icon: [512, 512, [], "f1b9", "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"]
  },
      vt = {
    prefix: "fas",
    iconName: "car-alt",
    icon: [480, 512, [], "f5de", "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"]
  },
      dt = {
    prefix: "fas",
    iconName: "car-battery",
    icon: [512, 512, [], "f5df", "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"]
  },
      Mt = {
    prefix: "fas",
    iconName: "car-building",
    icon: [640, 512, [], "f859", "M213.52 455.07A88.41 88.41 0 0 1 192 397.24v-28.69a89.11 89.11 0 0 1 42.09-75.84l7.55-20.71H220a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a11.79 11.79 0 0 1 9.43 4.92A131.1 131.1 0 0 1 352 162.18V32a32 32 0 0 0-32-32H32A32 32 0 0 0 0 32v464a16 16 0 0 0 16 16h205.06a59.85 59.85 0 0 1-7.54-28.69zM208 92a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12v40a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12zm-64 296a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12V92a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm460.58 183.56L600 304.2l-17.87-49.08a99.92 99.92 0 0 0-93.2-63.12H375.07a99.94 99.94 0 0 0-93.24 63.12L264 304.2l-4.55 11.35a57.41 57.41 0 0 0-35.42 53v28.69a57 57 0 0 0 21.52 44.46v41.61A28.69 28.69 0 0 0 274.21 512h28.69a28.69 28.69 0 0 0 28.68-28.69V448h200.83v35.31A28.7 28.7 0 0 0 561.1 512h28.69a28.7 28.7 0 0 0 28.69-28.69V441.7A57 57 0 0 0 640 397.24v-28.69a57.39 57.39 0 0 0-35.42-52.99zM335.11 284c6.53-16.92 22.36-28 40-28h113.82c17.6 0 33.42 11.1 40 28L541 320H323zM300 407.85c-14.4 0-24-9.57-24-23.93S285.6 360 300 360s36 21.53 36 35.89-21.6 11.96-36 11.96zm264 0c-14.4 0-36 2.39-36-12S549.6 360 564 360s24 9.57 24 23.92-9.6 23.93-24 23.93z"]
  },
      pt = {
    prefix: "fas",
    iconName: "car-bump",
    icon: [576, 512, [], "f5e0", "M575.67 492.44c2.06 9.91-5.85 19.27-16.13 19.27h-158.9c-10.29 0-18.19-9.35-16.13-19.27 9.07-43.75 48.42-76.67 95.58-76.67s86.51 32.92 95.58 76.67zm-401.95-39.28c7.2 16.17-.24 35.04-16.62 42.15l-32.21 13.98c-16.38 7.11-35.5-.23-42.7-16.4l-22.56-50.64c-13.99-6.28-25.89-17.26-32.57-32.24L5.45 361.49C-5.9 336 1.13 307.34 20.57 289.3l-1.04-30.49-1.89-55.13c-1.62-47.33 25.71-90.22 69.62-109.28l121.08-52.56c43.92-19.06 94.42-9.95 128.66 23.22l39.89 38.64 22.06 21.37c26.61-1.95 52.76 12.31 64.12 37.79l21.62 48.52c6.68 14.98 6.83 31.06 2.06 45.48l22.56 50.64c7.2 16.17-.24 35.04-16.62 42.15l-32.21 13.98c-16.38 7.11-35.5-.23-42.7-16.4l-13.79-30.95-244.06 105.93 13.79 30.95zm181.42-205.69c8.02 18.01 34.14 3.09 52.45-4.85 18.3-7.94 25.16-25.25 17.13-43.26-8.02-18.01-25.58-24.72-43.88-16.78-18.3 7.95-33.73 46.88-25.7 64.89zm-213.56 92.7c-8.02-18.01-47.52-33.11-65.82-25.17-18.3 7.94-25.16 25.25-17.13 43.26 8.02 18.01 25.58 24.72 43.88 16.78 18.3-7.95 47.1-16.86 39.07-34.87zm188.63-189.52l-39.89-38.64c-14.59-14.13-36.43-18.07-55.14-9.95L114.1 154.62c-18.71 8.12-30.53 26.67-29.84 46.84l1.89 55.13 244.06-105.94z"]
  },
      zt = {
    prefix: "fas",
    iconName: "car-bus",
    icon: [640, 512, [], "f85a", "M604.58 315.56L600 304.2l-17.87-49.08a99.92 99.92 0 0 0-93.2-63.12H375.07a99.92 99.92 0 0 0-93.23 63.12L264 304.2l-4.55 11.36a57.39 57.39 0 0 0-35.42 53v28.69a57 57 0 0 0 21.52 44.46V480a32 32 0 0 0 32 32h22.07a32 32 0 0 0 32-32v-32h200.79v32a32 32 0 0 0 32 32h22.07a32 32 0 0 0 32-32v-38.3A57 57 0 0 0 640 397.24v-28.69a57.39 57.39 0 0 0-35.42-52.99zM335.11 284c6.53-16.92 22.36-28 40-28h113.82c17.6 0 33.42 11.1 40 28L541 320H323zM300 407.85c-14.4 0-24-9.57-24-23.92S285.6 360 300 360s36 21.53 36 35.89-21.6 11.96-36 11.96zm264 0c-14.4 0-36 2.39-36-12S549.6 360 564 360s24 9.57 24 23.93-9.6 23.92-24 23.92zM252.12 243.23a134.44 134.44 0 0 1 9.65-19.23H192V80h81.33A14.67 14.67 0 0 1 288 94.67v98.07a131.26 131.26 0 0 1 64-30.56V62.86C352 27.66 274.06 0 176 0S0 27.66 0 62.86v259.81A29.33 29.33 0 0 0 29.33 352H40v32a32 32 0 0 0 32 32h23.17a32 32 0 0 0 32-32v-32h67c4.63-24.49 18.73-46.08 40-59.29zM80 312a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm80-88H78.67A14.67 14.67 0 0 1 64 209.33V94.67A14.67 14.67 0 0 1 78.67 80H160z"]
  },
      Ct = {
    prefix: "fas",
    iconName: "car-crash",
    icon: [640, 512, [], "f5e1", "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"]
  },
      Lt = {
    prefix: "fas",
    iconName: "car-garage",
    icon: [640, 512, [], "f5e2", "M512.49 292.9l-5.07-12.67-19.93-49.83C470.38 187.63 429.57 160 383.5 160h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.82-5.07 12.67C104.33 302.52 88 325.34 88 352v32c0 20.12 9.48 37.86 24 49.59V480c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h224v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-46.41c14.52-11.73 24-29.47 24-49.59v-32c0-26.66-16.33-49.48-39.51-59.1zM160 399.8c-19.2 0-32-12.76-32-31.9s12.8-31.9 32-31.9 48 28.71 48 47.85-28.8 15.95-48 15.95zm38.4-111.79l13.53-33.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17l13.53 33.83H198.4zM480 399.8c-19.2 0-48 3.19-48-15.95S460.8 336 480 336s32 12.76 32 31.9-12.8 31.9-32 31.9zm151.76-231.57L331.67 3.02a24.04 24.04 0 0 0-23.34 0L8.24 168.23c-7.73 4.3-10.52 14.05-6.22 21.79l7.78 14.01c4.3 7.74 14.05 10.52 21.79 6.22L320 51.53l288.41 158.73c7.74 4.3 17.49 1.51 21.79-6.22l7.78-14.01c4.3-7.75 1.51-17.5-6.22-21.8z"]
  },
      At = {
    prefix: "fas",
    iconName: "car-mechanic",
    icon: [512, 512, [], "f5e3", "M503.91 104h-55.98l-24-24 24-24h55.97c5.95 0 9.9-6.31 7.25-11.64-15.19-30.52-49.01-50.04-86.84-42.87-25.65 4.86-46.72 22.98-57.05 46.51H145.01c-12.38-28.17-40.2-48-72.94-48C40.75 0 13.9 18.12.84 44.37-1.81 49.69 2.15 56 8.09 56h55.98l24 24-24 24H8.09c-5.95 0-9.9 6.31-7.25 11.64 15.19 30.52 49.01 50.04 86.84 42.87 25.65-4.86 46.73-22.99 57.05-46.51h222.25c12.38 28.17 40.2 48 72.94 48 31.32 0 58.17-18.12 71.23-44.37 2.66-5.33-1.3-11.63-7.24-11.63zm-55.42 188.91l-5.07-12.67-19.93-49.83c-17.11-42.77-57.92-70.4-103.99-70.4h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.82-5.07 12.67C40.33 302.52 24 325.34 24 352v32c0 20.12 9.48 37.86 24 49.59V480c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h224v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-46.41c14.52-11.73 24-29.47 24-49.59v-32c0-26.66-16.33-49.48-39.51-59.09zM96 399.8c-19.2 0-32-12.76-32-31.9S76.8 336 96 336s48 28.71 48 47.85-28.8 15.95-48 15.95zm38.4-111.79l13.53-33.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17l13.53 33.83H134.4zM416 399.8c-19.2 0-48 3.19-48-15.95S396.8 336 416 336s32 12.76 32 31.9-12.8 31.9-32 31.9z"]
  },
      Nt = {
    prefix: "fas",
    iconName: "car-side",
    icon: [640, 512, [], "f5e4", "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"]
  },
      gt = {
    prefix: "fas",
    iconName: "car-tilt",
    icon: [640, 512, [], "f5e5", "M624 448H317.12l-42.1-42.1 192.33-192.33 22.63 22.63c12.5 12.5 32.76 12.5 45.25 0l22.63-22.63c12.5-12.5 12.5-32.76 0-45.26l-38.24-38.23c-1-14.91-6.93-29.56-18.33-40.96l-33.94-33.94c-19.33-19.33-47.88-23.53-71.42-12.96L368.11 30.3 318.78 9.15C276.45-9 228.04.32 195.47 32.9l-89.8 89.81c-32.57 32.57-41.89 80.97-23.75 123.31l21.14 49.33 11.92 27.82c-10.57 23.54-6.37 52.09 12.96 71.42L181.36 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM399.47 100.43c13.58-13.58 31.65-13.61 45.18-.07 13.54 13.54 13.51 31.61-.07 45.19s-31.69 36.2-45.22 22.66c-13.53-13.54-13.47-54.21.11-67.78zM140.74 220.81a48.003 48.003 0 0 1 10.18-52.85l89.8-89.8a48.003 48.003 0 0 1 52.85-10.18l49.33 21.14-181.02 181.01-21.14-49.32zm77.57 151c-13.58 13.58-31.65 13.61-45.19.07-13.53-13.53-13.51-31.61.07-45.18 13.58-13.58 54.24-13.64 67.78-.11 13.54 13.54-9.09 31.65-22.66 45.22z"]
  },
      Ht = {
    prefix: "fas",
    iconName: "car-wash",
    icon: [464, 512, [], "f5e6", "M349.33 85.33C349.33 61.77 392 0 392 0s42.67 61.77 42.67 85.33S415.56 128 392 128s-42.67-19.11-42.67-42.67zM232 128c23.56 0 42.67-19.1 42.67-42.67S232 0 232 0s-42.67 61.77-42.67 85.33S208.44 128 232 128zm-160 0c23.56 0 42.67-19.1 42.67-42.67S72 0 72 0 29.33 61.77 29.33 85.33 48.44 128 72 128zm392 224v32c0 20.12-9.48 37.86-24 49.59V480c0 17.67-14.33 32-32 32h-32c-17.67 0-32-14.33-32-32v-32H120v32c0 17.67-14.33 32-32 32H56c-17.67 0-32-14.33-32-32v-46.41C9.48 421.86 0 404.13 0 384v-32c0-26.67 16.33-49.48 39.51-59.1l5.07-12.67 19.93-49.82c17.11-42.77 57.92-70.4 103.99-70.4h127c46.06 0 86.88 27.63 103.99 70.4l19.93 49.83 5.07 12.67C447.67 302.52 464 325.34 464 352zm-344 31.85C120 364.71 91.2 336 72 336s-32 12.76-32 31.9 12.8 31.9 32 31.9 48 3.19 48-15.95zm233.6-95.84l-13.53-33.83c-7.29-18.22-24.94-30.17-44.57-30.17h-127c-19.63 0-37.28 11.95-44.57 30.17l-13.53 33.83h243.2zM424 367.9c0-19.14-12.8-31.9-32-31.9s-48 28.71-48 47.85 28.8 15.95 48 15.95 32-12.76 32-31.9z"]
  },
      Vt = {
    prefix: "fas",
    iconName: "caravan",
    icon: [640, 512, [], "f8ff", "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"]
  },
      xt = {
    prefix: "fas",
    iconName: "caravan-alt",
    icon: [640, 512, [], "e000", "M624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32Zm192,0a32,32,0,0,1-32,32H352a32,32,0,0,1-32-32V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"]
  },
      wt = {
    prefix: "fas",
    iconName: "caret-circle-down",
    icon: [512, 512, [], "f32d", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-379.5-27.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H133c-10.7 0-16.1 12.9-8.5 20.5z"]
  },
      yt = {
    prefix: "fas",
    iconName: "caret-circle-left",
    icon: [512, 512, [], "f32e", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm27.5-379.5l-123 123c-4.7 4.7-4.7 12.3 0 17l123 123c7.6 7.6 20.5 2.2 20.5-8.5V133c0-10.7-12.9-16.1-20.5-8.5z"]
  },
      bt = {
    prefix: "fas",
    iconName: "caret-circle-right",
    icon: [512, 512, [], "f330", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-27.5 379.5l123-123c4.7-4.7 4.7-12.3 0-17l-123-123c-7.6-7.6-20.5-2.2-20.5 8.5v246c0 10.7 12.9 16.1 20.5 8.5z"]
  },
      St = {
    prefix: "fas",
    iconName: "caret-circle-up",
    icon: [512, 512, [], "f331", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm379.5 27.5l-123-123c-4.7-4.7-12.3-4.7-17 0l-123 123c-7.6 7.6-2.2 20.5 8.5 20.5h246c10.7 0 16.1-12.9 8.5-20.5z"]
  },
      Tt = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [320, 512, [], "f0d7", "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"]
  },
      Dt = {
    prefix: "fas",
    iconName: "caret-left",
    icon: [192, 512, [], "f0d9", "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"]
  },
      jt = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [192, 512, [], "f0da", "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"]
  },
      Et = {
    prefix: "fas",
    iconName: "caret-square-down",
    icon: [448, 512, [], "f150", "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"]
  },
      kt = {
    prefix: "fas",
    iconName: "caret-square-left",
    icon: [448, 512, [], "f191", "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"]
  },
      It = {
    prefix: "fas",
    iconName: "caret-square-right",
    icon: [448, 512, [], "f152", "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"]
  },
      Ot = {
    prefix: "fas",
    iconName: "caret-square-up",
    icon: [448, 512, [], "f151", "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"]
  },
      Qt = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [320, 512, [], "f0d8", "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"]
  },
      Zt = {
    prefix: "fas",
    iconName: "carrot",
    icon: [512, 512, [], "f787", "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"]
  },
      Ut = {
    prefix: "fas",
    iconName: "cars",
    icon: [640, 512, [], "f85b", "M252.13 243.23A131.77 131.77 0 0 1 375.07 160h38.41a57.49 57.49 0 0 0-32.9-36.44L376 112.2l-17.84-49.08A99.92 99.92 0 0 0 264.93 0H151.07a99.92 99.92 0 0 0-93.23 63.12L40 112.2l-4.55 11.36A57.39 57.39 0 0 0 0 176.55v28.69a57 57 0 0 0 21.52 44.46V288a32 32 0 0 0 32 32h22.07a32 32 0 0 0 32-32v-32h139.88zM111.11 92c6.53-16.92 22.36-28 40-28h113.82c17.6 0 33.42 11.1 40 28L317 128H99zM76 215.85c-14.4 0-24-9.57-24-23.92S61.6 168 76 168s36 21.53 36 35.89-21.6 11.96-36 11.96zm528.58 99.71L600 304.2l-17.87-49.08a99.92 99.92 0 0 0-93.2-63.12H375.07a99.92 99.92 0 0 0-93.23 63.12L264 304.2l-4.55 11.36a57.39 57.39 0 0 0-35.42 53v28.69a57 57 0 0 0 21.52 44.46V480a32 32 0 0 0 32 32h22.07a32 32 0 0 0 32-32v-32h200.79v32a32 32 0 0 0 32 32h22.07a32 32 0 0 0 32-32v-38.3A57 57 0 0 0 640 397.24v-28.69a57.39 57.39 0 0 0-35.42-52.99zM335.11 284c6.53-16.92 22.36-28 40-28h113.82c17.6 0 33.42 11.1 40 28L541 320H323zM300 407.85c-14.4 0-24-9.57-24-23.93S285.6 360 300 360s36 21.53 36 35.89-21.6 11.96-36 11.96zm264 0c-14.4 0-36 2.39-36-12S549.6 360 564 360s24 9.57 24 23.92-9.6 23.93-24 23.93z"]
  },
      Bt = {
    prefix: "fas",
    iconName: "cart-arrow-down",
    icon: [576, 512, [], "f218", "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"]
  },
      Rt = {
    prefix: "fas",
    iconName: "cart-plus",
    icon: [576, 512, [], "f217", "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"]
  },
      Yt = {
    prefix: "fas",
    iconName: "cash-register",
    icon: [512, 512, [], "f788", "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"]
  },
      Pt = {
    prefix: "fas",
    iconName: "cassette-tape",
    icon: [512, 512, [], "f8ab", "M464 63H48a48 48 0 0 0-48 48v288a48 48 0 0 0 48 48h32l48-96h256l48 96h32a48 48 0 0 0 48-48V111a48 48 0 0 0-48-48zM128 255a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm182.78 0H201.22a78.91 78.91 0 0 0 0-64h109.56a78.91 78.91 0 0 0 0 64zm73.22 0a32 32 0 1 1 32-32 32 32 0 0 1-32 32zM147.78 383l-32 64h280.44l-32-64z"]
  },
      Ft = {
    prefix: "fas",
    iconName: "cat",
    icon: [512, 512, [], "f6be", "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      Wt = {
    prefix: "fas",
    iconName: "cat-space",
    icon: [640, 512, [], "e001", "M544,32.72461V32l-.39648.39648C516.86914,12.32617,484.00391,0,448,0s-68.86914,12.32617-95.60352,32.39648L352,32v.72461C313.35156,61.93164,288,107.82422,288,160a159.95251,159.95251,0,0,0,3.89258,34.31445c-35.83985,5.3418-91.793,23.25782-131.89258,83.63867V192A96.105,96.105,0,0,0,64,96a32,32,0,0,0,0,64,32.04169,32.04169,0,0,1,32,32V448a64.06328,64.06328,0,0,0,64,64H336a15.9908,15.9908,0,0,0,16-16V480a32.00158,32.00158,0,0,0-32-32H288l128-96V496a15.9908,15.9908,0,0,0,16,16h32a15.9908,15.9908,0,0,0,16-16V316.77539A160.036,160.036,0,0,0,608,160C608,107.82422,582.64844,61.93164,544,32.72461ZM448,32a127.06647,127.06647,0,0,1,72.9375,23.0625L480,96H416L375.0625,55.0625A127.06647,127.06647,0,0,1,448,32Zm56,128a16,16,0,1,1-16-16A15.9908,15.9908,0,0,1,504,160Zm-80,0a16,16,0,1,1-16-16A15.9908,15.9908,0,0,1,424,160Zm24,128A128.14414,128.14414,0,0,1,320,160c0-32.16992,12.334-61.25391,32-83.76367V160a96,96,0,0,0,192,0V76.23633C563.666,98.74609,576,127.83008,576,160A128.14414,128.14414,0,0,1,448,288ZM162.94531,68.76953l39.71094,16.56055,16.5625,39.71094a5.32345,5.32345,0,0,0,9.53906,0l16.5586-39.71094,39.71484-16.56055a5.336,5.336,0,0,0,0-9.541l-39.71484-16.5586L228.75781,2.957a5.325,5.325,0,0,0-9.53906,0l-16.5625,39.71289-39.71094,16.5586a5.336,5.336,0,0,0,0,9.541Z"]
  },
      Gt = {
    prefix: "fas",
    iconName: "cauldron",
    icon: [448, 512, [], "f6bf", "M448 212v-40c0-6.63-6.27-12-14-12H14c-7.73 0-14 5.37-14 12v40c0 6.63 6.27 12 14 12h19.79C12.39 262.52 0 305.28 0 345.6c0 39.08 11.82 70.65 32 95.53V488c0 13.25 10.75 24 24 24s24-10.75 24-24v-7.49c38.95 21.3 89.14 31.49 144 31.49s105.05-10.19 144-31.49V488c0 13.25 10.75 24 24 24s24-10.75 24-24v-46.87c20.18-24.88 32-56.45 32-95.53 0-40.32-12.39-83.08-33.79-121.6H434c7.73 0 14-5.37 14-12zM160 64c17.67 0 32-14.33 32-32S177.67 0 160 0s-32 14.33-32 32 14.33 32 32 32zm112 64c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48z"]
  },
      qt = {
    prefix: "fas",
    iconName: "cctv",
    icon: [576, 512, [], "f8ac", "M517.45 168.58L139.24 2.29a32 32 0 0 0-39.67 13.84L4.23 183a32 32 0 0 0 16.85 46l156.57 64.85L137.81 400H64v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h96a32 32 0 0 0 30-20.77l46.85-124.94 68.52 28.38a32 32 0 0 0 27.89-2.94l189.26-118.31c22.21-13.88 19.25-47.11-5.07-56.84zm48.47 105.2l-35.45-15.59-138.4 86.5 119.58 52.58a16.86 16.86 0 0 0 22.22-8.65l40.7-92.62a16.85 16.85 0 0 0-8.65-22.22z"]
  },
      Jt = {
    prefix: "fas",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"]
  },
      Kt = {
    prefix: "fas",
    iconName: "chair",
    icon: [448, 512, [], "f6c0", "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"]
  },
      Xt = {
    prefix: "fas",
    iconName: "chair-office",
    icon: [448, 512, [], "f6c1", "M64 224v-64c0-17.67-14.33-32-32-32S0 142.33 0 160v64c0 17.67 14.33 32 32 32s32-14.33 32-32zm352-96c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32s32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm-64-64c0-35.35-28.65-64-64-64H160c-35.35 0-64 28.65-64 64v192h256V64zm51.67 245.88A31.996 31.996 0 0 0 373.31 288H74.69c-13.77 0-26 8.81-30.36 21.88l-10.67 32C26.76 362.6 42.18 384 64.03 384H192v67.36c-28.27 6.01-50.99 19.69-61.85 37.21-6.41 10.34 2.41 23.43 15.02 23.43h157.66c12.61 0 21.44-13.09 15.02-23.43-10.86-17.52-33.59-31.2-61.85-37.21V384h127.97c21.84 0 37.27-21.4 30.36-42.12l-10.66-32z"]
  },
      _t = {
    prefix: "fas",
    iconName: "chalkboard",
    icon: [640, 512, [], "f51b", "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      $t = {
    prefix: "fas",
    iconName: "chalkboard-teacher",
    icon: [640, 512, [], "f51c", "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"]
  },
      cr = {
    prefix: "fas",
    iconName: "charging-station",
    icon: [576, 512, [], "f5e7", "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"]
  },
      er = {
    prefix: "fas",
    iconName: "chart-area",
    icon: [512, 512, [], "f1fe", "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"]
  },
      ar = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [512, 512, [], "f080", "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      nr = {
    prefix: "fas",
    iconName: "chart-line",
    icon: [512, 512, [], "f201", "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"]
  },
      tr = {
    prefix: "fas",
    iconName: "chart-line-down",
    icon: [512, 512, [], "f64d", "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-16-80V185.94c0-21.38-25.85-32.09-40.97-16.97l-32.4 32.4-96-96c-12.5-12.5-32.76-12.5-45.25 0L192 178.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63l68.69 68.69c12.5 12.5 32.76 12.5 45.25 0L288 173.25l73.38 73.38-32.4 32.4c-15.12 15.12-4.41 40.97 16.97 40.97H464c8.84 0 16-7.17 16-16z"]
  },
      rr = {
    prefix: "fas",
    iconName: "chart-network",
    icon: [640, 512, [], "f78a", "M576 192c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zM64 240c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm449.6-37.2l-19.2-25.6-48 36 19.2 25.6 48-36zM576 384c-14.4 0-27.6 5-38.3 13l-96-57.6c3.8-11.2 6.3-23 6.3-35.5 0-61.9-50.1-112-112-112-8.4 0-16.6 1.1-24.4 2.9l-40.8-87.4C281.4 96 288 80.8 288 64c0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64c1.1 0 2.1-.3 3.2-.3l41 87.8C241.5 235.9 224 267.8 224 304c0 61.9 50.1 112 112 112 32.1 0 60.8-13.7 81.2-35.3l95.8 57.5c-.5 3.2-1 6.5-1 9.8 0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64zm-240-32c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm-184-32h48v-32h-48v32z"]
  },
      ir = {
    prefix: "fas",
    iconName: "chart-pie",
    icon: [544, 512, [], "f200", "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"]
  },
      or = {
    prefix: "fas",
    iconName: "chart-pie-alt",
    icon: [512, 512, [], "f64e", "M461.29 288H224V50.71c0-9.55-8.39-17.39-17.84-16.06C87.08 51.47-3.96 155.43.13 280.07 4.2 404.1 107.91 507.8 231.93 511.87c124.64 4.09 228.6-86.95 245.42-206.03 1.33-9.45-6.52-17.84-16.06-17.84zM288.8.04C279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.69 16.2-16.8C503.72 103.74 408.26 8.28 288.8.04z"]
  },
      lr = {
    prefix: "fas",
    iconName: "chart-scatter",
    icon: [512, 512, [], "f7ee", "M496 384H64V80a16 16 0 0 0-16-16H16A16 16 0 0 0 0 80v336a32 32 0 0 0 32 32h464a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-336-64a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm256-160a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm-224 0a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm192 160a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm-96-64a32 32 0 1 0-32-32 32 32 0 0 0 32 32z"]
  },
      fr = {
    prefix: "fas",
    iconName: "check",
    icon: [512, 512, [], "f00c", "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"]
  },
      sr = {
    prefix: "fas",
    iconName: "check-circle",
    icon: [512, 512, [], "f058", "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"]
  },
      ur = {
    prefix: "fas",
    iconName: "check-double",
    icon: [512, 512, [], "f560", "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"]
  },
      hr = {
    prefix: "fas",
    iconName: "check-square",
    icon: [448, 512, [], "f14a", "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"]
  },
      mr = {
    prefix: "fas",
    iconName: "cheese",
    icon: [512, 512, [], "f7ef", "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"]
  },
      vr = {
    prefix: "fas",
    iconName: "cheese-swiss",
    icon: [512, 512, [], "f7f0", "M368 336a48 48 0 0 1-48-48H0v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288h-96a48 48 0 0 1-48 48zm-192 96a48 48 0 1 1 48-48 48 48 0 0 1-48 48zM299.83 32a32 32 0 0 0-21.13 7l-61.76 48.06a47.91 47.91 0 0 1-75.1 58.48L0 256h512c0-119.89-94-217.8-212.17-224z"]
  },
      dr = {
    prefix: "fas",
    iconName: "cheeseburger",
    icon: [512, 512, [], "f7f1", "M464 256h-48l-96 64-96-64H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zM58.6 224h394.7c34.6 0 54.6-43.9 34.8-75.9C448 83.2 359.5 32.1 256 32c-103.5.1-192 51.2-232.2 116.1-19.8 32 .3 75.9 34.8 75.9zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm352 272H32a16 16 0 0 0-16 16v16a64.06 64.06 0 0 0 64 64h352a64.06 64.06 0 0 0 64-64v-16a16 16 0 0 0-16-16z"]
  },
      Mr = {
    prefix: "fas",
    iconName: "chess",
    icon: [512, 512, [], "f439", "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"]
  },
      pr = {
    prefix: "fas",
    iconName: "chess-bishop",
    icon: [320, 512, [], "f43a", "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      zr = {
    prefix: "fas",
    iconName: "chess-bishop-alt",
    icon: [256, 512, [], "f43b", "M64 288h14.89A535.84 535.84 0 0 1 64 384h128a535.84 535.84 0 0 1-14.89-96H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-11.67c16-6.67 26.48-25.09 26.48-50.43 0-19.32-7.2-42.34-17.73-63.33l-48.59 48.59a4 4 0 0 1-5.66 0l-5.66-5.66a4 4 0 0 1 0-5.65L181 111.7c-10.22-16.81-22.2-31.22-33.86-39.33C155.31 69.59 160 61.85 160 52.73 160 41.28 151.92 32 140.47 32h-24.94C104.08 32 96 41.28 96 52.73c0 9.12 4.69 16.86 12.87 19.64-28.58 19.87-59.68 76.75-59.68 117.2 0 25.34 10.49 43.76 26.48 50.43H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm183.16 171.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"]
  },
      Cr = {
    prefix: "fas",
    iconName: "chess-board",
    icon: [512, 512, [], "f43c", "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"]
  },
      Lr = {
    prefix: "fas",
    iconName: "chess-clock",
    icon: [640, 512, [], "f43d", "M519.38 243a12 12 0 0 0-17 0l-50.89 50.89a12 12 0 0 0 0 17l5.65 5.66a12 12 0 0 0 17 0L525 265.59a12 12 0 0 0 0-17zm80.52-115h-56v-16a16 16 0 0 0-16-16h-128a16 16 0 0 0-16 16v16H200.15V79.94H240a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H112a16 16 0 0 0-16 16v15.94a16 16 0 0 0 16 16h40.18V128H39.9a40 40 0 0 0-40 40v272a40 40 0 0 0 40 40h560a40 40 0 0 0 40-40V168a40 40 0 0 0-40-40zM176.2 416.06a112 112 0 1 1 112-111.95 111.95 111.95 0 0 1-112 111.95zm288 0a112 112 0 1 1 112-111.95 111.95 111.95 0 0 1-112 111.95zm-284-191.92h-8a12 12 0 0 0-12 12v72a12 12 0 0 0 12 12h8a12 12 0 0 0 12-12v-72a12 12 0 0 0-12-12z"]
  },
      Ar = {
    prefix: "fas",
    iconName: "chess-clock-alt",
    icon: [640, 512, [], "f43e", "M600 128H487.75V80H528a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H400a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h39.75v48H255.91v-16a16 16 0 0 0-16-16h-128a16 16 0 0 0-16 16v16H40a40.17 40.17 0 0 0-40 40.11V440a40 40 0 0 0 40 40h560a40 40 0 0 0 40-40V168.11A40.17 40.17 0 0 0 600 128zM175.93 416.06a112 112 0 1 1 112-111.95 112 112 0 0 1-112 111.95zm287.89 0a112 112 0 1 1 112-111.95 112 112 0 0 1-112 111.95zM231.12 243a12 12 0 0 0-17 0l-50.89 50.89a12 12 0 0 0 0 17l5.66 5.66a12 12 0 0 0 17 0l50.89-50.9a12 12 0 0 0 0-17zm236.7-18.84h-8a12 12 0 0 0-12 12v72a12 12 0 0 0 12 12h8a12 12 0 0 0 12-12v-72a12 12 0 0 0-12-12.02z"]
  },
      Nr = {
    prefix: "fas",
    iconName: "chess-king",
    icon: [448, 512, [], "f43f", "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"]
  },
      gr = {
    prefix: "fas",
    iconName: "chess-king-alt",
    icon: [320, 512, [], "f440", "M106 208H96a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 96 384h128a535.78 535.78 0 0 1-15.94-128H224a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H176V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24h-24a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H87.09a16 16 0 0 0-15 21.62zm173.16 251.58L256 448v-16a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v16l-23.15 11.58A16 16 0 0 0 32 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"]
  },
      Hr = {
    prefix: "fas",
    iconName: "chess-knight",
    icon: [384, 512, [], "f441", "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      Vr = {
    prefix: "fas",
    iconName: "chess-knight-alt",
    icon: [320, 512, [], "f442", "M311.16 459.58L288 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zM45.55 235.52l28.83 12.86a22.59 22.59 0 0 0 17.67.34l9.09-3.65a22.79 22.79 0 0 0 13.33-14.62l6.53-21.87a17.09 17.09 0 0 1 8.92-11.15l14.2-5.43v37.21a28.58 28.58 0 0 1-16.9 26.09L80.68 279C40.87 299.22 32.42 352.42 64 384h192c7-7.85 16-18.31 16-32V203.16C272 126.62 209.38 64 132.84 64H40.52A8.54 8.54 0 0 0 32 72.56 12.14 12.14 0 0 0 33.27 78l10.1 20.28-6.37 6.35a17.21 17.21 0 0 0-5 12.11v97.9a22.86 22.86 0 0 0 13.55 20.88zM80.07 128a16 16 0 1 1-15.94 16 16 16 0 0 1 15.94-16z"]
  },
      xr = {
    prefix: "fas",
    iconName: "chess-pawn",
    icon: [320, 512, [], "f443", "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      wr = {
    prefix: "fas",
    iconName: "chess-pawn-alt",
    icon: [256, 512, [], "f444", "M64 288h14.89A535.84 535.84 0 0 1 64 384h128a535.84 535.84 0 0 1-14.89-96H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-16.44a80 80 0 1 0-95.12 0H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16zm183.16 171.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"]
  },
      yr = {
    prefix: "fas",
    iconName: "chess-queen",
    icon: [512, 512, [], "f445", "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"]
  },
      br = {
    prefix: "fas",
    iconName: "chess-queen-alt",
    icon: [256, 512, [], "f446", "M67.37 192H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h16v14a535.76 535.76 0 0 1-16 130h128a535.76 535.76 0 0 1-16-130v-14h16a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-3.37l44.5-95.73a6.73 6.73 0 0 0-2.29-8.62l-10.06-6.71c-3.13-2.08-7.12-1-9.38 2a20.05 20.05 0 0 1-19.89 7.67c-9.74-1.81-16.35-11-16.35-21a5.65 5.65 0 0 0-5.64-5.61h-16.33a5.45 5.45 0 0 0-5.41 4.17 20.22 20.22 0 0 1-39.56 0 5.45 5.45 0 0 0-5.41-4.17H86.48a5.65 5.65 0 0 0-5.64 5.64c0 10.82-8 20.53-18.81 21.26a20 20 0 0 1-17.49-8.06 6.81 6.81 0 0 0-9.3-1.91l-10.08 6.72a6.73 6.73 0 0 0-2.29 8.62zM128 48a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm119.16 411.6L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"]
  },
      Sr = {
    prefix: "fas",
    iconName: "chess-rook",
    icon: [384, 512, [], "f447", "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      Tr = {
    prefix: "fas",
    iconName: "chess-rook-alt",
    icon: [320, 512, [], "f448", "M311.16 459.58L288 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zM71.81 210.32L57.33 384h205.34l-14.48-173.7 30.62-31.11a32 32 0 0 0 9.19-22.45V72a8 8 0 0 0-8-8h-35.18a8 8 0 0 0-8 8v40h-32.94V72a8 8 0 0 0-8-8h-71.75a8 8 0 0 0-8 8v40H83.19V72a8 8 0 0 0-8-8H40a8 8 0 0 0-8 8v84.82a32 32 0 0 0 9.21 22.47zm64.6 21.27a23.59 23.59 0 0 1 47.18 0v47.18h-47.18z"]
  },
      Dr = {
    prefix: "fas",
    iconName: "chevron-circle-down",
    icon: [512, 512, [], "f13a", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"]
  },
      jr = {
    prefix: "fas",
    iconName: "chevron-circle-left",
    icon: [512, 512, [], "f137", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"]
  },
      Er = {
    prefix: "fas",
    iconName: "chevron-circle-right",
    icon: [512, 512, [], "f138", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"]
  },
      kr = {
    prefix: "fas",
    iconName: "chevron-circle-up",
    icon: [512, 512, [], "f139", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"]
  },
      Ir = {
    prefix: "fas",
    iconName: "chevron-double-down",
    icon: [448, 512, [], "f322", "M207 477.5L12.7 283.1c-9.4-9.4-9.4-24.6 0-33.9l22.7-22.7c9.4-9.4 24.5-9.4 33.9 0l154.7 154 154.7-154c9.4-9.3 24.5-9.3 33.9 0l22.7 22.7c9.4 9.4 9.4 24.6 0 33.9L241 477.5c-9.4 9.3-24.6 9.3-34 0zm34-192L435.3 91.1c9.4-9.4 9.4-24.6 0-33.9l-22.7-22.7c-9.4-9.4-24.5-9.4-33.9 0L224 188.5 69.3 34.5c-9.4-9.3-24.5-9.3-33.9 0L12.7 57.2c-9.4 9.4-9.4 24.6 0 33.9L207 285.5c9.4 9.3 24.6 9.3 34 0z"]
  },
      Or = {
    prefix: "fas",
    iconName: "chevron-double-left",
    icon: [512, 512, [], "f323", "M34.5 239L228.9 44.7c9.4-9.4 24.6-9.4 33.9 0l22.7 22.7c9.4 9.4 9.4 24.5 0 33.9L131.5 256l154 154.7c9.3 9.4 9.3 24.5 0 33.9l-22.7 22.7c-9.4 9.4-24.6 9.4-33.9 0L34.5 273c-9.3-9.4-9.3-24.6 0-34zm192 34l194.3 194.3c9.4 9.4 24.6 9.4 33.9 0l22.7-22.7c9.4-9.4 9.4-24.5 0-33.9L323.5 256l154-154.7c9.3-9.4 9.3-24.5 0-33.9l-22.7-22.7c-9.4-9.4-24.6-9.4-33.9 0L226.5 239c-9.3 9.4-9.3 24.6 0 34z"]
  },
      Qr = {
    prefix: "fas",
    iconName: "chevron-double-right",
    icon: [512, 512, [], "f324", "M477.5 273L283.1 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.7-22.7c-9.4-9.4-9.4-24.5 0-33.9l154-154.7-154-154.7c-9.3-9.4-9.3-24.5 0-33.9l22.7-22.7c9.4-9.4 24.6-9.4 33.9 0L477.5 239c9.3 9.4 9.3 24.6 0 34zm-192-34L91.1 44.7c-9.4-9.4-24.6-9.4-33.9 0L34.5 67.4c-9.4 9.4-9.4 24.5 0 33.9l154 154.7-154 154.7c-9.3 9.4-9.3 24.5 0 33.9l22.7 22.7c9.4 9.4 24.6 9.4 33.9 0L285.5 273c9.3-9.4 9.3-24.6 0-34z"]
  },
      Zr = {
    prefix: "fas",
    iconName: "chevron-double-up",
    icon: [448, 512, [], "f325", "M241 34.5l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9l-22.7 22.7c-9.4 9.4-24.5 9.4-33.9 0L224 131.5l-154.7 154c-9.4 9.3-24.5 9.3-33.9 0l-22.7-22.7c-9.4-9.4-9.4-24.6 0-33.9L207 34.5c9.4-9.3 24.6-9.3 34 0zm-34 192L12.7 420.9c-9.4 9.4-9.4 24.6 0 33.9l22.7 22.7c9.4 9.4 24.5 9.4 33.9 0l154.7-154 154.7 154c9.4 9.3 24.5 9.3 33.9 0l22.7-22.7c9.4-9.4 9.4-24.6 0-33.9L241 226.5c-9.4-9.3-24.6-9.3-34 0z"]
  },
      Ur = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [448, 512, [], "f078", "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"]
  },
      Br = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [320, 512, [], "f053", "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"]
  },
      Rr = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [320, 512, [], "f054", "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"]
  },
      Yr = {
    prefix: "fas",
    iconName: "chevron-square-down",
    icon: [448, 512, [], "f329", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM240.971 361.941l135.515-135.515c9.373-9.373 9.373-24.569 0-33.941l-16.971-16.971c-9.373-9.373-24.569-9.373-33.941 0L224 277.088 122.427 175.515c-9.373-9.373-24.569-9.373-33.941 0l-16.971 16.971c-9.373 9.373-9.373 24.569 0 33.941L207.03 361.942c9.372 9.372 24.568 9.372 33.941-.001z"]
  },
      Pr = {
    prefix: "fas",
    iconName: "chevron-square-left",
    icon: [448, 512, [], "f32a", "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM118.059 272.971l135.515 135.515c9.373 9.373 24.569 9.373 33.941 0l16.971-16.971c9.373-9.373 9.373-24.569 0-33.941L202.912 256l101.574-101.573c9.373-9.373 9.373-24.569 0-33.941l-16.971-16.971c-9.373-9.373-24.569-9.373-33.941 0L118.059 239.029c-9.373 9.373-9.373 24.569 0 33.942z"]
  },
      Fr = {
    prefix: "fas",
    iconName: "chevron-square-right",
    icon: [448, 512, [], "f32b", "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm281.941 207.029L194.427 103.515c-9.373-9.373-24.569-9.373-33.941 0l-16.971 16.971c-9.373 9.373-9.373 24.569 0 33.941L245.088 256 143.515 357.573c-9.373 9.373-9.373 24.569 0 33.941l16.971 16.971c9.373 9.373 24.569 9.373 33.941 0L329.942 272.97c9.372-9.372 9.372-24.568-.001-33.941z"]
  },
      Wr = {
    prefix: "fas",
    iconName: "chevron-square-up",
    icon: [448, 512, [], "f32c", "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm207.029-281.941L71.515 285.573c-9.373 9.373-9.373 24.569 0 33.941l16.971 16.971c9.373 9.373 24.569 9.373 33.941 0L224 234.912l101.573 101.574c9.373 9.373 24.569 9.373 33.941 0l16.971-16.971c9.373-9.373 9.373-24.569 0-33.941L240.971 150.059c-9.373-9.373-24.569-9.373-33.942 0z"]
  },
      Gr = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [448, 512, [], "f077", "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"]
  },
      qr = {
    prefix: "fas",
    iconName: "child",
    icon: [384, 512, [], "f1ae", "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"]
  },
      Jr = {
    prefix: "fas",
    iconName: "chimney",
    icon: [512, 512, [], "f78b", "M480 0H32C14.3 0 0 14.3 0 32v128c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32zM32 512h288V384H32v128zm160-160h288V224H192v128zM32 224v128h128V224H32zm320 288h128V384H352v128z"]
  },
      Kr = {
    prefix: "fas",
    iconName: "church",
    icon: [640, 512, [], "f51d", "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"]
  },
      Xr = {
    prefix: "fas",
    iconName: "circle",
    icon: [512, 512, [], "f111", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"]
  },
      _r = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [512, 512, [], "f1ce", "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"]
  },
      $r = {
    prefix: "fas",
    iconName: "city",
    icon: [640, 512, [], "f64f", "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"]
  },
      ci = {
    prefix: "fas",
    iconName: "clarinet",
    icon: [640, 512, [], "f8ad", "M630.12 129.22a15.94 15.94 0 0 0-17.43 3.47L569.38 176H480v-32h24a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H232a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H101.19a32 32 0 0 0-10.12 1.64l-80.13 26.71A16 16 0 0 0 0 219.53v72.94a16 16 0 0 0 10.94 15.18l80.13 26.71a32 32 0 0 0 10.12 1.64h468.19l43.31 43.31A16 16 0 0 0 624 384a15.73 15.73 0 0 0 6.12-1.22A16 16 0 0 0 640 368V144a16 16 0 0 0-9.88-14.78zM384 144h64v32h-64zm-96 0h64v32h-64zm-16 136a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm96 0a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm96 0a24 24 0 1 1 24-24 24 24 0 0 1-24 24z"]
  },
      ei = {
    prefix: "fas",
    iconName: "claw-marks",
    icon: [512, 512, [], "f6c2", "M6.99 224.51c-5-2.37-9.4 4.09-5.49 8l85.12 85.13c6 6 9.37 14.14 9.37 22.63V384h43.74c8.49 0 16.63 3.37 22.63 9.37l117.15 117.16c3.86 3.86 10.32-.56 7.99-5.49C206.4 333.11 63.36 251.26 6.99 224.51zM246.63 29.63c6 6 9.37 14.14 9.37 22.63V96h43.74c8.49 0 16.63 3.37 22.63 9.37l52.26 52.26c6 6 9.37 14.14 9.37 22.63V224h43.73c8.49 0 16.63 3.37 22.63 9.37l53.16 53.16c3.86 3.86 10.32-.56 7.99-5.49C430.4 109.11 287.36 27.26 230.99.51c-5-2.37-9.4 4.09-5.49 8l21.13 21.12zm-42.36 90.69c-7.8-6.05-12.27-15.15-12.27-25.03V64h-57.99c-6.01 0-12.04-1.84-17.12-5.05C74.85 32.39 38.37 13.23 12.42.91 3.54-3.3-4.28 8.18 2.67 15.13l179.96 179.96c6 6 9.37 14.14 9.37 22.63V256h38.29c8.49 0 16.62 3.37 22.63 9.37l89.71 89.71c6 6 9.37 14.14 9.37 22.63V416h38.29c8.49 0 16.62 3.37 22.63 9.37l84.01 84.01c6.86 6.86 18.34-.99 14.2-9.76-82.73-175.34-201.55-297.65-306.86-379.3z"]
  },
      ai = {
    prefix: "fas",
    iconName: "clinic-medical",
    icon: [576, 512, [], "f7f2", "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"]
  },
      ni = {
    prefix: "fas",
    iconName: "clipboard",
    icon: [384, 512, [], "f328", "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"]
  },
      ti = {
    prefix: "fas",
    iconName: "clipboard-check",
    icon: [384, 512, [], "f46c", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"]
  },
      ri = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"]
  },
      ii = {
    prefix: "fas",
    iconName: "clipboard-list-check",
    icon: [384, 512, [], "f737", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM65.6 209.4l12.7-12.6c2.1-2.1 5.5-2.1 7.6 0l20.6 20.8 47.6-47.2c2.1-2.1 5.5-2.1 7.6 0l12.6 12.7c2.1 2.1 2.1 5.5 0 7.6l-64.2 63.6c-2.1 2.1-5.5 2.1-7.6 0L65.6 217c-2.1-2.1-2.1-5.5 0-7.6zM96 392c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm224-16c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-128c0 4.4-4.3 8-9.6 8H154.1l32.3-32h124c5.3 0 9.6 3.6 9.6 8v16z"]
  },
      oi = {
    prefix: "fas",
    iconName: "clipboard-prescription",
    icon: [384, 512, [], "f5e8", "M176 240h-48v32h48c8.82 0 16-7.18 16-16s-7.18-16-16-16zM336 64h-80c0-35.29-28.71-64-64-64s-64 28.71-64 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM192 40c13.26 0 24 10.74 24 24 0 13.25-10.74 24-24 24s-24-10.75-24-24c0-13.26 10.74-24 24-24zm112 392l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.34 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0l11.3 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.24 6.24 6.24 16.37 0 22.62z"]
  },
      li = {
    prefix: "fas",
    iconName: "clipboard-user",
    icon: [384, 512, [], "f7f3", "M336 64h-80a64 64 0 0 0-128 0H48a48 48 0 0 0-48 48v352a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V112a48 48 0 0 0-48-48zM192 40a24 24 0 1 1-24 24 24 24 0 0 1 24-24zm0 152a64 64 0 1 1-64 64 64 64 0 0 1 64-64zm112 236.8c0 10.61-10 19.2-22.4 19.2H102.4C90 448 80 439.4 80 428.8v-19.2c0-31.81 30.09-57.6 67.2-57.6h5a103.25 103.25 0 0 0 79.7 0h5c37.11 0 67.2 25.79 67.2 57.6z"]
  },
      fi = {
    prefix: "fas",
    iconName: "clock",
    icon: [512, 512, [], "f017", "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"]
  },
      si = {
    prefix: "fas",
    iconName: "clone",
    icon: [512, 512, [], "f24d", "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"]
  },
      ui = {
    prefix: "fas",
    iconName: "closed-captioning",
    icon: [512, 512, [], "f20a", "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"]
  },
      hi = {
    prefix: "fas",
    iconName: "cloud",
    icon: [640, 512, [], "f0c2", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"]
  },
      mi = {
    prefix: "fas",
    iconName: "cloud-download",
    icon: [640, 512, [], "f0ed", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-139.9 93L305 412.3c-9.4 9.4-24.6 9.4-33.9 0l-92.7-92.7c-9.4-9.4-9.4-24.6 0-33.9l10.8-10.8c9.6-9.6 25.2-9.3 34.5.5l32.4 34.5V184c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v125.9l32.4-34.5c9.3-9.9 24.9-10.1 34.5-.5l10.8 10.8c9.2 9.3 9.2 24.5-.1 33.9z"]
  },
      vi = {
    prefix: "fas",
    iconName: "cloud-download-alt",
    icon: [640, 512, [], "f381", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"]
  },
      di = {
    prefix: "fas",
    iconName: "cloud-drizzle",
    icon: [512, 512, [], "f738", "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM48 360c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm96 80c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm96-80c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm96 80c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm96-80c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-8.8-7.2-16-16-16z"]
  },
      Mi = {
    prefix: "fas",
    iconName: "cloud-hail",
    icon: [512, 512, [], "f739", "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zm-32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-192 96c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm128 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-64-96c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm64-96c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      pi = {
    prefix: "fas",
    iconName: "cloud-hail-mixed",
    icon: [512, 512, [], "f73a", "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm95.3-.4c-7.9-3.9-17.5-.8-21.5 7.2l-16 32c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l16-32c3.8-8.1.7-17.7-7.2-21.6zm-192 0c-7.9-3.9-17.5-.8-21.5 7.2l-16 32c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l16-32c3.8-8.1.7-17.7-7.2-21.6zm384 0c-7.9-3.9-17.5-.8-21.5 7.2l-16 32c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l16-32c3.8-8.1.7-17.7-7.2-21.6zm-95.3.4c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      zi = {
    prefix: "fas",
    iconName: "cloud-meatball",
    icon: [512, 512, [], "f73b", "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"]
  },
      Ci = {
    prefix: "fas",
    iconName: "cloud-moon",
    icon: [576, 512, [], "f6c3", "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"]
  },
      Li = {
    prefix: "fas",
    iconName: "cloud-moon-rain",
    icon: [576, 512, [], "f73c", "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"]
  },
      Ai = {
    prefix: "fas",
    iconName: "cloud-music",
    icon: [640, 512, [], "f8ae", "M537.59 226.59a96 96 0 0 0-142.9-114.39A160 160 0 0 0 96 192c0 2.7.09 5.41.19 8.09A144 144 0 0 0 144 480h368a128 128 0 0 0 25.59-253.41zM384 352c0 17.67-21.5 32-48 32s-48-14.33-48-32 21.5-32 48-32a69.89 69.89 0 0 1 16 2v-76.36l-96 37.52V384c0 17.67-21.5 32-48 32s-48-14.33-48-32 21.5-32 48-32a69.89 69.89 0 0 1 16 2V239.25A16 16 0 0 1 235.19 224l128-47.25A16 16 0 0 1 384 192z"]
  },
      Ni = {
    prefix: "fas",
    iconName: "cloud-rain",
    icon: [512, 512, [], "f73d", "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"]
  },
      gi = {
    prefix: "fas",
    iconName: "cloud-rainbow",
    icon: [576, 512, [], "f73e", "M430.8 304.9c9.9 5.6 19 12.4 26.9 20.3C487.1 292.8 529 272 576 272v-64c-61 0-116.3 24.6-156.8 64.3 5.7 9.9 9.8 20.9 11.6 32.6zm-31.6 20.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.9-56.5-66-101.9-66-61.9 0-112 50.1-112 112 0 3 .7 5.8.9 8.7C39.2 324.4 0 365.4 0 416c0 53 43 96 96 96h272c53 0 96-43 96-96 0-42-27.2-77.4-64.8-90.4zm-160.6-152c21 5.9 40.4 16.5 56.6 31C359.6 119.4 461.3 64 576 64V0C437.1 0 314.2 68.7 238.6 173.6zm87.2 51.5c7.4-.8 36.7-5.4 68.4 18.9 46.4-46.8 110.7-76 181.8-76v-64c-101.3 0-191.6 47.4-250.2 121.1z"]
  },
      Hi = {
    prefix: "fas",
    iconName: "cloud-showers",
    icon: [512, 512, [], "f73f", "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM48 368c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96 32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96-32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96 32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96-32c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16z"]
  },
      Vi = {
    prefix: "fas",
    iconName: "cloud-showers-heavy",
    icon: [512, 512, [], "f740", "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"]
  },
      xi = {
    prefix: "fas",
    iconName: "cloud-sleet",
    icon: [512, 512, [], "f741", "M512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96zM87.2 353.7c-7.9-3.9-17.5-.7-21.5 7.2l-64 128c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l64-128c3.8-8.1.7-17.7-7.2-21.6zm256 0c-7.9-3.9-17.5-.7-21.5 7.2l-64 128c-3.9 7.9-.8 17.5 7.2 21.5 2.3 1.1 4.8 1.7 7.2 1.7 5.8 0 11.5-3.2 14.3-8.8l64-128c3.8-8.1.7-17.7-7.2-21.6zm151.7 35.4l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V360c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zm-256 0l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V360c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9z"]
  },
      wi = {
    prefix: "fas",
    iconName: "cloud-snow",
    icon: [512, 512, [], "f742", "M96 320h320c53 0 96-43 96-96s-43-96-96-96c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96zm30.9 69.1l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V360c0-4.4-3.6-8-8-8H56c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16L4 432c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zm192 32l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V392c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9zm192-32l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V360c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V472c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16 27.9-16c3.8-2.2 5.1-7.1 2.9-10.9z"]
  },
      yi = {
    prefix: "fas",
    iconName: "cloud-sun",
    icon: [640, 512, [], "f6c4", "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"]
  },
      bi = {
    prefix: "fas",
    iconName: "cloud-sun-rain",
    icon: [576, 512, [], "f743", "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"]
  },
      Si = {
    prefix: "fas",
    iconName: "cloud-upload",
    icon: [640, 512, [], "f0ee", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-139.9 63.7l-10.8 10.8c-9.6 9.6-25.2 9.3-34.5-.5L320 266.1V392c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V266.1l-32.4 34.5c-9.3 9.9-24.9 10.1-34.5.5l-10.8-10.8c-9.4-9.4-9.4-24.6 0-33.9l92.7-92.7c9.4-9.4 24.6-9.4 33.9 0l92.7 92.7c9.4 9.4 9.4 24.6.1 33.9z"]
  },
      Ti = {
    prefix: "fas",
    iconName: "cloud-upload-alt",
    icon: [640, 512, [], "f382", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"]
  },
      Di = {
    prefix: "fas",
    iconName: "clouds",
    icon: [640, 512, [], "f744", "M544 320c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8-18.6-35.9-55.8-60.8-99-60.8-61.9 0-112 50.1-112 112 0 7.3.8 14.3 2.1 21.2-38.3 12.6-66.1 48.3-66.1 90.8 0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM304 160c40.7 0 78.6 17.2 105.4 46.5 9.8-5.6 20.5-9.4 31.6-11.8 4.3-10.8 7-22.3 7-34.7 0-53-43-96-96-96-14.1 0-27.4 3.2-39.5 8.7C296.6 30.3 256 0 208 0 151.6 0 105.3 41.9 97.6 96.2c-.5 0-1-.2-1.6-.2-53 0-96 43-96 96s43 96 96 96h65.6c8.1-71.8 68.5-128 142.4-128z"]
  },
      ji = {
    prefix: "fas",
    iconName: "clouds-moon",
    icon: [640, 512, [], "f745", "M448 320h-1.6c-7.4-36.5-39.7-64-78.4-64-24.6 0-46.3 11.3-61 28.8-18.6-35.9-55.8-60.8-99-60.8-58.3 0-105.6 44.7-110.9 101.6C59.3 338.5 32 373.9 32 416c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zm183-71.3c-78.2 14.8-150-44.7-150-123.1 0-45.1 24.3-86.6 63.9-109 6.1-3.4 4.6-12.6-2.4-13.9C532.9.9 523 0 513.1 0 424.2 0 352 71.6 352 160c0 .7.2 1.3.2 2 16.3 16.8 27 38.8 30.3 63.1 38.5 5.1 71.7 29.9 87.6 64.8 23.1 4 44 14.4 61.1 29.1 42.5-4.7 80.7-26 107.1-58.2 4.4-5.5-.4-13.4-7.3-12.1zM68.3 303.2C83.2 238.6 140.2 192 208 192c40.7 0 78.6 17.2 105.4 46.5 11.5-6.5 24.1-10.8 37.1-12.9-6.8-37.3-39.3-65.6-78.5-65.6h-17.6c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64H80c-44.2 0-80 35.8-80 80 0 33.9 21.2 62.8 51 74.4 5.5-4.1 11.2-8 17.3-11.2z"]
  },
      Ei = {
    prefix: "fas",
    iconName: "clouds-sun",
    icon: [640, 512, [], "f746", "M512 320h-1.6c-7.4-36.5-39.7-64-78.4-64-24.6 0-46.3 11.3-61 28.8-18.6-35.9-55.8-60.8-99-60.8-58.3 0-105.6 44.7-110.9 101.6C123.3 338.5 96 373.9 96 416c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zm48-160h-17.6c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64H368c-27.6 0-51.8 13.9-66.2 35.1 29.1 6.2 55.5 21.3 75.6 43.3 16.5-9.4 35.3-14.5 54.6-14.5 44.6 0 84.3 26.6 102.1 65.9 20.5 3.6 39.1 12.3 55 24.4 29.8-11.7 50.9-40.5 50.9-74.3 0-44.1-35.8-79.9-80-79.9zM132.3 303.2c2.4-10.3 6.1-19.9 10.5-29.1-6.6-4-13-8.5-18.7-14.2-37.4-37.4-37.4-98.3 0-135.8 37.4-37.4 98.3-37.4 135.8 0 12.2 12.2 19.9 26.9 24.1 42.4 6.1-7 12.9-13.3 20.6-18.6l26.3-78.4c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1C59.3 49.7 49.7 59.4 53 69.6l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5L53 314.5c-3.4 10.2 6.3 19.8 16.5 16.5l42.7-14.2c6.3-5.1 12.9-9.8 20.1-13.6zM128 192c0 23.4 12.8 43.8 31.7 54.9 23.1-29.5 57.2-49.2 96.2-53.5 0-.5.1-.9.1-1.4 0-35.3-28.7-64-64-64s-64 28.7-64 64z"]
  },
      ki = {
    prefix: "fas",
    iconName: "club",
    icon: [512, 512, [], "f327", "M371.5 169.1C403.1 88.4 343.7 0 256 0c-87.8 0-147 88.5-115.5 169.1C65.7 159.2 0 217.3 0 292c0 68.5 55.5 124 124 124 36.5 0 69.3-15.8 92-40.9-.1 36.7-.8 52.4-53 75.6-13.8 6.1-21.4 21.1-18.3 35.9 3.1 14.8 16.2 25.4 31.3 25.4h160c15.1 0 28.2-10.6 31.3-25.4 3.1-14.8-4.5-29.7-18.3-35.9-51.6-23-52.8-38.1-53-75.6 22.7 25.1 55.5 40.9 92 40.9 68.5 0 124-55.5 124-124 0-74.8-65.8-132.8-140.5-122.9z"]
  },
      Ii = {
    prefix: "fas",
    iconName: "cocktail",
    icon: [576, 512, [], "f561", "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"]
  },
      Oi = {
    prefix: "fas",
    iconName: "code",
    icon: [640, 512, [], "f121", "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"]
  },
      Qi = {
    prefix: "fas",
    iconName: "code-branch",
    icon: [384, 512, [], "f126", "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"]
  },
      Zi = {
    prefix: "fas",
    iconName: "code-commit",
    icon: [640, 512, [], "f386", "M128 256c0 10.8.9 21.5 2.6 32H12c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h118.6c-1.7 10.5-2.6 21.2-2.6 32zm500-32H509.4c1.8 10.5 2.6 21.2 2.6 32s-.9 21.5-2.6 32H628c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12zm-308-10c-23.2 0-42 18.8-42 42s18.8 42 42 42 42-18.8 42-42-18.8-42-42-42m0-118c88.4 0 160 71.6 160 160s-71.6 160-160 160-160-71.6-160-160S231.6 96 320 96z"]
  },
      Ui = {
    prefix: "fas",
    iconName: "code-merge",
    icon: [384, 512, [], "f387", "M304 192c-38 0-69.8 26.5-77.9 62-23.9-3.5-58-12.9-83.9-37.6-16.6-15.9-27.9-36.5-33.7-61.6C138.6 143.3 160 114.1 160 80c0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3V246.1c1.6 1.7 3.3 3.4 5 5 39.3 37.5 90.4 48.6 121.2 51.8 12.1 28.9 40.6 49.2 73.8 49.2 44.2 0 80-35.8 80-80S348.2 192 304 192zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-160c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      Bi = {
    prefix: "fas",
    iconName: "coffee",
    icon: [640, 512, [], "f0f4", "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"]
  },
      Ri = {
    prefix: "fas",
    iconName: "coffee-pot",
    icon: [512, 512, [], "e002", "M431.45,177.65,480,32H88A88,88,0,0,0,0,120v88a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V136a40,40,0,0,1,40-40h13.33l27.39,82.16C95.41,217.9,64,277.69,64,344.62c0,51.47,18.62,84.77,49.64,117.71A57.18,57.18,0,0,0,155.17,480H420.84a57.08,57.08,0,0,0,41.45-17.6c31-32.95,49.69-66.24,49.71-117.72C512,278.37,481.37,217.83,431.45,177.65ZM445.91,320H130.61c6.71-39.06,28.92-72.85,60.5-96h195.8C417.89,247.2,439.49,281.22,445.91,320Z"]
  },
      Yi = {
    prefix: "fas",
    iconName: "coffee-togo",
    icon: [448, 512, [], "f6c5", "M432 64h-16l-23.16-46.31A32 32 0 0 0 364.22 0H83.78a32 32 0 0 0-28.62 17.69L32 64H16C7.16 64 0 71.16 0 80v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16zM106.78 512h234.44c16.64 0 30.51-12.76 31.89-29.34L400 160H48l26.89 322.66C76.27 499.24 90.14 512 106.78 512zm221-256l-13.34 160H133.56l-13.34-160h207.56z"]
  },
      Pi = {
    prefix: "fas",
    iconName: "coffin",
    icon: [384, 512, [], "f6c6", "M374.44,115.19,266.7,9.37a32.89,32.89,0,0,0-23-9.37H140.32a32.89,32.89,0,0,0-23,9.37L9.54,115.19A31.61,31.61,0,0,0,1,145.58L88.08,487.76A32.47,32.47,0,0,0,119.69,512H264.31a32.48,32.48,0,0,0,31.61-24.24L383,145.58a31.65,31.65,0,0,0-8.59-30.39Z"]
  },
      Fi = {
    prefix: "fas",
    iconName: "coffin-cross",
    icon: [384, 512, [], "e051", "M374.45 115.19L266.71 9.37c-6.11-6-14.4-9.37-23.04-9.37H140.33c-8.64 0-16.93 3.37-23.04 9.37L9.55 115.19C1.46 123.14-1.8 134.67.98 145.58l87.11 342.18C91.71 502.01 104.75 512 119.7 512h144.62c14.95 0 27.98-9.99 31.61-24.24l87.11-342.18c2.76-10.91-.49-22.44-8.59-30.39zM288 192c0 8.84-7.16 16-16 16h-56v128c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16V208h-56c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h56v-48c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v48h56c8.84 0 16 7.16 16 16v16z"]
  },
      Wi = {
    prefix: "fas",
    iconName: "cog",
    icon: [512, 512, [], "f013", "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      Gi = {
    prefix: "fas",
    iconName: "cogs",
    icon: [640, 512, [], "f085", "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"]
  },
      qi = {
    prefix: "fas",
    iconName: "coin",
    icon: [512, 512, [], "f85c", "M0 320c0 27.77 18 53.37 48 74.33V330c-18.85-12-35.4-25.36-48-40.38zm256 32c141.33 0 256-64.44 256-144S397.33 64 256 64 0 128.44 0 208s114.67 144 256 144zM80 412.51c27.09 12.89 59.66 22.81 96 28.8V377c-35.39-6-67.81-15.88-96-29zm384-18.18c30.05-21 48-46.56 48-74.33v-30.37c-12.6 15-29.15 28.37-48 40.38zm-128 47c36.34-6 68.91-15.91 96-28.8V348c-28.19 13.12-60.61 23-96 29zM208 381.2v64.09c15.62 1.51 31.49 2.71 48 2.71s32.38-1.2 48-2.71V381.2a477.2 477.2 0 0 1-48 2.8 477.2 477.2 0 0 1-48-2.8z"]
  },
      Ji = {
    prefix: "fas",
    iconName: "coins",
    icon: [512, 512, [], "f51e", "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"]
  },
      Ki = {
    prefix: "fas",
    iconName: "columns",
    icon: [512, 512, [], "f0db", "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"]
  },
      Xi = {
    prefix: "fas",
    iconName: "comet",
    icon: [512, 512, [], "e003", "M491.12794.70921c-38.6972,11.5936-111.77976,34.29644-187.67439,61.2961-2.09343-6.99991-3.99939-13.49983-5.5929-18.59351a16.058,16.058,0,0,0-22.90274-9.49988c-42.39976,22.09347-152.77349,82.59271-214.37343,142.4982-1.09359,1-2.49962,2-3.49947,3A194.83045,194.83045,0,1,0,332.6522,454.90662c.99985-1,1.9997-2.40622,2.99954-3.49995,59.78772-61.6086,120.3722-172.10721,142.47819-214.40356a16.06158,16.06158,0,0,0-9.49854-22.906c-5.20233-1.59373-11.6076-3.5-18.60653-5.59368,26.99587-75.999,49.69552-148.99813,61.30311-187.70077A16.18325,16.18325,0,0,0,491.12794.70921ZM315.33649,300.35583l-50.586,49.33337,11.92591,69.72764a15.30186,15.30186,0,0,1-22.19583,16.13651L191.9589,402.626l-62.52168,32.92732c-11.07253,5.93743-24.33026-3.5312-22.19582-16.13651l11.99816-69.72764L68.64379,300.35583a15.31471,15.31471,0,0,1,8.46745-26.13639l69.85454-10.19714,31.2667-63.46795a15.29265,15.29265,0,0,1,27.45283,0L236.952,264.0223l69.85454,10.19714A15.34746,15.34746,0,0,1,315.33649,300.35583Z"]
  },
      _i = {
    prefix: "fas",
    iconName: "comment",
    icon: [512, 512, [], "f075", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"]
  },
      $i = {
    prefix: "fas",
    iconName: "comment-alt",
    icon: [512, 512, [], "f27a", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"]
  },
      co = {
    prefix: "fas",
    iconName: "comment-alt-check",
    icon: [512, 512, [], "f4a2", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm-77.9 163.8l-131 130c-4.3 4.3-11.3 4.3-15.6-.1l-75.7-76.3c-4.3-4.3-4.2-11.3.1-15.6l26-25.8c4.3-4.3 11.3-4.2 15.6.1l42.1 42.5 97.2-96.4c4.3-4.3 11.3-4.2 15.6.1l25.8 26c4.2 4.3 4.2 11.3-.1 15.5z"]
  },
      eo = {
    prefix: "fas",
    iconName: "comment-alt-dollar",
    icon: [512, 512, [], "f650", "M448 0H64C28.65 0 0 28.65 0 64v288c0 35.35 28.65 64 64 64h96v83.98c0 9.85 11.21 15.5 19.13 9.65L304 416h144c35.35 0 64-28.65 64-64V64c0-35.35-28.65-64-64-64zM280 302.44V320c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V96c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"]
  },
      ao = {
    prefix: "fas",
    iconName: "comment-alt-dots",
    icon: [512, 512, [], "f4a3", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM128 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      no = {
    prefix: "fas",
    iconName: "comment-alt-edit",
    icon: [512, 512, [], "f4a4", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM215.4 310.6l-48.2 5.4c-6.5.7-11.9-4.8-11.2-11.2l5.4-48.2 96.3-96.3 54 54-96.3 96.3zm150.7-150.7l-31.8 31.8-54-54 31.8-31.8c7.9-7.9 20.7-7.9 28.6 0l25.4 25.4c7.9 7.9 7.9 20.7 0 28.6z"]
  },
      to = {
    prefix: "fas",
    iconName: "comment-alt-exclamation",
    icon: [512, 512, [], "f4a5", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM256 336c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm25.4-110.4c-.8 8.2-7.7 14.4-15.9 14.4h-19c-8.2 0-15.1-6.2-15.9-14.4l-12.8-128c-.9-9.4 6.5-17.6 15.9-17.6h44.6c9.5 0 16.9 8.2 15.9 17.6l-12.8 128z"]
  },
      ro = {
    prefix: "fas",
    iconName: "comment-alt-lines",
    icon: [512, 512, [], "f4a6", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM288 264c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm96-96c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"]
  },
      io = {
    prefix: "fas",
    iconName: "comment-alt-medical",
    icon: [512, 512, [], "f7f4", "M448 0H64A64 64 0 0 0 0 64v288a64 64 0 0 0 64 64h96v84a12 12 0 0 0 19.13 9.65L304 416h144a64 64 0 0 0 64-64V64a64 64 0 0 0-64-64zm-96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"]
  },
      oo = {
    prefix: "fas",
    iconName: "comment-alt-minus",
    icon: [512, 512, [], "f4a7", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm-80 216c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16v16z"]
  },
      lo = {
    prefix: "fas",
    iconName: "comment-alt-music",
    icon: [512, 512, [], "f8af", "M448-1H64A64.05 64.05 0 0 0 0 63v288a64.05 64.05 0 0 0 64 64h96v84a12 12 0 0 0 19.09 9.7L304 415h144a64.05 64.05 0 0 0 64-64V63a64.05 64.05 0 0 0-64-64zm-96 256c0 17.67-21.5 32-48 32s-48-14.33-48-32 21.5-32 48-32a69.89 69.89 0 0 1 16 2v-76.36l-96 37.52V287c0 17.67-21.5 32-48 32s-48-14.33-48-32 21.5-32 48-32a69.89 69.89 0 0 1 16 2V142.25A16 16 0 0 1 203.19 127l128-47.25A16 16 0 0 1 352 95z"]
  },
      fo = {
    prefix: "fas",
    iconName: "comment-alt-plus",
    icon: [512, 512, [], "f4a8", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm-80 216c0 8.8-7.2 16-16 16h-72v72c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-72h-72c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h72v-72c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v72h72c8.8 0 16 7.2 16 16v16z"]
  },
      so = {
    prefix: "fas",
    iconName: "comment-alt-slash",
    icon: [640, 512, [], "f4a9", "M64 352c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L368 416h2L64 179.5V352zm569.8 106.1l-77.6-60c12.1-11.6 19.8-28 19.8-46.1V64c0-35.3-28.7-64-64-64H128c-21.5 0-40.4 10.7-52 27L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"]
  },
      uo = {
    prefix: "fas",
    iconName: "comment-alt-smile",
    icon: [512, 512, [], "f4aa", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM320 133.2c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm-128 0c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm164.2 140.9C331.3 303.3 294.8 320 256 320c-38.8 0-75.3-16.7-100.2-45.9-5.8-6.7-5-16.8 1.8-22.5 6.7-5.7 16.8-5 22.5 1.8 18.8 22 46.5 34.6 75.8 34.6 29.4 0 57-12.6 75.8-34.7 5.8-6.7 15.9-7.5 22.6-1.8 6.8 5.8 7.6 15.9 1.9 22.6z"]
  },
      ho = {
    prefix: "fas",
    iconName: "comment-alt-times",
    icon: [512, 512, [], "f4ab", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM340.9 258.9c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-6.2 6.2-16.4 6.2-22.6 0l-51-50.9-50.9 50.9c-6.2 6.2-16.4 6.2-22.6 0l-11.3-11.3c-6.2-6.2-6.2-16.4 0-22.6l50.9-50.9-50.9-50.9c-6.2-6.2-6.2-16.4 0-22.6l11.3-11.3c6.2-6.2 16.4-6.2 22.6 0l50.9 50.9 50.9-50.9c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6L289.9 208l51 50.9z"]
  },
      mo = {
    prefix: "fas",
    iconName: "comment-check",
    icon: [512, 512, [], "f4ac", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zm114.1 163.8l-131 130c-4.3 4.3-11.3 4.3-15.6-.1l-75.7-76.3c-4.3-4.3-4.2-11.3.1-15.6l26-25.8c4.3-4.3 11.3-4.2 15.6.1l42.1 42.5 97.2-96.4c4.3-4.3 11.3-4.2 15.6.1l25.8 26c4.2 4.3 4.2 11.3-.1 15.5z"]
  },
      vo = {
    prefix: "fas",
    iconName: "comment-dollar",
    icon: [512, 512, [], "f651", "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"]
  },
      Mo = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [512, 512, [], "f4ad", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      po = {
    prefix: "fas",
    iconName: "comment-edit",
    icon: [512, 512, [], "f4ae", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zm-40.6 310.6l-48.2 5.4c-6.5.7-11.9-4.8-11.2-11.2l5.4-48.2 96.3-96.3 54 54-96.3 96.3zm150.7-150.7l-31.8 31.8-54-54 31.8-31.8c7.9-7.9 20.7-7.9 28.6 0l25.4 25.4c7.9 7.9 7.9 20.7 0 28.6z"]
  },
      zo = {
    prefix: "fas",
    iconName: "comment-exclamation",
    icon: [512, 512, [], "f4af", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zm0 336c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm25.4-110.4c-.8 8.2-7.7 14.4-15.9 14.4h-19c-8.2 0-15.1-6.2-15.9-14.4l-12.8-128c-.9-9.4 6.5-17.6 15.9-17.6h44.6c9.5 0 16.9 8.2 15.9 17.6l-12.8 128z"]
  },
      Co = {
    prefix: "fas",
    iconName: "comment-lines",
    icon: [512, 512, [], "f4b0", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zm32 264c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm96-96c0 4.4-3.6 8-8 8H136c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"]
  },
      Lo = {
    prefix: "fas",
    iconName: "comment-medical",
    icon: [512, 512, [], "f7f5", "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"]
  },
      Ao = {
    prefix: "fas",
    iconName: "comment-minus",
    icon: [512, 512, [], "f4b1", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zm112 216c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16v16z"]
  },
      No = {
    prefix: "fas",
    iconName: "comment-music",
    icon: [512, 512, [], "f8b0", "M256 32C114.59 32 0 125.09 0 240c0 49.59 21.41 95 57 130.7C44.5 421.09 2.69 466 2.19 466.5a8 8 0 0 0-1.5 8.7A7.87 7.87 0 0 0 8 480c66.31 0 116-31.8 140.59-51.41A304.63 304.63 0 0 0 256 448c141.41 0 256-93.09 256-208S397.41 32 256 32zm96 256c0 17.67-21.5 32-48 32s-48-14.33-48-32 21.5-32 48-32a69.89 69.89 0 0 1 16 2v-76.36l-96 37.52V320c0 17.67-21.5 32-48 32s-48-14.33-48-32 21.5-32 48-32a69.89 69.89 0 0 1 16 2V175.25A16 16 0 0 1 203.19 160l128-47.25A16 16 0 0 1 352 128z"]
  },
      go = {
    prefix: "fas",
    iconName: "comment-plus",
    icon: [512, 512, [], "f4b2", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zm112 216c0 8.8-7.2 16-16 16h-72v72c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-72h-72c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h72v-72c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v72h72c8.8 0 16 7.2 16 16v16z"]
  },
      Ho = {
    prefix: "fas",
    iconName: "comment-slash",
    icon: [640, 512, [], "f4b3", "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"]
  },
      Vo = {
    prefix: "fas",
    iconName: "comment-smile",
    icon: [512, 512, [], "f4b4", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zm64 133.2c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm-128 0c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm164.2 140.9C331.3 335.3 294.8 352 256 352c-38.8 0-75.3-16.7-100.2-45.9-5.8-6.7-5-16.8 1.8-22.5 6.7-5.7 16.8-5 22.5 1.8 18.8 22 46.5 34.6 75.8 34.6 29.4 0 57-12.6 75.8-34.7 5.8-6.7 15.9-7.5 22.6-1.8 6.8 5.8 7.6 15.9 1.9 22.6z"]
  },
      xo = {
    prefix: "fas",
    iconName: "comment-times",
    icon: [512, 512, [], "f4b5", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zm84.9 258.9c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-6.2 6.2-16.4 6.2-22.6 0l-51-50.9-50.9 50.9c-6.2 6.2-16.4 6.2-22.6 0l-11.3-11.3c-6.2-6.2-6.2-16.4 0-22.6l50.9-50.9-50.9-50.9c-6.2-6.2-6.2-16.4 0-22.6l11.3-11.3c6.2-6.2 16.4-6.2 22.6 0l50.9 50.9 50.9-50.9c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6L289.9 240l51 50.9z"]
  },
      wo = {
    prefix: "fas",
    iconName: "comments",
    icon: [576, 512, [], "f086", "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"]
  },
      yo = {
    prefix: "fas",
    iconName: "comments-alt",
    icon: [576, 512, [], "f4b6", "M416 224V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v160c0 35.3 28.7 64 64 64v54.2c0 8 9.1 12.6 15.5 7.8l82.8-62.1H352c35.3.1 64-28.6 64-63.9zm96-64h-64v64c0 52.9-43.1 96-96 96H192v64c0 35.3 28.7 64 64 64h125.7l82.8 62.1c6.4 4.8 15.5.2 15.5-7.8V448h32c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64z"]
  },
      bo = {
    prefix: "fas",
    iconName: "comments-alt-dollar",
    icon: [576, 512, [], "f652", "M416 224V64c0-35.35-28.65-64-64-64H64C28.65 0 0 28.65 0 64v160c0 35.35 28.65 64 64 64v54.23c0 8 9.11 12.6 15.54 7.84L162.33 288H352c35.35 0 64-28.65 64-64zm-192-.12V240c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V48c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM512 160h-64v64c0 52.93-43.06 96-96 96H192v64c0 35.35 28.65 64 64 64h125.67l82.79 62.07c6.44 4.76 15.54.16 15.54-7.84V448h32c35.35 0 64-28.65 64-64V224c0-35.35-28.65-64-64-64z"]
  },
      So = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [576, 512, [], "f653", "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"]
  },
      To = {
    prefix: "fas",
    iconName: "compact-disc",
    icon: [496, 512, [], "f51f", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      Do = {
    prefix: "fas",
    iconName: "compass",
    icon: [496, 512, [], "f14e", "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"]
  },
      jo = {
    prefix: "fas",
    iconName: "compass-slash",
    icon: [640, 512, [], "f5e9", "M633.82 458.1l-99.85-77.17C555.47 344.21 568 301.62 568 256 568 119.03 456.97 8 320 8c-68.31 0-130.03 27.72-174.82 72.44L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM446.14 156.05l-53.03 116.01-105.65-81.66 132.48-60.55c16.66-7.6 33.81 9.55 26.2 26.2zM220.05 382.14c-16.65 7.61-33.81-9.55-26.2-26.2l25.7-56.24L80.57 192.29C75.16 212.65 72 233.93 72 256c0 136.97 111.03 248 248 248 44.43 0 86.03-11.83 122.1-32.29L286.77 351.65l-66.72 30.49z"]
  },
      Eo = {
    prefix: "fas",
    iconName: "compress",
    icon: [448, 512, [], "f066", "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"]
  },
      ko = {
    prefix: "fas",
    iconName: "compress-alt",
    icon: [448, 512, [], "f422", "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"]
  },
      Io = {
    prefix: "fas",
    iconName: "compress-arrows-alt",
    icon: [512, 512, [], "f78c", "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"]
  },
      Oo = {
    prefix: "fas",
    iconName: "compress-wide",
    icon: [512, 512, [], "f326", "M500 224H376c-13.3 0-24-10.7-24-24V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-340-24V76c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 236V312c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm256 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H376c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"]
  },
      Qo = {
    prefix: "fas",
    iconName: "computer-classic",
    icon: [448, 512, [], "f8b1", "M32 496a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-48H32zM416 0H32A32 32 0 0 0 0 32v368a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V32a32 32 0 0 0-32-32zM80 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm304-12a8 8 0 0 1-8 8H232a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h144a8 8 0 0 1 8 8zm0-120a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32z"]
  },
      Zo = {
    prefix: "fas",
    iconName: "computer-speaker",
    icon: [640, 512, [], "f8b2", "M288 416H128a32 32 0 0 0 0 64h176.41A79.24 79.24 0 0 1 288 432zM0 80v256a48 48 0 0 0 48 48h240v-64H64V96h224V80a79.24 79.24 0 0 1 16.41-48H48A48 48 0 0 0 0 80zm592-48H368a48 48 0 0 0-48 48v352a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zM480 96a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm0 320a96 96 0 1 1 96-96 96 96 0 0 1-96 96zm0-160a64 64 0 1 0 64 64 64 64 0 0 0-64-64z"]
  },
      Uo = {
    prefix: "fas",
    iconName: "concierge-bell",
    icon: [512, 512, [], "f562", "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      Bo = {
    prefix: "fas",
    iconName: "construction",
    icon: [640, 512, [], "f85d", "M634.66 460.17L349.5 15.92c-13.62-21.23-45.38-21.23-59 0L5.34 460.17C-9.14 482.73 7.52 512 34.85 512h570.3c27.33 0 43.99-29.27 29.51-51.83zM308 160a28 28 0 1 1-28 28 28 28 0 0 1 28-28zm-4 272a16 16 0 0 1-32 0v-32.77l-46.31-29.92-18.25 66.89A16 16 0 0 1 192 448a15.64 15.64 0 0 1-4.22-.56 16 16 0 0 1-11.24-19.64l29.75-109.11 83.06 53.67A31.91 31.91 0 0 1 304 399.23zm48 16l12-29.94A16 16 0 0 1 378.83 408h35.64l-94.8-58.34s-.08 0-.11-.07l-103.95-64a16 16 0 0 1-4.41-23.22l11.61-15.49a47.88 47.88 0 0 1 48.83-18l24.58 7.28c17.45 3.82 31.84 18.53 35.56 37.14l10.55 52.7L430 380l21.16-42.44a16 16 0 0 1 27.78-1.5L550.8 448z"]
  },
      Ro = {
    prefix: "fas",
    iconName: "container-storage",
    icon: [640, 512, [], "f4b7", "M640 80V48c0-8.8-7.2-16-16-16H16C7.2 32 0 39.2 0 48v32c0 8.8 7.2 16 16 16v320c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16V96c8.8 0 16-7.2 16-16zM448 416h-32V96h32v320zM192 96h32v320h-32V96zm144 320h-32V96h32v320zM80 96h32v320H80V96zm480 320h-32V96h32v320z"]
  },
      Yo = {
    prefix: "fas",
    iconName: "conveyor-belt",
    icon: [640, 512, [], "f46e", "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm400 64H96c-53 0-96 43-96 96s43 96 96 96h448c53 0 96-43 96-96s-43-96-96-96zM128 448c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Po = {
    prefix: "fas",
    iconName: "conveyor-belt-alt",
    icon: [640, 512, [], "f46f", "M80 256h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm320 0h160c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16zm144 64H96c-53 0-96 43-96 96s43 96 96 96h448c53 0 96-43 96-96s-43-96-96-96zM128 448c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Fo = {
    prefix: "fas",
    iconName: "cookie",
    icon: [512, 512, [], "f563", "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Wo = {
    prefix: "fas",
    iconName: "cookie-bite",
    icon: [512, 512, [], "f564", "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Go = {
    prefix: "fas",
    iconName: "copy",
    icon: [448, 512, [], "f0c5", "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"]
  },
      qo = {
    prefix: "fas",
    iconName: "copyright",
    icon: [512, 512, [], "f1f9", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"]
  },
      Jo = {
    prefix: "fas",
    iconName: "corn",
    icon: [512, 512, [], "f6c7", "M118.63 370.74l-67.88 67.88L96 483.88c37.49 37.49 98.27 37.49 135.76 0l90.51-90.51 97.66-19.53c6.43-1.29 8.85-9.59 3.91-13.89-88-76.52-221.49-72.92-305.21 10.79zm82.4-85.89c15.42-67.76-.79-141.26-49-196.71-4.29-4.94-12.58-2.51-13.87 3.91l-19.54 97.68-90.51 90.51c-37.49 37.49-37.49 98.28 0 135.77L96 348.12c30.38-30.38 66.59-51.38 105.03-63.27zM511.93 45.3v-3.2c1.28-21.44-14.72-40-36.48-41.91-16.63-1.61-31.67 7.03-39.03 21.11-9.92-9.59-24.33-13.75-38.41-9.6-13.44 3.85-23.67 14.08-27.51 26.88-10.88-7.03-24.96-8.64-37.77-3.2-12.79 5.77-21.11 17.28-23.36 29.77-11.52-5.44-25.59-5.44-37.44 1.59-11.85 6.72-18.88 18.89-19.84 31.36-11.83-4.47-25.91-3.19-37.11 4.81-3.26 2.3-5.94 5.13-8.31 8.17 28.33 51.23 37.75 110.06 28.31 166.44 56.39-9.36 115.25-.37 166.48 28.13 1.7-1.66 3.43-3.29 4.87-5.31 8-11.2 9.28-24.97 4.79-36.8 12.8-.97 24.96-8 31.69-19.85 7.03-11.84 7.36-25.92 1.59-37.44 12.8-2.25 24.31-10.25 30.08-23.05 5.76-12.8 4.15-26.87-2.88-37.77 12.47-3.83 23.03-13.75 27.2-27.19 4.16-14.08 0-28.48-8.97-38.41 12.51-6.37 21.46-19.17 22.1-34.53z"]
  },
      Ko = {
    prefix: "fas",
    iconName: "couch",
    icon: [640, 512, [], "f4b8", "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"]
  },
      Xo = {
    prefix: "fas",
    iconName: "cow",
    icon: [640, 512, [], "f6c8", "M634.01 276.72l-10-13.81v-77.02c0-11.89-12.52-19.63-23.16-14.31-10.82 5.41-19.47 13.59-26.31 23.01l-65.82-90.9A96.025 96.025 0 0 0 430.96 64H112c-48.6 0-88 39.4-88 88v86.41C9.48 250.14 0 267.88 0 288v32h8c35.35 0 64-28.65 64-64V152c0-16.87 10.55-31.16 25.34-37.04-.87 4.22-1.34 8.57-1.34 13.04v304c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V320c9.32 9.32 20.28 16.5 32.04 21.87V368c0 8.84 7.16 16 16 16s16-7.16 16-16v-17.31c9.1 1.12 12.81 2.36 32-.01V368c0 8.84 7.16 16 16 16s16-7.16 16-16v-26.18c11.71-5.36 22.64-12.51 31.92-21.79V432c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V256l32 32v41.48a63.97 63.97 0 0 0 10.75 35.5l41.33 61.99a47.233 47.233 0 0 0 39.3 21.03c22.52 0 41.9-15.89 46.32-37.97l21.73-108.63c1.72-8.62-.23-17.57-5.38-24.68zM377.24 167.36l-22.89 22.75c-21.82 21.7-51.41 33.88-82.26 33.88h-.17c-30.86 0-60.45-12.19-82.26-33.88l-22.89-22.75c-15.72-15.63-2.3-39.36 22.25-39.36h165.96c24.56 0 37.98 23.73 22.26 39.36zM576.01 352c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.17 16-16 16z"]
  },
      _o = {
    prefix: "fas",
    iconName: "cowbell",
    icon: [448, 512, [], "f8b3", "M384.19 122.35A32 32 0 0 0 352.64 96h-16V48a48.1 48.1 0 0 0-48.12-48H160.29a48.1 48.1 0 0 0-48.09 48v48H95.36a32 32 0 0 0-31.55 26.35l-63.3 352A32 32 0 0 0 32.07 512h383.86a32 32 0 0 0 31.56-37.65zM176.32 64h96.17v32h-96.17z"]
  },
      $o = {
    prefix: "fas",
    iconName: "cowbell-more",
    icon: [640, 512, [], "f8b4", "M287.78 352c0-75.21 43.66-140.27 106.92-171.76l-10.41-57.89A32.06 32.06 0 0 0 352.72 96h-15.91V48a48.05 48.05 0 0 0-48-48h-128a48.05 48.05 0 0 0-48 48v48H95.38a32 32 0 0 0-31.56 26.35l-63.31 352A32 32 0 0 0 32.07 512h342c-51.95-34.42-86.29-93.26-86.29-160zm-15-256h-96V64h96zM480 192a160 160 0 1 0 160 160 160 160 0 0 0-160-160zm80 168a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"]
  },
      cl = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [576, 512, [], "f09d", "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"]
  },
      el = {
    prefix: "fas",
    iconName: "credit-card-blank",
    icon: [576, 512, [], "f389", "M528 40H48C21.5 40 0 61.5 0 88v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V88c0-26.5-21.5-48-48-48zM160 404c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40zm192 0c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40z"]
  },
      al = {
    prefix: "fas",
    iconName: "credit-card-front",
    icon: [576, 512, [], "f38a", "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM192 268c0-6.6 5.4-12 12-12h64c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-64c-6.6 0-12-5.4-12-12v-40zm-32 136c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v8zm16-96c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h88c6.6 0 12 5.4 12 12v40zm176 96c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v8zm32-96c0 6.6-5.4 12-12 12h-64c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h64c6.6 0 12 5.4 12 12v40zm128 0c0 6.6-5.4 12-12 12h-88c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h88c6.6 0 12 5.4 12 12v40zm0-140c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v48z"]
  },
      nl = {
    prefix: "fas",
    iconName: "cricket",
    icon: [640, 512, [], "f449", "M421.5 321.5L158 506c-8.9 6.2-20.5 7.9-30.4 3.5C54.8 477 5.7 406.9.1 327.4c-.8-10.8 4.8-21.2 13.7-27.4l263.5-184.5-30.9 175.1 175.1 30.9zM635.7 30.4l-15.2-20.2C612.9-.6 597.9-3.3 587 4.3L443 104.8c-14.5 10.1-34.4 6.6-44.6-7.9l-21.9-31.3c-5.1-7.2-15-9-22.3-3.9l-21.3 14.9L302 251.7l175.1 30.9 21.3-14.9c7.2-5.1 9-15 3.9-22.3l-24.5-35c-10.1-14.5-6.6-34.4 7.9-44.6L629.8 63.9c10.8-7.6 13.5-22.6 5.9-33.5zM496 352c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z"]
  },
      tl = {
    prefix: "fas",
    iconName: "croissant",
    icon: [512, 512, [], "f7f6", "M209.1 387.94L110 465.73a215.54 215.54 0 0 0 70.67 44.19 32 32 0 0 0 42.91-35.18zm300.82-207.28A215.54 215.54 0 0 0 465.73 110l-77.79 99.1 86.8 14.47a32.36 32.36 0 0 0 5.26.43 32 32 0 0 0 29.92-43.34zM234.9 22.59A32 32 0 0 0 196.55 1 268.35 268.35 0 0 0 1 196.55a32 32 0 0 0 21.6 38.35l208 64a32 32 0 0 0 32-8l28.31-28.31a32 32 0 0 0 8-32zm212.84 43a32 32 0 0 0-12.33-21.39A217.11 217.11 0 0 0 304.46 0a215.78 215.78 0 0 0-43.26 4.48c1.41 2.93 3.3 5.52 4.28 8.7l64 208c.06.2 0 .41.1.62 6-1.93 11.61-5 15.6-10l96-122.32a32 32 0 0 0 6.56-23.85zM221.8 329.57c-.2-.06-.42 0-.62-.09l-208-64a62.68 62.68 0 0 1-8.54-3.57 215.1 215.1 0 0 0 39.59 173.5 32 32 0 0 0 21.39 12.33 32.51 32.51 0 0 0 4.05.26 32 32 0 0 0 19.76-6.83l122.32-96c5.1-3.99 8.12-9.58 10.05-15.6z"]
  },
      rl = {
    prefix: "fas",
    iconName: "crop",
    icon: [512, 512, [], "f125", "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"]
  },
      il = {
    prefix: "fas",
    iconName: "crop-alt",
    icon: [512, 512, [], "f565", "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"]
  },
      ol = {
    prefix: "fas",
    iconName: "cross",
    icon: [384, 512, [], "f654", "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
  },
      ll = {
    prefix: "fas",
    iconName: "crosshairs",
    icon: [512, 512, [], "f05b", "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"]
  },
      fl = {
    prefix: "fas",
    iconName: "crow",
    icon: [640, 512, [], "f520", "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
  },
      sl = {
    prefix: "fas",
    iconName: "crown",
    icon: [640, 512, [], "f521", "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"]
  },
      ul = {
    prefix: "fas",
    iconName: "crutch",
    icon: [512, 512, [], "f7f7", "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"]
  },
      hl = {
    prefix: "fas",
    iconName: "crutches",
    icon: [640, 512, [], "f7f8", "M635.31 185.71l-181-181a16 16 0 0 0-22.62 0L409 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zM441 395.76a128.09 128.09 0 0 1-33.67 13L371.74 417l90.32 90.32a16 16 0 0 0 22.63 0l22.62-22.62a16 16 0 0 0 0-22.63zm-245.19-42.1l9.7-9.7 13.22-57.32L106.51 174.4l67.89-67.89 78.75 78.75a126.75 126.75 0 0 1 12.29-14.34L297.37 139l-77.72-77.74L231 49.94a16 16 0 0 0 0-22.63L208.33 4.69a16 16 0 0 0-22.62 0l-181 181a16 16 0 0 0 0 22.62L27.31 231a16 16 0 0 0 22.63 0l11.32-11.31 132.29 132.25c.68.68 1.58 1.06 2.28 1.72zm259.96-101.54l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L234.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L510.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"]
  },
      ml = {
    prefix: "fas",
    iconName: "cube",
    icon: [512, 512, [], "f1b2", "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"]
  },
      vl = {
    prefix: "fas",
    iconName: "cubes",
    icon: [512, 512, [], "f1b3", "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"]
  },
      dl = {
    prefix: "fas",
    iconName: "curling",
    icon: [640, 512, [], "f44a", "M554.1 192H85.9c13.2-37.2 48.4-64 90.1-64h48v-16C224 50.1 274.1 0 336 0h128c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16-117.7 0-176-11.4-176 48v16h176c41.7 0 76.9 26.8 90.1 64zM0 416c0 53 43 96 96 96h448c53 0 96-43 96-96v-32H0v32zm544-176H96c-53 0-96 43-96 96v16h640v-16c0-53-43-96-96-96z"]
  },
      Ml = {
    prefix: "fas",
    iconName: "cut",
    icon: [448, 512, [], "f0c4", "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"]
  },
      pl = {
    prefix: "fas",
    iconName: "dagger",
    icon: [384, 512, [], "f6cb", "M336 128H224V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112H48c-26.51 0-48 21.49-48 48s21.49 48 48 48c20.87 0 38.45-13.4 45.06-32h197.88c6.61 18.6 24.19 32 45.06 32 26.51 0 48-21.49 48-48s-21.49-48-48-48zM128 428.84l50.69 76.03c6.33 9.5 20.29 9.5 26.63 0L256 428.84V224H128v204.84z"]
  },
      zl = {
    prefix: "fas",
    iconName: "database",
    icon: [448, 512, [], "f1c0", "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"]
  },
      Cl = {
    prefix: "fas",
    iconName: "deaf",
    icon: [512, 512, [], "f2a4", "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"]
  },
      Ll = {
    prefix: "fas",
    iconName: "debug",
    icon: [512, 512, [], "f7f9", "M146.27 303.84l30.88-4.41a79.07 79.07 0 0 0 6.77 22.72l-24.8 16.54a16 16 0 1 0 17.75 26.62l26.39-17.59a76.88 76.88 0 0 0 71.68 17.73L176 266.5v.76l-34.27 4.9a16 16 0 0 0 4.54 31.68zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 432c-101.46 0-184-82.54-184-184a182.89 182.89 0 0 1 33.38-105.37l256 256A182.89 182.89 0 0 1 256 440zm150.62-78.63l-60.3-60.3 19.41 2.77a16.23 16.23 0 0 0 2.27.16 16 16 0 0 0 2.25-31.84l-34.25-4.9v-22.52l34.27-4.9a16 16 0 1 0-4.54-31.68l-30.88 4.41a79.07 79.07 0 0 0-6.77-22.72l24.79-16.54a16 16 0 1 0-17.75-26.62l-26.38 17.59a78.43 78.43 0 0 0-102-2.79l-56.11-56.11A182.89 182.89 0 0 1 256 72c101.46 0 184 82.54 184 184a182.89 182.89 0 0 1-33.38 105.37z"]
  },
      Al = {
    prefix: "fas",
    iconName: "deer",
    icon: [512, 512, [], "f78e", "M488.7 133.3l-91.9-25.8 11.1-5.6c12.4-6.2 23-15.6 30.7-27.1l18.1-27.2c2.5-3.7 1.5-8.6-2.2-11.1l-13.3-8.9c-3.7-2.5-8.6-1.5-11.1 2.2l-18 27.2c-4.6 7-11 12.6-18.5 16.3L351 94.6l-33.8-9.5 8.3-10.3c6.8-8.5 10.5-19.1 10.5-30V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v36.8c0 3.6-1.2 7.1-3.5 10l-16.8 20.9-16.1-4.5c-6.9-1.9-11.7-8.2-11.7-15.4V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v47.8c0 21.5 14.3 40.4 35 46.2l78.9 22.2L304 192H64c-35.3 0-64 28.7-64 64v64l32-21.3v48.9l-11.9 31.8c-4.6 12.2-5.3 25.4-2.2 38l24.9 82.5C44.6 507 51 512 58.3 512h63.8c10.4 0 18-9.8 15.5-19.9l-26.3-88.4 19.4-51.7H288v144c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V288l32-64h64c17.7 0 32-14.3 32-32v-27.9c0-14.3-9.6-26.9-23.3-30.8zM416 176c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      Nl = {
    prefix: "fas",
    iconName: "deer-rudolph",
    icon: [512, 512, [], "f78f", "M480 96c-17.7 0-32 14.3-32 32 0 1.1.5 2 .6 3l-83.8-23.5 11.1-5.6c12.4-6.2 23-15.6 30.7-27.1l18.1-27.2c2.5-3.7 1.5-8.6-2.2-11.1l-13.3-8.9c-3.7-2.5-8.6-1.5-11.1 2.2l-18 27.2c-4.6 7-11 12.6-18.5 16.3L319 94.6l-33.8-9.5 8.3-10.3c6.8-8.5 10.5-19.1 10.5-30V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v36.8c0 3.6-1.2 7.1-3.5 10l-16.8 20.9-16.1-4.5c-6.9-1.9-11.7-8.2-11.7-15.4V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v47.8c0 21.5 14.3 40.4 35 46.2l78.9 22.2L272 192H64c-35.3 0-64 28.7-64 64v64l32-21.3v48.9l-11.9 31.8c-4.6 12.2-5.3 25.4-2.2 38l24.9 82.5C44.6 507 51 512 58.3 512h63.8c10.4 0 18-9.8 15.5-19.9l-26.3-88.4 19.4-51.7H256v144c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V288l32-64h64c17.7 0 32-14.3 32-32v-27.9c0-1.5-.5-2.8-.7-4.2.2 0 .5.1.7.1 17.7 0 32-14.3 32-32s-14.3-32-32-32zm-96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      gl = {
    prefix: "fas",
    iconName: "democrat",
    icon: [640, 512, [], "f747", "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"]
  },
      Hl = {
    prefix: "fas",
    iconName: "desktop",
    icon: [576, 512, [], "f108", "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"]
  },
      Vl = {
    prefix: "fas",
    iconName: "desktop-alt",
    icon: [576, 512, [], "f390", "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 288H64V64h448v224z"]
  },
      xl = {
    prefix: "fas",
    iconName: "dewpoint",
    icon: [512, 512, [], "f748", "M160.1 22.1C109.1 179.8 0 222.7 0 333.9 0 432.3 85.9 512 192 512s192-79.7 192-178.1c0-111.8-108.9-153.3-160.1-311.8-8.7-28.8-54-30.1-63.8 0zM416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      wl = {
    prefix: "fas",
    iconName: "dharmachakra",
    icon: [512, 512, [], "f655", "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"]
  },
      yl = {
    prefix: "fas",
    iconName: "diagnoses",
    icon: [640, 512, [], "f470", "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
  },
      bl = {
    prefix: "fas",
    iconName: "diamond",
    icon: [448, 512, [], "f219", "M242.2 8.3c-9.6-11.1-26.8-11.1-36.4 0l-200 232c-7.8 9-7.8 22.3 0 31.3l200 232c9.6 11.1 26.8 11.1 36.4 0l200-232c7.8-9 7.8-22.3 0-31.3l-200-232z"]
  },
      Sl = {
    prefix: "fas",
    iconName: "dice",
    icon: [640, 512, [], "f522", "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
  },
      Tl = {
    prefix: "fas",
    iconName: "dice-d10",
    icon: [512, 512, [], "f6cd", "M11.09 255.29l130.38-27.25 67.78-212.5c2.95-9.2-8.4-15.92-14.45-8.54L3.01 240.87c-5.24 6.38.2 16.07 8.08 14.42zm359.43-27.24L500.9 255.3c7.89 1.65 13.32-8.05 8.09-14.43L317.19 6.99c-6.04-7.37-17.39-.66-14.46 8.55l67.79 212.51zm-106.49-222c-2.57-8.06-13.49-8.06-16.06 0l-73.4 230.11L256 292.87l81.43-56.72-73.4-230.1zm241.16 286.22l-144.06-30.11-88.2 61.45v179.53c0 7.59 8.55 11.66 14.02 6.67l222.13-202.2c5.31-4.82 3-13.9-3.89-15.34zm-498.38 0c-6.89 1.44-9.2 10.52-3.9 15.34L225.05 509.8c5.48 4.98 14.02.92 14.02-6.67V323.61l-88.2-61.45L6.81 292.27z"]
  },
      Dl = {
    prefix: "fas",
    iconName: "dice-d12",
    icon: [512, 512, [], "f6ce", "M256 273.89l-108.59 54.29L206.23 512h99.53l58.82-183.82L256 273.89zm16-27.78l108.84 54.42 123.62-123.62-51.43-102.84L272 139.24v106.87zm-32 0V139.24L58.97 74.07 7.54 176.92l123.62 123.62L240 246.11zM422.28 51.14L333.51 6.76A63.874 63.874 0 0 0 304.89 0H207.1c-9.94 0-19.73 2.31-28.62 6.76L89.72 51.14 256 111l166.28-59.86zm-24.23 277.43l-55.01 171.91 85.88-42.94a64.02 64.02 0 0 0 28.62-28.62l47.7-95.4A64.07 64.07 0 0 0 512 304.9v-90.27L398.05 328.57zM0 214.62v90.27c0 9.94 2.31 19.74 6.76 28.62l47.7 95.4a63.972 63.972 0 0 0 28.62 28.62l85.88 42.94-55.01-171.91L0 214.62z"]
  },
      jl = {
    prefix: "fas",
    iconName: "dice-d20",
    icon: [480, 512, [], "f6cf", "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"]
  },
      El = {
    prefix: "fas",
    iconName: "dice-d4",
    icon: [512, 512, [], "f6d0", "M225.28 3.34L1.68 309.48C-1 313.15-.4 318.4 3.03 321.3l223.61 188.81c5.3 4.47 13.17.51 13.17-6.64V8.53C239.8.4 229.99-3.1 225.28 3.34zm285.04 306.14L286.72 3.34C282.01-3.1 272.2.4 272.2 8.53v494.94c0 7.15 7.87 11.11 13.17 6.64l223.6-188.81c3.44-2.9 4.04-8.15 1.35-11.82z"]
  },
      kl = {
    prefix: "fas",
    iconName: "dice-d6",
    icon: [448, 512, [], "f6d1", "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"]
  },
      Il = {
    prefix: "fas",
    iconName: "dice-d8",
    icon: [512, 512, [], "f6d2", "M225.53 2.52L2.36 233.83c-4.21 4.37-2.56 11.71 3.1 13.77l234.13 85.06V8.39c-.01-7.49-8.91-11.21-14.06-5.87zm284.11 231.31L286.47 2.52C281.32-2.82 272.41.9 272.41 8.4v324.27l234.13-85.06c5.66-2.07 7.31-9.42 3.1-13.78zM33.53 310.38l192 199.1c5.15 5.34 14.06 1.62 14.06-5.88V368.29L42.13 296.61c-8.21-2.98-14.72 7.43-8.6 13.77zm436.34-13.77l-197.46 71.68V503.6c0 7.5 8.91 11.22 14.06 5.88l192-199.1c6.12-6.34-.39-16.75-8.6-13.77z"]
  },
      Ol = {
    prefix: "fas",
    iconName: "dice-five",
    icon: [448, 512, [], "f523", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Ql = {
    prefix: "fas",
    iconName: "dice-four",
    icon: [448, 512, [], "f524", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Zl = {
    prefix: "fas",
    iconName: "dice-one",
    icon: [448, 512, [], "f525", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Ul = {
    prefix: "fas",
    iconName: "dice-six",
    icon: [448, 512, [], "f526", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Bl = {
    prefix: "fas",
    iconName: "dice-three",
    icon: [448, 512, [], "f527", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Rl = {
    prefix: "fas",
    iconName: "dice-two",
    icon: [448, 512, [], "f528", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Yl = {
    prefix: "fas",
    iconName: "digging",
    icon: [576, 512, [], "f85e", "M272 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-62.24 261.36q-38.7-25.78-79.55-48.09l-71.56-39-57.42 201a32 32 0 1 0 61.56 17.59l36.6-128.16L160 401.11V480a32 32 0 0 0 64 0v-96a32 32 0 0 0-14.24-26.64zM311.07 416a32 32 0 0 0-30.36 21.88L256 512h320L474.07 305.68c-11.29-22.59-43.07-23.81-56.07-2.15l-31.86 54.29-65.3-35.62L296.85 201a129.78 129.78 0 0 0-69.72-91.2c-1-.5-2.11-.66-3.11-1.13a31 31 0 0 0-7.22-2.67c-15.34-6.1-31.56-10-48.07-10H96a32 32 0 0 0-24.07 10.92l-56 64a25.89 25.89 0 0 0-2.3 3.16c-8.83 14.1-3 32.86 11.62 40.85l336.6 184.3L352 416zM105.9 205l-23.49-12.85L110.54 160h34.33zm93.74 51.13l34.73-41.23 13.5 67.54z"]
  },
      Pl = {
    prefix: "fas",
    iconName: "digital-tachograph",
    icon: [640, 512, [], "f566", "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"]
  },
      Fl = {
    prefix: "fas",
    iconName: "diploma",
    icon: [640, 512, [], "f5ea", "M384 268.67V128H256v140.67l-95.16 164c-3.05 7.49 2.65 15.63 10.73 15.32l36.64.01 25.21 28.52c5.56 5.87 15.33 4.04 18.39-3.45L320 352l68.2 121.07c3.05 7.49 12.83 9.32 18.39 3.45l25.2-28.52 36.64-.01c8.08.31 13.78-7.83 10.73-15.32l-95.16-164zm-160-8.61V115.94c-9.64-2.45-19.21-5.19-28.65-8.37L68.39 64.78c-15.03-3.1-30.25 3.27-37.03 14.77-41.81 70.94-41.81 217.95 0 288.89 6.78 11.5 22.01 17.88 37.03 14.77l104.6-35.24L224 260.06zm384.64-180.5c-6.78-11.5-22.01-17.88-37.03-14.77l-126.96 42.78c-9.44 3.18-19.01 5.93-28.65 8.37v144.12l51.01 87.92 104.6 35.24c15.03 3.1 30.25-3.27 37.03-14.77 41.81-70.94 41.81-217.95 0-288.89z"]
  },
      Wl = {
    prefix: "fas",
    iconName: "directions",
    icon: [512, 512, [], "f5eb", "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"]
  },
      Gl = {
    prefix: "fas",
    iconName: "disc-drive",
    icon: [512, 512, [], "f8b5", "M496 416h-16V96a64 64 0 0 0-64-64H96a64 64 0 0 0-64 64v320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-240 0a160 160 0 1 1 160-160 160 160 0 0 1-160 160zm0-192a32 32 0 1 0 32 32 32 32 0 0 0-32-32z"]
  },
      ql = {
    prefix: "fas",
    iconName: "disease",
    icon: [512, 512, [], "f7fa", "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"]
  },
      Jl = {
    prefix: "fas",
    iconName: "divide",
    icon: [448, 512, [], "f529", "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
  },
      Kl = {
    prefix: "fas",
    iconName: "dizzy",
    icon: [496, 512, [], "f567", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"]
  },
      Xl = {
    prefix: "fas",
    iconName: "dna",
    icon: [448, 512, [], "f471", "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"]
  },
      _l = {
    prefix: "fas",
    iconName: "do-not-enter",
    icon: [496, 512, [], "f5ec", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm176 296H72c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h352c8.84 0 16 7.16 16 16v64c0 8.84-7.16 16-16 16z"]
  },
      $l = {
    prefix: "fas",
    iconName: "dog",
    icon: [576, 512, [], "f6d3", "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"]
  },
      cf = {
    prefix: "fas",
    iconName: "dog-leashed",
    icon: [576, 512, [], "f6d4", "M67.64,3.37,288,168.08V192H239.54L38.17,41.25a16,16,0,0,1-2.8-22.45L45.19,6.18A16,16,0,0,1,67.64,3.37ZM128,224H288V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.1C58.83,268.85,32,233.66,32,192a32,32,0,0,1,64,0A32,32,0,0,0,128,224ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.23-21.39,27.32-11.31L374.6,64h53.62c10.92,0,23.74,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112ZM320,231.84l128,45.71V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H320ZM432,112a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"]
  },
      ef = {
    prefix: "fas",
    iconName: "dollar-sign",
    icon: [288, 512, [], "f155", "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"]
  },
      af = {
    prefix: "fas",
    iconName: "dolly",
    icon: [576, 512, [], "f472", "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      nf = {
    prefix: "fas",
    iconName: "dolly-empty",
    icon: [576, 512, [], "f473", "M575.2 326.4L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6L565 346.6c8.4-2.8 13-11.8 10.2-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      tf = {
    prefix: "fas",
    iconName: "dolly-flatbed",
    icon: [640, 512, [], "f474", "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
  },
      rf = {
    prefix: "fas",
    iconName: "dolly-flatbed-alt",
    icon: [640, 512, [], "f475", "M624 384H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-416-64h160c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm224-160h96c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm0 160h160c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16H432c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16z"]
  },
      of = {
    prefix: "fas",
    iconName: "dolly-flatbed-empty",
    icon: [640, 512, [], "f476", "M624 384H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
  },
      lf = {
    prefix: "fas",
    iconName: "donate",
    icon: [512, 512, [], "f4b9", "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"]
  },
      ff = {
    prefix: "fas",
    iconName: "door-closed",
    icon: [640, 512, [], "f52a", "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"]
  },
      sf = {
    prefix: "fas",
    iconName: "door-open",
    icon: [640, 512, [], "f52b", "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"]
  },
      uf = {
    prefix: "fas",
    iconName: "dot-circle",
    icon: [512, 512, [], "f192", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"]
  },
      hf = {
    prefix: "fas",
    iconName: "dove",
    icon: [512, 512, [], "f4ba", "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      mf = {
    prefix: "fas",
    iconName: "download",
    icon: [512, 512, [], "f019", "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"]
  },
      vf = {
    prefix: "fas",
    iconName: "drafting-compass",
    icon: [512, 512, [], "f568", "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"]
  },
      df = {
    prefix: "fas",
    iconName: "dragon",
    icon: [640, 512, [], "f6d5", "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"]
  },
      Mf = {
    prefix: "fas",
    iconName: "draw-circle",
    icon: [512, 512, [], "f5ed", "M512 256c0-26.93-16.67-49.88-40.23-59.32-20.88-75.84-80.61-135.56-156.45-156.45C305.88 16.68 282.93 0 256 0s-49.88 16.68-59.32 40.23C120.84 61.11 61.11 120.84 40.23 196.68 16.67 206.12 0 229.07 0 256s16.67 49.88 40.23 59.32c20.88 75.84 80.61 135.56 156.45 156.45C206.12 495.33 229.07 512 256 512s49.88-16.67 59.32-40.23c75.84-20.88 135.56-80.61 156.45-156.45C495.33 305.88 512 282.93 512 256zm-64-16c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM272 64c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 272c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm176 176c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm65.15-40.53C293.41 393.25 275.88 384 256 384s-37.41 9.25-49.15 23.47a159.62 159.62 0 0 1-102.32-102.32C118.75 293.41 128 275.88 128 256s-9.25-37.42-23.47-49.15a159.62 159.62 0 0 1 102.32-102.32C218.59 118.75 236.12 128 256 128s37.41-9.25 49.15-23.47a159.62 159.62 0 0 1 102.32 102.32C393.25 218.58 384 236.12 384 256s9.25 37.41 23.47 49.15a159.598 159.598 0 0 1-102.32 102.32z"]
  },
      pf = {
    prefix: "fas",
    iconName: "draw-polygon",
    icon: [448, 512, [], "f5ee", "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"]
  },
      zf = {
    prefix: "fas",
    iconName: "draw-square",
    icon: [448, 512, [], "f5ef", "M416 360.88V151.12c19.05-11.09 32-31.49 32-55.12 0-35.35-28.65-64-64-64-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-23.63-12.94-44.04-31.99-55.12zm-320 0V151.12A63.825 63.825 0 0 0 119.12 128h209.75a63.825 63.825 0 0 0 23.12 23.12v209.75a63.825 63.825 0 0 0-23.12 23.12H119.12A63.798 63.798 0 0 0 96 360.88zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"]
  },
      Cf = {
    prefix: "fas",
    iconName: "dreidel",
    icon: [448, 512, [], "f792", "M19.6 224C7 236.5 0 253.5 0 271.3v141.8c0 37 29.9 66.9 66.9 66.9h141.8c17.7 0 34.7-7 47.3-19.6l58.9-58.9L78.5 165.1 19.6 224zM443.3 59.3l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-109 109-71.9-71.9c-13.1-13.1-34.2-13.1-47.3 0l-68.7 68.7 236.4 236.4 68.7-68.7c13.1-13.1 13.1-34.2 0-47.3l-72-71.9 109-109c6.3-6.3 6.3-16.4 0-22.7z"]
  },
      Lf = {
    prefix: "fas",
    iconName: "drone",
    icon: [512, 512, [], "f85f", "M112 224a110.32 110.32 0 0 0 16.26-1.64l-35.93-49.77a63.82 63.82 0 1 1 80.26-80.26l49.77 35.93A110.45 110.45 0 0 0 224 112a112 112 0 1 0-112 112zM339.41 92.33a63.82 63.82 0 1 1 80.26 80.26l-35.93 49.77A110.32 110.32 0 0 0 400 224a112 112 0 1 0-112-112 110.32 110.32 0 0 0 1.64 16.26zM172.59 419.67a63.82 63.82 0 1 1-80.26-80.26l35.93-49.77A110.32 110.32 0 0 0 112 288a112 112 0 1 0 112 112 110.32 110.32 0 0 0-1.64-16.26zM400 288a110.32 110.32 0 0 0-16.26 1.64l35.93 49.77a63.82 63.82 0 1 1-80.26 80.25l-49.77-35.92A110.32 110.32 0 0 0 288 400a112 112 0 1 0 112-112zm1-144.2a31.91 31.91 0 1 0-32.8-32.8l-67.86 49h-88.68l-67.86-49a31.91 31.91 0 1 0-32.8 32.8l49 67.86v88.68l-49 67.86a31.91 31.91 0 1 0 32.8 32.8l67.86-49h88.68l67.86 49a31.91 31.91 0 1 0 32.8-32.8l-49-67.86v-88.68z"]
  },
      Af = {
    prefix: "fas",
    iconName: "drone-alt",
    icon: [640, 512, [], "f860", "M288 136a24 24 0 0 0-24-24h-97.62a23.66 23.66 0 0 0-44.77 0H24a24 24 0 0 0 0 48h240a24 24 0 0 0 24-24zm328.4-23.93l-97.82.31a23.58 23.58 0 0 0-45 .14l-98 .31a23.55 23.55 0 0 0 .15 47.09l240.81-.77a23.54 23.54 0 0 0-.15-47.08zM472 237.65l-96.85-29.05a191.9 191.9 0 0 0-110.33 0L168 237.65V192h-48v64.05a32 32 0 0 0 32 32h45.4a179 179 0 0 0-53.33 110.24 16.14 16.14 0 0 0 16 17.71h16.25c8.34 0 14.76-6.58 15.68-14.87a130 130 0 0 1 53.67-91.38l32.92 32.93a32 32 0 0 0 22.63 9.37h37.49a32 32 0 0 0 22.63-9.37l32.92-32.93A130.06 130.06 0 0 1 448 401.13c.92 8.29 7.34 14.85 15.68 14.87h16.25a16.14 16.14 0 0 0 16-17.71 179 179 0 0 0-53.33-110.24H488a32 32 0 0 0 32-32V192h-48z"]
  },
      Nf = {
    prefix: "fas",
    iconName: "drum",
    icon: [512, 512, [], "f569", "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"]
  },
      gf = {
    prefix: "fas",
    iconName: "drum-steelpan",
    icon: [576, 512, [], "f56a", "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"]
  },
      Hf = {
    prefix: "fas",
    iconName: "drumstick",
    icon: [512, 512, [], "f6d6", "M462.43 49.57a169.21 169.21 0 0 0-239.31 0C187.66 85 160 128 160 192v85.83l-40.59 40.59c-9.71 9.69-24 11.07-36.76 6a60.31 60.31 0 0 0-65 98.72c15.27 15.27 36.5 19.58 56.1 15.09-4.49 19.6-.18 40.83 15.09 56.1a60.32 60.32 0 0 0 98.73-65c-5.09-12.73-3.72-27 6-36.75l40.6-40.58H320c64 0 107-27.66 142.44-63.12a169.22 169.22 0 0 0-.01-239.31z"]
  },
      Vf = {
    prefix: "fas",
    iconName: "drumstick-bite",
    icon: [512, 512, [], "f6d7", "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"]
  },
      xf = {
    prefix: "fas",
    iconName: "dryer",
    icon: [448, 512, [], "f861", "M384 0H64A64 64 0 0 0 0 64v416a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a64 64 0 0 0-64-64zM184 64a24 24 0 1 1-24 24 24 24 0 0 1 24-24zM64 88a24 24 0 1 1 24 24 24 24 0 0 1-24-24zm160 360a144 144 0 1 1 144-144 144 144 0 0 1-144 144zm-8-176c0-22.64-11.95-34.59-20.69-43.33-5.82-5.82-9.24-9.45-10.6-14.62A8 8 0 0 0 177 208h-16.29a8.16 8.16 0 0 0-8 9.53c2.77 16.64 12.51 26.38 19.93 33.8C180.53 259.17 184 263 184 272s-3.47 12.86-11.31 20.7C164 301.47 152 313.42 152 336.06s11.95 34.56 20.69 43.28c5.82 5.82 9.23 9.44 10.6 14.59A8 8 0 0 0 191 400h16.32a8.16 8.16 0 0 0 8-9.53c-2.77-16.61-12.51-26.35-19.93-33.75C187.47 348.88 184 345 184 336.06s3.47-12.86 11.31-20.7C204.05 306.62 216 294.67 216 272zm80 0c0-22.64-11.95-34.59-20.69-43.33-5.82-5.82-9.24-9.45-10.6-14.62A8 8 0 0 0 257 208h-16.29a8.16 8.16 0 0 0-8 9.53c2.77 16.64 12.51 26.38 19.93 33.8C260.53 259.17 264 263 264 272s-3.47 12.86-11.31 20.7C244 301.47 232 313.42 232 336.06s11.95 34.56 20.69 43.28c5.82 5.82 9.23 9.44 10.6 14.59A8 8 0 0 0 271 400h16.32a8.16 8.16 0 0 0 7.95-9.53c-2.77-16.61-12.51-26.35-19.93-33.75C267.47 348.88 264 345 264 336.06s3.47-12.86 11.31-20.7C284.05 306.62 296 294.67 296 272z"]
  },
      wf = {
    prefix: "fas",
    iconName: "dryer-alt",
    icon: [448, 512, [], "f862", "M384 0H64A64 64 0 0 0 0 64v416a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a64 64 0 0 0-64-64zM184 64a24 24 0 1 1-24 24 24 24 0 0 1 24-24zM64 88a24 24 0 1 1 24 24 24 24 0 0 1-24-24zm160 360a144 144 0 1 1 144-144 144 144 0 0 1-144 144zm0-256a112 112 0 1 0 112 112 112 112 0 0 0-112-112zm0 192a80 80 0 0 1-78.39-64H184a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-38.39A80 80 0 1 1 224 384z"]
  },
      yf = {
    prefix: "fas",
    iconName: "duck",
    icon: [512, 512, [], "f6d8", "M416 224c53.02 0 96-42.98 96-96h-64c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 23.15 8.37 44.15 22.1 60.59 6.25 7.48 9.9 16.78 9.9 26.53 0 22.58-18.3 40.88-40.88 40.88h-21.69c-31.51 0-80.18-13.2-101.68-36.24C113.73 209.03 96 216.17 96 230.63 96 315.33 164.67 384 249.37 384h-32c-76.01 0-138.67-55.44-150.82-128h-50.4C7.03 256-.64 263.66.03 272.75 8.61 388.64 105.35 480 223.42 480h107.2c55.51 0 110.81-44.52 116.72-99.71 4.54-42.43-14.76-80.4-46.04-102.86-10.85-7.79-17.3-20.27-17.3-33.63 0-7.12 1.97-13.83 5.33-19.79H416zm-64-80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      bf = {
    prefix: "fas",
    iconName: "dumbbell",
    icon: [640, 512, [], "f44b", "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"]
  },
      Sf = {
    prefix: "fas",
    iconName: "dumpster",
    icon: [576, 512, [], "f793", "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
  },
      Tf = {
    prefix: "fas",
    iconName: "dumpster-fire",
    icon: [640, 512, [], "f794", "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"]
  },
      Df = {
    prefix: "fas",
    iconName: "dungeon",
    icon: [512, 512, [], "f6d9", "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"]
  },
      jf = {
    prefix: "fas",
    iconName: "ear",
    icon: [384, 512, [], "f5f0", "M192 0C85.96 0 0 85.96 0 192v176c0 79.53 64.47 144 144 144s144-64.47 144-144v-9.9c57.33-33.21 96-95.08 96-166.1C384 85.96 298.04 0 192 0zm128 200c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-8c0-52.94-43.06-96-96-96s-96 43.06-96 96c0 17.64 14.36 32 32 32h32c35.3 0 64 28.7 64 64s-28.7 64-64 64h-8c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h8c17.64 0 32-14.36 32-32s-14.36-32-32-32h-32c-35.3 0-64-28.7-64-64 0-70.58 57.42-128 128-128s128 57.42 128 128v8z"]
  },
      Ef = {
    prefix: "fas",
    iconName: "ear-muffs",
    icon: [640, 512, [], "f795", "M152 224c-11.9 0-22.3 5.4-29.6 13.7-10.6-6.9-23.8-9.3-36.4-4.4-11.8 4.8-20.2 14.7-23.7 26.2-11.8-.3-23.4 4.8-31.7 14.4-8 9.9-10.6 22.1-8.3 33.6-10.2 5.1-18.6 14.7-21.1 26.9-2.9 12.2.3 24 7.4 33.3-7 9-10.2 21.1-7.7 33.3 2.9 12.2 10.9 21.8 21.4 27.2-2.6 11.2 0 23.7 8 33.3 8 9.9 19.8 14.7 31.7 14.7 3.2 11.5 11.5 21.1 23.4 26.2 5.1 1.9 9.9 2.9 15 2.9 7.9 0 15.6-2.4 22.1-6.8 7.3 8.2 17.7 13.5 29.5 13.5 22.1 0 40-17.9 40-40 0-10-4-18.9-10.1-25.9 6.1-7 10.1-15.9 10.1-25.9 0-9.9-3.5-19.2-9.6-26.2 6.1-7 9.6-16 9.6-25.9s-3.5-18.9-9.6-25.9c6.1-7 9.6-16 9.6-25.9 0-10.2-4.1-19.1-10.2-26.1 6.1-7 10.2-16 10.2-26 0-22.3-17.9-40.2-40-40.2zm487.1 111c-2.9-12.2-10.9-21.8-21.4-26.9 2.6-11.5 0-24-8-33.6-8-9.9-19.8-14.7-31.7-14.7-3.2-11.5-11.5-21.4-23.4-26.2-12.7-5-26.1-2.5-36.8 4.5-7.3-8.4-17.8-14.1-29.9-14.1-22.1 0-40 17.9-40 40 0 10.1 4.1 19 10.2 26-6.1 7-10.2 15.9-10.2 26.1 0 9.9 3.5 18.9 9.6 25.9-6.1 7-9.6 16-9.6 25.9s3.5 18.9 9.6 25.9c-6.1 7-9.6 16-9.6 25.9 0 10.2 4.1 19.1 10.2 26.1-6.1 7-10.2 16-10.2 26 0 22.1 17.9 40 40 40 11.7 0 22-5.2 29.3-13.2 6.5 4.2 14.1 6.5 22 6.5 4.8 0 9.9-.6 14.7-2.9 11.8-4.5 20.2-14.4 23.4-25.9 11.8.3 23.7-4.8 32-14.4 8-9.9 10.6-22.1 8.3-33.6 10.2-5.1 18.2-14.7 21.1-26.9s-.3-24.3-7.4-33.3c7.2-8.7 10.4-20.9 7.8-33.1zM506.3 194.5c5.7 1.6 11.3 3.8 16.5 6.8 5.9-1.5 11.9-2.3 18-2.3 5.3 0 10.5.8 15.7 2C537.8 87.2 439 0 320 0S102.3 87.1 83.5 200.9c5.3-1.3 10.7-2.1 16.2-2.1 6.1 0 12.1.8 18 2.3 5.1-2.8 10.5-5 16-6.5C154.2 110.6 229.8 48 320 48c90.2 0 165.8 62.6 186.3 146.5z"]
  },
      kf = {
    prefix: "fas",
    iconName: "eclipse",
    icon: [640, 512, [], "f749", "M464 80c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176S561.2 80 464 80zM165.5 346.5c-49.9-49.9-49.9-131.1 0-181 35.1-35.1 85.5-45 129.8-30.7 7.5-10.4 15.8-20.1 25.1-28.9L271.5 9.6c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 5.3 1.8c-10.7-9.7-20.3-20.5-28.8-32.3-44.2 14.3-94.6 4.4-129.7-30.7zM256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96c7.7 0 15.1-1.2 22.3-2.9-14.2-28-22.3-59.6-22.3-93.1 0-33.5 8.1-65.1 22.3-93.1-7.2-1.7-14.6-2.9-22.3-2.9z"]
  },
      If = {
    prefix: "fas",
    iconName: "eclipse-alt",
    icon: [512, 512, [], "f74a", "M502.4 240.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181s131.1-49.9 181 0c49.9 49.9 49.9 131.1 0 181zm-20.4-37.3c-46.5 8.9-89.3-26.8-89.3-73.9 0-27.1 14.5-52 38-65.4 3.6-2.1 2.7-7.6-1.4-8.3-5.8-1.1-11.6-1.6-17.5-1.6-52.9 0-95.9 42.9-95.9 96 0 53 42.9 96 95.9 96 29.6 0 56.6-13.5 74.5-35.5 2.7-3.3-.2-8.1-4.3-7.3z"]
  },
      Of = {
    prefix: "fas",
    iconName: "edit",
    icon: [576, 512, [], "f044", "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"]
  },
      Qf = {
    prefix: "fas",
    iconName: "egg",
    icon: [384, 512, [], "f7fb", "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"]
  },
      Zf = {
    prefix: "fas",
    iconName: "egg-fried",
    icon: [512, 512, [], "f7fc", "M478.32 150.45c-39.5-40.71-100.73-46.29-144.39-82.24C284.12 27.2 245.81-9.25 175.39 2.1c-86.78 14-111.71 80-125 157.14-11.1 64.34-54.41 127-50 192.91s52.83 128.43 114.97 150.74c93 33.39 146.94-31.71 204.64-86.45 43.68-41.44 93.4-37.72 140.93-73.89 56.28-42.82 71.71-140.55 17.39-192.1zM224 352.38c-61.74 0-112-50.3-112-112.11s50.26-112.12 112-112.12 112 50.29 112 112.12-50.19 112.11-112 112.11zM216 160a72.09 72.09 0 0 0-72 72 16 16 0 0 0 32 0 40.05 40.05 0 0 1 40-40 16 16 0 0 0 0-32z"]
  },
      Uf = {
    prefix: "fas",
    iconName: "eject",
    icon: [448, 512, [], "f052", "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"]
  },
      Bf = {
    prefix: "fas",
    iconName: "elephant",
    icon: [640, 512, [], "f6da", "M512 32c-13.16 0-25.52 2.66-37.4 6.4C464.71 15.82 442.23 0 416 0c-35.35 0-64 28.65-64 64 0 23.63 12.95 44.04 32 55.12V160c0 17.67 14.33 32 32 32h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-35.29 0-64-28.71-64-64v-24.8c-20.08-18.03-32-43.92-32-71.2 0-11.28 2.31-21.94 5.9-32H192C85.96 32 0 117.96 0 224v112c0 8.84 7.16 16 16 16h16v144c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V388.15C160.35 405.7 198.72 416 240 416s79.65-10.3 112-27.85V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h64c23.44 0 45.11-6.76 64-17.75V368c0 8.83-7.17 16-16 16s-16-7.17-16-16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16 0 46.87 40.52 84.46 88.36 79.57 41.62-4.25 71.64-42.46 71.64-84.3V160c0-70.69-57.31-128-128-128zm16 128c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      Rf = {
    prefix: "fas",
    iconName: "ellipsis-h",
    icon: [512, 512, [], "f141", "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"]
  },
      Yf = {
    prefix: "fas",
    iconName: "ellipsis-h-alt",
    icon: [512, 512, [], "f39b", "M256 242c7.7 0 14 6.3 14 14s-6.3 14-14 14-14-6.3-14-14 6.3-14 14-14m0-58c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm176 58c7.7 0 14 6.3 14 14s-6.3 14-14 14-14-6.3-14-14 6.3-14 14-14m0-58c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zM80 242c7.7 0 14 6.3 14 14s-6.3 14-14 14-14-6.3-14-14 6.3-14 14-14m0-58c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"]
  },
      Pf = {
    prefix: "fas",
    iconName: "ellipsis-v",
    icon: [192, 512, [], "f142", "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"]
  },
      Ff = {
    prefix: "fas",
    iconName: "ellipsis-v-alt",
    icon: [192, 512, [], "f39c", "M96 242c7.7 0 14 6.3 14 14s-6.3 14-14 14-14-6.3-14-14 6.3-14 14-14m0-58c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0-118c7.7 0 14 6.3 14 14s-6.3 14-14 14-14-6.3-14-14 6.3-14 14-14m0-58C56.2 8 24 40.2 24 80s32.2 72 72 72 72-32.2 72-72S135.8 8 96 8zm0 410c7.7 0 14 6.3 14 14s-6.3 14-14 14-14-6.3-14-14 6.3-14 14-14m0-58c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"]
  },
      Wf = {
    prefix: "fas",
    iconName: "empty-set",
    icon: [512, 512, [], "f656", "M507.31 27.31L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0l-72.09 72.09C352.57 48.78 306.31 32 256 32 132.29 32 32 132.29 32 256c0 50.3 16.78 96.57 44.78 133.96l-72.09 72.1c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l72.09-72.09C159.43 463.22 205.7 480 256 480c123.71 0 224-100.29 224-224 0-50.3-16.78-96.57-44.78-133.96l72.09-72.09c6.25-6.26 6.25-16.39 0-22.64zM112 256c0-79.4 64.6-144 144-144 28.11 0 54.16 8.41 76.35 22.39L134.39 332.35C120.41 310.16 112 284.11 112 256zm288 0c0 79.4-64.6 144-144 144-28.11 0-54.16-8.41-76.35-22.39L377.6 179.65C391.59 201.84 400 227.89 400 256z"]
  },
      Gf = {
    prefix: "fas",
    iconName: "engine-warning",
    icon: [640, 512, [], "f5f2", "M48 256c0-59.53 19.55-117.38 55.36-164.51 5.18-6.81 4.48-16.31-2.03-21.86l-12.2-10.41c-6.91-5.9-17.62-5.06-23.15 2.15C23.32 117.02 0 185.5 0 256c0 70.47 23.32 138.96 65.96 194.62 5.53 7.21 16.23 8.05 23.15 2.16l12.19-10.4c6.51-5.55 7.21-15.04 2.04-21.86C67.55 373.37 48 315.53 48 256zM320 32C196.3 32 96 132.3 96 256c0 123.76 100.3 224 224 224s224-100.24 224-224c0-123.7-100.3-224-224-224zm0 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.44-110.41c-.82 8.18-7.7 14.41-15.92 14.41h-19.04c-8.22 0-15.1-6.23-15.92-14.41l-12.8-128c-.94-9.42 6.45-17.59 15.92-17.59h44.64c9.47 0 16.86 8.17 15.92 17.59l-12.8 128zM572.73 59.71c-5.58-7.18-16.29-7.95-23.17-2l-12.15 10.51c-6.47 5.6-7.1 15.09-1.88 21.87C572.04 137.47 592 195.81 592 256c0 60.23-19.96 118.57-56.46 165.95-5.22 6.78-4.59 16.27 1.88 21.87l12.15 10.5c6.87 5.95 17.59 5.18 23.17-2C616.21 396.38 640 327.31 640 256c0-71.27-23.79-140.34-67.27-196.29z"]
  },
      qf = {
    prefix: "fas",
    iconName: "envelope",
    icon: [512, 512, [], "f0e0", "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"]
  },
      Jf = {
    prefix: "fas",
    iconName: "envelope-open",
    icon: [512, 512, [], "f2b6", "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"]
  },
      Kf = {
    prefix: "fas",
    iconName: "envelope-open-dollar",
    icon: [512, 512, [], "f657", "M256 417.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.18 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77zM264 136h-16c-4.42 0-8 3.58-8 8v16.12c-23.62.63-42.67 20.55-42.67 45.07 0 19.97 12.98 37.81 31.58 43.39l45 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.11c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V336c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.62-.63 42.67-20.54 42.67-45.07 0-19.97-12.98-37.81-31.58-43.39l-45-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V144c0-4.42-3.58-8-8-8z"]
  },
      Xf = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"]
  },
      _f = {
    prefix: "fas",
    iconName: "envelope-square",
    icon: [448, 512, [], "f199", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"]
  },
      $f = {
    prefix: "fas",
    iconName: "equals",
    icon: [448, 512, [], "f52c", "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
  },
      cs = {
    prefix: "fas",
    iconName: "eraser",
    icon: [512, 512, [], "f12d", "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"]
  },
      es = {
    prefix: "fas",
    iconName: "ethernet",
    icon: [512, 512, [], "f796", "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"]
  },
      as = {
    prefix: "fas",
    iconName: "euro-sign",
    icon: [320, 512, [], "f153", "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"]
  },
      ns = {
    prefix: "fas",
    iconName: "exchange",
    icon: [512, 512, [], "f0ec", "M0 168v-16c0-13.255 10.745-24 24-24h381.97l-30.467-27.728c-9.815-9.289-10.03-24.846-.474-34.402l10.84-10.84c9.373-9.373 24.568-9.373 33.941 0l82.817 82.343c12.497 12.497 12.497 32.758 0 45.255l-82.817 82.343c-9.373 9.373-24.569 9.373-33.941 0l-10.84-10.84c-9.556-9.556-9.341-25.114.474-34.402L405.97 192H24c-13.255 0-24-10.745-24-24zm488 152H106.03l30.467-27.728c9.815-9.289 10.03-24.846.474-34.402l-10.84-10.84c-9.373-9.373-24.568-9.373-33.941 0L9.373 329.373c-12.497 12.497-12.497 32.758 0 45.255l82.817 82.343c9.373 9.373 24.569 9.373 33.941 0l10.84-10.84c9.556-9.556 9.341-25.113-.474-34.402L106.03 384H488c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"]
  },
      ts = {
    prefix: "fas",
    iconName: "exchange-alt",
    icon: [512, 512, [], "f362", "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"]
  },
      rs = {
    prefix: "fas",
    iconName: "exclamation",
    icon: [192, 512, [], "f12a", "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"]
  },
      is = {
    prefix: "fas",
    iconName: "exclamation-circle",
    icon: [512, 512, [], "f06a", "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"]
  },
      os = {
    prefix: "fas",
    iconName: "exclamation-square",
    icon: [448, 512, [], "f321", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-207.691 96h63.382c6.884 0 12.357 5.78 11.982 12.654l-7.418 136c-.347 6.364-5.609 11.346-11.982 11.346h-48.546c-6.373 0-11.635-4.982-11.982-11.346l-7.418-136c-.375-6.874 5.098-12.654 11.982-12.654zM224 398c-25.405 0-46-20.595-46-46s20.595-46 46-46 46 20.595 46 46-20.595 46-46 46z"]
  },
      ls = {
    prefix: "fas",
    iconName: "exclamation-triangle",
    icon: [576, 512, [], "f071", "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"]
  },
      fs = {
    prefix: "fas",
    iconName: "expand",
    icon: [448, 512, [], "f065", "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"]
  },
      ss = {
    prefix: "fas",
    iconName: "expand-alt",
    icon: [448, 512, [], "f424", "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"]
  },
      us = {
    prefix: "fas",
    iconName: "expand-arrows",
    icon: [448, 512, [], "f31d", "M448 312v136c0 17.7-14.3 32-32 32H280c-13.3 0-24-10.7-24-24v-15.3c0-13.5 11.2-24.4 24.7-24l66.3 1.9-123-123-123 123 66.3-1.9c13.5-.4 24.7 10.5 24.7 24V456c0 13.3-10.7 24-24 24H32c-17.7 0-32-14.3-32-32V312c0-13.3 10.7-24 24-24h15.3c13.5 0 24.4 11.2 24 24.7L61.4 379l123-123-123-123 1.9 66.3c.4 13.5-10.5 24.7-24 24.7H24c-13.3 0-24-10.7-24-24V64c0-17.7 14.3-32 32-32h136c13.3 0 24 10.7 24 24v15.3c0 13.5-11.2 24.4-24.7 24L101 93.4l123 123 123-123-66.3 1.9c-13.5.4-24.7-10.5-24.7-24V56c0-13.3 10.7-24 24-24h136c17.7 0 32 14.3 32 32v136c0 13.3-10.7 24-24 24h-15.3c-13.5 0-24.4-11.2-24-24.7l1.9-66.3-123 123 123 123-1.9-66.3c-.4-13.5 10.5-24.7 24-24.7H424c13.3 0 24 10.7 24 24z"]
  },
      hs = {
    prefix: "fas",
    iconName: "expand-arrows-alt",
    icon: [448, 512, [], "f31e", "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"]
  },
      ms = {
    prefix: "fas",
    iconName: "expand-wide",
    icon: [512, 512, [], "f320", "M0 212V88c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM352 76v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V88c0-13.3-10.7-24-24-24H364c-6.6 0-12 5.4-12 12zm148 212h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V300c0-6.6-5.4-12-12-12zM160 436v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"]
  },
      vs = {
    prefix: "fas",
    iconName: "external-link",
    icon: [512, 512, [], "f08e", "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM474.67,0H316a28,28,0,0,0-28,28V46.71A28,28,0,0,0,316.79,73.9L384,72,135.06,319.09l-.06.06a24,24,0,0,0,0,33.94l23.94,23.85.06.06a24,24,0,0,0,33.91-.09L440,128l-1.88,67.22V196a28,28,0,0,0,28,28H484a28,28,0,0,0,28-28V37.33h0A37.33,37.33,0,0,0,474.67,0Z"]
  },
      ds = {
    prefix: "fas",
    iconName: "external-link-alt",
    icon: [512, 512, [], "f35d", "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"]
  },
      Ms = {
    prefix: "fas",
    iconName: "external-link-square",
    icon: [448, 512, [], "f14c", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-64 47.111C384 109.929 370.071 96 352.889 96H220.667c-12.887 0-23.333 10.447-23.333 23.334v14.904c0 13.138 10.843 23.686 23.976 23.324l56.002-1.588L69.908 361.908c-7.858 7.802-7.88 20.504-.05 28.334l19.899 19.899c7.83 7.83 20.532 7.808 28.334-.05l205.935-207.404-1.588 56.003c-.362 13.133 10.186 23.976 23.324 23.976h14.904c12.887 0 23.334-10.447 23.334-23.333V127.111z"]
  },
      ps = {
    prefix: "fas",
    iconName: "external-link-square-alt",
    icon: [448, 512, [], "f360", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"]
  },
      zs = {
    prefix: "fas",
    iconName: "eye",
    icon: [576, 512, [], "f06e", "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"]
  },
      Cs = {
    prefix: "fas",
    iconName: "eye-dropper",
    icon: [512, 512, [], "f1fb", "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"]
  },
      Ls = {
    prefix: "fas",
    iconName: "eye-evil",
    icon: [640, 512, [], "f6db", "M627.03 239.08l-111.87-30.3c-4.79-6.56-10.15-13.4-16.13-20.45 1.35-2.07 55.18-87.98 55.18-87.98 8.94-14.32-6.1-31.35-22.45-25.42L412 118.29c-9.68-4.81-19.91-8.91-30.65-12.32l-44.47-95.24c-6.68-14.31-27.08-14.31-33.76 0l-44.47 95.24c-10.74 3.4-20.97 7.51-30.65 12.32L108.23 74.93C91.88 69 76.85 86.03 85.78 100.35c0 0 53.84 85.92 55.18 87.98a359.126 359.126 0 0 0-16.13 20.45l-111.87 30.3c-17.29 4.68-17.29 29.15 0 33.83l111.87 30.3c4.78 6.54 10.11 13.35 16.07 20.38-1.34 2.09-55.12 88.05-55.12 88.05-8.94 14.32 6.1 31.35 22.45 25.43L228 393.71c9.68 4.81 19.91 8.92 30.65 12.32l44.47 95.24c6.68 14.31 27.08 14.31 33.76 0l44.47-95.24c10.74-3.4 20.97-7.51 30.65-12.32l119.77 43.36c16.35 5.92 31.39-11.11 22.45-25.43 0 0-53.78-85.96-55.12-88.05 5.96-7.03 11.29-13.84 16.07-20.38l111.87-30.3c17.28-4.68 17.28-29.14-.01-33.83zM320 352c-53.02 0-96-42.98-96-96 0-19.73 5.99-38.06 16.2-53.31 15.91 9.57 34.77 16.33 55.59 19.33-4.41 9.25-7.79 20.41-7.79 33.98 0 42.67 32 64 32 64s32-21.33 32-64c0-13.57-3.37-24.73-7.79-33.98 20.82-3 39.68-9.76 55.59-19.33C410.01 217.94 416 236.27 416 256c0 53.02-42.98 96-96 96z"]
  },
      As = {
    prefix: "fas",
    iconName: "eye-slash",
    icon: [640, 512, [], "f070", "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"]
  },
      Ns = {
    prefix: "fas",
    iconName: "fan",
    icon: [512, 512, [], "f863", "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"]
  },
      gs = {
    prefix: "fas",
    iconName: "fan-table",
    icon: [448, 512, [], "e004", "M320,448H248V414.51C351.55,402.59,432,314.75,432,208,432,93.13,338.88,0,224,0S16,93.13,16,208c0,106.75,80.45,194.59,184,206.51V448H128c-28.42,0-54.95,18.53-63.3,44.16C61.48,502,69.88,512,80.26,512H367.74c10.38,0,18.78-10,15.56-19.84C375,466.53,348.42,448,320,448ZM119.67,334.8c-7.09-4.08-14.57-16.86-5.14-28.28l67.47-82c-57.17-20.29-69.18-77.3-59.64-113a93.77,93.77,0,0,1,44-57.34l0,0c13-7.39,24.26,2.35,27,9.73l37.08,99A94.36,94.36,0,0,1,386,235a18.84,18.84,0,0,1-21.91,18.58l-104.7-17.45a93.41,93.41,0,0,1-10.7,64.11A94.47,94.47,0,0,1,119.67,334.8ZM224,192a16,16,0,1,1-16,16A16,16,0,0,1,224,192Z"]
  },
      Hs = {
    prefix: "fas",
    iconName: "farm",
    icon: [576, 512, [], "f864", "M221.5 91.08l.37-.17A111.93 111.93 0 0 0 0 112v400h128V260.54a64.35 64.35 0 0 1 6.76-28.63l55.48-111a64.12 64.12 0 0 1 31.26-29.83zm351.12 155.14l-55.49-111a32 32 0 0 0-15.62-14.93L381 66.76a32 32 0 0 0-26 0l-120.51 53.56a32 32 0 0 0-15.62 14.93l-55.49 111a32.08 32.08 0 0 0-3.38 14.29V512h128v-96h160v96h128V260.54a32.08 32.08 0 0 0-3.38-14.32zM416 320h-96v-96h96z"]
  },
      Vs = {
    prefix: "fas",
    iconName: "fast-backward",
    icon: [512, 512, [], "f049", "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"]
  },
      xs = {
    prefix: "fas",
    iconName: "fast-forward",
    icon: [512, 512, [], "f050", "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"]
  },
      ws = {
    prefix: "fas",
    iconName: "faucet",
    icon: [512, 512, [], "e005", "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"]
  },
      ys = {
    prefix: "fas",
    iconName: "faucet-drip",
    icon: [512, 512, [], "e006", "M416,480a32,32,0,0,0,64,0c0-17.67-32-64-32-64S416,462.33,416,480ZM352,192H313.39c-15.71-13.44-35.46-23.07-57.39-28V116.44l-32-3.38-32,3.38V164c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,208v96a16,16,0,0,0,16,16h92.79C129.38,357.73,173,384,224,384s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,192ZM81.59,95.91,224,80.89l142.41,15c9.42,1,17.59-6.81,17.59-16.8V48.89c0-10-8.17-17.8-17.59-16.8L256,43.74V16A16,16,0,0,0,240,0H208a16,16,0,0,0-16,16V43.74L81.59,32.09C72.17,31.09,64,38.9,64,48.89V79.11C64,89.1,72.17,96.91,81.59,95.91Z"]
  },
      bs = {
    prefix: "fas",
    iconName: "fax",
    icon: [512, 512, [], "f1ac", "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"]
  },
      Ss = {
    prefix: "fas",
    iconName: "feather",
    icon: [512, 512, [], "f52d", "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"]
  },
      Ts = {
    prefix: "fas",
    iconName: "feather-alt",
    icon: [512, 512, [], "f56b", "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"]
  },
      Ds = {
    prefix: "fas",
    iconName: "female",
    icon: [256, 512, [], "f182", "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"]
  },
      js = {
    prefix: "fas",
    iconName: "field-hockey",
    icon: [640, 512, [], "f44c", "M560.7 0H628c6.6 0 12 5.4 12 12v124.9c0 3.2-1.3 6.2-3.5 8.5L592 190 479 76.9l73.3-73.3c2.2-2.3 5.2-3.6 8.4-3.6zm-53.4 274.7l50.8-50.8-113-113.1-230.7 231c-30 29.9-75-15.4-45.2-45.3 31.2-31.2 31.2-81.9 0-113.1-31.2-31.2-81.8-31.2-113 0C19.9 219.7 0 267.9 0 319.2c0 106 85.6 192 191.8 192 86.1 0 132.5-53.2 147.4-68-19.3-100.5 68.5-187.6 168.1-168.5zM480.2 320c-53 0-95.9 43-95.9 96s42.9 96 95.9 96 95.9-43 95.9-96-42.9-96-95.9-96z"]
  },
      Es = {
    prefix: "fas",
    iconName: "fighter-jet",
    icon: [640, 512, [], "f0fb", "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"]
  },
      ks = {
    prefix: "fas",
    iconName: "file",
    icon: [384, 512, [], "f15b", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
  },
      Is = {
    prefix: "fas",
    iconName: "file-alt",
    icon: [384, 512, [], "f15c", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
  },
      Os = {
    prefix: "fas",
    iconName: "file-archive",
    icon: [384, 512, [], "f1c6", "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"]
  },
      Qs = {
    prefix: "fas",
    iconName: "file-audio",
    icon: [384, 512, [], "f1c7", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
  },
      Zs = {
    prefix: "fas",
    iconName: "file-certificate",
    icon: [512, 512, [], "f5f3", "M504.99 105.01l-97.9-98c-7.71-7.71-16-7-23.1-7v128h128c0-7.53.64-15.35-7-23zm-153 31V.01H152c-13.3 0-24 10.7-24 24V133c18.3-5 19.58-5 26.45-5 16.23 0 32.1 6.67 43.53 18.3 8.72 9.59 4.41 6.98 18.28 10.76 21.07 5.75 37.64 22.53 43.23 43.8 3.11 13.2.6 8.66 10.75 18.99 15.25 15.51 21.26 38.26 15.7 59.36-3.75 13.23-3.71 8.01 0 22.12 5.57 21.11-.45 43.85-15.69 59.37-9.64 9.36-7.04 4.88-10.75 18.99-4.89 18.59-18.16 33.75-35.5 41.12V512h263.99c13.3 0 24-10.7 24-24V160.01h-136c-13.2 0-24-10.8-24-24zM247.42 338.28c7.4-7.53 10.29-18.5 7.58-28.79-5.43-20.65-5.44-17.74 0-38.42 2.71-10.28-.18-21.26-7.58-28.79-14.86-15.12-13.43-12.61-18.87-33.27-2.71-10.28-10.6-18.32-20.71-21.07-20.28-5.53-17.84-4.1-32.69-19.21-7.4-7.53-18.18-10.47-28.28-7.71-20.32 5.54-17.46 5.53-37.75 0-10.1-2.76-20.88.19-28.28 7.71-14.91 15.18-12.5 13.7-32.69 19.21-10.11 2.76-18 10.79-20.71 21.07-5.46 20.74-4 18.13-18.87 33.27-7.4 7.53-10.29 18.5-7.58 28.79 5.45 20.71 5.42 17.79 0 38.41-2.71 10.28.18 21.26 7.58 28.79 14.85 15.11 13.43 12.61 18.87 33.27 2.71 10.28 10.6 18.32 20.71 21.07 14.31 3.9 11.52 2.97 15.84 5V512l64-32 64 32V397.62c4.31-2.02 1.52-1.1 15.84-5 10.11-2.76 18-10.79 20.71-21.07 5.47-20.74 4.01-18.13 18.88-33.27zM128 352.01c-35.34 0-64-28.65-64-64s28.66-64 64-64 64 28.65 64 64-28.66 64-64 64z"]
  },
      Us = {
    prefix: "fas",
    iconName: "file-chart-line",
    icon: [384, 512, [], "f659", "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 299.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-70.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v70.4zm96 0c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V236.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v198.4zm32-134.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v134.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V300.8z"]
  },
      Bs = {
    prefix: "fas",
    iconName: "file-chart-pie",
    icon: [384, 512, [], "f65a", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-87.49 302.53c-28.73-11.16-51.87-34.3-63.04-63.03C43.42 298.14 90.91 224.8 160 210.66V352h141.34c-14.14 69.09-87.48 116.58-164.83 86.53zm175.63-118.55c0 .01.01.02 0 .02H192V199.86c0-.01.01 0 .02 0 66.34.01 120.11 53.78 120.12 120.12zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
  },
      Rs = {
    prefix: "fas",
    iconName: "file-check",
    icon: [384, 512, [], "f316", "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160h136v328c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V24C0 10.745 10.745 0 24 0h200v136c0 13.2 10.8 24 24 24zm65.296 109.732l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L162.12 346.45l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068L70.772 328.2c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"]
  },
      Ys = {
    prefix: "fas",
    iconName: "file-code",
    icon: [384, 512, [], "f1c9", "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"]
  },
      Ps = {
    prefix: "fas",
    iconName: "file-contract",
    icon: [384, 512, [], "f56c", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
  },
      Fs = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [384, 512, [], "f6dd", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
  },
      Ws = {
    prefix: "fas",
    iconName: "file-download",
    icon: [384, 512, [], "f56d", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
  },
      Gs = {
    prefix: "fas",
    iconName: "file-edit",
    icon: [384, 512, [], "f31c", "M384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-59.6 109.6l-95 95-5.4 48.2c-.7 6.4 4.7 11.9 11.2 11.2l48.2-5.4 95-95c2-2 2-5.2 0-7.2l-46.8-46.8c-2-2-5.2-2-7.2 0zm109.7-30.3l-25.4-25.4c-7.9-7.9-20.7-7.9-28.6 0l-26 26c-2 2-2 5.2 0 7.2l46.8 46.8c2 2 5.2 2 7.2 0l26-26c7.9-7.9 7.9-20.7 0-28.6z"]
  },
      qs = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
  },
      Js = {
    prefix: "fas",
    iconName: "file-exclamation",
    icon: [384, 512, [], "f31a", "M384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9zm0 38.1v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24h136zm-231.2 60.8l7.2 112c.4 6.3 5.6 11.2 12 11.2h40c6.3 0 11.6-4.9 12-11.2l7.2-112c.4-6.9-5-12.8-12-12.8h-54.4c-6.9 0-12.4 5.8-12 12.8zM232 400c0-22.1-17.9-40-40-40s-40 17.9-40 40 17.9 40 40 40 40-17.9 40-40z"]
  },
      Ks = {
    prefix: "fas",
    iconName: "file-export",
    icon: [576, 512, [], "f56e", "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"]
  },
      Xs = {
    prefix: "fas",
    iconName: "file-image",
    icon: [384, 512, [], "f1c5", "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"]
  },
      _s = {
    prefix: "fas",
    iconName: "file-import",
    icon: [512, 512, [], "f56f", "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"]
  },
      $s = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"]
  },
      cu = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"]
  },
      eu = {
    prefix: "fas",
    iconName: "file-medical",
    icon: [384, 512, [], "f477", "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"]
  },
      au = {
    prefix: "fas",
    iconName: "file-medical-alt",
    icon: [448, 512, [], "f478", "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
  },
      nu = {
    prefix: "fas",
    iconName: "file-minus",
    icon: [384, 512, [], "f318", "M377,105,279.1,7a24,24,0,0,0-17-7H256V128H384v-6.1A23.92,23.92,0,0,0,377,105ZM224,136V0H24A23.94,23.94,0,0,0,0,24V488a23.94,23.94,0,0,0,24,24H360a23.94,23.94,0,0,0,24-24V160H248A24.07,24.07,0,0,1,224,136Zm72,176v16a16,16,0,0,1-16,16H104a16,16,0,0,1-16-16V312a16,16,0,0,1,16-16H280A16,16,0,0,1,296,312Z"]
  },
      tu = {
    prefix: "fas",
    iconName: "file-music",
    icon: [384, 512, [], "f8b6", "M224 136V0H24A23.94 23.94 0 0 0 0 24v464a23.94 23.94 0 0 0 24 24h336a23.94 23.94 0 0 0 24-24V160H248a24.08 24.08 0 0 1-24-24zm64 88v160c0 17.67-21.5 32-48 32s-48-14.33-48-32 21.5-32 48-32a69.89 69.89 0 0 1 16 2v-76.36l-96 37.52V416c0 17.67-21.5 32-48 32s-48-14.33-48-32 21.5-32 48-32a69.89 69.89 0 0 1 16 2V271.25A16 16 0 0 1 139.19 256l128-47.25A16 16 0 0 1 288 224zm89-119L279.09 7a24 24 0 0 0-17-7H256v128h128v-6.09a23.91 23.91 0 0 0-7-16.91z"]
  },
      ru = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [384, 512, [], "f1c1", "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"]
  },
      iu = {
    prefix: "fas",
    iconName: "file-plus",
    icon: [384, 512, [], "f319", "M377,105,279.1,7a24,24,0,0,0-17-7H256V128H384v-6.1A23.92,23.92,0,0,0,377,105ZM224,136V0H24A23.94,23.94,0,0,0,0,24V488a23.94,23.94,0,0,0,24,24H360a23.94,23.94,0,0,0,24-24V160H248A24.07,24.07,0,0,1,224,136Zm72,176v16a16,16,0,0,1-16,16H216v64a16,16,0,0,1-16,16H184a16,16,0,0,1-16-16V344H104a16,16,0,0,1-16-16V312a16,16,0,0,1,16-16h64V232a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64A16,16,0,0,1,296,312Z"]
  },
      ou = {
    prefix: "fas",
    iconName: "file-powerpoint",
    icon: [384, 512, [], "f1c4", "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"]
  },
      lu = {
    prefix: "fas",
    iconName: "file-prescription",
    icon: [384, 512, [], "f572", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
  },
      fu = {
    prefix: "fas",
    iconName: "file-search",
    icon: [640, 512, [], "f865", "M288 320c0-65.45 39.59-121.68 96-146.44V160H248a24.07 24.07 0 0 1-24-24V0H24A23.94 23.94 0 0 0 0 24v464a23.94 23.94 0 0 0 24 24h336a23.94 23.94 0 0 0 24-24v-21.56c-56.41-24.75-96-80.99-96-146.44zm96-198.1a23.92 23.92 0 0 0-7-16.9L279.1 7a24 24 0 0 0-17-7H256v128h128zm251.31 340.16l-77.41-77.41A126.69 126.69 0 0 0 576 320a128 128 0 1 0-128 128c23.7 0 45.61-6.88 64.65-18.11l77.41 77.42a16 16 0 0 0 22.63 0l22.62-22.62a16 16 0 0 0 0-22.63zM448 384a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"]
  },
      su = {
    prefix: "fas",
    iconName: "file-signature",
    icon: [576, 512, [], "f573", "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"]
  },
      uu = {
    prefix: "fas",
    iconName: "file-spreadsheet",
    icon: [384, 512, [], "f65b", "M296 368h-48v48h48v-48zm-80-80h-48v48h48v-48zm80 0h-48v48h48v-48zm-80 80h-48v48h48v-48zm8-232V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm104 104v192c0 8.84-7.16 16-16 16H72c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h240c8.84 0 16 7.16 16 16zm49-135L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM136 288H88v48h48v-48zm0 80H88v48h48v-48z"]
  },
      hu = {
    prefix: "fas",
    iconName: "file-times",
    icon: [384, 512, [], "f317", "M224,136V0H24A23.94,23.94,0,0,0,0,24V488a23.94,23.94,0,0,0,24,24H360a23.94,23.94,0,0,0,24-24V160H248A24.07,24.07,0,0,1,224,136Zm35.88,104.8,11.32,11.32a16,16,0,0,1,0,22.63L225.94,320l45.26,45.25a16,16,0,0,1,0,22.63L259.88,399.2a16,16,0,0,1-22.63,0L192,353.94,146.75,399.2a16,16,0,0,1-22.63,0L112.8,387.88a16,16,0,0,1,0-22.63L158.06,320,112.8,274.75a16,16,0,0,1,0-22.63l11.32-11.32a16,16,0,0,1,22.63,0L192,286.06l45.25-45.26A16,16,0,0,1,259.88,240.8ZM377,105,279.1,7a24,24,0,0,0-17-7H256V128H384v-6.1A23.92,23.92,0,0,0,377,105Z"]
  },
      mu = {
    prefix: "fas",
    iconName: "file-upload",
    icon: [384, 512, [], "f574", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
  },
      vu = {
    prefix: "fas",
    iconName: "file-user",
    icon: [384, 512, [], "f65c", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm80 273.6v19.2c0 10.61-10.03 19.2-22.4 19.2H102.4c-12.37 0-22.4-8.6-22.4-19.2v-19.2c0-31.81 30.09-57.6 67.2-57.6h4.95c12.29 5.12 25.73 8 39.85 8s27.56-2.88 39.85-8h4.95c37.11 0 67.2 25.79 67.2 57.6zM192 320c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm185-215L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"]
  },
      du = {
    prefix: "fas",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"]
  },
      Mu = {
    prefix: "fas",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"]
  },
      pu = {
    prefix: "fas",
    iconName: "files-medical",
    icon: [448, 512, [], "f7fd", "M96 392V96H24a24 24 0 0 0-24 24v368a24 24 0 0 0 24 24h272a24 24 0 0 0 24-24v-40H152a56.06 56.06 0 0 1-56-56zm224-288V0H152a24 24 0 0 0-24 24v368a24 24 0 0 0 24 24h272a24 24 0 0 0 24-24V128H344a24.07 24.07 0 0 1-24-24zm64 128v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm57-159L375 7a24 24 0 0 0-17-7h-6v96h96v-6.06A24 24 0 0 0 441 73z"]
  },
      zu = {
    prefix: "fas",
    iconName: "fill",
    icon: [512, 512, [], "f575", "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"]
  },
      Cu = {
    prefix: "fas",
    iconName: "fill-drip",
    icon: [576, 512, [], "f576", "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"]
  },
      Lu = {
    prefix: "fas",
    iconName: "film",
    icon: [512, 512, [], "f008", "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"]
  },
      Au = {
    prefix: "fas",
    iconName: "film-alt",
    icon: [512, 512, [], "f3a0", "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm384 192c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"]
  },
      Nu = {
    prefix: "fas",
    iconName: "film-canister",
    icon: [576, 512, [], "f8b7", "M544 128H352v288h128a32 32 0 0 0 32-32v-32a32 32 0 0 1 32-32 32 32 0 0 0 32-32V160a32 32 0 0 0-32-32zM440 360a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16zm0-160a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16zm96 0a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16zM336 448h-16V96h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-80V16a16 16 0 0 0-16-16H112a16 16 0 0 0-16 16v16H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h16v352H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      gu = {
    prefix: "fas",
    iconName: "filter",
    icon: [512, 512, [], "f0b0", "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"]
  },
      Hu = {
    prefix: "fas",
    iconName: "fingerprint",
    icon: [512, 512, [], "f577", "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"]
  },
      Vu = {
    prefix: "fas",
    iconName: "fire",
    icon: [384, 512, [], "f06d", "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"]
  },
      xu = {
    prefix: "fas",
    iconName: "fire-alt",
    icon: [448, 512, [], "f7e4", "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"]
  },
      wu = {
    prefix: "fas",
    iconName: "fire-extinguisher",
    icon: [448, 512, [], "f134", "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"]
  },
      yu = {
    prefix: "fas",
    iconName: "fire-smoke",
    icon: [640, 512, [], "f74b", "M528 288c-37.1 0-69.7 18.3-90.1 46.1C418.4 288.2 373 256 320 256s-98.4 32.2-117.9 78.1c-20.4-27.8-53-46.1-90.1-46.1C50.1 288 0 338.1 0 400s50.1 112 112 112h416c61.9 0 112-50.1 112-112s-50.1-112-112-112zm-332.3-4.8c9.7-12 21.3-22.3 33.9-31-4.7-11.6-7.4-24.7-7.4-39.3 0-29.8 18.2-56.1 54.4-101.1 5.2 6.2 73.8 96.9 73.8 96.9l43.8-51.7c3.1 5.3 5.9 10.5 8.4 15.4 12.4 24.5 13.9 53.1 5.1 77.8 13.7 9 26.1 20 36.5 32.8 13.5-9.7 28.6-16.7 44.5-21.3 4.6-15.5 7.2-31.9 7.2-48.9 0-40.3-40.8-123.4-97.8-174.2C381.8 53.2 367 68.5 353.9 84 332.6 55.7 306.1 26.9 276 0c-77.2 68.9-132 158.8-132 213 0 17 2.6 33.4 7.2 48.9 15.9 4.6 31 11.6 44.5 21.3z"]
  },
      bu = {
    prefix: "fas",
    iconName: "fireplace",
    icon: [640, 512, [], "f79a", "M32 512h96V384c0-106 86-192 192-192s192 86 192 192v128h96V128H32v384zm310.3-200.4c-14-18.8-31.4-37.8-51.1-55.6-50.5 45.6-86.4 105-86.4 140.8 0 63.6 51.6 115.2 115.2 115.2s115.2-51.6 115.2-115.2c0-26.6-26.7-81.6-64-115.2-10.7 9.6-20.4 19.8-28.9 30zm15.5 136.9c-10.6 7.7-23.7 12.3-37.8 12.3-35.3 0-64-24.4-64-64 0-19.7 11.9-37.1 35.6-66.8 3.4 4.1 48.3 64.1 48.3 64.1l28.7-34.2c2 3.5 3.9 6.9 5.5 10.2 13.4 26.6 7.8 60.8-16.3 78.4zM624 0H16C7.2 0 0 7.2 0 16v64c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16z"]
  },
      Su = {
    prefix: "fas",
    iconName: "first-aid",
    icon: [576, 512, [], "f479", "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"]
  },
      Tu = {
    prefix: "fas",
    iconName: "fish",
    icon: [576, 512, [], "f578", "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"]
  },
      Du = {
    prefix: "fas",
    iconName: "fish-cooked",
    icon: [640, 512, [], "f7fe", "M363.44 64c-100 0-187.26 65.72-235.85 122l-97-79.26C17.08 95.68-3 107.42.4 124.29L27.27 256 .39 387.73C-3 404.6 17.07 416.32 30.54 405.32l97-79.26C176.17 382.28 263.48 448 363.44 448 516.18 448 640 294.4 640 256S516.18 64 363.44 64zM245.66 261.65l-11.31-11.31a8 8 0 0 1 0-11.31L319 154.34a8 8 0 0 1 11.32 0l11.31 11.31a8 8 0 0 1 0 11.32L257 261.65a8 8 0 0 1-11.34 0zm59.31 80a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L431 170.34a8 8 0 0 1 11.32 0l11.31 11.31a8 8 0 0 1 0 11.32zM501.66 273L417 357.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L479 250.34a8 8 0 0 1 11.32 0l11.31 11.31a8 8 0 0 1 .03 11.35z"]
  },
      ju = {
    prefix: "fas",
    iconName: "fist-raised",
    icon: [384, 512, [], "f6de", "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"]
  },
      Eu = {
    prefix: "fas",
    iconName: "flag",
    icon: [512, 512, [], "f024", "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"]
  },
      ku = {
    prefix: "fas",
    iconName: "flag-alt",
    icon: [512, 512, [], "f74c", "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm430.6 4.2C291.3 91.5 305.4-62.2 96 32.4V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8V30.8c0-25.1-26.8-38.1-49.4-26.6z"]
  },
      Iu = {
    prefix: "fas",
    iconName: "flag-checkered",
    icon: [512, 512, [], "f11e", "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"]
  },
      Ou = {
    prefix: "fas",
    iconName: "flag-usa",
    icon: [512, 512, [], "f74d", "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"]
  },
      Qu = {
    prefix: "fas",
    iconName: "flame",
    icon: [384, 512, [], "f6df", "M192 0C79.7 101.33 0 220.92 0 300.55 0 425.05 78.95 512 192 512s192-86.95 192-211.45C384 220.6 303.78 100.86 192 0zm0 448c-70.58 0-128-52.89-128-117.89 0-44.13 25.84-71.51 34.34-79.76 3.12-3.12 8.19-3.12 11.31 0a7.98 7.98 0 0 1 2.34 5.66v40c0 30.93 25.07 56 56 56s56-25.07 56-56c0-72-112.64-64.77-39.43-164.33 2.89-3.93 7.48-4.16 10.58-3.17 1.62.53 5.38 2.24 5.38 6.78 0 33.55 25.05 54.97 51.57 77.63 33.38 28.54 67.9 58.04 67.9 117.21C320 395.11 262.58 448 192 448z"]
  },
      Zu = {
    prefix: "fas",
    iconName: "flashlight",
    icon: [640, 512, [], "f8b8", "M384 160H32a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h352l16.12 10.75c43.14 28.76 92.62 45.67 143.88 50.89V98.36c-51.26 5.22-100.74 22.13-143.88 50.89zm-96 128h-32a32 32 0 0 1 0-64h32a32 32 0 0 1 0 64zM608 96h-32v320h32a32 32 0 0 0 32-32V128a32 32 0 0 0-32-32z"]
  },
      Uu = {
    prefix: "fas",
    iconName: "flask",
    icon: [448, 512, [], "f0c3", "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"]
  },
      Bu = {
    prefix: "fas",
    iconName: "flask-poison",
    icon: [416, 512, [], "f6e0", "M80 48V16c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16zm88 240c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm247.95 68.67c-1.14 51.68-21.15 98.7-53.39 134.48-12.09 13.41-29.52 20.85-47.58 20.85H100.94c-17.78 0-35.05-7.13-47-20.3C20.43 454.79 0 405.79 0 352c0-80.12 45.61-149.15 112-183.88V96h192v73.05c67.19 36.13 113.71 107.67 111.95 187.62zM320 312c0-48.6-50.14-88-112-88S96 263.4 96 312c0 29.87 19.04 56.17 48 72.08V416c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-31.92c28.96-15.91 48-42.21 48-72.08zm-72-24c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      Ru = {
    prefix: "fas",
    iconName: "flask-potion",
    icon: [416, 512, [], "f6e1", "M415.95 356.67c-1.14 51.68-21.15 98.7-53.39 134.48-12.09 13.41-29.52 20.85-47.58 20.85H100.94c-17.78 0-35.05-7.13-47-20.3C20.43 454.79 0 405.79 0 352c0-80.12 45.61-149.15 112-183.88V96h64v110.86C155.79 217.44 75.67 245.6 65.15 335.42c65.85-32.92 127.64-31.03 181.8-3.95C291.94 353.97 328.27 352 351.8 352c-.27-91.84-75.33-125.09-111.79-144.7V96h64v73.05c67.18 36.13 113.7 107.67 111.94 187.62zM96 64h224c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H96c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16z"]
  },
      Yu = {
    prefix: "fas",
    iconName: "flower",
    icon: [512, 512, [], "f7ff", "M480 160A128 128 0 0 0 352 32c-38.45 0-72.54 17.3-96 44.14C232.54 49.3 198.45 32 160 32A128 128 0 0 0 32 160c0 38.45 17.3 72.54 44.14 96C49.3 279.46 32 313.55 32 352a128 128 0 0 0 128 128c38.45 0 72.54-17.3 96-44.14C279.46 462.7 313.55 480 352 480a128 128 0 0 0 128-128c0-38.45-17.3-72.54-44.14-96C462.7 232.54 480 198.45 480 160zM256 336a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"]
  },
      Pu = {
    prefix: "fas",
    iconName: "flower-daffodil",
    icon: [512, 512, [], "f800", "M495.87 320h-47.26c-63 0-119.82 22.23-160.61 57.92v-96.67A79.8 79.8 0 0 0 367.56 144 79.78 79.78 0 1 0 256 32.44 79.78 79.78 0 1 0 144.44 144 79.81 79.81 0 0 0 224 281.25v96.67C183.21 342.23 126.37 320 63.39 320H16.13c-9.19 0-17 7.72-16.06 16.84C10.06 435 106.43 512 223.83 512h64.34c117.4 0 213.77-77 223.76-175.16.92-9.12-6.87-16.84-16.06-16.84zM256 192a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"]
  },
      Fu = {
    prefix: "fas",
    iconName: "flower-tulip",
    icon: [512, 512, [], "f801", "M495.87 320h-47.26c-63 0-119.82 22.23-160.61 57.92V256a128 128 0 0 0 128-128V32l-80 48-78.86-80L176 80 96 32v96a128 128 0 0 0 128 128v121.92C183.21 342.23 126.37 320 63.39 320H16.13c-9.19 0-17 7.72-16.06 16.84C10.06 435 106.43 512 223.83 512h64.34c117.4 0 213.77-77 223.76-175.16.92-9.12-6.87-16.84-16.06-16.84z"]
  },
      Wu = {
    prefix: "fas",
    iconName: "flushed",
    icon: [496, 512, [], "f579", "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"]
  },
      Gu = {
    prefix: "fas",
    iconName: "flute",
    icon: [640, 512, [], "f8b9", "M0 208v96a32 32 0 0 0 32 32h64V176H32a32 32 0 0 0-32 32zm608-32H128v160h480a32 32 0 0 0 32-32v-96a32 32 0 0 0-32-32zM320 280a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm96 0a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm96 0a24 24 0 1 1 24-24 24 24 0 0 1-24 24z"]
  },
      qu = {
    prefix: "fas",
    iconName: "flux-capacitor",
    icon: [448, 512, [], "f8ba", "M448,112V400a80.15451,80.15451,0,0,1-80,80H80A80.15451,80.15451,0,0,1,0,400V112A80.15451,80.15451,0,0,1,80,32H368A80.15451,80.15451,0,0,1,448,112ZM139.0625,238.82812l-45-44.95312c-7.60938-7.73438-13.78125-22.8125-13.78125-33.65625a48.01238,48.01238,0,0,1,48-48c10.84375,0,25.92187,6.17187,33.65625,13.78125l44.95312,45A96.07,96.07,0,0,0,208,160a80,80,0,1,0-80,80A93.8335,93.8335,0,0,0,139.0625,238.82812ZM208,262.625V352a16,16,0,0,0,32,0V262.625l91.31249-91.3125a18.49794,18.49794,0,0,0,4.39063-11.01562,15.99079,15.99079,0,0,0-16-16,18.498,18.498,0,0,0-11.01563,4.39062L224,233.375l-84.6875-84.6875a18.498,18.498,0,0,0-11.01562-4.39062,15.99079,15.99079,0,0,0-16,16,18.498,18.498,0,0,0,4.39062,11.01562ZM224.23438,432A79.79393,79.79393,0,0,0,304,352.23438c0-22.04688-14.34375-50.67188-32-63.875V352a48,48,0,0,1-96,0V288.35938c-17.65625,13.20312-32,41.82812-32,63.875A79.79393,79.79393,0,0,0,223.76562,432h.46876ZM400,160a80,80,0,0,0-160,0,93.8335,93.8335,0,0,0,1.17188,11.0625l44.95312-45c7.73438-7.60938,22.81249-13.78125,33.65625-13.78125a48.01238,48.01238,0,0,1,48,48c0,10.84375-6.17187,25.92187-13.78125,33.65625l-45,44.95312A96.06972,96.06972,0,0,0,320,240,80.034,80.034,0,0,0,400,160Z"]
  },
      Ju = {
    prefix: "fas",
    iconName: "fog",
    icon: [640, 512, [], "f74e", "M160 320h320c53 0 96-43 96-96s-43-96-96-96c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C320.4 24.8 283.3 0 240 0c-61.9 0-112 50.1-112 112 0 7.3.8 14.3 2.1 21.2C91.8 145.8 64 181.5 64 224c0 53 43 96 96 96zm48 144H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H288c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-48-56v-16c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16z"]
  },
      Ku = {
    prefix: "fas",
    iconName: "folder",
    icon: [512, 512, [], "f07b", "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"]
  },
      Xu = {
    prefix: "fas",
    iconName: "folder-download",
    icon: [512, 512, [], "e053", "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM364.44,283.36,268,379.06a17.05,17.05,0,0,1-24,0l-96.42-95.7A16,16,0,0,1,158.81,256H224V208a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16v48h65.18A16,16,0,0,1,364.44,283.36Z"]
  },
      _u = {
    prefix: "fas",
    iconName: "folder-minus",
    icon: [512, 512, [], "f65d", "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"]
  },
      $u = {
    prefix: "fas",
    iconName: "folder-open",
    icon: [576, 512, [], "f07c", "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"]
  },
      ch = {
    prefix: "fas",
    iconName: "folder-plus",
    icon: [512, 512, [], "f65e", "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"]
  },
      eh = {
    prefix: "fas",
    iconName: "folder-times",
    icon: [512, 512, [], "f65f", "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zM340.85 338.91c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L256 321.94l-50.91 50.91c-6.25 6.25-16.38 6.25-22.63 0l-11.31-11.31c-6.25-6.25-6.25-16.38 0-22.63L222.06 288l-50.91-50.91c-6.25-6.25-6.25-16.38 0-22.63l11.31-11.31c6.25-6.25 16.38-6.25 22.63 0L256 254.06l50.91-50.91c6.25-6.25 16.38-6.25 22.63 0l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63L289.94 288l50.91 50.91z"]
  },
      ah = {
    prefix: "fas",
    iconName: "folder-tree",
    icon: [576, 512, [], "f802", "M544 32H432L400 0h-80a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm0 288H432l-32-32h-80a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V352a32 32 0 0 0-32-32zM64 16A16 16 0 0 0 48 0H16A16 16 0 0 0 0 16v400a32 32 0 0 0 32 32h224v-64H64V160h192V96H64z"]
  },
      nh = {
    prefix: "fas",
    iconName: "folder-upload",
    icon: [512, 512, [], "e054", "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM353.19,320H288v48a16,16,0,0,1-16,16H240a16,16,0,0,1-16-16V320H158.83a16,16,0,0,1-11.27-27.34L244,197a17.05,17.05,0,0,1,24,0l96.42,95.7A16,16,0,0,1,353.19,320Z"]
  },
      th = {
    prefix: "fas",
    iconName: "folders",
    icon: [640, 512, [], "f660", "M96 336V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48v-48H176c-44.11 0-80-35.89-80-80zM592 64H400L336 0H176c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48z"]
  },
      rh = {
    prefix: "fas",
    iconName: "font",
    icon: [448, 512, [], "f031", "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"]
  },
      ih = {
    prefix: "fas",
    iconName: "font-awesome-logo-full",
    icon: [3992, 512, ["Font Awesome"], "f4e6", "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"]
  },
      oh = {
    prefix: "fas",
    iconName: "font-case",
    icon: [640, 512, [], "f866", "M229.88 85.69A32 32 0 0 0 199.58 64h-47.16a32 32 0 0 0-30.3 21.69L.85 426.89A16 16 0 0 0 16 448h50.62a16 16 0 0 0 15.16-10.89L100.85 384h150.3l19.07 53.11A16 16 0 0 0 285.38 448H336a16 16 0 0 0 15.16-21.11zM129.58 304L176 174.74 222.42 304zM624 160h-32a16 16 0 0 0-16 16v1.81c-18.9-11-40.58-17.81-64-17.81a128.14 128.14 0 0 0-128 128v32a128.14 128.14 0 0 0 128 128c23.42 0 45.1-6.78 64-17.81V432a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V176a16 16 0 0 0-16-16zm-64 160a48 48 0 0 1-96 0v-32a48 48 0 0 1 96 0z"]
  },
      lh = {
    prefix: "fas",
    iconName: "football-ball",
    icon: [496, 512, [], "f44e", "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"]
  },
      fh = {
    prefix: "fas",
    iconName: "football-helmet",
    icon: [512, 512, [], "f44f", "M480 320H355.5l-15.2-76 136.8-17.8c9-1.2 15.6-9.8 13.9-18.7C466.2 82.6 347.9-8.6 211.9 10.6 104.6 25.7 17.8 112.6 2.6 219.9-7.6 292 13.3 359 53.7 409.9c3.1 3.9 7.8 6.1 12.8 6.1H120l85.7 45c25.2 12.6 55.7 7.7 75.7-12.3 36.2-36.2 10.9-81.9 5-96.7h42.9l9.5 47.3c9.5 47.4 48 85.3 95.9 91.3 44 5.5 42.5 5.4 45.3 5.4 22.5 0 32-19.7 32-32V352c0-17.7-14.3-32-32-32zm-304 40c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm97.6-40l-10.3-25.7c-7.8-19.4 4.9-40.9 25.6-43.6l19.6-2.6 14.4 71.9h-49.3zM480 464l-41.3-5.2c-25.9-3.2-48-18.7-60.1-40.7H480V464zm0-80H368.3l-6.4-32H480v32z"]
  },
      sh = {
    prefix: "fas",
    iconName: "forklift",
    icon: [640, 512, [], "f47a", "M624 384h-80V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM416 237.1c0-8.7-1.8-17.2-5.2-25.2L332.5 29.1C324.9 11.4 307.6 0 288.3 0H144c-26.5 0-48 21.5-48 48v112H48c-26.5 0-48 21.5-48 48v208c0 53 43 96 96 96s96-43 96-96h64c0 53 43 96 96 96s96-43 96-96c0-28.3-12.5-53.5-32-71.1V237.1zM96 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm160-208l-96-96V64h117.8L352 237.1V256h-96zm96 208c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      uh = {
    prefix: "fas",
    iconName: "forward",
    icon: [512, 512, [], "f04e", "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"]
  },
      hh = {
    prefix: "fas",
    iconName: "fragile",
    icon: [288, 512, [], "f4bb", "M287.4 192.7l-16-178.1C270.7 6.3 263.9 0 255.7 0h-63.5l30.6 63.7-85.5 56L186.7 224 65.2 104.3l85.5-56L117.9 0H32.3c-8.2 0-15 6.3-15.7 14.6L.6 192.7c-7.2 80 50.7 148.9 127.4 157.6V480H74.1c-24.5 0-33.2 32-20 32h179.8c13.1 0 4.5-32-20-32H160V350.3c76.7-8.8 134.6-77.6 127.4-157.6z"]
  },
      mh = {
    prefix: "fas",
    iconName: "french-fries",
    icon: [512, 512, [], "f803", "M432 224h-34c-6.92 0-13.7 4.27-15.19 11-8.6 39-62.09 69-126.79 69s-118.19-30-126.79-69c-1.49-6.76-8.27-11-15.19-11H80a16 16 0 0 0-15.62 19.47l54.1 243.47A32 32 0 0 0 149.73 512h212.54a32 32 0 0 0 31.24-25.06l54.1-243.47A16 16 0 0 0 432 224zm-80.45 4.14c.4-1.78 1.46-3.22 2.06-4.91l30.14-172.46a16 16 0 0 0-20.34-18.08l-34.28 10.25c-4.24 1.27-7.17 4.51-9.13 8.33v207.27c17.55-8.38 29.15-19.54 31.54-30.4zm79.9-36.14l16.3-93.23a16 16 0 0 0-20.34-18.08l-17.31 5.17-18.75 107.26c2.24-.32 4.33-1.12 6.63-1.12zM288 268.78V32a16 16 0 0 0-8.84-14.31l-32-16A16 16 0 0 0 224 16v252.78a160.62 160.62 0 0 0 64 0zM114 192c3.6 0 7 1 10.35 1.75l-20-107.16-19.74-5.9a16 16 0 0 0-20.36 18.08L80.55 192zm78 66.54V33.17l-3.76-20.1a16 16 0 0 0-25.39-9.81l-28.51 21.62a16 16 0 0 0-6.07 15.69l36.9 197.22c5.3 7.58 14.49 14.86 26.83 20.75z"]
  },
      vh = {
    prefix: "fas",
    iconName: "frog",
    icon: [576, 512, [], "f52e", "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"]
  },
      dh = {
    prefix: "fas",
    iconName: "frosty-head",
    icon: [384, 512, [], "f79b", "M320 16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v192h256V16zm48 224H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24.4C29.9 310.1 24 334.8 24 360.9c0 59.9 31.3 112.1 78.2 142 10.2 6.5 22.5 9.1 34.6 9.1h109.6c14.7 0 29.1-4.6 41.1-13 51.4-35.8 82.2-99.4 69.5-169.6-2.6-14.5-7.5-28.3-13.7-41.4H368c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM130.7 362.7c-11.8 0-21.3-9.6-21.3-21.3 0-11.8 9.6-21.3 21.3-21.3 11.8 0 21.3 9.6 21.3 21.3 0 11.7-9.6 21.3-21.3 21.3zM192 464s-32-46.3-32-64c0-17.7 14.3-32 32-32s32 14.3 32 32-32 64-32 64zm61.3-101.3c-11.8 0-21.3-9.6-21.3-21.3 0-11.8 9.6-21.3 21.3-21.3 11.8 0 21.3 9.6 21.3 21.3.1 11.7-9.5 21.3-21.3 21.3z"]
  },
      Mh = {
    prefix: "fas",
    iconName: "frown",
    icon: [496, 512, [], "f119", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"]
  },
      ph = {
    prefix: "fas",
    iconName: "frown-open",
    icon: [496, 512, [], "f57a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      zh = {
    prefix: "fas",
    iconName: "function",
    icon: [640, 512, [], "f661", "M288.73 320c0-52.34 16.96-103.22 48.01-144.95 5.17-6.94 4.45-16.54-2.15-22.14l-24.69-20.98c-7-5.95-17.83-5.09-23.38 2.23C246.09 187.42 224 252.78 224 320c0 67.23 22.09 132.59 62.52 185.84 5.56 7.32 16.38 8.18 23.38 2.23l24.69-20.99c6.59-5.61 7.31-15.2 2.15-22.14-31.06-41.71-48.01-92.6-48.01-144.94zM224 16c0-8.84-7.16-16-16-16h-48C102.56 0 56 46.56 56 104v64H16c-8.84 0-16 7.16-16 16v48c0 8.84 7.16 16 16 16h40v128c0 13.2-10.8 24-24 24H16c-8.84 0-16 7.16-16 16v48c0 8.84 7.16 16 16 16h16c57.44 0 104-46.56 104-104V248h40c8.84 0 16-7.16 16-16v-48c0-8.84-7.16-16-16-16h-40v-64c0-13.2 10.8-24 24-24h48c8.84 0 16-7.16 16-16V16zm353.48 118.16c-5.56-7.32-16.38-8.18-23.38-2.23l-24.69 20.98c-6.59 5.61-7.31 15.2-2.15 22.14 31.05 41.71 48.01 92.61 48.01 144.95 0 52.34-16.96 103.23-48.01 144.95-5.17 6.94-4.45 16.54 2.15 22.14l24.69 20.99c7 5.95 17.83 5.09 23.38-2.23C617.91 452.57 640 387.22 640 320c0-67.23-22.09-132.59-62.52-185.84zm-54.17 231.9L477.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L432 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L386.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L432 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63z"]
  },
      Ch = {
    prefix: "fas",
    iconName: "funnel-dollar",
    icon: [640, 512, [], "f662", "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"]
  },
      Lh = {
    prefix: "fas",
    iconName: "futbol",
    icon: [512, 512, [], "f1e3", "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"]
  },
      Ah = {
    prefix: "fas",
    iconName: "galaxy",
    icon: [512, 512, [], "e008", "M506.578,274.10351C489.78116,202.99807,431.23821,146.26567,359.5898,131.959a194.38794,194.38794,0,0,0-101.80269,6.61719,143.73889,143.73889,0,0,1,85.51364-110.7441C356.6152,22.13681,353.61715,2.41416,339.207.963a196.56477,196.56477,0,0,0-65.10349,4.459C202.99807,22.21884,146.26567,80.76179,131.959,152.4102a194.38794,194.38794,0,0,0,6.61719,101.80269,143.73889,143.73889,0,0,1-110.7441-85.51364C22.13681,155.3848,2.41416,158.38285.963,172.793a196.56477,196.56477,0,0,0,4.459,65.10349C22.21884,309.00193,80.76179,365.73433,152.4102,380.041a194.38794,194.38794,0,0,0,101.80269-6.61719,143.73889,143.73889,0,0,1-85.51364,110.7441c-13.31445,5.69531-10.3164,25.418,4.09375,26.86913a196.56477,196.56477,0,0,0,65.10349-4.459C309.00193,489.78116,365.73433,431.23821,380.041,359.5898a194.38794,194.38794,0,0,0-6.61719-101.80269,143.73889,143.73889,0,0,1,110.7441,85.51364c5.69531,13.31445,25.418,10.3164,26.86913-4.09375A196.56477,196.56477,0,0,0,506.578,274.10351ZM256,304a48,48,0,1,1,48-48A47.99985,47.99985,0,0,1,256,304Z"]
  },
      Nh = {
    prefix: "fas",
    iconName: "game-board",
    icon: [512, 512, [], "f867", "M256 160h-96v96h96zm0 192h96v-96h-96zM480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm-32 160h-96v96h96v96h-96v96h-96v-96h-96v96H64v-96h96v-96H64v-96h96V64h96v96h96V64h96z"]
  },
      gh = {
    prefix: "fas",
    iconName: "game-board-alt",
    icon: [512, 512, [], "f868", "M480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm-32 256H256v192H64V256h192V64h192z"]
  },
      Hh = {
    prefix: "fas",
    iconName: "game-console-handheld",
    icon: [384, 512, [], "f8bb", "M352 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h256a96 96 0 0 0 96-96V32a32 32 0 0 0-32-32zM160 344a8 8 0 0 1-8 8h-24v24a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8v-24H72a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h24v-24a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v24h24a8 8 0 0 1 8 8zm72 40a24 24 0 1 1 24-24 24 24 0 0 1-24 24zM112 224a16 16 0 0 1-16-16V80a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v112a32 32 0 0 1-32 32zm184 112a24 24 0 1 1 24-24 24 24 0 0 1-24 24z"]
  },
      Vh = {
    prefix: "fas",
    iconName: "gamepad",
    icon: [640, 512, [], "f11b", "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"]
  },
      xh = {
    prefix: "fas",
    iconName: "gamepad-alt",
    icon: [640, 512, [], "f8bc", "M638.59 368.22l-33.37-211.59c-8.86-50.26-48.4-90.77-100.66-103.13h-.07a803.19 803.19 0 0 0-369 0C83.17 65.86 43.64 106.36 34.78 156.63L1.41 368.22C-8.9 426.73 38.8 480 101.51 480c49.67 0 93.77-30.07 109.48-74.64l7.52-21.36h203l7.49 21.36C444.72 449.93 488.82 480 538.49 480c62.71 0 110.41-53.27 100.1-111.78zM280 236a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52h-52a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm152 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"]
  },
      wh = {
    prefix: "fas",
    iconName: "garage",
    icon: [640, 512, [], "e009", "M128,512H512V352H128.11Zm144-96h96a16,16,0,0,1,0,32H272a16,16,0,0,1,0-32ZM128,320H511.47l.53-96H128S128,320,128,320ZM610.5,117,338.41,3.67A57.4,57.4,0,0,0,320,0,57.4,57.4,0,0,0,301.5,3.67L29.5,117A48.11,48.11,0,0,0,0,161.28V496a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V224c0-17.59,14.59-32,32.59-32H511.41c18,0,32.59,14.41,32.59,32V496a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V161.28A48.11,48.11,0,0,0,610.5,117Z"]
  },
      yh = {
    prefix: "fas",
    iconName: "garage-car",
    icon: [640, 512, [], "e00a", "M610.5,117,338.41,3.67A57.4,57.4,0,0,0,320,0,57.4,57.4,0,0,0,301.5,3.67L29.5,117A48.11,48.11,0,0,0,0,161.28V496a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V224c0-17.59,14.59-32,32.59-32H511.41c18,0,32.59,14.41,32.59,32V496a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V161.28A48.11,48.11,0,0,0,610.5,117Zm-145,238.42-15.75-63A69.09,69.09,0,0,0,382.61,240H257.39a69.09,69.09,0,0,0-67.11,52.39l-15.75,63A47.9,47.9,0,0,0,144,400v32c0,11.72,6.61,21.52,16,27.1V488a24,24,0,0,0,24,24h32a24,24,0,0,0,24-24V464H400v24a24,24,0,0,0,24,24h32a24,24,0,0,0,24-24V459.1c9.39-5.58,16-15.38,16-27.1V400A47.9,47.9,0,0,0,465.47,355.4ZM236.84,304.05A21.15,21.15,0,0,1,257.39,288H382.61a21.15,21.15,0,0,1,20.55,16.05l12,47.95H224.86ZM208,431.85c-14.4,0-24-9.56-24-23.92S193.6,384,208,384s36,21.53,36,35.89S222.4,431.85,208,431.85Zm224,0c-14.4,0-36,2.39-36-12S417.6,384,432,384s24,9.58,24,23.93S446.4,431.85,432,431.85Z"]
  },
      bh = {
    prefix: "fas",
    iconName: "garage-open",
    icon: [640, 512, [], "e00b", "M128,224v64H511.47l.53-64S128,224,128,224ZM465.47,355.4,456.62,320H407.14l8,32H224.86l8-32H183.38l-8.85,35.4A47.9,47.9,0,0,0,144,400v32c0,11.72,6.61,21.52,16,27.1V488a24,24,0,0,0,24,24h32a24,24,0,0,0,24-24V464H400v24a24,24,0,0,0,24,24h32a24,24,0,0,0,24-24V459.1c9.39-5.58,16-15.38,16-27.1V400A47.9,47.9,0,0,0,465.47,355.4ZM208,431.85c-14.4,0-24-9.56-24-23.92S193.6,384,208,384s36,21.53,36,35.89S222.4,431.85,208,431.85Zm224,0c-14.4,0-36,2.39-36-12S417.6,384,432,384s24,9.58,24,23.93S446.4,431.85,432,431.85ZM610.5,117,338.41,3.67A57.4,57.4,0,0,0,320,0,57.4,57.4,0,0,0,301.5,3.67L29.5,117A48.11,48.11,0,0,0,0,161.28V496a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V224c0-17.59,14.59-32,32.59-32H511.41c18,0,32.59,14.41,32.59,32V496a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V161.28A48.11,48.11,0,0,0,610.5,117Z"]
  },
      Sh = {
    prefix: "fas",
    iconName: "gas-pump",
    icon: [512, 512, [], "f52f", "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"]
  },
      Th = {
    prefix: "fas",
    iconName: "gas-pump-slash",
    icon: [640, 512, [], "f5f4", "M633.82 458.1l-65.45-50.58c4.72-9.54 7.63-20.15 7.63-31.52V152.57c0-16.97-6.74-33.25-18.75-45.26l-80.97-80.97c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L480 97.94V160c0 28.14 20.93 51.27 48 55.19V376c0 .1-.05.18-.05.27L384 265.02V64c0-35.35-28.65-64-64-64H160c-28.65 0-52.62 18.96-60.78 44.92L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM96 416h274.03L96 204.21V416zm304 32H80c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      Dh = {
    prefix: "fas",
    iconName: "gavel",
    icon: [512, 512, [], "f0e3", "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"]
  },
      jh = {
    prefix: "fas",
    iconName: "gem",
    icon: [576, 512, [], "f3a5", "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"]
  },
      Eh = {
    prefix: "fas",
    iconName: "genderless",
    icon: [288, 512, [], "f22d", "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"]
  },
      kh = {
    prefix: "fas",
    iconName: "ghost",
    icon: [384, 512, [], "f6e2", "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Ih = {
    prefix: "fas",
    iconName: "gift",
    icon: [512, 512, [], "f06b", "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"]
  },
      Oh = {
    prefix: "fas",
    iconName: "gift-card",
    icon: [576, 512, [], "f663", "M528 128h-58.07c6.22-12.06 10.07-25.52 10.07-40 0-48.52-39.48-88-88-88-41.6 0-68.51 21.34-103.04 68.33C254.44 21.33 227.53 0 185.93 0c-48.52 0-88 39.48-88 88 0 14.48 3.85 27.94 10.07 40H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zM392 48c22.06 0 40 17.94 40 40 0 22.05-17.94 40-40 40h-86.07c51.36-76.47 65.72-80 86.07-80zM145.93 88c0-22.06 17.94-40 40-40 19.94 0 34.58 3.27 86.07 80h-86.07c-22.06 0-40-17.95-40-40zm60.13 104l-35.72 35.72c-6.25 6.25-6.25 16.38 0 22.63l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0L273.94 192h28.13l69.65 69.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L369.94 192H512v128H64V192h142.06zM64 448v-64h448v64H64z"]
  },
      Qh = {
    prefix: "fas",
    iconName: "gifts",
    icon: [640, 512, [], "f79c", "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"]
  },
      Zh = {
    prefix: "fas",
    iconName: "gingerbread-man",
    icon: [416, 512, [], "f79d", "M322.2 304H352c38.9 0 69.6-34.7 63.1-74.8-5.1-31.5-34.7-53.2-66.5-53.2h-65.9c-7.1 0-10.5-8.4-5.5-13.5 20.8-21.6 31.6-52.8 24.9-86.3-7.5-37.5-38.5-67.8-76-74.6C165-9.4 112 37.1 112 96c0 25.7 10.2 49.1 26.7 66.3 5 5.2 1.7 13.7-5.5 13.7H67.4C35.5 176 6 197.8.9 229.2-5.6 269.3 25.1 304 64 304h29.8c10.1 0 18.2 8.2 18.2 18.2 0 4.3-1.5 8.4-4.2 11.7l-58.2 69.8c-23.3 27.9-21.6 72.4 7.1 94.7C68.3 507.6 82.2 512 96 512c18.3 0 36.5-7.8 49.2-23l38.3-45.9c12.8-15.4 36.4-15.4 49.2 0L271 489c12.7 15.2 30.8 23 49.2 23 13.8 0 27.7-4.4 39.3-13.5 28.7-22.4 30.4-66.8 7.1-94.7L308.4 334c-2.7-3.3-4.2-7.4-4.2-11.7-.2-10.1 8-18.3 18-18.3zM176 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-144c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      Uh = {
    prefix: "fas",
    iconName: "glass",
    icon: [384, 512, [], "f804", "M354 0H34A32 32 0 0 0 2.06 34l32 448A32 32 0 0 0 66 512h256a32 32 0 0 0 31.94-30l32-448A32 32 0 0 0 354 0zm-34.37 64l-6.86 96H75.22l-6.86-96z"]
  },
      Bh = {
    prefix: "fas",
    iconName: "glass-champagne",
    icon: [256, 512, [], "f79e", "M216 464h-56V347.7c60.7-15.2 103.3-72 95-135.4L228 27.4C225.7 11.7 212.2 0 196.3 0H59.7C43.8 0 30.3 11.7 28 27.4L1 212.3c-8.3 63.4 34.3 120.2 95 135.4V464H40c-22.1 0-40 17.9-40 40 0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8 0-22.1-17.9-40-40-40zM61.8 128l11.7-80h109l11.7 80H61.8z"]
  },
      Rh = {
    prefix: "fas",
    iconName: "glass-cheers",
    icon: [640, 512, [], "f79f", "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"]
  },
      Yh = {
    prefix: "fas",
    iconName: "glass-citrus",
    icon: [512, 512, [], "f869", "M368 0c-62.61 0-115.35 40.2-135.18 96h52.54C302 67.45 332.63 48 368 48a96.11 96.11 0 0 1 96 96c0 50.07-38.67 90.84-87.63 95.15l-4.84 48.49C449.39 285.73 512 222.32 512 144A144 144 0 0 0 368 0zm-48 128H32A32 32 0 0 0 .16 163.18l32 320A32 32 0 0 0 64 512h224a32 32 0 0 0 31.84-28.82l32-320A32 32 0 0 0 320 128zm-41.76 128H73.76l-6.4-64h217.28z"]
  },
      Ph = {
    prefix: "fas",
    iconName: "glass-martini",
    icon: [512, 512, [], "f000", "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"]
  },
      Fh = {
    prefix: "fas",
    iconName: "glass-martini-alt",
    icon: [512, 512, [], "f57b", "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"]
  },
      Wh = {
    prefix: "fas",
    iconName: "glass-whiskey",
    icon: [512, 512, [], "f7a0", "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"]
  },
      Gh = {
    prefix: "fas",
    iconName: "glass-whiskey-rocks",
    icon: [512, 512, [], "f7a1", "M252.1 345.4l45.3 45.3c12.5 12.5 32.8 12.5 45.3 0l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3l-45.3-45.3c-12.5-12.5-32.8-12.5-45.3 0l-45.3 45.3c-12.5 12.5-12.5 32.8 0 45.3zM480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-66.3 249.4c9.9 11.6 15.6 26 15.6 41.4 0 17.1-6.7 33.2-18.7 45.3l-45.3 45.3C353.2 425.3 337.1 432 320 432c-17.1 0-33.2-6.7-45.3-18.7L229.5 368H160c-35.3 0-64-28.7-64-64v-38.9L69.4 96h373.2l-28.9 185.4zM160 336h52.2c-.9-4.3-1.4-8.7-1.4-13.3 0-17.1 6.7-33.2 18.7-45.3L256 251v-11c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32z"]
  },
      qh = {
    prefix: "fas",
    iconName: "glasses",
    icon: [576, 512, [], "f530", "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"]
  },
      Jh = {
    prefix: "fas",
    iconName: "glasses-alt",
    icon: [576, 512, [], "f5f5", "M560.51 225.9L528.75 98.64C522.05 71.78 495.01 32 443.33 32c-15.63 0-23.03 2.94-43.02 9.6-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.24 6.7 8.48 10.94 15.18 10.94 3.54 0 4.82-.74 18.23-5.21 26.07-8.68 48.2 6.13 53.53 27.54l29.67 118.68C490.97 215.88 466.47 208 440 208c-55.09 0-102.27 32.91-123.65 80h-56.7c-21.38-47.09-68.56-80-123.65-80-26.47 0-50.97 7.88-71.86 20.96l29.67-118.68c5.32-21.41 27.46-36.22 53.53-27.54 13.42 4.47 14.7 5.21 18.23 5.21 6.7 0 12.94-4.24 15.18-10.94l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24C155.7 34.94 148.3 32 132.67 32 81 32 53.95 71.78 47.25 98.64L15.49 225.9C2.16 279.34 0 300.12 0 344c0 75.11 60.89 136 136 136 72.37 0 130.97-56.69 135.19-128h33.61c4.22 71.31 62.82 128 135.19 128 75.11 0 136-60.89 136-136 .01-43.88-2.15-64.66-15.48-118.1zM136 416c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72zm304 0c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z"]
  },
      Kh = {
    prefix: "fas",
    iconName: "globe",
    icon: [496, 512, [], "f0ac", "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"]
  },
      Xh = {
    prefix: "fas",
    iconName: "globe-africa",
    icon: [496, 512, [], "f57c", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"]
  },
      _h = {
    prefix: "fas",
    iconName: "globe-americas",
    icon: [496, 512, [], "f57d", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"]
  },
      $h = {
    prefix: "fas",
    iconName: "globe-asia",
    icon: [496, 512, [], "f57e", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"]
  },
      cm = {
    prefix: "fas",
    iconName: "globe-europe",
    icon: [496, 512, [], "f7a2", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"]
  },
      em = {
    prefix: "fas",
    iconName: "globe-snow",
    icon: [448, 512, [], "f7a3", "M384 416H64l-47.4 71.1c-7.1 10.7.5 24.9 13.3 24.9h388.2c12.8 0 20.4-14.2 13.3-24.9L384 416zm-192-32v-32h-57.9c-14.2 0-22-15-12.9-24.9l65.5-71.1h-30.1c-10.7 0-16.5-11.2-9.7-18.7l67.4-73.2c5-5.5 14.3-5.5 19.3 0l67.4 73.2c6.8 7.4 1 18.7-9.7 18.7h-30.1l65.5 71.1c9.1 9.9 1.3 24.9-12.9 24.9H256v32h124.1c41.7-40.6 67.9-97.1 67.9-160C448 100.3 347.7 0 224 0S0 100.3 0 224c0 62.9 26.1 119.4 67.9 160H192zm144-224c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm-96-96c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zM80 224c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"]
  },
      am = {
    prefix: "fas",
    iconName: "globe-stand",
    icon: [448, 512, [], "f5f6", "M321.14 305.14c62.48-62.48 62.48-163.79 0-226.27-62.48-62.48-163.79-62.48-226.27 0-62.48 62.48-62.48 163.79 0 226.27s163.78 62.48 226.27 0zM348.12 464h-92.03v-36.98c44.6-9.01 87.14-30.71 121.75-65.31 85.25-85.22 92.73-218.44 22.91-312.38l10.7-10.7c6.25-6.25 6.25-16.38 0-22.63L400.14 4.69c-6.25-6.25-16.38-6.25-22.64 0L334.47 47.7c3.18 2.79 6.39 5.52 9.41 8.53 74.89 74.86 74.89 196.67 0 271.53C307.61 364.03 259.37 384 208.07 384s-99.53-19.97-135.81-56.24c-3.07-3.07-5.25-6.65-8.07-9.88l-59.5 59.5c-6.25 6.25-6.25 16.38 0 22.63L16 411.31c6.25 6.25 16.38 6.25 22.64 0l26.71-26.7c37.78 28.06 81.91 43.6 126.72 46.64V464h-92.03c-19.89 0-36.01 16.12-36.01 36 0 6.63 5.37 12 12 12h296.1c6.63 0 12-5.37 12-12 0-19.88-16.12-36-36.01-36z"]
  },
      nm = {
    prefix: "fas",
    iconName: "golf-ball",
    icon: [416, 512, [], "f450", "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"]
  },
      tm = {
    prefix: "fas",
    iconName: "golf-club",
    icon: [640, 512, [], "f451", "M638.4 29.9L424.3 475.7c-10.7 22.2-33.1 36.3-57.7 36.3H64c-35.3 0-64-28.7-64-64v-8h120c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H0v-48h120c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H0v-26.9c0-40.1 36.4-70.3 75.8-62.9l389.7 73.1L595.2 9c3.8-8 13.4-11.3 21.4-7.4L631 8.5c7.9 3.9 11.2 13.5 7.4 21.4z"]
  },
      rm = {
    prefix: "fas",
    iconName: "gopuram",
    icon: [512, 512, [], "f664", "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"]
  },
      im = {
    prefix: "fas",
    iconName: "graduation-cap",
    icon: [640, 512, [], "f19d", "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"]
  },
      om = {
    prefix: "fas",
    iconName: "gramophone",
    icon: [384, 512, [], "f8bd", "M69.56 317.08c62.84-43.05 161.76-94.4 238.6-73.8A26.79 26.79 0 0 1 328 269.15a34.81 34.81 0 0 1-34.78 34.77H184a24 24 0 0 0-24 24v24h133.22A82.87 82.87 0 0 0 376 269.15a74.89 74.89 0 0 0-55.41-72.27C243.17 176.13 183 80.83 150.84 13.62 141.2-6.5 111.76-3.68 106 17.79L32.82 291.06c-5.82 21.62 18.53 38.49 36.74 26.02zM368 448h-16v-32a32 32 0 0 0-32-32H64a32 32 0 0 0-32 32v32H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      lm = {
    prefix: "fas",
    iconName: "greater-than",
    icon: [384, 512, [], "f531", "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"]
  },
      fm = {
    prefix: "fas",
    iconName: "greater-than-equal",
    icon: [448, 512, [], "f532", "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"]
  },
      sm = {
    prefix: "fas",
    iconName: "grimace",
    icon: [496, 512, [], "f57f", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"]
  },
      um = {
    prefix: "fas",
    iconName: "grin",
    icon: [496, 512, [], "f580", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
  },
      hm = {
    prefix: "fas",
    iconName: "grin-alt",
    icon: [496, 512, [], "f581", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
  },
      mm = {
    prefix: "fas",
    iconName: "grin-beam",
    icon: [496, 512, [], "f582", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
  },
      vm = {
    prefix: "fas",
    iconName: "grin-beam-sweat",
    icon: [504, 512, [], "f583", "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
  },
      dm = {
    prefix: "fas",
    iconName: "grin-hearts",
    icon: [496, 512, [], "f584", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"]
  },
      Mm = {
    prefix: "fas",
    iconName: "grin-squint",
    icon: [496, 512, [], "f585", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
  },
      pm = {
    prefix: "fas",
    iconName: "grin-squint-tears",
    icon: [512, 512, [], "f586", "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"]
  },
      zm = {
    prefix: "fas",
    iconName: "grin-stars",
    icon: [496, 512, [], "f587", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"]
  },
      Cm = {
    prefix: "fas",
    iconName: "grin-tears",
    icon: [640, 512, [], "f588", "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"]
  },
      Lm = {
    prefix: "fas",
    iconName: "grin-tongue",
    icon: [496, 512, [], "f589", "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"]
  },
      Am = {
    prefix: "fas",
    iconName: "grin-tongue-squint",
    icon: [496, 512, [], "f58a", "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"]
  },
      Nm = {
    prefix: "fas",
    iconName: "grin-tongue-wink",
    icon: [496, 512, [], "f58b", "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"]
  },
      gm = {
    prefix: "fas",
    iconName: "grin-wink",
    icon: [496, 512, [], "f58c", "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"]
  },
      Hm = {
    prefix: "fas",
    iconName: "grip-horizontal",
    icon: [448, 512, [], "f58d", "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
  },
      Vm = {
    prefix: "fas",
    iconName: "grip-lines",
    icon: [512, 512, [], "f7a4", "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
  },
      xm = {
    prefix: "fas",
    iconName: "grip-lines-vertical",
    icon: [256, 512, [], "f7a5", "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"]
  },
      wm = {
    prefix: "fas",
    iconName: "grip-vertical",
    icon: [320, 512, [], "f58e", "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
  },
      ym = {
    prefix: "fas",
    iconName: "guitar",
    icon: [512, 512, [], "f7a6", "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"]
  },
      bm = {
    prefix: "fas",
    iconName: "guitar-electric",
    icon: [512, 512, [], "f8be", "M511.21 39.54a48.1 48.1 0 0 0-37.79-38.23C450.48-3 450.66.78 366.74 54.9A32.12 32.12 0 0 0 352 81.82v33.25L243.76 223.23a39.42 39.42 0 0 1-3.18-38.43l17.29-37.13a18.82 18.82 0 0 0-30.38-21.24l-38.31 38.28a77.44 77.44 0 0 0-18.24 28.84 77.63 77.63 0 0 1-40.52 44.37L54 273.29C-3.23 296.15-18.4 370 25.16 413.53l73.39 73.33c43.56 43.53 117.45 28.37 140.35-28.78l35.4-76.39a77.62 77.62 0 0 1 44.41-40.49 77.68 77.68 0 0 0 28.86-18.2l21.56-21.55a19.87 19.87 0 0 0-20.1-33L325.31 276a39.6 39.6 0 0 1-36.75-7.11L461.6 96c.82.05 1.56.35 2.4.35a48 48 0 0 0 47.21-56.81zm-329.56 354.8l-11.31 11.31a8 8 0 0 1-11.31 0L106.34 353a8 8 0 0 1 0-11.32l11.31-11.31a8 8 0 0 1 11.32 0L181.65 383a8 8 0 0 1 0 11.34zm64-64l-11.31 11.31a8 8 0 0 1-11.31 0L170.34 289a8 8 0 0 1 0-11.32l11.31-11.31a8 8 0 0 1 11.32 0L245.65 319a8 8 0 0 1 0 11.34z"]
  },
      Sm = {
    prefix: "fas",
    iconName: "guitars",
    icon: [512, 512, [], "f8bf", "M229.27 300.21A74.51 74.51 0 0 0 237.7 266c0-29.14-17-54.82-43.14-71.17-12.83-8-27.53-12-42.56-13.88v-54.22l16.6-33.21a29.17 29.17 0 0 0 3.08-13v-54.1A26.42 26.42 0 0 0 145.25 0h-34.53A26.41 26.41 0 0 0 84.3 26.41v54.08a29.12 29.12 0 0 0 3.07 13L104 126.74V181c-15 1.84-29.74 5.84-42.58 13.83a103.31 103.31 0 0 0-18.58 14.67c-15.39 15.39-24.62 35-24.62 56.58a74.37 74.37 0 0 0 8.42 34.2c8 15.65 6 35.59-4.88 48.78C8.11 365.55-.07 385.43 0 407c-.07 58 57.34 105 128 105 39.89 0 75.54-15 99-38.47 1.28-1.27 2.23-2.75 3.43-4.07a111.36 111.36 0 0 1 2.32-80.3L243 361.42a102.52 102.52 0 0 0-8.81-12.42c-10.89-13.16-12.89-33.16-4.92-48.79zm-73 32.08a40 40 0 1 1 0-56.58 40 40 0 0 1 .02 56.58zm349.19 68.53l-26.93-73.45a72.1 72.1 0 0 1 2.58-55.79 72.13 72.13 0 0 0 7-30.94v-28.32a18.47 18.47 0 0 0-34.88-8.47l-10.61 20.55c-5.36 10.37-15.35 17-26.62 19l-8-.1V73.38a34.72 34.72 0 0 0 5.09-3.8 40.77 40.77 0 0 0-51.44-62.75c-16.39 11.15-14 13.35-31.85 96.24a27.3 27.3 0 0 0 7.33 25L360 151v91.66l-8-.11c-11.31-3.11-20.84-11-25-22.37l-13-35.76a17.49 17.49 0 0 0-33.92 6v50.33a72.07 72.07 0 0 0 7 30.93 72.07 72.07 0 0 1 2.53 55.78l-27 73.48C240 453.53 278.54 512 335.76 512h96.41c57.23-.06 95.83-58.59 73.31-111.18zM432 392a8 8 0 0 1-8 8h-80a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h80a8 8 0 0 1 8 8zm0-64.12a8 8 0 0 1-8 8h-80a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h80a8 8 0 0 1 8 8z"]
  },
      Tm = {
    prefix: "fas",
    iconName: "h-square",
    icon: [448, 512, [], "f0fd", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"]
  },
      Dm = {
    prefix: "fas",
    iconName: "h1",
    icon: [576, 512, [], "f313", "M304 96h-98.94A13.06 13.06 0 0 0 192 109.06v37.88A13.06 13.06 0 0 0 205.06 160H224v64H96v-64h18.94A13.06 13.06 0 0 0 128 146.94V112a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v34.94A13.06 13.06 0 0 0 13.06 160H32v192H13.06A13.06 13.06 0 0 0 0 365.06V400a16 16 0 0 0 16 16h98.94A13.06 13.06 0 0 0 128 402.94v-37.88A13.06 13.06 0 0 0 114.94 352H96v-64h128v64h-18.94A13.06 13.06 0 0 0 192 365.06V400a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-34.94A13.06 13.06 0 0 0 306.94 352H288V160h18.94A13.06 13.06 0 0 0 320 146.94V112a16 16 0 0 0-16-16zm256 256h-48V120a24 24 0 0 0-24-24h-40a24 24 0 0 0-21.44 13.26l-24 48A24 24 0 0 0 424 192h24v160h-48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      jm = {
    prefix: "fas",
    iconName: "h2",
    icon: [576, 512, [], "f314", "M560 352H440.79c17-42.95 135.21-66.57 135.21-159.62C576 132.55 528.33 96 469.14 96c-43.83 0-81.41 21.38-103.42 57a15.66 15.66 0 0 0 4.75 21.4l28.26 18.6a16.15 16.15 0 0 0 21.86-3.83c10.77-14.86 24.94-26 43.85-26s38.22 10.46 38.22 33.84c0 52.18-142.1 73.21-142.1 184.56a155.06 155.06 0 0 0 1.71 20.66A15.94 15.94 0 0 0 378.14 416H560a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM304 96h-98.94A13.06 13.06 0 0 0 192 109.06v37.88A13.06 13.06 0 0 0 205.06 160H224v64H96v-64h18.94A13.06 13.06 0 0 0 128 146.94V112a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v34.94A13.06 13.06 0 0 0 13.06 160H32v192H13.06A13.06 13.06 0 0 0 0 365.06V400a16 16 0 0 0 16 16h98.94A13.06 13.06 0 0 0 128 402.94v-37.88A13.06 13.06 0 0 0 114.94 352H96v-64h128v64h-18.94A13.06 13.06 0 0 0 192 365.06V400a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-34.94A13.06 13.06 0 0 0 306.94 352H288V160h18.94A13.06 13.06 0 0 0 320 146.94V112a16 16 0 0 0-16-16z"]
  },
      Em = {
    prefix: "fas",
    iconName: "h3",
    icon: [576, 512, [], "f315", "M499 217.69l64.4-72.31a15.48 15.48 0 0 0 4-10.31v-23.32A16 16 0 0 0 551.12 96H384a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h85.18c-2.29 2.45-4.65 5-7.19 7.9l-53.1 61.1a18 18 0 0 0-3.83 10.17 18.36 18.36 0 0 0 1.38 6.34l8.41 18.59c2.35 5.21 9 9.42 14.84 9.42h15.95c28.94 0 57.79 10.32 57.79 38.48 0 21.32-19.93 36.79-47.39 36.79-22.08 0-41.18-9.17-57.7-22.83a16.46 16.46 0 0 0-23.87 3.34l-19.75 28.8a15.46 15.46 0 0 0 2.53 20.35C384.9 403.21 422 416 459.51 416c71 0 116.49-48.86 116.49-106.06 0-47.3-32.73-80.89-77-92.25zM304 96h-98.94A13.06 13.06 0 0 0 192 109.06v37.88A13.06 13.06 0 0 0 205.06 160H224v64H96v-64h18.94A13.06 13.06 0 0 0 128 146.94V112a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v34.94A13.06 13.06 0 0 0 13.06 160H32v192H13.06A13.06 13.06 0 0 0 0 365.06V400a16 16 0 0 0 16 16h98.94A13.06 13.06 0 0 0 128 402.94v-37.88A13.06 13.06 0 0 0 114.94 352H96v-64h128v64h-18.94A13.06 13.06 0 0 0 192 365.06V400a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-34.94A13.06 13.06 0 0 0 306.94 352H288V160h18.94A13.06 13.06 0 0 0 320 146.94V112a16 16 0 0 0-16-16z"]
  },
      km = {
    prefix: "fas",
    iconName: "h4",
    icon: [576, 512, [], "f86a", "M304 96h-98.94A13.06 13.06 0 0 0 192 109.06v37.88A13.06 13.06 0 0 0 205.06 160H224v64H96v-64h18.94A13.06 13.06 0 0 0 128 146.94V112a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v34.94A13.06 13.06 0 0 0 13.06 160H32v192H13.06A13.06 13.06 0 0 0 0 365.06V400a16 16 0 0 0 16 16h98.94A13.06 13.06 0 0 0 128 402.94v-37.88A13.06 13.06 0 0 0 114.94 352H96v-64h128v64h-18.94A13.06 13.06 0 0 0 192 365.06V400a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-34.94A13.06 13.06 0 0 0 306.94 352H288V160h18.94A13.06 13.06 0 0 0 320 146.94V112a16 16 0 0 0-16-16zm256 128h-16V112a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v112h-64V112a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v144a32 32 0 0 0 32 32h96v112a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      Im = {
    prefix: "fas",
    iconName: "hamburger",
    icon: [512, 512, [], "f805", "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"]
  },
      Om = {
    prefix: "fas",
    iconName: "hammer",
    icon: [576, 512, [], "f6e3", "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"]
  },
      Qm = {
    prefix: "fas",
    iconName: "hammer-war",
    icon: [384, 512, [], "f6e4", "M346.74 32.44L224 52.9V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v36.9L37.26 32.44C17.76 29.19 0 44.23 0 64.01v191.98c0 19.77 17.76 34.81 37.26 31.56L192 261.77l154.74 25.79C366.25 290.81 384 275.77 384 256V64.01c0-19.78-17.76-34.82-37.26-31.57zM160 299.54V496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V299.54l-32-5.33-32 5.33z"]
  },
      Zm = {
    prefix: "fas",
    iconName: "hamsa",
    icon: [512, 512, [], "f665", "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
  },
      Um = {
    prefix: "fas",
    iconName: "hand-heart",
    icon: [448, 512, [], "f4bc", "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zm-62.9 261.2l-72.6 71.4c-4.7 4.6-12.3 4.6-17 0l-72.6-71.4c-21.1-20.7-19.8-55.1 3.7-74.2 20.5-16.7 51.1-13.7 70 4.8l7.4 7.3 7.4-7.3c18.8-18.5 49.4-21.5 70-4.8 23.5 19.1 24.7 53.4 3.7 74.2z"]
  },
      Bm = {
    prefix: "fas",
    iconName: "hand-holding",
    icon: [576, 512, [], "f4bd", "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"]
  },
      Rm = {
    prefix: "fas",
    iconName: "hand-holding-box",
    icon: [576, 512, [], "f47b", "M112 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H352v128l-64-32-64 32V0H112c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm453.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"]
  },
      Ym = {
    prefix: "fas",
    iconName: "hand-holding-heart",
    icon: [576, 512, [], "f4be", "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"]
  },
      Pm = {
    prefix: "fas",
    iconName: "hand-holding-magic",
    icon: [576, 512, [], "f6e5", "M224 224c52.94 0 96-43.06 96-96 0 0-32 32-96 32-17.72 0-32-17.5-32-32V96c0-17.64 14.36-32 32-32h128c17.64 0 32 14.36 32 32v32c0 34.3-17.51 66.54-42.09 90.8L288 272l17.81-1.01c77.05-4.36 141.58-65.27 142.18-141.43 0-.52.01-1.04.01-1.56V96c0-52.94-43.06-96-96-96H224c-52.94 0-96 43.06-96 96v32c0 51.14 44.86 96 96 96zm341.28 104.1c-11.83-10.69-30.18-9.96-42.63 0l-92.34 73.87A64.004 64.004 0 0 1 390.33 416H272c-8.84 0-16-7.16-16-16s7.16-16 16-16h78.28c15.94 0 30.72-10.89 33.28-26.63C386.82 337.32 371.43 320 352 320H192c-26.97 0-53.11 9.27-74.06 26.27L71.44 384H16c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h356.77c14.53 0 28.63-4.95 39.98-14.03l151.23-120.99c15.19-12.13 16.38-35.27 1.3-48.88z"]
  },
      Fm = {
    prefix: "fas",
    iconName: "hand-holding-medical",
    icon: [576, 512, [], "e05c", "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"]
  },
      Wm = {
    prefix: "fas",
    iconName: "hand-holding-seedling",
    icon: [576, 512, [], "f4bf", "M480 0h-64c-40.7 0-77.5 15.7-105.8 40.8 25.4 32 40.9 72.2 41.6 116C424.9 142 480 77.5 480 0zM256 160v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V160C320 71.6 248.4 0 160 0H96c0 88.4 71.6 160 160 160zm309.3 168.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"]
  },
      Gm = {
    prefix: "fas",
    iconName: "hand-holding-usd",
    icon: [576, 512, [], "f4c0", "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"]
  },
      qm = {
    prefix: "fas",
    iconName: "hand-holding-water",
    icon: [576, 512, [], "f4c1", "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"]
  },
      Jm = {
    prefix: "fas",
    iconName: "hand-lizard",
    icon: [576, 512, [], "f258", "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"]
  },
      Km = {
    prefix: "fas",
    iconName: "hand-middle-finger",
    icon: [512, 512, [], "f806", "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"]
  },
      Xm = {
    prefix: "fas",
    iconName: "hand-paper",
    icon: [448, 512, [], "f256", "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"]
  },
      _m = {
    prefix: "fas",
    iconName: "hand-peace",
    icon: [448, 512, [], "f25b", "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"]
  },
      $m = {
    prefix: "fas",
    iconName: "hand-point-down",
    icon: [384, 512, [], "f0a7", "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"]
  },
      cv = {
    prefix: "fas",
    iconName: "hand-point-left",
    icon: [512, 512, [], "f0a5", "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"]
  },
      ev = {
    prefix: "fas",
    iconName: "hand-point-right",
    icon: [512, 512, [], "f0a4", "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"]
  },
      av = {
    prefix: "fas",
    iconName: "hand-point-up",
    icon: [384, 512, [], "f0a6", "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"]
  },
      nv = {
    prefix: "fas",
    iconName: "hand-pointer",
    icon: [448, 512, [], "f25a", "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"]
  },
      tv = {
    prefix: "fas",
    iconName: "hand-receiving",
    icon: [640, 512, [], "f47c", "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32zm-169.3 41.6L342.4 9.3C330-3.1 310-3.1 297.6 9.3l-96.4 96.4c-12.4 12.3-12.4 32.4 0 44.7l96.4 96.4c12.3 12.3 32.4 12.3 44.7 0l96.4-96.4c12.4-12.4 12.4-32.4 0-44.8z"]
  },
      rv = {
    prefix: "fas",
    iconName: "hand-rock",
    icon: [512, 512, [], "f255", "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"]
  },
      iv = {
    prefix: "fas",
    iconName: "hand-scissors",
    icon: [512, 512, [], "f257", "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"]
  },
      ov = {
    prefix: "fas",
    iconName: "hand-sparkles",
    icon: [640, 512, [], "e05d", "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"]
  },
      lv = {
    prefix: "fas",
    iconName: "hand-spock",
    icon: [512, 512, [], "f259", "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"]
  },
      fv = {
    prefix: "fas",
    iconName: "hands",
    icon: [640, 512, [], "f4c2", "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"]
  },
      sv = {
    prefix: "fas",
    iconName: "hands-heart",
    icon: [640, 512, [], "f4c3", "M436 17.5c-30.8-26.7-76.7-21.9-104.9 7.7L320 36.9l-11.1-11.6C280.7-4.4 234.8-9.2 204 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.5-33.2 29.7-88.2-5.7-118.8zM204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"]
  },
      uv = {
    prefix: "fas",
    iconName: "hands-helping",
    icon: [640, 512, [], "f4c4", "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"]
  },
      hv = {
    prefix: "fas",
    iconName: "hands-usd",
    icon: [640, 512, [], "f4c5", "M393.3 159.4c-2.9-23-20.7-41.3-42.9-47.7l-50.1-14.3c-3.6-1-6.1-4.4-6.1-8.1 0-4.6 3.8-8.4 8.4-8.4h32.8c3.6 0 7.1.8 10.3 2.2 4.8 2.2 10.4 1.7 14.1-2l17.5-17.5c5.3-5.3 4.7-14.3-1.5-18.4-9.5-6.3-20.4-10.1-31.8-11.5V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v17.6c-30.3 3.6-53.4 31-49.3 63 2.9 23 20.7 41.3 42.9 47.7l50.1 14.3c3.6 1 6.1 4.4 6.1 8.1 0 4.6-3.8 8.4-8.4 8.4h-32.8c-3.6 0-7.1-.8-10.3-2.2-4.8-2.2-10.4-1.7-14.1 2l-17.5 17.5c-5.3 5.3-4.7 14.3 1.5 18.4 9.5 6.3 20.4 10.1 31.8 11.5V240c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-17.6c30.3-3.6 53.4-30.9 49.3-63zm-188.5 71c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"]
  },
      mv = {
    prefix: "fas",
    iconName: "hands-wash",
    icon: [576, 512, [], "e05e", "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"]
  },
      vv = {
    prefix: "fas",
    iconName: "handshake",
    icon: [640, 512, [], "f2b5", "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"]
  },
      dv = {
    prefix: "fas",
    iconName: "handshake-alt",
    icon: [640, 512, [], "f4c6", "M483.9 338.7L334.6 217.5l-30 27.5c-40.6 37.1-86.8 11.9-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128H16c-8.8 0-16 7.2-16 16v191.9c0 8.8 7.2 16 16 16h130.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1zM624 128H512l-54.6-54.6c-6-6-14.1-9.4-22.6-9.4h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.7 15.7-16.3 40.6-2.1 56 9.6 10.5 35 21.6 56.1 2.7.1-.1.3-.1.4-.2l53-48.5 27-24.7c6.5-5.9 16.6-5.5 22.6 1s5.5 16.6-1 22.6l-26.1 23.9 145.6 118.2c12.2 9.9 19.5 23.5 22.2 37.9H624c8.8 0 16-7.2 16-16V143.9c0-8.8-7.2-15.9-16-15.9z"]
  },
      Mv = {
    prefix: "fas",
    iconName: "handshake-alt-slash",
    icon: [640, 512, [], "e05f", "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"]
  },
      pv = {
    prefix: "fas",
    iconName: "handshake-slash",
    icon: [640, 512, [], "e060", "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"]
  },
      zv = {
    prefix: "fas",
    iconName: "hanukiah",
    icon: [640, 512, [], "f6e6", "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"]
  },
      Cv = {
    prefix: "fas",
    iconName: "hard-hat",
    icon: [512, 512, [], "f807", "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      Lv = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [448, 512, [], "f292", "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"]
  },
      Av = {
    prefix: "fas",
    iconName: "hat-chef",
    icon: [512, 512, [], "f86b", "M416 32a95.17 95.17 0 0 0-57.73 19.74C334.93 20.5 298 0 256 0s-78.93 20.5-102.27 51.74A95.56 95.56 0 0 0 0 128c0 41.74 64 192 64 192h60.09L112 169.25a8 8 0 0 1 7.33-8.61l16-1.28a8 8 0 0 1 8.61 7.34L156.2 320h83.14V168a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v152h84.46l12.27-153.3a8 8 0 0 1 8.61-7.34l16 1.28a8 8 0 0 1 7.33 8.61L387.91 320H448s64-150.26 64-192a96 96 0 0 0-96-96zM64 480a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V352H64z"]
  },
      Nv = {
    prefix: "fas",
    iconName: "hat-cowboy",
    icon: [640, 512, [], "f8c0", "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"]
  },
      gv = {
    prefix: "fas",
    iconName: "hat-cowboy-side",
    icon: [640, 512, [], "f8c1", "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"]
  },
      Hv = {
    prefix: "fas",
    iconName: "hat-santa",
    icon: [640, 512, [], "f7a7", "M480 384H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32zm-96-192l71.7 19.5c2.3-4.1 4.9-8 8.2-11.4.4-14.5 6.2-28.6 17-39.4 2.2-2.2 4.7-4.1 7.2-5.9L435 92.1C402.6 54 355.2 32 305.2 32c-68.6 0-130.4 41.2-156.8 104.5L58.7 352h393.9L384 192zm256 48c0-12.1-8.2-21.9-19.2-25.2 5.5-10.1 4.4-22.8-4.2-31.4s-21.3-9.7-31.4-4.2c-3.3-11-13.1-19.2-25.2-19.2s-21.9 8.2-25.2 19.2c-10.1-5.5-22.8-4.4-31.4 4.2s-9.7 21.3-4.2 31.4c-11 3.3-19.2 13.1-19.2 25.2s8.2 21.9 19.2 25.2c-5.5 10.1-4.4 22.8 4.2 31.4 5.2 5.2 12 7.8 18.9 7.8 4.4 0 8.6-1.5 12.5-3.6 3.3 11 13.1 19.2 25.2 19.2s21.9-8.2 25.2-19.2c4 2.1 8.2 3.6 12.5 3.6 6.8 0 13.6-2.6 18.9-7.8 8.6-8.6 9.7-21.3 4.2-31.4 11-3.3 19.2-13.1 19.2-25.2z"]
  },
      Vv = {
    prefix: "fas",
    iconName: "hat-winter",
    icon: [512, 512, [], "f7a8", "M195.2 105.2c-5.5 10.1-4.4 22.8 4.2 31.4 5.2 5.2 12 7.8 18.9 7.8 4.4 0 8.6-1.5 12.5-3.6 3.3 11 13.1 19.2 25.2 19.2s21.9-8.2 25.2-19.2c4 2.1 8.2 3.6 12.5 3.6 6.8 0 13.6-2.6 18.9-7.8 8.6-8.6 9.7-21.3 4.2-31.4 11-3.3 19.2-13.1 19.2-25.2s-8.2-21.9-19.2-25.2c5.5-10.1 4.4-22.8-4.2-31.4s-21.3-9.7-31.4-4.2C277.9 8.2 268.1 0 256 0s-21.9 8.2-25.2 19.2c-10.1-5.5-22.8-4.4-31.4 4.2s-9.7 21.3-4.2 31.4C184.2 58.1 176 67.9 176 80s8.2 21.9 19.2 25.2zM128 270.1l64 32 64-32 64 32 64-32 64 32 7.2-3.6c-19.7-50.2-55.2-104.9-119-140.5-.4.4-.6.8-1 1.2-10.6 10.6-24.6 16.7-39.6 17.2-10.5 9.9-24.5 15.7-39.6 15.7-15.2 0-29.2-5.8-39.6-15.7-14.9-.5-28.9-6.5-39.6-17.2-.4-.4-.6-.8-1-1.2-63.9 35.6-99.4 90.4-119 140.5l7.2 3.6 64-32zM496 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-30.3-118.9l-17.7 8.8-64-32-64 32-64-32-64 32-64-32-64 32-17.7-8.8C32.2 377.8 32 416 32 416h448s-.2-38.2-14.3-86.9z"]
  },
      xv = {
    prefix: "fas",
    iconName: "hat-witch",
    icon: [576, 512, [], "f6e7", "M571.21 426.81l-22.66-22.66c-6.03-6.03-15.49-5.96-21.99-.43C492.89 432.38 450.6 448 405.89 448H170.11c-44.71 0-87.01-15.62-120.68-44.28-6.5-5.53-15.95-5.61-21.99.43L4.79 426.81c-6.44 6.44-6.45 17.25.4 23.25C50.85 490.12 108.8 512 170.11 512h235.78c61.31 0 119.26-21.88 164.93-61.94 6.84-6 6.84-16.81.39-23.25zM224 416v-64c0-17.67 14.33-32 32-32h64c17.67 0 32 14.33 32 32v64h53.89c23.94 0 46.54-5.79 67.29-15.91l-79.6-185.73a64.009 64.009 0 0 1-1.89-45.45l6.35-19.04A32.01 32.01 0 0 1 428.4 128h39.2c13.77 0 26 8.81 30.36 21.88L512 192l30.36-77.24c3.83-11.5.84-24.18-7.73-32.75L465.28 9.37c-10.21-10.2-25.97-12.32-38.5-5.16L260.43 107.18a128.004 128.004 0 0 0-53.47 59.15L103.03 400.19c20.69 10.06 43.23 15.81 67.08 15.81H224zm32 0h64v-64h-64v64z"]
  },
      wv = {
    prefix: "fas",
    iconName: "hat-wizard",
    icon: [512, 512, [], "f6e8", "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"]
  },
      yv = {
    prefix: "fas",
    iconName: "hdd",
    icon: [576, 512, [], "f0a0", "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"]
  },
      bv = {
    prefix: "fas",
    iconName: "head-side",
    icon: [512, 512, [], "f6e9", "M509.21 275c-20.94-47.12-48.44-151.73-73.08-186.75C397.68 33.6 334.56 0 266.09 0H192C85.96 0 0 85.96 0 192c0 56.79 24.8 107.67 64 142.82V512h256v-64h64c35.35 0 64-28.65 64-64v-64h31.96c23.16 0 38.65-23.84 29.25-45zM320 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      Sv = {
    prefix: "fas",
    iconName: "head-side-brain",
    icon: [512, 512, [], "f808", "M160 178.94V176c0 1-.23 1.89-.29 2.85a2.46 2.46 0 0 1 .29.09zM509.21 275c-20.94-47.12-48.44-151.73-73.08-186.75A207.94 207.94 0 0 0 266.09 0H192C86 0 0 86 0 192a191.28 191.28 0 0 0 64 142.82V512h256v-64h64a64 64 0 0 0 64-64v-64h32a32 32 0 0 0 29.21-45zM336 208h-50.94a47.5 47.5 0 0 1 2.94 16 48 48 0 0 1-48 48 47.5 47.5 0 0 1-16-2.94V320h-64v-50.94a47.5 47.5 0 0 1-16 2.94 48 48 0 0 1-48-48c0-1 .23-1.89.29-2.85A47.88 47.88 0 0 1 112 128a48 48 0 0 1 48-48 47.46 47.46 0 0 1 23.53 6.4 47.76 47.76 0 0 1 80.94 0 47.37 47.37 0 0 1 68.59 25.6H336a48 48 0 0 1 0 96z"]
  },
      Tv = {
    prefix: "fas",
    iconName: "head-side-cough",
    icon: [640, 512, [], "e061", "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"]
  },
      Dv = {
    prefix: "fas",
    iconName: "head-side-cough-slash",
    icon: [640, 512, [], "e062", "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"]
  },
      jv = {
    prefix: "fas",
    iconName: "head-side-headphones",
    icon: [512, 512, [], "f8c2", "M509.21 273c-20.94-47.12-48.44-151.73-73.1-186.75A207.87 207.87 0 0 0 266.09-2H256v107.19c37.74 18 64 56.21 64 100.81a112 112 0 1 1-224 0c0-44.6 26.26-82.79 64-100.81V.88C69.23 16.14 0 94.88 0 190a191.27 191.27 0 0 0 64 142.81V510h256v-64h64a64 64 0 0 0 64-64v-64h32a32 32 0 0 0 29.21-45zM128 206a80 80 0 1 0 80-80 80 80 0 0 0-80 80zm80-32a32 32 0 1 1-32 32 32 32 0 0 1 32-32z"]
  },
      Ev = {
    prefix: "fas",
    iconName: "head-side-mask",
    icon: [512, 512, [], "e063", "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"]
  },
      kv = {
    prefix: "fas",
    iconName: "head-side-medical",
    icon: [512, 512, [], "f809", "M509.21 275c-20.94-47.12-48.44-151.73-73.08-186.75A207.94 207.94 0 0 0 266.09 0H192C86 0 0 86 0 192a191.28 191.28 0 0 0 64 142.82V512h256v-64h64a64 64 0 0 0 64-64v-64h32a32 32 0 0 0 29.21-45zM320 216a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"]
  },
      Iv = {
    prefix: "fas",
    iconName: "head-side-virus",
    icon: [512, 512, [], "e064", "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"]
  },
      Ov = {
    prefix: "fas",
    iconName: "head-vr",
    icon: [512, 512, [], "f6ea", "M304 64h112v160H308.56c-41.85 0-79.98-30.11-84.15-71.75C219.62 104.36 257.1 64 304 64zm208 144V80c0-8.84-7.16-16-16-16h-48v160h48c8.84 0 16-7.16 16-16zm-319.43-52.56c-3.16-31.6 7.18-63.15 28.37-86.57C242.14 45.44 272.41 32 304 32h72.3C343.87 11.68 305.97 0 266.09 0H224C140.44 0 69.54 53.48 43.16 128H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h187.49c-5.67-11.31-9.61-23.56-10.92-36.56zM501.51 256H308.56c-31.13 0-59.73-12.33-80.92-32H34.95c7.4 43.72 29.4 82.44 61.05 110.82V512h224v-64h64c35.35 0 64-28.65 64-64v-64h31.96c23.16 0 38.65-23.84 29.24-45-2.47-5.56-5.05-12.04-7.69-19z"]
  },
      Qv = {
    prefix: "fas",
    iconName: "heading",
    icon: [512, 512, [], "f1dc", "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"]
  },
      Zv = {
    prefix: "fas",
    iconName: "headphones",
    icon: [512, 512, [], "f025", "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"]
  },
      Uv = {
    prefix: "fas",
    iconName: "headphones-alt",
    icon: [512, 512, [], "f58f", "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"]
  },
      Bv = {
    prefix: "fas",
    iconName: "headset",
    icon: [512, 512, [], "f590", "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"]
  },
      Rv = {
    prefix: "fas",
    iconName: "heart",
    icon: [512, 512, [], "f004", "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"]
  },
      Yv = {
    prefix: "fas",
    iconName: "heart-broken",
    icon: [512, 512, [], "f7a9", "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"]
  },
      Pv = {
    prefix: "fas",
    iconName: "heart-circle",
    icon: [496, 512, [], "f4c7", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm123.5 272.3L260.9 394.5c-7.1 7.4-18.7 7.4-25.9 0L124.5 280.3c-32.1-33.2-30.2-88.2 5.7-118.8 31.3-26.7 77.9-21.9 106.6 7.7l11.3 11.6 11.3-11.6c28.7-29.6 75.3-34.4 106.6-7.7 35.8 30.6 37.7 85.6 5.5 118.8z"]
  },
      Fv = {
    prefix: "fas",
    iconName: "heart-rate",
    icon: [640, 512, [], "f5f8", "M624 224H480c-12.12 0-23.21 6.85-28.63 17.69l-26.54 53.09-73.95-271.2C346.99 9.35 333.82-.51 319.13.02 304.36.43 291.8 10.86 288.7 25.3l-69.14 322.68-28.79-100.78C186.84 233.47 174.29 224 160 224H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h119.86l57.38 200.79c3.94 13.77 16.52 23.2 30.75 23.2.36 0 .73 0 1.09-.02 14.67-.5 27.14-10.92 30.22-25.28l68.44-319.4 61.39 225.12a32.012 32.012 0 0 0 27.72 23.42c13.16 1.2 25.84-5.69 31.78-17.53L499.78 288H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      Wv = {
    prefix: "fas",
    iconName: "heart-square",
    icon: [448, 512, [], "f4c8", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-52.5 248.3L236.9 394.5c-7.1 7.4-18.7 7.4-25.9 0L100.5 280.3c-32.1-33.2-30.2-88.2 5.7-118.8 31.3-26.7 77.9-21.9 106.6 7.7l11.3 11.6 11.3-11.6c28.7-29.6 75.3-34.4 106.6-7.7 35.8 30.6 37.7 85.6 5.5 118.8z"]
  },
      Gv = {
    prefix: "fas",
    iconName: "heartbeat",
    icon: [512, 512, [], "f21e", "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"]
  },
      qv = {
    prefix: "fas",
    iconName: "heat",
    icon: [448, 512, [], "e00c", "M64,152.25V112A16,16,0,0,0,48,96H16A16,16,0,0,0,0,112v40.25A218.65,218.65,0,0,0,56.48,299,154.12,154.12,0,0,1,96,402.41V464a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V402.41a218.44,218.44,0,0,0-56.42-146.69A154.3,154.3,0,0,1,64,152.25ZM391.58,255.72A154.3,154.3,0,0,1,352,152.25V112a16,16,0,0,0-16-16H304a16,16,0,0,0-16,16v40.25A218.65,218.65,0,0,0,344.48,299,154.12,154.12,0,0,1,384,402.41V464a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V402.41A218.44,218.44,0,0,0,391.58,255.72ZM208,152.25V48a16,16,0,0,0-16-16H160a16,16,0,0,0-16,16V152.25A218.65,218.65,0,0,0,200.48,299,154.12,154.12,0,0,1,240,402.41V464a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V402.41a218.44,218.44,0,0,0-56.42-146.69A154.3,154.3,0,0,1,208,152.25Z"]
  },
      Jv = {
    prefix: "fas",
    iconName: "helicopter",
    icon: [640, 512, [], "f533", "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"]
  },
      Kv = {
    prefix: "fas",
    iconName: "helmet-battle",
    icon: [576, 512, [], "f6eb", "M32.01 256C49.68 256 64 243.44 64 227.94V0L.97 221.13C-4.08 238.84 11.2 256 32.01 256zm543.02-34.87L512 0v227.94c0 15.5 14.32 28.06 31.99 28.06 20.81 0 36.09-17.16 31.04-34.87zM480 210.82C480 90.35 288 0 288 0S96 90.35 96 210.82c0 82.76-22.86 145.9-31.13 180.71-3.43 14.43 3.59 29.37 16.32 35.24L256 512V256l-96-32v-32h256v32l-96 32v256l174.82-85.23c12.73-5.87 19.75-20.81 16.32-35.24-8.28-34.81-31.14-97.95-31.14-180.71z"]
  },
      Xv = {
    prefix: "fas",
    iconName: "hexagon",
    icon: [576, 512, [], "f312", "M441.5 39.8C432.9 25.1 417.1 16 400 16H176c-17.1 0-32.9 9.1-41.5 23.8l-112 192c-8.7 14.9-8.7 33.4 0 48.4l112 192c8.6 14.7 24.4 23.8 41.5 23.8h224c17.1 0 32.9-9.1 41.5-23.8l112-192c8.7-14.9 8.7-33.4 0-48.4l-112-192z"]
  },
      _v = {
    prefix: "fas",
    iconName: "highlighter",
    icon: [544, 512, [], "f591", "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"]
  },
      $v = {
    prefix: "fas",
    iconName: "hiking",
    icon: [384, 512, [], "f6ec", "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"]
  },
      cd = {
    prefix: "fas",
    iconName: "hippo",
    icon: [640, 512, [], "f6ed", "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      ed = {
    prefix: "fas",
    iconName: "history",
    icon: [512, 512, [], "f1da", "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"]
  },
      ad = {
    prefix: "fas",
    iconName: "hockey-mask",
    icon: [448, 512, [], "f6ee", "M376.61 54.46c-82.95-72.61-222.26-72.61-305.22 0C7.36 110.5-31.01 224.44 32.63 416 64.53 512 224 512 224 512s159.47 0 191.37-96c63.64-191.56 25.27-305.5-38.76-361.54zM288 64c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm-128 0c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm16 400c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm0-64c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm0-64c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm-48-64c-35.35 0-64-28.65-64-64 0-17.67 14.33-32 32-32h64c17.67 0 32 14.33 32 32 0 35.35-28.65 64-64 64zm96-128c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm48 320c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm0-64c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm0-64c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm48-64c-35.35 0-64-28.65-64-64 0-17.67 14.33-32 32-32h64c17.67 0 32 14.33 32 32 0 35.35-28.65 64-64 64z"]
  },
      nd = {
    prefix: "fas",
    iconName: "hockey-puck",
    icon: [512, 512, [], "f453", "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"]
  },
      td = {
    prefix: "fas",
    iconName: "hockey-sticks",
    icon: [640, 512, [], "f454", "M0 368v128c0 8.8 7.2 16 16 16h48V352H16c-8.8 0-16 7.2-16 16zM484.6 30.3L427.4 1.7c-7.9-4-17.5-.7-21.5 7.2L238.8 343.2c-2.7 5.4-8.2 8.8-14.3 8.8H96v160h126.1c24.2 0 46.4-13.7 57.2-35.4L491.8 51.8c3.9-7.9.7-17.5-7.2-21.5zm-245.1 204L293.2 127 234.1 8.8c-4-7.9-13.6-11.1-21.5-7.2l-57.3 28.6c-7.9 4-11.1 13.6-7.2 21.5l91.4 182.6zM624 352h-48v160h48c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-223.5-10.3L346.8 449c12.6 25.2 25.4 63 71.1 63H544V352H415.6c-4.6 0-10.8-1.7-15.1-10.3z"]
  },
      rd = {
    prefix: "fas",
    iconName: "holly-berry",
    icon: [448, 512, [], "f7aa", "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"]
  },
      id = {
    prefix: "fas",
    iconName: "home",
    icon: [576, 512, [], "f015", "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"]
  },
      od = {
    prefix: "fas",
    iconName: "home-alt",
    icon: [576, 512, [], "f80a", "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"]
  },
      ld = {
    prefix: "fas",
    iconName: "home-heart",
    icon: [576, 512, [], "f4c9", "M64 311.4V496c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V311.4c-6.7-5.5-44.7-38.3-224-196.4C107.9 273.9 70.4 306.1 64 311.4zm314.1-26.3c27.6 23 29.1 64.2 4.5 89.1l-84.7 85.6c-5.5 5.5-14.3 5.5-19.8 0l-84.7-85.6c-24.6-24.9-23.2-66.1 4.3-89.1 24-20 59.7-16.4 81.6 5.8l8.6 8.7 8.6-8.7c22-22.2 57.7-25.8 81.6-5.8zM64 311.4v-.3s-2.7 2.5 0 .3zm506.7-75.1L512 184.5V48c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v51.7L314.7 10.3c-15.3-13.7-38.2-13.7-53.5 0l-256 226c-6.6 5.9-7.1 16-1.2 22.6l21.4 23.8c5.9 6.6 16 7.1 22.6 1.2L277.4 81.7c6-5.3 15.1-5.3 21.2 0L527.9 284c6.6 5.9 16.7 5.4 22.6-1.2l21.4-23.8c5.9-6.7 5.4-16.8-1.2-22.7zM512 311.1v.3c2.9 2.3 0-.3 0-.3z"]
  },
      fd = {
    prefix: "fas",
    iconName: "home-lg",
    icon: [576, 512, [], "f80b", "M570.69 236.28L512 184.45V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v51.69L314.75 10.31a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59zM288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V368a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v128a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2z"]
  },
      sd = {
    prefix: "fas",
    iconName: "home-lg-alt",
    icon: [576, 512, [], "f80c", "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V368a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v128a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm282.69 121.28l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"]
  },
      ud = {
    prefix: "fas",
    iconName: "hood-cloak",
    icon: [576, 512, [], "f6ef", "M288.27 192c-70.69 0-128 57.31-128 128v192h256V320c0-70.69-57.3-128-128-128zm281.37 268.84C511.97 383.87 511.97 320 511.97 320h.06v-64c0-84.03-46.37-123.05-101.18-182.7l39.75-39.75C462.99 21.17 454.22 0 436.71 0H287.6C192 0 64.03 109.45 64.03 256v64s0 63.87-57.67 140.84C1.89 466.8-.07 473.48 0 480c.19 16.52 13.46 32 32.33 32h95.94V320c0-88.22 71.78-160 160-160s160 71.78 160 160v192h95.4c18.87 0 32.14-15.48 32.33-32 .07-6.52-1.89-13.2-6.36-19.16z"]
  },
      hd = {
    prefix: "fas",
    iconName: "horizontal-rule",
    icon: [640, 512, [], "f86c", "M640 239.87v31.26A15.88 15.88 0 0 1 624.14 287H15.87A15.88 15.88 0 0 1 0 271.13v-31.26A15.88 15.88 0 0 1 15.87 224h608.27A15.88 15.88 0 0 1 640 239.87z"]
  },
      md = {
    prefix: "fas",
    iconName: "horse",
    icon: [576, 512, [], "f6f0", "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      vd = {
    prefix: "fas",
    iconName: "horse-head",
    icon: [512, 512, [], "f7ab", "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"]
  },
      dd = {
    prefix: "fas",
    iconName: "horse-saddle",
    icon: [576, 512, [], "f8c3", "M128 160v-25.83a96.74 96.74 0 0 0-40 26.94V160a88.09 88.09 0 0 0-88 88v56a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-56c0-13.22 6.87-24.39 16.78-31.69-.22 2.6-.78 5.07-.78 7.69a95.47 95.47 0 0 0 30.53 69.88l-25.72 68.6a64.13 64.13 0 0 0-2.15 38l24.84 99.4c1.69 6.68 8.62 12.12 15.5 12.12h66a16 16 0 0 0 15.53-19.88l-26.34-105.26L186 323.27l22 3.66v-72.54A95.83 95.83 0 0 1 128 160zm160 0v-32H160v32a64 64 0 0 0 128 0zm287.9-83.41a31.69 31.69 0 0 0-8.56-21.79c-3.78-4-8.59-9.11-13.69-14.5 11.07-6.85 19.5-17.49 22.19-30.66A8.11 8.11 0 0 0 567.9 0h-120A127.94 127.94 0 0 0 320 127.05v33a95.83 95.83 0 0 1-80 94.39v77.87l80 13.33V496a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V318.22A111.5 111.5 0 0 0 448 240a3.55 3.55 0 0 0-.1-.64V136.89l16 7.11 18.91 37.7a32 32 0 0 0 40.5 15.36l32.56-13C567 179.61 576 166.3 576 154.34zM511.9 96a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"]
  },
      Md = {
    prefix: "fas",
    iconName: "hospital",
    icon: [448, 512, [], "f0f8", "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"]
  },
      pd = {
    prefix: "fas",
    iconName: "hospital-alt",
    icon: [576, 512, [], "f47d", "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"]
  },
      zd = {
    prefix: "fas",
    iconName: "hospital-symbol",
    icon: [512, 512, [], "f47e", "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"]
  },
      Cd = {
    prefix: "fas",
    iconName: "hospital-user",
    icon: [640, 512, [], "f80d", "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"]
  },
      Ld = {
    prefix: "fas",
    iconName: "hospitals",
    icon: [640, 512, [], "f80e", "M256 96V32a32 32 0 0 0-32-32H64a32 32 0 0 0-32 32v64a32 32 0 0 0-32 32v352a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V128a32 32 0 0 0-32-32zM128 404a12 12 0 0 1-12 12H76a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H76a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm26-116h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26v26a6 6 0 0 1-6 6zm70 244a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zM608 96V32a32 32 0 0 0-32-32H416a32 32 0 0 0-32 32v64a32 32 0 0 0-32 32v352a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V128a32 32 0 0 0-32-32zM480 404a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm26-116h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26v26a6 6 0 0 1-6 6zm70 244a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"]
  },
      Ad = {
    prefix: "fas",
    iconName: "hot-tub",
    icon: [512, 512, [], "f593", "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"]
  },
      Nd = {
    prefix: "fas",
    iconName: "hotdog",
    icon: [512, 512, [], "f80f", "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"]
  },
      gd = {
    prefix: "fas",
    iconName: "hotel",
    icon: [576, 512, [], "f594", "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"]
  },
      Hd = {
    prefix: "fas",
    iconName: "hourglass",
    icon: [384, 512, [], "f254", "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"]
  },
      Vd = {
    prefix: "fas",
    iconName: "hourglass-end",
    icon: [384, 512, [], "f253", "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"]
  },
      xd = {
    prefix: "fas",
    iconName: "hourglass-half",
    icon: [384, 512, [], "f252", "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"]
  },
      wd = {
    prefix: "fas",
    iconName: "hourglass-start",
    icon: [384, 512, [], "f251", "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"]
  },
      yd = {
    prefix: "fas",
    iconName: "house",
    icon: [576, 512, [], "e00d", "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.76,10.3C308.48,4.61,296.51,0,288,0s-20.45,4.61-26.73,10.3l-256,226a16,16,0,0,0-1.2,22.6l21.4,23.8A18.31,18.31,0,0,0,37.42,288a18.51,18.51,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.87l15.91,14A18.62,18.62,0,0,0,538.63,288a18.12,18.12,0,0,0,11.87-5.31l21.41-23.81A18.61,18.61,0,0,0,576,248.18,18.21,18.21,0,0,0,570.69,236.27ZM352,298.66A21.39,21.39,0,0,1,330.64,320h-85.3A21.39,21.39,0,0,1,224,298.66V213.32A21.39,21.39,0,0,1,245.34,192h85.3A21.39,21.39,0,0,1,352,213.32Z"]
  },
      bd = {
    prefix: "fas",
    iconName: "house-damage",
    icon: [576, 512, [], "f6f1", "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"]
  },
      Sd = {
    prefix: "fas",
    iconName: "house-day",
    icon: [640, 512, [], "e00e", "M136,176a40,40,0,1,0,40-40A40.07,40.07,0,0,0,136,176ZM635.23,292.42,576,240V144a16,16,0,0,0-16-16H528a16,16,0,0,0-16,16v39.29l-88.48-78.37a35.32,35.32,0,0,0-46.92,0L164.8,292.42a14.18,14.18,0,0,0-1.23,20l18.79,21.28a14.21,14.21,0,0,0,20,1.25L224,315.87V480a32,32,0,0,0,32,32H544a32,32,0,0,0,32-32V315.84L597.62,335a14.28,14.28,0,0,0,20-1.25l18.79-21.28A14.25,14.25,0,0,0,635.23,292.42ZM448,368a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V304a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16ZM104,176a72,72,0,0,1,144,0v0l42.83-37.93-10.54-5.26,23-69a11.88,11.88,0,0,0-15.06-15l-69,23L186.66,6.6a11.9,11.9,0,0,0-21.31,0L132.83,71.7l-69.09-23a11.88,11.88,0,0,0-15.06,15l23,69L6.6,165.34a11.91,11.91,0,0,0,0,21.32l65.11,32.51-23,69.1a11.89,11.89,0,0,0,15.06,15.06l69-23,.74,1.49a46.66,46.66,0,0,1,10.08-13.32l24.07-21.31C131.92,243,104,212.84,104,176Z"]
  },
      Td = {
    prefix: "fas",
    iconName: "house-flood",
    icon: [576, 512, [], "f74f", "M21.4 244c-5.9-6.6-5.2-16.7 1.4-22.6L261.6 10c15.1-13.4 37.8-13.4 52.9 0L416 99.9V48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v108.6l73.2 64.8c6.6 5.9 7.2 16 1.4 22.6l-21.2 24c-5.9 6.6-16 7.2-22.6 1.4L288 72.1 65.2 269.4c-6.6 5.9-16.7 5.2-22.6-1.4l-21.2-24zm540.7 203.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zM288 114.8l192 170v99.8h-.1c-16 0-31.6 5.5-43.9 15.4-12.2 9.8-31.5 15.6-51.7 15.6-21.2 0-40.7-6.1-53.5-16.7-11.7-9.7-26.1-14.8-41.6-14.8-16.2 0-32.3 5.7-45.5 16.1-12.4 9.8-31.1 15.4-51.5 15.4-21.2 0-40.7-6.1-53.5-16.7-11.6-9.6-26-14.7-41.4-14.7-.5 0-.9.1-1.4.1v-99.4L288 114.8zM320 224h-64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"]
  },
      Dd = {
    prefix: "fas",
    iconName: "house-leave",
    icon: [640, 512, [], "e00f", "M356.87,384.5a30.05,30.05,0,0,0,6.95-10.64l20.71-51.5,11.76-29.25c-.48-3-.81-6-1-9a63.54,63.54,0,0,1-58,.39c-31.26-15.74-44.05-54.16-28.52-85.64l6.73-13.65a127.24,127.24,0,0,1,66.4-61.67l7.52-3.07L263.52,8.92a35.32,35.32,0,0,0-46.92,0L4.8,196.42a14.18,14.18,0,0,0-1.23,20l18.79,21.28a14.2,14.2,0,0,0,20,1.25L64,219.87V384a32,32,0,0,0,32,32H325.44ZM224,272a16,16,0,0,1-16,16H144a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16ZM528,96a48,48,0,1,0-48-48A48,48,0,0,0,528,96ZM393.55,385.74a61.78,61.78,0,0,1-14.18,21.49l-50,50.11a32,32,0,0,0,45.18,45.29l59.4-59.4a64.8,64.8,0,0,0,14.2-21.5l13.5-33.79c-55.29-60.29-38.7-41.79-47.4-53.69ZM622.42,245.06l-23.29-11.8-9.7-29.38c-14.7-44.61-55.7-75.81-102.19-75.9-36-.09-55.88,10.09-93.28,25.2a95.46,95.46,0,0,0-49.7,46.2L337.56,213a32.11,32.11,0,0,0,14.2,42.9,31.55,31.55,0,0,0,42.49-14.31L401,228a31.82,31.82,0,0,1,16.49-15.41l26.8-10.79-15.2,60.69A64.23,64.23,0,0,0,444,321.25l59.9,65.4a64.42,64.42,0,0,1,14.89,27.69L537,487.63a32,32,0,0,0,62.1-15.5l-22.2-89a63.81,63.81,0,0,0-14.9-27.7l-45.5-49.7,17.2-68.69,5.5,16.5a63.73,63.73,0,0,0,31.7,37l23.29,11.81a31.57,31.57,0,0,0,42.5-14.31A32.37,32.37,0,0,0,622.42,245.06Z"]
  },
      jd = {
    prefix: "fas",
    iconName: "house-night",
    icon: [640, 512, [], "e010", "M112,224a111.77,111.77,0,0,0,87-41.47,5.25,5.25,0,0,0-5.05-8.47A87.74,87.74,0,0,1,134.11,11.6a5.26,5.26,0,0,0-1.65-9.73A136.16,136.16,0,0,0,112,0a112,112,0,0,0,0,224Zm523.23,68.42L576,240V144a16,16,0,0,0-16-16H528a16,16,0,0,0-16,16v39.29l-88.48-78.37a35.32,35.32,0,0,0-46.92,0L164.8,292.42a14.19,14.19,0,0,0-1.23,20l18.79,21.28a14.2,14.2,0,0,0,20,1.25L224,315.87V480a32,32,0,0,0,32,32H544a32,32,0,0,0,32-32V315.84L597.62,335a14.28,14.28,0,0,0,20-1.25l18.79-21.28A14.25,14.25,0,0,0,635.23,292.42ZM448,368a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V304a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16ZM195,68.78l39.72,16.56,16.56,39.72a5.32,5.32,0,0,0,9.54,0l16.56-39.72,39.72-16.56a5.33,5.33,0,0,0,0-9.54L277.33,42.68,260.77,3a5.32,5.32,0,0,0-9.54,0L234.67,42.68,195,59.24a5.33,5.33,0,0,0,0,9.54Zm-37.9,310.46-39.72-16.56L100.77,323a5.32,5.32,0,0,0-9.54,0L74.67,362.68,35,379.24a5.33,5.33,0,0,0,0,9.54l39.72,16.56,16.56,39.72a5.32,5.32,0,0,0,9.54,0l16.56-39.72,39.72-16.56a5.33,5.33,0,0,0,0-9.54Z"]
  },
      Ed = {
    prefix: "fas",
    iconName: "house-return",
    icon: [640, 512, [], "e011", "M374.8,333.36a63.48,63.48,0,0,1-80.3-31.17c-15.47-31.51-2.63-69.95,28.56-85.65l11.51-5.83,5.56-16.83a143.26,143.26,0,0,1,51.95-71.1L263.52,8.92a35.32,35.32,0,0,0-46.92,0L4.8,196.41a14.19,14.19,0,0,0-1.23,20l18.79,21.29a14.21,14.21,0,0,0,20,1.24L64,219.87V384a32,32,0,0,0,32,32H341.86L352,375.38a95.83,95.83,0,0,1,22.33-41.5ZM224,272a16,16,0,0,1-16,16H144a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16Zm307-9.51-15.2-60.69,26.79,10.79A31.81,31.81,0,0,1,559,228l6.71,13.59a31.56,31.56,0,0,0,42.49,14.31,32.11,32.11,0,0,0,14.2-42.9l-6.7-13.59A95.44,95.44,0,0,0,566,153.21c-37.4-15.11-57.29-25.3-93.28-25.2-46.49.09-87.49,31.29-102.19,75.89l-9.7,29.38-23.29,11.8a32.37,32.37,0,0,0-14.3,43,31.58,31.58,0,0,0,42.5,14.31l23.29-11.81a63.75,63.75,0,0,0,31.7-37l5.5-16.49,17.2,68.69L398,355.46a63.83,63.83,0,0,0-14.9,27.69l-22.2,89a32,32,0,0,0,62.1,15.5l18.29-73.28a64.51,64.51,0,0,1,14.89-27.7l59.9-65.39A64.21,64.21,0,0,0,531,262.48ZM432,96a48,48,0,1,0-48-48A48,48,0,0,0,432,96ZM630.63,457.34l-50-50.1a61.78,61.78,0,0,1-14.18-21.49l-20.7-51.49c-8.7,11.9,7.89-6.59-47.4,53.69l13.5,33.79a64.75,64.75,0,0,0,14.2,21.49l59.4,59.4a32,32,0,0,0,45.18-45.29Z"]
  },
      kd = {
    prefix: "fas",
    iconName: "house-signal",
    icon: [640, 512, [], "e012", "M635.23,196.42,576,144V48a16,16,0,0,0-16-16H528a16,16,0,0,0-16,16V87.29L423.52,8.92a35.32,35.32,0,0,0-46.92,0L164.8,196.42a14.19,14.19,0,0,0-1.23,20l18.79,21.28a14.2,14.2,0,0,0,20,1.25L224,219.87v64A320.42,320.42,0,0,1,305.24,416H544a32,32,0,0,0,32-32V219.84L597.62,239a14.28,14.28,0,0,0,20-1.25l18.79-21.28A14.25,14.25,0,0,0,635.23,196.42ZM448,272a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16ZM0,416v96H96A96,96,0,0,0,0,416Zm0-96v63.93A128.12,128.12,0,0,1,128.07,512H192C192,406,106,320,0,320Zm0-96H0v63.93c123.71,0,224.07,100.36,224.07,224.07H288C288,352.94,159.06,224,0,224Z"]
  },
      Id = {
    prefix: "fas",
    iconName: "house-user",
    icon: [576, 512, [], "e065", "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"]
  },
      Od = {
    prefix: "fas",
    iconName: "hryvnia",
    icon: [384, 512, [], "f6f2", "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"]
  },
      Qd = {
    prefix: "fas",
    iconName: "humidity",
    icon: [384, 512, [], "f750", "M223.9 22.1c-8.7-28.8-53.9-30.1-63.8 0C109.1 179.8 0 222.7 0 333.9 0 432.3 85.9 512 192 512s192-79.7 192-178.1c0-111.7-108.9-153.3-160.1-311.8zM96 288c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm49.5 131.8c-2.8 3.5-7.8 4-11.2 1.2l-12.5-10c-3.4-2.8-4-7.8-1.2-11.2l118-147.5c2.8-3.4 7.8-4 11.2-1.2l12.5 10c3.5 2.8 4 7.8 1.2 11.2l-118 147.5zM256 416c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Zd = {
    prefix: "fas",
    iconName: "hurricane",
    icon: [384, 512, [], "f751", "M176 96l24.5-74.8C204.2 10 194.9-1.3 183.1.1 80 12.4 0 101.6 0 208c0 114.9 93.1 208 208 208l-24.5 74.8c-3.7 11.2 5.6 22.5 17.4 21.1C304 499.6 384 410.4 384 304c0-114.9-93.1-208-208-208zm16 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      Ud = {
    prefix: "fas",
    iconName: "i-cursor",
    icon: [256, 512, [], "f246", "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"]
  },
      Bd = {
    prefix: "fas",
    iconName: "ice-cream",
    icon: [448, 512, [], "f810", "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"]
  },
      Rd = {
    prefix: "fas",
    iconName: "ice-skate",
    icon: [576, 512, [], "f7ac", "M568 416h-32c-4.4 0-8 3.6-8 8v16c0 13.3-10.7 24-24 24h-72v-48h-48v48H144v-48H96v48H8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h504c35.3 0 64-28.7 64-64v-24c0-4.4-3.6-8-8-8zM64 384h416c17.7 0 32-14.3 32-32v-37c0-44.1-30-82.4-72.7-93.1L320 192h-56c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h56v-32h-56c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h56V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16L78.4 82.7c-27.5 7.9-46.4 33-46.4 61.5V352c0 17.7 14.3 32 32 32z"]
  },
      Yd = {
    prefix: "fas",
    iconName: "icicles",
    icon: [512, 512, [], "f7ad", "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"]
  },
      Pd = {
    prefix: "fas",
    iconName: "icons",
    icon: [512, 512, [], "f86d", "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"]
  },
      Fd = {
    prefix: "fas",
    iconName: "icons-alt",
    icon: [512, 512, [], "f86e", "M16 160h64v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-48h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-96h192a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H16A16 16 0 0 0 0 16v32a16 16 0 0 0 16 16zM478.08.33L329.51 23.18C314.87 25.44 304 38.94 304 54.86V161.7a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.49-64 48s28.65 48 64 48c35.2 0 63.73-21.33 64-47.69V99.73L464 82.5v47.2a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.49-64 48s28.65 48 64 48c35.2 0 63.73-21.33 64-47.69V32c0-19.47-16-34.43-33.92-31.67zM328 368a40 40 0 1 0-40-40 40 40 0 0 0 40 40zm-108.41 15.94L197 361.31a16 16 0 0 0-22.63 0l-27.92 27.89-22.7-22.7a64 64 0 1 0-90.7-3.3l-6.92 6.92c-29.59 29.59-35.69 77.63-9.81 110.52A81.31 81.31 0 0 0 138 488.19l8.48-8.49 27.61 27.61a16 16 0 0 0 22.63 0l22.62-22.62a16 16 0 0 0 0-22.63l-27.64-27.61 27.89-27.89a16 16 0 0 0 0-22.62zM80 304a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm12.72 138.94a17.29 17.29 0 1 1-24.45-24.46l8.48-8.48 24.45 24.45zm392-150.25a16 16 0 0 0-22.63 0l-169.4 169.37a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l169.37-169.37a16 16 0 0 0 0-22.63zM472 432a40 40 0 1 0 40 40 40 40 0 0 0-40-40z"]
  },
      Wd = {
    prefix: "fas",
    iconName: "id-badge",
    icon: [384, 512, [], "f2c1", "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"]
  },
      Gd = {
    prefix: "fas",
    iconName: "id-card",
    icon: [576, 512, [], "f2c2", "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"]
  },
      qd = {
    prefix: "fas",
    iconName: "id-card-alt",
    icon: [576, 512, [], "f47f", "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"]
  },
      Jd = {
    prefix: "fas",
    iconName: "igloo",
    icon: [576, 512, [], "f7ae", "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"]
  },
      Kd = {
    prefix: "fas",
    iconName: "image",
    icon: [512, 512, [], "f03e", "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"]
  },
      Xd = {
    prefix: "fas",
    iconName: "image-polaroid",
    icon: [448, 512, [], "f8c4", "M128 192a32 32 0 1 0-32-32 32 32 0 0 0 32 32zM416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 320H64V96h320zM268.8 209.07a16 16 0 0 0-25.6 0l-49.32 65.75L173.31 244a16 16 0 0 0-26.62 0L96 320h256z"]
  },
      _d = {
    prefix: "fas",
    iconName: "images",
    icon: [576, 512, [], "f302", "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"]
  },
      $d = {
    prefix: "fas",
    iconName: "inbox",
    icon: [576, 512, [], "f01c", "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"]
  },
      cM = {
    prefix: "fas",
    iconName: "inbox-in",
    icon: [576, 512, [], "f310", "M250.5 0h68.6c9.5 0 17.1 7.7 17.1 17.1V160h68.3c17.8 0 26.7 21.5 14.1 34.1l-119.4 120c-7.9 7.9-20.9 7.8-28.6-.3L157 193.8c-12.1-12.7-3.1-33.8 14.5-33.8h61.9V17.1c0-9.4 7.7-17.1 17.1-17.1zm315 338.9l-94.6-118.2c-4.5-5.6-13-6-18-.9l-28.1 28.9c-4.2 4.3-4.5 11.1-.8 15.9l44.3 55.4H376l-32 64H232l-32-64h-92.4l43.8-54.7c3.7-4.7 3.5-11.4-.6-15.7l-27.6-29.5c-5-5.3-13.6-5-18.1.7l-94.4 118c-7 8.6-10.7 19.1-10.7 30V464c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48v-95.2c0-10.9-3.7-21.4-10.5-29.9z"]
  },
      eM = {
    prefix: "fas",
    iconName: "inbox-out",
    icon: [576, 512, [], "f311", "M576 368.8V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-95.2c0-10.9 3.7-21.5 10.5-30l94.4-118c4.6-5.7 13.1-6 18.1-.7l27.6 29.5c4.1 4.4 4.3 11 .6 15.7L107.6 320H200l32 64h112l32-64h92.4l-44.3-55.4c-3.8-4.7-3.5-11.5.8-15.9l28.1-28.9c5-5.2 13.5-4.8 18 .9l94.6 118.2c6.7 8.5 10.4 19 10.4 29.9zm-233.4-65.9V160h61.9c17.6 0 26.6-21.1 14.5-33.8L305.3 6.2c-7.7-8.1-20.7-8.3-28.6-.3l-119.4 120c-12.6 12.6-3.7 34.1 14.1 34.1h68.3v142.9c0 9.5 7.7 17.1 17.1 17.1h68.6c9.5 0 17.2-7.7 17.2-17.1z"]
  },
      aM = {
    prefix: "fas",
    iconName: "indent",
    icon: [448, 512, [], "f03c", "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      nM = {
    prefix: "fas",
    iconName: "industry",
    icon: [512, 512, [], "f275", "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"]
  },
      tM = {
    prefix: "fas",
    iconName: "industry-alt",
    icon: [512, 512, [], "f3b3", "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248zM404 384h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm-128 0h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm-128 0h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"]
  },
      rM = {
    prefix: "fas",
    iconName: "infinity",
    icon: [640, 512, [], "f534", "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"]
  },
      iM = {
    prefix: "fas",
    iconName: "info",
    icon: [192, 512, [], "f129", "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"]
  },
      oM = {
    prefix: "fas",
    iconName: "info-circle",
    icon: [512, 512, [], "f05a", "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"]
  },
      lM = {
    prefix: "fas",
    iconName: "info-square",
    icon: [448, 512, [], "f30f", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-176 86c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"]
  },
      fM = {
    prefix: "fas",
    iconName: "inhaler",
    icon: [640, 512, [], "f5f9", "M32 448c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm0-192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm0 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96-48c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zM616.27 38.02L478.47 1.1c-17.07-4.57-34.62 5.56-39.19 22.63l-15.41 57.52 168.74 168.74L638.9 77.21c4.58-17.07-5.55-34.61-22.63-39.19zm-207.08 73.8c-8.74-8.74-23.66-4.7-26.79 7.26L346.49 256H224c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h295.31c14.55 0 27.26-9.81 30.95-23.88l44.22-168.59c2.88-11-.29-22.71-8.33-30.75L409.19 111.82zM128 400c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
  },
      sM = {
    prefix: "fas",
    iconName: "integral",
    icon: [384, 512, [], "f667", "M377.21 73.03l-28-36.17C328.43 9.98 295.87-3.75 262.05.89 221.86 6.41 190.54 40 181.42 80.82l-78.16 334.36-23.95-30.91c-10.69-13.79-30.18-16.03-43.53-4.98l-24.17 20c-13.35 11.05-15.51 31.19-4.82 44.98l21.42 27.65c15.98 20.63 38.53 35.82 63.89 39.21 49.82 6.67 94.4-26.18 105.34-75.22l79.2-339.11 28.03 36.2c10.68 13.8 30.17 16.04 43.52 5l24.18-20c13.36-11.03 15.53-31.17 4.84-44.97z"]
  },
      uM = {
    prefix: "fas",
    iconName: "intersection",
    icon: [384, 512, [], "f668", "M166.74 33.62C69.96 46.04 0 133.11 0 230.68V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V224c0-59.2 53.85-106.04 115.13-94.14 45.58 8.85 76.87 51.5 76.87 97.93V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V224c0-114.18-100.17-205.4-217.26-190.38z"]
  },
      hM = {
    prefix: "fas",
    iconName: "inventory",
    icon: [640, 512, [], "f480", "M624 0h-32c-8.8 0-16 7.2-16 16v144H64V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v496h64v-32h512v32h64V16c0-8.8-7.2-16-16-16zm-48 416H64V224h512v192zM368 128h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zM112 384h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm160 0h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16z"]
  },
      mM = {
    prefix: "fas",
    iconName: "island-tropical",
    icon: [448, 512, [], "f811", "M336.53 32c-34.88 0-65.66 13.82-86.3 35.08C235.78 28.29 193.72 0 143.47 0 87 0 40.31 35.43 32.18 81.64A12.38 12.38 0 0 0 44.6 96H80l16-32 16 32h30.17c-34.21 35-39.62 86.88-14.54 122.58 4.36 6.2 13.14 7.31 18.5 1.95l71-71c4 79.62-11 159.62-21 202.5H142.8A144 144 0 0 0 .36 474.78C-2.53 494.3 12.39 512 32.12 512H352c18.46 0 34.11-15.74 31.8-34.05-7-55.68-47.06-101-99-118.13 10.2-88.69-7.32-183.68-18.52-231.82H368l16-32 16 32h35.4a12.38 12.38 0 0 0 12.42-14.36C439.69 67.43 393 32 336.53 32z"]
  },
      vM = {
    prefix: "fas",
    iconName: "italic",
    icon: [320, 512, [], "f033", "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"]
  },
      dM = {
    prefix: "fas",
    iconName: "jack-o-lantern",
    icon: [576, 512, [], "f30e", "M352 106.6V35.81c0-6.06-3.42-11.6-8.84-14.31l-39.6-19.8c-8.37-4.19-18.54-.32-22.01 8.37l-36.06 90.15C258.62 97.58 272.65 96 288 96c24.28 0 45.23 3.99 64 10.6zm143.3 46.53c-27-23.09-65.36-29.76-99.49-20.93 6.09 5.5 12.16 11.02 17.19 17.8 3.1 4.26 5.46 9.42 8.15 14.17C389.39 140.55 345.54 128 288 128s-101.39 12.54-133.15 36.17c2.69-4.75 5.04-9.91 8.15-14.17 5.02-6.78 11.1-12.29 17.19-17.8-34.13-8.83-72.49-2.16-99.49 20.93-107.6 92.01-107.6 241.72 0 333.74 38.63 33.03 100.82 33.34 140.12 1.25C238.65 503.51 260.72 512 288 512s49.35-8.49 67.19-23.88c39.3 32.09 101.49 31.78 140.12-1.25 107.59-92.01 107.59-241.73-.01-333.74zM320.85 278L362 211.33c2.33-4.57 8.6-4.42 12 0L415.15 278c1.66 3.25.9 10-6 10h-82.29c-6.9 0-7.7-6.69-6.01-10zm-160 0L202 211.33c2.33-4.57 8.6-4.42 12 0L255.15 278c1.66 3.25.9 10-6 10h-82.29c-6.9 0-7.7-6.69-6.01-10zm308.95 67.6c-5.96 17.04-12.75 28.62-18.7 36.96-9.38 12.94-21.34 23.8-35.19 32.99-.25-8.62-7.23-15.55-15.91-15.55h-16c-8.84 0-16 7.16-16 16v21.48c-23.46 6.88-50.16 10.52-79.98 10.52-29.85 0-56.56-3.65-80.02-10.51V416c0-8.84-7.16-16-16-16h-16c-8.7 0-15.71 6.97-15.92 15.63-13.71-9.08-25.53-19.79-34.75-32.51-6.12-8.59-13.02-20.31-19.04-37.46-4.87-13.89 10.56-26.15 23.24-18.67 32.94 19.44 70.39 32.74 110.47 38.84V384c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-14.26h.02c58.38 0 112.72-15.74 158.54-42.79 12.66-7.48 28.09 4.77 23.24 18.65z"]
  },
      MM = {
    prefix: "fas",
    iconName: "jedi",
    icon: [576, 512, [], "f669", "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"]
  },
      pM = {
    prefix: "fas",
    iconName: "joint",
    icon: [640, 512, [], "f595", "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"]
  },
      zM = {
    prefix: "fas",
    iconName: "journal-whills",
    icon: [448, 512, [], "f66a", "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"]
  },
      CM = {
    prefix: "fas",
    iconName: "joystick",
    icon: [448, 512, [], "f8c5", "M416 352H128v-16a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v16H32a32 32 0 0 0-32 32v96a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-96a32 32 0 0 0-32-32zM192 218.8V320h64V218.8c46.15-13.8 80-56.14 80-106.8a112 112 0 0 0-224 0c0 50.66 33.85 93 80 106.8zM200 48a24 24 0 1 1-24 24 24 24 0 0 1 24-24z"]
  },
      LM = {
    prefix: "fas",
    iconName: "jug",
    icon: [448, 512, [], "f8c6", "M448 168a71.72 71.72 0 0 0-126.68-46.35L311 108.77A31.66 31.66 0 0 1 305.23 96H142.77a31.66 31.66 0 0 1-5.77 12.77l-76.95 96.17a128 128 0 0 0-28 80V448a64 64 0 0 0 64 64H352a64 64 0 0 0 64-64V284.9a127.59 127.59 0 0 0-11.1-51A72 72 0 0 0 448 168zm-96 216a32 32 0 0 1-32 32H128a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h192a32 32 0 0 1 32 32zm25.38-192.28l-24.09-30.1C356.14 151.54 365 144 376 144a23.88 23.88 0 0 1 1.38 47.72zM152 64h144a23.94 23.94 0 0 0 24-24V24a23.94 23.94 0 0 0-24-24H152a23.94 23.94 0 0 0-24 24v16a23.94 23.94 0 0 0 24 24z"]
  },
      AM = {
    prefix: "fas",
    iconName: "kaaba",
    icon: [576, 512, [], "f66b", "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"]
  },
      NM = {
    prefix: "fas",
    iconName: "kazoo",
    icon: [640, 512, [], "f8c7", "M608 128h-95.42c-19.51-9.89-41.25-16-64.58-16s-45.07 6.11-64.58 16H241.93a128.3 128.3 0 0 0-35.17 4.92L23.21 185.37A32 32 0 0 0 0 216.14v79.72a32 32 0 0 0 23.21 30.77l183.55 52.44a127.93 127.93 0 0 0 35.17 4.93h141.49c19.51 9.89 41.25 16 64.58 16s45.07-6.11 64.58-16H608a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32zM448 352a96 96 0 1 1 96-96 96 96 0 0 1-96 96zm50.91-135.6l-11.31-11.31a8 8 0 0 0-11.32 0L448 233.37l-28.29-28.28a8 8 0 0 0-11.31 0l-11.31 11.31a8 8 0 0 0 0 11.31L425.37 256l-28.28 28.28a8 8 0 0 0 0 11.32l11.31 11.31a8 8 0 0 0 11.31 0L448 278.63l28.28 28.28a8 8 0 0 0 11.32 0l11.31-11.31a8 8 0 0 0 0-11.32L470.63 256l28.28-28.29a8 8 0 0 0 0-11.31z"]
  },
      gM = {
    prefix: "fas",
    iconName: "kerning",
    icon: [640, 512, [], "f86f", "M416.54 0h-17A8 8 0 0 0 392 5.32l-176.28 496a8 8 0 0 0 7.55 10.68h17a8 8 0 0 0 7.54-5.32l176.28-496A8 8 0 0 0 416.54 0zM304 96h-50.62a16 16 0 0 0-15.16 10.89L160 306.68 81.78 106.89A16 16 0 0 0 66.62 96H16A16 16 0 0 0 .85 117.11l105.27 277.2a32 32 0 0 0 30.3 21.69h47.16a32 32 0 0 0 30.3-21.69l105.27-277.2A16 16 0 0 0 304 96zm335.15 298.89l-105.27-277.2A32 32 0 0 0 503.58 96h-47.16a32 32 0 0 0-30.3 21.69l-105.27 277.2A16 16 0 0 0 336 416h50.61a16 16 0 0 0 15.16-10.89L416.31 368h127.38l14.53 37.11A16 16 0 0 0 573.38 416H624a16 16 0 0 0 15.15-21.11zM447.63 288L480 205.32 512.37 288z"]
  },
      HM = {
    prefix: "fas",
    iconName: "key",
    icon: [512, 512, [], "f084", "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"]
  },
      VM = {
    prefix: "fas",
    iconName: "key-skeleton",
    icon: [512, 512, [], "f6f3", "M448 0H320c-35.35 0-64 28.65-64 64v153.6L4.69 468.91c-6.25 6.25-6.25 16.38 0 22.63l15.77 15.77c6.25 6.25 16.38 6.25 22.63 0l36.25-36.25 36.11 36.11c6.25 6.25 16.38 6.25 22.63 0l43.16-43.16c6.25-6.25 6.25-16.38 0-22.63l-36.11-36.11L176 374.4l36.91 36.91c6.25 6.25 16.38 6.25 22.63 0l15.77-15.77c6.25-6.25 6.25-16.38 0-22.63L214.4 336l80-80H448c35.35 0 64-28.65 64-64V64c0-35.35-28.65-64-64-64zm-73.37 182.63c-12.5 12.5-32.76 12.5-45.26 0s-12.5-32.76 0-45.25c12.5-12.5 32.76-12.5 45.26 0 12.49 12.49 12.49 32.75 0 45.25zm64-64c-12.5 12.5-32.76 12.5-45.26 0s-12.5-32.76 0-45.25c12.5-12.5 32.76-12.5 45.26 0 12.49 12.49 12.49 32.75 0 45.25z"]
  },
      xM = {
    prefix: "fas",
    iconName: "keyboard",
    icon: [576, 512, [], "f11c", "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"]
  },
      wM = {
    prefix: "fas",
    iconName: "keynote",
    icon: [512, 512, [], "f66c", "M368 448h-80v-64h-64v64h-80c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm140.62-166.76l-51.78-103.55A32 32 0 0 0 428.22 160H144c0-37.62 26.21-69.06 62.68-77.55C215.31 90.81 227.03 96 240 96h64c26.51 0 48-21.49 48-48S330.51 0 304 0h-64c-22.35 0-40.96 15.34-46.31 36.02C137.77 49.72 96 99.91 96 160H83.78a32 32 0 0 0-28.62 17.69L3.38 281.24A32.066 32.066 0 0 0 0 295.55V320c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-24.45c0-4.96-1.16-9.86-3.38-14.31z"]
  },
      yM = {
    prefix: "fas",
    iconName: "khanda",
    icon: [512, 512, [], "f66d", "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"]
  },
      bM = {
    prefix: "fas",
    iconName: "kidneys",
    icon: [640, 512, [], "f5fb", "M231.6 32.07c-35.33-39.56-96.04-42.99-135.62-7.69C36.08 77.85 2.39 149.96.13 224c-1.28 42.04 7.47 70.91 12.89 90.06 11.94 42.31 50.46 69.93 92.35 69.93 64.31 0 109.65-61.47 92.47-122.11-1.04-3.7-23.08-50.43 26.07-94.27 39.58-35.3 43.02-95.98 7.69-135.54zm72.27 235.7c0-21.31-11.84-40.5-30.97-50.09l-35.84-17.92c-8.57 10.12-16.55 24.95-11.66 42.26l1.82 6.49 24.21 12.11c2.72 1.37 4.44 4.09 4.44 7.16v212.21l.02 16.01c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16l-.02-48V267.77zm62.97-50.09c-19.09 9.59-30.97 28.78-30.97 50.09l.02 212.21V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16l-.02-48V267.77c0-3.03 1.72-5.78 4.47-7.16l23.87-11.94 2.13-7.39c4.89-16.94-3.08-31.56-11.61-41.56l-35.89 17.96zM543.89 24.3C504.34-10.92 443.56-7.45 408.3 32.2c-35.27 39.59-31.73 100.27 7.91 135.52 49.6 44.12 26.49 91.15 25.76 93.71C424.49 322 469.62 384 534.29 384c41.74 0 80.13-27.37 92.26-69.46 5.54-19.27 14.54-48.08 13.35-90.54-2.09-74.03-35.81-146.16-96.01-199.7z"]
  },
      SM = {
    prefix: "fas",
    iconName: "kiss",
    icon: [496, 512, [], "f596", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      TM = {
    prefix: "fas",
    iconName: "kiss-beam",
    icon: [496, 512, [], "f597", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"]
  },
      DM = {
    prefix: "fas",
    iconName: "kiss-wink-heart",
    icon: [504, 512, [], "f598", "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"]
  },
      jM = {
    prefix: "fas",
    iconName: "kite",
    icon: [640, 512, [], "f6f4", "M113.75 315.83l53.38 35.58c10.63 7.09 24.88-.54 24.88-13.31v-68.21c0-12.78-14.24-20.4-24.88-13.31L120 288v-64c0-48.6-39.4-88-88-88H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16c22.09 0 40 17.91 40 40v64l-47.12-31.42C14.24 249.49 0 257.12 0 269.89v68.21c0 12.78 14.24 20.4 24.88 13.31l53.38-35.58a32.004 32.004 0 0 1 35.49 0zM615.8 1.57C613.24.91 610.77 0 608 0H345.46c-2.36 0-4.54.67-6.76 1.16l138.76 138.76L615.8 1.57zM331.31 331.31c-3.12 3.12-8.19 3.12-11.31 0L308.69 320c-3.12-3.12-3.12-8.19 0-11.31l146.14-146.14L315.11 22.82c-.21.7-.66 1.26-.83 1.98l-78.76 341.31c-.39 1.69-.44 3.34-.55 4.99l-88.33 88.33c-9.83 9.83-26.63 2.87-26.63-11.03v-89.95l-24-16-24 16v84.86c0 16.55 5.05 33.04 15.7 45.71 26.48 31.53 68.98 28.26 92.87 4.34l88.31-88.31c1.66-.12 3.32-.19 5.02-.58l341.31-78.76c.72-.17 1.29-.62 1.99-.83L477.46 185.17 331.31 331.31zM638.43 24.2L500.08 162.54 638.84 301.3c.49-2.22 1.16-4.4 1.16-6.75V32c0-2.77-.91-5.24-1.57-7.8z"]
  },
      EM = {
    prefix: "fas",
    iconName: "kiwi-bird",
    icon: [576, 512, [], "f535", "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"]
  },
      kM = {
    prefix: "fas",
    iconName: "knife-kitchen",
    icon: [576, 512, [], "f6f5", "M267.52 216.6L4.87 469.83c-8.72 8.41-5.22 22.73 6.49 26.49 113.84 36.59 239.36 8.02 324.21-73.79l61.04-58.85c6.48-6.25 6.48-16.38 0-22.63L267.52 216.6zM566.28 43.31L531.07 9.37c-12.96-12.5-33.98-12.5-46.94 0l-192.31 185.4 112.1 108.08 34.35-27.71c6.22-6 9.72-14.14 9.72-22.63V208L566.28 88.57c12.96-12.5 12.96-32.76 0-45.26zM444.24 149.66c-6.48 6.25-16.99 6.25-23.47 0s-6.48-16.38 0-22.63 16.99-6.25 23.47 0 6.48 16.38 0 22.63zm60.52-58.35c-6.48 6.25-16.99 6.25-23.47 0s-6.48-16.38 0-22.63 16.99-6.25 23.47 0 6.48 16.39 0 22.63z"]
  },
      IM = {
    prefix: "fas",
    iconName: "lambda",
    icon: [448, 512, [], "f66e", "M424 384h-43.5L197.6 48.68A32.018 32.018 0 0 0 169.5 32H24C10.75 32 0 42.74 0 56v48c0 13.25 10.75 24 24 24h107.5l4.63 8.49L3.25 446.55C-3.53 462.38 8.08 480 25.31 480h52.23c9.6 0 18.28-5.72 22.06-14.55l95.02-221.72L314.4 463.32A32.018 32.018 0 0 0 342.5 480H424c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"]
  },
      OM = {
    prefix: "fas",
    iconName: "lamp",
    icon: [448, 512, [], "f4ca", "M445.5 211.4L368 19.4C363.3 7.6 352.4 0 340.4 0H120.6c-11.4 0-21.8 6.8-27 17.7l-90.4 192c-10 21.3 4.6 46.3 27 46.3h387.7c21.6 0 36.2-23.5 27.6-44.6zM158.3 288C121 325.2 96 386.8 96 428.8c0 28.4 11.5 54.3 30.5 74.3 5.7 6 13.9 8.9 22.2 8.9h150.6c8.3 0 16.5-2.9 22.2-8.9 19-20.1 30.5-45.9 30.5-74.3 0-42-25-103.6-62.3-140.8H158.3z"]
  },
      QM = {
    prefix: "fas",
    iconName: "lamp-desk",
    icon: [512, 512, [], "e014", "M494.42,64H346.5L301.24,18.74a64,64,0,0,0-90.5,90.5l11,11L103,239a24,24,0,0,0-6.11,23.56L149.9,448H64C35.58,448,9.05,466.53.7,492.16-2.52,502,5.88,512,16.26,512H367.74c10.39,0,18.78-10,15.57-19.84C375,466.53,348.42,448,320,448H199.82L147,263,255.72,154.22l.28.28V302.42c0,15.63,18.9,23.46,30,12.4L506.82,94C517.88,82.9,510.05,64,494.42,64ZM379.71,266.33a55.73,55.73,0,0,0,78.62-78.62Z"]
  },
      ZM = {
    prefix: "fas",
    iconName: "lamp-floor",
    icon: [384, 512, [], "e015", "M256,448H224V255.69H160V448H128c-28.42,0-54.95,18.53-63.3,44.16C61.48,502,69.88,512,80.26,512H303.74c10.38,0,18.78-10,15.56-19.84C311,466.53,284.42,448,256,448ZM381.38,179.4l-68.57-160A32,32,0,0,0,283.39,0H100.61A32,32,0,0,0,71.19,19.4L2.62,179.4A32,32,0,0,0,32,224H352A32,32,0,0,0,381.38,179.4Z"]
  },
      UM = {
    prefix: "fas",
    iconName: "landmark",
    icon: [512, 512, [], "f66f", "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      BM = {
    prefix: "fas",
    iconName: "landmark-alt",
    icon: [512, 512, [], "f752", "M48 256h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-18.9C431.6 111.7 368.3 48.4 288 34.9V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v18.9C143.7 48.4 80.4 111.7 66.9 192H48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm448 192h-16v-16c0-8.8-7.2-16-16-16h-16V288h-64v128h-96V288h-64v128h-96V288H64v128H48c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
  },
      RM = {
    prefix: "fas",
    iconName: "language",
    icon: [640, 512, [], "f1ab", "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"]
  },
      YM = {
    prefix: "fas",
    iconName: "laptop",
    icon: [640, 512, [], "f109", "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"]
  },
      PM = {
    prefix: "fas",
    iconName: "laptop-code",
    icon: [640, 512, [], "f5fc", "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"]
  },
      FM = {
    prefix: "fas",
    iconName: "laptop-house",
    icon: [640, 512, [], "e066", "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"]
  },
      WM = {
    prefix: "fas",
    iconName: "laptop-medical",
    icon: [640, 512, [], "f812", "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"]
  },
      GM = {
    prefix: "fas",
    iconName: "lasso",
    icon: [576, 512, [], "f8c8", "M288 0C126.5 0 0 79.63 0 181.3c0 49.78 30.22 95.84 85 129.7 3.52 2.17 7.37 4.29 11.3 6.41 0 .89-.33 1.71-.33 2.6 0 35.35 35.82 64 80 64 .69 0 1.33-.15 2-.16a68.71 68.71 0 0 1 2.69 17.9A45.7 45.7 0 0 1 134.94 448H48a16 16 0 0 0-16 15.94v32.12A16 16 0 0 0 48 512h86.94c59.38 0 108.8-47.22 109.76-106.38A135 135 0 0 0 238 360a468.23 468.23 0 0 0 50 2.58c161.5 0 288-79.63 288-181.28S449.5 0 288 0zm0 298.82c-12.73 0-25.23-.81-37.6-2C238.79 273 210 256 176 256a94.36 94.36 0 0 0-41.2 9.4c-5.58-2.86-11.32-5.69-16.05-8.61C98.31 244.17 64 217.57 64 181.3c0-62.61 104.69-117.54 224-117.54s224 54.93 224 117.54-104.69 117.52-224 117.52z"]
  },
      qM = {
    prefix: "fas",
    iconName: "laugh",
    icon: [496, 512, [], "f599", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"]
  },
      JM = {
    prefix: "fas",
    iconName: "laugh-beam",
    icon: [496, 512, [], "f59a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"]
  },
      KM = {
    prefix: "fas",
    iconName: "laugh-squint",
    icon: [496, 512, [], "f59b", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"]
  },
      XM = {
    prefix: "fas",
    iconName: "laugh-wink",
    icon: [496, 512, [], "f59c", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"]
  },
      _M = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [512, 512, [], "f5fd", "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"]
  },
      $M = {
    prefix: "fas",
    iconName: "layer-minus",
    icon: [512, 512, [], "f5fe", "M12.41 276.3l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40L266.65 130.72a25.682 25.682 0 0 0-21.29 0L12.41 236.3c-16.55 7.5-16.55 32.5 0 40zM304 64h192c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H304c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16zm195.59 300.1l-58.09-26.33-161.63 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 337.77l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"]
  },
      cp = {
    prefix: "fas",
    iconName: "layer-plus",
    icon: [512, 512, [], "f5ff", "M304 144h64v64c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-64h64c8.84 0 16-7.16 16-16V96c0-8.84-7.16-16-16-16h-64V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v64h-64c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16zm195.59 220.1l-58.54-26.53-161.19 73.06c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.95 337.57 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40zM12.41 275.9l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L448 299.28V280.7c-15.32 4.38-31.27 7.29-48 7.29-88.01 0-160.72-64.67-173.72-149.04L12.41 235.9c-16.55 7.5-16.55 32.5 0 40z"]
  },
      ep = {
    prefix: "fas",
    iconName: "leaf",
    icon: [576, 512, [], "f06c", "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"]
  },
      ap = {
    prefix: "fas",
    iconName: "leaf-heart",
    icon: [576, 512, [], "f4cb", "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 19.2 2.9 37.7 8.1 55.1C31.6 399.5 4.3 463.2 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6zM430.6 294.4L345.9 380c-5.5 5.5-14.3 5.5-19.8 0l-84.7-85.6c-24.6-24.9-23.2-66.1 4.3-89.1 24-20 59.6-16.4 81.6 5.8l8.6 8.7 8.6-8.7c22-22.2 57.7-25.8 81.6-5.8 27.6 22.9 29.1 64.2 4.5 89.1z"]
  },
      np = {
    prefix: "fas",
    iconName: "leaf-maple",
    icon: [512, 512, [], "f6f6", "M503.58 166.05l-37.24-22.34 9.86-88.78c1.23-11.04-8.1-20.37-19.14-19.14l-88.78 9.86-22.33-37.23c-6.63-11.05-22.57-11.26-29.49-.39l-89.6 140.79 16.58-64.84c2.8-12.58-8.62-23.7-21.12-20.58L196.6 77.22l-45.3-51.33c-6.94-8.67-20.13-8.67-27.07 0l-45.3 51.33L53.2 63.41c-12.5-3.12-23.92 8-21.12 20.58l33.04 160.19-37.09 15.89c-14.01 6-14.01 25.86 0 31.87l102.75 44.04L9.37 457.38c-12.5 12.5-12.5 32.75 0 45.25C15.62 508.88 23.81 512 32 512s16.37-3.12 22.62-9.38L257 300.25l-66.1 115.67 29.16 68.05c6.01 14.01 25.87 14.01 31.87 0l15.89-37.09 160.19 33.04c12.58 2.79 23.7-8.62 20.58-21.12l-13.81-25.72 51.32-45.3c8.67-6.94 8.67-20.13 0-27.07l-51.32-45.3 13.81-25.72c3.12-12.5-8-23.92-20.58-21.12l-64.84 16.58 140.79-89.59c10.88-6.94 10.67-22.88-.38-29.51z"]
  },
      tp = {
    prefix: "fas",
    iconName: "leaf-oak",
    icon: [512, 512, [], "f6f7", "M488.4 155.16c-3.97-2.74-8.07-5.45-12.47-7.36-7.33-3.19-10.35-11.81-8.06-19.56 9.76-33.08 2.92-57.01-12.43-71.51l.17-.17c-14.49-15.34-38.43-22.19-71.5-12.43-7.76 2.29-16.37-.73-19.56-8.06-1.91-4.39-4.62-8.5-7.36-12.47-18.65-26.98-54.04-31.7-77.81-9.65-6.76 6.27-11.71 14.7-16.65 22.66-7.82 12.63-14.94 25.7-23.13 39.93-6.72-5.51-11.65-9.75-16.77-13.73-28.61-22.23-59.63-15.96-77.62 15.4-13.05 22.74-11.64 47.07-8.47 71.76 1.65 12.84 2.69 25.76 4.38 42.31-6.14-4.27-8.58-6.24-11.27-7.78-26.1-14.94-55.32-4.3-63.17 24.64-3.2 11.82-3.57 25.64-.86 37.58 3.93 17.31 12.87 33.46 17.61 50.66 2.6 9.41 3.91 21.04.72 29.81-7.54 20.71-11.4 40.95-5.91 61.32L9.37 457.38c-12.5 12.5-12.5 32.75 0 45.25C15.62 508.88 23.81 512 32 512s16.37-3.12 22.62-9.38l183.71-183.71-64.41 112.71c3.62-1.09 7.23-2.11 10.87-3.43 8.77-3.19 20.4-1.88 29.81.72 17.2 4.75 33.35 13.68 50.66 17.62 11.94 2.71 25.76 2.35 37.58-.86 28.94-7.85 39.58-37.07 24.64-63.17-1.54-2.69-3.52-5.12-7.78-11.27 16.55 1.69 29.46 2.72 42.31 4.38 24.69 3.17 49.01 4.57 71.76-8.47 31.37-17.99 37.63-49.02 15.4-77.62-3.98-5.12-8.21-10.05-13.73-16.77 14.24-8.19 27.31-15.31 39.93-23.13 7.96-4.94 16.4-9.89 22.66-16.65 22.06-23.77 17.35-59.16-9.63-77.81z"]
  },
      rp = {
    prefix: "fas",
    iconName: "lemon",
    icon: [512, 512, [], "f094", "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"]
  },
      ip = {
    prefix: "fas",
    iconName: "less-than",
    icon: [384, 512, [], "f536", "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"]
  },
      op = {
    prefix: "fas",
    iconName: "less-than-equal",
    icon: [448, 512, [], "f537", "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"]
  },
      lp = {
    prefix: "fas",
    iconName: "level-down",
    icon: [352, 512, [], "f149", "M345.04 368l-136 136.901c-9.388 9.465-24.691 9.465-34.079 0L38.96 368c-9.307-9.384-9.277-24.526.069-33.872l22.056-22.056c9.619-9.619 25.301-9.329 34.557.639L152 373.16V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v349.16l56.357-60.448c9.256-9.968 24.938-10.258 34.557-.639l22.056 22.056c9.346 9.345 9.377 24.487.07 33.871z"]
  },
      fp = {
    prefix: "fas",
    iconName: "level-down-alt",
    icon: [320, 512, [], "f3be", "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"]
  },
      sp = {
    prefix: "fas",
    iconName: "level-up",
    icon: [352, 512, [], "f148", "M345.04 144l-136-136.901c-9.388-9.465-24.691-9.465-34.079 0L38.96 144c-9.307 9.384-9.277 24.526.069 33.872l22.056 22.056c9.619 9.619 25.301 9.329 34.557-.639L152 138.84V432H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V138.84l56.357 60.448c9.256 9.968 24.938 10.258 34.557.639l22.056-22.056c9.346-9.345 9.377-24.487.07-33.871z"]
  },
      up = {
    prefix: "fas",
    iconName: "level-up-alt",
    icon: [320, 512, [], "f3bf", "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"]
  },
      hp = {
    prefix: "fas",
    iconName: "life-ring",
    icon: [512, 512, [], "f1cd", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"]
  },
      mp = {
    prefix: "fas",
    iconName: "light-ceiling",
    icon: [512, 512, [], "e016", "M288,162.39V0H224V162.39C108.51,176.59,16.56,266,.31,379.85-2.41,399,13.07,416,32.54,416H479.46c19.47,0,34.95-17,32.23-36.15C495.44,266,403.49,176.59,288,162.39ZM256,512a64,64,0,0,0,64-64H192A64,64,0,0,0,256,512Z"]
  },
      vp = {
    prefix: "fas",
    iconName: "light-switch",
    icon: [384, 512, [], "e017", "M320,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H320a64,64,0,0,0,64-64V64A64,64,0,0,0,320,0ZM192,32a16,16,0,1,1-16,16A16,16,0,0,1,192,32Zm0,448a16,16,0,1,1,16-16A16,16,0,0,1,192,480Zm96-112a48,48,0,0,1-48,48H144a48,48,0,0,1-48-48V272H288Zm0-128H96V144a48,48,0,0,1,48-48h96a48,48,0,0,1,48,48Z"]
  },
      dp = {
    prefix: "fas",
    iconName: "light-switch-off",
    icon: [384, 512, [], "e018", "M320,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H320a64,64,0,0,0,64-64V64A64,64,0,0,0,320,0ZM192,32a16,16,0,1,1-16,16A16,16,0,0,1,192,32Zm0,448a16,16,0,1,1,16-16A16,16,0,0,1,192,480Zm96-192h0v80a48,48,0,0,1-48,48H144a48,48,0,0,1-48-48V272h0V240h0V144a48,48,0,0,1,48-48h96a48,48,0,0,1,48,48v80h0ZM128,352a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V256H128Z"]
  },
      Mp = {
    prefix: "fas",
    iconName: "light-switch-on",
    icon: [384, 512, [], "e019", "M320,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H320a64,64,0,0,0,64-64V64A64,64,0,0,0,320,0ZM192,32a16,16,0,1,1-16,16A16,16,0,0,1,192,32Zm0,448a16,16,0,1,1,16-16A16,16,0,0,1,192,480Zm96-240h0v32h0v96a48,48,0,0,1-48,48H144a48,48,0,0,1-48-48V288h0V224h0V144a48,48,0,0,1,48-48h96a48,48,0,0,1,48,48ZM224,128H160a32,32,0,0,0-32,32v96H256V160A32,32,0,0,0,224,128Z"]
  },
      pp = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [352, 512, [], "f0eb", "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"]
  },
      zp = {
    prefix: "fas",
    iconName: "lightbulb-dollar",
    icon: [352, 512, [], "f670", "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM175.45 0C73.44.31 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0zM192 255.88V272c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V80c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"]
  },
      Cp = {
    prefix: "fas",
    iconName: "lightbulb-exclamation",
    icon: [352, 512, [], "f671", "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM175.45 0C73.44.31 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0zm.55 320c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm38.24-238.41l-12.8 128c-.82 8.18-7.7 14.41-15.92 14.41h-19.04c-8.22 0-15.1-6.23-15.92-14.41l-12.8-128c-.94-9.42 6.45-17.59 15.92-17.59h44.64c9.47 0 16.86 8.17 15.92 17.59z"]
  },
      Lp = {
    prefix: "fas",
    iconName: "lightbulb-on",
    icon: [640, 512, [], "f672", "M240.06,454.34A32,32,0,0,0,245.42,472l17.1,25.69c5.23,7.91,17.17,14.28,26.64,14.28h61.7c9.47,0,21.41-6.37,26.64-14.28L394.59,472A37.47,37.47,0,0,0,400,454.34L400,416H240ZM319.45,0C217.44.31,144,83,144,176a175,175,0,0,0,43.56,115.78c16.52,18.85,42.36,58.22,52.21,91.44,0,.28.07.53.11.78H400.12c0-.25.07-.5.11-.78,9.85-33.22,35.69-72.59,52.21-91.44A175,175,0,0,0,496,176C496,78.63,416.91-.31,319.45,0ZM320,96a80.09,80.09,0,0,0-80,80,16,16,0,0,1-32,0A112.12,112.12,0,0,1,320,64a16,16,0,0,1,0,32ZM112,192a24,24,0,0,0-24-24H24a24,24,0,0,0,0,48H88A24,24,0,0,0,112,192Zm504-24H552a24,24,0,0,0,0,48h64a24,24,0,0,0,0-48ZM131.08,55.22l-55.42-32a24,24,0,1,0-24,41.56l55.42,32a24,24,0,1,0,24-41.56Zm457.26,264-55.42-32a24,24,0,1,0-24,41.56l55.42,32a24,24,0,0,0,24-41.56Zm-481.26-32-55.42,32a24,24,0,1,0,24,41.56l55.42-32a24,24,0,0,0-24-41.56ZM520.94,100a23.8,23.8,0,0,0,12-3.22l55.42-32a24,24,0,0,0-24-41.56l-55.42,32a24,24,0,0,0,12,44.78Z"]
  },
      Ap = {
    prefix: "fas",
    iconName: "lightbulb-slash",
    icon: [640, 512, [], "f673", "M633.82 458.1L439.73 308.09c4.51-6.26 8.87-11.94 12.71-16.31C479.55 260.85 496 220.37 496 176 496 78.8 417.2 0 320 0 208.69 0 164.65 92.77 163.64 94.71L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM320 96c-37.14 0-68.17 25.56-77.14 59.94l-26.89-20.78C232.36 93.59 272.69 64 320 64c8.84 0 16 7.16 16 16s-7.16 16-16 16zm-79.99 320l.04 38.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.02-15.21L370.03 416H240.01zm-76.28-159.44c6.57 12.69 14.49 24.57 23.83 35.22 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h88.74L163.73 256.56z"]
  },
      Np = {
    prefix: "fas",
    iconName: "lights-holiday",
    icon: [640, 512, [], "f7b2", "M637.4 98.8l-17.5-27.4c-4.7-7.4-14.2-9.5-21.8-5.1C522 110.7 424 135 320 135S118 110.7 41.9 66.3c-7.6-4.4-17.1-2.3-21.8 5.1L2.6 98.8c-4.9 7.8-2.7 18.3 5.2 22.9 38.1 22.4 81.1 40 127 53L114.7 230c-25.5 1.1-48.5 16.2-61.3 51.6-18.1 49.8 14.3 129 27.9 134 13.5 4.9 89.3-34.9 107.5-84.7 12.9-35.3 5-61.7-13.8-79l22.8-62.6c29.3 5.2 59.6 8.4 90.4 9.8v63c-23.6 9.8-40 31.8-40 69.5 0 53 57.6 116.4 72 116.4s72-63.3 72-116.4c0-37.6-16.4-59.7-40-69.5v-63c30.8-1.4 61-4.6 90.4-9.8l22.8 62.6c-18.8 17.3-26.7 43.6-13.8 79 18.1 49.8 93.9 89.6 107.5 84.7 13.5-4.9 46-84.2 27.9-134-12.9-35.3-35.8-50.5-61.3-51.6l-20.1-55.3c45.9-13 88.9-30.6 127-53 7.5-4.6 9.7-15.1 4.8-22.9zM145.6 309c-4.8 13.1-26.4 37.1-42.5 46.5-6.3-17.5-7.4-49.7-2.7-62.9 4.1-11.3 17.6-16.8 30-12.3s19.3 17.4 15.2 28.7zM320 384c-11.9-14.3-24-44.2-24-58.2 0-12.1 10.7-21.8 24-21.8s24 9.8 24 21.8c0 14-12.1 43.9-24 58.2zm189.5-103.7c12.5-4.5 25.9 1 30 12.3 4.8 13.1 3.7 45.4-2.7 62.9-16.1-9.3-37.7-33.3-42.5-46.5-4-11.3 2.8-24.2 15.2-28.7z"]
  },
      gp = {
    prefix: "fas",
    iconName: "line-columns",
    icon: [512, 512, [], "f870", "M496 288H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 128H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-256H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM208 288H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-384H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm0 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      Hp = {
    prefix: "fas",
    iconName: "line-height",
    icon: [640, 512, [], "f871", "M626.29 224H269.71c-7.57 0-13.71 7.16-13.71 16v32c0 8.84 6.14 16 13.71 16h356.58c7.57 0 13.71-7.16 13.71-16v-32c0-8.84-6.14-16-13.71-16zm0 160H269.71c-7.57 0-13.71 7.16-13.71 16v32c0 8.84 6.14 16 13.71 16h356.58c7.57 0 13.71-7.16 13.71-16v-32c0-8.84-6.14-16-13.71-16zm0-320H269.71C262.14 64 256 71.16 256 80v32c0 8.84 6.14 16 13.71 16h356.58c7.57 0 13.71-7.16 13.71-16V80c0-8.84-6.14-16-13.71-16zM176 144c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C-4.64 126 .36 144 16 144h48v224H16c-14.29 0-21.31 17.31-11.29 27.31l80 80a16 16 0 0 0 22.62 0l80-80C196.64 386 191.64 368 176 368h-48V144z"]
  },
      Vp = {
    prefix: "fas",
    iconName: "link",
    icon: [512, 512, [], "f0c1", "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"]
  },
      xp = {
    prefix: "fas",
    iconName: "lips",
    icon: [640, 512, [], "f600", "M631.14 195.68C579.47 109.99 466.31 32 417.72 32c0 0-32.57 0-97.72 50-65.15-50-97.72-50-97.72-50-48.59 0-161.75 77.99-213.42 163.68-10.32 17.11-11.63 37.99-3.89 56.38C32.95 318.51 117.59 480 279.28 480h81.43c161.69 0 246.33-161.49 274.32-227.95 7.74-18.38 6.43-39.26-3.89-56.37zM320 320c-170.66 0-256-96-256-96s64-32 160-32l35.38 8.84C278.2 205.55 298.95 208 320 208s41.8-2.45 60.62-7.16L416 192c96 0 160 32 160 32s-85.34 96-256 96z"]
  },
      wp = {
    prefix: "fas",
    iconName: "lira-sign",
    icon: [384, 512, [], "f195", "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"]
  },
      yp = {
    prefix: "fas",
    iconName: "list",
    icon: [512, 512, [], "f03a", "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      bp = {
    prefix: "fas",
    iconName: "list-alt",
    icon: [512, 512, [], "f022", "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"]
  },
      Sp = {
    prefix: "fas",
    iconName: "list-music",
    icon: [512, 512, [], "f8c9", "M16 256h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0-128h256a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16H16A16 16 0 0 0 0 80v32a16 16 0 0 0 16 16zm128 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM470.94 1.33l-96.53 28.51A32 32 0 0 0 352 60.34V360a148.76 148.76 0 0 0-48-8c-61.86 0-112 35.82-112 80s50.14 80 112 80 112-35.82 112-80V148.15l73-21.39a32 32 0 0 0 23-30.71V32a32 32 0 0 0-41.06-30.67z"]
  },
      Tp = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [512, 512, [], "f0cb", "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"]
  },
      Dp = {
    prefix: "fas",
    iconName: "list-ul",
    icon: [512, 512, [], "f0ca", "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      jp = {
    prefix: "fas",
    iconName: "location",
    icon: [512, 512, [], "f601", "M496 224h-50.88C431.61 143.66 368.34 80.39 288 66.88V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v50.88C143.66 80.39 80.39 143.66 66.88 224H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h50.88C80.39 368.34 143.66 431.61 224 445.12V496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-50.88c80.34-13.51 143.61-76.78 157.12-157.12H496c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM256 384c-70.7 0-128-57.31-128-128s57.3-128 128-128 128 57.31 128 128-57.3 128-128 128zm0-216c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88z"]
  },
      Ep = {
    prefix: "fas",
    iconName: "location-arrow",
    icon: [512, 512, [], "f124", "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"]
  },
      kp = {
    prefix: "fas",
    iconName: "location-circle",
    icon: [496, 512, [], "f602", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm110.24 169.74l-95.95 207.89c-11.2 23.99-46.38 15.99-46.38-9.59v-87.96h-87.96c-25.59 0-33.58-35.18-9.59-46.38l207.89-95.95c19.2-7.99 39.99 12.8 31.99 31.99z"]
  },
      Ip = {
    prefix: "fas",
    iconName: "location-slash",
    icon: [640, 512, [], "f603", "M633.82 458.1L488.95 346.13c9.66-17.86 16.68-37.35 20.18-58.13H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-50.88C495.61 143.66 432.34 80.39 352 66.88V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v50.88c-37.52 6.31-71.24 23.54-97.95 48.24L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM437.33 306.24l-33.09-25.58c2.33-7.84 3.76-16.05 3.76-24.66 0-48.6-39.4-88-88-88-16.56 0-31.84 4.8-44.99 12.78l-33.21-25.66C263.45 138.28 290.44 128 320 128c70.7 0 128 57.31 128 128 0 17.93-3.94 34.83-10.67 50.24zM320 384c-62.37 0-114.18-44.65-125.55-103.7L121.61 224H80c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h50.88c13.51 80.34 76.78 143.61 157.12 157.12V496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-50.88c14.07-2.37 27.35-6.75 40.19-11.99l-64.57-49.9c-2.57.15-5.01.77-7.62.77z"]
  },
      Op = {
    prefix: "fas",
    iconName: "lock",
    icon: [448, 512, [], "f023", "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"]
  },
      Qp = {
    prefix: "fas",
    iconName: "lock-alt",
    icon: [448, 512, [], "f30d", "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zM264 392c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48zm32-168H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"]
  },
      Zp = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [576, 512, [], "f3c1", "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"]
  },
      Up = {
    prefix: "fas",
    iconName: "lock-open-alt",
    icon: [576, 512, [], "f3c2", "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0zM264 392c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"]
  },
      Bp = {
    prefix: "fas",
    iconName: "long-arrow-alt-down",
    icon: [256, 512, [], "f309", "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"]
  },
      Rp = {
    prefix: "fas",
    iconName: "long-arrow-alt-left",
    icon: [448, 512, [], "f30a", "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"]
  },
      Yp = {
    prefix: "fas",
    iconName: "long-arrow-alt-right",
    icon: [448, 512, [], "f30b", "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"]
  },
      Pp = {
    prefix: "fas",
    iconName: "long-arrow-alt-up",
    icon: [256, 512, [], "f30c", "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"]
  },
      Fp = {
    prefix: "fas",
    iconName: "long-arrow-down",
    icon: [320, 512, [], "f175", "M261.573 286.544L196 352.118V56c0-13.255-10.745-24-24-24h-24c-13.255 0-24 10.745-24 24v296.118l-65.573-65.574c-9.373-9.373-24.569-9.373-33.941 0L7.515 303.515c-9.373 9.373-9.373 24.569 0 33.941L143.03 472.97c9.373 9.373 24.568 9.373 33.941 0l135.515-135.514c9.373-9.373 9.373-24.569 0-33.941l-16.971-16.971c-9.373-9.373-24.569-9.373-33.942 0z"]
  },
      Wp = {
    prefix: "fas",
    iconName: "long-arrow-left",
    icon: [448, 512, [], "f177", "M193.456 357.573L127.882 292H424c13.255 0 24-10.745 24-24v-24c0-13.255-10.745-24-24-24H127.882l65.574-65.573c9.373-9.373 9.373-24.569 0-33.941l-16.971-16.971c-9.373-9.373-24.569-9.373-33.941 0L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l135.515 135.515c9.373 9.373 24.569 9.373 33.941 0l16.971-16.971c9.373-9.372 9.373-24.568 0-33.941z"]
  },
      Gp = {
    prefix: "fas",
    iconName: "long-arrow-right",
    icon: [448, 512, [], "f178", "M254.544 154.427L320.118 220H24c-13.255 0-24 10.745-24 24v24c0 13.255 10.745 24 24 24h296.118l-65.574 65.573c-9.373 9.373-9.373 24.569 0 33.941l16.971 16.971c9.373 9.373 24.569 9.373 33.941 0L440.97 272.97c9.373-9.373 9.373-24.569 0-33.941L305.456 103.515c-9.373-9.373-24.569-9.373-33.941 0l-16.971 16.971c-9.373 9.372-9.373 24.568 0 33.941z"]
  },
      qp = {
    prefix: "fas",
    iconName: "long-arrow-up",
    icon: [320, 512, [], "f176", "M58.427 225.456L124 159.882V456c0 13.255 10.745 24 24 24h24c13.255 0 24-10.745 24-24V159.882l65.573 65.574c9.373 9.373 24.569 9.373 33.941 0l16.971-16.971c9.373-9.373 9.373-24.569 0-33.941L176.971 39.029c-9.373-9.373-24.568-9.373-33.941 0L7.515 174.544c-9.373 9.373-9.373 24.569 0 33.941l16.971 16.971c9.372 9.373 24.568 9.373 33.941 0z"]
  },
      Jp = {
    prefix: "fas",
    iconName: "loveseat",
    icon: [512, 512, [], "f4cc", "M160 224v64h192v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm288-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h256v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"]
  },
      Kp = {
    prefix: "fas",
    iconName: "low-vision",
    icon: [576, 512, [], "f2a8", "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"]
  },
      Xp = {
    prefix: "fas",
    iconName: "luchador",
    icon: [448, 512, [], "f455", "M190.2 256H144c-26.5 0-48-23.9-48-53.3V192h48c26.5 0 48 23.9 48 53.3v8.7c-.6.7-1.2 1.3-1.8 2zm33.8 64h38.7c-6.8-14.8-18.5-33.4-38.7-53.3-20.2 19.9-31.9 38.5-38.7 53.3H224zm-64 32c-17.6 0-32 14.4-32 32s14.4 32 32 32h128c17.6 0 32-14.4 32-32s-14.4-32-32-32H160zm96-106.7v8.7c.6.7 1.2 1.3 1.8 2H304c26.5 0 48-23.9 48-53.3V192h-48c-26.5 0-48 23.9-48 53.3zM448 224v128c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V224C0 100.3 100.3 0 224 0s224 100.3 224 224zm-64-52c0-6.6-5.4-12-12-12h-68c-37.9 0-69.3 28.3-77.5 66.2-.9-.7-4.2-.7-5.1 0C213.3 188.3 182 160 144 160H76c-6.6 0-12 5.4-12 12v30.7c0 47.1 35.8 85.3 80 85.3h22.4c-7.4 12.2-12.5 23.5-15.8 32.9-30.9 4.6-54.6 31-54.6 63.1 0 35.5 29.4 64 64.9 64H287c35.5 0 64.9-28.5 64.9-64 0-32.1-23.7-58.5-54.6-63.1-3.3-9.5-8.4-20.7-15.8-32.9H304c44.2 0 80-38.2 80-85.3V172z"]
  },
      _p = {
    prefix: "fas",
    iconName: "luggage-cart",
    icon: [640, 512, [], "f59d", "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"]
  },
      $p = {
    prefix: "fas",
    iconName: "lungs",
    icon: [640, 512, [], "f604", "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"]
  },
      cz = {
    prefix: "fas",
    iconName: "lungs-virus",
    icon: [640, 512, [], "e067", "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"]
  },
      ez = {
    prefix: "fas",
    iconName: "mace",
    icon: [512, 512, [], "f6f8", "M170.65 296.09L4.69 462.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l165.97-165.97a161.122 161.122 0 0 1-45.27-45.26zm330.33-101.12l-74.99-23.77c-12.6-41.73-45.59-74.19-87.67-85.95L313.05 10.8c-4.92-14.5-17.46-14.37-22.08.22l-23.77 75c-41.73 12.6-74.19 45.59-85.96 87.67l-74.44 25.26c-14.5 4.92-14.37 17.46.22 22.08l74.99 23.77c12.6 41.73 45.59 74.19 87.67 85.96l25.26 74.44c4.92 14.5 17.46 14.37 22.08-.22l23.77-74.99c41.73-12.6 74.19-45.59 85.95-87.67l74.44-25.26c14.52-4.93 14.39-17.47-.2-22.09zM304 240c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      az = {
    prefix: "fas",
    iconName: "magic",
    icon: [512, 512, [], "f0d0", "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"]
  },
      nz = {
    prefix: "fas",
    iconName: "magnet",
    icon: [512, 512, [], "f076", "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"]
  },
      tz = {
    prefix: "fas",
    iconName: "mail-bulk",
    icon: [576, 512, [], "f674", "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"]
  },
      rz = {
    prefix: "fas",
    iconName: "mailbox",
    icon: [576, 512, [], "f813", "M144 64A144 144 0 0 0 0 208v208a32 32 0 0 0 32 32h256V208A144 144 0 0 0 144 64zm80 176a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h128a16 16 0 0 1 16 16zM432 64H244.87C290.23 95.87 320 148.48 320 208v240h224a32 32 0 0 0 32-32V208A144 144 0 0 0 432 64zm80 208a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-48h-56a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h104a16 16 0 0 1 16 16z"]
  },
      iz = {
    prefix: "fas",
    iconName: "male",
    icon: [192, 512, [], "f183", "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"]
  },
      oz = {
    prefix: "fas",
    iconName: "mandolin",
    icon: [512, 512, [], "f6f9", "M507.31 50.67l-46-46a16 16 0 0 0-19.81-2.25l-64 40.07a32 32 0 0 0-14 19.11L349 117.73l-74.46 74.46C90.38 190.67 46 241 30.74 256.28c-46.81 46.79-39.52 150.36 17.54 207.45s160.65 64.34 207.44 17.53C271 466 321.32 421.62 319.8 237.45L394.27 163l56.11-14.51a32 32 0 0 0 19.11-14l40.07-64a16 16 0 0 0-2.25-19.82zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"]
  },
      lz = {
    prefix: "fas",
    iconName: "map",
    icon: [576, 512, [], "f279", "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"]
  },
      fz = {
    prefix: "fas",
    iconName: "map-marked",
    icon: [576, 512, [], "f59f", "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"]
  },
      sz = {
    prefix: "fas",
    iconName: "map-marked-alt",
    icon: [576, 512, [], "f5a0", "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"]
  },
      uz = {
    prefix: "fas",
    iconName: "map-marker",
    icon: [384, 512, [], "f041", "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"]
  },
      hz = {
    prefix: "fas",
    iconName: "map-marker-alt",
    icon: [384, 512, [], "f3c5", "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"]
  },
      mz = {
    prefix: "fas",
    iconName: "map-marker-alt-slash",
    icon: [640, 512, [], "f605", "M300.8 502.4c9.6 12.8 28.8 12.8 38.4 0 18.6-26.69 35.23-50.32 50.14-71.47L131.47 231.62c10.71 52.55 50.15 99.78 169.33 270.78zm333.02-44.3L462.41 325.62C502.09 265.52 512 238.3 512 192 512 86.4 425.6 0 320 0c-68.2 0-128.24 36.13-162.3 90.12L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zm-263.7-203.81L247 159.13c12.34-27.96 40.01-47.13 73-47.13 44.8 0 80 35.2 80 80 0 25.57-11.71 47.74-29.88 62.29z"]
  },
      vz = {
    prefix: "fas",
    iconName: "map-marker-check",
    icon: [384, 512, [], "f606", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm114.08 163.83L175.04 293.82c-4.31 4.28-11.28 4.25-15.55-.06l-75.72-76.33c-4.28-4.31-4.25-11.28.06-15.56l26.03-25.82c4.31-4.28 11.28-4.25 15.56.06l42.15 42.49 97.2-96.42c4.31-4.28 11.28-4.25 15.55.06l25.82 26.03c4.28 4.32 4.25 11.28-.06 15.56z"]
  },
      dz = {
    prefix: "fas",
    iconName: "map-marker-edit",
    icon: [384, 512, [], "f607", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm-43.17 283.15l-42.83 4.8c-5.78.62-10.57-4.27-9.95-9.95l4.8-42.83 85.54-85.54 47.98 47.98-85.54 85.54zm133.91-133.9l-28.26 28.26-47.98-47.98 28.26-28.26c7.02-7.02 18.39-7.02 25.41 0l22.57 22.57c7.02 7.01 7.02 18.39 0 25.41z"]
  },
      Mz = {
    prefix: "fas",
    iconName: "map-marker-exclamation",
    icon: [384, 512, [], "f608", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.44-110.41c-.82 8.18-7.7 14.41-15.92 14.41h-19.04c-8.22 0-15.1-6.23-15.92-14.41l-12.8-128c-.94-9.42 6.45-17.59 15.92-17.59h44.64c9.47 0 16.86 8.17 15.92 17.59l-12.8 128z"]
  },
      pz = {
    prefix: "fas",
    iconName: "map-marker-minus",
    icon: [384, 512, [], "f609", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm112 200c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"]
  },
      zz = {
    prefix: "fas",
    iconName: "map-marker-plus",
    icon: [384, 512, [], "f60a", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm112 200c0 8.84-7.16 16-16 16h-72v72c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-72H96c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h72V96c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v72h72c8.84 0 16 7.16 16 16v16z"]
  },
      Cz = {
    prefix: "fas",
    iconName: "map-marker-question",
    icon: [384, 512, [], "f60b", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm26.67-113.27v1.43c0 8.75-7.09 15.84-15.84 15.84h-16.32c-8.75 0-15.84-7.09-15.84-15.84V224c0-9.1 5.19-17.43 13.33-21.5 30.61-15.31 50.67-26.54 50.67-42.5 0-19.39-14.02-40-40-40-17.93 0-33.13 11.84-38.2 28.12-2.15 6.9-8.11 11.88-15.33 11.88H124.3c-10.24 0-17.72-9.56-15.44-19.55 8.91-39.15 44-68.45 85.81-68.45 55.08 0 88 44.75 88 88 0 40.95-32.75 62.47-64 78.73z"]
  },
      Lz = {
    prefix: "fas",
    iconName: "map-marker-slash",
    icon: [640, 512, [], "f60c", "M633.82 458.1L462.41 325.62C502.09 265.52 512 238.3 512 192 512 86.4 425.6 0 320 0c-68.2 0-128.24 36.13-162.3 90.12L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM300.8 502.4c9.6 12.8 28.8 12.8 38.4 0 18.6-26.69 35.23-50.32 50.14-71.47L131.47 231.62c10.71 52.55 50.15 99.78 169.33 270.78z"]
  },
      Az = {
    prefix: "fas",
    iconName: "map-marker-smile",
    icon: [384, 512, [], "f60d", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm64 117.16c14.82 0 26.84 12.02 26.84 26.84s-12.02 26.84-26.84 26.84-26.84-12.02-26.84-26.84 12.02-26.84 26.84-26.84zm-128 0c14.82 0 26.84 12.02 26.84 26.84s-12.02 26.84-26.84 26.84-26.84-12.02-26.84-26.84 12.02-26.84 26.84-26.84zm164.17 140.97C267.3 287.28 230.78 304 192 304c-38.75 0-75.27-16.72-100.16-45.86-5.75-6.72-4.95-16.81 1.77-22.55 6.69-5.73 16.81-4.97 22.55 1.77C134.98 259.38 162.62 272 192 272c29.41 0 57.03-12.63 75.83-34.66 5.78-6.73 15.86-7.53 22.56-1.78 6.72 5.74 7.52 15.85 1.78 22.57z"]
  },
      Nz = {
    prefix: "fas",
    iconName: "map-marker-times",
    icon: [384, 512, [], "f60e", "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm84.85 242.91c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L192 225.94l-50.91 50.91c-6.25 6.25-16.38 6.25-22.63 0l-11.31-11.31c-6.25-6.25-6.25-16.38 0-22.63L158.06 192l-50.91-50.91c-6.25-6.25-6.25-16.38 0-22.63l11.31-11.31c6.25-6.25 16.38-6.25 22.63 0L192 158.06l50.91-50.91c6.25-6.25 16.38-6.25 22.63 0l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63L225.94 192l50.91 50.91z"]
  },
      gz = {
    prefix: "fas",
    iconName: "map-pin",
    icon: [288, 512, [], "f276", "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"]
  },
      Hz = {
    prefix: "fas",
    iconName: "map-signs",
    icon: [512, 512, [], "f277", "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"]
  },
      Vz = {
    prefix: "fas",
    iconName: "marker",
    icon: [512, 512, [], "f5a1", "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"]
  },
      xz = {
    prefix: "fas",
    iconName: "mars",
    icon: [384, 512, [], "f222", "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      wz = {
    prefix: "fas",
    iconName: "mars-double",
    icon: [512, 512, [], "f227", "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"]
  },
      yz = {
    prefix: "fas",
    iconName: "mars-stroke",
    icon: [384, 512, [], "f229", "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      bz = {
    prefix: "fas",
    iconName: "mars-stroke-h",
    icon: [480, 512, [], "f22b", "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"]
  },
      Sz = {
    prefix: "fas",
    iconName: "mars-stroke-v",
    icon: [288, 512, [], "f22a", "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"]
  },
      Tz = {
    prefix: "fas",
    iconName: "mask",
    icon: [640, 512, [], "f6fa", "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"]
  },
      Dz = {
    prefix: "fas",
    iconName: "meat",
    icon: [512, 512, [], "f814", "M444 68.52C399.45 24.05 345.11 0 299.17 0c-23.64 0-44.77 6.79-61.47 20a41.83 41.83 0 0 0-7.3 5.82C191.68 64.5 128.14 139.6 128.14 209.42v100.37l-8.61 8.6c-9.71 9.69-24 11.07-36.79 6a60.33 60.33 0 0 0-65 98.72c15.26 15.28 36.51 19.59 56.13 15.1-4.49 19.6-.18 40.83 15.11 56.1a60.36 60.36 0 0 0 98.83-65c-5.1-12.73-3.72-27 6-36.75l8.6-8.59h100.47c69.89 0 145.07-63.46 183.8-102.15a40.86 40.86 0 0 0 6.66-9c37.42-49.4 17.37-137.63-49.34-204.3zm8.73 179.39c-9.76 9.75-24.3 11.8-34.79 11.8-34.72 0-77.19-20.87-110.82-54.47-27.19-27.16-46.31-60.32-52.45-91-4.74-23.7-1.19-43.56 9.74-54.48C274.13 50.05 288.69 48 299.18 48c34.72 0 77.18 20.87 110.82 54.46 53.88 53.84 67 121.19 42.7 145.45zM331.89 127.23c-9.81 9.8-5.84 29.67 8.88 44.37s34.61 18.68 44.42 8.87 5.84-29.66-8.88-44.37-34.61-18.67-44.42-8.87z"]
  },
      jz = {
    prefix: "fas",
    iconName: "medal",
    icon: [512, 512, [], "f5a2", "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"]
  },
      Ez = {
    prefix: "fas",
    iconName: "medkit",
    icon: [512, 512, [], "f0fa", "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"]
  },
      kz = {
    prefix: "fas",
    iconName: "megaphone",
    icon: [576, 512, [], "f675", "M32 176c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32 11.38 0 20.9-6.28 26.57-15.22l106.99 32.3c-3.35 9.76-5.56 20.04-5.56 30.92 0 52.94 43.06 96 96 96 44.49 0 81.66-30.57 92.5-71.7L480 448V64L58.57 191.22C52.9 182.28 43.38 176 32 176zm179.29 190.88l91.47 27.61C297.95 415.92 278.85 432 256 432c-26.47 0-48-21.53-48-48 0-6.05 1.24-11.79 3.29-17.12zM560 32h-32c-8.84 0-16 7.16-16 16v416c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16z"]
  },
      Iz = {
    prefix: "fas",
    iconName: "meh",
    icon: [496, 512, [], "f11a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Oz = {
    prefix: "fas",
    iconName: "meh-blank",
    icon: [496, 512, [], "f5a4", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Qz = {
    prefix: "fas",
    iconName: "meh-rolling-eyes",
    icon: [496, 512, [], "f5a5", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"]
  },
      Zz = {
    prefix: "fas",
    iconName: "memory",
    icon: [640, 512, [], "f538", "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"]
  },
      Uz = {
    prefix: "fas",
    iconName: "menorah",
    icon: [640, 512, [], "f676", "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"]
  },
      Bz = {
    prefix: "fas",
    iconName: "mercury",
    icon: [288, 512, [], "f223", "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"]
  },
      Rz = {
    prefix: "fas",
    iconName: "meteor",
    icon: [512, 512, [], "f753", "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"]
  },
      Yz = {
    prefix: "fas",
    iconName: "microchip",
    icon: [512, 512, [], "f2db", "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"]
  },
      Pz = {
    prefix: "fas",
    iconName: "microphone",
    icon: [352, 512, [], "f130", "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"]
  },
      Fz = {
    prefix: "fas",
    iconName: "microphone-alt",
    icon: [352, 512, [], "f3c9", "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"]
  },
      Wz = {
    prefix: "fas",
    iconName: "microphone-alt-slash",
    icon: [640, 512, [], "f539", "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"]
  },
      Gz = {
    prefix: "fas",
    iconName: "microphone-slash",
    icon: [640, 512, [], "f131", "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"]
  },
      qz = {
    prefix: "fas",
    iconName: "microphone-stand",
    icon: [512, 512, [], "f8cb", "M289.54 60.53c-23.85 23.84-34.57 55.55-33 86.77l108.15 108.14c31.22 1.58 62.94-9.14 86.78-33l2.19-2.18L291.72 58.34zM6.74 423.18a26.67 26.67 0 0 0 1.07 36.57l44.38 44.37a26.74 26.74 0 0 0 36.63 1.14L224 385.93V496a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V329.44L344 280 232 168zM478.46 33.54a114.49 114.49 0 0 0-161.93 0l-2.19 2.18 161.94 161.93 2.18-2.18a114.49 114.49 0 0 0 0-161.93z"]
  },
      Jz = {
    prefix: "fas",
    iconName: "microscope",
    icon: [512, 512, [], "f610", "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"]
  },
      Kz = {
    prefix: "fas",
    iconName: "microwave",
    icon: [512, 512, [], "e01b", "M464,64H48A48,48,0,0,0,0,112V368a48,48,0,0,0,48,48h0l24,32h48l24-32H368l24,32h48l24-32h0a48,48,0,0,0,48-48V112A48,48,0,0,0,464,64ZM384,352H64V128H384Zm64-72a24,24,0,1,1,24-24A24,24,0,0,1,448,280Zm0-96a24,24,0,1,1,24-24A24,24,0,0,1,448,184Z"]
  },
      Xz = {
    prefix: "fas",
    iconName: "mind-share",
    icon: [640, 512, [], "f677", "M410.4 273.1c7-1 13.3-1.1 18.6-1.1h51v-15.2c0-20 12-37.3 29-44.8 2.8-7.7 4.8-15.8 4.8-24.5 0-31.3-19.3-58.1-46.7-69.3 1-4.2 1.6-8.6 1.6-13.2 0-33.1-27-60-60.2-60-.7 0-1.4.2-2.1.2-6.6-25.9-30-45.2-58.2-45.2C315 0 288 26.9 288 60v324c12.6-57.1 64-102.3 122.4-110.9zM195.8 0c-28.1 0-51.5 19.3-58.2 45.2-.7 0-1.4-.2-2.1-.2-33.3 0-60.2 26.9-60.2 60 0 4.5.6 8.9 1.6 13.2-27.4 11.2-46.7 38-46.7 69.3 0 11.8 3 22.8 7.8 32.7-22.6 13-38 37-38 64.8 0 31.3 19.2 58 46.5 69.3-.8 4.3-1.3 8.7-1.3 13.2 0 37.3 30.3 67.5 67.8 67.5 3.9 0 7.6-.5 11.3-1.1 9 26.7 34.1 46.1 64 46.1 37.4 0 67.8-30.2 67.8-67.5L256 60c0-33.1-27-60-60.2-60zM635 339.8l-96-95.2c-10.1-10-27-2.6-27 12.2V304h-79.9c-5.6 0-11.2-.1-17 .8-47.1 6.9-85.6 44.5-93.4 91.5C313.9 443 335 486.7 370 510c9.8 6.5 21.6-3.2 17.8-14.4-9-26.6-5.6-95.5 60.3-95.5h64v47.2c0 14.8 16.9 22.2 27 12.2l96-95.2c6.6-6.7 6.6-17.9-.1-24.5z"]
  },
      _z = {
    prefix: "fas",
    iconName: "minus",
    icon: [448, 512, [], "f068", "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
  },
      $z = {
    prefix: "fas",
    iconName: "minus-circle",
    icon: [512, 512, [], "f056", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"]
  },
      cC = {
    prefix: "fas",
    iconName: "minus-hexagon",
    icon: [576, 512, [], "f307", "M553.5 231.8c8.7 14.9 8.7 33.4 0 48.4l-112 192c-8.6 14.7-24.4 23.8-41.5 23.8H176c-17.1 0-32.9-9.1-41.5-23.8l-112-192c-8.7-14.9-8.7-33.4 0-48.4l112-192C143.1 25.1 158.9 16 176 16h224c17.1 0 32.9 9.1 41.5 23.8l112 192zM420 296c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12H156c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h264z"]
  },
      eC = {
    prefix: "fas",
    iconName: "minus-octagon",
    icon: [512, 512, [], "f308", "M497.9 150.5c9 9 14.1 21.2 14.1 33.9v143.1c0 12.7-5.1 24.9-14.1 33.9L361.5 497.9c-9 9-21.2 14.1-33.9 14.1H184.5c-12.7 0-24.9-5.1-33.9-14.1L14.1 361.5c-9-9-14.1-21.2-14.1-33.9V184.5c0-12.7 5.1-24.9 14.1-33.9L150.5 14.1c9-9 21.2-14.1 33.9-14.1h143.1c12.7 0 24.9 5.1 33.9 14.1l136.5 136.4zM388 296c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12H124c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h264z"]
  },
      aC = {
    prefix: "fas",
    iconName: "minus-square",
    icon: [448, 512, [], "f146", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"]
  },
      nC = {
    prefix: "fas",
    iconName: "mistletoe",
    icon: [576, 512, [], "f7b4", "M373.3 117.3c23.6 0 42.7-19.1 42.7-42.7S396.9 32 373.3 32s-42.7 19.1-42.7 42.7 19.2 42.6 42.7 42.6zm168.8 144.1c-26-26-89.6-38.6-130.9-44.2L312 117.1c-8.4-12.1-13.3-26.6-13.3-42.4s5-30.3 13.3-42.4V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v102.1l-99.1 99.1C123.6 222.8 60 235.4 34 261.4c-40 40-45.4 99.4-12.1 132.7 33.3 33.3 92.8 27.9 132.7-12.1 11.4-11.4 20.1-30.2 26.9-51 6.8 12.3 19.5 20.9 34.5 20.9 22.1 0 40-17.9 40-40s-17.9-40-40-40c-8.2 0-15.4 3.1-21.7 7.3 1.8-10 3.4-19.6 4.5-28.2l65.2-65.2v72.8c14.6 13.2 24 32.1 24 53.3 0 39.7-32.3 72-72 72-6.2 0-12.1-1-17.8-2.5-3.7 9.9-6.2 19.5-6.2 28.1 0 56.6 43 102.4 96 102.4s96-45.8 96-102.4c0-38.1-43.6-94.6-72-127.3v-96.3l65.2 65.2c5.6 41.3 18.2 104.9 44.2 130.9 40 40 99.4 45.4 132.7 12.1 33.4-33.3 28-92.7-12-132.7z"]
  },
      tC = {
    prefix: "fas",
    iconName: "mitten",
    icon: [448, 512, [], "f7b5", "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"]
  },
      rC = {
    prefix: "fas",
    iconName: "mobile",
    icon: [320, 512, [], "f10b", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      iC = {
    prefix: "fas",
    iconName: "mobile-alt",
    icon: [320, 512, [], "f3cd", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"]
  },
      oC = {
    prefix: "fas",
    iconName: "mobile-android",
    icon: [320, 512, [], "f3ce", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-64 452c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v8z"]
  },
      lC = {
    prefix: "fas",
    iconName: "mobile-android-alt",
    icon: [320, 512, [], "f3cf", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-64 452c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v8zm64-80c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"]
  },
      fC = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [640, 512, [], "f0d6", "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"]
  },
      sC = {
    prefix: "fas",
    iconName: "money-bill-alt",
    icon: [640, 512, [], "f3d1", "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"]
  },
      uC = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [640, 512, [], "f53a", "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"]
  },
      hC = {
    prefix: "fas",
    iconName: "money-bill-wave-alt",
    icon: [640, 512, [], "f53b", "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"]
  },
      mC = {
    prefix: "fas",
    iconName: "money-check",
    icon: [640, 512, [], "f53c", "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"]
  },
      vC = {
    prefix: "fas",
    iconName: "money-check-alt",
    icon: [640, 512, [], "f53d", "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"]
  },
      dC = {
    prefix: "fas",
    iconName: "money-check-edit",
    icon: [640, 512, [], "f872", "M462.88 374.62a32 32 0 0 0 22.63 9.38H528a16 16 0 0 0 16-16v-42.46a32 32 0 0 0-9.38-22.63L303.19 71.47l-71.7 71.7zm-254-254l71.7-71.8L238.79 7a24.1 24.1 0 0 0-33.9 0L167 44.87a24 24 0 0 0 0 33.8zM608 160H437l120.27 120.28A64 64 0 0 1 576 325.54V400a16 16 0 0 1-16 16H104a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h323l-64-64H104a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h227L203 160H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32z"]
  },
      MC = {
    prefix: "fas",
    iconName: "money-check-edit-alt",
    icon: [640, 512, [], "f873", "M204.78 116.47l4.1 4.1 71.69-71.8L238.78 7a24.1 24.1 0 0 0-33.9 0L167 44.87a24 24 0 0 0 0 33.8zM608 160H437l120.25 120.28A64 64 0 0 1 576 325.54V400a16 16 0 0 1-16 16H264a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h163l-64-64h-99a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h67L203 160H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM144 415.88V432a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8v-16.29a57.26 57.26 0 0 1-31.37-11.35 8 8 0 0 1-.57-12.14L91.81 381a8.21 8.21 0 0 1 10.13-.73 24.08 24.08 0 0 0 12.82 3.73h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V240a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16.29a57.18 57.18 0 0 1 31.37 11.35 8 8 0 0 1 .57 12.14L164.18 291a8.22 8.22 0 0 1-10.14.73 23.93 23.93 0 0 0-12.81-3.73h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.57 23.42 31.57 43.39 0 24.53-19.04 44.44-42.66 45.07zm318.87-41.25a32 32 0 0 0 22.62 9.37H528a16 16 0 0 0 16-16v-42.46a32 32 0 0 0-9.37-22.63L303.17 71.47l-71.7 71.7z"]
  },
      pC = {
    prefix: "fas",
    iconName: "monitor-heart-rate",
    icon: [576, 512, [], "f611", "M480 96H96v160h100.95c3.03 0 5.8 1.71 7.15 4.42l19.9 39.8 49.69-99.38c5.9-11.79 22.72-11.79 28.62 0L329.89 256H400c8.84 0 16 7.16 16 16s-7.16 16-16 16h-89.89L288 243.78l-49.69 99.38c-5.9 11.79-22.72 11.79-28.62 0L182.11 288H96v128h384V96zm48-96H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zm-16 448H64V64h448v384z"]
  },
      zC = {
    prefix: "fas",
    iconName: "monkey",
    icon: [640, 512, [], "f6fb", "M549.47 267.22C529.43 280.25 505.64 288 480 288c-56.67 0-104.29-37.26-121.08-88.38C262.91 224.9 192 312.05 192 416v32c-17.64 0-32-14.36-32-32V176c0-44.11-35.89-80-80-80S0 131.89 0 176v48c0 17.67 14.33 32 32 32s32-14.33 32-32v-48c0-8.83 7.17-16 16-16s16 7.17 16 16v240c0 52.94 43.06 96 96 96h240c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l155.68-103.79 34.68 104.02 1.64 10.11V496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-37.61c0-10.34-1.67-20.61-4.94-30.42l-53.59-160.75zM592 64h-21.88C556.9 26.8 521.74 0 480 0s-76.9 26.8-90.12 64H368c-26.51 0-48 21.49-48 48s21.49 48 48 48h16c0 53.02 42.98 96 96 96s96-42.98 96-96h16c26.51 0 48-21.49 48-48s-21.49-48-48-48zm-152 56c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      CC = {
    prefix: "fas",
    iconName: "monument",
    icon: [384, 512, [], "f5a6", "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"]
  },
      LC = {
    prefix: "fas",
    iconName: "moon",
    icon: [512, 512, [], "f186", "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"]
  },
      AC = {
    prefix: "fas",
    iconName: "moon-cloud",
    icon: [576, 512, [], "f754", "M256 256c-12 0-23.1 3.5-32.7 9.2-3.5-41-37.4-73.2-79.3-73.2-38.8 0-71.1 27.6-78.4 64.2-.5 0-1-.2-1.6-.2-35.3 0-64 28.7-64 64s28.7 64 64 64h192c35.3 0 64-28.7 64-64s-28.7-64-64-64zm309.3 106.4c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7-11.6-2.1-23.3-3.2-35-3.2-90.8 0-166.7 63.2-186.6 148.1 2.5 4 4.9 8.2 6.9 12.6 3.6-.4 7.1-.6 10.7-.6 52.9 0 96 43.1 96 96 0 36.1-20.2 67.2-49.7 83.6 33.2 27.7 76 44.4 122.7 44.4 59.2 0 113.2-26.9 149-71.1 5.2-6.6-.6-16.2-8.8-14.6z"]
  },
      NC = {
    prefix: "fas",
    iconName: "moon-stars",
    icon: [512, 512, [], "f755", "M332.2 426.4c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C108.7 109.4 0 200 0 320c0 106 85.8 192 191.8 192 59.2 0 113.2-26.9 149-71.1 5.3-6.5-.5-16.1-8.6-14.5zM304 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zm154.7 85.3L432 128l-26.7 53.3L352 208l53.3 26.7L432 288l26.7-53.3L512 208l-53.3-26.7z"]
  },
      gC = {
    prefix: "fas",
    iconName: "mortar-pestle",
    icon: [512, 512, [], "f5a7", "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      HC = {
    prefix: "fas",
    iconName: "mosque",
    icon: [640, 512, [], "f678", "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"]
  },
      VC = {
    prefix: "fas",
    iconName: "motorcycle",
    icon: [640, 512, [], "f21c", "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"]
  },
      xC = {
    prefix: "fas",
    iconName: "mountain",
    icon: [640, 512, [], "f6fc", "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"]
  },
      wC = {
    prefix: "fas",
    iconName: "mountains",
    icon: [640, 512, [], "f6fd", "M635.73 406.91l-194.04-297.6c-11.57-17.75-39.8-17.75-51.37 0l-32.84 50.37 67.68 105.68c2.38 3.72 1.3 8.67-2.42 11.05l-13.46 8.62c-3.72 2.38-8.67 1.3-11.05-2.42l-59.9-93.54-70.81-110.55c-12.4-19.36-42.64-19.36-55.04 0L4.58 403.18C-7.99 422.81 6.81 448 30.92 448h580.22c22.5 0 36.32-23.09 24.59-41.09z"]
  },
      yC = {
    prefix: "fas",
    iconName: "mouse",
    icon: [384, 512, [], "f8cc", "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"]
  },
      bC = {
    prefix: "fas",
    iconName: "mouse-alt",
    icon: [384, 512, [], "f8cd", "M224 0h-64A160 160 0 0 0 0 160v192a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V160A160 160 0 0 0 224 0zm0 160a32 32 0 0 1-64 0v-32a32 32 0 0 1 64 0z"]
  },
      SC = {
    prefix: "fas",
    iconName: "mouse-pointer",
    icon: [320, 512, [], "f245", "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"]
  },
      TC = {
    prefix: "fas",
    iconName: "mp3-player",
    icon: [384, 512, [], "f8ce", "M336 0H48A48 48 0 0 0 0 48v416a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zM192 448a96 96 0 1 1 96-96 96 96 0 0 1-96 96zm128-256H64V64h256zM192 320a32 32 0 1 0 32 32 32 32 0 0 0-32-32z"]
  },
      DC = {
    prefix: "fas",
    iconName: "mug",
    icon: [576, 512, [], "f874", "M448 63H56a23.94 23.94 0 0 0-24 24v264a96 96 0 0 0 96 96h192a96 96 0 0 0 96-96v-32h32a128 128 0 0 0 0-256zm0 192h-32V127h32a64 64 0 0 1 0 128z"]
  },
      jC = {
    prefix: "fas",
    iconName: "mug-hot",
    icon: [512, 512, [], "f7b6", "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
  },
      EC = {
    prefix: "fas",
    iconName: "mug-marshmallows",
    icon: [512, 512, [], "f7b7", "M178.5 67.2l22.4-22.4c-5.9-7.3-14.5-12.4-24.6-12.4H64c-17.7 0-32 14.3-32 32v63.9h130.1c-5.5-21.1-.2-44.6 16.4-61.1zm18.2 61.2h151c7.2-12.3 6.1-28.1-4.4-38.6l-48.5-48.4c-12.5-12.5-32.8-12.5-45.3 0L201 89.8c-10.4 10.5-11.5 26.3-4.3 38.6zM400 160.3H160v63.5c0 17.7-14.3 32-32 32s-32-14.3-32-32v-63.5H32c-17.7 0-32 14.3-32 32v191.8c0 53 43 95.9 96 95.9h192c53 0 96-42.9 96-95.9h16c61.8 0 112-50.2 112-111.9s-50.2-111.9-112-111.9zm0 159.9h-16v-95.9h16c26.5 0 48 21.5 48 47.9s-21.5 48-48 48z"]
  },
      kC = {
    prefix: "fas",
    iconName: "mug-tea",
    icon: [640, 512, [], "f875", "M595.6 416H12.36c-25 0-11.6 64 36 64h511.35c47.69 0 60.89-64 35.89-64zM192 384h192a96 96 0 0 0 96-96h32a128 128 0 0 0 0-256H240v64l38.63 38.63a32 32 0 0 1 9.37 22.62V224a32 32 0 0 1-32 32h-64a32 32 0 0 1-32-32v-66.75a32 32 0 0 1 9.37-22.62L208 96V32h-88a23.94 23.94 0 0 0-24 24v232a96 96 0 0 0 96 96zM480 96h32a64 64 0 0 1 0 128h-32z"]
  },
      IC = {
    prefix: "fas",
    iconName: "music",
    icon: [512, 512, [], "f001", "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"]
  },
      OC = {
    prefix: "fas",
    iconName: "music-alt",
    icon: [384, 512, [], "f8cf", "M310.94 1.33l-96.53 28.51A32 32 0 0 0 192 60.34V360a148.76 148.76 0 0 0-48-8c-61.86 0-112 35.82-112 80s50.14 80 112 80 112-35.82 112-80V148.15l73-21.39a32 32 0 0 0 23-30.71V32a32 32 0 0 0-41.06-30.67z"]
  },
      QC = {
    prefix: "fas",
    iconName: "music-alt-slash",
    icon: [640, 512, [], "f8d0", "M272 352c-61.86 0-112 35.82-112 80s50.14 80 112 80 112-35.82 112-80v-5.18l-94.91-73.36A144.39 144.39 0 0 0 272 352zm361.82 106.1L384 265V148.15l73-21.39a32 32 0 0 0 23-30.71V32a32 32 0 0 0-41.07-30.67L342.4 29.84a32 32 0 0 0-22.4 30.5v155.22L45.47 3.39A16 16 0 0 0 23 6.2L3.37 31.47a16 16 0 0 0 2.81 22.45l588.35 454.71a16 16 0 0 0 22.47-2.81l19.63-25.27a16 16 0 0 0-2.81-22.45z"]
  },
      ZC = {
    prefix: "fas",
    iconName: "music-slash",
    icon: [640, 512, [], "f8d1", "M192 387.92a139 139 0 0 0-32-3.92c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V327.88l-64-49.46zm441.82 70.18l-65.06-50.28c4.51-7.37 7.24-15.35 7.24-23.82V32a32 32 0 0 0-41.62-30.49L214.41 96a31.85 31.85 0 0 0-21 21.73L45.47 3.39A16 16 0 0 0 23 6.2L3.37 31.47a16 16 0 0 0 2.81 22.45l588.35 454.71a16 16 0 0 0 22.47-2.81l19.63-25.27a16 16 0 0 0-2.81-22.45zM512 323.92a139 139 0 0 0-32-3.92 137 137 0 0 0-22.15 2.11l-156.61-121L512 139.3z"]
  },
      UC = {
    prefix: "fas",
    iconName: "narwhal",
    icon: [640, 512, [], "f6fe", "M600.83 211.05l38.9-166.17c1.04-4.46-.94-9.25-5.14-11.57-5.07-2.8-11.45-.96-14.25 4.11L535 192s.41.17 1.12.46C299.61 197.4 227.97 416 163.88 416 144.1 416 128 399.91 128 380.13v-97.99l49.75-30.51A32.007 32.007 0 0 0 192 225v-80.98c0-12.78-14.24-20.4-24.88-13.31L96 178.13l-71.12-47.42C14.24 123.63 0 131.25 0 144.03V225c0 10.7 5.35 20.69 14.25 26.62L64 282.14v97.99C64 435.2 108.8 480 163.88 480H576c35.35 0 64-28.65 64-64V288c0-31.6-15.54-59.45-39.17-76.95zM432 352c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      BC = {
    prefix: "fas",
    iconName: "network-wired",
    icon: [640, 512, [], "f6ff", "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"]
  },
      RC = {
    prefix: "fas",
    iconName: "neuter",
    icon: [288, 512, [], "f22c", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      YC = {
    prefix: "fas",
    iconName: "newspaper",
    icon: [576, 512, [], "f1ea", "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"]
  },
      PC = {
    prefix: "fas",
    iconName: "not-equal",
    icon: [448, 512, [], "f53e", "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"]
  },
      FC = {
    prefix: "fas",
    iconName: "notes-medical",
    icon: [384, 512, [], "f481", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"]
  },
      WC = {
    prefix: "fas",
    iconName: "object-group",
    icon: [512, 512, [], "f247", "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"]
  },
      GC = {
    prefix: "fas",
    iconName: "object-ungroup",
    icon: [576, 512, [], "f248", "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"]
  },
      qC = {
    prefix: "fas",
    iconName: "octagon",
    icon: [512, 512, [], "f306", "M361.5 14.1c-9-9-21.2-14.1-33.9-14.1H184.5c-12.7 0-24.9 5.1-33.9 14.1L14.1 150.5c-9 9-14.1 21.2-14.1 33.9v143.1c0 12.7 5.1 24.9 14.1 33.9l136.5 136.5c9 9 21.2 14.1 33.9 14.1h143.1c12.7 0 24.9-5.1 33.9-14.1L498 361.4c9-9 14.1-21.2 14.1-33.9v-143c0-12.7-5.1-24.9-14.1-33.9L361.5 14.1z"]
  },
      JC = {
    prefix: "fas",
    iconName: "oil-can",
    icon: [640, 512, [], "f613", "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"]
  },
      KC = {
    prefix: "fas",
    iconName: "oil-temp",
    icon: [640, 512, [], "f614", "M320 384c44.18 0 80-35.82 80-80 0-32.79-19.77-60.89-48-73.25V208h48c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-48v-32h48c8.84 0 16-7.16 16-16V96c0-8.84-7.16-16-16-16h-48V48h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v214.75c-28.23 12.35-48 40.46-48 73.25 0 44.18 35.82 80 80 80zm-304 0h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84 5.67 0 11.01-.79 16.46-1.3-16.71-16.89-27.65-39.17-30.96-63.86-18.79-2.44-33.34-9.14-41.59-16.74-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 311.58 58.04 320 32 320H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16zm608 64h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 439.58 442.04 448 416 448s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 439.58 250.04 448 224 448s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 439.58 58.04 448 32 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-128h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1-8.24 7.6-22.8 14.3-41.59 16.74-3.32 24.69-14.25 46.97-30.96 63.86 5.46.51 10.79 1.3 16.46 1.3 38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c.02-8.84-7.14-16-15.98-16z"]
  },
      XC = {
    prefix: "fas",
    iconName: "om",
    icon: [512, 512, [], "f679", "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"]
  },
      _C = {
    prefix: "fas",
    iconName: "omega",
    icon: [512, 512, [], "f67a", "M488 416h-32.61c42.89-53.17 65.05-123.68 53.64-199.4C492.12 104.36 399.19 14.85 286.45 1.77 131.74-16.18 0 104.82 0 256c0 60.59 21.27 116.18 56.61 160H24c-13.25 0-24 10.75-24 24v48c0 13.25 10.75 24 24 24h136c17.67 0 32-14.33 32-32v-42.7c0-20.53-11.09-38.78-27.88-50.59-48.22-33.92-76.98-93.67-65.67-159.06 10.89-62.93 60.5-114.85 122.99-128.01C324.68 77.9 416 156.49 416 256c0 54.44-27.4 102.51-69.08 131.38-16.49 11.43-26.92 29.63-26.92 49.7V480c0 17.67 14.33 32 32 32h136c13.25 0 24-10.75 24-24v-48c0-13.25-10.75-24-24-24z"]
  },
      $C = {
    prefix: "fas",
    iconName: "ornament",
    icon: [384, 512, [], "f7b8", "M288 153.9V112c0-8.8-7.2-16-16-16h-24.9c5.5-9.4 8.9-20.3 8.9-32 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 11.7 3.4 22.6 8.9 32H112c-8.8 0-16 7.2-16 16v41.9C66.9 170.7 42.7 195 25.9 224h332.2c-16.8-29-41-53.3-70.1-70.1zM192 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm180.6 176H11.4C4.3 276.1 0 297.5 0 320s4.1 44 11.2 64h361.7c7.1-20 11.2-41.5 11.2-64-.1-22.5-4.4-43.9-11.5-64zM192 512c71 0 132.9-38.7 166.1-96H25.9c33.2 57.3 95.1 96 166.1 96z"]
  },
      cL = {
    prefix: "fas",
    iconName: "otter",
    icon: [640, 512, [], "f700", "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"]
  },
      eL = {
    prefix: "fas",
    iconName: "outdent",
    icon: [448, 512, [], "f03b", "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      aL = {
    prefix: "fas",
    iconName: "outlet",
    icon: [512, 512, [], "e01c", "M448,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H448a64,64,0,0,0,64-64V64A64,64,0,0,0,448,0ZM386.26,409.29A22.87,22.87,0,0,1,369.85,416H142.15a22.87,22.87,0,0,1-16.41-6.71C87.71,370.28,64,316.1,64,256s23.71-114.28,61.74-153.3A22.86,22.86,0,0,1,142.15,96h227.7a22.86,22.86,0,0,1,16.41,6.7c38,39,61.74,93.2,61.74,153.3S424.29,370.28,386.26,409.29ZM256,304a32,32,0,0,0-32,32v16h64V336A32,32,0,0,0,256,304ZM192,176H176a16,16,0,0,0-16,16v80a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V192A16,16,0,0,0,192,176Zm144,0H320a16,16,0,0,0-16,16v80a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V192A16,16,0,0,0,336,176Z"]
  },
      nL = {
    prefix: "fas",
    iconName: "oven",
    icon: [448, 512, [], "e01d", "M96,320H352V288H96ZM384,0H64A64,64,0,0,0,0,64v96H448V64A64,64,0,0,0,384,0ZM80,104a24,24,0,1,1,24-24A24,24,0,0,1,80,104Zm96,0a24,24,0,1,1,24-24A24,24,0,0,1,176,104Zm96,0a24,24,0,1,1,24-24A24,24,0,0,1,272,104Zm96,0a24,24,0,1,1,24-24A24,24,0,0,1,368,104ZM0,480a32,32,0,0,0,32,32H416a32,32,0,0,0,32-32V192H0ZM64,256H384V448H64Z"]
  },
      tL = {
    prefix: "fas",
    iconName: "overline",
    icon: [448, 512, [], "f876", "M432 0H16A16 16 0 0 0 0 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16zM232.19 128h-16.38A167.81 167.81 0 0 0 48 295.81v48.38A167.81 167.81 0 0 0 215.81 512h16.38A167.81 167.81 0 0 0 400 344.19v-48.38A167.81 167.81 0 0 0 232.19 128zM320 344.19A87.91 87.91 0 0 1 232.19 432h-16.38A87.91 87.91 0 0 1 128 344.19v-48.38A87.91 87.91 0 0 1 215.81 208h16.38A87.91 87.91 0 0 1 320 295.81z"]
  },
      rL = {
    prefix: "fas",
    iconName: "page-break",
    icon: [576, 512, [], "f877", "M243.6 256a19.59 19.59 0 0 0-19.6 19.6v24.8a19.59 19.59 0 0 0 19.6 19.6h88.8a19.59 19.59 0 0 0 19.6-19.6v-24.8a19.59 19.59 0 0 0-19.6-19.6zM160 64h176v64a16 16 0 0 0 16 16h64v64h64v-76.06a48.16 48.16 0 0 0-14.09-34L382 14.09A48 48 0 0 0 348.09 0H144a48.14 48.14 0 0 0-48 48.07V208h64zm400 192H432a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM416 448H160v-80H96v96a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48v-96h-64zM160 304v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16z"]
  },
      iL = {
    prefix: "fas",
    iconName: "pager",
    icon: [512, 512, [], "f815", "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"]
  },
      oL = {
    prefix: "fas",
    iconName: "paint-brush",
    icon: [512, 512, [], "f1fc", "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"]
  },
      lL = {
    prefix: "fas",
    iconName: "paint-brush-alt",
    icon: [512, 512, [], "f5a9", "M365.99 33.1L194.11 289.51l78 65 218.81-221.52C564.15 52.52 427.95-55.3 365.99 33.1zM167.87 309.29c-40.45 2.41-77.23 17.53-98.03 72.35-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.39-.68-6.64-1.06-9.96l-87.07-72.56z"]
  },
      fL = {
    prefix: "fas",
    iconName: "paint-roller",
    icon: [512, 512, [], "f5aa", "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"]
  },
      sL = {
    prefix: "fas",
    iconName: "palette",
    icon: [512, 512, [], "f53f", "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      uL = {
    prefix: "fas",
    iconName: "pallet",
    icon: [640, 512, [], "f482", "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"]
  },
      hL = {
    prefix: "fas",
    iconName: "pallet-alt",
    icon: [640, 512, [], "f483", "M80 256h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm320 0h160c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H400c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16zm224 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"]
  },
      mL = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [512, 512, [], "f1d8", "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"]
  },
      vL = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [448, 512, [], "f0c6", "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"]
  },
      dL = {
    prefix: "fas",
    iconName: "parachute-box",
    icon: [512, 512, [], "f4cd", "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"]
  },
      ML = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [448, 512, [], "f1dd", "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"]
  },
      pL = {
    prefix: "fas",
    iconName: "paragraph-rtl",
    icon: [384, 512, [], "f878", "M368 384H112v-48c0-14.25-17.23-21.39-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 516.64 112 511.64 112 496v-48h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM144 224h16v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h32v240a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V64h16a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H144C80 0 32 48 32 112s48 112 112 112z"]
  },
      zL = {
    prefix: "fas",
    iconName: "parking",
    icon: [448, 512, [], "f540", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"]
  },
      CL = {
    prefix: "fas",
    iconName: "parking-circle",
    icon: [496, 512, [], "f615", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.46 0-184-82.54-184-184S146.54 72 248 72s184 82.54 184 184-82.54 184-184 184zm32-296h-96c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h48c44.18 0 80-35.82 80-80s-35.82-80-80-80zm0 96h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16z"]
  },
      LL = {
    prefix: "fas",
    iconName: "parking-circle-slash",
    icon: [496, 512, [], "f616", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.46 0-184-82.54-184-184 0-30.83 7.71-59.86 21.17-85.41l286.39 221.35C338.86 421.69 295.58 440 248 440zm-9.77-232H280c8.82 0 16 7.18 16 16s-7.18 16-16 16h-.37l-41.4-32zm172.6 133.41l-76.42-59.06C350.07 267.74 360 247.1 360 224c0-44.18-35.82-80-80-80h-96c-6.91 0-12.67 4.43-14.9 10.57l-44.66-34.51C157.14 90.31 200.42 72 248 72c101.46 0 184 82.54 184 184 0 30.83-7.71 59.86-21.17 85.41zM168 352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-19.48l-64-49.46V352z"]
  },
      AL = {
    prefix: "fas",
    iconName: "parking-slash",
    icon: [640, 512, [], "f617", "M288 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64.86L96 204.21V432c0 26.5 21.5 48 48 48h308.83L288 352.6V368zm345.82 90.1L544 388.68V80c0-26.5-21.5-48-48-48H144c-15.31 0-28.79 7.31-37.58 18.48L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM409.69 284.87l-50.53-39.05c5.4-5.73 8.84-13.34 8.84-21.82 0-17.64-14.36-32-32-32h-46.48l-65.06-50.29C225.61 134 231.98 128 240 128h96c52.94 0 96 43.06 96 96 0 23.24-8.49 44.35-22.31 60.87z"]
  },
      NL = {
    prefix: "fas",
    iconName: "passport",
    icon: [448, 512, [], "f5ab", "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"]
  },
      gL = {
    prefix: "fas",
    iconName: "pastafarianism",
    icon: [640, 512, [], "f67b", "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"]
  },
      HL = {
    prefix: "fas",
    iconName: "paste",
    icon: [448, 512, [], "f0ea", "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"]
  },
      VL = {
    prefix: "fas",
    iconName: "pause",
    icon: [448, 512, [], "f04c", "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"]
  },
      xL = {
    prefix: "fas",
    iconName: "pause-circle",
    icon: [512, 512, [], "f28b", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"]
  },
      wL = {
    prefix: "fas",
    iconName: "paw",
    icon: [512, 512, [], "f1b0", "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"]
  },
      yL = {
    prefix: "fas",
    iconName: "paw-alt",
    icon: [448, 512, [], "f701", "M144 128c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm-48 64c0-26.51-21.49-48-48-48S0 165.49 0 192s21.49 48 48 48 48-21.49 48-48zm208-64c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48zm96 16c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-32.69 156.78c-26.29-14.84-47.14-61.41-67.17-97.83C284.41 174.31 254.21 160 224 160s-60.41 14.31-76.15 42.95c-20.29 36.96-40.12 82.56-67.17 97.83C51.63 317.18 32 348.18 32 383.95c0 53.01 42.98 95.98 96 95.98 51.71 1.76 72.19-31.99 96-31.99s44.29 33.75 96 31.99c53.02 0 96-42.97 96-95.98 0-35.77-19.63-66.77-48.69-83.17z"]
  },
      bL = {
    prefix: "fas",
    iconName: "paw-claws",
    icon: [512, 512, [], "f702", "M193.44 222.61c30.94-8.14 46.42-49.94 34.58-93.36-6.53-23.92-20.07-43.04-36.02-54.29V0l-64.01 79.99c-15.02 17.7-20.45 47.82-12.01 78.75 11.84 43.42 46.53 72.02 77.46 63.87zm125.12 0c30.94 8.14 65.62-20.45 77.46-63.87 8.44-30.94 3.01-61.05-12.01-78.75L320 0v74.96c-15.95 11.26-29.49 30.37-36.02 54.29-11.84 43.42 3.64 85.22 34.58 93.36zM256 256c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 378.76 335.41 256 256 256zm-147.28-12.61c-7.21-24.03-24.89-41.91-44.72-48.46V128l-45.51 62.37A96.204 96.204 0 0 0 0 247.09c.03 6.97 1.09 14.22 3.28 21.52 10.4 34.65 42.44 57.09 71.56 50.13 29.11-6.97 44.28-40.7 33.88-75.35zm384.79-53.02L448 128v66.94c-19.83 6.55-37.51 24.43-44.72 48.46-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 2.19-7.29 3.25-14.54 3.28-21.52a96.283 96.283 0 0 0-18.5-56.72z"]
  },
      SL = {
    prefix: "fas",
    iconName: "peace",
    icon: [496, 512, [], "f67c", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"]
  },
      TL = {
    prefix: "fas",
    iconName: "pegasus",
    icon: [576, 512, [], "f703", "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128-63.92 0-104.2-36.78-127.66-90.27-3.22-7.35-13.61-7.76-17.04-.5C165.49 57.82 160 80.8 160 105.1c0 67.04 51.01 133.09 128 147.74v3.17c-82.89 0-143.33-57.52-157.03-122.86-16.72 5.47-31.62 14.98-42.97 27.97V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      DL = {
    prefix: "fas",
    iconName: "pen",
    icon: [512, 512, [], "f304", "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"]
  },
      jL = {
    prefix: "fas",
    iconName: "pen-alt",
    icon: [512, 512, [], "f305", "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"]
  },
      EL = {
    prefix: "fas",
    iconName: "pen-fancy",
    icon: [512, 512, [], "f5ac", "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"]
  },
      kL = {
    prefix: "fas",
    iconName: "pen-nib",
    icon: [512, 512, [], "f5ad", "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"]
  },
      IL = {
    prefix: "fas",
    iconName: "pen-square",
    icon: [448, 512, [], "f14b", "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"]
  },
      OL = {
    prefix: "fas",
    iconName: "pencil",
    icon: [512, 512, [], "f040", "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"]
  },
      QL = {
    prefix: "fas",
    iconName: "pencil-alt",
    icon: [512, 512, [], "f303", "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"]
  },
      ZL = {
    prefix: "fas",
    iconName: "pencil-paintbrush",
    icon: [512, 512, [], "f618", "M316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm181.85 44.53c18.75-18.76 18.75-49.17 0-67.93l-45.26-45.25c-18.76-18.76-49.18-18.76-67.94 0L338.7 60.08l113.2 113.2 46.03-46.04zm-41.18 264.38c-6.59 0-12.24-3.77-14.59-9.98-18.13-47.78-48.4-65.38-82.65-70.71L257.83 412.61C266.64 475.95 315.42 512 384 512c90.07 0 128-72.38 128-154.73-9.79 6.68-44.14 34.35-55.25 34.35zm-336.57-158.3L216 137.51 146.01 33.1C84.05-55.3-52.15 52.52 21.08 132.99l99.1 100.33z"]
  },
      UL = {
    prefix: "fas",
    iconName: "pencil-ruler",
    icon: [512, 512, [], "f5ae", "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"]
  },
      BL = {
    prefix: "fas",
    iconName: "pennant",
    icon: [576, 512, [], "f456", "M571 228.5c-78.1 88.2-179.8 108.8-184.1 109.6-134.8 26.1-153.3 7.5-237.1 37.5-10.6 3.8-21.8-3.6-21.8-14.8V112.5c0-9 7.3-16.4 16.3-16 43.2 2 95.3 13.2 155.2 42.4 140.6 68.5 223.7 62.9 252.9 57.2 18-3.8 31.3 18.1 18.6 32.4zM56 0C25.1 0 0 25.1 0 56c0 22.3 13.2 41.4 32 50.4V504c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V106.4c18.8-9 32-28.1 32-50.4 0-30.9-25.1-56-56-56z"]
  },
      RL = {
    prefix: "fas",
    iconName: "people-arrows",
    icon: [576, 512, [], "e068", "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"]
  },
      YL = {
    prefix: "fas",
    iconName: "people-carry",
    icon: [640, 512, [], "f4ce", "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"]
  },
      PL = {
    prefix: "fas",
    iconName: "pepper-hot",
    icon: [512, 512, [], "f816", "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"]
  },
      FL = {
    prefix: "fas",
    iconName: "percent",
    icon: [448, 512, [], "f295", "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"]
  },
      WL = {
    prefix: "fas",
    iconName: "percentage",
    icon: [384, 512, [], "f541", "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"]
  },
      GL = {
    prefix: "fas",
    iconName: "person-booth",
    icon: [576, 512, [], "f756", "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"]
  },
      qL = {
    prefix: "fas",
    iconName: "person-carry",
    icon: [384, 512, [], "f4cf", "M0 479.9c0 17.7 14.3 32 32 32s32-14.3 32-32v-74.5C48 391.7.6 350.8 0 350.3v129.6zM368 96H208c-8.8 0-16 7.2-16 16v112h-25.4l-33.3-61.8c-11.1-21.1-32.8-34.2-56.6-34.2H48c-26.5 0-48 21.5-48 48v103c0 18.7 8.2 36.4 22.4 48.6l76 65.1 14.1 92.5c1 5.7 10.1 30.7 36.8 26.3 17.4-2.9 29.2-19.4 26.3-36.8l-14.1-92.5c-2.5-14.8-10.1-28.3-21.5-38.1l-44-37.7v-78.3l32 59.9h240c8.8 0 16-7.2 16-16V112c0-8.9-7.2-16-16-16zM80 96c26.5 0 48-21.5 48-48S106.5 0 80 0 32 21.5 32 48s21.5 48 48 48z"]
  },
      JL = {
    prefix: "fas",
    iconName: "person-dolly",
    icon: [512, 512, [], "f4d0", "M331.1 360.5c2.3 8.5 11.1 13.6 19.6 11.3l117-31.3c8.5-2.3 13.6-11.1 11.3-19.6L447.6 204c-2.3-8.5-11.1-13.6-19.6-11.3L311 224c-8.5 2.3-13.6 11.1-11.3 19.6l31.4 116.9zM0 479.9c0 17.7 14.3 32 32 32s32-14.3 32-32v-74.5C48 391.7.5 350.8 0 350.3v129.6zm503.4-106.1c-1.1-4.3-5.5-6.8-9.8-5.7l-154.1 41.3c-9.8-12.9-24.2-21.9-40.9-24.5l-59.4-221.6c-1.1-4.3-5.5-6.8-9.8-5.7l-30.9 8.3c-4.3 1.1-6.8 5.5-5.7 9.8l12.9 48.2h-39l-33.3-61.8c-11.1-21.1-32.8-34.2-56.7-34.2H48c-26.5 0-48 21.5-48 48v103c0 18.7 8.2 36.4 22.4 48.6l76 65.1 14.1 92.5c1 5.7 10.1 30.7 36.8 26.3 17.4-2.9 29.2-19.4 26.3-36.8l-14.1-92.5c-2.5-14.8-10.1-28.3-21.5-38.1l-44-37.7V228l32 59.9h94.8l28.9 107.8c-16.4 11.6-27.2 30.6-27.2 52.2 0 35.3 28.7 64 64 64 32.7 0 59.3-24.5 63.2-56.1l154.2-41.3c4.3-1.1 6.8-5.5 5.7-9.8l-8.2-30.9zm-214.8 90.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.1 16-16 16zM80 96c26.5 0 48-21.5 48-48S106.6 0 80 0 32 21.5 32 48s21.5 48 48 48z"]
  },
      KL = {
    prefix: "fas",
    iconName: "person-dolly-empty",
    icon: [512, 512, [], "f4d1", "M0 479.9c0 17.7 14.3 32 32 32s32-14.3 32-32v-74.5C48 391.7.5 350.8 0 350.3v129.6zm503.4-106.1c-1.1-4.3-5.5-6.8-9.8-5.7l-154.1 41.3c-9.8-12.9-24.2-21.9-40.9-24.5l-59.4-221.6c-1.1-4.3-5.5-6.8-9.8-5.7l-30.9 8.3c-4.3 1.1-6.8 5.5-5.7 9.8l12.9 48.2h-39l-33.3-61.8c-11.1-21.1-32.8-34.2-56.7-34.2H48c-26.5 0-48 21.5-48 48v103c0 18.7 8.2 36.4 22.4 48.6l76 65.1 14.1 92.5c1 5.7 10.1 30.7 36.8 26.3 17.4-2.9 29.2-19.4 26.3-36.8l-14.1-92.5c-2.5-14.8-10.1-28.3-21.5-38.1l-44-37.7V228l32 59.9h94.8l28.9 107.8c-16.4 11.6-27.2 30.6-27.2 52.2 0 35.3 28.7 64 64 64 32.7 0 59.3-24.5 63.2-56.1l154.2-41.3c4.3-1.1 6.8-5.5 5.7-9.8l-8.2-30.9zm-214.8 90.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.1 16-16 16zM80 96c26.5 0 48-21.5 48-48S106.6 0 80 0 32 21.5 32 48s21.5 48 48 48z"]
  },
      XL = {
    prefix: "fas",
    iconName: "person-sign",
    icon: [512, 512, [], "f757", "M144 96c26.5 0 48-21.5 48-48S170.4 0 144 0 96 21.5 96 48s21.5 48 48 48zm357.5-29.4L433.8 42l5.5-15c3-8.3-1.3-17.5-9.6-20.5l-15-5.5c-8.3-3-17.5 1.3-20.5 9.6l-5.5 15L321.1 1c-8.3-3-17.5 1.3-20.5 9.6l-43.8 120.3c-3 8.3 1.3 17.5 9.6 20.5L334 176l-13 36-47.8-16-49.3-49.3c-12.1-12.1-28.1-18.8-45.2-18.8h-62.9c-24.4 0-46.3 13.6-57.2 35.4L3.4 273.7c-7.9 15.8-1.5 35 14.3 42.9 4.6 2.3 9.5 3.4 14.3 3.4 11.7 0 23-6.5 28.6-17.7L80 263.6v54.8L64.1 476.8c-1.7 17.6 11.1 33.3 28.6 35 1.1.1 2.2.2 3.2.2 16.2 0 30.1-12.3 31.8-28.8L140.9 352h15.3l35.8 71.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-82.5v-91.2l20 20c7 7 15.6 12.3 25 15.5l46.1 15.4-11.2 30.8c-3 8.3 1.3 17.5 9.6 20.5l15 5.5c8.3 3 17.5-1.3 20.5-9.6l46.2-126.9 67.6 24.6c8.3 3 17.5-1.3 20.5-9.6L511 87.1c3.1-8.3-1.2-17.4-9.5-20.5z"]
  },
      _L = {
    prefix: "fas",
    iconName: "phone",
    icon: [512, 512, [], "f095", "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"]
  },
      $L = {
    prefix: "fas",
    iconName: "phone-alt",
    icon: [512, 512, [], "f879", "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"]
  },
      cA = {
    prefix: "fas",
    iconName: "phone-laptop",
    icon: [640, 512, [], "f87a", "M604 128H420a36 36 0 0 0-36 36v312a36 36 0 0 0 36 36h184a36 36 0 0 0 36-36V164a36 36 0 0 0-36-36zm-28 320H448V192h128zM128 64h320v32h64V48a48.1 48.1 0 0 0-47.91-48H111.91A48.1 48.1 0 0 0 64 48v240H16a16 16 0 0 0-16 16v16a64.14 64.14 0 0 0 63.91 64H352v-96H128z"]
  },
      eA = {
    prefix: "fas",
    iconName: "phone-office",
    icon: [576, 512, [], "f67d", "M128 416h64c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v352c0 17.67 14.33 32 32 32zM528 32H256v352c0 35.29-28.71 64-64 64h-64c-35.29 0-64-28.71-64-64V32H48C21.49 32 0 53.49 0 80v384c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM384 432c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v32zm0-128c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v32zm128 128c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v32zm0-128c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v32zm0-112H320V96h192v96z"]
  },
      aA = {
    prefix: "fas",
    iconName: "phone-plus",
    icon: [512, 512, [], "f4d2", "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4zM16 144h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16h-64V16c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v64H16C7.2 80 0 87.2 0 96v32c0 8.8 7.2 16 16 16z"]
  },
      nA = {
    prefix: "fas",
    iconName: "phone-rotary",
    icon: [512, 512, [], "f8d3", "M370.43 192.25A64 64 0 0 0 314.86 160H197.14a64 64 0 0 0-55.57 32.25L36.22 376.62A32 32 0 0 0 32 392.5V448a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-55.5a32 32 0 0 0-4.22-15.88zM256 384a72 72 0 1 1 72-72 72 72 0 0 1-72 72zm250.18-261C436.76 65 347.38 32 256 32S75.24 65 5.82 123A16.45 16.45 0 0 0 0 135.64V192a16 16 0 0 0 16 16h70.11a16 16 0 0 0 14.31-8.85L128 128c39.9-17.28 83.2-24 128-24 44.77 0 88.07 6.72 128 24l27.58 71.15a16 16 0 0 0 14.31 8.85H496a16 16 0 0 0 16-16v-56.36a16.45 16.45 0 0 0-5.82-12.64z"]
  },
      tA = {
    prefix: "fas",
    iconName: "phone-slash",
    icon: [640, 512, [], "f3dd", "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"]
  },
      rA = {
    prefix: "fas",
    iconName: "phone-square",
    icon: [448, 512, [], "f098", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"]
  },
      iA = {
    prefix: "fas",
    iconName: "phone-square-alt",
    icon: [448, 512, [], "f87b", "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"]
  },
      oA = {
    prefix: "fas",
    iconName: "phone-volume",
    icon: [384, 512, [], "f2a0", "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"]
  },
      lA = {
    prefix: "fas",
    iconName: "photo-video",
    icon: [640, 512, [], "f87c", "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"]
  },
      fA = {
    prefix: "fas",
    iconName: "pi",
    icon: [512, 512, [], "f67e", "M488 160c13.25 0 24-10.75 24-24V88c0-13.26-10.75-24-24-24H99.91c-16.97 0-33.25 6.74-45.25 18.74L4.72 132.69C-5.36 142.77 1.78 160 16.03 160H128v142.46c0 38.8-12.89 75.63-36.62 105.62-7.27 9.18-5.71 22.57 2.56 30.85l34.11 34.11c10.25 10.25 26.95 8.94 36.12-2.28C202.93 423.33 224 364.51 224 302.46V160h64v202.58c0 54.98 37.28 105.36 91.32 115.42 42.26 7.87 83.64-7.87 109.62-40.34l17.8-21.66c8.28-10.35 6.6-25.45-3.75-33.73l-37.46-29.98c-10.35-8.28-25.45-6.61-33.73 3.75L414 377.67a16.806 16.806 0 0 1-13.16 6.33c-9.28 0-16.84-7.56-16.84-16.84V160h104z"]
  },
      sA = {
    prefix: "fas",
    iconName: "piano",
    icon: [512, 512, [], "f8d4", "M476.62,269.81l-57.24-28.62A64,64,0,0,1,384,184,184.45,184.45,0,0,0,199.55-.5h-15.1A184.45,184.45,0,0,0,0,184H0V479.5a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V327.05A64,64,0,0,0,476.62,269.81ZM448,447.5H64v-96H96v56a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8v-56h32v56a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8v-56h32v56a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8v-56h64v56a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8v-56h32v56a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8v-56h32Z"]
  },
      uA = {
    prefix: "fas",
    iconName: "piano-keyboard",
    icon: [576, 512, [], "f8d5", "M544 63H32A32 32 0 0 0 0 95v320a32 32 0 0 0 32 32h512a32 32 0 0 0 32-32V95a32 32 0 0 0-32-32zM144 383H64V223h64v80a16 16 0 0 0 16 16zm128 0h-96v-64a16 16 0 0 0 16-16v-80h64v80a16 16 0 0 0 16 16zm128 0h-96v-64a16 16 0 0 0 16-16v-80h64v80a16 16 0 0 0 16 16zm112 0h-80v-64a16 16 0 0 0 16-16v-80h64z"]
  },
      hA = {
    prefix: "fas",
    iconName: "pie",
    icon: [576, 512, [], "f705", "M458.78 304c-10.12 6.94-36.19 32-85.25 32s-75.15-25-85.26-32h-.08c-7.33 5-35.19 32-85.28 32-49.13 0-75.17-25-85.34-32h-.22c-8.34 5.7-26.69 22.63-59.6 29.2l31 92.88A32 32 0 0 0 119.07 448h337.87a32 32 0 0 0 30.36-21.88l31-92.88c-33.11-6.62-52.47-24.4-59.46-29.2zM544 240c-6.44 0-10.37-1.2-14.47-3.52C494.93 136.17 400.07 64 288 64S81 136.21 46.45 236.55c-4.07 2.28-8 3.45-14.45 3.45a32 32 0 0 0 0 64c32 0 50-13.47 61.92-22.39 9.08-6.8 12.83-9.61 23.53-9.61s14.47 2.81 23.55 9.61c11.91 8.92 29.89 22.39 61.91 22.39s50-13.48 61.88-22.41c9-6.78 12.8-9.59 23.45-9.59s14.39 2.81 23.44 9.59c11.89 8.92 29.86 22.41 61.86 22.41s49.95-13.48 61.84-22.41c9.05-6.78 12.8-9.59 23.44-9.59s14.34 2.81 23.38 9.58C494.06 290.52 512 304 544 304a32 32 0 0 0 0-64zm-337.69-88.84l-16 32c-9.44 18.83-38.17 4.79-28.62-14.31l16-32c9.53-18.85 38.09-4.63 28.62 14.31zM304 176c0 21.17-32 21.18-32 0v-32c0-21.17 32-21.18 32 0zm81.69 7.16l-16-32c-9.48-18.95 19.13-33.19 28.62-14.31l16 32c9.53 19.05-19.17 33.15-28.62 14.31z"]
  },
      mA = {
    prefix: "fas",
    iconName: "pig",
    icon: [576, 512, [], "f706", "M560 192h-29.51c-8.77-20.04-21.64-37.71-37.38-52.46L512 64h-32c-29.4 0-55.39 13.5-73 34.32-7.57-1.1-15.12-2.32-23-2.32H256c-77.4 0-141.95 54.97-156.78 128H56c-14.8 0-26.51-13.46-23.54-28.78C34.68 183.82 45.34 176 56.95 176h1.01c3.34 0 6.04-2.71 6.04-6.04v-19.92c0-3.34-2.71-6.04-6.04-6.04C29.5 144 4.1 164.4.47 192.62-3.91 226.77 22.7 256 56 256h40c0 52.18 25.35 98.07 64 127.28V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-48h128v48c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-80.72A160.09 160.09 0 0 0 511.28 352H560c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm-128 64c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      vA = {
    prefix: "fas",
    iconName: "piggy-bank",
    icon: [576, 512, [], "f4d3", "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"]
  },
      dA = {
    prefix: "fas",
    iconName: "pills",
    icon: [576, 512, [], "f484", "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"]
  },
      MA = {
    prefix: "fas",
    iconName: "pizza",
    icon: [576, 512, [], "f817", "M403.22 403.08c-81.87 81.92-215 81.22-296-2.11-77-79.19-77-210.74 0-289.94 81-83.33 214.14-84 296-2.11l22-22.07c6.46-6.46 6.44-17.36-.42-23.39-112.86-99.22-292.21-82.09-382.18 51.37-56.83 84.3-56.83 198.05 0 282.34 90 133.46 269.32 150.59 382.23 51.37 6.86-6 6.88-16.93.42-23.39zM131.9 380.45a175.77 175.77 0 0 0 248.71 0L256.25 256l124.36-124.45a175.77 175.77 0 0 0-248.71 0c-68.68 68.73-68.68 180.17 0 248.9zM256.25 352a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-48-208a16 16 0 1 1-16 16 16 16 0 0 1 16.04-16zm-48 96a16 16 0 1 1-16 16 16 16 0 0 1 16.08-16zm362.99-139.87c-5.79-7.55-17.22-7.92-23.95-1.19l-21.42 21.44c66.7 77.84 66.7 193.4 0 271.24l21.42 21.44c6.73 6.73 18.16 6.37 23.95-1.19a256.62 256.62 0 0 0 0-311.74zm-68.05 43l-49.92 50a15.83 15.83 0 0 1 10.86 15 16 16 0 0 1-16 16 15.83 15.83 0 0 1-14.95-10.87L342.35 256l112.84 112.93a176.6 176.6 0 0 0 0-225.85zM448.1 288a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"]
  },
      pA = {
    prefix: "fas",
    iconName: "pizza-slice",
    icon: [512, 512, [], "f818", "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"]
  },
      zA = {
    prefix: "fas",
    iconName: "place-of-worship",
    icon: [640, 512, [], "f67f", "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"]
  },
      CA = {
    prefix: "fas",
    iconName: "plane",
    icon: [576, 512, [], "f072", "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"]
  },
      LA = {
    prefix: "fas",
    iconName: "plane-alt",
    icon: [576, 512, [], "f3de", "M472 200H347.7l-38.6-72H324c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12h-49.2L243.5 5.7c-2.2-3.5-6.1-5.7-10.2-5.7h-57.8c-7.9 0-13.6 7.4-11.6 15l33.3 185.4c-32.6 1-63.1 3.7-89.9 7.8l-39.8-66.4c-2.2-3.6-6.1-5.8-10.3-5.8H14.6c-7.6 0-13.3 6.9-11.8 14.4l16.6 82.8C6.9 240.1 0 247.9 0 256s6.9 15.9 19.4 22.8L2.9 361.6C1.4 369.1 7.1 376 14.6 376h42.6c4.2 0 8.1-2.2 10.3-5.8l39.8-66.4c26.8 4.1 57.3 6.8 89.9 7.8L163.9 497c-2 7.6 3.8 15 11.6 15h57.8c4.2 0 8-2.2 10.2-5.7l31.3-58.3H324c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-14.9l38.6-72H472c57.4 0 104-25.1 104-56s-46.6-56-104-56z"]
  },
      AA = {
    prefix: "fas",
    iconName: "plane-arrival",
    icon: [640, 512, [], "f5af", "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"]
  },
      NA = {
    prefix: "fas",
    iconName: "plane-departure",
    icon: [640, 512, [], "f5b0", "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"]
  },
      gA = {
    prefix: "fas",
    iconName: "plane-slash",
    icon: [640, 512, [], "e069", "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"]
  },
      HA = {
    prefix: "fas",
    iconName: "planet-moon",
    icon: [576, 512, [], "e01f", "M512,0a64,64,0,1,0,64,64A63.99942,63.99942,0,0,0,512,0ZM224,64C100.28711,64,0,164.28516,0,288,0,411.71289,100.28711,512,224,512S448,411.71289,448,288C448,164.28516,347.71289,64,224,64Zm96,272.89062a64.02377,64.02377,0,0,1-6.75781,28.627L272.918,446.166a28.68332,28.68332,0,0,1-20.89258,15.45312q-5.16211.86719-10.41992,1.43359a16.03421,16.03421,0,0,1-17.60742-15.98437C223.99609,423.58984,223.99414,384,224,384a32.00033,32.00033,0,0,1-32-32V320l-54.62695-54.62891A32.00483,32.00483,0,0,0,114.74609,256l-25.02539-.00195c-20.74414,0-34.53125-21.54493-25.96875-40.43946C91.39258,154.55469,152.7793,112,224,112q2.25586,0,4.49805.0625A28.487,28.487,0,0,1,256,140.62109,64.00066,64.00066,0,0,1,245.25,176.125l-49.72852,57.35742a32.00106,32.00106,0,0,0,1.55079,43.58985A37.31367,37.31367,0,0,0,223.45312,288H288a31.99908,31.99908,0,0,1,32,32Z"]
  },
      VA = {
    prefix: "fas",
    iconName: "planet-ringed",
    icon: [512, 512, [], "e020", "M502.91733,9.0683c-23.49085-23.49086-88.309.01368-167.21341,54.81788-75.418-31.2567-165.47314-16.29536-226.79313,45.02464-61.318,61.32-76.28132,151.37515-45.02463,226.79319C9.082,414.60847-14.42256,479.42661,9.0683,502.91747c37.19239,37.19241,177.89534-43.21014,314.2681-179.58293C459.70916,186.9637,540.10973,46.26071,502.91733,9.0683ZM346.505,346.50508c-38.15531,38.15337-84.07059,78.86539-130.69292,113.57336A207.99464,207.99464,0,0,0,460.03924,215.65C423.85078,264.25092,382.07819,310.93186,346.505,346.50508Z"]
  },
      xA = {
    prefix: "fas",
    iconName: "play",
    icon: [448, 512, [], "f04b", "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"]
  },
      wA = {
    prefix: "fas",
    iconName: "play-circle",
    icon: [512, 512, [], "f144", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"]
  },
      yA = {
    prefix: "fas",
    iconName: "plug",
    icon: [384, 512, [], "f1e6", "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"]
  },
      bA = {
    prefix: "fas",
    iconName: "plus",
    icon: [448, 512, [], "f067", "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
  },
      SA = {
    prefix: "fas",
    iconName: "plus-circle",
    icon: [512, 512, [], "f055", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"]
  },
      TA = {
    prefix: "fas",
    iconName: "plus-hexagon",
    icon: [576, 512, [], "f300", "M553.5 231.8c8.7 14.9 8.7 33.4 0 48.4l-112 192c-8.6 14.7-24.4 23.8-41.5 23.8H176c-17.1 0-32.9-9.1-41.5-23.8l-112-192c-8.7-14.9-8.7-33.4 0-48.4l112-192C143.1 25.1 158.9 16 176 16h224c17.1 0 32.9 9.1 41.5 23.8l112 192zM432 228c0-6.6-5.4-12-12-12h-92v-92c0-6.6-5.4-12-12-12h-56c-6.6 0-12 5.4-12 12v92h-92c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h92v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h92c6.6 0 12-5.4 12-12v-56z"]
  },
      DA = {
    prefix: "fas",
    iconName: "plus-octagon",
    icon: [512, 512, [], "f301", "M497.9 150.5c9 9 14.1 21.2 14.1 33.9v143.1c0 12.7-5.1 24.9-14.1 33.9L361.5 497.9c-9 9-21.2 14.1-33.9 14.1H184.5c-12.7 0-24.9-5.1-33.9-14.1L14.1 361.5c-9-9-14.1-21.2-14.1-33.9V184.5c0-12.7 5.1-24.9 14.1-33.9L150.5 14.1c9-9 21.2-14.1 33.9-14.1h143.1c12.7 0 24.9 5.1 33.9 14.1l136.5 136.4zM400 228c0-6.6-5.4-12-12-12h-92v-92c0-6.6-5.4-12-12-12h-56c-6.6 0-12 5.4-12 12v92h-92c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h92v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h92c6.6 0 12-5.4 12-12v-56z"]
  },
      jA = {
    prefix: "fas",
    iconName: "plus-square",
    icon: [448, 512, [], "f0fe", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"]
  },
      EA = {
    prefix: "fas",
    iconName: "podcast",
    icon: [448, 512, [], "f2ce", "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"]
  },
      kA = {
    prefix: "fas",
    iconName: "podium",
    icon: [448, 512, [], "f680", "M432 144H111.36c6.33-30.9 30.72-55.29 62.71-62.05C182.76 90.63 194.75 96 208 96h64c26.51 0 48-21.49 48-48S298.51 0 272 0h-64c-22.06 0-40.45 14.97-46.07 35.24C109.85 46.85 70.16 90.29 63.35 144H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-32 320h-38.22L384 224H64l22.22 240H48c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"]
  },
      IA = {
    prefix: "fas",
    iconName: "podium-star",
    icon: [448, 512, [], "f758", "M432 144H111.4c6.3-30.9 30.7-55.3 62.7-62 8.7 8.7 20.7 14 33.9 14h64c26.5 0 48-21.5 48-48S298.5 0 272 0h-64c-22.1 0-40.4 15-46.1 35.2-52.1 11.6-91.8 55-98.6 108.8H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-32 320h-38.2L384 224H64l22.2 240H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-95.5-137.3l-33 32.2 7.8 45.5c1.4 8.2-7.2 14.3-14.5 10.5L224 393.4l-40.8 21.5c-7.2 3.8-15.9-2.3-14.5-10.5l7.8-45.5-33-32.2c-5.9-5.8-2.7-15.9 5.5-17.1l45.6-6.7 20.4-41.4c3.7-7.5 14.3-7.4 17.9 0l20.4 41.4 45.6 6.7c8.2 1.2 11.5 11.3 5.6 17.1z"]
  },
      OA = {
    prefix: "fas",
    iconName: "police-box",
    icon: [384, 512, [], "e021", "M368,464H352V88a24,24,0,0,0-24-24h-8.02148V48a16,16,0,0,0-16-16H208V16a16,16,0,0,0-32,0V32H80A16,16,0,0,0,64,48V64H56A24,24,0,0,0,32,88V464H16A16,16,0,0,0,0,480v16a16,16,0,0,0,16,16H368a16,16,0,0,0,16-16V480A16,16,0,0,0,368,464ZM168,128a8.00039,8.00039,0,0,1,8,8v24H144V128Zm-64,0h24v32H96V136A8.00039,8.00039,0,0,1,104,128Zm0,80a8.00039,8.00039,0,0,1-8-8V176h32v32Zm72,104a8.00039,8.00039,0,0,1-8,8H104a8.00039,8.00039,0,0,1-8-8V248a8.00039,8.00039,0,0,1,8-8h64a8.00039,8.00039,0,0,1,8,8Zm-8-104H144V176h32v24A8.00039,8.00039,0,0,1,168,208Zm112-80a8.00039,8.00039,0,0,1,8,8v24H256V128Zm-64,0h24v32H208V136A8.00039,8.00039,0,0,1,216,128Zm-8,72V176h32v32H216A8.00039,8.00039,0,0,1,208,200Zm72,8H256V176h32v24A8.00039,8.00039,0,0,1,280,208Z"]
  },
      QA = {
    prefix: "fas",
    iconName: "poll",
    icon: [448, 512, [], "f681", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"]
  },
      ZA = {
    prefix: "fas",
    iconName: "poll-h",
    icon: [448, 512, [], "f682", "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"]
  },
      UA = {
    prefix: "fas",
    iconName: "poll-people",
    icon: [640, 512, [], "f759", "M80 96c26.5 0 48-21.5 48-48S106.5 0 80 0 32 21.5 32 48s21.5 48 48 48zm48 240c0-26.5-21.5-48-48-48s-48 21.5-48 48 21.5 48 48 48 48-21.5 48-48zm-32 80H64c-35.3 0-64 28.7-64 64v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-35.3-28.7-64-64-64zM616 32H248c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24h368c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24zm-40 96h-64V96h64v32zm-480 0H64c-35.3 0-64 28.7-64 64v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-35.3-28.7-64-64-64zm520 192H248c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24h368c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24zm-40 96H352v-32h224v32z"]
  },
      BA = {
    prefix: "fas",
    iconName: "poo",
    icon: [512, 512, [], "f2fe", "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      RA = {
    prefix: "fas",
    iconName: "poo-storm",
    icon: [448, 512, [], "f75a", "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"]
  },
      YA = {
    prefix: "fas",
    iconName: "poop",
    icon: [512, 512, [], "f619", "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"]
  },
      PA = {
    prefix: "fas",
    iconName: "popcorn",
    icon: [512, 512, [], "f819", "M443.62 138.88a42.72 42.72 0 0 0-33.09-20.79 37.89 37.89 0 0 0-.33-37.43c-9.11-16-28-23.69-45.55-20.17-.33-16.64-11.47-32-29-37.43a43.36 43.36 0 0 0-39.14 6.4 4.25 4.25 0 0 0-.68-1.92C288.73 6.42 264.77-4.78 242.5 2a41.66 41.66 0 0 0-27.32 27.19 43.4 43.4 0 0 0-38.82-6.08c-17.54 5.44-28.66 20.79-29 37.43-17.56-3.54-36.46 4.12-45.57 20.12a37.18 37.18 0 0 0-.33 37.43c-13.46 1.28-26.32 8.64-33.06 20.79-3.92 6.74-4.77 14-4.27 21.12h383.73c.52-7.12-.33-14.37-4.24-21.12zM366.4 192l-28 256h-45.01L315 192H197.05l21.56 256h-45.05l-28-256H64l43.91 292.75A32 32 0 0 0 139.56 512h232.88a32 32 0 0 0 31.65-27.25L448 192z"]
  },
      FA = {
    prefix: "fas",
    iconName: "portal-enter",
    icon: [512, 512, [], "e022", "M432,0c-40.78711,0-74.373,97.74414-79.30859,223.98438H339.96875l-26.0625-53.25c-12.5-25.54688-35.45313-44.21876-61.78125-50.9375L181.04688,98.65625a95.62917,95.62917,0,0,0-80.84376,17.14063L60.54688,146.20312a31.99557,31.99557,0,1,0,38.9375,50.78126l39.6875-30.40626c7.67187-5.89062,17.4375-8,25.26562-6.14062l14.70312,4.375L141.6875,252.20312a64.16816,64.16816,0,0,0,26.29688,80.3125l84.96874,50.17188-27.46874,87.71875a32.00118,32.00118,0,1,0,61.07811,19.125l31.64063-101.0625a48.20913,48.20913,0,0,0-21.64063-54.39063l-61.25-36.14062L266.625,219.65625l20.28125,41.4375a48.27457,48.27457,0,0,0,43.10937,26.89063h22.67383C357.61719,414.23828,391.209,512,432,512c44.18359,0,80-114.61523,80-256S476.18359,0,432,0ZM272,96a48,48,0,1,0-48-48A47.99238,47.99238,0,0,0,272,96ZM113.6875,317.46875,98.89062,351.98438H32a32,32,0,0,0,0,64h77.45312a47.90248,47.90248,0,0,0,44.10938-29.07813l8.78125-20.53125-10.65625-6.29688A95.295,95.295,0,0,1,113.6875,317.46875Z"]
  },
      WA = {
    prefix: "fas",
    iconName: "portal-exit",
    icon: [512, 512, [], "e023", "M480,223.98438H435.96875l-26.0625-53.25c-12.5-25.54688-35.45313-44.21876-61.78125-50.9375L277.04688,98.65625a95.62917,95.62917,0,0,0-80.84376,17.14063l-39.65624,30.40624c-1.56055,1.19532-2.44336,2.85352-3.72071,4.25977C140.25586,61.78906,112.41016,0,80,0,35.81641,0,0,114.61523,0,256S35.81641,512,80,512c25.25391,0,47.73828-37.5332,62.40039-96.01562h63.05273a47.90248,47.90248,0,0,0,44.10938-29.07813l8.78125-20.53125-10.65625-6.29688a95.295,95.295,0,0,1-38-42.60937l-14.79688,34.51563H154.13281A768.691,768.691,0,0,0,160,256c0-20.22266-.80859-39.80273-2.19336-58.67383,11.14258,7.87305,26.27734,8.39258,37.67774-.34179l39.6875-30.40626c7.67187-5.89062,17.4375-8,25.26562-6.14062l14.70312,4.375L237.6875,252.20312a64.16816,64.16816,0,0,0,26.29688,80.3125l84.96874,50.17188-27.46874,87.71875a32.00118,32.00118,0,1,0,61.07812,19.125l31.64062-101.0625a48.20913,48.20913,0,0,0-21.64062-54.39063l-61.25-36.14062,31.3125-78.28125,20.28125,41.4375a48.27458,48.27458,0,0,0,43.10937,26.89063H480a32,32,0,0,0,0-64ZM368,96a48,48,0,1,0-48-48A47.99238,47.99238,0,0,0,368,96Z"]
  },
      GA = {
    prefix: "fas",
    iconName: "portrait",
    icon: [384, 512, [], "f3e0", "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"]
  },
      qA = {
    prefix: "fas",
    iconName: "pound-sign",
    icon: [320, 512, [], "f154", "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"]
  },
      JA = {
    prefix: "fas",
    iconName: "power-off",
    icon: [512, 512, [], "f011", "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"]
  },
      KA = {
    prefix: "fas",
    iconName: "pray",
    icon: [384, 512, [], "f683", "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"]
  },
      XA = {
    prefix: "fas",
    iconName: "praying-hands",
    icon: [640, 512, [], "f684", "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"]
  },
      _A = {
    prefix: "fas",
    iconName: "prescription",
    icon: [384, 512, [], "f5b1", "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"]
  },
      $A = {
    prefix: "fas",
    iconName: "prescription-bottle",
    icon: [384, 512, [], "f485", "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"]
  },
      cN = {
    prefix: "fas",
    iconName: "prescription-bottle-alt",
    icon: [384, 512, [], "f486", "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"]
  },
      eN = {
    prefix: "fas",
    iconName: "presentation",
    icon: [576, 512, [], "f685", "M560 0H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h16v256c0 17.67 14.33 32 32 32h192v34.75l-75.31 75.31c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L288 445.25l62.06 62.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L320 386.75V352h192c17.67 0 32-14.33 32-32V64h16c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16zm-80 288H96V64h384v224z"]
  },
      aN = {
    prefix: "fas",
    iconName: "print",
    icon: [512, 512, [], "f02f", "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
  },
      nN = {
    prefix: "fas",
    iconName: "print-search",
    icon: [640, 512, [], "f81a", "M128 448v-96h163.23a160.64 160.64 0 0 1-3.23-32c0-36.16 12.51-69.18 32.81-96H128V64h192v48a16 16 0 0 0 16 16h48v45.56A158.69 158.69 0 0 1 448 160V77.25a32 32 0 0 0-9.37-22.63L393.37 9.37A32 32 0 0 0 370.74 0H96a32 32 0 0 0-32 32v160a64 64 0 0 0-64 64v112a16 16 0 0 0 16 16h48v96a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32c-35.7 0-68.37-12.16-95-32zm507.31 14.06l-77.41-77.41c11.22-19 18.1-40.95 18.1-64.65a128 128 0 1 0-128 128c23.7 0 45.61-6.88 64.65-18.11l77.41 77.42a16 16 0 0 0 22.63 0l22.62-22.62a16 16 0 0 0 0-22.63zM448 384a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"]
  },
      tN = {
    prefix: "fas",
    iconName: "print-slash",
    icon: [640, 512, [], "f686", "M192 448v-96h95.22L93.47 202.25C75.78 213.64 64 233.4 64 256v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c4 0 7.76-.93 11.29-2.28L411.43 448H192zm441.82 10.1L537.95 384H560c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64V77.25c0-8.49-3.37-16.62-9.37-22.63L457.37 9.37c-6-6-14.14-9.37-22.63-9.37H160c-17.67 0-32 14.33-32 32v35.16L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM448 224H330.93L192 116.62V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
  },
      rN = {
    prefix: "fas",
    iconName: "procedures",
    icon: [640, 512, [], "f487", "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"]
  },
      iN = {
    prefix: "fas",
    iconName: "project-diagram",
    icon: [640, 512, [], "f542", "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"]
  },
      oN = {
    prefix: "fas",
    iconName: "projector",
    icon: [640, 512, [], "f8d6", "M592 192h-94.08A144.14 144.14 0 0 1 576 320c0 61.91-39.28 114.82-94.22 135.13L493 499.88A16 16 0 0 0 508.49 512h39A16 16 0 0 0 563 499.88L576 448h16a48 48 0 0 0 48-48V240a48 48 0 0 0-48-48zM288 320a144.14 144.14 0 0 1 78.08-128H48a48 48 0 0 0-48 48v160a48 48 0 0 0 48 48h16l13 51.88A16 16 0 0 0 92.49 512h39A16 16 0 0 0 147 499.88L160 448h206.08A144.14 144.14 0 0 1 288 320zM96 352a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm96 0a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm352-32a112 112 0 1 0-112 112 112.16 112.16 0 0 0 112-112zm-120-40a32 32 0 0 0-32 32 16 16 0 0 1-32 0 64.07 64.07 0 0 1 64-64 16 16 0 0 1 0 32zm0-152h16a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16zm93.65 5.65a16 16 0 0 0 22.63 0l67.88-67.88a16 16 0 0 0 0-22.63l-11.31-11.31a16 16 0 0 0-22.63 0l-67.88 67.89a16 16 0 0 0 0 22.62zm-193.93 0a16 16 0 0 0 22.63 0l11.31-11.31a16 16 0 0 0 0-22.62l-67.88-67.89a16 16 0 0 0-22.63 0l-11.31 11.31a16 16 0 0 0 0 22.63z"]
  },
      lN = {
    prefix: "fas",
    iconName: "pump-medical",
    icon: [384, 512, [], "e06a", "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"]
  },
      fN = {
    prefix: "fas",
    iconName: "pump-soap",
    icon: [384, 512, [], "e06b", "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"]
  },
      sN = {
    prefix: "fas",
    iconName: "pumpkin",
    icon: [576, 512, [], "f707", "M352 113.21v-77.4c0-6.06-3.42-11.6-8.84-14.31l-39.6-19.8c-8.37-4.19-18.54-.32-22.01 8.37L244 103.93C257.27 99.2 271.57 96 288 96c25.16 0 46.23 6.12 64 17.21zm143.3 39.92c-31.61-27.03-78.8-31.69-116.51-15.05 3.07 3.97 6.52 7.38 9.21 11.92 8.32 14.27 14.5 31.78 19.11 51.62-3.69-8.81-7.96-16.87-12.86-24.12-22.67-33-58.08-49.5-106.25-49.5s-83.58 16.5-106.25 49.5c-4.9 7.25-9.17 15.3-12.86 24.11 4.61-19.84 10.78-37.34 19.11-51.61 2.69-4.54 6.13-7.95 9.21-11.92-37.71-16.64-84.9-11.98-116.51 15.05-107.6 92.01-107.6 241.72 0 333.74 38.63 33.03 100.82 33.34 140.12 1.25C238.65 503.51 260.72 512 288 512s49.35-8.49 67.19-23.88c39.3 32.09 101.49 31.78 140.12-1.25 107.59-92.01 107.59-241.73-.01-333.74z"]
  },
      uN = {
    prefix: "fas",
    iconName: "puzzle-piece",
    icon: [576, 512, [], "f12e", "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"]
  },
      hN = {
    prefix: "fas",
    iconName: "qrcode",
    icon: [448, 512, [], "f029", "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"]
  },
      mN = {
    prefix: "fas",
    iconName: "question",
    icon: [384, 512, [], "f128", "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"]
  },
      vN = {
    prefix: "fas",
    iconName: "question-circle",
    icon: [512, 512, [], "f059", "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"]
  },
      dN = {
    prefix: "fas",
    iconName: "question-square",
    icon: [448, 512, [], "f2fd", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 430c-25.365 0-46-20.636-46-46 0-25.365 20.635-46 46-46s46 20.635 46 46c0 25.364-20.635 46-46 46zm40-131.333V300c0 6.627-5.373 12-12 12h-56c-6.627 0-12-5.373-12-12v-4c0-41.059 31.128-57.472 54.652-70.66 20.171-11.309 32.534-19 32.534-33.976 0-19.81-25.269-32.958-45.698-32.958-27.19 0-39.438 13.139-57.303 35.797-4.045 5.13-11.46 6.069-16.665 2.122l-34.699-26.31c-5.068-3.843-6.251-10.972-2.715-16.258C141.4 112.957 176.158 90 230.655 90c56.366 0 116.531 43.998 116.531 102 0 77.02-83.186 78.205-83.186 106.667z"]
  },
      MN = {
    prefix: "fas",
    iconName: "quidditch",
    icon: [640, 512, [], "f458", "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"]
  },
      pN = {
    prefix: "fas",
    iconName: "quote-left",
    icon: [512, 512, [], "f10d", "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"]
  },
      zN = {
    prefix: "fas",
    iconName: "quote-right",
    icon: [512, 512, [], "f10e", "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"]
  },
      CN = {
    prefix: "fas",
    iconName: "quran",
    icon: [448, 512, [], "f687", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"]
  },
      LN = {
    prefix: "fas",
    iconName: "rabbit",
    icon: [448, 512, [], "f708", "M445.54 487.52L352 337.85V272h7.35c31.29 0 56.65-25.36 56.65-56.65a56.66 56.66 0 0 0-23.72-46.1l-48.65-34.75c-1.1-.54-2.27-.74-3.38-1.21 7.8-12.49 15.21-29.76 20.54-49.66 11.32-42.24 9.08-79.55-5-83.32-14.08-3.77-34.67 27.41-45.99 69.66-2.72 10.15-4.61 19.97-5.79 29.15-1.18-9.18-3.07-19-5.79-29.15-11.33-42.25-31.92-73.43-46-69.66s-16.32 41.08-5 83.32c6.94 25.9 17.37 47.54 27.64 59.62-9.11 7.93-15.9 18.5-18.03 31.55-.54 3.32-.82 6.72-.82 10.19V256h-12.8c-83.19 0-152.93 56.77-173.12 133.61C63.44 386.15 56.01 384 48 384c-26.51 0-48 21.49-48 48s21.49 48 48 48c7.93 0 15.3-2.11 21.89-5.51C79.98 496.58 102.13 512 128 512h144c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-22.59l74.35-60.18 72.91 116.66a15.99 15.99 0 0 0 13.57 7.52h37.74c12.56 0 20.22-13.82 13.56-24.48zM336 208c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      AN = {
    prefix: "fas",
    iconName: "rabbit-fast",
    icon: [576, 512, [], "f709", "M135.52 412.67a15.99 15.99 0 0 0-7.52 13.57v37.74c0 12.57 13.82 20.23 24.48 13.57l66.69-39.87-47.85-47.85-35.8 22.84zm416.76-195.42l-56.42-34.62c-.06-13.95-2.28-30.77-7.07-48.67-11.32-42.24-31.91-73.43-45.99-69.66-14.08 3.77-16.32 41.08-5 83.32.65 2.44 1.44 4.7 2.15 7.06-4.89-6.08-10.23-12.23-16.31-18.32-30.93-30.92-64.35-47.64-74.66-37.33s6.4 43.73 37.33 74.66c12.67 12.67 25.67 22.77 37.42 29.78-3.14 5.76-5.71 12.06-6.89 19.32-.49 3.03-.71 6.15-.75 9.31C364.55 195.11 261.59 128 192 128c-52.08 0-85.21 28.24-104.72 54.09-1.77-2.7-2.96-5.66-5.33-8.03-18.75-18.75-49.14-18.75-67.88 0-18.74 18.74-18.74 49.14 0 67.88 16.4 16.39 41.29 17.57 59.92 5.29l191.4 191.4c6 6 14.14 9.37 22.63 9.37h144c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-96v-55.59c0-35.53-23.86-67.16-58.02-76.91l-42.38-12.11c-8.5-2.44-13.42-11.3-11-19.78 2.44-8.52 11.41-13.33 19.78-11l42.38 12.11C318.59 234.38 352 278.66 352 328.41V352l64-32h103.35c31.29 0 56.65-25.36 56.65-56.65a56.66 56.66 0 0 0-23.72-46.1zM496 256c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      NN = {
    prefix: "fas",
    iconName: "racquet",
    icon: [640, 512, [], "f45a", "M125.9 346.5l56.7 80-120.7 82.6c-7.2 5-17.2 3.3-22.2-3.9L2.9 453.4c-5.1-7.2-3.4-17.1 3.7-22.3.1.1 119.3-84.6 119.3-84.6zm402.8-16.7c-49.1 34.8-103.9 52-153.5 52-27.6 0-84.5-15.1-171.9 18.6l-45.7-64.5c32.7-38.2 56.7-83.2 67.7-132.7 12.2-54.7 49.5-110.5 106.8-151.1 100.5-71.2 228.2-70.2 283.4 7.7 54.3 76.7 15.4 197.6-86.8 270zm-271.2 5.9c-11.7-12.3-12-11.7-21.2-29.7-7.9 14.1-16.3 27.9-26.2 41 15.7-4.9 31.5-8.5 47.4-11.3zM485.9 64c-106.4 0-178.6 90-195 141.1-21.3 66.2 13.3 112.8 83.9 112.8 84.1 0 171.1-66.8 195-141.1C591.1 110.7 556.5 64 485.9 64z"]
  },
      gN = {
    prefix: "fas",
    iconName: "radar",
    icon: [512, 512, [], "e024", "M504,256c0,136.9668-111.0332,248-248,248S8,392.9668,8,256,119.0332,8,256,8A246.36335,246.36335,0,0,1,395.14648,50.916L425.377,20.68555a16.00006,16.00006,0,0,1,22.627,0l11.31054,11.31054a16.00006,16.00006,0,0,1,0,22.627l-201.373,201.373L257.93555,256H320a64.00026,64.00026,0,1,1-66.15625-63.78125L281.97852,164.084A92.08681,92.08681,0,0,0,256,160a96,96,0,1,0,96,96h64c0,79.53906-58.498,145.17578-134.63281,157.43555C275.54492,405.49414,266.60156,400,256,400s-19.54492,5.49414-25.36719,13.43555A159.59519,159.59519,0,0,1,98.56445,281.36719C106.50586,275.54492,112,266.60156,112,256s-5.49414-19.54492-13.43555-25.36719C110.82422,154.49805,176.46094,96,256,96c27.11328,0,52.21484,7.48438,74.53125,19.53125L354.51953,91.543A190.21144,190.21144,0,0,0,256,64C159.74023,64,80.26172,134.91211,66.375,227.30078a31.59809,31.59809,0,0,0,0,57.39649A191.79963,191.79963,0,0,0,227.30273,445.625a31.59657,31.59657,0,0,0,57.39454,0C377.08594,431.74023,448,352.25977,448,256Z"]
  },
      HN = {
    prefix: "fas",
    iconName: "radiation",
    icon: [496, 512, [], "f7b9", "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"]
  },
      VN = {
    prefix: "fas",
    iconName: "radiation-alt",
    icon: [496, 512, [], "f7ba", "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"]
  },
      xN = {
    prefix: "fas",
    iconName: "radio",
    icon: [512, 512, [], "f8d7", "M447 127H210.5l288.83-81.21a16 16 0 0 0 11.07-19.74l-4.33-15.38A16 16 0 0 0 486.33-.4L63 127a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V191a64 64 0 0 0-64-64zM207 247v16a8 8 0 0 1-8 8H87a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h112a8 8 0 0 1 8 8zm0 144a8 8 0 0 1-8 8H87a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h112a8 8 0 0 1 8 8zm16-64a8 8 0 0 1-8 8H71a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h144a8 8 0 0 1 8 8zm144 72a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"]
  },
      wN = {
    prefix: "fas",
    iconName: "radio-alt",
    icon: [512, 512, [], "f8d8", "M448 128H211.5l288.83-81.21a16 16 0 0 0 11.07-19.74l-4.33-15.38A16 16 0 0 0 487.33.6L64 128a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zM224 424a8 8 0 0 1-8 8H104a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h112a8 8 0 0 1 8 8zm32-64a8 8 0 0 1-8 8H72a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h176a8 8 0 0 1 8 8zm128 88a64 64 0 1 1 64-64 64 64 0 0 1-64 64zm64-192H64v-64h384z"]
  },
      yN = {
    prefix: "fas",
    iconName: "rainbow",
    icon: [576, 512, [], "f75b", "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"]
  },
      bN = {
    prefix: "fas",
    iconName: "raindrops",
    icon: [448, 512, [], "f75c", "M216 136.3c0-34.9-31.8-47.9-46.7-97.4-2.5-9-15.7-9.4-18.6 0-14.9 49.3-46.7 62.7-46.7 97.4 0 30.8 25 55.7 56 55.7s56-24.9 56-55.7zM46.7 230.9C31.8 280.2 0 293.6 0 328.3 0 359.1 25 384 56 384s56-24.9 56-55.7c0-34.9-31.8-47.9-46.7-97.4-2.5-9-15.7-9.4-18.6 0zm294.5-87.7c-5.8-19.8-36-20.7-42.5 0C264.7 251.6 192 281.1 192 357.6c0 67.7 57.2 122.4 128 122.4s128-54.8 128-122.4c0-76.9-72.6-105.5-106.8-214.4z"]
  },
      SN = {
    prefix: "fas",
    iconName: "ram",
    icon: [640, 512, [], "f70a", "M622.25 105.96L576 83.22V64c0-17.67-14.33-32-32-32h-72.97C453.45 12.5 428.26 0 400 0c-52.94 0-96 43.06-96 96 0 47.46 34.7 86.72 80.02 94.38-5.23.88-10.53 1.62-16.02 1.62-51.54 0-93.26-40.71-95.56-91.68-5.9-2.63-12.29-4.32-19.33-4.32-12.47 0-24 4.8-32.31 12.8-8.64-8-20.16-12.8-32.64-12.8-13.12 0-24.97 5.44-33.61 13.75-11.19-9.28-26.23-13.75-41.59-10.23-17.59 3.84-31.03 16.95-35.84 33.28-16.64-2.88-34.23 3.2-45.44 17.28-11.52 14.08-13.44 32.64-7.03 48.31-14.72 8-24.64 24-24.64 41.92 0 18.23 10.23 33.92 24.95 41.92-6.41 15.69-4.16 34.23 7.05 48.31 11.52 14.09 29.11 20.17 45.75 16.97 4.08 13.88 14.64 25.07 28.47 30.58l-6.14 16.38a63.973 63.973 0 0 0-2.16 38l16.85 67.41A16.002 16.002 0 0 0 130.3 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-18.31-73.26 14.76-39.36c4.73-2.15 9.22-4.78 12.9-8.31 8.64 8 20.17 12.81 32.64 12.81 12.48 0 24-4.81 32.64-12.81 8.64 8 19.84 12.81 32.64 12.81 12.49 0 23.87-4.96 32.46-12.91.16.15.34.27.51.42V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V330.67L483.5 307a64.009 64.009 0 0 0 28.5-53.25V192h87.66c9.26 0 17.76-4.9 22.37-12.94 7.59-13.26 17.98-33.45 17.98-44.59a31.798 31.798 0 0 0-17.76-28.51zM352 96c0-26.47 21.53-48 48-48s48 21.53 48 48-21.53 48-48 48-48-21.53-48-48zm160 16c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      TN = {
    prefix: "fas",
    iconName: "ramp-loading",
    icon: [384, 512, [], "f4d4", "M292.4 328.8c-2.7-5.4-8.2-8.8-14.3-8.8H105.9c-6.1 0-11.6 3.4-14.3 8.8l-80 160C6.3 499.5 14 512 25.9 512h332.2c11.9 0 19.6-12.5 14.3-23.2l-80-160zM352 0H32C14.3 0 0 14.3 0 32v320c0 16.5 12.6 29.5 28.6 31.3L63 314.5c.3-.6.7-1 1-1.5V64h256v249c.3.5.8 1 1 1.5l34.4 68.8c16-1.8 28.6-14.9 28.6-31.3V32c0-17.7-14.3-32-32-32z"]
  },
      DN = {
    prefix: "fas",
    iconName: "random",
    icon: [512, 512, [], "f074", "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"]
  },
      jN = {
    prefix: "fas",
    iconName: "raygun",
    icon: [576, 512, [], "e025", "M554.9375,119.01044,480.002,143.98307H416.043V79.991a15.99661,15.99661,0,0,0-16-15.998H384.041a15.99828,15.99828,0,0,0-16.002,15.998V271.96731a15.99953,15.99953,0,0,0,16.002,15.998h16.002a15.99787,15.99787,0,0,0,16-15.998V207.97519h64.07617l74.8125,24.97068A16.00321,16.00321,0,0,0,576,217.76815v-83.58A16.00191,16.00191,0,0,0,554.9375,119.01044ZM320.0332,31.99687h-16.002a15.99787,15.99787,0,0,0-16,15.998V75.21557a110.96789,110.96789,0,0,0-48.06641-11.22264H192L87.166,1.70979A16.00223,16.00223,0,0,0,64.00586,16.01837v59.164C26.26758,93.196,0,131.38348,0,175.97913,0,231.25837,40.14844,276.9009,92.82812,286.03175L22.4082,407.95153A47.93786,47.93786,0,0,0,40.00391,473.5374L95.416,505.53346a47.96127,47.96127,0,0,0,65.60156-17.59178L281.10547,279.93019c2.38281-.94531,4.623-2.08789,6.92578-3.1875v27.22068a15.99912,15.99912,0,0,0,16,15.998h16.002a15.96,15.96,0,0,0,15.94141-15.69725v-256.57A15.95874,15.95874,0,0,0,320.0332,31.99687Zm-208.082,167.98028a23.998,23.998,0,1,1,24.002-23.998A24.00117,24.00117,0,0,1,111.95117,199.97715Zm96.00977,0a23.998,23.998,0,1,1,24.00195-23.998A24.00118,24.00118,0,0,1,207.96094,199.97715Z"]
  },
      EN = {
    prefix: "fas",
    iconName: "receipt",
    icon: [384, 512, [], "f543", "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"]
  },
      kN = {
    prefix: "fas",
    iconName: "record-vinyl",
    icon: [512, 512, [], "f8d9", "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"]
  },
      IN = {
    prefix: "fas",
    iconName: "rectangle-landscape",
    icon: [512, 512, [], "f2fa", "M464 448H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48z"]
  },
      ON = {
    prefix: "fas",
    iconName: "rectangle-portrait",
    icon: [384, 512, [], "f2fb", "M0 464V48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"]
  },
      QN = {
    prefix: "fas",
    iconName: "rectangle-wide",
    icon: [640, 512, [], "f2fc", "M592 416H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h544c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48z"]
  },
      ZN = {
    prefix: "fas",
    iconName: "recycle",
    icon: [512, 512, [], "f1b8", "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"]
  },
      UN = {
    prefix: "fas",
    iconName: "redo",
    icon: [512, 512, [], "f01e", "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"]
  },
      BN = {
    prefix: "fas",
    iconName: "redo-alt",
    icon: [512, 512, [], "f2f9", "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"]
  },
      RN = {
    prefix: "fas",
    iconName: "refrigerator",
    icon: [384, 512, [], "e026", "M0,160V48A48,48,0,0,1,48,0H336a48,48,0,0,1,48,48V160H320V72a8,8,0,0,0-8-8H296a8,8,0,0,0-8,8v88Zm320,32V376a8,8,0,0,1-8,8H296a8,8,0,0,1-8-8V192H0V464a48,48,0,0,0,48,48H336a48,48,0,0,0,48-48V192Z"]
  },
      YN = {
    prefix: "fas",
    iconName: "registered",
    icon: [512, 512, [], "f25d", "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"]
  },
      PN = {
    prefix: "fas",
    iconName: "remove-format",
    icon: [640, 512, [], "f87d", "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"]
  },
      FN = {
    prefix: "fas",
    iconName: "repeat",
    icon: [512, 512, [], "f363", "M512 256c0 88.224-71.775 160-160 160H170.067l34.512 32.419c9.875 9.276 10.119 24.883.539 34.464l-10.775 10.775c-9.373 9.372-24.568 9.372-33.941 0l-92.686-92.686c-9.373-9.373-9.373-24.568 0-33.941l92.686-92.686c9.373-9.373 24.568-9.373 33.941 0l10.775 10.775c9.581 9.581 9.337 25.187-.539 34.464L170.067 352H352c52.935 0 96-43.065 96-96 0-13.958-2.996-27.228-8.376-39.204-4.061-9.039-2.284-19.626 4.723-26.633l12.183-12.183c11.499-11.499 30.965-8.526 38.312 5.982C505.814 205.624 512 230.103 512 256zM72.376 295.204C66.996 283.228 64 269.958 64 256c0-52.935 43.065-96 96-96h181.933l-34.512 32.419c-9.875 9.276-10.119 24.883-.539 34.464l10.775 10.775c9.373 9.372 24.568 9.372 33.941 0l92.686-92.686c9.373-9.373 9.373-24.568 0-33.941l-92.686-92.686c-9.373-9.373-24.568-9.373-33.941 0L306.882 29.12c-9.581 9.581-9.337 25.187.539 34.464L341.933 96H160C71.775 96 0 167.776 0 256c0 25.897 6.186 50.376 17.157 72.039 7.347 14.508 26.813 17.481 38.312 5.982l12.183-12.183c7.008-7.008 8.786-17.595 4.724-26.634z"]
  },
      WN = {
    prefix: "fas",
    iconName: "repeat-1",
    icon: [512, 512, [], "f365", "M512 256c0 88.224-71.775 160-160 160H170.067l34.512 32.419c9.875 9.276 10.119 24.883.539 34.464l-10.775 10.775c-9.373 9.372-24.568 9.372-33.941 0l-92.686-92.686c-9.373-9.373-9.373-24.568 0-33.941l80.269-80.27c9.373-9.373 24.568-9.373 33.941 0l10.775 10.775c9.581 9.581 9.337 25.187-.539 34.464l-22.095 20H352c52.935 0 96-43.065 96-96 0-13.958-2.996-27.228-8.376-39.204-4.061-9.039-2.284-19.626 4.723-26.633l12.183-12.183c11.499-11.499 30.965-8.526 38.312 5.982C505.814 205.624 512 230.103 512 256zM72.376 295.204C66.996 283.228 64 269.958 64 256c0-52.935 43.065-96 96-96h181.933l-22.095 20.002c-9.875 9.276-10.119 24.883-.539 34.464l10.775 10.775c9.373 9.372 24.568 9.372 33.941 0l80.269-80.27c9.373-9.373 9.373-24.568 0-33.941l-92.686-92.686c-9.373-9.373-24.568-9.373-33.941 0l-10.775 10.775c-9.581 9.581-9.337 25.187.539 34.464L341.933 96H160C71.775 96 0 167.776 0 256c0 25.897 6.186 50.376 17.157 72.039 7.347 14.508 26.813 17.481 38.312 5.982l12.183-12.183c7.008-7.008 8.786-17.595 4.724-26.634zm154.887 4.323c0-7.477 3.917-11.572 11.573-11.572h15.131v-39.878c0-5.163.534-10.503.534-10.503h-.356s-1.779 2.67-2.848 3.738c-4.451 4.273-10.504 4.451-15.666-1.068l-5.518-6.231c-5.342-5.341-4.984-11.216.534-16.379l21.72-19.939c4.449-4.095 8.366-5.697 14.42-5.697h12.105c7.656 0 11.749 3.916 11.749 11.572v84.384h15.488c7.655 0 11.572 4.094 11.572 11.572v8.901c0 7.477-3.917 11.572-11.572 11.572h-67.293c-7.656 0-11.573-4.095-11.573-11.572v-8.9z"]
  },
      GN = {
    prefix: "fas",
    iconName: "repeat-1-alt",
    icon: [512, 512, [], "f366", "M493.544 181.463c11.956 22.605 18.655 48.4 18.452 75.75C511.339 345.365 438.56 416 350.404 416H192v47.495c0 22.475-26.177 32.268-40.971 17.475l-80-80c-9.372-9.373-9.372-24.569 0-33.941l80-80C166.138 271.92 192 282.686 192 304v48h158.875c52.812 0 96.575-42.182 97.12-94.992.155-15.045-3.17-29.312-9.218-42.046-4.362-9.185-2.421-20.124 4.8-27.284 4.745-4.706 8.641-8.555 11.876-11.786 11.368-11.352 30.579-8.631 38.091 5.571zM64.005 254.992c.545-52.81 44.308-94.992 97.12-94.992H320v47.505c0 22.374 26.121 32.312 40.971 17.465l80-80c9.372-9.373 9.372-24.569 0-33.941l-80-80C346.014 16.077 320 26.256 320 48.545V96H161.596C73.44 96 .661 166.635.005 254.788c-.204 27.35 6.495 53.145 18.452 75.75 7.512 14.202 26.723 16.923 38.091 5.57 3.235-3.231 7.13-7.08 11.876-11.786 7.22-7.16 9.162-18.098 4.8-27.284-6.049-12.735-9.374-27.001-9.219-42.046zm163.258 44.535c0-7.477 3.917-11.572 11.573-11.572h15.131v-39.878c0-5.163.534-10.503.534-10.503h-.356s-1.779 2.67-2.848 3.738c-4.451 4.273-10.504 4.451-15.666-1.068l-5.518-6.231c-5.342-5.341-4.984-11.216.534-16.379l21.72-19.939c4.449-4.095 8.366-5.697 14.42-5.697h12.105c7.656 0 11.749 3.916 11.749 11.572v84.384h15.488c7.655 0 11.572 4.094 11.572 11.572v8.901c0 7.477-3.917 11.572-11.572 11.572h-67.293c-7.656 0-11.573-4.095-11.573-11.572v-8.9z"]
  },
      qN = {
    prefix: "fas",
    iconName: "repeat-alt",
    icon: [512, 512, [], "f364", "M493.544 181.463c11.956 22.605 18.655 48.4 18.452 75.75C511.339 345.365 438.56 416 350.404 416H192v47.495c0 22.475-26.177 32.268-40.971 17.475l-80-80c-9.372-9.373-9.372-24.569 0-33.941l80-80C166.138 271.92 192 282.686 192 304v48h158.875c52.812 0 96.575-42.182 97.12-94.992.155-15.045-3.17-29.312-9.218-42.046-4.362-9.185-2.421-20.124 4.8-27.284 4.745-4.706 8.641-8.555 11.876-11.786 11.368-11.352 30.579-8.631 38.091 5.571zM64.005 254.992c.545-52.81 44.308-94.992 97.12-94.992H320v47.505c0 22.374 26.121 32.312 40.971 17.465l80-80c9.372-9.373 9.372-24.569 0-33.941l-80-80C346.014 16.077 320 26.256 320 48.545V96H161.596C73.44 96 .661 166.635.005 254.788c-.204 27.35 6.495 53.145 18.452 75.75 7.512 14.202 26.723 16.923 38.091 5.57 3.235-3.231 7.13-7.08 11.876-11.786 7.22-7.16 9.162-18.098 4.8-27.284-6.049-12.735-9.374-27.001-9.219-42.046z"]
  },
      JN = {
    prefix: "fas",
    iconName: "reply",
    icon: [512, 512, [], "f3e5", "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"]
  },
      KN = {
    prefix: "fas",
    iconName: "reply-all",
    icon: [576, 512, [], "f122", "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"]
  },
      XN = {
    prefix: "fas",
    iconName: "republican",
    icon: [640, 512, [], "f75e", "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"]
  },
      _N = {
    prefix: "fas",
    iconName: "restroom",
    icon: [640, 512, [], "f7bd", "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"]
  },
      $N = {
    prefix: "fas",
    iconName: "retweet",
    icon: [640, 512, [], "f079", "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"]
  },
      cg = {
    prefix: "fas",
    iconName: "retweet-alt",
    icon: [640, 512, [], "f361", "M392.402 383.598C404.359 395.555 395.891 416 378.981 416H120c-13.255 0-24-10.745-24-24V192H48c-21.361 0-32.045-25.895-16.971-40.971l80-80c9.373-9.372 24.568-9.372 33.941 0l80 80C240.074 166.134 229.319 192 208 192h-48v160h202.056c7.82 0 14.874 4.783 17.675 12.084a55.865 55.865 0 0 0 12.671 19.514zM592 320h-48V120c0-13.255-10.745-24-24-24H261.019c-16.91 0-25.378 20.445-13.421 32.402a55.865 55.865 0 0 1 12.671 19.514c2.801 7.302 9.855 12.084 17.675 12.084H480v160h-48c-21.313 0-32.08 25.861-16.971 40.971l80 80c9.374 9.372 24.568 9.372 33.941 0l80-80C624.041 345.9 613.368 320 592 320z"]
  },
      eg = {
    prefix: "fas",
    iconName: "ribbon",
    icon: [448, 512, [], "f4d6", "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"]
  },
      ag = {
    prefix: "fas",
    iconName: "ring",
    icon: [512, 512, [], "f70b", "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"]
  },
      ng = {
    prefix: "fas",
    iconName: "rings-wedding",
    icon: [512, 512, [], "f81b", "M351.25 160.77A206.38 206.38 0 0 1 379.9 233 112 112 0 1 1 224 336c0-42.21 23.69-78.57 58.31-97.49 3.37 10.64 5.69 21.75 5.69 33.49a111.34 111.34 0 0 1-30.73 76.6A79.84 79.84 0 0 0 293 403.23 175.36 175.36 0 0 0 352 272c0-81.62-55.64-150.07-131-170l35-70-32-32h-96L96 32l35 70C55.64 121.93 0 190.38 0 272a176 176 0 0 0 176 176 171.77 171.77 0 0 0 22.94-1.71A175.93 175.93 0 0 0 512 336c0-92-70.7-167.49-160.75-175.23zM64 272a112.12 112.12 0 0 1 112-112c26.85 0 51.19 9.88 70.5 25.69C194.94 216.24 160 271.68 160 336a175.89 175.89 0 0 0 6.55 47C109.28 378.16 64 330.52 64 272z"]
  },
      tg = {
    prefix: "fas",
    iconName: "road",
    icon: [576, 512, [], "f018", "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"]
  },
      rg = {
    prefix: "fas",
    iconName: "robot",
    icon: [640, 512, [], "f544", "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"]
  },
      ig = {
    prefix: "fas",
    iconName: "rocket",
    icon: [512, 512, [], "f135", "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"]
  },
      og = {
    prefix: "fas",
    iconName: "rocket-launch",
    icon: [512, 512, [], "e027", "M505.16405,19.29688c-1.176-5.4629-6.98736-11.26563-12.45106-12.4336C460.61647,0,435.46433,0,410.41962,0,307.2013,0,245.30155,55.20312,199.09162,128H94.88878c-16.29733,0-35.599,11.92383-42.88913,26.49805L2.57831,253.29688A28.39645,28.39645,0,0,0,.06231,264a24.008,24.008,0,0,0,24.00353,24H128.01866a96.00682,96.00682,0,0,1,96.01414,96V488a24.008,24.008,0,0,0,24.00353,24,28.54751,28.54751,0,0,0,10.7047-2.51562l98.747-49.40626c14.56074-7.28515,26.4746-26.56445,26.4746-42.84374V312.79688c72.58882-46.3125,128.01886-108.40626,128.01886-211.09376C512.07522,76.55273,512.07522,51.40234,505.16405,19.29688ZM384.05637,168a40,40,0,1,1,40.00589-40A40.02,40.02,0,0,1,384.05637,168ZM35.68474,352.06641C9.82742,377.91992-2.94985,442.59375.57606,511.41016c69.11565,3.55859,133.61147-9.35157,159.36527-35.10547,40.28913-40.2793,42.8774-93.98633,6.31147-130.54883C129.68687,309.19727,75.97,311.78516,35.68474,352.06641Zm81.63312,84.03125c-8.58525,8.584-30.08256,12.88672-53.11915,11.69922-1.174-22.93555,3.08444-44.49219,11.70289-53.10938,13.42776-13.42578,31.33079-14.28906,43.51813-2.10352C131.60707,404.77148,130.74562,422.67188,117.31786,436.09766Z"]
  },
      lg = {
    prefix: "fas",
    iconName: "route",
    icon: [512, 512, [], "f4d7", "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      fg = {
    prefix: "fas",
    iconName: "route-highway",
    icon: [448, 512, [], "f61a", "M428.4 269.21c-30.48-45.42-11.8-104.47 13-155.4 3.96-8.13 3.34-17.75-1.87-25.13l-41.18-58.36c-5.06-7.18-15.76-13.1-27.49-8.61-15.37 5.88-32.67 8.89-50.26 8.89-29.51 0-59.81-8.47-83.16-26.11C233.48 1.5 228.74 0 224 0s-9.48 1.5-13.44 4.49C187.21 22.13 156.9 30.6 127.39 30.6c-17.59 0-34.89-3.01-50.25-8.89-11.82-4.52-22.49 1.52-27.49 8.61L8.47 88.69c-5.21 7.38-5.83 16.99-1.87 25.13 24.8 50.92 43.47 109.97 13 155.4-37.94 56.52-18.55 139.43 38.81 166.03L223.97 512l165.62-76.76c57.36-26.6 76.75-109.51 38.81-166.03zm-65.72 107.96l-138.7 64.29-138.65-64.29c-19.78-9.17-29.7-46.8-12.59-72.3 24.73-36.86 29.2-76.74 25.22-112.87h252.07c-3.98 36.13.49 76.02 25.22 112.88 17.23 25.66 7.05 63.2-12.57 72.29z"]
  },
      sg = {
    prefix: "fas",
    iconName: "route-interstate",
    icon: [480, 512, [], "f61b", "M464.83 55.14c-3.6-11.66-14.92-19.1-26.18-15.95-18.23 5.12-37.74 7.96-58.1 7.96-49.12 0-93.61-16.07-126.17-42.11C250.18 1.68 245.09 0 240 0s-10.18 1.68-14.37 5.03c-32.56 26.04-77.05 42.11-126.17 42.11-20.36 0-39.87-2.84-58.1-7.96-11.23-3.15-22.57 4.26-26.18 15.95C-21.83 175.11-6.68 410.34 240 512 486.68 410.34 501.84 175.11 464.83 55.14zM240 441.87C115.27 380.93 72.01 279.56 64.76 192h350.49c-7.26 87.56-50.52 188.93-175.25 249.87z"]
  },
      ug = {
    prefix: "fas",
    iconName: "router",
    icon: [576, 512, [], "f8da", "M528 320H376v-80a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v80H48a48 48 0 0 0-48 48v96a48 48 0 0 0 48 48h480a48 48 0 0 0 48-48v-96a48 48 0 0 0-48-48zM96 448a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm96 0a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm-32.59-320.34a15.85 15.85 0 0 0 21.86.64c96.45-86.55 244.24-85.85 341.11.42a16 16 0 0 0 21.84-.63l22.71-22.7a16.11 16.11 0 0 0-.71-23.34C444.81-27.34 259.26-27.34 137.78 82a16.11 16.11 0 0 0-.71 23.34zm46.47 38a16.12 16.12 0 0 0-.86 23.61L227.73 212a15.94 15.94 0 0 0 21.7.78c58.77-49.84 145.8-49.36 205.14.21a16.07 16.07 0 0 0 21.63-.84l22.8-22.8a16.22 16.22 0 0 0-.84-23.63c-83.83-71.91-208.42-71.91-292.28-.06z"]
  },
      hg = {
    prefix: "fas",
    iconName: "rss",
    icon: [448, 512, [], "f09e", "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"]
  },
      mg = {
    prefix: "fas",
    iconName: "rss-square",
    icon: [448, 512, [], "f143", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"]
  },
      vg = {
    prefix: "fas",
    iconName: "ruble-sign",
    icon: [384, 512, [], "f158", "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"]
  },
      dg = {
    prefix: "fas",
    iconName: "ruler",
    icon: [640, 512, [], "f545", "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"]
  },
      Mg = {
    prefix: "fas",
    iconName: "ruler-combined",
    icon: [512, 512, [], "f546", "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"]
  },
      pg = {
    prefix: "fas",
    iconName: "ruler-horizontal",
    icon: [576, 512, [], "f547", "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"]
  },
      zg = {
    prefix: "fas",
    iconName: "ruler-triangle",
    icon: [512, 512, [], "f61c", "M501.65 452.08l-51.16-51.16-38.57 38.57c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l38.57-38.57-56.57-56.57-38.57 38.57c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l38.57-38.57-56.57-56.57-38.57 38.57c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l38.57-38.57-56.57-56.57-38.57 38.57c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l38.57-38.57-56.6-56.59-38.57 38.57c-3.12 3.12-8.19 3.12-11.31 0L72.51 111.4c-3.12-3.12-3.12-8.19 0-11.31l38.57-38.57-51.17-51.17C52.76 3.2 43.97 0 35.35 0 17.31 0 0 14.01 0 35.17V476.9C0 496.29 15.71 512 35.1 512h441.73c31.27 0 46.93-37.8 24.82-59.92zM128 384V259.46L252.54 384H128z"]
  },
      Cg = {
    prefix: "fas",
    iconName: "ruler-vertical",
    icon: [256, 512, [], "f548", "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"]
  },
      Lg = {
    prefix: "fas",
    iconName: "running",
    icon: [416, 512, [], "f70c", "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"]
  },
      Ag = {
    prefix: "fas",
    iconName: "rupee-sign",
    icon: [320, 512, [], "f156", "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"]
  },
      Ng = {
    prefix: "fas",
    iconName: "rv",
    icon: [640, 512, [], "f7be", "M621.3 269.3L563 211c-12-12-28.4-18.8-45.4-18.8L416 192v240h.2c.1 34.1 22.1 66.3 54.9 76.2 54.8 16.6 105-23.9 105-76.2v-16h32c17.6 0 32-14.4 32-32v-69.5c-.1-17-6.8-33.2-18.8-45.2zM496 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm-16-176v-48h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480zm128-160.8c-.4-52.6-43.2-95.2-96-95.2H384V16c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v16H64C28.7 32 0 60.7 0 96v197.5c0 17 6.7 33.3 18.7 45.3L96 416v11.4c0 41.8 30.1 80 71.8 84.1 47.9 4.8 88.2-32.7 88.2-79.6v-16h128V160h192c17.9 0 32.1-14.8 32-32.8zM176 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm80-256c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v64z"]
  },
      gg = {
    prefix: "fas",
    iconName: "sack",
    icon: [512, 512, [], "f81c", "M192 96h128l47.4-71.12A16 16 0 0 0 354.09 0H157.94a16 16 0 0 0-13.31 24.88zm128 32H192C-10.38 243.4.09 396.64.09 416c0 53 49.11 96 109.68 96h292.48c60.58 0 109.68-43 109.68-96 0-19 9.35-173.24-191.93-288z"]
  },
      Hg = {
    prefix: "fas",
    iconName: "sack-dollar",
    icon: [512, 512, [], "f81d", "M192 96h128l47.4-71.12A16 16 0 0 0 354.09 0H157.94a16 16 0 0 0-13.31 24.88zm128 32H192C-10.38 243.4.09 396.64.09 416c0 53 49.11 96 109.68 96h292.48c60.58 0 109.68-43 109.68-96 0-19 9.35-173.24-191.93-288zm-46.58 278v17.34a8.69 8.69 0 0 1-8.7 8.62h-17.41a8.69 8.69 0 0 1-8.71-8.62v-17.51a63.19 63.19 0 0 1-34.16-12.17 8.55 8.55 0 0 1-.66-13l12.84-12.06a8.92 8.92 0 0 1 11-.76 26.72 26.72 0 0 0 13.93 4h30.58c7.07 0 12.84-6.35 12.84-14.22 0-6.46-3.92-12.06-9.58-13.67l-49-14.54c-20.24-6-34.39-25.2-34.39-46.74 0-26.38 20.68-47.82 46.46-48.57v-17.48a8.69 8.69 0 0 1 8.74-8.62h17.41a8.68 8.68 0 0 1 8.7 8.62v17.55a63.12 63.12 0 0 1 34.17 12.17 8.55 8.55 0 0 1 .65 13l-12.73 12.2a8.92 8.92 0 0 1-11 .75 26.78 26.78 0 0 0-13.93-4h-30.56c-7.07 0-12.84 6.35-12.84 14.21 0 6.46 3.92 12.06 9.57 13.68l49 14.54c20.24 6 34.38 25.2 34.38 46.74-.14 26.4-20.92 47.94-46.6 48.54z"]
  },
      Vg = {
    prefix: "fas",
    iconName: "sad-cry",
    icon: [496, 512, [], "f5b3", "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"]
  },
      xg = {
    prefix: "fas",
    iconName: "sad-tear",
    icon: [496, 512, [], "f5b4", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"]
  },
      wg = {
    prefix: "fas",
    iconName: "salad",
    icon: [512, 512, [], "f81e", "M96 256h73.37l-87-87a8 8 0 0 1 0-11.31l11.32-11.32a8 8 0 0 1 11.31 0l103 103V104a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v152h52.54a126.72 126.72 0 0 1-4.54-32A128.14 128.14 0 0 1 416 96c2.65 0 5.12.62 7.73.78C406.14 76.84 380.69 64 352 64a95 95 0 0 0-25.15 3.75 111.94 111.94 0 0 0-205.7 0A95 95 0 0 0 96 64a96 96 0 0 0 0 192zm224-32a95 95 0 0 0 5.88 32h169.29a47.88 47.88 0 0 1 10.57 1.24A95.87 95.87 0 1 0 320 224zm175.17 64h-479C7 288-.74 295.72.06 304.84 6.69 381.21 58.27 444.23 128 468.69V480a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32v-11.51c69.4-24.62 120.66-87.49 127.27-163.65.79-9.12-6.95-16.84-16.1-16.84z"]
  },
      yg = {
    prefix: "fas",
    iconName: "sandwich",
    icon: [512, 512, [], "f81f", "M480 32H32A32 32 0 0 0 0 64v96a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm17.9 223.29c-15.08-1.68-24-6.17-35.51-11.9-17.27-8.64-38.73-19.39-78.27-19.39s-61 10.75-78.26 19.38C291.22 250.7 280.64 256 256.22 256s-35.08-5.3-49.75-12.62c-17.28-8.63-38.78-19.38-78.36-19.38S67 234.73 49.77 243.38c-11.51 5.74-20.51 10.24-35.67 11.91A15.93 15.93 0 0 0 0 271.08v32.14a16.26 16.26 0 0 0 17.85 16c28.58-2.63 46-11.36 60.51-18.59C93 293.3 103.64 288 128.11 288s35.09 5.3 49.77 12.62c17.26 8.65 38.78 19.38 78.34 19.38s61-10.75 78.26-19.38C349.12 293.3 359.7 288 384.12 288s35 5.3 49.61 12.61c14.47 7.24 31.89 16 60.41 18.6a16.27 16.27 0 0 0 17.86-16v-32.14a15.94 15.94 0 0 0-14.1-15.78zM480 352h-64l-96 48-96-48H32a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32z"]
  },
      bg = {
    prefix: "fas",
    iconName: "satellite",
    icon: [512, 512, [], "f7bf", "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"]
  },
      Sg = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [512, 512, [], "f7c0", "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"]
  },
      Tg = {
    prefix: "fas",
    iconName: "sausage",
    icon: [512, 512, [], "f820", "M447.83 69.83L463 24.18A18.36 18.36 0 0 0 445.62 0h-59.24A18.36 18.36 0 0 0 369 24.18l15.21 45.65C346.88 83 320 118.2 320 160c0 88.22-71.78 160-160 160-41.8 0-77 26.88-90.17 64.17L24.18 369A18.36 18.36 0 0 0 0 386.38v59.24A18.37 18.37 0 0 0 24.18 463l45.65-15.21C83 485.12 118.2 512 160 512c194.09 0 352-157.91 352-352 0-41.8-26.88-77-64.17-90.17zM160 400a16 16 0 0 1 0-32c114.69 0 208-93.31 208-208a16 16 0 0 1 32 0c0 132.34-107.66 240-240 240z"]
  },
      Dg = {
    prefix: "fas",
    iconName: "save",
    icon: [448, 512, [], "f0c7", "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"]
  },
      jg = {
    prefix: "fas",
    iconName: "sax-hot",
    icon: [640, 512, [], "f8db", "M83.23 176A60.88 60.88 0 0 1 72 140.8c0-7.62 8.66-30.3 28.46-57.54q2 2.61 3.89 5.22L147 147.26l27.06-33.08c6.07 12.1 9.54 22.24 9.92 26.62a60.88 60.88 0 0 1-11.21 35.2h61.34a117 117 0 0 0 5.89-35.2c0-26.63-26-81.57-62.23-115.2a301.94 301.94 0 0 0-28.1 30A387.31 387.31 0 0 0 100 0C50.88 45.58 16 105 16 140.8a117 117 0 0 0 5.89 35.2zm552.05-75.31L608 73.37A32 32 0 0 0 585.34 64h-46.83a64 64 0 0 0-45.26 18.74L449 127l-10.34-10.34a16 16 0 0 0-22.63 0L404.69 128a16 16 0 0 0 0 22.63L415 161l-14 14-10.34-10.34a16 16 0 0 0-22.63 0L356.69 176a16 16 0 0 0 0 22.63L367 209l-14 14-10.34-10.34a16 16 0 0 0-22.63 0L308.69 224a16 16 0 0 0 0 22.63L319 257 210 366a25.41 25.41 0 0 1-39.76-31l47.39-79H240a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a15.91 15.91 0 0 0 15.21 15.84C7.48 288.56 0 326.72 0 352c0 61.4 35 114.09 85.73 140.92A150 150 0 0 0 160 512c77.1 0 116.46-51.33 128-64l246.39-308a32 32 0 0 1 25-12H624c14.22 0 21.36-17.23 11.28-27.31zM88 392a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm32-88a24 24 0 1 1 24-24 24 24 0 0 1-24 24z"]
  },
      Eg = {
    prefix: "fas",
    iconName: "saxophone",
    icon: [640, 512, [], "f8dc", "M635.28 68.69L608 41.37A32 32 0 0 0 585.34 32h-46.83a64 64 0 0 0-45.26 18.74L449 95l-10.37-10.31a16 16 0 0 0-22.63 0L404.69 96a16 16 0 0 0 0 22.63L415 129l-14 14-10.34-10.34a16 16 0 0 0-22.63 0L356.69 144a16 16 0 0 0 0 22.63L367 177l-14 14-10.34-10.34a16 16 0 0 0-22.63 0L308.69 192a16 16 0 0 0 0 22.63L319 225 210 334a25.41 25.41 0 0 1-39.76-31l76.16-127H272a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h11.46C18.65 207.92 0 280.13 0 320c0 61.4 35 114.09 85.73 140.92A150 150 0 0 0 160 480c77.1 0 116.46-51.33 128-64l246.39-308a32 32 0 0 1 25-12H624c14.22 0 21.36-17.23 11.28-27.31zM96 344a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm32-96a24 24 0 1 1 24-24 24 24 0 0 1-24 24z"]
  },
      kg = {
    prefix: "fas",
    iconName: "scalpel",
    icon: [512, 512, [], "f61d", "M482.7 11.85c-29.2-20.83-70.18-13.03-93.49 14.22l-201.5 235.46c-8.9 10.41-1.51 26.47 12.19 26.47h131.94c9.37 0 18.28-4.1 24.37-11.22l139.02-162.44c26.37-30.8 21.23-78.41-12.53-102.49zM0 512c87 .07 170.28-29.18 234.29-81.16.2-.16.39-.32.59-.48 31.37-25.71 46.72-63.93 46.72-102.32V320H176L0 512z"]
  },
      Ig = {
    prefix: "fas",
    iconName: "scalpel-path",
    icon: [640, 512, [], "f61e", "M312 480h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm160 0h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm160 0h-80c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h80c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm-397.12-49.64c31.37-25.71 46.72-63.93 46.72-102.32V320H176L0 512c87 .07 170.28-29.18 234.29-81.16.2-.16.39-.32.59-.48zM482.71 11.85c-29.2-20.83-70.18-13.03-93.49 14.22l-201.5 235.46c-8.9 10.41-1.51 26.46 12.19 26.46h131.94c9.37 0 18.28-4.1 24.37-11.22l139.02-162.44c26.36-30.79 21.22-78.4-12.53-102.48z"]
  },
      Og = {
    prefix: "fas",
    iconName: "scanner",
    icon: [640, 512, [], "f488", "M368 64H96c-53 0-96 43-96 96 0 52.4 42.1 94.9 94.3 95.8L6.4 408C-6.9 431 1 460.3 24 473.6l55.4 32c23 13.3 52.3 5.4 65.6-17.6l133.9-232H368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM256 448c17.7 0 32-14.3 32-32V304.3L205 448h51zm376 0H456c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-96H456c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0-288H456c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8zm0-64H456c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zm0 288H456c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0-128H456c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"]
  },
      Qg = {
    prefix: "fas",
    iconName: "scanner-image",
    icon: [640, 512, [], "f8f3", "M10.93 108.71L467.65 256h167.59l3.93-11.75a16 16 0 0 0-10.1-20.25L36.3 32.83a16 16 0 0 0-20.24 10.1L.83 88.46a16 16 0 0 0 10.1 20.25zM32 288a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V288zm88 112a8 8 0 0 1-8 8H80a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm96 0a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8z"]
  },
      Zg = {
    prefix: "fas",
    iconName: "scanner-keyboard",
    icon: [576, 512, [], "f489", "M400 96H16c-8.8 0-16 7.2-16 16v137.4c0 4.2 1.7 8.3 4.7 11.3L32 288v176c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V288l27.3-27.3c3-3 4.7-7.1 4.7-11.3V112c0-8.8-7.2-16-16-16zM192 440c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v48zm0-96c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v48zm128 96c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v48zm0-96c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v48zm32-128c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h272c4.4 0 8 3.6 8 8v48zM256 8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h64V8zm152-8h-48c-4.4 0-8 3.6-8 8v56h64V8c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zM320 8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56h32V8zm152-8h-16c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8z"]
  },
      Ug = {
    prefix: "fas",
    iconName: "scanner-touchscreen",
    icon: [576, 512, [], "f48a", "M400 96H16c-8.8 0-16 7.2-16 16v137.4c0 4.2 1.7 8.3 4.7 11.3L32 288v176c0 26.5 21.5 48 48 48h256c26.5 0 48-21.5 48-48V288l27.3-27.3c3-3 4.7-7.1 4.7-11.3V112c0-8.8-7.2-16-16-16zm-80 336c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16v256zM256 8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h64V8zm64 0c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56h32V8zm88-8h-48c-4.4 0-8 3.6-8 8v56h64V8c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zm-96 0h-16c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8z"]
  },
      Bg = {
    prefix: "fas",
    iconName: "scarecrow",
    icon: [448, 512, [], "f70d", "M224 448.1c-7.7 0-15.4-1.9-22.2-5.5l-9.8-5.2V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-58.7l-9.8 5.2c-6.8 3.7-14.5 5.6-22.2 5.6zm221.7-261.8L419.3 160l18.3-18.3c5-5 1.5-13.7-5.7-13.7H314.1c3.6-10 5.9-20.7 5.9-32 0-53-43-96-96-96s-96 43-96 96c0 11.3 2.3 22 5.9 32H16c-7.1 0-10.7 8.6-5.7 13.7L28.7 160 2.3 186.3c-3.1 3.1-3.1 8.2 0 11.3L28.7 224l-18.3 18.3c-5 5-1.5 13.7 5.7 13.7h106.1l-26 141.3c-2.1 12.9 11.2 22.8 22.9 16.9l32.7-24.2c5-3.7 11.6-4.2 17.1-1.3l47.9 25.5c4.5 2.4 9.8 2.4 14.3 0l47.9-25.5c5.5-2.9 12.1-2.4 17.1 1.3l32.7 24.2c11.7 5.9 25.1-4 22.9-16.9L325.9 256H432c7.1 0 10.7-8.6 5.7-13.7L419.3 224l26.3-26.3c3.2-3.2 3.2-8.2.1-11.4zM192 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 16c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      Rg = {
    prefix: "fas",
    iconName: "scarf",
    icon: [512, 512, [], "f7c1", "M214.2 100.9c36.9-8.6 68.1-3.7 84.4.2l-19.5 19.4 109.8 109.6c46.6-51.7 20.4-105.3 13.2-117.3l-43.7-73.4c-4.3-7.2-9.9-13.3-16.8-18-40.6-27.5-127.3-29.6-171.3.1-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.1c-1.5 2.5-37.1 62.1 11.5 115.8l135.1 140.7L369.6 256 214.2 100.9zM166 323.7L47.6 441.9c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l118.4-118.2-22.6-22.6zm-45.3-45.1L2.3 396.7c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l118.4-118.2-22.6-22.5zM92.9 487.1c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l118.4-118.2-22.6-22.6L92.9 487.1zm208.9-118.2l-22.6 22.6 117.4 117.2c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3L301.8 368.9zm207.9 26.8L392.3 278.6l-22.6 22.6L487 418.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.2-3.1 3.2-8.1.1-11.3zm-162.7-72l-22.6 22.6 117.4 117.2c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3L347 323.7z"]
  },
      Yg = {
    prefix: "fas",
    iconName: "school",
    icon: [640, 512, [], "f549", "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"]
  },
      Pg = {
    prefix: "fas",
    iconName: "screwdriver",
    icon: [512, 512, [], "f54a", "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"]
  },
      Fg = {
    prefix: "fas",
    iconName: "scroll",
    icon: [640, 512, [], "f70e", "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"]
  },
      Wg = {
    prefix: "fas",
    iconName: "scroll-old",
    icon: [640, 512, [], "f70f", "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288v-57.37c0-4.24-1.69-8.31-4.69-11.31L512 256l27.31-27.31c3-3 4.69-7.07 4.69-11.31v-50.75c0-4.24-1.69-8.31-4.69-11.31L512 128l26.86-26.86c3.27-3.27 5.21-7.84 4.86-12.45C539.98 39.15 498.48 0 448 0H111.59C121.74 13.41 128 29.92 128 48v137.37c0 4.24 1.69 8.31 4.69 11.31L160 224l-27.31 27.31c-3 3-4.69 7.07-4.69 11.31V416c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zm187.31-23.88L416 416l-27.31-27.31c-3-3-7.07-4.69-11.31-4.69H288v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H454.63c-4.25 0-8.32 1.69-11.32 4.69z"]
  },
      Gg = {
    prefix: "fas",
    iconName: "scrubber",
    icon: [496, 512, [], "f2f8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 312c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"]
  },
      qg = {
    prefix: "fas",
    iconName: "scythe",
    icon: [640, 512, [], "f710", "M608 0h-25.45l-59.74 288H400a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h109.54l-29.26 141.05A16 16 0 0 0 496 512h31.45a16 16 0 0 0 15.72-13l96.27-461A32 32 0 0 0 608 0zm-58.13 0h-211C192 0 64 64 0 192h510z"]
  },
      Jg = {
    prefix: "fas",
    iconName: "sd-card",
    icon: [384, 512, [], "f7c2", "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"]
  },
      Kg = {
    prefix: "fas",
    iconName: "search",
    icon: [512, 512, [], "f002", "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"]
  },
      Xg = {
    prefix: "fas",
    iconName: "search-dollar",
    icon: [512, 512, [], "f688", "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"]
  },
      _g = {
    prefix: "fas",
    iconName: "search-location",
    icon: [512, 512, [], "f689", "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
  },
      $g = {
    prefix: "fas",
    iconName: "search-minus",
    icon: [512, 512, [], "f010", "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"]
  },
      cH = {
    prefix: "fas",
    iconName: "search-plus",
    icon: [512, 512, [], "f00e", "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"]
  },
      eH = {
    prefix: "fas",
    iconName: "seedling",
    icon: [512, 512, [], "f4d8", "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"]
  },
      aH = {
    prefix: "fas",
    iconName: "send-back",
    icon: [640, 512, [], "f87e", "M256 224V32a32 32 0 0 0-32-32H32A32 32 0 0 0 0 32v192a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32zm-64-32H64V64h128zm416 64H416a32 32 0 0 0-32 32v192a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32V288a32 32 0 0 0-32-32zm-32 192H448V320h128zm-96-224v-80a48 48 0 0 0-48-48H288v128a64.07 64.07 0 0 1-64 64h-64v80a48 48 0 0 0 48 48h144V288a64.07 64.07 0 0 1 64-64z"]
  },
      nH = {
    prefix: "fas",
    iconName: "send-backward",
    icon: [512, 512, [], "f87f", "M464,160H208a48,48,0,0,0-48,48V464a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48h0V208A48,48,0,0,0,464,160ZM448,448H224V224H448ZM352,128V48A48,48,0,0,0,304,0H48A48,48,0,0,0,0,48V304a48,48,0,0,0,48,48h80V208a80.09,80.09,0,0,1,80-80Z"]
  },
      tH = {
    prefix: "fas",
    iconName: "sensor",
    icon: [448, 512, [], "e028", "M384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32ZM96,272a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Zm64,0a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Zm64,0a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Z"]
  },
      rH = {
    prefix: "fas",
    iconName: "sensor-alert",
    icon: [640, 512, [], "e029", "M235.19,387.38,376,143.23a82.24,82.24,0,0,1,72-41.58V96a64,64,0,0,0-64-64H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H242.51c-2.47-3.15-5.24-6-7.29-9.54A82.22,82.22,0,0,1,235.19,387.38ZM96,272a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Zm64,0a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Zm48,16a16,16,0,0,1-16-16V112a16,16,0,0,1,32,0V272A16,16,0,0,1,208,288ZM633.09,403.37,492.27,159.22c-19.66-34.09-68.87-34.09-88.53,0L262.91,403.36C243.26,437.43,267.85,480,307.18,480H588.82C628.15,480,652.74,437.43,633.09,403.37ZM448,432a24,24,0,1,1,24-24A24,24,0,0,1,448,432Zm19.08-82.8A12,12,0,0,1,455.14,360H440.87a12,12,0,0,1-11.95-10.8l-9.59-96A12,12,0,0,1,431.27,240h33.47a12,12,0,0,1,11.94,13.2Z"]
  },
      iH = {
    prefix: "fas",
    iconName: "sensor-fire",
    icon: [640, 512, [], "e02a", "M288.89,315.43c0-61.11,53.71-153.47,130.6-224.61a32.08,32.08,0,0,1,21.83-8.53c2.27,0,4.45.75,6.68,1.23A64.11,64.11,0,0,0,385.08,32H64.18A64.08,64.08,0,0,0,0,96V416a64.08,64.08,0,0,0,64.18,64H376.46A197.48,197.48,0,0,1,288.89,315.43ZM96.27,272a16,16,0,0,1-32.09,0V112a16,16,0,0,1,32.09,0Zm64.18,0a16,16,0,0,1-32.09,0V112a16,16,0,0,1,32.09,0Zm64.18,0a16,16,0,0,1-32.09,0V112a16,16,0,0,1,32.09,0ZM551.12,150.86A426.14,426.14,0,0,0,511,193.7,553.25,553.25,0,0,0,440,114.29c-70.19,65.11-120,150-120,201.14C320,406.33,391.63,480,480,480s160-73.67,160-164.57C640,277.38,602.87,198.89,551.12,150.86Zm-11.06,247A100.9,100.9,0,0,1,482.14,416C428,416,384,380.19,384,322.07c0-29,18.23-54.48,54.6-98.07,5.19,6,74.11,94,74.11,94l44-50.14c3.11,5.12,5.93,10.15,8.44,15C585.65,322,577,372.05,540.06,397.9Z"]
  },
      oH = {
    prefix: "fas",
    iconName: "sensor-on",
    icon: [640, 512, [], "e02b", "M384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32ZM96,272a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Zm64,0a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Zm64,0a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Zm392-40H552a24,24,0,0,0,0,48h64a24,24,0,0,0,0-48Zm-80-88a23.87,23.87,0,0,0,13.29-4l48-32a24,24,0,1,0-26.62-39.92l-48,32A24,24,0,0,0,536,144Zm13.29,228A24,24,0,1,0,522.69,412l48,32A24,24,0,1,0,597.31,404Z"]
  },
      lH = {
    prefix: "fas",
    iconName: "sensor-smoke",
    icon: [640, 512, [], "e02c", "M572.67,321.28a47.81,47.81,0,0,0-82.4-46.63,79.94,79.94,0,0,0-152.63,45.52c-.56,0-1.08-.17-1.64-.17a80,80,0,0,0,0,160H560a79.85,79.85,0,0,0,12.67-158.72Zm-268.08-28.8A112.15,112.15,0,0,1,416,192c11.14,0,21.74,2.15,32,5.22V96a64,64,0,0,0-64-64H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H257.86a111.81,111.81,0,0,1,46.73-187.52ZM96,272a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Zm64,0a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Zm48,16a16,16,0,0,1-16-16V112a16,16,0,0,1,32,0V272A16,16,0,0,1,208,288Z"]
  },
      fH = {
    prefix: "fas",
    iconName: "server",
    icon: [512, 512, [], "f233", "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"]
  },
      sH = {
    prefix: "fas",
    iconName: "shapes",
    icon: [512, 512, [], "f61f", "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"]
  },
      uH = {
    prefix: "fas",
    iconName: "share",
    icon: [512, 512, [], "f064", "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"]
  },
      hH = {
    prefix: "fas",
    iconName: "share-all",
    icon: [576, 512, [], "f367", "M439.691 226.164L263.687 378.15C248.3 391.439 224 380.687 224 359.986v-84.175c-108.668 12.533-151.102 58.854-112.59 182.015 5.034 16.098-14.424 28.562-28.077 18.631C39.582 444.635 0 383.766 0 322.326 0 190.99 94.818 149.009 224 138.777V56.015c0-20.667 24.28-31.469 39.687-18.164l176.004 151.985c11.086 9.575 11.071 26.767 0 36.328zm128-36.328L391.687 37.851C376.28 24.546 352 35.348 352 56.015v15.818l108.607 93.786A55.949 55.949 0 0 1 480 207.998a55.96 55.96 0 0 1-19.394 42.385L352 344.168v15.818c0 20.701 24.3 31.453 39.687 18.164l176.004-151.986c11.071-9.561 11.086-26.753 0-36.328z"]
  },
      mH = {
    prefix: "fas",
    iconName: "share-alt",
    icon: [448, 512, [], "f1e0", "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"]
  },
      vH = {
    prefix: "fas",
    iconName: "share-alt-square",
    icon: [448, 512, [], "f1e1", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"]
  },
      dH = {
    prefix: "fas",
    iconName: "share-square",
    icon: [576, 512, [], "f14d", "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"]
  },
      MH = {
    prefix: "fas",
    iconName: "sheep",
    icon: [640, 512, [], "f711", "M622.25 105.96L576 83.22V64c0-17.67-14.33-32-32-32h-64c0-17.67-14.33-32-32-32s-32 14.33-32 32v76.82c-17.53-15.92-47.07-15.86-64.62.42-8.6-8.16-20.16-13.24-32.99-13.24-12.47 0-24 4.8-32.64 12.8-8.64-8-19.83-12.8-32.64-12.8-12.47 0-24 4.8-32.31 12.8-8.64-8-20.16-12.8-32.64-12.8-13.12 0-24.97 5.44-33.61 13.75-11.19-9.28-26.23-13.75-41.59-10.23-17.59 3.84-31.03 16.95-35.84 33.28-16.64-2.88-34.23 3.2-45.44 17.28-11.52 14.08-13.44 32.64-7.03 48.31C9.92 206.72 0 222.39 0 240.31c0 18.23 10.23 33.92 24.95 41.92-6.41 15.69-4.16 34.23 7.05 48.31 11.52 14.09 29.11 20.17 45.75 17.28 4.08 13.61 14.64 24.76 28.47 30.27l-6.14 16.38a63.973 63.973 0 0 0-2.16 38l16.85 67.41A16.002 16.002 0 0 0 130.29 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-18.31-73.26 14.76-39.36c4.73-2.15 9.22-4.78 12.9-8.31 8.64 8 20.17 12.81 32.64 12.81 12.48 0 24-4.81 32.64-12.81 8.64 8 19.84 12.81 32.64 12.81 12.52 0 23.87-4.98 32.39-12.97.17.16.4.21.57.37V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V330.67L483.5 307a64.009 64.009 0 0 0 28.5-53.25V192h87.66c9.26 0 17.76-4.9 22.37-12.94 7.59-13.26 17.98-33.45 17.98-44.59a31.798 31.798 0 0 0-17.76-28.51zM512 112c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      pH = {
    prefix: "fas",
    iconName: "shekel-sign",
    icon: [448, 512, [], "f20b", "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"]
  },
      zH = {
    prefix: "fas",
    iconName: "shield",
    icon: [512, 512, [], "f132", "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3z"]
  },
      CH = {
    prefix: "fas",
    iconName: "shield-alt",
    icon: [512, 512, [], "f3ed", "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"]
  },
      LH = {
    prefix: "fas",
    iconName: "shield-check",
    icon: [512, 512, [], "f2f7", "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zm-47.2 114.2l-184 184c-6.2 6.2-16.4 6.2-22.6 0l-104-104c-6.2-6.2-6.2-16.4 0-22.6l22.6-22.6c6.2-6.2 16.4-6.2 22.6 0l70.1 70.1 150.1-150.1c6.2-6.2 16.4-6.2 22.6 0l22.6 22.6c6.3 6.3 6.3 16.4 0 22.6z"]
  },
      AH = {
    prefix: "fas",
    iconName: "shield-cross",
    icon: [448, 512, [], "f712", "M420.43 83.69l-179.2-80c-11.03-4.92-23.43-4.92-34.46 0l-179.2 80C10.88 91.14 0 108.62 0 128c0 198.49 106.86 335.71 206.77 380.31 11.03 4.92 23.43 4.92 34.46 0C321.13 472.64 448 349.28 448 128c0-19.38-10.88-36.86-27.57-44.31zM374.09 224H256v200.27c-11.34 8.92-22.26 16.12-32.07 21.3-10.68-5.51-21.36-12.66-31.93-20.81V224H74.8c-4.39-20.25-7.37-41.58-8.9-64H192V80.37l32-14.29 32 14.29V160h126.74c-1.47 22.72-4.4 44.07-8.65 64z"]
  },
      NH = {
    prefix: "fas",
    iconName: "shield-virus",
    icon: [512, 512, [], "e06c", "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"]
  },
      gH = {
    prefix: "fas",
    iconName: "ship",
    icon: [640, 512, [], "f21a", "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"]
  },
      HH = {
    prefix: "fas",
    iconName: "shipping-fast",
    icon: [640, 512, [], "f48b", "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"]
  },
      VH = {
    prefix: "fas",
    iconName: "shipping-timed",
    icon: [640, 512, [], "f48c", "M248 160h-24v-56c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm376 192h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm48-176c-61.9 0-112-50.1-112-112S146.1 64 208 64s112 50.1 112 112-50.1 112-112 112zm272 176c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"]
  },
      xH = {
    prefix: "fas",
    iconName: "shish-kebab",
    icon: [512, 512, [], "f821", "M126.55 255.59a30.61 30.61 0 0 0-43.28 0L41 297.89a30.6 30.6 0 0 0 0 43.29L170.82 471a30.6 30.6 0 0 0 43.29 0l42.3-42.3a30.61 30.61 0 0 0 0-43.28zm108.22-108.21a30.62 30.62 0 0 0-43.29 0l-42.3 42.3a30.61 30.61 0 0 0 0 43.28L279 362.82a30.61 30.61 0 0 0 43.28 0l42.3-42.3a30.6 30.6 0 0 0 0-43.29zM4.55 473.52a15.49 15.49 0 0 0 0 21.94l12 12a15.49 15.49 0 0 0 21.94 0l61.78-61.73-33.95-33.94zM511.21 84.07c-3.78-29.71-21.06-55.68-47.42-71.21a95.17 95.17 0 0 0-97.93 1.43C323.2 41 307.71 94 330 138.88c1.44 2.93 2.28 7.16 0 9.49l-24.47 24.45 33.93 33.93 24.48-24.46c16.72-16.73 20.28-42.14 9.09-64.72-9.62-19.43-6-48.25 19.61-63.36a45.55 45.55 0 0 1 45.92-.53c14.22 8 23.15 21 25.13 36.45a47.88 47.88 0 0 1-6 30.09c-3.71 6.39-3.31 14.32 1.91 19.55l12.29 12.29c6.72 6.72 18.17 6.09 23.54-1.75a95.31 95.31 0 0 0 15.78-66.24z"]
  },
      wH = {
    prefix: "fas",
    iconName: "shoe-prints",
    icon: [640, 512, [], "f54b", "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"]
  },
      yH = {
    prefix: "fas",
    iconName: "shopping-bag",
    icon: [448, 512, [], "f290", "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"]
  },
      bH = {
    prefix: "fas",
    iconName: "shopping-basket",
    icon: [576, 512, [], "f291", "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"]
  },
      SH = {
    prefix: "fas",
    iconName: "shopping-cart",
    icon: [576, 512, [], "f07a", "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"]
  },
      TH = {
    prefix: "fas",
    iconName: "shovel",
    icon: [512, 512, [], "f713", "M500.3 96.38L415.62 11.7c-15.59-15.59-40.97-15.59-56.56 0l-32.67 32.67c-18.94 18.94-29.25 44.31-29.25 70.55 0 6.53.64 13.13 1.95 19.69 1.74 8.69 4.75 16.84 8.53 24.53L197.36 269.39l-45.26-45.26c-12.5-12.5-32.76-12.5-45.25 0l-67.88 67.88C-11.02 342-6.29 473.03 16.34 495.66c22.63 22.63 153.66 27.36 203.65-22.63l67.88-67.88c12.5-12.5 12.5-32.76 0-45.25l-45.26-45.26 110.26-110.26c7.7 3.79 15.87 6.8 24.57 8.54 32.81 6.56 66.53-3.64 90.19-27.3l32.67-32.67c15.6-15.6 15.6-40.97 0-56.57zm-77.92 43.99a35.87 35.87 0 0 1-32.42 9.8c-14.23-2.86-25.27-13.91-28.13-28.17-2.33-11.83 1.31-23.91 9.8-32.38l15.7-15.7 50.75 50.75-15.7 15.7z"]
  },
      DH = {
    prefix: "fas",
    iconName: "shovel-snow",
    icon: [512, 512, [], "f7c3", "M503.2 72.3L439.7 8.8C428-2.9 409-2.9 397.3 8.8l-24.5 24.5c-14.2 14.2-21.9 33.2-21.9 52.9 0 4.9.5 9.8 1.5 14.8 1.3 6.5 3.6 12.6 6.4 18.4l-99.3 99.3-49.3-49.3c-11.3-11.3-29.3-12.5-41.9-2.7L12.4 287c-15.2 11.7-16.6 34.1-3 47.6l168 168c13.6 13.6 35.9 12.1 47.6-3l120.4-155.8c9.8-12.7 8.6-30.6-2.7-41.9l-49.3-49.3 99.3-99.3c5.8 2.8 11.9 5.1 18.4 6.4 24.6 4.9 49.9-2.7 67.6-20.5l24.5-24.5c11.7-11.7 11.7-30.7 0-42.4zM112 352c-4.1 0-8.2-1.6-11.3-4.7-6.2-6.2-6.2-16.4 0-22.6l80-80c6.2-6.3 16.4-6.3 22.6 0 6.2 6.2 6.2 16.4 0 22.6l-80 80c-3.1 3.1-7.2 4.7-11.3 4.7zm155.3-20.7l-80 80c-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7c-6.2-6.2-6.2-16.4 0-22.6l80-80c6.2-6.2 16.4-6.2 22.6 0s6.3 16.4 0 22.6zm177.5-226c-6.4 6.4-15.5 9.1-24.3 7.3-10.7-2.1-19-10.4-21.1-21.1-1.7-8.9 1-17.9 7.3-24.3l11.8-11.8 38.1 38.1-11.8 11.8z"]
  },
      jH = {
    prefix: "fas",
    iconName: "shower",
    icon: [512, 512, [], "f2cc", "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"]
  },
      EH = {
    prefix: "fas",
    iconName: "shredder",
    icon: [512, 512, [], "f68a", "M232 496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-80h-48v80zm-96 0c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-80h-48v80zm-96 0c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-80H40v80zm288 0c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-80h-48v80zm120-304V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 32H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-8 200c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-80h-48v80z"]
  },
      kH = {
    prefix: "fas",
    iconName: "shuttle-van",
    icon: [640, 512, [], "f5b6", "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"]
  },
      IH = {
    prefix: "fas",
    iconName: "shuttlecock",
    icon: [512, 512, [], "f45b", "M484 192h-20c0 6 4.3 55.7-44.7 71.2L328.1 292l-26.4 45.4-78 36.3-25.7-25.8 70.8-70.8 140.8-44.5c13.3-4.2 22.4-16.6 22.4-30.5V108c0-15.5-12.5-28-28-28h-94.1c-14 0-26.3 9.1-30.5 22.4l-44.5 140.8-70.8 70.8-25.7-25.7 36.3-78 45.4-26.4 28.8-91.2C263.4 46.7 307.7 48 320 48V28c0-15.4-12.6-28-28-28h-54.6c-10.8 0-20.8 6.3-25.4 16.2L95.5 266.5l-39.2 39.2 150 150 39.2-39.2L495.8 300c9.8-4.6 16.2-14.5 16.2-25.4V220c0-15.4-12.6-28-28-28zM31.1 331c-41.4 41.4-41.4 108.6 0 150 41.4 41.4 108.6 41.4 150 0l2.6-2.6-150-150-2.6 2.6z"]
  },
      OH = {
    prefix: "fas",
    iconName: "sickle",
    icon: [512, 512, [], "f822", "M129.94 308.69a16 16 0 0 0-22.63 0l-22.62 22.62a16 16 0 0 0 0 22.63l2.74 2.75-82.74 82.74a16 16 0 0 0 0 22.63L50 507.31a16 16 0 0 0 22.63 0l82.75-82.75 2.74 2.74a16 16 0 0 0 22.63 0l22.62-22.62a16 16 0 0 0 0-22.63zM320 0c-96 0-166.25 69.31-184.12 151.44-13.74 63.14 10.71 128.65 56.41 174.34L224 355.87l35.42-35.42c-38.53-64.2-23.88-151.27 46.88-196 43.09-27.24 99.58-28.9 144.05-4a148.11 148.11 0 0 1 47.33 41.42c5.08 6.9 15.79 1.93 14.14-6.48C501.17 100.72 448 0 320 0z"]
  },
      QH = {
    prefix: "fas",
    iconName: "sigma",
    icon: [384, 512, [], "f68b", "M352 32H52.03C32.37 32 14.59 42.89 5.68 60.44c-8.91 17.53-7.25 38.31 4.31 54.16L132.66 256 10.03 397.36c-11.59 15.89-13.25 36.67-4.34 54.2C14.59 469.11 32.37 480 52.03 480H352c17.67 0 32-14.33 32-32v-72c0-13.25-10.75-24-24-24h-48c-13.25 0-24 10.75-24 24v8H142.25l109.09-128-109.09-128H288v8c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24V64c0-17.67-14.33-32-32-32z"]
  },
      ZH = {
    prefix: "fas",
    iconName: "sign",
    icon: [512, 512, [], "f4d9", "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"]
  },
      UH = {
    prefix: "fas",
    iconName: "sign-in",
    icon: [512, 512, [], "f090", "M137.2 110.3l21.9-21.9c9.3-9.3 24.5-9.4 33.9-.1L344.9 239c9.5 9.4 9.5 24.7 0 34.1L193 423.7c-9.4 9.3-24.5 9.3-33.9-.1l-21.9-21.9c-9.7-9.7-9.3-25.4.8-34.7l77.6-71.1H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h191.5l-77.6-71.1c-10-9.1-10.4-24.9-.7-34.5zM512 352V160c0-53-43-96-96-96h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84c53 0 96-43 96-96z"]
  },
      BH = {
    prefix: "fas",
    iconName: "sign-in-alt",
    icon: [512, 512, [], "f2f6", "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"]
  },
      RH = {
    prefix: "fas",
    iconName: "sign-language",
    icon: [448, 512, [], "f2a7", "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"]
  },
      YH = {
    prefix: "fas",
    iconName: "sign-out",
    icon: [512, 512, [], "f08b", "M180 448H96c-53 0-96-43-96-96V160c0-53 43-96 96-96h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H96c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm117.9-303.1l77.6 71.1H184c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h191.5l-77.6 71.1c-10.1 9.2-10.4 25-.8 34.7l21.9 21.9c9.3 9.3 24.5 9.4 33.9.1l152-150.8c9.5-9.4 9.5-24.7 0-34.1L353 88.3c-9.4-9.3-24.5-9.3-33.9.1l-21.9 21.9c-9.7 9.6-9.3 25.4.7 34.6z"]
  },
      PH = {
    prefix: "fas",
    iconName: "sign-out-alt",
    icon: [512, 512, [], "f2f5", "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"]
  },
      FH = {
    prefix: "fas",
    iconName: "signal",
    icon: [640, 512, [], "f012", "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"]
  },
      WH = {
    prefix: "fas",
    iconName: "signal-1",
    icon: [640, 512, [], "f68c", "M88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16z"]
  },
      GH = {
    prefix: "fas",
    iconName: "signal-2",
    icon: [640, 512, [], "f68d", "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16z"]
  },
      qH = {
    prefix: "fas",
    iconName: "signal-3",
    icon: [640, 512, [], "f68e", "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16z"]
  },
      JH = {
    prefix: "fas",
    iconName: "signal-4",
    icon: [640, 512, [], "f68f", "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16z"]
  },
      KH = {
    prefix: "fas",
    iconName: "signal-alt",
    icon: [640, 512, [], "f690", "M96 384H64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160-128h-32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V288c0-17.67-14.33-32-32-32zm160-128h-32c-17.67 0-32 14.33-32 32v320c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM576 0h-32c-17.67 0-32 14.33-32 32v448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"]
  },
      XH = {
    prefix: "fas",
    iconName: "signal-alt-1",
    icon: [640, 512, [], "f691", "M96 384H64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"]
  },
      _H = {
    prefix: "fas",
    iconName: "signal-alt-2",
    icon: [640, 512, [], "f692", "M96 384H64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160-128h-32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V288c0-17.67-14.33-32-32-32z"]
  },
      $H = {
    prefix: "fas",
    iconName: "signal-alt-3",
    icon: [640, 512, [], "f693", "M96 384H64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160-128h-32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V288c0-17.67-14.33-32-32-32zm160-128h-32c-17.67 0-32 14.33-32 32v320c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"]
  },
      cV = {
    prefix: "fas",
    iconName: "signal-alt-slash",
    icon: [640, 512, [], "f694", "M633.82 458.1L608 438.14V32c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v331.95l-64-49.46V160c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v80.29L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM96 384H64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm96-96v192c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V352.6l-94.33-72.9c-.74 2.71-1.67 5.36-1.67 8.3zm160 192c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-3.73l-96-74.2V480z"]
  },
      eV = {
    prefix: "fas",
    iconName: "signal-slash",
    icon: [640, 512, [], "f695", "M633.82 458.1L616 444.33V16c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v366.5l-48-37.1V112c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v171.57l-48-37.1V208c0-8.84-7.16-16-16-16h-48c-1.82 0-3.5.48-5.13 1.04L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c1.22.95 2.04 2.18 2.9 3.37H600c.73 0 1.35-.32 2.06-.42 5.51.8 11.27-1.05 14.93-5.77l19.64-25.27c5.43-6.96 4.17-17.01-2.81-22.44zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm80-96c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V309.32L204.41 288H168zm112 208c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-87.75l-80-61.83V496zm128 0c0 8.84 7.16 16 16 16h48c5.49 0 10.1-2.94 12.98-7.15L408 445.35V496z"]
  },
      aV = {
    prefix: "fas",
    iconName: "signal-stream",
    icon: [576, 512, [], "f8dd", "M288 200a56 56 0 1 0 56 56 56 56 0 0 0-56-56zM64 256a214.3 214.3 0 0 1 55.42-144.06c5.59-6.22 4.91-15.74-1.08-21.59L96 68.53a16.41 16.41 0 0 0-23.56 1C25.59 121 0 186.56 0 256s25.59 135 72.44 186.52a16.41 16.41 0 0 0 23.56 1l22.34-21.82c6-5.85 6.67-15.37 1.08-21.59A214.3 214.3 0 0 1 64 256zm134.27-87.63l-22.76-22.23a16.44 16.44 0 0 0-24 1.31 168.77 168.77 0 0 0 0 217.1 16.44 16.44 0 0 0 24 1.31l22.76-22.22a15.12 15.12 0 0 0 1.45-20.32 107.39 107.39 0 0 1 0-134.64 15.11 15.11 0 0 0-1.45-20.31zm305.29-98.89a16.41 16.41 0 0 0-23.56-1l-22.34 21.87c-6 5.85-6.67 15.37-1.08 21.59a214.95 214.95 0 0 1 0 288.12c-5.59 6.22-4.91 15.74 1.08 21.59L480 443.47a16.41 16.41 0 0 0 23.56-1C550.41 391 576 325.44 576 256s-25.59-135-72.44-186.52zm-79.1 78a16.44 16.44 0 0 0-24-1.31L377.7 168.4a15.11 15.11 0 0 0-1.45 20.31 107.39 107.39 0 0 1 0 134.64 15.12 15.12 0 0 0 1.45 20.32l22.76 22.22a16.44 16.44 0 0 0 24-1.31 168.77 168.77 0 0 0 0-217.1z"]
  },
      nV = {
    prefix: "fas",
    iconName: "signature",
    icon: [640, 512, [], "f5b7", "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"]
  },
      tV = {
    prefix: "fas",
    iconName: "sim-card",
    icon: [384, 512, [], "f7c4", "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"]
  },
      rV = {
    prefix: "fas",
    iconName: "sink",
    icon: [512, 512, [], "e06d", "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"]
  },
      iV = {
    prefix: "fas",
    iconName: "siren",
    icon: [448, 512, [], "e02d", "M128.21,134.94a8,8,0,0,1,9-6.87l15.86,2.13a8,8,0,0,1,6.87,9L135.82,320H400L375,120.06A64,64,0,0,0,311.5,64h-175A64,64,0,0,0,73,120.06L48,320h55.54ZM432,352H16A16,16,0,0,0,0,368v64a16,16,0,0,0,16,16H432a16,16,0,0,0,16-16V368A16,16,0,0,0,432,352Z"]
  },
      oV = {
    prefix: "fas",
    iconName: "siren-on",
    icon: [640, 512, [], "e02e", "M224.21,134.94a8,8,0,0,1,9-6.87l15.86,2.13a8,8,0,0,1,6.87,9L231.82,320H496L471,120.06A64,64,0,0,0,407.5,64h-175A64,64,0,0,0,169,120.06L144,320h55.54ZM528,352H112a16,16,0,0,0-16,16v64a16,16,0,0,0,16,16H528a16,16,0,0,0,16-16V368A16,16,0,0,0,528,352ZM112,192a24,24,0,0,0-24-24H24a24,24,0,0,0,0,48H88A24,24,0,0,0,112,192Zm504-24H552a24,24,0,0,0,0,48h64a24,24,0,0,0,0-48ZM90.69,76a24,24,0,1,0,26.62-39.92l-48-32A24,24,0,1,0,42.69,44ZM536,80a23.87,23.87,0,0,0,13.29-4l48-32A24,24,0,1,0,570.69,4.06l-48,32A24,24,0,0,0,536,80Z"]
  },
      lV = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [640, 512, [], "f0e8", "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"]
  },
      fV = {
    prefix: "fas",
    iconName: "skating",
    icon: [448, 512, [], "f7c5", "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"]
  },
      sV = {
    prefix: "fas",
    iconName: "skeleton",
    icon: [512, 512, [], "f620", "M496 160H288v-32h144c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48H80c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h144v32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h208v32H80c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h144v32H112c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80c0-5.48-.56-10.83-1.61-16h131.23a80.321 80.321 0 0 0-1.61 16c0 44.18 35.82 80 80 80s80-35.82 80-80-35.82-80-80-80H288v-32h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H288v-32h208c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM112 464c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm288-64c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32z"]
  },
      uV = {
    prefix: "fas",
    iconName: "ski-jump",
    icon: [512, 512, [], "f7c7", "M510.7 190.2c-2.2-13.1-14.8-21.9-27.7-19.7-13.1 2.2-21.9 14.6-19.7 27.7 3.3 19.3-6 38.9-22.1 48.1L174 383.8l44.9-109 121.4-110.5c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h97.5l-58.9 76.5c-3.4 4.4.2-3.6-60.2 143.3-5.1 12.4-1.8 26.2 7.3 35L13 466.7c-11.8 6-16.4 20.5-10.3 32.3 4.3 8.3 12.7 13 21.4 13 3.7 0 7.5-.9 11-2.7l429.2-220.9c34.3-19.7 53-59.2 46.4-98.2zM400 96c26.5 0 48-21.5 48-48S426.5 0 400 0s-48 21.5-48 48 21.5 48 48 48z"]
  },
      hV = {
    prefix: "fas",
    iconName: "ski-lift",
    icon: [512, 512, [], "f7c8", "M112 128c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM256 0h-32v184l32-8V0zm232 288c-13.2 0-24 10.8-24 24 0 13.9-8.8 26.5-21.8 31.3L320 388.5V248c0-9.9-4.5-19.2-12.3-25.2-7.8-6.1-17.9-8.3-27.5-5.8l-68.3 17-24.1-53.7c-10.9-24.2-39.3-35-63.5-24.1-24.2 10.9-35 39.3-24.1 63.5 0 0 26.9 65.9 27.8 68.1 7.9 19.1 22.7 27.6 39.8 23.3L256 289v123.2l-144.3 53.3c-12.4 4.6-18.8 18.4-14.2 30.8 3.6 9.7 12.8 15.7 22.5 15.7 2.8 0 5.6-.5 8.3-1.5l330.5-122.1c31.8-11.8 53.2-42.5 53.2-76.4 0-13.2-10.7-24-24-24zm-296.4 93.4c12.6-4.2 19.4-17.8 15.2-30.4-4.2-12.6-17.7-19.5-30.4-15.2L158 342c-19 6.4-40-2.5-48.7-20.7l-63.6-133c-5.7-11.9-20-17-32-11.3-12 5.7-17 20-11.3 32L66 342c15 31.2 46.4 50 79.5 50 12.6 0 17-.9 46.1-10.6z"]
  },
      mV = {
    prefix: "fas",
    iconName: "skiing",
    icon: [512, 512, [], "f7c9", "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"]
  },
      vV = {
    prefix: "fas",
    iconName: "skiing-nordic",
    icon: [576, 512, [], "f7ca", "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"]
  },
      dV = {
    prefix: "fas",
    iconName: "skull",
    icon: [512, 512, [], "f54c", "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"]
  },
      MV = {
    prefix: "fas",
    iconName: "skull-cow",
    icon: [640, 512, [], "f8de", "M416,96H224a64,64,0,0,0-64,64V288a64,64,0,0,0,64,64l26.82,134.27A32,32,0,0,0,282.2,512h75.53a32,32,0,0,0,31.38-25.72L416,352a64,64,0,0,0,64-64V160A64,64,0,0,0,416,96ZM256,288a32,32,0,1,1,32-32A32,32,0,0,1,256,288Zm128,0a32,32,0,1,1,32-32A32,32,0,0,1,384,288ZM60.11,113.55C43.35,89.42,56.5,39,63,21.62a16,16,0,0,0-26.19-17C13.05,27.87,0,60.31,0,95.91,0,166.53,57.42,224,128,224V128.09H96C78.64,128.09,66.91,123.34,60.11,113.55Zm543.12-109A16,16,0,0,0,577,21.64c6.06,16.15,19.6,67.73,2.88,91.89-6.8,9.79-18.54,14.56-35.9,14.56H512V224c70.57,0,128-57.47,128-128.09C640,60.31,627,27.87,603.23,4.57Z"]
  },
      pV = {
    prefix: "fas",
    iconName: "skull-crossbones",
    icon: [448, 512, [], "f714", "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"]
  },
      zV = {
    prefix: "fas",
    iconName: "slash",
    icon: [640, 512, [], "f715", "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"]
  },
      CV = {
    prefix: "fas",
    iconName: "sledding",
    icon: [512, 512, [], "f7cb", "M505 420.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-49.1-25.4c4.2-5.4 7.2-11.9 7.2-19.4v-96c0-17.7-14.3-32-32-32h-50.8l46.1-46.1c13.8-13.8 17.9-34.3 10.4-52.3-7.5-18-24.9-29.6-44.3-29.6H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.8l-73.4 73.4c-3 2.9-5.3 6.5-6.9 10.4-2.1 5.1-2.4 10.5-1.8 15.9L35 226.6c-11.7-6-26.3-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.4l391.9 202.6c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.4 9.3-24.6 0-33.9zM320 374l-104.4-54H320v54zm80-246c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z"]
  },
      LV = {
    prefix: "fas",
    iconName: "sleigh",
    icon: [640, 512, [], "f7cc", "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"]
  },
      AV = {
    prefix: "fas",
    iconName: "sliders-h",
    icon: [512, 512, [], "f1de", "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"]
  },
      NV = {
    prefix: "fas",
    iconName: "sliders-h-square",
    icon: [448, 512, [], "f3f0", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 324c0 6.6-5.4 12-12 12h-52v24c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-24H76c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h180v-24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v24h52c6.6 0 12 5.4 12 12v40zm0-160c0 6.6-5.4 12-12 12H192v24c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-24H76c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h52v-24c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v24h180c6.6 0 12 5.4 12 12v40z"]
  },
      gV = {
    prefix: "fas",
    iconName: "sliders-v",
    icon: [448, 512, [], "f3f1", "M112 96H96V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v80H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h16v336c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V160h16c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm320 128h-16V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v208h-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h16v208c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V288h16c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM272 352h-16V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v336h-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h16v80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-80h16c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"]
  },
      HV = {
    prefix: "fas",
    iconName: "sliders-v-square",
    icon: [448, 512, [], "f3f2", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM200 224h-24v180c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V224H88c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h24v-52c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h24c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24zm184 104c0 13.3-10.7 24-24 24h-24v52c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-52h-24c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h24V108c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v180h24c13.3 0 24 10.7 24 24v16z"]
  },
      VV = {
    prefix: "fas",
    iconName: "smile",
    icon: [496, 512, [], "f118", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"]
  },
      xV = {
    prefix: "fas",
    iconName: "smile-beam",
    icon: [496, 512, [], "f5b8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"]
  },
      wV = {
    prefix: "fas",
    iconName: "smile-plus",
    icon: [640, 512, [], "f5b9", "M208 96C93.1 96 0 189.1 0 304s93.1 208 208 208 208-93.1 208-208S322.9 96 208 96zm64 133.2c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm-128 0c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm164.2 140.9C283.3 399.3 246.8 416 208 416c-38.8 0-75.3-16.7-100.2-45.9-5.8-6.7-5-16.8 1.8-22.5s16.8-5 22.5 1.8c18.8 22 46.5 34.6 75.8 34.6 29.4 0 57-12.6 75.8-34.7 5.8-6.8 15.9-7.5 22.6-1.8 6.8 5.8 7.6 15.9 1.9 22.6zM624 80h-64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16z"]
  },
      yV = {
    prefix: "fas",
    iconName: "smile-wink",
    icon: [496, 512, [], "f4da", "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"]
  },
      bV = {
    prefix: "fas",
    iconName: "smog",
    icon: [640, 512, [], "f75f", "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"]
  },
      SV = {
    prefix: "fas",
    iconName: "smoke",
    icon: [640, 512, [], "f760", "M528 288c-18 0-34.7 4.6-49.7 12.1C454 255 406.8 224 352 224c-41 0-77.8 17.3-104 44.8-26.2-27.5-63-44.8-104-44.8C64.5 224 0 288.5 0 368s64.5 144 144 144h384c61.9 0 112-50.1 112-112s-50.1-112-112-112zM402.4 158.8C380.1 139.9 351.6 128 320 128c-51.7 0-95.9 30.8-116.1 74.8 15.6 5.7 30.6 13.4 44.1 23.4C278 204 314 192 352 192c54.9 0 106 25.9 139 69.1 12.1-3.4 24.5-5.1 37-5.1 35.5 0 67.6 13.4 92.7 34.8 12-19.5 19.3-42.2 19.3-66.8 0-70.7-57.3-128-128-128-46.8 0-87.3 25.3-109.6 62.8zM144 192c9.9 0 19.5.9 29.1 2.5C197.2 136.8 253.7 96 320 96c26.2 0 52 6.7 75.1 19.2 9.3-10.2 20.2-18.4 31.6-25.8C403.8 54.9 364.6 32 320 32c-31.6 0-60.1 11.9-82.4 30.8C215.3 25.3 174.8 0 128 0 57.3 0 0 57.3 0 128c0 38.2 17.1 72.1 43.7 95.6 28.5-19.9 63-31.6 100.3-31.6z"]
  },
      TV = {
    prefix: "fas",
    iconName: "smoking",
    icon: [640, 512, [], "f48d", "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"]
  },
      DV = {
    prefix: "fas",
    iconName: "smoking-ban",
    icon: [512, 512, [], "f54d", "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"]
  },
      jV = {
    prefix: "fas",
    iconName: "sms",
    icon: [512, 512, [], "f7cd", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"]
  },
      EV = {
    prefix: "fas",
    iconName: "snake",
    icon: [640, 512, [], "f716", "M617.4 180.09l-86.59-26.63c-33.39-10.27-66.71 8.26-78.25 38.54H448c-70.69 0-128 57.31-128 128v64c0 17.64-14.36 32-32 32s-32-14.36-32-32V133.7C256 66.89 207.29 7.11 140.79.63 64.49-6.82 0 53.2 0 128v191.53c0 62.18 11.18 123.86 33.02 182.09 5.19 13.84 24.77 13.84 29.96 0A518.514 518.514 0 0 0 96 319.53V128c0-17.64 14.36-32 32-32s32 14.36 32 32v250.3c0 66.81 48.71 126.59 115.21 133.08C351.51 518.82 416 458.8 416 384v-64c0-17.67 14.33-32 32-32h4.2c11.1 30.62 44.38 49.63 77.96 39.69l86.92-25.72c13.59-4.02 22.92-16.51 22.92-30.68v-60.61c0-14.05-9.17-26.46-22.6-30.59zM528 288c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm0-64c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      kV = {
    prefix: "fas",
    iconName: "snooze",
    icon: [448, 512, [], "f880", "M192 224H40a24 24 0 0 0-24 24v48a24 24 0 0 0 24 24h50.44L8.08 412.66A32 32 0 0 0 0 433.92V480a32 32 0 0 0 32 32h152a24 24 0 0 0 24-24v-48a24 24 0 0 0-24-24h-50.44l82.36-92.66a32 32 0 0 0 8.08-21.26V256a32 32 0 0 0-32-32zm0-32h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-34.75l57.38-57.38A32 32 0 0 0 320 48V32a32 32 0 0 0-32-32H184a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h42.75l-57.38 57.38A32 32 0 0 0 160 144v16a32 32 0 0 0 32 32zm256 80v-16a32 32 0 0 0-32-32h-96a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h34.75l-57.38 57.38A32 32 0 0 0 288 368v16a32 32 0 0 0 32 32h104a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-42.75l57.38-57.38A32 32 0 0 0 448 272z"]
  },
      IV = {
    prefix: "fas",
    iconName: "snow-blowing",
    icon: [640, 512, [], "f761", "M540.2 320H361.7c-6.3 0-12.5 1.9-17.8 5.4l-44 29.3c-13.2 8.8-7 29.3 8.9 29.3h233.3c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1h-32.8c-10 0-17.7 9.3-15.7 19.1 8.9 43.8 47.7 76.9 94.1 76.9 59.2 0 106-53.8 94.1-115.1-8.7-45.6-51.4-76.9-97.8-76.9zM400 288h144c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1 4.2-12.7 16.3-21.9 30.4-21.9 19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H400c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm-99.5 21.2l-5.5-20.4 26.6 15.3c5.8 3.4 13.2 1.4 16.6-4.4l12.1-21c3.4-5.8 1.4-13.2-4.4-16.6l-26.6-15.3 20.4-5.5c6.5-1.7 10.3-8.4 8.6-14.9l-3.1-11.7c-1.7-6.5-8.4-10.3-14.9-8.6L274.7 221l-50.2-29 50.2-29 55.6 14.9c6.5 1.7 13.1-2.1 14.9-8.6l3.1-11.7c1.7-6.5-2.1-13.1-8.6-14.9l-20.4-5.5 26.6-15.3c5.8-3.4 7.8-10.8 4.4-16.6l-12.1-21c-3.4-5.8-10.8-7.8-16.6-4.4L295 95.2l5.5-20.4c1.7-6.5-2.1-13.1-8.6-14.9l-11.7-3.1c-6.5-1.7-13.1 2.1-14.9 8.6L250.4 121 200 150.1V93.2L240.2 53c4.7-4.7 4.7-12.3 0-17l-8.5-8.5c-4.7-4.7-12.3-4.7-17 0L200 42.3V12c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v30.3l-14.8-14.8c-4.7-4.7-12.3-4.7-17 0l-8.5 8.5c-4.7 4.7-4.7 12.3 0 17L152 93.2v56.9L101.6 121l-15-55.7c-1.7-6.5-8.4-10.3-14.9-8.6L60 59.9c-6.5 1.7-10.3 8.4-8.6 14.9l5.5 20.4-26.5-15.3c-5.8-3.4-13.2-1.4-16.6 4.4l-12.1 21c-3.4 5.8-1.4 13.2 4.4 16.6l26.6 15.3-20.4 5.5c-6.5 1.7-10.3 8.4-8.6 14.9l3.1 11.7c1.7 6.5 8.4 10.3 14.9 8.6L77.3 163l50.2 29-50.2 29-55.7-15c-6.5-1.7-13.1 2.1-14.9 8.6l-3.1 11.7c-1.7 6.5 2.1 13.1 8.6 14.9l20.4 5.5-26.5 15.4c-5.8 3.4-7.8 10.8-4.4 16.6l12.1 21c3.4 5.8 10.8 7.8 16.6 4.4L57 288.8l-5.5 20.4c-1.7 6.5 2.1 13.1 8.6 14.9l11.7 3.1c6.5 1.7 13.1-2.1 14.9-8.6l14.9-55.6 50.4-29.1v56.9L111.8 331c-4.7 4.7-4.7 12.3 0 17l8.5 8.5c4.7 4.7 12.3 4.7 17 0l14.8-14.8V372c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-30.3l14.8 14.8c4.7 4.7 12.3 4.7 17 0l8.5-8.5c4.7-4.7 4.7-12.3 0-17L200 290.8v-56.9l50.4 29.1 14.9 55.6c1.7 6.5 8.4 10.3 14.9 8.6l11.7-3.1c6.5-1.7 10.4-8.4 8.6-14.9z"]
  },
      OV = {
    prefix: "fas",
    iconName: "snowboarding",
    icon: [512, 512, [], "f7ce", "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"]
  },
      QV = {
    prefix: "fas",
    iconName: "snowflake",
    icon: [448, 512, [], "f2dc", "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"]
  },
      ZV = {
    prefix: "fas",
    iconName: "snowflakes",
    icon: [640, 512, [], "f7cf", "M608.1 256l27.9-16c3.8-2.2 5.1-7.1 2.9-10.9l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V200c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V312c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-28.4l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9l-27.9-16zM445.9 145.7l-15.5-26.8c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.3v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.2 6.2-6.2 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.2 6.2-6.2 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.4 1.7-16.8-5.7-21.1l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.8-36.9 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.5-4.3 10-13.8 5.7-21.2zm82-25.7c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V91.6l28 16.1c3.8 2.2 8.7.9 10.9-2.9l8-13.9c2.2-3.8.9-8.7-2.9-10.9L576 64l27.9-16c3.8-2.2 5.1-7.1 2.9-10.9l-8-13.9c-2.2-3.8-7.1-5.1-10.9-2.9l-28 16.1V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v28.4l-28-16.1c-3.8-2.2-8.7-.9-10.9 2.9l-8 13.9c-2.2 3.8-.9 8.7 2.9 10.9l27.9 16-27.9 16c-3.8 2.2-5.1 7.1-2.9 10.9l8 13.9c2.2 3.8 7.1 5.1 10.9 2.9l28-16.1V120z"]
  },
      UV = {
    prefix: "fas",
    iconName: "snowman",
    icon: [512, 512, [], "f7d0", "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      BV = {
    prefix: "fas",
    iconName: "snowmobile",
    icon: [640, 512, [], "f7d1", "M636.8 446.4l-9.6-12.8c-5.3-7.1-15.3-8.5-22.4-3.2L570.7 456c-6.9 5.2-15.3 8-24 8h-.7l-46-61.3 68.9-45.9c4.5-3 7.1-8 7.1-13.3V266c0-6.1-3.4-11.6-8.8-14.3L407.9 172l-41.5-83.1c-4-7.9-13.5-11.1-21.5-7.2-7.9 4-11.1 13.6-7.2 21.5l35.6 71.2L360 192h-58.7L246 136.8c-14.5-14.5-35.2-21.2-55.5-17.9-20.2 3.3-37.8 16.2-47 34.5l-29.8 59.7c-7.6 15.3-8.9 32.6-3.5 48.9 3.4 10.2 9.4 18.9 16.9 26.1H96c-12.1 0-23.2 6.8-28.6 17.7l-32 64C24.7 391 40.2 416 64 416h386l36 48h-54c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h114.7c19 0 37.6-6.2 52.8-17.6l34.1-25.6c7.1-5.3 8.5-15.3 3.2-22.4zM288 288h-24.4l-67-33.5 25.6-51.1 33.9 33.9c12.1 12.1 28.2 18.8 45.2 18.8H312L288 288zM240 96c26.5 0 48-21.5 48-48S266.5 0 240 0s-48 21.5-48 48 21.5 48 48 48zm48 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h256c17.7 0 32-14.3 32-32s-14.3-32-32-32z"]
  },
      RV = {
    prefix: "fas",
    iconName: "snowplow",
    icon: [640, 512, [], "f7d2", "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"]
  },
      YV = {
    prefix: "fas",
    iconName: "soap",
    icon: [512, 512, [], "e06e", "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"]
  },
      PV = {
    prefix: "fas",
    iconName: "socks",
    icon: [512, 512, [], "f696", "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"]
  },
      FV = {
    prefix: "fas",
    iconName: "solar-panel",
    icon: [640, 512, [], "f5ba", "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"]
  },
      WV = {
    prefix: "fas",
    iconName: "solar-system",
    icon: [512, 512, [], "e02f", "M391.77844,120.23438c-16.64439-16.64258-42.06121-17.63868-60.76247-4.73047C307.55639,102.98633,281.92079,96,256,96A160,160,0,1,0,369.149,369.13672c51.02312-51.01758,59.65883-127.62891,27.36235-188.14453C409.421,162.291,408.42283,136.877,391.77844,120.23438ZM335.20393,335.19531a112.44148,112.44148,0,1,1-24.47337-176.39062c1.047,10.668,4.98687,21.14062,13.15964,29.3125,8.163,8.16211,18.62312,12.0957,29.27857,13.15039C377.15966,243.93945,371.48131,298.92383,335.20393,335.19531ZM256,192a64,64,0,1,0,64.007,64A64.00289,64.00289,0,0,0,256,192Zm80.90528,255.67773a208.24661,208.24661,0,0,1-227.9994-44.59961C39.328,333.50781,29.62381,226.59766,79.41829,146.38672a56.05613,56.05613,0,1,0-37.799-30.34375c-64.97,99.2832-53.88672,233.75781,33.34152,320.97656A255.17414,255.17414,0,0,0,364.422,487.65039c-2.19165-1.80273-4.5376-3.32812-6.58665-5.377A86.91321,86.91321,0,0,1,336.90528,447.67773ZM437.03922,74.98047A255.17108,255.17108,0,0,0,147.58,24.34961c2.19165,1.80273,4.53761,3.32812,6.5847,5.375a86.87534,86.87534,0,0,1,20.93,34.59766,208.24661,208.24661,0,0,1,227.9994,44.59961c69.57593,69.56835,79.28011,176.47851,29.48759,256.68945a56.05819,56.05819,0,1,0,37.799,30.3457C535.3507,296.67383,524.26746,162.19922,437.03922,74.98047Z"]
  },
      GV = {
    prefix: "fas",
    iconName: "sort",
    icon: [320, 512, [], "f0dc", "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"]
  },
      qV = {
    prefix: "fas",
    iconName: "sort-alpha-down",
    icon: [448, 512, [], "f15d", "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"]
  },
      JV = {
    prefix: "fas",
    iconName: "sort-alpha-down-alt",
    icon: [448, 512, [], "f881", "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"]
  },
      KV = {
    prefix: "fas",
    iconName: "sort-alpha-up",
    icon: [448, 512, [], "f15e", "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"]
  },
      XV = {
    prefix: "fas",
    iconName: "sort-alpha-up-alt",
    icon: [448, 512, [], "f882", "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"]
  },
      _V = {
    prefix: "fas",
    iconName: "sort-alt",
    icon: [384, 512, [], "f883", "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm203.29-219.31l-80-96a16 16 0 0 0-22.62 0l-80 96C186.65 142.74 193.78 160 208 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.19 0 21.36-17.24 11.29-27.31z"]
  },
      $V = {
    prefix: "fas",
    iconName: "sort-amount-down",
    icon: [512, 512, [], "f160", "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      cx = {
    prefix: "fas",
    iconName: "sort-amount-down-alt",
    icon: [512, 512, [], "f884", "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"]
  },
      ex = {
    prefix: "fas",
    iconName: "sort-amount-up",
    icon: [512, 512, [], "f161", "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      ax = {
    prefix: "fas",
    iconName: "sort-amount-up-alt",
    icon: [512, 512, [], "f885", "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"]
  },
      nx = {
    prefix: "fas",
    iconName: "sort-circle",
    icon: [512, 512, [], "e030", "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM360.57,319.41l-91.5,91.18a18.41,18.41,0,0,1-26.07,0l-91.57-91.18C139.83,307.85,148,288,164.5,288h183C364,288,372.17,307.85,360.57,319.41ZM347.5,224h-183c-16.46,0-24.67-19.85-13.07-31.42L243,101.41a18.41,18.41,0,0,1,26.07,0l91.5,91.17C372.17,204.15,364,224,347.5,224Z"]
  },
      tx = {
    prefix: "fas",
    iconName: "sort-circle-down",
    icon: [512, 512, [], "e031", "M197.7,192H314.41L256,133.67ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM360.57,319.42,269,410.59a18.41,18.41,0,0,1-26.07,0l-91.5-91.17C139.83,307.85,148,288,164.5,288h183C364,288,372.17,307.85,360.57,319.42ZM347.5,224h-183c-16.46,0-24.67-19.85-13.07-31.42l91.5-91.17a18.41,18.41,0,0,1,26.07,0l91.57,91.17C372.17,204.15,364,224,347.5,224Z"]
  },
      rx = {
    prefix: "fas",
    iconName: "sort-circle-up",
    icon: [512, 512, [], "e032", "M256,378.33,314.3,320H197.59ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM151.43,192.58,243,101.41a18.41,18.41,0,0,1,26.07,0l91.5,91.17C372.17,204.15,364,224,347.5,224h-183C148,224,139.83,204.15,151.43,192.58ZM360.57,319.42l-91.5,91.17a18.41,18.41,0,0,1-26.07,0l-91.57-91.17C139.83,307.85,148,288,164.5,288h183C364,288,372.17,307.85,360.57,319.42Z"]
  },
      ix = {
    prefix: "fas",
    iconName: "sort-down",
    icon: [320, 512, [], "f0dd", "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"]
  },
      ox = {
    prefix: "fas",
    iconName: "sort-numeric-down",
    icon: [448, 512, [], "f162", "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"]
  },
      lx = {
    prefix: "fas",
    iconName: "sort-numeric-down-alt",
    icon: [448, 512, [], "f886", "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"]
  },
      fx = {
    prefix: "fas",
    iconName: "sort-numeric-up",
    icon: [448, 512, [], "f163", "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"]
  },
      sx = {
    prefix: "fas",
    iconName: "sort-numeric-up-alt",
    icon: [448, 512, [], "f887", "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"]
  },
      ux = {
    prefix: "fas",
    iconName: "sort-shapes-down",
    icon: [448, 512, [], "f888", "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm268.1-169.14L361 45.71c-11.09-18.28-38.81-18.28-49.9 0l-83.2 137.15c-11.08 18.28 2.77 41.14 24.95 41.14h166.3c22.18 0 36.03-22.86 24.95-41.14zM408 288H264a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h144a24 24 0 0 0 24-24V312a24 24 0 0 0-24-24z"]
  },
      hx = {
    prefix: "fas",
    iconName: "sort-shapes-down-alt",
    icon: [448, 512, [], "f889", "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm268.1 86.86L361 301.71c-11.09-18.28-38.81-18.28-49.9 0l-83.2 137.15c-11.08 18.28 2.77 41.14 24.95 41.14h166.3c22.18 0 36.03-22.86 24.95-41.14zM264 224h144a24 24 0 0 0 24-24V56a24 24 0 0 0-24-24H264a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24z"]
  },
      mx = {
    prefix: "fas",
    iconName: "sort-shapes-up",
    icon: [448, 512, [], "f88a", "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31zM444.1 182.86L361 45.71c-11.09-18.28-38.81-18.28-49.9 0l-83.2 137.15c-11.08 18.28 2.77 41.14 24.95 41.14h166.3c22.18 0 36.03-22.86 24.95-41.14zM408 288H264a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h144a24 24 0 0 0 24-24V312a24 24 0 0 0-24-24z"]
  },
      vx = {
    prefix: "fas",
    iconName: "sort-shapes-up-alt",
    icon: [448, 512, [], "f88b", "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31zM444.1 438.86L361 301.71c-11.09-18.28-38.81-18.28-49.9 0l-83.2 137.15c-11.08 18.28 2.77 41.14 24.95 41.14h166.3c22.18 0 36.03-22.86 24.95-41.14zM264 224h144a24 24 0 0 0 24-24V56a24 24 0 0 0-24-24H264a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24z"]
  },
      dx = {
    prefix: "fas",
    iconName: "sort-size-down",
    icon: [512, 512, [], "f88c", "M428 320H276a20 20 0 0 0-20 20v120a20 20 0 0 0 20 20h152a20 20 0 0 0 20-20V340a20 20 0 0 0-20-20zm-252 32h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zM484 32H284a28 28 0 0 0-28 28v168a28 28 0 0 0 28 28h200a28 28 0 0 0 28-28V60a28 28 0 0 0-28-28z"]
  },
      Mx = {
    prefix: "fas",
    iconName: "sort-size-down-alt",
    icon: [512, 512, [], "f88d", "M275.9 192h152.2a20 20 0 0 0 19.9-20V52a20 20 0 0 0-19.9-20H275.9A20 20 0 0 0 256 52v120a20 20 0 0 0 19.9 20zM484 256H284a28 28 0 0 0-28 28v168a28 28 0 0 0 28 28h200a28 28 0 0 0 28-28V284a28 28 0 0 0-28-28zm-308 96h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"]
  },
      px = {
    prefix: "fas",
    iconName: "sort-size-up",
    icon: [512, 512, [], "f88e", "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM484 32H284a28 28 0 0 0-28 28v168a28 28 0 0 0 28 28h200a28 28 0 0 0 28-28V60a28 28 0 0 0-28-28zm-56 288H276a20 20 0 0 0-20 20v120a20 20 0 0 0 20 20h152a20 20 0 0 0 20-20V340a20 20 0 0 0-20-20z"]
  },
      zx = {
    prefix: "fas",
    iconName: "sort-size-up-alt",
    icon: [512, 512, [], "f88f", "M276 192h152a20 20 0 0 0 20-20V52a20 20 0 0 0-20-20H276a20 20 0 0 0-20 20v120a20 20 0 0 0 20 20zm208 64H284a28 28 0 0 0-28 28v168a28 28 0 0 0 28 28h200a28 28 0 0 0 28-28V284a28 28 0 0 0-28-28zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"]
  },
      Cx = {
    prefix: "fas",
    iconName: "sort-up",
    icon: [320, 512, [], "f0de", "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"]
  },
      Lx = {
    prefix: "fas",
    iconName: "soup",
    icon: [512, 512, [], "f823", "M191.11 146.5a16.23 16.23 0 0 0 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18a130.72 130.72 0 0 0-36.6-74.7 94.83 94.83 0 0 1-26.4-53.5A16.11 16.11 0 0 0 160.81 0h-16.4a16.31 16.31 0 0 0-16.3 18 145.36 145.36 0 0 0 40.6 84.4 81.22 81.22 0 0 1 22.4 44.1zm112 0a16.23 16.23 0 0 0 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18a130.72 130.72 0 0 0-36.6-74.7 94.83 94.83 0 0 1-26.4-53.5A16.11 16.11 0 0 0 272.76 0h-16.4c-9.8 0-17.5 8.5-16.3 18a145.36 145.36 0 0 0 40.6 84.4 81.22 81.22 0 0 1 22.4 44.1zM480 192H32a32 32 0 0 0-32 32c0 94.7 51.56 177.16 128 221.45V480a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32v-34.55C460.44 401.16 512 318.7 512 224a32 32 0 0 0-32-32z"]
  },
      Ax = {
    prefix: "fas",
    iconName: "spa",
    icon: [576, 512, [], "f5bb", "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"]
  },
      Nx = {
    prefix: "fas",
    iconName: "space-shuttle",
    icon: [640, 512, [], "f197", "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"]
  },
      gx = {
    prefix: "fas",
    iconName: "space-station-moon",
    icon: [512, 512, [], "e033", "M256,8C119.0332,8,8,119.0332,8,256a250.01609,250.01609,0,0,0,1.72461,28.26562C81.19727,306.76953,165.47852,320,256,320s174.80273-13.23047,246.27539-35.73438A250.01609,250.01609,0,0,0,504,256C504,119.0332,392.9668,8,256,8ZM192,240a80,80,0,1,1,80-80A80.00021,80.00021,0,0,1,192,240ZM16.71094,320.26367C45.05859,426.01953,141.29883,504,256,504s210.94141-77.98047,239.28906-183.73633C424.71289,340.53906,343.3418,352,256,352S87.28711,340.53906,16.71094,320.26367ZM192,136a24,24,0,1,0,24,24A23.99993,23.99993,0,0,0,192,136Z"]
  },
      Hx = {
    prefix: "fas",
    iconName: "space-station-moon-alt",
    icon: [512, 512, [], "e034", "M192,136a24,24,0,1,0,24,24A23.99993,23.99993,0,0,0,192,136ZM384,343.13867A940.38216,940.38216,0,0,1,256,352c-87.3418,0-168.71289-11.46094-239.28906-31.73633C45.05859,426.01953,141.29883,504,256,504a247.46107,247.46107,0,0,0,192-91.0918V384H384ZM501.70508,224H448V160H368V96h48V66.67383A246.86934,246.86934,0,0,0,256,8C119.0332,8,8,119.0332,8,256a250.01609,250.01609,0,0,0,1.72461,28.26562C81.19727,306.76953,165.47852,320,256,320s174.80273-13.23047,246.27539-35.73438A250.01609,250.01609,0,0,0,504,256,249.15161,249.15161,0,0,0,501.70508,224ZM192,240a80,80,0,1,1,80-80A80.00021,80.00021,0,0,1,192,240Z"]
  },
      Vx = {
    prefix: "fas",
    iconName: "spade",
    icon: [512, 512, [], "f2f4", "M272.5 6.6c-9.3-8.8-23.8-8.8-33.1 0C191.4 52.4 53.6 185 32 208.9c-19.3 21.3-32 49.4-32 80.6C0 360 54.9 415.7 123.5 416c36.7.1 69.7-15.7 92.5-40.9-.1 36.6-.8 52.3-52.4 75.4-14.1 6.3-22.2 21.6-18.7 36.6 3.3 14.5 16.3 24.8 31.2 24.8h159.4c15.5 0 29.2-10.8 32.1-26 2.8-14.6-4.8-29.2-18.4-35.2-51.6-23-52.8-38.1-53-75.6 23.4 25.8 57.5 41.8 95.3 40.8 67.5-1.7 120.7-56.5 120.7-124 0-32.2-12.2-61.2-32-83.1C458.4 185 320.6 52.4 272.5 6.6z"]
  },
      xx = {
    prefix: "fas",
    iconName: "sparkles",
    icon: [512, 512, [], "f890", "M324.42 103.15L384 128l24.84 59.58a8 8 0 0 0 14.32 0L448 128l59.58-24.85a8 8 0 0 0 0-14.31L448 64 423.16 4.42a8 8 0 0 0-14.32 0L384 64l-59.58 24.84a8 8 0 0 0 0 14.31zm183.16 305.69L448 384l-24.84-59.58a8 8 0 0 0-14.32 0L384 384l-59.58 24.84a8 8 0 0 0 0 14.32L384 448l24.84 59.58a8 8 0 0 0 14.32 0L448 448l59.58-24.84a8 8 0 0 0 0-14.32zM384 255.64a16.06 16.06 0 0 0-8.84-14.33l-112.57-56.39-56.28-112.77c-5.44-10.87-23.19-10.87-28.62 0l-56.28 112.77L8.84 241.31a16 16 0 0 0 0 28.67l112.57 56.39 56.28 112.77a16 16 0 0 0 28.62 0l56.28-112.77L375.16 270a16.07 16.07 0 0 0 8.84-14.36z"]
  },
      wx = {
    prefix: "fas",
    iconName: "speaker",
    icon: [384, 512, [], "f8df", "M192 272a64 64 0 1 0 64 64 64 64 0 0 0-64-64zM336 0H48A48 48 0 0 0 0 48v416a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zM192 64a48 48 0 1 1-48 48 48 48 0 0 1 48-48zm0 384a112 112 0 1 1 112-112 112 112 0 0 1-112 112z"]
  },
      yx = {
    prefix: "fas",
    iconName: "speakers",
    icon: [640, 512, [], "f8e0", "M591 0H335a48 48 0 0 0-48 48v416a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zM463 64a48 48 0 1 1-48 48 48 48 0 0 1 48-48zm0 384a112 112 0 1 1 112-112 112 112 0 0 1-112 112zm0-176a64 64 0 1 0 64 64 64 64 0 0 0-64-64zM255 48a79.24 79.24 0 0 1 16.41-48H47A48 48 0 0 0-1 48v416a48 48 0 0 0 48 48h224.41A79.24 79.24 0 0 1 255 464v-49.78a112 112 0 1 1 0-156.44zm-80 112a48 48 0 1 1 48-48 48 48 0 0 1-48 48zm-64 176a64 64 0 1 0 64-64 64 64 0 0 0-64 64z"]
  },
      bx = {
    prefix: "fas",
    iconName: "spell-check",
    icon: [576, 512, [], "f891", "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"]
  },
      Sx = {
    prefix: "fas",
    iconName: "spider",
    icon: [576, 512, [], "f717", "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"]
  },
      Tx = {
    prefix: "fas",
    iconName: "spider-black-widow",
    icon: [576, 512, [], "f718", "M382.29 26.13c-2.79-8.38 1.73-17.44 10.12-20.24L407.58.83c8.38-2.8 17.45 1.73 20.24 10.12l25.89 77.68a32.04 32.04 0 0 1-1.73 24.43l-27.15 54.3L398.9 176h-4.67l-5.22-26.12c-.71-3.58-1.8-7.58-3.21-11.79l20.29-40.58-23.8-71.38zM151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm417.7 204.21l-13.31 8.88c-7.35 4.9-17.29 2.91-22.19-4.44l-48-72h-47.06l60.83 97.33a31.988 31.988 0 0 1 4.86 16.96V496c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-73.11l-74.08-118.53c1.01 14.05 2.08 28.11 2.08 42.21C384 399.64 343.24 448 288 448s-96-48.36-96-101.43c0-14.1 1.08-28.16 2.08-42.21L120 422.89V496c0 8.84-7.16 16-16 16H88c-8.84 0-16-7.16-16-16v-77.71c0-6 1.69-11.88 4.86-16.96L137.69 304H90.63l-48 72c-4.9 7.35-14.84 9.34-22.19 4.44l-13.31-8.88c-7.35-4.9-9.34-14.84-4.44-22.19l52.75-79.12A32.007 32.007 0 0 1 82.07 256H160l-68.99-24.36a32.03 32.03 0 0 1-16.51-12.61l-53.6-80.41c-4.9-7.35-2.91-17.29 4.44-22.19l13.31-8.88c7.35-4.9 17.29-2.91 22.19 4.44l50.56 75.83L171.9 208H208l10.37-51.85C220.56 145.18 235.74 96 288 96c52.26 0 67.44 49.18 69.63 60.15L368 208h36.1l60.49-20.17L515.16 112c4.9-7.35 14.83-9.34 22.19-4.44l13.31 8.88c7.35 4.9 9.34 14.83 4.44 22.19l-53.6 80.41a32.03 32.03 0 0 1-16.51 12.61L416 256h77.94c10.7 0 20.69 5.35 26.62 14.25l52.75 79.12c4.9 7.36 2.92 17.29-4.44 22.19zM300 320l26.4-35.2c3.96-5.27.19-12.8-6.4-12.8h-64c-6.59 0-10.36 7.53-6.4 12.8L276 320l-26.4 35.2c-3.96 5.27-.19 12.8 6.4 12.8h64c6.59 0 10.36-7.53 6.4-12.8L300 320z"]
  },
      Dx = {
    prefix: "fas",
    iconName: "spider-web",
    icon: [576, 512, [], "f719", "M567.16 233.86c-56.54-59.32-97.92-131.64-120.56-210.71l-.02-.06c-4.72-16.48-21.5-26.26-38-22.14l-.07.02a497.663 497.663 0 0 1-241.03 0l-.07-.02c-16.5-4.12-33.28 5.66-38 22.14l-.02.06C106.76 102.22 65.38 174.54 8.84 233.86c-11.79 12.37-11.79 31.92 0 44.29 56.54 59.32 97.92 131.64 120.56 210.71l.02.06c4.72 16.48 21.5 26.26 38 22.14l.07-.02a497.663 497.663 0 0 1 241.03 0l.07.02c16.5 4.12 33.28-5.66 38-22.14l.03-.12c22.63-79.04 63.99-151.32 120.5-210.62l.04-.04c11.79-12.36 11.79-31.92 0-44.28zM365.54 73.71l-23.52 40.74a264.971 264.971 0 0 1-108.04 0l-23.52-40.74a563.283 563.283 0 0 0 155.08 0zM288 208.01l-23.43-40.58a313.24 313.24 0 0 0 46.86 0L288 208.01zM302.43 232h-.58l-.29-.5.87.5zM288 303.99l23.44 40.59c-7.8-.58-15.62-.99-23.44-.99s-15.63.41-23.44.99L288 303.99zm-65-112.58L246.43 232h-46.87c8.81-12.93 16.65-26.5 23.44-40.59zm-53.39 221.65A574.3 574.3 0 0 0 93.29 280h45.11c24.22 27.11 42.66 59.04 54.01 93.56l-22.8 39.5zM138.4 232H93.29a574.3 574.3 0 0 0 76.32-133.06l22.81 39.5A264.912 264.912 0 0 1 138.4 232zm108.03 48L223 320.59A314.825 314.825 0 0 0 199.56 280h46.87zM288 432.28c-25.95 0-51.82 2.43-77.54 6.01l23.52-40.73c35.58-7.42 72.45-7.42 108.04 0l23.52 40.73c-25.72-3.58-51.59-6.01-77.54-6.01zm65-111.69L329.57 280h46.87A314.825 314.825 0 0 0 353 320.59zM329.56 232L353 191.41A314.825 314.825 0 0 0 376.44 232h-46.88zm76.83 181.06l-22.81-39.5c11.35-34.52 29.8-66.45 54.02-93.56h45.11a574.3 574.3 0 0 0-76.32 133.06zM437.6 232a264.912 264.912 0 0 1-54.02-93.56l22.81-39.5A574.3 574.3 0 0 0 482.71 232H437.6z"]
  },
      jx = {
    prefix: "fas",
    iconName: "spinner",
    icon: [512, 512, [], "f110", "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"]
  },
      Ex = {
    prefix: "fas",
    iconName: "spinner-third",
    icon: [512, 512, [], "f3f4", "M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z"]
  },
      kx = {
    prefix: "fas",
    iconName: "splotch",
    icon: [512, 512, [], "f5bc", "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"]
  },
      Ix = {
    prefix: "fas",
    iconName: "spray-can",
    icon: [512, 512, [], "f5bd", "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
  },
      Ox = {
    prefix: "fas",
    iconName: "sprinkler",
    icon: [512, 512, [], "e035", "M398.19,256H288V80a16,16,0,0,0-16-16H240a16,16,0,0,0-16,16V256H113.81a17.77,17.77,0,0,0-14.22,28.44l67.52,78.23L192,387.56V512H320V387.56l24.89-24.89,67.52-78.23A17.77,17.77,0,0,0,398.19,256ZM152,152a24,24,0,1,0-24-24A24,24,0,0,0,152,152ZM88,96A24,24,0,1,0,64,72,24,24,0,0,0,88,96Zm24,72a24,24,0,1,0-24,24A24,24,0,0,0,112,168ZM24,104a24,24,0,1,0,24,24A24,24,0,0,0,24,104ZM24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0Zm0,208a24,24,0,1,0,24,24A24,24,0,0,0,24,208Zm336-56a24,24,0,1,0-24-24A24,24,0,0,0,360,152Zm64,8a24,24,0,1,0,24,24A24,24,0,0,0,424,160Zm0-96a24,24,0,1,0,24,24A24,24,0,0,0,424,64Zm64,40a24,24,0,1,0,24,24A24,24,0,0,0,488,104Zm0,104a24,24,0,1,0,24,24A24,24,0,0,0,488,208Zm0-160a24,24,0,1,0-24-24A24,24,0,0,0,488,48Z"]
  },
      Qx = {
    prefix: "fas",
    iconName: "square",
    icon: [448, 512, [], "f0c8", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"]
  },
      Zx = {
    prefix: "fas",
    iconName: "square-full",
    icon: [512, 512, [], "f45c", "M512 512H0V0h512v512z"]
  },
      Ux = {
    prefix: "fas",
    iconName: "square-root",
    icon: [576, 512, [], "f697", "M552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"]
  },
      Bx = {
    prefix: "fas",
    iconName: "square-root-alt",
    icon: [576, 512, [], "f698", "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"]
  },
      Rx = {
    prefix: "fas",
    iconName: "squirrel",
    icon: [512, 512, [], "f71a", "M479.85 448h-30.93c18.19-18.4 30.93-42.12 30.93-64 0-26.55-22.08-52.81-47.85-61.09V224h47.85c20.4 0 35.7-18.91 31.43-38.87C500.84 136.42 466.72 96 415.87 96V64c-48.01 0-74.22 62.73-89.4 108.29l-65.34 196.52c-1.39 4.19-5.92 6.46-10.11 5.07l-15.19-5.05c-4.19-1.39-6.46-5.92-5.07-10.12l34.53-103.85C312.5 112.89 214.16 0 127.96 0 57.29 0 0 57.31 0 128s57.29 128 127.96 128c.27 0 .52-.08.79-.08-20.93 27.67-33.56 61.96-32.74 99.54C97.94 443.88 175.85 512 264.27 512h231.58c8.83 0 15.99-7.16 15.99-16v-16c0-17.67-14.32-32-31.99-32zm-47.98-304c8.83 0 15.99 7.16 15.99 16s-7.16 16-15.99 16-16-7.16-16-16 7.17-16 16-16z"]
  },
      Yx = {
    prefix: "fas",
    iconName: "staff",
    icon: [512, 512, [], "f71b", "M432 0h-76.23c-30.3 0-58 17.12-71.55 44.22l-16 32c-3.95 7.9-.75 17.51 7.15 21.46l57.25 28.63c7.9 3.95 17.51.75 21.47-7.16L365.67 96H416v75.8l-157.29 44.94a176.122 176.122 0 0 0-76.11 44.78L156.12 288H112c-8.84 0-16 7.16-16 16v44.12L7.03 437.1c-9.37 9.37-9.37 24.57 0 33.94l33.93 33.93c9.37 9.37 24.57 9.37 33.94 0l175.55-175.55a80.111 80.111 0 0 1 34.62-20.37l84.82-24.24 32.25 18.62c7.65 4.42 17.44 1.79 21.86-5.86l19.51-33.8 10.46-2.99c34.34-9.81 58.02-41.21 58.02-76.92V80C512 35.82 476.18 0 432 0z"]
  },
      Px = {
    prefix: "fas",
    iconName: "stamp",
    icon: [512, 512, [], "f5bf", "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"]
  },
      Fx = {
    prefix: "fas",
    iconName: "star",
    icon: [576, 512, [], "f005", "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"]
  },
      Wx = {
    prefix: "fas",
    iconName: "star-and-crescent",
    icon: [512, 512, [], "f699", "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"]
  },
      Gx = {
    prefix: "fas",
    iconName: "star-christmas",
    icon: [512, 512, [], "f7d4", "M505.3 247.4l-192.5-48.1L264.6 6.7c-2.2-9-15-9-17.2 0l-48.1 192.6L6.7 247.4c-9 2.2-9 15 0 17.2l192.5 48.1 48.1 192.5c2.2 9 15 9 17.2 0l48.1-192.5 192.6-48.1c9-2.2 9-15 .1-17.2zm-352.4-69.5l19.9-5 5-19.9L109 97.9c-7.5-6-17.2 3.7-11.2 11.2l55.1 68.8zm206.2 156.2l-19.9 5-5 19.9 68.8 55.1c7.5 6 17.2-3.7 11.2-11.2l-55.1-68.8zm0-156.2l55.1-68.8c6-7.5-3.7-17.2-11.2-11.2l-68.8 55 5 19.9 19.9 5.1zM152.9 334.1l-55 68.8c-6 7.5 3.7 17.2 11.2 11.2l68.8-55.1-5-19.9-20-5z"]
  },
      qx = {
    prefix: "fas",
    iconName: "star-exclamation",
    icon: [576, 512, [], "f2f3", "M259.3 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6l130.7 68.7c23.3 12.3 50.9-7.5 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8C305-5.9 271.1-6 259.3 17.8zM256.1 160h64c4.7 0 8.4 4.1 8 8.6l-8 112c-.3 4.2-3.8 7.4-8 7.4h-48c-4.2 0-7.7-3.2-8-7.4l-8-112c-.5-4.7 3.5-8.6 8-8.6zM288 392c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"]
  },
      Jx = {
    prefix: "fas",
    iconName: "star-half",
    icon: [576, 512, [], "f089", "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"]
  },
      Kx = {
    prefix: "fas",
    iconName: "star-half-alt",
    icon: [536, 512, [], "f5c0", "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"]
  },
      Xx = {
    prefix: "fas",
    iconName: "star-of-david",
    icon: [464, 512, [], "f69a", "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"]
  },
      _x = {
    prefix: "fas",
    iconName: "star-of-life",
    icon: [480, 512, [], "f621", "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"]
  },
      $x = {
    prefix: "fas",
    iconName: "star-shooting",
    icon: [512, 512, [], "e036", "M308.68131,191.99637l11.31076,11.30812a15.9975,15.9975,0,0,0,22.62737,0L507.31388,38.62192a15.99872,15.99872,0,0,0,0-22.626L496.00312,4.68584a16.001,16.001,0,0,0-22.62737,0L308.68131,169.36841A16.00107,16.00107,0,0,0,308.68131,191.99637ZM239.99059,91.30917a15.9975,15.9975,0,0,0,22.62737,0l52.69238-52.68725a15.99872,15.99872,0,0,0,0-22.626L303.99958,4.68584a16.001,16.001,0,0,0-22.62737,0L228.67984,57.37309a16.00105,16.00105,0,0,0,0,22.628ZM496.00312,196.67782a16.001,16.001,0,0,0-22.62737,0l-52.69237,52.68725a16.00105,16.00105,0,0,0,0,22.628l11.31075,11.30812a15.9975,15.9975,0,0,0,22.62737,0l52.69238-52.68725a15.99872,15.99872,0,0,0,0-22.626ZM364.29366,267.28619,259.49486,251.99l-46.90712-95.19915c-8.39078-16.99929-32.6881-17.20241-41.18826,0L124.49237,251.99,19.69356,267.28619C.89634,269.98921-6.71318,293.19136,6.9902,306.48768l75.90765,73.99691L64.89752,485.074c-3.20319,18.90546,16.68781,33.108,33.29749,24.20211l93.7986-49.38856,93.79861,49.38856A22.95373,22.95373,0,0,0,319.08971,485.074l-17.891-104.58938,75.892-73.99691C390.7004,293.19136,383.09089,269.98921,364.29366,267.28619Z"]
  },
      cw = {
    prefix: "fas",
    iconName: "starfighter",
    icon: [640, 512, [], "e037", "M208,288H144a15.99985,15.99985,0,0,0-16,16v48H48V160h8a8.00008,8.00008,0,0,0,8-8V136a7.99977,7.99977,0,0,0-8-8H48V112.85547c0-7.96924-5.44531-15.356-13.311-16.63623A16.01034,16.01034,0,0,0,16,112v16H8a7.99977,7.99977,0,0,0-8,8v16a8.00008,8.00008,0,0,0,8,8h8V431.14209c0,7.97021,5.44531,15.3584,13.312,16.63867A16.01152,16.01152,0,0,0,48,432v-3.20117L176,480v16a16.00016,16.00016,0,0,0,16,16h16a16.00016,16.00016,0,0,0,16-16V304A15.99985,15.99985,0,0,0,208,288ZM632,128h-8V112.85547c0-7.96924-5.44531-15.356-13.311-16.63623A16.01034,16.01034,0,0,0,592,112v16h-8a7.99977,7.99977,0,0,0-8,8v16a8.00008,8.00008,0,0,0,8,8h8V352H512V304a15.99985,15.99985,0,0,0-16-16H432a15.99985,15.99985,0,0,0-16,16V496a16.00016,16.00016,0,0,0,16,16h16a16.00016,16.00016,0,0,0,16-16V480l128-51.20117v2.34326c0,7.97021,5.44531,15.3584,13.312,16.63867A16.01152,16.01152,0,0,0,624,432V160h8a8.00008,8.00008,0,0,0,8-8V136A7.99977,7.99977,0,0,0,632,128ZM337.875,0h-35.75a15.99837,15.99837,0,0,0-15.877,14.01562L256,256V464a16.00079,16.00079,0,0,0,16,16h96a16.00079,16.00079,0,0,0,16-16V256L353.752,14.01562A15.99837,15.99837,0,0,0,337.875,0ZM352,304a16.00079,16.00079,0,0,1-16,16H304a16.00079,16.00079,0,0,1-16-16V256a32,32,0,0,1,64,0Z"]
  },
      ew = {
    prefix: "fas",
    iconName: "starfighter-alt",
    icon: [576, 512, [], "e038", "M560,32H528a15.99954,15.99954,0,0,0-16,16V216l-75.51953-18.87891C412.99414,137.96289,355.52344,96,288,96S163.00586,137.96289,139.51953,197.12109L64,216V48A15.99954,15.99954,0,0,0,48,32H16A15.99954,15.99954,0,0,0,0,48V464a16.00079,16.00079,0,0,0,16,16H48a16.00079,16.00079,0,0,0,16-16V296l75.51953,18.87891C163.00586,374.03711,220.47656,416,288,416s124.99414-41.96289,148.48047-101.12109L512,296V464a16.00079,16.00079,0,0,0,16,16h32a16.00079,16.00079,0,0,0,16-16V48A15.99954,15.99954,0,0,0,560,32ZM300,161.21094a94.90406,94.90406,0,0,1,46.584,19.23633l-22.627,22.62695A63.5822,63.5822,0,0,0,300,193.21094Zm-24,0v32a63.5822,63.5822,0,0,0-23.957,9.86328L229.416,180.44727A94.90406,94.90406,0,0,1,276,161.21094ZM212.44727,197.416,235.07422,220.043A63.5822,63.5822,0,0,0,225.21094,244h-32A94.90406,94.90406,0,0,1,212.44727,197.416ZM193.21094,268h32a63.5822,63.5822,0,0,0,9.86328,23.957l-22.62695,22.627A94.90406,94.90406,0,0,1,193.21094,268ZM276,350.78906a94.90406,94.90406,0,0,1-46.584-19.23633l22.62695-22.627A63.5822,63.5822,0,0,0,276,318.78906ZM256,256a32,32,0,1,1,32,32A31.99908,31.99908,0,0,1,256,256Zm44,94.78906v-32a63.5822,63.5822,0,0,0,23.957-9.86328l22.627,22.627A94.90406,94.90406,0,0,1,300,350.78906ZM363.55273,314.584l-22.627-22.627A63.5822,63.5822,0,0,0,350.78906,268h32A94.90406,94.90406,0,0,1,363.55273,314.584ZM350.78906,244a63.5822,63.5822,0,0,0-9.86328-23.957l22.627-22.62695A94.90406,94.90406,0,0,1,382.78906,244Z"]
  },
      aw = {
    prefix: "fas",
    iconName: "stars",
    icon: [512, 512, [], "f762", "M259.69042,85.96457l49.64549,20.69969,20.70353,49.643a6.65746,6.65746,0,0,0,11.926,0L362.667,106.66426l49.64549-20.69969a6.66574,6.66574,0,0,0,0-11.92493L362.667,53.338,341.96545,3.697a6.65746,6.65746,0,0,0-11.926,0L309.33591,53.338,259.69042,74.03964a6.66574,6.66574,0,0,0,0,11.92493ZM364.294,267.29343,259.4951,251.99764l-46.90716-95.19633c-8.39078-16.99879-32.68813-17.2019-41.18829,0l-46.90716,95.19633L19.69358,267.29343C.89634,269.99636-6.71318,293.19783,6.99021,306.49376l75.90772,73.99472L64.89758,485.07476c-3.20319,18.9049,16.68782,33.107,33.29752,24.2014l93.7987-49.3871,93.79869,49.3871A22.95361,22.95361,0,0,0,319.09,485.07476L301.199,380.48848l75.89209-73.99472C390.70077,293.19783,383.09125,269.99636,364.294,267.29343ZM509.05268,219.2285,469.339,202.67109,452.7801,162.961a5.32691,5.32691,0,0,0-9.5412,0L426.678,202.67109l-39.7117,16.55741a5.33385,5.33385,0,0,0,0,9.54033L426.678,245.3282l16.56087,39.7081a5.32534,5.32534,0,0,0,9.5412,0L469.339,245.3282l39.71366-16.55937a5.33386,5.33386,0,0,0,0-9.54033Z"]
  },
      nw = {
    prefix: "fas",
    iconName: "starship",
    icon: [640, 512, [], "e039", "M448,224a32,32,0,1,0,32,32A32.03667,32.03667,0,0,0,448,224ZM240,128a31.99908,31.99908,0,0,0-32-32H24A23.99993,23.99993,0,0,0,0,120v16a24.00118,24.00118,0,0,0,24,24H86.23828l55.32227,56.94922-10.79493.98047a38.22631,38.22631,0,0,0,0,76.13867l10.79688.98242L64,352H24A23.99993,23.99993,0,0,0,0,376v16a24.00118,24.00118,0,0,0,24,24H208a32,32,0,0,0,0-64H137.76172L208.25,301.11328l20.7793,1.88867a222.14594,222.14594,0,0,1,0-94.0039l-20.78125,1.88867L160,160h48A32.00033,32.00033,0,0,0,240,128ZM448,64c-106.03906,0-192,85.96094-192,192s85.96094,192,192,192,192-85.96094,192-192S554.03906,64,448,64Zm0,256a64,64,0,1,1,64-64A64.07333,64.07333,0,0,1,448,320Z"]
  },
      tw = {
    prefix: "fas",
    iconName: "starship-freighter",
    icon: [576, 512, [], "e03a", "M224.00871,208.00014a48,48,0,1,0,47.99881,48A47.99927,47.99927,0,0,0,224.00871,208.00014ZM560.0004,223.65443a16.00059,16.00059,0,0,0,15.9996-16v-52.455a16.0008,16.0008,0,0,0-10.52318-15.0332l-254.15-92.60347C255.57629,27.50609,193.613,25.59008,139.21979,49.15061-4.095,111.22285.01425,256.00012.01425,256.00012s-4.35536,144.66594,139.20554,206.8495c54.39319,23.55858,116.3565,21.64452,172.10707,1.58593l16.32772-5.94921,3.19524,3.90429A48.04351,48.04351,0,0,0,368.00515,480h63.99841a47.91689,47.91689,0,0,0,40.167-74.16988L565.47682,371.834A16.0008,16.0008,0,0,0,576,356.80084v-52.455a16.00059,16.00059,0,0,0-15.9996-16H416.004V223.65443ZM80.01227,272.00011a16,16,0,1,1,15.99961-16A16.00059,16.00059,0,0,1,80.01227,272.00011Zm31.99921,96a16,16,0,1,1,15.99961-16A16.00059,16.00059,0,0,1,112.01148,368.00006Zm0-191.9999a16,16,0,1,1,15.99961-16A16.00059,16.00059,0,0,1,112.01148,176.00016ZM224.00871,336.00007a80,80,0,1,1,79.998-80A80.09064,80.09064,0,0,1,224.00871,336.00007Z"]
  },
      rw = {
    prefix: "fas",
    iconName: "steak",
    icon: [576, 512, [], "f824", "M368.85 96c-27.31 0-51.89 23.7-62.62 60.36-6.24 21.36-26.75 106.21-173.16 170-138.8 60.35 163.93 169.45 321.26-9.82 38.21-43.53 32.8-126-11.57-176.59C417.86 111.58 391.61 96 368.85 96zM384 255.9a32 32 0 1 1 32-32 32 32 0 0 1-32 32zM514.92 76.65C467.92 23.11 416.28 0 368.85 0 298.27 0 237 51.17 214.1 129.38 165 269.31 1.37 212.32 0 351.63c-1.19 121.61 139.27 164.61 256 160 87.78-3.4 187.32-37.09 270.49-131.84C596.78 299.75 591.6 164 514.92 76.65zm-36.53 261c-76.15 86.75-164.32 107.76-224.82 110.1-37.65 1.38-131.52-6.52-171.24-46.62-2.49-2.51-59.44-61.76 38-104.17 71.64-31.19 132.3-71.24 155.23-149.6C290.34 96.7 327 64 368.85 64c32.58 0 66.45 19 98 54.88 55.15 62.84 60.45 163.03 11.54 218.76z"]
  },
      iw = {
    prefix: "fas",
    iconName: "steering-wheel",
    icon: [496, 512, [], "f622", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 64c90.53 0 165.82 65.77 181.03 152h-93.9c-11.09-19.05-31.49-32-55.12-32h-64c-23.63 0-44.04 12.95-55.12 32h-93.9C82.18 137.77 157.47 72 248 72zM66.97 288H168l48 64v85.03C140.19 423.65 80.35 363.81 66.97 288zM280 437.03V352l48-64h101.03C415.65 363.81 355.81 423.65 280 437.03z"]
  },
      ow = {
    prefix: "fas",
    iconName: "step-backward",
    icon: [448, 512, [], "f048", "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"]
  },
      lw = {
    prefix: "fas",
    iconName: "step-forward",
    icon: [448, 512, [], "f051", "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"]
  },
      fw = {
    prefix: "fas",
    iconName: "stethoscope",
    icon: [512, 512, [], "f0f1", "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"]
  },
      sw = {
    prefix: "fas",
    iconName: "sticky-note",
    icon: [448, 512, [], "f249", "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"]
  },
      uw = {
    prefix: "fas",
    iconName: "stocking",
    icon: [384, 512, [], "f7d5", "M368 0H80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM96 251.5l-39 26C-1.8 316.7-17.7 396.2 21.5 455c24.7 37 65.2 57 106.6 57 24.4 0 49.1-7 70.9-21.5l81.7-54.5c44.6-29.7 71.2-79.5 71.2-133.1V128H96v123.5z"]
  },
      hw = {
    prefix: "fas",
    iconName: "stomach",
    icon: [512, 512, [], "f623", "M384 96c-54.29 0-90.86 32.57-109.17 64H256c-35.34 0-64-28.65-64-64V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v80c0 70.69 57.3 128 128 128h.49c-.07 1.85-.49 3.63-.49 5.5V288c0 35.35-28.66 64-64 64h-64C57.3 352 0 409.31 0 480v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-37.63 33.96-51.21 53.92-51.21 17.11 0 29.59 6.71 41.07 18.2C226.21 514.21 297.63 512 308.36 512c112.48 0 203.65-91.17 203.65-203.65V224C512 153.31 454.7 96 384 96zm64 212.35c0 9.23-1.01 18.21-2.73 26.95-21.56 6.08-45.01.97-61.27-15.3-17.37-17.37-42.91-22.14-65.6-13.93.84-5.93 1.6-11.9 1.6-18.07v-58.5c0-36.15 26.38-69.5 64-69.5 35.29 0 64 28.71 64 64v84.35z"]
  },
      mw = {
    prefix: "fas",
    iconName: "stop",
    icon: [448, 512, [], "f04d", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"]
  },
      vw = {
    prefix: "fas",
    iconName: "stop-circle",
    icon: [512, 512, [], "f28d", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"]
  },
      dw = {
    prefix: "fas",
    iconName: "stopwatch",
    icon: [448, 512, [], "f2f2", "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"]
  },
      Mw = {
    prefix: "fas",
    iconName: "stopwatch-20",
    icon: [448, 512, [], "e06f", "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"]
  },
      pw = {
    prefix: "fas",
    iconName: "store",
    icon: [616, 512, [], "f54e", "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"]
  },
      zw = {
    prefix: "fas",
    iconName: "store-alt",
    icon: [640, 512, [], "f54f", "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"]
  },
      Cw = {
    prefix: "fas",
    iconName: "store-alt-slash",
    icon: [640, 512, [], "e070", "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"]
  },
      Lw = {
    prefix: "fas",
    iconName: "store-slash",
    icon: [640, 512, [], "e071", "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"]
  },
      Aw = {
    prefix: "fas",
    iconName: "stream",
    icon: [512, 512, [], "f550", "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"]
  },
      Nw = {
    prefix: "fas",
    iconName: "street-view",
    icon: [512, 512, [], "f21d", "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"]
  },
      gw = {
    prefix: "fas",
    iconName: "stretcher",
    icon: [640, 512, [], "f825", "M608 128H192L79.84 10.74a32 32 0 0 0-45.18-2.66L10.74 29.35a32 32 0 0 0-2.66 45.17l121.7 128A64 64 0 0 0 177.62 224H608a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32zm-92.22 266.93a62.23 62.23 0 0 0-56.18-7.3l-43-37.63L524 256h-97.2L368 307.48 309.17 256H212l107.4 94-43 37.63a62.23 62.23 0 0 0-56.18 7.3 64.35 64.35 0 0 0-17.29 17.29 64.07 64.07 0 1 0 115.82 23.4l49.25-43.1 49.25 43.1a64 64 0 1 0 98.53-40.69zM256 464a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm224 0a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"]
  },
      Hw = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"]
  },
      Vw = {
    prefix: "fas",
    iconName: "stroopwafel",
    icon: [512, 512, [], "f551", "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"]
  },
      xw = {
    prefix: "fas",
    iconName: "subscript",
    icon: [512, 512, [], "f12c", "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"]
  },
      ww = {
    prefix: "fas",
    iconName: "subway",
    icon: [448, 512, [], "f239", "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"]
  },
      yw = {
    prefix: "fas",
    iconName: "suitcase",
    icon: [512, 512, [], "f0f2", "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"]
  },
      bw = {
    prefix: "fas",
    iconName: "suitcase-rolling",
    icon: [384, 512, [], "f5c1", "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"]
  },
      Sw = {
    prefix: "fas",
    iconName: "sun",
    icon: [512, 512, [], "f185", "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"]
  },
      Tw = {
    prefix: "fas",
    iconName: "sun-cloud",
    icon: [640, 512, [], "f763", "M576 224c-12 0-23.1 3.5-32.7 9.2-3.5-41-37.4-73.2-79.3-73.2-38.8 0-71.1 27.6-78.4 64.2-.5 0-1-.2-1.6-.2-35.3 0-64 28.7-64 64s28.7 64 64 64h192c35.3 0 64-28.7 64-64s-28.7-64-64-64zM429.4 384H384c-22.2 0-42.4-7.9-58.6-20.5-49.6 32-116.5 26.4-159.9-16.9-49.9-49.9-49.9-131.1 0-181s131.1-49.9 181 0c7.2 7.2 13 15.1 18.1 23.4 13.2-25.5 35.6-45 62.6-54.5l13.9-41.7c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.3-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9L429.4 384zm-92.5-179.3C319.8 177.9 290 160 256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96c17.2 0 33.1-4.9 47.1-12.8-9.4-14.8-15.1-32.3-15.1-51.2 0-35.8 19.8-66.8 48.9-83.3z"]
  },
      Dw = {
    prefix: "fas",
    iconName: "sun-dust",
    icon: [512, 512, [], "f764", "M256 160c-52.9 0-96 43.1-96 96 0 26.5 10.8 50.5 28.1 67.8l135.7-135.7C306.5 170.8 282.5 160 256 160zm163.3-89.2l-100.4 33.5-47.4-94.7c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-2.3 6.8-.2 13.4 4.2 17.7l90.5-90.5c-49.9-49.9-49.9-131.1 0-181s131.1-49.9 181 0L437 75c-4.3-4.4-10.9-6.5-17.7-4.2zM160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm320-256c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm-144 64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm80 96c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm0-192c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM320 448c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"]
  },
      jw = {
    prefix: "fas",
    iconName: "sun-haze",
    icon: [640, 512, [], "f765", "M193.6 240c3.4-27.2 15-53.6 35.9-74.5 49.9-49.9 131.1-49.9 181 0 20.9 20.9 32.5 47.3 35.9 74.5h119l-93.7-46.9 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.7c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7-100.5-33.5c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4L74.6 240h119zM320 160c-47.5 0-86.7 34.7-94.4 80h188.8c-7.7-45.3-46.9-80-94.4-80zM80 336h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16zm544-48H496c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM208 464H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H288c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-48-56v-16c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16z"]
  },
      Ew = {
    prefix: "fas",
    iconName: "sunglasses",
    icon: [576, 512, [], "f892", "M574.09 280.38L528.75 98.66a87.94 87.94 0 0 0-113.19-62.14l-15.25 5.08a16 16 0 0 0-10.12 20.25L395.25 77a16 16 0 0 0 20.22 10.13l13.19-4.39c10.87-3.63 23-3.57 33.15 1.73a39.59 39.59 0 0 1 20.38 25.81l38.47 153.83a276.7 276.7 0 0 0-81.22-12.47c-34.75 0-74 7-114.85 26.75h-73.18c-40.85-19.75-80.07-26.75-114.85-26.75a276.75 276.75 0 0 0-81.22 12.45l38.47-153.8a39.61 39.61 0 0 1 20.38-25.82c10.15-5.29 22.28-5.34 33.15-1.73l13.16 4.39A16 16 0 0 0 180.75 77l5.06-15.19a16 16 0 0 0-10.12-20.21l-15.25-5.08A87.95 87.95 0 0 0 47.25 98.65L1.91 280.38A75.35 75.35 0 0 0 0 295.86v70.25C0 429 51.59 480 115.19 480h37.12c60.28 0 110.38-45.94 114.88-105.37l2.93-38.63h35.76l2.93 38.63c4.5 59.43 54.6 105.37 114.88 105.37h37.12C524.41 480 576 429 576 366.13v-70.25a62.67 62.67 0 0 0-1.91-15.5zm-509.9 87.53c0-.61-.19-1.18-.19-1.8v-37.55a217.35 217.35 0 0 1 72.59-12.9c9.14 0 18.14 1.21 27.14 2.48zm308.13-2.07l-2.82-37.28a196.55 196.55 0 0 1 69.94-12.9 202.07 202.07 0 0 1 28.72 2.26z"]
  },
      kw = {
    prefix: "fas",
    iconName: "sunrise",
    icon: [576, 512, [], "f766", "M250.9 374.5c-20.6 8.5-36.3 23.5-46.6 41.5h167.2c-23.8-41.6-75.1-60.3-120.6-41.5zM80.7 416h87.6c.2-.5.2-1 .4-1.4 27.3-65.8 102.9-97.2 168.7-69.9 33.4 13.8 57.8 40.2 70.3 71.3h87.6l28.4-32.7c9.4-10.9 2.4-27.9-12-28.9l-106.5-7.6-7.6-106.5c-1-14.4-18-21.4-28.9-12l-80.7 70-80.7-70c-10.9-9.4-27.9-2.4-28.9 12l-7.6 106.5-106.5 7.6c-14.4 1-21.4 18-12 28.9L80.7 416zM560 464H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM190.8 128H256v80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-80h65.2c14.3 0 21.4-17.3 11.2-27.4L300 5c-6.6-6.6-17.4-6.6-24 0l-96.4 95.7c-10.2 10-3 27.3 11.2 27.3z"]
  },
      Iw = {
    prefix: "fas",
    iconName: "sunset",
    icon: [576, 512, [], "f767", "M250.9 374.5c-20.6 8.5-36.3 23.5-46.6 41.5h167.2c-23.8-41.6-75.1-60.3-120.6-41.5zM80.7 416h87.6c.2-.5.2-1 .4-1.4 27.3-65.8 102.9-97.2 168.7-69.9 33.4 13.8 57.8 40.2 70.3 71.3h87.6l28.4-32.7c9.4-10.9 2.4-27.9-12-28.9l-106.5-7.6-7.6-106.5c-1-14.4-18-21.4-28.9-12l-80.7 70-80.7-70c-10.9-9.4-27.9-2.4-28.9 12l-7.6 106.5-106.5 7.6c-14.4 1-21.4 18-12 28.9L80.7 416zM560 464H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM276 219c6.6 6.6 17.4 6.6 24 0l96.4-95.7c10.1-10.1 3-27.4-11.3-27.4H320V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v80h-65.2c-14.3 0-21.4 17.3-11.2 27.4L276 219z"]
  },
      Ow = {
    prefix: "fas",
    iconName: "superscript",
    icon: [512, 512, [], "f12b", "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"]
  },
      Qw = {
    prefix: "fas",
    iconName: "surprise",
    icon: [496, 512, [], "f5c2", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      Zw = {
    prefix: "fas",
    iconName: "swatchbook",
    icon: [512, 512, [], "f5c3", "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"]
  },
      Uw = {
    prefix: "fas",
    iconName: "swimmer",
    icon: [640, 512, [], "f5c4", "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"]
  },
      Bw = {
    prefix: "fas",
    iconName: "swimming-pool",
    icon: [640, 512, [], "f5c5", "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"]
  },
      Rw = {
    prefix: "fas",
    iconName: "sword",
    icon: [512, 512, [], "f71c", "M110.11 227.59c-6.25-6.25-16.38-6.25-22.63 0l-18.79 18.8a16.005 16.005 0 0 0-2 20.19l53.39 80.09-53.43 53.43-29.26-14.63a13.902 13.902 0 0 0-16.04 2.6L4.07 405.36c-5.42 5.43-5.42 14.22 0 19.64L87 507.93c5.42 5.42 14.22 5.42 19.64 0l17.29-17.29a13.873 13.873 0 0 0 2.6-16.03l-14.63-29.26 53.43-53.43 80.09 53.39c6.35 4.23 14.8 3.39 20.19-2l18.8-18.79c6.25-6.25 6.25-16.38 0-22.63l-174.3-174.3zM493.73.16L400 16 171.89 244.11l96 96L496 112l15.83-93.73c1.51-10.56-7.54-19.61-18.1-18.11z"]
  },
      Yw = {
    prefix: "fas",
    iconName: "sword-laser",
    icon: [512, 512, [], "e03b", "M105.4989,327.28721l79.19794,79.19384,22.628-22.62688L128.1269,304.66032ZM9.37147,412.13472a32.00179,32.00179,0,0,0-.01935,45.23473L54.586,502.64519a32.07776,32.07776,0,0,0,45.26149.022L179.05363,423.465,88.54035,332.956Zm186.63937-175.355a8.00079,8.00079,0,0,0-11.314,0l-11.314,11.31319a8.00026,8.00026,0,0,0,0,11.31369l79.19793,79.19385a8.00081,8.00081,0,0,0,11.314,0l11.31394-11.3132a8.00015,8.00015,0,0,0,0-11.31369Zm-56.56994,56.567L218.63878,372.541l22.628-22.62688-79.19793-79.19433ZM504.97121,7.02851a24.00693,24.00693,0,0,0-33.279-.64061L225.58713,232.41406l53.98729,53.98451L505.612,40.306A24.0046,24.0046,0,0,0,504.97121,7.02851Z"]
  },
      Pw = {
    prefix: "fas",
    iconName: "sword-laser-alt",
    icon: [512, 512, [], "e03c", "M54.60974,502.65158l.002.00195a32.08551,32.08551,0,0,0,45.26143.01173l84.88276-84.88155-22.63853-22.6382ZM94.22325,327.25434,9.3698,412.12416A31.99505,31.99505,0,0,0,9.36,457.35955l.00586.0039L116.85006,349.87887ZM128.16737,361.196,20.67539,468.68451l22.6229,22.64406L150.8,383.82836Zm180.866-105.13441H172.03587a15.99913,15.99913,0,0,0-11.31731,4.68861l-55.178,55.187,90.53068,90.52938L320.294,283.43531C330.45087,273.37628,323.328,256.06161,309.03335,256.06161ZM504.96954,7.02964a24.01262,24.01262,0,0,0-33.28575-.64077l-245.70461,225.667H329.50336l176.107-191.739A24.01232,24.01232,0,0,0,504.96954,7.02964Z"]
  },
      Fw = {
    prefix: "fas",
    iconName: "swords",
    icon: [512, 512, [], "f71d", "M309.37 389.38l80-80L93.33 13.33 15.22.14C6.42-1.12-1.12 6.42.14 15.22l13.2 78.11 296.03 296.05zm197.94 72.68L448 402.75l31.64-59.03c3.33-6.22 2.2-13.88-2.79-18.87l-17.54-17.53c-6.25-6.25-16.38-6.25-22.63 0L307.31 436.69c-6.25 6.25-6.25 16.38 0 22.62l17.53 17.54a16 16 0 0 0 18.87 2.79L402.75 448l59.31 59.31c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63zm-8.64-368.73l13.2-78.11c1.26-8.8-6.29-16.34-15.08-15.08l-78.11 13.2-140.05 140.03 80 80L498.67 93.33zm-345.3 185.3L100 332l-24.69-24.69c-6.25-6.25-16.38-6.25-22.62 0l-17.54 17.53a15.998 15.998 0 0 0-2.79 18.87L64 402.75 4.69 462.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L109.25 448l59.03 31.64c6.22 3.33 13.88 2.2 18.87-2.79l17.53-17.54c6.25-6.25 6.25-16.38 0-22.62L180 412l53.37-53.37-80-80z"]
  },
      Ww = {
    prefix: "fas",
    iconName: "swords-laser",
    icon: [640, 512, [], "e03d", "M135.03144,7.03013a24.01269,24.01269,0,0,0-.64257,33.287l225.66788,245.7026V182.49655L168.31854,6.38951A24.01275,24.01275,0,0,0,135.03144,7.03013ZM411.43563,191.70552c-10.05859-10.15623-27.373-3.0332-27.373,11.26169V339.963a16.00393,16.00393,0,0,0,4.6875,11.31834L443.93757,406.459l90.52927-90.53106Zm77.75974,192.12654L596.68361,491.324l22.64452-22.623-107.5-107.50172ZM630.666,412.12692l-84.88278-84.88263-22.63671,22.63862L630.65235,457.3905l.002-.002A32.08761,32.08761,0,0,0,630.666,412.12692Zm-175.412,5.64843L540.125,502.62868a31.99249,31.99249,0,0,0,45.23436.00977l.0039-.00586L477.879,395.1504ZM256.00015,313.1994l42.69725-46.67959-42.69725-46.48818ZM400.71689,154.98489,505.61138,40.3074a24.00207,24.00207,0,0,0-33.918-33.91984L343.65636,123.985,381.4669,158.7134a47.95342,47.95342,0,0,1,18.71483-3.78124C400.36337,154.93216,400.53525,154.98294,400.71689,154.98489ZM196.59978,224.62928l-28.76366,29.11321a32.0069,32.0069,0,0,0-45.27733,45.25186L9.33618,412.15427a32.06806,32.06806,0,0,0,.01172,45.2499l45.30857,45.23818a32.01845,32.01845,0,0,0,45.25-.00976L219.26774,384.25784a15.99284,15.99284,0,0,0,4.73242-11.3574v-137.029C224.00016,221.56678,206.65642,214.45156,196.59978,224.62928ZM168.5412,360.44734a16,16,0,1,1,16.0078-16A16.00535,16.00535,0,0,1,168.5412,360.44734Z"]
  },
      Gw = {
    prefix: "fas",
    iconName: "synagogue",
    icon: [640, 512, [], "f69b", "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"]
  },
      qw = {
    prefix: "fas",
    iconName: "sync",
    icon: [512, 512, [], "f021", "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"]
  },
      Jw = {
    prefix: "fas",
    iconName: "sync-alt",
    icon: [512, 512, [], "f2f1", "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"]
  },
      Kw = {
    prefix: "fas",
    iconName: "syringe",
    icon: [512, 512, [], "f48e", "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"]
  },
      Xw = {
    prefix: "fas",
    iconName: "table",
    icon: [512, 512, [], "f0ce", "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"]
  },
      _w = {
    prefix: "fas",
    iconName: "table-tennis",
    icon: [512, 512, [], "f45d", "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"]
  },
      $w = {
    prefix: "fas",
    iconName: "tablet",
    icon: [448, 512, [], "f10a", "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
  },
      cy = {
    prefix: "fas",
    iconName: "tablet-alt",
    icon: [448, 512, [], "f3fa", "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"]
  },
      ey = {
    prefix: "fas",
    iconName: "tablet-android",
    icon: [448, 512, [], "f3fb", "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM288 452c0 6.6-5.4 12-12 12H172c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8z"]
  },
      ay = {
    prefix: "fas",
    iconName: "tablet-android-alt",
    icon: [448, 512, [], "f3fc", "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM288 452c0 6.6-5.4 12-12 12H172c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8zm112-80c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"]
  },
      ny = {
    prefix: "fas",
    iconName: "tablet-rugged",
    icon: [448, 512, [], "f48f", "M439.2 164.4c5.4-2.7 8.8-8.2 8.8-14.3V73.9c0-6.1-3.4-11.6-8.8-14.3L416 48c0-26.5-21.5-48-48-48H80C53.5 0 32 21.5 32 48L8.8 59.6C3.4 62.3 0 67.8 0 73.9v76.2c0 6.1 3.4 11.6 8.8 14.3L32 176v16L8.8 203.6c-5.4 2.7-8.8 8.2-8.8 14.3v76.2c0 6.1 3.4 11.6 8.8 14.3L32 320v16L8.8 347.6c-5.4 2.7-8.8 8.2-8.8 14.3v76.2c0 6.1 3.4 11.6 8.8 14.3L32 464c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48l23.2-11.6c5.4-2.7 8.8-8.2 8.8-14.3v-76.2c0-6.1-3.4-11.6-8.8-14.3L416 336v-16l23.2-11.6c5.4-2.7 8.8-8.2 8.8-14.3v-76.2c0-6.1-3.4-11.6-8.8-14.3L416 192v-16l23.2-11.6zM352 432c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v352z"]
  },
      ty = {
    prefix: "fas",
    iconName: "tablets",
    icon: [640, 512, [], "f490", "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"]
  },
      ry = {
    prefix: "fas",
    iconName: "tachometer",
    icon: [576, 512, [], "f0e4", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm102.77 119.59l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36z"]
  },
      iy = {
    prefix: "fas",
    iconName: "tachometer-alt",
    icon: [576, 512, [], "f3fd", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      oy = {
    prefix: "fas",
    iconName: "tachometer-alt-average",
    icon: [576, 512, [], "f624", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm199.12 192H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-26.85 16.56-49.75 40-59.25V128c0-13.25 10.75-24 24-24s24 10.75 24 24v196.75c23.44 9.5 40 32.41 40 59.25 0 11.72-3.38 22.55-8.88 32zM400 192c0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32-32-14.33-32-32zm80 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      ly = {
    prefix: "fas",
    iconName: "tachometer-alt-fast",
    icon: [576, 512, [], "f625", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm199.12 192H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-35.35 28.65-64 64-64 5.65 0 11.02.96 16.24 2.34L412.8 177.59c7.98-10.56 23-12.72 33.61-4.8 10.59 7.95 12.75 23 4.8 33.61L342.65 351.14c5.81 9.63 9.35 20.79 9.35 32.86 0 11.72-3.38 22.55-8.88 32zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      fy = {
    prefix: "fas",
    iconName: "tachometer-alt-fastest",
    icon: [576, 512, [], "f626", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm144 128c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zM288 96c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm339.95 151.67l-133.93 22.32c-1.51 6.37-3.69 12.48-6.9 18.01H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-35.35 28.65-64 64-64 23.06 0 43.1 12.31 54.37 30.61l133.68-22.28c13.09-2.17 25.45 6.64 27.62 19.72 2.19 13.07-6.65 25.45-19.72 27.62z"]
  },
      sy = {
    prefix: "fas",
    iconName: "tachometer-alt-slow",
    icon: [576, 512, [], "f627", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm247.12 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-12.07 3.54-23.23 9.35-32.86L124.8 206.41c-7.95-10.61-5.8-25.66 4.8-33.61 10.64-7.92 25.66-5.77 33.61 4.8l108.56 144.74c5.21-1.37 10.59-2.34 16.24-2.34 35.35 0 64 28.65 64 64-.01 11.72-3.39 22.55-8.89 32zM400 192c0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32-32-14.33-32-32zm80 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      uy = {
    prefix: "fas",
    iconName: "tachometer-alt-slowest",
    icon: [576, 512, [], "f628", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zm-144 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zm199.12 256H232.88c-3.21-5.52-5.39-11.63-6.9-18.01L92.05 375.67c-13.06-2.17-21.91-14.55-19.72-27.62 2.17-13.08 14.53-21.89 27.62-19.72l133.68 22.28C244.9 332.31 264.94 320 288 320c35.35 0 64 28.65 64 64 0 11.72-3.38 22.55-8.88 32zM400 192c0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32-32-14.33-32-32zm80 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      hy = {
    prefix: "fas",
    iconName: "tachometer-average",
    icon: [576, 512, [], "f629", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm55.12 384H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-26.85 16.56-49.75 40-59.25V128c0-13.25 10.75-24 24-24s24 10.75 24 24v196.75c23.44 9.5 40 32.41 40 59.25 0 11.72-3.38 22.55-8.88 32z"]
  },
      my = {
    prefix: "fas",
    iconName: "tachometer-fast",
    icon: [576, 512, [], "f62a", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm163.2 174.41L342.65 351.14c5.81 9.63 9.35 20.79 9.35 32.86 0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-35.35 28.65-64 64-64 5.65 0 11.02.96 16.24 2.34L412.8 177.59c7.98-10.56 23-12.72 33.61-4.8 10.59 7.96 12.75 23.01 4.79 33.62z"]
  },
      vy = {
    prefix: "fas",
    iconName: "tachometer-fastest",
    icon: [576, 512, [], "f62b", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm195.95 343.67l-133.93 22.32c-1.51 6.37-3.69 12.48-6.9 18.01H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-35.35 28.65-64 64-64 23.06 0 43.1 12.31 54.37 30.61l133.68-22.28c13.09-2.17 25.45 6.64 27.62 19.72 2.19 13.07-6.65 25.45-19.72 27.62z"]
  },
      dy = {
    prefix: "fas",
    iconName: "tachometer-slow",
    icon: [576, 512, [], "f62c", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm55.12 384H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-12.07 3.54-23.23 9.35-32.86L124.8 206.41c-7.95-10.61-5.8-25.66 4.8-33.61 10.64-7.92 25.66-5.77 33.61 4.8l108.56 144.74c5.21-1.37 10.59-2.34 16.24-2.34 35.35 0 64 28.65 64 64-.01 11.72-3.39 22.55-8.89 32z"]
  },
      My = {
    prefix: "fas",
    iconName: "tachometer-slowest",
    icon: [576, 512, [], "f62d", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm55.12 384H232.88c-3.21-5.52-5.39-11.63-6.9-18.01L92.05 375.67c-13.06-2.17-21.91-14.55-19.72-27.62 2.17-13.08 14.53-21.89 27.62-19.72l133.68 22.28C244.9 332.31 264.94 320 288 320c35.35 0 64 28.65 64 64 0 11.72-3.38 22.55-8.88 32z"]
  },
      py = {
    prefix: "fas",
    iconName: "taco",
    icon: [512, 512, [], "f826", "M256 192C125.82 192 18.14 299.4.32 439.08-2.43 460.66 13 480 32.56 480h446.88c19.56 0 35-19.34 32.24-40.92C493.86 299.4 386.18 192 256 192zM112 416a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm64-64a16 16 0 1 1 16-16 16 16 0 0 1-16 16zM7.33 279.48a129 129 0 0 1 4.53 28.14C64 218.51 154.91 160 256 160s192 58.52 244.14 147.64a128.36 128.36 0 0 1 4.53-28.09c0-.09.05-.18.08-.26 5.14-17.32 11-36.94 4.16-55-7.15-19.06-24.76-29.36-40.31-38.46-9.49-5.54-19.32-11.29-23.71-17.53-4.74-6.69-7.33-18.51-9.83-30-3.95-18.08-8.44-38.58-23.64-50.64-15.69-12.45-36-11-54-9.81-10.79.76-22 1.5-29.18-1.1-6.93-2.51-15.12-10.14-23-17.51-29.05-27.07-50.66-44.51-98.38-.05-7.92 7.37-16.11 15-23 17.51-7.22 2.6-18.39 1.86-29.18 1.1-18-1.24-38.32-2.64-54 9.81-15.2 12.06-19.69 32.56-23.64 50.64-2.5 11.46-5.09 23.28-9.83 30-4.39 6.24-14.22 12-23.71 17.53-15.55 9.1-33.16 19.39-40.31 38.46-6.81 18.08-1 37.7 4.16 55-.07.07-.05.16-.02.24z"]
  },
      zy = {
    prefix: "fas",
    iconName: "tag",
    icon: [512, 512, [], "f02b", "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"]
  },
      Cy = {
    prefix: "fas",
    iconName: "tags",
    icon: [640, 512, [], "f02c", "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"]
  },
      Ly = {
    prefix: "fas",
    iconName: "tally",
    icon: [640, 512, [], "f69c", "M639.21 169.49l-9.89-30.43c-2.73-8.4-11.75-13-20.16-10.27L544 149.88V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v122.59l-64 20.71V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v164.01l-64 20.71V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v205.43l-64 20.71V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v246.86l-84.94 27.49C2.65 325.08-1.95 334.11.79 342.51l9.89 30.43c2.73 8.4 11.76 13 20.16 10.27L96 362.13V464c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V341.41l64-20.71V464c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V299.99l64-20.71V464c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V258.57l64-20.71V464c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V217.14l84.94-27.49c8.4-2.73 13.01-11.75 10.27-20.16z"]
  },
      Ay = {
    prefix: "fas",
    iconName: "tanakh",
    icon: [448, 512, [], "f827", "M318 139.44h-34.9l17.48 29.19zm-34.86 105.12h34.91l-17.47-29.17zm-59.09 52.07l16.78-28.07h-33.58zM130 244.56h34.9l-17.48-29.19zm34.89-105.12H130l17.47 29.17zM352 0H25.6C9.6 0 0 9.6 0 25.6v332.8q0 14.4 9.6 19.2c3.2 12.8 3.2 57.6 0 73.6Q0 460.8 0 470.4v16c0 16 12.8 25.6 25.6 25.6H352c54.4 0 96-41.6 96-96V96c0-54.4-41.6-96-96-96zM105.41 125.59a20.11 20.11 0 0 1 17.5-10.15h56.3L206.8 69.3a20 20 0 0 1 17.25-9.82 19.66 19.66 0 0 1 17 9.68l27.7 46.28h56.36a20 20 0 0 1 17.14 30.29L314.57 192l27.79 46.43a19.6 19.6 0 0 1 .23 20 20.11 20.11 0 0 1-17.5 10.15h-56.3L241.2 314.7a20 20 0 0 1-17.2 9.82 19.66 19.66 0 0 1-17-9.68l-27.7-46.28h-56.39a20 20 0 0 1-17.14-30.29L133.43 192l-27.79-46.43a19.6 19.6 0 0 1-.23-19.98zM352 448H67.2v-64H352c16 0 32 12.8 32 32s-12.8 32-32 32zM224 87.38l-16.78 28.06h33.58zm-31.12 157.18h62.3L286.59 192l-31.47-52.58h-62.3L161.41 192z"]
  },
      Ny = {
    prefix: "fas",
    iconName: "tape",
    icon: [640, 512, [], "f4db", "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"]
  },
      gy = {
    prefix: "fas",
    iconName: "tasks",
    icon: [512, 512, [], "f0ae", "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      Hy = {
    prefix: "fas",
    iconName: "tasks-alt",
    icon: [512, 512, [], "f828", "M488 351H24c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h464c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24zm-24 80H289v-32h175v32zm24-240H24c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h464c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24zm-24 80H161v-32h303v32zm24-240H24C10.7 31 0 41.7 0 55v80c0 13.3 10.7 24 24 24h464c13.3 0 24-10.7 24-24V55c0-13.3-10.7-24-24-24zm-24 80H353V79h111v32z"]
  },
      Vy = {
    prefix: "fas",
    iconName: "taxi",
    icon: [512, 512, [], "f1ba", "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      xy = {
    prefix: "fas",
    iconName: "teeth",
    icon: [640, 512, [], "f62e", "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"]
  },
      wy = {
    prefix: "fas",
    iconName: "teeth-open",
    icon: [640, 512, [], "f62f", "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"]
  },
      yy = {
    prefix: "fas",
    iconName: "telescope",
    icon: [640, 512, [], "e03e", "M380.41991,92.1336,74.29894,241.7427c-8.31835,4.06444-12.27733,13.25583-9.05663,21.02925l8.74413,21.10934L9.881,310.43593a16.00146,16.00146,0,0,0-8.66015,20.90425L21.27748,379.762a16.00055,16.00055,0,0,0,20.90429,8.66014l64.10544-26.55464,8.74219,21.10738c3.21874,7.77343,12.51757,11.47459,21.27147,8.46678l127.0019-43.623c.1875.24219.39258.46875.584.709L216.42,490.93949A16.00034,16.00034,0,0,0,231.5977,512H248.459a15.99985,15.99985,0,0,0,15.17772-10.94139l42.16209-126.49585a71.088,71.088,0,0,0,28.44726,0l42.164,126.49585A15.99986,15.99986,0,0,0,391.58787,512h16.85937a16.00062,16.00062,0,0,0,15.17968-21.06051L376.16014,348.52765a71.2877,71.2877,0,0,0,15.85742-44.52726c0-.13086-.03906-.25-.03906-.38086l66.56637-22.86519ZM320,328.00035a24,24,0,1,1,24-24A24.02622,24.02622,0,0,1,320,328.00035ZM638.77722,216.83064,553.06241,9.88181a15.99768,15.99768,0,0,0-20.90233-8.66014L414.84372,49.81923a15.99966,15.99966,0,0,0-8.65625,20.90426l85.71286,206.94883a16.00055,16.00055,0,0,0,20.90429,8.66014L630.119,237.73489A15.99729,15.99729,0,0,0,638.77722,216.83064Z"]
  },
      by = {
    prefix: "fas",
    iconName: "temperature-down",
    icon: [512, 512, [], "e03f", "M160,322.91V304a16,16,0,0,0-32,0v18.91a48,48,0,1,0,32,0ZM256,112a112,112,0,0,0-224,0V278.5C12.3,303.19,0,334,0,368a144,144,0,0,0,288,0c0-34-12.3-64.91-32-89.5ZM144,448A79.87,79.87,0,0,1,96,304.19V112a48,48,0,0,1,96,0V304.19A79.87,79.87,0,0,1,144,448Zm352-96H448V48a16,16,0,0,0-16-16H400a16,16,0,0,0-16,16V352H336c-14.21,0-21.39,17.25-11.31,27.31l80,96a16,16,0,0,0,22.62,0l80-96C517.34,369.25,510.22,352,496,352Z"]
  },
      Sy = {
    prefix: "fas",
    iconName: "temperature-frigid",
    icon: [576, 512, [], "f768", "M544 278.5V112C544 50.1 493.9 0 432 0S320 50.1 320 112v166.5c-19.7 24.6-32 55.5-32 89.5 0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5zM432 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zM268.3 305.4c5.1-13 11.4-25.7 19.7-37.5v-7.2L224.6 224l63.4-36.6v-56.1l-88 50.8v-56.9L240.2 85c4.7-4.7 4.7-12.3 0-17l-8.5-8.5c-4.7-4.7-12.3-4.7-17 0L200 74.3V44c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v30.3l-14.8-14.8c-4.7-4.7-12.3-4.7-17 0l-8.5 8.5c-4.7 4.7-4.7 12.3 0 17l40.2 40.2v56.9L101.6 153l-15-55.7c-1.7-6.5-8.4-10.3-14.9-8.6L60 91.9c-6.5 1.7-10.3 8.4-8.6 14.9l5.5 20.4-26.6-15.3c-5.8-3.4-13.2-1.4-16.6 4.4l-12.1 21c-3.4 5.8-1.4 13.2 4.4 16.6l26.6 15.3-20.4 5.5c-6.5 1.7-10.3 8.4-8.6 14.9l3.1 11.7c1.7 6.5 8.4 10.3 14.9 8.6L77.3 195l50.2 29-50.2 29-55.7-15c-6.5-1.7-13.1 2.1-14.9 8.6l-3.1 11.7c-1.7 6.5 2.1 13.1 8.6 14.9l20.4 5.5-26.5 15.4c-5.8 3.4-7.8 10.8-4.4 16.6l12.1 21c3.4 5.8 10.8 7.8 16.6 4.4L57 320.8l-5.5 20.4c-1.7 6.5 2.1 13.1 8.6 14.9l11.7 3.1c6.5 1.7 13.1-2.1 14.9-8.6l14.9-55.6 50.4-29.1v56.9L111.8 363c-4.7 4.7-4.7 12.3 0 17l8.5 8.5c4.7 4.7 12.3 4.7 17 0l14.8-14.8V404c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-30.3l14.8 14.8c4.7 4.7 12.3 4.7 17 0l8.5-8.5c4.7-4.7 4.7-12.3 0-17L200 322.8v-56.9l68.3 39.5zM448 322.9V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"]
  },
      Ty = {
    prefix: "fas",
    iconName: "temperature-high",
    icon: [512, 512, [], "f769", "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"]
  },
      Dy = {
    prefix: "fas",
    iconName: "temperature-hot",
    icon: [640, 512, [], "f76a", "M352 267.9V112c0-16.9 3.5-33 8.9-48.1L279 91.2 237.6 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1L91.2 169 8.4 210.4c-11.2 5.6-11.2 21.5 0 27.1L91.2 279l-29.3 87.9c-4 11.9 7.3 23.1 19.2 19.2l87.9-29.3 41.4 82.8c5.6 11.2 21.6 11.2 27.1 0l41.4-82.9 41.1 13.7c0-.8-.1-1.6-.1-2.5.1-35.8 11.1-70.2 32.1-100zm-60.1 24c-37.4 37.4-98.3 37.4-135.8 0s-37.4-98.4 0-135.8c37.4-37.4 98.3-37.4 135.8 0 37.4 37.4 37.4 98.4 0 135.8zM224 160c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm384 118.5V112C608 50.1 557.9 0 496 0S384 50.1 384 112v166.5c-19.7 24.6-32 55.5-32 89.5 0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5zM496 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"]
  },
      jy = {
    prefix: "fas",
    iconName: "temperature-low",
    icon: [512, 512, [], "f76b", "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"]
  },
      Ey = {
    prefix: "fas",
    iconName: "temperature-up",
    icon: [512, 512, [], "e040", "M160,322.91V112a16,16,0,0,0-32,0V322.91a48,48,0,1,0,32,0ZM256,112a112,112,0,0,0-224,0V278.5C12.3,303.19,0,334,0,368a144,144,0,0,0,288,0c0-34-12.3-64.91-32-89.5ZM144,448A79.87,79.87,0,0,1,96,304.19V112a48,48,0,0,1,96,0V304.19A79.87,79.87,0,0,1,144,448ZM507.3,132.69l-80-96a16,16,0,0,0-22.63,0l-80,96C314.66,142.75,321.78,160,336,160h48V464a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V160h48C510.19,160,517.36,142.75,507.3,132.69Z"]
  },
      ky = {
    prefix: "fas",
    iconName: "tenge",
    icon: [384, 512, [], "f7d7", "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"]
  },
      Iy = {
    prefix: "fas",
    iconName: "tennis-ball",
    icon: [496, 512, [], "f45e", "M219 79.1c-.9-27.9 5.6-52.4 18.4-71.1C113.8 13.2 5.8 110.6 0 245.3c18.7-12.9 43.1-19.6 71.1-18.4C150 228.8 221.2 150.3 219 79.1zm207.4 157.8c19.4.4 64.8-3.1 58.7-54.8-11.6-37.2-32-72.3-61.5-101.8S359 30.4 321.8 18.8c-51.7-6-55.4 39.2-54.8 58.7 1.5 47.1-21.6 101.6-58.7 138.7-37.1 37.3-91.3 60.6-138.7 58.8-19.6-.5-64.9 3.1-58.7 55 11.6 37.2 31.9 72.2 61.4 101.7s64.5 49.8 101.7 61.4c51.8 6 55.6-39.1 55-58.7-1.5-47.1 21.6-101.6 58.7-138.7 37.2-37.2 91.9-60.7 138.7-58.8zm-1.5 48.1c-71.5-2.6-150.3 70.4-147.9 147.9.9 27.9-5.6 52.4-18.5 71.1 121-5.1 231.6-100.1 237.4-237.4-18.6 12.8-43.1 19.3-71 18.4z"]
  },
      Oy = {
    prefix: "fas",
    iconName: "terminal",
    icon: [640, 512, [], "f120", "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"]
  },
      Qy = {
    prefix: "fas",
    iconName: "text",
    icon: [448, 512, [], "f893", "M432 32a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32H264v304h40a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H144a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h40V112H64v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16z"]
  },
      Zy = {
    prefix: "fas",
    iconName: "text-height",
    icon: [576, 512, [], "f034", "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"]
  },
      Uy = {
    prefix: "fas",
    iconName: "text-size",
    icon: [640, 512, [], "f894", "M624 32H272a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h88v304h-40a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h88v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM304 224H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h56v128H96a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V288h56v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16z"]
  },
      By = {
    prefix: "fas",
    iconName: "text-width",
    icon: [448, 512, [], "f035", "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"]
  },
      Ry = {
    prefix: "fas",
    iconName: "th",
    icon: [512, 512, [], "f00a", "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"]
  },
      Yy = {
    prefix: "fas",
    iconName: "th-large",
    icon: [512, 512, [], "f009", "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"]
  },
      Py = {
    prefix: "fas",
    iconName: "th-list",
    icon: [512, 512, [], "f00b", "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"]
  },
      Fy = {
    prefix: "fas",
    iconName: "theater-masks",
    icon: [640, 512, [], "f630", "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"]
  },
      Wy = {
    prefix: "fas",
    iconName: "thermometer",
    icon: [512, 512, [], "f491", "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"]
  },
      Gy = {
    prefix: "fas",
    iconName: "thermometer-empty",
    icon: [256, 512, [], "f2cb", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]
  },
      qy = {
    prefix: "fas",
    iconName: "thermometer-full",
    icon: [256, 512, [], "f2c7", "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"]
  },
      Jy = {
    prefix: "fas",
    iconName: "thermometer-half",
    icon: [256, 512, [], "f2c9", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]
  },
      Ky = {
    prefix: "fas",
    iconName: "thermometer-quarter",
    icon: [256, 512, [], "f2ca", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]
  },
      Xy = {
    prefix: "fas",
    iconName: "thermometer-three-quarters",
    icon: [256, 512, [], "f2c8", "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"]
  },
      _y = {
    prefix: "fas",
    iconName: "theta",
    icon: [384, 512, [], "f69e", "M192 8C84.34 8 0 116.94 0 256s84.34 248 192 248 192-108.94 192-248S299.66 8 192 8zm0 96c41.44 0 77.35 44.41 90.43 104H101.57c13.08-59.59 48.99-104 90.43-104zm0 304c-41.44 0-77.35-44.41-90.43-104h180.86c-13.08 59.59-48.99 104-90.43 104z"]
  },
      $y = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [512, 512, [], "f165", "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"]
  },
      cb = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [512, 512, [], "f164", "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"]
  },
      eb = {
    prefix: "fas",
    iconName: "thumbtack",
    icon: [384, 512, [], "f08d", "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"]
  },
      ab = {
    prefix: "fas",
    iconName: "thunderstorm",
    icon: [512, 512, [], "f76c", "M337 288h-72.1l22.6-77.1c2.5-9.5-4.6-18.9-14.5-18.9h-82c-7.5 0-13.9 5.6-14.9 13l-16 130c-1.2 9 5.8 17 14.9 17h81l-31.6 141.5c-2.2 9.5 5 18.5 14.6 18.5 5.2 0 10.2-2.7 13-7.5l98-194c5.7-10-1.5-22.5-13-22.5zm79-160c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h32.5l15.9-119.2c3.1-23.3 23.1-40.8 46.6-40.8h85c14.7 0 28.3 6.7 37.3 18.4s11.9 26.5 8.1 40.7L310.5 260H341c16.7 0 32.3 9 40.7 23.5 6.4 11.2 7.8 24.4 4.3 36.5h30c53 0 96-43 96-96s-43-96-96-96z"]
  },
      nb = {
    prefix: "fas",
    iconName: "thunderstorm-moon",
    icon: [576, 512, [], "f76d", "M567.9 223.8c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM276 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm74.5-110.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h16.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2 8.4 10.9 11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44.2 0 80-35.8 80-80 .1-39.2-28.1-71.7-65.4-78.5z"]
  },
      tb = {
    prefix: "fas",
    iconName: "thunderstorm-sun",
    icon: [576, 512, [], "f76e", "M124.1 259.9c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zM436 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm74.5-110.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h16.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2 8.4 10.9 11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44.2 0 80-35.8 80-80 .1-39.2-28.1-71.7-65.4-78.5z"]
  },
      rb = {
    prefix: "fas",
    iconName: "ticket",
    icon: [576, 512, [], "f145", "M576 208v-96c0-26.51-21.49-48-48-48H48C21.49 64 0 85.49 0 112v96c26.51 0 48 21.49 48 48s-21.49 48-48 48v96c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48v-96c-26.51 0-48-21.49-48-48s21.49-48 48-48z"]
  },
      ib = {
    prefix: "fas",
    iconName: "ticket-alt",
    icon: [576, 512, [], "f3ff", "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"]
  },
      ob = {
    prefix: "fas",
    iconName: "tilde",
    icon: [512, 512, [], "f69f", "M339.54 381.51c-35.52-6.48-66.75-27.68-89.31-55.87l-66.52-83.15C174.33 230.73 160.3 224 145.25 224 118.09 224 96 246.09 96 273.25V321c0 17.67-14.33 32-32 32H32c-17.67 0-32-14.33-32-32v-40.92c0-78.1 58.67-147.33 136.64-151.83 47.6-2.75 92.54 17.39 122.05 54.27l69.59 87c9.39 11.75 23.42 18.48 38.47 18.48 27.16 0 49.25-22.09 49.25-49.25V192c0-17.67 14.33-32 32-32h32c17.67 0 32 14.33 32 32v46.75c0 89-80.45 159.56-172.46 142.76z"]
  },
      lb = {
    prefix: "fas",
    iconName: "times",
    icon: [352, 512, [], "f00d", "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"]
  },
      fb = {
    prefix: "fas",
    iconName: "times-circle",
    icon: [512, 512, [], "f057", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"]
  },
      sb = {
    prefix: "fas",
    iconName: "times-hexagon",
    icon: [576, 512, [], "f2ee", "M553.5 231.8c8.7 14.9 8.7 33.4 0 48.4l-112 192c-8.6 14.7-24.4 23.8-41.5 23.8H176c-17.1 0-32.9-9.1-41.5-23.8l-112-192c-8.7-14.9-8.7-33.4 0-48.4l112-192C143.1 25.1 158.9 16 176 16h224c17.1 0 32.9 9.1 41.5 23.8l112 192zM409.6 338c4.7-4.7 4.7-12.3 0-17l-65-65 65.1-65.1c4.7-4.7 4.7-12.3 0-17L370 134.4c-4.7-4.7-12.3-4.7-17 0l-65 65-65.1-65.1c-4.7-4.7-12.3-4.7-17 0L166.4 174c-4.7 4.7-4.7 12.3 0 17l65.1 65.1-65.1 65.1c-4.7 4.7-4.7 12.3 0 17l39.6 39.6c4.7 4.7 12.3 4.7 17 0l65.1-65.1 65.1 65.1c4.7 4.7 12.3 4.7 17 0l39.4-39.8z"]
  },
      ub = {
    prefix: "fas",
    iconName: "times-octagon",
    icon: [512, 512, [], "f2f0", "M497.9 150.5c9 9 14.1 21.2 14.1 33.9v143.1c0 12.7-5.1 24.9-14.1 33.9L361.5 497.9c-9 9-21.2 14.1-33.9 14.1H184.5c-12.7 0-24.9-5.1-33.9-14.1L14.1 361.5c-9-9-14.1-21.2-14.1-33.9V184.5c0-12.7 5.1-24.9 14.1-33.9L150.5 14.1c9-9 21.2-14.1 33.9-14.1h143.1c12.7 0 24.9 5.1 33.9 14.1l136.5 136.4zM377.6 338c4.7-4.7 4.7-12.3 0-17l-65-65 65.1-65.1c4.7-4.7 4.7-12.3 0-17L338 134.4c-4.7-4.7-12.3-4.7-17 0l-65 65-65.1-65.1c-4.7-4.7-12.3-4.7-17 0L134.4 174c-4.7 4.7-4.7 12.3 0 17l65.1 65.1-65.1 65.1c-4.7 4.7-4.7 12.3 0 17l39.6 39.6c4.7 4.7 12.3 4.7 17 0l65.1-65.1 65.1 65.1c4.7 4.7 12.3 4.7 17 0l39.4-39.8z"]
  },
      hb = {
    prefix: "fas",
    iconName: "times-square",
    icon: [448, 512, [], "f2d3", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-54.4 289.1c4.7 4.7 4.7 12.3 0 17L306 377.6c-4.7 4.7-12.3 4.7-17 0L224 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L102.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L280 256l65.6 65.1z"]
  },
      mb = {
    prefix: "fas",
    iconName: "tint",
    icon: [352, 512, [], "f043", "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"]
  },
      vb = {
    prefix: "fas",
    iconName: "tint-slash",
    icon: [640, 512, [], "f5c7", "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"]
  },
      db = {
    prefix: "fas",
    iconName: "tire",
    icon: [512, 512, [], "f631", "M256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm0 448c-105.87 0-192-86.13-192-192S150.13 64 256 64s192 86.13 192 192-86.13 192-192 192zm-80-192c0-17.82 6.03-34.12 15.88-47.41l-48.23-66.38C114.27 171.22 96 211.45 96 256c0 8.87 1.22 17.42 2.61 25.89l77.46-25.17c0-.24-.07-.47-.07-.72zm15 46.36l-77.42 25.15c22.86 45.4 66.32 78.17 118.42 86.07v-81.65c-16.69-5.28-31.04-15.64-41-29.57zM256 176c8.87 0 17.25 1.79 25.22 4.45l47.93-65.97C307.14 103.06 282.51 96 256 96s-51.14 7.06-73.15 18.48l47.93 65.97c7.97-2.66 16.35-4.45 25.22-4.45zm112.35-33.79l-48.23 66.38C329.97 221.88 336 238.18 336 256c0 .25-.07.48-.07.73l77.46 25.17c1.39-8.48 2.61-17.02 2.61-25.89 0-44.56-18.27-84.79-47.65-113.8zM280 331.93v81.65c52.1-7.9 95.55-40.67 118.42-86.07L321 302.36c-9.96 13.93-24.31 24.29-41 29.57zM256 224c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
  },
      Mb = {
    prefix: "fas",
    iconName: "tire-flat",
    icon: [512, 512, [], "f632", "M256 160c-26.51 0-51.14 7.06-73.15 18.48l47.93 65.97c7.97-2.66 16.35-4.45 25.22-4.45s17.25 1.79 25.22 4.45l47.93-65.97C307.14 167.06 282.51 160 256 160zM96 320c0 8.87 1.22 17.42 2.61 25.89l77.46-25.17c0-.25-.07-.48-.07-.73 0-17.82 6.03-34.12 15.88-47.41l-48.23-66.38C114.27 235.22 96 275.45 96 320zm224.12-47.41C329.97 285.88 336 302.18 336 320c0 .25-.07.48-.07.73l77.46 25.17c1.39-8.48 2.61-17.02 2.61-25.89 0-44.55-18.27-84.78-47.65-113.79l-48.23 66.37zM256 288c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm224 160h-2.61C499.3 410.36 512 366.71 512 320c0-141.38-114.62-256-256-256S0 178.62 0 320c0 46.71 12.7 90.36 34.61 128H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h448c17.67 0 32-14.33 32-32s-14.33-32-32-32zm-81.3 0h-47.79a160.175 160.175 0 0 0 47.51-56.49L321 366.36c-9.96 13.94-24.31 24.29-41 29.57V448h-48v-52.07c-16.69-5.28-31.04-15.64-41-29.57l-77.42 25.15A160.175 160.175 0 0 0 161.09 448H113.3C82.76 413.99 64 369.2 64 320c0-105.87 86.13-192 192-192s192 86.13 192 192c0 49.2-18.76 93.99-49.3 128z"]
  },
      pb = {
    prefix: "fas",
    iconName: "tire-pressure-warning",
    icon: [512, 512, [], "f633", "M474.5 141.54C458.33 113.26 448 80.61 448 46.09V17.14C448 7.67 440.84 0 432 0h-32c-8.84 0-16 7.16-16 16v48c0 32 15.23 74.85 34.94 109.31C437.95 206.56 448 244.86 448 284.08c0 41.13-12.75 82.49-35.8 118.12-5.72 8.85-15.95 13.79-26.48 13.79H126.29c-10.53 0-20.76-4.95-26.48-13.79-23.05-35.63-35.8-77-35.8-118.12 0-39.22 10.05-77.53 29.06-110.77C112.77 138.85 128 96 128 64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.67-16 17.14v28.95c0 34.53-10.33 67.17-26.5 95.46C13.76 183.06 0 231.81 0 284.08 0 360.89 32.54 430.22 80 480v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c47.46-49.78 80-119.11 80-195.92 0-52.27-13.76-101.02-37.5-142.54zM246.48 256h19.04c8.22 0 15.1-6.23 15.92-14.41l12.8-128c.94-9.42-6.45-17.59-15.92-17.59h-44.64c-9.47 0-16.86 8.17-15.92 17.59l12.8 128c.82 8.18 7.7 14.41 15.92 14.41zm9.52 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
  },
      zb = {
    prefix: "fas",
    iconName: "tire-rugged",
    icon: [512, 512, [], "f634", "M480 192h-9.4c-4.43-14.88-10.27-29.15-17.53-42.56l6.58-6.58c12.5-12.5 12.5-32.76 0-45.26L414.4 52.35c-12.5-12.5-32.76-12.5-45.26 0l-6.58 6.58c-13.41-7.27-27.68-13.1-42.56-17.53V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v9.4c-14.88 4.43-29.15 10.27-42.56 17.53l-6.58-6.58c-12.5-12.5-32.76-12.5-45.26 0L52.35 97.61c-12.5 12.5-12.5 32.76 0 45.26l6.58 6.58c-7.27 13.41-13.1 27.68-17.53 42.56H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h9.4c4.43 14.88 10.27 29.15 17.53 42.56l-6.58 6.58c-12.5 12.5-12.5 32.76 0 45.25l45.25 45.26c12.5 12.5 32.76 12.5 45.26 0l6.58-6.58c13.41 7.27 27.68 13.1 42.56 17.53v9.4c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-9.4c14.88-4.43 29.15-10.27 42.56-17.53l6.58 6.58c12.5 12.5 32.76 12.5 45.26 0l45.25-45.26c12.5-12.5 12.5-32.76 0-45.25l-6.58-6.58c7.27-13.41 13.1-27.68 17.53-42.56h9.4c17.67 0 32-14.33 32-32v-64c0-17.68-14.33-32.01-32-32.01zM256 383.98c-70.69 0-128-57.31-128-128s57.31-128 128-128 128 57.31 128 128c0 70.7-57.31 128-128 128zM256 160c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm0 144c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm72-72c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24zm-144 0c-13.25 0-24 10.74-24 24 0 13.25 10.75 24 24 24s24-10.75 24-24c0-13.26-10.75-24-24-24z"]
  },
      Cb = {
    prefix: "fas",
    iconName: "tired",
    icon: [496, 512, [], "f5c8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"]
  },
      Lb = {
    prefix: "fas",
    iconName: "toggle-off",
    icon: [576, 512, [], "f204", "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"]
  },
      Ab = {
    prefix: "fas",
    iconName: "toggle-on",
    icon: [576, 512, [], "f205", "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"]
  },
      Nb = {
    prefix: "fas",
    iconName: "toilet",
    icon: [384, 512, [], "f7d8", "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"]
  },
      gb = {
    prefix: "fas",
    iconName: "toilet-paper",
    icon: [576, 512, [], "f71e", "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"]
  },
      Hb = {
    prefix: "fas",
    iconName: "toilet-paper-alt",
    icon: [576, 512, [], "f71f", "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zm352 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"]
  },
      Vb = {
    prefix: "fas",
    iconName: "toilet-paper-slash",
    icon: [640, 512, [], "e072", "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"]
  },
      xb = {
    prefix: "fas",
    iconName: "tombstone",
    icon: [512, 512, [], "f720", "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-48-256C448 85.96 362.04 0 256 0S64 85.96 64 192v224h384V192zm-96-8c0 8.84-7.16 16-16 16h-56v128c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16V200h-56c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h56v-48c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v48h56c8.84 0 16 7.16 16 16v16z"]
  },
      wb = {
    prefix: "fas",
    iconName: "tombstone-alt",
    icon: [512, 512, [], "f721", "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-48-256C448 85.96 362.04 0 256 0S64 85.96 64 192v224h384V192z"]
  },
      yb = {
    prefix: "fas",
    iconName: "toolbox",
    icon: [512, 512, [], "f552", "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"]
  },
      bb = {
    prefix: "fas",
    iconName: "tools",
    icon: [512, 512, [], "f7d9", "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"]
  },
      Sb = {
    prefix: "fas",
    iconName: "tooth",
    icon: [448, 512, [], "f5c9", "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"]
  },
      Tb = {
    prefix: "fas",
    iconName: "toothbrush",
    icon: [640, 512, [], "f635", "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM64 416V232c0-4.42-3.58-8-8-8H40c-4.42 0-8 3.58-8 8v184h32zm64 0V232c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v184h32zm64 0V232c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v184h32zm64 0V232c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v184h32zm64 0V232c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v184h32zm64 0V232c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v184h32zm32 0h32V232c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v184zM64 192h352c35.35 0 64-28.65 64-64C480 57.31 422.69 0 352 0c23.62 23.62 6.89 64-26.51 64H64C28.65 64 0 92.65 0 128s28.65 64 64 64z"]
  },
      Db = {
    prefix: "fas",
    iconName: "torah",
    icon: [640, 512, [], "f6a0", "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"]
  },
      jb = {
    prefix: "fas",
    iconName: "torii-gate",
    icon: [512, 512, [], "f6a1", "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"]
  },
      Eb = {
    prefix: "fas",
    iconName: "tornado",
    icon: [512, 512, [], "f76f", "M393.8 96H12.2c9.7 34.2 24.5 62.1 42.7 85.3h349.8c-14.1-23.1-20.6-50.2-10.9-85.3zm35.4-70.8c7.4-10.6 0-25.2-12.9-25.2H16.1C7.1 0-.3 7.6 0 16.5c.6 17 2.5 32.6 5.1 47.5h401.1c5.9-12.1 13.3-24.9 23-38.8zM299 330.7c33 20.5 54.4 45.8 53.3 85.3h125.5c25.1-34.4 34.7-62 34.1-85.3H299zm130.9-117.4h-345c45.1 40.4 101 63.6 150.1 85.3h269.4c-14.5-32.1-47.4-56.9-74.5-85.3zm-98.1 275.8c-5 10.6 2.7 22.9 14.4 22.9h27.4c7.9 0 15.8-3 21.7-8.3 22.7-20.3 41-38.6 56.4-55.7H347.4c-3.4 12.5-8.4 26.1-15.6 41.1z"]
  },
      kb = {
    prefix: "fas",
    iconName: "tractor",
    icon: [640, 512, [], "f722", "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"]
  },
      Ib = {
    prefix: "fas",
    iconName: "trademark",
    icon: [640, 512, [], "f25c", "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"]
  },
      Ob = {
    prefix: "fas",
    iconName: "traffic-cone",
    icon: [512, 512, [], "f636", "M362.12 192H149.88l-38.21 96h288.65l-38.2-96zM289.73 10.08A16.01 16.01 0 0 0 274.86 0h-37.72a16.01 16.01 0 0 0-14.87 10.08L175.35 128h161.3L289.73 10.08zM496 448h-32l-38.21-96H86.21L48 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"]
  },
      Qb = {
    prefix: "fas",
    iconName: "traffic-light",
    icon: [384, 512, [], "f637", "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"]
  },
      Zb = {
    prefix: "fas",
    iconName: "traffic-light-go",
    icon: [384, 512, [], "f638", "M192 208c-17.64 0-32 14.36-32 32s14.36 32 32 32 32-14.36 32-32-14.36-32-32-32zm0-128c-17.64 0-32 14.36-32 32s14.36 32 32 32 32-14.36 32-32-14.36-32-32-32zm192 112h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"]
  },
      Ub = {
    prefix: "fas",
    iconName: "traffic-light-slow",
    icon: [384, 512, [], "f639", "M192 336c-17.64 0-32 14.36-32 32s14.36 32 32 32 32-14.36 32-32-14.36-32-32-32zm192-144h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-80c-17.64 0-32 14.36-32 32s14.36 32 32 32 32-14.36 32-32-14.36-32-32-32z"]
  },
      Bb = {
    prefix: "fas",
    iconName: "traffic-light-stop",
    icon: [384, 512, [], "f63a", "M192 336c-17.64 0-32 14.36-32 32s14.36 32 32 32 32-14.36 32-32-14.36-32-32-32zm0-128c-17.64 0-32 14.36-32 32s14.36 32 32 32 32-14.36 32-32-14.36-32-32-32zm192-16h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"]
  },
      Rb = {
    prefix: "fas",
    iconName: "trailer",
    icon: [640, 512, [], "e041", "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"]
  },
      Yb = {
    prefix: "fas",
    iconName: "train",
    icon: [448, 512, [], "f238", "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"]
  },
      Pb = {
    prefix: "fas",
    iconName: "tram",
    icon: [512, 512, [], "f7da", "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"]
  },
      Fb = {
    prefix: "fas",
    iconName: "transgender",
    icon: [384, 512, [], "f224", "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      Wb = {
    prefix: "fas",
    iconName: "transgender-alt",
    icon: [480, 512, [], "f225", "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      Gb = {
    prefix: "fas",
    iconName: "transporter",
    icon: [512, 512, [], "e042", "M384.00049,448H327.999V238.7793l31.42272,37.70508a31.99572,31.99572,0,0,0,49.15756-40.96876l-70.39251-84.48437A63.843,63.843,0,0,0,289.01358,128h-66.033A63.7877,63.7877,0,0,0,173.823,151.03125l-70.40813,84.48437a31.99572,31.99572,0,0,0,49.15756,40.96876l31.42272-37.70508V448h-56.0015A31.99951,31.99951,0,0,0,95.9928,480v32H416.00134V480A31.99951,31.99951,0,0,0,384.00049,448Zm-120.00321,0H247.99686V320h16.00042ZM255.958,96l.01953-.00195L255.99707,96a48,48,0,1,0,0-96l-.01953.002L255.958,0a48,48,0,1,0,0,96ZM509.789,44.43164,480.005,32.01172,467.58475,2.22656a3.99471,3.99471,0,0,0-7.15644,0L448.00806,32.01172l-29.784,12.41992a3.99921,3.99921,0,0,0,0,7.1543l29.784,12.41992L460.42831,93.791a3.99628,3.99628,0,0,0,7.15644,0L480.005,64.00586l29.784-12.41992a3.99921,3.99921,0,0,0,0-7.1543ZM63.99194,96,51.57169,66.21484a3.99313,3.99313,0,0,0-7.15449,0L31.997,96,2.211,108.41992a3.99921,3.99921,0,0,0,0,7.1543l29.786,12.41992L44.4172,157.7793a3.9947,3.9947,0,0,0,7.15449,0l12.42025-29.78516,29.786-12.41992a4.00079,4.00079,0,0,0,0-7.1543Z"]
  },
      qb = {
    prefix: "fas",
    iconName: "transporter-1",
    icon: [512, 512, [], "e043", "M263.99728,416H327.999V384H263.99728ZM152.57243,276.48438l31.42272-37.70508V352h64.00171V320h16.00042v32H327.999V238.7793l31.42272,37.70508a31.99572,31.99572,0,0,0,49.15756-40.96876l-70.39251-84.48437A63.843,63.843,0,0,0,289.01358,128h-66.033A63.7877,63.7877,0,0,0,173.823,151.03125l-70.40813,84.48437a31.99572,31.99572,0,0,0,49.15756,40.96876ZM255.958,96l.01953-.00195L255.99707,96a48,48,0,1,0,0-96l-.01953.002L255.958,0a48,48,0,1,0,0,96ZM183.99515,416h64.00171V384H183.99515ZM509.789,364.41992,480.005,352l-12.42026-29.78516a3.99471,3.99471,0,0,0-7.15644,0L448.00806,352l-29.784,12.41992a3.99921,3.99921,0,0,0,0,7.1543l29.784,12.41992,12.42025,29.78516a3.99628,3.99628,0,0,0,7.15644,0L480.005,383.99414l29.784-12.41992a3.99921,3.99921,0,0,0,0-7.1543ZM63.99194,128.002,51.57169,98.21875a3.99313,3.99313,0,0,0-7.15449,0L31.997,128.002,2.211,140.42188a4.00078,4.00078,0,0,0,0,7.15624l29.786,12.41993,12.42025,29.7832a3.99313,3.99313,0,0,0,7.15449,0l12.42025-29.7832,29.786-12.41993a4.00236,4.00236,0,0,0,0-7.15624ZM384.00049,448H127.99365A31.99951,31.99951,0,0,0,95.9928,480v32H416.00134V480A31.99951,31.99951,0,0,0,384.00049,448Z"]
  },
      Jb = {
    prefix: "fas",
    iconName: "transporter-2",
    icon: [512, 512, [], "e044", "M328.00024,320h-64.002v32h64.002Zm-64.002,96h64.002V384h-64.002ZM255.959,96l.01953-.00195L255.99805,96a48,48,0,1,0,0-96l-.01954.002L255.959,0a48,48,0,1,0,0,96Zm72.04126,160H183.99585v32H328.00024Zm31.42284,20.48438a31.98515,31.98515,0,0,0,45.06387,4.09374A31.45531,31.45531,0,0,0,415.57323,256h-73.221Zm-21.235-125.45313A63.84341,63.84341,0,0,0,289.01468,128H222.98141a63.78806,63.78806,0,0,0-49.15775,23.03125L113.01321,224H398.98679ZM384.002,448H127.99414a31.99957,31.99957,0,0,0-32.001,32v32H416.00293V480A31.99957,31.99957,0,0,0,384.002,448ZM247.9978,320h-64.002v32h64.002ZM152.573,276.48438,169.64385,256h-73.221a31.45534,31.45534,0,0,0,11.08628,24.57812A32.00632,32.00632,0,0,0,152.573,276.48438ZM183.99585,416h64.002V384h-64.002ZM509.791,140.416l-29.78607-12.41993-12.4203-29.7832a3.99315,3.99315,0,0,0-7.15451,0l-12.4203,29.7832L418.2237,140.416a4.00079,4.00079,0,0,0,0,7.15625l29.78607,12.41992,12.4203,29.7832a3.99315,3.99315,0,0,0,7.15451,0l12.4203-29.7832L509.791,147.57227a4.00237,4.00237,0,0,0,0-7.15625ZM63.99023,32.002,51.56993,2.21875a3.99315,3.99315,0,0,0-7.15451,0L31.99512,32.002,2.20905,44.42188a4.00078,4.00078,0,0,0,0,7.15429L31.99512,63.99609l12.4203,29.78516a3.99315,3.99315,0,0,0,7.15451,0l12.4203-29.78516L93.7763,51.57617a3.99921,3.99921,0,0,0,0-7.15429Z"]
  },
      Kb = {
    prefix: "fas",
    iconName: "transporter-3",
    icon: [512, 512, [], "e045", "M372.32386,192H139.68l-26.66683,32H398.98679ZM263.99829,416h64.002V384h-64.002Zm64.002-96h-64.002v32h64.002Zm31.42284-43.51562a31.98515,31.98515,0,0,0,45.06387,4.09374A31.45531,31.45531,0,0,0,415.57323,256h-73.221ZM255.99805,0l-.01954.002L255.959,0a47.95186,47.95186,0,0,0-45.0502,32h90.13947A47.95186,47.95186,0,0,0,255.99805,0ZM255.959,96l.01953-.00195L255.99805,96a47.87741,47.87741,0,0,0,45.06-32H210.899A47.87741,47.87741,0,0,0,255.959,96Zm82.22908,55.03125A63.84341,63.84341,0,0,0,289.01468,128H222.98141a63.78806,63.78806,0,0,0-49.15775,23.03125L166.34883,160H345.66094ZM247.9978,320h-64.002v32h64.002ZM152.573,276.48438,169.64385,256h-73.221a31.45534,31.45534,0,0,0,11.08628,24.57812A32.00632,32.00632,0,0,0,152.573,276.48438ZM384.002,448H127.99414a31.99957,31.99957,0,0,0-32.001,32v32H416.00293V480A31.99957,31.99957,0,0,0,384.002,448ZM328.00024,256H183.99585v32H328.00024ZM183.99585,416h64.002V384h-64.002ZM509.791,44.43164,480.00488,32.01172,467.58458,2.22656a3.99315,3.99315,0,0,0-7.15451,0l-12.4203,29.78516L418.2237,44.43164a3.99921,3.99921,0,0,0,0,7.1543l29.78607,12.41992L460.43007,93.791a3.99472,3.99472,0,0,0,7.15451,0l12.4203-29.78516L509.791,51.58594a4.00079,4.00079,0,0,0,0-7.1543ZM63.99023,352.00391,51.56993,322.2207a3.99315,3.99315,0,0,0-7.15451,0l-12.4203,29.78321L2.20905,364.42383a4.00237,4.00237,0,0,0,0,7.15625L31.99512,384l12.4203,29.7832a3.99315,3.99315,0,0,0,7.15451,0L63.99023,384,93.7763,371.58008a4.00079,4.00079,0,0,0,0-7.15625Z"]
  },
      Xb = {
    prefix: "fas",
    iconName: "transporter-empty",
    icon: [512, 512, [], "e046", "M384.002,447.99976H127.99414a31.99963,31.99963,0,0,0-32.001,32.00012V512H416.00293V479.99988A31.99963,31.99963,0,0,0,384.002,447.99976ZM509.791,268.419l-29.78607-12.42-12.4203-29.78527a3.99315,3.99315,0,0,0-7.15451,0L448.00977,255.999l-29.78607,12.42a3.99924,3.99924,0,0,0,0,7.15433l29.78607,12.42,12.4203,29.78527a3.99471,3.99471,0,0,0,7.15451,0l12.4203-29.78527,29.78607-12.42a4.00082,4.00082,0,0,0,0-7.15433ZM63.99023,32.00208,51.56993,2.21876a3.99314,3.99314,0,0,0-7.15451,0L31.99512,32.00208,2.20905,44.422a4.0024,4.0024,0,0,0,0,7.15628l29.78607,12.42,12.4203,29.78332a3.99314,3.99314,0,0,0,7.15451,0l12.4203-29.78332,29.78607-12.42a4.00082,4.00082,0,0,0,0-7.15628Z"]
  },
      _b = {
    prefix: "fas",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"]
  },
      $b = {
    prefix: "fas",
    iconName: "trash-alt",
    icon: [448, 512, [], "f2ed", "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      cS = {
    prefix: "fas",
    iconName: "trash-restore",
    icon: [448, 512, [], "f829", "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      eS = {
    prefix: "fas",
    iconName: "trash-restore-alt",
    icon: [448, 512, [], "f82a", "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      aS = {
    prefix: "fas",
    iconName: "trash-undo",
    icon: [448, 512, [], "f895", "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm47.18-189.47l84-81.59c8.84-8.59 23.61-2.24 23.61 10.47v41.67c82.47.8 144 18.36 144 103.92 0 34.29-20.14 68.26-42.41 86-6.95 5.54-16.85-1.41-14.29-10.4 23.08-80.93-6.55-101.74-87.3-102.72v44.69c0 12.69-14.76 19.07-23.61 10.47l-84-81.59a14.7 14.7 0 0 1 0-20.92zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"]
  },
      nS = {
    prefix: "fas",
    iconName: "trash-undo-alt",
    icon: [448, 512, [], "f896", "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm68.38-186.47l84-81.59c8.84-8.59 23.61-2.24 23.61 10.47v41.67c82.47.8 144 18.36 144 103.92 0 34.29-20.14 68.26-42.41 86-6.95 5.54-16.85-1.41-14.29-10.4 23.08-80.93-6.55-101.74-87.3-102.72v44.69c0 12.69-14.76 19.07-23.61 10.47l-84-81.59a14.7 14.7 0 0 1 0-20.92z"]
  },
      tS = {
    prefix: "fas",
    iconName: "treasure-chest",
    icon: [576, 512, [], "f723", "M0 448c0 17.67 14.33 32 32 32h64V288H0v160zm0-320v128h96V32C42.98 32 0 74.98 0 128zm352 208c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48h-96v192h320V288h-96v48zm128 144h64c17.67 0 32-14.33 32-32V288h-96v192zM128 256h96v-48c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v48h96V32H128v224zM480 32v224h96V128c0-53.02-42.98-96-96-96zM304 304v-64c0-8.84-7.16-16-16-16s-16 7.16-16 16v64c0 8.84 7.16 16 16 16s16-7.16 16-16z"]
  },
      rS = {
    prefix: "fas",
    iconName: "tree",
    icon: [384, 512, [], "f1bb", "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"]
  },
      iS = {
    prefix: "fas",
    iconName: "tree-alt",
    icon: [512, 512, [], "f400", "M496 235c-10.67-16-25-27.67-43-35h1c8.67-16 11.83-32.5 9.5-49.5s-9.17-31.67-20.5-44S417.83 86 401.5 82s-32.83-2.33-49.5 5c-2.67-24.67-13.17-45.33-31.5-62S280.67 0 256 0s-46.17 8.33-64.5 25-28.83 37.33-31.5 62c-16.67-7.33-33.17-9-49.5-5S80.33 94.17 69 106.5s-18.17 27-20.5 44S49.67 184 59 200c-18 7.33-32.33 19-43 35S0 268.67 0 288c0 26.67 9.33 49.33 28 68s41.33 28 68 28h128v56.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L288 440.45V384h128c26.67 0 49.33-9.33 68-28s28-41.33 28-68c0-19.33-5.33-37-16-53z"]
  },
      oS = {
    prefix: "fas",
    iconName: "tree-christmas",
    icon: [448, 512, [], "f7db", "M224 160l26.7-53.3L304 80l-53.3-26.7L224 0l-26.7 53.3L144 80l53.3 26.7L224 160zm215.6 295.6L349.8 352h36c25.6 0 39.5-26.3 23.2-43.5L262.8 154 224 208l-38.8-54L39 308.5C22.7 325.7 36.6 352 62.2 352h36L8.4 455.6c-19 21.9-3.8 56.4 24.7 56.4h381.7c28.6 0 43.7-34.6 24.8-56.4zM160 312c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm128 128c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"]
  },
      lS = {
    prefix: "fas",
    iconName: "tree-decorated",
    icon: [448, 512, [], "f7dc", "M439.6 455.6L349.8 352h36c25.6 0 39.5-29.2 23.2-48.5L314.1 192h44.8c21.3 0 32.9-22.5 19.3-37.3L243.3 8.2c-10-10.9-28.6-10.9-38.6 0L69.9 154.7c-13.6 14.8-2 37.3 19.3 37.3H134L39 303.5C22.7 322.8 36.6 352 62.2 352h36L8.4 455.6c-19 21.9-3.8 56.4 24.7 56.4h381.7c28.6 0 43.7-34.6 24.8-56.4zM160 312c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm72-152c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24-24-10.7-24-24zm56 280c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"]
  },
      fS = {
    prefix: "fas",
    iconName: "tree-large",
    icon: [448, 512, [], "f7dd", "M439.6 455.6L349.8 352h36c25.6 0 39.5-29.2 23.2-48.5L314.1 192h44.8c21.3 0 32.9-22.5 19.3-37.3L243.3 8.2c-10-10.9-28.6-10.9-38.6 0L69.9 154.7c-13.6 14.8-2 37.3 19.3 37.3H134L39 303.5C22.7 322.8 36.6 352 62.2 352h36L8.4 455.6c-19 21.9-3.8 56.4 24.7 56.4h381.7c28.6 0 43.7-34.6 24.8-56.4z"]
  },
      sS = {
    prefix: "fas",
    iconName: "tree-palm",
    icon: [640, 512, [], "f82b", "M448.76 64c-39.43 0-75.06 11.74-103 30.5C327.14 40.17 265.37 0 191.24 0c-80.62 0-147.37 47.24-159 108.86C30.39 118.79 38.75 128 50 128h54l24-48 33.46 66.92c-3.53 3.07-7.28 5.69-10.66 9.07C93.8 213 80 293.6 115.37 345.38c5.7 8.34 18.12 8.94 26.07 1l146.13-146.14c10.72 104.75-11.42 215-25.85 272.15C256.64 492.52 272 512 292.8 512h55.13c15.75 0 29.67-11.37 31.71-27 14.79-113.47-11.57-236.34-26.41-293H488l24-48 24 48h54c11.25 0 19.61-9.21 17.74-19.14C596.13 111.24 529.38 64 448.76 64z"]
  },
      uS = {
    prefix: "fas",
    iconName: "trees",
    icon: [640, 512, [], "f724", "M298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.39 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.87c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26L298.42 288zm335.89 90.49L554.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L524.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L459.66 4.83c-6.03-6.45-17.28-6.45-23.32 0l-95.06 101.26c11.09 15.37 13.97 35.3 6.34 52.96-4 9.27-10.38 17.03-18.26 22.68l41.54 48.32c13.93 16.25 17.04 39.23 7.94 58.52-4.19 8.89-10.46 16.24-18.11 21.58l41.62 47.15c8.65 9.8 13.34 14.15 13.65 26.69v56.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L480 440.45V416h136.87c9.01 0 17.26-5.2 21.01-13.25 3.79-8.17 2.43-17.47-3.57-24.26z"]
  },
      hS = {
    prefix: "fas",
    iconName: "triangle",
    icon: [576, 512, [], "f2ec", "M329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.9 0 60-40 41.6-72l-240-416z"]
  },
      mS = {
    prefix: "fas",
    iconName: "triangle-music",
    icon: [512, 512, [], "f8e2", "M497.81 368.09l-80.48-130.24-46.49 46.5 72.55 117.4a29 29 0 0 1 .69 30A31.73 31.73 0 0 1 415.87 448H96.13a31.73 31.73 0 0 1-28.21-16.23 29 29 0 0 1 .69-30l159.87-258.7c8.4-13.6 22.05-15.07 27.52-15.07s19.12 1.47 27.52 15.05l44.11 71.37-53 53a56.85 56.85 0 1 0 33.92 33.94l198.7-198.74a16 16 0 0 0 0-22.62l-11.31-11.31a16 16 0 0 0-22.62 0l-99.21 99.23L338 109.39c-11.72-19-29.55-32.22-50-39.34V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v54.05c-20.41 7.12-38.24 20.37-50 39.34L14.19 368.09A92.48 92.48 0 0 0 12 462.92 96.17 96.17 0 0 0 96.13 512h319.74A96.17 96.17 0 0 0 500 462.92a92.48 92.48 0 0 0-2.19-94.83z"]
  },
      vS = {
    prefix: "fas",
    iconName: "trophy",
    icon: [576, 512, [], "f091", "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"]
  },
      dS = {
    prefix: "fas",
    iconName: "trophy-alt",
    icon: [576, 512, [], "f2eb", "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 66.5 77.9 131.7 171.9 142.4C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6C498.4 275.6 576 210.3 576 144V88c0-13.3-10.7-24-24-24zM64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-47.5-16.4-77-49.9-77-70.2zm448 0c0 20.2-29.4 53.8-77 70.2 7-25 11.8-53.6 12.8-86.2H512v16zm-127.3 4.7l-39.6 38.6 9.4 54.6c1.7 9.8-8.7 17.2-17.4 12.6l-49-25.8-49 25.8c-8.8 4.6-19.1-2.9-17.4-12.6l9.4-54.6-39.6-38.6c-7.1-6.9-3.2-19 6.7-20.5l54.8-8 24.5-49.6c4.4-8.9 17.1-8.9 21.5 0l24.5 49.6 54.8 8c9.6 1.5 13.5 13.6 6.4 20.5z"]
  },
      MS = {
    prefix: "fas",
    iconName: "truck",
    icon: [640, 512, [], "f0d1", "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"]
  },
      pS = {
    prefix: "fas",
    iconName: "truck-container",
    icon: [640, 512, [], "f4dc", "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H464c-17.7 0-32 14.3-32 32v144H32c-17.7 0-32 14.3-32 32v27.8c0 40.8 28.7 78.1 69.1 83.5 30.7 4.1 58.3-9.5 74.9-31.7 18.4 24.7 50.4 38.7 85.3 29.7 25.2-6.5 46.1-26.2 54.4-50.8 4.9-14.8 5.4-29.2 2.8-42.4h163.2c-2.7 13.2-2.2 27.6 2.8 42.4 8.4 25.1 29.9 44.9 55.6 51.1 52.8 12.8 100-26.9 100-77.6 0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17.1-6.7-33.3-18.7-45.3zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm-48-176v-48h37.5c4.2 0 8.3 1.7 11.3 4.7l43.3 43.3H480zM32 304h336c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v208c0 17.7 14.3 32 32 32zM304 80h32v176h-32V80zm-80 0h32v176h-32V80zm-80 0h32v176h-32V80zm-80 0h32v176H64V80z"]
  },
      zS = {
    prefix: "fas",
    iconName: "truck-couch",
    icon: [640, 512, [], "f4dd", "M24.1 400L320 320.7v-122c-8.3-4-18-5.6-27.6-3.1-21.3 5.7-34 27.7-28.3 49l6.2 23.2-185.4 49.7-6.2-23.2C73 273 51 260.3 29.7 266c-21.3 5.7-34 27.7-28.3 49l22.7 85zm-2.7-164.9c39.6-10.6 73.7 13.4 85.5 43.4L232 245c-5.4-35.7 16.5-70.7 52.2-80.2 2.6-.7 5.3-.7 8-1.1-9.9-36.9-45.9-55.1-78.7-46.3L58.9 158.8c-32.8 8.8-54.8 42.6-45.1 79.1 2.5-1 5-2.1 7.6-2.8zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      CS = {
    prefix: "fas",
    iconName: "truck-loading",
    icon: [640, 512, [], "f4de", "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      LS = {
    prefix: "fas",
    iconName: "truck-monster",
    icon: [640, 512, [], "f63b", "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"]
  },
      AS = {
    prefix: "fas",
    iconName: "truck-moving",
    icon: [640, 512, [], "f4df", "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"]
  },
      NS = {
    prefix: "fas",
    iconName: "truck-pickup",
    icon: [640, 512, [], "f63c", "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"]
  },
      gS = {
    prefix: "fas",
    iconName: "truck-plow",
    icon: [640, 512, [], "f7de", "M598.6 393.4c-14.5-14.5-22.6-34.1-22.6-54.6V237.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-32v-64c0-17.7-14.3-32-32-32h-45.9l-82-136.7C311.5 40.9 295.7 32 278.9 32H168c-22.1 0-40 17.9-40 40v120H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h5.9c-3.6 10.1-5.9 20.7-5.9 32 0 53 43 96 96 96s96-43 96-96c0-11.3-2.3-21.9-5.9-32h75.8c-3.6 10.1-5.9 20.7-5.9 32 0 53 43 96 96 96s96-43 96-96c0-11.3-2.3-21.9-5.9-32h39.2c3.1 32.6 16.7 63.3 40.1 86.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 96h77.9l57.6 96H192V96zm-32 288c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32zm224 32c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"]
  },
      HS = {
    prefix: "fas",
    iconName: "truck-ramp",
    icon: [640, 512, [], "f4e0", "M384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"]
  },
      VS = {
    prefix: "fas",
    iconName: "trumpet",
    icon: [640, 512, [], "f8e3", "M624 64a16.27 16.27 0 0 0-13 6.67 555.44 555.44 0 0 1-66.19 71.68c-15.38 13-32.93 25.66-52.54 36-5.55 2.94-25.75 13.6-60 13.63H400V160a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v32h-40v-32a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v32h-40v-32a16 16 0 0 0-16-16h-16a16 16 0 0 0-16 16v32H48a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16h33.81C70.78 274.9 64 296.58 64 320a128.14 128.14 0 0 0 128 128h224a96.1 96.1 0 0 0 96-96v-31.43a251.78 251.78 0 0 0-34.67-22.65c-8.63-4.55-18.76-7-29.33-8.41V352a32 32 0 0 1-32 32h-16V256h32c34.48 0 54.66 10.66 60.27 13.62a294.39 294.39 0 0 1 49.17 33.28c39.49 34.65 69.09 73.78 69.25 74A16 16 0 0 0 624 384c12.09 0 16-10.94 16-16V80c0-12-10.81-16-16-16zM176 381.73a63.69 63.69 0 0 1 0-123.46zm88 2.27h-40V256h40zm88 0h-40V256h40z"]
  },
      xS = {
    prefix: "fas",
    iconName: "tshirt",
    icon: [640, 512, [], "f553", "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"]
  },
      wS = {
    prefix: "fas",
    iconName: "tty",
    icon: [512, 512, [], "f1e4", "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"]
  },
      yS = {
    prefix: "fas",
    iconName: "turkey",
    icon: [640, 512, [], "f725", "M596.39 83.63A52.25 52.25 0 0 0 572.46 85a51.78 51.78 0 0 0 10.25-36.3c-2-20.79-16.24-39.48-36.09-46a53.11 53.11 0 0 0-69 41.13 52.26 52.26 0 0 0 .43 20.88c3.53 15.67-1.36 32-14.57 41.19-15.48 10.73-24.23 17.61-48.07 28C377 110.67 333.83 96 288 96 128.94 96 0 269.13 0 384s128.94 128 288 128 288-13.12 288-128c0-50-24.54-110.94-65.24-163.91a193.68 193.68 0 0 0-61 90.2c-19.05 58.14-68.12 99.33-125 104.93q-8 .78-15.7.78c-49.36 0-93.81-23-121.94-63a148 148 0 0 1-23.87-55.58 8 8 0 0 1 7.94-9.42h16.43a8 8 0 0 1 7.71 6.28C207.22 344.46 251.64 384 309.05 384q6.19 0 12.56-.62c45.84-4.51 83.33-39.06 97.74-83.05 20.72-63.26 63.07-101.22 90.64-120.41 14.76-10.27 33.47-8.35 48.61 1.35a52.93 52.93 0 0 0 30.26 8.26c20.9-.57 40.12-14.38 47.52-33.94 12.22-32.3-7.86-66.09-39.99-71.96z"]
  },
      bS = {
    prefix: "fas",
    iconName: "turntable",
    icon: [576, 512, [], "f8e4", "M224 224a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM512 32H64A64 64 0 0 0 0 96v320a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V96a64 64 0 0 0-64-64zM224 416a160 160 0 1 1 160-160 160 160 0 0 1-160 160zm288-148.18a64 64 0 0 1-6.76 28.63l-18.93 37.86a16 16 0 0 1 7.16 21.46l-25.69 51.38a16 16 0 0 1-21.47 7.16L417.69 400a16 16 0 0 1-7.16-21.46l25.69-51.38a16 16 0 0 1 21.47-7.16l18.93-37.87a32 32 0 0 0 3.38-14.32V104a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8z"]
  },
      SS = {
    prefix: "fas",
    iconName: "turtle",
    icon: [576, 512, [], "f726", "M68.25 256h279.51c23.54 0 40.97-19.8 35.1-40.04C362.84 146.97 292.33 64 208.41 64h-.82c-83.91 0-154.43 82.97-174.44 151.96C27.27 236.2 44.71 256 68.25 256zm484.03-118.75l-48.65-34.75c-35.17-17.42-80.49 1.57-86.81 40.31-.54 3.32-.82 6.72-.82 10.19v71.22c-.03 13.88-4.6 27.18-13.27 38.44-12.42 16.11-31.25 25.34-51.68 25.34H18.6C8.33 288 0 296.33 0 306.6c0 8 5.12 15.11 12.71 17.64l98.29 22.1L66.17 424c-6.16 10.67 1.54 24 13.86 24h36.95c5.71 0 11-3.05 13.86-8l40.3-69.8c25.99 8.52 45.55 13.8 84.87 13.8s58.89-5.28 84.87-13.8l40.3 69.8c2.86 4.95 8.14 8 13.86 8h36.95c12.32 0 20.01-13.33 13.86-24l-47.21-81.76c21.25-8.42 40.36-21.78 54.81-40.53 14.08-18.28 22.47-39.4 25.29-61.7h40.62c31.29 0 56.65-25.36 56.65-56.65a56.7 56.7 0 0 0-23.73-46.11zM480 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      TS = {
    prefix: "fas",
    iconName: "tv",
    icon: [640, 512, [], "f26c", "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"]
  },
      DS = {
    prefix: "fas",
    iconName: "tv-alt",
    icon: [640, 512, [], "f8e5", "M520 448H120a24 24 0 0 0-24 24v16a24 24 0 0 0 24 24h400a24 24 0 0 0 24-24v-16a24 24 0 0 0-24-24zM592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h544a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"]
  },
      jS = {
    prefix: "fas",
    iconName: "tv-music",
    icon: [640, 512, [], "f8e6", "M512 448H128a32 32 0 0 0 0 64h384a32 32 0 0 0 0-64zM240 320c26.5 0 48-14.33 48-32v-84.84l96-37.52V226a69.89 69.89 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32 48-14.33 48-32V112a16 16 0 0 0-20.81-15.25l-128 47.25A16 16 0 0 0 256 159.25V258a69.89 69.89 0 0 0-16-2c-26.5 0-48 14.33-48 32s21.5 32 48 32zM592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h544a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"]
  },
      ES = {
    prefix: "fas",
    iconName: "tv-retro",
    icon: [512, 512, [], "f401", "M464 96H338.8l35.7-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 94.2 182.8 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L173.2 96H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h16v32h48l21.3-32h245.3l21.3 32h48v-32h16c26.5 0 48-21.5 48-48V144c.1-26.5-21.4-48-47.9-48zm-72 312s0 8-168 8c-152 0-152-8-152-8s-8 0-8-120 8-120 8-120 0-8 152-8c168 0 168 8 168 8s8 0 8 120-8 120-8 120zm72-100c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v8z"]
  },
      kS = {
    prefix: "fas",
    iconName: "typewriter",
    icon: [512, 512, [], "f8e7", "M480 192h-32V77.26a32 32 0 0 0-9.38-22.64L393.38 9.38A32 32 0 0 0 370.73 0H96a32 32 0 0 0-32 32v160H32a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32v160a64 64 0 0 0 64 64h320a64 64 0 0 0 64-64V288a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32zM128 64h192v48a16 16 0 0 0 16 16h48v64h-18.75a32 32 0 0 0-22.62 9.37l-13.26 13.26a32 32 0 0 1-22.62 9.37h-101.5a32 32 0 0 1-22.62-9.37l-13.26-13.26a32 32 0 0 0-22.62-9.37H128zm240 232v16a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8zm-64 64a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8zm-8-40h-16a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8zm-56 40a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8zm-8-40h-16a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8zm-56 40a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8zm-8-40h-16a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8zm-64 0H88a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8zm32 64h-16a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8zm232 56a8 8 0 0 1-8 8H152a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h208a8 8 0 0 1 8 8zm32-64a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8zm32-64a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8z"]
  },
      IS = {
    prefix: "fas",
    iconName: "ufo",
    icon: [640, 512, [], "e047", "M494.73633,212.84375C481.5332,128.67773,408.32031,64,320,64S158.4668,128.67773,145.26367,212.84375C57.86328,235.69336,0,275.11719,0,320c0,70.69141,143.26953,128,320,128s320-57.30859,320-128C640,275.11719,582.13672,235.69336,494.73633,212.84375ZM128,360a24,24,0,1,1,24-24A24.00118,24.00118,0,0,1,128,360Zm192,32a24,24,0,1,1,24-24A24.00118,24.00118,0,0,1,320,392ZM447.36133,256.78125a275.4037,275.4037,0,0,1-254.72266,0c-.74023-5.54687-1.70508-11.0332-1.70508-16.78125,0-70.69336,57.78321-128,129.06641-128s129.06641,57.30664,129.06641,128C449.06641,245.74805,448.10156,251.23438,447.36133,256.78125ZM512,360a24,24,0,1,1,24-24A24.00118,24.00118,0,0,1,512,360Z"]
  },
      OS = {
    prefix: "fas",
    iconName: "ufo-beam",
    icon: [640, 512, [], "e048", "M33.69355,481.68452A15.99666,15.99666,0,0,0,40.8477,503.1494l14.31611,7.15822a16.00213,16.00213,0,0,0,21.46635-7.15431L158.316,339.77409a15.87807,15.87807,0,0,0,1.57028-5.79493,454.17592,454.17592,0,0,1-45.60452-13.47659Zm492.02691-161.178A454.88192,454.88192,0,0,1,480.114,333.98111a15.86859,15.86859,0,0,0,1.57028,5.793l81.68581,163.37922a16.00157,16.00157,0,0,0,21.46635,7.15431l14.31611-7.15822a15.99835,15.99835,0,0,0,7.15415-21.46488ZM608,208.0004c0-40.89266-56.534-76.56069-140.68263-96.11151C449.22009,47.57626,390.38147,0,320.006,0S190.79185,47.57626,172.69457,111.88889C88.54593,131.43971,32.01194,167.10774,32.01194,208.0004c0,61.85559,128.93874,112.00022,287.994,112.00022S608,269.856,608,208.0004Zm-479.99,24a24.00005,24.00005,0,1,1,23.9995-24A24.001,24.001,0,0,1,128.01,232.00045Zm191.996,48.00009a24,24,0,1,1,23.9995-24A24.001,24.001,0,0,1,320.006,280.00054ZM424.20889,166.45735a224.72853,224.72853,0,0,1-104.20292,25.543,224.72856,224.72856,0,0,1-104.20292-25.543,102.694,102.694,0,0,1-1.3945-13.73049c0-57.84,47.27636-104.72677,105.59742-104.72677S425.60339,94.8869,425.60339,152.72686A102.694,102.694,0,0,1,424.20889,166.45735Zm87.7931,65.5431a24.00005,24.00005,0,1,1,23.9995-24A24.001,24.001,0,0,1,512.002,232.00045Z"]
  },
      QS = {
    prefix: "fas",
    iconName: "umbrella",
    icon: [576, 512, [], "f0e9", "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"]
  },
      ZS = {
    prefix: "fas",
    iconName: "umbrella-beach",
    icon: [640, 512, [], "f5ca", "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"]
  },
      US = {
    prefix: "fas",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"]
  },
      BS = {
    prefix: "fas",
    iconName: "undo",
    icon: [512, 512, [], "f0e2", "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"]
  },
      RS = {
    prefix: "fas",
    iconName: "undo-alt",
    icon: [512, 512, [], "f2ea", "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"]
  },
      YS = {
    prefix: "fas",
    iconName: "unicorn",
    icon: [640, 512, [], "f727", "M631.98 32H531.73c5.93-6.14 10.4-13.63 12.18-22.36 1.01-4.96-2.88-9.64-7.94-9.64H416c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59 102.04 22.33V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74L544 83.3l92.42-36.65c6.59-4.38 3.48-14.65-4.44-14.65zM480 96c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"]
  },
      PS = {
    prefix: "fas",
    iconName: "union",
    icon: [384, 512, [], "f6a2", "M384 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v240c0 59.2-53.85 106.04-115.13 94.14-45.58-8.85-76.87-51.5-76.87-97.93V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v240c0 114.18 100.17 205.4 217.26 190.38C314.04 465.96 384 378.89 384 281.32V48z"]
  },
      FS = {
    prefix: "fas",
    iconName: "universal-access",
    icon: [512, 512, [], "f29a", "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"]
  },
      WS = {
    prefix: "fas",
    iconName: "university",
    icon: [512, 512, [], "f19c", "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"]
  },
      GS = {
    prefix: "fas",
    iconName: "unlink",
    icon: [512, 512, [], "f127", "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"]
  },
      qS = {
    prefix: "fas",
    iconName: "unlock",
    icon: [448, 512, [], "f09c", "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"]
  },
      JS = {
    prefix: "fas",
    iconName: "unlock-alt",
    icon: [448, 512, [], "f13e", "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"]
  },
      KS = {
    prefix: "fas",
    iconName: "upload",
    icon: [512, 512, [], "f093", "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"]
  },
      XS = {
    prefix: "fas",
    iconName: "usb-drive",
    icon: [640, 512, [], "f8e9", "M624 128H480v256h144a16 16 0 0 0 16-16V144a16 16 0 0 0-16-16zm-40 184a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16zm0-96a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16zM432 96H64a64 64 0 0 0-64 64v192a64 64 0 0 0 64 64h368a16 16 0 0 0 16-16V112a16 16 0 0 0-16-16z"]
  },
      _S = {
    prefix: "fas",
    iconName: "usd-circle",
    icon: [496, 512, [], "f2e8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 376v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16.2c-16.5-.6-32.6-5.8-46.4-15.1-8.7-5.9-10-18.1-2.3-25.2l12-11.3c5.4-5.1 13.3-5.4 19.7-1.6 6.1 3.6 12.9 5.4 19.9 5.4h45c11.3 0 20.5-10.5 20.5-23.4 0-10.6-6.3-19.9-15.2-22.7L205 268c-29-8.8-49.2-37-49.2-68.6 0-39.3 30.6-71.3 68.2-71.4v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16.2c16.5.6 32.6 5.8 46.4 15.1 8.7 5.9 10 18.1 2.3 25.2l-12 11.3c-5.4 5.1-13.3 5.4-19.7 1.6-6.1-3.6-12.9-5.4-19.9-5.4h-45c-11.3 0-20.5 10.5-20.5 23.4 0 10.6 6.3 19.9 15.2 22.7l72 21.9c29 8.8 49.2 37 49.2 68.6.2 39.3-30.4 71.2-68 71.4z"]
  },
      $S = {
    prefix: "fas",
    iconName: "usd-square",
    icon: [448, 512, [], "f2e9", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM248 384v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16.2c-16.5-.6-32.6-5.8-46.4-15.1-8.7-5.9-10-18.1-2.3-25.2l12-11.3c5.4-5.1 13.3-5.4 19.7-1.6 6.1 3.6 12.9 5.4 19.9 5.4h45c11.3 0 20.5-10.5 20.5-23.4 0-10.6-6.3-19.9-15.2-22.7L181 268c-29-8.8-49.2-37-49.2-68.6 0-39.3 30.6-71.3 68.2-71.4v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16.2c16.5.6 32.6 5.8 46.4 15.1 8.7 5.9 10 18.1 2.3 25.2l-12 11.3c-5.4 5.1-13.3 5.4-19.7 1.6-6.1-3.6-12.9-5.4-19.9-5.4h-45c-11.3 0-20.5 10.5-20.5 23.4 0 10.6 6.3 19.9 15.2 22.7l72 21.9c29 8.8 49.2 37 49.2 68.6.2 39.3-30.4 71.2-68 71.4z"]
  },
      cT = {
    prefix: "fas",
    iconName: "user",
    icon: [448, 512, [], "f007", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"]
  },
      eT = {
    prefix: "fas",
    iconName: "user-alien",
    icon: [448, 512, [], "e04a", "M352,384H317.61523c-19.65039,17.98828-39.01953,33.541-55.49023,45.84766a63.66049,63.66049,0,0,1-76.25.00195C169.4043,417.543,150.03516,401.98828,130.38477,384H96A95.99975,95.99975,0,0,0,0,480a32.00033,32.00033,0,0,0,32,32H416a32.00033,32.00033,0,0,0,32-32A95.99975,95.99975,0,0,0,352,384ZM205.0293,404.21484a31.66414,31.66414,0,0,0,37.9414,0C288.459,370.22266,400,277.51172,400,185.68359,400,70.31836,321.18164,0,224,0,126.791,0,48,70.31836,48,185.68359,48,277.51172,159.541,370.22266,205.0293,404.21484ZM240,252a60.00047,60.00047,0,0,1,60-60h24a12.0006,12.0006,0,0,1,12,12v8a60.00047,60.00047,0,0,1-60,60H252a12.0006,12.0006,0,0,1-12-12ZM112,212v-8a12.0006,12.0006,0,0,1,12-12h24a60.00047,60.00047,0,0,1,60,60v8a12.0006,12.0006,0,0,1-12,12H172A60.00047,60.00047,0,0,1,112,212Z"]
  },
      aT = {
    prefix: "fas",
    iconName: "user-alt",
    icon: [512, 512, [], "f406", "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"]
  },
      nT = {
    prefix: "fas",
    iconName: "user-alt-slash",
    icon: [640, 512, [], "f4fa", "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"]
  },
      tT = {
    prefix: "fas",
    iconName: "user-astronaut",
    icon: [448, 512, [], "f4fb", "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"]
  },
      rT = {
    prefix: "fas",
    iconName: "user-chart",
    icon: [640, 512, [], "f6a3", "M208 352h-3.81c-13.93 4.83-28.64 8-44.19 8s-30.26-3.17-44.19-8H112C50.14 352 0 402.14 0 464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48 0-61.86-50.14-112-112-112zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288H307.76c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0zM160 320c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zm168.97-152.97c-9.37-9.37-24.57-9.37-33.94 0l-14.75 14.75c4.68 13.29 7.72 27.35 7.72 42.21 0 6.83-.98 13.41-2.02 19.95l26.02-26 55.03 55.03c9.37 9.37 24.57 9.37 33.94 0l72-72 24.3 24.3c11.34 11.34 30.73 3.31 30.73-12.73V124c0-6.63-5.37-12-12-12h-88.54c-16.04 0-24.07 19.39-12.73 30.73l24.3 24.3L384 222.06l-55.03-55.03z"]
  },
      iT = {
    prefix: "fas",
    iconName: "user-check",
    icon: [640, 512, [], "f4fc", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"]
  },
      oT = {
    prefix: "fas",
    iconName: "user-circle",
    icon: [496, 512, [], "f2bd", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"]
  },
      lT = {
    prefix: "fas",
    iconName: "user-clock",
    icon: [640, 512, [], "f4fd", "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"]
  },
      fT = {
    prefix: "fas",
    iconName: "user-cog",
    icon: [640, 512, [], "f4fe", "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"]
  },
      sT = {
    prefix: "fas",
    iconName: "user-cowboy",
    icon: [448, 512, [], "f8ea", "M438.47 97.8a18.2 18.2 0 0 0-21.92 5.2c-.43.57-44.81 61.59-192.55 61.59C77.12 164.57 32.4 104.21 31.46 103a18 18 0 0 0-21.79-5.37c-7.76 3.53-11.51 11.84-8.79 19.44.35 1 24.66 66 95.14 106.7v.23a128 128 0 0 0 256 0v-.22C422.47 183 446.77 118 447.13 117.07c2.69-7.54-1.03-15.69-8.66-19.27zM313.59 384H296.9a174.1 174.1 0 0 1-145.81 0H134.4A133.82 133.82 0 0 0 9.54 469.8c-7.88 20.39 8.53 42.2 30.4 42.2h368.11c21.87 0 38.28-21.81 30.4-42.2A133.82 133.82 0 0 0 313.59 384zm28.9-270.43C331.44 64.05 310.86 0 278.1 0c-10.33 0-19.55 4.45-27.3 10.47a42.42 42.42 0 0 1-52.08 0C191 4.45 181.75 0 171.42 0c-32.87 0-53.48 64.49-64.51 114.08C133 124 170.75 132.57 224 132.57c54.17 0 92.36-8.84 118.49-19z"]
  },
      uT = {
    prefix: "fas",
    iconName: "user-crown",
    icon: [448, 512, [], "f6a4", "M352 0l-64 32-64-32-64 32L96 0v96h256V0zm-38.4 304h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16H134.4C60.17 304 0 364.17 0 438.4V464c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-25.6c0-74.23-60.17-134.4-134.4-134.4zM224 272c70.69 0 128-57.31 128-128v-16H96v16c0 70.69 57.31 128 128 128z"]
  },
      hT = {
    prefix: "fas",
    iconName: "user-edit",
    icon: [640, 512, [], "f4ff", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"]
  },
      mT = {
    prefix: "fas",
    iconName: "user-friends",
    icon: [640, 512, [], "f500", "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"]
  },
      vT = {
    prefix: "fas",
    iconName: "user-graduate",
    icon: [448, 512, [], "f501", "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"]
  },
      dT = {
    prefix: "fas",
    iconName: "user-hard-hat",
    icon: [448, 512, [], "f82c", "M88 176h272a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8h-8a112 112 0 0 0-68.4-103.2L256 80V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v64l-27.6-55.2A112 112 0 0 0 96 128h-8a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8zm225.6 176h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.4 134.4 0 0 0 0 486.4 25.6 25.6 0 0 0 25.6 512h396.8a25.6 25.6 0 0 0 25.6-25.6A134.4 134.4 0 0 0 313.6 352zM224 320c65.22 0 118.44-48.94 126.39-112H97.61c7.95 63.06 61.17 112 126.39 112z"]
  },
      MT = {
    prefix: "fas",
    iconName: "user-headset",
    icon: [448, 512, [], "f82d", "M320 352h-23.1a174.08 174.08 0 0 1-145.8 0H128A128 128 0 0 0 0 480a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32 128 128 0 0 0-128-128zM48 224a16 16 0 0 0 16-16v-16c0-88.22 71.78-160 160-160s160 71.78 160 160v16a80.09 80.09 0 0 1-80 80h-32a32 32 0 0 0-32-32h-32a32 32 0 0 0 0 64h96a112.14 112.14 0 0 0 112-112v-16C416 86.13 329.87 0 224 0S32 86.13 32 192v16a16 16 0 0 0 16 16zm160 0h32a64 64 0 0 1 55.41 32H304a48.05 48.05 0 0 0 48-48v-16a128 128 0 0 0-256 0c0 40.42 19.1 76 48.35 99.47-.06-1.17-.35-2.28-.35-3.47a64.07 64.07 0 0 1 64-64z"]
  },
      pT = {
    prefix: "fas",
    iconName: "user-injured",
    icon: [448, 512, [], "f728", "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"]
  },
      zT = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [640, 512, [], "f502", "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"]
  },
      CT = {
    prefix: "fas",
    iconName: "user-md",
    icon: [448, 512, [], "f0f0", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"]
  },
      LT = {
    prefix: "fas",
    iconName: "user-md-chat",
    icon: [640, 512, [], "f82e", "M104 424a24 24 0 1 0 24-24 24 24 0 0 0-24 24zm120-168A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 32.65v49A80.13 80.13 0 0 1 384 416v40a16 16 0 0 1-12.86 15.69L339 478.14a8 8 0 0 1-9.41-6.27l-3.14-15.69a8 8 0 0 1 6.28-9.41l19.27-3.86V416a48.08 48.08 0 0 0-57.57-47c-22.79 4.42-38.43 25.75-38.43 49v25l19.29 3.86a8 8 0 0 1 6.28 9.41l-3.14 15.69a8 8 0 0 1-9.41 6.27l-31.17-4.24A16 16 0 0 1 224 458.05V416a80.13 80.13 0 0 1 64-78.38v-46.1a172 172 0 0 1-121.42 2.69A111.51 111.51 0 0 0 144 289v81.6a56 56 0 1 1-32 0v-80.34C48.49 301 0 355.84 0 422.4V464a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48v-41.6c0-72.03-56.82-130.33-128-133.75zM512 0c-70.69 0-128 50.15-128 112 0 28.76 12.75 54.72 33.11 74.55a312.08 312.08 0 0 1-31.29 55.37 9.86 9.86 0 0 0-1.25 9.07c1.09 3.13 3.43 5 6.11 5 39.84 0 72.35-17.13 95.22-34.36A146 146 0 0 0 512 224c70.69 0 128-50.15 128-112S582.69 0 512 0z"]
  },
      AT = {
    prefix: "fas",
    iconName: "user-minus",
    icon: [640, 512, [], "f503", "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"]
  },
      NT = {
    prefix: "fas",
    iconName: "user-music",
    icon: [640, 512, [], "f8eb", "M224 257A128 128 0 1 0 96 129a128 128 0 0 0 128 128zm64 176c0-54.9 48.34-99.39 114.45-109.72C378.72 302.2 347.82 289 313.59 289h-16.68a174.12 174.12 0 0 1-145.82 0h-16.68A134.43 134.43 0 0 0 0 423.41V465a48 48 0 0 0 48 48h282.42C304.13 492.81 288 464.66 288 433zM598.94 98.33l-96.53 28.51a32 32 0 0 0-22.41 30.5V361a148.76 148.76 0 0 0-48-8c-61.86 0-112 35.82-112 80s50.14 80 112 80 112-35.82 112-80V245.15l73-21.39a32 32 0 0 0 23-30.71V129a32 32 0 0 0-41.06-30.67z"]
  },
      gT = {
    prefix: "fas",
    iconName: "user-ninja",
    icon: [448, 512, [], "f504", "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"]
  },
      HT = {
    prefix: "fas",
    iconName: "user-nurse",
    icon: [448, 512, [], "f82f", "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"]
  },
      VT = {
    prefix: "fas",
    iconName: "user-plus",
    icon: [640, 512, [], "f234", "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"]
  },
      xT = {
    prefix: "fas",
    iconName: "user-robot",
    icon: [448, 512, [], "e04b", "M17.99986,256H48V128H17.99986A17.9784,17.9784,0,0,0,0,146v92A17.97965,17.97965,0,0,0,17.99986,256Zm412-128H400V256h29.99985A17.97847,17.97847,0,0,0,448,238V146A17.97722,17.97722,0,0,0,429.99985,128ZM116,320H332a36.0356,36.0356,0,0,0,36-36V109a44.98411,44.98411,0,0,0-45-45H241.99985V18a18,18,0,1,0-36,0V64H125a44.98536,44.98536,0,0,0-45,45V284A36.03685,36.03685,0,0,0,116,320Zm188-48H272V240h32ZM288,128a32,32,0,1,1-32,32A31.99658,31.99658,0,0,1,288,128ZM208,240h32v32H208Zm-32,32H144V240h32ZM160,128a32,32,0,1,1-32,32A31.99658,31.99658,0,0,1,160,128ZM352,352H96A95.99975,95.99975,0,0,0,0,448v32a32.00033,32.00033,0,0,0,32,32h96V448a31.99908,31.99908,0,0,1,32-32H288a31.99908,31.99908,0,0,1,32,32v64h96a32.00033,32.00033,0,0,0,32-32V448A95.99975,95.99975,0,0,0,352,352ZM176,448a15.99954,15.99954,0,0,0-16,16v48h32V464A15.99954,15.99954,0,0,0,176,448Zm96,0a16,16,0,1,0,16,16A15.99954,15.99954,0,0,0,272,448Z"]
  },
      wT = {
    prefix: "fas",
    iconName: "user-secret",
    icon: [448, 512, [], "f21b", "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"]
  },
      yT = {
    prefix: "fas",
    iconName: "user-shield",
    icon: [640, 512, [], "f505", "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"]
  },
      bT = {
    prefix: "fas",
    iconName: "user-slash",
    icon: [640, 512, [], "f506", "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"]
  },
      ST = {
    prefix: "fas",
    iconName: "user-tag",
    icon: [640, 512, [], "f507", "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"]
  },
      TT = {
    prefix: "fas",
    iconName: "user-tie",
    icon: [448, 512, [], "f508", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"]
  },
      DT = {
    prefix: "fas",
    iconName: "user-times",
    icon: [640, 512, [], "f235", "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"]
  },
      jT = {
    prefix: "fas",
    iconName: "user-unlock",
    icon: [640, 512, [], "e058", "M224,256A128,128,0,1,0,96,128,128,128,0,0,0,224,256Zm96,64a63.07,63.07,0,0,1,8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5H296.9a174.1,174.1,0,0,1-145.8,0H134.4A134.43,134.43,0,0,0,0,422.4V464a48,48,0,0,0,48,48H328.9a63.58,63.58,0,0,1-8.9-32Zm288-32H464V208.67c0-17.44,13.67-32.18,31.1-32.66A32,32,0,0,1,528,208a16,16,0,0,0,16,16h17a15,15,0,0,0,15-15h0c0-43.28-34-79.51-77.26-80.95A80,80,0,0,0,416,208v80H384a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H608a32,32,0,0,0,32-32V320A32,32,0,0,0,608,288ZM496,432a32,32,0,1,1,32-32A32,32,0,0,1,496,432Z"]
  },
      ET = {
    prefix: "fas",
    iconName: "user-visor",
    icon: [448, 512, [], "e04c", "M105.05859,174.653C123.72266,222.237,169.79492,256.05336,224,256.05336S324.27734,222.237,342.94141,174.653C357.168,171.401,368,159.2643,368,144.05336v-64a31.99909,31.99909,0,0,0-32-32H323.18164C299.7168,19.00649,264.25.05336,224,.05336s-75.7168,18.95313-99.18164,48H112a31.99909,31.99909,0,0,0-32,32v64C80,159.2643,90.832,171.401,105.05859,174.653ZM128,96.05336H320v32H128Zm185.59375,192h-16.6875a174.10379,174.10379,0,0,1-145.8125,0h-16.6875A134.44134,134.44134,0,0,0,0,422.45961v41.59375a48.01238,48.01238,0,0,0,48,48H400a48.01238,48.01238,0,0,0,48-48V422.45961A134.44134,134.44134,0,0,0,313.59375,288.05336Zm39.6875,159.79688A4.06431,4.06431,0,0,1,352,448.05336a4.01558,4.01558,0,0,1-3.26562-1.6875c-12.1875-17.1875-17.625-23.04687-19.85938-25.03125a5.72835,5.72835,0,0,0-1.375.375c-3.29688,1-12.1875,5.48438-37.04688,24.8125a4.1133,4.1133,0,0,1-4.39062.34375,4.03445,4.03445,0,0,1-2.04688-3.92187c3.875-36.39063,15.875-66.5,35.70313-89.5a4.30685,4.30685,0,0,1,3.14063-1.39063,3.97907,3.97907,0,0,1,3.0625,1.5625c18.8125,24.59375,28.92187,54.96875,30.07812,90.3125A3.992,3.992,0,0,1,353.28125,447.85024Z"]
  },
      kT = {
    prefix: "fas",
    iconName: "users",
    icon: [640, 512, [], "f0c0", "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"]
  },
      IT = {
    prefix: "fas",
    iconName: "users-class",
    icon: [640, 512, [], "f63d", "M256 288c0 35.35 28.66 64 64 64 35.35 0 64-28.65 64-64s-28.65-64-64-64c-35.34 0-64 28.65-64 64zm224 0c0 35.35 28.66 64 64 64 35.35 0 64-28.65 64-64s-28.65-64-64-64c-35.34 0-64 28.65-64 64zM96 352c35.35 0 64-28.65 64-64s-28.65-64-64-64c-35.34 0-64 28.65-64 64s28.66 64 64 64zm480 32h-64c-35.34 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32v-32c0-35.35-28.66-64-64-64zm-224 0h-64c-35.34 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32v-32c0-35.35-28.66-64-64-64zm-224 0H64c-35.34 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32v-32c0-35.35-28.66-64-64-64zM96 64h448v128c24.68 0 46.98 9.62 64 24.97V49.59C608 22.25 586.47 0 560 0H80C53.53 0 32 22.25 32 49.59v167.38C49.02 201.62 71.33 192 96 192V64z"]
  },
      OT = {
    prefix: "fas",
    iconName: "users-cog",
    icon: [640, 512, [], "f509", "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"]
  },
      QT = {
    prefix: "fas",
    iconName: "users-crown",
    icon: [640, 512, [], "f6a5", "M96 224c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm224 32c53.02 0 96-42.98 96-96v-16H224v16c0 53.02 42.98 96 96 96zm256 0h-64c-17.59 0-33.5 7.11-45.07 18.59 40.27 22.06 68.86 62.03 75.13 109.41H608c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-402.93 18.59C161.5 263.11 145.59 256 128 256H64c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h65.94c6.27-47.38 34.85-87.34 75.13-109.41zM544 224c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm-147.2 64h-8.31c-20.84 9.96-43.89 16-68.49 16s-47.64-6.04-68.49-16h-8.31C179.58 288 128 339.58 128 403.2V432c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-28.8c0-63.62-51.58-115.2-115.2-115.2zM416 32l-48 24-48-24-48 24-48-24v80h192V32z"]
  },
      ZT = {
    prefix: "fas",
    iconName: "users-medical",
    icon: [640, 512, [], "f830", "M96 224a64 64 0 1 0-64-64 64.06 64.06 0 0 0 64 64zm224 32a112 112 0 1 0-112-112 111.94 111.94 0 0 0 112 112zm32 96c0-19.1 3.92-37.17 10.09-54.17A152.75 152.75 0 0 1 320 304c-24.6 0-47.6-6-68.5-16h-8.3A115.23 115.23 0 0 0 128 403.2V432a48 48 0 0 0 48 48h241c-39.22-29.19-65-75.47-65-128zm-178.9-77.4A63.81 63.81 0 0 0 128 256H64a64.06 64.06 0 0 0-64 64v32a32 32 0 0 0 32 32h65.9a146.64 146.64 0 0 1 75.2-109.4zM512 224a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm64 144a5.33 5.33 0 0 1-5.33 5.33h-37.34v37.34A5.33 5.33 0 0 1 528 416h-32a5.33 5.33 0 0 1-5.33-5.33v-37.34h-37.34A5.33 5.33 0 0 1 448 368v-32a5.33 5.33 0 0 1 5.33-5.33h37.34v-37.34A5.33 5.33 0 0 1 496 288h32a5.33 5.33 0 0 1 5.33 5.33v37.34h37.34A5.33 5.33 0 0 1 576 336z"]
  },
      UT = {
    prefix: "fas",
    iconName: "users-slash",
    icon: [640, 512, [], "e073", "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"]
  },
      BT = {
    prefix: "fas",
    iconName: "utensil-fork",
    icon: [512, 512, [], "f2e3", "M469.5 119.4L356.3 232.6c-3.8 1.7-14.7-9.5-12.9-12.9 19.2-21.5 105.3-117.9 107.3-120.1 14.1-19.3-19.1-52.5-38.4-38.4-2.3 2-98.7 88.1-120.1 107.3-3.4 1.8-14.6-9.1-12.9-12.9L392.5 42.4c15.4-19.4-18.7-53-37.5-39.3-4.4 3.1-88.6 62.8-116.2 90.3-41.8 41.8-49.6 94.1-28.7 139.1L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l180.5-201.2c45 20.9 97.2 13.3 139.1-28.7 27.6-27.6 87.3-111.8 90.4-116.2 13.7-18.7-19.9-52.7-39.3-37.4z"]
  },
      RT = {
    prefix: "fas",
    iconName: "utensil-knife",
    icon: [512, 512, [], "f2e4", "M424.9 8.7L20.8 412.8c-11.5 11.5-11.5 30.3 0 41.8l48.8 48.8c12.2 12.2 32.2 11.4 43.4-1.8l148.2-174.3C504.1 357 538.5 80.5 466.7 8.7c-11.6-11.6-30.3-11.6-41.8 0z"]
  },
      YT = {
    prefix: "fas",
    iconName: "utensil-spoon",
    icon: [512, 512, [], "f2e5", "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"]
  },
      PT = {
    prefix: "fas",
    iconName: "utensils",
    icon: [416, 512, [], "f2e7", "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"]
  },
      FT = {
    prefix: "fas",
    iconName: "utensils-alt",
    icon: [576, 512, [], "f2e6", "M53.8 8.6L293 230.7c28.8-25.5 18-16 48.4-42.9-21.4-36.3-17.2-75.1 16.1-108.4C379.3 57.7 452.3 6 456.2 3.2c16.1-11.8 37.6 11.5 24.8 26.2l-81.2 93.8c-1.3 1.5 3 6 4.7 4.6L501.4 49c15.1-12.3 37.9 10.2 25.5 25.5l-78.8 96.9c-1.3 1.6 3.1 6 4.6 4.6l93.8-81.2c14.7-12.7 38 8.7 26.2 24.9-2.8 4-54.5 76.9-76.2 98.6-34.2 34.3-73.5 36.9-108.5 16.2-26.6 30.1-14.5 16.3-41 46.3l154.7 143.6c13.3 12.3 13.7 33.3.8 46.1l-32 32c-12.8 12.8-33.6 12.4-46-.7C405.4 479.2 223.9 265.3 216 256 56 256 0 165.9 0 32.1 0 4.2 33.3-10.4 53.8 8.6zm19.6 462l32 32c13 13 34.4 12.4 46.6-1.4l117.5-132.7-56.6-66.8L74.8 424c-13.8 12.3-14.5 33.6-1.4 46.6z"]
  },
      WT = {
    prefix: "fas",
    iconName: "vacuum",
    icon: [640, 512, [], "e04d", "M143.27,256,102.12,448H48A48,48,0,0,0,0,496a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V464a16,16,0,0,0-16-16h-8.41l41.14-192ZM640,128A128.14,128.14,0,0,0,512,0H301.61C241.64,0,189,42.56,176.44,101.19L150.12,224h65.47L239,114.59A64.33,64.33,0,0,1,301.61,64H512a64,64,0,0,1,13.47,126.51A191.27,191.27,0,0,0,384,128a32,32,0,0,0-32,32V321.62A109.65,109.65,0,0,1,368,320a111.83,111.83,0,0,1,78.14,192H512a64,64,0,0,0,64-64V320a191.27,191.27,0,0,0-15.06-74.65C607.17,226.11,640,181.13,640,128ZM368,352a80,80,0,1,0,80,80A80,80,0,0,0,368,352Zm0,96a16,16,0,1,1,16-16A16,16,0,0,1,368,448Z"]
  },
      GT = {
    prefix: "fas",
    iconName: "vacuum-robot",
    icon: [512, 512, [], "e04e", "M431.36,80.64c-96.85-96.85-253.87-96.85-350.72,0s-96.85,253.87,0,350.72,253.87,96.85,350.72,0S528.21,177.49,431.36,80.64ZM199.43,403.08a16,16,0,0,1-22.63,0L108.92,335.2a16,16,0,0,1,22.63-22.63l67.88,67.88A16,16,0,0,1,199.43,403.08Zm67.88-22.63a16,16,0,0,1-22.62,0L131.55,267.31a16,16,0,0,1,22.63-22.62L267.31,357.82A16,16,0,0,1,267.31,380.45Zm22.63-67.88a16,16,0,0,1-22.63,0l-67.88-67.88a16,16,0,0,1,22.63-22.63l67.88,67.88A16,16,0,0,1,289.94,312.57Zm90.51,67.88a16,16,0,0,1-22.62-22.62c56.14-56.16,56.14-147.5,0-203.66s-147.5-56.15-203.66,0a16,16,0,0,1-22.62-22.62c68.62-68.63,180.28-68.63,248.9,0S449.08,311.83,380.45,380.45Z"]
  },
      qT = {
    prefix: "fas",
    iconName: "value-absolute",
    icon: [512, 512, [], "f6a6", "M48 32H16C7.16 32 0 39.16 0 48v416c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16zm448 0h-32c-8.84 0-16 7.16-16 16v416c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16zM377.3 150.87l-16.17-16.17c-8.93-8.93-23.41-8.93-32.35 0L256 207.48l-72.78-72.78c-8.93-8.93-23.41-8.93-32.35 0l-16.17 16.17c-8.93 8.93-8.93 23.41 0 32.35L207.48 256l-72.78 72.78c-8.93 8.93-8.93 23.41 0 32.35l16.17 16.17c8.93 8.93 23.41 8.93 32.35 0L256 304.52l72.78 72.78c8.93 8.93 23.41 8.93 32.35 0l16.17-16.17c8.93-8.93 8.93-23.41 0-32.35L304.52 256l72.78-72.78c8.93-8.93 8.93-23.42 0-32.35z"]
  },
      JT = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [512, 512, [], "f5cb", "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"]
  },
      KT = {
    prefix: "fas",
    iconName: "venus",
    icon: [288, 512, [], "f221", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"]
  },
      XT = {
    prefix: "fas",
    iconName: "venus-double",
    icon: [512, 512, [], "f226", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"]
  },
      _T = {
    prefix: "fas",
    iconName: "venus-mars",
    icon: [576, 512, [], "f228", "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"]
  },
      $T = {
    prefix: "fas",
    iconName: "vest",
    icon: [448, 512, [], "e085", "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"]
  },
      cD = {
    prefix: "fas",
    iconName: "vest-patches",
    icon: [448, 512, [], "e086", "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"]
  },
      eD = {
    prefix: "fas",
    iconName: "vhs",
    icon: [512, 512, [], "f8ec", "M496 64H16A16 16 0 0 0 0 80v48h512V80a16 16 0 0 0-16-16zM0 400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V160H0zm384-50.94a47.73 47.73 0 0 0 0-90.12V224h48.86C452 245.26 464 273.12 464 304s-12 58.73-31.14 80H384zM192 224h128v160H192zm-112.86 0H128v34.94a47.73 47.73 0 0 0 0 90.12V384H79.14C60 362.73 48 334.87 48 304s12-58.74 31.14-80z"]
  },
      aD = {
    prefix: "fas",
    iconName: "vial",
    icon: [480, 512, [], "f492", "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"]
  },
      nD = {
    prefix: "fas",
    iconName: "vials",
    icon: [640, 512, [], "f493", "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"]
  },
      tD = {
    prefix: "fas",
    iconName: "video",
    icon: [576, 512, [], "f03d", "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"]
  },
      rD = {
    prefix: "fas",
    iconName: "video-plus",
    icon: [576, 512, [], "f4e1", "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zM304 264c0 8.8-7.2 16-16 16h-72v72c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-72H96c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h72v-72c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v72h72c8.8 0 16 7.2 16 16v16zm272-136.5v256.9c0 25.5-29.1 40.4-50.4 25.8L416 334.7V177.3l109.6-75.5c21.3-14.7 50.4.3 50.4 25.7z"]
  },
      iD = {
    prefix: "fas",
    iconName: "video-slash",
    icon: [640, 512, [], "f4e2", "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"]
  },
      oD = {
    prefix: "fas",
    iconName: "vihara",
    icon: [640, 512, [], "f6a7", "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"]
  },
      lD = {
    prefix: "fas",
    iconName: "violin",
    icon: [640, 512, [], "f8ed", "M347.31 16L336 4.69a16 16 0 0 0-22.62 0L4.69 313.38a16 16 0 0 0 0 22.62L16 347.31a16 16 0 0 0 22.62 0L347.31 38.62a16 16 0 0 0 0-22.62zM520 48a24 24 0 1 0-24-24 24 24 0 0 0 24 24zM237.61 415.84l-13.45-13.45a16 16 0 0 0-20.19-2l-68.84 45.9a16 16 0 0 0-2.44 24.62l36.4 36.4a16 16 0 0 0 24.62-2.44l45.9-68.87a16 16 0 0 0-2-20.16zM472 96a24 24 0 1 0-24-24 24 24 0 0 0 24 24zm-14.23 131.48L635.31 49.94a16 16 0 0 0 0-22.63L612.69 4.69a16 16 0 0 0-22.63 0L412.52 182.23c-12.17-8.77-25.53-15.76-40.15-19.16-32.87-7.65-65.69-.93-88.56 21.05A79.09 79.09 0 0 1 288 208.4a79.78 79.78 0 0 1-123.28 67.08 89.85 89.85 0 0 0-7.16 6c-31.25 31.16-36.67 79.33-19.54 124.47l48.23-32.16a48 48 0 0 1 60.57 6l13.45 13.45a48.15 48.15 0 0 1 6 60.57L234.11 502c45.12 17.09 93.26 11.63 124.41-19.53a89.77 89.77 0 0 0 6.23-7.48A79.27 79.27 0 0 1 455.87 356c21.92-22.84 28.6-55.6 21-88.4-3.36-14.6-10.34-27.95-19.1-40.12zM616 96a24 24 0 1 0 24 24 24 24 0 0 0-24-24zm-48 48a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"]
  },
      fD = {
    prefix: "fas",
    iconName: "virus",
    icon: [512, 512, [], "e074", "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"]
  },
      sD = {
    prefix: "fas",
    iconName: "virus-slash",
    icon: [640, 512, [], "e075", "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"]
  },
      uD = {
    prefix: "fas",
    iconName: "viruses",
    icon: [640, 512, [], "e076", "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"]
  },
      hD = {
    prefix: "fas",
    iconName: "voicemail",
    icon: [640, 512, [], "f897", "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"]
  },
      mD = {
    prefix: "fas",
    iconName: "volcano",
    icon: [512, 512, [], "f770", "M160 144c12.9 0 24.8-3.9 34.8-10.4L224 192h64l29.2-58.4c10 6.5 21.9 10.4 34.8 10.4 35.3 0 64-28.7 64-64s-28.7-64-64-64c-15.8 0-30 5.9-41.2 15.4C299.6 12.7 279.4 0 256 0s-43.6 12.7-54.8 31.4C190 21.9 175.8 16 160 16c-35.3 0-64 28.7-64 64s28.7 64 64 64zm144.4 80h-96.8c-9.8 0-19.1 4.5-25.2 12.3l-55.6 71 13.2 16.5c9.8 12.2 30.3 12.2 40.1 0 10.8-13.5 26.8-21.3 44.1-21.6 17.2-1.5 33.6 7 44.8 20.1l31.6 36.8c9.8 11.4 29.2 11.4 39 0l45.1-52.6-55-70.2c-6.2-7.8-15.4-12.3-25.3-12.3zm201.1 236.8L404.7 332.1l-40.9 47.7c-11 12.8-27 20.2-43.8 20.2s-32.8-7.3-43.8-20.2L244.6 343c-4.9-5.7-12-9-19.5-9h-.4c-7.7.2-14.8 3.7-19.6 9.7-22.1 27.5-68.1 27.5-90.1 0l-8.4-10.6L6.5 460.8C-9.4 481.9 5.7 512 32.1 512H480c26.3 0 41.4-30.1 25.5-51.2z"]
  },
      vD = {
    prefix: "fas",
    iconName: "volleyball-ball",
    icon: [512, 512, [], "f45f", "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"]
  },
      dD = {
    prefix: "fas",
    iconName: "volume",
    icon: [480, 512, [], "f6a8", "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.53 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"]
  },
      MD = {
    prefix: "fas",
    iconName: "volume-down",
    icon: [384, 512, [], "f027", "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"]
  },
      pD = {
    prefix: "fas",
    iconName: "volume-mute",
    icon: [512, 512, [], "f6a9", "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"]
  },
      zD = {
    prefix: "fas",
    iconName: "volume-off",
    icon: [256, 512, [], "f026", "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"]
  },
      CD = {
    prefix: "fas",
    iconName: "volume-slash",
    icon: [640, 512, [], "f2e2", "M633.82 458.1l-69-53.33C592.42 360.8 608 309.68 608 256c0-95.33-47.73-183.58-127.65-236.03-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 42.78-11.96 83.59-33.22 119.06l-38.12-29.46C503.49 318.68 512 288.06 512 256c0-63.09-32.06-122.09-85.77-156.16-11.19-7.09-26.03-3.8-33.12 7.41-7.09 11.2-3.78 26.03 7.41 33.13C440.27 165.59 464 209.44 464 256c0 21.21-5.03 41.57-14.2 59.88l-39.56-30.58c3.38-9.35 5.76-19.07 5.76-29.3 0-31.88-17.53-61.33-45.77-76.88-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61 11.76 6.46 19.12 18.18 20.4 31.06L288 190.82V88.02c0-21.46-25.96-31.98-40.97-16.97l-49.71 49.7L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM32 184v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V352.6L43.76 163.84C36.86 168.05 32 175.32 32 184z"]
  },
      LD = {
    prefix: "fas",
    iconName: "volume-up",
    icon: [576, 512, [], "f028", "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"]
  },
      AD = {
    prefix: "fas",
    iconName: "vote-nay",
    icon: [640, 512, [], "f771", "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM235.1 157.1c-6.2-6.2-6.2-16.4 0-22.6l11.3-11.3c6.2-6.2 16.4-6.2 22.6 0l50.9 50.9 50.9-50.9c6.2-6.2 16.4-6.2 22.6 0l11.3 11.3c6.2 6.2 6.2 16.4 0 22.6L353.9 208l50.9 50.9c6.2 6.2 6.2 16.4 0 22.6l-11.3 11.3c-6.2 6.2-16.4 6.2-22.6 0L320 241.9l-50.9 50.9c-6.2 6.2-16.4 6.2-22.6 0l-11.3-11.3c-6.2-6.2-6.2-16.4 0-22.6l50.9-50.9-51-50.9z"]
  },
      ND = {
    prefix: "fas",
    iconName: "vote-yea",
    icon: [640, 512, [], "f772", "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"]
  },
      gD = {
    prefix: "fas",
    iconName: "vr-cardboard",
    icon: [640, 512, [], "f729", "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"]
  },
      HD = {
    prefix: "fas",
    iconName: "wagon-covered",
    icon: [640, 512, [], "f8ee", "M224,224V92.88c0-36.88-25.33-68.15-59.43-73.37L39.55.39c-26-4-46.53,23.34-37.3,49.69L70.78,224ZM600.45.39l-125,19.12C441.33,24.73,416,56,416,92.88V224H569.22L637.75,50.08C647,23.73,626.48-3.59,600.45.39ZM384,56a40,40,0,0,0-40-40H296a40,40,0,0,0-40,40V224H384ZM560,256H80a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H97.79c-.31.3-.68.5-1,.8A112,112,0,1,0,286.47,416h67.06A111.85,111.85,0,1,0,543.2,320.8c-.31-.3-.68-.5-1-.8H560a16,16,0,0,0,16-16V272A16,16,0,0,0,560,256ZM160,461.74A62.48,62.48,0,0,1,114.26,416H160ZM160,384H114.26A62.44,62.44,0,0,1,160,338.26Zm61.25,61.25A63.43,63.43,0,0,1,192,461.74V416h45.74A63.43,63.43,0,0,1,221.25,445.25ZM192,384V338.26A62.44,62.44,0,0,1,237.74,384Zm256,77.74A62.48,62.48,0,0,1,402.26,416H448ZM448,384H402.26A62.44,62.44,0,0,1,448,338.26Zm61.25,61.25A63.43,63.43,0,0,1,480,461.74V416h45.74A63.34,63.34,0,0,1,509.25,445.25ZM480,384V338.26A62.44,62.44,0,0,1,525.74,384Z"]
  },
      VD = {
    prefix: "fas",
    iconName: "walker",
    icon: [448, 512, [], "f831", "M416 392.88V96a96 96 0 0 0-96-96H190.66A95.62 95.62 0 0 0 96 80L.24 487.77a16 16 0 0 0 13 18.51l31.54 5.48a16 16 0 0 0 18.5-13L127.81 224H352v168.88a64 64 0 1 0 64 0zM352 160H142.83l16.26-69.25A31.91 31.91 0 0 1 190.66 64H320a32 32 0 0 1 32 32zm32 304a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"]
  },
      xD = {
    prefix: "fas",
    iconName: "walkie-talkie",
    icon: [384, 512, [], "f8ef", "M352 96h-32V80a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16h-32V80a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v16h-48V16A16 16 0 0 0 96 0H80a16 16 0 0 0-16 16v80H32a32.09 32.09 0 0 0-32 32v178.74a32 32 0 0 0 9.37 22.63L32 352v112a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48V352l22.63-22.63a32 32 0 0 0 9.37-22.63V128a32.09 32.09 0 0 0-32-32zm-64 216a8 8 0 0 1-8 8H104a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h176a8 8 0 0 1 8 8zm0-64a8 8 0 0 1-8 8H104a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h176a8 8 0 0 1 8 8zm0-64a8 8 0 0 1-8 8H104a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h176a8 8 0 0 1 8 8z"]
  },
      wD = {
    prefix: "fas",
    iconName: "walking",
    icon: [320, 512, [], "f554", "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"]
  },
      yD = {
    prefix: "fas",
    iconName: "wallet",
    icon: [512, 512, [], "f555", "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"]
  },
      bD = {
    prefix: "fas",
    iconName: "wand",
    icon: [512, 512, [], "f72a", "M400 192c8.84 0 16-7.16 16-16v-27.96l91.87-101.83c5.72-6.32 5.48-16.02-.55-22.05L487.84 4.69c-6.03-6.03-15.73-6.27-22.05-.55L186.6 256H144c-8.84 0-16 7.16-16 16v36.87L10.53 414.84c-13.57 12.28-14.1 33.42-1.16 46.36l41.43 41.43c12.94 12.94 34.08 12.41 46.36-1.16L376.34 192H400z"]
  },
      SD = {
    prefix: "fas",
    iconName: "wand-magic",
    icon: [512, 512, [], "f72b", "M80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.34 0 80l53.34 26.67L80 160zm144-64l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zm234.66 245.33L432 288l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67zM400 192c8.84 0 16-7.16 16-16v-27.96l91.87-101.83c5.72-6.32 5.48-16.02-.55-22.05L487.84 4.69c-6.03-6.03-15.73-6.27-22.05-.55L186.6 256H144c-8.84 0-16 7.16-16 16v36.87L10.53 414.84c-13.57 12.28-14.1 33.42-1.16 46.36l41.43 41.43c12.94 12.94 34.08 12.41 46.36-1.16L376.34 192H400z"]
  },
      TD = {
    prefix: "fas",
    iconName: "warehouse",
    icon: [640, 512, [], "f494", "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"]
  },
      DD = {
    prefix: "fas",
    iconName: "warehouse-alt",
    icon: [640, 512, [], "f495", "M610.5 117L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V208c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v296c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3zM304 416H144c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm192 0H368c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zM304 288H144c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"]
  },
      jD = {
    prefix: "fas",
    iconName: "washer",
    icon: [446, 512, [], "f898", "M384 0H64A64 64 0 0 0 0 64v416a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a64 64 0 0 0-64-64zM184 64a24 24 0 1 1-24 24 24 24 0 0 1 24-24zM64 88a24 24 0 1 1 24 24 24 24 0 0 1-24-24zm160 360a144 144 0 1 1 144-144 144 144 0 0 1-144 144zm36.87-163.66a51.23 51.23 0 0 1-73.74 0 51.79 51.79 0 0 1-73.24 1A110.76 110.76 0 0 0 112 304a112 112 0 0 0 224 0 110.76 110.76 0 0 0-1.89-18.69 51.79 51.79 0 0 1-73.24-1z"]
  },
      ED = {
    prefix: "fas",
    iconName: "watch",
    icon: [384, 512, [], "f2e1", "M192 80c97.2 0 176 78.8 176 176s-78.8 176-176 176S16 353.2 16 256 94.8 80 192 80m0-24c47.4 0 92.4 16.6 128 46.3V24c0-13.3-10.7-24-24-24H88C74.7 0 64 10.7 64 24v78.3C99.6 72.6 144.5 56 192 56zm0 400c-47.5 0-92.4-16.7-128-46.3V488c0 13.3 10.7 24 24 24h208c13.3 0 24-10.7 24-24v-78.3c-35.6 29.7-80.6 46.3-128 46.3zm53-130.3l18.8-25.9c3.9-5.4 2.7-12.9-2.6-16.8L220 253v-93c0-6.6-5.4-12-12-12h-32c-6.6 0-12 5.4-12 12v115.4c0 3.8 1.8 7.4 4.9 9.7l59.3 43.2c5.4 4 12.9 2.8 16.8-2.6z"]
  },
      kD = {
    prefix: "fas",
    iconName: "watch-calculator",
    icon: [384, 512, [], "f8f0", "M320 80H64a64 64 0 0 0-64 64v224a64 64 0 0 0 64 64h256a64 64 0 0 0 64-64V144a64 64 0 0 0-64-64zM120 368a8 8 0 0 1-8 8H80a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm0-96a8 8 0 0 1-8 8H80a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm96 96a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm0-96a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm96 96a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm0-96a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8zm0-96a8 8 0 0 1-8 8H80a8 8 0 0 1-8-8v-32a8 8 0 0 1 8-8h224a8 8 0 0 1 8 8zm8-144a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v16h256zM64 480a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32v-16H64z"]
  },
      ID = {
    prefix: "fas",
    iconName: "watch-fitness",
    icon: [384, 512, [], "f63e", "M64 480c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-16H64v16zM320 32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v16h256V32zm0 48H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h256c35.35 0 64-28.65 64-64V144c0-35.35-28.65-64-64-64zm-33.43 182.21l-84.67 85.64a13.89 13.89 0 0 1-19.8 0l-84.67-85.64c-24.6-24.88-23.16-66.13 4.33-89.08 23.96-20.02 59.65-16.42 81.62 5.81l8.62 8.72 8.62-8.72c21.97-22.23 57.66-25.82 81.62-5.81 27.49 22.96 28.93 64.21 4.33 89.08z"]
  },
      OD = {
    prefix: "fas",
    iconName: "water",
    icon: [576, 512, [], "f773", "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"]
  },
      QD = {
    prefix: "fas",
    iconName: "water-lower",
    icon: [576, 512, [], "f774", "M562.1 447.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zM276 219c6.6 6.6 17.4 6.6 24 0l96.4-95.7c10.1-10.1 3-27.4-11.3-27.4H320V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v80h-65.2c-14.3 0-21.4 17.3-11.2 27.4L276 219z"]
  },
      ZD = {
    prefix: "fas",
    iconName: "water-rise",
    icon: [576, 512, [], "f775", "M562.1 447.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zM190.8 128H256v80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-80h65.2c14.3 0 21.4-17.3 11.2-27.4L300 5c-6.6-6.6-17.4-6.6-24 0l-96.4 95.7c-10.2 10-3 27.3 11.2 27.3z"]
  },
      UD = {
    prefix: "fas",
    iconName: "wave-sine",
    icon: [640, 512, [], "f899", "M464 480c-90.52 0-132.84-107.94-173.8-212.31C258.64 187.2 222.88 96 176 96c-39.7 0-91.38 81.89-114.12 149a16 16 0 0 1-19.74 10.33l-30.72-9.21A16 16 0 0 1 .84 225.68C19.55 169.79 82.16 32 176 32c90.52 0 132.84 107.94 173.8 212.31C381.36 324.8 417.12 416 464 416c39.7 0 91.38-81.89 114.12-149a16 16 0 0 1 19.74-10.33l30.72 9.21a16 16 0 0 1 10.58 20.43C620.45 342.21 557.84 480 464 480z"]
  },
      BD = {
    prefix: "fas",
    iconName: "wave-square",
    icon: [640, 512, [], "f83e", "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"]
  },
      RD = {
    prefix: "fas",
    iconName: "wave-triangle",
    icon: [640, 512, [], "f89a", "M464 480h-.34a32 32 0 0 1-25.25-12.8l-263-350.65L53.73 281.88a16 16 0 0 1-22.46 2.7L6.12 264.82a16 16 0 0 1-2.7-22.47L150.84 44.23A32 32 0 0 1 176 32h.34a32 32 0 0 1 25.25 12.8l263 350.65 121.68-165.33a16 16 0 0 1 22.46-2.7l25.15 19.76a16 16 0 0 1 2.7 22.47L489.16 467.77A32 32 0 0 1 464 480z"]
  },
      YD = {
    prefix: "fas",
    iconName: "waveform",
    icon: [640, 512, [], "f8f1", "M140 192h-24a16 16 0 0 0-16 16v96a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-96a16 16 0 0 0-16-16zm-96 32H20a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM236 96h-24a16 16 0 0 0-16 16v288a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V112a16 16 0 0 0-16-16zm384 128h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM524 64h-24a16 16 0 0 0-16 16v352a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm-96 64h-24a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V144a16 16 0 0 0-16-16zM332 0h-24a16 16 0 0 0-16 16v480a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16z"]
  },
      PD = {
    prefix: "fas",
    iconName: "waveform-path",
    icon: [640, 512, [], "f8f2", "M624 263h-43.69l-12.65-84a24 24 0 0 0-23.1-20h-.12c-9.5 0-21.38 7.22-23.91 18.95L500.16 281 471.75 83.44a24 24 0 0 0-47.41-.39l-38.5 239-42.06-302.46a24 24 0 0 0-47.56 0l-42.06 302.47-38.5-239a24 24 0 0 0-47.41.39L139.84 281l-20.37-103a23.54 23.54 0 0 0-23.59-19h-.5a24 24 0 0 0-23 20l-12.69 84H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h81.19l23.34 117c2.56 11.89 11.94 19.42 24.13 19a24.08 24.08 0 0 0 23.09-20.45l25.5-178.08L232.34 491c1.82 11.13 12.63 19.8 23.85 20.05a24 24 0 0 0 23.59-20.61L320 200.7l40.22 289.71a24 24 0 0 0 47.44.54l39.09-242.5 25.5 178.13a24 24 0 0 0 23 20.42c12 0 21.84-8 24.19-18.95l23.34-117H624a16 16 0 0 0 16-16V279a16 16 0 0 0-16-16z"]
  },
      FD = {
    prefix: "fas",
    iconName: "webcam",
    icon: [448, 512, [], "f832", "M402.29 438.6l-49.19-30.75c58.11-40.46 96.23-107.66 96.23-183.85 0-123.71-100.29-224-224-224s-224 100.29-224 224c0 76.19 38.12 143.39 96.23 183.85L48.37 438.6a32 32 0 0 0-15 27.14V480a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32v-14.26a32 32 0 0 0-15.08-27.14zm-177-54.6a160 160 0 1 1 160-160 160 160 0 0 1-159.96 160zm0-288a128 128 0 1 0 128 128A128 128 0 0 0 225.33 96zm0 80a48.05 48.05 0 0 0-48 48 16 16 0 0 1-32 0 80.09 80.09 0 0 1 80-80 16 16 0 1 1 0 32z"]
  },
      WD = {
    prefix: "fas",
    iconName: "webcam-slash",
    icon: [640, 512, [], "f833", "M163.46 256.92l-66.53-51.41c-.5 6.11-.93 12.25-.93 18.49 0 76.19 38.12 143.39 96.23 183.85L143 438.6a32 32 0 0 0-15 27.14V480a32 32 0 0 0 32 32h320a31.58 31.58 0 0 0 10.7-2.16L327 383.3c-83.42 3.7-148.41-54.1-163.54-126.38zM633.82 458.1L500.7 355.21c27-36.85 43.3-82 43.3-131.21C544 100.29 443.71 0 320 0a223.48 223.48 0 0 0-173 81.8L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM320 176a47.78 47.78 0 0 0-33.46 13.69l-25.3-19.55A79.57 79.57 0 0 1 320 144a16 16 0 0 1 0 32zm130.12 140.12l-25.23-19.5A126 126 0 0 0 448 224a127.86 127.86 0 0 0-224.93-83.36l-24.65-19C227.56 86.62 270.85 64 320 64a160 160 0 0 1 160 160 157.21 157.21 0 0 1-29.88 92.12z"]
  },
      GD = {
    prefix: "fas",
    iconName: "weight",
    icon: [512, 512, [], "f496", "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"]
  },
      qD = {
    prefix: "fas",
    iconName: "weight-hanging",
    icon: [512, 512, [], "f5cd", "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"]
  },
      JD = {
    prefix: "fas",
    iconName: "whale",
    icon: [640, 512, [], "f72c", "M544 160c-243.05 0-315.29 224-380.12 224-19.78 0-35.88-16.09-35.88-35.87v-97.99l49.75-30.51A32.007 32.007 0 0 0 192 193v-80.98c0-12.78-14.24-20.4-24.88-13.31L96 146.13 24.88 98.71C14.24 91.63 0 99.25 0 112.03V193c0 10.7 5.35 20.69 14.25 26.62L64 250.14v97.99C64 403.2 108.8 448 163.88 448H576c35.35 0 64-28.65 64-64V256c0-52.94-43.06-96-96-96zM432 288c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16z"]
  },
      KD = {
    prefix: "fas",
    iconName: "wheat",
    icon: [512, 512, [], "f72d", "M481.7 113.55c25.4-27.43 32.47-72.08 29.75-113C482.47-1.39 431.2.29 398.9 30.43c-37.2 37.35-30.99 104.3-29.76 113 41.58 2.78 85-4.15 112.56-29.88zm-43.51 56c-16.1 3.87-33.24 6.45-52.18 6.45-6.34 0-12.69-.22-19-.64l-25.9-1.73-3.65-25.7c-.32-2.29-4.98-37.33 4.65-75.88-12.86-31.93-40.99-55.43-45.79-59.03-27.88 24.38-50.81 56.03-51.97 89.52 1.09 28.48 18.66 56.4 40.93 78.93l-41.48 41.48c1.59-5.97 2.8-12.06 3.02-18.39-.09-46.86-46.08-85.04-52.32-89.73-27.88 24.38-50.81 56.03-51.97 89.52 1.1 28.48 18.66 56.4 40.93 78.93l-41.48 41.48c1.59-5.97 2.8-12.06 3.02-18.39-.09-46.86-46.08-85.04-52.32-89.73-27.88 24.38-50.81 56.03-51.96 89.52 1.09 28.48 18.66 56.4 40.93 78.93L9.38 457.38c-12.5 12.5-12.5 32.75 0 45.25C15.63 508.88 23.81 512 32 512s16.38-3.12 22.63-9.38l72.24-72.24c22.73 22.77 50.36 40.17 79.4 41.17 33.21-1.28 65.71-24.89 89.73-52.32-17-19.44-50.28-50.61-89.52-51.97-6.62.01-12.99 1.11-19.2 2.71l41.41-41.41c22.73 22.77 50.36 40.17 79.4 41.17 33.21-1.28 65.71-24.89 89.73-52.32-17-19.44-50.28-50.61-89.52-51.97-6.62.01-12.99 1.11-19.2 2.71l41.41-41.41c22.73 22.77 50.36 40.17 79.4 41.17 33.21-1.28 65.71-24.89 89.73-52.32-12.76-14.6-34.7-35.8-61.45-46.04z"]
  },
      XD = {
    prefix: "fas",
    iconName: "wheelchair",
    icon: [512, 512, [], "f193", "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"]
  },
      _D = {
    prefix: "fas",
    iconName: "whistle",
    icon: [640, 512, [], "f460", "M232 256c0 13.2-10.8 24-24 24s-24-10.8-24-24 10.8-24 24-24 24 10.8 24 24zm252-49.7l150 120c6.7 5.4 8 15.2 2.8 22.1l-78.2 104.3c-4.8 6.5-13.7 8.3-20.7 4.3l-150.4-86C312.1 484.4 150.8 492.8 61 403c-65.5-65.5-78.1-163.8-38-242-14.4-11.8-23-29.7-23-49 0-35.3 28.7-64 64-64 19.2 0 36.9 8.9 49 23.5 65.3-33.6 144.4-30.8 207 9.3l86.6 63.6c5.3 4.2 7.3 11.3 5.1 17.7l-10.2 29.5c-1.1 3.2-.1 6.7 2.6 8.9l25.2 20.2c2.6 2.1 6.2 2.3 9.1.6l27.4-16.2c5.8-3.4 13-2.9 18.2 1.2zM85.5 88.3C79.7 83 72 80 64 80c-17.7 0-32 14.3-32 32 0 8.1 3.3 15.4 8.4 21.2 15.2-20.6 27.3-31.9 45.1-44.9zM280 256c0-39.7-32.3-72-72-72s-72 32.3-72 72 32.3 72 72 72 72-32.3 72-72z"]
  },
      $D = {
    prefix: "fas",
    iconName: "wifi",
    icon: [640, 512, [], "f1eb", "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"]
  },
      cj = {
    prefix: "fas",
    iconName: "wifi-1",
    icon: [640, 512, [], "f6aa", "M384 416c0 35.35-28.65 64-64 64s-64-28.65-64-64 28.65-64 64-64 64 28.65 64 64z"]
  },
      ej = {
    prefix: "fas",
    iconName: "wifi-2",
    icon: [640, 512, [], "f6ab", "M384 416c0 35.35-28.65 64-64 64s-64-28.65-64-64 28.65-64 64-64 64 28.65 64 64zm139.24-124.44c6.55-6.46 6.33-17.06-.57-23.15-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.45-33.99z"]
  },
      aj = {
    prefix: "fas",
    iconName: "wifi-slash",
    icon: [640, 512, [], "f6ac", "M5.09 154.87c-6.66 6.16-6.79 16.59-.35 22.97l34.24 33.96c6.14 6.09 16.02 6.23 22.4.38 6.99-6.4 14.31-12.22 21.65-18.01l-64.96-50.21c-4.3 3.71-8.79 7.04-12.98 10.91zm471.75 181.9l45.42-45.21c6.52-6.46 6.29-17.06-.57-23.17-64.94-57.74-148.91-82.66-230.34-74.98l-83.16-64.27c125.94-38.36 267.75-11.01 370.43 83.05 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.96c6.44-6.39 6.3-16.82-.35-22.97C496.46 26.82 298.08-.76 133.42 71.35L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.03-2.81-22.45L476.84 336.77zm-358.53-68.38c-6.86 6.1-7.08 16.7-.57 23.17l34.28 34.01c5.97 5.93 15.59 6.32 21.94.8 13.35-11.6 28.01-20.66 43.15-28.55l-68.36-52.83c-10.48 7.15-20.74 14.78-30.44 23.4zM256 416c0 35.35 28.65 64 64 64 31.91 0 58.15-23.42 62.99-53.98l-88.7-68.56C271.77 367.37 256 389.82 256 416z"]
  },
      nj = {
    prefix: "fas",
    iconName: "wind",
    icon: [512, 512, [], "f72e", "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"]
  },
      tj = {
    prefix: "fas",
    iconName: "wind-turbine",
    icon: [514, 512, [], "f89b", "M350.1 480h-48.32l-5-76.66L221 314l-10.78 166H161.9a36.94 36.94 0 0 0-33 20.42A8 8 0 0 0 136 512h240a8 8 0 0 0 7.15-11.58A36.93 36.93 0 0 0 350.1 480zm48.59-54.21l-88.35-182.32a55.73 55.73 0 0 1-.73-42.79l73.28-179.07a15.8 15.8 0 0 0-27.5-15.07L241.27 163.21a55.74 55.74 0 0 1-36.47 22.4L13.32 215.94A15.81 15.81 0 0 0 0 231.89v.23a15.8 15.8 0 0 0 14.1 15.35L203.83 268a55.78 55.78 0 0 1 37.54 20.58l130.31 153.5a15.81 15.81 0 0 0 20.53 3.63l.19-.12a15.79 15.79 0 0 0 6.29-19.8zM256 248a24 24 0 1 1 24-24 24 24 0 0 1-24 24z"]
  },
      rj = {
    prefix: "fas",
    iconName: "wind-warning",
    icon: [640, 512, [], "f776", "M635.3 161.5c-8.9-28.6-32.2-51.9-60.7-60.8-59.1-18.4-114 19.1-124.7 72.4-2 9.8 5.8 18.9 15.7 18.9h32.8c6.7 0 13.1-3.8 15.2-10.1 4.2-12.7 16.3-21.9 30.4-21.9 19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H413.4c-3.3 22.6-9.9 44.1-19.4 64h150c62.8 0 111.8-60.7 91.3-126.5zm2.8 235.4c-8.9-45.6-51.5-76.9-97.9-76.9H375.6c-18 25.8-41.4 47.4-68.3 63.7.6.1 1 .3 1.6.3h233.3c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1h-32.8c-10 0-17.7 9.3-15.7 19.1 8.9 43.8 47.7 76.9 94.1 76.9 59.2 0 106-53.8 94.1-115.1zM384 192C384 86 298 0 192 0S0 86 0 192s86 192 192 192 192-86 192-192zM192 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm25.4-110.4c-.8 8.2-7.7 14.4-15.9 14.4h-19c-8.2 0-15.1-6.2-15.9-14.4l-12.8-128c-.9-9.4 6.4-17.6 15.9-17.6h44.6c9.5 0 16.9 8.2 15.9 17.6l-12.8 128z"]
  },
      ij = {
    prefix: "fas",
    iconName: "window",
    icon: [512, 512, [], "f40e", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-336 96c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm96 0c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm96 0c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32z"]
  },
      oj = {
    prefix: "fas",
    iconName: "window-alt",
    icon: [512, 512, [], "f40f", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM256 96c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm96 0c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm96 0c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32z"]
  },
      lj = {
    prefix: "fas",
    iconName: "window-close",
    icon: [512, 512, [], "f410", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"]
  },
      fj = {
    prefix: "fas",
    iconName: "window-frame",
    icon: [512, 512, [], "e04f", "M496,448H480V32A32,32,0,0,0,448,0H64A32,32,0,0,0,32,32V448H16A16,16,0,0,0,0,464v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V464A16,16,0,0,0,496,448ZM416,224H272V64H416ZM96,64H240V224H96Zm0,224H240V448H96ZM272,448V288H416V448Z"]
  },
      sj = {
    prefix: "fas",
    iconName: "window-frame-open",
    icon: [512, 512, [], "e050", "M480,32A32,32,0,0,0,448,0H64A32,32,0,0,0,32,32V288H480ZM240,224H96V64H240Zm176,0H272V64H416Zm80,224H480V320H416V448H96V320H32V448H16A16,16,0,0,0,0,464v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V464A16,16,0,0,0,496,448Z"]
  },
      uj = {
    prefix: "fas",
    iconName: "window-maximize",
    icon: [512, 512, [], "f2d0", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"]
  },
      hj = {
    prefix: "fas",
    iconName: "window-minimize",
    icon: [512, 512, [], "f2d1", "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"]
  },
      mj = {
    prefix: "fas",
    iconName: "window-restore",
    icon: [512, 512, [], "f2d2", "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"]
  },
      vj = {
    prefix: "fas",
    iconName: "windsock",
    icon: [512, 512, [], "f777", "M256 380.6l96-13.7V161.1l-96-13.7v233.2zm-144 20.5l80-11.4V138.3l-80-11.4v274.2zM498.3 182L416 170.3v187.4l82.3-11.8c7.9-1.1 13.7-7.9 13.7-15.8V197.9c0-8-5.9-14.7-13.7-15.9zM56 0C25.1 0 0 25.1 0 56c0 22.3 13.1 41.4 32 50.4V496c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V106.4c18.9-9 32-28.1 32-50.4 0-30.9-25.1-56-56-56z"]
  },
      dj = {
    prefix: "fas",
    iconName: "wine-bottle",
    icon: [512, 512, [], "f72f", "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"]
  },
      Mj = {
    prefix: "fas",
    iconName: "wine-glass",
    icon: [288, 512, [], "f4e3", "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"]
  },
      pj = {
    prefix: "fas",
    iconName: "wine-glass-alt",
    icon: [288, 512, [], "f5ce", "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"]
  },
      zj = {
    prefix: "fas",
    iconName: "won-sign",
    icon: [576, 512, [], "f159", "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"]
  },
      Cj = {
    prefix: "fas",
    iconName: "wreath",
    icon: [448, 512, [], "f7e2", "M298.9 384.8L224 416l-74.9-31.2c-10.4-3.5-21.1 4.3-21.1 15.2v96c0 10.9 10.7 18.6 21.1 15.2L224 480l74.9 31.2c10.4 3.5 21.1-4.3 21.1-15.2v-96c0-10.9-10.7-18.6-21.1-15.2zM448 224c0-16.9-8.7-31.6-21.9-40.2 8.9-12.9 11.3-29.9 4.8-45.5-6.6-15.9-20.7-26.2-36.4-28.9 3.3-15.4-.2-31.9-12.1-43.8-11.9-11.9-28.5-15.4-43.8-12.1-2.7-15.8-13-29.9-28.8-36.4-15.6-6.5-32.6-4-45.5 4.8C255.6 8.7 240.9 0 224 0s-31.6 8.7-40.2 21.9c-13-8.9-30-11.3-45.5-4.8-15.8 6.6-26.2 20.7-28.8 36.4-15.4-3.3-31.9.2-43.8 12.1C53.8 77.5 50.3 94 53.6 109.4c-15.8 2.7-29.8 13-36.4 28.8-6.5 15.6-4 32.6 4.8 45.5C8.7 192.4 0 207.1 0 224s8.7 31.6 21.9 40.2c-8.9 12.9-11.3 29.9-4.8 45.5 6.6 15.8 20.7 25.8 36.5 28.5-3.4 15.5 0 32.2 12.1 44.2 8.6 8.6 19.6 12.7 30.8 13.5 1-11.4 5.7-22 14-30.2 9-8.8 21-13.7 33.5-13.7 5.2 0 10.3.8 15.2 2.5l1.1.4 1.1.4 62.7 26.1 62.7-26.1 1.1-.4 1.1-.4c4.9-1.6 10-2.5 15.2-2.5 25 0 45.4 19.3 47.6 43.8 11.2-.7 22.2-4.9 30.8-13.5 12-12 15.5-28.7 12.1-44.2 15.8-2.7 29.9-12.6 36.5-28.5 6.5-15.6 4-32.6-4.8-45.5 12.9-8.5 21.6-23.2 21.6-40.1zm-146.5 26.2c-2.8 8.9-1.1 20.2-6.3 27.6-5.2 7.5-16.1 9.3-23.3 14.8-7.1 5.4-12.1 15.6-20.7 18.5-8.2 2.8-18.1-2.3-27.2-2.3s-19 5.1-27.2 2.3c-8.5-2.9-13.6-13.1-20.7-18.5-7.2-5.4-18.1-7.3-23.3-14.8-5.2-7.4-3.5-18.7-6.3-27.6-2.7-8.6-10.5-16.7-10.5-26.2s7.8-17.6 10.5-26.2c2.8-8.9 1.1-20.2 6.3-27.6 5.2-7.5 16.1-9.3 23.3-14.8 7.1-5.4 12.1-15.6 20.7-18.5 8.2-2.8 18.1 2.3 27.2 2.3s19-5.1 27.2-2.3c8.5 2.9 13.6 13.1 20.7 18.5 7.2 5.4 18.1 7.3 23.3 14.8 5.2 7.4 3.5 18.7 6.3 27.6 2.7 8.6 10.5 16.7 10.5 26.2s-7.8 17.6-10.5 26.2z"]
  },
      Lj = {
    prefix: "fas",
    iconName: "wrench",
    icon: [512, 512, [], "f0ad", "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"]
  },
      Aj = {
    prefix: "fas",
    iconName: "x-ray",
    icon: [640, 512, [], "f497", "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"]
  },
      Nj = {
    prefix: "fas",
    iconName: "yen-sign",
    icon: [384, 512, [], "f157", "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"]
  },
      gj = {
    prefix: "fas",
    iconName: "yin-yang",
    icon: [496, 512, [], "f6ad", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
  },
      Hj = {
    faAbacus: t,
    faAcorn: r,
    faAd: i,
    faAddressBook: o,
    faAddressCard: l,
    faAdjust: f,
    faAirConditioner: s,
    faAirFreshener: u,
    faAlarmClock: h,
    faAlarmExclamation: m,
    faAlarmPlus: v,
    faAlarmSnooze: d,
    faAlbum: M,
    faAlbumCollection: p,
    faAlicorn: z,
    faAlien: C,
    faAlienMonster: L,
    faAlignCenter: A,
    faAlignJustify: N,
    faAlignLeft: g,
    faAlignRight: H,
    faAlignSlash: V,
    faAllergies: x,
    faAmbulance: w,
    faAmericanSignLanguageInterpreting: y,
    faAmpGuitar: b,
    faAnalytics: S,
    faAnchor: T,
    faAngel: D,
    faAngleDoubleDown: j,
    faAngleDoubleLeft: E,
    faAngleDoubleRight: k,
    faAngleDoubleUp: I,
    faAngleDown: O,
    faAngleLeft: Q,
    faAngleRight: Z,
    faAngleUp: U,
    faAngry: B,
    faAnkh: R,
    faAppleAlt: Y,
    faAppleCrate: P,
    faArchive: F,
    faArchway: W,
    faArrowAltCircleDown: G,
    faArrowAltCircleLeft: q,
    faArrowAltCircleRight: J,
    faArrowAltCircleUp: K,
    faArrowAltDown: X,
    faArrowAltFromBottom: _,
    faArrowAltFromLeft: $,
    faArrowAltFromRight: cc,
    faArrowAltFromTop: ec,
    faArrowAltLeft: ac,
    faArrowAltRight: nc,
    faArrowAltSquareDown: tc,
    faArrowAltSquareLeft: rc,
    faArrowAltSquareRight: ic,
    faArrowAltSquareUp: oc,
    faArrowAltToBottom: lc,
    faArrowAltToLeft: fc,
    faArrowAltToRight: sc,
    faArrowAltToTop: uc,
    faArrowAltUp: hc,
    faArrowCircleDown: mc,
    faArrowCircleLeft: vc,
    faArrowCircleRight: dc,
    faArrowCircleUp: Mc,
    faArrowDown: pc,
    faArrowFromBottom: zc,
    faArrowFromLeft: Cc,
    faArrowFromRight: Lc,
    faArrowFromTop: Ac,
    faArrowLeft: Nc,
    faArrowRight: gc,
    faArrowSquareDown: Hc,
    faArrowSquareLeft: Vc,
    faArrowSquareRight: xc,
    faArrowSquareUp: wc,
    faArrowToBottom: yc,
    faArrowToLeft: bc,
    faArrowToRight: Sc,
    faArrowToTop: Tc,
    faArrowUp: Dc,
    faArrows: jc,
    faArrowsAlt: Ec,
    faArrowsAltH: kc,
    faArrowsAltV: Ic,
    faArrowsH: Oc,
    faArrowsV: Qc,
    faAssistiveListeningSystems: Zc,
    faAsterisk: Uc,
    faAt: Bc,
    faAtlas: Rc,
    faAtom: Yc,
    faAtomAlt: Pc,
    faAudioDescription: Fc,
    faAward: Wc,
    faAxe: Gc,
    faAxeBattle: qc,
    faBaby: Jc,
    faBabyCarriage: Kc,
    faBackpack: Xc,
    faBackspace: _c,
    faBackward: $c,
    faBacon: ce,
    faBacteria: ee,
    faBacterium: ae,
    faBadge: ne,
    faBadgeCheck: te,
    faBadgeDollar: re,
    faBadgePercent: ie,
    faBadgeSheriff: oe,
    faBadgerHoney: le,
    faBagsShopping: fe,
    faBahai: se,
    faBalanceScale: ue,
    faBalanceScaleLeft: he,
    faBalanceScaleRight: me,
    faBallPile: ve,
    faBallot: de,
    faBallotCheck: Me,
    faBan: pe,
    faBandAid: ze,
    faBanjo: Ce,
    faBarcode: Le,
    faBarcodeAlt: Ae,
    faBarcodeRead: Ne,
    faBarcodeScan: ge,
    faBars: He,
    faBaseball: Ve,
    faBaseballBall: xe,
    faBasketballBall: we,
    faBasketballHoop: ye,
    faBat: be,
    faBath: Se,
    faBatteryBolt: Te,
    faBatteryEmpty: De,
    faBatteryFull: je,
    faBatteryHalf: Ee,
    faBatteryQuarter: ke,
    faBatterySlash: Ie,
    faBatteryThreeQuarters: Oe,
    faBed: Qe,
    faBedAlt: Ze,
    faBedBunk: Ue,
    faBedEmpty: Be,
    faBeer: Re,
    faBell: Ye,
    faBellExclamation: Pe,
    faBellOn: Fe,
    faBellPlus: We,
    faBellSchool: Ge,
    faBellSchoolSlash: qe,
    faBellSlash: Je,
    faBells: Ke,
    faBetamax: Xe,
    faBezierCurve: _e,
    faBible: $e,
    faBicycle: ca,
    faBiking: ea,
    faBikingMountain: aa,
    faBinoculars: na,
    faBiohazard: ta,
    faBirthdayCake: ra,
    faBlanket: ia,
    faBlender: oa,
    faBlenderPhone: la,
    faBlind: fa,
    faBlinds: sa,
    faBlindsOpen: ua,
    faBlindsRaised: ha,
    faBlog: ma,
    faBold: va,
    faBolt: da,
    faBomb: Ma,
    faBone: pa,
    faBoneBreak: za,
    faBong: Ca,
    faBook: La,
    faBookAlt: Aa,
    faBookDead: Na,
    faBookHeart: ga,
    faBookMedical: Ha,
    faBookOpen: Va,
    faBookReader: xa,
    faBookSpells: wa,
    faBookUser: ya,
    faBookmark: ba,
    faBooks: Sa,
    faBooksMedical: Ta,
    faBoombox: Da,
    faBoot: ja,
    faBoothCurtain: Ea,
    faBorderAll: ka,
    faBorderBottom: Ia,
    faBorderCenterH: Oa,
    faBorderCenterV: Qa,
    faBorderInner: Za,
    faBorderLeft: Ua,
    faBorderNone: Ba,
    faBorderOuter: Ra,
    faBorderRight: Ya,
    faBorderStyle: Pa,
    faBorderStyleAlt: Fa,
    faBorderTop: Wa,
    faBowArrow: Ga,
    faBowlingBall: qa,
    faBowlingPins: Ja,
    faBox: Ka,
    faBoxAlt: Xa,
    faBoxBallot: _a,
    faBoxCheck: $a,
    faBoxFragile: cn,
    faBoxFull: en,
    faBoxHeart: an,
    faBoxOpen: nn,
    faBoxTissue: tn,
    faBoxUp: rn,
    faBoxUsd: on,
    faBoxes: ln,
    faBoxesAlt: fn,
    faBoxingGlove: sn,
    faBrackets: un,
    faBracketsCurly: hn,
    faBraille: mn,
    faBrain: vn,
    faBreadLoaf: dn,
    faBreadSlice: Mn,
    faBriefcase: pn,
    faBriefcaseMedical: zn,
    faBringForward: Cn,
    faBringFront: Ln,
    faBroadcastTower: An,
    faBroom: Nn,
    faBrowser: gn,
    faBrush: Hn,
    faBug: Vn,
    faBuilding: xn,
    faBullhorn: wn,
    faBullseye: yn,
    faBullseyeArrow: bn,
    faBullseyePointer: Sn,
    faBurgerSoda: Tn,
    faBurn: Dn,
    faBurrito: jn,
    faBus: En,
    faBusAlt: kn,
    faBusSchool: In,
    faBusinessTime: On,
    faCabinetFiling: Qn,
    faCactus: Zn,
    faCalculator: Un,
    faCalculatorAlt: Bn,
    faCalendar: Rn,
    faCalendarAlt: Yn,
    faCalendarCheck: Pn,
    faCalendarDay: Fn,
    faCalendarEdit: Wn,
    faCalendarExclamation: Gn,
    faCalendarMinus: qn,
    faCalendarPlus: Jn,
    faCalendarStar: Kn,
    faCalendarTimes: Xn,
    faCalendarWeek: _n,
    faCamcorder: $n,
    faCamera: ct,
    faCameraAlt: et,
    faCameraHome: at,
    faCameraMovie: nt,
    faCameraPolaroid: tt,
    faCameraRetro: rt,
    faCampfire: it,
    faCampground: ot,
    faCandleHolder: lt,
    faCandyCane: ft,
    faCandyCorn: st,
    faCannabis: ut,
    faCapsules: ht,
    faCar: mt,
    faCarAlt: vt,
    faCarBattery: dt,
    faCarBuilding: Mt,
    faCarBump: pt,
    faCarBus: zt,
    faCarCrash: Ct,
    faCarGarage: Lt,
    faCarMechanic: At,
    faCarSide: Nt,
    faCarTilt: gt,
    faCarWash: Ht,
    faCaravan: Vt,
    faCaravanAlt: xt,
    faCaretCircleDown: wt,
    faCaretCircleLeft: yt,
    faCaretCircleRight: bt,
    faCaretCircleUp: St,
    faCaretDown: Tt,
    faCaretLeft: Dt,
    faCaretRight: jt,
    faCaretSquareDown: Et,
    faCaretSquareLeft: kt,
    faCaretSquareRight: It,
    faCaretSquareUp: Ot,
    faCaretUp: Qt,
    faCarrot: Zt,
    faCars: Ut,
    faCartArrowDown: Bt,
    faCartPlus: Rt,
    faCashRegister: Yt,
    faCassetteTape: Pt,
    faCat: Ft,
    faCatSpace: Wt,
    faCauldron: Gt,
    faCctv: qt,
    faCertificate: Jt,
    faChair: Kt,
    faChairOffice: Xt,
    faChalkboard: _t,
    faChalkboardTeacher: $t,
    faChargingStation: cr,
    faChartArea: er,
    faChartBar: ar,
    faChartLine: nr,
    faChartLineDown: tr,
    faChartNetwork: rr,
    faChartPie: ir,
    faChartPieAlt: or,
    faChartScatter: lr,
    faCheck: fr,
    faCheckCircle: sr,
    faCheckDouble: ur,
    faCheckSquare: hr,
    faCheese: mr,
    faCheeseSwiss: vr,
    faCheeseburger: dr,
    faChess: Mr,
    faChessBishop: pr,
    faChessBishopAlt: zr,
    faChessBoard: Cr,
    faChessClock: Lr,
    faChessClockAlt: Ar,
    faChessKing: Nr,
    faChessKingAlt: gr,
    faChessKnight: Hr,
    faChessKnightAlt: Vr,
    faChessPawn: xr,
    faChessPawnAlt: wr,
    faChessQueen: yr,
    faChessQueenAlt: br,
    faChessRook: Sr,
    faChessRookAlt: Tr,
    faChevronCircleDown: Dr,
    faChevronCircleLeft: jr,
    faChevronCircleRight: Er,
    faChevronCircleUp: kr,
    faChevronDoubleDown: Ir,
    faChevronDoubleLeft: Or,
    faChevronDoubleRight: Qr,
    faChevronDoubleUp: Zr,
    faChevronDown: Ur,
    faChevronLeft: Br,
    faChevronRight: Rr,
    faChevronSquareDown: Yr,
    faChevronSquareLeft: Pr,
    faChevronSquareRight: Fr,
    faChevronSquareUp: Wr,
    faChevronUp: Gr,
    faChild: qr,
    faChimney: Jr,
    faChurch: Kr,
    faCircle: Xr,
    faCircleNotch: _r,
    faCity: $r,
    faClarinet: ci,
    faClawMarks: ei,
    faClinicMedical: ai,
    faClipboard: ni,
    faClipboardCheck: ti,
    faClipboardList: ri,
    faClipboardListCheck: ii,
    faClipboardPrescription: oi,
    faClipboardUser: li,
    faClock: fi,
    faClone: si,
    faClosedCaptioning: ui,
    faCloud: hi,
    faCloudDownload: mi,
    faCloudDownloadAlt: vi,
    faCloudDrizzle: di,
    faCloudHail: Mi,
    faCloudHailMixed: pi,
    faCloudMeatball: zi,
    faCloudMoon: Ci,
    faCloudMoonRain: Li,
    faCloudMusic: Ai,
    faCloudRain: Ni,
    faCloudRainbow: gi,
    faCloudShowers: Hi,
    faCloudShowersHeavy: Vi,
    faCloudSleet: xi,
    faCloudSnow: wi,
    faCloudSun: yi,
    faCloudSunRain: bi,
    faCloudUpload: Si,
    faCloudUploadAlt: Ti,
    faClouds: Di,
    faCloudsMoon: ji,
    faCloudsSun: Ei,
    faClub: ki,
    faCocktail: Ii,
    faCode: Oi,
    faCodeBranch: Qi,
    faCodeCommit: Zi,
    faCodeMerge: Ui,
    faCoffee: Bi,
    faCoffeePot: Ri,
    faCoffeeTogo: Yi,
    faCoffin: Pi,
    faCoffinCross: Fi,
    faCog: Wi,
    faCogs: Gi,
    faCoin: qi,
    faCoins: Ji,
    faColumns: Ki,
    faComet: Xi,
    faComment: _i,
    faCommentAlt: $i,
    faCommentAltCheck: co,
    faCommentAltDollar: eo,
    faCommentAltDots: ao,
    faCommentAltEdit: no,
    faCommentAltExclamation: to,
    faCommentAltLines: ro,
    faCommentAltMedical: io,
    faCommentAltMinus: oo,
    faCommentAltMusic: lo,
    faCommentAltPlus: fo,
    faCommentAltSlash: so,
    faCommentAltSmile: uo,
    faCommentAltTimes: ho,
    faCommentCheck: mo,
    faCommentDollar: vo,
    faCommentDots: Mo,
    faCommentEdit: po,
    faCommentExclamation: zo,
    faCommentLines: Co,
    faCommentMedical: Lo,
    faCommentMinus: Ao,
    faCommentMusic: No,
    faCommentPlus: go,
    faCommentSlash: Ho,
    faCommentSmile: Vo,
    faCommentTimes: xo,
    faComments: wo,
    faCommentsAlt: yo,
    faCommentsAltDollar: bo,
    faCommentsDollar: So,
    faCompactDisc: To,
    faCompass: Do,
    faCompassSlash: jo,
    faCompress: Eo,
    faCompressAlt: ko,
    faCompressArrowsAlt: Io,
    faCompressWide: Oo,
    faComputerClassic: Qo,
    faComputerSpeaker: Zo,
    faConciergeBell: Uo,
    faConstruction: Bo,
    faContainerStorage: Ro,
    faConveyorBelt: Yo,
    faConveyorBeltAlt: Po,
    faCookie: Fo,
    faCookieBite: Wo,
    faCopy: Go,
    faCopyright: qo,
    faCorn: Jo,
    faCouch: Ko,
    faCow: Xo,
    faCowbell: _o,
    faCowbellMore: $o,
    faCreditCard: cl,
    faCreditCardBlank: el,
    faCreditCardFront: al,
    faCricket: nl,
    faCroissant: tl,
    faCrop: rl,
    faCropAlt: il,
    faCross: ol,
    faCrosshairs: ll,
    faCrow: fl,
    faCrown: sl,
    faCrutch: ul,
    faCrutches: hl,
    faCube: ml,
    faCubes: vl,
    faCurling: dl,
    faCut: Ml,
    faDagger: pl,
    faDatabase: zl,
    faDeaf: Cl,
    faDebug: Ll,
    faDeer: Al,
    faDeerRudolph: Nl,
    faDemocrat: gl,
    faDesktop: Hl,
    faDesktopAlt: Vl,
    faDewpoint: xl,
    faDharmachakra: wl,
    faDiagnoses: yl,
    faDiamond: bl,
    faDice: Sl,
    faDiceD10: Tl,
    faDiceD12: Dl,
    faDiceD20: jl,
    faDiceD4: El,
    faDiceD6: kl,
    faDiceD8: Il,
    faDiceFive: Ol,
    faDiceFour: Ql,
    faDiceOne: Zl,
    faDiceSix: Ul,
    faDiceThree: Bl,
    faDiceTwo: Rl,
    faDigging: Yl,
    faDigitalTachograph: Pl,
    faDiploma: Fl,
    faDirections: Wl,
    faDiscDrive: Gl,
    faDisease: ql,
    faDivide: Jl,
    faDizzy: Kl,
    faDna: Xl,
    faDoNotEnter: _l,
    faDog: $l,
    faDogLeashed: cf,
    faDollarSign: ef,
    faDolly: af,
    faDollyEmpty: nf,
    faDollyFlatbed: tf,
    faDollyFlatbedAlt: rf,
    faDollyFlatbedEmpty: of,
    faDonate: lf,
    faDoorClosed: ff,
    faDoorOpen: sf,
    faDotCircle: uf,
    faDove: hf,
    faDownload: mf,
    faDraftingCompass: vf,
    faDragon: df,
    faDrawCircle: Mf,
    faDrawPolygon: pf,
    faDrawSquare: zf,
    faDreidel: Cf,
    faDrone: Lf,
    faDroneAlt: Af,
    faDrum: Nf,
    faDrumSteelpan: gf,
    faDrumstick: Hf,
    faDrumstickBite: Vf,
    faDryer: xf,
    faDryerAlt: wf,
    faDuck: yf,
    faDumbbell: bf,
    faDumpster: Sf,
    faDumpsterFire: Tf,
    faDungeon: Df,
    faEar: jf,
    faEarMuffs: Ef,
    faEclipse: kf,
    faEclipseAlt: If,
    faEdit: Of,
    faEgg: Qf,
    faEggFried: Zf,
    faEject: Uf,
    faElephant: Bf,
    faEllipsisH: Rf,
    faEllipsisHAlt: Yf,
    faEllipsisV: Pf,
    faEllipsisVAlt: Ff,
    faEmptySet: Wf,
    faEngineWarning: Gf,
    faEnvelope: qf,
    faEnvelopeOpen: Jf,
    faEnvelopeOpenDollar: Kf,
    faEnvelopeOpenText: Xf,
    faEnvelopeSquare: _f,
    faEquals: $f,
    faEraser: cs,
    faEthernet: es,
    faEuroSign: as,
    faExchange: ns,
    faExchangeAlt: ts,
    faExclamation: rs,
    faExclamationCircle: is,
    faExclamationSquare: os,
    faExclamationTriangle: ls,
    faExpand: fs,
    faExpandAlt: ss,
    faExpandArrows: us,
    faExpandArrowsAlt: hs,
    faExpandWide: ms,
    faExternalLink: vs,
    faExternalLinkAlt: ds,
    faExternalLinkSquare: Ms,
    faExternalLinkSquareAlt: ps,
    faEye: zs,
    faEyeDropper: Cs,
    faEyeEvil: Ls,
    faEyeSlash: As,
    faFan: Ns,
    faFanTable: gs,
    faFarm: Hs,
    faFastBackward: Vs,
    faFastForward: xs,
    faFaucet: ws,
    faFaucetDrip: ys,
    faFax: bs,
    faFeather: Ss,
    faFeatherAlt: Ts,
    faFemale: Ds,
    faFieldHockey: js,
    faFighterJet: Es,
    faFile: ks,
    faFileAlt: Is,
    faFileArchive: Os,
    faFileAudio: Qs,
    faFileCertificate: Zs,
    faFileChartLine: Us,
    faFileChartPie: Bs,
    faFileCheck: Rs,
    faFileCode: Ys,
    faFileContract: Ps,
    faFileCsv: Fs,
    faFileDownload: Ws,
    faFileEdit: Gs,
    faFileExcel: qs,
    faFileExclamation: Js,
    faFileExport: Ks,
    faFileImage: Xs,
    faFileImport: _s,
    faFileInvoice: $s,
    faFileInvoiceDollar: cu,
    faFileMedical: eu,
    faFileMedicalAlt: au,
    faFileMinus: nu,
    faFileMusic: tu,
    faFilePdf: ru,
    faFilePlus: iu,
    faFilePowerpoint: ou,
    faFilePrescription: lu,
    faFileSearch: fu,
    faFileSignature: su,
    faFileSpreadsheet: uu,
    faFileTimes: hu,
    faFileUpload: mu,
    faFileUser: vu,
    faFileVideo: du,
    faFileWord: Mu,
    faFilesMedical: pu,
    faFill: zu,
    faFillDrip: Cu,
    faFilm: Lu,
    faFilmAlt: Au,
    faFilmCanister: Nu,
    faFilter: gu,
    faFingerprint: Hu,
    faFire: Vu,
    faFireAlt: xu,
    faFireExtinguisher: wu,
    faFireSmoke: yu,
    faFireplace: bu,
    faFirstAid: Su,
    faFish: Tu,
    faFishCooked: Du,
    faFistRaised: ju,
    faFlag: Eu,
    faFlagAlt: ku,
    faFlagCheckered: Iu,
    faFlagUsa: Ou,
    faFlame: Qu,
    faFlashlight: Zu,
    faFlask: Uu,
    faFlaskPoison: Bu,
    faFlaskPotion: Ru,
    faFlower: Yu,
    faFlowerDaffodil: Pu,
    faFlowerTulip: Fu,
    faFlushed: Wu,
    faFlute: Gu,
    faFluxCapacitor: qu,
    faFog: Ju,
    faFolder: Ku,
    faFolderDownload: Xu,
    faFolderMinus: _u,
    faFolderOpen: $u,
    faFolderPlus: ch,
    faFolderTimes: eh,
    faFolderTree: ah,
    faFolderUpload: nh,
    faFolders: th,
    faFont: rh,
    faFontAwesomeLogoFull: ih,
    faFontCase: oh,
    faFootballBall: lh,
    faFootballHelmet: fh,
    faForklift: sh,
    faForward: uh,
    faFragile: hh,
    faFrenchFries: mh,
    faFrog: vh,
    faFrostyHead: dh,
    faFrown: Mh,
    faFrownOpen: ph,
    faFunction: zh,
    faFunnelDollar: Ch,
    faFutbol: Lh,
    faGalaxy: Ah,
    faGameBoard: Nh,
    faGameBoardAlt: gh,
    faGameConsoleHandheld: Hh,
    faGamepad: Vh,
    faGamepadAlt: xh,
    faGarage: wh,
    faGarageCar: yh,
    faGarageOpen: bh,
    faGasPump: Sh,
    faGasPumpSlash: Th,
    faGavel: Dh,
    faGem: jh,
    faGenderless: Eh,
    faGhost: kh,
    faGift: Ih,
    faGiftCard: Oh,
    faGifts: Qh,
    faGingerbreadMan: Zh,
    faGlass: Uh,
    faGlassChampagne: Bh,
    faGlassCheers: Rh,
    faGlassCitrus: Yh,
    faGlassMartini: Ph,
    faGlassMartiniAlt: Fh,
    faGlassWhiskey: Wh,
    faGlassWhiskeyRocks: Gh,
    faGlasses: qh,
    faGlassesAlt: Jh,
    faGlobe: Kh,
    faGlobeAfrica: Xh,
    faGlobeAmericas: _h,
    faGlobeAsia: $h,
    faGlobeEurope: cm,
    faGlobeSnow: em,
    faGlobeStand: am,
    faGolfBall: nm,
    faGolfClub: tm,
    faGopuram: rm,
    faGraduationCap: im,
    faGramophone: om,
    faGreaterThan: lm,
    faGreaterThanEqual: fm,
    faGrimace: sm,
    faGrin: um,
    faGrinAlt: hm,
    faGrinBeam: mm,
    faGrinBeamSweat: vm,
    faGrinHearts: dm,
    faGrinSquint: Mm,
    faGrinSquintTears: pm,
    faGrinStars: zm,
    faGrinTears: Cm,
    faGrinTongue: Lm,
    faGrinTongueSquint: Am,
    faGrinTongueWink: Nm,
    faGrinWink: gm,
    faGripHorizontal: Hm,
    faGripLines: Vm,
    faGripLinesVertical: xm,
    faGripVertical: wm,
    faGuitar: ym,
    faGuitarElectric: bm,
    faGuitars: Sm,
    faHSquare: Tm,
    faH1: Dm,
    faH2: jm,
    faH3: Em,
    faH4: km,
    faHamburger: Im,
    faHammer: Om,
    faHammerWar: Qm,
    faHamsa: Zm,
    faHandHeart: Um,
    faHandHolding: Bm,
    faHandHoldingBox: Rm,
    faHandHoldingHeart: Ym,
    faHandHoldingMagic: Pm,
    faHandHoldingMedical: Fm,
    faHandHoldingSeedling: Wm,
    faHandHoldingUsd: Gm,
    faHandHoldingWater: qm,
    faHandLizard: Jm,
    faHandMiddleFinger: Km,
    faHandPaper: Xm,
    faHandPeace: _m,
    faHandPointDown: $m,
    faHandPointLeft: cv,
    faHandPointRight: ev,
    faHandPointUp: av,
    faHandPointer: nv,
    faHandReceiving: tv,
    faHandRock: rv,
    faHandScissors: iv,
    faHandSparkles: ov,
    faHandSpock: lv,
    faHands: fv,
    faHandsHeart: sv,
    faHandsHelping: uv,
    faHandsUsd: hv,
    faHandsWash: mv,
    faHandshake: vv,
    faHandshakeAlt: dv,
    faHandshakeAltSlash: Mv,
    faHandshakeSlash: pv,
    faHanukiah: zv,
    faHardHat: Cv,
    faHashtag: Lv,
    faHatChef: Av,
    faHatCowboy: Nv,
    faHatCowboySide: gv,
    faHatSanta: Hv,
    faHatWinter: Vv,
    faHatWitch: xv,
    faHatWizard: wv,
    faHdd: yv,
    faHeadSide: bv,
    faHeadSideBrain: Sv,
    faHeadSideCough: Tv,
    faHeadSideCoughSlash: Dv,
    faHeadSideHeadphones: jv,
    faHeadSideMask: Ev,
    faHeadSideMedical: kv,
    faHeadSideVirus: Iv,
    faHeadVr: Ov,
    faHeading: Qv,
    faHeadphones: Zv,
    faHeadphonesAlt: Uv,
    faHeadset: Bv,
    faHeart: Rv,
    faHeartBroken: Yv,
    faHeartCircle: Pv,
    faHeartRate: Fv,
    faHeartSquare: Wv,
    faHeartbeat: Gv,
    faHeat: qv,
    faHelicopter: Jv,
    faHelmetBattle: Kv,
    faHexagon: Xv,
    faHighlighter: _v,
    faHiking: $v,
    faHippo: cd,
    faHistory: ed,
    faHockeyMask: ad,
    faHockeyPuck: nd,
    faHockeySticks: td,
    faHollyBerry: rd,
    faHome: id,
    faHomeAlt: od,
    faHomeHeart: ld,
    faHomeLg: fd,
    faHomeLgAlt: sd,
    faHoodCloak: ud,
    faHorizontalRule: hd,
    faHorse: md,
    faHorseHead: vd,
    faHorseSaddle: dd,
    faHospital: Md,
    faHospitalAlt: pd,
    faHospitalSymbol: zd,
    faHospitalUser: Cd,
    faHospitals: Ld,
    faHotTub: Ad,
    faHotdog: Nd,
    faHotel: gd,
    faHourglass: Hd,
    faHourglassEnd: Vd,
    faHourglassHalf: xd,
    faHourglassStart: wd,
    faHouse: yd,
    faHouseDamage: bd,
    faHouseDay: Sd,
    faHouseFlood: Td,
    faHouseLeave: Dd,
    faHouseNight: jd,
    faHouseReturn: Ed,
    faHouseSignal: kd,
    faHouseUser: Id,
    faHryvnia: Od,
    faHumidity: Qd,
    faHurricane: Zd,
    faICursor: Ud,
    faIceCream: Bd,
    faIceSkate: Rd,
    faIcicles: Yd,
    faIcons: Pd,
    faIconsAlt: Fd,
    faIdBadge: Wd,
    faIdCard: Gd,
    faIdCardAlt: qd,
    faIgloo: Jd,
    faImage: Kd,
    faImagePolaroid: Xd,
    faImages: _d,
    faInbox: $d,
    faInboxIn: cM,
    faInboxOut: eM,
    faIndent: aM,
    faIndustry: nM,
    faIndustryAlt: tM,
    faInfinity: rM,
    faInfo: iM,
    faInfoCircle: oM,
    faInfoSquare: lM,
    faInhaler: fM,
    faIntegral: sM,
    faIntersection: uM,
    faInventory: hM,
    faIslandTropical: mM,
    faItalic: vM,
    faJackOLantern: dM,
    faJedi: MM,
    faJoint: pM,
    faJournalWhills: zM,
    faJoystick: CM,
    faJug: LM,
    faKaaba: AM,
    faKazoo: NM,
    faKerning: gM,
    faKey: HM,
    faKeySkeleton: VM,
    faKeyboard: xM,
    faKeynote: wM,
    faKhanda: yM,
    faKidneys: bM,
    faKiss: SM,
    faKissBeam: TM,
    faKissWinkHeart: DM,
    faKite: jM,
    faKiwiBird: EM,
    faKnifeKitchen: kM,
    faLambda: IM,
    faLamp: OM,
    faLampDesk: QM,
    faLampFloor: ZM,
    faLandmark: UM,
    faLandmarkAlt: BM,
    faLanguage: RM,
    faLaptop: YM,
    faLaptopCode: PM,
    faLaptopHouse: FM,
    faLaptopMedical: WM,
    faLasso: GM,
    faLaugh: qM,
    faLaughBeam: JM,
    faLaughSquint: KM,
    faLaughWink: XM,
    faLayerGroup: _M,
    faLayerMinus: $M,
    faLayerPlus: cp,
    faLeaf: ep,
    faLeafHeart: ap,
    faLeafMaple: np,
    faLeafOak: tp,
    faLemon: rp,
    faLessThan: ip,
    faLessThanEqual: op,
    faLevelDown: lp,
    faLevelDownAlt: fp,
    faLevelUp: sp,
    faLevelUpAlt: up,
    faLifeRing: hp,
    faLightCeiling: mp,
    faLightSwitch: vp,
    faLightSwitchOff: dp,
    faLightSwitchOn: Mp,
    faLightbulb: pp,
    faLightbulbDollar: zp,
    faLightbulbExclamation: Cp,
    faLightbulbOn: Lp,
    faLightbulbSlash: Ap,
    faLightsHoliday: Np,
    faLineColumns: gp,
    faLineHeight: Hp,
    faLink: Vp,
    faLips: xp,
    faLiraSign: wp,
    faList: yp,
    faListAlt: bp,
    faListMusic: Sp,
    faListOl: Tp,
    faListUl: Dp,
    faLocation: jp,
    faLocationArrow: Ep,
    faLocationCircle: kp,
    faLocationSlash: Ip,
    faLock: Op,
    faLockAlt: Qp,
    faLockOpen: Zp,
    faLockOpenAlt: Up,
    faLongArrowAltDown: Bp,
    faLongArrowAltLeft: Rp,
    faLongArrowAltRight: Yp,
    faLongArrowAltUp: Pp,
    faLongArrowDown: Fp,
    faLongArrowLeft: Wp,
    faLongArrowRight: Gp,
    faLongArrowUp: qp,
    faLoveseat: Jp,
    faLowVision: Kp,
    faLuchador: Xp,
    faLuggageCart: _p,
    faLungs: $p,
    faLungsVirus: cz,
    faMace: ez,
    faMagic: az,
    faMagnet: nz,
    faMailBulk: tz,
    faMailbox: rz,
    faMale: iz,
    faMandolin: oz,
    faMap: lz,
    faMapMarked: fz,
    faMapMarkedAlt: sz,
    faMapMarker: uz,
    faMapMarkerAlt: hz,
    faMapMarkerAltSlash: mz,
    faMapMarkerCheck: vz,
    faMapMarkerEdit: dz,
    faMapMarkerExclamation: Mz,
    faMapMarkerMinus: pz,
    faMapMarkerPlus: zz,
    faMapMarkerQuestion: Cz,
    faMapMarkerSlash: Lz,
    faMapMarkerSmile: Az,
    faMapMarkerTimes: Nz,
    faMapPin: gz,
    faMapSigns: Hz,
    faMarker: Vz,
    faMars: xz,
    faMarsDouble: wz,
    faMarsStroke: yz,
    faMarsStrokeH: bz,
    faMarsStrokeV: Sz,
    faMask: Tz,
    faMeat: Dz,
    faMedal: jz,
    faMedkit: Ez,
    faMegaphone: kz,
    faMeh: Iz,
    faMehBlank: Oz,
    faMehRollingEyes: Qz,
    faMemory: Zz,
    faMenorah: Uz,
    faMercury: Bz,
    faMeteor: Rz,
    faMicrochip: Yz,
    faMicrophone: Pz,
    faMicrophoneAlt: Fz,
    faMicrophoneAltSlash: Wz,
    faMicrophoneSlash: Gz,
    faMicrophoneStand: qz,
    faMicroscope: Jz,
    faMicrowave: Kz,
    faMindShare: Xz,
    faMinus: _z,
    faMinusCircle: $z,
    faMinusHexagon: cC,
    faMinusOctagon: eC,
    faMinusSquare: aC,
    faMistletoe: nC,
    faMitten: tC,
    faMobile: rC,
    faMobileAlt: iC,
    faMobileAndroid: oC,
    faMobileAndroidAlt: lC,
    faMoneyBill: fC,
    faMoneyBillAlt: sC,
    faMoneyBillWave: uC,
    faMoneyBillWaveAlt: hC,
    faMoneyCheck: mC,
    faMoneyCheckAlt: vC,
    faMoneyCheckEdit: dC,
    faMoneyCheckEditAlt: MC,
    faMonitorHeartRate: pC,
    faMonkey: zC,
    faMonument: CC,
    faMoon: LC,
    faMoonCloud: AC,
    faMoonStars: NC,
    faMortarPestle: gC,
    faMosque: HC,
    faMotorcycle: VC,
    faMountain: xC,
    faMountains: wC,
    faMouse: yC,
    faMouseAlt: bC,
    faMousePointer: SC,
    faMp3Player: TC,
    faMug: DC,
    faMugHot: jC,
    faMugMarshmallows: EC,
    faMugTea: kC,
    faMusic: IC,
    faMusicAlt: OC,
    faMusicAltSlash: QC,
    faMusicSlash: ZC,
    faNarwhal: UC,
    faNetworkWired: BC,
    faNeuter: RC,
    faNewspaper: YC,
    faNotEqual: PC,
    faNotesMedical: FC,
    faObjectGroup: WC,
    faObjectUngroup: GC,
    faOctagon: qC,
    faOilCan: JC,
    faOilTemp: KC,
    faOm: XC,
    faOmega: _C,
    faOrnament: $C,
    faOtter: cL,
    faOutdent: eL,
    faOutlet: aL,
    faOven: nL,
    faOverline: tL,
    faPageBreak: rL,
    faPager: iL,
    faPaintBrush: oL,
    faPaintBrushAlt: lL,
    faPaintRoller: fL,
    faPalette: sL,
    faPallet: uL,
    faPalletAlt: hL,
    faPaperPlane: mL,
    faPaperclip: vL,
    faParachuteBox: dL,
    faParagraph: ML,
    faParagraphRtl: pL,
    faParking: zL,
    faParkingCircle: CL,
    faParkingCircleSlash: LL,
    faParkingSlash: AL,
    faPassport: NL,
    faPastafarianism: gL,
    faPaste: HL,
    faPause: VL,
    faPauseCircle: xL,
    faPaw: wL,
    faPawAlt: yL,
    faPawClaws: bL,
    faPeace: SL,
    faPegasus: TL,
    faPen: DL,
    faPenAlt: jL,
    faPenFancy: EL,
    faPenNib: kL,
    faPenSquare: IL,
    faPencil: OL,
    faPencilAlt: QL,
    faPencilPaintbrush: ZL,
    faPencilRuler: UL,
    faPennant: BL,
    faPeopleArrows: RL,
    faPeopleCarry: YL,
    faPepperHot: PL,
    faPercent: FL,
    faPercentage: WL,
    faPersonBooth: GL,
    faPersonCarry: qL,
    faPersonDolly: JL,
    faPersonDollyEmpty: KL,
    faPersonSign: XL,
    faPhone: _L,
    faPhoneAlt: $L,
    faPhoneLaptop: cA,
    faPhoneOffice: eA,
    faPhonePlus: aA,
    faPhoneRotary: nA,
    faPhoneSlash: tA,
    faPhoneSquare: rA,
    faPhoneSquareAlt: iA,
    faPhoneVolume: oA,
    faPhotoVideo: lA,
    faPi: fA,
    faPiano: sA,
    faPianoKeyboard: uA,
    faPie: hA,
    faPig: mA,
    faPiggyBank: vA,
    faPills: dA,
    faPizza: MA,
    faPizzaSlice: pA,
    faPlaceOfWorship: zA,
    faPlane: CA,
    faPlaneAlt: LA,
    faPlaneArrival: AA,
    faPlaneDeparture: NA,
    faPlaneSlash: gA,
    faPlanetMoon: HA,
    faPlanetRinged: VA,
    faPlay: xA,
    faPlayCircle: wA,
    faPlug: yA,
    faPlus: bA,
    faPlusCircle: SA,
    faPlusHexagon: TA,
    faPlusOctagon: DA,
    faPlusSquare: jA,
    faPodcast: EA,
    faPodium: kA,
    faPodiumStar: IA,
    faPoliceBox: OA,
    faPoll: QA,
    faPollH: ZA,
    faPollPeople: UA,
    faPoo: BA,
    faPooStorm: RA,
    faPoop: YA,
    faPopcorn: PA,
    faPortalEnter: FA,
    faPortalExit: WA,
    faPortrait: GA,
    faPoundSign: qA,
    faPowerOff: JA,
    faPray: KA,
    faPrayingHands: XA,
    faPrescription: _A,
    faPrescriptionBottle: $A,
    faPrescriptionBottleAlt: cN,
    faPresentation: eN,
    faPrint: aN,
    faPrintSearch: nN,
    faPrintSlash: tN,
    faProcedures: rN,
    faProjectDiagram: iN,
    faProjector: oN,
    faPumpMedical: lN,
    faPumpSoap: fN,
    faPumpkin: sN,
    faPuzzlePiece: uN,
    faQrcode: hN,
    faQuestion: mN,
    faQuestionCircle: vN,
    faQuestionSquare: dN,
    faQuidditch: MN,
    faQuoteLeft: pN,
    faQuoteRight: zN,
    faQuran: CN,
    faRabbit: LN,
    faRabbitFast: AN,
    faRacquet: NN,
    faRadar: gN,
    faRadiation: HN,
    faRadiationAlt: VN,
    faRadio: xN,
    faRadioAlt: wN,
    faRainbow: yN,
    faRaindrops: bN,
    faRam: SN,
    faRampLoading: TN,
    faRandom: DN,
    faRaygun: jN,
    faReceipt: EN,
    faRecordVinyl: kN,
    faRectangleLandscape: IN,
    faRectanglePortrait: ON,
    faRectangleWide: QN,
    faRecycle: ZN,
    faRedo: UN,
    faRedoAlt: BN,
    faRefrigerator: RN,
    faRegistered: YN,
    faRemoveFormat: PN,
    faRepeat: FN,
    faRepeat1: WN,
    faRepeat1Alt: GN,
    faRepeatAlt: qN,
    faReply: JN,
    faReplyAll: KN,
    faRepublican: XN,
    faRestroom: _N,
    faRetweet: $N,
    faRetweetAlt: cg,
    faRibbon: eg,
    faRing: ag,
    faRingsWedding: ng,
    faRoad: tg,
    faRobot: rg,
    faRocket: ig,
    faRocketLaunch: og,
    faRoute: lg,
    faRouteHighway: fg,
    faRouteInterstate: sg,
    faRouter: ug,
    faRss: hg,
    faRssSquare: mg,
    faRubleSign: vg,
    faRuler: dg,
    faRulerCombined: Mg,
    faRulerHorizontal: pg,
    faRulerTriangle: zg,
    faRulerVertical: Cg,
    faRunning: Lg,
    faRupeeSign: Ag,
    faRv: Ng,
    faSack: gg,
    faSackDollar: Hg,
    faSadCry: Vg,
    faSadTear: xg,
    faSalad: wg,
    faSandwich: yg,
    faSatellite: bg,
    faSatelliteDish: Sg,
    faSausage: Tg,
    faSave: Dg,
    faSaxHot: jg,
    faSaxophone: Eg,
    faScalpel: kg,
    faScalpelPath: Ig,
    faScanner: Og,
    faScannerImage: Qg,
    faScannerKeyboard: Zg,
    faScannerTouchscreen: Ug,
    faScarecrow: Bg,
    faScarf: Rg,
    faSchool: Yg,
    faScrewdriver: Pg,
    faScroll: Fg,
    faScrollOld: Wg,
    faScrubber: Gg,
    faScythe: qg,
    faSdCard: Jg,
    faSearch: Kg,
    faSearchDollar: Xg,
    faSearchLocation: _g,
    faSearchMinus: $g,
    faSearchPlus: cH,
    faSeedling: eH,
    faSendBack: aH,
    faSendBackward: nH,
    faSensor: tH,
    faSensorAlert: rH,
    faSensorFire: iH,
    faSensorOn: oH,
    faSensorSmoke: lH,
    faServer: fH,
    faShapes: sH,
    faShare: uH,
    faShareAll: hH,
    faShareAlt: mH,
    faShareAltSquare: vH,
    faShareSquare: dH,
    faSheep: MH,
    faShekelSign: pH,
    faShield: zH,
    faShieldAlt: CH,
    faShieldCheck: LH,
    faShieldCross: AH,
    faShieldVirus: NH,
    faShip: gH,
    faShippingFast: HH,
    faShippingTimed: VH,
    faShishKebab: xH,
    faShoePrints: wH,
    faShoppingBag: yH,
    faShoppingBasket: bH,
    faShoppingCart: SH,
    faShovel: TH,
    faShovelSnow: DH,
    faShower: jH,
    faShredder: EH,
    faShuttleVan: kH,
    faShuttlecock: IH,
    faSickle: OH,
    faSigma: QH,
    faSign: ZH,
    faSignIn: UH,
    faSignInAlt: BH,
    faSignLanguage: RH,
    faSignOut: YH,
    faSignOutAlt: PH,
    faSignal: FH,
    faSignal1: WH,
    faSignal2: GH,
    faSignal3: qH,
    faSignal4: JH,
    faSignalAlt: KH,
    faSignalAlt1: XH,
    faSignalAlt2: _H,
    faSignalAlt3: $H,
    faSignalAltSlash: cV,
    faSignalSlash: eV,
    faSignalStream: aV,
    faSignature: nV,
    faSimCard: tV,
    faSink: rV,
    faSiren: iV,
    faSirenOn: oV,
    faSitemap: lV,
    faSkating: fV,
    faSkeleton: sV,
    faSkiJump: uV,
    faSkiLift: hV,
    faSkiing: mV,
    faSkiingNordic: vV,
    faSkull: dV,
    faSkullCow: MV,
    faSkullCrossbones: pV,
    faSlash: zV,
    faSledding: CV,
    faSleigh: LV,
    faSlidersH: AV,
    faSlidersHSquare: NV,
    faSlidersV: gV,
    faSlidersVSquare: HV,
    faSmile: VV,
    faSmileBeam: xV,
    faSmilePlus: wV,
    faSmileWink: yV,
    faSmog: bV,
    faSmoke: SV,
    faSmoking: TV,
    faSmokingBan: DV,
    faSms: jV,
    faSnake: EV,
    faSnooze: kV,
    faSnowBlowing: IV,
    faSnowboarding: OV,
    faSnowflake: QV,
    faSnowflakes: ZV,
    faSnowman: UV,
    faSnowmobile: BV,
    faSnowplow: RV,
    faSoap: YV,
    faSocks: PV,
    faSolarPanel: FV,
    faSolarSystem: WV,
    faSort: GV,
    faSortAlphaDown: qV,
    faSortAlphaDownAlt: JV,
    faSortAlphaUp: KV,
    faSortAlphaUpAlt: XV,
    faSortAlt: _V,
    faSortAmountDown: $V,
    faSortAmountDownAlt: cx,
    faSortAmountUp: ex,
    faSortAmountUpAlt: ax,
    faSortCircle: nx,
    faSortCircleDown: tx,
    faSortCircleUp: rx,
    faSortDown: ix,
    faSortNumericDown: ox,
    faSortNumericDownAlt: lx,
    faSortNumericUp: fx,
    faSortNumericUpAlt: sx,
    faSortShapesDown: ux,
    faSortShapesDownAlt: hx,
    faSortShapesUp: mx,
    faSortShapesUpAlt: vx,
    faSortSizeDown: dx,
    faSortSizeDownAlt: Mx,
    faSortSizeUp: px,
    faSortSizeUpAlt: zx,
    faSortUp: Cx,
    faSoup: Lx,
    faSpa: Ax,
    faSpaceShuttle: Nx,
    faSpaceStationMoon: gx,
    faSpaceStationMoonAlt: Hx,
    faSpade: Vx,
    faSparkles: xx,
    faSpeaker: wx,
    faSpeakers: yx,
    faSpellCheck: bx,
    faSpider: Sx,
    faSpiderBlackWidow: Tx,
    faSpiderWeb: Dx,
    faSpinner: jx,
    faSpinnerThird: Ex,
    faSplotch: kx,
    faSprayCan: Ix,
    faSprinkler: Ox,
    faSquare: Qx,
    faSquareFull: Zx,
    faSquareRoot: Ux,
    faSquareRootAlt: Bx,
    faSquirrel: Rx,
    faStaff: Yx,
    faStamp: Px,
    faStar: Fx,
    faStarAndCrescent: Wx,
    faStarChristmas: Gx,
    faStarExclamation: qx,
    faStarHalf: Jx,
    faStarHalfAlt: Kx,
    faStarOfDavid: Xx,
    faStarOfLife: _x,
    faStarShooting: $x,
    faStarfighter: cw,
    faStarfighterAlt: ew,
    faStars: aw,
    faStarship: nw,
    faStarshipFreighter: tw,
    faSteak: rw,
    faSteeringWheel: iw,
    faStepBackward: ow,
    faStepForward: lw,
    faStethoscope: fw,
    faStickyNote: sw,
    faStocking: uw,
    faStomach: hw,
    faStop: mw,
    faStopCircle: vw,
    faStopwatch: dw,
    faStopwatch20: Mw,
    faStore: pw,
    faStoreAlt: zw,
    faStoreAltSlash: Cw,
    faStoreSlash: Lw,
    faStream: Aw,
    faStreetView: Nw,
    faStretcher: gw,
    faStrikethrough: Hw,
    faStroopwafel: Vw,
    faSubscript: xw,
    faSubway: ww,
    faSuitcase: yw,
    faSuitcaseRolling: bw,
    faSun: Sw,
    faSunCloud: Tw,
    faSunDust: Dw,
    faSunHaze: jw,
    faSunglasses: Ew,
    faSunrise: kw,
    faSunset: Iw,
    faSuperscript: Ow,
    faSurprise: Qw,
    faSwatchbook: Zw,
    faSwimmer: Uw,
    faSwimmingPool: Bw,
    faSword: Rw,
    faSwordLaser: Yw,
    faSwordLaserAlt: Pw,
    faSwords: Fw,
    faSwordsLaser: Ww,
    faSynagogue: Gw,
    faSync: qw,
    faSyncAlt: Jw,
    faSyringe: Kw,
    faTable: Xw,
    faTableTennis: _w,
    faTablet: $w,
    faTabletAlt: cy,
    faTabletAndroid: ey,
    faTabletAndroidAlt: ay,
    faTabletRugged: ny,
    faTablets: ty,
    faTachometer: ry,
    faTachometerAlt: iy,
    faTachometerAltAverage: oy,
    faTachometerAltFast: ly,
    faTachometerAltFastest: fy,
    faTachometerAltSlow: sy,
    faTachometerAltSlowest: uy,
    faTachometerAverage: hy,
    faTachometerFast: my,
    faTachometerFastest: vy,
    faTachometerSlow: dy,
    faTachometerSlowest: My,
    faTaco: py,
    faTag: zy,
    faTags: Cy,
    faTally: Ly,
    faTanakh: Ay,
    faTape: Ny,
    faTasks: gy,
    faTasksAlt: Hy,
    faTaxi: Vy,
    faTeeth: xy,
    faTeethOpen: wy,
    faTelescope: yy,
    faTemperatureDown: by,
    faTemperatureFrigid: Sy,
    faTemperatureHigh: Ty,
    faTemperatureHot: Dy,
    faTemperatureLow: jy,
    faTemperatureUp: Ey,
    faTenge: ky,
    faTennisBall: Iy,
    faTerminal: Oy,
    faText: Qy,
    faTextHeight: Zy,
    faTextSize: Uy,
    faTextWidth: By,
    faTh: Ry,
    faThLarge: Yy,
    faThList: Py,
    faTheaterMasks: Fy,
    faThermometer: Wy,
    faThermometerEmpty: Gy,
    faThermometerFull: qy,
    faThermometerHalf: Jy,
    faThermometerQuarter: Ky,
    faThermometerThreeQuarters: Xy,
    faTheta: _y,
    faThumbsDown: $y,
    faThumbsUp: cb,
    faThumbtack: eb,
    faThunderstorm: ab,
    faThunderstormMoon: nb,
    faThunderstormSun: tb,
    faTicket: rb,
    faTicketAlt: ib,
    faTilde: ob,
    faTimes: lb,
    faTimesCircle: fb,
    faTimesHexagon: sb,
    faTimesOctagon: ub,
    faTimesSquare: hb,
    faTint: mb,
    faTintSlash: vb,
    faTire: db,
    faTireFlat: Mb,
    faTirePressureWarning: pb,
    faTireRugged: zb,
    faTired: Cb,
    faToggleOff: Lb,
    faToggleOn: Ab,
    faToilet: Nb,
    faToiletPaper: gb,
    faToiletPaperAlt: Hb,
    faToiletPaperSlash: Vb,
    faTombstone: xb,
    faTombstoneAlt: wb,
    faToolbox: yb,
    faTools: bb,
    faTooth: Sb,
    faToothbrush: Tb,
    faTorah: Db,
    faToriiGate: jb,
    faTornado: Eb,
    faTractor: kb,
    faTrademark: Ib,
    faTrafficCone: Ob,
    faTrafficLight: Qb,
    faTrafficLightGo: Zb,
    faTrafficLightSlow: Ub,
    faTrafficLightStop: Bb,
    faTrailer: Rb,
    faTrain: Yb,
    faTram: Pb,
    faTransgender: Fb,
    faTransgenderAlt: Wb,
    faTransporter: Gb,
    faTransporter1: qb,
    faTransporter2: Jb,
    faTransporter3: Kb,
    faTransporterEmpty: Xb,
    faTrash: _b,
    faTrashAlt: $b,
    faTrashRestore: cS,
    faTrashRestoreAlt: eS,
    faTrashUndo: aS,
    faTrashUndoAlt: nS,
    faTreasureChest: tS,
    faTree: rS,
    faTreeAlt: iS,
    faTreeChristmas: oS,
    faTreeDecorated: lS,
    faTreeLarge: fS,
    faTreePalm: sS,
    faTrees: uS,
    faTriangle: hS,
    faTriangleMusic: mS,
    faTrophy: vS,
    faTrophyAlt: dS,
    faTruck: MS,
    faTruckContainer: pS,
    faTruckCouch: zS,
    faTruckLoading: CS,
    faTruckMonster: LS,
    faTruckMoving: AS,
    faTruckPickup: NS,
    faTruckPlow: gS,
    faTruckRamp: HS,
    faTrumpet: VS,
    faTshirt: xS,
    faTty: wS,
    faTurkey: yS,
    faTurntable: bS,
    faTurtle: SS,
    faTv: TS,
    faTvAlt: DS,
    faTvMusic: jS,
    faTvRetro: ES,
    faTypewriter: kS,
    faUfo: IS,
    faUfoBeam: OS,
    faUmbrella: QS,
    faUmbrellaBeach: ZS,
    faUnderline: US,
    faUndo: BS,
    faUndoAlt: RS,
    faUnicorn: YS,
    faUnion: PS,
    faUniversalAccess: FS,
    faUniversity: WS,
    faUnlink: GS,
    faUnlock: qS,
    faUnlockAlt: JS,
    faUpload: KS,
    faUsbDrive: XS,
    faUsdCircle: _S,
    faUsdSquare: $S,
    faUser: cT,
    faUserAlien: eT,
    faUserAlt: aT,
    faUserAltSlash: nT,
    faUserAstronaut: tT,
    faUserChart: rT,
    faUserCheck: iT,
    faUserCircle: oT,
    faUserClock: lT,
    faUserCog: fT,
    faUserCowboy: sT,
    faUserCrown: uT,
    faUserEdit: hT,
    faUserFriends: mT,
    faUserGraduate: vT,
    faUserHardHat: dT,
    faUserHeadset: MT,
    faUserInjured: pT,
    faUserLock: zT,
    faUserMd: CT,
    faUserMdChat: LT,
    faUserMinus: AT,
    faUserMusic: NT,
    faUserNinja: gT,
    faUserNurse: HT,
    faUserPlus: VT,
    faUserRobot: xT,
    faUserSecret: wT,
    faUserShield: yT,
    faUserSlash: bT,
    faUserTag: ST,
    faUserTie: TT,
    faUserTimes: DT,
    faUserUnlock: jT,
    faUserVisor: ET,
    faUsers: kT,
    faUsersClass: IT,
    faUsersCog: OT,
    faUsersCrown: QT,
    faUsersMedical: ZT,
    faUsersSlash: UT,
    faUtensilFork: BT,
    faUtensilKnife: RT,
    faUtensilSpoon: YT,
    faUtensils: PT,
    faUtensilsAlt: FT,
    faVacuum: WT,
    faVacuumRobot: GT,
    faValueAbsolute: qT,
    faVectorSquare: JT,
    faVenus: KT,
    faVenusDouble: XT,
    faVenusMars: _T,
    faVest: $T,
    faVestPatches: cD,
    faVhs: eD,
    faVial: aD,
    faVials: nD,
    faVideo: tD,
    faVideoPlus: rD,
    faVideoSlash: iD,
    faVihara: oD,
    faViolin: lD,
    faVirus: fD,
    faVirusSlash: sD,
    faViruses: uD,
    faVoicemail: hD,
    faVolcano: mD,
    faVolleyballBall: vD,
    faVolume: dD,
    faVolumeDown: MD,
    faVolumeMute: pD,
    faVolumeOff: zD,
    faVolumeSlash: CD,
    faVolumeUp: LD,
    faVoteNay: AD,
    faVoteYea: ND,
    faVrCardboard: gD,
    faWagonCovered: HD,
    faWalker: VD,
    faWalkieTalkie: xD,
    faWalking: wD,
    faWallet: yD,
    faWand: bD,
    faWandMagic: SD,
    faWarehouse: TD,
    faWarehouseAlt: DD,
    faWasher: jD,
    faWatch: ED,
    faWatchCalculator: kD,
    faWatchFitness: ID,
    faWater: OD,
    faWaterLower: QD,
    faWaterRise: ZD,
    faWaveSine: UD,
    faWaveSquare: BD,
    faWaveTriangle: RD,
    faWaveform: YD,
    faWaveformPath: PD,
    faWebcam: FD,
    faWebcamSlash: WD,
    faWeight: GD,
    faWeightHanging: qD,
    faWhale: JD,
    faWheat: KD,
    faWheelchair: XD,
    faWhistle: _D,
    faWifi: $D,
    faWifi1: cj,
    faWifi2: ej,
    faWifiSlash: aj,
    faWind: nj,
    faWindTurbine: tj,
    faWindWarning: rj,
    faWindow: ij,
    faWindowAlt: oj,
    faWindowClose: lj,
    faWindowFrame: fj,
    faWindowFrameOpen: sj,
    faWindowMaximize: uj,
    faWindowMinimize: hj,
    faWindowRestore: mj,
    faWindsock: vj,
    faWineBottle: dj,
    faWineGlass: Mj,
    faWineGlassAlt: pj,
    faWonSign: zj,
    faWreath: Cj,
    faWrench: Lj,
    faXRay: Aj,
    faYenSign: Nj,
    faYinYang: gj
  };
}, function (c, e, a) {
  "use strict";
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var n = "function" == typeof Symbol && Symbol.for,
      t = n ? Symbol.for("react.element") : 60103,
      r = n ? Symbol.for("react.portal") : 60106,
      i = n ? Symbol.for("react.fragment") : 60107,
      o = n ? Symbol.for("react.strict_mode") : 60108,
      l = n ? Symbol.for("react.profiler") : 60114,
      f = n ? Symbol.for("react.provider") : 60109,
      s = n ? Symbol.for("react.context") : 60110,
      u = n ? Symbol.for("react.async_mode") : 60111,
      h = n ? Symbol.for("react.concurrent_mode") : 60111,
      m = n ? Symbol.for("react.forward_ref") : 60112,
      v = n ? Symbol.for("react.suspense") : 60113,
      d = n ? Symbol.for("react.suspense_list") : 60120,
      M = n ? Symbol.for("react.memo") : 60115,
      p = n ? Symbol.for("react.lazy") : 60116,
      z = n ? Symbol.for("react.block") : 60121,
      C = n ? Symbol.for("react.fundamental") : 60117,
      L = n ? Symbol.for("react.responder") : 60118,
      A = n ? Symbol.for("react.scope") : 60119;

  function N(c) {
    if ("object" == typeof c && null !== c) {
      var e = c.$$typeof;

      switch (e) {
        case t:
          switch (c = c.type) {
            case u:
            case h:
            case i:
            case l:
            case o:
            case v:
              return c;

            default:
              switch (c = c && c.$$typeof) {
                case s:
                case m:
                case p:
                case M:
                case f:
                  return c;

                default:
                  return e;
              }

          }

        case r:
          return e;
      }
    }
  }

  function g(c) {
    return N(c) === h;
  }

  e.AsyncMode = u, e.ConcurrentMode = h, e.ContextConsumer = s, e.ContextProvider = f, e.Element = t, e.ForwardRef = m, e.Fragment = i, e.Lazy = p, e.Memo = M, e.Portal = r, e.Profiler = l, e.StrictMode = o, e.Suspense = v, e.isAsyncMode = function (c) {
    return g(c) || N(c) === u;
  }, e.isConcurrentMode = g, e.isContextConsumer = function (c) {
    return N(c) === s;
  }, e.isContextProvider = function (c) {
    return N(c) === f;
  }, e.isElement = function (c) {
    return "object" == typeof c && null !== c && c.$$typeof === t;
  }, e.isForwardRef = function (c) {
    return N(c) === m;
  }, e.isFragment = function (c) {
    return N(c) === i;
  }, e.isLazy = function (c) {
    return N(c) === p;
  }, e.isMemo = function (c) {
    return N(c) === M;
  }, e.isPortal = function (c) {
    return N(c) === r;
  }, e.isProfiler = function (c) {
    return N(c) === l;
  }, e.isStrictMode = function (c) {
    return N(c) === o;
  }, e.isSuspense = function (c) {
    return N(c) === v;
  }, e.isValidElementType = function (c) {
    return "string" == typeof c || "function" == typeof c || c === i || c === h || c === l || c === o || c === v || c === d || "object" == typeof c && null !== c && (c.$$typeof === p || c.$$typeof === M || c.$$typeof === f || c.$$typeof === s || c.$$typeof === m || c.$$typeof === C || c.$$typeof === L || c.$$typeof === A || c.$$typeof === z);
  }, e.typeOf = N;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.ApprovalToggleButton = void 0;

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = s(t),
      i = s(a(2)),
      o = s(a(85)),
      l = a(14),
      f = a(26);

  function s(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var u = e.ApprovalToggleButton = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "colors",
      value: function value() {
        this.props.styles;
        return {
          active: {
            base: "#e95832"
          },
          activeThumb: {
            base: "#e95832"
          },
          inactive: {
            base: "#EB0000"
          },
          inactiveThumb: {
            base: "#EB0000"
          }
        };
      }
    }, {
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.onChange,
            a = c.value,
            n = c.t,
            t = !0 === a,
            i = t ? "toggle-approve" : "toggle-reject";
        return r.default.createElement("div", {
          style: {
            textAlign: "center"
          }
        }, r.default.createElement(o.default, {
          colors: this.colors(),
          onToggle: e,
          thumbStyle: {
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0",
            left: "32px"
          },
          thumbIcon: r.default.createElement(l.FontAwesomeIcon, {
            icon: t ? f.faCheck : f.faTimes,
            className: "toggle_button_approval__icon " + i
          }),
          trackStyle: {
            height: "23px"
          },
          value: a,
          activeLabel: "",
          inactiveLabel: ""
        }), r.default.createElement("small", {
          className: "all-caps " + i
        }, n(t ? "approvalToggleButton:approveLbl" : "approvalToggleButton:declineLbl")));
      }
    }]), e;
  }();

  u.propTypes = {
    onChange: i.default.func.isRequired,
    value: i.default.bool.isRequired,
    styles: i.default.object.isRequired
  }, e.default = u;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n,
      t = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      r = a(0),
      i = (n = r) && n.__esModule ? n : {
    default: n
  },
      o = a(36),
      l = a(22);

  var f = function f(c) {
    var e = c.title,
        a = c.subtitle,
        n = c.content,
        t = c.styles,
        r = c.style,
        o = c.pricingPromiseTextEl,
        l = void 0 === o ? null : o;
    return i.default.createElement("div", {
      style: r
    }, i.default.createElement("div", {
      className: "modal-title"
    }, e), i.default.createElement("div", {
      className: "all-caps modal-subtitle"
    }, a), i.default.createElement("div", {
      className: "modal-price",
      style: {
        color: t.secondaryColor
      }
    }, n), l);
  },
      s = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, i.default.Component), t(e, [{
      key: "renderGoodPriceIndicator",
      value: function value(c, e, a) {
        var n = this.props,
            t = n.contactUsEl,
            r = n.t;

        if (null != c && null != e && null != a) {
          var o = Number(c),
              l = Number(e),
              f = Number(a),
              s = (l + o) / 2;
          return f <= s ? i.default.createElement("div", {
            className: "price-indicator-wrapper"
          }, i.default.createElement("div", {
            className: "price-indicator ca-light-green"
          }, r("priceInfoDisplay:greatPriceLbl"))) : s < f && f <= o ? i.default.createElement("div", {
            className: "price-indicator-wrapper"
          }, i.default.createElement("div", {
            className: "price-indicator ca-light-green"
          }, r("priceInfoDisplay:goodPriceLbl"))) : o < f ? i.default.createElement("div", {
            className: "price-indicator-wrapper"
          }, i.default.createElement("div", {
            className: "price-indicator ca-red"
          }, r("priceInfoDisplay:highPriceLbl")), t && i.default.createElement("div", {
            style: {
              marginTop: "10px"
            }
          }, r("priceInfoDisplay:priceSeemsLittleHighLbl"), " ", t)) : null;
        }
      }
    }, {
      key: "displayPriceRange",
      value: function value(c, e) {
        if (c && e && c != e) {
          var a = this.props.i18n;
          return i.default.createElement("span", null, (0, o.numberFormatToCurrency)(e, a), " - ", (0, o.numberFormatToCurrency)(c, a));
        }
      }
    }, {
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.styles,
            a = (c.onApprovalChange, c.isShopSuggested),
            n = c.hidePriceRange,
            t = c.t,
            r = c.i18n,
            s = c.pricingPromiseTextEl,
            u = this.props.service || {},
            h = this.props.priceRange || {},
            m = h.high_price_estimate || {},
            v = h.low_price_estimate || {},
            d = m.shop_price_estimate,
            M = v.shop_price_estimate,
            p = u.override_total_with_promotional_discount,
            z = this.displayPriceRange(d, M),
            C = !n && a && z,
            L = (0, l.formattedName)(u);
        return i.default.createElement("div", {
          className: "modal-price-range"
        }, C && i.default.createElement(f, {
          title: t("priceInfoDisplay:priceRangeTitle"),
          subtitle: L,
          content: z,
          styles: e,
          style: {
            marginBottom: "30px"
          }
        }), i.default.createElement(f, {
          title: t("priceInfoDisplay:caradvisePriceTitle"),
          subtitle: L,
          content: (0, o.numberFormatToCurrency)(p, r),
          styles: e,
          style: C ? {} : {
            marginBottom: "50px"
          },
          pricingPromiseTextEl: s
        }), C && this.renderGoodPriceIndicator(d, M, p));
      }
    }]), e;
  }();

  e.default = s;
}, function (c, e) {
  c.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALySURBVHgB7ZhPUhNBFMa/10NpyhVuEtkNJ3AylGvJCYANRDbiCcATACcQToBsNBQL8ASMay0ynIC4UCQuTJVVFFKVfr5OGAjYmT9JJit+VVNJdad7vn79+r3XAR6Ih86XZg6IMImc0EBDKYRtTSdTta9B0u8nNPGJAtaREyQPiyoFRvOV35KPwzb05lQtbFh/f1b1XAV1ijEjQt/bhCnTIAvYxJhhYEUMcfR90Zvvbafoy49Fb81RtCpNLsYN6ZXSx3D3jqAI2cJZjA6XWXkO8VzsQhkt0rpS3A9DwpgwC1VM70Dk2foJHBRr9YrCmBBfDUp79bLdX7nRBr/pCkNHvSsRwLVNpDVPKsV94pQO+h3fOM6q/sZtqGE5VFyJ5rkW5IvHYweZ4EapVp/GgDSr5SNmTEocXOhdVGfLCpf6UKJ1Cxkwq8IwKH578ffWMhE3Tn3XjPEw86dne/V55MCNU4uVtsw2pBk04XDG7R1A0NPDsGW2QZ7dpEF/LvAZOWGNQ91TB9chdWAc7163OPPxwM6cxISt8drRGudV3zj6HUGUclsHZWyBMS2ZBTHIRY6ohLeHllb3dN7LrcJU8XrwzdZeKKhcYpAhXhBZLQQH/BpD8lus3FyaWUUWQf1SivjR7LB106VYmYm3flX99dSCOsFSI7D1Sfm5M6gvdev4bpqScmSjV1TiKWPS23263CePVeYUYhbhwDHj3KjNiGpW/c5cqSrGn0v+lmzdqrWTObxfQvSjYxlWB/JWa9VoautUgowDXhWoHlcXm2sN2s52cf/LfwehufzCI92ek0OyZklFXeS+Vto7XkhdU5vVSW6r950wEmYOAdOtKGIvaUxv1ZipyG8uex5YHSW/ID1E3BLRleKHsLOITKnDDGqzLmNkCVbm6RGTWZDBmPXRJZfFStsYApZrj9mmXjGGoe5l3bqJTOn7Mu2N1wiRx9zpA1v/yC6KJnI7Cs+1Vp780+FG7RrUMDlRaR1eXCGYlmCLB4bgH8qARcJEa/e4AAAAAElFTkSuQmCC";
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n,
      t = a(0),
      r = (n = t) && n.__esModule ? n : {
    default: n
  },
      i = a(14),
      o = a(26);

  e.default = function (c) {
    var e = c.comment,
        a = c.isAse,
        n = c.t;

    if (e) {
      var t = a ? "approvals_form_field__ase_comment" : "approvals_form_field__comment",
          l = a ? "approvals_form_order_ase_comments__icon" : "approvals_form_order_comments__icon",
          f = a ? r.default.createElement("label", null, " ", n("orderServiceComment:aseCommentLbl")) : r.default.createElement("label", null, n("orderServiceComment:shopCommentsLbl"));
      return r.default.createElement("div", {
        className: t
      }, r.default.createElement(i.FontAwesomeIcon, {
        className: l,
        icon: o.faComments,
        size: "1x"
      }), r.default.createElement("span", null, f, r.default.createElement("br", null), e));
    }

    return null;
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  },
      t = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      r = a(0),
      i = f(r),
      o = f(a(2)),
      l = a(56);

  a(12);

  function f(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  function s(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var u = function (c) {
    function e() {
      var c, a, n;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) {
        r[i] = arguments[i];
      }

      return a = n = s(this, (c = e.__proto__ || Object.getPrototypeOf(e)).call.apply(c, [this].concat(r))), n.state = {
        formData: {
          vanity_name: (n.props.service || {}).vanity_label || ""
        }
      }, n.handleClick = function (c, e) {
        n.props.onVanitySubmit(c, e);
      }, n.preventNumberInput = function (c) {
        var e = c.keyCode ? c.keyCode : c.which;
        (e > 47 && e < 58 || e > 95 && e < 107) && c.preventDefault();
      }, s(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, r.Component), t(e, [{
      key: "onChange",
      value: function value(c, e) {
        var a = n({}, this.state.formData);
        a[c] = e, this.setState({
          formData: a
        });
      }
    }, {
      key: "render",
      value: function value() {
        var c = this,
            e = this.props,
            a = e.service,
            n = e.t,
            t = e.isSubmitting,
            r = e.canEditVanity,
            o = this.state.formData.vanity_name;
        return i.default.createElement(l.Form, null, i.default.createElement(l.Form.Group, {
          inline: !0
        }, i.default.createElement(l.Form.Field, null, i.default.createElement(l.Form.Input, {
          placeholder: n("approvalsFormVanity:vanityLbl"),
          onChange: function onChange(e) {
            return c.onChange("vanity_name", e.target.value);
          },
          value: o
        })), i.default.createElement(l.Form.Field, null, r ? i.default.createElement(l.Button, {
          size: "mini",
          content: n("approvalsFormVanity:saveText"),
          onClick: function onClick() {
            return c.handleClick(a, o);
          },
          loading: t,
          disabled: t
        }) : i.default.createElement(l.Button, {
          size: "mini",
          content: n("approvalsFormVanity:saveText"),
          loading: t,
          disabled: !r
        }))));
      }
    }]), e;
  }();

  u.propTypes = {
    isSubmitting: o.default.bool.isRequired
  }, e.default = u;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = a(80);
  a(2);
  var t = a(0);

  function r(c) {
    return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (c) {
      return typeof c;
    } : function (c) {
      return c && "function" == typeof Symbol && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
    })(c);
  }

  function i(c, e) {
    if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
  }

  function o(c, e) {
    for (var a = 0; a < e.length; a++) {
      var n = e[a];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
    }
  }

  function l(c, e, a) {
    return e && o(c.prototype, e), a && o(c, a), c;
  }

  function f(c, e, a) {
    return e in c ? Object.defineProperty(c, e, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[e] = a, c;
  }

  function s(c, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    c.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: c,
        writable: !0,
        configurable: !0
      }
    }), e && function (c, e) {
      (Object.setPrototypeOf || function (c, e) {
        return c.__proto__ = e, c;
      })(c, e);
    }(c, e);
  }

  function u(c) {
    return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (c) {
      return c.__proto__ || Object.getPrototypeOf(c);
    })(c);
  }

  function h(c, e) {
    return !e || "object" != typeof e && "function" != typeof e ? function (c) {
      if (void 0 === c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return c;
    }(c) : e;
  }

  var m = function () {
    function c(e) {
      i(this, c), f(this, "handlers", void 0), this.handlers = e.slice(0);
    }

    return l(c, [{
      key: "addHandlers",
      value: function value(e) {
        for (var a = this.handlers.slice(0), n = e.length, t = 0; t < n; t += 1) {
          a.push(e[t]);
        }

        return new c(a);
      }
    }, {
      key: "dispatchEvent",
      value: function value(c, e) {
        var a = this.handlers.length - 1;

        if (e) {
          for (var n = a; n >= 0; n -= 1) {
            this.handlers[n].called || (this.handlers[n].called = !0, this.handlers[n](c));
          }

          for (var t = a; t >= 0; t -= 1) {
            this.handlers[t].called = !1;
          }
        } else (0, this.handlers[a])(c);
      }
    }, {
      key: "hasHandlers",
      value: function value() {
        return this.handlers.length > 0;
      }
    }, {
      key: "removeHandlers",
      value: function value(e) {
        for (var a = [], n = this.handlers.length, t = 0; t < n; t += 1) {
          var r = this.handlers[t];
          -1 === e.indexOf(r) && a.push(r);
        }

        return new c(a);
      }
    }]), c;
  }();

  function v(c) {
    var e = new Map();
    return c.forEach(function (c, a) {
      e.set(a, c);
    }), e;
  }

  function d(c) {
    return Array.isArray(c) ? c : [c];
  }

  var M = function M(c) {
    return null !== c && "object" === r(c) && c.hasOwnProperty("current");
  };

  function p(c) {
    return "document" === c ? document : "window" === c ? window : M(c) ? c.current || document : c || document;
  }

  var z = function () {
    function c(e, a) {
      i(this, c), f(this, "handlerSets", void 0), f(this, "poolName", void 0), this.handlerSets = a, this.poolName = e;
    }

    return l(c, [{
      key: "addHandlers",
      value: function value(e, a) {
        var n = v(this.handlerSets);

        if (n.has(e)) {
          var t = n.get(e);
          n.set(e, t.addHandlers(a));
        } else n.set(e, new m(a));

        return new c(this.poolName, n);
      }
    }, {
      key: "dispatchEvent",
      value: function value(c, e) {
        var a = this.handlerSets.get(c),
            n = "default" === this.poolName;
        a && a.dispatchEvent(e, n);
      }
    }, {
      key: "hasHandlers",
      value: function value(c) {
        if (!c) return this.handlerSets.size > 0;
        var e = this.handlerSets.get(c);
        return !!e && e.hasHandlers();
      }
    }, {
      key: "removeHandlers",
      value: function value(e, a) {
        var n = v(this.handlerSets);
        if (!n.has(e)) return new c(this.poolName, n);
        var t = n.get(e).removeHandlers(a);
        return t.hasHandlers() ? n.set(e, t) : n.delete(e), new c(this.poolName, n);
      }
    }]), c;
  }();

  f(z, "createByType", function (c, e, a) {
    var n = new Map();
    return n.set(e, new m(a)), new z(c, n);
  });

  var C = function () {
    function c(e) {
      var a = this;
      i(this, c), f(this, "handlers", new Map()), f(this, "pools", new Map()), f(this, "target", void 0), f(this, "createEmitter", function (c) {
        return function (e) {
          a.pools.forEach(function (a) {
            a.dispatchEvent(c, e);
          });
        };
      }), this.target = e;
    }

    return l(c, [{
      key: "addHandlers",
      value: function value(c, e, a) {
        if (this.pools.has(c)) {
          var n = this.pools.get(c);
          this.pools.set(c, n.addHandlers(e, a));
        } else this.pools.set(c, z.createByType(c, e, a));

        this.handlers.has(e) || this.addTargetHandler(e);
      }
    }, {
      key: "hasHandlers",
      value: function value() {
        return this.handlers.size > 0;
      }
    }, {
      key: "removeHandlers",
      value: function value(c, e, a) {
        if (this.pools.has(c)) {
          var n = this.pools.get(c).removeHandlers(e, a);
          n.hasHandlers() ? this.pools.set(c, n) : this.pools.delete(c);
          var t = !1;
          this.pools.forEach(function (c) {
            return t = t || c.hasHandlers(e);
          }), t || this.removeTargetHandler(e);
        }
      }
    }, {
      key: "addTargetHandler",
      value: function value(c) {
        var e = this.createEmitter(c);
        this.handlers.set(c, e), this.target.addEventListener(c, e, !0);
      }
    }, {
      key: "removeTargetHandler",
      value: function value(c) {
        this.handlers.has(c) && (this.target.removeEventListener(c, this.handlers.get(c), !0), this.handlers.delete(c));
      }
    }]), c;
  }(),
      L = new (function () {
    function c() {
      var e = this;
      i(this, c), f(this, "targets", new Map()), f(this, "getTarget", function (c) {
        var a = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            n = p(c);
        if (e.targets.has(n)) return e.targets.get(n);
        if (!a) return null;
        var t = new C(n);
        return e.targets.set(n, t), t;
      }), f(this, "removeTarget", function (c) {
        e.targets.delete(p(c));
      });
    }

    return l(c, [{
      key: "sub",
      value: function value(c, e) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

        if (n.canUseDOM) {
          var t = a.target,
              r = void 0 === t ? document : t,
              i = a.pool,
              o = void 0 === i ? "default" : i;
          this.getTarget(r).addHandlers(o, c, d(e));
        }
      }
    }, {
      key: "unsub",
      value: function value(c, e) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

        if (n.canUseDOM) {
          var t = a.target,
              r = void 0 === t ? document : t,
              i = a.pool,
              o = void 0 === i ? "default" : i,
              l = this.getTarget(r, !1);
          l && (l.removeHandlers(o, c, d(e)), l.hasHandlers() || this.removeTarget(r));
        }
      }
    }]), c;
  }())(),
      A = function (c) {
    function e() {
      return i(this, e), h(this, u(e).apply(this, arguments));
    }

    return s(e, t.PureComponent), l(e, [{
      key: "componentDidMount",
      value: function value() {
        this.subscribe(this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function value(c) {
        this.unsubscribe(c), this.subscribe(this.props);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.unsubscribe(this.props);
      }
    }, {
      key: "subscribe",
      value: function value(c) {
        var e = c.name,
            a = c.on,
            n = c.pool,
            t = c.target;
        L.sub(e, a, {
          pool: n,
          target: t
        });
      }
    }, {
      key: "unsubscribe",
      value: function value(c) {
        var e = c.name,
            a = c.on,
            n = c.pool,
            t = c.target;
        L.unsub(e, a, {
          pool: n,
          target: t
        });
      }
    }, {
      key: "render",
      value: function value() {
        return null;
      }
    }]), e;
  }();

  f(A, "defaultProps", {
    pool: "default",
    target: "document"
  }), A.propTypes = {}, e.instance = L, e.default = A;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = o(a(0)),
      t = o(a(2)),
      r = a(14),
      i = a(26);

  function o(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var l = function l(c) {
    var e = c.order;
    return e.shop_comments ? n.default.createElement("div", {
      className: "approvals_form_order_comments"
    }, n.default.createElement(r.FontAwesomeIcon, {
      className: "approvals_form_order_comments__icon",
      icon: i.faComments,
      size: "1x"
    }), n.default.createElement("span", null, e.shop_comments)) : null;
  };

  l.propTypes = {
    order: t.default.object.isRequired
  }, e.default = l;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = i(t);

  i(a(2));

  function i(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var o = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.t,
            a = c.pricingPromiseBannerEl;
        return r.default.createElement("div", {
          className: "approvals_form_header"
        }, r.default.createElement("div", {
          className: "approvals_form_header__heading"
        }, e("approvalsFormHeader:reviewAndApproveServiceHeader")), a, r.default.createElement("div", {
          className: "approvals_form_header__sub_heading"
        }, e("approvalsFormHeader:clickHereForInfoText")));
      }
    }]), e;
  }();

  o.propTypes = {}, e.default = o;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  },
      t = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      r = a(0),
      i = m(r),
      o = m(a(2)),
      l = m(a(16)),
      f = m(a(21)),
      s = a(20),
      u = a(56),
      h = a(38);

  function m(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var v = function (c) {
    function e(c) {
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var a = function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, c));

      return a.allowSubmit = function () {
        var c = a.props,
            e = c.isSubmitting,
            n = c.user,
            t = (0, c.priceTotals)(),
            r = t.shop + t.tax;
        return !e && (!n.pays_through_platform || n.has_cc_info_saved || 0 == r);
      }, a.handleClick = function (c, e) {
        var n = a.props,
            t = n.order,
            r = n.user;
        !t || t.affirm_checkout_token || t.payment_type !== h.AFFIRM || !r || 1 !== r.affiliation.affiliation_type_id && 2 !== r.affiliation.affiliation_type_id ? c.openModal() : e.openModal();
      }, a.hasNewlyApprovedServices = function () {
        return a.props.services.some(function (c) {
          return c.status_new === s.statuses.approved && c.status !== s.statuses.approved;
        });
      }, a.buttonStyle = function () {
        return {
          border: "none",
          display: "inline-block"
        };
      }, a.leftButtonStyle = function () {
        return n({}, a.buttonStyle(), {
          marginRight: "10px",
          height: "auto"
        });
      }, a.textStyle = function () {
        return {
          fontSize: "12px",
          textAlign: "center"
        };
      }, a.renderDialog = function (c, e) {
        var n = a.props.t,
            t = [{
          onClick: function onClick() {
            return c();
          },
          text: n("approvalsFormSubmit:confirmApprovalsText"),
          colorStyle: "orange",
          appendClose: !0,
          style: {
            marginTop: "40px",
            marginBottom: "15px"
          },
          linkTo: "/confirmApproval"
        }, {
          onClick: function onClick() {},
          text: n("approvalsFormSubmit:editApprovalsText"),
          colorStyle: "white",
          appendClose: !0,
          style: {
            marginBottom: "40px"
          },
          linkTo: "/editApproval"
        }],
            r = a.props.services && a.props.services.filter(function (c) {
          return c.status_new === s.statuses.approved && c.status !== s.statuses.approved;
        }),
            o = r && 0 === r.length ? i.default.createElement("span", null, n("approvalsFormSubmit:notApprovingAnyServiceText")) : i.default.createElement("span", null, n("approvalsFormSubmit:aboutToApproveServicesDesc1"), i.default.createElement("span", {
          style: {
            textDecorationLine: "underline"
          }
        }, " " + n("approvalsFormSubmit:aboutToApproveServicesDesc2") + " "), n("approvalsFormSubmit:aboutToApproveServicesDesc3")),
            l = a.props.user;
        return i.default.createElement(f.default, {
          centerButtons: !0,
          ref: e,
          buttons: t
        }, i.default.createElement("div", {
          className: "flex-centered-content"
        }, i.default.createElement("div", {
          className: "modal-title"
        }, n("approvalsFormSubmit:confirmApprovedWorkLbl")), l.pays_through_platform && i.default.createElement("div", {
          className: "all-caps modal-subtitle",
          style: {
            marginTop: "5px",
            marginBottom: "20px"
          }
        }, n("approvalsFormSubmit:chargeCardToBeginWorkLbl")), i.default.createElement("span", {
          style: {
            fontWeight: "bold",
            marginBottom: "10px"
          }
        }, o), i.default.createElement("div", {
          style: {
            marginBottom: "5px"
          }
        }, r && r.map(function (c) {
          return i.default.createElement("div", {
            style: {
              margin: "5px 0"
            }
          }, c.name);
        }))));
      }, a.renderWarningDialog = function (c) {
        a.props.t;
        return i.default.createElement(f.default, {
          ref: c,
          warningClassName: "warning"
        }, i.default.createElement(u.Message, {
          warning: !0
        }, i.default.createElement(u.Message.Header, null, "Alert !!!"), i.default.createElement("span", {
          style: {
            display: "flex",
            textAlign: "justify"
          }
        }, "Please confirm you are approving all necessary services before checking out with affirm, press submit on CarAdvise approvals screen upon successful completion of your Affirm application to complete the approval process.")));
      }, a.submitDialog = i.default.createRef(), a.warningDialog = i.default.createRef(), a;
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, r.Component), t(e, [{
      key: "render",
      value: function value() {
        var c = this,
            e = this.props,
            a = (e.isSubmitting, e.isVisible),
            n = e.onSubmit,
            t = (e.order, e.priceTotals, e.user),
            r = e.t,
            o = e.paymentProviderTypes;
        return a && (!t.pays_through_platform || t.has_cc_info_saved || o && o.length > 0) ? i.default.createElement("div", null, i.default.createElement("div", {
          className: "approvals_form_submit"
        }, this.renderDialog(n, function (e) {
          c.submitDialog = e;
        }), i.default.createElement("div", {
          className: "approvals_form_submit__buttons_container"
        }, i.default.createElement(l.default, {
          colorStyle: "orange",
          disabled: !this.allowSubmit(),
          onClick: function onClick(e) {
            e.preventDefault(), c.handleClick(c.submitDialog, c.warningDialog, n);
          },
          style: this.leftButtonStyle(),
          styleText: this.textStyle(),
          text: r("approvalsFormSubmit:submitText"),
          linkTo: "/submitApproval"
        }))), this.renderWarningDialog(function (e) {
          c.warningDialog = e;
        })) : null;
      }
    }]), e;
  }();

  v.propTypes = {
    isSubmitting: o.default.bool.isRequired,
    onSubmit: o.default.func.isRequired,
    user: o.default.object.isRequired,
    order: o.default.object.isRequired,
    isVisible: o.default.bool,
    priceTotals: o.default.func.isRequired,
    hasNewlyApprovedServices: o.default.bool,
    hideChargeMessage: o.default.bool
  }, v.defaultProps = {
    isVisible: !0
  }, e.default = v;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = l(t),
      i = l(a(2)),
      o = l(a(16));

  l(a(21)), a(20);

  function l(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  function f(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var s = function (c) {
    function e() {
      var c, a, n;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) {
        r[i] = arguments[i];
      }

      return a = n = f(this, (c = e.__proto__ || Object.getPrototypeOf(e)).call.apply(c, [this].concat(r))), n.onCancel = function (c) {
        c.preventDefault(), n.permitCancelation() && n.confirmCancelation() && n.props.onCancel();
      }, n.buttonStyle = function () {
        return {
          border: "none",
          display: "inline-block",
          marginRight: "10px"
        };
      }, n.textStyle = function () {
        return {
          fontSize: "12px",
          textAlign: "center"
        };
      }, f(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "permitCancelation",
      value: function value() {
        var c = this.props,
            e = c.currentUserCanCancel,
            a = c.formattedCancelationContacts,
            n = c.t;
        return !!e || (null != a && alert(n("approvalsFormCancel:contactForCancellationText") + "\n\n" + a), !1);
      }
    }, {
      key: "confirmCancelation",
      value: function value() {
        return window.confirm(this.props.t("approvalsFormCancel:cancellationConfirmationMessage"));
      }
    }, {
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.isSubmitting,
            a = (c.onCancel, c.eligibleForCancelation),
            n = (c.currentUserCanCancel, c.formattedCancelationContacts, c.t);
        return a ? r.default.createElement("div", {
          className: "approvals_form_cancel"
        }, r.default.createElement("div", {
          className: "approvals_form_cancel__button_container"
        }, r.default.createElement(o.default, {
          disabled: e,
          style: this.buttonStyle(),
          styleText: this.textStyle(),
          text: n("approvalsFormCancel:cancelText"),
          onClick: this.onCancel
        }))) : null;
      }
    }]), e;
  }();

  s.propTypes = {
    isSubmitting: i.default.bool.isRequired,
    onCancel: i.default.func.isRequired,
    eligibleForCancelation: i.default.bool.isRequired,
    currentUserCanCancel: i.default.bool.isRequired,
    formattedCancelationContacts: i.default.string.isRequired
  }, s.defaultProps = {
    eligibleForCancelation: !1
  }, e.default = s;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = s(t),
      i = s(a(2)),
      o = s(a(230)),
      l = s(a(233)),
      f = a(12);

  function s(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var u = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.user,
            a = c.order,
            n = c.paymentMethods,
            t = c.services,
            i = c.priceTotals,
            s = c.paymentListEl,
            u = c.hideSavings,
            h = c.differentPaymentEl,
            m = c.loadingSums,
            v = c.paymentProviderTypes,
            d = c.hasPaymentMethod,
            M = c.t,
            p = c.i18n,
            z = c.savingsRibbonEl,
            C = c.allCreditCardsInfo,
            L = c.selectedCreditCardId,
            A = c.promotionalCodeLink,
            N = c.pays_through_platform,
            g = c.creditCardOptions,
            H = c.CreditCardDropdown,
            V = c.handleChange,
            x = c.SelectPaymentProvidersView,
            w = c.selectedPaymentProvider,
            y = c.canApprove,
            b = c.wex_account_number;
        return r.default.createElement("div", {
          className: "approvals_form_summary"
        }, r.default.createElement("div", {
          className: "row approvals_form_summary__row"
        }, r.default.createElement("div", {
          className: "approvals_form_summary__column--left"
        }, r.default.createElement(l.default, {
          user: e,
          order: a,
          services: t,
          priceTotals: i,
          hideSavings: u,
          loadingSums: m,
          savingsRibbonEl: z,
          t: M,
          i18n: p,
          promotionalCodeLink: A
        })), (a.state === f.AWAITING_APPROVAL && y || a.state != f.AWAITING_APPROVAL) && s && r.default.createElement("div", {
          className: "approvals_form_summary__column--right"
        }, r.default.createElement(o.default, {
          paymentMethods: n,
          paymentProviderTypes: v,
          hasPaymentMethod: d,
          paymentListEl: s,
          differentPaymentEl: h,
          t: M,
          allCreditCardsInfo: C,
          order: a,
          creditCardOptions: g,
          CreditCardDropdown: H,
          handleChange: V,
          selectedCreditCardId: L,
          pays_through_platform: N,
          SelectPaymentProvidersView: x,
          selectedPaymentProvider: w,
          wex_account_number: b
        }))));
      }
    }]), e;
  }();

  u.propTypes = {
    order: i.default.object.isRequired,
    paymentMethods: i.default.array.isRequired,
    services: i.default.array.isRequired,
    priceTotals: i.default.func.isRequired,
    paymentListEl: i.default.element.isRequired,
    savingsRibbonEl: i.default.element.isRequired,
    hideSavings: i.default.bool,
    loadingSums: i.default.bool,
    hasPaymentMethod: i.default.bool,
    paymentProviderTypes: i.default.array
  }, e.default = u;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = u(t),
      i = u(a(2)),
      o = function (c) {
    if (c && c.__esModule) return c;
    var e = {};
    if (null != c) for (var a in c) {
      Object.prototype.hasOwnProperty.call(c, a) && (e[a] = c[a]);
    }
    return e.default = c, e;
  }(a(87)),
      l = u(a(231)),
      f = a(38),
      s = a(12);

  function u(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var h = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "renderContent",
      value: function value() {
        var c = this,
            e = this.props,
            a = e.paymentMethods,
            n = e.paymentListEl,
            t = e.differentPaymentEl,
            i = e.paymentProviderTypes,
            u = (e.hasPaymentMethod, e.t),
            h = e.allCreditCardsInfo,
            m = (e.onCreditCardChange, e.order),
            v = e.selectedCreditCardId,
            d = e.pays_through_platform,
            M = e.SelectPaymentProvidersView,
            p = e.selectedPaymentProvider,
            z = e.wex_account_number,
            C = void 0;
        return a && (C = o.findDefault(a)), m && i && d && i.length > 0 && !i.includes(f.FLEETCOR) && [s.PAID, s.APPROVAL, s.COMPLETED, s.PAID_AT_SHOP, s.IN_MANUAL_REVIEW].includes(m.state) && 0 == h.length && null == z ? r.default.createElement("div", null, " ", u("approvalsFormPaymentMethod:NoPaymentMethodUsedLbl"), " ") : d && i.length > 0 ? r.default.createElement(l.default, {
          paymentMethod: C,
          paymentProviderTypes: i,
          differentPaymentEl: t,
          t: u,
          allCreditCardsInfo: h,
          SelectPaymentProvidersView: M,
          selectedPaymentProvider: p,
          order: m,
          paymentListEl: n,
          wex_account_number: z,
          CreditCardDropdown: this.props.allCreditCardsInfo && this.props.creditCardOptions && m && r.default.cloneElement(this.props.CreditCardDropdown, {
            options: this.props.creditCardOptions(),
            onChange: function onChange(e, a) {
              return c.props.handleChange(e, a);
            },
            value: v,
            placeholder: u("approvalsFormPaymentMethod:chooseOptionLbl")
          })
        }) : n;
      }
    }, {
      key: "render",
      value: function value() {
        return r.default.createElement("div", {
          className: "approvals_form_payments"
        }, this.renderContent());
      }
    }]), e;
  }();

  h.propTypes = {
    paymentMethods: i.default.array.isRequired,
    paymentListEl: i.default.element.isRequired,
    paymentProviderType: i.default.string
  }, e.default = h;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    return function (c, e) {
      if (Array.isArray(c)) return c;
      if (Symbol.iterator in Object(c)) return function (c, e) {
        var a = [],
            n = !0,
            t = !1,
            r = void 0;

        try {
          for (var i, o = c[Symbol.iterator](); !(n = (i = o.next()).done) && (a.push(i.value), !e || a.length !== e); n = !0) {
            ;
          }
        } catch (c) {
          t = !0, r = c;
        } finally {
          try {
            !n && o.return && o.return();
          } finally {
            if (t) throw r;
          }
        }

        return a;
      }(c, e);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }(),
      t = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      r = a(0),
      i = h(r),
      o = h(a(2)),
      l = h(a(35)),
      f = h(a(232)),
      s = a(38),
      u = a(12);

  function h(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var m = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, r.Component), t(e, [{
      key: "renderPaymentMethodDetails",
      value: function value() {
        var c = this.props,
            e = (c.paymentMethod, c.t),
            a = c.allCreditCardsInfo,
            n = c.CreditCardDropdown,
            t = c.paymentProviderTypes,
            r = c.SelectPaymentProvidersView,
            o = c.selectedPaymentProvider,
            l = c.order,
            f = c.paymentListEl,
            h = c.wex_account_number;
        return l && ![u.PAID, u.APPROVAL, u.COMPLETED, u.PAID_AT_SHOP, u.IN_MANUAL_REVIEW].includes(l.state) && t.length > 1 ? i.default.createElement("div", null, r, o.length > 0 && o === s.BRAINTREE && (a && a.length > 1 ? i.default.createElement("div", {
          className: "dropdown-and-label-component"
        }, i.default.createElement("label", {
          for: "credit-card-dropdown",
          className: "label-of-dropdown"
        }, "" + e("approvalsFormPaymentMethod:creditCardEndingLbl")), n) : a && 1 === a.length ? "pay_pal_account" == a[0].type ? i.default.createElement("div", null, " ", e("approvalsFormPaymentMethod:paypalAccountLbl") + " " + this.convertEmail(a[0].email) + " ", " ") : i.default.createElement("div", null, e("approvalsFormPaymentMethod:creditCardEndingLbl") + " " + a[0].last_4) : i.default.createElement("div", null, f)), o.length > 0 && o === s.WEX && (h ? i.default.createElement("div", null, e("approvalsFormPaymentMethod:storedWexCardLbl") + " " + h.substr(-4)) : i.default.createElement("div", null, f)), o === s.FLEETCOR && i.default.createElement("div", null, e("approvalsFormPaymentMethod:fleetcorMethodLbl"))) : t.includes(s.BRAINTREE) ? a ? a.length > 1 ? i.default.createElement("div", {
          className: "dropdown-and-label-component"
        }, i.default.createElement("label", {
          for: "credit-card-dropdown",
          className: "label-of-dropdown"
        }, "" + e("approvalsFormPaymentMethod:creditCardEndingLbl")), n) : 1 === a.length ? l && [u.PAID, u.APPROVAL, u.COMPLETED, u.PAID_AT_SHOP, u.IN_MANUAL_REVIEW].includes(l.state) && null == a[0].last_4 ? i.default.createElement("div", null, " ", e("approvalsFormPaymentMethod:paypalAccountChangedLbl"), " ") : "pay_pal_account" == a[0].type ? i.default.createElement("div", null, " ", e("approvalsFormPaymentMethod:paypalAccountLbl") + " " + this.convertEmail(a[0].email), " ") : i.default.createElement("div", null, e("approvalsFormPaymentMethod:creditCardEndingLbl") + " " + a[0].last_4) : f : f : t.includes(s.WEX) ? h ? i.default.createElement("div", null, " ", e("approvalsFormPaymentMethod:storedWexCardLbl") + " " + h.substr(-4)) : f : t.includes(s.FLEETCOR) ? l && [u.PAID, u.APPROVAL, u.COMPLETED, u.PAID_AT_SHOP, u.IN_MANUAL_REVIEW].includes(l.state) ? i.default.createElement("div", null, " ", e("approvalsFormPaymentMethod:fleetcorMethodChargedLbl"), " ") : i.default.createElement("div", null, " ", e("approvalsFormPaymentMethod:fleetcorMethodLbl"), " ") : void 0;
      }
    }, {
      key: "convertEmail",
      value: function value(c) {
        var e = c.split("@"),
            a = n(e, 2),
            t = a[0],
            r = a[1];
        return t.substring(0, 2) + "******" + t.substring(t.length - 2) + "@" + r;
      }
    }, {
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.t,
            a = c.paymentProviderTypes;
        return i.default.createElement("div", {
          className: "approvals_form_payment_method"
        }, i.default.createElement("div", {
          className: "row"
        }, i.default.createElement("div", {
          className: "column--10"
        }, 1 == a.length && i.default.createElement("div", {
          className: "approvals_form_payment_method__label"
        }, e("approvalsFormPaymentMethod:paymentMethodLbl")), i.default.createElement("div", {
          className: "approvals_form_payment_method__details"
        }, this.renderPaymentMethodDetails()), i.default.createElement("div", {
          className: "approvals_form_payment_method__link"
        }, this.props.differentPaymentEl)), i.default.createElement("div", {
          className: "column--2 img-parent-class"
        }, i.default.createElement(l.default, {
          className: "approvals_form_payment_method__icon",
          src: f.default
        }))));
      }
    }]), e;
  }();

  m.propTypes = {
    paymentMethod: o.default.object.isRequired
  }, e.default = m;
}, function (c, e) {
  c.exports = "data:image/png;base64,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";
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = h(t),
      i = h(a(2)),
      o = a(36),
      l = (a(88), a(14)),
      f = a(26),
      s = h(a(234)),
      u = a(12);

  a(37);

  function h(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  function m(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var v = function (c) {
    function e() {
      var c, a, n;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var t = arguments.length, i = Array(t), u = 0; u < t; u++) {
        i[u] = arguments[u];
      }

      return a = n = m(this, (c = e.__proto__ || Object.getPrototypeOf(e)).call.apply(c, [this].concat(i))), n.formattedMemberSavings = function (c) {
        return "(" + (0, o.numberFormatToCurrency)((c.retail - c.shop).toFixed(2), n.props.i18n) + ")";
      }, n.formattedSubtotal = function (c) {
        var e = c.shop - c.transactionFee;
        return "" + (0, o.numberFormatToCurrency)(n.bottomOutAtZero(e).toFixed(2), n.props.i18n);
      }, n.formattedTax = function (c) {
        var e = c.tax;
        return "" + (0, o.numberFormatToCurrency)(n.bottomOutAtZero(e).toFixed(2), n.props.i18n);
      }, n.formattedTransactionFees = function (c) {
        var e = c.transactionFee;
        return "" + (0, o.numberFormatToCurrency)(n.bottomOutAtZero(e).toFixed(2), n.props.i18n);
      }, n.formattedTotal = function (c) {
        var e = c.shop + c.tax;
        return "" + (0, o.numberFormatToCurrency)(n.bottomOutAtZero(e).toFixed(2), n.props.i18n);
      }, n.formattedTotalSavings = function (c) {
        var e = c.totalSavings;
        return "" + (0, o.numberFormatToCurrency)(n.bottomOutAtZero(e).toFixed(2), n.props.i18n);
      }, n.formattedAlreadyPaid = function (c) {
        return "" + (0, o.numberFormatToCurrency)(n.bottomOutAtZero(c.previousPayments).toFixed(2), n.props.i18n);
      }, n.formattedDue = function (c) {
        var e = n.due(c);
        return "" + (0, o.numberFormatToCurrency)(Math.abs(e).toFixed(2), n.props.i18n);
      }, n.formattedOrderLevelPrepayDiscount = function (c) {
        return "" + (0, o.numberFormatToCurrency)(c.prepayDiscount.toFixed(2), n.props.i18n);
      }, n.formattedOrderLevelPromotionalDiscount = function (c) {
        return "" + (0, o.numberFormatToCurrency)(c.promotionalDiscount.toFixed(2), n.props.i18n);
      }, n.formattedCaradviseCash = function (c) {
        return "" + (0, o.numberFormatToCurrency)(c.totalRewardsCredit.toFixed(2), n.props.i18n);
      }, n.bottomOutAtZero = function (c) {
        return c < 0 ? 0 : c;
      }, n.due = function (c) {
        return c.shop + c.tax - c.previousPayments;
      }, n.renderSavingsRow = function (c) {
        var e = c.retail - c.shop,
            a = n.props.t;
        return e > 0 ? r.default.createElement("div", {
          className: "row approvals_form_totals__row"
        }, r.default.createElement("div", {
          className: "column--8"
        }, a("approvalsFormTotals:memberSavingsLbl")), r.default.createElement("div", {
          className: "column--4 approvals_form_totals__price_column"
        }, r.default.createElement("div", null, n.formattedMemberSavings(c)))) : null;
      }, n.renderSubtotalRow = function (c) {
        var e = n.props.t;
        return r.default.createElement("div", {
          className: "row approvals_form_totals__row"
        }, r.default.createElement("div", {
          className: "column--8"
        }, e("approvalsFormTotals:subtotalLbl")), r.default.createElement("div", {
          className: "column--4 approvals_form_totals__price_column"
        }, r.default.createElement("div", null, n.formattedSubtotal(c))));
      }, n.renderCaradviseCashRow = function (c) {
        if (c.totalRewardsCredit <= 0) return null;
        var e = n.props.t;
        return r.default.createElement("div", {
          className: "row approvals_form_totals__row"
        }, r.default.createElement("div", {
          className: "column--8"
        }, e("approvalsFormTotals:carAdviseCashLbl")), r.default.createElement("div", {
          className: "column--4 approvals_form_totals__price_column"
        }, "-", n.formattedCaradviseCash(c)));
      }, n.renderTopLevelPromotionalDiscountRow = function (c) {
        if (n.props.order.promotional_discount > 0) {
          var e = n.props.t;
          return r.default.createElement("div", {
            className: "row approvals_form_totals__row"
          }, r.default.createElement("div", {
            className: "column--8"
          }, e("approvalsFormTotals:promotionalDiscountLbl")), r.default.createElement("div", {
            className: "column--4 approvals_form_totals__price_column"
          }, r.default.createElement("div", null, "-", n.formattedOrderLevelPromotionalDiscount(c))));
        }

        return null;
      }, n.renderTopLevelPrepayDiscountRow = function (c) {
        if (c.prepayDiscount > 0) {
          n.props.t;
          return r.default.createElement("div", {
            className: "row approvals_form_totals__row"
          }, r.default.createElement("div", {
            className: "column--8"
          }, "5% Pay Ahead Discount"), r.default.createElement("div", {
            className: "column--4 approvals_form_totals__price_column"
          }, r.default.createElement("div", null, "-", n.formattedOrderLevelPrepayDiscount(c))));
        }

        return null;
      }, n.renderTaxRow = function (c) {
        var e = n.props.t;
        return r.default.createElement("div", {
          className: "row approvals_form_totals__row"
        }, r.default.createElement("div", {
          className: "column--8"
        }, r.default.createElement("div", null, c.transactionFee > 0 ? r.default.createElement("span", null, e("approvalsFormTotals:TaxLbl"), " ", r.default.createElement(l.FontAwesomeIcon, {
          "data-tip": e("approvalsFormTotals:taxTooltip"),
          "data-event": "click focus",
          style: {
            cursor: "pointer"
          },
          icon: f.faQuestionCircle
        })) : r.default.createElement("span", null, e("approvalsFormTotals:estimatedTaxLbl"), " ", r.default.createElement(l.FontAwesomeIcon, {
          "data-tip": e("approvalsFormTotals:taxTooltip"),
          "data-event": "click focus",
          style: {
            cursor: "pointer"
          },
          icon: f.faQuestionCircle
        })), r.default.createElement(s.default, {
          place: "top",
          type: "light",
          effect: "float",
          border: !0,
          borderColor: "black",
          globalEventOff: "click",
          className: "tooltip"
        }))), r.default.createElement("div", {
          className: "column--4 approvals_form_totals__price_column"
        }, r.default.createElement("div", null, n.formattedTax(c))));
      }, n.renderFeesRow = function (c) {
        var e = n.props.t;
        return r.default.createElement("div", {
          className: "row approvals_form_totals__row"
        }, r.default.createElement("div", {
          className: "column--8"
        }, r.default.createElement("div", null, r.default.createElement("span", null, e("approvalsFormTotals:taxAndFeeLbl"), " ", r.default.createElement(l.FontAwesomeIcon, {
          "data-tip": e("approvalsFormTotals:transactionFeeTooltip"),
          "data-event": "click focus",
          style: {
            cursor: "pointer"
          },
          icon: f.faQuestionCircle
        })), r.default.createElement(s.default, {
          place: "top",
          type: "light",
          effect: "float",
          border: !0,
          borderColor: "black",
          globalEventOff: "click",
          className: "tooltip"
        }))), r.default.createElement("div", {
          className: "column--4 approvals_form_totals__price_column"
        }, r.default.createElement("div", null, n.formattedTransactionFees(c))));
      }, n.renderTotalRow = function (c) {
        var e = n.props.t;
        return r.default.createElement("div", {
          className: "row approvals_form_totals__row" + (c.previousPayments > 0 ? "" : "--total")
        }, r.default.createElement("div", {
          className: "column--8"
        }, e("approvalsFormTotals:totalPriceLbl")), r.default.createElement("div", {
          className: "column--4 approvals_form_totals__price_column"
        }, r.default.createElement("div", null, n.formattedTotal(c))));
      }, n.renderTotalSavingsRow = function (c) {
        var e = n.props,
            a = (e.order, e.user),
            t = e.t,
            i = c.shop + c.tax;
        return a && a.pays_through_platform && c.totalSavings && c.totalSavings > 0 && i > 0 ? r.default.createElement("div", {
          style: {
            color: "#faa41d"
          },
          className: "row approvals_form_totals__row--total"
        }, r.default.createElement("div", null, t("approvalsFormTotals:totalSavingsLbl")), r.default.createElement("div", {
          className: "column--4 approvals_form_totals__price_column"
        }, r.default.createElement("div", null, n.formattedTotalSavings(c)))) : null;
      }, n.renderAlreadyPaidRow = function (c) {
        var e = n.props.t;
        return c.previousPayments <= 0 || 0 == n.due(c) ? null : r.default.createElement("div", {
          className: "row approvals_form_totals__row"
        }, r.default.createElement("div", {
          className: "column--8"
        }, e("approvalsFormTotals:alreadyPaidLbl")), r.default.createElement("div", {
          className: "column--4 approvals_form_totals__price_column"
        }, r.default.createElement("div", null, "(", n.formattedAlreadyPaid(c), ")")));
      }, n.renderDueRow = function (c) {
        var e = n.props.t;
        if (c.previousPayments <= 0) return null;
        var a = n.formattedDue(c),
            t = n.due(c) < 0 ? e("approvalsFormTotals:totalRefundLbl") : e("approvalsFormTotals:totalDueLbl");
        return r.default.createElement("div", {
          className: "row approvals_form_totals__row--total"
        }, r.default.createElement("div", {
          className: "column--8"
        }, t), r.default.createElement("div", {
          className: "column--4 approvals_form_totals__price_column"
        }, r.default.createElement("div", null, a)));
      }, n.renderPromotionalCodeLink = function (c) {
        return r.default.createElement("div", {
          className: "row approvals_form_totals__row--total"
        }, r.default.createElement("div", {
          className: "column--4"
        }), r.default.createElement("div", {
          className: "column--8 approvals_form_totals__price_column"
        }, r.default.createElement("div", null, c)));
      }, n.renderRefundWarningMessage = function (c) {
        var e = n.props.t;
        return n.due(c) >= 0 ? null : r.default.createElement("div", {
          style: {
            color: "red"
          }
        }, e("approvalsFormTotals:refundWarningMessage"));
      }, m(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "renderCaradviseDiscount",
      value: function value() {
        var c = this.props,
            e = c.user,
            a = c.order,
            n = c.t,
            t = c.i18n;
        return e && e.pays_through_platform && a.caradvise_discount && a.caradvise_discount > 0 ? r.default.createElement("div", {
          className: "row approvals_form_totals__row"
        }, r.default.createElement("div", {
          className: "column--8"
        }, n("approvalsFormTotals:carAdviseDiscountLbl")), r.default.createElement("div", {
          className: "column--4 approvals_form_totals__price_column"
        }, "-", (0, o.numberFormatToCurrency)(a.caradvise_discount, t))) : null;
      }
    }, {
      key: "renderMembershipDiscount",
      value: function value() {
        var c = this.props,
            e = c.order,
            a = c.t,
            n = c.i18n;
        return e.membership_discount && parseFloat(e.membership_discount) > 0 ? r.default.createElement("div", {
          className: "row approvals_form_totals__row"
        }, r.default.createElement("div", {
          className: "column--8"
        }, a("approvalsFormTotals:membershipDiscountLbl")), r.default.createElement("div", {
          className: "column--4 approvals_form_totals__price_column"
        }, "-", (0, o.numberFormatToCurrency)(e.membership_discount, n))) : null;
      }
    }, {
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.priceTotals,
            a = c.loadingSums,
            n = c.hideSavings,
            t = c.savingsRibbonEl,
            i = c.promotionalCodeLink,
            o = c.order,
            s = e();
        return a ? r.default.createElement("div", {
          className: "approvals_form_totals"
        }, r.default.createElement("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100px"
          }
        }, r.default.createElement(l.FontAwesomeIcon, {
          icon: f.faSpinner,
          spin: !0
        }))) : r.default.createElement("div", {
          className: "approvals_form_totals"
        }, !n && this.renderSavingsRow(s), this.renderCaradviseCashRow(s), s.prepayDiscount > 0 && this.renderTopLevelPrepayDiscountRow(s), this.renderTopLevelPromotionalDiscountRow(s), this.renderCaradviseDiscount(), this.renderMembershipDiscount(), this.renderSubtotalRow(s), this.renderTaxRow(s), this.renderFeesRow(s), this.renderTotalRow(s), this.renderTotalSavingsRow(s), this.renderAlreadyPaidRow(s), this.renderDueRow(s), t, o.status == u.AWAITING_APPROVAL ? this.renderPromotionalCodeLink(i) : "", this.renderRefundWarningMessage(s));
      }
    }]), e;
  }();

  v.propTypes = {
    order: i.default.object.isRequired,
    services: i.default.array.isRequired,
    priceTotals: i.default.func.isRequired,
    savingsRibbonEl: i.default.element,
    hideSavings: i.default.bool,
    loadingSums: i.default.bool
  }, e.default = v;
}, function (c, e, a) {
  "use strict";

  a.r(e), function (c) {
    a.d(e, "default", function () {
      return Wr;
    });
    var n = a(0),
        t = a.n(n),
        r = a(2),
        i = a.n(r),
        o = a(304);

    function l(c, e) {
      var a = Object.keys(c);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(c);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(c, e).enumerable;
        })), a.push.apply(a, n);
      }

      return a;
    }

    function f(c) {
      for (var e = 1; e < arguments.length; e++) {
        var a = null != arguments[e] ? arguments[e] : {};
        e % 2 ? l(Object(a), !0).forEach(function (e) {
          u(c, e, a[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(a)) : l(Object(a)).forEach(function (e) {
          Object.defineProperty(c, e, Object.getOwnPropertyDescriptor(a, e));
        });
      }

      return c;
    }

    function s(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    function u(c, e, a) {
      return e in c ? Object.defineProperty(c, e, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : c[e] = a, c;
    }

    function h() {
      return (h = Object.assign ? Object.assign.bind() : function (c) {
        for (var e = 1; e < arguments.length; e++) {
          var a = arguments[e];

          for (var n in a) {
            Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
          }
        }

        return c;
      }).apply(this, arguments);
    }

    function m(c) {
      return (m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (c) {
        return c.__proto__ || Object.getPrototypeOf(c);
      })(c);
    }

    function v(c, e) {
      return (v = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (c, e) {
        return c.__proto__ = e, c;
      })(c, e);
    }

    function d(c, e) {
      if (e && ("object" == typeof e || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return function (c) {
        if (void 0 === c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return c;
      }(c);
    }

    function M(c) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (c) {
          return !1;
        }
      }();

      return function () {
        var a,
            n = m(c);

        if (e) {
          var t = m(this).constructor;
          a = Reflect.construct(n, arguments, t);
        } else a = n.apply(this, arguments);

        return d(this, a);
      };
    }

    function p(c, e) {
      (null == e || e > c.length) && (e = c.length);

      for (var a = 0, n = new Array(e); a < e; a++) {
        n[a] = c[a];
      }

      return n;
    }

    function z(c, e) {
      var a = "undefined" != typeof Symbol && c[Symbol.iterator] || c["@@iterator"];

      if (!a) {
        if (Array.isArray(c) || (a = function (c, e) {
          if (c) {
            if ("string" == typeof c) return p(c, e);
            var a = Object.prototype.toString.call(c).slice(8, -1);
            return "Object" === a && c.constructor && (a = c.constructor.name), "Map" === a || "Set" === a ? Array.from(c) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? p(c, e) : void 0;
          }
        }(c)) || e && c && "number" == typeof c.length) {
          a && (c = a);

          var _n3 = 0,
              t = function t() {};

          return {
            s: t,
            n: function n() {
              return _n3 >= c.length ? {
                done: !0
              } : {
                done: !1,
                value: c[_n3++]
              };
            },
            e: function e(c) {
              throw c;
            },
            f: t
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var r,
          i = !0,
          o = !1;
      return {
        s: function s() {
          a = a.call(c);
        },
        n: function n() {
          var c = a.next();
          return i = c.done, c;
        },
        e: function e(c) {
          o = !0, r = c;
        },
        f: function f() {
          try {
            i || null == a.return || a.return();
          } finally {
            if (o) throw r;
          }
        }
      };
    }

    var C = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== c ? c : "undefined" != typeof self ? self : {},
        L = function L(c) {
      return c && c.Math == Math && c;
    },
        A = L("object" == typeof globalThis && globalThis) || L("object" == typeof window && window) || L("object" == typeof self && self) || L("object" == typeof C && C) || function () {
      return this;
    }() || Function("return this")(),
        N = {},
        g = function g(c) {
      try {
        return !!c();
      } catch (c) {
        return !0;
      }
    },
        H = !g(function () {
      return 7 != Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1];
    }),
        V = !g(function () {
      var c = function () {}.bind();

      return "function" != typeof c || c.hasOwnProperty("prototype");
    }),
        x = V,
        w = Function.prototype.call,
        y = x ? w.bind(w) : function () {
      return w.apply(w, arguments);
    },
        b = {},
        S = {}.propertyIsEnumerable,
        T = Object.getOwnPropertyDescriptor,
        D = T && !S.call({
      1: 2
    }, 1);

    b.f = D ? function (c) {
      var e = T(this, c);
      return !!e && e.enumerable;
    } : S;

    var j,
        E,
        k = function k(c, e) {
      return {
        enumerable: !(1 & c),
        configurable: !(2 & c),
        writable: !(4 & c),
        value: e
      };
    },
        I = V,
        O = Function.prototype,
        Q = O.call,
        Z = I && O.bind.bind(Q, Q),
        U = function U(c) {
      return I ? Z(c) : function () {
        return Q.apply(c, arguments);
      };
    },
        B = U,
        R = B({}.toString),
        Y = B("".slice),
        P = function P(c) {
      return Y(R(c), 8, -1);
    },
        F = P,
        W = U,
        G = function G(c) {
      if ("Function" === F(c)) return W(c);
    },
        q = g,
        J = P,
        K = Object,
        X = G("".split),
        _ = q(function () {
      return !K("z").propertyIsEnumerable(0);
    }) ? function (c) {
      return "String" == J(c) ? X(c, "") : K(c);
    } : K,
        $ = function $(c) {
      return null == c;
    },
        cc = $,
        ec = TypeError,
        ac = function ac(c) {
      if (cc(c)) throw ec("Can't call method on " + c);
      return c;
    },
        nc = _,
        tc = ac,
        rc = function rc(c) {
      return nc(tc(c));
    },
        ic = "object" == typeof document && document.all,
        oc = {
      all: ic,
      IS_HTMLDDA: void 0 === ic && void 0 !== ic
    },
        lc = oc.all,
        fc = oc.IS_HTMLDDA ? function (c) {
      return "function" == typeof c || c === lc;
    } : function (c) {
      return "function" == typeof c;
    },
        sc = fc,
        uc = oc.all,
        hc = oc.IS_HTMLDDA ? function (c) {
      return "object" == typeof c ? null !== c : sc(c) || c === uc;
    } : function (c) {
      return "object" == typeof c ? null !== c : sc(c);
    },
        mc = A,
        vc = fc,
        dc = function dc(c, e) {
      return arguments.length < 2 ? (a = mc[c], vc(a) ? a : void 0) : mc[c] && mc[c][e];
      var a;
    },
        Mc = G({}.isPrototypeOf),
        pc = A,
        zc = dc("navigator", "userAgent") || "",
        Cc = pc.process,
        Lc = pc.Deno,
        Ac = Cc && Cc.versions || Lc && Lc.version,
        Nc = Ac && Ac.v8;

    Nc && (E = (j = Nc.split("."))[0] > 0 && j[0] < 4 ? 1 : +(j[0] + j[1])), !E && zc && (!(j = zc.match(/Edge\/(\d+)/)) || j[1] >= 74) && (j = zc.match(/Chrome\/(\d+)/)) && (E = +j[1]);

    var gc = E,
        Hc = g,
        Vc = !!Object.getOwnPropertySymbols && !Hc(function () {
      var c = Symbol();
      return !String(c) || !(Object(c) instanceof Symbol) || !Symbol.sham && gc && gc < 41;
    }),
        xc = Vc && !Symbol.sham && "symbol" == typeof Symbol.iterator,
        wc = dc,
        yc = fc,
        bc = Mc,
        Sc = Object,
        Tc = xc ? function (c) {
      return "symbol" == typeof c;
    } : function (c) {
      var e = wc("Symbol");
      return yc(e) && bc(e.prototype, Sc(c));
    },
        Dc = String,
        jc = fc,
        Ec = function Ec(c) {
      try {
        return Dc(c);
      } catch (c) {
        return "Object";
      }
    },
        kc = TypeError,
        Ic = function Ic(c) {
      if (jc(c)) return c;
      throw kc(Ec(c) + " is not a function");
    },
        Oc = Ic,
        Qc = $,
        Zc = y,
        Uc = fc,
        Bc = hc,
        Rc = TypeError,
        Yc = {
      exports: {}
    },
        Pc = A,
        Fc = Object.defineProperty,
        Wc = function Wc(c, e) {
      try {
        Fc(Pc, c, {
          value: e,
          configurable: !0,
          writable: !0
        });
      } catch (a) {
        Pc[c] = e;
      }

      return e;
    },
        Gc = Wc,
        qc = A["__core-js_shared__"] || Gc("__core-js_shared__", {}),
        Jc = qc;

    (Yc.exports = function (c, e) {
      return Jc[c] || (Jc[c] = void 0 !== e ? e : {});
    })("versions", []).push({
      version: "3.25.5",
      mode: "global",
      copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
      license: "https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE",
      source: "https://github.com/zloirock/core-js"
    });

    var Kc = ac,
        Xc = Object,
        _c = function _c(c) {
      return Xc(Kc(c));
    },
        $c = _c,
        ce = G({}.hasOwnProperty),
        ee = Object.hasOwn || function (c, e) {
      return ce($c(c), e);
    },
        ae = G,
        ne = 0,
        te = Math.random(),
        re = ae(1..toString),
        ie = function ie(c) {
      return "Symbol(" + (void 0 === c ? "" : c) + ")_" + re(++ne + te, 36);
    },
        oe = A,
        le = Yc.exports,
        fe = ee,
        se = ie,
        ue = Vc,
        he = xc,
        me = le("wks"),
        ve = oe.Symbol,
        de = ve && ve.for,
        Me = he ? ve : ve && ve.withoutSetter || se,
        pe = function pe(c) {
      if (!fe(me, c) || !ue && "string" != typeof me[c]) {
        var e = "Symbol." + c;
        ue && fe(ve, c) ? me[c] = ve[c] : me[c] = he && de ? de(e) : Me(e);
      }

      return me[c];
    },
        ze = y,
        Ce = hc,
        Le = Tc,
        Ae = function Ae(c, e) {
      var a = c[e];
      return Qc(a) ? void 0 : Oc(a);
    },
        Ne = function Ne(c, e) {
      var a, n;
      if ("string" === e && Uc(a = c.toString) && !Bc(n = Zc(a, c))) return n;
      if (Uc(a = c.valueOf) && !Bc(n = Zc(a, c))) return n;
      if ("string" !== e && Uc(a = c.toString) && !Bc(n = Zc(a, c))) return n;
      throw Rc("Can't convert object to primitive value");
    },
        ge = TypeError,
        He = pe("toPrimitive"),
        Ve = function Ve(c, e) {
      if (!Ce(c) || Le(c)) return c;
      var a,
          n = Ae(c, He);

      if (n) {
        if (void 0 === e && (e = "default"), a = ze(n, c, e), !Ce(a) || Le(a)) return a;
        throw ge("Can't convert object to primitive value");
      }

      return void 0 === e && (e = "number"), Ne(c, e);
    },
        xe = Tc,
        we = function we(c) {
      var e = Ve(c, "string");
      return xe(e) ? e : e + "";
    },
        ye = hc,
        be = A.document,
        Se = ye(be) && ye(be.createElement),
        Te = function Te(c) {
      return Se ? be.createElement(c) : {};
    },
        De = Te,
        je = !H && !g(function () {
      return 7 != Object.defineProperty(De("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    }),
        Ee = H,
        ke = y,
        Ie = b,
        Oe = k,
        Qe = rc,
        Ze = we,
        Ue = ee,
        Be = je,
        Re = Object.getOwnPropertyDescriptor;

    N.f = Ee ? Re : function (c, e) {
      if (c = Qe(c), e = Ze(e), Be) try {
        return Re(c, e);
      } catch (c) {}
      if (Ue(c, e)) return Oe(!ke(Ie.f, c, e), c[e]);
    };

    var Ye = {},
        Pe = H && g(function () {
      return 42 != Object.defineProperty(function () {}, "prototype", {
        value: 42,
        writable: !1
      }).prototype;
    }),
        Fe = hc,
        We = String,
        Ge = TypeError,
        qe = function qe(c) {
      if (Fe(c)) return c;
      throw Ge(We(c) + " is not an object");
    },
        Je = H,
        Ke = je,
        Xe = Pe,
        _e = qe,
        $e = we,
        ca = TypeError,
        ea = Object.defineProperty,
        aa = Object.getOwnPropertyDescriptor;

    Ye.f = Je ? Xe ? function (c, e, a) {
      if (_e(c), e = $e(e), _e(a), "function" == typeof c && "prototype" === e && "value" in a && "writable" in a && !a.writable) {
        var n = aa(c, e);
        n && n.writable && (c[e] = a.value, a = {
          configurable: "configurable" in a ? a.configurable : n.configurable,
          enumerable: "enumerable" in a ? a.enumerable : n.enumerable,
          writable: !1
        });
      }

      return ea(c, e, a);
    } : ea : function (c, e, a) {
      if (_e(c), e = $e(e), _e(a), Ke) try {
        return ea(c, e, a);
      } catch (c) {}
      if ("get" in a || "set" in a) throw ca("Accessors not supported");
      return "value" in a && (c[e] = a.value), c;
    };
    var na = Ye,
        ta = k,
        ra = H ? function (c, e, a) {
      return na.f(c, e, ta(1, a));
    } : function (c, e, a) {
      return c[e] = a, c;
    },
        ia = {
      exports: {}
    },
        oa = H,
        la = ee,
        fa = Function.prototype,
        sa = oa && Object.getOwnPropertyDescriptor,
        ua = la(fa, "name"),
        ha = {
      EXISTS: ua,
      PROPER: ua && "something" === function () {}.name,
      CONFIGURABLE: ua && (!oa || oa && sa(fa, "name").configurable)
    },
        ma = fc,
        va = qc,
        da = G(Function.toString);
    ma(va.inspectSource) || (va.inspectSource = function (c) {
      return da(c);
    });

    var Ma,
        pa,
        za,
        Ca = va.inspectSource,
        La = fc,
        Aa = A.WeakMap,
        Na = La(Aa) && /native code/.test(String(Aa)),
        ga = Yc.exports,
        Ha = ie,
        Va = ga("keys"),
        xa = function xa(c) {
      return Va[c] || (Va[c] = Ha(c));
    },
        wa = {},
        ya = Na,
        ba = A,
        Sa = hc,
        Ta = ra,
        Da = ee,
        ja = qc,
        Ea = xa,
        ka = wa,
        Ia = ba.TypeError,
        Oa = ba.WeakMap;

    if (ya || ja.state) {
      var Qa = ja.state || (ja.state = new Oa());
      Qa.get = Qa.get, Qa.has = Qa.has, Qa.set = Qa.set, Ma = function Ma(c, e) {
        if (Qa.has(c)) throw Ia("Object already initialized");
        return e.facade = c, Qa.set(c, e), e;
      }, pa = function pa(c) {
        return Qa.get(c) || {};
      }, za = function za(c) {
        return Qa.has(c);
      };
    } else {
      var Za = Ea("state");
      ka[Za] = !0, Ma = function Ma(c, e) {
        if (Da(c, Za)) throw Ia("Object already initialized");
        return e.facade = c, Ta(c, Za, e), e;
      }, pa = function pa(c) {
        return Da(c, Za) ? c[Za] : {};
      }, za = function za(c) {
        return Da(c, Za);
      };
    }

    var Ua = {
      set: Ma,
      get: pa,
      has: za,
      enforce: function enforce(c) {
        return za(c) ? pa(c) : Ma(c, {});
      },
      getterFor: function getterFor(c) {
        return function (e) {
          var a;
          if (!Sa(e) || (a = pa(e)).type !== c) throw Ia("Incompatible receiver, " + c + " required");
          return a;
        };
      }
    },
        Ba = g,
        Ra = fc,
        Ya = ee,
        Pa = H,
        Fa = ha.CONFIGURABLE,
        Wa = Ca,
        Ga = Ua.enforce,
        qa = Ua.get,
        Ja = Object.defineProperty,
        Ka = Pa && !Ba(function () {
      return 8 !== Ja(function () {}, "length", {
        value: 8
      }).length;
    }),
        Xa = String(String).split("String"),
        _a = ia.exports = function (c, e, a) {
      "Symbol(" === String(e).slice(0, 7) && (e = "[" + String(e).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), a && a.getter && (e = "get " + e), a && a.setter && (e = "set " + e), (!Ya(c, "name") || Fa && c.name !== e) && (Pa ? Ja(c, "name", {
        value: e,
        configurable: !0
      }) : c.name = e), Ka && a && Ya(a, "arity") && c.length !== a.arity && Ja(c, "length", {
        value: a.arity
      });

      try {
        a && Ya(a, "constructor") && a.constructor ? Pa && Ja(c, "prototype", {
          writable: !1
        }) : c.prototype && (c.prototype = void 0);
      } catch (c) {}

      var n = Ga(c);
      return Ya(n, "source") || (n.source = Xa.join("string" == typeof e ? e : "")), c;
    };

    Function.prototype.toString = _a(function () {
      return Ra(this) && qa(this).source || Wa(this);
    }, "toString");

    var $a = fc,
        cn = Ye,
        en = ia.exports,
        an = Wc,
        nn = {},
        tn = Math.ceil,
        rn = Math.floor,
        on = Math.trunc || function (c) {
      var e = +c;
      return (e > 0 ? rn : tn)(e);
    },
        ln = function ln(c) {
      var e = +c;
      return e != e || 0 === e ? 0 : on(e);
    },
        fn = ln,
        sn = Math.max,
        un = Math.min,
        hn = ln,
        mn = Math.min,
        vn = function vn(c) {
      return c > 0 ? mn(hn(c), 9007199254740991) : 0;
    },
        dn = function dn(c) {
      return vn(c.length);
    },
        Mn = rc,
        pn = function pn(c, e) {
      var a = fn(c);
      return a < 0 ? sn(a + e, 0) : un(a, e);
    },
        zn = dn,
        Cn = function Cn(c) {
      return function (e, a, n) {
        var t,
            r = Mn(e),
            i = zn(r),
            o = pn(n, i);

        if (c && a != a) {
          for (; i > o;) {
            if ((t = r[o++]) != t) return !0;
          }
        } else for (; i > o; o++) {
          if ((c || o in r) && r[o] === a) return c || o || 0;
        }

        return !c && -1;
      };
    },
        Ln = {
      includes: Cn(!0),
      indexOf: Cn(!1)
    },
        An = ee,
        Nn = rc,
        gn = Ln.indexOf,
        Hn = wa,
        Vn = G([].push),
        xn = function xn(c, e) {
      var a,
          n = Nn(c),
          t = 0,
          r = [];

      for (a in n) {
        !An(Hn, a) && An(n, a) && Vn(r, a);
      }

      for (; e.length > t;) {
        An(n, a = e[t++]) && (~gn(r, a) || Vn(r, a));
      }

      return r;
    },
        wn = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
        yn = xn,
        bn = wn.concat("length", "prototype");

    nn.f = Object.getOwnPropertyNames || function (c) {
      return yn(c, bn);
    };

    var Sn = {};
    Sn.f = Object.getOwnPropertySymbols;

    var Tn = dc,
        Dn = nn,
        jn = Sn,
        En = qe,
        kn = G([].concat),
        In = Tn("Reflect", "ownKeys") || function (c) {
      var e = Dn.f(En(c)),
          a = jn.f;
      return a ? kn(e, a(c)) : e;
    },
        On = ee,
        Qn = In,
        Zn = N,
        Un = Ye,
        Bn = g,
        Rn = fc,
        Yn = /#|\.prototype\./,
        Pn = function Pn(c, e) {
      var a = Wn[Fn(c)];
      return a == qn || a != Gn && (Rn(e) ? Bn(e) : !!e);
    },
        Fn = Pn.normalize = function (c) {
      return String(c).replace(Yn, ".").toLowerCase();
    },
        Wn = Pn.data = {},
        Gn = Pn.NATIVE = "N",
        qn = Pn.POLYFILL = "P",
        Jn = Pn,
        Kn = A,
        Xn = N.f,
        _n = ra,
        $n = function $n(c, e, a, n) {
      n || (n = {});
      var t = n.enumerable,
          r = void 0 !== n.name ? n.name : e;
      if ($a(a) && en(a, r, n), n.global) t ? c[e] = a : an(e, a);else {
        try {
          n.unsafe ? c[e] && (t = !0) : delete c[e];
        } catch (c) {}

        t ? c[e] = a : cn.f(c, e, {
          value: a,
          enumerable: !1,
          configurable: !n.nonConfigurable,
          writable: !n.nonWritable
        });
      }
      return c;
    },
        ct = Wc,
        et = function et(c, e, a) {
      for (var n = Qn(e), t = Un.f, r = Zn.f, i = 0; i < n.length; i++) {
        var o = n[i];
        On(c, o) || a && On(a, o) || t(c, o, r(e, o));
      }
    },
        at = Jn,
        nt = Ic,
        tt = V,
        rt = G(G.bind),
        it = P,
        ot = Array.isArray || function (c) {
      return "Array" == it(c);
    },
        lt = {};

    lt[pe("toStringTag")] = "z";

    var ft = "[object z]" === String(lt),
        st = fc,
        ut = P,
        ht = pe("toStringTag"),
        mt = Object,
        vt = "Arguments" == ut(function () {
      return arguments;
    }()),
        dt = G,
        Mt = g,
        pt = fc,
        zt = ft ? ut : function (c) {
      var e, a, n;
      return void 0 === c ? "Undefined" : null === c ? "Null" : "string" == typeof (a = function (c, e) {
        try {
          return c[e];
        } catch (c) {}
      }(e = mt(c), ht)) ? a : vt ? ut(e) : "Object" == (n = ut(e)) && st(e.callee) ? "Arguments" : n;
    },
        Ct = Ca,
        Lt = function Lt() {},
        At = [],
        Nt = dc("Reflect", "construct"),
        gt = /^\s*(?:class|function)\b/,
        Ht = dt(gt.exec),
        Vt = !gt.exec(Lt),
        xt = function xt(c) {
      if (!pt(c)) return !1;

      try {
        return Nt(Lt, At, c), !0;
      } catch (c) {
        return !1;
      }
    },
        wt = function wt(c) {
      if (!pt(c)) return !1;

      switch (zt(c)) {
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
          return !1;
      }

      try {
        return Vt || !!Ht(gt, Ct(c));
      } catch (c) {
        return !0;
      }
    };

    wt.sham = !0;

    var yt = !Nt || Mt(function () {
      var c;
      return xt(xt.call) || !xt(Object) || !xt(function () {
        c = !0;
      }) || c;
    }) ? wt : xt,
        bt = ot,
        St = yt,
        Tt = hc,
        Dt = pe("species"),
        jt = Array,
        Et = function Et(c) {
      var e;
      return bt(c) && (e = c.constructor, St(e) && (e === jt || bt(e.prototype)) ? e = void 0 : Tt(e) && null === (e = e[Dt]) && (e = void 0)), void 0 === e ? jt : e;
    },
        kt = function kt(c, e) {
      return nt(c), void 0 === e ? c : tt ? rt(c, e) : function () {
        return c.apply(e, arguments);
      };
    },
        It = _,
        Ot = _c,
        Qt = dn,
        Zt = function Zt(c, e) {
      return new (Et(c))(0 === e ? 0 : e);
    },
        Ut = G([].push),
        Bt = function Bt(c) {
      var e = 1 == c,
          a = 2 == c,
          n = 3 == c,
          t = 4 == c,
          r = 6 == c,
          i = 7 == c,
          o = 5 == c || r;
      return function (l, f, s, u) {
        for (var h, m, v = Ot(l), d = It(v), M = kt(f, s), p = Qt(d), z = 0, C = u || Zt, L = e ? C(l, p) : a || i ? C(l, 0) : void 0; p > z; z++) {
          if ((o || z in d) && (m = M(h = d[z], z, v), c)) if (e) L[z] = m;else if (m) switch (c) {
            case 3:
              return !0;

            case 5:
              return h;

            case 6:
              return z;

            case 2:
              Ut(L, h);
          } else switch (c) {
            case 4:
              return !1;

            case 7:
              Ut(L, h);
          }
        }

        return r ? -1 : n || t ? t : L;
      };
    },
        Rt = {
      forEach: Bt(0),
      map: Bt(1),
      filter: Bt(2),
      some: Bt(3),
      every: Bt(4),
      find: Bt(5),
      findIndex: Bt(6),
      filterReject: Bt(7)
    },
        Yt = {},
        Pt = xn,
        Ft = wn,
        Wt = Object.keys || function (c) {
      return Pt(c, Ft);
    },
        Gt = H,
        qt = Pe,
        Jt = Ye,
        Kt = qe,
        Xt = rc,
        _t = Wt;

    Yt.f = Gt && !qt ? Object.defineProperties : function (c, e) {
      Kt(c);

      for (var a, n = Xt(e), t = _t(e), r = t.length, i = 0; r > i;) {
        Jt.f(c, a = t[i++], n[a]);
      }

      return c;
    };

    var $t,
        cr = dc("document", "documentElement"),
        er = qe,
        ar = Yt,
        nr = wn,
        tr = wa,
        rr = cr,
        ir = Te,
        or = xa("IE_PROTO"),
        lr = function lr() {},
        fr = function fr(c) {
      return "<script>" + c + "<\/script>";
    },
        sr = function sr(c) {
      c.write(fr("")), c.close();
      var e = c.parentWindow.Object;
      return c = null, e;
    },
        _ur = function ur() {
      try {
        $t = new ActiveXObject("htmlfile");
      } catch (c) {}

      var c, e;
      _ur = "undefined" != typeof document ? document.domain && $t ? sr($t) : ((e = ir("iframe")).style.display = "none", rr.appendChild(e), e.src = String("javascript:"), (c = e.contentWindow.document).open(), c.write(fr("document.F=Object")), c.close(), c.F) : sr($t);

      for (var a = nr.length; a--;) {
        delete _ur.prototype[nr[a]];
      }

      return _ur();
    };

    tr[or] = !0;

    var hr = pe,
        mr = Object.create || function (c, e) {
      var a;
      return null !== c ? (lr.prototype = er(c), a = new lr(), lr.prototype = null, a[or] = c) : a = _ur(), void 0 === e ? a : ar.f(a, e);
    },
        vr = Ye.f,
        dr = hr("unscopables"),
        Mr = Array.prototype;

    null == Mr[dr] && vr(Mr, dr, {
      configurable: !0,
      value: mr(null)
    });

    var pr = function pr(c, e) {
      var a,
          n,
          t,
          r,
          i,
          o = c.target,
          l = c.global,
          f = c.stat;
      if (a = l ? Kn : f ? Kn[o] || ct(o, {}) : (Kn[o] || {}).prototype) for (n in e) {
        if (r = e[n], t = c.dontCallGetSet ? (i = Xn(a, n)) && i.value : a[n], !at(l ? n : o + (f ? "." : "#") + n, c.forced) && void 0 !== t) {
          if (typeof r == typeof t) continue;
          et(r, t);
        }

        (c.sham || t && t.sham) && _n(r, "sham", !0), $n(a, n, r, c);
      }
    },
        zr = Rt.find,
        Cr = function Cr(c) {
      Mr[dr][c] = !0;
    },
        Lr = !0;

    "find" in [] && Array(1).find(function () {
      Lr = !1;
    }), pr({
      target: "Array",
      proto: !0,
      forced: Lr
    }, {
      find: function find(c) {
        return zr(this, c, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), Cr("find");

    var Ar = {
      GLOBAL: {
        HIDE: "__react_tooltip_hide_event",
        REBUILD: "__react_tooltip_rebuild_event",
        SHOW: "__react_tooltip_show_event"
      }
    },
        Nr = function Nr(c, e) {
      var a;
      "function" == typeof window.CustomEvent ? a = new window.CustomEvent(c, {
        detail: e
      }) : (a = document.createEvent("Event")).initEvent(c, !1, !0, e), window.dispatchEvent(a);
    };

    var gr = function gr(c, e) {
      var a = this.state.show,
          n = this.props.id,
          t = this.isCapture(e.currentTarget),
          r = e.currentTarget.getAttribute("currentItem");
      t || e.stopPropagation(), a && "true" === r ? c || this.hideTooltip(e) : (e.currentTarget.setAttribute("currentItem", "true"), Hr(e.currentTarget, this.getTargetArray(n)), this.showTooltip(e));
    },
        Hr = function Hr(c, e) {
      for (var a = 0; a < e.length; a++) {
        c !== e[a] ? e[a].setAttribute("currentItem", "false") : e[a].setAttribute("currentItem", "true");
      }
    },
        Vr = {
      id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
      set: function set(c, e, a) {
        this.id in c ? c[this.id][e] = a : Object.defineProperty(c, this.id, {
          configurable: !0,
          value: u({}, e, a)
        });
      },
      get: function get(c, e) {
        var a = c[this.id];
        if (void 0 !== a) return a[e];
      }
    };

    var xr = function xr(c, e, a) {
      for (var n, t, r = e.respectEffect, i = void 0 !== r && r, o = e.customEvent, l = void 0 !== o && o, f = this.props.id, s = null, u = a.target; null === s && null !== u;) {
        t = u, s = u.getAttribute("data-tip") || null, n = u.getAttribute("data-for") || null, u = u.parentElement;
      }

      if (u = t || a.target, !this.isCustomEvent(u) || l) {
        var h = null == f && null == n || n === f;

        if (null != s && (!i || "float" === this.getEffect(u)) && h) {
          var m = function (c) {
            var e = {};

            for (var a in c) {
              "function" == typeof c[a] ? e[a] = c[a].bind(c) : e[a] = c[a];
            }

            return e;
          }(a);

          m.currentTarget = u, c(m);
        }
      }
    },
        wr = function wr(c, e) {
      var a = {};
      return c.forEach(function (c) {
        var n = c.getAttribute(e);
        n && n.split(" ").forEach(function (c) {
          return a[c] = !0;
        });
      }), a;
    },
        yr = function yr() {
      return document.getElementsByTagName("body")[0];
    };

    var br = function br() {
      return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    };

    function Sr(c, e, a, n, t, r, i) {
      var o = Tr(a),
          l = o.width,
          f = o.height,
          s = Tr(e),
          u = s.width,
          h = s.height,
          m = Dr(c, e, r),
          v = m.mouseX,
          d = m.mouseY,
          M = jr(r, u, h, l, f),
          p = Er(i),
          C = p.extraOffsetX,
          L = p.extraOffsetY,
          A = window.innerWidth,
          N = window.innerHeight,
          g = kr(a),
          H = g.parentTop,
          V = g.parentLeft,
          x = function x(c) {
        var e = M[c].l;
        return v + e + C;
      },
          w = function w(c) {
        var e = M[c].t;
        return d + e + L;
      },
          y = function y(c) {
        return e = M[c].r, v + e + C > A;
        var e;
      },
          b = function b(c) {
        return e = M[c].b, d + e + L > N;
        var e;
      },
          S = function S(c) {
        return function (c) {
          return x(c) < 0;
        }(c) || y(c) || function (c) {
          return w(c) < 0;
        }(c) || b(c);
      },
          T = function T(c) {
        return !S(c);
      },
          D = {
        top: T("top"),
        bottom: T("bottom"),
        left: T("left"),
        right: T("right")
      };

      var j,
          E = function () {
        var c,
            e = z(t.split(",").concat(n, ["top", "bottom", "left", "right"]));

        try {
          for (e.s(); !(c = e.n()).done;) {
            var a = c.value;
            if (D[a]) return a;
          }
        } catch (c) {
          e.e(c);
        } finally {
          e.f();
        }

        return n;
      }(),
          k = !1;

      return E && E !== n && (k = !0, j = E), k ? {
        isNewState: !0,
        newState: {
          place: j
        }
      } : {
        isNewState: !1,
        position: {
          left: parseInt(x(n) - V, 10),
          top: parseInt(w(n) - H, 10)
        }
      };
    }

    var Tr = function Tr(c) {
      var e = c.getBoundingClientRect(),
          a = e.height,
          n = e.width;
      return {
        height: parseInt(a, 10),
        width: parseInt(n, 10)
      };
    },
        Dr = function Dr(c, e, a) {
      var n = e.getBoundingClientRect(),
          t = n.top,
          r = n.left,
          i = Tr(e),
          o = i.width,
          l = i.height;
      return "float" === a ? {
        mouseX: c.clientX,
        mouseY: c.clientY
      } : {
        mouseX: r + o / 2,
        mouseY: t + l / 2
      };
    },
        jr = function jr(c, e, a, n, t) {
      var r, i, o, l;
      return "float" === c ? (r = {
        l: -n / 2,
        r: n / 2,
        t: -(t + 3 + 2),
        b: -3
      }, o = {
        l: -n / 2,
        r: n / 2,
        t: 15,
        b: t + 3 + 2 + 12
      }, l = {
        l: -(n + 3 + 2),
        r: -3,
        t: -t / 2,
        b: t / 2
      }, i = {
        l: 3,
        r: n + 3 + 2,
        t: -t / 2,
        b: t / 2
      }) : "solid" === c && (r = {
        l: -n / 2,
        r: n / 2,
        t: -(a / 2 + t + 2),
        b: -a / 2
      }, o = {
        l: -n / 2,
        r: n / 2,
        t: a / 2,
        b: a / 2 + t + 2
      }, l = {
        l: -(n + e / 2 + 2),
        r: -e / 2,
        t: -t / 2,
        b: t / 2
      }, i = {
        l: e / 2,
        r: n + e / 2 + 2,
        t: -t / 2,
        b: t / 2
      }), {
        top: r,
        bottom: o,
        left: l,
        right: i
      };
    },
        Er = function Er(c) {
      var e = 0,
          a = 0;

      for (var n in "[object String]" === Object.prototype.toString.apply(c) && (c = JSON.parse(c.toString().replace(/'/g, '"'))), c) {
        "top" === n ? a -= parseInt(c[n], 10) : "bottom" === n ? a += parseInt(c[n], 10) : "left" === n ? e -= parseInt(c[n], 10) : "right" === n && (e += parseInt(c[n], 10));
      }

      return {
        extraOffsetX: e,
        extraOffsetY: a
      };
    },
        kr = function kr(c) {
      for (var e = c; e;) {
        var a = window.getComputedStyle(e);
        if ("none" !== a.getPropertyValue("transform") || "transform" === a.getPropertyValue("will-change")) break;
        e = e.parentElement;
      }

      return {
        parentTop: e && e.getBoundingClientRect().top || 0,
        parentLeft: e && e.getBoundingClientRect().left || 0
      };
    };

    function Ir(c, e, a, n) {
      if (e) return e;
      if (null != a) return a;
      if (null === a) return null;
      var r = /<br\s*\/?>/;
      return n && "false" !== n && r.test(c) ? c.split(r).map(function (c, e) {
        return t.a.createElement("span", {
          key: e,
          className: "multi-line"
        }, c);
      }) : c;
    }

    function Or(c) {
      var e = {};
      return Object.keys(c).filter(function (c) {
        return /(^aria-\w+$|^role$)/.test(c);
      }).forEach(function (a) {
        e[a] = c[a];
      }), e;
    }

    function Qr(c) {
      var e = c.length;
      return c.hasOwnProperty ? Array.prototype.slice.call(c) : new Array(e).fill().map(function (e) {
        return c[e];
      });
    }

    var Zr = {
      dark: {
        text: "#fff",
        background: "#222",
        border: "transparent",
        arrow: "#222"
      },
      success: {
        text: "#fff",
        background: "#8DC572",
        border: "transparent",
        arrow: "#8DC572"
      },
      warning: {
        text: "#fff",
        background: "#F0AD4E",
        border: "transparent",
        arrow: "#F0AD4E"
      },
      error: {
        text: "#fff",
        background: "#BE6464",
        border: "transparent",
        arrow: "#BE6464"
      },
      info: {
        text: "#fff",
        background: "#337AB7",
        border: "transparent",
        arrow: "#337AB7"
      },
      light: {
        text: "#222",
        background: "#fff",
        border: "transparent",
        arrow: "#fff"
      }
    };
    var Ur,
        Br,
        Rr = "8px 21px",
        Yr = {
      tooltip: 3,
      arrow: 0
    };

    function Pr(c, e, a, n, t, r) {
      return function (c, e) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Rr,
            n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : Yr,
            t = e.text,
            r = e.background,
            i = e.border,
            o = e.arrow,
            l = n.arrow,
            f = n.tooltip;
        return "\n  \t.".concat(c, " {\n\t    color: ").concat(t, ";\n\t    background: ").concat(r, ";\n\t    border: 1px solid ").concat(i, ";\n\t    border-radius: ").concat(f, "px;\n\t    padding: ").concat(a, ";\n  \t}\n\n  \t.").concat(c, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(c, '.place-top::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 20px;\n        height: 12px;\n    }\n    .').concat(c, '.place-top::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(l, "px;\n        border: 1px solid ").concat(i, ";\n        background-color: ").concat(o, ";\n        z-index: -2;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(135deg);\n    }\n\n    .").concat(c, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(c, '.place-bottom::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 18px;\n        height: 10px;\n    }\n    .').concat(c, '.place-bottom::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(l, "px;\n        border: 1px solid ").concat(i, ";\n        background-color: ").concat(o, ";\n        z-index: -2;\n        top: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(c, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(c, '.place-left::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .').concat(c, '.place-left::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(l, "px;\n        border: 1px solid ").concat(i, ";\n        background-color: ").concat(o, ";\n        z-index: -2;\n        right: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(c, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(c, '.place-right::before {\n        content: "";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .').concat(c, '.place-right::after {\n        content: "";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ').concat(l, "px;\n        border: 1px solid ").concat(i, ";\n        background-color: ").concat(o, ";\n        z-index: -2;\n        left: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(-135deg);\n    }\n  ");
      }(c, function (c, e, a) {
        var n = c.text,
            t = c.background,
            r = c.border,
            i = c.arrow ? c.arrow : c.background,
            o = function (c) {
          return Zr[c] ? f({}, Zr[c]) : void 0;
        }(e);

        n && (o.text = n);
        t && (o.background = t);
        a && (o.border = r || ("light" === e ? "black" : "white"));
        i && (o.arrow = i);
        return o;
      }(e, a, n), t, r);
    }

    var Fr,
        Wr = function (c) {
      c.hide = function (c) {
        Nr(Ar.GLOBAL.HIDE, {
          target: c
        });
      }, c.rebuild = function () {
        Nr(Ar.GLOBAL.REBUILD);
      }, c.show = function (c) {
        Nr(Ar.GLOBAL.SHOW, {
          target: c
        });
      }, c.prototype.globalRebuild = function () {
        this.mount && (this.unbindListener(), this.bindListener());
      }, c.prototype.globalShow = function (c) {
        if (this.mount) {
          var e = !!(c && c.detail && c.detail.target);
          this.showTooltip({
            currentTarget: e && c.detail.target
          }, !0);
        }
      }, c.prototype.globalHide = function (c) {
        if (this.mount) {
          var e = !!(c && c.detail && c.detail.target);
          this.hideTooltip({
            currentTarget: e && c.detail.target
          }, e);
        }
      };
    }(Ur = function (c) {
      c.prototype.bindWindowEvents = function (c) {
        window.removeEventListener(Ar.GLOBAL.HIDE, this.globalHide), window.addEventListener(Ar.GLOBAL.HIDE, this.globalHide, !1), window.removeEventListener(Ar.GLOBAL.REBUILD, this.globalRebuild), window.addEventListener(Ar.GLOBAL.REBUILD, this.globalRebuild, !1), window.removeEventListener(Ar.GLOBAL.SHOW, this.globalShow), window.addEventListener(Ar.GLOBAL.SHOW, this.globalShow, !1), c && (window.removeEventListener("resize", this.onWindowResize), window.addEventListener("resize", this.onWindowResize, !1));
      }, c.prototype.unbindWindowEvents = function () {
        window.removeEventListener(Ar.GLOBAL.HIDE, this.globalHide), window.removeEventListener(Ar.GLOBAL.REBUILD, this.globalRebuild), window.removeEventListener(Ar.GLOBAL.SHOW, this.globalShow), window.removeEventListener("resize", this.onWindowResize);
      }, c.prototype.onWindowResize = function () {
        this.mount && this.hideTooltip();
      };
    }(Ur = function (c) {
      c.prototype.isCustomEvent = function (c) {
        return this.state.event || !!c.getAttribute("data-event");
      }, c.prototype.customBindListener = function (c) {
        var e = this,
            a = this.state,
            n = a.event,
            t = a.eventOff,
            r = c.getAttribute("data-event") || n,
            i = c.getAttribute("data-event-off") || t;
        r.split(" ").forEach(function (a) {
          c.removeEventListener(a, Vr.get(c, a));
          var n = gr.bind(e, i);
          Vr.set(c, a, n), c.addEventListener(a, n, !1);
        }), i && i.split(" ").forEach(function (a) {
          c.removeEventListener(a, e.hideTooltip), c.addEventListener(a, e.hideTooltip, !1);
        });
      }, c.prototype.customUnbindListener = function (c) {
        var e = this.state,
            a = e.event,
            n = e.eventOff,
            t = a || c.getAttribute("data-event"),
            r = n || c.getAttribute("data-event-off");
        c.removeEventListener(t, Vr.get(c, a)), r && c.removeEventListener(r, this.hideTooltip);
      };
    }(Ur = function (c) {
      c.prototype.isCapture = function (c) {
        return c && "true" === c.getAttribute("data-iscapture") || this.props.isCapture || !1;
      };
    }(Ur = function (c) {
      c.prototype.getEffect = function (c) {
        return c.getAttribute("data-effect") || this.props.effect || "float";
      };
    }(Ur = function (c) {
      c.prototype.isBodyMode = function () {
        return !!this.props.bodyMode;
      }, c.prototype.bindBodyListener = function (c) {
        var e = this,
            a = this.state,
            n = a.event,
            t = a.eventOff,
            r = a.possibleCustomEvents,
            i = a.possibleCustomEventsOff,
            o = yr(),
            l = wr(c, "data-event"),
            f = wr(c, "data-event-off");
        null != n && (l[n] = !0), null != t && (f[t] = !0), r.split(" ").forEach(function (c) {
          return l[c] = !0;
        }), i.split(" ").forEach(function (c) {
          return f[c] = !0;
        }), this.unbindBodyListener(o);
        var s = this.bodyModeListeners = {};

        for (var u in null == n && (s.mouseover = xr.bind(this, this.showTooltip, {}), s.mousemove = xr.bind(this, this.updateTooltip, {
          respectEffect: !0
        }), s.mouseout = xr.bind(this, this.hideTooltip, {})), l) {
          s[u] = xr.bind(this, function (c) {
            var a = c.currentTarget.getAttribute("data-event-off") || t;
            gr.call(e, a, c);
          }, {
            customEvent: !0
          });
        }

        for (var h in f) {
          s[h] = xr.bind(this, this.hideTooltip, {
            customEvent: !0
          });
        }

        for (var m in s) {
          o.addEventListener(m, s[m]);
        }
      }, c.prototype.unbindBodyListener = function (c) {
        c = c || yr();
        var e = this.bodyModeListeners;

        for (var a in e) {
          c.removeEventListener(a, e[a]);
        }
      };
    }((u(Br = function (c) {
      !function (c, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        c.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: c,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(c, "prototype", {
          writable: !1
        }), e && v(c, e);
      }(l, t.a.Component);
      var e,
          a,
          n,
          r = M(l);

      function l(c) {
        var e;
        return function (c, e) {
          if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, l), (e = r.call(this, c)).state = {
          uuid: c.uuid || "t" + Object(o.a)(),
          place: c.place || "top",
          desiredPlace: c.place || "top",
          type: c.type || "dark",
          effect: c.effect || "float",
          show: !1,
          border: !1,
          borderClass: "border",
          customColors: {},
          customRadius: {},
          offset: {},
          padding: c.padding,
          extraClass: "",
          html: !1,
          delayHide: 0,
          delayShow: 0,
          event: c.event || null,
          eventOff: c.eventOff || null,
          currentEvent: null,
          currentTarget: null,
          ariaProps: Or(c),
          isEmptyTip: !1,
          disable: !1,
          possibleCustomEvents: c.possibleCustomEvents || "",
          possibleCustomEventsOff: c.possibleCustomEventsOff || "",
          originTooltip: null,
          isMultiline: !1
        }, e.bind(["showTooltip", "updateTooltip", "hideTooltip", "hideTooltipOnScroll", "getTooltipContent", "globalRebuild", "globalShow", "globalHide", "onWindowResize", "mouseOnToolTip"]), e.mount = !0, e.delayShowLoop = null, e.delayHideLoop = null, e.delayReshow = null, e.intervalUpdateContent = null, e;
      }

      return e = l, n = [{
        key: "propTypes",
        get: function get() {
          return {
            uuid: i.a.string,
            children: i.a.any,
            place: i.a.string,
            type: i.a.string,
            effect: i.a.string,
            offset: i.a.object,
            padding: i.a.string,
            multiline: i.a.bool,
            border: i.a.bool,
            borderClass: i.a.string,
            textColor: i.a.string,
            backgroundColor: i.a.string,
            borderColor: i.a.string,
            arrowColor: i.a.string,
            arrowRadius: i.a.string,
            tooltipRadius: i.a.string,
            insecure: i.a.bool,
            class: i.a.string,
            className: i.a.string,
            id: i.a.string,
            html: i.a.bool,
            delayHide: i.a.number,
            delayUpdate: i.a.number,
            delayShow: i.a.number,
            event: i.a.string,
            eventOff: i.a.string,
            isCapture: i.a.bool,
            globalEventOff: i.a.string,
            getContent: i.a.any,
            afterShow: i.a.func,
            afterHide: i.a.func,
            overridePosition: i.a.func,
            disable: i.a.bool,
            scrollHide: i.a.bool,
            resizeHide: i.a.bool,
            wrapper: i.a.string,
            bodyMode: i.a.bool,
            possibleCustomEvents: i.a.string,
            possibleCustomEventsOff: i.a.string,
            clickable: i.a.bool,
            disableInternalStyle: i.a.bool
          };
        }
      }, {
        key: "getDerivedStateFromProps",
        value: function value(c, e) {
          var a = e.ariaProps,
              n = Or(c);
          return Object.keys(n).some(function (c) {
            return n[c] !== a[c];
          }) ? f(f({}, e), {}, {
            ariaProps: n
          }) : null;
        }
      }], (a = [{
        key: "bind",
        value: function value(c) {
          var e = this;
          c.forEach(function (c) {
            e[c] = e[c].bind(e);
          });
        }
      }, {
        key: "componentDidMount",
        value: function value() {
          var c = this.props;
          c.insecure;
          var e = c.resizeHide,
              a = c.disableInternalStyle;
          this.mount = !0, this.bindListener(), this.bindWindowEvents(e), a || this.injectStyles();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.mount = !1, this.clearTimer(), this.unbindListener(), this.removeScrollListener(this.state.currentTarget), this.unbindWindowEvents();
        }
      }, {
        key: "injectStyles",
        value: function value() {
          var c = this.tooltipRef;

          if (c) {
            for (var e, a = c.parentNode; a.parentNode;) {
              a = a.parentNode;
            }

            switch (a.constructor.name) {
              case "Document":
              case "HTMLDocument":
              case void 0:
                e = a.head;
                break;

              case "ShadowRoot":
              default:
                e = a;
            }

            if (!e.querySelector("style[data-react-tooltip]")) {
              var n = document.createElement("style");
              n.textContent = '.__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: "";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  bottom: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-bottom::before {\n  top: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-left::before {\n  right: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip.place-right::before {\n  left: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}', n.setAttribute("data-react-tooltip", "true"), e.appendChild(n);
            }
          }
        }
      }, {
        key: "mouseOnToolTip",
        value: function value() {
          return !(!this.state.show || !this.tooltipRef) && (this.tooltipRef.matches || (this.tooltipRef.msMatchesSelector ? this.tooltipRef.matches = this.tooltipRef.msMatchesSelector : this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector), this.tooltipRef.matches(":hover"));
        }
      }, {
        key: "getTargetArray",
        value: function value(c) {
          var e,
              a = [];

          if (c) {
            var n = c.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
            e = '[data-tip][data-for="'.concat(n, '"]');
          } else e = "[data-tip]:not([data-for])";

          return Qr(document.getElementsByTagName("*")).filter(function (c) {
            return c.shadowRoot;
          }).forEach(function (c) {
            a = a.concat(Qr(c.shadowRoot.querySelectorAll(e)));
          }), a.concat(Qr(document.querySelectorAll(e)));
        }
      }, {
        key: "bindListener",
        value: function value() {
          var c = this,
              e = this.props,
              a = e.id,
              n = e.globalEventOff,
              t = e.isCapture,
              r = this.getTargetArray(a);
          r.forEach(function (e) {
            null === e.getAttribute("currentItem") && e.setAttribute("currentItem", "false"), c.unbindBasicListener(e), c.isCustomEvent(e) && c.customUnbindListener(e);
          }), this.isBodyMode() ? this.bindBodyListener(r) : r.forEach(function (e) {
            var a = c.isCapture(e),
                n = c.getEffect(e);
            c.isCustomEvent(e) ? c.customBindListener(e) : (e.addEventListener("mouseenter", c.showTooltip, a), e.addEventListener("focus", c.showTooltip, a), "float" === n && e.addEventListener("mousemove", c.updateTooltip, a), e.addEventListener("mouseleave", c.hideTooltip, a), e.addEventListener("blur", c.hideTooltip, a));
          }), n && (window.removeEventListener(n, this.hideTooltip), window.addEventListener(n, this.hideTooltip, t)), this.bindRemovalTracker();
        }
      }, {
        key: "unbindListener",
        value: function value() {
          var c = this,
              e = this.props,
              a = e.id,
              n = e.globalEventOff;
          this.isBodyMode() ? this.unbindBodyListener() : this.getTargetArray(a).forEach(function (e) {
            c.unbindBasicListener(e), c.isCustomEvent(e) && c.customUnbindListener(e);
          });
          n && window.removeEventListener(n, this.hideTooltip), this.unbindRemovalTracker();
        }
      }, {
        key: "unbindBasicListener",
        value: function value(c) {
          var e = this.isCapture(c);
          c.removeEventListener("mouseenter", this.showTooltip, e), c.removeEventListener("mousemove", this.updateTooltip, e), c.removeEventListener("mouseleave", this.hideTooltip, e);
        }
      }, {
        key: "getTooltipContent",
        value: function value() {
          var c,
              e = this.props,
              a = e.getContent,
              n = e.children;
          return a && (c = Array.isArray(a) ? a[0] && a[0](this.state.originTooltip) : a(this.state.originTooltip)), Ir(this.state.originTooltip, n, c, this.state.isMultiline);
        }
      }, {
        key: "isEmptyTip",
        value: function value(c) {
          return "string" == typeof c && "" === c || null === c;
        }
      }, {
        key: "showTooltip",
        value: function value(c, e) {
          if (this.tooltipRef) {
            if (e) if (!this.getTargetArray(this.props.id).some(function (e) {
              return e === c.currentTarget;
            })) return;
            var a = this.props,
                n = a.multiline,
                t = a.getContent,
                r = c.currentTarget.getAttribute("data-tip"),
                i = c.currentTarget.getAttribute("data-multiline") || n || !1,
                o = c instanceof window.FocusEvent || e,
                l = !0;
            c.currentTarget.getAttribute("data-scroll-hide") ? l = "true" === c.currentTarget.getAttribute("data-scroll-hide") : null != this.props.scrollHide && (l = this.props.scrollHide), c && c.currentTarget && c.currentTarget.setAttribute && c.currentTarget.setAttribute("aria-describedby", this.props.id || this.state.uuid);
            var f = c.currentTarget.getAttribute("data-place") || this.props.place || "top",
                s = o ? "solid" : this.getEffect(c.currentTarget),
                u = c.currentTarget.getAttribute("data-offset") || this.props.offset || {},
                h = Sr(c, c.currentTarget, this.tooltipRef, f.split(",")[0], f, s, u);
            h.position && this.props.overridePosition && (h.position = this.props.overridePosition(h.position, c, c.currentTarget, this.tooltipRef, f, f, s, u));
            var m = h.isNewState ? h.newState.place : f.split(",")[0];
            this.clearTimer();

            var v = c.currentTarget,
                d = this.state.show ? v.getAttribute("data-delay-update") || this.props.delayUpdate : 0,
                M = this,
                p = function p() {
              M.setState({
                originTooltip: r,
                isMultiline: i,
                desiredPlace: f,
                place: m,
                type: v.getAttribute("data-type") || M.props.type || "dark",
                customColors: {
                  text: v.getAttribute("data-text-color") || M.props.textColor || null,
                  background: v.getAttribute("data-background-color") || M.props.backgroundColor || null,
                  border: v.getAttribute("data-border-color") || M.props.borderColor || null,
                  arrow: v.getAttribute("data-arrow-color") || M.props.arrowColor || null
                },
                customRadius: {
                  tooltip: v.getAttribute("data-tooltip-radius") || M.props.tooltipRadius || "3",
                  arrow: v.getAttribute("data-arrow-radius") || M.props.arrowRadius || "0"
                },
                effect: s,
                offset: u,
                padding: v.getAttribute("data-padding") || M.props.padding,
                html: (v.getAttribute("data-html") ? "true" === v.getAttribute("data-html") : M.props.html) || !1,
                delayShow: v.getAttribute("data-delay-show") || M.props.delayShow || 0,
                delayHide: v.getAttribute("data-delay-hide") || M.props.delayHide || 0,
                delayUpdate: v.getAttribute("data-delay-update") || M.props.delayUpdate || 0,
                border: (v.getAttribute("data-border") ? "true" === v.getAttribute("data-border") : M.props.border) || !1,
                borderClass: v.getAttribute("data-border-class") || M.props.borderClass || "border",
                extraClass: v.getAttribute("data-class") || M.props.class || M.props.className || "",
                disable: (v.getAttribute("data-tip-disable") ? "true" === v.getAttribute("data-tip-disable") : M.props.disable) || !1,
                currentTarget: v
              }, function () {
                l && M.addScrollListener(M.state.currentTarget), M.updateTooltip(c), t && Array.isArray(t) && (M.intervalUpdateContent = setInterval(function () {
                  if (M.mount) {
                    var c = M.props.getContent,
                        e = Ir(r, "", c[0](), i),
                        a = M.isEmptyTip(e);
                    M.setState({
                      isEmptyTip: a
                    }), M.updatePosition();
                  }
                }, t[1]));
              });
            };

            d ? this.delayReshow = setTimeout(p, d) : p();
          }
        }
      }, {
        key: "updateTooltip",
        value: function value(c) {
          var e = this,
              a = this.state,
              n = a.delayShow,
              t = a.disable,
              r = this.props,
              i = r.afterShow,
              o = r.disable,
              l = this.getTooltipContent(),
              f = c.currentTarget || c.target;

          if (!this.mouseOnToolTip() && !(this.isEmptyTip(l) || t || o)) {
            var s = this.state.show ? 0 : parseInt(n, 10),
                u = function u() {
              if (Array.isArray(l) && l.length > 0 || l) {
                var a = !e.state.show;
                e.setState({
                  currentEvent: c,
                  currentTarget: f,
                  show: !0
                }, function () {
                  e.updatePosition(function () {
                    a && i && i(c);
                  });
                });
              }
            };

            this.delayShowLoop && clearTimeout(this.delayShowLoop), s ? this.delayShowLoop = setTimeout(u, s) : (this.delayShowLoop = null, u());
          }
        }
      }, {
        key: "listenForTooltipExit",
        value: function value() {
          this.state.show && this.tooltipRef && this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
        }
      }, {
        key: "removeListenerForTooltipExit",
        value: function value() {
          this.state.show && this.tooltipRef && this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
        }
      }, {
        key: "hideTooltip",
        value: function value(c, e) {
          var a = this,
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
            isScroll: !1
          },
              t = this.state.disable,
              r = n.isScroll ? 0 : this.state.delayHide,
              i = this.props,
              o = i.afterHide,
              l = i.disable,
              f = this.getTooltipContent();

          if (this.mount && !(this.isEmptyTip(f) || t || l)) {
            if (e) if (!this.getTargetArray(this.props.id).some(function (e) {
              return e === c.currentTarget;
            }) || !this.state.show) return;
            c && c.currentTarget && c.currentTarget.removeAttribute && c.currentTarget.removeAttribute("aria-describedby");

            var s = function s() {
              var e = a.state.show;
              a.mouseOnToolTip() ? a.listenForTooltipExit() : (a.removeListenerForTooltipExit(), a.setState({
                show: !1
              }, function () {
                a.removeScrollListener(a.state.currentTarget), e && o && o(c);
              }));
            };

            this.clearTimer(), r ? this.delayHideLoop = setTimeout(s, parseInt(r, 10)) : s();
          }
        }
      }, {
        key: "hideTooltipOnScroll",
        value: function value(c, e) {
          this.hideTooltip(c, e, {
            isScroll: !0
          });
        }
      }, {
        key: "addScrollListener",
        value: function value(c) {
          var e = this.isCapture(c);
          window.addEventListener("scroll", this.hideTooltipOnScroll, e);
        }
      }, {
        key: "removeScrollListener",
        value: function value(c) {
          var e = this.isCapture(c);
          window.removeEventListener("scroll", this.hideTooltipOnScroll, e);
        }
      }, {
        key: "updatePosition",
        value: function value(c) {
          var e = this,
              a = this.state,
              n = a.currentEvent,
              t = a.currentTarget,
              r = a.place,
              i = a.desiredPlace,
              o = a.effect,
              l = a.offset,
              f = this.tooltipRef,
              s = Sr(n, t, f, r, i, o, l);
          if (s.position && this.props.overridePosition && (s.position = this.props.overridePosition(s.position, n, t, f, r, i, o, l)), s.isNewState) return this.setState(s.newState, function () {
            e.updatePosition(c);
          });
          c && "function" == typeof c && c(), f.style.left = s.position.left + "px", f.style.top = s.position.top + "px";
        }
      }, {
        key: "clearTimer",
        value: function value() {
          this.delayShowLoop && (clearTimeout(this.delayShowLoop), this.delayShowLoop = null), this.delayHideLoop && (clearTimeout(this.delayHideLoop), this.delayHideLoop = null), this.delayReshow && (clearTimeout(this.delayReshow), this.delayReshow = null), this.intervalUpdateContent && (clearInterval(this.intervalUpdateContent), this.intervalUpdateContent = null);
        }
      }, {
        key: "hasCustomColors",
        value: function value() {
          var c = this;
          return Boolean(Object.keys(this.state.customColors).find(function (e) {
            return "border" !== e && c.state.customColors[e];
          }) || this.state.border && this.state.customColors.border);
        }
      }, {
        key: "render",
        value: function value() {
          var c = this,
              e = this.state,
              a = e.extraClass,
              n = e.html,
              r = e.ariaProps,
              i = e.disable,
              o = e.uuid,
              f = this.getTooltipContent(),
              s = this.isEmptyTip(f),
              u = this.props.disableInternalStyle ? "" : Pr(this.state.uuid, this.state.customColors, this.state.type, this.state.border, this.state.padding, this.state.customRadius),
              m = "__react_component_tooltip" + " ".concat(this.state.uuid) + (!this.state.show || i || s ? "" : " show") + (this.state.border ? " " + this.state.borderClass : "") + " place-".concat(this.state.place) + " type-".concat(this.hasCustomColors() ? "custom" : this.state.type) + (this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : ""),
              v = this.props.wrapper;
          l.supportedWrappers.indexOf(v) < 0 && (v = l.defaultProps.wrapper);
          var d = [m, a].filter(Boolean).join(" ");

          if (n) {
            var M = "".concat(f).concat(u ? '\n<style aria-hidden="true">'.concat(u, "</style>") : "");
            return t.a.createElement(v, h({
              className: "".concat(d),
              id: this.props.id || o,
              ref: function ref(e) {
                return c.tooltipRef = e;
              }
            }, r, {
              "data-id": "tooltip",
              dangerouslySetInnerHTML: {
                __html: M
              }
            }));
          }

          return t.a.createElement(v, h({
            className: "".concat(d),
            id: this.props.id || o
          }, r, {
            ref: function ref(e) {
              return c.tooltipRef = e;
            },
            "data-id": "tooltip"
          }), u && t.a.createElement("style", {
            dangerouslySetInnerHTML: {
              __html: u
            },
            "aria-hidden": "true"
          }), f);
        }
      }]) && s(e.prototype, a), n && s(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), l;
    }(), "defaultProps", {
      insecure: !0,
      resizeHide: !0,
      wrapper: "div",
      clickable: !1
    }), u(Br, "supportedWrappers", ["div", "span"]), u(Br, "displayName", "ReactTooltip"), (Fr = Ur = Br).prototype.bindRemovalTracker = function () {
      var c = this,
          e = br();

      if (null != e) {
        var a = new e(function (e) {
          for (var a = 0; a < e.length; a++) {
            for (var n = e[a], t = 0; t < n.removedNodes.length; t++) {
              if (n.removedNodes[t] === c.state.currentTarget) return void c.hideTooltip();
            }
          }
        });
        a.observe(window.document, {
          childList: !0,
          subtree: !0
        }), this.removalTracker = a;
      }
    }, Ur = void (Fr.prototype.unbindRemovalTracker = function () {
      this.removalTracker && (this.removalTracker.disconnect(), this.removalTracker = null);
    }) || Ur)) || Ur) || Ur) || Ur) || Ur) || Ur) || Ur;
  }.call(this, a(18));
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (c) {
    var e = c.comments,
        a = c.onCommentChange,
        n = c.isVisible,
        t = c.characterLimit,
        i = c.t;
    return n ? r.default.createElement("div", {
      className: "approvals_form_notes"
    }, r.default.createElement("textarea", {
      style: {
        padding: "8px"
      },
      value: e,
      onChange: a,
      placeholder: i("approvalsFormNotes:addNotesToShopPlaceholder"),
      rows: "4"
    }), t && r.default.createElement("small", null, i("approvalsFormNotes:remainingCharactersLbl") + " " + (t - (e ? e.length : 0)))) : null;
  };
  var n,
      t = a(0),
      r = (n = t) && n.__esModule ? n : {
    default: n
  };
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (c) {
    var e = c.approverNotes,
        a = c.handleApproverChange,
        n = c.isVisible,
        t = c.characterLimit,
        o = c.t,
        l = c.handleSubmit,
        f = c.canAddApprovalNotes,
        s = c.isSubmitting;
    c.resetForm;
    return n ? r.default.createElement("div", {
      className: "approvals_form_fields_section__wrapper"
    }, r.default.createElement("div", {
      className: "approvals_form_fields_section"
    }, r.default.createElement("div", {
      className: "approvals_form_fields_section__header--secondary"
    }, o("approvalsFormNotes:approversNoteLabel")), r.default.createElement("div", {
      className: "approvals_form_approvers_notes"
    }, r.default.createElement(i.Form, null, r.default.createElement(i.Form.Group, null, r.default.createElement(i.Form.Field, {
      width: "12"
    }, r.default.createElement(i.Form.TextArea, {
      placeholder: o("approvalsFormNotes:addApprovalsNotesToShopPlaceholder"),
      name: "email",
      value: e,
      onChange: a,
      id: "form-textarea-control-approver-notes",
      rows: 3
    }), t && r.default.createElement("small", null, o("approvalsFormNotes:remainingCharactersLbl") + " " + (t - (e ? e.length : 0)))), f ? r.default.createElement(i.Button, {
      content: o("approvalsFormNotes:saveText"),
      size: "mini",
      onClick: function onClick() {
        l();
      },
      loading: s,
      disabled: s || 0 === e.length
    }) : r.default.createElement(i.Button, {
      size: "mini",
      content: o("approvalsFormNotes:saveText"),
      disabled: !f
    })))))) : null;
  };
  var n,
      t = a(0),
      r = (n = t) && n.__esModule ? n : {
    default: n
  },
      i = a(56);
}, function (c, e) {
  function a(c, e, a) {
    var n, t, r, i, o;

    function l() {
      var f = Date.now() - i;
      f < e && f >= 0 ? n = setTimeout(l, e - f) : (n = null, a || (o = c.apply(r, t), r = t = null));
    }

    null == e && (e = 100);

    var f = function f() {
      r = this, t = arguments, i = Date.now();
      var f = a && !n;
      return n || (n = setTimeout(l, e)), f && (o = c.apply(r, t), r = t = null), o;
    };

    return f.clear = function () {
      n && (clearTimeout(n), n = null);
    }, f.flush = function () {
      n && (o = c.apply(r, t), r = t = null, clearTimeout(n), n = null);
    }, f;
  }

  a.debounce = a, c.exports = a;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = l(t),
      i = (l(a(2)), l(a(35))),
      o = l(a(239));

  function l(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var f = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "render",
      value: function value() {
        var c = this.props.t;
        return r.default.createElement("div", {
          className: "approvals_empty_state"
        }, r.default.createElement(i.default, {
          className: "approvals_empty_state__icon",
          src: o.default
        }), r.default.createElement("p", {
          className: "approvals_empty_state__text"
        }, c("approvalsEmptyState:emptyStateMessage")));
      }
    }]), e;
  }();

  f.propTypes = {}, e.default = f;
}, function (c, e) {
  c.exports = "data:image/png;base64,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";
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (c) {
    var e = c.infoModalOpen,
        a = c.closeInfoModal,
        l = c.order,
        f = c.services,
        s = c.t;
    return null == f || null == l || 0 === f.length || l.status !== o.AWAITING_APPROVAL ? null : n.default.createElement(i.default, {
      isOpen: e,
      toggleModal: a,
      headerTitle: s("approvalsInfoModal:approveWorkText"),
      headerSubtitle: s("approvalsInfoModal:toGetServiceText")
    }, n.default.createElement("p", {
      style: {
        paddingTop: "20px",
        marginBottom: 0
      }
    }, s("approvalsInfoModal:approvalInfoDesc")), n.default.createElement("div", {
      style: {
        width: "100px",
        margin: "0 auto"
      }
    }, n.default.createElement("img", {
      src: r.default,
      alt: s("approvalsInfoModal:approvalToggleButtonAltText"),
      style: {
        height: "auto",
        width: "100%"
      }
    })), n.default.createElement(t.default, {
      key: "btn-close-modal",
      text: s("approvalsInfoModal:gotItText"),
      colorStyle: "orange",
      onClick: a,
      style: {
        width: "100px",
        padding: "0 10px",
        marginBottom: "10px"
      }
    }));
  };
  var n = l(a(0)),
      t = l(a(16)),
      r = l(a(241)),
      i = l(a(89)),
      o = a(12);

  function l(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }
}, function (c, e) {
  c.exports = "data:image/gif;base64,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";
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = p(t),
      i = a(90),
      o = p(a(91)),
      l = p(a(243)),
      f = p(a(244)),
      s = p(a(16)),
      u = p(a(245)),
      h = p(a(246)),
      m = p(a(247)),
      v = p(a(248)),
      d = a(37),
      M = a(249);

  function p(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  function z(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var C = function (c) {
    function e() {
      var c,
          a,
          n,
          t,
          r,
          i = this;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, l = Array(o), f = 0; f < o; f++) {
        l[f] = arguments[f];
      }

      return a = n = z(this, (c = e.__proto__ || Object.getPrototypeOf(e)).call.apply(c, [this].concat(l))), n.state = {
        hidingChrome: !1
      }, n.print = (t = _regeneratorRuntime.mark(function c(e) {
        return _regeneratorRuntime.wrap(function (c) {
          for (;;) {
            switch (c.prev = c.next) {
              case 0:
                return e.preventDefault(), null != window.analytics && (window.analytics.identify(n.props.user.id), window.analytics.track({
                  type: "track",
                  event: "Print Card Clicked",
                  properties: {
                    "shop instructions": "Process as CarAdvise National Account through Auto Integrate. 1-844-923-8473",
                    driver: n.props.name,
                    "VIN #": n.props.vehicle.vin
                  },
                  userId: n.props.user.id
                })), c.next = 4, n.setState({
                  hidingChrome: !0
                });

              case 4:
                return c.next = 6, n.props.hideChrome();

              case 6:
                return window.print(), c.next = 9, n.props.showChrome();

              case 9:
                return c.next = 11, n.setState({
                  hidingChrome: !1
                });

              case 11:
              case "end":
                return c.stop();
            }
          }
        }, c, i);
      }), r = function r() {
        var c = t.apply(this, arguments);
        return new Promise(function (e, a) {
          return function n(t, r) {
            try {
              var i = c[t](r),
                  o = i.value;
            } catch (c) {
              return void a(c);
            }

            if (!i.done) return Promise.resolve(o).then(function (c) {
              n("next", c);
            }, function (c) {
              n("throw", c);
            });
            e(o);
          }("next");
        });
      }, function (c) {
        return r.apply(this, arguments);
      }), z(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.PureComponent), n(e, [{
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.children,
            a = c.vehicle,
            n = c.name,
            t = (c.inceptionDate, c.primaryColor),
            p = c.logo,
            z = c.logoWidth,
            C = c.forceHideChrome,
            L = c.gradient,
            A = c.language,
            N = c.apple_wallet_url,
            g = c.google_wallet_url,
            H = r.default.createElement(o.default, {
          vehicle: a,
          name: n,
          logo: p,
          logoWidth: z,
          primaryColor: t,
          gradient: L
        }),
            V = r.default.createElement(l.default, {
          vehicle: a,
          name: n,
          logo: p,
          logoWidth: z,
          primaryColor: t,
          gradient: L
        }),
            x = r.default.createElement(f.default, {
          vehicle: a,
          name: n,
          logo: p,
          logoWidth: z,
          primaryColor: t,
          gradient: L
        }),
            w = H;
        return ((0, d.isFleetMaintenanceHub)() || (0, d.isFleetMaintenanceHubCanada)() || (0, d.isInstacartCanada)()) && (w = "fr" == A ? x : V), this.state.hidingChrome || C ? w : r.default.createElement(i.FullWidthGenericPanel, null, r.default.createElement("div", {
          className: "membership-panel"
        }, r.default.createElement("div", {
          style: {
            display: "flex",
            flex: 1,
            flexDirection: "column",
            alignItems: "center"
          }
        }, w, r.default.createElement("div", {
          className: "print-card-button"
        }, r.default.createElement(s.default, {
          colorStyle: "orange",
          text: "fr" == A ? "Imprimer la carte" : "Print Card",
          linkTo: "/printMembershipCard",
          onClick: this.print
        }), "fr" == A && r.default.createElement("div", {
          style: {
            padding: 10
          }
        }, M.isIOS && r.default.createElement("a", {
          href: g
        }, r.default.createElement("img", {
          src: h.default
        })), M.isIOS && r.default.createElement("a", {
          href: N
        }, r.default.createElement("img", {
          src: v.default
        }))), "fr" != A && r.default.createElement("div", {
          style: {
            padding: 10
          }
        }, M.isAndroid && r.default.createElement("a", {
          href: g
        }, r.default.createElement("img", {
          src: u.default
        })), M.isIOS && r.default.createElement("a", {
          href: N
        }, r.default.createElement("img", {
          src: m.default
        }))))), r.default.createElement("div", {
          style: {
            display: "flex",
            flex: 1,
            flexDirection: "column"
          }
        }, e)));
      }
    }]), e;
  }();

  e.default = C;
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (c) {
    var e = c.name,
        a = c.vehicle,
        t = c.primaryColor,
        r = c.logo,
        o = c.logoWidth,
        l = c.gradient;
    return n.default.createElement("div", {
      className: "membership-card",
      style: {
        borderWidth: "1px",
        borderStyle: "dashed",
        borderColor: t
      }
    }, n.default.createElement("div", {
      className: "membership-inner-card"
    }, n.default.createElement("div", {
      className: "membership-content-area"
    }, n.default.createElement("div", {
      className: "membership-top-area"
    }, n.default.createElement("div", {
      className: "membership-instructions-area"
    }, n.default.createElement("div", {
      className: "print-footer-container"
    }, o && n.default.createElement("div", {
      className: "print-footer",
      style: {
        background: r + " no-repeat center"
      }
    }, n.default.createElement("img", {
      src: "images/CarAdvise-Logo.png",
      height: "20"
    }))), n.default.createElement("p", {
      className: "membership-title"
    }, "Shop Instructions"), n.default.createElement("p", {
      className: "membership-subtitle-print"
    }, n.default.createElement("b", null, "Process as CarAdvise National Account:"), " ", n.default.createElement("br", null), n.default.createElement("span", {
      className: "membership-phone-number"
    }, " Call 1-844-923-8473 for approval")), n.default.createElement("p", {
      className: "membership-title"
    }, "Fleet Membership ID")), n.default.createElement("div", {
      className: "membership-name-and-vehicle"
    }, n.default.createElement("p", {
      className: "membership-name"
    }, n.default.createElement("b", null, "Driver:"), " ", e), n.default.createElement("p", {
      className: "membership-vehicle"
    }), n.default.createElement("p", {
      className: "membership-vehicle"
    }, a && "VIN: " + (a.vin || ""), n.default.createElement("div", {
      className: "membership-payment-infotext"
    }, "You will receive a text message to approve work. Pay CarAdvise. Do not pay the shop."))))), n.default.createElement(i, {
      gradient: l
    }, n.default.createElement("div", {
      className: "membership-footer-logo-container"
    }, o ? n.default.createElement("div", {
      className: "membership-footer-logo",
      style: {
        width: o,
        background: r + " no-repeat center"
      }
    }) : r))));
  };
  var n = r(a(0)),
      t = r(a(55));

  function r(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  function i(c) {
    var e = c.gradient,
        a = c.children,
        r = "to right,\n              " + e.start + ",\n              " + (e.mid ? e.mid + "," : "") + "\n              " + e.end;
    return n.default.createElement(t.default, null, ".membership-footer-logo-container {\n        background: -webkit-linear-gradient(\n          " + r + "\n        ); /* For Safari 5.1 to 6.0 */\n        background: -o-linear-gradient(\n          " + r + "\n        ); /* For Opera 11.1 to 12.0 */\n        background: -moz-linear-gradient(\n          " + r + "\n        ); /* For Firefox 3.6 to 15 */\n        background: linear-gradient(\n          " + r + "\n        );\n      }\n    )", a);
  }
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (c) {
    var e = c.name,
        a = c.vehicle,
        t = c.primaryColor,
        r = c.logo,
        o = c.logoWidth,
        l = c.gradient;
    return n.default.createElement("div", {
      className: "membership-card",
      style: {
        borderWidth: "1px",
        borderStyle: "dashed",
        borderColor: t
      }
    }, n.default.createElement("div", {
      className: "membership-inner-card"
    }, n.default.createElement("div", {
      className: "membership-content-area"
    }, n.default.createElement("div", {
      className: "membership-top-area"
    }, n.default.createElement("div", {
      className: "membership-instructions-area"
    }, n.default.createElement("div", {
      className: "print-footer-container"
    }, o && n.default.createElement("div", {
      className: "print-footer",
      style: {
        background: r + " no-repeat center"
      }
    }, n.default.createElement("img", {
      src: "images/CarAdvise-Logo.png",
      height: "20"
    }))), n.default.createElement("p", {
      className: "membership-title"
    }, "INSTRUCTIONS DE L’ATELIER (Shop Instructions)"), n.default.createElement("p", {
      className: "membership-subtitle-print"
    }, n.default.createElement("b", null, "Traiter comme Compte National CarAdvise:"), n.default.createElement("br", null), n.default.createElement("span", {
      className: "membership-phone-number"
    }, " Appelez le 1-844-923-8473  pour approbation"), n.default.createElement("br", null), n.default.createElement("small", null, "(Process as CarAdvise National Account: Call 1-844-923-8473 for approval)")), n.default.createElement("p", {
      className: "membership-title"
    }, "ID D'ADHÉSION À LA FLOTTE (Fleet Membership ID)")), n.default.createElement("div", {
      className: "membership-name-and-vehicle"
    }, n.default.createElement("p", {
      className: "membership-name"
    }, n.default.createElement("b", null, "Conducteur:"), " ", e, n.default.createElement("br", null), " ", n.default.createElement("small", null, "(Driver)"), " "), n.default.createElement("p", {
      className: "membership-vehicle"
    }), n.default.createElement("p", {
      className: "membership-vehicle"
    }, a && "VIN: " + (a.vin || ""), n.default.createElement("div", {
      className: "membership-payment-infotext"
    }, "Vous recevrez  un texte pour approuver le travail. Payez CarAdvise.", n.default.createElement("br", null), "Ne payez pas l'atelier.", n.default.createElement("br", null), n.default.createElement("small", null, "(You will receive a text message to approve work. Pay CarAdvise. Do not pay the shop.)")))))), n.default.createElement(i, {
      gradient: l
    }, n.default.createElement("div", {
      className: "membership-footer-logo-container"
    }, o ? n.default.createElement("div", {
      className: "membership-footer-logo",
      style: {
        width: o,
        background: r + " no-repeat center"
      }
    }) : r))));
  };
  var n = r(a(0)),
      t = r(a(55));

  function r(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  function i(c) {
    var e = c.gradient,
        a = c.children,
        r = "to right,\n              " + e.start + ",\n              " + (e.mid ? e.mid + "," : "") + "\n              " + e.end;
    return n.default.createElement(t.default, null, ".membership-footer-logo-container {\n        background: -webkit-linear-gradient(\n          " + r + "\n        ); /* For Safari 5.1 to 6.0 */\n        background: -o-linear-gradient(\n          " + r + "\n        ); /* For Opera 11.1 to 12.0 */\n        background: -moz-linear-gradient(\n          " + r + "\n        ); /* For Firefox 3.6 to 15 */\n        background: linear-gradient(\n          " + r + "\n        );\n      }\n    )", a);
  }
}, function (c, e) {
  c.exports = "data:image/svg+xml;base64,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";
}, function (c, e) {
  c.exports = "data:image/svg+xml;base64,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";
}, function (c, e) {
  c.exports = "data:image/svg+xml;base64,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";
}, function (c, e) {
  c.exports = "data:image/svg+xml;base64,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";
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n,
      t = a(0),
      r = (n = t) && "object" == typeof n && "default" in n ? n.default : n,
      i = a(250),
      o = new i(),
      l = o.getBrowser(),
      f = o.getCPU(),
      s = o.getDevice(),
      u = o.getEngine(),
      h = o.getOS(),
      m = o.getUA(),
      v = function v(c) {
    return o.setUA(c);
  },
      d = function d(c) {
    if (c) {
      var e = new i(c);
      return {
        UA: e,
        browser: e.getBrowser(),
        cpu: e.getCPU(),
        device: e.getDevice(),
        engine: e.getEngine(),
        os: e.getOS(),
        ua: e.getUA(),
        setUserAgent: function setUserAgent(c) {
          return e.setUA(c);
        }
      };
    }

    console.error("No userAgent string was provided");
  },
      M = Object.freeze({
    ClientUAInstance: o,
    browser: l,
    cpu: f,
    device: s,
    engine: u,
    os: h,
    ua: m,
    setUa: v,
    parseUserAgent: d
  });

  function p(c, e) {
    var a = Object.keys(c);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(c);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(c, e).enumerable;
      })), a.push.apply(a, n);
    }

    return a;
  }

  function z(c) {
    return (z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (c) {
      return typeof c;
    } : function (c) {
      return c && "function" == typeof Symbol && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
    })(c);
  }

  function C(c, e) {
    for (var a = 0; a < e.length; a++) {
      var n = e[a];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
    }
  }

  function L(c, e, a) {
    return e in c ? Object.defineProperty(c, e, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[e] = a, c;
  }

  function A() {
    return (A = Object.assign || function (c) {
      for (var e = 1; e < arguments.length; e++) {
        var a = arguments[e];

        for (var n in a) {
          Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
        }
      }

      return c;
    }).apply(this, arguments);
  }

  function N(c) {
    return (N = Object.setPrototypeOf ? Object.getPrototypeOf : function (c) {
      return c.__proto__ || Object.getPrototypeOf(c);
    })(c);
  }

  function g(c, e) {
    return (g = Object.setPrototypeOf || function (c, e) {
      return c.__proto__ = e, c;
    })(c, e);
  }

  function H(c, e) {
    if (null == c) return {};

    var a,
        n,
        t = function (c, e) {
      if (null == c) return {};
      var a,
          n,
          t = {},
          r = Object.keys(c);

      for (n = 0; n < r.length; n++) {
        a = r[n], e.indexOf(a) >= 0 || (t[a] = c[a]);
      }

      return t;
    }(c, e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(c);

      for (n = 0; n < r.length; n++) {
        a = r[n], e.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(c, a) && (t[a] = c[a]);
      }
    }

    return t;
  }

  function V(c) {
    if (void 0 === c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return c;
  }

  function x(c, e) {
    return function (c) {
      if (Array.isArray(c)) return c;
    }(c) || function (c, e) {
      var a = null == c ? null : "undefined" != typeof Symbol && c[Symbol.iterator] || c["@@iterator"];
      if (null == a) return;
      var n,
          t,
          r = [],
          i = !0,
          o = !1;

      try {
        for (a = a.call(c); !(i = (n = a.next()).done) && (r.push(n.value), !e || r.length !== e); i = !0) {
          ;
        }
      } catch (c) {
        o = !0, t = c;
      } finally {
        try {
          i || null == a.return || a.return();
        } finally {
          if (o) throw t;
        }
      }

      return r;
    }(c, e) || function (c, e) {
      if (!c) return;
      if ("string" == typeof c) return w(c, e);
      var a = Object.prototype.toString.call(c).slice(8, -1);
      "Object" === a && c.constructor && (a = c.constructor.name);
      if ("Map" === a || "Set" === a) return Array.from(c);
      if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return w(c, e);
    }(c, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function w(c, e) {
    (null == e || e > c.length) && (e = c.length);

    for (var a = 0, n = new Array(e); a < e; a++) {
      n[a] = c[a];
    }

    return n;
  }

  var y = "mobile",
      b = "tablet",
      S = "smarttv",
      T = "console",
      D = "wearable",
      j = "embedded",
      E = void 0,
      k = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
  },
      I = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
  },
      O = {
    isMobile: !1,
    isTablet: !1,
    isBrowser: !1,
    isSmartTV: !1,
    isConsole: !1,
    isWearable: !1
  },
      Q = function Q(c) {
    switch (c) {
      case y:
        return {
          isMobile: !0
        };

      case b:
        return {
          isTablet: !0
        };

      case S:
        return {
          isSmartTV: !0
        };

      case T:
        return {
          isConsole: !0
        };

      case D:
        return {
          isWearable: !0
        };

      case E:
        return {
          isBrowser: !0
        };

      case j:
        return {
          isEmbedded: !0
        };

      default:
        return O;
    }
  },
      Z = function Z(c) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "none";
    return c || e;
  },
      U = function U() {
    return !("undefined" == typeof window || !window.navigator && !navigator) && (window.navigator || navigator);
  },
      B = function B(c) {
    var e = U();
    return e && e.platform && (-1 !== e.platform.indexOf(c) || "MacIntel" === e.platform && e.maxTouchPoints > 1 && !window.MSStream);
  },
      R = function R(c, e, a, n, t) {
    return {
      isBrowser: c,
      browserMajorVersion: Z(e.major),
      browserFullVersion: Z(e.version),
      browserName: Z(e.name),
      engineName: Z(a.name),
      engineVersion: Z(a.version),
      osName: Z(n.name),
      osVersion: Z(n.version),
      userAgent: Z(t)
    };
  },
      Y = function Y(c, e, a, n) {
    return function (c) {
      for (var e = 1; e < arguments.length; e++) {
        var a = null != arguments[e] ? arguments[e] : {};
        e % 2 ? p(Object(a), !0).forEach(function (e) {
          L(c, e, a[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(a)) : p(Object(a)).forEach(function (e) {
          Object.defineProperty(c, e, Object.getOwnPropertyDescriptor(a, e));
        });
      }

      return c;
    }({}, c, {
      vendor: Z(e.vendor),
      model: Z(e.model),
      os: Z(a.name),
      osVersion: Z(a.version),
      ua: Z(n)
    });
  },
      P = function P(c, e, a, n) {
    return {
      isSmartTV: c,
      engineName: Z(e.name),
      engineVersion: Z(e.version),
      osName: Z(a.name),
      osVersion: Z(a.version),
      userAgent: Z(n)
    };
  },
      F = function F(c, e, a, n) {
    return {
      isConsole: c,
      engineName: Z(e.name),
      engineVersion: Z(e.version),
      osName: Z(a.name),
      osVersion: Z(a.version),
      userAgent: Z(n)
    };
  },
      W = function W(c, e, a, n) {
    return {
      isWearable: c,
      engineName: Z(e.name),
      engineVersion: Z(e.version),
      osName: Z(a.name),
      osVersion: Z(a.version),
      userAgent: Z(n)
    };
  },
      G = function G(c, e, a, n, t) {
    return {
      isEmbedded: c,
      vendor: Z(e.vendor),
      model: Z(e.model),
      engineName: Z(a.name),
      engineVersion: Z(a.version),
      osName: Z(n.name),
      osVersion: Z(n.version),
      userAgent: Z(t)
    };
  };

  var q = function q(c) {
    return c.type === y;
  },
      J = function J(c) {
    return c.type === b;
  },
      K = function K(c) {
    var e = c.type;
    return e === y || e === b;
  },
      X = function X(c) {
    return c.type === S;
  },
      _ = function _(c) {
    return c.type === E;
  },
      $ = function $(c) {
    return c.type === D;
  },
      cc = function cc(c) {
    return c.type === T;
  },
      ec = function ec(c) {
    return c.type === j;
  },
      ac = function ac(c) {
    var e = c.vendor;
    return Z(e);
  },
      nc = function nc(c) {
    var e = c.model;
    return Z(e);
  },
      tc = function tc(c) {
    var e = c.type;
    return Z(e, "browser");
  },
      rc = function rc(c) {
    return c.name === I.Android;
  },
      ic = function ic(c) {
    return c.name === I.Windows;
  },
      oc = function oc(c) {
    return c.name === I.MAC_OS;
  },
      lc = function lc(c) {
    return c.name === I.WindowsPhone;
  },
      fc = function fc(c) {
    return c.name === I.IOS;
  },
      sc = function sc(c) {
    var e = c.version;
    return Z(e);
  },
      uc = function uc(c) {
    var e = c.name;
    return Z(e);
  },
      hc = function hc(c) {
    return c.name === k.Chrome;
  },
      mc = function mc(c) {
    return c.name === k.Firefox;
  },
      vc = function vc(c) {
    return c.name === k.Chromium;
  },
      dc = function dc(c) {
    return c.name === k.Edge;
  },
      Mc = function Mc(c) {
    return c.name === k.Yandex;
  },
      pc = function pc(c) {
    var e = c.name;
    return e === k.Safari || e === k.MobileSafari;
  },
      zc = function zc(c) {
    return c.name === k.MobileSafari;
  },
      Cc = function Cc(c) {
    return c.name === k.Opera;
  },
      Lc = function Lc(c) {
    var e = c.name;
    return e === k.InternetExplorer || e === k.Ie;
  },
      Ac = function Ac(c) {
    return c.name === k.MIUI;
  },
      Nc = function Nc(c) {
    return c.name === k.SamsungBrowser;
  },
      gc = function gc(c) {
    var e = c.version;
    return Z(e);
  },
      Hc = function Hc(c) {
    var e = c.major;
    return Z(e);
  },
      Vc = function Vc(c) {
    var e = c.name;
    return Z(e);
  },
      xc = function xc(c) {
    var e = c.name;
    return Z(e);
  },
      wc = function wc(c) {
    var e = c.version;
    return Z(e);
  },
      yc = function yc() {
    var c = U(),
        e = c && c.userAgent && c.userAgent.toLowerCase();
    return "string" == typeof e && /electron/.test(e);
  },
      bc = function bc(c) {
    return "string" == typeof c && -1 !== c.indexOf("Edg/");
  },
      Sc = function Sc() {
    var c = U();
    return c && (/iPad|iPhone|iPod/.test(c.platform) || "MacIntel" === c.platform && c.maxTouchPoints > 1) && !window.MSStream;
  },
      Tc = function Tc() {
    return B("iPad");
  },
      Dc = function Dc() {
    return B("iPhone");
  },
      jc = function jc() {
    return B("iPod");
  },
      Ec = function Ec(c) {
    return Z(c);
  };

  function kc(c) {
    var e = c || M,
        a = e.device,
        n = e.browser,
        t = e.os,
        r = e.engine,
        i = e.ua;
    return {
      isSmartTV: X(a),
      isConsole: cc(a),
      isWearable: $(a),
      isEmbedded: ec(a),
      isMobileSafari: zc(n) || Tc(),
      isChromium: vc(n),
      isMobile: K(a) || Tc(),
      isMobileOnly: q(a),
      isTablet: J(a) || Tc(),
      isBrowser: _(a),
      isDesktop: _(a),
      isAndroid: rc(t),
      isWinPhone: lc(t),
      isIOS: fc(t) || Tc(),
      isChrome: hc(n),
      isFirefox: mc(n),
      isSafari: pc(n),
      isOpera: Cc(n),
      isIE: Lc(n),
      osVersion: sc(t),
      osName: uc(t),
      fullBrowserVersion: gc(n),
      browserVersion: Hc(n),
      browserName: Vc(n),
      mobileVendor: ac(a),
      mobileModel: nc(a),
      engineName: xc(r),
      engineVersion: wc(r),
      getUA: Ec(i),
      isEdge: dc(n) || bc(i),
      isYandex: Mc(n),
      deviceType: tc(a),
      isIOS13: Sc(),
      isIPad13: Tc(),
      isIPhone13: Dc(),
      isIPod13: jc(),
      isElectron: yc(),
      isEdgeChromium: bc(i),
      isLegacyEdge: dc(n) && !bc(i),
      isWindows: ic(t),
      isMacOs: oc(t),
      isMIUI: Ac(n),
      isSamsungBrowser: Nc(n)
    };
  }

  var Ic = X(s),
      Oc = cc(s),
      Qc = $(s),
      Zc = ec(s),
      Uc = zc(l) || Tc(),
      Bc = vc(l),
      Rc = K(s) || Tc(),
      Yc = q(s),
      Pc = J(s) || Tc(),
      Fc = _(s),
      Wc = _(s),
      Gc = rc(h),
      qc = lc(h),
      Jc = fc(h) || Tc(),
      Kc = hc(l),
      Xc = mc(l),
      _c = pc(l),
      $c = Cc(l),
      ce = Lc(l),
      ee = sc(h),
      ae = uc(h),
      ne = gc(l),
      te = Hc(l),
      re = Vc(l),
      ie = ac(s),
      oe = nc(s),
      le = xc(u),
      fe = wc(u),
      se = Ec(m),
      ue = dc(l) || bc(m),
      he = Mc(l),
      me = tc(s),
      ve = Sc(),
      de = Tc(),
      Me = Dc(),
      pe = jc(),
      ze = yc(),
      Ce = bc(m),
      Le = dc(l) && !bc(m),
      Ae = ic(h),
      Ne = oc(h),
      ge = Ac(l),
      He = Nc(l);

  function Ve(c) {
    var e = c || window.navigator.userAgent;
    return d(e);
  }

  e.AndroidView = function (c) {
    var e = c.renderWithFragment,
        a = c.children,
        n = H(c, ["renderWithFragment", "children"]);
    return Gc ? e ? r.createElement(t.Fragment, null, a) : r.createElement("div", n, a) : null;
  }, e.BrowserTypes = k, e.BrowserView = function (c) {
    var e = c.renderWithFragment,
        a = c.children,
        n = H(c, ["renderWithFragment", "children"]);
    return Fc ? e ? r.createElement(t.Fragment, null, a) : r.createElement("div", n, a) : null;
  }, e.ConsoleView = function (c) {
    var e = c.renderWithFragment,
        a = c.children,
        n = H(c, ["renderWithFragment", "children"]);
    return Oc ? e ? r.createElement(t.Fragment, null, a) : r.createElement("div", n, a) : null;
  }, e.CustomView = function (c) {
    var e = c.renderWithFragment,
        a = c.children,
        n = (c.viewClassName, c.style, c.condition),
        i = H(c, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
    return n ? e ? r.createElement(t.Fragment, null, a) : r.createElement("div", i, a) : null;
  }, e.IEView = function (c) {
    var e = c.renderWithFragment,
        a = c.children,
        n = H(c, ["renderWithFragment", "children"]);
    return ce ? e ? r.createElement(t.Fragment, null, a) : r.createElement("div", n, a) : null;
  }, e.IOSView = function (c) {
    var e = c.renderWithFragment,
        a = c.children,
        n = H(c, ["renderWithFragment", "children"]);
    return Jc ? e ? r.createElement(t.Fragment, null, a) : r.createElement("div", n, a) : null;
  }, e.MobileOnlyView = function (c) {
    var e = c.renderWithFragment,
        a = c.children,
        n = (c.viewClassName, c.style, H(c, ["renderWithFragment", "children", "viewClassName", "style"]));
    return Yc ? e ? r.createElement(t.Fragment, null, a) : r.createElement("div", n, a) : null;
  }, e.MobileView = function (c) {
    var e = c.renderWithFragment,
        a = c.children,
        n = H(c, ["renderWithFragment", "children"]);
    return Rc ? e ? r.createElement(t.Fragment, null, a) : r.createElement("div", n, a) : null;
  }, e.OsTypes = I, e.SmartTVView = function (c) {
    var e = c.renderWithFragment,
        a = c.children,
        n = H(c, ["renderWithFragment", "children"]);
    return Ic ? e ? r.createElement(t.Fragment, null, a) : r.createElement("div", n, a) : null;
  }, e.TabletView = function (c) {
    var e = c.renderWithFragment,
        a = c.children,
        n = H(c, ["renderWithFragment", "children"]);
    return Pc ? e ? r.createElement(t.Fragment, null, a) : r.createElement("div", n, a) : null;
  }, e.WearableView = function (c) {
    var e = c.renderWithFragment,
        a = c.children,
        n = H(c, ["renderWithFragment", "children"]);
    return Qc ? e ? r.createElement(t.Fragment, null, a) : r.createElement("div", n, a) : null;
  }, e.WinPhoneView = function (c) {
    var e = c.renderWithFragment,
        a = c.children,
        n = H(c, ["renderWithFragment", "children"]);
    return qc ? e ? r.createElement(t.Fragment, null, a) : r.createElement("div", n, a) : null;
  }, e.browserName = re, e.browserVersion = te, e.deviceDetect = function (c) {
    var e = c ? d(c) : M,
        a = e.device,
        n = e.browser,
        t = e.engine,
        r = e.os,
        i = e.ua,
        o = Q(a.type),
        l = o.isBrowser,
        f = o.isMobile,
        s = o.isTablet,
        u = o.isSmartTV,
        h = o.isConsole,
        m = o.isWearable,
        v = o.isEmbedded;
    return l ? R(l, n, t, r, i) : u ? P(u, t, r, i) : h ? F(h, t, r, i) : f ? Y(o, a, r, i) : s ? Y(o, a, r, i) : m ? W(m, t, r, i) : v ? G(v, a, t, r, i) : void 0;
  }, e.deviceType = me, e.engineName = le, e.engineVersion = fe, e.fullBrowserVersion = ne, e.getSelectorsByUserAgent = function (c) {
    if (c && "string" == typeof c) {
      var e = d(c);
      return kc({
        device: e.device,
        browser: e.browser,
        os: e.os,
        engine: e.engine,
        ua: e.ua
      });
    }

    console.error("No valid user agent string was provided");
  }, e.getUA = se, e.isAndroid = Gc, e.isBrowser = Fc, e.isChrome = Kc, e.isChromium = Bc, e.isConsole = Oc, e.isDesktop = Wc, e.isEdge = ue, e.isEdgeChromium = Ce, e.isElectron = ze, e.isEmbedded = Zc, e.isFirefox = Xc, e.isIE = ce, e.isIOS = Jc, e.isIOS13 = ve, e.isIPad13 = de, e.isIPhone13 = Me, e.isIPod13 = pe, e.isLegacyEdge = Le, e.isMIUI = ge, e.isMacOs = Ne, e.isMobile = Rc, e.isMobileOnly = Yc, e.isMobileSafari = Uc, e.isOpera = $c, e.isSafari = _c, e.isSamsungBrowser = He, e.isSmartTV = Ic, e.isTablet = Pc, e.isWearable = Qc, e.isWinPhone = qc, e.isWindows = Ae, e.isYandex = he, e.mobileModel = oe, e.mobileVendor = ie, e.osName = ae, e.osVersion = ee, e.parseUserAgent = d, e.setUserAgent = function (c) {
    return v(c);
  }, e.useDeviceData = Ve, e.useDeviceSelectors = function (c) {
    var e = Ve(c || window.navigator.userAgent);
    return [kc(e), e];
  }, e.useMobileOrientation = function () {
    var c = x(t.useState(function () {
      var c = window.innerWidth > window.innerHeight ? 90 : 0;
      return {
        isPortrait: 0 === c,
        isLandscape: 90 === c,
        orientation: 0 === c ? "portrait" : "landscape"
      };
    }), 2),
        e = c[0],
        a = c[1],
        n = t.useCallback(function () {
      var c = window.innerWidth > window.innerHeight ? 90 : 0,
          n = {
        isPortrait: 0 === c,
        isLandscape: 90 === c,
        orientation: 0 === c ? "portrait" : "landscape"
      };
      e.orientation !== n.orientation && a(n);
    }, [e.orientation]);
    return t.useEffect(function () {
      return void 0 !== ("undefined" == typeof window ? "undefined" : z(window)) && Rc && (n(), window.addEventListener("load", n, !1), window.addEventListener("resize", n, !1)), function () {
        window.removeEventListener("resize", n, !1), window.removeEventListener("load", n, !1);
      };
    }, [n]), e;
  }, e.withOrientationChange = function (c) {
    return function (e) {
      function a(c) {
        var e;
        return function (c, e) {
          if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, a), (e = function (c, e) {
          if (e && ("object" == typeof e || "function" == typeof e)) return e;
          if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
          return V(c);
        }(this, N(a).call(this, c))).isEventListenerAdded = !1, e.handleOrientationChange = e.handleOrientationChange.bind(V(e)), e.onOrientationChange = e.onOrientationChange.bind(V(e)), e.onPageLoad = e.onPageLoad.bind(V(e)), e.state = {
          isLandscape: !1,
          isPortrait: !1
        }, e;
      }

      var n, t, i;
      return function (c, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        c.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: c,
            writable: !0,
            configurable: !0
          }
        }), e && g(c, e);
      }(a, r.Component), n = a, (t = [{
        key: "handleOrientationChange",
        value: function value() {
          this.isEventListenerAdded || (this.isEventListenerAdded = !0);
          var c = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: 0 === c,
            isLandscape: 90 === c
          });
        }
      }, {
        key: "onOrientationChange",
        value: function value() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function value() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function value() {
          void 0 !== ("undefined" == typeof window ? "undefined" : z(window)) && Rc && (this.isEventListenerAdded ? window.removeEventListener("load", this.onPageLoad, !1) : (this.handleOrientationChange(), window.addEventListener("load", this.onPageLoad, !1)), window.addEventListener("resize", this.onOrientationChange, !1));
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          window.removeEventListener("resize", this.onOrientationChange, !1);
        }
      }, {
        key: "render",
        value: function value() {
          return r.createElement(c, A({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]) && C(n.prototype, t), i && C(n, i), a;
    }();
  };
}, function (c, e, a) {
  var n;
  !function (t, r) {
    "use strict";

    var i = "model",
        o = "name",
        l = "type",
        f = "vendor",
        s = "version",
        u = "mobile",
        h = "tablet",
        m = "smarttv",
        v = function v(c) {
      for (var e = {}, a = 0; a < c.length; a++) {
        e[c[a].toUpperCase()] = c[a];
      }

      return e;
    },
        d = function d(c, e) {
      return "string" == typeof c && -1 !== M(e).indexOf(M(c));
    },
        M = function M(c) {
      return c.toLowerCase();
    },
        p = function p(c, e) {
      if ("string" == typeof c) return c = c.replace(/^\s\s*/, "").replace(/\s\s*$/, ""), void 0 === e ? c : c.substring(0, 350);
    },
        z = function z(c, e) {
      for (var a, n, t, r, i, o, l = 0; l < e.length && !i;) {
        var f = e[l],
            s = e[l + 1];

        for (a = n = 0; a < f.length && !i;) {
          if (i = f[a++].exec(c)) for (t = 0; t < s.length; t++) {
            o = i[++n], "object" == typeof (r = s[t]) && r.length > 0 ? 2 === r.length ? "function" == typeof r[1] ? this[r[0]] = r[1].call(this, o) : this[r[0]] = r[1] : 3 === r.length ? "function" != typeof r[1] || r[1].exec && r[1].test ? this[r[0]] = o ? o.replace(r[1], r[2]) : void 0 : this[r[0]] = o ? r[1].call(this, o, r[2]) : void 0 : 4 === r.length && (this[r[0]] = o ? r[3].call(this, o.replace(r[1], r[2])) : void 0) : this[r] = o || void 0;
          }
        }

        l += 2;
      }
    },
        C = function C(c, e) {
      for (var a in e) {
        if ("object" == typeof e[a] && e[a].length > 0) {
          for (var n = 0; n < e[a].length; n++) {
            if (d(e[a][n], c)) return "?" === a ? void 0 : a;
          }
        } else if (d(e[a], c)) return "?" === a ? void 0 : a;
      }

      return c;
    },
        L = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2000: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      8.1: "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    },
        A = {
      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [s, [o, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [s, [o, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [o, s], [/opios[\/ ]+([\w\.]+)/i], [s, [o, "Opera Mini"]], [/\bopr\/([\w\.]+)/i], [s, [o, "Opera"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, /(ba?idubrowser)[\/ ]?([\w\.]+)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(weibo)__([\d\.]+)/i], [o, s], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [s, [o, "UCBrowser"]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i], [s, [o, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i], [s, [o, "WeChat"]], [/konqueror\/([\w\.]+)/i], [s, [o, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [s, [o, "IE"]], [/yabrowser\/([\w\.]+)/i], [s, [o, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i], [[o, /(.+)/, "$1 Secure Browser"], s], [/\bfocus\/([\w\.]+)/i], [s, [o, "Firefox Focus"]], [/\bopt\/([\w\.]+)/i], [s, [o, "Opera Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [s, [o, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [s, [o, "Dolphin"]], [/coast\/([\w\.]+)/i], [s, [o, "Opera Coast"]], [/miuibrowser\/([\w\.]+)/i], [s, [o, "MIUI Browser"]], [/fxios\/([-\w\.]+)/i], [s, [o, "Firefox"]], [/\bqihu|(qi?ho?o?|360)browser/i], [[o, "360 Browser"]], [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i], [[o, /(.+)/, "$1 Browser"], s], [/(comodo_dragon)\/([\w\.]+)/i], [[o, /_/g, " "], s], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i], [o, s], [/(metasr)[\/ ]?([\w\.]+)/i, /(lbbrowser)/i, /\[(linkedin)app\]/i], [o], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[o, "Facebook"], s], [/safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(chromium|instagram)[\/ ]([-\w\.]+)/i], [o, s], [/\bgsa\/([\w\.]+) .*safari\//i], [s, [o, "GSA"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [s, [o, "Chrome Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[o, "Chrome WebView"], s], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [s, [o, "Android Browser"]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [o, s], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [s, [o, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [s, o], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [o, [s, C, {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      }]], [/(webkit|khtml)\/([\w\.]+)/i], [o, s], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[o, "Netscape"], s], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [s, [o, "Firefox Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i], [o, s]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [["architecture", "amd64"]], [/(ia32(?=;))/i], [["architecture", M]], [/((?:i[346]|x)86)[;\)]/i], [["architecture", "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [["architecture", "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [["architecture", "armhf"]], [/windows (ce|mobile); ppc;/i], [["architecture", "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [["architecture", /ower/, "", M]], [/(sun4\w)[;\)]/i], [["architecture", "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [["architecture", M]]],
      device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [i, [f, "Samsung"], [l, h]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [i, [f, "Samsung"], [l, u]], [/\((ip(?:hone|od)[\w ]*);/i], [i, [f, "Apple"], [l, u]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [i, [f, "Apple"], [l, h]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [i, [f, "Huawei"], [l, h]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [i, [f, "Huawei"], [l, u]], [/\b(poco[\w ]+)(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[i, /_/g, " "], [f, "Xiaomi"], [l, u]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[i, /_/g, " "], [f, "Xiaomi"], [l, h]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [i, [f, "OPPO"], [l, u]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [i, [f, "Vivo"], [l, u]], [/\b(rmx[12]\d{3})(?: bui|;|\))/i], [i, [f, "Realme"], [l, u]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [i, [f, "Motorola"], [l, u]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [i, [f, "Motorola"], [l, h]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [i, [f, "LG"], [l, h]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [i, [f, "LG"], [l, u]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [i, [f, "Lenovo"], [l, h]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[i, /_/g, " "], [f, "Nokia"], [l, u]], [/(pixel c)\b/i], [i, [f, "Google"], [l, h]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [i, [f, "Google"], [l, u]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [i, [f, "Sony"], [l, u]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[i, "Xperia Tablet"], [f, "Sony"], [l, h]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [i, [f, "OnePlus"], [l, u]], [/(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [i, [f, "Amazon"], [l, h]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[i, /(.+)/g, "Fire Phone $1"], [f, "Amazon"], [l, u]], [/(playbook);[-\w\),; ]+(rim)/i], [i, f, [l, h]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [i, [f, "BlackBerry"], [l, u]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [i, [f, "ASUS"], [l, h]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [i, [f, "ASUS"], [l, u]], [/(nexus 9)/i], [i, [f, "HTC"], [l, h]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i], [f, [i, /_/g, " "], [l, u]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [i, [f, "Acer"], [l, h]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [i, [f, "Meizu"], [l, u]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [i, [f, "Sharp"], [l, u]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [f, i, [l, u]], [/(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [f, i, [l, h]], [/(surface duo)/i], [i, [f, "Microsoft"], [l, h]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [i, [f, "Fairphone"], [l, u]], [/(u304aa)/i], [i, [f, "AT&T"], [l, u]], [/\bsie-(\w*)/i], [i, [f, "Siemens"], [l, u]], [/\b(rct\w+) b/i], [i, [f, "RCA"], [l, h]], [/\b(venue[\d ]{2,7}) b/i], [i, [f, "Dell"], [l, h]], [/\b(q(?:mv|ta)\w+) b/i], [i, [f, "Verizon"], [l, h]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [i, [f, "Barnes & Noble"], [l, h]], [/\b(tm\d{3}\w+) b/i], [i, [f, "NuVision"], [l, h]], [/\b(k88) b/i], [i, [f, "ZTE"], [l, h]], [/\b(nx\d{3}j) b/i], [i, [f, "ZTE"], [l, u]], [/\b(gen\d{3}) b.+49h/i], [i, [f, "Swiss"], [l, u]], [/\b(zur\d{3}) b/i], [i, [f, "Swiss"], [l, h]], [/\b((zeki)?tb.*\b) b/i], [i, [f, "Zeki"], [l, h]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[f, "Dragon Touch"], i, [l, h]], [/\b(ns-?\w{0,9}) b/i], [i, [f, "Insignia"], [l, h]], [/\b((nxa|next)-?\w{0,9}) b/i], [i, [f, "NextBook"], [l, h]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[f, "Voice"], i, [l, u]], [/\b(lvtel\-)?(v1[12]) b/i], [[f, "LvTel"], i, [l, u]], [/\b(ph-1) /i], [i, [f, "Essential"], [l, u]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [i, [f, "Envizen"], [l, h]], [/\b(trio[-\w\. ]+) b/i], [i, [f, "MachSpeed"], [l, h]], [/\btu_(1491) b/i], [i, [f, "Rotor"], [l, h]], [/(shield[\w ]+) b/i], [i, [f, "Nvidia"], [l, h]], [/(sprint) (\w+)/i], [f, i, [l, u]], [/(kin\.[onetw]{3})/i], [[i, /\./g, " "], [f, "Microsoft"], [l, u]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [i, [f, "Zebra"], [l, h]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [i, [f, "Zebra"], [l, u]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [f, i, [l, "console"]], [/droid.+; (shield) bui/i], [i, [f, "Nvidia"], [l, "console"]], [/(playstation [345portablevi]+)/i], [i, [f, "Sony"], [l, "console"]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [i, [f, "Microsoft"], [l, "console"]], [/smart-tv.+(samsung)/i], [f, [l, m]], [/hbbtv.+maple;(\d+)/i], [[i, /^/, "SmartTV"], [f, "Samsung"], [l, m]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[f, "LG"], [l, m]], [/(apple) ?tv/i], [f, [i, "Apple TV"], [l, m]], [/crkey/i], [[i, "Chromecast"], [f, "Google"], [l, m]], [/droid.+aft(\w)( bui|\))/i], [i, [f, "Amazon"], [l, m]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [i, [f, "Sharp"], [l, m]], [/(bravia[\w ]+)( bui|\))/i], [i, [f, "Sony"], [l, m]], [/(mitv-\w{5}) bui/i], [i, [f, "Xiaomi"], [l, m]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i], [[f, p], [i, p], [l, m]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[l, m]], [/((pebble))app/i], [f, i, [l, "wearable"]], [/droid.+; (glass) \d/i], [i, [f, "Google"], [l, "wearable"]], [/droid.+; (wt63?0{2,3})\)/i], [i, [f, "Zebra"], [l, "wearable"]], [/(quest( 2)?)/i], [i, [f, "Facebook"], [l, "wearable"]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [f, [l, "embedded"]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i], [i, [l, u]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [i, [l, h]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[l, h]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[l, u]], [/(android[-\w\. ]{0,9});.+buil/i], [i, [f, "Generic"]]],
      engine: [[/windows.+ edge\/([\w\.]+)/i], [s, [o, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [s, [o, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i], [o, s], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [s, o]],
      os: [[/microsoft (windows) (vista|xp)/i], [o, s], [/(windows) nt 6\.2; (arm)/i, /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [o, [s, C, L]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[o, "Windows"], [s, C, L]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /cfnetwork\/.+darwin/i], [[s, /_/g, "."], [o, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[o, "Mac OS"], [s, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [s, o], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [o, s], [/\(bb(10);/i], [s, [o, "BlackBerry"]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [s, [o, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [s, [o, "Firefox OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [s, [o, "webOS"]], [/crkey\/([\d\.]+)/i], [s, [o, "Chromecast"]], [/(cros) [\w]+ ([\w\.]+\w)/i], [[o, "Chromium OS"], s], [/(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [o, s], [/(sunos) ?([\w\.\d]*)/i], [[o, "Solaris"], s], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i, /(unix) ?([\w\.]*)/i], [o, s]]
    },
        N = function N(c, e) {
      if ("object" == typeof c && (e = c, c = void 0), !(this instanceof N)) return new N(c, e).getResult();
      var a = c || (void 0 !== t && t.navigator && t.navigator.userAgent ? t.navigator.userAgent : ""),
          n = e ? function (c, e) {
        var a = {};

        for (var n in c) {
          e[n] && e[n].length % 2 == 0 ? a[n] = e[n].concat(c[n]) : a[n] = c[n];
        }

        return a;
      }(A, e) : A;
      return this.getBrowser = function () {
        var c,
            e = {};
        return e.name = void 0, e.version = void 0, z.call(e, a, n.browser), e.major = "string" == typeof (c = e.version) ? c.replace(/[^\d\.]/g, "").split(".")[0] : void 0, e;
      }, this.getCPU = function () {
        var c = {
          architecture: void 0
        };
        return z.call(c, a, n.cpu), c;
      }, this.getDevice = function () {
        var c = {
          vendor: void 0,
          model: void 0,
          type: void 0
        };
        return z.call(c, a, n.device), c;
      }, this.getEngine = function () {
        var c = {
          name: void 0,
          version: void 0
        };
        return z.call(c, a, n.engine), c;
      }, this.getOS = function () {
        var c = {
          name: void 0,
          version: void 0
        };
        return z.call(c, a, n.os), c;
      }, this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function () {
        return a;
      }, this.setUA = function (c) {
        return a = "string" == typeof c && c.length > 350 ? p(c, 350) : c, this;
      }, this.setUA(a), this;
    };

    N.VERSION = "1.0.32", N.BROWSER = v([o, s, "major"]), N.CPU = v(["architecture"]), N.DEVICE = v([i, f, l, "console", u, m, h, "wearable", "embedded"]), N.ENGINE = N.OS = v([o, s]), void 0 !== e ? (void 0 !== c && c.exports && (e = c.exports = N), e.UAParser = N) : a(251) ? void 0 === (n = function () {
      return N;
    }.call(e, a, e, c)) || (c.exports = n) : void 0 !== t && (t.UAParser = N);
    var g = void 0 !== t && (t.jQuery || t.Zepto);

    if (g && !g.ua) {
      var H = new N();
      g.ua = H.getResult(), g.ua.get = function () {
        return H.getUA();
      }, g.ua.set = function (c) {
        H.setUA(c);
        var e = H.getResult();

        for (var a in e) {
          g.ua[a] = e[a];
        }
      };
    }
  }("object" == typeof window ? window : this);
}, function (c, e) {
  (function (e) {
    c.exports = e;
  }).call(this, {});
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.companyOverrideInfo = r, e.estimatedPriceMessageOverride = function (c) {
    return r(c).estimatedPriceMessage;
  }, e.hidePromotionText = function (c) {
    return r(c).hidePromotionText;
  }, e.hideOrderServicePrices = function (c) {
    return r(c).hideOrderServicePrices;
  }, e.totalSavingsTextOverride = function (c) {
    return r(c).totalSavingsText;
  }, e.shopPriceOverrideText = function (c) {
    return r(c).estimatedPriceMessage;
  }, e.hideSubtotal = function (c) {
    return r(c).hideSubtotal;
  }, e.hideTax = function (c) {
    return r(c).hideTax;
  }, e.totalPriceTextOverride = function (c) {
    return r(c).estimatedPriceMessage;
  };
  var n = a(92);

  function t(c) {
    var e,
        a,
        t,
        r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        i = r.percent_discount || "";
    return (e = {}, a = n.JIFFY_LUBE_COMPANY_ID, t = {
      estimatedPriceMessage: i + "% Off Retail",
      totalSavingsText: i + "%",
      hideOrderServicePrices: !0,
      hidePromotionText: !0,
      hideSubtotal: !0,
      hideTax: !0
    }, a in e ? Object.defineProperty(e, a, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[a] = t, e)[c || r.id] || {};
  }

  function r(c) {
    return null == c ? {} : t(c.company_id, c.company);
  }
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.ToggleButton = void 0;

  var n = function () {
    function c(c, e) {
      for (var a = 0; a < e.length; a++) {
        var n = e[a];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(c, n.key, n);
      }
    }

    return function (e, a, n) {
      return a && c(e.prototype, a), n && c(e, n), e;
    };
  }(),
      t = a(0),
      r = s(t),
      i = s(a(2)),
      o = s(a(85)),
      l = s(a(254)),
      f = s(a(255));

  function s(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }

  var u = e.ToggleButton = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, t.Component), n(e, [{
      key: "colors",
      value: function value() {
        var c = this.props.styles;
        return {
          active: {
            base: c.primaryColor
          },
          activeThumb: {
            base: c.secondaryButtonColor
          },
          inactive: {
            base: c.gray
          },
          inactiveThumb: {
            base: c.secondaryButtonColor
          }
        };
      }
    }, {
      key: "toggleSource",
      value: function value() {
        return !0 === this.props.value ? l.default : f.default;
      }
    }, {
      key: "toggleIcon",
      value: function value() {
        return r.default.createElement("img", {
          className: "toggle_button__icon",
          src: this.toggleSource()
        });
      }
    }, {
      key: "trackStyle",
      value: function value() {
        return {
          height: "22px"
        };
      }
    }, {
      key: "render",
      value: function value() {
        var c = this.props,
            e = c.onChange,
            a = c.value;
        return r.default.createElement(o.default, {
          colors: this.colors(),
          onToggle: e,
          thumbIcon: this.toggleIcon(),
          trackStyle: this.trackStyle(),
          value: a,
          activeLabel: "",
          inactiveLabel: ""
        });
      }
    }]), e;
  }();

  u.propTypes = {
    onChange: i.default.func.isRequired,
    value: i.default.bool.isRequired,
    styles: i.default.object.isRequired
  }, e.default = u;
}, function (c, e) {
  c.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA2CAYAAACWeYpTAAAAAXNSR0IArs4c6QAABXRJREFUaAXlV01rXVUUvSexgxJt8TM1fU9aB1p05NCJgwo6dSJo7MCBSAYVWpVORDuSSltEUDSK2EERFUFNtSk0CE4E/QHNQPyCVmlocKBNDG3ybs++eft03f32+br3tSn0Ts7+WHvttXJu3kuK4iZ5zAb5bLO3bKK5zcLUfddjR9T8tRBxLThTf6iEU00PU9QwuXKMadgBs8MSNyweTXTTWs1sW4Ft55uaSJ1zZm9JnRC4G92gkFsUOYJzsAOLoJDL424FOHLCaj5laQrGt7jNrORsajhqtKnIpnPSmC/PNRw02kRs6kwKLmYm1scfktdoihAkojg0E+pJHi33mfLVVQ4pQubaENZC+FAPOVJinylfXXKWUozM5QDmPmxuHTk51gxoNcL76sxVYZp+jyIJx9kGfz+6c/v42OqLxpjz09/3Pn75y3OX+2TMhSaohjnvTTqZkMAYx4YlVuYhvgp79u3OrrtvHZkrynKcwGtlMT02dfYlZbE0J3Ma0WpIVTa5UWkqltPCGkaaJMCoKXYDDoXTbCin8egzEkXUATXB9VaVyT7ltZo0acy6iV5pZoGvNiM5AMehxHPdnblG3WA/wAUYU3sg/+2tzq67xq6+rmSyLAvTK4tv9p1cfU2Qy3lsh3qIc3HOqyvJMceYyDGvYmvywYnbR+ast+p3EkzOvPHVpT0fnV5Y7c/5XlPiwR7tSX7a3qi2KN1krzhhTT539PQCf9oSH85r/I1qbDRGLvtVfuz5HZuWprvvrXzYPbP8Qffw/qc7m0BFhfn1SPcB9SatyVe/WCGTfJMwWjMrdyMuOR7tI2Nksl/ln01tmbKflq9bjjvtq/jo7p3m4eXNW77+af7f6hUjk9tvM3PGlNtoz9XX1XxLJt//4ULuTaIOjPs2/EfO7yizuAX2k2Qb/+zJhH09nnrzcfPp0srEngOPjd7vNfn5/5PCJHLz7yHt4Zj7jU8WzaePCPsu/uPQju69d/R+tnruoUG+sbJXnLLJI+4mLcAqtp+u5ru9x5cnP/lxkW9SM4I1jvmkNSkx4fBxf+s68djtx7KHuVl4p/PQ1s32K0OYZR4LrkyWpTl5YObi5Lun/rnEvf6JwqmEOcd8+vqyTjk+9LY1firD4/vOzS9eXHvCvsIXiIm+F5mxumF7kwGTDG1yovnofBujjrzzyl/zi0ujziw1qpu0pq3J2YOzy88qN+nmM4Isc8g7FKNE2Nn/55nz/4086W52/SbJ5DOHTyzK15U1SOGYY8z4xie/ZnxqRLLHOZ80w7H55dB9nYmt5QtrZfn33pnLx46vf08iL2M1I1jjmE/iSIlxF8etPoxYMJGlxLzUd6aYYAyfzCVzrtNZ9dq8uiFyXpSCcWJ4CE6cxxggaWEbo7gBRWBMGJnjnNaP4WPzsl/lKX8Z0WJ8NVUiUZQzqeIRlxKLtf6UbxRJ/ej1DmJ9MSGxl8KJ+JQ4awcbjQkJ9X2iWAj2JQ/1ZB9zjOVsSu7m+b8XGgq9nloPaxjHuHwCnag+IDf38Vb11BuVSyWp7FMua3KGcw0rZ2XOs8kn3gTGGoHWT61pfL6aNCVzmtNqkq+GSb1RH3mNrL9Jq0kRWk5zclbmNKfVNL5aTd6IzGvgfqJhtBrOav2QYF/PV8ddFA/gpACZSwLKQ5hQT+OStQGBAAj1ADZokppSmMyRQMYhbKgneWIGYn3k82KlIJkjiRbn4jWOUM0rXBkKYjWhWk3hdaVcvBv0BEHBTWc0kVrNwz9QbjPbxCAJSJrzCfPVB5xFCj6eJHERbmon8/iEEEmoR/2NfpJNktCYmVh/o8xmmUwxykZuFMPZBtsYuN6mG5tjkzk3ijNaPAzzQzGkibupalcAANCWSJOGKTUAAAAASUVORK5CYII=";
}, function (c, e) {
  c.exports = "data:image/png;base64,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";
}, function (c, e, a) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.PRIVACY_POLICIES = void 0;

  var n = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  };

  e.default = function (c) {
    var e = c.className,
        a = c.style,
        t = c.t;
    return i.default.createElement("div", {
      className: e,
      style: n({}, a, {
        paddingBottom: "20px",
        fontSize: "0.8em"
      })
    }, t("privacyPolicyAndTerms:signingLabel"), i.default.createElement("a", {
      style: {
        textDecoration: "underline",
        color: "unset"
      },
      href: s(t),
      rel: "noopener noreferrer",
      target: "_blank"
    }, f == o.FLEETCOR || f == o.FUELMAN ? "Fuelman Privacy Policy" : t("privacyPolicyAndTerms:privacyPolicyLabel")), t("privacyPolicyAndTerms:andLabel"), i.default.createElement("a", {
      style: {
        textDecoration: "underline",
        color: "unset"
      },
      href: u(),
      rel: "noopener noreferrer",
      target: "_blank"
    }, f == o.FLEETCOR || f == o.FUELMAN ? "Site Terms" : t("privacyPolicyAndTerms:termsOfUseLabel")));
  };

  var t,
      r = a(0),
      i = (t = r) && t.__esModule ? t : {
    default: t
  },
      o = a(37);
  var l = e.PRIVACY_POLICIES = {
    shell: "https://caradvise.com/privacy-policy-fmh",
    fleetcor: "https://www.fuelman.com/privacy-policy/",
    fuelman: "https://www.fuelman.com/privacy-policy/",
    ntw: "https://www.ntw.com/privacy-policy"
  },
      f = (0, o.getSubdomain)();

  function s(c) {
    return f.match(/shellcanada/) ? c("privacyPolicyAndTerms:privacyPolicyUrl") : f.match(/shell/) || f.match(/fleetcor/) || f.match(/fuelman/) || f.match(/ntw/) ? l[f] : "http://caradvise.com/privacy/";
  }

  function u() {
    return f.match(/fleetcor/) || f.match(/fuelman/) ? "https://caradvise.com/fuelmanterms/" : f.match(/ntw/) ? "https://www.ntw.com/terms-of-use" : "http://caradvise.com/terms/";
  }
}, function (c, e, a) {
  var n = a(258);
  "string" == typeof n && (n = [[c.i, n, ""]]);
  var t = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  a(260)(n, t);
  n.locals && (c.exports = n.locals);
}, function (c, e, a) {
  (c.exports = a(259)(!1)).push([c.i, '.visible-md-up {\n  display: none; }\n\n.visible-md-down {\n  display: none; }\n\n.visible-sm {\n  display: none; }\n\n@media only screen and (max-width: 949px) {\n  .visible-md-down {\n    display: unset; } }\n\n@media only screen and (min-width: 426px) {\n  .visible-md-up {\n    display: unset; } }\n\n@media only screen and (max-width: 425px) {\n  .visible-sm {\n    display: unset; } }\n\n/* To add more CarAdvise styling, see https://caradvise.atlassian.net/wiki/spaces/PR/pages/21332001/Digital+Components?preview=/21332001/21200917/CarAdvise_DigitalComponents.pdf */\n/* Fixed Color Scheme */\n/* Color classes */\n.ca-white {\n  color: #FFFFFF; }\n\n.ca-very-light-gray {\n  color: #F7F7F7; }\n\n.ca-light-gray {\n  color: #EFEFEF; }\n\n.ca-gray {\n  color: #DDDDDD; }\n\n.ca-orange {\n  color: #e95832; }\n\n.ca-blue {\n  color: #0390FF; }\n\n.ca-caradvise-electric-blue {\n  color: #292f36; }\n\n.ca-light-green {\n  color: #faa41d; }\n\n.ca-red {\n  color: #FF0000; }\n\n.toggle-approve {\n  color: #e95832;\n  font-family: "Monteserrat", sans-serif; }\n\n.toggle-reject {\n  color: #EB0000;\n  font-family: "Monteserrat", sans-serif; }\n\n.classic-ca-button-text {\n  font-size: 12pt;\n  font-family: "Montserrat", sans-serif;\n  background-color: transparent; }\n\n.left-button-icons {\n  font-size: 19px; }\n\n.right-button-icons {\n  font-size: 19px;\n  float: right;\n  margin-right: 12px;\n  margin-left: 10px;\n  margin-top: 1px; }\n\n.classic-ca-button {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  height: 30px;\n  border-style: solid;\n  border-width: 2px;\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 6px;\n  padding: 10px 10px 10px 10px;\n  text-decoration: none;\n  overflow: hidden;\n  margin: 0 auto;\n  box-shadow: 2px 2px 10px #ccc; }\n\n.classic-ca-button > span {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between; }\n\n.content .classic-ca-button {\n  max-width: 240px; }\n\n.appointment .classic-ca-button {\n  width: 90%;\n  margin-top: 5px;\n  margin-bottom: 5px; }\n\n.grey-button {\n  max-width: 240px;\n  border: 2px solid #999; }\n\n.grey-button:hover {\n  border: 2px solid; }\n\n.orange-link {\n  text-decoration: underline; }\n\n.orange-button {\n  max-width: 240px;\n  border: 2px solid; }\n\n.orange-button:hover {\n  border: 2px solid; }\n\n.white-button {\n  max-width: 240px;\n  border: none; }\n\n.white-button:hover {\n  max-width: 240px;\n  border: none; }\n\n.blue-button-gradient {\n  background: #8CD0FF;\n  background: linear-gradient(#8CD0FF, #3EACFF, #0091FF);\n  background: -webkit-linear-gradient(#8CD0FF, #3EACFF, #0091FF);\n  /* For Safari 5.1 to 6.0 */\n  background: -o-linear-gradient(#8CD0FF, #3EACFF, #0091FF);\n  /* For Opera 11.1 to 12.0 */\n  background: -moz-linear-gradient(#8CD0FF, #3EACFF, #0091FF);\n  /* For Firefox 3.6 to 15 */\n  background: linear-gradient(#8CD0FF, #3EACFF, #0091FF);\n  /* Standard syntax */ }\n\n.toggle_button__icon {\n  height: 21px;\n  width: 21px; }\n\n.toggle_button_approval__icon {\n  background-color: white;\n  padding: 2px;\n  width: 12px !important;\n  height: 12px !important;\n  border-radius: 50%; }\n\n.modal-dialog {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  right: auto;\n  bottom: auto;\n  margin-right: -50%;\n  transform: translate(-50%, -50%);\n  border: 1px solid #ccc;\n  background: #fff;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 6px;\n  outline: none;\n  max-width: 640px;\n  max-height: 100%; }\n  @media only screen and (min-width: 720px) {\n    .modal-dialog {\n      min-width: 500px; } }\n\n.modal-dialog-overflow {\n  overflow: auto !important; }\n\n.modal-dialog .nav-button {\n  color: #EFEFEF;\n  width: 200px;\n  text-align: center;\n  cursor: pointer; }\n  @media only screen and (max-width: 720px) {\n    .modal-dialog .nav-button {\n      width: 100px; } }\n\n.modal-dialog .modal-no-details {\n  height: 300px;\n  display: flex;\n  align-items: center;\n  text-align: center; }\n\n.ReactModal__Overlay {\n  z-index: 1001; }\n\n.modal-dialog label {\n  display: flex;\n  flex-direction: column; }\n\n.modal-dialog input, select {\n  padding: 10px;\n  font-size: 14px;\n  margin: 5px 5px 15px 0;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  -moz-box-shadow: inset 2px 2px 4px #efefef;\n  -webkit-box-shadow: inset 2px 2px 4px #efefef;\n  box-shadow: inset 2px 2px 4px #efefef; }\n\n.modal-dialog .modal-dialog-header {\n  min-height: 2em;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding-right: 10px;\n  align-items: center; }\n  .modal-dialog .modal-dialog-header .modal-dialog-header-title {\n    font-size: 16px;\n    font-weight: bold;\n    display: flex;\n    flex: 2;\n    justify-content: center; }\n\n.approval-modal-service-details-content p, .approval-modal-service-details-content h3 {\n  text-align: center; }\n\n.modal-dialog .modal-step-nav {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  padding: 10px;\n  margin-top: 20px; }\n\n.modal-dialog .modal-page {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center; }\n\n.modal-dialog .modal-title {\n  font-size: larger;\n  font-weight: 800;\n  text-align: center;\n  font-family: \'Catamaran\', sans-serif;\n  color: #292f36; }\n\n.modal-dialog .modal-subtitle {\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-align: center;\n  font-family: "Montserrat", sans-serif; }\n\n.modal-header-close {\n  display: flex;\n  justify-content: flex-end;\n  margin-right: 20px;\n  margin-top: 10px; }\n  .modal-header-close .modal-header-close-button {\n    cursor: pointer; }\n\n.modal-dialog .flex-centered-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center; }\n\n.modal-dialog .modal-price {\n  font-weight: 800;\n  font-size: 1.8rem;\n  margin-top: 5px;\n  font-family: "Montserrat", sans-serif; }\n\n.modal-dialog .modal-dialog-header a {\n  display: inline-block;\n  color: #fff;\n  cursor: pointer; }\n\n.modal-dialog .modal-dialog-content {\n  display: flex;\n  padding: 0 60px;\n  flex-direction: column;\n  text-align: center;\n  font-family: "Lato", sans-serif; }\n\n.warning {\n  display: flex;\n  padding: 0 40px 40px 40px;\n  flex-direction: column;\n  text-align: center; }\n\n.modal-dialog .modal-dialog-buttons {\n  flex-direction: column;\n  order: 1;\n  align-items: center;\n  width: 200px;\n  margin: 0 auto;\n  font-family: "Montserrat", sans-serif; }\n\n.modal-dialog .modal-dialog-buttons a {\n  margin: 10px 0;\n  padding: 5px;\n  font-family: "Montserrat", sans-serif; }\n\n.modal-dialog-header-title {\n  display: flex;\n  flex: 0.59;\n  padding: 0.5em; }\n\n.modal-dialog .price-indicator-wrapper {\n  margin-bottom: 50px; }\n\n.modal-dialog .price-indicator {\n  border-radius: 20px;\n  border: 2px solid;\n  text-align: center;\n  padding: 5px 20px;\n  margin-top: 20px;\n  display: inline-block; }\n\n.box-shadow {\n  box-shadow: 2px 2px 10px #ccc; }\n\n@media only screen and (min-width: 425px) and (max-width: 720px) {\n  .modal-dialog {\n    max-width: 680px; }\n    .modal-dialog .modal-dialog-content {\n      padding: 0 10px; } }\n\n@media only screen and (min-width: 350px) and (max-width: 424px) {\n  .modal-dialog {\n    max-width: 385px; }\n    .modal-dialog .modal-dialog-content {\n      padding: 0 10px; } }\n\n@media only screen and (max-width: 349px) {\n  .modal-dialog {\n    max-width: 310px; }\n    .modal-dialog .modal-dialog-content {\n      padding: 0 10px; } }\n\n.generic-panel {\n  position: relative;\n  width: 100%;\n  max-width: 640px;\n  background-color: #fff;\n  flex: 1;\n  justify-content: center;\n  background-color: #fff;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  box-shadow: 2px 2px 10px #ccc;\n  text-align: left; }\n  @media screen and (min-width: 720px) {\n    .generic-panel {\n      width: 640px; } }\n  .generic-panel .generic-panel-container {\n    padding: 20px 20px 40px 20px; }\n\n.underline {\n  text-decoration: underline;\n  cursor: pointer;\n  font-family: \'Monteserrat\', sans-serif; }\n\n.all-caps {\n  text-transform: uppercase; }\n\n.approvals_empty_state {\n  text-align: center;\n  padding: 100px 0; }\n\n.approvals_empty_state__text {\n  font-size: 18px;\n  font-weight: bold; }\n\n.approvals_empty_state__icon {\n  margin: 0 auto;\n  height: 60px;\n  width: 60px; }\n\n.approvals_form {\n  padding: 20px; }\n\n.approvals_form_field {\n  padding: 20px 25px;\n  font-size: 14px;\n  border-bottom: 1px solid #DDDDDD; }\n\n.approvals_form_field:last-of-type {\n  border-bottom: none; }\n\n.approvals_form_field__approved_badge {\n  border-radius: 30px;\n  font-size: 12px;\n  opacity: 0.6;\n  padding: 2px;\n  text-align: center;\n  line-height: 1.4em;\n  font-family: \'Monteserrat\', sans-serif;\n  height: 15px;\n  width: 75px; }\n\n.approvals_form_field__button_column {\n  display: flex;\n  justify-content: flex-end;\n  align-self: center; }\n\n.approvals_form_field__check_icon {\n  height: 14px;\n  width: 14px; }\n\n.approvals_form_field__comment {\n  background-color: #EFEFEF;\n  margin: 10px -25px -10px -25px;\n  padding: 10px 25px; }\n\n.approvals_form_field__ase_comment {\n  background-color: #DDDDDD;\n  margin: 10px -25px -20px -25px;\n  padding: 10px 25px; }\n\n.approvals_form_field__info_icon {\n  margin-left: 5px; }\n\n.approvals_form_field__price_column {\n  margin-right: 12px;\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: center;\n  align-self: center; }\n\n.approvals_form_field__price_retail {\n  text-decoration: line-through; }\n  @media screen and (max-width: 425px) {\n    .approvals_form_field__price_retail {\n      display: none !important; } }\n\n.approvals_form_field__price_shop {\n  display: inline; }\n\n.approvals_form_field__price_shop_icon {\n  display: inline;\n  margin: 1px 2px 0 0;\n  height: 15px;\n  width: 15px; }\n\n.approvals_form_field__price_shop_wrapper {\n  display: flex; }\n\n.approvals_form_field__row {\n  margin-bottom: 0;\n  font-family: \'Monteserrat\', sans-serif; }\n  @media screen and (max-width: 374px) {\n    .approvals_form_field__row {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: space-between;\n      text-align: center; }\n      .approvals_form_field__row > div {\n        margin-bottom: 10px; } }\n\n.approvals_form_fields_section {\n  margin-bottom: 20px;\n  border-radius: 8px;\n  -moz-border-radius: 8px;\n  -webkit-border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0px 2px 7px 2px rgba(179, 179, 179, 0.5);\n  -moz-box-shadow: 0px 2px 7px 2px rgba(179, 179, 179, 0.5);\n  -webkit-box-shadow: 0px 2px 7px 2px rgba(179, 179, 179, 0.5); }\n\n.approvals_form_fields_section__header, .approvals_form_fields_section__header--primary, .approvals_form_fields_section__header--secondary, .approvals_form_fields_section__header--tertiary {\n  color: #FFFFFF;\n  font-size: 12px;\n  letter-spacing: 2px;\n  padding: 15px 20px; }\n  @media screen and (max-width: 720px) {\n    .approvals_form_fields_section__header, .approvals_form_fields_section__header--primary, .approvals_form_fields_section__header--secondary, .approvals_form_fields_section__header--tertiary {\n      padding: 10px !important; } }\n\n.approvals_form_header {\n  margin-bottom: 20px; }\n\n.approvals_form_header__heading {\n  font-size: 24px;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 20px; }\n\n.approvals_form_header__sub_heading {\n  font-size: 14px;\n  text-align: center; }\n\n.approvals_form_order_comments {\n  background-color: #EFEFEF;\n  font-size: 14px;\n  margin-bottom: 20px;\n  padding: 20px 25px;\n  border-radius: 8px;\n  -moz-border-radius: 8px;\n  -webkit-border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0px 2px 7px 2px rgba(179, 179, 179, 0.5);\n  -moz-box-shadow: 0px 2px 7px 2px rgba(179, 179, 179, 0.5);\n  -webkit-box-shadow: 0px 2px 7px 2px rgba(179, 179, 179, 0.5); }\n\n.approvals_form_order_comments__icon {\n  margin-right: 5px; }\n\n.approvals_form_order_ase_comments__icon {\n  margin-right: 5px;\n  color: #0390FF; }\n\n.approvals_form_payment_method__details {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 5px; }\n\n.approvals_form_payment_method__icon {\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  top: 30%; }\n\n.img-parent-class {\n  position: relative; }\n\n.approvals_form_payment_method__label {\n  margin-bottom: 5px; }\n\n.approvals_form_payment_method__link {\n  text-decoration: underline; }\n\n.dropdown-and-label-component {\n  display: flex; }\n\n.label-of-dropdown {\n  margin-right: 10px; }\n\n@media only screen and (max-width: 768px) {\n  /* For mobile phones: */\n  .dropdown-and-label-component {\n    flex-direction: column; }\n  .label-of-dropdown {\n    margin-bottom: 5px;\n    margin-top: 7px; } }\n\n.approvals_form_submit__buttons_container, .approvals_form_cancel__button_container {\n  text-align: right; }\n\n.approvals_form_summary {\n  margin-bottom: 20px; }\n\n.approvals_form_summary__column, .approvals_form_summary__column--left, .approvals_form_summary__column--right {\n  padding: 20px 25px;\n  font-size: 14px;\n  border-radius: 8px;\n  -moz-border-radius: 8px;\n  -webkit-border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0px 2px 7px 2px rgba(179, 179, 179, 0.5);\n  -moz-box-shadow: 0px 2px 7px 2px rgba(179, 179, 179, 0.5);\n  -webkit-box-shadow: 0px 2px 7px 2px rgba(179, 179, 179, 0.5); }\n\n.approvals_form_summary__column--left {\n  flex: 5; }\n\n.approvals_form_summary__column--right {\n  flex: 7;\n  margin-right: 0;\n  margin-left: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center; }\n  @media screen and (max-width: 720px) {\n    .approvals_form_summary__column--right {\n      margin-top: 20px !important;\n      margin-left: 0 !important; } }\n\n@media screen and (max-width: 720px) {\n  .approvals_form_summary__row {\n    display: block !important; } }\n\n.approvals_form_totals__price_column {\n  display: flex;\n  justify-content: flex-end;\n  font-family: "Monteserrat", sans-serif; }\n\n.approvals_form_totals__row, .approvals_form_totals__row--total {\n  margin-bottom: 10px;\n  font-family: "Monteserrat", sans-serif; }\n\n.approvals_form_totals__row--total {\n  font-weight: bold; }\n\n.approvals_new {\n  background-color: transparent;\n  border-radius: 0;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none; }\n\n.approvals_form_notes {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  margin-bottom: 20px; }\n  .approvals_form_notes textarea {\n    flex: 1;\n    border-radius: 6px;\n    border-color: #DDDDDD; }\n\n.approvals_form_approvers_notes .ui.form .fields {\n  display: flex;\n  align-items: center;\n  margin: 1em !important;\n  height: 120px; }\n  @media screen and (max-width: 720px) {\n    .approvals_form_approvers_notes .ui.form .fields {\n      height: 200px; } }\n\n.print-card-button {\n  max-width: 420px; }\n\n.membership-card {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  border-radius: 6px;\n  padding: 2px;\n  max-width: 420px;\n  max-height: max-content;\n  background-color: white;\n  text-align: left;\n  margin-bottom: 10px; }\n  @media print {\n    .membership-card {\n      width: 320px;\n      max-height: 210px;\n      padding: 5px;\n      margin: 5px; }\n      .membership-card .print-footer {\n        display: block !important; }\n      .membership-card .membership-footer-logo-container {\n        display: none; } }\n  .membership-card p {\n    margin: 0px; }\n  .membership-card .membership-inner-card {\n    border: 1px solid;\n    border-radius: 6px;\n    max-width: 340px;\n    justify-content: space-between; }\n    .membership-card .membership-inner-card .headerLogo {\n      height: 30px; }\n    .membership-card .membership-inner-card .membership-content-area {\n      display: flex;\n      flex: 3;\n      flex-direction: row;\n      padding: 20px;\n      padding-top: 10px;\n      padding-bottom: 0px; }\n      @media screen and (max-width: 425px) {\n        .membership-card .membership-inner-card .membership-content-area {\n          flex-direction: column; } }\n      .membership-card .membership-inner-card .membership-content-area .membership-title {\n        flex: 1;\n        font-weight: normal;\n        font-family: "Montserrat", sans-serif;\n        color: #292f36;\n        font-size: 0.8em;\n        padding-bottom: 5px; }\n      .membership-card .membership-inner-card .membership-content-area .membership-top-area {\n        padding-bottom: 5px;\n        padding-top: 5px;\n        display: flex;\n        flex: 4;\n        flex-direction: column;\n        justify-content: space-between; }\n        .membership-card .membership-inner-card .membership-content-area .membership-top-area .membership-name-and-vehicle {\n          display: flex;\n          flex-direction: column;\n          justify-content: flex-start;\n          font-family: "Montserrat", sans-serif; }\n          .membership-card .membership-inner-card .membership-content-area .membership-top-area .membership-name-and-vehicle .membership-name {\n            font-weight: 550;\n            font-size: 0.7em;\n            color: black;\n            margin-top: inherit; }\n          .membership-card .membership-inner-card .membership-content-area .membership-top-area .membership-name-and-vehicle .membership-vehicle {\n            font-size: 0.7em;\n            font-weight: 350;\n            color: black;\n            margin-bottom: 5px; }\n    .membership-card .membership-inner-card .membership-instructions-area {\n      margin-top: 0px;\n      display: flex;\n      flex: 2;\n      flex-direction: column; }\n      .membership-card .membership-inner-card .membership-instructions-area .membership-subtitle-print {\n        display: block;\n        margin-bottom: 10px;\n        font-size: 0.8em;\n        font-weight: 550;\n        color: black; }\n        @media screen and (max-width: 720px) {\n          .membership-card .membership-inner-card .membership-instructions-area .membership-subtitle-print {\n            font-size: 0.8em; } }\n        .membership-card .membership-inner-card .membership-instructions-area .membership-subtitle-print .membership-phone-number {\n          font-size: 1em;\n          font-weight: 550;\n          color: black; }\n          @media screen and (max-width: 720px) {\n            .membership-card .membership-inner-card .membership-instructions-area .membership-subtitle-print .membership-phone-number {\n              font-size: 0.8em; } }\n  @media screen and (min-width: 720px) {\n    .membership-card {\n      margin-right: 20px; } }\n\n.membership-payment-infotext {\n  flex: 1;\n  font-size: 0.9em;\n  font-weight: 500;\n  font-style: italic;\n  margin-top: 5px;\n  color: dimgray; }\n\n.membership-panel {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between; }\n  @media screen and (max-width: 720px) {\n    .membership-panel {\n      flex-direction: column; } }\n  .membership-panel .membership-footer-logo-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 10px;\n    padding-bottom: 9px; }\n  .membership-panel .membership-footer-logo {\n    display: block;\n    margin-left: 10px;\n    background-size: contain !important;\n    height: 15px; }\n    @media only screen and (max-width: 950px) {\n      .membership-panel .membership-footer-logo {\n        margin: 0 auto; } }\n\n.print-footer-container {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.print-footer {\n  display: none;\n  margin-left: 20px;\n  margin-right: 20px;\n  background-size: contain;\n  padding-bottom: 5px; }\n', ""]);
}, function (c, e, a) {
  "use strict";

  c.exports = function (c) {
    var e = [];
    return e.toString = function () {
      return this.map(function (e) {
        var a = function (c, e) {
          var a = c[1] || "",
              n = c[3];
          if (!n) return a;

          if (e && "function" == typeof btoa) {
            var t = (i = n, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */"),
                r = n.sources.map(function (c) {
              return "/*# sourceURL=" + n.sourceRoot + c + " */";
            });
            return [a].concat(r).concat([t]).join("\n");
          }

          var i;
          return [a].join("\n");
        }(e, c);

        return e[2] ? "@media " + e[2] + "{" + a + "}" : a;
      }).join("");
    }, e.i = function (c, a) {
      "string" == typeof c && (c = [[null, c, ""]]);

      for (var n = {}, t = 0; t < this.length; t++) {
        var r = this[t][0];
        null != r && (n[r] = !0);
      }

      for (t = 0; t < c.length; t++) {
        var i = c[t];
        null != i[0] && n[i[0]] || (a && !i[2] ? i[2] = a : a && (i[2] = "(" + i[2] + ") and (" + a + ")"), e.push(i));
      }
    }, e;
  };
}, function (c, e, a) {
  var n,
      t,
      r = {},
      i = (n = function n() {
    return window && document && document.all && !window.atob;
  }, function () {
    return void 0 === t && (t = n.apply(this, arguments)), t;
  }),
      o = function (c) {
    var e = {};
    return function (c, a) {
      if ("function" == typeof c) return c();

      if (void 0 === e[c]) {
        var n = function (c, e) {
          return e ? e.querySelector(c) : document.querySelector(c);
        }.call(this, c, a);

        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
          n = n.contentDocument.head;
        } catch (c) {
          n = null;
        }
        e[c] = n;
      }

      return e[c];
    };
  }(),
      l = null,
      f = 0,
      s = [],
      u = a(261);

  function h(c, e) {
    for (var a = 0; a < c.length; a++) {
      var n = c[a],
          t = r[n.id];

      if (t) {
        t.refs++;

        for (var i = 0; i < t.parts.length; i++) {
          t.parts[i](n.parts[i]);
        }

        for (; i < n.parts.length; i++) {
          t.parts.push(z(n.parts[i], e));
        }
      } else {
        var o = [];

        for (i = 0; i < n.parts.length; i++) {
          o.push(z(n.parts[i], e));
        }

        r[n.id] = {
          id: n.id,
          refs: 1,
          parts: o
        };
      }
    }
  }

  function m(c, e) {
    for (var a = [], n = {}, t = 0; t < c.length; t++) {
      var r = c[t],
          i = e.base ? r[0] + e.base : r[0],
          o = {
        css: r[1],
        media: r[2],
        sourceMap: r[3]
      };
      n[i] ? n[i].parts.push(o) : a.push(n[i] = {
        id: i,
        parts: [o]
      });
    }

    return a;
  }

  function v(c, e) {
    var a = o(c.insertInto);
    if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var n = s[s.length - 1];
    if ("top" === c.insertAt) n ? n.nextSibling ? a.insertBefore(e, n.nextSibling) : a.appendChild(e) : a.insertBefore(e, a.firstChild), s.push(e);else if ("bottom" === c.insertAt) a.appendChild(e);else {
      if ("object" != typeof c.insertAt || !c.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var t = o(c.insertAt.before, a);
      a.insertBefore(e, t);
    }
  }

  function d(c) {
    if (null === c.parentNode) return !1;
    c.parentNode.removeChild(c);
    var e = s.indexOf(c);
    e >= 0 && s.splice(e, 1);
  }

  function M(c) {
    var e = document.createElement("style");

    if (void 0 === c.attrs.type && (c.attrs.type = "text/css"), void 0 === c.attrs.nonce) {
      var n = function () {
        0;
        return a.nc;
      }();

      n && (c.attrs.nonce = n);
    }

    return p(e, c.attrs), v(c, e), e;
  }

  function p(c, e) {
    Object.keys(e).forEach(function (a) {
      c.setAttribute(a, e[a]);
    });
  }

  function z(c, e) {
    var a, n, t, r;

    if (e.transform && c.css) {
      if (!(r = "function" == typeof e.transform ? e.transform(c.css) : e.transform.default(c.css))) return function () {};
      c.css = r;
    }

    if (e.singleton) {
      var i = f++;
      a = l || (l = M(e)), n = A.bind(null, a, i, !1), t = A.bind(null, a, i, !0);
    } else c.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (a = function (c) {
      var e = document.createElement("link");
      return void 0 === c.attrs.type && (c.attrs.type = "text/css"), c.attrs.rel = "stylesheet", p(e, c.attrs), v(c, e), e;
    }(e), n = function (c, e, a) {
      var n = a.css,
          t = a.sourceMap,
          r = void 0 === e.convertToAbsoluteUrls && t;
      (e.convertToAbsoluteUrls || r) && (n = u(n));
      t && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(t)))) + " */");
      var i = new Blob([n], {
        type: "text/css"
      }),
          o = c.href;
      c.href = URL.createObjectURL(i), o && URL.revokeObjectURL(o);
    }.bind(null, a, e), t = function t() {
      d(a), a.href && URL.revokeObjectURL(a.href);
    }) : (a = M(e), n = function (c, e) {
      var a = e.css,
          n = e.media;
      n && c.setAttribute("media", n);
      if (c.styleSheet) c.styleSheet.cssText = a;else {
        for (; c.firstChild;) {
          c.removeChild(c.firstChild);
        }

        c.appendChild(document.createTextNode(a));
      }
    }.bind(null, a), t = function t() {
      d(a);
    });

    return n(c), function (e) {
      if (e) {
        if (e.css === c.css && e.media === c.media && e.sourceMap === c.sourceMap) return;
        n(c = e);
      } else t();
    };
  }

  c.exports = function (c, e) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = i()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
    var a = m(c, e);
    return h(a, e), function (c) {
      for (var n = [], t = 0; t < a.length; t++) {
        var i = a[t];
        (o = r[i.id]).refs--, n.push(o);
      }

      c && h(m(c, e), e);

      for (t = 0; t < n.length; t++) {
        var o;

        if (0 === (o = n[t]).refs) {
          for (var l = 0; l < o.parts.length; l++) {
            o.parts[l]();
          }

          delete r[o.id];
        }
      }
    };
  };

  var C,
      L = (C = [], function (c, e) {
    return C[c] = e, C.filter(Boolean).join("\n");
  });

  function A(c, e, a, n) {
    var t = a ? "" : n.css;
    if (c.styleSheet) c.styleSheet.cssText = L(e, t);else {
      var r = document.createTextNode(t),
          i = c.childNodes;
      i[e] && c.removeChild(i[e]), i.length ? c.insertBefore(r, i[e]) : c.appendChild(r);
    }
  }
}, function (c, e) {
  c.exports = function (c) {
    var e = "undefined" != typeof window && window.location;
    if (!e) throw new Error("fixUrls requires window.location");
    if (!c || "string" != typeof c) return c;
    var a = e.protocol + "//" + e.host,
        n = a + e.pathname.replace(/\/[^\/]*$/, "/");
    return c.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (c, e) {
      var t,
          r = e.trim().replace(/^"(.*)"$/, function (c, e) {
        return e;
      }).replace(/^'(.*)'$/, function (c, e) {
        return e;
      });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(r) ? c : (t = 0 === r.indexOf("//") ? r : 0 === r.indexOf("/") ? a + r : n + r.replace(/^\.\//, ""), "url(" + JSON.stringify(t) + ")");
    });
  };
}, function (c) {
  c.exports = {
    test: "Hello world!!"
  };
}, function (c) {
  c.exports = {
    test: "Bonjour le monde!!"
  };
}, function (c) {
  c.exports = {
    emptyStateMessage: "You currently have no services that need approval."
  };
}, function (c) {
  c.exports = {
    emptyStateMessage: "Vous n'avez actuellement aucun service nécessitant une approbation."
  };
}, function (c) {
  c.exports = {
    priceLbl: "Price",
    notRequiredLbl: "Not Required",
    moreInfoNeededLbl: "More Info Needed",
    otherLbl: "Other"
  };
}, function (c) {
  c.exports = {
    priceLbl: "Prix",
    notRequiredLbl: "Non requis",
    moreInfoNeededLbl: "Plus d'informations nécessaires",
    otherLbl: "Autre"
  };
}, function (c) {
  c.exports = {
    reviewAndApproveServiceHeader: "Review & Approve Services",
    clickHereForInfoText: "Click on each service for more information."
  };
}, function (c) {
  c.exports = {
    reviewAndApproveServiceHeader: "Examiner et approuver les services",
    clickHereForInfoText: "Cliquez sur chaque service pour plus d'informations."
  };
}, function (c) {
  c.exports = {
    yourServicesTitle: "YOUR SERVICES",
    shopSuggestedServiceTitle: "SHOP SUGGESTED SERVICES",
    previouslyApprovedServicesTitle: "PREVIOUSLY APPROVED SERVICES",
    autoApprovedServicesTitle: "AUTO-APPROVED SERVICES"
  };
}, function (c) {
  c.exports = {
    yourServicesTitle: "VOS SERVICES",
    shopSuggestedServiceTitle: "ACHETER LES SERVICES SUGGÉRÉS",
    previouslyApprovedServicesTitle: "SERVICES PRÉCÉDEMMENT APPROUVÉS",
    autoApprovedServicesTitle: "SERVICES AUTORISÉS"
  };
}, function (c) {
  c.exports = {
    hasBeenAutoApprovedText: "This has been auto-approved because there's no cost to you.",
    wasAutoApprovedText: "This was auto-approved because it was requested by you.",
    approvedLbl: "APPROVED",
    savedLbl: "SAVED",
    approveText: "Approve",
    declineText: "Decline",
    whatWillThisCostTitle: "What will this cost?",
    whyShouldIDoThisTitle: "Why Should I Do This?",
    seeDetailsLbl: "See Details",
    whatIfIDeclineTitle: "What If I Decline?"
  };
}, function (c) {
  c.exports = {
    hasBeenAutoApprovedText: "Cela a été auto-approuvé car il n'y a aucun coût pour vous.",
    wasAutoApprovedText: "Cela a été auto-approuvé car vous l'avez demandé.",
    approvedLbl: "APPROUVÉ",
    savedLbl: "ENREGISTRÉE",
    approveText: "Approuver",
    declineText: "Déclin",
    whatWillThisCostTitle: "Combien cela coûtera-t-il?",
    whyShouldIDoThisTitle: "Pourquoi devrais-je faire ça?",
    seeDetailsLbl: "Voir les détails",
    whatIfIDeclineTitle: "Et si je refuse?"
  };
}, function (c) {
  c.exports = {
    approveWorkText: "Approve Work",
    toGetServiceText: "To Get Service",
    approvalInfoDesc: "In order to get the service you want done on your car, approve the service by sliding the toggle to the right",
    approvalToggleButtonAltText: "Approval toggle button",
    gotItText: "Got It!"
  };
}, function (c) {
  c.exports = {
    approveWorkText: "Approuver le travail",
    toGetServiceText: "Pour obtenir un service",
    approvalInfoDesc: "Afin d'obtenir le service que vous souhaitez faire sur votre voiture, approuvez le service en faisant glisser le bouton vers la droite",
    approvalToggleButtonAltText: "Bouton bascule d'approbation",
    gotItText: "Je l'ai!"
  };
}, function (c) {
  c.exports = {
    addNotesToShopPlaceholder: "Add notes to shop",
    remainingCharactersLbl: "Characters remaining:",
    addApprovalsNotesToShopPlaceholder: "Add approver notes to order",
    approversNotesLabel: "APPROVER NOTES",
    saveText: "Save",
    approversNoteLabel: "APPROVER NOTE"
  };
}, function (c) {
  c.exports = {
    addNotesToShopPlaceholder: "Ajouter des notes à la boutique",
    remainingCharactersLbl: "Caractères restants:",
    addApprovalsNotesToShopPlaceholder: "Ajouter des notes d'approbation à la commande",
    approversNotesLabel: "NOTES DE L'APPROBATEUR",
    saveText: "Sauvegarder",
    approversNoteLabel: "NOTE DE L'APPROBATEUR"
  };
}, function (c) {
  c.exports = {
    memberSavingsLbl: "Member Savings",
    subtotalLbl: "Subtotal",
    promotionalDiscountLbl: "Promotional Discount",
    taxAndFeeLbl: "Transaction Fee",
    estimatedTaxLbl: "Estimated Tax",
    TaxLbl: "Tax",
    carAdviseDiscountLbl: "CarAdvise Discount",
    membershipDiscountLbl: "Membership Discount",
    totalPriceLbl: "Total Price",
    totalSavingsLbl: "Total Savings",
    alreadyPaidLbl: "Already Paid",
    totalRefundLbl: "Total Refund",
    totalDueLbl: "Total Due",
    carAdviseCashLbl: "CarAdvise Cash",
    refundWarningMessage: "You are initiating a refund and declining work you prior approved. Be aware that refunds can take a few business days depending on your bank. If you wish to proceed, please press submit. If you don’t, please go back and re-approve those items - the prior payment will apply.",
    transactionFeeTooltip: "The transaction fee includes credit card and administrative fees involved with processing your order.",
    taxTooltip: "This includes applicable sales taxes in your area."
  };
}, function (c) {
  c.exports = {
    memberSavingsLbl: "Économies des membres",
    subtotalLbl: "Total",
    promotionalDiscountLbl: "Remise promotionnelle",
    taxAndFeeLbl: "frais de transaction",
    estimatedTaxLbl: "taxe estimée",
    TaxLbl: "Impôt",
    carAdviseDiscountLbl: "Remise CarAdvise",
    membershipDiscountLbl: "Rabais d'adhésion",
    totalPriceLbl: "Prix ​​total",
    totalSavingsLbl: "Économies totales",
    alreadyPaidLbl: "Déjà payé",
    totalRefundLbl: "Remboursement total",
    totalDueLbl: "Total dû",
    carAdviseCashLbl: "Crédit de CarAdvise",
    refundWarningMessage: "Vous lancez un remboursement et refusez un travail que vous avez préalablement approuvé. Sachez que les remboursements peuvent prendre quelques jours ouvrés selon votre banque. Si vous souhaitez continuer, veuillez appuyer sur Soumettre. Si vous ne le faites pas, veuillez revenir en arrière et approuver à nouveau ces articles - le paiement préalable s'appliquera.",
    transactionFeeTooltip: "Les frais de transaction comprennent les frais de carte de crédit et les frais administratifs liés au traitement de votre commande.",
    taxTooltip: "Cela inclut les taxes de vente applicables dans votre région."
  };
}, function (c) {
  c.exports = {
    creditCardEndingLbl: "Credit Card Ending in",
    paypalAccountLbl: "PayPal Account",
    storedWexCardLbl: "Stored Wex Card Ending in",
    paymentMethodLbl: "Payment Method:",
    fleetcorMethodLbl: "You will be charged by Fuelman card",
    fleetcorMethodChargedLbl: "Charged by Fuelman card",
    paypalAccountChangedLbl: "Charged by PayPal account",
    chooseOptionLbl: "Choose Option",
    NoPaymentMethodUsedLbl: "No payment method used"
  };
}, function (c) {
  c.exports = {
    creditCardEndingLbl: "Carte de crédit se terminant dans",
    paypalAccountLbl: "Compte Paypal",
    storedWexCardLbl: "Carte Wex stockée se terminant dans",
    paymentMethodLbl: "Mode de paiement:",
    fleetcorMethodLbl: "Vous serez débité par carte Fuelman",
    fleetcorMethodChargedLbl: "Chargé par la carte Fuelman",
    paypalAccountChangedLbl: "Facturé par compte PayPal",
    chooseOptionLbl: "Choisissez une option",
    NoPaymentMethodUsedLbl: "Aucun moyen de paiement utilisé"
  };
}, function (c) {
  c.exports = {
    contactForCancellationText: "Please contact Manager or Admin for cancel:",
    cancellationConfirmationMessage: "Are you sure you want cancel?",
    cancelText: "CANCEL"
  };
}, function (c) {
  c.exports = {
    contactForCancellationText: "Veuillez contacter le responsable ou l'administrateur pour annuler:",
    cancellationConfirmationMessage: "Voulez-vous vraiment annuler?",
    cancelText: "ANNULER"
  };
}, function (c) {
  c.exports = {
    confirmApprovalsText: "Confirm Approvals",
    editApprovalsText: "Edit Approvals",
    notApprovingAnyServiceText: "You are NOT approving any services!",
    aboutToApproveServicesDesc1: "You are about to",
    aboutToApproveServicesDesc2: "approve",
    aboutToApproveServicesDesc3: "the following services:",
    confirmApprovedWorkLbl: "Confirm Approved Work",
    chargeCardToBeginWorkLbl: "Your card will be charged and work will begin.",
    submitText: "Submit"
  };
}, function (c) {
  c.exports = {
    confirmApprovalsText: "Confirmer les approbations",
    editApprovalsText: "Modifier les approbations",
    notApprovingAnyServiceText: "Vous n'approuvez aucun service!",
    aboutToApproveServicesDesc1: "Vous êtes sur le point de",
    aboutToApproveServicesDesc2: "approuver",
    aboutToApproveServicesDesc3: "les services suivants:",
    confirmApprovedWorkLbl: "Confirmer le travail approuvé",
    chargeCardToBeginWorkLbl: "Votre carte sera débitée et le travail commencera.",
    submitText: "Soumettre"
  };
}, function (c) {
  c.exports = {
    approveLbl: "Approve",
    declineLbl: "Decline"
  };
}, function (c) {
  c.exports = {
    approveLbl: "Approuver",
    declineLbl: "Déclin"
  };
}, function (c) {
  c.exports = {
    greatPriceLbl: "Great Price",
    goodPriceLbl: "Good Price",
    highPriceLbl: "High Price",
    priceSeemsLittleHighLbl: "This price seems a little high- please",
    priceRangeTitle: "CarAdvise Price Range",
    caradvisePriceTitle: "Your CarAdvise Price"
  };
}, function (c) {
  c.exports = {
    greatPriceLbl: "Super prix",
    goodPriceLbl: "Bon prix",
    highPriceLbl: "Prix ​​élevé",
    priceSeemsLittleHighLbl: "Ce prix semble un peu élevé - veuillez",
    priceRangeTitle: "Gamme de prix CarAdvise",
    caradvisePriceTitle: "Votre prix CarAdvise"
  };
}, function (c) {
  c.exports = {
    noInfoAvailableTitle: "No Information Available",
    noInfoAvailableDesc: "No information is available for this service at this time."
  };
}, function (c) {
  c.exports = {
    noInfoAvailableTitle: "Pas d'information disponible",
    noInfoAvailableDesc: "Aucune information n'est disponible pour ce service pour le moment."
  };
}, function (c) {
  c.exports = {
    whatIsIncludedText: "What Is Included?",
    whyShouldDoThisText: "Why Should I Do This?",
    standardLbl: "standard",
    oilQuartsNeededText: "Yours requires {{oil_quarts_needed}} quarts.",
    oilQuartsNeededDesc: "This includes {{oilDescription}}oil and a standard filter. Note that different vehicles will require various types of non-standard oil, premium filters and more quarts of oil.",
    estimateNotIncludeCostDesc: "This estimate does NOT include the cost of parts, which include:",
    estimateIncludeLaborDesc: "This estimate includes the labor estimate and the cost of parts, which include:",
    estimateIncludeLaborTimeDesc: "This estimate includes the labor time to complete this work.",
    workBeginTimeText: "Estimated Time Once Work Begins:"
  };
}, function (c) {
  c.exports = {
    whatIsIncludedText: "Qu'est-ce qui est inclus?",
    whyShouldDoThisText: "Pourquoi devrais-je faire ça?",
    standardLbl: "la norme",
    oilQuartsNeededText: "Le vôtre nécessite {{oil_quarts_needed}} quarts.",
    oilQuartsNeededDesc: "Cela comprend {{oilDescription}} huile et un filtre standard. Notez que différents véhicules nécessiteront différents types d'huile non standard, des filtres premium et plus de litres d'huile.",
    estimateNotIncludeCostDesc: "Cette estimation n'inclut PAS le coût des pièces, qui comprennent:",
    estimateIncludeLaborDesc: "Cette estimation comprend l'estimation de la main-d'œuvre et le coût des pièces, qui comprennent:",
    estimateIncludeLaborTimeDesc: "Cette estimation comprend le temps de travail nécessaire pour terminer ce travail.",
    workBeginTimeText: "Temps estimé une fois le travail commencé:"
  };
}, function (c) {
  c.exports = {
    regionInfo: "*Region info:",
    region0Text: "Region 0: UNDEFINED REGION or FALLBACK region when none can be found for a shop",
    region1Text: "Region 1 (State that rates are lower than the rest): AR CO ID IA KY MA ME MN MS MT NC ND NE NH NM NV RI SC SD TN UT VT WA WI WV WY",
    region2Text: "Region 2 (State that rates are higher than state 1): AL AZ CT DE FL GA IL IN KS LA MD MI MO OH OK OR PA TX VA",
    region3Text: "Region 3 (State that rates are higher than state 2): AK CA NY NJ",
    region4Text: "Region 4 (Metro):",
    region5Text: "Region 5 (Major Metro):",
    shopLaborRateDesc: "The shop labor rate of {{shop_labor_rate}} was used because no specific pricing entry was found to price this at {{shop_price_estimate}}.",
    shopPricingEntryDesc: "The shop pricing entry of {{shop_pricing_id}} was used to price this at ${{shop_price_estimate}}.",
    statisticalModelDesc: "The statistical model figured out that we should price this at ${{shop_price_estimate}} +/- {{statistical_estimate_stdev}}",
    markupUsedLbl: "Markup Used:",
    serviceDefinitionLbl: "Service Definition:",
    regionUsedLbl: "Region Used",
    baseVehicleServiceLbl: "Base Vehicle Service:",
    fallbackBaseVehicleServiceLbl: "Fallback Base Vehicle Service:",
    oemPartsLbl: "OEM parts:",
    oemManHoursLbl: "OEM man-hours:",
    savedLbl: "Saved:",
    extraQuartsLbl: "Extra quarts:",
    extraQuartsPriceLbl: "Extra quarts price:",
    retailPricingLogicLbl: "Retail Pricing Logic:",
    retailPricingDesc1: "The retail labor rate of {{retail_labor_rate}} was used because no specific pricing entry was found to price this at {{retail_price_estimate}}.",
    retailPricingDesc2: "The retail pricing entry of {{retail_pricing_id}} was used to price this at ${{retail_price_estimate}}.",
    mathHereIsLbl: "The math here is",
    shopPricingLbl: "Shop Pricing Logic:",
    laborAvgLbl: "Labor Avg:",
    partsAvgLbl: "Parts Avg:",
    partsStdevLbl: "Parts Stdev:",
    laborStdevLbl: "Labor Stdev:",
    estimateLbl: "Estimate:",
    stdevLbl: "Stdev:",
    significantLbl: "significant?"
  };
}, function (c) {
  c.exports = {
    regionInfo: "* Info région:",
    region0Text: "Région 0: RÉGION NON DÉFINIE ou région de RETOUR quand aucune ne peut être trouvée pour un magasin",
    region1Text: "Région 1 (indiquer que les taux sont inférieurs aux autres): AR CO ID IA KY MA ME MN MS MT NC ND NE NH NM NV RI SC SD TN UT VT WA WI WV WY",
    region2Text: "Région 2 (indiquer que les taux sont supérieurs à l'état 1): AL AZ CT DE FL GA IL IN KS LA MD MI MO OH OK OU PA TX VA",
    region3Text: "Région 3 (indiquer que les taux sont supérieurs à l'état 2): AK CA NY NJ",
    region4Text: "Région 4 (métro):",
    region5Text: "Région 5 (Grand métro):",
    shopLaborRateDesc: "Le taux de main-d'œuvre de {{shop_labor_rate}} a été utilisé car aucune entrée de prix spécifique n'a été trouvée pour fixer le prix à {{shop_price_estimate}}.",
    shopPricingEntryDesc: "L'entrée de prix de magasin de {{shop_pricing_id}} a été utilisée pour le prix à $ {{shop_price_estimate}}.",
    statisticalModelDesc: "Le modèle statistique a déterminé que nous devrions fixer le prix à $ {{shop_price_estimate}} +/- {{statistics_estimate_stdev}}",
    markupUsedLbl: "Balisage utilisé:",
    serviceDefinitionLbl: "Définition du service:",
    regionUsedLbl: "Région utilisée",
    baseVehicleServiceLbl: "Service de véhicule de base:",
    fallbackBaseVehicleServiceLbl: "Service de véhicule de base de secours:",
    oemPartsLbl: "Pièces OEM:",
    oemManHoursLbl: "Heures de travail OEM:",
    savedLbl: "Enregistrée:",
    extraQuartsLbl: "Quartz supplémentaire:",
    extraQuartsPriceLbl: "Prix ​​supplémentaire en quarts:",
    retailPricingLogicLbl: "Logique des prix de détail:",
    retailPricingDesc1: "Le taux de main-d'œuvre au détail de {{retail_labor_rate}} a été utilisé car aucune entrée de tarification spécifique n'a été trouvée pour fixer le prix à {{retail_price_estimate}}.",
    retailPricingDesc2: "L'entrée de prix de détail de {{retail_pricing_id}} a été utilisée pour fixer le prix à {{retail_price_estimate}} $.",
    mathHereIsLbl: "Le calcul ici est",
    shopPricingLbl: "Logique de prix de la boutique:",
    laborAvgLbl: "Moy. Travail:",
    partsAvgLbl: "Moy. Pièces:",
    partsStdevLbl: "Pièces Stdev:",
    laborStdevLbl: "Labor Stdev:",
    estimateLbl: "Estimation:",
    stdevLbl: "Stdev:",
    significantLbl: "importante?"
  };
}, function (c) {
  c.exports = {
    aseCommentLbl: "ASE COMMENTS:",
    shopCommentsLbl: "SHOP COMMENTS:"
  };
}, function (c) {
  c.exports = {
    aseCommentLbl: "ASE COMMENTS:",
    shopCommentsLbl: "COMMENTAIRES DE LA BOUTIQUE:"
  };
}, function (c) {
  c.exports = {
    andLabel: " and ",
    signingLabel: "By signing in you are agreeing to our ",
    privacyPolicyLabel: "Privacy Policy",
    privacyPolicyUrl: "https://caradvise.com/privacy-policy-ca",
    termsOfUseLabel: "Terms of Use"
  };
}, function (c) {
  c.exports = {
    andLabel: " et ",
    signingLabel: "En vous connectant, vous acceptez notre ",
    privacyPolicyLabel: "Politique de confidentialité",
    privacyPolicyUrl: "https://caradvise.com/privacy-policy-fr",
    termsOfUseLabel: "Conditions d'utilisation"
  };
}, function (c) {
  c.exports = {
    saveText: "Save",
    vanityLbl: "Vanity Name"
  };
}, function (c) {
  c.exports = {
    saveText: "Sauvegarder",
    vanityLbl: "Nom de vanité"
  };
}, function (c, e, a) {
  "use strict";

  a.r(e);
  var n = a(6),
      t = a.n(n),
      r = a(0),
      i = a.n(r),
      o = a(2),
      l = a.n(o),
      f = a(1);

  function s(c) {
    return "/" === c.charAt(0);
  }

  function u(c, e) {
    for (var a = e, n = a + 1, t = c.length; n < t; a += 1, n += 1) {
      c[a] = c[n];
    }

    c.pop();
  }

  var h = function h(c, e) {
    void 0 === e && (e = "");
    var a,
        n = c && c.split("/") || [],
        t = e && e.split("/") || [],
        r = c && s(c),
        i = e && s(e),
        o = r || i;
    if (c && s(c) ? t = n : n.length && (t.pop(), t = t.concat(n)), !t.length) return "/";

    if (t.length) {
      var l = t[t.length - 1];
      a = "." === l || ".." === l || "" === l;
    } else a = !1;

    for (var f = 0, h = t.length; h >= 0; h--) {
      var m = t[h];
      "." === m ? u(t, h) : ".." === m ? (u(t, h), f++) : f && (u(t, h), f--);
    }

    if (!o) for (; f--; f) {
      t.unshift("..");
    }
    !o || "" === t[0] || t[0] && s(t[0]) || t.unshift("");
    var v = t.join("/");
    return a && "/" !== v.substr(-1) && (v += "/"), v;
  };

  function m(c) {
    return c.valueOf ? c.valueOf() : Object.prototype.valueOf.call(c);
  }

  var v = function c(e, a) {
    if (e === a) return !0;
    if (null == e || null == a) return !1;
    if (Array.isArray(e)) return Array.isArray(a) && e.length === a.length && e.every(function (e, n) {
      return c(e, a[n]);
    });

    if ("object" == typeof e || "object" == typeof a) {
      var n = m(e),
          t = m(a);
      return n !== e || t !== a ? c(n, t) : Object.keys(Object.assign({}, e, a)).every(function (n) {
        return c(e[n], a[n]);
      });
    }

    return !1;
  },
      d = !0,
      M = "Invariant failed";

  function p(c, e) {
    if (!c) {
      if (d) throw new Error(M);
      var a = "function" == typeof e ? e() : e,
          n = a ? "".concat(M, ": ").concat(a) : M;
      throw new Error(n);
    }
  }

  function z(c) {
    return "/" === c.charAt(0) ? c : "/" + c;
  }

  function C(c) {
    return "/" === c.charAt(0) ? c.substr(1) : c;
  }

  function L(c, e) {
    return function (c, e) {
      return 0 === c.toLowerCase().indexOf(e.toLowerCase()) && -1 !== "/?#".indexOf(c.charAt(e.length));
    }(c, e) ? c.substr(e.length) : c;
  }

  function A(c) {
    return "/" === c.charAt(c.length - 1) ? c.slice(0, -1) : c;
  }

  function N(c) {
    var e = c.pathname,
        a = c.search,
        n = c.hash,
        t = e || "/";
    return a && "?" !== a && (t += "?" === a.charAt(0) ? a : "?" + a), n && "#" !== n && (t += "#" === n.charAt(0) ? n : "#" + n), t;
  }

  function g(c, e, a, n) {
    var t;
    "string" == typeof c ? (t = function (c) {
      var e = c || "/",
          a = "",
          n = "",
          t = e.indexOf("#");
      -1 !== t && (n = e.substr(t), e = e.substr(0, t));
      var r = e.indexOf("?");
      return -1 !== r && (a = e.substr(r), e = e.substr(0, r)), {
        pathname: e,
        search: "?" === a ? "" : a,
        hash: "#" === n ? "" : n
      };
    }(c)).state = e : (void 0 === (t = Object(f.a)({}, c)).pathname && (t.pathname = ""), t.search ? "?" !== t.search.charAt(0) && (t.search = "?" + t.search) : t.search = "", t.hash ? "#" !== t.hash.charAt(0) && (t.hash = "#" + t.hash) : t.hash = "", void 0 !== e && void 0 === t.state && (t.state = e));

    try {
      t.pathname = decodeURI(t.pathname);
    } catch (c) {
      throw c instanceof URIError ? new URIError('Pathname "' + t.pathname + '" could not be decoded. This is likely caused by an invalid percent-encoding.') : c;
    }

    return a && (t.key = a), n ? t.pathname ? "/" !== t.pathname.charAt(0) && (t.pathname = h(t.pathname, n.pathname)) : t.pathname = n.pathname : t.pathname || (t.pathname = "/"), t;
  }

  function H() {
    var c = null;
    var e = [];
    return {
      setPrompt: function setPrompt(e) {
        return c = e, function () {
          c === e && (c = null);
        };
      },
      confirmTransitionTo: function confirmTransitionTo(e, a, n, t) {
        if (null != c) {
          var r = "function" == typeof c ? c(e, a) : c;
          "string" == typeof r ? "function" == typeof n ? n(r, t) : t(!0) : t(!1 !== r);
        } else t(!0);
      },
      appendListener: function appendListener(c) {
        var a = !0;

        function n() {
          a && c.apply(void 0, arguments);
        }

        return e.push(n), function () {
          a = !1, e = e.filter(function (c) {
            return c !== n;
          });
        };
      },
      notifyListeners: function notifyListeners() {
        for (var c = arguments.length, a = new Array(c), n = 0; n < c; n++) {
          a[n] = arguments[n];
        }

        e.forEach(function (c) {
          return c.apply(void 0, a);
        });
      }
    };
  }

  var V = !("undefined" == typeof window || !window.document || !window.document.createElement);

  function x(c, e) {
    e(window.confirm(c));
  }

  var w = "popstate",
      y = "hashchange";

  function b() {
    try {
      return window.history.state || {};
    } catch (c) {
      return {};
    }
  }

  function S(c) {
    void 0 === c && (c = {}), V || p(!1);
    var e,
        a = window.history,
        n = (-1 === (e = window.navigator.userAgent).indexOf("Android 2.") && -1 === e.indexOf("Android 4.0") || -1 === e.indexOf("Mobile Safari") || -1 !== e.indexOf("Chrome") || -1 !== e.indexOf("Windows Phone")) && window.history && "pushState" in window.history,
        t = !(-1 === window.navigator.userAgent.indexOf("Trident")),
        r = c,
        i = r.forceRefresh,
        o = void 0 !== i && i,
        l = r.getUserConfirmation,
        s = void 0 === l ? x : l,
        u = r.keyLength,
        h = void 0 === u ? 6 : u,
        m = c.basename ? A(z(c.basename)) : "";

    function v(c) {
      var e = c || {},
          a = e.key,
          n = e.state,
          t = window.location,
          r = t.pathname + t.search + t.hash;
      return m && (r = L(r, m)), g(r, n, a);
    }

    function d() {
      return Math.random().toString(36).substr(2, h);
    }

    var M = H();

    function C(c) {
      Object(f.a)(B, c), B.length = a.length, M.notifyListeners(B.location, B.action);
    }

    function S(c) {
      (function (c) {
        return void 0 === c.state && -1 === navigator.userAgent.indexOf("CriOS");
      })(c) || j(v(c.state));
    }

    function T() {
      j(v(b()));
    }

    var D = !1;

    function j(c) {
      if (D) D = !1, C();else {
        M.confirmTransitionTo(c, "POP", s, function (e) {
          e ? C({
            action: "POP",
            location: c
          }) : function (c) {
            var e = B.location,
                a = k.indexOf(e.key);
            -1 === a && (a = 0);
            var n = k.indexOf(c.key);
            -1 === n && (n = 0);
            var t = a - n;
            t && (D = !0, O(t));
          }(c);
        });
      }
    }

    var E = v(b()),
        k = [E.key];

    function I(c) {
      return m + N(c);
    }

    function O(c) {
      a.go(c);
    }

    var Q = 0;

    function Z(c) {
      1 === (Q += c) && 1 === c ? (window.addEventListener(w, S), t && window.addEventListener(y, T)) : 0 === Q && (window.removeEventListener(w, S), t && window.removeEventListener(y, T));
    }

    var U = !1;
    var B = {
      length: a.length,
      action: "POP",
      location: E,
      createHref: I,
      push: function push(c, e) {
        var t = g(c, e, d(), B.location);
        M.confirmTransitionTo(t, "PUSH", s, function (c) {
          if (c) {
            var e = I(t),
                r = t.key,
                i = t.state;
            if (n) {
              if (a.pushState({
                key: r,
                state: i
              }, null, e), o) window.location.href = e;else {
                var l = k.indexOf(B.location.key),
                    f = k.slice(0, l + 1);
                f.push(t.key), k = f, C({
                  action: "PUSH",
                  location: t
                });
              }
            } else window.location.href = e;
          }
        });
      },
      replace: function replace(c, e) {
        var t = g(c, e, d(), B.location);
        M.confirmTransitionTo(t, "REPLACE", s, function (c) {
          if (c) {
            var e = I(t),
                r = t.key,
                i = t.state;
            if (n) {
              if (a.replaceState({
                key: r,
                state: i
              }, null, e), o) window.location.replace(e);else {
                var l = k.indexOf(B.location.key);
                -1 !== l && (k[l] = t.key), C({
                  action: "REPLACE",
                  location: t
                });
              }
            } else window.location.replace(e);
          }
        });
      },
      go: O,
      goBack: function goBack() {
        O(-1);
      },
      goForward: function goForward() {
        O(1);
      },
      block: function block(c) {
        void 0 === c && (c = !1);
        var e = M.setPrompt(c);
        return U || (Z(1), U = !0), function () {
          return U && (U = !1, Z(-1)), e();
        };
      },
      listen: function listen(c) {
        var e = M.appendListener(c);
        return Z(1), function () {
          Z(-1), e();
        };
      }
    };
    return B;
  }

  var T = "hashchange",
      D = {
    hashbang: {
      encodePath: function encodePath(c) {
        return "!" === c.charAt(0) ? c : "!/" + C(c);
      },
      decodePath: function decodePath(c) {
        return "!" === c.charAt(0) ? c.substr(1) : c;
      }
    },
    noslash: {
      encodePath: C,
      decodePath: z
    },
    slash: {
      encodePath: z,
      decodePath: z
    }
  };

  function j(c) {
    var e = c.indexOf("#");
    return -1 === e ? c : c.slice(0, e);
  }

  function E() {
    var c = window.location.href,
        e = c.indexOf("#");
    return -1 === e ? "" : c.substring(e + 1);
  }

  function k(c) {
    window.location.replace(j(window.location.href) + "#" + c);
  }

  function I(c) {
    void 0 === c && (c = {}), V || p(!1);
    var e = window.history,
        a = (window.navigator.userAgent.indexOf("Firefox"), c),
        n = a.getUserConfirmation,
        t = void 0 === n ? x : n,
        r = a.hashType,
        i = void 0 === r ? "slash" : r,
        o = c.basename ? A(z(c.basename)) : "",
        l = D[i],
        s = l.encodePath,
        u = l.decodePath;

    function h() {
      var c = u(E());
      return o && (c = L(c, o)), g(c);
    }

    var m = H();

    function v(c) {
      Object(f.a)(U, c), U.length = e.length, m.notifyListeners(U.location, U.action);
    }

    var d = !1,
        M = null;

    function C() {
      var c,
          e,
          a = E(),
          n = s(a);
      if (a !== n) k(n);else {
        var r = h(),
            i = U.location;
        if (!d && (e = r, (c = i).pathname === e.pathname && c.search === e.search && c.hash === e.hash)) return;
        if (M === N(r)) return;
        M = null, function (c) {
          if (d) d = !1, v();else {
            m.confirmTransitionTo(c, "POP", t, function (e) {
              e ? v({
                action: "POP",
                location: c
              }) : function (c) {
                var e = U.location,
                    a = S.lastIndexOf(N(e));
                -1 === a && (a = 0);
                var n = S.lastIndexOf(N(c));
                -1 === n && (n = 0);
                var t = a - n;
                t && (d = !0, I(t));
              }(c);
            });
          }
        }(r);
      }
    }

    var w = E(),
        y = s(w);
    w !== y && k(y);
    var b = h(),
        S = [N(b)];

    function I(c) {
      e.go(c);
    }

    var O = 0;

    function Q(c) {
      1 === (O += c) && 1 === c ? window.addEventListener(T, C) : 0 === O && window.removeEventListener(T, C);
    }

    var Z = !1;
    var U = {
      length: e.length,
      action: "POP",
      location: b,
      createHref: function createHref(c) {
        var e = document.querySelector("base"),
            a = "";
        return e && e.getAttribute("href") && (a = j(window.location.href)), a + "#" + s(o + N(c));
      },
      push: function push(c, e) {
        var a = g(c, void 0, void 0, U.location);
        m.confirmTransitionTo(a, "PUSH", t, function (c) {
          if (c) {
            var e = N(a),
                n = s(o + e);

            if (E() !== n) {
              M = e, function (c) {
                window.location.hash = c;
              }(n);
              var t = S.lastIndexOf(N(U.location)),
                  r = S.slice(0, t + 1);
              r.push(e), S = r, v({
                action: "PUSH",
                location: a
              });
            } else v();
          }
        });
      },
      replace: function replace(c, e) {
        var a = g(c, void 0, void 0, U.location);
        m.confirmTransitionTo(a, "REPLACE", t, function (c) {
          if (c) {
            var e = N(a),
                n = s(o + e);
            E() !== n && (M = e, k(n));
            var t = S.indexOf(N(U.location));
            -1 !== t && (S[t] = e), v({
              action: "REPLACE",
              location: a
            });
          }
        });
      },
      go: I,
      goBack: function goBack() {
        I(-1);
      },
      goForward: function goForward() {
        I(1);
      },
      block: function block(c) {
        void 0 === c && (c = !1);
        var e = m.setPrompt(c);
        return Z || (Q(1), Z = !0), function () {
          return Z && (Z = !1, Q(-1)), e();
        };
      },
      listen: function listen(c) {
        var e = m.appendListener(c);
        return Q(1), function () {
          Q(-1), e();
        };
      }
    };
    return U;
  }

  function O(c, e, a) {
    return Math.min(Math.max(c, e), a);
  }

  var Q = a(7),
      Z = a.n(Q),
      U = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  };

  function B(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var R = function (c) {
    function e() {
      var a, n;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) {
        r[i] = arguments[i];
      }

      return a = n = B(this, c.call.apply(c, [this].concat(r))), n.state = {
        match: n.computeMatch(n.props.history.location.pathname)
      }, B(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, c), e.prototype.getChildContext = function () {
      return {
        router: U({}, this.context.router, {
          history: this.props.history,
          route: {
            location: this.props.history.location,
            match: this.state.match
          }
        })
      };
    }, e.prototype.computeMatch = function (c) {
      return {
        path: "/",
        url: "/",
        params: {},
        isExact: "/" === c
      };
    }, e.prototype.componentWillMount = function () {
      var c = this,
          e = this.props,
          a = e.children,
          n = e.history;
      Z()(null == a || 1 === i.a.Children.count(a), "A <Router> may have only one child element"), this.unlisten = n.listen(function () {
        c.setState({
          match: c.computeMatch(n.location.pathname)
        });
      });
    }, e.prototype.componentWillReceiveProps = function (c) {
      t()(this.props.history === c.history, "You cannot change <Router history>");
    }, e.prototype.componentWillUnmount = function () {
      this.unlisten();
    }, e.prototype.render = function () {
      var c = this.props.children;
      return c ? i.a.Children.only(c) : null;
    }, e;
  }(i.a.Component);

  R.propTypes = {
    history: l.a.object.isRequired,
    children: l.a.node
  }, R.contextTypes = {
    router: l.a.object
  }, R.childContextTypes = {
    router: l.a.object.isRequired
  };
  var Y = R,
      P = Y;

  function F(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var W = function (c) {
    function e() {
      var a, n;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) {
        r[i] = arguments[i];
      }

      return a = n = F(this, c.call.apply(c, [this].concat(r))), n.history = S(n.props), F(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, c), e.prototype.componentWillMount = function () {
      t()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { BrowserRouter as Router }`.");
    }, e.prototype.render = function () {
      return i.a.createElement(P, {
        history: this.history,
        children: this.props.children
      });
    }, e;
  }(i.a.Component);

  W.propTypes = {
    basename: l.a.string,
    forceRefresh: l.a.bool,
    getUserConfirmation: l.a.func,
    keyLength: l.a.number,
    children: l.a.node
  };
  var G = W;

  function q(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var J = function (c) {
    function e() {
      var a, n;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) {
        r[i] = arguments[i];
      }

      return a = n = q(this, c.call.apply(c, [this].concat(r))), n.history = I(n.props), q(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, c), e.prototype.componentWillMount = function () {
      t()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { HashRouter as Router }`.");
    }, e.prototype.render = function () {
      return i.a.createElement(P, {
        history: this.history,
        children: this.props.children
      });
    }, e;
  }(i.a.Component);

  J.propTypes = {
    basename: l.a.string,
    getUserConfirmation: l.a.func,
    hashType: l.a.oneOf(["hashbang", "noslash", "slash"]),
    children: l.a.node
  };

  var K = J,
      X = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  };

  function _(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var $ = function $(c) {
    return !!(c.metaKey || c.altKey || c.ctrlKey || c.shiftKey);
  },
      cc = function (c) {
    function e() {
      var a, n;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) {
        r[i] = arguments[i];
      }

      return a = n = _(this, c.call.apply(c, [this].concat(r))), n.handleClick = function (c) {
        if (n.props.onClick && n.props.onClick(c), !c.defaultPrevented && 0 === c.button && !n.props.target && !$(c)) {
          c.preventDefault();
          var e = n.context.router.history,
              a = n.props,
              t = a.replace,
              r = a.to;
          t ? e.replace(r) : e.push(r);
        }
      }, _(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, c), e.prototype.render = function () {
      var c = this.props,
          e = (c.replace, c.to),
          a = c.innerRef,
          n = function (c, e) {
        var a = {};

        for (var n in c) {
          e.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(c, n) && (a[n] = c[n]);
        }

        return a;
      }(c, ["replace", "to", "innerRef"]);

      Z()(this.context.router, "You should not use <Link> outside a <Router>"), Z()(void 0 !== e, 'You must specify the "to" property');
      var t = this.context.router.history,
          r = "string" == typeof e ? g(e, null, null, t.location) : e,
          o = t.createHref(r);
      return i.a.createElement("a", X({}, n, {
        onClick: this.handleClick,
        href: o,
        ref: a
      }));
    }, e;
  }(i.a.Component);

  cc.propTypes = {
    onClick: l.a.func,
    target: l.a.string,
    replace: l.a.bool,
    to: l.a.oneOfType([l.a.string, l.a.object]).isRequired,
    innerRef: l.a.oneOfType([l.a.string, l.a.func])
  }, cc.defaultProps = {
    replace: !1
  }, cc.contextTypes = {
    router: l.a.shape({
      history: l.a.shape({
        push: l.a.func.isRequired,
        replace: l.a.func.isRequired,
        createHref: l.a.func.isRequired
      }).isRequired
    }).isRequired
  };
  var ec = cc;

  function ac(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var nc = function (c) {
    function e() {
      var a, n;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) {
        r[i] = arguments[i];
      }

      return a = n = ac(this, c.call.apply(c, [this].concat(r))), n.history = function (c) {
        void 0 === c && (c = {});
        var e = c,
            a = e.getUserConfirmation,
            n = e.initialEntries,
            t = void 0 === n ? ["/"] : n,
            r = e.initialIndex,
            i = void 0 === r ? 0 : r,
            o = e.keyLength,
            l = void 0 === o ? 6 : o,
            s = H();

        function u(c) {
          Object(f.a)(p, c), p.length = p.entries.length, s.notifyListeners(p.location, p.action);
        }

        function h() {
          return Math.random().toString(36).substr(2, l);
        }

        var m = O(i, 0, t.length - 1),
            v = t.map(function (c) {
          return g(c, void 0, "string" == typeof c ? h() : c.key || h());
        }),
            d = N;

        function M(c) {
          var e = O(p.index + c, 0, p.entries.length - 1),
              n = p.entries[e];
          s.confirmTransitionTo(n, "POP", a, function (c) {
            c ? u({
              action: "POP",
              location: n,
              index: e
            }) : u();
          });
        }

        var p = {
          length: v.length,
          action: "POP",
          location: v[m],
          index: m,
          entries: v,
          createHref: d,
          push: function push(c, e) {
            var n = g(c, e, h(), p.location);
            s.confirmTransitionTo(n, "PUSH", a, function (c) {
              if (c) {
                var e = p.index + 1,
                    a = p.entries.slice(0);
                a.length > e ? a.splice(e, a.length - e, n) : a.push(n), u({
                  action: "PUSH",
                  location: n,
                  index: e,
                  entries: a
                });
              }
            });
          },
          replace: function replace(c, e) {
            var n = g(c, e, h(), p.location);
            s.confirmTransitionTo(n, "REPLACE", a, function (c) {
              c && (p.entries[p.index] = n, u({
                action: "REPLACE",
                location: n
              }));
            });
          },
          go: M,
          goBack: function goBack() {
            M(-1);
          },
          goForward: function goForward() {
            M(1);
          },
          canGo: function canGo(c) {
            var e = p.index + c;
            return e >= 0 && e < p.entries.length;
          },
          block: function block(c) {
            return void 0 === c && (c = !1), s.setPrompt(c);
          },
          listen: function listen(c) {
            return s.appendListener(c);
          }
        };
        return p;
      }(n.props), ac(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, c), e.prototype.componentWillMount = function () {
      t()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { MemoryRouter as Router }`.");
    }, e.prototype.render = function () {
      return i.a.createElement(Y, {
        history: this.history,
        children: this.props.children
      });
    }, e;
  }(i.a.Component);

  nc.propTypes = {
    initialEntries: l.a.array,
    initialIndex: l.a.number,
    getUserConfirmation: l.a.func,
    keyLength: l.a.number,
    children: l.a.node
  };

  var tc = nc,
      rc = a(39),
      ic = a.n(rc),
      oc = {},
      lc = 0,
      fc = function fc(c) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        a = arguments[2];
    "string" == typeof e && (e = {
      path: e
    });
    var n = e,
        t = n.path,
        r = n.exact,
        i = void 0 !== r && r,
        o = n.strict,
        l = void 0 !== o && o,
        f = n.sensitive;
    if (null == t) return a;

    var s = function (c, e) {
      var a = "" + e.end + e.strict + e.sensitive,
          n = oc[a] || (oc[a] = {});
      if (n[c]) return n[c];
      var t = [],
          r = {
        re: ic()(c, t, e),
        keys: t
      };
      return lc < 1e4 && (n[c] = r, lc++), r;
    }(t, {
      end: i,
      strict: l,
      sensitive: void 0 !== f && f
    }),
        u = s.re,
        h = s.keys,
        m = u.exec(c);

    if (!m) return null;
    var v = m[0],
        d = m.slice(1),
        M = c === v;
    return i && !M ? null : {
      path: t,
      url: "/" === t && "" === v ? "/" : v,
      isExact: M,
      params: h.reduce(function (c, e, a) {
        return c[e.name] = d[a], c;
      }, {})
    };
  },
      sc = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  };

  function uc(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var hc = function hc(c) {
    return 0 === i.a.Children.count(c);
  },
      mc = function (c) {
    function e() {
      var a, n;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) {
        r[i] = arguments[i];
      }

      return a = n = uc(this, c.call.apply(c, [this].concat(r))), n.state = {
        match: n.computeMatch(n.props, n.context.router)
      }, uc(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, c), e.prototype.getChildContext = function () {
      return {
        router: sc({}, this.context.router, {
          route: {
            location: this.props.location || this.context.router.route.location,
            match: this.state.match
          }
        })
      };
    }, e.prototype.computeMatch = function (c, e) {
      var a = c.computedMatch,
          n = c.location,
          t = c.path,
          r = c.strict,
          i = c.exact,
          o = c.sensitive;
      if (a) return a;
      Z()(e, "You should not use <Route> or withRouter() outside a <Router>");
      var l = e.route,
          f = (n || l.location).pathname;
      return fc(f, {
        path: t,
        strict: r,
        exact: i,
        sensitive: o
      }, l.match);
    }, e.prototype.componentWillMount = function () {
      t()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored"), t()(!(this.props.component && this.props.children && !hc(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored"), t()(!(this.props.render && this.props.children && !hc(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    }, e.prototype.componentWillReceiveProps = function (c, e) {
      t()(!(c.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.'), t()(!(!c.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.'), this.setState({
        match: this.computeMatch(c, e.router)
      });
    }, e.prototype.render = function () {
      var c = this.state.match,
          e = this.props,
          a = e.children,
          n = e.component,
          t = e.render,
          r = this.context.router,
          o = r.history,
          l = r.route,
          f = r.staticContext,
          s = {
        match: c,
        location: this.props.location || l.location,
        history: o,
        staticContext: f
      };
      return n ? c ? i.a.createElement(n, s) : null : t ? c ? t(s) : null : "function" == typeof a ? a(s) : a && !hc(a) ? i.a.Children.only(a) : null;
    }, e;
  }(i.a.Component);

  mc.propTypes = {
    computedMatch: l.a.object,
    path: l.a.string,
    exact: l.a.bool,
    strict: l.a.bool,
    sensitive: l.a.bool,
    component: l.a.func,
    render: l.a.func,
    children: l.a.oneOfType([l.a.func, l.a.node]),
    location: l.a.object
  }, mc.contextTypes = {
    router: l.a.shape({
      history: l.a.object.isRequired,
      route: l.a.object.isRequired,
      staticContext: l.a.object
    })
  }, mc.childContextTypes = {
    router: l.a.object.isRequired
  };

  var vc = mc,
      dc = vc,
      Mc = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  },
      pc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (c) {
    return typeof c;
  } : function (c) {
    return c && "function" == typeof Symbol && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
  };

  var zc = function zc(c) {
    var e = c.to,
        a = c.exact,
        n = c.strict,
        t = c.location,
        r = c.activeClassName,
        o = c.className,
        l = c.activeStyle,
        f = c.style,
        s = c.isActive,
        u = c["aria-current"],
        h = function (c, e) {
      var a = {};

      for (var n in c) {
        e.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(c, n) && (a[n] = c[n]);
      }

      return a;
    }(c, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]),
        m = "object" === (void 0 === e ? "undefined" : pc(e)) ? e.pathname : e,
        v = m && m.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");

    return i.a.createElement(dc, {
      path: v,
      exact: a,
      strict: n,
      location: t,
      children: function children(c) {
        var a = c.location,
            n = c.match,
            t = !!(s ? s(n, a) : n);
        return i.a.createElement(ec, Mc({
          to: e,
          className: t ? [o, r].filter(function (c) {
            return c;
          }).join(" ") : o,
          style: t ? Mc({}, f, l) : f,
          "aria-current": t && u || null
        }, h));
      }
    });
  };

  zc.propTypes = {
    to: ec.propTypes.to,
    exact: l.a.bool,
    strict: l.a.bool,
    location: l.a.object,
    activeClassName: l.a.string,
    className: l.a.string,
    activeStyle: l.a.object,
    style: l.a.object,
    isActive: l.a.func,
    "aria-current": l.a.oneOf(["page", "step", "location", "date", "time", "true"])
  }, zc.defaultProps = {
    activeClassName: "active",
    "aria-current": "page"
  };
  var Cc = zc;

  var Lc = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, c.apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, c), e.prototype.enable = function (c) {
      this.unblock && this.unblock(), this.unblock = this.context.router.history.block(c);
    }, e.prototype.disable = function () {
      this.unblock && (this.unblock(), this.unblock = null);
    }, e.prototype.componentWillMount = function () {
      Z()(this.context.router, "You should not use <Prompt> outside a <Router>"), this.props.when && this.enable(this.props.message);
    }, e.prototype.componentWillReceiveProps = function (c) {
      c.when ? this.props.when && this.props.message === c.message || this.enable(c.message) : this.disable();
    }, e.prototype.componentWillUnmount = function () {
      this.disable();
    }, e.prototype.render = function () {
      return null;
    }, e;
  }(i.a.Component);

  Lc.propTypes = {
    when: l.a.bool,
    message: l.a.oneOfType([l.a.func, l.a.string]).isRequired
  }, Lc.defaultProps = {
    when: !0
  }, Lc.contextTypes = {
    router: l.a.shape({
      history: l.a.shape({
        block: l.a.func.isRequired
      }).isRequired
    }).isRequired
  };

  var Ac = Lc,
      Nc = {},
      gc = 0,
      Hc = function Hc() {
    var c = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "/",
        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return "/" === c ? c : function (c) {
      var e = c,
          a = Nc[e] || (Nc[e] = {});
      if (a[c]) return a[c];
      var n = ic.a.compile(c);
      return gc < 1e4 && (a[c] = n, gc++), n;
    }(c)(e, {
      pretty: !0
    });
  },
      Vc = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  };

  var xc = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, c.apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, c), e.prototype.isStatic = function () {
      return this.context.router && this.context.router.staticContext;
    }, e.prototype.componentWillMount = function () {
      Z()(this.context.router, "You should not use <Redirect> outside a <Router>"), this.isStatic() && this.perform();
    }, e.prototype.componentDidMount = function () {
      this.isStatic() || this.perform();
    }, e.prototype.componentDidUpdate = function (c) {
      var e,
          a,
          n = g(c.to),
          r = g(this.props.to);
      (a = r, (e = n).pathname === a.pathname && e.search === a.search && e.hash === a.hash && e.key === a.key && v(e.state, a.state)) ? t()(!1, "You tried to redirect to the same route you're currently on: \"" + r.pathname + r.search + '"') : this.perform();
    }, e.prototype.computeTo = function (c) {
      var e = c.computedMatch,
          a = c.to;
      return e ? "string" == typeof a ? Hc(a, e.params) : Vc({}, a, {
        pathname: Hc(a.pathname, e.params)
      }) : a;
    }, e.prototype.perform = function () {
      var c = this.context.router.history,
          e = this.props.push,
          a = this.computeTo(this.props);
      e ? c.push(a) : c.replace(a);
    }, e.prototype.render = function () {
      return null;
    }, e;
  }(i.a.Component);

  xc.propTypes = {
    computedMatch: l.a.object,
    push: l.a.bool,
    from: l.a.string,
    to: l.a.oneOfType([l.a.string, l.a.object]).isRequired
  }, xc.defaultProps = {
    push: !1
  }, xc.contextTypes = {
    router: l.a.shape({
      history: l.a.shape({
        push: l.a.func.isRequired,
        replace: l.a.func.isRequired
      }).isRequired,
      staticContext: l.a.object
    }).isRequired
  };

  var wc = xc,
      yc = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  };

  function bc(c, e) {
    if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? c : e;
  }

  var Sc = function Sc(c) {
    return "/" === c.charAt(0) ? c : "/" + c;
  },
      Tc = function Tc(c, e) {
    return c ? yc({}, e, {
      pathname: Sc(c) + e.pathname
    }) : e;
  },
      Dc = function Dc(c, e) {
    if (!c) return e;
    var a = Sc(c);
    return 0 !== e.pathname.indexOf(a) ? e : yc({}, e, {
      pathname: e.pathname.substr(a.length)
    });
  },
      jc = function jc(c) {
    return "string" == typeof c ? c : N(c);
  },
      Ec = function Ec(c) {
    return function () {
      Z()(!1, "You cannot %s with <StaticRouter>", c);
    };
  },
      kc = function kc() {},
      Ic = function (c) {
    function e() {
      var a, n;
      !function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) {
        r[i] = arguments[i];
      }

      return a = n = bc(this, c.call.apply(c, [this].concat(r))), n.createHref = function (c) {
        return Sc(n.props.basename + jc(c));
      }, n.handlePush = function (c) {
        var e = n.props,
            a = e.basename,
            t = e.context;
        t.action = "PUSH", t.location = Tc(a, g(c)), t.url = jc(t.location);
      }, n.handleReplace = function (c) {
        var e = n.props,
            a = e.basename,
            t = e.context;
        t.action = "REPLACE", t.location = Tc(a, g(c)), t.url = jc(t.location);
      }, n.handleListen = function () {
        return kc;
      }, n.handleBlock = function () {
        return kc;
      }, bc(n, a);
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, c), e.prototype.getChildContext = function () {
      return {
        router: {
          staticContext: this.props.context
        }
      };
    }, e.prototype.componentWillMount = function () {
      t()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { StaticRouter as Router }`.");
    }, e.prototype.render = function () {
      var c = this.props,
          e = c.basename,
          a = (c.context, c.location),
          n = function (c, e) {
        var a = {};

        for (var n in c) {
          e.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(c, n) && (a[n] = c[n]);
        }

        return a;
      }(c, ["basename", "context", "location"]),
          t = {
        createHref: this.createHref,
        action: "POP",
        location: Dc(e, g(a)),
        push: this.handlePush,
        replace: this.handleReplace,
        go: Ec("go"),
        goBack: Ec("goBack"),
        goForward: Ec("goForward"),
        listen: this.handleListen,
        block: this.handleBlock
      };

      return i.a.createElement(Y, yc({}, n, {
        history: t
      }));
    }, e;
  }(i.a.Component);

  Ic.propTypes = {
    basename: l.a.string,
    context: l.a.object.isRequired,
    location: l.a.oneOfType([l.a.string, l.a.object])
  }, Ic.defaultProps = {
    basename: "",
    location: "/"
  }, Ic.childContextTypes = {
    router: l.a.object.isRequired
  };
  var Oc = Ic;

  var Qc = function (c) {
    function e() {
      return function (c, e) {
        if (!(c instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (c, e) {
        if (!c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? c : e;
      }(this, c.apply(this, arguments));
    }

    return function (c, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      c.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: c,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(c, e) : c.__proto__ = e);
    }(e, c), e.prototype.componentWillMount = function () {
      Z()(this.context.router, "You should not use <Switch> outside a <Router>");
    }, e.prototype.componentWillReceiveProps = function (c) {
      t()(!(c.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.'), t()(!(!c.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    }, e.prototype.render = function () {
      var c = this.context.router.route,
          e = this.props.children,
          a = this.props.location || c.location,
          n = void 0,
          t = void 0;
      return i.a.Children.forEach(e, function (e) {
        if (null == n && i.a.isValidElement(e)) {
          var r = e.props,
              o = r.path,
              l = r.exact,
              f = r.strict,
              s = r.sensitive,
              u = r.from,
              h = o || u;
          t = e, n = fc(a.pathname, {
            path: h,
            exact: l,
            strict: f,
            sensitive: s
          }, c.match);
        }
      }), n ? i.a.cloneElement(t, {
        location: a,
        computedMatch: n
      }) : null;
    }, e;
  }(i.a.Component);

  Qc.contextTypes = {
    router: l.a.shape({
      route: l.a.object.isRequired
    }).isRequired
  }, Qc.propTypes = {
    children: l.a.node,
    location: l.a.object
  };

  var Zc = Qc,
      Uc = Hc,
      Bc = fc,
      Rc = a(93),
      Yc = a.n(Rc),
      Pc = Object.assign || function (c) {
    for (var e = 1; e < arguments.length; e++) {
      var a = arguments[e];

      for (var n in a) {
        Object.prototype.hasOwnProperty.call(a, n) && (c[n] = a[n]);
      }
    }

    return c;
  };

  var Fc = function Fc(c) {
    var e = function e(_e2) {
      var a = _e2.wrappedComponentRef,
          n = function (c, e) {
        var a = {};

        for (var n in c) {
          e.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(c, n) && (a[n] = c[n]);
        }

        return a;
      }(_e2, ["wrappedComponentRef"]);

      return i.a.createElement(vc, {
        children: function children(e) {
          return i.a.createElement(c, Pc({}, n, e, {
            ref: a
          }));
        }
      });
    };

    return e.displayName = "withRouter(" + (c.displayName || c.name) + ")", e.WrappedComponent = c, e.propTypes = {
      wrappedComponentRef: l.a.func
    }, Yc()(e, c);
  };

  a.d(e, "BrowserRouter", function () {
    return G;
  }), a.d(e, "HashRouter", function () {
    return K;
  }), a.d(e, "Link", function () {
    return ec;
  }), a.d(e, "MemoryRouter", function () {
    return tc;
  }), a.d(e, "NavLink", function () {
    return Cc;
  }), a.d(e, "Prompt", function () {
    return Ac;
  }), a.d(e, "Redirect", function () {
    return wc;
  }), a.d(e, "Route", function () {
    return dc;
  }), a.d(e, "Router", function () {
    return P;
  }), a.d(e, "StaticRouter", function () {
    return Oc;
  }), a.d(e, "Switch", function () {
    return Zc;
  }), a.d(e, "generatePath", function () {
    return Uc;
  }), a.d(e, "matchPath", function () {
    return Bc;
  }), a.d(e, "withRouter", function () {
    return Fc;
  });
}, function (c, e, a) {
  "use strict";

  a.r(e);
  var n = a(3),
      t = a(0),
      r = a.n(t),
      i = a(2),
      o = a.n(i),
      l = o.a.shape({
    trySubscribe: o.a.func.isRequired,
    tryUnsubscribe: o.a.func.isRequired,
    notifyNestedSubs: o.a.func.isRequired,
    isSubscribed: o.a.func.isRequired
  }),
      f = o.a.shape({
    subscribe: o.a.func.isRequired,
    dispatch: o.a.func.isRequired,
    getState: o.a.func.isRequired
  });
  r.a.forwardRef;

  function s(c) {
    var e;
    void 0 === c && (c = "store");

    var a = c + "Subscription",
        r = function (e) {
      Object(n.a)(i, e);
      var r = i.prototype;

      function i(a, n) {
        var t;
        return (t = e.call(this, a, n) || this)[c] = a.store, t;
      }

      return r.getChildContext = function () {
        var e;
        return (e = {})[c] = this[c], e[a] = null, e;
      }, r.render = function () {
        return t.Children.only(this.props.children);
      }, i;
    }(t.Component);

    return r.propTypes = {
      store: f.isRequired,
      children: o.a.element.isRequired
    }, r.childContextTypes = ((e = {})[c] = f.isRequired, e[a] = l, e), r;
  }

  var u = s(),
      h = a(28),
      m = a(1),
      v = a(8),
      d = a(94),
      M = a.n(d),
      p = a(7),
      z = a.n(p),
      C = a(27),
      L = null,
      A = {
    notify: function notify() {}
  };

  var N = function () {
    function c(c, e, a) {
      this.store = c, this.parentSub = e, this.onStateChange = a, this.unsubscribe = null, this.listeners = A;
    }

    var e = c.prototype;
    return e.addNestedSub = function (c) {
      return this.trySubscribe(), this.listeners.subscribe(c);
    }, e.notifyNestedSubs = function () {
      this.listeners.notify();
    }, e.isSubscribed = function () {
      return Boolean(this.unsubscribe);
    }, e.trySubscribe = function () {
      var c, e;
      this.unsubscribe || (this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange), this.listeners = (c = [], e = [], {
        clear: function clear() {
          e = L, c = L;
        },
        notify: function notify() {
          for (var a = c = e, n = 0; n < a.length; n++) {
            a[n]();
          }
        },
        get: function get() {
          return e;
        },
        subscribe: function subscribe(a) {
          var n = !0;
          return e === c && (e = c.slice()), e.push(a), function () {
            n && c !== L && (n = !1, e === c && (e = c.slice()), e.splice(e.indexOf(a), 1));
          };
        }
      }));
    }, e.tryUnsubscribe = function () {
      this.unsubscribe && (this.unsubscribe(), this.unsubscribe = null, this.listeners.clear(), this.listeners = A);
    }, c;
  }(),
      g = void 0 !== r.a.forwardRef,
      H = 0,
      V = {};

  function x() {}

  function w(c, e) {
    var a, r;
    void 0 === e && (e = {});
    var i = e,
        o = i.getDisplayName,
        s = void 0 === o ? function (c) {
      return "ConnectAdvanced(" + c + ")";
    } : o,
        u = i.methodName,
        d = void 0 === u ? "connectAdvanced" : u,
        p = i.renderCountProp,
        L = void 0 === p ? void 0 : p,
        A = i.shouldHandleStateChanges,
        w = void 0 === A || A,
        y = i.storeKey,
        b = void 0 === y ? "store" : y,
        S = i.withRef,
        T = void 0 !== S && S,
        D = Object(v.a)(i, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]),
        j = b + "Subscription",
        E = H++,
        k = ((a = {})[b] = f, a[j] = l, a),
        I = ((r = {})[j] = l, r);
    return function (e) {
      z()(Object(C.isValidElementType)(e), "You must pass a component to the function returned by " + d + ". Instead received " + JSON.stringify(e));

      var a = e.displayName || e.name || "Component",
          r = s(a),
          i = Object(m.a)({}, D, {
        getDisplayName: s,
        methodName: d,
        renderCountProp: L,
        shouldHandleStateChanges: w,
        storeKey: b,
        withRef: T,
        displayName: r,
        wrappedComponentName: a,
        WrappedComponent: e
      }),
          o = function (a) {
        function o(c, e) {
          var n;
          return (n = a.call(this, c, e) || this).version = E, n.state = {}, n.renderCount = 0, n.store = c[b] || e[b], n.propsMode = Boolean(c[b]), n.setWrappedInstance = n.setWrappedInstance.bind(Object(h.a)(Object(h.a)(n))), z()(n.store, 'Could not find "' + b + '" in either the context or props of "' + r + '". Either wrap the root component in a <Provider>, or explicitly pass "' + b + '" as a prop to "' + r + '".'), n.initSelector(), n.initSubscription(), n;
        }

        Object(n.a)(o, a);
        var l = o.prototype;
        return l.getChildContext = function () {
          var c,
              e = this.propsMode ? null : this.subscription;
          return (c = {})[j] = e || this.context[j], c;
        }, l.componentDidMount = function () {
          w && (this.subscription.trySubscribe(), this.selector.run(this.props), this.selector.shouldComponentUpdate && this.forceUpdate());
        }, l.componentWillReceiveProps = function (c) {
          this.selector.run(c);
        }, l.shouldComponentUpdate = function () {
          return this.selector.shouldComponentUpdate;
        }, l.componentWillUnmount = function () {
          this.subscription && this.subscription.tryUnsubscribe(), this.subscription = null, this.notifyNestedSubs = x, this.store = null, this.selector.run = x, this.selector.shouldComponentUpdate = !1;
        }, l.getWrappedInstance = function () {
          return z()(T, "To access the wrapped instance, you need to specify { withRef: true } in the options argument of the " + d + "() call."), this.wrappedInstance;
        }, l.setWrappedInstance = function (c) {
          this.wrappedInstance = c;
        }, l.initSelector = function () {
          var e = c(this.store.dispatch, i);
          this.selector = function (c, e) {
            var a = {
              run: function run(n) {
                try {
                  var t = c(e.getState(), n);
                  (t !== a.props || a.error) && (a.shouldComponentUpdate = !0, a.props = t, a.error = null);
                } catch (c) {
                  a.shouldComponentUpdate = !0, a.error = c;
                }
              }
            };
            return a;
          }(e, this.store), this.selector.run(this.props);
        }, l.initSubscription = function () {
          if (w) {
            var c = (this.propsMode ? this.props : this.context)[j];
            this.subscription = new N(this.store, c, this.onStateChange.bind(this)), this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
          }
        }, l.onStateChange = function () {
          this.selector.run(this.props), this.selector.shouldComponentUpdate ? (this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate, this.setState(V)) : this.notifyNestedSubs();
        }, l.notifyNestedSubsOnComponentDidUpdate = function () {
          this.componentDidUpdate = void 0, this.notifyNestedSubs();
        }, l.isSubscribed = function () {
          return Boolean(this.subscription) && this.subscription.isSubscribed();
        }, l.addExtraProps = function (c) {
          if (!(T || L || this.propsMode && this.subscription)) return c;
          var e = Object(m.a)({}, c);
          return T && (e.ref = this.setWrappedInstance), L && (e[L] = this.renderCount++), this.propsMode && this.subscription && (e[j] = this.subscription), e;
        }, l.render = function () {
          var c = this.selector;
          if (c.shouldComponentUpdate = !1, c.error) throw c.error;
          return Object(t.createElement)(e, this.addExtraProps(c.props));
        }, o;
      }(t.Component);

      return g && (o.prototype.UNSAFE_componentWillReceiveProps = o.prototype.componentWillReceiveProps, delete o.prototype.componentWillReceiveProps), o.WrappedComponent = e, o.displayName = r, o.childContextTypes = I, o.contextTypes = k, o.propTypes = k, M()(o, e);
    };
  }

  var y = Object.prototype.hasOwnProperty;

  function b(c, e) {
    return c === e ? 0 !== c || 0 !== e || 1 / c == 1 / e : c != c && e != e;
  }

  function S(c, e) {
    if (b(c, e)) return !0;
    if ("object" != typeof c || null === c || "object" != typeof e || null === e) return !1;
    var a = Object.keys(c),
        n = Object.keys(e);
    if (a.length !== n.length) return !1;

    for (var t = 0; t < a.length; t++) {
      if (!y.call(e, a[t]) || !b(c[a[t]], e[a[t]])) return !1;
    }

    return !0;
  }

  a(41);

  function T(c) {
    return "Minified Redux error #" + c + "; visit https://redux.js.org/Errors?code=" + c + " for the full message or use the non-minified dev environment for full errors. ";
  }

  "function" == typeof Symbol && Symbol.observable;

  var D = function D() {
    return Math.random().toString(36).substring(7).split("").join(".");
  };

  D(), D();

  function j(c, e) {
    return function () {
      return e(c.apply(this, arguments));
    };
  }

  function E(c) {
    return function (e, a) {
      var n = c(e, a);

      function t() {
        return n;
      }

      return t.dependsOnOwnProps = !1, t;
    };
  }

  function k(c) {
    return null !== c.dependsOnOwnProps && void 0 !== c.dependsOnOwnProps ? Boolean(c.dependsOnOwnProps) : 1 !== c.length;
  }

  function I(c, e) {
    return function (e, a) {
      a.displayName;

      var n = function n(c, e) {
        return n.dependsOnOwnProps ? n.mapToProps(c, e) : n.mapToProps(c);
      };

      return n.dependsOnOwnProps = !0, n.mapToProps = function (e, a) {
        n.mapToProps = c, n.dependsOnOwnProps = k(c);
        var t = n(e, a);
        return "function" == typeof t && (n.mapToProps = t, n.dependsOnOwnProps = k(t), t = n(e, a)), t;
      }, n;
    };
  }

  var O = [function (c) {
    return "function" == typeof c ? I(c) : void 0;
  }, function (c) {
    return c ? void 0 : E(function (c) {
      return {
        dispatch: c
      };
    });
  }, function (c) {
    return c && "object" == typeof c ? E(function (e) {
      return function (c, e) {
        if ("function" == typeof c) return j(c, e);
        if ("object" != typeof c || null === c) throw new Error(T(16));
        var a = {};

        for (var n in c) {
          var t = c[n];
          "function" == typeof t && (a[n] = j(t, e));
        }

        return a;
      }(c, e);
    }) : void 0;
  }];
  var Q = [function (c) {
    return "function" == typeof c ? I(c) : void 0;
  }, function (c) {
    return c ? void 0 : E(function () {
      return {};
    });
  }];

  function Z(c, e, a) {
    return Object(m.a)({}, a, c, e);
  }

  var U = [function (c) {
    return "function" == typeof c ? function (c) {
      return function (e, a) {
        a.displayName;
        var n,
            t = a.pure,
            r = a.areMergedPropsEqual,
            i = !1;
        return function (e, a, o) {
          var l = c(e, a, o);
          return i ? t && r(l, n) || (n = l) : (i = !0, n = l), n;
        };
      };
    }(c) : void 0;
  }, function (c) {
    return c ? void 0 : function () {
      return Z;
    };
  }];

  function B(c, e, a, n) {
    return function (t, r) {
      return a(c(t, r), e(n, r), r);
    };
  }

  function R(c, e, a, n, t) {
    var r,
        i,
        o,
        l,
        f,
        s = t.areStatesEqual,
        u = t.areOwnPropsEqual,
        h = t.areStatePropsEqual,
        m = !1;

    function v(t, m) {
      var v,
          d,
          M = !u(m, i),
          p = !s(t, r);
      return r = t, i = m, M && p ? (o = c(r, i), e.dependsOnOwnProps && (l = e(n, i)), f = a(o, l, i)) : M ? (c.dependsOnOwnProps && (o = c(r, i)), e.dependsOnOwnProps && (l = e(n, i)), f = a(o, l, i)) : p ? (v = c(r, i), d = !h(v, o), o = v, d && (f = a(o, l, i)), f) : f;
    }

    return function (t, s) {
      return m ? v(t, s) : (o = c(r = t, i = s), l = e(n, i), f = a(o, l, i), m = !0, f);
    };
  }

  function Y(c, e) {
    var a = e.initMapStateToProps,
        n = e.initMapDispatchToProps,
        t = e.initMergeProps,
        r = Object(v.a)(e, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]),
        i = a(c, r),
        o = n(c, r),
        l = t(c, r);
    return (r.pure ? R : B)(i, o, l, c, r);
  }

  function P(c, e, a) {
    for (var n = e.length - 1; n >= 0; n--) {
      var t = e[n](c);
      if (t) return t;
    }

    return function (e, n) {
      throw new Error("Invalid value of type " + typeof c + " for " + a + " argument when connecting component " + n.wrappedComponentName + ".");
    };
  }

  function F(c, e) {
    return c === e;
  }

  var W,
      G,
      q,
      J,
      K,
      X,
      _,
      $,
      cc,
      ec,
      ac,
      nc,
      tc = (q = (G = void 0 === W ? {} : W).connectHOC, J = void 0 === q ? w : q, K = G.mapStateToPropsFactories, X = void 0 === K ? Q : K, _ = G.mapDispatchToPropsFactories, $ = void 0 === _ ? O : _, cc = G.mergePropsFactories, ec = void 0 === cc ? U : cc, ac = G.selectorFactory, nc = void 0 === ac ? Y : ac, function (c, e, a, n) {
    void 0 === n && (n = {});
    var t = n,
        r = t.pure,
        i = void 0 === r || r,
        o = t.areStatesEqual,
        l = void 0 === o ? F : o,
        f = t.areOwnPropsEqual,
        s = void 0 === f ? S : f,
        u = t.areStatePropsEqual,
        h = void 0 === u ? S : u,
        d = t.areMergedPropsEqual,
        M = void 0 === d ? S : d,
        p = Object(v.a)(t, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]),
        z = P(c, X, "mapStateToProps"),
        C = P(e, $, "mapDispatchToProps"),
        L = P(a, ec, "mergeProps");
    return J(nc, Object(m.a)({
      methodName: "connect",
      getDisplayName: function getDisplayName(c) {
        return "Connect(" + c + ")";
      },
      shouldHandleStateChanges: Boolean(c),
      initMapStateToProps: z,
      initMapDispatchToProps: C,
      initMergeProps: L,
      pure: i,
      areStatesEqual: l,
      areOwnPropsEqual: s,
      areStatePropsEqual: h,
      areMergedPropsEqual: M
    }, p));
  });

  a.d(e, "Provider", function () {
    return u;
  }), a.d(e, "createProvider", function () {
    return s;
  }), a.d(e, "connectAdvanced", function () {
    return w;
  }), a.d(e, "connect", function () {
    return tc;
  });
}, function (c, e, a) {
  "use strict";

  var n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto),
      t = new Uint8Array(16);

  for (var r = [], i = 0; i < 256; ++i) {
    r[i] = (i + 256).toString(16).substr(1);
  }

  var o = function o(c, e) {
    var a = e || 0,
        n = r;
    return [n[c[a++]], n[c[a++]], n[c[a++]], n[c[a++]], "-", n[c[a++]], n[c[a++]], "-", n[c[a++]], n[c[a++]], "-", n[c[a++]], n[c[a++]], "-", n[c[a++]], n[c[a++]], n[c[a++]], n[c[a++]], n[c[a++]], n[c[a++]]].join("");
  };

  e.a = function (c, e, a) {
    var r = e && a || 0;
    "string" == typeof c && (e = "binary" === c ? new Array(16) : null, c = null);

    var i = (c = c || {}).random || (c.rng || function () {
      if (!n) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
      return n(t);
    })();

    if (i[6] = 15 & i[6] | 64, i[8] = 63 & i[8] | 128, e) for (var l = 0; l < 16; ++l) {
      e[r + l] = i[l];
    }
    return e || o(i);
  };
}]);